[
  {
    "id": "06075",
    "name": "06075",
    "x": 6.751,
    "y": 3.54,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036766,
      "w": 0.99932
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 101
    },
    "layers": [
      {
        "id": "682ffddbd15af3232a54616b",
        "height": 0.14832,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d13e",
            "leftCorner": {
              "x": 6.752,
              "y": 3.556,
              "z": 0.121
            },
            "rightCorner": {
              "x": 6.82,
              "y": 3.551,
              "z": 0.121
            },
            "gtin": "4063367402937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d13f",
            "leftCorner": {
              "x": 6.82,
              "y": 3.551,
              "z": 0.121
            },
            "rightCorner": {
              "x": 6.888,
              "y": 3.546,
              "z": 0.121
            },
            "gtin": "4063367402937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d140",
            "leftCorner": {
              "x": 6.888,
              "y": 3.546,
              "z": 0.121
            },
            "rightCorner": {
              "x": 6.956,
              "y": 3.541,
              "z": 0.121
            },
            "gtin": "4063367402937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d145",
            "leftCorner": {
              "x": 6.959,
              "y": 3.587,
              "z": 0.121
            },
            "rightCorner": {
              "x": 7.186,
              "y": 3.571,
              "z": 0.121
            },
            "gtin": "4337185499487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d146",
            "leftCorner": {
              "x": 7.186,
              "y": 3.571,
              "z": 0.121
            },
            "rightCorner": {
              "x": 7.413,
              "y": 3.554,
              "z": 0.121
            },
            "gtin": "4337185499487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d147",
            "leftCorner": {
              "x": 7.413,
              "y": 3.545,
              "z": 0.121
            },
            "rightCorner": {
              "x": 7.636,
              "y": 3.528,
              "z": 0.121
            },
            "gtin": "4000521124007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d148",
            "leftCorner": {
              "x": 7.636,
              "y": 3.523,
              "z": 0.121
            },
            "rightCorner": {
              "x": 7.808,
              "y": 3.51,
              "z": 0.121
            },
            "gtin": "4000521123017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d149",
            "leftCorner": {
              "x": 7.808,
              "y": 3.51,
              "z": 0.121
            },
            "rightCorner": {
              "x": 7.979,
              "y": 3.497,
              "z": 0.121
            },
            "gtin": "4000521123017",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546169",
        "height": 0.49673,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d0aa",
            "leftCorner": {
              "x": 6.752,
              "y": 3.556,
              "z": 0.406
            },
            "rightCorner": {
              "x": 6.862,
              "y": 3.547,
              "z": 0.406
            },
            "gtin": "4000521122010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0ab",
            "leftCorner": {
              "x": 6.862,
              "y": 3.547,
              "z": 0.406
            },
            "rightCorner": {
              "x": 6.973,
              "y": 3.539,
              "z": 0.406
            },
            "gtin": "4000521122010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0ac",
            "leftCorner": {
              "x": 6.973,
              "y": 3.539,
              "z": 0.406
            },
            "rightCorner": {
              "x": 7.083,
              "y": 3.531,
              "z": 0.406
            },
            "gtin": "4000521122010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0ad",
            "leftCorner": {
              "x": 7.083,
              "y": 3.531,
              "z": 0.406
            },
            "rightCorner": {
              "x": 7.193,
              "y": 3.523,
              "z": 0.406
            },
            "gtin": "4000521122010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0b1",
            "leftCorner": {
              "x": 7.195,
              "y": 3.552,
              "z": 0.406
            },
            "rightCorner": {
              "x": 7.276,
              "y": 3.546,
              "z": 0.406
            },
            "gtin": "4005394116319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0b2",
            "leftCorner": {
              "x": 7.276,
              "y": 3.546,
              "z": 0.406
            },
            "rightCorner": {
              "x": 7.356,
              "y": 3.54,
              "z": 0.406
            },
            "gtin": "4005394116319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0b3",
            "leftCorner": {
              "x": 7.357,
              "y": 3.546,
              "z": 0.406
            },
            "rightCorner": {
              "x": 7.563,
              "y": 3.531,
              "z": 0.406
            },
            "gtin": "4008391085053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0b4",
            "leftCorner": {
              "x": 7.564,
              "y": 3.54,
              "z": 0.406
            },
            "rightCorner": {
              "x": 7.692,
              "y": 3.53,
              "z": 0.406
            },
            "gtin": "4000521122706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0b5",
            "leftCorner": {
              "x": 7.692,
              "y": 3.53,
              "z": 0.406
            },
            "rightCorner": {
              "x": 7.821,
              "y": 3.521,
              "z": 0.406
            },
            "gtin": "4000521122706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0b6",
            "leftCorner": {
              "x": 7.821,
              "y": 3.521,
              "z": 0.406
            },
            "rightCorner": {
              "x": 7.949,
              "y": 3.511,
              "z": 0.406
            },
            "gtin": "4000521122706",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546168",
        "height": 0.74554,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d034",
            "leftCorner": {
              "x": 6.752,
              "y": 3.558,
              "z": 0.61
            },
            "rightCorner": {
              "x": 6.884,
              "y": 3.548,
              "z": 0.61
            },
            "gtin": "4002809021602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d036",
            "leftCorner": {
              "x": 6.886,
              "y": 3.585,
              "z": 0.61
            },
            "rightCorner": {
              "x": 6.979,
              "y": 3.578,
              "z": 0.61
            },
            "gtin": "4000521761516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d037",
            "leftCorner": {
              "x": 6.979,
              "y": 3.578,
              "z": 0.61
            },
            "rightCorner": {
              "x": 7.072,
              "y": 3.571,
              "z": 0.61
            },
            "gtin": "4000521761516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d038",
            "leftCorner": {
              "x": 7.072,
              "y": 3.571,
              "z": 0.61
            },
            "rightCorner": {
              "x": 7.164,
              "y": 3.564,
              "z": 0.61
            },
            "gtin": "4000521761516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d039",
            "leftCorner": {
              "x": 7.164,
              "y": 3.564,
              "z": 0.61
            },
            "rightCorner": {
              "x": 7.226,
              "y": 3.56,
              "z": 0.61
            },
            "gtin": "4000521117009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d03a",
            "leftCorner": {
              "x": 7.226,
              "y": 3.56,
              "z": 0.61
            },
            "rightCorner": {
              "x": 7.289,
              "y": 3.555,
              "z": 0.61
            },
            "gtin": "4000521117009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d03b",
            "leftCorner": {
              "x": 7.289,
              "y": 3.557,
              "z": 0.61
            },
            "rightCorner": {
              "x": 7.394,
              "y": 3.55,
              "z": 0.61
            },
            "gtin": "4000521030681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d03c",
            "leftCorner": {
              "x": 7.394,
              "y": 3.555,
              "z": 0.61
            },
            "rightCorner": {
              "x": 7.452,
              "y": 3.55,
              "z": 0.61
            },
            "gtin": "4000521103019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d03d",
            "leftCorner": {
              "x": 7.452,
              "y": 3.55,
              "z": 0.61
            },
            "rightCorner": {
              "x": 7.511,
              "y": 3.546,
              "z": 0.61
            },
            "gtin": "4000521103019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d03e",
            "leftCorner": {
              "x": 7.511,
              "y": 3.546,
              "z": 0.61
            },
            "rightCorner": {
              "x": 7.569,
              "y": 3.542,
              "z": 0.61
            },
            "gtin": "4000521103019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d03f",
            "leftCorner": {
              "x": 7.569,
              "y": 3.542,
              "z": 0.61
            },
            "rightCorner": {
              "x": 7.627,
              "y": 3.537,
              "z": 0.61
            },
            "gtin": "4000521103019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d040",
            "leftCorner": {
              "x": 7.627,
              "y": 3.537,
              "z": 0.61
            },
            "rightCorner": {
              "x": 7.685,
              "y": 3.533,
              "z": 0.61
            },
            "gtin": "4000521103019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d041",
            "leftCorner": {
              "x": 7.686,
              "y": 3.539,
              "z": 0.61
            },
            "rightCorner": {
              "x": 7.783,
              "y": 3.532,
              "z": 0.61
            },
            "gtin": "4000521004866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d042",
            "leftCorner": {
              "x": 7.783,
              "y": 3.532,
              "z": 0.61
            },
            "rightCorner": {
              "x": 7.88,
              "y": 3.524,
              "z": 0.61
            },
            "gtin": "4000521004866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d043",
            "leftCorner": {
              "x": 7.88,
              "y": 3.524,
              "z": 0.61
            },
            "rightCorner": {
              "x": 7.977,
              "y": 3.517,
              "z": 0.61
            },
            "gtin": "4000521004866",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546167",
        "height": 1.0029,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cfd5",
            "leftCorner": {
              "x": 6.752,
              "y": 3.559,
              "z": 0.821
            },
            "rightCorner": {
              "x": 6.841,
              "y": 3.552,
              "z": 0.821
            },
            "gtin": "4035731805606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfd6",
            "leftCorner": {
              "x": 6.841,
              "y": 3.552,
              "z": 0.821
            },
            "rightCorner": {
              "x": 6.93,
              "y": 3.546,
              "z": 0.821
            },
            "gtin": "4035731805606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfd8",
            "leftCorner": {
              "x": 6.933,
              "y": 3.584,
              "z": 0.821
            },
            "rightCorner": {
              "x": 7.037,
              "y": 3.576,
              "z": 0.821
            },
            "gtin": "4067776037636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfd9",
            "leftCorner": {
              "x": 7.037,
              "y": 3.577,
              "z": 0.821
            },
            "rightCorner": {
              "x": 7.126,
              "y": 3.57,
              "z": 0.821
            },
            "gtin": "4000521024802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfda",
            "leftCorner": {
              "x": 7.126,
              "y": 3.57,
              "z": 0.821
            },
            "rightCorner": {
              "x": 7.214,
              "y": 3.564,
              "z": 0.821
            },
            "gtin": "4000521024802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfdb",
            "leftCorner": {
              "x": 7.214,
              "y": 3.563,
              "z": 0.821
            },
            "rightCorner": {
              "x": 7.258,
              "y": 3.56,
              "z": 0.821
            },
            "gtin": "4063367397332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfdc",
            "leftCorner": {
              "x": 7.258,
              "y": 3.56,
              "z": 0.821
            },
            "rightCorner": {
              "x": 7.302,
              "y": 3.556,
              "z": 0.821
            },
            "gtin": "4063367397332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfdd",
            "leftCorner": {
              "x": 7.302,
              "y": 3.556,
              "z": 0.821
            },
            "rightCorner": {
              "x": 7.345,
              "y": 3.553,
              "z": 0.821
            },
            "gtin": "4063367397332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfde",
            "leftCorner": {
              "x": 7.345,
              "y": 3.553,
              "z": 0.821
            },
            "rightCorner": {
              "x": 7.389,
              "y": 3.55,
              "z": 0.821
            },
            "gtin": "4063367397332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfdf",
            "leftCorner": {
              "x": 7.389,
              "y": 3.55,
              "z": 0.821
            },
            "rightCorner": {
              "x": 7.432,
              "y": 3.547,
              "z": 0.821
            },
            "gtin": "4063367397332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfe0",
            "leftCorner": {
              "x": 7.433,
              "y": 3.554,
              "z": 0.821
            },
            "rightCorner": {
              "x": 7.609,
              "y": 3.541,
              "z": 0.821
            },
            "gtin": "4000521110314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfe1",
            "leftCorner": {
              "x": 7.608,
              "y": 3.537,
              "z": 0.821
            },
            "rightCorner": {
              "x": 7.703,
              "y": 3.53,
              "z": 0.821
            },
            "gtin": "4035731806207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfe2",
            "leftCorner": {
              "x": 7.703,
              "y": 3.53,
              "z": 0.821
            },
            "rightCorner": {
              "x": 7.798,
              "y": 3.523,
              "z": 0.821
            },
            "gtin": "4035731806207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfe3",
            "leftCorner": {
              "x": 7.798,
              "y": 3.52,
              "z": 0.821
            },
            "rightCorner": {
              "x": 7.881,
              "y": 3.514,
              "z": 0.821
            },
            "gtin": "4067776048304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfe4",
            "leftCorner": {
              "x": 7.88,
              "y": 3.504,
              "z": 0.821
            },
            "rightCorner": {
              "x": 7.963,
              "y": 3.498,
              "z": 0.821
            },
            "gtin": "4002809020094",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546166",
        "height": 1.2527,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cf79",
            "leftCorner": {
              "x": 6.752,
              "y": 3.555,
              "z": 1.025
            },
            "rightCorner": {
              "x": 6.819,
              "y": 3.55,
              "z": 1.025
            },
            "gtin": "4035731805002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf7c",
            "leftCorner": {
              "x": 6.821,
              "y": 3.584,
              "z": 1.025
            },
            "rightCorner": {
              "x": 6.871,
              "y": 3.58,
              "z": 1.025
            },
            "gtin": "4035731805101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf7d",
            "leftCorner": {
              "x": 6.871,
              "y": 3.58,
              "z": 1.025
            },
            "rightCorner": {
              "x": 6.92,
              "y": 3.577,
              "z": 1.025
            },
            "gtin": "4035731805101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf7e",
            "leftCorner": {
              "x": 6.921,
              "y": 3.583,
              "z": 1.025
            },
            "rightCorner": {
              "x": 7.014,
              "y": 3.577,
              "z": 1.025
            },
            "gtin": "4067776067206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf7f",
            "leftCorner": {
              "x": 7.014,
              "y": 3.574,
              "z": 1.025
            },
            "rightCorner": {
              "x": 7.081,
              "y": 3.57,
              "z": 1.025
            },
            "gtin": "4067776067312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf80",
            "leftCorner": {
              "x": 7.081,
              "y": 3.57,
              "z": 1.025
            },
            "rightCorner": {
              "x": 7.147,
              "y": 3.565,
              "z": 1.025
            },
            "gtin": "4067776067312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf81",
            "leftCorner": {
              "x": 7.148,
              "y": 3.57,
              "z": 1.025
            },
            "rightCorner": {
              "x": 7.212,
              "y": 3.565,
              "z": 1.025
            },
            "gtin": "4067776048311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf82",
            "leftCorner": {
              "x": 7.211,
              "y": 3.554,
              "z": 1.025
            },
            "rightCorner": {
              "x": 7.283,
              "y": 3.549,
              "z": 1.025
            },
            "gtin": "40352619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf83",
            "leftCorner": {
              "x": 7.283,
              "y": 3.544,
              "z": 1.025
            },
            "rightCorner": {
              "x": 7.345,
              "y": 3.54,
              "z": 1.025
            },
            "gtin": "40352459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf84",
            "leftCorner": {
              "x": 7.346,
              "y": 3.561,
              "z": 1.025
            },
            "rightCorner": {
              "x": 7.406,
              "y": 3.556,
              "z": 1.025
            },
            "gtin": "40352480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf85",
            "leftCorner": {
              "x": 7.405,
              "y": 3.539,
              "z": 1.025
            },
            "rightCorner": {
              "x": 7.484,
              "y": 3.534,
              "z": 1.025
            },
            "gtin": "40352442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf86",
            "leftCorner": {
              "x": 7.484,
              "y": 3.534,
              "z": 1.025
            },
            "rightCorner": {
              "x": 7.563,
              "y": 3.528,
              "z": 1.025
            },
            "gtin": "40352442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf87",
            "leftCorner": {
              "x": 7.563,
              "y": 3.537,
              "z": 1.025
            },
            "rightCorner": {
              "x": 7.623,
              "y": 3.532,
              "z": 1.025
            },
            "gtin": "4000521027537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf88",
            "leftCorner": {
              "x": 7.623,
              "y": 3.531,
              "z": 1.025
            },
            "rightCorner": {
              "x": 7.69,
              "y": 3.526,
              "z": 1.025
            },
            "gtin": "4000521026158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf89",
            "leftCorner": {
              "x": 7.69,
              "y": 3.526,
              "z": 1.025
            },
            "rightCorner": {
              "x": 7.757,
              "y": 3.521,
              "z": 1.025
            },
            "gtin": "4000521026158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf8a",
            "leftCorner": {
              "x": 7.757,
              "y": 3.521,
              "z": 1.025
            },
            "rightCorner": {
              "x": 7.82,
              "y": 3.516,
              "z": 1.025
            },
            "gtin": "4000521026110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf8b",
            "leftCorner": {
              "x": 7.82,
              "y": 3.516,
              "z": 1.025
            },
            "rightCorner": {
              "x": 7.882,
              "y": 3.512,
              "z": 1.025
            },
            "gtin": "4000521026110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf8c",
            "leftCorner": {
              "x": 7.882,
              "y": 3.513,
              "z": 1.025
            },
            "rightCorner": {
              "x": 8.031,
              "y": 3.503,
              "z": 1.025
            },
            "gtin": "4000521026134",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a54616a",
        "height": 1.5048,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d0fb",
            "leftCorner": {
              "x": 6.751,
              "y": 3.546,
              "z": 1.231
            },
            "rightCorner": {
              "x": 6.818,
              "y": 3.541,
              "z": 1.231
            },
            "gtin": "4250448351035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0fe",
            "leftCorner": {
              "x": 6.82,
              "y": 3.576,
              "z": 1.231
            },
            "rightCorner": {
              "x": 6.881,
              "y": 3.572,
              "z": 1.231
            },
            "gtin": "5060234989217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0ff",
            "leftCorner": {
              "x": 6.882,
              "y": 3.575,
              "z": 1.231
            },
            "rightCorner": {
              "x": 6.938,
              "y": 3.571,
              "z": 1.231
            },
            "gtin": "5060234989255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d100",
            "leftCorner": {
              "x": 6.938,
              "y": 3.571,
              "z": 1.231
            },
            "rightCorner": {
              "x": 6.994,
              "y": 3.567,
              "z": 1.231
            },
            "gtin": "5060234989255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d101",
            "leftCorner": {
              "x": 6.994,
              "y": 3.564,
              "z": 1.231
            },
            "rightCorner": {
              "x": 7.047,
              "y": 3.56,
              "z": 1.231
            },
            "gtin": "4002674316131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d102",
            "leftCorner": {
              "x": 7.047,
              "y": 3.56,
              "z": 1.231
            },
            "rightCorner": {
              "x": 7.1,
              "y": 3.556,
              "z": 1.231
            },
            "gtin": "4002674316131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d103",
            "leftCorner": {
              "x": 7.1,
              "y": 3.559,
              "z": 1.231
            },
            "rightCorner": {
              "x": 7.156,
              "y": 3.555,
              "z": 1.231
            },
            "gtin": "4002674316179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d104",
            "leftCorner": {
              "x": 7.157,
              "y": 3.564,
              "z": 1.231
            },
            "rightCorner": {
              "x": 7.2,
              "y": 3.561,
              "z": 1.231
            },
            "gtin": "4002674316216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d105",
            "leftCorner": {
              "x": 7.2,
              "y": 3.561,
              "z": 1.231
            },
            "rightCorner": {
              "x": 7.257,
              "y": 3.557,
              "z": 1.231
            },
            "gtin": "4000521142810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d106",
            "leftCorner": {
              "x": 7.257,
              "y": 3.557,
              "z": 1.231
            },
            "rightCorner": {
              "x": 7.314,
              "y": 3.553,
              "z": 1.231
            },
            "gtin": "4000521142810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d107",
            "leftCorner": {
              "x": 7.314,
              "y": 3.55,
              "z": 1.231
            },
            "rightCorner": {
              "x": 7.411,
              "y": 3.543,
              "z": 1.231
            },
            "gtin": "4000521140816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d108",
            "leftCorner": {
              "x": 7.412,
              "y": 3.549,
              "z": 1.231
            },
            "rightCorner": {
              "x": 7.483,
              "y": 3.543,
              "z": 1.231
            },
            "gtin": "4000521141813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d109",
            "leftCorner": {
              "x": 7.483,
              "y": 3.543,
              "z": 1.231
            },
            "rightCorner": {
              "x": 7.555,
              "y": 3.538,
              "z": 1.231
            },
            "gtin": "4000521141813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d10a",
            "leftCorner": {
              "x": 7.554,
              "y": 3.524,
              "z": 1.231
            },
            "rightCorner": {
              "x": 7.631,
              "y": 3.519,
              "z": 1.231
            },
            "gtin": "4000521144814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d10b",
            "leftCorner": {
              "x": 7.631,
              "y": 3.52,
              "z": 1.231
            },
            "rightCorner": {
              "x": 7.688,
              "y": 3.516,
              "z": 1.231
            },
            "gtin": "4002809022500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d10c",
            "leftCorner": {
              "x": 7.688,
              "y": 3.51,
              "z": 1.231
            },
            "rightCorner": {
              "x": 7.734,
              "y": 3.506,
              "z": 1.231
            },
            "gtin": "4002809022487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d10d",
            "leftCorner": {
              "x": 7.734,
              "y": 3.506,
              "z": 1.231
            },
            "rightCorner": {
              "x": 7.781,
              "y": 3.503,
              "z": 1.231
            },
            "gtin": "4002809022487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d10e",
            "leftCorner": {
              "x": 7.781,
              "y": 3.503,
              "z": 1.231
            },
            "rightCorner": {
              "x": 7.828,
              "y": 3.5,
              "z": 1.231
            },
            "gtin": "4002809022487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d10f",
            "leftCorner": {
              "x": 7.828,
              "y": 3.498,
              "z": 1.231
            },
            "rightCorner": {
              "x": 7.899,
              "y": 3.493,
              "z": 1.231
            },
            "gtin": "4002809022494",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d110",
            "leftCorner": {
              "x": 7.899,
              "y": 3.498,
              "z": 1.231
            },
            "rightCorner": {
              "x": 7.964,
              "y": 3.493,
              "z": 1.231
            },
            "gtin": "4002809022517",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546165",
        "height": 1.7024,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1ceec",
            "leftCorner": {
              "x": 6.788,
              "y": 3.572,
              "z": 1.393
            },
            "rightCorner": {
              "x": 6.854,
              "y": 3.567,
              "z": 1.393
            },
            "gtin": "4000521020323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceed",
            "leftCorner": {
              "x": 6.854,
              "y": 3.567,
              "z": 1.393
            },
            "rightCorner": {
              "x": 6.921,
              "y": 3.562,
              "z": 1.393
            },
            "gtin": "4000521020323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceee",
            "leftCorner": {
              "x": 6.922,
              "y": 3.575,
              "z": 1.393
            },
            "rightCorner": {
              "x": 6.98,
              "y": 3.57,
              "z": 1.393
            },
            "gtin": "4063367479694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceef",
            "leftCorner": {
              "x": 6.979,
              "y": 3.566,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.057,
              "y": 3.56,
              "z": 1.393
            },
            "gtin": "40352602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cef0",
            "leftCorner": {
              "x": 7.058,
              "y": 3.567,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.136,
              "y": 3.561,
              "z": 1.393
            },
            "gtin": "4000521030551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cef1",
            "leftCorner": {
              "x": 7.136,
              "y": 3.555,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.225,
              "y": 3.549,
              "z": 1.393
            },
            "gtin": "4002674316025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cef2",
            "leftCorner": {
              "x": 7.226,
              "y": 3.565,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.293,
              "y": 3.56,
              "z": 1.393
            },
            "gtin": "4002809021046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cef3",
            "leftCorner": {
              "x": 7.293,
              "y": 3.564,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.365,
              "y": 3.559,
              "z": 1.393
            },
            "gtin": "4000521027537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cef4",
            "leftCorner": {
              "x": 7.364,
              "y": 3.544,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.439,
              "y": 3.539,
              "z": 1.393
            },
            "gtin": "4000521021795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cef5",
            "leftCorner": {
              "x": 7.439,
              "y": 3.539,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.513,
              "y": 3.533,
              "z": 1.393
            },
            "gtin": "4000521021795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cef6",
            "leftCorner": {
              "x": 7.514,
              "y": 3.542,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.571,
              "y": 3.538,
              "z": 1.393
            },
            "gtin": "4250448352223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cef7",
            "leftCorner": {
              "x": 7.571,
              "y": 3.537,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.627,
              "y": 3.533,
              "z": 1.393
            },
            "gtin": "4002674286410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cef8",
            "leftCorner": {
              "x": 7.626,
              "y": 3.52,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.699,
              "y": 3.514,
              "z": 1.393
            },
            "gtin": "4002674286403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cef9",
            "leftCorner": {
              "x": 7.701,
              "y": 3.527,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.797,
              "y": 3.52,
              "z": 1.393
            },
            "gtin": "4002674286434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cefa",
            "leftCorner": {
              "x": 7.797,
              "y": 3.511,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.875,
              "y": 3.506,
              "z": 1.393
            },
            "gtin": "4022500137488",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c835ed67a01d9a1cefb",
            "leftCorner": {
              "x": 7.876,
              "y": 3.516,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.95,
              "y": 3.511,
              "z": 1.393
            },
            "gtin": "4022500137174",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "e024c"
  },
  {
    "id": "34a48",
    "name": "34a48",
    "x": -4.238,
    "y": 28.406,
    "width": 0.5,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99972,
      "w": 0.023542
    },

    "layers": [],
    "leftNeighborShelfId": "a6d6c",
    "rightNeighborShelfId": "a6d6d"
  },
  {
    "id": "34a49",
    "name": "34a49",
    "x": 21.04,
    "y": 5.745,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72834,
      "w": 0.68522
    },

    "layers": [],
    "leftNeighborShelfId": "ddeae",
    "rightNeighborShelfId": "34a4a"
  },
  {
    "id": "34a4a",
    "name": "34a4a",
    "x": 20.957,
    "y": 4.397,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72834,
      "w": 0.68522
    },

    "layers": [],
    "leftNeighborShelfId": "34a49",
    "rightNeighborShelfId": "34a4b"
  },
  {
    "id": "34a4b",
    "name": "34a4b",
    "x": 20.875,
    "y": 3.05,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72834,
      "w": 0.68522
    },

    "layers": [],
    "leftNeighborShelfId": "34a4a",
    "rightNeighborShelfId": "34a4c"
  },
  {
    "id": "34a4c",
    "name": "34a4c",
    "x": 20.793,
    "y": 1.702,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72834,
      "w": 0.68522
    },

    "layers": [],
    "leftNeighborShelfId": "34a4b"
  },
  {
    "id": "34a5e",
    "name": "34a5e",
    "x": 8.161,
    "y": 16.459,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036216,
      "w": 0.99934
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546350",
        "height": 0.18269,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e5a2",
            "leftCorner": {
              "x": 8.208,
              "y": 16.491,
              "z": 0.149
            },
            "rightCorner": {
              "x": 8.576,
              "y": 16.465,
              "z": 0.149
            },
            "gtin": "4008596503406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5a0",
            "leftCorner": {
              "x": 8.577,
              "y": 16.478,
              "z": 0.149
            },
            "rightCorner": {
              "x": 8.695,
              "y": 16.469,
              "z": 0.149
            },
            "gtin": "4337185461217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5a1",
            "leftCorner": {
              "x": 8.695,
              "y": 16.469,
              "z": 0.149
            },
            "rightCorner": {
              "x": 8.813,
              "y": 16.461,
              "z": 0.149
            },
            "gtin": "4337185461217",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546351",
        "height": 0.80212,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e1fc",
            "leftCorner": {
              "x": 8.398,
              "y": 16.58,
              "z": 0.656
            },
            "rightCorner": {
              "x": 8.51,
              "y": 16.572,
              "z": 0.656
            },
            "gtin": "4063367434679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1fd",
            "leftCorner": {
              "x": 8.51,
              "y": 16.572,
              "z": 0.656
            },
            "rightCorner": {
              "x": 8.621,
              "y": 16.564,
              "z": 0.656
            },
            "gtin": "4063367434679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1fe",
            "leftCorner": {
              "x": 8.621,
              "y": 16.564,
              "z": 0.656
            },
            "rightCorner": {
              "x": 8.733,
              "y": 16.556,
              "z": 0.656
            },
            "gtin": "4063367434679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1ff",
            "leftCorner": {
              "x": 8.733,
              "y": 16.556,
              "z": 0.656
            },
            "rightCorner": {
              "x": 8.845,
              "y": 16.548,
              "z": 0.656
            },
            "gtin": "4063367434679",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54634e",
        "height": 1.3143,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e1c5",
            "leftCorner": {
              "x": 8.175,
              "y": 16.655,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.392,
              "y": 16.639,
              "z": 1.075
            },
            "gtin": "3435649871280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1c6",
            "leftCorner": {
              "x": 8.392,
              "y": 16.639,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.609,
              "y": 16.623,
              "z": 1.075
            },
            "gtin": "3435649871280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1c8",
            "leftCorner": {
              "x": 8.612,
              "y": 16.666,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.84,
              "y": 16.649,
              "z": 1.075
            },
            "gtin": "5999040443159",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54634f",
        "height": 1.7151,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e16f",
            "leftCorner": {
              "x": 8.16,
              "y": 16.683,
              "z": 1.403
            },
            "rightCorner": {
              "x": 8.251,
              "y": 16.676,
              "z": 1.403
            },
            "gtin": "4045178005996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e170",
            "leftCorner": {
              "x": 8.251,
              "y": 16.676,
              "z": 1.403
            },
            "rightCorner": {
              "x": 8.343,
              "y": 16.67,
              "z": 1.403
            },
            "gtin": "4045178005996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e171",
            "leftCorner": {
              "x": 8.344,
              "y": 16.689,
              "z": 1.403
            },
            "rightCorner": {
              "x": 8.417,
              "y": 16.683,
              "z": 1.403
            },
            "gtin": "4063367397240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e172",
            "leftCorner": {
              "x": 8.417,
              "y": 16.683,
              "z": 1.403
            },
            "rightCorner": {
              "x": 8.489,
              "y": 16.678,
              "z": 1.403
            },
            "gtin": "4063367397240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e173",
            "leftCorner": {
              "x": 8.489,
              "y": 16.678,
              "z": 1.403
            },
            "rightCorner": {
              "x": 8.562,
              "y": 16.673,
              "z": 1.403
            },
            "gtin": "4063367397240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e174",
            "leftCorner": {
              "x": 8.562,
              "y": 16.671,
              "z": 1.403
            },
            "rightCorner": {
              "x": 8.67,
              "y": 16.662,
              "z": 1.403
            },
            "gtin": "4002015561619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e175",
            "leftCorner": {
              "x": 8.67,
              "y": 16.662,
              "z": 1.403
            },
            "rightCorner": {
              "x": 8.778,
              "y": 16.655,
              "z": 1.403
            },
            "gtin": "4002015561619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e176",
            "leftCorner": {
              "x": 8.778,
              "y": 16.655,
              "z": 1.403
            },
            "rightCorner": {
              "x": 8.886,
              "y": 16.647,
              "z": 1.403
            },
            "gtin": "4002015561619",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "cde33",
    "rightNeighborShelfId": "34a5f"
  },
  {
    "id": "34a5f",
    "name": "34a5f",
    "x": 8.81,
    "y": 16.412,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036216,
      "w": 0.99934
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546357",
        "height": 0.80323,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e200",
            "leftCorner": {
              "x": 8.845,
              "y": 16.543,
              "z": 0.657
            },
            "rightCorner": {
              "x": 8.931,
              "y": 16.537,
              "z": 0.657
            },
            "gtin": "4300175162258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e201",
            "leftCorner": {
              "x": 8.931,
              "y": 16.537,
              "z": 0.657
            },
            "rightCorner": {
              "x": 9.017,
              "y": 16.53,
              "z": 0.657
            },
            "gtin": "4300175162258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e202",
            "leftCorner": {
              "x": 9.017,
              "y": 16.53,
              "z": 0.657
            },
            "rightCorner": {
              "x": 9.104,
              "y": 16.525,
              "z": 0.657
            },
            "gtin": "4300175162258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e203",
            "leftCorner": {
              "x": 9.104,
              "y": 16.525,
              "z": 0.657
            },
            "rightCorner": {
              "x": 9.19,
              "y": 16.518,
              "z": 0.657
            },
            "gtin": "4300175162258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e204",
            "leftCorner": {
              "x": 9.19,
              "y": 16.526,
              "z": 0.657
            },
            "rightCorner": {
              "x": 9.338,
              "y": 16.515,
              "z": 0.657
            },
            "gtin": "5999040443159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e205",
            "leftCorner": {
              "x": 9.338,
              "y": 16.518,
              "z": 0.657
            },
            "rightCorner": {
              "x": 9.526,
              "y": 16.503,
              "z": 0.657
            },
            "gtin": "4002015561732",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546358",
        "height": 1.3129,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e1c9",
            "leftCorner": {
              "x": 8.841,
              "y": 16.655,
              "z": 1.074
            },
            "rightCorner": {
              "x": 8.895,
              "y": 16.652,
              "z": 1.074
            },
            "gtin": "4010321006489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1ca",
            "leftCorner": {
              "x": 8.895,
              "y": 16.652,
              "z": 1.074
            },
            "rightCorner": {
              "x": 8.949,
              "y": 16.648,
              "z": 1.074
            },
            "gtin": "4010321006489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1cb",
            "leftCorner": {
              "x": 8.949,
              "y": 16.648,
              "z": 1.074
            },
            "rightCorner": {
              "x": 9.003,
              "y": 16.645,
              "z": 1.074
            },
            "gtin": "4010321006489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1cc",
            "leftCorner": {
              "x": 9.001,
              "y": 16.613,
              "z": 1.074
            },
            "rightCorner": {
              "x": 9.137,
              "y": 16.604,
              "z": 1.074
            },
            "gtin": "8715700131139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1cd",
            "leftCorner": {
              "x": 9.137,
              "y": 16.604,
              "z": 1.074
            },
            "rightCorner": {
              "x": 9.273,
              "y": 16.593,
              "z": 1.074
            },
            "gtin": "8715700131139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1ce",
            "leftCorner": {
              "x": 9.275,
              "y": 16.613,
              "z": 1.074
            },
            "rightCorner": {
              "x": 9.455,
              "y": 16.599,
              "z": 1.074
            },
            "gtin": "8715700111094",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546359",
        "height": 1.7147,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e177",
            "leftCorner": {
              "x": 8.886,
              "y": 16.643,
              "z": 1.403
            },
            "rightCorner": {
              "x": 8.957,
              "y": 16.638,
              "z": 1.403
            },
            "gtin": "3017800253762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e178",
            "leftCorner": {
              "x": 8.957,
              "y": 16.638,
              "z": 1.403
            },
            "rightCorner": {
              "x": 9.027,
              "y": 16.633,
              "z": 1.403
            },
            "gtin": "3017800253762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e179",
            "leftCorner": {
              "x": 9.027,
              "y": 16.633,
              "z": 1.403
            },
            "rightCorner": {
              "x": 9.098,
              "y": 16.627,
              "z": 1.403
            },
            "gtin": "3017800253762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e17a",
            "leftCorner": {
              "x": 9.098,
              "y": 16.624,
              "z": 1.403
            },
            "rightCorner": {
              "x": 9.199,
              "y": 16.616,
              "z": 1.403
            },
            "gtin": "3083680000369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e17b",
            "leftCorner": {
              "x": 9.199,
              "y": 16.616,
              "z": 1.403
            },
            "rightCorner": {
              "x": 9.3,
              "y": 16.61,
              "z": 1.403
            },
            "gtin": "3083680000369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e17c",
            "leftCorner": {
              "x": 9.3,
              "y": 16.61,
              "z": 1.403
            },
            "rightCorner": {
              "x": 9.401,
              "y": 16.602,
              "z": 1.403
            },
            "gtin": "3083680000369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e17d",
            "leftCorner": {
              "x": 9.4,
              "y": 16.593,
              "z": 1.403
            },
            "rightCorner": {
              "x": 9.485,
              "y": 16.587,
              "z": 1.403
            },
            "gtin": "3017800251638",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a5e",
    "rightNeighborShelfId": "34a60"
  },
  {
    "id": "34a60",
    "name": "34a60",
    "x": 9.458,
    "y": 16.365,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036216,
      "w": 0.99934
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 16
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546360",
        "height": 0.17708,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a54635f",
        "height": 0.80556,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e206",
            "leftCorner": {
              "x": 9.526,
              "y": 16.498,
              "z": 0.659
            },
            "rightCorner": {
              "x": 9.617,
              "y": 16.492,
              "z": 0.659
            },
            "gtin": "4063367499098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e207",
            "leftCorner": {
              "x": 9.617,
              "y": 16.492,
              "z": 0.659
            },
            "rightCorner": {
              "x": 9.708,
              "y": 16.485,
              "z": 0.659
            },
            "gtin": "4063367499098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e208",
            "leftCorner": {
              "x": 9.707,
              "y": 16.473,
              "z": 0.659
            },
            "rightCorner": {
              "x": 9.971,
              "y": 16.453,
              "z": 0.659
            },
            "gtin": "4337185476600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e209",
            "leftCorner": {
              "x": 9.972,
              "y": 16.464,
              "z": 0.659
            },
            "rightCorner": {
              "x": 10.069,
              "y": 16.458,
              "z": 0.659
            },
            "gtin": "041500805016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e20a",
            "leftCorner": {
              "x": 10.069,
              "y": 16.458,
              "z": 0.659
            },
            "rightCorner": {
              "x": 10.167,
              "y": 16.45,
              "z": 0.659
            },
            "gtin": "041500805016",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54635e",
        "height": 1.3167,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e1cf",
            "leftCorner": {
              "x": 9.454,
              "y": 16.591,
              "z": 1.077
            },
            "rightCorner": {
              "x": 9.641,
              "y": 16.578,
              "z": 1.077
            },
            "gtin": "8001440132506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1d0",
            "leftCorner": {
              "x": 9.64,
              "y": 16.565,
              "z": 1.077
            },
            "rightCorner": {
              "x": 9.821,
              "y": 16.553,
              "z": 1.077
            },
            "gtin": "8001440132551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1d1",
            "leftCorner": {
              "x": 9.822,
              "y": 16.564,
              "z": 1.077
            },
            "rightCorner": {
              "x": 9.994,
              "y": 16.552,
              "z": 1.077
            },
            "gtin": "8001440132520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1d2",
            "leftCorner": {
              "x": 9.994,
              "y": 16.56,
              "z": 1.077
            },
            "rightCorner": {
              "x": 10.142,
              "y": 16.548,
              "z": 1.077
            },
            "gtin": "8001440132544",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54635d",
        "height": 1.7136,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e17e",
            "leftCorner": {
              "x": 9.485,
              "y": 16.585,
              "z": 1.402
            },
            "rightCorner": {
              "x": 9.548,
              "y": 16.581,
              "z": 1.402
            },
            "gtin": "4063367186448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e17f",
            "leftCorner": {
              "x": 9.548,
              "y": 16.581,
              "z": 1.402
            },
            "rightCorner": {
              "x": 9.611,
              "y": 16.576,
              "z": 1.402
            },
            "gtin": "4063367186448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e180",
            "leftCorner": {
              "x": 9.611,
              "y": 16.576,
              "z": 1.402
            },
            "rightCorner": {
              "x": 9.674,
              "y": 16.572,
              "z": 1.402
            },
            "gtin": "4063367186448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e181",
            "leftCorner": {
              "x": 9.674,
              "y": 16.572,
              "z": 1.402
            },
            "rightCorner": {
              "x": 9.737,
              "y": 16.567,
              "z": 1.402
            },
            "gtin": "4063367186448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e182",
            "leftCorner": {
              "x": 9.737,
              "y": 16.568,
              "z": 1.402
            },
            "rightCorner": {
              "x": 9.889,
              "y": 16.557,
              "z": 1.402
            },
            "gtin": "8720600618956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e183",
            "leftCorner": {
              "x": 9.89,
              "y": 16.566,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.015,
              "y": 16.556,
              "z": 1.402
            },
            "gtin": "8720600618895",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e184",
            "leftCorner": {
              "x": 10.015,
              "y": 16.556,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.14,
              "y": 16.547,
              "z": 1.402
            },
            "gtin": "8720600618895",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a5f",
    "rightNeighborShelfId": "34a61"
  },
  {
    "id": "34a61",
    "name": "34a61",
    "x": 10.106,
    "y": 16.318,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036216,
      "w": 0.99934
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 21
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546364",
        "height": 0.17847,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e663",
            "leftCorner": {
              "x": 10.507,
              "y": 16.33,
              "z": 0.146
            },
            "rightCorner": {
              "x": 10.711,
              "y": 16.315,
              "z": 0.146
            },
            "gtin": "4063367156946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e664",
            "leftCorner": {
              "x": 10.711,
              "y": 16.315,
              "z": 0.146
            },
            "rightCorner": {
              "x": 10.917,
              "y": 16.3,
              "z": 0.146
            },
            "gtin": "4063367156946",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546363",
        "height": 0.80517,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e20b",
            "leftCorner": {
              "x": 10.166,
              "y": 16.444,
              "z": 0.659
            },
            "rightCorner": {
              "x": 10.466,
              "y": 16.422,
              "z": 0.659
            },
            "gtin": "4260456257960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e20c",
            "leftCorner": {
              "x": 10.466,
              "y": 16.422,
              "z": 0.659
            },
            "rightCorner": {
              "x": 10.767,
              "y": 16.401,
              "z": 0.659
            },
            "gtin": "4260456257960",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546362",
        "height": 1.313,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e1d3",
            "leftCorner": {
              "x": 10.142,
              "y": 16.545,
              "z": 1.074
            },
            "rightCorner": {
              "x": 10.225,
              "y": 16.54,
              "z": 1.074
            },
            "gtin": "3083681098419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1d4",
            "leftCorner": {
              "x": 10.225,
              "y": 16.54,
              "z": 1.074
            },
            "rightCorner": {
              "x": 10.309,
              "y": 16.533,
              "z": 1.074
            },
            "gtin": "3083681098419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1d5",
            "leftCorner": {
              "x": 10.309,
              "y": 16.539,
              "z": 1.074
            },
            "rightCorner": {
              "x": 10.491,
              "y": 16.527,
              "z": 1.074
            },
            "gtin": "3083681153415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1d6",
            "leftCorner": {
              "x": 10.491,
              "y": 16.522,
              "z": 1.074
            },
            "rightCorner": {
              "x": 10.572,
              "y": 16.515,
              "z": 1.074
            },
            "gtin": "4063367560712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1d7",
            "leftCorner": {
              "x": 10.572,
              "y": 16.515,
              "z": 1.074
            },
            "rightCorner": {
              "x": 10.653,
              "y": 16.51,
              "z": 1.074
            },
            "gtin": "4063367560712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1d8",
            "leftCorner": {
              "x": 10.653,
              "y": 16.51,
              "z": 1.074
            },
            "rightCorner": {
              "x": 10.733,
              "y": 16.504,
              "z": 1.074
            },
            "gtin": "4063367560712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1d9",
            "leftCorner": {
              "x": 10.733,
              "y": 16.507,
              "z": 1.074
            },
            "rightCorner": {
              "x": 10.884,
              "y": 16.496,
              "z": 1.074
            },
            "gtin": "4063367551925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1da",
            "leftCorner": {
              "x": 10.884,
              "y": 16.496,
              "z": 1.074
            },
            "rightCorner": {
              "x": 11.036,
              "y": 16.485,
              "z": 1.074
            },
            "gtin": "4063367551925",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546361",
        "height": 1.7135,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e185",
            "leftCorner": {
              "x": 10.14,
              "y": 16.553,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.197,
              "y": 16.548,
              "z": 1.402
            },
            "gtin": "4045178005491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e186",
            "leftCorner": {
              "x": 10.197,
              "y": 16.548,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.255,
              "y": 16.544,
              "z": 1.402
            },
            "gtin": "4045178005491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e187",
            "leftCorner": {
              "x": 10.255,
              "y": 16.544,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.312,
              "y": 16.54,
              "z": 1.402
            },
            "gtin": "4045178005491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e188",
            "leftCorner": {
              "x": 10.312,
              "y": 16.54,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.37,
              "y": 16.535,
              "z": 1.402
            },
            "gtin": "4045178005491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e189",
            "leftCorner": {
              "x": 10.369,
              "y": 16.522,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.47,
              "y": 16.515,
              "z": 1.402
            },
            "gtin": "4045178005859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e18a",
            "leftCorner": {
              "x": 10.47,
              "y": 16.515,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.571,
              "y": 16.507,
              "z": 1.402
            },
            "gtin": "4045178005859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e18b",
            "leftCorner": {
              "x": 10.573,
              "y": 16.526,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.652,
              "y": 16.521,
              "z": 1.402
            },
            "gtin": "4045178005453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e18c",
            "leftCorner": {
              "x": 10.652,
              "y": 16.521,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.73,
              "y": 16.515,
              "z": 1.402
            },
            "gtin": "4045178005453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e18d",
            "leftCorner": {
              "x": 10.73,
              "y": 16.51,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.82,
              "y": 16.503,
              "z": 1.402
            },
            "gtin": "4045178002469",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a60",
    "rightNeighborShelfId": "34a62"
  },
  {
    "id": "34a62",
    "name": "34a62",
    "x": 10.755,
    "y": 16.271,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036216,
      "w": 0.99934
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 16
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546367",
        "height": 0.17638,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a546365",
        "height": 0.80227,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e20d",
            "leftCorner": {
              "x": 10.768,
              "y": 16.406,
              "z": 0.656
            },
            "rightCorner": {
              "x": 10.984,
              "y": 16.391,
              "z": 0.656
            },
            "gtin": "4002015003119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e20e",
            "leftCorner": {
              "x": 10.984,
              "y": 16.391,
              "z": 0.656
            },
            "rightCorner": {
              "x": 11.201,
              "y": 16.376,
              "z": 0.656
            },
            "gtin": "4002015003119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e20f",
            "leftCorner": {
              "x": 11.2,
              "y": 16.372,
              "z": 0.656
            },
            "rightCorner": {
              "x": 11.397,
              "y": 16.357,
              "z": 0.656
            },
            "gtin": "4002015003188",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546368",
        "height": 1.3112,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e1db",
            "leftCorner": {
              "x": 11.037,
              "y": 16.486,
              "z": 1.073
            },
            "rightCorner": {
              "x": 11.21,
              "y": 16.473,
              "z": 1.073
            },
            "gtin": "4002015501578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1dc",
            "leftCorner": {
              "x": 11.208,
              "y": 16.465,
              "z": 1.073
            },
            "rightCorner": {
              "x": 11.31,
              "y": 16.458,
              "z": 1.073
            },
            "gtin": "4063367499050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1dd",
            "leftCorner": {
              "x": 11.31,
              "y": 16.458,
              "z": 1.073
            },
            "rightCorner": {
              "x": 11.41,
              "y": 16.451,
              "z": 1.073
            },
            "gtin": "4063367499050",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546366",
        "height": 1.715,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e18e",
            "leftCorner": {
              "x": 10.821,
              "y": 16.502,
              "z": 1.403
            },
            "rightCorner": {
              "x": 10.871,
              "y": 16.498,
              "z": 1.403
            },
            "gtin": "4045178005477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e18f",
            "leftCorner": {
              "x": 10.871,
              "y": 16.498,
              "z": 1.403
            },
            "rightCorner": {
              "x": 10.922,
              "y": 16.495,
              "z": 1.403
            },
            "gtin": "4045178005477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e190",
            "leftCorner": {
              "x": 10.922,
              "y": 16.495,
              "z": 1.403
            },
            "rightCorner": {
              "x": 10.973,
              "y": 16.491,
              "z": 1.403
            },
            "gtin": "4045178005477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e191",
            "leftCorner": {
              "x": 10.973,
              "y": 16.491,
              "z": 1.403
            },
            "rightCorner": {
              "x": 11.024,
              "y": 16.487,
              "z": 1.403
            },
            "gtin": "4045178005477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e192",
            "leftCorner": {
              "x": 11.024,
              "y": 16.485,
              "z": 1.403
            },
            "rightCorner": {
              "x": 11.105,
              "y": 16.48,
              "z": 1.403
            },
            "gtin": "4045178005972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e193",
            "leftCorner": {
              "x": 11.105,
              "y": 16.48,
              "z": 1.403
            },
            "rightCorner": {
              "x": 11.186,
              "y": 16.474,
              "z": 1.403
            },
            "gtin": "4045178005972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e194",
            "leftCorner": {
              "x": 11.184,
              "y": 16.461,
              "z": 1.403
            },
            "rightCorner": {
              "x": 11.25,
              "y": 16.456,
              "z": 1.403
            },
            "gtin": "4045178002728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e195",
            "leftCorner": {
              "x": 11.25,
              "y": 16.456,
              "z": 1.403
            },
            "rightCorner": {
              "x": 11.315,
              "y": 16.452,
              "z": 1.403
            },
            "gtin": "4045178002728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e196",
            "leftCorner": {
              "x": 11.315,
              "y": 16.452,
              "z": 1.403
            },
            "rightCorner": {
              "x": 11.38,
              "y": 16.446,
              "z": 1.403
            },
            "gtin": "4045178002728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e197",
            "leftCorner": {
              "x": 11.382,
              "y": 16.462,
              "z": 1.403
            },
            "rightCorner": {
              "x": 11.425,
              "y": 16.459,
              "z": 1.403
            },
            "gtin": "4045178003855",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a61",
    "rightNeighborShelfId": "34a63"
  },
  {
    "id": "34a63",
    "name": "34a63",
    "x": 11.403,
    "y": 16.224,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036216,
      "w": 0.99934
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 16
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54636c",
        "height": 0.17831,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e665",
            "leftCorner": {
              "x": 11.888,
              "y": 16.247,
              "z": 0.146
            },
            "rightCorner": {
              "x": 11.983,
              "y": 16.241,
              "z": 0.146
            },
            "gtin": "4337185461507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e666",
            "leftCorner": {
              "x": 11.983,
              "y": 16.241,
              "z": 0.146
            },
            "rightCorner": {
              "x": 12.079,
              "y": 16.234,
              "z": 0.146
            },
            "gtin": "4337185461507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e667",
            "leftCorner": {
              "x": 12.079,
              "y": 16.234,
              "z": 0.146
            },
            "rightCorner": {
              "x": 12.175,
              "y": 16.227,
              "z": 0.146
            },
            "gtin": "4337185461507",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54636b",
        "height": 0.80412,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e210",
            "leftCorner": {
              "x": 11.398,
              "y": 16.369,
              "z": 0.658
            },
            "rightCorner": {
              "x": 11.613,
              "y": 16.353,
              "z": 0.658
            },
            "gtin": "4002015003089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e211",
            "leftCorner": {
              "x": 11.613,
              "y": 16.35,
              "z": 0.658
            },
            "rightCorner": {
              "x": 11.738,
              "y": 16.34,
              "z": 0.658
            },
            "gtin": "4002015003096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e212",
            "leftCorner": {
              "x": 11.738,
              "y": 16.34,
              "z": 0.658
            },
            "rightCorner": {
              "x": 11.863,
              "y": 16.331,
              "z": 0.658
            },
            "gtin": "4002015003096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e213",
            "leftCorner": {
              "x": 11.864,
              "y": 16.339,
              "z": 0.658
            },
            "rightCorner": {
              "x": 12.029,
              "y": 16.328,
              "z": 0.658
            },
            "gtin": "4002015003201",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546369",
        "height": 1.3107,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e1de",
            "leftCorner": {
              "x": 11.41,
              "y": 16.454,
              "z": 1.072
            },
            "rightCorner": {
              "x": 11.565,
              "y": 16.443,
              "z": 1.072
            },
            "gtin": "8002920019621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1df",
            "leftCorner": {
              "x": 11.566,
              "y": 16.456,
              "z": 1.072
            },
            "rightCorner": {
              "x": 11.714,
              "y": 16.446,
              "z": 1.072
            },
            "gtin": "4002015515421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1e0",
            "leftCorner": {
              "x": 11.714,
              "y": 16.446,
              "z": 1.072
            },
            "rightCorner": {
              "x": 11.862,
              "y": 16.435,
              "z": 1.072
            },
            "gtin": "4002015515421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1e1",
            "leftCorner": {
              "x": 11.862,
              "y": 16.435,
              "z": 1.072
            },
            "rightCorner": {
              "x": 12.043,
              "y": 16.422,
              "z": 1.072
            },
            "gtin": "4002015516527",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54636a",
        "height": 1.7136,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e198",
            "leftCorner": {
              "x": 11.424,
              "y": 16.457,
              "z": 1.402
            },
            "rightCorner": {
              "x": 11.641,
              "y": 16.441,
              "z": 1.402
            },
            "gtin": "3083681152883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e199",
            "leftCorner": {
              "x": 11.641,
              "y": 16.442,
              "z": 1.402
            },
            "rightCorner": {
              "x": 11.77,
              "y": 16.432,
              "z": 1.402
            },
            "gtin": "3083681152852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e19a",
            "leftCorner": {
              "x": 11.77,
              "y": 16.432,
              "z": 1.402
            },
            "rightCorner": {
              "x": 11.9,
              "y": 16.423,
              "z": 1.402
            },
            "gtin": "3083681152852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e19b",
            "leftCorner": {
              "x": 11.9,
              "y": 16.418,
              "z": 1.402
            },
            "rightCorner": {
              "x": 12.007,
              "y": 16.41,
              "z": 1.402
            },
            "gtin": "3017800251652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e19c",
            "leftCorner": {
              "x": 12.007,
              "y": 16.419,
              "z": 1.402
            },
            "rightCorner": {
              "x": 12.074,
              "y": 16.414,
              "z": 1.402
            },
            "gtin": "3017800251621",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a62",
    "rightNeighborShelfId": "34a64"
  },
  {
    "id": "34a64",
    "name": "34a64",
    "x": 12.051,
    "y": 16.177,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036216,
      "w": 0.99934
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546370",
        "height": 0.17695,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e668",
            "leftCorner": {
              "x": 12.174,
              "y": 16.226,
              "z": 0.145
            },
            "rightCorner": {
              "x": 12.397,
              "y": 16.21,
              "z": 0.145
            },
            "gtin": "4063367156953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e669",
            "leftCorner": {
              "x": 12.397,
              "y": 16.21,
              "z": 0.145
            },
            "rightCorner": {
              "x": 12.62,
              "y": 16.194,
              "z": 0.145
            },
            "gtin": "4063367156953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e66a",
            "leftCorner": {
              "x": 12.62,
              "y": 16.191,
              "z": 0.145
            },
            "rightCorner": {
              "x": 12.739,
              "y": 16.183,
              "z": 0.145
            },
            "gtin": "4337185461644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e66b",
            "leftCorner": {
              "x": 12.739,
              "y": 16.183,
              "z": 0.145
            },
            "rightCorner": {
              "x": 12.858,
              "y": 16.173,
              "z": 0.145
            },
            "gtin": "4337185461644",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54636e",
        "height": 0.8068,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e214",
            "leftCorner": {
              "x": 12.029,
              "y": 16.326,
              "z": 0.66
            },
            "rightCorner": {
              "x": 12.163,
              "y": 16.316,
              "z": 0.66
            },
            "gtin": "4002015501622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e215",
            "leftCorner": {
              "x": 12.163,
              "y": 16.316,
              "z": 0.66
            },
            "rightCorner": {
              "x": 12.297,
              "y": 16.307,
              "z": 0.66
            },
            "gtin": "4002015501622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e216",
            "leftCorner": {
              "x": 12.295,
              "y": 16.296,
              "z": 0.66
            },
            "rightCorner": {
              "x": 12.51,
              "y": 16.281,
              "z": 0.66
            },
            "gtin": "4002015002891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e217",
            "leftCorner": {
              "x": 12.51,
              "y": 16.281,
              "z": 0.66
            },
            "rightCorner": {
              "x": 12.726,
              "y": 16.265,
              "z": 0.66
            },
            "gtin": "4002015002891",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54636d",
        "height": 1.3139,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e1e2",
            "leftCorner": {
              "x": 12.042,
              "y": 16.426,
              "z": 1.075
            },
            "rightCorner": {
              "x": 12.402,
              "y": 16.4,
              "z": 1.075
            },
            "gtin": "3083680009508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1e3",
            "leftCorner": {
              "x": 12.402,
              "y": 16.401,
              "z": 1.075
            },
            "rightCorner": {
              "x": 12.556,
              "y": 16.39,
              "z": 1.075
            },
            "gtin": "4002015516626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1e4",
            "leftCorner": {
              "x": 12.556,
              "y": 16.39,
              "z": 1.075
            },
            "rightCorner": {
              "x": 12.708,
              "y": 16.379,
              "z": 1.075
            },
            "gtin": "4002015516626",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54636f",
        "height": 1.718,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e19d",
            "leftCorner": {
              "x": 12.073,
              "y": 16.414,
              "z": 1.406
            },
            "rightCorner": {
              "x": 12.286,
              "y": 16.399,
              "z": 1.406
            },
            "gtin": "3083681152913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e19e",
            "leftCorner": {
              "x": 12.287,
              "y": 16.402,
              "z": 1.406
            },
            "rightCorner": {
              "x": 12.343,
              "y": 16.398,
              "z": 1.406
            },
            "gtin": "3017800251690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e19f",
            "leftCorner": {
              "x": 12.343,
              "y": 16.398,
              "z": 1.406
            },
            "rightCorner": {
              "x": 12.399,
              "y": 16.394,
              "z": 1.406
            },
            "gtin": "3017800251690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1a0",
            "leftCorner": {
              "x": 12.399,
              "y": 16.394,
              "z": 1.406
            },
            "rightCorner": {
              "x": 12.455,
              "y": 16.39,
              "z": 1.406
            },
            "gtin": "3017800251690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1a1",
            "leftCorner": {
              "x": 12.455,
              "y": 16.39,
              "z": 1.406
            },
            "rightCorner": {
              "x": 12.511,
              "y": 16.386,
              "z": 1.406
            },
            "gtin": "3017800251690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1a2",
            "leftCorner": {
              "x": 12.512,
              "y": 16.394,
              "z": 1.406
            },
            "rightCorner": {
              "x": 12.571,
              "y": 16.389,
              "z": 1.406
            },
            "gtin": "4002471074500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1a3",
            "leftCorner": {
              "x": 12.571,
              "y": 16.389,
              "z": 1.406
            },
            "rightCorner": {
              "x": 12.632,
              "y": 16.386,
              "z": 1.406
            },
            "gtin": "4002471074500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1a4",
            "leftCorner": {
              "x": 12.632,
              "y": 16.388,
              "z": 1.406
            },
            "rightCorner": {
              "x": 12.702,
              "y": 16.382,
              "z": 1.406
            },
            "gtin": "4068500600218",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a63",
    "rightNeighborShelfId": "34a65"
  },
  {
    "id": "34a65",
    "name": "34a65",
    "x": 12.7,
    "y": 16.13,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036216,
      "w": 0.99934
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 21
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546374",
        "height": 0.18285,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e661",
            "leftCorner": {
              "x": 12.858,
              "y": 16.149,
              "z": 0.15
            },
            "rightCorner": {
              "x": 13.104,
              "y": 16.131,
              "z": 0.15
            },
            "gtin": "4063367462177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e662",
            "leftCorner": {
              "x": 13.104,
              "y": 16.131,
              "z": 0.15
            },
            "rightCorner": {
              "x": 13.35,
              "y": 16.113,
              "z": 0.15
            },
            "gtin": "4063367462177",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546373",
        "height": 0.80975,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e218",
            "leftCorner": {
              "x": 12.726,
              "y": 16.273,
              "z": 0.663
            },
            "rightCorner": {
              "x": 12.814,
              "y": 16.266,
              "z": 0.663
            },
            "gtin": "4002015501639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e219",
            "leftCorner": {
              "x": 12.814,
              "y": 16.266,
              "z": 0.663
            },
            "rightCorner": {
              "x": 12.9,
              "y": 16.26,
              "z": 0.663
            },
            "gtin": "4002015501639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e21a",
            "leftCorner": {
              "x": 12.9,
              "y": 16.26,
              "z": 0.663
            },
            "rightCorner": {
              "x": 12.987,
              "y": 16.254,
              "z": 0.663
            },
            "gtin": "4002015501639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e21b",
            "leftCorner": {
              "x": 12.987,
              "y": 16.255,
              "z": 0.663
            },
            "rightCorner": {
              "x": 13.228,
              "y": 16.237,
              "z": 0.663
            },
            "gtin": "4002015003195",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e21c",
            "leftCorner": {
              "x": 13.227,
              "y": 16.235,
              "z": 0.663
            },
            "rightCorner": {
              "x": 13.344,
              "y": 16.228,
              "z": 0.663
            },
            "gtin": "4337185755378",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e21d",
            "leftCorner": {
              "x": 13.344,
              "y": 16.228,
              "z": 0.663
            },
            "rightCorner": {
              "x": 13.462,
              "y": 16.219,
              "z": 0.663
            },
            "gtin": "4337185755378",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546372",
        "height": 1.3172,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e1e5",
            "leftCorner": {
              "x": 12.708,
              "y": 16.361,
              "z": 1.078
            },
            "rightCorner": {
              "x": 12.957,
              "y": 16.343,
              "z": 1.078
            },
            "gtin": "4002015561626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1e6",
            "leftCorner": {
              "x": 12.957,
              "y": 16.349,
              "z": 1.078
            },
            "rightCorner": {
              "x": 13.026,
              "y": 16.344,
              "z": 1.078
            },
            "gtin": "4008596503444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1e7",
            "leftCorner": {
              "x": 13.026,
              "y": 16.344,
              "z": 1.078
            },
            "rightCorner": {
              "x": 13.094,
              "y": 16.339,
              "z": 1.078
            },
            "gtin": "4008596503444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1e8",
            "leftCorner": {
              "x": 13.094,
              "y": 16.339,
              "z": 1.078
            },
            "rightCorner": {
              "x": 13.163,
              "y": 16.334,
              "z": 1.078
            },
            "gtin": "4008596503444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1e9",
            "leftCorner": {
              "x": 13.164,
              "y": 16.344,
              "z": 1.078
            },
            "rightCorner": {
              "x": 13.331,
              "y": 16.332,
              "z": 1.078
            },
            "gtin": "4063367155284",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546371",
        "height": 1.7191,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e1a5",
            "leftCorner": {
              "x": 12.702,
              "y": 16.369,
              "z": 1.407
            },
            "rightCorner": {
              "x": 12.764,
              "y": 16.366,
              "z": 1.407
            },
            "gtin": "3083680001663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1a6",
            "leftCorner": {
              "x": 12.764,
              "y": 16.366,
              "z": 1.407
            },
            "rightCorner": {
              "x": 12.826,
              "y": 16.361,
              "z": 1.407
            },
            "gtin": "3083680001663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1a7",
            "leftCorner": {
              "x": 12.827,
              "y": 16.364,
              "z": 1.407
            },
            "rightCorner": {
              "x": 12.94,
              "y": 16.356,
              "z": 1.407
            },
            "gtin": "3083680002752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1a8",
            "leftCorner": {
              "x": 12.94,
              "y": 16.356,
              "z": 1.407
            },
            "rightCorner": {
              "x": 13.053,
              "y": 16.347,
              "z": 1.407
            },
            "gtin": "3083680002752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1a9",
            "leftCorner": {
              "x": 13.054,
              "y": 16.353,
              "z": 1.407
            },
            "rightCorner": {
              "x": 13.125,
              "y": 16.348,
              "z": 1.407
            },
            "gtin": "4063367388439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1aa",
            "leftCorner": {
              "x": 13.125,
              "y": 16.348,
              "z": 1.407
            },
            "rightCorner": {
              "x": 13.195,
              "y": 16.342,
              "z": 1.407
            },
            "gtin": "4063367388439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1ab",
            "leftCorner": {
              "x": 13.195,
              "y": 16.342,
              "z": 1.407
            },
            "rightCorner": {
              "x": 13.266,
              "y": 16.337,
              "z": 1.407
            },
            "gtin": "4063367388439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1ac",
            "leftCorner": {
              "x": 13.266,
              "y": 16.337,
              "z": 1.407
            },
            "rightCorner": {
              "x": 13.336,
              "y": 16.332,
              "z": 1.407
            },
            "gtin": "4063367388439",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a64",
    "rightNeighborShelfId": "34a66"
  },
  {
    "id": "34a66",
    "name": "34a66",
    "x": 13.348,
    "y": 16.083,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036216,
      "w": 0.99934
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 15
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546377",
        "height": 0.80847,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e21e",
            "leftCorner": {
              "x": 13.462,
              "y": 16.228,
              "z": 0.661
            },
            "rightCorner": {
              "x": 13.758,
              "y": 16.206,
              "z": 0.661
            },
            "gtin": "4337185929199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e21f",
            "leftCorner": {
              "x": 13.758,
              "y": 16.207,
              "z": 0.661
            },
            "rightCorner": {
              "x": 13.985,
              "y": 16.191,
              "z": 0.661
            },
            "gtin": "4337185888465",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546376",
        "height": 1.3167,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e1ea",
            "leftCorner": {
              "x": 13.329,
              "y": 16.313,
              "z": 1.077
            },
            "rightCorner": {
              "x": 13.434,
              "y": 16.305,
              "z": 1.077
            },
            "gtin": "4337185485572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1eb",
            "leftCorner": {
              "x": 13.434,
              "y": 16.305,
              "z": 1.077
            },
            "rightCorner": {
              "x": 13.538,
              "y": 16.298,
              "z": 1.077
            },
            "gtin": "4337185485572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1ec",
            "leftCorner": {
              "x": 13.538,
              "y": 16.298,
              "z": 1.077
            },
            "rightCorner": {
              "x": 13.643,
              "y": 16.29,
              "z": 1.077
            },
            "gtin": "4337185485572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1ed",
            "leftCorner": {
              "x": 13.644,
              "y": 16.311,
              "z": 1.077
            },
            "rightCorner": {
              "x": 13.776,
              "y": 16.302,
              "z": 1.077
            },
            "gtin": "4006835411208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1ee",
            "leftCorner": {
              "x": 13.776,
              "y": 16.302,
              "z": 1.077
            },
            "rightCorner": {
              "x": 13.907,
              "y": 16.292,
              "z": 1.077
            },
            "gtin": "4006835411208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1ef",
            "leftCorner": {
              "x": 13.908,
              "y": 16.293,
              "z": 1.077
            },
            "rightCorner": {
              "x": 13.988,
              "y": 16.287,
              "z": 1.077
            },
            "gtin": "4012200462706",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546375",
        "height": 1.7186,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e1ad",
            "leftCorner": {
              "x": 13.334,
              "y": 16.325,
              "z": 1.406
            },
            "rightCorner": {
              "x": 13.533,
              "y": 16.311,
              "z": 1.406
            },
            "gtin": "3083681003949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1ae",
            "leftCorner": {
              "x": 13.534,
              "y": 16.323,
              "z": 1.406
            },
            "rightCorner": {
              "x": 13.632,
              "y": 16.315,
              "z": 1.406
            },
            "gtin": "3083681160833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1af",
            "leftCorner": {
              "x": 13.632,
              "y": 16.315,
              "z": 1.406
            },
            "rightCorner": {
              "x": 13.73,
              "y": 16.308,
              "z": 1.406
            },
            "gtin": "3083681160833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1b0",
            "leftCorner": {
              "x": 13.73,
              "y": 16.308,
              "z": 1.406
            },
            "rightCorner": {
              "x": 13.829,
              "y": 16.301,
              "z": 1.406
            },
            "gtin": "3083681160833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1b1",
            "leftCorner": {
              "x": 13.829,
              "y": 16.305,
              "z": 1.406
            },
            "rightCorner": {
              "x": 13.874,
              "y": 16.302,
              "z": 1.406
            },
            "gtin": "3083680002394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1b2",
            "leftCorner": {
              "x": 13.874,
              "y": 16.302,
              "z": 1.406
            },
            "rightCorner": {
              "x": 13.92,
              "y": 16.298,
              "z": 1.406
            },
            "gtin": "3083680002394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1b3",
            "leftCorner": {
              "x": 13.92,
              "y": 16.298,
              "z": 1.406
            },
            "rightCorner": {
              "x": 13.965,
              "y": 16.295,
              "z": 1.406
            },
            "gtin": "3083680002394",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a65",
    "rightNeighborShelfId": "34a67"
  },
  {
    "id": "34a67",
    "name": "34a67",
    "x": 13.996,
    "y": 16.036,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036216,
      "w": 0.99934
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546304",
        "height": 0.18517,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e228",
            "leftCorner": {
              "x": 13.997,
              "y": 16.044,
              "z": 0.152
            },
            "rightCorner": {
              "x": 14.045,
              "y": 16.041,
              "z": 0.152
            }
          },
          {
            "id": "68300c855ed67a01d9a1e229",
            "leftCorner": {
              "x": 14.048,
              "y": 16.08,
              "z": 0.152
            },
            "rightCorner": {
              "x": 14.348,
              "y": 16.057,
              "z": 0.152
            },
            "gtin": "4063367145643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e22a",
            "leftCorner": {
              "x": 14.348,
              "y": 16.057,
              "z": 0.152
            },
            "rightCorner": {
              "x": 14.647,
              "y": 16.036,
              "z": 0.152
            },
            "gtin": "4063367145643",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546303",
        "height": 0.80215,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e220",
            "leftCorner": {
              "x": 13.984,
              "y": 16.174,
              "z": 0.656
            },
            "rightCorner": {
              "x": 14.212,
              "y": 16.158,
              "z": 0.656
            },
            "gtin": "4337185755408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e221",
            "leftCorner": {
              "x": 14.212,
              "y": 16.158,
              "z": 0.656
            },
            "rightCorner": {
              "x": 14.439,
              "y": 16.141,
              "z": 0.656
            },
            "gtin": "4337185755408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e222",
            "leftCorner": {
              "x": 14.44,
              "y": 16.156,
              "z": 0.656
            },
            "rightCorner": {
              "x": 14.544,
              "y": 16.149,
              "z": 0.656
            },
            "gtin": "4337185271632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e223",
            "leftCorner": {
              "x": 14.544,
              "y": 16.149,
              "z": 0.656
            },
            "rightCorner": {
              "x": 14.649,
              "y": 16.141,
              "z": 0.656
            },
            "gtin": "4337185271632",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546302",
        "height": 1.3116,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e1f0",
            "leftCorner": {
              "x": 13.987,
              "y": 16.276,
              "z": 1.073
            },
            "rightCorner": {
              "x": 14.065,
              "y": 16.27,
              "z": 1.073
            },
            "gtin": "4012200430408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1f1",
            "leftCorner": {
              "x": 14.065,
              "y": 16.27,
              "z": 1.073
            },
            "rightCorner": {
              "x": 14.143,
              "y": 16.264,
              "z": 1.073
            },
            "gtin": "4012200430408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1f2",
            "leftCorner": {
              "x": 14.143,
              "y": 16.268,
              "z": 1.073
            },
            "rightCorner": {
              "x": 14.223,
              "y": 16.263,
              "z": 1.073
            },
            "gtin": "40804255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1f3",
            "leftCorner": {
              "x": 14.223,
              "y": 16.263,
              "z": 1.073
            },
            "rightCorner": {
              "x": 14.303,
              "y": 16.257,
              "z": 1.073
            },
            "gtin": "40804255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1f4",
            "leftCorner": {
              "x": 14.302,
              "y": 16.247,
              "z": 1.073
            },
            "rightCorner": {
              "x": 14.458,
              "y": 16.236,
              "z": 1.073
            },
            "gtin": "40804477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1f5",
            "leftCorner": {
              "x": 14.459,
              "y": 16.249,
              "z": 1.073
            },
            "rightCorner": {
              "x": 14.6,
              "y": 16.239,
              "z": 1.073
            },
            "gtin": "4002015000095",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546301",
        "height": 1.7121,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e1b4",
            "leftCorner": {
              "x": 13.965,
              "y": 16.283,
              "z": 1.401
            },
            "rightCorner": {
              "x": 14.071,
              "y": 16.277,
              "z": 1.401
            },
            "gtin": "40804385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1b5",
            "leftCorner": {
              "x": 14.071,
              "y": 16.278,
              "z": 1.401
            },
            "rightCorner": {
              "x": 14.136,
              "y": 16.273,
              "z": 1.401
            },
            "gtin": "40804187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1b6",
            "leftCorner": {
              "x": 14.136,
              "y": 16.273,
              "z": 1.401
            },
            "rightCorner": {
              "x": 14.202,
              "y": 16.268,
              "z": 1.401
            },
            "gtin": "40804187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1b7",
            "leftCorner": {
              "x": 14.202,
              "y": 16.268,
              "z": 1.401
            },
            "rightCorner": {
              "x": 14.267,
              "y": 16.263,
              "z": 1.401
            },
            "gtin": "40804187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1b8",
            "leftCorner": {
              "x": 14.266,
              "y": 16.252,
              "z": 1.401
            },
            "rightCorner": {
              "x": 14.376,
              "y": 16.244,
              "z": 1.401
            },
            "gtin": "4063367396175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1b9",
            "leftCorner": {
              "x": 14.376,
              "y": 16.244,
              "z": 1.401
            },
            "rightCorner": {
              "x": 14.487,
              "y": 16.235,
              "z": 1.401
            },
            "gtin": "4063367396175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1ba",
            "leftCorner": {
              "x": 14.487,
              "y": 16.243,
              "z": 1.401
            },
            "rightCorner": {
              "x": 14.538,
              "y": 16.24,
              "z": 1.401
            },
            "gtin": "4037700078486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1bb",
            "leftCorner": {
              "x": 14.538,
              "y": 16.24,
              "z": 1.401
            },
            "rightCorner": {
              "x": 14.589,
              "y": 16.236,
              "z": 1.401
            },
            "gtin": "4037700078486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1bc",
            "leftCorner": {
              "x": 14.589,
              "y": 16.236,
              "z": 1.401
            },
            "rightCorner": {
              "x": 14.64,
              "y": 16.232,
              "z": 1.401
            },
            "gtin": "4037700078486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1bd",
            "leftCorner": {
              "x": 14.64,
              "y": 16.232,
              "z": 1.401
            },
            "rightCorner": {
              "x": 14.691,
              "y": 16.228,
              "z": 1.401
            },
            "gtin": "4037700078486",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a66",
    "rightNeighborShelfId": "34a68"
  },
  {
    "id": "34a68",
    "name": "34a68",
    "x": 14.644,
    "y": 15.989,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036216,
      "w": 0.99934
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546379",
        "height": 0.80082,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e224",
            "leftCorner": {
              "x": 14.648,
              "y": 16.12,
              "z": 0.655
            },
            "rightCorner": {
              "x": 14.795,
              "y": 16.11,
              "z": 0.655
            },
            "gtin": "4337185756856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e225",
            "leftCorner": {
              "x": 14.795,
              "y": 16.11,
              "z": 0.655
            },
            "rightCorner": {
              "x": 14.943,
              "y": 16.098,
              "z": 0.655
            },
            "gtin": "4337185756856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e226",
            "leftCorner": {
              "x": 14.942,
              "y": 16.088,
              "z": 0.655
            },
            "rightCorner": {
              "x": 15.068,
              "y": 16.079,
              "z": 0.655
            },
            "gtin": "4063367214141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e227",
            "leftCorner": {
              "x": 15.068,
              "y": 16.079,
              "z": 0.655
            },
            "rightCorner": {
              "x": 15.194,
              "y": 16.07,
              "z": 0.655
            },
            "gtin": "4063367214141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1fb",
            "leftCorner": {
              "x": 15.196,
              "y": 16.09,
              "z": 0.655
            },
            "rightCorner": {
              "x": 15.303,
              "y": 16.083,
              "z": 0.655
            },
            "gtin": "4250262709289",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546378",
        "height": 1.3068,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e1f6",
            "leftCorner": {
              "x": 14.611,
              "y": 16.216,
              "z": 1.069
            },
            "rightCorner": {
              "x": 14.759,
              "y": 16.205,
              "z": 1.069
            },
            "gtin": "4002015000477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1f7",
            "leftCorner": {
              "x": 14.759,
              "y": 16.205,
              "z": 1.069
            },
            "rightCorner": {
              "x": 14.907,
              "y": 16.194,
              "z": 1.069
            },
            "gtin": "4002015000477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1f8",
            "leftCorner": {
              "x": 14.907,
              "y": 16.194,
              "z": 1.069
            },
            "rightCorner": {
              "x": 15.055,
              "y": 16.183,
              "z": 1.069
            },
            "gtin": "4002015000477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1f9",
            "leftCorner": {
              "x": 15.056,
              "y": 16.206,
              "z": 1.069
            },
            "rightCorner": {
              "x": 15.134,
              "y": 16.2,
              "z": 1.069
            },
            "gtin": "4002015529114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1fa",
            "leftCorner": {
              "x": 15.134,
              "y": 16.2,
              "z": 1.069
            },
            "rightCorner": {
              "x": 15.211,
              "y": 16.195,
              "z": 1.069
            },
            "gtin": "4002015529114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1c7",
            "leftCorner": {
              "x": 15.211,
              "y": 16.192,
              "z": 1.069
            },
            "rightCorner": {
              "x": 15.31,
              "y": 16.186,
              "z": 1.069
            },
            "gtin": "8595058803410",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54637a",
        "height": 1.708,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e1be",
            "leftCorner": {
              "x": 14.69,
              "y": 16.221,
              "z": 1.397
            },
            "rightCorner": {
              "x": 14.768,
              "y": 16.215,
              "z": 1.397
            },
            "gtin": "4002239614801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1bf",
            "leftCorner": {
              "x": 14.768,
              "y": 16.215,
              "z": 1.397
            },
            "rightCorner": {
              "x": 14.847,
              "y": 16.209,
              "z": 1.397
            },
            "gtin": "4002239614801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1c0",
            "leftCorner": {
              "x": 14.847,
              "y": 16.21,
              "z": 1.397
            },
            "rightCorner": {
              "x": 14.919,
              "y": 16.206,
              "z": 1.397
            },
            "gtin": "4002239640503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1c1",
            "leftCorner": {
              "x": 14.919,
              "y": 16.206,
              "z": 1.397
            },
            "rightCorner": {
              "x": 14.993,
              "y": 16.2,
              "z": 1.397
            },
            "gtin": "4002239640503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1c2",
            "leftCorner": {
              "x": 14.993,
              "y": 16.2,
              "z": 1.397
            },
            "rightCorner": {
              "x": 15.065,
              "y": 16.195,
              "z": 1.397
            },
            "gtin": "4002239640503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1c3",
            "leftCorner": {
              "x": 15.066,
              "y": 16.201,
              "z": 1.397
            },
            "rightCorner": {
              "x": 15.139,
              "y": 16.195,
              "z": 1.397
            },
            "gtin": "4002239817004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e1c4",
            "leftCorner": {
              "x": 15.139,
              "y": 16.195,
              "z": 1.397
            },
            "rightCorner": {
              "x": 15.213,
              "y": 16.19,
              "z": 1.397
            },
            "gtin": "4002239817004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e169",
            "leftCorner": {
              "x": 15.213,
              "y": 16.189,
              "z": 1.397
            },
            "rightCorner": {
              "x": 15.31,
              "y": 16.183,
              "z": 1.397
            },
            "gtin": "4002239854009",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a67",
    "rightNeighborShelfId": "34a69"
  },
  {
    "id": "34a69",
    "name": "34a69",
    "x": 15.293,
    "y": 15.942,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036216,
      "w": 0.99934
    },

    "layers": [],
    "leftNeighborShelfId": "34a68",
    "rightNeighborShelfId": "34a6a"
  },
  {
    "id": "34a6a",
    "name": "34a6a",
    "x": 15.941,
    "y": 15.894,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036216,
      "w": 0.99934
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 17
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5462b0",
        "height": 0.18705,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1ddb8",
            "leftCorner": {
              "x": 15.942,
              "y": 15.909,
              "z": 0.153
            },
            "rightCorner": {
              "x": 16.067,
              "y": 15.899,
              "z": 0.153
            }
          },
          {
            "id": "68300c855ed67a01d9a1ddb9",
            "leftCorner": {
              "x": 16.07,
              "y": 15.942,
              "z": 0.153
            },
            "rightCorner": {
              "x": 16.332,
              "y": 15.923,
              "z": 0.153
            },
            "gtin": "4063367390739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddba",
            "leftCorner": {
              "x": 16.332,
              "y": 15.923,
              "z": 0.153
            },
            "rightCorner": {
              "x": 16.593,
              "y": 15.904,
              "z": 0.153
            },
            "gtin": "4063367390739",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462af",
        "height": 0.81107,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dda0",
            "leftCorner": {
              "x": 15.948,
              "y": 15.986,
              "z": 0.664
            },
            "rightCorner": {
              "x": 16.228,
              "y": 15.965,
              "z": 0.664
            },
            "gtin": "4037700078592",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dda1",
            "leftCorner": {
              "x": 16.228,
              "y": 15.965,
              "z": 0.664
            },
            "rightCorner": {
              "x": 16.507,
              "y": 15.945,
              "z": 0.664
            },
            "gtin": "4037700078592",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dda3",
            "leftCorner": {
              "x": 16.511,
              "y": 15.998,
              "z": 0.664
            },
            "rightCorner": {
              "x": 16.59,
              "y": 15.992,
              "z": 0.664
            },
            "gtin": "4063367163197",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dda4",
            "leftCorner": {
              "x": 16.59,
              "y": 15.992,
              "z": 0.664
            },
            "rightCorner": {
              "x": 16.67,
              "y": 15.986,
              "z": 0.664
            },
            "gtin": "4063367163197",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dda5",
            "leftCorner": {
              "x": 16.67,
              "y": 15.986,
              "z": 0.664
            },
            "rightCorner": {
              "x": 16.749,
              "y": 15.981,
              "z": 0.664
            },
            "gtin": "4063367163197",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462ae",
        "height": 1.3188,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd84",
            "leftCorner": {
              "x": 15.954,
              "y": 16.082,
              "z": 1.079
            },
            "rightCorner": {
              "x": 16.204,
              "y": 16.064,
              "z": 1.079
            },
            "gtin": "4006099673725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd86",
            "leftCorner": {
              "x": 16.207,
              "y": 16.102,
              "z": 1.079
            },
            "rightCorner": {
              "x": 16.391,
              "y": 16.09,
              "z": 1.079
            },
            "gtin": "4063367396182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd87",
            "leftCorner": {
              "x": 16.39,
              "y": 16.081,
              "z": 1.079
            },
            "rightCorner": {
              "x": 16.525,
              "y": 16.071,
              "z": 1.079
            },
            "gtin": "4063367214134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd88",
            "leftCorner": {
              "x": 16.525,
              "y": 16.071,
              "z": 1.079
            },
            "rightCorner": {
              "x": 16.662,
              "y": 16.061,
              "z": 1.079
            },
            "gtin": "4063367214134",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462ad",
        "height": 1.7184,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd5d",
            "leftCorner": {
              "x": 15.955,
              "y": 16.091,
              "z": 1.406
            },
            "rightCorner": {
              "x": 16.04,
              "y": 16.084,
              "z": 1.406
            },
            "gtin": "40804378",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd5e",
            "leftCorner": {
              "x": 16.04,
              "y": 16.084,
              "z": 1.406
            },
            "rightCorner": {
              "x": 16.127,
              "y": 16.079,
              "z": 1.406
            },
            "gtin": "40804378",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd60",
            "leftCorner": {
              "x": 16.128,
              "y": 16.109,
              "z": 1.406
            },
            "rightCorner": {
              "x": 16.321,
              "y": 16.095,
              "z": 1.406
            },
            "gtin": "40804361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd61",
            "leftCorner": {
              "x": 16.321,
              "y": 16.114,
              "z": 1.406
            },
            "rightCorner": {
              "x": 16.394,
              "y": 16.108,
              "z": 1.406
            },
            "gtin": "40804415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd62",
            "leftCorner": {
              "x": 16.394,
              "y": 16.108,
              "z": 1.406
            },
            "rightCorner": {
              "x": 16.466,
              "y": 16.103,
              "z": 1.406
            },
            "gtin": "40804415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd63",
            "leftCorner": {
              "x": 16.466,
              "y": 16.098,
              "z": 1.406
            },
            "rightCorner": {
              "x": 16.55,
              "y": 16.092,
              "z": 1.406
            },
            "gtin": "4012200430705",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a69",
    "rightNeighborShelfId": "34a6b"
  },
  {
    "id": "34a6b",
    "name": "34a6b",
    "x": 16.589,
    "y": 15.847,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036216,
      "w": 0.99934
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54637d",
        "height": 0.80978,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dda6",
            "leftCorner": {
              "x": 16.747,
              "y": 15.964,
              "z": 0.663
            },
            "rightCorner": {
              "x": 16.884,
              "y": 15.954,
              "z": 0.663
            },
            "gtin": "4063367108655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dda7",
            "leftCorner": {
              "x": 16.884,
              "y": 15.954,
              "z": 0.663
            },
            "rightCorner": {
              "x": 17.021,
              "y": 15.944,
              "z": 0.663
            },
            "gtin": "4063367108655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dda8",
            "leftCorner": {
              "x": 17.021,
              "y": 15.949,
              "z": 0.663
            },
            "rightCorner": {
              "x": 17.133,
              "y": 15.942,
              "z": 0.663
            },
            "gtin": "4012712000335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dda9",
            "leftCorner": {
              "x": 17.133,
              "y": 15.942,
              "z": 0.663
            },
            "rightCorner": {
              "x": 17.247,
              "y": 15.934,
              "z": 0.663
            },
            "gtin": "4012712000335",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54637c",
        "height": 1.314,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd89",
            "leftCorner": {
              "x": 16.662,
              "y": 16.07,
              "z": 1.075
            },
            "rightCorner": {
              "x": 16.782,
              "y": 16.061,
              "z": 1.075
            },
            "gtin": "4037700078516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd8a",
            "leftCorner": {
              "x": 16.782,
              "y": 16.068,
              "z": 1.075
            },
            "rightCorner": {
              "x": 16.898,
              "y": 16.06,
              "z": 1.075
            },
            "gtin": "40804316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd8b",
            "leftCorner": {
              "x": 16.898,
              "y": 16.06,
              "z": 1.075
            },
            "rightCorner": {
              "x": 17.013,
              "y": 16.051,
              "z": 1.075
            },
            "gtin": "40804316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd8c",
            "leftCorner": {
              "x": 17.013,
              "y": 16.048,
              "z": 1.075
            },
            "rightCorner": {
              "x": 17.115,
              "y": 16.041,
              "z": 1.075
            },
            "gtin": "40737720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd8d",
            "leftCorner": {
              "x": 17.115,
              "y": 16.041,
              "z": 1.075
            },
            "rightCorner": {
              "x": 17.217,
              "y": 16.034,
              "z": 1.075
            },
            "gtin": "40737720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd8e",
            "leftCorner": {
              "x": 17.217,
              "y": 16.031,
              "z": 1.075
            },
            "rightCorner": {
              "x": 17.268,
              "y": 16.028,
              "z": 1.075
            },
            "gtin": "40804309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd8f",
            "leftCorner": {
              "x": 17.268,
              "y": 16.028,
              "z": 1.075
            },
            "rightCorner": {
              "x": 17.32,
              "y": 16.023,
              "z": 1.075
            },
            "gtin": "40804309",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54637b",
        "height": 1.7204,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd64",
            "leftCorner": {
              "x": 16.549,
              "y": 16.084,
              "z": 1.408
            },
            "rightCorner": {
              "x": 16.634,
              "y": 16.079,
              "z": 1.408
            },
            "gtin": "40122915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd65",
            "leftCorner": {
              "x": 16.634,
              "y": 16.079,
              "z": 1.408
            },
            "rightCorner": {
              "x": 16.719,
              "y": 16.072,
              "z": 1.408
            },
            "gtin": "40122915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd66",
            "leftCorner": {
              "x": 16.719,
              "y": 16.07,
              "z": 1.408
            },
            "rightCorner": {
              "x": 16.855,
              "y": 16.06,
              "z": 1.408
            },
            "gtin": "4002239646109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd67",
            "leftCorner": {
              "x": 16.855,
              "y": 16.06,
              "z": 1.408
            },
            "rightCorner": {
              "x": 16.956,
              "y": 16.054,
              "z": 1.408
            },
            "gtin": "4337185771262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd68",
            "leftCorner": {
              "x": 16.956,
              "y": 16.053,
              "z": 1.408
            },
            "rightCorner": {
              "x": 17.09,
              "y": 16.043,
              "z": 1.408
            },
            "gtin": "4337185771286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd69",
            "leftCorner": {
              "x": 17.089,
              "y": 16.038,
              "z": 1.408
            },
            "rightCorner": {
              "x": 17.158,
              "y": 16.033,
              "z": 1.408
            },
            "gtin": "42426509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd6a",
            "leftCorner": {
              "x": 17.158,
              "y": 16.033,
              "z": 1.408
            },
            "rightCorner": {
              "x": 17.226,
              "y": 16.028,
              "z": 1.408
            },
            "gtin": "42426509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd6b",
            "leftCorner": {
              "x": 17.226,
              "y": 16.028,
              "z": 1.408
            },
            "rightCorner": {
              "x": 17.294,
              "y": 16.023,
              "z": 1.408
            },
            "gtin": "42426509",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a6a",
    "rightNeighborShelfId": "34a6c"
  },
  {
    "id": "34a6c",
    "name": "34a6c",
    "x": 17.238,
    "y": 15.8,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036216,
      "w": 0.99934
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 26
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546381",
        "height": 0.18593,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e66c",
            "leftCorner": {
              "x": 17.239,
              "y": 15.818,
              "z": 0.152
            },
            "rightCorner": {
              "x": 17.356,
              "y": 15.81,
              "z": 0.152
            },
            "gtin": "4063367023750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e66d",
            "leftCorner": {
              "x": 17.356,
              "y": 15.81,
              "z": 0.152
            },
            "rightCorner": {
              "x": 17.472,
              "y": 15.801,
              "z": 0.152
            },
            "gtin": "4063367023750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e66e",
            "leftCorner": {
              "x": 17.472,
              "y": 15.801,
              "z": 0.152
            },
            "rightCorner": {
              "x": 17.588,
              "y": 15.793,
              "z": 0.152
            },
            "gtin": "4063367023750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e66f",
            "leftCorner": {
              "x": 17.591,
              "y": 15.84,
              "z": 0.152
            },
            "rightCorner": {
              "x": 17.692,
              "y": 15.833,
              "z": 0.152
            },
            "gtin": "4063367145575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e670",
            "leftCorner": {
              "x": 17.692,
              "y": 15.833,
              "z": 0.152
            },
            "rightCorner": {
              "x": 17.791,
              "y": 15.825,
              "z": 0.152
            },
            "gtin": "4063367145575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e671",
            "leftCorner": {
              "x": 17.791,
              "y": 15.825,
              "z": 0.152
            },
            "rightCorner": {
              "x": 17.891,
              "y": 15.818,
              "z": 0.152
            },
            "gtin": "4063367145575",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546380",
        "height": 0.80988,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1ddaa",
            "leftCorner": {
              "x": 17.247,
              "y": 15.943,
              "z": 0.663
            },
            "rightCorner": {
              "x": 17.39,
              "y": 15.932,
              "z": 0.663
            },
            "gtin": "4012712000403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddab",
            "leftCorner": {
              "x": 17.39,
              "y": 15.938,
              "z": 0.663
            },
            "rightCorner": {
              "x": 17.565,
              "y": 15.925,
              "z": 0.663
            },
            "gtin": "4008122021886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddac",
            "leftCorner": {
              "x": 17.565,
              "y": 15.924,
              "z": 0.663
            },
            "rightCorner": {
              "x": 17.722,
              "y": 15.912,
              "z": 0.663
            },
            "gtin": "4008122023330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddad",
            "leftCorner": {
              "x": 17.722,
              "y": 15.904,
              "z": 0.663
            },
            "rightCorner": {
              "x": 17.812,
              "y": 15.897,
              "z": 0.663
            },
            "gtin": "4008122023477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddae",
            "leftCorner": {
              "x": 17.812,
              "y": 15.897,
              "z": 0.663
            },
            "rightCorner": {
              "x": 17.903,
              "y": 15.891,
              "z": 0.663
            },
            "gtin": "4008122023477",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54637f",
        "height": 1.3157,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd90",
            "leftCorner": {
              "x": 17.321,
              "y": 16.033,
              "z": 1.076
            },
            "rightCorner": {
              "x": 17.439,
              "y": 16.025,
              "z": 1.076
            },
            "gtin": "4012712000687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd91",
            "leftCorner": {
              "x": 17.439,
              "y": 16.025,
              "z": 1.076
            },
            "rightCorner": {
              "x": 17.558,
              "y": 16.016,
              "z": 1.076
            },
            "gtin": "4012712000687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd92",
            "leftCorner": {
              "x": 17.558,
              "y": 16.019,
              "z": 1.076
            },
            "rightCorner": {
              "x": 17.652,
              "y": 16.012,
              "z": 1.076
            },
            "gtin": "4012712000885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd93",
            "leftCorner": {
              "x": 17.652,
              "y": 16.012,
              "z": 1.076
            },
            "rightCorner": {
              "x": 17.745,
              "y": 16.005,
              "z": 1.076
            },
            "gtin": "4012712000885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd94",
            "leftCorner": {
              "x": 17.745,
              "y": 16.003,
              "z": 1.076
            },
            "rightCorner": {
              "x": 17.801,
              "y": 15.999,
              "z": 1.076
            },
            "gtin": "4012712000366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd95",
            "leftCorner": {
              "x": 17.801,
              "y": 15.999,
              "z": 1.076
            },
            "rightCorner": {
              "x": 17.857,
              "y": 15.995,
              "z": 1.076
            },
            "gtin": "4012712000366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd96",
            "leftCorner": {
              "x": 17.857,
              "y": 15.995,
              "z": 1.076
            },
            "rightCorner": {
              "x": 17.912,
              "y": 15.991,
              "z": 1.076
            },
            "gtin": "4012712000366",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54637e",
        "height": 1.7164,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd6c",
            "leftCorner": {
              "x": 17.294,
              "y": 16.032,
              "z": 1.404
            },
            "rightCorner": {
              "x": 17.432,
              "y": 16.022,
              "z": 1.404
            },
            "gtin": "4002442820341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd6d",
            "leftCorner": {
              "x": 17.433,
              "y": 16.031,
              "z": 1.404
            },
            "rightCorner": {
              "x": 17.514,
              "y": 16.025,
              "z": 1.404
            },
            "gtin": "80596295",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd6e",
            "leftCorner": {
              "x": 17.514,
              "y": 16.025,
              "z": 1.404
            },
            "rightCorner": {
              "x": 17.595,
              "y": 16.019,
              "z": 1.404
            },
            "gtin": "80596295",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd6f",
            "leftCorner": {
              "x": 17.595,
              "y": 16.026,
              "z": 1.404
            },
            "rightCorner": {
              "x": 17.643,
              "y": 16.023,
              "z": 1.404
            },
            "gtin": "4012712000663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd70",
            "leftCorner": {
              "x": 17.643,
              "y": 16.023,
              "z": 1.404
            },
            "rightCorner": {
              "x": 17.69,
              "y": 16.019,
              "z": 1.404
            },
            "gtin": "4012712000663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd71",
            "leftCorner": {
              "x": 17.69,
              "y": 16.009,
              "z": 1.404
            },
            "rightCorner": {
              "x": 17.796,
              "y": 16.001,
              "z": 1.404
            },
            "gtin": "4012712011188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd72",
            "leftCorner": {
              "x": 17.796,
              "y": 16.008,
              "z": 1.404
            },
            "rightCorner": {
              "x": 17.866,
              "y": 16.003,
              "z": 1.404
            },
            "gtin": "4012712010648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd73",
            "leftCorner": {
              "x": 17.866,
              "y": 16.003,
              "z": 1.404
            },
            "rightCorner": {
              "x": 17.936,
              "y": 15.998,
              "z": 1.404
            },
            "gtin": "4012712010648",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a6b",
    "rightNeighborShelfId": "34a6d"
  },
  {
    "id": "34a6d",
    "name": "34a6d",
    "x": 17.886,
    "y": 15.753,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036216,
      "w": 0.99934
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546384",
        "height": 0.80733,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1ddaf",
            "leftCorner": {
              "x": 17.905,
              "y": 15.903,
              "z": 0.661
            },
            "rightCorner": {
              "x": 18.032,
              "y": 15.894,
              "z": 0.661
            },
            "gtin": "4008122020889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddb0",
            "leftCorner": {
              "x": 18.031,
              "y": 15.879,
              "z": 0.661
            },
            "rightCorner": {
              "x": 18.172,
              "y": 15.869,
              "z": 0.661
            },
            "gtin": "4008122023446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddb1",
            "leftCorner": {
              "x": 18.172,
              "y": 15.868,
              "z": 0.661
            },
            "rightCorner": {
              "x": 18.282,
              "y": 15.861,
              "z": 0.661
            },
            "gtin": "4008122023361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddb2",
            "leftCorner": {
              "x": 18.282,
              "y": 15.861,
              "z": 0.661
            },
            "rightCorner": {
              "x": 18.391,
              "y": 15.853,
              "z": 0.661
            },
            "gtin": "4008122023361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddb3",
            "leftCorner": {
              "x": 18.391,
              "y": 15.859,
              "z": 0.661
            },
            "rightCorner": {
              "x": 18.465,
              "y": 15.853,
              "z": 0.661
            },
            "gtin": "4008122021046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddb4",
            "leftCorner": {
              "x": 18.465,
              "y": 15.853,
              "z": 0.661
            },
            "rightCorner": {
              "x": 18.539,
              "y": 15.848,
              "z": 0.661
            },
            "gtin": "4008122021046",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546382",
        "height": 1.3139,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd97",
            "leftCorner": {
              "x": 17.913,
              "y": 15.995,
              "z": 1.075
            },
            "rightCorner": {
              "x": 18.129,
              "y": 15.98,
              "z": 1.075
            },
            "gtin": "4042700102086",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c855ed67a01d9a1dd98",
            "leftCorner": {
              "x": 18.128,
              "y": 15.976,
              "z": 1.075
            },
            "rightCorner": {
              "x": 18.298,
              "y": 15.964,
              "z": 1.075
            },
            "gtin": "4006424698669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd99",
            "leftCorner": {
              "x": 18.298,
              "y": 15.965,
              "z": 1.075
            },
            "rightCorner": {
              "x": 18.394,
              "y": 15.958,
              "z": 1.075
            },
            "gtin": "4042700102079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd9a",
            "leftCorner": {
              "x": 18.394,
              "y": 15.958,
              "z": 1.075
            },
            "rightCorner": {
              "x": 18.49,
              "y": 15.951,
              "z": 1.075
            },
            "gtin": "4042700102079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd9b",
            "leftCorner": {
              "x": 18.49,
              "y": 15.951,
              "z": 1.075
            },
            "rightCorner": {
              "x": 18.583,
              "y": 15.945,
              "z": 1.075
            },
            "gtin": "8720600612503",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546383",
        "height": 1.7143,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd74",
            "leftCorner": {
              "x": 17.936,
              "y": 15.997,
              "z": 1.403
            },
            "rightCorner": {
              "x": 18.024,
              "y": 15.991,
              "z": 1.403
            },
            "gtin": "4042700091045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd75",
            "leftCorner": {
              "x": 18.024,
              "y": 15.991,
              "z": 1.403
            },
            "rightCorner": {
              "x": 18.112,
              "y": 15.985,
              "z": 1.403
            },
            "gtin": "4042700091045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd76",
            "leftCorner": {
              "x": 18.112,
              "y": 15.985,
              "z": 1.403
            },
            "rightCorner": {
              "x": 18.199,
              "y": 15.978,
              "z": 1.403
            },
            "gtin": "4042700091045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd77",
            "leftCorner": {
              "x": 18.2,
              "y": 15.984,
              "z": 1.403
            },
            "rightCorner": {
              "x": 18.247,
              "y": 15.98,
              "z": 1.403
            },
            "gtin": "4009046752672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd78",
            "leftCorner": {
              "x": 18.247,
              "y": 15.98,
              "z": 1.403
            },
            "rightCorner": {
              "x": 18.296,
              "y": 15.976,
              "z": 1.403
            },
            "gtin": "4009046752672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd79",
            "leftCorner": {
              "x": 18.296,
              "y": 15.976,
              "z": 1.403
            },
            "rightCorner": {
              "x": 18.343,
              "y": 15.973,
              "z": 1.403
            },
            "gtin": "4009046752672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd7a",
            "leftCorner": {
              "x": 18.343,
              "y": 15.966,
              "z": 1.403
            },
            "rightCorner": {
              "x": 18.506,
              "y": 15.954,
              "z": 1.403
            },
            "gtin": "4009046752580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd7b",
            "leftCorner": {
              "x": 18.505,
              "y": 15.945,
              "z": 1.403
            },
            "rightCorner": {
              "x": 18.576,
              "y": 15.94,
              "z": 1.403
            },
            "gtin": "4009046752641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd7c",
            "leftCorner": {
              "x": 18.576,
              "y": 15.94,
              "z": 1.403
            },
            "rightCorner": {
              "x": 18.648,
              "y": 15.935,
              "z": 1.403
            },
            "gtin": "4009046752641",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a6c",
    "rightNeighborShelfId": "34a6e"
  },
  {
    "id": "34a6e",
    "name": "34a6e",
    "x": 18.534,
    "y": 15.706,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036216,
      "w": 0.99934
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 17
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546385",
        "height": 0.80445,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1ddb5",
            "leftCorner": {
              "x": 18.539,
              "y": 15.847,
              "z": 0.658
            },
            "rightCorner": {
              "x": 18.678,
              "y": 15.837,
              "z": 0.658
            },
            "gtin": "4012712080313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddb6",
            "leftCorner": {
              "x": 18.677,
              "y": 15.833,
              "z": 0.658
            },
            "rightCorner": {
              "x": 18.854,
              "y": 15.82,
              "z": 0.658
            },
            "gtin": "8720600030109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddb7",
            "leftCorner": {
              "x": 18.855,
              "y": 15.826,
              "z": 0.658
            },
            "rightCorner": {
              "x": 19.062,
              "y": 15.811,
              "z": 0.658
            },
            "gtin": "8720600027109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dda2",
            "leftCorner": {
              "x": 19.062,
              "y": 15.801,
              "z": 0.658
            },
            "rightCorner": {
              "x": 19.192,
              "y": 15.792,
              "z": 0.658
            },
            "gtin": "4012712010303",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546386",
        "height": 1.3062,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd9c",
            "leftCorner": {
              "x": 18.584,
              "y": 15.947,
              "z": 1.069
            },
            "rightCorner": {
              "x": 18.772,
              "y": 15.933,
              "z": 1.069
            },
            "gtin": "4045178003268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd9d",
            "leftCorner": {
              "x": 18.772,
              "y": 15.933,
              "z": 1.069
            },
            "rightCorner": {
              "x": 18.938,
              "y": 15.921,
              "z": 1.069
            },
            "gtin": "4045178002667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd9e",
            "leftCorner": {
              "x": 18.937,
              "y": 15.918,
              "z": 1.069
            },
            "rightCorner": {
              "x": 19.022,
              "y": 15.913,
              "z": 1.069
            },
            "gtin": "4045178002681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd9f",
            "leftCorner": {
              "x": 19.022,
              "y": 15.913,
              "z": 1.069
            },
            "rightCorner": {
              "x": 19.106,
              "y": 15.906,
              "z": 1.069
            },
            "gtin": "4045178002681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd85",
            "leftCorner": {
              "x": 19.105,
              "y": 15.896,
              "z": 1.069
            },
            "rightCorner": {
              "x": 19.199,
              "y": 15.889,
              "z": 1.069
            },
            "gtin": "4045178003930",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546387",
        "height": 1.7079,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd7d",
            "leftCorner": {
              "x": 18.648,
              "y": 15.935,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.718,
              "y": 15.93,
              "z": 1.397
            },
            "gtin": "4063367420467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd7e",
            "leftCorner": {
              "x": 18.718,
              "y": 15.93,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.788,
              "y": 15.924,
              "z": 1.397
            },
            "gtin": "4063367420467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd7f",
            "leftCorner": {
              "x": 18.788,
              "y": 15.924,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.858,
              "y": 15.919,
              "z": 1.397
            },
            "gtin": "4063367420467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd80",
            "leftCorner": {
              "x": 18.858,
              "y": 15.919,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.928,
              "y": 15.914,
              "z": 1.397
            },
            "gtin": "4063367420467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd81",
            "leftCorner": {
              "x": 18.928,
              "y": 15.914,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.997,
              "y": 15.909,
              "z": 1.397
            },
            "gtin": "4063367420467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd82",
            "leftCorner": {
              "x": 18.998,
              "y": 15.919,
              "z": 1.397
            },
            "rightCorner": {
              "x": 19.069,
              "y": 15.914,
              "z": 1.397
            },
            "gtin": "4045178002124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd83",
            "leftCorner": {
              "x": 19.069,
              "y": 15.914,
              "z": 1.397
            },
            "rightCorner": {
              "x": 19.139,
              "y": 15.908,
              "z": 1.397
            },
            "gtin": "4045178002124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd5f",
            "leftCorner": {
              "x": 19.138,
              "y": 15.898,
              "z": 1.397
            },
            "rightCorner": {
              "x": 19.2,
              "y": 15.894,
              "z": 1.397
            },
            "gtin": "8720600664052",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a6d"
  },
  {
    "id": "34a6f",
    "name": "34a6f",
    "x": 18.655,
    "y": 17.014,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029806
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54638b",
        "height": 0.18128,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e672",
            "leftCorner": {
              "x": 18.654,
              "y": 16.995,
              "z": 0.148
            },
            "rightCorner": {
              "x": 18.157,
              "y": 17.025,
              "z": 0.148
            },
            "gtin": "40081908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e674",
            "leftCorner": {
              "x": 18.154,
              "y": 16.977,
              "z": 0.148
            },
            "rightCorner": {
              "x": 18.024,
              "y": 16.985,
              "z": 0.148
            },
            "gtin": "8720600096105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e675",
            "leftCorner": {
              "x": 18.024,
              "y": 16.985,
              "z": 0.148
            },
            "rightCorner": {
              "x": 17.895,
              "y": 16.993,
              "z": 0.148
            },
            "gtin": "8720600096105",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54638a",
        "height": 0.80218,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1da09",
            "leftCorner": {
              "x": 18.474,
              "y": 16.876,
              "z": 0.656
            },
            "rightCorner": {
              "x": 18.394,
              "y": 16.881,
              "z": 0.656
            },
            "gtin": "4016435000825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da0a",
            "leftCorner": {
              "x": 18.394,
              "y": 16.881,
              "z": 0.656
            },
            "rightCorner": {
              "x": 18.314,
              "y": 16.886,
              "z": 0.656
            },
            "gtin": "4016435000825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da0b",
            "leftCorner": {
              "x": 18.314,
              "y": 16.886,
              "z": 0.656
            },
            "rightCorner": {
              "x": 18.234,
              "y": 16.891,
              "z": 0.656
            },
            "gtin": "4016435000825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da0c",
            "leftCorner": {
              "x": 18.234,
              "y": 16.907,
              "z": 0.656
            },
            "rightCorner": {
              "x": 18.12,
              "y": 16.913,
              "z": 0.656
            },
            "gtin": "40081915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da0d",
            "leftCorner": {
              "x": 18.12,
              "y": 16.913,
              "z": 0.656
            },
            "rightCorner": {
              "x": 18.005,
              "y": 16.921,
              "z": 0.656
            },
            "gtin": "40081915",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546388",
        "height": 1.3065,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d9a5",
            "leftCorner": {
              "x": 18.674,
              "y": 16.778,
              "z": 1.069
            },
            "rightCorner": {
              "x": 18.416,
              "y": 16.794,
              "z": 1.069
            },
            "gtin": "4003384070016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9a6",
            "leftCorner": {
              "x": 18.416,
              "y": 16.787,
              "z": 1.069
            },
            "rightCorner": {
              "x": 18.28,
              "y": 16.794,
              "z": 1.069
            },
            "gtin": "4003384070023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9a7",
            "leftCorner": {
              "x": 18.28,
              "y": 16.794,
              "z": 1.069
            },
            "rightCorner": {
              "x": 18.146,
              "y": 16.802,
              "z": 1.069
            },
            "gtin": "4003384070023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9a8",
            "leftCorner": {
              "x": 18.146,
              "y": 16.801,
              "z": 1.069
            },
            "rightCorner": {
              "x": 17.986,
              "y": 16.811,
              "z": 1.069
            },
            "gtin": "4063367399053",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546389",
        "height": 1.7062,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d932",
            "leftCorner": {
              "x": 18.565,
              "y": 16.784,
              "z": 1.396
            },
            "rightCorner": {
              "x": 18.462,
              "y": 16.791,
              "z": 1.396
            },
            "gtin": "4008100154544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d933",
            "leftCorner": {
              "x": 18.463,
              "y": 16.814,
              "z": 1.396
            },
            "rightCorner": {
              "x": 18.429,
              "y": 16.816,
              "z": 1.396
            },
            "gtin": "4088898154537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d934",
            "leftCorner": {
              "x": 18.428,
              "y": 16.803,
              "z": 1.396
            },
            "rightCorner": {
              "x": 18.288,
              "y": 16.812,
              "z": 1.396
            },
            "gtin": "4008100154537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d935",
            "leftCorner": {
              "x": 18.287,
              "y": 16.808,
              "z": 1.396
            },
            "rightCorner": {
              "x": 18.21,
              "y": 16.813,
              "z": 1.396
            },
            "gtin": "4008100154636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d936",
            "leftCorner": {
              "x": 18.209,
              "y": 16.803,
              "z": 1.396
            },
            "rightCorner": {
              "x": 18.136,
              "y": 16.807,
              "z": 1.396
            },
            "gtin": "4002471073008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d937",
            "leftCorner": {
              "x": 18.136,
              "y": 16.807,
              "z": 1.396
            },
            "rightCorner": {
              "x": 18.062,
              "y": 16.811,
              "z": 1.396
            },
            "gtin": "4002471073008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d938",
            "leftCorner": {
              "x": 18.062,
              "y": 16.811,
              "z": 1.396
            },
            "rightCorner": {
              "x": 17.989,
              "y": 16.816,
              "z": 1.396
            },
            "gtin": "4002471073008",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "6ebce",
    "rightNeighborShelfId": "34a70"
  },
  {
    "id": "34a70",
    "name": "34a70",
    "x": 18.006,
    "y": 17.053,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029806
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54638d",
        "height": 0.18372,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e676",
            "leftCorner": {
              "x": 17.894,
              "y": 17.004,
              "z": 0.15
            },
            "rightCorner": {
              "x": 17.754,
              "y": 17.013,
              "z": 0.15
            },
            "gtin": "4063367157271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e677",
            "leftCorner": {
              "x": 17.754,
              "y": 17.013,
              "z": 0.15
            },
            "rightCorner": {
              "x": 17.613,
              "y": 17.021,
              "z": 0.15
            },
            "gtin": "4063367157271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e678",
            "leftCorner": {
              "x": 17.613,
              "y": 17.016,
              "z": 0.15
            },
            "rightCorner": {
              "x": 17.335,
              "y": 17.033,
              "z": 0.15
            },
            "gtin": "4337185480720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e679",
            "leftCorner": {
              "x": 17.335,
              "y": 17.033,
              "z": 0.15
            },
            "rightCorner": {
              "x": 17.055,
              "y": 17.05,
              "z": 0.15
            },
            "gtin": "4337185480720",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54638c",
        "height": 0.8036,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1da0e",
            "leftCorner": {
              "x": 18.004,
              "y": 16.905,
              "z": 0.657
            },
            "rightCorner": {
              "x": 17.883,
              "y": 16.913,
              "z": 0.657
            },
            "gtin": "40081922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da0f",
            "leftCorner": {
              "x": 17.883,
              "y": 16.913,
              "z": 0.657
            },
            "rightCorner": {
              "x": 17.761,
              "y": 16.919,
              "z": 0.657
            },
            "gtin": "40081922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da10",
            "leftCorner": {
              "x": 17.761,
              "y": 16.919,
              "z": 0.657
            },
            "rightCorner": {
              "x": 17.64,
              "y": 16.927,
              "z": 0.657
            },
            "gtin": "40081922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da11",
            "leftCorner": {
              "x": 17.64,
              "y": 16.927,
              "z": 0.657
            },
            "rightCorner": {
              "x": 17.519,
              "y": 16.935,
              "z": 0.657
            },
            "gtin": "40081922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da12",
            "leftCorner": {
              "x": 17.519,
              "y": 16.938,
              "z": 0.657
            },
            "rightCorner": {
              "x": 17.385,
              "y": 16.945,
              "z": 0.657
            },
            "gtin": "40122991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da13",
            "leftCorner": {
              "x": 17.385,
              "y": 16.945,
              "z": 0.657
            },
            "rightCorner": {
              "x": 17.251,
              "y": 16.953,
              "z": 0.657
            },
            "gtin": "40122991",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54638e",
        "height": 1.3106,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d9a9",
            "leftCorner": {
              "x": 17.987,
              "y": 16.835,
              "z": 1.072
            },
            "rightCorner": {
              "x": 17.787,
              "y": 16.846,
              "z": 1.072
            },
            "gtin": "4008100152557",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9aa",
            "leftCorner": {
              "x": 17.787,
              "y": 16.846,
              "z": 1.072
            },
            "rightCorner": {
              "x": 17.588,
              "y": 16.858,
              "z": 1.072
            },
            "gtin": "4008100152557",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9ab",
            "leftCorner": {
              "x": 17.586,
              "y": 16.838,
              "z": 1.072
            },
            "rightCorner": {
              "x": 17.402,
              "y": 16.849,
              "z": 1.072
            },
            "gtin": "4012200505335",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54638f",
        "height": 1.7049,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d939",
            "leftCorner": {
              "x": 17.989,
              "y": 16.832,
              "z": 1.395
            },
            "rightCorner": {
              "x": 17.873,
              "y": 16.839,
              "z": 1.395
            },
            "gtin": "4063367399060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d93a",
            "leftCorner": {
              "x": 17.873,
              "y": 16.839,
              "z": 1.395
            },
            "rightCorner": {
              "x": 17.756,
              "y": 16.845,
              "z": 1.395
            },
            "gtin": "4063367399060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d93b",
            "leftCorner": {
              "x": 17.756,
              "y": 16.845,
              "z": 1.395
            },
            "rightCorner": {
              "x": 17.64,
              "y": 16.852,
              "z": 1.395
            },
            "gtin": "4063367399060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d93c",
            "leftCorner": {
              "x": 17.639,
              "y": 16.838,
              "z": 1.395
            },
            "rightCorner": {
              "x": 17.56,
              "y": 16.842,
              "z": 1.395
            },
            "gtin": "4063367157240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d93d",
            "leftCorner": {
              "x": 17.56,
              "y": 16.842,
              "z": 1.395
            },
            "rightCorner": {
              "x": 17.482,
              "y": 16.847,
              "z": 1.395
            },
            "gtin": "4063367157240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d93e",
            "leftCorner": {
              "x": 17.482,
              "y": 16.847,
              "z": 1.395
            },
            "rightCorner": {
              "x": 17.403,
              "y": 16.851,
              "z": 1.395
            },
            "gtin": "4063367157240",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a6f",
    "rightNeighborShelfId": "34a71"
  },
  {
    "id": "34a71",
    "name": "34a71",
    "x": 17.357,
    "y": 17.091,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029806
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546397",
        "height": 0.18334,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e67a",
            "leftCorner": {
              "x": 17.056,
              "y": 17.052,
              "z": 0.15
            },
            "rightCorner": {
              "x": 16.824,
              "y": 17.066,
              "z": 0.15
            },
            "gtin": "40804743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e67b",
            "leftCorner": {
              "x": 16.826,
              "y": 17.091,
              "z": 0.15
            },
            "rightCorner": {
              "x": 16.547,
              "y": 17.108,
              "z": 0.15
            },
            "gtin": "40804002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e67c",
            "leftCorner": {
              "x": 16.547,
              "y": 17.108,
              "z": 0.15
            },
            "rightCorner": {
              "x": 16.269,
              "y": 17.124,
              "z": 0.15
            },
            "gtin": "40804002",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546396",
        "height": 0.80417,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1da14",
            "leftCorner": {
              "x": 17.251,
              "y": 16.958,
              "z": 0.658
            },
            "rightCorner": {
              "x": 17.135,
              "y": 16.965,
              "z": 0.658
            },
            "gtin": "40804774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da15",
            "leftCorner": {
              "x": 17.135,
              "y": 16.965,
              "z": 0.658
            },
            "rightCorner": {
              "x": 17.019,
              "y": 16.972,
              "z": 0.658
            },
            "gtin": "40804774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da16",
            "leftCorner": {
              "x": 17.019,
              "y": 16.963,
              "z": 0.658
            },
            "rightCorner": {
              "x": 16.718,
              "y": 16.981,
              "z": 0.658
            },
            "gtin": "4008100173460",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546395",
        "height": 1.3094,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d9ac",
            "leftCorner": {
              "x": 17.403,
              "y": 16.859,
              "z": 1.071
            },
            "rightCorner": {
              "x": 17.202,
              "y": 16.87,
              "z": 1.071
            },
            "gtin": "4012200505359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9ad",
            "leftCorner": {
              "x": 17.202,
              "y": 16.87,
              "z": 1.071
            },
            "rightCorner": {
              "x": 17.001,
              "y": 16.883,
              "z": 1.071
            },
            "gtin": "4012200505359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9ae",
            "leftCorner": {
              "x": 17.0,
              "y": 16.867,
              "z": 1.071
            },
            "rightCorner": {
              "x": 16.908,
              "y": 16.872,
              "z": 1.071
            },
            "gtin": "4045178002568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9af",
            "leftCorner": {
              "x": 16.908,
              "y": 16.872,
              "z": 1.071
            },
            "rightCorner": {
              "x": 16.815,
              "y": 16.878,
              "z": 1.071
            },
            "gtin": "4045178002568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9b0",
            "leftCorner": {
              "x": 16.815,
              "y": 16.878,
              "z": 1.071
            },
            "rightCorner": {
              "x": 16.723,
              "y": 16.884,
              "z": 1.071
            },
            "gtin": "4045178002568",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546394",
        "height": 1.7116,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d93f",
            "leftCorner": {
              "x": 17.402,
              "y": 16.847,
              "z": 1.4
            },
            "rightCorner": {
              "x": 17.282,
              "y": 16.854,
              "z": 1.4
            },
            "gtin": "4068500600232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d940",
            "leftCorner": {
              "x": 17.282,
              "y": 16.854,
              "z": 1.4
            },
            "rightCorner": {
              "x": 17.161,
              "y": 16.862,
              "z": 1.4
            },
            "gtin": "4068500600232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d941",
            "leftCorner": {
              "x": 17.161,
              "y": 16.86,
              "z": 1.4
            },
            "rightCorner": {
              "x": 17.096,
              "y": 16.863,
              "z": 1.4
            },
            "gtin": "4008100173019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d942",
            "leftCorner": {
              "x": 17.096,
              "y": 16.863,
              "z": 1.4
            },
            "rightCorner": {
              "x": 17.033,
              "y": 16.867,
              "z": 1.4
            },
            "gtin": "4008100173019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d943",
            "leftCorner": {
              "x": 17.033,
              "y": 16.87,
              "z": 1.4
            },
            "rightCorner": {
              "x": 16.948,
              "y": 16.874,
              "z": 1.4
            },
            "gtin": "4008100173026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d944",
            "leftCorner": {
              "x": 16.948,
              "y": 16.874,
              "z": 1.4
            },
            "rightCorner": {
              "x": 16.863,
              "y": 16.879,
              "z": 1.4
            },
            "gtin": "4008100173026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d945",
            "leftCorner": {
              "x": 16.863,
              "y": 16.886,
              "z": 1.4
            },
            "rightCorner": {
              "x": 16.753,
              "y": 16.893,
              "z": 1.4
            },
            "gtin": "4008100173224",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a70",
    "rightNeighborShelfId": "34a72"
  },
  {
    "id": "34a72",
    "name": "34a72",
    "x": 16.708,
    "y": 17.13,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029806
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 14
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54639b",
        "height": 0.18576,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e67d",
            "leftCorner": {
              "x": 16.268,
              "y": 17.114,
              "z": 0.152
            },
            "rightCorner": {
              "x": 16.128,
              "y": 17.122,
              "z": 0.152
            },
            "gtin": "4002442819079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e67e",
            "leftCorner": {
              "x": 16.128,
              "y": 17.122,
              "z": 0.152
            },
            "rightCorner": {
              "x": 15.987,
              "y": 17.13,
              "z": 0.152
            },
            "gtin": "4002442819079",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546398",
        "height": 0.80639,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1da17",
            "leftCorner": {
              "x": 16.719,
              "y": 16.996,
              "z": 0.66
            },
            "rightCorner": {
              "x": 16.516,
              "y": 17.008,
              "z": 0.66
            },
            "gtin": "4008100173606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da18",
            "leftCorner": {
              "x": 16.516,
              "y": 17.011,
              "z": 0.66
            },
            "rightCorner": {
              "x": 16.221,
              "y": 17.028,
              "z": 0.66
            },
            "gtin": "4012200462706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da19",
            "leftCorner": {
              "x": 16.221,
              "y": 17.018,
              "z": 0.66
            },
            "rightCorner": {
              "x": 16.064,
              "y": 17.027,
              "z": 0.66
            },
            "gtin": "4063367388415",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546399",
        "height": 1.3102,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d9b1",
            "leftCorner": {
              "x": 16.725,
              "y": 16.898,
              "z": 1.072
            },
            "rightCorner": {
              "x": 16.57,
              "y": 16.907,
              "z": 1.072
            },
            "gtin": "4045178002544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9b2",
            "leftCorner": {
              "x": 16.57,
              "y": 16.907,
              "z": 1.072
            },
            "rightCorner": {
              "x": 16.267,
              "y": 16.926,
              "z": 1.072
            },
            "gtin": "8720600099106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9b3",
            "leftCorner": {
              "x": 16.267,
              "y": 16.926,
              "z": 1.072
            },
            "rightCorner": {
              "x": 15.963,
              "y": 16.944,
              "z": 1.072
            },
            "gtin": "8720600099106",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54639a",
        "height": 1.7156,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d946",
            "leftCorner": {
              "x": 16.754,
              "y": 16.911,
              "z": 1.404
            },
            "rightCorner": {
              "x": 16.679,
              "y": 16.916,
              "z": 1.404
            },
            "gtin": "40081977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d947",
            "leftCorner": {
              "x": 16.679,
              "y": 16.916,
              "z": 1.404
            },
            "rightCorner": {
              "x": 16.602,
              "y": 16.92,
              "z": 1.404
            },
            "gtin": "40081977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d948",
            "leftCorner": {
              "x": 16.602,
              "y": 16.92,
              "z": 1.404
            },
            "rightCorner": {
              "x": 16.526,
              "y": 16.925,
              "z": 1.404
            },
            "gtin": "40081977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d949",
            "leftCorner": {
              "x": 16.526,
              "y": 16.925,
              "z": 1.404
            },
            "rightCorner": {
              "x": 16.367,
              "y": 16.933,
              "z": 1.404
            },
            "gtin": "4008100173668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d94a",
            "leftCorner": {
              "x": 16.367,
              "y": 16.933,
              "z": 1.404
            },
            "rightCorner": {
              "x": 16.209,
              "y": 16.943,
              "z": 1.404
            },
            "gtin": "4008100173668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d94b",
            "leftCorner": {
              "x": 16.209,
              "y": 16.933,
              "z": 1.404
            },
            "rightCorner": {
              "x": 16.097,
              "y": 16.941,
              "z": 1.404
            },
            "gtin": "4063367391606",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a71",
    "rightNeighborShelfId": "34a73"
  },
  {
    "id": "34a73",
    "name": "34a73",
    "x": 16.06,
    "y": 17.169,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029806
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 21
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54639f",
        "height": 0.19218,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e67f",
            "leftCorner": {
              "x": 15.989,
              "y": 17.139,
              "z": 0.157
            },
            "rightCorner": {
              "x": 15.647,
              "y": 17.159,
              "z": 0.157
            },
            "gtin": "4002442819284",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e680",
            "leftCorner": {
              "x": 15.646,
              "y": 17.126,
              "z": 0.157
            },
            "rightCorner": {
              "x": 15.39,
              "y": 17.142,
              "z": 0.157
            },
            "gtin": "4337185512483",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54639d",
        "height": 0.81031,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1da1a",
            "leftCorner": {
              "x": 16.065,
              "y": 17.037,
              "z": 0.663
            },
            "rightCorner": {
              "x": 15.992,
              "y": 17.041,
              "z": 0.663
            },
            "gtin": "40804705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da1b",
            "leftCorner": {
              "x": 15.992,
              "y": 17.041,
              "z": 0.663
            },
            "rightCorner": {
              "x": 15.918,
              "y": 17.045,
              "z": 0.663
            },
            "gtin": "40804705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da1c",
            "leftCorner": {
              "x": 15.918,
              "y": 17.045,
              "z": 0.663
            },
            "rightCorner": {
              "x": 15.844,
              "y": 17.05,
              "z": 0.663
            },
            "gtin": "40804705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da1d",
            "leftCorner": {
              "x": 15.844,
              "y": 17.046,
              "z": 0.663
            },
            "rightCorner": {
              "x": 15.68,
              "y": 17.056,
              "z": 0.663
            },
            "gtin": "40804019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da1e",
            "leftCorner": {
              "x": 15.68,
              "y": 17.056,
              "z": 0.663
            },
            "rightCorner": {
              "x": 15.514,
              "y": 17.066,
              "z": 0.663
            },
            "gtin": "40804019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da1f",
            "leftCorner": {
              "x": 15.514,
              "y": 17.066,
              "z": 0.663
            },
            "rightCorner": {
              "x": 15.35,
              "y": 17.076,
              "z": 0.663
            },
            "gtin": "40804019",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54639e",
        "height": 1.3156,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d9b4",
            "leftCorner": {
              "x": 15.965,
              "y": 16.943,
              "z": 1.076
            },
            "rightCorner": {
              "x": 15.802,
              "y": 16.952,
              "z": 1.076
            },
            "gtin": "4250262709401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9b5",
            "leftCorner": {
              "x": 15.802,
              "y": 16.952,
              "z": 1.076
            },
            "rightCorner": {
              "x": 15.64,
              "y": 16.962,
              "z": 1.076
            },
            "gtin": "4250262709401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9b6",
            "leftCorner": {
              "x": 15.639,
              "y": 16.941,
              "z": 1.076
            },
            "rightCorner": {
              "x": 15.565,
              "y": 16.946,
              "z": 1.076
            },
            "gtin": "4012712001547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9b7",
            "leftCorner": {
              "x": 15.565,
              "y": 16.946,
              "z": 1.076
            },
            "rightCorner": {
              "x": 15.49,
              "y": 16.95,
              "z": 1.076
            },
            "gtin": "4012712001547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9b8",
            "leftCorner": {
              "x": 15.49,
              "y": 16.95,
              "z": 1.076
            },
            "rightCorner": {
              "x": 15.414,
              "y": 16.955,
              "z": 1.076
            },
            "gtin": "4012712001547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9b9",
            "leftCorner": {
              "x": 15.414,
              "y": 16.955,
              "z": 1.076
            },
            "rightCorner": {
              "x": 15.34,
              "y": 16.959,
              "z": 1.076
            },
            "gtin": "4012712001547",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54639c",
        "height": 1.7161,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d94c",
            "leftCorner": {
              "x": 16.098,
              "y": 16.943,
              "z": 1.404
            },
            "rightCorner": {
              "x": 15.976,
              "y": 16.95,
              "z": 1.404
            },
            "gtin": "4250262709487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d94d",
            "leftCorner": {
              "x": 15.976,
              "y": 16.95,
              "z": 1.404
            },
            "rightCorner": {
              "x": 15.854,
              "y": 16.958,
              "z": 1.404
            },
            "gtin": "4250262709487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d94e",
            "leftCorner": {
              "x": 15.853,
              "y": 16.948,
              "z": 1.404
            },
            "rightCorner": {
              "x": 15.763,
              "y": 16.953,
              "z": 1.404
            },
            "gtin": "4016435002713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d94f",
            "leftCorner": {
              "x": 15.763,
              "y": 16.953,
              "z": 1.404
            },
            "rightCorner": {
              "x": 15.674,
              "y": 16.958,
              "z": 1.404
            },
            "gtin": "4016435002713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d950",
            "leftCorner": {
              "x": 15.674,
              "y": 16.958,
              "z": 1.404
            },
            "rightCorner": {
              "x": 15.584,
              "y": 16.964,
              "z": 1.404
            },
            "gtin": "4016435002713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d951",
            "leftCorner": {
              "x": 15.583,
              "y": 16.938,
              "z": 1.404
            },
            "rightCorner": {
              "x": 15.473,
              "y": 16.944,
              "z": 1.404
            },
            "gtin": "4032549046108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d952",
            "leftCorner": {
              "x": 15.474,
              "y": 16.953,
              "z": 1.404
            },
            "rightCorner": {
              "x": 15.353,
              "y": 16.959,
              "z": 1.404
            },
            "gtin": "4032549046122",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a72",
    "rightNeighborShelfId": "34a74"
  },
  {
    "id": "34a74",
    "name": "34a74",
    "x": 15.411,
    "y": 17.207,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029806
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463a3",
        "height": 0.19414,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e681",
            "leftCorner": {
              "x": 15.39,
              "y": 17.154,
              "z": 0.159
            },
            "rightCorner": {
              "x": 15.27,
              "y": 17.16,
              "z": 0.159
            },
            "gtin": "4337185512599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e682",
            "leftCorner": {
              "x": 15.27,
              "y": 17.16,
              "z": 0.159
            },
            "rightCorner": {
              "x": 15.15,
              "y": 17.168,
              "z": 0.159
            },
            "gtin": "4337185512599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e683",
            "leftCorner": {
              "x": 15.15,
              "y": 17.17,
              "z": 0.159
            },
            "rightCorner": {
              "x": 15.003,
              "y": 17.178,
              "z": 0.159
            },
            "gtin": "4337185510502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e684",
            "leftCorner": {
              "x": 15.003,
              "y": 17.178,
              "z": 0.159
            },
            "rightCorner": {
              "x": 14.857,
              "y": 17.187,
              "z": 0.159
            },
            "gtin": "4337185510502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e685",
            "leftCorner": {
              "x": 14.856,
              "y": 17.184,
              "z": 0.159
            },
            "rightCorner": {
              "x": 14.738,
              "y": 17.191,
              "z": 0.159
            },
            "gtin": "4063367145506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e686",
            "leftCorner": {
              "x": 14.738,
              "y": 17.191,
              "z": 0.159
            },
            "rightCorner": {
              "x": 14.62,
              "y": 17.198,
              "z": 0.159
            },
            "gtin": "4063367145506",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463a0",
        "height": 0.8125,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1da20",
            "leftCorner": {
              "x": 15.349,
              "y": 17.063,
              "z": 0.665
            },
            "rightCorner": {
              "x": 15.192,
              "y": 17.072,
              "z": 0.665
            },
            "gtin": "40804606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da21",
            "leftCorner": {
              "x": 15.193,
              "y": 17.081,
              "z": 0.665
            },
            "rightCorner": {
              "x": 15.037,
              "y": 17.091,
              "z": 0.665
            },
            "gtin": "40804583",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da22",
            "leftCorner": {
              "x": 15.036,
              "y": 17.079,
              "z": 0.665
            },
            "rightCorner": {
              "x": 14.944,
              "y": 17.085,
              "z": 0.665
            },
            "gtin": "40804651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da23",
            "leftCorner": {
              "x": 14.944,
              "y": 17.085,
              "z": 0.665
            },
            "rightCorner": {
              "x": 14.852,
              "y": 17.09,
              "z": 0.665
            },
            "gtin": "40804651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da24",
            "leftCorner": {
              "x": 14.852,
              "y": 17.09,
              "z": 0.665
            },
            "rightCorner": {
              "x": 14.76,
              "y": 17.095,
              "z": 0.665
            },
            "gtin": "40804651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da25",
            "leftCorner": {
              "x": 14.76,
              "y": 17.095,
              "z": 0.665
            },
            "rightCorner": {
              "x": 14.668,
              "y": 17.101,
              "z": 0.665
            },
            "gtin": "40804651",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463a1",
        "height": 1.3168,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d9ba",
            "leftCorner": {
              "x": 15.34,
              "y": 16.971,
              "z": 1.077
            },
            "rightCorner": {
              "x": 15.138,
              "y": 16.983,
              "z": 1.077
            },
            "gtin": "4250262708244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9bb",
            "leftCorner": {
              "x": 15.138,
              "y": 16.981,
              "z": 1.077
            },
            "rightCorner": {
              "x": 14.918,
              "y": 16.994,
              "z": 1.077
            },
            "gtin": "4250262708268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9bc",
            "leftCorner": {
              "x": 14.918,
              "y": 16.984,
              "z": 1.077
            },
            "rightCorner": {
              "x": 14.688,
              "y": 16.998,
              "z": 1.077
            },
            "gtin": "4250262709494",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463a2",
        "height": 1.7233,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d953",
            "leftCorner": {
              "x": 15.353,
              "y": 16.977,
              "z": 1.41
            },
            "rightCorner": {
              "x": 15.28,
              "y": 16.981,
              "z": 1.41
            },
            "gtin": "4037700078509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d954",
            "leftCorner": {
              "x": 15.28,
              "y": 16.981,
              "z": 1.41
            },
            "rightCorner": {
              "x": 15.206,
              "y": 16.985,
              "z": 1.41
            },
            "gtin": "4037700078509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d955",
            "leftCorner": {
              "x": 15.206,
              "y": 16.985,
              "z": 1.41
            },
            "rightCorner": {
              "x": 15.134,
              "y": 16.99,
              "z": 1.41
            },
            "gtin": "4037700078509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d956",
            "leftCorner": {
              "x": 15.134,
              "y": 17.002,
              "z": 1.41
            },
            "rightCorner": {
              "x": 15.039,
              "y": 17.008,
              "z": 1.41
            },
            "gtin": "4037700078424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d957",
            "leftCorner": {
              "x": 15.039,
              "y": 17.008,
              "z": 1.41
            },
            "rightCorner": {
              "x": 14.943,
              "y": 17.014,
              "z": 1.41
            },
            "gtin": "4037700078424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d958",
            "leftCorner": {
              "x": 14.944,
              "y": 17.017,
              "z": 1.41
            },
            "rightCorner": {
              "x": 14.77,
              "y": 17.027,
              "z": 1.41
            },
            "gtin": "40804637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d959",
            "leftCorner": {
              "x": 14.769,
              "y": 17.01,
              "z": 1.41
            },
            "rightCorner": {
              "x": 14.661,
              "y": 17.017,
              "z": 1.41
            },
            "gtin": "40198552",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a73",
    "rightNeighborShelfId": "34a75"
  },
  {
    "id": "34a75",
    "name": "34a75",
    "x": 14.762,
    "y": 17.246,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029806
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463a7",
        "height": 0.18516,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e687",
            "leftCorner": {
              "x": 14.62,
              "y": 17.202,
              "z": 0.151
            },
            "rightCorner": {
              "x": 14.312,
              "y": 17.221,
              "z": 0.151
            },
            "gtin": "4337185512575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e688",
            "leftCorner": {
              "x": 14.311,
              "y": 17.213,
              "z": 0.151
            },
            "rightCorner": {
              "x": 14.074,
              "y": 17.228,
              "z": 0.151
            },
            "gtin": "4337185512544",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463a4",
        "height": 0.81185,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1da26",
            "leftCorner": {
              "x": 14.669,
              "y": 17.12,
              "z": 0.664
            },
            "rightCorner": {
              "x": 14.548,
              "y": 17.127,
              "z": 0.664
            },
            "gtin": "40081410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da27",
            "leftCorner": {
              "x": 14.548,
              "y": 17.127,
              "z": 0.664
            },
            "rightCorner": {
              "x": 14.428,
              "y": 17.134,
              "z": 0.664
            },
            "gtin": "40081410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da28",
            "leftCorner": {
              "x": 14.428,
              "y": 17.134,
              "z": 0.664
            },
            "rightCorner": {
              "x": 14.307,
              "y": 17.141,
              "z": 0.664
            },
            "gtin": "40081410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da29",
            "leftCorner": {
              "x": 14.306,
              "y": 17.124,
              "z": 0.664
            },
            "rightCorner": {
              "x": 14.155,
              "y": 17.133,
              "z": 0.664
            },
            "gtin": "4012200417409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da2a",
            "leftCorner": {
              "x": 14.155,
              "y": 17.133,
              "z": 0.664
            },
            "rightCorner": {
              "x": 14.005,
              "y": 17.142,
              "z": 0.664
            },
            "gtin": "4012200417409",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463a6",
        "height": 1.3172,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d9bd",
            "leftCorner": {
              "x": 14.688,
              "y": 17.002,
              "z": 1.078
            },
            "rightCorner": {
              "x": 14.574,
              "y": 17.008,
              "z": 1.078
            },
            "gtin": "4063367343247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9be",
            "leftCorner": {
              "x": 14.574,
              "y": 17.008,
              "z": 1.078
            },
            "rightCorner": {
              "x": 14.462,
              "y": 17.015,
              "z": 1.078
            },
            "gtin": "4063367343247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9bf",
            "leftCorner": {
              "x": 14.462,
              "y": 17.015,
              "z": 1.078
            },
            "rightCorner": {
              "x": 14.348,
              "y": 17.022,
              "z": 1.078
            },
            "gtin": "4063367343247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9c0",
            "leftCorner": {
              "x": 14.348,
              "y": 17.022,
              "z": 1.078
            },
            "rightCorner": {
              "x": 14.235,
              "y": 17.029,
              "z": 1.078
            },
            "gtin": "4063367343247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9c1",
            "leftCorner": {
              "x": 14.235,
              "y": 17.034,
              "z": 1.078
            },
            "rightCorner": {
              "x": 14.155,
              "y": 17.038,
              "z": 1.078
            },
            "gtin": "4337185469428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9c2",
            "leftCorner": {
              "x": 14.155,
              "y": 17.038,
              "z": 1.078
            },
            "rightCorner": {
              "x": 14.075,
              "y": 17.043,
              "z": 1.078
            },
            "gtin": "4337185469428",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463a5",
        "height": 1.7201,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d95a",
            "leftCorner": {
              "x": 14.66,
              "y": 17.018,
              "z": 1.407
            },
            "rightCorner": {
              "x": 14.584,
              "y": 17.022,
              "z": 1.407
            },
            "gtin": "40804675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d95b",
            "leftCorner": {
              "x": 14.584,
              "y": 17.022,
              "z": 1.407
            },
            "rightCorner": {
              "x": 14.506,
              "y": 17.027,
              "z": 1.407
            },
            "gtin": "40804675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d95c",
            "leftCorner": {
              "x": 14.506,
              "y": 17.024,
              "z": 1.407
            },
            "rightCorner": {
              "x": 14.425,
              "y": 17.029,
              "z": 1.407
            },
            "gtin": "40804613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d95d",
            "leftCorner": {
              "x": 14.425,
              "y": 17.029,
              "z": 1.407
            },
            "rightCorner": {
              "x": 14.343,
              "y": 17.034,
              "z": 1.407
            },
            "gtin": "40804613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d95e",
            "leftCorner": {
              "x": 14.343,
              "y": 17.033,
              "z": 1.407
            },
            "rightCorner": {
              "x": 14.197,
              "y": 17.042,
              "z": 1.407
            },
            "gtin": "40198545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d95f",
            "leftCorner": {
              "x": 14.198,
              "y": 17.053,
              "z": 1.407
            },
            "rightCorner": {
              "x": 14.098,
              "y": 17.059,
              "z": 1.407
            },
            "gtin": "4012200401057",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a74",
    "rightNeighborShelfId": "34a76"
  },
  {
    "id": "34a76",
    "name": "34a76",
    "x": 14.113,
    "y": 17.285,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029806
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 26
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463b0",
        "height": 0.17528,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e689",
            "leftCorner": {
              "x": 14.075,
              "y": 17.222,
              "z": 0.143
            },
            "rightCorner": {
              "x": 13.92,
              "y": 17.231,
              "z": 0.143
            },
            "gtin": "4337185510342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e68a",
            "leftCorner": {
              "x": 13.92,
              "y": 17.231,
              "z": 0.143
            },
            "rightCorner": {
              "x": 13.764,
              "y": 17.241,
              "z": 0.143
            },
            "gtin": "4337185510342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e68b",
            "leftCorner": {
              "x": 13.764,
              "y": 17.241,
              "z": 0.143
            },
            "rightCorner": {
              "x": 13.608,
              "y": 17.25,
              "z": 0.143
            },
            "gtin": "4337185510342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e68c",
            "leftCorner": {
              "x": 13.608,
              "y": 17.25,
              "z": 0.143
            },
            "rightCorner": {
              "x": 13.454,
              "y": 17.258,
              "z": 0.143
            },
            "gtin": "4337185510342",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463af",
        "height": 0.80648,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1da2b",
            "leftCorner": {
              "x": 14.007,
              "y": 17.152,
              "z": 0.66
            },
            "rightCorner": {
              "x": 13.903,
              "y": 17.158,
              "z": 0.66
            },
            "gtin": "4012200046654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da2c",
            "leftCorner": {
              "x": 13.903,
              "y": 17.158,
              "z": 0.66
            },
            "rightCorner": {
              "x": 13.8,
              "y": 17.164,
              "z": 0.66
            },
            "gtin": "4012200046654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da2d",
            "leftCorner": {
              "x": 13.8,
              "y": 17.164,
              "z": 0.66
            },
            "rightCorner": {
              "x": 13.697,
              "y": 17.17,
              "z": 0.66
            },
            "gtin": "4012200046654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da2e",
            "leftCorner": {
              "x": 13.695,
              "y": 17.154,
              "z": 0.66
            },
            "rightCorner": {
              "x": 13.583,
              "y": 17.16,
              "z": 0.66
            },
            "gtin": "4008463110768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da2f",
            "leftCorner": {
              "x": 13.583,
              "y": 17.16,
              "z": 0.66
            },
            "rightCorner": {
              "x": 13.47,
              "y": 17.167,
              "z": 0.66
            },
            "gtin": "4008463110768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da30",
            "leftCorner": {
              "x": 13.47,
              "y": 17.167,
              "z": 0.66
            },
            "rightCorner": {
              "x": 13.357,
              "y": 17.174,
              "z": 0.66
            },
            "gtin": "4008463110768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da31",
            "leftCorner": {
              "x": 13.357,
              "y": 17.174,
              "z": 0.66
            },
            "rightCorner": {
              "x": 13.244,
              "y": 17.18,
              "z": 0.66
            },
            "gtin": "4008463110768",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463ae",
        "height": 1.3163,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d9c3",
            "leftCorner": {
              "x": 14.076,
              "y": 17.056,
              "z": 1.077
            },
            "rightCorner": {
              "x": 13.959,
              "y": 17.064,
              "z": 1.077
            },
            "gtin": "5701116208162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9c4",
            "leftCorner": {
              "x": 13.959,
              "y": 17.064,
              "z": 1.077
            },
            "rightCorner": {
              "x": 13.843,
              "y": 17.07,
              "z": 1.077
            },
            "gtin": "5701116208162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9c5",
            "leftCorner": {
              "x": 13.841,
              "y": 17.061,
              "z": 1.077
            },
            "rightCorner": {
              "x": 13.786,
              "y": 17.064,
              "z": 1.077
            },
            "gtin": "3017800262542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9c6",
            "leftCorner": {
              "x": 13.786,
              "y": 17.064,
              "z": 1.077
            },
            "rightCorner": {
              "x": 13.73,
              "y": 17.068,
              "z": 1.077
            },
            "gtin": "3017800262542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9c7",
            "leftCorner": {
              "x": 13.73,
              "y": 17.069,
              "z": 1.077
            },
            "rightCorner": {
              "x": 13.653,
              "y": 17.073,
              "z": 1.077
            },
            "gtin": "3017800253700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9c8",
            "leftCorner": {
              "x": 13.653,
              "y": 17.073,
              "z": 1.077
            },
            "rightCorner": {
              "x": 13.576,
              "y": 17.078,
              "z": 1.077
            },
            "gtin": "3017800253700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9c9",
            "leftCorner": {
              "x": 13.576,
              "y": 17.082,
              "z": 1.077
            },
            "rightCorner": {
              "x": 13.541,
              "y": 17.083,
              "z": 1.077
            },
            "gtin": "3017800262580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9ca",
            "leftCorner": {
              "x": 13.541,
              "y": 17.083,
              "z": 1.077
            },
            "rightCorner": {
              "x": 13.505,
              "y": 17.086,
              "z": 1.077
            },
            "gtin": "3017800262580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9cb",
            "leftCorner": {
              "x": 13.505,
              "y": 17.086,
              "z": 1.077
            },
            "rightCorner": {
              "x": 13.469,
              "y": 17.089,
              "z": 1.077
            },
            "gtin": "3017800262580",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463ad",
        "height": 1.7135,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d960",
            "leftCorner": {
              "x": 14.099,
              "y": 17.065,
              "z": 1.402
            },
            "rightCorner": {
              "x": 13.95,
              "y": 17.074,
              "z": 1.402
            },
            "gtin": "40198682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d961",
            "leftCorner": {
              "x": 13.95,
              "y": 17.071,
              "z": 1.402
            },
            "rightCorner": {
              "x": 13.785,
              "y": 17.081,
              "z": 1.402
            },
            "gtin": "40122748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d962",
            "leftCorner": {
              "x": 13.784,
              "y": 17.078,
              "z": 1.402
            },
            "rightCorner": {
              "x": 13.706,
              "y": 17.084,
              "z": 1.402
            },
            "gtin": "40804521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d963",
            "leftCorner": {
              "x": 13.706,
              "y": 17.084,
              "z": 1.402
            },
            "rightCorner": {
              "x": 13.627,
              "y": 17.089,
              "z": 1.402
            },
            "gtin": "40804521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d964",
            "leftCorner": {
              "x": 13.627,
              "y": 17.093,
              "z": 1.402
            },
            "rightCorner": {
              "x": 13.536,
              "y": 17.098,
              "z": 1.402
            },
            "gtin": "40804644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d965",
            "leftCorner": {
              "x": 13.536,
              "y": 17.098,
              "z": 1.402
            },
            "rightCorner": {
              "x": 13.444,
              "y": 17.104,
              "z": 1.402
            },
            "gtin": "40804644",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a75",
    "rightNeighborShelfId": "34a77"
  },
  {
    "id": "34a77",
    "name": "34a77",
    "x": 13.464,
    "y": 17.324,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029806
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463b9",
        "height": 0.17716,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e673",
            "leftCorner": {
              "x": 13.453,
              "y": 17.275,
              "z": 0.145
            },
            "rightCorner": {
              "x": 12.812,
              "y": 17.314,
              "z": 0.145
            },
            "gtin": "4063367283864",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463b8",
        "height": 0.807,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1da32",
            "leftCorner": {
              "x": 13.245,
              "y": 17.206,
              "z": 0.66
            },
            "rightCorner": {
              "x": 13.171,
              "y": 17.209,
              "z": 0.66
            },
            "gtin": "4010321006618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da33",
            "leftCorner": {
              "x": 13.171,
              "y": 17.209,
              "z": 0.66
            },
            "rightCorner": {
              "x": 13.098,
              "y": 17.214,
              "z": 0.66
            },
            "gtin": "4010321006618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da34",
            "leftCorner": {
              "x": 13.098,
              "y": 17.214,
              "z": 0.66
            },
            "rightCorner": {
              "x": 13.024,
              "y": 17.218,
              "z": 0.66
            },
            "gtin": "4010321006618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da35",
            "leftCorner": {
              "x": 13.023,
              "y": 17.214,
              "z": 0.66
            },
            "rightCorner": {
              "x": 12.844,
              "y": 17.225,
              "z": 0.66
            },
            "gtin": "4002442819154",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463b6",
        "height": 1.3141,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d9cc",
            "leftCorner": {
              "x": 13.469,
              "y": 17.102,
              "z": 1.075
            },
            "rightCorner": {
              "x": 13.424,
              "y": 17.105,
              "z": 1.075
            },
            "gtin": "3017800253847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9cd",
            "leftCorner": {
              "x": 13.424,
              "y": 17.105,
              "z": 1.075
            },
            "rightCorner": {
              "x": 13.378,
              "y": 17.108,
              "z": 1.075
            },
            "gtin": "3017800253847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9ce",
            "leftCorner": {
              "x": 13.378,
              "y": 17.108,
              "z": 1.075
            },
            "rightCorner": {
              "x": 13.333,
              "y": 17.11,
              "z": 1.075
            },
            "gtin": "3017800253847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9cf",
            "leftCorner": {
              "x": 13.333,
              "y": 17.11,
              "z": 1.075
            },
            "rightCorner": {
              "x": 13.288,
              "y": 17.113,
              "z": 1.075
            },
            "gtin": "3017800253847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9d0",
            "leftCorner": {
              "x": 13.288,
              "y": 17.113,
              "z": 1.075
            },
            "rightCorner": {
              "x": 13.242,
              "y": 17.116,
              "z": 1.075
            },
            "gtin": "3017800253847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9d1",
            "leftCorner": {
              "x": 13.242,
              "y": 17.111,
              "z": 1.075
            },
            "rightCorner": {
              "x": 13.133,
              "y": 17.116,
              "z": 1.075
            },
            "gtin": "4010321006618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9d2",
            "leftCorner": {
              "x": 13.133,
              "y": 17.116,
              "z": 1.075
            },
            "rightCorner": {
              "x": 13.023,
              "y": 17.123,
              "z": 1.075
            },
            "gtin": "4010321006618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9d3",
            "leftCorner": {
              "x": 13.023,
              "y": 17.123,
              "z": 1.075
            },
            "rightCorner": {
              "x": 12.915,
              "y": 17.13,
              "z": 1.075
            },
            "gtin": "4010321006618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9d4",
            "leftCorner": {
              "x": 12.915,
              "y": 17.13,
              "z": 1.075
            },
            "rightCorner": {
              "x": 12.806,
              "y": 17.136,
              "z": 1.075
            },
            "gtin": "4010321006618",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463b7",
        "height": 1.7149,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d966",
            "leftCorner": {
              "x": 13.444,
              "y": 17.121,
              "z": 1.403
            },
            "rightCorner": {
              "x": 13.327,
              "y": 17.128,
              "z": 1.403
            },
            "gtin": "4002015561695",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d967",
            "leftCorner": {
              "x": 13.327,
              "y": 17.119,
              "z": 1.403
            },
            "rightCorner": {
              "x": 13.208,
              "y": 17.127,
              "z": 1.403
            },
            "gtin": "4002015561701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d968",
            "leftCorner": {
              "x": 13.208,
              "y": 17.127,
              "z": 1.403
            },
            "rightCorner": {
              "x": 13.089,
              "y": 17.134,
              "z": 1.403
            },
            "gtin": "4002015561701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d969",
            "leftCorner": {
              "x": 13.087,
              "y": 17.125,
              "z": 1.403
            },
            "rightCorner": {
              "x": 12.985,
              "y": 17.13,
              "z": 1.403
            },
            "gtin": "4045178002483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d96a",
            "leftCorner": {
              "x": 12.985,
              "y": 17.14,
              "z": 1.403
            },
            "rightCorner": {
              "x": 12.852,
              "y": 17.148,
              "z": 1.403
            },
            "gtin": "4002442820310",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a76",
    "rightNeighborShelfId": "34a78"
  },
  {
    "id": "34a78",
    "name": "34a78",
    "x": 12.815,
    "y": 17.362,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029806
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546209",
        "height": 0.80664,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1da36",
            "leftCorner": {
              "x": 12.842,
              "y": 17.205,
              "z": 0.66
            },
            "rightCorner": {
              "x": 12.708,
              "y": 17.212,
              "z": 0.66
            },
            "gtin": "8710609006519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da37",
            "leftCorner": {
              "x": 12.708,
              "y": 17.212,
              "z": 0.66
            },
            "rightCorner": {
              "x": 12.574,
              "y": 17.22,
              "z": 0.66
            },
            "gtin": "8710609006519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da38",
            "leftCorner": {
              "x": 12.574,
              "y": 17.208,
              "z": 0.66
            },
            "rightCorner": {
              "x": 12.441,
              "y": 17.216,
              "z": 0.66
            },
            "gtin": "8710609412082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da39",
            "leftCorner": {
              "x": 12.441,
              "y": 17.216,
              "z": 0.66
            },
            "rightCorner": {
              "x": 12.307,
              "y": 17.223,
              "z": 0.66
            },
            "gtin": "8710609412082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da3a",
            "leftCorner": {
              "x": 12.309,
              "y": 17.233,
              "z": 0.66
            },
            "rightCorner": {
              "x": 12.205,
              "y": 17.24,
              "z": 0.66
            },
            "gtin": "8710609412075",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546208",
        "height": 1.3158,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d9d5",
            "leftCorner": {
              "x": 12.804,
              "y": 17.115,
              "z": 1.077
            },
            "rightCorner": {
              "x": 12.703,
              "y": 17.121,
              "z": 1.077
            },
            "gtin": "4337185731228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9d6",
            "leftCorner": {
              "x": 12.703,
              "y": 17.121,
              "z": 1.077
            },
            "rightCorner": {
              "x": 12.603,
              "y": 17.128,
              "z": 1.077
            },
            "gtin": "4337185731228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9d7",
            "leftCorner": {
              "x": 12.602,
              "y": 17.114,
              "z": 1.077
            },
            "rightCorner": {
              "x": 12.505,
              "y": 17.119,
              "z": 1.077
            },
            "gtin": "4337185659683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9d8",
            "leftCorner": {
              "x": 12.505,
              "y": 17.119,
              "z": 1.077
            },
            "rightCorner": {
              "x": 12.408,
              "y": 17.125,
              "z": 1.077
            },
            "gtin": "4337185659683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9d9",
            "leftCorner": {
              "x": 12.408,
              "y": 17.125,
              "z": 1.077
            },
            "rightCorner": {
              "x": 12.311,
              "y": 17.131,
              "z": 1.077
            },
            "gtin": "4337185659683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9da",
            "leftCorner": {
              "x": 12.311,
              "y": 17.132,
              "z": 1.077
            },
            "rightCorner": {
              "x": 12.185,
              "y": 17.14,
              "z": 1.077
            },
            "gtin": "4063367218989",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546207",
        "height": 1.7116,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d96b",
            "leftCorner": {
              "x": 12.85,
              "y": 17.132,
              "z": 1.4
            },
            "rightCorner": {
              "x": 12.755,
              "y": 17.138,
              "z": 1.4
            },
            "gtin": "3083680975353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d96c",
            "leftCorner": {
              "x": 12.754,
              "y": 17.12,
              "z": 1.4
            },
            "rightCorner": {
              "x": 12.623,
              "y": 17.127,
              "z": 1.4
            },
            "gtin": "3083680019880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d96d",
            "leftCorner": {
              "x": 12.622,
              "y": 17.117,
              "z": 1.4
            },
            "rightCorner": {
              "x": 12.544,
              "y": 17.122,
              "z": 1.4
            },
            "gtin": "4063367289859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d96e",
            "leftCorner": {
              "x": 12.544,
              "y": 17.122,
              "z": 1.4
            },
            "rightCorner": {
              "x": 12.465,
              "y": 17.127,
              "z": 1.4
            },
            "gtin": "4063367289859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d96f",
            "leftCorner": {
              "x": 12.465,
              "y": 17.127,
              "z": 1.4
            },
            "rightCorner": {
              "x": 12.386,
              "y": 17.132,
              "z": 1.4
            },
            "gtin": "4063367289859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d970",
            "leftCorner": {
              "x": 12.386,
              "y": 17.127,
              "z": 1.4
            },
            "rightCorner": {
              "x": 12.272,
              "y": 17.135,
              "z": 1.4
            },
            "gtin": "4063367289941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d971",
            "leftCorner": {
              "x": 12.274,
              "y": 17.144,
              "z": 1.4
            },
            "rightCorner": {
              "x": 12.2,
              "y": 17.148,
              "z": 1.4
            },
            "gtin": "4063367289897",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a77",
    "rightNeighborShelfId": "34a79"
  },
  {
    "id": "34a79",
    "name": "34a79",
    "x": 12.166,
    "y": 17.401,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029806
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 17
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463bd",
        "height": 0.17842,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a5463ba",
        "height": 0.80947,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1da3b",
            "leftCorner": {
              "x": 12.206,
              "y": 17.256,
              "z": 0.662
            },
            "rightCorner": {
              "x": 12.033,
              "y": 17.266,
              "z": 0.662
            },
            "gtin": "8710609011117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da3c",
            "leftCorner": {
              "x": 12.033,
              "y": 17.266,
              "z": 0.662
            },
            "rightCorner": {
              "x": 11.86,
              "y": 17.277,
              "z": 0.662
            },
            "gtin": "8710609011117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da01",
            "leftCorner": {
              "x": 11.86,
              "y": 17.284,
              "z": 0.662
            },
            "rightCorner": {
              "x": 11.685,
              "y": 17.294,
              "z": 0.662
            },
            "gtin": "8001440133114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da02",
            "leftCorner": {
              "x": 11.685,
              "y": 17.294,
              "z": 0.662
            },
            "rightCorner": {
              "x": 11.51,
              "y": 17.304,
              "z": 0.662
            },
            "gtin": "8001440133114",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463bb",
        "height": 1.315,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d9db",
            "leftCorner": {
              "x": 12.187,
              "y": 17.161,
              "z": 1.076
            },
            "rightCorner": {
              "x": 12.031,
              "y": 17.17,
              "z": 1.076
            },
            "gtin": "4063367308772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9dc",
            "leftCorner": {
              "x": 12.032,
              "y": 17.179,
              "z": 1.076
            },
            "rightCorner": {
              "x": 11.874,
              "y": 17.189,
              "z": 1.076
            },
            "gtin": "4063367308864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9dd",
            "leftCorner": {
              "x": 11.874,
              "y": 17.185,
              "z": 1.076
            },
            "rightCorner": {
              "x": 11.707,
              "y": 17.195,
              "z": 1.076
            },
            "gtin": "4063367308604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9de",
            "leftCorner": {
              "x": 11.707,
              "y": 17.188,
              "z": 1.076
            },
            "rightCorner": {
              "x": 11.537,
              "y": 17.198,
              "z": 1.076
            },
            "gtin": "4063367308703",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463bc",
        "height": 1.7177,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d972",
            "leftCorner": {
              "x": 12.201,
              "y": 17.164,
              "z": 1.405
            },
            "rightCorner": {
              "x": 12.083,
              "y": 17.171,
              "z": 1.405
            },
            "gtin": "4063367289910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d973",
            "leftCorner": {
              "x": 12.083,
              "y": 17.171,
              "z": 1.405
            },
            "rightCorner": {
              "x": 11.966,
              "y": 17.178,
              "z": 1.405
            },
            "gtin": "4063367289910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d974",
            "leftCorner": {
              "x": 11.966,
              "y": 17.181,
              "z": 1.405
            },
            "rightCorner": {
              "x": 11.888,
              "y": 17.185,
              "z": 1.405
            },
            "gtin": "5901135054249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d975",
            "leftCorner": {
              "x": 11.888,
              "y": 17.185,
              "z": 1.405
            },
            "rightCorner": {
              "x": 11.811,
              "y": 17.19,
              "z": 1.405
            },
            "gtin": "5901135054249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d976",
            "leftCorner": {
              "x": 11.811,
              "y": 17.19,
              "z": 1.405
            },
            "rightCorner": {
              "x": 11.733,
              "y": 17.195,
              "z": 1.405
            },
            "gtin": "5901135054249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d977",
            "leftCorner": {
              "x": 11.733,
              "y": 17.192,
              "z": 1.405
            },
            "rightCorner": {
              "x": 11.688,
              "y": 17.195,
              "z": 1.405
            },
            "gtin": "4032549035379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d978",
            "leftCorner": {
              "x": 11.688,
              "y": 17.195,
              "z": 1.405
            },
            "rightCorner": {
              "x": 11.641,
              "y": 17.198,
              "z": 1.405
            },
            "gtin": "4032549035379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d979",
            "leftCorner": {
              "x": 11.641,
              "y": 17.198,
              "z": 1.405
            },
            "rightCorner": {
              "x": 11.596,
              "y": 17.2,
              "z": 1.405
            },
            "gtin": "4032549035379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d97a",
            "leftCorner": {
              "x": 11.596,
              "y": 17.198,
              "z": 1.405
            },
            "rightCorner": {
              "x": 11.519,
              "y": 17.204,
              "z": 1.405
            },
            "gtin": "4260176723684",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a78",
    "rightNeighborShelfId": "34a7a"
  },
  {
    "id": "34a7a",
    "name": "34a7a",
    "x": 11.518,
    "y": 17.44,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029806
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 24
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463c1",
        "height": 0.17507,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e6aa",
            "leftCorner": {
              "x": 11.524,
              "y": 17.384,
              "z": 0.143
            },
            "rightCorner": {
              "x": 11.396,
              "y": 17.391,
              "z": 0.143
            },
            "gtin": "8710609016310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6a6",
            "leftCorner": {
              "x": 11.517,
              "y": 17.423,
              "z": 0.143
            },
            "rightCorner": {
              "x": 11.304,
              "y": 17.436,
              "z": 0.143
            },
            "gtin": "8710609016310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6ab",
            "leftCorner": {
              "x": 11.396,
              "y": 17.391,
              "z": 0.143
            },
            "rightCorner": {
              "x": 11.268,
              "y": 17.398,
              "z": 0.143
            },
            "gtin": "8710609016310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6a7",
            "leftCorner": {
              "x": 11.304,
              "y": 17.436,
              "z": 0.143
            },
            "rightCorner": {
              "x": 11.091,
              "y": 17.449,
              "z": 0.143
            },
            "gtin": "8710609016310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6ac",
            "leftCorner": {
              "x": 11.268,
              "y": 17.4,
              "z": 0.143
            },
            "rightCorner": {
              "x": 11.018,
              "y": 17.414,
              "z": 0.143
            },
            "gtin": "4337185461194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6a8",
            "leftCorner": {
              "x": 11.091,
              "y": 17.449,
              "z": 0.143
            },
            "rightCorner": {
              "x": 10.878,
              "y": 17.462,
              "z": 0.143
            },
            "gtin": "8710609016310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6ad",
            "leftCorner": {
              "x": 11.018,
              "y": 17.414,
              "z": 0.143
            },
            "rightCorner": {
              "x": 10.767,
              "y": 17.429,
              "z": 0.143
            },
            "gtin": "4337185461194",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463c0",
        "height": 0.79797,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e68d",
            "leftCorner": {
              "x": 11.512,
              "y": 17.339,
              "z": 0.653
            },
            "rightCorner": {
              "x": 11.296,
              "y": 17.352,
              "z": 0.653
            },
            "gtin": "8410066140282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e68e",
            "leftCorner": {
              "x": 11.296,
              "y": 17.352,
              "z": 0.653
            },
            "rightCorner": {
              "x": 11.08,
              "y": 17.365,
              "z": 0.653
            },
            "gtin": "8410066140282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e691",
            "leftCorner": {
              "x": 11.078,
              "y": 17.322,
              "z": 0.653
            },
            "rightCorner": {
              "x": 10.97,
              "y": 17.328,
              "z": 0.653
            },
            "gtin": "8410066140312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e692",
            "leftCorner": {
              "x": 10.969,
              "y": 17.323,
              "z": 0.653
            },
            "rightCorner": {
              "x": 10.817,
              "y": 17.332,
              "z": 0.653
            },
            "gtin": "8032793343325",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463be",
        "height": 1.3166,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d9df",
            "leftCorner": {
              "x": 11.538,
              "y": 17.209,
              "z": 1.077
            },
            "rightCorner": {
              "x": 11.227,
              "y": 17.228,
              "z": 1.077
            },
            "gtin": "4023900544685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9e0",
            "leftCorner": {
              "x": 11.228,
              "y": 17.238,
              "z": 1.077
            },
            "rightCorner": {
              "x": 11.139,
              "y": 17.243,
              "z": 1.077
            },
            "gtin": "8001440120039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9e1",
            "leftCorner": {
              "x": 11.139,
              "y": 17.243,
              "z": 1.077
            },
            "rightCorner": {
              "x": 11.051,
              "y": 17.248,
              "z": 1.077
            },
            "gtin": "8001440120039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9e2",
            "leftCorner": {
              "x": 11.051,
              "y": 17.248,
              "z": 1.077
            },
            "rightCorner": {
              "x": 10.963,
              "y": 17.254,
              "z": 1.077
            },
            "gtin": "8001440120039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9e3",
            "leftCorner": {
              "x": 10.963,
              "y": 17.254,
              "z": 1.077
            },
            "rightCorner": {
              "x": 10.875,
              "y": 17.259,
              "z": 1.077
            },
            "gtin": "8001440120039",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463bf",
        "height": 1.7086,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d97b",
            "leftCorner": {
              "x": 11.521,
              "y": 17.217,
              "z": 1.398
            },
            "rightCorner": {
              "x": 11.454,
              "y": 17.221,
              "z": 1.398
            },
            "gtin": "4023900544784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d97c",
            "leftCorner": {
              "x": 11.454,
              "y": 17.221,
              "z": 1.398
            },
            "rightCorner": {
              "x": 11.386,
              "y": 17.225,
              "z": 1.398
            },
            "gtin": "4023900544784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d97d",
            "leftCorner": {
              "x": 11.385,
              "y": 17.223,
              "z": 1.398
            },
            "rightCorner": {
              "x": 11.277,
              "y": 17.229,
              "z": 1.398
            },
            "gtin": "4023900544661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d97e",
            "leftCorner": {
              "x": 11.277,
              "y": 17.229,
              "z": 1.398
            },
            "rightCorner": {
              "x": 11.168,
              "y": 17.236,
              "z": 1.398
            },
            "gtin": "4023900544661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d97f",
            "leftCorner": {
              "x": 11.168,
              "y": 17.236,
              "z": 1.398
            },
            "rightCorner": {
              "x": 11.059,
              "y": 17.243,
              "z": 1.398
            },
            "gtin": "4023900544661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d980",
            "leftCorner": {
              "x": 11.058,
              "y": 17.232,
              "z": 1.398
            },
            "rightCorner": {
              "x": 11.003,
              "y": 17.236,
              "z": 1.398
            },
            "gtin": "4023900531395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d981",
            "leftCorner": {
              "x": 11.003,
              "y": 17.236,
              "z": 1.398
            },
            "rightCorner": {
              "x": 10.947,
              "y": 17.239,
              "z": 1.398
            },
            "gtin": "4023900531395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d982",
            "leftCorner": {
              "x": 10.947,
              "y": 17.238,
              "z": 1.398
            },
            "rightCorner": {
              "x": 10.781,
              "y": 17.248,
              "z": 1.398
            },
            "gtin": "4023900532033",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a79",
    "rightNeighborShelfId": "34a7b"
  },
  {
    "id": "34a7b",
    "name": "34a7b",
    "x": 10.869,
    "y": 17.479,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029806
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546393",
        "height": 0.17728,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e6ae",
            "leftCorner": {
              "x": 10.767,
              "y": 17.425,
              "z": 0.145
            },
            "rightCorner": {
              "x": 10.599,
              "y": 17.435,
              "z": 0.145
            },
            "gtin": "8710609351411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6af",
            "leftCorner": {
              "x": 10.599,
              "y": 17.435,
              "z": 0.145
            },
            "rightCorner": {
              "x": 10.43,
              "y": 17.446,
              "z": 0.145
            },
            "gtin": "8710609351411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6b0",
            "leftCorner": {
              "x": 10.432,
              "y": 17.467,
              "z": 0.145
            },
            "rightCorner": {
              "x": 10.344,
              "y": 17.472,
              "z": 0.145
            },
            "gtin": "4300175162173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6b1",
            "leftCorner": {
              "x": 10.344,
              "y": 17.472,
              "z": 0.145
            },
            "rightCorner": {
              "x": 10.256,
              "y": 17.476,
              "z": 0.145
            },
            "gtin": "4300175162173",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546391",
        "height": 0.80341,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e693",
            "leftCorner": {
              "x": 10.817,
              "y": 17.338,
              "z": 0.657
            },
            "rightCorner": {
              "x": 10.406,
              "y": 17.363,
              "z": 0.657
            },
            "gtin": "8032793343264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e694",
            "leftCorner": {
              "x": 10.405,
              "y": 17.356,
              "z": 0.657
            },
            "rightCorner": {
              "x": 10.324,
              "y": 17.361,
              "z": 0.657
            },
            "gtin": "8410313000161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e695",
            "leftCorner": {
              "x": 10.324,
              "y": 17.361,
              "z": 0.657
            },
            "rightCorner": {
              "x": 10.243,
              "y": 17.366,
              "z": 0.657
            },
            "gtin": "8410313000161",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546390",
        "height": 1.3141,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d9e4",
            "leftCorner": {
              "x": 10.873,
              "y": 17.247,
              "z": 1.075
            },
            "rightCorner": {
              "x": 10.807,
              "y": 17.25,
              "z": 1.075
            },
            "gtin": "4008100169319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9e5",
            "leftCorner": {
              "x": 10.807,
              "y": 17.25,
              "z": 1.075
            },
            "rightCorner": {
              "x": 10.74,
              "y": 17.254,
              "z": 1.075
            },
            "gtin": "4008100169319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9e6",
            "leftCorner": {
              "x": 10.74,
              "y": 17.248,
              "z": 1.075
            },
            "rightCorner": {
              "x": 10.534,
              "y": 17.26,
              "z": 1.075
            },
            "gtin": "4008100169302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9e7",
            "leftCorner": {
              "x": 10.534,
              "y": 17.262,
              "z": 1.075
            },
            "rightCorner": {
              "x": 10.386,
              "y": 17.272,
              "z": 1.075
            },
            "gtin": "8001440122415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9e8",
            "leftCorner": {
              "x": 10.386,
              "y": 17.272,
              "z": 1.075
            },
            "rightCorner": {
              "x": 10.281,
              "y": 17.278,
              "z": 1.075
            },
            "gtin": "8005110000775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9e9",
            "leftCorner": {
              "x": 10.281,
              "y": 17.278,
              "z": 1.075
            },
            "rightCorner": {
              "x": 10.176,
              "y": 17.284,
              "z": 1.075
            },
            "gtin": "8005110000775",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546392",
        "height": 1.7081,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d983",
            "leftCorner": {
              "x": 10.781,
              "y": 17.253,
              "z": 1.398
            },
            "rightCorner": {
              "x": 10.615,
              "y": 17.263,
              "z": 1.398
            },
            "gtin": "4008100169401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d984",
            "leftCorner": {
              "x": 10.613,
              "y": 17.236,
              "z": 1.398
            },
            "rightCorner": {
              "x": 10.467,
              "y": 17.246,
              "z": 1.398
            },
            "gtin": "4008100169395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d985",
            "leftCorner": {
              "x": 10.468,
              "y": 17.266,
              "z": 1.398
            },
            "rightCorner": {
              "x": 10.387,
              "y": 17.271,
              "z": 1.398
            },
            "gtin": "4045178011898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d986",
            "leftCorner": {
              "x": 10.387,
              "y": 17.271,
              "z": 1.398
            },
            "rightCorner": {
              "x": 10.305,
              "y": 17.276,
              "z": 1.398
            },
            "gtin": "4045178011898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d987",
            "leftCorner": {
              "x": 10.305,
              "y": 17.267,
              "z": 1.398
            },
            "rightCorner": {
              "x": 10.144,
              "y": 17.276,
              "z": 1.398
            },
            "gtin": "8001440121302",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a7a",
    "rightNeighborShelfId": "34a7c"
  },
  {
    "id": "34a7c",
    "name": "34a7c",
    "x": 10.22,
    "y": 17.517,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029806
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463c5",
        "height": 0.17853,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e6b2",
            "leftCorner": {
              "x": 10.255,
              "y": 17.46,
              "z": 0.146
            },
            "rightCorner": {
              "x": 10.135,
              "y": 17.467,
              "z": 0.146
            },
            "gtin": "4063367493447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6b3",
            "leftCorner": {
              "x": 10.135,
              "y": 17.467,
              "z": 0.146
            },
            "rightCorner": {
              "x": 10.014,
              "y": 17.474,
              "z": 0.146
            },
            "gtin": "4063367493447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6b4",
            "leftCorner": {
              "x": 10.014,
              "y": 17.474,
              "z": 0.146
            },
            "rightCorner": {
              "x": 9.894,
              "y": 17.481,
              "z": 0.146
            },
            "gtin": "4063367493447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6b5",
            "leftCorner": {
              "x": 9.894,
              "y": 17.483,
              "z": 0.146
            },
            "rightCorner": {
              "x": 9.343,
              "y": 17.516,
              "z": 0.146
            },
            "gtin": "4337185461026",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463c3",
        "height": 0.80783,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e696",
            "leftCorner": {
              "x": 10.243,
              "y": 17.362,
              "z": 0.661
            },
            "rightCorner": {
              "x": 10.021,
              "y": 17.375,
              "z": 0.661
            },
            "gtin": "8400000010085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e697",
            "leftCorner": {
              "x": 10.021,
              "y": 17.377,
              "z": 0.661
            },
            "rightCorner": {
              "x": 9.915,
              "y": 17.383,
              "z": 0.661
            },
            "gtin": "4337185022999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e698",
            "leftCorner": {
              "x": 9.915,
              "y": 17.38,
              "z": 0.661
            },
            "rightCorner": {
              "x": 9.769,
              "y": 17.389,
              "z": 0.661
            },
            "gtin": "4063367413414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e699",
            "leftCorner": {
              "x": 9.77,
              "y": 17.399,
              "z": 0.661
            },
            "rightCorner": {
              "x": 9.514,
              "y": 17.414,
              "z": 0.661
            },
            "gtin": "4063367413407",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463c4",
        "height": 1.3161,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d9ea",
            "leftCorner": {
              "x": 10.175,
              "y": 17.271,
              "z": 1.077
            },
            "rightCorner": {
              "x": 10.017,
              "y": 17.281,
              "z": 1.077
            },
            "gtin": "8050327210578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9eb",
            "leftCorner": {
              "x": 10.017,
              "y": 17.283,
              "z": 1.077
            },
            "rightCorner": {
              "x": 9.857,
              "y": 17.292,
              "z": 1.077
            },
            "gtin": "8005110413520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9ec",
            "leftCorner": {
              "x": 9.857,
              "y": 17.291,
              "z": 1.077
            },
            "rightCorner": {
              "x": 9.72,
              "y": 17.299,
              "z": 1.077
            },
            "gtin": "8005110551215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9ed",
            "leftCorner": {
              "x": 9.72,
              "y": 17.31,
              "z": 1.077
            },
            "rightCorner": {
              "x": 9.578,
              "y": 17.318,
              "z": 1.077
            },
            "gtin": "8005110060007",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463c2",
        "height": 1.7113,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d988",
            "leftCorner": {
              "x": 10.144,
              "y": 17.274,
              "z": 1.4
            },
            "rightCorner": {
              "x": 10.019,
              "y": 17.281,
              "z": 1.4
            },
            "gtin": "8001440120244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d989",
            "leftCorner": {
              "x": 10.019,
              "y": 17.281,
              "z": 1.4
            },
            "rightCorner": {
              "x": 9.894,
              "y": 17.288,
              "z": 1.4
            },
            "gtin": "8001440120244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d98a",
            "leftCorner": {
              "x": 9.894,
              "y": 17.289,
              "z": 1.4
            },
            "rightCorner": {
              "x": 9.819,
              "y": 17.294,
              "z": 1.4
            },
            "gtin": "4045178012338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d98b",
            "leftCorner": {
              "x": 9.819,
              "y": 17.294,
              "z": 1.4
            },
            "rightCorner": {
              "x": 9.745,
              "y": 17.299,
              "z": 1.4
            },
            "gtin": "4045178012338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d98c",
            "leftCorner": {
              "x": 9.745,
              "y": 17.302,
              "z": 1.4
            },
            "rightCorner": {
              "x": 9.677,
              "y": 17.306,
              "z": 1.4
            },
            "gtin": "4045178004302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d98d",
            "leftCorner": {
              "x": 9.677,
              "y": 17.306,
              "z": 1.4
            },
            "rightCorner": {
              "x": 9.608,
              "y": 17.31,
              "z": 1.4
            },
            "gtin": "4045178004302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d98e",
            "leftCorner": {
              "x": 9.609,
              "y": 17.328,
              "z": 1.4
            },
            "rightCorner": {
              "x": 9.52,
              "y": 17.333,
              "z": 1.4
            },
            "gtin": "4045178011898",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a7b",
    "rightNeighborShelfId": "34a7d"
  },
  {
    "id": "34a7d",
    "name": "34a7d",
    "x": 9.571,
    "y": 17.556,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029806
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 23
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463ce",
        "height": 0.17518,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e6b6",
            "leftCorner": {
              "x": 9.344,
              "y": 17.528,
              "z": 0.143
            },
            "rightCorner": {
              "x": 9.252,
              "y": 17.533,
              "z": 0.143
            },
            "gtin": "4063367493416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6b7",
            "leftCorner": {
              "x": 9.252,
              "y": 17.533,
              "z": 0.143
            },
            "rightCorner": {
              "x": 9.16,
              "y": 17.538,
              "z": 0.143
            },
            "gtin": "4063367493416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6b8",
            "leftCorner": {
              "x": 9.16,
              "y": 17.538,
              "z": 0.143
            },
            "rightCorner": {
              "x": 9.068,
              "y": 17.544,
              "z": 0.143
            },
            "gtin": "4063367493416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6b9",
            "leftCorner": {
              "x": 9.067,
              "y": 17.523,
              "z": 0.143
            },
            "rightCorner": {
              "x": 8.874,
              "y": 17.534,
              "z": 0.143
            },
            "gtin": "4337185460999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6ba",
            "leftCorner": {
              "x": 8.874,
              "y": 17.534,
              "z": 0.143
            },
            "rightCorner": {
              "x": 8.681,
              "y": 17.545,
              "z": 0.143
            },
            "gtin": "4337185460999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6bb",
            "leftCorner": {
              "x": 8.681,
              "y": 17.545,
              "z": 0.143
            },
            "rightCorner": {
              "x": 8.489,
              "y": 17.557,
              "z": 0.143
            },
            "gtin": "4337185460999",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463cd",
        "height": 0.80986,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e69a",
            "leftCorner": {
              "x": 9.514,
              "y": 17.418,
              "z": 0.663
            },
            "rightCorner": {
              "x": 9.423,
              "y": 17.423,
              "z": 0.663
            },
            "gtin": "4337185463464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e69b",
            "leftCorner": {
              "x": 9.423,
              "y": 17.423,
              "z": 0.663
            },
            "rightCorner": {
              "x": 9.332,
              "y": 17.429,
              "z": 0.663
            },
            "gtin": "4337185463464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e69c",
            "leftCorner": {
              "x": 9.332,
              "y": 17.426,
              "z": 0.663
            },
            "rightCorner": {
              "x": 9.092,
              "y": 17.441,
              "z": 0.663
            },
            "gtin": "4337185461088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e69d",
            "leftCorner": {
              "x": 9.092,
              "y": 17.431,
              "z": 0.663
            },
            "rightCorner": {
              "x": 9.007,
              "y": 17.436,
              "z": 0.663
            },
            "gtin": "8050327210615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e69e",
            "leftCorner": {
              "x": 9.007,
              "y": 17.436,
              "z": 0.663
            },
            "rightCorner": {
              "x": 8.922,
              "y": 17.441,
              "z": 0.663
            },
            "gtin": "8050327210615",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463cc",
        "height": 1.3158,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d9ee",
            "leftCorner": {
              "x": 9.578,
              "y": 17.322,
              "z": 1.077
            },
            "rightCorner": {
              "x": 9.424,
              "y": 17.331,
              "z": 1.077
            },
            "gtin": "80042556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9ef",
            "leftCorner": {
              "x": 9.424,
              "y": 17.331,
              "z": 1.077
            },
            "rightCorner": {
              "x": 9.358,
              "y": 17.335,
              "z": 1.077
            },
            "gtin": "8005110550508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9f0",
            "leftCorner": {
              "x": 9.358,
              "y": 17.335,
              "z": 1.077
            },
            "rightCorner": {
              "x": 9.291,
              "y": 17.339,
              "z": 1.077
            },
            "gtin": "8005110550508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9f1",
            "leftCorner": {
              "x": 9.291,
              "y": 17.339,
              "z": 1.077
            },
            "rightCorner": {
              "x": 9.208,
              "y": 17.344,
              "z": 1.077
            },
            "gtin": "8005110000454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9f2",
            "leftCorner": {
              "x": 9.208,
              "y": 17.344,
              "z": 1.077
            },
            "rightCorner": {
              "x": 9.125,
              "y": 17.35,
              "z": 1.077
            },
            "gtin": "8005110000454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9f3",
            "leftCorner": {
              "x": 9.125,
              "y": 17.342,
              "z": 1.077
            },
            "rightCorner": {
              "x": 8.946,
              "y": 17.353,
              "z": 1.077
            },
            "gtin": "8005110170423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9f4",
            "leftCorner": {
              "x": 8.945,
              "y": 17.344,
              "z": 1.077
            },
            "rightCorner": {
              "x": 8.86,
              "y": 17.349,
              "z": 1.077
            },
            "gtin": "4008100168473",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463cb",
        "height": 1.7162,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d98f",
            "leftCorner": {
              "x": 9.519,
              "y": 17.32,
              "z": 1.404
            },
            "rightCorner": {
              "x": 9.425,
              "y": 17.325,
              "z": 1.404
            },
            "gtin": "80042563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d990",
            "leftCorner": {
              "x": 9.425,
              "y": 17.325,
              "z": 1.404
            },
            "rightCorner": {
              "x": 9.331,
              "y": 17.33,
              "z": 1.404
            },
            "gtin": "80042563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d991",
            "leftCorner": {
              "x": 9.331,
              "y": 17.327,
              "z": 1.404
            },
            "rightCorner": {
              "x": 9.201,
              "y": 17.336,
              "z": 1.404
            },
            "gtin": "8000320996863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d992",
            "leftCorner": {
              "x": 9.201,
              "y": 17.343,
              "z": 1.404
            },
            "rightCorner": {
              "x": 9.079,
              "y": 17.35,
              "z": 1.404
            },
            "gtin": "4008100169326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d993",
            "leftCorner": {
              "x": 9.079,
              "y": 17.345,
              "z": 1.404
            },
            "rightCorner": {
              "x": 8.889,
              "y": 17.356,
              "z": 1.404
            },
            "gtin": "8005110004742",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a7c",
    "rightNeighborShelfId": "34a7e"
  },
  {
    "id": "34a7e",
    "name": "34a7e",
    "x": 8.922,
    "y": 17.595,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029806
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 17
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463d2",
        "height": 0.18252,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e6bc",
            "leftCorner": {
              "x": 8.49,
              "y": 17.581,
              "z": 0.149
            },
            "rightCorner": {
              "x": 8.403,
              "y": 17.587,
              "z": 0.149
            },
            "gtin": "8008074000096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6bd",
            "leftCorner": {
              "x": 8.402,
              "y": 17.575,
              "z": 0.149
            },
            "rightCorner": {
              "x": 8.227,
              "y": 17.585,
              "z": 0.149
            },
            "gtin": "4063367305344",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463cf",
        "height": 0.80926,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e69f",
            "leftCorner": {
              "x": 8.922,
              "y": 17.442,
              "z": 0.662
            },
            "rightCorner": {
              "x": 8.597,
              "y": 17.461,
              "z": 0.662
            },
            "gtin": "4063367388422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6a0",
            "leftCorner": {
              "x": 8.598,
              "y": 17.472,
              "z": 0.662
            },
            "rightCorner": {
              "x": 8.411,
              "y": 17.484,
              "z": 0.662
            },
            "gtin": "4063367409806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6a1",
            "leftCorner": {
              "x": 8.412,
              "y": 17.49,
              "z": 0.662
            },
            "rightCorner": {
              "x": 8.291,
              "y": 17.496,
              "z": 0.662
            },
            "gtin": "4063367412356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6a2",
            "leftCorner": {
              "x": 8.291,
              "y": 17.496,
              "z": 0.662
            },
            "rightCorner": {
              "x": 8.171,
              "y": 17.504,
              "z": 0.662
            },
            "gtin": "4063367412356",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463d0",
        "height": 1.3144,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d9f5",
            "leftCorner": {
              "x": 8.86,
              "y": 17.352,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.776,
              "y": 17.358,
              "z": 1.075
            },
            "gtin": "4008100168237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9f6",
            "leftCorner": {
              "x": 8.776,
              "y": 17.358,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.691,
              "y": 17.362,
              "z": 1.075
            },
            "gtin": "4008100168237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9f7",
            "leftCorner": {
              "x": 8.691,
              "y": 17.366,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.494,
              "y": 17.379,
              "z": 1.075
            },
            "gtin": "4008100168466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9f8",
            "leftCorner": {
              "x": 8.494,
              "y": 17.389,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.328,
              "y": 17.398,
              "z": 1.075
            },
            "gtin": "4008100169234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9f9",
            "leftCorner": {
              "x": 8.328,
              "y": 17.391,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.236,
              "y": 17.398,
              "z": 1.075
            },
            "gtin": "4008100168046",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463d1",
        "height": 1.7133,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d994",
            "leftCorner": {
              "x": 8.89,
              "y": 17.367,
              "z": 1.402
            },
            "rightCorner": {
              "x": 8.789,
              "y": 17.373,
              "z": 1.402
            },
            "gtin": "8001440130724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d995",
            "leftCorner": {
              "x": 8.788,
              "y": 17.36,
              "z": 1.402
            },
            "rightCorner": {
              "x": 8.662,
              "y": 17.368,
              "z": 1.402
            },
            "gtin": "8005110140013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d996",
            "leftCorner": {
              "x": 8.662,
              "y": 17.368,
              "z": 1.402
            },
            "rightCorner": {
              "x": 8.536,
              "y": 17.376,
              "z": 1.402
            },
            "gtin": "8005110140013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d997",
            "leftCorner": {
              "x": 8.536,
              "y": 17.377,
              "z": 1.402
            },
            "rightCorner": {
              "x": 8.427,
              "y": 17.384,
              "z": 1.402
            },
            "gtin": "4008100168695",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d998",
            "leftCorner": {
              "x": 8.427,
              "y": 17.384,
              "z": 1.402
            },
            "rightCorner": {
              "x": 8.319,
              "y": 17.39,
              "z": 1.402
            },
            "gtin": "4008100168695",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d999",
            "leftCorner": {
              "x": 8.319,
              "y": 17.391,
              "z": 1.402
            },
            "rightCorner": {
              "x": 8.255,
              "y": 17.395,
              "z": 1.402
            },
            "gtin": "40081076",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a7d",
    "rightNeighborShelfId": "34a7f"
  },
  {
    "id": "34a7f",
    "name": "34a7f",
    "x": 8.273,
    "y": 17.633,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029806
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 20
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463d5",
        "height": 1.3114,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d9fb",
            "leftCorner": {
              "x": 8.1,
              "y": 17.389,
              "z": 1.073
            },
            "rightCorner": {
              "x": 7.945,
              "y": 17.399,
              "z": 1.073
            },
            "gtin": "4008100168220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9fc",
            "leftCorner": {
              "x": 7.946,
              "y": 17.418,
              "z": 1.073
            },
            "rightCorner": {
              "x": 7.656,
              "y": 17.436,
              "z": 1.073
            },
            "gtin": "40081236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9a1",
            "leftCorner": {
              "x": 7.656,
              "y": 17.438,
              "z": 1.073
            },
            "rightCorner": {
              "x": 7.61,
              "y": 17.441,
              "z": 1.073
            },
            "gtin": "4008100164635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9fa",
            "leftCorner": {
              "x": 8.235,
              "y": 17.391,
              "z": 1.073
            },
            "rightCorner": {
              "x": 8.101,
              "y": 17.399,
              "z": 1.073
            },
            "gtin": "4008100168244",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463d3",
        "height": 1.7129,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d99a",
            "leftCorner": {
              "x": 8.255,
              "y": 17.391,
              "z": 1.401
            },
            "rightCorner": {
              "x": 8.185,
              "y": 17.395,
              "z": 1.401
            },
            "gtin": "4008100168763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d99b",
            "leftCorner": {
              "x": 8.185,
              "y": 17.395,
              "z": 1.401
            },
            "rightCorner": {
              "x": 8.115,
              "y": 17.399,
              "z": 1.401
            },
            "gtin": "4008100168763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d99c",
            "leftCorner": {
              "x": 8.115,
              "y": 17.388,
              "z": 1.401
            },
            "rightCorner": {
              "x": 7.865,
              "y": 17.402,
              "z": 1.401
            },
            "gtin": "4008100168039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d99d",
            "leftCorner": {
              "x": 7.866,
              "y": 17.407,
              "z": 1.401
            },
            "rightCorner": {
              "x": 7.792,
              "y": 17.412,
              "z": 1.401
            },
            "gtin": "4008100168046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d99e",
            "leftCorner": {
              "x": 7.792,
              "y": 17.412,
              "z": 1.401
            },
            "rightCorner": {
              "x": 7.719,
              "y": 17.416,
              "z": 1.401
            },
            "gtin": "4008100168046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d92c",
            "leftCorner": {
              "x": 7.72,
              "y": 17.436,
              "z": 1.401
            },
            "rightCorner": {
              "x": 7.665,
              "y": 17.439,
              "z": 1.401
            },
            "gtin": "4008100169371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d92d",
            "leftCorner": {
              "x": 7.665,
              "y": 17.439,
              "z": 1.401
            },
            "rightCorner": {
              "x": 7.61,
              "y": 17.442,
              "z": 1.401
            },
            "gtin": "4008100169371",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463d6",
        "height": 0.17847,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e6be",
            "leftCorner": {
              "x": 8.226,
              "y": 17.577,
              "z": 0.146
            },
            "rightCorner": {
              "x": 8.111,
              "y": 17.583,
              "z": 0.146
            },
            "gtin": "4063367305405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6bf",
            "leftCorner": {
              "x": 8.111,
              "y": 17.583,
              "z": 0.146
            },
            "rightCorner": {
              "x": 7.996,
              "y": 17.59,
              "z": 0.146
            },
            "gtin": "4063367305405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6c0",
            "leftCorner": {
              "x": 7.995,
              "y": 17.579,
              "z": 0.146
            },
            "rightCorner": {
              "x": 7.741,
              "y": 17.594,
              "z": 0.146
            },
            "gtin": "4063367305511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6a9",
            "leftCorner": {
              "x": 7.743,
              "y": 17.613,
              "z": 0.146
            },
            "rightCorner": {
              "x": 7.621,
              "y": 17.62,
              "z": 0.146
            },
            "gtin": "4063367305672",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463d4",
        "height": 0.80331,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e6a3",
            "leftCorner": {
              "x": 8.17,
              "y": 17.481,
              "z": 0.657
            },
            "rightCorner": {
              "x": 7.976,
              "y": 17.492,
              "z": 0.657
            },
            "gtin": "4063367183362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6a4",
            "leftCorner": {
              "x": 7.976,
              "y": 17.484,
              "z": 0.657
            },
            "rightCorner": {
              "x": 7.855,
              "y": 17.491,
              "z": 0.657
            },
            "gtin": "4063367183393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6a5",
            "leftCorner": {
              "x": 7.855,
              "y": 17.491,
              "z": 0.657
            },
            "rightCorner": {
              "x": 7.733,
              "y": 17.498,
              "z": 0.657
            },
            "gtin": "4063367183393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e68f",
            "leftCorner": {
              "x": 7.734,
              "y": 17.518,
              "z": 0.657
            },
            "rightCorner": {
              "x": 7.675,
              "y": 17.522,
              "z": 0.657
            },
            "gtin": "4063367183386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e690",
            "leftCorner": {
              "x": 7.675,
              "y": 17.522,
              "z": 0.657
            },
            "rightCorner": {
              "x": 7.615,
              "y": 17.525,
              "z": 0.657
            },
            "gtin": "4063367183386",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a7e"
  },
  {
    "id": "34a80",
    "name": "34a80",
    "x": 8.211,
    "y": 19.55,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.038562,
      "w": 0.99926
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 8
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546777",
        "height": 0.16635,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a21016",
            "leftCorner": {
              "x": 8.278,
              "y": 19.6,
              "z": 0.136
            },
            "rightCorner": {
              "x": 8.863,
              "y": 19.555,
              "z": 0.136
            },
            "gtin": "4003586100313",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546775",
        "height": 1.1013,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a2100a",
            "leftCorner": {
              "x": 8.271,
              "y": 19.683,
              "z": 0.901
            },
            "rightCorner": {
              "x": 8.515,
              "y": 19.664,
              "z": 0.901
            },
            "gtin": "4003586105714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2100b",
            "leftCorner": {
              "x": 8.515,
              "y": 19.663,
              "z": 0.901
            },
            "rightCorner": {
              "x": 8.713,
              "y": 19.647,
              "z": 0.901
            },
            "gtin": "4003586000347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2100c",
            "leftCorner": {
              "x": 8.713,
              "y": 19.647,
              "z": 0.901
            },
            "rightCorner": {
              "x": 8.91,
              "y": 19.632,
              "z": 0.901
            },
            "gtin": "4003586000347",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546776",
        "height": 1.6545,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a2100f",
            "leftCorner": {
              "x": 8.305,
              "y": 19.675,
              "z": 1.354
            },
            "rightCorner": {
              "x": 8.447,
              "y": 19.663,
              "z": 1.354
            },
            "gtin": "4003586102256",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21010",
            "leftCorner": {
              "x": 8.447,
              "y": 19.663,
              "z": 1.354
            },
            "rightCorner": {
              "x": 8.59,
              "y": 19.652,
              "z": 1.354
            },
            "gtin": "4003586102256",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21011",
            "leftCorner": {
              "x": 8.59,
              "y": 19.652,
              "z": 1.354
            },
            "rightCorner": {
              "x": 8.732,
              "y": 19.641,
              "z": 1.354
            },
            "gtin": "4003586102256",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21012",
            "leftCorner": {
              "x": 8.732,
              "y": 19.641,
              "z": 1.354
            },
            "rightCorner": {
              "x": 8.875,
              "y": 19.63,
              "z": 1.354
            },
            "gtin": "4003586102256",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "8d2f4",
    "rightNeighborShelfId": "34a81"
  },
  {
    "id": "34a81",
    "name": "34a81",
    "x": 8.859,
    "y": 19.5,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.038562,
      "w": 0.99926
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 6
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54677f",
        "height": 1.1063,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a21007",
            "leftCorner": {
              "x": 8.91,
              "y": 19.626,
              "z": 0.905
            },
            "rightCorner": {
              "x": 9.517,
              "y": 19.58,
              "z": 0.905
            },
            "gtin": "4003586000330",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54677e",
        "height": 1.6555,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a21013",
            "leftCorner": {
              "x": 8.874,
              "y": 19.623,
              "z": 1.355
            },
            "rightCorner": {
              "x": 8.98,
              "y": 19.616,
              "z": 1.355
            },
            "gtin": "4003586103185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21014",
            "leftCorner": {
              "x": 8.98,
              "y": 19.616,
              "z": 1.355
            },
            "rightCorner": {
              "x": 9.086,
              "y": 19.608,
              "z": 1.355
            },
            "gtin": "4003586103185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21015",
            "leftCorner": {
              "x": 9.086,
              "y": 19.608,
              "z": 1.355
            },
            "rightCorner": {
              "x": 9.192,
              "y": 19.6,
              "z": 1.355
            },
            "gtin": "4003586103185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2100d",
            "leftCorner": {
              "x": 9.193,
              "y": 19.609,
              "z": 1.355
            },
            "rightCorner": {
              "x": 9.355,
              "y": 19.596,
              "z": 1.355
            },
            "gtin": "4003586003324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2100e",
            "leftCorner": {
              "x": 9.355,
              "y": 19.596,
              "z": 1.355
            },
            "rightCorner": {
              "x": 9.517,
              "y": 19.584,
              "z": 1.355
            },
            "gtin": "4003586003324",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a80",
    "rightNeighborShelfId": "509ec"
  },
  {
    "id": "34a82",
    "name": "34a82",
    "x": 11.35,
    "y": 19.311,
    "width": 0.67,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03476,
      "w": 0.9994
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 9
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546786",
        "height": 0.16608,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e074",
            "leftCorner": {
              "x": 11.401,
              "y": 19.355,
              "z": 0.136
            },
            "rightCorner": {
              "x": 11.672,
              "y": 19.336,
              "z": 0.136
            },
            "gtin": "4003586101723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e075",
            "leftCorner": {
              "x": 11.672,
              "y": 19.336,
              "z": 0.136
            },
            "rightCorner": {
              "x": 11.944,
              "y": 19.317,
              "z": 0.136
            },
            "gtin": "4003586101723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e076",
            "leftCorner": {
              "x": 11.944,
              "y": 19.315,
              "z": 0.136
            },
            "rightCorner": {
              "x": 12.207,
              "y": 19.297,
              "z": 0.136
            },
            "gtin": "4003586108456",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546785",
        "height": 0.84732,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e04c",
            "leftCorner": {
              "x": 11.378,
              "y": 19.451,
              "z": 0.693
            },
            "rightCorner": {
              "x": 11.622,
              "y": 19.434,
              "z": 0.693
            },
            "gtin": "4003586104137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e04d",
            "leftCorner": {
              "x": 11.622,
              "y": 19.431,
              "z": 0.693
            },
            "rightCorner": {
              "x": 11.787,
              "y": 19.42,
              "z": 0.693
            },
            "gtin": "4003586104038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e04e",
            "leftCorner": {
              "x": 11.787,
              "y": 19.42,
              "z": 0.693
            },
            "rightCorner": {
              "x": 11.953,
              "y": 19.408,
              "z": 0.693
            },
            "gtin": "4003586104038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e04f",
            "leftCorner": {
              "x": 11.953,
              "y": 19.414,
              "z": 0.693
            },
            "rightCorner": {
              "x": 12.13,
              "y": 19.402,
              "z": 0.693
            },
            "gtin": "4003586104120",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546784",
        "height": 1.3111,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a546787",
        "height": 1.6505,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e06b",
            "leftCorner": {
              "x": 11.886,
              "y": 19.411,
              "z": 1.35
            },
            "rightCorner": {
              "x": 12.033,
              "y": 19.401,
              "z": 1.35
            },
            "gtin": "4003586104885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e06c",
            "leftCorner": {
              "x": 12.033,
              "y": 19.401,
              "z": 1.35
            },
            "rightCorner": {
              "x": 12.18,
              "y": 19.391,
              "z": 1.35
            },
            "gtin": "4003586104885",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "509ec",
    "rightNeighborShelfId": "34a83"
  },
  {
    "id": "34a83",
    "name": "34a83",
    "x": 12.019,
    "y": 19.264,
    "width": 0.67,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03476,
      "w": 0.9994
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 9
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5462e7",
        "height": 0.16688,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e077",
            "leftCorner": {
              "x": 12.207,
              "y": 19.289,
              "z": 0.137
            },
            "rightCorner": {
              "x": 12.557,
              "y": 19.265,
              "z": 0.137
            },
            "gtin": "4003586101389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e078",
            "leftCorner": {
              "x": 12.558,
              "y": 19.282,
              "z": 0.137
            },
            "rightCorner": {
              "x": 12.713,
              "y": 19.271,
              "z": 0.137
            },
            "gtin": "4003586108807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e079",
            "leftCorner": {
              "x": 12.713,
              "y": 19.271,
              "z": 0.137
            },
            "rightCorner": {
              "x": 12.867,
              "y": 19.26,
              "z": 0.137
            },
            "gtin": "4003586108807",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462e5",
        "height": 0.84787,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e050",
            "leftCorner": {
              "x": 12.129,
              "y": 19.389,
              "z": 0.694
            },
            "rightCorner": {
              "x": 12.289,
              "y": 19.378,
              "z": 0.694
            },
            "gtin": "4003586103994",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462e4",
        "height": 1.3021,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e032",
            "leftCorner": {
              "x": 12.192,
              "y": 19.386,
              "z": 1.065
            },
            "rightCorner": {
              "x": 12.508,
              "y": 19.363,
              "z": 1.065
            },
            "gtin": "4003586101723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e033",
            "leftCorner": {
              "x": 12.508,
              "y": 19.363,
              "z": 1.065
            },
            "rightCorner": {
              "x": 12.826,
              "y": 19.342,
              "z": 1.065
            },
            "gtin": "4003586101723",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462e6",
        "height": 1.6539,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e06d",
            "leftCorner": {
              "x": 12.178,
              "y": 19.364,
              "z": 1.353
            },
            "rightCorner": {
              "x": 12.352,
              "y": 19.353,
              "z": 1.353
            },
            "gtin": "4062139009831",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e06e",
            "leftCorner": {
              "x": 12.352,
              "y": 19.353,
              "z": 1.353
            },
            "rightCorner": {
              "x": 12.526,
              "y": 19.34,
              "z": 1.353
            },
            "gtin": "4062139009831",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e06f",
            "leftCorner": {
              "x": 12.526,
              "y": 19.34,
              "z": 1.353
            },
            "rightCorner": {
              "x": 12.7,
              "y": 19.329,
              "z": 1.353
            },
            "gtin": "4062139009831",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a82",
    "rightNeighborShelfId": "34a84"
  },
  {
    "id": "34a84",
    "name": "34a84",
    "x": 12.687,
    "y": 19.218,
    "width": 0.67,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03476,
      "w": 0.9994
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 12
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54678a",
        "height": 0.16978,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e07a",
            "leftCorner": {
              "x": 12.868,
              "y": 19.255,
              "z": 0.139
            },
            "rightCorner": {
              "x": 13.022,
              "y": 19.245,
              "z": 0.139
            },
            "gtin": "4003586100399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e07b",
            "leftCorner": {
              "x": 13.022,
              "y": 19.245,
              "z": 0.139
            },
            "rightCorner": {
              "x": 13.174,
              "y": 19.234,
              "z": 0.139
            },
            "gtin": "4003586100399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e07c",
            "leftCorner": {
              "x": 13.174,
              "y": 19.229,
              "z": 0.139
            },
            "rightCorner": {
              "x": 13.284,
              "y": 19.221,
              "z": 0.139
            },
            "gtin": "4003586101082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e07d",
            "leftCorner": {
              "x": 13.284,
              "y": 19.221,
              "z": 0.139
            },
            "rightCorner": {
              "x": 13.395,
              "y": 19.214,
              "z": 0.139
            },
            "gtin": "4003586101082",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54678b",
        "height": 0.84816,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e051",
            "leftCorner": {
              "x": 13.225,
              "y": 19.328,
              "z": 0.694
            },
            "rightCorner": {
              "x": 13.394,
              "y": 19.316,
              "z": 0.694
            },
            "gtin": "4062139003136",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546789",
        "height": 1.3064,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e034",
            "leftCorner": {
              "x": 12.826,
              "y": 19.345,
              "z": 1.069
            },
            "rightCorner": {
              "x": 12.947,
              "y": 19.336,
              "z": 1.069
            },
            "gtin": "4003586105134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e035",
            "leftCorner": {
              "x": 12.947,
              "y": 19.336,
              "z": 1.069
            },
            "rightCorner": {
              "x": 13.067,
              "y": 19.328,
              "z": 1.069
            },
            "gtin": "4003586105134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e036",
            "leftCorner": {
              "x": 13.067,
              "y": 19.327,
              "z": 1.069
            },
            "rightCorner": {
              "x": 13.225,
              "y": 19.315,
              "z": 1.069
            },
            "gtin": "4003586105127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e037",
            "leftCorner": {
              "x": 13.225,
              "y": 19.315,
              "z": 1.069
            },
            "rightCorner": {
              "x": 13.383,
              "y": 19.305,
              "z": 1.069
            },
            "gtin": "4003586105127",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546788",
        "height": 1.6563,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e070",
            "leftCorner": {
              "x": 12.701,
              "y": 19.335,
              "z": 1.355
            },
            "rightCorner": {
              "x": 12.889,
              "y": 19.322,
              "z": 1.355
            },
            "gtin": "4062139009879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e071",
            "leftCorner": {
              "x": 12.889,
              "y": 19.33,
              "z": 1.355
            },
            "rightCorner": {
              "x": 13.136,
              "y": 19.313,
              "z": 1.355
            },
            "gtin": "4062139009855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e072",
            "leftCorner": {
              "x": 13.136,
              "y": 19.313,
              "z": 1.355
            },
            "rightCorner": {
              "x": 13.382,
              "y": 19.296,
              "z": 1.355
            },
            "gtin": "4062139009855",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a83",
    "rightNeighborShelfId": "34a85"
  },
  {
    "id": "34a85",
    "name": "34a85",
    "x": 13.355,
    "y": 19.171,
    "width": 0.67,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03476,
      "w": 0.9994
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 11
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54678f",
        "height": 0.16683,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e07e",
            "leftCorner": {
              "x": 13.395,
              "y": 19.223,
              "z": 0.136
            },
            "rightCorner": {
              "x": 13.584,
              "y": 19.211,
              "z": 0.136
            },
            "gtin": "4062139007677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e07f",
            "leftCorner": {
              "x": 13.584,
              "y": 19.211,
              "z": 0.136
            },
            "rightCorner": {
              "x": 13.775,
              "y": 19.197,
              "z": 0.136
            },
            "gtin": "4062139007677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e080",
            "leftCorner": {
              "x": 13.774,
              "y": 19.188,
              "z": 0.136
            },
            "rightCorner": {
              "x": 14.118,
              "y": 19.164,
              "z": 0.136
            },
            "gtin": "4062139005864",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54678c",
        "height": 0.84803,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e052",
            "leftCorner": {
              "x": 13.394,
              "y": 19.31,
              "z": 0.694
            },
            "rightCorner": {
              "x": 13.559,
              "y": 19.298,
              "z": 0.694
            },
            "gtin": "4062139005963",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e053",
            "leftCorner": {
              "x": 13.559,
              "y": 19.298,
              "z": 0.694
            },
            "rightCorner": {
              "x": 13.725,
              "y": 19.287,
              "z": 0.694
            },
            "gtin": "4062139005963",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e054",
            "leftCorner": {
              "x": 13.725,
              "y": 19.287,
              "z": 0.694
            },
            "rightCorner": {
              "x": 13.891,
              "y": 19.276,
              "z": 0.694
            },
            "gtin": "4062139005963",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e055",
            "leftCorner": {
              "x": 13.891,
              "y": 19.276,
              "z": 0.694
            },
            "rightCorner": {
              "x": 14.057,
              "y": 19.264,
              "z": 0.694
            },
            "gtin": "4062139005963",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54678e",
        "height": 1.3045,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e038",
            "leftCorner": {
              "x": 13.383,
              "y": 19.3,
              "z": 1.067
            },
            "rightCorner": {
              "x": 13.544,
              "y": 19.289,
              "z": 1.067
            },
            "gtin": "4260257870061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e039",
            "leftCorner": {
              "x": 13.544,
              "y": 19.289,
              "z": 1.067
            },
            "rightCorner": {
              "x": 13.707,
              "y": 19.277,
              "z": 1.067
            },
            "gtin": "4260257870061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e03a",
            "leftCorner": {
              "x": 13.707,
              "y": 19.285,
              "z": 1.067
            },
            "rightCorner": {
              "x": 13.886,
              "y": 19.273,
              "z": 1.067
            },
            "gtin": "4260257870092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e03b",
            "leftCorner": {
              "x": 13.886,
              "y": 19.273,
              "z": 1.067
            },
            "rightCorner": {
              "x": 14.064,
              "y": 19.261,
              "z": 1.067
            },
            "gtin": "4260257870092",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54678d",
        "height": 1.6558,
        "facings": []
      }
    ],
    "leftNeighborShelfId": "34a84",
    "rightNeighborShelfId": "34a86"
  },
  {
    "id": "34a86",
    "name": "34a86",
    "x": 14.024,
    "y": 19.125,
    "width": 0.67,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03476,
      "w": 0.9994
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 12
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546792",
        "height": 0.17026,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e081",
            "leftCorner": {
              "x": 14.119,
              "y": 19.167,
              "z": 0.139
            },
            "rightCorner": {
              "x": 14.686,
              "y": 19.127,
              "z": 0.139
            },
            "gtin": "4062139005888",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546791",
        "height": 0.84899,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e056",
            "leftCorner": {
              "x": 14.056,
              "y": 19.251,
              "z": 0.695
            },
            "rightCorner": {
              "x": 14.205,
              "y": 19.241,
              "z": 0.695
            },
            "gtin": "4062139003150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e057",
            "leftCorner": {
              "x": 14.205,
              "y": 19.241,
              "z": 0.695
            },
            "rightCorner": {
              "x": 14.353,
              "y": 19.23,
              "z": 0.695
            },
            "gtin": "4062139003150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e058",
            "leftCorner": {
              "x": 14.353,
              "y": 19.241,
              "z": 0.695
            },
            "rightCorner": {
              "x": 14.534,
              "y": 19.229,
              "z": 0.695
            },
            "gtin": "4062139006762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e059",
            "leftCorner": {
              "x": 14.534,
              "y": 19.229,
              "z": 0.695
            },
            "rightCorner": {
              "x": 14.713,
              "y": 19.217,
              "z": 0.695
            },
            "gtin": "4062139006762",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546793",
        "height": 1.3041,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e03c",
            "leftCorner": {
              "x": 14.063,
              "y": 19.254,
              "z": 1.067
            },
            "rightCorner": {
              "x": 14.215,
              "y": 19.242,
              "z": 1.067
            },
            "gtin": "4260257870085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e03d",
            "leftCorner": {
              "x": 14.215,
              "y": 19.242,
              "z": 1.067
            },
            "rightCorner": {
              "x": 14.366,
              "y": 19.232,
              "z": 1.067
            },
            "gtin": "4260257870085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e03e",
            "leftCorner": {
              "x": 14.368,
              "y": 19.237,
              "z": 1.067
            },
            "rightCorner": {
              "x": 14.543,
              "y": 19.225,
              "z": 1.067
            },
            "gtin": "4260257870078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e03f",
            "leftCorner": {
              "x": 14.543,
              "y": 19.225,
              "z": 1.067
            },
            "rightCorner": {
              "x": 14.719,
              "y": 19.212,
              "z": 1.067
            },
            "gtin": "4260257870078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e040",
            "leftCorner": {
              "x": 14.719,
              "y": 19.212,
              "z": 1.067
            },
            "rightCorner": {
              "x": 14.895,
              "y": 19.2,
              "z": 1.067
            },
            "gtin": "4260257870078",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546790",
        "height": 1.6534,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e069",
            "leftCorner": {
              "x": 14.084,
              "y": 19.246,
              "z": 1.353
            },
            "rightCorner": {
              "x": 14.393,
              "y": 19.224,
              "z": 1.353
            },
            "gtin": "4062139006052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e06a",
            "leftCorner": {
              "x": 14.393,
              "y": 19.224,
              "z": 1.353
            },
            "rightCorner": {
              "x": 14.701,
              "y": 19.203,
              "z": 1.353
            },
            "gtin": "4062139006052",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a85",
    "rightNeighborShelfId": "34a87"
  },
  {
    "id": "34a87",
    "name": "34a87",
    "x": 14.692,
    "y": 19.078,
    "width": 0.67,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03476,
      "w": 0.9994
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 5
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546795",
        "height": 0.16581,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a546794",
        "height": 0.84481,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a546796",
        "height": 1.2986,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e041",
            "leftCorner": {
              "x": 14.894,
              "y": 19.19,
              "z": 1.063
            },
            "rightCorner": {
              "x": 15.067,
              "y": 19.178,
              "z": 1.063
            },
            "gtin": "4018077009266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e042",
            "leftCorner": {
              "x": 15.067,
              "y": 19.178,
              "z": 1.063
            },
            "rightCorner": {
              "x": 15.241,
              "y": 19.166,
              "z": 1.063
            },
            "gtin": "4018077009266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e043",
            "leftCorner": {
              "x": 15.242,
              "y": 19.183,
              "z": 1.063
            },
            "rightCorner": {
              "x": 15.329,
              "y": 19.177,
              "z": 1.063
            },
            "gtin": "4018077822094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e044",
            "leftCorner": {
              "x": 15.329,
              "y": 19.177,
              "z": 1.063
            },
            "rightCorner": {
              "x": 15.415,
              "y": 19.17,
              "z": 1.063
            },
            "gtin": "4018077822094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e045",
            "leftCorner": {
              "x": 15.415,
              "y": 19.17,
              "z": 1.063
            },
            "rightCorner": {
              "x": 15.501,
              "y": 19.164,
              "z": 1.063
            },
            "gtin": "4018077822094",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a86",
    "rightNeighborShelfId": "34a88"
  },
  {
    "id": "34a88",
    "name": "34a88",
    "x": 15.361,
    "y": 19.032,
    "width": 0.67,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03476,
      "w": 0.9994
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 13
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546799",
        "height": 0.17008,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e082",
            "leftCorner": {
              "x": 15.416,
              "y": 19.085,
              "z": 0.139
            },
            "rightCorner": {
              "x": 15.611,
              "y": 19.071,
              "z": 0.139
            },
            "gtin": "4018077004285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e083",
            "leftCorner": {
              "x": 15.611,
              "y": 19.071,
              "z": 0.139
            },
            "rightCorner": {
              "x": 15.805,
              "y": 19.058,
              "z": 0.139
            },
            "gtin": "4018077004285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e073",
            "leftCorner": {
              "x": 15.806,
              "y": 19.07,
              "z": 0.139
            },
            "rightCorner": {
              "x": 16.034,
              "y": 19.054,
              "z": 0.139
            },
            "gtin": "4018077004377",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546797",
        "height": 0.84645,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e05a",
            "leftCorner": {
              "x": 15.419,
              "y": 19.165,
              "z": 0.693
            },
            "rightCorner": {
              "x": 15.565,
              "y": 19.155,
              "z": 0.693
            },
            "gtin": "4018077822018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e05b",
            "leftCorner": {
              "x": 15.565,
              "y": 19.155,
              "z": 0.693
            },
            "rightCorner": {
              "x": 15.712,
              "y": 19.145,
              "z": 0.693
            },
            "gtin": "4018077822018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e05c",
            "leftCorner": {
              "x": 15.712,
              "y": 19.145,
              "z": 0.693
            },
            "rightCorner": {
              "x": 15.858,
              "y": 19.135,
              "z": 0.693
            },
            "gtin": "4018077822018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e05d",
            "leftCorner": {
              "x": 15.858,
              "y": 19.135,
              "z": 0.693
            },
            "rightCorner": {
              "x": 16.004,
              "y": 19.125,
              "z": 0.693
            },
            "gtin": "4018077822018",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54679a",
        "height": 1.3045,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e046",
            "leftCorner": {
              "x": 15.501,
              "y": 19.151,
              "z": 1.067
            },
            "rightCorner": {
              "x": 15.756,
              "y": 19.133,
              "z": 1.067
            },
            "gtin": "4018077714313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e047",
            "leftCorner": {
              "x": 15.756,
              "y": 19.133,
              "z": 1.067
            },
            "rightCorner": {
              "x": 16.013,
              "y": 19.116,
              "z": 1.067
            },
            "gtin": "4018077714313",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546798",
        "height": 1.6566,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e44f",
            "leftCorner": {
              "x": 15.367,
              "y": 19.123,
              "z": 1.355
            },
            "rightCorner": {
              "x": 15.609,
              "y": 19.106,
              "z": 1.355
            },
            "gtin": "5701397326548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e450",
            "leftCorner": {
              "x": 15.609,
              "y": 19.106,
              "z": 1.355
            },
            "rightCorner": {
              "x": 15.849,
              "y": 19.089,
              "z": 1.355
            },
            "gtin": "5701397326548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e452",
            "leftCorner": {
              "x": 15.851,
              "y": 19.13,
              "z": 1.355
            },
            "rightCorner": {
              "x": 16.016,
              "y": 19.119,
              "z": 1.355
            },
            "gtin": "5701397326616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e453",
            "leftCorner": {
              "x": 16.016,
              "y": 19.119,
              "z": 1.355
            },
            "rightCorner": {
              "x": 16.18,
              "y": 19.108,
              "z": 1.355
            },
            "gtin": "5701397326616",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a87",
    "rightNeighborShelfId": "34a89"
  },
  {
    "id": "34a89",
    "name": "34a89",
    "x": 16.029,
    "y": 18.985,
    "width": 0.67,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03476,
      "w": 0.9994
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 7
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54679b",
        "height": 0.84533,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e05e",
            "leftCorner": {
              "x": 16.004,
              "y": 19.116,
              "z": 0.692
            },
            "rightCorner": {
              "x": 16.176,
              "y": 19.104,
              "z": 0.692
            },
            "gtin": "4018077006883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e05f",
            "leftCorner": {
              "x": 16.176,
              "y": 19.104,
              "z": 0.692
            },
            "rightCorner": {
              "x": 16.349,
              "y": 19.092,
              "z": 0.692
            },
            "gtin": "4018077006883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e060",
            "leftCorner": {
              "x": 16.35,
              "y": 19.104,
              "z": 0.692
            },
            "rightCorner": {
              "x": 16.539,
              "y": 19.09,
              "z": 0.692
            },
            "gtin": "4018077822018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e061",
            "leftCorner": {
              "x": 16.539,
              "y": 19.09,
              "z": 0.692
            },
            "rightCorner": {
              "x": 16.73,
              "y": 19.078,
              "z": 0.692
            },
            "gtin": "4018077822018",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54679c",
        "height": 1.3023,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a54679d",
        "height": 1.6539,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e454",
            "leftCorner": {
              "x": 16.18,
              "y": 19.108,
              "z": 1.353
            },
            "rightCorner": {
              "x": 16.396,
              "y": 19.093,
              "z": 1.353
            },
            "gtin": "5701397326531",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e455",
            "leftCorner": {
              "x": 16.396,
              "y": 19.093,
              "z": 1.353
            },
            "rightCorner": {
              "x": 16.613,
              "y": 19.078,
              "z": 1.353
            },
            "gtin": "5701397326531",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e456",
            "leftCorner": {
              "x": 16.613,
              "y": 19.078,
              "z": 1.353
            },
            "rightCorner": {
              "x": 16.831,
              "y": 19.063,
              "z": 1.353
            },
            "gtin": "5701397326531",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a88",
    "rightNeighborShelfId": "34a8a"
  },
  {
    "id": "34a8a",
    "name": "34a8a",
    "x": 16.697,
    "y": 18.938,
    "width": 0.67,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03476,
      "w": 0.9994
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 15
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54679f",
        "height": 0.16594,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a21061",
            "leftCorner": {
              "x": 16.699,
              "y": 18.954,
              "z": 0.136
            },
            "rightCorner": {
              "x": 16.965,
              "y": 18.935,
              "z": 0.136
            },
            "gtin": "4018077004469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21062",
            "leftCorner": {
              "x": 16.965,
              "y": 18.935,
              "z": 0.136
            },
            "rightCorner": {
              "x": 17.23,
              "y": 18.917,
              "z": 0.136
            },
            "gtin": "4018077004469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21064",
            "leftCorner": {
              "x": 17.234,
              "y": 18.962,
              "z": 0.136
            },
            "rightCorner": {
              "x": 17.346,
              "y": 18.954,
              "z": 0.136
            },
            "gtin": "4018077010170",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54679e",
        "height": 0.84746,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e062",
            "leftCorner": {
              "x": 16.73,
              "y": 19.075,
              "z": 0.693
            },
            "rightCorner": {
              "x": 16.882,
              "y": 19.063,
              "z": 0.693
            },
            "gtin": "4018077004193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e063",
            "leftCorner": {
              "x": 16.882,
              "y": 19.063,
              "z": 0.693
            },
            "rightCorner": {
              "x": 17.036,
              "y": 19.053,
              "z": 0.693
            },
            "gtin": "4018077004193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e064",
            "leftCorner": {
              "x": 17.037,
              "y": 19.057,
              "z": 0.693
            },
            "rightCorner": {
              "x": 17.215,
              "y": 19.044,
              "z": 0.693
            },
            "gtin": "4018077009266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e065",
            "leftCorner": {
              "x": 17.214,
              "y": 19.033,
              "z": 0.693
            },
            "rightCorner": {
              "x": 17.322,
              "y": 19.025,
              "z": 0.693
            },
            "gtin": "4018077012280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e066",
            "leftCorner": {
              "x": 17.322,
              "y": 19.025,
              "z": 0.693
            },
            "rightCorner": {
              "x": 17.43,
              "y": 19.018,
              "z": 0.693
            },
            "gtin": "4018077012280",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467a1",
        "height": 1.3028,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e048",
            "leftCorner": {
              "x": 16.967,
              "y": 19.049,
              "z": 1.066
            },
            "rightCorner": {
              "x": 17.114,
              "y": 19.039,
              "z": 1.066
            },
            "gtin": "4018077714016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e049",
            "leftCorner": {
              "x": 17.114,
              "y": 19.039,
              "z": 1.066
            },
            "rightCorner": {
              "x": 17.263,
              "y": 19.029,
              "z": 1.066
            },
            "gtin": "4018077714016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e031",
            "leftCorner": {
              "x": 17.262,
              "y": 19.023,
              "z": 1.066
            },
            "rightCorner": {
              "x": 17.375,
              "y": 19.015,
              "z": 1.066
            },
            "gtin": "4018077714054",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467a0",
        "height": 1.6547,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e457",
            "leftCorner": {
              "x": 16.829,
              "y": 19.041,
              "z": 1.354
            },
            "rightCorner": {
              "x": 16.959,
              "y": 19.032,
              "z": 1.354
            },
            "gtin": "7350045596161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e458",
            "leftCorner": {
              "x": 16.96,
              "y": 19.053,
              "z": 1.354
            },
            "rightCorner": {
              "x": 17.101,
              "y": 19.043,
              "z": 1.354
            },
            "gtin": "7350045594723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e459",
            "leftCorner": {
              "x": 17.1,
              "y": 19.033,
              "z": 1.354
            },
            "rightCorner": {
              "x": 17.38,
              "y": 19.013,
              "z": 1.354
            },
            "gtin": "7350045591050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e45a",
            "leftCorner": {
              "x": 17.38,
              "y": 19.013,
              "z": 1.354
            },
            "rightCorner": {
              "x": 17.66,
              "y": 18.994,
              "z": 1.354
            },
            "gtin": "7350045591050",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a89",
    "rightNeighborShelfId": "34a8b"
  },
  {
    "id": "34a8b",
    "name": "34a8b",
    "x": 17.366,
    "y": 18.892,
    "width": 0.67,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03476,
      "w": 0.9994
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 6
    },
    "layers": [
      {
        "id": "682ffddfd15af3232a5469c5",
        "height": 0.16698,
        "facings": []
      },
      {
        "id": "682ffddfd15af3232a5469c4",
        "height": 0.84705,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e04a",
            "leftCorner": {
              "x": 17.432,
              "y": 19.036,
              "z": 0.693
            },
            "rightCorner": {
              "x": 17.738,
              "y": 19.014,
              "z": 0.693
            },
            "gtin": "4018077006524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e04b",
            "leftCorner": {
              "x": 17.738,
              "y": 19.014,
              "z": 0.693
            },
            "rightCorner": {
              "x": 18.045,
              "y": 18.994,
              "z": 0.693
            },
            "gtin": "4018077006524",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469c6",
        "height": 1.6533,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e45b",
            "leftCorner": {
              "x": 17.661,
              "y": 19.007,
              "z": 1.353
            },
            "rightCorner": {
              "x": 17.799,
              "y": 18.998,
              "z": 1.353
            },
            "gtin": "7350045593290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e45c",
            "leftCorner": {
              "x": 17.799,
              "y": 18.998,
              "z": 1.353
            },
            "rightCorner": {
              "x": 17.938,
              "y": 18.988,
              "z": 1.353
            },
            "gtin": "7350045593290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e45d",
            "leftCorner": {
              "x": 17.937,
              "y": 18.983,
              "z": 1.353
            },
            "rightCorner": {
              "x": 18.139,
              "y": 18.968,
              "z": 1.353
            },
            "gtin": "7350045595355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e45e",
            "leftCorner": {
              "x": 18.139,
              "y": 18.968,
              "z": 1.353
            },
            "rightCorner": {
              "x": 18.341,
              "y": 18.955,
              "z": 1.353
            },
            "gtin": "7350045595355",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a8a",
    "rightNeighborShelfId": "34a8c"
  },
  {
    "id": "34a8c",
    "name": "34a8c",
    "x": 18.034,
    "y": 18.845,
    "width": 0.67,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03476,
      "w": 0.9994
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 5
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5467a2",
        "height": 0.17354,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a21065",
            "leftCorner": {
              "x": 18.074,
              "y": 18.895,
              "z": 0.142
            },
            "rightCorner": {
              "x": 18.326,
              "y": 18.878,
              "z": 0.142
            },
            "gtin": "4003586106995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21066",
            "leftCorner": {
              "x": 18.326,
              "y": 18.878,
              "z": 0.142
            },
            "rightCorner": {
              "x": 18.578,
              "y": 18.86,
              "z": 0.142
            },
            "gtin": "4003586106995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21067",
            "leftCorner": {
              "x": 18.577,
              "y": 18.849,
              "z": 0.142
            },
            "rightCorner": {
              "x": 18.701,
              "y": 18.841,
              "z": 0.142
            },
            "gtin": "4003586106988",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21068",
            "leftCorner": {
              "x": 18.701,
              "y": 18.841,
              "z": 0.142
            },
            "rightCorner": {
              "x": 18.826,
              "y": 18.832,
              "z": 0.142
            },
            "gtin": "4003586106988",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467a3",
        "height": 1.6569,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e45f",
            "leftCorner": {
              "x": 18.338,
              "y": 18.941,
              "z": 1.356
            },
            "rightCorner": {
              "x": 18.449,
              "y": 18.934,
              "z": 1.356
            },
            "gtin": "7350045595904",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a8b",
    "rightNeighborShelfId": "34a8d"
  },
  {
    "id": "34a8d",
    "name": "34a8d",
    "x": 18.702,
    "y": 18.799,
    "width": 0.67,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03476,
      "w": 0.9994
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 12
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5467a6",
        "height": 0.16646,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a21063",
            "leftCorner": {
              "x": 18.827,
              "y": 18.853,
              "z": 0.136
            },
            "rightCorner": {
              "x": 19.375,
              "y": 18.815,
              "z": 0.136
            },
            "gtin": "4003586107251",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467a4",
        "height": 0.84823,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e476",
            "leftCorner": {
              "x": 19.576,
              "y": 18.885,
              "z": 0.694
            },
            "rightCorner": {
              "x": 19.848,
              "y": 18.866,
              "z": 0.694
            },
            "gtin": "4018077006425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e471",
            "leftCorner": {
              "x": 18.709,
              "y": 18.89,
              "z": 0.694
            },
            "rightCorner": {
              "x": 19.005,
              "y": 18.869,
              "z": 0.694
            },
            "gtin": "4018077006524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e472",
            "leftCorner": {
              "x": 19.005,
              "y": 18.869,
              "z": 0.694
            },
            "rightCorner": {
              "x": 19.3,
              "y": 18.849,
              "z": 0.694
            },
            "gtin": "4018077006524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e475",
            "leftCorner": {
              "x": 19.303,
              "y": 18.904,
              "z": 0.694
            },
            "rightCorner": {
              "x": 19.576,
              "y": 18.885,
              "z": 0.694
            },
            "gtin": "4018077006425",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467a5",
        "height": 1.3008,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e467",
            "leftCorner": {
              "x": 18.709,
              "y": 18.894,
              "z": 1.064
            },
            "rightCorner": {
              "x": 18.799,
              "y": 18.888,
              "z": 1.064
            },
            "gtin": "4036554703766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e468",
            "leftCorner": {
              "x": 18.799,
              "y": 18.888,
              "z": 1.064
            },
            "rightCorner": {
              "x": 18.89,
              "y": 18.881,
              "z": 1.064
            },
            "gtin": "4036554703766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e46b",
            "leftCorner": {
              "x": 18.893,
              "y": 18.918,
              "z": 1.064
            },
            "rightCorner": {
              "x": 19.053,
              "y": 18.907,
              "z": 1.064
            },
            "gtin": "4036554703735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e46c",
            "leftCorner": {
              "x": 19.053,
              "y": 18.907,
              "z": 1.064
            },
            "rightCorner": {
              "x": 19.214,
              "y": 18.896,
              "z": 1.064
            },
            "gtin": "4036554703735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e46d",
            "leftCorner": {
              "x": 19.213,
              "y": 18.894,
              "z": 1.064
            },
            "rightCorner": {
              "x": 19.538,
              "y": 18.872,
              "z": 1.064
            },
            "gtin": "4036554703759",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467a7",
        "height": 1.6525,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e460",
            "leftCorner": {
              "x": 19.213,
              "y": 18.893,
              "z": 1.352
            },
            "rightCorner": {
              "x": 19.336,
              "y": 18.885,
              "z": 1.352
            },
            "gtin": "4262479220068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e461",
            "leftCorner": {
              "x": 19.336,
              "y": 18.892,
              "z": 1.352
            },
            "rightCorner": {
              "x": 19.385,
              "y": 18.888,
              "z": 1.352
            },
            "gtin": "4262479220082",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a8c",
    "rightNeighborShelfId": "34a8e"
  },
  {
    "id": "34a8e",
    "name": "34a8e",
    "x": 19.371,
    "y": 18.752,
    "width": 0.67,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03476,
      "w": 0.9994
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 13
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54631b",
        "height": 0.84725,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e473",
            "leftCorner": {
              "x": 19.848,
              "y": 18.858,
              "z": 0.693
            },
            "rightCorner": {
              "x": 19.948,
              "y": 18.851,
              "z": 0.693
            },
            "gtin": "4013138018386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e474",
            "leftCorner": {
              "x": 19.948,
              "y": 18.851,
              "z": 0.693
            },
            "rightCorner": {
              "x": 20.05,
              "y": 18.843,
              "z": 0.693
            },
            "gtin": "4013138018386",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54631a",
        "height": 1.2994,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e46e",
            "leftCorner": {
              "x": 19.536,
              "y": 18.858,
              "z": 1.063
            },
            "rightCorner": {
              "x": 19.662,
              "y": 18.849,
              "z": 1.063
            },
            "gtin": "4036554704725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e46f",
            "leftCorner": {
              "x": 19.662,
              "y": 18.849,
              "z": 1.063
            },
            "rightCorner": {
              "x": 19.788,
              "y": 18.84,
              "z": 1.063
            },
            "gtin": "4036554704725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e470",
            "leftCorner": {
              "x": 19.788,
              "y": 18.84,
              "z": 1.063
            },
            "rightCorner": {
              "x": 19.913,
              "y": 18.832,
              "z": 1.063
            },
            "gtin": "4036554704725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e469",
            "leftCorner": {
              "x": 19.913,
              "y": 18.842,
              "z": 1.063
            },
            "rightCorner": {
              "x": 19.981,
              "y": 18.837,
              "z": 1.063
            },
            "gtin": "4036554704718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e46a",
            "leftCorner": {
              "x": 19.981,
              "y": 18.837,
              "z": 1.063
            },
            "rightCorner": {
              "x": 20.048,
              "y": 18.831,
              "z": 1.063
            },
            "gtin": "4036554704718",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546319",
        "height": 1.6499,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e462",
            "leftCorner": {
              "x": 19.385,
              "y": 18.874,
              "z": 1.35
            },
            "rightCorner": {
              "x": 19.536,
              "y": 18.863,
              "z": 1.35
            },
            "gtin": "4260562940688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e463",
            "leftCorner": {
              "x": 19.536,
              "y": 18.863,
              "z": 1.35
            },
            "rightCorner": {
              "x": 19.74,
              "y": 18.849,
              "z": 1.35
            },
            "gtin": "4260562940664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e464",
            "leftCorner": {
              "x": 19.742,
              "y": 18.861,
              "z": 1.35
            },
            "rightCorner": {
              "x": 19.815,
              "y": 18.856,
              "z": 1.35
            },
            "gtin": "634158955907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e465",
            "leftCorner": {
              "x": 19.814,
              "y": 18.846,
              "z": 1.35
            },
            "rightCorner": {
              "x": 19.886,
              "y": 18.84,
              "z": 1.35
            },
            "gtin": "4260562940688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e466",
            "leftCorner": {
              "x": 19.886,
              "y": 18.84,
              "z": 1.35
            },
            "rightCorner": {
              "x": 19.959,
              "y": 18.835,
              "z": 1.35
            },
            "gtin": "4260562940688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e451",
            "leftCorner": {
              "x": 19.959,
              "y": 18.829,
              "z": 1.35
            },
            "rightCorner": {
              "x": 20.048,
              "y": 18.822,
              "z": 1.35
            },
            "gtin": "634158955921",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a8d"
  },
  {
    "id": "34a8f",
    "name": "34a8f",
    "x": 20.7,
    "y": 30.471,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99958,
      "w": 0.029134
    },

    "layers": [],
    "rightNeighborShelfId": "34a98"
  },
  {
    "id": "34a90",
    "name": "34a90",
    "x": 9.804,
    "y": 28.95,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.035676,
      "w": 0.99936
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 33
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5468a9",
        "height": 0.69289,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2138f",
            "leftCorner": {
              "x": 9.815,
              "y": 29.107,
              "z": 0.567
            },
            "rightCorner": {
              "x": 10.183,
              "y": 29.08,
              "z": 0.567
            },
            "gtin": "4066627090424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21391",
            "leftCorner": {
              "x": 10.185,
              "y": 29.117,
              "z": 0.567
            },
            "rightCorner": {
              "x": 10.767,
              "y": 29.076,
              "z": 0.567
            },
            "gtin": "4066632092673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21390",
            "leftCorner": {
              "x": 10.766,
              "y": 29.062,
              "z": 0.567
            },
            "rightCorner": {
              "x": 11.163,
              "y": 29.033,
              "z": 0.567
            },
            "gtin": "4066627213908",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468a7",
        "height": 0.75141,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2137f",
            "leftCorner": {
              "x": 9.816,
              "y": 29.118,
              "z": 0.615
            },
            "rightCorner": {
              "x": 10.005,
              "y": 29.104,
              "z": 0.615
            },
            "gtin": "4066627295713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21380",
            "leftCorner": {
              "x": 10.005,
              "y": 29.104,
              "z": 0.615
            },
            "rightCorner": {
              "x": 10.194,
              "y": 29.091,
              "z": 0.615
            },
            "gtin": "4066627295713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21383",
            "leftCorner": {
              "x": 10.196,
              "y": 29.121,
              "z": 0.615
            },
            "rightCorner": {
              "x": 10.38,
              "y": 29.108,
              "z": 0.615
            },
            "gtin": "4066627181641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21384",
            "leftCorner": {
              "x": 10.38,
              "y": 29.108,
              "z": 0.615
            },
            "rightCorner": {
              "x": 10.564,
              "y": 29.095,
              "z": 0.615
            },
            "gtin": "4066627181641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21385",
            "leftCorner": {
              "x": 10.564,
              "y": 29.095,
              "z": 0.615
            },
            "rightCorner": {
              "x": 10.747,
              "y": 29.082,
              "z": 0.615
            },
            "gtin": "4066627181641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21381",
            "leftCorner": {
              "x": 10.748,
              "y": 29.095,
              "z": 0.615
            },
            "rightCorner": {
              "x": 10.957,
              "y": 29.079,
              "z": 0.615
            },
            "gtin": "4066632092673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21382",
            "leftCorner": {
              "x": 10.957,
              "y": 29.079,
              "z": 0.615
            },
            "rightCorner": {
              "x": 11.166,
              "y": 29.064,
              "z": 0.615
            },
            "gtin": "4066632092673",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468aa",
        "height": 1.1038,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21392",
            "leftCorner": {
              "x": 9.815,
              "y": 29.104,
              "z": 0.903
            },
            "rightCorner": {
              "x": 9.922,
              "y": 29.096,
              "z": 0.903
            },
            "gtin": "4066627311352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21394",
            "leftCorner": {
              "x": 9.925,
              "y": 29.131,
              "z": 0.903
            },
            "rightCorner": {
              "x": 10.041,
              "y": 29.123,
              "z": 0.903
            },
            "gtin": "4066627311369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21395",
            "leftCorner": {
              "x": 10.041,
              "y": 29.123,
              "z": 0.903
            },
            "rightCorner": {
              "x": 10.157,
              "y": 29.114,
              "z": 0.903
            },
            "gtin": "4066627311369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21396",
            "leftCorner": {
              "x": 10.157,
              "y": 29.117,
              "z": 0.903
            },
            "rightCorner": {
              "x": 10.309,
              "y": 29.106,
              "z": 0.903
            },
            "gtin": "4066627305733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21397",
            "leftCorner": {
              "x": 10.31,
              "y": 29.111,
              "z": 0.903
            },
            "rightCorner": {
              "x": 10.407,
              "y": 29.103,
              "z": 0.903
            },
            "gtin": "4066627324956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21398",
            "leftCorner": {
              "x": 10.407,
              "y": 29.103,
              "z": 0.903
            },
            "rightCorner": {
              "x": 10.504,
              "y": 29.097,
              "z": 0.903
            },
            "gtin": "4066627324956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21399",
            "leftCorner": {
              "x": 10.504,
              "y": 29.097,
              "z": 0.903
            },
            "rightCorner": {
              "x": 10.736,
              "y": 29.08,
              "z": 0.903
            },
            "gtin": "4066627324963",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21393",
            "leftCorner": {
              "x": 10.736,
              "y": 29.082,
              "z": 0.903
            },
            "rightCorner": {
              "x": 11.165,
              "y": 29.052,
              "z": 0.903
            },
            "gtin": "4067526078773",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468ab",
        "height": 1.562,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2139a",
            "leftCorner": {
              "x": 9.815,
              "y": 29.107,
              "z": 1.278
            },
            "rightCorner": {
              "x": 10.123,
              "y": 29.085,
              "z": 1.278
            },
            "gtin": "4066627346590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2139d",
            "leftCorner": {
              "x": 10.126,
              "y": 29.123,
              "z": 1.278
            },
            "rightCorner": {
              "x": 10.528,
              "y": 29.094,
              "z": 1.278
            },
            "gtin": "4066627346583",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2139e",
            "leftCorner": {
              "x": 10.528,
              "y": 29.098,
              "z": 1.278
            },
            "rightCorner": {
              "x": 10.692,
              "y": 29.086,
              "z": 1.278
            },
            "gtin": "4066627346576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2139f",
            "leftCorner": {
              "x": 10.692,
              "y": 29.091,
              "z": 1.278
            },
            "rightCorner": {
              "x": 10.894,
              "y": 29.076,
              "z": 1.278
            },
            "gtin": "4063367112263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2139b",
            "leftCorner": {
              "x": 10.894,
              "y": 29.069,
              "z": 1.278
            },
            "rightCorner": {
              "x": 11.029,
              "y": 29.059,
              "z": 1.278
            },
            "gtin": "4066627299193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2139c",
            "leftCorner": {
              "x": 11.029,
              "y": 29.059,
              "z": 1.278
            },
            "rightCorner": {
              "x": 11.165,
              "y": 29.049,
              "z": 1.278
            },
            "gtin": "4066627299193",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468a8",
        "height": 1.7599,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21386",
            "leftCorner": {
              "x": 9.815,
              "y": 29.1,
              "z": 1.44
            },
            "rightCorner": {
              "x": 9.939,
              "y": 29.091,
              "z": 1.44
            },
            "gtin": "4066627299421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21389",
            "leftCorner": {
              "x": 9.942,
              "y": 29.131,
              "z": 1.44
            },
            "rightCorner": {
              "x": 10.0,
              "y": 29.127,
              "z": 1.44
            },
            "gtin": "4066627299414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2138a",
            "leftCorner": {
              "x": 10.0,
              "y": 29.127,
              "z": 1.44
            },
            "rightCorner": {
              "x": 10.058,
              "y": 29.123,
              "z": 1.44
            },
            "gtin": "4066627299414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2138b",
            "leftCorner": {
              "x": 10.058,
              "y": 29.123,
              "z": 1.44
            },
            "rightCorner": {
              "x": 10.116,
              "y": 29.119,
              "z": 1.44
            },
            "gtin": "4066627299414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2138c",
            "leftCorner": {
              "x": 10.116,
              "y": 29.114,
              "z": 1.44
            },
            "rightCorner": {
              "x": 10.322,
              "y": 29.099,
              "z": 1.44
            },
            "gtin": "4066627295317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2138d",
            "leftCorner": {
              "x": 10.322,
              "y": 29.099,
              "z": 1.44
            },
            "rightCorner": {
              "x": 10.528,
              "y": 29.085,
              "z": 1.44
            },
            "gtin": "4066627295317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2138e",
            "leftCorner": {
              "x": 10.529,
              "y": 29.091,
              "z": 1.44
            },
            "rightCorner": {
              "x": 10.826,
              "y": 29.07,
              "z": 1.44
            },
            "gtin": "4066627299797",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21387",
            "leftCorner": {
              "x": 10.826,
              "y": 29.072,
              "z": 1.44
            },
            "rightCorner": {
              "x": 10.995,
              "y": 29.06,
              "z": 1.44
            },
            "gtin": "4066627299209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21388",
            "leftCorner": {
              "x": 10.995,
              "y": 29.06,
              "z": 1.44
            },
            "rightCorner": {
              "x": 11.164,
              "y": 29.047,
              "z": 1.44
            },
            "gtin": "4066627299209",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d1391",
    "rightNeighborShelfId": "34a91"
  },
  {
    "id": "34a91",
    "name": "34a91",
    "x": 11.151,
    "y": 28.853,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.035676,
      "w": 0.99936
    },

    "layers": [],
    "leftNeighborShelfId": "34a90",
    "rightNeighborShelfId": "34a92"
  },
  {
    "id": "34a92",
    "name": "34a92",
    "x": 12.497,
    "y": 28.757,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.035676,
      "w": 0.99936
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5468af",
        "height": 1.3445,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a213b5",
            "leftCorner": {
              "x": 12.507,
              "y": 28.909,
              "z": 1.1
            },
            "rightCorner": {
              "x": 13.282,
              "y": 28.853,
              "z": 1.1
            }
          },
          {
            "id": "68300c8b5ed67a01d9a213b6",
            "leftCorner": {
              "x": 13.285,
              "y": 28.893,
              "z": 1.1
            },
            "rightCorner": {
              "x": 13.857,
              "y": 28.853,
              "z": 1.1
            },
            "gtin": "4063367301841",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468ad",
        "height": 1.4184,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a213a0",
            "leftCorner": {
              "x": 12.508,
              "y": 28.921,
              "z": 1.16
            },
            "rightCorner": {
              "x": 12.666,
              "y": 28.91,
              "z": 1.16
            },
            "gtin": "4063367500329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213a1",
            "leftCorner": {
              "x": 12.666,
              "y": 28.91,
              "z": 1.16
            },
            "rightCorner": {
              "x": 12.823,
              "y": 28.898,
              "z": 1.16
            },
            "gtin": "4063367500329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213a2",
            "leftCorner": {
              "x": 12.823,
              "y": 28.898,
              "z": 1.16
            },
            "rightCorner": {
              "x": 12.98,
              "y": 28.888,
              "z": 1.16
            },
            "gtin": "4063367500329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213a8",
            "leftCorner": {
              "x": 12.982,
              "y": 28.926,
              "z": 1.16
            },
            "rightCorner": {
              "x": 13.081,
              "y": 28.918,
              "z": 1.16
            },
            "gtin": "4337185622847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213a9",
            "leftCorner": {
              "x": 13.081,
              "y": 28.918,
              "z": 1.16
            },
            "rightCorner": {
              "x": 13.179,
              "y": 28.911,
              "z": 1.16
            },
            "gtin": "4337185622847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213aa",
            "leftCorner": {
              "x": 13.179,
              "y": 28.911,
              "z": 1.16
            },
            "rightCorner": {
              "x": 13.276,
              "y": 28.904,
              "z": 1.16
            },
            "gtin": "4337185622847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213a3",
            "leftCorner": {
              "x": 13.276,
              "y": 28.895,
              "z": 1.16
            },
            "rightCorner": {
              "x": 13.393,
              "y": 28.887,
              "z": 1.16
            },
            "gtin": "4063367113734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213a4",
            "leftCorner": {
              "x": 13.393,
              "y": 28.887,
              "z": 1.16
            },
            "rightCorner": {
              "x": 13.508,
              "y": 28.879,
              "z": 1.16
            },
            "gtin": "4063367113734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213a5",
            "leftCorner": {
              "x": 13.508,
              "y": 28.879,
              "z": 1.16
            },
            "rightCorner": {
              "x": 13.625,
              "y": 28.871,
              "z": 1.16
            },
            "gtin": "4063367113734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213a6",
            "leftCorner": {
              "x": 13.625,
              "y": 28.871,
              "z": 1.16
            },
            "rightCorner": {
              "x": 13.741,
              "y": 28.863,
              "z": 1.16
            },
            "gtin": "4063367113734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213a7",
            "leftCorner": {
              "x": 13.741,
              "y": 28.863,
              "z": 1.16
            },
            "rightCorner": {
              "x": 13.857,
              "y": 28.854,
              "z": 1.16
            },
            "gtin": "4063367113734",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468ae",
        "height": 1.7687,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a213ab",
            "leftCorner": {
              "x": 12.508,
              "y": 28.92,
              "z": 1.447
            },
            "rightCorner": {
              "x": 12.615,
              "y": 28.912,
              "z": 1.447
            },
            "gtin": "4063367503115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213ac",
            "leftCorner": {
              "x": 12.615,
              "y": 28.912,
              "z": 1.447
            },
            "rightCorner": {
              "x": 12.723,
              "y": 28.904,
              "z": 1.447
            },
            "gtin": "4063367503115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213ad",
            "leftCorner": {
              "x": 12.723,
              "y": 28.904,
              "z": 1.447
            },
            "rightCorner": {
              "x": 12.83,
              "y": 28.897,
              "z": 1.447
            },
            "gtin": "4063367503115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213ae",
            "leftCorner": {
              "x": 12.83,
              "y": 28.897,
              "z": 1.447
            },
            "rightCorner": {
              "x": 12.938,
              "y": 28.889,
              "z": 1.447
            },
            "gtin": "4063367503115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213b2",
            "leftCorner": {
              "x": 12.94,
              "y": 28.933,
              "z": 1.447
            },
            "rightCorner": {
              "x": 13.266,
              "y": 28.91,
              "z": 1.447
            },
            "gtin": "4063367500343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213b3",
            "leftCorner": {
              "x": 13.265,
              "y": 28.903,
              "z": 1.447
            },
            "rightCorner": {
              "x": 13.484,
              "y": 28.888,
              "z": 1.447
            },
            "gtin": "4063367500329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213b4",
            "leftCorner": {
              "x": 13.484,
              "y": 28.888,
              "z": 1.447
            },
            "rightCorner": {
              "x": 13.702,
              "y": 28.872,
              "z": 1.447
            },
            "gtin": "4063367500329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213af",
            "leftCorner": {
              "x": 13.703,
              "y": 28.875,
              "z": 1.447
            },
            "rightCorner": {
              "x": 13.755,
              "y": 28.871,
              "z": 1.447
            },
            "gtin": "4337185621345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213b0",
            "leftCorner": {
              "x": 13.755,
              "y": 28.871,
              "z": 1.447
            },
            "rightCorner": {
              "x": 13.806,
              "y": 28.868,
              "z": 1.447
            },
            "gtin": "4337185621345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213b1",
            "leftCorner": {
              "x": 13.806,
              "y": 28.868,
              "z": 1.447
            },
            "rightCorner": {
              "x": 13.858,
              "y": 28.864,
              "z": 1.447
            },
            "gtin": "4337185621345",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a91",
    "rightNeighborShelfId": "34a93"
  },
  {
    "id": "34a93",
    "name": "34a93",
    "x": 13.844,
    "y": 28.661,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.035676,
      "w": 0.99936
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 26
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5468b3",
        "height": 0.22666,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a213c4",
            "leftCorner": {
              "x": 13.842,
              "y": 28.633,
              "z": 0.185
            },
            "rightCorner": {
              "x": 14.117,
              "y": 28.613,
              "z": 0.185
            },
            "gtin": "791732462227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213c5",
            "leftCorner": {
              "x": 14.117,
              "y": 28.613,
              "z": 0.185
            },
            "rightCorner": {
              "x": 14.392,
              "y": 28.594,
              "z": 0.185
            },
            "gtin": "791732462227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213c7",
            "leftCorner": {
              "x": 14.394,
              "y": 28.618,
              "z": 0.185
            },
            "rightCorner": {
              "x": 14.571,
              "y": 28.605,
              "z": 0.185
            },
            "gtin": "791732462807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213c8",
            "leftCorner": {
              "x": 14.573,
              "y": 28.62,
              "z": 0.185
            },
            "rightCorner": {
              "x": 14.694,
              "y": 28.611,
              "z": 0.185
            },
            "gtin": "791732462371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213c9",
            "leftCorner": {
              "x": 14.694,
              "y": 28.606,
              "z": 0.185
            },
            "rightCorner": {
              "x": 14.83,
              "y": 28.596,
              "z": 0.185
            },
            "gtin": "791732462395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213ca",
            "leftCorner": {
              "x": 14.83,
              "y": 28.597,
              "z": 0.185
            },
            "rightCorner": {
              "x": 15.007,
              "y": 28.584,
              "z": 0.185
            },
            "gtin": "767523544311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213c6",
            "leftCorner": {
              "x": 15.008,
              "y": 28.595,
              "z": 0.185
            },
            "rightCorner": {
              "x": 15.192,
              "y": 28.582,
              "z": 0.185
            },
            "gtin": "767523543260",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468b2",
        "height": 0.66398,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a213c2",
            "leftCorner": {
              "x": 13.857,
              "y": 28.842,
              "z": 0.543
            },
            "rightCorner": {
              "x": 15.055,
              "y": 28.757,
              "z": 0.543
            },
            "gtin": "767523544465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213c3",
            "leftCorner": {
              "x": 15.058,
              "y": 28.794,
              "z": 0.543
            },
            "rightCorner": {
              "x": 15.207,
              "y": 28.784,
              "z": 0.543
            },
            "gtin": "791732462210",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468b7",
        "height": 0.74572,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a213d2",
            "leftCorner": {
              "x": 13.857,
              "y": 28.831,
              "z": 0.61
            },
            "rightCorner": {
              "x": 14.362,
              "y": 28.795,
              "z": 0.61
            }
          },
          {
            "id": "68300c8b5ed67a01d9a213d3",
            "leftCorner": {
              "x": 14.362,
              "y": 28.795,
              "z": 0.61
            },
            "rightCorner": {
              "x": 14.868,
              "y": 28.759,
              "z": 0.61
            }
          },
          {
            "id": "68300c8b5ed67a01d9a213d4",
            "leftCorner": {
              "x": 14.871,
              "y": 28.798,
              "z": 0.61
            },
            "rightCorner": {
              "x": 15.206,
              "y": 28.774,
              "z": 0.61
            },
            "gtin": "791688734768",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468b1",
        "height": 0.90959,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a213bb",
            "leftCorner": {
              "x": 13.855,
              "y": 28.822,
              "z": 0.744
            },
            "rightCorner": {
              "x": 14.005,
              "y": 28.811,
              "z": 0.744
            },
            "gtin": "791688734829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213bc",
            "leftCorner": {
              "x": 14.005,
              "y": 28.811,
              "z": 0.744
            },
            "rightCorner": {
              "x": 14.154,
              "y": 28.801,
              "z": 0.744
            },
            "gtin": "791688734829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213be",
            "leftCorner": {
              "x": 14.157,
              "y": 28.839,
              "z": 0.744
            },
            "rightCorner": {
              "x": 14.247,
              "y": 28.832,
              "z": 0.744
            },
            "gtin": "791732462579",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213bf",
            "leftCorner": {
              "x": 14.247,
              "y": 28.832,
              "z": 0.744
            },
            "rightCorner": {
              "x": 14.337,
              "y": 28.826,
              "z": 0.744
            },
            "gtin": "791732462579",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213c0",
            "leftCorner": {
              "x": 14.337,
              "y": 28.826,
              "z": 0.744
            },
            "rightCorner": {
              "x": 14.43,
              "y": 28.819,
              "z": 0.744
            },
            "gtin": "767523546315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213c1",
            "leftCorner": {
              "x": 14.43,
              "y": 28.819,
              "z": 0.744
            },
            "rightCorner": {
              "x": 14.524,
              "y": 28.812,
              "z": 0.744
            },
            "gtin": "767523546315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213bd",
            "leftCorner": {
              "x": 14.524,
              "y": 28.815,
              "z": 0.744
            },
            "rightCorner": {
              "x": 15.205,
              "y": 28.765,
              "z": 0.744
            },
            "gtin": "791688734775",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468b4",
        "height": 1.3554,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a213cb",
            "leftCorner": {
              "x": 13.856,
              "y": 28.828,
              "z": 1.109
            },
            "rightCorner": {
              "x": 14.332,
              "y": 28.794,
              "z": 1.109
            },
            "gtin": "791732463200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213cc",
            "leftCorner": {
              "x": 14.335,
              "y": 28.827,
              "z": 1.109
            },
            "rightCorner": {
              "x": 15.205,
              "y": 28.765,
              "z": 1.109
            },
            "gtin": "767523545950",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468b6",
        "height": 1.3885,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a213cd",
            "leftCorner": {
              "x": 13.857,
              "y": 28.832,
              "z": 1.136
            },
            "rightCorner": {
              "x": 14.633,
              "y": 28.776,
              "z": 1.136
            },
            "gtin": "791732462456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213cf",
            "leftCorner": {
              "x": 14.635,
              "y": 28.817,
              "z": 1.136
            },
            "rightCorner": {
              "x": 14.862,
              "y": 28.8,
              "z": 1.136
            },
            "gtin": "647056915898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213d0",
            "leftCorner": {
              "x": 14.862,
              "y": 28.799,
              "z": 1.136
            },
            "rightCorner": {
              "x": 14.987,
              "y": 28.791,
              "z": 1.136
            },
            "gtin": "791732462357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213d1",
            "leftCorner": {
              "x": 14.987,
              "y": 28.795,
              "z": 1.136
            },
            "rightCorner": {
              "x": 15.079,
              "y": 28.789,
              "z": 1.136
            },
            "gtin": "034731856643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213ce",
            "leftCorner": {
              "x": 15.079,
              "y": 28.785,
              "z": 1.136
            },
            "rightCorner": {
              "x": 15.206,
              "y": 28.776,
              "z": 1.136
            },
            "gtin": "647056915881",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468b0",
        "height": 1.9184,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a213b7",
            "leftCorner": {
              "x": 13.856,
              "y": 28.829,
              "z": 1.57
            },
            "rightCorner": {
              "x": 14.181,
              "y": 28.806,
              "z": 1.57
            },
            "gtin": "791732462326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213b9",
            "leftCorner": {
              "x": 14.184,
              "y": 28.838,
              "z": 1.57
            },
            "rightCorner": {
              "x": 14.446,
              "y": 28.819,
              "z": 1.57
            },
            "gtin": "767523543413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213ba",
            "leftCorner": {
              "x": 14.446,
              "y": 28.825,
              "z": 1.57
            },
            "rightCorner": {
              "x": 14.839,
              "y": 28.797,
              "z": 1.57
            },
            "gtin": "791688734744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213b8",
            "leftCorner": {
              "x": 14.84,
              "y": 28.804,
              "z": 1.57
            },
            "rightCorner": {
              "x": 15.206,
              "y": 28.778,
              "z": 1.57
            },
            "gtin": "791688734751",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a92",
    "rightNeighborShelfId": "34a94"
  },
  {
    "id": "34a94",
    "name": "34a94",
    "x": 15.19,
    "y": 28.565,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.035676,
      "w": 0.99936
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 20
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5468ba",
        "height": 1.1982,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a213e5",
            "leftCorner": {
              "x": 15.201,
              "y": 28.708,
              "z": 0.98
            },
            "rightCorner": {
              "x": 15.366,
              "y": 28.696,
              "z": 0.98
            },
            "gtin": "4062139025749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213e7",
            "leftCorner": {
              "x": 15.369,
              "y": 28.728,
              "z": 0.98
            },
            "rightCorner": {
              "x": 15.927,
              "y": 28.688,
              "z": 0.98
            },
            "gtin": "4062139026524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213e8",
            "leftCorner": {
              "x": 15.928,
              "y": 28.703,
              "z": 0.98
            },
            "rightCorner": {
              "x": 16.05,
              "y": 28.694,
              "z": 0.98
            },
            "gtin": "4062139025749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213e6",
            "leftCorner": {
              "x": 16.051,
              "y": 28.727,
              "z": 0.98
            },
            "rightCorner": {
              "x": 16.552,
              "y": 28.691,
              "z": 0.98
            },
            "gtin": "4062139026524",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468b8",
        "height": 1.2565,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a213d5",
            "leftCorner": {
              "x": 15.201,
              "y": 28.709,
              "z": 1.028
            },
            "rightCorner": {
              "x": 15.272,
              "y": 28.704,
              "z": 1.028
            },
            "gtin": "4062139025671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213d6",
            "leftCorner": {
              "x": 15.272,
              "y": 28.704,
              "z": 1.028
            },
            "rightCorner": {
              "x": 15.342,
              "y": 28.699,
              "z": 1.028
            },
            "gtin": "4062139025671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213d9",
            "leftCorner": {
              "x": 15.344,
              "y": 28.73,
              "z": 1.028
            },
            "rightCorner": {
              "x": 15.533,
              "y": 28.717,
              "z": 1.028
            },
            "gtin": "4062139025688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213da",
            "leftCorner": {
              "x": 15.533,
              "y": 28.717,
              "z": 1.028
            },
            "rightCorner": {
              "x": 15.72,
              "y": 28.703,
              "z": 1.028
            },
            "gtin": "4062139025688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213db",
            "leftCorner": {
              "x": 15.72,
              "y": 28.703,
              "z": 1.028
            },
            "rightCorner": {
              "x": 15.908,
              "y": 28.689,
              "z": 1.028
            },
            "gtin": "4062139025688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213d7",
            "leftCorner": {
              "x": 15.909,
              "y": 28.72,
              "z": 1.028
            },
            "rightCorner": {
              "x": 16.231,
              "y": 28.697,
              "z": 1.028
            },
            "gtin": "4062139025251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213d8",
            "leftCorner": {
              "x": 16.231,
              "y": 28.697,
              "z": 1.028
            },
            "rightCorner": {
              "x": 16.551,
              "y": 28.674,
              "z": 1.028
            },
            "gtin": "4062139025251",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468b9",
        "height": 1.6555,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a213dc",
            "leftCorner": {
              "x": 15.2,
              "y": 28.704,
              "z": 1.355
            },
            "rightCorner": {
              "x": 15.35,
              "y": 28.693,
              "z": 1.355
            },
            "gtin": "4062139025671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213e2",
            "leftCorner": {
              "x": 15.353,
              "y": 28.734,
              "z": 1.355
            },
            "rightCorner": {
              "x": 15.539,
              "y": 28.72,
              "z": 1.355
            },
            "gtin": "4062139025688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213e3",
            "leftCorner": {
              "x": 15.539,
              "y": 28.72,
              "z": 1.355
            },
            "rightCorner": {
              "x": 15.726,
              "y": 28.708,
              "z": 1.355
            },
            "gtin": "4062139025688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213e4",
            "leftCorner": {
              "x": 15.726,
              "y": 28.708,
              "z": 1.355
            },
            "rightCorner": {
              "x": 15.913,
              "y": 28.694,
              "z": 1.355
            },
            "gtin": "4062139025688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213dd",
            "leftCorner": {
              "x": 15.914,
              "y": 28.712,
              "z": 1.355
            },
            "rightCorner": {
              "x": 16.042,
              "y": 28.703,
              "z": 1.355
            },
            "gtin": "4062139025251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213de",
            "leftCorner": {
              "x": 16.042,
              "y": 28.703,
              "z": 1.355
            },
            "rightCorner": {
              "x": 16.169,
              "y": 28.694,
              "z": 1.355
            },
            "gtin": "4062139025251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213df",
            "leftCorner": {
              "x": 16.169,
              "y": 28.694,
              "z": 1.355
            },
            "rightCorner": {
              "x": 16.296,
              "y": 28.685,
              "z": 1.355
            },
            "gtin": "4062139025251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213e0",
            "leftCorner": {
              "x": 16.296,
              "y": 28.685,
              "z": 1.355
            },
            "rightCorner": {
              "x": 16.424,
              "y": 28.676,
              "z": 1.355
            },
            "gtin": "4062139025251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213e1",
            "leftCorner": {
              "x": 16.424,
              "y": 28.676,
              "z": 1.355
            },
            "rightCorner": {
              "x": 16.551,
              "y": 28.666,
              "z": 1.355
            },
            "gtin": "4062139025251",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a93",
    "rightNeighborShelfId": "34a95"
  },
  {
    "id": "34a95",
    "name": "34a95",
    "x": 16.537,
    "y": 28.468,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.035676,
      "w": 0.99936
    },

    "layers": [],
    "leftNeighborShelfId": "34a94",
    "rightNeighborShelfId": "34a96"
  },
  {
    "id": "34a96",
    "name": "34a96",
    "x": 17.883,
    "y": 28.372,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.035676,
      "w": 0.99936
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 10
    },
    "layers": [
      {
        "id": "682ffddfd15af3232a5469c2",
        "height": 1.1919,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21878",
            "leftCorner": {
              "x": 17.896,
              "y": 28.542,
              "z": 0.975
            },
            "rightCorner": {
              "x": 17.999,
              "y": 28.534,
              "z": 0.975
            },
            "gtin": "4062139025435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2187a",
            "leftCorner": {
              "x": 18.002,
              "y": 28.567,
              "z": 0.975
            },
            "rightCorner": {
              "x": 18.872,
              "y": 28.505,
              "z": 0.975
            },
            "gtin": "4062139025442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21879",
            "leftCorner": {
              "x": 18.872,
              "y": 28.5,
              "z": 0.975
            },
            "rightCorner": {
              "x": 19.244,
              "y": 28.473,
              "z": 0.975
            },
            "gtin": "4062139025343",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469c3",
        "height": 1.2533,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2187b",
            "leftCorner": {
              "x": 17.895,
              "y": 28.535,
              "z": 1.025
            },
            "rightCorner": {
              "x": 18.18,
              "y": 28.514,
              "z": 1.025
            }
          },
          {
            "id": "68300c8b5ed67a01d9a2187c",
            "leftCorner": {
              "x": 18.18,
              "y": 28.514,
              "z": 1.025
            },
            "rightCorner": {
              "x": 18.466,
              "y": 28.494,
              "z": 1.025
            }
          },
          {
            "id": "68300c8b5ed67a01d9a2187d",
            "leftCorner": {
              "x": 18.466,
              "y": 28.494,
              "z": 1.025
            },
            "rightCorner": {
              "x": 18.751,
              "y": 28.473,
              "z": 1.025
            }
          },
          {
            "id": "68300c8b5ed67a01d9a2187e",
            "leftCorner": {
              "x": 18.754,
              "y": 28.511,
              "z": 1.025
            },
            "rightCorner": {
              "x": 18.918,
              "y": 28.499,
              "z": 1.025
            },
            "gtin": "4062139025336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2187f",
            "leftCorner": {
              "x": 18.918,
              "y": 28.499,
              "z": 1.025
            },
            "rightCorner": {
              "x": 19.081,
              "y": 28.488,
              "z": 1.025
            },
            "gtin": "4062139025336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21880",
            "leftCorner": {
              "x": 19.081,
              "y": 28.488,
              "z": 1.025
            },
            "rightCorner": {
              "x": 19.244,
              "y": 28.475,
              "z": 1.025
            },
            "gtin": "4062139025336",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469c1",
        "height": 1.6639,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21874",
            "leftCorner": {
              "x": 17.896,
              "y": 28.549,
              "z": 1.361
            },
            "rightCorner": {
              "x": 18.129,
              "y": 28.532,
              "z": 1.361
            },
            "gtin": "4004980404007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21875",
            "leftCorner": {
              "x": 18.129,
              "y": 28.532,
              "z": 1.361
            },
            "rightCorner": {
              "x": 18.361,
              "y": 28.515,
              "z": 1.361
            },
            "gtin": "4004980404007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21876",
            "leftCorner": {
              "x": 18.361,
              "y": 28.515,
              "z": 1.361
            },
            "rightCorner": {
              "x": 18.593,
              "y": 28.498,
              "z": 1.361
            },
            "gtin": "4004980404007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21877",
            "leftCorner": {
              "x": 18.595,
              "y": 28.531,
              "z": 1.361
            },
            "rightCorner": {
              "x": 19.245,
              "y": 28.485,
              "z": 1.361
            },
            "gtin": "4004980401907",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a95",
    "rightNeighborShelfId": "34a97"
  },
  {
    "id": "34a97",
    "name": "34a97",
    "x": 19.23,
    "y": 28.276,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.035676,
      "w": 0.99936
    },

    "layers": [],
    "leftNeighborShelfId": "34a96"
  },
  {
    "id": "34a98",
    "name": "34a98",
    "x": 19.352,
    "y": 30.549,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99958,
      "w": 0.029134
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 14
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5468be",
        "height": 1.1016,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a213f9",
            "leftCorner": {
              "x": 19.345,
              "y": 30.419,
              "z": 0.901
            },
            "rightCorner": {
              "x": 18.601,
              "y": 30.462,
              "z": 0.901
            },
            "gtin": "4003586104137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213fa",
            "leftCorner": {
              "x": 18.599,
              "y": 30.434,
              "z": 0.901
            },
            "rightCorner": {
              "x": 17.996,
              "y": 30.47,
              "z": 0.901
            },
            "gtin": "4003586104038",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468bf",
        "height": 1.1586,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a213ee",
            "leftCorner": {
              "x": 19.291,
              "y": 30.365,
              "z": 0.948
            },
            "rightCorner": {
              "x": 18.801,
              "y": 30.394,
              "z": 0.948
            },
            "gtin": "4003586105196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213ef",
            "leftCorner": {
              "x": 18.801,
              "y": 30.394,
              "z": 0.948
            },
            "rightCorner": {
              "x": 18.31,
              "y": 30.423,
              "z": 0.948
            },
            "gtin": "4003586105196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213eb",
            "leftCorner": {
              "x": 18.31,
              "y": 30.419,
              "z": 0.948
            },
            "rightCorner": {
              "x": 17.993,
              "y": 30.438,
              "z": 0.948
            },
            "gtin": "4003586105196",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468bd",
        "height": 1.7063,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a213f4",
            "leftCorner": {
              "x": 19.356,
              "y": 30.366,
              "z": 1.396
            },
            "rightCorner": {
              "x": 19.115,
              "y": 30.38,
              "z": 1.396
            },
            "gtin": "4003586105738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213f0",
            "leftCorner": {
              "x": 19.344,
              "y": 30.403,
              "z": 1.396
            },
            "rightCorner": {
              "x": 18.9,
              "y": 30.428,
              "z": 1.396
            },
            "gtin": "4003586105738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213f5",
            "leftCorner": {
              "x": 19.115,
              "y": 30.38,
              "z": 1.396
            },
            "rightCorner": {
              "x": 18.874,
              "y": 30.395,
              "z": 1.396
            },
            "gtin": "4003586105738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213f1",
            "leftCorner": {
              "x": 18.9,
              "y": 30.428,
              "z": 1.396
            },
            "rightCorner": {
              "x": 18.455,
              "y": 30.454,
              "z": 1.396
            },
            "gtin": "4003586105738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213f6",
            "leftCorner": {
              "x": 18.874,
              "y": 30.395,
              "z": 1.396
            },
            "rightCorner": {
              "x": 18.634,
              "y": 30.409,
              "z": 1.396
            },
            "gtin": "4003586105738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213f7",
            "leftCorner": {
              "x": 18.632,
              "y": 30.392,
              "z": 1.396
            },
            "rightCorner": {
              "x": 18.434,
              "y": 30.403,
              "z": 1.396
            },
            "gtin": "4003586105738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213f2",
            "leftCorner": {
              "x": 18.455,
              "y": 30.454,
              "z": 1.396
            },
            "rightCorner": {
              "x": 18.01,
              "y": 30.48,
              "z": 1.396
            },
            "gtin": "4003586105738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213f8",
            "leftCorner": {
              "x": 18.434,
              "y": 30.403,
              "z": 1.396
            },
            "rightCorner": {
              "x": 18.234,
              "y": 30.415,
              "z": 1.396
            },
            "gtin": "4003586105738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213f3",
            "leftCorner": {
              "x": 18.235,
              "y": 30.426,
              "z": 1.396
            },
            "rightCorner": {
              "x": 17.994,
              "y": 30.44,
              "z": 1.396
            },
            "gtin": "4063367230370",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a8f",
    "rightNeighborShelfId": "34a99"
  },
  {
    "id": "34a99",
    "name": "34a99",
    "x": 18.004,
    "y": 30.628,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99958,
      "w": 0.029134
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 20
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5468c2",
        "height": 1.1012,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21462",
            "leftCorner": {
              "x": 17.286,
              "y": 30.491,
              "z": 0.901
            },
            "rightCorner": {
              "x": 17.04,
              "y": 30.505,
              "z": 0.901
            },
            "gtin": "4014741621031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21463",
            "leftCorner": {
              "x": 17.04,
              "y": 30.514,
              "z": 0.901
            },
            "rightCorner": {
              "x": 16.827,
              "y": 30.527,
              "z": 0.901
            },
            "gtin": "4014741622038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21464",
            "leftCorner": {
              "x": 16.827,
              "y": 30.526,
              "z": 0.901
            },
            "rightCorner": {
              "x": 16.661,
              "y": 30.536,
              "z": 0.901
            },
            "gtin": "4014741623035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2145f",
            "leftCorner": {
              "x": 17.995,
              "y": 30.489,
              "z": 0.901
            },
            "rightCorner": {
              "x": 17.74,
              "y": 30.504,
              "z": 0.901
            },
            "gtin": "4014741621031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21461",
            "leftCorner": {
              "x": 17.738,
              "y": 30.467,
              "z": 0.901
            },
            "rightCorner": {
              "x": 17.286,
              "y": 30.492,
              "z": 0.901
            },
            "gtin": "4014741622038",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468c0",
        "height": 1.1611,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a213fb",
            "leftCorner": {
              "x": 17.995,
              "y": 30.484,
              "z": 0.95
            },
            "rightCorner": {
              "x": 17.559,
              "y": 30.509,
              "z": 0.95
            },
            "gtin": "4018077004285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213fd",
            "leftCorner": {
              "x": 17.557,
              "y": 30.469,
              "z": 0.95
            },
            "rightCorner": {
              "x": 17.374,
              "y": 30.48,
              "z": 0.95
            },
            "gtin": "4018077004469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213fe",
            "leftCorner": {
              "x": 17.374,
              "y": 30.48,
              "z": 0.95
            },
            "rightCorner": {
              "x": 17.191,
              "y": 30.491,
              "z": 0.95
            },
            "gtin": "4018077004469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213ff",
            "leftCorner": {
              "x": 17.191,
              "y": 30.498,
              "z": 0.95
            },
            "rightCorner": {
              "x": 17.095,
              "y": 30.503,
              "z": 0.95
            },
            "gtin": "4003586101389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21400",
            "leftCorner": {
              "x": 17.095,
              "y": 30.503,
              "z": 0.95
            },
            "rightCorner": {
              "x": 16.999,
              "y": 30.509,
              "z": 0.95
            },
            "gtin": "4003586101389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21401",
            "leftCorner": {
              "x": 16.999,
              "y": 30.509,
              "z": 0.95
            },
            "rightCorner": {
              "x": 16.903,
              "y": 30.514,
              "z": 0.95
            },
            "gtin": "4003586101389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21402",
            "leftCorner": {
              "x": 16.903,
              "y": 30.508,
              "z": 0.95
            },
            "rightCorner": {
              "x": 16.619,
              "y": 30.525,
              "z": 0.95
            },
            "gtin": "4003586101723",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468c1",
        "height": 1.7074,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21422",
            "leftCorner": {
              "x": 17.995,
              "y": 30.494,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.741,
              "y": 30.51,
              "z": 1.397
            },
            "gtin": "4018077004117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21423",
            "leftCorner": {
              "x": 17.741,
              "y": 30.51,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.488,
              "y": 30.524,
              "z": 1.397
            },
            "gtin": "4018077004117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21425",
            "leftCorner": {
              "x": 17.485,
              "y": 30.481,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.331,
              "y": 30.49,
              "z": 1.397
            },
            "gtin": "4062139005888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21426",
            "leftCorner": {
              "x": 17.331,
              "y": 30.49,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.176,
              "y": 30.499,
              "z": 1.397
            },
            "gtin": "4062139005888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21427",
            "leftCorner": {
              "x": 17.177,
              "y": 30.502,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.023,
              "y": 30.512,
              "z": 1.397
            },
            "gtin": "4062139005963",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21428",
            "leftCorner": {
              "x": 17.023,
              "y": 30.512,
              "z": 1.397
            },
            "rightCorner": {
              "x": 16.87,
              "y": 30.521,
              "z": 1.397
            },
            "gtin": "4062139005963",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21429",
            "leftCorner": {
              "x": 16.87,
              "y": 30.536,
              "z": 1.397
            },
            "rightCorner": {
              "x": 16.724,
              "y": 30.544,
              "z": 1.397
            },
            "gtin": "4062139003136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2142a",
            "leftCorner": {
              "x": 16.724,
              "y": 30.543,
              "z": 1.397
            },
            "rightCorner": {
              "x": 16.632,
              "y": 30.548,
              "z": 1.397
            },
            "gtin": "4062139005864",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a98",
    "rightNeighborShelfId": "34a9a"
  },
  {
    "id": "34a9a",
    "name": "34a9a",
    "x": 16.656,
    "y": 30.706,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99958,
      "w": 0.029134
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 24
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5468c5",
        "height": 1.102,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21465",
            "leftCorner": {
              "x": 16.66,
              "y": 30.527,
              "z": 0.902
            },
            "rightCorner": {
              "x": 16.403,
              "y": 30.541,
              "z": 0.902
            },
            "gtin": "4260126428843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21466",
            "leftCorner": {
              "x": 16.403,
              "y": 30.534,
              "z": 0.902
            },
            "rightCorner": {
              "x": 16.174,
              "y": 30.547,
              "z": 0.902
            },
            "gtin": "4104720022284",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21467",
            "leftCorner": {
              "x": 16.174,
              "y": 30.548,
              "z": 0.902
            },
            "rightCorner": {
              "x": 15.898,
              "y": 30.564,
              "z": 0.902
            },
            "gtin": "4260126428805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21468",
            "leftCorner": {
              "x": 15.898,
              "y": 30.555,
              "z": 0.902
            },
            "rightCorner": {
              "x": 15.729,
              "y": 30.564,
              "z": 0.902
            },
            "gtin": "4009286151266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21469",
            "leftCorner": {
              "x": 15.729,
              "y": 30.56,
              "z": 0.902
            },
            "rightCorner": {
              "x": 15.465,
              "y": 30.576,
              "z": 0.902
            },
            "gtin": "4009286151273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21460",
            "leftCorner": {
              "x": 15.465,
              "y": 30.577,
              "z": 0.902
            },
            "rightCorner": {
              "x": 15.297,
              "y": 30.587,
              "z": 0.902
            },
            "gtin": "4009286151259",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468c6",
        "height": 1.1568,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21403",
            "leftCorner": {
              "x": 16.619,
              "y": 30.52,
              "z": 0.946
            },
            "rightCorner": {
              "x": 16.272,
              "y": 30.541,
              "z": 0.946
            },
            "gtin": "4003586104038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21404",
            "leftCorner": {
              "x": 16.272,
              "y": 30.541,
              "z": 0.946
            },
            "rightCorner": {
              "x": 15.927,
              "y": 30.561,
              "z": 0.946
            },
            "gtin": "4003586104038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21405",
            "leftCorner": {
              "x": 15.927,
              "y": 30.56,
              "z": 0.946
            },
            "rightCorner": {
              "x": 15.681,
              "y": 30.574,
              "z": 0.946
            },
            "gtin": "3036810201280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21406",
            "leftCorner": {
              "x": 15.681,
              "y": 30.574,
              "z": 0.946
            },
            "rightCorner": {
              "x": 15.435,
              "y": 30.588,
              "z": 0.946
            },
            "gtin": "3036810201280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21407",
            "leftCorner": {
              "x": 15.435,
              "y": 30.588,
              "z": 0.946
            },
            "rightCorner": {
              "x": 15.19,
              "y": 30.603,
              "z": 0.946
            },
            "gtin": "3036810201280",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468c3",
        "height": 1.7025,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2142b",
            "leftCorner": {
              "x": 16.63,
              "y": 30.515,
              "z": 1.393
            },
            "rightCorner": {
              "x": 16.406,
              "y": 30.528,
              "z": 1.393
            },
            "gtin": "4003586105127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2142c",
            "leftCorner": {
              "x": 16.406,
              "y": 30.528,
              "z": 1.393
            },
            "rightCorner": {
              "x": 16.182,
              "y": 30.541,
              "z": 1.393
            },
            "gtin": "4003586105127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2142d",
            "leftCorner": {
              "x": 16.182,
              "y": 30.541,
              "z": 1.393
            },
            "rightCorner": {
              "x": 15.96,
              "y": 30.554,
              "z": 1.393
            },
            "gtin": "4003586105127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2142e",
            "leftCorner": {
              "x": 15.96,
              "y": 30.557,
              "z": 1.393
            },
            "rightCorner": {
              "x": 15.836,
              "y": 30.564,
              "z": 1.393
            },
            "gtin": "4260380782071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2142f",
            "leftCorner": {
              "x": 15.836,
              "y": 30.565,
              "z": 1.393
            },
            "rightCorner": {
              "x": 15.691,
              "y": 30.574,
              "z": 1.393
            },
            "gtin": "4337185741951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21430",
            "leftCorner": {
              "x": 15.691,
              "y": 30.568,
              "z": 1.393
            },
            "rightCorner": {
              "x": 15.629,
              "y": 30.572,
              "z": 1.393
            },
            "gtin": "8445291253001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21431",
            "leftCorner": {
              "x": 15.629,
              "y": 30.572,
              "z": 1.393
            },
            "rightCorner": {
              "x": 15.567,
              "y": 30.575,
              "z": 1.393
            },
            "gtin": "8445291253001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21432",
            "leftCorner": {
              "x": 15.567,
              "y": 30.575,
              "z": 1.393
            },
            "rightCorner": {
              "x": 15.506,
              "y": 30.579,
              "z": 1.393
            },
            "gtin": "8445291253001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21433",
            "leftCorner": {
              "x": 15.506,
              "y": 30.579,
              "z": 1.393
            },
            "rightCorner": {
              "x": 15.444,
              "y": 30.582,
              "z": 1.393
            },
            "gtin": "8445291253001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21434",
            "leftCorner": {
              "x": 15.444,
              "y": 30.582,
              "z": 1.393
            },
            "rightCorner": {
              "x": 15.382,
              "y": 30.586,
              "z": 1.393
            },
            "gtin": "8445291253001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21435",
            "leftCorner": {
              "x": 15.381,
              "y": 30.57,
              "z": 1.393
            },
            "rightCorner": {
              "x": 15.326,
              "y": 30.573,
              "z": 1.393
            },
            "gtin": "8410066140589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21436",
            "leftCorner": {
              "x": 15.326,
              "y": 30.573,
              "z": 1.393
            },
            "rightCorner": {
              "x": 15.272,
              "y": 30.576,
              "z": 1.393
            },
            "gtin": "8410066140589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21437",
            "leftCorner": {
              "x": 15.272,
              "y": 30.576,
              "z": 1.393
            },
            "rightCorner": {
              "x": 15.217,
              "y": 30.579,
              "z": 1.393
            },
            "gtin": "8410066140589",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a99",
    "rightNeighborShelfId": "34a9b"
  },
  {
    "id": "34a9b",
    "name": "34a9b",
    "x": 15.309,
    "y": 30.785,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99958,
      "w": 0.029134
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 32
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5468ca",
        "height": 1.0854,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2146a",
            "leftCorner": {
              "x": 15.3,
              "y": 30.634,
              "z": 0.888
            },
            "rightCorner": {
              "x": 14.841,
              "y": 30.661,
              "z": 0.888
            },
            "gtin": "4027400148008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2146c",
            "leftCorner": {
              "x": 14.838,
              "y": 30.623,
              "z": 0.888
            },
            "rightCorner": {
              "x": 14.538,
              "y": 30.64,
              "z": 0.888
            },
            "gtin": "4027400148039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2146d",
            "leftCorner": {
              "x": 14.538,
              "y": 30.638,
              "z": 0.888
            },
            "rightCorner": {
              "x": 14.374,
              "y": 30.647,
              "z": 0.888
            },
            "gtin": "8715700411224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2146e",
            "leftCorner": {
              "x": 14.375,
              "y": 30.642,
              "z": 0.888
            },
            "rightCorner": {
              "x": 14.238,
              "y": 30.65,
              "z": 0.888
            },
            "gtin": "8715700115801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2146f",
            "leftCorner": {
              "x": 14.238,
              "y": 30.658,
              "z": 0.888
            },
            "rightCorner": {
              "x": 14.055,
              "y": 30.668,
              "z": 0.888
            },
            "gtin": "8715700122205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2146b",
            "leftCorner": {
              "x": 14.055,
              "y": 30.667,
              "z": 0.888
            },
            "rightCorner": {
              "x": 13.95,
              "y": 30.673,
              "z": 0.888
            },
            "gtin": "8715700411194",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468c8",
        "height": 1.1537,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21408",
            "leftCorner": {
              "x": 15.189,
              "y": 30.603,
              "z": 0.944
            },
            "rightCorner": {
              "x": 15.109,
              "y": 30.607,
              "z": 0.944
            },
            "gtin": "4030800079629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21409",
            "leftCorner": {
              "x": 15.109,
              "y": 30.607,
              "z": 0.944
            },
            "rightCorner": {
              "x": 15.029,
              "y": 30.612,
              "z": 0.944
            },
            "gtin": "4030800079629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2140a",
            "leftCorner": {
              "x": 15.03,
              "y": 30.601,
              "z": 0.944
            },
            "rightCorner": {
              "x": 14.928,
              "y": 30.607,
              "z": 0.944
            },
            "gtin": "4030800082018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2140b",
            "leftCorner": {
              "x": 14.928,
              "y": 30.607,
              "z": 0.944
            },
            "rightCorner": {
              "x": 14.827,
              "y": 30.613,
              "z": 0.944
            },
            "gtin": "4030800082018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2140c",
            "leftCorner": {
              "x": 14.827,
              "y": 30.618,
              "z": 0.944
            },
            "rightCorner": {
              "x": 14.667,
              "y": 30.627,
              "z": 0.944
            },
            "gtin": "4030800079667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2140d",
            "leftCorner": {
              "x": 14.667,
              "y": 30.627,
              "z": 0.944
            },
            "rightCorner": {
              "x": 14.508,
              "y": 30.636,
              "z": 0.944
            },
            "gtin": "4030800079667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2140e",
            "leftCorner": {
              "x": 14.508,
              "y": 30.638,
              "z": 0.944
            },
            "rightCorner": {
              "x": 14.318,
              "y": 30.65,
              "z": 0.944
            },
            "gtin": "1220000450165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2140f",
            "leftCorner": {
              "x": 14.319,
              "y": 30.652,
              "z": 0.944
            },
            "rightCorner": {
              "x": 14.104,
              "y": 30.665,
              "z": 0.944
            },
            "gtin": "1220000450189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21410",
            "leftCorner": {
              "x": 14.104,
              "y": 30.662,
              "z": 0.944
            },
            "rightCorner": {
              "x": 14.009,
              "y": 30.668,
              "z": 0.944
            },
            "gtin": "1220000450202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21411",
            "leftCorner": {
              "x": 14.009,
              "y": 30.668,
              "z": 0.944
            },
            "rightCorner": {
              "x": 13.913,
              "y": 30.674,
              "z": 0.944
            },
            "gtin": "1220000450202",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468c7",
        "height": 1.7087,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21438",
            "leftCorner": {
              "x": 15.218,
              "y": 30.595,
              "z": 1.398
            },
            "rightCorner": {
              "x": 15.158,
              "y": 30.599,
              "z": 1.398
            },
            "gtin": "4030800079629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21439",
            "leftCorner": {
              "x": 15.158,
              "y": 30.599,
              "z": 1.398
            },
            "rightCorner": {
              "x": 15.098,
              "y": 30.602,
              "z": 1.398
            },
            "gtin": "4030800079629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2143a",
            "leftCorner": {
              "x": 15.098,
              "y": 30.602,
              "z": 1.398
            },
            "rightCorner": {
              "x": 15.039,
              "y": 30.606,
              "z": 1.398
            },
            "gtin": "4030800079629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2143b",
            "leftCorner": {
              "x": 15.039,
              "y": 30.608,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.954,
              "y": 30.613,
              "z": 1.398
            },
            "gtin": "4030800082018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2143c",
            "leftCorner": {
              "x": 14.954,
              "y": 30.613,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.87,
              "y": 30.618,
              "z": 1.398
            },
            "gtin": "4030800082018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2143d",
            "leftCorner": {
              "x": 14.87,
              "y": 30.618,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.785,
              "y": 30.623,
              "z": 1.398
            },
            "gtin": "4030800082018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2143e",
            "leftCorner": {
              "x": 14.786,
              "y": 30.627,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.7,
              "y": 30.632,
              "z": 1.398
            },
            "gtin": "4030800079667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2143f",
            "leftCorner": {
              "x": 14.7,
              "y": 30.632,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.614,
              "y": 30.637,
              "z": 1.398
            },
            "gtin": "4030800079667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21440",
            "leftCorner": {
              "x": 14.614,
              "y": 30.637,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.527,
              "y": 30.642,
              "z": 1.398
            },
            "gtin": "4030800079667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21441",
            "leftCorner": {
              "x": 14.528,
              "y": 30.637,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.453,
              "y": 30.642,
              "z": 1.398
            },
            "gtin": "1220000450165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21442",
            "leftCorner": {
              "x": 14.453,
              "y": 30.642,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.379,
              "y": 30.646,
              "z": 1.398
            },
            "gtin": "1220000450165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21443",
            "leftCorner": {
              "x": 14.379,
              "y": 30.646,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.306,
              "y": 30.65,
              "z": 1.398
            },
            "gtin": "1220000450165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21444",
            "leftCorner": {
              "x": 14.306,
              "y": 30.658,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.208,
              "y": 30.663,
              "z": 1.398
            },
            "gtin": "1220000450189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21445",
            "leftCorner": {
              "x": 14.208,
              "y": 30.663,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.109,
              "y": 30.669,
              "z": 1.398
            },
            "gtin": "1220000450189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21446",
            "leftCorner": {
              "x": 14.109,
              "y": 30.667,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.002,
              "y": 30.674,
              "z": 1.398
            },
            "gtin": "1220000450202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21447",
            "leftCorner": {
              "x": 14.002,
              "y": 30.674,
              "z": 1.398
            },
            "rightCorner": {
              "x": 13.895,
              "y": 30.68,
              "z": 1.398
            },
            "gtin": "1220000450202",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a9a",
    "rightNeighborShelfId": "34a9c"
  },
  {
    "id": "34a9c",
    "name": "34a9c",
    "x": 13.961,
    "y": 30.864,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99958,
      "w": 0.029134
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 26
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5468cd",
        "height": 1.0995,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21470",
            "leftCorner": {
              "x": 13.952,
              "y": 30.71,
              "z": 0.9
            },
            "rightCorner": {
              "x": 13.63,
              "y": 30.729,
              "z": 0.9
            },
            "gtin": "4009286151426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21472",
            "leftCorner": {
              "x": 13.628,
              "y": 30.688,
              "z": 0.9
            },
            "rightCorner": {
              "x": 13.465,
              "y": 30.697,
              "z": 0.9
            },
            "gtin": "4009286151402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21473",
            "leftCorner": {
              "x": 13.465,
              "y": 30.703,
              "z": 0.9
            },
            "rightCorner": {
              "x": 13.238,
              "y": 30.717,
              "z": 0.9
            },
            "gtin": "4009286151419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21474",
            "leftCorner": {
              "x": 13.237,
              "y": 30.699,
              "z": 0.9
            },
            "rightCorner": {
              "x": 13.058,
              "y": 30.709,
              "z": 0.9
            },
            "gtin": "4104720020334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21475",
            "leftCorner": {
              "x": 13.059,
              "y": 30.717,
              "z": 0.9
            },
            "rightCorner": {
              "x": 12.823,
              "y": 30.731,
              "z": 0.9
            },
            "gtin": "4104720020341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21476",
            "leftCorner": {
              "x": 12.824,
              "y": 30.745,
              "z": 0.9
            },
            "rightCorner": {
              "x": 12.547,
              "y": 30.761,
              "z": 0.9
            },
            "gtin": "4104720020327",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468cc",
        "height": 1.1609,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21412",
            "leftCorner": {
              "x": 13.913,
              "y": 30.673,
              "z": 0.95
            },
            "rightCorner": {
              "x": 13.584,
              "y": 30.692,
              "z": 0.95
            },
            "gtin": "4030800079643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21413",
            "leftCorner": {
              "x": 13.584,
              "y": 30.678,
              "z": 0.95
            },
            "rightCorner": {
              "x": 13.376,
              "y": 30.691,
              "z": 0.95
            },
            "gtin": "4030800082032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21414",
            "leftCorner": {
              "x": 13.376,
              "y": 30.691,
              "z": 0.95
            },
            "rightCorner": {
              "x": 13.168,
              "y": 30.702,
              "z": 0.95
            },
            "gtin": "4030800082032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21415",
            "leftCorner": {
              "x": 13.169,
              "y": 30.706,
              "z": 0.95
            },
            "rightCorner": {
              "x": 12.981,
              "y": 30.717,
              "z": 0.95
            },
            "gtin": "4400139019953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21416",
            "leftCorner": {
              "x": 12.982,
              "y": 30.734,
              "z": 0.95
            },
            "rightCorner": {
              "x": 12.852,
              "y": 30.742,
              "z": 0.95
            },
            "gtin": "4400139018024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21417",
            "leftCorner": {
              "x": 12.852,
              "y": 30.743,
              "z": 0.95
            },
            "rightCorner": {
              "x": 12.71,
              "y": 30.752,
              "z": 0.95
            },
            "gtin": "4400139017904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21418",
            "leftCorner": {
              "x": 12.71,
              "y": 30.752,
              "z": 0.95
            },
            "rightCorner": {
              "x": 12.567,
              "y": 30.76,
              "z": 0.95
            },
            "gtin": "4400139017904",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468cb",
        "height": 1.7068,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21448",
            "leftCorner": {
              "x": 13.893,
              "y": 30.658,
              "z": 1.396
            },
            "rightCorner": {
              "x": 13.793,
              "y": 30.664,
              "z": 1.396
            },
            "gtin": "4030800079643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21449",
            "leftCorner": {
              "x": 13.793,
              "y": 30.664,
              "z": 1.396
            },
            "rightCorner": {
              "x": 13.694,
              "y": 30.67,
              "z": 1.396
            },
            "gtin": "4030800079643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2144a",
            "leftCorner": {
              "x": 13.694,
              "y": 30.67,
              "z": 1.396
            },
            "rightCorner": {
              "x": 13.594,
              "y": 30.676,
              "z": 1.396
            },
            "gtin": "4030800079643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2144b",
            "leftCorner": {
              "x": 13.594,
              "y": 30.684,
              "z": 1.396
            },
            "rightCorner": {
              "x": 13.455,
              "y": 30.692,
              "z": 1.396
            },
            "gtin": "4030800082032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2144c",
            "leftCorner": {
              "x": 13.455,
              "y": 30.692,
              "z": 1.396
            },
            "rightCorner": {
              "x": 13.314,
              "y": 30.7,
              "z": 1.396
            },
            "gtin": "4030800082032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2144d",
            "leftCorner": {
              "x": 13.314,
              "y": 30.7,
              "z": 1.396
            },
            "rightCorner": {
              "x": 13.174,
              "y": 30.708,
              "z": 1.396
            },
            "gtin": "4030800082032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2144e",
            "leftCorner": {
              "x": 13.175,
              "y": 30.716,
              "z": 1.396
            },
            "rightCorner": {
              "x": 13.068,
              "y": 30.722,
              "z": 1.396
            },
            "gtin": "4009286150085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2144f",
            "leftCorner": {
              "x": 13.068,
              "y": 30.722,
              "z": 1.396
            },
            "rightCorner": {
              "x": 12.961,
              "y": 30.728,
              "z": 1.396
            },
            "gtin": "4009286150085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21450",
            "leftCorner": {
              "x": 12.961,
              "y": 30.734,
              "z": 1.396
            },
            "rightCorner": {
              "x": 12.809,
              "y": 30.743,
              "z": 1.396
            },
            "gtin": "4009286150009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21451",
            "leftCorner": {
              "x": 12.809,
              "y": 30.747,
              "z": 1.396
            },
            "rightCorner": {
              "x": 12.736,
              "y": 30.751,
              "z": 1.396
            },
            "gtin": "4009286150962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21452",
            "leftCorner": {
              "x": 12.736,
              "y": 30.751,
              "z": 1.396
            },
            "rightCorner": {
              "x": 12.662,
              "y": 30.755,
              "z": 1.396
            },
            "gtin": "4009286150962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21453",
            "leftCorner": {
              "x": 12.662,
              "y": 30.755,
              "z": 1.396
            },
            "rightCorner": {
              "x": 12.588,
              "y": 30.76,
              "z": 1.396
            },
            "gtin": "4009286150962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21454",
            "leftCorner": {
              "x": 12.588,
              "y": 30.76,
              "z": 1.396
            },
            "rightCorner": {
              "x": 12.514,
              "y": 30.765,
              "z": 1.396
            },
            "gtin": "4009286150962",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a9b",
    "rightNeighborShelfId": "34a9d"
  },
  {
    "id": "34a9d",
    "name": "34a9d",
    "x": 12.613,
    "y": 30.942,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99958,
      "w": 0.029134
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 30
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5468d0",
        "height": 1.099,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21477",
            "leftCorner": {
              "x": 12.547,
              "y": 30.758,
              "z": 0.899
            },
            "rightCorner": {
              "x": 12.403,
              "y": 30.765,
              "z": 0.899
            },
            "gtin": "4104720021737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21478",
            "leftCorner": {
              "x": 12.403,
              "y": 30.77,
              "z": 0.899
            },
            "rightCorner": {
              "x": 12.239,
              "y": 30.779,
              "z": 0.899
            },
            "gtin": "4104720021713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21479",
            "leftCorner": {
              "x": 12.239,
              "y": 30.775,
              "z": 0.899
            },
            "rightCorner": {
              "x": 12.069,
              "y": 30.785,
              "z": 0.899
            },
            "gtin": "4104720021577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2147a",
            "leftCorner": {
              "x": 12.069,
              "y": 30.79,
              "z": 0.899
            },
            "rightCorner": {
              "x": 11.872,
              "y": 30.801,
              "z": 0.899
            },
            "gtin": "4104720021638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2147b",
            "leftCorner": {
              "x": 11.873,
              "y": 30.815,
              "z": 0.899
            },
            "rightCorner": {
              "x": 11.704,
              "y": 30.825,
              "z": 0.899
            },
            "gtin": "4002674242546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2147c",
            "leftCorner": {
              "x": 11.703,
              "y": 30.812,
              "z": 0.899
            },
            "rightCorner": {
              "x": 11.582,
              "y": 30.82,
              "z": 0.899
            },
            "gtin": "4002674288254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2147d",
            "leftCorner": {
              "x": 11.583,
              "y": 30.828,
              "z": 0.899
            },
            "rightCorner": {
              "x": 11.46,
              "y": 30.834,
              "z": 0.899
            },
            "gtin": "4002674286120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2147e",
            "leftCorner": {
              "x": 11.459,
              "y": 30.823,
              "z": 0.899
            },
            "rightCorner": {
              "x": 11.409,
              "y": 30.827,
              "z": 0.899
            },
            "gtin": "4002674129182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21471",
            "leftCorner": {
              "x": 11.409,
              "y": 30.836,
              "z": 0.899
            },
            "rightCorner": {
              "x": 11.254,
              "y": 30.844,
              "z": 0.899
            },
            "gtin": "4002674286021",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468cf",
        "height": 1.1575,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21419",
            "leftCorner": {
              "x": 12.566,
              "y": 30.75,
              "z": 0.947
            },
            "rightCorner": {
              "x": 12.475,
              "y": 30.756,
              "z": 0.947
            },
            "gtin": "810020935554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2141a",
            "leftCorner": {
              "x": 12.475,
              "y": 30.756,
              "z": 0.947
            },
            "rightCorner": {
              "x": 12.384,
              "y": 30.762,
              "z": 0.947
            },
            "gtin": "810020935554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2141b",
            "leftCorner": {
              "x": 12.384,
              "y": 30.76,
              "z": 0.947
            },
            "rightCorner": {
              "x": 12.256,
              "y": 30.767,
              "z": 0.947
            },
            "gtin": "810020935578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2141c",
            "leftCorner": {
              "x": 12.256,
              "y": 30.767,
              "z": 0.947
            },
            "rightCorner": {
              "x": 12.127,
              "y": 30.774,
              "z": 0.947
            },
            "gtin": "810020935578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2141d",
            "leftCorner": {
              "x": 12.126,
              "y": 30.768,
              "z": 0.947
            },
            "rightCorner": {
              "x": 11.886,
              "y": 30.782,
              "z": 0.947
            },
            "gtin": "810020935530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2141e",
            "leftCorner": {
              "x": 11.886,
              "y": 30.788,
              "z": 0.947
            },
            "rightCorner": {
              "x": 11.769,
              "y": 30.795,
              "z": 0.947
            },
            "gtin": "4250077903674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2141f",
            "leftCorner": {
              "x": 11.769,
              "y": 30.792,
              "z": 0.947
            },
            "rightCorner": {
              "x": 11.647,
              "y": 30.799,
              "z": 0.947
            },
            "gtin": "4260663732137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21420",
            "leftCorner": {
              "x": 11.647,
              "y": 30.797,
              "z": 0.947
            },
            "rightCorner": {
              "x": 11.502,
              "y": 30.806,
              "z": 0.947
            },
            "gtin": "4260663731369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21421",
            "leftCorner": {
              "x": 11.502,
              "y": 30.809,
              "z": 0.947
            },
            "rightCorner": {
              "x": 11.367,
              "y": 30.817,
              "z": 0.947
            },
            "gtin": "4260663731383",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a213fc",
            "leftCorner": {
              "x": 11.366,
              "y": 30.813,
              "z": 0.947
            },
            "rightCorner": {
              "x": 11.253,
              "y": 30.82,
              "z": 0.947
            },
            "gtin": "4260663731307",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468ce",
        "height": 1.7076,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21455",
            "leftCorner": {
              "x": 12.513,
              "y": 30.755,
              "z": 1.397
            },
            "rightCorner": {
              "x": 12.366,
              "y": 30.764,
              "z": 1.397
            },
            "gtin": "810020935554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21456",
            "leftCorner": {
              "x": 12.366,
              "y": 30.764,
              "z": 1.397
            },
            "rightCorner": {
              "x": 12.1,
              "y": 30.779,
              "z": 1.397
            },
            "gtin": "810020935578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21457",
            "leftCorner": {
              "x": 12.1,
              "y": 30.777,
              "z": 1.397
            },
            "rightCorner": {
              "x": 11.87,
              "y": 30.789,
              "z": 1.397
            },
            "gtin": "810020935530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21458",
            "leftCorner": {
              "x": 11.871,
              "y": 30.794,
              "z": 1.397
            },
            "rightCorner": {
              "x": 11.729,
              "y": 30.803,
              "z": 1.397
            },
            "gtin": "40198682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21459",
            "leftCorner": {
              "x": 11.729,
              "y": 30.798,
              "z": 1.397
            },
            "rightCorner": {
              "x": 11.681,
              "y": 30.8,
              "z": 1.397
            },
            "gtin": "40804934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2145a",
            "leftCorner": {
              "x": 11.681,
              "y": 30.8,
              "z": 1.397
            },
            "rightCorner": {
              "x": 11.631,
              "y": 30.803,
              "z": 1.397
            },
            "gtin": "40804934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2145b",
            "leftCorner": {
              "x": 11.631,
              "y": 30.794,
              "z": 1.397
            },
            "rightCorner": {
              "x": 11.555,
              "y": 30.798,
              "z": 1.397
            },
            "gtin": "40804972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2145c",
            "leftCorner": {
              "x": 11.555,
              "y": 30.798,
              "z": 1.397
            },
            "rightCorner": {
              "x": 11.48,
              "y": 30.803,
              "z": 1.397
            },
            "gtin": "40804972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2145d",
            "leftCorner": {
              "x": 11.48,
              "y": 30.816,
              "z": 1.397
            },
            "rightCorner": {
              "x": 11.418,
              "y": 30.819,
              "z": 1.397
            },
            "gtin": "40122694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2145e",
            "leftCorner": {
              "x": 11.418,
              "y": 30.819,
              "z": 1.397
            },
            "rightCorner": {
              "x": 11.356,
              "y": 30.822,
              "z": 1.397
            },
            "gtin": "40122694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21424",
            "leftCorner": {
              "x": 11.356,
              "y": 30.825,
              "z": 1.397
            },
            "rightCorner": {
              "x": 11.254,
              "y": 30.83,
              "z": 1.397
            },
            "gtin": "40122717",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a9c",
    "rightNeighborShelfId": "34a9e"
  },
  {
    "id": "34a9e",
    "name": "34a9e",
    "x": 11.266,
    "y": 31.021,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99958,
      "w": 0.029134
    },

    "layers": [],
    "leftNeighborShelfId": "34a9d",
    "rightNeighborShelfId": "34a9f"
  },
  {
    "id": "34a9f",
    "name": "34a9f",
    "x": 9.918,
    "y": 31.1,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99958,
      "w": 0.029134
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546597",
        "height": 1.0977,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fda0",
            "leftCorner": {
              "x": 9.226,
              "y": 30.94,
              "z": 0.898
            },
            "rightCorner": {
              "x": 9.122,
              "y": 30.947,
              "z": 0.898
            },
            "gtin": "42421122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd9d",
            "leftCorner": {
              "x": 9.909,
              "y": 30.943,
              "z": 0.898
            },
            "rightCorner": {
              "x": 9.427,
              "y": 30.971,
              "z": 0.898
            },
            "gtin": "4000339057825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd9f",
            "leftCorner": {
              "x": 9.425,
              "y": 30.93,
              "z": 0.898
            },
            "rightCorner": {
              "x": 9.226,
              "y": 30.941,
              "z": 0.898
            },
            "gtin": "7622300103569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fda1",
            "leftCorner": {
              "x": 9.123,
              "y": 30.952,
              "z": 0.898
            },
            "rightCorner": {
              "x": 8.909,
              "y": 30.965,
              "z": 0.898
            },
            "gtin": "4005500087038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fda2",
            "leftCorner": {
              "x": 8.909,
              "y": 30.959,
              "z": 0.898
            },
            "rightCorner": {
              "x": 8.757,
              "y": 30.968,
              "z": 0.898
            },
            "gtin": "40056012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fda3",
            "leftCorner": {
              "x": 8.757,
              "y": 30.973,
              "z": 0.898
            },
            "rightCorner": {
              "x": 8.654,
              "y": 30.978,
              "z": 0.898
            },
            "gtin": "40056142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd9e",
            "leftCorner": {
              "x": 8.654,
              "y": 30.982,
              "z": 0.898
            },
            "rightCorner": {
              "x": 8.559,
              "y": 30.988,
              "z": 0.898
            },
            "gtin": "4005500087762",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546599",
        "height": 1.1596,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fdab",
            "leftCorner": {
              "x": 9.909,
              "y": 30.94,
              "z": 0.949
            },
            "rightCorner": {
              "x": 9.761,
              "y": 30.949,
              "z": 0.949
            },
            "gtin": "7622202029868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdad",
            "leftCorner": {
              "x": 9.758,
              "y": 30.91,
              "z": 0.949
            },
            "rightCorner": {
              "x": 9.623,
              "y": 30.918,
              "z": 0.949
            },
            "gtin": "7622202029776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdae",
            "leftCorner": {
              "x": 9.623,
              "y": 30.918,
              "z": 0.949
            },
            "rightCorner": {
              "x": 9.487,
              "y": 30.925,
              "z": 0.949
            },
            "gtin": "7622202029776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdaf",
            "leftCorner": {
              "x": 9.487,
              "y": 30.925,
              "z": 0.949
            },
            "rightCorner": {
              "x": 9.351,
              "y": 30.934,
              "z": 0.949
            },
            "gtin": "7622202029776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdb0",
            "leftCorner": {
              "x": 9.351,
              "y": 30.939,
              "z": 0.949
            },
            "rightCorner": {
              "x": 9.234,
              "y": 30.946,
              "z": 0.949
            },
            "gtin": "7622201680206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdb1",
            "leftCorner": {
              "x": 9.233,
              "y": 30.937,
              "z": 0.949
            },
            "rightCorner": {
              "x": 9.078,
              "y": 30.946,
              "z": 0.949
            },
            "gtin": "4005500087113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdb2",
            "leftCorner": {
              "x": 9.079,
              "y": 30.956,
              "z": 0.949
            },
            "rightCorner": {
              "x": 8.849,
              "y": 30.969,
              "z": 0.949
            },
            "gtin": "4005500087120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdac",
            "leftCorner": {
              "x": 8.849,
              "y": 30.958,
              "z": 0.949
            },
            "rightCorner": {
              "x": 8.558,
              "y": 30.975,
              "z": 0.949
            },
            "gtin": "42421702",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546598",
        "height": 1.7187,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fda4",
            "leftCorner": {
              "x": 9.909,
              "y": 30.95,
              "z": 1.406
            },
            "rightCorner": {
              "x": 9.721,
              "y": 30.961,
              "z": 1.406
            },
            "gtin": "40056050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fda5",
            "leftCorner": {
              "x": 9.721,
              "y": 30.961,
              "z": 1.406
            },
            "rightCorner": {
              "x": 9.532,
              "y": 30.972,
              "z": 1.406
            },
            "gtin": "40056050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fda6",
            "leftCorner": {
              "x": 9.532,
              "y": 30.972,
              "z": 1.406
            },
            "rightCorner": {
              "x": 9.344,
              "y": 30.983,
              "z": 1.406
            },
            "gtin": "40056050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fda7",
            "leftCorner": {
              "x": 9.344,
              "y": 30.983,
              "z": 1.406
            },
            "rightCorner": {
              "x": 9.155,
              "y": 30.994,
              "z": 1.406
            },
            "gtin": "40056050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fda8",
            "leftCorner": {
              "x": 9.153,
              "y": 30.957,
              "z": 1.406
            },
            "rightCorner": {
              "x": 8.955,
              "y": 30.968,
              "z": 1.406
            },
            "gtin": "40056050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fda9",
            "leftCorner": {
              "x": 8.955,
              "y": 30.968,
              "z": 1.406
            },
            "rightCorner": {
              "x": 8.757,
              "y": 30.981,
              "z": 1.406
            },
            "gtin": "40056050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdaa",
            "leftCorner": {
              "x": 8.757,
              "y": 30.981,
              "z": 1.406
            },
            "rightCorner": {
              "x": 8.559,
              "y": 30.992,
              "z": 1.406
            },
            "gtin": "40056050",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a9e"
  },
  {
    "id": "41a81",
    "name": "41a81",
    "x": 9.368,
    "y": 25.946,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.038658,
      "w": 0.99925
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 84
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5467c8",
        "height": 0.14527,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ecb2",
            "leftCorner": {
              "x": 9.651,
              "y": 25.985,
              "z": 0.119
            },
            "rightCorner": {
              "x": 9.762,
              "y": 25.977,
              "z": 0.119
            },
            "gtin": "7622400883033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecb3",
            "leftCorner": {
              "x": 9.762,
              "y": 25.977,
              "z": 0.119
            },
            "rightCorner": {
              "x": 9.873,
              "y": 25.968,
              "z": 0.119
            },
            "gtin": "7622400883033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecb4",
            "leftCorner": {
              "x": 9.873,
              "y": 25.964,
              "z": 0.119
            },
            "rightCorner": {
              "x": 9.949,
              "y": 25.958,
              "z": 0.119
            },
            "gtin": "7622210349675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecb5",
            "leftCorner": {
              "x": 9.949,
              "y": 25.958,
              "z": 0.119
            },
            "rightCorner": {
              "x": 10.025,
              "y": 25.952,
              "z": 0.119
            },
            "gtin": "7622210349675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecb6",
            "leftCorner": {
              "x": 10.025,
              "y": 25.951,
              "z": 0.119
            },
            "rightCorner": {
              "x": 10.172,
              "y": 25.941,
              "z": 0.119
            },
            "gtin": "4025700001450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecb7",
            "leftCorner": {
              "x": 10.172,
              "y": 25.941,
              "z": 0.119
            },
            "rightCorner": {
              "x": 10.319,
              "y": 25.929,
              "z": 0.119
            },
            "gtin": "4025700001450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecb8",
            "leftCorner": {
              "x": 10.319,
              "y": 25.929,
              "z": 0.119
            },
            "rightCorner": {
              "x": 10.467,
              "y": 25.917,
              "z": 0.119
            },
            "gtin": "4025700001450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecb9",
            "leftCorner": {
              "x": 10.467,
              "y": 25.917,
              "z": 0.119
            },
            "rightCorner": {
              "x": 10.614,
              "y": 25.906,
              "z": 0.119
            },
            "gtin": "4025700001450",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467c7",
        "height": 0.44731,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ed23",
            "leftCorner": {
              "x": 9.459,
              "y": 25.983,
              "z": 0.366
            },
            "rightCorner": {
              "x": 9.793,
              "y": 25.957,
              "z": 0.366
            },
            "gtin": "3045140118502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed24",
            "leftCorner": {
              "x": 9.794,
              "y": 25.972,
              "z": 0.366
            },
            "rightCorner": {
              "x": 9.905,
              "y": 25.963,
              "z": 0.366
            },
            "gtin": "7622210055439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed25",
            "leftCorner": {
              "x": 9.905,
              "y": 25.963,
              "z": 0.366
            },
            "rightCorner": {
              "x": 10.017,
              "y": 25.955,
              "z": 0.366
            },
            "gtin": "7622210055439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed26",
            "leftCorner": {
              "x": 10.017,
              "y": 25.963,
              "z": 0.366
            },
            "rightCorner": {
              "x": 10.163,
              "y": 25.951,
              "z": 0.366
            },
            "gtin": "7622300185015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed27",
            "leftCorner": {
              "x": 10.163,
              "y": 25.951,
              "z": 0.366
            },
            "rightCorner": {
              "x": 10.309,
              "y": 25.941,
              "z": 0.366
            },
            "gtin": "7622300185015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed28",
            "leftCorner": {
              "x": 10.309,
              "y": 25.941,
              "z": 0.366
            },
            "rightCorner": {
              "x": 10.454,
              "y": 25.929,
              "z": 0.366
            },
            "gtin": "7622300185015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed29",
            "leftCorner": {
              "x": 10.454,
              "y": 25.922,
              "z": 0.366
            },
            "rightCorner": {
              "x": 10.527,
              "y": 25.917,
              "z": 0.366
            },
            "gtin": "4025700001023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed2a",
            "leftCorner": {
              "x": 10.527,
              "y": 25.917,
              "z": 0.366
            },
            "rightCorner": {
              "x": 10.601,
              "y": 25.912,
              "z": 0.366
            },
            "gtin": "4025700001023",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467c5",
        "height": 0.74859,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eb7b",
            "leftCorner": {
              "x": 9.407,
              "y": 25.977,
              "z": 0.612
            },
            "rightCorner": {
              "x": 9.471,
              "y": 25.972,
              "z": 0.612
            },
            "gtin": "7622201814007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb7c",
            "leftCorner": {
              "x": 9.471,
              "y": 25.972,
              "z": 0.612
            },
            "rightCorner": {
              "x": 9.535,
              "y": 25.967,
              "z": 0.612
            },
            "gtin": "7622201814007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb7d",
            "leftCorner": {
              "x": 9.535,
              "y": 25.967,
              "z": 0.612
            },
            "rightCorner": {
              "x": 9.599,
              "y": 25.962,
              "z": 0.612
            },
            "gtin": "7622201814007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb7e",
            "leftCorner": {
              "x": 9.6,
              "y": 25.978,
              "z": 0.612
            },
            "rightCorner": {
              "x": 9.794,
              "y": 25.963,
              "z": 0.612
            },
            "gtin": "4025700001030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb7f",
            "leftCorner": {
              "x": 9.794,
              "y": 25.963,
              "z": 0.612
            },
            "rightCorner": {
              "x": 9.988,
              "y": 25.949,
              "z": 0.612
            },
            "gtin": "4025700001030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb80",
            "leftCorner": {
              "x": 9.988,
              "y": 25.942,
              "z": 0.612
            },
            "rightCorner": {
              "x": 10.128,
              "y": 25.93,
              "z": 0.612
            },
            "gtin": "7622200003938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb81",
            "leftCorner": {
              "x": 10.129,
              "y": 25.942,
              "z": 0.612
            },
            "rightCorner": {
              "x": 10.207,
              "y": 25.936,
              "z": 0.612
            },
            "gtin": "7622201678982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb82",
            "leftCorner": {
              "x": 10.207,
              "y": 25.936,
              "z": 0.612
            },
            "rightCorner": {
              "x": 10.285,
              "y": 25.93,
              "z": 0.612
            },
            "gtin": "7622201678982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb83",
            "leftCorner": {
              "x": 10.284,
              "y": 25.915,
              "z": 0.612
            },
            "rightCorner": {
              "x": 10.32,
              "y": 25.912,
              "z": 0.612
            },
            "gtin": "4000417629210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb84",
            "leftCorner": {
              "x": 10.32,
              "y": 25.912,
              "z": 0.612
            },
            "rightCorner": {
              "x": 10.357,
              "y": 25.91,
              "z": 0.612
            },
            "gtin": "4000417629210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb85",
            "leftCorner": {
              "x": 10.357,
              "y": 25.91,
              "z": 0.612
            },
            "rightCorner": {
              "x": 10.393,
              "y": 25.907,
              "z": 0.612
            },
            "gtin": "4000417629210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb86",
            "leftCorner": {
              "x": 10.394,
              "y": 25.917,
              "z": 0.612
            },
            "rightCorner": {
              "x": 10.496,
              "y": 25.909,
              "z": 0.612
            },
            "gtin": "4000417601216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb87",
            "leftCorner": {
              "x": 10.495,
              "y": 25.903,
              "z": 0.612
            },
            "rightCorner": {
              "x": 10.558,
              "y": 25.898,
              "z": 0.612
            },
            "gtin": "4000417620811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb88",
            "leftCorner": {
              "x": 10.558,
              "y": 25.898,
              "z": 0.612
            },
            "rightCorner": {
              "x": 10.621,
              "y": 25.893,
              "z": 0.612
            },
            "gtin": "4000417620811",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467c6",
        "height": 1.0003,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eb2f",
            "leftCorner": {
              "x": 9.409,
              "y": 25.985,
              "z": 0.818
            },
            "rightCorner": {
              "x": 9.652,
              "y": 25.965,
              "z": 0.818
            },
            "gtin": "3045140105502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb30",
            "leftCorner": {
              "x": 9.652,
              "y": 25.965,
              "z": 0.818
            },
            "rightCorner": {
              "x": 9.894,
              "y": 25.947,
              "z": 0.818
            },
            "gtin": "3045140105502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb31",
            "leftCorner": {
              "x": 9.894,
              "y": 25.947,
              "z": 0.818
            },
            "rightCorner": {
              "x": 10.137,
              "y": 25.928,
              "z": 0.818
            },
            "gtin": "3045140105502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb32",
            "leftCorner": {
              "x": 10.137,
              "y": 25.923,
              "z": 0.818
            },
            "rightCorner": {
              "x": 10.195,
              "y": 25.917,
              "z": 0.818
            },
            "gtin": "7622400779756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb33",
            "leftCorner": {
              "x": 10.195,
              "y": 25.917,
              "z": 0.818
            },
            "rightCorner": {
              "x": 10.253,
              "y": 25.913,
              "z": 0.818
            },
            "gtin": "7622400779756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb34",
            "leftCorner": {
              "x": 10.254,
              "y": 25.922,
              "z": 0.818
            },
            "rightCorner": {
              "x": 10.331,
              "y": 25.915,
              "z": 0.818
            },
            "gtin": "7622400949166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb35",
            "leftCorner": {
              "x": 10.331,
              "y": 25.915,
              "z": 0.818
            },
            "rightCorner": {
              "x": 10.409,
              "y": 25.91,
              "z": 0.818
            },
            "gtin": "7622400949166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb36",
            "leftCorner": {
              "x": 10.409,
              "y": 25.909,
              "z": 0.818
            },
            "rightCorner": {
              "x": 10.456,
              "y": 25.905,
              "z": 0.818
            },
            "gtin": "4000417628510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb37",
            "leftCorner": {
              "x": 10.456,
              "y": 25.905,
              "z": 0.818
            },
            "rightCorner": {
              "x": 10.503,
              "y": 25.901,
              "z": 0.818
            },
            "gtin": "4000417628510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb38",
            "leftCorner": {
              "x": 10.502,
              "y": 25.892,
              "z": 0.818
            },
            "rightCorner": {
              "x": 10.58,
              "y": 25.887,
              "z": 0.818
            },
            "gtin": "4000417628411",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467c2",
        "height": 1.2519,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ebe3",
            "leftCorner": {
              "x": 9.394,
              "y": 25.995,
              "z": 1.024
            },
            "rightCorner": {
              "x": 9.446,
              "y": 25.99,
              "z": 1.024
            },
            "gtin": "7610815028774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebe4",
            "leftCorner": {
              "x": 9.446,
              "y": 25.99,
              "z": 1.024
            },
            "rightCorner": {
              "x": 9.499,
              "y": 25.986,
              "z": 1.024
            },
            "gtin": "7610815028774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebe5",
            "leftCorner": {
              "x": 9.499,
              "y": 25.986,
              "z": 1.024
            },
            "rightCorner": {
              "x": 9.551,
              "y": 25.982,
              "z": 1.024
            },
            "gtin": "7610815028774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebe6",
            "leftCorner": {
              "x": 9.55,
              "y": 25.973,
              "z": 1.024
            },
            "rightCorner": {
              "x": 9.659,
              "y": 25.965,
              "z": 1.024
            },
            "gtin": "4260739994322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebe7",
            "leftCorner": {
              "x": 9.659,
              "y": 25.971,
              "z": 1.024
            },
            "rightCorner": {
              "x": 9.726,
              "y": 25.966,
              "z": 1.024
            },
            "gtin": "4260556675978",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebe8",
            "leftCorner": {
              "x": 9.726,
              "y": 25.966,
              "z": 1.024
            },
            "rightCorner": {
              "x": 9.792,
              "y": 25.961,
              "z": 1.024
            },
            "gtin": "4260556675978",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebe9",
            "leftCorner": {
              "x": 9.792,
              "y": 25.965,
              "z": 1.024
            },
            "rightCorner": {
              "x": 9.89,
              "y": 25.957,
              "z": 1.024
            },
            "gtin": "4260334140810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebea",
            "leftCorner": {
              "x": 9.89,
              "y": 25.95,
              "z": 1.024
            },
            "rightCorner": {
              "x": 9.955,
              "y": 25.946,
              "z": 1.024
            },
            "gtin": "4260402487625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebeb",
            "leftCorner": {
              "x": 9.955,
              "y": 25.945,
              "z": 1.024
            },
            "rightCorner": {
              "x": 10.006,
              "y": 25.941,
              "z": 1.024
            },
            "gtin": "4058400013386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebec",
            "leftCorner": {
              "x": 10.006,
              "y": 25.941,
              "z": 1.024
            },
            "rightCorner": {
              "x": 10.058,
              "y": 25.936,
              "z": 1.024
            },
            "gtin": "4058400013386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebed",
            "leftCorner": {
              "x": 10.058,
              "y": 25.941,
              "z": 1.024
            },
            "rightCorner": {
              "x": 10.102,
              "y": 25.939,
              "z": 1.024
            },
            "gtin": "4030387034080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebee",
            "leftCorner": {
              "x": 10.102,
              "y": 25.939,
              "z": 1.024
            },
            "rightCorner": {
              "x": 10.145,
              "y": 25.935,
              "z": 1.024
            },
            "gtin": "4030387034080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebef",
            "leftCorner": {
              "x": 10.144,
              "y": 25.927,
              "z": 1.024
            },
            "rightCorner": {
              "x": 10.214,
              "y": 25.922,
              "z": 1.024
            },
            "gtin": "7622210928832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebf0",
            "leftCorner": {
              "x": 10.214,
              "y": 25.922,
              "z": 1.024
            },
            "rightCorner": {
              "x": 10.283,
              "y": 25.916,
              "z": 1.024
            },
            "gtin": "7622210928832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebf1",
            "leftCorner": {
              "x": 10.284,
              "y": 25.919,
              "z": 1.024
            },
            "rightCorner": {
              "x": 10.434,
              "y": 25.907,
              "z": 1.024
            },
            "gtin": "7622210928887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebf2",
            "leftCorner": {
              "x": 10.434,
              "y": 25.906,
              "z": 1.024
            },
            "rightCorner": {
              "x": 10.491,
              "y": 25.902,
              "z": 1.024
            },
            "gtin": "7622210928894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebf3",
            "leftCorner": {
              "x": 10.491,
              "y": 25.902,
              "z": 1.024
            },
            "rightCorner": {
              "x": 10.548,
              "y": 25.898,
              "z": 1.024
            },
            "gtin": "7622210928894",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467c4",
        "height": 1.502,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ec4a",
            "leftCorner": {
              "x": 9.388,
              "y": 25.995,
              "z": 1.229
            },
            "rightCorner": {
              "x": 9.436,
              "y": 25.991,
              "z": 1.229
            },
            "gtin": "4260137740996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec4b",
            "leftCorner": {
              "x": 9.436,
              "y": 25.991,
              "z": 1.229
            },
            "rightCorner": {
              "x": 9.486,
              "y": 25.987,
              "z": 1.229
            },
            "gtin": "4260137740996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec4c",
            "leftCorner": {
              "x": 9.485,
              "y": 25.983,
              "z": 1.229
            },
            "rightCorner": {
              "x": 9.576,
              "y": 25.977,
              "z": 1.229
            },
            "gtin": "4063367194351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec4d",
            "leftCorner": {
              "x": 9.576,
              "y": 25.972,
              "z": 1.229
            },
            "rightCorner": {
              "x": 9.679,
              "y": 25.964,
              "z": 1.229
            },
            "gtin": "4063367194412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec4e",
            "leftCorner": {
              "x": 9.677,
              "y": 25.944,
              "z": 1.229
            },
            "rightCorner": {
              "x": 9.736,
              "y": 25.939,
              "z": 1.229
            },
            "gtin": "4063367194399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec4f",
            "leftCorner": {
              "x": 9.736,
              "y": 25.939,
              "z": 1.229
            },
            "rightCorner": {
              "x": 9.794,
              "y": 25.935,
              "z": 1.229
            },
            "gtin": "4063367194399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec50",
            "leftCorner": {
              "x": 9.795,
              "y": 25.949,
              "z": 1.229
            },
            "rightCorner": {
              "x": 9.842,
              "y": 25.945,
              "z": 1.229
            },
            "gtin": "4260661092288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec51",
            "leftCorner": {
              "x": 9.842,
              "y": 25.945,
              "z": 1.229
            },
            "rightCorner": {
              "x": 9.889,
              "y": 25.941,
              "z": 1.229
            },
            "gtin": "4260661092288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec52",
            "leftCorner": {
              "x": 9.89,
              "y": 25.943,
              "z": 1.229
            },
            "rightCorner": {
              "x": 9.943,
              "y": 25.939,
              "z": 1.229
            }
          },
          {
            "id": "68300c865ed67a01d9a1ec53",
            "leftCorner": {
              "x": 9.943,
              "y": 25.931,
              "z": 1.229
            },
            "rightCorner": {
              "x": 9.992,
              "y": 25.927,
              "z": 1.229
            },
            "gtin": "4000194331450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec54",
            "leftCorner": {
              "x": 9.992,
              "y": 25.927,
              "z": 1.229
            },
            "rightCorner": {
              "x": 10.041,
              "y": 25.923,
              "z": 1.229
            },
            "gtin": "4000194331450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec55",
            "leftCorner": {
              "x": 10.042,
              "y": 25.927,
              "z": 1.229
            },
            "rightCorner": {
              "x": 10.098,
              "y": 25.923,
              "z": 1.229
            },
            "gtin": "4000194331306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec56",
            "leftCorner": {
              "x": 10.098,
              "y": 25.923,
              "z": 1.229
            },
            "rightCorner": {
              "x": 10.154,
              "y": 25.919,
              "z": 1.229
            },
            "gtin": "4000194331306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec57",
            "leftCorner": {
              "x": 10.154,
              "y": 25.919,
              "z": 1.229
            },
            "rightCorner": {
              "x": 10.21,
              "y": 25.915,
              "z": 1.229
            },
            "gtin": "4000194331306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec58",
            "leftCorner": {
              "x": 10.21,
              "y": 25.921,
              "z": 1.229
            },
            "rightCorner": {
              "x": 10.36,
              "y": 25.91,
              "z": 1.229
            },
            "gtin": "7622300681975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec59",
            "leftCorner": {
              "x": 10.36,
              "y": 25.91,
              "z": 1.229
            },
            "rightCorner": {
              "x": 10.511,
              "y": 25.898,
              "z": 1.229
            },
            "gtin": "7622300681975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec5a",
            "leftCorner": {
              "x": 10.511,
              "y": 25.897,
              "z": 1.229
            },
            "rightCorner": {
              "x": 10.59,
              "y": 25.891,
              "z": 1.229
            },
            "gtin": "4262451981581",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467c3",
        "height": 1.7524,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eacc",
            "leftCorner": {
              "x": 9.391,
              "y": 25.992,
              "z": 1.434
            },
            "rightCorner": {
              "x": 9.475,
              "y": 25.985,
              "z": 1.434
            },
            "gtin": "7622201755218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eacd",
            "leftCorner": {
              "x": 9.475,
              "y": 25.985,
              "z": 1.434
            },
            "rightCorner": {
              "x": 9.558,
              "y": 25.979,
              "z": 1.434
            },
            "gtin": "7622201755218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eace",
            "leftCorner": {
              "x": 9.558,
              "y": 25.979,
              "z": 1.434
            },
            "rightCorner": {
              "x": 9.642,
              "y": 25.972,
              "z": 1.434
            },
            "gtin": "7622201755218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eacf",
            "leftCorner": {
              "x": 9.642,
              "y": 25.972,
              "z": 1.434
            },
            "rightCorner": {
              "x": 9.726,
              "y": 25.965,
              "z": 1.434
            },
            "gtin": "7622201755218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ead0",
            "leftCorner": {
              "x": 9.726,
              "y": 25.964,
              "z": 1.434
            },
            "rightCorner": {
              "x": 9.91,
              "y": 25.95,
              "z": 1.434
            },
            "gtin": "7622201765033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ead1",
            "leftCorner": {
              "x": 9.91,
              "y": 25.95,
              "z": 1.434
            },
            "rightCorner": {
              "x": 10.095,
              "y": 25.935,
              "z": 1.434
            },
            "gtin": "7622201765033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ead2",
            "leftCorner": {
              "x": 10.094,
              "y": 25.923,
              "z": 1.434
            },
            "rightCorner": {
              "x": 10.161,
              "y": 25.918,
              "z": 1.434
            },
            "gtin": "4262451981987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ead3",
            "leftCorner": {
              "x": 10.161,
              "y": 25.918,
              "z": 1.434
            },
            "rightCorner": {
              "x": 10.228,
              "y": 25.913,
              "z": 1.434
            },
            "gtin": "4262451981987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ead4",
            "leftCorner": {
              "x": 10.229,
              "y": 25.919,
              "z": 1.434
            },
            "rightCorner": {
              "x": 10.386,
              "y": 25.907,
              "z": 1.434
            },
            "gtin": "4014400916744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ead5",
            "leftCorner": {
              "x": 10.386,
              "y": 25.917,
              "z": 1.434
            },
            "rightCorner": {
              "x": 10.482,
              "y": 25.91,
              "z": 1.434
            },
            "gtin": "4014400916751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ead6",
            "leftCorner": {
              "x": 10.482,
              "y": 25.91,
              "z": 1.434
            },
            "rightCorner": {
              "x": 10.577,
              "y": 25.903,
              "z": 1.434
            },
            "gtin": "4014400916751",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d1381",
    "rightNeighborShelfId": "41a88"
  },
  {
    "id": "41a88",
    "name": "41a88",
    "x": 10.565,
    "y": 25.853,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.038658,
      "w": 0.99925
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 126
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546850",
        "height": 0.14983,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ecba",
            "leftCorner": {
              "x": 10.614,
              "y": 25.896,
              "z": 0.123
            },
            "rightCorner": {
              "x": 10.664,
              "y": 25.892,
              "z": 0.123
            },
            "gtin": "4000607164002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecbb",
            "leftCorner": {
              "x": 10.664,
              "y": 25.892,
              "z": 0.123
            },
            "rightCorner": {
              "x": 10.714,
              "y": 25.889,
              "z": 0.123
            },
            "gtin": "4000607164002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecbc",
            "leftCorner": {
              "x": 10.714,
              "y": 25.889,
              "z": 0.123
            },
            "rightCorner": {
              "x": 10.765,
              "y": 25.885,
              "z": 0.123
            },
            "gtin": "4000607164002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecbd",
            "leftCorner": {
              "x": 10.765,
              "y": 25.892,
              "z": 0.123
            },
            "rightCorner": {
              "x": 10.846,
              "y": 25.886,
              "z": 0.123
            },
            "gtin": "4000607831706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecbe",
            "leftCorner": {
              "x": 10.846,
              "y": 25.886,
              "z": 0.123
            },
            "rightCorner": {
              "x": 10.927,
              "y": 25.88,
              "z": 0.123
            },
            "gtin": "4000607831706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecbf",
            "leftCorner": {
              "x": 10.927,
              "y": 25.886,
              "z": 0.123
            },
            "rightCorner": {
              "x": 10.964,
              "y": 25.883,
              "z": 0.123
            },
            "gtin": "4000607165009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecc0",
            "leftCorner": {
              "x": 10.964,
              "y": 25.883,
              "z": 0.123
            },
            "rightCorner": {
              "x": 11.0,
              "y": 25.881,
              "z": 0.123
            },
            "gtin": "4000607165009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecc1",
            "leftCorner": {
              "x": 11.0,
              "y": 25.881,
              "z": 0.123
            },
            "rightCorner": {
              "x": 11.036,
              "y": 25.878,
              "z": 0.123
            },
            "gtin": "4000607165009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecc2",
            "leftCorner": {
              "x": 11.036,
              "y": 25.878,
              "z": 0.123
            },
            "rightCorner": {
              "x": 11.072,
              "y": 25.875,
              "z": 0.123
            },
            "gtin": "4000607165009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecc3",
            "leftCorner": {
              "x": 11.072,
              "y": 25.876,
              "z": 0.123
            },
            "rightCorner": {
              "x": 11.136,
              "y": 25.872,
              "z": 0.123
            },
            "gtin": "4000607855511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecc4",
            "leftCorner": {
              "x": 11.136,
              "y": 25.872,
              "z": 0.123
            },
            "rightCorner": {
              "x": 11.2,
              "y": 25.867,
              "z": 0.123
            },
            "gtin": "4000607855511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecc5",
            "leftCorner": {
              "x": 11.2,
              "y": 25.869,
              "z": 0.123
            },
            "rightCorner": {
              "x": 11.314,
              "y": 25.861,
              "z": 0.123
            },
            "gtin": "4000607777905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecc6",
            "leftCorner": {
              "x": 11.313,
              "y": 25.853,
              "z": 0.123
            },
            "rightCorner": {
              "x": 11.395,
              "y": 25.847,
              "z": 0.123
            },
            "gtin": "4000607164408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecc7",
            "leftCorner": {
              "x": 11.395,
              "y": 25.847,
              "z": 0.123
            },
            "rightCorner": {
              "x": 11.477,
              "y": 25.84,
              "z": 0.123
            },
            "gtin": "4000607164408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecc8",
            "leftCorner": {
              "x": 11.477,
              "y": 25.832,
              "z": 0.123
            },
            "rightCorner": {
              "x": 11.557,
              "y": 25.827,
              "z": 0.123
            },
            "gtin": "4000607778902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecc9",
            "leftCorner": {
              "x": 11.557,
              "y": 25.827,
              "z": 0.123
            },
            "rightCorner": {
              "x": 11.638,
              "y": 25.82,
              "z": 0.123
            },
            "gtin": "4000607778902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecca",
            "leftCorner": {
              "x": 11.638,
              "y": 25.813,
              "z": 0.123
            },
            "rightCorner": {
              "x": 11.683,
              "y": 25.81,
              "z": 0.123
            },
            "gtin": "4000607730900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eccb",
            "leftCorner": {
              "x": 11.683,
              "y": 25.81,
              "z": 0.123
            },
            "rightCorner": {
              "x": 11.729,
              "y": 25.806,
              "z": 0.123
            },
            "gtin": "4000607730900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eccc",
            "leftCorner": {
              "x": 11.729,
              "y": 25.806,
              "z": 0.123
            },
            "rightCorner": {
              "x": 11.774,
              "y": 25.802,
              "z": 0.123
            },
            "gtin": "4000607730900",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54684e",
        "height": 0.44785,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ed2b",
            "leftCorner": {
              "x": 10.6,
              "y": 25.898,
              "z": 0.366
            },
            "rightCorner": {
              "x": 10.762,
              "y": 25.886,
              "z": 0.366
            },
            "gtin": "4000607167706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed2c",
            "leftCorner": {
              "x": 10.763,
              "y": 25.898,
              "z": 0.366
            },
            "rightCorner": {
              "x": 10.831,
              "y": 25.892,
              "z": 0.366
            },
            "gtin": "4000607162602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed2d",
            "leftCorner": {
              "x": 10.831,
              "y": 25.892,
              "z": 0.366
            },
            "rightCorner": {
              "x": 10.898,
              "y": 25.887,
              "z": 0.366
            },
            "gtin": "4000607162602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed2e",
            "leftCorner": {
              "x": 10.898,
              "y": 25.887,
              "z": 0.366
            },
            "rightCorner": {
              "x": 10.966,
              "y": 25.881,
              "z": 0.366
            },
            "gtin": "4000607162602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed2f",
            "leftCorner": {
              "x": 10.967,
              "y": 25.887,
              "z": 0.366
            },
            "rightCorner": {
              "x": 11.019,
              "y": 25.883,
              "z": 0.366
            },
            "gtin": "4000607151101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed30",
            "leftCorner": {
              "x": 11.019,
              "y": 25.883,
              "z": 0.366
            },
            "rightCorner": {
              "x": 11.071,
              "y": 25.879,
              "z": 0.366
            },
            "gtin": "4000607151101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed31",
            "leftCorner": {
              "x": 11.071,
              "y": 25.879,
              "z": 0.366
            },
            "rightCorner": {
              "x": 11.123,
              "y": 25.875,
              "z": 0.366
            },
            "gtin": "4000607151101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed32",
            "leftCorner": {
              "x": 11.123,
              "y": 25.872,
              "z": 0.366
            },
            "rightCorner": {
              "x": 11.207,
              "y": 25.866,
              "z": 0.366
            },
            "gtin": "4000607163609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed33",
            "leftCorner": {
              "x": 11.207,
              "y": 25.866,
              "z": 0.366
            },
            "rightCorner": {
              "x": 11.292,
              "y": 25.86,
              "z": 0.366
            },
            "gtin": "4000607163609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed34",
            "leftCorner": {
              "x": 11.29,
              "y": 25.853,
              "z": 0.366
            },
            "rightCorner": {
              "x": 11.334,
              "y": 25.849,
              "z": 0.366
            },
            "gtin": "4000607151200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed35",
            "leftCorner": {
              "x": 11.334,
              "y": 25.849,
              "z": 0.366
            },
            "rightCorner": {
              "x": 11.377,
              "y": 25.846,
              "z": 0.366
            },
            "gtin": "4000607151200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed36",
            "leftCorner": {
              "x": 11.377,
              "y": 25.846,
              "z": 0.366
            },
            "rightCorner": {
              "x": 11.42,
              "y": 25.842,
              "z": 0.366
            },
            "gtin": "4000607151200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed37",
            "leftCorner": {
              "x": 11.42,
              "y": 25.842,
              "z": 0.366
            },
            "rightCorner": {
              "x": 11.463,
              "y": 25.84,
              "z": 0.366
            },
            "gtin": "4000607151200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed38",
            "leftCorner": {
              "x": 11.463,
              "y": 25.838,
              "z": 0.366
            },
            "rightCorner": {
              "x": 11.496,
              "y": 25.836,
              "z": 0.366
            },
            "gtin": "4000607151002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed39",
            "leftCorner": {
              "x": 11.496,
              "y": 25.836,
              "z": 0.366
            },
            "rightCorner": {
              "x": 11.53,
              "y": 25.833,
              "z": 0.366
            },
            "gtin": "4000607151002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed3a",
            "leftCorner": {
              "x": 11.53,
              "y": 25.833,
              "z": 0.366
            },
            "rightCorner": {
              "x": 11.564,
              "y": 25.83,
              "z": 0.366
            },
            "gtin": "4000607151002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed3b",
            "leftCorner": {
              "x": 11.564,
              "y": 25.83,
              "z": 0.366
            },
            "rightCorner": {
              "x": 11.597,
              "y": 25.828,
              "z": 0.366
            },
            "gtin": "4000607151002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed3c",
            "leftCorner": {
              "x": 11.597,
              "y": 25.828,
              "z": 0.366
            },
            "rightCorner": {
              "x": 11.63,
              "y": 25.825,
              "z": 0.366
            },
            "gtin": "4000607151002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed3d",
            "leftCorner": {
              "x": 11.629,
              "y": 25.816,
              "z": 0.366
            },
            "rightCorner": {
              "x": 11.701,
              "y": 25.81,
              "z": 0.366
            },
            "gtin": "4000607029004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed3e",
            "leftCorner": {
              "x": 11.701,
              "y": 25.81,
              "z": 0.366
            },
            "rightCorner": {
              "x": 11.772,
              "y": 25.805,
              "z": 0.366
            },
            "gtin": "4000607029004",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54684f",
        "height": 0.75044,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eb89",
            "leftCorner": {
              "x": 10.622,
              "y": 25.904,
              "z": 0.614
            },
            "rightCorner": {
              "x": 10.652,
              "y": 25.901,
              "z": 0.614
            },
            "gtin": "4000417602114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb8a",
            "leftCorner": {
              "x": 10.652,
              "y": 25.901,
              "z": 0.614
            },
            "rightCorner": {
              "x": 10.682,
              "y": 25.898,
              "z": 0.614
            },
            "gtin": "4000417602114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb8b",
            "leftCorner": {
              "x": 10.682,
              "y": 25.898,
              "z": 0.614
            },
            "rightCorner": {
              "x": 10.713,
              "y": 25.897,
              "z": 0.614
            },
            "gtin": "4000417602114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb8c",
            "leftCorner": {
              "x": 10.713,
              "y": 25.897,
              "z": 0.614
            },
            "rightCorner": {
              "x": 10.743,
              "y": 25.894,
              "z": 0.614
            },
            "gtin": "4000417602114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb8d",
            "leftCorner": {
              "x": 10.743,
              "y": 25.894,
              "z": 0.614
            },
            "rightCorner": {
              "x": 10.773,
              "y": 25.892,
              "z": 0.614
            },
            "gtin": "4000417602114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb8e",
            "leftCorner": {
              "x": 10.773,
              "y": 25.892,
              "z": 0.614
            },
            "rightCorner": {
              "x": 10.803,
              "y": 25.89,
              "z": 0.614
            },
            "gtin": "4000417602114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb8f",
            "leftCorner": {
              "x": 10.805,
              "y": 25.904,
              "z": 0.614
            },
            "rightCorner": {
              "x": 10.883,
              "y": 25.898,
              "z": 0.614
            },
            "gtin": "4000417280008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb90",
            "leftCorner": {
              "x": 10.883,
              "y": 25.898,
              "z": 0.614
            },
            "rightCorner": {
              "x": 10.961,
              "y": 25.893,
              "z": 0.614
            },
            "gtin": "4000417280008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb91",
            "leftCorner": {
              "x": 10.96,
              "y": 25.876,
              "z": 0.614
            },
            "rightCorner": {
              "x": 11.172,
              "y": 25.86,
              "z": 0.614
            },
            "gtin": "4000417602510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb92",
            "leftCorner": {
              "x": 11.172,
              "y": 25.869,
              "z": 0.614
            },
            "rightCorner": {
              "x": 11.22,
              "y": 25.865,
              "z": 0.614
            },
            "gtin": "4000417602817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb93",
            "leftCorner": {
              "x": 11.22,
              "y": 25.865,
              "z": 0.614
            },
            "rightCorner": {
              "x": 11.269,
              "y": 25.861,
              "z": 0.614
            },
            "gtin": "4000417602817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb94",
            "leftCorner": {
              "x": 11.267,
              "y": 25.847,
              "z": 0.614
            },
            "rightCorner": {
              "x": 11.314,
              "y": 25.843,
              "z": 0.614
            },
            "gtin": "4000417601810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb95",
            "leftCorner": {
              "x": 11.314,
              "y": 25.843,
              "z": 0.614
            },
            "rightCorner": {
              "x": 11.361,
              "y": 25.84,
              "z": 0.614
            },
            "gtin": "4000417601810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb96",
            "leftCorner": {
              "x": 11.36,
              "y": 25.833,
              "z": 0.614
            },
            "rightCorner": {
              "x": 11.471,
              "y": 25.824,
              "z": 0.614
            },
            "gtin": "4000417602718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb97",
            "leftCorner": {
              "x": 11.472,
              "y": 25.832,
              "z": 0.614
            },
            "rightCorner": {
              "x": 11.523,
              "y": 25.828,
              "z": 0.614
            },
            "gtin": "4000417629814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb98",
            "leftCorner": {
              "x": 11.523,
              "y": 25.828,
              "z": 0.614
            },
            "rightCorner": {
              "x": 11.574,
              "y": 25.824,
              "z": 0.614
            },
            "gtin": "4000417629814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb99",
            "leftCorner": {
              "x": 11.574,
              "y": 25.813,
              "z": 0.614
            },
            "rightCorner": {
              "x": 11.698,
              "y": 25.803,
              "z": 0.614
            },
            "gtin": "4000417623713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb9a",
            "leftCorner": {
              "x": 11.698,
              "y": 25.805,
              "z": 0.614
            },
            "rightCorner": {
              "x": 11.78,
              "y": 25.798,
              "z": 0.614
            },
            "gtin": "4000417601513",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54684c",
        "height": 1.002,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eb39",
            "leftCorner": {
              "x": 10.58,
              "y": 25.888,
              "z": 0.82
            },
            "rightCorner": {
              "x": 10.624,
              "y": 25.885,
              "z": 0.82
            },
            "gtin": "4000417602015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb3a",
            "leftCorner": {
              "x": 10.624,
              "y": 25.885,
              "z": 0.82
            },
            "rightCorner": {
              "x": 10.667,
              "y": 25.882,
              "z": 0.82
            },
            "gtin": "4000417602015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb3b",
            "leftCorner": {
              "x": 10.668,
              "y": 25.89,
              "z": 0.82
            },
            "rightCorner": {
              "x": 10.886,
              "y": 25.873,
              "z": 0.82
            },
            "gtin": "4000417602213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb3c",
            "leftCorner": {
              "x": 10.886,
              "y": 25.876,
              "z": 0.82
            },
            "rightCorner": {
              "x": 10.936,
              "y": 25.872,
              "z": 0.82
            },
            "gtin": "4000417621412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb3d",
            "leftCorner": {
              "x": 10.936,
              "y": 25.872,
              "z": 0.82
            },
            "rightCorner": {
              "x": 10.985,
              "y": 25.868,
              "z": 0.82
            },
            "gtin": "4000417621412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb3e",
            "leftCorner": {
              "x": 10.986,
              "y": 25.878,
              "z": 0.82
            },
            "rightCorner": {
              "x": 11.137,
              "y": 25.867,
              "z": 0.82
            },
            "gtin": "4000417601919",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c865ed67a01d9a1eb3f",
            "leftCorner": {
              "x": 11.135,
              "y": 25.857,
              "z": 0.82
            },
            "rightCorner": {
              "x": 11.235,
              "y": 25.849,
              "z": 0.82
            },
            "gtin": "4000417601117",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c865ed67a01d9a1eb40",
            "leftCorner": {
              "x": 11.235,
              "y": 25.849,
              "z": 0.82
            },
            "rightCorner": {
              "x": 11.269,
              "y": 25.847,
              "z": 0.82
            },
            "gtin": "4000417622013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb41",
            "leftCorner": {
              "x": 11.269,
              "y": 25.847,
              "z": 0.82
            },
            "rightCorner": {
              "x": 11.303,
              "y": 25.844,
              "z": 0.82
            },
            "gtin": "4000417622013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb42",
            "leftCorner": {
              "x": 11.303,
              "y": 25.844,
              "z": 0.82
            },
            "rightCorner": {
              "x": 11.337,
              "y": 25.841,
              "z": 0.82
            },
            "gtin": "4000417622013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb43",
            "leftCorner": {
              "x": 11.337,
              "y": 25.835,
              "z": 0.82
            },
            "rightCorner": {
              "x": 11.406,
              "y": 25.83,
              "z": 0.82
            },
            "gtin": "4000417628312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb44",
            "leftCorner": {
              "x": 11.406,
              "y": 25.83,
              "z": 0.82
            },
            "rightCorner": {
              "x": 11.477,
              "y": 25.824,
              "z": 0.82
            },
            "gtin": "4000417628312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb45",
            "leftCorner": {
              "x": 11.477,
              "y": 25.819,
              "z": 0.82
            },
            "rightCorner": {
              "x": 11.529,
              "y": 25.815,
              "z": 0.82
            },
            "gtin": "4000417620217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb46",
            "leftCorner": {
              "x": 11.529,
              "y": 25.815,
              "z": 0.82
            },
            "rightCorner": {
              "x": 11.581,
              "y": 25.811,
              "z": 0.82
            },
            "gtin": "4000417620217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb47",
            "leftCorner": {
              "x": 11.58,
              "y": 25.808,
              "z": 0.82
            },
            "rightCorner": {
              "x": 11.636,
              "y": 25.804,
              "z": 0.82
            },
            "gtin": "4000417629418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb48",
            "leftCorner": {
              "x": 11.636,
              "y": 25.804,
              "z": 0.82
            },
            "rightCorner": {
              "x": 11.692,
              "y": 25.8,
              "z": 0.82
            },
            "gtin": "4000417629418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb49",
            "leftCorner": {
              "x": 11.692,
              "y": 25.798,
              "z": 0.82
            },
            "rightCorner": {
              "x": 11.756,
              "y": 25.793,
              "z": 0.82
            },
            "gtin": "4000417602619",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54684a",
        "height": 1.2541,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ebf4",
            "leftCorner": {
              "x": 10.548,
              "y": 25.892,
              "z": 1.026
            },
            "rightCorner": {
              "x": 10.656,
              "y": 25.883,
              "z": 1.026
            },
            "gtin": "4000417670212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebf5",
            "leftCorner": {
              "x": 10.657,
              "y": 25.905,
              "z": 1.026
            },
            "rightCorner": {
              "x": 10.713,
              "y": 25.901,
              "z": 1.026
            },
            "gtin": "4000417670014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebf6",
            "leftCorner": {
              "x": 10.713,
              "y": 25.901,
              "z": 1.026
            },
            "rightCorner": {
              "x": 10.768,
              "y": 25.897,
              "z": 1.026
            },
            "gtin": "4000417670014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebf7",
            "leftCorner": {
              "x": 10.768,
              "y": 25.9,
              "z": 1.026
            },
            "rightCorner": {
              "x": 10.824,
              "y": 25.895,
              "z": 1.026
            },
            "gtin": "4000417670113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebf8",
            "leftCorner": {
              "x": 10.824,
              "y": 25.895,
              "z": 1.026
            },
            "rightCorner": {
              "x": 10.879,
              "y": 25.89,
              "z": 1.026
            },
            "gtin": "4000417670113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebf9",
            "leftCorner": {
              "x": 10.879,
              "y": 25.89,
              "z": 1.026
            },
            "rightCorner": {
              "x": 10.934,
              "y": 25.886,
              "z": 1.026
            },
            "gtin": "4000417670113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebfa",
            "leftCorner": {
              "x": 10.934,
              "y": 25.886,
              "z": 1.026
            },
            "rightCorner": {
              "x": 10.989,
              "y": 25.882,
              "z": 1.026
            },
            "gtin": "4000417670113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebfb",
            "leftCorner": {
              "x": 10.989,
              "y": 25.884,
              "z": 1.026
            },
            "rightCorner": {
              "x": 11.038,
              "y": 25.88,
              "z": 1.026
            },
            "gtin": "4000417670311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebfc",
            "leftCorner": {
              "x": 11.038,
              "y": 25.88,
              "z": 1.026
            },
            "rightCorner": {
              "x": 11.087,
              "y": 25.876,
              "z": 1.026
            },
            "gtin": "4000417670311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebfd",
            "leftCorner": {
              "x": 11.087,
              "y": 25.87,
              "z": 1.026
            },
            "rightCorner": {
              "x": 11.246,
              "y": 25.858,
              "z": 1.026
            },
            "gtin": "4000417670410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebfe",
            "leftCorner": {
              "x": 11.246,
              "y": 25.858,
              "z": 1.026
            },
            "rightCorner": {
              "x": 11.404,
              "y": 25.845,
              "z": 1.026
            },
            "gtin": "4000417670410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebff",
            "leftCorner": {
              "x": 11.404,
              "y": 25.845,
              "z": 1.026
            },
            "rightCorner": {
              "x": 11.564,
              "y": 25.833,
              "z": 1.026
            },
            "gtin": "4000417670410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec00",
            "leftCorner": {
              "x": 11.564,
              "y": 25.83,
              "z": 1.026
            },
            "rightCorner": {
              "x": 11.63,
              "y": 25.825,
              "z": 1.026
            },
            "gtin": "4000417670717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec01",
            "leftCorner": {
              "x": 11.63,
              "y": 25.825,
              "z": 1.026
            },
            "rightCorner": {
              "x": 11.698,
              "y": 25.82,
              "z": 1.026
            },
            "gtin": "4000417670717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec02",
            "leftCorner": {
              "x": 11.698,
              "y": 25.82,
              "z": 1.026
            },
            "rightCorner": {
              "x": 11.765,
              "y": 25.815,
              "z": 1.026
            },
            "gtin": "4000417670717",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54684b",
        "height": 1.5055,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ec5b",
            "leftCorner": {
              "x": 10.591,
              "y": 25.899,
              "z": 1.232
            },
            "rightCorner": {
              "x": 10.66,
              "y": 25.894,
              "z": 1.232
            },
            "gtin": "4000417106100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec5c",
            "leftCorner": {
              "x": 10.66,
              "y": 25.894,
              "z": 1.232
            },
            "rightCorner": {
              "x": 10.729,
              "y": 25.888,
              "z": 1.232
            },
            "gtin": "4000417106100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec5d",
            "leftCorner": {
              "x": 10.729,
              "y": 25.888,
              "z": 1.232
            },
            "rightCorner": {
              "x": 10.797,
              "y": 25.883,
              "z": 1.232
            },
            "gtin": "4000417106100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec5e",
            "leftCorner": {
              "x": 10.798,
              "y": 25.894,
              "z": 1.232
            },
            "rightCorner": {
              "x": 10.854,
              "y": 25.889,
              "z": 1.232
            },
            "gtin": "4000417107107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec5f",
            "leftCorner": {
              "x": 10.854,
              "y": 25.889,
              "z": 1.232
            },
            "rightCorner": {
              "x": 10.91,
              "y": 25.884,
              "z": 1.232
            },
            "gtin": "4000417107107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec60",
            "leftCorner": {
              "x": 10.91,
              "y": 25.883,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.007,
              "y": 25.876,
              "z": 1.232
            },
            "gtin": "4000417108104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec61",
            "leftCorner": {
              "x": 11.006,
              "y": 25.874,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.055,
              "y": 25.87,
              "z": 1.232
            },
            "gtin": "4000417104106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec62",
            "leftCorner": {
              "x": 11.055,
              "y": 25.87,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.103,
              "y": 25.866,
              "z": 1.232
            },
            "gtin": "4000417104106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec63",
            "leftCorner": {
              "x": 11.103,
              "y": 25.866,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.152,
              "y": 25.863,
              "z": 1.232
            },
            "gtin": "4000417104106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec64",
            "leftCorner": {
              "x": 11.152,
              "y": 25.872,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.188,
              "y": 25.87,
              "z": 1.232
            },
            "gtin": "4000417103109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec65",
            "leftCorner": {
              "x": 11.188,
              "y": 25.87,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.223,
              "y": 25.867,
              "z": 1.232
            },
            "gtin": "4000417103109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec66",
            "leftCorner": {
              "x": 11.223,
              "y": 25.867,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.259,
              "y": 25.864,
              "z": 1.232
            },
            "gtin": "4000417103109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec67",
            "leftCorner": {
              "x": 11.259,
              "y": 25.855,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.304,
              "y": 25.851,
              "z": 1.232
            },
            "gtin": "4000417102003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec68",
            "leftCorner": {
              "x": 11.304,
              "y": 25.851,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.351,
              "y": 25.847,
              "z": 1.232
            },
            "gtin": "4000417102003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec69",
            "leftCorner": {
              "x": 11.351,
              "y": 25.849,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.394,
              "y": 25.846,
              "z": 1.232
            },
            "gtin": "4000417101006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec6a",
            "leftCorner": {
              "x": 11.394,
              "y": 25.846,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.437,
              "y": 25.842,
              "z": 1.232
            },
            "gtin": "4000417101006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec6b",
            "leftCorner": {
              "x": 11.437,
              "y": 25.836,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.546,
              "y": 25.827,
              "z": 1.232
            },
            "gtin": "4000417693310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec6c",
            "leftCorner": {
              "x": 11.546,
              "y": 25.817,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.577,
              "y": 25.815,
              "z": 1.232
            },
            "gtin": "4000417693211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec6d",
            "leftCorner": {
              "x": 11.577,
              "y": 25.815,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.608,
              "y": 25.812,
              "z": 1.232
            },
            "gtin": "4000417693211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec6e",
            "leftCorner": {
              "x": 11.608,
              "y": 25.812,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.639,
              "y": 25.81,
              "z": 1.232
            },
            "gtin": "4000417693211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec6f",
            "leftCorner": {
              "x": 11.64,
              "y": 25.814,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.685,
              "y": 25.81,
              "z": 1.232
            },
            "gtin": "4000417693815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec70",
            "leftCorner": {
              "x": 11.685,
              "y": 25.81,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.73,
              "y": 25.807,
              "z": 1.232
            },
            "gtin": "4000417693815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec71",
            "leftCorner": {
              "x": 11.73,
              "y": 25.807,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.774,
              "y": 25.803,
              "z": 1.232
            },
            "gtin": "4000417693815",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54684d",
        "height": 1.7532,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ead7",
            "leftCorner": {
              "x": 10.576,
              "y": 25.884,
              "z": 1.434
            },
            "rightCorner": {
              "x": 10.629,
              "y": 25.88,
              "z": 1.434
            },
            "gtin": "4014400914269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ead8",
            "leftCorner": {
              "x": 10.629,
              "y": 25.88,
              "z": 1.434
            },
            "rightCorner": {
              "x": 10.682,
              "y": 25.876,
              "z": 1.434
            },
            "gtin": "4014400914269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ead9",
            "leftCorner": {
              "x": 10.682,
              "y": 25.876,
              "z": 1.434
            },
            "rightCorner": {
              "x": 10.735,
              "y": 25.872,
              "z": 1.434
            },
            "gtin": "4014400914269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eada",
            "leftCorner": {
              "x": 10.735,
              "y": 25.872,
              "z": 1.434
            },
            "rightCorner": {
              "x": 10.788,
              "y": 25.868,
              "z": 1.434
            },
            "gtin": "4014400914269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eadb",
            "leftCorner": {
              "x": 10.789,
              "y": 25.879,
              "z": 1.434
            },
            "rightCorner": {
              "x": 10.861,
              "y": 25.873,
              "z": 1.434
            },
            "gtin": "4014400914252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eadc",
            "leftCorner": {
              "x": 10.861,
              "y": 25.873,
              "z": 1.434
            },
            "rightCorner": {
              "x": 10.933,
              "y": 25.868,
              "z": 1.434
            },
            "gtin": "4014400914252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eadd",
            "leftCorner": {
              "x": 10.934,
              "y": 25.876,
              "z": 1.434
            },
            "rightCorner": {
              "x": 11.023,
              "y": 25.869,
              "z": 1.434
            },
            "gtin": "4014400914276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eade",
            "leftCorner": {
              "x": 11.023,
              "y": 25.869,
              "z": 1.434
            },
            "rightCorner": {
              "x": 11.113,
              "y": 25.863,
              "z": 1.434
            },
            "gtin": "4014400914276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eadf",
            "leftCorner": {
              "x": 11.112,
              "y": 25.856,
              "z": 1.434
            },
            "rightCorner": {
              "x": 11.212,
              "y": 25.847,
              "z": 1.434
            },
            "gtin": "4014400914245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eae0",
            "leftCorner": {
              "x": 11.212,
              "y": 25.847,
              "z": 1.434
            },
            "rightCorner": {
              "x": 11.313,
              "y": 25.84,
              "z": 1.434
            },
            "gtin": "4014400914245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eae1",
            "leftCorner": {
              "x": 11.313,
              "y": 25.842,
              "z": 1.434
            },
            "rightCorner": {
              "x": 11.448,
              "y": 25.832,
              "z": 1.434
            },
            "gtin": "4000417663115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eae2",
            "leftCorner": {
              "x": 11.448,
              "y": 25.834,
              "z": 1.434
            },
            "rightCorner": {
              "x": 11.518,
              "y": 25.829,
              "z": 1.434
            },
            "gtin": "4000417663313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eae3",
            "leftCorner": {
              "x": 11.518,
              "y": 25.829,
              "z": 1.434
            },
            "rightCorner": {
              "x": 11.589,
              "y": 25.823,
              "z": 1.434
            },
            "gtin": "4000417663313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eae4",
            "leftCorner": {
              "x": 11.588,
              "y": 25.816,
              "z": 1.434
            },
            "rightCorner": {
              "x": 11.653,
              "y": 25.811,
              "z": 1.434
            },
            "gtin": "4000417663016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eae5",
            "leftCorner": {
              "x": 11.653,
              "y": 25.811,
              "z": 1.434
            },
            "rightCorner": {
              "x": 11.718,
              "y": 25.807,
              "z": 1.434
            },
            "gtin": "4000417663016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eae6",
            "leftCorner": {
              "x": 11.718,
              "y": 25.807,
              "z": 1.434
            },
            "rightCorner": {
              "x": 11.781,
              "y": 25.801,
              "z": 1.434
            },
            "gtin": "4000417663016",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41a81",
    "rightNeighborShelfId": "41a89"
  },
  {
    "id": "41a89",
    "name": "41a89",
    "x": 11.761,
    "y": 25.76,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.038658,
      "w": 0.99925
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 106
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54641f",
        "height": 0.15259,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eccd",
            "leftCorner": {
              "x": 11.775,
              "y": 25.815,
              "z": 0.125
            },
            "rightCorner": {
              "x": 11.815,
              "y": 25.812,
              "z": 0.125
            },
            "gtin": "7610041080201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecce",
            "leftCorner": {
              "x": 11.814,
              "y": 25.806,
              "z": 0.125
            },
            "rightCorner": {
              "x": 11.881,
              "y": 25.802,
              "z": 0.125
            },
            "gtin": "7610041080904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eccf",
            "leftCorner": {
              "x": 11.881,
              "y": 25.804,
              "z": 0.125
            },
            "rightCorner": {
              "x": 11.972,
              "y": 25.796,
              "z": 0.125
            },
            "gtin": "7610041080102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecd0",
            "leftCorner": {
              "x": 11.972,
              "y": 25.796,
              "z": 0.125
            },
            "rightCorner": {
              "x": 12.048,
              "y": 25.79,
              "z": 0.125
            },
            "gtin": "7610041080003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecd1",
            "leftCorner": {
              "x": 12.048,
              "y": 25.791,
              "z": 0.125
            },
            "rightCorner": {
              "x": 12.156,
              "y": 25.782,
              "z": 0.125
            },
            "gtin": "7610041006959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecd2",
            "leftCorner": {
              "x": 12.156,
              "y": 25.788,
              "z": 0.125
            },
            "rightCorner": {
              "x": 12.281,
              "y": 25.779,
              "z": 0.125
            },
            "gtin": "8714786305427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecd3",
            "leftCorner": {
              "x": 12.281,
              "y": 25.779,
              "z": 0.125
            },
            "rightCorner": {
              "x": 12.322,
              "y": 25.776,
              "z": 0.125
            },
            "gtin": "4250231136436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecd4",
            "leftCorner": {
              "x": 12.322,
              "y": 25.776,
              "z": 0.125
            },
            "rightCorner": {
              "x": 12.362,
              "y": 25.772,
              "z": 0.125
            },
            "gtin": "4250231136436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecd5",
            "leftCorner": {
              "x": 12.362,
              "y": 25.772,
              "z": 0.125
            },
            "rightCorner": {
              "x": 12.403,
              "y": 25.77,
              "z": 0.125
            },
            "gtin": "4250231136436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecd6",
            "leftCorner": {
              "x": 12.403,
              "y": 25.767,
              "z": 0.125
            },
            "rightCorner": {
              "x": 12.514,
              "y": 25.758,
              "z": 0.125
            },
            "gtin": "4250231136498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecd7",
            "leftCorner": {
              "x": 12.513,
              "y": 25.746,
              "z": 0.125
            },
            "rightCorner": {
              "x": 12.582,
              "y": 25.74,
              "z": 0.125
            },
            "gtin": "4250231136474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecd8",
            "leftCorner": {
              "x": 12.582,
              "y": 25.74,
              "z": 0.125
            },
            "rightCorner": {
              "x": 12.65,
              "y": 25.735,
              "z": 0.125
            },
            "gtin": "4250231136474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecd9",
            "leftCorner": {
              "x": 12.652,
              "y": 25.75,
              "z": 0.125
            },
            "rightCorner": {
              "x": 12.752,
              "y": 25.743,
              "z": 0.125
            },
            "gtin": "4250231136412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecda",
            "leftCorner": {
              "x": 12.752,
              "y": 25.743,
              "z": 0.125
            },
            "rightCorner": {
              "x": 12.852,
              "y": 25.735,
              "z": 0.125
            },
            "gtin": "4250231136412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecdb",
            "leftCorner": {
              "x": 12.851,
              "y": 25.725,
              "z": 0.125
            },
            "rightCorner": {
              "x": 12.925,
              "y": 25.72,
              "z": 0.125
            },
            "gtin": "4250231136450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecdc",
            "leftCorner": {
              "x": 12.925,
              "y": 25.72,
              "z": 0.125
            },
            "rightCorner": {
              "x": 12.998,
              "y": 25.713,
              "z": 0.125
            },
            "gtin": "4250231136450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecdd",
            "leftCorner": {
              "x": 12.998,
              "y": 25.713,
              "z": 0.125
            },
            "rightCorner": {
              "x": 13.072,
              "y": 25.708,
              "z": 0.125
            },
            "gtin": "4250231136450",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546420",
        "height": 0.45166,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ed3f",
            "leftCorner": {
              "x": 11.772,
              "y": 25.811,
              "z": 0.37
            },
            "rightCorner": {
              "x": 11.839,
              "y": 25.807,
              "z": 0.37
            },
            "gtin": "4000607000652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed40",
            "leftCorner": {
              "x": 11.839,
              "y": 25.807,
              "z": 0.37
            },
            "rightCorner": {
              "x": 11.907,
              "y": 25.801,
              "z": 0.37
            },
            "gtin": "4000607000652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed41",
            "leftCorner": {
              "x": 11.907,
              "y": 25.804,
              "z": 0.37
            },
            "rightCorner": {
              "x": 12.032,
              "y": 25.794,
              "z": 0.37
            },
            "gtin": "40084701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed42",
            "leftCorner": {
              "x": 12.032,
              "y": 25.794,
              "z": 0.37
            },
            "rightCorner": {
              "x": 12.157,
              "y": 25.784,
              "z": 0.37
            },
            "gtin": "40084701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed43",
            "leftCorner": {
              "x": 12.157,
              "y": 25.782,
              "z": 0.37
            },
            "rightCorner": {
              "x": 12.289,
              "y": 25.772,
              "z": 0.37
            },
            "gtin": "40084060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed44",
            "leftCorner": {
              "x": 12.289,
              "y": 25.772,
              "z": 0.37
            },
            "rightCorner": {
              "x": 12.423,
              "y": 25.761,
              "z": 0.37
            },
            "gtin": "40084060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed45",
            "leftCorner": {
              "x": 12.423,
              "y": 25.761,
              "z": 0.37
            },
            "rightCorner": {
              "x": 12.555,
              "y": 25.751,
              "z": 0.37
            },
            "gtin": "40084060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed46",
            "leftCorner": {
              "x": 12.555,
              "y": 25.751,
              "z": 0.37
            },
            "rightCorner": {
              "x": 12.688,
              "y": 25.74,
              "z": 0.37
            },
            "gtin": "40084060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed47",
            "leftCorner": {
              "x": 12.688,
              "y": 25.74,
              "z": 0.37
            },
            "rightCorner": {
              "x": 12.822,
              "y": 25.73,
              "z": 0.37
            },
            "gtin": "40084060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed48",
            "leftCorner": {
              "x": 12.82,
              "y": 25.708,
              "z": 0.37
            },
            "rightCorner": {
              "x": 12.938,
              "y": 25.7,
              "z": 0.37
            },
            "gtin": "40084527",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54641c",
        "height": 0.75258,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eb9b",
            "leftCorner": {
              "x": 11.78,
              "y": 25.804,
              "z": 0.616
            },
            "rightCorner": {
              "x": 11.84,
              "y": 25.8,
              "z": 0.616
            },
            "gtin": "4000607849602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb9c",
            "leftCorner": {
              "x": 11.84,
              "y": 25.8,
              "z": 0.616
            },
            "rightCorner": {
              "x": 11.9,
              "y": 25.794,
              "z": 0.616
            },
            "gtin": "4000607849602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb9d",
            "leftCorner": {
              "x": 11.9,
              "y": 25.804,
              "z": 0.616
            },
            "rightCorner": {
              "x": 11.952,
              "y": 25.801,
              "z": 0.616
            },
            "gtin": "4000607849800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb9e",
            "leftCorner": {
              "x": 11.952,
              "y": 25.801,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.004,
              "y": 25.797,
              "z": 0.616
            },
            "gtin": "4000607849800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb9f",
            "leftCorner": {
              "x": 12.004,
              "y": 25.792,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.128,
              "y": 25.782,
              "z": 0.616
            },
            "gtin": "4000607849404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eba0",
            "leftCorner": {
              "x": 12.128,
              "y": 25.78,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.175,
              "y": 25.776,
              "z": 0.616
            },
            "gtin": "4000607850011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eba1",
            "leftCorner": {
              "x": 12.175,
              "y": 25.776,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.223,
              "y": 25.772,
              "z": 0.616
            },
            "gtin": "4000607850011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eba2",
            "leftCorner": {
              "x": 12.223,
              "y": 25.772,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.27,
              "y": 25.769,
              "z": 0.616
            },
            "gtin": "4000607850011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eba3",
            "leftCorner": {
              "x": 12.27,
              "y": 25.769,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.318,
              "y": 25.765,
              "z": 0.616
            },
            "gtin": "4000607850011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eba4",
            "leftCorner": {
              "x": 12.318,
              "y": 25.776,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.4,
              "y": 25.77,
              "z": 0.616
            },
            "gtin": "8000500359815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eba5",
            "leftCorner": {
              "x": 12.4,
              "y": 25.77,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.483,
              "y": 25.763,
              "z": 0.616
            },
            "gtin": "8000500359815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eba6",
            "leftCorner": {
              "x": 12.483,
              "y": 25.757,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.574,
              "y": 25.75,
              "z": 0.616
            },
            "gtin": "8000500359679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eba7",
            "leftCorner": {
              "x": 12.575,
              "y": 25.758,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.635,
              "y": 25.753,
              "z": 0.616
            },
            "gtin": "8000500359884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eba8",
            "leftCorner": {
              "x": 12.635,
              "y": 25.753,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.694,
              "y": 25.749,
              "z": 0.616
            },
            "gtin": "8000500359884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eba9",
            "leftCorner": {
              "x": 12.692,
              "y": 25.734,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.728,
              "y": 25.73,
              "z": 0.616
            },
            "gtin": "8000500359488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebaa",
            "leftCorner": {
              "x": 12.728,
              "y": 25.73,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.763,
              "y": 25.728,
              "z": 0.616
            },
            "gtin": "8000500359488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebab",
            "leftCorner": {
              "x": 12.763,
              "y": 25.728,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.799,
              "y": 25.725,
              "z": 0.616
            },
            "gtin": "8000500359488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebac",
            "leftCorner": {
              "x": 12.799,
              "y": 25.725,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.835,
              "y": 25.723,
              "z": 0.616
            },
            "gtin": "8000500359488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebad",
            "leftCorner": {
              "x": 12.835,
              "y": 25.72,
              "z": 0.616
            },
            "rightCorner": {
              "x": 13.377,
              "y": 25.677,
              "z": 0.616
            },
            "gtin": "8000500359556",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54641b",
        "height": 1.0049,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eb4a",
            "leftCorner": {
              "x": 11.756,
              "y": 25.8,
              "z": 0.822
            },
            "rightCorner": {
              "x": 11.882,
              "y": 25.79,
              "z": 0.822
            },
            "gtin": "4000539001307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb4b",
            "leftCorner": {
              "x": 11.883,
              "y": 25.804,
              "z": 0.822
            },
            "rightCorner": {
              "x": 11.942,
              "y": 25.8,
              "z": 0.822
            },
            "gtin": "4000539001406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb4c",
            "leftCorner": {
              "x": 11.941,
              "y": 25.783,
              "z": 0.822
            },
            "rightCorner": {
              "x": 12.015,
              "y": 25.777,
              "z": 0.822
            },
            "gtin": "7610400100007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb4d",
            "leftCorner": {
              "x": 12.015,
              "y": 25.786,
              "z": 0.822
            },
            "rightCorner": {
              "x": 12.068,
              "y": 25.781,
              "z": 0.822
            },
            "gtin": "4000539002007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb4e",
            "leftCorner": {
              "x": 12.068,
              "y": 25.781,
              "z": 0.822
            },
            "rightCorner": {
              "x": 12.121,
              "y": 25.778,
              "z": 0.822
            },
            "gtin": "4000539002007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb4f",
            "leftCorner": {
              "x": 12.12,
              "y": 25.762,
              "z": 0.822
            },
            "rightCorner": {
              "x": 12.222,
              "y": 25.753,
              "z": 0.822
            },
            "gtin": "4000539002809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb50",
            "leftCorner": {
              "x": 12.222,
              "y": 25.753,
              "z": 0.822
            },
            "rightCorner": {
              "x": 12.322,
              "y": 25.746,
              "z": 0.822
            },
            "gtin": "4000539002809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb51",
            "leftCorner": {
              "x": 12.323,
              "y": 25.76,
              "z": 0.822
            },
            "rightCorner": {
              "x": 12.389,
              "y": 25.756,
              "z": 0.822
            },
            "gtin": "4000539003103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb52",
            "leftCorner": {
              "x": 12.389,
              "y": 25.756,
              "z": 0.822
            },
            "rightCorner": {
              "x": 12.455,
              "y": 25.751,
              "z": 0.822
            },
            "gtin": "4000539003103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb53",
            "leftCorner": {
              "x": 12.455,
              "y": 25.745,
              "z": 0.822
            },
            "rightCorner": {
              "x": 12.543,
              "y": 25.738,
              "z": 0.822
            },
            "gtin": "4000539113789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb54",
            "leftCorner": {
              "x": 12.544,
              "y": 25.748,
              "z": 0.822
            },
            "rightCorner": {
              "x": 12.621,
              "y": 25.741,
              "z": 0.822
            },
            "gtin": "4000539003202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb55",
            "leftCorner": {
              "x": 12.621,
              "y": 25.742,
              "z": 0.822
            },
            "rightCorner": {
              "x": 12.69,
              "y": 25.736,
              "z": 0.822
            },
            "gtin": "4000539003004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb56",
            "leftCorner": {
              "x": 12.69,
              "y": 25.736,
              "z": 0.822
            },
            "rightCorner": {
              "x": 12.757,
              "y": 25.731,
              "z": 0.822
            },
            "gtin": "4000539003004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb57",
            "leftCorner": {
              "x": 12.757,
              "y": 25.731,
              "z": 0.822
            },
            "rightCorner": {
              "x": 12.826,
              "y": 25.727,
              "z": 0.822
            },
            "gtin": "4000539003004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb58",
            "leftCorner": {
              "x": 12.826,
              "y": 25.717,
              "z": 0.822
            },
            "rightCorner": {
              "x": 12.898,
              "y": 25.711,
              "z": 0.822
            },
            "gtin": "4000539033100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb59",
            "leftCorner": {
              "x": 12.898,
              "y": 25.711,
              "z": 0.822
            },
            "rightCorner": {
              "x": 12.972,
              "y": 25.705,
              "z": 0.822
            },
            "gtin": "4000539033100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb5a",
            "leftCorner": {
              "x": 12.972,
              "y": 25.705,
              "z": 0.822
            },
            "rightCorner": {
              "x": 13.045,
              "y": 25.7,
              "z": 0.822
            },
            "gtin": "4000539033100",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54641d",
        "height": 1.2553,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ec03",
            "leftCorner": {
              "x": 11.764,
              "y": 25.813,
              "z": 1.027
            },
            "rightCorner": {
              "x": 11.829,
              "y": 25.807,
              "z": 1.027
            },
            "gtin": "7610400099905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec04",
            "leftCorner": {
              "x": 11.829,
              "y": 25.807,
              "z": 1.027
            },
            "rightCorner": {
              "x": 11.893,
              "y": 25.803,
              "z": 1.027
            },
            "gtin": "7610400099905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec05",
            "leftCorner": {
              "x": 11.893,
              "y": 25.8,
              "z": 1.027
            },
            "rightCorner": {
              "x": 11.972,
              "y": 25.793,
              "z": 1.027
            },
            "gtin": "3046920020688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec06",
            "leftCorner": {
              "x": 11.972,
              "y": 25.791,
              "z": 1.027
            },
            "rightCorner": {
              "x": 12.066,
              "y": 25.784,
              "z": 1.027
            },
            "gtin": "3046920022071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec07",
            "leftCorner": {
              "x": 12.067,
              "y": 25.786,
              "z": 1.027
            },
            "rightCorner": {
              "x": 12.143,
              "y": 25.78,
              "z": 1.027
            },
            "gtin": "7610400099882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec08",
            "leftCorner": {
              "x": 12.143,
              "y": 25.78,
              "z": 1.027
            },
            "rightCorner": {
              "x": 12.22,
              "y": 25.775,
              "z": 1.027
            },
            "gtin": "7610400099882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec09",
            "leftCorner": {
              "x": 12.22,
              "y": 25.775,
              "z": 1.027
            },
            "rightCorner": {
              "x": 12.296,
              "y": 25.768,
              "z": 1.027
            },
            "gtin": "7610400099882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec0a",
            "leftCorner": {
              "x": 12.295,
              "y": 25.762,
              "z": 1.027
            },
            "rightCorner": {
              "x": 12.33,
              "y": 25.76,
              "z": 1.027
            },
            "gtin": "3046920029674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec0b",
            "leftCorner": {
              "x": 12.33,
              "y": 25.76,
              "z": 1.027
            },
            "rightCorner": {
              "x": 12.364,
              "y": 25.757,
              "z": 1.027
            },
            "gtin": "3046920029674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec0c",
            "leftCorner": {
              "x": 12.365,
              "y": 25.77,
              "z": 1.027
            },
            "rightCorner": {
              "x": 12.489,
              "y": 25.761,
              "z": 1.027
            },
            "gtin": "4000539110184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec0d",
            "leftCorner": {
              "x": 12.489,
              "y": 25.758,
              "z": 1.027
            },
            "rightCorner": {
              "x": 12.536,
              "y": 25.754,
              "z": 1.027
            },
            "gtin": "3046920021722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec0e",
            "leftCorner": {
              "x": 12.535,
              "y": 25.743,
              "z": 1.027
            },
            "rightCorner": {
              "x": 12.598,
              "y": 25.739,
              "z": 1.027
            },
            "gtin": "7610400097208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec0f",
            "leftCorner": {
              "x": 12.598,
              "y": 25.739,
              "z": 1.027
            },
            "rightCorner": {
              "x": 12.66,
              "y": 25.733,
              "z": 1.027
            },
            "gtin": "7610400097208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec10",
            "leftCorner": {
              "x": 12.66,
              "y": 25.729,
              "z": 1.027
            },
            "rightCorner": {
              "x": 12.687,
              "y": 25.727,
              "z": 1.027
            },
            "gtin": "4000539224607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec11",
            "leftCorner": {
              "x": 12.687,
              "y": 25.727,
              "z": 1.027
            },
            "rightCorner": {
              "x": 12.714,
              "y": 25.724,
              "z": 1.027
            },
            "gtin": "4000539224607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec12",
            "leftCorner": {
              "x": 12.714,
              "y": 25.726,
              "z": 1.027
            },
            "rightCorner": {
              "x": 12.757,
              "y": 25.723,
              "z": 1.027
            },
            "gtin": "4000539221903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec13",
            "leftCorner": {
              "x": 12.757,
              "y": 25.723,
              "z": 1.027
            },
            "rightCorner": {
              "x": 12.801,
              "y": 25.72,
              "z": 1.027
            },
            "gtin": "4000539221903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec14",
            "leftCorner": {
              "x": 12.8,
              "y": 25.715,
              "z": 1.027
            },
            "rightCorner": {
              "x": 12.835,
              "y": 25.712,
              "z": 1.027
            },
            "gtin": "4000539221804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec15",
            "leftCorner": {
              "x": 12.835,
              "y": 25.712,
              "z": 1.027
            },
            "rightCorner": {
              "x": 12.87,
              "y": 25.709,
              "z": 1.027
            },
            "gtin": "4000539221804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec16",
            "leftCorner": {
              "x": 12.871,
              "y": 25.721,
              "z": 1.027
            },
            "rightCorner": {
              "x": 12.953,
              "y": 25.715,
              "z": 1.027
            },
            "gtin": "4000539222108",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54641e",
        "height": 1.5064,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ec72",
            "leftCorner": {
              "x": 11.773,
              "y": 25.808,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.846,
              "y": 25.803,
              "z": 1.232
            },
            "gtin": "3046920022156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec73",
            "leftCorner": {
              "x": 11.846,
              "y": 25.803,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.919,
              "y": 25.797,
              "z": 1.232
            },
            "gtin": "3046920022156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec74",
            "leftCorner": {
              "x": 11.919,
              "y": 25.797,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.992,
              "y": 25.792,
              "z": 1.232
            },
            "gtin": "3046920022156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec75",
            "leftCorner": {
              "x": 11.992,
              "y": 25.789,
              "z": 1.232
            },
            "rightCorner": {
              "x": 12.148,
              "y": 25.777,
              "z": 1.232
            },
            "gtin": "4000539113185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec76",
            "leftCorner": {
              "x": 12.148,
              "y": 25.777,
              "z": 1.232
            },
            "rightCorner": {
              "x": 12.304,
              "y": 25.765,
              "z": 1.232
            },
            "gtin": "4000539113185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec77",
            "leftCorner": {
              "x": 12.304,
              "y": 25.768,
              "z": 1.232
            },
            "rightCorner": {
              "x": 12.411,
              "y": 25.76,
              "z": 1.232
            },
            "gtin": "4000539003509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec78",
            "leftCorner": {
              "x": 12.411,
              "y": 25.76,
              "z": 1.232
            },
            "rightCorner": {
              "x": 12.517,
              "y": 25.751,
              "z": 1.232
            },
            "gtin": "4000539003509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec79",
            "leftCorner": {
              "x": 12.517,
              "y": 25.743,
              "z": 1.232
            },
            "rightCorner": {
              "x": 12.734,
              "y": 25.727,
              "z": 1.232
            },
            "gtin": "3046920029681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec7a",
            "leftCorner": {
              "x": 12.733,
              "y": 25.719,
              "z": 1.232
            },
            "rightCorner": {
              "x": 13.021,
              "y": 25.697,
              "z": 1.232
            },
            "gtin": "3046920029759",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54641a",
        "height": 1.7553,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eae7",
            "leftCorner": {
              "x": 11.782,
              "y": 25.817,
              "z": 1.436
            },
            "rightCorner": {
              "x": 11.833,
              "y": 25.813,
              "z": 1.436
            },
            "gtin": "4000539102585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eae8",
            "leftCorner": {
              "x": 11.833,
              "y": 25.813,
              "z": 1.436
            },
            "rightCorner": {
              "x": 11.885,
              "y": 25.809,
              "z": 1.436
            },
            "gtin": "4000539102585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eae9",
            "leftCorner": {
              "x": 11.884,
              "y": 25.797,
              "z": 1.436
            },
            "rightCorner": {
              "x": 11.961,
              "y": 25.792,
              "z": 1.436
            },
            "gtin": "3046920022132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaea",
            "leftCorner": {
              "x": 11.961,
              "y": 25.792,
              "z": 1.436
            },
            "rightCorner": {
              "x": 12.037,
              "y": 25.786,
              "z": 1.436
            },
            "gtin": "3046920022132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaeb",
            "leftCorner": {
              "x": 12.037,
              "y": 25.786,
              "z": 1.436
            },
            "rightCorner": {
              "x": 12.114,
              "y": 25.78,
              "z": 1.436
            },
            "gtin": "3046920022132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaec",
            "leftCorner": {
              "x": 12.114,
              "y": 25.78,
              "z": 1.436
            },
            "rightCorner": {
              "x": 12.191,
              "y": 25.774,
              "z": 1.436
            },
            "gtin": "3046920022132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaed",
            "leftCorner": {
              "x": 12.191,
              "y": 25.775,
              "z": 1.436
            },
            "rightCorner": {
              "x": 12.279,
              "y": 25.767,
              "z": 1.436
            },
            "gtin": "4000539102080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaee",
            "leftCorner": {
              "x": 12.279,
              "y": 25.767,
              "z": 1.436
            },
            "rightCorner": {
              "x": 12.367,
              "y": 25.761,
              "z": 1.436
            },
            "gtin": "4000539102080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaef",
            "leftCorner": {
              "x": 12.367,
              "y": 25.761,
              "z": 1.436
            },
            "rightCorner": {
              "x": 12.455,
              "y": 25.754,
              "z": 1.436
            },
            "gtin": "4000539102080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaf0",
            "leftCorner": {
              "x": 12.455,
              "y": 25.753,
              "z": 1.436
            },
            "rightCorner": {
              "x": 12.564,
              "y": 25.744,
              "z": 1.436
            },
            "gtin": "3046920028363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaf1",
            "leftCorner": {
              "x": 12.564,
              "y": 25.744,
              "z": 1.436
            },
            "rightCorner": {
              "x": 12.674,
              "y": 25.735,
              "z": 1.436
            },
            "gtin": "3046920028363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaf2",
            "leftCorner": {
              "x": 12.674,
              "y": 25.735,
              "z": 1.436
            },
            "rightCorner": {
              "x": 12.787,
              "y": 25.726,
              "z": 1.436
            },
            "gtin": "3046920020558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaf3",
            "leftCorner": {
              "x": 12.787,
              "y": 25.726,
              "z": 1.436
            },
            "rightCorner": {
              "x": 12.902,
              "y": 25.717,
              "z": 1.436
            },
            "gtin": "3046920020558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaf4",
            "leftCorner": {
              "x": 12.902,
              "y": 25.717,
              "z": 1.436
            },
            "rightCorner": {
              "x": 13.015,
              "y": 25.708,
              "z": 1.436
            },
            "gtin": "3046920020558",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41a88",
    "rightNeighborShelfId": "41a8a"
  },
  {
    "id": "41a8a",
    "name": "41a8a",
    "x": 12.957,
    "y": 25.668,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.038658,
      "w": 0.99925
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 86
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546862",
        "height": 0.15286,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ecde",
            "leftCorner": {
              "x": 13.07,
              "y": 25.704,
              "z": 0.125
            },
            "rightCorner": {
              "x": 13.129,
              "y": 25.699,
              "z": 0.125
            },
            "gtin": "4000956026389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecdf",
            "leftCorner": {
              "x": 13.129,
              "y": 25.699,
              "z": 0.125
            },
            "rightCorner": {
              "x": 13.187,
              "y": 25.695,
              "z": 0.125
            },
            "gtin": "4000956026389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ece0",
            "leftCorner": {
              "x": 13.187,
              "y": 25.695,
              "z": 0.125
            },
            "rightCorner": {
              "x": 13.245,
              "y": 25.691,
              "z": 0.125
            },
            "gtin": "4000956026389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ece1",
            "leftCorner": {
              "x": 13.247,
              "y": 25.708,
              "z": 0.125
            },
            "rightCorner": {
              "x": 13.428,
              "y": 25.694,
              "z": 0.125
            },
            "gtin": "4000956026143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ece2",
            "leftCorner": {
              "x": 13.427,
              "y": 25.677,
              "z": 0.125
            },
            "rightCorner": {
              "x": 13.474,
              "y": 25.674,
              "z": 0.125
            },
            "gtin": "4000956026518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ece3",
            "leftCorner": {
              "x": 13.474,
              "y": 25.674,
              "z": 0.125
            },
            "rightCorner": {
              "x": 13.52,
              "y": 25.67,
              "z": 0.125
            },
            "gtin": "4000956026518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ece4",
            "leftCorner": {
              "x": 13.52,
              "y": 25.67,
              "z": 0.125
            },
            "rightCorner": {
              "x": 13.567,
              "y": 25.666,
              "z": 0.125
            },
            "gtin": "4000956026518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ece5",
            "leftCorner": {
              "x": 13.568,
              "y": 25.672,
              "z": 0.125
            },
            "rightCorner": {
              "x": 13.668,
              "y": 25.665,
              "z": 0.125
            },
            "gtin": "4000956022190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ece6",
            "leftCorner": {
              "x": 13.668,
              "y": 25.665,
              "z": 0.125
            },
            "rightCorner": {
              "x": 13.769,
              "y": 25.657,
              "z": 0.125
            },
            "gtin": "4000956022190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ece7",
            "leftCorner": {
              "x": 13.768,
              "y": 25.651,
              "z": 0.125
            },
            "rightCorner": {
              "x": 13.823,
              "y": 25.647,
              "z": 0.125
            },
            "gtin": "4000956024118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ece8",
            "leftCorner": {
              "x": 13.823,
              "y": 25.647,
              "z": 0.125
            },
            "rightCorner": {
              "x": 13.877,
              "y": 25.643,
              "z": 0.125
            },
            "gtin": "4000956024118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ece9",
            "leftCorner": {
              "x": 13.878,
              "y": 25.651,
              "z": 0.125
            },
            "rightCorner": {
              "x": 13.932,
              "y": 25.647,
              "z": 0.125
            },
            "gtin": "4000956024101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecea",
            "leftCorner": {
              "x": 13.932,
              "y": 25.647,
              "z": 0.125
            },
            "rightCorner": {
              "x": 13.987,
              "y": 25.642,
              "z": 0.125
            },
            "gtin": "4000956024101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eceb",
            "leftCorner": {
              "x": 13.985,
              "y": 25.628,
              "z": 0.125
            },
            "rightCorner": {
              "x": 14.062,
              "y": 25.621,
              "z": 0.125
            },
            "gtin": "4000956024125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecec",
            "leftCorner": {
              "x": 14.063,
              "y": 25.634,
              "z": 0.125
            },
            "rightCorner": {
              "x": 14.127,
              "y": 25.63,
              "z": 0.125
            },
            "gtin": "4000956024293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eced",
            "leftCorner": {
              "x": 14.127,
              "y": 25.63,
              "z": 0.125
            },
            "rightCorner": {
              "x": 14.192,
              "y": 25.625,
              "z": 0.125
            },
            "gtin": "4000956024293",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54685d",
        "height": 0.44776,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ed49",
            "leftCorner": {
              "x": 12.939,
              "y": 25.721,
              "z": 0.366
            },
            "rightCorner": {
              "x": 13.045,
              "y": 25.713,
              "z": 0.366
            },
            "gtin": "4000956021698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed4a",
            "leftCorner": {
              "x": 13.045,
              "y": 25.713,
              "z": 0.366
            },
            "rightCorner": {
              "x": 13.15,
              "y": 25.705,
              "z": 0.366
            },
            "gtin": "4000956021698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed4b",
            "leftCorner": {
              "x": 13.15,
              "y": 25.705,
              "z": 0.366
            },
            "rightCorner": {
              "x": 13.257,
              "y": 25.696,
              "z": 0.366
            },
            "gtin": "4000956021698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed4c",
            "leftCorner": {
              "x": 13.256,
              "y": 25.689,
              "z": 0.366
            },
            "rightCorner": {
              "x": 13.372,
              "y": 25.681,
              "z": 0.366
            },
            "gtin": "4000956021780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed4d",
            "leftCorner": {
              "x": 13.373,
              "y": 25.683,
              "z": 0.366
            },
            "rightCorner": {
              "x": 13.481,
              "y": 25.675,
              "z": 0.366
            },
            "gtin": "4000956021155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed4e",
            "leftCorner": {
              "x": 13.482,
              "y": 25.687,
              "z": 0.366
            },
            "rightCorner": {
              "x": 13.607,
              "y": 25.678,
              "z": 0.366
            },
            "gtin": "4000956021636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed4f",
            "leftCorner": {
              "x": 13.607,
              "y": 25.678,
              "z": 0.366
            },
            "rightCorner": {
              "x": 13.731,
              "y": 25.668,
              "z": 0.366
            },
            "gtin": "4000956021636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed50",
            "leftCorner": {
              "x": 13.731,
              "y": 25.668,
              "z": 0.366
            },
            "rightCorner": {
              "x": 13.856,
              "y": 25.659,
              "z": 0.366
            },
            "gtin": "4000956021636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed51",
            "leftCorner": {
              "x": 13.856,
              "y": 25.659,
              "z": 0.366
            },
            "rightCorner": {
              "x": 13.981,
              "y": 25.649,
              "z": 0.366
            },
            "gtin": "4000956021636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed52",
            "leftCorner": {
              "x": 13.979,
              "y": 25.633,
              "z": 0.366
            },
            "rightCorner": {
              "x": 14.092,
              "y": 25.625,
              "z": 0.366
            },
            "gtin": "4000956021148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed53",
            "leftCorner": {
              "x": 14.092,
              "y": 25.625,
              "z": 0.366
            },
            "rightCorner": {
              "x": 14.205,
              "y": 25.616,
              "z": 0.366
            },
            "gtin": "4000956021148",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546863",
        "height": 0.75102,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ebae",
            "leftCorner": {
              "x": 13.378,
              "y": 25.688,
              "z": 0.614
            },
            "rightCorner": {
              "x": 13.504,
              "y": 25.679,
              "z": 0.614
            },
            "gtin": "7610400068482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebaf",
            "leftCorner": {
              "x": 13.504,
              "y": 25.679,
              "z": 0.614
            },
            "rightCorner": {
              "x": 13.562,
              "y": 25.674,
              "z": 0.614
            },
            "gtin": "7610400100045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebb0",
            "leftCorner": {
              "x": 13.562,
              "y": 25.674,
              "z": 0.614
            },
            "rightCorner": {
              "x": 13.621,
              "y": 25.669,
              "z": 0.614
            },
            "gtin": "7610400100045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebb1",
            "leftCorner": {
              "x": 13.621,
              "y": 25.669,
              "z": 0.614
            },
            "rightCorner": {
              "x": 13.782,
              "y": 25.657,
              "z": 0.614
            },
            "gtin": "7610400100052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebb2",
            "leftCorner": {
              "x": 13.782,
              "y": 25.657,
              "z": 0.614
            },
            "rightCorner": {
              "x": 13.942,
              "y": 25.645,
              "z": 0.614
            },
            "gtin": "7610400100052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebb3",
            "leftCorner": {
              "x": 13.941,
              "y": 25.644,
              "z": 0.614
            },
            "rightCorner": {
              "x": 14.24,
              "y": 25.621,
              "z": 0.614
            },
            "gtin": "7610400100069",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54685f",
        "height": 1.0036,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eb5b",
            "leftCorner": {
              "x": 13.042,
              "y": 25.669,
              "z": 0.821
            },
            "rightCorner": {
              "x": 13.235,
              "y": 25.654,
              "z": 0.821
            },
            "gtin": "4000539281501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb5c",
            "leftCorner": {
              "x": 13.237,
              "y": 25.684,
              "z": 0.821
            },
            "rightCorner": {
              "x": 13.431,
              "y": 25.669,
              "z": 0.821
            },
            "gtin": "3046920021821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb5d",
            "leftCorner": {
              "x": 13.431,
              "y": 25.676,
              "z": 0.821
            },
            "rightCorner": {
              "x": 13.534,
              "y": 25.668,
              "z": 0.821
            },
            "gtin": "3046920021555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb5e",
            "leftCorner": {
              "x": 13.534,
              "y": 25.672,
              "z": 0.821
            },
            "rightCorner": {
              "x": 13.633,
              "y": 25.665,
              "z": 0.821
            },
            "gtin": "3046920021845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb5f",
            "leftCorner": {
              "x": 13.631,
              "y": 25.657,
              "z": 0.821
            },
            "rightCorner": {
              "x": 13.748,
              "y": 25.647,
              "z": 0.821
            },
            "gtin": "3046920021807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb60",
            "leftCorner": {
              "x": 13.748,
              "y": 25.648,
              "z": 0.821
            },
            "rightCorner": {
              "x": 13.863,
              "y": 25.64,
              "z": 0.821
            },
            "gtin": "3046920021838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb61",
            "leftCorner": {
              "x": 13.863,
              "y": 25.64,
              "z": 0.821
            },
            "rightCorner": {
              "x": 13.977,
              "y": 25.63,
              "z": 0.821
            },
            "gtin": "3046920021838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb62",
            "leftCorner": {
              "x": 13.977,
              "y": 25.63,
              "z": 0.821
            },
            "rightCorner": {
              "x": 14.092,
              "y": 25.622,
              "z": 0.821
            },
            "gtin": "3046920021838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb63",
            "leftCorner": {
              "x": 14.092,
              "y": 25.622,
              "z": 0.821
            },
            "rightCorner": {
              "x": 14.207,
              "y": 25.612,
              "z": 0.821
            },
            "gtin": "3046920021838",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54685e",
        "height": 1.2538,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ec17",
            "leftCorner": {
              "x": 12.953,
              "y": 25.713,
              "z": 1.026
            },
            "rightCorner": {
              "x": 13.002,
              "y": 25.709,
              "z": 1.026
            },
            "gtin": "4000539245701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec18",
            "leftCorner": {
              "x": 13.002,
              "y": 25.705,
              "z": 1.026
            },
            "rightCorner": {
              "x": 13.043,
              "y": 25.701,
              "z": 1.026
            },
            "gtin": "4000539245305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec19",
            "leftCorner": {
              "x": 13.043,
              "y": 25.693,
              "z": 1.026
            },
            "rightCorner": {
              "x": 13.086,
              "y": 25.69,
              "z": 1.026
            },
            "gtin": "4000539245404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec1a",
            "leftCorner": {
              "x": 13.086,
              "y": 25.69,
              "z": 1.026
            },
            "rightCorner": {
              "x": 13.129,
              "y": 25.687,
              "z": 1.026
            },
            "gtin": "4000539245404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec1b",
            "leftCorner": {
              "x": 13.131,
              "y": 25.705,
              "z": 1.026
            },
            "rightCorner": {
              "x": 13.225,
              "y": 25.698,
              "z": 1.026
            },
            "gtin": "4000539245503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec1c",
            "leftCorner": {
              "x": 13.225,
              "y": 25.699,
              "z": 1.026
            },
            "rightCorner": {
              "x": 13.362,
              "y": 25.688,
              "z": 1.026
            },
            "gtin": "7610400099943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec1d",
            "leftCorner": {
              "x": 13.362,
              "y": 25.689,
              "z": 1.026
            },
            "rightCorner": {
              "x": 13.46,
              "y": 25.682,
              "z": 1.026
            },
            "gtin": "8003340803227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec1e",
            "leftCorner": {
              "x": 13.459,
              "y": 25.664,
              "z": 1.026
            },
            "rightCorner": {
              "x": 13.555,
              "y": 25.656,
              "z": 1.026
            },
            "gtin": "8003340803203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec1f",
            "leftCorner": {
              "x": 13.555,
              "y": 25.656,
              "z": 1.026
            },
            "rightCorner": {
              "x": 13.652,
              "y": 25.649,
              "z": 1.026
            },
            "gtin": "8003340803203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec20",
            "leftCorner": {
              "x": 13.653,
              "y": 25.661,
              "z": 1.026
            },
            "rightCorner": {
              "x": 13.774,
              "y": 25.651,
              "z": 1.026
            },
            "gtin": "8003340803241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec21",
            "leftCorner": {
              "x": 13.774,
              "y": 25.649,
              "z": 1.026
            },
            "rightCorner": {
              "x": 13.856,
              "y": 25.642,
              "z": 1.026
            },
            "gtin": "7610400110679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec22",
            "leftCorner": {
              "x": 13.856,
              "y": 25.642,
              "z": 1.026
            },
            "rightCorner": {
              "x": 13.938,
              "y": 25.635,
              "z": 1.026
            },
            "gtin": "7610400110679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec23",
            "leftCorner": {
              "x": 13.938,
              "y": 25.635,
              "z": 1.026
            },
            "rightCorner": {
              "x": 14.02,
              "y": 25.63,
              "z": 1.026
            },
            "gtin": "7610400110679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec24",
            "leftCorner": {
              "x": 14.019,
              "y": 25.622,
              "z": 1.026
            },
            "rightCorner": {
              "x": 14.088,
              "y": 25.617,
              "z": 1.026
            },
            "gtin": "7610400099981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec25",
            "leftCorner": {
              "x": 14.087,
              "y": 25.605,
              "z": 1.026
            },
            "rightCorner": {
              "x": 14.221,
              "y": 25.594,
              "z": 1.026
            },
            "gtin": "8003340803265",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546860",
        "height": 1.5049,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ec7b",
            "leftCorner": {
              "x": 13.021,
              "y": 25.705,
              "z": 1.231
            },
            "rightCorner": {
              "x": 13.091,
              "y": 25.7,
              "z": 1.231
            },
            "gtin": "4000539139307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec7c",
            "leftCorner": {
              "x": 13.091,
              "y": 25.7,
              "z": 1.231
            },
            "rightCorner": {
              "x": 13.161,
              "y": 25.695,
              "z": 1.231
            },
            "gtin": "4000539139307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec7d",
            "leftCorner": {
              "x": 13.161,
              "y": 25.698,
              "z": 1.231
            },
            "rightCorner": {
              "x": 13.215,
              "y": 25.694,
              "z": 1.231
            },
            "gtin": "4000539019807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec7e",
            "leftCorner": {
              "x": 13.215,
              "y": 25.694,
              "z": 1.231
            },
            "rightCorner": {
              "x": 13.269,
              "y": 25.69,
              "z": 1.231
            },
            "gtin": "4000539019807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec7f",
            "leftCorner": {
              "x": 13.269,
              "y": 25.69,
              "z": 1.231
            },
            "rightCorner": {
              "x": 13.324,
              "y": 25.686,
              "z": 1.231
            },
            "gtin": "4000539019807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec80",
            "leftCorner": {
              "x": 13.324,
              "y": 25.684,
              "z": 1.231
            },
            "rightCorner": {
              "x": 13.402,
              "y": 25.678,
              "z": 1.231
            },
            "gtin": "7610400097345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec81",
            "leftCorner": {
              "x": 13.402,
              "y": 25.676,
              "z": 1.231
            },
            "rightCorner": {
              "x": 13.463,
              "y": 25.671,
              "z": 1.231
            },
            "gtin": "7610400097352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec82",
            "leftCorner": {
              "x": 13.463,
              "y": 25.671,
              "z": 1.231
            },
            "rightCorner": {
              "x": 13.523,
              "y": 25.667,
              "z": 1.231
            },
            "gtin": "7610400097352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec83",
            "leftCorner": {
              "x": 13.523,
              "y": 25.667,
              "z": 1.231
            },
            "rightCorner": {
              "x": 13.583,
              "y": 25.663,
              "z": 1.231
            },
            "gtin": "7610400097352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec84",
            "leftCorner": {
              "x": 13.583,
              "y": 25.665,
              "z": 1.231
            },
            "rightCorner": {
              "x": 13.673,
              "y": 25.657,
              "z": 1.231
            },
            "gtin": "7610400097369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec85",
            "leftCorner": {
              "x": 13.673,
              "y": 25.657,
              "z": 1.231
            },
            "rightCorner": {
              "x": 13.762,
              "y": 25.65,
              "z": 1.231
            },
            "gtin": "7610400097369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec86",
            "leftCorner": {
              "x": 13.762,
              "y": 25.637,
              "z": 1.231
            },
            "rightCorner": {
              "x": 13.86,
              "y": 25.63,
              "z": 1.231
            },
            "gtin": "4000539113246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec87",
            "leftCorner": {
              "x": 13.86,
              "y": 25.63,
              "z": 1.231
            },
            "rightCorner": {
              "x": 13.959,
              "y": 25.622,
              "z": 1.231
            },
            "gtin": "4000539113246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec88",
            "leftCorner": {
              "x": 13.959,
              "y": 25.618,
              "z": 1.231
            },
            "rightCorner": {
              "x": 14.068,
              "y": 25.609,
              "z": 1.231
            },
            "gtin": "3046920022262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec89",
            "leftCorner": {
              "x": 14.07,
              "y": 25.618,
              "z": 1.231
            },
            "rightCorner": {
              "x": 14.184,
              "y": 25.609,
              "z": 1.231
            },
            "gtin": "4000539118708",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546861",
        "height": 1.7586,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eaf5",
            "leftCorner": {
              "x": 13.014,
              "y": 25.704,
              "z": 1.439
            },
            "rightCorner": {
              "x": 13.112,
              "y": 25.696,
              "z": 1.439
            },
            "gtin": "4000539014109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaf6",
            "leftCorner": {
              "x": 13.112,
              "y": 25.696,
              "z": 1.439
            },
            "rightCorner": {
              "x": 13.211,
              "y": 25.689,
              "z": 1.439
            },
            "gtin": "4000539014109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaf7",
            "leftCorner": {
              "x": 13.211,
              "y": 25.697,
              "z": 1.439
            },
            "rightCorner": {
              "x": 13.3,
              "y": 25.691,
              "z": 1.439
            },
            "gtin": "4000539113741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaf8",
            "leftCorner": {
              "x": 13.3,
              "y": 25.688,
              "z": 1.439
            },
            "rightCorner": {
              "x": 13.395,
              "y": 25.68,
              "z": 1.439
            },
            "gtin": "4000539014307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaf9",
            "leftCorner": {
              "x": 13.395,
              "y": 25.68,
              "z": 1.439
            },
            "rightCorner": {
              "x": 13.491,
              "y": 25.673,
              "z": 1.439
            },
            "gtin": "4000539014307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eafa",
            "leftCorner": {
              "x": 13.491,
              "y": 25.673,
              "z": 1.439
            },
            "rightCorner": {
              "x": 13.587,
              "y": 25.665,
              "z": 1.439
            },
            "gtin": "4000539014307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eafb",
            "leftCorner": {
              "x": 13.587,
              "y": 25.66,
              "z": 1.439
            },
            "rightCorner": {
              "x": 13.64,
              "y": 25.656,
              "z": 1.439
            },
            "gtin": "4000539014000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eafc",
            "leftCorner": {
              "x": 13.64,
              "y": 25.656,
              "z": 1.439
            },
            "rightCorner": {
              "x": 13.693,
              "y": 25.652,
              "z": 1.439
            },
            "gtin": "4000539014000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eafd",
            "leftCorner": {
              "x": 13.693,
              "y": 25.652,
              "z": 1.439
            },
            "rightCorner": {
              "x": 13.747,
              "y": 25.648,
              "z": 1.439
            },
            "gtin": "4000539014000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eafe",
            "leftCorner": {
              "x": 13.745,
              "y": 25.636,
              "z": 1.439
            },
            "rightCorner": {
              "x": 13.855,
              "y": 25.628,
              "z": 1.439
            },
            "gtin": "4000539021404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaff",
            "leftCorner": {
              "x": 13.855,
              "y": 25.628,
              "z": 1.439
            },
            "rightCorner": {
              "x": 13.965,
              "y": 25.62,
              "z": 1.439
            },
            "gtin": "4000539021404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb00",
            "leftCorner": {
              "x": 13.965,
              "y": 25.615,
              "z": 1.439
            },
            "rightCorner": {
              "x": 14.118,
              "y": 25.603,
              "z": 1.439
            },
            "gtin": "4000539084805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb01",
            "leftCorner": {
              "x": 14.118,
              "y": 25.603,
              "z": 1.439
            },
            "rightCorner": {
              "x": 14.272,
              "y": 25.591,
              "z": 1.439
            },
            "gtin": "4000539084805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb02",
            "leftCorner": {
              "x": 14.272,
              "y": 25.591,
              "z": 1.439
            },
            "rightCorner": {
              "x": 14.425,
              "y": 25.58,
              "z": 1.439
            },
            "gtin": "4000539084805",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41a89",
    "rightNeighborShelfId": "41a8b"
  },
  {
    "id": "41a8b",
    "name": "41a8b",
    "x": 14.154,
    "y": 25.575,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.038658,
      "w": 0.99925
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 80
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5467f6",
        "height": 0.15313,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ecee",
            "leftCorner": {
              "x": 14.192,
              "y": 25.625,
              "z": 0.125
            },
            "rightCorner": {
              "x": 14.336,
              "y": 25.613,
              "z": 0.125
            },
            "gtin": "4001743760196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecef",
            "leftCorner": {
              "x": 14.337,
              "y": 25.617,
              "z": 0.125
            },
            "rightCorner": {
              "x": 14.47,
              "y": 25.607,
              "z": 0.125
            },
            "gtin": "4001743760219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecf0",
            "leftCorner": {
              "x": 14.469,
              "y": 25.606,
              "z": 0.125
            },
            "rightCorner": {
              "x": 14.552,
              "y": 25.6,
              "z": 0.125
            },
            "gtin": "4001743760240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecf1",
            "leftCorner": {
              "x": 14.552,
              "y": 25.6,
              "z": 0.125
            },
            "rightCorner": {
              "x": 14.635,
              "y": 25.593,
              "z": 0.125
            },
            "gtin": "4001743760240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecf2",
            "leftCorner": {
              "x": 14.635,
              "y": 25.585,
              "z": 0.125
            },
            "rightCorner": {
              "x": 14.796,
              "y": 25.572,
              "z": 0.125
            },
            "gtin": "4001743760226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecf3",
            "leftCorner": {
              "x": 14.796,
              "y": 25.573,
              "z": 0.125
            },
            "rightCorner": {
              "x": 14.932,
              "y": 25.562,
              "z": 0.125
            },
            "gtin": "4001743760189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ecf4",
            "leftCorner": {
              "x": 14.932,
              "y": 25.573,
              "z": 0.125
            },
            "rightCorner": {
              "x": 15.057,
              "y": 25.564,
              "z": 0.125
            },
            "gtin": "4001743760257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ecf5",
            "leftCorner": {
              "x": 15.056,
              "y": 25.547,
              "z": 0.125
            },
            "rightCorner": {
              "x": 15.21,
              "y": 25.535,
              "z": 0.125
            },
            "gtin": "4001743760288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ecf6",
            "leftCorner": {
              "x": 15.21,
              "y": 25.534,
              "z": 0.125
            },
            "rightCorner": {
              "x": 15.368,
              "y": 25.522,
              "z": 0.125
            },
            "gtin": "4001743760264",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467f4",
        "height": 0.45087,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ed54",
            "leftCorner": {
              "x": 14.206,
              "y": 25.617,
              "z": 0.369
            },
            "rightCorner": {
              "x": 14.253,
              "y": 25.614,
              "z": 0.369
            },
            "gtin": "4000607000126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed55",
            "leftCorner": {
              "x": 14.253,
              "y": 25.614,
              "z": 0.369
            },
            "rightCorner": {
              "x": 14.298,
              "y": 25.611,
              "z": 0.369
            },
            "gtin": "4000607000126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed56",
            "leftCorner": {
              "x": 14.298,
              "y": 25.611,
              "z": 0.369
            },
            "rightCorner": {
              "x": 14.344,
              "y": 25.607,
              "z": 0.369
            },
            "gtin": "4000607000126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed57",
            "leftCorner": {
              "x": 14.344,
              "y": 25.607,
              "z": 0.369
            },
            "rightCorner": {
              "x": 14.39,
              "y": 25.603,
              "z": 0.369
            },
            "gtin": "4000607000126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed58",
            "leftCorner": {
              "x": 14.39,
              "y": 25.605,
              "z": 0.369
            },
            "rightCorner": {
              "x": 14.468,
              "y": 25.599,
              "z": 0.369
            },
            "gtin": "4000607000171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed59",
            "leftCorner": {
              "x": 14.468,
              "y": 25.599,
              "z": 0.369
            },
            "rightCorner": {
              "x": 14.545,
              "y": 25.593,
              "z": 0.369
            },
            "gtin": "4000607000171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed5a",
            "leftCorner": {
              "x": 14.545,
              "y": 25.601,
              "z": 0.369
            },
            "rightCorner": {
              "x": 14.617,
              "y": 25.595,
              "z": 0.369
            },
            "gtin": "4000607000140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed5b",
            "leftCorner": {
              "x": 14.617,
              "y": 25.595,
              "z": 0.369
            },
            "rightCorner": {
              "x": 14.688,
              "y": 25.589,
              "z": 0.369
            },
            "gtin": "4000607000140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed5c",
            "leftCorner": {
              "x": 14.688,
              "y": 25.579,
              "z": 0.369
            },
            "rightCorner": {
              "x": 14.888,
              "y": 25.564,
              "z": 0.369
            },
            "gtin": "4000607000164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed5d",
            "leftCorner": {
              "x": 14.888,
              "y": 25.567,
              "z": 0.369
            },
            "rightCorner": {
              "x": 15.051,
              "y": 25.555,
              "z": 0.369
            },
            "gtin": "4000607000133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed5e",
            "leftCorner": {
              "x": 15.051,
              "y": 25.555,
              "z": 0.369
            },
            "rightCorner": {
              "x": 15.132,
              "y": 25.548,
              "z": 0.369
            },
            "gtin": "4000607000157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed5f",
            "leftCorner": {
              "x": 15.132,
              "y": 25.548,
              "z": 0.369
            },
            "rightCorner": {
              "x": 15.211,
              "y": 25.542,
              "z": 0.369
            },
            "gtin": "4000607000157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed60",
            "leftCorner": {
              "x": 15.212,
              "y": 25.548,
              "z": 0.369
            },
            "rightCorner": {
              "x": 15.379,
              "y": 25.535,
              "z": 0.369
            },
            "gtin": "4001743760202",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467f7",
        "height": 0.75247,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ebb4",
            "leftCorner": {
              "x": 14.242,
              "y": 25.619,
              "z": 0.616
            },
            "rightCorner": {
              "x": 14.293,
              "y": 25.615,
              "z": 0.616
            },
            "gtin": "7622201783297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebb5",
            "leftCorner": {
              "x": 14.293,
              "y": 25.615,
              "z": 0.616
            },
            "rightCorner": {
              "x": 14.343,
              "y": 25.611,
              "z": 0.616
            },
            "gtin": "7622201783297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebb6",
            "leftCorner": {
              "x": 14.343,
              "y": 25.611,
              "z": 0.616
            },
            "rightCorner": {
              "x": 14.394,
              "y": 25.607,
              "z": 0.616
            },
            "gtin": "7622201783297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebb7",
            "leftCorner": {
              "x": 14.394,
              "y": 25.607,
              "z": 0.616
            },
            "rightCorner": {
              "x": 14.446,
              "y": 25.603,
              "z": 0.616
            },
            "gtin": "7622201783297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebb8",
            "leftCorner": {
              "x": 14.446,
              "y": 25.606,
              "z": 0.616
            },
            "rightCorner": {
              "x": 14.553,
              "y": 25.597,
              "z": 0.616
            },
            "gtin": "7622201680121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebb9",
            "leftCorner": {
              "x": 14.553,
              "y": 25.597,
              "z": 0.616
            },
            "rightCorner": {
              "x": 14.661,
              "y": 25.589,
              "z": 0.616
            },
            "gtin": "7622201680121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebba",
            "leftCorner": {
              "x": 14.661,
              "y": 25.589,
              "z": 0.616
            },
            "rightCorner": {
              "x": 14.886,
              "y": 25.572,
              "z": 0.616
            },
            "gtin": "7622201783365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebbb",
            "leftCorner": {
              "x": 14.888,
              "y": 25.58,
              "z": 0.616
            },
            "rightCorner": {
              "x": 15.088,
              "y": 25.564,
              "z": 0.616
            },
            "gtin": "7622201783396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebbc",
            "leftCorner": {
              "x": 15.087,
              "y": 25.557,
              "z": 0.616
            },
            "rightCorner": {
              "x": 15.153,
              "y": 25.552,
              "z": 0.616
            },
            "gtin": "753854584119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebbd",
            "leftCorner": {
              "x": 15.153,
              "y": 25.552,
              "z": 0.616
            },
            "rightCorner": {
              "x": 15.218,
              "y": 25.547,
              "z": 0.616
            },
            "gtin": "753854584119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebbe",
            "leftCorner": {
              "x": 15.217,
              "y": 25.54,
              "z": 0.616
            },
            "rightCorner": {
              "x": 15.27,
              "y": 25.536,
              "z": 0.616
            },
            "gtin": "753854500140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebbf",
            "leftCorner": {
              "x": 15.27,
              "y": 25.536,
              "z": 0.616
            },
            "rightCorner": {
              "x": 15.323,
              "y": 25.532,
              "z": 0.616
            },
            "gtin": "753854500140",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467f3",
        "height": 1.0034,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eb64",
            "leftCorner": {
              "x": 14.208,
              "y": 25.614,
              "z": 0.821
            },
            "rightCorner": {
              "x": 14.283,
              "y": 25.608,
              "z": 0.821
            },
            "gtin": "8720701143234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb65",
            "leftCorner": {
              "x": 14.283,
              "y": 25.608,
              "z": 0.821
            },
            "rightCorner": {
              "x": 14.359,
              "y": 25.601,
              "z": 0.821
            },
            "gtin": "8720701143234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb66",
            "leftCorner": {
              "x": 14.359,
              "y": 25.595,
              "z": 0.821
            },
            "rightCorner": {
              "x": 14.531,
              "y": 25.582,
              "z": 0.821
            },
            "gtin": "8719956497094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb67",
            "leftCorner": {
              "x": 14.531,
              "y": 25.597,
              "z": 0.821
            },
            "rightCorner": {
              "x": 14.717,
              "y": 25.582,
              "z": 0.821
            },
            "gtin": "8717677338054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb68",
            "leftCorner": {
              "x": 14.716,
              "y": 25.569,
              "z": 0.821
            },
            "rightCorner": {
              "x": 14.763,
              "y": 25.566,
              "z": 0.821
            },
            "gtin": "8717677338016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb69",
            "leftCorner": {
              "x": 14.763,
              "y": 25.566,
              "z": 0.821
            },
            "rightCorner": {
              "x": 14.811,
              "y": 25.562,
              "z": 0.821
            },
            "gtin": "8717677338016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb6a",
            "leftCorner": {
              "x": 14.811,
              "y": 25.562,
              "z": 0.821
            },
            "rightCorner": {
              "x": 14.858,
              "y": 25.558,
              "z": 0.821
            },
            "gtin": "8717677338016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb6b",
            "leftCorner": {
              "x": 14.858,
              "y": 25.562,
              "z": 0.821
            },
            "rightCorner": {
              "x": 15.024,
              "y": 25.549,
              "z": 0.821
            },
            "gtin": "8720701144293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb6c",
            "leftCorner": {
              "x": 15.024,
              "y": 25.561,
              "z": 0.821
            },
            "rightCorner": {
              "x": 15.1,
              "y": 25.555,
              "z": 0.821
            },
            "gtin": "8717677337996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb6d",
            "leftCorner": {
              "x": 15.1,
              "y": 25.555,
              "z": 0.821
            },
            "rightCorner": {
              "x": 15.175,
              "y": 25.55,
              "z": 0.821
            },
            "gtin": "8717677337996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb2a",
            "leftCorner": {
              "x": 15.173,
              "y": 25.531,
              "z": 0.821
            },
            "rightCorner": {
              "x": 15.263,
              "y": 25.523,
              "z": 0.821
            },
            "gtin": "8717677339143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb2b",
            "leftCorner": {
              "x": 15.263,
              "y": 25.523,
              "z": 0.821
            },
            "rightCorner": {
              "x": 15.353,
              "y": 25.516,
              "z": 0.821
            },
            "gtin": "8717677339143",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467f8",
        "height": 1.2583,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ec26",
            "leftCorner": {
              "x": 14.223,
              "y": 25.612,
              "z": 1.03
            },
            "rightCorner": {
              "x": 14.423,
              "y": 25.597,
              "z": 1.03
            },
            "gtin": "4000607055102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec27",
            "leftCorner": {
              "x": 14.423,
              "y": 25.599,
              "z": 1.03
            },
            "rightCorner": {
              "x": 14.491,
              "y": 25.594,
              "z": 1.03
            },
            "gtin": "3830053875563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec28",
            "leftCorner": {
              "x": 14.491,
              "y": 25.594,
              "z": 1.03
            },
            "rightCorner": {
              "x": 14.559,
              "y": 25.589,
              "z": 1.03
            },
            "gtin": "3830053875563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec29",
            "leftCorner": {
              "x": 14.558,
              "y": 25.585,
              "z": 1.03
            },
            "rightCorner": {
              "x": 14.686,
              "y": 25.575,
              "z": 1.03
            },
            "gtin": "3830053876492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec2a",
            "leftCorner": {
              "x": 14.686,
              "y": 25.568,
              "z": 1.03
            },
            "rightCorner": {
              "x": 14.764,
              "y": 25.563,
              "z": 1.03
            },
            "gtin": "8720701145696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec2b",
            "leftCorner": {
              "x": 14.764,
              "y": 25.571,
              "z": 1.03
            },
            "rightCorner": {
              "x": 14.871,
              "y": 25.562,
              "z": 1.03
            },
            "gtin": "8720701145733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec2c",
            "leftCorner": {
              "x": 14.871,
              "y": 25.562,
              "z": 1.03
            },
            "rightCorner": {
              "x": 14.977,
              "y": 25.554,
              "z": 1.03
            },
            "gtin": "8720701145733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec2d",
            "leftCorner": {
              "x": 14.978,
              "y": 25.568,
              "z": 1.03
            },
            "rightCorner": {
              "x": 15.064,
              "y": 25.561,
              "z": 1.03
            },
            "gtin": "4337185589379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec2e",
            "leftCorner": {
              "x": 15.064,
              "y": 25.561,
              "z": 1.03
            },
            "rightCorner": {
              "x": 15.15,
              "y": 25.554,
              "z": 1.03
            },
            "gtin": "4337185589379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec2f",
            "leftCorner": {
              "x": 15.15,
              "y": 25.545,
              "z": 1.03
            },
            "rightCorner": {
              "x": 15.196,
              "y": 25.542,
              "z": 1.03
            },
            "gtin": "4063367401084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec30",
            "leftCorner": {
              "x": 15.196,
              "y": 25.542,
              "z": 1.03
            },
            "rightCorner": {
              "x": 15.243,
              "y": 25.538,
              "z": 1.03
            },
            "gtin": "4063367401084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec31",
            "leftCorner": {
              "x": 15.243,
              "y": 25.538,
              "z": 1.03
            },
            "rightCorner": {
              "x": 15.29,
              "y": 25.534,
              "z": 1.03
            },
            "gtin": "4063367401084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec32",
            "leftCorner": {
              "x": 15.29,
              "y": 25.534,
              "z": 1.03
            },
            "rightCorner": {
              "x": 15.338,
              "y": 25.531,
              "z": 1.03
            },
            "gtin": "4063367401084",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467f5",
        "height": 1.5047,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ec8a",
            "leftCorner": {
              "x": 14.184,
              "y": 25.607,
              "z": 1.231
            },
            "rightCorner": {
              "x": 14.264,
              "y": 25.6,
              "z": 1.231
            },
            "gtin": "4013320066379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec8b",
            "leftCorner": {
              "x": 14.264,
              "y": 25.602,
              "z": 1.231
            },
            "rightCorner": {
              "x": 14.306,
              "y": 25.599,
              "z": 1.231
            },
            "gtin": "4013320296677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec8c",
            "leftCorner": {
              "x": 14.305,
              "y": 25.597,
              "z": 1.231
            },
            "rightCorner": {
              "x": 14.372,
              "y": 25.592,
              "z": 1.231
            },
            "gtin": "4013320185803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec8d",
            "leftCorner": {
              "x": 14.372,
              "y": 25.6,
              "z": 1.231
            },
            "rightCorner": {
              "x": 14.423,
              "y": 25.596,
              "z": 1.231
            },
            "gtin": "4013320066393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec8e",
            "leftCorner": {
              "x": 14.422,
              "y": 25.593,
              "z": 1.231
            },
            "rightCorner": {
              "x": 14.455,
              "y": 25.59,
              "z": 1.231
            },
            "gtin": "4013320066355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec8f",
            "leftCorner": {
              "x": 14.455,
              "y": 25.591,
              "z": 1.231
            },
            "rightCorner": {
              "x": 14.509,
              "y": 25.587,
              "z": 1.231
            },
            "gtin": "4013320066355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec90",
            "leftCorner": {
              "x": 14.509,
              "y": 25.588,
              "z": 1.231
            },
            "rightCorner": {
              "x": 14.604,
              "y": 25.58,
              "z": 1.231
            },
            "gtin": "4013320185780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec91",
            "leftCorner": {
              "x": 14.604,
              "y": 25.569,
              "z": 1.231
            },
            "rightCorner": {
              "x": 14.652,
              "y": 25.566,
              "z": 1.231
            },
            "gtin": "4337185869983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec92",
            "leftCorner": {
              "x": 14.652,
              "y": 25.566,
              "z": 1.231
            },
            "rightCorner": {
              "x": 14.7,
              "y": 25.562,
              "z": 1.231
            },
            "gtin": "4337185869983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec93",
            "leftCorner": {
              "x": 14.7,
              "y": 25.56,
              "z": 1.231
            },
            "rightCorner": {
              "x": 14.795,
              "y": 25.552,
              "z": 1.231
            },
            "gtin": "4337185869952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec94",
            "leftCorner": {
              "x": 14.797,
              "y": 25.585,
              "z": 1.231
            },
            "rightCorner": {
              "x": 15.006,
              "y": 25.569,
              "z": 1.231
            },
            "gtin": "4337185868467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec95",
            "leftCorner": {
              "x": 15.006,
              "y": 25.56,
              "z": 1.231
            },
            "rightCorner": {
              "x": 15.055,
              "y": 25.556,
              "z": 1.231
            },
            "gtin": "4337185868429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec96",
            "leftCorner": {
              "x": 15.056,
              "y": 25.567,
              "z": 1.231
            },
            "rightCorner": {
              "x": 15.205,
              "y": 25.555,
              "z": 1.231
            },
            "gtin": "4030387760644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec97",
            "leftCorner": {
              "x": 15.203,
              "y": 25.538,
              "z": 1.231
            },
            "rightCorner": {
              "x": 15.346,
              "y": 25.527,
              "z": 1.231
            },
            "gtin": "4030387760637",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467f9",
        "height": 1.7557,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eb03",
            "leftCorner": {
              "x": 14.427,
              "y": 25.592,
              "z": 1.436
            },
            "rightCorner": {
              "x": 14.5,
              "y": 25.586,
              "z": 1.436
            },
            "gtin": "7614500010013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb04",
            "leftCorner": {
              "x": 14.5,
              "y": 25.586,
              "z": 1.436
            },
            "rightCorner": {
              "x": 14.572,
              "y": 25.581,
              "z": 1.436
            },
            "gtin": "7614500010013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb05",
            "leftCorner": {
              "x": 14.572,
              "y": 25.576,
              "z": 1.436
            },
            "rightCorner": {
              "x": 14.802,
              "y": 25.558,
              "z": 1.436
            },
            "gtin": "7614500010617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb06",
            "leftCorner": {
              "x": 14.803,
              "y": 25.57,
              "z": 1.436
            },
            "rightCorner": {
              "x": 14.997,
              "y": 25.556,
              "z": 1.436
            },
            "gtin": "7614500010310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb07",
            "leftCorner": {
              "x": 14.997,
              "y": 25.563,
              "z": 1.436
            },
            "rightCorner": {
              "x": 15.115,
              "y": 25.554,
              "z": 1.436
            },
            "gtin": "7622300107949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb08",
            "leftCorner": {
              "x": 15.115,
              "y": 25.554,
              "z": 1.436
            },
            "rightCorner": {
              "x": 15.233,
              "y": 25.544,
              "z": 1.436
            },
            "gtin": "7622300107949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb09",
            "leftCorner": {
              "x": 15.231,
              "y": 25.53,
              "z": 1.436
            },
            "rightCorner": {
              "x": 15.351,
              "y": 25.521,
              "z": 1.436
            },
            "gtin": "5099872011127",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41a8a",
    "rightNeighborShelfId": "41a8c"
  },
  {
    "id": "41a8c",
    "name": "41a8c",
    "x": 15.35,
    "y": 25.482,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.038658,
      "w": 0.99925
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 72
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54686a",
        "height": 0.1621,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ecf7",
            "leftCorner": {
              "x": 15.367,
              "y": 25.529,
              "z": 0.133
            },
            "rightCorner": {
              "x": 15.559,
              "y": 25.514,
              "z": 0.133
            },
            "gtin": "4001743760714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ecf8",
            "leftCorner": {
              "x": 15.558,
              "y": 25.501,
              "z": 0.133
            },
            "rightCorner": {
              "x": 15.785,
              "y": 25.484,
              "z": 0.133
            },
            "gtin": "4001743760295",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ecf9",
            "leftCorner": {
              "x": 15.786,
              "y": 25.503,
              "z": 0.133
            },
            "rightCorner": {
              "x": 16.544,
              "y": 25.445,
              "z": 0.133
            },
            "gtin": "7613287633354",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546869",
        "height": 0.46028,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ed61",
            "leftCorner": {
              "x": 15.378,
              "y": 25.526,
              "z": 0.377
            },
            "rightCorner": {
              "x": 15.721,
              "y": 25.5,
              "z": 0.377
            },
            "gtin": "4337185443275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed62",
            "leftCorner": {
              "x": 15.721,
              "y": 25.507,
              "z": 0.377
            },
            "rightCorner": {
              "x": 15.809,
              "y": 25.5,
              "z": 0.377
            },
            "gtin": "7622201733803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed63",
            "leftCorner": {
              "x": 15.809,
              "y": 25.5,
              "z": 0.377
            },
            "rightCorner": {
              "x": 15.897,
              "y": 25.493,
              "z": 0.377
            },
            "gtin": "7622201733803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed64",
            "leftCorner": {
              "x": 15.897,
              "y": 25.493,
              "z": 0.377
            },
            "rightCorner": {
              "x": 15.985,
              "y": 25.486,
              "z": 0.377
            },
            "gtin": "7622201733803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed65",
            "leftCorner": {
              "x": 15.985,
              "y": 25.491,
              "z": 0.377
            },
            "rightCorner": {
              "x": 16.052,
              "y": 25.486,
              "z": 0.377
            },
            "gtin": "7622201727130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed66",
            "leftCorner": {
              "x": 16.052,
              "y": 25.486,
              "z": 0.377
            },
            "rightCorner": {
              "x": 16.119,
              "y": 25.481,
              "z": 0.377
            },
            "gtin": "7622201727130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed67",
            "leftCorner": {
              "x": 16.119,
              "y": 25.481,
              "z": 0.377
            },
            "rightCorner": {
              "x": 16.185,
              "y": 25.476,
              "z": 0.377
            },
            "gtin": "7622201727130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed68",
            "leftCorner": {
              "x": 16.184,
              "y": 25.457,
              "z": 0.377
            },
            "rightCorner": {
              "x": 16.271,
              "y": 25.45,
              "z": 0.377
            },
            "gtin": "7622210071903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed69",
            "leftCorner": {
              "x": 16.271,
              "y": 25.45,
              "z": 0.377
            },
            "rightCorner": {
              "x": 16.358,
              "y": 25.444,
              "z": 0.377
            },
            "gtin": "7622210071903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed6a",
            "leftCorner": {
              "x": 16.358,
              "y": 25.444,
              "z": 0.377
            },
            "rightCorner": {
              "x": 16.444,
              "y": 25.437,
              "z": 0.377
            },
            "gtin": "7622210071903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed6b",
            "leftCorner": {
              "x": 16.445,
              "y": 25.444,
              "z": 0.377
            },
            "rightCorner": {
              "x": 16.854,
              "y": 25.412,
              "z": 0.377
            },
            "gtin": "6411401015830",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546865",
        "height": 0.75848,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ebc0",
            "leftCorner": {
              "x": 15.322,
              "y": 25.531,
              "z": 0.621
            },
            "rightCorner": {
              "x": 15.533,
              "y": 25.515,
              "z": 0.621
            },
            "gtin": "4337185468636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebc1",
            "leftCorner": {
              "x": 15.532,
              "y": 25.512,
              "z": 0.621
            },
            "rightCorner": {
              "x": 15.681,
              "y": 25.5,
              "z": 0.621
            },
            "gtin": "4337185467240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebc2",
            "leftCorner": {
              "x": 15.681,
              "y": 25.5,
              "z": 0.621
            },
            "rightCorner": {
              "x": 15.829,
              "y": 25.488,
              "z": 0.621
            },
            "gtin": "4337185467240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebc3",
            "leftCorner": {
              "x": 15.83,
              "y": 25.494,
              "z": 0.621
            },
            "rightCorner": {
              "x": 15.934,
              "y": 25.487,
              "z": 0.621
            },
            "gtin": "4063367210921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebc4",
            "leftCorner": {
              "x": 15.934,
              "y": 25.487,
              "z": 0.621
            },
            "rightCorner": {
              "x": 16.036,
              "y": 25.479,
              "z": 0.621
            },
            "gtin": "4063367210921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebc5",
            "leftCorner": {
              "x": 16.036,
              "y": 25.477,
              "z": 0.621
            },
            "rightCorner": {
              "x": 16.141,
              "y": 25.469,
              "z": 0.621
            },
            "gtin": "4063367372681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebc6",
            "leftCorner": {
              "x": 16.141,
              "y": 25.469,
              "z": 0.621
            },
            "rightCorner": {
              "x": 16.245,
              "y": 25.461,
              "z": 0.621
            },
            "gtin": "4063367372681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebc7",
            "leftCorner": {
              "x": 16.244,
              "y": 25.459,
              "z": 0.621
            },
            "rightCorner": {
              "x": 16.303,
              "y": 25.454,
              "z": 0.621
            },
            "gtin": "4063367210860",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebc8",
            "leftCorner": {
              "x": 16.303,
              "y": 25.454,
              "z": 0.621
            },
            "rightCorner": {
              "x": 16.363,
              "y": 25.45,
              "z": 0.621
            },
            "gtin": "4063367210860",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebc9",
            "leftCorner": {
              "x": 16.363,
              "y": 25.45,
              "z": 0.621
            },
            "rightCorner": {
              "x": 16.422,
              "y": 25.445,
              "z": 0.621
            },
            "gtin": "4063367210860",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebca",
            "leftCorner": {
              "x": 16.422,
              "y": 25.44,
              "z": 0.621
            },
            "rightCorner": {
              "x": 16.502,
              "y": 25.434,
              "z": 0.621
            },
            "gtin": "4063367378980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebcb",
            "leftCorner": {
              "x": 16.502,
              "y": 25.434,
              "z": 0.621
            },
            "rightCorner": {
              "x": 16.583,
              "y": 25.428,
              "z": 0.621
            },
            "gtin": "4063367378980",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546864",
        "height": 1.0149,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a211e9",
            "leftCorner": {
              "x": 15.35,
              "y": 25.487,
              "z": 0.83
            },
            "rightCorner": {
              "x": 15.42,
              "y": 25.481,
              "z": 0.83
            },
            "gtin": "4260334140032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211ea",
            "leftCorner": {
              "x": 15.42,
              "y": 25.481,
              "z": 0.83
            },
            "rightCorner": {
              "x": 15.491,
              "y": 25.476,
              "z": 0.83
            },
            "gtin": "4260334140032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211eb",
            "leftCorner": {
              "x": 15.491,
              "y": 25.476,
              "z": 0.83
            },
            "rightCorner": {
              "x": 15.561,
              "y": 25.47,
              "z": 0.83
            },
            "gtin": "4260334140032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211ed",
            "leftCorner": {
              "x": 15.563,
              "y": 25.498,
              "z": 0.83
            },
            "rightCorner": {
              "x": 15.655,
              "y": 25.491,
              "z": 0.83
            },
            "gtin": "4260334140810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211ee",
            "leftCorner": {
              "x": 15.656,
              "y": 25.495,
              "z": 0.83
            },
            "rightCorner": {
              "x": 15.723,
              "y": 25.49,
              "z": 0.83
            },
            "gtin": "4012362999669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211ef",
            "leftCorner": {
              "x": 15.723,
              "y": 25.49,
              "z": 0.83
            },
            "rightCorner": {
              "x": 15.791,
              "y": 25.485,
              "z": 0.83
            },
            "gtin": "4012362999669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211f0",
            "leftCorner": {
              "x": 15.791,
              "y": 25.485,
              "z": 0.83
            },
            "rightCorner": {
              "x": 15.86,
              "y": 25.479,
              "z": 0.83
            },
            "gtin": "4012362999669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211f1",
            "leftCorner": {
              "x": 15.86,
              "y": 25.479,
              "z": 0.83
            },
            "rightCorner": {
              "x": 15.928,
              "y": 25.474,
              "z": 0.83
            },
            "gtin": "4012362999669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211f2",
            "leftCorner": {
              "x": 15.928,
              "y": 25.484,
              "z": 0.83
            },
            "rightCorner": {
              "x": 16.021,
              "y": 25.477,
              "z": 0.83
            },
            "gtin": "4063367379000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211f3",
            "leftCorner": {
              "x": 16.021,
              "y": 25.477,
              "z": 0.83
            },
            "rightCorner": {
              "x": 16.113,
              "y": 25.47,
              "z": 0.83
            },
            "gtin": "4063367379000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211f4",
            "leftCorner": {
              "x": 16.112,
              "y": 25.452,
              "z": 0.83
            },
            "rightCorner": {
              "x": 16.215,
              "y": 25.443,
              "z": 0.83
            },
            "gtin": "4337185468773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211f5",
            "leftCorner": {
              "x": 16.215,
              "y": 25.443,
              "z": 0.83
            },
            "rightCorner": {
              "x": 16.32,
              "y": 25.435,
              "z": 0.83
            },
            "gtin": "4337185468773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211f6",
            "leftCorner": {
              "x": 16.321,
              "y": 25.453,
              "z": 0.83
            },
            "rightCorner": {
              "x": 16.59,
              "y": 25.432,
              "z": 0.83
            },
            "gtin": "4063367379048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211f7",
            "leftCorner": {
              "x": 16.59,
              "y": 25.432,
              "z": 0.83
            },
            "rightCorner": {
              "x": 16.86,
              "y": 25.411,
              "z": 0.83
            },
            "gtin": "4063367379048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211f8",
            "leftCorner": {
              "x": 16.86,
              "y": 25.411,
              "z": 0.83
            },
            "rightCorner": {
              "x": 17.128,
              "y": 25.39,
              "z": 0.83
            },
            "gtin": "4063367379048",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546868",
        "height": 1.2629,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ec33",
            "leftCorner": {
              "x": 15.337,
              "y": 25.523,
              "z": 1.033
            },
            "rightCorner": {
              "x": 15.449,
              "y": 25.514,
              "z": 1.033
            },
            "gtin": "4000607000478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec34",
            "leftCorner": {
              "x": 15.449,
              "y": 25.514,
              "z": 1.033
            },
            "rightCorner": {
              "x": 15.562,
              "y": 25.505,
              "z": 1.033
            },
            "gtin": "4000607000478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec35",
            "leftCorner": {
              "x": 15.562,
              "y": 25.507,
              "z": 1.033
            },
            "rightCorner": {
              "x": 15.614,
              "y": 25.503,
              "z": 1.033
            },
            "gtin": "4000607000454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec36",
            "leftCorner": {
              "x": 15.614,
              "y": 25.503,
              "z": 1.033
            },
            "rightCorner": {
              "x": 15.667,
              "y": 25.498,
              "z": 1.033
            },
            "gtin": "4000607000454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec37",
            "leftCorner": {
              "x": 15.667,
              "y": 25.498,
              "z": 1.033
            },
            "rightCorner": {
              "x": 15.719,
              "y": 25.495,
              "z": 1.033
            },
            "gtin": "4000607000454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec38",
            "leftCorner": {
              "x": 15.719,
              "y": 25.498,
              "z": 1.033
            },
            "rightCorner": {
              "x": 15.786,
              "y": 25.492,
              "z": 1.033
            },
            "gtin": "4337185501470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec39",
            "leftCorner": {
              "x": 15.786,
              "y": 25.492,
              "z": 1.033
            },
            "rightCorner": {
              "x": 15.852,
              "y": 25.488,
              "z": 1.033
            },
            "gtin": "4337185501470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec3a",
            "leftCorner": {
              "x": 15.852,
              "y": 25.488,
              "z": 1.033
            },
            "rightCorner": {
              "x": 15.918,
              "y": 25.483,
              "z": 1.033
            },
            "gtin": "4337185501470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec3b",
            "leftCorner": {
              "x": 15.918,
              "y": 25.483,
              "z": 1.033
            },
            "rightCorner": {
              "x": 15.969,
              "y": 25.479,
              "z": 1.033
            },
            "gtin": "4001743761216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec3c",
            "leftCorner": {
              "x": 15.969,
              "y": 25.479,
              "z": 1.033
            },
            "rightCorner": {
              "x": 16.019,
              "y": 25.475,
              "z": 1.033
            },
            "gtin": "4001743761216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec3d",
            "leftCorner": {
              "x": 16.019,
              "y": 25.475,
              "z": 1.033
            },
            "rightCorner": {
              "x": 16.07,
              "y": 25.472,
              "z": 1.033
            },
            "gtin": "4001743761216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec3e",
            "leftCorner": {
              "x": 16.07,
              "y": 25.472,
              "z": 1.033
            },
            "rightCorner": {
              "x": 16.121,
              "y": 25.467,
              "z": 1.033
            },
            "gtin": "4001743761216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec3f",
            "leftCorner": {
              "x": 16.119,
              "y": 25.449,
              "z": 1.033
            },
            "rightCorner": {
              "x": 16.284,
              "y": 25.436,
              "z": 1.033
            },
            "gtin": "4337185524578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec40",
            "leftCorner": {
              "x": 16.285,
              "y": 25.446,
              "z": 1.033
            },
            "rightCorner": {
              "x": 16.38,
              "y": 25.439,
              "z": 1.033
            },
            "gtin": "4001743761407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec41",
            "leftCorner": {
              "x": 16.38,
              "y": 25.439,
              "z": 1.033
            },
            "rightCorner": {
              "x": 16.476,
              "y": 25.432,
              "z": 1.033
            },
            "gtin": "4001743761407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec42",
            "leftCorner": {
              "x": 16.476,
              "y": 25.432,
              "z": 1.033
            },
            "rightCorner": {
              "x": 16.572,
              "y": 25.425,
              "z": 1.033
            },
            "gtin": "4001743761407",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546866",
        "height": 1.5137,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ec98",
            "leftCorner": {
              "x": 15.346,
              "y": 25.526,
              "z": 1.238
            },
            "rightCorner": {
              "x": 15.522,
              "y": 25.513,
              "z": 1.238
            },
            "gtin": "4063367288296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec99",
            "leftCorner": {
              "x": 15.522,
              "y": 25.513,
              "z": 1.238
            },
            "rightCorner": {
              "x": 15.698,
              "y": 25.499,
              "z": 1.238
            },
            "gtin": "4063367288296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec9a",
            "leftCorner": {
              "x": 15.698,
              "y": 25.5,
              "z": 1.238
            },
            "rightCorner": {
              "x": 15.792,
              "y": 25.493,
              "z": 1.238
            },
            "gtin": "4063367288272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec9b",
            "leftCorner": {
              "x": 15.792,
              "y": 25.493,
              "z": 1.238
            },
            "rightCorner": {
              "x": 15.884,
              "y": 25.486,
              "z": 1.238
            },
            "gtin": "4063367288272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec9c",
            "leftCorner": {
              "x": 15.885,
              "y": 25.491,
              "z": 1.238
            },
            "rightCorner": {
              "x": 15.99,
              "y": 25.483,
              "z": 1.238
            },
            "gtin": "4063367288333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec9d",
            "leftCorner": {
              "x": 15.99,
              "y": 25.482,
              "z": 1.238
            },
            "rightCorner": {
              "x": 16.232,
              "y": 25.463,
              "z": 1.238
            },
            "gtin": "4063367288319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec9e",
            "leftCorner": {
              "x": 16.232,
              "y": 25.463,
              "z": 1.238
            },
            "rightCorner": {
              "x": 16.474,
              "y": 25.444,
              "z": 1.238
            },
            "gtin": "4063367288319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec9f",
            "leftCorner": {
              "x": 16.474,
              "y": 25.44,
              "z": 1.238
            },
            "rightCorner": {
              "x": 16.571,
              "y": 25.433,
              "z": 1.238
            },
            "gtin": "3830053878335",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546867",
        "height": 1.7619,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eb0a",
            "leftCorner": {
              "x": 15.35,
              "y": 25.521,
              "z": 1.442
            },
            "rightCorner": {
              "x": 15.446,
              "y": 25.514,
              "z": 1.442
            },
            "gtin": "4063367377921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb0b",
            "leftCorner": {
              "x": 15.446,
              "y": 25.514,
              "z": 1.442
            },
            "rightCorner": {
              "x": 15.543,
              "y": 25.506,
              "z": 1.442
            },
            "gtin": "4063367377921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb0c",
            "leftCorner": {
              "x": 15.543,
              "y": 25.503,
              "z": 1.442
            },
            "rightCorner": {
              "x": 15.73,
              "y": 25.489,
              "z": 1.442
            },
            "gtin": "4063367211027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb0d",
            "leftCorner": {
              "x": 15.731,
              "y": 25.499,
              "z": 1.442
            },
            "rightCorner": {
              "x": 15.929,
              "y": 25.484,
              "z": 1.442
            },
            "gtin": "4337185632228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb0e",
            "leftCorner": {
              "x": 15.929,
              "y": 25.484,
              "z": 1.442
            },
            "rightCorner": {
              "x": 16.128,
              "y": 25.469,
              "z": 1.442
            },
            "gtin": "4337185632228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb0f",
            "leftCorner": {
              "x": 16.128,
              "y": 25.465,
              "z": 1.442
            },
            "rightCorner": {
              "x": 16.347,
              "y": 25.448,
              "z": 1.442
            },
            "gtin": "4013900509227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb10",
            "leftCorner": {
              "x": 16.347,
              "y": 25.448,
              "z": 1.442
            },
            "rightCorner": {
              "x": 16.567,
              "y": 25.431,
              "z": 1.442
            },
            "gtin": "4013900509227",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41a8b",
    "rightNeighborShelfId": "41a8d"
  },
  {
    "id": "41a8d",
    "name": "41a8d",
    "x": 16.547,
    "y": 25.389,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.038658,
      "w": 0.99925
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 32
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54686f",
        "height": 0.15815,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ecfa",
            "leftCorner": {
              "x": 16.543,
              "y": 25.42,
              "z": 0.129
            },
            "rightCorner": {
              "x": 16.651,
              "y": 25.413,
              "z": 0.129
            },
            "gtin": "42395041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ecfb",
            "leftCorner": {
              "x": 16.651,
              "y": 25.413,
              "z": 0.129
            },
            "rightCorner": {
              "x": 16.76,
              "y": 25.404,
              "z": 0.129
            },
            "gtin": "42395041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ecfc",
            "leftCorner": {
              "x": 16.76,
              "y": 25.405,
              "z": 0.129
            },
            "rightCorner": {
              "x": 16.898,
              "y": 25.395,
              "z": 0.129
            },
            "gtin": "8445291432987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ecfd",
            "leftCorner": {
              "x": 16.899,
              "y": 25.411,
              "z": 0.129
            },
            "rightCorner": {
              "x": 17.111,
              "y": 25.395,
              "z": 0.129
            },
            "gtin": "40345512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ecfe",
            "leftCorner": {
              "x": 17.111,
              "y": 25.395,
              "z": 0.129
            },
            "rightCorner": {
              "x": 17.323,
              "y": 25.378,
              "z": 0.129
            },
            "gtin": "40345512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ecff",
            "leftCorner": {
              "x": 17.323,
              "y": 25.378,
              "z": 0.129
            },
            "rightCorner": {
              "x": 17.536,
              "y": 25.361,
              "z": 0.129
            },
            "gtin": "40345512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed00",
            "leftCorner": {
              "x": 17.534,
              "y": 25.355,
              "z": 0.129
            },
            "rightCorner": {
              "x": 17.609,
              "y": 25.35,
              "z": 0.129
            },
            "gtin": "7613287899590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed01",
            "leftCorner": {
              "x": 17.609,
              "y": 25.35,
              "z": 0.129
            },
            "rightCorner": {
              "x": 17.684,
              "y": 25.344,
              "z": 0.129
            },
            "gtin": "7613287899590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed02",
            "leftCorner": {
              "x": 17.684,
              "y": 25.344,
              "z": 0.129
            },
            "rightCorner": {
              "x": 17.759,
              "y": 25.338,
              "z": 0.129
            },
            "gtin": "7613287899590",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546870",
        "height": 0.45275,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ed6c",
            "leftCorner": {
              "x": 16.854,
              "y": 25.411,
              "z": 0.37
            },
            "rightCorner": {
              "x": 17.142,
              "y": 25.39,
              "z": 0.37
            },
            "gtin": "5000159561730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed6d",
            "leftCorner": {
              "x": 17.143,
              "y": 25.394,
              "z": 0.37
            },
            "rightCorner": {
              "x": 17.463,
              "y": 25.37,
              "z": 0.37
            },
            "gtin": "5000159561723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed6e",
            "leftCorner": {
              "x": 17.463,
              "y": 25.37,
              "z": 0.37
            },
            "rightCorner": {
              "x": 17.784,
              "y": 25.345,
              "z": 0.37
            },
            "gtin": "5000159561723",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54686e",
        "height": 0.76522,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ebcc",
            "leftCorner": {
              "x": 16.583,
              "y": 25.418,
              "z": 0.626
            },
            "rightCorner": {
              "x": 16.806,
              "y": 25.4,
              "z": 0.626
            },
            "gtin": "5413548283128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebcd",
            "leftCorner": {
              "x": 16.806,
              "y": 25.4,
              "z": 0.626
            },
            "rightCorner": {
              "x": 17.028,
              "y": 25.383,
              "z": 0.626
            },
            "gtin": "5413548283128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebce",
            "leftCorner": {
              "x": 17.028,
              "y": 25.383,
              "z": 0.626
            },
            "rightCorner": {
              "x": 17.252,
              "y": 25.366,
              "z": 0.626
            },
            "gtin": "5413548283128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebcf",
            "leftCorner": {
              "x": 17.253,
              "y": 25.388,
              "z": 0.626
            },
            "rightCorner": {
              "x": 17.502,
              "y": 25.369,
              "z": 0.626
            },
            "gtin": "4008400280127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebd0",
            "leftCorner": {
              "x": 17.502,
              "y": 25.369,
              "z": 0.626
            },
            "rightCorner": {
              "x": 17.75,
              "y": 25.349,
              "z": 0.626
            },
            "gtin": "4008400280127",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546871",
        "height": 1.0086,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a211f9",
            "leftCorner": {
              "x": 17.128,
              "y": 25.385,
              "z": 0.825
            },
            "rightCorner": {
              "x": 17.303,
              "y": 25.371,
              "z": 0.825
            },
            "gtin": "8000500253687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211fa",
            "leftCorner": {
              "x": 17.303,
              "y": 25.371,
              "z": 0.825
            },
            "rightCorner": {
              "x": 17.478,
              "y": 25.358,
              "z": 0.825
            },
            "gtin": "8000500253687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211fb",
            "leftCorner": {
              "x": 17.478,
              "y": 25.367,
              "z": 0.825
            },
            "rightCorner": {
              "x": 17.959,
              "y": 25.33,
              "z": 0.825
            },
            "gtin": "8000500028124",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54686d",
        "height": 1.2585,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ebdd",
            "leftCorner": {
              "x": 16.572,
              "y": 25.421,
              "z": 1.03
            },
            "rightCorner": {
              "x": 16.963,
              "y": 25.391,
              "z": 1.03
            },
            "gtin": "80310891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebde",
            "leftCorner": {
              "x": 16.963,
              "y": 25.391,
              "z": 1.03
            },
            "rightCorner": {
              "x": 17.355,
              "y": 25.361,
              "z": 1.03
            },
            "gtin": "80310891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebdf",
            "leftCorner": {
              "x": 17.355,
              "y": 25.361,
              "z": 1.03
            },
            "rightCorner": {
              "x": 17.746,
              "y": 25.331,
              "z": 1.03
            },
            "gtin": "80310891",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54686b",
        "height": 1.5208,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eca0",
            "leftCorner": {
              "x": 16.573,
              "y": 25.435,
              "z": 1.244
            },
            "rightCorner": {
              "x": 17.024,
              "y": 25.399,
              "z": 1.244
            },
            "gtin": "4013900509203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eca1",
            "leftCorner": {
              "x": 17.024,
              "y": 25.399,
              "z": 1.244
            },
            "rightCorner": {
              "x": 17.476,
              "y": 25.365,
              "z": 1.244
            },
            "gtin": "4013900509203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eca2",
            "leftCorner": {
              "x": 17.476,
              "y": 25.361,
              "z": 1.244
            },
            "rightCorner": {
              "x": 17.657,
              "y": 25.346,
              "z": 1.244
            },
            "gtin": "4013900509265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eca3",
            "leftCorner": {
              "x": 17.657,
              "y": 25.346,
              "z": 1.244
            },
            "rightCorner": {
              "x": 17.84,
              "y": 25.332,
              "z": 1.244
            },
            "gtin": "4013900509265",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54686c",
        "height": 1.7588,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eb11",
            "leftCorner": {
              "x": 16.567,
              "y": 25.424,
              "z": 1.439
            },
            "rightCorner": {
              "x": 16.778,
              "y": 25.408,
              "z": 1.439
            },
            "gtin": "4000281311518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb12",
            "leftCorner": {
              "x": 16.778,
              "y": 25.415,
              "z": 1.439
            },
            "rightCorner": {
              "x": 17.05,
              "y": 25.393,
              "z": 1.439
            },
            "gtin": "4000281325515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb13",
            "leftCorner": {
              "x": 17.05,
              "y": 25.4,
              "z": 1.439
            },
            "rightCorner": {
              "x": 17.274,
              "y": 25.383,
              "z": 1.439
            },
            "gtin": "4000281348514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb14",
            "leftCorner": {
              "x": 17.274,
              "y": 25.382,
              "z": 1.439
            },
            "rightCorner": {
              "x": 17.538,
              "y": 25.361,
              "z": 1.439
            },
            "gtin": "4000281306514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb15",
            "leftCorner": {
              "x": 17.537,
              "y": 25.356,
              "z": 1.439
            },
            "rightCorner": {
              "x": 17.739,
              "y": 25.341,
              "z": 1.439
            },
            "gtin": "4000281334500",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41a8c",
    "rightNeighborShelfId": "41a8e"
  },
  {
    "id": "41a8e",
    "name": "41a8e",
    "x": 17.743,
    "y": 25.297,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.038658,
      "w": 0.99925
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 55
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5467ed",
        "height": 0.1575,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ed03",
            "leftCorner": {
              "x": 17.758,
              "y": 25.334,
              "z": 0.129
            },
            "rightCorner": {
              "x": 17.89,
              "y": 25.324,
              "z": 0.129
            },
            "gtin": "5000159023283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed04",
            "leftCorner": {
              "x": 17.892,
              "y": 25.342,
              "z": 0.129
            },
            "rightCorner": {
              "x": 18.029,
              "y": 25.332,
              "z": 0.129
            },
            "gtin": "5900951291708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed05",
            "leftCorner": {
              "x": 18.029,
              "y": 25.332,
              "z": 0.129
            },
            "rightCorner": {
              "x": 18.166,
              "y": 25.321,
              "z": 0.129
            },
            "gtin": "5900951291708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed06",
            "leftCorner": {
              "x": 18.166,
              "y": 25.321,
              "z": 0.129
            },
            "rightCorner": {
              "x": 18.302,
              "y": 25.311,
              "z": 0.129
            },
            "gtin": "5900951291708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed07",
            "leftCorner": {
              "x": 18.302,
              "y": 25.314,
              "z": 0.129
            },
            "rightCorner": {
              "x": 18.403,
              "y": 25.306,
              "z": 0.129
            },
            "gtin": "5900951314865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed08",
            "leftCorner": {
              "x": 18.403,
              "y": 25.306,
              "z": 0.129
            },
            "rightCorner": {
              "x": 18.504,
              "y": 25.298,
              "z": 0.129
            },
            "gtin": "5900951314865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed09",
            "leftCorner": {
              "x": 18.503,
              "y": 25.289,
              "z": 0.129
            },
            "rightCorner": {
              "x": 18.641,
              "y": 25.279,
              "z": 0.129
            },
            "gtin": "5905858675323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed0a",
            "leftCorner": {
              "x": 18.641,
              "y": 25.279,
              "z": 0.129
            },
            "rightCorner": {
              "x": 18.78,
              "y": 25.269,
              "z": 0.129
            },
            "gtin": "5905858675323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed0b",
            "leftCorner": {
              "x": 18.781,
              "y": 25.271,
              "z": 0.129
            },
            "rightCorner": {
              "x": 19.005,
              "y": 25.254,
              "z": 0.129
            },
            "gtin": "5905858675330",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467eb",
        "height": 0.45585,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ed6f",
            "leftCorner": {
              "x": 17.783,
              "y": 25.336,
              "z": 0.373
            },
            "rightCorner": {
              "x": 18.01,
              "y": 25.319,
              "z": 0.373
            },
            "gtin": "5000159454346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed70",
            "leftCorner": {
              "x": 18.01,
              "y": 25.319,
              "z": 0.373
            },
            "rightCorner": {
              "x": 18.238,
              "y": 25.301,
              "z": 0.373
            },
            "gtin": "5000159454346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed71",
            "leftCorner": {
              "x": 18.238,
              "y": 25.301,
              "z": 0.373
            },
            "rightCorner": {
              "x": 18.465,
              "y": 25.283,
              "z": 0.373
            },
            "gtin": "5000159454346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed72",
            "leftCorner": {
              "x": 18.465,
              "y": 25.288,
              "z": 0.373
            },
            "rightCorner": {
              "x": 18.694,
              "y": 25.271,
              "z": 0.373
            },
            "gtin": "5000159471725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed73",
            "leftCorner": {
              "x": 18.694,
              "y": 25.269,
              "z": 0.373
            },
            "rightCorner": {
              "x": 18.991,
              "y": 25.246,
              "z": 0.373
            },
            "gtin": "5900951321221",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467e9",
        "height": 0.76713,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ebd1",
            "leftCorner": {
              "x": 17.751,
              "y": 25.353,
              "z": 0.628
            },
            "rightCorner": {
              "x": 18.082,
              "y": 25.326,
              "z": 0.628
            },
            "gtin": "4337185491726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebd2",
            "leftCorner": {
              "x": 18.082,
              "y": 25.326,
              "z": 0.628
            },
            "rightCorner": {
              "x": 18.414,
              "y": 25.301,
              "z": 0.628
            },
            "gtin": "4337185491726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebd3",
            "leftCorner": {
              "x": 18.414,
              "y": 25.301,
              "z": 0.628
            },
            "rightCorner": {
              "x": 18.745,
              "y": 25.275,
              "z": 0.628
            },
            "gtin": "4337185491726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebd4",
            "leftCorner": {
              "x": 18.744,
              "y": 25.263,
              "z": 0.628
            },
            "rightCorner": {
              "x": 18.878,
              "y": 25.253,
              "z": 0.628
            },
            "gtin": "4337185491672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebd5",
            "leftCorner": {
              "x": 18.878,
              "y": 25.253,
              "z": 0.628
            },
            "rightCorner": {
              "x": 19.013,
              "y": 25.242,
              "z": 0.628
            },
            "gtin": "4337185491672",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467ee",
        "height": 1.0136,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a211fc",
            "leftCorner": {
              "x": 17.957,
              "y": 25.321,
              "z": 0.829
            },
            "rightCorner": {
              "x": 18.003,
              "y": 25.318,
              "z": 0.829
            },
            "gtin": "4262354077145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211fd",
            "leftCorner": {
              "x": 18.003,
              "y": 25.318,
              "z": 0.829
            },
            "rightCorner": {
              "x": 18.05,
              "y": 25.314,
              "z": 0.829
            },
            "gtin": "4262354077145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211fe",
            "leftCorner": {
              "x": 18.05,
              "y": 25.313,
              "z": 0.829
            },
            "rightCorner": {
              "x": 18.15,
              "y": 25.305,
              "z": 0.829
            },
            "gtin": "4262354077046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211ff",
            "leftCorner": {
              "x": 18.151,
              "y": 25.31,
              "z": 0.829
            },
            "rightCorner": {
              "x": 18.314,
              "y": 25.297,
              "z": 0.829
            },
            "gtin": "4000417067203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21200",
            "leftCorner": {
              "x": 18.314,
              "y": 25.297,
              "z": 0.829
            },
            "rightCorner": {
              "x": 18.476,
              "y": 25.285,
              "z": 0.829
            },
            "gtin": "4000417067203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21201",
            "leftCorner": {
              "x": 18.476,
              "y": 25.284,
              "z": 0.829
            },
            "rightCorner": {
              "x": 18.603,
              "y": 25.274,
              "z": 0.829
            },
            "gtin": "4002575563887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21202",
            "leftCorner": {
              "x": 18.603,
              "y": 25.274,
              "z": 0.829
            },
            "rightCorner": {
              "x": 18.731,
              "y": 25.264,
              "z": 0.829
            },
            "gtin": "4002575563887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21203",
            "leftCorner": {
              "x": 18.731,
              "y": 25.267,
              "z": 0.829
            },
            "rightCorner": {
              "x": 18.849,
              "y": 25.257,
              "z": 0.829
            },
            "gtin": "753854584171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21204",
            "leftCorner": {
              "x": 18.849,
              "y": 25.243,
              "z": 0.829
            },
            "rightCorner": {
              "x": 18.903,
              "y": 25.239,
              "z": 0.829
            },
            "gtin": "4262354077145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21205",
            "leftCorner": {
              "x": 18.903,
              "y": 25.239,
              "z": 0.829
            },
            "rightCorner": {
              "x": 18.956,
              "y": 25.234,
              "z": 0.829
            },
            "gtin": "4262354077145",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467e8",
        "height": 1.2687,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a211d6",
            "leftCorner": {
              "x": 17.743,
              "y": 25.307,
              "z": 1.038
            },
            "rightCorner": {
              "x": 17.86,
              "y": 25.299,
              "z": 1.038
            },
            "gtin": "4014400933642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211d7",
            "leftCorner": {
              "x": 17.86,
              "y": 25.299,
              "z": 1.038
            },
            "rightCorner": {
              "x": 17.977,
              "y": 25.289,
              "z": 1.038
            },
            "gtin": "4014400933642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211d8",
            "leftCorner": {
              "x": 17.977,
              "y": 25.289,
              "z": 1.038
            },
            "rightCorner": {
              "x": 18.094,
              "y": 25.28,
              "z": 1.038
            },
            "gtin": "4014400933642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211db",
            "leftCorner": {
              "x": 18.095,
              "y": 25.305,
              "z": 1.038
            },
            "rightCorner": {
              "x": 18.166,
              "y": 25.299,
              "z": 1.038
            },
            "gtin": "7622202259463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211dc",
            "leftCorner": {
              "x": 18.166,
              "y": 25.299,
              "z": 1.038
            },
            "rightCorner": {
              "x": 18.235,
              "y": 25.293,
              "z": 1.038
            },
            "gtin": "7622202259463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211dd",
            "leftCorner": {
              "x": 18.236,
              "y": 25.304,
              "z": 1.038
            },
            "rightCorner": {
              "x": 18.366,
              "y": 25.294,
              "z": 1.038
            },
            "gtin": "4014400933659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211de",
            "leftCorner": {
              "x": 18.366,
              "y": 25.294,
              "z": 1.038
            },
            "rightCorner": {
              "x": 18.494,
              "y": 25.284,
              "z": 1.038
            },
            "gtin": "4014400933659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211df",
            "leftCorner": {
              "x": 18.494,
              "y": 25.284,
              "z": 1.038
            },
            "rightCorner": {
              "x": 18.623,
              "y": 25.275,
              "z": 1.038
            },
            "gtin": "4014400933659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211e0",
            "leftCorner": {
              "x": 18.623,
              "y": 25.272,
              "z": 1.038
            },
            "rightCorner": {
              "x": 18.735,
              "y": 25.264,
              "z": 1.038
            },
            "gtin": "7622400928604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211e1",
            "leftCorner": {
              "x": 18.735,
              "y": 25.264,
              "z": 1.038
            },
            "rightCorner": {
              "x": 18.845,
              "y": 25.254,
              "z": 1.038
            },
            "gtin": "7622400928604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211e2",
            "leftCorner": {
              "x": 18.845,
              "y": 25.254,
              "z": 1.038
            },
            "rightCorner": {
              "x": 18.957,
              "y": 25.246,
              "z": 1.038
            },
            "gtin": "7622400928604",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467ec",
        "height": 1.522,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eca4",
            "leftCorner": {
              "x": 17.839,
              "y": 25.329,
              "z": 1.245
            },
            "rightCorner": {
              "x": 18.112,
              "y": 25.308,
              "z": 1.245
            },
            "gtin": "5000159571425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eca5",
            "leftCorner": {
              "x": 18.112,
              "y": 25.308,
              "z": 1.245
            },
            "rightCorner": {
              "x": 18.384,
              "y": 25.287,
              "z": 1.245
            },
            "gtin": "5000159571425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eca6",
            "leftCorner": {
              "x": 18.384,
              "y": 25.282,
              "z": 1.245
            },
            "rightCorner": {
              "x": 18.552,
              "y": 25.269,
              "z": 1.245
            },
            "gtin": "4006814050015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eca7",
            "leftCorner": {
              "x": 18.552,
              "y": 25.269,
              "z": 1.245
            },
            "rightCorner": {
              "x": 18.72,
              "y": 25.256,
              "z": 1.245
            },
            "gtin": "4006814050015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec45",
            "leftCorner": {
              "x": 18.721,
              "y": 25.269,
              "z": 1.245
            },
            "rightCorner": {
              "x": 18.831,
              "y": 25.261,
              "z": 1.245
            },
            "gtin": "7622201405731",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec46",
            "leftCorner": {
              "x": 18.831,
              "y": 25.261,
              "z": 1.245
            },
            "rightCorner": {
              "x": 18.943,
              "y": 25.252,
              "z": 1.245
            },
            "gtin": "7622201405731",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467ea",
        "height": 1.7601,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eb16",
            "leftCorner": {
              "x": 17.738,
              "y": 25.345,
              "z": 1.44
            },
            "rightCorner": {
              "x": 17.981,
              "y": 25.327,
              "z": 1.44
            },
            "gtin": "4003006004849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb17",
            "leftCorner": {
              "x": 17.979,
              "y": 25.321,
              "z": 1.44
            },
            "rightCorner": {
              "x": 18.091,
              "y": 25.313,
              "z": 1.44
            },
            "gtin": "5000159500296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb18",
            "leftCorner": {
              "x": 18.091,
              "y": 25.313,
              "z": 1.44
            },
            "rightCorner": {
              "x": 18.202,
              "y": 25.304,
              "z": 1.44
            },
            "gtin": "5000159500296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb19",
            "leftCorner": {
              "x": 18.202,
              "y": 25.304,
              "z": 1.44
            },
            "rightCorner": {
              "x": 18.313,
              "y": 25.295,
              "z": 1.44
            },
            "gtin": "5000159500296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb1a",
            "leftCorner": {
              "x": 18.313,
              "y": 25.297,
              "z": 1.44
            },
            "rightCorner": {
              "x": 18.576,
              "y": 25.277,
              "z": 1.44
            },
            "gtin": "5000159500258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb1b",
            "leftCorner": {
              "x": 18.575,
              "y": 25.26,
              "z": 1.44
            },
            "rightCorner": {
              "x": 18.673,
              "y": 25.253,
              "z": 1.44
            },
            "gtin": "9000332813447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb1c",
            "leftCorner": {
              "x": 18.673,
              "y": 25.253,
              "z": 1.44
            },
            "rightCorner": {
              "x": 18.772,
              "y": 25.245,
              "z": 1.44
            },
            "gtin": "9000332813447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb1d",
            "leftCorner": {
              "x": 18.774,
              "y": 25.267,
              "z": 1.44
            },
            "rightCorner": {
              "x": 18.858,
              "y": 25.26,
              "z": 1.44
            },
            "gtin": "9002859050824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb1e",
            "leftCorner": {
              "x": 18.858,
              "y": 25.26,
              "z": 1.44
            },
            "rightCorner": {
              "x": 18.943,
              "y": 25.253,
              "z": 1.44
            },
            "gtin": "9002859050824",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41a8d",
    "rightNeighborShelfId": "41a8f"
  },
  {
    "id": "41a8f",
    "name": "41a8f",
    "x": 18.963,
    "y": 25.196,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.033644,
      "w": 0.99943
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 45
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546873",
        "height": 1.268,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a211da",
            "leftCorner": {
              "x": 19.972,
              "y": 25.178,
              "z": 1.037
            },
            "rightCorner": {
              "x": 20.214,
              "y": 25.161,
              "z": 1.037
            },
            "gtin": "4008468018281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211e3",
            "leftCorner": {
              "x": 18.981,
              "y": 25.246,
              "z": 1.037
            },
            "rightCorner": {
              "x": 19.221,
              "y": 25.23,
              "z": 1.037
            },
            "gtin": "4008468014061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211e4",
            "leftCorner": {
              "x": 19.221,
              "y": 25.23,
              "z": 1.037
            },
            "rightCorner": {
              "x": 19.459,
              "y": 25.214,
              "z": 1.037
            },
            "gtin": "4008468014061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211e5",
            "leftCorner": {
              "x": 19.46,
              "y": 25.221,
              "z": 1.037
            },
            "rightCorner": {
              "x": 19.528,
              "y": 25.216,
              "z": 1.037
            },
            "gtin": "4008468018274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211e6",
            "leftCorner": {
              "x": 19.528,
              "y": 25.216,
              "z": 1.037
            },
            "rightCorner": {
              "x": 19.596,
              "y": 25.212,
              "z": 1.037
            },
            "gtin": "4008468018274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211e7",
            "leftCorner": {
              "x": 19.596,
              "y": 25.212,
              "z": 1.037
            },
            "rightCorner": {
              "x": 19.664,
              "y": 25.207,
              "z": 1.037
            },
            "gtin": "4008468018274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211e8",
            "leftCorner": {
              "x": 19.664,
              "y": 25.207,
              "z": 1.037
            },
            "rightCorner": {
              "x": 19.732,
              "y": 25.203,
              "z": 1.037
            },
            "gtin": "4008468018274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211d9",
            "leftCorner": {
              "x": 19.731,
              "y": 25.194,
              "z": 1.037
            },
            "rightCorner": {
              "x": 19.972,
              "y": 25.178,
              "z": 1.037
            },
            "gtin": "4008468018281",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546878",
        "height": 0.15895,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ed0c",
            "leftCorner": {
              "x": 19.031,
              "y": 25.24,
              "z": 0.13
            },
            "rightCorner": {
              "x": 19.232,
              "y": 25.225,
              "z": 0.13
            },
            "gtin": "4012362080602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed0d",
            "leftCorner": {
              "x": 19.232,
              "y": 25.235,
              "z": 0.13
            },
            "rightCorner": {
              "x": 19.431,
              "y": 25.222,
              "z": 0.13
            },
            "gtin": "4012362080503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed0e",
            "leftCorner": {
              "x": 19.431,
              "y": 25.228,
              "z": 0.13
            },
            "rightCorner": {
              "x": 19.521,
              "y": 25.222,
              "z": 0.13
            },
            "gtin": "4012362080701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed0f",
            "leftCorner": {
              "x": 19.521,
              "y": 25.222,
              "z": 0.13
            },
            "rightCorner": {
              "x": 19.612,
              "y": 25.215,
              "z": 0.13
            },
            "gtin": "4012362080701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed10",
            "leftCorner": {
              "x": 19.612,
              "y": 25.205,
              "z": 0.13
            },
            "rightCorner": {
              "x": 19.785,
              "y": 25.194,
              "z": 0.13
            },
            "gtin": "4047600012107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed11",
            "leftCorner": {
              "x": 19.785,
              "y": 25.194,
              "z": 0.13
            },
            "rightCorner": {
              "x": 19.959,
              "y": 25.182,
              "z": 0.13
            },
            "gtin": "4047600012107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed12",
            "leftCorner": {
              "x": 19.959,
              "y": 25.181,
              "z": 0.13
            },
            "rightCorner": {
              "x": 20.042,
              "y": 25.176,
              "z": 0.13
            },
            "gtin": "4006894415506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed13",
            "leftCorner": {
              "x": 20.042,
              "y": 25.176,
              "z": 0.13
            },
            "rightCorner": {
              "x": 20.125,
              "y": 25.17,
              "z": 0.13
            },
            "gtin": "4006894415506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecac",
            "leftCorner": {
              "x": 20.125,
              "y": 25.169,
              "z": 0.13
            },
            "rightCorner": {
              "x": 20.215,
              "y": 25.164,
              "z": 0.13
            },
            "gtin": "4006894167504",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546875",
        "height": 0.45286,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ed74",
            "leftCorner": {
              "x": 19.017,
              "y": 25.242,
              "z": 0.371
            },
            "rightCorner": {
              "x": 19.252,
              "y": 25.226,
              "z": 0.371
            },
            "gtin": "4006894444506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed17",
            "leftCorner": {
              "x": 19.252,
              "y": 25.237,
              "z": 0.371
            },
            "rightCorner": {
              "x": 19.493,
              "y": 25.222,
              "z": 0.371
            },
            "gtin": "4006894444308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed18",
            "leftCorner": {
              "x": 19.493,
              "y": 25.222,
              "z": 0.371
            },
            "rightCorner": {
              "x": 19.734,
              "y": 25.206,
              "z": 0.371
            },
            "gtin": "4006894444308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed19",
            "leftCorner": {
              "x": 19.734,
              "y": 25.206,
              "z": 0.371
            },
            "rightCorner": {
              "x": 19.974,
              "y": 25.189,
              "z": 0.371
            },
            "gtin": "4006894444308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed1a",
            "leftCorner": {
              "x": 19.974,
              "y": 25.189,
              "z": 0.371
            },
            "rightCorner": {
              "x": 20.215,
              "y": 25.173,
              "z": 0.371
            },
            "gtin": "4006894444308",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546877",
        "height": 0.75756,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ebd6",
            "leftCorner": {
              "x": 19.039,
              "y": 25.227,
              "z": 0.62
            },
            "rightCorner": {
              "x": 19.288,
              "y": 25.21,
              "z": 0.62
            },
            "gtin": "4337185617560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebd7",
            "leftCorner": {
              "x": 19.288,
              "y": 25.21,
              "z": 0.62
            },
            "rightCorner": {
              "x": 19.536,
              "y": 25.194,
              "z": 0.62
            },
            "gtin": "4337185617560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebd8",
            "leftCorner": {
              "x": 19.538,
              "y": 25.224,
              "z": 0.62
            },
            "rightCorner": {
              "x": 19.746,
              "y": 25.209,
              "z": 0.62
            },
            "gtin": "4013900507957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebd9",
            "leftCorner": {
              "x": 19.746,
              "y": 25.209,
              "z": 0.62
            },
            "rightCorner": {
              "x": 19.955,
              "y": 25.196,
              "z": 0.62
            },
            "gtin": "4013900507957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb72",
            "leftCorner": {
              "x": 19.955,
              "y": 25.178,
              "z": 0.62
            },
            "rightCorner": {
              "x": 20.085,
              "y": 25.169,
              "z": 0.62
            },
            "gtin": "4063367380136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb73",
            "leftCorner": {
              "x": 20.085,
              "y": 25.169,
              "z": 0.62
            },
            "rightCorner": {
              "x": 20.213,
              "y": 25.16,
              "z": 0.62
            },
            "gtin": "4063367380136",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546872",
        "height": 1.0157,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21206",
            "leftCorner": {
              "x": 18.981,
              "y": 25.24,
              "z": 0.831
            },
            "rightCorner": {
              "x": 19.351,
              "y": 25.216,
              "z": 0.831
            },
            "gtin": "4000281157512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21207",
            "leftCorner": {
              "x": 19.351,
              "y": 25.216,
              "z": 0.831
            },
            "rightCorner": {
              "x": 19.722,
              "y": 25.19,
              "z": 0.831
            },
            "gtin": "4000281157512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211ec",
            "leftCorner": {
              "x": 19.721,
              "y": 25.188,
              "z": 0.831
            },
            "rightCorner": {
              "x": 20.213,
              "y": 25.155,
              "z": 0.831
            },
            "gtin": "4008468013972",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546874",
        "height": 1.5095,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21360",
            "leftCorner": {
              "x": 18.964,
              "y": 25.203,
              "z": 1.235
            },
            "rightCorner": {
              "x": 19.389,
              "y": 25.174,
              "z": 1.235
            },
            "gtin": "7622201801458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21363",
            "leftCorner": {
              "x": 19.392,
              "y": 25.226,
              "z": 1.235
            },
            "rightCorner": {
              "x": 19.64,
              "y": 25.209,
              "z": 1.235
            },
            "gtin": "4008601702923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21364",
            "leftCorner": {
              "x": 19.64,
              "y": 25.209,
              "z": 1.235
            },
            "rightCorner": {
              "x": 19.886,
              "y": 25.193,
              "z": 1.235
            },
            "gtin": "4008601702923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21361",
            "leftCorner": {
              "x": 19.886,
              "y": 25.172,
              "z": 1.235
            },
            "rightCorner": {
              "x": 20.049,
              "y": 25.161,
              "z": 1.235
            },
            "gtin": "4012362085416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21362",
            "leftCorner": {
              "x": 20.049,
              "y": 25.161,
              "z": 1.235
            },
            "rightCorner": {
              "x": 20.213,
              "y": 25.15,
              "z": 1.235
            },
            "gtin": "4012362085416",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546876",
        "height": 1.7614,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eb1f",
            "leftCorner": {
              "x": 18.966,
              "y": 25.223,
              "z": 1.441
            },
            "rightCorner": {
              "x": 19.064,
              "y": 25.216,
              "z": 1.441
            },
            "gtin": "4002575520651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb20",
            "leftCorner": {
              "x": 19.064,
              "y": 25.216,
              "z": 1.441
            },
            "rightCorner": {
              "x": 19.163,
              "y": 25.21,
              "z": 1.441
            },
            "gtin": "4002575520651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb21",
            "leftCorner": {
              "x": 19.164,
              "y": 25.235,
              "z": 1.441
            },
            "rightCorner": {
              "x": 19.293,
              "y": 25.226,
              "z": 1.441
            },
            "gtin": "4021700900021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb22",
            "leftCorner": {
              "x": 19.293,
              "y": 25.226,
              "z": 1.441
            },
            "rightCorner": {
              "x": 19.422,
              "y": 25.217,
              "z": 1.441
            },
            "gtin": "4021700900021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb23",
            "leftCorner": {
              "x": 19.422,
              "y": 25.211,
              "z": 1.441
            },
            "rightCorner": {
              "x": 19.712,
              "y": 25.192,
              "z": 1.441
            },
            "gtin": "4021700902629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb24",
            "leftCorner": {
              "x": 19.712,
              "y": 25.195,
              "z": 1.441
            },
            "rightCorner": {
              "x": 19.808,
              "y": 25.189,
              "z": 1.441
            },
            "gtin": "4014522302500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb25",
            "leftCorner": {
              "x": 19.808,
              "y": 25.189,
              "z": 1.441
            },
            "rightCorner": {
              "x": 19.903,
              "y": 25.182,
              "z": 1.441
            },
            "gtin": "4014522302500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb26",
            "leftCorner": {
              "x": 19.903,
              "y": 25.182,
              "z": 1.441
            },
            "rightCorner": {
              "x": 19.998,
              "y": 25.176,
              "z": 1.441
            },
            "gtin": "4014522302500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eac9",
            "leftCorner": {
              "x": 19.998,
              "y": 25.17,
              "z": 1.441
            },
            "rightCorner": {
              "x": 20.106,
              "y": 25.163,
              "z": 1.441
            },
            "gtin": "8585047308538",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaca",
            "leftCorner": {
              "x": 20.106,
              "y": 25.163,
              "z": 1.441
            },
            "rightCorner": {
              "x": 20.213,
              "y": 25.156,
              "z": 1.441
            },
            "gtin": "8585047308538",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41a8e"
  },
  {
    "id": "41a94",
    "name": "41a94",
    "x": 19.261,
    "y": 26.407,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99968,
      "w": 0.02547
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 36
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546881",
        "height": 1.667,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20239",
            "leftCorner": {
              "x": 18.38,
              "y": 26.399,
              "z": 1.364
            },
            "rightCorner": {
              "x": 18.342,
              "y": 26.401,
              "z": 1.364
            },
            "gtin": "039047001138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2023a",
            "leftCorner": {
              "x": 18.342,
              "y": 26.401,
              "z": 1.364
            },
            "rightCorner": {
              "x": 18.305,
              "y": 26.403,
              "z": 1.364
            },
            "gtin": "039047001138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20235",
            "leftCorner": {
              "x": 19.175,
              "y": 26.365,
              "z": 1.364
            },
            "rightCorner": {
              "x": 18.922,
              "y": 26.378,
              "z": 1.364
            },
            "gtin": "4063367197956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20236",
            "leftCorner": {
              "x": 18.922,
              "y": 26.378,
              "z": 1.364
            },
            "rightCorner": {
              "x": 18.67,
              "y": 26.39,
              "z": 1.364
            },
            "gtin": "4063367197956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20237",
            "leftCorner": {
              "x": 18.67,
              "y": 26.39,
              "z": 1.364
            },
            "rightCorner": {
              "x": 18.418,
              "y": 26.403,
              "z": 1.364
            },
            "gtin": "4063367197956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20238",
            "leftCorner": {
              "x": 18.418,
              "y": 26.397,
              "z": 1.364
            },
            "rightCorner": {
              "x": 18.38,
              "y": 26.399,
              "z": 1.364
            },
            "gtin": "039047001138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2023b",
            "leftCorner": {
              "x": 18.305,
              "y": 26.403,
              "z": 1.364
            },
            "rightCorner": {
              "x": 18.267,
              "y": 26.405,
              "z": 1.364
            },
            "gtin": "039047001138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2023c",
            "leftCorner": {
              "x": 18.267,
              "y": 26.403,
              "z": 1.364
            },
            "rightCorner": {
              "x": 18.118,
              "y": 26.411,
              "z": 1.364
            },
            "gtin": "039047001329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2023d",
            "leftCorner": {
              "x": 18.118,
              "y": 26.411,
              "z": 1.364
            },
            "rightCorner": {
              "x": 17.968,
              "y": 26.418,
              "z": 1.364
            },
            "gtin": "039047001329",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546882",
        "height": 0.16316,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2028d",
            "leftCorner": {
              "x": 19.149,
              "y": 26.364,
              "z": 0.133
            },
            "rightCorner": {
              "x": 18.953,
              "y": 26.375,
              "z": 0.133
            },
            "gtin": "4337185588259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2028e",
            "leftCorner": {
              "x": 18.952,
              "y": 26.363,
              "z": 0.133
            },
            "rightCorner": {
              "x": 18.405,
              "y": 26.39,
              "z": 0.133
            },
            "gtin": "4009176339811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2028f",
            "leftCorner": {
              "x": 18.407,
              "y": 26.41,
              "z": 0.133
            },
            "rightCorner": {
              "x": 18.207,
              "y": 26.42,
              "z": 0.133
            },
            "gtin": "4337185588273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20290",
            "leftCorner": {
              "x": 18.207,
              "y": 26.42,
              "z": 0.133
            },
            "rightCorner": {
              "x": 18.008,
              "y": 26.43,
              "z": 0.133
            },
            "gtin": "4337185588273",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546880",
        "height": 0.66226,
        "facings": [
          {
            "id": "68300c895ed67a01d9a201a5",
            "leftCorner": {
              "x": 19.161,
              "y": 26.354,
              "z": 0.542
            },
            "rightCorner": {
              "x": 18.916,
              "y": 26.367,
              "z": 0.542
            },
            "gtin": "4337185467059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201a6",
            "leftCorner": {
              "x": 18.916,
              "y": 26.371,
              "z": 0.542
            },
            "rightCorner": {
              "x": 18.612,
              "y": 26.386,
              "z": 0.542
            },
            "gtin": "4063367198076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201a7",
            "leftCorner": {
              "x": 18.612,
              "y": 26.386,
              "z": 0.542
            },
            "rightCorner": {
              "x": 18.309,
              "y": 26.402,
              "z": 0.542
            },
            "gtin": "4063367198076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201a8",
            "leftCorner": {
              "x": 18.309,
              "y": 26.402,
              "z": 0.542
            },
            "rightCorner": {
              "x": 18.006,
              "y": 26.417,
              "z": 0.542
            },
            "gtin": "4063367198076",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54687e",
        "height": 1.0158,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2015d",
            "leftCorner": {
              "x": 19.241,
              "y": 26.364,
              "z": 0.831
            },
            "rightCorner": {
              "x": 19.085,
              "y": 26.371,
              "z": 0.831
            },
            "gtin": "7610046212805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2015e",
            "leftCorner": {
              "x": 19.085,
              "y": 26.371,
              "z": 0.831
            },
            "rightCorner": {
              "x": 18.929,
              "y": 26.379,
              "z": 0.831
            },
            "gtin": "7610046212805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2015f",
            "leftCorner": {
              "x": 18.929,
              "y": 26.369,
              "z": 0.831
            },
            "rightCorner": {
              "x": 18.683,
              "y": 26.382,
              "z": 0.831
            },
            "gtin": "4006529025216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20160",
            "leftCorner": {
              "x": 18.683,
              "y": 26.382,
              "z": 0.831
            },
            "rightCorner": {
              "x": 18.438,
              "y": 26.394,
              "z": 0.831
            },
            "gtin": "4006529025216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20161",
            "leftCorner": {
              "x": 18.438,
              "y": 26.392,
              "z": 0.831
            },
            "rightCorner": {
              "x": 18.312,
              "y": 26.398,
              "z": 0.831
            },
            "gtin": "8717185473780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20162",
            "leftCorner": {
              "x": 18.312,
              "y": 26.398,
              "z": 0.831
            },
            "rightCorner": {
              "x": 18.186,
              "y": 26.404,
              "z": 0.831
            },
            "gtin": "8717185473780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20163",
            "leftCorner": {
              "x": 18.186,
              "y": 26.404,
              "z": 0.831
            },
            "rightCorner": {
              "x": 18.061,
              "y": 26.41,
              "z": 0.831
            },
            "gtin": "8717185473780",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54687f",
        "height": 1.3691,
        "facings": [
          {
            "id": "68300c895ed67a01d9a201e8",
            "leftCorner": {
              "x": 19.233,
              "y": 26.369,
              "z": 1.12
            },
            "rightCorner": {
              "x": 19.18,
              "y": 26.372,
              "z": 1.12
            },
            "gtin": "8008698005231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201e9",
            "leftCorner": {
              "x": 19.18,
              "y": 26.372,
              "z": 1.12
            },
            "rightCorner": {
              "x": 19.126,
              "y": 26.374,
              "z": 1.12
            },
            "gtin": "8008698005231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201ea",
            "leftCorner": {
              "x": 19.126,
              "y": 26.367,
              "z": 1.12
            },
            "rightCorner": {
              "x": 19.014,
              "y": 26.373,
              "z": 1.12
            },
            "gtin": "7610046312802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201eb",
            "leftCorner": {
              "x": 19.014,
              "y": 26.368,
              "z": 1.12
            },
            "rightCorner": {
              "x": 18.954,
              "y": 26.372,
              "z": 1.12
            },
            "gtin": "7610046112808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201ec",
            "leftCorner": {
              "x": 18.954,
              "y": 26.372,
              "z": 1.12
            },
            "rightCorner": {
              "x": 18.894,
              "y": 26.374,
              "z": 1.12
            },
            "gtin": "7610046112808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201ed",
            "leftCorner": {
              "x": 18.894,
              "y": 26.376,
              "z": 1.12
            },
            "rightCorner": {
              "x": 18.801,
              "y": 26.381,
              "z": 1.12
            },
            "gtin": "7610046016014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201ee",
            "leftCorner": {
              "x": 18.801,
              "y": 26.381,
              "z": 1.12
            },
            "rightCorner": {
              "x": 18.708,
              "y": 26.386,
              "z": 1.12
            },
            "gtin": "7610046016014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201ef",
            "leftCorner": {
              "x": 18.708,
              "y": 26.382,
              "z": 1.12
            },
            "rightCorner": {
              "x": 18.644,
              "y": 26.385,
              "z": 1.12
            },
            "gtin": "7610046216018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201f0",
            "leftCorner": {
              "x": 18.644,
              "y": 26.385,
              "z": 1.12
            },
            "rightCorner": {
              "x": 18.579,
              "y": 26.388,
              "z": 1.12
            },
            "gtin": "7610046216018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201f1",
            "leftCorner": {
              "x": 18.579,
              "y": 26.388,
              "z": 1.12
            },
            "rightCorner": {
              "x": 18.514,
              "y": 26.392,
              "z": 1.12
            },
            "gtin": "7610046216018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201f2",
            "leftCorner": {
              "x": 18.515,
              "y": 26.394,
              "z": 1.12
            },
            "rightCorner": {
              "x": 18.279,
              "y": 26.406,
              "z": 1.12
            },
            "gtin": "7610046116011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201f3",
            "leftCorner": {
              "x": 18.279,
              "y": 26.404,
              "z": 1.12
            },
            "rightCorner": {
              "x": 17.974,
              "y": 26.419,
              "z": 1.12
            },
            "gtin": "7610046316015",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d1360",
    "rightNeighborShelfId": "41a95"
  },
  {
    "id": "41a95",
    "name": "41a95",
    "x": 18.062,
    "y": 26.468,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99968,
      "w": 0.02547
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 32
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5465c3",
        "height": 0.16217,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20291",
            "leftCorner": {
              "x": 18.007,
              "y": 26.407,
              "z": 0.133
            },
            "rightCorner": {
              "x": 17.81,
              "y": 26.417,
              "z": 0.133
            },
            "gtin": "9000331607788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20292",
            "leftCorner": {
              "x": 17.81,
              "y": 26.417,
              "z": 0.133
            },
            "rightCorner": {
              "x": 17.557,
              "y": 26.431,
              "z": 0.133
            },
            "gtin": "9000331607917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20293",
            "leftCorner": {
              "x": 17.557,
              "y": 26.437,
              "z": 0.133
            },
            "rightCorner": {
              "x": 17.367,
              "y": 26.446,
              "z": 0.133
            },
            "gtin": "9000331607719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20294",
            "leftCorner": {
              "x": 17.367,
              "y": 26.446,
              "z": 0.133
            },
            "rightCorner": {
              "x": 17.176,
              "y": 26.456,
              "z": 0.133
            },
            "gtin": "9000331607719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20295",
            "leftCorner": {
              "x": 17.176,
              "y": 26.452,
              "z": 0.133
            },
            "rightCorner": {
              "x": 16.776,
              "y": 26.472,
              "z": 0.133
            },
            "gtin": "4009176514508",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465c0",
        "height": 0.66422,
        "facings": [
          {
            "id": "68300c895ed67a01d9a201a9",
            "leftCorner": {
              "x": 18.005,
              "y": 26.413,
              "z": 0.543
            },
            "rightCorner": {
              "x": 17.826,
              "y": 26.422,
              "z": 0.543
            },
            "gtin": "9000331607702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201aa",
            "leftCorner": {
              "x": 17.826,
              "y": 26.422,
              "z": 0.543
            },
            "rightCorner": {
              "x": 17.646,
              "y": 26.431,
              "z": 0.543
            },
            "gtin": "9000331607702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201ab",
            "leftCorner": {
              "x": 17.646,
              "y": 26.431,
              "z": 0.543
            },
            "rightCorner": {
              "x": 17.466,
              "y": 26.44,
              "z": 0.543
            },
            "gtin": "9000331607702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201ac",
            "leftCorner": {
              "x": 17.465,
              "y": 26.423,
              "z": 0.543
            },
            "rightCorner": {
              "x": 17.137,
              "y": 26.441,
              "z": 0.543
            },
            "gtin": "9000331607948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201ad",
            "leftCorner": {
              "x": 17.137,
              "y": 26.441,
              "z": 0.543
            },
            "rightCorner": {
              "x": 16.809,
              "y": 26.457,
              "z": 0.543
            },
            "gtin": "9000331607948",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465bf",
        "height": 1.0186,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20164",
            "leftCorner": {
              "x": 18.061,
              "y": 26.428,
              "z": 0.833
            },
            "rightCorner": {
              "x": 17.918,
              "y": 26.435,
              "z": 0.833
            },
            "gtin": "9000331607924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20165",
            "leftCorner": {
              "x": 17.918,
              "y": 26.435,
              "z": 0.833
            },
            "rightCorner": {
              "x": 17.776,
              "y": 26.443,
              "z": 0.833
            },
            "gtin": "9000331607924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20166",
            "leftCorner": {
              "x": 17.774,
              "y": 26.431,
              "z": 0.833
            },
            "rightCorner": {
              "x": 17.452,
              "y": 26.447,
              "z": 0.833
            },
            "gtin": "9000331607795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20167",
            "leftCorner": {
              "x": 17.452,
              "y": 26.447,
              "z": 0.833
            },
            "rightCorner": {
              "x": 17.129,
              "y": 26.464,
              "z": 0.833
            },
            "gtin": "9000331607795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20168",
            "leftCorner": {
              "x": 17.129,
              "y": 26.46,
              "z": 0.833
            },
            "rightCorner": {
              "x": 16.96,
              "y": 26.468,
              "z": 0.833
            },
            "gtin": "4006952008145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20169",
            "leftCorner": {
              "x": 16.96,
              "y": 26.468,
              "z": 0.833
            },
            "rightCorner": {
              "x": 16.792,
              "y": 26.477,
              "z": 0.833
            },
            "gtin": "4006952008145",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465c1",
        "height": 1.3683,
        "facings": [
          {
            "id": "68300c895ed67a01d9a201f4",
            "leftCorner": {
              "x": 17.975,
              "y": 26.428,
              "z": 1.12
            },
            "rightCorner": {
              "x": 17.712,
              "y": 26.442,
              "z": 1.12
            },
            "gtin": "9000331627908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201f5",
            "leftCorner": {
              "x": 17.712,
              "y": 26.442,
              "z": 1.12
            },
            "rightCorner": {
              "x": 17.45,
              "y": 26.455,
              "z": 1.12
            },
            "gtin": "9000331627908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201f6",
            "leftCorner": {
              "x": 17.448,
              "y": 26.435,
              "z": 1.12
            },
            "rightCorner": {
              "x": 17.279,
              "y": 26.442,
              "z": 1.12
            },
            "gtin": "9000331607955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201f7",
            "leftCorner": {
              "x": 17.279,
              "y": 26.442,
              "z": 1.12
            },
            "rightCorner": {
              "x": 17.112,
              "y": 26.451,
              "z": 1.12
            },
            "gtin": "9000331607955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201f8",
            "leftCorner": {
              "x": 17.112,
              "y": 26.453,
              "z": 1.12
            },
            "rightCorner": {
              "x": 16.922,
              "y": 26.464,
              "z": 1.12
            },
            "gtin": "9000331627908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201f9",
            "leftCorner": {
              "x": 16.922,
              "y": 26.464,
              "z": 1.12
            },
            "rightCorner": {
              "x": 16.733,
              "y": 26.473,
              "z": 1.12
            },
            "gtin": "9000331627908",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465c2",
        "height": 1.6703,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2023e",
            "leftCorner": {
              "x": 17.968,
              "y": 26.424,
              "z": 1.367
            },
            "rightCorner": {
              "x": 17.9,
              "y": 26.427,
              "z": 1.367
            },
            "gtin": "039047001176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2023f",
            "leftCorner": {
              "x": 17.9,
              "y": 26.427,
              "z": 1.367
            },
            "rightCorner": {
              "x": 17.832,
              "y": 26.43,
              "z": 1.367
            },
            "gtin": "039047001176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20240",
            "leftCorner": {
              "x": 17.832,
              "y": 26.419,
              "z": 1.367
            },
            "rightCorner": {
              "x": 17.7,
              "y": 26.426,
              "z": 1.367
            },
            "gtin": "9000331693286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20241",
            "leftCorner": {
              "x": 17.7,
              "y": 26.429,
              "z": 1.367
            },
            "rightCorner": {
              "x": 17.581,
              "y": 26.435,
              "z": 1.367
            },
            "gtin": "4006894590609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20242",
            "leftCorner": {
              "x": 17.581,
              "y": 26.435,
              "z": 1.367
            },
            "rightCorner": {
              "x": 17.461,
              "y": 26.441,
              "z": 1.367
            },
            "gtin": "4006894590609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20243",
            "leftCorner": {
              "x": 17.461,
              "y": 26.437,
              "z": 1.367
            },
            "rightCorner": {
              "x": 17.329,
              "y": 26.444,
              "z": 1.367
            },
            "gtin": "9000331614700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20244",
            "leftCorner": {
              "x": 17.329,
              "y": 26.444,
              "z": 1.367
            },
            "rightCorner": {
              "x": 17.198,
              "y": 26.45,
              "z": 1.367
            },
            "gtin": "9000331614700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20245",
            "leftCorner": {
              "x": 17.198,
              "y": 26.45,
              "z": 1.367
            },
            "rightCorner": {
              "x": 17.048,
              "y": 26.457,
              "z": 1.367
            },
            "gtin": "9000331614410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20246",
            "leftCorner": {
              "x": 17.048,
              "y": 26.466,
              "z": 1.367
            },
            "rightCorner": {
              "x": 16.946,
              "y": 26.472,
              "z": 1.367
            },
            "gtin": "9000331697048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20247",
            "leftCorner": {
              "x": 16.946,
              "y": 26.472,
              "z": 1.367
            },
            "rightCorner": {
              "x": 16.843,
              "y": 26.477,
              "z": 1.367
            },
            "gtin": "9000331697048",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41a94",
    "rightNeighborShelfId": "41a96"
  },
  {
    "id": "41a96",
    "name": "41a96",
    "x": 16.864,
    "y": 26.529,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99968,
      "w": 0.02547
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 39
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546887",
        "height": 0.16051,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20296",
            "leftCorner": {
              "x": 16.777,
              "y": 26.482,
              "z": 0.131
            },
            "rightCorner": {
              "x": 15.992,
              "y": 26.522,
              "z": 0.131
            },
            "gtin": "4337185329814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20297",
            "leftCorner": {
              "x": 15.992,
              "y": 26.528,
              "z": 0.131
            },
            "rightCorner": {
              "x": 15.786,
              "y": 26.539,
              "z": 0.131
            },
            "gtin": "4337185329845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20298",
            "leftCorner": {
              "x": 15.786,
              "y": 26.539,
              "z": 0.131
            },
            "rightCorner": {
              "x": 15.579,
              "y": 26.549,
              "z": 0.131
            },
            "gtin": "4337185329845",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546884",
        "height": 0.66546,
        "facings": [
          {
            "id": "68300c895ed67a01d9a201ae",
            "leftCorner": {
              "x": 16.811,
              "y": 26.491,
              "z": 0.544
            },
            "rightCorner": {
              "x": 16.67,
              "y": 26.497,
              "z": 0.544
            },
            "gtin": "4001518117453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201af",
            "leftCorner": {
              "x": 16.67,
              "y": 26.497,
              "z": 0.544
            },
            "rightCorner": {
              "x": 16.529,
              "y": 26.505,
              "z": 0.544
            },
            "gtin": "4001518117453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201b0",
            "leftCorner": {
              "x": 16.529,
              "y": 26.505,
              "z": 0.544
            },
            "rightCorner": {
              "x": 16.389,
              "y": 26.512,
              "z": 0.544
            },
            "gtin": "4001518117453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201b1",
            "leftCorner": {
              "x": 16.389,
              "y": 26.512,
              "z": 0.544
            },
            "rightCorner": {
              "x": 16.248,
              "y": 26.52,
              "z": 0.544
            },
            "gtin": "4001518117453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201b2",
            "leftCorner": {
              "x": 16.248,
              "y": 26.512,
              "z": 0.544
            },
            "rightCorner": {
              "x": 16.096,
              "y": 26.52,
              "z": 0.544
            },
            "gtin": "4009703000634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201b3",
            "leftCorner": {
              "x": 16.096,
              "y": 26.52,
              "z": 0.544
            },
            "rightCorner": {
              "x": 15.944,
              "y": 26.527,
              "z": 0.544
            },
            "gtin": "4009703000634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201b4",
            "leftCorner": {
              "x": 15.944,
              "y": 26.52,
              "z": 0.544
            },
            "rightCorner": {
              "x": 15.846,
              "y": 26.524,
              "z": 0.544
            },
            "gtin": "4337185467004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201b5",
            "leftCorner": {
              "x": 15.846,
              "y": 26.524,
              "z": 0.544
            },
            "rightCorner": {
              "x": 15.747,
              "y": 26.529,
              "z": 0.544
            },
            "gtin": "4337185467004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201b6",
            "leftCorner": {
              "x": 15.748,
              "y": 26.544,
              "z": 0.544
            },
            "rightCorner": {
              "x": 15.673,
              "y": 26.548,
              "z": 0.544
            },
            "gtin": "4337185467011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201b7",
            "leftCorner": {
              "x": 15.673,
              "y": 26.548,
              "z": 0.544
            },
            "rightCorner": {
              "x": 15.598,
              "y": 26.552,
              "z": 0.544
            },
            "gtin": "4337185467011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201b8",
            "leftCorner": {
              "x": 15.598,
              "y": 26.552,
              "z": 0.544
            },
            "rightCorner": {
              "x": 15.523,
              "y": 26.556,
              "z": 0.544
            },
            "gtin": "4337185467011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201b9",
            "leftCorner": {
              "x": 15.523,
              "y": 26.556,
              "z": 0.544
            },
            "rightCorner": {
              "x": 15.448,
              "y": 26.56,
              "z": 0.544
            },
            "gtin": "4337185467011",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546885",
        "height": 1.0166,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2016a",
            "leftCorner": {
              "x": 16.793,
              "y": 26.502,
              "z": 0.832
            },
            "rightCorner": {
              "x": 16.612,
              "y": 26.511,
              "z": 0.832
            },
            "gtin": "4006952006943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2016b",
            "leftCorner": {
              "x": 16.612,
              "y": 26.511,
              "z": 0.832
            },
            "rightCorner": {
              "x": 16.432,
              "y": 26.522,
              "z": 0.832
            },
            "gtin": "4006952006943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2016c",
            "leftCorner": {
              "x": 16.431,
              "y": 26.506,
              "z": 0.832
            },
            "rightCorner": {
              "x": 16.311,
              "y": 26.512,
              "z": 0.832
            },
            "gtin": "4006952006936",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2016d",
            "leftCorner": {
              "x": 16.311,
              "y": 26.512,
              "z": 0.832
            },
            "rightCorner": {
              "x": 16.191,
              "y": 26.518,
              "z": 0.832
            },
            "gtin": "4006952006936",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2016e",
            "leftCorner": {
              "x": 16.191,
              "y": 26.513,
              "z": 0.832
            },
            "rightCorner": {
              "x": 16.098,
              "y": 26.517,
              "z": 0.832
            },
            "gtin": "4063367194429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2016f",
            "leftCorner": {
              "x": 16.098,
              "y": 26.517,
              "z": 0.832
            },
            "rightCorner": {
              "x": 16.005,
              "y": 26.522,
              "z": 0.832
            },
            "gtin": "4063367194429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20170",
            "leftCorner": {
              "x": 16.005,
              "y": 26.522,
              "z": 0.832
            },
            "rightCorner": {
              "x": 15.912,
              "y": 26.526,
              "z": 0.832
            },
            "gtin": "4063367194429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20171",
            "leftCorner": {
              "x": 15.912,
              "y": 26.527,
              "z": 0.832
            },
            "rightCorner": {
              "x": 15.788,
              "y": 26.534,
              "z": 0.832
            },
            "gtin": "4063367194436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20172",
            "leftCorner": {
              "x": 15.788,
              "y": 26.534,
              "z": 0.832
            },
            "rightCorner": {
              "x": 15.664,
              "y": 26.54,
              "z": 0.832
            },
            "gtin": "4063367194436",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546886",
        "height": 1.3712,
        "facings": [
          {
            "id": "68300c895ed67a01d9a201fa",
            "leftCorner": {
              "x": 16.734,
              "y": 26.497,
              "z": 1.122
            },
            "rightCorner": {
              "x": 16.529,
              "y": 26.507,
              "z": 1.122
            },
            "gtin": "4006894512205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201fb",
            "leftCorner": {
              "x": 16.529,
              "y": 26.507,
              "z": 1.122
            },
            "rightCorner": {
              "x": 16.323,
              "y": 26.518,
              "z": 1.122
            },
            "gtin": "4006894512205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201fc",
            "leftCorner": {
              "x": 16.324,
              "y": 26.527,
              "z": 1.122
            },
            "rightCorner": {
              "x": 16.224,
              "y": 26.531,
              "z": 1.122
            },
            "gtin": "4006894532104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201fd",
            "leftCorner": {
              "x": 16.224,
              "y": 26.531,
              "z": 1.122
            },
            "rightCorner": {
              "x": 16.124,
              "y": 26.537,
              "z": 1.122
            },
            "gtin": "4006894532104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201fe",
            "leftCorner": {
              "x": 16.124,
              "y": 26.528,
              "z": 1.122
            },
            "rightCorner": {
              "x": 15.827,
              "y": 26.543,
              "z": 1.122
            },
            "gtin": "4006529020716",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201ff",
            "leftCorner": {
              "x": 15.827,
              "y": 26.543,
              "z": 1.122
            },
            "rightCorner": {
              "x": 15.531,
              "y": 26.558,
              "z": 1.122
            },
            "gtin": "4006529020716",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546883",
        "height": 1.6688,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20248",
            "leftCorner": {
              "x": 16.845,
              "y": 26.489,
              "z": 1.365
            },
            "rightCorner": {
              "x": 16.759,
              "y": 26.493,
              "z": 1.365
            },
            "gtin": "4006894554106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20249",
            "leftCorner": {
              "x": 16.759,
              "y": 26.493,
              "z": 1.365
            },
            "rightCorner": {
              "x": 16.674,
              "y": 26.497,
              "z": 1.365
            },
            "gtin": "4006894554106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2024a",
            "leftCorner": {
              "x": 16.674,
              "y": 26.497,
              "z": 1.365
            },
            "rightCorner": {
              "x": 16.589,
              "y": 26.501,
              "z": 1.365
            },
            "gtin": "4006894554106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2024b",
            "leftCorner": {
              "x": 16.589,
              "y": 26.504,
              "z": 1.365
            },
            "rightCorner": {
              "x": 16.319,
              "y": 26.518,
              "z": 1.365
            },
            "gtin": "4006894116205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2024c",
            "leftCorner": {
              "x": 16.319,
              "y": 26.519,
              "z": 1.365
            },
            "rightCorner": {
              "x": 16.218,
              "y": 26.525,
              "z": 1.365
            },
            "gtin": "4006894126907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2024d",
            "leftCorner": {
              "x": 16.218,
              "y": 26.525,
              "z": 1.365
            },
            "rightCorner": {
              "x": 16.118,
              "y": 26.53,
              "z": 1.365
            },
            "gtin": "4006894126907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2024e",
            "leftCorner": {
              "x": 16.118,
              "y": 26.527,
              "z": 1.365
            },
            "rightCorner": {
              "x": 15.861,
              "y": 26.541,
              "z": 1.365
            },
            "gtin": "4006894510805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2024f",
            "leftCorner": {
              "x": 15.861,
              "y": 26.542,
              "z": 1.365
            },
            "rightCorner": {
              "x": 15.721,
              "y": 26.549,
              "z": 1.365
            },
            "gtin": "4006894518504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20250",
            "leftCorner": {
              "x": 15.721,
              "y": 26.549,
              "z": 1.365
            },
            "rightCorner": {
              "x": 15.581,
              "y": 26.556,
              "z": 1.365
            },
            "gtin": "4006894518504",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41a95",
    "rightNeighborShelfId": "41a97"
  },
  {
    "id": "41a97",
    "name": "41a97",
    "x": 15.665,
    "y": 26.59,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99968,
      "w": 0.02547
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 44
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54688a",
        "height": 0.15699,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20299",
            "leftCorner": {
              "x": 15.578,
              "y": 26.548,
              "z": 0.128
            },
            "rightCorner": {
              "x": 15.463,
              "y": 26.554,
              "z": 0.128
            },
            "gtin": "8720663520487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2029a",
            "leftCorner": {
              "x": 15.463,
              "y": 26.554,
              "z": 0.128
            },
            "rightCorner": {
              "x": 15.348,
              "y": 26.56,
              "z": 0.128
            },
            "gtin": "8720663520487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2029b",
            "leftCorner": {
              "x": 15.348,
              "y": 26.556,
              "z": 0.128
            },
            "rightCorner": {
              "x": 15.245,
              "y": 26.562,
              "z": 0.128
            },
            "gtin": "4006529002163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2029c",
            "leftCorner": {
              "x": 15.245,
              "y": 26.562,
              "z": 0.128
            },
            "rightCorner": {
              "x": 15.141,
              "y": 26.567,
              "z": 0.128
            },
            "gtin": "4006529002163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2029d",
            "leftCorner": {
              "x": 15.141,
              "y": 26.565,
              "z": 0.128
            },
            "rightCorner": {
              "x": 14.694,
              "y": 26.588,
              "z": 0.128
            },
            "gtin": "4006529002156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2029e",
            "leftCorner": {
              "x": 14.693,
              "y": 26.576,
              "z": 0.128
            },
            "rightCorner": {
              "x": 14.557,
              "y": 26.582,
              "z": 0.128
            },
            "gtin": "4006529002149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2029f",
            "leftCorner": {
              "x": 14.557,
              "y": 26.582,
              "z": 0.128
            },
            "rightCorner": {
              "x": 14.42,
              "y": 26.589,
              "z": 0.128
            },
            "gtin": "4006529002149",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54688c",
        "height": 0.66211,
        "facings": [
          {
            "id": "68300c895ed67a01d9a201ba",
            "leftCorner": {
              "x": 15.447,
              "y": 26.549,
              "z": 0.542
            },
            "rightCorner": {
              "x": 15.302,
              "y": 26.557,
              "z": 0.542
            },
            "gtin": "4337185467035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201bb",
            "leftCorner": {
              "x": 15.302,
              "y": 26.557,
              "z": 0.542
            },
            "rightCorner": {
              "x": 15.157,
              "y": 26.564,
              "z": 0.542
            },
            "gtin": "4337185467035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201bc",
            "leftCorner": {
              "x": 15.157,
              "y": 26.564,
              "z": 0.542
            },
            "rightCorner": {
              "x": 15.011,
              "y": 26.572,
              "z": 0.542
            },
            "gtin": "4337185467035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201bd",
            "leftCorner": {
              "x": 15.011,
              "y": 26.57,
              "z": 0.542
            },
            "rightCorner": {
              "x": 14.789,
              "y": 26.581,
              "z": 0.542
            },
            "gtin": "4337185466984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201be",
            "leftCorner": {
              "x": 14.788,
              "y": 26.576,
              "z": 0.542
            },
            "rightCorner": {
              "x": 14.695,
              "y": 26.58,
              "z": 0.542
            },
            "gtin": "4337185467028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201bf",
            "leftCorner": {
              "x": 14.695,
              "y": 26.58,
              "z": 0.542
            },
            "rightCorner": {
              "x": 14.601,
              "y": 26.586,
              "z": 0.542
            },
            "gtin": "4337185467028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201c0",
            "leftCorner": {
              "x": 14.603,
              "y": 26.594,
              "z": 0.542
            },
            "rightCorner": {
              "x": 14.519,
              "y": 26.598,
              "z": 0.542
            },
            "gtin": "4337185450280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201c1",
            "leftCorner": {
              "x": 14.519,
              "y": 26.598,
              "z": 0.542
            },
            "rightCorner": {
              "x": 14.435,
              "y": 26.602,
              "z": 0.542
            },
            "gtin": "4337185450280",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546889",
        "height": 1.0132,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20173",
            "leftCorner": {
              "x": 15.664,
              "y": 26.549,
              "z": 0.829
            },
            "rightCorner": {
              "x": 15.579,
              "y": 26.554,
              "z": 0.829
            },
            "gtin": "4337185458057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20174",
            "leftCorner": {
              "x": 15.579,
              "y": 26.554,
              "z": 0.829
            },
            "rightCorner": {
              "x": 15.495,
              "y": 26.558,
              "z": 0.829
            },
            "gtin": "4337185458057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20175",
            "leftCorner": {
              "x": 15.495,
              "y": 26.555,
              "z": 0.829
            },
            "rightCorner": {
              "x": 15.246,
              "y": 26.568,
              "z": 0.829
            },
            "gtin": "4337185458095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20176",
            "leftCorner": {
              "x": 15.246,
              "y": 26.572,
              "z": 0.829
            },
            "rightCorner": {
              "x": 15.062,
              "y": 26.582,
              "z": 0.829
            },
            "gtin": "8720663520470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20177",
            "leftCorner": {
              "x": 15.062,
              "y": 26.582,
              "z": 0.829
            },
            "rightCorner": {
              "x": 14.879,
              "y": 26.591,
              "z": 0.829
            },
            "gtin": "8720663520470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20178",
            "leftCorner": {
              "x": 14.879,
              "y": 26.591,
              "z": 0.829
            },
            "rightCorner": {
              "x": 14.695,
              "y": 26.601,
              "z": 0.829
            },
            "gtin": "8720663520470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20179",
            "leftCorner": {
              "x": 14.694,
              "y": 26.595,
              "z": 0.829
            },
            "rightCorner": {
              "x": 14.605,
              "y": 26.598,
              "z": 0.829
            },
            "gtin": "8720663520494",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2017a",
            "leftCorner": {
              "x": 14.605,
              "y": 26.598,
              "z": 0.829
            },
            "rightCorner": {
              "x": 14.515,
              "y": 26.603,
              "z": 0.829
            },
            "gtin": "8720663520494",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2017b",
            "leftCorner": {
              "x": 14.515,
              "y": 26.603,
              "z": 0.829
            },
            "rightCorner": {
              "x": 14.426,
              "y": 26.608,
              "z": 0.829
            },
            "gtin": "8720663520494",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54688b",
        "height": 1.3644,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20200",
            "leftCorner": {
              "x": 15.53,
              "y": 26.547,
              "z": 1.116
            },
            "rightCorner": {
              "x": 15.381,
              "y": 26.554,
              "z": 1.116
            },
            "gtin": "4001518116593",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20201",
            "leftCorner": {
              "x": 15.381,
              "y": 26.555,
              "z": 1.116
            },
            "rightCorner": {
              "x": 15.181,
              "y": 26.566,
              "z": 1.116
            },
            "gtin": "4001518110454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20202",
            "leftCorner": {
              "x": 15.181,
              "y": 26.566,
              "z": 1.116
            },
            "rightCorner": {
              "x": 14.982,
              "y": 26.576,
              "z": 1.116
            },
            "gtin": "4001518110454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20203",
            "leftCorner": {
              "x": 14.982,
              "y": 26.572,
              "z": 1.116
            },
            "rightCorner": {
              "x": 14.901,
              "y": 26.576,
              "z": 1.116
            },
            "gtin": "8690504010609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20204",
            "leftCorner": {
              "x": 14.901,
              "y": 26.576,
              "z": 1.116
            },
            "rightCorner": {
              "x": 14.821,
              "y": 26.58,
              "z": 1.116
            },
            "gtin": "8690504010609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20205",
            "leftCorner": {
              "x": 14.821,
              "y": 26.585,
              "z": 1.116
            },
            "rightCorner": {
              "x": 14.737,
              "y": 26.589,
              "z": 1.116
            },
            "gtin": "4002652007112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20206",
            "leftCorner": {
              "x": 14.737,
              "y": 26.589,
              "z": 1.116
            },
            "rightCorner": {
              "x": 14.654,
              "y": 26.594,
              "z": 1.116
            },
            "gtin": "4002652007112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20207",
            "leftCorner": {
              "x": 14.652,
              "y": 26.588,
              "z": 1.116
            },
            "rightCorner": {
              "x": 14.527,
              "y": 26.594,
              "z": 1.116
            },
            "gtin": "4063367006685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20208",
            "leftCorner": {
              "x": 14.527,
              "y": 26.594,
              "z": 1.116
            },
            "rightCorner": {
              "x": 14.4,
              "y": 26.6,
              "z": 1.116
            },
            "gtin": "4063367006685",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546888",
        "height": 1.6656,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20251",
            "leftCorner": {
              "x": 15.581,
              "y": 26.559,
              "z": 1.363
            },
            "rightCorner": {
              "x": 15.468,
              "y": 26.564,
              "z": 1.363
            },
            "gtin": "4001518117408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20252",
            "leftCorner": {
              "x": 15.468,
              "y": 26.564,
              "z": 1.363
            },
            "rightCorner": {
              "x": 15.355,
              "y": 26.57,
              "z": 1.363
            },
            "gtin": "4001518117408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20253",
            "leftCorner": {
              "x": 15.355,
              "y": 26.557,
              "z": 1.363
            },
            "rightCorner": {
              "x": 15.255,
              "y": 26.562,
              "z": 1.363
            },
            "gtin": "4001518116272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20254",
            "leftCorner": {
              "x": 15.255,
              "y": 26.562,
              "z": 1.363
            },
            "rightCorner": {
              "x": 15.156,
              "y": 26.568,
              "z": 1.363
            },
            "gtin": "4001518116272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20255",
            "leftCorner": {
              "x": 15.156,
              "y": 26.568,
              "z": 1.363
            },
            "rightCorner": {
              "x": 15.057,
              "y": 26.572,
              "z": 1.363
            },
            "gtin": "4001518116272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20256",
            "leftCorner": {
              "x": 15.057,
              "y": 26.574,
              "z": 1.363
            },
            "rightCorner": {
              "x": 14.931,
              "y": 26.58,
              "z": 1.363
            },
            "gtin": "5410126006360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20257",
            "leftCorner": {
              "x": 14.931,
              "y": 26.58,
              "z": 1.363
            },
            "rightCorner": {
              "x": 14.806,
              "y": 26.586,
              "z": 1.363
            },
            "gtin": "5410126006360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20258",
            "leftCorner": {
              "x": 14.806,
              "y": 26.582,
              "z": 1.363
            },
            "rightCorner": {
              "x": 14.738,
              "y": 26.586,
              "z": 1.363
            },
            "gtin": "5410126006377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20259",
            "leftCorner": {
              "x": 14.738,
              "y": 26.586,
              "z": 1.363
            },
            "rightCorner": {
              "x": 14.67,
              "y": 26.589,
              "z": 1.363
            },
            "gtin": "5410126006377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2025a",
            "leftCorner": {
              "x": 14.67,
              "y": 26.589,
              "z": 1.363
            },
            "rightCorner": {
              "x": 14.604,
              "y": 26.592,
              "z": 1.363
            },
            "gtin": "5410126006377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2025b",
            "leftCorner": {
              "x": 14.604,
              "y": 26.599,
              "z": 1.363
            },
            "rightCorner": {
              "x": 14.405,
              "y": 26.61,
              "z": 1.363
            },
            "gtin": "4001518116791",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41a96",
    "rightNeighborShelfId": "41a98"
  },
  {
    "id": "41a98",
    "name": "41a98",
    "x": 14.456,
    "y": 26.652,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99948,
      "w": 0.032248
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 39
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546890",
        "height": 1.01,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20181",
            "leftCorner": {
              "x": 13.933,
              "y": 26.638,
              "z": 0.826
            },
            "rightCorner": {
              "x": 13.836,
              "y": 26.644,
              "z": 0.826
            },
            "gtin": "4001518113639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20182",
            "leftCorner": {
              "x": 13.835,
              "y": 26.637,
              "z": 0.826
            },
            "rightCorner": {
              "x": 13.728,
              "y": 26.645,
              "z": 0.826
            },
            "gtin": "4001518115039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20183",
            "leftCorner": {
              "x": 13.728,
              "y": 26.645,
              "z": 0.826
            },
            "rightCorner": {
              "x": 13.621,
              "y": 26.652,
              "z": 0.826
            },
            "gtin": "4001518115039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20184",
            "leftCorner": {
              "x": 13.621,
              "y": 26.652,
              "z": 0.826
            },
            "rightCorner": {
              "x": 13.523,
              "y": 26.658,
              "z": 0.826
            },
            "gtin": "4101540714580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20185",
            "leftCorner": {
              "x": 13.523,
              "y": 26.654,
              "z": 0.826
            },
            "rightCorner": {
              "x": 13.4,
              "y": 26.662,
              "z": 0.826
            },
            "gtin": "4101540714573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20186",
            "leftCorner": {
              "x": 13.4,
              "y": 26.666,
              "z": 0.826
            },
            "rightCorner": {
              "x": 13.273,
              "y": 26.675,
              "z": 0.826
            },
            "gtin": "8717185470154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2017c",
            "leftCorner": {
              "x": 14.414,
              "y": 26.602,
              "z": 0.826
            },
            "rightCorner": {
              "x": 14.319,
              "y": 26.609,
              "z": 0.826
            },
            "gtin": "4001518115190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2017d",
            "leftCorner": {
              "x": 14.319,
              "y": 26.609,
              "z": 0.826
            },
            "rightCorner": {
              "x": 14.226,
              "y": 26.614,
              "z": 0.826
            },
            "gtin": "4001518115190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2017e",
            "leftCorner": {
              "x": 14.226,
              "y": 26.62,
              "z": 0.826
            },
            "rightCorner": {
              "x": 14.129,
              "y": 26.625,
              "z": 0.826
            },
            "gtin": "4001518113639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2017f",
            "leftCorner": {
              "x": 14.129,
              "y": 26.625,
              "z": 0.826
            },
            "rightCorner": {
              "x": 14.031,
              "y": 26.632,
              "z": 0.826
            },
            "gtin": "4001518113639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20180",
            "leftCorner": {
              "x": 14.031,
              "y": 26.632,
              "z": 0.826
            },
            "rightCorner": {
              "x": 13.933,
              "y": 26.638,
              "z": 0.826
            },
            "gtin": "4001518113639",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546891",
        "height": 0.15632,
        "facings": [
          {
            "id": "68300c895ed67a01d9a202a0",
            "leftCorner": {
              "x": 14.409,
              "y": 26.603,
              "z": 0.128
            },
            "rightCorner": {
              "x": 14.105,
              "y": 26.623,
              "z": 0.128
            },
            "gtin": "4009176339743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202a1",
            "leftCorner": {
              "x": 14.105,
              "y": 26.623,
              "z": 0.128
            },
            "rightCorner": {
              "x": 13.801,
              "y": 26.642,
              "z": 0.128
            },
            "gtin": "4009176339743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202a2",
            "leftCorner": {
              "x": 13.801,
              "y": 26.64,
              "z": 0.128
            },
            "rightCorner": {
              "x": 13.602,
              "y": 26.653,
              "z": 0.128
            },
            "gtin": "4009176339750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202a3",
            "leftCorner": {
              "x": 13.602,
              "y": 26.653,
              "z": 0.128
            },
            "rightCorner": {
              "x": 13.402,
              "y": 26.666,
              "z": 0.128
            },
            "gtin": "4009176339750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202a4",
            "leftCorner": {
              "x": 13.402,
              "y": 26.666,
              "z": 0.128
            },
            "rightCorner": {
              "x": 13.202,
              "y": 26.679,
              "z": 0.128
            },
            "gtin": "4009176339750",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54688d",
        "height": 0.65943,
        "facings": [
          {
            "id": "68300c895ed67a01d9a201c2",
            "leftCorner": {
              "x": 14.423,
              "y": 26.6,
              "z": 0.54
            },
            "rightCorner": {
              "x": 14.218,
              "y": 26.613,
              "z": 0.54
            },
            "gtin": "4009176339767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201c3",
            "leftCorner": {
              "x": 14.218,
              "y": 26.613,
              "z": 0.54
            },
            "rightCorner": {
              "x": 14.012,
              "y": 26.627,
              "z": 0.54
            },
            "gtin": "4009176339767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201c4",
            "leftCorner": {
              "x": 14.012,
              "y": 26.627,
              "z": 0.54
            },
            "rightCorner": {
              "x": 13.806,
              "y": 26.64,
              "z": 0.54
            },
            "gtin": "4009176339767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201c5",
            "leftCorner": {
              "x": 13.806,
              "y": 26.639,
              "z": 0.54
            },
            "rightCorner": {
              "x": 13.186,
              "y": 26.68,
              "z": 0.54
            },
            "gtin": "4063367429675",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54688f",
        "height": 1.3629,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20209",
            "leftCorner": {
              "x": 14.388,
              "y": 26.602,
              "z": 1.115
            },
            "rightCorner": {
              "x": 14.219,
              "y": 26.613,
              "z": 1.115
            },
            "gtin": "4063367006661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2020a",
            "leftCorner": {
              "x": 14.219,
              "y": 26.613,
              "z": 1.115
            },
            "rightCorner": {
              "x": 14.05,
              "y": 26.624,
              "z": 1.115
            },
            "gtin": "4063367006661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2020b",
            "leftCorner": {
              "x": 14.05,
              "y": 26.624,
              "z": 1.115
            },
            "rightCorner": {
              "x": 13.976,
              "y": 26.628,
              "z": 1.115
            },
            "gtin": "4337185537639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2020c",
            "leftCorner": {
              "x": 13.976,
              "y": 26.628,
              "z": 1.115
            },
            "rightCorner": {
              "x": 13.903,
              "y": 26.633,
              "z": 1.115
            },
            "gtin": "4337185537639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2020d",
            "leftCorner": {
              "x": 13.903,
              "y": 26.633,
              "z": 1.115
            },
            "rightCorner": {
              "x": 13.83,
              "y": 26.637,
              "z": 1.115
            },
            "gtin": "4337185537639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2020e",
            "leftCorner": {
              "x": 13.83,
              "y": 26.638,
              "z": 1.115
            },
            "rightCorner": {
              "x": 13.646,
              "y": 26.65,
              "z": 1.115
            },
            "gtin": "7300400125956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2020f",
            "leftCorner": {
              "x": 13.646,
              "y": 26.65,
              "z": 1.115
            },
            "rightCorner": {
              "x": 13.463,
              "y": 26.662,
              "z": 1.115
            },
            "gtin": "7300400125956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20210",
            "leftCorner": {
              "x": 13.463,
              "y": 26.664,
              "z": 1.115
            },
            "rightCorner": {
              "x": 13.266,
              "y": 26.677,
              "z": 1.115
            },
            "gtin": "8000500385807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20211",
            "leftCorner": {
              "x": 13.266,
              "y": 26.677,
              "z": 1.115
            },
            "rightCorner": {
              "x": 13.068,
              "y": 26.69,
              "z": 1.115
            },
            "gtin": "8000500385807",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54688e",
        "height": 1.6634,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2025c",
            "leftCorner": {
              "x": 14.393,
              "y": 26.6,
              "z": 1.361
            },
            "rightCorner": {
              "x": 14.316,
              "y": 26.606,
              "z": 1.361
            },
            "gtin": "8008698004630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2025d",
            "leftCorner": {
              "x": 14.316,
              "y": 26.606,
              "z": 1.361
            },
            "rightCorner": {
              "x": 14.24,
              "y": 26.61,
              "z": 1.361
            },
            "gtin": "8008698004630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2025e",
            "leftCorner": {
              "x": 14.241,
              "y": 26.614,
              "z": 1.361
            },
            "rightCorner": {
              "x": 14.161,
              "y": 26.62,
              "z": 1.361
            },
            "gtin": "8008698040126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2025f",
            "leftCorner": {
              "x": 14.161,
              "y": 26.618,
              "z": 1.361
            },
            "rightCorner": {
              "x": 14.054,
              "y": 26.625,
              "z": 1.361
            },
            "gtin": "8008698012819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20260",
            "leftCorner": {
              "x": 14.054,
              "y": 26.627,
              "z": 1.361
            },
            "rightCorner": {
              "x": 13.903,
              "y": 26.636,
              "z": 1.361
            },
            "gtin": "8032755325345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20261",
            "leftCorner": {
              "x": 13.903,
              "y": 26.636,
              "z": 1.361
            },
            "rightCorner": {
              "x": 13.751,
              "y": 26.646,
              "z": 1.361
            },
            "gtin": "8032755325345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20262",
            "leftCorner": {
              "x": 13.751,
              "y": 26.642,
              "z": 1.361
            },
            "rightCorner": {
              "x": 13.61,
              "y": 26.651,
              "z": 1.361
            },
            "gtin": "8032755325338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20263",
            "leftCorner": {
              "x": 13.61,
              "y": 26.651,
              "z": 1.361
            },
            "rightCorner": {
              "x": 13.469,
              "y": 26.66,
              "z": 1.361
            },
            "gtin": "8032755325338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20264",
            "leftCorner": {
              "x": 13.469,
              "y": 26.658,
              "z": 1.361
            },
            "rightCorner": {
              "x": 13.304,
              "y": 26.669,
              "z": 1.361
            },
            "gtin": "4001518116517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20265",
            "leftCorner": {
              "x": 13.304,
              "y": 26.669,
              "z": 1.361
            },
            "rightCorner": {
              "x": 13.139,
              "y": 26.679,
              "z": 1.361
            },
            "gtin": "4001518116517",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41a97",
    "rightNeighborShelfId": "41a99"
  },
  {
    "id": "41a99",
    "name": "41a99",
    "x": 13.259,
    "y": 26.729,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99948,
      "w": 0.032248
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 35
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546895",
        "height": 0.1572,
        "facings": [
          {
            "id": "68300c895ed67a01d9a202a5",
            "leftCorner": {
              "x": 13.202,
              "y": 26.678,
              "z": 0.129
            },
            "rightCorner": {
              "x": 13.071,
              "y": 26.686,
              "z": 0.129
            },
            "gtin": "4001518117316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202a6",
            "leftCorner": {
              "x": 13.071,
              "y": 26.686,
              "z": 0.129
            },
            "rightCorner": {
              "x": 12.94,
              "y": 26.695,
              "z": 0.129
            },
            "gtin": "4001518117316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202a7",
            "leftCorner": {
              "x": 12.94,
              "y": 26.695,
              "z": 0.129
            },
            "rightCorner": {
              "x": 12.81,
              "y": 26.703,
              "z": 0.129
            },
            "gtin": "4001518117316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202a8",
            "leftCorner": {
              "x": 12.808,
              "y": 26.695,
              "z": 0.129
            },
            "rightCorner": {
              "x": 12.637,
              "y": 26.707,
              "z": 0.129
            },
            "gtin": "4337185467158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202a9",
            "leftCorner": {
              "x": 12.637,
              "y": 26.707,
              "z": 0.129
            },
            "rightCorner": {
              "x": 12.464,
              "y": 26.718,
              "z": 0.129
            },
            "gtin": "4337185467158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202aa",
            "leftCorner": {
              "x": 12.464,
              "y": 26.718,
              "z": 0.129
            },
            "rightCorner": {
              "x": 12.291,
              "y": 26.729,
              "z": 0.129
            },
            "gtin": "4337185467158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202ab",
            "leftCorner": {
              "x": 12.293,
              "y": 26.736,
              "z": 0.129
            },
            "rightCorner": {
              "x": 12.187,
              "y": 26.743,
              "z": 0.129
            },
            "gtin": "4001518116623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202ac",
            "leftCorner": {
              "x": 12.187,
              "y": 26.744,
              "z": 0.129
            },
            "rightCorner": {
              "x": 12.113,
              "y": 26.749,
              "z": 0.129
            },
            "gtin": "4001518722930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202ad",
            "leftCorner": {
              "x": 12.113,
              "y": 26.749,
              "z": 0.129
            },
            "rightCorner": {
              "x": 12.04,
              "y": 26.754,
              "z": 0.129
            },
            "gtin": "4001518722930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202ae",
            "leftCorner": {
              "x": 12.04,
              "y": 26.754,
              "z": 0.129
            },
            "rightCorner": {
              "x": 11.967,
              "y": 26.758,
              "z": 0.129
            },
            "gtin": "4001518722930",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546893",
        "height": 0.65851,
        "facings": [
          {
            "id": "68300c895ed67a01d9a201c6",
            "leftCorner": {
              "x": 13.187,
              "y": 26.682,
              "z": 0.539
            },
            "rightCorner": {
              "x": 13.113,
              "y": 26.687,
              "z": 0.539
            },
            "gtin": "4009176515253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201c7",
            "leftCorner": {
              "x": 13.113,
              "y": 26.687,
              "z": 0.539
            },
            "rightCorner": {
              "x": 13.038,
              "y": 26.692,
              "z": 0.539
            },
            "gtin": "4009176515253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201c8",
            "leftCorner": {
              "x": 13.039,
              "y": 26.698,
              "z": 0.539
            },
            "rightCorner": {
              "x": 12.813,
              "y": 26.712,
              "z": 0.539
            },
            "gtin": "4009176339774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201c9",
            "leftCorner": {
              "x": 12.812,
              "y": 26.698,
              "z": 0.539
            },
            "rightCorner": {
              "x": 12.417,
              "y": 26.724,
              "z": 0.539
            },
            "gtin": "4063367400711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201ca",
            "leftCorner": {
              "x": 12.417,
              "y": 26.724,
              "z": 0.539
            },
            "rightCorner": {
              "x": 12.023,
              "y": 26.749,
              "z": 0.539
            },
            "gtin": "4063367400711",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546892",
        "height": 1.0118,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20187",
            "leftCorner": {
              "x": 13.274,
              "y": 26.681,
              "z": 0.828
            },
            "rightCorner": {
              "x": 13.047,
              "y": 26.696,
              "z": 0.828
            },
            "gtin": "8717185470345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20188",
            "leftCorner": {
              "x": 13.047,
              "y": 26.696,
              "z": 0.828
            },
            "rightCorner": {
              "x": 12.819,
              "y": 26.711,
              "z": 0.828
            },
            "gtin": "8717185470345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20189",
            "leftCorner": {
              "x": 12.818,
              "y": 26.701,
              "z": 0.828
            },
            "rightCorner": {
              "x": 12.664,
              "y": 26.711,
              "z": 0.828
            },
            "gtin": "4001518117231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2018a",
            "leftCorner": {
              "x": 12.664,
              "y": 26.726,
              "z": 0.828
            },
            "rightCorner": {
              "x": 12.608,
              "y": 26.729,
              "z": 0.828
            },
            "gtin": "4001518117255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2018b",
            "leftCorner": {
              "x": 12.608,
              "y": 26.729,
              "z": 0.828
            },
            "rightCorner": {
              "x": 12.553,
              "y": 26.733,
              "z": 0.828
            },
            "gtin": "4001518117255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2018c",
            "leftCorner": {
              "x": 12.553,
              "y": 26.733,
              "z": 0.828
            },
            "rightCorner": {
              "x": 12.497,
              "y": 26.736,
              "z": 0.828
            },
            "gtin": "4001518117255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2018d",
            "leftCorner": {
              "x": 12.497,
              "y": 26.736,
              "z": 0.828
            },
            "rightCorner": {
              "x": 12.441,
              "y": 26.741,
              "z": 0.828
            },
            "gtin": "4001518117255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2018e",
            "leftCorner": {
              "x": 12.441,
              "y": 26.734,
              "z": 0.828
            },
            "rightCorner": {
              "x": 12.246,
              "y": 26.745,
              "z": 0.828
            },
            "gtin": "4001518117217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2018f",
            "leftCorner": {
              "x": 12.246,
              "y": 26.745,
              "z": 0.828
            },
            "rightCorner": {
              "x": 12.051,
              "y": 26.758,
              "z": 0.828
            },
            "gtin": "4001518117217",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546896",
        "height": 1.3647,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20212",
            "leftCorner": {
              "x": 13.069,
              "y": 26.687,
              "z": 1.117
            },
            "rightCorner": {
              "x": 12.374,
              "y": 26.731,
              "z": 1.117
            },
            "gtin": "8000500269169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20213",
            "leftCorner": {
              "x": 12.374,
              "y": 26.73,
              "z": 1.117
            },
            "rightCorner": {
              "x": 12.264,
              "y": 26.738,
              "z": 1.117
            },
            "gtin": "8000500227848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20214",
            "leftCorner": {
              "x": 12.264,
              "y": 26.738,
              "z": 1.117
            },
            "rightCorner": {
              "x": 12.154,
              "y": 26.745,
              "z": 1.117
            },
            "gtin": "8000500227848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20215",
            "leftCorner": {
              "x": 12.154,
              "y": 26.745,
              "z": 1.117
            },
            "rightCorner": {
              "x": 12.044,
              "y": 26.752,
              "z": 1.117
            },
            "gtin": "8000500227848",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546894",
        "height": 1.6632,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20266",
            "leftCorner": {
              "x": 13.14,
              "y": 26.686,
              "z": 1.361
            },
            "rightCorner": {
              "x": 13.04,
              "y": 26.692,
              "z": 1.361
            },
            "gtin": "8000500391228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20267",
            "leftCorner": {
              "x": 13.04,
              "y": 26.692,
              "z": 1.361
            },
            "rightCorner": {
              "x": 12.941,
              "y": 26.699,
              "z": 1.361
            },
            "gtin": "8000500391228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20268",
            "leftCorner": {
              "x": 12.941,
              "y": 26.701,
              "z": 1.361
            },
            "rightCorner": {
              "x": 12.765,
              "y": 26.713,
              "z": 1.361
            },
            "gtin": "8000500426449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20269",
            "leftCorner": {
              "x": 12.765,
              "y": 26.713,
              "z": 1.361
            },
            "rightCorner": {
              "x": 12.589,
              "y": 26.724,
              "z": 1.361
            },
            "gtin": "8000500426449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2026a",
            "leftCorner": {
              "x": 12.589,
              "y": 26.727,
              "z": 1.361
            },
            "rightCorner": {
              "x": 12.339,
              "y": 26.744,
              "z": 1.361
            },
            "gtin": "8000500310427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2026b",
            "leftCorner": {
              "x": 12.339,
              "y": 26.744,
              "z": 1.361
            },
            "rightCorner": {
              "x": 12.089,
              "y": 26.76,
              "z": 1.361
            },
            "gtin": "8000500310427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2026c",
            "leftCorner": {
              "x": 12.089,
              "y": 26.76,
              "z": 1.361
            },
            "rightCorner": {
              "x": 11.84,
              "y": 26.776,
              "z": 1.361
            },
            "gtin": "8000500310427",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41a98",
    "rightNeighborShelfId": "41a9a"
  },
  {
    "id": "41a9a",
    "name": "41a9a",
    "x": 12.061,
    "y": 26.806,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99948,
      "w": 0.032248
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 44
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546899",
        "height": 0.1513,
        "facings": [
          {
            "id": "68300c895ed67a01d9a202af",
            "leftCorner": {
              "x": 11.966,
              "y": 26.757,
              "z": 0.124
            },
            "rightCorner": {
              "x": 11.859,
              "y": 26.764,
              "z": 0.124
            },
            "gtin": "4001518703007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202b0",
            "leftCorner": {
              "x": 11.859,
              "y": 26.764,
              "z": 0.124
            },
            "rightCorner": {
              "x": 11.751,
              "y": 26.771,
              "z": 0.124
            },
            "gtin": "4001518703007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202b1",
            "leftCorner": {
              "x": 11.751,
              "y": 26.771,
              "z": 0.124
            },
            "rightCorner": {
              "x": 11.645,
              "y": 26.778,
              "z": 0.124
            },
            "gtin": "4001518703007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202b2",
            "leftCorner": {
              "x": 11.645,
              "y": 26.778,
              "z": 0.124
            },
            "rightCorner": {
              "x": 11.521,
              "y": 26.786,
              "z": 0.124
            },
            "gtin": "4001518103487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202b3",
            "leftCorner": {
              "x": 11.521,
              "y": 26.786,
              "z": 0.124
            },
            "rightCorner": {
              "x": 11.397,
              "y": 26.795,
              "z": 0.124
            },
            "gtin": "4001518103487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202b4",
            "leftCorner": {
              "x": 11.399,
              "y": 26.808,
              "z": 0.124
            },
            "rightCorner": {
              "x": 11.2,
              "y": 26.821,
              "z": 0.124
            },
            "gtin": "4001518115817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202b5",
            "leftCorner": {
              "x": 11.2,
              "y": 26.821,
              "z": 0.124
            },
            "rightCorner": {
              "x": 11.001,
              "y": 26.834,
              "z": 0.124
            },
            "gtin": "4001518115817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202b6",
            "leftCorner": {
              "x": 11.001,
              "y": 26.827,
              "z": 0.124
            },
            "rightCorner": {
              "x": 10.858,
              "y": 26.836,
              "z": 0.124
            },
            "gtin": "4001518115817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202b7",
            "leftCorner": {
              "x": 10.858,
              "y": 26.836,
              "z": 0.124
            },
            "rightCorner": {
              "x": 10.715,
              "y": 26.845,
              "z": 0.124
            },
            "gtin": "4001518115817",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546898",
        "height": 0.65459,
        "facings": [
          {
            "id": "68300c895ed67a01d9a201cb",
            "leftCorner": {
              "x": 12.022,
              "y": 26.751,
              "z": 0.536
            },
            "rightCorner": {
              "x": 11.86,
              "y": 26.762,
              "z": 0.536
            },
            "gtin": "4017100297618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201cc",
            "leftCorner": {
              "x": 11.86,
              "y": 26.763,
              "z": 0.536
            },
            "rightCorner": {
              "x": 11.752,
              "y": 26.769,
              "z": 0.536
            },
            "gtin": "4017100298905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201cd",
            "leftCorner": {
              "x": 11.752,
              "y": 26.769,
              "z": 0.536
            },
            "rightCorner": {
              "x": 11.645,
              "y": 26.776,
              "z": 0.536
            },
            "gtin": "4017100298905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201ce",
            "leftCorner": {
              "x": 11.645,
              "y": 26.776,
              "z": 0.536
            },
            "rightCorner": {
              "x": 11.536,
              "y": 26.783,
              "z": 0.536
            },
            "gtin": "4017100298905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201cf",
            "leftCorner": {
              "x": 11.536,
              "y": 26.783,
              "z": 0.536
            },
            "rightCorner": {
              "x": 11.428,
              "y": 26.791,
              "z": 0.536
            },
            "gtin": "4017100298905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201d0",
            "leftCorner": {
              "x": 11.428,
              "y": 26.789,
              "z": 0.536
            },
            "rightCorner": {
              "x": 11.125,
              "y": 26.808,
              "z": 0.536
            },
            "gtin": "4063367286346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201d1",
            "leftCorner": {
              "x": 11.125,
              "y": 26.808,
              "z": 0.536
            },
            "rightCorner": {
              "x": 10.822,
              "y": 26.828,
              "z": 0.536
            },
            "gtin": "4063367286346",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54689a",
        "height": 1.0079,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20190",
            "leftCorner": {
              "x": 12.052,
              "y": 26.784,
              "z": 0.825
            },
            "rightCorner": {
              "x": 11.997,
              "y": 26.787,
              "z": 0.825
            },
            "gtin": "7622210137234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20191",
            "leftCorner": {
              "x": 11.997,
              "y": 26.787,
              "z": 0.825
            },
            "rightCorner": {
              "x": 11.942,
              "y": 26.792,
              "z": 0.825
            },
            "gtin": "7622210137234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20192",
            "leftCorner": {
              "x": 11.942,
              "y": 26.792,
              "z": 0.825
            },
            "rightCorner": {
              "x": 11.887,
              "y": 26.795,
              "z": 0.825
            },
            "gtin": "7622210137234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20193",
            "leftCorner": {
              "x": 11.885,
              "y": 26.77,
              "z": 0.825
            },
            "rightCorner": {
              "x": 11.653,
              "y": 26.785,
              "z": 0.825
            },
            "gtin": "8410000810004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20194",
            "leftCorner": {
              "x": 11.653,
              "y": 26.785,
              "z": 0.825
            },
            "rightCorner": {
              "x": 11.42,
              "y": 26.8,
              "z": 0.825
            },
            "gtin": "8410000810004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20195",
            "leftCorner": {
              "x": 11.42,
              "y": 26.8,
              "z": 0.825
            },
            "rightCorner": {
              "x": 11.188,
              "y": 26.815,
              "z": 0.825
            },
            "gtin": "8410000810004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20196",
            "leftCorner": {
              "x": 11.188,
              "y": 26.817,
              "z": 0.825
            },
            "rightCorner": {
              "x": 11.069,
              "y": 26.825,
              "z": 0.825
            },
            "gtin": "7622210755506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20197",
            "leftCorner": {
              "x": 11.069,
              "y": 26.825,
              "z": 0.825
            },
            "rightCorner": {
              "x": 10.951,
              "y": 26.832,
              "z": 0.825
            },
            "gtin": "7622210755506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20198",
            "leftCorner": {
              "x": 10.951,
              "y": 26.832,
              "z": 0.825
            },
            "rightCorner": {
              "x": 10.832,
              "y": 26.84,
              "z": 0.825
            },
            "gtin": "7622210755506",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546897",
        "height": 1.3616,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20216",
            "leftCorner": {
              "x": 12.043,
              "y": 26.753,
              "z": 1.114
            },
            "rightCorner": {
              "x": 11.929,
              "y": 26.76,
              "z": 1.114
            },
            "gtin": "7622300489427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20217",
            "leftCorner": {
              "x": 11.929,
              "y": 26.76,
              "z": 1.114
            },
            "rightCorner": {
              "x": 11.815,
              "y": 26.768,
              "z": 1.114
            },
            "gtin": "7622300489427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20218",
            "leftCorner": {
              "x": 11.815,
              "y": 26.768,
              "z": 1.114
            },
            "rightCorner": {
              "x": 11.702,
              "y": 26.775,
              "z": 1.114
            },
            "gtin": "7622300489427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20219",
            "leftCorner": {
              "x": 11.704,
              "y": 26.811,
              "z": 1.114
            },
            "rightCorner": {
              "x": 11.582,
              "y": 26.819,
              "z": 1.114
            },
            "gtin": "7622201391270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2021a",
            "leftCorner": {
              "x": 11.582,
              "y": 26.819,
              "z": 1.114
            },
            "rightCorner": {
              "x": 11.46,
              "y": 26.826,
              "z": 1.114
            },
            "gtin": "7622201391270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2021b",
            "leftCorner": {
              "x": 11.458,
              "y": 26.803,
              "z": 1.114
            },
            "rightCorner": {
              "x": 11.281,
              "y": 26.814,
              "z": 1.114
            },
            "gtin": "7622300336738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2021c",
            "leftCorner": {
              "x": 11.281,
              "y": 26.819,
              "z": 1.114
            },
            "rightCorner": {
              "x": 11.02,
              "y": 26.837,
              "z": 1.114
            },
            "gtin": "7622210977434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2021d",
            "leftCorner": {
              "x": 11.019,
              "y": 26.828,
              "z": 1.114
            },
            "rightCorner": {
              "x": 10.938,
              "y": 26.833,
              "z": 1.114
            },
            "gtin": "7622210137258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2021e",
            "leftCorner": {
              "x": 10.938,
              "y": 26.833,
              "z": 1.114
            },
            "rightCorner": {
              "x": 10.856,
              "y": 26.838,
              "z": 1.114
            },
            "gtin": "7622210137258",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54689b",
        "height": 1.6605,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2026d",
            "leftCorner": {
              "x": 11.838,
              "y": 26.762,
              "z": 1.359
            },
            "rightCorner": {
              "x": 11.78,
              "y": 26.766,
              "z": 1.359
            },
            "gtin": "7622300476144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2026e",
            "leftCorner": {
              "x": 11.78,
              "y": 26.766,
              "z": 1.359
            },
            "rightCorner": {
              "x": 11.723,
              "y": 26.769,
              "z": 1.359
            },
            "gtin": "7622300476144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2026f",
            "leftCorner": {
              "x": 11.723,
              "y": 26.769,
              "z": 1.359
            },
            "rightCorner": {
              "x": 11.666,
              "y": 26.773,
              "z": 1.359
            },
            "gtin": "7622300476144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20270",
            "leftCorner": {
              "x": 11.667,
              "y": 26.788,
              "z": 1.359
            },
            "rightCorner": {
              "x": 11.471,
              "y": 26.801,
              "z": 1.359
            },
            "gtin": "7622300476175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20271",
            "leftCorner": {
              "x": 11.471,
              "y": 26.795,
              "z": 1.359
            },
            "rightCorner": {
              "x": 11.375,
              "y": 26.801,
              "z": 1.359
            },
            "gtin": "7622300479008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20272",
            "leftCorner": {
              "x": 11.375,
              "y": 26.801,
              "z": 1.359
            },
            "rightCorner": {
              "x": 11.279,
              "y": 26.807,
              "z": 1.359
            },
            "gtin": "7622300479008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20273",
            "leftCorner": {
              "x": 11.279,
              "y": 26.802,
              "z": 1.359
            },
            "rightCorner": {
              "x": 11.131,
              "y": 26.811,
              "z": 1.359
            },
            "gtin": "7622201774998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20274",
            "leftCorner": {
              "x": 11.131,
              "y": 26.811,
              "z": 1.359
            },
            "rightCorner": {
              "x": 10.983,
              "y": 26.821,
              "z": 1.359
            },
            "gtin": "7622201774998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20275",
            "leftCorner": {
              "x": 10.985,
              "y": 26.842,
              "z": 1.359
            },
            "rightCorner": {
              "x": 10.889,
              "y": 26.849,
              "z": 1.359
            },
            "gtin": "7622201425050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20276",
            "leftCorner": {
              "x": 10.889,
              "y": 26.849,
              "z": 1.359
            },
            "rightCorner": {
              "x": 10.794,
              "y": 26.854,
              "z": 1.359
            },
            "gtin": "7622201425050",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41a99",
    "rightNeighborShelfId": "41a9b"
  },
  {
    "id": "41a9b",
    "name": "41a9b",
    "x": 10.864,
    "y": 26.884,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99948,
      "w": 0.032248
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 31
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5468a0",
        "height": 0.14881,
        "facings": [
          {
            "id": "68300c895ed67a01d9a202b8",
            "leftCorner": {
              "x": 10.709,
              "y": 26.844,
              "z": 0.122
            },
            "rightCorner": {
              "x": 10.094,
              "y": 26.883,
              "z": 0.122
            },
            "gtin": "7622300356767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202b9",
            "leftCorner": {
              "x": 10.095,
              "y": 26.89,
              "z": 0.122
            },
            "rightCorner": {
              "x": 9.961,
              "y": 26.898,
              "z": 0.122
            },
            "gtin": "7622300503079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202ba",
            "leftCorner": {
              "x": 9.961,
              "y": 26.887,
              "z": 0.122
            },
            "rightCorner": {
              "x": 9.56,
              "y": 26.914,
              "z": 0.122
            },
            "gtin": "4017100131004",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54689e",
        "height": 0.64896,
        "facings": [
          {
            "id": "68300c895ed67a01d9a201d2",
            "leftCorner": {
              "x": 10.821,
              "y": 26.84,
              "z": 0.531
            },
            "rightCorner": {
              "x": 10.592,
              "y": 26.855,
              "z": 0.531
            },
            "gtin": "4337185580024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201d3",
            "leftCorner": {
              "x": 10.591,
              "y": 26.846,
              "z": 0.531
            },
            "rightCorner": {
              "x": 10.502,
              "y": 26.852,
              "z": 0.531
            },
            "gtin": "7622210100917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201d4",
            "leftCorner": {
              "x": 10.502,
              "y": 26.852,
              "z": 0.531
            },
            "rightCorner": {
              "x": 10.412,
              "y": 26.858,
              "z": 0.531
            },
            "gtin": "7622210100917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201d5",
            "leftCorner": {
              "x": 10.412,
              "y": 26.857,
              "z": 0.531
            },
            "rightCorner": {
              "x": 10.136,
              "y": 26.875,
              "z": 0.531
            },
            "gtin": "4017100165009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201d6",
            "leftCorner": {
              "x": 10.136,
              "y": 26.874,
              "z": 0.531
            },
            "rightCorner": {
              "x": 9.881,
              "y": 26.89,
              "z": 0.531
            },
            "gtin": "4017100376108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2019d",
            "leftCorner": {
              "x": 9.881,
              "y": 26.891,
              "z": 0.531
            },
            "rightCorner": {
              "x": 9.747,
              "y": 26.899,
              "z": 0.531
            },
            "gtin": "4017100179006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2019e",
            "leftCorner": {
              "x": 9.747,
              "y": 26.899,
              "z": 0.531
            },
            "rightCorner": {
              "x": 9.613,
              "y": 26.908,
              "z": 0.531
            },
            "gtin": "4017100179006",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54689d",
        "height": 1.0052,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20199",
            "leftCorner": {
              "x": 10.832,
              "y": 26.848,
              "z": 0.822
            },
            "rightCorner": {
              "x": 10.641,
              "y": 26.861,
              "z": 0.822
            },
            "gtin": "7622201148676",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c895ed67a01d9a2019a",
            "leftCorner": {
              "x": 10.642,
              "y": 26.866,
              "z": 0.822
            },
            "rightCorner": {
              "x": 10.4,
              "y": 26.881,
              "z": 0.822
            },
            "gtin": "7622210984678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2019b",
            "leftCorner": {
              "x": 10.398,
              "y": 26.852,
              "z": 0.822
            },
            "rightCorner": {
              "x": 10.12,
              "y": 26.87,
              "z": 0.822
            },
            "gtin": "4017100219900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20156",
            "leftCorner": {
              "x": 10.12,
              "y": 26.874,
              "z": 0.822
            },
            "rightCorner": {
              "x": 9.866,
              "y": 26.89,
              "z": 0.822
            },
            "gtin": "4017100218712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20157",
            "leftCorner": {
              "x": 9.866,
              "y": 26.89,
              "z": 0.822
            },
            "rightCorner": {
              "x": 9.613,
              "y": 26.907,
              "z": 0.822
            },
            "gtin": "4017100218712",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54689c",
        "height": 1.3577,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2021f",
            "leftCorner": {
              "x": 10.857,
              "y": 26.837,
              "z": 1.111
            },
            "rightCorner": {
              "x": 10.72,
              "y": 26.846,
              "z": 1.111
            },
            "gtin": "7622201135836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20220",
            "leftCorner": {
              "x": 10.72,
              "y": 26.84,
              "z": 1.111
            },
            "rightCorner": {
              "x": 10.651,
              "y": 26.844,
              "z": 1.111
            },
            "gtin": "7622201823733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20221",
            "leftCorner": {
              "x": 10.651,
              "y": 26.844,
              "z": 1.111
            },
            "rightCorner": {
              "x": 10.582,
              "y": 26.849,
              "z": 1.111
            },
            "gtin": "7622201823733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20222",
            "leftCorner": {
              "x": 10.583,
              "y": 26.867,
              "z": 1.111
            },
            "rightCorner": {
              "x": 10.347,
              "y": 26.882,
              "z": 1.111
            },
            "gtin": "4017100211003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20223",
            "leftCorner": {
              "x": 10.347,
              "y": 26.882,
              "z": 1.111
            },
            "rightCorner": {
              "x": 10.111,
              "y": 26.898,
              "z": 1.111
            },
            "gtin": "4017100211003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20224",
            "leftCorner": {
              "x": 10.11,
              "y": 26.882,
              "z": 1.111
            },
            "rightCorner": {
              "x": 9.982,
              "y": 26.89,
              "z": 1.111
            },
            "gtin": "4017100264900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20225",
            "leftCorner": {
              "x": 9.982,
              "y": 26.89,
              "z": 1.111
            },
            "rightCorner": {
              "x": 9.853,
              "y": 26.898,
              "z": 1.111
            },
            "gtin": "4017100264900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201db",
            "leftCorner": {
              "x": 9.853,
              "y": 26.902,
              "z": 1.111
            },
            "rightCorner": {
              "x": 9.733,
              "y": 26.909,
              "z": 1.111
            },
            "gtin": "4017100211119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201dc",
            "leftCorner": {
              "x": 9.733,
              "y": 26.909,
              "z": 1.111
            },
            "rightCorner": {
              "x": 9.614,
              "y": 26.917,
              "z": 1.111
            },
            "gtin": "4017100211119",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54689f",
        "height": 1.6557,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20277",
            "leftCorner": {
              "x": 10.792,
              "y": 26.85,
              "z": 1.355
            },
            "rightCorner": {
              "x": 10.64,
              "y": 26.86,
              "z": 1.355
            },
            "gtin": "4004363110341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20278",
            "leftCorner": {
              "x": 10.64,
              "y": 26.86,
              "z": 1.355
            },
            "rightCorner": {
              "x": 10.488,
              "y": 26.87,
              "z": 1.355
            },
            "gtin": "4004363110341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20279",
            "leftCorner": {
              "x": 10.488,
              "y": 26.87,
              "z": 1.355
            },
            "rightCorner": {
              "x": 10.336,
              "y": 26.88,
              "z": 1.355
            },
            "gtin": "4004363110341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2027a",
            "leftCorner": {
              "x": 10.335,
              "y": 26.865,
              "z": 1.355
            },
            "rightCorner": {
              "x": 10.219,
              "y": 26.872,
              "z": 1.355
            },
            "gtin": "4009176342798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2027b",
            "leftCorner": {
              "x": 10.219,
              "y": 26.872,
              "z": 1.355
            },
            "rightCorner": {
              "x": 10.103,
              "y": 26.88,
              "z": 1.355
            },
            "gtin": "4009176342798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2027c",
            "leftCorner": {
              "x": 10.103,
              "y": 26.882,
              "z": 1.355
            },
            "rightCorner": {
              "x": 9.882,
              "y": 26.896,
              "z": 1.355
            },
            "gtin": "4017100193927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2027d",
            "leftCorner": {
              "x": 9.883,
              "y": 26.904,
              "z": 1.355
            },
            "rightCorner": {
              "x": 9.716,
              "y": 26.914,
              "z": 1.355
            },
            "gtin": "4017100241215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2027e",
            "leftCorner": {
              "x": 9.716,
              "y": 26.914,
              "z": 1.355
            },
            "rightCorner": {
              "x": 9.548,
              "y": 26.925,
              "z": 1.355
            },
            "gtin": "4017100241215",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41a9a",
    "rightNeighborShelfId": "41a9c"
  },
  {
    "id": "41a9c",
    "name": "41a9c",
    "x": 9.611,
    "y": 26.962,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99932,
      "w": 0.036897
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 38
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5468a6",
        "height": 0.1423,
        "facings": [
          {
            "id": "68300c895ed67a01d9a202bb",
            "leftCorner": {
              "x": 9.554,
              "y": 26.91,
              "z": 0.116
            },
            "rightCorner": {
              "x": 9.409,
              "y": 26.921,
              "z": 0.116
            },
            "gtin": "4017100110818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202bc",
            "leftCorner": {
              "x": 9.409,
              "y": 26.921,
              "z": 0.116
            },
            "rightCorner": {
              "x": 9.265,
              "y": 26.932,
              "z": 0.116
            },
            "gtin": "4017100110818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202bd",
            "leftCorner": {
              "x": 9.264,
              "y": 26.927,
              "z": 0.116
            },
            "rightCorner": {
              "x": 8.964,
              "y": 26.949,
              "z": 0.116
            },
            "gtin": "4017100115516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202be",
            "leftCorner": {
              "x": 8.964,
              "y": 26.943,
              "z": 0.116
            },
            "rightCorner": {
              "x": 8.562,
              "y": 26.973,
              "z": 0.116
            },
            "gtin": "4017100114717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20287",
            "leftCorner": {
              "x": 8.562,
              "y": 26.979,
              "z": 0.116
            },
            "rightCorner": {
              "x": 8.36,
              "y": 26.994,
              "z": 0.116
            },
            "gtin": "4017100121418",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468a3",
        "height": 0.49099,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2136f",
            "leftCorner": {
              "x": 9.609,
              "y": 26.938,
              "z": 0.402
            },
            "rightCorner": {
              "x": 8.971,
              "y": 26.985,
              "z": 0.402
            },
            "gtin": "4017100370007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21372",
            "leftCorner": {
              "x": 8.968,
              "y": 26.945,
              "z": 0.402
            },
            "rightCorner": {
              "x": 8.866,
              "y": 26.953,
              "z": 0.402
            },
            "gtin": "4017100362026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21373",
            "leftCorner": {
              "x": 8.866,
              "y": 26.953,
              "z": 0.402
            },
            "rightCorner": {
              "x": 8.764,
              "y": 26.96,
              "z": 0.402
            },
            "gtin": "4017100362026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21374",
            "leftCorner": {
              "x": 8.764,
              "y": 26.96,
              "z": 0.402
            },
            "rightCorner": {
              "x": 8.661,
              "y": 26.968,
              "z": 0.402
            },
            "gtin": "4017100362026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21375",
            "leftCorner": {
              "x": 8.661,
              "y": 26.968,
              "z": 0.402
            },
            "rightCorner": {
              "x": 8.559,
              "y": 26.975,
              "z": 0.402
            },
            "gtin": "4017100362026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21370",
            "leftCorner": {
              "x": 8.558,
              "y": 26.967,
              "z": 0.402
            },
            "rightCorner": {
              "x": 8.459,
              "y": 26.974,
              "z": 0.402
            },
            "gtin": "4017100360015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21371",
            "leftCorner": {
              "x": 8.459,
              "y": 26.974,
              "z": 0.402
            },
            "rightCorner": {
              "x": 8.359,
              "y": 26.982,
              "z": 0.402
            },
            "gtin": "4017100360015",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468a4",
        "height": 0.84654,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21376",
            "leftCorner": {
              "x": 9.61,
              "y": 26.952,
              "z": 0.693
            },
            "rightCorner": {
              "x": 9.456,
              "y": 26.964,
              "z": 0.693
            },
            "gtin": "4017100146015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21377",
            "leftCorner": {
              "x": 9.456,
              "y": 26.964,
              "z": 0.693
            },
            "rightCorner": {
              "x": 9.302,
              "y": 26.975,
              "z": 0.693
            },
            "gtin": "4017100146015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2137a",
            "leftCorner": {
              "x": 9.299,
              "y": 26.936,
              "z": 0.693
            },
            "rightCorner": {
              "x": 9.19,
              "y": 26.944,
              "z": 0.693
            },
            "gtin": "4017100138126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2137b",
            "leftCorner": {
              "x": 9.19,
              "y": 26.944,
              "z": 0.693
            },
            "rightCorner": {
              "x": 9.082,
              "y": 26.952,
              "z": 0.693
            },
            "gtin": "4017100138126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2137c",
            "leftCorner": {
              "x": 9.082,
              "y": 26.952,
              "z": 0.693
            },
            "rightCorner": {
              "x": 8.973,
              "y": 26.96,
              "z": 0.693
            },
            "gtin": "4017100138126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2137d",
            "leftCorner": {
              "x": 8.972,
              "y": 26.947,
              "z": 0.693
            },
            "rightCorner": {
              "x": 8.827,
              "y": 26.958,
              "z": 0.693
            },
            "gtin": "4017100124211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2137e",
            "leftCorner": {
              "x": 8.827,
              "y": 26.958,
              "z": 0.693
            },
            "rightCorner": {
              "x": 8.682,
              "y": 26.969,
              "z": 0.693
            },
            "gtin": "4017100124211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21378",
            "leftCorner": {
              "x": 8.683,
              "y": 26.974,
              "z": 0.693
            },
            "rightCorner": {
              "x": 8.521,
              "y": 26.985,
              "z": 0.693
            },
            "gtin": "4017100138010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21379",
            "leftCorner": {
              "x": 8.521,
              "y": 26.985,
              "z": 0.693
            },
            "rightCorner": {
              "x": 8.36,
              "y": 26.997,
              "z": 0.693
            },
            "gtin": "4017100138010",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468a1",
        "height": 1.1507,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21365",
            "leftCorner": {
              "x": 9.598,
              "y": 26.93,
              "z": 0.941
            },
            "rightCorner": {
              "x": 8.98,
              "y": 26.976,
              "z": 0.941
            },
            "gtin": "4017100365416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21366",
            "leftCorner": {
              "x": 8.98,
              "y": 26.976,
              "z": 0.941
            },
            "rightCorner": {
              "x": 8.362,
              "y": 27.022,
              "z": 0.941
            },
            "gtin": "4017100365416",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468a2",
        "height": 1.4003,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21367",
            "leftCorner": {
              "x": 9.611,
              "y": 26.959,
              "z": 1.146
            },
            "rightCorner": {
              "x": 9.406,
              "y": 26.974,
              "z": 1.146
            },
            "gtin": "4017100101007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21368",
            "leftCorner": {
              "x": 9.406,
              "y": 26.974,
              "z": 1.146
            },
            "rightCorner": {
              "x": 9.201,
              "y": 26.99,
              "z": 1.146
            },
            "gtin": "4017100101007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2136a",
            "leftCorner": {
              "x": 9.198,
              "y": 26.951,
              "z": 1.146
            },
            "rightCorner": {
              "x": 9.003,
              "y": 26.965,
              "z": 1.146
            },
            "gtin": "4017100225611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2136b",
            "leftCorner": {
              "x": 9.001,
              "y": 26.952,
              "z": 1.146
            },
            "rightCorner": {
              "x": 8.852,
              "y": 26.962,
              "z": 1.146
            },
            "gtin": "4017100206009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2136c",
            "leftCorner": {
              "x": 8.852,
              "y": 26.962,
              "z": 1.146
            },
            "rightCorner": {
              "x": 8.703,
              "y": 26.973,
              "z": 1.146
            },
            "gtin": "4017100206009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2136d",
            "leftCorner": {
              "x": 8.703,
              "y": 26.973,
              "z": 1.146
            },
            "rightCorner": {
              "x": 8.554,
              "y": 26.984,
              "z": 1.146
            },
            "gtin": "4017100206009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2136e",
            "leftCorner": {
              "x": 8.555,
              "y": 26.994,
              "z": 1.146
            },
            "rightCorner": {
              "x": 8.448,
              "y": 27.002,
              "z": 1.146
            },
            "gtin": "4017100143748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21369",
            "leftCorner": {
              "x": 8.448,
              "y": 26.998,
              "z": 1.146
            },
            "rightCorner": {
              "x": 8.361,
              "y": 27.005,
              "z": 1.146
            },
            "gtin": "4017100134012",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468a5",
        "height": 1.6494,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2027f",
            "leftCorner": {
              "x": 9.543,
              "y": 26.934,
              "z": 1.35
            },
            "rightCorner": {
              "x": 9.06,
              "y": 26.97,
              "z": 1.35
            },
            "gtin": "4017100136009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20280",
            "leftCorner": {
              "x": 9.058,
              "y": 26.948,
              "z": 1.35
            },
            "rightCorner": {
              "x": 8.917,
              "y": 26.958,
              "z": 1.35
            },
            "gtin": "4017100287022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20281",
            "leftCorner": {
              "x": 8.917,
              "y": 26.958,
              "z": 1.35
            },
            "rightCorner": {
              "x": 8.775,
              "y": 26.969,
              "z": 1.35
            },
            "gtin": "4017100287022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20282",
            "leftCorner": {
              "x": 8.776,
              "y": 26.982,
              "z": 1.35
            },
            "rightCorner": {
              "x": 8.701,
              "y": 26.987,
              "z": 1.35
            },
            "gtin": "4017100291005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20283",
            "leftCorner": {
              "x": 8.701,
              "y": 26.987,
              "z": 1.35
            },
            "rightCorner": {
              "x": 8.625,
              "y": 26.994,
              "z": 1.35
            },
            "gtin": "4017100291005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20284",
            "leftCorner": {
              "x": 8.625,
              "y": 26.994,
              "z": 1.35
            },
            "rightCorner": {
              "x": 8.549,
              "y": 26.999,
              "z": 1.35
            },
            "gtin": "4017100291005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20229",
            "leftCorner": {
              "x": 8.548,
              "y": 26.984,
              "z": 1.35
            },
            "rightCorner": {
              "x": 8.36,
              "y": 26.999,
              "z": 1.35
            },
            "gtin": "4017100290008",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41a9b"
  },
  {
    "id": "41ab1",
    "name": "41ab1",
    "x": 2.565,
    "y": 15.072,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68756,
      "w": 0.72613
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 63
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463e6",
        "height": 1.0011,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e7f8",
            "leftCorner": {
              "x": 2.529,
              "y": 15.22,
              "z": 0.819
            },
            "rightCorner": {
              "x": 2.535,
              "y": 15.335,
              "z": 0.819
            },
            "gtin": "070177020477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7f9",
            "leftCorner": {
              "x": 2.526,
              "y": 15.336,
              "z": 0.819
            },
            "rightCorner": {
              "x": 2.53,
              "y": 15.413,
              "z": 0.819
            },
            "gtin": "070177087807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7fa",
            "leftCorner": {
              "x": 2.53,
              "y": 15.413,
              "z": 0.819
            },
            "rightCorner": {
              "x": 2.534,
              "y": 15.488,
              "z": 0.819
            },
            "gtin": "070177087807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7fb",
            "leftCorner": {
              "x": 2.54,
              "y": 15.488,
              "z": 0.819
            },
            "rightCorner": {
              "x": 2.545,
              "y": 15.58,
              "z": 0.819
            },
            "gtin": "070177090463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7fc",
            "leftCorner": {
              "x": 2.545,
              "y": 15.58,
              "z": 0.819
            },
            "rightCorner": {
              "x": 2.55,
              "y": 15.671,
              "z": 0.819
            },
            "gtin": "070177090463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7fd",
            "leftCorner": {
              "x": 2.55,
              "y": 15.671,
              "z": 0.819
            },
            "rightCorner": {
              "x": 2.555,
              "y": 15.763,
              "z": 0.819
            },
            "gtin": "070177090463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7fe",
            "leftCorner": {
              "x": 2.551,
              "y": 15.763,
              "z": 0.819
            },
            "rightCorner": {
              "x": 2.557,
              "y": 15.868,
              "z": 0.819
            },
            "gtin": "4008837210063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7ff",
            "leftCorner": {
              "x": 2.557,
              "y": 15.868,
              "z": 0.819
            },
            "rightCorner": {
              "x": 2.563,
              "y": 15.973,
              "z": 0.819
            },
            "gtin": "4008837210063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e800",
            "leftCorner": {
              "x": 2.569,
              "y": 15.972,
              "z": 0.819
            },
            "rightCorner": {
              "x": 2.575,
              "y": 16.094,
              "z": 0.819
            },
            "gtin": "4008837210056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e801",
            "leftCorner": {
              "x": 2.575,
              "y": 16.094,
              "z": 0.819
            },
            "rightCorner": {
              "x": 2.582,
              "y": 16.216,
              "z": 0.819
            },
            "gtin": "4008837210056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e802",
            "leftCorner": {
              "x": 2.582,
              "y": 16.216,
              "z": 0.819
            },
            "rightCorner": {
              "x": 2.589,
              "y": 16.338,
              "z": 0.819
            },
            "gtin": "4008837210056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7f7",
            "leftCorner": {
              "x": 2.523,
              "y": 15.105,
              "z": 0.819
            },
            "rightCorner": {
              "x": 2.529,
              "y": 15.22,
              "z": 0.819
            },
            "gtin": "070177020477",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463e7",
        "height": 1.362,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e86f",
            "leftCorner": {
              "x": 2.519,
              "y": 15.133,
              "z": 1.114
            },
            "rightCorner": {
              "x": 2.522,
              "y": 15.186,
              "z": 1.114
            },
            "gtin": "070177010768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e870",
            "leftCorner": {
              "x": 2.522,
              "y": 15.186,
              "z": 1.114
            },
            "rightCorner": {
              "x": 2.525,
              "y": 15.239,
              "z": 1.114
            },
            "gtin": "070177010768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e871",
            "leftCorner": {
              "x": 2.527,
              "y": 15.238,
              "z": 1.114
            },
            "rightCorner": {
              "x": 2.534,
              "y": 15.351,
              "z": 1.114
            },
            "gtin": "070177010775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e872",
            "leftCorner": {
              "x": 2.534,
              "y": 15.351,
              "z": 1.114
            },
            "rightCorner": {
              "x": 2.54,
              "y": 15.465,
              "z": 1.114
            },
            "gtin": "070177010775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e873",
            "leftCorner": {
              "x": 2.54,
              "y": 15.465,
              "z": 1.114
            },
            "rightCorner": {
              "x": 2.546,
              "y": 15.578,
              "z": 1.114
            },
            "gtin": "070177010775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e874",
            "leftCorner": {
              "x": 2.542,
              "y": 15.578,
              "z": 1.114
            },
            "rightCorner": {
              "x": 2.549,
              "y": 15.715,
              "z": 1.114
            },
            "gtin": "4008837210070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e875",
            "leftCorner": {
              "x": 2.549,
              "y": 15.715,
              "z": 1.114
            },
            "rightCorner": {
              "x": 2.556,
              "y": 15.852,
              "z": 1.114
            },
            "gtin": "4008837210070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e876",
            "leftCorner": {
              "x": 2.556,
              "y": 15.852,
              "z": 1.114
            },
            "rightCorner": {
              "x": 2.564,
              "y": 15.989,
              "z": 1.114
            },
            "gtin": "4008837210070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e877",
            "leftCorner": {
              "x": 2.563,
              "y": 15.989,
              "z": 1.114
            },
            "rightCorner": {
              "x": 2.572,
              "y": 16.155,
              "z": 1.114
            },
            "gtin": "4008837210025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e878",
            "leftCorner": {
              "x": 2.572,
              "y": 16.155,
              "z": 1.114
            },
            "rightCorner": {
              "x": 2.581,
              "y": 16.321,
              "z": 1.114
            },
            "gtin": "4008837210025",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463ea",
        "height": 1.7023,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e7b3",
            "leftCorner": {
              "x": 2.547,
              "y": 15.184,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.553,
              "y": 15.279,
              "z": 1.393
            },
            "gtin": "4008837201054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7b4",
            "leftCorner": {
              "x": 2.553,
              "y": 15.279,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.558,
              "y": 15.373,
              "z": 1.393
            },
            "gtin": "4008837201054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7b5",
            "leftCorner": {
              "x": 2.558,
              "y": 15.373,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.563,
              "y": 15.468,
              "z": 1.393
            },
            "gtin": "4008837201054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7b6",
            "leftCorner": {
              "x": 2.563,
              "y": 15.468,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.568,
              "y": 15.563,
              "z": 1.393
            },
            "gtin": "4008837201054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7b7",
            "leftCorner": {
              "x": 2.548,
              "y": 15.564,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.555,
              "y": 15.682,
              "z": 1.393
            },
            "gtin": "4008837201047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7b8",
            "leftCorner": {
              "x": 2.555,
              "y": 15.682,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.561,
              "y": 15.799,
              "z": 1.393
            },
            "gtin": "4008837201047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7b9",
            "leftCorner": {
              "x": 2.565,
              "y": 15.799,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.569,
              "y": 15.884,
              "z": 1.393
            },
            "gtin": "4008837202082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7ba",
            "leftCorner": {
              "x": 2.569,
              "y": 15.884,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.574,
              "y": 15.969,
              "z": 1.393
            },
            "gtin": "4008837202082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7bb",
            "leftCorner": {
              "x": 2.553,
              "y": 15.97,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.557,
              "y": 16.05,
              "z": 1.393
            },
            "gtin": "4008837203010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7bc",
            "leftCorner": {
              "x": 2.557,
              "y": 16.05,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.561,
              "y": 16.129,
              "z": 1.393
            },
            "gtin": "4008837203010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7bd",
            "leftCorner": {
              "x": 2.585,
              "y": 16.128,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.59,
              "y": 16.224,
              "z": 1.393
            },
            "gtin": "4008837204109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7be",
            "leftCorner": {
              "x": 2.59,
              "y": 16.224,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.595,
              "y": 16.321,
              "z": 1.393
            },
            "gtin": "4008837204109",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463e9",
        "height": 0.15062,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e8b7",
            "leftCorner": {
              "x": 2.512,
              "y": 15.12,
              "z": 0.123
            },
            "rightCorner": {
              "x": 2.518,
              "y": 15.229,
              "z": 0.123
            },
            "gtin": "4337185537127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8b8",
            "leftCorner": {
              "x": 2.516,
              "y": 15.229,
              "z": 0.123
            },
            "rightCorner": {
              "x": 2.523,
              "y": 15.367,
              "z": 0.123
            },
            "gtin": "4001258016658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8b9",
            "leftCorner": {
              "x": 2.523,
              "y": 15.367,
              "z": 0.123
            },
            "rightCorner": {
              "x": 2.531,
              "y": 15.505,
              "z": 0.123
            },
            "gtin": "4001258016658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8ba",
            "leftCorner": {
              "x": 2.531,
              "y": 15.505,
              "z": 0.123
            },
            "rightCorner": {
              "x": 2.536,
              "y": 15.592,
              "z": 0.123
            },
            "gtin": "4001258016696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8bb",
            "leftCorner": {
              "x": 2.536,
              "y": 15.592,
              "z": 0.123
            },
            "rightCorner": {
              "x": 2.54,
              "y": 15.679,
              "z": 0.123
            },
            "gtin": "4001258016696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8bc",
            "leftCorner": {
              "x": 2.547,
              "y": 15.679,
              "z": 0.123
            },
            "rightCorner": {
              "x": 2.551,
              "y": 15.763,
              "z": 0.123
            },
            "gtin": "4001258016672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8bd",
            "leftCorner": {
              "x": 2.551,
              "y": 15.763,
              "z": 0.123
            },
            "rightCorner": {
              "x": 2.556,
              "y": 15.846,
              "z": 0.123
            },
            "gtin": "4001258016672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8be",
            "leftCorner": {
              "x": 2.554,
              "y": 15.846,
              "z": 0.123
            },
            "rightCorner": {
              "x": 2.564,
              "y": 16.032,
              "z": 0.123
            },
            "gtin": "4001258016719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8bf",
            "leftCorner": {
              "x": 2.577,
              "y": 16.031,
              "z": 0.123
            },
            "rightCorner": {
              "x": 2.584,
              "y": 16.156,
              "z": 0.123
            },
            "gtin": "4337185581236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8c0",
            "leftCorner": {
              "x": 2.573,
              "y": 16.156,
              "z": 0.123
            },
            "rightCorner": {
              "x": 2.581,
              "y": 16.302,
              "z": 0.123
            },
            "gtin": "4337185581212",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463e8",
        "height": 0.59783,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e83e",
            "leftCorner": {
              "x": 2.513,
              "y": 15.155,
              "z": 0.489
            },
            "rightCorner": {
              "x": 2.518,
              "y": 15.236,
              "z": 0.489
            },
            "gtin": "4009452002262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e83f",
            "leftCorner": {
              "x": 2.518,
              "y": 15.236,
              "z": 0.489
            },
            "rightCorner": {
              "x": 2.522,
              "y": 15.317,
              "z": 0.489
            },
            "gtin": "4009452002262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e840",
            "leftCorner": {
              "x": 2.52,
              "y": 15.317,
              "z": 0.489
            },
            "rightCorner": {
              "x": 2.522,
              "y": 15.366,
              "z": 0.489
            },
            "gtin": "4337185589980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e841",
            "leftCorner": {
              "x": 2.522,
              "y": 15.366,
              "z": 0.489
            },
            "rightCorner": {
              "x": 2.525,
              "y": 15.415,
              "z": 0.489
            },
            "gtin": "4337185589980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e842",
            "leftCorner": {
              "x": 2.525,
              "y": 15.415,
              "z": 0.489
            },
            "rightCorner": {
              "x": 2.528,
              "y": 15.464,
              "z": 0.489
            },
            "gtin": "4337185589980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e843",
            "leftCorner": {
              "x": 2.53,
              "y": 15.464,
              "z": 0.489
            },
            "rightCorner": {
              "x": 2.532,
              "y": 15.501,
              "z": 0.489
            },
            "gtin": "4337185579233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e844",
            "leftCorner": {
              "x": 2.532,
              "y": 15.501,
              "z": 0.489
            },
            "rightCorner": {
              "x": 2.534,
              "y": 15.538,
              "z": 0.489
            },
            "gtin": "4337185579233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e845",
            "leftCorner": {
              "x": 2.534,
              "y": 15.538,
              "z": 0.489
            },
            "rightCorner": {
              "x": 2.537,
              "y": 15.576,
              "z": 0.489
            },
            "gtin": "4337185579233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e846",
            "leftCorner": {
              "x": 2.537,
              "y": 15.576,
              "z": 0.489
            },
            "rightCorner": {
              "x": 2.539,
              "y": 15.613,
              "z": 0.489
            },
            "gtin": "4337185579233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e847",
            "leftCorner": {
              "x": 2.54,
              "y": 15.613,
              "z": 0.489
            },
            "rightCorner": {
              "x": 2.543,
              "y": 15.66,
              "z": 0.489
            },
            "gtin": "4337185597831",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e848",
            "leftCorner": {
              "x": 2.543,
              "y": 15.66,
              "z": 0.489
            },
            "rightCorner": {
              "x": 2.545,
              "y": 15.706,
              "z": 0.489
            },
            "gtin": "4337185597831",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e849",
            "leftCorner": {
              "x": 2.545,
              "y": 15.706,
              "z": 0.489
            },
            "rightCorner": {
              "x": 2.548,
              "y": 15.753,
              "z": 0.489
            },
            "gtin": "4337185597831",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e84a",
            "leftCorner": {
              "x": 2.548,
              "y": 15.753,
              "z": 0.489
            },
            "rightCorner": {
              "x": 2.55,
              "y": 15.8,
              "z": 0.489
            },
            "gtin": "4337185597831",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e84b",
            "leftCorner": {
              "x": 2.544,
              "y": 15.8,
              "z": 0.489
            },
            "rightCorner": {
              "x": 2.551,
              "y": 15.916,
              "z": 0.489
            },
            "gtin": "4337185706714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e84c",
            "leftCorner": {
              "x": 2.551,
              "y": 15.916,
              "z": 0.489
            },
            "rightCorner": {
              "x": 2.557,
              "y": 16.033,
              "z": 0.489
            },
            "gtin": "4337185706714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e84d",
            "leftCorner": {
              "x": 2.558,
              "y": 16.033,
              "z": 0.489
            },
            "rightCorner": {
              "x": 2.564,
              "y": 16.138,
              "z": 0.489
            },
            "gtin": "4337185537035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e84e",
            "leftCorner": {
              "x": 2.564,
              "y": 16.138,
              "z": 0.489
            },
            "rightCorner": {
              "x": 2.57,
              "y": 16.244,
              "z": 0.489
            },
            "gtin": "4337185537035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e84f",
            "leftCorner": {
              "x": 2.57,
              "y": 16.244,
              "z": 0.489
            },
            "rightCorner": {
              "x": 2.576,
              "y": 16.348,
              "z": 0.489
            },
            "gtin": "4337185537035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e850",
            "leftCorner": {
              "x": 2.576,
              "y": 16.348,
              "z": 0.489
            },
            "rightCorner": {
              "x": 2.581,
              "y": 16.453,
              "z": 0.489
            },
            "gtin": "4337185537035",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "edebf",
    "rightNeighborShelfId": "41ab2"
  },
  {
    "id": "41ab2",
    "name": "41ab2",
    "x": 2.631,
    "y": 16.27,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68756,
      "w": 0.72613
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 36
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463f3",
        "height": 0.15075,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e8c1",
            "leftCorner": {
              "x": 2.572,
              "y": 16.302,
              "z": 0.123
            },
            "rightCorner": {
              "x": 2.582,
              "y": 16.488,
              "z": 0.123
            },
            "gtin": "4337185581199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8c2",
            "leftCorner": {
              "x": 2.599,
              "y": 16.487,
              "z": 0.123
            },
            "rightCorner": {
              "x": 2.608,
              "y": 16.647,
              "z": 0.123
            },
            "gtin": "4002221007482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8c3",
            "leftCorner": {
              "x": 2.595,
              "y": 16.648,
              "z": 0.123
            },
            "rightCorner": {
              "x": 2.603,
              "y": 16.783,
              "z": 0.123
            },
            "gtin": "4016883444028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8c4",
            "leftCorner": {
              "x": 2.602,
              "y": 16.783,
              "z": 0.123
            },
            "rightCorner": {
              "x": 2.609,
              "y": 16.905,
              "z": 0.123
            },
            "gtin": "4016883441355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8c5",
            "leftCorner": {
              "x": 2.617,
              "y": 16.905,
              "z": 0.123
            },
            "rightCorner": {
              "x": 2.624,
              "y": 17.042,
              "z": 0.123
            },
            "gtin": "4002221047389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8c6",
            "leftCorner": {
              "x": 2.615,
              "y": 17.042,
              "z": 0.123
            },
            "rightCorner": {
              "x": 2.622,
              "y": 17.18,
              "z": 0.123
            },
            "gtin": "4002221030299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8c7",
            "leftCorner": {
              "x": 2.634,
              "y": 17.18,
              "z": 0.123
            },
            "rightCorner": {
              "x": 2.646,
              "y": 17.397,
              "z": 0.123
            },
            "gtin": "4002221009288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8c8",
            "leftCorner": {
              "x": 2.637,
              "y": 17.398,
              "z": 0.123
            },
            "rightCorner": {
              "x": 2.644,
              "y": 17.523,
              "z": 0.123
            },
            "gtin": "4001257158007",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463f4",
        "height": 0.59471,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e851",
            "leftCorner": {
              "x": 2.578,
              "y": 16.453,
              "z": 0.487
            },
            "rightCorner": {
              "x": 2.59,
              "y": 16.669,
              "z": 0.487
            },
            "gtin": "4337185599149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e852",
            "leftCorner": {
              "x": 2.59,
              "y": 16.669,
              "z": 0.487
            },
            "rightCorner": {
              "x": 2.602,
              "y": 16.885,
              "z": 0.487
            },
            "gtin": "4337185599149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e853",
            "leftCorner": {
              "x": 2.602,
              "y": 16.885,
              "z": 0.487
            },
            "rightCorner": {
              "x": 2.614,
              "y": 17.1,
              "z": 0.487
            },
            "gtin": "4337185599149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e854",
            "leftCorner": {
              "x": 2.635,
              "y": 17.1,
              "z": 0.487
            },
            "rightCorner": {
              "x": 2.64,
              "y": 17.193,
              "z": 0.487
            },
            "gtin": "4002221048607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e855",
            "leftCorner": {
              "x": 2.633,
              "y": 17.194,
              "z": 0.487
            },
            "rightCorner": {
              "x": 2.637,
              "y": 17.275,
              "z": 0.487
            },
            "gtin": "4002221048508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e856",
            "leftCorner": {
              "x": 2.623,
              "y": 17.276,
              "z": 0.487
            },
            "rightCorner": {
              "x": 2.626,
              "y": 17.335,
              "z": 0.487
            },
            "gtin": "4002221048447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e857",
            "leftCorner": {
              "x": 2.642,
              "y": 17.334,
              "z": 0.487
            },
            "rightCorner": {
              "x": 2.649,
              "y": 17.463,
              "z": 0.487
            },
            "gtin": "4002221048485",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463f0",
        "height": 1.0044,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e803",
            "leftCorner": {
              "x": 2.577,
              "y": 16.338,
              "z": 0.822
            },
            "rightCorner": {
              "x": 2.587,
              "y": 16.513,
              "z": 0.822
            },
            "gtin": "4008837219806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e804",
            "leftCorner": {
              "x": 2.587,
              "y": 16.513,
              "z": 0.822
            },
            "rightCorner": {
              "x": 2.596,
              "y": 16.687,
              "z": 0.822
            },
            "gtin": "4008837219806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e805",
            "leftCorner": {
              "x": 2.594,
              "y": 16.688,
              "z": 0.822
            },
            "rightCorner": {
              "x": 2.605,
              "y": 16.89,
              "z": 0.822
            },
            "gtin": "4008837219844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e806",
            "leftCorner": {
              "x": 2.605,
              "y": 16.89,
              "z": 0.822
            },
            "rightCorner": {
              "x": 2.616,
              "y": 17.091,
              "z": 0.822
            },
            "gtin": "4008837219844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e807",
            "leftCorner": {
              "x": 2.614,
              "y": 17.091,
              "z": 0.822
            },
            "rightCorner": {
              "x": 2.625,
              "y": 17.286,
              "z": 0.822
            },
            "gtin": "4008837219813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e808",
            "leftCorner": {
              "x": 2.625,
              "y": 17.286,
              "z": 0.822
            },
            "rightCorner": {
              "x": 2.635,
              "y": 17.482,
              "z": 0.822
            },
            "gtin": "4008837219813",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463f1",
        "height": 1.3586,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e879",
            "leftCorner": {
              "x": 2.582,
              "y": 16.321,
              "z": 1.112
            },
            "rightCorner": {
              "x": 2.602,
              "y": 16.703,
              "z": 1.112
            },
            "gtin": "4008837210001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e87a",
            "leftCorner": {
              "x": 2.597,
              "y": 16.703,
              "z": 1.112
            },
            "rightCorner": {
              "x": 2.604,
              "y": 16.846,
              "z": 1.112
            },
            "gtin": "4008837214108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e87b",
            "leftCorner": {
              "x": 2.604,
              "y": 16.846,
              "z": 1.112
            },
            "rightCorner": {
              "x": 2.612,
              "y": 16.987,
              "z": 1.112
            },
            "gtin": "4008837214108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e87c",
            "leftCorner": {
              "x": 2.611,
              "y": 16.987,
              "z": 1.112
            },
            "rightCorner": {
              "x": 2.625,
              "y": 17.244,
              "z": 1.112
            },
            "gtin": "4008837214184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e87d",
            "leftCorner": {
              "x": 2.626,
              "y": 17.244,
              "z": 1.112
            },
            "rightCorner": {
              "x": 2.634,
              "y": 17.373,
              "z": 1.112
            },
            "gtin": "4008837214191",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e87e",
            "leftCorner": {
              "x": 2.634,
              "y": 17.373,
              "z": 1.112
            },
            "rightCorner": {
              "x": 2.64,
              "y": 17.502,
              "z": 1.112
            },
            "gtin": "4008837214191",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463f2",
        "height": 1.7034,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e7bf",
            "leftCorner": {
              "x": 2.582,
              "y": 16.322,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.588,
              "y": 16.447,
              "z": 1.394
            },
            "gtin": "4008837204093",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7c0",
            "leftCorner": {
              "x": 2.588,
              "y": 16.447,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.595,
              "y": 16.573,
              "z": 1.394
            },
            "gtin": "4008837204093",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7c1",
            "leftCorner": {
              "x": 2.595,
              "y": 16.573,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.605,
              "y": 16.744,
              "z": 1.394
            },
            "gtin": "4008837222219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7c2",
            "leftCorner": {
              "x": 2.611,
              "y": 16.744,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.616,
              "y": 16.835,
              "z": 1.394
            },
            "gtin": "4008837222202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7c3",
            "leftCorner": {
              "x": 2.609,
              "y": 16.835,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.617,
              "y": 16.989,
              "z": 1.394
            },
            "gtin": "4008837225432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7c4",
            "leftCorner": {
              "x": 2.612,
              "y": 16.989,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.62,
              "y": 17.126,
              "z": 1.394
            },
            "gtin": "4008837225401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7c5",
            "leftCorner": {
              "x": 2.623,
              "y": 17.126,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.629,
              "y": 17.244,
              "z": 1.394
            },
            "gtin": "4008837225449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7c6",
            "leftCorner": {
              "x": 2.625,
              "y": 17.244,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.633,
              "y": 17.386,
              "z": 1.394
            },
            "gtin": "4008837225418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7c7",
            "leftCorner": {
              "x": 2.637,
              "y": 17.386,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.643,
              "y": 17.491,
              "z": 1.394
            },
            "gtin": "4008837225425",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41ab1",
    "rightNeighborShelfId": "41ab3"
  },
  {
    "id": "41ab3",
    "name": "41ab3",
    "x": 2.696,
    "y": 17.468,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68756,
      "w": 0.72613
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 53
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463fb",
        "height": 1.358,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e87f",
            "leftCorner": {
              "x": 2.655,
              "y": 17.501,
              "z": 1.111
            },
            "rightCorner": {
              "x": 2.661,
              "y": 17.622,
              "z": 1.111
            },
            "gtin": "4002221037946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e880",
            "leftCorner": {
              "x": 2.658,
              "y": 17.623,
              "z": 1.111
            },
            "rightCorner": {
              "x": 2.662,
              "y": 17.69,
              "z": 1.111
            },
            "gtin": "4002221038066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e881",
            "leftCorner": {
              "x": 2.662,
              "y": 17.69,
              "z": 1.111
            },
            "rightCorner": {
              "x": 2.665,
              "y": 17.758,
              "z": 1.111
            },
            "gtin": "4002221038066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e882",
            "leftCorner": {
              "x": 2.66,
              "y": 17.759,
              "z": 1.111
            },
            "rightCorner": {
              "x": 2.668,
              "y": 17.906,
              "z": 1.111
            },
            "gtin": "4002221038103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e883",
            "leftCorner": {
              "x": 2.668,
              "y": 17.906,
              "z": 1.111
            },
            "rightCorner": {
              "x": 2.675,
              "y": 18.047,
              "z": 1.111
            },
            "gtin": "4002221037960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e884",
            "leftCorner": {
              "x": 2.675,
              "y": 18.047,
              "z": 1.111
            },
            "rightCorner": {
              "x": 2.679,
              "y": 18.11,
              "z": 1.111
            },
            "gtin": "4002221048362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e885",
            "leftCorner": {
              "x": 2.679,
              "y": 18.11,
              "z": 1.111
            },
            "rightCorner": {
              "x": 2.682,
              "y": 18.172,
              "z": 1.111
            },
            "gtin": "4002221048362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e886",
            "leftCorner": {
              "x": 2.672,
              "y": 18.172,
              "z": 1.111
            },
            "rightCorner": {
              "x": 2.679,
              "y": 18.308,
              "z": 1.111
            },
            "gtin": "4002221038042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e887",
            "leftCorner": {
              "x": 2.675,
              "y": 18.308,
              "z": 1.111
            },
            "rightCorner": {
              "x": 2.682,
              "y": 18.421,
              "z": 1.111
            },
            "gtin": "4002221038028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e888",
            "leftCorner": {
              "x": 2.685,
              "y": 18.421,
              "z": 1.111
            },
            "rightCorner": {
              "x": 2.694,
              "y": 18.585,
              "z": 1.111
            },
            "gtin": "4002221048201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e889",
            "leftCorner": {
              "x": 2.704,
              "y": 18.584,
              "z": 1.111
            },
            "rightCorner": {
              "x": 2.709,
              "y": 18.658,
              "z": 1.111
            },
            "gtin": "4002221040069",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463fd",
        "height": 0.14716,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e8c9",
            "leftCorner": {
              "x": 2.638,
              "y": 17.523,
              "z": 0.12
            },
            "rightCorner": {
              "x": 2.646,
              "y": 17.667,
              "z": 0.12
            },
            "gtin": "4001257160000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8ca",
            "leftCorner": {
              "x": 2.65,
              "y": 17.667,
              "z": 0.12
            },
            "rightCorner": {
              "x": 2.66,
              "y": 17.845,
              "z": 0.12
            },
            "gtin": "4001257152005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8cb",
            "leftCorner": {
              "x": 2.653,
              "y": 17.845,
              "z": 0.12
            },
            "rightCorner": {
              "x": 2.659,
              "y": 17.955,
              "z": 0.12
            },
            "gtin": "4001257154009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8cc",
            "leftCorner": {
              "x": 2.666,
              "y": 17.955,
              "z": 0.12
            },
            "rightCorner": {
              "x": 2.672,
              "y": 18.066,
              "z": 0.12
            },
            "gtin": "4002221009325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8cd",
            "leftCorner": {
              "x": 2.672,
              "y": 18.066,
              "z": 0.12
            },
            "rightCorner": {
              "x": 2.678,
              "y": 18.178,
              "z": 0.12
            },
            "gtin": "4002221009325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8ce",
            "leftCorner": {
              "x": 2.665,
              "y": 18.179,
              "z": 0.12
            },
            "rightCorner": {
              "x": 2.671,
              "y": 18.281,
              "z": 0.12
            },
            "gtin": "4001257159004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8cf",
            "leftCorner": {
              "x": 2.671,
              "y": 18.281,
              "z": 0.12
            },
            "rightCorner": {
              "x": 2.677,
              "y": 18.382,
              "z": 0.12
            },
            "gtin": "4001257159004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8d0",
            "leftCorner": {
              "x": 2.669,
              "y": 18.383,
              "z": 0.12
            },
            "rightCorner": {
              "x": 2.677,
              "y": 18.523,
              "z": 0.12
            },
            "gtin": "4001257153002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8d1",
            "leftCorner": {
              "x": 2.703,
              "y": 18.522,
              "z": 0.12
            },
            "rightCorner": {
              "x": 2.711,
              "y": 18.66,
              "z": 0.12
            },
            "gtin": "4002221014015",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463fa",
        "height": 0.60181,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e858",
            "leftCorner": {
              "x": 2.643,
              "y": 17.463,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.647,
              "y": 17.543,
              "z": 0.492
            },
            "gtin": "4002221048560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e859",
            "leftCorner": {
              "x": 2.647,
              "y": 17.543,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.652,
              "y": 17.622,
              "z": 0.492
            },
            "gtin": "4002221048560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e85a",
            "leftCorner": {
              "x": 2.65,
              "y": 17.623,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.653,
              "y": 17.685,
              "z": 0.492
            },
            "gtin": "4002221048461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e85b",
            "leftCorner": {
              "x": 2.653,
              "y": 17.685,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.657,
              "y": 17.747,
              "z": 0.492
            },
            "gtin": "4002221048461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e85c",
            "leftCorner": {
              "x": 2.655,
              "y": 17.747,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.66,
              "y": 17.827,
              "z": 0.492
            },
            "gtin": "4002221048584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e85d",
            "leftCorner": {
              "x": 2.665,
              "y": 17.826,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.672,
              "y": 17.954,
              "z": 0.492
            },
            "gtin": "4002221048546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e85e",
            "leftCorner": {
              "x": 2.657,
              "y": 17.956,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.662,
              "y": 18.043,
              "z": 0.492
            },
            "gtin": "4002221011311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e85f",
            "leftCorner": {
              "x": 2.662,
              "y": 18.043,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.666,
              "y": 18.131,
              "z": 0.492
            },
            "gtin": "4002221011311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e860",
            "leftCorner": {
              "x": 2.661,
              "y": 18.131,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.67,
              "y": 18.282,
              "z": 0.492
            },
            "gtin": "4001257157000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e861",
            "leftCorner": {
              "x": 2.666,
              "y": 18.282,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.673,
              "y": 18.409,
              "z": 0.492
            },
            "gtin": "4001257156003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e862",
            "leftCorner": {
              "x": 2.666,
              "y": 18.409,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.674,
              "y": 18.542,
              "z": 0.492
            },
            "gtin": "4002221030114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e835",
            "leftCorner": {
              "x": 2.687,
              "y": 18.541,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.694,
              "y": 18.67,
              "z": 0.492
            },
            "gtin": "4002221030275",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463f9",
        "height": 0.99718,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e809",
            "leftCorner": {
              "x": 2.653,
              "y": 17.481,
              "z": 0.816
            },
            "rightCorner": {
              "x": 2.661,
              "y": 17.635,
              "z": 0.816
            },
            "gtin": "4002221030015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e80a",
            "leftCorner": {
              "x": 2.663,
              "y": 17.635,
              "z": 0.816
            },
            "rightCorner": {
              "x": 2.67,
              "y": 17.757,
              "z": 0.816
            },
            "gtin": "4002221037984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e80b",
            "leftCorner": {
              "x": 2.663,
              "y": 17.757,
              "z": 0.816
            },
            "rightCorner": {
              "x": 2.67,
              "y": 17.87,
              "z": 0.816
            },
            "gtin": "4002221030237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e80c",
            "leftCorner": {
              "x": 2.663,
              "y": 17.871,
              "z": 0.816
            },
            "rightCorner": {
              "x": 2.667,
              "y": 17.936,
              "z": 0.816
            },
            "gtin": "4002221048225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e80d",
            "leftCorner": {
              "x": 2.667,
              "y": 17.936,
              "z": 0.816
            },
            "rightCorner": {
              "x": 2.67,
              "y": 18.002,
              "z": 0.816
            },
            "gtin": "4002221048225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e80e",
            "leftCorner": {
              "x": 2.671,
              "y": 18.002,
              "z": 0.816
            },
            "rightCorner": {
              "x": 2.679,
              "y": 18.155,
              "z": 0.816
            },
            "gtin": "4002221030176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e80f",
            "leftCorner": {
              "x": 2.67,
              "y": 18.157,
              "z": 0.816
            },
            "rightCorner": {
              "x": 2.673,
              "y": 18.218,
              "z": 0.816
            },
            "gtin": "4002221030152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e810",
            "leftCorner": {
              "x": 2.673,
              "y": 18.218,
              "z": 0.816
            },
            "rightCorner": {
              "x": 2.677,
              "y": 18.279,
              "z": 0.816
            },
            "gtin": "4002221030152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e811",
            "leftCorner": {
              "x": 2.674,
              "y": 18.279,
              "z": 0.816
            },
            "rightCorner": {
              "x": 2.678,
              "y": 18.341,
              "z": 0.816
            },
            "gtin": "4002221030077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e812",
            "leftCorner": {
              "x": 2.678,
              "y": 18.341,
              "z": 0.816
            },
            "rightCorner": {
              "x": 2.681,
              "y": 18.402,
              "z": 0.816
            },
            "gtin": "4002221030077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e813",
            "leftCorner": {
              "x": 2.685,
              "y": 18.402,
              "z": 0.816
            },
            "rightCorner": {
              "x": 2.692,
              "y": 18.537,
              "z": 0.816
            },
            "gtin": "4002221030053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e814",
            "leftCorner": {
              "x": 2.692,
              "y": 18.537,
              "z": 0.816
            },
            "rightCorner": {
              "x": 2.7,
              "y": 18.671,
              "z": 0.816
            },
            "gtin": "4002221030053",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463fc",
        "height": 1.7035,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e7c8",
            "leftCorner": {
              "x": 2.681,
              "y": 17.488,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.684,
              "y": 17.554,
              "z": 1.394
            },
            "gtin": "4002221035140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7c9",
            "leftCorner": {
              "x": 2.684,
              "y": 17.554,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.688,
              "y": 17.619,
              "z": 1.394
            },
            "gtin": "4002221035140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7ca",
            "leftCorner": {
              "x": 2.663,
              "y": 17.62,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.668,
              "y": 17.715,
              "z": 1.394
            },
            "gtin": "4002221035102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7cb",
            "leftCorner": {
              "x": 2.666,
              "y": 17.715,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.67,
              "y": 17.789,
              "z": 1.394
            },
            "gtin": "4002221035126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7cc",
            "leftCorner": {
              "x": 2.663,
              "y": 17.79,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.669,
              "y": 17.909,
              "z": 1.394
            },
            "gtin": "4002221035065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7cd",
            "leftCorner": {
              "x": 2.676,
              "y": 17.909,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.684,
              "y": 18.067,
              "z": 1.394
            },
            "gtin": "4001257001723",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c865ed67a01d9a1e7ce",
            "leftCorner": {
              "x": 2.667,
              "y": 18.069,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.676,
              "y": 18.229,
              "z": 1.394
            },
            "gtin": "4001257218503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7cf",
            "leftCorner": {
              "x": 2.676,
              "y": 18.229,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.685,
              "y": 18.39,
              "z": 1.394
            },
            "gtin": "4001257218503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7d0",
            "leftCorner": {
              "x": 2.685,
              "y": 18.39,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.693,
              "y": 18.551,
              "z": 1.394
            },
            "gtin": "4001257218503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7d1",
            "leftCorner": {
              "x": 2.709,
              "y": 18.55,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.715,
              "y": 18.664,
              "z": 1.394
            },
            "gtin": "4001257218404",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41ab2",
    "rightNeighborShelfId": "41ab4"
  },
  {
    "id": "41ab4",
    "name": "41ab4",
    "x": 2.761,
    "y": 18.666,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68756,
      "w": 0.72613
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 66
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546401",
        "height": 0.14367,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e8d2",
            "leftCorner": {
              "x": 2.706,
              "y": 18.661,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.712,
              "y": 18.78,
              "z": 0.118
            },
            "gtin": "4009300001188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8d3",
            "leftCorner": {
              "x": 2.717,
              "y": 18.78,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.722,
              "y": 18.874,
              "z": 0.118
            },
            "gtin": "4009300002789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8d4",
            "leftCorner": {
              "x": 2.722,
              "y": 18.874,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.728,
              "y": 18.966,
              "z": 0.118
            },
            "gtin": "4009300002789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8d5",
            "leftCorner": {
              "x": 2.724,
              "y": 18.967,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.733,
              "y": 19.132,
              "z": 0.118
            },
            "gtin": "4009300002796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8d6",
            "leftCorner": {
              "x": 2.751,
              "y": 19.132,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.753,
              "y": 19.18,
              "z": 0.118
            },
            "gtin": "4009300008903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8d7",
            "leftCorner": {
              "x": 2.753,
              "y": 19.18,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.756,
              "y": 19.228,
              "z": 0.118
            },
            "gtin": "4009300008903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8d8",
            "leftCorner": {
              "x": 2.756,
              "y": 19.228,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.758,
              "y": 19.276,
              "z": 0.118
            },
            "gtin": "4009300008903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8d9",
            "leftCorner": {
              "x": 2.753,
              "y": 19.277,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.757,
              "y": 19.355,
              "z": 0.118
            },
            "gtin": "4009300005810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8da",
            "leftCorner": {
              "x": 2.757,
              "y": 19.355,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.761,
              "y": 19.433,
              "z": 0.118
            },
            "gtin": "4009300005810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8db",
            "leftCorner": {
              "x": 2.771,
              "y": 19.432,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.777,
              "y": 19.55,
              "z": 0.118
            },
            "gtin": "4009300001140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8dc",
            "leftCorner": {
              "x": 2.777,
              "y": 19.55,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.784,
              "y": 19.668,
              "z": 0.118
            },
            "gtin": "4009300001140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8dd",
            "leftCorner": {
              "x": 2.77,
              "y": 19.668,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.777,
              "y": 19.794,
              "z": 0.118
            },
            "gtin": "4009300005827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8de",
            "leftCorner": {
              "x": 2.787,
              "y": 19.794,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.79,
              "y": 19.842,
              "z": 0.118
            },
            "gtin": "4009300005902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8df",
            "leftCorner": {
              "x": 2.79,
              "y": 19.842,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.793,
              "y": 19.891,
              "z": 0.118
            },
            "gtin": "4009300005902",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546402",
        "height": 0.59166,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e981",
            "leftCorner": {
              "x": 2.758,
              "y": 18.666,
              "z": 0.484
            },
            "rightCorner": {
              "x": 2.762,
              "y": 18.741,
              "z": 0.484
            },
            "gtin": "4009300014720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e982",
            "leftCorner": {
              "x": 2.762,
              "y": 18.741,
              "z": 0.484
            },
            "rightCorner": {
              "x": 2.766,
              "y": 18.816,
              "z": 0.484
            },
            "gtin": "4009300014720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e985",
            "leftCorner": {
              "x": 2.729,
              "y": 18.818,
              "z": 0.484
            },
            "rightCorner": {
              "x": 2.74,
              "y": 19.019,
              "z": 0.484
            },
            "gtin": "4009300005841",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c865ed67a01d9a1e986",
            "leftCorner": {
              "x": 2.741,
              "y": 19.019,
              "z": 0.484
            },
            "rightCorner": {
              "x": 2.744,
              "y": 19.082,
              "z": 0.484
            },
            "gtin": "4009300005865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e987",
            "leftCorner": {
              "x": 2.744,
              "y": 19.082,
              "z": 0.484
            },
            "rightCorner": {
              "x": 2.748,
              "y": 19.145,
              "z": 0.484
            },
            "gtin": "4009300005865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e988",
            "leftCorner": {
              "x": 2.746,
              "y": 19.145,
              "z": 0.484
            },
            "rightCorner": {
              "x": 2.75,
              "y": 19.209,
              "z": 0.484
            },
            "gtin": "4009300005896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e989",
            "leftCorner": {
              "x": 2.75,
              "y": 19.209,
              "z": 0.484
            },
            "rightCorner": {
              "x": 2.753,
              "y": 19.272,
              "z": 0.484
            },
            "gtin": "4009300005896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e98a",
            "leftCorner": {
              "x": 2.747,
              "y": 19.272,
              "z": 0.484
            },
            "rightCorner": {
              "x": 2.755,
              "y": 19.421,
              "z": 0.484
            },
            "gtin": "4009300014737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e98b",
            "leftCorner": {
              "x": 2.763,
              "y": 19.42,
              "z": 0.484
            },
            "rightCorner": {
              "x": 2.772,
              "y": 19.581,
              "z": 0.484
            },
            "gtin": "4009300011774",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c865ed67a01d9a1e98c",
            "leftCorner": {
              "x": 2.765,
              "y": 19.581,
              "z": 0.484
            },
            "rightCorner": {
              "x": 2.773,
              "y": 19.733,
              "z": 0.484
            },
            "gtin": "4009300008965",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c865ed67a01d9a1e98d",
            "leftCorner": {
              "x": 2.775,
              "y": 19.733,
              "z": 0.484
            },
            "rightCorner": {
              "x": 2.785,
              "y": 19.924,
              "z": 0.484
            },
            "gtin": "4009300007524",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463ff",
        "height": 0.9954,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e815",
            "leftCorner": {
              "x": 2.717,
              "y": 18.671,
              "z": 0.814
            },
            "rightCorner": {
              "x": 2.724,
              "y": 18.796,
              "z": 0.814
            },
            "gtin": "9001475049106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e816",
            "leftCorner": {
              "x": 2.724,
              "y": 18.796,
              "z": 0.814
            },
            "rightCorner": {
              "x": 2.728,
              "y": 18.866,
              "z": 0.814
            },
            "gtin": "9001475032917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e817",
            "leftCorner": {
              "x": 2.728,
              "y": 18.866,
              "z": 0.814
            },
            "rightCorner": {
              "x": 2.732,
              "y": 18.937,
              "z": 0.814
            },
            "gtin": "9001475032917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e818",
            "leftCorner": {
              "x": 2.731,
              "y": 18.937,
              "z": 0.814
            },
            "rightCorner": {
              "x": 2.734,
              "y": 18.995,
              "z": 0.814
            },
            "gtin": "4009300016915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e819",
            "leftCorner": {
              "x": 2.734,
              "y": 18.995,
              "z": 0.814
            },
            "rightCorner": {
              "x": 2.737,
              "y": 19.053,
              "z": 0.814
            },
            "gtin": "4009300016915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e81a",
            "leftCorner": {
              "x": 2.744,
              "y": 19.053,
              "z": 0.814
            },
            "rightCorner": {
              "x": 2.751,
              "y": 19.18,
              "z": 0.814
            },
            "gtin": "9001475049304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e81b",
            "leftCorner": {
              "x": 2.75,
              "y": 19.18,
              "z": 0.814
            },
            "rightCorner": {
              "x": 2.753,
              "y": 19.232,
              "z": 0.814
            },
            "gtin": "9001475049205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e81c",
            "leftCorner": {
              "x": 2.753,
              "y": 19.232,
              "z": 0.814
            },
            "rightCorner": {
              "x": 2.756,
              "y": 19.283,
              "z": 0.814
            },
            "gtin": "9001475049205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e81d",
            "leftCorner": {
              "x": 2.756,
              "y": 19.283,
              "z": 0.814
            },
            "rightCorner": {
              "x": 2.759,
              "y": 19.335,
              "z": 0.814
            },
            "gtin": "9001475049205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e81e",
            "leftCorner": {
              "x": 2.765,
              "y": 19.334,
              "z": 0.814
            },
            "rightCorner": {
              "x": 2.772,
              "y": 19.447,
              "z": 0.814
            },
            "gtin": "4009300005858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e81f",
            "leftCorner": {
              "x": 2.765,
              "y": 19.447,
              "z": 0.814
            },
            "rightCorner": {
              "x": 2.768,
              "y": 19.507,
              "z": 0.814
            },
            "gtin": "4009300009863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e820",
            "leftCorner": {
              "x": 2.768,
              "y": 19.507,
              "z": 0.814
            },
            "rightCorner": {
              "x": 2.771,
              "y": 19.568,
              "z": 0.814
            },
            "gtin": "4009300009863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e821",
            "leftCorner": {
              "x": 2.771,
              "y": 19.568,
              "z": 0.814
            },
            "rightCorner": {
              "x": 2.775,
              "y": 19.628,
              "z": 0.814
            },
            "gtin": "4009300009863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e822",
            "leftCorner": {
              "x": 2.775,
              "y": 19.628,
              "z": 0.814
            },
            "rightCorner": {
              "x": 2.778,
              "y": 19.688,
              "z": 0.814
            },
            "gtin": "4009300009863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e823",
            "leftCorner": {
              "x": 2.778,
              "y": 19.688,
              "z": 0.814
            },
            "rightCorner": {
              "x": 2.781,
              "y": 19.749,
              "z": 0.814
            },
            "gtin": "4009300009863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e824",
            "leftCorner": {
              "x": 2.784,
              "y": 19.749,
              "z": 0.814
            },
            "rightCorner": {
              "x": 2.786,
              "y": 19.79,
              "z": 0.814
            },
            "gtin": "4009300011958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e825",
            "leftCorner": {
              "x": 2.786,
              "y": 19.79,
              "z": 0.814
            },
            "rightCorner": {
              "x": 2.788,
              "y": 19.831,
              "z": 0.814
            },
            "gtin": "4009300011958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e826",
            "leftCorner": {
              "x": 2.788,
              "y": 19.831,
              "z": 0.814
            },
            "rightCorner": {
              "x": 2.79,
              "y": 19.872,
              "z": 0.814
            },
            "gtin": "4009300011958",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546400",
        "height": 1.3514,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e88a",
            "leftCorner": {
              "x": 2.713,
              "y": 18.659,
              "z": 1.106
            },
            "rightCorner": {
              "x": 2.716,
              "y": 18.707,
              "z": 1.106
            },
            "gtin": "4008071044882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e88b",
            "leftCorner": {
              "x": 2.716,
              "y": 18.707,
              "z": 1.106
            },
            "rightCorner": {
              "x": 2.718,
              "y": 18.756,
              "z": 1.106
            },
            "gtin": "4008071044882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e88c",
            "leftCorner": {
              "x": 2.717,
              "y": 18.756,
              "z": 1.106
            },
            "rightCorner": {
              "x": 2.72,
              "y": 18.81,
              "z": 1.106
            },
            "gtin": "4008071044844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e88d",
            "leftCorner": {
              "x": 2.72,
              "y": 18.81,
              "z": 1.106
            },
            "rightCorner": {
              "x": 2.723,
              "y": 18.864,
              "z": 1.106
            },
            "gtin": "4008071044844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e88e",
            "leftCorner": {
              "x": 2.73,
              "y": 18.863,
              "z": 1.106
            },
            "rightCorner": {
              "x": 2.735,
              "y": 18.962,
              "z": 1.106
            },
            "gtin": "4008071044813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e88f",
            "leftCorner": {
              "x": 2.747,
              "y": 18.961,
              "z": 1.106
            },
            "rightCorner": {
              "x": 2.758,
              "y": 19.157,
              "z": 1.106
            },
            "gtin": "4008071044820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e890",
            "leftCorner": {
              "x": 2.749,
              "y": 19.158,
              "z": 1.106
            },
            "rightCorner": {
              "x": 2.753,
              "y": 19.232,
              "z": 1.106
            },
            "gtin": "4008071043953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e891",
            "leftCorner": {
              "x": 2.753,
              "y": 19.232,
              "z": 1.106
            },
            "rightCorner": {
              "x": 2.757,
              "y": 19.306,
              "z": 1.106
            },
            "gtin": "4008071043953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e892",
            "leftCorner": {
              "x": 2.762,
              "y": 19.305,
              "z": 1.106
            },
            "rightCorner": {
              "x": 2.771,
              "y": 19.478,
              "z": 1.106
            },
            "gtin": "4008071043908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e893",
            "leftCorner": {
              "x": 2.766,
              "y": 19.478,
              "z": 1.106
            },
            "rightCorner": {
              "x": 2.771,
              "y": 19.558,
              "z": 1.106
            },
            "gtin": "4008071043960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e894",
            "leftCorner": {
              "x": 2.771,
              "y": 19.558,
              "z": 1.106
            },
            "rightCorner": {
              "x": 2.775,
              "y": 19.638,
              "z": 1.106
            },
            "gtin": "4008071043960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e895",
            "leftCorner": {
              "x": 2.779,
              "y": 19.638,
              "z": 1.106
            },
            "rightCorner": {
              "x": 2.793,
              "y": 19.886,
              "z": 1.106
            },
            "gtin": "4008071043977",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463fe",
        "height": 1.7041,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e7d2",
            "leftCorner": {
              "x": 2.721,
              "y": 18.663,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.726,
              "y": 18.748,
              "z": 1.394
            },
            "gtin": "4002221037618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7d3",
            "leftCorner": {
              "x": 2.722,
              "y": 18.748,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.727,
              "y": 18.842,
              "z": 1.394
            },
            "gtin": "4002221040182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7d4",
            "leftCorner": {
              "x": 2.729,
              "y": 18.842,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.735,
              "y": 18.957,
              "z": 1.394
            },
            "gtin": "4002221037595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7d5",
            "leftCorner": {
              "x": 2.735,
              "y": 18.957,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.741,
              "y": 19.071,
              "z": 1.394
            },
            "gtin": "4002221037595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7d6",
            "leftCorner": {
              "x": 2.762,
              "y": 19.07,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.767,
              "y": 19.161,
              "z": 1.394
            },
            "gtin": "4002221047709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7d7",
            "leftCorner": {
              "x": 2.747,
              "y": 19.162,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.75,
              "y": 19.219,
              "z": 1.394
            },
            "gtin": "4002221037632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7d8",
            "leftCorner": {
              "x": 2.75,
              "y": 19.219,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.753,
              "y": 19.277,
              "z": 1.394
            },
            "gtin": "4002221037632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7d9",
            "leftCorner": {
              "x": 2.765,
              "y": 19.275,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.773,
              "y": 19.421,
              "z": 1.394
            },
            "gtin": "4002221040205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7da",
            "leftCorner": {
              "x": 2.763,
              "y": 19.421,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.766,
              "y": 19.48,
              "z": 1.394
            },
            "gtin": "4001257214109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7db",
            "leftCorner": {
              "x": 2.766,
              "y": 19.48,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.77,
              "y": 19.539,
              "z": 1.394
            },
            "gtin": "4001257214109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7dc",
            "leftCorner": {
              "x": 2.771,
              "y": 19.539,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.783,
              "y": 19.746,
              "z": 1.394
            },
            "gtin": "4002221015128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7dd",
            "leftCorner": {
              "x": 2.784,
              "y": 19.745,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.786,
              "y": 19.79,
              "z": 1.394
            },
            "gtin": "4001257283501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7de",
            "leftCorner": {
              "x": 2.786,
              "y": 19.79,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.789,
              "y": 19.835,
              "z": 1.394
            },
            "gtin": "4001257283501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7df",
            "leftCorner": {
              "x": 2.789,
              "y": 19.835,
              "z": 1.394
            },
            "rightCorner": {
              "x": 2.791,
              "y": 19.88,
              "z": 1.394
            },
            "gtin": "4001257283501",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41ab3",
    "rightNeighborShelfId": "41ab5"
  },
  {
    "id": "41ab5",
    "name": "41ab5",
    "x": 2.827,
    "y": 19.864,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68756,
      "w": 0.72613
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 66
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546409",
        "height": 1.3551,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e898",
            "leftCorner": {
              "x": 2.782,
              "y": 20.005,
              "z": 1.109
            },
            "rightCorner": {
              "x": 2.787,
              "y": 20.087,
              "z": 1.109
            },
            "gtin": "4009300012733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e899",
            "leftCorner": {
              "x": 2.787,
              "y": 20.087,
              "z": 1.109
            },
            "rightCorner": {
              "x": 2.791,
              "y": 20.169,
              "z": 1.109
            },
            "gtin": "4009300012733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e89a",
            "leftCorner": {
              "x": 2.797,
              "y": 20.169,
              "z": 1.109
            },
            "rightCorner": {
              "x": 2.806,
              "y": 20.344,
              "z": 1.109
            },
            "gtin": "4009300012726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e89b",
            "leftCorner": {
              "x": 2.807,
              "y": 20.344,
              "z": 1.109
            },
            "rightCorner": {
              "x": 2.814,
              "y": 20.479,
              "z": 1.109
            },
            "gtin": "4009300012719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e89c",
            "leftCorner": {
              "x": 2.813,
              "y": 20.479,
              "z": 1.109
            },
            "rightCorner": {
              "x": 2.824,
              "y": 20.672,
              "z": 1.109
            },
            "gtin": "4009300005209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e89d",
            "leftCorner": {
              "x": 2.831,
              "y": 20.671,
              "z": 1.109
            },
            "rightCorner": {
              "x": 2.836,
              "y": 20.763,
              "z": 1.109
            },
            "gtin": "4009300004516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e89e",
            "leftCorner": {
              "x": 2.836,
              "y": 20.763,
              "z": 1.109
            },
            "rightCorner": {
              "x": 2.841,
              "y": 20.854,
              "z": 1.109
            },
            "gtin": "4009300004516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e89f",
            "leftCorner": {
              "x": 2.837,
              "y": 20.855,
              "z": 1.109
            },
            "rightCorner": {
              "x": 2.841,
              "y": 20.937,
              "z": 1.109
            },
            "gtin": "4009300007982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8a0",
            "leftCorner": {
              "x": 2.841,
              "y": 20.937,
              "z": 1.109
            },
            "rightCorner": {
              "x": 2.846,
              "y": 21.019,
              "z": 1.109
            },
            "gtin": "4009300007982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e866",
            "leftCorner": {
              "x": 2.84,
              "y": 21.02,
              "z": 1.109
            },
            "rightCorner": {
              "x": 2.845,
              "y": 21.115,
              "z": 1.109
            },
            "gtin": "4009300003403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e896",
            "leftCorner": {
              "x": 2.788,
              "y": 19.887,
              "z": 1.109
            },
            "rightCorner": {
              "x": 2.791,
              "y": 19.946,
              "z": 1.109
            },
            "gtin": "4009300007401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e897",
            "leftCorner": {
              "x": 2.791,
              "y": 19.946,
              "z": 1.109
            },
            "rightCorner": {
              "x": 2.794,
              "y": 20.004,
              "z": 1.109
            },
            "gtin": "4009300007401",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54640b",
        "height": 1.696,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e7e0",
            "leftCorner": {
              "x": 2.793,
              "y": 19.879,
              "z": 1.388
            },
            "rightCorner": {
              "x": 2.802,
              "y": 20.057,
              "z": 1.388
            },
            "gtin": "4009300002406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7e1",
            "leftCorner": {
              "x": 2.794,
              "y": 20.057,
              "z": 1.388
            },
            "rightCorner": {
              "x": 2.799,
              "y": 20.15,
              "z": 1.388
            },
            "gtin": "4009300001072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7e2",
            "leftCorner": {
              "x": 2.799,
              "y": 20.15,
              "z": 1.388
            },
            "rightCorner": {
              "x": 2.805,
              "y": 20.243,
              "z": 1.388
            },
            "gtin": "4009300001072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7e3",
            "leftCorner": {
              "x": 2.803,
              "y": 20.243,
              "z": 1.388
            },
            "rightCorner": {
              "x": 2.808,
              "y": 20.334,
              "z": 1.388
            },
            "gtin": "4009300001065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7e4",
            "leftCorner": {
              "x": 2.808,
              "y": 20.334,
              "z": 1.388
            },
            "rightCorner": {
              "x": 2.813,
              "y": 20.425,
              "z": 1.388
            },
            "gtin": "4009300001065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7e5",
            "leftCorner": {
              "x": 2.82,
              "y": 20.425,
              "z": 1.388
            },
            "rightCorner": {
              "x": 2.825,
              "y": 20.517,
              "z": 1.388
            },
            "gtin": "4009300009870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7e6",
            "leftCorner": {
              "x": 2.825,
              "y": 20.517,
              "z": 1.388
            },
            "rightCorner": {
              "x": 2.83,
              "y": 20.61,
              "z": 1.388
            },
            "gtin": "4009300009870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7e7",
            "leftCorner": {
              "x": 2.819,
              "y": 20.611,
              "z": 1.388
            },
            "rightCorner": {
              "x": 2.822,
              "y": 20.681,
              "z": 1.388
            },
            "gtin": "4009300006053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7e8",
            "leftCorner": {
              "x": 2.822,
              "y": 20.681,
              "z": 1.388
            },
            "rightCorner": {
              "x": 2.826,
              "y": 20.751,
              "z": 1.388
            },
            "gtin": "4009300006053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7e9",
            "leftCorner": {
              "x": 2.837,
              "y": 20.749,
              "z": 1.388
            },
            "rightCorner": {
              "x": 2.841,
              "y": 20.812,
              "z": 1.388
            },
            "gtin": "4009300007807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7ea",
            "leftCorner": {
              "x": 2.841,
              "y": 20.812,
              "z": 1.388
            },
            "rightCorner": {
              "x": 2.844,
              "y": 20.875,
              "z": 1.388
            },
            "gtin": "4009300007807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7eb",
            "leftCorner": {
              "x": 2.848,
              "y": 20.874,
              "z": 1.388
            },
            "rightCorner": {
              "x": 2.855,
              "y": 21.004,
              "z": 1.388
            },
            "gtin": "4002221049611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7a6",
            "leftCorner": {
              "x": 2.854,
              "y": 21.004,
              "z": 1.388
            },
            "rightCorner": {
              "x": 2.86,
              "y": 21.114,
              "z": 1.388
            },
            "gtin": "4002221049659",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54640c",
        "height": 0.14216,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e8e0",
            "leftCorner": {
              "x": 2.785,
              "y": 19.892,
              "z": 0.116
            },
            "rightCorner": {
              "x": 2.794,
              "y": 20.049,
              "z": 0.116
            },
            "gtin": "4009300001164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8e1",
            "leftCorner": {
              "x": 2.792,
              "y": 20.049,
              "z": 0.116
            },
            "rightCorner": {
              "x": 2.796,
              "y": 20.13,
              "z": 0.116
            },
            "gtin": "4009300005834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8e2",
            "leftCorner": {
              "x": 2.796,
              "y": 20.13,
              "z": 0.116
            },
            "rightCorner": {
              "x": 2.801,
              "y": 20.211,
              "z": 0.116
            },
            "gtin": "4009300005834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8e3",
            "leftCorner": {
              "x": 2.796,
              "y": 20.211,
              "z": 0.116
            },
            "rightCorner": {
              "x": 2.8,
              "y": 20.291,
              "z": 0.116
            },
            "gtin": "4009300005926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8e4",
            "leftCorner": {
              "x": 2.8,
              "y": 20.291,
              "z": 0.116
            },
            "rightCorner": {
              "x": 2.804,
              "y": 20.37,
              "z": 0.116
            },
            "gtin": "4009300005926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8e5",
            "leftCorner": {
              "x": 2.801,
              "y": 20.37,
              "z": 0.116
            },
            "rightCorner": {
              "x": 2.812,
              "y": 20.571,
              "z": 0.116
            },
            "gtin": "4009300011750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8e6",
            "leftCorner": {
              "x": 2.816,
              "y": 20.571,
              "z": 0.116
            },
            "rightCorner": {
              "x": 2.819,
              "y": 20.627,
              "z": 0.116
            },
            "gtin": "4009300008170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8e7",
            "leftCorner": {
              "x": 2.819,
              "y": 20.627,
              "z": 0.116
            },
            "rightCorner": {
              "x": 2.822,
              "y": 20.684,
              "z": 0.116
            },
            "gtin": "4009300008170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8e8",
            "leftCorner": {
              "x": 2.827,
              "y": 20.684,
              "z": 0.116
            },
            "rightCorner": {
              "x": 2.833,
              "y": 20.789,
              "z": 0.116
            },
            "gtin": "4009300019343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8e9",
            "leftCorner": {
              "x": 2.833,
              "y": 20.789,
              "z": 0.116
            },
            "rightCorner": {
              "x": 2.839,
              "y": 20.894,
              "z": 0.116
            },
            "gtin": "4009300019343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8a7",
            "leftCorner": {
              "x": 2.834,
              "y": 20.894,
              "z": 0.116
            },
            "rightCorner": {
              "x": 2.84,
              "y": 21.005,
              "z": 0.116
            },
            "gtin": "4009300005889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8a8",
            "leftCorner": {
              "x": 2.84,
              "y": 21.005,
              "z": 0.116
            },
            "rightCorner": {
              "x": 2.846,
              "y": 21.115,
              "z": 0.116
            },
            "gtin": "4009300005889",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54640a",
        "height": 0.59659,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e98e",
            "leftCorner": {
              "x": 2.782,
              "y": 19.925,
              "z": 0.488
            },
            "rightCorner": {
              "x": 2.787,
              "y": 20.005,
              "z": 0.488
            },
            "gtin": "4009300005872",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e98f",
            "leftCorner": {
              "x": 2.774,
              "y": 20.006,
              "z": 0.488
            },
            "rightCorner": {
              "x": 2.776,
              "y": 20.038,
              "z": 0.488
            },
            "gtin": "4009300019398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e990",
            "leftCorner": {
              "x": 2.776,
              "y": 20.038,
              "z": 0.488
            },
            "rightCorner": {
              "x": 2.778,
              "y": 20.071,
              "z": 0.488
            },
            "gtin": "4009300019398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e991",
            "leftCorner": {
              "x": 2.778,
              "y": 20.071,
              "z": 0.488
            },
            "rightCorner": {
              "x": 2.78,
              "y": 20.103,
              "z": 0.488
            },
            "gtin": "4009300019398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e992",
            "leftCorner": {
              "x": 2.78,
              "y": 20.103,
              "z": 0.488
            },
            "rightCorner": {
              "x": 2.781,
              "y": 20.136,
              "z": 0.488
            },
            "gtin": "4009300019398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e993",
            "leftCorner": {
              "x": 2.783,
              "y": 20.136,
              "z": 0.488
            },
            "rightCorner": {
              "x": 2.786,
              "y": 20.192,
              "z": 0.488
            },
            "gtin": "4009300019404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e994",
            "leftCorner": {
              "x": 2.786,
              "y": 20.192,
              "z": 0.488
            },
            "rightCorner": {
              "x": 2.789,
              "y": 20.247,
              "z": 0.488
            },
            "gtin": "4009300019404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e995",
            "leftCorner": {
              "x": 2.789,
              "y": 20.247,
              "z": 0.488
            },
            "rightCorner": {
              "x": 2.792,
              "y": 20.303,
              "z": 0.488
            },
            "gtin": "4009300019404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e996",
            "leftCorner": {
              "x": 2.791,
              "y": 20.303,
              "z": 0.488
            },
            "rightCorner": {
              "x": 2.799,
              "y": 20.453,
              "z": 0.488
            },
            "gtin": "4009300019374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e997",
            "leftCorner": {
              "x": 2.804,
              "y": 20.452,
              "z": 0.488
            },
            "rightCorner": {
              "x": 2.814,
              "y": 20.648,
              "z": 0.488
            },
            "gtin": "4009300002642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e998",
            "leftCorner": {
              "x": 2.808,
              "y": 20.648,
              "z": 0.488
            },
            "rightCorner": {
              "x": 2.814,
              "y": 20.76,
              "z": 0.488
            },
            "gtin": "4009300009894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e999",
            "leftCorner": {
              "x": 2.814,
              "y": 20.76,
              "z": 0.488
            },
            "rightCorner": {
              "x": 2.82,
              "y": 20.873,
              "z": 0.488
            },
            "gtin": "4009300009894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e99a",
            "leftCorner": {
              "x": 2.82,
              "y": 20.873,
              "z": 0.488
            },
            "rightCorner": {
              "x": 2.826,
              "y": 20.985,
              "z": 0.488
            },
            "gtin": "4009300009894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e983",
            "leftCorner": {
              "x": 2.837,
              "y": 20.984,
              "z": 0.488
            },
            "rightCorner": {
              "x": 2.841,
              "y": 21.049,
              "z": 0.488
            },
            "gtin": "4009300016946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e984",
            "leftCorner": {
              "x": 2.841,
              "y": 21.049,
              "z": 0.488
            },
            "rightCorner": {
              "x": 2.844,
              "y": 21.115,
              "z": 0.488
            },
            "gtin": "4009300016946",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546408",
        "height": 0.99921,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e827",
            "leftCorner": {
              "x": 2.774,
              "y": 19.872,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.778,
              "y": 19.947,
              "z": 0.818
            },
            "gtin": "4009300016953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e828",
            "leftCorner": {
              "x": 2.778,
              "y": 19.947,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.783,
              "y": 20.022,
              "z": 0.818
            },
            "gtin": "4009300016953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e829",
            "leftCorner": {
              "x": 2.781,
              "y": 20.022,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.788,
              "y": 20.161,
              "z": 0.818
            },
            "gtin": "4009300014492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e82a",
            "leftCorner": {
              "x": 2.791,
              "y": 20.159,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.795,
              "y": 20.237,
              "z": 0.818
            },
            "gtin": "4009300014164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e82b",
            "leftCorner": {
              "x": 2.795,
              "y": 20.237,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.799,
              "y": 20.315,
              "z": 0.818
            },
            "gtin": "4009300014164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e82c",
            "leftCorner": {
              "x": 2.8,
              "y": 20.315,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.804,
              "y": 20.387,
              "z": 0.818
            },
            "gtin": "4009300019367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e82d",
            "leftCorner": {
              "x": 2.804,
              "y": 20.387,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.808,
              "y": 20.461,
              "z": 0.818
            },
            "gtin": "4009300019367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e82e",
            "leftCorner": {
              "x": 2.806,
              "y": 20.461,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.811,
              "y": 20.552,
              "z": 0.818
            },
            "gtin": "4009300011934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e82f",
            "leftCorner": {
              "x": 2.811,
              "y": 20.552,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.816,
              "y": 20.642,
              "z": 0.818
            },
            "gtin": "4009300011934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e830",
            "leftCorner": {
              "x": 2.814,
              "y": 20.642,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.818,
              "y": 20.724,
              "z": 0.818
            },
            "gtin": "4009300005162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e831",
            "leftCorner": {
              "x": 2.818,
              "y": 20.724,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.822,
              "y": 20.804,
              "z": 0.818
            },
            "gtin": "4009300005162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e832",
            "leftCorner": {
              "x": 2.841,
              "y": 20.803,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.851,
              "y": 20.984,
              "z": 0.818
            },
            "gtin": "4009300008033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7ed",
            "leftCorner": {
              "x": 2.84,
              "y": 20.984,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.844,
              "y": 21.049,
              "z": 0.818
            },
            "gtin": "4009300011941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7ee",
            "leftCorner": {
              "x": 2.844,
              "y": 21.049,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.847,
              "y": 21.115,
              "z": 0.818
            },
            "gtin": "4009300011941",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41ab4"
  },
  {
    "id": "41ab6",
    "name": "41ab6",
    "x": 1.25,
    "y": 21.231,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9996,
      "w": 0.028166
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 66,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546254",
        "height": 0.16705,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dbd1",
            "leftCorner": {
              "x": 0.82,
              "y": 21.203,
              "z": 0.137
            },
            "rightCorner": {
              "x": 0.43,
              "y": 21.225,
              "z": 0.137
            },
            "gtin": "4063367375828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbd2",
            "leftCorner": {
              "x": 0.43,
              "y": 21.225,
              "z": 0.137
            },
            "rightCorner": {
              "x": 0.039,
              "y": 21.247,
              "z": 0.137
            },
            "gtin": "4063367375828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbd0",
            "leftCorner": {
              "x": 1.211,
              "y": 21.181,
              "z": 0.137
            },
            "rightCorner": {
              "x": 0.82,
              "y": 21.203,
              "z": 0.137
            },
            "gtin": "4063367375828",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546252",
        "height": 0.51002,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dbb2",
            "leftCorner": {
              "x": 1.25,
              "y": 21.226,
              "z": 0.417
            },
            "rightCorner": {
              "x": 1.013,
              "y": 21.24,
              "z": 0.417
            },
            "gtin": "8001480020597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbb3",
            "leftCorner": {
              "x": 1.013,
              "y": 21.24,
              "z": 0.417
            },
            "rightCorner": {
              "x": 0.776,
              "y": 21.253,
              "z": 0.417
            },
            "gtin": "8001480020597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbb4",
            "leftCorner": {
              "x": 0.773,
              "y": 21.215,
              "z": 0.417
            },
            "rightCorner": {
              "x": 0.532,
              "y": 21.229,
              "z": 0.417
            },
            "gtin": "4063367223754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbb5",
            "leftCorner": {
              "x": 0.532,
              "y": 21.229,
              "z": 0.417
            },
            "rightCorner": {
              "x": 0.291,
              "y": 21.242,
              "z": 0.417
            },
            "gtin": "4063367223754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbb6",
            "leftCorner": {
              "x": 0.291,
              "y": 21.242,
              "z": 0.417
            },
            "rightCorner": {
              "x": 0.05,
              "y": 21.256,
              "z": 0.417
            },
            "gtin": "4063367223754",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546251",
        "height": 0.91089,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dba6",
            "leftCorner": {
              "x": 1.25,
              "y": 21.223,
              "z": 0.745
            },
            "rightCorner": {
              "x": 1.197,
              "y": 21.226,
              "z": 0.745
            },
            "gtin": "4012400522309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dba7",
            "leftCorner": {
              "x": 1.197,
              "y": 21.226,
              "z": 0.745
            },
            "rightCorner": {
              "x": 1.145,
              "y": 21.23,
              "z": 0.745
            },
            "gtin": "4012400522309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dba8",
            "leftCorner": {
              "x": 1.145,
              "y": 21.23,
              "z": 0.745
            },
            "rightCorner": {
              "x": 1.092,
              "y": 21.232,
              "z": 0.745
            },
            "gtin": "4012400522309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbab",
            "leftCorner": {
              "x": 1.09,
              "y": 21.189,
              "z": 0.745
            },
            "rightCorner": {
              "x": 1.002,
              "y": 21.194,
              "z": 0.745
            },
            "gtin": "4022142042140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbac",
            "leftCorner": {
              "x": 1.002,
              "y": 21.194,
              "z": 0.745
            },
            "rightCorner": {
              "x": 0.914,
              "y": 21.199,
              "z": 0.745
            },
            "gtin": "4022142042140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbad",
            "leftCorner": {
              "x": 0.914,
              "y": 21.199,
              "z": 0.745
            },
            "rightCorner": {
              "x": 0.831,
              "y": 21.204,
              "z": 0.745
            },
            "gtin": "4062196284943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbae",
            "leftCorner": {
              "x": 0.831,
              "y": 21.204,
              "z": 0.745
            },
            "rightCorner": {
              "x": 0.748,
              "y": 21.208,
              "z": 0.745
            },
            "gtin": "4062196284943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbaf",
            "leftCorner": {
              "x": 0.748,
              "y": 21.212,
              "z": 0.745
            },
            "rightCorner": {
              "x": 0.579,
              "y": 21.222,
              "z": 0.745
            },
            "gtin": "4062196284936",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbb0",
            "leftCorner": {
              "x": 0.579,
              "y": 21.222,
              "z": 0.745
            },
            "rightCorner": {
              "x": 0.409,
              "y": 21.232,
              "z": 0.745
            },
            "gtin": "4062196284936",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbb1",
            "leftCorner": {
              "x": 0.409,
              "y": 21.232,
              "z": 0.745
            },
            "rightCorner": {
              "x": 0.24,
              "y": 21.241,
              "z": 0.745
            },
            "gtin": "4062196284936",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dba9",
            "leftCorner": {
              "x": 0.24,
              "y": 21.246,
              "z": 0.745
            },
            "rightCorner": {
              "x": 0.145,
              "y": 21.252,
              "z": 0.745
            },
            "gtin": "4002448112488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbaa",
            "leftCorner": {
              "x": 0.145,
              "y": 21.252,
              "z": 0.745
            },
            "rightCorner": {
              "x": 0.05,
              "y": 21.257,
              "z": 0.745
            },
            "gtin": "4002448112488",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54624f",
        "height": 1.2633,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1db50",
            "leftCorner": {
              "x": 1.25,
              "y": 21.225,
              "z": 1.034
            },
            "rightCorner": {
              "x": 1.194,
              "y": 21.228,
              "z": 1.034
            },
            "gtin": "4052400017160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db53",
            "leftCorner": {
              "x": 1.192,
              "y": 21.189,
              "z": 1.034
            },
            "rightCorner": {
              "x": 1.141,
              "y": 21.192,
              "z": 1.034
            },
            "gtin": "4052400017085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db54",
            "leftCorner": {
              "x": 1.141,
              "y": 21.194,
              "z": 1.034
            },
            "rightCorner": {
              "x": 1.078,
              "y": 21.198,
              "z": 1.034
            },
            "gtin": "4052400017184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db55",
            "leftCorner": {
              "x": 1.078,
              "y": 21.196,
              "z": 1.034
            },
            "rightCorner": {
              "x": 1.018,
              "y": 21.199,
              "z": 1.034
            },
            "gtin": "4052400017030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db56",
            "leftCorner": {
              "x": 1.018,
              "y": 21.199,
              "z": 1.034
            },
            "rightCorner": {
              "x": 0.958,
              "y": 21.202,
              "z": 1.034
            },
            "gtin": "4052400017030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db57",
            "leftCorner": {
              "x": 0.957,
              "y": 21.198,
              "z": 1.034
            },
            "rightCorner": {
              "x": 0.892,
              "y": 21.201,
              "z": 1.034
            },
            "gtin": "4052400017016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db58",
            "leftCorner": {
              "x": 0.892,
              "y": 21.208,
              "z": 1.034
            },
            "rightCorner": {
              "x": 0.84,
              "y": 21.211,
              "z": 1.034
            },
            "gtin": "4052400017306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db59",
            "leftCorner": {
              "x": 0.841,
              "y": 21.216,
              "z": 1.034
            },
            "rightCorner": {
              "x": 0.755,
              "y": 21.221,
              "z": 1.034
            },
            "gtin": "4052400018099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db5a",
            "leftCorner": {
              "x": 0.755,
              "y": 21.224,
              "z": 1.034
            },
            "rightCorner": {
              "x": 0.7,
              "y": 21.228,
              "z": 1.034
            },
            "gtin": "4008455004129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db5b",
            "leftCorner": {
              "x": 0.7,
              "y": 21.228,
              "z": 1.034
            },
            "rightCorner": {
              "x": 0.645,
              "y": 21.231,
              "z": 1.034
            },
            "gtin": "4008455004129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db5c",
            "leftCorner": {
              "x": 0.644,
              "y": 21.218,
              "z": 1.034
            },
            "rightCorner": {
              "x": 0.597,
              "y": 21.22,
              "z": 1.034
            },
            "gtin": "4008455004068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db5d",
            "leftCorner": {
              "x": 0.597,
              "y": 21.22,
              "z": 1.034
            },
            "rightCorner": {
              "x": 0.536,
              "y": 21.223,
              "z": 1.034
            },
            "gtin": "4008455004075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db5e",
            "leftCorner": {
              "x": 0.536,
              "y": 21.224,
              "z": 1.034
            },
            "rightCorner": {
              "x": 0.495,
              "y": 21.227,
              "z": 1.034
            },
            "gtin": "4008455004099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db5f",
            "leftCorner": {
              "x": 0.495,
              "y": 21.243,
              "z": 1.034
            },
            "rightCorner": {
              "x": 0.447,
              "y": 21.246,
              "z": 1.034
            },
            "gtin": "4008455004082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db60",
            "leftCorner": {
              "x": 0.447,
              "y": 21.246,
              "z": 1.034
            },
            "rightCorner": {
              "x": 0.399,
              "y": 21.248,
              "z": 1.034
            },
            "gtin": "4008455004082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db61",
            "leftCorner": {
              "x": 0.399,
              "y": 21.248,
              "z": 1.034
            },
            "rightCorner": {
              "x": 0.35,
              "y": 21.251,
              "z": 1.034
            },
            "gtin": "4008455004082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db62",
            "leftCorner": {
              "x": 0.349,
              "y": 21.232,
              "z": 1.034
            },
            "rightCorner": {
              "x": 0.304,
              "y": 21.234,
              "z": 1.034
            },
            "gtin": "4008455004266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db63",
            "leftCorner": {
              "x": 0.304,
              "y": 21.234,
              "z": 1.034
            },
            "rightCorner": {
              "x": 0.258,
              "y": 21.237,
              "z": 1.034
            },
            "gtin": "4008455004266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db64",
            "leftCorner": {
              "x": 0.258,
              "y": 21.237,
              "z": 1.034
            },
            "rightCorner": {
              "x": 0.212,
              "y": 21.239,
              "z": 1.034
            },
            "gtin": "4008455004266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db65",
            "leftCorner": {
              "x": 0.213,
              "y": 21.255,
              "z": 1.034
            },
            "rightCorner": {
              "x": 0.161,
              "y": 21.259,
              "z": 1.034
            },
            "gtin": "4008455004037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db51",
            "leftCorner": {
              "x": 0.16,
              "y": 21.246,
              "z": 1.034
            },
            "rightCorner": {
              "x": 0.105,
              "y": 21.249,
              "z": 1.034
            },
            "gtin": "4008455004013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db52",
            "leftCorner": {
              "x": 0.105,
              "y": 21.249,
              "z": 1.034
            },
            "rightCorner": {
              "x": 0.049,
              "y": 21.253,
              "z": 1.034
            },
            "gtin": "4008455004013",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546253",
        "height": 1.4635,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dbb7",
            "leftCorner": {
              "x": 1.25,
              "y": 21.238,
              "z": 1.197
            },
            "rightCorner": {
              "x": 1.174,
              "y": 21.241,
              "z": 1.197
            },
            "gtin": "4062196272506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbb8",
            "leftCorner": {
              "x": 1.174,
              "y": 21.241,
              "z": 1.197
            },
            "rightCorner": {
              "x": 1.097,
              "y": 21.246,
              "z": 1.197
            },
            "gtin": "4062196272506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbba",
            "leftCorner": {
              "x": 1.095,
              "y": 21.201,
              "z": 1.197
            },
            "rightCorner": {
              "x": 1.012,
              "y": 21.206,
              "z": 1.197
            },
            "gtin": "4052400018099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbbb",
            "leftCorner": {
              "x": 1.012,
              "y": 21.206,
              "z": 1.197
            },
            "rightCorner": {
              "x": 0.929,
              "y": 21.21,
              "z": 1.197
            },
            "gtin": "4052400018099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbbc",
            "leftCorner": {
              "x": 0.929,
              "y": 21.203,
              "z": 1.197
            },
            "rightCorner": {
              "x": 0.837,
              "y": 21.208,
              "z": 1.197
            },
            "gtin": "4062196272520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbbd",
            "leftCorner": {
              "x": 0.837,
              "y": 21.218,
              "z": 1.197
            },
            "rightCorner": {
              "x": 0.768,
              "y": 21.223,
              "z": 1.197
            },
            "gtin": "4052400018082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbbe",
            "leftCorner": {
              "x": 0.768,
              "y": 21.223,
              "z": 1.197
            },
            "rightCorner": {
              "x": 0.699,
              "y": 21.227,
              "z": 1.197
            },
            "gtin": "4052400018082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbbf",
            "leftCorner": {
              "x": 0.7,
              "y": 21.241,
              "z": 1.197
            },
            "rightCorner": {
              "x": 0.613,
              "y": 21.246,
              "z": 1.197
            },
            "gtin": "4052400018174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbc0",
            "leftCorner": {
              "x": 0.613,
              "y": 21.246,
              "z": 1.197
            },
            "rightCorner": {
              "x": 0.526,
              "y": 21.25,
              "z": 1.197
            },
            "gtin": "4052400018174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbc1",
            "leftCorner": {
              "x": 0.526,
              "y": 21.247,
              "z": 1.197
            },
            "rightCorner": {
              "x": 0.443,
              "y": 21.252,
              "z": 1.197
            },
            "gtin": "4052400018167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbc2",
            "leftCorner": {
              "x": 0.443,
              "y": 21.252,
              "z": 1.197
            },
            "rightCorner": {
              "x": 0.36,
              "y": 21.257,
              "z": 1.197
            },
            "gtin": "4052400018167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbc3",
            "leftCorner": {
              "x": 0.36,
              "y": 21.256,
              "z": 1.197
            },
            "rightCorner": {
              "x": 0.257,
              "y": 21.261,
              "z": 1.197
            },
            "gtin": "4052400018181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbc4",
            "leftCorner": {
              "x": 0.257,
              "y": 21.261,
              "z": 1.197
            },
            "rightCorner": {
              "x": 0.154,
              "y": 21.267,
              "z": 1.197
            },
            "gtin": "4052400018181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbb9",
            "leftCorner": {
              "x": 0.153,
              "y": 21.26,
              "z": 1.197
            },
            "rightCorner": {
              "x": 0.05,
              "y": 21.266,
              "z": 1.197
            },
            "gtin": "4052400025127",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546250",
        "height": 1.7161,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1db71",
            "leftCorner": {
              "x": 1.257,
              "y": 21.202,
              "z": 1.404
            },
            "rightCorner": {
              "x": 1.078,
              "y": 21.212,
              "z": 1.404
            },
            "gtin": "4002448034605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db72",
            "leftCorner": {
              "x": 1.077,
              "y": 21.193,
              "z": 1.404
            },
            "rightCorner": {
              "x": 0.982,
              "y": 21.198,
              "z": 1.404
            },
            "gtin": "4022142405013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db73",
            "leftCorner": {
              "x": 0.982,
              "y": 21.198,
              "z": 1.404
            },
            "rightCorner": {
              "x": 0.886,
              "y": 21.203,
              "z": 1.404
            },
            "gtin": "4022142405013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db74",
            "leftCorner": {
              "x": 0.887,
              "y": 21.206,
              "z": 1.404
            },
            "rightCorner": {
              "x": 0.738,
              "y": 21.215,
              "z": 1.404
            },
            "gtin": "4002448027102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db75",
            "leftCorner": {
              "x": 0.738,
              "y": 21.215,
              "z": 1.404
            },
            "rightCorner": {
              "x": 0.59,
              "y": 21.224,
              "z": 1.404
            },
            "gtin": "4002448027102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db76",
            "leftCorner": {
              "x": 0.59,
              "y": 21.227,
              "z": 1.404
            },
            "rightCorner": {
              "x": 0.417,
              "y": 21.236,
              "z": 1.404
            },
            "gtin": "8001480026209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db77",
            "leftCorner": {
              "x": 0.418,
              "y": 21.243,
              "z": 1.404
            },
            "rightCorner": {
              "x": 0.307,
              "y": 21.249,
              "z": 1.404
            },
            "gtin": "4022142042140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db78",
            "leftCorner": {
              "x": 0.307,
              "y": 21.249,
              "z": 1.404
            },
            "rightCorner": {
              "x": 0.195,
              "y": 21.256,
              "z": 1.404
            },
            "gtin": "4022142042140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db79",
            "leftCorner": {
              "x": 0.195,
              "y": 21.247,
              "z": 1.404
            },
            "rightCorner": {
              "x": 0.098,
              "y": 21.253,
              "z": 1.404
            },
            "gtin": "4002448034544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db7a",
            "leftCorner": {
              "x": 0.098,
              "y": 21.253,
              "z": 1.404
            },
            "rightCorner": {
              "x": 0.001,
              "y": 21.258,
              "z": 1.404
            },
            "gtin": "4002448034544",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "edec0",
    "rightNeighborShelfId": "41ab7"
  },
  {
    "id": "41ab7",
    "name": "41ab7",
    "x": 0.052,
    "y": 21.299,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9996,
      "w": 0.028166
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 23
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546422",
        "height": 0.16437,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a546421",
        "height": 0.61353,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a546425",
        "height": 1.0571,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1eda2",
            "leftCorner": {
              "x": 0.052,
              "y": 21.299,
              "z": 0.865
            },
            "rightCorner": {
              "x": -0.246,
              "y": 21.316,
              "z": 0.865
            },
            "gtin": "4000270167713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eda4",
            "leftCorner": {
              "x": -0.248,
              "y": 21.276,
              "z": 0.865
            },
            "rightCorner": {
              "x": -0.336,
              "y": 21.28,
              "z": 0.865
            },
            "gtin": "4335896638003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eda5",
            "leftCorner": {
              "x": -0.336,
              "y": 21.28,
              "z": 0.865
            },
            "rightCorner": {
              "x": -0.423,
              "y": 21.285,
              "z": 0.865
            },
            "gtin": "4335896638003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eda6",
            "leftCorner": {
              "x": -0.423,
              "y": 21.278,
              "z": 0.865
            },
            "rightCorner": {
              "x": -0.489,
              "y": 21.282,
              "z": 0.865
            },
            "gtin": "4013356248312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eda7",
            "leftCorner": {
              "x": -0.489,
              "y": 21.282,
              "z": 0.865
            },
            "rightCorner": {
              "x": -0.554,
              "y": 21.285,
              "z": 0.865
            },
            "gtin": "4013356248312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eda8",
            "leftCorner": {
              "x": -0.554,
              "y": 21.294,
              "z": 0.865
            },
            "rightCorner": {
              "x": -0.828,
              "y": 21.31,
              "z": 0.865
            },
            "gtin": "4300175298452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eda9",
            "leftCorner": {
              "x": -0.828,
              "y": 21.31,
              "z": 0.865
            },
            "rightCorner": {
              "x": -1.101,
              "y": 21.325,
              "z": 0.865
            },
            "gtin": "4300175298452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edaa",
            "leftCorner": {
              "x": -1.101,
              "y": 21.325,
              "z": 0.865
            },
            "rightCorner": {
              "x": -1.375,
              "y": 21.341,
              "z": 0.865
            },
            "gtin": "4300175298452",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546423",
        "height": 1.4108,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ed88",
            "leftCorner": {
              "x": 0.052,
              "y": 21.305,
              "z": 1.154
            },
            "rightCorner": {
              "x": -0.258,
              "y": 21.323,
              "z": 1.154
            },
            "gtin": "4026700521559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed89",
            "leftCorner": {
              "x": -0.258,
              "y": 21.323,
              "z": 1.154
            },
            "rightCorner": {
              "x": -0.567,
              "y": 21.34,
              "z": 1.154
            },
            "gtin": "4026700521559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed8c",
            "leftCorner": {
              "x": -0.569,
              "y": 21.318,
              "z": 1.154
            },
            "rightCorner": {
              "x": -0.741,
              "y": 21.327,
              "z": 1.154
            },
            "gtin": "4026700531558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed8d",
            "leftCorner": {
              "x": -0.743,
              "y": 21.307,
              "z": 1.154
            },
            "rightCorner": {
              "x": -0.878,
              "y": 21.315,
              "z": 1.154
            },
            "gtin": "4026700471359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed8e",
            "leftCorner": {
              "x": -0.878,
              "y": 21.315,
              "z": 1.154
            },
            "rightCorner": {
              "x": -1.014,
              "y": 21.322,
              "z": 1.154
            },
            "gtin": "4026700471359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed8f",
            "leftCorner": {
              "x": -1.014,
              "y": 21.322,
              "z": 1.154
            },
            "rightCorner": {
              "x": -1.15,
              "y": 21.33,
              "z": 1.154
            },
            "gtin": "4026700471359",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546424",
        "height": 1.7097,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1db7b",
            "leftCorner": {
              "x": 0.002,
              "y": 21.267,
              "z": 1.399
            },
            "rightCorner": {
              "x": -0.142,
              "y": 21.275,
              "z": 1.399
            },
            "gtin": "4012400520503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db7c",
            "leftCorner": {
              "x": -0.142,
              "y": 21.275,
              "z": 1.399
            },
            "rightCorner": {
              "x": -0.285,
              "y": 21.283,
              "z": 1.399
            },
            "gtin": "4012400520503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db7d",
            "leftCorner": {
              "x": -0.286,
              "y": 21.279,
              "z": 1.399
            },
            "rightCorner": {
              "x": -0.471,
              "y": 21.29,
              "z": 1.399
            },
            "gtin": "4015000971881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db7e",
            "leftCorner": {
              "x": -0.471,
              "y": 21.29,
              "z": 1.399
            },
            "rightCorner": {
              "x": -0.655,
              "y": 21.3,
              "z": 1.399
            },
            "gtin": "4015000971881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db7f",
            "leftCorner": {
              "x": -0.655,
              "y": 21.303,
              "z": 1.399
            },
            "rightCorner": {
              "x": -0.903,
              "y": 21.317,
              "z": 1.399
            },
            "gtin": "4026700521559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db80",
            "leftCorner": {
              "x": -0.904,
              "y": 21.314,
              "z": 1.399
            },
            "rightCorner": {
              "x": -0.985,
              "y": 21.319,
              "z": 1.399
            },
            "gtin": "4026700531657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db81",
            "leftCorner": {
              "x": -0.985,
              "y": 21.319,
              "z": 1.399
            },
            "rightCorner": {
              "x": -1.067,
              "y": 21.323,
              "z": 1.399
            },
            "gtin": "4026700531657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db82",
            "leftCorner": {
              "x": -1.067,
              "y": 21.323,
              "z": 1.399
            },
            "rightCorner": {
              "x": -1.119,
              "y": 21.326,
              "z": 1.399
            },
            "gtin": "4026700470857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db83",
            "leftCorner": {
              "x": -1.119,
              "y": 21.326,
              "z": 1.399
            },
            "rightCorner": {
              "x": -1.17,
              "y": 21.329,
              "z": 1.399
            },
            "gtin": "4026700470857",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41ab6",
    "rightNeighborShelfId": "41ab8"
  },
  {
    "id": "41ab8",
    "name": "41ab8",
    "x": -1.146,
    "y": 21.366,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9996,
      "w": 0.028166
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 44,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546429",
        "height": 0.15945,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dbd8",
            "leftCorner": {
              "x": -2.092,
              "y": 21.366,
              "z": 0.13
            },
            "rightCorner": {
              "x": -2.24,
              "y": 21.374,
              "z": 0.13
            },
            "gtin": "4337185392641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbd3",
            "leftCorner": {
              "x": -1.165,
              "y": 21.316,
              "z": 0.13
            },
            "rightCorner": {
              "x": -1.407,
              "y": 21.33,
              "z": 0.13
            },
            "gtin": "4251758410627",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c855ed67a01d9a1dbd4",
            "leftCorner": {
              "x": -1.407,
              "y": 21.325,
              "z": 0.13
            },
            "rightCorner": {
              "x": -1.586,
              "y": 21.334,
              "z": 0.13
            },
            "gtin": "4251758410542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbd5",
            "leftCorner": {
              "x": -1.586,
              "y": 21.334,
              "z": 0.13
            },
            "rightCorner": {
              "x": -1.765,
              "y": 21.345,
              "z": 0.13
            },
            "gtin": "4251758410542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbd6",
            "leftCorner": {
              "x": -1.765,
              "y": 21.345,
              "z": 0.13
            },
            "rightCorner": {
              "x": -1.945,
              "y": 21.355,
              "z": 0.13
            },
            "gtin": "4251758410542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbd7",
            "leftCorner": {
              "x": -1.945,
              "y": 21.357,
              "z": 0.13
            },
            "rightCorner": {
              "x": -2.092,
              "y": 21.366,
              "z": 0.13
            },
            "gtin": "4337185392641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbd9",
            "leftCorner": {
              "x": -2.24,
              "y": 21.374,
              "z": 0.13
            },
            "rightCorner": {
              "x": -2.388,
              "y": 21.381,
              "z": 0.13
            },
            "gtin": "4337185392641",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546427",
        "height": 0.60985,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ed76",
            "leftCorner": {
              "x": -1.177,
              "y": 21.316,
              "z": 0.499
            },
            "rightCorner": {
              "x": -1.36,
              "y": 21.327,
              "z": 0.499
            },
            "gtin": "4063367442742",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed77",
            "leftCorner": {
              "x": -1.36,
              "y": 21.327,
              "z": 0.499
            },
            "rightCorner": {
              "x": -1.543,
              "y": 21.336,
              "z": 0.499
            },
            "gtin": "4063367442742",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed78",
            "leftCorner": {
              "x": -1.543,
              "y": 21.333,
              "z": 0.499
            },
            "rightCorner": {
              "x": -1.652,
              "y": 21.339,
              "z": 0.499
            },
            "gtin": "4251758410849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed79",
            "leftCorner": {
              "x": -1.652,
              "y": 21.339,
              "z": 0.499
            },
            "rightCorner": {
              "x": -1.761,
              "y": 21.346,
              "z": 0.499
            },
            "gtin": "4251758410849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed7a",
            "leftCorner": {
              "x": -1.761,
              "y": 21.35,
              "z": 0.499
            },
            "rightCorner": {
              "x": -1.958,
              "y": 21.362,
              "z": 0.499
            },
            "gtin": "4251758424006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed7b",
            "leftCorner": {
              "x": -1.959,
              "y": 21.355,
              "z": 0.499
            },
            "rightCorner": {
              "x": -2.173,
              "y": 21.367,
              "z": 0.499
            },
            "gtin": "4012400500987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed7c",
            "leftCorner": {
              "x": -2.173,
              "y": 21.367,
              "z": 0.499
            },
            "rightCorner": {
              "x": -2.387,
              "y": 21.378,
              "z": 0.499
            },
            "gtin": "4012400500987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed7d",
            "leftCorner": {
              "x": -2.387,
              "y": 21.378,
              "z": 0.499
            },
            "rightCorner": {
              "x": -2.601,
              "y": 21.39,
              "z": 0.499
            },
            "gtin": "4012400500987",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54642a",
        "height": 1.0532,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1edab",
            "leftCorner": {
              "x": -1.375,
              "y": 21.34,
              "z": 0.862
            },
            "rightCorner": {
              "x": -1.538,
              "y": 21.349,
              "z": 0.862
            },
            "gtin": "4251758424075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edac",
            "leftCorner": {
              "x": -1.538,
              "y": 21.353,
              "z": 0.862
            },
            "rightCorner": {
              "x": -1.633,
              "y": 21.359,
              "z": 0.862
            },
            "gtin": "4251758410962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edad",
            "leftCorner": {
              "x": -1.633,
              "y": 21.359,
              "z": 0.862
            },
            "rightCorner": {
              "x": -1.728,
              "y": 21.364,
              "z": 0.862
            },
            "gtin": "4251758410962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edae",
            "leftCorner": {
              "x": -1.729,
              "y": 21.354,
              "z": 0.862
            },
            "rightCorner": {
              "x": -1.936,
              "y": 21.366,
              "z": 0.862
            },
            "gtin": "4251758411167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edaf",
            "leftCorner": {
              "x": -1.935,
              "y": 21.371,
              "z": 0.862
            },
            "rightCorner": {
              "x": -2.098,
              "y": 21.38,
              "z": 0.862
            },
            "gtin": "4251758410849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edb0",
            "leftCorner": {
              "x": -2.098,
              "y": 21.38,
              "z": 0.862
            },
            "rightCorner": {
              "x": -2.261,
              "y": 21.39,
              "z": 0.862
            },
            "gtin": "4251758410849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eda3",
            "leftCorner": {
              "x": -2.261,
              "y": 21.387,
              "z": 0.862
            },
            "rightCorner": {
              "x": -2.346,
              "y": 21.391,
              "z": 0.862
            },
            "gtin": "4251758410467",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546426",
        "height": 1.4053,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ed90",
            "leftCorner": {
              "x": -1.15,
              "y": 21.333,
              "z": 1.15
            },
            "rightCorner": {
              "x": -1.337,
              "y": 21.344,
              "z": 1.15
            },
            "gtin": "4251758424006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed91",
            "leftCorner": {
              "x": -1.337,
              "y": 21.344,
              "z": 1.15
            },
            "rightCorner": {
              "x": -1.524,
              "y": 21.354,
              "z": 1.15
            },
            "gtin": "4251758424006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed92",
            "leftCorner": {
              "x": -1.524,
              "y": 21.354,
              "z": 1.15
            },
            "rightCorner": {
              "x": -1.712,
              "y": 21.365,
              "z": 1.15
            },
            "gtin": "4251758424006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed93",
            "leftCorner": {
              "x": -1.712,
              "y": 21.352,
              "z": 1.15
            },
            "rightCorner": {
              "x": -2.04,
              "y": 21.371,
              "z": 1.15
            },
            "gtin": "4251758410986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed94",
            "leftCorner": {
              "x": -2.04,
              "y": 21.371,
              "z": 1.15
            },
            "rightCorner": {
              "x": -2.368,
              "y": 21.389,
              "z": 1.15
            },
            "gtin": "4251758410986",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546428",
        "height": 1.7097,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1db84",
            "leftCorner": {
              "x": -1.17,
              "y": 21.327,
              "z": 1.399
            },
            "rightCorner": {
              "x": -1.227,
              "y": 21.33,
              "z": 1.399
            },
            "gtin": "4063367376566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db85",
            "leftCorner": {
              "x": -1.227,
              "y": 21.33,
              "z": 1.399
            },
            "rightCorner": {
              "x": -1.284,
              "y": 21.333,
              "z": 1.399
            },
            "gtin": "4063367376566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db86",
            "leftCorner": {
              "x": -1.284,
              "y": 21.34,
              "z": 1.399
            },
            "rightCorner": {
              "x": -1.37,
              "y": 21.345,
              "z": 1.399
            },
            "gtin": "4001499939891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db87",
            "leftCorner": {
              "x": -1.37,
              "y": 21.353,
              "z": 1.399
            },
            "rightCorner": {
              "x": -1.434,
              "y": 21.357,
              "z": 1.399
            },
            "gtin": "4008455047614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db88",
            "leftCorner": {
              "x": -1.434,
              "y": 21.357,
              "z": 1.399
            },
            "rightCorner": {
              "x": -1.499,
              "y": 21.361,
              "z": 1.399
            },
            "gtin": "4008455047614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db89",
            "leftCorner": {
              "x": -1.499,
              "y": 21.361,
              "z": 1.399
            },
            "rightCorner": {
              "x": -1.563,
              "y": 21.364,
              "z": 1.399
            },
            "gtin": "4008455047614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db8a",
            "leftCorner": {
              "x": -1.564,
              "y": 21.351,
              "z": 1.399
            },
            "rightCorner": {
              "x": -1.671,
              "y": 21.357,
              "z": 1.399
            },
            "gtin": "4008455087818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db8b",
            "leftCorner": {
              "x": -1.671,
              "y": 21.357,
              "z": 1.399
            },
            "rightCorner": {
              "x": -1.727,
              "y": 21.36,
              "z": 1.399
            },
            "gtin": "4008455049113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db8c",
            "leftCorner": {
              "x": -1.727,
              "y": 21.36,
              "z": 1.399
            },
            "rightCorner": {
              "x": -1.783,
              "y": 21.363,
              "z": 1.399
            },
            "gtin": "4008455049113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db8d",
            "leftCorner": {
              "x": -1.784,
              "y": 21.354,
              "z": 1.399
            },
            "rightCorner": {
              "x": -1.834,
              "y": 21.357,
              "z": 1.399
            },
            "gtin": "4002448084945",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db8e",
            "leftCorner": {
              "x": -1.834,
              "y": 21.357,
              "z": 1.399
            },
            "rightCorner": {
              "x": -1.885,
              "y": 21.36,
              "z": 1.399
            },
            "gtin": "4002448084945",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db8f",
            "leftCorner": {
              "x": -1.885,
              "y": 21.36,
              "z": 1.399
            },
            "rightCorner": {
              "x": -1.936,
              "y": 21.363,
              "z": 1.399
            },
            "gtin": "4002448084945",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db90",
            "leftCorner": {
              "x": -1.936,
              "y": 21.363,
              "z": 1.399
            },
            "rightCorner": {
              "x": -1.986,
              "y": 21.366,
              "z": 1.399
            },
            "gtin": "4002448084945",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db91",
            "leftCorner": {
              "x": -1.986,
              "y": 21.366,
              "z": 1.399
            },
            "rightCorner": {
              "x": -2.037,
              "y": 21.369,
              "z": 1.399
            },
            "gtin": "4002448084945",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db92",
            "leftCorner": {
              "x": -2.037,
              "y": 21.374,
              "z": 1.399
            },
            "rightCorner": {
              "x": -2.123,
              "y": 21.379,
              "z": 1.399
            },
            "gtin": "4013162004027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db93",
            "leftCorner": {
              "x": -2.123,
              "y": 21.379,
              "z": 1.399
            },
            "rightCorner": {
              "x": -2.21,
              "y": 21.384,
              "z": 1.399
            },
            "gtin": "4013162004027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db94",
            "leftCorner": {
              "x": -2.21,
              "y": 21.384,
              "z": 1.399
            },
            "rightCorner": {
              "x": -2.297,
              "y": 21.389,
              "z": 1.399
            },
            "gtin": "4013162004027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db95",
            "leftCorner": {
              "x": -2.297,
              "y": 21.389,
              "z": 1.399
            },
            "rightCorner": {
              "x": -2.383,
              "y": 21.393,
              "z": 1.399
            },
            "gtin": "4013162004027",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41ab7",
    "rightNeighborShelfId": "41ab9"
  },
  {
    "id": "41ab9",
    "name": "41ab9",
    "x": -2.344,
    "y": 21.434,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9996,
      "w": 0.028166
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 34,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54642d",
        "height": 0.16334,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dbda",
            "leftCorner": {
              "x": -2.388,
              "y": 21.378,
              "z": 0.134
            },
            "rightCorner": {
              "x": -2.626,
              "y": 21.393,
              "z": 0.134
            },
            "gtin": "4262429770032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbdb",
            "leftCorner": {
              "x": -2.626,
              "y": 21.393,
              "z": 0.134
            },
            "rightCorner": {
              "x": -2.864,
              "y": 21.406,
              "z": 0.134
            },
            "gtin": "4262429770032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbdc",
            "leftCorner": {
              "x": -2.864,
              "y": 21.406,
              "z": 0.134
            },
            "rightCorner": {
              "x": -3.102,
              "y": 21.419,
              "z": 0.134
            },
            "gtin": "4262429770032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbdd",
            "leftCorner": {
              "x": -3.102,
              "y": 21.418,
              "z": 0.134
            },
            "rightCorner": {
              "x": -3.252,
              "y": 21.427,
              "z": 0.134
            },
            "gtin": "4262429770025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbde",
            "leftCorner": {
              "x": -3.252,
              "y": 21.427,
              "z": 0.134
            },
            "rightCorner": {
              "x": -3.401,
              "y": 21.435,
              "z": 0.134
            },
            "gtin": "4262429770025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbdf",
            "leftCorner": {
              "x": -3.401,
              "y": 21.435,
              "z": 0.134
            },
            "rightCorner": {
              "x": -3.551,
              "y": 21.443,
              "z": 0.134
            },
            "gtin": "4262429770025",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54642f",
        "height": 0.61008,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ed7e",
            "leftCorner": {
              "x": -2.601,
              "y": 21.392,
              "z": 0.499
            },
            "rightCorner": {
              "x": -3.068,
              "y": 21.418,
              "z": 0.499
            },
            "gtin": "4012400500925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed7f",
            "leftCorner": {
              "x": -3.068,
              "y": 21.418,
              "z": 0.499
            },
            "rightCorner": {
              "x": -3.536,
              "y": 21.445,
              "z": 0.499
            },
            "gtin": "4012400500925",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54642c",
        "height": 1.0633,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1edb1",
            "leftCorner": {
              "x": -2.344,
              "y": 21.426,
              "z": 0.87
            },
            "rightCorner": {
              "x": -2.543,
              "y": 21.437,
              "z": 0.87
            },
            "gtin": "4001499969423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edb5",
            "leftCorner": {
              "x": -2.545,
              "y": 21.401,
              "z": 0.87
            },
            "rightCorner": {
              "x": -2.71,
              "y": 21.411,
              "z": 0.87
            },
            "gtin": "4001499969409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edb6",
            "leftCorner": {
              "x": -2.71,
              "y": 21.405,
              "z": 0.87
            },
            "rightCorner": {
              "x": -2.872,
              "y": 21.413,
              "z": 0.87
            },
            "gtin": "4001499969393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edb7",
            "leftCorner": {
              "x": -2.872,
              "y": 21.415,
              "z": 0.87
            },
            "rightCorner": {
              "x": -2.907,
              "y": 21.418,
              "z": 0.87
            },
            "gtin": "4001499969416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edb8",
            "leftCorner": {
              "x": -2.907,
              "y": 21.418,
              "z": 0.87
            },
            "rightCorner": {
              "x": -2.942,
              "y": 21.42,
              "z": 0.87
            },
            "gtin": "4001499969416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edb9",
            "leftCorner": {
              "x": -2.942,
              "y": 21.419,
              "z": 0.87
            },
            "rightCorner": {
              "x": -3.054,
              "y": 21.425,
              "z": 0.87
            },
            "gtin": "4001499966620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edba",
            "leftCorner": {
              "x": -3.054,
              "y": 21.421,
              "z": 0.87
            },
            "rightCorner": {
              "x": -3.18,
              "y": 21.428,
              "z": 0.87
            },
            "gtin": "4001499966637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edbb",
            "leftCorner": {
              "x": -3.18,
              "y": 21.433,
              "z": 0.87
            },
            "rightCorner": {
              "x": -3.362,
              "y": 21.444,
              "z": 0.87
            },
            "gtin": "4012400528103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edbc",
            "leftCorner": {
              "x": -3.362,
              "y": 21.444,
              "z": 0.87
            },
            "rightCorner": {
              "x": -3.543,
              "y": 21.454,
              "z": 0.87
            },
            "gtin": "4012400528103",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54642b",
        "height": 1.4047,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ed95",
            "leftCorner": {
              "x": -2.368,
              "y": 21.391,
              "z": 1.149
            },
            "rightCorner": {
              "x": -2.462,
              "y": 21.396,
              "z": 1.149
            },
            "gtin": "4001499969522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed96",
            "leftCorner": {
              "x": -2.462,
              "y": 21.396,
              "z": 1.149
            },
            "rightCorner": {
              "x": -2.557,
              "y": 21.401,
              "z": 1.149
            },
            "gtin": "4001499969522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed97",
            "leftCorner": {
              "x": -2.557,
              "y": 21.401,
              "z": 1.149
            },
            "rightCorner": {
              "x": -2.652,
              "y": 21.407,
              "z": 1.149
            },
            "gtin": "4001499969522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed98",
            "leftCorner": {
              "x": -2.652,
              "y": 21.395,
              "z": 1.149
            },
            "rightCorner": {
              "x": -2.75,
              "y": 21.4,
              "z": 1.149
            },
            "gtin": "4001499969508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed99",
            "leftCorner": {
              "x": -2.75,
              "y": 21.4,
              "z": 1.149
            },
            "rightCorner": {
              "x": -2.847,
              "y": 21.406,
              "z": 1.149
            },
            "gtin": "4001499969508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed9a",
            "leftCorner": {
              "x": -2.847,
              "y": 21.406,
              "z": 1.149
            },
            "rightCorner": {
              "x": -2.945,
              "y": 21.411,
              "z": 1.149
            },
            "gtin": "4001499969508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed9b",
            "leftCorner": {
              "x": -2.944,
              "y": 21.425,
              "z": 1.149
            },
            "rightCorner": {
              "x": -3.136,
              "y": 21.437,
              "z": 1.149
            },
            "gtin": "4001499966651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed9c",
            "leftCorner": {
              "x": -3.136,
              "y": 21.436,
              "z": 1.149
            },
            "rightCorner": {
              "x": -3.283,
              "y": 21.444,
              "z": 1.149
            },
            "gtin": "4001499966644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed9d",
            "leftCorner": {
              "x": -3.283,
              "y": 21.444,
              "z": 1.149
            },
            "rightCorner": {
              "x": -3.431,
              "y": 21.453,
              "z": 1.149
            },
            "gtin": "4001499966644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed9e",
            "leftCorner": {
              "x": -3.431,
              "y": 21.453,
              "z": 1.149
            },
            "rightCorner": {
              "x": -3.578,
              "y": 21.461,
              "z": 1.149
            },
            "gtin": "4001499966644",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54642e",
        "height": 1.7049,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1db96",
            "leftCorner": {
              "x": -2.383,
              "y": 21.397,
              "z": 1.395
            },
            "rightCorner": {
              "x": -2.543,
              "y": 21.407,
              "z": 1.395
            },
            "gtin": "4337185511226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db97",
            "leftCorner": {
              "x": -2.543,
              "y": 21.407,
              "z": 1.395
            },
            "rightCorner": {
              "x": -2.703,
              "y": 21.416,
              "z": 1.395
            },
            "gtin": "4337185511226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db98",
            "leftCorner": {
              "x": -2.703,
              "y": 21.419,
              "z": 1.395
            },
            "rightCorner": {
              "x": -2.966,
              "y": 21.434,
              "z": 1.395
            },
            "gtin": "4337185345432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db99",
            "leftCorner": {
              "x": -2.966,
              "y": 21.434,
              "z": 1.395
            },
            "rightCorner": {
              "x": -3.228,
              "y": 21.449,
              "z": 1.395
            },
            "gtin": "4337185345432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db9a",
            "leftCorner": {
              "x": -3.226,
              "y": 21.486,
              "z": 1.395
            },
            "rightCorner": {
              "x": -3.334,
              "y": 21.492,
              "z": 1.395
            },
            "gtin": "4063367304248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db9b",
            "leftCorner": {
              "x": -3.334,
              "y": 21.492,
              "z": 1.395
            },
            "rightCorner": {
              "x": -3.442,
              "y": 21.497,
              "z": 1.395
            },
            "gtin": "4063367304248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db9c",
            "leftCorner": {
              "x": -3.442,
              "y": 21.497,
              "z": 1.395
            },
            "rightCorner": {
              "x": -3.55,
              "y": 21.504,
              "z": 1.395
            },
            "gtin": "4063367304248",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41ab8",
    "rightNeighborShelfId": "41aba"
  },
  {
    "id": "41aba",
    "name": "41aba",
    "x": -3.542,
    "y": 21.501,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9996,
      "w": 0.028166
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 38,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54643a",
        "height": 0.16309,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dbe0",
            "leftCorner": {
              "x": -3.55,
              "y": 21.455,
              "z": 0.133
            },
            "rightCorner": {
              "x": -3.742,
              "y": 21.466,
              "z": 0.133
            },
            "gtin": "4012400529254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbe1",
            "leftCorner": {
              "x": -3.742,
              "y": 21.466,
              "z": 0.133
            },
            "rightCorner": {
              "x": -3.933,
              "y": 21.477,
              "z": 0.133
            },
            "gtin": "4012400529254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbe2",
            "leftCorner": {
              "x": -3.932,
              "y": 21.495,
              "z": 0.133
            },
            "rightCorner": {
              "x": -4.151,
              "y": 21.507,
              "z": 0.133
            },
            "gtin": "4012400529278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbc7",
            "leftCorner": {
              "x": -4.152,
              "y": 21.483,
              "z": 0.133
            },
            "rightCorner": {
              "x": -4.448,
              "y": 21.499,
              "z": 0.133
            },
            "gtin": "8720181546549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbc8",
            "leftCorner": {
              "x": -4.448,
              "y": 21.499,
              "z": 0.133
            },
            "rightCorner": {
              "x": -4.743,
              "y": 21.517,
              "z": 0.133
            },
            "gtin": "8720181546549",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546436",
        "height": 0.61115,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ed80",
            "leftCorner": {
              "x": -3.536,
              "y": 21.446,
              "z": 0.5
            },
            "rightCorner": {
              "x": -3.611,
              "y": 21.45,
              "z": 0.5
            },
            "gtin": "4013162034024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed81",
            "leftCorner": {
              "x": -3.611,
              "y": 21.451,
              "z": 0.5
            },
            "rightCorner": {
              "x": -3.79,
              "y": 21.461,
              "z": 0.5
            },
            "gtin": "4013162034000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed82",
            "leftCorner": {
              "x": -3.79,
              "y": 21.461,
              "z": 0.5
            },
            "rightCorner": {
              "x": -3.94,
              "y": 21.47,
              "z": 0.5
            },
            "gtin": "4012400524044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed83",
            "leftCorner": {
              "x": -3.94,
              "y": 21.47,
              "z": 0.5
            },
            "rightCorner": {
              "x": -4.091,
              "y": 21.478,
              "z": 0.5
            },
            "gtin": "4012400524044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed84",
            "leftCorner": {
              "x": -4.091,
              "y": 21.478,
              "z": 0.5
            },
            "rightCorner": {
              "x": -4.241,
              "y": 21.486,
              "z": 0.5
            },
            "gtin": "4012400524044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed85",
            "leftCorner": {
              "x": -4.241,
              "y": 21.494,
              "z": 0.5
            },
            "rightCorner": {
              "x": -4.358,
              "y": 21.501,
              "z": 0.5
            },
            "gtin": "4012400524396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed86",
            "leftCorner": {
              "x": -4.358,
              "y": 21.501,
              "z": 0.5
            },
            "rightCorner": {
              "x": -4.476,
              "y": 21.508,
              "z": 0.5
            },
            "gtin": "4012400524396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed87",
            "leftCorner": {
              "x": -4.476,
              "y": 21.508,
              "z": 0.5
            },
            "rightCorner": {
              "x": -4.594,
              "y": 21.514,
              "z": 0.5
            },
            "gtin": "4012400524396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed75",
            "leftCorner": {
              "x": -4.593,
              "y": 21.521,
              "z": 0.5
            },
            "rightCorner": {
              "x": -4.742,
              "y": 21.53,
              "z": 0.5
            },
            "gtin": "4012400524006",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546437",
        "height": 1.0576,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1edbd",
            "leftCorner": {
              "x": -3.543,
              "y": 21.462,
              "z": 0.865
            },
            "rightCorner": {
              "x": -3.662,
              "y": 21.468,
              "z": 0.865
            },
            "gtin": "4013162033904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edbe",
            "leftCorner": {
              "x": -3.662,
              "y": 21.468,
              "z": 0.865
            },
            "rightCorner": {
              "x": -3.782,
              "y": 21.475,
              "z": 0.865
            },
            "gtin": "4013162033904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edbf",
            "leftCorner": {
              "x": -3.782,
              "y": 21.475,
              "z": 0.865
            },
            "rightCorner": {
              "x": -3.901,
              "y": 21.482,
              "z": 0.865
            },
            "gtin": "4013162033904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edc0",
            "leftCorner": {
              "x": -3.901,
              "y": 21.482,
              "z": 0.865
            },
            "rightCorner": {
              "x": -4.021,
              "y": 21.489,
              "z": 0.865
            },
            "gtin": "4013162033904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edc1",
            "leftCorner": {
              "x": -4.021,
              "y": 21.483,
              "z": 0.865
            },
            "rightCorner": {
              "x": -4.143,
              "y": 21.49,
              "z": 0.865
            },
            "gtin": "4013162028573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edc2",
            "leftCorner": {
              "x": -4.143,
              "y": 21.49,
              "z": 0.865
            },
            "rightCorner": {
              "x": -4.265,
              "y": 21.497,
              "z": 0.865
            },
            "gtin": "4013162028573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edb2",
            "leftCorner": {
              "x": -4.264,
              "y": 21.504,
              "z": 0.865
            },
            "rightCorner": {
              "x": -4.423,
              "y": 21.513,
              "z": 0.865
            },
            "gtin": "4013162033867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edb3",
            "leftCorner": {
              "x": -4.423,
              "y": 21.513,
              "z": 0.865
            },
            "rightCorner": {
              "x": -4.583,
              "y": 21.522,
              "z": 0.865
            },
            "gtin": "4013162033867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edb4",
            "leftCorner": {
              "x": -4.583,
              "y": 21.522,
              "z": 0.865
            },
            "rightCorner": {
              "x": -4.742,
              "y": 21.531,
              "z": 0.865
            },
            "gtin": "4013162033867",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546438",
        "height": 1.4073,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ed9f",
            "leftCorner": {
              "x": -3.578,
              "y": 21.47,
              "z": 1.151
            },
            "rightCorner": {
              "x": -3.736,
              "y": 21.479,
              "z": 1.151
            },
            "gtin": "4001499966613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eda0",
            "leftCorner": {
              "x": -3.736,
              "y": 21.479,
              "z": 1.151
            },
            "rightCorner": {
              "x": -3.895,
              "y": 21.488,
              "z": 1.151
            },
            "gtin": "4001499966613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eda1",
            "leftCorner": {
              "x": -3.895,
              "y": 21.488,
              "z": 1.151
            },
            "rightCorner": {
              "x": -4.053,
              "y": 21.497,
              "z": 1.151
            },
            "gtin": "4001499966613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed8a",
            "leftCorner": {
              "x": -4.054,
              "y": 21.486,
              "z": 1.151
            },
            "rightCorner": {
              "x": -4.398,
              "y": 21.505,
              "z": 1.151
            },
            "gtin": "4012400528028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed8b",
            "leftCorner": {
              "x": -4.398,
              "y": 21.505,
              "z": 1.151
            },
            "rightCorner": {
              "x": -4.743,
              "y": 21.525,
              "z": 1.151
            },
            "gtin": "4012400528028",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546439",
        "height": 1.7097,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1db9d",
            "leftCorner": {
              "x": -3.552,
              "y": 21.465,
              "z": 1.399
            },
            "rightCorner": {
              "x": -3.685,
              "y": 21.473,
              "z": 1.399
            },
            "gtin": "5412533424065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db9e",
            "leftCorner": {
              "x": -3.685,
              "y": 21.476,
              "z": 1.399
            },
            "rightCorner": {
              "x": -3.863,
              "y": 21.486,
              "z": 1.399
            },
            "gtin": "5412533424089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db9f",
            "leftCorner": {
              "x": -3.863,
              "y": 21.485,
              "z": 1.399
            },
            "rightCorner": {
              "x": -3.951,
              "y": 21.49,
              "z": 1.399
            },
            "gtin": "4013162030606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dba0",
            "leftCorner": {
              "x": -3.951,
              "y": 21.49,
              "z": 1.399
            },
            "rightCorner": {
              "x": -4.039,
              "y": 21.494,
              "z": 1.399
            },
            "gtin": "4013162030606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dba1",
            "leftCorner": {
              "x": -4.039,
              "y": 21.486,
              "z": 1.399
            },
            "rightCorner": {
              "x": -4.15,
              "y": 21.492,
              "z": 1.399
            },
            "gtin": "4013162023486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dba2",
            "leftCorner": {
              "x": -4.15,
              "y": 21.491,
              "z": 1.399
            },
            "rightCorner": {
              "x": -4.29,
              "y": 21.499,
              "z": 1.399
            },
            "gtin": "4013162028634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dba3",
            "leftCorner": {
              "x": -4.289,
              "y": 21.509,
              "z": 1.399
            },
            "rightCorner": {
              "x": -4.401,
              "y": 21.516,
              "z": 1.399
            },
            "gtin": "4013162028610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dba4",
            "leftCorner": {
              "x": -4.401,
              "y": 21.516,
              "z": 1.399
            },
            "rightCorner": {
              "x": -4.513,
              "y": 21.522,
              "z": 1.399
            },
            "gtin": "4013162028610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dba5",
            "leftCorner": {
              "x": -4.513,
              "y": 21.522,
              "z": 1.399
            },
            "rightCorner": {
              "x": -4.625,
              "y": 21.529,
              "z": 1.399
            },
            "gtin": "4013162028610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db6a",
            "leftCorner": {
              "x": -4.625,
              "y": 21.526,
              "z": 1.399
            },
            "rightCorner": {
              "x": -4.742,
              "y": 21.533,
              "z": 1.399
            },
            "gtin": "4012400527984",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41ab9",
    "rightNeighborShelfId": "41abb"
  },
  {
    "id": "41abb",
    "name": "41abb",
    "x": -4.74,
    "y": 21.569,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9996,
      "w": 0.028166
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 26,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54643c",
        "height": 0.17046,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1edf9",
            "leftCorner": {
              "x": -4.735,
              "y": 21.664,
              "z": 0.139
            },
            "rightCorner": {
              "x": -4.989,
              "y": 21.677,
              "z": 0.139
            },
            "gtin": "8720181546549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edfa",
            "leftCorner": {
              "x": -4.989,
              "y": 21.677,
              "z": 0.139
            },
            "rightCorner": {
              "x": -5.243,
              "y": 21.692,
              "z": 0.139
            },
            "gtin": "8720181546549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edfb",
            "leftCorner": {
              "x": -5.247,
              "y": 21.621,
              "z": 0.139
            },
            "rightCorner": {
              "x": -5.592,
              "y": 21.641,
              "z": 0.139
            },
            "gtin": "8720181546556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edfc",
            "leftCorner": {
              "x": -5.592,
              "y": 21.641,
              "z": 0.139
            },
            "rightCorner": {
              "x": -5.937,
              "y": 21.66,
              "z": 0.139
            },
            "gtin": "8720181546556",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54643d",
        "height": 0.61194,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1edfd",
            "leftCorner": {
              "x": -4.738,
              "y": 21.607,
              "z": 0.501
            },
            "rightCorner": {
              "x": -4.999,
              "y": 21.622,
              "z": 0.501
            },
            "gtin": "4012400524105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edfe",
            "leftCorner": {
              "x": -4.999,
              "y": 21.622,
              "z": 0.501
            },
            "rightCorner": {
              "x": -5.26,
              "y": 21.637,
              "z": 0.501
            },
            "gtin": "4012400524105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee00",
            "leftCorner": {
              "x": -5.261,
              "y": 21.62,
              "z": 0.501
            },
            "rightCorner": {
              "x": -5.411,
              "y": 21.628,
              "z": 0.501
            },
            "gtin": "4012400524471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee01",
            "leftCorner": {
              "x": -5.411,
              "y": 21.628,
              "z": 0.501
            },
            "rightCorner": {
              "x": -5.561,
              "y": 21.637,
              "z": 0.501
            },
            "gtin": "4012400524471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee02",
            "leftCorner": {
              "x": -5.563,
              "y": 21.6,
              "z": 0.501
            },
            "rightCorner": {
              "x": -5.815,
              "y": 21.614,
              "z": 0.501
            },
            "gtin": "4015200031972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edff",
            "leftCorner": {
              "x": -5.816,
              "y": 21.589,
              "z": 0.501
            },
            "rightCorner": {
              "x": -5.94,
              "y": 21.597,
              "z": 0.501
            },
            "gtin": "4015200031989",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54643b",
        "height": 1.0642,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1edf5",
            "leftCorner": {
              "x": -4.736,
              "y": 21.649,
              "z": 0.871
            },
            "rightCorner": {
              "x": -4.995,
              "y": 21.663,
              "z": 0.871
            },
            "gtin": "4012400528080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edf6",
            "leftCorner": {
              "x": -4.995,
              "y": 21.663,
              "z": 0.871
            },
            "rightCorner": {
              "x": -5.254,
              "y": 21.678,
              "z": 0.871
            },
            "gtin": "4012400528080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edf8",
            "leftCorner": {
              "x": -5.256,
              "y": 21.641,
              "z": 0.871
            },
            "rightCorner": {
              "x": -5.503,
              "y": 21.655,
              "z": 0.871
            },
            "gtin": "4012400528103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edf7",
            "leftCorner": {
              "x": -5.505,
              "y": 21.622,
              "z": 0.871
            },
            "rightCorner": {
              "x": -5.938,
              "y": 21.647,
              "z": 0.871
            },
            "gtin": "4012400528066",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54643e",
        "height": 1.4077,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee03",
            "leftCorner": {
              "x": -4.735,
              "y": 21.667,
              "z": 1.152
            },
            "rightCorner": {
              "x": -4.902,
              "y": 21.677,
              "z": 1.152
            },
            "gtin": "8720181511103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee06",
            "leftCorner": {
              "x": -4.903,
              "y": 21.674,
              "z": 1.152
            },
            "rightCorner": {
              "x": -5.126,
              "y": 21.686,
              "z": 1.152
            },
            "gtin": "8720181327056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee07",
            "leftCorner": {
              "x": -5.126,
              "y": 21.686,
              "z": 1.152
            },
            "rightCorner": {
              "x": -5.35,
              "y": 21.698,
              "z": 1.152
            },
            "gtin": "8720181327056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee08",
            "leftCorner": {
              "x": -5.353,
              "y": 21.647,
              "z": 1.152
            },
            "rightCorner": {
              "x": -5.52,
              "y": 21.656,
              "z": 1.152
            },
            "gtin": "8720181327100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee09",
            "leftCorner": {
              "x": -5.52,
              "y": 21.656,
              "z": 1.152
            },
            "rightCorner": {
              "x": -5.686,
              "y": 21.665,
              "z": 1.152
            },
            "gtin": "8720181327100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee04",
            "leftCorner": {
              "x": -5.689,
              "y": 21.613,
              "z": 1.152
            },
            "rightCorner": {
              "x": -5.814,
              "y": 21.619,
              "z": 1.152
            },
            "gtin": "8720181327117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee05",
            "leftCorner": {
              "x": -5.814,
              "y": 21.619,
              "z": 1.152
            },
            "rightCorner": {
              "x": -5.939,
              "y": 21.627,
              "z": 1.152
            },
            "gtin": "8720181327117",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54643f",
        "height": 1.7091,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee0a",
            "leftCorner": {
              "x": -4.734,
              "y": 21.676,
              "z": 1.398
            },
            "rightCorner": {
              "x": -4.818,
              "y": 21.68,
              "z": 1.398
            },
            "gtin": "8720181260247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee0b",
            "leftCorner": {
              "x": -4.818,
              "y": 21.68,
              "z": 1.398
            },
            "rightCorner": {
              "x": -4.902,
              "y": 21.685,
              "z": 1.398
            },
            "gtin": "8720181260247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee0d",
            "leftCorner": {
              "x": -4.903,
              "y": 21.661,
              "z": 1.398
            },
            "rightCorner": {
              "x": -5.189,
              "y": 21.677,
              "z": 1.398
            },
            "gtin": "8720181260254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee0e",
            "leftCorner": {
              "x": -5.191,
              "y": 21.648,
              "z": 1.398
            },
            "rightCorner": {
              "x": -5.529,
              "y": 21.667,
              "z": 1.398
            },
            "gtin": "8720181546556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee0c",
            "leftCorner": {
              "x": -5.531,
              "y": 21.638,
              "z": 1.398
            },
            "rightCorner": {
              "x": -5.937,
              "y": 21.662,
              "z": 1.398
            },
            "gtin": "8720181327070",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41aba",
    "rightNeighborShelfId": "41abf"
  },
  {
    "id": "41abf",
    "name": "41abf",
    "x": -5.945,
    "y": 21.656,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9993,
      "w": 0.037315
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 29,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546407",
        "height": 0.14952,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d6a8",
            "leftCorner": {
              "x": -5.946,
              "y": 21.639,
              "z": 0.122
            },
            "rightCorner": {
              "x": -6.254,
              "y": 21.663,
              "z": 0.122
            },
            "gtin": "4015200030746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6a9",
            "leftCorner": {
              "x": -6.254,
              "y": 21.663,
              "z": 0.122
            },
            "rightCorner": {
              "x": -6.562,
              "y": 21.685,
              "z": 0.122
            },
            "gtin": "4015200030746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6ac",
            "leftCorner": {
              "x": -6.565,
              "y": 21.647,
              "z": 0.122
            },
            "rightCorner": {
              "x": -6.682,
              "y": 21.655,
              "z": 0.122
            },
            "gtin": "4015200032702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6ad",
            "leftCorner": {
              "x": -6.682,
              "y": 21.655,
              "z": 0.122
            },
            "rightCorner": {
              "x": -6.798,
              "y": 21.663,
              "z": 0.122
            },
            "gtin": "4015200032702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6ae",
            "leftCorner": {
              "x": -6.798,
              "y": 21.663,
              "z": 0.122
            },
            "rightCorner": {
              "x": -6.988,
              "y": 21.677,
              "z": 0.122
            },
            "gtin": "8700216570435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6af",
            "leftCorner": {
              "x": -6.988,
              "y": 21.677,
              "z": 0.122
            },
            "rightCorner": {
              "x": -7.177,
              "y": 21.692,
              "z": 0.122
            },
            "gtin": "8700216570435",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546403",
        "height": 0.60765,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e99b",
            "leftCorner": {
              "x": -5.946,
              "y": 21.647,
              "z": 0.497
            },
            "rightCorner": {
              "x": -6.176,
              "y": 21.665,
              "z": 0.497
            },
            "gtin": "4015200033648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e99c",
            "leftCorner": {
              "x": -6.176,
              "y": 21.665,
              "z": 0.497
            },
            "rightCorner": {
              "x": -6.407,
              "y": 21.681,
              "z": 0.497
            },
            "gtin": "4015200033648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e99e",
            "leftCorner": {
              "x": -6.41,
              "y": 21.644,
              "z": 0.497
            },
            "rightCorner": {
              "x": -6.561,
              "y": 21.655,
              "z": 0.497
            },
            "gtin": "4015200031750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e99f",
            "leftCorner": {
              "x": -6.561,
              "y": 21.655,
              "z": 0.497
            },
            "rightCorner": {
              "x": -6.713,
              "y": 21.667,
              "z": 0.497
            },
            "gtin": "4015200031750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9a0",
            "leftCorner": {
              "x": -6.713,
              "y": 21.667,
              "z": 0.497
            },
            "rightCorner": {
              "x": -6.864,
              "y": 21.678,
              "z": 0.497
            },
            "gtin": "4015200031750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9a1",
            "leftCorner": {
              "x": -6.865,
              "y": 21.674,
              "z": 0.497
            },
            "rightCorner": {
              "x": -7.088,
              "y": 21.69,
              "z": 0.497
            },
            "gtin": "4015200033815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9a2",
            "leftCorner": {
              "x": -7.088,
              "y": 21.69,
              "z": 0.497
            },
            "rightCorner": {
              "x": -7.312,
              "y": 21.707,
              "z": 0.497
            },
            "gtin": "4015200033815",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546404",
        "height": 1.0559,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d6bd",
            "leftCorner": {
              "x": -5.945,
              "y": 21.653,
              "z": 0.864
            },
            "rightCorner": {
              "x": -6.181,
              "y": 21.671,
              "z": 0.864
            },
            "gtin": "4015200031903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6be",
            "leftCorner": {
              "x": -6.181,
              "y": 21.671,
              "z": 0.864
            },
            "rightCorner": {
              "x": -6.417,
              "y": 21.689,
              "z": 0.864
            },
            "gtin": "4015200031903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6c2",
            "leftCorner": {
              "x": -6.419,
              "y": 21.659,
              "z": 0.864
            },
            "rightCorner": {
              "x": -6.488,
              "y": 21.663,
              "z": 0.864
            },
            "gtin": "4015200031941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6c3",
            "leftCorner": {
              "x": -6.488,
              "y": 21.663,
              "z": 0.864
            },
            "rightCorner": {
              "x": -6.558,
              "y": 21.669,
              "z": 0.864
            },
            "gtin": "4015200031941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6c4",
            "leftCorner": {
              "x": -6.559,
              "y": 21.653,
              "z": 0.864
            },
            "rightCorner": {
              "x": -6.739,
              "y": 21.667,
              "z": 0.864
            },
            "gtin": "4015200032177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6c5",
            "leftCorner": {
              "x": -6.738,
              "y": 21.673,
              "z": 0.864
            },
            "rightCorner": {
              "x": -6.959,
              "y": 21.689,
              "z": 0.864
            },
            "gtin": "4015200032184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6c6",
            "leftCorner": {
              "x": -6.959,
              "y": 21.689,
              "z": 0.864
            },
            "rightCorner": {
              "x": -7.18,
              "y": 21.706,
              "z": 0.864
            },
            "gtin": "4015200032184",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546406",
        "height": 1.3988,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d6ef",
            "leftCorner": {
              "x": -5.945,
              "y": 21.657,
              "z": 1.144
            },
            "rightCorner": {
              "x": -6.11,
              "y": 21.669,
              "z": 1.144
            },
            "gtin": "4015200032115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6f0",
            "leftCorner": {
              "x": -6.11,
              "y": 21.669,
              "z": 1.144
            },
            "rightCorner": {
              "x": -6.275,
              "y": 21.681,
              "z": 1.144
            },
            "gtin": "4015200032115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6f1",
            "leftCorner": {
              "x": -6.275,
              "y": 21.681,
              "z": 1.144
            },
            "rightCorner": {
              "x": -6.44,
              "y": 21.694,
              "z": 1.144
            },
            "gtin": "4015200032115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6f3",
            "leftCorner": {
              "x": -6.444,
              "y": 21.649,
              "z": 1.144
            },
            "rightCorner": {
              "x": -6.81,
              "y": 21.676,
              "z": 1.144
            },
            "gtin": "4015200031781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6f4",
            "leftCorner": {
              "x": -6.81,
              "y": 21.676,
              "z": 1.144
            },
            "rightCorner": {
              "x": -7.176,
              "y": 21.704,
              "z": 1.144
            },
            "gtin": "4015200031781",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546405",
        "height": 1.703,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e9a5",
            "leftCorner": {
              "x": -5.945,
              "y": 21.658,
              "z": 1.393
            },
            "rightCorner": {
              "x": -6.2,
              "y": 21.678,
              "z": 1.393
            },
            "gtin": "4015200031521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9a7",
            "leftCorner": {
              "x": -6.203,
              "y": 21.638,
              "z": 1.393
            },
            "rightCorner": {
              "x": -6.389,
              "y": 21.652,
              "z": 1.393
            },
            "gtin": "4015200031965",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9a8",
            "leftCorner": {
              "x": -6.389,
              "y": 21.652,
              "z": 1.393
            },
            "rightCorner": {
              "x": -6.574,
              "y": 21.665,
              "z": 1.393
            },
            "gtin": "4015200031965",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9a6",
            "leftCorner": {
              "x": -6.574,
              "y": 21.663,
              "z": 1.393
            },
            "rightCorner": {
              "x": -7.145,
              "y": 21.706,
              "z": 1.393
            },
            "gtin": "4015200033655",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41abb",
    "rightNeighborShelfId": "41ac0"
  },
  {
    "id": "41ac0",
    "name": "41ac0",
    "x": -7.142,
    "y": 21.746,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9993,
      "w": 0.037315
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 22,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546442",
        "height": 0.14646,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d6b0",
            "leftCorner": {
              "x": -7.178,
              "y": 21.685,
              "z": 0.12
            },
            "rightCorner": {
              "x": -7.356,
              "y": 21.698,
              "z": 0.12
            },
            "gtin": "8700216569873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6b1",
            "leftCorner": {
              "x": -7.355,
              "y": 21.704,
              "z": 0.12
            },
            "rightCorner": {
              "x": -7.752,
              "y": 21.734,
              "z": 0.12
            },
            "gtin": "8700216569972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6b2",
            "leftCorner": {
              "x": -7.752,
              "y": 21.734,
              "z": 0.12
            },
            "rightCorner": {
              "x": -8.149,
              "y": 21.764,
              "z": 0.12
            },
            "gtin": "8700216569972",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546444",
        "height": 0.60039,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e9a3",
            "leftCorner": {
              "x": -7.312,
              "y": 21.712,
              "z": 0.491
            },
            "rightCorner": {
              "x": -7.619,
              "y": 21.735,
              "z": 0.491
            },
            "gtin": "8700216702225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9a4",
            "leftCorner": {
              "x": -7.619,
              "y": 21.735,
              "z": 0.491
            },
            "rightCorner": {
              "x": -8.388,
              "y": 21.792,
              "z": 0.491
            },
            "gtin": "8700216702188",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546441",
        "height": 1.0604,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d6c7",
            "leftCorner": {
              "x": -7.18,
              "y": 21.703,
              "z": 0.868
            },
            "rightCorner": {
              "x": -7.347,
              "y": 21.715,
              "z": 0.868
            },
            "gtin": "8700216569934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6c8",
            "leftCorner": {
              "x": -7.347,
              "y": 21.712,
              "z": 0.868
            },
            "rightCorner": {
              "x": -7.496,
              "y": 21.724,
              "z": 0.868
            },
            "gtin": "8700216570022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6c9",
            "leftCorner": {
              "x": -7.496,
              "y": 21.724,
              "z": 0.868
            },
            "rightCorner": {
              "x": -7.644,
              "y": 21.734,
              "z": 0.868
            },
            "gtin": "8700216570022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6ca",
            "leftCorner": {
              "x": -7.644,
              "y": 21.73,
              "z": 0.868
            },
            "rightCorner": {
              "x": -7.785,
              "y": 21.742,
              "z": 0.868
            },
            "gtin": "8700216570251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6cb",
            "leftCorner": {
              "x": -7.785,
              "y": 21.742,
              "z": 0.868
            },
            "rightCorner": {
              "x": -7.925,
              "y": 21.752,
              "z": 0.868
            },
            "gtin": "8700216570251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6cc",
            "leftCorner": {
              "x": -7.925,
              "y": 21.765,
              "z": 0.868
            },
            "rightCorner": {
              "x": -8.048,
              "y": 21.774,
              "z": 0.868
            },
            "gtin": "8700216570398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6cd",
            "leftCorner": {
              "x": -8.048,
              "y": 21.774,
              "z": 0.868
            },
            "rightCorner": {
              "x": -8.172,
              "y": 21.783,
              "z": 0.868
            },
            "gtin": "8700216570398",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546440",
        "height": 1.4027,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d6f5",
            "leftCorner": {
              "x": -7.177,
              "y": 21.698,
              "z": 1.148
            },
            "rightCorner": {
              "x": -7.527,
              "y": 21.724,
              "z": 1.148
            },
            "gtin": "4015200031743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6f6",
            "leftCorner": {
              "x": -7.526,
              "y": 21.729,
              "z": 1.148
            },
            "rightCorner": {
              "x": -7.618,
              "y": 21.736,
              "z": 1.148
            },
            "gtin": "4015200032443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6f7",
            "leftCorner": {
              "x": -7.618,
              "y": 21.736,
              "z": 1.148
            },
            "rightCorner": {
              "x": -7.709,
              "y": 21.742,
              "z": 1.148
            },
            "gtin": "4015200032443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6f8",
            "leftCorner": {
              "x": -7.71,
              "y": 21.733,
              "z": 1.148
            },
            "rightCorner": {
              "x": -7.829,
              "y": 21.742,
              "z": 1.148
            },
            "gtin": "4015200032290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6f9",
            "leftCorner": {
              "x": -7.829,
              "y": 21.742,
              "z": 1.148
            },
            "rightCorner": {
              "x": -7.947,
              "y": 21.751,
              "z": 1.148
            },
            "gtin": "4015200032290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6fa",
            "leftCorner": {
              "x": -7.946,
              "y": 21.765,
              "z": 1.148
            },
            "rightCorner": {
              "x": -8.167,
              "y": 21.782,
              "z": 1.148
            },
            "gtin": "4015200034232",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546443",
        "height": 1.7185,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee0f",
            "leftCorner": {
              "x": -7.142,
              "y": 21.74,
              "z": 1.406
            },
            "rightCorner": {
              "x": -7.449,
              "y": 21.763,
              "z": 1.406
            },
            "gtin": "8700216651189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee10",
            "leftCorner": {
              "x": -7.449,
              "y": 21.763,
              "z": 1.406
            },
            "rightCorner": {
              "x": -7.756,
              "y": 21.786,
              "z": 1.406
            },
            "gtin": "8700216651189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee11",
            "leftCorner": {
              "x": -7.758,
              "y": 21.753,
              "z": 1.406
            },
            "rightCorner": {
              "x": -7.95,
              "y": 21.767,
              "z": 1.406
            },
            "gtin": "8700216678292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee12",
            "leftCorner": {
              "x": -7.95,
              "y": 21.767,
              "z": 1.406
            },
            "rightCorner": {
              "x": -8.142,
              "y": 21.782,
              "z": 1.406
            },
            "gtin": "8700216678292",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41abf",
    "rightNeighborShelfId": "41ac1"
  },
  {
    "id": "41ac1",
    "name": "41ac1",
    "x": -8.139,
    "y": 21.821,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9993,
      "w": 0.037315
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 9,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546447",
        "height": 0.1459,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d6b3",
            "leftCorner": {
              "x": -8.148,
              "y": 21.771,
              "z": 0.119
            },
            "rightCorner": {
              "x": -8.369,
              "y": 21.788,
              "z": 0.119
            },
            "gtin": "4015200035055",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546449",
        "height": 0.59511,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e99d",
            "leftCorner": {
              "x": -8.4,
              "y": 21.791,
              "z": 0.487
            },
            "rightCorner": {
              "x": -8.771,
              "y": 21.819,
              "z": 0.487
            },
            "gtin": "8700216702362",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546445",
        "height": 1.0518,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d6ce",
            "leftCorner": {
              "x": -8.174,
              "y": 21.765,
              "z": 0.861
            },
            "rightCorner": {
              "x": -8.335,
              "y": 21.777,
              "z": 0.861
            },
            "gtin": "8700216569897",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6cf",
            "leftCorner": {
              "x": -8.335,
              "y": 21.777,
              "z": 0.861
            },
            "rightCorner": {
              "x": -8.496,
              "y": 21.789,
              "z": 0.861
            },
            "gtin": "8700216569897",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6d0",
            "leftCorner": {
              "x": -8.495,
              "y": 21.802,
              "z": 0.861
            },
            "rightCorner": {
              "x": -8.625,
              "y": 21.812,
              "z": 0.861
            },
            "gtin": "8700216702324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6d1",
            "leftCorner": {
              "x": -8.625,
              "y": 21.812,
              "z": 0.861
            },
            "rightCorner": {
              "x": -8.756,
              "y": 21.822,
              "z": 0.861
            },
            "gtin": "8700216702324",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546448",
        "height": 1.408,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a546446",
        "height": 1.6983,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee13",
            "leftCorner": {
              "x": -8.163,
              "y": 21.775,
              "z": 1.39
            },
            "rightCorner": {
              "x": -8.366,
              "y": 21.791,
              "z": 1.39
            },
            "gtin": "8700216678582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee14",
            "leftCorner": {
              "x": -8.366,
              "y": 21.791,
              "z": 1.39
            },
            "rightCorner": {
              "x": -8.568,
              "y": 21.806,
              "z": 1.39
            },
            "gtin": "8700216678582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee15",
            "leftCorner": {
              "x": -8.568,
              "y": 21.806,
              "z": 1.39
            },
            "rightCorner": {
              "x": -8.77,
              "y": 21.821,
              "z": 1.39
            },
            "gtin": "8700216678582",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41ac0",
    "rightNeighborShelfId": "41ac2"
  },
  {
    "id": "41ac2",
    "name": "41ac2",
    "x": -8.762,
    "y": 21.867,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9993,
      "w": 0.037315
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 28,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5461e5",
        "height": 0.148,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d6b4",
            "leftCorner": {
              "x": -9.238,
              "y": 21.853,
              "z": 0.121
            },
            "rightCorner": {
              "x": -9.657,
              "y": 21.884,
              "z": 0.121
            },
            "gtin": "4015200035055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6b5",
            "leftCorner": {
              "x": -9.657,
              "y": 21.884,
              "z": 0.121
            },
            "rightCorner": {
              "x": -10.075,
              "y": 21.916,
              "z": 0.121
            },
            "gtin": "4015200035055",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461e6",
        "height": 0.58459,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a5461e7",
        "height": 1.0526,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d6d2",
            "leftCorner": {
              "x": -8.75,
              "y": 21.826,
              "z": 0.861
            },
            "rightCorner": {
              "x": -8.983,
              "y": 21.844,
              "z": 0.861
            },
            "gtin": "8700216651042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6d3",
            "leftCorner": {
              "x": -8.983,
              "y": 21.841,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.138,
              "y": 21.851,
              "z": 0.861
            },
            "gtin": "8700216650816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6d4",
            "leftCorner": {
              "x": -9.137,
              "y": 21.86,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.335,
              "y": 21.875,
              "z": 0.861
            },
            "gtin": "8700216678445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6d5",
            "leftCorner": {
              "x": -9.335,
              "y": 21.867,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.42,
              "y": 21.873,
              "z": 0.861
            },
            "gtin": "8700216650892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6d6",
            "leftCorner": {
              "x": -9.42,
              "y": 21.873,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.505,
              "y": 21.879,
              "z": 0.861
            },
            "gtin": "8700216650892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6d7",
            "leftCorner": {
              "x": -9.504,
              "y": 21.883,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.59,
              "y": 21.889,
              "z": 0.861
            },
            "gtin": "8700216678605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6d8",
            "leftCorner": {
              "x": -9.59,
              "y": 21.889,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.674,
              "y": 21.895,
              "z": 0.861
            },
            "gtin": "8700216678605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6d9",
            "leftCorner": {
              "x": -9.674,
              "y": 21.895,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.759,
              "y": 21.902,
              "z": 0.861
            },
            "gtin": "8700216678605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6da",
            "leftCorner": {
              "x": -9.759,
              "y": 21.905,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.91,
              "y": 21.917,
              "z": 0.861
            },
            "gtin": "8700216651097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6db",
            "leftCorner": {
              "x": -9.91,
              "y": 21.917,
              "z": 0.861
            },
            "rightCorner": {
              "x": -10.063,
              "y": 21.929,
              "z": 0.861
            },
            "gtin": "8700216651097",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461e8",
        "height": 1.4025,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d6fb",
            "leftCorner": {
              "x": -8.82,
              "y": 21.827,
              "z": 1.147
            },
            "rightCorner": {
              "x": -8.888,
              "y": 21.832,
              "z": 1.147
            },
            "gtin": "8700216650984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6fc",
            "leftCorner": {
              "x": -8.888,
              "y": 21.832,
              "z": 1.147
            },
            "rightCorner": {
              "x": -8.955,
              "y": 21.837,
              "z": 1.147
            },
            "gtin": "8700216650984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6fd",
            "leftCorner": {
              "x": -8.954,
              "y": 21.85,
              "z": 1.147
            },
            "rightCorner": {
              "x": -9.006,
              "y": 21.853,
              "z": 1.147
            },
            "gtin": "8700216823982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6fe",
            "leftCorner": {
              "x": -9.006,
              "y": 21.853,
              "z": 1.147
            },
            "rightCorner": {
              "x": -9.058,
              "y": 21.857,
              "z": 1.147
            },
            "gtin": "8700216823982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6ff",
            "leftCorner": {
              "x": -9.058,
              "y": 21.857,
              "z": 1.147
            },
            "rightCorner": {
              "x": -9.11,
              "y": 21.861,
              "z": 1.147
            },
            "gtin": "8700216823982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d700",
            "leftCorner": {
              "x": -9.11,
              "y": 21.861,
              "z": 1.147
            },
            "rightCorner": {
              "x": -9.289,
              "y": 21.874,
              "z": 1.147
            },
            "gtin": "8700216823951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d701",
            "leftCorner": {
              "x": -9.289,
              "y": 21.87,
              "z": 1.147
            },
            "rightCorner": {
              "x": -9.512,
              "y": 21.887,
              "z": 1.147
            },
            "gtin": "8700216702447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d702",
            "leftCorner": {
              "x": -9.512,
              "y": 21.887,
              "z": 1.147
            },
            "rightCorner": {
              "x": -9.736,
              "y": 21.904,
              "z": 1.147
            },
            "gtin": "8700216702447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d703",
            "leftCorner": {
              "x": -9.735,
              "y": 21.909,
              "z": 1.147
            },
            "rightCorner": {
              "x": -9.93,
              "y": 21.922,
              "z": 1.147
            },
            "gtin": "8700216702508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d704",
            "leftCorner": {
              "x": -9.931,
              "y": 21.907,
              "z": 1.147
            },
            "rightCorner": {
              "x": -10.082,
              "y": 21.918,
              "z": 1.147
            },
            "gtin": "8700216702638",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461e9",
        "height": 1.7221,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d712",
            "leftCorner": {
              "x": -8.762,
              "y": 21.864,
              "z": 1.409
            },
            "rightCorner": {
              "x": -8.894,
              "y": 21.874,
              "z": 1.409
            },
            "gtin": "8700216651066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d713",
            "leftCorner": {
              "x": -8.894,
              "y": 21.874,
              "z": 1.409
            },
            "rightCorner": {
              "x": -9.025,
              "y": 21.884,
              "z": 1.409
            },
            "gtin": "8700216651066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d716",
            "leftCorner": {
              "x": -9.028,
              "y": 21.844,
              "z": 1.409
            },
            "rightCorner": {
              "x": -9.193,
              "y": 21.856,
              "z": 1.409
            },
            "gtin": "4015200036014",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c845ed67a01d9a1d717",
            "leftCorner": {
              "x": -9.193,
              "y": 21.859,
              "z": 1.409
            },
            "rightCorner": {
              "x": -9.394,
              "y": 21.875,
              "z": 1.409
            },
            "gtin": "4015200035987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d718",
            "leftCorner": {
              "x": -9.395,
              "y": 21.869,
              "z": 1.409
            },
            "rightCorner": {
              "x": -9.655,
              "y": 21.888,
              "z": 1.409
            },
            "gtin": "4015200035048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d714",
            "leftCorner": {
              "x": -9.655,
              "y": 21.901,
              "z": 1.409
            },
            "rightCorner": {
              "x": -9.833,
              "y": 21.915,
              "z": 1.409
            },
            "gtin": "4015200035109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d715",
            "leftCorner": {
              "x": -9.833,
              "y": 21.915,
              "z": 1.409
            },
            "rightCorner": {
              "x": -10.011,
              "y": 21.928,
              "z": 1.409
            },
            "gtin": "4015200035109",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41ac1",
    "rightNeighborShelfId": "41ac6"
  },
  {
    "id": "41ac6",
    "name": "41ac6",
    "x": -10.009,
    "y": 21.96,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9993,
      "w": 0.037315
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 31,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54644e",
        "height": 0.14825,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a54644a",
        "height": 0.5935,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d6b7",
            "leftCorner": {
              "x": -10.051,
              "y": 21.915,
              "z": 0.486
            },
            "rightCorner": {
              "x": -10.162,
              "y": 21.923,
              "z": 0.486
            },
            "gtin": "8700216665384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6b8",
            "leftCorner": {
              "x": -10.162,
              "y": 21.923,
              "z": 0.486
            },
            "rightCorner": {
              "x": -10.273,
              "y": 21.932,
              "z": 0.486
            },
            "gtin": "8700216665384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6b9",
            "leftCorner": {
              "x": -10.273,
              "y": 21.931,
              "z": 0.486
            },
            "rightCorner": {
              "x": -10.659,
              "y": 21.96,
              "z": 0.486
            },
            "gtin": "8700216665711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6ba",
            "leftCorner": {
              "x": -10.659,
              "y": 21.968,
              "z": 0.486
            },
            "rightCorner": {
              "x": -10.923,
              "y": 21.987,
              "z": 0.486
            },
            "gtin": "8700216665612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6bb",
            "leftCorner": {
              "x": -10.922,
              "y": 21.994,
              "z": 0.486
            },
            "rightCorner": {
              "x": -11.12,
              "y": 22.009,
              "z": 0.486
            },
            "gtin": "8700216701853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6bc",
            "leftCorner": {
              "x": -11.12,
              "y": 22.002,
              "z": 0.486
            },
            "rightCorner": {
              "x": -11.337,
              "y": 22.018,
              "z": 0.486
            },
            "gtin": "8700216701815",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54644d",
        "height": 1.0495,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d6dc",
            "leftCorner": {
              "x": -10.064,
              "y": 21.923,
              "z": 0.859
            },
            "rightCorner": {
              "x": -10.151,
              "y": 21.93,
              "z": 0.859
            },
            "gtin": "8700216707985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6dd",
            "leftCorner": {
              "x": -10.151,
              "y": 21.93,
              "z": 0.859
            },
            "rightCorner": {
              "x": -10.238,
              "y": 21.936,
              "z": 0.859
            },
            "gtin": "8700216707985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6de",
            "leftCorner": {
              "x": -10.238,
              "y": 21.936,
              "z": 0.859
            },
            "rightCorner": {
              "x": -10.326,
              "y": 21.943,
              "z": 0.859
            },
            "gtin": "8700216707985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6df",
            "leftCorner": {
              "x": -10.325,
              "y": 21.948,
              "z": 0.859
            },
            "rightCorner": {
              "x": -10.469,
              "y": 21.959,
              "z": 0.859
            },
            "gtin": "8700216708098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6e0",
            "leftCorner": {
              "x": -10.47,
              "y": 21.955,
              "z": 0.859
            },
            "rightCorner": {
              "x": -10.659,
              "y": 21.97,
              "z": 0.859
            },
            "gtin": "8700216708029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6e1",
            "leftCorner": {
              "x": -10.659,
              "y": 21.969,
              "z": 0.859
            },
            "rightCorner": {
              "x": -10.806,
              "y": 21.98,
              "z": 0.859
            },
            "gtin": "8700216823890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6e2",
            "leftCorner": {
              "x": -10.806,
              "y": 21.98,
              "z": 0.859
            },
            "rightCorner": {
              "x": -10.954,
              "y": 21.991,
              "z": 0.859
            },
            "gtin": "8700216823890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6e3",
            "leftCorner": {
              "x": -10.953,
              "y": 22.001,
              "z": 0.859
            },
            "rightCorner": {
              "x": -11.064,
              "y": 22.01,
              "z": 0.859
            },
            "gtin": "8700216701921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6e4",
            "leftCorner": {
              "x": -11.064,
              "y": 22.01,
              "z": 0.859
            },
            "rightCorner": {
              "x": -11.174,
              "y": 22.017,
              "z": 0.859
            },
            "gtin": "8700216701921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6e5",
            "leftCorner": {
              "x": -11.174,
              "y": 22.017,
              "z": 0.859
            },
            "rightCorner": {
              "x": -11.286,
              "y": 22.026,
              "z": 0.859
            },
            "gtin": "8700216701921",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54644c",
        "height": 1.4021,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d705",
            "leftCorner": {
              "x": -10.083,
              "y": 21.923,
              "z": 1.147
            },
            "rightCorner": {
              "x": -10.267,
              "y": 21.937,
              "z": 1.147
            },
            "gtin": "8700216708159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d706",
            "leftCorner": {
              "x": -10.268,
              "y": 21.935,
              "z": 1.147
            },
            "rightCorner": {
              "x": -10.43,
              "y": 21.947,
              "z": 1.147
            },
            "gtin": "8700216708128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d707",
            "leftCorner": {
              "x": -10.43,
              "y": 21.947,
              "z": 1.147
            },
            "rightCorner": {
              "x": -10.591,
              "y": 21.959,
              "z": 1.147
            },
            "gtin": "8700216708128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d708",
            "leftCorner": {
              "x": -10.59,
              "y": 21.968,
              "z": 1.147
            },
            "rightCorner": {
              "x": -10.779,
              "y": 21.982,
              "z": 1.147
            },
            "gtin": "8700216709613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d709",
            "leftCorner": {
              "x": -10.779,
              "y": 21.989,
              "z": 1.147
            },
            "rightCorner": {
              "x": -10.891,
              "y": 21.998,
              "z": 1.147
            },
            "gtin": "8700216709538",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d70a",
            "leftCorner": {
              "x": -10.891,
              "y": 21.998,
              "z": 1.147
            },
            "rightCorner": {
              "x": -11.002,
              "y": 22.007,
              "z": 1.147
            },
            "gtin": "8700216709538",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d70b",
            "leftCorner": {
              "x": -11.002,
              "y": 22.009,
              "z": 1.147
            },
            "rightCorner": {
              "x": -11.287,
              "y": 22.03,
              "z": 1.147
            },
            "gtin": "8700216709613",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54644b",
        "height": 1.7026,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee16",
            "leftCorner": {
              "x": -10.009,
              "y": 21.958,
              "z": 1.393
            },
            "rightCorner": {
              "x": -10.109,
              "y": 21.966,
              "z": 1.393
            },
            "gtin": "8700216665520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee17",
            "leftCorner": {
              "x": -10.109,
              "y": 21.966,
              "z": 1.393
            },
            "rightCorner": {
              "x": -10.21,
              "y": 21.973,
              "z": 1.393
            },
            "gtin": "8700216665520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee1b",
            "leftCorner": {
              "x": -10.213,
              "y": 21.93,
              "z": 1.393
            },
            "rightCorner": {
              "x": -10.375,
              "y": 21.942,
              "z": 1.393
            },
            "gtin": "8700216665506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee1c",
            "leftCorner": {
              "x": -10.374,
              "y": 21.944,
              "z": 1.393
            },
            "rightCorner": {
              "x": -10.581,
              "y": 21.96,
              "z": 1.393
            },
            "gtin": "8700216665872",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee1d",
            "leftCorner": {
              "x": -10.581,
              "y": 21.965,
              "z": 1.393
            },
            "rightCorner": {
              "x": -10.744,
              "y": 21.978,
              "z": 1.393
            },
            "gtin": "8700216665445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee1e",
            "leftCorner": {
              "x": -10.744,
              "y": 21.978,
              "z": 1.393
            },
            "rightCorner": {
              "x": -10.907,
              "y": 21.99,
              "z": 1.393
            },
            "gtin": "8700216665445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee1f",
            "leftCorner": {
              "x": -10.906,
              "y": 22.001,
              "z": 1.393
            },
            "rightCorner": {
              "x": -11.116,
              "y": 22.016,
              "z": 1.393
            },
            "gtin": "8700216823852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee20",
            "leftCorner": {
              "x": -11.117,
              "y": 22.003,
              "z": 1.393
            },
            "rightCorner": {
              "x": -11.304,
              "y": 22.017,
              "z": 1.393
            },
            "gtin": "8700216701891",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41ac2",
    "rightNeighborShelfId": "41ac7"
  },
  {
    "id": "41ac7",
    "name": "41ac7",
    "x": -11.256,
    "y": 22.054,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9993,
      "w": 0.037315
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 29,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546453",
        "height": 0.14672,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d6aa",
            "leftCorner": {
              "x": -11.459,
              "y": 22.022,
              "z": 0.12
            },
            "rightCorner": {
              "x": -11.983,
              "y": 22.061,
              "z": 0.12
            },
            "gtin": "4015200034980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6ab",
            "leftCorner": {
              "x": -11.983,
              "y": 22.061,
              "z": 0.12
            },
            "rightCorner": {
              "x": -12.506,
              "y": 22.1,
              "z": 0.12
            },
            "gtin": "4015200034980",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546452",
        "height": 0.60052,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d6b6",
            "leftCorner": {
              "x": -11.339,
              "y": 22.001,
              "z": 0.491
            },
            "rightCorner": {
              "x": -12.506,
              "y": 22.089,
              "z": 0.491
            },
            "gtin": "4015200034935",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546450",
        "height": 1.0457,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d6e6",
            "leftCorner": {
              "x": -11.287,
              "y": 22.007,
              "z": 0.856
            },
            "rightCorner": {
              "x": -11.376,
              "y": 22.014,
              "z": 0.856
            },
            "gtin": "4015200035147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6e7",
            "leftCorner": {
              "x": -11.376,
              "y": 22.014,
              "z": 0.856
            },
            "rightCorner": {
              "x": -11.465,
              "y": 22.021,
              "z": 0.856
            },
            "gtin": "4015200035147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6e8",
            "leftCorner": {
              "x": -11.466,
              "y": 22.015,
              "z": 0.856
            },
            "rightCorner": {
              "x": -11.552,
              "y": 22.021,
              "z": 0.856
            },
            "gtin": "4015200035345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6e9",
            "leftCorner": {
              "x": -11.552,
              "y": 22.021,
              "z": 0.856
            },
            "rightCorner": {
              "x": -11.638,
              "y": 22.028,
              "z": 0.856
            },
            "gtin": "4015200035345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6ea",
            "leftCorner": {
              "x": -11.638,
              "y": 22.028,
              "z": 0.856
            },
            "rightCorner": {
              "x": -11.725,
              "y": 22.035,
              "z": 0.856
            },
            "gtin": "4015200035345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6eb",
            "leftCorner": {
              "x": -11.724,
              "y": 22.044,
              "z": 0.856
            },
            "rightCorner": {
              "x": -11.865,
              "y": 22.055,
              "z": 0.856
            },
            "gtin": "4015200035116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6ec",
            "leftCorner": {
              "x": -11.865,
              "y": 22.055,
              "z": 0.856
            },
            "rightCorner": {
              "x": -12.006,
              "y": 22.065,
              "z": 0.856
            },
            "gtin": "4015200035116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6ed",
            "leftCorner": {
              "x": -12.006,
              "y": 22.079,
              "z": 0.856
            },
            "rightCorner": {
              "x": -12.14,
              "y": 22.088,
              "z": 0.856
            },
            "gtin": "4015200035161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6ee",
            "leftCorner": {
              "x": -12.14,
              "y": 22.088,
              "z": 0.856
            },
            "rightCorner": {
              "x": -12.274,
              "y": 22.099,
              "z": 0.856
            },
            "gtin": "4015200035161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6bf",
            "leftCorner": {
              "x": -12.276,
              "y": 22.083,
              "z": 0.856
            },
            "rightCorner": {
              "x": -12.353,
              "y": 22.088,
              "z": 0.856
            },
            "gtin": "4015200035338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6c0",
            "leftCorner": {
              "x": -12.353,
              "y": 22.088,
              "z": 0.856
            },
            "rightCorner": {
              "x": -12.429,
              "y": 22.094,
              "z": 0.856
            },
            "gtin": "4015200035338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6c1",
            "leftCorner": {
              "x": -12.429,
              "y": 22.094,
              "z": 0.856
            },
            "rightCorner": {
              "x": -12.506,
              "y": 22.1,
              "z": 0.856
            },
            "gtin": "4015200035338",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54644f",
        "height": 1.4,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d70c",
            "leftCorner": {
              "x": -11.289,
              "y": 22.011,
              "z": 1.145
            },
            "rightCorner": {
              "x": -11.546,
              "y": 22.031,
              "z": 1.145
            },
            "gtin": "4015200034904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d70d",
            "leftCorner": {
              "x": -11.546,
              "y": 22.034,
              "z": 1.145
            },
            "rightCorner": {
              "x": -11.818,
              "y": 22.054,
              "z": 1.145
            },
            "gtin": "4015200034911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d70e",
            "leftCorner": {
              "x": -11.818,
              "y": 22.054,
              "z": 1.145
            },
            "rightCorner": {
              "x": -12.091,
              "y": 22.075,
              "z": 1.145
            },
            "gtin": "4015200034911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d70f",
            "leftCorner": {
              "x": -12.09,
              "y": 22.087,
              "z": 1.145
            },
            "rightCorner": {
              "x": -12.195,
              "y": 22.095,
              "z": 1.145
            },
            "gtin": "4015200035185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d710",
            "leftCorner": {
              "x": -12.195,
              "y": 22.095,
              "z": 1.145
            },
            "rightCorner": {
              "x": -12.3,
              "y": 22.102,
              "z": 1.145
            },
            "gtin": "4015200035185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d711",
            "leftCorner": {
              "x": -12.3,
              "y": 22.102,
              "z": 1.145
            },
            "rightCorner": {
              "x": -12.405,
              "y": 22.11,
              "z": 1.145
            },
            "gtin": "4015200035185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6f2",
            "leftCorner": {
              "x": -12.406,
              "y": 22.101,
              "z": 1.145
            },
            "rightCorner": {
              "x": -12.506,
              "y": 22.109,
              "z": 1.145
            },
            "gtin": "4015200034997",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546451",
        "height": 1.7022,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee21",
            "leftCorner": {
              "x": -11.305,
              "y": 22.003,
              "z": 1.393
            },
            "rightCorner": {
              "x": -11.463,
              "y": 22.014,
              "z": 1.393
            },
            "gtin": "4015200035062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee22",
            "leftCorner": {
              "x": -11.463,
              "y": 22.014,
              "z": 1.393
            },
            "rightCorner": {
              "x": -11.622,
              "y": 22.027,
              "z": 1.393
            },
            "gtin": "4015200035062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee23",
            "leftCorner": {
              "x": -11.622,
              "y": 22.027,
              "z": 1.393
            },
            "rightCorner": {
              "x": -11.781,
              "y": 22.038,
              "z": 1.393
            },
            "gtin": "4015200035062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee24",
            "leftCorner": {
              "x": -11.781,
              "y": 22.038,
              "z": 1.393
            },
            "rightCorner": {
              "x": -11.939,
              "y": 22.05,
              "z": 1.393
            },
            "gtin": "4015200035062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee18",
            "leftCorner": {
              "x": -11.938,
              "y": 22.058,
              "z": 1.393
            },
            "rightCorner": {
              "x": -12.127,
              "y": 22.071,
              "z": 1.393
            },
            "gtin": "4015200035017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee19",
            "leftCorner": {
              "x": -12.127,
              "y": 22.071,
              "z": 1.393
            },
            "rightCorner": {
              "x": -12.316,
              "y": 22.085,
              "z": 1.393
            },
            "gtin": "4015200035017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee1a",
            "leftCorner": {
              "x": -12.316,
              "y": 22.085,
              "z": 1.393
            },
            "rightCorner": {
              "x": -12.506,
              "y": 22.1,
              "z": 1.393
            },
            "gtin": "4015200035017",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41ac6",
    "rightNeighborShelfId": "41ac8"
  },
  {
    "id": "41ac8",
    "name": "41ac8",
    "x": -12.502,
    "y": 22.147,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9993,
      "w": 0.037315
    },

    "layers": [],
    "leftNeighborShelfId": "41ac7"
  },
  {
    "id": "41ac9",
    "name": "41ac9",
    "x": -14.047,
    "y": 22.979,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69518,
      "w": 0.71884
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 28,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54645c",
        "height": 0.13571,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee2c",
            "leftCorner": {
              "x": -14.095,
              "y": 22.996,
              "z": 0.111
            },
            "rightCorner": {
              "x": -14.092,
              "y": 23.1,
              "z": 0.111
            },
            "gtin": "4262429770124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee2d",
            "leftCorner": {
              "x": -14.092,
              "y": 23.1,
              "z": 0.111
            },
            "rightCorner": {
              "x": -14.088,
              "y": 23.203,
              "z": 0.111
            },
            "gtin": "4262429770124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee2e",
            "leftCorner": {
              "x": -14.095,
              "y": 23.203,
              "z": 0.111
            },
            "rightCorner": {
              "x": -14.091,
              "y": 23.326,
              "z": 0.111
            },
            "gtin": "4262429770131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee2f",
            "leftCorner": {
              "x": -14.091,
              "y": 23.326,
              "z": 0.111
            },
            "rightCorner": {
              "x": -14.087,
              "y": 23.449,
              "z": 0.111
            },
            "gtin": "4262429770131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee2b",
            "leftCorner": {
              "x": -14.085,
              "y": 23.449,
              "z": 0.111
            },
            "rightCorner": {
              "x": -14.079,
              "y": 23.61,
              "z": 0.111
            },
            "gtin": "4262429770117",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546459",
        "height": 0.59271,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee36",
            "leftCorner": {
              "x": -14.061,
              "y": 22.979,
              "z": 0.485
            },
            "rightCorner": {
              "x": -14.057,
              "y": 23.098,
              "z": 0.485
            },
            "gtin": "4001499957536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee37",
            "leftCorner": {
              "x": -14.057,
              "y": 23.098,
              "z": 0.485
            },
            "rightCorner": {
              "x": -14.053,
              "y": 23.216,
              "z": 0.485
            },
            "gtin": "4001499957536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee38",
            "leftCorner": {
              "x": -14.053,
              "y": 23.216,
              "z": 0.485
            },
            "rightCorner": {
              "x": -14.049,
              "y": 23.333,
              "z": 0.485
            },
            "gtin": "4001499957536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee39",
            "leftCorner": {
              "x": -14.049,
              "y": 23.333,
              "z": 0.485
            },
            "rightCorner": {
              "x": -14.045,
              "y": 23.452,
              "z": 0.485
            },
            "gtin": "4001499957536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee3a",
            "leftCorner": {
              "x": -14.075,
              "y": 23.453,
              "z": 0.485
            },
            "rightCorner": {
              "x": -14.072,
              "y": 23.531,
              "z": 0.485
            },
            "gtin": "4015200033549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee3b",
            "leftCorner": {
              "x": -14.072,
              "y": 23.531,
              "z": 0.485
            },
            "rightCorner": {
              "x": -14.07,
              "y": 23.61,
              "z": 0.485
            },
            "gtin": "4015200033549",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546458",
        "height": 1.0471,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee30",
            "leftCorner": {
              "x": -14.051,
              "y": 22.979,
              "z": 0.857
            },
            "rightCorner": {
              "x": -14.049,
              "y": 23.046,
              "z": 0.857
            },
            "gtin": "4001499957536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee31",
            "leftCorner": {
              "x": -14.049,
              "y": 23.046,
              "z": 0.857
            },
            "rightCorner": {
              "x": -14.046,
              "y": 23.112,
              "z": 0.857
            },
            "gtin": "4001499957536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee32",
            "leftCorner": {
              "x": -14.086,
              "y": 23.114,
              "z": 0.857
            },
            "rightCorner": {
              "x": -14.082,
              "y": 23.238,
              "z": 0.857
            },
            "gtin": "4015200033600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee33",
            "leftCorner": {
              "x": -14.082,
              "y": 23.238,
              "z": 0.857
            },
            "rightCorner": {
              "x": -14.079,
              "y": 23.363,
              "z": 0.857
            },
            "gtin": "4015200033600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee34",
            "leftCorner": {
              "x": -14.079,
              "y": 23.363,
              "z": 0.857
            },
            "rightCorner": {
              "x": -14.075,
              "y": 23.486,
              "z": 0.857
            },
            "gtin": "4015200033600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee35",
            "leftCorner": {
              "x": -14.075,
              "y": 23.486,
              "z": 0.857
            },
            "rightCorner": {
              "x": -14.07,
              "y": 23.61,
              "z": 0.857
            },
            "gtin": "4015200033600",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54645a",
        "height": 1.4021,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee25",
            "leftCorner": {
              "x": -14.052,
              "y": 22.979,
              "z": 1.147
            },
            "rightCorner": {
              "x": -14.045,
              "y": 23.169,
              "z": 1.147
            },
            "gtin": "5412533420128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee26",
            "leftCorner": {
              "x": -14.045,
              "y": 23.169,
              "z": 1.147
            },
            "rightCorner": {
              "x": -14.039,
              "y": 23.359,
              "z": 1.147
            },
            "gtin": "5412533420128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee27",
            "leftCorner": {
              "x": -14.039,
              "y": 23.359,
              "z": 1.147
            },
            "rightCorner": {
              "x": -14.033,
              "y": 23.549,
              "z": 1.147
            },
            "gtin": "5412533420128",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54645b",
        "height": 1.6911,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee3c",
            "leftCorner": {
              "x": -14.053,
              "y": 22.979,
              "z": 1.384
            },
            "rightCorner": {
              "x": -14.051,
              "y": 23.027,
              "z": 1.384
            },
            "gtin": "5412533419887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee3d",
            "leftCorner": {
              "x": -14.051,
              "y": 23.027,
              "z": 1.384
            },
            "rightCorner": {
              "x": -14.05,
              "y": 23.077,
              "z": 1.384
            },
            "gtin": "5412533419887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee40",
            "leftCorner": {
              "x": -14.088,
              "y": 23.078,
              "z": 1.384
            },
            "rightCorner": {
              "x": -14.086,
              "y": 23.135,
              "z": 1.384
            },
            "gtin": "5412533424584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee41",
            "leftCorner": {
              "x": -14.086,
              "y": 23.135,
              "z": 1.384
            },
            "rightCorner": {
              "x": -14.084,
              "y": 23.192,
              "z": 1.384
            },
            "gtin": "5412533424584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee42",
            "leftCorner": {
              "x": -14.088,
              "y": 23.193,
              "z": 1.384
            },
            "rightCorner": {
              "x": -14.084,
              "y": 23.297,
              "z": 1.384
            },
            "gtin": "5412533424553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee43",
            "leftCorner": {
              "x": -14.084,
              "y": 23.297,
              "z": 1.384
            },
            "rightCorner": {
              "x": -14.082,
              "y": 23.4,
              "z": 1.384
            },
            "gtin": "5412533424553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee3e",
            "leftCorner": {
              "x": -14.082,
              "y": 23.4,
              "z": 1.384
            },
            "rightCorner": {
              "x": -14.078,
              "y": 23.505,
              "z": 1.384
            },
            "gtin": "5412533420166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee3f",
            "leftCorner": {
              "x": -14.078,
              "y": 23.505,
              "z": 1.384
            },
            "rightCorner": {
              "x": -14.074,
              "y": 23.61,
              "z": 1.384
            },
            "gtin": "5412533420166",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "edece",
    "rightNeighborShelfId": "41aca"
  },
  {
    "id": "41aca",
    "name": "41aca",
    "x": -14.026,
    "y": 23.603,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69518,
      "w": 0.71884
    },

    "layers": [],
    "leftNeighborShelfId": "41ac9",
    "rightNeighborShelfId": "41acb"
  },
  {
    "id": "41acb",
    "name": "41acb",
    "x": -13.986,
    "y": 24.803,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69518,
      "w": 0.71884
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 4,
      "unknownStockCount": 22,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54646c",
        "height": 1.0435,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f08d",
            "leftCorner": {
              "x": -13.972,
              "y": 25.046,
              "z": 0.854
            },
            "rightCorner": {
              "x": -13.963,
              "y": 25.289,
              "z": 0.854
            }
          },
          {
            "id": "68300c875ed67a01d9a1f08e",
            "leftCorner": {
              "x": -13.963,
              "y": 25.289,
              "z": 0.854
            },
            "rightCorner": {
              "x": -13.955,
              "y": 25.532,
              "z": 0.854
            }
          },
          {
            "id": "68300c875ed67a01d9a1f08c",
            "leftCorner": {
              "x": -13.98,
              "y": 24.803,
              "z": 0.854
            },
            "rightCorner": {
              "x": -13.972,
              "y": 25.046,
              "z": 0.854
            }
          },
          {
            "id": "68300c875ed67a01d9a1f08f",
            "leftCorner": {
              "x": -13.997,
              "y": 25.533,
              "z": 0.854
            },
            "rightCorner": {
              "x": -13.991,
              "y": 25.691,
              "z": 0.854
            },
            "gtin": "8718951580329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f090",
            "leftCorner": {
              "x": -13.991,
              "y": 25.691,
              "z": 0.854
            },
            "rightCorner": {
              "x": -13.986,
              "y": 25.846,
              "z": 0.854
            },
            "gtin": "8718951580329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f091",
            "leftCorner": {
              "x": -13.986,
              "y": 25.846,
              "z": 0.854
            },
            "rightCorner": {
              "x": -13.981,
              "y": 26.004,
              "z": 0.854
            },
            "gtin": "8718951580329",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54646a",
        "height": 0.14933,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f082",
            "leftCorner": {
              "x": -14.009,
              "y": 24.804,
              "z": 0.122
            },
            "rightCorner": {
              "x": -14.002,
              "y": 25.018,
              "z": 0.122
            },
            "gtin": "8700216695077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f083",
            "leftCorner": {
              "x": -14.002,
              "y": 25.018,
              "z": 0.122
            },
            "rightCorner": {
              "x": -13.994,
              "y": 25.233,
              "z": 0.122
            },
            "gtin": "8700216695077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f084",
            "leftCorner": {
              "x": -13.994,
              "y": 25.233,
              "z": 0.122
            },
            "rightCorner": {
              "x": -13.987,
              "y": 25.448,
              "z": 0.122
            },
            "gtin": "8700216695077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f085",
            "leftCorner": {
              "x": -13.987,
              "y": 25.448,
              "z": 0.122
            },
            "rightCorner": {
              "x": -13.98,
              "y": 25.663,
              "z": 0.122
            },
            "gtin": "8700216695077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f086",
            "leftCorner": {
              "x": -14.026,
              "y": 25.664,
              "z": 0.122
            },
            "rightCorner": {
              "x": -14.022,
              "y": 25.778,
              "z": 0.122
            },
            "gtin": "8700216694223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f087",
            "leftCorner": {
              "x": -14.022,
              "y": 25.778,
              "z": 0.122
            },
            "rightCorner": {
              "x": -14.019,
              "y": 25.891,
              "z": 0.122
            },
            "gtin": "8700216694223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f088",
            "leftCorner": {
              "x": -14.019,
              "y": 25.891,
              "z": 0.122
            },
            "rightCorner": {
              "x": -14.015,
              "y": 26.005,
              "z": 0.122
            },
            "gtin": "8700216694223",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546468",
        "height": 0.59056,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f075",
            "leftCorner": {
              "x": -13.996,
              "y": 24.803,
              "z": 0.483
            },
            "rightCorner": {
              "x": -13.992,
              "y": 24.916,
              "z": 0.483
            },
            "gtin": "8700216694407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f076",
            "leftCorner": {
              "x": -13.992,
              "y": 24.916,
              "z": 0.483
            },
            "rightCorner": {
              "x": -13.988,
              "y": 25.029,
              "z": 0.483
            },
            "gtin": "8700216694407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f077",
            "leftCorner": {
              "x": -13.988,
              "y": 25.029,
              "z": 0.483
            },
            "rightCorner": {
              "x": -13.985,
              "y": 25.14,
              "z": 0.483
            },
            "gtin": "8700216694407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f078",
            "leftCorner": {
              "x": -13.985,
              "y": 25.14,
              "z": 0.483
            },
            "rightCorner": {
              "x": -13.981,
              "y": 25.253,
              "z": 0.483
            },
            "gtin": "8700216694407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f07b",
            "leftCorner": {
              "x": -14.019,
              "y": 25.254,
              "z": 0.483
            },
            "rightCorner": {
              "x": -14.015,
              "y": 25.38,
              "z": 0.483
            },
            "gtin": "8700216695015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f07c",
            "leftCorner": {
              "x": -14.015,
              "y": 25.38,
              "z": 0.483
            },
            "rightCorner": {
              "x": -14.011,
              "y": 25.506,
              "z": 0.483
            },
            "gtin": "8700216695015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f07d",
            "leftCorner": {
              "x": -14.011,
              "y": 25.506,
              "z": 0.483
            },
            "rightCorner": {
              "x": -14.006,
              "y": 25.632,
              "z": 0.483
            },
            "gtin": "8700216695015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f07e",
            "leftCorner": {
              "x": -14.006,
              "y": 25.632,
              "z": 0.483
            },
            "rightCorner": {
              "x": -14.002,
              "y": 25.757,
              "z": 0.483
            },
            "gtin": "8700216695015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f079",
            "leftCorner": {
              "x": -14.009,
              "y": 25.757,
              "z": 0.483
            },
            "rightCorner": {
              "x": -14.005,
              "y": 25.881,
              "z": 0.483
            },
            "gtin": "8700216695206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f07a",
            "leftCorner": {
              "x": -14.005,
              "y": 25.881,
              "z": 0.483
            },
            "rightCorner": {
              "x": -14.001,
              "y": 26.004,
              "z": 0.483
            },
            "gtin": "8700216695206",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54646b",
        "height": 1.3887,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f089",
            "leftCorner": {
              "x": -13.979,
              "y": 24.803,
              "z": 1.136
            },
            "rightCorner": {
              "x": -13.963,
              "y": 25.285,
              "z": 1.136
            },
            "gtin": "4013162031436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f08a",
            "leftCorner": {
              "x": -13.963,
              "y": 25.285,
              "z": 1.136
            },
            "rightCorner": {
              "x": -13.947,
              "y": 25.767,
              "z": 1.136
            },
            "gtin": "4013162031436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f08b",
            "leftCorner": {
              "x": -13.992,
              "y": 25.769,
              "z": 1.136
            },
            "rightCorner": {
              "x": -13.984,
              "y": 26.004,
              "z": 1.136
            },
            "gtin": "4013162031399",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546469",
        "height": 1.6988,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f07f",
            "leftCorner": {
              "x": -13.972,
              "y": 24.803,
              "z": 1.39
            },
            "rightCorner": {
              "x": -13.951,
              "y": 25.429,
              "z": 1.39
            },
            "gtin": "4013162031313",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c875ed67a01d9a1f081",
            "leftCorner": {
              "x": -13.993,
              "y": 25.43,
              "z": 1.39
            },
            "rightCorner": {
              "x": -13.983,
              "y": 25.725,
              "z": 1.39
            },
            "gtin": "4013162031375",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c875ed67a01d9a1f080",
            "leftCorner": {
              "x": -13.976,
              "y": 25.725,
              "z": 1.39
            },
            "rightCorner": {
              "x": -13.968,
              "y": 26.003,
              "z": 1.39
            },
            "gtin": "4013162034925",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41aca",
    "rightNeighborShelfId": "eded2"
  },
  {
    "id": "41acc",
    "name": "41acc",
    "x": -13.758,
    "y": 27.419,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68276,
      "w": 0.73065
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 58,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5461f4",
        "height": 0.15714,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d75a",
            "leftCorner": {
              "x": -13.772,
              "y": 27.421,
              "z": 0.129
            },
            "rightCorner": {
              "x": -13.764,
              "y": 27.54,
              "z": 0.129
            },
            "gtin": "8700216694933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d75b",
            "leftCorner": {
              "x": -13.764,
              "y": 27.54,
              "z": 0.129
            },
            "rightCorner": {
              "x": -13.755,
              "y": 27.66,
              "z": 0.129
            },
            "gtin": "8700216694933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d760",
            "leftCorner": {
              "x": -13.797,
              "y": 27.663,
              "z": 0.129
            },
            "rightCorner": {
              "x": -13.79,
              "y": 27.766,
              "z": 0.129
            },
            "gtin": "8700216694827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d761",
            "leftCorner": {
              "x": -13.79,
              "y": 27.766,
              "z": 0.129
            },
            "rightCorner": {
              "x": -13.783,
              "y": 27.87,
              "z": 0.129
            },
            "gtin": "8700216694827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d762",
            "leftCorner": {
              "x": -13.771,
              "y": 27.869,
              "z": 0.129
            },
            "rightCorner": {
              "x": -13.765,
              "y": 27.963,
              "z": 0.129
            },
            "gtin": "8700216694100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d763",
            "leftCorner": {
              "x": -13.765,
              "y": 27.963,
              "z": 0.129
            },
            "rightCorner": {
              "x": -13.759,
              "y": 28.057,
              "z": 0.129
            },
            "gtin": "8700216694100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d764",
            "leftCorner": {
              "x": -13.759,
              "y": 28.057,
              "z": 0.129
            },
            "rightCorner": {
              "x": -13.751,
              "y": 28.151,
              "z": 0.129
            },
            "gtin": "8700216694100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d765",
            "leftCorner": {
              "x": -13.751,
              "y": 28.151,
              "z": 0.129
            },
            "rightCorner": {
              "x": -13.745,
              "y": 28.245,
              "z": 0.129
            },
            "gtin": "8700216694100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d75c",
            "leftCorner": {
              "x": -13.759,
              "y": 28.246,
              "z": 0.129
            },
            "rightCorner": {
              "x": -13.753,
              "y": 28.34,
              "z": 0.129
            },
            "gtin": "8700216283038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d75d",
            "leftCorner": {
              "x": -13.753,
              "y": 28.34,
              "z": 0.129
            },
            "rightCorner": {
              "x": -13.747,
              "y": 28.434,
              "z": 0.129
            },
            "gtin": "8700216283038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d75e",
            "leftCorner": {
              "x": -13.747,
              "y": 28.434,
              "z": 0.129
            },
            "rightCorner": {
              "x": -13.741,
              "y": 28.526,
              "z": 0.129
            },
            "gtin": "8700216283038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d75f",
            "leftCorner": {
              "x": -13.741,
              "y": 28.526,
              "z": 0.129
            },
            "rightCorner": {
              "x": -13.735,
              "y": 28.62,
              "z": 0.129
            },
            "gtin": "8700216283038",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461f3",
        "height": 0.59527,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d74f",
            "leftCorner": {
              "x": -13.774,
              "y": 27.421,
              "z": 0.487
            },
            "rightCorner": {
              "x": -13.764,
              "y": 27.563,
              "z": 0.487
            },
            "gtin": "8700216694285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d750",
            "leftCorner": {
              "x": -13.764,
              "y": 27.563,
              "z": 0.487
            },
            "rightCorner": {
              "x": -13.754,
              "y": 27.707,
              "z": 0.487
            },
            "gtin": "8700216694285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d751",
            "leftCorner": {
              "x": -13.754,
              "y": 27.707,
              "z": 0.487
            },
            "rightCorner": {
              "x": -13.745,
              "y": 27.85,
              "z": 0.487
            },
            "gtin": "8700216694285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d752",
            "leftCorner": {
              "x": -13.745,
              "y": 27.85,
              "z": 0.487
            },
            "rightCorner": {
              "x": -13.734,
              "y": 27.994,
              "z": 0.487
            },
            "gtin": "8700216694285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d755",
            "leftCorner": {
              "x": -13.77,
              "y": 27.996,
              "z": 0.487
            },
            "rightCorner": {
              "x": -13.766,
              "y": 28.079,
              "z": 0.487
            },
            "gtin": "8700216283465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d756",
            "leftCorner": {
              "x": -13.766,
              "y": 28.079,
              "z": 0.487
            },
            "rightCorner": {
              "x": -13.76,
              "y": 28.163,
              "z": 0.487
            },
            "gtin": "8700216283465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d757",
            "leftCorner": {
              "x": -13.76,
              "y": 28.163,
              "z": 0.487
            },
            "rightCorner": {
              "x": -13.754,
              "y": 28.247,
              "z": 0.487
            },
            "gtin": "8700216283465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d758",
            "leftCorner": {
              "x": -13.755,
              "y": 28.247,
              "z": 0.487
            },
            "rightCorner": {
              "x": -13.751,
              "y": 28.324,
              "z": 0.487
            },
            "gtin": "8700216694667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d759",
            "leftCorner": {
              "x": -13.751,
              "y": 28.324,
              "z": 0.487
            },
            "rightCorner": {
              "x": -13.745,
              "y": 28.399,
              "z": 0.487
            },
            "gtin": "8700216694667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d753",
            "leftCorner": {
              "x": -13.744,
              "y": 28.399,
              "z": 0.487
            },
            "rightCorner": {
              "x": -13.736,
              "y": 28.51,
              "z": 0.487
            },
            "gtin": "8700216694377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d754",
            "leftCorner": {
              "x": -13.736,
              "y": 28.51,
              "z": 0.487
            },
            "rightCorner": {
              "x": -13.73,
              "y": 28.62,
              "z": 0.487
            },
            "gtin": "8700216694377",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461f0",
        "height": 1.06,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d72b",
            "leftCorner": {
              "x": -13.764,
              "y": 27.419,
              "z": 0.867
            },
            "rightCorner": {
              "x": -13.757,
              "y": 27.532,
              "z": 0.867
            },
            "gtin": "8700216694339",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d72c",
            "leftCorner": {
              "x": -13.757,
              "y": 27.532,
              "z": 0.867
            },
            "rightCorner": {
              "x": -13.749,
              "y": 27.645,
              "z": 0.867
            },
            "gtin": "8700216694339",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d72d",
            "leftCorner": {
              "x": -13.749,
              "y": 27.645,
              "z": 0.867
            },
            "rightCorner": {
              "x": -13.742,
              "y": 27.759,
              "z": 0.867
            },
            "gtin": "8700216694339",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d72e",
            "leftCorner": {
              "x": -13.742,
              "y": 27.759,
              "z": 0.867
            },
            "rightCorner": {
              "x": -13.734,
              "y": 27.871,
              "z": 0.867
            },
            "gtin": "8700216694339",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d72f",
            "leftCorner": {
              "x": -13.774,
              "y": 27.874,
              "z": 0.867
            },
            "rightCorner": {
              "x": -13.757,
              "y": 28.123,
              "z": 0.867
            },
            "gtin": "8700216694223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d730",
            "leftCorner": {
              "x": -13.757,
              "y": 28.123,
              "z": 0.867
            },
            "rightCorner": {
              "x": -13.74,
              "y": 28.371,
              "z": 0.867
            },
            "gtin": "8700216694223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d731",
            "leftCorner": {
              "x": -13.74,
              "y": 28.371,
              "z": 0.867
            },
            "rightCorner": {
              "x": -13.723,
              "y": 28.62,
              "z": 0.867
            },
            "gtin": "8700216694223",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461f2",
        "height": 1.4123,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d743",
            "leftCorner": {
              "x": -13.762,
              "y": 27.419,
              "z": 1.156
            },
            "rightCorner": {
              "x": -13.756,
              "y": 27.504,
              "z": 1.156
            },
            "gtin": "4022142115035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d744",
            "leftCorner": {
              "x": -13.756,
              "y": 27.504,
              "z": 1.156
            },
            "rightCorner": {
              "x": -13.75,
              "y": 27.589,
              "z": 1.156
            },
            "gtin": "4022142115035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d747",
            "leftCorner": {
              "x": -13.798,
              "y": 27.592,
              "z": 1.156
            },
            "rightCorner": {
              "x": -13.789,
              "y": 27.735,
              "z": 1.156
            },
            "gtin": "4251758404220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d748",
            "leftCorner": {
              "x": -13.789,
              "y": 27.735,
              "z": 1.156
            },
            "rightCorner": {
              "x": -13.779,
              "y": 27.877,
              "z": 1.156
            },
            "gtin": "4251758404220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d749",
            "leftCorner": {
              "x": -13.774,
              "y": 27.877,
              "z": 1.156
            },
            "rightCorner": {
              "x": -13.764,
              "y": 28.022,
              "z": 1.156
            },
            "gtin": "8001090747723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d74a",
            "leftCorner": {
              "x": -13.749,
              "y": 28.021,
              "z": 1.156
            },
            "rightCorner": {
              "x": -13.741,
              "y": 28.132,
              "z": 1.156
            },
            "gtin": "4013162014392",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d74b",
            "leftCorner": {
              "x": -13.751,
              "y": 28.132,
              "z": 1.156
            },
            "rightCorner": {
              "x": -13.745,
              "y": 28.221,
              "z": 1.156
            },
            "gtin": "8006540923306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d74c",
            "leftCorner": {
              "x": -13.745,
              "y": 28.221,
              "z": 1.156
            },
            "rightCorner": {
              "x": -13.739,
              "y": 28.31,
              "z": 1.156
            },
            "gtin": "8006540923306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d74d",
            "leftCorner": {
              "x": -13.739,
              "y": 28.31,
              "z": 1.156
            },
            "rightCorner": {
              "x": -13.732,
              "y": 28.408,
              "z": 1.156
            },
            "gtin": "8700216633802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d74e",
            "leftCorner": {
              "x": -13.732,
              "y": 28.408,
              "z": 1.156
            },
            "rightCorner": {
              "x": -13.726,
              "y": 28.506,
              "z": 1.156
            },
            "gtin": "8700216633802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d745",
            "leftCorner": {
              "x": -13.72,
              "y": 28.505,
              "z": 1.156
            },
            "rightCorner": {
              "x": -13.716,
              "y": 28.562,
              "z": 1.156
            },
            "gtin": "8700216680318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d746",
            "leftCorner": {
              "x": -13.716,
              "y": 28.562,
              "z": 1.156
            },
            "rightCorner": {
              "x": -13.712,
              "y": 28.619,
              "z": 1.156
            },
            "gtin": "8700216680318",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461f1",
        "height": 1.7034,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d732",
            "leftCorner": {
              "x": -13.76,
              "y": 27.419,
              "z": 1.394
            },
            "rightCorner": {
              "x": -13.749,
              "y": 27.578,
              "z": 1.394
            },
            "gtin": "8700216634038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d734",
            "leftCorner": {
              "x": -13.789,
              "y": 27.581,
              "z": 1.394
            },
            "rightCorner": {
              "x": -13.785,
              "y": 27.628,
              "z": 1.394
            },
            "gtin": "8700216700764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d735",
            "leftCorner": {
              "x": -13.785,
              "y": 27.628,
              "z": 1.394
            },
            "rightCorner": {
              "x": -13.782,
              "y": 27.677,
              "z": 1.394
            },
            "gtin": "8700216700764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d736",
            "leftCorner": {
              "x": -13.782,
              "y": 27.677,
              "z": 1.394
            },
            "rightCorner": {
              "x": -13.778,
              "y": 27.725,
              "z": 1.394
            },
            "gtin": "8700216700764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d737",
            "leftCorner": {
              "x": -13.778,
              "y": 27.725,
              "z": 1.394
            },
            "rightCorner": {
              "x": -13.773,
              "y": 27.8,
              "z": 1.394
            },
            "gtin": "8700216633994",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d738",
            "leftCorner": {
              "x": -13.773,
              "y": 27.8,
              "z": 1.394
            },
            "rightCorner": {
              "x": -13.769,
              "y": 27.875,
              "z": 1.394
            },
            "gtin": "8700216633994",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d739",
            "leftCorner": {
              "x": -13.769,
              "y": 27.875,
              "z": 1.394
            },
            "rightCorner": {
              "x": -13.763,
              "y": 27.95,
              "z": 1.394
            },
            "gtin": "8700216633994",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d73a",
            "leftCorner": {
              "x": -13.76,
              "y": 27.95,
              "z": 1.394
            },
            "rightCorner": {
              "x": -13.755,
              "y": 28.022,
              "z": 1.394
            },
            "gtin": "8700216633581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d73b",
            "leftCorner": {
              "x": -13.755,
              "y": 28.022,
              "z": 1.394
            },
            "rightCorner": {
              "x": -13.751,
              "y": 28.095,
              "z": 1.394
            },
            "gtin": "8700216633581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d73c",
            "leftCorner": {
              "x": -13.757,
              "y": 28.096,
              "z": 1.394
            },
            "rightCorner": {
              "x": -13.752,
              "y": 28.161,
              "z": 1.394
            },
            "gtin": "8700216633727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d73d",
            "leftCorner": {
              "x": -13.752,
              "y": 28.161,
              "z": 1.394
            },
            "rightCorner": {
              "x": -13.748,
              "y": 28.228,
              "z": 1.394
            },
            "gtin": "8700216633727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d73e",
            "leftCorner": {
              "x": -13.746,
              "y": 28.228,
              "z": 1.394
            },
            "rightCorner": {
              "x": -13.743,
              "y": 28.28,
              "z": 1.394
            },
            "gtin": "8700216680301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d73f",
            "leftCorner": {
              "x": -13.743,
              "y": 28.28,
              "z": 1.394
            },
            "rightCorner": {
              "x": -13.739,
              "y": 28.331,
              "z": 1.394
            },
            "gtin": "8700216680301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d740",
            "leftCorner": {
              "x": -13.739,
              "y": 28.331,
              "z": 1.394
            },
            "rightCorner": {
              "x": -13.736,
              "y": 28.383,
              "z": 1.394
            },
            "gtin": "8700216680301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d741",
            "leftCorner": {
              "x": -13.728,
              "y": 28.383,
              "z": 1.394
            },
            "rightCorner": {
              "x": -13.723,
              "y": 28.443,
              "z": 1.394
            },
            "gtin": "8700216633703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d742",
            "leftCorner": {
              "x": -13.723,
              "y": 28.443,
              "z": 1.394
            },
            "rightCorner": {
              "x": -13.72,
              "y": 28.503,
              "z": 1.394
            },
            "gtin": "8700216633703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d733",
            "leftCorner": {
              "x": -13.73,
              "y": 28.505,
              "z": 1.394
            },
            "rightCorner": {
              "x": -13.722,
              "y": 28.62,
              "z": 1.394
            },
            "gtin": "8006540923238",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "eded2",
    "rightNeighborShelfId": "41acd"
  },
  {
    "id": "41acd",
    "name": "41acd",
    "x": -13.677,
    "y": 28.617,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68276,
      "w": 0.73065
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 71
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546472",
        "height": 0.18042,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f0d6",
            "leftCorner": {
              "x": -13.684,
              "y": 28.82,
              "z": 0.148
            },
            "rightCorner": {
              "x": -13.671,
              "y": 29.021,
              "z": 0.148
            }
          },
          {
            "id": "68300c875ed67a01d9a1f0d7",
            "leftCorner": {
              "x": -13.671,
              "y": 29.021,
              "z": 0.148
            },
            "rightCorner": {
              "x": -13.657,
              "y": 29.223,
              "z": 0.148
            }
          },
          {
            "id": "68300c875ed67a01d9a1f0d8",
            "leftCorner": {
              "x": -13.657,
              "y": 29.223,
              "z": 0.148
            },
            "rightCorner": {
              "x": -13.644,
              "y": 29.425,
              "z": 0.148
            }
          },
          {
            "id": "68300c875ed67a01d9a1f0d5",
            "leftCorner": {
              "x": -13.698,
              "y": 28.619,
              "z": 0.148
            },
            "rightCorner": {
              "x": -13.684,
              "y": 28.82,
              "z": 0.148
            }
          },
          {
            "id": "68300c875ed67a01d9a1f0d9",
            "leftCorner": {
              "x": -13.684,
              "y": 29.427,
              "z": 0.148
            },
            "rightCorner": {
              "x": -13.678,
              "y": 29.506,
              "z": 0.148
            },
            "gtin": "4063367047831",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0da",
            "leftCorner": {
              "x": -13.678,
              "y": 29.506,
              "z": 0.148
            },
            "rightCorner": {
              "x": -13.673,
              "y": 29.584,
              "z": 0.148
            },
            "gtin": "4063367047831",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0db",
            "leftCorner": {
              "x": -13.673,
              "y": 29.584,
              "z": 0.148
            },
            "rightCorner": {
              "x": -13.668,
              "y": 29.663,
              "z": 0.148
            },
            "gtin": "4063367047831",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0dc",
            "leftCorner": {
              "x": -13.668,
              "y": 29.663,
              "z": 0.148
            },
            "rightCorner": {
              "x": -13.662,
              "y": 29.74,
              "z": 0.148
            },
            "gtin": "4063367047831",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0dd",
            "leftCorner": {
              "x": -13.662,
              "y": 29.74,
              "z": 0.148
            },
            "rightCorner": {
              "x": -13.657,
              "y": 29.818,
              "z": 0.148
            },
            "gtin": "4063367047831",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54646e",
        "height": 1.1515,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f09e",
            "leftCorner": {
              "x": -13.772,
              "y": 28.623,
              "z": 0.942
            },
            "rightCorner": {
              "x": -13.765,
              "y": 28.719,
              "z": 0.942
            },
            "gtin": "4015100810240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f09f",
            "leftCorner": {
              "x": -13.765,
              "y": 28.719,
              "z": 0.942
            },
            "rightCorner": {
              "x": -13.758,
              "y": 28.814,
              "z": 0.942
            },
            "gtin": "4015100810240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0a0",
            "leftCorner": {
              "x": -13.758,
              "y": 28.814,
              "z": 0.942
            },
            "rightCorner": {
              "x": -13.753,
              "y": 28.908,
              "z": 0.942
            },
            "gtin": "4015100810240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0a1",
            "leftCorner": {
              "x": -13.753,
              "y": 28.908,
              "z": 0.942
            },
            "rightCorner": {
              "x": -13.746,
              "y": 29.004,
              "z": 0.942
            },
            "gtin": "4015100810240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0a4",
            "leftCorner": {
              "x": -13.782,
              "y": 29.006,
              "z": 0.942
            },
            "rightCorner": {
              "x": -13.776,
              "y": 29.1,
              "z": 0.942
            },
            "gtin": "4015100810066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0a5",
            "leftCorner": {
              "x": -13.776,
              "y": 29.1,
              "z": 0.942
            },
            "rightCorner": {
              "x": -13.769,
              "y": 29.195,
              "z": 0.942
            },
            "gtin": "4015100810066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0a6",
            "leftCorner": {
              "x": -13.769,
              "y": 29.195,
              "z": 0.942
            },
            "rightCorner": {
              "x": -13.763,
              "y": 29.29,
              "z": 0.942
            },
            "gtin": "4015100810066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0a7",
            "leftCorner": {
              "x": -13.763,
              "y": 29.29,
              "z": 0.942
            },
            "rightCorner": {
              "x": -13.757,
              "y": 29.384,
              "z": 0.942
            },
            "gtin": "4015100810066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0a8",
            "leftCorner": {
              "x": -13.757,
              "y": 29.384,
              "z": 0.942
            },
            "rightCorner": {
              "x": -13.75,
              "y": 29.479,
              "z": 0.942
            },
            "gtin": "4015100810066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0a9",
            "leftCorner": {
              "x": -13.754,
              "y": 29.479,
              "z": 0.942
            },
            "rightCorner": {
              "x": -13.747,
              "y": 29.587,
              "z": 0.942
            },
            "gtin": "4015100860788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0aa",
            "leftCorner": {
              "x": -13.747,
              "y": 29.587,
              "z": 0.942
            },
            "rightCorner": {
              "x": -13.739,
              "y": 29.696,
              "z": 0.942
            },
            "gtin": "4015100860788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0a2",
            "leftCorner": {
              "x": -13.742,
              "y": 29.696,
              "z": 0.942
            },
            "rightCorner": {
              "x": -13.738,
              "y": 29.759,
              "z": 0.942
            },
            "gtin": "4015100810141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0a3",
            "leftCorner": {
              "x": -13.738,
              "y": 29.759,
              "z": 0.942
            },
            "rightCorner": {
              "x": -13.734,
              "y": 29.824,
              "z": 0.942
            },
            "gtin": "4015100810141",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546470",
        "height": 0.54682,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f0ba",
            "leftCorner": {
              "x": -13.784,
              "y": 28.625,
              "z": 0.447
            },
            "rightCorner": {
              "x": -13.777,
              "y": 28.728,
              "z": 0.447
            },
            "gtin": "4064666847955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0bb",
            "leftCorner": {
              "x": -13.777,
              "y": 28.728,
              "z": 0.447
            },
            "rightCorner": {
              "x": -13.769,
              "y": 28.831,
              "z": 0.447
            },
            "gtin": "4064666847955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0bc",
            "leftCorner": {
              "x": -13.769,
              "y": 28.831,
              "z": 0.447
            },
            "rightCorner": {
              "x": -13.762,
              "y": 28.934,
              "z": 0.447
            },
            "gtin": "4064666847955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0bd",
            "leftCorner": {
              "x": -13.762,
              "y": 28.934,
              "z": 0.447
            },
            "rightCorner": {
              "x": -13.755,
              "y": 29.038,
              "z": 0.447
            },
            "gtin": "4064666847955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0c1",
            "leftCorner": {
              "x": -13.797,
              "y": 29.041,
              "z": 0.447
            },
            "rightCorner": {
              "x": -13.792,
              "y": 29.129,
              "z": 0.447
            },
            "gtin": "4064666847924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0c2",
            "leftCorner": {
              "x": -13.792,
              "y": 29.129,
              "z": 0.447
            },
            "rightCorner": {
              "x": -13.785,
              "y": 29.217,
              "z": 0.447
            },
            "gtin": "4064666847924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0c3",
            "leftCorner": {
              "x": -13.785,
              "y": 29.217,
              "z": 0.447
            },
            "rightCorner": {
              "x": -13.78,
              "y": 29.306,
              "z": 0.447
            },
            "gtin": "4064666847924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0c4",
            "leftCorner": {
              "x": -13.78,
              "y": 29.306,
              "z": 0.447
            },
            "rightCorner": {
              "x": -13.773,
              "y": 29.394,
              "z": 0.447
            },
            "gtin": "4064666847924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0c5",
            "leftCorner": {
              "x": -13.773,
              "y": 29.394,
              "z": 0.447
            },
            "rightCorner": {
              "x": -13.767,
              "y": 29.483,
              "z": 0.447
            },
            "gtin": "4064666847924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0c6",
            "leftCorner": {
              "x": -13.767,
              "y": 29.483,
              "z": 0.447
            },
            "rightCorner": {
              "x": -13.761,
              "y": 29.572,
              "z": 0.447
            },
            "gtin": "4064666847924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0be",
            "leftCorner": {
              "x": -13.761,
              "y": 29.572,
              "z": 0.447
            },
            "rightCorner": {
              "x": -13.755,
              "y": 29.656,
              "z": 0.447
            },
            "gtin": "4068359038767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0bf",
            "leftCorner": {
              "x": -13.755,
              "y": 29.656,
              "z": 0.447
            },
            "rightCorner": {
              "x": -13.75,
              "y": 29.741,
              "z": 0.447
            },
            "gtin": "4068359038767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0c0",
            "leftCorner": {
              "x": -13.75,
              "y": 29.741,
              "z": 0.447
            },
            "rightCorner": {
              "x": -13.744,
              "y": 29.824,
              "z": 0.447
            },
            "gtin": "4068359038767",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54646d",
        "height": 0.84798,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f092",
            "leftCorner": {
              "x": -13.772,
              "y": 28.623,
              "z": 0.694
            },
            "rightCorner": {
              "x": -13.767,
              "y": 28.706,
              "z": 0.694
            },
            "gtin": "4015100810486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f093",
            "leftCorner": {
              "x": -13.767,
              "y": 28.706,
              "z": 0.694
            },
            "rightCorner": {
              "x": -13.761,
              "y": 28.787,
              "z": 0.694
            },
            "gtin": "4015100810486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f094",
            "leftCorner": {
              "x": -13.761,
              "y": 28.787,
              "z": 0.694
            },
            "rightCorner": {
              "x": -13.756,
              "y": 28.869,
              "z": 0.694
            },
            "gtin": "4015100810486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f095",
            "leftCorner": {
              "x": -13.756,
              "y": 28.869,
              "z": 0.694
            },
            "rightCorner": {
              "x": -13.749,
              "y": 28.95,
              "z": 0.694
            },
            "gtin": "4015100810486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f09a",
            "leftCorner": {
              "x": -13.78,
              "y": 28.953,
              "z": 0.694
            },
            "rightCorner": {
              "x": -13.773,
              "y": 29.069,
              "z": 0.694
            },
            "gtin": "4015100810448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f09b",
            "leftCorner": {
              "x": -13.773,
              "y": 29.069,
              "z": 0.694
            },
            "rightCorner": {
              "x": -13.765,
              "y": 29.185,
              "z": 0.694
            },
            "gtin": "4015100810448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f09c",
            "leftCorner": {
              "x": -13.765,
              "y": 29.185,
              "z": 0.694
            },
            "rightCorner": {
              "x": -13.757,
              "y": 29.301,
              "z": 0.694
            },
            "gtin": "4015100810448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f09d",
            "leftCorner": {
              "x": -13.757,
              "y": 29.301,
              "z": 0.694
            },
            "rightCorner": {
              "x": -13.749,
              "y": 29.417,
              "z": 0.694
            },
            "gtin": "4015100810448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f096",
            "leftCorner": {
              "x": -13.765,
              "y": 29.418,
              "z": 0.694
            },
            "rightCorner": {
              "x": -13.758,
              "y": 29.52,
              "z": 0.694
            },
            "gtin": "4015100810127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f097",
            "leftCorner": {
              "x": -13.758,
              "y": 29.52,
              "z": 0.694
            },
            "rightCorner": {
              "x": -13.752,
              "y": 29.621,
              "z": 0.694
            },
            "gtin": "4015100810127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f098",
            "leftCorner": {
              "x": -13.752,
              "y": 29.621,
              "z": 0.694
            },
            "rightCorner": {
              "x": -13.745,
              "y": 29.722,
              "z": 0.694
            },
            "gtin": "4015100810127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f099",
            "leftCorner": {
              "x": -13.745,
              "y": 29.722,
              "z": 0.694
            },
            "rightCorner": {
              "x": -13.738,
              "y": 29.824,
              "z": 0.694
            },
            "gtin": "4015100810127",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546471",
        "height": 1.4541,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f0c7",
            "leftCorner": {
              "x": -13.767,
              "y": 28.623,
              "z": 1.19
            },
            "rightCorner": {
              "x": -13.759,
              "y": 28.745,
              "z": 1.19
            },
            "gtin": "4015100800524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0c9",
            "leftCorner": {
              "x": -13.799,
              "y": 28.748,
              "z": 1.19
            },
            "rightCorner": {
              "x": -13.792,
              "y": 28.84,
              "z": 1.19
            },
            "gtin": "4015100800562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0ca",
            "leftCorner": {
              "x": -13.792,
              "y": 28.84,
              "z": 1.19
            },
            "rightCorner": {
              "x": -13.786,
              "y": 28.934,
              "z": 1.19
            },
            "gtin": "4015100800562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0cb",
            "leftCorner": {
              "x": -13.786,
              "y": 28.934,
              "z": 1.19
            },
            "rightCorner": {
              "x": -13.78,
              "y": 29.026,
              "z": 1.19
            },
            "gtin": "4015100800562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0cc",
            "leftCorner": {
              "x": -13.783,
              "y": 29.026,
              "z": 1.19
            },
            "rightCorner": {
              "x": -13.776,
              "y": 29.117,
              "z": 1.19
            },
            "gtin": "4064666587509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0cd",
            "leftCorner": {
              "x": -13.776,
              "y": 29.117,
              "z": 1.19
            },
            "rightCorner": {
              "x": -13.77,
              "y": 29.208,
              "z": 1.19
            },
            "gtin": "4064666587509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0ce",
            "leftCorner": {
              "x": -13.773,
              "y": 29.208,
              "z": 1.19
            },
            "rightCorner": {
              "x": -13.768,
              "y": 29.271,
              "z": 1.19
            },
            "gtin": "3614229728651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0cf",
            "leftCorner": {
              "x": -13.768,
              "y": 29.271,
              "z": 1.19
            },
            "rightCorner": {
              "x": -13.764,
              "y": 29.333,
              "z": 1.19
            },
            "gtin": "3614229728651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0d0",
            "leftCorner": {
              "x": -13.761,
              "y": 29.333,
              "z": 1.19
            },
            "rightCorner": {
              "x": -13.756,
              "y": 29.412,
              "z": 1.19
            },
            "gtin": "3614229728682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0d1",
            "leftCorner": {
              "x": -13.756,
              "y": 29.412,
              "z": 1.19
            },
            "rightCorner": {
              "x": -13.751,
              "y": 29.491,
              "z": 1.19
            },
            "gtin": "3614229728682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0d2",
            "leftCorner": {
              "x": -13.74,
              "y": 29.49,
              "z": 1.19
            },
            "rightCorner": {
              "x": -13.735,
              "y": 29.561,
              "z": 1.19
            },
            "gtin": "3614229728620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0d3",
            "leftCorner": {
              "x": -13.735,
              "y": 29.561,
              "z": 1.19
            },
            "rightCorner": {
              "x": -13.73,
              "y": 29.632,
              "z": 1.19
            },
            "gtin": "3614229728620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0d4",
            "leftCorner": {
              "x": -13.737,
              "y": 29.632,
              "z": 1.19
            },
            "rightCorner": {
              "x": -13.729,
              "y": 29.751,
              "z": 1.19
            },
            "gtin": "3614229728637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0c8",
            "leftCorner": {
              "x": -13.714,
              "y": 29.75,
              "z": 1.19
            },
            "rightCorner": {
              "x": -13.709,
              "y": 29.822,
              "z": 1.19
            },
            "gtin": "4005900981530",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54646f",
        "height": 1.7531,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f0ab",
            "leftCorner": {
              "x": -13.758,
              "y": 28.623,
              "z": 1.434
            },
            "rightCorner": {
              "x": -13.753,
              "y": 28.69,
              "z": 1.434
            },
            "gtin": "3600522471684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0ac",
            "leftCorner": {
              "x": -13.753,
              "y": 28.69,
              "z": 1.434
            },
            "rightCorner": {
              "x": -13.749,
              "y": 28.757,
              "z": 1.434
            },
            "gtin": "3600522471684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0ad",
            "leftCorner": {
              "x": -13.749,
              "y": 28.757,
              "z": 1.434
            },
            "rightCorner": {
              "x": -13.745,
              "y": 28.823,
              "z": 1.434
            },
            "gtin": "3600522471684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0ae",
            "leftCorner": {
              "x": -13.745,
              "y": 28.823,
              "z": 1.434
            },
            "rightCorner": {
              "x": -13.74,
              "y": 28.89,
              "z": 1.434
            },
            "gtin": "3600522471684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0b0",
            "leftCorner": {
              "x": -13.767,
              "y": 28.892,
              "z": 1.434
            },
            "rightCorner": {
              "x": -13.763,
              "y": 28.959,
              "z": 1.434
            },
            "gtin": "5037156225372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0b1",
            "leftCorner": {
              "x": -13.763,
              "y": 28.959,
              "z": 1.434
            },
            "rightCorner": {
              "x": -13.759,
              "y": 29.028,
              "z": 1.434
            },
            "gtin": "5037156225372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0b2",
            "leftCorner": {
              "x": -13.773,
              "y": 29.028,
              "z": 1.434
            },
            "rightCorner": {
              "x": -13.768,
              "y": 29.092,
              "z": 1.434
            },
            "gtin": "5037156225587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0b3",
            "leftCorner": {
              "x": -13.761,
              "y": 29.091,
              "z": 1.434
            },
            "rightCorner": {
              "x": -13.753,
              "y": 29.217,
              "z": 1.434
            },
            "gtin": "5037156225525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0b4",
            "leftCorner": {
              "x": -13.762,
              "y": 29.217,
              "z": 1.434
            },
            "rightCorner": {
              "x": -13.754,
              "y": 29.346,
              "z": 1.434
            },
            "gtin": "4002753283057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0b5",
            "leftCorner": {
              "x": -13.762,
              "y": 29.346,
              "z": 1.434
            },
            "rightCorner": {
              "x": -13.757,
              "y": 29.429,
              "z": 1.434
            },
            "gtin": "3600522280774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0b6",
            "leftCorner": {
              "x": -13.757,
              "y": 29.429,
              "z": 1.434
            },
            "rightCorner": {
              "x": -13.75,
              "y": 29.511,
              "z": 1.434
            },
            "gtin": "3600522280774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0b7",
            "leftCorner": {
              "x": -13.75,
              "y": 29.511,
              "z": 1.434
            },
            "rightCorner": {
              "x": -13.745,
              "y": 29.594,
              "z": 1.434
            },
            "gtin": "3600522280774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0b8",
            "leftCorner": {
              "x": -13.724,
              "y": 29.593,
              "z": 1.434
            },
            "rightCorner": {
              "x": -13.72,
              "y": 29.659,
              "z": 1.434
            },
            "gtin": "810006943474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0b9",
            "leftCorner": {
              "x": -13.725,
              "y": 29.659,
              "z": 1.434
            },
            "rightCorner": {
              "x": -13.719,
              "y": 29.746,
              "z": 1.434
            },
            "gtin": "4015100810806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0af",
            "leftCorner": {
              "x": -13.722,
              "y": 29.747,
              "z": 1.434
            },
            "rightCorner": {
              "x": -13.716,
              "y": 29.823,
              "z": 1.434
            },
            "gtin": "4015100810226",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41acc",
    "rightNeighborShelfId": "41ace"
  },
  {
    "id": "41ace",
    "name": "41ace",
    "x": -13.595,
    "y": 29.814,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68276,
      "w": 0.73065
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 74
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5461c1",
        "height": 0.1801,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d558",
            "leftCorner": {
              "x": -13.598,
              "y": 30.169,
              "z": 0.147
            },
            "rightCorner": {
              "x": -13.593,
              "y": 30.256,
              "z": 0.147
            }
          },
          {
            "id": "68300c845ed67a01d9a1d554",
            "leftCorner": {
              "x": -13.622,
              "y": 29.815,
              "z": 0.147
            },
            "rightCorner": {
              "x": -13.616,
              "y": 29.904,
              "z": 0.147
            }
          },
          {
            "id": "68300c845ed67a01d9a1d555",
            "leftCorner": {
              "x": -13.616,
              "y": 29.904,
              "z": 0.147
            },
            "rightCorner": {
              "x": -13.611,
              "y": 29.991,
              "z": 0.147
            }
          },
          {
            "id": "68300c845ed67a01d9a1d556",
            "leftCorner": {
              "x": -13.611,
              "y": 29.991,
              "z": 0.147
            },
            "rightCorner": {
              "x": -13.604,
              "y": 30.08,
              "z": 0.147
            }
          },
          {
            "id": "68300c845ed67a01d9a1d557",
            "leftCorner": {
              "x": -13.604,
              "y": 30.08,
              "z": 0.147
            },
            "rightCorner": {
              "x": -13.598,
              "y": 30.169,
              "z": 0.147
            }
          },
          {
            "id": "68300c845ed67a01d9a1d559",
            "leftCorner": {
              "x": -13.633,
              "y": 30.259,
              "z": 0.147
            },
            "rightCorner": {
              "x": -13.624,
              "y": 30.385,
              "z": 0.147
            },
            "gtin": "4063367047817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d55a",
            "leftCorner": {
              "x": -13.624,
              "y": 30.385,
              "z": 0.147
            },
            "rightCorner": {
              "x": -13.616,
              "y": 30.512,
              "z": 0.147
            },
            "gtin": "4063367047817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d55b",
            "leftCorner": {
              "x": -13.616,
              "y": 30.512,
              "z": 0.147
            },
            "rightCorner": {
              "x": -13.607,
              "y": 30.637,
              "z": 0.147
            },
            "gtin": "4063367047817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d55c",
            "leftCorner": {
              "x": -13.607,
              "y": 30.637,
              "z": 0.147
            },
            "rightCorner": {
              "x": -13.598,
              "y": 30.763,
              "z": 0.147
            },
            "gtin": "4063367047817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d55d",
            "leftCorner": {
              "x": -13.598,
              "y": 30.763,
              "z": 0.147
            },
            "rightCorner": {
              "x": -13.59,
              "y": 30.889,
              "z": 0.147
            },
            "gtin": "4063367047817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d55e",
            "leftCorner": {
              "x": -13.59,
              "y": 30.889,
              "z": 0.147
            },
            "rightCorner": {
              "x": -13.581,
              "y": 31.016,
              "z": 0.147
            },
            "gtin": "4063367047817",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461bd",
        "height": 0.54904,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d51a",
            "leftCorner": {
              "x": -13.703,
              "y": 29.821,
              "z": 0.449
            },
            "rightCorner": {
              "x": -13.698,
              "y": 29.9,
              "z": 0.449
            },
            "gtin": "4064666847917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d51b",
            "leftCorner": {
              "x": -13.698,
              "y": 29.9,
              "z": 0.449
            },
            "rightCorner": {
              "x": -13.693,
              "y": 29.979,
              "z": 0.449
            },
            "gtin": "4064666847917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d51c",
            "leftCorner": {
              "x": -13.693,
              "y": 29.979,
              "z": 0.449
            },
            "rightCorner": {
              "x": -13.687,
              "y": 30.06,
              "z": 0.449
            },
            "gtin": "4064666847917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d51d",
            "leftCorner": {
              "x": -13.687,
              "y": 30.06,
              "z": 0.449
            },
            "rightCorner": {
              "x": -13.681,
              "y": 30.139,
              "z": 0.449
            },
            "gtin": "4064666847917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d521",
            "leftCorner": {
              "x": -13.711,
              "y": 30.14,
              "z": 0.449
            },
            "rightCorner": {
              "x": -13.707,
              "y": 30.207,
              "z": 0.449
            },
            "gtin": "4064666847900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d522",
            "leftCorner": {
              "x": -13.707,
              "y": 30.207,
              "z": 0.449
            },
            "rightCorner": {
              "x": -13.702,
              "y": 30.274,
              "z": 0.449
            },
            "gtin": "4064666847900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d523",
            "leftCorner": {
              "x": -13.702,
              "y": 30.274,
              "z": 0.449
            },
            "rightCorner": {
              "x": -13.698,
              "y": 30.341,
              "z": 0.449
            },
            "gtin": "4064666847900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d524",
            "leftCorner": {
              "x": -13.698,
              "y": 30.341,
              "z": 0.449
            },
            "rightCorner": {
              "x": -13.693,
              "y": 30.407,
              "z": 0.449
            },
            "gtin": "4064666847900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d525",
            "leftCorner": {
              "x": -13.707,
              "y": 30.409,
              "z": 0.449
            },
            "rightCorner": {
              "x": -13.701,
              "y": 30.507,
              "z": 0.449
            },
            "gtin": "4064666847894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d526",
            "leftCorner": {
              "x": -13.701,
              "y": 30.507,
              "z": 0.449
            },
            "rightCorner": {
              "x": -13.694,
              "y": 30.605,
              "z": 0.449
            },
            "gtin": "4064666847894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d527",
            "leftCorner": {
              "x": -13.694,
              "y": 30.605,
              "z": 0.449
            },
            "rightCorner": {
              "x": -13.687,
              "y": 30.703,
              "z": 0.449
            },
            "gtin": "4064666847894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d528",
            "leftCorner": {
              "x": -13.687,
              "y": 30.703,
              "z": 0.449
            },
            "rightCorner": {
              "x": -13.681,
              "y": 30.802,
              "z": 0.449
            },
            "gtin": "4064666847894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d51e",
            "leftCorner": {
              "x": -13.681,
              "y": 30.802,
              "z": 0.449
            },
            "rightCorner": {
              "x": -13.676,
              "y": 30.875,
              "z": 0.449
            },
            "gtin": "4064666847870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d51f",
            "leftCorner": {
              "x": -13.676,
              "y": 30.875,
              "z": 0.449
            },
            "rightCorner": {
              "x": -13.671,
              "y": 30.948,
              "z": 0.449
            },
            "gtin": "4064666847870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d520",
            "leftCorner": {
              "x": -13.671,
              "y": 30.948,
              "z": 0.449
            },
            "rightCorner": {
              "x": -13.666,
              "y": 31.021,
              "z": 0.449
            },
            "gtin": "4064666847870",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461c0",
        "height": 0.84977,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d545",
            "leftCorner": {
              "x": -13.685,
              "y": 29.819,
              "z": 0.695
            },
            "rightCorner": {
              "x": -13.678,
              "y": 29.921,
              "z": 0.695
            },
            "gtin": "3600524163785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d546",
            "leftCorner": {
              "x": -13.678,
              "y": 29.921,
              "z": 0.695
            },
            "rightCorner": {
              "x": -13.671,
              "y": 30.023,
              "z": 0.695
            },
            "gtin": "3600524163785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d548",
            "leftCorner": {
              "x": -13.709,
              "y": 30.025,
              "z": 0.695
            },
            "rightCorner": {
              "x": -13.704,
              "y": 30.111,
              "z": 0.695
            },
            "gtin": "3600522910015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d549",
            "leftCorner": {
              "x": -13.704,
              "y": 30.111,
              "z": 0.695
            },
            "rightCorner": {
              "x": -13.697,
              "y": 30.197,
              "z": 0.695
            },
            "gtin": "3600522910015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d54a",
            "leftCorner": {
              "x": -13.697,
              "y": 30.197,
              "z": 0.695
            },
            "rightCorner": {
              "x": -13.692,
              "y": 30.283,
              "z": 0.695
            },
            "gtin": "3600522910015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d54b",
            "leftCorner": {
              "x": -13.694,
              "y": 30.283,
              "z": 0.695
            },
            "rightCorner": {
              "x": -13.689,
              "y": 30.348,
              "z": 0.695
            },
            "gtin": "7610099050423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d54c",
            "leftCorner": {
              "x": -13.689,
              "y": 30.348,
              "z": 0.695
            },
            "rightCorner": {
              "x": -13.685,
              "y": 30.413,
              "z": 0.695
            },
            "gtin": "7610099050423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d54d",
            "leftCorner": {
              "x": -13.686,
              "y": 30.413,
              "z": 0.695
            },
            "rightCorner": {
              "x": -13.681,
              "y": 30.48,
              "z": 0.695
            },
            "gtin": "3600524164614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d54e",
            "leftCorner": {
              "x": -13.681,
              "y": 30.48,
              "z": 0.695
            },
            "rightCorner": {
              "x": -13.677,
              "y": 30.547,
              "z": 0.695
            },
            "gtin": "3600524164614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d54f",
            "leftCorner": {
              "x": -13.677,
              "y": 30.547,
              "z": 0.695
            },
            "rightCorner": {
              "x": -13.672,
              "y": 30.613,
              "z": 0.695
            },
            "gtin": "3600524164614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d550",
            "leftCorner": {
              "x": -13.672,
              "y": 30.613,
              "z": 0.695
            },
            "rightCorner": {
              "x": -13.668,
              "y": 30.68,
              "z": 0.695
            },
            "gtin": "3600524164614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d551",
            "leftCorner": {
              "x": -13.674,
              "y": 30.68,
              "z": 0.695
            },
            "rightCorner": {
              "x": -13.669,
              "y": 30.763,
              "z": 0.695
            },
            "gtin": "3600522910008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d552",
            "leftCorner": {
              "x": -13.669,
              "y": 30.763,
              "z": 0.695
            },
            "rightCorner": {
              "x": -13.663,
              "y": 30.844,
              "z": 0.695
            },
            "gtin": "3600522910008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d553",
            "leftCorner": {
              "x": -13.663,
              "y": 30.844,
              "z": 0.695
            },
            "rightCorner": {
              "x": -13.657,
              "y": 30.927,
              "z": 0.695
            },
            "gtin": "3600522910008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d547",
            "leftCorner": {
              "x": -13.675,
              "y": 30.928,
              "z": 0.695
            },
            "rightCorner": {
              "x": -13.668,
              "y": 31.021,
              "z": 0.695
            },
            "gtin": "4064666847948",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461bf",
        "height": 1.1604,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d537",
            "leftCorner": {
              "x": -13.689,
              "y": 29.819,
              "z": 0.949
            },
            "rightCorner": {
              "x": -13.683,
              "y": 29.92,
              "z": 0.949
            },
            "gtin": "4015100810165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d538",
            "leftCorner": {
              "x": -13.683,
              "y": 29.92,
              "z": 0.949
            },
            "rightCorner": {
              "x": -13.675,
              "y": 30.019,
              "z": 0.949
            },
            "gtin": "4015100810165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d539",
            "leftCorner": {
              "x": -13.675,
              "y": 30.019,
              "z": 0.949
            },
            "rightCorner": {
              "x": -13.668,
              "y": 30.119,
              "z": 0.949
            },
            "gtin": "4015100810165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d53d",
            "leftCorner": {
              "x": -13.716,
              "y": 30.122,
              "z": 0.949
            },
            "rightCorner": {
              "x": -13.709,
              "y": 30.228,
              "z": 0.949
            },
            "gtin": "4015100810462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d53e",
            "leftCorner": {
              "x": -13.709,
              "y": 30.228,
              "z": 0.949
            },
            "rightCorner": {
              "x": -13.701,
              "y": 30.333,
              "z": 0.949
            },
            "gtin": "4015100810462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d53f",
            "leftCorner": {
              "x": -13.7,
              "y": 30.333,
              "z": 0.949
            },
            "rightCorner": {
              "x": -13.696,
              "y": 30.396,
              "z": 0.949
            },
            "gtin": "4015100810547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d540",
            "leftCorner": {
              "x": -13.696,
              "y": 30.396,
              "z": 0.949
            },
            "rightCorner": {
              "x": -13.691,
              "y": 30.461,
              "z": 0.949
            },
            "gtin": "4015100810547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d541",
            "leftCorner": {
              "x": -13.684,
              "y": 30.459,
              "z": 0.949
            },
            "rightCorner": {
              "x": -13.679,
              "y": 30.546,
              "z": 0.949
            },
            "gtin": "4015100810561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d542",
            "leftCorner": {
              "x": -13.679,
              "y": 30.546,
              "z": 0.949
            },
            "rightCorner": {
              "x": -13.673,
              "y": 30.631,
              "z": 0.949
            },
            "gtin": "4015100810561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d543",
            "leftCorner": {
              "x": -13.673,
              "y": 30.631,
              "z": 0.949
            },
            "rightCorner": {
              "x": -13.667,
              "y": 30.716,
              "z": 0.949
            },
            "gtin": "4015100810561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d544",
            "leftCorner": {
              "x": -13.667,
              "y": 30.716,
              "z": 0.949
            },
            "rightCorner": {
              "x": -13.662,
              "y": 30.801,
              "z": 0.949
            },
            "gtin": "4015100810561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d53a",
            "leftCorner": {
              "x": -13.662,
              "y": 30.801,
              "z": 0.949
            },
            "rightCorner": {
              "x": -13.657,
              "y": 30.874,
              "z": 0.949
            },
            "gtin": "4015100810189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d53b",
            "leftCorner": {
              "x": -13.657,
              "y": 30.874,
              "z": 0.949
            },
            "rightCorner": {
              "x": -13.652,
              "y": 30.947,
              "z": 0.949
            },
            "gtin": "4015100810189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d53c",
            "leftCorner": {
              "x": -13.652,
              "y": 30.947,
              "z": 0.949
            },
            "rightCorner": {
              "x": -13.647,
              "y": 31.02,
              "z": 0.949
            },
            "gtin": "4015100810189",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461be",
        "height": 1.4552,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d529",
            "leftCorner": {
              "x": -13.685,
              "y": 29.819,
              "z": 1.191
            },
            "rightCorner": {
              "x": -13.679,
              "y": 29.909,
              "z": 1.191
            },
            "gtin": "4005900749444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d52a",
            "leftCorner": {
              "x": -13.679,
              "y": 29.909,
              "z": 1.191
            },
            "rightCorner": {
              "x": -13.674,
              "y": 29.998,
              "z": 1.191
            },
            "gtin": "4005900749444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d52c",
            "leftCorner": {
              "x": -13.704,
              "y": 29.999,
              "z": 1.191
            },
            "rightCorner": {
              "x": -13.698,
              "y": 30.089,
              "z": 1.191
            },
            "gtin": "4005900749840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d52d",
            "leftCorner": {
              "x": -13.698,
              "y": 30.089,
              "z": 1.191
            },
            "rightCorner": {
              "x": -13.692,
              "y": 30.179,
              "z": 1.191
            },
            "gtin": "4005900749840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d52e",
            "leftCorner": {
              "x": -13.692,
              "y": 30.179,
              "z": 1.191
            },
            "rightCorner": {
              "x": -13.685,
              "y": 30.269,
              "z": 1.191
            },
            "gtin": "4005900749840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d52f",
            "leftCorner": {
              "x": -13.698,
              "y": 30.269,
              "z": 1.191
            },
            "rightCorner": {
              "x": -13.693,
              "y": 30.351,
              "z": 1.191
            },
            "gtin": "4005900749529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d530",
            "leftCorner": {
              "x": -13.693,
              "y": 30.351,
              "z": 1.191
            },
            "rightCorner": {
              "x": -13.688,
              "y": 30.432,
              "z": 1.191
            },
            "gtin": "4005900749529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d531",
            "leftCorner": {
              "x": -13.688,
              "y": 30.432,
              "z": 1.191
            },
            "rightCorner": {
              "x": -13.682,
              "y": 30.512,
              "z": 1.191
            },
            "gtin": "4005900749529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d532",
            "leftCorner": {
              "x": -13.682,
              "y": 30.512,
              "z": 1.191
            },
            "rightCorner": {
              "x": -13.676,
              "y": 30.594,
              "z": 1.191
            },
            "gtin": "4005900749529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d533",
            "leftCorner": {
              "x": -13.676,
              "y": 30.594,
              "z": 1.191
            },
            "rightCorner": {
              "x": -13.671,
              "y": 30.674,
              "z": 1.191
            },
            "gtin": "4005900749529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d534",
            "leftCorner": {
              "x": -13.679,
              "y": 30.674,
              "z": 1.191
            },
            "rightCorner": {
              "x": -13.672,
              "y": 30.769,
              "z": 1.191
            },
            "gtin": "4005900749642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d535",
            "leftCorner": {
              "x": -13.672,
              "y": 30.769,
              "z": 1.191
            },
            "rightCorner": {
              "x": -13.666,
              "y": 30.862,
              "z": 1.191
            },
            "gtin": "4005900749642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d536",
            "leftCorner": {
              "x": -13.666,
              "y": 30.862,
              "z": 1.191
            },
            "rightCorner": {
              "x": -13.659,
              "y": 30.956,
              "z": 1.191
            },
            "gtin": "4005900749642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d52b",
            "leftCorner": {
              "x": -13.671,
              "y": 30.956,
              "z": 1.191
            },
            "rightCorner": {
              "x": -13.667,
              "y": 31.021,
              "z": 1.191
            },
            "gtin": "4005900749406",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461bc",
        "height": 1.7537,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d510",
            "leftCorner": {
              "x": -13.682,
              "y": 29.819,
              "z": 1.435
            },
            "rightCorner": {
              "x": -13.674,
              "y": 29.926,
              "z": 1.435
            },
            "gtin": "4015100817843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d511",
            "leftCorner": {
              "x": -13.674,
              "y": 29.926,
              "z": 1.435
            },
            "rightCorner": {
              "x": -13.667,
              "y": 30.032,
              "z": 1.435
            },
            "gtin": "4015100817843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d513",
            "leftCorner": {
              "x": -13.706,
              "y": 30.034,
              "z": 1.435
            },
            "rightCorner": {
              "x": -13.691,
              "y": 30.252,
              "z": 1.435
            },
            "gtin": "4015100860023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d514",
            "leftCorner": {
              "x": -13.686,
              "y": 30.252,
              "z": 1.435
            },
            "rightCorner": {
              "x": -13.677,
              "y": 30.385,
              "z": 1.435
            },
            "gtin": "4015100817867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d515",
            "leftCorner": {
              "x": -13.677,
              "y": 30.385,
              "z": 1.435
            },
            "rightCorner": {
              "x": -13.667,
              "y": 30.516,
              "z": 1.435
            },
            "gtin": "4015100817867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d516",
            "leftCorner": {
              "x": -13.675,
              "y": 30.517,
              "z": 1.435
            },
            "rightCorner": {
              "x": -13.669,
              "y": 30.608,
              "z": 1.435
            },
            "gtin": "4015100817881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d517",
            "leftCorner": {
              "x": -13.669,
              "y": 30.608,
              "z": 1.435
            },
            "rightCorner": {
              "x": -13.663,
              "y": 30.698,
              "z": 1.435
            },
            "gtin": "4015100817881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d518",
            "leftCorner": {
              "x": -13.663,
              "y": 30.698,
              "z": 1.435
            },
            "rightCorner": {
              "x": -13.657,
              "y": 30.787,
              "z": 1.435
            },
            "gtin": "4015100817881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d519",
            "leftCorner": {
              "x": -13.659,
              "y": 30.787,
              "z": 1.435
            },
            "rightCorner": {
              "x": -13.648,
              "y": 30.944,
              "z": 1.435
            },
            "gtin": "4015100860108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d512",
            "leftCorner": {
              "x": -13.65,
              "y": 30.944,
              "z": 1.435
            },
            "rightCorner": {
              "x": -13.645,
              "y": 31.02,
              "z": 1.435
            },
            "gtin": "4015100817904",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41acd",
    "rightNeighborShelfId": "eded6"
  },
  {
    "id": "41acf",
    "name": "41acf",
    "x": -13.142,
    "y": 37.377,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68252,
      "w": 0.73087
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 71
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546479",
        "height": 0.16169,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e53f",
            "leftCorner": {
              "x": -13.154,
              "y": 37.378,
              "z": 0.132
            },
            "rightCorner": {
              "x": -13.149,
              "y": 37.452,
              "z": 0.132
            },
            "gtin": "8006540791394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e540",
            "leftCorner": {
              "x": -13.149,
              "y": 37.452,
              "z": 0.132
            },
            "rightCorner": {
              "x": -13.144,
              "y": 37.524,
              "z": 0.132
            },
            "gtin": "8006540791394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e541",
            "leftCorner": {
              "x": -13.144,
              "y": 37.524,
              "z": 0.132
            },
            "rightCorner": {
              "x": -13.14,
              "y": 37.597,
              "z": 0.132
            },
            "gtin": "8006540791394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e542",
            "leftCorner": {
              "x": -13.14,
              "y": 37.597,
              "z": 0.132
            },
            "rightCorner": {
              "x": -13.134,
              "y": 37.67,
              "z": 0.132
            },
            "gtin": "8006540791394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e546",
            "leftCorner": {
              "x": -13.173,
              "y": 37.673,
              "z": 0.132
            },
            "rightCorner": {
              "x": -13.167,
              "y": 37.756,
              "z": 0.132
            },
            "gtin": "8006540913741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e547",
            "leftCorner": {
              "x": -13.167,
              "y": 37.756,
              "z": 0.132
            },
            "rightCorner": {
              "x": -13.161,
              "y": 37.84,
              "z": 0.132
            },
            "gtin": "8006540913741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e548",
            "leftCorner": {
              "x": -13.161,
              "y": 37.84,
              "z": 0.132
            },
            "rightCorner": {
              "x": -13.156,
              "y": 37.923,
              "z": 0.132
            },
            "gtin": "8006540913741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e549",
            "leftCorner": {
              "x": -13.155,
              "y": 37.923,
              "z": 0.132
            },
            "rightCorner": {
              "x": -13.147,
              "y": 38.037,
              "z": 0.132
            },
            "gtin": "8006540689011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e54a",
            "leftCorner": {
              "x": -13.147,
              "y": 38.037,
              "z": 0.132
            },
            "rightCorner": {
              "x": -13.139,
              "y": 38.149,
              "z": 0.132
            },
            "gtin": "8006540689011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e54b",
            "leftCorner": {
              "x": -13.139,
              "y": 38.149,
              "z": 0.132
            },
            "rightCorner": {
              "x": -13.132,
              "y": 38.263,
              "z": 0.132
            },
            "gtin": "8006540689011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e54c",
            "leftCorner": {
              "x": -13.132,
              "y": 38.263,
              "z": 0.132
            },
            "rightCorner": {
              "x": -13.125,
              "y": 38.354,
              "z": 0.132
            },
            "gtin": "8006540688939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e54d",
            "leftCorner": {
              "x": -13.125,
              "y": 38.354,
              "z": 0.132
            },
            "rightCorner": {
              "x": -13.119,
              "y": 38.445,
              "z": 0.132
            },
            "gtin": "8006540688939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e54e",
            "leftCorner": {
              "x": -13.119,
              "y": 38.445,
              "z": 0.132
            },
            "rightCorner": {
              "x": -13.113,
              "y": 38.536,
              "z": 0.132
            },
            "gtin": "8006540688939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e54f",
            "leftCorner": {
              "x": -13.113,
              "y": 38.536,
              "z": 0.132
            },
            "rightCorner": {
              "x": -13.106,
              "y": 38.627,
              "z": 0.132
            },
            "gtin": "8006540688939",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546476",
        "height": 0.45696,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e4fe",
            "leftCorner": {
              "x": -13.15,
              "y": 37.377,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.136,
              "y": 37.589,
              "z": 0.374
            },
            "gtin": "8006540689080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4ff",
            "leftCorner": {
              "x": -13.136,
              "y": 37.589,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.121,
              "y": 37.802,
              "z": 0.374
            },
            "gtin": "8006540689080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e502",
            "leftCorner": {
              "x": -13.159,
              "y": 37.804,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.152,
              "y": 37.893,
              "z": 0.374
            },
            "gtin": "8006540688977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e503",
            "leftCorner": {
              "x": -13.152,
              "y": 37.893,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.147,
              "y": 37.981,
              "z": 0.374
            },
            "gtin": "8006540688977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e504",
            "leftCorner": {
              "x": -13.136,
              "y": 37.981,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.125,
              "y": 38.139,
              "z": 0.374
            },
            "gtin": "8006540769737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e505",
            "leftCorner": {
              "x": -13.125,
              "y": 38.139,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.115,
              "y": 38.298,
              "z": 0.374
            },
            "gtin": "8006540769737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e506",
            "leftCorner": {
              "x": -13.115,
              "y": 38.298,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.104,
              "y": 38.457,
              "z": 0.374
            },
            "gtin": "8006540769737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e507",
            "leftCorner": {
              "x": -13.119,
              "y": 38.459,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.112,
              "y": 38.556,
              "z": 0.374
            },
            "gtin": "8006540689158",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546475",
        "height": 0.75915,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e517",
            "leftCorner": {
              "x": -13.146,
              "y": 37.377,
              "z": 0.621
            },
            "rightCorner": {
              "x": -13.136,
              "y": 37.519,
              "z": 0.621
            },
            "gtin": "8006540689110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e518",
            "leftCorner": {
              "x": -13.136,
              "y": 37.519,
              "z": 0.621
            },
            "rightCorner": {
              "x": -13.127,
              "y": 37.661,
              "z": 0.621
            },
            "gtin": "8006540689110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e51b",
            "leftCorner": {
              "x": -13.167,
              "y": 37.663,
              "z": 0.621
            },
            "rightCorner": {
              "x": -13.152,
              "y": 37.884,
              "z": 0.621
            },
            "gtin": "8006540688892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e51c",
            "leftCorner": {
              "x": -13.152,
              "y": 37.884,
              "z": 0.621
            },
            "rightCorner": {
              "x": -13.136,
              "y": 38.105,
              "z": 0.621
            },
            "gtin": "8006540688892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e51d",
            "leftCorner": {
              "x": -13.122,
              "y": 38.104,
              "z": 0.621
            },
            "rightCorner": {
              "x": -13.105,
              "y": 38.362,
              "z": 0.621
            },
            "gtin": "8006540689233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e51e",
            "leftCorner": {
              "x": -13.105,
              "y": 38.362,
              "z": 0.621
            },
            "rightCorner": {
              "x": -13.087,
              "y": 38.62,
              "z": 0.621
            },
            "gtin": "8006540689233",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546474",
        "height": 1.0155,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e52b",
            "leftCorner": {
              "x": -13.144,
              "y": 37.377,
              "z": 0.831
            },
            "rightCorner": {
              "x": -13.136,
              "y": 37.488,
              "z": 0.831
            },
            "gtin": "8006540846513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e52c",
            "leftCorner": {
              "x": -13.136,
              "y": 37.488,
              "z": 0.831
            },
            "rightCorner": {
              "x": -13.128,
              "y": 37.6,
              "z": 0.831
            },
            "gtin": "8006540846513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e530",
            "leftCorner": {
              "x": -13.173,
              "y": 37.602,
              "z": 0.831
            },
            "rightCorner": {
              "x": -13.167,
              "y": 37.707,
              "z": 0.831
            },
            "gtin": "8006540689196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e531",
            "leftCorner": {
              "x": -13.16,
              "y": 37.707,
              "z": 0.831
            },
            "rightCorner": {
              "x": -13.152,
              "y": 37.825,
              "z": 0.831
            },
            "gtin": "8006540452189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e532",
            "leftCorner": {
              "x": -13.152,
              "y": 37.825,
              "z": 0.831
            },
            "rightCorner": {
              "x": -13.143,
              "y": 37.945,
              "z": 0.831
            },
            "gtin": "8006540452189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e533",
            "leftCorner": {
              "x": -13.143,
              "y": 37.945,
              "z": 0.831
            },
            "rightCorner": {
              "x": -13.135,
              "y": 38.064,
              "z": 0.831
            },
            "gtin": "8006540452189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e534",
            "leftCorner": {
              "x": -13.135,
              "y": 38.064,
              "z": 0.831
            },
            "rightCorner": {
              "x": -13.127,
              "y": 38.184,
              "z": 0.831
            },
            "gtin": "8006540452189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e535",
            "leftCorner": {
              "x": -13.117,
              "y": 38.183,
              "z": 0.831
            },
            "rightCorner": {
              "x": -13.11,
              "y": 38.27,
              "z": 0.831
            },
            "gtin": "3574661662619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e536",
            "leftCorner": {
              "x": -13.11,
              "y": 38.27,
              "z": 0.831
            },
            "rightCorner": {
              "x": -13.104,
              "y": 38.358,
              "z": 0.831
            },
            "gtin": "3574661662619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e537",
            "leftCorner": {
              "x": -13.104,
              "y": 38.358,
              "z": 0.831
            },
            "rightCorner": {
              "x": -13.099,
              "y": 38.444,
              "z": 0.831
            },
            "gtin": "3574661662619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e538",
            "leftCorner": {
              "x": -13.099,
              "y": 38.444,
              "z": 0.831
            },
            "rightCorner": {
              "x": -13.092,
              "y": 38.532,
              "z": 0.831
            },
            "gtin": "3574661662619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e539",
            "leftCorner": {
              "x": -13.092,
              "y": 38.532,
              "z": 0.831
            },
            "rightCorner": {
              "x": -13.087,
              "y": 38.62,
              "z": 0.831
            },
            "gtin": "3574661662619",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546473",
        "height": 1.2692,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e558",
            "leftCorner": {
              "x": -13.145,
              "y": 37.377,
              "z": 1.038
            },
            "rightCorner": {
              "x": -13.141,
              "y": 37.449,
              "z": 1.038
            },
            "gtin": "8700216637954",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e559",
            "leftCorner": {
              "x": -13.141,
              "y": 37.449,
              "z": 1.038
            },
            "rightCorner": {
              "x": -13.135,
              "y": 37.521,
              "z": 1.038
            },
            "gtin": "8700216637954",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e55a",
            "leftCorner": {
              "x": -13.135,
              "y": 37.521,
              "z": 1.038
            },
            "rightCorner": {
              "x": -13.131,
              "y": 37.593,
              "z": 1.038
            },
            "gtin": "8700216637954",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e560",
            "leftCorner": {
              "x": -13.173,
              "y": 37.595,
              "z": 1.038
            },
            "rightCorner": {
              "x": -13.169,
              "y": 37.657,
              "z": 1.038
            },
            "gtin": "8700216637541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e561",
            "leftCorner": {
              "x": -13.169,
              "y": 37.657,
              "z": 1.038
            },
            "rightCorner": {
              "x": -13.165,
              "y": 37.718,
              "z": 1.038
            },
            "gtin": "8700216637541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e562",
            "leftCorner": {
              "x": -13.165,
              "y": 37.718,
              "z": 1.038
            },
            "rightCorner": {
              "x": -13.153,
              "y": 37.886,
              "z": 1.038
            },
            "gtin": "8700216637596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e563",
            "leftCorner": {
              "x": -13.153,
              "y": 37.886,
              "z": 1.038
            },
            "rightCorner": {
              "x": -13.142,
              "y": 38.054,
              "z": 1.038
            },
            "gtin": "8700216637596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e564",
            "leftCorner": {
              "x": -13.124,
              "y": 38.052,
              "z": 1.038
            },
            "rightCorner": {
              "x": -13.117,
              "y": 38.149,
              "z": 1.038
            },
            "gtin": "8700216491563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e565",
            "leftCorner": {
              "x": -13.117,
              "y": 38.149,
              "z": 1.038
            },
            "rightCorner": {
              "x": -13.11,
              "y": 38.246,
              "z": 1.038
            },
            "gtin": "8700216491563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e566",
            "leftCorner": {
              "x": -13.12,
              "y": 38.246,
              "z": 1.038
            },
            "rightCorner": {
              "x": -13.113,
              "y": 38.338,
              "z": 1.038
            },
            "gtin": "8700216491570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e567",
            "leftCorner": {
              "x": -13.113,
              "y": 38.338,
              "z": 1.038
            },
            "rightCorner": {
              "x": -13.107,
              "y": 38.431,
              "z": 1.038
            },
            "gtin": "8700216491570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e568",
            "leftCorner": {
              "x": -13.11,
              "y": 38.431,
              "z": 1.038
            },
            "rightCorner": {
              "x": -13.104,
              "y": 38.516,
              "z": 1.038
            },
            "gtin": "8006540738900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e569",
            "leftCorner": {
              "x": -13.104,
              "y": 38.516,
              "z": 1.038
            },
            "rightCorner": {
              "x": -13.099,
              "y": 38.601,
              "z": 1.038
            },
            "gtin": "8006540738900",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546477",
        "height": 1.5115,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f0de",
            "leftCorner": {
              "x": -13.136,
              "y": 37.377,
              "z": 1.237
            },
            "rightCorner": {
              "x": -13.125,
              "y": 37.533,
              "z": 1.237
            },
            "gtin": "8700216638012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0df",
            "leftCorner": {
              "x": -13.125,
              "y": 37.533,
              "z": 1.237
            },
            "rightCorner": {
              "x": -13.115,
              "y": 37.69,
              "z": 1.237
            },
            "gtin": "8700216638012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0e3",
            "leftCorner": {
              "x": -13.156,
              "y": 37.693,
              "z": 1.237
            },
            "rightCorner": {
              "x": -13.148,
              "y": 37.799,
              "z": 1.237
            },
            "gtin": "8006540822166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0e4",
            "leftCorner": {
              "x": -13.148,
              "y": 37.799,
              "z": 1.237
            },
            "rightCorner": {
              "x": -13.141,
              "y": 37.904,
              "z": 1.237
            },
            "gtin": "8006540822166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0e5",
            "leftCorner": {
              "x": -13.141,
              "y": 37.904,
              "z": 1.237
            },
            "rightCorner": {
              "x": -13.134,
              "y": 38.01,
              "z": 1.237
            },
            "gtin": "8006540822166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0e6",
            "leftCorner": {
              "x": -13.134,
              "y": 38.01,
              "z": 1.237
            },
            "rightCorner": {
              "x": -13.127,
              "y": 38.115,
              "z": 1.237
            },
            "gtin": "8006540822166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0e0",
            "leftCorner": {
              "x": -13.113,
              "y": 38.115,
              "z": 1.237
            },
            "rightCorner": {
              "x": -13.102,
              "y": 38.268,
              "z": 1.237
            },
            "gtin": "8001841971926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0e1",
            "leftCorner": {
              "x": -13.102,
              "y": 38.268,
              "z": 1.237
            },
            "rightCorner": {
              "x": -13.092,
              "y": 38.422,
              "z": 1.237
            },
            "gtin": "8001841971926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0e2",
            "leftCorner": {
              "x": -13.092,
              "y": 38.422,
              "z": 1.237
            },
            "rightCorner": {
              "x": -13.081,
              "y": 38.576,
              "z": 1.237
            },
            "gtin": "8001841971926",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546478",
        "height": 1.7617,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e4e2",
            "leftCorner": {
              "x": -13.129,
              "y": 37.376,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.117,
              "y": 37.552,
              "z": 1.441
            },
            "gtin": "8006540732120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4e7",
            "leftCorner": {
              "x": -13.171,
              "y": 37.555,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.163,
              "y": 37.675,
              "z": 1.441
            },
            "gtin": "8006540538227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4e8",
            "leftCorner": {
              "x": -13.163,
              "y": 37.675,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.154,
              "y": 37.795,
              "z": 1.441
            },
            "gtin": "8006540538227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4e9",
            "leftCorner": {
              "x": -13.154,
              "y": 37.795,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.146,
              "y": 37.914,
              "z": 1.441
            },
            "gtin": "8006540538227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4ea",
            "leftCorner": {
              "x": -13.146,
              "y": 37.914,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.139,
              "y": 38.034,
              "z": 1.441
            },
            "gtin": "8006540538227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4eb",
            "leftCorner": {
              "x": -13.12,
              "y": 38.033,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.111,
              "y": 38.162,
              "z": 1.441
            },
            "gtin": "8006540822913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4ec",
            "leftCorner": {
              "x": -13.111,
              "y": 38.162,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.102,
              "y": 38.291,
              "z": 1.441
            },
            "gtin": "8006540822913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4ed",
            "leftCorner": {
              "x": -13.099,
              "y": 38.291,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.086,
              "y": 38.49,
              "z": 1.441
            },
            "gtin": "4015400598381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4ee",
            "leftCorner": {
              "x": -13.104,
              "y": 38.491,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.097,
              "y": 38.581,
              "z": 1.441
            },
            "gtin": "8700216420969",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "eded6",
    "rightNeighborShelfId": "41ad0"
  },
  {
    "id": "41ad0",
    "name": "41ad0",
    "x": -13.06,
    "y": 38.574,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68252,
      "w": 0.73087
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 45
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546339",
        "height": 0.163,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e550",
            "leftCorner": {
              "x": -13.126,
              "y": 38.628,
              "z": 0.133
            },
            "rightCorner": {
              "x": -13.116,
              "y": 38.762,
              "z": 0.133
            },
            "gtin": "8006540689271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e551",
            "leftCorner": {
              "x": -13.116,
              "y": 38.762,
              "z": 0.133
            },
            "rightCorner": {
              "x": -13.108,
              "y": 38.896,
              "z": 0.133
            },
            "gtin": "8006540689271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e552",
            "leftCorner": {
              "x": -13.108,
              "y": 38.896,
              "z": 0.133
            },
            "rightCorner": {
              "x": -13.101,
              "y": 38.999,
              "z": 0.133
            },
            "gtin": "3574661661995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e553",
            "leftCorner": {
              "x": -13.101,
              "y": 38.999,
              "z": 0.133
            },
            "rightCorner": {
              "x": -13.094,
              "y": 39.103,
              "z": 0.133
            },
            "gtin": "3574661661995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e554",
            "leftCorner": {
              "x": -13.094,
              "y": 39.103,
              "z": 0.133
            },
            "rightCorner": {
              "x": -13.087,
              "y": 39.207,
              "z": 0.133
            },
            "gtin": "3574661661995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e555",
            "leftCorner": {
              "x": -13.075,
              "y": 39.206,
              "z": 0.133
            },
            "rightCorner": {
              "x": -13.062,
              "y": 39.406,
              "z": 0.133
            },
            "gtin": "3574661661988",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e556",
            "leftCorner": {
              "x": -13.062,
              "y": 39.406,
              "z": 0.133
            },
            "rightCorner": {
              "x": -13.048,
              "y": 39.605,
              "z": 0.133
            },
            "gtin": "3574661661988",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e557",
            "leftCorner": {
              "x": -13.048,
              "y": 39.605,
              "z": 0.133
            },
            "rightCorner": {
              "x": -13.034,
              "y": 39.804,
              "z": 0.133
            },
            "gtin": "3574661661988",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546336",
        "height": 0.4567,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e508",
            "leftCorner": {
              "x": -13.118,
              "y": 38.557,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.109,
              "y": 38.685,
              "z": 0.374
            },
            "gtin": "3574661661940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e509",
            "leftCorner": {
              "x": -13.109,
              "y": 38.685,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.1,
              "y": 38.816,
              "z": 0.374
            },
            "gtin": "3574661500324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e50a",
            "leftCorner": {
              "x": -13.105,
              "y": 38.816,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.087,
              "y": 39.069,
              "z": 0.374
            },
            "gtin": "3574661661957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e50b",
            "leftCorner": {
              "x": -13.083,
              "y": 39.068,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.071,
              "y": 39.237,
              "z": 0.374
            },
            "gtin": "3574661487311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e50c",
            "leftCorner": {
              "x": -13.071,
              "y": 39.237,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.06,
              "y": 39.405,
              "z": 0.374
            },
            "gtin": "3574661487311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e50d",
            "leftCorner": {
              "x": -13.066,
              "y": 39.405,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.054,
              "y": 39.58,
              "z": 0.374
            },
            "gtin": "3574661486314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e50e",
            "leftCorner": {
              "x": -13.054,
              "y": 39.58,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.042,
              "y": 39.755,
              "z": 0.374
            },
            "gtin": "3574661486314",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546337",
        "height": 0.76411,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e51f",
            "leftCorner": {
              "x": -13.113,
              "y": 38.621,
              "z": 0.625
            },
            "rightCorner": {
              "x": -13.105,
              "y": 38.754,
              "z": 0.625
            },
            "gtin": "3574661486307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e520",
            "leftCorner": {
              "x": -13.105,
              "y": 38.754,
              "z": 0.625
            },
            "rightCorner": {
              "x": -13.095,
              "y": 38.888,
              "z": 0.625
            },
            "gtin": "3574661486307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e521",
            "leftCorner": {
              "x": -13.095,
              "y": 38.888,
              "z": 0.625
            },
            "rightCorner": {
              "x": -13.086,
              "y": 39.022,
              "z": 0.625
            },
            "gtin": "3574661486307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e522",
            "leftCorner": {
              "x": -13.09,
              "y": 39.022,
              "z": 0.625
            },
            "rightCorner": {
              "x": -13.068,
              "y": 39.332,
              "z": 0.625
            },
            "gtin": "3574661486321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e523",
            "leftCorner": {
              "x": -13.068,
              "y": 39.332,
              "z": 0.625
            },
            "rightCorner": {
              "x": -13.048,
              "y": 39.641,
              "z": 0.625
            },
            "gtin": "3574661486321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e524",
            "leftCorner": {
              "x": -13.036,
              "y": 39.641,
              "z": 0.625
            },
            "rightCorner": {
              "x": -13.027,
              "y": 39.776,
              "z": 0.625
            },
            "gtin": "3574661482194",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546338",
        "height": 1.0167,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a54633a",
        "height": 1.2612,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e56a",
            "leftCorner": {
              "x": -13.105,
              "y": 38.601,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.098,
              "y": 38.71,
              "z": 1.032
            },
            "gtin": "3574661662602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e56b",
            "leftCorner": {
              "x": -13.098,
              "y": 38.71,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.09,
              "y": 38.818,
              "z": 1.032
            },
            "gtin": "3574661662602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e56c",
            "leftCorner": {
              "x": -13.09,
              "y": 38.818,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.083,
              "y": 38.928,
              "z": 1.032
            },
            "gtin": "3574661662602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e56d",
            "leftCorner": {
              "x": -13.083,
              "y": 38.928,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.075,
              "y": 39.037,
              "z": 1.032
            },
            "gtin": "3574661662602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e56e",
            "leftCorner": {
              "x": -13.088,
              "y": 39.038,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.073,
              "y": 39.26,
              "z": 1.032
            },
            "gtin": "4000576441067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e56f",
            "leftCorner": {
              "x": -13.065,
              "y": 39.26,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.056,
              "y": 39.41,
              "z": 1.032
            },
            "gtin": "4000576446062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e570",
            "leftCorner": {
              "x": -13.056,
              "y": 39.41,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.045,
              "y": 39.56,
              "z": 1.032
            },
            "gtin": "4000576446062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e571",
            "leftCorner": {
              "x": -13.045,
              "y": 39.56,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.035,
              "y": 39.711,
              "z": 1.032
            },
            "gtin": "4000576446062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e572",
            "leftCorner": {
              "x": -13.035,
              "y": 39.711,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.024,
              "y": 39.861,
              "z": 1.032
            },
            "gtin": "4000576446062",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54633b",
        "height": 1.5222,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e578",
            "leftCorner": {
              "x": -13.071,
              "y": 38.575,
              "z": 1.245
            },
            "rightCorner": {
              "x": -13.052,
              "y": 38.866,
              "z": 1.245
            },
            "gtin": "4000576445065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e579",
            "leftCorner": {
              "x": -13.052,
              "y": 38.866,
              "z": 1.245
            },
            "rightCorner": {
              "x": -13.031,
              "y": 39.157,
              "z": 1.245
            },
            "gtin": "4000576445065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e57c",
            "leftCorner": {
              "x": -13.074,
              "y": 39.161,
              "z": 1.245
            },
            "rightCorner": {
              "x": -13.06,
              "y": 39.369,
              "z": 1.245
            },
            "gtin": "4000576440060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e57d",
            "leftCorner": {
              "x": -13.06,
              "y": 39.369,
              "z": 1.245
            },
            "rightCorner": {
              "x": -13.046,
              "y": 39.576,
              "z": 1.245
            },
            "gtin": "4000576440060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e57e",
            "leftCorner": {
              "x": -13.046,
              "y": 39.576,
              "z": 1.245
            },
            "rightCorner": {
              "x": -13.032,
              "y": 39.785,
              "z": 1.245
            },
            "gtin": "4000576440060",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546335",
        "height": 1.7618,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e4ef",
            "leftCorner": {
              "x": -13.105,
              "y": 38.581,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.097,
              "y": 38.684,
              "z": 1.441
            },
            "gtin": "8006540732083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4f0",
            "leftCorner": {
              "x": -13.097,
              "y": 38.684,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.091,
              "y": 38.787,
              "z": 1.441
            },
            "gtin": "8006540732083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4f1",
            "leftCorner": {
              "x": -13.101,
              "y": 38.788,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.093,
              "y": 38.891,
              "z": 1.441
            },
            "gtin": "4000576047825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4f2",
            "leftCorner": {
              "x": -13.093,
              "y": 38.891,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.087,
              "y": 38.994,
              "z": 1.441
            },
            "gtin": "4000576047825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4f3",
            "leftCorner": {
              "x": -13.081,
              "y": 38.993,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.069,
              "y": 39.163,
              "z": 1.441
            },
            "gtin": "4000576047801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4f4",
            "leftCorner": {
              "x": -13.072,
              "y": 39.163,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.065,
              "y": 39.266,
              "z": 1.441
            },
            "gtin": "4000576449063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4f5",
            "leftCorner": {
              "x": -13.065,
              "y": 39.266,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.057,
              "y": 39.367,
              "z": 1.441
            },
            "gtin": "4000576449063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4f6",
            "leftCorner": {
              "x": -13.049,
              "y": 39.367,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.034,
              "y": 39.593,
              "z": 1.441
            },
            "gtin": "4000576058579",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4f7",
            "leftCorner": {
              "x": -13.021,
              "y": 39.593,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.014,
              "y": 39.712,
              "z": 1.441
            },
            "gtin": "4000576021504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4f8",
            "leftCorner": {
              "x": -13.016,
              "y": 39.712,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.009,
              "y": 39.798,
              "z": 1.441
            },
            "gtin": "4000576013394",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41acf",
    "rightNeighborShelfId": "41ad1"
  },
  {
    "id": "41ad1",
    "name": "41ad1",
    "x": -12.978,
    "y": 39.772,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68252,
      "w": 0.73087
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 58
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a54647d",
        "height": 0.16356,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e543",
            "leftCorner": {
              "x": -13.031,
              "y": 39.805,
              "z": 0.134
            },
            "rightCorner": {
              "x": -13.004,
              "y": 40.194,
              "z": 0.134
            },
            "gtin": "7322542133569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e544",
            "leftCorner": {
              "x": -13.004,
              "y": 40.194,
              "z": 0.134
            },
            "rightCorner": {
              "x": -12.978,
              "y": 40.583,
              "z": 0.134
            },
            "gtin": "7322542133569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e545",
            "leftCorner": {
              "x": -12.978,
              "y": 40.583,
              "z": 0.134
            },
            "rightCorner": {
              "x": -12.952,
              "y": 40.972,
              "z": 0.134
            },
            "gtin": "7322542133569",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54647f",
        "height": 0.46548,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e50f",
            "leftCorner": {
              "x": -13.029,
              "y": 39.755,
              "z": 0.381
            },
            "rightCorner": {
              "x": -13.021,
              "y": 39.887,
              "z": 0.381
            },
            "gtin": "7322542090473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e510",
            "leftCorner": {
              "x": -13.021,
              "y": 39.887,
              "z": 0.381
            },
            "rightCorner": {
              "x": -13.012,
              "y": 40.021,
              "z": 0.381
            },
            "gtin": "7322542090473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e511",
            "leftCorner": {
              "x": -13.012,
              "y": 40.021,
              "z": 0.381
            },
            "rightCorner": {
              "x": -13.002,
              "y": 40.154,
              "z": 0.381
            },
            "gtin": "7322542090473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e512",
            "leftCorner": {
              "x": -13.015,
              "y": 40.156,
              "z": 0.381
            },
            "rightCorner": {
              "x": -13.009,
              "y": 40.253,
              "z": 0.381
            },
            "gtin": "7322541068039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e513",
            "leftCorner": {
              "x": -13.009,
              "y": 40.253,
              "z": 0.381
            },
            "rightCorner": {
              "x": -13.003,
              "y": 40.35,
              "z": 0.381
            },
            "gtin": "7322541068039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e514",
            "leftCorner": {
              "x": -12.985,
              "y": 40.349,
              "z": 0.381
            },
            "rightCorner": {
              "x": -12.975,
              "y": 40.481,
              "z": 0.381
            },
            "gtin": "7322541185231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e515",
            "leftCorner": {
              "x": -12.974,
              "y": 40.481,
              "z": 0.381
            },
            "rightCorner": {
              "x": -12.966,
              "y": 40.605,
              "z": 0.381
            },
            "gtin": "7322542285398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e516",
            "leftCorner": {
              "x": -12.966,
              "y": 40.605,
              "z": 0.381
            },
            "rightCorner": {
              "x": -12.958,
              "y": 40.728,
              "z": 0.381
            },
            "gtin": "7322542285398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e500",
            "leftCorner": {
              "x": -12.951,
              "y": 40.728,
              "z": 0.381
            },
            "rightCorner": {
              "x": -12.943,
              "y": 40.85,
              "z": 0.381
            },
            "gtin": "7322540574876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e501",
            "leftCorner": {
              "x": -12.943,
              "y": 40.85,
              "z": 0.381
            },
            "rightCorner": {
              "x": -12.935,
              "y": 40.971,
              "z": 0.381
            },
            "gtin": "7322540574876",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54647a",
        "height": 0.75684,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e525",
            "leftCorner": {
              "x": -13.027,
              "y": 39.777,
              "z": 0.619
            },
            "rightCorner": {
              "x": -13.014,
              "y": 39.962,
              "z": 0.619
            },
            "gtin": "7322542308752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e526",
            "leftCorner": {
              "x": -13.014,
              "y": 39.962,
              "z": 0.619
            },
            "rightCorner": {
              "x": -13.002,
              "y": 40.147,
              "z": 0.619
            },
            "gtin": "7322542308752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e527",
            "leftCorner": {
              "x": -13.002,
              "y": 40.147,
              "z": 0.619
            },
            "rightCorner": {
              "x": -12.989,
              "y": 40.332,
              "z": 0.619
            },
            "gtin": "7322542308752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e528",
            "leftCorner": {
              "x": -12.985,
              "y": 40.332,
              "z": 0.619
            },
            "rightCorner": {
              "x": -12.973,
              "y": 40.511,
              "z": 0.619
            },
            "gtin": "7322541091174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e529",
            "leftCorner": {
              "x": -12.973,
              "y": 40.511,
              "z": 0.619
            },
            "rightCorner": {
              "x": -12.961,
              "y": 40.683,
              "z": 0.619
            },
            "gtin": "7322541146775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e52a",
            "leftCorner": {
              "x": -12.961,
              "y": 40.683,
              "z": 0.619
            },
            "rightCorner": {
              "x": -12.949,
              "y": 40.856,
              "z": 0.619
            },
            "gtin": "7322541146775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e519",
            "leftCorner": {
              "x": -12.953,
              "y": 40.856,
              "z": 0.619
            },
            "rightCorner": {
              "x": -12.949,
              "y": 40.914,
              "z": 0.619
            },
            "gtin": "7322541152035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e51a",
            "leftCorner": {
              "x": -12.949,
              "y": 40.914,
              "z": 0.619
            },
            "rightCorner": {
              "x": -12.946,
              "y": 40.972,
              "z": 0.619
            },
            "gtin": "7322541152035",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546480",
        "height": 1.026,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e53a",
            "leftCorner": {
              "x": -13.017,
              "y": 40.069,
              "z": 0.839
            },
            "rightCorner": {
              "x": -13.01,
              "y": 40.173,
              "z": 0.839
            },
            "gtin": "7322541085739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e53b",
            "leftCorner": {
              "x": -13.01,
              "y": 40.173,
              "z": 0.839
            },
            "rightCorner": {
              "x": -13.004,
              "y": 40.278,
              "z": 0.839
            },
            "gtin": "7322541085739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e53c",
            "leftCorner": {
              "x": -13.004,
              "y": 40.278,
              "z": 0.839
            },
            "rightCorner": {
              "x": -12.996,
              "y": 40.382,
              "z": 0.839
            },
            "gtin": "7322541085739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e53d",
            "leftCorner": {
              "x": -12.977,
              "y": 40.381,
              "z": 0.839
            },
            "rightCorner": {
              "x": -12.968,
              "y": 40.504,
              "z": 0.839
            },
            "gtin": "7322541067032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e53e",
            "leftCorner": {
              "x": -12.968,
              "y": 40.504,
              "z": 0.839
            },
            "rightCorner": {
              "x": -12.961,
              "y": 40.626,
              "z": 0.839
            },
            "gtin": "7322541067032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e52d",
            "leftCorner": {
              "x": -12.963,
              "y": 40.626,
              "z": 0.839
            },
            "rightCorner": {
              "x": -12.954,
              "y": 40.742,
              "z": 0.839
            },
            "gtin": "7322541688367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e52e",
            "leftCorner": {
              "x": -12.954,
              "y": 40.742,
              "z": 0.839
            },
            "rightCorner": {
              "x": -12.947,
              "y": 40.857,
              "z": 0.839
            },
            "gtin": "7322541688367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e52f",
            "leftCorner": {
              "x": -12.947,
              "y": 40.857,
              "z": 0.839
            },
            "rightCorner": {
              "x": -12.939,
              "y": 40.972,
              "z": 0.839
            },
            "gtin": "7322541688367",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54647c",
        "height": 1.2619,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e573",
            "leftCorner": {
              "x": -13.02,
              "y": 39.861,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.01,
              "y": 40.007,
              "z": 1.032
            },
            "gtin": "7322541079677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e574",
            "leftCorner": {
              "x": -13.014,
              "y": 40.007,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.006,
              "y": 40.114,
              "z": 1.032
            },
            "gtin": "7322541079967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e575",
            "leftCorner": {
              "x": -13.006,
              "y": 40.114,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.0,
              "y": 40.222,
              "z": 1.032
            },
            "gtin": "7322541079967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e576",
            "leftCorner": {
              "x": -13.0,
              "y": 40.222,
              "z": 1.032
            },
            "rightCorner": {
              "x": -12.992,
              "y": 40.329,
              "z": 1.032
            },
            "gtin": "7322541079967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e577",
            "leftCorner": {
              "x": -12.992,
              "y": 40.329,
              "z": 1.032
            },
            "rightCorner": {
              "x": -12.985,
              "y": 40.435,
              "z": 1.032
            },
            "gtin": "7322541079967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e55b",
            "leftCorner": {
              "x": -12.966,
              "y": 40.434,
              "z": 1.032
            },
            "rightCorner": {
              "x": -12.959,
              "y": 40.542,
              "z": 1.032
            },
            "gtin": "7322541083087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e55c",
            "leftCorner": {
              "x": -12.959,
              "y": 40.542,
              "z": 1.032
            },
            "rightCorner": {
              "x": -12.951,
              "y": 40.649,
              "z": 1.032
            },
            "gtin": "7322541083087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e55d",
            "leftCorner": {
              "x": -12.951,
              "y": 40.649,
              "z": 1.032
            },
            "rightCorner": {
              "x": -12.944,
              "y": 40.757,
              "z": 1.032
            },
            "gtin": "7322541083087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e55e",
            "leftCorner": {
              "x": -12.944,
              "y": 40.757,
              "z": 1.032
            },
            "rightCorner": {
              "x": -12.937,
              "y": 40.863,
              "z": 1.032
            },
            "gtin": "7322541083087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e55f",
            "leftCorner": {
              "x": -12.937,
              "y": 40.863,
              "z": 1.032
            },
            "rightCorner": {
              "x": -12.93,
              "y": 40.971,
              "z": 1.032
            },
            "gtin": "7322541083087",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54647e",
        "height": 1.5165,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e57f",
            "leftCorner": {
              "x": -13.012,
              "y": 39.784,
              "z": 1.241
            },
            "rightCorner": {
              "x": -13.007,
              "y": 39.86,
              "z": 1.241
            },
            "gtin": "7322541343341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e580",
            "leftCorner": {
              "x": -13.007,
              "y": 39.86,
              "z": 1.241
            },
            "rightCorner": {
              "x": -13.002,
              "y": 39.936,
              "z": 1.241
            },
            "gtin": "7322541343341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e581",
            "leftCorner": {
              "x": -13.009,
              "y": 39.936,
              "z": 1.241
            },
            "rightCorner": {
              "x": -13.0,
              "y": 40.069,
              "z": 1.241
            },
            "gtin": "7322541343259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e582",
            "leftCorner": {
              "x": -13.0,
              "y": 40.069,
              "z": 1.241
            },
            "rightCorner": {
              "x": -12.991,
              "y": 40.2,
              "z": 1.241
            },
            "gtin": "7322541343259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e583",
            "leftCorner": {
              "x": -12.998,
              "y": 40.201,
              "z": 1.241
            },
            "rightCorner": {
              "x": -12.983,
              "y": 40.41,
              "z": 1.241
            },
            "gtin": "7322542146989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e584",
            "leftCorner": {
              "x": -12.956,
              "y": 40.409,
              "z": 1.241
            },
            "rightCorner": {
              "x": -12.949,
              "y": 40.527,
              "z": 1.241
            },
            "gtin": "7322542075104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e585",
            "leftCorner": {
              "x": -12.949,
              "y": 40.527,
              "z": 1.241
            },
            "rightCorner": {
              "x": -12.94,
              "y": 40.645,
              "z": 1.241
            },
            "gtin": "7322542075104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e586",
            "leftCorner": {
              "x": -12.948,
              "y": 40.646,
              "z": 1.241
            },
            "rightCorner": {
              "x": -12.936,
              "y": 40.834,
              "z": 1.241
            },
            "gtin": "7322542076330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e57a",
            "leftCorner": {
              "x": -12.937,
              "y": 40.834,
              "z": 1.241
            },
            "rightCorner": {
              "x": -12.933,
              "y": 40.902,
              "z": 1.241
            },
            "gtin": "7322542088012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e57b",
            "leftCorner": {
              "x": -12.933,
              "y": 40.902,
              "z": 1.241
            },
            "rightCorner": {
              "x": -12.928,
              "y": 40.971,
              "z": 1.241
            },
            "gtin": "7322542088012",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54647b",
        "height": 1.7617,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e4f9",
            "leftCorner": {
              "x": -13.017,
              "y": 39.799,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.003,
              "y": 39.994,
              "z": 1.441
            },
            "gtin": "4000576036157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4fa",
            "leftCorner": {
              "x": -13.012,
              "y": 39.994,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.006,
              "y": 40.08,
              "z": 1.441
            },
            "gtin": "7322541343686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4fb",
            "leftCorner": {
              "x": -13.006,
              "y": 40.08,
              "z": 1.441
            },
            "rightCorner": {
              "x": -13.001,
              "y": 40.165,
              "z": 1.441
            },
            "gtin": "7322541343686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4fc",
            "leftCorner": {
              "x": -13.003,
              "y": 40.165,
              "z": 1.441
            },
            "rightCorner": {
              "x": -12.993,
              "y": 40.302,
              "z": 1.441
            },
            "gtin": "4009408044735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4fd",
            "leftCorner": {
              "x": -12.993,
              "y": 40.302,
              "z": 1.441
            },
            "rightCorner": {
              "x": -12.984,
              "y": 40.439,
              "z": 1.441
            },
            "gtin": "4009408044735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4e3",
            "leftCorner": {
              "x": -12.963,
              "y": 40.438,
              "z": 1.441
            },
            "rightCorner": {
              "x": -12.954,
              "y": 40.571,
              "z": 1.441
            },
            "gtin": "4000576029630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4e4",
            "leftCorner": {
              "x": -12.954,
              "y": 40.571,
              "z": 1.441
            },
            "rightCorner": {
              "x": -12.944,
              "y": 40.705,
              "z": 1.441
            },
            "gtin": "4000576029630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4e5",
            "leftCorner": {
              "x": -12.944,
              "y": 40.705,
              "z": 1.441
            },
            "rightCorner": {
              "x": -12.935,
              "y": 40.838,
              "z": 1.441
            },
            "gtin": "4000576029630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4e6",
            "leftCorner": {
              "x": -12.935,
              "y": 40.838,
              "z": 1.441
            },
            "rightCorner": {
              "x": -12.926,
              "y": 40.971,
              "z": 1.441
            },
            "gtin": "4000576029630",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41ad0",
    "rightNeighborShelfId": "ededa"
  },
  {
    "id": "46886",
    "name": "46886",
    "x": 1.992,
    "y": 37.949,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029553
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 58
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546502",
        "height": 0.15232,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f649",
            "leftCorner": {
              "x": 1.991,
              "y": 37.939,
              "z": 0.125
            },
            "rightCorner": {
              "x": 1.894,
              "y": 37.944,
              "z": 0.125
            },
            "gtin": "4008600432111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f64c",
            "leftCorner": {
              "x": 1.89,
              "y": 37.885,
              "z": 0.125
            },
            "rightCorner": {
              "x": 1.797,
              "y": 37.891,
              "z": 0.125
            },
            "gtin": "4008600432302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f64d",
            "leftCorner": {
              "x": 1.797,
              "y": 37.887,
              "z": 0.125
            },
            "rightCorner": {
              "x": 1.7,
              "y": 37.893,
              "z": 0.125
            },
            "gtin": "4008600311713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f64e",
            "leftCorner": {
              "x": 1.7,
              "y": 37.893,
              "z": 0.125
            },
            "rightCorner": {
              "x": 1.603,
              "y": 37.899,
              "z": 0.125
            },
            "gtin": "4008600311713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f64f",
            "leftCorner": {
              "x": 1.603,
              "y": 37.899,
              "z": 0.125
            },
            "rightCorner": {
              "x": 1.507,
              "y": 37.904,
              "z": 0.125
            },
            "gtin": "4008600311713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f650",
            "leftCorner": {
              "x": 1.508,
              "y": 37.92,
              "z": 0.125
            },
            "rightCorner": {
              "x": 1.413,
              "y": 37.925,
              "z": 0.125
            },
            "gtin": "4008600356547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f651",
            "leftCorner": {
              "x": 1.414,
              "y": 37.939,
              "z": 0.125
            },
            "rightCorner": {
              "x": 1.343,
              "y": 37.943,
              "z": 0.125
            },
            "gtin": "4008600434269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f652",
            "leftCorner": {
              "x": 1.343,
              "y": 37.941,
              "z": 0.125
            },
            "rightCorner": {
              "x": 1.255,
              "y": 37.946,
              "z": 0.125
            },
            "gtin": "4008600434306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f653",
            "leftCorner": {
              "x": 1.256,
              "y": 37.957,
              "z": 0.125
            },
            "rightCorner": {
              "x": 1.193,
              "y": 37.96,
              "z": 0.125
            },
            "gtin": "4008600307914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f654",
            "leftCorner": {
              "x": 1.192,
              "y": 37.939,
              "z": 0.125
            },
            "rightCorner": {
              "x": 1.078,
              "y": 37.946,
              "z": 0.125
            },
            "gtin": "4008600307877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f655",
            "leftCorner": {
              "x": 1.079,
              "y": 37.959,
              "z": 0.125
            },
            "rightCorner": {
              "x": 1.02,
              "y": 37.962,
              "z": 0.125
            },
            "gtin": "4008600372622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f656",
            "leftCorner": {
              "x": 1.02,
              "y": 37.962,
              "z": 0.125
            },
            "rightCorner": {
              "x": 0.962,
              "y": 37.966,
              "z": 0.125
            },
            "gtin": "4008600372622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f657",
            "leftCorner": {
              "x": 0.961,
              "y": 37.964,
              "z": 0.125
            },
            "rightCorner": {
              "x": 0.841,
              "y": 37.971,
              "z": 0.125
            },
            "gtin": "4008600321910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f658",
            "leftCorner": {
              "x": 0.841,
              "y": 37.973,
              "z": 0.125
            },
            "rightCorner": {
              "x": 0.807,
              "y": 37.975,
              "z": 0.125
            },
            "gtin": "4008600382782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f659",
            "leftCorner": {
              "x": 0.807,
              "y": 37.975,
              "z": 0.125
            },
            "rightCorner": {
              "x": 0.773,
              "y": 37.977,
              "z": 0.125
            },
            "gtin": "4008600382782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f65a",
            "leftCorner": {
              "x": 0.773,
              "y": 37.977,
              "z": 0.125
            },
            "rightCorner": {
              "x": 0.738,
              "y": 37.979,
              "z": 0.125
            },
            "gtin": "4008600382782",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546505",
        "height": 0.71057,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f712",
            "leftCorner": {
              "x": 1.978,
              "y": 37.716,
              "z": 0.581
            },
            "rightCorner": {
              "x": 1.411,
              "y": 37.75,
              "z": 0.581
            },
            "gtin": "4008600398783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f714",
            "leftCorner": {
              "x": 1.409,
              "y": 37.714,
              "z": 0.581
            },
            "rightCorner": {
              "x": 1.188,
              "y": 37.727,
              "z": 0.581
            },
            "gtin": "4008600425489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f715",
            "leftCorner": {
              "x": 1.188,
              "y": 37.733,
              "z": 0.581
            },
            "rightCorner": {
              "x": 1.044,
              "y": 37.742,
              "z": 0.581
            },
            "gtin": "4008600425502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f713",
            "leftCorner": {
              "x": 1.043,
              "y": 37.734,
              "z": 0.581
            },
            "rightCorner": {
              "x": 0.728,
              "y": 37.752,
              "z": 0.581
            },
            "gtin": "4008600425496",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546500",
        "height": 0.91075,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f6f2",
            "leftCorner": {
              "x": 1.979,
              "y": 37.722,
              "z": 0.745
            },
            "rightCorner": {
              "x": 1.579,
              "y": 37.746,
              "z": 0.745
            },
            "gtin": "4008600371533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6f5",
            "leftCorner": {
              "x": 1.576,
              "y": 37.703,
              "z": 0.745
            },
            "rightCorner": {
              "x": 1.203,
              "y": 37.725,
              "z": 0.745
            },
            "gtin": "4008600371465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6f6",
            "leftCorner": {
              "x": 1.203,
              "y": 37.727,
              "z": 0.745
            },
            "rightCorner": {
              "x": 0.714,
              "y": 37.755,
              "z": 0.745
            },
            "gtin": "4008600398738",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546503",
        "height": 0.93963,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f70e",
            "leftCorner": {
              "x": 1.979,
              "y": 37.731,
              "z": 0.769
            },
            "rightCorner": {
              "x": 1.659,
              "y": 37.75,
              "z": 0.769
            },
            "gtin": "4008600371526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f70f",
            "leftCorner": {
              "x": 1.659,
              "y": 37.75,
              "z": 0.769
            },
            "rightCorner": {
              "x": 1.34,
              "y": 37.768,
              "z": 0.769
            },
            "gtin": "4008600371526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f711",
            "leftCorner": {
              "x": 1.338,
              "y": 37.733,
              "z": 0.769
            },
            "rightCorner": {
              "x": 0.92,
              "y": 37.758,
              "z": 0.769
            },
            "gtin": "4008600398790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f710",
            "leftCorner": {
              "x": 0.918,
              "y": 37.733,
              "z": 0.769
            },
            "rightCorner": {
              "x": 0.728,
              "y": 37.744,
              "z": 0.769
            },
            "gtin": "4008600398752",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546501",
        "height": 1.1327,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f704",
            "leftCorner": {
              "x": 1.978,
              "y": 37.719,
              "z": 0.927
            },
            "rightCorner": {
              "x": 1.876,
              "y": 37.726,
              "z": 0.927
            },
            "gtin": "4008600312239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f705",
            "leftCorner": {
              "x": 1.876,
              "y": 37.726,
              "z": 0.927
            },
            "rightCorner": {
              "x": 1.774,
              "y": 37.732,
              "z": 0.927
            },
            "gtin": "4008600312239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f707",
            "leftCorner": {
              "x": 1.772,
              "y": 37.691,
              "z": 0.927
            },
            "rightCorner": {
              "x": 1.558,
              "y": 37.704,
              "z": 0.927
            },
            "gtin": "4008600312253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f708",
            "leftCorner": {
              "x": 1.558,
              "y": 37.706,
              "z": 0.927
            },
            "rightCorner": {
              "x": 1.45,
              "y": 37.713,
              "z": 0.927
            },
            "gtin": "4008600312246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f709",
            "leftCorner": {
              "x": 1.45,
              "y": 37.708,
              "z": 0.927
            },
            "rightCorner": {
              "x": 1.306,
              "y": 37.716,
              "z": 0.927
            },
            "gtin": "4008600378723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f70a",
            "leftCorner": {
              "x": 1.306,
              "y": 37.718,
              "z": 0.927
            },
            "rightCorner": {
              "x": 1.18,
              "y": 37.727,
              "z": 0.927
            },
            "gtin": "4008600378709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f70b",
            "leftCorner": {
              "x": 1.18,
              "y": 37.727,
              "z": 0.927
            },
            "rightCorner": {
              "x": 1.054,
              "y": 37.734,
              "z": 0.927
            },
            "gtin": "4008600378709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f70c",
            "leftCorner": {
              "x": 1.054,
              "y": 37.746,
              "z": 0.927
            },
            "rightCorner": {
              "x": 0.899,
              "y": 37.755,
              "z": 0.927
            },
            "gtin": "4008600378716",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f70d",
            "leftCorner": {
              "x": 0.899,
              "y": 37.749,
              "z": 0.927
            },
            "rightCorner": {
              "x": 0.782,
              "y": 37.756,
              "z": 0.927
            },
            "gtin": "4008600425489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f706",
            "leftCorner": {
              "x": 0.782,
              "y": 37.763,
              "z": 0.927
            },
            "rightCorner": {
              "x": 0.729,
              "y": 37.765,
              "z": 0.927
            },
            "gtin": "4008600425502",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546509",
        "height": 1.3599,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f718",
            "leftCorner": {
              "x": 1.984,
              "y": 37.815,
              "z": 1.113
            },
            "rightCorner": {
              "x": 1.376,
              "y": 37.851,
              "z": 1.113
            },
            "gtin": "8720689012683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f719",
            "leftCorner": {
              "x": 1.374,
              "y": 37.812,
              "z": 1.113
            },
            "rightCorner": {
              "x": 0.734,
              "y": 37.85,
              "z": 1.113
            },
            "gtin": "8720689012683",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464fe",
        "height": 1.3881,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f6e6",
            "leftCorner": {
              "x": 1.984,
              "y": 37.808,
              "z": 1.136
            },
            "rightCorner": {
              "x": 1.761,
              "y": 37.822,
              "z": 1.136
            },
            "gtin": "9001616824708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6e8",
            "leftCorner": {
              "x": 1.758,
              "y": 37.773,
              "z": 1.136
            },
            "rightCorner": {
              "x": 1.61,
              "y": 37.781,
              "z": 1.136
            },
            "gtin": "8720689012997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6e9",
            "leftCorner": {
              "x": 1.61,
              "y": 37.783,
              "z": 1.136
            },
            "rightCorner": {
              "x": 1.499,
              "y": 37.79,
              "z": 1.136
            },
            "gtin": "8720689012201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6ea",
            "leftCorner": {
              "x": 1.499,
              "y": 37.789,
              "z": 1.136
            },
            "rightCorner": {
              "x": 1.317,
              "y": 37.8,
              "z": 1.136
            },
            "gtin": "8720689012966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6eb",
            "leftCorner": {
              "x": 1.317,
              "y": 37.8,
              "z": 1.136
            },
            "rightCorner": {
              "x": 1.134,
              "y": 37.811,
              "z": 1.136
            },
            "gtin": "8720689012966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6ec",
            "leftCorner": {
              "x": 1.135,
              "y": 37.827,
              "z": 1.136
            },
            "rightCorner": {
              "x": 0.874,
              "y": 37.843,
              "z": 1.136
            },
            "gtin": "8720689012942",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6e7",
            "leftCorner": {
              "x": 0.874,
              "y": 37.842,
              "z": 1.136
            },
            "rightCorner": {
              "x": 0.734,
              "y": 37.85,
              "z": 1.136
            },
            "gtin": "8720689017473",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464fd",
        "height": 1.5699,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f6de",
            "leftCorner": {
              "x": 1.984,
              "y": 37.811,
              "z": 1.284
            },
            "rightCorner": {
              "x": 1.783,
              "y": 37.823,
              "z": 1.284
            },
            "gtin": "9001616824623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6df",
            "leftCorner": {
              "x": 1.783,
              "y": 37.823,
              "z": 1.284
            },
            "rightCorner": {
              "x": 1.583,
              "y": 37.835,
              "z": 1.284
            },
            "gtin": "9001616824623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6e1",
            "leftCorner": {
              "x": 1.579,
              "y": 37.775,
              "z": 1.284
            },
            "rightCorner": {
              "x": 1.454,
              "y": 37.784,
              "z": 1.284
            },
            "gtin": "9001616827501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6e2",
            "leftCorner": {
              "x": 1.454,
              "y": 37.784,
              "z": 1.284
            },
            "rightCorner": {
              "x": 1.328,
              "y": 37.791,
              "z": 1.284
            },
            "gtin": "9001616827501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6e3",
            "leftCorner": {
              "x": 1.33,
              "y": 37.812,
              "z": 1.284
            },
            "rightCorner": {
              "x": 1.048,
              "y": 37.828,
              "z": 1.284
            },
            "gtin": "9001616824685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6e4",
            "leftCorner": {
              "x": 1.048,
              "y": 37.828,
              "z": 1.284
            },
            "rightCorner": {
              "x": 0.91,
              "y": 37.836,
              "z": 1.284
            },
            "gtin": "9001616824647",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6e5",
            "leftCorner": {
              "x": 0.91,
              "y": 37.836,
              "z": 1.284
            },
            "rightCorner": {
              "x": 0.772,
              "y": 37.844,
              "z": 1.284
            },
            "gtin": "9001616824647",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6e0",
            "leftCorner": {
              "x": 0.772,
              "y": 37.849,
              "z": 1.284
            },
            "rightCorner": {
              "x": 0.734,
              "y": 37.851,
              "z": 1.284
            },
            "gtin": "9001616827525",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546506",
        "height": 1.7827,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f716",
            "leftCorner": {
              "x": 1.984,
              "y": 37.81,
              "z": 1.459
            },
            "rightCorner": {
              "x": 1.354,
              "y": 37.848,
              "z": 1.459
            },
            "gtin": "9001616824609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f717",
            "leftCorner": {
              "x": 1.352,
              "y": 37.806,
              "z": 1.459
            },
            "rightCorner": {
              "x": 0.734,
              "y": 37.842,
              "z": 1.459
            },
            "gtin": "9001616824609",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464ff",
        "height": 1.8269,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f6ed",
            "leftCorner": {
              "x": 1.984,
              "y": 37.809,
              "z": 1.495
            },
            "rightCorner": {
              "x": 1.653,
              "y": 37.829,
              "z": 1.495
            },
            "gtin": "9001616838743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6ef",
            "leftCorner": {
              "x": 1.651,
              "y": 37.794,
              "z": 1.495
            },
            "rightCorner": {
              "x": 1.072,
              "y": 37.828,
              "z": 1.495
            },
            "gtin": "9001616838705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6f0",
            "leftCorner": {
              "x": 1.071,
              "y": 37.82,
              "z": 1.495
            },
            "rightCorner": {
              "x": 0.922,
              "y": 37.829,
              "z": 1.495
            },
            "gtin": "9001616824661",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c885ed67a01d9a1f6f1",
            "leftCorner": {
              "x": 0.922,
              "y": 37.827,
              "z": 1.495
            },
            "rightCorner": {
              "x": 0.807,
              "y": 37.834,
              "z": 1.495
            },
            "gtin": "9001616827488",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c885ed67a01d9a1f6ee",
            "leftCorner": {
              "x": 0.808,
              "y": 37.847,
              "z": 1.495
            },
            "rightCorner": {
              "x": 0.734,
              "y": 37.851,
              "z": 1.495
            },
            "gtin": "9001616855665",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "da3c7",
    "rightNeighborShelfId": "46887"
  },
  {
    "id": "46887",
    "name": "46887",
    "x": 0.744,
    "y": 38.023,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029553
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 82
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a54650f",
        "height": 0.15143,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f65b",
            "leftCorner": {
              "x": 0.737,
              "y": 37.959,
              "z": 0.124
            },
            "rightCorner": {
              "x": 0.546,
              "y": 37.971,
              "z": 0.124
            },
            "gtin": "5099514400074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f65c",
            "leftCorner": {
              "x": 0.547,
              "y": 37.987,
              "z": 0.124
            },
            "rightCorner": {
              "x": 0.268,
              "y": 38.003,
              "z": 0.124
            },
            "gtin": "5099514002728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f65d",
            "leftCorner": {
              "x": 0.267,
              "y": 37.999,
              "z": 0.124
            },
            "rightCorner": {
              "x": 0.092,
              "y": 38.009,
              "z": 0.124
            },
            "gtin": "4006000028446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f65e",
            "leftCorner": {
              "x": 0.091,
              "y": 37.994,
              "z": 0.124
            },
            "rightCorner": {
              "x": 0.025,
              "y": 37.998,
              "z": 0.124
            },
            "gtin": "8001841078137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f65f",
            "leftCorner": {
              "x": 0.025,
              "y": 37.998,
              "z": 0.124
            },
            "rightCorner": {
              "x": -0.041,
              "y": 38.002,
              "z": 0.124
            },
            "gtin": "8001841078137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f660",
            "leftCorner": {
              "x": -0.041,
              "y": 38.002,
              "z": 0.124
            },
            "rightCorner": {
              "x": -0.107,
              "y": 38.006,
              "z": 0.124
            },
            "gtin": "8001841078137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f661",
            "leftCorner": {
              "x": -0.106,
              "y": 38.013,
              "z": 0.124
            },
            "rightCorner": {
              "x": -0.337,
              "y": 38.026,
              "z": 0.124
            },
            "gtin": "8001841062792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f662",
            "leftCorner": {
              "x": -0.337,
              "y": 38.026,
              "z": 0.124
            },
            "rightCorner": {
              "x": -0.568,
              "y": 38.04,
              "z": 0.124
            },
            "gtin": "8001841062792",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54650a",
        "height": 0.59923,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f71a",
            "leftCorner": {
              "x": 0.743,
              "y": 38.014,
              "z": 0.49
            },
            "rightCorner": {
              "x": 0.679,
              "y": 38.018,
              "z": 0.49
            },
            "gtin": "4001499908347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f71b",
            "leftCorner": {
              "x": 0.679,
              "y": 38.018,
              "z": 0.49
            },
            "rightCorner": {
              "x": 0.615,
              "y": 38.022,
              "z": 0.49
            },
            "gtin": "4001499908347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f71d",
            "leftCorner": {
              "x": 0.613,
              "y": 37.983,
              "z": 0.49
            },
            "rightCorner": {
              "x": 0.543,
              "y": 37.987,
              "z": 0.49
            },
            "gtin": "4065331001207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f71e",
            "leftCorner": {
              "x": 0.543,
              "y": 37.987,
              "z": 0.49
            },
            "rightCorner": {
              "x": 0.474,
              "y": 37.991,
              "z": 0.49
            },
            "gtin": "4065331001207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f71f",
            "leftCorner": {
              "x": 0.474,
              "y": 37.991,
              "z": 0.49
            },
            "rightCorner": {
              "x": 0.405,
              "y": 37.995,
              "z": 0.49
            },
            "gtin": "4065331001207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f720",
            "leftCorner": {
              "x": 0.405,
              "y": 37.995,
              "z": 0.49
            },
            "rightCorner": {
              "x": 0.321,
              "y": 38.0,
              "z": 0.49
            },
            "gtin": "4065331002792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f721",
            "leftCorner": {
              "x": 0.321,
              "y": 38.0,
              "z": 0.49
            },
            "rightCorner": {
              "x": 0.237,
              "y": 38.005,
              "z": 0.49
            },
            "gtin": "4065331002792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f722",
            "leftCorner": {
              "x": 0.237,
              "y": 37.998,
              "z": 0.49
            },
            "rightCorner": {
              "x": 0.139,
              "y": 38.003,
              "z": 0.49
            },
            "gtin": "4065331001160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f723",
            "leftCorner": {
              "x": 0.139,
              "y": 38.003,
              "z": 0.49
            },
            "rightCorner": {
              "x": 0.041,
              "y": 38.008,
              "z": 0.49
            },
            "gtin": "4065331001160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f724",
            "leftCorner": {
              "x": 0.04,
              "y": 37.999,
              "z": 0.49
            },
            "rightCorner": {
              "x": -0.089,
              "y": 38.007,
              "z": 0.49
            },
            "gtin": "4065331002815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f725",
            "leftCorner": {
              "x": -0.088,
              "y": 38.023,
              "z": 0.49
            },
            "rightCorner": {
              "x": -0.144,
              "y": 38.027,
              "z": 0.49
            },
            "gtin": "4065331001122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f726",
            "leftCorner": {
              "x": -0.144,
              "y": 38.027,
              "z": 0.49
            },
            "rightCorner": {
              "x": -0.2,
              "y": 38.03,
              "z": 0.49
            },
            "gtin": "4065331001122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f727",
            "leftCorner": {
              "x": -0.2,
              "y": 38.028,
              "z": 0.49
            },
            "rightCorner": {
              "x": -0.257,
              "y": 38.031,
              "z": 0.49
            },
            "gtin": "4065331001085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f728",
            "leftCorner": {
              "x": -0.257,
              "y": 38.031,
              "z": 0.49
            },
            "rightCorner": {
              "x": -0.314,
              "y": 38.035,
              "z": 0.49
            },
            "gtin": "4065331001085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f729",
            "leftCorner": {
              "x": -0.313,
              "y": 38.045,
              "z": 0.49
            },
            "rightCorner": {
              "x": -0.438,
              "y": 38.052,
              "z": 0.49
            },
            "gtin": "4065331001306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f71c",
            "leftCorner": {
              "x": -0.438,
              "y": 38.056,
              "z": 0.49
            },
            "rightCorner": {
              "x": -0.506,
              "y": 38.06,
              "z": 0.49
            },
            "gtin": "5902357007525",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54650e",
        "height": 0.90116,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f6f7",
            "leftCorner": {
              "x": 0.728,
              "y": 37.983,
              "z": 0.737
            },
            "rightCorner": {
              "x": 0.653,
              "y": 37.987,
              "z": 0.737
            },
            "gtin": "4065331000323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6f8",
            "leftCorner": {
              "x": 0.653,
              "y": 37.987,
              "z": 0.737
            },
            "rightCorner": {
              "x": 0.579,
              "y": 37.992,
              "z": 0.737
            },
            "gtin": "4065331000323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6f9",
            "leftCorner": {
              "x": 0.578,
              "y": 37.977,
              "z": 0.737
            },
            "rightCorner": {
              "x": 0.472,
              "y": 37.983,
              "z": 0.737
            },
            "gtin": "4065331000057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6fa",
            "leftCorner": {
              "x": 0.472,
              "y": 37.983,
              "z": 0.737
            },
            "rightCorner": {
              "x": 0.365,
              "y": 37.99,
              "z": 0.737
            },
            "gtin": "4065331000057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6fb",
            "leftCorner": {
              "x": 0.366,
              "y": 38.002,
              "z": 0.737
            },
            "rightCorner": {
              "x": 0.278,
              "y": 38.007,
              "z": 0.737
            },
            "gtin": "4065331001542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6fc",
            "leftCorner": {
              "x": 0.278,
              "y": 38.007,
              "z": 0.737
            },
            "rightCorner": {
              "x": 0.191,
              "y": 38.012,
              "z": 0.737
            },
            "gtin": "4065331001542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6fd",
            "leftCorner": {
              "x": 0.19,
              "y": 37.997,
              "z": 0.737
            },
            "rightCorner": {
              "x": 0.061,
              "y": 38.005,
              "z": 0.737
            },
            "gtin": "4006000034201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6fe",
            "leftCorner": {
              "x": 0.061,
              "y": 37.996,
              "z": 0.737
            },
            "rightCorner": {
              "x": -0.006,
              "y": 38.0,
              "z": 0.737
            },
            "gtin": "4103040009210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6ff",
            "leftCorner": {
              "x": -0.004,
              "y": 38.021,
              "z": 0.737
            },
            "rightCorner": {
              "x": -0.138,
              "y": 38.028,
              "z": 0.737
            },
            "gtin": "4103040009234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f700",
            "leftCorner": {
              "x": -0.139,
              "y": 38.023,
              "z": 0.737
            },
            "rightCorner": {
              "x": -0.213,
              "y": 38.028,
              "z": 0.737
            },
            "gtin": "5902357007105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f701",
            "leftCorner": {
              "x": -0.213,
              "y": 38.028,
              "z": 0.737
            },
            "rightCorner": {
              "x": -0.288,
              "y": 38.032,
              "z": 0.737
            },
            "gtin": "5902357007105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f702",
            "leftCorner": {
              "x": -0.288,
              "y": 38.035,
              "z": 0.737
            },
            "rightCorner": {
              "x": -0.347,
              "y": 38.039,
              "z": 0.737
            },
            "gtin": "4337185856044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f703",
            "leftCorner": {
              "x": -0.347,
              "y": 38.039,
              "z": 0.737
            },
            "rightCorner": {
              "x": -0.406,
              "y": 38.042,
              "z": 0.737
            },
            "gtin": "4337185856044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6f3",
            "leftCorner": {
              "x": -0.405,
              "y": 38.057,
              "z": 0.737
            },
            "rightCorner": {
              "x": -0.455,
              "y": 38.06,
              "z": 0.737
            },
            "gtin": "4337185856068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6f4",
            "leftCorner": {
              "x": -0.455,
              "y": 38.06,
              "z": 0.737
            },
            "rightCorner": {
              "x": -0.506,
              "y": 38.063,
              "z": 0.737
            },
            "gtin": "4337185856068",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54650d",
        "height": 1.1558,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f73b",
            "leftCorner": {
              "x": 0.743,
              "y": 38.013,
              "z": 0.946
            },
            "rightCorner": {
              "x": 0.654,
              "y": 38.018,
              "z": 0.946
            },
            "gtin": "3574661816005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f73e",
            "leftCorner": {
              "x": 0.652,
              "y": 37.994,
              "z": 0.946
            },
            "rightCorner": {
              "x": 0.554,
              "y": 37.999,
              "z": 0.946
            },
            "gtin": "3574661474915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f73f",
            "leftCorner": {
              "x": 0.553,
              "y": 37.983,
              "z": 0.946
            },
            "rightCorner": {
              "x": 0.441,
              "y": 37.99,
              "z": 0.946
            },
            "gtin": "3574661474939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f740",
            "leftCorner": {
              "x": 0.441,
              "y": 37.996,
              "z": 0.946
            },
            "rightCorner": {
              "x": 0.373,
              "y": 38.0,
              "z": 0.946
            },
            "gtin": "3574661817064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f741",
            "leftCorner": {
              "x": 0.373,
              "y": 38.0,
              "z": 0.946
            },
            "rightCorner": {
              "x": 0.305,
              "y": 38.004,
              "z": 0.946
            },
            "gtin": "3574661817064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f742",
            "leftCorner": {
              "x": 0.304,
              "y": 37.999,
              "z": 0.946
            },
            "rightCorner": {
              "x": 0.208,
              "y": 38.005,
              "z": 0.946
            },
            "gtin": "3574661264431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f743",
            "leftCorner": {
              "x": 0.208,
              "y": 38.009,
              "z": 0.946
            },
            "rightCorner": {
              "x": 0.009,
              "y": 38.021,
              "z": 0.946
            },
            "gtin": "4065331000064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f744",
            "leftCorner": {
              "x": 0.009,
              "y": 38.014,
              "z": 0.946
            },
            "rightCorner": {
              "x": -0.07,
              "y": 38.019,
              "z": 0.946
            },
            "gtin": "4065331000330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f745",
            "leftCorner": {
              "x": -0.07,
              "y": 38.019,
              "z": 0.946
            },
            "rightCorner": {
              "x": -0.149,
              "y": 38.024,
              "z": 0.946
            },
            "gtin": "4065331000330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f746",
            "leftCorner": {
              "x": -0.149,
              "y": 38.024,
              "z": 0.946
            },
            "rightCorner": {
              "x": -0.228,
              "y": 38.029,
              "z": 0.946
            },
            "gtin": "4065331000330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f747",
            "leftCorner": {
              "x": -0.227,
              "y": 38.035,
              "z": 0.946
            },
            "rightCorner": {
              "x": -0.317,
              "y": 38.04,
              "z": 0.946
            },
            "gtin": "4065331000026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f748",
            "leftCorner": {
              "x": -0.317,
              "y": 38.038,
              "z": 0.946
            },
            "rightCorner": {
              "x": -0.369,
              "y": 38.041,
              "z": 0.946
            },
            "gtin": "4065331000033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f749",
            "leftCorner": {
              "x": -0.369,
              "y": 38.041,
              "z": 0.946
            },
            "rightCorner": {
              "x": -0.422,
              "y": 38.044,
              "z": 0.946
            },
            "gtin": "4065331000033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f73c",
            "leftCorner": {
              "x": -0.421,
              "y": 38.05,
              "z": 0.946
            },
            "rightCorner": {
              "x": -0.464,
              "y": 38.053,
              "z": 0.946
            },
            "gtin": "42420743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f73d",
            "leftCorner": {
              "x": -0.464,
              "y": 38.053,
              "z": 0.946
            },
            "rightCorner": {
              "x": -0.506,
              "y": 38.055,
              "z": 0.946
            },
            "gtin": "42420743",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54650c",
        "height": 1.4099,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f72a",
            "leftCorner": {
              "x": 0.744,
              "y": 38.016,
              "z": 1.154
            },
            "rightCorner": {
              "x": 0.685,
              "y": 38.02,
              "z": 1.154
            },
            "gtin": "4011609011904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f72b",
            "leftCorner": {
              "x": 0.685,
              "y": 38.02,
              "z": 1.154
            },
            "rightCorner": {
              "x": 0.627,
              "y": 38.022,
              "z": 1.154
            },
            "gtin": "4011609011904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f72c",
            "leftCorner": {
              "x": 0.627,
              "y": 38.022,
              "z": 1.154
            },
            "rightCorner": {
              "x": 0.569,
              "y": 38.026,
              "z": 1.154
            },
            "gtin": "4011609011904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f72e",
            "leftCorner": {
              "x": 0.567,
              "y": 37.991,
              "z": 1.154
            },
            "rightCorner": {
              "x": 0.484,
              "y": 37.996,
              "z": 1.154
            },
            "gtin": "3574661500553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f72f",
            "leftCorner": {
              "x": 0.484,
              "y": 37.996,
              "z": 1.154
            },
            "rightCorner": {
              "x": 0.402,
              "y": 38.001,
              "z": 1.154
            },
            "gtin": "3574661500553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f730",
            "leftCorner": {
              "x": 0.403,
              "y": 38.011,
              "z": 1.154
            },
            "rightCorner": {
              "x": 0.344,
              "y": 38.014,
              "z": 1.154
            },
            "gtin": "4048976170033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f731",
            "leftCorner": {
              "x": 0.344,
              "y": 38.014,
              "z": 1.154
            },
            "rightCorner": {
              "x": 0.285,
              "y": 38.018,
              "z": 1.154
            },
            "gtin": "4048976170033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f732",
            "leftCorner": {
              "x": 0.284,
              "y": 38.002,
              "z": 1.154
            },
            "rightCorner": {
              "x": 0.137,
              "y": 38.01,
              "z": 1.154
            },
            "gtin": "4048976170323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f733",
            "leftCorner": {
              "x": 0.137,
              "y": 37.995,
              "z": 1.154
            },
            "rightCorner": {
              "x": 0.083,
              "y": 37.998,
              "z": 1.154
            },
            "gtin": "4048976170064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f734",
            "leftCorner": {
              "x": 0.083,
              "y": 37.998,
              "z": 1.154
            },
            "rightCorner": {
              "x": 0.029,
              "y": 38.001,
              "z": 1.154
            },
            "gtin": "4048976170064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f735",
            "leftCorner": {
              "x": 0.029,
              "y": 37.998,
              "z": 1.154
            },
            "rightCorner": {
              "x": -0.029,
              "y": 38.002,
              "z": 1.154
            },
            "gtin": "4001638500777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f736",
            "leftCorner": {
              "x": -0.029,
              "y": 38.002,
              "z": 1.154
            },
            "rightCorner": {
              "x": -0.087,
              "y": 38.005,
              "z": 1.154
            },
            "gtin": "4001638500777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f737",
            "leftCorner": {
              "x": -0.085,
              "y": 38.025,
              "z": 1.154
            },
            "rightCorner": {
              "x": -0.173,
              "y": 38.03,
              "z": 1.154
            },
            "gtin": "4065331000781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f738",
            "leftCorner": {
              "x": -0.173,
              "y": 38.03,
              "z": 1.154
            },
            "rightCorner": {
              "x": -0.261,
              "y": 38.036,
              "z": 1.154
            },
            "gtin": "4065331000781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f739",
            "leftCorner": {
              "x": -0.261,
              "y": 38.036,
              "z": 1.154
            },
            "rightCorner": {
              "x": -0.349,
              "y": 38.041,
              "z": 1.154
            },
            "gtin": "4065331000781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f73a",
            "leftCorner": {
              "x": -0.349,
              "y": 38.039,
              "z": 1.154
            },
            "rightCorner": {
              "x": -0.418,
              "y": 38.043,
              "z": 1.154
            },
            "gtin": "42241294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f72d",
            "leftCorner": {
              "x": -0.417,
              "y": 38.06,
              "z": 1.154
            },
            "rightCorner": {
              "x": -0.506,
              "y": 38.065,
              "z": 1.154
            },
            "gtin": "4021457660599",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54650b",
        "height": 1.6569,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f5de",
            "leftCorner": {
              "x": 0.744,
              "y": 38.016,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.695,
              "y": 38.019,
              "z": 1.356
            },
            "gtin": "5060420233384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5df",
            "leftCorner": {
              "x": 0.695,
              "y": 38.019,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.646,
              "y": 38.022,
              "z": 1.356
            },
            "gtin": "5060420233384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5e2",
            "leftCorner": {
              "x": 0.644,
              "y": 37.981,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.493,
              "y": 37.99,
              "z": 1.356
            },
            "gtin": "5060420235357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5e3",
            "leftCorner": {
              "x": 0.493,
              "y": 37.997,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.387,
              "y": 38.003,
              "z": 1.356
            },
            "gtin": "5060420234435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5e4",
            "leftCorner": {
              "x": 0.387,
              "y": 38.003,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.281,
              "y": 38.01,
              "z": 1.356
            },
            "gtin": "5060420234435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5e5",
            "leftCorner": {
              "x": 0.281,
              "y": 38.01,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.175,
              "y": 38.016,
              "z": 1.356
            },
            "gtin": "5060420234435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5e6",
            "leftCorner": {
              "x": 0.174,
              "y": 38.001,
              "z": 1.356
            },
            "rightCorner": {
              "x": 0.035,
              "y": 38.01,
              "z": 1.356
            },
            "gtin": "4008600384946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5e7",
            "leftCorner": {
              "x": 0.035,
              "y": 38.01,
              "z": 1.356
            },
            "rightCorner": {
              "x": -0.105,
              "y": 38.018,
              "z": 1.356
            },
            "gtin": "4008600384946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5e8",
            "leftCorner": {
              "x": -0.104,
              "y": 38.039,
              "z": 1.356
            },
            "rightCorner": {
              "x": -0.228,
              "y": 38.047,
              "z": 1.356
            },
            "gtin": "5060420233353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5e9",
            "leftCorner": {
              "x": -0.229,
              "y": 38.04,
              "z": 1.356
            },
            "rightCorner": {
              "x": -0.381,
              "y": 38.048,
              "z": 1.356
            },
            "gtin": "4306188020950",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5ea",
            "leftCorner": {
              "x": -0.381,
              "y": 38.048,
              "z": 1.356
            },
            "rightCorner": {
              "x": -0.5,
              "y": 38.055,
              "z": 1.356
            },
            "gtin": "4065331000682",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "46886",
    "rightNeighborShelfId": "46888"
  },
  {
    "id": "46888",
    "name": "46888",
    "x": -0.504,
    "y": 38.097,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029553
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 93
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546515",
        "height": 0.1506,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f663",
            "leftCorner": {
              "x": -0.568,
              "y": 38.043,
              "z": 0.123
            },
            "rightCorner": {
              "x": -0.912,
              "y": 38.064,
              "z": 0.123
            },
            "gtin": "8001841041483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f664",
            "leftCorner": {
              "x": -0.912,
              "y": 38.064,
              "z": 0.123
            },
            "rightCorner": {
              "x": -1.255,
              "y": 38.084,
              "z": 0.123
            },
            "gtin": "8001841041483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f665",
            "leftCorner": {
              "x": -1.254,
              "y": 38.094,
              "z": 0.123
            },
            "rightCorner": {
              "x": -1.549,
              "y": 38.111,
              "z": 0.123
            },
            "gtin": "8001841078441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f666",
            "leftCorner": {
              "x": -1.549,
              "y": 38.111,
              "z": 0.123
            },
            "rightCorner": {
              "x": -1.843,
              "y": 38.129,
              "z": 0.123
            },
            "gtin": "8001841078441",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546512",
        "height": 0.55894,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f76f",
            "leftCorner": {
              "x": -0.504,
              "y": 38.093,
              "z": 0.457
            },
            "rightCorner": {
              "x": -0.549,
              "y": 38.096,
              "z": 0.457
            },
            "gtin": "40623474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f770",
            "leftCorner": {
              "x": -0.549,
              "y": 38.096,
              "z": 0.457
            },
            "rightCorner": {
              "x": -0.593,
              "y": 38.099,
              "z": 0.457
            },
            "gtin": "40623474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f774",
            "leftCorner": {
              "x": -0.595,
              "y": 38.073,
              "z": 0.457
            },
            "rightCorner": {
              "x": -0.79,
              "y": 38.085,
              "z": 0.457
            },
            "gtin": "4337185932373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f775",
            "leftCorner": {
              "x": -0.791,
              "y": 38.073,
              "z": 0.457
            },
            "rightCorner": {
              "x": -0.847,
              "y": 38.076,
              "z": 0.457
            },
            "gtin": "4000576045708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f776",
            "leftCorner": {
              "x": -0.847,
              "y": 38.076,
              "z": 0.457
            },
            "rightCorner": {
              "x": -0.904,
              "y": 38.08,
              "z": 0.457
            },
            "gtin": "4000576045708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f777",
            "leftCorner": {
              "x": -0.903,
              "y": 38.09,
              "z": 0.457
            },
            "rightCorner": {
              "x": -0.992,
              "y": 38.096,
              "z": 0.457
            },
            "gtin": "4063367447808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f778",
            "leftCorner": {
              "x": -0.992,
              "y": 38.096,
              "z": 0.457
            },
            "rightCorner": {
              "x": -1.082,
              "y": 38.101,
              "z": 0.457
            },
            "gtin": "4063367447808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f779",
            "leftCorner": {
              "x": -1.082,
              "y": 38.101,
              "z": 0.457
            },
            "rightCorner": {
              "x": -1.171,
              "y": 38.106,
              "z": 0.457
            },
            "gtin": "4063367447808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f77a",
            "leftCorner": {
              "x": -1.171,
              "y": 38.097,
              "z": 0.457
            },
            "rightCorner": {
              "x": -1.252,
              "y": 38.102,
              "z": 0.457
            },
            "gtin": "8001841041483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f77b",
            "leftCorner": {
              "x": -1.252,
              "y": 38.102,
              "z": 0.457
            },
            "rightCorner": {
              "x": -1.333,
              "y": 38.106,
              "z": 0.457
            },
            "gtin": "8001841041483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f77c",
            "leftCorner": {
              "x": -1.333,
              "y": 38.106,
              "z": 0.457
            },
            "rightCorner": {
              "x": -1.413,
              "y": 38.111,
              "z": 0.457
            },
            "gtin": "8001841041483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f771",
            "leftCorner": {
              "x": -1.414,
              "y": 38.105,
              "z": 0.457
            },
            "rightCorner": {
              "x": -1.527,
              "y": 38.112,
              "z": 0.457
            },
            "gtin": "8006540826669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f772",
            "leftCorner": {
              "x": -1.527,
              "y": 38.112,
              "z": 0.457
            },
            "rightCorner": {
              "x": -1.641,
              "y": 38.118,
              "z": 0.457
            },
            "gtin": "8006540826669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f773",
            "leftCorner": {
              "x": -1.641,
              "y": 38.118,
              "z": 0.457
            },
            "rightCorner": {
              "x": -1.755,
              "y": 38.125,
              "z": 0.457
            },
            "gtin": "8006540826669",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546510",
        "height": 0.84944,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f74a",
            "leftCorner": {
              "x": -0.505,
              "y": 38.088,
              "z": 0.695
            },
            "rightCorner": {
              "x": -0.542,
              "y": 38.091,
              "z": 0.695
            },
            "gtin": "4065331004215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f74b",
            "leftCorner": {
              "x": -0.542,
              "y": 38.091,
              "z": 0.695
            },
            "rightCorner": {
              "x": -0.58,
              "y": 38.092,
              "z": 0.695
            },
            "gtin": "4065331004215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f74d",
            "leftCorner": {
              "x": -0.582,
              "y": 38.055,
              "z": 0.695
            },
            "rightCorner": {
              "x": -0.648,
              "y": 38.059,
              "z": 0.695
            },
            "gtin": "4021457660636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f74e",
            "leftCorner": {
              "x": -0.648,
              "y": 38.059,
              "z": 0.695
            },
            "rightCorner": {
              "x": -0.714,
              "y": 38.062,
              "z": 0.695
            },
            "gtin": "4021457660636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f74f",
            "leftCorner": {
              "x": -0.714,
              "y": 38.064,
              "z": 0.695
            },
            "rightCorner": {
              "x": -0.757,
              "y": 38.067,
              "z": 0.695
            },
            "gtin": "4065331000743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f750",
            "leftCorner": {
              "x": -0.757,
              "y": 38.067,
              "z": 0.695
            },
            "rightCorner": {
              "x": -0.8,
              "y": 38.069,
              "z": 0.695
            },
            "gtin": "4065331000743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f751",
            "leftCorner": {
              "x": -0.799,
              "y": 38.073,
              "z": 0.695
            },
            "rightCorner": {
              "x": -0.856,
              "y": 38.077,
              "z": 0.695
            },
            "gtin": "4065331000767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f752",
            "leftCorner": {
              "x": -0.858,
              "y": 38.058,
              "z": 0.695
            },
            "rightCorner": {
              "x": -0.934,
              "y": 38.063,
              "z": 0.695
            },
            "gtin": "3574661264974",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f753",
            "leftCorner": {
              "x": -0.933,
              "y": 38.081,
              "z": 0.695
            },
            "rightCorner": {
              "x": -0.98,
              "y": 38.083,
              "z": 0.695
            },
            "gtin": "4260401410846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f754",
            "leftCorner": {
              "x": -0.981,
              "y": 38.078,
              "z": 0.695
            },
            "rightCorner": {
              "x": -1.045,
              "y": 38.082,
              "z": 0.695
            },
            "gtin": "4260401410686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f755",
            "leftCorner": {
              "x": -1.044,
              "y": 38.088,
              "z": 0.695
            },
            "rightCorner": {
              "x": -1.09,
              "y": 38.09,
              "z": 0.695
            },
            "gtin": "4062300419414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f756",
            "leftCorner": {
              "x": -1.09,
              "y": 38.084,
              "z": 0.695
            },
            "rightCorner": {
              "x": -1.189,
              "y": 38.09,
              "z": 0.695
            },
            "gtin": "4062300419452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f757",
            "leftCorner": {
              "x": -1.189,
              "y": 38.09,
              "z": 0.695
            },
            "rightCorner": {
              "x": -1.259,
              "y": 38.094,
              "z": 0.695
            },
            "gtin": "4011609011379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f758",
            "leftCorner": {
              "x": -1.259,
              "y": 38.094,
              "z": 0.695
            },
            "rightCorner": {
              "x": -1.328,
              "y": 38.099,
              "z": 0.695
            },
            "gtin": "4011609011379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f759",
            "leftCorner": {
              "x": -1.328,
              "y": 38.099,
              "z": 0.695
            },
            "rightCorner": {
              "x": -1.398,
              "y": 38.103,
              "z": 0.695
            },
            "gtin": "4011609011379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f75a",
            "leftCorner": {
              "x": -1.398,
              "y": 38.103,
              "z": 0.695
            },
            "rightCorner": {
              "x": -1.446,
              "y": 38.105,
              "z": 0.695
            },
            "gtin": "4337185820496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f75b",
            "leftCorner": {
              "x": -1.446,
              "y": 38.105,
              "z": 0.695
            },
            "rightCorner": {
              "x": -1.493,
              "y": 38.108,
              "z": 0.695
            },
            "gtin": "4337185820496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f75c",
            "leftCorner": {
              "x": -1.493,
              "y": 38.103,
              "z": 0.695
            },
            "rightCorner": {
              "x": -1.555,
              "y": 38.107,
              "z": 0.695
            },
            "gtin": "4337185820533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f75d",
            "leftCorner": {
              "x": -1.555,
              "y": 38.11,
              "z": 0.695
            },
            "rightCorner": {
              "x": -1.697,
              "y": 38.119,
              "z": 0.695
            },
            "gtin": "4063367454424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f74c",
            "leftCorner": {
              "x": -1.697,
              "y": 38.116,
              "z": 0.695
            },
            "rightCorner": {
              "x": -1.755,
              "y": 38.119,
              "z": 0.695
            },
            "gtin": "4337185909641",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546511",
        "height": 1.1013,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f75e",
            "leftCorner": {
              "x": -0.504,
              "y": 38.09,
              "z": 0.901
            },
            "rightCorner": {
              "x": -0.568,
              "y": 38.094,
              "z": 0.901
            },
            "gtin": "4102963301135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f75f",
            "leftCorner": {
              "x": -0.568,
              "y": 38.094,
              "z": 0.901
            },
            "rightCorner": {
              "x": -0.631,
              "y": 38.098,
              "z": 0.901
            },
            "gtin": "4102963301135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f760",
            "leftCorner": {
              "x": -0.631,
              "y": 38.098,
              "z": 0.901
            },
            "rightCorner": {
              "x": -0.694,
              "y": 38.101,
              "z": 0.901
            },
            "gtin": "4102963301135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f763",
            "leftCorner": {
              "x": -0.697,
              "y": 38.055,
              "z": 0.901
            },
            "rightCorner": {
              "x": -0.781,
              "y": 38.06,
              "z": 0.901
            },
            "gtin": "4102963800003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f764",
            "leftCorner": {
              "x": -0.781,
              "y": 38.06,
              "z": 0.901
            },
            "rightCorner": {
              "x": -0.865,
              "y": 38.065,
              "z": 0.901
            },
            "gtin": "4102963800003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f765",
            "leftCorner": {
              "x": -0.865,
              "y": 38.073,
              "z": 0.901
            },
            "rightCorner": {
              "x": -0.926,
              "y": 38.076,
              "z": 0.901
            },
            "gtin": "41029671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f766",
            "leftCorner": {
              "x": -0.926,
              "y": 38.073,
              "z": 0.901
            },
            "rightCorner": {
              "x": -1.039,
              "y": 38.08,
              "z": 0.901
            },
            "gtin": "4011448001104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f767",
            "leftCorner": {
              "x": -1.039,
              "y": 38.083,
              "z": 0.901
            },
            "rightCorner": {
              "x": -1.139,
              "y": 38.089,
              "z": 0.901
            },
            "gtin": "4011448007007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f768",
            "leftCorner": {
              "x": -1.139,
              "y": 38.089,
              "z": 0.901
            },
            "rightCorner": {
              "x": -1.239,
              "y": 38.095,
              "z": 0.901
            },
            "gtin": "4011448007007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f769",
            "leftCorner": {
              "x": -1.238,
              "y": 38.104,
              "z": 0.901
            },
            "rightCorner": {
              "x": -1.33,
              "y": 38.109,
              "z": 0.901
            },
            "gtin": "4001638096560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f76a",
            "leftCorner": {
              "x": -1.33,
              "y": 38.099,
              "z": 0.901
            },
            "rightCorner": {
              "x": -1.563,
              "y": 38.112,
              "z": 0.901
            },
            "gtin": "42420675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f76b",
            "leftCorner": {
              "x": -1.564,
              "y": 38.097,
              "z": 0.901
            },
            "rightCorner": {
              "x": -1.587,
              "y": 38.098,
              "z": 0.901
            },
            "gtin": "3574661643014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f76c",
            "leftCorner": {
              "x": -1.587,
              "y": 38.098,
              "z": 0.901
            },
            "rightCorner": {
              "x": -1.61,
              "y": 38.099,
              "z": 0.901
            },
            "gtin": "3574661643014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f76d",
            "leftCorner": {
              "x": -1.61,
              "y": 38.099,
              "z": 0.901
            },
            "rightCorner": {
              "x": -1.633,
              "y": 38.101,
              "z": 0.901
            },
            "gtin": "3574661643014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f76e",
            "leftCorner": {
              "x": -1.633,
              "y": 38.101,
              "z": 0.901
            },
            "rightCorner": {
              "x": -1.657,
              "y": 38.102,
              "z": 0.901
            },
            "gtin": "3574661643014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f761",
            "leftCorner": {
              "x": -1.656,
              "y": 38.112,
              "z": 0.901
            },
            "rightCorner": {
              "x": -1.705,
              "y": 38.116,
              "z": 0.901
            },
            "gtin": "3574661727073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f762",
            "leftCorner": {
              "x": -1.705,
              "y": 38.116,
              "z": 0.901
            },
            "rightCorner": {
              "x": -1.755,
              "y": 38.119,
              "z": 0.901
            },
            "gtin": "3574661727073",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546514",
        "height": 1.3566,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f77d",
            "leftCorner": {
              "x": -0.505,
              "y": 38.088,
              "z": 1.11
            },
            "rightCorner": {
              "x": -0.545,
              "y": 38.09,
              "z": 1.11
            },
            "gtin": "3574661606057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f77e",
            "leftCorner": {
              "x": -0.545,
              "y": 38.09,
              "z": 1.11
            },
            "rightCorner": {
              "x": -0.585,
              "y": 38.093,
              "z": 1.11
            },
            "gtin": "3574661606057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f780",
            "leftCorner": {
              "x": -0.587,
              "y": 38.054,
              "z": 1.11
            },
            "rightCorner": {
              "x": -0.653,
              "y": 38.057,
              "z": 1.11
            },
            "gtin": "3574661821337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f781",
            "leftCorner": {
              "x": -0.653,
              "y": 38.057,
              "z": 1.11
            },
            "rightCorner": {
              "x": -0.718,
              "y": 38.062,
              "z": 1.11
            },
            "gtin": "3574661821337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f782",
            "leftCorner": {
              "x": -0.718,
              "y": 38.061,
              "z": 1.11
            },
            "rightCorner": {
              "x": -0.77,
              "y": 38.063,
              "z": 1.11
            },
            "gtin": "3574661606040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f783",
            "leftCorner": {
              "x": -0.77,
              "y": 38.063,
              "z": 1.11
            },
            "rightCorner": {
              "x": -0.823,
              "y": 38.067,
              "z": 1.11
            },
            "gtin": "3574661606040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f784",
            "leftCorner": {
              "x": -0.823,
              "y": 38.064,
              "z": 1.11
            },
            "rightCorner": {
              "x": -0.855,
              "y": 38.065,
              "z": 1.11
            },
            "gtin": "3574661606026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f785",
            "leftCorner": {
              "x": -0.855,
              "y": 38.065,
              "z": 1.11
            },
            "rightCorner": {
              "x": -0.887,
              "y": 38.067,
              "z": 1.11
            },
            "gtin": "3574661606026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f786",
            "leftCorner": {
              "x": -0.887,
              "y": 38.068,
              "z": 1.11
            },
            "rightCorner": {
              "x": -0.935,
              "y": 38.071,
              "z": 1.11
            },
            "gtin": "3574661606033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f787",
            "leftCorner": {
              "x": -0.935,
              "y": 38.071,
              "z": 1.11
            },
            "rightCorner": {
              "x": -0.984,
              "y": 38.074,
              "z": 1.11
            },
            "gtin": "3574661606033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f788",
            "leftCorner": {
              "x": -0.984,
              "y": 38.079,
              "z": 1.11
            },
            "rightCorner": {
              "x": -1.042,
              "y": 38.082,
              "z": 1.11
            },
            "gtin": "3574661821344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f789",
            "leftCorner": {
              "x": -1.041,
              "y": 38.087,
              "z": 1.11
            },
            "rightCorner": {
              "x": -1.134,
              "y": 38.093,
              "z": 1.11
            },
            "gtin": "4001638523172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f78a",
            "leftCorner": {
              "x": -1.134,
              "y": 38.094,
              "z": 1.11
            },
            "rightCorner": {
              "x": -1.192,
              "y": 38.098,
              "z": 1.11
            },
            "gtin": "4001638523158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f78b",
            "leftCorner": {
              "x": -1.191,
              "y": 38.111,
              "z": 1.11
            },
            "rightCorner": {
              "x": -1.25,
              "y": 38.116,
              "z": 1.11
            },
            "gtin": "4001638523196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f78c",
            "leftCorner": {
              "x": -1.251,
              "y": 38.108,
              "z": 1.11
            },
            "rightCorner": {
              "x": -1.306,
              "y": 38.11,
              "z": 1.11
            },
            "gtin": "4001638523165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f78d",
            "leftCorner": {
              "x": -1.306,
              "y": 38.11,
              "z": 1.11
            },
            "rightCorner": {
              "x": -1.361,
              "y": 38.114,
              "z": 1.11
            },
            "gtin": "4001638523165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f78e",
            "leftCorner": {
              "x": -1.362,
              "y": 38.1,
              "z": 1.11
            },
            "rightCorner": {
              "x": -1.41,
              "y": 38.103,
              "z": 1.11
            },
            "gtin": "4001638523127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f78f",
            "leftCorner": {
              "x": -1.41,
              "y": 38.103,
              "z": 1.11
            },
            "rightCorner": {
              "x": -1.458,
              "y": 38.107,
              "z": 1.11
            },
            "gtin": "4001638523127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f790",
            "leftCorner": {
              "x": -1.457,
              "y": 38.115,
              "z": 1.11
            },
            "rightCorner": {
              "x": -1.537,
              "y": 38.119,
              "z": 1.11
            },
            "gtin": "4001638096652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f791",
            "leftCorner": {
              "x": -1.537,
              "y": 38.119,
              "z": 1.11
            },
            "rightCorner": {
              "x": -1.616,
              "y": 38.124,
              "z": 1.11
            },
            "gtin": "4001638096652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f792",
            "leftCorner": {
              "x": -1.616,
              "y": 38.124,
              "z": 1.11
            },
            "rightCorner": {
              "x": -1.696,
              "y": 38.129,
              "z": 1.11
            },
            "gtin": "4001638096652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f77f",
            "leftCorner": {
              "x": -1.696,
              "y": 38.129,
              "z": 1.11
            },
            "rightCorner": {
              "x": -1.754,
              "y": 38.132,
              "z": 1.11
            },
            "gtin": "4103040898241",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546513",
        "height": 1.6591,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f5eb",
            "leftCorner": {
              "x": -0.5,
              "y": 38.062,
              "z": 1.357
            },
            "rightCorner": {
              "x": -0.549,
              "y": 38.065,
              "z": 1.357
            },
            "gtin": "4065331000880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5ec",
            "leftCorner": {
              "x": -0.549,
              "y": 38.065,
              "z": 1.357
            },
            "rightCorner": {
              "x": -0.598,
              "y": 38.067,
              "z": 1.357
            },
            "gtin": "4065331000880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5ed",
            "leftCorner": {
              "x": -0.598,
              "y": 38.067,
              "z": 1.357
            },
            "rightCorner": {
              "x": -0.648,
              "y": 38.071,
              "z": 1.357
            },
            "gtin": "4065331000880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5ee",
            "leftCorner": {
              "x": -0.648,
              "y": 38.069,
              "z": 1.357
            },
            "rightCorner": {
              "x": -0.722,
              "y": 38.073,
              "z": 1.357
            },
            "gtin": "42241249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5ef",
            "leftCorner": {
              "x": -0.722,
              "y": 38.073,
              "z": 1.357
            },
            "rightCorner": {
              "x": -0.797,
              "y": 38.077,
              "z": 1.357
            },
            "gtin": "42241249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5f0",
            "leftCorner": {
              "x": -0.797,
              "y": 38.063,
              "z": 1.357
            },
            "rightCorner": {
              "x": -0.843,
              "y": 38.066,
              "z": 1.357
            },
            "gtin": "42241225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5f1",
            "leftCorner": {
              "x": -0.843,
              "y": 38.071,
              "z": 1.357
            },
            "rightCorner": {
              "x": -0.911,
              "y": 38.075,
              "z": 1.357
            },
            "gtin": "4021457657001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5f2",
            "leftCorner": {
              "x": -0.911,
              "y": 38.076,
              "z": 1.357
            },
            "rightCorner": {
              "x": -0.986,
              "y": 38.08,
              "z": 1.357
            },
            "gtin": "42241218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5f3",
            "leftCorner": {
              "x": -0.986,
              "y": 38.084,
              "z": 1.357
            },
            "rightCorner": {
              "x": -1.087,
              "y": 38.09,
              "z": 1.357
            },
            "gtin": "3574661500515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5f4",
            "leftCorner": {
              "x": -1.087,
              "y": 38.09,
              "z": 1.357
            },
            "rightCorner": {
              "x": -1.187,
              "y": 38.096,
              "z": 1.357
            },
            "gtin": "3574661500515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5f5",
            "leftCorner": {
              "x": -1.187,
              "y": 38.095,
              "z": 1.357
            },
            "rightCorner": {
              "x": -1.274,
              "y": 38.1,
              "z": 1.357
            },
            "gtin": "3574660549102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5f6",
            "leftCorner": {
              "x": -1.274,
              "y": 38.106,
              "z": 1.357
            },
            "rightCorner": {
              "x": -1.385,
              "y": 38.113,
              "z": 1.357
            },
            "gtin": "3574661474960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5f7",
            "leftCorner": {
              "x": -1.384,
              "y": 38.122,
              "z": 1.357
            },
            "rightCorner": {
              "x": -1.481,
              "y": 38.127,
              "z": 1.357
            },
            "gtin": "4063367410581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5f8",
            "leftCorner": {
              "x": -1.481,
              "y": 38.127,
              "z": 1.357
            },
            "rightCorner": {
              "x": -1.577,
              "y": 38.133,
              "z": 1.357
            },
            "gtin": "4063367410581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5f9",
            "leftCorner": {
              "x": -1.576,
              "y": 38.146,
              "z": 1.357
            },
            "rightCorner": {
              "x": -1.665,
              "y": 38.151,
              "z": 1.357
            },
            "gtin": "4063367410567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5fa",
            "leftCorner": {
              "x": -1.665,
              "y": 38.151,
              "z": 1.357
            },
            "rightCorner": {
              "x": -1.754,
              "y": 38.156,
              "z": 1.357
            },
            "gtin": "4063367410567",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "46887",
    "rightNeighborShelfId": "46889"
  },
  {
    "id": "46889",
    "name": "46889",
    "x": -1.752,
    "y": 38.171,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029553
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 27
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5464e0",
        "height": 0.15716,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f667",
            "leftCorner": {
              "x": -1.843,
              "y": 38.131,
              "z": 0.129
            },
            "rightCorner": {
              "x": -2.75,
              "y": 38.185,
              "z": 0.129
            },
            "gtin": "4063367431203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f64a",
            "leftCorner": {
              "x": -2.751,
              "y": 38.169,
              "z": 0.129
            },
            "rightCorner": {
              "x": -2.877,
              "y": 38.177,
              "z": 0.129
            },
            "gtin": "4063367430893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f64b",
            "leftCorner": {
              "x": -2.877,
              "y": 38.177,
              "z": 0.129
            },
            "rightCorner": {
              "x": -3.003,
              "y": 38.184,
              "z": 0.129
            },
            "gtin": "4063367430893",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464df",
        "height": 0.79622,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f623",
            "leftCorner": {
              "x": -1.753,
              "y": 38.157,
              "z": 0.651
            },
            "rightCorner": {
              "x": -1.988,
              "y": 38.171,
              "z": 0.651
            },
            "gtin": "4063367430848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f624",
            "leftCorner": {
              "x": -1.988,
              "y": 38.171,
              "z": 0.651
            },
            "rightCorner": {
              "x": -2.224,
              "y": 38.185,
              "z": 0.651
            },
            "gtin": "4063367430848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f628",
            "leftCorner": {
              "x": -2.226,
              "y": 38.146,
              "z": 0.651
            },
            "rightCorner": {
              "x": -2.366,
              "y": 38.154,
              "z": 0.651
            },
            "gtin": "4063367430794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f629",
            "leftCorner": {
              "x": -2.366,
              "y": 38.154,
              "z": 0.651
            },
            "rightCorner": {
              "x": -2.505,
              "y": 38.162,
              "z": 0.651
            },
            "gtin": "4063367430794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f62a",
            "leftCorner": {
              "x": -2.505,
              "y": 38.162,
              "z": 0.651
            },
            "rightCorner": {
              "x": -2.644,
              "y": 38.17,
              "z": 0.651
            },
            "gtin": "4063367430794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f62b",
            "leftCorner": {
              "x": -2.644,
              "y": 38.167,
              "z": 0.651
            },
            "rightCorner": {
              "x": -2.856,
              "y": 38.18,
              "z": 0.651
            },
            "gtin": "4063367147913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f62c",
            "leftCorner": {
              "x": -2.856,
              "y": 38.178,
              "z": 0.651
            },
            "rightCorner": {
              "x": -3.02,
              "y": 38.187,
              "z": 0.651
            },
            "gtin": "4062300446670",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464e1",
        "height": 1.2016,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f668",
            "leftCorner": {
              "x": -1.753,
              "y": 38.156,
              "z": 0.983
            },
            "rightCorner": {
              "x": -2.072,
              "y": 38.176,
              "z": 0.983
            },
            "gtin": "4063367271595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f669",
            "leftCorner": {
              "x": -2.072,
              "y": 38.176,
              "z": 0.983
            },
            "rightCorner": {
              "x": -2.392,
              "y": 38.195,
              "z": 0.983
            },
            "gtin": "4063367271595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f66b",
            "leftCorner": {
              "x": -2.394,
              "y": 38.156,
              "z": 0.983
            },
            "rightCorner": {
              "x": -2.518,
              "y": 38.163,
              "z": 0.983
            },
            "gtin": "4063367392351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f66c",
            "leftCorner": {
              "x": -2.518,
              "y": 38.163,
              "z": 0.983
            },
            "rightCorner": {
              "x": -2.642,
              "y": 38.171,
              "z": 0.983
            },
            "gtin": "4063367392351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f66d",
            "leftCorner": {
              "x": -2.642,
              "y": 38.17,
              "z": 0.983
            },
            "rightCorner": {
              "x": -2.756,
              "y": 38.176,
              "z": 0.983
            },
            "gtin": "4337185932342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f66e",
            "leftCorner": {
              "x": -2.756,
              "y": 38.176,
              "z": 0.983
            },
            "rightCorner": {
              "x": -2.869,
              "y": 38.184,
              "z": 0.983
            },
            "gtin": "4337185932342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f66f",
            "leftCorner": {
              "x": -2.87,
              "y": 38.175,
              "z": 0.983
            },
            "rightCorner": {
              "x": -2.96,
              "y": 38.18,
              "z": 0.983
            },
            "gtin": "4063367184109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f670",
            "leftCorner": {
              "x": -2.96,
              "y": 38.18,
              "z": 0.983
            },
            "rightCorner": {
              "x": -3.05,
              "y": 38.185,
              "z": 0.983
            },
            "gtin": "4063367184109",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464de",
        "height": 1.6605,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f5fb",
            "leftCorner": {
              "x": -1.756,
              "y": 38.122,
              "z": 1.359
            },
            "rightCorner": {
              "x": -1.911,
              "y": 38.131,
              "z": 1.359
            },
            "gtin": "4000735366200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5fc",
            "leftCorner": {
              "x": -1.911,
              "y": 38.131,
              "z": 1.359
            },
            "rightCorner": {
              "x": -2.066,
              "y": 38.14,
              "z": 1.359
            },
            "gtin": "4000735366200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5fd",
            "leftCorner": {
              "x": -2.066,
              "y": 38.14,
              "z": 1.359
            },
            "rightCorner": {
              "x": -2.221,
              "y": 38.15,
              "z": 1.359
            },
            "gtin": "4000735366200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5fe",
            "leftCorner": {
              "x": -2.222,
              "y": 38.148,
              "z": 1.359
            },
            "rightCorner": {
              "x": -2.398,
              "y": 38.158,
              "z": 1.359
            },
            "gtin": "4063367451164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5ff",
            "leftCorner": {
              "x": -2.398,
              "y": 38.158,
              "z": 1.359
            },
            "rightCorner": {
              "x": -2.574,
              "y": 38.168,
              "z": 1.359
            },
            "gtin": "4063367451164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f600",
            "leftCorner": {
              "x": -2.574,
              "y": 38.165,
              "z": 1.359
            },
            "rightCorner": {
              "x": -2.717,
              "y": 38.173,
              "z": 1.359
            },
            "gtin": "4063367430930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f601",
            "leftCorner": {
              "x": -2.717,
              "y": 38.173,
              "z": 1.359
            },
            "rightCorner": {
              "x": -2.859,
              "y": 38.182,
              "z": 1.359
            },
            "gtin": "4063367430930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f602",
            "leftCorner": {
              "x": -2.858,
              "y": 38.186,
              "z": 1.359
            },
            "rightCorner": {
              "x": -2.949,
              "y": 38.191,
              "z": 1.359
            },
            "gtin": "4002857008068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f603",
            "leftCorner": {
              "x": -2.949,
              "y": 38.191,
              "z": 1.359
            },
            "rightCorner": {
              "x": -3.039,
              "y": 38.197,
              "z": 1.359
            },
            "gtin": "4002857008068",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "46888",
    "rightNeighborShelfId": "4688a"
  },
  {
    "id": "4688a",
    "name": "4688a",
    "x": -2.999,
    "y": 38.244,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029553
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 23
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546520",
        "height": 0.14497,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f967",
            "leftCorner": {
              "x": -2.999,
              "y": 38.236,
              "z": 0.119
            },
            "rightCorner": {
              "x": -3.317,
              "y": 38.254,
              "z": 0.119
            },
            "gtin": "8700216775793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f969",
            "leftCorner": {
              "x": -3.32,
              "y": 38.21,
              "z": 0.119
            },
            "rightCorner": {
              "x": -3.545,
              "y": 38.224,
              "z": 0.119
            },
            "gtin": "8700216754149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f96a",
            "leftCorner": {
              "x": -3.545,
              "y": 38.229,
              "z": 0.119
            },
            "rightCorner": {
              "x": -3.913,
              "y": 38.25,
              "z": 0.119
            },
            "gtin": "8700216793247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f96b",
            "leftCorner": {
              "x": -3.912,
              "y": 38.259,
              "z": 0.119
            },
            "rightCorner": {
              "x": -4.415,
              "y": 38.289,
              "z": 0.119
            },
            "gtin": "8700216793285",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54651d",
        "height": 0.79508,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f62d",
            "leftCorner": {
              "x": -3.018,
              "y": 38.198,
              "z": 0.651
            },
            "rightCorner": {
              "x": -3.219,
              "y": 38.209,
              "z": 0.651
            },
            "gtin": "8700216664554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f62e",
            "leftCorner": {
              "x": -3.219,
              "y": 38.209,
              "z": 0.651
            },
            "rightCorner": {
              "x": -3.419,
              "y": 38.222,
              "z": 0.651
            },
            "gtin": "8700216664554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f62f",
            "leftCorner": {
              "x": -3.419,
              "y": 38.222,
              "z": 0.651
            },
            "rightCorner": {
              "x": -3.619,
              "y": 38.233,
              "z": 0.651
            },
            "gtin": "8700216664554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f630",
            "leftCorner": {
              "x": -3.619,
              "y": 38.237,
              "z": 0.651
            },
            "rightCorner": {
              "x": -3.836,
              "y": 38.251,
              "z": 0.651
            },
            "gtin": "8700216664370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f631",
            "leftCorner": {
              "x": -3.836,
              "y": 38.251,
              "z": 0.651
            },
            "rightCorner": {
              "x": -4.053,
              "y": 38.263,
              "z": 0.651
            },
            "gtin": "8700216664370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f632",
            "leftCorner": {
              "x": -4.053,
              "y": 38.263,
              "z": 0.651
            },
            "rightCorner": {
              "x": -4.27,
              "y": 38.277,
              "z": 0.651
            },
            "gtin": "8700216664370",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54651e",
        "height": 1.2048,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f671",
            "leftCorner": {
              "x": -3.048,
              "y": 38.2,
              "z": 0.986
            },
            "rightCorner": {
              "x": -3.121,
              "y": 38.204,
              "z": 0.986
            },
            "gtin": "8700216665162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f672",
            "leftCorner": {
              "x": -3.121,
              "y": 38.204,
              "z": 0.986
            },
            "rightCorner": {
              "x": -3.194,
              "y": 38.208,
              "z": 0.986
            },
            "gtin": "8700216665162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f673",
            "leftCorner": {
              "x": -3.194,
              "y": 38.208,
              "z": 0.986
            },
            "rightCorner": {
              "x": -3.463,
              "y": 38.224,
              "z": 0.986
            },
            "gtin": "8700216207485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f674",
            "leftCorner": {
              "x": -3.464,
              "y": 38.222,
              "z": 0.986
            },
            "rightCorner": {
              "x": -3.779,
              "y": 38.24,
              "z": 0.986
            },
            "gtin": "8700216664752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f675",
            "leftCorner": {
              "x": -3.779,
              "y": 38.24,
              "z": 0.986
            },
            "rightCorner": {
              "x": -4.28,
              "y": 38.269,
              "z": 0.986
            },
            "gtin": "8700216664479",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54651f",
        "height": 1.6591,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f604",
            "leftCorner": {
              "x": -3.038,
              "y": 38.195,
              "z": 1.357
            },
            "rightCorner": {
              "x": -3.169,
              "y": 38.203,
              "z": 1.357
            },
            "gtin": "8700216664547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f605",
            "leftCorner": {
              "x": -3.169,
              "y": 38.203,
              "z": 1.357
            },
            "rightCorner": {
              "x": -3.3,
              "y": 38.21,
              "z": 1.357
            },
            "gtin": "8700216664547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f606",
            "leftCorner": {
              "x": -3.299,
              "y": 38.216,
              "z": 1.357
            },
            "rightCorner": {
              "x": -3.471,
              "y": 38.227,
              "z": 1.357
            },
            "gtin": "8700216664448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f607",
            "leftCorner": {
              "x": -3.471,
              "y": 38.227,
              "z": 1.357
            },
            "rightCorner": {
              "x": -3.642,
              "y": 38.237,
              "z": 1.357
            },
            "gtin": "8700216664448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f608",
            "leftCorner": {
              "x": -3.642,
              "y": 38.237,
              "z": 1.357
            },
            "rightCorner": {
              "x": -3.814,
              "y": 38.247,
              "z": 1.357
            },
            "gtin": "8700216664448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f609",
            "leftCorner": {
              "x": -3.813,
              "y": 38.252,
              "z": 1.357
            },
            "rightCorner": {
              "x": -3.963,
              "y": 38.26,
              "z": 1.357
            },
            "gtin": "8700216664509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f60a",
            "leftCorner": {
              "x": -3.963,
              "y": 38.258,
              "z": 1.357
            },
            "rightCorner": {
              "x": -4.144,
              "y": 38.269,
              "z": 1.357
            },
            "gtin": "8700216207614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f60b",
            "leftCorner": {
              "x": -4.144,
              "y": 38.269,
              "z": 1.357
            },
            "rightCorner": {
              "x": -4.325,
              "y": 38.28,
              "z": 1.357
            },
            "gtin": "8700216207614",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "46889",
    "rightNeighborShelfId": "4688b"
  },
  {
    "id": "4688b",
    "name": "4688b",
    "x": -4.247,
    "y": 38.318,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029553
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 24
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546524",
        "height": 0.14707,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f96c",
            "leftCorner": {
              "x": -4.415,
              "y": 38.281,
              "z": 0.12
            },
            "rightCorner": {
              "x": -4.594,
              "y": 38.291,
              "z": 0.12
            },
            "gtin": "8700216812368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f96d",
            "leftCorner": {
              "x": -4.595,
              "y": 38.287,
              "z": 0.12
            },
            "rightCorner": {
              "x": -5.044,
              "y": 38.315,
              "z": 0.12
            },
            "gtin": "8700216664585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f968",
            "leftCorner": {
              "x": -5.043,
              "y": 38.343,
              "z": 0.12
            },
            "rightCorner": {
              "x": -5.496,
              "y": 38.369,
              "z": 0.12
            },
            "gtin": "8700216754125",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546521",
        "height": 0.80446,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f633",
            "leftCorner": {
              "x": -4.272,
              "y": 38.259,
              "z": 0.658
            },
            "rightCorner": {
              "x": -4.398,
              "y": 38.266,
              "z": 0.658
            },
            "gtin": "8700216669887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f634",
            "leftCorner": {
              "x": -4.398,
              "y": 38.266,
              "z": 0.658
            },
            "rightCorner": {
              "x": -4.523,
              "y": 38.274,
              "z": 0.658
            },
            "gtin": "8700216669887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f635",
            "leftCorner": {
              "x": -4.523,
              "y": 38.274,
              "z": 0.658
            },
            "rightCorner": {
              "x": -4.65,
              "y": 38.281,
              "z": 0.658
            },
            "gtin": "8700216669887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f636",
            "leftCorner": {
              "x": -4.648,
              "y": 38.304,
              "z": 0.658
            },
            "rightCorner": {
              "x": -4.843,
              "y": 38.316,
              "z": 0.658
            },
            "gtin": "8700216669795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f637",
            "leftCorner": {
              "x": -4.843,
              "y": 38.316,
              "z": 0.658
            },
            "rightCorner": {
              "x": -5.037,
              "y": 38.327,
              "z": 0.658
            },
            "gtin": "8700216669795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f638",
            "leftCorner": {
              "x": -5.037,
              "y": 38.327,
              "z": 0.658
            },
            "rightCorner": {
              "x": -5.231,
              "y": 38.339,
              "z": 0.658
            },
            "gtin": "8700216669795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f639",
            "leftCorner": {
              "x": -5.231,
              "y": 38.344,
              "z": 0.658
            },
            "rightCorner": {
              "x": -5.387,
              "y": 38.354,
              "z": 0.658
            },
            "gtin": "8700216669832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f63a",
            "leftCorner": {
              "x": -5.387,
              "y": 38.354,
              "z": 0.658
            },
            "rightCorner": {
              "x": -5.543,
              "y": 38.363,
              "z": 0.658
            },
            "gtin": "8700216669832",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546522",
        "height": 1.2025,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f676",
            "leftCorner": {
              "x": -4.279,
              "y": 38.276,
              "z": 0.984
            },
            "rightCorner": {
              "x": -4.41,
              "y": 38.283,
              "z": 0.984
            },
            "gtin": "8700216241403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f677",
            "leftCorner": {
              "x": -4.41,
              "y": 38.283,
              "z": 0.984
            },
            "rightCorner": {
              "x": -4.54,
              "y": 38.291,
              "z": 0.984
            },
            "gtin": "8700216241403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f678",
            "leftCorner": {
              "x": -4.54,
              "y": 38.291,
              "z": 0.984
            },
            "rightCorner": {
              "x": -4.67,
              "y": 38.299,
              "z": 0.984
            },
            "gtin": "8700216241403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f679",
            "leftCorner": {
              "x": -4.669,
              "y": 38.314,
              "z": 0.984
            },
            "rightCorner": {
              "x": -5.015,
              "y": 38.335,
              "z": 0.984
            },
            "gtin": "8700216241373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f67a",
            "leftCorner": {
              "x": -5.016,
              "y": 38.327,
              "z": 0.984
            },
            "rightCorner": {
              "x": -5.395,
              "y": 38.349,
              "z": 0.984
            },
            "gtin": "8700216670456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f67b",
            "leftCorner": {
              "x": -5.395,
              "y": 38.349,
              "z": 0.984
            },
            "rightCorner": {
              "x": -5.51,
              "y": 38.356,
              "z": 0.984
            },
            "gtin": "8700216241359",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546523",
        "height": 1.6578,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f60c",
            "leftCorner": {
              "x": -4.325,
              "y": 38.288,
              "z": 1.356
            },
            "rightCorner": {
              "x": -4.456,
              "y": 38.296,
              "z": 1.356
            },
            "gtin": "8700216670555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f60d",
            "leftCorner": {
              "x": -4.456,
              "y": 38.296,
              "z": 1.356
            },
            "rightCorner": {
              "x": -4.586,
              "y": 38.304,
              "z": 1.356
            },
            "gtin": "8700216670555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f60e",
            "leftCorner": {
              "x": -4.586,
              "y": 38.304,
              "z": 1.356
            },
            "rightCorner": {
              "x": -4.717,
              "y": 38.311,
              "z": 1.356
            },
            "gtin": "8700216670555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f60f",
            "leftCorner": {
              "x": -4.717,
              "y": 38.3,
              "z": 1.356
            },
            "rightCorner": {
              "x": -5.042,
              "y": 38.319,
              "z": 1.356
            },
            "gtin": "8700216241434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f610",
            "leftCorner": {
              "x": -5.042,
              "y": 38.324,
              "z": 1.356
            },
            "rightCorner": {
              "x": -5.209,
              "y": 38.334,
              "z": 1.356
            },
            "gtin": "8700216670500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f611",
            "leftCorner": {
              "x": -5.209,
              "y": 38.334,
              "z": 1.356
            },
            "rightCorner": {
              "x": -5.376,
              "y": 38.344,
              "z": 1.356
            },
            "gtin": "8700216670500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f612",
            "leftCorner": {
              "x": -5.376,
              "y": 38.344,
              "z": 1.356
            },
            "rightCorner": {
              "x": -5.543,
              "y": 38.355,
              "z": 1.356
            },
            "gtin": "8700216670500",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4688a",
    "rightNeighborShelfId": "4688c"
  },
  {
    "id": "4688c",
    "name": "4688c",
    "x": -5.495,
    "y": 38.392,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029553
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546525",
        "height": 0.79689,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f63b",
            "leftCorner": {
              "x": -5.545,
              "y": 38.344,
              "z": 0.652
            },
            "rightCorner": {
              "x": -5.701,
              "y": 38.353,
              "z": 0.652
            },
            "gtin": "8700216713139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f63c",
            "leftCorner": {
              "x": -5.701,
              "y": 38.353,
              "z": 0.652
            },
            "rightCorner": {
              "x": -5.857,
              "y": 38.363,
              "z": 0.652
            },
            "gtin": "8700216713139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f63d",
            "leftCorner": {
              "x": -5.857,
              "y": 38.363,
              "z": 0.652
            },
            "rightCorner": {
              "x": -6.013,
              "y": 38.372,
              "z": 0.652
            },
            "gtin": "8700216713139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f63e",
            "leftCorner": {
              "x": -6.013,
              "y": 38.371,
              "z": 0.652
            },
            "rightCorner": {
              "x": -6.365,
              "y": 38.391,
              "z": 0.652
            },
            "gtin": "8700216713160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f63f",
            "leftCorner": {
              "x": -6.365,
              "y": 38.39,
              "z": 0.652
            },
            "rightCorner": {
              "x": -6.658,
              "y": 38.408,
              "z": 0.652
            },
            "gtin": "8700216713436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f640",
            "leftCorner": {
              "x": -6.658,
              "y": 38.408,
              "z": 0.652
            },
            "rightCorner": {
              "x": -6.95,
              "y": 38.425,
              "z": 0.652
            },
            "gtin": "8700216713436",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546526",
        "height": 1.2066,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f67c",
            "leftCorner": {
              "x": -5.511,
              "y": 38.342,
              "z": 0.987
            },
            "rightCorner": {
              "x": -5.732,
              "y": 38.356,
              "z": 0.987
            },
            "gtin": "8700216713238",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f67d",
            "leftCorner": {
              "x": -5.732,
              "y": 38.356,
              "z": 0.987
            },
            "rightCorner": {
              "x": -5.952,
              "y": 38.368,
              "z": 0.987
            },
            "gtin": "8700216713238",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f67e",
            "leftCorner": {
              "x": -5.952,
              "y": 38.371,
              "z": 0.987
            },
            "rightCorner": {
              "x": -6.073,
              "y": 38.378,
              "z": 0.987
            },
            "gtin": "8700216713085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f67f",
            "leftCorner": {
              "x": -6.073,
              "y": 38.378,
              "z": 0.987
            },
            "rightCorner": {
              "x": -6.194,
              "y": 38.385,
              "z": 0.987
            },
            "gtin": "8700216713085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f680",
            "leftCorner": {
              "x": -6.194,
              "y": 38.385,
              "z": 0.987
            },
            "rightCorner": {
              "x": -6.314,
              "y": 38.392,
              "z": 0.987
            },
            "gtin": "8700216713085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f681",
            "leftCorner": {
              "x": -6.314,
              "y": 38.388,
              "z": 0.987
            },
            "rightCorner": {
              "x": -6.525,
              "y": 38.4,
              "z": 0.987
            },
            "gtin": "8700216793315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f682",
            "leftCorner": {
              "x": -6.525,
              "y": 38.4,
              "z": 0.987
            },
            "rightCorner": {
              "x": -6.735,
              "y": 38.412,
              "z": 0.987
            },
            "gtin": "8700216793315",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546527",
        "height": 1.6618,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f613",
            "leftCorner": {
              "x": -5.543,
              "y": 38.361,
              "z": 1.36
            },
            "rightCorner": {
              "x": -5.937,
              "y": 38.384,
              "z": 1.36
            },
            "gtin": "8700216754361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f614",
            "leftCorner": {
              "x": -5.938,
              "y": 38.365,
              "z": 1.36
            },
            "rightCorner": {
              "x": -6.067,
              "y": 38.373,
              "z": 1.36
            },
            "gtin": "8700216227285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f615",
            "leftCorner": {
              "x": -6.067,
              "y": 38.373,
              "z": 1.36
            },
            "rightCorner": {
              "x": -6.195,
              "y": 38.38,
              "z": 1.36
            },
            "gtin": "8700216227285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f616",
            "leftCorner": {
              "x": -6.195,
              "y": 38.387,
              "z": 1.36
            },
            "rightCorner": {
              "x": -6.37,
              "y": 38.398,
              "z": 1.36
            },
            "gtin": "8700216775748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f617",
            "leftCorner": {
              "x": -6.37,
              "y": 38.403,
              "z": 1.36
            },
            "rightCorner": {
              "x": -6.581,
              "y": 38.416,
              "z": 1.36
            },
            "gtin": "8700216754088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f618",
            "leftCorner": {
              "x": -6.581,
              "y": 38.416,
              "z": 1.36
            },
            "rightCorner": {
              "x": -6.792,
              "y": 38.428,
              "z": 1.36
            },
            "gtin": "8700216754088",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4688b",
    "rightNeighborShelfId": "4688d"
  },
  {
    "id": "4688d",
    "name": "4688d",
    "x": -6.743,
    "y": 38.466,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029553
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 21
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a54652b",
        "height": 0.15059,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f96e",
            "leftCorner": {
              "x": -6.744,
              "y": 38.442,
              "z": 0.123
            },
            "rightCorner": {
              "x": -7.238,
              "y": 38.471,
              "z": 0.123
            },
            "gtin": "8700216812580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f970",
            "leftCorner": {
              "x": -7.24,
              "y": 38.435,
              "z": 0.123
            },
            "rightCorner": {
              "x": -8.214,
              "y": 38.493,
              "z": 0.123
            },
            "gtin": "8700216670531",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54652a",
        "height": 0.80285,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f641",
            "leftCorner": {
              "x": -6.95,
              "y": 38.426,
              "z": 0.657
            },
            "rightCorner": {
              "x": -7.101,
              "y": 38.435,
              "z": 0.657
            },
            "gtin": "4062300432529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f642",
            "leftCorner": {
              "x": -7.101,
              "y": 38.435,
              "z": 0.657
            },
            "rightCorner": {
              "x": -7.252,
              "y": 38.444,
              "z": 0.657
            },
            "gtin": "4062300432529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f643",
            "leftCorner": {
              "x": -7.252,
              "y": 38.452,
              "z": 0.657
            },
            "rightCorner": {
              "x": -7.505,
              "y": 38.468,
              "z": 0.657
            },
            "gtin": "4062300432543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f644",
            "leftCorner": {
              "x": -7.505,
              "y": 38.468,
              "z": 0.657
            },
            "rightCorner": {
              "x": -7.757,
              "y": 38.482,
              "z": 0.657
            },
            "gtin": "4062300432543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f645",
            "leftCorner": {
              "x": -7.757,
              "y": 38.482,
              "z": 0.657
            },
            "rightCorner": {
              "x": -8.01,
              "y": 38.498,
              "z": 0.657
            },
            "gtin": "4062300432543",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546528",
        "height": 1.2014,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f683",
            "leftCorner": {
              "x": -6.736,
              "y": 38.414,
              "z": 0.983
            },
            "rightCorner": {
              "x": -6.909,
              "y": 38.424,
              "z": 0.983
            },
            "gtin": "4062300432482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f684",
            "leftCorner": {
              "x": -6.909,
              "y": 38.424,
              "z": 0.983
            },
            "rightCorner": {
              "x": -7.082,
              "y": 38.434,
              "z": 0.983
            },
            "gtin": "4062300432482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f685",
            "leftCorner": {
              "x": -7.082,
              "y": 38.434,
              "z": 0.983
            },
            "rightCorner": {
              "x": -7.255,
              "y": 38.444,
              "z": 0.983
            },
            "gtin": "4062300432482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f686",
            "leftCorner": {
              "x": -7.255,
              "y": 38.448,
              "z": 0.983
            },
            "rightCorner": {
              "x": -7.438,
              "y": 38.459,
              "z": 0.983
            },
            "gtin": "4062300432499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f687",
            "leftCorner": {
              "x": -7.438,
              "y": 38.459,
              "z": 0.983
            },
            "rightCorner": {
              "x": -7.621,
              "y": 38.47,
              "z": 0.983
            },
            "gtin": "4062300432499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f688",
            "leftCorner": {
              "x": -7.621,
              "y": 38.47,
              "z": 0.983
            },
            "rightCorner": {
              "x": -7.804,
              "y": 38.481,
              "z": 0.983
            },
            "gtin": "4062300432499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f689",
            "leftCorner": {
              "x": -7.804,
              "y": 38.491,
              "z": 0.983
            },
            "rightCorner": {
              "x": -7.994,
              "y": 38.503,
              "z": 0.983
            },
            "gtin": "4062300432505",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546529",
        "height": 1.6575,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f619",
            "leftCorner": {
              "x": -6.793,
              "y": 38.421,
              "z": 1.356
            },
            "rightCorner": {
              "x": -7.063,
              "y": 38.438,
              "z": 1.356
            },
            "gtin": "4062300432512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f61a",
            "leftCorner": {
              "x": -7.063,
              "y": 38.438,
              "z": 1.356
            },
            "rightCorner": {
              "x": -7.333,
              "y": 38.454,
              "z": 1.356
            },
            "gtin": "4062300432512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f61b",
            "leftCorner": {
              "x": -7.333,
              "y": 38.452,
              "z": 1.356
            },
            "rightCorner": {
              "x": -7.49,
              "y": 38.461,
              "z": 1.356
            },
            "gtin": "4062300432536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f61c",
            "leftCorner": {
              "x": -7.49,
              "y": 38.461,
              "z": 1.356
            },
            "rightCorner": {
              "x": -7.647,
              "y": 38.47,
              "z": 1.356
            },
            "gtin": "4062300432536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f61d",
            "leftCorner": {
              "x": -7.647,
              "y": 38.472,
              "z": 1.356
            },
            "rightCorner": {
              "x": -7.808,
              "y": 38.482,
              "z": 1.356
            },
            "gtin": "4062300432550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f61e",
            "leftCorner": {
              "x": -7.808,
              "y": 38.488,
              "z": 1.356
            },
            "rightCorner": {
              "x": -8.176,
              "y": 38.51,
              "z": 1.356
            },
            "gtin": "4062300432574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f61f",
            "leftCorner": {
              "x": -8.176,
              "y": 38.51,
              "z": 1.356
            },
            "rightCorner": {
              "x": -8.545,
              "y": 38.531,
              "z": 1.356
            },
            "gtin": "4062300432574",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4688c",
    "rightNeighborShelfId": "4688e"
  },
  {
    "id": "4688e",
    "name": "4688e",
    "x": -7.991,
    "y": 38.54,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029553
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 17
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a54652e",
        "height": 0.15787,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f971",
            "leftCorner": {
              "x": -8.214,
              "y": 38.504,
              "z": 0.129
            },
            "rightCorner": {
              "x": -8.41,
              "y": 38.515,
              "z": 0.129
            },
            "gtin": "4063367439728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f96f",
            "leftCorner": {
              "x": -8.41,
              "y": 38.513,
              "z": 0.129
            },
            "rightCorner": {
              "x": -9.242,
              "y": 38.563,
              "z": 0.129
            },
            "gtin": "4063367422492",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54652c",
        "height": 0.79968,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f646",
            "leftCorner": {
              "x": -8.01,
              "y": 38.501,
              "z": 0.654
            },
            "rightCorner": {
              "x": -8.153,
              "y": 38.51,
              "z": 0.654
            },
            "gtin": "4063367422393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f647",
            "leftCorner": {
              "x": -8.153,
              "y": 38.51,
              "z": 0.654
            },
            "rightCorner": {
              "x": -8.295,
              "y": 38.518,
              "z": 0.654
            },
            "gtin": "4063367422393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f648",
            "leftCorner": {
              "x": -8.295,
              "y": 38.517,
              "z": 0.654
            },
            "rightCorner": {
              "x": -8.616,
              "y": 38.535,
              "z": 0.654
            },
            "gtin": "4063367422386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f625",
            "leftCorner": {
              "x": -8.616,
              "y": 38.523,
              "z": 0.654
            },
            "rightCorner": {
              "x": -8.825,
              "y": 38.536,
              "z": 0.654
            },
            "gtin": "4063367422409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f626",
            "leftCorner": {
              "x": -8.825,
              "y": 38.536,
              "z": 0.654
            },
            "rightCorner": {
              "x": -9.033,
              "y": 38.548,
              "z": 0.654
            },
            "gtin": "4063367422409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f627",
            "leftCorner": {
              "x": -9.033,
              "y": 38.548,
              "z": 0.654
            },
            "rightCorner": {
              "x": -9.242,
              "y": 38.561,
              "z": 0.654
            },
            "gtin": "4063367422409",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54652d",
        "height": 1.2007,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f68a",
            "leftCorner": {
              "x": -7.994,
              "y": 38.501,
              "z": 0.982
            },
            "rightCorner": {
              "x": -8.133,
              "y": 38.509,
              "z": 0.982
            },
            "gtin": "4063367422362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f68b",
            "leftCorner": {
              "x": -8.133,
              "y": 38.509,
              "z": 0.982
            },
            "rightCorner": {
              "x": -8.273,
              "y": 38.517,
              "z": 0.982
            },
            "gtin": "4063367422362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f68c",
            "leftCorner": {
              "x": -8.273,
              "y": 38.517,
              "z": 0.982
            },
            "rightCorner": {
              "x": -8.413,
              "y": 38.525,
              "z": 0.982
            },
            "gtin": "4063367422362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f66a",
            "leftCorner": {
              "x": -8.413,
              "y": 38.516,
              "z": 0.982
            },
            "rightCorner": {
              "x": -9.242,
              "y": 38.565,
              "z": 0.982
            },
            "gtin": "4063367422379",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54652f",
        "height": 1.6534,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f620",
            "leftCorner": {
              "x": -8.545,
              "y": 38.525,
              "z": 1.353
            },
            "rightCorner": {
              "x": -8.748,
              "y": 38.537,
              "z": 1.353
            },
            "gtin": "8700216614252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f621",
            "leftCorner": {
              "x": -8.748,
              "y": 38.537,
              "z": 1.353
            },
            "rightCorner": {
              "x": -8.951,
              "y": 38.548,
              "z": 1.353
            },
            "gtin": "8700216614252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f622",
            "leftCorner": {
              "x": -8.952,
              "y": 38.529,
              "z": 1.353
            },
            "rightCorner": {
              "x": -9.117,
              "y": 38.539,
              "z": 1.353
            },
            "gtin": "8700216241274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5e0",
            "leftCorner": {
              "x": -9.116,
              "y": 38.552,
              "z": 1.353
            },
            "rightCorner": {
              "x": -9.179,
              "y": 38.556,
              "z": 1.353
            },
            "gtin": "8700216614214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5e1",
            "leftCorner": {
              "x": -9.179,
              "y": 38.556,
              "z": 1.353
            },
            "rightCorner": {
              "x": -9.242,
              "y": 38.56,
              "z": 1.353
            },
            "gtin": "8700216614214",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4688d",
    "rightNeighborShelfId": "4688f"
  },
  {
    "id": "4688f",
    "name": "4688f",
    "x": -9.239,
    "y": 38.614,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029553
    },

    "layers": [],
    "leftNeighborShelfId": "4688e",
    "rightNeighborShelfId": "46890"
  },
  {
    "id": "46890",
    "name": "46890",
    "x": -10.486,
    "y": 38.688,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029553
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 21
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546532",
        "height": 1.3534,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f97f",
            "leftCorner": {
              "x": -11.574,
              "y": 38.696,
              "z": 1.107
            },
            "rightCorner": {
              "x": -11.737,
              "y": 38.705,
              "z": 1.107
            },
            "gtin": "4337185877704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f979",
            "leftCorner": {
              "x": -10.487,
              "y": 38.665,
              "z": 1.107
            },
            "rightCorner": {
              "x": -10.687,
              "y": 38.677,
              "z": 1.107
            },
            "gtin": "5029053537795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f97a",
            "leftCorner": {
              "x": -10.687,
              "y": 38.677,
              "z": 1.107
            },
            "rightCorner": {
              "x": -10.885,
              "y": 38.689,
              "z": 1.107
            },
            "gtin": "5029053537795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f97b",
            "leftCorner": {
              "x": -10.885,
              "y": 38.689,
              "z": 1.107
            },
            "rightCorner": {
              "x": -11.084,
              "y": 38.7,
              "z": 1.107
            },
            "gtin": "5029053537795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f97c",
            "leftCorner": {
              "x": -11.086,
              "y": 38.667,
              "z": 1.107
            },
            "rightCorner": {
              "x": -11.248,
              "y": 38.676,
              "z": 1.107
            },
            "gtin": "4337185877704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f97d",
            "leftCorner": {
              "x": -11.248,
              "y": 38.676,
              "z": 1.107
            },
            "rightCorner": {
              "x": -11.412,
              "y": 38.686,
              "z": 1.107
            },
            "gtin": "4337185877704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f97e",
            "leftCorner": {
              "x": -11.412,
              "y": 38.686,
              "z": 1.107
            },
            "rightCorner": {
              "x": -11.574,
              "y": 38.696,
              "z": 1.107
            },
            "gtin": "4337185877704",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546531",
        "height": 1.6549,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f974",
            "leftCorner": {
              "x": -10.487,
              "y": 38.661,
              "z": 1.354
            },
            "rightCorner": {
              "x": -10.702,
              "y": 38.673,
              "z": 1.354
            },
            "gtin": "4063367450174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f975",
            "leftCorner": {
              "x": -10.702,
              "y": 38.673,
              "z": 1.354
            },
            "rightCorner": {
              "x": -10.918,
              "y": 38.686,
              "z": 1.354
            },
            "gtin": "4063367450174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f976",
            "leftCorner": {
              "x": -10.918,
              "y": 38.686,
              "z": 1.354
            },
            "rightCorner": {
              "x": -11.133,
              "y": 38.699,
              "z": 1.354
            },
            "gtin": "4063367450174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f977",
            "leftCorner": {
              "x": -11.134,
              "y": 38.661,
              "z": 1.354
            },
            "rightCorner": {
              "x": -11.436,
              "y": 38.679,
              "z": 1.354
            },
            "gtin": "4063367450181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f978",
            "leftCorner": {
              "x": -11.436,
              "y": 38.679,
              "z": 1.354
            },
            "rightCorner": {
              "x": -11.738,
              "y": 38.697,
              "z": 1.354
            },
            "gtin": "4063367450181",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546533",
        "height": 0.15837,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f980",
            "leftCorner": {
              "x": -10.487,
              "y": 38.668,
              "z": 0.13
            },
            "rightCorner": {
              "x": -10.728,
              "y": 38.682,
              "z": 0.13
            },
            "gtin": "4063367439902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f981",
            "leftCorner": {
              "x": -10.728,
              "y": 38.682,
              "z": 0.13
            },
            "rightCorner": {
              "x": -10.969,
              "y": 38.697,
              "z": 0.13
            },
            "gtin": "4063367439902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f982",
            "leftCorner": {
              "x": -10.969,
              "y": 38.697,
              "z": 0.13
            },
            "rightCorner": {
              "x": -11.211,
              "y": 38.71,
              "z": 0.13
            },
            "gtin": "4063367439902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f985",
            "leftCorner": {
              "x": -11.213,
              "y": 38.67,
              "z": 0.13
            },
            "rightCorner": {
              "x": -11.373,
              "y": 38.679,
              "z": 0.13
            },
            "gtin": "4063367431524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f986",
            "leftCorner": {
              "x": -11.374,
              "y": 38.676,
              "z": 0.13
            },
            "rightCorner": {
              "x": -11.542,
              "y": 38.685,
              "z": 0.13
            },
            "gtin": "4063367431531",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f983",
            "leftCorner": {
              "x": -11.541,
              "y": 38.705,
              "z": 0.13
            },
            "rightCorner": {
              "x": -11.639,
              "y": 38.711,
              "z": 0.13
            },
            "gtin": "8595611631627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f984",
            "leftCorner": {
              "x": -11.639,
              "y": 38.711,
              "z": 0.13
            },
            "rightCorner": {
              "x": -11.737,
              "y": 38.717,
              "z": 0.13
            },
            "gtin": "8595611631627",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546530",
        "height": 0.64867,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f972",
            "leftCorner": {
              "x": -10.487,
              "y": 38.663,
              "z": 0.531
            },
            "rightCorner": {
              "x": -11.135,
              "y": 38.701,
              "z": 0.531
            },
            "gtin": "4063367439889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f973",
            "leftCorner": {
              "x": -11.137,
              "y": 38.662,
              "z": 0.531
            },
            "rightCorner": {
              "x": -11.738,
              "y": 38.697,
              "z": 0.531
            },
            "gtin": "8595611631603",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4688f"
  },
  {
    "id": "46891",
    "name": "46891",
    "x": -10.308,
    "y": 36.834,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.021082,
      "w": 0.99978
    },

    "layers": [],
    "leftNeighborShelfId": "da3c8",
    "rightNeighborShelfId": "46892"
  },
  {
    "id": "46892",
    "name": "46892",
    "x": -9.063,
    "y": 36.785,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.018656,
      "w": 0.99983
    },

    "layers": [],
    "leftNeighborShelfId": "46891",
    "rightNeighborShelfId": "46894"
  },
  {
    "id": "46894",
    "name": "46894",
    "x": -7.81,
    "y": 36.753,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.020829,
      "w": 0.99978
    },

    "layers": [],
    "leftNeighborShelfId": "46892",
    "rightNeighborShelfId": "46895"
  },
  {
    "id": "46895",
    "name": "46895",
    "x": -6.564,
    "y": 36.7,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.025662,
      "w": 0.99967
    },

    "layers": [],
    "leftNeighborShelfId": "46894",
    "rightNeighborShelfId": "46896"
  },
  {
    "id": "46896",
    "name": "46896",
    "x": -5.298,
    "y": 36.62,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.028166,
      "w": 0.9996
    },

    "layers": [],
    "leftNeighborShelfId": "46895",
    "rightNeighborShelfId": "46897"
  },
  {
    "id": "46897",
    "name": "46897",
    "x": -4.069,
    "y": 36.57,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.029753,
      "w": 0.99956
    },

    "layers": [],
    "leftNeighborShelfId": "46896",
    "rightNeighborShelfId": "46898"
  },
  {
    "id": "46898",
    "name": "46898",
    "x": -2.814,
    "y": 36.479,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.02752,
      "w": 0.99962
    },

    "layers": [],
    "leftNeighborShelfId": "46897",
    "rightNeighborShelfId": "46899"
  },
  {
    "id": "46899",
    "name": "46899",
    "x": -1.571,
    "y": 36.392,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.029248,
      "w": 0.99957
    },

    "layers": [],
    "leftNeighborShelfId": "46898",
    "rightNeighborShelfId": "4689c"
  },
  {
    "id": "4689c",
    "name": "4689c",
    "x": -0.331,
    "y": 36.325,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.025427,
      "w": 0.99968
    },

    "layers": [],
    "leftNeighborShelfId": "46899",
    "rightNeighborShelfId": "4689d"
  },
  {
    "id": "4689d",
    "name": "4689d",
    "x": 0.938,
    "y": 36.247,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.023272,
      "w": 0.99973
    },

    "layers": [],
    "leftNeighborShelfId": "4689c",
    "rightNeighborShelfId": "4689e"
  },
  {
    "id": "4689e",
    "name": "4689e",
    "x": 2.165,
    "y": 36.164,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.019503,
      "w": 0.99981
    },

    "layers": [],
    "leftNeighborShelfId": "4689d"
  },
  {
    "id": "4689f",
    "name": "4689f",
    "x": 8.42,
    "y": 44.14,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72741,
      "w": 0.6862
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 97
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546541",
        "height": 0.513,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fa41",
            "leftCorner": {
              "x": 8.535,
              "y": 43.775,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.531,
              "y": 43.697,
              "z": 0.42
            },
            "gtin": "5054563200181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa42",
            "leftCorner": {
              "x": 8.549,
              "y": 43.696,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.544,
              "y": 43.616,
              "z": 0.42
            },
            "gtin": "8720181502835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa43",
            "leftCorner": {
              "x": 8.544,
              "y": 43.616,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.538,
              "y": 43.512,
              "z": 0.42
            },
            "gtin": "8720181502828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa44",
            "leftCorner": {
              "x": 8.543,
              "y": 43.512,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.539,
              "y": 43.446,
              "z": 0.42
            },
            "gtin": "4063367424298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa45",
            "leftCorner": {
              "x": 8.539,
              "y": 43.446,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.536,
              "y": 43.382,
              "z": 0.42
            },
            "gtin": "4063367424298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa46",
            "leftCorner": {
              "x": 8.533,
              "y": 43.382,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.527,
              "y": 43.28,
              "z": 0.42
            },
            "gtin": "4063367424274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa47",
            "leftCorner": {
              "x": 8.529,
              "y": 43.28,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.524,
              "y": 43.187,
              "z": 0.42
            },
            "gtin": "4009903011119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa48",
            "leftCorner": {
              "x": 8.502,
              "y": 43.189,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.494,
              "y": 43.056,
              "z": 0.42
            },
            "gtin": "8718951031876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa49",
            "leftCorner": {
              "x": 8.5,
              "y": 43.055,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.496,
              "y": 42.99,
              "z": 0.42
            },
            "gtin": "8006540946930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa4a",
            "leftCorner": {
              "x": 8.496,
              "y": 42.99,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.492,
              "y": 42.924,
              "z": 0.42
            },
            "gtin": "8006540946930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa3b",
            "leftCorner": {
              "x": 8.524,
              "y": 44.134,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.515,
              "y": 43.985,
              "z": 0.42
            },
            "gtin": "7610108049363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa3d",
            "leftCorner": {
              "x": 8.552,
              "y": 43.983,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.549,
              "y": 43.928,
              "z": 0.42
            },
            "gtin": "4007965116407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa3e",
            "leftCorner": {
              "x": 8.548,
              "y": 43.928,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.545,
              "y": 43.883,
              "z": 0.42
            },
            "gtin": "5054563200242",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa3f",
            "leftCorner": {
              "x": 8.555,
              "y": 43.883,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.552,
              "y": 43.835,
              "z": 0.42
            },
            "gtin": "5054563122872",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa40",
            "leftCorner": {
              "x": 8.536,
              "y": 43.836,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.532,
              "y": 43.775,
              "z": 0.42
            },
            "gtin": "5054563121516",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54653f",
        "height": 1.1115,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fa20",
            "leftCorner": {
              "x": 8.542,
              "y": 43.735,
              "z": 0.909
            },
            "rightCorner": {
              "x": 8.539,
              "y": 43.674,
              "z": 0.909
            },
            "gtin": "8718951582378",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa21",
            "leftCorner": {
              "x": 8.537,
              "y": 43.674,
              "z": 0.909
            },
            "rightCorner": {
              "x": 8.532,
              "y": 43.589,
              "z": 0.909
            },
            "gtin": "8718951271234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa22",
            "leftCorner": {
              "x": 8.532,
              "y": 43.589,
              "z": 0.909
            },
            "rightCorner": {
              "x": 8.528,
              "y": 43.504,
              "z": 0.909
            },
            "gtin": "8718951271234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa23",
            "leftCorner": {
              "x": 8.535,
              "y": 43.504,
              "z": 0.909
            },
            "rightCorner": {
              "x": 8.526,
              "y": 43.342,
              "z": 0.909
            },
            "gtin": "4007965146008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa24",
            "leftCorner": {
              "x": 8.522,
              "y": 43.342,
              "z": 0.909
            },
            "rightCorner": {
              "x": 8.518,
              "y": 43.282,
              "z": 0.909
            },
            "gtin": "8720181501760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa25",
            "leftCorner": {
              "x": 8.518,
              "y": 43.282,
              "z": 0.909
            },
            "rightCorner": {
              "x": 8.515,
              "y": 43.221,
              "z": 0.909
            },
            "gtin": "8720181501760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa26",
            "leftCorner": {
              "x": 8.504,
              "y": 43.222,
              "z": 0.909
            },
            "rightCorner": {
              "x": 8.501,
              "y": 43.16,
              "z": 0.909
            },
            "gtin": "5054563219206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa27",
            "leftCorner": {
              "x": 8.501,
              "y": 43.16,
              "z": 0.909
            },
            "rightCorner": {
              "x": 8.497,
              "y": 43.097,
              "z": 0.909
            },
            "gtin": "5054563219206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa28",
            "leftCorner": {
              "x": 8.487,
              "y": 43.098,
              "z": 0.909
            },
            "rightCorner": {
              "x": 8.483,
              "y": 43.04,
              "z": 0.909
            },
            "gtin": "5054563207296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa29",
            "leftCorner": {
              "x": 8.483,
              "y": 43.04,
              "z": 0.909
            },
            "rightCorner": {
              "x": 8.48,
              "y": 42.98,
              "z": 0.909
            },
            "gtin": "5054563207296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa1a",
            "leftCorner": {
              "x": 8.488,
              "y": 42.98,
              "z": 0.909
            },
            "rightCorner": {
              "x": 8.486,
              "y": 42.932,
              "z": 0.909
            },
            "gtin": "5054563207326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa1b",
            "leftCorner": {
              "x": 8.486,
              "y": 42.932,
              "z": 0.909
            },
            "rightCorner": {
              "x": 8.483,
              "y": 42.884,
              "z": 0.909
            },
            "gtin": "5054563207326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa19",
            "leftCorner": {
              "x": 8.525,
              "y": 44.134,
              "z": 0.909
            },
            "rightCorner": {
              "x": 8.522,
              "y": 44.083,
              "z": 0.909
            },
            "gtin": "4001638081863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa1c",
            "leftCorner": {
              "x": 8.545,
              "y": 44.081,
              "z": 0.909
            },
            "rightCorner": {
              "x": 8.539,
              "y": 43.985,
              "z": 0.909
            },
            "gtin": "4021457652310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa1d",
            "leftCorner": {
              "x": 8.539,
              "y": 43.985,
              "z": 0.909
            },
            "rightCorner": {
              "x": 8.536,
              "y": 43.918,
              "z": 0.909
            },
            "gtin": "4063367308949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa1e",
            "leftCorner": {
              "x": 8.578,
              "y": 43.916,
              "z": 0.909
            },
            "rightCorner": {
              "x": 8.571,
              "y": 43.796,
              "z": 0.909
            },
            "gtin": "8718951411272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa1f",
            "leftCorner": {
              "x": 8.546,
              "y": 43.798,
              "z": 0.909
            },
            "rightCorner": {
              "x": 8.542,
              "y": 43.735,
              "z": 0.909
            },
            "gtin": "8718951582378",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546540",
        "height": 1.4122,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fa2a",
            "leftCorner": {
              "x": 8.522,
              "y": 44.134,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.519,
              "y": 44.069,
              "z": 1.155
            },
            "gtin": "4022551352823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa2c",
            "leftCorner": {
              "x": 8.549,
              "y": 44.068,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.546,
              "y": 44.005,
              "z": 1.155
            },
            "gtin": "8006540491782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa2d",
            "leftCorner": {
              "x": 8.548,
              "y": 44.005,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.544,
              "y": 43.928,
              "z": 1.155
            },
            "gtin": "8006540491737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa2e",
            "leftCorner": {
              "x": 8.55,
              "y": 43.928,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.547,
              "y": 43.884,
              "z": 1.155
            },
            "gtin": "7317400002231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa2f",
            "leftCorner": {
              "x": 8.54,
              "y": 43.885,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.537,
              "y": 43.828,
              "z": 1.155
            },
            "gtin": "7317400002248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa30",
            "leftCorner": {
              "x": 8.542,
              "y": 43.828,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.538,
              "y": 43.761,
              "z": 1.155
            },
            "gtin": "7317400002255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa31",
            "leftCorner": {
              "x": 8.54,
              "y": 43.76,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.538,
              "y": 43.714,
              "z": 1.155
            },
            "gtin": "7317400002262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa32",
            "leftCorner": {
              "x": 8.542,
              "y": 43.713,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.539,
              "y": 43.656,
              "z": 1.155
            },
            "gtin": "7317400002217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa33",
            "leftCorner": {
              "x": 8.533,
              "y": 43.656,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.529,
              "y": 43.586,
              "z": 1.155
            },
            "gtin": "4063367218729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa34",
            "leftCorner": {
              "x": 8.53,
              "y": 43.586,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.526,
              "y": 43.513,
              "z": 1.155
            },
            "gtin": "4063367218682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa35",
            "leftCorner": {
              "x": 8.528,
              "y": 43.513,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.523,
              "y": 43.432,
              "z": 1.155
            },
            "gtin": "4063367218705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa36",
            "leftCorner": {
              "x": 8.521,
              "y": 43.432,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.516,
              "y": 43.351,
              "z": 1.155
            },
            "gtin": "4022551352809",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c885ed67a01d9a1fa37",
            "leftCorner": {
              "x": 8.513,
              "y": 43.351,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.509,
              "y": 43.279,
              "z": 1.155
            },
            "gtin": "4022551352816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa38",
            "leftCorner": {
              "x": 8.514,
              "y": 43.279,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.51,
              "y": 43.203,
              "z": 1.155
            },
            "gtin": "4022551353479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa39",
            "leftCorner": {
              "x": 8.506,
              "y": 43.203,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.498,
              "y": 43.061,
              "z": 1.155
            },
            "gtin": "4022551353233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa3a",
            "leftCorner": {
              "x": 8.494,
              "y": 43.061,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.488,
              "y": 42.952,
              "z": 1.155
            },
            "gtin": "4022551353226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa2b",
            "leftCorner": {
              "x": 8.477,
              "y": 42.952,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.473,
              "y": 42.885,
              "z": 1.155
            },
            "gtin": "4022551353219",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54653d",
        "height": 1.7106,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f9dd",
            "leftCorner": {
              "x": 8.534,
              "y": 43.761,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.532,
              "y": 43.724,
              "z": 1.4
            },
            "gtin": "7350075692796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9de",
            "leftCorner": {
              "x": 8.541,
              "y": 43.724,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.538,
              "y": 43.668,
              "z": 1.4
            },
            "gtin": "7350075693090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9df",
            "leftCorner": {
              "x": 8.529,
              "y": 43.668,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.524,
              "y": 43.589,
              "z": 1.4
            },
            "gtin": "7350075693106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9e0",
            "leftCorner": {
              "x": 8.523,
              "y": 43.589,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.52,
              "y": 43.542,
              "z": 1.4
            },
            "gtin": "4001638098014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9e1",
            "leftCorner": {
              "x": 8.529,
              "y": 43.542,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.526,
              "y": 43.489,
              "z": 1.4
            },
            "gtin": "4001638098090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9e2",
            "leftCorner": {
              "x": 8.536,
              "y": 43.488,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.532,
              "y": 43.425,
              "z": 1.4
            },
            "gtin": "4021457652280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9e3",
            "leftCorner": {
              "x": 8.527,
              "y": 43.425,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.525,
              "y": 43.379,
              "z": 1.4
            },
            "gtin": "4021457652297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9e4",
            "leftCorner": {
              "x": 8.516,
              "y": 43.38,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.513,
              "y": 43.329,
              "z": 1.4
            },
            "gtin": "4063367308840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9e5",
            "leftCorner": {
              "x": 8.519,
              "y": 43.329,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.515,
              "y": 43.262,
              "z": 1.4
            },
            "gtin": "4008890009031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9e6",
            "leftCorner": {
              "x": 8.521,
              "y": 43.262,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.518,
              "y": 43.213,
              "z": 1.4
            },
            "gtin": "4008890009413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9e7",
            "leftCorner": {
              "x": 8.518,
              "y": 43.213,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.515,
              "y": 43.164,
              "z": 1.4
            },
            "gtin": "4008890009413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9e8",
            "leftCorner": {
              "x": 8.5,
              "y": 43.165,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.496,
              "y": 43.096,
              "z": 1.4
            },
            "gtin": "4008890008928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9e9",
            "leftCorner": {
              "x": 8.509,
              "y": 43.095,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.505,
              "y": 43.022,
              "z": 1.4
            },
            "gtin": "4008890009314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9ea",
            "leftCorner": {
              "x": 8.502,
              "y": 43.022,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.499,
              "y": 42.957,
              "z": 1.4
            },
            "gtin": "4008890009437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9eb",
            "leftCorner": {
              "x": 8.499,
              "y": 42.957,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.495,
              "y": 42.896,
              "z": 1.4
            },
            "gtin": "4008890009154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9d7",
            "leftCorner": {
              "x": 8.524,
              "y": 44.134,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.517,
              "y": 44.009,
              "z": 1.4
            },
            "gtin": "5016221012413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9d9",
            "leftCorner": {
              "x": 8.55,
              "y": 44.007,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.547,
              "y": 43.948,
              "z": 1.4
            },
            "gtin": "5016221012451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9da",
            "leftCorner": {
              "x": 8.547,
              "y": 43.948,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.543,
              "y": 43.888,
              "z": 1.4
            },
            "gtin": "5016221012451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9db",
            "leftCorner": {
              "x": 8.55,
              "y": 43.887,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.545,
              "y": 43.798,
              "z": 1.4
            },
            "gtin": "7317400017303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9dc",
            "leftCorner": {
              "x": 8.536,
              "y": 43.798,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.534,
              "y": 43.761,
              "z": 1.4
            },
            "gtin": "7350075692796",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546542",
        "height": 0.18696,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f195",
            "leftCorner": {
              "x": 8.439,
              "y": 44.139,
              "z": 0.153
            },
            "rightCorner": {
              "x": 8.429,
              "y": 43.961,
              "z": 0.153
            },
            "gtin": "4063367308734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f198",
            "leftCorner": {
              "x": 8.454,
              "y": 43.96,
              "z": 0.153
            },
            "rightCorner": {
              "x": 8.451,
              "y": 43.912,
              "z": 0.153
            },
            "gtin": "4063367308635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f199",
            "leftCorner": {
              "x": 8.451,
              "y": 43.912,
              "z": 0.153
            },
            "rightCorner": {
              "x": 8.448,
              "y": 43.863,
              "z": 0.153
            },
            "gtin": "4063367308635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f19a",
            "leftCorner": {
              "x": 8.453,
              "y": 43.863,
              "z": 0.153
            },
            "rightCorner": {
              "x": 8.447,
              "y": 43.755,
              "z": 0.153
            },
            "gtin": "4063367308567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f19b",
            "leftCorner": {
              "x": 8.446,
              "y": 43.756,
              "z": 0.153
            },
            "rightCorner": {
              "x": 8.443,
              "y": 43.713,
              "z": 0.153
            },
            "gtin": "4063367308420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f19c",
            "leftCorner": {
              "x": 8.443,
              "y": 43.713,
              "z": 0.153
            },
            "rightCorner": {
              "x": 8.441,
              "y": 43.67,
              "z": 0.153
            },
            "gtin": "4063367308420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f19d",
            "leftCorner": {
              "x": 8.441,
              "y": 43.67,
              "z": 0.153
            },
            "rightCorner": {
              "x": 8.438,
              "y": 43.628,
              "z": 0.153
            },
            "gtin": "4063367308420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f19e",
            "leftCorner": {
              "x": 8.451,
              "y": 43.627,
              "z": 0.153
            },
            "rightCorner": {
              "x": 8.442,
              "y": 43.481,
              "z": 0.153
            },
            "gtin": "8006540947203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f19f",
            "leftCorner": {
              "x": 8.439,
              "y": 43.481,
              "z": 0.153
            },
            "rightCorner": {
              "x": 8.433,
              "y": 43.377,
              "z": 0.153
            },
            "gtin": "8006540945162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1a0",
            "leftCorner": {
              "x": 8.438,
              "y": 43.377,
              "z": 0.153
            },
            "rightCorner": {
              "x": 8.434,
              "y": 43.318,
              "z": 0.153
            },
            "gtin": "5054563191519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1a1",
            "leftCorner": {
              "x": 8.431,
              "y": 43.318,
              "z": 0.153
            },
            "rightCorner": {
              "x": 8.427,
              "y": 43.239,
              "z": 0.153
            },
            "gtin": "5054563191489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1a2",
            "leftCorner": {
              "x": 8.427,
              "y": 43.239,
              "z": 0.153
            },
            "rightCorner": {
              "x": 8.422,
              "y": 43.16,
              "z": 0.153
            },
            "gtin": "5054563191489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1a3",
            "leftCorner": {
              "x": 8.425,
              "y": 43.16,
              "z": 0.153
            },
            "rightCorner": {
              "x": 8.418,
              "y": 43.04,
              "z": 0.153
            },
            "gtin": "5054563202277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1a4",
            "leftCorner": {
              "x": 8.429,
              "y": 43.04,
              "z": 0.153
            },
            "rightCorner": {
              "x": 8.424,
              "y": 42.959,
              "z": 0.153
            },
            "gtin": "8006540947050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1a5",
            "leftCorner": {
              "x": 8.424,
              "y": 42.959,
              "z": 0.153
            },
            "rightCorner": {
              "x": 8.419,
              "y": 42.876,
              "z": 0.153
            },
            "gtin": "8006540947050",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54653e",
        "height": 0.80952,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fa0a",
            "leftCorner": {
              "x": 8.52,
              "y": 44.134,
              "z": 0.662
            },
            "rightCorner": {
              "x": 8.517,
              "y": 44.082,
              "z": 0.662
            },
            "gtin": "4008666812186",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa0b",
            "leftCorner": {
              "x": 8.517,
              "y": 44.082,
              "z": 0.662
            },
            "rightCorner": {
              "x": 8.514,
              "y": 44.03,
              "z": 0.662
            },
            "gtin": "4008666812186",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa0d",
            "leftCorner": {
              "x": 8.568,
              "y": 44.027,
              "z": 0.662
            },
            "rightCorner": {
              "x": 8.563,
              "y": 43.952,
              "z": 0.662
            },
            "gtin": "4008666812162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa0e",
            "leftCorner": {
              "x": 8.563,
              "y": 43.952,
              "z": 0.662
            },
            "rightCorner": {
              "x": 8.559,
              "y": 43.878,
              "z": 0.662
            },
            "gtin": "4008666812162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa0f",
            "leftCorner": {
              "x": 8.531,
              "y": 43.88,
              "z": 0.662
            },
            "rightCorner": {
              "x": 8.522,
              "y": 43.719,
              "z": 0.662
            },
            "gtin": "5054563104397",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c885ed67a01d9a1fa10",
            "leftCorner": {
              "x": 8.54,
              "y": 43.718,
              "z": 0.662
            },
            "rightCorner": {
              "x": 8.532,
              "y": 43.57,
              "z": 0.662
            },
            "gtin": "5054563193445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa11",
            "leftCorner": {
              "x": 8.524,
              "y": 43.57,
              "z": 0.662
            },
            "rightCorner": {
              "x": 8.52,
              "y": 43.489,
              "z": 0.662
            },
            "gtin": "5054563193414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa12",
            "leftCorner": {
              "x": 8.52,
              "y": 43.489,
              "z": 0.662
            },
            "rightCorner": {
              "x": 8.515,
              "y": 43.407,
              "z": 0.662
            },
            "gtin": "5054563193414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa13",
            "leftCorner": {
              "x": 8.508,
              "y": 43.408,
              "z": 0.662
            },
            "rightCorner": {
              "x": 8.501,
              "y": 43.303,
              "z": 0.662
            },
            "gtin": "4014612521408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa14",
            "leftCorner": {
              "x": 8.505,
              "y": 43.302,
              "z": 0.662
            },
            "rightCorner": {
              "x": 8.501,
              "y": 43.237,
              "z": 0.662
            },
            "gtin": "4014612500380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa15",
            "leftCorner": {
              "x": 8.501,
              "y": 43.237,
              "z": 0.662
            },
            "rightCorner": {
              "x": 8.497,
              "y": 43.172,
              "z": 0.662
            },
            "gtin": "4014612500380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa16",
            "leftCorner": {
              "x": 8.512,
              "y": 43.171,
              "z": 0.662
            },
            "rightCorner": {
              "x": 8.505,
              "y": 43.058,
              "z": 0.662
            },
            "gtin": "4014612500359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa17",
            "leftCorner": {
              "x": 8.508,
              "y": 43.058,
              "z": 0.662
            },
            "rightCorner": {
              "x": 8.504,
              "y": 42.99,
              "z": 0.662
            },
            "gtin": "4063367308383",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa18",
            "leftCorner": {
              "x": 8.504,
              "y": 42.99,
              "z": 0.662
            },
            "rightCorner": {
              "x": 8.5,
              "y": 42.924,
              "z": 0.662
            },
            "gtin": "4063367308383",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa0c",
            "leftCorner": {
              "x": 8.492,
              "y": 42.924,
              "z": 0.662
            },
            "rightCorner": {
              "x": 8.489,
              "y": 42.884,
              "z": 0.662
            },
            "gtin": "4063367308345",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "cde05",
    "rightNeighborShelfId": "468a0"
  },
  {
    "id": "468a0",
    "name": "468a0",
    "x": 8.347,
    "y": 42.892,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72741,
      "w": 0.6862
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 87
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546549",
        "height": 0.18069,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f1a6",
            "leftCorner": {
              "x": 8.398,
              "y": 42.877,
              "z": 0.148
            },
            "rightCorner": {
              "x": 8.392,
              "y": 42.776,
              "z": 0.148
            },
            "gtin": "8718951035461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1a7",
            "leftCorner": {
              "x": 8.392,
              "y": 42.776,
              "z": 0.148
            },
            "rightCorner": {
              "x": 8.386,
              "y": 42.675,
              "z": 0.148
            },
            "gtin": "8718951035461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1a8",
            "leftCorner": {
              "x": 8.388,
              "y": 42.675,
              "z": 0.148
            },
            "rightCorner": {
              "x": 8.376,
              "y": 42.482,
              "z": 0.148
            },
            "gtin": "8718951035430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1a9",
            "leftCorner": {
              "x": 8.375,
              "y": 42.482,
              "z": 0.148
            },
            "rightCorner": {
              "x": 8.369,
              "y": 42.383,
              "z": 0.148
            },
            "gtin": "8718951227323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1aa",
            "leftCorner": {
              "x": 8.369,
              "y": 42.383,
              "z": 0.148
            },
            "rightCorner": {
              "x": 8.363,
              "y": 42.285,
              "z": 0.148
            },
            "gtin": "8718951227323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1ab",
            "leftCorner": {
              "x": 8.378,
              "y": 42.284,
              "z": 0.148
            },
            "rightCorner": {
              "x": 8.357,
              "y": 41.929,
              "z": 0.148
            },
            "gtin": "8718951227293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1ac",
            "leftCorner": {
              "x": 8.323,
              "y": 41.931,
              "z": 0.148
            },
            "rightCorner": {
              "x": 8.299,
              "y": 41.515,
              "z": 0.148
            },
            "gtin": "8718951226869",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546544",
        "height": 0.5133,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fa4b",
            "leftCorner": {
              "x": 8.496,
              "y": 42.923,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.493,
              "y": 42.858,
              "z": 0.42
            },
            "gtin": "8718951505537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa4c",
            "leftCorner": {
              "x": 8.503,
              "y": 42.857,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.493,
              "y": 42.688,
              "z": 0.42
            },
            "gtin": "8718951312432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa4d",
            "leftCorner": {
              "x": 8.491,
              "y": 42.688,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.486,
              "y": 42.599,
              "z": 0.42
            },
            "gtin": "8718951314535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa4e",
            "leftCorner": {
              "x": 8.486,
              "y": 42.599,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.48,
              "y": 42.51,
              "z": 0.42
            },
            "gtin": "8718951314535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa4f",
            "leftCorner": {
              "x": 8.484,
              "y": 42.51,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.473,
              "y": 42.326,
              "z": 0.42
            },
            "gtin": "8718951313224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa50",
            "leftCorner": {
              "x": 8.474,
              "y": 42.326,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.471,
              "y": 42.27,
              "z": 0.42
            },
            "gtin": "8718951340985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa51",
            "leftCorner": {
              "x": 8.471,
              "y": 42.27,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.468,
              "y": 42.214,
              "z": 0.42
            },
            "gtin": "8718951340985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa52",
            "leftCorner": {
              "x": 8.468,
              "y": 42.214,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.465,
              "y": 42.158,
              "z": 0.42
            },
            "gtin": "8718951340985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa53",
            "leftCorner": {
              "x": 8.461,
              "y": 42.158,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.45,
              "y": 41.983,
              "z": 0.42
            },
            "gtin": "7509546064864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa54",
            "leftCorner": {
              "x": 8.452,
              "y": 41.982,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.442,
              "y": 41.808,
              "z": 0.42
            },
            "gtin": "8718951099371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa55",
            "leftCorner": {
              "x": 8.443,
              "y": 41.808,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.436,
              "y": 41.689,
              "z": 0.42
            },
            "gtin": "8718951249981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa56",
            "leftCorner": {
              "x": 8.436,
              "y": 41.689,
              "z": 0.42
            },
            "rightCorner": {
              "x": 8.43,
              "y": 41.572,
              "z": 0.42
            },
            "gtin": "8718951249981",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546545",
        "height": 0.76727,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fa82",
            "leftCorner": {
              "x": 8.461,
              "y": 42.885,
              "z": 0.628
            },
            "rightCorner": {
              "x": 8.456,
              "y": 42.805,
              "z": 0.628
            },
            "gtin": "8006540883365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa83",
            "leftCorner": {
              "x": 8.456,
              "y": 42.805,
              "z": 0.628
            },
            "rightCorner": {
              "x": 8.452,
              "y": 42.726,
              "z": 0.628
            },
            "gtin": "8006540883365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa84",
            "leftCorner": {
              "x": 8.487,
              "y": 42.723,
              "z": 0.628
            },
            "rightCorner": {
              "x": 8.482,
              "y": 42.637,
              "z": 0.628
            },
            "gtin": "8001090573049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa85",
            "leftCorner": {
              "x": 8.482,
              "y": 42.637,
              "z": 0.628
            },
            "rightCorner": {
              "x": 8.477,
              "y": 42.55,
              "z": 0.628
            },
            "gtin": "8001090573049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa86",
            "leftCorner": {
              "x": 8.48,
              "y": 42.549,
              "z": 0.628
            },
            "rightCorner": {
              "x": 8.474,
              "y": 42.457,
              "z": 0.628
            },
            "gtin": "5054563038708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa87",
            "leftCorner": {
              "x": 8.474,
              "y": 42.457,
              "z": 0.628
            },
            "rightCorner": {
              "x": 8.469,
              "y": 42.363,
              "z": 0.628
            },
            "gtin": "5054563038708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa88",
            "leftCorner": {
              "x": 8.474,
              "y": 42.363,
              "z": 0.628
            },
            "rightCorner": {
              "x": 8.469,
              "y": 42.265,
              "z": 0.628
            },
            "gtin": "5054563211446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa89",
            "leftCorner": {
              "x": 8.469,
              "y": 42.265,
              "z": 0.628
            },
            "rightCorner": {
              "x": 8.463,
              "y": 42.168,
              "z": 0.628
            },
            "gtin": "5054563211446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa8a",
            "leftCorner": {
              "x": 8.455,
              "y": 42.168,
              "z": 0.628
            },
            "rightCorner": {
              "x": 8.45,
              "y": 42.082,
              "z": 0.628
            },
            "gtin": "5054563209146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa8b",
            "leftCorner": {
              "x": 8.45,
              "y": 42.082,
              "z": 0.628
            },
            "rightCorner": {
              "x": 8.445,
              "y": 41.995,
              "z": 0.628
            },
            "gtin": "5054563209146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa8c",
            "leftCorner": {
              "x": 8.445,
              "y": 41.995,
              "z": 0.628
            },
            "rightCorner": {
              "x": 8.438,
              "y": 41.883,
              "z": 0.628
            },
            "gtin": "5054563206558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa8d",
            "leftCorner": {
              "x": 8.438,
              "y": 41.883,
              "z": 0.628
            },
            "rightCorner": {
              "x": 8.432,
              "y": 41.771,
              "z": 0.628
            },
            "gtin": "5054563206558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa8e",
            "leftCorner": {
              "x": 8.433,
              "y": 41.771,
              "z": 0.628
            },
            "rightCorner": {
              "x": 8.43,
              "y": 41.712,
              "z": 0.628
            },
            "gtin": "5054563207111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa8f",
            "leftCorner": {
              "x": 8.43,
              "y": 41.712,
              "z": 0.628
            },
            "rightCorner": {
              "x": 8.426,
              "y": 41.654,
              "z": 0.628
            },
            "gtin": "5054563207111",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546543",
        "height": 1.0095,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fa65",
            "leftCorner": {
              "x": 8.456,
              "y": 42.885,
              "z": 0.826
            },
            "rightCorner": {
              "x": 8.452,
              "y": 42.823,
              "z": 0.826
            },
            "gtin": "8718951563629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa67",
            "leftCorner": {
              "x": 8.491,
              "y": 42.821,
              "z": 0.826
            },
            "rightCorner": {
              "x": 8.486,
              "y": 42.739,
              "z": 0.826
            },
            "gtin": "5054563085917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa68",
            "leftCorner": {
              "x": 8.486,
              "y": 42.739,
              "z": 0.826
            },
            "rightCorner": {
              "x": 8.482,
              "y": 42.658,
              "z": 0.826
            },
            "gtin": "5054563085917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa69",
            "leftCorner": {
              "x": 8.481,
              "y": 42.658,
              "z": 0.826
            },
            "rightCorner": {
              "x": 8.476,
              "y": 42.565,
              "z": 0.826
            },
            "gtin": "5054563085863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa6a",
            "leftCorner": {
              "x": 8.476,
              "y": 42.565,
              "z": 0.826
            },
            "rightCorner": {
              "x": 8.471,
              "y": 42.473,
              "z": 0.826
            },
            "gtin": "5054563085863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa6b",
            "leftCorner": {
              "x": 8.474,
              "y": 42.473,
              "z": 0.826
            },
            "rightCorner": {
              "x": 8.468,
              "y": 42.368,
              "z": 0.826
            },
            "gtin": "5054563240828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa6c",
            "leftCorner": {
              "x": 8.468,
              "y": 42.368,
              "z": 0.826
            },
            "rightCorner": {
              "x": 8.462,
              "y": 42.261,
              "z": 0.826
            },
            "gtin": "5054563240828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa6d",
            "leftCorner": {
              "x": 8.458,
              "y": 42.262,
              "z": 0.826
            },
            "rightCorner": {
              "x": 8.453,
              "y": 42.176,
              "z": 0.826
            },
            "gtin": "5054563104144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa6e",
            "leftCorner": {
              "x": 8.446,
              "y": 42.177,
              "z": 0.826
            },
            "rightCorner": {
              "x": 8.434,
              "y": 41.958,
              "z": 0.826
            },
            "gtin": "5054563209115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa6f",
            "leftCorner": {
              "x": 8.442,
              "y": 41.958,
              "z": 0.826
            },
            "rightCorner": {
              "x": 8.433,
              "y": 41.792,
              "z": 0.826
            },
            "gtin": "5054563209740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa70",
            "leftCorner": {
              "x": 8.438,
              "y": 41.791,
              "z": 0.826
            },
            "rightCorner": {
              "x": 8.434,
              "y": 41.72,
              "z": 0.826
            },
            "gtin": "5054563120946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa71",
            "leftCorner": {
              "x": 8.434,
              "y": 41.72,
              "z": 0.826
            },
            "rightCorner": {
              "x": 8.43,
              "y": 41.649,
              "z": 0.826
            },
            "gtin": "5054563120946",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546547",
        "height": 1.2597,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fa9f",
            "leftCorner": {
              "x": 8.454,
              "y": 42.886,
              "z": 1.031
            },
            "rightCorner": {
              "x": 8.45,
              "y": 42.802,
              "z": 1.031
            },
            "gtin": "5054563219657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faa0",
            "leftCorner": {
              "x": 8.45,
              "y": 42.802,
              "z": 1.031
            },
            "rightCorner": {
              "x": 8.445,
              "y": 42.72,
              "z": 1.031
            },
            "gtin": "5054563219657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faa2",
            "leftCorner": {
              "x": 8.488,
              "y": 42.717,
              "z": 1.031
            },
            "rightCorner": {
              "x": 8.482,
              "y": 42.615,
              "z": 1.031
            },
            "gtin": "5054563099587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faa3",
            "leftCorner": {
              "x": 8.486,
              "y": 42.615,
              "z": 1.031
            },
            "rightCorner": {
              "x": 8.48,
              "y": 42.518,
              "z": 1.031
            },
            "gtin": "5054563099556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faa4",
            "leftCorner": {
              "x": 8.475,
              "y": 42.518,
              "z": 1.031
            },
            "rightCorner": {
              "x": 8.465,
              "y": 42.35,
              "z": 1.031
            },
            "gtin": "5054563150707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faa5",
            "leftCorner": {
              "x": 8.458,
              "y": 42.35,
              "z": 1.031
            },
            "rightCorner": {
              "x": 8.452,
              "y": 42.246,
              "z": 1.031
            },
            "gtin": "5054563186188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faa6",
            "leftCorner": {
              "x": 8.452,
              "y": 42.246,
              "z": 1.031
            },
            "rightCorner": {
              "x": 8.446,
              "y": 42.143,
              "z": 1.031
            },
            "gtin": "5054563186188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faa7",
            "leftCorner": {
              "x": 8.446,
              "y": 42.143,
              "z": 1.031
            },
            "rightCorner": {
              "x": 8.439,
              "y": 42.031,
              "z": 1.031
            },
            "gtin": "5054563157201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faa8",
            "leftCorner": {
              "x": 8.439,
              "y": 42.031,
              "z": 1.031
            },
            "rightCorner": {
              "x": 8.432,
              "y": 41.918,
              "z": 1.031
            },
            "gtin": "5054563157201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faa9",
            "leftCorner": {
              "x": 8.43,
              "y": 41.918,
              "z": 1.031
            },
            "rightCorner": {
              "x": 8.421,
              "y": 41.759,
              "z": 1.031
            },
            "gtin": "5054563153463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faaa",
            "leftCorner": {
              "x": 8.427,
              "y": 41.757,
              "z": 1.031
            },
            "rightCorner": {
              "x": 8.423,
              "y": 41.697,
              "z": 1.031
            },
            "gtin": "5054563949486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faab",
            "leftCorner": {
              "x": 8.423,
              "y": 41.697,
              "z": 1.031
            },
            "rightCorner": {
              "x": 8.42,
              "y": 41.636,
              "z": 1.031
            },
            "gtin": "5054563949486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faac",
            "leftCorner": {
              "x": 8.42,
              "y": 41.636,
              "z": 1.031
            },
            "rightCorner": {
              "x": 8.416,
              "y": 41.574,
              "z": 1.031
            },
            "gtin": "5054563949486",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546548",
        "height": 1.5139,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fab6",
            "leftCorner": {
              "x": 8.455,
              "y": 42.886,
              "z": 1.239
            },
            "rightCorner": {
              "x": 8.45,
              "y": 42.794,
              "z": 1.239
            },
            "gtin": "5054563209207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fab7",
            "leftCorner": {
              "x": 8.45,
              "y": 42.794,
              "z": 1.239
            },
            "rightCorner": {
              "x": 8.444,
              "y": 42.702,
              "z": 1.239
            },
            "gtin": "5054563209207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fab9",
            "leftCorner": {
              "x": 8.487,
              "y": 42.7,
              "z": 1.239
            },
            "rightCorner": {
              "x": 8.476,
              "y": 42.52,
              "z": 1.239
            },
            "gtin": "5054563089243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faba",
            "leftCorner": {
              "x": 8.467,
              "y": 42.521,
              "z": 1.239
            },
            "rightCorner": {
              "x": 8.462,
              "y": 42.433,
              "z": 1.239
            },
            "gtin": "5054563209238",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fabb",
            "leftCorner": {
              "x": 8.462,
              "y": 42.433,
              "z": 1.239
            },
            "rightCorner": {
              "x": 8.457,
              "y": 42.343,
              "z": 1.239
            },
            "gtin": "5054563209238",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fabc",
            "leftCorner": {
              "x": 8.461,
              "y": 42.343,
              "z": 1.239
            },
            "rightCorner": {
              "x": 8.456,
              "y": 42.253,
              "z": 1.239
            },
            "gtin": "5054563209290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fabd",
            "leftCorner": {
              "x": 8.456,
              "y": 42.253,
              "z": 1.239
            },
            "rightCorner": {
              "x": 8.451,
              "y": 42.163,
              "z": 1.239
            },
            "gtin": "5054563209290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fabe",
            "leftCorner": {
              "x": 8.451,
              "y": 42.163,
              "z": 1.239
            },
            "rightCorner": {
              "x": 8.445,
              "y": 42.068,
              "z": 1.239
            },
            "gtin": "5054563209269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fabf",
            "leftCorner": {
              "x": 8.445,
              "y": 42.068,
              "z": 1.239
            },
            "rightCorner": {
              "x": 8.44,
              "y": 41.974,
              "z": 1.239
            },
            "gtin": "5054563209269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fac0",
            "leftCorner": {
              "x": 8.433,
              "y": 41.974,
              "z": 1.239
            },
            "rightCorner": {
              "x": 8.428,
              "y": 41.893,
              "z": 1.239
            },
            "gtin": "4008666830005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fac1",
            "leftCorner": {
              "x": 8.428,
              "y": 41.893,
              "z": 1.239
            },
            "rightCorner": {
              "x": 8.423,
              "y": 41.812,
              "z": 1.239
            },
            "gtin": "4008666830005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fac2",
            "leftCorner": {
              "x": 8.427,
              "y": 41.812,
              "z": 1.239
            },
            "rightCorner": {
              "x": 8.422,
              "y": 41.72,
              "z": 1.239
            },
            "gtin": "4008666831125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fac3",
            "leftCorner": {
              "x": 8.422,
              "y": 41.72,
              "z": 1.239
            },
            "rightCorner": {
              "x": 8.417,
              "y": 41.629,
              "z": 1.239
            },
            "gtin": "4008666831125",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546546",
        "height": 1.7202,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f9ec",
            "leftCorner": {
              "x": 8.494,
              "y": 42.895,
              "z": 1.407
            },
            "rightCorner": {
              "x": 8.491,
              "y": 42.845,
              "z": 1.407
            },
            "gtin": "8712561437370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9ed",
            "leftCorner": {
              "x": 8.491,
              "y": 42.845,
              "z": 1.407
            },
            "rightCorner": {
              "x": 8.488,
              "y": 42.794,
              "z": 1.407
            },
            "gtin": "8712561437370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9ee",
            "leftCorner": {
              "x": 8.48,
              "y": 42.795,
              "z": 1.407
            },
            "rightCorner": {
              "x": 8.475,
              "y": 42.717,
              "z": 1.407
            },
            "gtin": "4015100185294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9ef",
            "leftCorner": {
              "x": 8.49,
              "y": 42.716,
              "z": 1.407
            },
            "rightCorner": {
              "x": 8.486,
              "y": 42.647,
              "z": 1.407
            },
            "gtin": "4015100295962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9f0",
            "leftCorner": {
              "x": 8.486,
              "y": 42.647,
              "z": 1.407
            },
            "rightCorner": {
              "x": 8.482,
              "y": 42.579,
              "z": 1.407
            },
            "gtin": "4015100295962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9f1",
            "leftCorner": {
              "x": 8.485,
              "y": 42.578,
              "z": 1.407
            },
            "rightCorner": {
              "x": 8.483,
              "y": 42.538,
              "z": 1.407
            },
            "gtin": "4015100295986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9f2",
            "leftCorner": {
              "x": 8.483,
              "y": 42.538,
              "z": 1.407
            },
            "rightCorner": {
              "x": 8.48,
              "y": 42.497,
              "z": 1.407
            },
            "gtin": "4015100295986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9f3",
            "leftCorner": {
              "x": 8.48,
              "y": 42.497,
              "z": 1.407
            },
            "rightCorner": {
              "x": 8.478,
              "y": 42.457,
              "z": 1.407
            },
            "gtin": "4015100295986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9f4",
            "leftCorner": {
              "x": 8.461,
              "y": 42.458,
              "z": 1.407
            },
            "rightCorner": {
              "x": 8.457,
              "y": 42.404,
              "z": 1.407
            },
            "gtin": "4009903500002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9f5",
            "leftCorner": {
              "x": 8.457,
              "y": 42.404,
              "z": 1.407
            },
            "rightCorner": {
              "x": 8.454,
              "y": 42.348,
              "z": 1.407
            },
            "gtin": "4009903500002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9f6",
            "leftCorner": {
              "x": 8.459,
              "y": 42.348,
              "z": 1.407
            },
            "rightCorner": {
              "x": 8.455,
              "y": 42.279,
              "z": 1.407
            },
            "gtin": "4009903600009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9f7",
            "leftCorner": {
              "x": 8.455,
              "y": 42.279,
              "z": 1.407
            },
            "rightCorner": {
              "x": 8.451,
              "y": 42.209,
              "z": 1.407
            },
            "gtin": "4009903600009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9f8",
            "leftCorner": {
              "x": 8.443,
              "y": 42.209,
              "z": 1.407
            },
            "rightCorner": {
              "x": 8.433,
              "y": 42.036,
              "z": 1.407
            },
            "gtin": "8718951454613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9f9",
            "leftCorner": {
              "x": 8.447,
              "y": 42.035,
              "z": 1.407
            },
            "rightCorner": {
              "x": 8.44,
              "y": 41.928,
              "z": 1.407
            },
            "gtin": "8714789921006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9fa",
            "leftCorner": {
              "x": 8.44,
              "y": 41.928,
              "z": 1.407
            },
            "rightCorner": {
              "x": 8.434,
              "y": 41.821,
              "z": 1.407
            },
            "gtin": "8714789921006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9fb",
            "leftCorner": {
              "x": 8.43,
              "y": 41.821,
              "z": 1.407
            },
            "rightCorner": {
              "x": 8.42,
              "y": 41.648,
              "z": 1.407
            },
            "gtin": "7610108059461",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4689f",
    "rightNeighborShelfId": "468a1"
  },
  {
    "id": "468a1",
    "name": "468a1",
    "x": 8.274,
    "y": 41.644,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72741,
      "w": 0.6862
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 89
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546550",
        "height": 0.1779,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f1ad",
            "leftCorner": {
              "x": 8.313,
              "y": 41.514,
              "z": 0.146
            },
            "rightCorner": {
              "x": 8.306,
              "y": 41.384,
              "z": 0.146
            },
            "gtin": "8720181603167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1ae",
            "leftCorner": {
              "x": 8.314,
              "y": 41.382,
              "z": 0.146
            },
            "rightCorner": {
              "x": 8.307,
              "y": 41.274,
              "z": 0.146
            },
            "gtin": "3574661778310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1af",
            "leftCorner": {
              "x": 8.302,
              "y": 41.275,
              "z": 0.146
            },
            "rightCorner": {
              "x": 8.292,
              "y": 41.106,
              "z": 0.146
            },
            "gtin": "3574661731001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1b0",
            "leftCorner": {
              "x": 8.296,
              "y": 41.106,
              "z": 0.146
            },
            "rightCorner": {
              "x": 8.29,
              "y": 41.002,
              "z": 0.146
            },
            "gtin": "3574661730936",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1b1",
            "leftCorner": {
              "x": 8.28,
              "y": 41.002,
              "z": 0.146
            },
            "rightCorner": {
              "x": 8.27,
              "y": 40.845,
              "z": 0.146
            },
            "gtin": "3574661731087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1b2",
            "leftCorner": {
              "x": 8.27,
              "y": 40.845,
              "z": 0.146
            },
            "rightCorner": {
              "x": 8.261,
              "y": 40.687,
              "z": 0.146
            },
            "gtin": "3574661731087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1b3",
            "leftCorner": {
              "x": 8.278,
              "y": 40.687,
              "z": 0.146
            },
            "rightCorner": {
              "x": 8.273,
              "y": 40.611,
              "z": 0.146
            },
            "gtin": "3574661730967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1b4",
            "leftCorner": {
              "x": 8.273,
              "y": 40.611,
              "z": 0.146
            },
            "rightCorner": {
              "x": 8.269,
              "y": 40.535,
              "z": 0.146
            },
            "gtin": "3574661730967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1b5",
            "leftCorner": {
              "x": 8.266,
              "y": 40.535,
              "z": 0.146
            },
            "rightCorner": {
              "x": 8.256,
              "y": 40.357,
              "z": 0.146
            },
            "gtin": "3574661731100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1b6",
            "leftCorner": {
              "x": 8.256,
              "y": 40.357,
              "z": 0.146
            },
            "rightCorner": {
              "x": 8.245,
              "y": 40.18,
              "z": 0.146
            },
            "gtin": "3574661731100",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54654e",
        "height": 0.50427,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fa57",
            "leftCorner": {
              "x": 8.41,
              "y": 41.573,
              "z": 0.413
            },
            "rightCorner": {
              "x": 8.405,
              "y": 41.502,
              "z": 0.413
            },
            "gtin": "42025788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa58",
            "leftCorner": {
              "x": 8.402,
              "y": 41.502,
              "z": 0.413
            },
            "rightCorner": {
              "x": 8.398,
              "y": 41.427,
              "z": 0.413
            },
            "gtin": "42023722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa59",
            "leftCorner": {
              "x": 8.398,
              "y": 41.427,
              "z": 0.413
            },
            "rightCorner": {
              "x": 8.393,
              "y": 41.353,
              "z": 0.413
            },
            "gtin": "42023722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa5a",
            "leftCorner": {
              "x": 8.399,
              "y": 41.352,
              "z": 0.413
            },
            "rightCorner": {
              "x": 8.395,
              "y": 41.29,
              "z": 0.413
            },
            "gtin": "5054563125217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa5b",
            "leftCorner": {
              "x": 8.408,
              "y": 41.288,
              "z": 0.413
            },
            "rightCorner": {
              "x": 8.403,
              "y": 41.199,
              "z": 0.413
            },
            "gtin": "5054563160461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa5c",
            "leftCorner": {
              "x": 8.399,
              "y": 41.199,
              "z": 0.413
            },
            "rightCorner": {
              "x": 8.395,
              "y": 41.119,
              "z": 0.413
            },
            "gtin": "5054563129598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa5d",
            "leftCorner": {
              "x": 8.397,
              "y": 41.119,
              "z": 0.413
            },
            "rightCorner": {
              "x": 8.393,
              "y": 41.043,
              "z": 0.413
            },
            "gtin": "5054563129567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa5e",
            "leftCorner": {
              "x": 8.379,
              "y": 41.043,
              "z": 0.413
            },
            "rightCorner": {
              "x": 8.373,
              "y": 40.936,
              "z": 0.413
            },
            "gtin": "5054563123923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa5f",
            "leftCorner": {
              "x": 8.389,
              "y": 40.936,
              "z": 0.413
            },
            "rightCorner": {
              "x": 8.385,
              "y": 40.862,
              "z": 0.413
            },
            "gtin": "5054563123893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa60",
            "leftCorner": {
              "x": 8.385,
              "y": 40.862,
              "z": 0.413
            },
            "rightCorner": {
              "x": 8.381,
              "y": 40.788,
              "z": 0.413
            },
            "gtin": "5054563123893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa61",
            "leftCorner": {
              "x": 8.371,
              "y": 40.788,
              "z": 0.413
            },
            "rightCorner": {
              "x": 8.364,
              "y": 40.659,
              "z": 0.413
            },
            "gtin": "5054563123954",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa62",
            "leftCorner": {
              "x": 8.374,
              "y": 40.659,
              "z": 0.413
            },
            "rightCorner": {
              "x": 8.37,
              "y": 40.594,
              "z": 0.413
            },
            "gtin": "5054563160461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa63",
            "leftCorner": {
              "x": 8.37,
              "y": 40.594,
              "z": 0.413
            },
            "rightCorner": {
              "x": 8.366,
              "y": 40.531,
              "z": 0.413
            },
            "gtin": "5054563160461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa64",
            "leftCorner": {
              "x": 8.372,
              "y": 40.53,
              "z": 0.413
            },
            "rightCorner": {
              "x": 8.368,
              "y": 40.454,
              "z": 0.413
            },
            "gtin": "4101160100503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa3c",
            "leftCorner": {
              "x": 8.35,
              "y": 40.455,
              "z": 0.413
            },
            "rightCorner": {
              "x": 8.346,
              "y": 40.388,
              "z": 0.413
            },
            "gtin": "4026600851503",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54654a",
        "height": 0.76445,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fa90",
            "leftCorner": {
              "x": 8.419,
              "y": 41.655,
              "z": 0.625
            },
            "rightCorner": {
              "x": 8.416,
              "y": 41.615,
              "z": 0.625
            },
            "gtin": "4009932002218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa91",
            "leftCorner": {
              "x": 8.412,
              "y": 41.615,
              "z": 0.625
            },
            "rightCorner": {
              "x": 8.409,
              "y": 41.56,
              "z": 0.625
            },
            "gtin": "4009932002201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa92",
            "leftCorner": {
              "x": 8.409,
              "y": 41.56,
              "z": 0.625
            },
            "rightCorner": {
              "x": 8.406,
              "y": 41.505,
              "z": 0.625
            },
            "gtin": "4009932002201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa93",
            "leftCorner": {
              "x": 8.403,
              "y": 41.505,
              "z": 0.625
            },
            "rightCorner": {
              "x": 8.399,
              "y": 41.442,
              "z": 0.625
            },
            "gtin": "4009932002133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa94",
            "leftCorner": {
              "x": 8.41,
              "y": 41.441,
              "z": 0.625
            },
            "rightCorner": {
              "x": 8.406,
              "y": 41.372,
              "z": 0.625
            },
            "gtin": "4009932002171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa95",
            "leftCorner": {
              "x": 8.401,
              "y": 41.372,
              "z": 0.625
            },
            "rightCorner": {
              "x": 8.396,
              "y": 41.286,
              "z": 0.625
            },
            "gtin": "4009932003109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa96",
            "leftCorner": {
              "x": 8.401,
              "y": 41.285,
              "z": 0.625
            },
            "rightCorner": {
              "x": 8.398,
              "y": 41.227,
              "z": 0.625
            },
            "gtin": "8700216623711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa97",
            "leftCorner": {
              "x": 8.398,
              "y": 41.227,
              "z": 0.625
            },
            "rightCorner": {
              "x": 8.394,
              "y": 41.168,
              "z": 0.625
            },
            "gtin": "8700216623711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa98",
            "leftCorner": {
              "x": 8.392,
              "y": 41.168,
              "z": 0.625
            },
            "rightCorner": {
              "x": 8.385,
              "y": 41.059,
              "z": 0.625
            },
            "gtin": "8700216623650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa99",
            "leftCorner": {
              "x": 8.403,
              "y": 41.058,
              "z": 0.625
            },
            "rightCorner": {
              "x": 8.396,
              "y": 40.938,
              "z": 0.625
            },
            "gtin": "8700216624053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa9a",
            "leftCorner": {
              "x": 8.396,
              "y": 40.938,
              "z": 0.625
            },
            "rightCorner": {
              "x": 8.385,
              "y": 40.755,
              "z": 0.625
            },
            "gtin": "8700216619943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa9b",
            "leftCorner": {
              "x": 8.374,
              "y": 40.756,
              "z": 0.625
            },
            "rightCorner": {
              "x": 8.366,
              "y": 40.619,
              "z": 0.625
            },
            "gtin": "8700216795944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa9c",
            "leftCorner": {
              "x": 8.372,
              "y": 40.618,
              "z": 0.625
            },
            "rightCorner": {
              "x": 8.368,
              "y": 40.541,
              "z": 0.625
            },
            "gtin": "8700216619776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa9d",
            "leftCorner": {
              "x": 8.368,
              "y": 40.541,
              "z": 0.625
            },
            "rightCorner": {
              "x": 8.363,
              "y": 40.464,
              "z": 0.625
            },
            "gtin": "8700216619776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa9e",
            "leftCorner": {
              "x": 8.362,
              "y": 40.465,
              "z": 0.625
            },
            "rightCorner": {
              "x": 8.359,
              "y": 40.421,
              "z": 0.625
            },
            "gtin": "5054563067449",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54654c",
        "height": 1.0066,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fa72",
            "leftCorner": {
              "x": 8.42,
              "y": 41.65,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.414,
              "y": 41.562,
              "z": 0.824
            },
            "gtin": "8700216666749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa73",
            "leftCorner": {
              "x": 8.414,
              "y": 41.562,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.409,
              "y": 41.476,
              "z": 0.824
            },
            "gtin": "8700216666749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa74",
            "leftCorner": {
              "x": 8.403,
              "y": 41.476,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.398,
              "y": 41.401,
              "z": 0.824
            },
            "gtin": "8006540217733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa75",
            "leftCorner": {
              "x": 8.398,
              "y": 41.401,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.394,
              "y": 41.325,
              "z": 0.824
            },
            "gtin": "8006540217733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa76",
            "leftCorner": {
              "x": 8.4,
              "y": 41.325,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.393,
              "y": 41.219,
              "z": 0.824
            },
            "gtin": "8700216666503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa77",
            "leftCorner": {
              "x": 8.397,
              "y": 41.219,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.392,
              "y": 41.129,
              "z": 0.824
            },
            "gtin": "8700216666329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa78",
            "leftCorner": {
              "x": 8.392,
              "y": 41.129,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.386,
              "y": 41.039,
              "z": 0.824
            },
            "gtin": "8700216666329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa79",
            "leftCorner": {
              "x": 8.383,
              "y": 41.039,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.375,
              "y": 40.902,
              "z": 0.824
            },
            "gtin": "8700216666619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa7a",
            "leftCorner": {
              "x": 8.386,
              "y": 40.901,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.383,
              "y": 40.84,
              "z": 0.824
            },
            "gtin": "4002448014287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa7b",
            "leftCorner": {
              "x": 8.374,
              "y": 40.84,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.371,
              "y": 40.779,
              "z": 0.824
            },
            "gtin": "4002448038900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa7c",
            "leftCorner": {
              "x": 8.371,
              "y": 40.779,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.367,
              "y": 40.719,
              "z": 0.824
            },
            "gtin": "4002448038900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa7d",
            "leftCorner": {
              "x": 8.369,
              "y": 40.719,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.367,
              "y": 40.673,
              "z": 0.824
            },
            "gtin": "4002448039464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa7e",
            "leftCorner": {
              "x": 8.367,
              "y": 40.673,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.364,
              "y": 40.628,
              "z": 0.824
            },
            "gtin": "4002448039464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa7f",
            "leftCorner": {
              "x": 8.364,
              "y": 40.628,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.361,
              "y": 40.582,
              "z": 0.824
            },
            "gtin": "4002448039464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa80",
            "leftCorner": {
              "x": 8.366,
              "y": 40.582,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.363,
              "y": 40.531,
              "z": 0.824
            },
            "gtin": "4002448039105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa81",
            "leftCorner": {
              "x": 8.363,
              "y": 40.531,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.36,
              "y": 40.481,
              "z": 0.824
            },
            "gtin": "4002448039105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa66",
            "leftCorner": {
              "x": 8.34,
              "y": 40.482,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.335,
              "y": 40.389,
              "z": 0.824
            },
            "gtin": "5054563091994",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54654f",
        "height": 1.2656,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1faad",
            "leftCorner": {
              "x": 8.415,
              "y": 41.575,
              "z": 1.035
            },
            "rightCorner": {
              "x": 8.405,
              "y": 41.402,
              "z": 1.035
            },
            "gtin": "5054563949363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faae",
            "leftCorner": {
              "x": 8.398,
              "y": 41.402,
              "z": 1.035
            },
            "rightCorner": {
              "x": 8.391,
              "y": 41.281,
              "z": 1.035
            },
            "gtin": "5054563949516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faaf",
            "leftCorner": {
              "x": 8.392,
              "y": 41.281,
              "z": 1.035
            },
            "rightCorner": {
              "x": 8.385,
              "y": 41.173,
              "z": 1.035
            },
            "gtin": "5054563949394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fab0",
            "leftCorner": {
              "x": 8.388,
              "y": 41.171,
              "z": 1.035
            },
            "rightCorner": {
              "x": 8.384,
              "y": 41.091,
              "z": 1.035
            },
            "gtin": "5054563949424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fab1",
            "leftCorner": {
              "x": 8.384,
              "y": 41.091,
              "z": 1.035
            },
            "rightCorner": {
              "x": 8.381,
              "y": 41.03,
              "z": 1.035
            },
            "gtin": "5054563121486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fab2",
            "leftCorner": {
              "x": 8.391,
              "y": 41.029,
              "z": 1.035
            },
            "rightCorner": {
              "x": 8.386,
              "y": 40.94,
              "z": 1.035
            },
            "gtin": "5054563177421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fab3",
            "leftCorner": {
              "x": 8.39,
              "y": 40.94,
              "z": 1.035
            },
            "rightCorner": {
              "x": 8.384,
              "y": 40.841,
              "z": 1.035
            },
            "gtin": "4016369461334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fab4",
            "leftCorner": {
              "x": 8.375,
              "y": 40.841,
              "z": 1.035
            },
            "rightCorner": {
              "x": 8.371,
              "y": 40.779,
              "z": 1.035
            },
            "gtin": "4016369461495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fab5",
            "leftCorner": {
              "x": 8.383,
              "y": 40.778,
              "z": 1.035
            },
            "rightCorner": {
              "x": 8.367,
              "y": 40.5,
              "z": 1.035
            },
            "gtin": "4016369465202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faa1",
            "leftCorner": {
              "x": 8.357,
              "y": 40.5,
              "z": 1.035
            },
            "rightCorner": {
              "x": 8.351,
              "y": 40.388,
              "z": 1.035
            },
            "gtin": "5054563091970",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54654d",
        "height": 1.5197,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fac4",
            "leftCorner": {
              "x": 8.413,
              "y": 41.629,
              "z": 1.243
            },
            "rightCorner": {
              "x": 8.408,
              "y": 41.541,
              "z": 1.243
            },
            "gtin": "8017331095416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fac5",
            "leftCorner": {
              "x": 8.406,
              "y": 41.541,
              "z": 1.243
            },
            "rightCorner": {
              "x": 8.401,
              "y": 41.472,
              "z": 1.243
            },
            "gtin": "8017331095386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fac6",
            "leftCorner": {
              "x": 8.398,
              "y": 41.472,
              "z": 1.243
            },
            "rightCorner": {
              "x": 8.389,
              "y": 41.31,
              "z": 1.243
            },
            "gtin": "8718951419902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fac7",
            "leftCorner": {
              "x": 8.402,
              "y": 41.308,
              "z": 1.243
            },
            "rightCorner": {
              "x": 8.392,
              "y": 41.131,
              "z": 1.243
            },
            "gtin": "8718951080041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fac8",
            "leftCorner": {
              "x": 8.39,
              "y": 41.131,
              "z": 1.243
            },
            "rightCorner": {
              "x": 8.379,
              "y": 40.937,
              "z": 1.243
            },
            "gtin": "7610108047536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fac9",
            "leftCorner": {
              "x": 8.383,
              "y": 40.937,
              "z": 1.243
            },
            "rightCorner": {
              "x": 8.372,
              "y": 40.745,
              "z": 1.243
            },
            "gtin": "7610108053568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faca",
            "leftCorner": {
              "x": 8.373,
              "y": 40.745,
              "z": 1.243
            },
            "rightCorner": {
              "x": 8.36,
              "y": 40.533,
              "z": 1.243
            },
            "gtin": "7610108059249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fab8",
            "leftCorner": {
              "x": 8.361,
              "y": 40.533,
              "z": 1.243
            },
            "rightCorner": {
              "x": 8.352,
              "y": 40.387,
              "z": 1.243
            },
            "gtin": "8714789899299",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54654b",
        "height": 1.7168,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f9fc",
            "leftCorner": {
              "x": 8.407,
              "y": 41.649,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.403,
              "y": 41.591,
              "z": 1.405
            },
            "gtin": "4007965015007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9fd",
            "leftCorner": {
              "x": 8.403,
              "y": 41.591,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.4,
              "y": 41.532,
              "z": 1.405
            },
            "gtin": "4007965015007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9fe",
            "leftCorner": {
              "x": 8.4,
              "y": 41.532,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.396,
              "y": 41.472,
              "z": 1.405
            },
            "gtin": "4007965015007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9ff",
            "leftCorner": {
              "x": 8.402,
              "y": 41.472,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.392,
              "y": 41.29,
              "z": 1.405
            },
            "gtin": "7610108056316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa00",
            "leftCorner": {
              "x": 8.39,
              "y": 41.29,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.386,
              "y": 41.224,
              "z": 1.405
            },
            "gtin": "8718951453395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa01",
            "leftCorner": {
              "x": 8.386,
              "y": 41.224,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.382,
              "y": 41.158,
              "z": 1.405
            },
            "gtin": "8718951453395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa02",
            "leftCorner": {
              "x": 8.388,
              "y": 41.158,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.38,
              "y": 41.021,
              "z": 1.405
            },
            "gtin": "8718951032644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa03",
            "leftCorner": {
              "x": 8.384,
              "y": 41.02,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.375,
              "y": 40.879,
              "z": 1.405
            },
            "gtin": "7610108059317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa04",
            "leftCorner": {
              "x": 8.371,
              "y": 40.879,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.367,
              "y": 40.809,
              "z": 1.405
            },
            "gtin": "4007965013607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa05",
            "leftCorner": {
              "x": 8.367,
              "y": 40.809,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.363,
              "y": 40.74,
              "z": 1.405
            },
            "gtin": "4007965013607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa06",
            "leftCorner": {
              "x": 8.355,
              "y": 40.74,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.351,
              "y": 40.669,
              "z": 1.405
            },
            "gtin": "7610108058884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa07",
            "leftCorner": {
              "x": 8.351,
              "y": 40.669,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.347,
              "y": 40.599,
              "z": 1.405
            },
            "gtin": "7610108058884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa08",
            "leftCorner": {
              "x": 8.341,
              "y": 40.6,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.338,
              "y": 40.543,
              "z": 1.405
            },
            "gtin": "7610108044115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fa09",
            "leftCorner": {
              "x": 8.338,
              "y": 40.543,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.335,
              "y": 40.487,
              "z": 1.405
            },
            "gtin": "7610108044115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9d8",
            "leftCorner": {
              "x": 8.346,
              "y": 40.485,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.34,
              "y": 40.388,
              "z": 1.405
            },
            "gtin": "7610108059416",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468a0",
    "rightNeighborShelfId": "468a2"
  },
  {
    "id": "468a2",
    "name": "468a2",
    "x": 8.202,
    "y": 40.396,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72741,
      "w": 0.6862
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 127
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546555",
        "height": 0.70367,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fb0f",
            "leftCorner": {
              "x": 8.284,
              "y": 40.391,
              "z": 0.576
            },
            "rightCorner": {
              "x": 8.282,
              "y": 40.35,
              "z": 0.576
            }
          },
          {
            "id": "68300c885ed67a01d9a1fb11",
            "leftCorner": {
              "x": 8.312,
              "y": 40.349,
              "z": 0.576
            },
            "rightCorner": {
              "x": 8.307,
              "y": 40.268,
              "z": 0.576
            },
            "gtin": "4064761001030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb12",
            "leftCorner": {
              "x": 8.309,
              "y": 40.268,
              "z": 0.576
            },
            "rightCorner": {
              "x": 8.304,
              "y": 40.19,
              "z": 0.576
            },
            "gtin": "4306188025566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb13",
            "leftCorner": {
              "x": 8.308,
              "y": 40.19,
              "z": 0.576
            },
            "rightCorner": {
              "x": 8.303,
              "y": 40.119,
              "z": 0.576
            },
            "gtin": "4260555341546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb14",
            "leftCorner": {
              "x": 8.301,
              "y": 40.119,
              "z": 0.576
            },
            "rightCorner": {
              "x": 8.298,
              "y": 40.051,
              "z": 0.576
            },
            "gtin": "4306188025535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb15",
            "leftCorner": {
              "x": 8.304,
              "y": 40.051,
              "z": 0.576
            },
            "rightCorner": {
              "x": 8.3,
              "y": 39.983,
              "z": 0.576
            },
            "gtin": "4306188025504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb16",
            "leftCorner": {
              "x": 8.295,
              "y": 39.984,
              "z": 0.576
            },
            "rightCorner": {
              "x": 8.292,
              "y": 39.932,
              "z": 0.576
            },
            "gtin": "4306188000273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb17",
            "leftCorner": {
              "x": 8.292,
              "y": 39.932,
              "z": 0.576
            },
            "rightCorner": {
              "x": 8.289,
              "y": 39.878,
              "z": 0.576
            },
            "gtin": "4306188000273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb18",
            "leftCorner": {
              "x": 8.295,
              "y": 39.878,
              "z": 0.576
            },
            "rightCorner": {
              "x": 8.293,
              "y": 39.831,
              "z": 0.576
            },
            "gtin": "4306188357759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb19",
            "leftCorner": {
              "x": 8.293,
              "y": 39.831,
              "z": 0.576
            },
            "rightCorner": {
              "x": 8.29,
              "y": 39.784,
              "z": 0.576
            },
            "gtin": "4306188357759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb1a",
            "leftCorner": {
              "x": 8.285,
              "y": 39.784,
              "z": 0.576
            },
            "rightCorner": {
              "x": 8.281,
              "y": 39.706,
              "z": 0.576
            },
            "gtin": "4064761001085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb1b",
            "leftCorner": {
              "x": 8.288,
              "y": 39.706,
              "z": 0.576
            },
            "rightCorner": {
              "x": 8.285,
              "y": 39.646,
              "z": 0.576
            },
            "gtin": "4260768630383",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb1c",
            "leftCorner": {
              "x": 8.286,
              "y": 39.646,
              "z": 0.576
            },
            "rightCorner": {
              "x": 8.28,
              "y": 39.548,
              "z": 0.576
            },
            "gtin": "4260555341591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb1d",
            "leftCorner": {
              "x": 8.277,
              "y": 39.549,
              "z": 0.576
            },
            "rightCorner": {
              "x": 8.273,
              "y": 39.478,
              "z": 0.576
            },
            "gtin": "4047036004394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb1e",
            "leftCorner": {
              "x": 8.276,
              "y": 39.478,
              "z": 0.576
            },
            "rightCorner": {
              "x": 8.272,
              "y": 39.409,
              "z": 0.576
            },
            "gtin": "4064761001047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb1f",
            "leftCorner": {
              "x": 8.282,
              "y": 39.409,
              "z": 0.576
            },
            "rightCorner": {
              "x": 8.277,
              "y": 39.324,
              "z": 0.576
            },
            "gtin": "4260555341560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb20",
            "leftCorner": {
              "x": 8.268,
              "y": 39.325,
              "z": 0.576
            },
            "rightCorner": {
              "x": 8.263,
              "y": 39.238,
              "z": 0.576
            },
            "gtin": "4022679167842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb10",
            "leftCorner": {
              "x": 8.266,
              "y": 39.238,
              "z": 0.576
            },
            "rightCorner": {
              "x": 8.26,
              "y": 39.141,
              "z": 0.576
            },
            "gtin": "4306188039358",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546558",
        "height": 0.18062,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f1b7",
            "leftCorner": {
              "x": 8.228,
              "y": 40.182,
              "z": 0.148
            },
            "rightCorner": {
              "x": 8.222,
              "y": 40.076,
              "z": 0.148
            },
            "gtin": "8718951483668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1b8",
            "leftCorner": {
              "x": 8.222,
              "y": 40.076,
              "z": 0.148
            },
            "rightCorner": {
              "x": 8.216,
              "y": 39.971,
              "z": 0.148
            },
            "gtin": "8718951483668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1b9",
            "leftCorner": {
              "x": 8.216,
              "y": 39.971,
              "z": 0.148
            },
            "rightCorner": {
              "x": 8.21,
              "y": 39.867,
              "z": 0.148
            },
            "gtin": "8718951483668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1ba",
            "leftCorner": {
              "x": 8.213,
              "y": 39.867,
              "z": 0.148
            },
            "rightCorner": {
              "x": 8.208,
              "y": 39.777,
              "z": 0.148
            },
            "gtin": "8017331098837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1bb",
            "leftCorner": {
              "x": 8.208,
              "y": 39.777,
              "z": 0.148
            },
            "rightCorner": {
              "x": 8.202,
              "y": 39.687,
              "z": 0.148
            },
            "gtin": "8017331098837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1bc",
            "leftCorner": {
              "x": 8.202,
              "y": 39.687,
              "z": 0.148
            },
            "rightCorner": {
              "x": 8.197,
              "y": 39.598,
              "z": 0.148
            },
            "gtin": "8017331098837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1bd",
            "leftCorner": {
              "x": 8.203,
              "y": 39.598,
              "z": 0.148
            },
            "rightCorner": {
              "x": 8.19,
              "y": 39.373,
              "z": 0.148
            },
            "gtin": "4011609011515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1be",
            "leftCorner": {
              "x": 8.192,
              "y": 39.373,
              "z": 0.148
            },
            "rightCorner": {
              "x": 8.187,
              "y": 39.297,
              "z": 0.148
            },
            "gtin": "4011609011553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1bf",
            "leftCorner": {
              "x": 8.187,
              "y": 39.297,
              "z": 0.148
            },
            "rightCorner": {
              "x": 8.183,
              "y": 39.222,
              "z": 0.148
            },
            "gtin": "4011609011553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1c0",
            "leftCorner": {
              "x": 8.191,
              "y": 39.221,
              "z": 0.148
            },
            "rightCorner": {
              "x": 8.179,
              "y": 39.009,
              "z": 0.148
            },
            "gtin": "4011609011478",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546554",
        "height": 0.46034,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1faf8",
            "leftCorner": {
              "x": 8.294,
              "y": 40.391,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.292,
              "y": 40.35,
              "z": 0.377
            },
            "gtin": "4306188360711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faf9",
            "leftCorner": {
              "x": 8.292,
              "y": 40.35,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.29,
              "y": 40.31,
              "z": 0.377
            },
            "gtin": "4306188360711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fafa",
            "leftCorner": {
              "x": 8.29,
              "y": 40.31,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.287,
              "y": 40.269,
              "z": 0.377
            },
            "gtin": "4306188360711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fafd",
            "leftCorner": {
              "x": 8.326,
              "y": 40.267,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.322,
              "y": 40.201,
              "z": 0.377
            },
            "gtin": "4306188357520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fafe",
            "leftCorner": {
              "x": 8.322,
              "y": 40.201,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.318,
              "y": 40.133,
              "z": 0.377
            },
            "gtin": "4306188357520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faff",
            "leftCorner": {
              "x": 8.318,
              "y": 40.133,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.314,
              "y": 40.065,
              "z": 0.377
            },
            "gtin": "4306188357520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb00",
            "leftCorner": {
              "x": 8.314,
              "y": 40.065,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.311,
              "y": 40.022,
              "z": 0.377
            },
            "gtin": "4306188357582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb01",
            "leftCorner": {
              "x": 8.311,
              "y": 40.022,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.309,
              "y": 39.979,
              "z": 0.377
            },
            "gtin": "4306188357582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb02",
            "leftCorner": {
              "x": 8.309,
              "y": 39.979,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.306,
              "y": 39.935,
              "z": 0.377
            },
            "gtin": "4306188357582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb03",
            "leftCorner": {
              "x": 8.306,
              "y": 39.935,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.304,
              "y": 39.892,
              "z": 0.377
            },
            "gtin": "4306188357582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb04",
            "leftCorner": {
              "x": 8.304,
              "y": 39.892,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.3,
              "y": 39.836,
              "z": 0.377
            },
            "gtin": "4306188357551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb05",
            "leftCorner": {
              "x": 8.3,
              "y": 39.836,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.297,
              "y": 39.78,
              "z": 0.377
            },
            "gtin": "4306188357551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb06",
            "leftCorner": {
              "x": 8.297,
              "y": 39.78,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.294,
              "y": 39.724,
              "z": 0.377
            },
            "gtin": "4306188357551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb07",
            "leftCorner": {
              "x": 8.292,
              "y": 39.724,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.289,
              "y": 39.668,
              "z": 0.377
            },
            "gtin": "4306188357643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb08",
            "leftCorner": {
              "x": 8.289,
              "y": 39.668,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.285,
              "y": 39.611,
              "z": 0.377
            },
            "gtin": "4306188357643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb09",
            "leftCorner": {
              "x": 8.285,
              "y": 39.611,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.282,
              "y": 39.555,
              "z": 0.377
            },
            "gtin": "4306188357643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb0a",
            "leftCorner": {
              "x": 8.282,
              "y": 39.555,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.279,
              "y": 39.497,
              "z": 0.377
            },
            "gtin": "4306188357643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb0b",
            "leftCorner": {
              "x": 8.282,
              "y": 39.497,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.278,
              "y": 39.438,
              "z": 0.377
            },
            "gtin": "4022679167880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb0c",
            "leftCorner": {
              "x": 8.278,
              "y": 39.438,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.275,
              "y": 39.378,
              "z": 0.377
            },
            "gtin": "4022679167880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb0d",
            "leftCorner": {
              "x": 8.275,
              "y": 39.378,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.271,
              "y": 39.317,
              "z": 0.377
            },
            "gtin": "4022679167880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb0e",
            "leftCorner": {
              "x": 8.271,
              "y": 39.317,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.268,
              "y": 39.258,
              "z": 0.377
            },
            "gtin": "4022679167880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fafb",
            "leftCorner": {
              "x": 8.278,
              "y": 39.257,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.275,
              "y": 39.198,
              "z": 0.377
            },
            "gtin": "4022679167927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fafc",
            "leftCorner": {
              "x": 8.275,
              "y": 39.198,
              "z": 0.377
            },
            "rightCorner": {
              "x": 8.271,
              "y": 39.14,
              "z": 0.377
            },
            "gtin": "4022679167927",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546552",
        "height": 0.90385,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fada",
            "leftCorner": {
              "x": 8.274,
              "y": 40.393,
              "z": 0.74
            },
            "rightCorner": {
              "x": 8.269,
              "y": 40.301,
              "z": 0.74
            },
            "gtin": "4250752203228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fadc",
            "leftCorner": {
              "x": 8.317,
              "y": 40.299,
              "z": 0.74
            },
            "rightCorner": {
              "x": 8.312,
              "y": 40.202,
              "z": 0.74
            },
            "gtin": "4003087422150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fadd",
            "leftCorner": {
              "x": 8.3,
              "y": 40.203,
              "z": 0.74
            },
            "rightCorner": {
              "x": 8.294,
              "y": 40.109,
              "z": 0.74
            },
            "gtin": "4008617008170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fade",
            "leftCorner": {
              "x": 8.285,
              "y": 40.109,
              "z": 0.74
            },
            "rightCorner": {
              "x": 8.28,
              "y": 40.022,
              "z": 0.74
            },
            "gtin": "4008617036333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fadf",
            "leftCorner": {
              "x": 8.297,
              "y": 40.02,
              "z": 0.74
            },
            "rightCorner": {
              "x": 8.293,
              "y": 39.955,
              "z": 0.74
            },
            "gtin": "4008617011668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fae0",
            "leftCorner": {
              "x": 8.26,
              "y": 39.958,
              "z": 0.74
            },
            "rightCorner": {
              "x": 8.255,
              "y": 39.866,
              "z": 0.74
            },
            "gtin": "4008617121626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fae1",
            "leftCorner": {
              "x": 8.281,
              "y": 39.864,
              "z": 0.74
            },
            "rightCorner": {
              "x": 8.275,
              "y": 39.76,
              "z": 0.74
            },
            "gtin": "4250752205154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fae2",
            "leftCorner": {
              "x": 8.271,
              "y": 39.76,
              "z": 0.74
            },
            "rightCorner": {
              "x": 8.266,
              "y": 39.679,
              "z": 0.74
            },
            "gtin": "4008617037125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fae3",
            "leftCorner": {
              "x": 8.273,
              "y": 39.679,
              "z": 0.74
            },
            "rightCorner": {
              "x": 8.269,
              "y": 39.605,
              "z": 0.74
            },
            "gtin": "4008491276276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fae4",
            "leftCorner": {
              "x": 8.259,
              "y": 39.605,
              "z": 0.74
            },
            "rightCorner": {
              "x": 8.252,
              "y": 39.484,
              "z": 0.74
            },
            "gtin": "4008491105187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fae5",
            "leftCorner": {
              "x": 8.269,
              "y": 39.483,
              "z": 0.74
            },
            "rightCorner": {
              "x": 8.264,
              "y": 39.402,
              "z": 0.74
            },
            "gtin": "4260555341522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fae6",
            "leftCorner": {
              "x": 8.273,
              "y": 39.402,
              "z": 0.74
            },
            "rightCorner": {
              "x": 8.267,
              "y": 39.307,
              "z": 0.74
            },
            "gtin": "4250752205505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fae7",
            "leftCorner": {
              "x": 8.269,
              "y": 39.307,
              "z": 0.74
            },
            "rightCorner": {
              "x": 8.264,
              "y": 39.222,
              "z": 0.74
            },
            "gtin": "4250752203990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fadb",
            "leftCorner": {
              "x": 8.249,
              "y": 39.223,
              "z": 0.74
            },
            "rightCorner": {
              "x": 8.245,
              "y": 39.142,
              "z": 0.74
            },
            "gtin": "4026600499002",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546551",
        "height": 1.1094,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1facb",
            "leftCorner": {
              "x": 8.263,
              "y": 40.393,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.258,
              "y": 40.313,
              "z": 0.908
            },
            "gtin": "4008491101905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1facd",
            "leftCorner": {
              "x": 8.302,
              "y": 40.31,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.299,
              "y": 40.265,
              "z": 0.908
            },
            "gtin": "4008491276290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1face",
            "leftCorner": {
              "x": 8.299,
              "y": 40.265,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.296,
              "y": 40.22,
              "z": 0.908
            },
            "gtin": "4008491276290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1facf",
            "leftCorner": {
              "x": 8.304,
              "y": 40.22,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.299,
              "y": 40.121,
              "z": 0.908
            },
            "gtin": "4008491217996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fad0",
            "leftCorner": {
              "x": 8.3,
              "y": 40.121,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.295,
              "y": 40.036,
              "z": 0.908
            },
            "gtin": "4008491129541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fad1",
            "leftCorner": {
              "x": 8.273,
              "y": 40.037,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.268,
              "y": 39.953,
              "z": 0.908
            },
            "gtin": "4008491277297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fad2",
            "leftCorner": {
              "x": 8.285,
              "y": 39.952,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.279,
              "y": 39.861,
              "z": 0.908
            },
            "gtin": "4009932132809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fad3",
            "leftCorner": {
              "x": 8.258,
              "y": 39.862,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.253,
              "y": 39.769,
              "z": 0.908
            },
            "gtin": "4009932007084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fad4",
            "leftCorner": {
              "x": 8.258,
              "y": 39.769,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.253,
              "y": 39.696,
              "z": 0.908
            },
            "gtin": "4036581537754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fad5",
            "leftCorner": {
              "x": 8.267,
              "y": 39.696,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.262,
              "y": 39.598,
              "z": 0.908
            },
            "gtin": "4008491104562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fad6",
            "leftCorner": {
              "x": 8.251,
              "y": 39.599,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.246,
              "y": 39.522,
              "z": 0.908
            },
            "gtin": "4003087410157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fad7",
            "leftCorner": {
              "x": 8.25,
              "y": 39.522,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.243,
              "y": 39.398,
              "z": 0.908
            },
            "gtin": "4009932009064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fad8",
            "leftCorner": {
              "x": 8.256,
              "y": 39.398,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.251,
              "y": 39.324,
              "z": 0.908
            },
            "gtin": "4008617032168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fad9",
            "leftCorner": {
              "x": 8.226,
              "y": 39.326,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.221,
              "y": 39.238,
              "z": 0.908
            },
            "gtin": "4250752204683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1facc",
            "leftCorner": {
              "x": 8.221,
              "y": 39.238,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.215,
              "y": 39.144,
              "z": 0.908
            },
            "gtin": "4009932005554",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546553",
        "height": 1.3101,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fae8",
            "leftCorner": {
              "x": 8.271,
              "y": 40.393,
              "z": 1.072
            },
            "rightCorner": {
              "x": 8.266,
              "y": 40.316,
              "z": 1.072
            },
            "gtin": "4009932134179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faeb",
            "leftCorner": {
              "x": 8.297,
              "y": 40.314,
              "z": 1.072
            },
            "rightCorner": {
              "x": 8.292,
              "y": 40.225,
              "z": 1.072
            },
            "gtin": "4009932137026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faec",
            "leftCorner": {
              "x": 8.295,
              "y": 40.225,
              "z": 1.072
            },
            "rightCorner": {
              "x": 8.291,
              "y": 40.165,
              "z": 1.072
            },
            "gtin": "4003087440758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faed",
            "leftCorner": {
              "x": 8.291,
              "y": 40.165,
              "z": 1.072
            },
            "rightCorner": {
              "x": 8.285,
              "y": 40.067,
              "z": 1.072
            },
            "gtin": "4009932004731",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faee",
            "leftCorner": {
              "x": 8.296,
              "y": 40.067,
              "z": 1.072
            },
            "rightCorner": {
              "x": 8.291,
              "y": 39.982,
              "z": 1.072
            },
            "gtin": "4009932001891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faef",
            "leftCorner": {
              "x": 8.274,
              "y": 39.982,
              "z": 1.072
            },
            "rightCorner": {
              "x": 8.268,
              "y": 39.883,
              "z": 1.072
            },
            "gtin": "4009932001990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faf0",
            "leftCorner": {
              "x": 8.281,
              "y": 39.883,
              "z": 1.072
            },
            "rightCorner": {
              "x": 8.276,
              "y": 39.801,
              "z": 1.072
            },
            "gtin": "4009932001945",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faf1",
            "leftCorner": {
              "x": 8.267,
              "y": 39.801,
              "z": 1.072
            },
            "rightCorner": {
              "x": 8.261,
              "y": 39.704,
              "z": 1.072
            },
            "gtin": "4009932134100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faf2",
            "leftCorner": {
              "x": 8.255,
              "y": 39.704,
              "z": 1.072
            },
            "rightCorner": {
              "x": 8.249,
              "y": 39.606,
              "z": 1.072
            },
            "gtin": "4009932131925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faf3",
            "leftCorner": {
              "x": 8.273,
              "y": 39.604,
              "z": 1.072
            },
            "rightCorner": {
              "x": 8.27,
              "y": 39.554,
              "z": 1.072
            },
            "gtin": "4008617011620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faf4",
            "leftCorner": {
              "x": 8.27,
              "y": 39.554,
              "z": 1.072
            },
            "rightCorner": {
              "x": 8.267,
              "y": 39.504,
              "z": 1.072
            },
            "gtin": "4008617011620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faf5",
            "leftCorner": {
              "x": 8.265,
              "y": 39.504,
              "z": 1.072
            },
            "rightCorner": {
              "x": 8.259,
              "y": 39.408,
              "z": 1.072
            },
            "gtin": "4009932131376",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faf6",
            "leftCorner": {
              "x": 8.252,
              "y": 39.41,
              "z": 1.072
            },
            "rightCorner": {
              "x": 8.245,
              "y": 39.295,
              "z": 1.072
            },
            "gtin": "4009932002560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faf7",
            "leftCorner": {
              "x": 8.245,
              "y": 39.295,
              "z": 1.072
            },
            "rightCorner": {
              "x": 8.242,
              "y": 39.231,
              "z": 1.072
            },
            "gtin": "4009932136616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fae9",
            "leftCorner": {
              "x": 8.246,
              "y": 39.231,
              "z": 1.072
            },
            "rightCorner": {
              "x": 8.244,
              "y": 39.186,
              "z": 1.072
            },
            "gtin": "4009932003727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1faea",
            "leftCorner": {
              "x": 8.244,
              "y": 39.186,
              "z": 1.072
            },
            "rightCorner": {
              "x": 8.241,
              "y": 39.142,
              "z": 1.072
            },
            "gtin": "4009932003727",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546556",
        "height": 1.5084,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f116",
            "leftCorner": {
              "x": 8.264,
              "y": 40.393,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.26,
              "y": 40.318,
              "z": 1.234
            },
            "gtin": "4009932004533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f118",
            "leftCorner": {
              "x": 8.302,
              "y": 40.316,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.297,
              "y": 40.22,
              "z": 1.234
            },
            "gtin": "4009932131888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f119",
            "leftCorner": {
              "x": 8.283,
              "y": 40.221,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.278,
              "y": 40.137,
              "z": 1.234
            },
            "gtin": "4009932133394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f11a",
            "leftCorner": {
              "x": 8.265,
              "y": 40.138,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.262,
              "y": 40.078,
              "z": 1.234
            },
            "gtin": "4009932133431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f11b",
            "leftCorner": {
              "x": 8.262,
              "y": 40.078,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.258,
              "y": 40.019,
              "z": 1.234
            },
            "gtin": "4009932133431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f11c",
            "leftCorner": {
              "x": 8.258,
              "y": 40.019,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.255,
              "y": 39.96,
              "z": 1.234
            },
            "gtin": "4009932133431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f11d",
            "leftCorner": {
              "x": 8.28,
              "y": 39.958,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.275,
              "y": 39.871,
              "z": 1.234
            },
            "gtin": "4008491103114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f11e",
            "leftCorner": {
              "x": 8.261,
              "y": 39.872,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.257,
              "y": 39.804,
              "z": 1.234
            },
            "gtin": "4009932135220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f11f",
            "leftCorner": {
              "x": 8.262,
              "y": 39.804,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.256,
              "y": 39.711,
              "z": 1.234
            },
            "gtin": "4009932137149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f120",
            "leftCorner": {
              "x": 8.249,
              "y": 39.711,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.243,
              "y": 39.609,
              "z": 1.234
            },
            "gtin": "4009932135565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f121",
            "leftCorner": {
              "x": 8.266,
              "y": 39.607,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.261,
              "y": 39.519,
              "z": 1.234
            },
            "gtin": "4009932134346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f122",
            "leftCorner": {
              "x": 8.255,
              "y": 39.52,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.249,
              "y": 39.42,
              "z": 1.234
            },
            "gtin": "4008617042587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f123",
            "leftCorner": {
              "x": 8.262,
              "y": 39.42,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.256,
              "y": 39.308,
              "z": 1.234
            },
            "gtin": "4009932132007",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c875ed67a01d9a1f124",
            "leftCorner": {
              "x": 8.256,
              "y": 39.308,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.251,
              "y": 39.228,
              "z": 1.234
            },
            "gtin": "4009932131802",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c875ed67a01d9a1f125",
            "leftCorner": {
              "x": 8.242,
              "y": 39.229,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.238,
              "y": 39.171,
              "z": 1.234
            },
            "gtin": "4008491102957",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546557",
        "height": 1.7049,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f14c",
            "leftCorner": {
              "x": 8.266,
              "y": 40.393,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.26,
              "y": 40.297,
              "z": 1.395
            },
            "gtin": "4009932138382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f14e",
            "leftCorner": {
              "x": 8.3,
              "y": 40.295,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.294,
              "y": 40.196,
              "z": 1.395
            },
            "gtin": "4008617040644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f14f",
            "leftCorner": {
              "x": 8.293,
              "y": 40.196,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.289,
              "y": 40.13,
              "z": 1.395
            },
            "gtin": "4306188359944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f150",
            "leftCorner": {
              "x": 8.292,
              "y": 40.13,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.289,
              "y": 40.072,
              "z": 1.395
            },
            "gtin": "4250752201057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f151",
            "leftCorner": {
              "x": 8.277,
              "y": 40.073,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.273,
              "y": 40.008,
              "z": 1.395
            },
            "gtin": "4036581420001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f152",
            "leftCorner": {
              "x": 8.283,
              "y": 40.008,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.279,
              "y": 39.944,
              "z": 1.395
            },
            "gtin": "4036581420339",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f153",
            "leftCorner": {
              "x": 8.281,
              "y": 39.944,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.278,
              "y": 39.894,
              "z": 1.395
            },
            "gtin": "4009932003901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f154",
            "leftCorner": {
              "x": 8.262,
              "y": 39.895,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.257,
              "y": 39.808,
              "z": 1.395
            },
            "gtin": "4009932131154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f155",
            "leftCorner": {
              "x": 8.27,
              "y": 39.806,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.264,
              "y": 39.699,
              "z": 1.395
            },
            "gtin": "4009932008463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f156",
            "leftCorner": {
              "x": 8.253,
              "y": 39.699,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.25,
              "y": 39.662,
              "z": 1.395
            },
            "gtin": "4009932132243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f157",
            "leftCorner": {
              "x": 8.25,
              "y": 39.662,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.248,
              "y": 39.624,
              "z": 1.395
            },
            "gtin": "4009932132243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f158",
            "leftCorner": {
              "x": 8.263,
              "y": 39.624,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.258,
              "y": 39.544,
              "z": 1.395
            },
            "gtin": "4009932008937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f159",
            "leftCorner": {
              "x": 8.247,
              "y": 39.545,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.245,
              "y": 39.498,
              "z": 1.395
            },
            "gtin": "4009932009132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f15a",
            "leftCorner": {
              "x": 8.245,
              "y": 39.498,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.242,
              "y": 39.452,
              "z": 1.395
            },
            "gtin": "4009932009132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f15b",
            "leftCorner": {
              "x": 8.25,
              "y": 39.451,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.247,
              "y": 39.409,
              "z": 1.395
            },
            "gtin": "4009932007565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f15c",
            "leftCorner": {
              "x": 8.247,
              "y": 39.409,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.245,
              "y": 39.366,
              "z": 1.395
            },
            "gtin": "4009932007565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f15d",
            "leftCorner": {
              "x": 8.251,
              "y": 39.366,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.247,
              "y": 39.291,
              "z": 1.395
            },
            "gtin": "4009932007312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f15e",
            "leftCorner": {
              "x": 8.246,
              "y": 39.291,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.24,
              "y": 39.204,
              "z": 1.395
            },
            "gtin": "4009932006766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f15f",
            "leftCorner": {
              "x": 8.24,
              "y": 39.204,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.237,
              "y": 39.163,
              "z": 1.395
            },
            "gtin": "4009932136678",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468a1",
    "rightNeighborShelfId": "468a3"
  },
  {
    "id": "468a3",
    "name": "468a3",
    "x": 8.129,
    "y": 39.148,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72741,
      "w": 0.6862
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 115
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546487",
        "height": 0.17416,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f1c1",
            "leftCorner": {
              "x": 8.179,
              "y": 39.008,
              "z": 0.142
            },
            "rightCorner": {
              "x": 8.175,
              "y": 38.936,
              "z": 0.142
            },
            "gtin": "4063367241659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1c2",
            "leftCorner": {
              "x": 8.166,
              "y": 38.937,
              "z": 0.142
            },
            "rightCorner": {
              "x": 8.157,
              "y": 38.769,
              "z": 0.142
            },
            "gtin": "4009932003307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1c3",
            "leftCorner": {
              "x": 8.16,
              "y": 38.769,
              "z": 0.142
            },
            "rightCorner": {
              "x": 8.156,
              "y": 38.713,
              "z": 0.142
            },
            "gtin": "4043027007887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1c4",
            "leftCorner": {
              "x": 8.156,
              "y": 38.713,
              "z": 0.142
            },
            "rightCorner": {
              "x": 8.153,
              "y": 38.657,
              "z": 0.142
            },
            "gtin": "4043027007887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1c5",
            "leftCorner": {
              "x": 8.152,
              "y": 38.657,
              "z": 0.142
            },
            "rightCorner": {
              "x": 8.147,
              "y": 38.569,
              "z": 0.142
            },
            "gtin": "4043027007344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1c6",
            "leftCorner": {
              "x": 8.141,
              "y": 38.57,
              "z": 0.142
            },
            "rightCorner": {
              "x": 8.135,
              "y": 38.469,
              "z": 0.142
            },
            "gtin": "4003573289021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1c7",
            "leftCorner": {
              "x": 8.135,
              "y": 38.469,
              "z": 0.142
            },
            "rightCorner": {
              "x": 8.129,
              "y": 38.368,
              "z": 0.142
            },
            "gtin": "4003573289021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1c8",
            "leftCorner": {
              "x": 8.141,
              "y": 38.367,
              "z": 0.142
            },
            "rightCorner": {
              "x": 8.135,
              "y": 38.278,
              "z": 0.142
            },
            "gtin": "4009932001259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1c9",
            "leftCorner": {
              "x": 8.135,
              "y": 38.278,
              "z": 0.142
            },
            "rightCorner": {
              "x": 8.13,
              "y": 38.188,
              "z": 0.142
            },
            "gtin": "4009932001259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f196",
            "leftCorner": {
              "x": 8.118,
              "y": 38.188,
              "z": 0.142
            },
            "rightCorner": {
              "x": 8.109,
              "y": 38.043,
              "z": 0.142
            },
            "gtin": "4009932001037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f197",
            "leftCorner": {
              "x": 8.109,
              "y": 38.043,
              "z": 0.142
            },
            "rightCorner": {
              "x": 8.101,
              "y": 37.897,
              "z": 0.142
            },
            "gtin": "4009932001037",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546482",
        "height": 0.50921,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f0f8",
            "leftCorner": {
              "x": 8.222,
              "y": 39.143,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.216,
              "y": 39.052,
              "z": 0.417
            },
            "gtin": "4009932137187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0fa",
            "leftCorner": {
              "x": 8.253,
              "y": 39.051,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.247,
              "y": 38.943,
              "z": 0.417
            },
            "gtin": "4009932131208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0fb",
            "leftCorner": {
              "x": 8.266,
              "y": 38.943,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.263,
              "y": 38.882,
              "z": 0.417
            },
            "gtin": "4009932132069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0fc",
            "leftCorner": {
              "x": 8.243,
              "y": 38.883,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.237,
              "y": 38.783,
              "z": 0.417
            },
            "gtin": "4009932137606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0fd",
            "leftCorner": {
              "x": 8.245,
              "y": 38.783,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.239,
              "y": 38.68,
              "z": 0.417
            },
            "gtin": "4009932132786",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0fe",
            "leftCorner": {
              "x": 8.242,
              "y": 38.68,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.237,
              "y": 38.586,
              "z": 0.417
            },
            "gtin": "4009932003215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0ff",
            "leftCorner": {
              "x": 8.237,
              "y": 38.586,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.231,
              "y": 38.492,
              "z": 0.417
            },
            "gtin": "4009932003215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f100",
            "leftCorner": {
              "x": 8.218,
              "y": 38.492,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.209,
              "y": 38.354,
              "z": 0.417
            },
            "gtin": "4260555341553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f101",
            "leftCorner": {
              "x": 8.208,
              "y": 38.354,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.201,
              "y": 38.235,
              "z": 0.417
            },
            "gtin": "4043107022243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f102",
            "leftCorner": {
              "x": 8.206,
              "y": 38.235,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.203,
              "y": 38.176,
              "z": 0.417
            },
            "gtin": "4008233046631",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f103",
            "leftCorner": {
              "x": 8.203,
              "y": 38.176,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.199,
              "y": 38.102,
              "z": 0.417
            },
            "gtin": "4250752202634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f104",
            "leftCorner": {
              "x": 8.206,
              "y": 38.102,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.2,
              "y": 38.003,
              "z": 0.417
            },
            "gtin": "4306188030751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f105",
            "leftCorner": {
              "x": 8.187,
              "y": 38.004,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.183,
              "y": 37.944,
              "z": 0.417
            },
            "gtin": "4008233103495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0f9",
            "leftCorner": {
              "x": 8.186,
              "y": 37.944,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.183,
              "y": 37.893,
              "z": 0.417
            },
            "gtin": "4008617138822",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546481",
        "height": 0.75601,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f0e7",
            "leftCorner": {
              "x": 8.222,
              "y": 39.143,
              "z": 0.619
            },
            "rightCorner": {
              "x": 8.218,
              "y": 39.064,
              "z": 0.619
            },
            "gtin": "4011932229335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0ea",
            "leftCorner": {
              "x": 8.261,
              "y": 39.062,
              "z": 0.619
            },
            "rightCorner": {
              "x": 8.256,
              "y": 38.976,
              "z": 0.619
            },
            "gtin": "4011932228284",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0eb",
            "leftCorner": {
              "x": 8.253,
              "y": 38.976,
              "z": 0.619
            },
            "rightCorner": {
              "x": 8.248,
              "y": 38.88,
              "z": 0.619
            },
            "gtin": "4011932236012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0ec",
            "leftCorner": {
              "x": 8.246,
              "y": 38.88,
              "z": 0.619
            },
            "rightCorner": {
              "x": 8.242,
              "y": 38.811,
              "z": 0.619
            },
            "gtin": "4306188360582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0ed",
            "leftCorner": {
              "x": 8.242,
              "y": 38.811,
              "z": 0.619
            },
            "rightCorner": {
              "x": 8.238,
              "y": 38.742,
              "z": 0.619
            },
            "gtin": "4306188360582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0ee",
            "leftCorner": {
              "x": 8.241,
              "y": 38.741,
              "z": 0.619
            },
            "rightCorner": {
              "x": 8.231,
              "y": 38.57,
              "z": 0.619
            },
            "gtin": "4008617148951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0ef",
            "leftCorner": {
              "x": 8.23,
              "y": 38.57,
              "z": 0.619
            },
            "rightCorner": {
              "x": 8.224,
              "y": 38.465,
              "z": 0.619
            },
            "gtin": "4008617152606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0f0",
            "leftCorner": {
              "x": 8.222,
              "y": 38.465,
              "z": 0.619
            },
            "rightCorner": {
              "x": 8.216,
              "y": 38.362,
              "z": 0.619
            },
            "gtin": "4008491119771",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0f1",
            "leftCorner": {
              "x": 8.22,
              "y": 38.362,
              "z": 0.619
            },
            "rightCorner": {
              "x": 8.217,
              "y": 38.319,
              "z": 0.619
            },
            "gtin": "4008617121336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0f2",
            "leftCorner": {
              "x": 8.217,
              "y": 38.319,
              "z": 0.619
            },
            "rightCorner": {
              "x": 8.215,
              "y": 38.276,
              "z": 0.619
            },
            "gtin": "4008617121336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0f3",
            "leftCorner": {
              "x": 8.201,
              "y": 38.278,
              "z": 0.619
            },
            "rightCorner": {
              "x": 8.199,
              "y": 38.236,
              "z": 0.619
            },
            "gtin": "4008617121527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0f4",
            "leftCorner": {
              "x": 8.199,
              "y": 38.236,
              "z": 0.619
            },
            "rightCorner": {
              "x": 8.196,
              "y": 38.192,
              "z": 0.619
            },
            "gtin": "4008617121527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0f5",
            "leftCorner": {
              "x": 8.206,
              "y": 38.191,
              "z": 0.619
            },
            "rightCorner": {
              "x": 8.202,
              "y": 38.135,
              "z": 0.619
            },
            "gtin": "4083700302717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0f6",
            "leftCorner": {
              "x": 8.202,
              "y": 38.135,
              "z": 0.619
            },
            "rightCorner": {
              "x": 8.199,
              "y": 38.079,
              "z": 0.619
            },
            "gtin": "4083700302717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0f7",
            "leftCorner": {
              "x": 8.192,
              "y": 38.079,
              "z": 0.619
            },
            "rightCorner": {
              "x": 8.186,
              "y": 37.977,
              "z": 0.619
            },
            "gtin": "4008491445887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0e8",
            "leftCorner": {
              "x": 8.17,
              "y": 37.979,
              "z": 0.619
            },
            "rightCorner": {
              "x": 8.168,
              "y": 37.937,
              "z": 0.619
            },
            "gtin": "4250752202986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f0e9",
            "leftCorner": {
              "x": 8.168,
              "y": 37.937,
              "z": 0.619
            },
            "rightCorner": {
              "x": 8.165,
              "y": 37.894,
              "z": 0.619
            },
            "gtin": "4250752202986",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546483",
        "height": 1.0059,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f106",
            "leftCorner": {
              "x": 8.216,
              "y": 39.143,
              "z": 0.823
            },
            "rightCorner": {
              "x": 8.213,
              "y": 39.084,
              "z": 0.823
            },
            "gtin": "4008491224567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f108",
            "leftCorner": {
              "x": 8.25,
              "y": 39.082,
              "z": 0.823
            },
            "rightCorner": {
              "x": 8.246,
              "y": 39.015,
              "z": 0.823
            },
            "gtin": "4008491112901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f109",
            "leftCorner": {
              "x": 8.249,
              "y": 39.015,
              "z": 0.823
            },
            "rightCorner": {
              "x": 8.244,
              "y": 38.94,
              "z": 0.823
            },
            "gtin": "4008491116138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f10a",
            "leftCorner": {
              "x": 8.244,
              "y": 38.94,
              "z": 0.823
            },
            "rightCorner": {
              "x": 8.24,
              "y": 38.866,
              "z": 0.823
            },
            "gtin": "4008491116138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f10b",
            "leftCorner": {
              "x": 8.24,
              "y": 38.866,
              "z": 0.823
            },
            "rightCorner": {
              "x": 8.236,
              "y": 38.797,
              "z": 0.823
            },
            "gtin": "4002448089735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f10c",
            "leftCorner": {
              "x": 8.236,
              "y": 38.797,
              "z": 0.823
            },
            "rightCorner": {
              "x": 8.232,
              "y": 38.729,
              "z": 0.823
            },
            "gtin": "4002448089735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f10d",
            "leftCorner": {
              "x": 8.235,
              "y": 38.729,
              "z": 0.823
            },
            "rightCorner": {
              "x": 8.23,
              "y": 38.643,
              "z": 0.823
            },
            "gtin": "4002448089797",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f10e",
            "leftCorner": {
              "x": 8.234,
              "y": 38.643,
              "z": 0.823
            },
            "rightCorner": {
              "x": 8.227,
              "y": 38.531,
              "z": 0.823
            },
            "gtin": "4306188360926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f10f",
            "leftCorner": {
              "x": 8.213,
              "y": 38.533,
              "z": 0.823
            },
            "rightCorner": {
              "x": 8.205,
              "y": 38.399,
              "z": 0.823
            },
            "gtin": "4008617148012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f110",
            "leftCorner": {
              "x": 8.219,
              "y": 38.398,
              "z": 0.823
            },
            "rightCorner": {
              "x": 8.215,
              "y": 38.33,
              "z": 0.823
            },
            "gtin": "4008617148005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f111",
            "leftCorner": {
              "x": 8.207,
              "y": 38.33,
              "z": 0.823
            },
            "rightCorner": {
              "x": 8.2,
              "y": 38.214,
              "z": 0.823
            },
            "gtin": "4008491216388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f112",
            "leftCorner": {
              "x": 8.207,
              "y": 38.213,
              "z": 0.823
            },
            "rightCorner": {
              "x": 8.202,
              "y": 38.131,
              "z": 0.823
            },
            "gtin": "4008491261708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f113",
            "leftCorner": {
              "x": 8.2,
              "y": 38.131,
              "z": 0.823
            },
            "rightCorner": {
              "x": 8.196,
              "y": 38.054,
              "z": 0.823
            },
            "gtin": "4008491312622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f114",
            "leftCorner": {
              "x": 8.176,
              "y": 38.055,
              "z": 0.823
            },
            "rightCorner": {
              "x": 8.171,
              "y": 37.965,
              "z": 0.823
            },
            "gtin": "4008491444200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f115",
            "leftCorner": {
              "x": 8.184,
              "y": 37.964,
              "z": 0.823
            },
            "rightCorner": {
              "x": 8.182,
              "y": 37.931,
              "z": 0.823
            },
            "gtin": "4250752203723",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c875ed67a01d9a1f107",
            "leftCorner": {
              "x": 8.174,
              "y": 37.931,
              "z": 0.823
            },
            "rightCorner": {
              "x": 8.172,
              "y": 37.894,
              "z": 0.823
            },
            "gtin": "4250752201644",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546486",
        "height": 1.2576,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f182",
            "leftCorner": {
              "x": 8.215,
              "y": 39.143,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.212,
              "y": 39.082,
              "z": 1.029
            },
            "gtin": "4043107022168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f183",
            "leftCorner": {
              "x": 8.212,
              "y": 39.082,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.208,
              "y": 39.021,
              "z": 1.029
            },
            "gtin": "4043107022168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f184",
            "leftCorner": {
              "x": 8.208,
              "y": 39.021,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.205,
              "y": 38.96,
              "z": 1.029
            },
            "gtin": "4043107022168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f187",
            "leftCorner": {
              "x": 8.249,
              "y": 38.958,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.243,
              "y": 38.871,
              "z": 1.029
            },
            "gtin": "4008491130141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f188",
            "leftCorner": {
              "x": 8.237,
              "y": 38.871,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.234,
              "y": 38.821,
              "z": 1.029
            },
            "gtin": "4043027007436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f189",
            "leftCorner": {
              "x": 8.217,
              "y": 38.823,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.214,
              "y": 38.765,
              "z": 1.029
            },
            "gtin": "4250752202962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f18a",
            "leftCorner": {
              "x": 8.223,
              "y": 38.764,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.218,
              "y": 38.689,
              "z": 1.029
            },
            "gtin": "4250752202696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f18b",
            "leftCorner": {
              "x": 8.235,
              "y": 38.687,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.231,
              "y": 38.618,
              "z": 1.029
            },
            "gtin": "4250752206014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f18c",
            "leftCorner": {
              "x": 8.219,
              "y": 38.618,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.216,
              "y": 38.554,
              "z": 1.029
            },
            "gtin": "4008491223362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f18d",
            "leftCorner": {
              "x": 8.217,
              "y": 38.554,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.212,
              "y": 38.466,
              "z": 1.029
            },
            "gtin": "4008491111928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f18e",
            "leftCorner": {
              "x": 8.213,
              "y": 38.466,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.21,
              "y": 38.411,
              "z": 1.029
            },
            "gtin": "4008617134480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f18f",
            "leftCorner": {
              "x": 8.208,
              "y": 38.411,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.201,
              "y": 38.289,
              "z": 1.029
            },
            "gtin": "4008491221870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f190",
            "leftCorner": {
              "x": 8.21,
              "y": 38.287,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.206,
              "y": 38.225,
              "z": 1.029
            },
            "gtin": "4008617136675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f191",
            "leftCorner": {
              "x": 8.206,
              "y": 38.225,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.203,
              "y": 38.162,
              "z": 1.029
            },
            "gtin": "4008617136675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f192",
            "leftCorner": {
              "x": 8.198,
              "y": 38.163,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.195,
              "y": 38.119,
              "z": 1.029
            },
            "gtin": "4008617134404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f193",
            "leftCorner": {
              "x": 8.195,
              "y": 38.119,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.193,
              "y": 38.075,
              "z": 1.029
            },
            "gtin": "4008617134404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f194",
            "leftCorner": {
              "x": 8.194,
              "y": 38.075,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.188,
              "y": 37.981,
              "z": 1.029
            },
            "gtin": "4008617134909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f185",
            "leftCorner": {
              "x": 8.187,
              "y": 37.981,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.184,
              "y": 37.937,
              "z": 1.029
            },
            "gtin": "4008617134220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f186",
            "leftCorner": {
              "x": 8.184,
              "y": 37.937,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.182,
              "y": 37.893,
              "z": 1.029
            },
            "gtin": "4008617134220",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546484",
        "height": 1.5077,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f126",
            "leftCorner": {
              "x": 8.241,
              "y": 39.171,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.238,
              "y": 39.111,
              "z": 1.234
            },
            "gtin": "4250752205628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f127",
            "leftCorner": {
              "x": 8.238,
              "y": 39.111,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.234,
              "y": 39.05,
              "z": 1.234
            },
            "gtin": "4250752205628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f128",
            "leftCorner": {
              "x": 8.242,
              "y": 39.05,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.236,
              "y": 38.96,
              "z": 1.234
            },
            "gtin": "4260768630369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f129",
            "leftCorner": {
              "x": 8.236,
              "y": 38.96,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.231,
              "y": 38.869,
              "z": 1.234
            },
            "gtin": "4260768630369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f12a",
            "leftCorner": {
              "x": 8.223,
              "y": 38.869,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.22,
              "y": 38.821,
              "z": 1.234
            },
            "gtin": "4306188029700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f12b",
            "leftCorner": {
              "x": 8.22,
              "y": 38.821,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.217,
              "y": 38.772,
              "z": 1.234
            },
            "gtin": "4306188029700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f12c",
            "leftCorner": {
              "x": 8.227,
              "y": 38.771,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.221,
              "y": 38.66,
              "z": 1.234
            },
            "gtin": "4306188361381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f12d",
            "leftCorner": {
              "x": 8.224,
              "y": 38.66,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.22,
              "y": 38.583,
              "z": 1.234
            },
            "gtin": "4306188000853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f12e",
            "leftCorner": {
              "x": 8.22,
              "y": 38.583,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.216,
              "y": 38.508,
              "z": 1.234
            },
            "gtin": "4043107022106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f12f",
            "leftCorner": {
              "x": 8.217,
              "y": 38.508,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.214,
              "y": 38.454,
              "z": 1.234
            },
            "gtin": "4043107022113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f130",
            "leftCorner": {
              "x": 8.186,
              "y": 38.455,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.184,
              "y": 38.426,
              "z": 1.234
            },
            "gtin": "4306188432784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f131",
            "leftCorner": {
              "x": 8.184,
              "y": 38.426,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.182,
              "y": 38.396,
              "z": 1.234
            },
            "gtin": "4306188432784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f132",
            "leftCorner": {
              "x": 8.188,
              "y": 38.396,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.185,
              "y": 38.337,
              "z": 1.234
            },
            "gtin": "4306188359302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f133",
            "leftCorner": {
              "x": 8.185,
              "y": 38.337,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.181,
              "y": 38.278,
              "z": 1.234
            },
            "gtin": "4306188359302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f134",
            "leftCorner": {
              "x": 8.181,
              "y": 38.278,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.178,
              "y": 38.219,
              "z": 1.234
            },
            "gtin": "4306188359302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f135",
            "leftCorner": {
              "x": 8.193,
              "y": 38.218,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.189,
              "y": 38.143,
              "z": 1.234
            },
            "gtin": "4306188009627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f136",
            "leftCorner": {
              "x": 8.189,
              "y": 38.143,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.184,
              "y": 38.069,
              "z": 1.234
            },
            "gtin": "4306188009627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f137",
            "leftCorner": {
              "x": 8.177,
              "y": 38.07,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.175,
              "y": 38.026,
              "z": 1.234
            },
            "gtin": "4306188432753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f138",
            "leftCorner": {
              "x": 8.175,
              "y": 38.026,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.172,
              "y": 37.983,
              "z": 1.234
            },
            "gtin": "4306188432753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f139",
            "leftCorner": {
              "x": 8.182,
              "y": 37.983,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.179,
              "y": 37.936,
              "z": 1.234
            },
            "gtin": "4260768630376",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f13a",
            "leftCorner": {
              "x": 8.179,
              "y": 37.936,
              "z": 1.234
            },
            "rightCorner": {
              "x": 8.177,
              "y": 37.889,
              "z": 1.234
            },
            "gtin": "4260768630376",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546485",
        "height": 1.7065,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f160",
            "leftCorner": {
              "x": 8.246,
              "y": 39.162,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.243,
              "y": 39.104,
              "z": 1.396
            },
            "gtin": "4022679167989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f161",
            "leftCorner": {
              "x": 8.243,
              "y": 39.104,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.239,
              "y": 39.047,
              "z": 1.396
            },
            "gtin": "4022679167989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f162",
            "leftCorner": {
              "x": 8.241,
              "y": 39.047,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.238,
              "y": 39.006,
              "z": 1.396
            },
            "gtin": "4022679167965",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f163",
            "leftCorner": {
              "x": 8.238,
              "y": 39.006,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.236,
              "y": 38.966,
              "z": 1.396
            },
            "gtin": "4022679167965",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f164",
            "leftCorner": {
              "x": 8.23,
              "y": 38.966,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.227,
              "y": 38.912,
              "z": 1.396
            },
            "gtin": "4022679167903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f165",
            "leftCorner": {
              "x": 8.227,
              "y": 38.912,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.224,
              "y": 38.859,
              "z": 1.396
            },
            "gtin": "4022679167903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f166",
            "leftCorner": {
              "x": 8.224,
              "y": 38.859,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.221,
              "y": 38.805,
              "z": 1.396
            },
            "gtin": "4022679167903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f167",
            "leftCorner": {
              "x": 8.223,
              "y": 38.805,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.218,
              "y": 38.714,
              "z": 1.396
            },
            "gtin": "4008617001096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f168",
            "leftCorner": {
              "x": 8.225,
              "y": 38.714,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.221,
              "y": 38.652,
              "z": 1.396
            },
            "gtin": "4008617001072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f169",
            "leftCorner": {
              "x": 8.221,
              "y": 38.652,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.218,
              "y": 38.589,
              "z": 1.396
            },
            "gtin": "4008617001072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f16a",
            "leftCorner": {
              "x": 8.216,
              "y": 38.589,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.212,
              "y": 38.527,
              "z": 1.396
            },
            "gtin": "4008617001058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f16b",
            "leftCorner": {
              "x": 8.208,
              "y": 38.527,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.203,
              "y": 38.431,
              "z": 1.396
            },
            "gtin": "4008617136651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f16c",
            "leftCorner": {
              "x": 8.202,
              "y": 38.431,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.195,
              "y": 38.316,
              "z": 1.396
            },
            "gtin": "4008617136552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f16d",
            "leftCorner": {
              "x": 8.195,
              "y": 38.316,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.189,
              "y": 38.223,
              "z": 1.396
            },
            "gtin": "4306188039341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f16e",
            "leftCorner": {
              "x": 8.189,
              "y": 38.223,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.184,
              "y": 38.131,
              "z": 1.396
            },
            "gtin": "4306188039341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f16f",
            "leftCorner": {
              "x": 8.187,
              "y": 38.131,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.183,
              "y": 38.076,
              "z": 1.396
            },
            "gtin": "4306188359395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f170",
            "leftCorner": {
              "x": 8.183,
              "y": 38.076,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.18,
              "y": 38.019,
              "z": 1.396
            },
            "gtin": "4306188359395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f171",
            "leftCorner": {
              "x": 8.167,
              "y": 38.02,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.158,
              "y": 37.853,
              "z": 1.396
            },
            "gtin": "4022679167781",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468a2",
    "rightNeighborShelfId": "468a4"
  },
  {
    "id": "468a4",
    "name": "468a4",
    "x": 8.056,
    "y": 37.9,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72741,
      "w": 0.6862
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 120
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546560",
        "height": 0.19297,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fb6d",
            "leftCorner": {
              "x": 8.064,
              "y": 37.899,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.059,
              "y": 37.813,
              "z": 0.158
            },
            "gtin": "4306188028154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb6f",
            "leftCorner": {
              "x": 8.1,
              "y": 37.81,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.095,
              "y": 37.723,
              "z": 0.158
            },
            "gtin": "4008617005292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb70",
            "leftCorner": {
              "x": 8.114,
              "y": 37.722,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.106,
              "y": 37.585,
              "z": 0.158
            },
            "gtin": "4036581536429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb71",
            "leftCorner": {
              "x": 8.106,
              "y": 37.585,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.098,
              "y": 37.449,
              "z": 0.158
            },
            "gtin": "4036581536429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb72",
            "leftCorner": {
              "x": 8.078,
              "y": 37.451,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.074,
              "y": 37.371,
              "z": 0.158
            },
            "gtin": "4260175672358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb73",
            "leftCorner": {
              "x": 8.074,
              "y": 37.371,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.069,
              "y": 37.293,
              "z": 0.158
            },
            "gtin": "4260175672358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb74",
            "leftCorner": {
              "x": 8.069,
              "y": 37.293,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.063,
              "y": 37.184,
              "z": 0.158
            },
            "gtin": "4250752203204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb75",
            "leftCorner": {
              "x": 8.063,
              "y": 37.184,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.056,
              "y": 37.074,
              "z": 0.158
            },
            "gtin": "4250752203204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb76",
            "leftCorner": {
              "x": 8.058,
              "y": 37.074,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.051,
              "y": 36.939,
              "z": 0.158
            },
            "gtin": "4260175672365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb77",
            "leftCorner": {
              "x": 8.045,
              "y": 36.939,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.041,
              "y": 36.876,
              "z": 0.158
            },
            "gtin": "4260644048103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb78",
            "leftCorner": {
              "x": 8.036,
              "y": 36.876,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.031,
              "y": 36.781,
              "z": 0.158
            },
            "gtin": "4260644048097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb6e",
            "leftCorner": {
              "x": 8.045,
              "y": 36.78,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.037,
              "y": 36.648,
              "z": 0.158
            },
            "gtin": "4260644048141",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546559",
        "height": 0.46439,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fb21",
            "leftCorner": {
              "x": 8.168,
              "y": 37.893,
              "z": 0.38
            },
            "rightCorner": {
              "x": 8.163,
              "y": 37.811,
              "z": 0.38
            },
            "gtin": "4008617009962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb23",
            "leftCorner": {
              "x": 8.198,
              "y": 37.809,
              "z": 0.38
            },
            "rightCorner": {
              "x": 8.194,
              "y": 37.737,
              "z": 0.38
            },
            "gtin": "4306188030720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb24",
            "leftCorner": {
              "x": 8.187,
              "y": 37.737,
              "z": 0.38
            },
            "rightCorner": {
              "x": 8.183,
              "y": 37.657,
              "z": 0.38
            },
            "gtin": "4043107022229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb25",
            "leftCorner": {
              "x": 8.183,
              "y": 37.657,
              "z": 0.38
            },
            "rightCorner": {
              "x": 8.178,
              "y": 37.577,
              "z": 0.38
            },
            "gtin": "4043107022229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb26",
            "leftCorner": {
              "x": 8.186,
              "y": 37.577,
              "z": 0.38
            },
            "rightCorner": {
              "x": 8.183,
              "y": 37.523,
              "z": 0.38
            },
            "gtin": "4009241392000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb27",
            "leftCorner": {
              "x": 8.183,
              "y": 37.523,
              "z": 0.38
            },
            "rightCorner": {
              "x": 8.18,
              "y": 37.468,
              "z": 0.38
            },
            "gtin": "4009241392000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb28",
            "leftCorner": {
              "x": 8.18,
              "y": 37.468,
              "z": 0.38
            },
            "rightCorner": {
              "x": 8.177,
              "y": 37.414,
              "z": 0.38
            },
            "gtin": "4009241392000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb29",
            "leftCorner": {
              "x": 8.172,
              "y": 37.415,
              "z": 0.38
            },
            "rightCorner": {
              "x": 8.169,
              "y": 37.37,
              "z": 0.38
            },
            "gtin": "4008491223751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb2a",
            "leftCorner": {
              "x": 8.182,
              "y": 37.369,
              "z": 0.38
            },
            "rightCorner": {
              "x": 8.177,
              "y": 37.282,
              "z": 0.38
            },
            "gtin": "4033082021454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb2b",
            "leftCorner": {
              "x": 8.169,
              "y": 37.282,
              "z": 0.38
            },
            "rightCorner": {
              "x": 8.165,
              "y": 37.208,
              "z": 0.38
            },
            "gtin": "4033082021225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb2c",
            "leftCorner": {
              "x": 8.165,
              "y": 37.208,
              "z": 0.38
            },
            "rightCorner": {
              "x": 8.16,
              "y": 37.135,
              "z": 0.38
            },
            "gtin": "4033082021225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb2d",
            "leftCorner": {
              "x": 8.16,
              "y": 37.135,
              "z": 0.38
            },
            "rightCorner": {
              "x": 8.156,
              "y": 37.061,
              "z": 0.38
            },
            "gtin": "4033082021225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb2e",
            "leftCorner": {
              "x": 8.169,
              "y": 37.06,
              "z": 0.38
            },
            "rightCorner": {
              "x": 8.163,
              "y": 36.965,
              "z": 0.38
            },
            "gtin": "4022679167767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb2f",
            "leftCorner": {
              "x": 8.17,
              "y": 36.965,
              "z": 0.38
            },
            "rightCorner": {
              "x": 8.163,
              "y": 36.835,
              "z": 0.38
            },
            "gtin": "4003087445807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb30",
            "leftCorner": {
              "x": 8.163,
              "y": 36.835,
              "z": 0.38
            },
            "rightCorner": {
              "x": 8.156,
              "y": 36.717,
              "z": 0.38
            },
            "gtin": "4003087400158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb22",
            "leftCorner": {
              "x": 8.145,
              "y": 36.718,
              "z": 0.38
            },
            "rightCorner": {
              "x": 8.141,
              "y": 36.642,
              "z": 0.38
            },
            "gtin": "4008377000728",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54655a",
        "height": 0.70703,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fb31",
            "leftCorner": {
              "x": 8.164,
              "y": 37.893,
              "z": 0.578
            },
            "rightCorner": {
              "x": 8.16,
              "y": 37.813,
              "z": 0.578
            },
            "gtin": "4306188028437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb34",
            "leftCorner": {
              "x": 8.197,
              "y": 37.811,
              "z": 0.578
            },
            "rightCorner": {
              "x": 8.191,
              "y": 37.717,
              "z": 0.578
            },
            "gtin": "4009932137217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb35",
            "leftCorner": {
              "x": 8.184,
              "y": 37.718,
              "z": 0.578
            },
            "rightCorner": {
              "x": 8.178,
              "y": 37.62,
              "z": 0.578
            },
            "gtin": "4009932133462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb36",
            "leftCorner": {
              "x": 8.186,
              "y": 37.619,
              "z": 0.578
            },
            "rightCorner": {
              "x": 8.18,
              "y": 37.518,
              "z": 0.578
            },
            "gtin": "4009932133530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb37",
            "leftCorner": {
              "x": 8.176,
              "y": 37.518,
              "z": 0.578
            },
            "rightCorner": {
              "x": 8.171,
              "y": 37.436,
              "z": 0.578
            },
            "gtin": "4009932131703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb38",
            "leftCorner": {
              "x": 8.171,
              "y": 37.436,
              "z": 0.578
            },
            "rightCorner": {
              "x": 8.166,
              "y": 37.355,
              "z": 0.578
            },
            "gtin": "4009932131703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb39",
            "leftCorner": {
              "x": 8.173,
              "y": 37.354,
              "z": 0.578
            },
            "rightCorner": {
              "x": 8.166,
              "y": 37.227,
              "z": 0.578
            },
            "gtin": "4026600429214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb3a",
            "leftCorner": {
              "x": 8.182,
              "y": 37.227,
              "z": 0.578
            },
            "rightCorner": {
              "x": 8.175,
              "y": 37.12,
              "z": 0.578
            },
            "gtin": "4008491104142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb3b",
            "leftCorner": {
              "x": 8.163,
              "y": 37.121,
              "z": 0.578
            },
            "rightCorner": {
              "x": 8.16,
              "y": 37.057,
              "z": 0.578
            },
            "gtin": "4064761001078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb3c",
            "leftCorner": {
              "x": 8.16,
              "y": 37.057,
              "z": 0.578
            },
            "rightCorner": {
              "x": 8.156,
              "y": 36.994,
              "z": 0.578
            },
            "gtin": "4064761001078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb3d",
            "leftCorner": {
              "x": 8.156,
              "y": 36.994,
              "z": 0.578
            },
            "rightCorner": {
              "x": 8.151,
              "y": 36.898,
              "z": 0.578
            },
            "gtin": "4033082021201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb3e",
            "leftCorner": {
              "x": 8.151,
              "y": 36.898,
              "z": 0.578
            },
            "rightCorner": {
              "x": 8.145,
              "y": 36.804,
              "z": 0.578
            },
            "gtin": "4033082021201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb32",
            "leftCorner": {
              "x": 8.148,
              "y": 36.803,
              "z": 0.578
            },
            "rightCorner": {
              "x": 8.143,
              "y": 36.723,
              "z": 0.578
            },
            "gtin": "4026241812291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb33",
            "leftCorner": {
              "x": 8.143,
              "y": 36.723,
              "z": 0.578
            },
            "rightCorner": {
              "x": 8.139,
              "y": 36.642,
              "z": 0.578
            },
            "gtin": "4026241812291",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54655b",
        "height": 0.90927,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fb3f",
            "leftCorner": {
              "x": 8.152,
              "y": 37.894,
              "z": 0.744
            },
            "rightCorner": {
              "x": 8.147,
              "y": 37.804,
              "z": 0.744
            },
            "gtin": "4009932131161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb41",
            "leftCorner": {
              "x": 8.176,
              "y": 37.802,
              "z": 0.744
            },
            "rightCorner": {
              "x": 8.171,
              "y": 37.721,
              "z": 0.744
            },
            "gtin": "4009932133769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb42",
            "leftCorner": {
              "x": 8.18,
              "y": 37.72,
              "z": 0.744
            },
            "rightCorner": {
              "x": 8.174,
              "y": 37.623,
              "z": 0.744
            },
            "gtin": "4009932136272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb43",
            "leftCorner": {
              "x": 8.166,
              "y": 37.624,
              "z": 0.744
            },
            "rightCorner": {
              "x": 8.161,
              "y": 37.537,
              "z": 0.744
            },
            "gtin": "4250752201873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb44",
            "leftCorner": {
              "x": 8.157,
              "y": 37.537,
              "z": 0.744
            },
            "rightCorner": {
              "x": 8.154,
              "y": 37.488,
              "z": 0.744
            },
            "gtin": "4250752205444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb45",
            "leftCorner": {
              "x": 8.154,
              "y": 37.488,
              "z": 0.744
            },
            "rightCorner": {
              "x": 8.151,
              "y": 37.44,
              "z": 0.744
            },
            "gtin": "4250752205444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb46",
            "leftCorner": {
              "x": 8.156,
              "y": 37.44,
              "z": 0.744
            },
            "rightCorner": {
              "x": 8.152,
              "y": 37.379,
              "z": 0.744
            },
            "gtin": "4009241527006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb47",
            "leftCorner": {
              "x": 8.161,
              "y": 37.379,
              "z": 0.744
            },
            "rightCorner": {
              "x": 8.156,
              "y": 37.288,
              "z": 0.744
            },
            "gtin": "4003087440659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb48",
            "leftCorner": {
              "x": 8.156,
              "y": 37.288,
              "z": 0.744
            },
            "rightCorner": {
              "x": 8.151,
              "y": 37.203,
              "z": 0.744
            },
            "gtin": "4008491109406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb49",
            "leftCorner": {
              "x": 8.154,
              "y": 37.203,
              "z": 0.744
            },
            "rightCorner": {
              "x": 8.148,
              "y": 37.103,
              "z": 0.744
            },
            "gtin": "4008491108645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb4a",
            "leftCorner": {
              "x": 8.161,
              "y": 37.102,
              "z": 0.744
            },
            "rightCorner": {
              "x": 8.157,
              "y": 37.041,
              "z": 0.744
            },
            "gtin": "4008491108997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb4b",
            "leftCorner": {
              "x": 8.137,
              "y": 37.042,
              "z": 0.744
            },
            "rightCorner": {
              "x": 8.132,
              "y": 36.95,
              "z": 0.744
            },
            "gtin": "4003573800219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb4c",
            "leftCorner": {
              "x": 8.149,
              "y": 36.95,
              "z": 0.744
            },
            "rightCorner": {
              "x": 8.144,
              "y": 36.864,
              "z": 0.744
            },
            "gtin": "4250752204560",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c885ed67a01d9a1fb4d",
            "leftCorner": {
              "x": 8.145,
              "y": 36.864,
              "z": 0.744
            },
            "rightCorner": {
              "x": 8.139,
              "y": 36.762,
              "z": 0.744
            },
            "gtin": "4008491276283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb40",
            "leftCorner": {
              "x": 8.124,
              "y": 36.763,
              "z": 0.744
            },
            "rightCorner": {
              "x": 8.117,
              "y": 36.644,
              "z": 0.744
            },
            "gtin": "4009737202226",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54655c",
        "height": 1.1101,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fb4e",
            "leftCorner": {
              "x": 8.159,
              "y": 37.894,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.153,
              "y": 37.8,
              "z": 0.908
            },
            "gtin": "4008491132916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb50",
            "leftCorner": {
              "x": 8.168,
              "y": 37.799,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.164,
              "y": 37.736,
              "z": 0.908
            },
            "gtin": "4003087431657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb51",
            "leftCorner": {
              "x": 8.175,
              "y": 37.735,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.17,
              "y": 37.652,
              "z": 0.908
            },
            "gtin": "4250752204744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb52",
            "leftCorner": {
              "x": 8.173,
              "y": 37.653,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.166,
              "y": 37.533,
              "z": 0.908
            },
            "gtin": "4009932001327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb53",
            "leftCorner": {
              "x": 8.173,
              "y": 37.533,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.168,
              "y": 37.453,
              "z": 0.908
            },
            "gtin": "4008617013976",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c885ed67a01d9a1fb54",
            "leftCorner": {
              "x": 8.17,
              "y": 37.452,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.166,
              "y": 37.397,
              "z": 0.908
            },
            "gtin": "4306188357865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb55",
            "leftCorner": {
              "x": 8.166,
              "y": 37.397,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.163,
              "y": 37.342,
              "z": 0.908
            },
            "gtin": "4306188357865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb56",
            "leftCorner": {
              "x": 8.173,
              "y": 37.342,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.166,
              "y": 37.218,
              "z": 0.908
            },
            "gtin": "4003087400158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb57",
            "leftCorner": {
              "x": 8.166,
              "y": 37.218,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.158,
              "y": 37.093,
              "z": 0.908
            },
            "gtin": "4003087400158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb58",
            "leftCorner": {
              "x": 8.159,
              "y": 37.093,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.155,
              "y": 37.022,
              "z": 0.908
            },
            "gtin": "4036581252589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb59",
            "leftCorner": {
              "x": 8.155,
              "y": 37.022,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.151,
              "y": 36.952,
              "z": 0.908
            },
            "gtin": "4036581252589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb5a",
            "leftCorner": {
              "x": 8.155,
              "y": 36.951,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.151,
              "y": 36.875,
              "z": 0.908
            },
            "gtin": "4306188030799",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb5b",
            "leftCorner": {
              "x": 8.151,
              "y": 36.875,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.146,
              "y": 36.799,
              "z": 0.908
            },
            "gtin": "4306188030799",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb5c",
            "leftCorner": {
              "x": 8.14,
              "y": 36.8,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.135,
              "y": 36.728,
              "z": 0.908
            },
            "gtin": "4008617014010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb4f",
            "leftCorner": {
              "x": 8.119,
              "y": 36.729,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.114,
              "y": 36.644,
              "z": 0.908
            },
            "gtin": "4009932006698",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54655e",
        "height": 1.3133,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fb5d",
            "leftCorner": {
              "x": 8.161,
              "y": 37.894,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.156,
              "y": 37.81,
              "z": 1.075
            },
            "gtin": "4003087433453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb60",
            "leftCorner": {
              "x": 8.181,
              "y": 37.808,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.178,
              "y": 37.749,
              "z": 1.075
            },
            "gtin": "4003087441953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb61",
            "leftCorner": {
              "x": 8.181,
              "y": 37.749,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.176,
              "y": 37.655,
              "z": 1.075
            },
            "gtin": "4003087432456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb62",
            "leftCorner": {
              "x": 8.171,
              "y": 37.655,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.166,
              "y": 37.582,
              "z": 1.075
            },
            "gtin": "4260555341607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb63",
            "leftCorner": {
              "x": 8.177,
              "y": 37.582,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.174,
              "y": 37.524,
              "z": 1.075
            },
            "gtin": "4009932132281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb64",
            "leftCorner": {
              "x": 8.174,
              "y": 37.524,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.171,
              "y": 37.463,
              "z": 1.075
            },
            "gtin": "4036581526970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb65",
            "leftCorner": {
              "x": 8.173,
              "y": 37.463,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.168,
              "y": 37.378,
              "z": 1.075
            },
            "gtin": "4306188017134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb66",
            "leftCorner": {
              "x": 8.171,
              "y": 37.378,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.167,
              "y": 37.304,
              "z": 1.075
            },
            "gtin": "4008617403098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb67",
            "leftCorner": {
              "x": 8.171,
              "y": 37.304,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.165,
              "y": 37.204,
              "z": 1.075
            },
            "gtin": "4005120170325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb68",
            "leftCorner": {
              "x": 8.157,
              "y": 37.205,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.148,
              "y": 37.062,
              "z": 1.075
            },
            "gtin": "4005120170318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb69",
            "leftCorner": {
              "x": 8.156,
              "y": 37.063,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.151,
              "y": 36.98,
              "z": 1.075
            },
            "gtin": "4005120170400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb6a",
            "leftCorner": {
              "x": 8.151,
              "y": 36.98,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.144,
              "y": 36.874,
              "z": 1.075
            },
            "gtin": "4008455033914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb6b",
            "leftCorner": {
              "x": 8.149,
              "y": 36.873,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.145,
              "y": 36.804,
              "z": 1.075
            },
            "gtin": "4008491111935",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb6c",
            "leftCorner": {
              "x": 8.15,
              "y": 36.803,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.147,
              "y": 36.759,
              "z": 1.075
            },
            "gtin": "4008491100717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb5e",
            "leftCorner": {
              "x": 8.132,
              "y": 36.76,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.129,
              "y": 36.701,
              "z": 1.075
            },
            "gtin": "4009932004465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb5f",
            "leftCorner": {
              "x": 8.129,
              "y": 36.701,
              "z": 1.075
            },
            "rightCorner": {
              "x": 8.125,
              "y": 36.643,
              "z": 1.075
            },
            "gtin": "4009932004465",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54655d",
        "height": 1.5106,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f13b",
            "leftCorner": {
              "x": 8.181,
              "y": 37.889,
              "z": 1.236
            },
            "rightCorner": {
              "x": 8.179,
              "y": 37.857,
              "z": 1.236
            },
            "gtin": "4009932134872",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f13c",
            "leftCorner": {
              "x": 8.179,
              "y": 37.857,
              "z": 1.236
            },
            "rightCorner": {
              "x": 8.178,
              "y": 37.824,
              "z": 1.236
            },
            "gtin": "4009932134872",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f13d",
            "leftCorner": {
              "x": 8.177,
              "y": 37.824,
              "z": 1.236
            },
            "rightCorner": {
              "x": 8.175,
              "y": 37.788,
              "z": 1.236
            },
            "gtin": "4003573189079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f13e",
            "leftCorner": {
              "x": 8.168,
              "y": 37.789,
              "z": 1.236
            },
            "rightCorner": {
              "x": 8.164,
              "y": 37.717,
              "z": 1.236
            },
            "gtin": "4064761001108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f13f",
            "leftCorner": {
              "x": 8.164,
              "y": 37.717,
              "z": 1.236
            },
            "rightCorner": {
              "x": 8.16,
              "y": 37.646,
              "z": 1.236
            },
            "gtin": "4064761001108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f140",
            "leftCorner": {
              "x": 8.163,
              "y": 37.646,
              "z": 1.236
            },
            "rightCorner": {
              "x": 8.159,
              "y": 37.583,
              "z": 1.236
            },
            "gtin": "4306188001164",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c875ed67a01d9a1f141",
            "leftCorner": {
              "x": 8.169,
              "y": 37.582,
              "z": 1.236
            },
            "rightCorner": {
              "x": 8.166,
              "y": 37.538,
              "z": 1.236
            },
            "gtin": "4043107022137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f142",
            "leftCorner": {
              "x": 8.148,
              "y": 37.54,
              "z": 1.236
            },
            "rightCorner": {
              "x": 8.144,
              "y": 37.462,
              "z": 1.236
            },
            "gtin": "4009932135886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f143",
            "leftCorner": {
              "x": 8.154,
              "y": 37.461,
              "z": 1.236
            },
            "rightCorner": {
              "x": 8.151,
              "y": 37.401,
              "z": 1.236
            },
            "gtin": "4009932136883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f144",
            "leftCorner": {
              "x": 8.171,
              "y": 37.399,
              "z": 1.236
            },
            "rightCorner": {
              "x": 8.168,
              "y": 37.351,
              "z": 1.236
            },
            "gtin": "4036581583584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f145",
            "leftCorner": {
              "x": 8.171,
              "y": 37.351,
              "z": 1.236
            },
            "rightCorner": {
              "x": 8.167,
              "y": 37.282,
              "z": 1.236
            },
            "gtin": "4036581583386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f146",
            "leftCorner": {
              "x": 8.175,
              "y": 37.282,
              "z": 1.236
            },
            "rightCorner": {
              "x": 8.169,
              "y": 37.182,
              "z": 1.236
            },
            "gtin": "4036581583546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f147",
            "leftCorner": {
              "x": 8.154,
              "y": 37.183,
              "z": 1.236
            },
            "rightCorner": {
              "x": 8.148,
              "y": 37.08,
              "z": 1.236
            },
            "gtin": "4022679167705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f148",
            "leftCorner": {
              "x": 8.15,
              "y": 37.08,
              "z": 1.236
            },
            "rightCorner": {
              "x": 8.145,
              "y": 36.994,
              "z": 1.236
            },
            "gtin": "4008455037813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f149",
            "leftCorner": {
              "x": 8.145,
              "y": 36.994,
              "z": 1.236
            },
            "rightCorner": {
              "x": 8.14,
              "y": 36.906,
              "z": 1.236
            },
            "gtin": "4008455037813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f14a",
            "leftCorner": {
              "x": 8.156,
              "y": 36.906,
              "z": 1.236
            },
            "rightCorner": {
              "x": 8.15,
              "y": 36.81,
              "z": 1.236
            },
            "gtin": "4008455037615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f14b",
            "leftCorner": {
              "x": 8.15,
              "y": 36.81,
              "z": 1.236
            },
            "rightCorner": {
              "x": 8.144,
              "y": 36.714,
              "z": 1.236
            },
            "gtin": "4008455037615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f117",
            "leftCorner": {
              "x": 8.118,
              "y": 36.715,
              "z": 1.236
            },
            "rightCorner": {
              "x": 8.114,
              "y": 36.644,
              "z": 1.236
            },
            "gtin": "4036581251902",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54655f",
        "height": 1.711,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f172",
            "leftCorner": {
              "x": 8.179,
              "y": 37.851,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.174,
              "y": 37.777,
              "z": 1.4
            },
            "gtin": "4008491115698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f173",
            "leftCorner": {
              "x": 8.162,
              "y": 37.778,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.16,
              "y": 37.743,
              "z": 1.4
            },
            "gtin": "4008617988694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f174",
            "leftCorner": {
              "x": 8.16,
              "y": 37.743,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.158,
              "y": 37.71,
              "z": 1.4
            },
            "gtin": "4008617988694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f175",
            "leftCorner": {
              "x": 8.159,
              "y": 37.71,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.155,
              "y": 37.638,
              "z": 1.4
            },
            "gtin": "4003573289052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f176",
            "leftCorner": {
              "x": 8.169,
              "y": 37.637,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.163,
              "y": 37.539,
              "z": 1.4
            },
            "gtin": "4306188028468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f177",
            "leftCorner": {
              "x": 8.16,
              "y": 37.539,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.156,
              "y": 37.471,
              "z": 1.4
            },
            "gtin": "4008617012627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f178",
            "leftCorner": {
              "x": 8.16,
              "y": 37.471,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.155,
              "y": 37.382,
              "z": 1.4
            },
            "gtin": "4008233125824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f179",
            "leftCorner": {
              "x": 8.153,
              "y": 37.383,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.147,
              "y": 37.28,
              "z": 1.4
            },
            "gtin": "4008233172156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f17a",
            "leftCorner": {
              "x": 8.173,
              "y": 37.278,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.167,
              "y": 37.178,
              "z": 1.4
            },
            "gtin": "4008617027287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f17b",
            "leftCorner": {
              "x": 8.168,
              "y": 37.178,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.165,
              "y": 37.14,
              "z": 1.4
            },
            "gtin": "4008617403227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f17c",
            "leftCorner": {
              "x": 8.165,
              "y": 37.14,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.163,
              "y": 37.101,
              "z": 1.4
            },
            "gtin": "4008617403227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f17d",
            "leftCorner": {
              "x": 8.162,
              "y": 37.101,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.157,
              "y": 37.01,
              "z": 1.4
            },
            "gtin": "4003573289069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f17e",
            "leftCorner": {
              "x": 8.145,
              "y": 37.01,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.139,
              "y": 36.903,
              "z": 1.4
            },
            "gtin": "4008455033518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f17f",
            "leftCorner": {
              "x": 8.139,
              "y": 36.903,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.133,
              "y": 36.796,
              "z": 1.4
            },
            "gtin": "4008455033518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f180",
            "leftCorner": {
              "x": 8.138,
              "y": 36.796,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.136,
              "y": 36.755,
              "z": 1.4
            },
            "gtin": "4036581252411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f181",
            "leftCorner": {
              "x": 8.136,
              "y": 36.755,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.134,
              "y": 36.715,
              "z": 1.4
            },
            "gtin": "4036581252411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f14d",
            "leftCorner": {
              "x": 8.127,
              "y": 36.715,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.123,
              "y": 36.643,
              "z": 1.4
            },
            "gtin": "4260609512045",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468a3"
  },
  {
    "id": "468a5",
    "name": "468a5",
    "x": 7.964,
    "y": 34.024,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.7228,
      "w": 0.69106
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 66
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a54656a",
        "height": 1.0546,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fb86",
            "leftCorner": {
              "x": 7.987,
              "y": 33.582,
              "z": 0.863
            },
            "rightCorner": {
              "x": 7.984,
              "y": 33.521,
              "z": 0.863
            },
            "gtin": "4009900379564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb87",
            "leftCorner": {
              "x": 7.984,
              "y": 33.521,
              "z": 0.863
            },
            "rightCorner": {
              "x": 7.981,
              "y": 33.461,
              "z": 0.863
            },
            "gtin": "4009900379564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb88",
            "leftCorner": {
              "x": 7.981,
              "y": 33.461,
              "z": 0.863
            },
            "rightCorner": {
              "x": 7.979,
              "y": 33.4,
              "z": 0.863
            },
            "gtin": "4009900379564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb89",
            "leftCorner": {
              "x": 7.979,
              "y": 33.4,
              "z": 0.863
            },
            "rightCorner": {
              "x": 7.976,
              "y": 33.339,
              "z": 0.863
            },
            "gtin": "4009900379564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb8a",
            "leftCorner": {
              "x": 7.99,
              "y": 33.339,
              "z": 0.863
            },
            "rightCorner": {
              "x": 7.986,
              "y": 33.249,
              "z": 0.863
            },
            "gtin": "4009900381352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb8b",
            "leftCorner": {
              "x": 7.986,
              "y": 33.249,
              "z": 0.863
            },
            "rightCorner": {
              "x": 7.982,
              "y": 33.16,
              "z": 0.863
            },
            "gtin": "4009900381352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb7b",
            "leftCorner": {
              "x": 7.971,
              "y": 33.16,
              "z": 0.863
            },
            "rightCorner": {
              "x": 7.965,
              "y": 33.023,
              "z": 0.863
            },
            "gtin": "4009900476812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb85",
            "leftCorner": {
              "x": 7.999,
              "y": 33.709,
              "z": 0.863
            },
            "rightCorner": {
              "x": 7.993,
              "y": 33.582,
              "z": 0.863
            },
            "gtin": "4009900406918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb80",
            "leftCorner": {
              "x": 8.002,
              "y": 33.993,
              "z": 0.863
            },
            "rightCorner": {
              "x": 7.998,
              "y": 33.909,
              "z": 0.863
            },
            "gtin": "3501275620797",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb81",
            "leftCorner": {
              "x": 7.998,
              "y": 33.909,
              "z": 0.863
            },
            "rightCorner": {
              "x": 7.995,
              "y": 33.825,
              "z": 0.863
            },
            "gtin": "3501275620797",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb82",
            "leftCorner": {
              "x": 7.998,
              "y": 33.825,
              "z": 0.863
            },
            "rightCorner": {
              "x": 7.996,
              "y": 33.786,
              "z": 0.863
            },
            "gtin": "80957577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb83",
            "leftCorner": {
              "x": 7.996,
              "y": 33.786,
              "z": 0.863
            },
            "rightCorner": {
              "x": 7.995,
              "y": 33.748,
              "z": 0.863
            },
            "gtin": "80957577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb84",
            "leftCorner": {
              "x": 7.995,
              "y": 33.748,
              "z": 0.863
            },
            "rightCorner": {
              "x": 7.993,
              "y": 33.709,
              "z": 0.863
            },
            "gtin": "80957577",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54656b",
        "height": 1.3075,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fbbf",
            "leftCorner": {
              "x": 7.998,
              "y": 33.988,
              "z": 1.07
            },
            "rightCorner": {
              "x": 7.995,
              "y": 33.925,
              "z": 1.07
            },
            "gtin": "4009900544122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbc0",
            "leftCorner": {
              "x": 7.993,
              "y": 33.925,
              "z": 1.07
            },
            "rightCorner": {
              "x": 7.989,
              "y": 33.852,
              "z": 1.07
            },
            "gtin": "4009900544368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbc1",
            "leftCorner": {
              "x": 8.0,
              "y": 33.852,
              "z": 1.07
            },
            "rightCorner": {
              "x": 7.997,
              "y": 33.799,
              "z": 1.07
            },
            "gtin": "4009900543903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbc2",
            "leftCorner": {
              "x": 7.997,
              "y": 33.799,
              "z": 1.07
            },
            "rightCorner": {
              "x": 7.995,
              "y": 33.747,
              "z": 1.07
            },
            "gtin": "4009900543903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbc3",
            "leftCorner": {
              "x": 7.995,
              "y": 33.747,
              "z": 1.07
            },
            "rightCorner": {
              "x": 7.993,
              "y": 33.694,
              "z": 1.07
            },
            "gtin": "4009900543903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbc4",
            "leftCorner": {
              "x": 7.999,
              "y": 33.694,
              "z": 1.07
            },
            "rightCorner": {
              "x": 7.996,
              "y": 33.625,
              "z": 1.07
            },
            "gtin": "4009900360937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbc5",
            "leftCorner": {
              "x": 7.996,
              "y": 33.625,
              "z": 1.07
            },
            "rightCorner": {
              "x": 7.993,
              "y": 33.555,
              "z": 1.07
            },
            "gtin": "4009900360937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbc6",
            "leftCorner": {
              "x": 7.998,
              "y": 33.555,
              "z": 1.07
            },
            "rightCorner": {
              "x": 7.995,
              "y": 33.485,
              "z": 1.07
            },
            "gtin": "4009900474214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbc7",
            "leftCorner": {
              "x": 7.995,
              "y": 33.485,
              "z": 1.07
            },
            "rightCorner": {
              "x": 7.991,
              "y": 33.415,
              "z": 1.07
            },
            "gtin": "4009900474214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbc8",
            "leftCorner": {
              "x": 7.982,
              "y": 33.415,
              "z": 1.07
            },
            "rightCorner": {
              "x": 7.978,
              "y": 33.333,
              "z": 1.07
            },
            "gtin": "4009900398640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbc9",
            "leftCorner": {
              "x": 7.978,
              "y": 33.333,
              "z": 1.07
            },
            "rightCorner": {
              "x": 7.974,
              "y": 33.251,
              "z": 1.07
            },
            "gtin": "4009900398640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbca",
            "leftCorner": {
              "x": 7.982,
              "y": 33.251,
              "z": 1.07
            },
            "rightCorner": {
              "x": 7.975,
              "y": 33.102,
              "z": 1.07
            },
            "gtin": "4008429162510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbb8",
            "leftCorner": {
              "x": 7.983,
              "y": 33.102,
              "z": 1.07
            },
            "rightCorner": {
              "x": 7.979,
              "y": 33.022,
              "z": 1.07
            },
            "gtin": "4009900376600",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54656d",
        "height": 1.5602,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fb94",
            "leftCorner": {
              "x": 8.008,
              "y": 33.961,
              "z": 1.277
            },
            "rightCorner": {
              "x": 8.003,
              "y": 33.851,
              "z": 1.277
            },
            "gtin": "5011053026591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb95",
            "leftCorner": {
              "x": 8.003,
              "y": 33.851,
              "z": 1.277
            },
            "rightCorner": {
              "x": 7.998,
              "y": 33.74,
              "z": 1.277
            },
            "gtin": "5011053026591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb96",
            "leftCorner": {
              "x": 7.998,
              "y": 33.74,
              "z": 1.277
            },
            "rightCorner": {
              "x": 7.993,
              "y": 33.629,
              "z": 1.277
            },
            "gtin": "5011053026591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb97",
            "leftCorner": {
              "x": 7.989,
              "y": 33.629,
              "z": 1.277
            },
            "rightCorner": {
              "x": 7.985,
              "y": 33.541,
              "z": 1.277
            },
            "gtin": "4337185928710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb98",
            "leftCorner": {
              "x": 7.989,
              "y": 33.541,
              "z": 1.277
            },
            "rightCorner": {
              "x": 7.987,
              "y": 33.485,
              "z": 1.277
            },
            "gtin": "4337185450778",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb99",
            "leftCorner": {
              "x": 7.987,
              "y": 33.485,
              "z": 1.277
            },
            "rightCorner": {
              "x": 7.984,
              "y": 33.429,
              "z": 1.277
            },
            "gtin": "4337185450778",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb9a",
            "leftCorner": {
              "x": 7.978,
              "y": 33.429,
              "z": 1.277
            },
            "rightCorner": {
              "x": 7.974,
              "y": 33.348,
              "z": 1.277
            },
            "gtin": "4337185450655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb9b",
            "leftCorner": {
              "x": 7.976,
              "y": 33.348,
              "z": 1.277
            },
            "rightCorner": {
              "x": 7.97,
              "y": 33.229,
              "z": 1.277
            },
            "gtin": "4337185928703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb9c",
            "leftCorner": {
              "x": 7.97,
              "y": 33.229,
              "z": 1.277
            },
            "rightCorner": {
              "x": 7.965,
              "y": 33.11,
              "z": 1.277
            },
            "gtin": "4337185928703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb8c",
            "leftCorner": {
              "x": 7.98,
              "y": 33.11,
              "z": 1.277
            },
            "rightCorner": {
              "x": 7.976,
              "y": 33.022,
              "z": 1.277
            },
            "gtin": "4337185928697",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54656c",
        "height": 1.7543,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fba2",
            "leftCorner": {
              "x": 8.007,
              "y": 33.976,
              "z": 1.435
            },
            "rightCorner": {
              "x": 7.997,
              "y": 33.755,
              "z": 1.435
            },
            "gtin": "8000500341872",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fba3",
            "leftCorner": {
              "x": 7.997,
              "y": 33.755,
              "z": 1.435
            },
            "rightCorner": {
              "x": 7.987,
              "y": 33.534,
              "z": 1.435
            },
            "gtin": "8000500341872",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fba4",
            "leftCorner": {
              "x": 7.995,
              "y": 33.534,
              "z": 1.435
            },
            "rightCorner": {
              "x": 7.988,
              "y": 33.39,
              "z": 1.435
            },
            "gtin": "4337185450532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fba5",
            "leftCorner": {
              "x": 7.987,
              "y": 33.39,
              "z": 1.435
            },
            "rightCorner": {
              "x": 7.982,
              "y": 33.27,
              "z": 1.435
            },
            "gtin": "4063367398896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb9e",
            "leftCorner": {
              "x": 7.977,
              "y": 33.27,
              "z": 1.435
            },
            "rightCorner": {
              "x": 7.972,
              "y": 33.147,
              "z": 1.435
            },
            "gtin": "4337185450570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb9f",
            "leftCorner": {
              "x": 7.972,
              "y": 33.147,
              "z": 1.435
            },
            "rightCorner": {
              "x": 7.966,
              "y": 33.023,
              "z": 1.435
            },
            "gtin": "4337185450570",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546568",
        "height": 0.1518,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fbe0",
            "leftCorner": {
              "x": 8.016,
              "y": 33.943,
              "z": 0.124
            },
            "rightCorner": {
              "x": 8.011,
              "y": 33.819,
              "z": 0.124
            },
            "gtin": "4260042072250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbe1",
            "leftCorner": {
              "x": 8.011,
              "y": 33.819,
              "z": 0.124
            },
            "rightCorner": {
              "x": 8.005,
              "y": 33.696,
              "z": 0.124
            },
            "gtin": "4260042072250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbe2",
            "leftCorner": {
              "x": 7.99,
              "y": 33.697,
              "z": 0.124
            },
            "rightCorner": {
              "x": 7.98,
              "y": 33.465,
              "z": 0.124
            },
            "gtin": "8714786302549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbe3",
            "leftCorner": {
              "x": 8.002,
              "y": 33.463,
              "z": 0.124
            },
            "rightCorner": {
              "x": 7.996,
              "y": 33.341,
              "z": 0.124
            },
            "gtin": "5200701001213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbe4",
            "leftCorner": {
              "x": 7.985,
              "y": 33.342,
              "z": 0.124
            },
            "rightCorner": {
              "x": 7.977,
              "y": 33.164,
              "z": 0.124
            },
            "gtin": "4260042076449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbda",
            "leftCorner": {
              "x": 7.978,
              "y": 33.164,
              "z": 0.124
            },
            "rightCorner": {
              "x": 7.972,
              "y": 33.023,
              "z": 0.124
            },
            "gtin": "4003196029363",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546569",
        "height": 0.50216,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fbd1",
            "leftCorner": {
              "x": 7.992,
              "y": 33.994,
              "z": 0.411
            },
            "rightCorner": {
              "x": 7.986,
              "y": 33.85,
              "z": 0.411
            },
            "gtin": "5011053024436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbd2",
            "leftCorner": {
              "x": 8.012,
              "y": 33.849,
              "z": 0.411
            },
            "rightCorner": {
              "x": 8.001,
              "y": 33.6,
              "z": 0.411
            },
            "gtin": "3587361043176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbd3",
            "leftCorner": {
              "x": 7.991,
              "y": 33.601,
              "z": 0.411
            },
            "rightCorner": {
              "x": 7.987,
              "y": 33.516,
              "z": 0.411
            },
            "gtin": "5011061123374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbd4",
            "leftCorner": {
              "x": 7.971,
              "y": 33.516,
              "z": 0.411
            },
            "rightCorner": {
              "x": 7.969,
              "y": 33.474,
              "z": 0.411
            },
            "gtin": "9001643201633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbd5",
            "leftCorner": {
              "x": 7.969,
              "y": 33.474,
              "z": 0.411
            },
            "rightCorner": {
              "x": 7.967,
              "y": 33.432,
              "z": 0.411
            },
            "gtin": "9001643201633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbd6",
            "leftCorner": {
              "x": 7.979,
              "y": 33.431,
              "z": 0.411
            },
            "rightCorner": {
              "x": 7.976,
              "y": 33.358,
              "z": 0.411
            },
            "gtin": "4004363010306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbd7",
            "leftCorner": {
              "x": 7.976,
              "y": 33.358,
              "z": 0.411
            },
            "rightCorner": {
              "x": 7.972,
              "y": 33.284,
              "z": 0.411
            },
            "gtin": "4004363010306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbcc",
            "leftCorner": {
              "x": 7.984,
              "y": 33.284,
              "z": 0.411
            },
            "rightCorner": {
              "x": 7.972,
              "y": 33.023,
              "z": 0.411
            },
            "gtin": "4003196043000",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54656e",
        "height": 0.80101,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fbaf",
            "leftCorner": {
              "x": 8.01,
              "y": 33.883,
              "z": 0.655
            },
            "rightCorner": {
              "x": 8.006,
              "y": 33.803,
              "z": 0.655
            },
            "gtin": "4000266110105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbb0",
            "leftCorner": {
              "x": 8.006,
              "y": 33.803,
              "z": 0.655
            },
            "rightCorner": {
              "x": 8.003,
              "y": 33.724,
              "z": 0.655
            },
            "gtin": "4000266110105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbb1",
            "leftCorner": {
              "x": 8.001,
              "y": 33.725,
              "z": 0.655
            },
            "rightCorner": {
              "x": 7.996,
              "y": 33.627,
              "z": 0.655
            },
            "gtin": "5011061160553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbb2",
            "leftCorner": {
              "x": 7.996,
              "y": 33.627,
              "z": 0.655
            },
            "rightCorner": {
              "x": 7.992,
              "y": 33.529,
              "z": 0.655
            },
            "gtin": "5011061160553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbb3",
            "leftCorner": {
              "x": 7.995,
              "y": 33.529,
              "z": 0.655
            },
            "rightCorner": {
              "x": 7.99,
              "y": 33.429,
              "z": 0.655
            },
            "gtin": "5011061192523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbb4",
            "leftCorner": {
              "x": 7.983,
              "y": 33.429,
              "z": 0.655
            },
            "rightCorner": {
              "x": 7.978,
              "y": 33.322,
              "z": 0.655
            },
            "gtin": "5011061105011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbb5",
            "leftCorner": {
              "x": 7.996,
              "y": 33.321,
              "z": 0.655
            },
            "rightCorner": {
              "x": 7.993,
              "y": 33.268,
              "z": 0.655
            },
            "gtin": "4053900009501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbb6",
            "leftCorner": {
              "x": 7.993,
              "y": 33.268,
              "z": 0.655
            },
            "rightCorner": {
              "x": 7.991,
              "y": 33.215,
              "z": 0.655
            },
            "gtin": "4053900009501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fba7",
            "leftCorner": {
              "x": 7.971,
              "y": 33.215,
              "z": 0.655
            },
            "rightCorner": {
              "x": 7.966,
              "y": 33.119,
              "z": 0.655
            },
            "gtin": "4012340000011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fba8",
            "leftCorner": {
              "x": 7.966,
              "y": 33.119,
              "z": 0.655
            },
            "rightCorner": {
              "x": 7.962,
              "y": 33.023,
              "z": 0.655
            },
            "gtin": "4012340000011",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "edeea"
  },
  {
    "id": "468a6",
    "name": "468a6",
    "x": 1.862,
    "y": 34.436,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9998,
      "w": 0.019817
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 34
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546573",
        "height": 0.14743,
        "facings": []
      },
      {
        "id": "682ffdddd15af3232a546572",
        "height": 0.71252,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fbf5",
            "leftCorner": {
              "x": 1.861,
              "y": 34.422,
              "z": 0.583
            },
            "rightCorner": {
              "x": 1.648,
              "y": 34.43,
              "z": 0.583
            },
            "gtin": "4000576023683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbf8",
            "leftCorner": {
              "x": 1.647,
              "y": 34.398,
              "z": 0.583
            },
            "rightCorner": {
              "x": 1.573,
              "y": 34.401,
              "z": 0.583
            },
            "gtin": "4000576005863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbf9",
            "leftCorner": {
              "x": 1.573,
              "y": 34.401,
              "z": 0.583
            },
            "rightCorner": {
              "x": 1.5,
              "y": 34.404,
              "z": 0.583
            },
            "gtin": "4000576005863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbfa",
            "leftCorner": {
              "x": 1.5,
              "y": 34.404,
              "z": 0.583
            },
            "rightCorner": {
              "x": 1.426,
              "y": 34.406,
              "z": 0.583
            },
            "gtin": "4000576005863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbfb",
            "leftCorner": {
              "x": 1.426,
              "y": 34.396,
              "z": 0.583
            },
            "rightCorner": {
              "x": 1.149,
              "y": 34.408,
              "z": 0.583
            },
            "gtin": "662834510782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbf6",
            "leftCorner": {
              "x": 1.149,
              "y": 34.403,
              "z": 0.583
            },
            "rightCorner": {
              "x": 0.88,
              "y": 34.413,
              "z": 0.583
            },
            "gtin": "4000851022462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbf7",
            "leftCorner": {
              "x": 0.88,
              "y": 34.413,
              "z": 0.583
            },
            "rightCorner": {
              "x": 0.611,
              "y": 34.425,
              "z": 0.583
            },
            "gtin": "4000851022462",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546570",
        "height": 1.1042,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fbeb",
            "leftCorner": {
              "x": 1.862,
              "y": 34.443,
              "z": 0.903
            },
            "rightCorner": {
              "x": 1.747,
              "y": 34.448,
              "z": 0.903
            },
            "gtin": "7321012001117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbec",
            "leftCorner": {
              "x": 1.747,
              "y": 34.448,
              "z": 0.903
            },
            "rightCorner": {
              "x": 1.632,
              "y": 34.453,
              "z": 0.903
            },
            "gtin": "7321012001117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbf0",
            "leftCorner": {
              "x": 1.631,
              "y": 34.419,
              "z": 0.903
            },
            "rightCorner": {
              "x": 1.487,
              "y": 34.425,
              "z": 0.903
            },
            "gtin": "7321011643721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbf1",
            "leftCorner": {
              "x": 1.487,
              "y": 34.425,
              "z": 0.903
            },
            "rightCorner": {
              "x": 1.344,
              "y": 34.43,
              "z": 0.903
            },
            "gtin": "7321011643721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbf2",
            "leftCorner": {
              "x": 1.344,
              "y": 34.43,
              "z": 0.903
            },
            "rightCorner": {
              "x": 1.2,
              "y": 34.436,
              "z": 0.903
            },
            "gtin": "7321011643721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbf3",
            "leftCorner": {
              "x": 1.2,
              "y": 34.433,
              "z": 0.903
            },
            "rightCorner": {
              "x": 1.073,
              "y": 34.438,
              "z": 0.903
            },
            "gtin": "4000576005863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbf4",
            "leftCorner": {
              "x": 1.072,
              "y": 34.421,
              "z": 0.903
            },
            "rightCorner": {
              "x": 0.93,
              "y": 34.426,
              "z": 0.903
            },
            "gtin": "4000576023683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbed",
            "leftCorner": {
              "x": 0.93,
              "y": 34.432,
              "z": 0.903
            },
            "rightCorner": {
              "x": 0.824,
              "y": 34.437,
              "z": 0.903
            },
            "gtin": "4000576005979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbee",
            "leftCorner": {
              "x": 0.824,
              "y": 34.437,
              "z": 0.903
            },
            "rightCorner": {
              "x": 0.718,
              "y": 34.441,
              "z": 0.903
            },
            "gtin": "4000576005979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbef",
            "leftCorner": {
              "x": 0.718,
              "y": 34.441,
              "z": 0.903
            },
            "rightCorner": {
              "x": 0.611,
              "y": 34.445,
              "z": 0.903
            },
            "gtin": "4000576005979",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54656f",
        "height": 1.4063,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fbe5",
            "leftCorner": {
              "x": 1.862,
              "y": 34.447,
              "z": 1.151
            },
            "rightCorner": {
              "x": 1.716,
              "y": 34.452,
              "z": 1.151
            },
            "gtin": "4000576084547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbe8",
            "leftCorner": {
              "x": 1.715,
              "y": 34.415,
              "z": 1.151
            },
            "rightCorner": {
              "x": 1.484,
              "y": 34.423,
              "z": 1.151
            },
            "gtin": "7321011837571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbe9",
            "leftCorner": {
              "x": 1.484,
              "y": 34.426,
              "z": 1.151
            },
            "rightCorner": {
              "x": 1.212,
              "y": 34.437,
              "z": 1.151
            },
            "gtin": "4063367429811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbea",
            "leftCorner": {
              "x": 1.212,
              "y": 34.437,
              "z": 1.151
            },
            "rightCorner": {
              "x": 0.94,
              "y": 34.447,
              "z": 1.151
            },
            "gtin": "4063367429811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbe6",
            "leftCorner": {
              "x": 0.939,
              "y": 34.424,
              "z": 1.151
            },
            "rightCorner": {
              "x": 0.775,
              "y": 34.43,
              "z": 1.151
            },
            "gtin": "4002215080309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbe7",
            "leftCorner": {
              "x": 0.775,
              "y": 34.43,
              "z": 1.151
            },
            "rightCorner": {
              "x": 0.611,
              "y": 34.437,
              "z": 1.151
            },
            "gtin": "4002215080309",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546571",
        "height": 1.7093,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e911",
            "leftCorner": {
              "x": 1.81,
              "y": 34.422,
              "z": 1.399
            },
            "rightCorner": {
              "x": 1.726,
              "y": 34.426,
              "z": 1.399
            },
            "gtin": "4260344220502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e912",
            "leftCorner": {
              "x": 1.726,
              "y": 34.426,
              "z": 1.399
            },
            "rightCorner": {
              "x": 1.642,
              "y": 34.429,
              "z": 1.399
            },
            "gtin": "4260344220502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e913",
            "leftCorner": {
              "x": 1.641,
              "y": 34.424,
              "z": 1.399
            },
            "rightCorner": {
              "x": 1.559,
              "y": 34.427,
              "z": 1.399
            },
            "gtin": "4260344220595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e914",
            "leftCorner": {
              "x": 1.559,
              "y": 34.427,
              "z": 1.399
            },
            "rightCorner": {
              "x": 1.477,
              "y": 34.43,
              "z": 1.399
            },
            "gtin": "4260344220595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e915",
            "leftCorner": {
              "x": 1.477,
              "y": 34.425,
              "z": 1.399
            },
            "rightCorner": {
              "x": 1.399,
              "y": 34.429,
              "z": 1.399
            },
            "gtin": "4260344220939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e916",
            "leftCorner": {
              "x": 1.399,
              "y": 34.429,
              "z": 1.399
            },
            "rightCorner": {
              "x": 1.321,
              "y": 34.432,
              "z": 1.399
            },
            "gtin": "4260344220939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e917",
            "leftCorner": {
              "x": 1.32,
              "y": 34.427,
              "z": 1.399
            },
            "rightCorner": {
              "x": 1.096,
              "y": 34.436,
              "z": 1.399
            },
            "gtin": "4260344220496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e918",
            "leftCorner": {
              "x": 1.096,
              "y": 34.427,
              "z": 1.399
            },
            "rightCorner": {
              "x": 0.924,
              "y": 34.434,
              "z": 1.399
            },
            "gtin": "4260344220588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e919",
            "leftCorner": {
              "x": 0.924,
              "y": 34.434,
              "z": 1.399
            },
            "rightCorner": {
              "x": 0.751,
              "y": 34.441,
              "z": 1.399
            },
            "gtin": "4260344220588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e91a",
            "leftCorner": {
              "x": 0.751,
              "y": 34.438,
              "z": 1.399
            },
            "rightCorner": {
              "x": 0.675,
              "y": 34.44,
              "z": 1.399
            },
            "gtin": "4260344220717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e91b",
            "leftCorner": {
              "x": 0.675,
              "y": 34.44,
              "z": 1.399
            },
            "rightCorner": {
              "x": 0.599,
              "y": 34.443,
              "z": 1.399
            },
            "gtin": "4260344220717",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "da3bb",
    "rightNeighborShelfId": "468a7"
  },
  {
    "id": "468a7",
    "name": "468a7",
    "x": 0.613,
    "y": 34.486,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9998,
      "w": 0.019817
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 4
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546537",
        "height": 0.15377,
        "facings": []
      },
      {
        "id": "682ffdddd15af3232a546535",
        "height": 0.70006,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f987",
            "leftCorner": {
              "x": 0.612,
              "y": 34.472,
              "z": 0.573
            },
            "rightCorner": {
              "x": 0.427,
              "y": 34.479,
              "z": 0.573
            },
            "gtin": "4015000306812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f98b",
            "leftCorner": {
              "x": 0.425,
              "y": 34.443,
              "z": 0.573
            },
            "rightCorner": {
              "x": -0.643,
              "y": 34.486,
              "z": 0.573
            },
            "gtin": "4063367492679",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546536",
        "height": 1.2112,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f98c",
            "leftCorner": {
              "x": 0.612,
              "y": 34.454,
              "z": 0.991
            },
            "rightCorner": {
              "x": 0.55,
              "y": 34.456,
              "z": 0.991
            }
          },
          {
            "id": "68300c885ed67a01d9a1f98d",
            "leftCorner": {
              "x": 0.548,
              "y": 34.418,
              "z": 0.991
            },
            "rightCorner": {
              "x": -0.045,
              "y": 34.442,
              "z": 0.991
            },
            "gtin": "4056524000091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f98e",
            "leftCorner": {
              "x": -0.045,
              "y": 34.442,
              "z": 0.991
            },
            "rightCorner": {
              "x": -0.639,
              "y": 34.465,
              "z": 0.991
            },
            "gtin": "4056524000091",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546534",
        "height": 1.7025,
        "facings": []
      }
    ],
    "leftNeighborShelfId": "468a6",
    "rightNeighborShelfId": "468a8"
  },
  {
    "id": "468a8",
    "name": "468a8",
    "x": -0.632,
    "y": 34.534,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99963,
      "w": 0.027311
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546574",
        "height": 0.15006,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f991",
            "leftCorner": {
              "x": -0.965,
              "y": 34.487,
              "z": 0.123
            },
            "rightCorner": {
              "x": -1.194,
              "y": 34.501,
              "z": 0.123
            },
            "gtin": "4063367394317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f992",
            "leftCorner": {
              "x": -1.194,
              "y": 34.501,
              "z": 0.123
            },
            "rightCorner": {
              "x": -1.423,
              "y": 34.513,
              "z": 0.123
            },
            "gtin": "4063367394317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f98f",
            "leftCorner": {
              "x": -1.423,
              "y": 34.519,
              "z": 0.123
            },
            "rightCorner": {
              "x": -1.653,
              "y": 34.531,
              "z": 0.123
            },
            "gtin": "4063367180521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f990",
            "leftCorner": {
              "x": -1.653,
              "y": 34.531,
              "z": 0.123
            },
            "rightCorner": {
              "x": -1.883,
              "y": 34.544,
              "z": 0.123
            },
            "gtin": "4063367180521",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546575",
        "height": 0.70383,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f988",
            "leftCorner": {
              "x": -0.64,
              "y": 34.487,
              "z": 0.576
            },
            "rightCorner": {
              "x": -1.054,
              "y": 34.51,
              "z": 0.576
            },
            "gtin": "7322540788709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f989",
            "leftCorner": {
              "x": -1.054,
              "y": 34.51,
              "z": 0.576
            },
            "rightCorner": {
              "x": -1.468,
              "y": 34.533,
              "z": 0.576
            },
            "gtin": "7322540788709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f98a",
            "leftCorner": {
              "x": -1.468,
              "y": 34.533,
              "z": 0.576
            },
            "rightCorner": {
              "x": -1.883,
              "y": 34.555,
              "z": 0.576
            },
            "gtin": "7322540788709",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546577",
        "height": 1.2001,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fbfc",
            "leftCorner": {
              "x": -0.633,
              "y": 34.519,
              "z": 0.982
            },
            "rightCorner": {
              "x": -0.97,
              "y": 34.537,
              "z": 0.982
            },
            "gtin": "7322540786668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbfd",
            "leftCorner": {
              "x": -0.97,
              "y": 34.537,
              "z": 0.982
            },
            "rightCorner": {
              "x": -1.307,
              "y": 34.556,
              "z": 0.982
            },
            "gtin": "7322540786668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc00",
            "leftCorner": {
              "x": -1.309,
              "y": 34.508,
              "z": 0.982
            },
            "rightCorner": {
              "x": -1.577,
              "y": 34.522,
              "z": 0.982
            },
            "gtin": "7322541409337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc01",
            "leftCorner": {
              "x": -1.576,
              "y": 34.533,
              "z": 0.982
            },
            "rightCorner": {
              "x": -1.928,
              "y": 34.552,
              "z": 0.982
            },
            "gtin": "7322540788006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc02",
            "leftCorner": {
              "x": -1.928,
              "y": 34.552,
              "z": 0.982
            },
            "rightCorner": {
              "x": -2.281,
              "y": 34.572,
              "z": 0.982
            },
            "gtin": "7322540788006",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546576",
        "height": 1.6991,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e91c",
            "leftCorner": {
              "x": -0.655,
              "y": 34.494,
              "z": 1.39
            },
            "rightCorner": {
              "x": -0.724,
              "y": 34.498,
              "z": 1.39
            },
            "gtin": "7322541402932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e91d",
            "leftCorner": {
              "x": -0.724,
              "y": 34.498,
              "z": 1.39
            },
            "rightCorner": {
              "x": -0.793,
              "y": 34.502,
              "z": 1.39
            },
            "gtin": "7322541402932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e91e",
            "leftCorner": {
              "x": -0.793,
              "y": 34.502,
              "z": 1.39
            },
            "rightCorner": {
              "x": -0.862,
              "y": 34.505,
              "z": 1.39
            },
            "gtin": "7322541402932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e91f",
            "leftCorner": {
              "x": -0.862,
              "y": 34.508,
              "z": 1.39
            },
            "rightCorner": {
              "x": -1.004,
              "y": 34.516,
              "z": 1.39
            },
            "gtin": "7322541409337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e920",
            "leftCorner": {
              "x": -1.004,
              "y": 34.516,
              "z": 1.39
            },
            "rightCorner": {
              "x": -1.146,
              "y": 34.524,
              "z": 1.39
            },
            "gtin": "7322541409337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e921",
            "leftCorner": {
              "x": -1.146,
              "y": 34.51,
              "z": 1.39
            },
            "rightCorner": {
              "x": -1.3,
              "y": 34.518,
              "z": 1.39
            },
            "gtin": "7322541403113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e922",
            "leftCorner": {
              "x": -1.3,
              "y": 34.518,
              "z": 1.39
            },
            "rightCorner": {
              "x": -1.454,
              "y": 34.527,
              "z": 1.39
            },
            "gtin": "7322541403113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e923",
            "leftCorner": {
              "x": -1.454,
              "y": 34.527,
              "z": 1.39
            },
            "rightCorner": {
              "x": -1.609,
              "y": 34.535,
              "z": 1.39
            },
            "gtin": "7322541403113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e924",
            "leftCorner": {
              "x": -1.609,
              "y": 34.535,
              "z": 1.39
            },
            "rightCorner": {
              "x": -1.763,
              "y": 34.544,
              "z": 1.39
            },
            "gtin": "7322541403113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e925",
            "leftCorner": {
              "x": -1.763,
              "y": 34.544,
              "z": 1.39
            },
            "rightCorner": {
              "x": -1.917,
              "y": 34.552,
              "z": 1.39
            },
            "gtin": "7322541403113",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468a7",
    "rightNeighborShelfId": "468ab"
  },
  {
    "id": "468ab",
    "name": "468ab",
    "x": -1.88,
    "y": 34.602,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99963,
      "w": 0.027311
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 14
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546579",
        "height": 0.13962,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc06",
            "leftCorner": {
              "x": -1.881,
              "y": 34.588,
              "z": 0.114
            },
            "rightCorner": {
              "x": -1.978,
              "y": 34.593,
              "z": 0.114
            }
          },
          {
            "id": "68300c885ed67a01d9a1fc07",
            "leftCorner": {
              "x": -1.98,
              "y": 34.557,
              "z": 0.114
            },
            "rightCorner": {
              "x": -3.131,
              "y": 34.621,
              "z": 0.114
            },
            "gtin": "4000851023179",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54657a",
        "height": 1.1991,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc03",
            "leftCorner": {
              "x": -2.282,
              "y": 34.552,
              "z": 0.981
            },
            "rightCorner": {
              "x": -2.468,
              "y": 34.562,
              "z": 0.981
            },
            "gtin": "7322540786514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc04",
            "leftCorner": {
              "x": -2.468,
              "y": 34.562,
              "z": 0.981
            },
            "rightCorner": {
              "x": -2.655,
              "y": 34.573,
              "z": 0.981
            },
            "gtin": "7322540786514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc05",
            "leftCorner": {
              "x": -2.655,
              "y": 34.573,
              "z": 0.981
            },
            "rightCorner": {
              "x": -2.842,
              "y": 34.583,
              "z": 0.981
            },
            "gtin": "7322540786514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbfe",
            "leftCorner": {
              "x": -2.841,
              "y": 34.588,
              "z": 0.981
            },
            "rightCorner": {
              "x": -2.987,
              "y": 34.595,
              "z": 0.981
            },
            "gtin": "4262428310598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbff",
            "leftCorner": {
              "x": -2.987,
              "y": 34.595,
              "z": 0.981
            },
            "rightCorner": {
              "x": -3.132,
              "y": 34.604,
              "z": 0.981
            },
            "gtin": "4262428310598",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546578",
        "height": 1.696,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e926",
            "leftCorner": {
              "x": -1.917,
              "y": 34.553,
              "z": 1.388
            },
            "rightCorner": {
              "x": -2.162,
              "y": 34.567,
              "z": 1.388
            },
            "gtin": "5029053038759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e927",
            "leftCorner": {
              "x": -2.163,
              "y": 34.553,
              "z": 1.388
            },
            "rightCorner": {
              "x": -2.332,
              "y": 34.563,
              "z": 1.388
            },
            "gtin": "5029053579405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e928",
            "leftCorner": {
              "x": -2.332,
              "y": 34.563,
              "z": 1.388
            },
            "rightCorner": {
              "x": -2.501,
              "y": 34.572,
              "z": 1.388
            },
            "gtin": "5029053579405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e929",
            "leftCorner": {
              "x": -2.501,
              "y": 34.577,
              "z": 1.388
            },
            "rightCorner": {
              "x": -2.614,
              "y": 34.584,
              "z": 1.388
            },
            "gtin": "5029053028620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e92a",
            "leftCorner": {
              "x": -2.614,
              "y": 34.584,
              "z": 1.388
            },
            "rightCorner": {
              "x": -2.728,
              "y": 34.59,
              "z": 1.388
            },
            "gtin": "5029053028620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e92b",
            "leftCorner": {
              "x": -2.728,
              "y": 34.59,
              "z": 1.388
            },
            "rightCorner": {
              "x": -2.841,
              "y": 34.597,
              "z": 1.388
            },
            "gtin": "5029053028620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e92c",
            "leftCorner": {
              "x": -2.841,
              "y": 34.601,
              "z": 1.388
            },
            "rightCorner": {
              "x": -3.0,
              "y": 34.609,
              "z": 1.388
            },
            "gtin": "7322540786866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e92d",
            "leftCorner": {
              "x": -3.0,
              "y": 34.609,
              "z": 1.388
            },
            "rightCorner": {
              "x": -3.159,
              "y": 34.617,
              "z": 1.388
            },
            "gtin": "7322540786866",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468a8",
    "rightNeighborShelfId": "468ac"
  },
  {
    "id": "468ac",
    "name": "468ac",
    "x": -3.128,
    "y": 34.67,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99963,
      "w": 0.027311
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 10
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a54657e",
        "height": 0.15029,
        "facings": []
      },
      {
        "id": "682ffdddd15af3232a54657d",
        "height": 0.69515,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc0c",
            "leftCorner": {
              "x": -3.128,
              "y": 34.665,
              "z": 0.569
            },
            "rightCorner": {
              "x": -3.236,
              "y": 34.671,
              "z": 0.569
            }
          },
          {
            "id": "68300c885ed67a01d9a1fc0d",
            "leftCorner": {
              "x": -3.236,
              "y": 34.671,
              "z": 0.569
            },
            "rightCorner": {
              "x": -3.343,
              "y": 34.676,
              "z": 0.569
            }
          },
          {
            "id": "68300c885ed67a01d9a1fc0e",
            "leftCorner": {
              "x": -3.345,
              "y": 34.64,
              "z": 0.569
            },
            "rightCorner": {
              "x": -3.862,
              "y": 34.668,
              "z": 0.569
            },
            "gtin": "4000735363131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc0f",
            "leftCorner": {
              "x": -3.862,
              "y": 34.668,
              "z": 0.569
            },
            "rightCorner": {
              "x": -4.378,
              "y": 34.696,
              "z": 0.569
            },
            "gtin": "4000735363131",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54657c",
        "height": 1.2577,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc08",
            "leftCorner": {
              "x": -3.129,
              "y": 34.651,
              "z": 1.029
            },
            "rightCorner": {
              "x": -3.177,
              "y": 34.654,
              "z": 1.029
            }
          },
          {
            "id": "68300c885ed67a01d9a1fc09",
            "leftCorner": {
              "x": -3.179,
              "y": 34.616,
              "z": 1.029
            },
            "rightCorner": {
              "x": -3.579,
              "y": 34.638,
              "z": 1.029
            },
            "gtin": "4000735363131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc0a",
            "leftCorner": {
              "x": -3.579,
              "y": 34.638,
              "z": 1.029
            },
            "rightCorner": {
              "x": -3.979,
              "y": 34.66,
              "z": 1.029
            },
            "gtin": "4000735363131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc0b",
            "leftCorner": {
              "x": -3.979,
              "y": 34.66,
              "z": 1.029
            },
            "rightCorner": {
              "x": -4.379,
              "y": 34.681,
              "z": 1.029
            },
            "gtin": "4000735363131",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54657b",
        "height": 1.6973,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e92e",
            "leftCorner": {
              "x": -3.158,
              "y": 34.623,
              "z": 1.389
            },
            "rightCorner": {
              "x": -3.401,
              "y": 34.637,
              "z": 1.389
            },
            "gtin": "5029053001159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e92f",
            "leftCorner": {
              "x": -3.401,
              "y": 34.637,
              "z": 1.389
            },
            "rightCorner": {
              "x": -3.645,
              "y": 34.65,
              "z": 1.389
            },
            "gtin": "5029053001159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e930",
            "leftCorner": {
              "x": -3.645,
              "y": 34.65,
              "z": 1.389
            },
            "rightCorner": {
              "x": -3.888,
              "y": 34.663,
              "z": 1.389
            },
            "gtin": "5029053001159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e931",
            "leftCorner": {
              "x": -3.888,
              "y": 34.665,
              "z": 1.389
            },
            "rightCorner": {
              "x": -4.173,
              "y": 34.681,
              "z": 1.389
            },
            "gtin": "5029053578309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e932",
            "leftCorner": {
              "x": -4.173,
              "y": 34.681,
              "z": 1.389
            },
            "rightCorner": {
              "x": -4.458,
              "y": 34.697,
              "z": 1.389
            },
            "gtin": "5029053578309",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468ab",
    "rightNeighborShelfId": "468ad"
  },
  {
    "id": "468ad",
    "name": "468ad",
    "x": -4.376,
    "y": 34.739,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99963,
      "w": 0.027311
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 5
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546580",
        "height": 0.14774,
        "facings": []
      },
      {
        "id": "682ffdddd15af3232a546582",
        "height": 0.74443,
        "facings": []
      },
      {
        "id": "682ffdddd15af3232a54657f",
        "height": 1.3501,
        "facings": []
      },
      {
        "id": "682ffdddd15af3232a546581",
        "height": 1.7034,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e933",
            "leftCorner": {
              "x": -4.458,
              "y": 34.698,
              "z": 1.394
            },
            "rightCorner": {
              "x": -4.655,
              "y": 34.71,
              "z": 1.394
            },
            "gtin": "4000735366323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e934",
            "leftCorner": {
              "x": -4.655,
              "y": 34.71,
              "z": 1.394
            },
            "rightCorner": {
              "x": -4.851,
              "y": 34.72,
              "z": 1.394
            },
            "gtin": "4000735366323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e935",
            "leftCorner": {
              "x": -4.851,
              "y": 34.72,
              "z": 1.394
            },
            "rightCorner": {
              "x": -5.048,
              "y": 34.73,
              "z": 1.394
            },
            "gtin": "4000735366323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e936",
            "leftCorner": {
              "x": -5.048,
              "y": 34.73,
              "z": 1.394
            },
            "rightCorner": {
              "x": -5.245,
              "y": 34.742,
              "z": 1.394
            },
            "gtin": "4000735366323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e937",
            "leftCorner": {
              "x": -5.246,
              "y": 34.724,
              "z": 1.394
            },
            "rightCorner": {
              "x": -5.609,
              "y": 34.743,
              "z": 1.394
            },
            "gtin": "4260344220861",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468ac",
    "rightNeighborShelfId": "468ae"
  },
  {
    "id": "468ae",
    "name": "468ae",
    "x": -5.624,
    "y": 34.807,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99963,
      "w": 0.027311
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 11,
      "shelfCategory": "TOILET_PAPER"
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546586",
        "height": 0.15462,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc13",
            "leftCorner": {
              "x": -6.506,
              "y": 34.806,
              "z": 0.127
            },
            "rightCorner": {
              "x": -6.923,
              "y": 34.829,
              "z": 0.127
            },
            "gtin": "4260344220144",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546583",
        "height": 0.74967,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc2d",
            "leftCorner": {
              "x": -5.682,
              "y": 34.766,
              "z": 0.613
            },
            "rightCorner": {
              "x": -6.097,
              "y": 34.788,
              "z": 0.613
            },
            "gtin": "4260344220076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc2e",
            "leftCorner": {
              "x": -6.097,
              "y": 34.788,
              "z": 0.613
            },
            "rightCorner": {
              "x": -6.511,
              "y": 34.811,
              "z": 0.613
            },
            "gtin": "4260344220076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc2f",
            "leftCorner": {
              "x": -6.511,
              "y": 34.811,
              "z": 0.613
            },
            "rightCorner": {
              "x": -6.925,
              "y": 34.834,
              "z": 0.613
            },
            "gtin": "4260344220076",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546585",
        "height": 1.3529,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc28",
            "leftCorner": {
              "x": -5.734,
              "y": 34.77,
              "z": 1.107
            },
            "rightCorner": {
              "x": -6.947,
              "y": 34.837,
              "z": 1.107
            },
            "gtin": "4260344221349",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546584",
        "height": 1.7018,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e938",
            "leftCorner": {
              "x": -5.608,
              "y": 34.754,
              "z": 1.392
            },
            "rightCorner": {
              "x": -5.915,
              "y": 34.77,
              "z": 1.392
            },
            "gtin": "7322540973297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e939",
            "leftCorner": {
              "x": -5.915,
              "y": 34.77,
              "z": 1.392
            },
            "rightCorner": {
              "x": -6.222,
              "y": 34.788,
              "z": 1.392
            },
            "gtin": "7322540973297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e93a",
            "leftCorner": {
              "x": -6.222,
              "y": 34.788,
              "z": 1.392
            },
            "rightCorner": {
              "x": -6.528,
              "y": 34.804,
              "z": 1.392
            },
            "gtin": "7322540973297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e93b",
            "leftCorner": {
              "x": -6.529,
              "y": 34.801,
              "z": 1.392
            },
            "rightCorner": {
              "x": -6.669,
              "y": 34.808,
              "z": 1.392
            },
            "gtin": "4260344220076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e93c",
            "leftCorner": {
              "x": -6.669,
              "y": 34.808,
              "z": 1.392
            },
            "rightCorner": {
              "x": -6.809,
              "y": 34.816,
              "z": 1.392
            },
            "gtin": "4260344220076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e93d",
            "leftCorner": {
              "x": -6.809,
              "y": 34.816,
              "z": 1.392
            },
            "rightCorner": {
              "x": -6.949,
              "y": 34.824,
              "z": 1.392
            },
            "gtin": "4260344220076",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468ad",
    "rightNeighborShelfId": "468af"
  },
  {
    "id": "468af",
    "name": "468af",
    "x": -6.873,
    "y": 34.875,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99963,
      "w": 0.027311
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 24
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a54658b",
        "height": 0.15935,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc14",
            "leftCorner": {
              "x": -6.924,
              "y": 34.824,
              "z": 0.13
            },
            "rightCorner": {
              "x": -7.8,
              "y": 34.871,
              "z": 0.13
            },
            "gtin": "4260344220878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc15",
            "leftCorner": {
              "x": -7.8,
              "y": 34.868,
              "z": 0.13
            },
            "rightCorner": {
              "x": -7.917,
              "y": 34.875,
              "z": 0.13
            },
            "gtin": "4063367231698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc16",
            "leftCorner": {
              "x": -7.917,
              "y": 34.875,
              "z": 0.13
            },
            "rightCorner": {
              "x": -8.033,
              "y": 34.881,
              "z": 0.13
            },
            "gtin": "4063367231698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc17",
            "leftCorner": {
              "x": -8.033,
              "y": 34.881,
              "z": 0.13
            },
            "rightCorner": {
              "x": -8.15,
              "y": 34.888,
              "z": 0.13
            },
            "gtin": "4063367231698",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54658a",
        "height": 0.74774,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc29",
            "leftCorner": {
              "x": -6.926,
              "y": 34.822,
              "z": 0.612
            },
            "rightCorner": {
              "x": -7.226,
              "y": 34.838,
              "z": 0.612
            },
            "gtin": "4337185384660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc2a",
            "leftCorner": {
              "x": -7.226,
              "y": 34.838,
              "z": 0.612
            },
            "rightCorner": {
              "x": -7.525,
              "y": 34.856,
              "z": 0.612
            },
            "gtin": "4337185384660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc2b",
            "leftCorner": {
              "x": -7.525,
              "y": 34.856,
              "z": 0.612
            },
            "rightCorner": {
              "x": -7.825,
              "y": 34.872,
              "z": 0.612
            },
            "gtin": "4337185384660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc2c",
            "leftCorner": {
              "x": -7.825,
              "y": 34.872,
              "z": 0.612
            },
            "rightCorner": {
              "x": -8.124,
              "y": 34.888,
              "z": 0.612
            },
            "gtin": "4337185384660",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546589",
        "height": 1.0522,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc30",
            "leftCorner": {
              "x": -6.874,
              "y": 34.856,
              "z": 0.861
            },
            "rightCorner": {
              "x": -6.995,
              "y": 34.863,
              "z": 0.861
            },
            "gtin": "4337185384585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc31",
            "leftCorner": {
              "x": -6.995,
              "y": 34.863,
              "z": 0.861
            },
            "rightCorner": {
              "x": -7.116,
              "y": 34.869,
              "z": 0.861
            },
            "gtin": "4337185384585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc32",
            "leftCorner": {
              "x": -7.116,
              "y": 34.869,
              "z": 0.861
            },
            "rightCorner": {
              "x": -7.238,
              "y": 34.876,
              "z": 0.861
            },
            "gtin": "4337185384585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc33",
            "leftCorner": {
              "x": -7.238,
              "y": 34.876,
              "z": 0.861
            },
            "rightCorner": {
              "x": -7.359,
              "y": 34.883,
              "z": 0.861
            },
            "gtin": "4337185384585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc38",
            "leftCorner": {
              "x": -7.361,
              "y": 34.841,
              "z": 0.861
            },
            "rightCorner": {
              "x": -7.495,
              "y": 34.848,
              "z": 0.861
            },
            "gtin": "4063367099403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc39",
            "leftCorner": {
              "x": -7.495,
              "y": 34.848,
              "z": 0.861
            },
            "rightCorner": {
              "x": -7.629,
              "y": 34.856,
              "z": 0.861
            },
            "gtin": "4063367099403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc3a",
            "leftCorner": {
              "x": -7.629,
              "y": 34.856,
              "z": 0.861
            },
            "rightCorner": {
              "x": -7.764,
              "y": 34.862,
              "z": 0.861
            },
            "gtin": "4063367099403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc34",
            "leftCorner": {
              "x": -7.763,
              "y": 34.87,
              "z": 0.861
            },
            "rightCorner": {
              "x": -7.854,
              "y": 34.875,
              "z": 0.861
            },
            "gtin": "4337185384622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc35",
            "leftCorner": {
              "x": -7.854,
              "y": 34.875,
              "z": 0.861
            },
            "rightCorner": {
              "x": -7.944,
              "y": 34.88,
              "z": 0.861
            },
            "gtin": "4337185384622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc36",
            "leftCorner": {
              "x": -7.944,
              "y": 34.88,
              "z": 0.861
            },
            "rightCorner": {
              "x": -8.034,
              "y": 34.885,
              "z": 0.861
            },
            "gtin": "4337185384622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc37",
            "leftCorner": {
              "x": -8.034,
              "y": 34.885,
              "z": 0.861
            },
            "rightCorner": {
              "x": -8.124,
              "y": 34.89,
              "z": 0.861
            },
            "gtin": "4337185384622",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546587",
        "height": 1.3621,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc26",
            "leftCorner": {
              "x": -6.95,
              "y": 34.802,
              "z": 1.114
            },
            "rightCorner": {
              "x": -7.538,
              "y": 34.834,
              "z": 1.114
            },
            "gtin": "4260344220076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc27",
            "leftCorner": {
              "x": -7.538,
              "y": 34.834,
              "z": 1.114
            },
            "rightCorner": {
              "x": -8.125,
              "y": 34.866,
              "z": 1.114
            },
            "gtin": "4260344220076",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546588",
        "height": 1.7115,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e93e",
            "leftCorner": {
              "x": -6.95,
              "y": 34.819,
              "z": 1.4
            },
            "rightCorner": {
              "x": -7.336,
              "y": 34.84,
              "z": 1.4
            },
            "gtin": "4260344220144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e93f",
            "leftCorner": {
              "x": -7.336,
              "y": 34.84,
              "z": 1.4
            },
            "rightCorner": {
              "x": -7.722,
              "y": 34.861,
              "z": 1.4
            },
            "gtin": "4260344220144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e940",
            "leftCorner": {
              "x": -7.722,
              "y": 34.861,
              "z": 1.4
            },
            "rightCorner": {
              "x": -8.107,
              "y": 34.882,
              "z": 1.4
            },
            "gtin": "4260344220144",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468ae",
    "rightNeighborShelfId": "468b0"
  },
  {
    "id": "468b0",
    "name": "468b0",
    "x": -8.121,
    "y": 34.943,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99963,
      "w": 0.027311
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 32
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546590",
        "height": 0.16056,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc18",
            "leftCorner": {
              "x": -8.15,
              "y": 34.892,
              "z": 0.131
            },
            "rightCorner": {
              "x": -8.229,
              "y": 34.897,
              "z": 0.131
            },
            "gtin": "4063367108556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc19",
            "leftCorner": {
              "x": -8.229,
              "y": 34.897,
              "z": 0.131
            },
            "rightCorner": {
              "x": -8.308,
              "y": 34.901,
              "z": 0.131
            },
            "gtin": "4063367108556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc1a",
            "leftCorner": {
              "x": -8.308,
              "y": 34.901,
              "z": 0.131
            },
            "rightCorner": {
              "x": -8.387,
              "y": 34.905,
              "z": 0.131
            },
            "gtin": "4063367108556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc1b",
            "leftCorner": {
              "x": -8.387,
              "y": 34.905,
              "z": 0.131
            },
            "rightCorner": {
              "x": -8.467,
              "y": 34.91,
              "z": 0.131
            },
            "gtin": "4063367108556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc1c",
            "leftCorner": {
              "x": -8.467,
              "y": 34.909,
              "z": 0.131
            },
            "rightCorner": {
              "x": -8.539,
              "y": 34.913,
              "z": 0.131
            },
            "gtin": "4337185384707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc1d",
            "leftCorner": {
              "x": -8.539,
              "y": 34.913,
              "z": 0.131
            },
            "rightCorner": {
              "x": -8.612,
              "y": 34.917,
              "z": 0.131
            },
            "gtin": "4337185384707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc1e",
            "leftCorner": {
              "x": -8.612,
              "y": 34.913,
              "z": 0.131
            },
            "rightCorner": {
              "x": -8.818,
              "y": 34.924,
              "z": 0.131
            },
            "gtin": "4337185384783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc1f",
            "leftCorner": {
              "x": -8.818,
              "y": 34.924,
              "z": 0.131
            },
            "rightCorner": {
              "x": -9.024,
              "y": 34.935,
              "z": 0.131
            },
            "gtin": "4337185384783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc20",
            "leftCorner": {
              "x": -9.024,
              "y": 34.935,
              "z": 0.131
            },
            "rightCorner": {
              "x": -9.23,
              "y": 34.946,
              "z": 0.131
            },
            "gtin": "4337185384783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc21",
            "leftCorner": {
              "x": -9.23,
              "y": 34.946,
              "z": 0.131
            },
            "rightCorner": {
              "x": -9.436,
              "y": 34.957,
              "z": 0.131
            },
            "gtin": "4337185384783",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546591",
        "height": 0.49889,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc73",
            "leftCorner": {
              "x": -8.122,
              "y": 34.928,
              "z": 0.408
            },
            "rightCorner": {
              "x": -8.454,
              "y": 34.946,
              "z": 0.408
            },
            "gtin": "4337185384769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc74",
            "leftCorner": {
              "x": -8.454,
              "y": 34.946,
              "z": 0.408
            },
            "rightCorner": {
              "x": -8.787,
              "y": 34.964,
              "z": 0.408
            },
            "gtin": "4337185384769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc75",
            "leftCorner": {
              "x": -8.787,
              "y": 34.964,
              "z": 0.408
            },
            "rightCorner": {
              "x": -9.118,
              "y": 34.982,
              "z": 0.408
            },
            "gtin": "4337185384769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc79",
            "leftCorner": {
              "x": -9.121,
              "y": 34.942,
              "z": 0.408
            },
            "rightCorner": {
              "x": -9.332,
              "y": 34.954,
              "z": 0.408
            },
            "gtin": "4337185384882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc7a",
            "leftCorner": {
              "x": -9.332,
              "y": 34.954,
              "z": 0.408
            },
            "rightCorner": {
              "x": -9.542,
              "y": 34.965,
              "z": 0.408
            },
            "gtin": "4337185384882",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54658f",
        "height": 0.85431,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc63",
            "leftCorner": {
              "x": -8.121,
              "y": 34.94,
              "z": 0.699
            },
            "rightCorner": {
              "x": -8.634,
              "y": 34.969,
              "z": 0.699
            },
            "gtin": "4063367015892",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c885ed67a01d9a1fc68",
            "leftCorner": {
              "x": -8.637,
              "y": 34.921,
              "z": 0.699
            },
            "rightCorner": {
              "x": -9.426,
              "y": 34.965,
              "z": 0.699
            },
            "gtin": "4063367206764",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54658e",
        "height": 1.1619,
        "facings": []
      },
      {
        "id": "682ffdddd15af3232a54658d",
        "height": 1.4188,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc3b",
            "leftCorner": {
              "x": -8.122,
              "y": 34.932,
              "z": 1.161
            },
            "rightCorner": {
              "x": -8.382,
              "y": 34.946,
              "z": 1.161
            },
            "gtin": "4063367206788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc3c",
            "leftCorner": {
              "x": -8.382,
              "y": 34.946,
              "z": 1.161
            },
            "rightCorner": {
              "x": -8.641,
              "y": 34.96,
              "z": 1.161
            },
            "gtin": "4063367206788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc3d",
            "leftCorner": {
              "x": -8.641,
              "y": 34.96,
              "z": 1.161
            },
            "rightCorner": {
              "x": -8.901,
              "y": 34.974,
              "z": 1.161
            },
            "gtin": "4063367206788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc3e",
            "leftCorner": {
              "x": -8.903,
              "y": 34.935,
              "z": 1.161
            },
            "rightCorner": {
              "x": -9.02,
              "y": 34.943,
              "z": 1.161
            },
            "gtin": "4063367206740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc3f",
            "leftCorner": {
              "x": -9.02,
              "y": 34.943,
              "z": 1.161
            },
            "rightCorner": {
              "x": -9.137,
              "y": 34.949,
              "z": 1.161
            },
            "gtin": "4063367206740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc40",
            "leftCorner": {
              "x": -9.137,
              "y": 34.949,
              "z": 1.161
            },
            "rightCorner": {
              "x": -9.254,
              "y": 34.955,
              "z": 1.161
            },
            "gtin": "4063367206740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc41",
            "leftCorner": {
              "x": -9.254,
              "y": 34.955,
              "z": 1.161
            },
            "rightCorner": {
              "x": -9.372,
              "y": 34.962,
              "z": 1.161
            },
            "gtin": "4063367206740",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54658c",
        "height": 1.7053,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e941",
            "leftCorner": {
              "x": -8.107,
              "y": 34.893,
              "z": 1.395
            },
            "rightCorner": {
              "x": -8.206,
              "y": 34.899,
              "z": 1.395
            },
            "gtin": "7322541497426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e942",
            "leftCorner": {
              "x": -8.206,
              "y": 34.899,
              "z": 1.395
            },
            "rightCorner": {
              "x": -8.305,
              "y": 34.904,
              "z": 1.395
            },
            "gtin": "7322541497426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e943",
            "leftCorner": {
              "x": -8.305,
              "y": 34.904,
              "z": 1.395
            },
            "rightCorner": {
              "x": -8.405,
              "y": 34.909,
              "z": 1.395
            },
            "gtin": "7322541497426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e944",
            "leftCorner": {
              "x": -8.405,
              "y": 34.908,
              "z": 1.395
            },
            "rightCorner": {
              "x": -8.641,
              "y": 34.921,
              "z": 1.395
            },
            "gtin": "7322541497501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e945",
            "leftCorner": {
              "x": -8.641,
              "y": 34.921,
              "z": 1.395
            },
            "rightCorner": {
              "x": -8.877,
              "y": 34.934,
              "z": 1.395
            },
            "gtin": "7322541497501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e946",
            "leftCorner": {
              "x": -8.877,
              "y": 34.934,
              "z": 1.395
            },
            "rightCorner": {
              "x": -9.113,
              "y": 34.947,
              "z": 1.395
            },
            "gtin": "7322541497501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e947",
            "leftCorner": {
              "x": -9.113,
              "y": 34.941,
              "z": 1.395
            },
            "rightCorner": {
              "x": -9.188,
              "y": 34.945,
              "z": 1.395
            },
            "gtin": "7322541691770",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e948",
            "leftCorner": {
              "x": -9.188,
              "y": 34.945,
              "z": 1.395
            },
            "rightCorner": {
              "x": -9.262,
              "y": 34.949,
              "z": 1.395
            },
            "gtin": "7322541691770",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e949",
            "leftCorner": {
              "x": -9.262,
              "y": 34.949,
              "z": 1.395
            },
            "rightCorner": {
              "x": -9.336,
              "y": 34.953,
              "z": 1.395
            },
            "gtin": "7322541691770",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e94a",
            "leftCorner": {
              "x": -9.336,
              "y": 34.953,
              "z": 1.395
            },
            "rightCorner": {
              "x": -9.411,
              "y": 34.957,
              "z": 1.395
            },
            "gtin": "7322541691770",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468af",
    "rightNeighborShelfId": "468b1"
  },
  {
    "id": "468b1",
    "name": "468b1",
    "x": -9.369,
    "y": 35.012,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99963,
      "w": 0.027311
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 63
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a54659a",
        "height": 0.15963,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc22",
            "leftCorner": {
              "x": -9.435,
              "y": 34.974,
              "z": 0.131
            },
            "rightCorner": {
              "x": -9.539,
              "y": 34.979,
              "z": 0.131
            },
            "gtin": "4337185384660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc23",
            "leftCorner": {
              "x": -9.539,
              "y": 34.979,
              "z": 0.131
            },
            "rightCorner": {
              "x": -9.643,
              "y": 34.985,
              "z": 0.131
            },
            "gtin": "4337185384660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc24",
            "leftCorner": {
              "x": -9.643,
              "y": 34.989,
              "z": 0.131
            },
            "rightCorner": {
              "x": -10.153,
              "y": 35.018,
              "z": 0.131
            },
            "gtin": "4063367272974",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc25",
            "leftCorner": {
              "x": -10.153,
              "y": 35.018,
              "z": 0.131
            },
            "rightCorner": {
              "x": -10.665,
              "y": 35.045,
              "z": 0.131
            },
            "gtin": "4063367272974",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54659f",
        "height": 0.49544,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc7b",
            "leftCorner": {
              "x": -9.541,
              "y": 34.977,
              "z": 0.405
            },
            "rightCorner": {
              "x": -9.636,
              "y": 34.982,
              "z": 0.405
            },
            "gtin": "4337185384684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc7c",
            "leftCorner": {
              "x": -9.636,
              "y": 34.982,
              "z": 0.405
            },
            "rightCorner": {
              "x": -9.732,
              "y": 34.988,
              "z": 0.405
            },
            "gtin": "4337185384684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc7d",
            "leftCorner": {
              "x": -9.732,
              "y": 34.988,
              "z": 0.405
            },
            "rightCorner": {
              "x": -9.826,
              "y": 34.992,
              "z": 0.405
            },
            "gtin": "4337185384684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc7e",
            "leftCorner": {
              "x": -9.826,
              "y": 34.992,
              "z": 0.405
            },
            "rightCorner": {
              "x": -9.921,
              "y": 34.998,
              "z": 0.405
            },
            "gtin": "4337185384684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc7f",
            "leftCorner": {
              "x": -9.922,
              "y": 34.98,
              "z": 0.405
            },
            "rightCorner": {
              "x": -10.174,
              "y": 34.994,
              "z": 0.405
            },
            "gtin": "4046871004149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc80",
            "leftCorner": {
              "x": -10.174,
              "y": 34.994,
              "z": 0.405
            },
            "rightCorner": {
              "x": -10.425,
              "y": 35.007,
              "z": 0.405
            },
            "gtin": "4046871004149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc81",
            "leftCorner": {
              "x": -10.425,
              "y": 35.007,
              "z": 0.405
            },
            "rightCorner": {
              "x": -10.676,
              "y": 35.021,
              "z": 0.405
            },
            "gtin": "4046871004149",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54659e",
        "height": 0.85663,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc69",
            "leftCorner": {
              "x": -9.426,
              "y": 34.959,
              "z": 0.701
            },
            "rightCorner": {
              "x": -9.757,
              "y": 34.978,
              "z": 0.701
            },
            "gtin": "4337185384608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc6a",
            "leftCorner": {
              "x": -9.757,
              "y": 34.978,
              "z": 0.701
            },
            "rightCorner": {
              "x": -10.088,
              "y": 34.996,
              "z": 0.701
            },
            "gtin": "4337185384608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc6b",
            "leftCorner": {
              "x": -10.088,
              "y": 34.996,
              "z": 0.701
            },
            "rightCorner": {
              "x": -10.419,
              "y": 35.014,
              "z": 0.701
            },
            "gtin": "4337185384608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc6c",
            "leftCorner": {
              "x": -10.418,
              "y": 35.021,
              "z": 0.701
            },
            "rightCorner": {
              "x": -10.558,
              "y": 35.028,
              "z": 0.701
            },
            "gtin": "4337185384523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc6d",
            "leftCorner": {
              "x": -10.558,
              "y": 35.028,
              "z": 0.701
            },
            "rightCorner": {
              "x": -10.697,
              "y": 35.035,
              "z": 0.701
            },
            "gtin": "4337185384523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc6e",
            "leftCorner": {
              "x": -10.697,
              "y": 35.035,
              "z": 0.701
            },
            "rightCorner": {
              "x": -10.837,
              "y": 35.044,
              "z": 0.701
            },
            "gtin": "4337185384523",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54659d",
        "height": 1.1571,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc44",
            "leftCorner": {
              "x": -9.424,
              "y": 34.969,
              "z": 0.947
            },
            "rightCorner": {
              "x": -9.593,
              "y": 34.979,
              "z": 0.947
            },
            "gtin": "3574660357783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc45",
            "leftCorner": {
              "x": -9.593,
              "y": 34.976,
              "z": 0.947
            },
            "rightCorner": {
              "x": -9.783,
              "y": 34.987,
              "z": 0.947
            },
            "gtin": "3574661587134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc46",
            "leftCorner": {
              "x": -9.782,
              "y": 34.995,
              "z": 0.947
            },
            "rightCorner": {
              "x": -9.858,
              "y": 34.999,
              "z": 0.947
            },
            "gtin": "3574661582481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc47",
            "leftCorner": {
              "x": -9.858,
              "y": 34.999,
              "z": 0.947
            },
            "rightCorner": {
              "x": -9.934,
              "y": 35.003,
              "z": 0.947
            },
            "gtin": "3574661582481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc48",
            "leftCorner": {
              "x": -9.934,
              "y": 34.995,
              "z": 0.947
            },
            "rightCorner": {
              "x": -10.004,
              "y": 34.998,
              "z": 0.947
            },
            "gtin": "3574661587110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc49",
            "leftCorner": {
              "x": -10.004,
              "y": 34.998,
              "z": 0.947
            },
            "rightCorner": {
              "x": -10.074,
              "y": 35.002,
              "z": 0.947
            },
            "gtin": "3574661587110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc4a",
            "leftCorner": {
              "x": -10.074,
              "y": 34.997,
              "z": 0.947
            },
            "rightCorner": {
              "x": -10.149,
              "y": 35.001,
              "z": 0.947
            },
            "gtin": "4001683001410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc4b",
            "leftCorner": {
              "x": -10.149,
              "y": 35.001,
              "z": 0.947
            },
            "rightCorner": {
              "x": -10.224,
              "y": 35.006,
              "z": 0.947
            },
            "gtin": "4001683001410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc4c",
            "leftCorner": {
              "x": -10.224,
              "y": 35.013,
              "z": 0.947
            },
            "rightCorner": {
              "x": -10.294,
              "y": 35.017,
              "z": 0.947
            },
            "gtin": "3574661654638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc4d",
            "leftCorner": {
              "x": -10.294,
              "y": 35.017,
              "z": 0.947
            },
            "rightCorner": {
              "x": -10.365,
              "y": 35.021,
              "z": 0.947
            },
            "gtin": "3574661654638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc4e",
            "leftCorner": {
              "x": -10.365,
              "y": 35.024,
              "z": 0.947
            },
            "rightCorner": {
              "x": -10.444,
              "y": 35.028,
              "z": 0.947
            },
            "gtin": "3574661567327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc4f",
            "leftCorner": {
              "x": -10.444,
              "y": 35.028,
              "z": 0.947
            },
            "rightCorner": {
              "x": -10.522,
              "y": 35.033,
              "z": 0.947
            },
            "gtin": "3574661567327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc50",
            "leftCorner": {
              "x": -10.522,
              "y": 35.024,
              "z": 0.947
            },
            "rightCorner": {
              "x": -10.61,
              "y": 35.028,
              "z": 0.947
            },
            "gtin": "3574661582467",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54659b",
        "height": 1.408,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fdb3",
            "leftCorner": {
              "x": -9.37,
              "y": 35.003,
              "z": 1.152
            },
            "rightCorner": {
              "x": -9.435,
              "y": 35.007,
              "z": 1.152
            },
            "gtin": "3574660235951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdb4",
            "leftCorner": {
              "x": -9.435,
              "y": 35.007,
              "z": 1.152
            },
            "rightCorner": {
              "x": -9.501,
              "y": 35.01,
              "z": 1.152
            },
            "gtin": "3574660235951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdb7",
            "leftCorner": {
              "x": -9.502,
              "y": 34.975,
              "z": 1.152
            },
            "rightCorner": {
              "x": -9.617,
              "y": 34.981,
              "z": 1.152
            },
            "gtin": "4001683001113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdb8",
            "leftCorner": {
              "x": -9.617,
              "y": 34.981,
              "z": 1.152
            },
            "rightCorner": {
              "x": -9.689,
              "y": 34.985,
              "z": 1.152
            },
            "gtin": "3574661567310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdb9",
            "leftCorner": {
              "x": -9.689,
              "y": 34.985,
              "z": 1.152
            },
            "rightCorner": {
              "x": -9.761,
              "y": 34.988,
              "z": 1.152
            },
            "gtin": "3574661567310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdba",
            "leftCorner": {
              "x": -9.76,
              "y": 34.996,
              "z": 1.152
            },
            "rightCorner": {
              "x": -9.827,
              "y": 35.0,
              "z": 1.152
            },
            "gtin": "3574661582474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdbb",
            "leftCorner": {
              "x": -9.827,
              "y": 35.0,
              "z": 1.152
            },
            "rightCorner": {
              "x": -9.893,
              "y": 35.003,
              "z": 1.152
            },
            "gtin": "3574661582474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdbc",
            "leftCorner": {
              "x": -9.893,
              "y": 35.003,
              "z": 1.152
            },
            "rightCorner": {
              "x": -9.959,
              "y": 35.007,
              "z": 1.152
            },
            "gtin": "3574661582474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdbd",
            "leftCorner": {
              "x": -9.96,
              "y": 34.992,
              "z": 1.152
            },
            "rightCorner": {
              "x": -10.082,
              "y": 34.998,
              "z": 1.152
            },
            "gtin": "3574661577845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdbe",
            "leftCorner": {
              "x": -10.081,
              "y": 35.002,
              "z": 1.152
            },
            "rightCorner": {
              "x": -10.141,
              "y": 35.005,
              "z": 1.152
            },
            "gtin": "3574661577869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdbf",
            "leftCorner": {
              "x": -10.141,
              "y": 35.005,
              "z": 1.152
            },
            "rightCorner": {
              "x": -10.201,
              "y": 35.009,
              "z": 1.152
            },
            "gtin": "3574661577869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdc0",
            "leftCorner": {
              "x": -10.201,
              "y": 35.013,
              "z": 1.152
            },
            "rightCorner": {
              "x": -10.25,
              "y": 35.015,
              "z": 1.152
            },
            "gtin": "4001683011426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdc1",
            "leftCorner": {
              "x": -10.25,
              "y": 35.015,
              "z": 1.152
            },
            "rightCorner": {
              "x": -10.298,
              "y": 35.018,
              "z": 1.152
            },
            "gtin": "4001683011426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdc2",
            "leftCorner": {
              "x": -10.299,
              "y": 35.012,
              "z": 1.152
            },
            "rightCorner": {
              "x": -10.351,
              "y": 35.016,
              "z": 1.152
            },
            "gtin": "3574660235982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdc3",
            "leftCorner": {
              "x": -10.351,
              "y": 35.016,
              "z": 1.152
            },
            "rightCorner": {
              "x": -10.403,
              "y": 35.019,
              "z": 1.152
            },
            "gtin": "3574660235982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdc4",
            "leftCorner": {
              "x": -10.402,
              "y": 35.025,
              "z": 1.152
            },
            "rightCorner": {
              "x": -10.458,
              "y": 35.028,
              "z": 1.152
            },
            "gtin": "3574661654614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdc5",
            "leftCorner": {
              "x": -10.458,
              "y": 35.028,
              "z": 1.152
            },
            "rightCorner": {
              "x": -10.513,
              "y": 35.031,
              "z": 1.152
            },
            "gtin": "3574661654614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdb5",
            "leftCorner": {
              "x": -10.513,
              "y": 35.024,
              "z": 1.152
            },
            "rightCorner": {
              "x": -10.567,
              "y": 35.027,
              "z": 1.152
            },
            "gtin": "3574661732459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdb6",
            "leftCorner": {
              "x": -10.567,
              "y": 35.027,
              "z": 1.152
            },
            "rightCorner": {
              "x": -10.62,
              "y": 35.031,
              "z": 1.152
            },
            "gtin": "3574661732459",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54659c",
        "height": 1.7097,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e94b",
            "leftCorner": {
              "x": -9.41,
              "y": 34.965,
              "z": 1.399
            },
            "rightCorner": {
              "x": -9.503,
              "y": 34.97,
              "z": 1.399
            },
            "gtin": "7322540887648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e94c",
            "leftCorner": {
              "x": -9.503,
              "y": 34.97,
              "z": 1.399
            },
            "rightCorner": {
              "x": -9.595,
              "y": 34.975,
              "z": 1.399
            },
            "gtin": "7322540887648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e94d",
            "leftCorner": {
              "x": -9.595,
              "y": 34.975,
              "z": 1.399
            },
            "rightCorner": {
              "x": -9.687,
              "y": 34.98,
              "z": 1.399
            },
            "gtin": "7322540887648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e94e",
            "leftCorner": {
              "x": -9.687,
              "y": 34.98,
              "z": 1.399
            },
            "rightCorner": {
              "x": -9.78,
              "y": 34.985,
              "z": 1.399
            },
            "gtin": "7322540887648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e94f",
            "leftCorner": {
              "x": -9.78,
              "y": 34.987,
              "z": 1.399
            },
            "rightCorner": {
              "x": -9.987,
              "y": 34.999,
              "z": 1.399
            },
            "gtin": "7322540887624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e950",
            "leftCorner": {
              "x": -9.986,
              "y": 35.001,
              "z": 1.399
            },
            "rightCorner": {
              "x": -10.073,
              "y": 35.005,
              "z": 1.399
            },
            "gtin": "7322541679693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e951",
            "leftCorner": {
              "x": -10.073,
              "y": 35.005,
              "z": 1.399
            },
            "rightCorner": {
              "x": -10.158,
              "y": 35.01,
              "z": 1.399
            },
            "gtin": "7322541679693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e952",
            "leftCorner": {
              "x": -10.158,
              "y": 35.01,
              "z": 1.399
            },
            "rightCorner": {
              "x": -10.244,
              "y": 35.014,
              "z": 1.399
            },
            "gtin": "7322541679693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e953",
            "leftCorner": {
              "x": -10.244,
              "y": 35.014,
              "z": 1.399
            },
            "rightCorner": {
              "x": -10.33,
              "y": 35.019,
              "z": 1.399
            },
            "gtin": "7322541679693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e954",
            "leftCorner": {
              "x": -10.33,
              "y": 35.019,
              "z": 1.399
            },
            "rightCorner": {
              "x": -10.416,
              "y": 35.023,
              "z": 1.399
            },
            "gtin": "7322541679693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e955",
            "leftCorner": {
              "x": -10.416,
              "y": 35.016,
              "z": 1.399
            },
            "rightCorner": {
              "x": -10.464,
              "y": 35.019,
              "z": 1.399
            },
            "gtin": "7322541679853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e956",
            "leftCorner": {
              "x": -10.464,
              "y": 35.019,
              "z": 1.399
            },
            "rightCorner": {
              "x": -10.512,
              "y": 35.022,
              "z": 1.399
            },
            "gtin": "7322541679853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e957",
            "leftCorner": {
              "x": -10.512,
              "y": 35.022,
              "z": 1.399
            },
            "rightCorner": {
              "x": -10.561,
              "y": 35.025,
              "z": 1.399
            },
            "gtin": "7322541679853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e958",
            "leftCorner": {
              "x": -10.561,
              "y": 35.025,
              "z": 1.399
            },
            "rightCorner": {
              "x": -10.609,
              "y": 35.027,
              "z": 1.399
            },
            "gtin": "7322541679853",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468b0",
    "rightNeighborShelfId": "468b2"
  },
  {
    "id": "468b2",
    "name": "468b2",
    "x": -10.617,
    "y": 35.08,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99963,
      "w": 0.027311
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 66
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5465a3",
        "height": 0.15815,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc10",
            "leftCorner": {
              "x": -10.666,
              "y": 35.027,
              "z": 0.129
            },
            "rightCorner": {
              "x": -11.067,
              "y": 35.049,
              "z": 0.129
            },
            "gtin": "4337185384745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc11",
            "leftCorner": {
              "x": -11.067,
              "y": 35.049,
              "z": 0.129
            },
            "rightCorner": {
              "x": -11.468,
              "y": 35.071,
              "z": 0.129
            },
            "gtin": "4337185384745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc12",
            "leftCorner": {
              "x": -11.468,
              "y": 35.071,
              "z": 0.129
            },
            "rightCorner": {
              "x": -11.869,
              "y": 35.093,
              "z": 0.129
            },
            "gtin": "4337185384745",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465a2",
        "height": 0.50087,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc76",
            "leftCorner": {
              "x": -10.675,
              "y": 35.045,
              "z": 0.41
            },
            "rightCorner": {
              "x": -11.072,
              "y": 35.067,
              "z": 0.41
            },
            "gtin": "4046871009908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc77",
            "leftCorner": {
              "x": -11.072,
              "y": 35.067,
              "z": 0.41
            },
            "rightCorner": {
              "x": -11.47,
              "y": 35.089,
              "z": 0.41
            },
            "gtin": "4046871009908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc78",
            "leftCorner": {
              "x": -11.47,
              "y": 35.089,
              "z": 0.41
            },
            "rightCorner": {
              "x": -11.868,
              "y": 35.11,
              "z": 0.41
            },
            "gtin": "4046871009908",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465a5",
        "height": 0.86311,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc6f",
            "leftCorner": {
              "x": -10.838,
              "y": 35.037,
              "z": 0.706
            },
            "rightCorner": {
              "x": -11.147,
              "y": 35.054,
              "z": 0.706
            },
            "gtin": "4337185384547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc70",
            "leftCorner": {
              "x": -11.147,
              "y": 35.054,
              "z": 0.706
            },
            "rightCorner": {
              "x": -11.457,
              "y": 35.071,
              "z": 0.706
            },
            "gtin": "4337185384547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc71",
            "leftCorner": {
              "x": -11.458,
              "y": 35.065,
              "z": 0.706
            },
            "rightCorner": {
              "x": -11.54,
              "y": 35.07,
              "z": 0.706
            },
            "gtin": "4337185384509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc72",
            "leftCorner": {
              "x": -11.54,
              "y": 35.07,
              "z": 0.706
            },
            "rightCorner": {
              "x": -11.623,
              "y": 35.074,
              "z": 0.706
            },
            "gtin": "4337185384509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc64",
            "leftCorner": {
              "x": -11.623,
              "y": 35.084,
              "z": 0.706
            },
            "rightCorner": {
              "x": -11.684,
              "y": 35.088,
              "z": 0.706
            },
            "gtin": "4337185384561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc65",
            "leftCorner": {
              "x": -11.684,
              "y": 35.088,
              "z": 0.706
            },
            "rightCorner": {
              "x": -11.746,
              "y": 35.091,
              "z": 0.706
            },
            "gtin": "4337185384561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc66",
            "leftCorner": {
              "x": -11.746,
              "y": 35.091,
              "z": 0.706
            },
            "rightCorner": {
              "x": -11.807,
              "y": 35.095,
              "z": 0.706
            },
            "gtin": "4337185384561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc67",
            "leftCorner": {
              "x": -11.807,
              "y": 35.095,
              "z": 0.706
            },
            "rightCorner": {
              "x": -11.868,
              "y": 35.098,
              "z": 0.706
            },
            "gtin": "4337185384561",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465a1",
        "height": 1.1568,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc51",
            "leftCorner": {
              "x": -10.61,
              "y": 35.034,
              "z": 0.946
            },
            "rightCorner": {
              "x": -10.679,
              "y": 35.038,
              "z": 0.946
            },
            "gtin": "3574661591667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc52",
            "leftCorner": {
              "x": -10.679,
              "y": 35.038,
              "z": 0.946
            },
            "rightCorner": {
              "x": -10.75,
              "y": 35.042,
              "z": 0.946
            },
            "gtin": "3574661591667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc53",
            "leftCorner": {
              "x": -10.75,
              "y": 35.045,
              "z": 0.946
            },
            "rightCorner": {
              "x": -10.895,
              "y": 35.053,
              "z": 0.946
            },
            "gtin": "3574661577852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc54",
            "leftCorner": {
              "x": -10.895,
              "y": 35.053,
              "z": 0.946
            },
            "rightCorner": {
              "x": -10.942,
              "y": 35.056,
              "z": 0.946
            },
            "gtin": "3574661591674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc55",
            "leftCorner": {
              "x": -10.942,
              "y": 35.056,
              "z": 0.946
            },
            "rightCorner": {
              "x": -10.989,
              "y": 35.058,
              "z": 0.946
            },
            "gtin": "3574661591674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc56",
            "leftCorner": {
              "x": -10.989,
              "y": 35.058,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.035,
              "y": 35.06,
              "z": 0.946
            },
            "gtin": "3574661591674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc57",
            "leftCorner": {
              "x": -11.035,
              "y": 35.056,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.082,
              "y": 35.059,
              "z": 0.946
            },
            "gtin": "4001683001137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc58",
            "leftCorner": {
              "x": -11.082,
              "y": 35.059,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.128,
              "y": 35.062,
              "z": 0.946
            },
            "gtin": "4001683001137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc59",
            "leftCorner": {
              "x": -11.128,
              "y": 35.062,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.173,
              "y": 35.064,
              "z": 0.946
            },
            "gtin": "4001683001137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc5a",
            "leftCorner": {
              "x": -11.174,
              "y": 35.059,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.261,
              "y": 35.064,
              "z": 0.946
            },
            "gtin": "4001669090131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc5b",
            "leftCorner": {
              "x": -11.261,
              "y": 35.072,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.335,
              "y": 35.076,
              "z": 0.946
            },
            "gtin": "4008491127998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc5c",
            "leftCorner": {
              "x": -11.333,
              "y": 35.099,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.389,
              "y": 35.101,
              "z": 0.946
            },
            "gtin": "4008491119740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc5d",
            "leftCorner": {
              "x": -11.389,
              "y": 35.101,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.445,
              "y": 35.105,
              "z": 0.946
            },
            "gtin": "4008491119740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc5e",
            "leftCorner": {
              "x": -11.445,
              "y": 35.104,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.554,
              "y": 35.109,
              "z": 0.946
            },
            "gtin": "4009932131093",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc5f",
            "leftCorner": {
              "x": -11.555,
              "y": 35.094,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.61,
              "y": 35.098,
              "z": 0.946
            },
            "gtin": "9120044181990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc60",
            "leftCorner": {
              "x": -11.61,
              "y": 35.098,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.664,
              "y": 35.101,
              "z": 0.946
            },
            "gtin": "9120044181990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc61",
            "leftCorner": {
              "x": -11.664,
              "y": 35.096,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.721,
              "y": 35.099,
              "z": 0.946
            },
            "gtin": "9120044182072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc62",
            "leftCorner": {
              "x": -11.721,
              "y": 35.099,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.779,
              "y": 35.103,
              "z": 0.946
            },
            "gtin": "9120044182072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc42",
            "leftCorner": {
              "x": -11.779,
              "y": 35.098,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.823,
              "y": 35.101,
              "z": 0.946
            },
            "gtin": "9120044182355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc43",
            "leftCorner": {
              "x": -11.823,
              "y": 35.101,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.868,
              "y": 35.102,
              "z": 0.946
            },
            "gtin": "9120044182355",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465a4",
        "height": 1.4531,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fdc6",
            "leftCorner": {
              "x": -10.617,
              "y": 35.073,
              "z": 1.189
            },
            "rightCorner": {
              "x": -10.679,
              "y": 35.077,
              "z": 1.189
            },
            "gtin": "4260348610019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdc7",
            "leftCorner": {
              "x": -10.679,
              "y": 35.077,
              "z": 1.189
            },
            "rightCorner": {
              "x": -10.741,
              "y": 35.08,
              "z": 1.189
            },
            "gtin": "4260348610019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdc8",
            "leftCorner": {
              "x": -10.741,
              "y": 35.08,
              "z": 1.189
            },
            "rightCorner": {
              "x": -10.802,
              "y": 35.083,
              "z": 1.189
            },
            "gtin": "4260348610019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdca",
            "leftCorner": {
              "x": -10.804,
              "y": 35.053,
              "z": 1.189
            },
            "rightCorner": {
              "x": -10.923,
              "y": 35.059,
              "z": 1.189
            },
            "gtin": "9005365004374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdcb",
            "leftCorner": {
              "x": -10.924,
              "y": 35.049,
              "z": 1.189
            },
            "rightCorner": {
              "x": -11.062,
              "y": 35.057,
              "z": 1.189
            },
            "gtin": "8001090643216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdcc",
            "leftCorner": {
              "x": -11.062,
              "y": 35.057,
              "z": 1.189
            },
            "rightCorner": {
              "x": -11.2,
              "y": 35.063,
              "z": 1.189
            },
            "gtin": "8001090643216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdcd",
            "leftCorner": {
              "x": -11.2,
              "y": 35.064,
              "z": 1.189
            },
            "rightCorner": {
              "x": -11.288,
              "y": 35.069,
              "z": 1.189
            },
            "gtin": "4015600522315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdce",
            "leftCorner": {
              "x": -11.288,
              "y": 35.069,
              "z": 1.189
            },
            "rightCorner": {
              "x": -11.374,
              "y": 35.074,
              "z": 1.189
            },
            "gtin": "4015600522315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdcf",
            "leftCorner": {
              "x": -11.374,
              "y": 35.074,
              "z": 1.189
            },
            "rightCorner": {
              "x": -11.462,
              "y": 35.078,
              "z": 1.189
            },
            "gtin": "4015600522315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdd0",
            "leftCorner": {
              "x": -11.461,
              "y": 35.079,
              "z": 1.189
            },
            "rightCorner": {
              "x": -11.543,
              "y": 35.084,
              "z": 1.189
            },
            "gtin": "8700216517829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdd1",
            "leftCorner": {
              "x": -11.541,
              "y": 35.1,
              "z": 1.189
            },
            "rightCorner": {
              "x": -11.601,
              "y": 35.103,
              "z": 1.189
            },
            "gtin": "9005365004213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdd2",
            "leftCorner": {
              "x": -11.601,
              "y": 35.103,
              "z": 1.189
            },
            "rightCorner": {
              "x": -11.662,
              "y": 35.107,
              "z": 1.189
            },
            "gtin": "9005365004213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdd3",
            "leftCorner": {
              "x": -11.662,
              "y": 35.094,
              "z": 1.189
            },
            "rightCorner": {
              "x": -11.786,
              "y": 35.1,
              "z": 1.189
            },
            "gtin": "9005365004336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdc9",
            "leftCorner": {
              "x": -11.786,
              "y": 35.107,
              "z": 1.189
            },
            "rightCorner": {
              "x": -11.868,
              "y": 35.111,
              "z": 1.189
            },
            "gtin": "4260457778433",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465a0",
        "height": 1.7087,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e959",
            "leftCorner": {
              "x": -10.607,
              "y": 35.054,
              "z": 1.398
            },
            "rightCorner": {
              "x": -10.69,
              "y": 35.058,
              "z": 1.398
            },
            "gtin": "4045612009139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e95a",
            "leftCorner": {
              "x": -10.69,
              "y": 35.046,
              "z": 1.398
            },
            "rightCorner": {
              "x": -10.808,
              "y": 35.053,
              "z": 1.398
            },
            "gtin": "4005808019588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e95b",
            "leftCorner": {
              "x": -10.808,
              "y": 35.046,
              "z": 1.398
            },
            "rightCorner": {
              "x": -10.85,
              "y": 35.048,
              "z": 1.398
            },
            "gtin": "4005900216878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e95c",
            "leftCorner": {
              "x": -10.85,
              "y": 35.048,
              "z": 1.398
            },
            "rightCorner": {
              "x": -10.892,
              "y": 35.051,
              "z": 1.398
            },
            "gtin": "4005900216878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e95d",
            "leftCorner": {
              "x": -10.892,
              "y": 35.052,
              "z": 1.398
            },
            "rightCorner": {
              "x": -10.945,
              "y": 35.055,
              "z": 1.398
            },
            "gtin": "5010934005205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e95e",
            "leftCorner": {
              "x": -10.945,
              "y": 35.055,
              "z": 1.398
            },
            "rightCorner": {
              "x": -10.998,
              "y": 35.057,
              "z": 1.398
            },
            "gtin": "5010934005205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e95f",
            "leftCorner": {
              "x": -10.999,
              "y": 35.05,
              "z": 1.398
            },
            "rightCorner": {
              "x": -11.065,
              "y": 35.053,
              "z": 1.398
            },
            "gtin": "8700216193498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e960",
            "leftCorner": {
              "x": -11.065,
              "y": 35.063,
              "z": 1.398
            },
            "rightCorner": {
              "x": -11.142,
              "y": 35.067,
              "z": 1.398
            },
            "gtin": "4103040047120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e961",
            "leftCorner": {
              "x": -11.141,
              "y": 35.075,
              "z": 1.398
            },
            "rightCorner": {
              "x": -11.2,
              "y": 35.078,
              "z": 1.398
            },
            "gtin": "5010934003416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e962",
            "leftCorner": {
              "x": -11.2,
              "y": 35.078,
              "z": 1.398
            },
            "rightCorner": {
              "x": -11.259,
              "y": 35.081,
              "z": 1.398
            },
            "gtin": "5010934003416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e963",
            "leftCorner": {
              "x": -11.26,
              "y": 35.072,
              "z": 1.398
            },
            "rightCorner": {
              "x": -11.418,
              "y": 35.081,
              "z": 1.398
            },
            "gtin": "4251758417459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e964",
            "leftCorner": {
              "x": -11.418,
              "y": 35.077,
              "z": 1.398
            },
            "rightCorner": {
              "x": -11.474,
              "y": 35.079,
              "z": 1.398
            },
            "gtin": "4063367020209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e965",
            "leftCorner": {
              "x": -11.474,
              "y": 35.079,
              "z": 1.398
            },
            "rightCorner": {
              "x": -11.529,
              "y": 35.082,
              "z": 1.398
            },
            "gtin": "4063367020209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e966",
            "leftCorner": {
              "x": -11.529,
              "y": 35.089,
              "z": 1.398
            },
            "rightCorner": {
              "x": -11.609,
              "y": 35.094,
              "z": 1.398
            },
            "gtin": "4003583217366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e967",
            "leftCorner": {
              "x": -11.609,
              "y": 35.094,
              "z": 1.398
            },
            "rightCorner": {
              "x": -11.688,
              "y": 35.098,
              "z": 1.398
            },
            "gtin": "4003583217366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e968",
            "leftCorner": {
              "x": -11.688,
              "y": 35.101,
              "z": 1.398
            },
            "rightCorner": {
              "x": -11.757,
              "y": 35.105,
              "z": 1.398
            },
            "gtin": "4003583217380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e969",
            "leftCorner": {
              "x": -11.757,
              "y": 35.105,
              "z": 1.398
            },
            "rightCorner": {
              "x": -11.825,
              "y": 35.109,
              "z": 1.398
            },
            "gtin": "4003583217380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e908",
            "leftCorner": {
              "x": -11.825,
              "y": 35.106,
              "z": 1.398
            },
            "rightCorner": {
              "x": -11.868,
              "y": 35.108,
              "z": 1.398
            },
            "gtin": "4260058866386",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468b1"
  },
  {
    "id": "468b3",
    "name": "468b3",
    "x": -10.595,
    "y": 33.934,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.029335,
      "w": 0.99957
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 61
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5465b1",
        "height": 0.17525,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1fee6",
            "leftCorner": {
              "x": -9.836,
              "y": 33.932,
              "z": 0.143
            },
            "rightCorner": {
              "x": -9.753,
              "y": 33.928,
              "z": 0.143
            },
            "gtin": "4000851013934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fee7",
            "leftCorner": {
              "x": -9.753,
              "y": 33.928,
              "z": 0.143
            },
            "rightCorner": {
              "x": -9.67,
              "y": 33.923,
              "z": 0.143
            },
            "gtin": "4000851013934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fee8",
            "leftCorner": {
              "x": -9.669,
              "y": 33.929,
              "z": 0.143
            },
            "rightCorner": {
              "x": -9.346,
              "y": 33.909,
              "z": 0.143
            },
            "gtin": "42397694",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465ae",
        "height": 0.41922,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1ff32",
            "leftCorner": {
              "x": -10.586,
              "y": 34.086,
              "z": 0.343
            },
            "rightCorner": {
              "x": -10.498,
              "y": 34.081,
              "z": 0.343
            },
            "gtin": "3574661687025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff33",
            "leftCorner": {
              "x": -10.498,
              "y": 34.081,
              "z": 0.343
            },
            "rightCorner": {
              "x": -10.41,
              "y": 34.075,
              "z": 0.343
            },
            "gtin": "3574661687025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff36",
            "leftCorner": {
              "x": -10.408,
              "y": 34.115,
              "z": 0.343
            },
            "rightCorner": {
              "x": -10.306,
              "y": 34.11,
              "z": 0.343
            },
            "gtin": "4000196031198",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff37",
            "leftCorner": {
              "x": -10.306,
              "y": 34.11,
              "z": 0.343
            },
            "rightCorner": {
              "x": -10.204,
              "y": 34.104,
              "z": 0.343
            },
            "gtin": "4000196031198",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff38",
            "leftCorner": {
              "x": -10.204,
              "y": 34.104,
              "z": 0.343
            },
            "rightCorner": {
              "x": -10.102,
              "y": 34.098,
              "z": 0.343
            },
            "gtin": "4000196031198",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff39",
            "leftCorner": {
              "x": -10.103,
              "y": 34.085,
              "z": 0.343
            },
            "rightCorner": {
              "x": -9.82,
              "y": 34.069,
              "z": 0.343
            },
            "gtin": "42417309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff3a",
            "leftCorner": {
              "x": -9.819,
              "y": 34.084,
              "z": 0.343
            },
            "rightCorner": {
              "x": -9.741,
              "y": 34.079,
              "z": 0.343
            },
            "gtin": "42429784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff3b",
            "leftCorner": {
              "x": -9.741,
              "y": 34.079,
              "z": 0.343
            },
            "rightCorner": {
              "x": -9.663,
              "y": 34.075,
              "z": 0.343
            },
            "gtin": "42429784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff3c",
            "leftCorner": {
              "x": -9.663,
              "y": 34.072,
              "z": 0.343
            },
            "rightCorner": {
              "x": -9.585,
              "y": 34.067,
              "z": 0.343
            },
            "gtin": "5054563126283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff3d",
            "leftCorner": {
              "x": -9.585,
              "y": 34.067,
              "z": 0.343
            },
            "rightCorner": {
              "x": -9.507,
              "y": 34.063,
              "z": 0.343
            },
            "gtin": "5054563126283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff3e",
            "leftCorner": {
              "x": -9.507,
              "y": 34.061,
              "z": 0.343
            },
            "rightCorner": {
              "x": -9.421,
              "y": 34.056,
              "z": 0.343
            },
            "gtin": "4007965133800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff3f",
            "leftCorner": {
              "x": -9.421,
              "y": 34.056,
              "z": 0.343
            },
            "rightCorner": {
              "x": -9.335,
              "y": 34.051,
              "z": 0.343
            },
            "gtin": "4007965133800",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465b0",
        "height": 0.7206,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1fe9f",
            "leftCorner": {
              "x": -10.591,
              "y": 34.112,
              "z": 0.59
            },
            "rightCorner": {
              "x": -10.508,
              "y": 34.107,
              "z": 0.59
            },
            "gtin": "5054563093394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fea0",
            "leftCorner": {
              "x": -10.508,
              "y": 34.107,
              "z": 0.59
            },
            "rightCorner": {
              "x": -10.425,
              "y": 34.103,
              "z": 0.59
            },
            "gtin": "5054563093394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fea1",
            "leftCorner": {
              "x": -10.425,
              "y": 34.111,
              "z": 0.59
            },
            "rightCorner": {
              "x": -10.365,
              "y": 34.107,
              "z": 0.59
            },
            "gtin": "8718951313767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fea2",
            "leftCorner": {
              "x": -10.365,
              "y": 34.107,
              "z": 0.59
            },
            "rightCorner": {
              "x": -10.303,
              "y": 34.103,
              "z": 0.59
            },
            "gtin": "8718951313767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fea3",
            "leftCorner": {
              "x": -10.303,
              "y": 34.103,
              "z": 0.59
            },
            "rightCorner": {
              "x": -10.243,
              "y": 34.1,
              "z": 0.59
            },
            "gtin": "8718951313767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fea4",
            "leftCorner": {
              "x": -10.243,
              "y": 34.099,
              "z": 0.59
            },
            "rightCorner": {
              "x": -10.154,
              "y": 34.094,
              "z": 0.59
            },
            "gtin": "59097785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fea5",
            "leftCorner": {
              "x": -10.154,
              "y": 34.094,
              "z": 0.59
            },
            "rightCorner": {
              "x": -10.065,
              "y": 34.089,
              "z": 0.59
            },
            "gtin": "59097785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fea6",
            "leftCorner": {
              "x": -10.065,
              "y": 34.075,
              "z": 0.59
            },
            "rightCorner": {
              "x": -9.989,
              "y": 34.069,
              "z": 0.59
            },
            "gtin": "59097662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fea7",
            "leftCorner": {
              "x": -9.989,
              "y": 34.069,
              "z": 0.59
            },
            "rightCorner": {
              "x": -9.913,
              "y": 34.065,
              "z": 0.59
            },
            "gtin": "59097662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fea8",
            "leftCorner": {
              "x": -9.914,
              "y": 34.075,
              "z": 0.59
            },
            "rightCorner": {
              "x": -9.843,
              "y": 34.071,
              "z": 0.59
            },
            "gtin": "40726830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fea9",
            "leftCorner": {
              "x": -9.843,
              "y": 34.071,
              "z": 0.59
            },
            "rightCorner": {
              "x": -9.773,
              "y": 34.067,
              "z": 0.59
            },
            "gtin": "40726830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feaa",
            "leftCorner": {
              "x": -9.773,
              "y": 34.074,
              "z": 0.59
            },
            "rightCorner": {
              "x": -9.624,
              "y": 34.066,
              "z": 0.59
            },
            "gtin": "40726526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feab",
            "leftCorner": {
              "x": -9.624,
              "y": 34.067,
              "z": 0.59
            },
            "rightCorner": {
              "x": -9.54,
              "y": 34.062,
              "z": 0.59
            },
            "gtin": "40726366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feac",
            "leftCorner": {
              "x": -9.54,
              "y": 34.062,
              "z": 0.59
            },
            "rightCorner": {
              "x": -9.455,
              "y": 34.057,
              "z": 0.59
            },
            "gtin": "40726366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fead",
            "leftCorner": {
              "x": -9.456,
              "y": 34.05,
              "z": 0.59
            },
            "rightCorner": {
              "x": -9.382,
              "y": 34.046,
              "z": 0.59
            },
            "gtin": "4027800318209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feae",
            "leftCorner": {
              "x": -9.382,
              "y": 34.046,
              "z": 0.59
            },
            "rightCorner": {
              "x": -9.309,
              "y": 34.042,
              "z": 0.59
            },
            "gtin": "4027800318209",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465ad",
        "height": 0.98267,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1fec9",
            "leftCorner": {
              "x": -10.579,
              "y": 34.108,
              "z": 0.804
            },
            "rightCorner": {
              "x": -10.497,
              "y": 34.104,
              "z": 0.804
            },
            "gtin": "7610099050058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feca",
            "leftCorner": {
              "x": -10.497,
              "y": 34.104,
              "z": 0.804
            },
            "rightCorner": {
              "x": -10.416,
              "y": 34.099,
              "z": 0.804
            },
            "gtin": "7610099050058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fecb",
            "leftCorner": {
              "x": -10.416,
              "y": 34.1,
              "z": 0.804
            },
            "rightCorner": {
              "x": -10.281,
              "y": 34.092,
              "z": 0.804
            },
            "gtin": "42389590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fecc",
            "leftCorner": {
              "x": -10.281,
              "y": 34.092,
              "z": 0.804
            },
            "rightCorner": {
              "x": -10.146,
              "y": 34.083,
              "z": 0.804
            },
            "gtin": "42389590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fecd",
            "leftCorner": {
              "x": -10.146,
              "y": 34.083,
              "z": 0.804
            },
            "rightCorner": {
              "x": -10.012,
              "y": 34.076,
              "z": 0.804
            },
            "gtin": "42389590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fece",
            "leftCorner": {
              "x": -10.012,
              "y": 34.069,
              "z": 0.804
            },
            "rightCorner": {
              "x": -9.926,
              "y": 34.064,
              "z": 0.804
            },
            "gtin": "4987072057971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fecf",
            "leftCorner": {
              "x": -9.926,
              "y": 34.064,
              "z": 0.804
            },
            "rightCorner": {
              "x": -9.841,
              "y": 34.059,
              "z": 0.804
            },
            "gtin": "4987072057971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fed0",
            "leftCorner": {
              "x": -9.841,
              "y": 34.059,
              "z": 0.804
            },
            "rightCorner": {
              "x": -9.755,
              "y": 34.054,
              "z": 0.804
            },
            "gtin": "4987072057971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fed1",
            "leftCorner": {
              "x": -9.755,
              "y": 34.054,
              "z": 0.804
            },
            "rightCorner": {
              "x": -9.669,
              "y": 34.049,
              "z": 0.804
            },
            "gtin": "4987072057971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fed2",
            "leftCorner": {
              "x": -9.668,
              "y": 34.06,
              "z": 0.804
            },
            "rightCorner": {
              "x": -9.583,
              "y": 34.055,
              "z": 0.804
            },
            "gtin": "4103040616012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fed3",
            "leftCorner": {
              "x": -9.583,
              "y": 34.055,
              "z": 0.804
            },
            "rightCorner": {
              "x": -9.497,
              "y": 34.05,
              "z": 0.804
            },
            "gtin": "4103040616012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fed4",
            "leftCorner": {
              "x": -9.496,
              "y": 34.056,
              "z": 0.804
            },
            "rightCorner": {
              "x": -9.319,
              "y": 34.046,
              "z": 0.804
            },
            "gtin": "3600524165345",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465ac",
        "height": 1.2848,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fde1",
            "leftCorner": {
              "x": -10.581,
              "y": 34.108,
              "z": 1.051
            },
            "rightCorner": {
              "x": -10.497,
              "y": 34.104,
              "z": 1.051
            },
            "gtin": "8720182847072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fde2",
            "leftCorner": {
              "x": -10.497,
              "y": 34.104,
              "z": 1.051
            },
            "rightCorner": {
              "x": -10.414,
              "y": 34.098,
              "z": 1.051
            },
            "gtin": "8720182847072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fde3",
            "leftCorner": {
              "x": -10.414,
              "y": 34.098,
              "z": 1.051
            },
            "rightCorner": {
              "x": -10.33,
              "y": 34.093,
              "z": 1.051
            },
            "gtin": "8720182847072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fde4",
            "leftCorner": {
              "x": -10.329,
              "y": 34.103,
              "z": 1.051
            },
            "rightCorner": {
              "x": -10.165,
              "y": 34.094,
              "z": 1.051
            },
            "gtin": "4063367218224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fde5",
            "leftCorner": {
              "x": -10.165,
              "y": 34.091,
              "z": 1.051
            },
            "rightCorner": {
              "x": -10.074,
              "y": 34.085,
              "z": 1.051
            },
            "gtin": "3600541182035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fde6",
            "leftCorner": {
              "x": -10.074,
              "y": 34.085,
              "z": 1.051
            },
            "rightCorner": {
              "x": -9.982,
              "y": 34.08,
              "z": 1.051
            },
            "gtin": "3600541182035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fde7",
            "leftCorner": {
              "x": -9.984,
              "y": 34.057,
              "z": 1.051
            },
            "rightCorner": {
              "x": -9.811,
              "y": 34.047,
              "z": 1.051
            },
            "gtin": "42422778",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fde8",
            "leftCorner": {
              "x": -9.811,
              "y": 34.047,
              "z": 1.051
            },
            "rightCorner": {
              "x": -9.639,
              "y": 34.037,
              "z": 1.051
            },
            "gtin": "42422778",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fde9",
            "leftCorner": {
              "x": -9.639,
              "y": 34.037,
              "z": 1.051
            },
            "rightCorner": {
              "x": -9.466,
              "y": 34.027,
              "z": 1.051
            },
            "gtin": "42422778",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdea",
            "leftCorner": {
              "x": -9.466,
              "y": 34.027,
              "z": 1.051
            },
            "rightCorner": {
              "x": -9.293,
              "y": 34.017,
              "z": 1.051
            },
            "gtin": "42422778",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465af",
        "height": 1.661,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fe11",
            "leftCorner": {
              "x": -10.541,
              "y": 34.076,
              "z": 1.359
            },
            "rightCorner": {
              "x": -9.826,
              "y": 34.034,
              "z": 1.359
            },
            "gtin": "8720182847225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe12",
            "leftCorner": {
              "x": -9.826,
              "y": 34.032,
              "z": 1.359
            },
            "rightCorner": {
              "x": -9.726,
              "y": 34.026,
              "z": 1.359
            },
            "gtin": "3616305254924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe13",
            "leftCorner": {
              "x": -9.726,
              "y": 34.024,
              "z": 1.359
            },
            "rightCorner": {
              "x": -9.573,
              "y": 34.015,
              "z": 1.359
            },
            "gtin": "5050456009534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe14",
            "leftCorner": {
              "x": -9.573,
              "y": 34.017,
              "z": 1.359
            },
            "rightCorner": {
              "x": -9.518,
              "y": 34.015,
              "z": 1.359
            },
            "gtin": "3326240055523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe15",
            "leftCorner": {
              "x": -9.518,
              "y": 34.015,
              "z": 1.359
            },
            "rightCorner": {
              "x": -9.464,
              "y": 34.011,
              "z": 1.359
            },
            "gtin": "3326240055523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe16",
            "leftCorner": {
              "x": -9.464,
              "y": 34.018,
              "z": 1.359
            },
            "rightCorner": {
              "x": -9.327,
              "y": 34.01,
              "z": 1.359
            },
            "gtin": "8411114095288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe17",
            "leftCorner": {
              "x": -9.327,
              "y": 34.01,
              "z": 1.359
            },
            "rightCorner": {
              "x": -9.19,
              "y": 34.002,
              "z": 1.359
            },
            "gtin": "8411114095288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe18",
            "leftCorner": {
              "x": -9.19,
              "y": 34.002,
              "z": 1.359
            },
            "rightCorner": {
              "x": -9.053,
              "y": 33.993,
              "z": 1.359
            },
            "gtin": "8411114095288",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "da3a2",
    "rightNeighborShelfId": "468b4"
  },
  {
    "id": "468b4",
    "name": "468b4",
    "x": -9.347,
    "y": 33.861,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.029335,
      "w": 0.99957
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 66
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5465b7",
        "height": 1.655,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fe19",
            "leftCorner": {
              "x": -9.052,
              "y": 33.988,
              "z": 1.354
            },
            "rightCorner": {
              "x": -8.973,
              "y": 33.983,
              "z": 1.354
            },
            "gtin": "3616305254665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe1a",
            "leftCorner": {
              "x": -8.973,
              "y": 33.983,
              "z": 1.354
            },
            "rightCorner": {
              "x": -8.895,
              "y": 33.978,
              "z": 1.354
            },
            "gtin": "3616305254665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe1b",
            "leftCorner": {
              "x": -8.897,
              "y": 33.954,
              "z": 1.354
            },
            "rightCorner": {
              "x": -8.797,
              "y": 33.948,
              "z": 1.354
            },
            "gtin": "3616303474089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe1c",
            "leftCorner": {
              "x": -8.797,
              "y": 33.948,
              "z": 1.354
            },
            "rightCorner": {
              "x": -8.697,
              "y": 33.943,
              "z": 1.354
            },
            "gtin": "3616303474089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe1d",
            "leftCorner": {
              "x": -8.696,
              "y": 33.959,
              "z": 1.354
            },
            "rightCorner": {
              "x": -8.551,
              "y": 33.951,
              "z": 1.354
            },
            "gtin": "4054995024998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe1e",
            "leftCorner": {
              "x": -8.551,
              "y": 33.952,
              "z": 1.354
            },
            "rightCorner": {
              "x": -8.471,
              "y": 33.947,
              "z": 1.354
            },
            "gtin": "4038033106976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe1f",
            "leftCorner": {
              "x": -8.471,
              "y": 33.945,
              "z": 1.354
            },
            "rightCorner": {
              "x": -8.397,
              "y": 33.941,
              "z": 1.354
            },
            "gtin": "4054995058597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe20",
            "leftCorner": {
              "x": -8.397,
              "y": 33.941,
              "z": 1.354
            },
            "rightCorner": {
              "x": -8.324,
              "y": 33.936,
              "z": 1.354
            },
            "gtin": "4054995058597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe21",
            "leftCorner": {
              "x": -8.324,
              "y": 33.932,
              "z": 1.354
            },
            "rightCorner": {
              "x": -8.227,
              "y": 33.927,
              "z": 1.354
            },
            "gtin": "5050456009541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe22",
            "leftCorner": {
              "x": -8.227,
              "y": 33.927,
              "z": 1.354
            },
            "rightCorner": {
              "x": -8.13,
              "y": 33.921,
              "z": 1.354
            },
            "gtin": "5050456009541",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465b5",
        "height": 1.2809,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fdec",
            "leftCorner": {
              "x": -9.22,
              "y": 34.023,
              "z": 1.048
            },
            "rightCorner": {
              "x": -9.149,
              "y": 34.018,
              "z": 1.048
            },
            "gtin": "42429166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdeb",
            "leftCorner": {
              "x": -9.291,
              "y": 34.027,
              "z": 1.048
            },
            "rightCorner": {
              "x": -9.22,
              "y": 34.023,
              "z": 1.048
            },
            "gtin": "42429166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fded",
            "leftCorner": {
              "x": -9.148,
              "y": 34.031,
              "z": 1.048
            },
            "rightCorner": {
              "x": -9.073,
              "y": 34.027,
              "z": 1.048
            },
            "gtin": "5037156288704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdee",
            "leftCorner": {
              "x": -9.073,
              "y": 34.027,
              "z": 1.048
            },
            "rightCorner": {
              "x": -8.999,
              "y": 34.023,
              "z": 1.048
            },
            "gtin": "5037156288704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdef",
            "leftCorner": {
              "x": -8.999,
              "y": 34.023,
              "z": 1.048
            },
            "rightCorner": {
              "x": -8.863,
              "y": 34.015,
              "z": 1.048
            },
            "gtin": "4002448079088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdf0",
            "leftCorner": {
              "x": -8.863,
              "y": 34.015,
              "z": 1.048
            },
            "rightCorner": {
              "x": -8.727,
              "y": 34.006,
              "z": 1.048
            },
            "gtin": "4002448079088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdf1",
            "leftCorner": {
              "x": -8.728,
              "y": 33.981,
              "z": 1.048
            },
            "rightCorner": {
              "x": -8.621,
              "y": 33.975,
              "z": 1.048
            },
            "gtin": "4895248006206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdf2",
            "leftCorner": {
              "x": -8.621,
              "y": 33.975,
              "z": 1.048
            },
            "rightCorner": {
              "x": -8.513,
              "y": 33.969,
              "z": 1.048
            },
            "gtin": "4895248006206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdf3",
            "leftCorner": {
              "x": -8.513,
              "y": 33.969,
              "z": 1.048
            },
            "rightCorner": {
              "x": -8.406,
              "y": 33.962,
              "z": 1.048
            },
            "gtin": "4895248006206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdf4",
            "leftCorner": {
              "x": -8.405,
              "y": 33.977,
              "z": 1.048
            },
            "rightCorner": {
              "x": -8.298,
              "y": 33.971,
              "z": 1.048
            },
            "gtin": "4002448128991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdf5",
            "leftCorner": {
              "x": -8.298,
              "y": 33.971,
              "z": 1.048
            },
            "rightCorner": {
              "x": -8.191,
              "y": 33.965,
              "z": 1.048
            },
            "gtin": "4002448128991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdd6",
            "leftCorner": {
              "x": -8.191,
              "y": 33.96,
              "z": 1.048
            },
            "rightCorner": {
              "x": -8.089,
              "y": 33.954,
              "z": 1.048
            },
            "gtin": "4027800383207",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465b6",
        "height": 0.17323,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1fee9",
            "leftCorner": {
              "x": -9.346,
              "y": 33.903,
              "z": 0.142
            },
            "rightCorner": {
              "x": -9.126,
              "y": 33.89,
              "z": 0.142
            },
            "gtin": "42449737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feea",
            "leftCorner": {
              "x": -9.126,
              "y": 33.89,
              "z": 0.142
            },
            "rightCorner": {
              "x": -8.907,
              "y": 33.877,
              "z": 0.142
            },
            "gtin": "42449737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feeb",
            "leftCorner": {
              "x": -8.906,
              "y": 33.89,
              "z": 0.142
            },
            "rightCorner": {
              "x": -8.686,
              "y": 33.877,
              "z": 0.142
            },
            "gtin": "42449713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feec",
            "leftCorner": {
              "x": -8.686,
              "y": 33.877,
              "z": 0.142
            },
            "rightCorner": {
              "x": -8.465,
              "y": 33.865,
              "z": 0.142
            },
            "gtin": "42449713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feed",
            "leftCorner": {
              "x": -8.466,
              "y": 33.843,
              "z": 0.142
            },
            "rightCorner": {
              "x": -8.398,
              "y": 33.839,
              "z": 0.142
            },
            "gtin": "3600542109772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feee",
            "leftCorner": {
              "x": -8.398,
              "y": 33.839,
              "z": 0.142
            },
            "rightCorner": {
              "x": -8.329,
              "y": 33.834,
              "z": 0.142
            },
            "gtin": "3600542109772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feef",
            "leftCorner": {
              "x": -8.329,
              "y": 33.834,
              "z": 0.142
            },
            "rightCorner": {
              "x": -8.26,
              "y": 33.831,
              "z": 0.142
            },
            "gtin": "3600542109772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fef0",
            "leftCorner": {
              "x": -8.26,
              "y": 33.832,
              "z": 0.142
            },
            "rightCorner": {
              "x": -8.109,
              "y": 33.823,
              "z": 0.142
            },
            "gtin": "4012758347067",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465b3",
        "height": 0.42763,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1ff40",
            "leftCorner": {
              "x": -9.334,
              "y": 34.041,
              "z": 0.35
            },
            "rightCorner": {
              "x": -9.247,
              "y": 34.035,
              "z": 0.35
            },
            "gtin": "40266114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff41",
            "leftCorner": {
              "x": -9.247,
              "y": 34.035,
              "z": 0.35
            },
            "rightCorner": {
              "x": -9.16,
              "y": 34.03,
              "z": 0.35
            },
            "gtin": "40266114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff42",
            "leftCorner": {
              "x": -9.159,
              "y": 34.044,
              "z": 0.35
            },
            "rightCorner": {
              "x": -9.082,
              "y": 34.04,
              "z": 0.35
            },
            "gtin": "3574661407258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff43",
            "leftCorner": {
              "x": -9.082,
              "y": 34.04,
              "z": 0.35
            },
            "rightCorner": {
              "x": -9.006,
              "y": 34.035,
              "z": 0.35
            },
            "gtin": "3574661407258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff44",
            "leftCorner": {
              "x": -9.006,
              "y": 34.035,
              "z": 0.35
            },
            "rightCorner": {
              "x": -8.93,
              "y": 34.031,
              "z": 0.35
            },
            "gtin": "3574661407258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff45",
            "leftCorner": {
              "x": -8.93,
              "y": 34.031,
              "z": 0.35
            },
            "rightCorner": {
              "x": -8.854,
              "y": 34.026,
              "z": 0.35
            },
            "gtin": "3574661407258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff46",
            "leftCorner": {
              "x": -8.854,
              "y": 34.023,
              "z": 0.35
            },
            "rightCorner": {
              "x": -8.657,
              "y": 34.011,
              "z": 0.35
            },
            "gtin": "3014260219949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff47",
            "leftCorner": {
              "x": -8.657,
              "y": 34.008,
              "z": 0.35
            },
            "rightCorner": {
              "x": -8.578,
              "y": 34.004,
              "z": 0.35
            },
            "gtin": "4251758413581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff48",
            "leftCorner": {
              "x": -8.578,
              "y": 34.004,
              "z": 0.35
            },
            "rightCorner": {
              "x": -8.499,
              "y": 33.999,
              "z": 0.35
            },
            "gtin": "4251758413581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff49",
            "leftCorner": {
              "x": -8.499,
              "y": 33.999,
              "z": 0.35
            },
            "rightCorner": {
              "x": -8.372,
              "y": 33.991,
              "z": 0.35
            },
            "gtin": "4007965016097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff4a",
            "leftCorner": {
              "x": -8.372,
              "y": 33.991,
              "z": 0.35
            },
            "rightCorner": {
              "x": -8.245,
              "y": 33.984,
              "z": 0.35
            },
            "gtin": "4007965016097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff34",
            "leftCorner": {
              "x": -8.245,
              "y": 33.99,
              "z": 0.35
            },
            "rightCorner": {
              "x": -8.166,
              "y": 33.985,
              "z": 0.35
            },
            "gtin": "7610108049752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff35",
            "leftCorner": {
              "x": -8.166,
              "y": 33.985,
              "z": 0.35
            },
            "rightCorner": {
              "x": -8.088,
              "y": 33.98,
              "z": 0.35
            },
            "gtin": "7610108049752",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465b4",
        "height": 0.72591,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1feaf",
            "leftCorner": {
              "x": -9.307,
              "y": 34.053,
              "z": 0.594
            },
            "rightCorner": {
              "x": -9.191,
              "y": 34.046,
              "z": 0.594
            },
            "gtin": "4063367345937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feb0",
            "leftCorner": {
              "x": -9.191,
              "y": 34.046,
              "z": 0.594
            },
            "rightCorner": {
              "x": -9.076,
              "y": 34.039,
              "z": 0.594
            },
            "gtin": "4063367345937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feb1",
            "leftCorner": {
              "x": -9.076,
              "y": 34.027,
              "z": 0.594
            },
            "rightCorner": {
              "x": -8.924,
              "y": 34.018,
              "z": 0.594
            },
            "gtin": "4895248006190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feb2",
            "leftCorner": {
              "x": -8.924,
              "y": 34.018,
              "z": 0.594
            },
            "rightCorner": {
              "x": -8.771,
              "y": 34.01,
              "z": 0.594
            },
            "gtin": "4895248006190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feb3",
            "leftCorner": {
              "x": -8.772,
              "y": 34.004,
              "z": 0.594
            },
            "rightCorner": {
              "x": -8.698,
              "y": 34.0,
              "z": 0.594
            },
            "gtin": "4036581536504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feb4",
            "leftCorner": {
              "x": -8.698,
              "y": 34.0,
              "z": 0.594
            },
            "rightCorner": {
              "x": -8.623,
              "y": 33.995,
              "z": 0.594
            },
            "gtin": "4036581536504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feb5",
            "leftCorner": {
              "x": -8.623,
              "y": 33.995,
              "z": 0.594
            },
            "rightCorner": {
              "x": -8.549,
              "y": 33.991,
              "z": 0.594
            },
            "gtin": "4036581536504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feb6",
            "leftCorner": {
              "x": -8.549,
              "y": 33.991,
              "z": 0.594
            },
            "rightCorner": {
              "x": -8.474,
              "y": 33.986,
              "z": 0.594
            },
            "gtin": "4036581536504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feb7",
            "leftCorner": {
              "x": -8.474,
              "y": 33.986,
              "z": 0.594
            },
            "rightCorner": {
              "x": -8.401,
              "y": 33.982,
              "z": 0.594
            },
            "gtin": "4036581536504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feb8",
            "leftCorner": {
              "x": -8.4,
              "y": 33.985,
              "z": 0.594
            },
            "rightCorner": {
              "x": -8.33,
              "y": 33.981,
              "z": 0.594
            },
            "gtin": "4008666211224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feb9",
            "leftCorner": {
              "x": -8.33,
              "y": 33.981,
              "z": 0.594
            },
            "rightCorner": {
              "x": -8.26,
              "y": 33.977,
              "z": 0.594
            },
            "gtin": "4008666211224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe8f",
            "leftCorner": {
              "x": -8.26,
              "y": 33.97,
              "z": 0.594
            },
            "rightCorner": {
              "x": -8.174,
              "y": 33.964,
              "z": 0.594
            },
            "gtin": "4036581536337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe90",
            "leftCorner": {
              "x": -8.174,
              "y": 33.964,
              "z": 0.594
            },
            "rightCorner": {
              "x": -8.089,
              "y": 33.959,
              "z": 0.594
            },
            "gtin": "4036581536337",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465b2",
        "height": 0.97835,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1fed5",
            "leftCorner": {
              "x": -9.319,
              "y": 34.036,
              "z": 0.8
            },
            "rightCorner": {
              "x": -9.141,
              "y": 34.025,
              "z": 0.8
            },
            "gtin": "662834510782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fed6",
            "leftCorner": {
              "x": -9.141,
              "y": 34.025,
              "z": 0.8
            },
            "rightCorner": {
              "x": -8.963,
              "y": 34.014,
              "z": 0.8
            },
            "gtin": "662834510782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fed7",
            "leftCorner": {
              "x": -8.963,
              "y": 34.014,
              "z": 0.8
            },
            "rightCorner": {
              "x": -8.785,
              "y": 34.004,
              "z": 0.8
            },
            "gtin": "662834510782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fed8",
            "leftCorner": {
              "x": -8.785,
              "y": 34.004,
              "z": 0.8
            },
            "rightCorner": {
              "x": -8.713,
              "y": 34.0,
              "z": 0.8
            },
            "gtin": "4002448017790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fed9",
            "leftCorner": {
              "x": -8.713,
              "y": 34.0,
              "z": 0.8
            },
            "rightCorner": {
              "x": -8.64,
              "y": 33.995,
              "z": 0.8
            },
            "gtin": "4002448017790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feda",
            "leftCorner": {
              "x": -8.64,
              "y": 33.995,
              "z": 0.8
            },
            "rightCorner": {
              "x": -8.568,
              "y": 33.991,
              "z": 0.8
            },
            "gtin": "4002448017790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1febe",
            "leftCorner": {
              "x": -8.569,
              "y": 33.979,
              "z": 0.8
            },
            "rightCorner": {
              "x": -8.448,
              "y": 33.972,
              "z": 0.8
            },
            "gtin": "4036581536306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1febf",
            "leftCorner": {
              "x": -8.448,
              "y": 33.972,
              "z": 0.8
            },
            "rightCorner": {
              "x": -8.329,
              "y": 33.965,
              "z": 0.8
            },
            "gtin": "4036581536306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fec0",
            "leftCorner": {
              "x": -8.329,
              "y": 33.965,
              "z": 0.8
            },
            "rightCorner": {
              "x": -8.209,
              "y": 33.959,
              "z": 0.8
            },
            "gtin": "4036581536306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fec1",
            "leftCorner": {
              "x": -8.209,
              "y": 33.959,
              "z": 0.8
            },
            "rightCorner": {
              "x": -8.089,
              "y": 33.951,
              "z": 0.8
            },
            "gtin": "4036581536306",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468b3",
    "rightNeighborShelfId": "468b5"
  },
  {
    "id": "468b5",
    "name": "468b5",
    "x": -8.099,
    "y": 33.788,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.029335,
      "w": 0.99957
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 77
    },
    "layers": [
      {
        "id": "682ffddfd15af3232a5469a8",
        "height": 1.3454,
        "facings": [
          {
            "id": "68300c895ed67a01d9a202ce",
            "leftCorner": {
              "x": -8.083,
              "y": 34.062,
              "z": 1.101
            },
            "rightCorner": {
              "x": -8.014,
              "y": 34.057,
              "z": 1.101
            },
            "gtin": "4002448100027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202d0",
            "leftCorner": {
              "x": -8.012,
              "y": 34.092,
              "z": 1.101
            },
            "rightCorner": {
              "x": -7.933,
              "y": 34.088,
              "z": 1.101
            },
            "gtin": "4002448100065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202d1",
            "leftCorner": {
              "x": -7.933,
              "y": 34.093,
              "z": 1.101
            },
            "rightCorner": {
              "x": -7.748,
              "y": 34.082,
              "z": 1.101
            },
            "gtin": "4002448099970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202d2",
            "leftCorner": {
              "x": -7.748,
              "y": 34.084,
              "z": 1.101
            },
            "rightCorner": {
              "x": -7.705,
              "y": 34.081,
              "z": 1.101
            },
            "gtin": "4002448122500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202d3",
            "leftCorner": {
              "x": -7.705,
              "y": 34.081,
              "z": 1.101
            },
            "rightCorner": {
              "x": -7.663,
              "y": 34.079,
              "z": 1.101
            },
            "gtin": "4002448122500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202d4",
            "leftCorner": {
              "x": -7.663,
              "y": 34.08,
              "z": 1.101
            },
            "rightCorner": {
              "x": -7.569,
              "y": 34.074,
              "z": 1.101
            },
            "gtin": "4002448100003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202d5",
            "leftCorner": {
              "x": -7.569,
              "y": 34.073,
              "z": 1.101
            },
            "rightCorner": {
              "x": -7.496,
              "y": 34.069,
              "z": 1.101
            },
            "gtin": "4063367218255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202d6",
            "leftCorner": {
              "x": -7.496,
              "y": 34.069,
              "z": 1.101
            },
            "rightCorner": {
              "x": -7.423,
              "y": 34.065,
              "z": 1.101
            },
            "gtin": "4063367218255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202d7",
            "leftCorner": {
              "x": -7.422,
              "y": 34.073,
              "z": 1.101
            },
            "rightCorner": {
              "x": -7.297,
              "y": 34.066,
              "z": 1.101
            },
            "gtin": "4063367263392",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202d8",
            "leftCorner": {
              "x": -7.298,
              "y": 34.048,
              "z": 1.101
            },
            "rightCorner": {
              "x": -7.223,
              "y": 34.043,
              "z": 1.101
            },
            "gtin": "4063367263521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202d9",
            "leftCorner": {
              "x": -7.222,
              "y": 34.052,
              "z": 1.101
            },
            "rightCorner": {
              "x": -7.13,
              "y": 34.047,
              "z": 1.101
            },
            "gtin": "4021457632855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202da",
            "leftCorner": {
              "x": -7.13,
              "y": 34.047,
              "z": 1.101
            },
            "rightCorner": {
              "x": -7.038,
              "y": 34.041,
              "z": 1.101
            },
            "gtin": "4021457632855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202db",
            "leftCorner": {
              "x": -7.039,
              "y": 34.035,
              "z": 1.101
            },
            "rightCorner": {
              "x": -6.942,
              "y": 34.03,
              "z": 1.101
            },
            "gtin": "4051089810369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202dc",
            "leftCorner": {
              "x": -6.942,
              "y": 34.03,
              "z": 1.101
            },
            "rightCorner": {
              "x": -6.845,
              "y": 34.024,
              "z": 1.101
            },
            "gtin": "4051089810369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202dd",
            "leftCorner": {
              "x": -6.845,
              "y": 34.024,
              "z": 1.101
            },
            "rightCorner": {
              "x": -6.748,
              "y": 34.018,
              "z": 1.101
            },
            "gtin": "4051089810369",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469a9",
        "height": 0.16778,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1fef1",
            "leftCorner": {
              "x": -8.099,
              "y": 34.005,
              "z": 0.137
            },
            "rightCorner": {
              "x": -7.891,
              "y": 33.993,
              "z": 0.137
            },
            "gtin": "4337185452512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fef2",
            "leftCorner": {
              "x": -7.891,
              "y": 33.993,
              "z": 0.137
            },
            "rightCorner": {
              "x": -7.683,
              "y": 33.981,
              "z": 0.137
            },
            "gtin": "4337185452512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fef3",
            "leftCorner": {
              "x": -7.683,
              "y": 33.981,
              "z": 0.137
            },
            "rightCorner": {
              "x": -7.476,
              "y": 33.969,
              "z": 0.137
            },
            "gtin": "4337185452512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fef4",
            "leftCorner": {
              "x": -7.476,
              "y": 33.962,
              "z": 0.137
            },
            "rightCorner": {
              "x": -7.268,
              "y": 33.95,
              "z": 0.137
            },
            "gtin": "4337185452550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fef5",
            "leftCorner": {
              "x": -7.268,
              "y": 33.95,
              "z": 0.137
            },
            "rightCorner": {
              "x": -7.059,
              "y": 33.937,
              "z": 0.137
            },
            "gtin": "4337185452550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fef6",
            "leftCorner": {
              "x": -7.059,
              "y": 33.937,
              "z": 0.137
            },
            "rightCorner": {
              "x": -6.851,
              "y": 33.925,
              "z": 0.137
            },
            "gtin": "4337185452550",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469a6",
        "height": 0.45439,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21829",
            "leftCorner": {
              "x": -8.083,
              "y": 34.059,
              "z": 0.372
            },
            "rightCorner": {
              "x": -8.025,
              "y": 34.055,
              "z": 0.372
            },
            "gtin": "4045612009429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2182a",
            "leftCorner": {
              "x": -8.025,
              "y": 34.055,
              "z": 0.372
            },
            "rightCorner": {
              "x": -7.967,
              "y": 34.052,
              "z": 0.372
            },
            "gtin": "4045612009429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2182b",
            "leftCorner": {
              "x": -7.967,
              "y": 34.052,
              "z": 0.372
            },
            "rightCorner": {
              "x": -7.908,
              "y": 34.048,
              "z": 0.372
            },
            "gtin": "4045612009429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2182c",
            "leftCorner": {
              "x": -7.908,
              "y": 34.048,
              "z": 0.372
            },
            "rightCorner": {
              "x": -7.85,
              "y": 34.045,
              "z": 0.372
            },
            "gtin": "4045612009429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21831",
            "leftCorner": {
              "x": -7.847,
              "y": 34.09,
              "z": 0.372
            },
            "rightCorner": {
              "x": -7.563,
              "y": 34.073,
              "z": 0.372
            },
            "gtin": "4045612009412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21832",
            "leftCorner": {
              "x": -7.563,
              "y": 34.073,
              "z": 0.372
            },
            "rightCorner": {
              "x": -7.279,
              "y": 34.056,
              "z": 0.372
            },
            "gtin": "4045612009412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21833",
            "leftCorner": {
              "x": -7.279,
              "y": 34.056,
              "z": 0.372
            },
            "rightCorner": {
              "x": -6.995,
              "y": 34.04,
              "z": 0.372
            },
            "gtin": "4045612009412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21834",
            "leftCorner": {
              "x": -6.996,
              "y": 34.035,
              "z": 0.372
            },
            "rightCorner": {
              "x": -6.723,
              "y": 34.019,
              "z": 0.372
            },
            "gtin": "4063367454622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21835",
            "leftCorner": {
              "x": -6.723,
              "y": 34.019,
              "z": 0.372
            },
            "rightCorner": {
              "x": -6.45,
              "y": 34.003,
              "z": 0.372
            },
            "gtin": "4063367454622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21836",
            "leftCorner": {
              "x": -6.45,
              "y": 34.003,
              "z": 0.372
            },
            "rightCorner": {
              "x": -6.177,
              "y": 33.987,
              "z": 0.372
            },
            "gtin": "4063367454622",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469a5",
        "height": 0.6938,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2181c",
            "leftCorner": {
              "x": -8.063,
              "y": 34.102,
              "z": 0.568
            },
            "rightCorner": {
              "x": -7.996,
              "y": 34.098,
              "z": 0.568
            },
            "gtin": "4103040302014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2181d",
            "leftCorner": {
              "x": -7.995,
              "y": 34.113,
              "z": 0.568
            },
            "rightCorner": {
              "x": -7.925,
              "y": 34.109,
              "z": 0.568
            },
            "gtin": "4001638098946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2181e",
            "leftCorner": {
              "x": -7.925,
              "y": 34.101,
              "z": 0.568
            },
            "rightCorner": {
              "x": -7.839,
              "y": 34.096,
              "z": 0.568
            },
            "gtin": "8720182264664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2181f",
            "leftCorner": {
              "x": -7.839,
              "y": 34.096,
              "z": 0.568
            },
            "rightCorner": {
              "x": -7.752,
              "y": 34.091,
              "z": 0.568
            },
            "gtin": "8720182264664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21820",
            "leftCorner": {
              "x": -7.753,
              "y": 34.069,
              "z": 0.568
            },
            "rightCorner": {
              "x": -7.552,
              "y": 34.057,
              "z": 0.568
            },
            "gtin": "4005900939616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21821",
            "leftCorner": {
              "x": -7.551,
              "y": 34.083,
              "z": 0.568
            },
            "rightCorner": {
              "x": -7.466,
              "y": 34.078,
              "z": 0.568
            },
            "gtin": "4012758347104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21822",
            "leftCorner": {
              "x": -7.466,
              "y": 34.078,
              "z": 0.568
            },
            "rightCorner": {
              "x": -7.382,
              "y": 34.073,
              "z": 0.568
            },
            "gtin": "4012758347104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21823",
            "leftCorner": {
              "x": -7.382,
              "y": 34.073,
              "z": 0.568
            },
            "rightCorner": {
              "x": -7.297,
              "y": 34.069,
              "z": 0.568
            },
            "gtin": "4012758347104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21824",
            "leftCorner": {
              "x": -7.297,
              "y": 34.069,
              "z": 0.568
            },
            "rightCorner": {
              "x": -7.213,
              "y": 34.064,
              "z": 0.568
            },
            "gtin": "4012758347104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21825",
            "leftCorner": {
              "x": -7.213,
              "y": 34.06,
              "z": 0.568
            },
            "rightCorner": {
              "x": -7.171,
              "y": 34.057,
              "z": 0.568
            },
            "gtin": "4012758347098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21826",
            "leftCorner": {
              "x": -7.171,
              "y": 34.057,
              "z": 0.568
            },
            "rightCorner": {
              "x": -7.129,
              "y": 34.055,
              "z": 0.568
            },
            "gtin": "4012758347098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21827",
            "leftCorner": {
              "x": -7.129,
              "y": 34.055,
              "z": 0.568
            },
            "rightCorner": {
              "x": -7.087,
              "y": 34.052,
              "z": 0.568
            },
            "gtin": "4012758347098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21828",
            "leftCorner": {
              "x": -7.087,
              "y": 34.052,
              "z": 0.568
            },
            "rightCorner": {
              "x": -7.045,
              "y": 34.05,
              "z": 0.568
            },
            "gtin": "4012758347098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2181a",
            "leftCorner": {
              "x": -7.045,
              "y": 34.047,
              "z": 0.568
            },
            "rightCorner": {
              "x": -6.939,
              "y": 34.04,
              "z": 0.568
            },
            "gtin": "8003520013040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2181b",
            "leftCorner": {
              "x": -6.939,
              "y": 34.04,
              "z": 0.568
            },
            "rightCorner": {
              "x": -6.832,
              "y": 34.034,
              "z": 0.568
            },
            "gtin": "8003520013040",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469a4",
        "height": 0.99805,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2180f",
            "leftCorner": {
              "x": -8.048,
              "y": 34.104,
              "z": 0.817
            },
            "rightCorner": {
              "x": -7.94,
              "y": 34.097,
              "z": 0.817
            },
            "gtin": "4002448140160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21810",
            "leftCorner": {
              "x": -7.94,
              "y": 34.095,
              "z": 0.817
            },
            "rightCorner": {
              "x": -7.886,
              "y": 34.092,
              "z": 0.817
            },
            "gtin": "4002448099871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21811",
            "leftCorner": {
              "x": -7.886,
              "y": 34.092,
              "z": 0.817
            },
            "rightCorner": {
              "x": -7.833,
              "y": 34.089,
              "z": 0.817
            },
            "gtin": "4002448099871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21812",
            "leftCorner": {
              "x": -7.833,
              "y": 34.085,
              "z": 0.817
            },
            "rightCorner": {
              "x": -7.766,
              "y": 34.081,
              "z": 0.817
            },
            "gtin": "4002448145080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21813",
            "leftCorner": {
              "x": -7.765,
              "y": 34.091,
              "z": 0.817
            },
            "rightCorner": {
              "x": -7.684,
              "y": 34.086,
              "z": 0.817
            },
            "gtin": "4251758434203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21814",
            "leftCorner": {
              "x": -7.684,
              "y": 34.084,
              "z": 0.817
            },
            "rightCorner": {
              "x": -7.578,
              "y": 34.078,
              "z": 0.817
            },
            "gtin": "4251758434081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21815",
            "leftCorner": {
              "x": -7.579,
              "y": 34.064,
              "z": 0.817
            },
            "rightCorner": {
              "x": -7.442,
              "y": 34.056,
              "z": 0.817
            },
            "gtin": "4251758434340",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21816",
            "leftCorner": {
              "x": -7.441,
              "y": 34.07,
              "z": 0.817
            },
            "rightCorner": {
              "x": -7.303,
              "y": 34.062,
              "z": 0.817
            },
            "gtin": "4002448122883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21817",
            "leftCorner": {
              "x": -7.303,
              "y": 34.062,
              "z": 0.817
            },
            "rightCorner": {
              "x": -7.24,
              "y": 34.058,
              "z": 0.817
            },
            "gtin": "4103040047557",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21818",
            "leftCorner": {
              "x": -7.24,
              "y": 34.053,
              "z": 0.817
            },
            "rightCorner": {
              "x": -7.155,
              "y": 34.048,
              "z": 0.817
            },
            "gtin": "4103040048189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21819",
            "leftCorner": {
              "x": -7.155,
              "y": 34.056,
              "z": 0.817
            },
            "rightCorner": {
              "x": -7.08,
              "y": 34.052,
              "z": 0.817
            },
            "gtin": "4063367180347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2180c",
            "leftCorner": {
              "x": -7.081,
              "y": 34.04,
              "z": 0.817
            },
            "rightCorner": {
              "x": -6.998,
              "y": 34.035,
              "z": 0.817
            },
            "gtin": "4009800005167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2180d",
            "leftCorner": {
              "x": -6.998,
              "y": 34.035,
              "z": 0.817
            },
            "rightCorner": {
              "x": -6.916,
              "y": 34.03,
              "z": 0.817
            },
            "gtin": "4009800005167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2180e",
            "leftCorner": {
              "x": -6.916,
              "y": 34.03,
              "z": 0.817
            },
            "rightCorner": {
              "x": -6.833,
              "y": 34.025,
              "z": 0.817
            },
            "gtin": "4009800005167",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469a7",
        "height": 1.6486,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fe23",
            "leftCorner": {
              "x": -8.119,
              "y": 34.11,
              "z": 1.349
            },
            "rightCorner": {
              "x": -8.031,
              "y": 34.105,
              "z": 1.349
            },
            "gtin": "4021457632947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe24",
            "leftCorner": {
              "x": -8.031,
              "y": 34.105,
              "z": 1.349
            },
            "rightCorner": {
              "x": -7.944,
              "y": 34.099,
              "z": 1.349
            },
            "gtin": "4021457632947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe25",
            "leftCorner": {
              "x": -7.944,
              "y": 34.099,
              "z": 1.349
            },
            "rightCorner": {
              "x": -7.843,
              "y": 34.094,
              "z": 1.349
            },
            "gtin": "4063367263507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe26",
            "leftCorner": {
              "x": -7.843,
              "y": 34.094,
              "z": 1.349
            },
            "rightCorner": {
              "x": -7.742,
              "y": 34.088,
              "z": 1.349
            },
            "gtin": "4063367263507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe27",
            "leftCorner": {
              "x": -7.742,
              "y": 34.092,
              "z": 1.349
            },
            "rightCorner": {
              "x": -7.619,
              "y": 34.084,
              "z": 1.349
            },
            "gtin": "4005808807017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe28",
            "leftCorner": {
              "x": -7.619,
              "y": 34.084,
              "z": 1.349
            },
            "rightCorner": {
              "x": -7.496,
              "y": 34.077,
              "z": 1.349
            },
            "gtin": "4005808807017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe29",
            "leftCorner": {
              "x": -7.496,
              "y": 34.077,
              "z": 1.349
            },
            "rightCorner": {
              "x": -7.422,
              "y": 34.073,
              "z": 1.349
            },
            "gtin": "4001499967412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe2a",
            "leftCorner": {
              "x": -7.422,
              "y": 34.073,
              "z": 1.349
            },
            "rightCorner": {
              "x": -7.349,
              "y": 34.069,
              "z": 1.349
            },
            "gtin": "4001499967412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe2b",
            "leftCorner": {
              "x": -7.349,
              "y": 34.069,
              "z": 1.349
            },
            "rightCorner": {
              "x": -7.276,
              "y": 34.064,
              "z": 1.349
            },
            "gtin": "4001499967412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe2c",
            "leftCorner": {
              "x": -7.276,
              "y": 34.06,
              "z": 1.349
            },
            "rightCorner": {
              "x": -7.176,
              "y": 34.054,
              "z": 1.349
            },
            "gtin": "4001499949180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe2d",
            "leftCorner": {
              "x": -7.176,
              "y": 34.054,
              "z": 1.349
            },
            "rightCorner": {
              "x": -7.077,
              "y": 34.049,
              "z": 1.349
            },
            "gtin": "4001499949180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe2e",
            "leftCorner": {
              "x": -7.077,
              "y": 34.04,
              "z": 1.349
            },
            "rightCorner": {
              "x": -6.997,
              "y": 34.035,
              "z": 1.349
            },
            "gtin": "4001499967443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe2f",
            "leftCorner": {
              "x": -6.997,
              "y": 34.035,
              "z": 1.349
            },
            "rightCorner": {
              "x": -6.917,
              "y": 34.03,
              "z": 1.349
            },
            "gtin": "4001499967443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe30",
            "leftCorner": {
              "x": -6.917,
              "y": 34.03,
              "z": 1.349
            },
            "rightCorner": {
              "x": -6.837,
              "y": 34.026,
              "z": 1.349
            },
            "gtin": "4001499967443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe31",
            "leftCorner": {
              "x": -6.837,
              "y": 34.023,
              "z": 1.349
            },
            "rightCorner": {
              "x": -6.767,
              "y": 34.018,
              "z": 1.349
            },
            "gtin": "4001499967429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe32",
            "leftCorner": {
              "x": -6.767,
              "y": 34.018,
              "z": 1.349
            },
            "rightCorner": {
              "x": -6.698,
              "y": 34.014,
              "z": 1.349
            },
            "gtin": "4001499967429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe33",
            "leftCorner": {
              "x": -6.698,
              "y": 34.014,
              "z": 1.349
            },
            "rightCorner": {
              "x": -6.628,
              "y": 34.01,
              "z": 1.349
            },
            "gtin": "4001499967429",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468b4",
    "rightNeighborShelfId": "468b6"
  },
  {
    "id": "468b6",
    "name": "468b6",
    "x": -6.852,
    "y": 33.714,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.029335,
      "w": 0.99957
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 68
    },
    "layers": [
      {
        "id": "682ffddfd15af3232a5469ad",
        "height": 0.16552,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1fef7",
            "leftCorner": {
              "x": -6.852,
              "y": 33.928,
              "z": 0.135
            },
            "rightCorner": {
              "x": -6.464,
              "y": 33.905,
              "z": 0.135
            },
            "gtin": "4337185452499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fef8",
            "leftCorner": {
              "x": -6.464,
              "y": 33.905,
              "z": 0.135
            },
            "rightCorner": {
              "x": -6.076,
              "y": 33.883,
              "z": 0.135
            },
            "gtin": "4337185452499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fef9",
            "leftCorner": {
              "x": -6.076,
              "y": 33.897,
              "z": 0.135
            },
            "rightCorner": {
              "x": -5.897,
              "y": 33.886,
              "z": 0.135
            },
            "gtin": "4337185452536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fefa",
            "leftCorner": {
              "x": -5.897,
              "y": 33.886,
              "z": 0.135
            },
            "rightCorner": {
              "x": -5.718,
              "y": 33.876,
              "z": 0.135
            },
            "gtin": "4337185452536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fefb",
            "leftCorner": {
              "x": -5.718,
              "y": 33.876,
              "z": 0.135
            },
            "rightCorner": {
              "x": -5.539,
              "y": 33.866,
              "z": 0.135
            },
            "gtin": "4337185452536",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469af",
        "height": 0.44873,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21837",
            "leftCorner": {
              "x": -6.177,
              "y": 33.996,
              "z": 0.367
            },
            "rightCorner": {
              "x": -6.065,
              "y": 33.99,
              "z": 0.367
            },
            "gtin": "4337185451157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21838",
            "leftCorner": {
              "x": -6.065,
              "y": 33.99,
              "z": 0.367
            },
            "rightCorner": {
              "x": -5.952,
              "y": 33.983,
              "z": 0.367
            },
            "gtin": "4337185451157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21839",
            "leftCorner": {
              "x": -5.952,
              "y": 33.983,
              "z": 0.367
            },
            "rightCorner": {
              "x": -5.84,
              "y": 33.976,
              "z": 0.367
            },
            "gtin": "4337185451157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2183a",
            "leftCorner": {
              "x": -5.84,
              "y": 33.976,
              "z": 0.367
            },
            "rightCorner": {
              "x": -5.728,
              "y": 33.97,
              "z": 0.367
            },
            "gtin": "4337185451157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2183b",
            "leftCorner": {
              "x": -5.728,
              "y": 33.97,
              "z": 0.367
            },
            "rightCorner": {
              "x": -5.616,
              "y": 33.963,
              "z": 0.367
            },
            "gtin": "4337185451157",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469ac",
        "height": 0.74156,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21863",
            "leftCorner": {
              "x": -6.835,
              "y": 34.001,
              "z": 0.607
            },
            "rightCorner": {
              "x": -6.702,
              "y": 33.993,
              "z": 0.607
            },
            "gtin": "8714789939674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21864",
            "leftCorner": {
              "x": -6.702,
              "y": 33.993,
              "z": 0.607
            },
            "rightCorner": {
              "x": -6.569,
              "y": 33.984,
              "z": 0.607
            },
            "gtin": "8714789939674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21865",
            "leftCorner": {
              "x": -6.569,
              "y": 33.984,
              "z": 0.607
            },
            "rightCorner": {
              "x": -6.435,
              "y": 33.977,
              "z": 0.607
            },
            "gtin": "8714789939674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21866",
            "leftCorner": {
              "x": -6.435,
              "y": 33.977,
              "z": 0.607
            },
            "rightCorner": {
              "x": -6.302,
              "y": 33.969,
              "z": 0.607
            },
            "gtin": "8714789939674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2186a",
            "leftCorner": {
              "x": -6.3,
              "y": 34.004,
              "z": 0.607
            },
            "rightCorner": {
              "x": -6.199,
              "y": 33.998,
              "z": 0.607
            },
            "gtin": "8714789939681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2186b",
            "leftCorner": {
              "x": -6.199,
              "y": 33.998,
              "z": 0.607
            },
            "rightCorner": {
              "x": -6.098,
              "y": 33.993,
              "z": 0.607
            },
            "gtin": "8714789939681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2186c",
            "leftCorner": {
              "x": -6.098,
              "y": 33.996,
              "z": 0.607
            },
            "rightCorner": {
              "x": -5.947,
              "y": 33.987,
              "z": 0.607
            },
            "gtin": "8714789939667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2186d",
            "leftCorner": {
              "x": -5.947,
              "y": 33.987,
              "z": 0.607
            },
            "rightCorner": {
              "x": -5.795,
              "y": 33.978,
              "z": 0.607
            },
            "gtin": "8714789939667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2186e",
            "leftCorner": {
              "x": -5.795,
              "y": 33.978,
              "z": 0.607
            },
            "rightCorner": {
              "x": -5.644,
              "y": 33.969,
              "z": 0.607
            },
            "gtin": "8714789939667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2186f",
            "leftCorner": {
              "x": -5.644,
              "y": 33.969,
              "z": 0.607
            },
            "rightCorner": {
              "x": -5.492,
              "y": 33.96,
              "z": 0.607
            },
            "gtin": "8714789939667",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469aa",
        "height": 1.0429,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2183f",
            "leftCorner": {
              "x": -6.835,
              "y": 33.998,
              "z": 0.853
            },
            "rightCorner": {
              "x": -6.751,
              "y": 33.993,
              "z": 0.853
            },
            "gtin": "4013356251732",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21846",
            "leftCorner": {
              "x": -6.748,
              "y": 34.038,
              "z": 0.853
            },
            "rightCorner": {
              "x": -6.67,
              "y": 34.033,
              "z": 0.853
            },
            "gtin": "017854100169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21847",
            "leftCorner": {
              "x": -6.67,
              "y": 34.026,
              "z": 0.853
            },
            "rightCorner": {
              "x": -6.601,
              "y": 34.022,
              "z": 0.853
            },
            "gtin": "017854116535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21848",
            "leftCorner": {
              "x": -6.601,
              "y": 34.026,
              "z": 0.853
            },
            "rightCorner": {
              "x": -6.513,
              "y": 34.021,
              "z": 0.853
            },
            "gtin": "017854100459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21849",
            "leftCorner": {
              "x": -6.513,
              "y": 34.021,
              "z": 0.853
            },
            "rightCorner": {
              "x": -6.425,
              "y": 34.016,
              "z": 0.853
            },
            "gtin": "017854100459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2184a",
            "leftCorner": {
              "x": -6.425,
              "y": 34.016,
              "z": 0.853
            },
            "rightCorner": {
              "x": -6.355,
              "y": 34.012,
              "z": 0.853
            },
            "gtin": "017854100442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2184b",
            "leftCorner": {
              "x": -6.355,
              "y": 34.012,
              "z": 0.853
            },
            "rightCorner": {
              "x": -6.285,
              "y": 34.008,
              "z": 0.853
            },
            "gtin": "017854100442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2184c",
            "leftCorner": {
              "x": -6.286,
              "y": 33.999,
              "z": 0.853
            },
            "rightCorner": {
              "x": -6.219,
              "y": 33.995,
              "z": 0.853
            },
            "gtin": "017854100466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2184d",
            "leftCorner": {
              "x": -6.219,
              "y": 33.995,
              "z": 0.853
            },
            "rightCorner": {
              "x": -6.153,
              "y": 33.991,
              "z": 0.853
            },
            "gtin": "017854100466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2184e",
            "leftCorner": {
              "x": -6.153,
              "y": 33.989,
              "z": 0.853
            },
            "rightCorner": {
              "x": -6.052,
              "y": 33.983,
              "z": 0.853
            },
            "gtin": "4001499116858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2184f",
            "leftCorner": {
              "x": -6.052,
              "y": 33.983,
              "z": 0.853
            },
            "rightCorner": {
              "x": -5.95,
              "y": 33.977,
              "z": 0.853
            },
            "gtin": "4001499116858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21850",
            "leftCorner": {
              "x": -5.95,
              "y": 33.981,
              "z": 0.853
            },
            "rightCorner": {
              "x": -5.892,
              "y": 33.977,
              "z": 0.853
            },
            "gtin": "4001499930676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21851",
            "leftCorner": {
              "x": -5.892,
              "y": 33.977,
              "z": 0.853
            },
            "rightCorner": {
              "x": -5.835,
              "y": 33.974,
              "z": 0.853
            },
            "gtin": "4001499930676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21852",
            "leftCorner": {
              "x": -5.835,
              "y": 33.974,
              "z": 0.853
            },
            "rightCorner": {
              "x": -5.778,
              "y": 33.971,
              "z": 0.853
            },
            "gtin": "4001499930676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21853",
            "leftCorner": {
              "x": -5.777,
              "y": 33.979,
              "z": 0.853
            },
            "rightCorner": {
              "x": -5.72,
              "y": 33.975,
              "z": 0.853
            },
            "gtin": "4337185817939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21854",
            "leftCorner": {
              "x": -5.72,
              "y": 33.975,
              "z": 0.853
            },
            "rightCorner": {
              "x": -5.664,
              "y": 33.972,
              "z": 0.853
            },
            "gtin": "4337185817939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21855",
            "leftCorner": {
              "x": -5.664,
              "y": 33.972,
              "z": 0.853
            },
            "rightCorner": {
              "x": -5.607,
              "y": 33.968,
              "z": 0.853
            },
            "gtin": "4337185817939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21856",
            "leftCorner": {
              "x": -5.607,
              "y": 33.963,
              "z": 0.853
            },
            "rightCorner": {
              "x": -5.546,
              "y": 33.96,
              "z": 0.853
            },
            "gtin": "4063367382505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21857",
            "leftCorner": {
              "x": -5.546,
              "y": 33.96,
              "z": 0.853
            },
            "rightCorner": {
              "x": -5.484,
              "y": 33.956,
              "z": 0.853
            },
            "gtin": "4063367382505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21858",
            "leftCorner": {
              "x": -5.484,
              "y": 33.956,
              "z": 0.853
            },
            "rightCorner": {
              "x": -5.423,
              "y": 33.953,
              "z": 0.853
            },
            "gtin": "4063367382505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21859",
            "leftCorner": {
              "x": -5.423,
              "y": 33.953,
              "z": 0.853
            },
            "rightCorner": {
              "x": -5.362,
              "y": 33.949,
              "z": 0.853
            },
            "gtin": "4063367382505",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469ab",
        "height": 1.3505,
        "facings": [
          {
            "id": "68300c895ed67a01d9a202de",
            "leftCorner": {
              "x": -6.748,
              "y": 34.03,
              "z": 1.105
            },
            "rightCorner": {
              "x": -6.663,
              "y": 34.025,
              "z": 1.105
            },
            "gtin": "4005808807000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202df",
            "leftCorner": {
              "x": -6.663,
              "y": 34.025,
              "z": 1.105
            },
            "rightCorner": {
              "x": -6.577,
              "y": 34.02,
              "z": 1.105
            },
            "gtin": "4005808807000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202e0",
            "leftCorner": {
              "x": -6.577,
              "y": 34.018,
              "z": 1.105
            },
            "rightCorner": {
              "x": -6.532,
              "y": 34.015,
              "z": 1.105
            },
            "gtin": "4005900083272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202e1",
            "leftCorner": {
              "x": -6.534,
              "y": 33.971,
              "z": 1.105
            },
            "rightCorner": {
              "x": -6.406,
              "y": 33.964,
              "z": 1.105
            },
            "gtin": "4017512209704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202e2",
            "leftCorner": {
              "x": -6.404,
              "y": 34.002,
              "z": 1.105
            },
            "rightCorner": {
              "x": -6.361,
              "y": 33.999,
              "z": 1.105
            },
            "gtin": "4017512182083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202e3",
            "leftCorner": {
              "x": -6.361,
              "y": 33.999,
              "z": 1.105
            },
            "rightCorner": {
              "x": -6.318,
              "y": 33.996,
              "z": 1.105
            },
            "gtin": "4017512182083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202e4",
            "leftCorner": {
              "x": -6.318,
              "y": 33.986,
              "z": 1.105
            },
            "rightCorner": {
              "x": -6.22,
              "y": 33.981,
              "z": 1.105
            },
            "gtin": "4017512158637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202e5",
            "leftCorner": {
              "x": -6.221,
              "y": 33.958,
              "z": 1.105
            },
            "rightCorner": {
              "x": -6.124,
              "y": 33.952,
              "z": 1.105
            },
            "gtin": "4017512125790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202e6",
            "leftCorner": {
              "x": -6.122,
              "y": 33.986,
              "z": 1.105
            },
            "rightCorner": {
              "x": -6.009,
              "y": 33.979,
              "z": 1.105
            },
            "gtin": "4017512163112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202e7",
            "leftCorner": {
              "x": -6.009,
              "y": 33.979,
              "z": 1.105
            },
            "rightCorner": {
              "x": -5.897,
              "y": 33.973,
              "z": 1.105
            },
            "gtin": "4017512163112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202e8",
            "leftCorner": {
              "x": -5.896,
              "y": 33.983,
              "z": 1.105
            },
            "rightCorner": {
              "x": -5.848,
              "y": 33.98,
              "z": 1.105
            },
            "gtin": "4017512157371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202e9",
            "leftCorner": {
              "x": -5.848,
              "y": 33.98,
              "z": 1.105
            },
            "rightCorner": {
              "x": -5.801,
              "y": 33.977,
              "z": 1.105
            },
            "gtin": "4017512157371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202ea",
            "leftCorner": {
              "x": -5.8,
              "y": 33.983,
              "z": 1.105
            },
            "rightCorner": {
              "x": -5.705,
              "y": 33.978,
              "z": 1.105
            },
            "gtin": "4017512157043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202eb",
            "leftCorner": {
              "x": -5.705,
              "y": 33.969,
              "z": 1.105
            },
            "rightCorner": {
              "x": -5.631,
              "y": 33.964,
              "z": 1.105
            },
            "gtin": "4017512189679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202ec",
            "leftCorner": {
              "x": -5.631,
              "y": 33.961,
              "z": 1.105
            },
            "rightCorner": {
              "x": -5.509,
              "y": 33.953,
              "z": 1.105
            },
            "gtin": "4017512158781",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469ae",
        "height": 1.6493,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fe34",
            "leftCorner": {
              "x": -6.628,
              "y": 34.026,
              "z": 1.349
            },
            "rightCorner": {
              "x": -6.523,
              "y": 34.021,
              "z": 1.349
            },
            "gtin": "4063367180361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe35",
            "leftCorner": {
              "x": -6.523,
              "y": 34.017,
              "z": 1.349
            },
            "rightCorner": {
              "x": -6.423,
              "y": 34.01,
              "z": 1.349
            },
            "gtin": "4103040524010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe36",
            "leftCorner": {
              "x": -6.423,
              "y": 34.006,
              "z": 1.349
            },
            "rightCorner": {
              "x": -6.203,
              "y": 33.994,
              "z": 1.349
            },
            "gtin": "4013356251756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe37",
            "leftCorner": {
              "x": -6.203,
              "y": 33.994,
              "z": 1.349
            },
            "rightCorner": {
              "x": -6.136,
              "y": 33.99,
              "z": 1.349
            },
            "gtin": "5902230519381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe38",
            "leftCorner": {
              "x": -6.136,
              "y": 33.993,
              "z": 1.349
            },
            "rightCorner": {
              "x": -6.085,
              "y": 33.991,
              "z": 1.349
            },
            "gtin": "4063367307928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe39",
            "leftCorner": {
              "x": -6.085,
              "y": 33.991,
              "z": 1.349
            },
            "rightCorner": {
              "x": -6.035,
              "y": 33.988,
              "z": 1.349
            },
            "gtin": "4063367307928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe3a",
            "leftCorner": {
              "x": -6.036,
              "y": 33.977,
              "z": 1.349
            },
            "rightCorner": {
              "x": -5.938,
              "y": 33.971,
              "z": 1.349
            },
            "gtin": "5902230519183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe3b",
            "leftCorner": {
              "x": -5.937,
              "y": 33.982,
              "z": 1.349
            },
            "rightCorner": {
              "x": -5.858,
              "y": 33.978,
              "z": 1.349
            },
            "gtin": "4063367307904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe3c",
            "leftCorner": {
              "x": -5.858,
              "y": 33.978,
              "z": 1.349
            },
            "rightCorner": {
              "x": -5.779,
              "y": 33.974,
              "z": 1.349
            },
            "gtin": "4063367307904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe3d",
            "leftCorner": {
              "x": -5.779,
              "y": 33.974,
              "z": 1.349
            },
            "rightCorner": {
              "x": -5.7,
              "y": 33.968,
              "z": 1.349
            },
            "gtin": "4063367307904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe3e",
            "leftCorner": {
              "x": -5.7,
              "y": 33.968,
              "z": 1.349
            },
            "rightCorner": {
              "x": -5.62,
              "y": 33.964,
              "z": 1.349
            },
            "gtin": "4063367307904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe3f",
            "leftCorner": {
              "x": -5.62,
              "y": 33.967,
              "z": 1.349
            },
            "rightCorner": {
              "x": -5.574,
              "y": 33.964,
              "z": 1.349
            },
            "gtin": "4063367307966",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468b5",
    "rightNeighborShelfId": "468b7"
  },
  {
    "id": "468b7",
    "name": "468b7",
    "x": -5.604,
    "y": 33.641,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.029335,
      "w": 0.99957
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 57
    },
    "layers": [
      {
        "id": "682ffddfd15af3232a5469b4",
        "height": 0.16853,
        "facings": []
      },
      {
        "id": "682ffddfd15af3232a5469b0",
        "height": 0.45052,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2183c",
            "leftCorner": {
              "x": -5.615,
              "y": 33.979,
              "z": 0.369
            },
            "rightCorner": {
              "x": -5.408,
              "y": 33.967,
              "z": 0.369
            },
            "gtin": "5902357007259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2183d",
            "leftCorner": {
              "x": -5.408,
              "y": 33.967,
              "z": 0.369
            },
            "rightCorner": {
              "x": -5.2,
              "y": 33.954,
              "z": 0.369
            },
            "gtin": "5902357007259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2183e",
            "leftCorner": {
              "x": -5.2,
              "y": 33.954,
              "z": 0.369
            },
            "rightCorner": {
              "x": -4.993,
              "y": 33.942,
              "z": 0.369
            },
            "gtin": "5902357007259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2182d",
            "leftCorner": {
              "x": -4.993,
              "y": 33.936,
              "z": 0.369
            },
            "rightCorner": {
              "x": -4.829,
              "y": 33.926,
              "z": 0.369
            },
            "gtin": "4337185451119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2182e",
            "leftCorner": {
              "x": -4.829,
              "y": 33.926,
              "z": 0.369
            },
            "rightCorner": {
              "x": -4.665,
              "y": 33.917,
              "z": 0.369
            },
            "gtin": "4337185451119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2182f",
            "leftCorner": {
              "x": -4.665,
              "y": 33.917,
              "z": 0.369
            },
            "rightCorner": {
              "x": -4.501,
              "y": 33.907,
              "z": 0.369
            },
            "gtin": "4337185451119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21830",
            "leftCorner": {
              "x": -4.501,
              "y": 33.907,
              "z": 0.369
            },
            "rightCorner": {
              "x": -4.337,
              "y": 33.897,
              "z": 0.369
            },
            "gtin": "4337185451119",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469b2",
        "height": 0.74747,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21870",
            "leftCorner": {
              "x": -5.492,
              "y": 33.969,
              "z": 0.612
            },
            "rightCorner": {
              "x": -5.344,
              "y": 33.96,
              "z": 0.612
            },
            "gtin": "8714789673653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21871",
            "leftCorner": {
              "x": -5.344,
              "y": 33.96,
              "z": 0.612
            },
            "rightCorner": {
              "x": -5.196,
              "y": 33.951,
              "z": 0.612
            },
            "gtin": "8714789673653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21872",
            "leftCorner": {
              "x": -5.196,
              "y": 33.951,
              "z": 0.612
            },
            "rightCorner": {
              "x": -5.048,
              "y": 33.942,
              "z": 0.612
            },
            "gtin": "8714789673653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21873",
            "leftCorner": {
              "x": -5.048,
              "y": 33.942,
              "z": 0.612
            },
            "rightCorner": {
              "x": -4.9,
              "y": 33.934,
              "z": 0.612
            },
            "gtin": "8714789673653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21867",
            "leftCorner": {
              "x": -4.899,
              "y": 33.936,
              "z": 0.612
            },
            "rightCorner": {
              "x": -4.712,
              "y": 33.926,
              "z": 0.612
            },
            "gtin": "8003520012944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21868",
            "leftCorner": {
              "x": -4.712,
              "y": 33.926,
              "z": 0.612
            },
            "rightCorner": {
              "x": -4.524,
              "y": 33.914,
              "z": 0.612
            },
            "gtin": "8003520012944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21869",
            "leftCorner": {
              "x": -4.524,
              "y": 33.914,
              "z": 0.612
            },
            "rightCorner": {
              "x": -4.336,
              "y": 33.903,
              "z": 0.612
            },
            "gtin": "8003520012944",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469b5",
        "height": 1.0477,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21842",
            "leftCorner": {
              "x": -4.666,
              "y": 33.918,
              "z": 0.857
            },
            "rightCorner": {
              "x": -4.584,
              "y": 33.914,
              "z": 0.857
            },
            "gtin": "4008233176635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2185a",
            "leftCorner": {
              "x": -5.362,
              "y": 33.945,
              "z": 0.857
            },
            "rightCorner": {
              "x": -5.31,
              "y": 33.941,
              "z": 0.857
            },
            "gtin": "4063367384806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2185b",
            "leftCorner": {
              "x": -5.31,
              "y": 33.941,
              "z": 0.857
            },
            "rightCorner": {
              "x": -5.259,
              "y": 33.939,
              "z": 0.857
            },
            "gtin": "4063367384806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2185c",
            "leftCorner": {
              "x": -5.258,
              "y": 33.948,
              "z": 0.857
            },
            "rightCorner": {
              "x": -5.191,
              "y": 33.944,
              "z": 0.857
            },
            "gtin": "4008233104003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2185d",
            "leftCorner": {
              "x": -5.191,
              "y": 33.944,
              "z": 0.857
            },
            "rightCorner": {
              "x": -5.125,
              "y": 33.94,
              "z": 0.857
            },
            "gtin": "4008233104003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2185e",
            "leftCorner": {
              "x": -5.124,
              "y": 33.943,
              "z": 0.857
            },
            "rightCorner": {
              "x": -5.072,
              "y": 33.94,
              "z": 0.857
            },
            "gtin": "4008233109121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2185f",
            "leftCorner": {
              "x": -5.072,
              "y": 33.94,
              "z": 0.857
            },
            "rightCorner": {
              "x": -5.019,
              "y": 33.936,
              "z": 0.857
            },
            "gtin": "4008233109121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21860",
            "leftCorner": {
              "x": -5.019,
              "y": 33.936,
              "z": 0.857
            },
            "rightCorner": {
              "x": -4.966,
              "y": 33.933,
              "z": 0.857
            },
            "gtin": "4008233109121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21861",
            "leftCorner": {
              "x": -4.966,
              "y": 33.939,
              "z": 0.857
            },
            "rightCorner": {
              "x": -4.898,
              "y": 33.935,
              "z": 0.857
            },
            "gtin": "4008233175102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21862",
            "leftCorner": {
              "x": -4.898,
              "y": 33.935,
              "z": 0.857
            },
            "rightCorner": {
              "x": -4.831,
              "y": 33.931,
              "z": 0.857
            },
            "gtin": "4008233175102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21840",
            "leftCorner": {
              "x": -4.831,
              "y": 33.928,
              "z": 0.857
            },
            "rightCorner": {
              "x": -4.749,
              "y": 33.923,
              "z": 0.857
            },
            "gtin": "4008233176635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21841",
            "leftCorner": {
              "x": -4.749,
              "y": 33.923,
              "z": 0.857
            },
            "rightCorner": {
              "x": -4.666,
              "y": 33.918,
              "z": 0.857
            },
            "gtin": "4008233176635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21843",
            "leftCorner": {
              "x": -4.584,
              "y": 33.914,
              "z": 0.857
            },
            "rightCorner": {
              "x": -4.501,
              "y": 33.909,
              "z": 0.857
            },
            "gtin": "4008233176635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21844",
            "leftCorner": {
              "x": -4.501,
              "y": 33.909,
              "z": 0.857
            },
            "rightCorner": {
              "x": -4.419,
              "y": 33.904,
              "z": 0.857
            },
            "gtin": "4008233176635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21845",
            "leftCorner": {
              "x": -4.419,
              "y": 33.904,
              "z": 0.857
            },
            "rightCorner": {
              "x": -4.337,
              "y": 33.899,
              "z": 0.857
            },
            "gtin": "4008233176635",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469b3",
        "height": 1.3534,
        "facings": [
          {
            "id": "68300c895ed67a01d9a202ed",
            "leftCorner": {
              "x": -5.509,
              "y": 33.962,
              "z": 1.107
            },
            "rightCorner": {
              "x": -5.406,
              "y": 33.956,
              "z": 1.107
            },
            "gtin": "4017512202903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202ee",
            "leftCorner": {
              "x": -5.406,
              "y": 33.957,
              "z": 1.107
            },
            "rightCorner": {
              "x": -5.348,
              "y": 33.954,
              "z": 1.107
            },
            "gtin": "4017512142124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202ef",
            "leftCorner": {
              "x": -5.348,
              "y": 33.954,
              "z": 1.107
            },
            "rightCorner": {
              "x": -5.289,
              "y": 33.951,
              "z": 1.107
            },
            "gtin": "4017512142124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202f0",
            "leftCorner": {
              "x": -5.289,
              "y": 33.956,
              "z": 1.107
            },
            "rightCorner": {
              "x": -5.182,
              "y": 33.95,
              "z": 1.107
            },
            "gtin": "4017512142131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202f1",
            "leftCorner": {
              "x": -5.182,
              "y": 33.95,
              "z": 1.107
            },
            "rightCorner": {
              "x": -5.076,
              "y": 33.943,
              "z": 1.107
            },
            "gtin": "4017512142131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202f2",
            "leftCorner": {
              "x": -5.076,
              "y": 33.943,
              "z": 1.107
            },
            "rightCorner": {
              "x": -4.969,
              "y": 33.937,
              "z": 1.107
            },
            "gtin": "4017512142131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202f3",
            "leftCorner": {
              "x": -4.969,
              "y": 33.936,
              "z": 1.107
            },
            "rightCorner": {
              "x": -4.863,
              "y": 33.931,
              "z": 1.107
            },
            "gtin": "4008233178172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202f4",
            "leftCorner": {
              "x": -4.864,
              "y": 33.923,
              "z": 1.107
            },
            "rightCorner": {
              "x": -4.767,
              "y": 33.917,
              "z": 1.107
            },
            "gtin": "4008233150963",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202f5",
            "leftCorner": {
              "x": -4.766,
              "y": 33.93,
              "z": 1.107
            },
            "rightCorner": {
              "x": -4.682,
              "y": 33.924,
              "z": 1.107
            },
            "gtin": "4008233165301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202f6",
            "leftCorner": {
              "x": -4.682,
              "y": 33.918,
              "z": 1.107
            },
            "rightCorner": {
              "x": -4.584,
              "y": 33.913,
              "z": 1.107
            },
            "gtin": "4008233176451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202f7",
            "leftCorner": {
              "x": -4.584,
              "y": 33.908,
              "z": 1.107
            },
            "rightCorner": {
              "x": -4.471,
              "y": 33.901,
              "z": 1.107
            },
            "gtin": "4008233161334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202f8",
            "leftCorner": {
              "x": -4.471,
              "y": 33.901,
              "z": 1.107
            },
            "rightCorner": {
              "x": -4.357,
              "y": 33.894,
              "z": 1.107
            },
            "gtin": "4008233161334",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469b1",
        "height": 1.65,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fe40",
            "leftCorner": {
              "x": -5.573,
              "y": 33.965,
              "z": 1.35
            },
            "rightCorner": {
              "x": -5.504,
              "y": 33.961,
              "z": 1.35
            },
            "gtin": "4063367307942",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe41",
            "leftCorner": {
              "x": -5.504,
              "y": 33.95,
              "z": 1.35
            },
            "rightCorner": {
              "x": -5.389,
              "y": 33.942,
              "z": 1.35
            },
            "gtin": "4063367307867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe42",
            "leftCorner": {
              "x": -5.388,
              "y": 33.957,
              "z": 1.35
            },
            "rightCorner": {
              "x": -5.284,
              "y": 33.95,
              "z": 1.35
            },
            "gtin": "4063367307843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe43",
            "leftCorner": {
              "x": -5.284,
              "y": 33.95,
              "z": 1.35
            },
            "rightCorner": {
              "x": -5.169,
              "y": 33.944,
              "z": 1.35
            },
            "gtin": "4054995053721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe44",
            "leftCorner": {
              "x": -5.169,
              "y": 33.946,
              "z": 1.35
            },
            "rightCorner": {
              "x": -5.071,
              "y": 33.94,
              "z": 1.35
            },
            "gtin": "4054995058412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe45",
            "leftCorner": {
              "x": -5.071,
              "y": 33.934,
              "z": 1.35
            },
            "rightCorner": {
              "x": -5.023,
              "y": 33.931,
              "z": 1.35
            },
            "gtin": "4030651051720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe46",
            "leftCorner": {
              "x": -5.023,
              "y": 33.931,
              "z": 1.35
            },
            "rightCorner": {
              "x": -4.975,
              "y": 33.928,
              "z": 1.35
            },
            "gtin": "4030651051720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe47",
            "leftCorner": {
              "x": -4.975,
              "y": 33.927,
              "z": 1.35
            },
            "rightCorner": {
              "x": -4.913,
              "y": 33.923,
              "z": 1.35
            },
            "gtin": "4030651047648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe48",
            "leftCorner": {
              "x": -4.913,
              "y": 33.923,
              "z": 1.35
            },
            "rightCorner": {
              "x": -4.852,
              "y": 33.92,
              "z": 1.35
            },
            "gtin": "4030651047648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe49",
            "leftCorner": {
              "x": -4.852,
              "y": 33.92,
              "z": 1.35
            },
            "rightCorner": {
              "x": -4.79,
              "y": 33.916,
              "z": 1.35
            },
            "gtin": "4030651047648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe4a",
            "leftCorner": {
              "x": -4.79,
              "y": 33.926,
              "z": 1.35
            },
            "rightCorner": {
              "x": -4.741,
              "y": 33.924,
              "z": 1.35
            },
            "gtin": "4008491109772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe4b",
            "leftCorner": {
              "x": -4.741,
              "y": 33.924,
              "z": 1.35
            },
            "rightCorner": {
              "x": -4.692,
              "y": 33.921,
              "z": 1.35
            },
            "gtin": "4008491109772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe4c",
            "leftCorner": {
              "x": -4.693,
              "y": 33.913,
              "z": 1.35
            },
            "rightCorner": {
              "x": -4.606,
              "y": 33.908,
              "z": 1.35
            },
            "gtin": "4030651041783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe4d",
            "leftCorner": {
              "x": -4.605,
              "y": 33.917,
              "z": 1.35
            },
            "rightCorner": {
              "x": -4.523,
              "y": 33.912,
              "z": 1.35
            },
            "gtin": "4030651046047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe4e",
            "leftCorner": {
              "x": -4.523,
              "y": 33.912,
              "z": 1.35
            },
            "rightCorner": {
              "x": -4.44,
              "y": 33.907,
              "z": 1.35
            },
            "gtin": "4030651046047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe4f",
            "leftCorner": {
              "x": -4.44,
              "y": 33.907,
              "z": 1.35
            },
            "rightCorner": {
              "x": -4.358,
              "y": 33.902,
              "z": 1.35
            },
            "gtin": "4030651046047",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468b6",
    "rightNeighborShelfId": "468b8"
  },
  {
    "id": "468b8",
    "name": "468b8",
    "x": -4.356,
    "y": 33.568,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.029335,
      "w": 0.99957
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 71
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5465c8",
        "height": 0.17202,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1fefc",
            "leftCorner": {
              "x": -4.298,
              "y": 33.623,
              "z": 0.141
            },
            "rightCorner": {
              "x": -4.187,
              "y": 33.616,
              "z": 0.141
            },
            "gtin": "4063367359200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fefd",
            "leftCorner": {
              "x": -4.187,
              "y": 33.616,
              "z": 0.141
            },
            "rightCorner": {
              "x": -4.075,
              "y": 33.61,
              "z": 0.141
            },
            "gtin": "4063367359200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fefe",
            "leftCorner": {
              "x": -4.075,
              "y": 33.61,
              "z": 0.141
            },
            "rightCorner": {
              "x": -3.964,
              "y": 33.604,
              "z": 0.141
            },
            "gtin": "4063367359200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1feff",
            "leftCorner": {
              "x": -3.964,
              "y": 33.602,
              "z": 0.141
            },
            "rightCorner": {
              "x": -3.85,
              "y": 33.596,
              "z": 0.141
            },
            "gtin": "4063367359354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff00",
            "leftCorner": {
              "x": -3.85,
              "y": 33.596,
              "z": 0.141
            },
            "rightCorner": {
              "x": -3.736,
              "y": 33.589,
              "z": 0.141
            },
            "gtin": "4063367359354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff01",
            "leftCorner": {
              "x": -3.736,
              "y": 33.589,
              "z": 0.141
            },
            "rightCorner": {
              "x": -3.622,
              "y": 33.582,
              "z": 0.141
            },
            "gtin": "4063367359354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff02",
            "leftCorner": {
              "x": -3.622,
              "y": 33.573,
              "z": 0.141
            },
            "rightCorner": {
              "x": -3.485,
              "y": 33.565,
              "z": 0.141
            },
            "gtin": "4063367359330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff03",
            "leftCorner": {
              "x": -3.485,
              "y": 33.565,
              "z": 0.141
            },
            "rightCorner": {
              "x": -3.347,
              "y": 33.557,
              "z": 0.141
            },
            "gtin": "4063367359330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff04",
            "leftCorner": {
              "x": -3.347,
              "y": 33.557,
              "z": 0.141
            },
            "rightCorner": {
              "x": -3.21,
              "y": 33.549,
              "z": 0.141
            },
            "gtin": "4063367359330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff05",
            "leftCorner": {
              "x": -3.21,
              "y": 33.549,
              "z": 0.141
            },
            "rightCorner": {
              "x": -3.073,
              "y": 33.541,
              "z": 0.141
            },
            "gtin": "4063367359330",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465c5",
        "height": 0.64226,
        "facings": [
          {
            "id": "68300c895ed67a01d9a202bf",
            "leftCorner": {
              "x": -4.35,
              "y": 33.678,
              "z": 0.525
            },
            "rightCorner": {
              "x": -4.299,
              "y": 33.675,
              "z": 0.525
            },
            "gtin": "4005900934413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202c0",
            "leftCorner": {
              "x": -4.299,
              "y": 33.675,
              "z": 0.525
            },
            "rightCorner": {
              "x": -4.248,
              "y": 33.672,
              "z": 0.525
            },
            "gtin": "4005900934413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202c2",
            "leftCorner": {
              "x": -4.245,
              "y": 33.721,
              "z": 0.525
            },
            "rightCorner": {
              "x": -4.172,
              "y": 33.717,
              "z": 0.525
            },
            "gtin": "4006000095837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202c3",
            "leftCorner": {
              "x": -4.172,
              "y": 33.717,
              "z": 0.525
            },
            "rightCorner": {
              "x": -4.1,
              "y": 33.712,
              "z": 0.525
            },
            "gtin": "4006000095837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202c4",
            "leftCorner": {
              "x": -4.1,
              "y": 33.712,
              "z": 0.525
            },
            "rightCorner": {
              "x": -4.028,
              "y": 33.708,
              "z": 0.525
            },
            "gtin": "4006000095837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202c5",
            "leftCorner": {
              "x": -4.028,
              "y": 33.708,
              "z": 0.525
            },
            "rightCorner": {
              "x": -3.955,
              "y": 33.703,
              "z": 0.525
            },
            "gtin": "4006000095837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202c6",
            "leftCorner": {
              "x": -3.956,
              "y": 33.693,
              "z": 0.525
            },
            "rightCorner": {
              "x": -3.842,
              "y": 33.687,
              "z": 0.525
            },
            "gtin": "8714789946269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202c7",
            "leftCorner": {
              "x": -3.842,
              "y": 33.687,
              "z": 0.525
            },
            "rightCorner": {
              "x": -3.728,
              "y": 33.68,
              "z": 0.525
            },
            "gtin": "8714789946269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202c8",
            "leftCorner": {
              "x": -3.728,
              "y": 33.68,
              "z": 0.525
            },
            "rightCorner": {
              "x": -3.614,
              "y": 33.673,
              "z": 0.525
            },
            "gtin": "8714789946269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202c9",
            "leftCorner": {
              "x": -3.614,
              "y": 33.675,
              "z": 0.525
            },
            "rightCorner": {
              "x": -3.528,
              "y": 33.67,
              "z": 0.525
            },
            "gtin": "8714789876757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202ca",
            "leftCorner": {
              "x": -3.528,
              "y": 33.67,
              "z": 0.525
            },
            "rightCorner": {
              "x": -3.441,
              "y": 33.665,
              "z": 0.525
            },
            "gtin": "8714789876757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202cb",
            "leftCorner": {
              "x": -3.441,
              "y": 33.665,
              "z": 0.525
            },
            "rightCorner": {
              "x": -3.355,
              "y": 33.66,
              "z": 0.525
            },
            "gtin": "8714789876757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202cc",
            "leftCorner": {
              "x": -3.356,
              "y": 33.655,
              "z": 0.525
            },
            "rightCorner": {
              "x": -3.27,
              "y": 33.65,
              "z": 0.525
            },
            "gtin": "8714789939803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202cd",
            "leftCorner": {
              "x": -3.27,
              "y": 33.65,
              "z": 0.525
            },
            "rightCorner": {
              "x": -3.184,
              "y": 33.645,
              "z": 0.525
            },
            "gtin": "8714789939803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202c1",
            "leftCorner": {
              "x": -3.184,
              "y": 33.652,
              "z": 0.525
            },
            "rightCorner": {
              "x": -3.099,
              "y": 33.647,
              "z": 0.525
            },
            "gtin": "4013162018871",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465c7",
        "height": 0.99656,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20309",
            "leftCorner": {
              "x": -4.35,
              "y": 33.666,
              "z": 0.815
            },
            "rightCorner": {
              "x": -4.276,
              "y": 33.662,
              "z": 0.815
            },
            "gtin": "4008233165745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2030a",
            "leftCorner": {
              "x": -4.276,
              "y": 33.662,
              "z": 0.815
            },
            "rightCorner": {
              "x": -4.202,
              "y": 33.657,
              "z": 0.815
            },
            "gtin": "4008233165745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2030b",
            "leftCorner": {
              "x": -4.202,
              "y": 33.657,
              "z": 0.815
            },
            "rightCorner": {
              "x": -4.128,
              "y": 33.653,
              "z": 0.815
            },
            "gtin": "4008233165745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2030e",
            "leftCorner": {
              "x": -4.126,
              "y": 33.686,
              "z": 0.815
            },
            "rightCorner": {
              "x": -4.052,
              "y": 33.682,
              "z": 0.815
            },
            "gtin": "4008233145853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2030f",
            "leftCorner": {
              "x": -4.052,
              "y": 33.682,
              "z": 0.815
            },
            "rightCorner": {
              "x": -3.979,
              "y": 33.677,
              "z": 0.815
            },
            "gtin": "4008233145853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20310",
            "leftCorner": {
              "x": -3.978,
              "y": 33.693,
              "z": 0.815
            },
            "rightCorner": {
              "x": -3.859,
              "y": 33.685,
              "z": 0.815
            },
            "gtin": "4008233121727",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c895ed67a01d9a20311",
            "leftCorner": {
              "x": -3.86,
              "y": 33.665,
              "z": 0.815
            },
            "rightCorner": {
              "x": -3.794,
              "y": 33.66,
              "z": 0.815
            },
            "gtin": "4063367384882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20312",
            "leftCorner": {
              "x": -3.794,
              "y": 33.66,
              "z": 0.815
            },
            "rightCorner": {
              "x": -3.727,
              "y": 33.656,
              "z": 0.815
            },
            "gtin": "4063367384882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20313",
            "leftCorner": {
              "x": -3.727,
              "y": 33.656,
              "z": 0.815
            },
            "rightCorner": {
              "x": -3.661,
              "y": 33.653,
              "z": 0.815
            },
            "gtin": "4063367384882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20314",
            "leftCorner": {
              "x": -3.661,
              "y": 33.653,
              "z": 0.815
            },
            "rightCorner": {
              "x": -3.594,
              "y": 33.649,
              "z": 0.815
            },
            "gtin": "4063367384882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20315",
            "leftCorner": {
              "x": -3.594,
              "y": 33.66,
              "z": 0.815
            },
            "rightCorner": {
              "x": -3.524,
              "y": 33.656,
              "z": 0.815
            },
            "gtin": "4063367384905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20316",
            "leftCorner": {
              "x": -3.524,
              "y": 33.656,
              "z": 0.815
            },
            "rightCorner": {
              "x": -3.454,
              "y": 33.651,
              "z": 0.815
            },
            "gtin": "4063367384905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20317",
            "leftCorner": {
              "x": -3.454,
              "y": 33.651,
              "z": 0.815
            },
            "rightCorner": {
              "x": -3.384,
              "y": 33.647,
              "z": 0.815
            },
            "gtin": "4063367384905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20318",
            "leftCorner": {
              "x": -3.384,
              "y": 33.642,
              "z": 0.815
            },
            "rightCorner": {
              "x": -3.247,
              "y": 33.634,
              "z": 0.815
            },
            "gtin": "4008233172033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2030c",
            "leftCorner": {
              "x": -3.246,
              "y": 33.64,
              "z": 0.815
            },
            "rightCorner": {
              "x": -3.173,
              "y": 33.635,
              "z": 0.815
            },
            "gtin": "4008233172088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2030d",
            "leftCorner": {
              "x": -3.173,
              "y": 33.635,
              "z": 0.815
            },
            "rightCorner": {
              "x": -3.1,
              "y": 33.631,
              "z": 0.815
            },
            "gtin": "4008233172088",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465c6",
        "height": 1.3458,
        "facings": [
          {
            "id": "68300c895ed67a01d9a202f9",
            "leftCorner": {
              "x": -4.366,
              "y": 33.727,
              "z": 1.101
            },
            "rightCorner": {
              "x": -4.275,
              "y": 33.722,
              "z": 1.101
            },
            "gtin": "4008233172439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202fa",
            "leftCorner": {
              "x": -4.277,
              "y": 33.701,
              "z": 1.101
            },
            "rightCorner": {
              "x": -4.223,
              "y": 33.697,
              "z": 1.101
            },
            "gtin": "4008233108575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202fb",
            "leftCorner": {
              "x": -4.223,
              "y": 33.697,
              "z": 1.101
            },
            "rightCorner": {
              "x": -4.169,
              "y": 33.694,
              "z": 1.101
            },
            "gtin": "4008233108575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202fc",
            "leftCorner": {
              "x": -4.168,
              "y": 33.709,
              "z": 1.101
            },
            "rightCorner": {
              "x": -4.087,
              "y": 33.704,
              "z": 1.101
            },
            "gtin": "4008233046068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202fd",
            "leftCorner": {
              "x": -4.087,
              "y": 33.692,
              "z": 1.101
            },
            "rightCorner": {
              "x": -4.031,
              "y": 33.69,
              "z": 1.101
            },
            "gtin": "4008233172446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202fe",
            "leftCorner": {
              "x": -4.031,
              "y": 33.69,
              "z": 1.101
            },
            "rightCorner": {
              "x": -3.975,
              "y": 33.687,
              "z": 1.101
            },
            "gtin": "4008233172446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202ff",
            "leftCorner": {
              "x": -3.975,
              "y": 33.698,
              "z": 1.101
            },
            "rightCorner": {
              "x": -3.921,
              "y": 33.695,
              "z": 1.101
            },
            "gtin": "4008233175089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20300",
            "leftCorner": {
              "x": -3.921,
              "y": 33.695,
              "z": 1.101
            },
            "rightCorner": {
              "x": -3.867,
              "y": 33.691,
              "z": 1.101
            },
            "gtin": "4008233175089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20301",
            "leftCorner": {
              "x": -3.867,
              "y": 33.688,
              "z": 1.101
            },
            "rightCorner": {
              "x": -3.828,
              "y": 33.685,
              "z": 1.101
            },
            "gtin": "4008233175065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20302",
            "leftCorner": {
              "x": -3.828,
              "y": 33.685,
              "z": 1.101
            },
            "rightCorner": {
              "x": -3.789,
              "y": 33.684,
              "z": 1.101
            },
            "gtin": "4008233175065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20303",
            "leftCorner": {
              "x": -3.791,
              "y": 33.663,
              "z": 1.101
            },
            "rightCorner": {
              "x": -3.66,
              "y": 33.655,
              "z": 1.101
            },
            "gtin": "4008233172422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20304",
            "leftCorner": {
              "x": -3.659,
              "y": 33.667,
              "z": 1.101
            },
            "rightCorner": {
              "x": -3.567,
              "y": 33.662,
              "z": 1.101
            },
            "gtin": "4008233128009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20305",
            "leftCorner": {
              "x": -3.567,
              "y": 33.662,
              "z": 1.101
            },
            "rightCorner": {
              "x": -3.469,
              "y": 33.657,
              "z": 1.101
            },
            "gtin": "4008233179049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20306",
            "leftCorner": {
              "x": -3.468,
              "y": 33.663,
              "z": 1.101
            },
            "rightCorner": {
              "x": -3.358,
              "y": 33.656,
              "z": 1.101
            },
            "gtin": "4008491480420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20307",
            "leftCorner": {
              "x": -3.358,
              "y": 33.655,
              "z": 1.101
            },
            "rightCorner": {
              "x": -3.263,
              "y": 33.65,
              "z": 1.101
            },
            "gtin": "4008491105804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20308",
            "leftCorner": {
              "x": -3.264,
              "y": 33.639,
              "z": 1.101
            },
            "rightCorner": {
              "x": -3.165,
              "y": 33.633,
              "z": 1.101
            },
            "gtin": "4017512209902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a202cf",
            "leftCorner": {
              "x": -3.165,
              "y": 33.632,
              "z": 1.101
            },
            "rightCorner": {
              "x": -3.1,
              "y": 33.628,
              "z": 1.101
            },
            "gtin": "4017512209100",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465c4",
        "height": 1.6542,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fe50",
            "leftCorner": {
              "x": -4.368,
              "y": 33.721,
              "z": 1.353
            },
            "rightCorner": {
              "x": -4.3,
              "y": 33.717,
              "z": 1.353
            },
            "gtin": "4030651053540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe51",
            "leftCorner": {
              "x": -4.301,
              "y": 33.697,
              "z": 1.353
            },
            "rightCorner": {
              "x": -4.249,
              "y": 33.694,
              "z": 1.353
            },
            "gtin": "4030651048294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe52",
            "leftCorner": {
              "x": -4.249,
              "y": 33.694,
              "z": 1.353
            },
            "rightCorner": {
              "x": -4.198,
              "y": 33.691,
              "z": 1.353
            },
            "gtin": "4030651048294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe53",
            "leftCorner": {
              "x": -4.198,
              "y": 33.688,
              "z": 1.353
            },
            "rightCorner": {
              "x": -4.136,
              "y": 33.684,
              "z": 1.353
            },
            "gtin": "4030651052772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe54",
            "leftCorner": {
              "x": -4.136,
              "y": 33.684,
              "z": 1.353
            },
            "rightCorner": {
              "x": -4.074,
              "y": 33.681,
              "z": 1.353
            },
            "gtin": "4030651052772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe55",
            "leftCorner": {
              "x": -4.074,
              "y": 33.686,
              "z": 1.353
            },
            "rightCorner": {
              "x": -3.973,
              "y": 33.679,
              "z": 1.353
            },
            "gtin": "4030651052031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe56",
            "leftCorner": {
              "x": -3.973,
              "y": 33.682,
              "z": 1.353
            },
            "rightCorner": {
              "x": -3.878,
              "y": 33.678,
              "z": 1.353
            },
            "gtin": "4008233153568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe57",
            "leftCorner": {
              "x": -3.878,
              "y": 33.676,
              "z": 1.353
            },
            "rightCorner": {
              "x": -3.748,
              "y": 33.668,
              "z": 1.353
            },
            "gtin": "4008233153575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe58",
            "leftCorner": {
              "x": -3.748,
              "y": 33.667,
              "z": 1.353
            },
            "rightCorner": {
              "x": -3.653,
              "y": 33.661,
              "z": 1.353
            },
            "gtin": "4008233175072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe59",
            "leftCorner": {
              "x": -3.653,
              "y": 33.661,
              "z": 1.353
            },
            "rightCorner": {
              "x": -3.558,
              "y": 33.655,
              "z": 1.353
            },
            "gtin": "4008233175072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe5a",
            "leftCorner": {
              "x": -3.558,
              "y": 33.655,
              "z": 1.353
            },
            "rightCorner": {
              "x": -3.433,
              "y": 33.648,
              "z": 1.353
            },
            "gtin": "4008491109772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe5b",
            "leftCorner": {
              "x": -3.433,
              "y": 33.653,
              "z": 1.353
            },
            "rightCorner": {
              "x": -3.307,
              "y": 33.646,
              "z": 1.353
            },
            "gtin": "4008491207546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe5c",
            "leftCorner": {
              "x": -3.307,
              "y": 33.645,
              "z": 1.353
            },
            "rightCorner": {
              "x": -3.23,
              "y": 33.64,
              "z": 1.353
            },
            "gtin": "4059779040164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe5d",
            "leftCorner": {
              "x": -3.23,
              "y": 33.64,
              "z": 1.353
            },
            "rightCorner": {
              "x": -3.12,
              "y": 33.634,
              "z": 1.353
            },
            "gtin": "4059779023051",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468b7",
    "rightNeighborShelfId": "468b9"
  },
  {
    "id": "468b9",
    "name": "468b9",
    "x": -3.108,
    "y": 33.494,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.029335,
      "w": 0.99957
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 92
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5465ce",
        "height": 0.16398,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1ff06",
            "leftCorner": {
              "x": -3.073,
              "y": 33.542,
              "z": 0.134
            },
            "rightCorner": {
              "x": -2.979,
              "y": 33.536,
              "z": 0.134
            },
            "gtin": "4013718065281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff07",
            "leftCorner": {
              "x": -2.979,
              "y": 33.536,
              "z": 0.134
            },
            "rightCorner": {
              "x": -2.885,
              "y": 33.531,
              "z": 0.134
            },
            "gtin": "4013718065281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff08",
            "leftCorner": {
              "x": -2.885,
              "y": 33.531,
              "z": 0.134
            },
            "rightCorner": {
              "x": -2.791,
              "y": 33.525,
              "z": 0.134
            },
            "gtin": "4013718065281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff09",
            "leftCorner": {
              "x": -2.791,
              "y": 33.525,
              "z": 0.134
            },
            "rightCorner": {
              "x": -2.697,
              "y": 33.52,
              "z": 0.134
            },
            "gtin": "4013718065281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff0a",
            "leftCorner": {
              "x": -2.697,
              "y": 33.516,
              "z": 0.134
            },
            "rightCorner": {
              "x": -2.614,
              "y": 33.511,
              "z": 0.134
            },
            "gtin": "4068829387906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff0b",
            "leftCorner": {
              "x": -2.614,
              "y": 33.511,
              "z": 0.134
            },
            "rightCorner": {
              "x": -2.531,
              "y": 33.506,
              "z": 0.134
            },
            "gtin": "4068829387906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff0c",
            "leftCorner": {
              "x": -2.531,
              "y": 33.506,
              "z": 0.134
            },
            "rightCorner": {
              "x": -2.448,
              "y": 33.501,
              "z": 0.134
            },
            "gtin": "4068829387906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff0d",
            "leftCorner": {
              "x": -2.448,
              "y": 33.501,
              "z": 0.134
            },
            "rightCorner": {
              "x": -2.364,
              "y": 33.496,
              "z": 0.134
            },
            "gtin": "4068829387906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff0e",
            "leftCorner": {
              "x": -2.364,
              "y": 33.504,
              "z": 0.134
            },
            "rightCorner": {
              "x": -2.288,
              "y": 33.5,
              "z": 0.134
            },
            "gtin": "4063367419522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff0f",
            "leftCorner": {
              "x": -2.288,
              "y": 33.5,
              "z": 0.134
            },
            "rightCorner": {
              "x": -2.213,
              "y": 33.495,
              "z": 0.134
            },
            "gtin": "4063367419522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff10",
            "leftCorner": {
              "x": -2.213,
              "y": 33.486,
              "z": 0.134
            },
            "rightCorner": {
              "x": -2.125,
              "y": 33.481,
              "z": 0.134
            },
            "gtin": "4306188359548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff11",
            "leftCorner": {
              "x": -2.125,
              "y": 33.481,
              "z": 0.134
            },
            "rightCorner": {
              "x": -2.037,
              "y": 33.476,
              "z": 0.134
            },
            "gtin": "4306188359548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff12",
            "leftCorner": {
              "x": -2.038,
              "y": 33.463,
              "z": 0.134
            },
            "rightCorner": {
              "x": -1.933,
              "y": 33.457,
              "z": 0.134
            },
            "gtin": "4008233157276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff13",
            "leftCorner": {
              "x": -1.933,
              "y": 33.457,
              "z": 0.134
            },
            "rightCorner": {
              "x": -1.828,
              "y": 33.45,
              "z": 0.134
            },
            "gtin": "4008233157276",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465cb",
        "height": 0.53829,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2034e",
            "leftCorner": {
              "x": -3.102,
              "y": 33.605,
              "z": 0.44
            },
            "rightCorner": {
              "x": -3.029,
              "y": 33.601,
              "z": 0.44
            },
            "gtin": "4012452041742",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2034f",
            "leftCorner": {
              "x": -3.029,
              "y": 33.601,
              "z": 0.44
            },
            "rightCorner": {
              "x": -2.957,
              "y": 33.596,
              "z": 0.44
            },
            "gtin": "4012452041742",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20350",
            "leftCorner": {
              "x": -2.957,
              "y": 33.596,
              "z": 0.44
            },
            "rightCorner": {
              "x": -2.884,
              "y": 33.592,
              "z": 0.44
            },
            "gtin": "4012452041742",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20352",
            "leftCorner": {
              "x": -2.883,
              "y": 33.618,
              "z": 0.44
            },
            "rightCorner": {
              "x": -2.801,
              "y": 33.613,
              "z": 0.44
            },
            "gtin": "4012452041759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20353",
            "leftCorner": {
              "x": -2.801,
              "y": 33.613,
              "z": 0.44
            },
            "rightCorner": {
              "x": -2.719,
              "y": 33.608,
              "z": 0.44
            },
            "gtin": "4012452041759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20354",
            "leftCorner": {
              "x": -2.719,
              "y": 33.608,
              "z": 0.44
            },
            "rightCorner": {
              "x": -2.636,
              "y": 33.603,
              "z": 0.44
            },
            "gtin": "4012452041759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20355",
            "leftCorner": {
              "x": -2.636,
              "y": 33.603,
              "z": 0.44
            },
            "rightCorner": {
              "x": -2.554,
              "y": 33.599,
              "z": 0.44
            },
            "gtin": "4012452041759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20356",
            "leftCorner": {
              "x": -2.554,
              "y": 33.599,
              "z": 0.44
            },
            "rightCorner": {
              "x": -2.472,
              "y": 33.594,
              "z": 0.44
            },
            "gtin": "4012452041759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20357",
            "leftCorner": {
              "x": -2.471,
              "y": 33.617,
              "z": 0.44
            },
            "rightCorner": {
              "x": -2.362,
              "y": 33.61,
              "z": 0.44
            },
            "gtin": "4008890006504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20358",
            "leftCorner": {
              "x": -2.362,
              "y": 33.61,
              "z": 0.44
            },
            "rightCorner": {
              "x": -2.253,
              "y": 33.604,
              "z": 0.44
            },
            "gtin": "4008890006504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20359",
            "leftCorner": {
              "x": -2.253,
              "y": 33.601,
              "z": 0.44
            },
            "rightCorner": {
              "x": -2.184,
              "y": 33.597,
              "z": 0.44
            },
            "gtin": "4337185592683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2035a",
            "leftCorner": {
              "x": -2.184,
              "y": 33.597,
              "z": 0.44
            },
            "rightCorner": {
              "x": -2.115,
              "y": 33.593,
              "z": 0.44
            },
            "gtin": "4337185592683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2035b",
            "leftCorner": {
              "x": -2.115,
              "y": 33.588,
              "z": 0.44
            },
            "rightCorner": {
              "x": -2.061,
              "y": 33.584,
              "z": 0.44
            },
            "gtin": "4337185592768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2035c",
            "leftCorner": {
              "x": -2.061,
              "y": 33.584,
              "z": 0.44
            },
            "rightCorner": {
              "x": -2.007,
              "y": 33.581,
              "z": 0.44
            },
            "gtin": "4337185592768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2035d",
            "leftCorner": {
              "x": -2.007,
              "y": 33.583,
              "z": 0.44
            },
            "rightCorner": {
              "x": -1.918,
              "y": 33.578,
              "z": 0.44
            },
            "gtin": "4011609011096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20351",
            "leftCorner": {
              "x": -1.917,
              "y": 33.581,
              "z": 0.44
            },
            "rightCorner": {
              "x": -1.851,
              "y": 33.577,
              "z": 0.44
            },
            "gtin": "4008491128476",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465cd",
        "height": 0.88871,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20370",
            "leftCorner": {
              "x": -3.102,
              "y": 33.593,
              "z": 0.727
            },
            "rightCorner": {
              "x": -3.022,
              "y": 33.588,
              "z": 0.727
            },
            "gtin": "4008233172064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20371",
            "leftCorner": {
              "x": -3.022,
              "y": 33.588,
              "z": 0.727
            },
            "rightCorner": {
              "x": -2.942,
              "y": 33.583,
              "z": 0.727
            },
            "gtin": "4008233172064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20372",
            "leftCorner": {
              "x": -2.942,
              "y": 33.583,
              "z": 0.727
            },
            "rightCorner": {
              "x": -2.861,
              "y": 33.579,
              "z": 0.727
            },
            "gtin": "4008233172064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20375",
            "leftCorner": {
              "x": -2.858,
              "y": 33.626,
              "z": 0.727
            },
            "rightCorner": {
              "x": -2.77,
              "y": 33.62,
              "z": 0.727
            },
            "gtin": "4008233157191",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20376",
            "leftCorner": {
              "x": -2.77,
              "y": 33.62,
              "z": 0.727
            },
            "rightCorner": {
              "x": -2.681,
              "y": 33.615,
              "z": 0.727
            },
            "gtin": "4008233157191",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20377",
            "leftCorner": {
              "x": -2.681,
              "y": 33.615,
              "z": 0.727
            },
            "rightCorner": {
              "x": -2.592,
              "y": 33.61,
              "z": 0.727
            },
            "gtin": "4008233157191",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20378",
            "leftCorner": {
              "x": -2.592,
              "y": 33.61,
              "z": 0.727
            },
            "rightCorner": {
              "x": -2.503,
              "y": 33.605,
              "z": 0.727
            },
            "gtin": "4008233157191",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20379",
            "leftCorner": {
              "x": -2.503,
              "y": 33.605,
              "z": 0.727
            },
            "rightCorner": {
              "x": -2.414,
              "y": 33.599,
              "z": 0.727
            },
            "gtin": "4008233157191",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2037a",
            "leftCorner": {
              "x": -2.415,
              "y": 33.586,
              "z": 0.727
            },
            "rightCorner": {
              "x": -2.329,
              "y": 33.581,
              "z": 0.727
            },
            "gtin": "4008233177670",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2037b",
            "leftCorner": {
              "x": -2.329,
              "y": 33.581,
              "z": 0.727
            },
            "rightCorner": {
              "x": -2.242,
              "y": 33.576,
              "z": 0.727
            },
            "gtin": "4008233177670",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2037c",
            "leftCorner": {
              "x": -2.241,
              "y": 33.591,
              "z": 0.727
            },
            "rightCorner": {
              "x": -2.153,
              "y": 33.586,
              "z": 0.727
            },
            "gtin": "4008233172057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2037d",
            "leftCorner": {
              "x": -2.153,
              "y": 33.586,
              "z": 0.727
            },
            "rightCorner": {
              "x": -2.064,
              "y": 33.581,
              "z": 0.727
            },
            "gtin": "4008233172057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2037e",
            "leftCorner": {
              "x": -2.064,
              "y": 33.581,
              "z": 0.727
            },
            "rightCorner": {
              "x": -1.976,
              "y": 33.575,
              "z": 0.727
            },
            "gtin": "4008233172057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20373",
            "leftCorner": {
              "x": -1.976,
              "y": 33.577,
              "z": 0.727
            },
            "rightCorner": {
              "x": -1.914,
              "y": 33.574,
              "z": 0.727
            },
            "gtin": "4008233172040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20374",
            "leftCorner": {
              "x": -1.914,
              "y": 33.574,
              "z": 0.727
            },
            "rightCorner": {
              "x": -1.851,
              "y": 33.57,
              "z": 0.727
            },
            "gtin": "4008233172040",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465cc",
        "height": 1.1459,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2035e",
            "leftCorner": {
              "x": -3.103,
              "y": 33.581,
              "z": 0.938
            },
            "rightCorner": {
              "x": -3.034,
              "y": 33.577,
              "z": 0.938
            },
            "gtin": "4008233080093",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20360",
            "leftCorner": {
              "x": -3.033,
              "y": 33.597,
              "z": 0.938
            },
            "rightCorner": {
              "x": -2.974,
              "y": 33.593,
              "z": 0.938
            },
            "gtin": "4008233124056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20361",
            "leftCorner": {
              "x": -2.974,
              "y": 33.593,
              "z": 0.938
            },
            "rightCorner": {
              "x": -2.915,
              "y": 33.59,
              "z": 0.938
            },
            "gtin": "4008233124056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20362",
            "leftCorner": {
              "x": -2.915,
              "y": 33.599,
              "z": 0.938
            },
            "rightCorner": {
              "x": -2.875,
              "y": 33.596,
              "z": 0.938
            },
            "gtin": "4008233061580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20363",
            "leftCorner": {
              "x": -2.875,
              "y": 33.596,
              "z": 0.938
            },
            "rightCorner": {
              "x": -2.835,
              "y": 33.594,
              "z": 0.938
            },
            "gtin": "4008233061580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20364",
            "leftCorner": {
              "x": -2.834,
              "y": 33.6,
              "z": 0.938
            },
            "rightCorner": {
              "x": -2.771,
              "y": 33.596,
              "z": 0.938
            },
            "gtin": "4008233060514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20365",
            "leftCorner": {
              "x": -2.771,
              "y": 33.594,
              "z": 0.938
            },
            "rightCorner": {
              "x": -2.709,
              "y": 33.591,
              "z": 0.938
            },
            "gtin": "4008233119984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20366",
            "leftCorner": {
              "x": -2.709,
              "y": 33.596,
              "z": 0.938
            },
            "rightCorner": {
              "x": -2.651,
              "y": 33.592,
              "z": 0.938
            },
            "gtin": "4008233052250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20367",
            "leftCorner": {
              "x": -2.651,
              "y": 33.592,
              "z": 0.938
            },
            "rightCorner": {
              "x": -2.593,
              "y": 33.589,
              "z": 0.938
            },
            "gtin": "4008233052250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20368",
            "leftCorner": {
              "x": -2.592,
              "y": 33.605,
              "z": 0.938
            },
            "rightCorner": {
              "x": -2.507,
              "y": 33.6,
              "z": 0.938
            },
            "gtin": "4008233038438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20369",
            "leftCorner": {
              "x": -2.508,
              "y": 33.597,
              "z": 0.938
            },
            "rightCorner": {
              "x": -2.455,
              "y": 33.594,
              "z": 0.938
            },
            "gtin": "4008233177625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2036a",
            "leftCorner": {
              "x": -2.455,
              "y": 33.594,
              "z": 0.938
            },
            "rightCorner": {
              "x": -2.402,
              "y": 33.591,
              "z": 0.938
            },
            "gtin": "4008233177625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2036b",
            "leftCorner": {
              "x": -2.403,
              "y": 33.581,
              "z": 0.938
            },
            "rightCorner": {
              "x": -2.344,
              "y": 33.577,
              "z": 0.938
            },
            "gtin": "4008491111843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2036c",
            "leftCorner": {
              "x": -2.344,
              "y": 33.577,
              "z": 0.938
            },
            "rightCorner": {
              "x": -2.285,
              "y": 33.574,
              "z": 0.938
            },
            "gtin": "4008491111843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2036d",
            "leftCorner": {
              "x": -2.284,
              "y": 33.588,
              "z": 0.938
            },
            "rightCorner": {
              "x": -2.204,
              "y": 33.583,
              "z": 0.938
            },
            "gtin": "4008491111805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2036e",
            "leftCorner": {
              "x": -2.204,
              "y": 33.584,
              "z": 0.938
            },
            "rightCorner": {
              "x": -2.064,
              "y": 33.576,
              "z": 0.938
            },
            "gtin": "4002448137634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2036f",
            "leftCorner": {
              "x": -2.064,
              "y": 33.576,
              "z": 0.938
            },
            "rightCorner": {
              "x": -1.924,
              "y": 33.567,
              "z": 0.938
            },
            "gtin": "4002448137634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2035f",
            "leftCorner": {
              "x": -1.925,
              "y": 33.56,
              "z": 0.938
            },
            "rightCorner": {
              "x": -1.852,
              "y": 33.556,
              "z": 0.938
            },
            "gtin": "4002448110743",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465c9",
        "height": 1.3959,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20319",
            "leftCorner": {
              "x": -3.102,
              "y": 33.596,
              "z": 1.142
            },
            "rightCorner": {
              "x": -3.049,
              "y": 33.593,
              "z": 1.142
            },
            "gtin": "4008491102919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2031a",
            "leftCorner": {
              "x": -3.049,
              "y": 33.593,
              "z": 1.142
            },
            "rightCorner": {
              "x": -2.997,
              "y": 33.59,
              "z": 1.142
            },
            "gtin": "4008491102919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2031c",
            "leftCorner": {
              "x": -2.995,
              "y": 33.619,
              "z": 1.142
            },
            "rightCorner": {
              "x": -2.869,
              "y": 33.611,
              "z": 1.142
            },
            "gtin": "4008491126878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2031d",
            "leftCorner": {
              "x": -2.869,
              "y": 33.619,
              "z": 1.142
            },
            "rightCorner": {
              "x": -2.784,
              "y": 33.614,
              "z": 1.142
            },
            "gtin": "4008491130608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2031e",
            "leftCorner": {
              "x": -2.784,
              "y": 33.615,
              "z": 1.142
            },
            "rightCorner": {
              "x": -2.674,
              "y": 33.609,
              "z": 1.142
            },
            "gtin": "4008491130646",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2031f",
            "leftCorner": {
              "x": -2.673,
              "y": 33.616,
              "z": 1.142
            },
            "rightCorner": {
              "x": -2.575,
              "y": 33.61,
              "z": 1.142
            },
            "gtin": "4008491132725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20320",
            "leftCorner": {
              "x": -2.576,
              "y": 33.593,
              "z": 1.142
            },
            "rightCorner": {
              "x": -2.474,
              "y": 33.587,
              "z": 1.142
            },
            "gtin": "4008491103794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20321",
            "leftCorner": {
              "x": -2.474,
              "y": 33.602,
              "z": 1.142
            },
            "rightCorner": {
              "x": -2.366,
              "y": 33.595,
              "z": 1.142
            },
            "gtin": "4008233108575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20322",
            "leftCorner": {
              "x": -2.367,
              "y": 33.576,
              "z": 1.142
            },
            "rightCorner": {
              "x": -2.243,
              "y": 33.569,
              "z": 1.142
            },
            "gtin": "4065331003850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20323",
            "leftCorner": {
              "x": -2.242,
              "y": 33.579,
              "z": 1.142
            },
            "rightCorner": {
              "x": -2.16,
              "y": 33.574,
              "z": 1.142
            },
            "gtin": "4017512209209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20324",
            "leftCorner": {
              "x": -2.16,
              "y": 33.58,
              "z": 1.142
            },
            "rightCorner": {
              "x": -2.105,
              "y": 33.577,
              "z": 1.142
            },
            "gtin": "083800064984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20325",
            "leftCorner": {
              "x": -2.105,
              "y": 33.579,
              "z": 1.142
            },
            "rightCorner": {
              "x": -1.987,
              "y": 33.572,
              "z": 1.142
            },
            "gtin": "4002448110774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20326",
            "leftCorner": {
              "x": -1.987,
              "y": 33.57,
              "z": 1.142
            },
            "rightCorner": {
              "x": -1.915,
              "y": 33.566,
              "z": 1.142
            },
            "gtin": "5000204093711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20327",
            "leftCorner": {
              "x": -1.915,
              "y": 33.567,
              "z": 1.142
            },
            "rightCorner": {
              "x": -1.846,
              "y": 33.563,
              "z": 1.142
            },
            "gtin": "5000204093681",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465ca",
        "height": 1.648,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fe5e",
            "leftCorner": {
              "x": -3.12,
              "y": 33.621,
              "z": 1.348
            },
            "rightCorner": {
              "x": -3.032,
              "y": 33.616,
              "z": 1.348
            },
            "gtin": "4008491108522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe5f",
            "leftCorner": {
              "x": -3.033,
              "y": 33.608,
              "z": 1.348
            },
            "rightCorner": {
              "x": -2.986,
              "y": 33.605,
              "z": 1.348
            },
            "gtin": "4008491101349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe60",
            "leftCorner": {
              "x": -2.986,
              "y": 33.605,
              "z": 1.348
            },
            "rightCorner": {
              "x": -2.939,
              "y": 33.602,
              "z": 1.348
            },
            "gtin": "4008491101349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe61",
            "leftCorner": {
              "x": -2.938,
              "y": 33.614,
              "z": 1.348
            },
            "rightCorner": {
              "x": -2.835,
              "y": 33.608,
              "z": 1.348
            },
            "gtin": "4008491110013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe62",
            "leftCorner": {
              "x": -2.835,
              "y": 33.617,
              "z": 1.348
            },
            "rightCorner": {
              "x": -2.707,
              "y": 33.61,
              "z": 1.348
            },
            "gtin": "4008491100182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe63",
            "leftCorner": {
              "x": -2.707,
              "y": 33.606,
              "z": 1.348
            },
            "rightCorner": {
              "x": -2.641,
              "y": 33.602,
              "z": 1.348
            },
            "gtin": "4008233174488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe64",
            "leftCorner": {
              "x": -2.641,
              "y": 33.602,
              "z": 1.348
            },
            "rightCorner": {
              "x": -2.575,
              "y": 33.598,
              "z": 1.348
            },
            "gtin": "4008233174488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe65",
            "leftCorner": {
              "x": -2.574,
              "y": 33.612,
              "z": 1.348
            },
            "rightCorner": {
              "x": -2.461,
              "y": 33.605,
              "z": 1.348
            },
            "gtin": "4008233172347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe66",
            "leftCorner": {
              "x": -2.462,
              "y": 33.592,
              "z": 1.348
            },
            "rightCorner": {
              "x": -2.352,
              "y": 33.586,
              "z": 1.348
            },
            "gtin": "4008233176420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe67",
            "leftCorner": {
              "x": -2.352,
              "y": 33.593,
              "z": 1.348
            },
            "rightCorner": {
              "x": -2.293,
              "y": 33.589,
              "z": 1.348
            },
            "gtin": "4059779031711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe68",
            "leftCorner": {
              "x": -2.293,
              "y": 33.589,
              "z": 1.348
            },
            "rightCorner": {
              "x": -2.233,
              "y": 33.586,
              "z": 1.348
            },
            "gtin": "4059779031711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe69",
            "leftCorner": {
              "x": -2.233,
              "y": 33.585,
              "z": 1.348
            },
            "rightCorner": {
              "x": -2.107,
              "y": 33.577,
              "z": 1.348
            },
            "gtin": "4059779035832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe6a",
            "leftCorner": {
              "x": -2.107,
              "y": 33.58,
              "z": 1.348
            },
            "rightCorner": {
              "x": -2.017,
              "y": 33.575,
              "z": 1.348
            },
            "gtin": "4006671299008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe6b",
            "leftCorner": {
              "x": -2.017,
              "y": 33.577,
              "z": 1.348
            },
            "rightCorner": {
              "x": -1.963,
              "y": 33.574,
              "z": 1.348
            },
            "gtin": "4008576408684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe6c",
            "leftCorner": {
              "x": -1.962,
              "y": 33.578,
              "z": 1.348
            },
            "rightCorner": {
              "x": -1.903,
              "y": 33.574,
              "z": 1.348
            },
            "gtin": "4008576408646",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468b8",
    "rightNeighborShelfId": "468ba"
  },
  {
    "id": "468ba",
    "name": "468ba",
    "x": -1.86,
    "y": 33.421,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.029335,
      "w": 0.99957
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 101
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5465cf",
        "height": 0.16768,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1ff14",
            "leftCorner": {
              "x": -1.826,
              "y": 33.474,
              "z": 0.137
            },
            "rightCorner": {
              "x": -1.72,
              "y": 33.467,
              "z": 0.137
            },
            "gtin": "4337185878534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff15",
            "leftCorner": {
              "x": -1.721,
              "y": 33.456,
              "z": 0.137
            },
            "rightCorner": {
              "x": -1.661,
              "y": 33.452,
              "z": 0.137
            },
            "gtin": "4337185597602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff16",
            "leftCorner": {
              "x": -1.661,
              "y": 33.452,
              "z": 0.137
            },
            "rightCorner": {
              "x": -1.601,
              "y": 33.45,
              "z": 0.137
            },
            "gtin": "4337185597602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff17",
            "leftCorner": {
              "x": -1.601,
              "y": 33.454,
              "z": 0.137
            },
            "rightCorner": {
              "x": -1.527,
              "y": 33.45,
              "z": 0.137
            },
            "gtin": "8717729181102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff18",
            "leftCorner": {
              "x": -1.527,
              "y": 33.445,
              "z": 0.137
            },
            "rightCorner": {
              "x": -1.472,
              "y": 33.441,
              "z": 0.137
            },
            "gtin": "8717729181133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff19",
            "leftCorner": {
              "x": -1.472,
              "y": 33.441,
              "z": 0.137
            },
            "rightCorner": {
              "x": -1.417,
              "y": 33.439,
              "z": 0.137
            },
            "gtin": "8717729181133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff1a",
            "leftCorner": {
              "x": -1.417,
              "y": 33.439,
              "z": 0.137
            },
            "rightCorner": {
              "x": -1.362,
              "y": 33.435,
              "z": 0.137
            },
            "gtin": "8717729181133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff1b",
            "leftCorner": {
              "x": -1.362,
              "y": 33.427,
              "z": 0.137
            },
            "rightCorner": {
              "x": -1.32,
              "y": 33.425,
              "z": 0.137
            },
            "gtin": "4063367218156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff1c",
            "leftCorner": {
              "x": -1.32,
              "y": 33.425,
              "z": 0.137
            },
            "rightCorner": {
              "x": -1.279,
              "y": 33.423,
              "z": 0.137
            },
            "gtin": "4063367218156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff1d",
            "leftCorner": {
              "x": -1.279,
              "y": 33.423,
              "z": 0.137
            },
            "rightCorner": {
              "x": -1.237,
              "y": 33.42,
              "z": 0.137
            },
            "gtin": "4063367218156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff1e",
            "leftCorner": {
              "x": -1.236,
              "y": 33.43,
              "z": 0.137
            },
            "rightCorner": {
              "x": -1.156,
              "y": 33.426,
              "z": 0.137
            },
            "gtin": "5704947015893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff1f",
            "leftCorner": {
              "x": -1.155,
              "y": 33.428,
              "z": 0.137
            },
            "rightCorner": {
              "x": -1.052,
              "y": 33.422,
              "z": 0.137
            },
            "gtin": "4036581537389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff20",
            "leftCorner": {
              "x": -1.052,
              "y": 33.42,
              "z": 0.137
            },
            "rightCorner": {
              "x": -0.952,
              "y": 33.414,
              "z": 0.137
            },
            "gtin": "4002448153184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff21",
            "leftCorner": {
              "x": -0.951,
              "y": 33.432,
              "z": 0.137
            },
            "rightCorner": {
              "x": -0.802,
              "y": 33.423,
              "z": 0.137
            },
            "gtin": "4002448137719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff22",
            "leftCorner": {
              "x": -0.803,
              "y": 33.418,
              "z": 0.137
            },
            "rightCorner": {
              "x": -0.694,
              "y": 33.412,
              "z": 0.137
            },
            "gtin": "4048976172648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff23",
            "leftCorner": {
              "x": -0.694,
              "y": 33.412,
              "z": 0.137
            },
            "rightCorner": {
              "x": -0.584,
              "y": 33.406,
              "z": 0.137
            },
            "gtin": "4048976172648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff24",
            "leftCorner": {
              "x": -0.584,
              "y": 33.406,
              "z": 0.137
            },
            "rightCorner": {
              "x": -0.475,
              "y": 33.399,
              "z": 0.137
            },
            "gtin": "4048976172648",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465d4",
        "height": 0.4498,
        "facings": [
          {
            "id": "68300c895ed67a01d9a203bc",
            "leftCorner": {
              "x": -1.853,
              "y": 33.541,
              "z": 0.368
            },
            "rightCorner": {
              "x": -1.778,
              "y": 33.537,
              "z": 0.368
            },
            "gtin": "4011609011041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203bd",
            "leftCorner": {
              "x": -1.778,
              "y": 33.537,
              "z": 0.368
            },
            "rightCorner": {
              "x": -1.704,
              "y": 33.533,
              "z": 0.368
            },
            "gtin": "4011609011041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203be",
            "leftCorner": {
              "x": -1.704,
              "y": 33.533,
              "z": 0.368
            },
            "rightCorner": {
              "x": -1.629,
              "y": 33.528,
              "z": 0.368
            },
            "gtin": "4011609011041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203bf",
            "leftCorner": {
              "x": -1.629,
              "y": 33.528,
              "z": 0.368
            },
            "rightCorner": {
              "x": -1.555,
              "y": 33.523,
              "z": 0.368
            },
            "gtin": "4011609011041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203c1",
            "leftCorner": {
              "x": -1.553,
              "y": 33.543,
              "z": 0.368
            },
            "rightCorner": {
              "x": -1.4,
              "y": 33.535,
              "z": 0.368
            },
            "gtin": "4337185592553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203c2",
            "leftCorner": {
              "x": -1.399,
              "y": 33.548,
              "z": 0.368
            },
            "rightCorner": {
              "x": -1.327,
              "y": 33.544,
              "z": 0.368
            },
            "gtin": "4011609011058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203c3",
            "leftCorner": {
              "x": -1.326,
              "y": 33.552,
              "z": 0.368
            },
            "rightCorner": {
              "x": -1.258,
              "y": 33.547,
              "z": 0.368
            },
            "gtin": "4011609011072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203c4",
            "leftCorner": {
              "x": -1.258,
              "y": 33.547,
              "z": 0.368
            },
            "rightCorner": {
              "x": -1.177,
              "y": 33.543,
              "z": 0.368
            },
            "gtin": "4063367176036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203c5",
            "leftCorner": {
              "x": -1.177,
              "y": 33.543,
              "z": 0.368
            },
            "rightCorner": {
              "x": -1.082,
              "y": 33.538,
              "z": 0.368
            },
            "gtin": "4011609011102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203c6",
            "leftCorner": {
              "x": -1.082,
              "y": 33.531,
              "z": 0.368
            },
            "rightCorner": {
              "x": -1.023,
              "y": 33.528,
              "z": 0.368
            },
            "gtin": "4011609011034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203c7",
            "leftCorner": {
              "x": -1.023,
              "y": 33.528,
              "z": 0.368
            },
            "rightCorner": {
              "x": -0.964,
              "y": 33.524,
              "z": 0.368
            },
            "gtin": "4011609011034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203c8",
            "leftCorner": {
              "x": -0.964,
              "y": 33.522,
              "z": 0.368
            },
            "rightCorner": {
              "x": -0.873,
              "y": 33.517,
              "z": 0.368
            },
            "gtin": "4011609011027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203c9",
            "leftCorner": {
              "x": -0.873,
              "y": 33.525,
              "z": 0.368
            },
            "rightCorner": {
              "x": -0.819,
              "y": 33.522,
              "z": 0.368
            },
            "gtin": "4005800325274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203ca",
            "leftCorner": {
              "x": -0.819,
              "y": 33.522,
              "z": 0.368
            },
            "rightCorner": {
              "x": -0.765,
              "y": 33.519,
              "z": 0.368
            },
            "gtin": "4005800325274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203cb",
            "leftCorner": {
              "x": -0.765,
              "y": 33.521,
              "z": 0.368
            },
            "rightCorner": {
              "x": -0.677,
              "y": 33.516,
              "z": 0.368
            },
            "gtin": "4005800187834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203cc",
            "leftCorner": {
              "x": -0.678,
              "y": 33.504,
              "z": 0.368
            },
            "rightCorner": {
              "x": -0.619,
              "y": 33.5,
              "z": 0.368
            },
            "gtin": "4005800278501",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465d0",
        "height": 0.70066,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20381",
            "leftCorner": {
              "x": -1.831,
              "y": 33.56,
              "z": 0.573
            },
            "rightCorner": {
              "x": -1.746,
              "y": 33.555,
              "z": 0.573
            },
            "gtin": "5038483501092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20382",
            "leftCorner": {
              "x": -1.747,
              "y": 33.551,
              "z": 0.573
            },
            "rightCorner": {
              "x": -1.686,
              "y": 33.548,
              "z": 0.573
            },
            "gtin": "4002448134107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20383",
            "leftCorner": {
              "x": -1.686,
              "y": 33.549,
              "z": 0.573
            },
            "rightCorner": {
              "x": -1.64,
              "y": 33.546,
              "z": 0.573
            },
            "gtin": "4006671161275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20384",
            "leftCorner": {
              "x": -1.64,
              "y": 33.546,
              "z": 0.573
            },
            "rightCorner": {
              "x": -1.595,
              "y": 33.543,
              "z": 0.573
            },
            "gtin": "4006671161275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20385",
            "leftCorner": {
              "x": -1.596,
              "y": 33.532,
              "z": 0.573
            },
            "rightCorner": {
              "x": -1.546,
              "y": 33.529,
              "z": 0.573
            },
            "gtin": "5038483502662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20386",
            "leftCorner": {
              "x": -1.546,
              "y": 33.529,
              "z": 0.573
            },
            "rightCorner": {
              "x": -1.496,
              "y": 33.527,
              "z": 0.573
            },
            "gtin": "5038483502662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20387",
            "leftCorner": {
              "x": -1.494,
              "y": 33.549,
              "z": 0.573
            },
            "rightCorner": {
              "x": -1.419,
              "y": 33.544,
              "z": 0.573
            },
            "gtin": "4103040909787",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20388",
            "leftCorner": {
              "x": -1.42,
              "y": 33.538,
              "z": 0.573
            },
            "rightCorner": {
              "x": -1.322,
              "y": 33.532,
              "z": 0.573
            },
            "gtin": "4011609011089",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c895ed67a01d9a20389",
            "leftCorner": {
              "x": -1.322,
              "y": 33.534,
              "z": 0.573
            },
            "rightCorner": {
              "x": -1.278,
              "y": 33.531,
              "z": 0.573
            },
            "gtin": "4005800315190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2038a",
            "leftCorner": {
              "x": -1.278,
              "y": 33.531,
              "z": 0.573
            },
            "rightCorner": {
              "x": -1.234,
              "y": 33.529,
              "z": 0.573
            },
            "gtin": "4005800315190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2038b",
            "leftCorner": {
              "x": -1.233,
              "y": 33.539,
              "z": 0.573
            },
            "rightCorner": {
              "x": -1.142,
              "y": 33.534,
              "z": 0.573
            },
            "gtin": "4005800279119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2038c",
            "leftCorner": {
              "x": -1.141,
              "y": 33.539,
              "z": 0.573
            },
            "rightCorner": {
              "x": -1.04,
              "y": 33.532,
              "z": 0.573
            },
            "gtin": "4005800279133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2038d",
            "leftCorner": {
              "x": -1.04,
              "y": 33.53,
              "z": 0.573
            },
            "rightCorner": {
              "x": -0.946,
              "y": 33.524,
              "z": 0.573
            },
            "gtin": "4005800280689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2038e",
            "leftCorner": {
              "x": -0.947,
              "y": 33.512,
              "z": 0.573
            },
            "rightCorner": {
              "x": -0.841,
              "y": 33.506,
              "z": 0.573
            },
            "gtin": "4005800279768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2038f",
            "leftCorner": {
              "x": -0.84,
              "y": 33.518,
              "z": 0.573
            },
            "rightCorner": {
              "x": -0.797,
              "y": 33.515,
              "z": 0.573
            },
            "gtin": "4005800278549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20390",
            "leftCorner": {
              "x": -0.797,
              "y": 33.515,
              "z": 0.573
            },
            "rightCorner": {
              "x": -0.754,
              "y": 33.513,
              "z": 0.573
            },
            "gtin": "4005800278549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20391",
            "leftCorner": {
              "x": -0.754,
              "y": 33.511,
              "z": 0.573
            },
            "rightCorner": {
              "x": -0.708,
              "y": 33.509,
              "z": 0.573
            },
            "gtin": "4005800278563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20392",
            "leftCorner": {
              "x": -0.708,
              "y": 33.509,
              "z": 0.573
            },
            "rightCorner": {
              "x": -0.663,
              "y": 33.506,
              "z": 0.573
            },
            "gtin": "4005800278563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20393",
            "leftCorner": {
              "x": -0.664,
              "y": 33.494,
              "z": 0.573
            },
            "rightCorner": {
              "x": -0.63,
              "y": 33.491,
              "z": 0.573
            },
            "gtin": "4005800279782",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465d2",
        "height": 1.0483,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2039e",
            "leftCorner": {
              "x": -1.854,
              "y": 33.526,
              "z": 0.858
            },
            "rightCorner": {
              "x": -1.808,
              "y": 33.523,
              "z": 0.858
            },
            "gtin": "4005800041938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2039f",
            "leftCorner": {
              "x": -1.808,
              "y": 33.523,
              "z": 0.858
            },
            "rightCorner": {
              "x": -1.761,
              "y": 33.52,
              "z": 0.858
            },
            "gtin": "4005800041938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203a1",
            "leftCorner": {
              "x": -1.76,
              "y": 33.55,
              "z": 0.858
            },
            "rightCorner": {
              "x": -1.695,
              "y": 33.546,
              "z": 0.858
            },
            "gtin": "4006671002011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203a2",
            "leftCorner": {
              "x": -1.695,
              "y": 33.546,
              "z": 0.858
            },
            "rightCorner": {
              "x": -1.631,
              "y": 33.543,
              "z": 0.858
            },
            "gtin": "4006671002011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203a3",
            "leftCorner": {
              "x": -1.631,
              "y": 33.543,
              "z": 0.858
            },
            "rightCorner": {
              "x": -1.567,
              "y": 33.539,
              "z": 0.858
            },
            "gtin": "4006671002011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203a4",
            "leftCorner": {
              "x": -1.566,
              "y": 33.548,
              "z": 0.858
            },
            "rightCorner": {
              "x": -1.512,
              "y": 33.544,
              "z": 0.858
            },
            "gtin": "4006671036115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203a5",
            "leftCorner": {
              "x": -1.512,
              "y": 33.544,
              "z": 0.858
            },
            "rightCorner": {
              "x": -1.458,
              "y": 33.542,
              "z": 0.858
            },
            "gtin": "4006671036115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203a6",
            "leftCorner": {
              "x": -1.458,
              "y": 33.547,
              "z": 0.858
            },
            "rightCorner": {
              "x": -1.382,
              "y": 33.542,
              "z": 0.858
            },
            "gtin": "4006671321020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203a7",
            "leftCorner": {
              "x": -1.383,
              "y": 33.524,
              "z": 0.858
            },
            "rightCorner": {
              "x": -1.294,
              "y": 33.519,
              "z": 0.858
            },
            "gtin": "4002448152682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203a8",
            "leftCorner": {
              "x": -1.294,
              "y": 33.522,
              "z": 0.858
            },
            "rightCorner": {
              "x": -1.219,
              "y": 33.517,
              "z": 0.858
            },
            "gtin": "5052197006308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203a9",
            "leftCorner": {
              "x": -1.218,
              "y": 33.544,
              "z": 0.858
            },
            "rightCorner": {
              "x": -1.145,
              "y": 33.54,
              "z": 0.858
            },
            "gtin": "4036581536238",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203aa",
            "leftCorner": {
              "x": -1.145,
              "y": 33.538,
              "z": 0.858
            },
            "rightCorner": {
              "x": -1.078,
              "y": 33.534,
              "z": 0.858
            },
            "gtin": "4036581533602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203ab",
            "leftCorner": {
              "x": -1.078,
              "y": 33.529,
              "z": 0.858
            },
            "rightCorner": {
              "x": -0.998,
              "y": 33.524,
              "z": 0.858
            },
            "gtin": "4036581536269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203ac",
            "leftCorner": {
              "x": -0.999,
              "y": 33.517,
              "z": 0.858
            },
            "rightCorner": {
              "x": -0.902,
              "y": 33.511,
              "z": 0.858
            },
            "gtin": "4036581532650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203ad",
            "leftCorner": {
              "x": -0.902,
              "y": 33.508,
              "z": 0.858
            },
            "rightCorner": {
              "x": -0.805,
              "y": 33.502,
              "z": 0.858
            },
            "gtin": "4005800117510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203ae",
            "leftCorner": {
              "x": -0.805,
              "y": 33.499,
              "z": 0.858
            },
            "rightCorner": {
              "x": -0.73,
              "y": 33.495,
              "z": 0.858
            },
            "gtin": "4005800280023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203af",
            "leftCorner": {
              "x": -0.729,
              "y": 33.508,
              "z": 0.858
            },
            "rightCorner": {
              "x": -0.654,
              "y": 33.503,
              "z": 0.858
            },
            "gtin": "4005800281426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203b0",
            "leftCorner": {
              "x": -0.655,
              "y": 33.493,
              "z": 0.858
            },
            "rightCorner": {
              "x": -0.587,
              "y": 33.489,
              "z": 0.858
            },
            "gtin": "4005800283888",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465d3",
        "height": 1.4046,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20328",
            "leftCorner": {
              "x": -1.846,
              "y": 33.555,
              "z": 1.149
            },
            "rightCorner": {
              "x": -1.787,
              "y": 33.552,
              "z": 1.149
            },
            "gtin": "5000204253009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20329",
            "leftCorner": {
              "x": -1.787,
              "y": 33.548,
              "z": 1.149
            },
            "rightCorner": {
              "x": -1.707,
              "y": 33.543,
              "z": 1.149
            },
            "gtin": "5000204094015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2032a",
            "leftCorner": {
              "x": -1.707,
              "y": 33.537,
              "z": 1.149
            },
            "rightCorner": {
              "x": -1.625,
              "y": 33.532,
              "z": 1.149
            },
            "gtin": "4030169030040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2032b",
            "leftCorner": {
              "x": -1.625,
              "y": 33.527,
              "z": 1.149
            },
            "rightCorner": {
              "x": -1.534,
              "y": 33.521,
              "z": 1.149
            },
            "gtin": "4030169040834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2032c",
            "leftCorner": {
              "x": -1.533,
              "y": 33.53,
              "z": 1.149
            },
            "rightCorner": {
              "x": -1.482,
              "y": 33.528,
              "z": 1.149
            },
            "gtin": "4030169030033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2032d",
            "leftCorner": {
              "x": -1.482,
              "y": 33.536,
              "z": 1.149
            },
            "rightCorner": {
              "x": -1.395,
              "y": 33.531,
              "z": 1.149
            },
            "gtin": "3663555003833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2032e",
            "leftCorner": {
              "x": -1.395,
              "y": 33.536,
              "z": 1.149
            },
            "rightCorner": {
              "x": -1.314,
              "y": 33.531,
              "z": 1.149
            },
            "gtin": "3663555003789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2032f",
            "leftCorner": {
              "x": -1.315,
              "y": 33.513,
              "z": 1.149
            },
            "rightCorner": {
              "x": -1.218,
              "y": 33.507,
              "z": 1.149
            },
            "gtin": "3663555003802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20330",
            "leftCorner": {
              "x": -1.216,
              "y": 33.538,
              "z": 1.149
            },
            "rightCorner": {
              "x": -1.154,
              "y": 33.535,
              "z": 1.149
            },
            "gtin": "4005800086373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20331",
            "leftCorner": {
              "x": -1.154,
              "y": 33.535,
              "z": 1.149
            },
            "rightCorner": {
              "x": -1.092,
              "y": 33.531,
              "z": 1.149
            },
            "gtin": "4005800086373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20332",
            "leftCorner": {
              "x": -1.092,
              "y": 33.531,
              "z": 1.149
            },
            "rightCorner": {
              "x": -1.03,
              "y": 33.527,
              "z": 1.149
            },
            "gtin": "4005800086373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20333",
            "leftCorner": {
              "x": -1.03,
              "y": 33.526,
              "z": 1.149
            },
            "rightCorner": {
              "x": -0.957,
              "y": 33.522,
              "z": 1.149
            },
            "gtin": "9001398012294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20334",
            "leftCorner": {
              "x": -0.957,
              "y": 33.522,
              "z": 1.149
            },
            "rightCorner": {
              "x": -0.884,
              "y": 33.518,
              "z": 1.149
            },
            "gtin": "9001398012294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20335",
            "leftCorner": {
              "x": -0.884,
              "y": 33.511,
              "z": 1.149
            },
            "rightCorner": {
              "x": -0.781,
              "y": 33.505,
              "z": 1.149
            },
            "gtin": "4046871008956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20336",
            "leftCorner": {
              "x": -0.781,
              "y": 33.507,
              "z": 1.149
            },
            "rightCorner": {
              "x": -0.669,
              "y": 33.501,
              "z": 1.149
            },
            "gtin": "9001398011617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20337",
            "leftCorner": {
              "x": -0.669,
              "y": 33.502,
              "z": 1.149
            },
            "rightCorner": {
              "x": -0.589,
              "y": 33.497,
              "z": 1.149
            },
            "gtin": "4260473283027",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465d1",
        "height": 1.6538,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fe6d",
            "leftCorner": {
              "x": -1.882,
              "y": 33.561,
              "z": 1.353
            },
            "rightCorner": {
              "x": -1.821,
              "y": 33.557,
              "z": 1.353
            },
            "gtin": "4006293365822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe6e",
            "leftCorner": {
              "x": -1.821,
              "y": 33.555,
              "z": 1.353
            },
            "rightCorner": {
              "x": -1.718,
              "y": 33.549,
              "z": 1.353
            },
            "gtin": "4006293018322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe6f",
            "leftCorner": {
              "x": -1.716,
              "y": 33.57,
              "z": 1.353
            },
            "rightCorner": {
              "x": -1.63,
              "y": 33.565,
              "z": 1.353
            },
            "gtin": "4001065858106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe70",
            "leftCorner": {
              "x": -1.631,
              "y": 33.547,
              "z": 1.353
            },
            "rightCorner": {
              "x": -1.556,
              "y": 33.543,
              "z": 1.353
            },
            "gtin": "4001065858137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe71",
            "leftCorner": {
              "x": -1.555,
              "y": 33.557,
              "z": 1.353
            },
            "rightCorner": {
              "x": -1.463,
              "y": 33.551,
              "z": 1.353
            },
            "gtin": "4001065699600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe72",
            "leftCorner": {
              "x": -1.463,
              "y": 33.541,
              "z": 1.353
            },
            "rightCorner": {
              "x": -1.407,
              "y": 33.538,
              "z": 1.353
            },
            "gtin": "4001065699785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe73",
            "leftCorner": {
              "x": -1.407,
              "y": 33.545,
              "z": 1.353
            },
            "rightCorner": {
              "x": -1.332,
              "y": 33.541,
              "z": 1.353
            },
            "gtin": "4001065699754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe74",
            "leftCorner": {
              "x": -1.332,
              "y": 33.538,
              "z": 1.353
            },
            "rightCorner": {
              "x": -1.258,
              "y": 33.534,
              "z": 1.353
            },
            "gtin": "4001065699693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe75",
            "leftCorner": {
              "x": -1.258,
              "y": 33.539,
              "z": 1.353
            },
            "rightCorner": {
              "x": -1.167,
              "y": 33.534,
              "z": 1.353
            },
            "gtin": "4001065699662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe76",
            "leftCorner": {
              "x": -1.167,
              "y": 33.534,
              "z": 1.353
            },
            "rightCorner": {
              "x": -1.072,
              "y": 33.528,
              "z": 1.353
            },
            "gtin": "4001065699853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe77",
            "leftCorner": {
              "x": -1.072,
              "y": 33.529,
              "z": 1.353
            },
            "rightCorner": {
              "x": -0.984,
              "y": 33.525,
              "z": 1.353
            },
            "gtin": "4051089812318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe78",
            "leftCorner": {
              "x": -0.984,
              "y": 33.521,
              "z": 1.353
            },
            "rightCorner": {
              "x": -0.874,
              "y": 33.515,
              "z": 1.353
            },
            "gtin": "5038483962435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe79",
            "leftCorner": {
              "x": -0.875,
              "y": 33.499,
              "z": 1.353
            },
            "rightCorner": {
              "x": -0.778,
              "y": 33.493,
              "z": 1.353
            },
            "gtin": "5038483962466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe7a",
            "leftCorner": {
              "x": -0.778,
              "y": 33.49,
              "z": 1.353
            },
            "rightCorner": {
              "x": -0.709,
              "y": 33.486,
              "z": 1.353
            },
            "gtin": "5052197038484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe7b",
            "leftCorner": {
              "x": -0.708,
              "y": 33.504,
              "z": 1.353
            },
            "rightCorner": {
              "x": -0.661,
              "y": 33.501,
              "z": 1.353
            },
            "gtin": "4002448118459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe7c",
            "leftCorner": {
              "x": -0.661,
              "y": 33.501,
              "z": 1.353
            },
            "rightCorner": {
              "x": -0.614,
              "y": 33.498,
              "z": 1.353
            },
            "gtin": "4002448118459",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468b9",
    "rightNeighborShelfId": "468bb"
  },
  {
    "id": "468bb",
    "name": "468bb",
    "x": -0.612,
    "y": 33.348,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.029335,
      "w": 0.99957
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 81
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5465db",
        "height": 0.16739,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1ff25",
            "leftCorner": {
              "x": -0.476,
              "y": 33.381,
              "z": 0.137
            },
            "rightCorner": {
              "x": -0.423,
              "y": 33.377,
              "z": 0.137
            },
            "gtin": "4260695111160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff26",
            "leftCorner": {
              "x": -0.423,
              "y": 33.377,
              "z": 0.137
            },
            "rightCorner": {
              "x": -0.37,
              "y": 33.374,
              "z": 0.137
            },
            "gtin": "4260695111160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff27",
            "leftCorner": {
              "x": -0.37,
              "y": 33.376,
              "z": 0.137
            },
            "rightCorner": {
              "x": -0.292,
              "y": 33.372,
              "z": 0.137
            },
            "gtin": "4005800306105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff28",
            "leftCorner": {
              "x": -0.292,
              "y": 33.372,
              "z": 0.137
            },
            "rightCorner": {
              "x": -0.214,
              "y": 33.366,
              "z": 0.137
            },
            "gtin": "4005800306105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff29",
            "leftCorner": {
              "x": -0.213,
              "y": 33.37,
              "z": 0.137
            },
            "rightCorner": {
              "x": -0.147,
              "y": 33.367,
              "z": 0.137
            },
            "gtin": "4036581531905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff2a",
            "leftCorner": {
              "x": -0.147,
              "y": 33.367,
              "z": 0.137
            },
            "rightCorner": {
              "x": -0.082,
              "y": 33.362,
              "z": 0.137
            },
            "gtin": "4036581531905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff2b",
            "leftCorner": {
              "x": -0.082,
              "y": 33.357,
              "z": 0.137
            },
            "rightCorner": {
              "x": -0.011,
              "y": 33.352,
              "z": 0.137
            },
            "gtin": "4036581526178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff2c",
            "leftCorner": {
              "x": -0.011,
              "y": 33.352,
              "z": 0.137
            },
            "rightCorner": {
              "x": 0.06,
              "y": 33.348,
              "z": 0.137
            },
            "gtin": "4036581526178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff2d",
            "leftCorner": {
              "x": 0.06,
              "y": 33.356,
              "z": 0.137
            },
            "rightCorner": {
              "x": 0.129,
              "y": 33.352,
              "z": 0.137
            },
            "gtin": "4036581537303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff2e",
            "leftCorner": {
              "x": 0.129,
              "y": 33.352,
              "z": 0.137
            },
            "rightCorner": {
              "x": 0.198,
              "y": 33.348,
              "z": 0.137
            },
            "gtin": "4036581537303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff2f",
            "leftCorner": {
              "x": 0.198,
              "y": 33.343,
              "z": 0.137
            },
            "rightCorner": {
              "x": 0.335,
              "y": 33.335,
              "z": 0.137
            },
            "gtin": "4306188028123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff30",
            "leftCorner": {
              "x": 0.335,
              "y": 33.333,
              "z": 0.137
            },
            "rightCorner": {
              "x": 0.448,
              "y": 33.326,
              "z": 0.137
            },
            "gtin": "4306188028185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff31",
            "leftCorner": {
              "x": 0.447,
              "y": 33.311,
              "z": 0.137
            },
            "rightCorner": {
              "x": 0.556,
              "y": 33.305,
              "z": 0.137
            },
            "gtin": "4012994277203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fede",
            "leftCorner": {
              "x": 0.557,
              "y": 33.322,
              "z": 0.137
            },
            "rightCorner": {
              "x": 0.638,
              "y": 33.318,
              "z": 0.137
            },
            "gtin": "4027800400201",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465d8",
        "height": 0.45624,
        "facings": [
          {
            "id": "68300c895ed67a01d9a203cd",
            "leftCorner": {
              "x": -0.618,
              "y": 33.502,
              "z": 0.373
            },
            "rightCorner": {
              "x": -0.555,
              "y": 33.498,
              "z": 0.373
            },
            "gtin": "4005800001710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203ce",
            "leftCorner": {
              "x": -0.555,
              "y": 33.498,
              "z": 0.373
            },
            "rightCorner": {
              "x": -0.491,
              "y": 33.495,
              "z": 0.373
            },
            "gtin": "4005800001710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203cf",
            "leftCorner": {
              "x": -0.492,
              "y": 33.483,
              "z": 0.373
            },
            "rightCorner": {
              "x": -0.398,
              "y": 33.477,
              "z": 0.373
            },
            "gtin": "8712175938751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203d0",
            "leftCorner": {
              "x": -0.398,
              "y": 33.477,
              "z": 0.373
            },
            "rightCorner": {
              "x": -0.304,
              "y": 33.471,
              "z": 0.373
            },
            "gtin": "8712175938751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203d1",
            "leftCorner": {
              "x": -0.304,
              "y": 33.471,
              "z": 0.373
            },
            "rightCorner": {
              "x": -0.209,
              "y": 33.465,
              "z": 0.373
            },
            "gtin": "8712175938751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203d2",
            "leftCorner": {
              "x": -0.209,
              "y": 33.469,
              "z": 0.373
            },
            "rightCorner": {
              "x": -0.155,
              "y": 33.466,
              "z": 0.373
            },
            "gtin": "8712175938737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203d3",
            "leftCorner": {
              "x": -0.155,
              "y": 33.465,
              "z": 0.373
            },
            "rightCorner": {
              "x": -0.084,
              "y": 33.461,
              "z": 0.373
            },
            "gtin": "8712175938522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203d4",
            "leftCorner": {
              "x": -0.083,
              "y": 33.462,
              "z": 0.373
            },
            "rightCorner": {
              "x": 0.17,
              "y": 33.448,
              "z": 0.373
            },
            "gtin": "8712175938607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203d5",
            "leftCorner": {
              "x": 0.171,
              "y": 33.453,
              "z": 0.373
            },
            "rightCorner": {
              "x": 0.254,
              "y": 33.448,
              "z": 0.373
            },
            "gtin": "4306188373568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203d6",
            "leftCorner": {
              "x": 0.254,
              "y": 33.445,
              "z": 0.373
            },
            "rightCorner": {
              "x": 0.332,
              "y": 33.441,
              "z": 0.373
            },
            "gtin": "4306188373247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203d7",
            "leftCorner": {
              "x": 0.332,
              "y": 33.44,
              "z": 0.373
            },
            "rightCorner": {
              "x": 0.415,
              "y": 33.435,
              "z": 0.373
            },
            "gtin": "4306188373322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203d8",
            "leftCorner": {
              "x": 0.415,
              "y": 33.425,
              "z": 0.373
            },
            "rightCorner": {
              "x": 0.476,
              "y": 33.422,
              "z": 0.373
            },
            "gtin": "4306188373162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203d9",
            "leftCorner": {
              "x": 0.476,
              "y": 33.429,
              "z": 0.373
            },
            "rightCorner": {
              "x": 0.585,
              "y": 33.423,
              "z": 0.373
            },
            "gtin": "4012994191660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203c0",
            "leftCorner": {
              "x": 0.585,
              "y": 33.426,
              "z": 0.373
            },
            "rightCorner": {
              "x": 0.644,
              "y": 33.422,
              "z": 0.373
            },
            "gtin": "4036581526253",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465d6",
        "height": 0.6993,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20394",
            "leftCorner": {
              "x": -0.63,
              "y": 33.496,
              "z": 0.572
            },
            "rightCorner": {
              "x": -0.54,
              "y": 33.491,
              "z": 0.572
            },
            "gtin": "4005800197277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20395",
            "leftCorner": {
              "x": -0.54,
              "y": 33.491,
              "z": 0.572
            },
            "rightCorner": {
              "x": -0.44,
              "y": 33.485,
              "z": 0.572
            },
            "gtin": "4008600433729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20396",
            "leftCorner": {
              "x": -0.441,
              "y": 33.479,
              "z": 0.572
            },
            "rightCorner": {
              "x": -0.334,
              "y": 33.473,
              "z": 0.572
            },
            "gtin": "4008600433743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20397",
            "leftCorner": {
              "x": -0.334,
              "y": 33.47,
              "z": 0.572
            },
            "rightCorner": {
              "x": -0.254,
              "y": 33.466,
              "z": 0.572
            },
            "gtin": "4008600433736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20398",
            "leftCorner": {
              "x": -0.254,
              "y": 33.466,
              "z": 0.572
            },
            "rightCorner": {
              "x": -0.174,
              "y": 33.46,
              "z": 0.572
            },
            "gtin": "4008600433736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20399",
            "leftCorner": {
              "x": -0.173,
              "y": 33.475,
              "z": 0.572
            },
            "rightCorner": {
              "x": -0.092,
              "y": 33.47,
              "z": 0.572
            },
            "gtin": "4008600444091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2039a",
            "leftCorner": {
              "x": -0.092,
              "y": 33.473,
              "z": 0.572
            },
            "rightCorner": {
              "x": 0.046,
              "y": 33.464,
              "z": 0.572
            },
            "gtin": "4008600177159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2039b",
            "leftCorner": {
              "x": 0.046,
              "y": 33.464,
              "z": 0.572
            },
            "rightCorner": {
              "x": 0.184,
              "y": 33.456,
              "z": 0.572
            },
            "gtin": "4008600177159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2039c",
            "leftCorner": {
              "x": 0.183,
              "y": 33.45,
              "z": 0.572
            },
            "rightCorner": {
              "x": 0.293,
              "y": 33.444,
              "z": 0.572
            },
            "gtin": "4008600404910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2039d",
            "leftCorner": {
              "x": 0.293,
              "y": 33.447,
              "z": 0.572
            },
            "rightCorner": {
              "x": 0.402,
              "y": 33.44,
              "z": 0.572
            },
            "gtin": "4008600427650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2037f",
            "leftCorner": {
              "x": 0.402,
              "y": 33.438,
              "z": 0.572
            },
            "rightCorner": {
              "x": 0.523,
              "y": 33.43,
              "z": 0.572
            },
            "gtin": "4008600404873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20380",
            "leftCorner": {
              "x": 0.523,
              "y": 33.43,
              "z": 0.572
            },
            "rightCorner": {
              "x": 0.645,
              "y": 33.424,
              "z": 0.572
            },
            "gtin": "4008600404873",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465d9",
        "height": 1.0539,
        "facings": [
          {
            "id": "68300c895ed67a01d9a203b1",
            "leftCorner": {
              "x": -0.587,
              "y": 33.497,
              "z": 0.862
            },
            "rightCorner": {
              "x": -0.487,
              "y": 33.49,
              "z": 0.862
            },
            "gtin": "4002448190523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203b2",
            "leftCorner": {
              "x": -0.488,
              "y": 33.472,
              "z": 0.862
            },
            "rightCorner": {
              "x": -0.337,
              "y": 33.463,
              "z": 0.862
            },
            "gtin": "4002448190356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203b3",
            "leftCorner": {
              "x": -0.337,
              "y": 33.468,
              "z": 0.862
            },
            "rightCorner": {
              "x": -0.234,
              "y": 33.462,
              "z": 0.862
            },
            "gtin": "4002448190578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203b4",
            "leftCorner": {
              "x": -0.233,
              "y": 33.471,
              "z": 0.862
            },
            "rightCorner": {
              "x": -0.178,
              "y": 33.468,
              "z": 0.862
            },
            "gtin": "4002448190202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203b5",
            "leftCorner": {
              "x": -0.178,
              "y": 33.468,
              "z": 0.862
            },
            "rightCorner": {
              "x": -0.122,
              "y": 33.464,
              "z": 0.862
            },
            "gtin": "4002448190202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203b6",
            "leftCorner": {
              "x": -0.122,
              "y": 33.467,
              "z": 0.862
            },
            "rightCorner": {
              "x": 0.015,
              "y": 33.458,
              "z": 0.862
            },
            "gtin": "4002448189404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203b7",
            "leftCorner": {
              "x": 0.014,
              "y": 33.445,
              "z": 0.862
            },
            "rightCorner": {
              "x": 0.145,
              "y": 33.437,
              "z": 0.862
            },
            "gtin": "4002448154891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203b8",
            "leftCorner": {
              "x": 0.145,
              "y": 33.442,
              "z": 0.862
            },
            "rightCorner": {
              "x": 0.211,
              "y": 33.438,
              "z": 0.862
            },
            "gtin": "4002448190189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203b9",
            "leftCorner": {
              "x": 0.211,
              "y": 33.438,
              "z": 0.862
            },
            "rightCorner": {
              "x": 0.277,
              "y": 33.435,
              "z": 0.862
            },
            "gtin": "4002448190189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203ba",
            "leftCorner": {
              "x": 0.277,
              "y": 33.44,
              "z": 0.862
            },
            "rightCorner": {
              "x": 0.396,
              "y": 33.433,
              "z": 0.862
            },
            "gtin": "4002448190455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203bb",
            "leftCorner": {
              "x": 0.396,
              "y": 33.429,
              "z": 0.862
            },
            "rightCorner": {
              "x": 0.504,
              "y": 33.423,
              "z": 0.862
            },
            "gtin": "4002448190493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203a0",
            "leftCorner": {
              "x": 0.503,
              "y": 33.422,
              "z": 0.862
            },
            "rightCorner": {
              "x": 0.644,
              "y": 33.414,
              "z": 0.862
            },
            "gtin": "8001090634924",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465da",
        "height": 1.4063,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20338",
            "leftCorner": {
              "x": -0.59,
              "y": 33.487,
              "z": 1.151
            },
            "rightCorner": {
              "x": -0.521,
              "y": 33.483,
              "z": 1.151
            },
            "gtin": "5038483962657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20339",
            "leftCorner": {
              "x": -0.522,
              "y": 33.464,
              "z": 1.151
            },
            "rightCorner": {
              "x": -0.454,
              "y": 33.46,
              "z": 1.151
            },
            "gtin": "4002448190189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2033a",
            "leftCorner": {
              "x": -0.454,
              "y": 33.46,
              "z": 1.151
            },
            "rightCorner": {
              "x": -0.386,
              "y": 33.456,
              "z": 1.151
            },
            "gtin": "4002448190189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2033b",
            "leftCorner": {
              "x": -0.386,
              "y": 33.459,
              "z": 1.151
            },
            "rightCorner": {
              "x": -0.273,
              "y": 33.453,
              "z": 1.151
            },
            "gtin": "4002448190646",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2033c",
            "leftCorner": {
              "x": -0.272,
              "y": 33.469,
              "z": 1.151
            },
            "rightCorner": {
              "x": -0.174,
              "y": 33.463,
              "z": 1.151
            },
            "gtin": "4002448190578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2033d",
            "leftCorner": {
              "x": -0.175,
              "y": 33.45,
              "z": 1.151
            },
            "rightCorner": {
              "x": -0.113,
              "y": 33.446,
              "z": 1.151
            },
            "gtin": "4001669418041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2033e",
            "leftCorner": {
              "x": -0.113,
              "y": 33.446,
              "z": 1.151
            },
            "rightCorner": {
              "x": -0.051,
              "y": 33.443,
              "z": 1.151
            },
            "gtin": "4001669418041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2033f",
            "leftCorner": {
              "x": -0.05,
              "y": 33.452,
              "z": 1.151
            },
            "rightCorner": {
              "x": 0.136,
              "y": 33.44,
              "z": 1.151
            },
            "gtin": "4001669408035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20340",
            "leftCorner": {
              "x": 0.137,
              "y": 33.442,
              "z": 1.151
            },
            "rightCorner": {
              "x": 0.241,
              "y": 33.436,
              "z": 1.151
            },
            "gtin": "4001669410014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20341",
            "leftCorner": {
              "x": 0.241,
              "y": 33.436,
              "z": 1.151
            },
            "rightCorner": {
              "x": 0.346,
              "y": 33.43,
              "z": 1.151
            },
            "gtin": "4001669410014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20342",
            "leftCorner": {
              "x": 0.346,
              "y": 33.429,
              "z": 1.151
            },
            "rightCorner": {
              "x": 0.442,
              "y": 33.424,
              "z": 1.151
            },
            "gtin": "4001669410328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20343",
            "leftCorner": {
              "x": 0.441,
              "y": 33.412,
              "z": 1.151
            },
            "rightCorner": {
              "x": 0.548,
              "y": 33.406,
              "z": 1.151
            },
            "gtin": "4008600444091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20344",
            "leftCorner": {
              "x": 0.549,
              "y": 33.421,
              "z": 1.151
            },
            "rightCorner": {
              "x": 0.64,
              "y": 33.416,
              "z": 1.151
            },
            "gtin": "4001669418164",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465d7",
        "height": 1.6601,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1fe7d",
            "leftCorner": {
              "x": -0.615,
              "y": 33.491,
              "z": 1.358
            },
            "rightCorner": {
              "x": -0.548,
              "y": 33.488,
              "z": 1.358
            },
            "gtin": "4002448189350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe7e",
            "leftCorner": {
              "x": -0.549,
              "y": 33.482,
              "z": 1.358
            },
            "rightCorner": {
              "x": -0.475,
              "y": 33.477,
              "z": 1.358
            },
            "gtin": "4001669090070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe7f",
            "leftCorner": {
              "x": -0.476,
              "y": 33.464,
              "z": 1.358
            },
            "rightCorner": {
              "x": -0.399,
              "y": 33.459,
              "z": 1.358
            },
            "gtin": "4001669090018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe80",
            "leftCorner": {
              "x": -0.399,
              "y": 33.47,
              "z": 1.358
            },
            "rightCorner": {
              "x": -0.349,
              "y": 33.467,
              "z": 1.358
            },
            "gtin": "4001669090124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe81",
            "leftCorner": {
              "x": -0.349,
              "y": 33.466,
              "z": 1.358
            },
            "rightCorner": {
              "x": -0.296,
              "y": 33.463,
              "z": 1.358
            },
            "gtin": "4001669091527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe82",
            "leftCorner": {
              "x": -0.296,
              "y": 33.463,
              "z": 1.358
            },
            "rightCorner": {
              "x": -0.243,
              "y": 33.459,
              "z": 1.358
            },
            "gtin": "4001669091527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe83",
            "leftCorner": {
              "x": -0.243,
              "y": 33.453,
              "z": 1.358
            },
            "rightCorner": {
              "x": -0.131,
              "y": 33.446,
              "z": 1.358
            },
            "gtin": "4008600177036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe84",
            "leftCorner": {
              "x": -0.13,
              "y": 33.459,
              "z": 1.358
            },
            "rightCorner": {
              "x": -0.02,
              "y": 33.453,
              "z": 1.358
            },
            "gtin": "4008600177104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe85",
            "leftCorner": {
              "x": -0.02,
              "y": 33.449,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.034,
              "y": 33.446,
              "z": 1.358
            },
            "gtin": "4008600177272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe86",
            "leftCorner": {
              "x": 0.034,
              "y": 33.446,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.088,
              "y": 33.443,
              "z": 1.358
            },
            "gtin": "4008600177272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe87",
            "leftCorner": {
              "x": 0.089,
              "y": 33.447,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.215,
              "y": 33.439,
              "z": 1.358
            },
            "gtin": "4001669418027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe88",
            "leftCorner": {
              "x": 0.214,
              "y": 33.428,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.336,
              "y": 33.421,
              "z": 1.358
            },
            "gtin": "4001669412087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe89",
            "leftCorner": {
              "x": 0.336,
              "y": 33.422,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.413,
              "y": 33.417,
              "z": 1.358
            },
            "gtin": "4001669412094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe8a",
            "leftCorner": {
              "x": 0.413,
              "y": 33.417,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.49,
              "y": 33.412,
              "z": 1.358
            },
            "gtin": "4001669412094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe8b",
            "leftCorner": {
              "x": 0.49,
              "y": 33.412,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.568,
              "y": 33.408,
              "z": 1.358
            },
            "gtin": "4001669412094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe03",
            "leftCorner": {
              "x": 0.567,
              "y": 33.402,
              "z": 1.358
            },
            "rightCorner": {
              "x": 0.643,
              "y": 33.397,
              "z": 1.358
            },
            "gtin": "4001669412070",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468ba",
    "rightNeighborShelfId": "468bc"
  },
  {
    "id": "468bc",
    "name": "468bc",
    "x": 0.635,
    "y": 33.274,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.029335,
      "w": 0.99957
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 8,
      "unknownStockCount": 86
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5465e3",
        "height": 0.17819,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2046d",
            "leftCorner": {
              "x": 0.636,
              "y": 33.286,
              "z": 0.146
            },
            "rightCorner": {
              "x": 0.808,
              "y": 33.276,
              "z": 0.146
            },
            "gtin": "7702018474905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20470",
            "leftCorner": {
              "x": 0.81,
              "y": 33.317,
              "z": 0.146
            },
            "rightCorner": {
              "x": 0.967,
              "y": 33.308,
              "z": 0.146
            },
            "gtin": "8006540733905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20471",
            "leftCorner": {
              "x": 0.967,
              "y": 33.308,
              "z": 0.146
            },
            "rightCorner": {
              "x": 1.124,
              "y": 33.298,
              "z": 0.146
            },
            "gtin": "8006540733905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20472",
            "leftCorner": {
              "x": 1.124,
              "y": 33.289,
              "z": 0.146
            },
            "rightCorner": {
              "x": 1.337,
              "y": 33.277,
              "z": 0.146
            },
            "gtin": "4337185922862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20473",
            "leftCorner": {
              "x": 1.337,
              "y": 33.282,
              "z": 0.146
            },
            "rightCorner": {
              "x": 1.399,
              "y": 33.278,
              "z": 0.146
            },
            "gtin": "4260086570019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20474",
            "leftCorner": {
              "x": 1.399,
              "y": 33.278,
              "z": 0.146
            },
            "rightCorner": {
              "x": 1.46,
              "y": 33.274,
              "z": 0.146
            },
            "gtin": "4260086570019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20475",
            "leftCorner": {
              "x": 1.46,
              "y": 33.281,
              "z": 0.146
            },
            "rightCorner": {
              "x": 1.547,
              "y": 33.276,
              "z": 0.146
            },
            "gtin": "4260086570033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20476",
            "leftCorner": {
              "x": 1.547,
              "y": 33.276,
              "z": 0.146
            },
            "rightCorner": {
              "x": 1.634,
              "y": 33.27,
              "z": 0.146
            },
            "gtin": "4260086570033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20477",
            "leftCorner": {
              "x": 1.635,
              "y": 33.285,
              "z": 0.146
            },
            "rightCorner": {
              "x": 1.675,
              "y": 33.282,
              "z": 0.146
            },
            "gtin": "4027800037148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20478",
            "leftCorner": {
              "x": 1.674,
              "y": 33.257,
              "z": 0.146
            },
            "rightCorner": {
              "x": 1.872,
              "y": 33.246,
              "z": 0.146
            },
            "gtin": "4337185922886",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465dd",
        "height": 0.49787,
        "facings": [
          {
            "id": "68300c895ed67a01d9a203f5",
            "leftCorner": {
              "x": 0.641,
              "y": 33.377,
              "z": 0.407
            },
            "rightCorner": {
              "x": 0.718,
              "y": 33.372,
              "z": 0.407
            },
            "gtin": "7702018621293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203f7",
            "leftCorner": {
              "x": 0.72,
              "y": 33.41,
              "z": 0.407
            },
            "rightCorner": {
              "x": 0.784,
              "y": 33.407,
              "z": 0.407
            },
            "gtin": "7702018621255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203f8",
            "leftCorner": {
              "x": 0.784,
              "y": 33.407,
              "z": 0.407
            },
            "rightCorner": {
              "x": 0.847,
              "y": 33.403,
              "z": 0.407
            },
            "gtin": "7702018621255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203f9",
            "leftCorner": {
              "x": 0.847,
              "y": 33.406,
              "z": 0.407
            },
            "rightCorner": {
              "x": 0.917,
              "y": 33.402,
              "z": 0.407
            },
            "gtin": "7702018621279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203fa",
            "leftCorner": {
              "x": 0.917,
              "y": 33.402,
              "z": 0.407
            },
            "rightCorner": {
              "x": 0.986,
              "y": 33.398,
              "z": 0.407
            },
            "gtin": "7702018621279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203fb",
            "leftCorner": {
              "x": 0.986,
              "y": 33.396,
              "z": 0.407
            },
            "rightCorner": {
              "x": 1.083,
              "y": 33.39,
              "z": 0.407
            },
            "gtin": "8001090870490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203fc",
            "leftCorner": {
              "x": 1.083,
              "y": 33.39,
              "z": 0.407
            },
            "rightCorner": {
              "x": 1.191,
              "y": 33.384,
              "z": 0.407
            },
            "gtin": "7702018620371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203fd",
            "leftCorner": {
              "x": 1.191,
              "y": 33.384,
              "z": 0.407
            },
            "rightCorner": {
              "x": 1.299,
              "y": 33.377,
              "z": 0.407
            },
            "gtin": "7702018620371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203fe",
            "leftCorner": {
              "x": 1.3,
              "y": 33.39,
              "z": 0.407
            },
            "rightCorner": {
              "x": 1.37,
              "y": 33.385,
              "z": 0.407
            },
            "gtin": "8001090282347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203ff",
            "leftCorner": {
              "x": 1.37,
              "y": 33.385,
              "z": 0.407
            },
            "rightCorner": {
              "x": 1.44,
              "y": 33.381,
              "z": 0.407
            },
            "gtin": "8001090282347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20400",
            "leftCorner": {
              "x": 1.439,
              "y": 33.365,
              "z": 0.407
            },
            "rightCorner": {
              "x": 1.479,
              "y": 33.363,
              "z": 0.407
            },
            "gtin": "7702018603947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20401",
            "leftCorner": {
              "x": 1.479,
              "y": 33.358,
              "z": 0.407
            },
            "rightCorner": {
              "x": 1.538,
              "y": 33.355,
              "z": 0.407
            },
            "gtin": "8714789849195",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20402",
            "leftCorner": {
              "x": 1.538,
              "y": 33.358,
              "z": 0.407
            },
            "rightCorner": {
              "x": 1.611,
              "y": 33.354,
              "z": 0.407
            },
            "gtin": "8714789849164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20403",
            "leftCorner": {
              "x": 1.612,
              "y": 33.372,
              "z": 0.407
            },
            "rightCorner": {
              "x": 1.688,
              "y": 33.368,
              "z": 0.407
            },
            "gtin": "4027800324903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20404",
            "leftCorner": {
              "x": 1.689,
              "y": 33.379,
              "z": 0.407
            },
            "rightCorner": {
              "x": 1.747,
              "y": 33.376,
              "z": 0.407
            },
            "gtin": "8700216013291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20405",
            "leftCorner": {
              "x": 1.747,
              "y": 33.376,
              "z": 0.407
            },
            "rightCorner": {
              "x": 1.805,
              "y": 33.372,
              "z": 0.407
            },
            "gtin": "8700216013291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20406",
            "leftCorner": {
              "x": 1.805,
              "y": 33.372,
              "z": 0.407
            },
            "rightCorner": {
              "x": 1.852,
              "y": 33.369,
              "z": 0.407
            },
            "gtin": "4005900922175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20407",
            "leftCorner": {
              "x": 1.852,
              "y": 33.369,
              "z": 0.407
            },
            "rightCorner": {
              "x": 1.899,
              "y": 33.367,
              "z": 0.407
            },
            "gtin": "4005900922175",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465dc",
        "height": 0.80059,
        "facings": [
          {
            "id": "68300c895ed67a01d9a203da",
            "leftCorner": {
              "x": 0.641,
              "y": 33.378,
              "z": 0.655
            },
            "rightCorner": {
              "x": 0.714,
              "y": 33.373,
              "z": 0.655
            },
            "gtin": "8700216013345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203dc",
            "leftCorner": {
              "x": 0.716,
              "y": 33.409,
              "z": 0.655
            },
            "rightCorner": {
              "x": 0.777,
              "y": 33.405,
              "z": 0.655
            },
            "gtin": "4063367400872",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203dd",
            "leftCorner": {
              "x": 0.777,
              "y": 33.405,
              "z": 0.655
            },
            "rightCorner": {
              "x": 0.839,
              "y": 33.402,
              "z": 0.655
            },
            "gtin": "4063367400872",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203de",
            "leftCorner": {
              "x": 0.84,
              "y": 33.413,
              "z": 0.655
            },
            "rightCorner": {
              "x": 0.9,
              "y": 33.409,
              "z": 0.655
            },
            "gtin": "4063367400858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203df",
            "leftCorner": {
              "x": 0.899,
              "y": 33.399,
              "z": 0.655
            },
            "rightCorner": {
              "x": 0.981,
              "y": 33.394,
              "z": 0.655
            },
            "gtin": "4063367400834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203e0",
            "leftCorner": {
              "x": 0.981,
              "y": 33.397,
              "z": 0.655
            },
            "rightCorner": {
              "x": 1.071,
              "y": 33.392,
              "z": 0.655
            },
            "gtin": "4027800277001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203e1",
            "leftCorner": {
              "x": 1.071,
              "y": 33.393,
              "z": 0.655
            },
            "rightCorner": {
              "x": 1.157,
              "y": 33.388,
              "z": 0.655
            },
            "gtin": "8001090978752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203e2",
            "leftCorner": {
              "x": 1.158,
              "y": 33.401,
              "z": 0.655
            },
            "rightCorner": {
              "x": 1.24,
              "y": 33.397,
              "z": 0.655
            },
            "gtin": "4027800238804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203e3",
            "leftCorner": {
              "x": 1.24,
              "y": 33.397,
              "z": 0.655
            },
            "rightCorner": {
              "x": 1.322,
              "y": 33.392,
              "z": 0.655
            },
            "gtin": "4027800238804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203e4",
            "leftCorner": {
              "x": 1.321,
              "y": 33.381,
              "z": 0.655
            },
            "rightCorner": {
              "x": 1.464,
              "y": 33.372,
              "z": 0.655
            },
            "gtin": "3616306097384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203e5",
            "leftCorner": {
              "x": 1.464,
              "y": 33.371,
              "z": 0.655
            },
            "rightCorner": {
              "x": 1.581,
              "y": 33.364,
              "z": 0.655
            },
            "gtin": "7702018620241",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c895ed67a01d9a203e6",
            "leftCorner": {
              "x": 1.58,
              "y": 33.349,
              "z": 0.655
            },
            "rightCorner": {
              "x": 1.658,
              "y": 33.344,
              "z": 0.655
            },
            "gtin": "8720181343506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203e7",
            "leftCorner": {
              "x": 1.658,
              "y": 33.351,
              "z": 0.655
            },
            "rightCorner": {
              "x": 1.738,
              "y": 33.346,
              "z": 0.655
            },
            "gtin": "8720181343476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203e8",
            "leftCorner": {
              "x": 1.738,
              "y": 33.346,
              "z": 0.655
            },
            "rightCorner": {
              "x": 1.818,
              "y": 33.343,
              "z": 0.655
            },
            "gtin": "8720181343476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203e9",
            "leftCorner": {
              "x": 1.818,
              "y": 33.339,
              "z": 0.655
            },
            "rightCorner": {
              "x": 1.886,
              "y": 33.334,
              "z": 0.655
            },
            "gtin": "8720181343452",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465e0",
        "height": 1.0655,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2041c",
            "leftCorner": {
              "x": 0.671,
              "y": 33.412,
              "z": 0.872
            },
            "rightCorner": {
              "x": 0.757,
              "y": 33.408,
              "z": 0.872
            },
            "gtin": "4009800001701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2041d",
            "leftCorner": {
              "x": 0.758,
              "y": 33.415,
              "z": 0.872
            },
            "rightCorner": {
              "x": 0.808,
              "y": 33.413,
              "z": 0.872
            },
            "gtin": "4005900614049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2041e",
            "leftCorner": {
              "x": 0.808,
              "y": 33.419,
              "z": 0.872
            },
            "rightCorner": {
              "x": 0.927,
              "y": 33.412,
              "z": 0.872
            },
            "gtin": "4006000079356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2041f",
            "leftCorner": {
              "x": 0.927,
              "y": 33.413,
              "z": 0.872
            },
            "rightCorner": {
              "x": 1.006,
              "y": 33.408,
              "z": 0.872
            },
            "gtin": "4005900612748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20420",
            "leftCorner": {
              "x": 1.005,
              "y": 33.395,
              "z": 0.872
            },
            "rightCorner": {
              "x": 1.101,
              "y": 33.389,
              "z": 0.872
            },
            "gtin": "4005900612663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20421",
            "leftCorner": {
              "x": 1.101,
              "y": 33.385,
              "z": 0.872
            },
            "rightCorner": {
              "x": 1.174,
              "y": 33.382,
              "z": 0.872
            },
            "gtin": "4006000072685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20422",
            "leftCorner": {
              "x": 1.175,
              "y": 33.397,
              "z": 0.872
            },
            "rightCorner": {
              "x": 1.246,
              "y": 33.392,
              "z": 0.872
            },
            "gtin": "4001638095747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20423",
            "leftCorner": {
              "x": 1.245,
              "y": 33.376,
              "z": 0.872
            },
            "rightCorner": {
              "x": 1.35,
              "y": 33.37,
              "z": 0.872
            },
            "gtin": "4001638098816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20424",
            "leftCorner": {
              "x": 1.35,
              "y": 33.381,
              "z": 0.872
            },
            "rightCorner": {
              "x": 1.559,
              "y": 33.369,
              "z": 0.872
            },
            "gtin": "3015810608817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20425",
            "leftCorner": {
              "x": 1.56,
              "y": 33.373,
              "z": 0.872
            },
            "rightCorner": {
              "x": 1.65,
              "y": 33.368,
              "z": 0.872
            },
            "gtin": "4027800551101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20426",
            "leftCorner": {
              "x": 1.65,
              "y": 33.357,
              "z": 0.872
            },
            "rightCorner": {
              "x": 1.727,
              "y": 33.352,
              "z": 0.872
            },
            "gtin": "8006540470374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20427",
            "leftCorner": {
              "x": 1.728,
              "y": 33.367,
              "z": 0.872
            },
            "rightCorner": {
              "x": 1.786,
              "y": 33.363,
              "z": 0.872
            },
            "gtin": "8001841694054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20428",
            "leftCorner": {
              "x": 1.786,
              "y": 33.368,
              "z": 0.872
            },
            "rightCorner": {
              "x": 1.839,
              "y": 33.366,
              "z": 0.872
            },
            "gtin": "8001841693934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20429",
            "leftCorner": {
              "x": 1.839,
              "y": 33.366,
              "z": 0.872
            },
            "rightCorner": {
              "x": 1.893,
              "y": 33.362,
              "z": 0.872
            },
            "gtin": "8001841693934",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465e5",
        "height": 1.304,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20485",
            "leftCorner": {
              "x": 0.642,
              "y": 33.4,
              "z": 1.067
            },
            "rightCorner": {
              "x": 1.444,
              "y": 33.353,
              "z": 1.067
            }
          },
          {
            "id": "68300c895ed67a01d9a20486",
            "leftCorner": {
              "x": 1.446,
              "y": 33.394,
              "z": 1.067
            },
            "rightCorner": {
              "x": 1.893,
              "y": 33.368,
              "z": 1.067
            },
            "gtin": "8001090422859",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465e6",
        "height": 1.3567,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20487",
            "leftCorner": {
              "x": 0.643,
              "y": 33.405,
              "z": 1.11
            },
            "rightCorner": {
              "x": 1.512,
              "y": 33.353,
              "z": 1.11
            }
          },
          {
            "id": "68300c895ed67a01d9a20488",
            "leftCorner": {
              "x": 1.515,
              "y": 33.393,
              "z": 1.11
            },
            "rightCorner": {
              "x": 1.893,
              "y": 33.371,
              "z": 1.11
            },
            "gtin": "8700216503525",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465df",
        "height": 1.4083,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20345",
            "leftCorner": {
              "x": 0.641,
              "y": 33.451,
              "z": 1.152
            },
            "rightCorner": {
              "x": 0.715,
              "y": 33.446,
              "z": 1.152
            },
            "gtin": "4027800020157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20346",
            "leftCorner": {
              "x": 0.715,
              "y": 33.446,
              "z": 1.152
            },
            "rightCorner": {
              "x": 0.808,
              "y": 33.441,
              "z": 1.152
            },
            "gtin": "4027800402205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20347",
            "leftCorner": {
              "x": 0.808,
              "y": 33.433,
              "z": 1.152
            },
            "rightCorner": {
              "x": 0.924,
              "y": 33.426,
              "z": 1.152
            },
            "gtin": "4027800239504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20348",
            "leftCorner": {
              "x": 0.924,
              "y": 33.432,
              "z": 1.152
            },
            "rightCorner": {
              "x": 1.022,
              "y": 33.426,
              "z": 1.152
            },
            "gtin": "4027800015504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20349",
            "leftCorner": {
              "x": 1.021,
              "y": 33.407,
              "z": 1.152
            },
            "rightCorner": {
              "x": 1.128,
              "y": 33.401,
              "z": 1.152
            },
            "gtin": "4027800011506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2034a",
            "leftCorner": {
              "x": 1.128,
              "y": 33.408,
              "z": 1.152
            },
            "rightCorner": {
              "x": 1.221,
              "y": 33.403,
              "z": 1.152
            },
            "gtin": "4027800404100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2034b",
            "leftCorner": {
              "x": 1.221,
              "y": 33.411,
              "z": 1.152
            },
            "rightCorner": {
              "x": 1.296,
              "y": 33.406,
              "z": 1.152
            },
            "gtin": "7702018417759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2034c",
            "leftCorner": {
              "x": 1.296,
              "y": 33.412,
              "z": 1.152
            },
            "rightCorner": {
              "x": 1.613,
              "y": 33.394,
              "z": 1.152
            },
            "gtin": "7702018343775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2034d",
            "leftCorner": {
              "x": 1.613,
              "y": 33.396,
              "z": 1.152
            },
            "rightCorner": {
              "x": 2.38,
              "y": 33.35,
              "z": 1.152
            },
            "gtin": "8700216519137",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465e7",
        "height": 1.442,
        "facings": []
      },
      {
        "id": "682ffdddd15af3232a5465e1",
        "height": 1.5667,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2043a",
            "leftCorner": {
              "x": 0.643,
              "y": 33.403,
              "z": 1.282
            },
            "rightCorner": {
              "x": 0.726,
              "y": 33.398,
              "z": 1.282
            },
            "gtin": "5060144646361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2043c",
            "leftCorner": {
              "x": 0.729,
              "y": 33.448,
              "z": 1.282
            },
            "rightCorner": {
              "x": 0.827,
              "y": 33.442,
              "z": 1.282
            },
            "gtin": "4027800373406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2043d",
            "leftCorner": {
              "x": 0.826,
              "y": 33.425,
              "z": 1.282
            },
            "rightCorner": {
              "x": 0.922,
              "y": 33.419,
              "z": 1.282
            },
            "gtin": "4027800513109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2043e",
            "leftCorner": {
              "x": 0.923,
              "y": 33.43,
              "z": 1.282
            },
            "rightCorner": {
              "x": 0.982,
              "y": 33.426,
              "z": 1.282
            },
            "gtin": "4027800799404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2043f",
            "leftCorner": {
              "x": 0.982,
              "y": 33.426,
              "z": 1.282
            },
            "rightCorner": {
              "x": 1.042,
              "y": 33.422,
              "z": 1.282
            },
            "gtin": "4027800799404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20440",
            "leftCorner": {
              "x": 1.042,
              "y": 33.415,
              "z": 1.282
            },
            "rightCorner": {
              "x": 1.142,
              "y": 33.409,
              "z": 1.282
            },
            "gtin": "8700216503419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20441",
            "leftCorner": {
              "x": 1.143,
              "y": 33.415,
              "z": 1.282
            },
            "rightCorner": {
              "x": 1.244,
              "y": 33.41,
              "z": 1.282
            },
            "gtin": "8700216036894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20442",
            "leftCorner": {
              "x": 1.244,
              "y": 33.404,
              "z": 1.282
            },
            "rightCorner": {
              "x": 1.36,
              "y": 33.397,
              "z": 1.282
            },
            "gtin": "3014260207618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20443",
            "leftCorner": {
              "x": 1.361,
              "y": 33.412,
              "z": 1.282
            },
            "rightCorner": {
              "x": 1.443,
              "y": 33.407,
              "z": 1.282
            },
            "gtin": "8700216478502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20444",
            "leftCorner": {
              "x": 1.443,
              "y": 33.396,
              "z": 1.282
            },
            "rightCorner": {
              "x": 1.526,
              "y": 33.391,
              "z": 1.282
            },
            "gtin": "8700216478762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20445",
            "leftCorner": {
              "x": 1.525,
              "y": 33.383,
              "z": 1.282
            },
            "rightCorner": {
              "x": 1.631,
              "y": 33.377,
              "z": 1.282
            },
            "gtin": "4027800404100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20446",
            "leftCorner": {
              "x": 1.633,
              "y": 33.404,
              "z": 1.282
            },
            "rightCorner": {
              "x": 1.718,
              "y": 33.398,
              "z": 1.282
            },
            "gtin": "8700216503358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20447",
            "leftCorner": {
              "x": 1.717,
              "y": 33.385,
              "z": 1.282
            },
            "rightCorner": {
              "x": 1.801,
              "y": 33.381,
              "z": 1.282
            },
            "gtin": "7702018605378",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20448",
            "leftCorner": {
              "x": 1.8,
              "y": 33.374,
              "z": 1.282
            },
            "rightCorner": {
              "x": 1.891,
              "y": 33.369,
              "z": 1.282
            },
            "gtin": "4337185922909",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465e2",
        "height": 1.8176,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20455",
            "leftCorner": {
              "x": 0.643,
              "y": 33.409,
              "z": 1.487
            },
            "rightCorner": {
              "x": 0.72,
              "y": 33.405,
              "z": 1.487
            },
            "gtin": "5060144646347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20457",
            "leftCorner": {
              "x": 0.723,
              "y": 33.444,
              "z": 1.487
            },
            "rightCorner": {
              "x": 0.82,
              "y": 33.438,
              "z": 1.487
            },
            "gtin": "8700216657990",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c895ed67a01d9a20458",
            "leftCorner": {
              "x": 0.82,
              "y": 33.43,
              "z": 1.487
            },
            "rightCorner": {
              "x": 0.924,
              "y": 33.424,
              "z": 1.487
            },
            "gtin": "4027800439935",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20459",
            "leftCorner": {
              "x": 0.923,
              "y": 33.414,
              "z": 1.487
            },
            "rightCorner": {
              "x": 1.039,
              "y": 33.408,
              "z": 1.487
            },
            "gtin": "8700216036719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2045a",
            "leftCorner": {
              "x": 1.039,
              "y": 33.421,
              "z": 1.487
            },
            "rightCorner": {
              "x": 1.129,
              "y": 33.417,
              "z": 1.487
            },
            "gtin": "8001090420831",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c895ed67a01d9a2045b",
            "leftCorner": {
              "x": 1.129,
              "y": 33.411,
              "z": 1.487
            },
            "rightCorner": {
              "x": 1.248,
              "y": 33.404,
              "z": 1.487
            },
            "gtin": "4027800373307",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c895ed67a01d9a2045c",
            "leftCorner": {
              "x": 1.249,
              "y": 33.421,
              "z": 1.487
            },
            "rightCorner": {
              "x": 1.345,
              "y": 33.416,
              "z": 1.487
            },
            "gtin": "5060896574066",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c895ed67a01d9a2045d",
            "leftCorner": {
              "x": 1.344,
              "y": 33.407,
              "z": 1.487
            },
            "rightCorner": {
              "x": 1.46,
              "y": 33.4,
              "z": 1.487
            },
            "gtin": "4027800175000",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c895ed67a01d9a2045e",
            "leftCorner": {
              "x": 1.46,
              "y": 33.409,
              "z": 1.487
            },
            "rightCorner": {
              "x": 1.57,
              "y": 33.403,
              "z": 1.487
            },
            "gtin": "8001090445780",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c895ed67a01d9a2045f",
            "leftCorner": {
              "x": 1.57,
              "y": 33.395,
              "z": 1.487
            },
            "rightCorner": {
              "x": 1.692,
              "y": 33.387,
              "z": 1.487
            },
            "gtin": "4027800143702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20460",
            "leftCorner": {
              "x": 1.693,
              "y": 33.389,
              "z": 1.487
            },
            "rightCorner": {
              "x": 1.807,
              "y": 33.382,
              "z": 1.487
            },
            "gtin": "8700216663175",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c895ed67a01d9a20461",
            "leftCorner": {
              "x": 1.806,
              "y": 33.369,
              "z": 1.487
            },
            "rightCorner": {
              "x": 1.868,
              "y": 33.366,
              "z": 1.487
            },
            "gtin": "8001090443014",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468bb",
    "rightNeighborShelfId": "468bd"
  },
  {
    "id": "468bd",
    "name": "468bd",
    "x": 1.883,
    "y": 33.201,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.029335,
      "w": 0.99957
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 90
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5465f3",
        "height": 0.17614,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20479",
            "leftCorner": {
              "x": 1.872,
              "y": 33.248,
              "z": 0.144
            },
            "rightCorner": {
              "x": 1.975,
              "y": 33.242,
              "z": 0.144
            },
            "gtin": "5015405091398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2047a",
            "leftCorner": {
              "x": 1.975,
              "y": 33.243,
              "z": 0.144
            },
            "rightCorner": {
              "x": 2.071,
              "y": 33.236,
              "z": 0.144
            },
            "gtin": "5015405091541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2047b",
            "leftCorner": {
              "x": 2.071,
              "y": 33.231,
              "z": 0.144
            },
            "rightCorner": {
              "x": 2.143,
              "y": 33.227,
              "z": 0.144
            },
            "gtin": "4337185922923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2047c",
            "leftCorner": {
              "x": 2.143,
              "y": 33.227,
              "z": 0.144
            },
            "rightCorner": {
              "x": 2.215,
              "y": 33.224,
              "z": 0.144
            },
            "gtin": "4337185922923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2047d",
            "leftCorner": {
              "x": 2.216,
              "y": 33.233,
              "z": 0.144
            },
            "rightCorner": {
              "x": 2.345,
              "y": 33.226,
              "z": 0.144
            },
            "gtin": "5015405091589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2047e",
            "leftCorner": {
              "x": 2.345,
              "y": 33.237,
              "z": 0.144
            },
            "rightCorner": {
              "x": 2.423,
              "y": 33.232,
              "z": 0.144
            },
            "gtin": "4027800318605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2047f",
            "leftCorner": {
              "x": 2.422,
              "y": 33.231,
              "z": 0.144
            },
            "rightCorner": {
              "x": 2.551,
              "y": 33.224,
              "z": 0.144
            },
            "gtin": "4260086570040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20480",
            "leftCorner": {
              "x": 2.551,
              "y": 33.225,
              "z": 0.144
            },
            "rightCorner": {
              "x": 2.649,
              "y": 33.219,
              "z": 0.144
            },
            "gtin": "4027800276028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20481",
            "leftCorner": {
              "x": 2.649,
              "y": 33.219,
              "z": 0.144
            },
            "rightCorner": {
              "x": 2.747,
              "y": 33.213,
              "z": 0.144
            },
            "gtin": "4027800276028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20482",
            "leftCorner": {
              "x": 2.747,
              "y": 33.2,
              "z": 0.144
            },
            "rightCorner": {
              "x": 2.855,
              "y": 33.194,
              "z": 0.144
            },
            "gtin": "4027800318605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20483",
            "leftCorner": {
              "x": 2.855,
              "y": 33.19,
              "z": 0.144
            },
            "rightCorner": {
              "x": 2.899,
              "y": 33.188,
              "z": 0.144
            }
          },
          {
            "id": "68300c895ed67a01d9a20484",
            "leftCorner": {
              "x": 2.899,
              "y": 33.184,
              "z": 0.144
            },
            "rightCorner": {
              "x": 2.956,
              "y": 33.181,
              "z": 0.144
            },
            "gtin": "4027800106806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2046e",
            "leftCorner": {
              "x": 2.957,
              "y": 33.197,
              "z": 0.144
            },
            "rightCorner": {
              "x": 3.045,
              "y": 33.191,
              "z": 0.144
            },
            "gtin": "4337185922961",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2046f",
            "leftCorner": {
              "x": 3.045,
              "y": 33.191,
              "z": 0.144
            },
            "rightCorner": {
              "x": 3.134,
              "y": 33.186,
              "z": 0.144
            },
            "gtin": "4337185922961",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465f1",
        "height": 0.50452,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20408",
            "leftCorner": {
              "x": 1.899,
              "y": 33.358,
              "z": 0.413
            },
            "rightCorner": {
              "x": 1.939,
              "y": 33.357,
              "z": 0.413
            },
            "gtin": "4005900922212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20409",
            "leftCorner": {
              "x": 1.939,
              "y": 33.357,
              "z": 0.413
            },
            "rightCorner": {
              "x": 1.98,
              "y": 33.354,
              "z": 0.413
            },
            "gtin": "4005900922212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2040a",
            "leftCorner": {
              "x": 1.979,
              "y": 33.352,
              "z": 0.413
            },
            "rightCorner": {
              "x": 2.045,
              "y": 33.348,
              "z": 0.413
            },
            "gtin": "4005900918628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2040b",
            "leftCorner": {
              "x": 2.045,
              "y": 33.348,
              "z": 0.413
            },
            "rightCorner": {
              "x": 2.111,
              "y": 33.345,
              "z": 0.413
            },
            "gtin": "4005900918628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2040c",
            "leftCorner": {
              "x": 2.111,
              "y": 33.334,
              "z": 0.413
            },
            "rightCorner": {
              "x": 2.233,
              "y": 33.326,
              "z": 0.413
            },
            "gtin": "4337185821912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2040d",
            "leftCorner": {
              "x": 2.233,
              "y": 33.326,
              "z": 0.413
            },
            "rightCorner": {
              "x": 2.355,
              "y": 33.318,
              "z": 0.413
            },
            "gtin": "4337185821912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2040e",
            "leftCorner": {
              "x": 2.356,
              "y": 33.333,
              "z": 0.413
            },
            "rightCorner": {
              "x": 2.413,
              "y": 33.33,
              "z": 0.413
            },
            "gtin": "4063367448201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2040f",
            "leftCorner": {
              "x": 2.413,
              "y": 33.33,
              "z": 0.413
            },
            "rightCorner": {
              "x": 2.47,
              "y": 33.326,
              "z": 0.413
            },
            "gtin": "4063367448201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20410",
            "leftCorner": {
              "x": 2.47,
              "y": 33.33,
              "z": 0.413
            },
            "rightCorner": {
              "x": 2.535,
              "y": 33.326,
              "z": 0.413
            },
            "gtin": "4063367448287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20411",
            "leftCorner": {
              "x": 2.535,
              "y": 33.326,
              "z": 0.413
            },
            "rightCorner": {
              "x": 2.6,
              "y": 33.322,
              "z": 0.413
            },
            "gtin": "4063367448287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20412",
            "leftCorner": {
              "x": 2.6,
              "y": 33.318,
              "z": 0.413
            },
            "rightCorner": {
              "x": 2.659,
              "y": 33.314,
              "z": 0.413
            },
            "gtin": "4063367448379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20413",
            "leftCorner": {
              "x": 2.659,
              "y": 33.314,
              "z": 0.413
            },
            "rightCorner": {
              "x": 2.719,
              "y": 33.311,
              "z": 0.413
            },
            "gtin": "4063367448379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20414",
            "leftCorner": {
              "x": 2.718,
              "y": 33.297,
              "z": 0.413
            },
            "rightCorner": {
              "x": 2.765,
              "y": 33.295,
              "z": 0.413
            },
            "gtin": "4063367448331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20415",
            "leftCorner": {
              "x": 2.765,
              "y": 33.295,
              "z": 0.413
            },
            "rightCorner": {
              "x": 2.811,
              "y": 33.291,
              "z": 0.413
            },
            "gtin": "4063367448331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20416",
            "leftCorner": {
              "x": 2.811,
              "y": 33.286,
              "z": 0.413
            },
            "rightCorner": {
              "x": 2.868,
              "y": 33.284,
              "z": 0.413
            },
            "gtin": "4063367448317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20417",
            "leftCorner": {
              "x": 2.868,
              "y": 33.284,
              "z": 0.413
            },
            "rightCorner": {
              "x": 2.925,
              "y": 33.28,
              "z": 0.413
            },
            "gtin": "4063367448317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20418",
            "leftCorner": {
              "x": 2.925,
              "y": 33.286,
              "z": 0.413
            },
            "rightCorner": {
              "x": 2.978,
              "y": 33.283,
              "z": 0.413
            },
            "gtin": "4063367448164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20419",
            "leftCorner": {
              "x": 2.978,
              "y": 33.283,
              "z": 0.413
            },
            "rightCorner": {
              "x": 3.03,
              "y": 33.279,
              "z": 0.413
            },
            "gtin": "4063367448164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2041a",
            "leftCorner": {
              "x": 3.03,
              "y": 33.279,
              "z": 0.413
            },
            "rightCorner": {
              "x": 3.083,
              "y": 33.277,
              "z": 0.413
            },
            "gtin": "4063367448164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203f6",
            "leftCorner": {
              "x": 3.082,
              "y": 33.268,
              "z": 0.413
            },
            "rightCorner": {
              "x": 3.139,
              "y": 33.264,
              "z": 0.413
            }
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465ee",
        "height": 0.80665,
        "facings": [
          {
            "id": "68300c895ed67a01d9a203ea",
            "leftCorner": {
              "x": 1.888,
              "y": 33.366,
              "z": 0.66
            },
            "rightCorner": {
              "x": 2.002,
              "y": 33.36,
              "z": 0.66
            },
            "gtin": "4002448189596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203eb",
            "leftCorner": {
              "x": 2.002,
              "y": 33.36,
              "z": 0.66
            },
            "rightCorner": {
              "x": 2.115,
              "y": 33.352,
              "z": 0.66
            },
            "gtin": "4002448189596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203ec",
            "leftCorner": {
              "x": 2.114,
              "y": 33.333,
              "z": 0.66
            },
            "rightCorner": {
              "x": 2.238,
              "y": 33.325,
              "z": 0.66
            },
            "gtin": "9300631115434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203ed",
            "leftCorner": {
              "x": 2.239,
              "y": 33.339,
              "z": 0.66
            },
            "rightCorner": {
              "x": 2.303,
              "y": 33.335,
              "z": 0.66
            },
            "gtin": "7702018617463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203ee",
            "leftCorner": {
              "x": 2.303,
              "y": 33.323,
              "z": 0.66
            },
            "rightCorner": {
              "x": 2.398,
              "y": 33.317,
              "z": 0.66
            },
            "gtin": "7702018617494",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203ef",
            "leftCorner": {
              "x": 2.398,
              "y": 33.326,
              "z": 0.66
            },
            "rightCorner": {
              "x": 2.509,
              "y": 33.32,
              "z": 0.66
            },
            "gtin": "4002448114017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203f0",
            "leftCorner": {
              "x": 2.508,
              "y": 33.306,
              "z": 0.66
            },
            "rightCorner": {
              "x": 2.616,
              "y": 33.3,
              "z": 0.66
            },
            "gtin": "4002448203148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203f1",
            "leftCorner": {
              "x": 2.616,
              "y": 33.311,
              "z": 0.66
            },
            "rightCorner": {
              "x": 2.728,
              "y": 33.305,
              "z": 0.66
            },
            "gtin": "3059944020640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203f2",
            "leftCorner": {
              "x": 2.728,
              "y": 33.296,
              "z": 0.66
            },
            "rightCorner": {
              "x": 2.832,
              "y": 33.29,
              "z": 0.66
            },
            "gtin": "4002448101123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203f3",
            "leftCorner": {
              "x": 2.831,
              "y": 33.275,
              "z": 0.66
            },
            "rightCorner": {
              "x": 2.942,
              "y": 33.268,
              "z": 0.66
            },
            "gtin": "4063367154515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203f4",
            "leftCorner": {
              "x": 2.942,
              "y": 33.268,
              "z": 0.66
            },
            "rightCorner": {
              "x": 3.054,
              "y": 33.262,
              "z": 0.66
            },
            "gtin": "4063367154515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a203db",
            "leftCorner": {
              "x": 3.054,
              "y": 33.267,
              "z": 0.66
            },
            "rightCorner": {
              "x": 3.139,
              "y": 33.262,
              "z": 0.66
            },
            "gtin": "4063367154485",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465f2",
        "height": 1.0691,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2042a",
            "leftCorner": {
              "x": 1.891,
              "y": 33.333,
              "z": 0.875
            },
            "rightCorner": {
              "x": 1.962,
              "y": 33.328,
              "z": 0.875
            },
            "gtin": "3600523526109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2042b",
            "leftCorner": {
              "x": 1.962,
              "y": 33.328,
              "z": 0.875
            },
            "rightCorner": {
              "x": 2.033,
              "y": 33.324,
              "z": 0.875
            },
            "gtin": "3600523526109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2042c",
            "leftCorner": {
              "x": 2.035,
              "y": 33.348,
              "z": 0.875
            },
            "rightCorner": {
              "x": 2.093,
              "y": 33.346,
              "z": 0.875
            },
            "gtin": "3600523816262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2042d",
            "leftCorner": {
              "x": 2.093,
              "y": 33.343,
              "z": 0.875
            },
            "rightCorner": {
              "x": 2.186,
              "y": 33.337,
              "z": 0.875
            },
            "gtin": "3600524062651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2042e",
            "leftCorner": {
              "x": 2.186,
              "y": 33.331,
              "z": 0.875
            },
            "rightCorner": {
              "x": 2.27,
              "y": 33.326,
              "z": 0.875
            },
            "gtin": "5060896573595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2042f",
            "leftCorner": {
              "x": 2.27,
              "y": 33.334,
              "z": 0.875
            },
            "rightCorner": {
              "x": 2.339,
              "y": 33.33,
              "z": 0.875
            },
            "gtin": "5060144644695",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20430",
            "leftCorner": {
              "x": 2.339,
              "y": 33.335,
              "z": 0.875
            },
            "rightCorner": {
              "x": 2.404,
              "y": 33.331,
              "z": 0.875
            },
            "gtin": "5060896573571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20431",
            "leftCorner": {
              "x": 2.404,
              "y": 33.328,
              "z": 0.875
            },
            "rightCorner": {
              "x": 2.457,
              "y": 33.325,
              "z": 0.875
            },
            "gtin": "5060896573618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20432",
            "leftCorner": {
              "x": 2.457,
              "y": 33.324,
              "z": 0.875
            },
            "rightCorner": {
              "x": 2.516,
              "y": 33.32,
              "z": 0.875
            },
            "gtin": "9000300128108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20433",
            "leftCorner": {
              "x": 2.516,
              "y": 33.326,
              "z": 0.875
            },
            "rightCorner": {
              "x": 2.609,
              "y": 33.321,
              "z": 0.875
            },
            "gtin": "4002448101147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20434",
            "leftCorner": {
              "x": 2.609,
              "y": 33.321,
              "z": 0.875
            },
            "rightCorner": {
              "x": 2.702,
              "y": 33.315,
              "z": 0.875
            },
            "gtin": "4002448101147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20435",
            "leftCorner": {
              "x": 2.7,
              "y": 33.293,
              "z": 0.875
            },
            "rightCorner": {
              "x": 2.759,
              "y": 33.29,
              "z": 0.875
            },
            "gtin": "4002448101185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20436",
            "leftCorner": {
              "x": 2.759,
              "y": 33.3,
              "z": 0.875
            },
            "rightCorner": {
              "x": 2.842,
              "y": 33.295,
              "z": 0.875
            },
            "gtin": "4002448190080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20437",
            "leftCorner": {
              "x": 2.841,
              "y": 33.286,
              "z": 0.875
            },
            "rightCorner": {
              "x": 2.902,
              "y": 33.282,
              "z": 0.875
            },
            "gtin": "4002448090663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20438",
            "leftCorner": {
              "x": 2.902,
              "y": 33.282,
              "z": 0.875
            },
            "rightCorner": {
              "x": 2.962,
              "y": 33.278,
              "z": 0.875
            },
            "gtin": "4002448090663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20439",
            "leftCorner": {
              "x": 2.962,
              "y": 33.278,
              "z": 0.875
            },
            "rightCorner": {
              "x": 3.088,
              "y": 33.272,
              "z": 0.875
            },
            "gtin": "4002448090656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2041b",
            "leftCorner": {
              "x": 3.088,
              "y": 33.275,
              "z": 0.875
            },
            "rightCorner": {
              "x": 3.139,
              "y": 33.271,
              "z": 0.875
            },
            "gtin": "4002448070559",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465f5",
        "height": 1.4011,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2031b",
            "leftCorner": {
              "x": 2.38,
              "y": 33.358,
              "z": 1.146
            },
            "rightCorner": {
              "x": 3.142,
              "y": 33.314,
              "z": 1.146
            },
            "gtin": "4337185923029",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465f7",
        "height": 1.4463,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2048a",
            "leftCorner": {
              "x": 2.908,
              "y": 33.311,
              "z": 1.183
            },
            "rightCorner": {
              "x": 3.005,
              "y": 33.305,
              "z": 1.183
            },
            "gtin": "8700216187497",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c895ed67a01d9a2048b",
            "leftCorner": {
              "x": 3.004,
              "y": 33.299,
              "z": 1.183
            },
            "rightCorner": {
              "x": 3.094,
              "y": 33.293,
              "z": 1.183
            },
            "gtin": "7702018401208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20489",
            "leftCorner": {
              "x": 3.093,
              "y": 33.281,
              "z": 1.183
            },
            "rightCorner": {
              "x": 3.14,
              "y": 33.278,
              "z": 1.183
            },
            "gtin": "4027800114306",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465f6",
        "height": 1.5312,
        "facings": [
          {
            "id": "68300c895ed67a01d9a206ce",
            "leftCorner": {
              "x": 1.89,
              "y": 33.323,
              "z": 1.253
            },
            "rightCorner": {
              "x": 2.484,
              "y": 33.287,
              "z": 1.253
            },
            "gtin": "4027800656103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206d0",
            "leftCorner": {
              "x": 2.487,
              "y": 33.33,
              "z": 1.253
            },
            "rightCorner": {
              "x": 3.076,
              "y": 33.295,
              "z": 1.253
            },
            "gtin": "4008576408325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206cf",
            "leftCorner": {
              "x": 3.076,
              "y": 33.291,
              "z": 1.253
            },
            "rightCorner": {
              "x": 3.14,
              "y": 33.287,
              "z": 1.253
            },
            "gtin": "4027800006403",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465f0",
        "height": 1.5724,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20449",
            "leftCorner": {
              "x": 1.892,
              "y": 33.377,
              "z": 1.287
            },
            "rightCorner": {
              "x": 1.972,
              "y": 33.372,
              "z": 1.287
            },
            "gtin": "5015405091459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2044a",
            "leftCorner": {
              "x": 1.972,
              "y": 33.372,
              "z": 1.287
            },
            "rightCorner": {
              "x": 2.053,
              "y": 33.367,
              "z": 1.287
            },
            "gtin": "5015405091459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2044b",
            "leftCorner": {
              "x": 2.053,
              "y": 33.367,
              "z": 1.287
            },
            "rightCorner": {
              "x": 2.133,
              "y": 33.363,
              "z": 1.287
            },
            "gtin": "5015405091459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2044c",
            "leftCorner": {
              "x": 2.132,
              "y": 33.345,
              "z": 1.287
            },
            "rightCorner": {
              "x": 2.196,
              "y": 33.342,
              "z": 1.287
            },
            "gtin": "4027800239702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2044d",
            "leftCorner": {
              "x": 2.196,
              "y": 33.342,
              "z": 1.287
            },
            "rightCorner": {
              "x": 2.261,
              "y": 33.338,
              "z": 1.287
            },
            "gtin": "4027800239702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2044e",
            "leftCorner": {
              "x": 2.261,
              "y": 33.344,
              "z": 1.287
            },
            "rightCorner": {
              "x": 2.356,
              "y": 33.337,
              "z": 1.287
            },
            "gtin": "4027800006366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2044f",
            "leftCorner": {
              "x": 2.356,
              "y": 33.337,
              "z": 1.287
            },
            "rightCorner": {
              "x": 2.45,
              "y": 33.332,
              "z": 1.287
            },
            "gtin": "4027800006366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20450",
            "leftCorner": {
              "x": 2.45,
              "y": 33.332,
              "z": 1.287
            },
            "rightCorner": {
              "x": 2.545,
              "y": 33.327,
              "z": 1.287
            },
            "gtin": "4027800006366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20451",
            "leftCorner": {
              "x": 2.546,
              "y": 33.34,
              "z": 1.287
            },
            "rightCorner": {
              "x": 2.69,
              "y": 33.332,
              "z": 1.287
            },
            "gtin": "4027800106400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20452",
            "leftCorner": {
              "x": 2.689,
              "y": 33.327,
              "z": 1.287
            },
            "rightCorner": {
              "x": 2.789,
              "y": 33.321,
              "z": 1.287
            },
            "gtin": "4027800968015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20453",
            "leftCorner": {
              "x": 2.789,
              "y": 33.321,
              "z": 1.287
            },
            "rightCorner": {
              "x": 2.904,
              "y": 33.315,
              "z": 1.287
            },
            "gtin": "7702018400997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20454",
            "leftCorner": {
              "x": 2.904,
              "y": 33.305,
              "z": 1.287
            },
            "rightCorner": {
              "x": 2.999,
              "y": 33.3,
              "z": 1.287
            },
            "gtin": "8700216495516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2043b",
            "leftCorner": {
              "x": 2.999,
              "y": 33.306,
              "z": 1.287
            },
            "rightCorner": {
              "x": 3.141,
              "y": 33.297,
              "z": 1.287
            },
            "gtin": "4027800113408",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465ef",
        "height": 1.8229,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20462",
            "leftCorner": {
              "x": 1.868,
              "y": 33.361,
              "z": 1.491
            },
            "rightCorner": {
              "x": 1.999,
              "y": 33.354,
              "z": 1.491
            },
            "gtin": "8001090442819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20463",
            "leftCorner": {
              "x": 2.0,
              "y": 33.363,
              "z": 1.491
            },
            "rightCorner": {
              "x": 2.1,
              "y": 33.357,
              "z": 1.491
            },
            "gtin": "7702018615384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20464",
            "leftCorner": {
              "x": 2.1,
              "y": 33.356,
              "z": 1.491
            },
            "rightCorner": {
              "x": 2.222,
              "y": 33.349,
              "z": 1.491
            },
            "gtin": "5015405091589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20465",
            "leftCorner": {
              "x": 2.221,
              "y": 33.342,
              "z": 1.491
            },
            "rightCorner": {
              "x": 2.311,
              "y": 33.336,
              "z": 1.491
            },
            "gtin": "4027800965038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20466",
            "leftCorner": {
              "x": 2.312,
              "y": 33.346,
              "z": 1.491
            },
            "rightCorner": {
              "x": 2.415,
              "y": 33.341,
              "z": 1.491
            },
            "gtin": "7702018322862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20467",
            "leftCorner": {
              "x": 2.414,
              "y": 33.331,
              "z": 1.491
            },
            "rightCorner": {
              "x": 2.5,
              "y": 33.326,
              "z": 1.491
            },
            "gtin": "8700216187220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20468",
            "leftCorner": {
              "x": 2.5,
              "y": 33.331,
              "z": 1.491
            },
            "rightCorner": {
              "x": 2.593,
              "y": 33.324,
              "z": 1.491
            },
            "gtin": "4027800138005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20469",
            "leftCorner": {
              "x": 2.592,
              "y": 33.323,
              "z": 1.491
            },
            "rightCorner": {
              "x": 2.696,
              "y": 33.318,
              "z": 1.491
            },
            "gtin": "8700216487689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2046a",
            "leftCorner": {
              "x": 2.697,
              "y": 33.325,
              "z": 1.491
            },
            "rightCorner": {
              "x": 2.81,
              "y": 33.317,
              "z": 1.491
            },
            "gtin": "4027800039432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2046b",
            "leftCorner": {
              "x": 2.811,
              "y": 33.33,
              "z": 1.491
            },
            "rightCorner": {
              "x": 2.916,
              "y": 33.325,
              "z": 1.491
            },
            "gtin": "4027800996834",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c895ed67a01d9a2046c",
            "leftCorner": {
              "x": 2.915,
              "y": 33.301,
              "z": 1.491
            },
            "rightCorner": {
              "x": 3.102,
              "y": 33.29,
              "z": 1.491
            },
            "gtin": "3014260285425",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c895ed67a01d9a20456",
            "leftCorner": {
              "x": 3.102,
              "y": 33.296,
              "z": 1.491
            },
            "rightCorner": {
              "x": 3.141,
              "y": 33.294,
              "z": 1.491
            },
            "gtin": "7350113020437",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468bc"
  },
  {
    "id": "468c4",
    "name": "468c4",
    "x": 1.823,
    "y": 31.08,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99979,
      "w": 0.020576
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 73
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5465fd",
        "height": 0.17542,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20740",
            "leftCorner": {
              "x": 1.822,
              "y": 31.06,
              "z": 0.144
            },
            "rightCorner": {
              "x": 1.74,
              "y": 31.062,
              "z": 0.144
            },
            "gtin": "5906735232066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20741",
            "leftCorner": {
              "x": 1.74,
              "y": 31.062,
              "z": 0.144
            },
            "rightCorner": {
              "x": 1.658,
              "y": 31.066,
              "z": 0.144
            },
            "gtin": "5906735232066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20742",
            "leftCorner": {
              "x": 1.658,
              "y": 31.066,
              "z": 0.144
            },
            "rightCorner": {
              "x": 1.576,
              "y": 31.069,
              "z": 0.144
            },
            "gtin": "5906735232066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20743",
            "leftCorner": {
              "x": 1.576,
              "y": 31.069,
              "z": 0.144
            },
            "rightCorner": {
              "x": 1.494,
              "y": 31.073,
              "z": 0.144
            },
            "gtin": "5906735232066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20746",
            "leftCorner": {
              "x": 1.492,
              "y": 31.02,
              "z": 0.144
            },
            "rightCorner": {
              "x": 1.376,
              "y": 31.024,
              "z": 0.144
            },
            "gtin": "5901832060130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20747",
            "leftCorner": {
              "x": 1.376,
              "y": 31.024,
              "z": 0.144
            },
            "rightCorner": {
              "x": 1.26,
              "y": 31.03,
              "z": 0.144
            },
            "gtin": "5901832060130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20748",
            "leftCorner": {
              "x": 1.26,
              "y": 31.03,
              "z": 0.144
            },
            "rightCorner": {
              "x": 1.144,
              "y": 31.034,
              "z": 0.144
            },
            "gtin": "5901832060130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20749",
            "leftCorner": {
              "x": 1.145,
              "y": 31.052,
              "z": 0.144
            },
            "rightCorner": {
              "x": 0.872,
              "y": 31.063,
              "z": 0.144
            },
            "gtin": "5901832061182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2074a",
            "leftCorner": {
              "x": 0.872,
              "y": 31.067,
              "z": 0.144
            },
            "rightCorner": {
              "x": 0.771,
              "y": 31.071,
              "z": 0.144
            },
            "gtin": "5901832062851",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2074b",
            "leftCorner": {
              "x": 0.771,
              "y": 31.071,
              "z": 0.144
            },
            "rightCorner": {
              "x": 0.67,
              "y": 31.075,
              "z": 0.144
            },
            "gtin": "5901832062851",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2074c",
            "leftCorner": {
              "x": 0.67,
              "y": 31.075,
              "z": 0.144
            },
            "rightCorner": {
              "x": 0.568,
              "y": 31.079,
              "z": 0.144
            },
            "gtin": "5901832062851",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465fb",
        "height": 0.49586,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2071d",
            "leftCorner": {
              "x": 1.278,
              "y": 30.966,
              "z": 0.406
            },
            "rightCorner": {
              "x": 1.207,
              "y": 30.969,
              "z": 0.406
            },
            "gtin": "9120112221252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20718",
            "leftCorner": {
              "x": 1.819,
              "y": 30.976,
              "z": 0.406
            },
            "rightCorner": {
              "x": 1.584,
              "y": 30.986,
              "z": 0.406
            },
            "gtin": "5906735232493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20719",
            "leftCorner": {
              "x": 1.584,
              "y": 30.986,
              "z": 0.406
            },
            "rightCorner": {
              "x": 1.35,
              "y": 30.995,
              "z": 0.406
            },
            "gtin": "5906735232493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2071c",
            "leftCorner": {
              "x": 1.349,
              "y": 30.963,
              "z": 0.406
            },
            "rightCorner": {
              "x": 1.278,
              "y": 30.966,
              "z": 0.406
            },
            "gtin": "9120112221252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2071e",
            "leftCorner": {
              "x": 1.207,
              "y": 30.965,
              "z": 0.406
            },
            "rightCorner": {
              "x": 1.135,
              "y": 30.967,
              "z": 0.406
            },
            "gtin": "5906735232592",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2071f",
            "leftCorner": {
              "x": 1.135,
              "y": 30.967,
              "z": 0.406
            },
            "rightCorner": {
              "x": 1.063,
              "y": 30.971,
              "z": 0.406
            },
            "gtin": "5906735232592",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20720",
            "leftCorner": {
              "x": 1.062,
              "y": 30.964,
              "z": 0.406
            },
            "rightCorner": {
              "x": 0.975,
              "y": 30.967,
              "z": 0.406
            },
            "gtin": "5903719643481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20721",
            "leftCorner": {
              "x": 0.975,
              "y": 30.967,
              "z": 0.406
            },
            "rightCorner": {
              "x": 0.888,
              "y": 30.971,
              "z": 0.406
            },
            "gtin": "5903719643481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20722",
            "leftCorner": {
              "x": 0.888,
              "y": 30.971,
              "z": 0.406
            },
            "rightCorner": {
              "x": 0.801,
              "y": 30.974,
              "z": 0.406
            },
            "gtin": "5903719643481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20723",
            "leftCorner": {
              "x": 0.801,
              "y": 30.984,
              "z": 0.406
            },
            "rightCorner": {
              "x": 0.717,
              "y": 30.988,
              "z": 0.406
            },
            "gtin": "3326240056476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20724",
            "leftCorner": {
              "x": 0.717,
              "y": 30.978,
              "z": 0.406
            },
            "rightCorner": {
              "x": 0.58,
              "y": 30.984,
              "z": 0.406
            },
            "gtin": "3326240005115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20725",
            "leftCorner": {
              "x": 0.58,
              "y": 30.984,
              "z": 0.406
            },
            "rightCorner": {
              "x": 0.444,
              "y": 30.989,
              "z": 0.406
            },
            "gtin": "3326240005115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20726",
            "leftCorner": {
              "x": 0.444,
              "y": 30.989,
              "z": 0.406
            },
            "rightCorner": {
              "x": 0.308,
              "y": 30.995,
              "z": 0.406
            },
            "gtin": "3326240005115",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465fa",
        "height": 0.74303,
        "facings": [
          {
            "id": "68300c895ed67a01d9a206fb",
            "leftCorner": {
              "x": 1.818,
              "y": 30.965,
              "z": 0.608
            },
            "rightCorner": {
              "x": 1.747,
              "y": 30.968,
              "z": 0.608
            },
            "gtin": "3616305265777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206fd",
            "leftCorner": {
              "x": 1.745,
              "y": 30.93,
              "z": 0.608
            },
            "rightCorner": {
              "x": 1.681,
              "y": 30.933,
              "z": 0.608
            },
            "gtin": "5903719640909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206fe",
            "leftCorner": {
              "x": 1.681,
              "y": 30.933,
              "z": 0.608
            },
            "rightCorner": {
              "x": 1.617,
              "y": 30.935,
              "z": 0.608
            },
            "gtin": "5903719640909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206ff",
            "leftCorner": {
              "x": 1.617,
              "y": 30.935,
              "z": 0.608
            },
            "rightCorner": {
              "x": 1.552,
              "y": 30.938,
              "z": 0.608
            },
            "gtin": "5903719640909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20700",
            "leftCorner": {
              "x": 1.552,
              "y": 30.938,
              "z": 0.608
            },
            "rightCorner": {
              "x": 1.488,
              "y": 30.941,
              "z": 0.608
            },
            "gtin": "5903719640909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20701",
            "leftCorner": {
              "x": 1.488,
              "y": 30.938,
              "z": 0.608
            },
            "rightCorner": {
              "x": 1.318,
              "y": 30.944,
              "z": 0.608
            },
            "gtin": "085715320131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20702",
            "leftCorner": {
              "x": 1.318,
              "y": 30.946,
              "z": 0.608
            },
            "rightCorner": {
              "x": 1.244,
              "y": 30.949,
              "z": 0.608
            },
            "gtin": "5050456053827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20703",
            "leftCorner": {
              "x": 1.244,
              "y": 30.949,
              "z": 0.608
            },
            "rightCorner": {
              "x": 1.169,
              "y": 30.952,
              "z": 0.608
            },
            "gtin": "5050456053827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20704",
            "leftCorner": {
              "x": 1.169,
              "y": 30.949,
              "z": 0.608
            },
            "rightCorner": {
              "x": 1.082,
              "y": 30.953,
              "z": 0.608
            },
            "gtin": "5050456099405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20705",
            "leftCorner": {
              "x": 1.082,
              "y": 30.953,
              "z": 0.608
            },
            "rightCorner": {
              "x": 0.994,
              "y": 30.957,
              "z": 0.608
            },
            "gtin": "5050456099405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20706",
            "leftCorner": {
              "x": 0.995,
              "y": 30.966,
              "z": 0.608
            },
            "rightCorner": {
              "x": 0.909,
              "y": 30.969,
              "z": 0.608
            },
            "gtin": "5050456079773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20707",
            "leftCorner": {
              "x": 0.909,
              "y": 30.969,
              "z": 0.608
            },
            "rightCorner": {
              "x": 0.824,
              "y": 30.973,
              "z": 0.608
            },
            "gtin": "5050456079773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20708",
            "leftCorner": {
              "x": 0.824,
              "y": 30.973,
              "z": 0.608
            },
            "rightCorner": {
              "x": 0.738,
              "y": 30.976,
              "z": 0.608
            },
            "gtin": "5050456079773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20709",
            "leftCorner": {
              "x": 0.738,
              "y": 30.975,
              "z": 0.608
            },
            "rightCorner": {
              "x": 0.605,
              "y": 30.98,
              "z": 0.608
            },
            "gtin": "719346648837",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465f8",
        "height": 1.0057,
        "facings": [
          {
            "id": "68300c895ed67a01d9a206d1",
            "leftCorner": {
              "x": 1.814,
              "y": 30.87,
              "z": 0.823
            },
            "rightCorner": {
              "x": 1.767,
              "y": 30.873,
              "z": 0.823
            },
            "gtin": "719346218535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206d2",
            "leftCorner": {
              "x": 1.767,
              "y": 30.873,
              "z": 0.823
            },
            "rightCorner": {
              "x": 1.719,
              "y": 30.874,
              "z": 0.823
            },
            "gtin": "719346218535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206d6",
            "leftCorner": {
              "x": 1.717,
              "y": 30.832,
              "z": 0.823
            },
            "rightCorner": {
              "x": 1.586,
              "y": 30.838,
              "z": 0.823
            },
            "gtin": "719346259644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206d7",
            "leftCorner": {
              "x": 1.588,
              "y": 30.877,
              "z": 0.823
            },
            "rightCorner": {
              "x": 1.527,
              "y": 30.88,
              "z": 0.823
            },
            "gtin": "719346218429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206d8",
            "leftCorner": {
              "x": 1.525,
              "y": 30.842,
              "z": 0.823
            },
            "rightCorner": {
              "x": 1.431,
              "y": 30.846,
              "z": 0.823
            },
            "gtin": "719346648820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206d9",
            "leftCorner": {
              "x": 1.431,
              "y": 30.842,
              "z": 0.823
            },
            "rightCorner": {
              "x": 1.307,
              "y": 30.847,
              "z": 0.823
            },
            "gtin": "3616305254627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206da",
            "leftCorner": {
              "x": 1.307,
              "y": 30.846,
              "z": 0.823
            },
            "rightCorner": {
              "x": 1.159,
              "y": 30.853,
              "z": 0.823
            },
            "gtin": "3616305254566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206db",
            "leftCorner": {
              "x": 1.159,
              "y": 30.858,
              "z": 0.823
            },
            "rightCorner": {
              "x": 1.078,
              "y": 30.861,
              "z": 0.823
            },
            "gtin": "719346235297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206dc",
            "leftCorner": {
              "x": 1.078,
              "y": 30.861,
              "z": 0.823
            },
            "rightCorner": {
              "x": 0.997,
              "y": 30.864,
              "z": 0.823
            },
            "gtin": "719346235297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206dd",
            "leftCorner": {
              "x": 0.998,
              "y": 30.875,
              "z": 0.823
            },
            "rightCorner": {
              "x": 0.919,
              "y": 30.879,
              "z": 0.823
            },
            "gtin": "719346648813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206de",
            "leftCorner": {
              "x": 0.919,
              "y": 30.879,
              "z": 0.823
            },
            "rightCorner": {
              "x": 0.84,
              "y": 30.882,
              "z": 0.823
            },
            "gtin": "719346648813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206df",
            "leftCorner": {
              "x": 0.84,
              "y": 30.881,
              "z": 0.823
            },
            "rightCorner": {
              "x": 0.76,
              "y": 30.883,
              "z": 0.823
            },
            "gtin": "719346218412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206e0",
            "leftCorner": {
              "x": 0.76,
              "y": 30.883,
              "z": 0.823
            },
            "rightCorner": {
              "x": 0.681,
              "y": 30.887,
              "z": 0.823
            },
            "gtin": "719346218412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206e1",
            "leftCorner": {
              "x": 0.682,
              "y": 30.922,
              "z": 0.823
            },
            "rightCorner": {
              "x": 0.611,
              "y": 30.925,
              "z": 0.823
            },
            "gtin": "719346218542",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465fc",
        "height": 1.2496,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20729",
            "leftCorner": {
              "x": 1.814,
              "y": 30.872,
              "z": 1.022
            },
            "rightCorner": {
              "x": 1.752,
              "y": 30.875,
              "z": 1.022
            },
            "gtin": "3616301640813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2072c",
            "leftCorner": {
              "x": 1.75,
              "y": 30.841,
              "z": 1.022
            },
            "rightCorner": {
              "x": 1.675,
              "y": 30.843,
              "z": 1.022
            },
            "gtin": "3616302039920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2072d",
            "leftCorner": {
              "x": 1.675,
              "y": 30.842,
              "z": 1.022
            },
            "rightCorner": {
              "x": 1.572,
              "y": 30.846,
              "z": 1.022
            },
            "gtin": "3616301641315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2072e",
            "leftCorner": {
              "x": 1.571,
              "y": 30.828,
              "z": 1.022
            },
            "rightCorner": {
              "x": 1.481,
              "y": 30.832,
              "z": 1.022
            },
            "gtin": "3616301640967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2072f",
            "leftCorner": {
              "x": 1.481,
              "y": 30.832,
              "z": 1.022
            },
            "rightCorner": {
              "x": 1.39,
              "y": 30.837,
              "z": 1.022
            },
            "gtin": "3616301640967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20730",
            "leftCorner": {
              "x": 1.39,
              "y": 30.838,
              "z": 1.022
            },
            "rightCorner": {
              "x": 1.275,
              "y": 30.842,
              "z": 1.022
            },
            "gtin": "3616301641070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20731",
            "leftCorner": {
              "x": 1.276,
              "y": 30.858,
              "z": 1.022
            },
            "rightCorner": {
              "x": 1.198,
              "y": 30.861,
              "z": 1.022
            },
            "gtin": "3616301640998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20732",
            "leftCorner": {
              "x": 1.198,
              "y": 30.861,
              "z": 1.022
            },
            "rightCorner": {
              "x": 1.119,
              "y": 30.865,
              "z": 1.022
            },
            "gtin": "3616301640998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20733",
            "leftCorner": {
              "x": 1.119,
              "y": 30.866,
              "z": 1.022
            },
            "rightCorner": {
              "x": 1.018,
              "y": 30.87,
              "z": 1.022
            },
            "gtin": "5050456007134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20734",
            "leftCorner": {
              "x": 1.018,
              "y": 30.87,
              "z": 1.022
            },
            "rightCorner": {
              "x": 0.917,
              "y": 30.874,
              "z": 1.022
            },
            "gtin": "5050456007134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20735",
            "leftCorner": {
              "x": 0.917,
              "y": 30.867,
              "z": 1.022
            },
            "rightCorner": {
              "x": 0.868,
              "y": 30.869,
              "z": 1.022
            },
            "gtin": "719346643894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20736",
            "leftCorner": {
              "x": 0.868,
              "y": 30.869,
              "z": 1.022
            },
            "rightCorner": {
              "x": 0.819,
              "y": 30.871,
              "z": 1.022
            },
            "gtin": "719346643894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20737",
            "leftCorner": {
              "x": 0.818,
              "y": 30.864,
              "z": 1.022
            },
            "rightCorner": {
              "x": 0.695,
              "y": 30.869,
              "z": 1.022
            },
            "gtin": "5050456524426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20738",
            "leftCorner": {
              "x": 0.695,
              "y": 30.869,
              "z": 1.022
            },
            "rightCorner": {
              "x": 0.571,
              "y": 30.874,
              "z": 1.022
            },
            "gtin": "5050456524426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20739",
            "leftCorner": {
              "x": 0.571,
              "y": 30.874,
              "z": 1.022
            },
            "rightCorner": {
              "x": 0.448,
              "y": 30.88,
              "z": 1.022
            },
            "gtin": "5050456524426",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465f9",
        "height": 1.5016,
        "facings": [
          {
            "id": "68300c895ed67a01d9a206eb",
            "leftCorner": {
              "x": 1.814,
              "y": 30.862,
              "z": 1.229
            },
            "rightCorner": {
              "x": 1.58,
              "y": 30.872,
              "z": 1.229
            },
            "gtin": "4037900643255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206ed",
            "leftCorner": {
              "x": 1.579,
              "y": 30.836,
              "z": 1.229
            },
            "rightCorner": {
              "x": 1.333,
              "y": 30.846,
              "z": 1.229
            },
            "gtin": "4260098635430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206ee",
            "leftCorner": {
              "x": 1.333,
              "y": 30.846,
              "z": 1.229
            },
            "rightCorner": {
              "x": 1.142,
              "y": 30.854,
              "z": 1.229
            },
            "gtin": "4260098634877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206ef",
            "leftCorner": {
              "x": 1.142,
              "y": 30.856,
              "z": 1.229
            },
            "rightCorner": {
              "x": 0.962,
              "y": 30.863,
              "z": 1.229
            },
            "gtin": "4260098634815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206f0",
            "leftCorner": {
              "x": 0.962,
              "y": 30.863,
              "z": 1.229
            },
            "rightCorner": {
              "x": 0.783,
              "y": 30.871,
              "z": 1.229
            },
            "gtin": "4260098634815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206f1",
            "leftCorner": {
              "x": 0.783,
              "y": 30.871,
              "z": 1.229
            },
            "rightCorner": {
              "x": 0.604,
              "y": 30.878,
              "z": 1.229
            },
            "gtin": "4260098634815",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "da3a1",
    "rightNeighborShelfId": "468c5"
  },
  {
    "id": "468c5",
    "name": "468c5",
    "x": 0.618,
    "y": 31.155,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9998,
      "w": 0.019756
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 65
    },
    "layers": [
      {
        "id": "682ffddfd15af3232a5469ba",
        "height": 0.17401,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2074d",
            "leftCorner": {
              "x": 0.571,
              "y": 31.316,
              "z": 0.142
            },
            "rightCorner": {
              "x": 0.483,
              "y": 31.32,
              "z": 0.142
            },
            "gtin": "5901832067122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2074e",
            "leftCorner": {
              "x": 0.483,
              "y": 31.32,
              "z": 0.142
            },
            "rightCorner": {
              "x": 0.394,
              "y": 31.323,
              "z": 0.142
            },
            "gtin": "5901832067122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2074f",
            "leftCorner": {
              "x": 0.394,
              "y": 31.322,
              "z": 0.142
            },
            "rightCorner": {
              "x": 0.286,
              "y": 31.326,
              "z": 0.142
            },
            "gtin": "3326240005351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20750",
            "leftCorner": {
              "x": 0.286,
              "y": 31.326,
              "z": 0.142
            },
            "rightCorner": {
              "x": 0.177,
              "y": 31.33,
              "z": 0.142
            },
            "gtin": "3326240005351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20751",
            "leftCorner": {
              "x": 0.177,
              "y": 31.337,
              "z": 0.142
            },
            "rightCorner": {
              "x": 0.101,
              "y": 31.341,
              "z": 0.142
            },
            "gtin": "3326240003814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20752",
            "leftCorner": {
              "x": 0.101,
              "y": 31.341,
              "z": 0.142
            },
            "rightCorner": {
              "x": 0.025,
              "y": 31.344,
              "z": 0.142
            },
            "gtin": "3326240003814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20753",
            "leftCorner": {
              "x": 0.025,
              "y": 31.331,
              "z": 0.142
            },
            "rightCorner": {
              "x": -0.014,
              "y": 31.333,
              "z": 0.142
            },
            "gtin": "3326240056698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20754",
            "leftCorner": {
              "x": -0.014,
              "y": 31.333,
              "z": 0.142
            },
            "rightCorner": {
              "x": -0.052,
              "y": 31.334,
              "z": 0.142
            },
            "gtin": "3326240056698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20755",
            "leftCorner": {
              "x": -0.052,
              "y": 31.351,
              "z": 0.142
            },
            "rightCorner": {
              "x": -0.178,
              "y": 31.355,
              "z": 0.142
            },
            "gtin": "3326240053277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20756",
            "leftCorner": {
              "x": -0.178,
              "y": 31.359,
              "z": 0.142
            },
            "rightCorner": {
              "x": -0.314,
              "y": 31.365,
              "z": 0.142
            },
            "gtin": "3326240005368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20757",
            "leftCorner": {
              "x": -0.314,
              "y": 31.358,
              "z": 0.142
            },
            "rightCorner": {
              "x": -0.364,
              "y": 31.36,
              "z": 0.142
            },
            "gtin": "3326240006136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20758",
            "leftCorner": {
              "x": -0.364,
              "y": 31.36,
              "z": 0.142
            },
            "rightCorner": {
              "x": -0.413,
              "y": 31.362,
              "z": 0.142
            },
            "gtin": "3326240006136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20759",
            "leftCorner": {
              "x": -0.413,
              "y": 31.372,
              "z": 0.142
            },
            "rightCorner": {
              "x": -0.455,
              "y": 31.373,
              "z": 0.142
            },
            "gtin": "8717524074968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2075a",
            "leftCorner": {
              "x": -0.455,
              "y": 31.373,
              "z": 0.142
            },
            "rightCorner": {
              "x": -0.496,
              "y": 31.375,
              "z": 0.142
            },
            "gtin": "8717524074968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2075b",
            "leftCorner": {
              "x": -0.496,
              "y": 31.375,
              "z": 0.142
            },
            "rightCorner": {
              "x": -0.538,
              "y": 31.377,
              "z": 0.142
            },
            "gtin": "8717524074968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2075c",
            "leftCorner": {
              "x": -0.538,
              "y": 31.377,
              "z": 0.142
            },
            "rightCorner": {
              "x": -0.58,
              "y": 31.378,
              "z": 0.142
            },
            "gtin": "8717524074968",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469bb",
        "height": 0.49434,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20727",
            "leftCorner": {
              "x": 0.31,
              "y": 31.233,
              "z": 0.404
            },
            "rightCorner": {
              "x": 0.173,
              "y": 31.238,
              "z": 0.404
            },
            "gtin": "8005610325569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20728",
            "leftCorner": {
              "x": 0.173,
              "y": 31.238,
              "z": 0.404
            },
            "rightCorner": {
              "x": 0.035,
              "y": 31.243,
              "z": 0.404
            },
            "gtin": "8005610325569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2071a",
            "leftCorner": {
              "x": 0.035,
              "y": 31.239,
              "z": 0.404
            },
            "rightCorner": {
              "x": -0.272,
              "y": 31.251,
              "z": 0.404
            },
            "gtin": "3326240005368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2071b",
            "leftCorner": {
              "x": -0.272,
              "y": 31.251,
              "z": 0.404
            },
            "rightCorner": {
              "x": -0.579,
              "y": 31.264,
              "z": 0.404
            },
            "gtin": "3326240005368",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469b6",
        "height": 0.74642,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2070a",
            "leftCorner": {
              "x": 0.607,
              "y": 31.216,
              "z": 0.611
            },
            "rightCorner": {
              "x": 0.483,
              "y": 31.221,
              "z": 0.611
            },
            "gtin": "3616305168948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2070b",
            "leftCorner": {
              "x": 0.483,
              "y": 31.221,
              "z": 0.611
            },
            "rightCorner": {
              "x": 0.358,
              "y": 31.225,
              "z": 0.611
            },
            "gtin": "3616305168948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2070c",
            "leftCorner": {
              "x": 0.358,
              "y": 31.225,
              "z": 0.611
            },
            "rightCorner": {
              "x": 0.234,
              "y": 31.231,
              "z": 0.611
            },
            "gtin": "3616305168948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2070d",
            "leftCorner": {
              "x": 0.234,
              "y": 31.231,
              "z": 0.611
            },
            "rightCorner": {
              "x": 0.109,
              "y": 31.235,
              "z": 0.611
            },
            "gtin": "3616305168948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2070e",
            "leftCorner": {
              "x": 0.109,
              "y": 31.233,
              "z": 0.611
            },
            "rightCorner": {
              "x": 0.062,
              "y": 31.235,
              "z": 0.611
            },
            "gtin": "3607346516737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2070f",
            "leftCorner": {
              "x": 0.062,
              "y": 31.235,
              "z": 0.611
            },
            "rightCorner": {
              "x": 0.015,
              "y": 31.237,
              "z": 0.611
            },
            "gtin": "3607346516737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20710",
            "leftCorner": {
              "x": 0.015,
              "y": 31.237,
              "z": 0.611
            },
            "rightCorner": {
              "x": -0.032,
              "y": 31.238,
              "z": 0.611
            },
            "gtin": "3607346516737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20711",
            "leftCorner": {
              "x": -0.032,
              "y": 31.238,
              "z": 0.611
            },
            "rightCorner": {
              "x": -0.106,
              "y": 31.24,
              "z": 0.611
            },
            "gtin": "3607346511107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20712",
            "leftCorner": {
              "x": -0.106,
              "y": 31.24,
              "z": 0.611
            },
            "rightCorner": {
              "x": -0.179,
              "y": 31.243,
              "z": 0.611
            },
            "gtin": "3607346511107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20713",
            "leftCorner": {
              "x": -0.179,
              "y": 31.259,
              "z": 0.611
            },
            "rightCorner": {
              "x": -0.247,
              "y": 31.262,
              "z": 0.611
            },
            "gtin": "3607346511299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20714",
            "leftCorner": {
              "x": -0.247,
              "y": 31.262,
              "z": 0.611
            },
            "rightCorner": {
              "x": -0.316,
              "y": 31.264,
              "z": 0.611
            },
            "gtin": "3607346511299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20715",
            "leftCorner": {
              "x": -0.316,
              "y": 31.264,
              "z": 0.611
            },
            "rightCorner": {
              "x": -0.385,
              "y": 31.267,
              "z": 0.611
            },
            "gtin": "3607346511299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20716",
            "leftCorner": {
              "x": -0.385,
              "y": 31.262,
              "z": 0.611
            },
            "rightCorner": {
              "x": -0.453,
              "y": 31.265,
              "z": 0.611
            },
            "gtin": "085715320131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20717",
            "leftCorner": {
              "x": -0.453,
              "y": 31.265,
              "z": 0.611
            },
            "rightCorner": {
              "x": -0.521,
              "y": 31.267,
              "z": 0.611
            },
            "gtin": "085715320131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206fc",
            "leftCorner": {
              "x": -0.522,
              "y": 31.256,
              "z": 0.611
            },
            "rightCorner": {
              "x": -0.579,
              "y": 31.259,
              "z": 0.611
            },
            "gtin": "3326240005320",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469b7",
        "height": 1.0101,
        "facings": [
          {
            "id": "68300c895ed67a01d9a206e2",
            "leftCorner": {
              "x": 0.612,
              "y": 31.133,
              "z": 0.826
            },
            "rightCorner": {
              "x": 0.536,
              "y": 31.136,
              "z": 0.826
            },
            "gtin": "719346643870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206e3",
            "leftCorner": {
              "x": 0.536,
              "y": 31.136,
              "z": 0.826
            },
            "rightCorner": {
              "x": 0.459,
              "y": 31.139,
              "z": 0.826
            },
            "gtin": "719346643870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206e4",
            "leftCorner": {
              "x": 0.46,
              "y": 31.154,
              "z": 0.826
            },
            "rightCorner": {
              "x": 0.371,
              "y": 31.158,
              "z": 0.826
            },
            "gtin": "3616304961212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206e5",
            "leftCorner": {
              "x": 0.371,
              "y": 31.148,
              "z": 0.826
            },
            "rightCorner": {
              "x": 0.24,
              "y": 31.153,
              "z": 0.826
            },
            "gtin": "3616305169433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206e6",
            "leftCorner": {
              "x": 0.24,
              "y": 31.144,
              "z": 0.826
            },
            "rightCorner": {
              "x": 0.113,
              "y": 31.149,
              "z": 0.826
            },
            "gtin": "4015953713200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206e7",
            "leftCorner": {
              "x": 0.113,
              "y": 31.154,
              "z": 0.826
            },
            "rightCorner": {
              "x": 0.013,
              "y": 31.158,
              "z": 0.826
            },
            "gtin": "5050456006427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206e8",
            "leftCorner": {
              "x": 0.013,
              "y": 31.158,
              "z": 0.826
            },
            "rightCorner": {
              "x": -0.086,
              "y": 31.162,
              "z": 0.826
            },
            "gtin": "5050456006427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206e9",
            "leftCorner": {
              "x": -0.086,
              "y": 31.162,
              "z": 0.826
            },
            "rightCorner": {
              "x": -0.186,
              "y": 31.166,
              "z": 0.826
            },
            "gtin": "5050456006427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206ea",
            "leftCorner": {
              "x": -0.186,
              "y": 31.166,
              "z": 0.826
            },
            "rightCorner": {
              "x": -0.286,
              "y": 31.169,
              "z": 0.826
            },
            "gtin": "5050456006427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206d3",
            "leftCorner": {
              "x": -0.287,
              "y": 31.157,
              "z": 0.826
            },
            "rightCorner": {
              "x": -0.385,
              "y": 31.161,
              "z": 0.826
            },
            "gtin": "3616303795429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206d4",
            "leftCorner": {
              "x": -0.385,
              "y": 31.161,
              "z": 0.826
            },
            "rightCorner": {
              "x": -0.484,
              "y": 31.165,
              "z": 0.826
            },
            "gtin": "3616303795429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206d5",
            "leftCorner": {
              "x": -0.484,
              "y": 31.165,
              "z": 0.826
            },
            "rightCorner": {
              "x": -0.582,
              "y": 31.169,
              "z": 0.826
            },
            "gtin": "3616303795429",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469b8",
        "height": 1.2491,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2073a",
            "leftCorner": {
              "x": 0.451,
              "y": 31.116,
              "z": 1.022
            },
            "rightCorner": {
              "x": 0.379,
              "y": 31.119,
              "z": 1.022
            },
            "gtin": "3616301641025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2073b",
            "leftCorner": {
              "x": 0.379,
              "y": 31.119,
              "z": 1.022
            },
            "rightCorner": {
              "x": 0.308,
              "y": 31.121,
              "z": 1.022
            },
            "gtin": "3616301641025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2073c",
            "leftCorner": {
              "x": 0.308,
              "y": 31.121,
              "z": 1.022
            },
            "rightCorner": {
              "x": 0.237,
              "y": 31.124,
              "z": 1.022
            },
            "gtin": "3616301641025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2073d",
            "leftCorner": {
              "x": 0.237,
              "y": 31.137,
              "z": 1.022
            },
            "rightCorner": {
              "x": 0.127,
              "y": 31.141,
              "z": 1.022
            },
            "gtin": "5050456524457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2073e",
            "leftCorner": {
              "x": 0.127,
              "y": 31.135,
              "z": 1.022
            },
            "rightCorner": {
              "x": 0.002,
              "y": 31.14,
              "z": 1.022
            },
            "gtin": "3616305169433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2073f",
            "leftCorner": {
              "x": 0.002,
              "y": 31.126,
              "z": 1.022
            },
            "rightCorner": {
              "x": -0.211,
              "y": 31.134,
              "z": 1.022
            },
            "gtin": "3326240003814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2072a",
            "leftCorner": {
              "x": -0.21,
              "y": 31.162,
              "z": 1.022
            },
            "rightCorner": {
              "x": -0.396,
              "y": 31.17,
              "z": 1.022
            },
            "gtin": "3614228850629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2072b",
            "leftCorner": {
              "x": -0.396,
              "y": 31.17,
              "z": 1.022
            },
            "rightCorner": {
              "x": -0.582,
              "y": 31.177,
              "z": 1.022
            },
            "gtin": "3614228850629",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469b9",
        "height": 1.5026,
        "facings": [
          {
            "id": "68300c895ed67a01d9a206f2",
            "leftCorner": {
              "x": 0.608,
              "y": 31.142,
              "z": 1.229
            },
            "rightCorner": {
              "x": 0.524,
              "y": 31.146,
              "z": 1.229
            },
            "gtin": "5903719641630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206f3",
            "leftCorner": {
              "x": 0.524,
              "y": 31.146,
              "z": 1.229
            },
            "rightCorner": {
              "x": 0.441,
              "y": 31.149,
              "z": 1.229
            },
            "gtin": "5903719641630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206f4",
            "leftCorner": {
              "x": 0.441,
              "y": 31.149,
              "z": 1.229
            },
            "rightCorner": {
              "x": 0.358,
              "y": 31.152,
              "z": 1.229
            },
            "gtin": "5903719641630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206f5",
            "leftCorner": {
              "x": 0.357,
              "y": 31.129,
              "z": 1.229
            },
            "rightCorner": {
              "x": 0.22,
              "y": 31.134,
              "z": 1.229
            },
            "gtin": "5903719641661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206f6",
            "leftCorner": {
              "x": 0.22,
              "y": 31.13,
              "z": 1.229
            },
            "rightCorner": {
              "x": 0.07,
              "y": 31.135,
              "z": 1.229
            },
            "gtin": "4015953734700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206f7",
            "leftCorner": {
              "x": 0.07,
              "y": 31.135,
              "z": 1.229
            },
            "rightCorner": {
              "x": -0.081,
              "y": 31.142,
              "z": 1.229
            },
            "gtin": "4015953734700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206f8",
            "leftCorner": {
              "x": -0.081,
              "y": 31.149,
              "z": 1.229
            },
            "rightCorner": {
              "x": -0.19,
              "y": 31.154,
              "z": 1.229
            },
            "gtin": "719346296625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206f9",
            "leftCorner": {
              "x": -0.19,
              "y": 31.154,
              "z": 1.229
            },
            "rightCorner": {
              "x": -0.3,
              "y": 31.158,
              "z": 1.229
            },
            "gtin": "719346296625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206fa",
            "leftCorner": {
              "x": -0.3,
              "y": 31.148,
              "z": 1.229
            },
            "rightCorner": {
              "x": -0.472,
              "y": 31.155,
              "z": 1.229
            },
            "gtin": "5050456005925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206ec",
            "leftCorner": {
              "x": -0.472,
              "y": 31.157,
              "z": 1.229
            },
            "rightCorner": {
              "x": -0.583,
              "y": 31.161,
              "z": 1.229
            },
            "gtin": "4015953658136",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468c4",
    "rightNeighborShelfId": "a6d4e"
  },
  {
    "id": "468c6",
    "name": "468c6",
    "x": -10.434,
    "y": 30.812,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.026709,
      "w": 0.99964
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 88
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546643",
        "height": 0.17162,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20672",
            "leftCorner": {
              "x": -10.049,
              "y": 30.851,
              "z": 0.14
            },
            "rightCorner": {
              "x": -9.858,
              "y": 30.841,
              "z": 0.14
            },
            "gtin": "4063367047800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20673",
            "leftCorner": {
              "x": -9.858,
              "y": 30.841,
              "z": 0.14
            },
            "rightCorner": {
              "x": -9.668,
              "y": 30.831,
              "z": 0.14
            },
            "gtin": "4063367047800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20674",
            "leftCorner": {
              "x": -9.668,
              "y": 30.831,
              "z": 0.14
            },
            "rightCorner": {
              "x": -9.478,
              "y": 30.82,
              "z": 0.14
            },
            "gtin": "4063367047800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20675",
            "leftCorner": {
              "x": -9.478,
              "y": 30.807,
              "z": 0.14
            },
            "rightCorner": {
              "x": -9.43,
              "y": 30.804,
              "z": 0.14
            },
            "gtin": "4015100860207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20676",
            "leftCorner": {
              "x": -9.43,
              "y": 30.804,
              "z": 0.14
            },
            "rightCorner": {
              "x": -9.381,
              "y": 30.802,
              "z": 0.14
            },
            "gtin": "4015100860207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20677",
            "leftCorner": {
              "x": -9.381,
              "y": 30.802,
              "z": 0.14
            },
            "rightCorner": {
              "x": -9.334,
              "y": 30.799,
              "z": 0.14
            },
            "gtin": "4015100860207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20678",
            "leftCorner": {
              "x": -9.333,
              "y": 30.815,
              "z": 0.14
            },
            "rightCorner": {
              "x": -9.262,
              "y": 30.811,
              "z": 0.14
            },
            "gtin": "4015100860085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20679",
            "leftCorner": {
              "x": -9.262,
              "y": 30.811,
              "z": 0.14
            },
            "rightCorner": {
              "x": -9.191,
              "y": 30.807,
              "z": 0.14
            },
            "gtin": "4015100860085",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546641",
        "height": 0.49047,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2059b",
            "leftCorner": {
              "x": -10.437,
              "y": 30.943,
              "z": 0.401
            },
            "rightCorner": {
              "x": -10.363,
              "y": 30.94,
              "z": 0.401
            },
            "gtin": "5010724527474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2059c",
            "leftCorner": {
              "x": -10.363,
              "y": 30.94,
              "z": 0.401
            },
            "rightCorner": {
              "x": -10.288,
              "y": 30.936,
              "z": 0.401
            },
            "gtin": "5010724527474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2059d",
            "leftCorner": {
              "x": -10.287,
              "y": 30.954,
              "z": 0.401
            },
            "rightCorner": {
              "x": -10.249,
              "y": 30.951,
              "z": 0.401
            },
            "gtin": "4005900756077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2059e",
            "leftCorner": {
              "x": -10.249,
              "y": 30.951,
              "z": 0.401
            },
            "rightCorner": {
              "x": -10.211,
              "y": 30.949,
              "z": 0.401
            },
            "gtin": "4005900756077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2059f",
            "leftCorner": {
              "x": -10.211,
              "y": 30.953,
              "z": 0.401
            },
            "rightCorner": {
              "x": -10.117,
              "y": 30.948,
              "z": 0.401
            },
            "gtin": "4005900952967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205a0",
            "leftCorner": {
              "x": -10.118,
              "y": 30.941,
              "z": 0.401
            },
            "rightCorner": {
              "x": -10.041,
              "y": 30.937,
              "z": 0.401
            },
            "gtin": "4005900755971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205a1",
            "leftCorner": {
              "x": -10.041,
              "y": 30.937,
              "z": 0.401
            },
            "rightCorner": {
              "x": -9.965,
              "y": 30.933,
              "z": 0.401
            },
            "gtin": "4005900755971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205a2",
            "leftCorner": {
              "x": -9.965,
              "y": 30.933,
              "z": 0.401
            },
            "rightCorner": {
              "x": -9.888,
              "y": 30.929,
              "z": 0.401
            },
            "gtin": "4005900755971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205a3",
            "leftCorner": {
              "x": -9.888,
              "y": 30.929,
              "z": 0.401
            },
            "rightCorner": {
              "x": -9.812,
              "y": 30.925,
              "z": 0.401
            },
            "gtin": "4005900755971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205a4",
            "leftCorner": {
              "x": -9.812,
              "y": 30.928,
              "z": 0.401
            },
            "rightCorner": {
              "x": -9.757,
              "y": 30.926,
              "z": 0.401
            },
            "gtin": "4015100810042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205a5",
            "leftCorner": {
              "x": -9.757,
              "y": 30.926,
              "z": 0.401
            },
            "rightCorner": {
              "x": -9.703,
              "y": 30.922,
              "z": 0.401
            },
            "gtin": "4015100810042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205a6",
            "leftCorner": {
              "x": -9.703,
              "y": 30.915,
              "z": 0.401
            },
            "rightCorner": {
              "x": -9.63,
              "y": 30.912,
              "z": 0.401
            },
            "gtin": "4015100810080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205a7",
            "leftCorner": {
              "x": -9.63,
              "y": 30.913,
              "z": 0.401
            },
            "rightCorner": {
              "x": -9.535,
              "y": 30.908,
              "z": 0.401
            },
            "gtin": "4015100809961",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205a8",
            "leftCorner": {
              "x": -9.535,
              "y": 30.908,
              "z": 0.401
            },
            "rightCorner": {
              "x": -9.467,
              "y": 30.905,
              "z": 0.401
            },
            "gtin": "4015100809985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205a9",
            "leftCorner": {
              "x": -9.467,
              "y": 30.905,
              "z": 0.401
            },
            "rightCorner": {
              "x": -9.399,
              "y": 30.901,
              "z": 0.401
            },
            "gtin": "4015100809985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205aa",
            "leftCorner": {
              "x": -9.399,
              "y": 30.902,
              "z": 0.401
            },
            "rightCorner": {
              "x": -9.329,
              "y": 30.899,
              "z": 0.401
            },
            "gtin": "4015100810028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205ab",
            "leftCorner": {
              "x": -9.329,
              "y": 30.899,
              "z": 0.401
            },
            "rightCorner": {
              "x": -9.26,
              "y": 30.895,
              "z": 0.401
            },
            "gtin": "4015100810028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205ac",
            "leftCorner": {
              "x": -9.26,
              "y": 30.887,
              "z": 0.401
            },
            "rightCorner": {
              "x": -9.218,
              "y": 30.884,
              "z": 0.401
            },
            "gtin": "4015100810288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205ad",
            "leftCorner": {
              "x": -9.218,
              "y": 30.884,
              "z": 0.401
            },
            "rightCorner": {
              "x": -9.177,
              "y": 30.882,
              "z": 0.401
            },
            "gtin": "4015100810288",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546642",
        "height": 0.79109,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20954",
            "leftCorner": {
              "x": -10.311,
              "y": 30.947,
              "z": 0.647
            },
            "rightCorner": {
              "x": -10.174,
              "y": 30.939,
              "z": 0.647
            },
            "gtin": "4015100734966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20955",
            "leftCorner": {
              "x": -10.174,
              "y": 30.933,
              "z": 0.647
            },
            "rightCorner": {
              "x": -10.107,
              "y": 30.929,
              "z": 0.647
            },
            "gtin": "4015100817065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20956",
            "leftCorner": {
              "x": -10.106,
              "y": 30.94,
              "z": 0.647
            },
            "rightCorner": {
              "x": -10.024,
              "y": 30.936,
              "z": 0.647
            },
            "gtin": "4015100816983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20957",
            "leftCorner": {
              "x": -10.024,
              "y": 30.936,
              "z": 0.647
            },
            "rightCorner": {
              "x": -9.946,
              "y": 30.932,
              "z": 0.647
            },
            "gtin": "4015100763744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20958",
            "leftCorner": {
              "x": -9.946,
              "y": 30.926,
              "z": 0.647
            },
            "rightCorner": {
              "x": -9.875,
              "y": 30.922,
              "z": 0.647
            },
            "gtin": "4015100816969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20959",
            "leftCorner": {
              "x": -9.875,
              "y": 30.922,
              "z": 0.647
            },
            "rightCorner": {
              "x": -9.755,
              "y": 30.916,
              "z": 0.647
            },
            "gtin": "4015100816884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2095a",
            "leftCorner": {
              "x": -9.755,
              "y": 30.927,
              "z": 0.647
            },
            "rightCorner": {
              "x": -9.656,
              "y": 30.921,
              "z": 0.647
            },
            "gtin": "4015100816921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2095b",
            "leftCorner": {
              "x": -9.656,
              "y": 30.922,
              "z": 0.647
            },
            "rightCorner": {
              "x": -9.598,
              "y": 30.919,
              "z": 0.647
            },
            "gtin": "4005900981585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2095c",
            "leftCorner": {
              "x": -9.598,
              "y": 30.919,
              "z": 0.647
            },
            "rightCorner": {
              "x": -9.541,
              "y": 30.916,
              "z": 0.647
            },
            "gtin": "4005900981585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2095d",
            "leftCorner": {
              "x": -9.542,
              "y": 30.904,
              "z": 0.647
            },
            "rightCorner": {
              "x": -9.479,
              "y": 30.902,
              "z": 0.647
            },
            "gtin": "4005900749727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2095e",
            "leftCorner": {
              "x": -9.479,
              "y": 30.902,
              "z": 0.647
            },
            "rightCorner": {
              "x": -9.417,
              "y": 30.898,
              "z": 0.647
            },
            "gtin": "4005900749727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2095f",
            "leftCorner": {
              "x": -9.416,
              "y": 30.91,
              "z": 0.647
            },
            "rightCorner": {
              "x": -9.372,
              "y": 30.908,
              "z": 0.647
            },
            "gtin": "4005900749680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20960",
            "leftCorner": {
              "x": -9.372,
              "y": 30.908,
              "z": 0.647
            },
            "rightCorner": {
              "x": -9.328,
              "y": 30.906,
              "z": 0.647
            },
            "gtin": "4005900749680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20961",
            "leftCorner": {
              "x": -9.328,
              "y": 30.906,
              "z": 0.647
            },
            "rightCorner": {
              "x": -9.283,
              "y": 30.903,
              "z": 0.647
            },
            "gtin": "4005900749680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20942",
            "leftCorner": {
              "x": -9.283,
              "y": 30.901,
              "z": 0.647
            },
            "rightCorner": {
              "x": -9.178,
              "y": 30.895,
              "z": 0.647
            },
            "gtin": "4005900749369",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546640",
        "height": 1.0453,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20930",
            "leftCorner": {
              "x": -10.425,
              "y": 30.944,
              "z": 0.855
            },
            "rightCorner": {
              "x": -10.352,
              "y": 30.94,
              "z": 0.855
            },
            "gtin": "4015100810967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20931",
            "leftCorner": {
              "x": -10.352,
              "y": 30.94,
              "z": 0.855
            },
            "rightCorner": {
              "x": -10.279,
              "y": 30.935,
              "z": 0.855
            },
            "gtin": "4015100810967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20932",
            "leftCorner": {
              "x": -10.279,
              "y": 30.934,
              "z": 0.855
            },
            "rightCorner": {
              "x": -10.229,
              "y": 30.932,
              "z": 0.855
            },
            "gtin": "4015100811049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20933",
            "leftCorner": {
              "x": -10.229,
              "y": 30.932,
              "z": 0.855
            },
            "rightCorner": {
              "x": -10.179,
              "y": 30.929,
              "z": 0.855
            },
            "gtin": "4015100811049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20934",
            "leftCorner": {
              "x": -10.179,
              "y": 30.929,
              "z": 0.855
            },
            "rightCorner": {
              "x": -10.129,
              "y": 30.927,
              "z": 0.855
            },
            "gtin": "4015100811049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20935",
            "leftCorner": {
              "x": -10.129,
              "y": 30.932,
              "z": 0.855
            },
            "rightCorner": {
              "x": -10.061,
              "y": 30.929,
              "z": 0.855
            },
            "gtin": "4015100810882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20936",
            "leftCorner": {
              "x": -10.061,
              "y": 30.929,
              "z": 0.855
            },
            "rightCorner": {
              "x": -9.994,
              "y": 30.925,
              "z": 0.855
            },
            "gtin": "4015100810882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20937",
            "leftCorner": {
              "x": -9.994,
              "y": 30.933,
              "z": 0.855
            },
            "rightCorner": {
              "x": -9.93,
              "y": 30.929,
              "z": 0.855
            },
            "gtin": "4013162032839",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20938",
            "leftCorner": {
              "x": -9.93,
              "y": 30.929,
              "z": 0.855
            },
            "rightCorner": {
              "x": -9.865,
              "y": 30.925,
              "z": 0.855
            },
            "gtin": "4013162032839",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20939",
            "leftCorner": {
              "x": -9.865,
              "y": 30.925,
              "z": 0.855
            },
            "rightCorner": {
              "x": -9.801,
              "y": 30.923,
              "z": 0.855
            },
            "gtin": "4013162032839",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2093a",
            "leftCorner": {
              "x": -9.801,
              "y": 30.906,
              "z": 0.855
            },
            "rightCorner": {
              "x": -9.721,
              "y": 30.901,
              "z": 0.855
            },
            "gtin": "4013162032815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2093b",
            "leftCorner": {
              "x": -9.721,
              "y": 30.901,
              "z": 0.855
            },
            "rightCorner": {
              "x": -9.641,
              "y": 30.898,
              "z": 0.855
            },
            "gtin": "4013162032815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2093c",
            "leftCorner": {
              "x": -9.642,
              "y": 30.888,
              "z": 0.855
            },
            "rightCorner": {
              "x": -9.584,
              "y": 30.884,
              "z": 0.855
            },
            "gtin": "4013162032853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2093d",
            "leftCorner": {
              "x": -9.584,
              "y": 30.884,
              "z": 0.855
            },
            "rightCorner": {
              "x": -9.527,
              "y": 30.882,
              "z": 0.855
            },
            "gtin": "4013162032853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2093e",
            "leftCorner": {
              "x": -9.527,
              "y": 30.882,
              "z": 0.855
            },
            "rightCorner": {
              "x": -9.47,
              "y": 30.878,
              "z": 0.855
            },
            "gtin": "4013162032853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2093f",
            "leftCorner": {
              "x": -9.47,
              "y": 30.878,
              "z": 0.855
            },
            "rightCorner": {
              "x": -9.413,
              "y": 30.876,
              "z": 0.855
            },
            "gtin": "4013162032853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20919",
            "leftCorner": {
              "x": -9.412,
              "y": 30.898,
              "z": 0.855
            },
            "rightCorner": {
              "x": -9.334,
              "y": 30.894,
              "z": 0.855
            },
            "gtin": "5014697020307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2091a",
            "leftCorner": {
              "x": -9.334,
              "y": 30.894,
              "z": 0.855
            },
            "rightCorner": {
              "x": -9.256,
              "y": 30.89,
              "z": 0.855
            },
            "gtin": "5014697020307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2091b",
            "leftCorner": {
              "x": -9.256,
              "y": 30.89,
              "z": 0.855
            },
            "rightCorner": {
              "x": -9.179,
              "y": 30.885,
              "z": 0.855
            },
            "gtin": "5014697020307",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54663e",
        "height": 1.2951,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20970",
            "leftCorner": {
              "x": -10.389,
              "y": 31.05,
              "z": 1.06
            },
            "rightCorner": {
              "x": -10.323,
              "y": 31.046,
              "z": 1.06
            },
            "gtin": "3600523528738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20971",
            "leftCorner": {
              "x": -10.323,
              "y": 31.046,
              "z": 1.06
            },
            "rightCorner": {
              "x": -10.256,
              "y": 31.042,
              "z": 1.06
            },
            "gtin": "3600523528738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20972",
            "leftCorner": {
              "x": -10.256,
              "y": 31.055,
              "z": 1.06
            },
            "rightCorner": {
              "x": -10.185,
              "y": 31.051,
              "z": 1.06
            },
            "gtin": "4015100811063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20973",
            "leftCorner": {
              "x": -10.186,
              "y": 31.039,
              "z": 1.06
            },
            "rightCorner": {
              "x": -10.091,
              "y": 31.034,
              "z": 1.06
            },
            "gtin": "4015100810905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20974",
            "leftCorner": {
              "x": -10.09,
              "y": 31.049,
              "z": 1.06
            },
            "rightCorner": {
              "x": -10.034,
              "y": 31.046,
              "z": 1.06
            },
            "gtin": "42373964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20975",
            "leftCorner": {
              "x": -10.034,
              "y": 31.037,
              "z": 1.06
            },
            "rightCorner": {
              "x": -9.943,
              "y": 31.033,
              "z": 1.06
            },
            "gtin": "4015100811001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20976",
            "leftCorner": {
              "x": -9.942,
              "y": 31.042,
              "z": 1.06
            },
            "rightCorner": {
              "x": -9.809,
              "y": 31.035,
              "z": 1.06
            },
            "gtin": "3600522471752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20977",
            "leftCorner": {
              "x": -9.809,
              "y": 31.035,
              "z": 1.06
            },
            "rightCorner": {
              "x": -9.677,
              "y": 31.028,
              "z": 1.06
            },
            "gtin": "3600522471752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20978",
            "leftCorner": {
              "x": -9.677,
              "y": 31.026,
              "z": 1.06
            },
            "rightCorner": {
              "x": -9.498,
              "y": 31.016,
              "z": 1.06
            },
            "gtin": "3600523767076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20979",
            "leftCorner": {
              "x": -9.499,
              "y": 31.004,
              "z": 1.06
            },
            "rightCorner": {
              "x": -9.427,
              "y": 31.0,
              "z": 1.06
            },
            "gtin": "4005900183828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2097a",
            "leftCorner": {
              "x": -9.427,
              "y": 31.0,
              "z": 1.06
            },
            "rightCorner": {
              "x": -9.354,
              "y": 30.997,
              "z": 1.06
            },
            "gtin": "4005900183828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20963",
            "leftCorner": {
              "x": -9.353,
              "y": 31.017,
              "z": 1.06
            },
            "rightCorner": {
              "x": -9.172,
              "y": 31.007,
              "z": 1.06
            },
            "gtin": "4005900137432",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54663f",
        "height": 1.4992,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20541",
            "leftCorner": {
              "x": -10.406,
              "y": 31.052,
              "z": 1.227
            },
            "rightCorner": {
              "x": -10.341,
              "y": 31.049,
              "z": 1.227
            },
            "gtin": "4064666594620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20542",
            "leftCorner": {
              "x": -10.341,
              "y": 31.049,
              "z": 1.227
            },
            "rightCorner": {
              "x": -10.276,
              "y": 31.045,
              "z": 1.227
            },
            "gtin": "4064666594620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20543",
            "leftCorner": {
              "x": -10.276,
              "y": 31.045,
              "z": 1.227
            },
            "rightCorner": {
              "x": -10.211,
              "y": 31.043,
              "z": 1.227
            },
            "gtin": "4064666594620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20544",
            "leftCorner": {
              "x": -10.211,
              "y": 31.042,
              "z": 1.227
            },
            "rightCorner": {
              "x": -10.067,
              "y": 31.033,
              "z": 1.227
            },
            "gtin": "4064666587479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20545",
            "leftCorner": {
              "x": -10.067,
              "y": 31.043,
              "z": 1.227
            },
            "rightCorner": {
              "x": -10.011,
              "y": 31.04,
              "z": 1.227
            },
            "gtin": "4064666587462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20546",
            "leftCorner": {
              "x": -10.011,
              "y": 31.04,
              "z": 1.227
            },
            "rightCorner": {
              "x": -9.955,
              "y": 31.037,
              "z": 1.227
            },
            "gtin": "4064666587462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20547",
            "leftCorner": {
              "x": -9.955,
              "y": 31.037,
              "z": 1.227
            },
            "rightCorner": {
              "x": -9.9,
              "y": 31.034,
              "z": 1.227
            },
            "gtin": "4064666587462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20548",
            "leftCorner": {
              "x": -9.9,
              "y": 31.025,
              "z": 1.227
            },
            "rightCorner": {
              "x": -9.836,
              "y": 31.021,
              "z": 1.227
            },
            "gtin": "30177819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20549",
            "leftCorner": {
              "x": -9.836,
              "y": 31.028,
              "z": 1.227
            },
            "rightCorner": {
              "x": -9.766,
              "y": 31.024,
              "z": 1.227
            },
            "gtin": "3600523766611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2054a",
            "leftCorner": {
              "x": -9.766,
              "y": 31.024,
              "z": 1.227
            },
            "rightCorner": {
              "x": -9.697,
              "y": 31.02,
              "z": 1.227
            },
            "gtin": "3600523766611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2054b",
            "leftCorner": {
              "x": -9.698,
              "y": 31.009,
              "z": 1.227
            },
            "rightCorner": {
              "x": -9.589,
              "y": 31.003,
              "z": 1.227
            },
            "gtin": "4015100800463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2054c",
            "leftCorner": {
              "x": -9.588,
              "y": 31.011,
              "z": 1.227
            },
            "rightCorner": {
              "x": -9.47,
              "y": 31.005,
              "z": 1.227
            },
            "gtin": "4015100800401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2054d",
            "leftCorner": {
              "x": -9.47,
              "y": 31.003,
              "z": 1.227
            },
            "rightCorner": {
              "x": -9.374,
              "y": 30.998,
              "z": 1.227
            },
            "gtin": "9120064451677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2054e",
            "leftCorner": {
              "x": -9.374,
              "y": 31.001,
              "z": 1.227
            },
            "rightCorner": {
              "x": -9.258,
              "y": 30.995,
              "z": 1.227
            },
            "gtin": "9120064451660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2054f",
            "leftCorner": {
              "x": -9.258,
              "y": 31.001,
              "z": 1.227
            },
            "rightCorner": {
              "x": -9.172,
              "y": 30.996,
              "z": 1.227
            },
            "gtin": "9120064451684",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d13d0",
    "rightNeighborShelfId": "468c7"
  },
  {
    "id": "468c7",
    "name": "468c7",
    "x": -9.185,
    "y": 30.746,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.026709,
      "w": 0.99964
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 77
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546649",
        "height": 0.1662,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2067a",
            "leftCorner": {
              "x": -9.192,
              "y": 30.788,
              "z": 0.136
            },
            "rightCorner": {
              "x": -9.1,
              "y": 30.783,
              "z": 0.136
            },
            "gtin": "3600540244901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2067b",
            "leftCorner": {
              "x": -9.101,
              "y": 30.765,
              "z": 0.136
            },
            "rightCorner": {
              "x": -9.0,
              "y": 30.761,
              "z": 0.136
            },
            "gtin": "4002441020087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2067c",
            "leftCorner": {
              "x": -8.999,
              "y": 30.773,
              "z": 0.136
            },
            "rightCorner": {
              "x": -8.943,
              "y": 30.769,
              "z": 0.136
            },
            "gtin": "4002441020261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2067d",
            "leftCorner": {
              "x": -8.943,
              "y": 30.769,
              "z": 0.136
            },
            "rightCorner": {
              "x": -8.885,
              "y": 30.767,
              "z": 0.136
            },
            "gtin": "4002441020261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2067e",
            "leftCorner": {
              "x": -8.885,
              "y": 30.771,
              "z": 0.136
            },
            "rightCorner": {
              "x": -8.748,
              "y": 30.764,
              "z": 0.136
            },
            "gtin": "3600541375369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2067f",
            "leftCorner": {
              "x": -8.748,
              "y": 30.764,
              "z": 0.136
            },
            "rightCorner": {
              "x": -8.611,
              "y": 30.757,
              "z": 0.136
            },
            "gtin": "3600541375369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20680",
            "leftCorner": {
              "x": -8.611,
              "y": 30.757,
              "z": 0.136
            },
            "rightCorner": {
              "x": -8.472,
              "y": 30.749,
              "z": 0.136
            },
            "gtin": "3600541375369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20681",
            "leftCorner": {
              "x": -8.472,
              "y": 30.756,
              "z": 0.136
            },
            "rightCorner": {
              "x": -8.362,
              "y": 30.751,
              "z": 0.136
            },
            "gtin": "3600541900141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20682",
            "leftCorner": {
              "x": -8.362,
              "y": 30.751,
              "z": 0.136
            },
            "rightCorner": {
              "x": -8.252,
              "y": 30.745,
              "z": 0.136
            },
            "gtin": "3600541900141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20683",
            "leftCorner": {
              "x": -8.251,
              "y": 30.77,
              "z": 0.136
            },
            "rightCorner": {
              "x": -8.112,
              "y": 30.763,
              "z": 0.136
            },
            "gtin": "4002441020193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20684",
            "leftCorner": {
              "x": -8.113,
              "y": 30.736,
              "z": 0.136
            },
            "rightCorner": {
              "x": -8.021,
              "y": 30.731,
              "z": 0.136
            },
            "gtin": "4002441020209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20685",
            "leftCorner": {
              "x": -8.021,
              "y": 30.731,
              "z": 0.136
            },
            "rightCorner": {
              "x": -7.929,
              "y": 30.727,
              "z": 0.136
            },
            "gtin": "4002441020209",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546646",
        "height": 0.49256,
        "facings": [
          {
            "id": "68300c895ed67a01d9a205ae",
            "leftCorner": {
              "x": -9.176,
              "y": 30.887,
              "z": 0.403
            },
            "rightCorner": {
              "x": -9.076,
              "y": 30.881,
              "z": 0.403
            },
            "gtin": "3600541901643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205af",
            "leftCorner": {
              "x": -9.076,
              "y": 30.881,
              "z": 0.403
            },
            "rightCorner": {
              "x": -8.976,
              "y": 30.876,
              "z": 0.403
            },
            "gtin": "3600541901643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205b0",
            "leftCorner": {
              "x": -8.976,
              "y": 30.878,
              "z": 0.403
            },
            "rightCorner": {
              "x": -8.858,
              "y": 30.871,
              "z": 0.403
            },
            "gtin": "3600541043046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205b1",
            "leftCorner": {
              "x": -8.858,
              "y": 30.869,
              "z": 0.403
            },
            "rightCorner": {
              "x": -8.732,
              "y": 30.862,
              "z": 0.403
            },
            "gtin": "3600542389877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205b2",
            "leftCorner": {
              "x": -8.731,
              "y": 30.871,
              "z": 0.403
            },
            "rightCorner": {
              "x": -8.626,
              "y": 30.866,
              "z": 0.403
            },
            "gtin": "3600540912183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205b3",
            "leftCorner": {
              "x": -8.626,
              "y": 30.873,
              "z": 0.403
            },
            "rightCorner": {
              "x": -8.515,
              "y": 30.867,
              "z": 0.403
            },
            "gtin": "3600541670488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205b4",
            "leftCorner": {
              "x": -8.516,
              "y": 30.839,
              "z": 0.403
            },
            "rightCorner": {
              "x": -8.41,
              "y": 30.833,
              "z": 0.403
            },
            "gtin": "3600541043060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205b5",
            "leftCorner": {
              "x": -8.41,
              "y": 30.833,
              "z": 0.403
            },
            "rightCorner": {
              "x": -8.304,
              "y": 30.827,
              "z": 0.403
            },
            "gtin": "3600541043060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205b6",
            "leftCorner": {
              "x": -8.304,
              "y": 30.841,
              "z": 0.403
            },
            "rightCorner": {
              "x": -8.194,
              "y": 30.836,
              "z": 0.403
            },
            "gtin": "4002441020308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205b7",
            "leftCorner": {
              "x": -8.193,
              "y": 30.843,
              "z": 0.403
            },
            "rightCorner": {
              "x": -8.079,
              "y": 30.837,
              "z": 0.403
            },
            "gtin": "3600542466547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205b8",
            "leftCorner": {
              "x": -8.078,
              "y": 30.844,
              "z": 0.403
            },
            "rightCorner": {
              "x": -7.925,
              "y": 30.837,
              "z": 0.403
            },
            "gtin": "3600540604415",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546645",
        "height": 0.74735,
        "facings": [
          {
            "id": "68300c895ed67a01d9a204fb",
            "leftCorner": {
              "x": -9.18,
              "y": 30.855,
              "z": 0.611
            },
            "rightCorner": {
              "x": -9.059,
              "y": 30.848,
              "z": 0.611
            },
            "gtin": "3600540871565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204ff",
            "leftCorner": {
              "x": -9.058,
              "y": 30.872,
              "z": 0.611
            },
            "rightCorner": {
              "x": -8.976,
              "y": 30.867,
              "z": 0.611
            },
            "gtin": "4002441020278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20500",
            "leftCorner": {
              "x": -8.975,
              "y": 30.876,
              "z": 0.611
            },
            "rightCorner": {
              "x": -8.876,
              "y": 30.871,
              "z": 0.611
            },
            "gtin": "3600541901759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20501",
            "leftCorner": {
              "x": -8.876,
              "y": 30.873,
              "z": 0.611
            },
            "rightCorner": {
              "x": -8.764,
              "y": 30.868,
              "z": 0.611
            },
            "gtin": "3600542389822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20502",
            "leftCorner": {
              "x": -8.764,
              "y": 30.874,
              "z": 0.611
            },
            "rightCorner": {
              "x": -8.706,
              "y": 30.87,
              "z": 0.611
            },
            "gtin": "3600541043015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20503",
            "leftCorner": {
              "x": -8.706,
              "y": 30.87,
              "z": 0.611
            },
            "rightCorner": {
              "x": -8.648,
              "y": 30.868,
              "z": 0.611
            },
            "gtin": "3600541043015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20504",
            "leftCorner": {
              "x": -8.649,
              "y": 30.858,
              "z": 0.611
            },
            "rightCorner": {
              "x": -8.545,
              "y": 30.852,
              "z": 0.611
            },
            "gtin": "3600542451659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20505",
            "leftCorner": {
              "x": -8.544,
              "y": 30.862,
              "z": 0.611
            },
            "rightCorner": {
              "x": -8.437,
              "y": 30.856,
              "z": 0.611
            },
            "gtin": "4002441020056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20506",
            "leftCorner": {
              "x": -8.437,
              "y": 30.856,
              "z": 0.611
            },
            "rightCorner": {
              "x": -8.33,
              "y": 30.851,
              "z": 0.611
            },
            "gtin": "4002441020056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20507",
            "leftCorner": {
              "x": -8.329,
              "y": 30.857,
              "z": 0.611
            },
            "rightCorner": {
              "x": -8.223,
              "y": 30.851,
              "z": 0.611
            },
            "gtin": "4002441020063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20508",
            "leftCorner": {
              "x": -8.223,
              "y": 30.851,
              "z": 0.611
            },
            "rightCorner": {
              "x": -8.116,
              "y": 30.845,
              "z": 0.611
            },
            "gtin": "4002441020063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20509",
            "leftCorner": {
              "x": -8.116,
              "y": 30.839,
              "z": 0.611
            },
            "rightCorner": {
              "x": -8.023,
              "y": 30.834,
              "z": 0.611
            },
            "gtin": "3600542447041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2050a",
            "leftCorner": {
              "x": -8.023,
              "y": 30.828,
              "z": 0.611
            },
            "rightCorner": {
              "x": -7.93,
              "y": 30.824,
              "z": 0.611
            },
            "gtin": "4002441020254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2050b",
            "leftCorner": {
              "x": -7.93,
              "y": 30.824,
              "z": 0.611
            },
            "rightCorner": {
              "x": -7.836,
              "y": 30.819,
              "z": 0.611
            },
            "gtin": "4002441020254",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546644",
        "height": 0.99585,
        "facings": [
          {
            "id": "68300c895ed67a01d9a204c2",
            "leftCorner": {
              "x": -9.18,
              "y": 30.847,
              "z": 0.815
            },
            "rightCorner": {
              "x": -9.089,
              "y": 30.842,
              "z": 0.815
            },
            "gtin": "3600541337374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204c3",
            "leftCorner": {
              "x": -9.089,
              "y": 30.842,
              "z": 0.815
            },
            "rightCorner": {
              "x": -8.997,
              "y": 30.837,
              "z": 0.815
            },
            "gtin": "3600541337374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204c5",
            "leftCorner": {
              "x": -8.995,
              "y": 30.874,
              "z": 0.815
            },
            "rightCorner": {
              "x": -8.933,
              "y": 30.87,
              "z": 0.815
            },
            "gtin": "3600541250956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204c6",
            "leftCorner": {
              "x": -8.933,
              "y": 30.87,
              "z": 0.815
            },
            "rightCorner": {
              "x": -8.87,
              "y": 30.867,
              "z": 0.815
            },
            "gtin": "3600541250956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204c7",
            "leftCorner": {
              "x": -8.871,
              "y": 30.864,
              "z": 0.815
            },
            "rightCorner": {
              "x": -8.762,
              "y": 30.858,
              "z": 0.815
            },
            "gtin": "3600541251007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204c8",
            "leftCorner": {
              "x": -8.762,
              "y": 30.858,
              "z": 0.815
            },
            "rightCorner": {
              "x": -8.655,
              "y": 30.852,
              "z": 0.815
            },
            "gtin": "3600541251007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204c9",
            "leftCorner": {
              "x": -8.655,
              "y": 30.852,
              "z": 0.815
            },
            "rightCorner": {
              "x": -8.547,
              "y": 30.846,
              "z": 0.815
            },
            "gtin": "3600541251007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204ca",
            "leftCorner": {
              "x": -8.546,
              "y": 30.86,
              "z": 0.815
            },
            "rightCorner": {
              "x": -8.44,
              "y": 30.855,
              "z": 0.815
            },
            "gtin": "3600541251052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204cb",
            "leftCorner": {
              "x": -8.44,
              "y": 30.855,
              "z": 0.815
            },
            "rightCorner": {
              "x": -8.334,
              "y": 30.85,
              "z": 0.815
            },
            "gtin": "3600541251052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204cc",
            "leftCorner": {
              "x": -8.335,
              "y": 30.837,
              "z": 0.815
            },
            "rightCorner": {
              "x": -8.228,
              "y": 30.831,
              "z": 0.815
            },
            "gtin": "3600541402096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204cd",
            "leftCorner": {
              "x": -8.228,
              "y": 30.831,
              "z": 0.815
            },
            "rightCorner": {
              "x": -8.122,
              "y": 30.825,
              "z": 0.815
            },
            "gtin": "3600541402096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204ce",
            "leftCorner": {
              "x": -8.121,
              "y": 30.838,
              "z": 0.815
            },
            "rightCorner": {
              "x": -8.035,
              "y": 30.834,
              "z": 0.815
            },
            "gtin": "3600541910812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204cf",
            "leftCorner": {
              "x": -8.035,
              "y": 30.834,
              "z": 0.815
            },
            "rightCorner": {
              "x": -7.949,
              "y": 30.829,
              "z": 0.815
            },
            "gtin": "3600541910812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204d0",
            "leftCorner": {
              "x": -7.949,
              "y": 30.829,
              "z": 0.815
            },
            "rightCorner": {
              "x": -7.863,
              "y": 30.824,
              "z": 0.815
            },
            "gtin": "3600541910812",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546647",
        "height": 1.2503,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2048c",
            "leftCorner": {
              "x": -9.18,
              "y": 30.853,
              "z": 1.023
            },
            "rightCorner": {
              "x": -9.087,
              "y": 30.848,
              "z": 1.023
            },
            "gtin": "3600541593718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2048d",
            "leftCorner": {
              "x": -9.087,
              "y": 30.848,
              "z": 1.023
            },
            "rightCorner": {
              "x": -8.996,
              "y": 30.843,
              "z": 1.023
            },
            "gtin": "3600541593718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20490",
            "leftCorner": {
              "x": -8.994,
              "y": 30.874,
              "z": 1.023
            },
            "rightCorner": {
              "x": -8.874,
              "y": 30.868,
              "z": 1.023
            },
            "gtin": "3600542306935",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20491",
            "leftCorner": {
              "x": -8.873,
              "y": 30.875,
              "z": 1.023
            },
            "rightCorner": {
              "x": -8.767,
              "y": 30.87,
              "z": 1.023
            },
            "gtin": "3600541250703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20492",
            "leftCorner": {
              "x": -8.767,
              "y": 30.869,
              "z": 1.023
            },
            "rightCorner": {
              "x": -8.657,
              "y": 30.863,
              "z": 1.023
            },
            "gtin": "3600542447546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20493",
            "leftCorner": {
              "x": -8.657,
              "y": 30.867,
              "z": 1.023
            },
            "rightCorner": {
              "x": -8.532,
              "y": 30.86,
              "z": 1.023
            },
            "gtin": "3600541250758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20494",
            "leftCorner": {
              "x": -8.532,
              "y": 30.86,
              "z": 1.023
            },
            "rightCorner": {
              "x": -8.407,
              "y": 30.853,
              "z": 1.023
            },
            "gtin": "3600541250758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20495",
            "leftCorner": {
              "x": -8.407,
              "y": 30.861,
              "z": 1.023
            },
            "rightCorner": {
              "x": -8.321,
              "y": 30.857,
              "z": 1.023
            },
            "gtin": "3600541250604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20496",
            "leftCorner": {
              "x": -8.321,
              "y": 30.859,
              "z": 1.023
            },
            "rightCorner": {
              "x": -8.211,
              "y": 30.854,
              "z": 1.023
            },
            "gtin": "3600541250802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20497",
            "leftCorner": {
              "x": -8.211,
              "y": 30.854,
              "z": 1.023
            },
            "rightCorner": {
              "x": -8.102,
              "y": 30.848,
              "z": 1.023
            },
            "gtin": "3600541250802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20498",
            "leftCorner": {
              "x": -8.103,
              "y": 30.833,
              "z": 1.023
            },
            "rightCorner": {
              "x": -8.005,
              "y": 30.827,
              "z": 1.023
            },
            "gtin": "3600541250857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20499",
            "leftCorner": {
              "x": -8.005,
              "y": 30.82,
              "z": 1.023
            },
            "rightCorner": {
              "x": -7.931,
              "y": 30.816,
              "z": 1.023
            },
            "gtin": "3600523776320",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546648",
        "height": 1.4996,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20550",
            "leftCorner": {
              "x": -9.178,
              "y": 30.87,
              "z": 1.227
            },
            "rightCorner": {
              "x": -9.121,
              "y": 30.868,
              "z": 1.227
            },
            "gtin": "3600541250154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20551",
            "leftCorner": {
              "x": -9.121,
              "y": 30.868,
              "z": 1.227
            },
            "rightCorner": {
              "x": -9.065,
              "y": 30.864,
              "z": 1.227
            },
            "gtin": "3600541250154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20552",
            "leftCorner": {
              "x": -9.065,
              "y": 30.865,
              "z": 1.227
            },
            "rightCorner": {
              "x": -8.958,
              "y": 30.86,
              "z": 1.227
            },
            "gtin": "3600541250253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20553",
            "leftCorner": {
              "x": -8.957,
              "y": 30.881,
              "z": 1.227
            },
            "rightCorner": {
              "x": -8.844,
              "y": 30.875,
              "z": 1.227
            },
            "gtin": "3600541250505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20554",
            "leftCorner": {
              "x": -8.845,
              "y": 30.862,
              "z": 1.227
            },
            "rightCorner": {
              "x": -8.779,
              "y": 30.858,
              "z": 1.227
            },
            "gtin": "3600541250406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20555",
            "leftCorner": {
              "x": -8.779,
              "y": 30.859,
              "z": 1.227
            },
            "rightCorner": {
              "x": -8.63,
              "y": 30.852,
              "z": 1.227
            },
            "gtin": "3600542447461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20556",
            "leftCorner": {
              "x": -8.629,
              "y": 30.866,
              "z": 1.227
            },
            "rightCorner": {
              "x": -8.548,
              "y": 30.862,
              "z": 1.227
            },
            "gtin": "3600541524217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20557",
            "leftCorner": {
              "x": -8.549,
              "y": 30.845,
              "z": 1.227
            },
            "rightCorner": {
              "x": -8.48,
              "y": 30.841,
              "z": 1.227
            },
            "gtin": "3600542524698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20558",
            "leftCorner": {
              "x": -8.48,
              "y": 30.841,
              "z": 1.227
            },
            "rightCorner": {
              "x": -8.41,
              "y": 30.838,
              "z": 1.227
            },
            "gtin": "3600542524698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20559",
            "leftCorner": {
              "x": -8.41,
              "y": 30.84,
              "z": 1.227
            },
            "rightCorner": {
              "x": -8.359,
              "y": 30.837,
              "z": 1.227
            },
            "gtin": "3600542519052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2055a",
            "leftCorner": {
              "x": -8.359,
              "y": 30.837,
              "z": 1.227
            },
            "rightCorner": {
              "x": -8.307,
              "y": 30.834,
              "z": 1.227
            },
            "gtin": "3600542519052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2055b",
            "leftCorner": {
              "x": -8.307,
              "y": 30.842,
              "z": 1.227
            },
            "rightCorner": {
              "x": -8.191,
              "y": 30.837,
              "z": 1.227
            },
            "gtin": "3600542518970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2055c",
            "leftCorner": {
              "x": -8.191,
              "y": 30.837,
              "z": 1.227
            },
            "rightCorner": {
              "x": -8.063,
              "y": 30.83,
              "z": 1.227
            },
            "gtin": "3600542519014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2055d",
            "leftCorner": {
              "x": -8.062,
              "y": 30.835,
              "z": 1.227
            },
            "rightCorner": {
              "x": -7.968,
              "y": 30.831,
              "z": 1.227
            },
            "gtin": "3600542519076",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468c6",
    "rightNeighborShelfId": "468c8"
  },
  {
    "id": "468c8",
    "name": "468c8",
    "x": -7.941,
    "y": 30.673,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.035929,
      "w": 0.99935
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 80
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a54664e",
        "height": 0.16062,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20686",
            "leftCorner": {
              "x": -7.933,
              "y": 30.717,
              "z": 0.131
            },
            "rightCorner": {
              "x": -7.862,
              "y": 30.711,
              "z": 0.131
            },
            "gtin": "4015100815887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20687",
            "leftCorner": {
              "x": -7.862,
              "y": 30.713,
              "z": 0.131
            },
            "rightCorner": {
              "x": -7.8,
              "y": 30.708,
              "z": 0.131
            },
            "gtin": "4015100816327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20688",
            "leftCorner": {
              "x": -7.8,
              "y": 30.708,
              "z": 0.131
            },
            "rightCorner": {
              "x": -7.738,
              "y": 30.704,
              "z": 0.131
            },
            "gtin": "4015100816327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20689",
            "leftCorner": {
              "x": -7.738,
              "y": 30.708,
              "z": 0.131
            },
            "rightCorner": {
              "x": -7.63,
              "y": 30.701,
              "z": 0.131
            },
            "gtin": "4015100816204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2068a",
            "leftCorner": {
              "x": -7.63,
              "y": 30.698,
              "z": 0.131
            },
            "rightCorner": {
              "x": -7.508,
              "y": 30.689,
              "z": 0.131
            },
            "gtin": "4015100816167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2068b",
            "leftCorner": {
              "x": -7.509,
              "y": 30.68,
              "z": 0.131
            },
            "rightCorner": {
              "x": -7.384,
              "y": 30.671,
              "z": 0.131
            },
            "gtin": "4015100816266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2068c",
            "leftCorner": {
              "x": -7.382,
              "y": 30.688,
              "z": 0.131
            },
            "rightCorner": {
              "x": -7.277,
              "y": 30.68,
              "z": 0.131
            },
            "gtin": "4015100816280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2068d",
            "leftCorner": {
              "x": -7.277,
              "y": 30.678,
              "z": 0.131
            },
            "rightCorner": {
              "x": -7.164,
              "y": 30.67,
              "z": 0.131
            },
            "gtin": "4015100816068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2068e",
            "leftCorner": {
              "x": -7.165,
              "y": 30.659,
              "z": 0.131
            },
            "rightCorner": {
              "x": -7.052,
              "y": 30.651,
              "z": 0.131
            },
            "gtin": "4015100816129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2068f",
            "leftCorner": {
              "x": -7.052,
              "y": 30.646,
              "z": 0.131
            },
            "rightCorner": {
              "x": -6.914,
              "y": 30.636,
              "z": 0.131
            },
            "gtin": "4015100816082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20690",
            "leftCorner": {
              "x": -6.913,
              "y": 30.649,
              "z": 0.131
            },
            "rightCorner": {
              "x": -6.809,
              "y": 30.641,
              "z": 0.131
            },
            "gtin": "4015100815849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20691",
            "leftCorner": {
              "x": -6.809,
              "y": 30.638,
              "z": 0.131
            },
            "rightCorner": {
              "x": -6.59,
              "y": 30.622,
              "z": 0.131
            },
            "gtin": "4015100816181",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54664b",
        "height": 0.48803,
        "facings": [
          {
            "id": "68300c895ed67a01d9a205b9",
            "leftCorner": {
              "x": -7.927,
              "y": 30.814,
              "z": 0.399
            },
            "rightCorner": {
              "x": -7.851,
              "y": 30.809,
              "z": 0.399
            },
            "gtin": "3600520982472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205ba",
            "leftCorner": {
              "x": -7.852,
              "y": 30.803,
              "z": 0.399
            },
            "rightCorner": {
              "x": -7.752,
              "y": 30.796,
              "z": 0.399
            },
            "gtin": "3600520982496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205bb",
            "leftCorner": {
              "x": -7.752,
              "y": 30.796,
              "z": 0.399
            },
            "rightCorner": {
              "x": -7.652,
              "y": 30.788,
              "z": 0.399
            },
            "gtin": "3600520982496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205bc",
            "leftCorner": {
              "x": -7.652,
              "y": 30.788,
              "z": 0.399
            },
            "rightCorner": {
              "x": -7.597,
              "y": 30.785,
              "z": 0.399
            },
            "gtin": "3600521188217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205bd",
            "leftCorner": {
              "x": -7.597,
              "y": 30.785,
              "z": 0.399
            },
            "rightCorner": {
              "x": -7.543,
              "y": 30.781,
              "z": 0.399
            },
            "gtin": "3600521188217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205be",
            "leftCorner": {
              "x": -7.542,
              "y": 30.783,
              "z": 0.399
            },
            "rightCorner": {
              "x": -7.475,
              "y": 30.778,
              "z": 0.399
            },
            "gtin": "3600520982502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205bf",
            "leftCorner": {
              "x": -7.475,
              "y": 30.775,
              "z": 0.399
            },
            "rightCorner": {
              "x": -7.378,
              "y": 30.768,
              "z": 0.399
            },
            "gtin": "3600521365632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205c0",
            "leftCorner": {
              "x": -7.378,
              "y": 30.768,
              "z": 0.399
            },
            "rightCorner": {
              "x": -7.282,
              "y": 30.761,
              "z": 0.399
            },
            "gtin": "3600521365632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205c1",
            "leftCorner": {
              "x": -7.281,
              "y": 30.763,
              "z": 0.399
            },
            "rightCorner": {
              "x": -7.129,
              "y": 30.752,
              "z": 0.399
            },
            "gtin": "3600520982519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205c2",
            "leftCorner": {
              "x": -7.129,
              "y": 30.757,
              "z": 0.399
            },
            "rightCorner": {
              "x": -7.032,
              "y": 30.751,
              "z": 0.399
            },
            "gtin": "3600520982557",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205c3",
            "leftCorner": {
              "x": -7.032,
              "y": 30.751,
              "z": 0.399
            },
            "rightCorner": {
              "x": -6.936,
              "y": 30.744,
              "z": 0.399
            },
            "gtin": "3600520982557",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205c4",
            "leftCorner": {
              "x": -6.936,
              "y": 30.744,
              "z": 0.399
            },
            "rightCorner": {
              "x": -6.802,
              "y": 30.734,
              "z": 0.399
            },
            "gtin": "3600522822332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205c5",
            "leftCorner": {
              "x": -6.802,
              "y": 30.734,
              "z": 0.399
            },
            "rightCorner": {
              "x": -6.668,
              "y": 30.724,
              "z": 0.399
            },
            "gtin": "3600522822332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205c6",
            "leftCorner": {
              "x": -6.668,
              "y": 30.724,
              "z": 0.399
            },
            "rightCorner": {
              "x": -6.535,
              "y": 30.715,
              "z": 0.399
            },
            "gtin": "3600522822332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205c7",
            "leftCorner": {
              "x": -6.535,
              "y": 30.715,
              "z": 0.399
            },
            "rightCorner": {
              "x": -6.401,
              "y": 30.705,
              "z": 0.399
            },
            "gtin": "3600522822332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205c8",
            "leftCorner": {
              "x": -6.401,
              "y": 30.705,
              "z": 0.399
            },
            "rightCorner": {
              "x": -6.268,
              "y": 30.695,
              "z": 0.399
            },
            "gtin": "3600522822332",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54664c",
        "height": 0.74242,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2050c",
            "leftCorner": {
              "x": -7.837,
              "y": 30.812,
              "z": 0.607
            },
            "rightCorner": {
              "x": -7.744,
              "y": 30.805,
              "z": 0.607
            },
            "gtin": "4015100334128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2050d",
            "leftCorner": {
              "x": -7.744,
              "y": 30.805,
              "z": 0.607
            },
            "rightCorner": {
              "x": -7.65,
              "y": 30.798,
              "z": 0.607
            },
            "gtin": "4015100334128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2050e",
            "leftCorner": {
              "x": -7.65,
              "y": 30.798,
              "z": 0.607
            },
            "rightCorner": {
              "x": -7.556,
              "y": 30.791,
              "z": 0.607
            },
            "gtin": "4015100334128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2050f",
            "leftCorner": {
              "x": -7.556,
              "y": 30.785,
              "z": 0.607
            },
            "rightCorner": {
              "x": -7.462,
              "y": 30.778,
              "z": 0.607
            },
            "gtin": "4015100334029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20510",
            "leftCorner": {
              "x": -7.462,
              "y": 30.778,
              "z": 0.607
            },
            "rightCorner": {
              "x": -7.368,
              "y": 30.771,
              "z": 0.607
            },
            "gtin": "4015100334029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20511",
            "leftCorner": {
              "x": -7.367,
              "y": 30.784,
              "z": 0.607
            },
            "rightCorner": {
              "x": -7.267,
              "y": 30.776,
              "z": 0.607
            },
            "gtin": "4015100334005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20512",
            "leftCorner": {
              "x": -7.267,
              "y": 30.776,
              "z": 0.607
            },
            "rightCorner": {
              "x": -7.167,
              "y": 30.769,
              "z": 0.607
            },
            "gtin": "4015100334005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20513",
            "leftCorner": {
              "x": -7.167,
              "y": 30.769,
              "z": 0.607
            },
            "rightCorner": {
              "x": -7.067,
              "y": 30.762,
              "z": 0.607
            },
            "gtin": "4015100334005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20514",
            "leftCorner": {
              "x": -7.067,
              "y": 30.762,
              "z": 0.607
            },
            "rightCorner": {
              "x": -6.967,
              "y": 30.755,
              "z": 0.607
            },
            "gtin": "4015100334005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20515",
            "leftCorner": {
              "x": -6.967,
              "y": 30.754,
              "z": 0.607
            },
            "rightCorner": {
              "x": -6.845,
              "y": 30.745,
              "z": 0.607
            },
            "gtin": "4015100334067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20516",
            "leftCorner": {
              "x": -6.845,
              "y": 30.745,
              "z": 0.607
            },
            "rightCorner": {
              "x": -6.722,
              "y": 30.736,
              "z": 0.607
            },
            "gtin": "4015100334067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20517",
            "leftCorner": {
              "x": -6.723,
              "y": 30.716,
              "z": 0.607
            },
            "rightCorner": {
              "x": -6.649,
              "y": 30.711,
              "z": 0.607
            },
            "gtin": "4015100814217",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54664f",
        "height": 0.9886,
        "facings": [
          {
            "id": "68300c895ed67a01d9a204d1",
            "leftCorner": {
              "x": -7.866,
              "y": 30.791,
              "z": 0.809
            },
            "rightCorner": {
              "x": -7.788,
              "y": 30.786,
              "z": 0.809
            },
            "gtin": "4015100732771",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204d2",
            "leftCorner": {
              "x": -7.786,
              "y": 30.801,
              "z": 0.809
            },
            "rightCorner": {
              "x": -7.708,
              "y": 30.795,
              "z": 0.809
            },
            "gtin": "4015100817508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204d3",
            "leftCorner": {
              "x": -7.708,
              "y": 30.795,
              "z": 0.809
            },
            "rightCorner": {
              "x": -7.629,
              "y": 30.79,
              "z": 0.809
            },
            "gtin": "4015100817508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204d4",
            "leftCorner": {
              "x": -7.629,
              "y": 30.784,
              "z": 0.809
            },
            "rightCorner": {
              "x": -7.546,
              "y": 30.778,
              "z": 0.809
            },
            "gtin": "4015100817782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204d5",
            "leftCorner": {
              "x": -7.546,
              "y": 30.779,
              "z": 0.809
            },
            "rightCorner": {
              "x": -7.478,
              "y": 30.775,
              "z": 0.809
            },
            "gtin": "4015100817805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204d6",
            "leftCorner": {
              "x": -7.477,
              "y": 30.787,
              "z": 0.809
            },
            "rightCorner": {
              "x": -7.331,
              "y": 30.776,
              "z": 0.809
            },
            "gtin": "4015100817683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204d7",
            "leftCorner": {
              "x": -7.33,
              "y": 30.782,
              "z": 0.809
            },
            "rightCorner": {
              "x": -7.232,
              "y": 30.776,
              "z": 0.809
            },
            "gtin": "4015100817485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204d8",
            "leftCorner": {
              "x": -7.233,
              "y": 30.764,
              "z": 0.809
            },
            "rightCorner": {
              "x": -7.164,
              "y": 30.759,
              "z": 0.809
            },
            "gtin": "4015100861006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204d9",
            "leftCorner": {
              "x": -7.164,
              "y": 30.759,
              "z": 0.809
            },
            "rightCorner": {
              "x": -7.095,
              "y": 30.754,
              "z": 0.809
            },
            "gtin": "4015100861006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204da",
            "leftCorner": {
              "x": -7.095,
              "y": 30.753,
              "z": 0.809
            },
            "rightCorner": {
              "x": -7.021,
              "y": 30.747,
              "z": 0.809
            },
            "gtin": "4015100817522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204db",
            "leftCorner": {
              "x": -7.021,
              "y": 30.747,
              "z": 0.809
            },
            "rightCorner": {
              "x": -6.946,
              "y": 30.742,
              "z": 0.809
            },
            "gtin": "4015100817522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204dc",
            "leftCorner": {
              "x": -6.947,
              "y": 30.735,
              "z": 0.809
            },
            "rightCorner": {
              "x": -6.84,
              "y": 30.728,
              "z": 0.809
            },
            "gtin": "4015100817744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204dd",
            "leftCorner": {
              "x": -6.84,
              "y": 30.729,
              "z": 0.809
            },
            "rightCorner": {
              "x": -6.766,
              "y": 30.724,
              "z": 0.809
            },
            "gtin": "4015100817423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204de",
            "leftCorner": {
              "x": -6.766,
              "y": 30.724,
              "z": 0.809
            },
            "rightCorner": {
              "x": -6.692,
              "y": 30.719,
              "z": 0.809
            },
            "gtin": "4015100817423",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54664d",
        "height": 1.2426,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2049a",
            "leftCorner": {
              "x": -7.932,
              "y": 30.812,
              "z": 1.017
            },
            "rightCorner": {
              "x": -7.831,
              "y": 30.804,
              "z": 1.017
            },
            "gtin": "3600524015107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2049b",
            "leftCorner": {
              "x": -7.831,
              "y": 30.808,
              "z": 1.017
            },
            "rightCorner": {
              "x": -7.738,
              "y": 30.802,
              "z": 1.017
            },
            "gtin": "4015100311150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2049c",
            "leftCorner": {
              "x": -7.738,
              "y": 30.807,
              "z": 1.017
            },
            "rightCorner": {
              "x": -7.631,
              "y": 30.799,
              "z": 1.017
            },
            "gtin": "4015100311037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2049d",
            "leftCorner": {
              "x": -7.632,
              "y": 30.787,
              "z": 1.017
            },
            "rightCorner": {
              "x": -7.536,
              "y": 30.78,
              "z": 1.017
            },
            "gtin": "4015100311174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2049e",
            "leftCorner": {
              "x": -7.536,
              "y": 30.78,
              "z": 1.017
            },
            "rightCorner": {
              "x": -7.44,
              "y": 30.774,
              "z": 1.017
            },
            "gtin": "4015100311174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2049f",
            "leftCorner": {
              "x": -7.439,
              "y": 30.78,
              "z": 1.017
            },
            "rightCorner": {
              "x": -7.34,
              "y": 30.772,
              "z": 1.017
            },
            "gtin": "4015100310917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204a0",
            "leftCorner": {
              "x": -7.32,
              "y": 30.782,
              "z": 1.017
            },
            "rightCorner": {
              "x": -7.254,
              "y": 30.777,
              "z": 1.017
            },
            "gtin": "4015100310832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204a1",
            "leftCorner": {
              "x": -7.254,
              "y": 30.766,
              "z": 1.017
            },
            "rightCorner": {
              "x": -7.125,
              "y": 30.757,
              "z": 1.017
            },
            "gtin": "4015100310931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204a2",
            "leftCorner": {
              "x": -7.124,
              "y": 30.766,
              "z": 1.017
            },
            "rightCorner": {
              "x": -7.007,
              "y": 30.757,
              "z": 1.017
            },
            "gtin": "4015100339895",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204a3",
            "leftCorner": {
              "x": -7.007,
              "y": 30.757,
              "z": 1.017
            },
            "rightCorner": {
              "x": -6.891,
              "y": 30.749,
              "z": 1.017
            },
            "gtin": "4015100339895",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204a4",
            "leftCorner": {
              "x": -6.891,
              "y": 30.742,
              "z": 1.017
            },
            "rightCorner": {
              "x": -6.794,
              "y": 30.734,
              "z": 1.017
            },
            "gtin": "4015100817768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204a5",
            "leftCorner": {
              "x": -6.794,
              "y": 30.734,
              "z": 1.017
            },
            "rightCorner": {
              "x": -6.697,
              "y": 30.728,
              "z": 1.017
            },
            "gtin": "4015100817768",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54664a",
        "height": 1.4948,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2055e",
            "leftCorner": {
              "x": -7.971,
              "y": 30.795,
              "z": 1.223
            },
            "rightCorner": {
              "x": -7.87,
              "y": 30.788,
              "z": 1.223
            },
            "gtin": "3600542518963",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2055f",
            "leftCorner": {
              "x": -7.869,
              "y": 30.798,
              "z": 1.223
            },
            "rightCorner": {
              "x": -7.776,
              "y": 30.791,
              "z": 1.223
            },
            "gtin": "3600523776337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20560",
            "leftCorner": {
              "x": -7.775,
              "y": 30.801,
              "z": 1.223
            },
            "rightCorner": {
              "x": -7.651,
              "y": 30.792,
              "z": 1.223
            },
            "gtin": "3600523789849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20561",
            "leftCorner": {
              "x": -7.651,
              "y": 30.796,
              "z": 1.223
            },
            "rightCorner": {
              "x": -7.56,
              "y": 30.789,
              "z": 1.223
            },
            "gtin": "3600523789856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20562",
            "leftCorner": {
              "x": -7.56,
              "y": 30.789,
              "z": 1.223
            },
            "rightCorner": {
              "x": -7.451,
              "y": 30.781,
              "z": 1.223
            },
            "gtin": "3600523776429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20563",
            "leftCorner": {
              "x": -7.451,
              "y": 30.785,
              "z": 1.223
            },
            "rightCorner": {
              "x": -7.334,
              "y": 30.778,
              "z": 1.223
            },
            "gtin": "3600523776290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20564",
            "leftCorner": {
              "x": -7.334,
              "y": 30.777,
              "z": 1.223
            },
            "rightCorner": {
              "x": -7.242,
              "y": 30.771,
              "z": 1.223
            },
            "gtin": "3600524080136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20565",
            "leftCorner": {
              "x": -7.242,
              "y": 30.773,
              "z": 1.223
            },
            "rightCorner": {
              "x": -7.159,
              "y": 30.766,
              "z": 1.223
            },
            "gtin": "3600523776306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20566",
            "leftCorner": {
              "x": -7.159,
              "y": 30.762,
              "z": 1.223
            },
            "rightCorner": {
              "x": -7.03,
              "y": 30.753,
              "z": 1.223
            },
            "gtin": "3600523776474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20567",
            "leftCorner": {
              "x": -7.03,
              "y": 30.747,
              "z": 1.223
            },
            "rightCorner": {
              "x": -6.974,
              "y": 30.743,
              "z": 1.223
            },
            "gtin": "3600523776382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20568",
            "leftCorner": {
              "x": -6.974,
              "y": 30.743,
              "z": 1.223
            },
            "rightCorner": {
              "x": -6.917,
              "y": 30.739,
              "z": 1.223
            },
            "gtin": "3600523776382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20569",
            "leftCorner": {
              "x": -6.917,
              "y": 30.743,
              "z": 1.223
            },
            "rightCorner": {
              "x": -6.841,
              "y": 30.739,
              "z": 1.223
            },
            "gtin": "3600524015060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2056a",
            "leftCorner": {
              "x": -6.841,
              "y": 30.741,
              "z": 1.223
            },
            "rightCorner": {
              "x": -6.735,
              "y": 30.733,
              "z": 1.223
            },
            "gtin": "3600523776368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2056b",
            "leftCorner": {
              "x": -6.735,
              "y": 30.726,
              "z": 1.223
            },
            "rightCorner": {
              "x": -6.677,
              "y": 30.722,
              "z": 1.223
            },
            "gtin": "3600523776405",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468c7",
    "rightNeighborShelfId": "a6d60"
  },
  {
    "id": "509ec",
    "name": "509ec",
    "x": 10.682,
    "y": 19.357,
    "width": 0.67,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03476,
      "w": 0.9994
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 5
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546780",
        "height": 0.1634,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a546782",
        "height": 0.84046,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a546781",
        "height": 1.2929,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a2105e",
            "leftCorner": {
              "x": 10.71,
              "y": 19.475,
              "z": 1.058
            },
            "rightCorner": {
              "x": 10.926,
              "y": 19.459,
              "z": 1.058
            },
            "gtin": "4003586102072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2105f",
            "leftCorner": {
              "x": 10.926,
              "y": 19.459,
              "z": 1.058
            },
            "rightCorner": {
              "x": 11.142,
              "y": 19.444,
              "z": 1.058
            },
            "gtin": "4003586102072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21060",
            "leftCorner": {
              "x": 11.142,
              "y": 19.444,
              "z": 1.058
            },
            "rightCorner": {
              "x": 11.359,
              "y": 19.429,
              "z": 1.058
            },
            "gtin": "4003586102072",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546783",
        "height": 1.6506,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e067",
            "leftCorner": {
              "x": 10.687,
              "y": 19.436,
              "z": 1.351
            },
            "rightCorner": {
              "x": 10.928,
              "y": 19.419,
              "z": 1.351
            },
            "gtin": "4003586107862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e068",
            "leftCorner": {
              "x": 10.928,
              "y": 19.419,
              "z": 1.351
            },
            "rightCorner": {
              "x": 11.17,
              "y": 19.402,
              "z": 1.351
            },
            "gtin": "4003586107862",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a81",
    "rightNeighborShelfId": "34a82"
  },
  {
    "id": "50a07",
    "name": "50a07",
    "x": 18.865,
    "y": 20.278,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99946,
      "w": 0.032824
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 29
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5467b1",
        "height": 0.13268,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1deab",
            "leftCorner": {
              "x": 18.832,
              "y": 20.218,
              "z": 0.109
            },
            "rightCorner": {
              "x": 18.238,
              "y": 20.257,
              "z": 0.109
            },
            "gtin": "4063367149078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1deac",
            "leftCorner": {
              "x": 18.238,
              "y": 20.257,
              "z": 0.109
            },
            "rightCorner": {
              "x": 17.645,
              "y": 20.296,
              "z": 0.109
            },
            "gtin": "4063367149078",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467ae",
        "height": 0.59158,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1ddff",
            "leftCorner": {
              "x": 18.799,
              "y": 20.224,
              "z": 0.484
            },
            "rightCorner": {
              "x": 18.655,
              "y": 20.233,
              "z": 0.484
            },
            "gtin": "4017100706004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de00",
            "leftCorner": {
              "x": 18.655,
              "y": 20.233,
              "z": 0.484
            },
            "rightCorner": {
              "x": 18.51,
              "y": 20.243,
              "z": 0.484
            },
            "gtin": "4017100706004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de01",
            "leftCorner": {
              "x": 18.51,
              "y": 20.243,
              "z": 0.484
            },
            "rightCorner": {
              "x": 18.366,
              "y": 20.252,
              "z": 0.484
            },
            "gtin": "4017100706004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de02",
            "leftCorner": {
              "x": 18.366,
              "y": 20.252,
              "z": 0.484
            },
            "rightCorner": {
              "x": 18.222,
              "y": 20.262,
              "z": 0.484
            },
            "gtin": "4017100706004",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467af",
        "height": 0.94542,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1ddc4",
            "leftCorner": {
              "x": 18.839,
              "y": 20.245,
              "z": 0.774
            },
            "rightCorner": {
              "x": 18.338,
              "y": 20.279,
              "z": 0.774
            },
            "gtin": "4018077010316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddc5",
            "leftCorner": {
              "x": 18.337,
              "y": 20.258,
              "z": 0.774
            },
            "rightCorner": {
              "x": 18.199,
              "y": 20.267,
              "z": 0.774
            },
            "gtin": "5907029010407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddc6",
            "leftCorner": {
              "x": 18.199,
              "y": 20.267,
              "z": 0.774
            },
            "rightCorner": {
              "x": 18.059,
              "y": 20.277,
              "z": 0.774
            },
            "gtin": "5907029010407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddc7",
            "leftCorner": {
              "x": 18.059,
              "y": 20.277,
              "z": 0.774
            },
            "rightCorner": {
              "x": 17.92,
              "y": 20.285,
              "z": 0.774
            },
            "gtin": "5907029010407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddc8",
            "leftCorner": {
              "x": 17.92,
              "y": 20.284,
              "z": 0.774
            },
            "rightCorner": {
              "x": 17.755,
              "y": 20.295,
              "z": 0.774
            },
            "gtin": "4003586102959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddc9",
            "leftCorner": {
              "x": 17.754,
              "y": 20.287,
              "z": 0.774
            },
            "rightCorner": {
              "x": 17.612,
              "y": 20.297,
              "z": 0.774
            },
            "gtin": "4018077683015",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467b0",
        "height": 1.3974,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e794",
            "leftCorner": {
              "x": 18.81,
              "y": 20.232,
              "z": 1.143
            },
            "rightCorner": {
              "x": 18.545,
              "y": 20.249,
              "z": 1.143
            },
            "gtin": "4000381004334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e795",
            "leftCorner": {
              "x": 18.545,
              "y": 20.25,
              "z": 1.143
            },
            "rightCorner": {
              "x": 18.408,
              "y": 20.258,
              "z": 1.143
            },
            "gtin": "4000381030258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e796",
            "leftCorner": {
              "x": 18.408,
              "y": 20.258,
              "z": 1.143
            },
            "rightCorner": {
              "x": 18.271,
              "y": 20.268,
              "z": 1.143
            },
            "gtin": "4000381030258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e797",
            "leftCorner": {
              "x": 18.271,
              "y": 20.266,
              "z": 1.143
            },
            "rightCorner": {
              "x": 18.11,
              "y": 20.276,
              "z": 1.143
            },
            "gtin": "4000381009070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e798",
            "leftCorner": {
              "x": 18.11,
              "y": 20.273,
              "z": 1.143
            },
            "rightCorner": {
              "x": 17.985,
              "y": 20.281,
              "z": 1.143
            },
            "gtin": "4000381002019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e799",
            "leftCorner": {
              "x": 17.985,
              "y": 20.281,
              "z": 1.143
            },
            "rightCorner": {
              "x": 17.861,
              "y": 20.29,
              "z": 1.143
            },
            "gtin": "4000381002019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e79a",
            "leftCorner": {
              "x": 17.861,
              "y": 20.283,
              "z": 1.143
            },
            "rightCorner": {
              "x": 17.668,
              "y": 20.296,
              "z": 1.143
            },
            "gtin": "4000381009018",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467ad",
        "height": 1.7406,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1de4f",
            "leftCorner": {
              "x": 18.838,
              "y": 20.24,
              "z": 1.424
            },
            "rightCorner": {
              "x": 18.764,
              "y": 20.245,
              "z": 1.424
            },
            "gtin": "4015537002454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de50",
            "leftCorner": {
              "x": 18.764,
              "y": 20.245,
              "z": 1.424
            },
            "rightCorner": {
              "x": 18.691,
              "y": 20.25,
              "z": 1.424
            },
            "gtin": "4015537002454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de51",
            "leftCorner": {
              "x": 18.69,
              "y": 20.246,
              "z": 1.424
            },
            "rightCorner": {
              "x": 18.577,
              "y": 20.253,
              "z": 1.424
            },
            "gtin": "4015537002836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de52",
            "leftCorner": {
              "x": 18.576,
              "y": 20.252,
              "z": 1.424
            },
            "rightCorner": {
              "x": 18.435,
              "y": 20.262,
              "z": 1.424
            },
            "gtin": "4000381010502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de53",
            "leftCorner": {
              "x": 18.435,
              "y": 20.262,
              "z": 1.424
            },
            "rightCorner": {
              "x": 18.294,
              "y": 20.271,
              "z": 1.424
            },
            "gtin": "4000381010502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de54",
            "leftCorner": {
              "x": 18.294,
              "y": 20.267,
              "z": 1.424
            },
            "rightCorner": {
              "x": 18.161,
              "y": 20.275,
              "z": 1.424
            },
            "gtin": "4000381003030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de55",
            "leftCorner": {
              "x": 18.161,
              "y": 20.275,
              "z": 1.424
            },
            "rightCorner": {
              "x": 18.028,
              "y": 20.284,
              "z": 1.424
            },
            "gtin": "4000381003030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de56",
            "leftCorner": {
              "x": 18.028,
              "y": 20.284,
              "z": 1.424
            },
            "rightCorner": {
              "x": 17.897,
              "y": 20.292,
              "z": 1.424
            },
            "gtin": "4000381003030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de57",
            "leftCorner": {
              "x": 17.897,
              "y": 20.301,
              "z": 1.424
            },
            "rightCorner": {
              "x": 17.761,
              "y": 20.31,
              "z": 1.424
            },
            "gtin": "4018077800009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de58",
            "leftCorner": {
              "x": 17.761,
              "y": 20.31,
              "z": 1.424
            },
            "rightCorner": {
              "x": 17.627,
              "y": 20.319,
              "z": 1.424
            },
            "gtin": "4018077800009",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "8d30f",
    "rightNeighborShelfId": "50a08"
  },
  {
    "id": "50a08",
    "name": "50a08",
    "x": 17.668,
    "y": 20.357,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99946,
      "w": 0.032824
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 32
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463df",
        "height": 0.1375,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dead",
            "leftCorner": {
              "x": 17.647,
              "y": 20.318,
              "z": 0.112
            },
            "rightCorner": {
              "x": 17.514,
              "y": 20.327,
              "z": 0.112
            },
            "gtin": "4063367433290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1deae",
            "leftCorner": {
              "x": 17.514,
              "y": 20.327,
              "z": 0.112
            },
            "rightCorner": {
              "x": 17.382,
              "y": 20.335,
              "z": 0.112
            },
            "gtin": "4063367433290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1deaf",
            "leftCorner": {
              "x": 17.382,
              "y": 20.335,
              "z": 0.112
            },
            "rightCorner": {
              "x": 17.251,
              "y": 20.344,
              "z": 0.112
            },
            "gtin": "4063367433290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1deb0",
            "leftCorner": {
              "x": 17.249,
              "y": 20.332,
              "z": 0.112
            },
            "rightCorner": {
              "x": 16.948,
              "y": 20.352,
              "z": 0.112
            },
            "gtin": "8594042912459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1deb1",
            "leftCorner": {
              "x": 16.948,
              "y": 20.352,
              "z": 0.112
            },
            "rightCorner": {
              "x": 16.645,
              "y": 20.371,
              "z": 0.112
            },
            "gtin": "8594042912459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1deb2",
            "leftCorner": {
              "x": 16.645,
              "y": 20.37,
              "z": 0.112
            },
            "rightCorner": {
              "x": 16.43,
              "y": 20.384,
              "z": 0.112
            },
            "gtin": "4063367149122",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463e0",
        "height": 0.58937,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1de03",
            "leftCorner": {
              "x": 16.909,
              "y": 20.351,
              "z": 0.482
            },
            "rightCorner": {
              "x": 16.645,
              "y": 20.368,
              "z": 0.482
            },
            "gtin": "4003586102713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de04",
            "leftCorner": {
              "x": 16.645,
              "y": 20.368,
              "z": 0.482
            },
            "rightCorner": {
              "x": 16.382,
              "y": 20.385,
              "z": 0.482
            },
            "gtin": "4003586102713",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463de",
        "height": 0.9472,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1ddca",
            "leftCorner": {
              "x": 17.614,
              "y": 20.314,
              "z": 0.775
            },
            "rightCorner": {
              "x": 17.371,
              "y": 20.33,
              "z": 0.775
            },
            "gtin": "4017100677007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddcb",
            "leftCorner": {
              "x": 17.371,
              "y": 20.322,
              "z": 0.775
            },
            "rightCorner": {
              "x": 17.059,
              "y": 20.343,
              "z": 0.775
            },
            "gtin": "4017100737909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddcc",
            "leftCorner": {
              "x": 17.059,
              "y": 20.343,
              "z": 0.775
            },
            "rightCorner": {
              "x": 16.685,
              "y": 20.367,
              "z": 0.775
            },
            "gtin": "4018077895074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddcd",
            "leftCorner": {
              "x": 16.685,
              "y": 20.36,
              "z": 0.775
            },
            "rightCorner": {
              "x": 16.408,
              "y": 20.378,
              "z": 0.775
            },
            "gtin": "4003586105196",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463dc",
        "height": 1.3916,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e79b",
            "leftCorner": {
              "x": 17.67,
              "y": 20.32,
              "z": 1.139
            },
            "rightCorner": {
              "x": 17.489,
              "y": 20.332,
              "z": 1.139
            },
            "gtin": "4018356009222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e79c",
            "leftCorner": {
              "x": 17.489,
              "y": 20.325,
              "z": 1.139
            },
            "rightCorner": {
              "x": 17.39,
              "y": 20.332,
              "z": 1.139
            },
            "gtin": "4018356009215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e79d",
            "leftCorner": {
              "x": 17.39,
              "y": 20.332,
              "z": 1.139
            },
            "rightCorner": {
              "x": 17.291,
              "y": 20.338,
              "z": 1.139
            },
            "gtin": "4018356009215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e79e",
            "leftCorner": {
              "x": 17.291,
              "y": 20.334,
              "z": 1.139
            },
            "rightCorner": {
              "x": 17.205,
              "y": 20.34,
              "z": 1.139
            },
            "gtin": "4018077779930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e79f",
            "leftCorner": {
              "x": 17.205,
              "y": 20.34,
              "z": 1.139
            },
            "rightCorner": {
              "x": 17.121,
              "y": 20.346,
              "z": 1.139
            },
            "gtin": "4018077779930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7a0",
            "leftCorner": {
              "x": 17.121,
              "y": 20.346,
              "z": 1.139
            },
            "rightCorner": {
              "x": 17.036,
              "y": 20.351,
              "z": 1.139
            },
            "gtin": "4018077779930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7a1",
            "leftCorner": {
              "x": 17.035,
              "y": 20.345,
              "z": 1.139
            },
            "rightCorner": {
              "x": 16.889,
              "y": 20.355,
              "z": 1.139
            },
            "gtin": "4018077895036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7a2",
            "leftCorner": {
              "x": 16.889,
              "y": 20.355,
              "z": 1.139
            },
            "rightCorner": {
              "x": 16.741,
              "y": 20.365,
              "z": 1.139
            },
            "gtin": "4018077895036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e78f",
            "leftCorner": {
              "x": 16.741,
              "y": 20.366,
              "z": 1.139
            },
            "rightCorner": {
              "x": 16.604,
              "y": 20.375,
              "z": 1.139
            },
            "gtin": "4018077690105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e790",
            "leftCorner": {
              "x": 16.604,
              "y": 20.375,
              "z": 1.139
            },
            "rightCorner": {
              "x": 16.467,
              "y": 20.385,
              "z": 1.139
            },
            "gtin": "4018077690105",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463dd",
        "height": 1.7429,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1de59",
            "leftCorner": {
              "x": 17.627,
              "y": 20.319,
              "z": 1.426
            },
            "rightCorner": {
              "x": 17.488,
              "y": 20.329,
              "z": 1.426
            },
            "gtin": "4018077888038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de5a",
            "leftCorner": {
              "x": 17.488,
              "y": 20.329,
              "z": 1.426
            },
            "rightCorner": {
              "x": 17.35,
              "y": 20.337,
              "z": 1.426
            },
            "gtin": "4018077888038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de5b",
            "leftCorner": {
              "x": 17.351,
              "y": 20.34,
              "z": 1.426
            },
            "rightCorner": {
              "x": 17.181,
              "y": 20.351,
              "z": 1.426
            },
            "gtin": "4018077690167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de5c",
            "leftCorner": {
              "x": 17.181,
              "y": 20.351,
              "z": 1.426
            },
            "rightCorner": {
              "x": 17.011,
              "y": 20.362,
              "z": 1.426
            },
            "gtin": "4018077690167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de5d",
            "leftCorner": {
              "x": 17.011,
              "y": 20.354,
              "z": 1.426
            },
            "rightCorner": {
              "x": 16.911,
              "y": 20.361,
              "z": 1.426
            },
            "gtin": "4018077895050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de5e",
            "leftCorner": {
              "x": 16.911,
              "y": 20.361,
              "z": 1.426
            },
            "rightCorner": {
              "x": 16.811,
              "y": 20.367,
              "z": 1.426
            },
            "gtin": "4018077895050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de5f",
            "leftCorner": {
              "x": 16.811,
              "y": 20.367,
              "z": 1.426
            },
            "rightCorner": {
              "x": 16.712,
              "y": 20.374,
              "z": 1.426
            },
            "gtin": "4018077895050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de60",
            "leftCorner": {
              "x": 16.711,
              "y": 20.366,
              "z": 1.426
            },
            "rightCorner": {
              "x": 16.608,
              "y": 20.372,
              "z": 1.426
            },
            "gtin": "7610058008007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de61",
            "leftCorner": {
              "x": 16.609,
              "y": 20.387,
              "z": 1.426
            },
            "rightCorner": {
              "x": 16.527,
              "y": 20.393,
              "z": 1.426
            },
            "gtin": "7610058008656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de62",
            "leftCorner": {
              "x": 16.527,
              "y": 20.393,
              "z": 1.426
            },
            "rightCorner": {
              "x": 16.445,
              "y": 20.398,
              "z": 1.426
            },
            "gtin": "7610058008656",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a07",
    "rightNeighborShelfId": "50a09"
  },
  {
    "id": "50a09",
    "name": "50a09",
    "x": 16.47,
    "y": 20.435,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99946,
      "w": 0.032824
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 26
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5467b6",
        "height": 0.13543,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1deb3",
            "leftCorner": {
              "x": 16.429,
              "y": 20.378,
              "z": 0.111
            },
            "rightCorner": {
              "x": 15.819,
              "y": 20.419,
              "z": 0.111
            },
            "gtin": "4001242105955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1deb4",
            "leftCorner": {
              "x": 15.82,
              "y": 20.425,
              "z": 0.111
            },
            "rightCorner": {
              "x": 15.514,
              "y": 20.445,
              "z": 0.111
            },
            "gtin": "4001242105955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1deb5",
            "leftCorner": {
              "x": 15.514,
              "y": 20.445,
              "z": 0.111
            },
            "rightCorner": {
              "x": 15.208,
              "y": 20.465,
              "z": 0.111
            },
            "gtin": "4001242105955",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467b3",
        "height": 0.59749,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1de05",
            "leftCorner": {
              "x": 16.381,
              "y": 20.373,
              "z": 0.489
            },
            "rightCorner": {
              "x": 16.118,
              "y": 20.391,
              "z": 0.489
            },
            "gtin": "4003586102676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de06",
            "leftCorner": {
              "x": 16.118,
              "y": 20.395,
              "z": 0.489
            },
            "rightCorner": {
              "x": 15.967,
              "y": 20.405,
              "z": 0.489
            },
            "gtin": "4003586006202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de07",
            "leftCorner": {
              "x": 15.967,
              "y": 20.405,
              "z": 0.489
            },
            "rightCorner": {
              "x": 15.816,
              "y": 20.415,
              "z": 0.489
            },
            "gtin": "4003586006202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de08",
            "leftCorner": {
              "x": 15.816,
              "y": 20.418,
              "z": 0.489
            },
            "rightCorner": {
              "x": 15.533,
              "y": 20.436,
              "z": 0.489
            },
            "gtin": "4003586006042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de09",
            "leftCorner": {
              "x": 15.533,
              "y": 20.436,
              "z": 0.489
            },
            "rightCorner": {
              "x": 15.248,
              "y": 20.455,
              "z": 0.489
            },
            "gtin": "4003586006042",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467b4",
        "height": 0.94382,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1ddce",
            "leftCorner": {
              "x": 16.408,
              "y": 20.382,
              "z": 0.772
            },
            "rightCorner": {
              "x": 16.12,
              "y": 20.401,
              "z": 0.772
            },
            "gtin": "4001242105924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddcf",
            "leftCorner": {
              "x": 16.12,
              "y": 20.401,
              "z": 0.772
            },
            "rightCorner": {
              "x": 15.83,
              "y": 20.42,
              "z": 0.772
            },
            "gtin": "4001242105924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddd0",
            "leftCorner": {
              "x": 15.831,
              "y": 20.436,
              "z": 0.772
            },
            "rightCorner": {
              "x": 15.561,
              "y": 20.453,
              "z": 0.772
            },
            "gtin": "4001242106297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddd1",
            "leftCorner": {
              "x": 15.56,
              "y": 20.443,
              "z": 0.772
            },
            "rightCorner": {
              "x": 15.469,
              "y": 20.45,
              "z": 0.772
            },
            "gtin": "4001242105931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddd2",
            "leftCorner": {
              "x": 15.469,
              "y": 20.445,
              "z": 0.772
            },
            "rightCorner": {
              "x": 15.208,
              "y": 20.463,
              "z": 0.772
            },
            "gtin": "4001242105900",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467b5",
        "height": 1.4237,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21069",
            "leftCorner": {
              "x": 16.469,
              "y": 20.423,
              "z": 1.165
            },
            "rightCorner": {
              "x": 16.303,
              "y": 20.434,
              "z": 1.165
            },
            "gtin": "4260350922667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2106a",
            "leftCorner": {
              "x": 16.303,
              "y": 20.434,
              "z": 1.165
            },
            "rightCorner": {
              "x": 16.135,
              "y": 20.445,
              "z": 1.165
            },
            "gtin": "4260350922667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2106c",
            "leftCorner": {
              "x": 16.133,
              "y": 20.4,
              "z": 1.165
            },
            "rightCorner": {
              "x": 15.909,
              "y": 20.415,
              "z": 1.165
            },
            "gtin": "4260350922643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2106d",
            "leftCorner": {
              "x": 15.91,
              "y": 20.426,
              "z": 1.165
            },
            "rightCorner": {
              "x": 15.442,
              "y": 20.457,
              "z": 1.165
            },
            "gtin": "4007552304903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2106b",
            "leftCorner": {
              "x": 15.441,
              "y": 20.45,
              "z": 1.165
            },
            "rightCorner": {
              "x": 15.27,
              "y": 20.462,
              "z": 1.165
            },
            "gtin": "4007552304941",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467b2",
        "height": 1.7428,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1de63",
            "leftCorner": {
              "x": 16.444,
              "y": 20.383,
              "z": 1.426
            },
            "rightCorner": {
              "x": 16.305,
              "y": 20.393,
              "z": 1.426
            },
            "gtin": "4031446500034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de64",
            "leftCorner": {
              "x": 16.305,
              "y": 20.393,
              "z": 1.426
            },
            "rightCorner": {
              "x": 16.166,
              "y": 20.401,
              "z": 1.426
            },
            "gtin": "4031446500034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de65",
            "leftCorner": {
              "x": 16.166,
              "y": 20.409,
              "z": 1.426
            },
            "rightCorner": {
              "x": 15.76,
              "y": 20.436,
              "z": 1.426
            },
            "gtin": "4031446500058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de66",
            "leftCorner": {
              "x": 15.76,
              "y": 20.441,
              "z": 1.426
            },
            "rightCorner": {
              "x": 15.629,
              "y": 20.45,
              "z": 1.426
            },
            "gtin": "3800205872955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de67",
            "leftCorner": {
              "x": 15.629,
              "y": 20.45,
              "z": 1.426
            },
            "rightCorner": {
              "x": 15.498,
              "y": 20.458,
              "z": 1.426
            },
            "gtin": "3800205872955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de68",
            "leftCorner": {
              "x": 15.498,
              "y": 20.46,
              "z": 1.426
            },
            "rightCorner": {
              "x": 15.408,
              "y": 20.466,
              "z": 1.426
            },
            "gtin": "3800205872948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de69",
            "leftCorner": {
              "x": 15.408,
              "y": 20.466,
              "z": 1.426
            },
            "rightCorner": {
              "x": 15.318,
              "y": 20.471,
              "z": 1.426
            },
            "gtin": "3800205872948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de6a",
            "leftCorner": {
              "x": 15.318,
              "y": 20.471,
              "z": 1.426
            },
            "rightCorner": {
              "x": 15.23,
              "y": 20.478,
              "z": 1.426
            },
            "gtin": "3800205872948",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a08",
    "rightNeighborShelfId": "50a0a"
  },
  {
    "id": "50a0a",
    "name": "50a0a",
    "x": 15.273,
    "y": 20.514,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99946,
      "w": 0.032824
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 47
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5462c7",
        "height": 0.13512,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1deb6",
            "leftCorner": {
              "x": 15.208,
              "y": 20.466,
              "z": 0.111
            },
            "rightCorner": {
              "x": 14.637,
              "y": 20.504,
              "z": 0.111
            },
            "gtin": "4063367147388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1deb7",
            "leftCorner": {
              "x": 14.638,
              "y": 20.511,
              "z": 0.111
            },
            "rightCorner": {
              "x": 13.925,
              "y": 20.558,
              "z": 0.111
            },
            "gtin": "4063367394089",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462c4",
        "height": 0.59243,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1de0a",
            "leftCorner": {
              "x": 15.249,
              "y": 20.456,
              "z": 0.485
            },
            "rightCorner": {
              "x": 15.032,
              "y": 20.47,
              "z": 0.485
            },
            "gtin": "4063367432965",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de0b",
            "leftCorner": {
              "x": 15.032,
              "y": 20.47,
              "z": 0.485
            },
            "rightCorner": {
              "x": 14.816,
              "y": 20.484,
              "z": 0.485
            },
            "gtin": "4063367432965",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de0c",
            "leftCorner": {
              "x": 14.816,
              "y": 20.482,
              "z": 0.485
            },
            "rightCorner": {
              "x": 14.623,
              "y": 20.495,
              "z": 0.485
            },
            "gtin": "4063367432941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de0d",
            "leftCorner": {
              "x": 14.623,
              "y": 20.495,
              "z": 0.485
            },
            "rightCorner": {
              "x": 14.43,
              "y": 20.507,
              "z": 0.485
            },
            "gtin": "4063367432941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de0e",
            "leftCorner": {
              "x": 14.43,
              "y": 20.507,
              "z": 0.485
            },
            "rightCorner": {
              "x": 14.238,
              "y": 20.521,
              "z": 0.485
            },
            "gtin": "4063367432941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de0f",
            "leftCorner": {
              "x": 14.238,
              "y": 20.521,
              "z": 0.485
            },
            "rightCorner": {
              "x": 14.045,
              "y": 20.534,
              "z": 0.485
            },
            "gtin": "4063367432941",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462c3",
        "height": 0.93648,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1ddd3",
            "leftCorner": {
              "x": 15.208,
              "y": 20.476,
              "z": 0.766
            },
            "rightCorner": {
              "x": 15.002,
              "y": 20.489,
              "z": 0.766
            },
            "gtin": "7622201497392",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddd4",
            "leftCorner": {
              "x": 15.002,
              "y": 20.489,
              "z": 0.766
            },
            "rightCorner": {
              "x": 14.796,
              "y": 20.503,
              "z": 0.766
            },
            "gtin": "7622201497392",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddd5",
            "leftCorner": {
              "x": 14.795,
              "y": 20.498,
              "z": 0.766
            },
            "rightCorner": {
              "x": 14.694,
              "y": 20.505,
              "z": 0.766
            },
            "gtin": "4001242105917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddd6",
            "leftCorner": {
              "x": 14.694,
              "y": 20.505,
              "z": 0.766
            },
            "rightCorner": {
              "x": 14.592,
              "y": 20.511,
              "z": 0.766
            },
            "gtin": "4001242105917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddd7",
            "leftCorner": {
              "x": 14.592,
              "y": 20.511,
              "z": 0.766
            },
            "rightCorner": {
              "x": 14.491,
              "y": 20.518,
              "z": 0.766
            },
            "gtin": "4001242105917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddd8",
            "leftCorner": {
              "x": 14.491,
              "y": 20.519,
              "z": 0.766
            },
            "rightCorner": {
              "x": 14.315,
              "y": 20.531,
              "z": 0.766
            },
            "gtin": "4062139006038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddd9",
            "leftCorner": {
              "x": 14.315,
              "y": 20.531,
              "z": 0.766
            },
            "rightCorner": {
              "x": 14.141,
              "y": 20.542,
              "z": 0.766
            },
            "gtin": "4062139006038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddda",
            "leftCorner": {
              "x": 14.141,
              "y": 20.542,
              "z": 0.766
            },
            "rightCorner": {
              "x": 13.965,
              "y": 20.554,
              "z": 0.766
            },
            "gtin": "4062139006038",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462c5",
        "height": 1.3913,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1de19",
            "leftCorner": {
              "x": 15.273,
              "y": 20.516,
              "z": 1.138
            },
            "rightCorner": {
              "x": 14.996,
              "y": 20.534,
              "z": 1.138
            },
            "gtin": "4031446869773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de1e",
            "leftCorner": {
              "x": 14.993,
              "y": 20.483,
              "z": 1.138
            },
            "rightCorner": {
              "x": 14.864,
              "y": 20.491,
              "z": 1.138
            },
            "gtin": "4031446980515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de1f",
            "leftCorner": {
              "x": 14.864,
              "y": 20.491,
              "z": 1.138
            },
            "rightCorner": {
              "x": 14.735,
              "y": 20.501,
              "z": 1.138
            },
            "gtin": "4031446980515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de20",
            "leftCorner": {
              "x": 14.736,
              "y": 20.515,
              "z": 1.138
            },
            "rightCorner": {
              "x": 14.646,
              "y": 20.519,
              "z": 1.138
            },
            "gtin": "4031446980355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de21",
            "leftCorner": {
              "x": 14.646,
              "y": 20.519,
              "z": 1.138
            },
            "rightCorner": {
              "x": 14.557,
              "y": 20.525,
              "z": 1.138
            },
            "gtin": "4031446980355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de22",
            "leftCorner": {
              "x": 14.556,
              "y": 20.523,
              "z": 1.138
            },
            "rightCorner": {
              "x": 14.498,
              "y": 20.528,
              "z": 1.138
            },
            "gtin": "4001242108222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de23",
            "leftCorner": {
              "x": 14.498,
              "y": 20.528,
              "z": 1.138
            },
            "rightCorner": {
              "x": 14.439,
              "y": 20.532,
              "z": 1.138
            },
            "gtin": "4001242108222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de24",
            "leftCorner": {
              "x": 14.439,
              "y": 20.532,
              "z": 1.138
            },
            "rightCorner": {
              "x": 14.38,
              "y": 20.535,
              "z": 1.138
            },
            "gtin": "4001242108222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de25",
            "leftCorner": {
              "x": 14.38,
              "y": 20.546,
              "z": 1.138
            },
            "rightCorner": {
              "x": 14.299,
              "y": 20.551,
              "z": 1.138
            },
            "gtin": "4001242108239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de26",
            "leftCorner": {
              "x": 14.299,
              "y": 20.551,
              "z": 1.138
            },
            "rightCorner": {
              "x": 14.218,
              "y": 20.556,
              "z": 1.138
            },
            "gtin": "4001242108239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de27",
            "leftCorner": {
              "x": 14.216,
              "y": 20.552,
              "z": 1.138
            },
            "rightCorner": {
              "x": 14.186,
              "y": 20.554,
              "z": 1.138
            },
            "gtin": "4001242108215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de28",
            "leftCorner": {
              "x": 14.186,
              "y": 20.554,
              "z": 1.138
            },
            "rightCorner": {
              "x": 14.154,
              "y": 20.556,
              "z": 1.138
            },
            "gtin": "4001242108215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de29",
            "leftCorner": {
              "x": 14.154,
              "y": 20.556,
              "z": 1.138
            },
            "rightCorner": {
              "x": 14.123,
              "y": 20.558,
              "z": 1.138
            },
            "gtin": "4001242108215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de2a",
            "leftCorner": {
              "x": 14.123,
              "y": 20.558,
              "z": 1.138
            },
            "rightCorner": {
              "x": 14.091,
              "y": 20.56,
              "z": 1.138
            },
            "gtin": "4001242108215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de2b",
            "leftCorner": {
              "x": 14.091,
              "y": 20.56,
              "z": 1.138
            },
            "rightCorner": {
              "x": 14.06,
              "y": 20.562,
              "z": 1.138
            },
            "gtin": "4001242108215",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462c6",
        "height": 1.7373,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1de6b",
            "leftCorner": {
              "x": 15.229,
              "y": 20.474,
              "z": 1.421
            },
            "rightCorner": {
              "x": 15.17,
              "y": 20.478,
              "z": 1.421
            },
            "gtin": "4337185914188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de6c",
            "leftCorner": {
              "x": 15.17,
              "y": 20.478,
              "z": 1.421
            },
            "rightCorner": {
              "x": 15.11,
              "y": 20.482,
              "z": 1.421
            },
            "gtin": "4337185914188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de6d",
            "leftCorner": {
              "x": 15.11,
              "y": 20.482,
              "z": 1.421
            },
            "rightCorner": {
              "x": 15.051,
              "y": 20.486,
              "z": 1.421
            },
            "gtin": "4337185914188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de6e",
            "leftCorner": {
              "x": 15.051,
              "y": 20.486,
              "z": 1.421
            },
            "rightCorner": {
              "x": 14.992,
              "y": 20.489,
              "z": 1.421
            },
            "gtin": "4337185914188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de6f",
            "leftCorner": {
              "x": 14.992,
              "y": 20.489,
              "z": 1.421
            },
            "rightCorner": {
              "x": 14.932,
              "y": 20.494,
              "z": 1.421
            },
            "gtin": "4337185914188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de70",
            "leftCorner": {
              "x": 14.932,
              "y": 20.494,
              "z": 1.421
            },
            "rightCorner": {
              "x": 14.874,
              "y": 20.498,
              "z": 1.421
            },
            "gtin": "4337185914188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de71",
            "leftCorner": {
              "x": 14.873,
              "y": 20.495,
              "z": 1.421
            },
            "rightCorner": {
              "x": 14.808,
              "y": 20.5,
              "z": 1.421
            },
            "gtin": "4063367286681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de72",
            "leftCorner": {
              "x": 14.808,
              "y": 20.5,
              "z": 1.421
            },
            "rightCorner": {
              "x": 14.744,
              "y": 20.504,
              "z": 1.421
            },
            "gtin": "4063367286681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de73",
            "leftCorner": {
              "x": 14.744,
              "y": 20.504,
              "z": 1.421
            },
            "rightCorner": {
              "x": 14.678,
              "y": 20.508,
              "z": 1.421
            },
            "gtin": "4063367286681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de74",
            "leftCorner": {
              "x": 14.679,
              "y": 20.513,
              "z": 1.421
            },
            "rightCorner": {
              "x": 14.614,
              "y": 20.517,
              "z": 1.421
            },
            "gtin": "4337185914300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de75",
            "leftCorner": {
              "x": 14.614,
              "y": 20.517,
              "z": 1.421
            },
            "rightCorner": {
              "x": 14.55,
              "y": 20.522,
              "z": 1.421
            },
            "gtin": "4337185914300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de76",
            "leftCorner": {
              "x": 14.55,
              "y": 20.522,
              "z": 1.421
            },
            "rightCorner": {
              "x": 14.486,
              "y": 20.525,
              "z": 1.421
            },
            "gtin": "4337185914300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de77",
            "leftCorner": {
              "x": 14.486,
              "y": 20.526,
              "z": 1.421
            },
            "rightCorner": {
              "x": 14.378,
              "y": 20.533,
              "z": 1.421
            },
            "gtin": "4337185914249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de78",
            "leftCorner": {
              "x": 14.378,
              "y": 20.533,
              "z": 1.421
            },
            "rightCorner": {
              "x": 14.268,
              "y": 20.541,
              "z": 1.421
            },
            "gtin": "4337185914249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de79",
            "leftCorner": {
              "x": 14.268,
              "y": 20.539,
              "z": 1.421
            },
            "rightCorner": {
              "x": 14.161,
              "y": 20.546,
              "z": 1.421
            },
            "gtin": "5701397024734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de7a",
            "leftCorner": {
              "x": 14.161,
              "y": 20.546,
              "z": 1.421
            },
            "rightCorner": {
              "x": 14.054,
              "y": 20.554,
              "z": 1.421
            },
            "gtin": "5701397024734",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a09",
    "rightNeighborShelfId": "50a0b"
  },
  {
    "id": "50a0b",
    "name": "50a0b",
    "x": 14.075,
    "y": 20.593,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99946,
      "w": 0.032824
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 28
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5467c1",
        "height": 0.13918,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1deb8",
            "leftCorner": {
              "x": 13.923,
              "y": 20.543,
              "z": 0.114
            },
            "rightCorner": {
              "x": 13.426,
              "y": 20.577,
              "z": 0.114
            },
            "gtin": "4063367394072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1deb9",
            "leftCorner": {
              "x": 13.427,
              "y": 20.582,
              "z": 0.114
            },
            "rightCorner": {
              "x": 12.812,
              "y": 20.622,
              "z": 0.114
            },
            "gtin": "4063367394027",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467be",
        "height": 0.59469,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1de10",
            "leftCorner": {
              "x": 14.045,
              "y": 20.542,
              "z": 0.487
            },
            "rightCorner": {
              "x": 13.889,
              "y": 20.553,
              "z": 0.487
            },
            "gtin": "5201360660360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de11",
            "leftCorner": {
              "x": 13.889,
              "y": 20.553,
              "z": 0.487
            },
            "rightCorner": {
              "x": 13.733,
              "y": 20.563,
              "z": 0.487
            },
            "gtin": "5201360660360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de12",
            "leftCorner": {
              "x": 13.733,
              "y": 20.563,
              "z": 0.487
            },
            "rightCorner": {
              "x": 13.577,
              "y": 20.574,
              "z": 0.487
            },
            "gtin": "5201360660360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de13",
            "leftCorner": {
              "x": 13.576,
              "y": 20.57,
              "z": 0.487
            },
            "rightCorner": {
              "x": 13.259,
              "y": 20.591,
              "z": 0.487
            },
            "gtin": "5201360660803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de14",
            "leftCorner": {
              "x": 13.26,
              "y": 20.605,
              "z": 0.487
            },
            "rightCorner": {
              "x": 13.06,
              "y": 20.617,
              "z": 0.487
            },
            "gtin": "5201360660520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de15",
            "leftCorner": {
              "x": 13.06,
              "y": 20.617,
              "z": 0.487
            },
            "rightCorner": {
              "x": 12.86,
              "y": 20.631,
              "z": 0.487
            },
            "gtin": "5201360660520",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467c0",
        "height": 0.93798,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dddb",
            "leftCorner": {
              "x": 13.965,
              "y": 20.554,
              "z": 0.767
            },
            "rightCorner": {
              "x": 13.833,
              "y": 20.563,
              "z": 0.767
            },
            "gtin": "5201360660575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dddc",
            "leftCorner": {
              "x": 13.833,
              "y": 20.563,
              "z": 0.767
            },
            "rightCorner": {
              "x": 13.702,
              "y": 20.572,
              "z": 0.767
            },
            "gtin": "5201360660575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dddd",
            "leftCorner": {
              "x": 13.702,
              "y": 20.574,
              "z": 0.767
            },
            "rightCorner": {
              "x": 13.435,
              "y": 20.59,
              "z": 0.767
            },
            "gtin": "5201360660773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddde",
            "leftCorner": {
              "x": 13.435,
              "y": 20.588,
              "z": 0.767
            },
            "rightCorner": {
              "x": 13.111,
              "y": 20.61,
              "z": 0.767
            },
            "gtin": "5201360660223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dddf",
            "leftCorner": {
              "x": 13.111,
              "y": 20.61,
              "z": 0.767
            },
            "rightCorner": {
              "x": 12.785,
              "y": 20.631,
              "z": 0.767
            },
            "gtin": "5201360660223",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467bf",
        "height": 1.3925,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1de2c",
            "leftCorner": {
              "x": 14.058,
              "y": 20.556,
              "z": 1.139
            },
            "rightCorner": {
              "x": 13.949,
              "y": 20.563,
              "z": 1.139
            },
            "gtin": "4063367066795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de2d",
            "leftCorner": {
              "x": 13.949,
              "y": 20.563,
              "z": 1.139
            },
            "rightCorner": {
              "x": 13.84,
              "y": 20.57,
              "z": 1.139
            },
            "gtin": "4063367066795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de2e",
            "leftCorner": {
              "x": 13.84,
              "y": 20.57,
              "z": 1.139
            },
            "rightCorner": {
              "x": 13.73,
              "y": 20.577,
              "z": 1.139
            },
            "gtin": "4063367066795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de2f",
            "leftCorner": {
              "x": 13.73,
              "y": 20.577,
              "z": 1.139
            },
            "rightCorner": {
              "x": 13.62,
              "y": 20.585,
              "z": 1.139
            },
            "gtin": "4063367066795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de30",
            "leftCorner": {
              "x": 13.62,
              "y": 20.589,
              "z": 1.139
            },
            "rightCorner": {
              "x": 13.398,
              "y": 20.603,
              "z": 1.139
            },
            "gtin": "4063367355592",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de31",
            "leftCorner": {
              "x": 13.398,
              "y": 20.603,
              "z": 1.139
            },
            "rightCorner": {
              "x": 13.174,
              "y": 20.618,
              "z": 1.139
            },
            "gtin": "4063367355592",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de32",
            "leftCorner": {
              "x": 13.174,
              "y": 20.615,
              "z": 1.139
            },
            "rightCorner": {
              "x": 13.015,
              "y": 20.625,
              "z": 1.139
            },
            "gtin": "4018077620003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de33",
            "leftCorner": {
              "x": 13.015,
              "y": 20.625,
              "z": 1.139
            },
            "rightCorner": {
              "x": 12.857,
              "y": 20.636,
              "z": 1.139
            },
            "gtin": "4018077620003",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467bd",
        "height": 1.7382,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1de7b",
            "leftCorner": {
              "x": 14.055,
              "y": 20.562,
              "z": 1.422
            },
            "rightCorner": {
              "x": 13.774,
              "y": 20.58,
              "z": 1.422
            },
            "gtin": "5701397024741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de7c",
            "leftCorner": {
              "x": 13.774,
              "y": 20.58,
              "z": 1.422
            },
            "rightCorner": {
              "x": 13.494,
              "y": 20.599,
              "z": 1.422
            },
            "gtin": "5701397024741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de7d",
            "leftCorner": {
              "x": 13.493,
              "y": 20.589,
              "z": 1.422
            },
            "rightCorner": {
              "x": 13.364,
              "y": 20.597,
              "z": 1.422
            },
            "gtin": "4063367399954",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de7e",
            "leftCorner": {
              "x": 13.364,
              "y": 20.597,
              "z": 1.422
            },
            "rightCorner": {
              "x": 13.236,
              "y": 20.606,
              "z": 1.422
            },
            "gtin": "4063367399954",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de7f",
            "leftCorner": {
              "x": 13.236,
              "y": 20.61,
              "z": 1.422
            },
            "rightCorner": {
              "x": 13.102,
              "y": 20.618,
              "z": 1.422
            },
            "gtin": "4063367066856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de80",
            "leftCorner": {
              "x": 13.102,
              "y": 20.618,
              "z": 1.422
            },
            "rightCorner": {
              "x": 12.969,
              "y": 20.627,
              "z": 1.422
            },
            "gtin": "4063367066856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de81",
            "leftCorner": {
              "x": 12.969,
              "y": 20.627,
              "z": 1.422
            },
            "rightCorner": {
              "x": 12.836,
              "y": 20.636,
              "z": 1.422
            },
            "gtin": "4063367066856",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a0a",
    "rightNeighborShelfId": "50a0c"
  },
  {
    "id": "50a0c",
    "name": "50a0c",
    "x": 12.878,
    "y": 20.672,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99946,
      "w": 0.032824
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 33
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5467cc",
        "height": 0.14396,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1deba",
            "leftCorner": {
              "x": 12.812,
              "y": 20.614,
              "z": 0.118
            },
            "rightCorner": {
              "x": 12.513,
              "y": 20.634,
              "z": 0.118
            },
            "gtin": "5201008423289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1debb",
            "leftCorner": {
              "x": 12.513,
              "y": 20.634,
              "z": 0.118
            },
            "rightCorner": {
              "x": 12.214,
              "y": 20.653,
              "z": 0.118
            },
            "gtin": "5201008423289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1debc",
            "leftCorner": {
              "x": 12.214,
              "y": 20.652,
              "z": 0.118
            },
            "rightCorner": {
              "x": 12.075,
              "y": 20.662,
              "z": 0.118
            },
            "gtin": "5201008423296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1debd",
            "leftCorner": {
              "x": 12.075,
              "y": 20.662,
              "z": 0.118
            },
            "rightCorner": {
              "x": 11.935,
              "y": 20.671,
              "z": 0.118
            },
            "gtin": "5201008423296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1debe",
            "leftCorner": {
              "x": 11.936,
              "y": 20.685,
              "z": 0.118
            },
            "rightCorner": {
              "x": 11.786,
              "y": 20.695,
              "z": 0.118
            },
            "gtin": "5201008423302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1debf",
            "leftCorner": {
              "x": 11.786,
              "y": 20.695,
              "z": 0.118
            },
            "rightCorner": {
              "x": 11.635,
              "y": 20.705,
              "z": 0.118
            },
            "gtin": "5201008423302",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467cb",
        "height": 0.58826,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1de16",
            "leftCorner": {
              "x": 12.86,
              "y": 20.633,
              "z": 0.481
            },
            "rightCorner": {
              "x": 12.706,
              "y": 20.643,
              "z": 0.481
            },
            "gtin": "7622202253102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de17",
            "leftCorner": {
              "x": 12.706,
              "y": 20.643,
              "z": 0.481
            },
            "rightCorner": {
              "x": 12.553,
              "y": 20.653,
              "z": 0.481
            },
            "gtin": "7622202253102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de18",
            "leftCorner": {
              "x": 12.553,
              "y": 20.653,
              "z": 0.481
            },
            "rightCorner": {
              "x": 12.399,
              "y": 20.664,
              "z": 0.481
            },
            "gtin": "7622202253102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddfd",
            "leftCorner": {
              "x": 12.399,
              "y": 20.654,
              "z": 0.481
            },
            "rightCorner": {
              "x": 12.037,
              "y": 20.677,
              "z": 0.481
            },
            "gtin": "7622202040900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddfe",
            "leftCorner": {
              "x": 12.037,
              "y": 20.677,
              "z": 0.481
            },
            "rightCorner": {
              "x": 11.677,
              "y": 20.702,
              "z": 0.481
            },
            "gtin": "7622202040900",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467cd",
        "height": 0.94735,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dde0",
            "leftCorner": {
              "x": 12.787,
              "y": 20.648,
              "z": 0.775
            },
            "rightCorner": {
              "x": 12.584,
              "y": 20.661,
              "z": 0.775
            },
            "gtin": "7622210998477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dde1",
            "leftCorner": {
              "x": 12.583,
              "y": 20.644,
              "z": 0.775
            },
            "rightCorner": {
              "x": 12.421,
              "y": 20.655,
              "z": 0.775
            },
            "gtin": "7622210641403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dde2",
            "leftCorner": {
              "x": 12.421,
              "y": 20.655,
              "z": 0.775
            },
            "rightCorner": {
              "x": 12.258,
              "y": 20.665,
              "z": 0.775
            },
            "gtin": "7622210641403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dde3",
            "leftCorner": {
              "x": 12.258,
              "y": 20.66,
              "z": 0.775
            },
            "rightCorner": {
              "x": 11.966,
              "y": 20.679,
              "z": 0.775
            },
            "gtin": "5410041001204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dde4",
            "leftCorner": {
              "x": 11.966,
              "y": 20.68,
              "z": 0.775
            },
            "rightCorner": {
              "x": 11.656,
              "y": 20.701,
              "z": 0.775
            },
            "gtin": "7622210641434",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467ca",
        "height": 1.3955,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1de34",
            "leftCorner": {
              "x": 12.856,
              "y": 20.622,
              "z": 1.142
            },
            "rightCorner": {
              "x": 12.796,
              "y": 20.627,
              "z": 1.142
            },
            "gtin": "8711299003109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de35",
            "leftCorner": {
              "x": 12.796,
              "y": 20.627,
              "z": 1.142
            },
            "rightCorner": {
              "x": 12.735,
              "y": 20.63,
              "z": 1.142
            },
            "gtin": "8711299003109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de36",
            "leftCorner": {
              "x": 12.735,
              "y": 20.633,
              "z": 1.142
            },
            "rightCorner": {
              "x": 12.196,
              "y": 20.669,
              "z": 1.142
            },
            "gtin": "5410041066005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de37",
            "leftCorner": {
              "x": 12.196,
              "y": 20.665,
              "z": 1.142
            },
            "rightCorner": {
              "x": 11.869,
              "y": 20.686,
              "z": 1.142
            },
            "gtin": "5410041030006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de38",
            "leftCorner": {
              "x": 11.869,
              "y": 20.686,
              "z": 1.142
            },
            "rightCorner": {
              "x": 11.54,
              "y": 20.708,
              "z": 1.142
            },
            "gtin": "5410041030006",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467c9",
        "height": 1.7403,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1de82",
            "leftCorner": {
              "x": 12.835,
              "y": 20.628,
              "z": 1.424
            },
            "rightCorner": {
              "x": 12.599,
              "y": 20.644,
              "z": 1.424
            },
            "gtin": "5000396021202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de83",
            "leftCorner": {
              "x": 12.599,
              "y": 20.644,
              "z": 1.424
            },
            "rightCorner": {
              "x": 12.363,
              "y": 20.659,
              "z": 1.424
            },
            "gtin": "5000396021202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de84",
            "leftCorner": {
              "x": 12.363,
              "y": 20.655,
              "z": 1.424
            },
            "rightCorner": {
              "x": 12.24,
              "y": 20.663,
              "z": 1.424
            },
            "gtin": "4018077620003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de85",
            "leftCorner": {
              "x": 12.242,
              "y": 20.682,
              "z": 1.424
            },
            "rightCorner": {
              "x": 12.093,
              "y": 20.692,
              "z": 1.424
            },
            "gtin": "4750127300601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de86",
            "leftCorner": {
              "x": 12.093,
              "y": 20.683,
              "z": 1.424
            },
            "rightCorner": {
              "x": 12.017,
              "y": 20.687,
              "z": 1.424
            },
            "gtin": "4750127300632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de87",
            "leftCorner": {
              "x": 12.017,
              "y": 20.687,
              "z": 1.424
            },
            "rightCorner": {
              "x": 11.942,
              "y": 20.693,
              "z": 1.424
            },
            "gtin": "4750127300632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de88",
            "leftCorner": {
              "x": 11.942,
              "y": 20.693,
              "z": 1.424
            },
            "rightCorner": {
              "x": 11.867,
              "y": 20.697,
              "z": 1.424
            },
            "gtin": "4750127300625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de89",
            "leftCorner": {
              "x": 11.867,
              "y": 20.697,
              "z": 1.424
            },
            "rightCorner": {
              "x": 11.792,
              "y": 20.702,
              "z": 1.424
            },
            "gtin": "4750127300625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de8a",
            "leftCorner": {
              "x": 11.793,
              "y": 20.706,
              "z": 1.424
            },
            "rightCorner": {
              "x": 11.727,
              "y": 20.711,
              "z": 1.424
            },
            "gtin": "4750127000266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de8b",
            "leftCorner": {
              "x": 11.727,
              "y": 20.711,
              "z": 1.424
            },
            "rightCorner": {
              "x": 11.661,
              "y": 20.715,
              "z": 1.424
            },
            "gtin": "4750127000266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de8c",
            "leftCorner": {
              "x": 11.661,
              "y": 20.715,
              "z": 1.424
            },
            "rightCorner": {
              "x": 11.594,
              "y": 20.719,
              "z": 1.424
            },
            "gtin": "4750127000266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de8d",
            "leftCorner": {
              "x": 11.594,
              "y": 20.719,
              "z": 1.424
            },
            "rightCorner": {
              "x": 11.528,
              "y": 20.724,
              "z": 1.424
            },
            "gtin": "4750127000266",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a0b",
    "rightNeighborShelfId": "50a0d"
  },
  {
    "id": "50a0d",
    "name": "50a0d",
    "x": 11.681,
    "y": 20.75,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99946,
      "w": 0.032824
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 44
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5467d0",
        "height": 0.13713,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dec0",
            "leftCorner": {
              "x": 11.635,
              "y": 20.699,
              "z": 0.112
            },
            "rightCorner": {
              "x": 11.398,
              "y": 20.714,
              "z": 0.112
            },
            "gtin": "4337185460777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dec1",
            "leftCorner": {
              "x": 11.398,
              "y": 20.714,
              "z": 0.112
            },
            "rightCorner": {
              "x": 11.161,
              "y": 20.73,
              "z": 0.112
            },
            "gtin": "4337185460777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dec2",
            "leftCorner": {
              "x": 11.162,
              "y": 20.75,
              "z": 0.112
            },
            "rightCorner": {
              "x": 10.776,
              "y": 20.776,
              "z": 0.112
            },
            "gtin": "4337185460784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dec3",
            "leftCorner": {
              "x": 10.776,
              "y": 20.776,
              "z": 0.112
            },
            "rightCorner": {
              "x": 10.39,
              "y": 20.802,
              "z": 0.112
            },
            "gtin": "4337185460784",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467cf",
        "height": 0.60018,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a211c3",
            "leftCorner": {
              "x": 11.68,
              "y": 20.736,
              "z": 0.491
            },
            "rightCorner": {
              "x": 11.63,
              "y": 20.74,
              "z": 0.491
            },
            "gtin": "4270000476907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211c4",
            "leftCorner": {
              "x": 11.63,
              "y": 20.74,
              "z": 0.491
            },
            "rightCorner": {
              "x": 11.581,
              "y": 20.743,
              "z": 0.491
            },
            "gtin": "4270000476907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211c7",
            "leftCorner": {
              "x": 11.578,
              "y": 20.706,
              "z": 0.491
            },
            "rightCorner": {
              "x": 11.472,
              "y": 20.714,
              "z": 0.491
            },
            "gtin": "7610058207271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211c8",
            "leftCorner": {
              "x": 11.472,
              "y": 20.714,
              "z": 0.491
            },
            "rightCorner": {
              "x": 11.365,
              "y": 20.72,
              "z": 0.491
            },
            "gtin": "7610058207271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211c9",
            "leftCorner": {
              "x": 11.365,
              "y": 20.716,
              "z": 0.491
            },
            "rightCorner": {
              "x": 11.243,
              "y": 20.724,
              "z": 0.491
            },
            "gtin": "7610058207264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211ca",
            "leftCorner": {
              "x": 11.243,
              "y": 20.724,
              "z": 0.491
            },
            "rightCorner": {
              "x": 11.122,
              "y": 20.732,
              "z": 0.491
            },
            "gtin": "7610058207264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211c5",
            "leftCorner": {
              "x": 11.123,
              "y": 20.739,
              "z": 0.491
            },
            "rightCorner": {
              "x": 10.802,
              "y": 20.76,
              "z": 0.491
            },
            "gtin": "4063367403767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211c6",
            "leftCorner": {
              "x": 10.802,
              "y": 20.76,
              "z": 0.491
            },
            "rightCorner": {
              "x": 10.481,
              "y": 20.781,
              "z": 0.491
            },
            "gtin": "4063367403767",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467ce",
        "height": 0.94175,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dde5",
            "leftCorner": {
              "x": 11.657,
              "y": 20.694,
              "z": 0.771
            },
            "rightCorner": {
              "x": 11.516,
              "y": 20.703,
              "z": 0.771
            },
            "gtin": "8711299009897",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dde6",
            "leftCorner": {
              "x": 11.516,
              "y": 20.703,
              "z": 0.771
            },
            "rightCorner": {
              "x": 11.403,
              "y": 20.711,
              "z": 0.771
            },
            "gtin": "8711299009941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dde7",
            "leftCorner": {
              "x": 11.403,
              "y": 20.713,
              "z": 0.771
            },
            "rightCorner": {
              "x": 11.31,
              "y": 20.719,
              "z": 0.771
            },
            "gtin": "8711299009842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dde8",
            "leftCorner": {
              "x": 11.31,
              "y": 20.73,
              "z": 0.771
            },
            "rightCorner": {
              "x": 11.259,
              "y": 20.734,
              "z": 0.771
            },
            "gtin": "8711299009798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dde9",
            "leftCorner": {
              "x": 11.259,
              "y": 20.734,
              "z": 0.771
            },
            "rightCorner": {
              "x": 11.206,
              "y": 20.736,
              "z": 0.771
            },
            "gtin": "8711299009798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddea",
            "leftCorner": {
              "x": 11.205,
              "y": 20.715,
              "z": 0.771
            },
            "rightCorner": {
              "x": 11.137,
              "y": 20.72,
              "z": 0.771
            },
            "gtin": "8711299009644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddeb",
            "leftCorner": {
              "x": 11.137,
              "y": 20.72,
              "z": 0.771
            },
            "rightCorner": {
              "x": 11.069,
              "y": 20.724,
              "z": 0.771
            },
            "gtin": "8711299009644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddec",
            "leftCorner": {
              "x": 11.071,
              "y": 20.743,
              "z": 0.771
            },
            "rightCorner": {
              "x": 10.623,
              "y": 20.773,
              "z": 0.771
            },
            "gtin": "8594042912466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dded",
            "leftCorner": {
              "x": 10.622,
              "y": 20.769,
              "z": 0.771
            },
            "rightCorner": {
              "x": 10.566,
              "y": 20.773,
              "z": 0.771
            },
            "gtin": "8594042912459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddee",
            "leftCorner": {
              "x": 10.566,
              "y": 20.773,
              "z": 0.771
            },
            "rightCorner": {
              "x": 10.51,
              "y": 20.776,
              "z": 0.771
            },
            "gtin": "8594042912459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddef",
            "leftCorner": {
              "x": 10.51,
              "y": 20.776,
              "z": 0.771
            },
            "rightCorner": {
              "x": 10.454,
              "y": 20.78,
              "z": 0.771
            },
            "gtin": "8594042912459",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467d1",
        "height": 1.3951,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1de39",
            "leftCorner": {
              "x": 11.542,
              "y": 20.714,
              "z": 1.141
            },
            "rightCorner": {
              "x": 11.417,
              "y": 20.722,
              "z": 1.141
            },
            "gtin": "7610058208193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de3a",
            "leftCorner": {
              "x": 11.417,
              "y": 20.722,
              "z": 1.141
            },
            "rightCorner": {
              "x": 11.293,
              "y": 20.731,
              "z": 1.141
            },
            "gtin": "7610058208193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de3b",
            "leftCorner": {
              "x": 11.293,
              "y": 20.735,
              "z": 1.141
            },
            "rightCorner": {
              "x": 11.173,
              "y": 20.742,
              "z": 1.141
            },
            "gtin": "4036554704213",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c855ed67a01d9a1de3c",
            "leftCorner": {
              "x": 11.173,
              "y": 20.737,
              "z": 1.141
            },
            "rightCorner": {
              "x": 11.051,
              "y": 20.745,
              "z": 1.141
            },
            "gtin": "4036554704244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de3d",
            "leftCorner": {
              "x": 11.053,
              "y": 20.758,
              "z": 1.141
            },
            "rightCorner": {
              "x": 10.971,
              "y": 20.764,
              "z": 1.141
            },
            "gtin": "4036554704237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de3e",
            "leftCorner": {
              "x": 10.971,
              "y": 20.764,
              "z": 1.141
            },
            "rightCorner": {
              "x": 10.889,
              "y": 20.769,
              "z": 1.141
            },
            "gtin": "4036554704237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de3f",
            "leftCorner": {
              "x": 10.889,
              "y": 20.768,
              "z": 1.141
            },
            "rightCorner": {
              "x": 10.835,
              "y": 20.772,
              "z": 1.141
            },
            "gtin": "4260546672635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de40",
            "leftCorner": {
              "x": 10.835,
              "y": 20.772,
              "z": 1.141
            },
            "rightCorner": {
              "x": 10.78,
              "y": 20.776,
              "z": 1.141
            },
            "gtin": "4260546672635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de1a",
            "leftCorner": {
              "x": 10.78,
              "y": 20.769,
              "z": 1.141
            },
            "rightCorner": {
              "x": 10.705,
              "y": 20.774,
              "z": 1.141
            },
            "gtin": "7610058042803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de1b",
            "leftCorner": {
              "x": 10.705,
              "y": 20.774,
              "z": 1.141
            },
            "rightCorner": {
              "x": 10.63,
              "y": 20.779,
              "z": 1.141
            },
            "gtin": "7610058042803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de1c",
            "leftCorner": {
              "x": 10.63,
              "y": 20.779,
              "z": 1.141
            },
            "rightCorner": {
              "x": 10.556,
              "y": 20.783,
              "z": 1.141
            },
            "gtin": "7610058042803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de1d",
            "leftCorner": {
              "x": 10.556,
              "y": 20.783,
              "z": 1.141
            },
            "rightCorner": {
              "x": 10.481,
              "y": 20.789,
              "z": 1.141
            },
            "gtin": "7610058042803",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467d2",
        "height": 1.7402,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1de8e",
            "leftCorner": {
              "x": 11.528,
              "y": 20.724,
              "z": 1.424
            },
            "rightCorner": {
              "x": 11.353,
              "y": 20.736,
              "z": 1.424
            },
            "gtin": "4750127300694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de8f",
            "leftCorner": {
              "x": 11.352,
              "y": 20.723,
              "z": 1.424
            },
            "rightCorner": {
              "x": 11.266,
              "y": 20.728,
              "z": 1.424
            },
            "gtin": "7610058208223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de90",
            "leftCorner": {
              "x": 11.266,
              "y": 20.728,
              "z": 1.424
            },
            "rightCorner": {
              "x": 11.182,
              "y": 20.733,
              "z": 1.424
            },
            "gtin": "7610058208223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de91",
            "leftCorner": {
              "x": 11.182,
              "y": 20.733,
              "z": 1.424
            },
            "rightCorner": {
              "x": 11.096,
              "y": 20.739,
              "z": 1.424
            },
            "gtin": "7610058208223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de92",
            "leftCorner": {
              "x": 11.096,
              "y": 20.742,
              "z": 1.424
            },
            "rightCorner": {
              "x": 11.012,
              "y": 20.747,
              "z": 1.424
            },
            "gtin": "4001518003817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de93",
            "leftCorner": {
              "x": 11.012,
              "y": 20.747,
              "z": 1.424
            },
            "rightCorner": {
              "x": 10.929,
              "y": 20.753,
              "z": 1.424
            },
            "gtin": "4001518003817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de94",
            "leftCorner": {
              "x": 10.929,
              "y": 20.741,
              "z": 1.424
            },
            "rightCorner": {
              "x": 10.743,
              "y": 20.754,
              "z": 1.424
            },
            "gtin": "4001518003800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de95",
            "leftCorner": {
              "x": 10.743,
              "y": 20.754,
              "z": 1.424
            },
            "rightCorner": {
              "x": 10.559,
              "y": 20.766,
              "z": 1.424
            },
            "gtin": "4001518003800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de96",
            "leftCorner": {
              "x": 10.56,
              "y": 20.781,
              "z": 1.424
            },
            "rightCorner": {
              "x": 10.513,
              "y": 20.785,
              "z": 1.424
            },
            "gtin": "4063367097690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de97",
            "leftCorner": {
              "x": 10.513,
              "y": 20.785,
              "z": 1.424
            },
            "rightCorner": {
              "x": 10.467,
              "y": 20.787,
              "z": 1.424
            },
            "gtin": "4063367097690",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a0c",
    "rightNeighborShelfId": "50a0e"
  },
  {
    "id": "50a0e",
    "name": "50a0e",
    "x": 10.483,
    "y": 20.829,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99946,
      "w": 0.032824
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 62
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546435",
        "height": 0.13731,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dec4",
            "leftCorner": {
              "x": 10.389,
              "y": 20.787,
              "z": 0.112
            },
            "rightCorner": {
              "x": 9.838,
              "y": 20.823,
              "z": 0.112
            },
            "gtin": "4335896051932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dec5",
            "leftCorner": {
              "x": 9.838,
              "y": 20.823,
              "z": 0.112
            },
            "rightCorner": {
              "x": 9.712,
              "y": 20.831,
              "z": 0.112
            },
            "gtin": "4337185458309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dec6",
            "leftCorner": {
              "x": 9.712,
              "y": 20.831,
              "z": 0.112
            },
            "rightCorner": {
              "x": 9.587,
              "y": 20.839,
              "z": 0.112
            },
            "gtin": "4337185458309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dec7",
            "leftCorner": {
              "x": 9.588,
              "y": 20.844,
              "z": 0.112
            },
            "rightCorner": {
              "x": 9.411,
              "y": 20.856,
              "z": 0.112
            },
            "gtin": "4063367150890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dec8",
            "leftCorner": {
              "x": 9.411,
              "y": 20.856,
              "z": 0.112
            },
            "rightCorner": {
              "x": 9.234,
              "y": 20.868,
              "z": 0.112
            },
            "gtin": "4063367150890",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546430",
        "height": 0.58659,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1edc3",
            "leftCorner": {
              "x": 10.482,
              "y": 20.817,
              "z": 0.48
            },
            "rightCorner": {
              "x": 10.287,
              "y": 20.83,
              "z": 0.48
            },
            "gtin": "8850043324623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edc7",
            "leftCorner": {
              "x": 10.284,
              "y": 20.784,
              "z": 0.48
            },
            "rightCorner": {
              "x": 10.157,
              "y": 20.792,
              "z": 0.48
            },
            "gtin": "634158955921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edc8",
            "leftCorner": {
              "x": 10.157,
              "y": 20.795,
              "z": 0.48
            },
            "rightCorner": {
              "x": 9.938,
              "y": 20.809,
              "z": 0.48
            },
            "gtin": "8009280002164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edc9",
            "leftCorner": {
              "x": 9.938,
              "y": 20.811,
              "z": 0.48
            },
            "rightCorner": {
              "x": 9.849,
              "y": 20.817,
              "z": 0.48
            },
            "gtin": "8009280001549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edca",
            "leftCorner": {
              "x": 9.85,
              "y": 20.825,
              "z": 0.48
            },
            "rightCorner": {
              "x": 9.743,
              "y": 20.832,
              "z": 0.48
            },
            "gtin": "8009280001570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edcb",
            "leftCorner": {
              "x": 9.743,
              "y": 20.832,
              "z": 0.48
            },
            "rightCorner": {
              "x": 9.636,
              "y": 20.839,
              "z": 0.48
            },
            "gtin": "8009280001570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edc4",
            "leftCorner": {
              "x": 9.636,
              "y": 20.834,
              "z": 0.48
            },
            "rightCorner": {
              "x": 9.518,
              "y": 20.842,
              "z": 0.48
            },
            "gtin": "8009280002720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edc5",
            "leftCorner": {
              "x": 9.518,
              "y": 20.842,
              "z": 0.48
            },
            "rightCorner": {
              "x": 9.4,
              "y": 20.849,
              "z": 0.48
            },
            "gtin": "8009280002720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edc6",
            "leftCorner": {
              "x": 9.4,
              "y": 20.849,
              "z": 0.48
            },
            "rightCorner": {
              "x": 9.282,
              "y": 20.858,
              "z": 0.48
            },
            "gtin": "8009280002720",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546434",
        "height": 0.94167,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1ddf0",
            "leftCorner": {
              "x": 10.454,
              "y": 20.795,
              "z": 0.77
            },
            "rightCorner": {
              "x": 10.385,
              "y": 20.8,
              "z": 0.77
            },
            "gtin": "4004980401907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddf1",
            "leftCorner": {
              "x": 10.385,
              "y": 20.8,
              "z": 0.77
            },
            "rightCorner": {
              "x": 10.315,
              "y": 20.804,
              "z": 0.77
            },
            "gtin": "4004980401907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddf2",
            "leftCorner": {
              "x": 10.315,
              "y": 20.797,
              "z": 0.77
            },
            "rightCorner": {
              "x": 10.197,
              "y": 20.806,
              "z": 0.77
            },
            "gtin": "4004980404007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddf3",
            "leftCorner": {
              "x": 10.197,
              "y": 20.808,
              "z": 0.77
            },
            "rightCorner": {
              "x": 10.013,
              "y": 20.82,
              "z": 0.77
            },
            "gtin": "4004980409705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddf4",
            "leftCorner": {
              "x": 10.013,
              "y": 20.816,
              "z": 0.77
            },
            "rightCorner": {
              "x": 9.931,
              "y": 20.82,
              "z": 0.77
            },
            "gtin": "4004980513006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddf5",
            "leftCorner": {
              "x": 9.931,
              "y": 20.82,
              "z": 0.77
            },
            "rightCorner": {
              "x": 9.85,
              "y": 20.826,
              "z": 0.77
            },
            "gtin": "4004980513006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddf6",
            "leftCorner": {
              "x": 9.85,
              "y": 20.826,
              "z": 0.77
            },
            "rightCorner": {
              "x": 9.768,
              "y": 20.831,
              "z": 0.77
            },
            "gtin": "4004980513006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddf7",
            "leftCorner": {
              "x": 9.768,
              "y": 20.83,
              "z": 0.77
            },
            "rightCorner": {
              "x": 9.718,
              "y": 20.834,
              "z": 0.77
            },
            "gtin": "4004980516809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddf8",
            "leftCorner": {
              "x": 9.718,
              "y": 20.834,
              "z": 0.77
            },
            "rightCorner": {
              "x": 9.668,
              "y": 20.837,
              "z": 0.77
            },
            "gtin": "4004980516809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddf9",
            "leftCorner": {
              "x": 9.668,
              "y": 20.837,
              "z": 0.77
            },
            "rightCorner": {
              "x": 9.618,
              "y": 20.841,
              "z": 0.77
            },
            "gtin": "4004980516809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddfa",
            "leftCorner": {
              "x": 9.618,
              "y": 20.841,
              "z": 0.77
            },
            "rightCorner": {
              "x": 9.513,
              "y": 20.847,
              "z": 0.77
            },
            "gtin": "4004980512801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddfb",
            "leftCorner": {
              "x": 9.513,
              "y": 20.847,
              "z": 0.77
            },
            "rightCorner": {
              "x": 9.408,
              "y": 20.854,
              "z": 0.77
            },
            "gtin": "4004980512801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddfc",
            "leftCorner": {
              "x": 9.409,
              "y": 20.86,
              "z": 0.77
            },
            "rightCorner": {
              "x": 9.182,
              "y": 20.875,
              "z": 0.77
            },
            "gtin": "4004980514003",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546433",
        "height": 1.2435,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ede4",
            "leftCorner": {
              "x": 10.483,
              "y": 20.822,
              "z": 1.017
            },
            "rightCorner": {
              "x": 10.279,
              "y": 20.836,
              "z": 1.017
            },
            "gtin": "4004980509801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ede7",
            "leftCorner": {
              "x": 10.277,
              "y": 20.798,
              "z": 1.017
            },
            "rightCorner": {
              "x": 10.211,
              "y": 20.803,
              "z": 1.017
            },
            "gtin": "4004980537903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ede8",
            "leftCorner": {
              "x": 10.211,
              "y": 20.803,
              "z": 1.017
            },
            "rightCorner": {
              "x": 10.146,
              "y": 20.807,
              "z": 1.017
            },
            "gtin": "4004980537903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ede9",
            "leftCorner": {
              "x": 10.146,
              "y": 20.798,
              "z": 1.017
            },
            "rightCorner": {
              "x": 10.055,
              "y": 20.804,
              "z": 1.017
            },
            "gtin": "4004980534001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edea",
            "leftCorner": {
              "x": 10.055,
              "y": 20.804,
              "z": 1.017
            },
            "rightCorner": {
              "x": 9.965,
              "y": 20.81,
              "z": 1.017
            },
            "gtin": "4004980534001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edeb",
            "leftCorner": {
              "x": 9.966,
              "y": 20.82,
              "z": 1.017
            },
            "rightCorner": {
              "x": 9.871,
              "y": 20.826,
              "z": 1.017
            },
            "gtin": "4004980539600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edec",
            "leftCorner": {
              "x": 9.87,
              "y": 20.817,
              "z": 1.017
            },
            "rightCorner": {
              "x": 9.713,
              "y": 20.828,
              "z": 1.017
            },
            "gtin": "4004980560307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eded",
            "leftCorner": {
              "x": 9.713,
              "y": 20.832,
              "z": 1.017
            },
            "rightCorner": {
              "x": 9.582,
              "y": 20.84,
              "z": 1.017
            },
            "gtin": "4063367419348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edee",
            "leftCorner": {
              "x": 9.582,
              "y": 20.84,
              "z": 1.017
            },
            "rightCorner": {
              "x": 9.45,
              "y": 20.848,
              "z": 1.017
            },
            "gtin": "4063367419348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edef",
            "leftCorner": {
              "x": 9.451,
              "y": 20.855,
              "z": 1.017
            },
            "rightCorner": {
              "x": 9.252,
              "y": 20.869,
              "z": 1.017
            },
            "gtin": "4337185617492",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546431",
        "height": 1.4923,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1edcc",
            "leftCorner": {
              "x": 10.483,
              "y": 20.826,
              "z": 1.221
            },
            "rightCorner": {
              "x": 10.419,
              "y": 20.831,
              "z": 1.221
            },
            "gtin": "4004980530508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edcd",
            "leftCorner": {
              "x": 10.419,
              "y": 20.831,
              "z": 1.221
            },
            "rightCorner": {
              "x": 10.355,
              "y": 20.835,
              "z": 1.221
            },
            "gtin": "4004980530508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edcf",
            "leftCorner": {
              "x": 10.352,
              "y": 20.787,
              "z": 1.221
            },
            "rightCorner": {
              "x": 10.263,
              "y": 20.792,
              "z": 1.221
            },
            "gtin": "4004980409507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edd0",
            "leftCorner": {
              "x": 10.263,
              "y": 20.792,
              "z": 1.221
            },
            "rightCorner": {
              "x": 10.175,
              "y": 20.797,
              "z": 1.221
            },
            "gtin": "4004980409507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edd1",
            "leftCorner": {
              "x": 10.175,
              "y": 20.801,
              "z": 1.221
            },
            "rightCorner": {
              "x": 10.069,
              "y": 20.808,
              "z": 1.221
            },
            "gtin": "4004980536906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edd2",
            "leftCorner": {
              "x": 10.07,
              "y": 20.813,
              "z": 1.221
            },
            "rightCorner": {
              "x": 9.893,
              "y": 20.825,
              "z": 1.221
            },
            "gtin": "4004980532007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edd3",
            "leftCorner": {
              "x": 9.893,
              "y": 20.824,
              "z": 1.221
            },
            "rightCorner": {
              "x": 9.816,
              "y": 20.829,
              "z": 1.221
            },
            "gtin": "4004980400504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edd4",
            "leftCorner": {
              "x": 9.816,
              "y": 20.829,
              "z": 1.221
            },
            "rightCorner": {
              "x": 9.738,
              "y": 20.834,
              "z": 1.221
            },
            "gtin": "4004980400504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edd5",
            "leftCorner": {
              "x": 9.738,
              "y": 20.842,
              "z": 1.221
            },
            "rightCorner": {
              "x": 9.681,
              "y": 20.846,
              "z": 1.221
            },
            "gtin": "4004980535107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edd6",
            "leftCorner": {
              "x": 9.681,
              "y": 20.846,
              "z": 1.221
            },
            "rightCorner": {
              "x": 9.623,
              "y": 20.85,
              "z": 1.221
            },
            "gtin": "4004980535107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edd7",
            "leftCorner": {
              "x": 9.623,
              "y": 20.85,
              "z": 1.221
            },
            "rightCorner": {
              "x": 9.565,
              "y": 20.853,
              "z": 1.221
            },
            "gtin": "4004980535107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edd8",
            "leftCorner": {
              "x": 9.565,
              "y": 20.853,
              "z": 1.221
            },
            "rightCorner": {
              "x": 9.45,
              "y": 20.86,
              "z": 1.221
            },
            "gtin": "4018077764011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edd9",
            "leftCorner": {
              "x": 9.45,
              "y": 20.86,
              "z": 1.221
            },
            "rightCorner": {
              "x": 9.335,
              "y": 20.868,
              "z": 1.221
            },
            "gtin": "4018077764011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edda",
            "leftCorner": {
              "x": 9.335,
              "y": 20.868,
              "z": 1.221
            },
            "rightCorner": {
              "x": 9.219,
              "y": 20.875,
              "z": 1.221
            },
            "gtin": "4018077764011",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546432",
        "height": 1.7408,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1de98",
            "leftCorner": {
              "x": 10.466,
              "y": 20.781,
              "z": 1.424
            },
            "rightCorner": {
              "x": 10.379,
              "y": 20.787,
              "z": 1.424
            },
            "gtin": "4063367097737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de99",
            "leftCorner": {
              "x": 10.379,
              "y": 20.79,
              "z": 1.424
            },
            "rightCorner": {
              "x": 10.284,
              "y": 20.796,
              "z": 1.424
            },
            "gtin": "4004980613805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de9a",
            "leftCorner": {
              "x": 10.284,
              "y": 20.796,
              "z": 1.424
            },
            "rightCorner": {
              "x": 10.189,
              "y": 20.802,
              "z": 1.424
            },
            "gtin": "4004980613805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de9b",
            "leftCorner": {
              "x": 10.189,
              "y": 20.802,
              "z": 1.424
            },
            "rightCorner": {
              "x": 10.094,
              "y": 20.808,
              "z": 1.424
            },
            "gtin": "4004980613805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de9c",
            "leftCorner": {
              "x": 10.094,
              "y": 20.808,
              "z": 1.424
            },
            "rightCorner": {
              "x": 9.942,
              "y": 20.818,
              "z": 1.424
            },
            "gtin": "4004980563308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de9d",
            "leftCorner": {
              "x": 9.942,
              "y": 20.82,
              "z": 1.424
            },
            "rightCorner": {
              "x": 9.878,
              "y": 20.824,
              "z": 1.424
            },
            "gtin": "4004980511606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de9e",
            "leftCorner": {
              "x": 9.878,
              "y": 20.824,
              "z": 1.424
            },
            "rightCorner": {
              "x": 9.813,
              "y": 20.828,
              "z": 1.424
            },
            "gtin": "4004980511606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de9f",
            "leftCorner": {
              "x": 9.813,
              "y": 20.834,
              "z": 1.424
            },
            "rightCorner": {
              "x": 9.711,
              "y": 20.842,
              "z": 1.424
            },
            "gtin": "4004980507500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dea0",
            "leftCorner": {
              "x": 9.711,
              "y": 20.842,
              "z": 1.424
            },
            "rightCorner": {
              "x": 9.609,
              "y": 20.848,
              "z": 1.424
            },
            "gtin": "4004980507500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dea1",
            "leftCorner": {
              "x": 9.609,
              "y": 20.846,
              "z": 1.424
            },
            "rightCorner": {
              "x": 9.435,
              "y": 20.858,
              "z": 1.424
            },
            "gtin": "7610058213111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dea2",
            "leftCorner": {
              "x": 9.435,
              "y": 20.858,
              "z": 1.424
            },
            "rightCorner": {
              "x": 9.261,
              "y": 20.87,
              "z": 1.424
            },
            "gtin": "7610058213111",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a0d",
    "rightNeighborShelfId": "50a0f"
  },
  {
    "id": "50a0f",
    "name": "50a0f",
    "x": 9.286,
    "y": 20.908,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99946,
      "w": 0.032824
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 36
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5467d6",
        "height": 1.5,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ede1",
            "leftCorner": {
              "x": 8.828,
              "y": 20.904,
              "z": 1.227
            },
            "rightCorner": {
              "x": 8.572,
              "y": 20.92,
              "z": 1.227
            },
            "gtin": "4018077768491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ede2",
            "leftCorner": {
              "x": 8.573,
              "y": 20.935,
              "z": 1.227
            },
            "rightCorner": {
              "x": 8.363,
              "y": 20.949,
              "z": 1.227
            },
            "gtin": "4063367323478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ede3",
            "leftCorner": {
              "x": 8.363,
              "y": 20.935,
              "z": 1.227
            },
            "rightCorner": {
              "x": 8.088,
              "y": 20.952,
              "z": 1.227
            },
            "gtin": "4018077007095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edce",
            "leftCorner": {
              "x": 8.087,
              "y": 20.942,
              "z": 1.227
            },
            "rightCorner": {
              "x": 8.036,
              "y": 20.945,
              "z": 1.227
            },
            "gtin": "4018077007194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eddb",
            "leftCorner": {
              "x": 9.216,
              "y": 20.862,
              "z": 1.227
            },
            "rightCorner": {
              "x": 9.144,
              "y": 20.866,
              "z": 1.227
            },
            "gtin": "4018077760594",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eddc",
            "leftCorner": {
              "x": 9.144,
              "y": 20.866,
              "z": 1.227
            },
            "rightCorner": {
              "x": 9.072,
              "y": 20.871,
              "z": 1.227
            },
            "gtin": "4018077760594",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eddd",
            "leftCorner": {
              "x": 9.072,
              "y": 20.871,
              "z": 1.227
            },
            "rightCorner": {
              "x": 9.001,
              "y": 20.876,
              "z": 1.227
            },
            "gtin": "4018077760594",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edde",
            "leftCorner": {
              "x": 9.001,
              "y": 20.883,
              "z": 1.227
            },
            "rightCorner": {
              "x": 8.943,
              "y": 20.887,
              "z": 1.227
            },
            "gtin": "4018077010682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eddf",
            "leftCorner": {
              "x": 8.943,
              "y": 20.887,
              "z": 1.227
            },
            "rightCorner": {
              "x": 8.886,
              "y": 20.891,
              "z": 1.227
            },
            "gtin": "4018077010682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ede0",
            "leftCorner": {
              "x": 8.886,
              "y": 20.891,
              "z": 1.227
            },
            "rightCorner": {
              "x": 8.828,
              "y": 20.894,
              "z": 1.227
            },
            "gtin": "4018077010682",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467d8",
        "height": 0.14094,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dec9",
            "leftCorner": {
              "x": 9.233,
              "y": 20.874,
              "z": 0.115
            },
            "rightCorner": {
              "x": 9.062,
              "y": 20.886,
              "z": 0.115
            },
            "gtin": "4335896051970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1deca",
            "leftCorner": {
              "x": 9.062,
              "y": 20.883,
              "z": 0.115
            },
            "rightCorner": {
              "x": 8.787,
              "y": 20.9,
              "z": 0.115
            },
            "gtin": "4063367055928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1decb",
            "leftCorner": {
              "x": 8.787,
              "y": 20.9,
              "z": 0.115
            },
            "rightCorner": {
              "x": 8.513,
              "y": 20.918,
              "z": 0.115
            },
            "gtin": "4063367055928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dea9",
            "leftCorner": {
              "x": 8.513,
              "y": 20.927,
              "z": 0.115
            },
            "rightCorner": {
              "x": 8.275,
              "y": 20.942,
              "z": 0.115
            },
            "gtin": "4300175157896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1deaa",
            "leftCorner": {
              "x": 8.275,
              "y": 20.942,
              "z": 0.115
            },
            "rightCorner": {
              "x": 8.037,
              "y": 20.959,
              "z": 0.115
            },
            "gtin": "4300175157896",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467d5",
        "height": 0.64941,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a211cb",
            "leftCorner": {
              "x": 9.285,
              "y": 20.898,
              "z": 0.531
            },
            "rightCorner": {
              "x": 9.164,
              "y": 20.906,
              "z": 0.531
            },
            "gtin": "4063367024139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211cc",
            "leftCorner": {
              "x": 9.164,
              "y": 20.906,
              "z": 0.531
            },
            "rightCorner": {
              "x": 9.044,
              "y": 20.915,
              "z": 0.531
            },
            "gtin": "4063367024139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211cd",
            "leftCorner": {
              "x": 9.044,
              "y": 20.915,
              "z": 0.531
            },
            "rightCorner": {
              "x": 8.923,
              "y": 20.922,
              "z": 0.531
            },
            "gtin": "4063367024139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211ce",
            "leftCorner": {
              "x": 8.92,
              "y": 20.887,
              "z": 0.531
            },
            "rightCorner": {
              "x": 8.478,
              "y": 20.917,
              "z": 0.531
            },
            "gtin": "4063367507762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211cf",
            "leftCorner": {
              "x": 8.478,
              "y": 20.917,
              "z": 0.531
            },
            "rightCorner": {
              "x": 8.036,
              "y": 20.946,
              "z": 0.531
            },
            "gtin": "4063367507762",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467d7",
        "height": 0.94145,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1ddbd",
            "leftCorner": {
              "x": 9.177,
              "y": 20.863,
              "z": 0.77
            },
            "rightCorner": {
              "x": 8.606,
              "y": 20.9,
              "z": 0.77
            },
            "gtin": "4063367507724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddbe",
            "leftCorner": {
              "x": 8.606,
              "y": 20.9,
              "z": 0.77
            },
            "rightCorner": {
              "x": 8.035,
              "y": 20.937,
              "z": 0.77
            },
            "gtin": "4063367507724",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467d4",
        "height": 1.2525,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1edf0",
            "leftCorner": {
              "x": 9.251,
              "y": 20.861,
              "z": 1.025
            },
            "rightCorner": {
              "x": 8.815,
              "y": 20.889,
              "z": 1.025
            },
            "gtin": "4063367409295",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edf1",
            "leftCorner": {
              "x": 8.816,
              "y": 20.915,
              "z": 1.025
            },
            "rightCorner": {
              "x": 8.663,
              "y": 20.925,
              "z": 1.025
            },
            "gtin": "4063367150883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edf2",
            "leftCorner": {
              "x": 8.663,
              "y": 20.925,
              "z": 1.025
            },
            "rightCorner": {
              "x": 8.511,
              "y": 20.935,
              "z": 1.025
            },
            "gtin": "4063367150883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edf3",
            "leftCorner": {
              "x": 8.511,
              "y": 20.939,
              "z": 1.025
            },
            "rightCorner": {
              "x": 8.383,
              "y": 20.948,
              "z": 1.025
            },
            "gtin": "4003586107794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1edf4",
            "leftCorner": {
              "x": 8.383,
              "y": 20.948,
              "z": 1.025
            },
            "rightCorner": {
              "x": 8.254,
              "y": 20.957,
              "z": 1.025
            },
            "gtin": "4003586107794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ede5",
            "leftCorner": {
              "x": 8.254,
              "y": 20.944,
              "z": 1.025
            },
            "rightCorner": {
              "x": 8.145,
              "y": 20.951,
              "z": 1.025
            },
            "gtin": "4003586006714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ede6",
            "leftCorner": {
              "x": 8.145,
              "y": 20.951,
              "z": 1.025
            },
            "rightCorner": {
              "x": 8.037,
              "y": 20.958,
              "z": 1.025
            },
            "gtin": "4003586006714",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467d3",
        "height": 1.7422,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dea3",
            "leftCorner": {
              "x": 9.26,
              "y": 20.861,
              "z": 1.425
            },
            "rightCorner": {
              "x": 8.974,
              "y": 20.88,
              "z": 1.425
            },
            "gtin": "4063367409547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dea4",
            "leftCorner": {
              "x": 8.975,
              "y": 20.889,
              "z": 1.425
            },
            "rightCorner": {
              "x": 8.825,
              "y": 20.899,
              "z": 1.425
            },
            "gtin": "4335896563527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dea5",
            "leftCorner": {
              "x": 8.825,
              "y": 20.899,
              "z": 1.425
            },
            "rightCorner": {
              "x": 8.675,
              "y": 20.909,
              "z": 1.425
            },
            "gtin": "4335896563527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dea6",
            "leftCorner": {
              "x": 8.676,
              "y": 20.927,
              "z": 1.425
            },
            "rightCorner": {
              "x": 8.46,
              "y": 20.941,
              "z": 1.425
            },
            "gtin": "4335896051994",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dea7",
            "leftCorner": {
              "x": 8.46,
              "y": 20.934,
              "z": 1.425
            },
            "rightCorner": {
              "x": 8.318,
              "y": 20.943,
              "z": 1.425
            },
            "gtin": "4063367254741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dea8",
            "leftCorner": {
              "x": 8.318,
              "y": 20.943,
              "z": 1.425
            },
            "rightCorner": {
              "x": 8.176,
              "y": 20.953,
              "z": 1.425
            },
            "gtin": "4063367254741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de42",
            "leftCorner": {
              "x": 8.175,
              "y": 20.948,
              "z": 1.425
            },
            "rightCorner": {
              "x": 8.036,
              "y": 20.957,
              "z": 1.425
            },
            "gtin": "4063367254789",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a0e"
  },
  {
    "id": "50a10",
    "name": "50a10",
    "x": 19.028,
    "y": 23.129,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99914,
      "w": 0.041492
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546814",
        "height": 0.14253,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21112",
            "leftCorner": {
              "x": 18.951,
              "y": 23.082,
              "z": 0.117
            },
            "rightCorner": {
              "x": 18.359,
              "y": 23.132,
              "z": 0.117
            },
            "gtin": "4009176339521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21113",
            "leftCorner": {
              "x": 18.359,
              "y": 23.128,
              "z": 0.117
            },
            "rightCorner": {
              "x": 18.157,
              "y": 23.144,
              "z": 0.117
            },
            "gtin": "7613035499478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21114",
            "leftCorner": {
              "x": 18.157,
              "y": 23.144,
              "z": 0.117
            },
            "rightCorner": {
              "x": 17.956,
              "y": 23.161,
              "z": 0.117
            },
            "gtin": "7613035499478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21115",
            "leftCorner": {
              "x": 17.956,
              "y": 23.161,
              "z": 0.117
            },
            "rightCorner": {
              "x": 17.755,
              "y": 23.178,
              "z": 0.117
            },
            "gtin": "7613035499478",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546812",
        "height": 0.49394,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2107c",
            "leftCorner": {
              "x": 18.967,
              "y": 23.084,
              "z": 0.404
            },
            "rightCorner": {
              "x": 18.617,
              "y": 23.114,
              "z": 0.404
            },
            "gtin": "4014400934045",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8b5ed67a01d9a2107d",
            "leftCorner": {
              "x": 18.616,
              "y": 23.103,
              "z": 0.404
            },
            "rightCorner": {
              "x": 17.778,
              "y": 23.172,
              "z": 0.404
            },
            "gtin": "4009176339545",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546813",
        "height": 0.8451,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21274",
            "leftCorner": {
              "x": 18.976,
              "y": 23.094,
              "z": 0.691
            },
            "rightCorner": {
              "x": 18.793,
              "y": 23.11,
              "z": 0.691
            },
            "gtin": "4063367211461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21275",
            "leftCorner": {
              "x": 18.793,
              "y": 23.102,
              "z": 0.691
            },
            "rightCorner": {
              "x": 18.648,
              "y": 23.114,
              "z": 0.691
            },
            "gtin": "4035800407007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21276",
            "leftCorner": {
              "x": 18.648,
              "y": 23.114,
              "z": 0.691
            },
            "rightCorner": {
              "x": 18.247,
              "y": 23.147,
              "z": 0.691
            },
            "gtin": "4009371246013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21277",
            "leftCorner": {
              "x": 18.247,
              "y": 23.147,
              "z": 0.691
            },
            "rightCorner": {
              "x": 17.846,
              "y": 23.18,
              "z": 0.691
            },
            "gtin": "4009371246013",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54680f",
        "height": 1.1931,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21232",
            "leftCorner": {
              "x": 19.02,
              "y": 23.07,
              "z": 0.976
            },
            "rightCorner": {
              "x": 18.669,
              "y": 23.1,
              "z": 0.976
            },
            "gtin": "4009176339569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21233",
            "leftCorner": {
              "x": 18.669,
              "y": 23.111,
              "z": 0.976
            },
            "rightCorner": {
              "x": 18.382,
              "y": 23.134,
              "z": 0.976
            },
            "gtin": "4018356004715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21234",
            "leftCorner": {
              "x": 18.382,
              "y": 23.134,
              "z": 0.976
            },
            "rightCorner": {
              "x": 18.095,
              "y": 23.158,
              "z": 0.976
            },
            "gtin": "4018356004715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21235",
            "leftCorner": {
              "x": 18.095,
              "y": 23.148,
              "z": 0.976
            },
            "rightCorner": {
              "x": 17.971,
              "y": 23.158,
              "z": 0.976
            },
            "gtin": "4018356009703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21236",
            "leftCorner": {
              "x": 17.971,
              "y": 23.158,
              "z": 0.976
            },
            "rightCorner": {
              "x": 17.848,
              "y": 23.168,
              "z": 0.976
            },
            "gtin": "4018356009703",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546811",
        "height": 1.4985,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21244",
            "leftCorner": {
              "x": 19.019,
              "y": 23.078,
              "z": 1.226
            },
            "rightCorner": {
              "x": 18.773,
              "y": 23.099,
              "z": 1.226
            },
            "gtin": "4018356004722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21245",
            "leftCorner": {
              "x": 18.773,
              "y": 23.099,
              "z": 1.226
            },
            "rightCorner": {
              "x": 18.527,
              "y": 23.119,
              "z": 1.226
            },
            "gtin": "4018356004722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21246",
            "leftCorner": {
              "x": 18.527,
              "y": 23.127,
              "z": 1.226
            },
            "rightCorner": {
              "x": 18.185,
              "y": 23.156,
              "z": 1.226
            },
            "gtin": "4018356004708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21247",
            "leftCorner": {
              "x": 18.185,
              "y": 23.156,
              "z": 1.226
            },
            "rightCorner": {
              "x": 17.844,
              "y": 23.184,
              "z": 1.226
            },
            "gtin": "4018356004708",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546810",
        "height": 1.7472,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21169",
            "leftCorner": {
              "x": 19.016,
              "y": 23.084,
              "z": 1.43
            },
            "rightCorner": {
              "x": 18.709,
              "y": 23.109,
              "z": 1.43
            },
            "gtin": "4004363000390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2116a",
            "leftCorner": {
              "x": 18.71,
              "y": 23.112,
              "z": 1.43
            },
            "rightCorner": {
              "x": 18.568,
              "y": 23.124,
              "z": 1.43
            },
            "gtin": "4004363101332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2116b",
            "leftCorner": {
              "x": 18.568,
              "y": 23.124,
              "z": 1.43
            },
            "rightCorner": {
              "x": 18.425,
              "y": 23.136,
              "z": 1.43
            },
            "gtin": "4004363101332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2116c",
            "leftCorner": {
              "x": 18.427,
              "y": 23.146,
              "z": 1.43
            },
            "rightCorner": {
              "x": 18.08,
              "y": 23.175,
              "z": 1.43
            },
            "gtin": "4004363101363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2116d",
            "leftCorner": {
              "x": 18.079,
              "y": 23.164,
              "z": 1.43
            },
            "rightCorner": {
              "x": 17.783,
              "y": 23.189,
              "z": 1.43
            },
            "gtin": "4000281480504",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d1349",
    "rightNeighborShelfId": "50a11"
  },
  {
    "id": "50a11",
    "name": "50a11",
    "x": 17.832,
    "y": 23.229,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99914,
      "w": 0.041492
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 51
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54681a",
        "height": 0.14464,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21116",
            "leftCorner": {
              "x": 17.754,
              "y": 23.179,
              "z": 0.118
            },
            "rightCorner": {
              "x": 17.607,
              "y": 23.192,
              "z": 0.118
            },
            "gtin": "7613035499652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21117",
            "leftCorner": {
              "x": 17.607,
              "y": 23.192,
              "z": 0.118
            },
            "rightCorner": {
              "x": 17.458,
              "y": 23.203,
              "z": 0.118
            },
            "gtin": "7613035499652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21118",
            "leftCorner": {
              "x": 17.458,
              "y": 23.203,
              "z": 0.118
            },
            "rightCorner": {
              "x": 17.311,
              "y": 23.216,
              "z": 0.118
            },
            "gtin": "7613035499652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21119",
            "leftCorner": {
              "x": 17.31,
              "y": 23.212,
              "z": 0.118
            },
            "rightCorner": {
              "x": 16.925,
              "y": 23.244,
              "z": 0.118
            },
            "gtin": "7613039875827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2111a",
            "leftCorner": {
              "x": 16.925,
              "y": 23.244,
              "z": 0.118
            },
            "rightCorner": {
              "x": 16.54,
              "y": 23.276,
              "z": 0.118
            },
            "gtin": "7613039875827",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546818",
        "height": 0.49266,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2107e",
            "leftCorner": {
              "x": 17.778,
              "y": 23.174,
              "z": 0.403
            },
            "rightCorner": {
              "x": 17.625,
              "y": 23.187,
              "z": 0.403
            },
            "gtin": "7613039891216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2107f",
            "leftCorner": {
              "x": 17.625,
              "y": 23.187,
              "z": 0.403
            },
            "rightCorner": {
              "x": 17.47,
              "y": 23.199,
              "z": 0.403
            },
            "gtin": "7613039891216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21080",
            "leftCorner": {
              "x": 17.47,
              "y": 23.199,
              "z": 0.403
            },
            "rightCorner": {
              "x": 17.316,
              "y": 23.212,
              "z": 0.403
            },
            "gtin": "7613039891216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21081",
            "leftCorner": {
              "x": 17.316,
              "y": 23.212,
              "z": 0.403
            },
            "rightCorner": {
              "x": 17.163,
              "y": 23.225,
              "z": 0.403
            },
            "gtin": "7613039891216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21082",
            "leftCorner": {
              "x": 17.163,
              "y": 23.23,
              "z": 0.403
            },
            "rightCorner": {
              "x": 17.005,
              "y": 23.243,
              "z": 0.403
            },
            "gtin": "8445290982452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21083",
            "leftCorner": {
              "x": 17.005,
              "y": 23.243,
              "z": 0.403
            },
            "rightCorner": {
              "x": 16.847,
              "y": 23.255,
              "z": 0.403
            },
            "gtin": "8445290982452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21084",
            "leftCorner": {
              "x": 16.847,
              "y": 23.255,
              "z": 0.403
            },
            "rightCorner": {
              "x": 16.689,
              "y": 23.268,
              "z": 0.403
            },
            "gtin": "8445290982452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21085",
            "leftCorner": {
              "x": 16.689,
              "y": 23.268,
              "z": 0.403
            },
            "rightCorner": {
              "x": 16.531,
              "y": 23.281,
              "z": 0.403
            },
            "gtin": "8445290982452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21086",
            "leftCorner": {
              "x": 16.531,
              "y": 23.281,
              "z": 0.403
            },
            "rightCorner": {
              "x": 16.373,
              "y": 23.295,
              "z": 0.403
            },
            "gtin": "8445290982452",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546815",
        "height": 0.84367,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21278",
            "leftCorner": {
              "x": 17.846,
              "y": 23.182,
              "z": 0.69
            },
            "rightCorner": {
              "x": 17.701,
              "y": 23.194,
              "z": 0.69
            },
            "gtin": "4337185609077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21279",
            "leftCorner": {
              "x": 17.701,
              "y": 23.198,
              "z": 0.69
            },
            "rightCorner": {
              "x": 17.467,
              "y": 23.217,
              "z": 0.69
            },
            "gtin": "4337185609114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2127a",
            "leftCorner": {
              "x": 17.467,
              "y": 23.217,
              "z": 0.69
            },
            "rightCorner": {
              "x": 17.232,
              "y": 23.236,
              "z": 0.69
            },
            "gtin": "4337185609114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2127b",
            "leftCorner": {
              "x": 17.233,
              "y": 23.252,
              "z": 0.69
            },
            "rightCorner": {
              "x": 17.065,
              "y": 23.266,
              "z": 0.69
            },
            "gtin": "4337185609091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2127c",
            "leftCorner": {
              "x": 17.064,
              "y": 23.256,
              "z": 0.69
            },
            "rightCorner": {
              "x": 16.916,
              "y": 23.269,
              "z": 0.69
            },
            "gtin": "4337185628542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2127d",
            "leftCorner": {
              "x": 16.916,
              "y": 23.269,
              "z": 0.69
            },
            "rightCorner": {
              "x": 16.767,
              "y": 23.281,
              "z": 0.69
            },
            "gtin": "4337185628542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2127e",
            "leftCorner": {
              "x": 16.767,
              "y": 23.281,
              "z": 0.69
            },
            "rightCorner": {
              "x": 16.619,
              "y": 23.293,
              "z": 0.69
            },
            "gtin": "4337185628542",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546816",
        "height": 1.2011,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21237",
            "leftCorner": {
              "x": 17.85,
              "y": 23.186,
              "z": 0.983
            },
            "rightCorner": {
              "x": 17.748,
              "y": 23.194,
              "z": 0.983
            },
            "gtin": "4000417652508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21238",
            "leftCorner": {
              "x": 17.748,
              "y": 23.189,
              "z": 0.983
            },
            "rightCorner": {
              "x": 17.684,
              "y": 23.195,
              "z": 0.983
            },
            "gtin": "4000417652409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21239",
            "leftCorner": {
              "x": 17.684,
              "y": 23.195,
              "z": 0.983
            },
            "rightCorner": {
              "x": 17.62,
              "y": 23.2,
              "z": 0.983
            },
            "gtin": "4000417652409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2123a",
            "leftCorner": {
              "x": 17.62,
              "y": 23.2,
              "z": 0.983
            },
            "rightCorner": {
              "x": 17.557,
              "y": 23.205,
              "z": 0.983
            },
            "gtin": "4000417652409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2123b",
            "leftCorner": {
              "x": 17.557,
              "y": 23.205,
              "z": 0.983
            },
            "rightCorner": {
              "x": 17.494,
              "y": 23.211,
              "z": 0.983
            },
            "gtin": "4000417652409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2123c",
            "leftCorner": {
              "x": 17.494,
              "y": 23.21,
              "z": 0.983
            },
            "rightCorner": {
              "x": 17.396,
              "y": 23.218,
              "z": 0.983
            },
            "gtin": "4000417652607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2123d",
            "leftCorner": {
              "x": 17.396,
              "y": 23.218,
              "z": 0.983
            },
            "rightCorner": {
              "x": 17.297,
              "y": 23.226,
              "z": 0.983
            },
            "gtin": "4000417652607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2123e",
            "leftCorner": {
              "x": 17.297,
              "y": 23.229,
              "z": 0.983
            },
            "rightCorner": {
              "x": 17.169,
              "y": 23.239,
              "z": 0.983
            },
            "gtin": "4000417652706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2123f",
            "leftCorner": {
              "x": 17.169,
              "y": 23.238,
              "z": 0.983
            },
            "rightCorner": {
              "x": 17.019,
              "y": 23.251,
              "z": 0.983
            },
            "gtin": "4000417117304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21240",
            "leftCorner": {
              "x": 17.019,
              "y": 23.251,
              "z": 0.983
            },
            "rightCorner": {
              "x": 16.958,
              "y": 23.256,
              "z": 0.983
            },
            "gtin": "4000417119605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21241",
            "leftCorner": {
              "x": 16.958,
              "y": 23.256,
              "z": 0.983
            },
            "rightCorner": {
              "x": 16.896,
              "y": 23.262,
              "z": 0.983
            },
            "gtin": "4000417119605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21242",
            "leftCorner": {
              "x": 16.896,
              "y": 23.262,
              "z": 0.983
            },
            "rightCorner": {
              "x": 16.836,
              "y": 23.267,
              "z": 0.983
            },
            "gtin": "4000417119605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21229",
            "leftCorner": {
              "x": 16.836,
              "y": 23.274,
              "z": 0.983
            },
            "rightCorner": {
              "x": 16.734,
              "y": 23.282,
              "z": 0.983
            },
            "gtin": "4000417113207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2122a",
            "leftCorner": {
              "x": 16.734,
              "y": 23.282,
              "z": 0.983
            },
            "rightCorner": {
              "x": 16.633,
              "y": 23.29,
              "z": 0.983
            },
            "gtin": "4000417113207",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546817",
        "height": 1.5028,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21248",
            "leftCorner": {
              "x": 17.843,
              "y": 23.18,
              "z": 1.23
            },
            "rightCorner": {
              "x": 17.654,
              "y": 23.196,
              "z": 1.23
            },
            "gtin": "4003754266445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21249",
            "leftCorner": {
              "x": 17.654,
              "y": 23.199,
              "z": 1.23
            },
            "rightCorner": {
              "x": 17.541,
              "y": 23.209,
              "z": 1.23
            },
            "gtin": "5425007882612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2124a",
            "leftCorner": {
              "x": 17.541,
              "y": 23.209,
              "z": 1.23
            },
            "rightCorner": {
              "x": 17.427,
              "y": 23.218,
              "z": 1.23
            },
            "gtin": "5425007882612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2124b",
            "leftCorner": {
              "x": 17.427,
              "y": 23.218,
              "z": 1.23
            },
            "rightCorner": {
              "x": 17.338,
              "y": 23.226,
              "z": 1.23
            },
            "gtin": "5425007885019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2124c",
            "leftCorner": {
              "x": 17.338,
              "y": 23.226,
              "z": 1.23
            },
            "rightCorner": {
              "x": 17.249,
              "y": 23.232,
              "z": 1.23
            },
            "gtin": "5425007885019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2124d",
            "leftCorner": {
              "x": 17.251,
              "y": 23.251,
              "z": 1.23
            },
            "rightCorner": {
              "x": 17.087,
              "y": 23.265,
              "z": 1.23
            },
            "gtin": "5425007885026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2124e",
            "leftCorner": {
              "x": 17.085,
              "y": 23.244,
              "z": 1.23
            },
            "rightCorner": {
              "x": 16.624,
              "y": 23.283,
              "z": 1.23
            },
            "gtin": "4000956024606",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546819",
        "height": 1.7514,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2116e",
            "leftCorner": {
              "x": 17.783,
              "y": 23.186,
              "z": 1.433
            },
            "rightCorner": {
              "x": 17.66,
              "y": 23.197,
              "z": 1.433
            },
            "gtin": "8000300404821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2116f",
            "leftCorner": {
              "x": 17.66,
              "y": 23.197,
              "z": 1.433
            },
            "rightCorner": {
              "x": 17.537,
              "y": 23.207,
              "z": 1.433
            },
            "gtin": "8000300404821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21170",
            "leftCorner": {
              "x": 17.536,
              "y": 23.198,
              "z": 1.433
            },
            "rightCorner": {
              "x": 17.241,
              "y": 23.223,
              "z": 1.433
            },
            "gtin": "3800020441718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21171",
            "leftCorner": {
              "x": 17.241,
              "y": 23.23,
              "z": 1.433
            },
            "rightCorner": {
              "x": 17.037,
              "y": 23.246,
              "z": 1.433
            },
            "gtin": "4000281481501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21172",
            "leftCorner": {
              "x": 17.037,
              "y": 23.256,
              "z": 1.433
            },
            "rightCorner": {
              "x": 16.993,
              "y": 23.259,
              "z": 1.433
            },
            "gtin": "8585047314072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21173",
            "leftCorner": {
              "x": 16.993,
              "y": 23.259,
              "z": 1.433
            },
            "rightCorner": {
              "x": 16.95,
              "y": 23.264,
              "z": 1.433
            },
            "gtin": "8585047314072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21174",
            "leftCorner": {
              "x": 16.95,
              "y": 23.264,
              "z": 1.433
            },
            "rightCorner": {
              "x": 16.905,
              "y": 23.267,
              "z": 1.433
            },
            "gtin": "8585047314072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21175",
            "leftCorner": {
              "x": 16.905,
              "y": 23.267,
              "z": 1.433
            },
            "rightCorner": {
              "x": 16.77,
              "y": 23.278,
              "z": 1.433
            },
            "gtin": "4006894103809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21176",
            "leftCorner": {
              "x": 16.77,
              "y": 23.282,
              "z": 1.433
            },
            "rightCorner": {
              "x": 16.603,
              "y": 23.296,
              "z": 1.433
            },
            "gtin": "4014303126639",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a10",
    "rightNeighborShelfId": "50a12"
  },
  {
    "id": "50a12",
    "name": "50a12",
    "x": 16.636,
    "y": 23.328,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99914,
      "w": 0.041492
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 56
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54681f",
        "height": 0.14722,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2111b",
            "leftCorner": {
              "x": 16.54,
              "y": 23.269,
              "z": 0.12
            },
            "rightCorner": {
              "x": 16.342,
              "y": 23.285,
              "z": 0.12
            },
            "gtin": "4006894134605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2111c",
            "leftCorner": {
              "x": 16.342,
              "y": 23.285,
              "z": 0.12
            },
            "rightCorner": {
              "x": 16.144,
              "y": 23.302,
              "z": 0.12
            },
            "gtin": "4006894134605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2111d",
            "leftCorner": {
              "x": 16.144,
              "y": 23.3,
              "z": 0.12
            },
            "rightCorner": {
              "x": 16.026,
              "y": 23.31,
              "z": 0.12
            },
            "gtin": "4006894134704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2111e",
            "leftCorner": {
              "x": 16.026,
              "y": 23.31,
              "z": 0.12
            },
            "rightCorner": {
              "x": 15.91,
              "y": 23.32,
              "z": 0.12
            },
            "gtin": "4006894134704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2111f",
            "leftCorner": {
              "x": 15.91,
              "y": 23.317,
              "z": 0.12
            },
            "rightCorner": {
              "x": 15.75,
              "y": 23.33,
              "z": 0.12
            },
            "gtin": "4063367183744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21120",
            "leftCorner": {
              "x": 15.75,
              "y": 23.33,
              "z": 0.12
            },
            "rightCorner": {
              "x": 15.592,
              "y": 23.343,
              "z": 0.12
            },
            "gtin": "4063367183744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21121",
            "leftCorner": {
              "x": 15.592,
              "y": 23.343,
              "z": 0.12
            },
            "rightCorner": {
              "x": 15.432,
              "y": 23.357,
              "z": 0.12
            },
            "gtin": "4063367183744",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546820",
        "height": 0.50034,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21087",
            "leftCorner": {
              "x": 16.373,
              "y": 23.295,
              "z": 0.409
            },
            "rightCorner": {
              "x": 16.202,
              "y": 23.31,
              "z": 0.409
            },
            "gtin": "5410291030030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21088",
            "leftCorner": {
              "x": 16.202,
              "y": 23.31,
              "z": 0.409
            },
            "rightCorner": {
              "x": 16.031,
              "y": 23.323,
              "z": 0.409
            },
            "gtin": "5410291030030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21089",
            "leftCorner": {
              "x": 16.029,
              "y": 23.31,
              "z": 0.409
            },
            "rightCorner": {
              "x": 15.888,
              "y": 23.321,
              "z": 0.409
            },
            "gtin": "4063367394959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2108a",
            "leftCorner": {
              "x": 15.888,
              "y": 23.326,
              "z": 0.409
            },
            "rightCorner": {
              "x": 15.765,
              "y": 23.337,
              "z": 0.409
            },
            "gtin": "4063367394973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2108b",
            "leftCorner": {
              "x": 15.765,
              "y": 23.337,
              "z": 0.409
            },
            "rightCorner": {
              "x": 15.641,
              "y": 23.347,
              "z": 0.409
            },
            "gtin": "4063367394973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2108c",
            "leftCorner": {
              "x": 15.641,
              "y": 23.347,
              "z": 0.409
            },
            "rightCorner": {
              "x": 15.518,
              "y": 23.358,
              "z": 0.409
            },
            "gtin": "4063367394973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2108d",
            "leftCorner": {
              "x": 15.518,
              "y": 23.368,
              "z": 0.409
            },
            "rightCorner": {
              "x": 15.446,
              "y": 23.374,
              "z": 0.409
            },
            "gtin": "654542666813",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54681b",
        "height": 0.85184,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2127f",
            "leftCorner": {
              "x": 16.618,
              "y": 23.281,
              "z": 0.697
            },
            "rightCorner": {
              "x": 16.479,
              "y": 23.293,
              "z": 0.697
            },
            "gtin": "4337185633423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21280",
            "leftCorner": {
              "x": 16.479,
              "y": 23.293,
              "z": 0.697
            },
            "rightCorner": {
              "x": 16.34,
              "y": 23.305,
              "z": 0.697
            },
            "gtin": "4337185633423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21281",
            "leftCorner": {
              "x": 16.339,
              "y": 23.292,
              "z": 0.697
            },
            "rightCorner": {
              "x": 16.275,
              "y": 23.298,
              "z": 0.697
            },
            "gtin": "4063367395581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21282",
            "leftCorner": {
              "x": 16.275,
              "y": 23.298,
              "z": 0.697
            },
            "rightCorner": {
              "x": 16.211,
              "y": 23.303,
              "z": 0.697
            },
            "gtin": "4063367395581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21283",
            "leftCorner": {
              "x": 16.211,
              "y": 23.303,
              "z": 0.697
            },
            "rightCorner": {
              "x": 16.148,
              "y": 23.308,
              "z": 0.697
            },
            "gtin": "4063367395581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21284",
            "leftCorner": {
              "x": 16.148,
              "y": 23.307,
              "z": 0.697
            },
            "rightCorner": {
              "x": 15.957,
              "y": 23.323,
              "z": 0.697
            },
            "gtin": "4337185834653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21285",
            "leftCorner": {
              "x": 15.957,
              "y": 23.318,
              "z": 0.697
            },
            "rightCorner": {
              "x": 15.77,
              "y": 23.333,
              "z": 0.697
            },
            "gtin": "4337185834677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21286",
            "leftCorner": {
              "x": 15.77,
              "y": 23.333,
              "z": 0.697
            },
            "rightCorner": {
              "x": 15.585,
              "y": 23.348,
              "z": 0.697
            },
            "gtin": "4337185834677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21287",
            "leftCorner": {
              "x": 15.585,
              "y": 23.348,
              "z": 0.697
            },
            "rightCorner": {
              "x": 15.4,
              "y": 23.364,
              "z": 0.697
            },
            "gtin": "4337185834677",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54681e",
        "height": 1.2244,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21292",
            "leftCorner": {
              "x": 16.634,
              "y": 23.303,
              "z": 1.002
            },
            "rightCorner": {
              "x": 16.506,
              "y": 23.315,
              "z": 1.002
            },
            "gtin": "4006894273007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21293",
            "leftCorner": {
              "x": 16.506,
              "y": 23.315,
              "z": 1.002
            },
            "rightCorner": {
              "x": 16.377,
              "y": 23.325,
              "z": 1.002
            },
            "gtin": "4006894273007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21296",
            "leftCorner": {
              "x": 16.374,
              "y": 23.291,
              "z": 1.002
            },
            "rightCorner": {
              "x": 16.273,
              "y": 23.299,
              "z": 1.002
            },
            "gtin": "4337185635625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21297",
            "leftCorner": {
              "x": 16.273,
              "y": 23.299,
              "z": 1.002
            },
            "rightCorner": {
              "x": 16.172,
              "y": 23.308,
              "z": 1.002
            },
            "gtin": "4337185635625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21298",
            "leftCorner": {
              "x": 16.172,
              "y": 23.308,
              "z": 1.002
            },
            "rightCorner": {
              "x": 16.071,
              "y": 23.316,
              "z": 1.002
            },
            "gtin": "4337185635625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21299",
            "leftCorner": {
              "x": 16.071,
              "y": 23.311,
              "z": 1.002
            },
            "rightCorner": {
              "x": 15.893,
              "y": 23.326,
              "z": 1.002
            },
            "gtin": "4337185635595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2129a",
            "leftCorner": {
              "x": 15.893,
              "y": 23.326,
              "z": 1.002
            },
            "rightCorner": {
              "x": 15.716,
              "y": 23.341,
              "z": 1.002
            },
            "gtin": "4337185635595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21294",
            "leftCorner": {
              "x": 15.716,
              "y": 23.34,
              "z": 1.002
            },
            "rightCorner": {
              "x": 15.575,
              "y": 23.351,
              "z": 1.002
            },
            "gtin": "4337185785382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21295",
            "leftCorner": {
              "x": 15.575,
              "y": 23.351,
              "z": 1.002
            },
            "rightCorner": {
              "x": 15.435,
              "y": 23.362,
              "z": 1.002
            },
            "gtin": "4337185785382",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54681c",
        "height": 1.5024,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2124f",
            "leftCorner": {
              "x": 16.625,
              "y": 23.284,
              "z": 1.229
            },
            "rightCorner": {
              "x": 16.515,
              "y": 23.292,
              "z": 1.229
            },
            "gtin": "8010939621162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21250",
            "leftCorner": {
              "x": 16.515,
              "y": 23.282,
              "z": 1.229
            },
            "rightCorner": {
              "x": 16.451,
              "y": 23.287,
              "z": 1.229
            },
            "gtin": "8010939621179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21251",
            "leftCorner": {
              "x": 16.451,
              "y": 23.287,
              "z": 1.229
            },
            "rightCorner": {
              "x": 16.387,
              "y": 23.292,
              "z": 1.229
            },
            "gtin": "8010939621179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21252",
            "leftCorner": {
              "x": 16.387,
              "y": 23.292,
              "z": 1.229
            },
            "rightCorner": {
              "x": 16.323,
              "y": 23.298,
              "z": 1.229
            },
            "gtin": "8010939621179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21253",
            "leftCorner": {
              "x": 16.324,
              "y": 23.308,
              "z": 1.229
            },
            "rightCorner": {
              "x": 16.117,
              "y": 23.325,
              "z": 1.229
            },
            "gtin": "8010939621155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21254",
            "leftCorner": {
              "x": 16.116,
              "y": 23.313,
              "z": 1.229
            },
            "rightCorner": {
              "x": 16.043,
              "y": 23.319,
              "z": 1.229
            },
            "gtin": "5099872017051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21255",
            "leftCorner": {
              "x": 16.043,
              "y": 23.319,
              "z": 1.229
            },
            "rightCorner": {
              "x": 15.97,
              "y": 23.326,
              "z": 1.229
            },
            "gtin": "5099872017051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21256",
            "leftCorner": {
              "x": 15.97,
              "y": 23.326,
              "z": 1.229
            },
            "rightCorner": {
              "x": 15.897,
              "y": 23.332,
              "z": 1.229
            },
            "gtin": "5099872017051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21257",
            "leftCorner": {
              "x": 15.897,
              "y": 23.335,
              "z": 1.229
            },
            "rightCorner": {
              "x": 15.807,
              "y": 23.343,
              "z": 1.229
            },
            "gtin": "5099872016528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21258",
            "leftCorner": {
              "x": 15.807,
              "y": 23.343,
              "z": 1.229
            },
            "rightCorner": {
              "x": 15.717,
              "y": 23.35,
              "z": 1.229
            },
            "gtin": "5099872016528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21259",
            "leftCorner": {
              "x": 15.717,
              "y": 23.349,
              "z": 1.229
            },
            "rightCorner": {
              "x": 15.652,
              "y": 23.354,
              "z": 1.229
            },
            "gtin": "5099872013206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2125a",
            "leftCorner": {
              "x": 15.652,
              "y": 23.354,
              "z": 1.229
            },
            "rightCorner": {
              "x": 15.585,
              "y": 23.361,
              "z": 1.229
            },
            "gtin": "5099872013206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2125b",
            "leftCorner": {
              "x": 15.585,
              "y": 23.361,
              "z": 1.229
            },
            "rightCorner": {
              "x": 15.486,
              "y": 23.368,
              "z": 1.229
            },
            "gtin": "5099872018003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2125c",
            "leftCorner": {
              "x": 15.486,
              "y": 23.368,
              "z": 1.229
            },
            "rightCorner": {
              "x": 15.386,
              "y": 23.377,
              "z": 1.229
            },
            "gtin": "5099872018003",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54681d",
        "height": 1.7532,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21177",
            "leftCorner": {
              "x": 16.602,
              "y": 23.282,
              "z": 1.434
            },
            "rightCorner": {
              "x": 16.47,
              "y": 23.293,
              "z": 1.434
            },
            "gtin": "4014303124598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21178",
            "leftCorner": {
              "x": 16.47,
              "y": 23.291,
              "z": 1.434
            },
            "rightCorner": {
              "x": 16.404,
              "y": 23.296,
              "z": 1.434
            },
            "gtin": "4014303121993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21179",
            "leftCorner": {
              "x": 16.404,
              "y": 23.296,
              "z": 1.434
            },
            "rightCorner": {
              "x": 16.339,
              "y": 23.302,
              "z": 1.434
            },
            "gtin": "4014303121993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2117a",
            "leftCorner": {
              "x": 16.339,
              "y": 23.302,
              "z": 1.434
            },
            "rightCorner": {
              "x": 16.274,
              "y": 23.307,
              "z": 1.434
            },
            "gtin": "4014303121993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2117b",
            "leftCorner": {
              "x": 16.274,
              "y": 23.303,
              "z": 1.434
            },
            "rightCorner": {
              "x": 16.164,
              "y": 23.312,
              "z": 1.434
            },
            "gtin": "4014303121757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2117c",
            "leftCorner": {
              "x": 16.164,
              "y": 23.312,
              "z": 1.434
            },
            "rightCorner": {
              "x": 16.055,
              "y": 23.321,
              "z": 1.434
            },
            "gtin": "4014303121757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2117d",
            "leftCorner": {
              "x": 16.055,
              "y": 23.321,
              "z": 1.434
            },
            "rightCorner": {
              "x": 15.947,
              "y": 23.331,
              "z": 1.434
            },
            "gtin": "4014303121757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2117e",
            "leftCorner": {
              "x": 15.947,
              "y": 23.331,
              "z": 1.434
            },
            "rightCorner": {
              "x": 15.838,
              "y": 23.34,
              "z": 1.434
            },
            "gtin": "4014303121757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2117f",
            "leftCorner": {
              "x": 15.837,
              "y": 23.331,
              "z": 1.434
            },
            "rightCorner": {
              "x": 15.735,
              "y": 23.34,
              "z": 1.434
            },
            "gtin": "4014303122334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21180",
            "leftCorner": {
              "x": 15.735,
              "y": 23.34,
              "z": 1.434
            },
            "rightCorner": {
              "x": 15.632,
              "y": 23.348,
              "z": 1.434
            },
            "gtin": "4014303122334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21181",
            "leftCorner": {
              "x": 15.634,
              "y": 23.358,
              "z": 1.434
            },
            "rightCorner": {
              "x": 15.382,
              "y": 23.379,
              "z": 1.434
            },
            "gtin": "4014303121955",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a11",
    "rightNeighborShelfId": "50a13"
  },
  {
    "id": "50a13",
    "name": "50a13",
    "x": 15.44,
    "y": 23.428,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99914,
      "w": 0.041492
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 55
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546824",
        "height": 0.14821,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21122",
            "leftCorner": {
              "x": 15.434,
              "y": 23.382,
              "z": 0.121
            },
            "rightCorner": {
              "x": 15.351,
              "y": 23.389,
              "z": 0.121
            },
            "gtin": "4007803815608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21123",
            "leftCorner": {
              "x": 15.351,
              "y": 23.389,
              "z": 0.121
            },
            "rightCorner": {
              "x": 15.268,
              "y": 23.397,
              "z": 0.121
            },
            "gtin": "4007803815608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21124",
            "leftCorner": {
              "x": 15.268,
              "y": 23.397,
              "z": 0.121
            },
            "rightCorner": {
              "x": 15.185,
              "y": 23.403,
              "z": 0.121
            },
            "gtin": "4007803815608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21125",
            "leftCorner": {
              "x": 15.184,
              "y": 23.399,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.887,
              "y": 23.424,
              "z": 0.121
            },
            "gtin": "4003006133853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21126",
            "leftCorner": {
              "x": 14.887,
              "y": 23.422,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.647,
              "y": 23.442,
              "z": 0.121
            },
            "gtin": "4000607432101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21127",
            "leftCorner": {
              "x": 14.647,
              "y": 23.442,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.409,
              "y": 23.462,
              "z": 0.121
            },
            "gtin": "4000607432101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21128",
            "leftCorner": {
              "x": 14.409,
              "y": 23.462,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.171,
              "y": 23.482,
              "z": 0.121
            },
            "gtin": "4000607432101",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546822",
        "height": 0.49119,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2108e",
            "leftCorner": {
              "x": 15.445,
              "y": 23.371,
              "z": 0.402
            },
            "rightCorner": {
              "x": 15.358,
              "y": 23.378,
              "z": 0.402
            },
            "gtin": "4337185664038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2108f",
            "leftCorner": {
              "x": 15.358,
              "y": 23.383,
              "z": 0.402
            },
            "rightCorner": {
              "x": 15.271,
              "y": 23.391,
              "z": 0.402
            },
            "gtin": "4337185664014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21090",
            "leftCorner": {
              "x": 15.271,
              "y": 23.391,
              "z": 0.402
            },
            "rightCorner": {
              "x": 15.184,
              "y": 23.398,
              "z": 0.402
            },
            "gtin": "4337185664014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21091",
            "leftCorner": {
              "x": 15.183,
              "y": 23.395,
              "z": 0.402
            },
            "rightCorner": {
              "x": 15.115,
              "y": 23.401,
              "z": 0.402
            },
            "gtin": "4000607483301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21092",
            "leftCorner": {
              "x": 15.115,
              "y": 23.401,
              "z": 0.402
            },
            "rightCorner": {
              "x": 15.045,
              "y": 23.407,
              "z": 0.402
            },
            "gtin": "4000607483301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21093",
            "leftCorner": {
              "x": 15.045,
              "y": 23.409,
              "z": 0.402
            },
            "rightCorner": {
              "x": 14.966,
              "y": 23.416,
              "z": 0.402
            },
            "gtin": "4000607477409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21094",
            "leftCorner": {
              "x": 14.966,
              "y": 23.416,
              "z": 0.402
            },
            "rightCorner": {
              "x": 14.888,
              "y": 23.423,
              "z": 0.402
            },
            "gtin": "4000607477409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21095",
            "leftCorner": {
              "x": 14.888,
              "y": 23.422,
              "z": 0.402
            },
            "rightCorner": {
              "x": 14.793,
              "y": 23.43,
              "z": 0.402
            },
            "gtin": "4000607475603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21096",
            "leftCorner": {
              "x": 14.793,
              "y": 23.43,
              "z": 0.402
            },
            "rightCorner": {
              "x": 14.699,
              "y": 23.438,
              "z": 0.402
            },
            "gtin": "4000607475603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21097",
            "leftCorner": {
              "x": 14.699,
              "y": 23.435,
              "z": 0.402
            },
            "rightCorner": {
              "x": 14.583,
              "y": 23.444,
              "z": 0.402
            },
            "gtin": "4000607469008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21098",
            "leftCorner": {
              "x": 14.583,
              "y": 23.444,
              "z": 0.402
            },
            "rightCorner": {
              "x": 14.468,
              "y": 23.454,
              "z": 0.402
            },
            "gtin": "4000607469008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21099",
            "leftCorner": {
              "x": 14.468,
              "y": 23.454,
              "z": 0.402
            },
            "rightCorner": {
              "x": 14.304,
              "y": 23.467,
              "z": 0.402
            },
            "gtin": "4000607000539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2109a",
            "leftCorner": {
              "x": 14.304,
              "y": 23.467,
              "z": 0.402
            },
            "rightCorner": {
              "x": 14.141,
              "y": 23.481,
              "z": 0.402
            },
            "gtin": "4000607000539",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546827",
        "height": 0.84569,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21288",
            "leftCorner": {
              "x": 15.402,
              "y": 23.394,
              "z": 0.692
            },
            "rightCorner": {
              "x": 15.262,
              "y": 23.405,
              "z": 0.692
            },
            "gtin": "7622210598080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21289",
            "leftCorner": {
              "x": 15.262,
              "y": 23.405,
              "z": 0.692
            },
            "rightCorner": {
              "x": 15.123,
              "y": 23.417,
              "z": 0.692
            },
            "gtin": "7622210598080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2128a",
            "leftCorner": {
              "x": 15.121,
              "y": 23.401,
              "z": 0.692
            },
            "rightCorner": {
              "x": 14.91,
              "y": 23.419,
              "z": 0.692
            },
            "gtin": "7622210928719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2128b",
            "leftCorner": {
              "x": 14.91,
              "y": 23.419,
              "z": 0.692
            },
            "rightCorner": {
              "x": 14.699,
              "y": 23.437,
              "z": 0.692
            },
            "gtin": "7622210928719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2128c",
            "leftCorner": {
              "x": 14.699,
              "y": 23.438,
              "z": 0.692
            },
            "rightCorner": {
              "x": 14.582,
              "y": 23.447,
              "z": 0.692
            },
            "gtin": "7622210928726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2128d",
            "leftCorner": {
              "x": 14.582,
              "y": 23.447,
              "z": 0.692
            },
            "rightCorner": {
              "x": 14.465,
              "y": 23.456,
              "z": 0.692
            },
            "gtin": "7622210928726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2128e",
            "leftCorner": {
              "x": 14.465,
              "y": 23.459,
              "z": 0.692
            },
            "rightCorner": {
              "x": 14.31,
              "y": 23.473,
              "z": 0.692
            },
            "gtin": "7622210928733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2128f",
            "leftCorner": {
              "x": 14.31,
              "y": 23.473,
              "z": 0.692
            },
            "rightCorner": {
              "x": 14.154,
              "y": 23.486,
              "z": 0.692
            },
            "gtin": "7622210928733",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546826",
        "height": 1.201,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2129b",
            "leftCorner": {
              "x": 15.439,
              "y": 23.416,
              "z": 0.983
            },
            "rightCorner": {
              "x": 14.544,
              "y": 23.49,
              "z": 0.983
            },
            "gtin": "7622201141776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2129e",
            "leftCorner": {
              "x": 14.54,
              "y": 23.447,
              "z": 0.983
            },
            "rightCorner": {
              "x": 14.477,
              "y": 23.453,
              "z": 0.983
            },
            "gtin": "7622210598011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2129f",
            "leftCorner": {
              "x": 14.477,
              "y": 23.453,
              "z": 0.983
            },
            "rightCorner": {
              "x": 14.413,
              "y": 23.459,
              "z": 0.983
            },
            "gtin": "7622210598011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212a0",
            "leftCorner": {
              "x": 14.413,
              "y": 23.459,
              "z": 0.983
            },
            "rightCorner": {
              "x": 14.349,
              "y": 23.464,
              "z": 0.983
            },
            "gtin": "7622210598011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212a1",
            "leftCorner": {
              "x": 14.349,
              "y": 23.464,
              "z": 0.983
            },
            "rightCorner": {
              "x": 14.286,
              "y": 23.469,
              "z": 0.983
            },
            "gtin": "7622210598011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212a2",
            "leftCorner": {
              "x": 14.286,
              "y": 23.469,
              "z": 0.983
            },
            "rightCorner": {
              "x": 14.223,
              "y": 23.474,
              "z": 0.983
            },
            "gtin": "7622210598011",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546825",
        "height": 1.4981,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2125d",
            "leftCorner": {
              "x": 15.389,
              "y": 23.406,
              "z": 1.226
            },
            "rightCorner": {
              "x": 15.214,
              "y": 23.421,
              "z": 1.226
            },
            "gtin": "7622010002442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2125e",
            "leftCorner": {
              "x": 15.214,
              "y": 23.421,
              "z": 1.226
            },
            "rightCorner": {
              "x": 15.04,
              "y": 23.435,
              "z": 1.226
            },
            "gtin": "7622010002442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2125f",
            "leftCorner": {
              "x": 15.04,
              "y": 23.435,
              "z": 1.226
            },
            "rightCorner": {
              "x": 14.865,
              "y": 23.45,
              "z": 1.226
            },
            "gtin": "7622010002442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21260",
            "leftCorner": {
              "x": 14.865,
              "y": 23.439,
              "z": 1.226
            },
            "rightCorner": {
              "x": 14.755,
              "y": 23.448,
              "z": 1.226
            },
            "gtin": "7622210615060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21261",
            "leftCorner": {
              "x": 14.755,
              "y": 23.448,
              "z": 1.226
            },
            "rightCorner": {
              "x": 14.644,
              "y": 23.457,
              "z": 1.226
            },
            "gtin": "7622210615060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21262",
            "leftCorner": {
              "x": 14.645,
              "y": 23.466,
              "z": 1.226
            },
            "rightCorner": {
              "x": 14.518,
              "y": 23.477,
              "z": 1.226
            },
            "gtin": "7622210597915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21263",
            "leftCorner": {
              "x": 14.517,
              "y": 23.461,
              "z": 1.226
            },
            "rightCorner": {
              "x": 14.204,
              "y": 23.487,
              "z": 1.226
            },
            "gtin": "7622210598073",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546823",
        "height": 1.7491,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21182",
            "leftCorner": {
              "x": 15.382,
              "y": 23.388,
              "z": 1.431
            },
            "rightCorner": {
              "x": 15.213,
              "y": 23.401,
              "z": 1.431
            },
            "gtin": "4014303121511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21183",
            "leftCorner": {
              "x": 15.213,
              "y": 23.408,
              "z": 1.431
            },
            "rightCorner": {
              "x": 15.146,
              "y": 23.414,
              "z": 1.431
            },
            "gtin": "4014303122747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21184",
            "leftCorner": {
              "x": 15.146,
              "y": 23.414,
              "z": 1.431
            },
            "rightCorner": {
              "x": 15.077,
              "y": 23.42,
              "z": 1.431
            },
            "gtin": "4014303122747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21185",
            "leftCorner": {
              "x": 15.077,
              "y": 23.42,
              "z": 1.431
            },
            "rightCorner": {
              "x": 15.009,
              "y": 23.426,
              "z": 1.431
            },
            "gtin": "4014303122747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21186",
            "leftCorner": {
              "x": 15.009,
              "y": 23.419,
              "z": 1.431
            },
            "rightCorner": {
              "x": 14.911,
              "y": 23.427,
              "z": 1.431
            },
            "gtin": "4014303125106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21187",
            "leftCorner": {
              "x": 14.911,
              "y": 23.427,
              "z": 1.431
            },
            "rightCorner": {
              "x": 14.813,
              "y": 23.435,
              "z": 1.431
            },
            "gtin": "4014303125106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21188",
            "leftCorner": {
              "x": 14.813,
              "y": 23.434,
              "z": 1.431
            },
            "rightCorner": {
              "x": 14.714,
              "y": 23.443,
              "z": 1.431
            },
            "gtin": "4014303122501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21189",
            "leftCorner": {
              "x": 14.714,
              "y": 23.443,
              "z": 1.431
            },
            "rightCorner": {
              "x": 14.616,
              "y": 23.451,
              "z": 1.431
            },
            "gtin": "4014303122501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2118a",
            "leftCorner": {
              "x": 14.616,
              "y": 23.452,
              "z": 1.431
            },
            "rightCorner": {
              "x": 14.517,
              "y": 23.46,
              "z": 1.431
            },
            "gtin": "4014303122983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2118b",
            "leftCorner": {
              "x": 14.517,
              "y": 23.46,
              "z": 1.431
            },
            "rightCorner": {
              "x": 14.42,
              "y": 23.468,
              "z": 1.431
            },
            "gtin": "4014303122983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2118c",
            "leftCorner": {
              "x": 14.421,
              "y": 23.484,
              "z": 1.431
            },
            "rightCorner": {
              "x": 14.383,
              "y": 23.486,
              "z": 1.431
            },
            "gtin": "8711508400071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2118d",
            "leftCorner": {
              "x": 14.383,
              "y": 23.486,
              "z": 1.431
            },
            "rightCorner": {
              "x": 14.345,
              "y": 23.49,
              "z": 1.431
            },
            "gtin": "8711508400071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2118e",
            "leftCorner": {
              "x": 14.342,
              "y": 23.463,
              "z": 1.431
            },
            "rightCorner": {
              "x": 14.269,
              "y": 23.47,
              "z": 1.431
            },
            "gtin": "8711508400064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2118f",
            "leftCorner": {
              "x": 14.269,
              "y": 23.47,
              "z": 1.431
            },
            "rightCorner": {
              "x": 14.197,
              "y": 23.475,
              "z": 1.431
            },
            "gtin": "8711508400064",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a12",
    "rightNeighborShelfId": "50a14"
  },
  {
    "id": "50a14",
    "name": "50a14",
    "x": 14.245,
    "y": 23.527,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99914,
      "w": 0.041492
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 42
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54682d",
        "height": 0.14289,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21129",
            "leftCorner": {
              "x": 14.17,
              "y": 23.474,
              "z": 0.117
            },
            "rightCorner": {
              "x": 14.075,
              "y": 23.482,
              "z": 0.117
            },
            "gtin": "4000607790706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2112a",
            "leftCorner": {
              "x": 14.075,
              "y": 23.482,
              "z": 0.117
            },
            "rightCorner": {
              "x": 13.978,
              "y": 23.491,
              "z": 0.117
            },
            "gtin": "4000607790706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2112b",
            "leftCorner": {
              "x": 13.979,
              "y": 23.501,
              "z": 0.117
            },
            "rightCorner": {
              "x": 13.876,
              "y": 23.509,
              "z": 0.117
            },
            "gtin": "4000607466793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2112c",
            "leftCorner": {
              "x": 13.876,
              "y": 23.509,
              "z": 0.117
            },
            "rightCorner": {
              "x": 13.773,
              "y": 23.518,
              "z": 0.117
            },
            "gtin": "4000607466793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2112d",
            "leftCorner": {
              "x": 13.773,
              "y": 23.518,
              "z": 0.117
            },
            "rightCorner": {
              "x": 13.671,
              "y": 23.527,
              "z": 0.117
            },
            "gtin": "4000607466793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2112e",
            "leftCorner": {
              "x": 13.67,
              "y": 23.514,
              "z": 0.117
            },
            "rightCorner": {
              "x": 13.577,
              "y": 23.522,
              "z": 0.117
            },
            "gtin": "4000607432804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2112f",
            "leftCorner": {
              "x": 13.577,
              "y": 23.522,
              "z": 0.117
            },
            "rightCorner": {
              "x": 13.485,
              "y": 23.531,
              "z": 0.117
            },
            "gtin": "4000607432804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21130",
            "leftCorner": {
              "x": 13.485,
              "y": 23.542,
              "z": 0.117
            },
            "rightCorner": {
              "x": 13.224,
              "y": 23.564,
              "z": 0.117
            },
            "gtin": "4000281776508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21131",
            "leftCorner": {
              "x": 13.224,
              "y": 23.564,
              "z": 0.117
            },
            "rightCorner": {
              "x": 12.963,
              "y": 23.585,
              "z": 0.117
            },
            "gtin": "4000281776508",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54682c",
        "height": 0.48675,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2109b",
            "leftCorner": {
              "x": 14.141,
              "y": 23.481,
              "z": 0.398
            },
            "rightCorner": {
              "x": 13.942,
              "y": 23.498,
              "z": 0.398
            },
            "gtin": "4014400932959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2109c",
            "leftCorner": {
              "x": 13.942,
              "y": 23.498,
              "z": 0.398
            },
            "rightCorner": {
              "x": 13.743,
              "y": 23.514,
              "z": 0.398
            },
            "gtin": "4014400932959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2109d",
            "leftCorner": {
              "x": 13.743,
              "y": 23.514,
              "z": 0.398
            },
            "rightCorner": {
              "x": 13.545,
              "y": 23.531,
              "z": 0.398
            },
            "gtin": "4014400932959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2109e",
            "leftCorner": {
              "x": 13.546,
              "y": 23.544,
              "z": 0.398
            },
            "rightCorner": {
              "x": 13.475,
              "y": 23.549,
              "z": 0.398
            },
            "gtin": "4262354077602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2109f",
            "leftCorner": {
              "x": 13.475,
              "y": 23.549,
              "z": 0.398
            },
            "rightCorner": {
              "x": 13.404,
              "y": 23.555,
              "z": 0.398
            },
            "gtin": "4262354077602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210a0",
            "leftCorner": {
              "x": 13.404,
              "y": 23.556,
              "z": 0.398
            },
            "rightCorner": {
              "x": 13.346,
              "y": 23.561,
              "z": 0.398
            },
            "gtin": "4262354077701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210a1",
            "leftCorner": {
              "x": 13.346,
              "y": 23.561,
              "z": 0.398
            },
            "rightCorner": {
              "x": 13.288,
              "y": 23.566,
              "z": 0.398
            },
            "gtin": "4262354077701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210a2",
            "leftCorner": {
              "x": 13.289,
              "y": 23.567,
              "z": 0.398
            },
            "rightCorner": {
              "x": 13.232,
              "y": 23.571,
              "z": 0.398
            },
            "gtin": "4262354077503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210a3",
            "leftCorner": {
              "x": 13.232,
              "y": 23.571,
              "z": 0.398
            },
            "rightCorner": {
              "x": 13.176,
              "y": 23.576,
              "z": 0.398
            },
            "gtin": "4262354077503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210a4",
            "leftCorner": {
              "x": 13.175,
              "y": 23.569,
              "z": 0.398
            },
            "rightCorner": {
              "x": 13.099,
              "y": 23.576,
              "z": 0.398
            },
            "gtin": "4000607000348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210a5",
            "leftCorner": {
              "x": 13.099,
              "y": 23.576,
              "z": 0.398
            },
            "rightCorner": {
              "x": 13.023,
              "y": 23.582,
              "z": 0.398
            },
            "gtin": "4000607000348",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54682b",
        "height": 0.83964,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21290",
            "leftCorner": {
              "x": 14.154,
              "y": 23.482,
              "z": 0.687
            },
            "rightCorner": {
              "x": 13.743,
              "y": 23.516,
              "z": 0.687
            },
            "gtin": "4014400400007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21291",
            "leftCorner": {
              "x": 13.743,
              "y": 23.516,
              "z": 0.687
            },
            "rightCorner": {
              "x": 13.333,
              "y": 23.551,
              "z": 0.687
            },
            "gtin": "4014400400007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2126d",
            "leftCorner": {
              "x": 13.333,
              "y": 23.565,
              "z": 0.687
            },
            "rightCorner": {
              "x": 13.238,
              "y": 23.573,
              "z": 0.687
            },
            "gtin": "4000956025405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2126e",
            "leftCorner": {
              "x": 13.238,
              "y": 23.573,
              "z": 0.687
            },
            "rightCorner": {
              "x": 13.142,
              "y": 23.581,
              "z": 0.687
            },
            "gtin": "4000956025405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2126f",
            "leftCorner": {
              "x": 13.142,
              "y": 23.581,
              "z": 0.687
            },
            "rightCorner": {
              "x": 13.045,
              "y": 23.589,
              "z": 0.687
            },
            "gtin": "4000956025405",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546828",
        "height": 1.1947,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a212a3",
            "leftCorner": {
              "x": 14.223,
              "y": 23.484,
              "z": 0.977
            },
            "rightCorner": {
              "x": 13.927,
              "y": 23.509,
              "z": 0.977
            },
            "gtin": "4014400900576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212a4",
            "leftCorner": {
              "x": 13.927,
              "y": 23.509,
              "z": 0.977
            },
            "rightCorner": {
              "x": 13.63,
              "y": 23.534,
              "z": 0.977
            },
            "gtin": "4014400900576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212a5",
            "leftCorner": {
              "x": 13.63,
              "y": 23.534,
              "z": 0.977
            },
            "rightCorner": {
              "x": 13.333,
              "y": 23.559,
              "z": 0.977
            },
            "gtin": "4014400900576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212a6",
            "leftCorner": {
              "x": 13.333,
              "y": 23.557,
              "z": 0.977
            },
            "rightCorner": {
              "x": 13.217,
              "y": 23.566,
              "z": 0.977
            },
            "gtin": "4000417101228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212a7",
            "leftCorner": {
              "x": 13.217,
              "y": 23.566,
              "z": 0.977
            },
            "rightCorner": {
              "x": 13.101,
              "y": 23.576,
              "z": 0.977
            },
            "gtin": "4000417101228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212a8",
            "leftCorner": {
              "x": 13.101,
              "y": 23.576,
              "z": 0.977
            },
            "rightCorner": {
              "x": 12.985,
              "y": 23.586,
              "z": 0.977
            },
            "gtin": "4000417101228",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54682a",
        "height": 1.4977,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21264",
            "leftCorner": {
              "x": 14.204,
              "y": 23.488,
              "z": 1.225
            },
            "rightCorner": {
              "x": 14.075,
              "y": 23.498,
              "z": 1.225
            },
            "gtin": "4019400440657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21265",
            "leftCorner": {
              "x": 14.075,
              "y": 23.498,
              "z": 1.225
            },
            "rightCorner": {
              "x": 13.946,
              "y": 23.509,
              "z": 1.225
            },
            "gtin": "4019400440657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21266",
            "leftCorner": {
              "x": 13.946,
              "y": 23.512,
              "z": 1.225
            },
            "rightCorner": {
              "x": 13.465,
              "y": 23.552,
              "z": 1.225
            },
            "gtin": "7613035903401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21267",
            "leftCorner": {
              "x": 13.465,
              "y": 23.552,
              "z": 1.225
            },
            "rightCorner": {
              "x": 12.985,
              "y": 23.592,
              "z": 1.225
            },
            "gtin": "7613035903401",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546829",
        "height": 1.7399,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21190",
            "leftCorner": {
              "x": 14.198,
              "y": 23.49,
              "z": 1.424
            },
            "rightCorner": {
              "x": 14.04,
              "y": 23.503,
              "z": 1.424
            },
            "gtin": "5000189983281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21191",
            "leftCorner": {
              "x": 14.04,
              "y": 23.503,
              "z": 1.424
            },
            "rightCorner": {
              "x": 13.881,
              "y": 23.516,
              "z": 1.424
            },
            "gtin": "5000189983281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21192",
            "leftCorner": {
              "x": 13.881,
              "y": 23.516,
              "z": 1.424
            },
            "rightCorner": {
              "x": 13.724,
              "y": 23.529,
              "z": 1.424
            },
            "gtin": "5000189983281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21193",
            "leftCorner": {
              "x": 13.722,
              "y": 23.517,
              "z": 1.424
            },
            "rightCorner": {
              "x": 13.543,
              "y": 23.532,
              "z": 1.424
            },
            "gtin": "5000189363069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21194",
            "leftCorner": {
              "x": 13.543,
              "y": 23.532,
              "z": 1.424
            },
            "rightCorner": {
              "x": 13.363,
              "y": 23.547,
              "z": 1.424
            },
            "gtin": "5000189363069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21195",
            "leftCorner": {
              "x": 13.363,
              "y": 23.547,
              "z": 1.424
            },
            "rightCorner": {
              "x": 13.184,
              "y": 23.562,
              "z": 1.424
            },
            "gtin": "5000189363069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21196",
            "leftCorner": {
              "x": 13.184,
              "y": 23.562,
              "z": 1.424
            },
            "rightCorner": {
              "x": 13.005,
              "y": 23.577,
              "z": 1.424
            },
            "gtin": "5000189363069",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a13",
    "rightNeighborShelfId": "50a15"
  },
  {
    "id": "50a15",
    "name": "50a15",
    "x": 13.049,
    "y": 23.627,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99914,
      "w": 0.041492
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 42
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546833",
        "height": 0.13923,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21132",
            "leftCorner": {
              "x": 12.963,
              "y": 23.584,
              "z": 0.114
            },
            "rightCorner": {
              "x": 12.89,
              "y": 23.59,
              "z": 0.114
            },
            "gtin": "4014400927443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21133",
            "leftCorner": {
              "x": 12.89,
              "y": 23.59,
              "z": 0.114
            },
            "rightCorner": {
              "x": 12.815,
              "y": 23.596,
              "z": 0.114
            },
            "gtin": "4014400927443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21134",
            "leftCorner": {
              "x": 12.815,
              "y": 23.596,
              "z": 0.114
            },
            "rightCorner": {
              "x": 12.741,
              "y": 23.602,
              "z": 0.114
            },
            "gtin": "4014400927443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21135",
            "leftCorner": {
              "x": 12.741,
              "y": 23.594,
              "z": 0.114
            },
            "rightCorner": {
              "x": 12.614,
              "y": 23.605,
              "z": 0.114
            },
            "gtin": "4014400927429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21136",
            "leftCorner": {
              "x": 12.614,
              "y": 23.605,
              "z": 0.114
            },
            "rightCorner": {
              "x": 12.488,
              "y": 23.615,
              "z": 0.114
            },
            "gtin": "4014400927429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21137",
            "leftCorner": {
              "x": 12.488,
              "y": 23.615,
              "z": 0.114
            },
            "rightCorner": {
              "x": 12.362,
              "y": 23.626,
              "z": 0.114
            },
            "gtin": "4014400927429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21138",
            "leftCorner": {
              "x": 12.362,
              "y": 23.634,
              "z": 0.114
            },
            "rightCorner": {
              "x": 12.195,
              "y": 23.648,
              "z": 0.114
            },
            "gtin": "4014400927436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21139",
            "leftCorner": {
              "x": 12.195,
              "y": 23.648,
              "z": 0.114
            },
            "rightCorner": {
              "x": 12.027,
              "y": 23.661,
              "z": 0.114
            },
            "gtin": "4014400927436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2113a",
            "leftCorner": {
              "x": 12.027,
              "y": 23.661,
              "z": 0.114
            },
            "rightCorner": {
              "x": 11.86,
              "y": 23.675,
              "z": 0.114
            },
            "gtin": "4014400927436",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54682e",
        "height": 0.49066,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a210a6",
            "leftCorner": {
              "x": 13.023,
              "y": 23.585,
              "z": 0.401
            },
            "rightCorner": {
              "x": 12.935,
              "y": 23.593,
              "z": 0.401
            },
            "gtin": "4014400927399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210a7",
            "leftCorner": {
              "x": 12.935,
              "y": 23.593,
              "z": 0.401
            },
            "rightCorner": {
              "x": 12.846,
              "y": 23.6,
              "z": 0.401
            },
            "gtin": "4014400927399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210a8",
            "leftCorner": {
              "x": 12.846,
              "y": 23.6,
              "z": 0.401
            },
            "rightCorner": {
              "x": 12.757,
              "y": 23.607,
              "z": 0.401
            },
            "gtin": "4014400927399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210a9",
            "leftCorner": {
              "x": 12.757,
              "y": 23.596,
              "z": 0.401
            },
            "rightCorner": {
              "x": 12.622,
              "y": 23.608,
              "z": 0.401
            },
            "gtin": "4014400925395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210aa",
            "leftCorner": {
              "x": 12.622,
              "y": 23.608,
              "z": 0.401
            },
            "rightCorner": {
              "x": 12.488,
              "y": 23.619,
              "z": 0.401
            },
            "gtin": "4014400925395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210ab",
            "leftCorner": {
              "x": 12.488,
              "y": 23.619,
              "z": 0.401
            },
            "rightCorner": {
              "x": 12.353,
              "y": 23.63,
              "z": 0.401
            },
            "gtin": "4014400925395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210ac",
            "leftCorner": {
              "x": 12.353,
              "y": 23.631,
              "z": 0.401
            },
            "rightCorner": {
              "x": 12.235,
              "y": 23.64,
              "z": 0.401
            },
            "gtin": "4014400927375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210ad",
            "leftCorner": {
              "x": 12.235,
              "y": 23.64,
              "z": 0.401
            },
            "rightCorner": {
              "x": 12.118,
              "y": 23.65,
              "z": 0.401
            },
            "gtin": "4014400927375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210ae",
            "leftCorner": {
              "x": 12.118,
              "y": 23.65,
              "z": 0.401
            },
            "rightCorner": {
              "x": 12.0,
              "y": 23.66,
              "z": 0.401
            },
            "gtin": "4014400927375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210af",
            "leftCorner": {
              "x": 12.0,
              "y": 23.66,
              "z": 0.401
            },
            "rightCorner": {
              "x": 11.857,
              "y": 23.672,
              "z": 0.401
            },
            "gtin": "8714786308138",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54682f",
        "height": 0.86195,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a212af",
            "leftCorner": {
              "x": 13.048,
              "y": 23.609,
              "z": 0.705
            },
            "rightCorner": {
              "x": 12.906,
              "y": 23.62,
              "z": 0.705
            },
            "gtin": "4014400933079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212b0",
            "leftCorner": {
              "x": 12.906,
              "y": 23.62,
              "z": 0.705
            },
            "rightCorner": {
              "x": 12.765,
              "y": 23.633,
              "z": 0.705
            },
            "gtin": "4014400933079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212b3",
            "leftCorner": {
              "x": 12.761,
              "y": 23.584,
              "z": 0.705
            },
            "rightCorner": {
              "x": 12.634,
              "y": 23.594,
              "z": 0.705
            },
            "gtin": "4014400933062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212b4",
            "leftCorner": {
              "x": 12.634,
              "y": 23.594,
              "z": 0.705
            },
            "rightCorner": {
              "x": 12.509,
              "y": 23.605,
              "z": 0.705
            },
            "gtin": "4014400933062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212b5",
            "leftCorner": {
              "x": 12.509,
              "y": 23.605,
              "z": 0.705
            },
            "rightCorner": {
              "x": 12.382,
              "y": 23.615,
              "z": 0.705
            },
            "gtin": "4014400933062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212b6",
            "leftCorner": {
              "x": 12.382,
              "y": 23.615,
              "z": 0.705
            },
            "rightCorner": {
              "x": 12.256,
              "y": 23.626,
              "z": 0.705
            },
            "gtin": "4014400933062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212b7",
            "leftCorner": {
              "x": 12.257,
              "y": 23.63,
              "z": 0.705
            },
            "rightCorner": {
              "x": 12.131,
              "y": 23.64,
              "z": 0.705
            },
            "gtin": "4014400933055",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8b5ed67a01d9a212b8",
            "leftCorner": {
              "x": 12.132,
              "y": 23.647,
              "z": 0.705
            },
            "rightCorner": {
              "x": 11.97,
              "y": 23.661,
              "z": 0.705
            },
            "gtin": "4014400930993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212b1",
            "leftCorner": {
              "x": 11.97,
              "y": 23.663,
              "z": 0.705
            },
            "rightCorner": {
              "x": 11.909,
              "y": 23.668,
              "z": 0.705
            },
            "gtin": "4003754092006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212b2",
            "leftCorner": {
              "x": 11.909,
              "y": 23.668,
              "z": 0.705
            },
            "rightCorner": {
              "x": 11.849,
              "y": 23.673,
              "z": 0.705
            },
            "gtin": "4003754092006",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546832",
        "height": 1.1934,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a212a9",
            "leftCorner": {
              "x": 12.986,
              "y": 23.593,
              "z": 0.976
            },
            "rightCorner": {
              "x": 12.87,
              "y": 23.602,
              "z": 0.976
            },
            "gtin": "4014400934175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212aa",
            "leftCorner": {
              "x": 12.87,
              "y": 23.602,
              "z": 0.976
            },
            "rightCorner": {
              "x": 12.755,
              "y": 23.611,
              "z": 0.976
            },
            "gtin": "4014400934175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212ab",
            "leftCorner": {
              "x": 12.755,
              "y": 23.611,
              "z": 0.976
            },
            "rightCorner": {
              "x": 12.639,
              "y": 23.621,
              "z": 0.976
            },
            "gtin": "4014400934175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212ac",
            "leftCorner": {
              "x": 12.638,
              "y": 23.603,
              "z": 0.976
            },
            "rightCorner": {
              "x": 12.434,
              "y": 23.62,
              "z": 0.976
            },
            "gtin": "4014400901412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212ad",
            "leftCorner": {
              "x": 12.435,
              "y": 23.625,
              "z": 0.976
            },
            "rightCorner": {
              "x": 12.319,
              "y": 23.635,
              "z": 0.976
            },
            "gtin": "4014400901405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212ae",
            "leftCorner": {
              "x": 12.319,
              "y": 23.635,
              "z": 0.976
            },
            "rightCorner": {
              "x": 12.204,
              "y": 23.645,
              "z": 0.976
            },
            "gtin": "4014400901405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2129c",
            "leftCorner": {
              "x": 12.203,
              "y": 23.64,
              "z": 0.976
            },
            "rightCorner": {
              "x": 12.026,
              "y": 23.655,
              "z": 0.976
            },
            "gtin": "4014400917956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2129d",
            "leftCorner": {
              "x": 12.026,
              "y": 23.655,
              "z": 0.976
            },
            "rightCorner": {
              "x": 11.848,
              "y": 23.67,
              "z": 0.976
            },
            "gtin": "4014400917956",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546831",
        "height": 1.491,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21268",
            "leftCorner": {
              "x": 12.984,
              "y": 23.583,
              "z": 1.22
            },
            "rightCorner": {
              "x": 12.654,
              "y": 23.61,
              "z": 1.22
            },
            "gtin": "4014400901191",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21269",
            "leftCorner": {
              "x": 12.654,
              "y": 23.61,
              "z": 1.22
            },
            "rightCorner": {
              "x": 12.325,
              "y": 23.637,
              "z": 1.22
            },
            "gtin": "4014400901191",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2126a",
            "leftCorner": {
              "x": 12.325,
              "y": 23.637,
              "z": 1.22
            },
            "rightCorner": {
              "x": 11.996,
              "y": 23.664,
              "z": 1.22
            },
            "gtin": "4014400901191",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21243",
            "leftCorner": {
              "x": 11.997,
              "y": 23.673,
              "z": 1.22
            },
            "rightCorner": {
              "x": 11.85,
              "y": 23.686,
              "z": 1.22
            },
            "gtin": "4014400923735",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546830",
        "height": 1.7415,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21197",
            "leftCorner": {
              "x": 13.006,
              "y": 23.59,
              "z": 1.425
            },
            "rightCorner": {
              "x": 12.558,
              "y": 23.628,
              "z": 1.425
            },
            "gtin": "4014400907728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21198",
            "leftCorner": {
              "x": 12.557,
              "y": 23.61,
              "z": 1.425
            },
            "rightCorner": {
              "x": 11.739,
              "y": 23.679,
              "z": 1.425
            },
            "gtin": "4014400900217",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a14",
    "rightNeighborShelfId": "50a16"
  },
  {
    "id": "50a16",
    "name": "50a16",
    "x": 11.853,
    "y": 23.726,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99914,
      "w": 0.041492
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 49
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5467ba",
        "height": 0.14593,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21149",
            "leftCorner": {
              "x": 10.719,
              "y": 23.78,
              "z": 0.119
            },
            "rightCorner": {
              "x": 10.667,
              "y": 23.783,
              "z": 0.119
            },
            "gtin": "4000161020233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2113b",
            "leftCorner": {
              "x": 11.86,
              "y": 23.681,
              "z": 0.119
            },
            "rightCorner": {
              "x": 11.806,
              "y": 23.686,
              "z": 0.119
            },
            "gtin": "4000161010203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2113c",
            "leftCorner": {
              "x": 11.806,
              "y": 23.687,
              "z": 0.119
            },
            "rightCorner": {
              "x": 11.651,
              "y": 23.701,
              "z": 0.119
            },
            "gtin": "4000161010319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2113d",
            "leftCorner": {
              "x": 11.65,
              "y": 23.697,
              "z": 0.119
            },
            "rightCorner": {
              "x": 11.545,
              "y": 23.705,
              "z": 0.119
            },
            "gtin": "4000161400110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2113e",
            "leftCorner": {
              "x": 11.545,
              "y": 23.705,
              "z": 0.119
            },
            "rightCorner": {
              "x": 11.44,
              "y": 23.714,
              "z": 0.119
            },
            "gtin": "4000161400110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2113f",
            "leftCorner": {
              "x": 11.44,
              "y": 23.714,
              "z": 0.119
            },
            "rightCorner": {
              "x": 11.357,
              "y": 23.721,
              "z": 0.119
            },
            "gtin": "4000161050308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21140",
            "leftCorner": {
              "x": 11.357,
              "y": 23.721,
              "z": 0.119
            },
            "rightCorner": {
              "x": 11.275,
              "y": 23.727,
              "z": 0.119
            },
            "gtin": "4000161050308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21141",
            "leftCorner": {
              "x": 11.275,
              "y": 23.727,
              "z": 0.119
            },
            "rightCorner": {
              "x": 11.193,
              "y": 23.735,
              "z": 0.119
            },
            "gtin": "4000161050308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21142",
            "leftCorner": {
              "x": 11.193,
              "y": 23.734,
              "z": 0.119
            },
            "rightCorner": {
              "x": 11.122,
              "y": 23.74,
              "z": 0.119
            },
            "gtin": "4000161100072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21143",
            "leftCorner": {
              "x": 11.122,
              "y": 23.74,
              "z": 0.119
            },
            "rightCorner": {
              "x": 11.052,
              "y": 23.746,
              "z": 0.119
            },
            "gtin": "4000161100072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21144",
            "leftCorner": {
              "x": 11.052,
              "y": 23.746,
              "z": 0.119
            },
            "rightCorner": {
              "x": 10.982,
              "y": 23.751,
              "z": 0.119
            },
            "gtin": "4000161100072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21145",
            "leftCorner": {
              "x": 10.982,
              "y": 23.751,
              "z": 0.119
            },
            "rightCorner": {
              "x": 10.93,
              "y": 23.755,
              "z": 0.119
            },
            "gtin": "4000161020295",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21146",
            "leftCorner": {
              "x": 10.93,
              "y": 23.755,
              "z": 0.119
            },
            "rightCorner": {
              "x": 10.878,
              "y": 23.76,
              "z": 0.119
            },
            "gtin": "4000161020295",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21147",
            "leftCorner": {
              "x": 10.878,
              "y": 23.758,
              "z": 0.119
            },
            "rightCorner": {
              "x": 10.775,
              "y": 23.766,
              "z": 0.119
            },
            "gtin": "4000161170846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21148",
            "leftCorner": {
              "x": 10.775,
              "y": 23.768,
              "z": 0.119
            },
            "rightCorner": {
              "x": 10.718,
              "y": 23.773,
              "z": 0.119
            },
            "gtin": "4000161210344",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467b7",
        "height": 0.49508,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a210b0",
            "leftCorner": {
              "x": 11.857,
              "y": 23.681,
              "z": 0.405
            },
            "rightCorner": {
              "x": 11.591,
              "y": 23.703,
              "z": 0.405
            },
            "gtin": "4000161100157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210b1",
            "leftCorner": {
              "x": 11.59,
              "y": 23.696,
              "z": 0.405
            },
            "rightCorner": {
              "x": 11.525,
              "y": 23.701,
              "z": 0.405
            },
            "gtin": "4000161020394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210b2",
            "leftCorner": {
              "x": 11.524,
              "y": 23.695,
              "z": 0.405
            },
            "rightCorner": {
              "x": 11.379,
              "y": 23.707,
              "z": 0.405
            },
            "gtin": "4000161020370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210b3",
            "leftCorner": {
              "x": 11.379,
              "y": 23.707,
              "z": 0.405
            },
            "rightCorner": {
              "x": 11.234,
              "y": 23.719,
              "z": 0.405
            },
            "gtin": "4000161020370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210b4",
            "leftCorner": {
              "x": 11.235,
              "y": 23.732,
              "z": 0.405
            },
            "rightCorner": {
              "x": 11.175,
              "y": 23.737,
              "z": 0.405
            },
            "gtin": "4000161200932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210b5",
            "leftCorner": {
              "x": 11.175,
              "y": 23.737,
              "z": 0.405
            },
            "rightCorner": {
              "x": 11.116,
              "y": 23.742,
              "z": 0.405
            },
            "gtin": "4000161200932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210b6",
            "leftCorner": {
              "x": 11.116,
              "y": 23.742,
              "z": 0.405
            },
            "rightCorner": {
              "x": 11.056,
              "y": 23.746,
              "z": 0.405
            },
            "gtin": "4000161200932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210b7",
            "leftCorner": {
              "x": 11.056,
              "y": 23.741,
              "z": 0.405
            },
            "rightCorner": {
              "x": 11.003,
              "y": 23.746,
              "z": 0.405
            },
            "gtin": "4000161090052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210b8",
            "leftCorner": {
              "x": 11.003,
              "y": 23.746,
              "z": 0.405
            },
            "rightCorner": {
              "x": 10.951,
              "y": 23.751,
              "z": 0.405
            },
            "gtin": "4000161090052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210b9",
            "leftCorner": {
              "x": 10.951,
              "y": 23.756,
              "z": 0.405
            },
            "rightCorner": {
              "x": 10.866,
              "y": 23.762,
              "z": 0.405
            },
            "gtin": "4000161060116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210ba",
            "leftCorner": {
              "x": 10.866,
              "y": 23.761,
              "z": 0.405
            },
            "rightCorner": {
              "x": 10.801,
              "y": 23.767,
              "z": 0.405
            },
            "gtin": "4000161060147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210bb",
            "leftCorner": {
              "x": 10.802,
              "y": 23.776,
              "z": 0.405
            },
            "rightCorner": {
              "x": 10.711,
              "y": 23.783,
              "z": 0.405
            },
            "gtin": "4000161060178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210bc",
            "leftCorner": {
              "x": 10.711,
              "y": 23.783,
              "z": 0.405
            },
            "rightCorner": {
              "x": 10.621,
              "y": 23.791,
              "z": 0.405
            },
            "gtin": "4000161060178",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467b9",
        "height": 0.74823,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a210e8",
            "leftCorner": {
              "x": 11.851,
              "y": 23.716,
              "z": 0.612
            },
            "rightCorner": {
              "x": 11.717,
              "y": 23.727,
              "z": 0.612
            },
            "gtin": "4008400183022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210e9",
            "leftCorner": {
              "x": 11.717,
              "y": 23.727,
              "z": 0.612
            },
            "rightCorner": {
              "x": 11.581,
              "y": 23.739,
              "z": 0.612
            },
            "gtin": "4008400183022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210ea",
            "leftCorner": {
              "x": 11.581,
              "y": 23.739,
              "z": 0.612
            },
            "rightCorner": {
              "x": 11.446,
              "y": 23.75,
              "z": 0.612
            },
            "gtin": "4008400183022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210eb",
            "leftCorner": {
              "x": 11.446,
              "y": 23.75,
              "z": 0.612
            },
            "rightCorner": {
              "x": 11.311,
              "y": 23.761,
              "z": 0.612
            },
            "gtin": "4008400183022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210ef",
            "leftCorner": {
              "x": 11.307,
              "y": 23.716,
              "z": 0.612
            },
            "rightCorner": {
              "x": 11.147,
              "y": 23.73,
              "z": 0.612
            },
            "gtin": "4008400181523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210f0",
            "leftCorner": {
              "x": 11.147,
              "y": 23.73,
              "z": 0.612
            },
            "rightCorner": {
              "x": 10.986,
              "y": 23.743,
              "z": 0.612
            },
            "gtin": "4008400181523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210f1",
            "leftCorner": {
              "x": 10.986,
              "y": 23.743,
              "z": 0.612
            },
            "rightCorner": {
              "x": 10.826,
              "y": 23.757,
              "z": 0.612
            },
            "gtin": "4008400181523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210f2",
            "leftCorner": {
              "x": 10.826,
              "y": 23.757,
              "z": 0.612
            },
            "rightCorner": {
              "x": 10.665,
              "y": 23.77,
              "z": 0.612
            },
            "gtin": "4008400181523",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467bc",
        "height": 1.0038,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a5467b8",
        "height": 1.5041,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a210ce",
            "leftCorner": {
              "x": 11.853,
              "y": 23.726,
              "z": 1.231
            },
            "rightCorner": {
              "x": 11.72,
              "y": 23.737,
              "z": 1.231
            },
            "gtin": "8000500443941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210cf",
            "leftCorner": {
              "x": 11.72,
              "y": 23.737,
              "z": 1.231
            },
            "rightCorner": {
              "x": 11.589,
              "y": 23.748,
              "z": 1.231
            },
            "gtin": "8000500443941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210d0",
            "leftCorner": {
              "x": 11.589,
              "y": 23.748,
              "z": 1.231
            },
            "rightCorner": {
              "x": 11.457,
              "y": 23.759,
              "z": 1.231
            },
            "gtin": "8000500443941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210d1",
            "leftCorner": {
              "x": 11.457,
              "y": 23.759,
              "z": 1.231
            },
            "rightCorner": {
              "x": 11.326,
              "y": 23.77,
              "z": 1.231
            },
            "gtin": "8000500443941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210d4",
            "leftCorner": {
              "x": 11.323,
              "y": 23.729,
              "z": 1.231
            },
            "rightCorner": {
              "x": 11.155,
              "y": 23.743,
              "z": 1.231
            },
            "gtin": "4008400102528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210d5",
            "leftCorner": {
              "x": 11.155,
              "y": 23.743,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.985,
              "y": 23.757,
              "z": 1.231
            },
            "gtin": "4008400102528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210d6",
            "leftCorner": {
              "x": 10.985,
              "y": 23.757,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.817,
              "y": 23.771,
              "z": 1.231
            },
            "gtin": "4008400102528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210d7",
            "leftCorner": {
              "x": 10.817,
              "y": 23.771,
              "z": 1.231
            },
            "rightCorner": {
              "x": 10.648,
              "y": 23.785,
              "z": 1.231
            },
            "gtin": "4008400102528",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467bb",
        "height": 1.7508,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21199",
            "leftCorner": {
              "x": 11.738,
              "y": 23.691,
              "z": 1.432
            },
            "rightCorner": {
              "x": 11.546,
              "y": 23.706,
              "z": 1.432
            },
            "gtin": "4008400121321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2119a",
            "leftCorner": {
              "x": 11.546,
              "y": 23.706,
              "z": 1.432
            },
            "rightCorner": {
              "x": 11.354,
              "y": 23.722,
              "z": 1.432
            },
            "gtin": "4008400121321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2119b",
            "leftCorner": {
              "x": 11.354,
              "y": 23.722,
              "z": 1.432
            },
            "rightCorner": {
              "x": 11.161,
              "y": 23.738,
              "z": 1.432
            },
            "gtin": "4008400121321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2119c",
            "leftCorner": {
              "x": 11.161,
              "y": 23.742,
              "z": 1.432
            },
            "rightCorner": {
              "x": 10.9,
              "y": 23.764,
              "z": 1.432
            },
            "gtin": "4008400122625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2119d",
            "leftCorner": {
              "x": 10.9,
              "y": 23.764,
              "z": 1.432
            },
            "rightCorner": {
              "x": 10.639,
              "y": 23.786,
              "z": 1.432
            },
            "gtin": "4008400122625",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a15",
    "rightNeighborShelfId": "50a17"
  },
  {
    "id": "50a17",
    "name": "50a17",
    "x": 10.657,
    "y": 23.826,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99914,
      "w": 0.041492
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 71
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54683b",
        "height": 0.14318,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2114a",
            "leftCorner": {
              "x": 10.667,
              "y": 23.778,
              "z": 0.117
            },
            "rightCorner": {
              "x": 10.534,
              "y": 23.789,
              "z": 0.117
            },
            "gtin": "4101730003487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2114b",
            "leftCorner": {
              "x": 10.534,
              "y": 23.788,
              "z": 0.117
            },
            "rightCorner": {
              "x": 10.453,
              "y": 23.795,
              "z": 0.117
            },
            "gtin": "4101730005481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2114c",
            "leftCorner": {
              "x": 10.453,
              "y": 23.795,
              "z": 0.117
            },
            "rightCorner": {
              "x": 10.373,
              "y": 23.802,
              "z": 0.117
            },
            "gtin": "4101730005481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2114d",
            "leftCorner": {
              "x": 10.373,
              "y": 23.802,
              "z": 0.117
            },
            "rightCorner": {
              "x": 10.293,
              "y": 23.808,
              "z": 0.117
            },
            "gtin": "4101730005481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2114e",
            "leftCorner": {
              "x": 10.292,
              "y": 23.803,
              "z": 0.117
            },
            "rightCorner": {
              "x": 10.114,
              "y": 23.818,
              "z": 0.117
            },
            "gtin": "4101730030032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2114f",
            "leftCorner": {
              "x": 10.114,
              "y": 23.817,
              "z": 0.117
            },
            "rightCorner": {
              "x": 9.992,
              "y": 23.827,
              "z": 0.117
            },
            "gtin": "4101730030087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21150",
            "leftCorner": {
              "x": 9.992,
              "y": 23.827,
              "z": 0.117
            },
            "rightCorner": {
              "x": 9.869,
              "y": 23.837,
              "z": 0.117
            },
            "gtin": "4101730030087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21151",
            "leftCorner": {
              "x": 9.87,
              "y": 23.845,
              "z": 0.117
            },
            "rightCorner": {
              "x": 9.773,
              "y": 23.853,
              "z": 0.117
            },
            "gtin": "4101730035112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21152",
            "leftCorner": {
              "x": 9.772,
              "y": 23.843,
              "z": 0.117
            },
            "rightCorner": {
              "x": 9.644,
              "y": 23.854,
              "z": 0.117
            },
            "gtin": "3046920045315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21153",
            "leftCorner": {
              "x": 9.644,
              "y": 23.854,
              "z": 0.117
            },
            "rightCorner": {
              "x": 9.516,
              "y": 23.864,
              "z": 0.117
            },
            "gtin": "3046920045315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21154",
            "leftCorner": {
              "x": 9.516,
              "y": 23.864,
              "z": 0.117
            },
            "rightCorner": {
              "x": 9.387,
              "y": 23.875,
              "z": 0.117
            },
            "gtin": "3046920045315",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546839",
        "height": 0.49789,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a210bd",
            "leftCorner": {
              "x": 10.619,
              "y": 23.786,
              "z": 0.407
            },
            "rightCorner": {
              "x": 10.469,
              "y": 23.799,
              "z": 0.407
            },
            "gtin": "4101730002749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210be",
            "leftCorner": {
              "x": 10.469,
              "y": 23.799,
              "z": 0.407
            },
            "rightCorner": {
              "x": 10.318,
              "y": 23.811,
              "z": 0.407
            },
            "gtin": "4101730002749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210bf",
            "leftCorner": {
              "x": 10.318,
              "y": 23.811,
              "z": 0.407
            },
            "rightCorner": {
              "x": 10.168,
              "y": 23.824,
              "z": 0.407
            },
            "gtin": "4101730002749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210c0",
            "leftCorner": {
              "x": 10.168,
              "y": 23.824,
              "z": 0.407
            },
            "rightCorner": {
              "x": 10.018,
              "y": 23.836,
              "z": 0.407
            },
            "gtin": "4101730002749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210c1",
            "leftCorner": {
              "x": 10.016,
              "y": 23.821,
              "z": 0.407
            },
            "rightCorner": {
              "x": 9.813,
              "y": 23.839,
              "z": 0.407
            },
            "gtin": "4101730005115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210c2",
            "leftCorner": {
              "x": 9.813,
              "y": 23.839,
              "z": 0.407
            },
            "rightCorner": {
              "x": 9.609,
              "y": 23.855,
              "z": 0.407
            },
            "gtin": "4101730005115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210c3",
            "leftCorner": {
              "x": 9.609,
              "y": 23.855,
              "z": 0.407
            },
            "rightCorner": {
              "x": 9.405,
              "y": 23.873,
              "z": 0.407
            },
            "gtin": "4101730005115",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546835",
        "height": 0.74366,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a210f3",
            "leftCorner": {
              "x": 10.666,
              "y": 23.77,
              "z": 0.608
            },
            "rightCorner": {
              "x": 10.56,
              "y": 23.779,
              "z": 0.608
            },
            "gtin": "4101730002718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210f4",
            "leftCorner": {
              "x": 10.56,
              "y": 23.779,
              "z": 0.608
            },
            "rightCorner": {
              "x": 10.454,
              "y": 23.788,
              "z": 0.608
            },
            "gtin": "4101730002718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210f5",
            "leftCorner": {
              "x": 10.455,
              "y": 23.792,
              "z": 0.608
            },
            "rightCorner": {
              "x": 10.349,
              "y": 23.801,
              "z": 0.608
            },
            "gtin": "4101730003869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210f6",
            "leftCorner": {
              "x": 10.349,
              "y": 23.801,
              "z": 0.608
            },
            "rightCorner": {
              "x": 10.244,
              "y": 23.81,
              "z": 0.608
            },
            "gtin": "4101730003869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210f7",
            "leftCorner": {
              "x": 10.243,
              "y": 23.802,
              "z": 0.608
            },
            "rightCorner": {
              "x": 10.165,
              "y": 23.809,
              "z": 0.608
            },
            "gtin": "4101730004835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210f8",
            "leftCorner": {
              "x": 10.165,
              "y": 23.809,
              "z": 0.608
            },
            "rightCorner": {
              "x": 10.086,
              "y": 23.816,
              "z": 0.608
            },
            "gtin": "4101730004835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210f9",
            "leftCorner": {
              "x": 10.086,
              "y": 23.816,
              "z": 0.608
            },
            "rightCorner": {
              "x": 10.007,
              "y": 23.822,
              "z": 0.608
            },
            "gtin": "4101730004835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210fa",
            "leftCorner": {
              "x": 10.008,
              "y": 23.823,
              "z": 0.608
            },
            "rightCorner": {
              "x": 9.878,
              "y": 23.833,
              "z": 0.608
            },
            "gtin": "4101730005153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210fb",
            "leftCorner": {
              "x": 9.877,
              "y": 23.825,
              "z": 0.608
            },
            "rightCorner": {
              "x": 9.771,
              "y": 23.834,
              "z": 0.608
            },
            "gtin": "4101730003555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210fc",
            "leftCorner": {
              "x": 9.771,
              "y": 23.834,
              "z": 0.608
            },
            "rightCorner": {
              "x": 9.665,
              "y": 23.842,
              "z": 0.608
            },
            "gtin": "4101730003555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210fd",
            "leftCorner": {
              "x": 9.666,
              "y": 23.849,
              "z": 0.608
            },
            "rightCorner": {
              "x": 9.571,
              "y": 23.858,
              "z": 0.608
            },
            "gtin": "4101730003562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210fe",
            "leftCorner": {
              "x": 9.571,
              "y": 23.858,
              "z": 0.608
            },
            "rightCorner": {
              "x": 9.477,
              "y": 23.866,
              "z": 0.608
            },
            "gtin": "4101730003562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210ff",
            "leftCorner": {
              "x": 9.477,
              "y": 23.866,
              "z": 0.608
            },
            "rightCorner": {
              "x": 9.383,
              "y": 23.873,
              "z": 0.608
            },
            "gtin": "4101730003562",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546837",
        "height": 0.99837,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a211ad",
            "leftCorner": {
              "x": 10.641,
              "y": 23.783,
              "z": 0.817
            },
            "rightCorner": {
              "x": 10.516,
              "y": 23.793,
              "z": 0.817
            },
            "gtin": "4000539103766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211ae",
            "leftCorner": {
              "x": 10.516,
              "y": 23.801,
              "z": 0.817
            },
            "rightCorner": {
              "x": 10.39,
              "y": 23.813,
              "z": 0.817
            },
            "gtin": "4000539109980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211af",
            "leftCorner": {
              "x": 10.39,
              "y": 23.813,
              "z": 0.817
            },
            "rightCorner": {
              "x": 10.263,
              "y": 23.823,
              "z": 0.817
            },
            "gtin": "4000539109980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211b0",
            "leftCorner": {
              "x": 10.262,
              "y": 23.818,
              "z": 0.817
            },
            "rightCorner": {
              "x": 10.17,
              "y": 23.825,
              "z": 0.817
            },
            "gtin": "4000539396427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211b1",
            "leftCorner": {
              "x": 10.17,
              "y": 23.825,
              "z": 0.817
            },
            "rightCorner": {
              "x": 10.078,
              "y": 23.833,
              "z": 0.817
            },
            "gtin": "4000539396427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211b2",
            "leftCorner": {
              "x": 10.078,
              "y": 23.826,
              "z": 0.817
            },
            "rightCorner": {
              "x": 10.007,
              "y": 23.833,
              "z": 0.817
            },
            "gtin": "4000539110467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211b3",
            "leftCorner": {
              "x": 10.007,
              "y": 23.833,
              "z": 0.817
            },
            "rightCorner": {
              "x": 9.935,
              "y": 23.839,
              "z": 0.817
            },
            "gtin": "4000539110467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211b4",
            "leftCorner": {
              "x": 9.936,
              "y": 23.843,
              "z": 0.817
            },
            "rightCorner": {
              "x": 9.793,
              "y": 23.855,
              "z": 0.817
            },
            "gtin": "4000539126604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211b5",
            "leftCorner": {
              "x": 9.792,
              "y": 23.845,
              "z": 0.817
            },
            "rightCorner": {
              "x": 9.63,
              "y": 23.858,
              "z": 0.817
            },
            "gtin": "4000539110566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211b6",
            "leftCorner": {
              "x": 9.63,
              "y": 23.861,
              "z": 0.817
            },
            "rightCorner": {
              "x": 9.477,
              "y": 23.873,
              "z": 0.817
            },
            "gtin": "4000539118883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211b7",
            "leftCorner": {
              "x": 9.477,
              "y": 23.873,
              "z": 0.817
            },
            "rightCorner": {
              "x": 9.374,
              "y": 23.882,
              "z": 0.817
            },
            "gtin": "4000539103827",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546836",
        "height": 1.2579,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a212b9",
            "leftCorner": {
              "x": 10.656,
              "y": 23.81,
              "z": 1.029
            },
            "rightCorner": {
              "x": 10.474,
              "y": 23.825,
              "z": 1.029
            },
            "gtin": "4000539103780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212bb",
            "leftCorner": {
              "x": 10.472,
              "y": 23.796,
              "z": 1.029
            },
            "rightCorner": {
              "x": 10.305,
              "y": 23.81,
              "z": 1.029
            },
            "gtin": "4000539114229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212bc",
            "leftCorner": {
              "x": 10.304,
              "y": 23.802,
              "z": 1.029
            },
            "rightCorner": {
              "x": 10.077,
              "y": 23.821,
              "z": 1.029
            },
            "gtin": "4000539320804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212bd",
            "leftCorner": {
              "x": 10.078,
              "y": 23.835,
              "z": 1.029
            },
            "rightCorner": {
              "x": 9.975,
              "y": 23.843,
              "z": 1.029
            },
            "gtin": "4000539110627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212be",
            "leftCorner": {
              "x": 9.975,
              "y": 23.843,
              "z": 1.029
            },
            "rightCorner": {
              "x": 9.873,
              "y": 23.852,
              "z": 1.029
            },
            "gtin": "4000539110627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212bf",
            "leftCorner": {
              "x": 9.871,
              "y": 23.83,
              "z": 1.029
            },
            "rightCorner": {
              "x": 9.75,
              "y": 23.84,
              "z": 1.029
            },
            "gtin": "4000539144462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212c0",
            "leftCorner": {
              "x": 9.75,
              "y": 23.843,
              "z": 1.029
            },
            "rightCorner": {
              "x": 9.635,
              "y": 23.852,
              "z": 1.029
            },
            "gtin": "4000539144189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212c1",
            "leftCorner": {
              "x": 9.635,
              "y": 23.852,
              "z": 1.029
            },
            "rightCorner": {
              "x": 9.504,
              "y": 23.864,
              "z": 1.029
            },
            "gtin": "4000539143229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212ba",
            "leftCorner": {
              "x": 9.504,
              "y": 23.858,
              "z": 1.029
            },
            "rightCorner": {
              "x": 9.406,
              "y": 23.866,
              "z": 1.029
            },
            "gtin": "4000539110863",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546838",
        "height": 1.5004,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a210d8",
            "leftCorner": {
              "x": 10.648,
              "y": 23.783,
              "z": 1.228
            },
            "rightCorner": {
              "x": 10.578,
              "y": 23.788,
              "z": 1.228
            },
            "gtin": "4000539124303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210d9",
            "leftCorner": {
              "x": 10.578,
              "y": 23.788,
              "z": 1.228
            },
            "rightCorner": {
              "x": 10.507,
              "y": 23.794,
              "z": 1.228
            },
            "gtin": "4000539124303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210da",
            "leftCorner": {
              "x": 10.507,
              "y": 23.792,
              "z": 1.228
            },
            "rightCorner": {
              "x": 10.394,
              "y": 23.801,
              "z": 1.228
            },
            "gtin": "4000539103964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210db",
            "leftCorner": {
              "x": 10.394,
              "y": 23.801,
              "z": 1.228
            },
            "rightCorner": {
              "x": 10.28,
              "y": 23.811,
              "z": 1.228
            },
            "gtin": "4000539103964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210dc",
            "leftCorner": {
              "x": 10.279,
              "y": 23.808,
              "z": 1.228
            },
            "rightCorner": {
              "x": 10.199,
              "y": 23.814,
              "z": 1.228
            },
            "gtin": "4000539103063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210dd",
            "leftCorner": {
              "x": 10.199,
              "y": 23.814,
              "z": 1.228
            },
            "rightCorner": {
              "x": 10.118,
              "y": 23.821,
              "z": 1.228
            },
            "gtin": "4000539103063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210de",
            "leftCorner": {
              "x": 10.117,
              "y": 23.816,
              "z": 1.228
            },
            "rightCorner": {
              "x": 10.042,
              "y": 23.823,
              "z": 1.228
            },
            "gtin": "4000539110382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210df",
            "leftCorner": {
              "x": 10.042,
              "y": 23.823,
              "z": 1.228
            },
            "rightCorner": {
              "x": 9.967,
              "y": 23.829,
              "z": 1.228
            },
            "gtin": "4000539110382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210e0",
            "leftCorner": {
              "x": 9.967,
              "y": 23.832,
              "z": 1.228
            },
            "rightCorner": {
              "x": 9.758,
              "y": 23.85,
              "z": 1.228
            },
            "gtin": "4000539111747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210e1",
            "leftCorner": {
              "x": 9.757,
              "y": 23.843,
              "z": 1.228
            },
            "rightCorner": {
              "x": 9.544,
              "y": 23.861,
              "z": 1.228
            },
            "gtin": "4000539105722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210e2",
            "leftCorner": {
              "x": 9.544,
              "y": 23.861,
              "z": 1.228
            },
            "rightCorner": {
              "x": 9.33,
              "y": 23.879,
              "z": 1.228
            },
            "gtin": "4000539105722",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54683a",
        "height": 1.7498,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2119e",
            "leftCorner": {
              "x": 10.64,
              "y": 23.807,
              "z": 1.432
            },
            "rightCorner": {
              "x": 10.448,
              "y": 23.823,
              "z": 1.432
            },
            "gtin": "4000539103889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2119f",
            "leftCorner": {
              "x": 10.448,
              "y": 23.813,
              "z": 1.432
            },
            "rightCorner": {
              "x": 10.262,
              "y": 23.828,
              "z": 1.432
            },
            "gtin": "4000539103162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211a0",
            "leftCorner": {
              "x": 10.262,
              "y": 23.824,
              "z": 1.432
            },
            "rightCorner": {
              "x": 10.104,
              "y": 23.837,
              "z": 1.432
            },
            "gtin": "4000539103186",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211a1",
            "leftCorner": {
              "x": 10.103,
              "y": 23.822,
              "z": 1.432
            },
            "rightCorner": {
              "x": 9.87,
              "y": 23.842,
              "z": 1.432
            },
            "gtin": "4000539103841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211a2",
            "leftCorner": {
              "x": 9.87,
              "y": 23.847,
              "z": 1.432
            },
            "rightCorner": {
              "x": 9.776,
              "y": 23.854,
              "z": 1.432
            },
            "gtin": "4000539103865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211a3",
            "leftCorner": {
              "x": 9.776,
              "y": 23.854,
              "z": 1.432
            },
            "rightCorner": {
              "x": 9.682,
              "y": 23.862,
              "z": 1.432
            },
            "gtin": "4000539103865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211a4",
            "leftCorner": {
              "x": 9.681,
              "y": 23.853,
              "z": 1.432
            },
            "rightCorner": {
              "x": 9.579,
              "y": 23.862,
              "z": 1.432
            },
            "gtin": "4000539103049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211a5",
            "leftCorner": {
              "x": 9.579,
              "y": 23.862,
              "z": 1.432
            },
            "rightCorner": {
              "x": 9.477,
              "y": 23.87,
              "z": 1.432
            },
            "gtin": "4000539103049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211a6",
            "leftCorner": {
              "x": 9.477,
              "y": 23.87,
              "z": 1.432
            },
            "rightCorner": {
              "x": 9.374,
              "y": 23.879,
              "z": 1.432
            },
            "gtin": "4000539103049",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a16",
    "rightNeighborShelfId": "50a18"
  },
  {
    "id": "50a18",
    "name": "50a18",
    "x": 9.405,
    "y": 23.931,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99913,
      "w": 0.041806
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 74
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546841",
        "height": 0.14101,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21155",
            "leftCorner": {
              "x": 9.381,
              "y": 23.876,
              "z": 0.115
            },
            "rightCorner": {
              "x": 9.244,
              "y": 23.887,
              "z": 0.115
            },
            "gtin": "3046920045308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21156",
            "leftCorner": {
              "x": 9.244,
              "y": 23.887,
              "z": 0.115
            },
            "rightCorner": {
              "x": 9.108,
              "y": 23.899,
              "z": 0.115
            },
            "gtin": "3046920045308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21157",
            "leftCorner": {
              "x": 9.107,
              "y": 23.894,
              "z": 0.115
            },
            "rightCorner": {
              "x": 9.006,
              "y": 23.903,
              "z": 0.115
            },
            "gtin": "4000539105029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21158",
            "leftCorner": {
              "x": 9.006,
              "y": 23.903,
              "z": 0.115
            },
            "rightCorner": {
              "x": 8.904,
              "y": 23.911,
              "z": 0.115
            },
            "gtin": "4000539105029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21159",
            "leftCorner": {
              "x": 8.903,
              "y": 23.896,
              "z": 0.115
            },
            "rightCorner": {
              "x": 8.754,
              "y": 23.908,
              "z": 0.115
            },
            "gtin": "4000539104824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2115a",
            "leftCorner": {
              "x": 8.755,
              "y": 23.919,
              "z": 0.115
            },
            "rightCorner": {
              "x": 8.652,
              "y": 23.928,
              "z": 0.115
            },
            "gtin": "4000539104886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2115b",
            "leftCorner": {
              "x": 8.652,
              "y": 23.928,
              "z": 0.115
            },
            "rightCorner": {
              "x": 8.549,
              "y": 23.936,
              "z": 0.115
            },
            "gtin": "4000539104886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2115c",
            "leftCorner": {
              "x": 8.549,
              "y": 23.936,
              "z": 0.115
            },
            "rightCorner": {
              "x": 8.446,
              "y": 23.946,
              "z": 0.115
            },
            "gtin": "4000539104886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2115d",
            "leftCorner": {
              "x": 8.446,
              "y": 23.942,
              "z": 0.115
            },
            "rightCorner": {
              "x": 8.34,
              "y": 23.951,
              "z": 0.115
            },
            "gtin": "4000539103742",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2115e",
            "leftCorner": {
              "x": 8.34,
              "y": 23.947,
              "z": 0.115
            },
            "rightCorner": {
              "x": 8.241,
              "y": 23.955,
              "z": 0.115
            },
            "gtin": "4000539320101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2110c",
            "leftCorner": {
              "x": 8.242,
              "y": 23.971,
              "z": 0.115
            },
            "rightCorner": {
              "x": 8.155,
              "y": 23.978,
              "z": 0.115
            },
            "gtin": "4000539320002",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54683c",
        "height": 0.49058,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a210c4",
            "leftCorner": {
              "x": 9.4,
              "y": 23.891,
              "z": 0.401
            },
            "rightCorner": {
              "x": 9.319,
              "y": 23.897,
              "z": 0.401
            },
            "gtin": "4000539107023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210c5",
            "leftCorner": {
              "x": 9.319,
              "y": 23.897,
              "z": 0.401
            },
            "rightCorner": {
              "x": 9.238,
              "y": 23.904,
              "z": 0.401
            },
            "gtin": "4000539107023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210c6",
            "leftCorner": {
              "x": 9.238,
              "y": 23.904,
              "z": 0.401
            },
            "rightCorner": {
              "x": 9.157,
              "y": 23.911,
              "z": 0.401
            },
            "gtin": "4000539107023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210c7",
            "leftCorner": {
              "x": 9.157,
              "y": 23.911,
              "z": 0.401
            },
            "rightCorner": {
              "x": 9.076,
              "y": 23.918,
              "z": 0.401
            },
            "gtin": "4000539107023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210c8",
            "leftCorner": {
              "x": 9.074,
              "y": 23.904,
              "z": 0.401
            },
            "rightCorner": {
              "x": 8.921,
              "y": 23.918,
              "z": 0.401
            },
            "gtin": "4000539109966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210c9",
            "leftCorner": {
              "x": 8.921,
              "y": 23.927,
              "z": 0.401
            },
            "rightCorner": {
              "x": 8.79,
              "y": 23.939,
              "z": 0.401
            },
            "gtin": "4000539105302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210ca",
            "leftCorner": {
              "x": 8.79,
              "y": 23.939,
              "z": 0.401
            },
            "rightCorner": {
              "x": 8.658,
              "y": 23.949,
              "z": 0.401
            },
            "gtin": "4000539105302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210cb",
            "leftCorner": {
              "x": 8.658,
              "y": 23.949,
              "z": 0.401
            },
            "rightCorner": {
              "x": 8.526,
              "y": 23.961,
              "z": 0.401
            },
            "gtin": "4000539105302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210cc",
            "leftCorner": {
              "x": 8.526,
              "y": 23.961,
              "z": 0.401
            },
            "rightCorner": {
              "x": 8.394,
              "y": 23.971,
              "z": 0.401
            },
            "gtin": "4000539105302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210cd",
            "leftCorner": {
              "x": 8.394,
              "y": 23.971,
              "z": 0.401
            },
            "rightCorner": {
              "x": 8.262,
              "y": 23.983,
              "z": 0.401
            },
            "gtin": "4000539105302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21071",
            "leftCorner": {
              "x": 8.261,
              "y": 23.971,
              "z": 0.401
            },
            "rightCorner": {
              "x": 8.155,
              "y": 23.979,
              "z": 0.401
            },
            "gtin": "4000539147067",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54683e",
        "height": 0.74196,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21100",
            "leftCorner": {
              "x": 9.378,
              "y": 23.898,
              "z": 0.607
            },
            "rightCorner": {
              "x": 9.305,
              "y": 23.904,
              "z": 0.607
            },
            "gtin": "4000539149047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21101",
            "leftCorner": {
              "x": 9.305,
              "y": 23.904,
              "z": 0.607
            },
            "rightCorner": {
              "x": 9.233,
              "y": 23.911,
              "z": 0.607
            },
            "gtin": "4000539149047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21102",
            "leftCorner": {
              "x": 9.233,
              "y": 23.912,
              "z": 0.607
            },
            "rightCorner": {
              "x": 9.113,
              "y": 23.921,
              "z": 0.607
            },
            "gtin": "4000539149122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21103",
            "leftCorner": {
              "x": 9.113,
              "y": 23.916,
              "z": 0.607
            },
            "rightCorner": {
              "x": 8.96,
              "y": 23.929,
              "z": 0.607
            },
            "gtin": "4000539149085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21104",
            "leftCorner": {
              "x": 8.959,
              "y": 23.916,
              "z": 0.607
            },
            "rightCorner": {
              "x": 8.893,
              "y": 23.921,
              "z": 0.607
            },
            "gtin": "4000539119989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21105",
            "leftCorner": {
              "x": 8.893,
              "y": 23.921,
              "z": 0.607
            },
            "rightCorner": {
              "x": 8.827,
              "y": 23.927,
              "z": 0.607
            },
            "gtin": "4000539119989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21106",
            "leftCorner": {
              "x": 8.827,
              "y": 23.927,
              "z": 0.607
            },
            "rightCorner": {
              "x": 8.762,
              "y": 23.933,
              "z": 0.607
            },
            "gtin": "4000539119989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21107",
            "leftCorner": {
              "x": 8.761,
              "y": 23.927,
              "z": 0.607
            },
            "rightCorner": {
              "x": 8.637,
              "y": 23.937,
              "z": 0.607
            },
            "gtin": "4000539408205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21108",
            "leftCorner": {
              "x": 8.637,
              "y": 23.937,
              "z": 0.607
            },
            "rightCorner": {
              "x": 8.512,
              "y": 23.948,
              "z": 0.607
            },
            "gtin": "4000539408205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21109",
            "leftCorner": {
              "x": 8.512,
              "y": 23.948,
              "z": 0.607
            },
            "rightCorner": {
              "x": 8.388,
              "y": 23.958,
              "z": 0.607
            },
            "gtin": "4000539408205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210ec",
            "leftCorner": {
              "x": 8.388,
              "y": 23.955,
              "z": 0.607
            },
            "rightCorner": {
              "x": 8.31,
              "y": 23.961,
              "z": 0.607
            },
            "gtin": "4000539365201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210ed",
            "leftCorner": {
              "x": 8.31,
              "y": 23.961,
              "z": 0.607
            },
            "rightCorner": {
              "x": 8.232,
              "y": 23.968,
              "z": 0.607
            },
            "gtin": "4000539365201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210ee",
            "leftCorner": {
              "x": 8.232,
              "y": 23.968,
              "z": 0.607
            },
            "rightCorner": {
              "x": 8.154,
              "y": 23.975,
              "z": 0.607
            },
            "gtin": "4000539365201",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54683f",
        "height": 0.99304,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a211b8",
            "leftCorner": {
              "x": 9.369,
              "y": 23.905,
              "z": 0.812
            },
            "rightCorner": {
              "x": 9.285,
              "y": 23.912,
              "z": 0.812
            },
            "gtin": "4000539135408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211b9",
            "leftCorner": {
              "x": 9.285,
              "y": 23.912,
              "z": 0.812
            },
            "rightCorner": {
              "x": 9.2,
              "y": 23.919,
              "z": 0.812
            },
            "gtin": "4000539135408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211ba",
            "leftCorner": {
              "x": 9.2,
              "y": 23.919,
              "z": 0.812
            },
            "rightCorner": {
              "x": 9.115,
              "y": 23.926,
              "z": 0.812
            },
            "gtin": "4000539135408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211bb",
            "leftCorner": {
              "x": 9.115,
              "y": 23.926,
              "z": 0.812
            },
            "rightCorner": {
              "x": 9.031,
              "y": 23.934,
              "z": 0.812
            },
            "gtin": "4000539135408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211bc",
            "leftCorner": {
              "x": 9.03,
              "y": 23.926,
              "z": 0.812
            },
            "rightCorner": {
              "x": 8.93,
              "y": 23.935,
              "z": 0.812
            },
            "gtin": "4000539144127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211bd",
            "leftCorner": {
              "x": 8.93,
              "y": 23.935,
              "z": 0.812
            },
            "rightCorner": {
              "x": 8.829,
              "y": 23.943,
              "z": 0.812
            },
            "gtin": "4000539144127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211be",
            "leftCorner": {
              "x": 8.829,
              "y": 23.94,
              "z": 0.812
            },
            "rightCorner": {
              "x": 8.72,
              "y": 23.949,
              "z": 0.812
            },
            "gtin": "4000539094804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211bf",
            "leftCorner": {
              "x": 8.72,
              "y": 23.949,
              "z": 0.812
            },
            "rightCorner": {
              "x": 8.611,
              "y": 23.958,
              "z": 0.812
            },
            "gtin": "4000539094804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211c0",
            "leftCorner": {
              "x": 8.611,
              "y": 23.958,
              "z": 0.812
            },
            "rightCorner": {
              "x": 8.502,
              "y": 23.967,
              "z": 0.812
            },
            "gtin": "4000539094804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211c1",
            "leftCorner": {
              "x": 8.502,
              "y": 23.967,
              "z": 0.812
            },
            "rightCorner": {
              "x": 8.393,
              "y": 23.976,
              "z": 0.812
            },
            "gtin": "4000539094804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211c2",
            "leftCorner": {
              "x": 8.393,
              "y": 23.976,
              "z": 0.812
            },
            "rightCorner": {
              "x": 8.284,
              "y": 23.986,
              "z": 0.812
            },
            "gtin": "4000539094804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211ab",
            "leftCorner": {
              "x": 8.283,
              "y": 23.966,
              "z": 0.812
            },
            "rightCorner": {
              "x": 8.219,
              "y": 23.971,
              "z": 0.812
            },
            "gtin": "4000539113369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211ac",
            "leftCorner": {
              "x": 8.219,
              "y": 23.971,
              "z": 0.812
            },
            "rightCorner": {
              "x": 8.154,
              "y": 23.977,
              "z": 0.812
            },
            "gtin": "4000539113369",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546842",
        "height": 1.2466,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a212c2",
            "leftCorner": {
              "x": 9.405,
              "y": 23.93,
              "z": 1.02
            },
            "rightCorner": {
              "x": 9.293,
              "y": 23.94,
              "z": 1.02
            },
            "gtin": "4000539119941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212c3",
            "leftCorner": {
              "x": 9.293,
              "y": 23.94,
              "z": 1.02
            },
            "rightCorner": {
              "x": 9.182,
              "y": 23.949,
              "z": 1.02
            },
            "gtin": "4000539119941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212c4",
            "leftCorner": {
              "x": 9.182,
              "y": 23.949,
              "z": 1.02
            },
            "rightCorner": {
              "x": 9.071,
              "y": 23.959,
              "z": 1.02
            },
            "gtin": "4000539119941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212c5",
            "leftCorner": {
              "x": 9.071,
              "y": 23.959,
              "z": 1.02
            },
            "rightCorner": {
              "x": 8.959,
              "y": 23.967,
              "z": 1.02
            },
            "gtin": "4000539119941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212c8",
            "leftCorner": {
              "x": 8.956,
              "y": 23.932,
              "z": 1.02
            },
            "rightCorner": {
              "x": 8.855,
              "y": 23.94,
              "z": 1.02
            },
            "gtin": "4000539059100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212c9",
            "leftCorner": {
              "x": 8.855,
              "y": 23.94,
              "z": 1.02
            },
            "rightCorner": {
              "x": 8.754,
              "y": 23.949,
              "z": 1.02
            },
            "gtin": "4000539059100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212ca",
            "leftCorner": {
              "x": 8.754,
              "y": 23.949,
              "z": 1.02
            },
            "rightCorner": {
              "x": 8.653,
              "y": 23.957,
              "z": 1.02
            },
            "gtin": "4000539059100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212cb",
            "leftCorner": {
              "x": 8.653,
              "y": 23.957,
              "z": 1.02
            },
            "rightCorner": {
              "x": 8.552,
              "y": 23.966,
              "z": 1.02
            },
            "gtin": "4000539059100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212cc",
            "leftCorner": {
              "x": 8.55,
              "y": 23.943,
              "z": 1.02
            },
            "rightCorner": {
              "x": 8.442,
              "y": 23.953,
              "z": 1.02
            },
            "gtin": "4000539142987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212cd",
            "leftCorner": {
              "x": 8.442,
              "y": 23.953,
              "z": 1.02
            },
            "rightCorner": {
              "x": 8.334,
              "y": 23.962,
              "z": 1.02
            },
            "gtin": "4000539142987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212c6",
            "leftCorner": {
              "x": 8.335,
              "y": 23.976,
              "z": 1.02
            },
            "rightCorner": {
              "x": 8.245,
              "y": 23.984,
              "z": 1.02
            },
            "gtin": "4000539110320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212c7",
            "leftCorner": {
              "x": 8.245,
              "y": 23.984,
              "z": 1.02
            },
            "rightCorner": {
              "x": 8.156,
              "y": 23.991,
              "z": 1.02
            },
            "gtin": "4000539110320",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546840",
        "height": 1.4984,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a210e3",
            "leftCorner": {
              "x": 9.325,
              "y": 23.894,
              "z": 1.226
            },
            "rightCorner": {
              "x": 9.112,
              "y": 23.911,
              "z": 1.226
            },
            "gtin": "4000539097805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210e4",
            "leftCorner": {
              "x": 9.112,
              "y": 23.911,
              "z": 1.226
            },
            "rightCorner": {
              "x": 8.9,
              "y": 23.93,
              "z": 1.226
            },
            "gtin": "4000539097805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210e5",
            "leftCorner": {
              "x": 8.899,
              "y": 23.921,
              "z": 1.226
            },
            "rightCorner": {
              "x": 8.659,
              "y": 23.941,
              "z": 1.226
            },
            "gtin": "4000539387708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210e6",
            "leftCorner": {
              "x": 8.658,
              "y": 23.938,
              "z": 1.226
            },
            "rightCorner": {
              "x": 8.551,
              "y": 23.947,
              "z": 1.226
            },
            "gtin": "4000539097706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210e7",
            "leftCorner": {
              "x": 8.551,
              "y": 23.947,
              "z": 1.226
            },
            "rightCorner": {
              "x": 8.444,
              "y": 23.956,
              "z": 1.226
            },
            "gtin": "4000539097706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210d2",
            "leftCorner": {
              "x": 8.444,
              "y": 23.957,
              "z": 1.226
            },
            "rightCorner": {
              "x": 8.3,
              "y": 23.969,
              "z": 1.226
            },
            "gtin": "4000539100901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a210d3",
            "leftCorner": {
              "x": 8.3,
              "y": 23.969,
              "z": 1.226
            },
            "rightCorner": {
              "x": 8.155,
              "y": 23.981,
              "z": 1.226
            },
            "gtin": "4000539100901",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54683d",
        "height": 1.7485,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a211a7",
            "leftCorner": {
              "x": 9.369,
              "y": 23.897,
              "z": 1.431
            },
            "rightCorner": {
              "x": 9.112,
              "y": 23.918,
              "z": 1.431
            },
            "gtin": "4000539103087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211a8",
            "leftCorner": {
              "x": 9.112,
              "y": 23.922,
              "z": 1.431
            },
            "rightCorner": {
              "x": 9.014,
              "y": 23.929,
              "z": 1.431
            },
            "gtin": "4000539102981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211a9",
            "leftCorner": {
              "x": 9.014,
              "y": 23.929,
              "z": 1.431
            },
            "rightCorner": {
              "x": 8.917,
              "y": 23.937,
              "z": 1.431
            },
            "gtin": "4000539102981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211aa",
            "leftCorner": {
              "x": 8.915,
              "y": 23.916,
              "z": 1.431
            },
            "rightCorner": {
              "x": 8.599,
              "y": 23.942,
              "z": 1.431
            },
            "gtin": "4000539103148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21161",
            "leftCorner": {
              "x": 8.6,
              "y": 23.944,
              "z": 1.431
            },
            "rightCorner": {
              "x": 8.451,
              "y": 23.956,
              "z": 1.431
            },
            "gtin": "4000539103124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21162",
            "leftCorner": {
              "x": 8.451,
              "y": 23.956,
              "z": 1.431
            },
            "rightCorner": {
              "x": 8.303,
              "y": 23.969,
              "z": 1.431
            },
            "gtin": "4000539103124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21163",
            "leftCorner": {
              "x": 8.303,
              "y": 23.969,
              "z": 1.431
            },
            "rightCorner": {
              "x": 8.155,
              "y": 23.981,
              "z": 1.431
            },
            "gtin": "4000539103124",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a17"
  },
  {
    "id": "50a19",
    "name": "50a19",
    "x": 9.186,
    "y": 22.608,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.039521,
      "w": 0.99922
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 39
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5467e2",
        "height": 0.14684,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a211d3",
            "leftCorner": {
              "x": 9.229,
              "y": 22.673,
              "z": 0.12
            },
            "rightCorner": {
              "x": 9.426,
              "y": 22.657,
              "z": 0.12
            },
            "gtin": "4001242108543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211d4",
            "leftCorner": {
              "x": 9.426,
              "y": 22.657,
              "z": 0.12
            },
            "rightCorner": {
              "x": 9.623,
              "y": 22.642,
              "z": 0.12
            },
            "gtin": "4001242108543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211d5",
            "leftCorner": {
              "x": 9.623,
              "y": 22.642,
              "z": 0.12
            },
            "rightCorner": {
              "x": 9.819,
              "y": 22.626,
              "z": 0.12
            },
            "gtin": "4001242108543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211d0",
            "leftCorner": {
              "x": 9.819,
              "y": 22.623,
              "z": 0.12
            },
            "rightCorner": {
              "x": 10.009,
              "y": 22.609,
              "z": 0.12
            },
            "gtin": "4001242108567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211d1",
            "leftCorner": {
              "x": 10.009,
              "y": 22.609,
              "z": 0.12
            },
            "rightCorner": {
              "x": 10.198,
              "y": 22.594,
              "z": 0.12
            },
            "gtin": "4001242108567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a211d2",
            "leftCorner": {
              "x": 10.198,
              "y": 22.594,
              "z": 0.12
            },
            "rightCorner": {
              "x": 10.387,
              "y": 22.579,
              "z": 0.12
            },
            "gtin": "4001242108567",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467df",
        "height": 0.60434,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e72d",
            "leftCorner": {
              "x": 9.249,
              "y": 22.675,
              "z": 0.494
            },
            "rightCorner": {
              "x": 9.509,
              "y": 22.655,
              "z": 0.494
            },
            "gtin": "4001242108536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e72e",
            "leftCorner": {
              "x": 9.509,
              "y": 22.655,
              "z": 0.494
            },
            "rightCorner": {
              "x": 9.77,
              "y": 22.635,
              "z": 0.494
            },
            "gtin": "4001242108536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e72f",
            "leftCorner": {
              "x": 9.77,
              "y": 22.632,
              "z": 0.494
            },
            "rightCorner": {
              "x": 10.11,
              "y": 22.604,
              "z": 0.494
            },
            "gtin": "4001242102459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e730",
            "leftCorner": {
              "x": 10.11,
              "y": 22.604,
              "z": 0.494
            },
            "rightCorner": {
              "x": 10.451,
              "y": 22.577,
              "z": 0.494
            },
            "gtin": "4001242102459",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467de",
        "height": 0.95125,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e743",
            "leftCorner": {
              "x": 9.231,
              "y": 22.671,
              "z": 0.778
            },
            "rightCorner": {
              "x": 9.311,
              "y": 22.665,
              "z": 0.778
            },
            "gtin": "5053990127733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e744",
            "leftCorner": {
              "x": 9.311,
              "y": 22.665,
              "z": 0.778
            },
            "rightCorner": {
              "x": 9.391,
              "y": 22.658,
              "z": 0.778
            },
            "gtin": "5053990127733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e745",
            "leftCorner": {
              "x": 9.391,
              "y": 22.658,
              "z": 0.778
            },
            "rightCorner": {
              "x": 9.471,
              "y": 22.652,
              "z": 0.778
            },
            "gtin": "5053990127733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e746",
            "leftCorner": {
              "x": 9.471,
              "y": 22.652,
              "z": 0.778
            },
            "rightCorner": {
              "x": 9.551,
              "y": 22.646,
              "z": 0.778
            },
            "gtin": "5053990127733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e747",
            "leftCorner": {
              "x": 9.551,
              "y": 22.637,
              "z": 0.778
            },
            "rightCorner": {
              "x": 9.638,
              "y": 22.63,
              "z": 0.778
            },
            "gtin": "5053990162413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e748",
            "leftCorner": {
              "x": 9.638,
              "y": 22.63,
              "z": 0.778
            },
            "rightCorner": {
              "x": 9.725,
              "y": 22.623,
              "z": 0.778
            },
            "gtin": "5053990162413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e749",
            "leftCorner": {
              "x": 9.725,
              "y": 22.623,
              "z": 0.778
            },
            "rightCorner": {
              "x": 9.813,
              "y": 22.616,
              "z": 0.778
            },
            "gtin": "5053990162413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e74a",
            "leftCorner": {
              "x": 9.813,
              "y": 22.615,
              "z": 0.778
            },
            "rightCorner": {
              "x": 10.083,
              "y": 22.594,
              "z": 0.778
            },
            "gtin": "5053990127740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e74b",
            "leftCorner": {
              "x": 10.082,
              "y": 22.585,
              "z": 0.778
            },
            "rightCorner": {
              "x": 10.215,
              "y": 22.575,
              "z": 0.778
            },
            "gtin": "5053990175123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e74c",
            "leftCorner": {
              "x": 10.215,
              "y": 22.575,
              "z": 0.778
            },
            "rightCorner": {
              "x": 10.348,
              "y": 22.564,
              "z": 0.778
            },
            "gtin": "5053990175123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e74d",
            "leftCorner": {
              "x": 10.348,
              "y": 22.564,
              "z": 0.778
            },
            "rightCorner": {
              "x": 10.481,
              "y": 22.554,
              "z": 0.778
            },
            "gtin": "5053990175123",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467e0",
        "height": 1.4049,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e6ca",
            "leftCorner": {
              "x": 9.233,
              "y": 22.668,
              "z": 1.149
            },
            "rightCorner": {
              "x": 9.308,
              "y": 22.662,
              "z": 1.149
            },
            "gtin": "5053990127665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6cb",
            "leftCorner": {
              "x": 9.308,
              "y": 22.662,
              "z": 1.149
            },
            "rightCorner": {
              "x": 9.383,
              "y": 22.656,
              "z": 1.149
            },
            "gtin": "5053990127665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6cc",
            "leftCorner": {
              "x": 9.383,
              "y": 22.656,
              "z": 1.149
            },
            "rightCorner": {
              "x": 9.458,
              "y": 22.65,
              "z": 1.149
            },
            "gtin": "5053990127665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6cd",
            "leftCorner": {
              "x": 9.458,
              "y": 22.65,
              "z": 1.149
            },
            "rightCorner": {
              "x": 9.533,
              "y": 22.644,
              "z": 1.149
            },
            "gtin": "5053990127665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6ce",
            "leftCorner": {
              "x": 9.533,
              "y": 22.644,
              "z": 1.149
            },
            "rightCorner": {
              "x": 9.608,
              "y": 22.639,
              "z": 1.149
            },
            "gtin": "5053990127665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6cf",
            "leftCorner": {
              "x": 9.607,
              "y": 22.628,
              "z": 1.149
            },
            "rightCorner": {
              "x": 9.706,
              "y": 22.621,
              "z": 1.149
            },
            "gtin": "5053990151035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6d0",
            "leftCorner": {
              "x": 9.706,
              "y": 22.621,
              "z": 1.149
            },
            "rightCorner": {
              "x": 9.805,
              "y": 22.612,
              "z": 1.149
            },
            "gtin": "5053990151035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6d1",
            "leftCorner": {
              "x": 9.805,
              "y": 22.612,
              "z": 1.149
            },
            "rightCorner": {
              "x": 9.904,
              "y": 22.605,
              "z": 1.149
            },
            "gtin": "5053990151035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6d2",
            "leftCorner": {
              "x": 9.904,
              "y": 22.607,
              "z": 1.149
            },
            "rightCorner": {
              "x": 10.035,
              "y": 22.597,
              "z": 1.149
            },
            "gtin": "5053990127641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6d3",
            "leftCorner": {
              "x": 10.035,
              "y": 22.597,
              "z": 1.149
            },
            "rightCorner": {
              "x": 10.165,
              "y": 22.587,
              "z": 1.149
            },
            "gtin": "5053990127641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6d4",
            "leftCorner": {
              "x": 10.165,
              "y": 22.587,
              "z": 1.149
            },
            "rightCorner": {
              "x": 10.295,
              "y": 22.577,
              "z": 1.149
            },
            "gtin": "5053990127641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6d5",
            "leftCorner": {
              "x": 10.295,
              "y": 22.577,
              "z": 1.149
            },
            "rightCorner": {
              "x": 10.425,
              "y": 22.566,
              "z": 1.149
            },
            "gtin": "5053990127641",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467e1",
        "height": 1.7554,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e708",
            "leftCorner": {
              "x": 9.232,
              "y": 22.661,
              "z": 1.436
            },
            "rightCorner": {
              "x": 9.382,
              "y": 22.649,
              "z": 1.436
            },
            "gtin": "5053990176168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e709",
            "leftCorner": {
              "x": 9.382,
              "y": 22.649,
              "z": 1.436
            },
            "rightCorner": {
              "x": 9.531,
              "y": 22.637,
              "z": 1.436
            },
            "gtin": "5053990176168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e70a",
            "leftCorner": {
              "x": 9.531,
              "y": 22.637,
              "z": 1.436
            },
            "rightCorner": {
              "x": 9.82,
              "y": 22.614,
              "z": 1.436
            },
            "gtin": "5053990175826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e70b",
            "leftCorner": {
              "x": 9.82,
              "y": 22.616,
              "z": 1.436
            },
            "rightCorner": {
              "x": 10.107,
              "y": 22.593,
              "z": 1.436
            },
            "gtin": "5053990175949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e70c",
            "leftCorner": {
              "x": 10.106,
              "y": 22.587,
              "z": 1.436
            },
            "rightCorner": {
              "x": 10.281,
              "y": 22.573,
              "z": 1.436
            },
            "gtin": "5053990175888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e70d",
            "leftCorner": {
              "x": 10.281,
              "y": 22.573,
              "z": 1.436
            },
            "rightCorner": {
              "x": 10.455,
              "y": 22.56,
              "z": 1.436
            },
            "gtin": "5053990175888",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d135f",
    "rightNeighborShelfId": "50a1a"
  },
  {
    "id": "50a1a",
    "name": "50a1a",
    "x": 10.384,
    "y": 22.506,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.033766,
      "w": 0.99943
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 35
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5467e7",
        "height": 0.15771,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a5467e4",
        "height": 0.59769,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e731",
            "leftCorner": {
              "x": 10.449,
              "y": 22.535,
              "z": 0.489
            },
            "rightCorner": {
              "x": 10.632,
              "y": 22.523,
              "z": 0.489
            },
            "gtin": "4000522137082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e732",
            "leftCorner": {
              "x": 10.632,
              "y": 22.523,
              "z": 0.489
            },
            "rightCorner": {
              "x": 10.814,
              "y": 22.51,
              "z": 0.489
            },
            "gtin": "4000522137082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e733",
            "leftCorner": {
              "x": 10.815,
              "y": 22.524,
              "z": 0.489
            },
            "rightCorner": {
              "x": 11.002,
              "y": 22.512,
              "z": 0.489
            },
            "gtin": "4000522137075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e734",
            "leftCorner": {
              "x": 11.003,
              "y": 22.522,
              "z": 0.489
            },
            "rightCorner": {
              "x": 11.213,
              "y": 22.508,
              "z": 0.489
            },
            "gtin": "4000522105265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e735",
            "leftCorner": {
              "x": 11.213,
              "y": 22.508,
              "z": 0.489
            },
            "rightCorner": {
              "x": 11.425,
              "y": 22.494,
              "z": 0.489
            },
            "gtin": "4000522105265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e736",
            "leftCorner": {
              "x": 11.425,
              "y": 22.494,
              "z": 0.489
            },
            "rightCorner": {
              "x": 11.635,
              "y": 22.479,
              "z": 0.489
            },
            "gtin": "4000522105265",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467e5",
        "height": 0.9509,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e74e",
            "leftCorner": {
              "x": 10.482,
              "y": 22.544,
              "z": 0.778
            },
            "rightCorner": {
              "x": 10.676,
              "y": 22.531,
              "z": 0.778
            },
            "gtin": "5026489487083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e74f",
            "leftCorner": {
              "x": 10.676,
              "y": 22.531,
              "z": 0.778
            },
            "rightCorner": {
              "x": 10.87,
              "y": 22.518,
              "z": 0.778
            },
            "gtin": "5026489487083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e750",
            "leftCorner": {
              "x": 10.871,
              "y": 22.529,
              "z": 0.778
            },
            "rightCorner": {
              "x": 11.001,
              "y": 22.52,
              "z": 0.778
            },
            "gtin": "5026489483078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e751",
            "leftCorner": {
              "x": 11.001,
              "y": 22.52,
              "z": 0.778
            },
            "rightCorner": {
              "x": 11.131,
              "y": 22.511,
              "z": 0.778
            },
            "gtin": "5026489483078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e752",
            "leftCorner": {
              "x": 11.131,
              "y": 22.513,
              "z": 0.778
            },
            "rightCorner": {
              "x": 11.303,
              "y": 22.501,
              "z": 0.778
            },
            "gtin": "5026489483023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e753",
            "leftCorner": {
              "x": 11.303,
              "y": 22.501,
              "z": 0.778
            },
            "rightCorner": {
              "x": 11.474,
              "y": 22.489,
              "z": 0.778
            },
            "gtin": "5026489483023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e754",
            "leftCorner": {
              "x": 11.473,
              "y": 22.484,
              "z": 0.778
            },
            "rightCorner": {
              "x": 11.62,
              "y": 22.474,
              "z": 0.778
            },
            "gtin": "5026489483030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e755",
            "leftCorner": {
              "x": 11.62,
              "y": 22.474,
              "z": 0.778
            },
            "rightCorner": {
              "x": 11.766,
              "y": 22.464,
              "z": 0.778
            },
            "gtin": "5026489483030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e756",
            "leftCorner": {
              "x": 11.766,
              "y": 22.464,
              "z": 0.778
            },
            "rightCorner": {
              "x": 11.911,
              "y": 22.454,
              "z": 0.778
            },
            "gtin": "5026489483030",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467e3",
        "height": 1.4024,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e6d6",
            "leftCorner": {
              "x": 10.426,
              "y": 22.545,
              "z": 1.147
            },
            "rightCorner": {
              "x": 10.517,
              "y": 22.539,
              "z": 1.147
            },
            "gtin": "4000522108426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6d7",
            "leftCorner": {
              "x": 10.517,
              "y": 22.539,
              "z": 1.147
            },
            "rightCorner": {
              "x": 10.608,
              "y": 22.533,
              "z": 1.147
            },
            "gtin": "4000522108426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6d8",
            "leftCorner": {
              "x": 10.609,
              "y": 22.546,
              "z": 1.147
            },
            "rightCorner": {
              "x": 10.694,
              "y": 22.54,
              "z": 1.147
            },
            "gtin": "4000522108433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6d9",
            "leftCorner": {
              "x": 10.694,
              "y": 22.54,
              "z": 1.147
            },
            "rightCorner": {
              "x": 10.779,
              "y": 22.535,
              "z": 1.147
            },
            "gtin": "4000522108433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6da",
            "leftCorner": {
              "x": 10.779,
              "y": 22.535,
              "z": 1.147
            },
            "rightCorner": {
              "x": 10.864,
              "y": 22.528,
              "z": 1.147
            },
            "gtin": "4000522108433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6db",
            "leftCorner": {
              "x": 10.864,
              "y": 22.53,
              "z": 1.147
            },
            "rightCorner": {
              "x": 10.965,
              "y": 22.523,
              "z": 1.147
            },
            "gtin": "4000522108440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6dc",
            "leftCorner": {
              "x": 10.965,
              "y": 22.523,
              "z": 1.147
            },
            "rightCorner": {
              "x": 11.067,
              "y": 22.516,
              "z": 1.147
            },
            "gtin": "4000522108440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6dd",
            "leftCorner": {
              "x": 11.067,
              "y": 22.516,
              "z": 1.147
            },
            "rightCorner": {
              "x": 11.168,
              "y": 22.51,
              "z": 1.147
            },
            "gtin": "4000522108440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6de",
            "leftCorner": {
              "x": 11.168,
              "y": 22.51,
              "z": 1.147
            },
            "rightCorner": {
              "x": 11.269,
              "y": 22.503,
              "z": 1.147
            },
            "gtin": "4000522108440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6df",
            "leftCorner": {
              "x": 11.269,
              "y": 22.505,
              "z": 1.147
            },
            "rightCorner": {
              "x": 11.355,
              "y": 22.499,
              "z": 1.147
            },
            "gtin": "8008698031018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6e0",
            "leftCorner": {
              "x": 11.355,
              "y": 22.499,
              "z": 1.147
            },
            "rightCorner": {
              "x": 11.44,
              "y": 22.494,
              "z": 1.147
            },
            "gtin": "8008698031018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6e1",
            "leftCorner": {
              "x": 11.439,
              "y": 22.487,
              "z": 1.147
            },
            "rightCorner": {
              "x": 11.527,
              "y": 22.481,
              "z": 1.147
            },
            "gtin": "8008698031056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6e2",
            "leftCorner": {
              "x": 11.527,
              "y": 22.481,
              "z": 1.147
            },
            "rightCorner": {
              "x": 11.614,
              "y": 22.475,
              "z": 1.147
            },
            "gtin": "8008698031056",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467e6",
        "height": 1.7516,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e70e",
            "leftCorner": {
              "x": 10.456,
              "y": 22.541,
              "z": 1.433
            },
            "rightCorner": {
              "x": 10.555,
              "y": 22.535,
              "z": 1.433
            },
            "gtin": "5053990161966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e70f",
            "leftCorner": {
              "x": 10.555,
              "y": 22.535,
              "z": 1.433
            },
            "rightCorner": {
              "x": 10.654,
              "y": 22.528,
              "z": 1.433
            },
            "gtin": "5053990161966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e710",
            "leftCorner": {
              "x": 10.654,
              "y": 22.528,
              "z": 1.433
            },
            "rightCorner": {
              "x": 10.753,
              "y": 22.521,
              "z": 1.433
            },
            "gtin": "5053990161966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e711",
            "leftCorner": {
              "x": 10.753,
              "y": 22.53,
              "z": 1.433
            },
            "rightCorner": {
              "x": 10.994,
              "y": 22.514,
              "z": 1.433
            },
            "gtin": "5053990168637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e712",
            "leftCorner": {
              "x": 10.992,
              "y": 22.484,
              "z": 1.433
            },
            "rightCorner": {
              "x": 11.278,
              "y": 22.464,
              "z": 1.433
            },
            "gtin": "4260475420383",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e713",
            "leftCorner": {
              "x": 11.279,
              "y": 22.493,
              "z": 1.433
            },
            "rightCorner": {
              "x": 11.445,
              "y": 22.482,
              "z": 1.433
            },
            "gtin": "5053990127726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e714",
            "leftCorner": {
              "x": 11.445,
              "y": 22.482,
              "z": 1.433
            },
            "rightCorner": {
              "x": 11.61,
              "y": 22.471,
              "z": 1.433
            },
            "gtin": "5053990127726",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a19",
    "rightNeighborShelfId": "50a1c"
  },
  {
    "id": "50a1c",
    "name": "50a1c",
    "x": 11.582,
    "y": 22.425,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.033766,
      "w": 0.99943
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 23
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463ab",
        "height": 0.14908,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a5463aa",
        "height": 0.59674,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e737",
            "leftCorner": {
              "x": 11.636,
              "y": 22.473,
              "z": 0.488
            },
            "rightCorner": {
              "x": 11.904,
              "y": 22.455,
              "z": 0.488
            },
            "gtin": "4000522105234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e738",
            "leftCorner": {
              "x": 11.904,
              "y": 22.459,
              "z": 0.488
            },
            "rightCorner": {
              "x": 12.206,
              "y": 22.438,
              "z": 0.488
            },
            "gtin": "4000522105227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e739",
            "leftCorner": {
              "x": 12.206,
              "y": 22.438,
              "z": 0.488
            },
            "rightCorner": {
              "x": 12.509,
              "y": 22.418,
              "z": 0.488
            },
            "gtin": "4000522105227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e73a",
            "leftCorner": {
              "x": 12.509,
              "y": 22.418,
              "z": 0.488
            },
            "rightCorner": {
              "x": 12.81,
              "y": 22.398,
              "z": 0.488
            },
            "gtin": "4000522105227",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463ac",
        "height": 0.9446,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e757",
            "leftCorner": {
              "x": 11.913,
              "y": 22.455,
              "z": 0.773
            },
            "rightCorner": {
              "x": 12.247,
              "y": 22.433,
              "z": 0.773
            },
            "gtin": "4260475420369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e758",
            "leftCorner": {
              "x": 12.248,
              "y": 22.438,
              "z": 0.773
            },
            "rightCorner": {
              "x": 12.535,
              "y": 22.419,
              "z": 0.773
            },
            "gtin": "4031446204338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e759",
            "leftCorner": {
              "x": 12.535,
              "y": 22.424,
              "z": 0.773
            },
            "rightCorner": {
              "x": 12.867,
              "y": 22.401,
              "z": 0.773
            },
            "gtin": "4031446204345",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463a8",
        "height": 1.3984,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e6e3",
            "leftCorner": {
              "x": 11.615,
              "y": 22.471,
              "z": 1.144
            },
            "rightCorner": {
              "x": 11.723,
              "y": 22.464,
              "z": 1.144
            },
            "gtin": "4270001182807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6e4",
            "leftCorner": {
              "x": 11.723,
              "y": 22.464,
              "z": 1.144
            },
            "rightCorner": {
              "x": 11.831,
              "y": 22.456,
              "z": 1.144
            },
            "gtin": "4270001182807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6e5",
            "leftCorner": {
              "x": 11.831,
              "y": 22.453,
              "z": 1.144
            },
            "rightCorner": {
              "x": 11.944,
              "y": 22.446,
              "z": 1.144
            },
            "gtin": "4260720850019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6e6",
            "leftCorner": {
              "x": 11.944,
              "y": 22.446,
              "z": 1.144
            },
            "rightCorner": {
              "x": 12.056,
              "y": 22.438,
              "z": 1.144
            },
            "gtin": "4260720850019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6e7",
            "leftCorner": {
              "x": 12.056,
              "y": 22.438,
              "z": 1.144
            },
            "rightCorner": {
              "x": 12.169,
              "y": 22.43,
              "z": 1.144
            },
            "gtin": "4260720850019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6e8",
            "leftCorner": {
              "x": 12.169,
              "y": 22.435,
              "z": 1.144
            },
            "rightCorner": {
              "x": 12.286,
              "y": 22.427,
              "z": 1.144
            },
            "gtin": "4260720850316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6e9",
            "leftCorner": {
              "x": 12.286,
              "y": 22.427,
              "z": 1.144
            },
            "rightCorner": {
              "x": 12.404,
              "y": 22.419,
              "z": 1.144
            },
            "gtin": "4260720850316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6ea",
            "leftCorner": {
              "x": 12.404,
              "y": 22.419,
              "z": 1.144
            },
            "rightCorner": {
              "x": 12.521,
              "y": 22.412,
              "z": 1.144
            },
            "gtin": "4260720850316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6eb",
            "leftCorner": {
              "x": 12.52,
              "y": 22.411,
              "z": 1.144
            },
            "rightCorner": {
              "x": 12.646,
              "y": 22.402,
              "z": 1.144
            },
            "gtin": "4270001182869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6ec",
            "leftCorner": {
              "x": 12.646,
              "y": 22.402,
              "z": 1.144
            },
            "rightCorner": {
              "x": 12.772,
              "y": 22.394,
              "z": 1.144
            },
            "gtin": "4270001182869",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463a9",
        "height": 1.7531,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e715",
            "leftCorner": {
              "x": 11.612,
              "y": 22.482,
              "z": 1.434
            },
            "rightCorner": {
              "x": 11.831,
              "y": 22.466,
              "z": 1.434
            },
            "gtin": "5060367450356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e716",
            "leftCorner": {
              "x": 11.831,
              "y": 22.466,
              "z": 1.434
            },
            "rightCorner": {
              "x": 12.051,
              "y": 22.452,
              "z": 1.434
            },
            "gtin": "5060367450356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e717",
            "leftCorner": {
              "x": 12.051,
              "y": 22.452,
              "z": 1.434
            },
            "rightCorner": {
              "x": 12.27,
              "y": 22.437,
              "z": 1.434
            },
            "gtin": "5060367450356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e718",
            "leftCorner": {
              "x": 12.271,
              "y": 22.443,
              "z": 1.434
            },
            "rightCorner": {
              "x": 12.433,
              "y": 22.432,
              "z": 1.434
            },
            "gtin": "4260257872775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e719",
            "leftCorner": {
              "x": 12.433,
              "y": 22.432,
              "z": 1.434
            },
            "rightCorner": {
              "x": 12.634,
              "y": 22.419,
              "z": 1.434
            },
            "gtin": "4260257872751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e71a",
            "leftCorner": {
              "x": 12.634,
              "y": 22.419,
              "z": 1.434
            },
            "rightCorner": {
              "x": 12.835,
              "y": 22.405,
              "z": 1.434
            },
            "gtin": "4260257872751",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a1a",
    "rightNeighborShelfId": "50a1d"
  },
  {
    "id": "50a1d",
    "name": "50a1d",
    "x": 12.779,
    "y": 22.344,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.033766,
      "w": 0.99943
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 29
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463ca",
        "height": 0.14426,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e73c",
            "leftCorner": {
              "x": 12.849,
              "y": 22.389,
              "z": 0.118
            },
            "rightCorner": {
              "x": 13.431,
              "y": 22.349,
              "z": 0.118
            },
            "gtin": "4000522106262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e73d",
            "leftCorner": {
              "x": 13.431,
              "y": 22.349,
              "z": 0.118
            },
            "rightCorner": {
              "x": 14.014,
              "y": 22.31,
              "z": 0.118
            },
            "gtin": "4000522106262",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463c8",
        "height": 0.59101,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e72b",
            "leftCorner": {
              "x": 12.81,
              "y": 22.395,
              "z": 0.484
            },
            "rightCorner": {
              "x": 13.395,
              "y": 22.355,
              "z": 0.484
            },
            "gtin": "4063367057533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e72c",
            "leftCorner": {
              "x": 13.395,
              "y": 22.355,
              "z": 0.484
            },
            "rightCorner": {
              "x": 13.98,
              "y": 22.315,
              "z": 0.484
            },
            "gtin": "4063367057533",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463c9",
        "height": 0.95131,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e75a",
            "leftCorner": {
              "x": 12.866,
              "y": 22.382,
              "z": 0.778
            },
            "rightCorner": {
              "x": 12.972,
              "y": 22.375,
              "z": 0.778
            },
            "gtin": "4260272983289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e75b",
            "leftCorner": {
              "x": 12.972,
              "y": 22.375,
              "z": 0.778
            },
            "rightCorner": {
              "x": 13.076,
              "y": 22.368,
              "z": 0.778
            },
            "gtin": "4260272983289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e75c",
            "leftCorner": {
              "x": 13.077,
              "y": 22.37,
              "z": 0.778
            },
            "rightCorner": {
              "x": 13.169,
              "y": 22.363,
              "z": 0.778
            },
            "gtin": "4260272983326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e75d",
            "leftCorner": {
              "x": 13.169,
              "y": 22.363,
              "z": 0.778
            },
            "rightCorner": {
              "x": 13.261,
              "y": 22.357,
              "z": 0.778
            },
            "gtin": "4260272983326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e75e",
            "leftCorner": {
              "x": 13.261,
              "y": 22.357,
              "z": 0.778
            },
            "rightCorner": {
              "x": 13.353,
              "y": 22.351,
              "z": 0.778
            },
            "gtin": "4260272983326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e75f",
            "leftCorner": {
              "x": 13.353,
              "y": 22.356,
              "z": 0.778
            },
            "rightCorner": {
              "x": 13.707,
              "y": 22.332,
              "z": 0.778
            },
            "gtin": "4260272983265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e760",
            "leftCorner": {
              "x": 13.706,
              "y": 22.303,
              "z": 0.778
            },
            "rightCorner": {
              "x": 13.844,
              "y": 22.293,
              "z": 0.778
            },
            "gtin": "4260272983302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e761",
            "leftCorner": {
              "x": 13.844,
              "y": 22.293,
              "z": 0.778
            },
            "rightCorner": {
              "x": 13.981,
              "y": 22.284,
              "z": 0.778
            },
            "gtin": "4260272983302",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463c6",
        "height": 1.3997,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e6ed",
            "leftCorner": {
              "x": 12.772,
              "y": 22.379,
              "z": 1.145
            },
            "rightCorner": {
              "x": 12.908,
              "y": 22.37,
              "z": 1.145
            },
            "gtin": "4270001182814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6ee",
            "leftCorner": {
              "x": 12.908,
              "y": 22.37,
              "z": 1.145
            },
            "rightCorner": {
              "x": 13.045,
              "y": 22.36,
              "z": 1.145
            },
            "gtin": "4270001182814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6ef",
            "leftCorner": {
              "x": 13.046,
              "y": 22.376,
              "z": 1.145
            },
            "rightCorner": {
              "x": 13.37,
              "y": 22.355,
              "z": 1.145
            },
            "gtin": "5017764900410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6f0",
            "leftCorner": {
              "x": 13.372,
              "y": 22.367,
              "z": 1.145
            },
            "rightCorner": {
              "x": 13.557,
              "y": 22.354,
              "z": 1.145
            },
            "gtin": "634158955907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6f1",
            "leftCorner": {
              "x": 13.557,
              "y": 22.348,
              "z": 1.145
            },
            "rightCorner": {
              "x": 13.781,
              "y": 22.332,
              "z": 1.145
            },
            "gtin": "6095509844860",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6f2",
            "leftCorner": {
              "x": 13.781,
              "y": 22.332,
              "z": 1.145
            },
            "rightCorner": {
              "x": 14.004,
              "y": 22.318,
              "z": 1.145
            },
            "gtin": "6095509844860",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463c7",
        "height": 1.748,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e71b",
            "leftCorner": {
              "x": 12.832,
              "y": 22.373,
              "z": 1.43
            },
            "rightCorner": {
              "x": 12.927,
              "y": 22.367,
              "z": 1.43
            },
            "gtin": "4063367255960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e71c",
            "leftCorner": {
              "x": 12.927,
              "y": 22.367,
              "z": 1.43
            },
            "rightCorner": {
              "x": 13.021,
              "y": 22.36,
              "z": 1.43
            },
            "gtin": "4063367255960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e71d",
            "leftCorner": {
              "x": 13.021,
              "y": 22.36,
              "z": 1.43
            },
            "rightCorner": {
              "x": 13.116,
              "y": 22.355,
              "z": 1.43
            },
            "gtin": "4063367255960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e71e",
            "leftCorner": {
              "x": 13.116,
              "y": 22.355,
              "z": 1.43
            },
            "rightCorner": {
              "x": 13.211,
              "y": 22.348,
              "z": 1.43
            },
            "gtin": "4063367255960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e71f",
            "leftCorner": {
              "x": 13.211,
              "y": 22.353,
              "z": 1.43
            },
            "rightCorner": {
              "x": 13.423,
              "y": 22.339,
              "z": 1.43
            },
            "gtin": "4063367255991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e720",
            "leftCorner": {
              "x": 13.423,
              "y": 22.339,
              "z": 1.43
            },
            "rightCorner": {
              "x": 13.635,
              "y": 22.325,
              "z": 1.43
            },
            "gtin": "4063367255991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e721",
            "leftCorner": {
              "x": 13.636,
              "y": 22.342,
              "z": 1.43
            },
            "rightCorner": {
              "x": 13.712,
              "y": 22.338,
              "z": 1.43
            },
            "gtin": "4063367256028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e722",
            "leftCorner": {
              "x": 13.712,
              "y": 22.338,
              "z": 1.43
            },
            "rightCorner": {
              "x": 13.787,
              "y": 22.332,
              "z": 1.43
            },
            "gtin": "4063367256028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e723",
            "leftCorner": {
              "x": 13.787,
              "y": 22.332,
              "z": 1.43
            },
            "rightCorner": {
              "x": 13.861,
              "y": 22.327,
              "z": 1.43
            },
            "gtin": "4063367256028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e724",
            "leftCorner": {
              "x": 13.861,
              "y": 22.327,
              "z": 1.43
            },
            "rightCorner": {
              "x": 13.936,
              "y": 22.322,
              "z": 1.43
            },
            "gtin": "4063367256028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e725",
            "leftCorner": {
              "x": 13.936,
              "y": 22.322,
              "z": 1.43
            },
            "rightCorner": {
              "x": 14.011,
              "y": 22.317,
              "z": 1.43
            },
            "gtin": "4063367256028",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a1c",
    "rightNeighborShelfId": "50a1e"
  },
  {
    "id": "50a1e",
    "name": "50a1e",
    "x": 13.976,
    "y": 22.263,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.033766,
      "w": 0.99943
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5467f2",
        "height": 0.14262,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e73e",
            "leftCorner": {
              "x": 14.014,
              "y": 22.32,
              "z": 0.117
            },
            "rightCorner": {
              "x": 14.321,
              "y": 22.3,
              "z": 0.117
            },
            "gtin": "4014740611156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e73f",
            "leftCorner": {
              "x": 14.321,
              "y": 22.3,
              "z": 0.117
            },
            "rightCorner": {
              "x": 14.63,
              "y": 22.278,
              "z": 0.117
            },
            "gtin": "4014740611156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e740",
            "leftCorner": {
              "x": 14.63,
              "y": 22.276,
              "z": 0.117
            },
            "rightCorner": {
              "x": 15.284,
              "y": 22.231,
              "z": 0.117
            },
            "gtin": "4260257872676",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467ef",
        "height": 0.95347,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e762",
            "leftCorner": {
              "x": 13.983,
              "y": 22.322,
              "z": 0.78
            },
            "rightCorner": {
              "x": 14.137,
              "y": 22.311,
              "z": 0.78
            },
            "gtin": "4018077634123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e763",
            "leftCorner": {
              "x": 14.137,
              "y": 22.311,
              "z": 0.78
            },
            "rightCorner": {
              "x": 14.29,
              "y": 22.301,
              "z": 0.78
            },
            "gtin": "4018077634123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e764",
            "leftCorner": {
              "x": 14.29,
              "y": 22.299,
              "z": 0.78
            },
            "rightCorner": {
              "x": 14.447,
              "y": 22.289,
              "z": 0.78
            },
            "gtin": "4008021000036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e765",
            "leftCorner": {
              "x": 14.447,
              "y": 22.289,
              "z": 0.78
            },
            "rightCorner": {
              "x": 14.604,
              "y": 22.278,
              "z": 0.78
            },
            "gtin": "4008021000036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e766",
            "leftCorner": {
              "x": 14.603,
              "y": 22.273,
              "z": 0.78
            },
            "rightCorner": {
              "x": 14.732,
              "y": 22.265,
              "z": 0.78
            },
            "gtin": "4018077619458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e767",
            "leftCorner": {
              "x": 14.732,
              "y": 22.265,
              "z": 0.78
            },
            "rightCorner": {
              "x": 14.861,
              "y": 22.257,
              "z": 0.78
            },
            "gtin": "4018077619458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e768",
            "leftCorner": {
              "x": 14.861,
              "y": 22.256,
              "z": 0.78
            },
            "rightCorner": {
              "x": 15.202,
              "y": 22.232,
              "z": 0.78
            },
            "gtin": "4018077619236",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467f1",
        "height": 1.401,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e6f3",
            "leftCorner": {
              "x": 14.003,
              "y": 22.312,
              "z": 1.146
            },
            "rightCorner": {
              "x": 14.299,
              "y": 22.292,
              "z": 1.146
            },
            "gtin": "4063367194788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6f4",
            "leftCorner": {
              "x": 14.299,
              "y": 22.292,
              "z": 1.146
            },
            "rightCorner": {
              "x": 14.595,
              "y": 22.272,
              "z": 1.146
            },
            "gtin": "4063367194788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6f5",
            "leftCorner": {
              "x": 14.595,
              "y": 22.263,
              "z": 1.146
            },
            "rightCorner": {
              "x": 14.92,
              "y": 22.24,
              "z": 1.146
            },
            "gtin": "4063367232220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6f6",
            "leftCorner": {
              "x": 14.92,
              "y": 22.24,
              "z": 1.146
            },
            "rightCorner": {
              "x": 15.244,
              "y": 22.219,
              "z": 1.146
            },
            "gtin": "4063367232220",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467f0",
        "height": 1.7487,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e726",
            "leftCorner": {
              "x": 14.011,
              "y": 22.314,
              "z": 1.431
            },
            "rightCorner": {
              "x": 14.294,
              "y": 22.295,
              "z": 1.431
            },
            "gtin": "4337185713323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e727",
            "leftCorner": {
              "x": 14.294,
              "y": 22.295,
              "z": 1.431
            },
            "rightCorner": {
              "x": 14.579,
              "y": 22.276,
              "z": 1.431
            },
            "gtin": "4337185713323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e728",
            "leftCorner": {
              "x": 14.578,
              "y": 22.275,
              "z": 1.431
            },
            "rightCorner": {
              "x": 14.81,
              "y": 22.259,
              "z": 1.431
            },
            "gtin": "4063367147524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e729",
            "leftCorner": {
              "x": 14.81,
              "y": 22.259,
              "z": 1.431
            },
            "rightCorner": {
              "x": 15.041,
              "y": 22.243,
              "z": 1.431
            },
            "gtin": "4063367147524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e72a",
            "leftCorner": {
              "x": 15.041,
              "y": 22.243,
              "z": 1.431
            },
            "rightCorner": {
              "x": 15.273,
              "y": 22.228,
              "z": 1.431
            },
            "gtin": "4063367147524",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a1d",
    "rightNeighborShelfId": "50a1f"
  },
  {
    "id": "50a1f",
    "name": "50a1f",
    "x": 15.173,
    "y": 22.182,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.033766,
      "w": 0.99943
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 4
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5467fd",
        "height": 0.14498,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e73b",
            "leftCorner": {
              "x": 15.284,
              "y": 22.238,
              "z": 0.119
            },
            "rightCorner": {
              "x": 16.374,
              "y": 22.164,
              "z": 0.119
            },
            "gtin": "4014740611132",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467fc",
        "height": 0.95028,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a5467fa",
        "height": 1.406,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a5467fb",
        "height": 1.7501,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e6ff",
            "leftCorner": {
              "x": 15.638,
              "y": 22.2,
              "z": 1.432
            },
            "rightCorner": {
              "x": 16.006,
              "y": 22.175,
              "z": 1.432
            },
            "gtin": "4063367149092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6fe",
            "leftCorner": {
              "x": 15.271,
              "y": 22.224,
              "z": 1.432
            },
            "rightCorner": {
              "x": 15.638,
              "y": 22.2,
              "z": 1.432
            },
            "gtin": "4063367149092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e700",
            "leftCorner": {
              "x": 16.006,
              "y": 22.175,
              "z": 1.432
            },
            "rightCorner": {
              "x": 16.373,
              "y": 22.149,
              "z": 1.432
            },
            "gtin": "4063367149092",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a1e",
    "rightNeighborShelfId": "50a20"
  },
  {
    "id": "50a20",
    "name": "50a20",
    "x": 16.371,
    "y": 22.101,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.033766,
      "w": 0.99943
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 9
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546800",
        "height": 0.94542,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e769",
            "leftCorner": {
              "x": 17.025,
              "y": 22.105,
              "z": 0.774
            },
            "rightCorner": {
              "x": 17.578,
              "y": 22.068,
              "z": 0.774
            },
            "gtin": "4063367149054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e76a",
            "leftCorner": {
              "x": 17.578,
              "y": 22.068,
              "z": 0.774
            },
            "rightCorner": {
              "x": 18.131,
              "y": 22.03,
              "z": 0.774
            },
            "gtin": "4063367149054",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467ff",
        "height": 1.4099,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e6f7",
            "leftCorner": {
              "x": 16.511,
              "y": 22.128,
              "z": 1.154
            },
            "rightCorner": {
              "x": 16.879,
              "y": 22.102,
              "z": 1.154
            },
            "gtin": "4063367149047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6f8",
            "leftCorner": {
              "x": 16.879,
              "y": 22.102,
              "z": 1.154
            },
            "rightCorner": {
              "x": 17.247,
              "y": 22.078,
              "z": 1.154
            },
            "gtin": "4063367149047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6f9",
            "leftCorner": {
              "x": 17.247,
              "y": 22.078,
              "z": 1.154
            },
            "rightCorner": {
              "x": 17.615,
              "y": 22.053,
              "z": 1.154
            },
            "gtin": "4063367149047",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467fe",
        "height": 1.7613,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21208",
            "leftCorner": {
              "x": 16.371,
              "y": 22.104,
              "z": 1.441
            },
            "rightCorner": {
              "x": 17.008,
              "y": 22.061,
              "z": 1.441
            },
            "gtin": "4063367149108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21209",
            "leftCorner": {
              "x": 17.011,
              "y": 22.094,
              "z": 1.441
            },
            "rightCorner": {
              "x": 17.197,
              "y": 22.082,
              "z": 1.441
            },
            "gtin": "4063367366147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2120a",
            "leftCorner": {
              "x": 17.197,
              "y": 22.082,
              "z": 1.441
            },
            "rightCorner": {
              "x": 17.384,
              "y": 22.069,
              "z": 1.441
            },
            "gtin": "4063367366147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2120b",
            "leftCorner": {
              "x": 17.384,
              "y": 22.069,
              "z": 1.441
            },
            "rightCorner": {
              "x": 17.57,
              "y": 22.056,
              "z": 1.441
            },
            "gtin": "4063367366147",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a1f",
    "rightNeighborShelfId": "50a21"
  },
  {
    "id": "50a21",
    "name": "50a21",
    "x": 17.568,
    "y": 22.02,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.033766,
      "w": 0.99943
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 7
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546802",
        "height": 0.14182,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21220",
            "leftCorner": {
              "x": 17.569,
              "y": 22.035,
              "z": 0.116
            },
            "rightCorner": {
              "x": 17.653,
              "y": 22.03,
              "z": 0.116
            }
          },
          {
            "id": "68300c8b5ed67a01d9a21221",
            "leftCorner": {
              "x": 17.655,
              "y": 22.068,
              "z": 0.116
            },
            "rightCorner": {
              "x": 18.819,
              "y": 21.989,
              "z": 0.116
            },
            "gtin": "4063367396830",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546803",
        "height": 0.94594,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e76b",
            "leftCorner": {
              "x": 18.154,
              "y": 22.032,
              "z": 0.774
            },
            "rightCorner": {
              "x": 18.489,
              "y": 22.009,
              "z": 0.774
            },
            "gtin": "4014400935677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e76c",
            "leftCorner": {
              "x": 18.489,
              "y": 22.009,
              "z": 0.774
            },
            "rightCorner": {
              "x": 18.825,
              "y": 21.986,
              "z": 0.774
            },
            "gtin": "4014400935677",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546804",
        "height": 1.4041,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a546801",
        "height": 1.7448,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2120c",
            "leftCorner": {
              "x": 17.568,
              "y": 22.024,
              "z": 1.428
            },
            "rightCorner": {
              "x": 17.923,
              "y": 21.999,
              "z": 1.428
            },
            "gtin": "3577060000082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2120d",
            "leftCorner": {
              "x": 17.923,
              "y": 21.999,
              "z": 1.428
            },
            "rightCorner": {
              "x": 18.278,
              "y": 21.976,
              "z": 1.428
            },
            "gtin": "3577060000082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21210",
            "leftCorner": {
              "x": 18.281,
              "y": 22.017,
              "z": 1.428
            },
            "rightCorner": {
              "x": 18.555,
              "y": 21.998,
              "z": 1.428
            },
            "gtin": "4031446425016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21211",
            "leftCorner": {
              "x": 18.555,
              "y": 21.998,
              "z": 1.428
            },
            "rightCorner": {
              "x": 18.83,
              "y": 21.98,
              "z": 1.428
            },
            "gtin": "4031446425016",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a20",
    "rightNeighborShelfId": "50a22"
  },
  {
    "id": "50a22",
    "name": "50a22",
    "x": 18.823,
    "y": 21.932,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.033818,
      "w": 0.99943
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 32
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546805",
        "height": 0.60296,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21222",
            "leftCorner": {
              "x": 18.824,
              "y": 21.941,
              "z": 0.493
            },
            "rightCorner": {
              "x": 19.022,
              "y": 21.927,
              "z": 0.493
            },
            "gtin": "4001242003633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21223",
            "leftCorner": {
              "x": 19.022,
              "y": 21.927,
              "z": 0.493
            },
            "rightCorner": {
              "x": 19.221,
              "y": 21.914,
              "z": 0.493
            },
            "gtin": "4001242003633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21224",
            "leftCorner": {
              "x": 19.221,
              "y": 21.914,
              "z": 0.493
            },
            "rightCorner": {
              "x": 19.419,
              "y": 21.901,
              "z": 0.493
            },
            "gtin": "4001242003633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21225",
            "leftCorner": {
              "x": 19.422,
              "y": 21.943,
              "z": 0.493
            },
            "rightCorner": {
              "x": 19.64,
              "y": 21.927,
              "z": 0.493
            },
            "gtin": "4001242003343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21226",
            "leftCorner": {
              "x": 19.64,
              "y": 21.927,
              "z": 0.493
            },
            "rightCorner": {
              "x": 19.856,
              "y": 21.912,
              "z": 0.493
            },
            "gtin": "4001242003343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21227",
            "leftCorner": {
              "x": 19.856,
              "y": 21.912,
              "z": 0.493
            },
            "rightCorner": {
              "x": 20.074,
              "y": 21.898,
              "z": 0.493
            },
            "gtin": "4001242003343",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546806",
        "height": 0.94359,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e76d",
            "leftCorner": {
              "x": 18.833,
              "y": 21.983,
              "z": 0.772
            },
            "rightCorner": {
              "x": 19.121,
              "y": 21.963,
              "z": 0.772
            },
            "gtin": "4001242003626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e76e",
            "leftCorner": {
              "x": 19.121,
              "y": 21.963,
              "z": 0.772
            },
            "rightCorner": {
              "x": 19.409,
              "y": 21.944,
              "z": 0.772
            },
            "gtin": "4001242003626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e76f",
            "leftCorner": {
              "x": 19.409,
              "y": 21.944,
              "z": 0.772
            },
            "rightCorner": {
              "x": 19.795,
              "y": 21.917,
              "z": 0.772
            },
            "gtin": "8713276041166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e741",
            "leftCorner": {
              "x": 19.794,
              "y": 21.913,
              "z": 0.772
            },
            "rightCorner": {
              "x": 19.934,
              "y": 21.903,
              "z": 0.772
            },
            "gtin": "4031446425290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e742",
            "leftCorner": {
              "x": 19.934,
              "y": 21.903,
              "z": 0.772
            },
            "rightCorner": {
              "x": 20.073,
              "y": 21.893,
              "z": 0.772
            },
            "gtin": "4031446425290",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546808",
        "height": 1.3968,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e6fa",
            "leftCorner": {
              "x": 18.877,
              "y": 21.971,
              "z": 1.143
            },
            "rightCorner": {
              "x": 19.186,
              "y": 21.95,
              "z": 1.143
            },
            "gtin": "4260350920885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6fb",
            "leftCorner": {
              "x": 19.186,
              "y": 21.95,
              "z": 1.143
            },
            "rightCorner": {
              "x": 19.495,
              "y": 21.929,
              "z": 1.143
            },
            "gtin": "4260350920885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6c4",
            "leftCorner": {
              "x": 19.495,
              "y": 21.934,
              "z": 1.143
            },
            "rightCorner": {
              "x": 19.687,
              "y": 21.922,
              "z": 1.143
            },
            "gtin": "4260350920915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6c5",
            "leftCorner": {
              "x": 19.687,
              "y": 21.922,
              "z": 1.143
            },
            "rightCorner": {
              "x": 19.881,
              "y": 21.909,
              "z": 1.143
            },
            "gtin": "4260350920915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6c6",
            "leftCorner": {
              "x": 19.881,
              "y": 21.909,
              "z": 1.143
            },
            "rightCorner": {
              "x": 20.074,
              "y": 21.895,
              "z": 1.143
            },
            "gtin": "4260350920915",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546807",
        "height": 1.7463,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21212",
            "leftCorner": {
              "x": 18.838,
              "y": 21.982,
              "z": 1.429
            },
            "rightCorner": {
              "x": 18.899,
              "y": 21.978,
              "z": 1.429
            },
            "gtin": "4008258526064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21213",
            "leftCorner": {
              "x": 18.899,
              "y": 21.978,
              "z": 1.429
            },
            "rightCorner": {
              "x": 18.959,
              "y": 21.973,
              "z": 1.429
            },
            "gtin": "4008258526064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21214",
            "leftCorner": {
              "x": 18.959,
              "y": 21.973,
              "z": 1.429
            },
            "rightCorner": {
              "x": 19.019,
              "y": 21.969,
              "z": 1.429
            },
            "gtin": "4008258526064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21215",
            "leftCorner": {
              "x": 19.019,
              "y": 21.962,
              "z": 1.429
            },
            "rightCorner": {
              "x": 19.087,
              "y": 21.958,
              "z": 1.429
            },
            "gtin": "4008258527054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21216",
            "leftCorner": {
              "x": 19.087,
              "y": 21.958,
              "z": 1.429
            },
            "rightCorner": {
              "x": 19.155,
              "y": 21.954,
              "z": 1.429
            },
            "gtin": "4008258527054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21217",
            "leftCorner": {
              "x": 19.156,
              "y": 21.963,
              "z": 1.429
            },
            "rightCorner": {
              "x": 19.276,
              "y": 21.954,
              "z": 1.429
            },
            "gtin": "4008258525043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21218",
            "leftCorner": {
              "x": 19.276,
              "y": 21.955,
              "z": 1.429
            },
            "rightCorner": {
              "x": 19.333,
              "y": 21.952,
              "z": 1.429
            },
            "gtin": "4008258528020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21219",
            "leftCorner": {
              "x": 19.333,
              "y": 21.952,
              "z": 1.429
            },
            "rightCorner": {
              "x": 19.388,
              "y": 21.948,
              "z": 1.429
            },
            "gtin": "4008258528020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2121a",
            "leftCorner": {
              "x": 19.388,
              "y": 21.948,
              "z": 1.429
            },
            "rightCorner": {
              "x": 19.443,
              "y": 21.944,
              "z": 1.429
            },
            "gtin": "4008258528020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2121b",
            "leftCorner": {
              "x": 19.443,
              "y": 21.943,
              "z": 1.429
            },
            "rightCorner": {
              "x": 19.529,
              "y": 21.938,
              "z": 1.429
            },
            "gtin": "028190007432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2121c",
            "leftCorner": {
              "x": 19.529,
              "y": 21.938,
              "z": 1.429
            },
            "rightCorner": {
              "x": 19.616,
              "y": 21.931,
              "z": 1.429
            },
            "gtin": "028190007432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2121d",
            "leftCorner": {
              "x": 19.616,
              "y": 21.931,
              "z": 1.429
            },
            "rightCorner": {
              "x": 19.702,
              "y": 21.925,
              "z": 1.429
            },
            "gtin": "028190007432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2121e",
            "leftCorner": {
              "x": 19.702,
              "y": 21.921,
              "z": 1.429
            },
            "rightCorner": {
              "x": 19.826,
              "y": 21.913,
              "z": 1.429
            },
            "gtin": "028190007791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2121f",
            "leftCorner": {
              "x": 19.826,
              "y": 21.913,
              "z": 1.429
            },
            "rightCorner": {
              "x": 19.95,
              "y": 21.905,
              "z": 1.429
            },
            "gtin": "028190007791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2120e",
            "leftCorner": {
              "x": 19.948,
              "y": 21.895,
              "z": 1.429
            },
            "rightCorner": {
              "x": 20.011,
              "y": 21.89,
              "z": 1.429
            },
            "gtin": "028190017875",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2120f",
            "leftCorner": {
              "x": 20.011,
              "y": 21.89,
              "z": 1.429
            },
            "rightCorner": {
              "x": 20.073,
              "y": 21.886,
              "z": 1.429
            },
            "gtin": "028190017875",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "50a21"
  },
  {
    "id": "6ebb3",
    "name": "6ebb3",
    "x": 16.149,
    "y": 12.655,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.051796,
      "w": 0.99866
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 54
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5462f7",
        "height": 1.038,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e135",
            "leftCorner": {
              "x": 16.149,
              "y": 12.661,
              "z": 0.849
            },
            "rightCorner": {
              "x": 16.275,
              "y": 12.649,
              "z": 0.849
            },
            "gtin": "8711000504802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e137",
            "leftCorner": {
              "x": 16.278,
              "y": 12.678,
              "z": 0.849
            },
            "rightCorner": {
              "x": 16.457,
              "y": 12.66,
              "z": 0.849
            },
            "gtin": "8711000584453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e138",
            "leftCorner": {
              "x": 16.458,
              "y": 12.669,
              "z": 0.849
            },
            "rightCorner": {
              "x": 16.614,
              "y": 12.653,
              "z": 0.849
            },
            "gtin": "8711000504741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e139",
            "leftCorner": {
              "x": 16.613,
              "y": 12.641,
              "z": 0.849
            },
            "rightCorner": {
              "x": 16.69,
              "y": 12.632,
              "z": 0.849
            },
            "gtin": "8711000364123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e13a",
            "leftCorner": {
              "x": 16.69,
              "y": 12.632,
              "z": 0.849
            },
            "rightCorner": {
              "x": 16.766,
              "y": 12.625,
              "z": 0.849
            },
            "gtin": "8711000364123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e13b",
            "leftCorner": {
              "x": 16.769,
              "y": 12.642,
              "z": 0.849
            },
            "rightCorner": {
              "x": 16.932,
              "y": 12.625,
              "z": 0.849
            },
            "gtin": "8711000501153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e13c",
            "leftCorner": {
              "x": 16.932,
              "y": 12.622,
              "z": 0.849
            },
            "rightCorner": {
              "x": 17.009,
              "y": 12.614,
              "z": 0.849
            },
            "gtin": "8711000500378",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e13d",
            "leftCorner": {
              "x": 17.009,
              "y": 12.614,
              "z": 0.849
            },
            "rightCorner": {
              "x": 17.087,
              "y": 12.607,
              "z": 0.849
            },
            "gtin": "8711000500378",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e13e",
            "leftCorner": {
              "x": 17.087,
              "y": 12.611,
              "z": 0.849
            },
            "rightCorner": {
              "x": 17.224,
              "y": 12.596,
              "z": 0.849
            },
            "gtin": "8711000381779",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e13f",
            "leftCorner": {
              "x": 17.224,
              "y": 12.595,
              "z": 0.849
            },
            "rightCorner": {
              "x": 17.293,
              "y": 12.588,
              "z": 0.849
            },
            "gtin": "8711000504895",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e140",
            "leftCorner": {
              "x": 17.293,
              "y": 12.588,
              "z": 0.849
            },
            "rightCorner": {
              "x": 17.364,
              "y": 12.581,
              "z": 0.849
            },
            "gtin": "8711000504895",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462fb",
        "height": 0.13481,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e00d",
            "leftCorner": {
              "x": 16.202,
              "y": 12.69,
              "z": 0.11
            },
            "rightCorner": {
              "x": 16.289,
              "y": 12.681,
              "z": 0.11
            },
            "gtin": "8711000484838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e00e",
            "leftCorner": {
              "x": 16.289,
              "y": 12.681,
              "z": 0.11
            },
            "rightCorner": {
              "x": 16.377,
              "y": 12.672,
              "z": 0.11
            },
            "gtin": "8711000484838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e00f",
            "leftCorner": {
              "x": 16.378,
              "y": 12.682,
              "z": 0.11
            },
            "rightCorner": {
              "x": 16.612,
              "y": 12.657,
              "z": 0.11
            },
            "gtin": "8711000852552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e010",
            "leftCorner": {
              "x": 16.613,
              "y": 12.663,
              "z": 0.11
            },
            "rightCorner": {
              "x": 16.719,
              "y": 12.652,
              "z": 0.11
            },
            "gtin": "8711000390757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e011",
            "leftCorner": {
              "x": 16.719,
              "y": 12.652,
              "z": 0.11
            },
            "rightCorner": {
              "x": 16.826,
              "y": 12.641,
              "z": 0.11
            },
            "gtin": "8711000390757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e012",
            "leftCorner": {
              "x": 16.826,
              "y": 12.641,
              "z": 0.11
            },
            "rightCorner": {
              "x": 16.932,
              "y": 12.63,
              "z": 0.11
            },
            "gtin": "8711000390757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e013",
            "leftCorner": {
              "x": 16.933,
              "y": 12.633,
              "z": 0.11
            },
            "rightCorner": {
              "x": 17.011,
              "y": 12.624,
              "z": 0.11
            },
            "gtin": "8711000500033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e014",
            "leftCorner": {
              "x": 17.011,
              "y": 12.624,
              "z": 0.11
            },
            "rightCorner": {
              "x": 17.09,
              "y": 12.616,
              "z": 0.11
            },
            "gtin": "8711000500033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e015",
            "leftCorner": {
              "x": 17.088,
              "y": 12.597,
              "z": 0.11
            },
            "rightCorner": {
              "x": 17.148,
              "y": 12.592,
              "z": 0.11
            },
            "gtin": "8711000504833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e016",
            "leftCorner": {
              "x": 17.148,
              "y": 12.592,
              "z": 0.11
            },
            "rightCorner": {
              "x": 17.207,
              "y": 12.586,
              "z": 0.11
            },
            "gtin": "8711000504833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e017",
            "leftCorner": {
              "x": 17.207,
              "y": 12.586,
              "z": 0.11
            },
            "rightCorner": {
              "x": 17.266,
              "y": 12.579,
              "z": 0.11
            },
            "gtin": "8711000504833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e018",
            "leftCorner": {
              "x": 17.266,
              "y": 12.579,
              "z": 0.11
            },
            "rightCorner": {
              "x": 17.326,
              "y": 12.573,
              "z": 0.11
            },
            "gtin": "8711000504833",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462f9",
        "height": 0.58446,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e111",
            "leftCorner": {
              "x": 16.184,
              "y": 12.697,
              "z": 0.478
            },
            "rightCorner": {
              "x": 16.25,
              "y": 12.692,
              "z": 0.478
            },
            "gtin": "8711000500408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e112",
            "leftCorner": {
              "x": 16.25,
              "y": 12.692,
              "z": 0.478
            },
            "rightCorner": {
              "x": 16.316,
              "y": 12.685,
              "z": 0.478
            },
            "gtin": "8711000500408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e113",
            "leftCorner": {
              "x": 16.316,
              "y": 12.686,
              "z": 0.478
            },
            "rightCorner": {
              "x": 16.394,
              "y": 12.678,
              "z": 0.478
            },
            "gtin": "8711000500774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e114",
            "leftCorner": {
              "x": 16.394,
              "y": 12.678,
              "z": 0.478
            },
            "rightCorner": {
              "x": 16.472,
              "y": 12.67,
              "z": 0.478
            },
            "gtin": "8711000500774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e115",
            "leftCorner": {
              "x": 16.471,
              "y": 12.663,
              "z": 0.478
            },
            "rightCorner": {
              "x": 16.609,
              "y": 12.649,
              "z": 0.478
            },
            "gtin": "8711000500552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e116",
            "leftCorner": {
              "x": 16.609,
              "y": 12.648,
              "z": 0.478
            },
            "rightCorner": {
              "x": 16.78,
              "y": 12.63,
              "z": 0.478
            },
            "gtin": "8711000443255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e117",
            "leftCorner": {
              "x": 16.781,
              "y": 12.648,
              "z": 0.478
            },
            "rightCorner": {
              "x": 16.922,
              "y": 12.633,
              "z": 0.478
            },
            "gtin": "8711000500002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e118",
            "leftCorner": {
              "x": 16.921,
              "y": 12.63,
              "z": 0.478
            },
            "rightCorner": {
              "x": 17.01,
              "y": 12.62,
              "z": 0.478
            },
            "gtin": "8711000459904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e119",
            "leftCorner": {
              "x": 17.01,
              "y": 12.62,
              "z": 0.478
            },
            "rightCorner": {
              "x": 17.097,
              "y": 12.612,
              "z": 0.478
            },
            "gtin": "8711000459904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e11a",
            "leftCorner": {
              "x": 17.097,
              "y": 12.606,
              "z": 0.478
            },
            "rightCorner": {
              "x": 17.247,
              "y": 12.589,
              "z": 0.478
            },
            "gtin": "8711000501092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e11b",
            "leftCorner": {
              "x": 17.248,
              "y": 12.595,
              "z": 0.478
            },
            "rightCorner": {
              "x": 17.307,
              "y": 12.59,
              "z": 0.478
            },
            "gtin": "8711000500224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e11c",
            "leftCorner": {
              "x": 17.307,
              "y": 12.59,
              "z": 0.478
            },
            "rightCorner": {
              "x": 17.367,
              "y": 12.583,
              "z": 0.478
            },
            "gtin": "8711000500224",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462fa",
        "height": 1.4991,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e151",
            "leftCorner": {
              "x": 16.149,
              "y": 12.659,
              "z": 1.227
            },
            "rightCorner": {
              "x": 16.271,
              "y": 12.647,
              "z": 1.227
            },
            "gtin": "8711000443927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e152",
            "leftCorner": {
              "x": 16.271,
              "y": 12.647,
              "z": 1.227
            },
            "rightCorner": {
              "x": 16.392,
              "y": 12.634,
              "z": 1.227
            },
            "gtin": "8711000443927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e154",
            "leftCorner": {
              "x": 16.395,
              "y": 12.662,
              "z": 1.227
            },
            "rightCorner": {
              "x": 16.558,
              "y": 12.644,
              "z": 1.227
            },
            "gtin": "8711000430873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e155",
            "leftCorner": {
              "x": 16.558,
              "y": 12.644,
              "z": 1.227
            },
            "rightCorner": {
              "x": 16.722,
              "y": 12.628,
              "z": 1.227
            },
            "gtin": "8711000430873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e156",
            "leftCorner": {
              "x": 16.725,
              "y": 12.662,
              "z": 1.227
            },
            "rightCorner": {
              "x": 16.85,
              "y": 12.648,
              "z": 1.227
            },
            "gtin": "8445291144811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e157",
            "leftCorner": {
              "x": 16.849,
              "y": 12.628,
              "z": 1.227
            },
            "rightCorner": {
              "x": 17.031,
              "y": 12.609,
              "z": 1.227
            },
            "gtin": "8445291146655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e158",
            "leftCorner": {
              "x": 17.031,
              "y": 12.611,
              "z": 1.227
            },
            "rightCorner": {
              "x": 17.223,
              "y": 12.591,
              "z": 1.227
            },
            "gtin": "8445291109070",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c855ed67a01d9a1e159",
            "leftCorner": {
              "x": 17.223,
              "y": 12.586,
              "z": 1.227
            },
            "rightCorner": {
              "x": 17.346,
              "y": 12.573,
              "z": 1.227
            },
            "gtin": "8445291149168",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462f8",
        "height": 1.7409,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e0aa",
            "leftCorner": {
              "x": 16.201,
              "y": 12.681,
              "z": 1.424
            },
            "rightCorner": {
              "x": 16.473,
              "y": 12.653,
              "z": 1.424
            },
            "gtin": "4008167314561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0ab",
            "leftCorner": {
              "x": 16.473,
              "y": 12.653,
              "z": 1.424
            },
            "rightCorner": {
              "x": 16.744,
              "y": 12.624,
              "z": 1.424
            },
            "gtin": "4008167314561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0ac",
            "leftCorner": {
              "x": 16.746,
              "y": 12.647,
              "z": 1.424
            },
            "rightCorner": {
              "x": 16.842,
              "y": 12.637,
              "z": 1.424
            },
            "gtin": "4053528008733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0ad",
            "leftCorner": {
              "x": 16.841,
              "y": 12.625,
              "z": 1.424
            },
            "rightCorner": {
              "x": 16.899,
              "y": 12.619,
              "z": 1.424
            },
            "gtin": "4053528008740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0ae",
            "leftCorner": {
              "x": 16.899,
              "y": 12.619,
              "z": 1.424
            },
            "rightCorner": {
              "x": 16.958,
              "y": 12.612,
              "z": 1.424
            },
            "gtin": "4053528008740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0af",
            "leftCorner": {
              "x": 16.958,
              "y": 12.613,
              "z": 1.424
            },
            "rightCorner": {
              "x": 17.004,
              "y": 12.608,
              "z": 1.424
            },
            "gtin": "4008167029311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0b0",
            "leftCorner": {
              "x": 17.004,
              "y": 12.608,
              "z": 1.424
            },
            "rightCorner": {
              "x": 17.05,
              "y": 12.603,
              "z": 1.424
            },
            "gtin": "4008167029311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0b1",
            "leftCorner": {
              "x": 17.05,
              "y": 12.611,
              "z": 1.424
            },
            "rightCorner": {
              "x": 17.106,
              "y": 12.606,
              "z": 1.424
            },
            "gtin": "4053528108884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0b2",
            "leftCorner": {
              "x": 17.106,
              "y": 12.606,
              "z": 1.424
            },
            "rightCorner": {
              "x": 17.162,
              "y": 12.6,
              "z": 1.424
            },
            "gtin": "4053528108884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0b3",
            "leftCorner": {
              "x": 17.16,
              "y": 12.58,
              "z": 1.424
            },
            "rightCorner": {
              "x": 17.21,
              "y": 12.574,
              "z": 1.424
            },
            "gtin": "4008167029212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0b4",
            "leftCorner": {
              "x": 17.21,
              "y": 12.574,
              "z": 1.424
            },
            "rightCorner": {
              "x": 17.259,
              "y": 12.57,
              "z": 1.424
            },
            "gtin": "4008167029212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0b5",
            "leftCorner": {
              "x": 17.259,
              "y": 12.57,
              "z": 1.424
            },
            "rightCorner": {
              "x": 17.309,
              "y": 12.565,
              "z": 1.424
            },
            "gtin": "4008167029212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0b6",
            "leftCorner": {
              "x": 17.309,
              "y": 12.565,
              "z": 1.424
            },
            "rightCorner": {
              "x": 17.358,
              "y": 12.559,
              "z": 1.424
            },
            "gtin": "4008167029212",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "6ebb4",
    "rightNeighborShelfId": "b6fa4"
  },
  {
    "id": "6ebb4",
    "name": "6ebb4",
    "x": 14.958,
    "y": 12.76,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.043192,
      "w": 0.99907
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 43
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5462f6",
        "height": 0.13597,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e009",
            "leftCorner": {
              "x": 15.02,
              "y": 12.803,
              "z": 0.111
            },
            "rightCorner": {
              "x": 15.288,
              "y": 12.78,
              "z": 0.111
            },
            "gtin": "4013743010041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e00a",
            "leftCorner": {
              "x": 15.288,
              "y": 12.78,
              "z": 0.111
            },
            "rightCorner": {
              "x": 15.559,
              "y": 12.757,
              "z": 0.111
            },
            "gtin": "4013743010041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e00b",
            "leftCorner": {
              "x": 15.558,
              "y": 12.752,
              "z": 0.111
            },
            "rightCorner": {
              "x": 15.882,
              "y": 12.724,
              "z": 0.111
            },
            "gtin": "4013743010027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e00c",
            "leftCorner": {
              "x": 15.882,
              "y": 12.724,
              "z": 0.111
            },
            "rightCorner": {
              "x": 16.207,
              "y": 12.696,
              "z": 0.111
            },
            "gtin": "4013743010027",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462f4",
        "height": 0.58833,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e104",
            "leftCorner": {
              "x": 14.958,
              "y": 12.762,
              "z": 0.481
            },
            "rightCorner": {
              "x": 15.16,
              "y": 12.745,
              "z": 0.481
            },
            "gtin": "8711000452479",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c855ed67a01d9a1e107",
            "leftCorner": {
              "x": 15.164,
              "y": 12.787,
              "z": 0.481
            },
            "rightCorner": {
              "x": 15.27,
              "y": 12.778,
              "z": 0.481
            },
            "gtin": "8711000452448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e108",
            "leftCorner": {
              "x": 15.27,
              "y": 12.778,
              "z": 0.481
            },
            "rightCorner": {
              "x": 15.376,
              "y": 12.769,
              "z": 0.481
            },
            "gtin": "8711000452448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e109",
            "leftCorner": {
              "x": 15.376,
              "y": 12.766,
              "z": 0.481
            },
            "rightCorner": {
              "x": 15.502,
              "y": 12.755,
              "z": 0.481
            },
            "gtin": "8711000452509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e10a",
            "leftCorner": {
              "x": 15.502,
              "y": 12.755,
              "z": 0.481
            },
            "rightCorner": {
              "x": 15.629,
              "y": 12.743,
              "z": 0.481
            },
            "gtin": "8711000452509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e10b",
            "leftCorner": {
              "x": 15.629,
              "y": 12.743,
              "z": 0.481
            },
            "rightCorner": {
              "x": 15.754,
              "y": 12.733,
              "z": 0.481
            },
            "gtin": "8711000452509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e10c",
            "leftCorner": {
              "x": 15.754,
              "y": 12.733,
              "z": 0.481
            },
            "rightCorner": {
              "x": 15.881,
              "y": 12.722,
              "z": 0.481
            },
            "gtin": "8711000452509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e10d",
            "leftCorner": {
              "x": 15.881,
              "y": 12.719,
              "z": 0.481
            },
            "rightCorner": {
              "x": 15.957,
              "y": 12.712,
              "z": 0.481
            },
            "gtin": "8711000452745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e10e",
            "leftCorner": {
              "x": 15.957,
              "y": 12.712,
              "z": 0.481
            },
            "rightCorner": {
              "x": 16.034,
              "y": 12.706,
              "z": 0.481
            },
            "gtin": "8711000452745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e10f",
            "leftCorner": {
              "x": 16.034,
              "y": 12.706,
              "z": 0.481
            },
            "rightCorner": {
              "x": 16.111,
              "y": 12.699,
              "z": 0.481
            },
            "gtin": "8711000452745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e110",
            "leftCorner": {
              "x": 16.111,
              "y": 12.699,
              "z": 0.481
            },
            "rightCorner": {
              "x": 16.187,
              "y": 12.692,
              "z": 0.481
            },
            "gtin": "8711000452745",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462f5",
        "height": 0.94731,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e12d",
            "leftCorner": {
              "x": 14.958,
              "y": 12.763,
              "z": 0.775
            },
            "rightCorner": {
              "x": 15.027,
              "y": 12.757,
              "z": 0.775
            },
            "gtin": "4047046008436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e12e",
            "leftCorner": {
              "x": 15.027,
              "y": 12.757,
              "z": 0.775
            },
            "rightCorner": {
              "x": 15.097,
              "y": 12.751,
              "z": 0.775
            },
            "gtin": "4047046008436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e131",
            "leftCorner": {
              "x": 15.099,
              "y": 12.782,
              "z": 0.775
            },
            "rightCorner": {
              "x": 15.274,
              "y": 12.767,
              "z": 0.775
            },
            "gtin": "4047046005008",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c855ed67a01d9a1e132",
            "leftCorner": {
              "x": 15.276,
              "y": 12.779,
              "z": 0.775
            },
            "rightCorner": {
              "x": 15.47,
              "y": 12.762,
              "z": 0.775
            },
            "gtin": "8711000675823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e133",
            "leftCorner": {
              "x": 15.469,
              "y": 12.759,
              "z": 0.775
            },
            "rightCorner": {
              "x": 15.744,
              "y": 12.735,
              "z": 0.775
            },
            "gtin": "8711000468128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e134",
            "leftCorner": {
              "x": 15.744,
              "y": 12.726,
              "z": 0.775
            },
            "rightCorner": {
              "x": 15.887,
              "y": 12.714,
              "z": 0.775
            },
            "gtin": "8711000452684",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c855ed67a01d9a1e12f",
            "leftCorner": {
              "x": 15.887,
              "y": 12.715,
              "z": 0.775
            },
            "rightCorner": {
              "x": 16.022,
              "y": 12.704,
              "z": 0.775
            },
            "gtin": "4047046006098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e130",
            "leftCorner": {
              "x": 16.022,
              "y": 12.704,
              "z": 0.775
            },
            "rightCorner": {
              "x": 16.156,
              "y": 12.692,
              "z": 0.775
            },
            "gtin": "4047046006098",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462f3",
        "height": 1.2933,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e0f7",
            "leftCorner": {
              "x": 14.958,
              "y": 12.76,
              "z": 1.058
            },
            "rightCorner": {
              "x": 15.032,
              "y": 12.753,
              "z": 1.058
            },
            "gtin": "8711000486566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0f8",
            "leftCorner": {
              "x": 15.032,
              "y": 12.753,
              "z": 1.058
            },
            "rightCorner": {
              "x": 15.104,
              "y": 12.747,
              "z": 1.058
            },
            "gtin": "8711000486566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0fa",
            "leftCorner": {
              "x": 15.109,
              "y": 12.787,
              "z": 1.058
            },
            "rightCorner": {
              "x": 15.288,
              "y": 12.772,
              "z": 1.058
            },
            "gtin": "8711000465462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0fb",
            "leftCorner": {
              "x": 15.288,
              "y": 12.771,
              "z": 1.058
            },
            "rightCorner": {
              "x": 15.377,
              "y": 12.763,
              "z": 1.058
            },
            "gtin": "8711000486597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0fc",
            "leftCorner": {
              "x": 15.377,
              "y": 12.763,
              "z": 1.058
            },
            "rightCorner": {
              "x": 15.467,
              "y": 12.755,
              "z": 1.058
            },
            "gtin": "8711000486597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0fd",
            "leftCorner": {
              "x": 15.467,
              "y": 12.757,
              "z": 1.058
            },
            "rightCorner": {
              "x": 15.521,
              "y": 12.752,
              "z": 1.058
            },
            "gtin": "8711000452530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0fe",
            "leftCorner": {
              "x": 15.521,
              "y": 12.752,
              "z": 1.058
            },
            "rightCorner": {
              "x": 15.574,
              "y": 12.747,
              "z": 1.058
            },
            "gtin": "8711000452530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0ff",
            "leftCorner": {
              "x": 15.574,
              "y": 12.747,
              "z": 1.058
            },
            "rightCorner": {
              "x": 15.627,
              "y": 12.742,
              "z": 1.058
            },
            "gtin": "8711000452530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e100",
            "leftCorner": {
              "x": 15.626,
              "y": 12.74,
              "z": 1.058
            },
            "rightCorner": {
              "x": 15.766,
              "y": 12.728,
              "z": 1.058
            },
            "gtin": "8711000452776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e101",
            "leftCorner": {
              "x": 15.766,
              "y": 12.724,
              "z": 1.058
            },
            "rightCorner": {
              "x": 15.833,
              "y": 12.717,
              "z": 1.058
            },
            "gtin": "8711000300008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e102",
            "leftCorner": {
              "x": 15.833,
              "y": 12.717,
              "z": 1.058
            },
            "rightCorner": {
              "x": 15.9,
              "y": 12.712,
              "z": 1.058
            },
            "gtin": "8711000300008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e103",
            "leftCorner": {
              "x": 15.9,
              "y": 12.713,
              "z": 1.058
            },
            "rightCorner": {
              "x": 16.041,
              "y": 12.701,
              "z": 1.058
            },
            "gtin": "8711000688021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0f9",
            "leftCorner": {
              "x": 16.039,
              "y": 12.695,
              "z": 1.058
            },
            "rightCorner": {
              "x": 16.156,
              "y": 12.685,
              "z": 1.058
            },
            "gtin": "8711000452653",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462f2",
        "height": 1.7432,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e0a0",
            "leftCorner": {
              "x": 14.956,
              "y": 12.799,
              "z": 1.426
            },
            "rightCorner": {
              "x": 15.189,
              "y": 12.779,
              "z": 1.426
            },
            "gtin": "4008167003878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0a1",
            "leftCorner": {
              "x": 15.189,
              "y": 12.779,
              "z": 1.426
            },
            "rightCorner": {
              "x": 15.421,
              "y": 12.759,
              "z": 1.426
            },
            "gtin": "4008167003878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0a2",
            "leftCorner": {
              "x": 15.421,
              "y": 12.752,
              "z": 1.426
            },
            "rightCorner": {
              "x": 15.513,
              "y": 12.744,
              "z": 1.426
            },
            "gtin": "4008167014539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0a3",
            "leftCorner": {
              "x": 15.513,
              "y": 12.744,
              "z": 1.426
            },
            "rightCorner": {
              "x": 15.605,
              "y": 12.736,
              "z": 1.426
            },
            "gtin": "4008167014539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0a4",
            "leftCorner": {
              "x": 15.605,
              "y": 12.736,
              "z": 1.426
            },
            "rightCorner": {
              "x": 15.698,
              "y": 12.728,
              "z": 1.426
            },
            "gtin": "4008167014539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0a5",
            "leftCorner": {
              "x": 15.698,
              "y": 12.73,
              "z": 1.426
            },
            "rightCorner": {
              "x": 15.792,
              "y": 12.722,
              "z": 1.426
            },
            "gtin": "4008167042877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0a6",
            "leftCorner": {
              "x": 15.792,
              "y": 12.722,
              "z": 1.426
            },
            "rightCorner": {
              "x": 15.884,
              "y": 12.713,
              "z": 1.426
            },
            "gtin": "4008167042877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0a7",
            "leftCorner": {
              "x": 15.883,
              "y": 12.704,
              "z": 1.426
            },
            "rightCorner": {
              "x": 15.991,
              "y": 12.694,
              "z": 1.426
            },
            "gtin": "4008167052876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0a8",
            "leftCorner": {
              "x": 15.991,
              "y": 12.694,
              "z": 1.426
            },
            "rightCorner": {
              "x": 16.098,
              "y": 12.685,
              "z": 1.426
            },
            "gtin": "4008167052876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0a9",
            "leftCorner": {
              "x": 16.098,
              "y": 12.685,
              "z": 1.426
            },
            "rightCorner": {
              "x": 16.205,
              "y": 12.676,
              "z": 1.426
            },
            "gtin": "4008167052876",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "6ebb5",
    "rightNeighborShelfId": "6ebb3"
  },
  {
    "id": "6ebb5",
    "name": "6ebb5",
    "x": 13.762,
    "y": 12.863,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.043192,
      "w": 0.99907
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 50
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5462f1",
        "height": 0.13746,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e003",
            "leftCorner": {
              "x": 13.83,
              "y": 12.914,
              "z": 0.112
            },
            "rightCorner": {
              "x": 13.943,
              "y": 12.905,
              "z": 0.112
            },
            "gtin": "4063367253584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e004",
            "leftCorner": {
              "x": 13.943,
              "y": 12.905,
              "z": 0.112
            },
            "rightCorner": {
              "x": 14.055,
              "y": 12.894,
              "z": 0.112
            },
            "gtin": "4063367253584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e005",
            "leftCorner": {
              "x": 14.056,
              "y": 12.895,
              "z": 0.112
            },
            "rightCorner": {
              "x": 14.455,
              "y": 12.861,
              "z": 0.112
            },
            "gtin": "4063367253560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e006",
            "leftCorner": {
              "x": 14.456,
              "y": 12.871,
              "z": 0.112
            },
            "rightCorner": {
              "x": 14.763,
              "y": 12.844,
              "z": 0.112
            },
            "gtin": "4013743010058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e007",
            "leftCorner": {
              "x": 14.761,
              "y": 12.824,
              "z": 0.112
            },
            "rightCorner": {
              "x": 14.891,
              "y": 12.813,
              "z": 0.112
            },
            "gtin": "4013743010034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e008",
            "leftCorner": {
              "x": 14.891,
              "y": 12.813,
              "z": 0.112
            },
            "rightCorner": {
              "x": 15.019,
              "y": 12.801,
              "z": 0.112
            },
            "gtin": "4013743010034",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462ee",
        "height": 0.79179,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e0d8",
            "leftCorner": {
              "x": 13.763,
              "y": 12.874,
              "z": 0.648
            },
            "rightCorner": {
              "x": 13.894,
              "y": 12.863,
              "z": 0.648
            },
            "gtin": "8711000851937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0da",
            "leftCorner": {
              "x": 13.897,
              "y": 12.9,
              "z": 0.648
            },
            "rightCorner": {
              "x": 14.08,
              "y": 12.884,
              "z": 0.648
            },
            "gtin": "8711000851845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0db",
            "leftCorner": {
              "x": 14.079,
              "y": 12.876,
              "z": 0.648
            },
            "rightCorner": {
              "x": 14.235,
              "y": 12.864,
              "z": 0.648
            },
            "gtin": "8711000851906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0dc",
            "leftCorner": {
              "x": 14.235,
              "y": 12.864,
              "z": 0.648
            },
            "rightCorner": {
              "x": 14.39,
              "y": 12.85,
              "z": 0.648
            },
            "gtin": "8711000851906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0dd",
            "leftCorner": {
              "x": 14.391,
              "y": 12.864,
              "z": 0.648
            },
            "rightCorner": {
              "x": 14.443,
              "y": 12.86,
              "z": 0.648
            },
            "gtin": "4002720001516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0de",
            "leftCorner": {
              "x": 14.443,
              "y": 12.86,
              "z": 0.648
            },
            "rightCorner": {
              "x": 14.494,
              "y": 12.856,
              "z": 0.648
            },
            "gtin": "4002720001516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0df",
            "leftCorner": {
              "x": 14.493,
              "y": 12.844,
              "z": 0.648
            },
            "rightCorner": {
              "x": 14.574,
              "y": 12.837,
              "z": 0.648
            },
            "gtin": "4002720001615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0e0",
            "leftCorner": {
              "x": 14.574,
              "y": 12.837,
              "z": 0.648
            },
            "rightCorner": {
              "x": 14.653,
              "y": 12.83,
              "z": 0.648
            },
            "gtin": "4002720001615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0d9",
            "leftCorner": {
              "x": 14.653,
              "y": 12.833,
              "z": 0.648
            },
            "rightCorner": {
              "x": 14.962,
              "y": 12.807,
              "z": 0.648
            },
            "gtin": "4002720001752",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462f0",
        "height": 1.145,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e0eb",
            "leftCorner": {
              "x": 13.762,
              "y": 12.864,
              "z": 0.937
            },
            "rightCorner": {
              "x": 13.917,
              "y": 12.85,
              "z": 0.937
            },
            "gtin": "4006581017761",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0ec",
            "leftCorner": {
              "x": 13.917,
              "y": 12.85,
              "z": 0.937
            },
            "rightCorner": {
              "x": 14.073,
              "y": 12.837,
              "z": 0.937
            },
            "gtin": "4006581017761",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0ef",
            "leftCorner": {
              "x": 14.076,
              "y": 12.876,
              "z": 0.937
            },
            "rightCorner": {
              "x": 14.133,
              "y": 12.871,
              "z": 0.937
            },
            "gtin": "4006581026008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0f0",
            "leftCorner": {
              "x": 14.133,
              "y": 12.871,
              "z": 0.937
            },
            "rightCorner": {
              "x": 14.19,
              "y": 12.867,
              "z": 0.937
            },
            "gtin": "4006581026008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0f1",
            "leftCorner": {
              "x": 14.19,
              "y": 12.867,
              "z": 0.937
            },
            "rightCorner": {
              "x": 14.246,
              "y": 12.861,
              "z": 0.937
            },
            "gtin": "4006581026008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0f2",
            "leftCorner": {
              "x": 14.246,
              "y": 12.861,
              "z": 0.937
            },
            "rightCorner": {
              "x": 14.304,
              "y": 12.856,
              "z": 0.937
            },
            "gtin": "4006581026008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0f3",
            "leftCorner": {
              "x": 14.304,
              "y": 12.856,
              "z": 0.937
            },
            "rightCorner": {
              "x": 14.361,
              "y": 12.852,
              "z": 0.937
            },
            "gtin": "4006581026008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0f4",
            "leftCorner": {
              "x": 14.362,
              "y": 12.858,
              "z": 0.937
            },
            "rightCorner": {
              "x": 14.428,
              "y": 12.852,
              "z": 0.937
            },
            "gtin": "4002720001639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0f5",
            "leftCorner": {
              "x": 14.428,
              "y": 12.852,
              "z": 0.937
            },
            "rightCorner": {
              "x": 14.495,
              "y": 12.846,
              "z": 0.937
            },
            "gtin": "4002720001639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0f6",
            "leftCorner": {
              "x": 14.495,
              "y": 12.842,
              "z": 0.937
            },
            "rightCorner": {
              "x": 14.672,
              "y": 12.827,
              "z": 0.937
            },
            "gtin": "4002720001516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0ed",
            "leftCorner": {
              "x": 14.673,
              "y": 12.836,
              "z": 0.937
            },
            "rightCorner": {
              "x": 14.817,
              "y": 12.824,
              "z": 0.937
            },
            "gtin": "4002720001738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0ee",
            "leftCorner": {
              "x": 14.817,
              "y": 12.824,
              "z": 0.937
            },
            "rightCorner": {
              "x": 14.963,
              "y": 12.812,
              "z": 0.937
            },
            "gtin": "4002720001738",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462ef",
        "height": 1.4962,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e0e1",
            "leftCorner": {
              "x": 13.763,
              "y": 12.874,
              "z": 1.224
            },
            "rightCorner": {
              "x": 13.861,
              "y": 12.866,
              "z": 1.224
            },
            "gtin": "8711000371237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0e2",
            "leftCorner": {
              "x": 13.861,
              "y": 12.866,
              "z": 1.224
            },
            "rightCorner": {
              "x": 13.958,
              "y": 12.857,
              "z": 1.224
            },
            "gtin": "8711000371237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0e4",
            "leftCorner": {
              "x": 13.961,
              "y": 12.898,
              "z": 1.224
            },
            "rightCorner": {
              "x": 14.099,
              "y": 12.886,
              "z": 1.224
            },
            "gtin": "8711000371251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0e5",
            "leftCorner": {
              "x": 14.099,
              "y": 12.886,
              "z": 1.224
            },
            "rightCorner": {
              "x": 14.235,
              "y": 12.874,
              "z": 1.224
            },
            "gtin": "8711000371251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0e6",
            "leftCorner": {
              "x": 14.236,
              "y": 12.875,
              "z": 1.224
            },
            "rightCorner": {
              "x": 14.377,
              "y": 12.862,
              "z": 1.224
            },
            "gtin": "8711000485798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0e7",
            "leftCorner": {
              "x": 14.377,
              "y": 12.862,
              "z": 1.224
            },
            "rightCorner": {
              "x": 14.519,
              "y": 12.851,
              "z": 1.224
            },
            "gtin": "8711000485798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0e8",
            "leftCorner": {
              "x": 14.518,
              "y": 12.849,
              "z": 1.224
            },
            "rightCorner": {
              "x": 14.679,
              "y": 12.835,
              "z": 1.224
            },
            "gtin": "8711000371190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0e9",
            "leftCorner": {
              "x": 14.679,
              "y": 12.837,
              "z": 1.224
            },
            "rightCorner": {
              "x": 14.766,
              "y": 12.83,
              "z": 1.224
            },
            "gtin": "8711000377505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0ea",
            "leftCorner": {
              "x": 14.766,
              "y": 12.83,
              "z": 1.224
            },
            "rightCorner": {
              "x": 14.851,
              "y": 12.822,
              "z": 1.224
            },
            "gtin": "8711000377505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0e3",
            "leftCorner": {
              "x": 14.852,
              "y": 12.825,
              "z": 1.224
            },
            "rightCorner": {
              "x": 14.963,
              "y": 12.816,
              "z": 1.224
            },
            "gtin": "8711000477571",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462ed",
        "height": 1.7448,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e093",
            "leftCorner": {
              "x": 13.787,
              "y": 12.903,
              "z": 1.428
            },
            "rightCorner": {
              "x": 13.872,
              "y": 12.896,
              "z": 1.428
            },
            "gtin": "4008167011101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e094",
            "leftCorner": {
              "x": 13.872,
              "y": 12.895,
              "z": 1.428
            },
            "rightCorner": {
              "x": 13.969,
              "y": 12.886,
              "z": 1.428
            },
            "gtin": "4008167011804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e095",
            "leftCorner": {
              "x": 13.969,
              "y": 12.887,
              "z": 1.428
            },
            "rightCorner": {
              "x": 14.044,
              "y": 12.881,
              "z": 1.428
            },
            "gtin": "4008167010609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e096",
            "leftCorner": {
              "x": 14.044,
              "y": 12.881,
              "z": 1.428
            },
            "rightCorner": {
              "x": 14.121,
              "y": 12.874,
              "z": 1.428
            },
            "gtin": "4008167010609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e097",
            "leftCorner": {
              "x": 14.121,
              "y": 12.868,
              "z": 1.428
            },
            "rightCorner": {
              "x": 14.206,
              "y": 12.861,
              "z": 1.428
            },
            "gtin": "8003753158648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e098",
            "leftCorner": {
              "x": 14.207,
              "y": 12.872,
              "z": 1.428
            },
            "rightCorner": {
              "x": 14.285,
              "y": 12.865,
              "z": 1.428
            },
            "gtin": "8003753158556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e099",
            "leftCorner": {
              "x": 14.285,
              "y": 12.867,
              "z": 1.428
            },
            "rightCorner": {
              "x": 14.359,
              "y": 12.86,
              "z": 1.428
            },
            "gtin": "8003753158617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e09a",
            "leftCorner": {
              "x": 14.358,
              "y": 12.855,
              "z": 1.428
            },
            "rightCorner": {
              "x": 14.45,
              "y": 12.846,
              "z": 1.428
            },
            "gtin": "8003753168142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e09b",
            "leftCorner": {
              "x": 14.45,
              "y": 12.847,
              "z": 1.428
            },
            "rightCorner": {
              "x": 14.547,
              "y": 12.839,
              "z": 1.428
            },
            "gtin": "4037014964123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e09c",
            "leftCorner": {
              "x": 14.546,
              "y": 12.832,
              "z": 1.428
            },
            "rightCorner": {
              "x": 14.676,
              "y": 12.82,
              "z": 1.428
            },
            "gtin": "4037014964048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e09d",
            "leftCorner": {
              "x": 14.676,
              "y": 12.824,
              "z": 1.428
            },
            "rightCorner": {
              "x": 14.763,
              "y": 12.816,
              "z": 1.428
            },
            "gtin": "4037014963928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e09e",
            "leftCorner": {
              "x": 14.763,
              "y": 12.816,
              "z": 1.428
            },
            "rightCorner": {
              "x": 14.852,
              "y": 12.809,
              "z": 1.428
            },
            "gtin": "4037014963928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e09f",
            "leftCorner": {
              "x": 14.853,
              "y": 12.817,
              "z": 1.428
            },
            "rightCorner": {
              "x": 14.957,
              "y": 12.807,
              "z": 1.428
            },
            "gtin": "4037014964000",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "6ebb6",
    "rightNeighborShelfId": "6ebb4"
  },
  {
    "id": "6ebb6",
    "name": "6ebb6",
    "x": 12.567,
    "y": 12.967,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.043192,
      "w": 0.99907
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 42
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5462eb",
        "height": 0.1473,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dffd",
            "leftCorner": {
              "x": 12.817,
              "y": 13.0,
              "z": 0.121
            },
            "rightCorner": {
              "x": 13.029,
              "y": 12.982,
              "z": 0.121
            },
            "gtin": "4009299119611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dffe",
            "leftCorner": {
              "x": 13.029,
              "y": 12.979,
              "z": 0.121
            },
            "rightCorner": {
              "x": 13.22,
              "y": 12.963,
              "z": 0.121
            },
            "gtin": "4063367408496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfff",
            "leftCorner": {
              "x": 13.22,
              "y": 12.968,
              "z": 0.121
            },
            "rightCorner": {
              "x": 13.346,
              "y": 12.957,
              "z": 0.121
            },
            "gtin": "4063367408472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e000",
            "leftCorner": {
              "x": 13.346,
              "y": 12.957,
              "z": 0.121
            },
            "rightCorner": {
              "x": 13.471,
              "y": 12.946,
              "z": 0.121
            },
            "gtin": "4063367408472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e001",
            "leftCorner": {
              "x": 13.471,
              "y": 12.946,
              "z": 0.121
            },
            "rightCorner": {
              "x": 13.596,
              "y": 12.936,
              "z": 0.121
            },
            "gtin": "4063367408472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e002",
            "leftCorner": {
              "x": 13.597,
              "y": 12.944,
              "z": 0.121
            },
            "rightCorner": {
              "x": 13.832,
              "y": 12.923,
              "z": 0.121
            },
            "gtin": "4337185458392",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462ec",
        "height": 0.74118,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e02e",
            "leftCorner": {
              "x": 13.257,
              "y": 12.954,
              "z": 0.606
            },
            "rightCorner": {
              "x": 13.357,
              "y": 12.945,
              "z": 0.606
            },
            "gtin": "4006581021058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e02f",
            "leftCorner": {
              "x": 13.357,
              "y": 12.945,
              "z": 0.606
            },
            "rightCorner": {
              "x": 13.458,
              "y": 12.936,
              "z": 0.606
            },
            "gtin": "4006581021058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e030",
            "leftCorner": {
              "x": 13.458,
              "y": 12.936,
              "z": 0.606
            },
            "rightCorner": {
              "x": 13.557,
              "y": 12.927,
              "z": 0.606
            },
            "gtin": "4006581021058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e028",
            "leftCorner": {
              "x": 13.557,
              "y": 12.925,
              "z": 0.606
            },
            "rightCorner": {
              "x": 13.627,
              "y": 12.92,
              "z": 0.606
            },
            "gtin": "4006581020686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e029",
            "leftCorner": {
              "x": 13.627,
              "y": 12.92,
              "z": 0.606
            },
            "rightCorner": {
              "x": 13.697,
              "y": 12.913,
              "z": 0.606
            },
            "gtin": "4006581020686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e02a",
            "leftCorner": {
              "x": 13.697,
              "y": 12.913,
              "z": 0.606
            },
            "rightCorner": {
              "x": 13.767,
              "y": 12.908,
              "z": 0.606
            },
            "gtin": "4006581020686",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462ea",
        "height": 1.0933,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e0ce",
            "leftCorner": {
              "x": 12.567,
              "y": 12.961,
              "z": 0.895
            },
            "rightCorner": {
              "x": 12.774,
              "y": 12.944,
              "z": 0.895
            },
            "gtin": "5901211000085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0cf",
            "leftCorner": {
              "x": 12.774,
              "y": 12.944,
              "z": 0.895
            },
            "rightCorner": {
              "x": 12.98,
              "y": 12.925,
              "z": 0.895
            },
            "gtin": "5901211000085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0d1",
            "leftCorner": {
              "x": 12.982,
              "y": 12.947,
              "z": 0.895
            },
            "rightCorner": {
              "x": 13.08,
              "y": 12.939,
              "z": 0.895
            },
            "gtin": "5901211000566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0d2",
            "leftCorner": {
              "x": 13.08,
              "y": 12.939,
              "z": 0.895
            },
            "rightCorner": {
              "x": 13.178,
              "y": 12.931,
              "z": 0.895
            },
            "gtin": "5901211000566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0d3",
            "leftCorner": {
              "x": 13.179,
              "y": 12.954,
              "z": 0.895
            },
            "rightCorner": {
              "x": 13.24,
              "y": 12.949,
              "z": 0.895
            },
            "gtin": "4337185928505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0d4",
            "leftCorner": {
              "x": 13.24,
              "y": 12.949,
              "z": 0.895
            },
            "rightCorner": {
              "x": 13.301,
              "y": 12.944,
              "z": 0.895
            },
            "gtin": "4337185928505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0d5",
            "leftCorner": {
              "x": 13.301,
              "y": 12.942,
              "z": 0.895
            },
            "rightCorner": {
              "x": 13.495,
              "y": 12.925,
              "z": 0.895
            },
            "gtin": "4337185928567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0d6",
            "leftCorner": {
              "x": 13.495,
              "y": 12.923,
              "z": 0.895
            },
            "rightCorner": {
              "x": 13.556,
              "y": 12.918,
              "z": 0.895
            },
            "gtin": "4337185928581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0d7",
            "leftCorner": {
              "x": 13.556,
              "y": 12.918,
              "z": 0.895
            },
            "rightCorner": {
              "x": 13.618,
              "y": 12.913,
              "z": 0.895
            },
            "gtin": "4337185928581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0d0",
            "leftCorner": {
              "x": 13.617,
              "y": 12.906,
              "z": 0.895
            },
            "rightCorner": {
              "x": 13.766,
              "y": 12.893,
              "z": 0.895
            },
            "gtin": "5901211000573",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462e9",
        "height": 1.4449,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e0c7",
            "leftCorner": {
              "x": 12.565,
              "y": 12.942,
              "z": 1.182
            },
            "rightCorner": {
              "x": 12.781,
              "y": 12.924,
              "z": 1.182
            },
            "gtin": "8000070053564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0c9",
            "leftCorner": {
              "x": 12.784,
              "y": 12.963,
              "z": 1.182
            },
            "rightCorner": {
              "x": 12.89,
              "y": 12.954,
              "z": 1.182
            },
            "gtin": "8000070053571",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c855ed67a01d9a1e0ca",
            "leftCorner": {
              "x": 12.889,
              "y": 12.945,
              "z": 1.182
            },
            "rightCorner": {
              "x": 13.197,
              "y": 12.919,
              "z": 1.182
            },
            "gtin": "8000070053625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0cb",
            "leftCorner": {
              "x": 13.197,
              "y": 12.916,
              "z": 1.182
            },
            "rightCorner": {
              "x": 13.44,
              "y": 12.896,
              "z": 1.182
            },
            "gtin": "8000070053540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0cc",
            "leftCorner": {
              "x": 13.441,
              "y": 12.908,
              "z": 1.182
            },
            "rightCorner": {
              "x": 13.541,
              "y": 12.899,
              "z": 1.182
            },
            "gtin": "5901211000559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0cd",
            "leftCorner": {
              "x": 13.541,
              "y": 12.899,
              "z": 1.182
            },
            "rightCorner": {
              "x": 13.639,
              "y": 12.891,
              "z": 1.182
            },
            "gtin": "5901211000559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0c8",
            "leftCorner": {
              "x": 13.641,
              "y": 12.908,
              "z": 1.182
            },
            "rightCorner": {
              "x": 13.766,
              "y": 12.898,
              "z": 1.182
            },
            "gtin": "4337185928604",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462e8",
        "height": 1.7444,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e084",
            "leftCorner": {
              "x": 12.566,
              "y": 12.95,
              "z": 1.427
            },
            "rightCorner": {
              "x": 12.639,
              "y": 12.944,
              "z": 1.427
            },
            "gtin": "4008167009900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e086",
            "leftCorner": {
              "x": 12.64,
              "y": 12.964,
              "z": 1.427
            },
            "rightCorner": {
              "x": 12.758,
              "y": 12.954,
              "z": 1.427
            },
            "gtin": "4008167009801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e087",
            "leftCorner": {
              "x": 12.757,
              "y": 12.952,
              "z": 1.427
            },
            "rightCorner": {
              "x": 12.86,
              "y": 12.943,
              "z": 1.427
            },
            "gtin": "4008167012801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e088",
            "leftCorner": {
              "x": 12.86,
              "y": 12.947,
              "z": 1.427
            },
            "rightCorner": {
              "x": 12.908,
              "y": 12.943,
              "z": 1.427
            },
            "gtin": "4008167010807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e089",
            "leftCorner": {
              "x": 12.908,
              "y": 12.943,
              "z": 1.427
            },
            "rightCorner": {
              "x": 12.955,
              "y": 12.938,
              "z": 1.427
            },
            "gtin": "4008167010807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e08a",
            "leftCorner": {
              "x": 12.955,
              "y": 12.938,
              "z": 1.427
            },
            "rightCorner": {
              "x": 13.002,
              "y": 12.934,
              "z": 1.427
            },
            "gtin": "4008167010807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e08b",
            "leftCorner": {
              "x": 13.002,
              "y": 12.937,
              "z": 1.427
            },
            "rightCorner": {
              "x": 13.102,
              "y": 12.928,
              "z": 1.427
            },
            "gtin": "4008167010104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e08c",
            "leftCorner": {
              "x": 13.104,
              "y": 12.943,
              "z": 1.427
            },
            "rightCorner": {
              "x": 13.204,
              "y": 12.935,
              "z": 1.427
            },
            "gtin": "4008167010302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e08d",
            "leftCorner": {
              "x": 13.206,
              "y": 12.941,
              "z": 1.427
            },
            "rightCorner": {
              "x": 13.284,
              "y": 12.934,
              "z": 1.427
            },
            "gtin": "4008167011804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e08e",
            "leftCorner": {
              "x": 13.284,
              "y": 12.928,
              "z": 1.427
            },
            "rightCorner": {
              "x": 13.456,
              "y": 12.914,
              "z": 1.427
            },
            "gtin": "4008167011903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e08f",
            "leftCorner": {
              "x": 13.456,
              "y": 12.911,
              "z": 1.427
            },
            "rightCorner": {
              "x": 13.554,
              "y": 12.902,
              "z": 1.427
            },
            "gtin": "4008167011200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e090",
            "leftCorner": {
              "x": 13.554,
              "y": 12.907,
              "z": 1.427
            },
            "rightCorner": {
              "x": 13.631,
              "y": 12.9,
              "z": 1.427
            },
            "gtin": "4008167011002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e091",
            "leftCorner": {
              "x": 13.631,
              "y": 12.897,
              "z": 1.427
            },
            "rightCorner": {
              "x": 13.708,
              "y": 12.89,
              "z": 1.427
            },
            "gtin": "4008167010500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e092",
            "leftCorner": {
              "x": 13.708,
              "y": 12.89,
              "z": 1.427
            },
            "rightCorner": {
              "x": 13.786,
              "y": 12.884,
              "z": 1.427
            },
            "gtin": "4008167010500",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "6ebb7",
    "rightNeighborShelfId": "6ebb5"
  },
  {
    "id": "6ebb7",
    "name": "6ebb7",
    "x": 11.371,
    "y": 13.07,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.043192,
      "w": 0.99907
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 41
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5462e1",
        "height": 0.144,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dff3",
            "leftCorner": {
              "x": 11.374,
              "y": 13.092,
              "z": 0.118
            },
            "rightCorner": {
              "x": 11.589,
              "y": 13.073,
              "z": 0.118
            },
            "gtin": "8711000708712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dff4",
            "leftCorner": {
              "x": 11.589,
              "y": 13.073,
              "z": 0.118
            },
            "rightCorner": {
              "x": 11.805,
              "y": 13.054,
              "z": 0.118
            },
            "gtin": "8711000708712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dff7",
            "leftCorner": {
              "x": 11.808,
              "y": 13.094,
              "z": 0.118
            },
            "rightCorner": {
              "x": 12.019,
              "y": 13.075,
              "z": 0.118
            },
            "gtin": "8711000708743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dff8",
            "leftCorner": {
              "x": 12.021,
              "y": 13.09,
              "z": 0.118
            },
            "rightCorner": {
              "x": 12.124,
              "y": 13.081,
              "z": 0.118
            },
            "gtin": "4000508002830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dff9",
            "leftCorner": {
              "x": 12.124,
              "y": 13.081,
              "z": 0.118
            },
            "rightCorner": {
              "x": 12.228,
              "y": 13.072,
              "z": 0.118
            },
            "gtin": "4000508002830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dffa",
            "leftCorner": {
              "x": 12.226,
              "y": 13.056,
              "z": 0.118
            },
            "rightCorner": {
              "x": 12.427,
              "y": 13.038,
              "z": 0.118
            },
            "gtin": "8711000708651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dffb",
            "leftCorner": {
              "x": 12.426,
              "y": 13.031,
              "z": 0.118
            },
            "rightCorner": {
              "x": 12.621,
              "y": 13.015,
              "z": 0.118
            },
            "gtin": "8711000708774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dffc",
            "leftCorner": {
              "x": 12.621,
              "y": 13.015,
              "z": 0.118
            },
            "rightCorner": {
              "x": 12.817,
              "y": 12.998,
              "z": 0.118
            },
            "gtin": "8711000708774",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462e2",
        "height": 0.74574,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e025",
            "leftCorner": {
              "x": 11.373,
              "y": 13.086,
              "z": 0.61
            },
            "rightCorner": {
              "x": 11.647,
              "y": 13.062,
              "z": 0.61
            },
            "gtin": "4000508059087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e026",
            "leftCorner": {
              "x": 11.647,
              "y": 13.062,
              "z": 0.61
            },
            "rightCorner": {
              "x": 11.921,
              "y": 13.038,
              "z": 0.61
            },
            "gtin": "4000508059087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e027",
            "leftCorner": {
              "x": 11.921,
              "y": 13.038,
              "z": 0.61
            },
            "rightCorner": {
              "x": 12.195,
              "y": 13.015,
              "z": 0.61
            },
            "gtin": "4000508059087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e02b",
            "leftCorner": {
              "x": 12.199,
              "y": 13.056,
              "z": 0.61
            },
            "rightCorner": {
              "x": 12.552,
              "y": 13.025,
              "z": 0.61
            },
            "gtin": "8711000707241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e02c",
            "leftCorner": {
              "x": 12.552,
              "y": 13.025,
              "z": 0.61
            },
            "rightCorner": {
              "x": 12.905,
              "y": 12.994,
              "z": 0.61
            },
            "gtin": "8711000707241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e02d",
            "leftCorner": {
              "x": 12.905,
              "y": 12.994,
              "z": 0.61
            },
            "rightCorner": {
              "x": 13.257,
              "y": 12.964,
              "z": 0.61
            },
            "gtin": "8711000707241",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462e0",
        "height": 1.0509,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dfed",
            "leftCorner": {
              "x": 11.373,
              "y": 13.082,
              "z": 0.86
            },
            "rightCorner": {
              "x": 11.67,
              "y": 13.055,
              "z": 0.86
            },
            "gtin": "4037014964499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfee",
            "leftCorner": {
              "x": 11.67,
              "y": 13.055,
              "z": 0.86
            },
            "rightCorner": {
              "x": 11.968,
              "y": 13.03,
              "z": 0.86
            },
            "gtin": "4037014964499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dff0",
            "leftCorner": {
              "x": 11.972,
              "y": 13.078,
              "z": 0.86
            },
            "rightCorner": {
              "x": 12.13,
              "y": 13.064,
              "z": 0.86
            },
            "gtin": "4037014964536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dff1",
            "leftCorner": {
              "x": 12.13,
              "y": 13.064,
              "z": 0.86
            },
            "rightCorner": {
              "x": 12.287,
              "y": 13.05,
              "z": 0.86
            },
            "gtin": "4037014964536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dff2",
            "leftCorner": {
              "x": 12.287,
              "y": 13.05,
              "z": 0.86
            },
            "rightCorner": {
              "x": 12.446,
              "y": 13.037,
              "z": 0.86
            },
            "gtin": "4037014964536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfef",
            "leftCorner": {
              "x": 12.443,
              "y": 13.011,
              "z": 0.86
            },
            "rightCorner": {
              "x": 12.57,
              "y": 13.0,
              "z": 0.86
            },
            "gtin": "4006581020013",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462dd",
        "height": 1.3602,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dfcb",
            "leftCorner": {
              "x": 11.371,
              "y": 13.072,
              "z": 1.113
            },
            "rightCorner": {
              "x": 11.503,
              "y": 13.061,
              "z": 1.113
            },
            "gtin": "8711000670026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfcd",
            "leftCorner": {
              "x": 11.507,
              "y": 13.101,
              "z": 1.113
            },
            "rightCorner": {
              "x": 11.613,
              "y": 13.092,
              "z": 1.113
            },
            "gtin": "8711000669990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfce",
            "leftCorner": {
              "x": 11.613,
              "y": 13.091,
              "z": 1.113
            },
            "rightCorner": {
              "x": 11.707,
              "y": 13.083,
              "z": 1.113
            },
            "gtin": "8711000669969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfcf",
            "leftCorner": {
              "x": 11.707,
              "y": 13.083,
              "z": 1.113
            },
            "rightCorner": {
              "x": 11.801,
              "y": 13.075,
              "z": 1.113
            },
            "gtin": "8711000669969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfd0",
            "leftCorner": {
              "x": 11.801,
              "y": 13.078,
              "z": 1.113
            },
            "rightCorner": {
              "x": 12.428,
              "y": 13.023,
              "z": 1.113
            },
            "gtin": "4006581020006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfcc",
            "leftCorner": {
              "x": 12.428,
              "y": 13.011,
              "z": 1.113
            },
            "rightCorner": {
              "x": 12.57,
              "y": 12.999,
              "z": 1.113
            },
            "gtin": "4006581020020",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462de",
        "height": 1.7565,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dfe1",
            "leftCorner": {
              "x": 11.384,
              "y": 13.115,
              "z": 1.437
            },
            "rightCorner": {
              "x": 11.487,
              "y": 13.105,
              "z": 1.437
            },
            "gtin": "8003753900438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfe2",
            "leftCorner": {
              "x": 11.487,
              "y": 13.108,
              "z": 1.437
            },
            "rightCorner": {
              "x": 11.567,
              "y": 13.101,
              "z": 1.437
            },
            "gtin": "8003753900490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfe3",
            "leftCorner": {
              "x": 11.567,
              "y": 13.101,
              "z": 1.437
            },
            "rightCorner": {
              "x": 11.646,
              "y": 13.094,
              "z": 1.437
            },
            "gtin": "8003753900490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfe4",
            "leftCorner": {
              "x": 11.646,
              "y": 13.094,
              "z": 1.437
            },
            "rightCorner": {
              "x": 11.724,
              "y": 13.087,
              "z": 1.437
            },
            "gtin": "8003753900490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfe5",
            "leftCorner": {
              "x": 11.724,
              "y": 13.078,
              "z": 1.437
            },
            "rightCorner": {
              "x": 11.78,
              "y": 13.073,
              "z": 1.437
            },
            "gtin": "8003753900438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfe6",
            "leftCorner": {
              "x": 11.78,
              "y": 13.073,
              "z": 1.437
            },
            "rightCorner": {
              "x": 11.837,
              "y": 13.069,
              "z": 1.437
            },
            "gtin": "8003753900438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfe7",
            "leftCorner": {
              "x": 11.837,
              "y": 13.071,
              "z": 1.437
            },
            "rightCorner": {
              "x": 11.925,
              "y": 13.063,
              "z": 1.437
            },
            "gtin": "8003753900520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfe8",
            "leftCorner": {
              "x": 11.925,
              "y": 13.063,
              "z": 1.437
            },
            "rightCorner": {
              "x": 12.012,
              "y": 13.056,
              "z": 1.437
            },
            "gtin": "8003753900520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfe9",
            "leftCorner": {
              "x": 12.012,
              "y": 13.064,
              "z": 1.437
            },
            "rightCorner": {
              "x": 12.121,
              "y": 13.053,
              "z": 1.437
            },
            "gtin": "8003753902630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfea",
            "leftCorner": {
              "x": 12.121,
              "y": 13.053,
              "z": 1.437
            },
            "rightCorner": {
              "x": 12.23,
              "y": 13.044,
              "z": 1.437
            },
            "gtin": "8003753902630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfeb",
            "leftCorner": {
              "x": 12.23,
              "y": 13.032,
              "z": 1.437
            },
            "rightCorner": {
              "x": 12.328,
              "y": 13.024,
              "z": 1.437
            },
            "gtin": "8003753900469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfec",
            "leftCorner": {
              "x": 12.328,
              "y": 13.024,
              "z": 1.437
            },
            "rightCorner": {
              "x": 12.428,
              "y": 13.015,
              "z": 1.437
            },
            "gtin": "8003753900469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfd3",
            "leftCorner": {
              "x": 12.427,
              "y": 13.007,
              "z": 1.437
            },
            "rightCorner": {
              "x": 12.474,
              "y": 13.004,
              "z": 1.437
            },
            "gtin": "8003753214887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfd4",
            "leftCorner": {
              "x": 12.474,
              "y": 13.004,
              "z": 1.437
            },
            "rightCorner": {
              "x": 12.522,
              "y": 12.999,
              "z": 1.437
            },
            "gtin": "8003753214887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfd5",
            "leftCorner": {
              "x": 12.522,
              "y": 12.999,
              "z": 1.437
            },
            "rightCorner": {
              "x": 12.57,
              "y": 12.996,
              "z": 1.437
            },
            "gtin": "8003753214887",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "6ebb8",
    "rightNeighborShelfId": "6ebb6"
  },
  {
    "id": "6ebb8",
    "name": "6ebb8",
    "x": 10.176,
    "y": 13.174,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.043192,
      "w": 0.99907
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 38
    },
    "layers": [
      {
        "id": "682ffddfd15af3232a5469c8",
        "height": 0.15863,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21889",
            "leftCorner": {
              "x": 10.765,
              "y": 13.131,
              "z": 0.13
            },
            "rightCorner": {
              "x": 10.903,
              "y": 13.119,
              "z": 0.13
            },
            "gtin": "4002720000304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21882",
            "leftCorner": {
              "x": 10.902,
              "y": 13.109,
              "z": 0.13
            },
            "rightCorner": {
              "x": 11.019,
              "y": 13.1,
              "z": 0.13
            },
            "gtin": "4002720004975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21881",
            "leftCorner": {
              "x": 10.173,
              "y": 13.145,
              "z": 0.13
            },
            "rightCorner": {
              "x": 10.276,
              "y": 13.137,
              "z": 0.13
            },
            "gtin": "4002720000496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21886",
            "leftCorner": {
              "x": 10.28,
              "y": 13.176,
              "z": 0.13
            },
            "rightCorner": {
              "x": 10.489,
              "y": 13.158,
              "z": 0.13
            },
            "gtin": "4002720002261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21887",
            "leftCorner": {
              "x": 10.488,
              "y": 13.155,
              "z": 0.13
            },
            "rightCorner": {
              "x": 10.627,
              "y": 13.143,
              "z": 0.13
            },
            "gtin": "4002720000304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21888",
            "leftCorner": {
              "x": 10.627,
              "y": 13.143,
              "z": 0.13
            },
            "rightCorner": {
              "x": 10.765,
              "y": 13.131,
              "z": 0.13
            },
            "gtin": "4002720000304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21883",
            "leftCorner": {
              "x": 11.019,
              "y": 13.1,
              "z": 0.13
            },
            "rightCorner": {
              "x": 11.137,
              "y": 13.089,
              "z": 0.13
            },
            "gtin": "4002720004975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21884",
            "leftCorner": {
              "x": 11.137,
              "y": 13.089,
              "z": 0.13
            },
            "rightCorner": {
              "x": 11.254,
              "y": 13.079,
              "z": 0.13
            },
            "gtin": "4002720004975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21885",
            "leftCorner": {
              "x": 11.254,
              "y": 13.079,
              "z": 0.13
            },
            "rightCorner": {
              "x": 11.371,
              "y": 13.068,
              "z": 0.13
            },
            "gtin": "4002720004975",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469c7",
        "height": 1.7663,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dfd6",
            "leftCorner": {
              "x": 10.279,
              "y": 13.177,
              "z": 1.445
            },
            "rightCorner": {
              "x": 10.323,
              "y": 13.174,
              "z": 1.445
            },
            "gtin": "9001414043783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfd7",
            "leftCorner": {
              "x": 10.323,
              "y": 13.174,
              "z": 1.445
            },
            "rightCorner": {
              "x": 10.367,
              "y": 13.17,
              "z": 1.445
            },
            "gtin": "9001414043783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfd8",
            "leftCorner": {
              "x": 10.365,
              "y": 13.157,
              "z": 1.445
            },
            "rightCorner": {
              "x": 10.499,
              "y": 13.145,
              "z": 1.445
            },
            "gtin": "4008167504009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfd9",
            "leftCorner": {
              "x": 10.499,
              "y": 13.145,
              "z": 1.445
            },
            "rightCorner": {
              "x": 10.632,
              "y": 13.134,
              "z": 1.445
            },
            "gtin": "4008167504009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfda",
            "leftCorner": {
              "x": 10.632,
              "y": 13.14,
              "z": 1.445
            },
            "rightCorner": {
              "x": 10.796,
              "y": 13.126,
              "z": 1.445
            },
            "gtin": "4006581071466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfdb",
            "leftCorner": {
              "x": 10.794,
              "y": 13.101,
              "z": 1.445
            },
            "rightCorner": {
              "x": 10.867,
              "y": 13.095,
              "z": 1.445
            },
            "gtin": "4006581082608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfdc",
            "leftCorner": {
              "x": 10.867,
              "y": 13.095,
              "z": 1.445
            },
            "rightCorner": {
              "x": 10.941,
              "y": 13.089,
              "z": 1.445
            },
            "gtin": "4006581082608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfdd",
            "leftCorner": {
              "x": 10.941,
              "y": 13.09,
              "z": 1.445
            },
            "rightCorner": {
              "x": 11.022,
              "y": 13.082,
              "z": 1.445
            },
            "gtin": "4063367004117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfde",
            "leftCorner": {
              "x": 11.022,
              "y": 13.082,
              "z": 1.445
            },
            "rightCorner": {
              "x": 11.104,
              "y": 13.075,
              "z": 1.445
            },
            "gtin": "4063367004117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfdf",
            "leftCorner": {
              "x": 11.103,
              "y": 13.07,
              "z": 1.445
            },
            "rightCorner": {
              "x": 11.241,
              "y": 13.059,
              "z": 1.445
            },
            "gtin": "4013743000233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfe0",
            "leftCorner": {
              "x": 11.241,
              "y": 13.059,
              "z": 1.445
            },
            "rightCorner": {
              "x": 11.378,
              "y": 13.047,
              "z": 1.445
            },
            "gtin": "4013743000233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfd1",
            "leftCorner": {
              "x": 10.173,
              "y": 13.136,
              "z": 1.445
            },
            "rightCorner": {
              "x": 10.224,
              "y": 13.132,
              "z": 1.445
            },
            "gtin": "9001414043806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfd2",
            "leftCorner": {
              "x": 10.224,
              "y": 13.132,
              "z": 1.445
            },
            "rightCorner": {
              "x": 10.274,
              "y": 13.127,
              "z": 1.445
            },
            "gtin": "9001414043806",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469ca",
        "height": 0.75945,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21891",
            "leftCorner": {
              "x": 10.172,
              "y": 13.127,
              "z": 0.621
            },
            "rightCorner": {
              "x": 10.428,
              "y": 13.105,
              "z": 0.621
            },
            "gtin": "4002720002117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21892",
            "leftCorner": {
              "x": 10.428,
              "y": 13.105,
              "z": 0.621
            },
            "rightCorner": {
              "x": 10.684,
              "y": 13.082,
              "z": 0.621
            },
            "gtin": "4002720002117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21893",
            "leftCorner": {
              "x": 10.684,
              "y": 13.082,
              "z": 0.621
            },
            "rightCorner": {
              "x": 10.94,
              "y": 13.061,
              "z": 0.621
            },
            "gtin": "4002720002117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21898",
            "leftCorner": {
              "x": 10.944,
              "y": 13.103,
              "z": 0.621
            },
            "rightCorner": {
              "x": 11.032,
              "y": 13.094,
              "z": 0.621
            },
            "gtin": "4002720002391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21899",
            "leftCorner": {
              "x": 11.032,
              "y": 13.094,
              "z": 0.621
            },
            "rightCorner": {
              "x": 11.12,
              "y": 13.087,
              "z": 0.621
            },
            "gtin": "4002720002391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21894",
            "leftCorner": {
              "x": 11.119,
              "y": 13.085,
              "z": 0.621
            },
            "rightCorner": {
              "x": 11.182,
              "y": 13.079,
              "z": 0.621
            },
            "gtin": "4002720002100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21895",
            "leftCorner": {
              "x": 11.182,
              "y": 13.079,
              "z": 0.621
            },
            "rightCorner": {
              "x": 11.245,
              "y": 13.074,
              "z": 0.621
            },
            "gtin": "4002720002100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21896",
            "leftCorner": {
              "x": 11.245,
              "y": 13.074,
              "z": 0.621
            },
            "rightCorner": {
              "x": 11.308,
              "y": 13.068,
              "z": 0.621
            },
            "gtin": "4002720002100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21897",
            "leftCorner": {
              "x": 11.308,
              "y": 13.068,
              "z": 0.621
            },
            "rightCorner": {
              "x": 11.371,
              "y": 13.063,
              "z": 0.621
            },
            "gtin": "4002720002100",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469c9",
        "height": 1.2719,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2188a",
            "leftCorner": {
              "x": 10.172,
              "y": 13.133,
              "z": 1.041
            },
            "rightCorner": {
              "x": 10.467,
              "y": 13.108,
              "z": 1.041
            },
            "gtin": "8711000509562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2188b",
            "leftCorner": {
              "x": 10.467,
              "y": 13.108,
              "z": 1.041
            },
            "rightCorner": {
              "x": 10.762,
              "y": 13.082,
              "z": 1.041
            },
            "gtin": "8711000509562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2188f",
            "leftCorner": {
              "x": 10.765,
              "y": 13.122,
              "z": 1.041
            },
            "rightCorner": {
              "x": 10.864,
              "y": 13.114,
              "z": 1.041
            },
            "gtin": "4006581092607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21890",
            "leftCorner": {
              "x": 10.864,
              "y": 13.114,
              "z": 1.041
            },
            "rightCorner": {
              "x": 10.963,
              "y": 13.105,
              "z": 1.041
            },
            "gtin": "4006581092607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2188c",
            "leftCorner": {
              "x": 10.961,
              "y": 13.088,
              "z": 1.041
            },
            "rightCorner": {
              "x": 11.098,
              "y": 13.077,
              "z": 1.041
            },
            "gtin": "4006581002606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2188d",
            "leftCorner": {
              "x": 11.098,
              "y": 13.077,
              "z": 1.041
            },
            "rightCorner": {
              "x": 11.234,
              "y": 13.065,
              "z": 1.041
            },
            "gtin": "4006581002606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2188e",
            "leftCorner": {
              "x": 11.234,
              "y": 13.065,
              "z": 1.041
            },
            "rightCorner": {
              "x": 11.37,
              "y": 13.053,
              "z": 1.041
            },
            "gtin": "4006581002606",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "da3e4",
    "rightNeighborShelfId": "6ebb7"
  },
  {
    "id": "6ebce",
    "name": "6ebce",
    "x": 19.304,
    "y": 16.975,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99956,
      "w": 0.029806
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 21
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54635b",
        "height": 1.7032,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d92f",
            "leftCorner": {
              "x": 18.94,
              "y": 16.76,
              "z": 1.394
            },
            "rightCorner": {
              "x": 18.81,
              "y": 16.767,
              "z": 1.394
            },
            "gtin": "4008418032596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d92e",
            "leftCorner": {
              "x": 19.069,
              "y": 16.751,
              "z": 1.394
            },
            "rightCorner": {
              "x": 18.94,
              "y": 16.76,
              "z": 1.394
            },
            "gtin": "4008418032596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d929",
            "leftCorner": {
              "x": 19.292,
              "y": 16.778,
              "z": 1.394
            },
            "rightCorner": {
              "x": 19.219,
              "y": 16.783,
              "z": 1.394
            },
            "gtin": "4008418404126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d92a",
            "leftCorner": {
              "x": 19.219,
              "y": 16.783,
              "z": 1.394
            },
            "rightCorner": {
              "x": 19.145,
              "y": 16.787,
              "z": 1.394
            },
            "gtin": "4008418404126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d92b",
            "leftCorner": {
              "x": 19.145,
              "y": 16.787,
              "z": 1.394
            },
            "rightCorner": {
              "x": 19.072,
              "y": 16.791,
              "z": 1.394
            },
            "gtin": "4008418404126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d930",
            "leftCorner": {
              "x": 18.809,
              "y": 16.756,
              "z": 1.394
            },
            "rightCorner": {
              "x": 18.735,
              "y": 16.76,
              "z": 1.394
            },
            "gtin": "4337185468834",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c845ed67a01d9a1d931",
            "leftCorner": {
              "x": 18.736,
              "y": 16.763,
              "z": 1.394
            },
            "rightCorner": {
              "x": 18.565,
              "y": 16.773,
              "z": 1.394
            },
            "gtin": "4000624056724",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54635c",
        "height": 0.80296,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d9fd",
            "leftCorner": {
              "x": 19.298,
              "y": 16.878,
              "z": 0.657
            },
            "rightCorner": {
              "x": 19.227,
              "y": 16.882,
              "z": 0.657
            },
            "gtin": "40804095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9fe",
            "leftCorner": {
              "x": 19.227,
              "y": 16.882,
              "z": 0.657
            },
            "rightCorner": {
              "x": 19.158,
              "y": 16.886,
              "z": 0.657
            },
            "gtin": "40804095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9ff",
            "leftCorner": {
              "x": 19.158,
              "y": 16.886,
              "z": 0.657
            },
            "rightCorner": {
              "x": 19.088,
              "y": 16.891,
              "z": 0.657
            },
            "gtin": "40804095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da00",
            "leftCorner": {
              "x": 19.088,
              "y": 16.891,
              "z": 0.657
            },
            "rightCorner": {
              "x": 19.018,
              "y": 16.894,
              "z": 0.657
            },
            "gtin": "40804095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da03",
            "leftCorner": {
              "x": 19.016,
              "y": 16.868,
              "z": 0.657
            },
            "rightCorner": {
              "x": 18.918,
              "y": 16.874,
              "z": 0.657
            },
            "gtin": "40804033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da04",
            "leftCorner": {
              "x": 18.918,
              "y": 16.874,
              "z": 0.657
            },
            "rightCorner": {
              "x": 18.82,
              "y": 16.88,
              "z": 0.657
            },
            "gtin": "40804033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da05",
            "leftCorner": {
              "x": 18.82,
              "y": 16.88,
              "z": 0.657
            },
            "rightCorner": {
              "x": 18.722,
              "y": 16.886,
              "z": 0.657
            },
            "gtin": "40804033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da06",
            "leftCorner": {
              "x": 18.721,
              "y": 16.873,
              "z": 0.657
            },
            "rightCorner": {
              "x": 18.639,
              "y": 16.878,
              "z": 0.657
            },
            "gtin": "4009309572542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da07",
            "leftCorner": {
              "x": 18.639,
              "y": 16.878,
              "z": 0.657
            },
            "rightCorner": {
              "x": 18.557,
              "y": 16.883,
              "z": 0.657
            },
            "gtin": "4009309572542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da08",
            "leftCorner": {
              "x": 18.557,
              "y": 16.883,
              "z": 0.657
            },
            "rightCorner": {
              "x": 18.474,
              "y": 16.887,
              "z": 0.657
            },
            "gtin": "4009309572542",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54635a",
        "height": 1.305,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d99f",
            "leftCorner": {
              "x": 19.292,
              "y": 16.776,
              "z": 1.068
            },
            "rightCorner": {
              "x": 19.173,
              "y": 16.783,
              "z": 1.068
            },
            "gtin": "4006578198510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9a0",
            "leftCorner": {
              "x": 19.173,
              "y": 16.783,
              "z": 1.068
            },
            "rightCorner": {
              "x": 19.054,
              "y": 16.79,
              "z": 1.068
            },
            "gtin": "4006578198510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9a2",
            "leftCorner": {
              "x": 19.052,
              "y": 16.752,
              "z": 1.068
            },
            "rightCorner": {
              "x": 18.926,
              "y": 16.759,
              "z": 1.068
            },
            "gtin": "4008418032565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9a3",
            "leftCorner": {
              "x": 18.926,
              "y": 16.759,
              "z": 1.068
            },
            "rightCorner": {
              "x": 18.8,
              "y": 16.767,
              "z": 1.068
            },
            "gtin": "4008418032565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d9a4",
            "leftCorner": {
              "x": 18.8,
              "y": 16.767,
              "z": 1.068
            },
            "rightCorner": {
              "x": 18.674,
              "y": 16.774,
              "z": 1.068
            },
            "gtin": "4008418032565",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "34a6f"
  },
  {
    "id": "8d2f4",
    "name": "8d2f4",
    "x": 7.563,
    "y": 19.6,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.038562,
      "w": 0.99926
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 5
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546774",
        "height": 0.16716,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a546772",
        "height": 1.1044,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a21004",
            "leftCorner": {
              "x": 7.571,
              "y": 19.701,
              "z": 0.904
            },
            "rightCorner": {
              "x": 7.69,
              "y": 19.692,
              "z": 0.904
            },
            "gtin": "4003586105738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21005",
            "leftCorner": {
              "x": 7.69,
              "y": 19.692,
              "z": 0.904
            },
            "rightCorner": {
              "x": 7.81,
              "y": 19.683,
              "z": 0.904
            },
            "gtin": "4003586105738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21006",
            "leftCorner": {
              "x": 7.81,
              "y": 19.683,
              "z": 0.904
            },
            "rightCorner": {
              "x": 7.929,
              "y": 19.673,
              "z": 0.904
            },
            "gtin": "4003586105738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21008",
            "leftCorner": {
              "x": 7.932,
              "y": 19.719,
              "z": 0.904
            },
            "rightCorner": {
              "x": 8.102,
              "y": 19.706,
              "z": 0.904
            },
            "gtin": "4003586105721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21009",
            "leftCorner": {
              "x": 8.102,
              "y": 19.706,
              "z": 0.904
            },
            "rightCorner": {
              "x": 8.272,
              "y": 19.693,
              "z": 0.904
            },
            "gtin": "4003586105721",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546773",
        "height": 1.6559,
        "facings": []
      }
    ],
    "rightNeighborShelfId": "34a80"
  },
  {
    "id": "8d30f",
    "name": "8d30f",
    "x": 20.062,
    "y": 20.199,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99946,
      "w": 0.032824
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 25
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5467a8",
        "height": 1.3908,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e78d",
            "leftCorner": {
              "x": 20.062,
              "y": 20.194,
              "z": 1.138
            },
            "rightCorner": {
              "x": 19.822,
              "y": 20.211,
              "z": 1.138
            },
            "gtin": "5949040203024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e78e",
            "leftCorner": {
              "x": 19.822,
              "y": 20.211,
              "z": 1.138
            },
            "rightCorner": {
              "x": 19.583,
              "y": 20.226,
              "z": 1.138
            },
            "gtin": "5949040203024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e791",
            "leftCorner": {
              "x": 19.581,
              "y": 20.202,
              "z": 1.138
            },
            "rightCorner": {
              "x": 19.262,
              "y": 20.222,
              "z": 1.138
            },
            "gtin": "5949040201105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e792",
            "leftCorner": {
              "x": 19.26,
              "y": 20.195,
              "z": 1.138
            },
            "rightCorner": {
              "x": 19.035,
              "y": 20.21,
              "z": 1.138
            },
            "gtin": "5949040203482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e793",
            "leftCorner": {
              "x": 19.035,
              "y": 20.21,
              "z": 1.138
            },
            "rightCorner": {
              "x": 18.809,
              "y": 20.225,
              "z": 1.138
            },
            "gtin": "5949040203482",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467aa",
        "height": 1.7378,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1de45",
            "leftCorner": {
              "x": 19.575,
              "y": 20.175,
              "z": 1.422
            },
            "rightCorner": {
              "x": 19.411,
              "y": 20.186,
              "z": 1.422
            },
            "gtin": "5949040203567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de41",
            "leftCorner": {
              "x": 20.061,
              "y": 20.187,
              "z": 1.422
            },
            "rightCorner": {
              "x": 19.774,
              "y": 20.206,
              "z": 1.422
            },
            "gtin": "4000522060038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de43",
            "leftCorner": {
              "x": 19.773,
              "y": 20.185,
              "z": 1.422
            },
            "rightCorner": {
              "x": 19.675,
              "y": 20.192,
              "z": 1.422
            },
            "gtin": "4000522060069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de44",
            "leftCorner": {
              "x": 19.675,
              "y": 20.192,
              "z": 1.422
            },
            "rightCorner": {
              "x": 19.576,
              "y": 20.198,
              "z": 1.422
            },
            "gtin": "4000522060069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de46",
            "leftCorner": {
              "x": 19.411,
              "y": 20.193,
              "z": 1.422
            },
            "rightCorner": {
              "x": 19.339,
              "y": 20.199,
              "z": 1.422
            },
            "gtin": "5949040204601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de47",
            "leftCorner": {
              "x": 19.339,
              "y": 20.199,
              "z": 1.422
            },
            "rightCorner": {
              "x": 19.267,
              "y": 20.203,
              "z": 1.422
            },
            "gtin": "5949040204601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de48",
            "leftCorner": {
              "x": 19.266,
              "y": 20.195,
              "z": 1.422
            },
            "rightCorner": {
              "x": 19.194,
              "y": 20.2,
              "z": 1.422
            },
            "gtin": "5949040203529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de49",
            "leftCorner": {
              "x": 19.194,
              "y": 20.2,
              "z": 1.422
            },
            "rightCorner": {
              "x": 19.124,
              "y": 20.205,
              "z": 1.422
            },
            "gtin": "5949040203529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de4a",
            "leftCorner": {
              "x": 19.124,
              "y": 20.205,
              "z": 1.422
            },
            "rightCorner": {
              "x": 19.053,
              "y": 20.209,
              "z": 1.422
            },
            "gtin": "5949040203529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de4b",
            "leftCorner": {
              "x": 19.053,
              "y": 20.209,
              "z": 1.422
            },
            "rightCorner": {
              "x": 18.992,
              "y": 20.213,
              "z": 1.422
            },
            "gtin": "8008698041055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de4c",
            "leftCorner": {
              "x": 18.992,
              "y": 20.213,
              "z": 1.422
            },
            "rightCorner": {
              "x": 18.931,
              "y": 20.216,
              "z": 1.422
            },
            "gtin": "8008698041055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de4d",
            "leftCorner": {
              "x": 18.931,
              "y": 20.22,
              "z": 1.422
            },
            "rightCorner": {
              "x": 18.884,
              "y": 20.224,
              "z": 1.422
            },
            "gtin": "8008698033395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1de4e",
            "leftCorner": {
              "x": 18.884,
              "y": 20.224,
              "z": 1.422
            },
            "rightCorner": {
              "x": 18.837,
              "y": 20.227,
              "z": 1.422
            },
            "gtin": "8008698033395",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467ac",
        "height": 0.13407,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a5467ab",
        "height": 0.59349,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a5467a9",
        "height": 0.93671,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1ddbb",
            "leftCorner": {
              "x": 20.061,
              "y": 20.183,
              "z": 0.766
            },
            "rightCorner": {
              "x": 19.863,
              "y": 20.196,
              "z": 0.766
            },
            "gtin": "5949040202072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddbc",
            "leftCorner": {
              "x": 19.863,
              "y": 20.196,
              "z": 0.766
            },
            "rightCorner": {
              "x": 19.666,
              "y": 20.209,
              "z": 0.766
            },
            "gtin": "5949040202072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddbf",
            "leftCorner": {
              "x": 19.663,
              "y": 20.169,
              "z": 0.766
            },
            "rightCorner": {
              "x": 19.482,
              "y": 20.181,
              "z": 0.766
            },
            "gtin": "5949040203673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddc0",
            "leftCorner": {
              "x": 19.482,
              "y": 20.187,
              "z": 0.766
            },
            "rightCorner": {
              "x": 19.353,
              "y": 20.196,
              "z": 0.766
            },
            "gtin": "5949040203505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddc1",
            "leftCorner": {
              "x": 19.353,
              "y": 20.196,
              "z": 0.766
            },
            "rightCorner": {
              "x": 19.223,
              "y": 20.205,
              "z": 0.766
            },
            "gtin": "5949040203505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddc2",
            "leftCorner": {
              "x": 19.222,
              "y": 20.19,
              "z": 0.766
            },
            "rightCorner": {
              "x": 19.029,
              "y": 20.202,
              "z": 0.766
            },
            "gtin": "5949040201082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ddc3",
            "leftCorner": {
              "x": 19.029,
              "y": 20.202,
              "z": 0.766
            },
            "rightCorner": {
              "x": 18.837,
              "y": 20.215,
              "z": 0.766
            },
            "gtin": "5949040201082",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "50a07"
  },
  {
    "id": "92ffd",
    "name": "92ffd",
    "x": 9.687,
    "y": 32.701,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.02595,
      "w": 0.99966
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 38
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546596",
        "height": 0.15207,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fd49",
            "leftCorner": {
              "x": 9.688,
              "y": 32.715,
              "z": 0.124
            },
            "rightCorner": {
              "x": 9.836,
              "y": 32.707,
              "z": 0.124
            },
            "gtin": "4001686151020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd4b",
            "leftCorner": {
              "x": 9.838,
              "y": 32.74,
              "z": 0.124
            },
            "rightCorner": {
              "x": 10.142,
              "y": 32.725,
              "z": 0.124
            },
            "gtin": "4001686014004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd4c",
            "leftCorner": {
              "x": 10.143,
              "y": 32.734,
              "z": 0.124
            },
            "rightCorner": {
              "x": 10.286,
              "y": 32.726,
              "z": 0.124
            },
            "gtin": "4001686011249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd4d",
            "leftCorner": {
              "x": 10.286,
              "y": 32.726,
              "z": 0.124
            },
            "rightCorner": {
              "x": 10.43,
              "y": 32.718,
              "z": 0.124
            },
            "gtin": "4001686011249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd4e",
            "leftCorner": {
              "x": 10.43,
              "y": 32.714,
              "z": 0.124
            },
            "rightCorner": {
              "x": 10.681,
              "y": 32.701,
              "z": 0.124
            },
            "gtin": "4001686011263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd4f",
            "leftCorner": {
              "x": 10.682,
              "y": 32.717,
              "z": 0.124
            },
            "rightCorner": {
              "x": 11.029,
              "y": 32.699,
              "z": 0.124
            },
            "gtin": "4001686011256",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546593",
        "height": 0.6544,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fd0b",
            "leftCorner": {
              "x": 9.687,
              "y": 32.709,
              "z": 0.535
            },
            "rightCorner": {
              "x": 9.835,
              "y": 32.701,
              "z": 0.535
            },
            "gtin": "4001686322871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd0c",
            "leftCorner": {
              "x": 9.835,
              "y": 32.701,
              "z": 0.535
            },
            "rightCorner": {
              "x": 9.982,
              "y": 32.694,
              "z": 0.535
            },
            "gtin": "4001686322871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd0e",
            "leftCorner": {
              "x": 9.984,
              "y": 32.729,
              "z": 0.535
            },
            "rightCorner": {
              "x": 10.082,
              "y": 32.724,
              "z": 0.535
            },
            "gtin": "4001686322628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd0f",
            "leftCorner": {
              "x": 10.082,
              "y": 32.724,
              "z": 0.535
            },
            "rightCorner": {
              "x": 10.181,
              "y": 32.718,
              "z": 0.535
            },
            "gtin": "4001686322628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd10",
            "leftCorner": {
              "x": 10.181,
              "y": 32.718,
              "z": 0.535
            },
            "rightCorner": {
              "x": 10.279,
              "y": 32.713,
              "z": 0.535
            },
            "gtin": "4001686322628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd11",
            "leftCorner": {
              "x": 10.279,
              "y": 32.713,
              "z": 0.535
            },
            "rightCorner": {
              "x": 10.377,
              "y": 32.708,
              "z": 0.535
            },
            "gtin": "4001686322628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd12",
            "leftCorner": {
              "x": 10.377,
              "y": 32.703,
              "z": 0.535
            },
            "rightCorner": {
              "x": 10.524,
              "y": 32.696,
              "z": 0.535
            },
            "gtin": "9002975002516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd13",
            "leftCorner": {
              "x": 10.524,
              "y": 32.696,
              "z": 0.535
            },
            "rightCorner": {
              "x": 10.671,
              "y": 32.688,
              "z": 0.535
            },
            "gtin": "9002975002516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd14",
            "leftCorner": {
              "x": 10.672,
              "y": 32.699,
              "z": 0.535
            },
            "rightCorner": {
              "x": 10.823,
              "y": 32.691,
              "z": 0.535
            },
            "gtin": "4001686331781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd15",
            "leftCorner": {
              "x": 10.822,
              "y": 32.68,
              "z": 0.535
            },
            "rightCorner": {
              "x": 11.09,
              "y": 32.666,
              "z": 0.535
            },
            "gtin": "9002975378925",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546594",
        "height": 1.0547,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fd20",
            "leftCorner": {
              "x": 9.687,
              "y": 32.702,
              "z": 0.863
            },
            "rightCorner": {
              "x": 9.886,
              "y": 32.691,
              "z": 0.863
            },
            "gtin": "4001686327845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd21",
            "leftCorner": {
              "x": 9.886,
              "y": 32.691,
              "z": 0.863
            },
            "rightCorner": {
              "x": 10.086,
              "y": 32.681,
              "z": 0.863
            },
            "gtin": "4001686327845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd26",
            "leftCorner": {
              "x": 10.088,
              "y": 32.718,
              "z": 0.863
            },
            "rightCorner": {
              "x": 10.4,
              "y": 32.702,
              "z": 0.863
            },
            "gtin": "4001686329870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd27",
            "leftCorner": {
              "x": 10.4,
              "y": 32.696,
              "z": 0.863
            },
            "rightCorner": {
              "x": 10.66,
              "y": 32.683,
              "z": 0.863
            },
            "gtin": "9002975002516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd28",
            "leftCorner": {
              "x": 10.661,
              "y": 32.693,
              "z": 0.863
            },
            "rightCorner": {
              "x": 10.847,
              "y": 32.684,
              "z": 0.863
            },
            "gtin": "4001686013908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd29",
            "leftCorner": {
              "x": 10.847,
              "y": 32.684,
              "z": 0.863
            },
            "rightCorner": {
              "x": 11.034,
              "y": 32.674,
              "z": 0.863
            },
            "gtin": "4001686013908",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546595",
        "height": 1.408,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fd35",
            "leftCorner": {
              "x": 9.687,
              "y": 32.697,
              "z": 1.152
            },
            "rightCorner": {
              "x": 9.872,
              "y": 32.688,
              "z": 1.152
            },
            "gtin": "4001686329351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd36",
            "leftCorner": {
              "x": 9.872,
              "y": 32.688,
              "z": 1.152
            },
            "rightCorner": {
              "x": 10.056,
              "y": 32.678,
              "z": 1.152
            },
            "gtin": "4001686329351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd37",
            "leftCorner": {
              "x": 10.056,
              "y": 32.678,
              "z": 1.152
            },
            "rightCorner": {
              "x": 10.241,
              "y": 32.669,
              "z": 1.152
            },
            "gtin": "4001686329351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd38",
            "leftCorner": {
              "x": 10.241,
              "y": 32.669,
              "z": 1.152
            },
            "rightCorner": {
              "x": 10.426,
              "y": 32.659,
              "z": 1.152
            },
            "gtin": "4001686329351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd3b",
            "leftCorner": {
              "x": 10.428,
              "y": 32.696,
              "z": 1.152
            },
            "rightCorner": {
              "x": 10.646,
              "y": 32.685,
              "z": 1.152
            },
            "gtin": "4001686327692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd3c",
            "leftCorner": {
              "x": 10.646,
              "y": 32.685,
              "z": 1.152
            },
            "rightCorner": {
              "x": 10.825,
              "y": 32.676,
              "z": 1.152
            },
            "gtin": "4001686013854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd3d",
            "leftCorner": {
              "x": 10.825,
              "y": 32.676,
              "z": 1.152
            },
            "rightCorner": {
              "x": 11.005,
              "y": 32.667,
              "z": 1.152
            },
            "gtin": "4001686013854",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546592",
        "height": 1.7551,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc82",
            "leftCorner": {
              "x": 9.687,
              "y": 32.705,
              "z": 1.436
            },
            "rightCorner": {
              "x": 9.93,
              "y": 32.693,
              "z": 1.436
            },
            "gtin": "4001686003398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc86",
            "leftCorner": {
              "x": 9.932,
              "y": 32.735,
              "z": 1.436
            },
            "rightCorner": {
              "x": 10.128,
              "y": 32.725,
              "z": 1.436
            },
            "gtin": "4001686002490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc87",
            "leftCorner": {
              "x": 10.128,
              "y": 32.725,
              "z": 1.436
            },
            "rightCorner": {
              "x": 10.324,
              "y": 32.714,
              "z": 1.436
            },
            "gtin": "4001686002490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc88",
            "leftCorner": {
              "x": 10.324,
              "y": 32.714,
              "z": 1.436
            },
            "rightCorner": {
              "x": 10.519,
              "y": 32.704,
              "z": 1.436
            },
            "gtin": "4001686002490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc89",
            "leftCorner": {
              "x": 10.519,
              "y": 32.702,
              "z": 1.436
            },
            "rightCorner": {
              "x": 10.705,
              "y": 32.691,
              "z": 1.436
            },
            "gtin": "4001686002513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc8a",
            "leftCorner": {
              "x": 10.705,
              "y": 32.687,
              "z": 1.436
            },
            "rightCorner": {
              "x": 10.768,
              "y": 32.684,
              "z": 1.436
            },
            "gtin": "4001686120279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc8b",
            "leftCorner": {
              "x": 10.768,
              "y": 32.684,
              "z": 1.436
            },
            "rightCorner": {
              "x": 10.831,
              "y": 32.681,
              "z": 1.436
            },
            "gtin": "4001686120279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc8c",
            "leftCorner": {
              "x": 10.831,
              "y": 32.681,
              "z": 1.436
            },
            "rightCorner": {
              "x": 10.895,
              "y": 32.678,
              "z": 1.436
            },
            "gtin": "4001686120279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc8d",
            "leftCorner": {
              "x": 10.895,
              "y": 32.678,
              "z": 1.436
            },
            "rightCorner": {
              "x": 10.958,
              "y": 32.675,
              "z": 1.436
            },
            "gtin": "4001686120279",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "edeb5",
    "rightNeighborShelfId": "92ffe"
  },
  {
    "id": "92ffe",
    "name": "92ffe",
    "x": 10.935,
    "y": 32.636,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.02595,
      "w": 0.99966
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 33
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5468da",
        "height": 0.15592,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fd50",
            "leftCorner": {
              "x": 11.029,
              "y": 32.693,
              "z": 0.128
            },
            "rightCorner": {
              "x": 11.113,
              "y": 32.689,
              "z": 0.128
            },
            "gtin": "4001686331668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd51",
            "leftCorner": {
              "x": 11.113,
              "y": 32.689,
              "z": 0.128
            },
            "rightCorner": {
              "x": 11.197,
              "y": 32.685,
              "z": 0.128
            },
            "gtin": "4001686331668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd52",
            "leftCorner": {
              "x": 11.197,
              "y": 32.685,
              "z": 0.128
            },
            "rightCorner": {
              "x": 11.282,
              "y": 32.68,
              "z": 0.128
            },
            "gtin": "4001686331668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd53",
            "leftCorner": {
              "x": 11.281,
              "y": 32.677,
              "z": 0.128
            },
            "rightCorner": {
              "x": 11.394,
              "y": 32.671,
              "z": 0.128
            },
            "gtin": "4001686372852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd54",
            "leftCorner": {
              "x": 11.394,
              "y": 32.671,
              "z": 0.128
            },
            "rightCorner": {
              "x": 11.506,
              "y": 32.666,
              "z": 0.128
            },
            "gtin": "4001686372852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd55",
            "leftCorner": {
              "x": 11.506,
              "y": 32.666,
              "z": 0.128
            },
            "rightCorner": {
              "x": 11.617,
              "y": 32.66,
              "z": 0.128
            },
            "gtin": "4001686372852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd56",
            "leftCorner": {
              "x": 11.617,
              "y": 32.649,
              "z": 0.128
            },
            "rightCorner": {
              "x": 11.862,
              "y": 32.637,
              "z": 0.128
            },
            "gtin": "4001686347591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd57",
            "leftCorner": {
              "x": 11.863,
              "y": 32.641,
              "z": 0.128
            },
            "rightCorner": {
              "x": 12.044,
              "y": 32.632,
              "z": 0.128
            },
            "gtin": "8426617119515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd58",
            "leftCorner": {
              "x": 12.044,
              "y": 32.632,
              "z": 0.128
            },
            "rightCorner": {
              "x": 12.225,
              "y": 32.622,
              "z": 0.128
            },
            "gtin": "8426617119515",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468d9",
        "height": 0.65446,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fd16",
            "leftCorner": {
              "x": 11.09,
              "y": 32.678,
              "z": 0.535
            },
            "rightCorner": {
              "x": 11.444,
              "y": 32.66,
              "z": 0.535
            },
            "gtin": "4001686322932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd17",
            "leftCorner": {
              "x": 11.444,
              "y": 32.65,
              "z": 0.535
            },
            "rightCorner": {
              "x": 11.757,
              "y": 32.634,
              "z": 0.535
            },
            "gtin": "4001686120163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd18",
            "leftCorner": {
              "x": 11.758,
              "y": 32.637,
              "z": 0.535
            },
            "rightCorner": {
              "x": 11.904,
              "y": 32.629,
              "z": 0.535
            },
            "gtin": "4001686376829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd19",
            "leftCorner": {
              "x": 11.904,
              "y": 32.629,
              "z": 0.535
            },
            "rightCorner": {
              "x": 12.049,
              "y": 32.621,
              "z": 0.535
            },
            "gtin": "4001686376829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd1a",
            "leftCorner": {
              "x": 12.049,
              "y": 32.611,
              "z": 0.535
            },
            "rightCorner": {
              "x": 12.337,
              "y": 32.597,
              "z": 0.535
            },
            "gtin": "4001686331842",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468d8",
        "height": 1.0577,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fd2a",
            "leftCorner": {
              "x": 11.034,
              "y": 32.684,
              "z": 0.865
            },
            "rightCorner": {
              "x": 11.156,
              "y": 32.677,
              "z": 0.865
            },
            "gtin": "4001686120132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd2b",
            "leftCorner": {
              "x": 11.156,
              "y": 32.677,
              "z": 0.865
            },
            "rightCorner": {
              "x": 11.278,
              "y": 32.672,
              "z": 0.865
            },
            "gtin": "4001686120132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd2c",
            "leftCorner": {
              "x": 11.278,
              "y": 32.672,
              "z": 0.865
            },
            "rightCorner": {
              "x": 11.401,
              "y": 32.665,
              "z": 0.865
            },
            "gtin": "4001686120132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd2d",
            "leftCorner": {
              "x": 11.4,
              "y": 32.646,
              "z": 0.865
            },
            "rightCorner": {
              "x": 11.741,
              "y": 32.629,
              "z": 0.865
            },
            "gtin": "4001686013922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd2e",
            "leftCorner": {
              "x": 11.741,
              "y": 32.625,
              "z": 0.865
            },
            "rightCorner": {
              "x": 12.087,
              "y": 32.607,
              "z": 0.865
            },
            "gtin": "4001686009635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd2f",
            "leftCorner": {
              "x": 12.087,
              "y": 32.615,
              "z": 0.865
            },
            "rightCorner": {
              "x": 12.242,
              "y": 32.606,
              "z": 0.865
            },
            "gtin": "4001686009420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd30",
            "leftCorner": {
              "x": 12.242,
              "y": 32.606,
              "z": 0.865
            },
            "rightCorner": {
              "x": 12.398,
              "y": 32.598,
              "z": 0.865
            },
            "gtin": "4001686009420",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468d7",
        "height": 1.4174,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fd3e",
            "leftCorner": {
              "x": 11.005,
              "y": 32.68,
              "z": 1.16
            },
            "rightCorner": {
              "x": 11.127,
              "y": 32.675,
              "z": 1.16
            },
            "gtin": "4001686329849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd3f",
            "leftCorner": {
              "x": 11.127,
              "y": 32.675,
              "z": 1.16
            },
            "rightCorner": {
              "x": 11.25,
              "y": 32.668,
              "z": 1.16
            },
            "gtin": "4001686329849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd40",
            "leftCorner": {
              "x": 11.249,
              "y": 32.654,
              "z": 1.16
            },
            "rightCorner": {
              "x": 11.437,
              "y": 32.645,
              "z": 1.16
            },
            "gtin": "4001686327579",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd41",
            "leftCorner": {
              "x": 11.437,
              "y": 32.645,
              "z": 1.16
            },
            "rightCorner": {
              "x": 11.625,
              "y": 32.635,
              "z": 1.16
            },
            "gtin": "4001686327579",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd42",
            "leftCorner": {
              "x": 11.625,
              "y": 32.636,
              "z": 1.16
            },
            "rightCorner": {
              "x": 11.926,
              "y": 32.62,
              "z": 1.16
            },
            "gtin": "4001686327548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd43",
            "leftCorner": {
              "x": 11.926,
              "y": 32.621,
              "z": 1.16
            },
            "rightCorner": {
              "x": 12.093,
              "y": 32.613,
              "z": 1.16
            },
            "gtin": "4001686102701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd44",
            "leftCorner": {
              "x": 12.093,
              "y": 32.613,
              "z": 1.16
            },
            "rightCorner": {
              "x": 12.259,
              "y": 32.604,
              "z": 1.16
            },
            "gtin": "4001686102701",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468d6",
        "height": 1.7595,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc8e",
            "leftCorner": {
              "x": 10.958,
              "y": 32.675,
              "z": 1.44
            },
            "rightCorner": {
              "x": 11.309,
              "y": 32.656,
              "z": 1.44
            },
            "gtin": "4001686327784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc8f",
            "leftCorner": {
              "x": 11.309,
              "y": 32.659,
              "z": 1.44
            },
            "rightCorner": {
              "x": 11.631,
              "y": 32.643,
              "z": 1.44
            },
            "gtin": "4001686103180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc90",
            "leftCorner": {
              "x": 11.63,
              "y": 32.624,
              "z": 1.44
            },
            "rightCorner": {
              "x": 11.77,
              "y": 32.617,
              "z": 1.44
            },
            "gtin": "4001686376850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc91",
            "leftCorner": {
              "x": 11.77,
              "y": 32.617,
              "z": 1.44
            },
            "rightCorner": {
              "x": 11.91,
              "y": 32.609,
              "z": 1.44
            },
            "gtin": "4001686376850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc92",
            "leftCorner": {
              "x": 11.91,
              "y": 32.609,
              "z": 1.44
            },
            "rightCorner": {
              "x": 12.184,
              "y": 32.595,
              "z": 1.44
            },
            "gtin": "4001686331729",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "92ffd",
    "rightNeighborShelfId": "92fff"
  },
  {
    "id": "92fff",
    "name": "92fff",
    "x": 12.184,
    "y": 32.571,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.02595,
      "w": 0.99966
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 35
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5468dc",
        "height": 0.15445,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fd59",
            "leftCorner": {
              "x": 12.235,
              "y": 32.621,
              "z": 0.126
            },
            "rightCorner": {
              "x": 12.543,
              "y": 32.605,
              "z": 0.126
            },
            "gtin": "8426617119522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd5a",
            "leftCorner": {
              "x": 12.542,
              "y": 32.595,
              "z": 0.126
            },
            "rightCorner": {
              "x": 12.799,
              "y": 32.582,
              "z": 0.126
            },
            "gtin": "8426617119508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd5b",
            "leftCorner": {
              "x": 12.801,
              "y": 32.613,
              "z": 0.126
            },
            "rightCorner": {
              "x": 12.988,
              "y": 32.603,
              "z": 0.126
            },
            "gtin": "4001686102862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd5c",
            "leftCorner": {
              "x": 12.988,
              "y": 32.589,
              "z": 0.126
            },
            "rightCorner": {
              "x": 13.135,
              "y": 32.581,
              "z": 0.126
            },
            "gtin": "8426617119492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd5d",
            "leftCorner": {
              "x": 13.135,
              "y": 32.581,
              "z": 0.126
            },
            "rightCorner": {
              "x": 13.268,
              "y": 32.574,
              "z": 0.126
            },
            "gtin": "8426617119461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd5e",
            "leftCorner": {
              "x": 13.268,
              "y": 32.571,
              "z": 0.126
            },
            "rightCorner": {
              "x": 13.338,
              "y": 32.568,
              "z": 0.126
            },
            "gtin": "8426617119478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd5f",
            "leftCorner": {
              "x": 13.338,
              "y": 32.568,
              "z": 0.126
            },
            "rightCorner": {
              "x": 13.407,
              "y": 32.564,
              "z": 0.126
            },
            "gtin": "8426617119478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd60",
            "leftCorner": {
              "x": 13.407,
              "y": 32.564,
              "z": 0.126
            },
            "rightCorner": {
              "x": 13.477,
              "y": 32.56,
              "z": 0.126
            },
            "gtin": "8426617119478",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468dd",
        "height": 0.6565,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fd1b",
            "leftCorner": {
              "x": 12.368,
              "y": 32.607,
              "z": 0.537
            },
            "rightCorner": {
              "x": 12.581,
              "y": 32.596,
              "z": 0.537
            },
            "gtin": "4001686327425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd1c",
            "leftCorner": {
              "x": 12.581,
              "y": 32.596,
              "z": 0.537
            },
            "rightCorner": {
              "x": 12.793,
              "y": 32.585,
              "z": 0.537
            },
            "gtin": "4001686327425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd1d",
            "leftCorner": {
              "x": 12.794,
              "y": 32.594,
              "z": 0.537
            },
            "rightCorner": {
              "x": 12.867,
              "y": 32.59,
              "z": 0.537
            },
            "gtin": "4001686002421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd1e",
            "leftCorner": {
              "x": 12.867,
              "y": 32.59,
              "z": 0.537
            },
            "rightCorner": {
              "x": 12.939,
              "y": 32.587,
              "z": 0.537
            },
            "gtin": "4001686002421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd1f",
            "leftCorner": {
              "x": 12.939,
              "y": 32.577,
              "z": 0.537
            },
            "rightCorner": {
              "x": 13.118,
              "y": 32.568,
              "z": 0.537
            },
            "gtin": "9002975002523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd0d",
            "leftCorner": {
              "x": 13.118,
              "y": 32.57,
              "z": 0.537
            },
            "rightCorner": {
              "x": 13.435,
              "y": 32.554,
              "z": 0.537
            },
            "gtin": "4001686002407",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468de",
        "height": 1.0654,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fd31",
            "leftCorner": {
              "x": 12.442,
              "y": 32.602,
              "z": 0.872
            },
            "rightCorner": {
              "x": 12.602,
              "y": 32.594,
              "z": 0.872
            },
            "gtin": "4001686327722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd32",
            "leftCorner": {
              "x": 12.602,
              "y": 32.594,
              "z": 0.872
            },
            "rightCorner": {
              "x": 12.763,
              "y": 32.585,
              "z": 0.872
            },
            "gtin": "4001686327722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd33",
            "leftCorner": {
              "x": 12.763,
              "y": 32.593,
              "z": 0.872
            },
            "rightCorner": {
              "x": 12.953,
              "y": 32.583,
              "z": 0.872
            },
            "gtin": "4001686009703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd34",
            "leftCorner": {
              "x": 12.953,
              "y": 32.583,
              "z": 0.872
            },
            "rightCorner": {
              "x": 13.143,
              "y": 32.574,
              "z": 0.872
            },
            "gtin": "4001686009703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd22",
            "leftCorner": {
              "x": 13.142,
              "y": 32.564,
              "z": 0.872
            },
            "rightCorner": {
              "x": 13.215,
              "y": 32.56,
              "z": 0.872
            },
            "gtin": "4001686103272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd23",
            "leftCorner": {
              "x": 13.215,
              "y": 32.56,
              "z": 0.872
            },
            "rightCorner": {
              "x": 13.289,
              "y": 32.556,
              "z": 0.872
            },
            "gtin": "4001686103272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd24",
            "leftCorner": {
              "x": 13.289,
              "y": 32.556,
              "z": 0.872
            },
            "rightCorner": {
              "x": 13.361,
              "y": 32.552,
              "z": 0.872
            },
            "gtin": "4001686103272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd25",
            "leftCorner": {
              "x": 13.361,
              "y": 32.552,
              "z": 0.872
            },
            "rightCorner": {
              "x": 13.435,
              "y": 32.549,
              "z": 0.872
            },
            "gtin": "4001686103272",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468db",
        "height": 1.4118,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fd45",
            "leftCorner": {
              "x": 12.274,
              "y": 32.603,
              "z": 1.155
            },
            "rightCorner": {
              "x": 12.693,
              "y": 32.581,
              "z": 1.155
            },
            "gtin": "4001686327630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd46",
            "leftCorner": {
              "x": 12.693,
              "y": 32.59,
              "z": 1.155
            },
            "rightCorner": {
              "x": 12.828,
              "y": 32.582,
              "z": 1.155
            },
            "gtin": "4001686322567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd47",
            "leftCorner": {
              "x": 12.828,
              "y": 32.582,
              "z": 1.155
            },
            "rightCorner": {
              "x": 12.961,
              "y": 32.576,
              "z": 1.155
            },
            "gtin": "4001686322567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd48",
            "leftCorner": {
              "x": 12.961,
              "y": 32.576,
              "z": 1.155
            },
            "rightCorner": {
              "x": 13.096,
              "y": 32.569,
              "z": 1.155
            },
            "gtin": "4001686322567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd39",
            "leftCorner": {
              "x": 13.095,
              "y": 32.557,
              "z": 1.155
            },
            "rightCorner": {
              "x": 13.265,
              "y": 32.548,
              "z": 1.155
            },
            "gtin": "4001686327814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd3a",
            "leftCorner": {
              "x": 13.265,
              "y": 32.548,
              "z": 1.155
            },
            "rightCorner": {
              "x": 13.435,
              "y": 32.539,
              "z": 1.155
            },
            "gtin": "4001686327814",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468df",
        "height": 1.7594,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc93",
            "leftCorner": {
              "x": 12.186,
              "y": 32.602,
              "z": 1.439
            },
            "rightCorner": {
              "x": 12.41,
              "y": 32.588,
              "z": 1.439
            },
            "gtin": "4001686103159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc94",
            "leftCorner": {
              "x": 12.41,
              "y": 32.588,
              "z": 1.439
            },
            "rightCorner": {
              "x": 12.635,
              "y": 32.575,
              "z": 1.439
            },
            "gtin": "4001686103159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc95",
            "leftCorner": {
              "x": 12.637,
              "y": 32.592,
              "z": 1.439
            },
            "rightCorner": {
              "x": 12.9,
              "y": 32.578,
              "z": 1.439
            },
            "gtin": "4001686103159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc96",
            "leftCorner": {
              "x": 12.9,
              "y": 32.578,
              "z": 1.439
            },
            "rightCorner": {
              "x": 13.031,
              "y": 32.572,
              "z": 1.439
            },
            "gtin": "4001686331811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc97",
            "leftCorner": {
              "x": 13.031,
              "y": 32.572,
              "z": 1.439
            },
            "rightCorner": {
              "x": 13.164,
              "y": 32.565,
              "z": 1.439
            },
            "gtin": "4001686331811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc98",
            "leftCorner": {
              "x": 13.164,
              "y": 32.567,
              "z": 1.439
            },
            "rightCorner": {
              "x": 13.357,
              "y": 32.557,
              "z": 1.439
            },
            "gtin": "4001686186114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc99",
            "leftCorner": {
              "x": 13.357,
              "y": 32.557,
              "z": 1.439
            },
            "rightCorner": {
              "x": 13.551,
              "y": 32.546,
              "z": 1.439
            },
            "gtin": "4001686186114",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "92ffe",
    "rightNeighborShelfId": "93000"
  },
  {
    "id": "93000",
    "name": "93000",
    "x": 13.432,
    "y": 32.506,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.02595,
      "w": 0.99966
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 44
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546854",
        "height": 0.15512,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fd61",
            "leftCorner": {
              "x": 13.471,
              "y": 32.573,
              "z": 0.127
            },
            "rightCorner": {
              "x": 13.592,
              "y": 32.566,
              "z": 0.127
            },
            "gtin": "4014400934168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd62",
            "leftCorner": {
              "x": 13.592,
              "y": 32.566,
              "z": 0.127
            },
            "rightCorner": {
              "x": 13.713,
              "y": 32.561,
              "z": 0.127
            },
            "gtin": "4014400934168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd63",
            "leftCorner": {
              "x": 13.713,
              "y": 32.561,
              "z": 0.127
            },
            "rightCorner": {
              "x": 13.834,
              "y": 32.554,
              "z": 0.127
            },
            "gtin": "4014400934168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd64",
            "leftCorner": {
              "x": 13.834,
              "y": 32.554,
              "z": 0.127
            },
            "rightCorner": {
              "x": 13.956,
              "y": 32.548,
              "z": 0.127
            },
            "gtin": "4014400934168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd65",
            "leftCorner": {
              "x": 13.956,
              "y": 32.558,
              "z": 0.127
            },
            "rightCorner": {
              "x": 14.143,
              "y": 32.548,
              "z": 0.127
            },
            "gtin": "4014400931914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd66",
            "leftCorner": {
              "x": 14.143,
              "y": 32.529,
              "z": 0.127
            },
            "rightCorner": {
              "x": 14.707,
              "y": 32.5,
              "z": 0.127
            },
            "gtin": "4014400914863",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546851",
        "height": 0.51021,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a212ce",
            "leftCorner": {
              "x": 13.433,
              "y": 32.525,
              "z": 0.417
            },
            "rightCorner": {
              "x": 13.629,
              "y": 32.515,
              "z": 0.417
            },
            "gtin": "4014400934144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212d1",
            "leftCorner": {
              "x": 13.632,
              "y": 32.561,
              "z": 0.417
            },
            "rightCorner": {
              "x": 13.847,
              "y": 32.551,
              "z": 0.417
            },
            "gtin": "4014400922608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212d2",
            "leftCorner": {
              "x": 13.846,
              "y": 32.546,
              "z": 0.417
            },
            "rightCorner": {
              "x": 14.058,
              "y": 32.535,
              "z": 0.417
            },
            "gtin": "4014400932331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212d3",
            "leftCorner": {
              "x": 14.058,
              "y": 32.527,
              "z": 0.417
            },
            "rightCorner": {
              "x": 14.265,
              "y": 32.516,
              "z": 0.417
            },
            "gtin": "4014400931419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212d4",
            "leftCorner": {
              "x": 14.266,
              "y": 32.524,
              "z": 0.417
            },
            "rightCorner": {
              "x": 14.314,
              "y": 32.522,
              "z": 0.417
            },
            "gtin": "4014400921366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212d5",
            "leftCorner": {
              "x": 14.314,
              "y": 32.522,
              "z": 0.417
            },
            "rightCorner": {
              "x": 14.362,
              "y": 32.519,
              "z": 0.417
            },
            "gtin": "4014400921366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212d6",
            "leftCorner": {
              "x": 14.362,
              "y": 32.519,
              "z": 0.417
            },
            "rightCorner": {
              "x": 14.411,
              "y": 32.517,
              "z": 0.417
            },
            "gtin": "4014400921366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212cf",
            "leftCorner": {
              "x": 14.409,
              "y": 32.511,
              "z": 0.417
            },
            "rightCorner": {
              "x": 14.547,
              "y": 32.504,
              "z": 0.417
            },
            "gtin": "4014400914856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212d0",
            "leftCorner": {
              "x": 14.547,
              "y": 32.504,
              "z": 0.417
            },
            "rightCorner": {
              "x": 14.683,
              "y": 32.496,
              "z": 0.417
            },
            "gtin": "4014400914856",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546852",
        "height": 0.85813,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a212d7",
            "leftCorner": {
              "x": 13.432,
              "y": 32.517,
              "z": 0.702
            },
            "rightCorner": {
              "x": 13.66,
              "y": 32.506,
              "z": 0.702
            },
            "gtin": "4014400916850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212d8",
            "leftCorner": {
              "x": 13.66,
              "y": 32.506,
              "z": 0.702
            },
            "rightCorner": {
              "x": 13.888,
              "y": 32.494,
              "z": 0.702
            },
            "gtin": "4014400916850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212da",
            "leftCorner": {
              "x": 13.89,
              "y": 32.532,
              "z": 0.702
            },
            "rightCorner": {
              "x": 14.211,
              "y": 32.515,
              "z": 0.702
            },
            "gtin": "4014400914870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212db",
            "leftCorner": {
              "x": 14.211,
              "y": 32.515,
              "z": 0.702
            },
            "rightCorner": {
              "x": 14.534,
              "y": 32.499,
              "z": 0.702
            },
            "gtin": "4014400914870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212d9",
            "leftCorner": {
              "x": 14.534,
              "y": 32.501,
              "z": 0.702
            },
            "rightCorner": {
              "x": 14.683,
              "y": 32.493,
              "z": 0.702
            },
            "gtin": "4014400914887",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546853",
        "height": 1.2122,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a212dc",
            "leftCorner": {
              "x": 13.432,
              "y": 32.521,
              "z": 0.992
            },
            "rightCorner": {
              "x": 13.668,
              "y": 32.509,
              "z": 0.992
            },
            "gtin": "4014400920383",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212de",
            "leftCorner": {
              "x": 13.669,
              "y": 32.55,
              "z": 0.992
            },
            "rightCorner": {
              "x": 13.778,
              "y": 32.544,
              "z": 0.992
            },
            "gtin": "4014400920390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212df",
            "leftCorner": {
              "x": 13.778,
              "y": 32.544,
              "z": 0.992
            },
            "rightCorner": {
              "x": 13.885,
              "y": 32.539,
              "z": 0.992
            },
            "gtin": "4014400920390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212e0",
            "leftCorner": {
              "x": 13.885,
              "y": 32.547,
              "z": 0.992
            },
            "rightCorner": {
              "x": 14.066,
              "y": 32.538,
              "z": 0.992
            },
            "gtin": "4014400924510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212e1",
            "leftCorner": {
              "x": 14.066,
              "y": 32.528,
              "z": 0.992
            },
            "rightCorner": {
              "x": 14.145,
              "y": 32.524,
              "z": 0.992
            },
            "gtin": "4014400932331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212e2",
            "leftCorner": {
              "x": 14.145,
              "y": 32.524,
              "z": 0.992
            },
            "rightCorner": {
              "x": 14.224,
              "y": 32.519,
              "z": 0.992
            },
            "gtin": "4014400932331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212e3",
            "leftCorner": {
              "x": 14.224,
              "y": 32.516,
              "z": 0.992
            },
            "rightCorner": {
              "x": 14.342,
              "y": 32.509,
              "z": 0.992
            },
            "gtin": "4014400922493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212e4",
            "leftCorner": {
              "x": 14.342,
              "y": 32.509,
              "z": 0.992
            },
            "rightCorner": {
              "x": 14.458,
              "y": 32.504,
              "z": 0.992
            },
            "gtin": "4014400922493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212dd",
            "leftCorner": {
              "x": 14.459,
              "y": 32.504,
              "z": 0.992
            },
            "rightCorner": {
              "x": 14.683,
              "y": 32.492,
              "z": 0.992
            },
            "gtin": "4014400904253",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546856",
        "height": 1.5632,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a212e5",
            "leftCorner": {
              "x": 13.432,
              "y": 32.517,
              "z": 1.279
            },
            "rightCorner": {
              "x": 13.636,
              "y": 32.506,
              "z": 1.279
            },
            "gtin": "4014400931365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212e6",
            "leftCorner": {
              "x": 13.636,
              "y": 32.506,
              "z": 1.279
            },
            "rightCorner": {
              "x": 13.84,
              "y": 32.496,
              "z": 1.279
            },
            "gtin": "4014400931365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212e8",
            "leftCorner": {
              "x": 13.842,
              "y": 32.537,
              "z": 1.279
            },
            "rightCorner": {
              "x": 13.968,
              "y": 32.53,
              "z": 1.279
            },
            "gtin": "4014400920390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212e9",
            "leftCorner": {
              "x": 13.968,
              "y": 32.53,
              "z": 1.279
            },
            "rightCorner": {
              "x": 14.093,
              "y": 32.524,
              "z": 1.279
            },
            "gtin": "4014400920390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212ea",
            "leftCorner": {
              "x": 14.093,
              "y": 32.524,
              "z": 1.279
            },
            "rightCorner": {
              "x": 14.218,
              "y": 32.517,
              "z": 1.279
            },
            "gtin": "4014400920390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212eb",
            "leftCorner": {
              "x": 14.218,
              "y": 32.508,
              "z": 1.279
            },
            "rightCorner": {
              "x": 14.4,
              "y": 32.498,
              "z": 1.279
            },
            "gtin": "4014400931921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212ec",
            "leftCorner": {
              "x": 14.4,
              "y": 32.498,
              "z": 1.279
            },
            "rightCorner": {
              "x": 14.582,
              "y": 32.489,
              "z": 1.279
            },
            "gtin": "4014400931921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212e7",
            "leftCorner": {
              "x": 14.582,
              "y": 32.495,
              "z": 1.279
            },
            "rightCorner": {
              "x": 14.683,
              "y": 32.489,
              "z": 1.279
            },
            "gtin": "4014400930207",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546855",
        "height": 1.7616,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fc9a",
            "leftCorner": {
              "x": 13.532,
              "y": 32.545,
              "z": 1.441
            },
            "rightCorner": {
              "x": 13.87,
              "y": 32.527,
              "z": 1.441
            },
            "gtin": "4014400932324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc9b",
            "leftCorner": {
              "x": 13.87,
              "y": 32.527,
              "z": 1.441
            },
            "rightCorner": {
              "x": 14.209,
              "y": 32.509,
              "z": 1.441
            },
            "gtin": "4014400932324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc9c",
            "leftCorner": {
              "x": 14.208,
              "y": 32.491,
              "z": 1.441
            },
            "rightCorner": {
              "x": 14.366,
              "y": 32.484,
              "z": 1.441
            },
            "gtin": "5010511471683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc9d",
            "leftCorner": {
              "x": 14.366,
              "y": 32.484,
              "z": 1.441
            },
            "rightCorner": {
              "x": 14.523,
              "y": 32.475,
              "z": 1.441
            },
            "gtin": "5010511471683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc9e",
            "leftCorner": {
              "x": 14.525,
              "y": 32.504,
              "z": 1.441
            },
            "rightCorner": {
              "x": 14.58,
              "y": 32.502,
              "z": 1.441
            },
            "gtin": "8713800119958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc9f",
            "leftCorner": {
              "x": 14.58,
              "y": 32.502,
              "z": 1.441
            },
            "rightCorner": {
              "x": 14.635,
              "y": 32.499,
              "z": 1.441
            },
            "gtin": "8713800119958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fca0",
            "leftCorner": {
              "x": 14.635,
              "y": 32.499,
              "z": 1.441
            },
            "rightCorner": {
              "x": 14.69,
              "y": 32.495,
              "z": 1.441
            },
            "gtin": "8713800119958",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "92fff",
    "rightNeighborShelfId": "93001"
  },
  {
    "id": "93001",
    "name": "93001",
    "x": 14.68,
    "y": 32.441,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.02595,
      "w": 0.99966
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 45
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5468e2",
        "height": 0.16205,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fd67",
            "leftCorner": {
              "x": 14.707,
              "y": 32.503,
              "z": 0.133
            },
            "rightCorner": {
              "x": 14.791,
              "y": 32.498,
              "z": 0.133
            },
            "gtin": "4000512463672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd68",
            "leftCorner": {
              "x": 14.791,
              "y": 32.498,
              "z": 0.133
            },
            "rightCorner": {
              "x": 14.875,
              "y": 32.494,
              "z": 0.133
            },
            "gtin": "4000512463672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd69",
            "leftCorner": {
              "x": 14.874,
              "y": 32.478,
              "z": 0.133
            },
            "rightCorner": {
              "x": 15.085,
              "y": 32.467,
              "z": 0.133
            },
            "gtin": "4000512463740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd6a",
            "leftCorner": {
              "x": 15.087,
              "y": 32.478,
              "z": 0.133
            },
            "rightCorner": {
              "x": 15.272,
              "y": 32.468,
              "z": 0.133
            },
            "gtin": "4000512463467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd6b",
            "leftCorner": {
              "x": 15.272,
              "y": 32.459,
              "z": 0.133
            },
            "rightCorner": {
              "x": 15.46,
              "y": 32.45,
              "z": 0.133
            },
            "gtin": "4000512004905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd6c",
            "leftCorner": {
              "x": 15.46,
              "y": 32.456,
              "z": 0.133
            },
            "rightCorner": {
              "x": 15.789,
              "y": 32.439,
              "z": 0.133
            },
            "gtin": "4000512365006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd6d",
            "leftCorner": {
              "x": 15.789,
              "y": 32.442,
              "z": 0.133
            },
            "rightCorner": {
              "x": 15.891,
              "y": 32.438,
              "z": 0.133
            },
            "gtin": "4000512015345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd6e",
            "leftCorner": {
              "x": 15.891,
              "y": 32.438,
              "z": 0.133
            },
            "rightCorner": {
              "x": 15.992,
              "y": 32.432,
              "z": 0.133
            },
            "gtin": "4000512015345",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468e3",
        "height": 0.56192,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2149c",
            "leftCorner": {
              "x": 14.681,
              "y": 32.466,
              "z": 0.46
            },
            "rightCorner": {
              "x": 15.096,
              "y": 32.445,
              "z": 0.46
            },
            "gtin": "4000512463443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214a0",
            "leftCorner": {
              "x": 15.097,
              "y": 32.484,
              "z": 0.46
            },
            "rightCorner": {
              "x": 15.337,
              "y": 32.472,
              "z": 0.46
            },
            "gtin": "4000512463764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214a1",
            "leftCorner": {
              "x": 15.337,
              "y": 32.477,
              "z": 0.46
            },
            "rightCorner": {
              "x": 15.548,
              "y": 32.466,
              "z": 0.46
            },
            "gtin": "4000512463733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214a2",
            "leftCorner": {
              "x": 15.548,
              "y": 32.466,
              "z": 0.46
            },
            "rightCorner": {
              "x": 15.758,
              "y": 32.455,
              "z": 0.46
            },
            "gtin": "4000512463733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2149d",
            "leftCorner": {
              "x": 15.758,
              "y": 32.441,
              "z": 0.46
            },
            "rightCorner": {
              "x": 15.815,
              "y": 32.438,
              "z": 0.46
            },
            "gtin": "4000512463665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2149e",
            "leftCorner": {
              "x": 15.815,
              "y": 32.438,
              "z": 0.46
            },
            "rightCorner": {
              "x": 15.873,
              "y": 32.434,
              "z": 0.46
            },
            "gtin": "4000512463665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2149f",
            "leftCorner": {
              "x": 15.873,
              "y": 32.434,
              "z": 0.46
            },
            "rightCorner": {
              "x": 15.931,
              "y": 32.431,
              "z": 0.46
            },
            "gtin": "4000512463665",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468e4",
        "height": 0.96488,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a214a3",
            "leftCorner": {
              "x": 14.68,
              "y": 32.458,
              "z": 0.789
            },
            "rightCorner": {
              "x": 14.83,
              "y": 32.451,
              "z": 0.789
            },
            "gtin": "4000512463689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214a4",
            "leftCorner": {
              "x": 14.83,
              "y": 32.451,
              "z": 0.789
            },
            "rightCorner": {
              "x": 14.98,
              "y": 32.443,
              "z": 0.789
            },
            "gtin": "4000512463689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214a7",
            "leftCorner": {
              "x": 14.981,
              "y": 32.474,
              "z": 0.789
            },
            "rightCorner": {
              "x": 15.142,
              "y": 32.465,
              "z": 0.789
            },
            "gtin": "4000512463634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214a8",
            "leftCorner": {
              "x": 15.142,
              "y": 32.469,
              "z": 0.789
            },
            "rightCorner": {
              "x": 15.237,
              "y": 32.465,
              "z": 0.789
            },
            "gtin": "4000512463436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214a9",
            "leftCorner": {
              "x": 15.237,
              "y": 32.465,
              "z": 0.789
            },
            "rightCorner": {
              "x": 15.331,
              "y": 32.46,
              "z": 0.789
            },
            "gtin": "4000512463436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214aa",
            "leftCorner": {
              "x": 15.331,
              "y": 32.463,
              "z": 0.789
            },
            "rightCorner": {
              "x": 15.563,
              "y": 32.451,
              "z": 0.789
            },
            "gtin": "4000512463429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214a5",
            "leftCorner": {
              "x": 15.563,
              "y": 32.448,
              "z": 0.789
            },
            "rightCorner": {
              "x": 15.747,
              "y": 32.439,
              "z": 0.789
            },
            "gtin": "4000512463658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214a6",
            "leftCorner": {
              "x": 15.747,
              "y": 32.439,
              "z": 0.789
            },
            "rightCorner": {
              "x": 15.931,
              "y": 32.429,
              "z": 0.789
            },
            "gtin": "4000512463658",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468e1",
        "height": 1.3686,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21495",
            "leftCorner": {
              "x": 14.68,
              "y": 32.451,
              "z": 1.12
            },
            "rightCorner": {
              "x": 14.915,
              "y": 32.439,
              "z": 1.12
            },
            "gtin": "8713800102875",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21497",
            "leftCorner": {
              "x": 14.918,
              "y": 32.497,
              "z": 1.12
            },
            "rightCorner": {
              "x": 15.089,
              "y": 32.488,
              "z": 1.12
            },
            "gtin": "8713800114748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21498",
            "leftCorner": {
              "x": 15.088,
              "y": 32.473,
              "z": 1.12
            },
            "rightCorner": {
              "x": 15.277,
              "y": 32.463,
              "z": 1.12
            },
            "gtin": "8713800111464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21499",
            "leftCorner": {
              "x": 15.277,
              "y": 32.458,
              "z": 1.12
            },
            "rightCorner": {
              "x": 15.421,
              "y": 32.451,
              "z": 1.12
            },
            "gtin": "8713800102837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2149a",
            "leftCorner": {
              "x": 15.421,
              "y": 32.451,
              "z": 1.12
            },
            "rightCorner": {
              "x": 15.565,
              "y": 32.443,
              "z": 1.12
            },
            "gtin": "8713800102837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2149b",
            "leftCorner": {
              "x": 15.565,
              "y": 32.441,
              "z": 1.12
            },
            "rightCorner": {
              "x": 15.861,
              "y": 32.426,
              "z": 1.12
            },
            "gtin": "4000512463832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21496",
            "leftCorner": {
              "x": 15.861,
              "y": 32.421,
              "z": 1.12
            },
            "rightCorner": {
              "x": 15.93,
              "y": 32.417,
              "z": 1.12
            },
            "gtin": "8436556390739",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468e0",
        "height": 1.7653,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fca1",
            "leftCorner": {
              "x": 14.689,
              "y": 32.503,
              "z": 1.444
            },
            "rightCorner": {
              "x": 14.822,
              "y": 32.496,
              "z": 1.444
            },
            "gtin": "8713800119996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fca2",
            "leftCorner": {
              "x": 14.822,
              "y": 32.498,
              "z": 1.444
            },
            "rightCorner": {
              "x": 14.875,
              "y": 32.495,
              "z": 1.444
            },
            "gtin": "8713800119934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fca3",
            "leftCorner": {
              "x": 14.875,
              "y": 32.495,
              "z": 1.444
            },
            "rightCorner": {
              "x": 14.927,
              "y": 32.492,
              "z": 1.444
            },
            "gtin": "8713800119934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fca4",
            "leftCorner": {
              "x": 14.927,
              "y": 32.492,
              "z": 1.444
            },
            "rightCorner": {
              "x": 14.98,
              "y": 32.49,
              "z": 1.444
            },
            "gtin": "8713800119934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fca5",
            "leftCorner": {
              "x": 14.979,
              "y": 32.481,
              "z": 1.444
            },
            "rightCorner": {
              "x": 15.079,
              "y": 32.476,
              "z": 1.444
            },
            "gtin": "8713800120718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fca6",
            "leftCorner": {
              "x": 15.079,
              "y": 32.476,
              "z": 1.444
            },
            "rightCorner": {
              "x": 15.179,
              "y": 32.471,
              "z": 1.444
            },
            "gtin": "8713800120718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fca7",
            "leftCorner": {
              "x": 15.179,
              "y": 32.473,
              "z": 1.444
            },
            "rightCorner": {
              "x": 15.284,
              "y": 32.467,
              "z": 1.444
            },
            "gtin": "4014437201486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fca8",
            "leftCorner": {
              "x": 15.285,
              "y": 32.471,
              "z": 1.444
            },
            "rightCorner": {
              "x": 15.34,
              "y": 32.469,
              "z": 1.444
            },
            "gtin": "8713600279821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fca9",
            "leftCorner": {
              "x": 15.34,
              "y": 32.469,
              "z": 1.444
            },
            "rightCorner": {
              "x": 15.395,
              "y": 32.465,
              "z": 1.444
            },
            "gtin": "8713600279821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcaa",
            "leftCorner": {
              "x": 15.396,
              "y": 32.469,
              "z": 1.444
            },
            "rightCorner": {
              "x": 15.53,
              "y": 32.462,
              "z": 1.444
            },
            "gtin": "8713600279005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcab",
            "leftCorner": {
              "x": 15.529,
              "y": 32.453,
              "z": 1.444
            },
            "rightCorner": {
              "x": 15.646,
              "y": 32.447,
              "z": 1.444
            },
            "gtin": "8713600279708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcac",
            "leftCorner": {
              "x": 15.646,
              "y": 32.447,
              "z": 1.444
            },
            "rightCorner": {
              "x": 15.762,
              "y": 32.441,
              "z": 1.444
            },
            "gtin": "8713600279708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcad",
            "leftCorner": {
              "x": 15.762,
              "y": 32.433,
              "z": 1.444
            },
            "rightCorner": {
              "x": 15.876,
              "y": 32.428,
              "z": 1.444
            },
            "gtin": "8713600279029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcae",
            "leftCorner": {
              "x": 15.876,
              "y": 32.428,
              "z": 1.444
            },
            "rightCorner": {
              "x": 15.926,
              "y": 32.425,
              "z": 1.444
            },
            "gtin": "8713600279142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcaf",
            "leftCorner": {
              "x": 15.926,
              "y": 32.425,
              "z": 1.444
            },
            "rightCorner": {
              "x": 15.976,
              "y": 32.422,
              "z": 1.444
            },
            "gtin": "8713600279142",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "93000",
    "rightNeighborShelfId": "93002"
  },
  {
    "id": "93002",
    "name": "93002",
    "x": 15.928,
    "y": 32.377,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.02595,
      "w": 0.99966
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 46
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5468e9",
        "height": 0.16372,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fd6f",
            "leftCorner": {
              "x": 15.993,
              "y": 32.431,
              "z": 0.134
            },
            "rightCorner": {
              "x": 16.169,
              "y": 32.422,
              "z": 0.134
            },
            "gtin": "4037400344621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd70",
            "leftCorner": {
              "x": 16.169,
              "y": 32.412,
              "z": 0.134
            },
            "rightCorner": {
              "x": 16.284,
              "y": 32.406,
              "z": 0.134
            },
            "gtin": "4037400344652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd71",
            "leftCorner": {
              "x": 16.284,
              "y": 32.406,
              "z": 0.134
            },
            "rightCorner": {
              "x": 16.401,
              "y": 32.401,
              "z": 0.134
            },
            "gtin": "4037400344652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd72",
            "leftCorner": {
              "x": 16.401,
              "y": 32.412,
              "z": 0.134
            },
            "rightCorner": {
              "x": 16.494,
              "y": 32.407,
              "z": 0.134
            },
            "gtin": "4037400344737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd73",
            "leftCorner": {
              "x": 16.494,
              "y": 32.407,
              "z": 0.134
            },
            "rightCorner": {
              "x": 16.585,
              "y": 32.401,
              "z": 0.134
            },
            "gtin": "4037400344737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd74",
            "leftCorner": {
              "x": 16.585,
              "y": 32.394,
              "z": 0.134
            },
            "rightCorner": {
              "x": 16.785,
              "y": 32.384,
              "z": 0.134
            },
            "gtin": "4037400344867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd75",
            "leftCorner": {
              "x": 16.785,
              "y": 32.383,
              "z": 0.134
            },
            "rightCorner": {
              "x": 16.889,
              "y": 32.377,
              "z": 0.134
            },
            "gtin": "4037400344881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd76",
            "leftCorner": {
              "x": 16.889,
              "y": 32.377,
              "z": 0.134
            },
            "rightCorner": {
              "x": 16.994,
              "y": 32.372,
              "z": 0.134
            },
            "gtin": "4037400344881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd77",
            "leftCorner": {
              "x": 16.994,
              "y": 32.38,
              "z": 0.134
            },
            "rightCorner": {
              "x": 17.197,
              "y": 32.37,
              "z": 0.134
            },
            "gtin": "4037400344164",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468e6",
        "height": 0.51229,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a214b1",
            "leftCorner": {
              "x": 15.929,
              "y": 32.398,
              "z": 0.419
            },
            "rightCorner": {
              "x": 16.027,
              "y": 32.392,
              "z": 0.419
            },
            "gtin": "4037400344744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214b2",
            "leftCorner": {
              "x": 16.027,
              "y": 32.392,
              "z": 0.419
            },
            "rightCorner": {
              "x": 16.124,
              "y": 32.388,
              "z": 0.419
            },
            "gtin": "4037400344744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214b4",
            "leftCorner": {
              "x": 16.126,
              "y": 32.422,
              "z": 0.419
            },
            "rightCorner": {
              "x": 16.341,
              "y": 32.411,
              "z": 0.419
            },
            "gtin": "4037400344768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214b5",
            "leftCorner": {
              "x": 16.341,
              "y": 32.411,
              "z": 0.419
            },
            "rightCorner": {
              "x": 16.556,
              "y": 32.399,
              "z": 0.419
            },
            "gtin": "4037400344768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214b6",
            "leftCorner": {
              "x": 16.556,
              "y": 32.404,
              "z": 0.419
            },
            "rightCorner": {
              "x": 16.759,
              "y": 32.394,
              "z": 0.419
            },
            "gtin": "4037400344829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214b7",
            "leftCorner": {
              "x": 16.759,
              "y": 32.394,
              "z": 0.419
            },
            "rightCorner": {
              "x": 16.859,
              "y": 32.388,
              "z": 0.419
            },
            "gtin": "4037400344874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214b8",
            "leftCorner": {
              "x": 16.859,
              "y": 32.388,
              "z": 0.419
            },
            "rightCorner": {
              "x": 16.958,
              "y": 32.384,
              "z": 0.419
            },
            "gtin": "4037400344874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214b9",
            "leftCorner": {
              "x": 16.958,
              "y": 32.389,
              "z": 0.419
            },
            "rightCorner": {
              "x": 17.076,
              "y": 32.383,
              "z": 0.419
            },
            "gtin": "4037400344843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214ba",
            "leftCorner": {
              "x": 17.076,
              "y": 32.383,
              "z": 0.419
            },
            "rightCorner": {
              "x": 17.192,
              "y": 32.376,
              "z": 0.419
            },
            "gtin": "4037400344843",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468e5",
        "height": 0.91496,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a214ab",
            "leftCorner": {
              "x": 15.929,
              "y": 32.395,
              "z": 0.749
            },
            "rightCorner": {
              "x": 16.17,
              "y": 32.382,
              "z": 0.749
            },
            "gtin": "4037400344799",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214ac",
            "leftCorner": {
              "x": 16.17,
              "y": 32.382,
              "z": 0.749
            },
            "rightCorner": {
              "x": 16.41,
              "y": 32.37,
              "z": 0.749
            },
            "gtin": "4037400344799",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214ae",
            "leftCorner": {
              "x": 16.412,
              "y": 32.403,
              "z": 0.749
            },
            "rightCorner": {
              "x": 16.506,
              "y": 32.398,
              "z": 0.749
            },
            "gtin": "4037400344805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214af",
            "leftCorner": {
              "x": 16.506,
              "y": 32.398,
              "z": 0.749
            },
            "rightCorner": {
              "x": 16.6,
              "y": 32.393,
              "z": 0.749
            },
            "gtin": "4037400344805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214b0",
            "leftCorner": {
              "x": 16.6,
              "y": 32.4,
              "z": 0.749
            },
            "rightCorner": {
              "x": 16.837,
              "y": 32.388,
              "z": 0.749
            },
            "gtin": "4037400344782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214ad",
            "leftCorner": {
              "x": 16.837,
              "y": 32.39,
              "z": 0.749
            },
            "rightCorner": {
              "x": 17.179,
              "y": 32.372,
              "z": 0.749
            },
            "gtin": "4037400344775",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468e8",
        "height": 1.3269,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a214be",
            "leftCorner": {
              "x": 15.929,
              "y": 32.398,
              "z": 1.086
            },
            "rightCorner": {
              "x": 16.192,
              "y": 32.384,
              "z": 1.086
            },
            "gtin": "4037400344850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214c0",
            "leftCorner": {
              "x": 16.193,
              "y": 32.414,
              "z": 1.086
            },
            "rightCorner": {
              "x": 16.39,
              "y": 32.404,
              "z": 1.086
            },
            "gtin": "4037400344836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214c1",
            "leftCorner": {
              "x": 16.389,
              "y": 32.4,
              "z": 1.086
            },
            "rightCorner": {
              "x": 16.59,
              "y": 32.389,
              "z": 1.086
            },
            "gtin": "4037400344645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214c2",
            "leftCorner": {
              "x": 16.592,
              "y": 32.402,
              "z": 1.086
            },
            "rightCorner": {
              "x": 16.807,
              "y": 32.392,
              "z": 1.086
            },
            "gtin": "4037400344751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214bf",
            "leftCorner": {
              "x": 16.807,
              "y": 32.383,
              "z": 1.086
            },
            "rightCorner": {
              "x": 17.179,
              "y": 32.363,
              "z": 1.086
            },
            "gtin": "4037400344638",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468e7",
        "height": 1.7663,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fcb0",
            "leftCorner": {
              "x": 15.975,
              "y": 32.424,
              "z": 1.445
            },
            "rightCorner": {
              "x": 16.029,
              "y": 32.42,
              "z": 1.445
            },
            "gtin": "4260402484488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcb1",
            "leftCorner": {
              "x": 16.029,
              "y": 32.42,
              "z": 1.445
            },
            "rightCorner": {
              "x": 16.083,
              "y": 32.418,
              "z": 1.445
            },
            "gtin": "4260402484488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcb2",
            "leftCorner": {
              "x": 16.083,
              "y": 32.416,
              "z": 1.445
            },
            "rightCorner": {
              "x": 16.152,
              "y": 32.412,
              "z": 1.445
            },
            "gtin": "4260402484501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcb3",
            "leftCorner": {
              "x": 16.152,
              "y": 32.412,
              "z": 1.445
            },
            "rightCorner": {
              "x": 16.22,
              "y": 32.408,
              "z": 1.445
            },
            "gtin": "4260402484501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcb4",
            "leftCorner": {
              "x": 16.22,
              "y": 32.408,
              "z": 1.445
            },
            "rightCorner": {
              "x": 16.27,
              "y": 32.406,
              "z": 1.445
            },
            "gtin": "9044400889026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcb5",
            "leftCorner": {
              "x": 16.27,
              "y": 32.402,
              "z": 1.445
            },
            "rightCorner": {
              "x": 16.366,
              "y": 32.397,
              "z": 1.445
            },
            "gtin": "9044400889002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcb6",
            "leftCorner": {
              "x": 16.366,
              "y": 32.392,
              "z": 1.445
            },
            "rightCorner": {
              "x": 16.452,
              "y": 32.387,
              "z": 1.445
            },
            "gtin": "4260278365119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcb7",
            "leftCorner": {
              "x": 16.452,
              "y": 32.395,
              "z": 1.445
            },
            "rightCorner": {
              "x": 16.546,
              "y": 32.39,
              "z": 1.445
            },
            "gtin": "4260278363108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcb8",
            "leftCorner": {
              "x": 16.547,
              "y": 32.4,
              "z": 1.445
            },
            "rightCorner": {
              "x": 16.608,
              "y": 32.396,
              "z": 1.445
            },
            "gtin": "9009200015006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcb9",
            "leftCorner": {
              "x": 16.608,
              "y": 32.396,
              "z": 1.445
            },
            "rightCorner": {
              "x": 16.67,
              "y": 32.393,
              "z": 1.445
            },
            "gtin": "9009200015006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcba",
            "leftCorner": {
              "x": 16.67,
              "y": 32.395,
              "z": 1.445
            },
            "rightCorner": {
              "x": 16.722,
              "y": 32.391,
              "z": 1.445
            },
            "gtin": "9009200016645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcbb",
            "leftCorner": {
              "x": 16.722,
              "y": 32.391,
              "z": 1.445
            },
            "rightCorner": {
              "x": 16.774,
              "y": 32.389,
              "z": 1.445
            },
            "gtin": "9009200016645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcbc",
            "leftCorner": {
              "x": 16.774,
              "y": 32.391,
              "z": 1.445
            },
            "rightCorner": {
              "x": 16.845,
              "y": 32.387,
              "z": 1.445
            },
            "gtin": "9009200014559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcbd",
            "leftCorner": {
              "x": 16.845,
              "y": 32.387,
              "z": 1.445
            },
            "rightCorner": {
              "x": 16.914,
              "y": 32.384,
              "z": 1.445
            },
            "gtin": "9009200014559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcbe",
            "leftCorner": {
              "x": 16.914,
              "y": 32.385,
              "z": 1.445
            },
            "rightCorner": {
              "x": 17.003,
              "y": 32.38,
              "z": 1.445
            },
            "gtin": "4014437223662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcbf",
            "leftCorner": {
              "x": 17.003,
              "y": 32.38,
              "z": 1.445
            },
            "rightCorner": {
              "x": 17.09,
              "y": 32.376,
              "z": 1.445
            },
            "gtin": "4014437223662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcc0",
            "leftCorner": {
              "x": 17.09,
              "y": 32.374,
              "z": 1.445
            },
            "rightCorner": {
              "x": 17.182,
              "y": 32.369,
              "z": 1.445
            },
            "gtin": "4014437223693",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "93001",
    "rightNeighborShelfId": "93003"
  },
  {
    "id": "93003",
    "name": "93003",
    "x": 17.177,
    "y": 32.312,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.02595,
      "w": 0.99966
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 4,
      "unknownStockCount": 39
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5468ef",
        "height": 0.16329,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fd78",
            "leftCorner": {
              "x": 17.197,
              "y": 32.355,
              "z": 0.134
            },
            "rightCorner": {
              "x": 17.436,
              "y": 32.343,
              "z": 0.134
            },
            "gtin": "8710497962867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd79",
            "leftCorner": {
              "x": 17.435,
              "y": 32.333,
              "z": 0.134
            },
            "rightCorner": {
              "x": 17.765,
              "y": 32.316,
              "z": 0.134
            },
            "gtin": "8710497963826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd7a",
            "leftCorner": {
              "x": 17.768,
              "y": 32.343,
              "z": 0.134
            },
            "rightCorner": {
              "x": 18.12,
              "y": 32.325,
              "z": 0.134
            },
            "gtin": "8710497962584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd7b",
            "leftCorner": {
              "x": 18.12,
              "y": 32.329,
              "z": 0.134
            },
            "rightCorner": {
              "x": 18.297,
              "y": 32.319,
              "z": 0.134
            },
            "gtin": "054300091510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd7c",
            "leftCorner": {
              "x": 18.297,
              "y": 32.319,
              "z": 0.134
            },
            "rightCorner": {
              "x": 18.473,
              "y": 32.31,
              "z": 0.134
            },
            "gtin": "054300091510",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468ea",
        "height": 0.51759,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a214bb",
            "leftCorner": {
              "x": 17.194,
              "y": 32.373,
              "z": 0.423
            },
            "rightCorner": {
              "x": 17.371,
              "y": 32.364,
              "z": 0.423
            },
            "gtin": "5410768023589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214bc",
            "leftCorner": {
              "x": 17.371,
              "y": 32.36,
              "z": 0.423
            },
            "rightCorner": {
              "x": 17.74,
              "y": 32.34,
              "z": 0.423
            },
            "gtin": "5411178000887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214bd",
            "leftCorner": {
              "x": 17.74,
              "y": 32.34,
              "z": 0.423
            },
            "rightCorner": {
              "x": 18.107,
              "y": 32.322,
              "z": 0.423
            },
            "gtin": "5411178000887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214b3",
            "leftCorner": {
              "x": 18.108,
              "y": 32.332,
              "z": 0.423
            },
            "rightCorner": {
              "x": 18.429,
              "y": 32.316,
              "z": 0.423
            },
            "gtin": "4033500101577",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468eb",
        "height": 0.81169,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a214c3",
            "leftCorner": {
              "x": 17.178,
              "y": 32.327,
              "z": 0.664
            },
            "rightCorner": {
              "x": 17.818,
              "y": 32.294,
              "z": 0.664
            },
            "gtin": "4063367000553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214c5",
            "leftCorner": {
              "x": 17.82,
              "y": 32.333,
              "z": 0.664
            },
            "rightCorner": {
              "x": 17.879,
              "y": 32.329,
              "z": 0.664
            },
            "gtin": "054300090018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214c6",
            "leftCorner": {
              "x": 17.879,
              "y": 32.329,
              "z": 0.664
            },
            "rightCorner": {
              "x": 17.938,
              "y": 32.326,
              "z": 0.664
            },
            "gtin": "054300090018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214c7",
            "leftCorner": {
              "x": 17.938,
              "y": 32.333,
              "z": 0.664
            },
            "rightCorner": {
              "x": 18.129,
              "y": 32.323,
              "z": 0.664
            },
            "gtin": "5410358451068",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8b5ed67a01d9a214c8",
            "leftCorner": {
              "x": 18.129,
              "y": 32.324,
              "z": 0.664
            },
            "rightCorner": {
              "x": 18.304,
              "y": 32.314,
              "z": 0.664
            },
            "gtin": "5410358459903",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8b5ed67a01d9a214c4",
            "leftCorner": {
              "x": 18.304,
              "y": 32.307,
              "z": 0.664
            },
            "rightCorner": {
              "x": 18.429,
              "y": 32.302,
              "z": 0.664
            },
            "gtin": "5410358459880",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468ed",
        "height": 1.225,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a214c9",
            "leftCorner": {
              "x": 17.178,
              "y": 32.322,
              "z": 1.002
            },
            "rightCorner": {
              "x": 17.378,
              "y": 32.312,
              "z": 1.002
            },
            "gtin": "8690146160274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214ca",
            "leftCorner": {
              "x": 17.378,
              "y": 32.312,
              "z": 1.002
            },
            "rightCorner": {
              "x": 17.579,
              "y": 32.301,
              "z": 1.002
            },
            "gtin": "8690146160274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214cc",
            "leftCorner": {
              "x": 17.58,
              "y": 32.342,
              "z": 1.002
            },
            "rightCorner": {
              "x": 17.725,
              "y": 32.335,
              "z": 1.002
            },
            "gtin": "8690146160182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214cd",
            "leftCorner": {
              "x": 17.725,
              "y": 32.335,
              "z": 1.002
            },
            "rightCorner": {
              "x": 17.87,
              "y": 32.327,
              "z": 1.002
            },
            "gtin": "8690146160182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214ce",
            "leftCorner": {
              "x": 17.87,
              "y": 32.334,
              "z": 1.002
            },
            "rightCorner": {
              "x": 18.072,
              "y": 32.324,
              "z": 1.002
            },
            "gtin": "8710497964151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214cf",
            "leftCorner": {
              "x": 18.072,
              "y": 32.324,
              "z": 1.002
            },
            "rightCorner": {
              "x": 18.274,
              "y": 32.314,
              "z": 1.002
            },
            "gtin": "8710497964151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214cb",
            "leftCorner": {
              "x": 18.273,
              "y": 32.298,
              "z": 1.002
            },
            "rightCorner": {
              "x": 18.428,
              "y": 32.29,
              "z": 1.002
            },
            "gtin": "5411011514403",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468ee",
        "height": 1.5174,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a214d0",
            "leftCorner": {
              "x": 17.178,
              "y": 32.324,
              "z": 1.241
            },
            "rightCorner": {
              "x": 17.327,
              "y": 32.316,
              "z": 1.241
            },
            "gtin": "4033500101768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214d1",
            "leftCorner": {
              "x": 17.327,
              "y": 32.316,
              "z": 1.241
            },
            "rightCorner": {
              "x": 17.476,
              "y": 32.308,
              "z": 1.241
            },
            "gtin": "4033500101768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214d3",
            "leftCorner": {
              "x": 17.478,
              "y": 32.345,
              "z": 1.241
            },
            "rightCorner": {
              "x": 17.544,
              "y": 32.342,
              "z": 1.241
            },
            "gtin": "4033500031294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214d4",
            "leftCorner": {
              "x": 17.544,
              "y": 32.342,
              "z": 1.241
            },
            "rightCorner": {
              "x": 17.609,
              "y": 32.338,
              "z": 1.241
            },
            "gtin": "4033500031294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214d5",
            "leftCorner": {
              "x": 17.609,
              "y": 32.342,
              "z": 1.241
            },
            "rightCorner": {
              "x": 17.669,
              "y": 32.339,
              "z": 1.241
            },
            "gtin": "4033500032550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214d6",
            "leftCorner": {
              "x": 17.669,
              "y": 32.339,
              "z": 1.241
            },
            "rightCorner": {
              "x": 17.727,
              "y": 32.336,
              "z": 1.241
            },
            "gtin": "4033500032550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214d7",
            "leftCorner": {
              "x": 17.727,
              "y": 32.336,
              "z": 1.241
            },
            "rightCorner": {
              "x": 17.786,
              "y": 32.333,
              "z": 1.241
            },
            "gtin": "4033500032550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214d8",
            "leftCorner": {
              "x": 17.787,
              "y": 32.343,
              "z": 1.241
            },
            "rightCorner": {
              "x": 17.833,
              "y": 32.341,
              "z": 1.241
            },
            "gtin": "4033500032529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214d9",
            "leftCorner": {
              "x": 17.833,
              "y": 32.341,
              "z": 1.241
            },
            "rightCorner": {
              "x": 17.88,
              "y": 32.337,
              "z": 1.241
            },
            "gtin": "4033500032529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214da",
            "leftCorner": {
              "x": 17.879,
              "y": 32.321,
              "z": 1.241
            },
            "rightCorner": {
              "x": 18.064,
              "y": 32.312,
              "z": 1.241
            },
            "gtin": "40335834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214db",
            "leftCorner": {
              "x": 18.065,
              "y": 32.32,
              "z": 1.241
            },
            "rightCorner": {
              "x": 18.126,
              "y": 32.318,
              "z": 1.241
            },
            "gtin": "40335759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214dc",
            "leftCorner": {
              "x": 18.126,
              "y": 32.318,
              "z": 1.241
            },
            "rightCorner": {
              "x": 18.187,
              "y": 32.314,
              "z": 1.241
            },
            "gtin": "40335759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214dd",
            "leftCorner": {
              "x": 18.187,
              "y": 32.314,
              "z": 1.241
            },
            "rightCorner": {
              "x": 18.248,
              "y": 32.311,
              "z": 1.241
            },
            "gtin": "40335759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214de",
            "leftCorner": {
              "x": 18.248,
              "y": 32.311,
              "z": 1.241
            },
            "rightCorner": {
              "x": 18.309,
              "y": 32.307,
              "z": 1.241
            },
            "gtin": "40335759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214df",
            "leftCorner": {
              "x": 18.309,
              "y": 32.309,
              "z": 1.241
            },
            "rightCorner": {
              "x": 18.436,
              "y": 32.303,
              "z": 1.241
            },
            "gtin": "4009371002121",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468ec",
        "height": 1.7656,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fcc1",
            "leftCorner": {
              "x": 17.182,
              "y": 32.338,
              "z": 1.445
            },
            "rightCorner": {
              "x": 17.449,
              "y": 32.324,
              "z": 1.445
            },
            "gtin": "4033500101751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcc2",
            "leftCorner": {
              "x": 17.45,
              "y": 32.349,
              "z": 1.445
            },
            "rightCorner": {
              "x": 17.748,
              "y": 32.334,
              "z": 1.445
            },
            "gtin": "4033500101850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcc3",
            "leftCorner": {
              "x": 17.748,
              "y": 32.341,
              "z": 1.445
            },
            "rightCorner": {
              "x": 17.905,
              "y": 32.333,
              "z": 1.445
            },
            "gtin": "4033500101959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcc4",
            "leftCorner": {
              "x": 17.905,
              "y": 32.333,
              "z": 1.445
            },
            "rightCorner": {
              "x": 18.062,
              "y": 32.325,
              "z": 1.445
            },
            "gtin": "4033500101959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcc5",
            "leftCorner": {
              "x": 18.062,
              "y": 32.324,
              "z": 1.445
            },
            "rightCorner": {
              "x": 18.341,
              "y": 32.309,
              "z": 1.445
            },
            "gtin": "5411011400003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcc6",
            "leftCorner": {
              "x": 18.34,
              "y": 32.304,
              "z": 1.445
            },
            "rightCorner": {
              "x": 18.409,
              "y": 32.301,
              "z": 1.445
            },
            "gtin": "4004806510127",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "93002",
    "rightNeighborShelfId": "93004"
  },
  {
    "id": "93004",
    "name": "93004",
    "x": 18.425,
    "y": 32.247,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.02595,
      "w": 0.99966
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 74
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5468f4",
        "height": 0.16412,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fd7d",
            "leftCorner": {
              "x": 18.472,
              "y": 32.292,
              "z": 0.134
            },
            "rightCorner": {
              "x": 18.651,
              "y": 32.282,
              "z": 0.134
            },
            "gtin": "4063367416958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd7e",
            "leftCorner": {
              "x": 18.651,
              "y": 32.278,
              "z": 0.134
            },
            "rightCorner": {
              "x": 18.823,
              "y": 32.269,
              "z": 0.134
            },
            "gtin": "4063367213953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd7f",
            "leftCorner": {
              "x": 18.823,
              "y": 32.277,
              "z": 0.134
            },
            "rightCorner": {
              "x": 19.041,
              "y": 32.266,
              "z": 0.134
            },
            "gtin": "4063367399404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd80",
            "leftCorner": {
              "x": 19.04,
              "y": 32.249,
              "z": 0.134
            },
            "rightCorner": {
              "x": 19.113,
              "y": 32.246,
              "z": 0.134
            },
            "gtin": "4063367416873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd81",
            "leftCorner": {
              "x": 19.113,
              "y": 32.246,
              "z": 0.134
            },
            "rightCorner": {
              "x": 19.186,
              "y": 32.242,
              "z": 0.134
            },
            "gtin": "4063367416873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd82",
            "leftCorner": {
              "x": 19.187,
              "y": 32.256,
              "z": 0.134
            },
            "rightCorner": {
              "x": 19.377,
              "y": 32.246,
              "z": 0.134
            },
            "gtin": "4063367213915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd83",
            "leftCorner": {
              "x": 19.377,
              "y": 32.246,
              "z": 0.134
            },
            "rightCorner": {
              "x": 19.567,
              "y": 32.236,
              "z": 0.134
            },
            "gtin": "4063367213915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd84",
            "leftCorner": {
              "x": 19.568,
              "y": 32.245,
              "z": 0.134
            },
            "rightCorner": {
              "x": 19.775,
              "y": 32.234,
              "z": 0.134
            },
            "gtin": "4063367213939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd85",
            "leftCorner": {
              "x": 19.775,
              "y": 32.234,
              "z": 0.134
            },
            "rightCorner": {
              "x": 19.983,
              "y": 32.224,
              "z": 0.134
            },
            "gtin": "4063367213939",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468f3",
        "height": 0.56142,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21509",
            "leftCorner": {
              "x": 18.426,
              "y": 32.26,
              "z": 0.459
            },
            "rightCorner": {
              "x": 18.665,
              "y": 32.248,
              "z": 0.459
            },
            "gtin": "4063367416910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2150b",
            "leftCorner": {
              "x": 18.667,
              "y": 32.285,
              "z": 0.459
            },
            "rightCorner": {
              "x": 18.858,
              "y": 32.275,
              "z": 0.459
            },
            "gtin": "4063367416859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2150c",
            "leftCorner": {
              "x": 18.858,
              "y": 32.277,
              "z": 0.459
            },
            "rightCorner": {
              "x": 19.073,
              "y": 32.266,
              "z": 0.459
            },
            "gtin": "4063367416897",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2150d",
            "leftCorner": {
              "x": 19.072,
              "y": 32.252,
              "z": 0.459
            },
            "rightCorner": {
              "x": 19.311,
              "y": 32.239,
              "z": 0.459
            },
            "gtin": "4063367416934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2150e",
            "leftCorner": {
              "x": 19.312,
              "y": 32.256,
              "z": 0.459
            },
            "rightCorner": {
              "x": 19.522,
              "y": 32.245,
              "z": 0.459
            },
            "gtin": "4063367214028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2150a",
            "leftCorner": {
              "x": 19.522,
              "y": 32.249,
              "z": 0.459
            },
            "rightCorner": {
              "x": 19.677,
              "y": 32.242,
              "z": 0.459
            },
            "gtin": "4063367399428",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468f5",
        "height": 0.96384,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2150f",
            "leftCorner": {
              "x": 18.425,
              "y": 32.254,
              "z": 0.789
            },
            "rightCorner": {
              "x": 18.548,
              "y": 32.248,
              "z": 0.789
            },
            "gtin": "4000843054891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21513",
            "leftCorner": {
              "x": 18.55,
              "y": 32.29,
              "z": 0.789
            },
            "rightCorner": {
              "x": 18.642,
              "y": 32.285,
              "z": 0.789
            },
            "gtin": "4000843054709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21514",
            "leftCorner": {
              "x": 18.641,
              "y": 32.282,
              "z": 0.789
            },
            "rightCorner": {
              "x": 18.715,
              "y": 32.279,
              "z": 0.789
            },
            "gtin": "4000843054877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21515",
            "leftCorner": {
              "x": 18.715,
              "y": 32.279,
              "z": 0.789
            },
            "rightCorner": {
              "x": 18.788,
              "y": 32.275,
              "z": 0.789
            },
            "gtin": "4000843054877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21516",
            "leftCorner": {
              "x": 18.786,
              "y": 32.252,
              "z": 0.789
            },
            "rightCorner": {
              "x": 18.918,
              "y": 32.246,
              "z": 0.789
            },
            "gtin": "4000843055683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21517",
            "leftCorner": {
              "x": 18.918,
              "y": 32.246,
              "z": 0.789
            },
            "rightCorner": {
              "x": 19.049,
              "y": 32.239,
              "z": 0.789
            },
            "gtin": "4000843055683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21518",
            "leftCorner": {
              "x": 19.049,
              "y": 32.25,
              "z": 0.789
            },
            "rightCorner": {
              "x": 19.107,
              "y": 32.247,
              "z": 0.789
            },
            "gtin": "4000843054655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21519",
            "leftCorner": {
              "x": 19.107,
              "y": 32.247,
              "z": 0.789
            },
            "rightCorner": {
              "x": 19.166,
              "y": 32.243,
              "z": 0.789
            },
            "gtin": "4000843054655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2151a",
            "leftCorner": {
              "x": 19.166,
              "y": 32.243,
              "z": 0.789
            },
            "rightCorner": {
              "x": 19.224,
              "y": 32.241,
              "z": 0.789
            },
            "gtin": "4000843054655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2151b",
            "leftCorner": {
              "x": 19.224,
              "y": 32.239,
              "z": 0.789
            },
            "rightCorner": {
              "x": 19.357,
              "y": 32.232,
              "z": 0.789
            },
            "gtin": "4000843054686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2151c",
            "leftCorner": {
              "x": 19.357,
              "y": 32.232,
              "z": 0.789
            },
            "rightCorner": {
              "x": 19.491,
              "y": 32.225,
              "z": 0.789
            },
            "gtin": "4000843054686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21510",
            "leftCorner": {
              "x": 19.493,
              "y": 32.242,
              "z": 0.789
            },
            "rightCorner": {
              "x": 19.553,
              "y": 32.238,
              "z": 0.789
            },
            "gtin": "4000843054679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21511",
            "leftCorner": {
              "x": 19.553,
              "y": 32.238,
              "z": 0.789
            },
            "rightCorner": {
              "x": 19.614,
              "y": 32.236,
              "z": 0.789
            },
            "gtin": "4000843054679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21512",
            "leftCorner": {
              "x": 19.614,
              "y": 32.236,
              "z": 0.789
            },
            "rightCorner": {
              "x": 19.676,
              "y": 32.232,
              "z": 0.789
            },
            "gtin": "4000843054679",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468f2",
        "height": 1.318,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a214fa",
            "leftCorner": {
              "x": 18.426,
              "y": 32.255,
              "z": 1.078
            },
            "rightCorner": {
              "x": 18.521,
              "y": 32.249,
              "z": 1.078
            },
            "gtin": "40468679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214fb",
            "leftCorner": {
              "x": 18.521,
              "y": 32.249,
              "z": 1.078
            },
            "rightCorner": {
              "x": 18.617,
              "y": 32.245,
              "z": 1.078
            },
            "gtin": "40468679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214fd",
            "leftCorner": {
              "x": 18.619,
              "y": 32.284,
              "z": 1.078
            },
            "rightCorner": {
              "x": 18.727,
              "y": 32.279,
              "z": 1.078
            },
            "gtin": "40468280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214fe",
            "leftCorner": {
              "x": 18.727,
              "y": 32.279,
              "z": 1.078
            },
            "rightCorner": {
              "x": 18.835,
              "y": 32.274,
              "z": 1.078
            },
            "gtin": "40468280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214ff",
            "leftCorner": {
              "x": 18.836,
              "y": 32.276,
              "z": 1.078
            },
            "rightCorner": {
              "x": 18.903,
              "y": 32.272,
              "z": 1.078
            },
            "gtin": "40468266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21500",
            "leftCorner": {
              "x": 18.903,
              "y": 32.272,
              "z": 1.078
            },
            "rightCorner": {
              "x": 18.971,
              "y": 32.269,
              "z": 1.078
            },
            "gtin": "40468266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21501",
            "leftCorner": {
              "x": 18.97,
              "y": 32.262,
              "z": 1.078
            },
            "rightCorner": {
              "x": 19.032,
              "y": 32.259,
              "z": 1.078
            },
            "gtin": "7610369421915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21502",
            "leftCorner": {
              "x": 19.032,
              "y": 32.259,
              "z": 1.078
            },
            "rightCorner": {
              "x": 19.094,
              "y": 32.256,
              "z": 1.078
            },
            "gtin": "7610369421915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21503",
            "leftCorner": {
              "x": 19.094,
              "y": 32.249,
              "z": 1.078
            },
            "rightCorner": {
              "x": 19.158,
              "y": 32.246,
              "z": 1.078
            },
            "gtin": "7610369422004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21504",
            "leftCorner": {
              "x": 19.158,
              "y": 32.246,
              "z": 1.078
            },
            "rightCorner": {
              "x": 19.224,
              "y": 32.243,
              "z": 1.078
            },
            "gtin": "7610369422004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21505",
            "leftCorner": {
              "x": 19.224,
              "y": 32.243,
              "z": 1.078
            },
            "rightCorner": {
              "x": 19.285,
              "y": 32.24,
              "z": 1.078
            },
            "gtin": "7610369421922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21506",
            "leftCorner": {
              "x": 19.285,
              "y": 32.24,
              "z": 1.078
            },
            "rightCorner": {
              "x": 19.347,
              "y": 32.237,
              "z": 1.078
            },
            "gtin": "7610369421922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21507",
            "leftCorner": {
              "x": 19.348,
              "y": 32.247,
              "z": 1.078
            },
            "rightCorner": {
              "x": 19.411,
              "y": 32.243,
              "z": 1.078
            },
            "gtin": "7610369421939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21508",
            "leftCorner": {
              "x": 19.411,
              "y": 32.243,
              "z": 1.078
            },
            "rightCorner": {
              "x": 19.475,
              "y": 32.24,
              "z": 1.078
            },
            "gtin": "7610369421939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214fc",
            "leftCorner": {
              "x": 19.475,
              "y": 32.241,
              "z": 1.078
            },
            "rightCorner": {
              "x": 19.676,
              "y": 32.23,
              "z": 1.078
            },
            "gtin": "42214663",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468f1",
        "height": 1.5189,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a214e0",
            "leftCorner": {
              "x": 18.437,
              "y": 32.307,
              "z": 1.243
            },
            "rightCorner": {
              "x": 18.506,
              "y": 32.303,
              "z": 1.243
            },
            "gtin": "9044400231009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214e1",
            "leftCorner": {
              "x": 18.506,
              "y": 32.303,
              "z": 1.243
            },
            "rightCorner": {
              "x": 18.576,
              "y": 32.299,
              "z": 1.243
            },
            "gtin": "9044400231009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214e2",
            "leftCorner": {
              "x": 18.575,
              "y": 32.282,
              "z": 1.243
            },
            "rightCorner": {
              "x": 18.667,
              "y": 32.277,
              "z": 1.243
            },
            "gtin": "9044400841000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214e3",
            "leftCorner": {
              "x": 18.667,
              "y": 32.277,
              "z": 1.243
            },
            "rightCorner": {
              "x": 18.757,
              "y": 32.272,
              "z": 1.243
            },
            "gtin": "9044400841000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214e4",
            "leftCorner": {
              "x": 18.757,
              "y": 32.272,
              "z": 1.243
            },
            "rightCorner": {
              "x": 18.849,
              "y": 32.268,
              "z": 1.243
            },
            "gtin": "9044400841000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214e5",
            "leftCorner": {
              "x": 18.849,
              "y": 32.273,
              "z": 1.243
            },
            "rightCorner": {
              "x": 18.941,
              "y": 32.268,
              "z": 1.243
            },
            "gtin": "4014437235320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214e6",
            "leftCorner": {
              "x": 18.941,
              "y": 32.268,
              "z": 1.243
            },
            "rightCorner": {
              "x": 19.032,
              "y": 32.263,
              "z": 1.243
            },
            "gtin": "4014437235320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214e7",
            "leftCorner": {
              "x": 19.032,
              "y": 32.259,
              "z": 1.243
            },
            "rightCorner": {
              "x": 19.148,
              "y": 32.252,
              "z": 1.243
            },
            "gtin": "4014437235337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214e8",
            "leftCorner": {
              "x": 19.148,
              "y": 32.252,
              "z": 1.243
            },
            "rightCorner": {
              "x": 19.265,
              "y": 32.246,
              "z": 1.243
            },
            "gtin": "4014437235337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214e9",
            "leftCorner": {
              "x": 19.265,
              "y": 32.252,
              "z": 1.243
            },
            "rightCorner": {
              "x": 19.349,
              "y": 32.248,
              "z": 1.243
            },
            "gtin": "4014437235306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214ea",
            "leftCorner": {
              "x": 19.349,
              "y": 32.248,
              "z": 1.243
            },
            "rightCorner": {
              "x": 19.432,
              "y": 32.244,
              "z": 1.243
            },
            "gtin": "4014437235306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214eb",
            "leftCorner": {
              "x": 19.432,
              "y": 32.244,
              "z": 1.243
            },
            "rightCorner": {
              "x": 19.516,
              "y": 32.239,
              "z": 1.243
            },
            "gtin": "4014437235306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214ec",
            "leftCorner": {
              "x": 19.516,
              "y": 32.241,
              "z": 1.243
            },
            "rightCorner": {
              "x": 19.6,
              "y": 32.237,
              "z": 1.243
            },
            "gtin": "4030300572064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214ed",
            "leftCorner": {
              "x": 19.6,
              "y": 32.237,
              "z": 1.243
            },
            "rightCorner": {
              "x": 19.683,
              "y": 32.233,
              "z": 1.243
            },
            "gtin": "4030300572064",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468f0",
        "height": 1.7672,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fcc7",
            "leftCorner": {
              "x": 18.409,
              "y": 32.3,
              "z": 1.446
            },
            "rightCorner": {
              "x": 18.526,
              "y": 32.294,
              "z": 1.446
            },
            "gtin": "4260562940923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcc8",
            "leftCorner": {
              "x": 18.526,
              "y": 32.295,
              "z": 1.446
            },
            "rightCorner": {
              "x": 18.615,
              "y": 32.291,
              "z": 1.446
            },
            "gtin": "4260562940930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcc9",
            "leftCorner": {
              "x": 18.615,
              "y": 32.291,
              "z": 1.446
            },
            "rightCorner": {
              "x": 18.703,
              "y": 32.286,
              "z": 1.446
            },
            "gtin": "4260562940930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcca",
            "leftCorner": {
              "x": 18.703,
              "y": 32.283,
              "z": 1.446
            },
            "rightCorner": {
              "x": 18.858,
              "y": 32.275,
              "z": 1.446
            },
            "gtin": "4260562940909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fccb",
            "leftCorner": {
              "x": 18.858,
              "y": 32.276,
              "z": 1.446
            },
            "rightCorner": {
              "x": 18.921,
              "y": 32.272,
              "z": 1.446
            },
            "gtin": "4260562940916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fccc",
            "leftCorner": {
              "x": 18.921,
              "y": 32.267,
              "z": 1.446
            },
            "rightCorner": {
              "x": 18.98,
              "y": 32.264,
              "z": 1.446
            },
            "gtin": "4002590140124",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c885ed67a01d9a1fccd",
            "leftCorner": {
              "x": 18.98,
              "y": 32.248,
              "z": 1.446
            },
            "rightCorner": {
              "x": 19.065,
              "y": 32.243,
              "z": 1.446
            },
            "gtin": "4002590140933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcce",
            "leftCorner": {
              "x": 19.065,
              "y": 32.243,
              "z": 1.446
            },
            "rightCorner": {
              "x": 19.15,
              "y": 32.238,
              "z": 1.446
            },
            "gtin": "4002590140933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fccf",
            "leftCorner": {
              "x": 19.15,
              "y": 32.249,
              "z": 1.446
            },
            "rightCorner": {
              "x": 19.231,
              "y": 32.246,
              "z": 1.446
            },
            "gtin": "4030300022088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcd0",
            "leftCorner": {
              "x": 19.231,
              "y": 32.246,
              "z": 1.446
            },
            "rightCorner": {
              "x": 19.312,
              "y": 32.241,
              "z": 1.446
            },
            "gtin": "4030300022088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcd1",
            "leftCorner": {
              "x": 19.312,
              "y": 32.239,
              "z": 1.446
            },
            "rightCorner": {
              "x": 19.431,
              "y": 32.233,
              "z": 1.446
            },
            "gtin": "4030300022880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcd2",
            "leftCorner": {
              "x": 19.432,
              "y": 32.244,
              "z": 1.446
            },
            "rightCorner": {
              "x": 19.464,
              "y": 32.242,
              "z": 1.446
            },
            "gtin": "4030300572576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcd3",
            "leftCorner": {
              "x": 19.464,
              "y": 32.242,
              "z": 1.446
            },
            "rightCorner": {
              "x": 19.497,
              "y": 32.241,
              "z": 1.446
            },
            "gtin": "4030300572576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcd4",
            "leftCorner": {
              "x": 19.497,
              "y": 32.241,
              "z": 1.446
            },
            "rightCorner": {
              "x": 19.529,
              "y": 32.238,
              "z": 1.446
            },
            "gtin": "4030300572576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcd5",
            "leftCorner": {
              "x": 19.529,
              "y": 32.238,
              "z": 1.446
            },
            "rightCorner": {
              "x": 19.562,
              "y": 32.237,
              "z": 1.446
            },
            "gtin": "4030300572576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcd6",
            "leftCorner": {
              "x": 19.561,
              "y": 32.232,
              "z": 1.446
            },
            "rightCorner": {
              "x": 19.639,
              "y": 32.229,
              "z": 1.446
            },
            "gtin": "4030300022057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcd7",
            "leftCorner": {
              "x": 19.639,
              "y": 32.229,
              "z": 1.446
            },
            "rightCorner": {
              "x": 19.716,
              "y": 32.225,
              "z": 1.446
            },
            "gtin": "4030300022057",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "93003",
    "rightNeighborShelfId": "93005"
  },
  {
    "id": "93005",
    "name": "93005",
    "x": 19.673,
    "y": 32.182,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.02595,
      "w": 0.99966
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 85
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546903",
        "height": 0.16365,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fd86",
            "leftCorner": {
              "x": 19.984,
              "y": 32.226,
              "z": 0.134
            },
            "rightCorner": {
              "x": 20.156,
              "y": 32.216,
              "z": 0.134
            },
            "gtin": "4337185927461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd87",
            "leftCorner": {
              "x": 20.156,
              "y": 32.216,
              "z": 0.134
            },
            "rightCorner": {
              "x": 20.33,
              "y": 32.207,
              "z": 0.134
            },
            "gtin": "4337185927461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd88",
            "leftCorner": {
              "x": 20.33,
              "y": 32.209,
              "z": 0.134
            },
            "rightCorner": {
              "x": 20.859,
              "y": 32.182,
              "z": 0.134
            },
            "gtin": "4337185500121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd89",
            "leftCorner": {
              "x": 20.859,
              "y": 32.169,
              "z": 0.134
            },
            "rightCorner": {
              "x": 20.972,
              "y": 32.163,
              "z": 0.134
            },
            "gtin": "4337185927478",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468ff",
        "height": 0.41728,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a215ac",
            "leftCorner": {
              "x": 19.674,
              "y": 32.196,
              "z": 0.341
            },
            "rightCorner": {
              "x": 19.791,
              "y": 32.189,
              "z": 0.341
            },
            "gtin": "4001686271285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215ae",
            "leftCorner": {
              "x": 19.793,
              "y": 32.228,
              "z": 0.341
            },
            "rightCorner": {
              "x": 19.845,
              "y": 32.225,
              "z": 0.341
            },
            "gtin": "4001686271278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215af",
            "leftCorner": {
              "x": 19.845,
              "y": 32.225,
              "z": 0.341
            },
            "rightCorner": {
              "x": 19.897,
              "y": 32.222,
              "z": 0.341
            },
            "gtin": "4001686271278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215b0",
            "leftCorner": {
              "x": 19.897,
              "y": 32.222,
              "z": 0.341
            },
            "rightCorner": {
              "x": 19.949,
              "y": 32.22,
              "z": 0.341
            },
            "gtin": "4001686271278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215b1",
            "leftCorner": {
              "x": 19.949,
              "y": 32.22,
              "z": 0.341
            },
            "rightCorner": {
              "x": 20.001,
              "y": 32.217,
              "z": 0.341
            },
            "gtin": "4001686271278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215b2",
            "leftCorner": {
              "x": 20.001,
              "y": 32.217,
              "z": 0.341
            },
            "rightCorner": {
              "x": 20.053,
              "y": 32.214,
              "z": 0.341
            },
            "gtin": "4001686271278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215b3",
            "leftCorner": {
              "x": 20.053,
              "y": 32.217,
              "z": 0.341
            },
            "rightCorner": {
              "x": 20.144,
              "y": 32.213,
              "z": 0.341
            },
            "gtin": "8717399045629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215b4",
            "leftCorner": {
              "x": 20.144,
              "y": 32.21,
              "z": 0.341
            },
            "rightCorner": {
              "x": 20.307,
              "y": 32.201,
              "z": 0.341
            },
            "gtin": "4009077026087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215b5",
            "leftCorner": {
              "x": 20.307,
              "y": 32.201,
              "z": 0.341
            },
            "rightCorner": {
              "x": 20.47,
              "y": 32.193,
              "z": 0.341
            },
            "gtin": "4009077026087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215b6",
            "leftCorner": {
              "x": 20.47,
              "y": 32.196,
              "z": 0.341
            },
            "rightCorner": {
              "x": 20.548,
              "y": 32.192,
              "z": 0.341
            },
            "gtin": "4009077031333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215b7",
            "leftCorner": {
              "x": 20.548,
              "y": 32.192,
              "z": 0.341
            },
            "rightCorner": {
              "x": 20.625,
              "y": 32.188,
              "z": 0.341
            },
            "gtin": "4009077031333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215b8",
            "leftCorner": {
              "x": 20.624,
              "y": 32.183,
              "z": 0.341
            },
            "rightCorner": {
              "x": 20.779,
              "y": 32.175,
              "z": 0.341
            },
            "gtin": "4009077031562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215ad",
            "leftCorner": {
              "x": 20.779,
              "y": 32.174,
              "z": 0.341
            },
            "rightCorner": {
              "x": 20.924,
              "y": 32.166,
              "z": 0.341
            },
            "gtin": "4009077031388",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468fe",
        "height": 0.71596,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21586",
            "leftCorner": {
              "x": 19.674,
              "y": 32.198,
              "z": 0.586
            },
            "rightCorner": {
              "x": 19.78,
              "y": 32.193,
              "z": 0.586
            },
            "gtin": "4009077026049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21587",
            "leftCorner": {
              "x": 19.78,
              "y": 32.193,
              "z": 0.586
            },
            "rightCorner": {
              "x": 19.887,
              "y": 32.187,
              "z": 0.586
            },
            "gtin": "4009077026049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21588",
            "leftCorner": {
              "x": 19.887,
              "y": 32.187,
              "z": 0.586
            },
            "rightCorner": {
              "x": 19.993,
              "y": 32.182,
              "z": 0.586
            },
            "gtin": "4009077026049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2158b",
            "leftCorner": {
              "x": 19.995,
              "y": 32.215,
              "z": 0.586
            },
            "rightCorner": {
              "x": 20.149,
              "y": 32.207,
              "z": 0.586
            },
            "gtin": "4009077026018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2158c",
            "leftCorner": {
              "x": 20.15,
              "y": 32.218,
              "z": 0.586
            },
            "rightCorner": {
              "x": 20.227,
              "y": 32.215,
              "z": 0.586
            },
            "gtin": "4009077024601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2158d",
            "leftCorner": {
              "x": 20.227,
              "y": 32.215,
              "z": 0.586
            },
            "rightCorner": {
              "x": 20.305,
              "y": 32.21,
              "z": 0.586
            },
            "gtin": "4009077024601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2158e",
            "leftCorner": {
              "x": 20.305,
              "y": 32.206,
              "z": 0.586
            },
            "rightCorner": {
              "x": 20.382,
              "y": 32.202,
              "z": 0.586
            },
            "gtin": "4009077024007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2158f",
            "leftCorner": {
              "x": 20.382,
              "y": 32.202,
              "z": 0.586
            },
            "rightCorner": {
              "x": 20.458,
              "y": 32.198,
              "z": 0.586
            },
            "gtin": "4009077024007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21590",
            "leftCorner": {
              "x": 20.459,
              "y": 32.202,
              "z": 0.586
            },
            "rightCorner": {
              "x": 20.564,
              "y": 32.197,
              "z": 0.586
            },
            "gtin": "4009077024106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21591",
            "leftCorner": {
              "x": 20.564,
              "y": 32.197,
              "z": 0.586
            },
            "rightCorner": {
              "x": 20.668,
              "y": 32.192,
              "z": 0.586
            },
            "gtin": "4009077024106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21592",
            "leftCorner": {
              "x": 20.668,
              "y": 32.185,
              "z": 0.586
            },
            "rightCorner": {
              "x": 20.812,
              "y": 32.177,
              "z": 0.586
            },
            "gtin": "4009077024762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21593",
            "leftCorner": {
              "x": 20.812,
              "y": 32.177,
              "z": 0.586
            },
            "rightCorner": {
              "x": 20.957,
              "y": 32.17,
              "z": 0.586
            },
            "gtin": "4009077024762",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546901",
        "height": 1.0184,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a215c5",
            "leftCorner": {
              "x": 19.674,
              "y": 32.198,
              "z": 0.833
            },
            "rightCorner": {
              "x": 19.791,
              "y": 32.192,
              "z": 0.833
            },
            "gtin": "4009077026094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215c6",
            "leftCorner": {
              "x": 19.791,
              "y": 32.192,
              "z": 0.833
            },
            "rightCorner": {
              "x": 19.907,
              "y": 32.186,
              "z": 0.833
            },
            "gtin": "4009077026094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215ca",
            "leftCorner": {
              "x": 19.91,
              "y": 32.221,
              "z": 0.833
            },
            "rightCorner": {
              "x": 19.97,
              "y": 32.218,
              "z": 0.833
            },
            "gtin": "4009077024304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215cb",
            "leftCorner": {
              "x": 19.97,
              "y": 32.218,
              "z": 0.833
            },
            "rightCorner": {
              "x": 20.031,
              "y": 32.215,
              "z": 0.833
            },
            "gtin": "4009077024304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215cc",
            "leftCorner": {
              "x": 20.031,
              "y": 32.214,
              "z": 0.833
            },
            "rightCorner": {
              "x": 20.215,
              "y": 32.205,
              "z": 0.833
            },
            "gtin": "4009077026117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215cd",
            "leftCorner": {
              "x": 20.215,
              "y": 32.205,
              "z": 0.833
            },
            "rightCorner": {
              "x": 20.399,
              "y": 32.196,
              "z": 0.833
            },
            "gtin": "4009077026117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215ce",
            "leftCorner": {
              "x": 20.399,
              "y": 32.198,
              "z": 0.833
            },
            "rightCorner": {
              "x": 20.56,
              "y": 32.188,
              "z": 0.833
            },
            "gtin": "4009077024458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215cf",
            "leftCorner": {
              "x": 20.56,
              "y": 32.182,
              "z": 0.833
            },
            "rightCorner": {
              "x": 20.648,
              "y": 32.178,
              "z": 0.833
            },
            "gtin": "4009077024151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215d0",
            "leftCorner": {
              "x": 20.648,
              "y": 32.178,
              "z": 0.833
            },
            "rightCorner": {
              "x": 20.736,
              "y": 32.173,
              "z": 0.833
            },
            "gtin": "4009077024151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215c7",
            "leftCorner": {
              "x": 20.736,
              "y": 32.176,
              "z": 0.833
            },
            "rightCorner": {
              "x": 20.799,
              "y": 32.173,
              "z": 0.833
            },
            "gtin": "4009077026070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215c8",
            "leftCorner": {
              "x": 20.799,
              "y": 32.173,
              "z": 0.833
            },
            "rightCorner": {
              "x": 20.861,
              "y": 32.169,
              "z": 0.833
            },
            "gtin": "4009077026070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215c9",
            "leftCorner": {
              "x": 20.861,
              "y": 32.169,
              "z": 0.833
            },
            "rightCorner": {
              "x": 20.924,
              "y": 32.166,
              "z": 0.833
            },
            "gtin": "4009077026070",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546900",
        "height": 1.2688,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a215b9",
            "leftCorner": {
              "x": 19.674,
              "y": 32.196,
              "z": 1.038
            },
            "rightCorner": {
              "x": 19.876,
              "y": 32.186,
              "z": 1.038
            },
            "gtin": "4030300572316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215bc",
            "leftCorner": {
              "x": 19.878,
              "y": 32.22,
              "z": 1.038
            },
            "rightCorner": {
              "x": 19.96,
              "y": 32.216,
              "z": 1.038
            },
            "gtin": "4000211000604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215bd",
            "leftCorner": {
              "x": 19.96,
              "y": 32.216,
              "z": 1.038
            },
            "rightCorner": {
              "x": 20.041,
              "y": 32.212,
              "z": 1.038
            },
            "gtin": "4000211000604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215be",
            "leftCorner": {
              "x": 20.041,
              "y": 32.218,
              "z": 1.038
            },
            "rightCorner": {
              "x": 20.171,
              "y": 32.211,
              "z": 1.038
            },
            "gtin": "4030300572057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215bf",
            "leftCorner": {
              "x": 20.171,
              "y": 32.211,
              "z": 1.038
            },
            "rightCorner": {
              "x": 20.301,
              "y": 32.205,
              "z": 1.038
            },
            "gtin": "4030300572057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215c0",
            "leftCorner": {
              "x": 20.3,
              "y": 32.198,
              "z": 1.038
            },
            "rightCorner": {
              "x": 20.387,
              "y": 32.195,
              "z": 1.038
            },
            "gtin": "4000211155298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215c1",
            "leftCorner": {
              "x": 20.387,
              "y": 32.195,
              "z": 1.038
            },
            "rightCorner": {
              "x": 20.472,
              "y": 32.19,
              "z": 1.038
            },
            "gtin": "4000211155298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215c2",
            "leftCorner": {
              "x": 20.472,
              "y": 32.19,
              "z": 1.038
            },
            "rightCorner": {
              "x": 20.558,
              "y": 32.185,
              "z": 1.038
            },
            "gtin": "4000211155298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215c3",
            "leftCorner": {
              "x": 20.558,
              "y": 32.183,
              "z": 1.038
            },
            "rightCorner": {
              "x": 20.66,
              "y": 32.178,
              "z": 1.038
            },
            "gtin": "4000211055000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215c4",
            "leftCorner": {
              "x": 20.66,
              "y": 32.178,
              "z": 1.038
            },
            "rightCorner": {
              "x": 20.791,
              "y": 32.171,
              "z": 1.038
            },
            "gtin": "4000211035279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215ba",
            "leftCorner": {
              "x": 20.791,
              "y": 32.174,
              "z": 1.038
            },
            "rightCorner": {
              "x": 20.857,
              "y": 32.17,
              "z": 1.038
            },
            "gtin": "4000211035286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215bb",
            "leftCorner": {
              "x": 20.857,
              "y": 32.17,
              "z": 1.038
            },
            "rightCorner": {
              "x": 20.925,
              "y": 32.167,
              "z": 1.038
            },
            "gtin": "4000211035286",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468fd",
        "height": 1.5196,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a214ee",
            "leftCorner": {
              "x": 19.684,
              "y": 32.237,
              "z": 1.243
            },
            "rightCorner": {
              "x": 19.811,
              "y": 32.23,
              "z": 1.243
            },
            "gtin": "4030300002851",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214ef",
            "leftCorner": {
              "x": 19.811,
              "y": 32.23,
              "z": 1.243
            },
            "rightCorner": {
              "x": 19.938,
              "y": 32.223,
              "z": 1.243
            },
            "gtin": "4030300002851",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214f0",
            "leftCorner": {
              "x": 19.938,
              "y": 32.22,
              "z": 1.243
            },
            "rightCorner": {
              "x": 20.004,
              "y": 32.217,
              "z": 1.243
            },
            "gtin": "4030300002660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214f1",
            "leftCorner": {
              "x": 20.004,
              "y": 32.217,
              "z": 1.243
            },
            "rightCorner": {
              "x": 20.07,
              "y": 32.213,
              "z": 1.243
            },
            "gtin": "4030300002660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214f2",
            "leftCorner": {
              "x": 20.07,
              "y": 32.209,
              "z": 1.243
            },
            "rightCorner": {
              "x": 20.157,
              "y": 32.204,
              "z": 1.243
            },
            "gtin": "4030300001656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214f3",
            "leftCorner": {
              "x": 20.157,
              "y": 32.204,
              "z": 1.243
            },
            "rightCorner": {
              "x": 20.245,
              "y": 32.2,
              "z": 1.243
            },
            "gtin": "4030300001656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214f4",
            "leftCorner": {
              "x": 20.245,
              "y": 32.198,
              "z": 1.243
            },
            "rightCorner": {
              "x": 20.339,
              "y": 32.193,
              "z": 1.243
            },
            "gtin": "4030300022811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214f5",
            "leftCorner": {
              "x": 20.339,
              "y": 32.193,
              "z": 1.243
            },
            "rightCorner": {
              "x": 20.432,
              "y": 32.188,
              "z": 1.243
            },
            "gtin": "4030300022811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214f6",
            "leftCorner": {
              "x": 20.432,
              "y": 32.188,
              "z": 1.243
            },
            "rightCorner": {
              "x": 20.526,
              "y": 32.183,
              "z": 1.243
            },
            "gtin": "4030300022811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214f7",
            "leftCorner": {
              "x": 20.527,
              "y": 32.197,
              "z": 1.243
            },
            "rightCorner": {
              "x": 20.609,
              "y": 32.192,
              "z": 1.243
            },
            "gtin": "4000211000925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214f8",
            "leftCorner": {
              "x": 20.609,
              "y": 32.192,
              "z": 1.243
            },
            "rightCorner": {
              "x": 20.693,
              "y": 32.188,
              "z": 1.243
            },
            "gtin": "4000211000925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214f9",
            "leftCorner": {
              "x": 20.693,
              "y": 32.186,
              "z": 1.243
            },
            "rightCorner": {
              "x": 20.823,
              "y": 32.179,
              "z": 1.243
            },
            "gtin": "4009077555235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a214d2",
            "leftCorner": {
              "x": 20.823,
              "y": 32.178,
              "z": 1.243
            },
            "rightCorner": {
              "x": 20.925,
              "y": 32.172,
              "z": 1.243
            },
            "gtin": "4009077555020",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546902",
        "height": 1.7667,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fcd8",
            "leftCorner": {
              "x": 19.716,
              "y": 32.222,
              "z": 1.445
            },
            "rightCorner": {
              "x": 19.784,
              "y": 32.218,
              "z": 1.445
            },
            "gtin": "4030300022033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcd9",
            "leftCorner": {
              "x": 19.784,
              "y": 32.218,
              "z": 1.445
            },
            "rightCorner": {
              "x": 19.85,
              "y": 32.215,
              "z": 1.445
            },
            "gtin": "4030300022033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcda",
            "leftCorner": {
              "x": 19.85,
              "y": 32.215,
              "z": 1.445
            },
            "rightCorner": {
              "x": 19.917,
              "y": 32.211,
              "z": 1.445
            },
            "gtin": "4030300022033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcdb",
            "leftCorner": {
              "x": 19.917,
              "y": 32.217,
              "z": 1.445
            },
            "rightCorner": {
              "x": 19.968,
              "y": 32.214,
              "z": 1.445
            },
            "gtin": "4030300022095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcdc",
            "leftCorner": {
              "x": 19.968,
              "y": 32.205,
              "z": 1.445
            },
            "rightCorner": {
              "x": 20.013,
              "y": 32.203,
              "z": 1.445
            },
            "gtin": "4030300022095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcdd",
            "leftCorner": {
              "x": 20.012,
              "y": 32.193,
              "z": 1.445
            },
            "rightCorner": {
              "x": 20.056,
              "y": 32.19,
              "z": 1.445
            },
            "gtin": "7610700607756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcde",
            "leftCorner": {
              "x": 20.056,
              "y": 32.19,
              "z": 1.445
            },
            "rightCorner": {
              "x": 20.102,
              "y": 32.188,
              "z": 1.445
            },
            "gtin": "7610700607756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcdf",
            "leftCorner": {
              "x": 20.103,
              "y": 32.214,
              "z": 1.445
            },
            "rightCorner": {
              "x": 20.167,
              "y": 32.211,
              "z": 1.445
            },
            "gtin": "7610700946541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fce0",
            "leftCorner": {
              "x": 20.167,
              "y": 32.21,
              "z": 1.445
            },
            "rightCorner": {
              "x": 20.234,
              "y": 32.207,
              "z": 1.445
            },
            "gtin": "7610700946442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fce1",
            "leftCorner": {
              "x": 20.234,
              "y": 32.207,
              "z": 1.445
            },
            "rightCorner": {
              "x": 20.292,
              "y": 32.203,
              "z": 1.445
            },
            "gtin": "7610700010105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fce2",
            "leftCorner": {
              "x": 20.293,
              "y": 32.206,
              "z": 1.445
            },
            "rightCorner": {
              "x": 20.336,
              "y": 32.204,
              "z": 1.445
            },
            "gtin": "7610700018545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fce3",
            "leftCorner": {
              "x": 20.336,
              "y": 32.204,
              "z": 1.445
            },
            "rightCorner": {
              "x": 20.379,
              "y": 32.203,
              "z": 1.445
            },
            "gtin": "7610700018545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fce4",
            "leftCorner": {
              "x": 20.378,
              "y": 32.19,
              "z": 1.445
            },
            "rightCorner": {
              "x": 20.429,
              "y": 32.187,
              "z": 1.445
            },
            "gtin": "7610700014134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fce5",
            "leftCorner": {
              "x": 20.429,
              "y": 32.194,
              "z": 1.445
            },
            "rightCorner": {
              "x": 20.497,
              "y": 32.191,
              "z": 1.445
            },
            "gtin": "7610700010822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fce6",
            "leftCorner": {
              "x": 20.497,
              "y": 32.192,
              "z": 1.445
            },
            "rightCorner": {
              "x": 20.569,
              "y": 32.188,
              "z": 1.445
            },
            "gtin": "7610700022764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fce7",
            "leftCorner": {
              "x": 20.568,
              "y": 32.177,
              "z": 1.445
            },
            "rightCorner": {
              "x": 20.6,
              "y": 32.175,
              "z": 1.445
            },
            "gtin": "7610700946053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fce8",
            "leftCorner": {
              "x": 20.6,
              "y": 32.175,
              "z": 1.445
            },
            "rightCorner": {
              "x": 20.632,
              "y": 32.174,
              "z": 1.445
            },
            "gtin": "7610700946053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fce9",
            "leftCorner": {
              "x": 20.632,
              "y": 32.172,
              "z": 1.445
            },
            "rightCorner": {
              "x": 20.688,
              "y": 32.169,
              "z": 1.445
            },
            "gtin": "7610700946398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcea",
            "leftCorner": {
              "x": 20.689,
              "y": 32.185,
              "z": 1.445
            },
            "rightCorner": {
              "x": 20.929,
              "y": 32.172,
              "z": 1.445
            },
            "gtin": "7610700600054",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "93004",
    "rightNeighborShelfId": "93006"
  },
  {
    "id": "93006",
    "name": "93006",
    "x": 20.922,
    "y": 32.117,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.02595,
      "w": 0.99966
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 93
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54690a",
        "height": 0.16247,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fd8a",
            "leftCorner": {
              "x": 20.973,
              "y": 32.16,
              "z": 0.133
            },
            "rightCorner": {
              "x": 21.129,
              "y": 32.152,
              "z": 0.133
            },
            "gtin": "4337185499623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd8b",
            "leftCorner": {
              "x": 21.129,
              "y": 32.152,
              "z": 0.133
            },
            "rightCorner": {
              "x": 21.286,
              "y": 32.145,
              "z": 0.133
            },
            "gtin": "4337185499623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd8c",
            "leftCorner": {
              "x": 21.285,
              "y": 32.13,
              "z": 0.133
            },
            "rightCorner": {
              "x": 21.403,
              "y": 32.123,
              "z": 0.133
            },
            "gtin": "4063367132520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd8d",
            "leftCorner": {
              "x": 21.403,
              "y": 32.123,
              "z": 0.133
            },
            "rightCorner": {
              "x": 21.52,
              "y": 32.117,
              "z": 0.133
            },
            "gtin": "4063367132520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd8e",
            "leftCorner": {
              "x": 21.52,
              "y": 32.117,
              "z": 0.133
            },
            "rightCorner": {
              "x": 21.638,
              "y": 32.11,
              "z": 0.133
            },
            "gtin": "4063367132520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd8f",
            "leftCorner": {
              "x": 21.64,
              "y": 32.153,
              "z": 0.133
            },
            "rightCorner": {
              "x": 21.864,
              "y": 32.142,
              "z": 0.133
            },
            "gtin": "4337185499630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd90",
            "leftCorner": {
              "x": 21.862,
              "y": 32.124,
              "z": 0.133
            },
            "rightCorner": {
              "x": 21.986,
              "y": 32.118,
              "z": 0.133
            },
            "gtin": "4063367214097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd91",
            "leftCorner": {
              "x": 21.986,
              "y": 32.118,
              "z": 0.133
            },
            "rightCorner": {
              "x": 22.109,
              "y": 32.111,
              "z": 0.133
            },
            "gtin": "4063367214097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd92",
            "leftCorner": {
              "x": 22.109,
              "y": 32.117,
              "z": 0.133
            },
            "rightCorner": {
              "x": 22.231,
              "y": 32.111,
              "z": 0.133
            },
            "gtin": "4063367330827",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546909",
        "height": 0.45863,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21607",
            "leftCorner": {
              "x": 20.923,
              "y": 32.144,
              "z": 0.375
            },
            "rightCorner": {
              "x": 21.065,
              "y": 32.136,
              "z": 0.375
            },
            "gtin": "4020400893015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21608",
            "leftCorner": {
              "x": 21.065,
              "y": 32.136,
              "z": 0.375
            },
            "rightCorner": {
              "x": 21.207,
              "y": 32.128,
              "z": 0.375
            },
            "gtin": "4020400893015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21609",
            "leftCorner": {
              "x": 21.207,
              "y": 32.128,
              "z": 0.375
            },
            "rightCorner": {
              "x": 21.348,
              "y": 32.121,
              "z": 0.375
            },
            "gtin": "4020400893015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2160c",
            "leftCorner": {
              "x": 21.35,
              "y": 32.148,
              "z": 0.375
            },
            "rightCorner": {
              "x": 21.553,
              "y": 32.138,
              "z": 0.375
            },
            "gtin": "4020400893022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2160a",
            "leftCorner": {
              "x": 21.554,
              "y": 32.155,
              "z": 0.375
            },
            "rightCorner": {
              "x": 21.864,
              "y": 32.139,
              "z": 0.375
            },
            "gtin": "4020400893039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2160b",
            "leftCorner": {
              "x": 21.864,
              "y": 32.139,
              "z": 0.375
            },
            "rightCorner": {
              "x": 22.174,
              "y": 32.123,
              "z": 0.375
            },
            "gtin": "4020400893039",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546908",
        "height": 0.71312,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21594",
            "leftCorner": {
              "x": 20.957,
              "y": 32.17,
              "z": 0.583
            },
            "rightCorner": {
              "x": 21.087,
              "y": 32.163,
              "z": 0.583
            },
            "gtin": "4020400893114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21595",
            "leftCorner": {
              "x": 21.087,
              "y": 32.163,
              "z": 0.583
            },
            "rightCorner": {
              "x": 21.216,
              "y": 32.156,
              "z": 0.583
            },
            "gtin": "4020400893114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21596",
            "leftCorner": {
              "x": 21.216,
              "y": 32.156,
              "z": 0.583
            },
            "rightCorner": {
              "x": 21.345,
              "y": 32.149,
              "z": 0.583
            },
            "gtin": "4020400893114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21597",
            "leftCorner": {
              "x": 21.345,
              "y": 32.136,
              "z": 0.583
            },
            "rightCorner": {
              "x": 21.472,
              "y": 32.13,
              "z": 0.583
            },
            "gtin": "4020400893046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21598",
            "leftCorner": {
              "x": 21.472,
              "y": 32.13,
              "z": 0.583
            },
            "rightCorner": {
              "x": 21.598,
              "y": 32.123,
              "z": 0.583
            },
            "gtin": "4020400893046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21599",
            "leftCorner": {
              "x": 21.599,
              "y": 32.146,
              "z": 0.583
            },
            "rightCorner": {
              "x": 21.677,
              "y": 32.141,
              "z": 0.583
            },
            "gtin": "4020400697422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2159a",
            "leftCorner": {
              "x": 21.677,
              "y": 32.141,
              "z": 0.583
            },
            "rightCorner": {
              "x": 21.757,
              "y": 32.137,
              "z": 0.583
            },
            "gtin": "4020400697422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2159b",
            "leftCorner": {
              "x": 21.757,
              "y": 32.143,
              "z": 0.583
            },
            "rightCorner": {
              "x": 21.911,
              "y": 32.135,
              "z": 0.583
            },
            "gtin": "4020400697415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2159c",
            "leftCorner": {
              "x": 21.91,
              "y": 32.123,
              "z": 0.583
            },
            "rightCorner": {
              "x": 22.034,
              "y": 32.117,
              "z": 0.583
            },
            "gtin": "4020400697439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2159d",
            "leftCorner": {
              "x": 22.034,
              "y": 32.117,
              "z": 0.583
            },
            "rightCorner": {
              "x": 22.158,
              "y": 32.11,
              "z": 0.583
            },
            "gtin": "4020400697439",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546905",
        "height": 0.96417,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a215d1",
            "leftCorner": {
              "x": 20.922,
              "y": 32.125,
              "z": 0.789
            },
            "rightCorner": {
              "x": 20.994,
              "y": 32.121,
              "z": 0.789
            },
            "gtin": "50357260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215d2",
            "leftCorner": {
              "x": 20.994,
              "y": 32.121,
              "z": 0.789
            },
            "rightCorner": {
              "x": 21.065,
              "y": 32.118,
              "z": 0.789
            },
            "gtin": "50357260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215d3",
            "leftCorner": {
              "x": 21.065,
              "y": 32.118,
              "z": 0.789
            },
            "rightCorner": {
              "x": 21.137,
              "y": 32.114,
              "z": 0.789
            },
            "gtin": "50357260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215d4",
            "leftCorner": {
              "x": 21.137,
              "y": 32.114,
              "z": 0.789
            },
            "rightCorner": {
              "x": 21.208,
              "y": 32.11,
              "z": 0.789
            },
            "gtin": "50357260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215d5",
            "leftCorner": {
              "x": 21.208,
              "y": 32.11,
              "z": 0.789
            },
            "rightCorner": {
              "x": 21.279,
              "y": 32.107,
              "z": 0.789
            },
            "gtin": "50357260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215d8",
            "leftCorner": {
              "x": 21.282,
              "y": 32.145,
              "z": 0.789
            },
            "rightCorner": {
              "x": 21.32,
              "y": 32.143,
              "z": 0.789
            },
            "gtin": "96060636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215d9",
            "leftCorner": {
              "x": 21.32,
              "y": 32.143,
              "z": 0.789
            },
            "rightCorner": {
              "x": 21.358,
              "y": 32.141,
              "z": 0.789
            },
            "gtin": "96060636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215da",
            "leftCorner": {
              "x": 21.358,
              "y": 32.148,
              "z": 0.789
            },
            "rightCorner": {
              "x": 21.466,
              "y": 32.142,
              "z": 0.789
            },
            "gtin": "50357321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215db",
            "leftCorner": {
              "x": 21.466,
              "y": 32.135,
              "z": 0.789
            },
            "rightCorner": {
              "x": 21.515,
              "y": 32.132,
              "z": 0.789
            },
            "gtin": "96130780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215dc",
            "leftCorner": {
              "x": 21.515,
              "y": 32.132,
              "z": 0.789
            },
            "rightCorner": {
              "x": 21.562,
              "y": 32.129,
              "z": 0.789
            },
            "gtin": "96130780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215dd",
            "leftCorner": {
              "x": 21.562,
              "y": 32.129,
              "z": 0.789
            },
            "rightCorner": {
              "x": 21.611,
              "y": 32.127,
              "z": 0.789
            },
            "gtin": "96130780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215de",
            "leftCorner": {
              "x": 21.611,
              "y": 32.127,
              "z": 0.789
            },
            "rightCorner": {
              "x": 21.659,
              "y": 32.125,
              "z": 0.789
            },
            "gtin": "96130780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215df",
            "leftCorner": {
              "x": 21.661,
              "y": 32.141,
              "z": 0.789
            },
            "rightCorner": {
              "x": 21.754,
              "y": 32.135,
              "z": 0.789
            },
            "gtin": "50357581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215e0",
            "leftCorner": {
              "x": 21.754,
              "y": 32.135,
              "z": 0.789
            },
            "rightCorner": {
              "x": 21.848,
              "y": 32.131,
              "z": 0.789
            },
            "gtin": "50357581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215e1",
            "leftCorner": {
              "x": 21.848,
              "y": 32.122,
              "z": 0.789
            },
            "rightCorner": {
              "x": 21.943,
              "y": 32.117,
              "z": 0.789
            },
            "gtin": "50836383",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215e2",
            "leftCorner": {
              "x": 21.944,
              "y": 32.118,
              "z": 0.789
            },
            "rightCorner": {
              "x": 22.055,
              "y": 32.112,
              "z": 0.789
            },
            "gtin": "50357390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215e3",
            "leftCorner": {
              "x": 22.053,
              "y": 32.097,
              "z": 0.789
            },
            "rightCorner": {
              "x": 22.109,
              "y": 32.094,
              "z": 0.789
            },
            "gtin": "50357437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215e4",
            "leftCorner": {
              "x": 22.109,
              "y": 32.094,
              "z": 0.789
            },
            "rightCorner": {
              "x": 22.166,
              "y": 32.092,
              "z": 0.789
            },
            "gtin": "50357437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215e5",
            "leftCorner": {
              "x": 22.166,
              "y": 32.092,
              "z": 0.789
            },
            "rightCorner": {
              "x": 22.222,
              "y": 32.089,
              "z": 0.789
            },
            "gtin": "50357437",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546907",
        "height": 1.1679,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a215f7",
            "leftCorner": {
              "x": 20.922,
              "y": 32.121,
              "z": 0.956
            },
            "rightCorner": {
              "x": 20.995,
              "y": 32.117,
              "z": 0.956
            },
            "gtin": "7610369422189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215f8",
            "leftCorner": {
              "x": 20.995,
              "y": 32.117,
              "z": 0.956
            },
            "rightCorner": {
              "x": 21.068,
              "y": 32.113,
              "z": 0.956
            },
            "gtin": "7610369422189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215fb",
            "leftCorner": {
              "x": 21.069,
              "y": 32.156,
              "z": 0.956
            },
            "rightCorner": {
              "x": 21.124,
              "y": 32.153,
              "z": 0.956
            },
            "gtin": "7610369422219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215fc",
            "leftCorner": {
              "x": 21.124,
              "y": 32.153,
              "z": 0.956
            },
            "rightCorner": {
              "x": 21.18,
              "y": 32.15,
              "z": 0.956
            },
            "gtin": "7610369422219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215fd",
            "leftCorner": {
              "x": 21.18,
              "y": 32.15,
              "z": 0.956
            },
            "rightCorner": {
              "x": 21.235,
              "y": 32.147,
              "z": 0.956
            },
            "gtin": "7610369422219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215fe",
            "leftCorner": {
              "x": 21.235,
              "y": 32.141,
              "z": 0.956
            },
            "rightCorner": {
              "x": 21.299,
              "y": 32.138,
              "z": 0.956
            },
            "gtin": "7610369422202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215ff",
            "leftCorner": {
              "x": 21.299,
              "y": 32.138,
              "z": 0.956
            },
            "rightCorner": {
              "x": 21.364,
              "y": 32.135,
              "z": 0.956
            },
            "gtin": "7610369422202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21600",
            "leftCorner": {
              "x": 21.364,
              "y": 32.141,
              "z": 0.956
            },
            "rightCorner": {
              "x": 21.462,
              "y": 32.136,
              "z": 0.956
            },
            "gtin": "7610369422196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21601",
            "leftCorner": {
              "x": 21.462,
              "y": 32.136,
              "z": 0.956
            },
            "rightCorner": {
              "x": 21.559,
              "y": 32.13,
              "z": 0.956
            },
            "gtin": "7610369422196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21602",
            "leftCorner": {
              "x": 21.559,
              "y": 32.13,
              "z": 0.956
            },
            "rightCorner": {
              "x": 21.657,
              "y": 32.126,
              "z": 0.956
            },
            "gtin": "7610369422196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21603",
            "leftCorner": {
              "x": 21.658,
              "y": 32.137,
              "z": 0.956
            },
            "rightCorner": {
              "x": 21.743,
              "y": 32.133,
              "z": 0.956
            },
            "gtin": "7610369422226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21604",
            "leftCorner": {
              "x": 21.743,
              "y": 32.133,
              "z": 0.956
            },
            "rightCorner": {
              "x": 21.828,
              "y": 32.128,
              "z": 0.956
            },
            "gtin": "7610369422226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21605",
            "leftCorner": {
              "x": 21.828,
              "y": 32.128,
              "z": 0.956
            },
            "rightCorner": {
              "x": 21.915,
              "y": 32.124,
              "z": 0.956
            },
            "gtin": "7610369422226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21606",
            "leftCorner": {
              "x": 21.915,
              "y": 32.124,
              "z": 0.956
            },
            "rightCorner": {
              "x": 22.0,
              "y": 32.119,
              "z": 0.956
            },
            "gtin": "7610369422226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215f9",
            "leftCorner": {
              "x": 22.0,
              "y": 32.115,
              "z": 0.956
            },
            "rightCorner": {
              "x": 22.086,
              "y": 32.111,
              "z": 0.956
            },
            "gtin": "4004363110426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215fa",
            "leftCorner": {
              "x": 22.086,
              "y": 32.111,
              "z": 0.956
            },
            "rightCorner": {
              "x": 22.173,
              "y": 32.106,
              "z": 0.956
            },
            "gtin": "4004363110426",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546906",
        "height": 1.4179,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a215ec",
            "leftCorner": {
              "x": 22.073,
              "y": 32.107,
              "z": 1.16
            },
            "rightCorner": {
              "x": 22.173,
              "y": 32.102,
              "z": 1.16
            },
            "gtin": "7610700015766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215e8",
            "leftCorner": {
              "x": 20.922,
              "y": 32.126,
              "z": 1.16
            },
            "rightCorner": {
              "x": 21.007,
              "y": 32.122,
              "z": 1.16
            },
            "gtin": "7610700947753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215e9",
            "leftCorner": {
              "x": 21.007,
              "y": 32.122,
              "z": 1.16
            },
            "rightCorner": {
              "x": 21.091,
              "y": 32.117,
              "z": 1.16
            },
            "gtin": "7610700947753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215ed",
            "leftCorner": {
              "x": 21.092,
              "y": 32.151,
              "z": 1.16
            },
            "rightCorner": {
              "x": 21.168,
              "y": 32.146,
              "z": 1.16
            },
            "gtin": "7610700945070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215ee",
            "leftCorner": {
              "x": 21.168,
              "y": 32.146,
              "z": 1.16
            },
            "rightCorner": {
              "x": 21.244,
              "y": 32.142,
              "z": 1.16
            },
            "gtin": "7610700945070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215ef",
            "leftCorner": {
              "x": 21.244,
              "y": 32.139,
              "z": 1.16
            },
            "rightCorner": {
              "x": 21.31,
              "y": 32.136,
              "z": 1.16
            },
            "gtin": "7610700945834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215f0",
            "leftCorner": {
              "x": 21.31,
              "y": 32.136,
              "z": 1.16
            },
            "rightCorner": {
              "x": 21.378,
              "y": 32.132,
              "z": 1.16
            },
            "gtin": "7610700945834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215f1",
            "leftCorner": {
              "x": 21.378,
              "y": 32.132,
              "z": 1.16
            },
            "rightCorner": {
              "x": 21.445,
              "y": 32.129,
              "z": 1.16
            },
            "gtin": "7610700945834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215f2",
            "leftCorner": {
              "x": 21.445,
              "y": 32.129,
              "z": 1.16
            },
            "rightCorner": {
              "x": 21.511,
              "y": 32.125,
              "z": 1.16
            },
            "gtin": "7610700945834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215f3",
            "leftCorner": {
              "x": 21.512,
              "y": 32.147,
              "z": 1.16
            },
            "rightCorner": {
              "x": 21.57,
              "y": 32.145,
              "z": 1.16
            },
            "gtin": "7610700623053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215f4",
            "leftCorner": {
              "x": 21.57,
              "y": 32.145,
              "z": 1.16
            },
            "rightCorner": {
              "x": 21.629,
              "y": 32.142,
              "z": 1.16
            },
            "gtin": "7610700623053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215f5",
            "leftCorner": {
              "x": 21.629,
              "y": 32.142,
              "z": 1.16
            },
            "rightCorner": {
              "x": 21.687,
              "y": 32.139,
              "z": 1.16
            },
            "gtin": "7610700623053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215f6",
            "leftCorner": {
              "x": 21.687,
              "y": 32.137,
              "z": 1.16
            },
            "rightCorner": {
              "x": 21.874,
              "y": 32.128,
              "z": 1.16
            },
            "gtin": "7610700011089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215ea",
            "leftCorner": {
              "x": 21.874,
              "y": 32.118,
              "z": 1.16
            },
            "rightCorner": {
              "x": 21.974,
              "y": 32.112,
              "z": 1.16
            },
            "gtin": "7610700015766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215eb",
            "leftCorner": {
              "x": 21.974,
              "y": 32.112,
              "z": 1.16
            },
            "rightCorner": {
              "x": 22.073,
              "y": 32.107,
              "z": 1.16
            },
            "gtin": "7610700015766",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546904",
        "height": 1.7659,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fceb",
            "leftCorner": {
              "x": 20.929,
              "y": 32.164,
              "z": 1.445
            },
            "rightCorner": {
              "x": 21.085,
              "y": 32.156,
              "z": 1.445
            },
            "gtin": "7610700945001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcec",
            "leftCorner": {
              "x": 21.085,
              "y": 32.156,
              "z": 1.445
            },
            "rightCorner": {
              "x": 21.241,
              "y": 32.148,
              "z": 1.445
            },
            "gtin": "7610700945001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fced",
            "leftCorner": {
              "x": 21.241,
              "y": 32.14,
              "z": 1.445
            },
            "rightCorner": {
              "x": 21.277,
              "y": 32.139,
              "z": 1.445
            },
            "gtin": "7610700945087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcee",
            "leftCorner": {
              "x": 21.277,
              "y": 32.139,
              "z": 1.445
            },
            "rightCorner": {
              "x": 21.314,
              "y": 32.137,
              "z": 1.445
            },
            "gtin": "7610700945087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcef",
            "leftCorner": {
              "x": 21.314,
              "y": 32.137,
              "z": 1.445
            },
            "rightCorner": {
              "x": 21.351,
              "y": 32.134,
              "z": 1.445
            },
            "gtin": "7610700945087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcf0",
            "leftCorner": {
              "x": 21.351,
              "y": 32.134,
              "z": 1.445
            },
            "rightCorner": {
              "x": 21.387,
              "y": 32.133,
              "z": 1.445
            },
            "gtin": "7610700945087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcf1",
            "leftCorner": {
              "x": 21.388,
              "y": 32.143,
              "z": 1.445
            },
            "rightCorner": {
              "x": 21.448,
              "y": 32.141,
              "z": 1.445
            },
            "gtin": "7610700945117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcf2",
            "leftCorner": {
              "x": 21.448,
              "y": 32.141,
              "z": 1.445
            },
            "rightCorner": {
              "x": 21.507,
              "y": 32.137,
              "z": 1.445
            },
            "gtin": "7610700945117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcf3",
            "leftCorner": {
              "x": 21.508,
              "y": 32.146,
              "z": 1.445
            },
            "rightCorner": {
              "x": 21.57,
              "y": 32.143,
              "z": 1.445
            },
            "gtin": "7610700018675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcf4",
            "leftCorner": {
              "x": 21.57,
              "y": 32.143,
              "z": 1.445
            },
            "rightCorner": {
              "x": 21.632,
              "y": 32.14,
              "z": 1.445
            },
            "gtin": "7610700018675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcf5",
            "leftCorner": {
              "x": 21.631,
              "y": 32.131,
              "z": 1.445
            },
            "rightCorner": {
              "x": 21.709,
              "y": 32.126,
              "z": 1.445
            },
            "gtin": "7610700014189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcf6",
            "leftCorner": {
              "x": 21.709,
              "y": 32.126,
              "z": 1.445
            },
            "rightCorner": {
              "x": 21.787,
              "y": 32.122,
              "z": 1.445
            },
            "gtin": "7610700014189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcf7",
            "leftCorner": {
              "x": 21.788,
              "y": 32.139,
              "z": 1.445
            },
            "rightCorner": {
              "x": 21.852,
              "y": 32.136,
              "z": 1.445
            },
            "gtin": "7610700017890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcf8",
            "leftCorner": {
              "x": 21.852,
              "y": 32.136,
              "z": 1.445
            },
            "rightCorner": {
              "x": 21.916,
              "y": 32.132,
              "z": 1.445
            },
            "gtin": "7610700017890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcf9",
            "leftCorner": {
              "x": 21.915,
              "y": 32.118,
              "z": 1.445
            },
            "rightCorner": {
              "x": 21.999,
              "y": 32.114,
              "z": 1.445
            },
            "gtin": "7610700946053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcfa",
            "leftCorner": {
              "x": 21.999,
              "y": 32.114,
              "z": 1.445
            },
            "rightCorner": {
              "x": 22.083,
              "y": 32.109,
              "z": 1.445
            },
            "gtin": "7610700946053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcfb",
            "leftCorner": {
              "x": 22.083,
              "y": 32.11,
              "z": 1.445
            },
            "rightCorner": {
              "x": 22.123,
              "y": 32.108,
              "z": 1.445
            },
            "gtin": "7610700022825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcfc",
            "leftCorner": {
              "x": 22.123,
              "y": 32.108,
              "z": 1.445
            },
            "rightCorner": {
              "x": 22.164,
              "y": 32.106,
              "z": 1.445
            },
            "gtin": "7610700022825",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "93005",
    "rightNeighborShelfId": "93008"
  },
  {
    "id": "93008",
    "name": "93008",
    "x": 22.17,
    "y": 32.052,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.02595,
      "w": 0.99966
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 66
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546910",
        "height": 0.16006,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fd93",
            "leftCorner": {
              "x": 22.219,
              "y": 32.103,
              "z": 0.131
            },
            "rightCorner": {
              "x": 22.297,
              "y": 32.1,
              "z": 0.131
            },
            "gtin": "4063367132605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd94",
            "leftCorner": {
              "x": 22.297,
              "y": 32.1,
              "z": 0.131
            },
            "rightCorner": {
              "x": 22.375,
              "y": 32.095,
              "z": 0.131
            },
            "gtin": "4063367132605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd95",
            "leftCorner": {
              "x": 22.376,
              "y": 32.106,
              "z": 0.131
            },
            "rightCorner": {
              "x": 22.51,
              "y": 32.099,
              "z": 0.131
            },
            "gtin": "4063367132582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd96",
            "leftCorner": {
              "x": 22.509,
              "y": 32.081,
              "z": 0.131
            },
            "rightCorner": {
              "x": 22.595,
              "y": 32.077,
              "z": 0.131
            },
            "gtin": "4063367132551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd97",
            "leftCorner": {
              "x": 22.595,
              "y": 32.077,
              "z": 0.131
            },
            "rightCorner": {
              "x": 22.68,
              "y": 32.072,
              "z": 0.131
            },
            "gtin": "4063367132551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd98",
            "leftCorner": {
              "x": 22.68,
              "y": 32.072,
              "z": 0.131
            },
            "rightCorner": {
              "x": 22.766,
              "y": 32.068,
              "z": 0.131
            },
            "gtin": "4063367132551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd99",
            "leftCorner": {
              "x": 22.766,
              "y": 32.078,
              "z": 0.131
            },
            "rightCorner": {
              "x": 22.851,
              "y": 32.074,
              "z": 0.131
            },
            "gtin": "4014400904406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd9a",
            "leftCorner": {
              "x": 22.851,
              "y": 32.074,
              "z": 0.131
            },
            "rightCorner": {
              "x": 22.936,
              "y": 32.069,
              "z": 0.131
            },
            "gtin": "4014400904406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd9b",
            "leftCorner": {
              "x": 22.936,
              "y": 32.069,
              "z": 0.131
            },
            "rightCorner": {
              "x": 23.021,
              "y": 32.065,
              "z": 0.131
            },
            "gtin": "4014400904406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd9c",
            "leftCorner": {
              "x": 23.021,
              "y": 32.068,
              "z": 0.131
            },
            "rightCorner": {
              "x": 23.089,
              "y": 32.065,
              "z": 0.131
            },
            "gtin": "4001686002049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd4a",
            "leftCorner": {
              "x": 23.089,
              "y": 32.063,
              "z": 0.131
            },
            "rightCorner": {
              "x": 23.171,
              "y": 32.059,
              "z": 0.131
            },
            "gtin": "4001686502396",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54690d",
        "height": 0.72219,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2159e",
            "leftCorner": {
              "x": 22.16,
              "y": 32.097,
              "z": 0.591
            },
            "rightCorner": {
              "x": 22.214,
              "y": 32.093,
              "z": 0.591
            },
            "gtin": "4054451250169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2159f",
            "leftCorner": {
              "x": 22.214,
              "y": 32.093,
              "z": 0.591
            },
            "rightCorner": {
              "x": 22.267,
              "y": 32.091,
              "z": 0.591
            },
            "gtin": "4054451250169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215a0",
            "leftCorner": {
              "x": 22.267,
              "y": 32.092,
              "z": 0.591
            },
            "rightCorner": {
              "x": 22.304,
              "y": 32.089,
              "z": 0.591
            },
            "gtin": "4054451250022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215a1",
            "leftCorner": {
              "x": 22.304,
              "y": 32.089,
              "z": 0.591
            },
            "rightCorner": {
              "x": 22.343,
              "y": 32.088,
              "z": 0.591
            },
            "gtin": "4054451250022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215a2",
            "leftCorner": {
              "x": 22.343,
              "y": 32.088,
              "z": 0.591
            },
            "rightCorner": {
              "x": 22.381,
              "y": 32.086,
              "z": 0.591
            },
            "gtin": "4054451250022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215a3",
            "leftCorner": {
              "x": 22.381,
              "y": 32.093,
              "z": 0.591
            },
            "rightCorner": {
              "x": 22.463,
              "y": 32.089,
              "z": 0.591
            },
            "gtin": "4054451250008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215a4",
            "leftCorner": {
              "x": 22.463,
              "y": 32.089,
              "z": 0.591
            },
            "rightCorner": {
              "x": 22.544,
              "y": 32.085,
              "z": 0.591
            },
            "gtin": "4054451250008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215a5",
            "leftCorner": {
              "x": 22.544,
              "y": 32.085,
              "z": 0.591
            },
            "rightCorner": {
              "x": 22.626,
              "y": 32.08,
              "z": 0.591
            },
            "gtin": "4054451250008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215a6",
            "leftCorner": {
              "x": 22.624,
              "y": 32.054,
              "z": 0.591
            },
            "rightCorner": {
              "x": 22.689,
              "y": 32.051,
              "z": 0.591
            },
            "gtin": "4054451250046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215a7",
            "leftCorner": {
              "x": 22.689,
              "y": 32.051,
              "z": 0.591
            },
            "rightCorner": {
              "x": 22.753,
              "y": 32.047,
              "z": 0.591
            },
            "gtin": "4054451250046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215a8",
            "leftCorner": {
              "x": 22.754,
              "y": 32.067,
              "z": 0.591
            },
            "rightCorner": {
              "x": 22.81,
              "y": 32.065,
              "z": 0.591
            },
            "gtin": "4054451250183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215a9",
            "leftCorner": {
              "x": 22.81,
              "y": 32.065,
              "z": 0.591
            },
            "rightCorner": {
              "x": 22.865,
              "y": 32.062,
              "z": 0.591
            },
            "gtin": "4054451250183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215aa",
            "leftCorner": {
              "x": 22.865,
              "y": 32.062,
              "z": 0.591
            },
            "rightCorner": {
              "x": 22.92,
              "y": 32.058,
              "z": 0.591
            },
            "gtin": "4054451250183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215ab",
            "leftCorner": {
              "x": 22.92,
              "y": 32.058,
              "z": 0.591
            },
            "rightCorner": {
              "x": 22.975,
              "y": 32.056,
              "z": 0.591
            },
            "gtin": "4054451250183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21589",
            "leftCorner": {
              "x": 22.976,
              "y": 32.064,
              "z": 0.591
            },
            "rightCorner": {
              "x": 23.074,
              "y": 32.059,
              "z": 0.591
            },
            "gtin": "4054451250060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2158a",
            "leftCorner": {
              "x": 23.074,
              "y": 32.059,
              "z": 0.591
            },
            "rightCorner": {
              "x": 23.171,
              "y": 32.054,
              "z": 0.591
            },
            "gtin": "4054451250060",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54690f",
        "height": 0.9615,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a215e6",
            "leftCorner": {
              "x": 22.212,
              "y": 32.104,
              "z": 0.787
            },
            "rightCorner": {
              "x": 22.479,
              "y": 32.089,
              "z": 0.787
            },
            "gtin": "4014400904277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215e7",
            "leftCorner": {
              "x": 22.479,
              "y": 32.093,
              "z": 0.787
            },
            "rightCorner": {
              "x": 22.759,
              "y": 32.079,
              "z": 0.787
            },
            "gtin": "4063367214080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215d6",
            "leftCorner": {
              "x": 22.758,
              "y": 32.064,
              "z": 0.787
            },
            "rightCorner": {
              "x": 22.965,
              "y": 32.054,
              "z": 0.787
            },
            "gtin": "4001686579176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a215d7",
            "leftCorner": {
              "x": 22.965,
              "y": 32.054,
              "z": 0.787
            },
            "rightCorner": {
              "x": 23.171,
              "y": 32.043,
              "z": 0.787
            },
            "gtin": "4001686579176",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54690b",
        "height": 1.2635,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2160e",
            "leftCorner": {
              "x": 22.2,
              "y": 32.101,
              "z": 1.034
            },
            "rightCorner": {
              "x": 22.266,
              "y": 32.098,
              "z": 1.034
            },
            "gtin": "4017602700722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2160f",
            "leftCorner": {
              "x": 22.266,
              "y": 32.088,
              "z": 1.034
            },
            "rightCorner": {
              "x": 22.313,
              "y": 32.085,
              "z": 1.034
            },
            "gtin": "4009077020122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21610",
            "leftCorner": {
              "x": 22.313,
              "y": 32.085,
              "z": 1.034
            },
            "rightCorner": {
              "x": 22.36,
              "y": 32.083,
              "z": 1.034
            },
            "gtin": "4009077020122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21611",
            "leftCorner": {
              "x": 22.361,
              "y": 32.095,
              "z": 1.034
            },
            "rightCorner": {
              "x": 22.464,
              "y": 32.089,
              "z": 1.034
            },
            "gtin": "4037400409474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21612",
            "leftCorner": {
              "x": 22.464,
              "y": 32.089,
              "z": 1.034
            },
            "rightCorner": {
              "x": 22.568,
              "y": 32.083,
              "z": 1.034
            },
            "gtin": "4037400409474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21613",
            "leftCorner": {
              "x": 22.568,
              "y": 32.073,
              "z": 1.034
            },
            "rightCorner": {
              "x": 22.762,
              "y": 32.063,
              "z": 1.034
            },
            "gtin": "4020400899079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21614",
            "leftCorner": {
              "x": 22.762,
              "y": 32.064,
              "z": 1.034
            },
            "rightCorner": {
              "x": 22.845,
              "y": 32.06,
              "z": 1.034
            },
            "gtin": "4020400001113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21615",
            "leftCorner": {
              "x": 22.845,
              "y": 32.06,
              "z": 1.034
            },
            "rightCorner": {
              "x": 22.926,
              "y": 32.056,
              "z": 1.034
            },
            "gtin": "4020400001113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2160d",
            "leftCorner": {
              "x": 22.927,
              "y": 32.061,
              "z": 1.034
            },
            "rightCorner": {
              "x": 23.171,
              "y": 32.05,
              "z": 1.034
            },
            "gtin": "4020400699075",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54690e",
        "height": 1.5134,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21616",
            "leftCorner": {
              "x": 22.17,
              "y": 32.057,
              "z": 1.238
            },
            "rightCorner": {
              "x": 22.289,
              "y": 32.051,
              "z": 1.238
            },
            "gtin": "90444241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21617",
            "leftCorner": {
              "x": 22.289,
              "y": 32.051,
              "z": 1.238
            },
            "rightCorner": {
              "x": 22.408,
              "y": 32.044,
              "z": 1.238
            },
            "gtin": "90444241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21619",
            "leftCorner": {
              "x": 22.41,
              "y": 32.083,
              "z": 1.238
            },
            "rightCorner": {
              "x": 22.657,
              "y": 32.07,
              "z": 1.238
            },
            "gtin": "90444265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2161a",
            "leftCorner": {
              "x": 22.657,
              "y": 32.071,
              "z": 1.238
            },
            "rightCorner": {
              "x": 22.747,
              "y": 32.066,
              "z": 1.238
            },
            "gtin": "90444289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2161b",
            "leftCorner": {
              "x": 22.747,
              "y": 32.066,
              "z": 1.238
            },
            "rightCorner": {
              "x": 22.837,
              "y": 32.061,
              "z": 1.238
            },
            "gtin": "90444289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2161c",
            "leftCorner": {
              "x": 22.837,
              "y": 32.061,
              "z": 1.238
            },
            "rightCorner": {
              "x": 22.927,
              "y": 32.057,
              "z": 1.238
            },
            "gtin": "90444289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2161d",
            "leftCorner": {
              "x": 22.928,
              "y": 32.063,
              "z": 1.238
            },
            "rightCorner": {
              "x": 22.976,
              "y": 32.061,
              "z": 1.238
            },
            "gtin": "90444272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2161e",
            "leftCorner": {
              "x": 22.976,
              "y": 32.061,
              "z": 1.238
            },
            "rightCorner": {
              "x": 23.023,
              "y": 32.058,
              "z": 1.238
            },
            "gtin": "90444272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21618",
            "leftCorner": {
              "x": 23.023,
              "y": 32.052,
              "z": 1.238
            },
            "rightCorner": {
              "x": 23.171,
              "y": 32.045,
              "z": 1.238
            },
            "gtin": "90444258",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54690c",
        "height": 1.7625,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fcfd",
            "leftCorner": {
              "x": 22.165,
              "y": 32.099,
              "z": 1.442
            },
            "rightCorner": {
              "x": 22.264,
              "y": 32.094,
              "z": 1.442
            },
            "gtin": "4014600207796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcfe",
            "leftCorner": {
              "x": 22.264,
              "y": 32.087,
              "z": 1.442
            },
            "rightCorner": {
              "x": 22.304,
              "y": 32.085,
              "z": 1.442
            },
            "gtin": "4014600207772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fcff",
            "leftCorner": {
              "x": 22.304,
              "y": 32.085,
              "z": 1.442
            },
            "rightCorner": {
              "x": 22.344,
              "y": 32.083,
              "z": 1.442
            },
            "gtin": "4014600207772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd00",
            "leftCorner": {
              "x": 22.345,
              "y": 32.101,
              "z": 1.442
            },
            "rightCorner": {
              "x": 22.383,
              "y": 32.1,
              "z": 1.442
            },
            "gtin": "4014600207758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd01",
            "leftCorner": {
              "x": 22.383,
              "y": 32.1,
              "z": 1.442
            },
            "rightCorner": {
              "x": 22.42,
              "y": 32.097,
              "z": 1.442
            },
            "gtin": "4014600207758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd02",
            "leftCorner": {
              "x": 22.42,
              "y": 32.1,
              "z": 1.442
            },
            "rightCorner": {
              "x": 22.476,
              "y": 32.097,
              "z": 1.442
            },
            "gtin": "4337185932489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd03",
            "leftCorner": {
              "x": 22.476,
              "y": 32.097,
              "z": 1.442
            },
            "rightCorner": {
              "x": 22.532,
              "y": 32.095,
              "z": 1.442
            },
            "gtin": "4337185932489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd04",
            "leftCorner": {
              "x": 22.532,
              "y": 32.095,
              "z": 1.442
            },
            "rightCorner": {
              "x": 22.587,
              "y": 32.092,
              "z": 1.442
            },
            "gtin": "4337185932489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd05",
            "leftCorner": {
              "x": 22.587,
              "y": 32.075,
              "z": 1.442
            },
            "rightCorner": {
              "x": 22.641,
              "y": 32.073,
              "z": 1.442
            },
            "gtin": "4337185932502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd06",
            "leftCorner": {
              "x": 22.641,
              "y": 32.073,
              "z": 1.442
            },
            "rightCorner": {
              "x": 22.696,
              "y": 32.069,
              "z": 1.442
            },
            "gtin": "4337185932502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd07",
            "leftCorner": {
              "x": 22.696,
              "y": 32.069,
              "z": 1.442
            },
            "rightCorner": {
              "x": 22.75,
              "y": 32.066,
              "z": 1.442
            },
            "gtin": "4337185932502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd08",
            "leftCorner": {
              "x": 22.75,
              "y": 32.068,
              "z": 1.442
            },
            "rightCorner": {
              "x": 22.813,
              "y": 32.066,
              "z": 1.442
            },
            "gtin": "4337185932526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd09",
            "leftCorner": {
              "x": 22.813,
              "y": 32.066,
              "z": 1.442
            },
            "rightCorner": {
              "x": 22.876,
              "y": 32.062,
              "z": 1.442
            },
            "gtin": "4337185932526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fd0a",
            "leftCorner": {
              "x": 22.876,
              "y": 32.062,
              "z": 1.442
            },
            "rightCorner": {
              "x": 22.94,
              "y": 32.059,
              "z": 1.442
            },
            "gtin": "4337185932526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc83",
            "leftCorner": {
              "x": 22.941,
              "y": 32.068,
              "z": 1.442
            },
            "rightCorner": {
              "x": 23.017,
              "y": 32.064,
              "z": 1.442
            },
            "gtin": "4337185932441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc84",
            "leftCorner": {
              "x": 23.017,
              "y": 32.064,
              "z": 1.442
            },
            "rightCorner": {
              "x": 23.095,
              "y": 32.059,
              "z": 1.442
            },
            "gtin": "4337185932441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fc85",
            "leftCorner": {
              "x": 23.095,
              "y": 32.059,
              "z": 1.442
            },
            "rightCorner": {
              "x": 23.171,
              "y": 32.056,
              "z": 1.442
            },
            "gtin": "4337185932441",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "93006"
  },
  {
    "id": "93009",
    "name": "93009",
    "x": 23.131,
    "y": 31.148,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.7305,
      "w": 0.68292
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 55
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54691a",
        "height": 0.15562,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e9a9",
            "leftCorner": {
              "x": 23.152,
              "y": 31.146,
              "z": 0.127
            },
            "rightCorner": {
              "x": 23.135,
              "y": 30.9,
              "z": 0.127
            },
            "gtin": "4001686510896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9ac",
            "leftCorner": {
              "x": 23.177,
              "y": 30.898,
              "z": 0.127
            },
            "rightCorner": {
              "x": 23.162,
              "y": 30.679,
              "z": 0.127
            },
            "gtin": "4014400917772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9ad",
            "leftCorner": {
              "x": 23.148,
              "y": 30.68,
              "z": 0.127
            },
            "rightCorner": {
              "x": 23.139,
              "y": 30.533,
              "z": 0.127
            },
            "gtin": "4014400929614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9ae",
            "leftCorner": {
              "x": 23.139,
              "y": 30.533,
              "z": 0.127
            },
            "rightCorner": {
              "x": 23.128,
              "y": 30.386,
              "z": 0.127
            },
            "gtin": "4014400929614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9af",
            "leftCorner": {
              "x": 23.13,
              "y": 30.385,
              "z": 0.127
            },
            "rightCorner": {
              "x": 23.121,
              "y": 30.242,
              "z": 0.127
            },
            "gtin": "4014400918229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9b0",
            "leftCorner": {
              "x": 23.121,
              "y": 30.242,
              "z": 0.127
            },
            "rightCorner": {
              "x": 23.111,
              "y": 30.098,
              "z": 0.127
            },
            "gtin": "4014400918229",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546918",
        "height": 0.70922,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21627",
            "leftCorner": {
              "x": 23.197,
              "y": 31.101,
              "z": 0.58
            },
            "rightCorner": {
              "x": 23.192,
              "y": 31.018,
              "z": 0.58
            },
            "gtin": "4014400932560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21628",
            "leftCorner": {
              "x": 23.192,
              "y": 31.018,
              "z": 0.58
            },
            "rightCorner": {
              "x": 23.186,
              "y": 30.935,
              "z": 0.58
            },
            "gtin": "4014400932560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21629",
            "leftCorner": {
              "x": 23.18,
              "y": 30.935,
              "z": 0.58
            },
            "rightCorner": {
              "x": 23.175,
              "y": 30.845,
              "z": 0.58
            },
            "gtin": "4014400926293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2162a",
            "leftCorner": {
              "x": 23.175,
              "y": 30.845,
              "z": 0.58
            },
            "rightCorner": {
              "x": 23.169,
              "y": 30.754,
              "z": 0.58
            },
            "gtin": "4014400926293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2162b",
            "leftCorner": {
              "x": 23.169,
              "y": 30.754,
              "z": 0.58
            },
            "rightCorner": {
              "x": 23.162,
              "y": 30.663,
              "z": 0.58
            },
            "gtin": "4014400926293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2162c",
            "leftCorner": {
              "x": 23.168,
              "y": 30.663,
              "z": 0.58
            },
            "rightCorner": {
              "x": 23.16,
              "y": 30.534,
              "z": 0.58
            },
            "gtin": "4014400933147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2162d",
            "leftCorner": {
              "x": 23.16,
              "y": 30.534,
              "z": 0.58
            },
            "rightCorner": {
              "x": 23.15,
              "y": 30.404,
              "z": 0.58
            },
            "gtin": "4014400933147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21623",
            "leftCorner": {
              "x": 23.15,
              "y": 30.404,
              "z": 0.58
            },
            "rightCorner": {
              "x": 23.141,
              "y": 30.275,
              "z": 0.58
            },
            "gtin": "4014600208090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21624",
            "leftCorner": {
              "x": 23.141,
              "y": 30.275,
              "z": 0.58
            },
            "rightCorner": {
              "x": 23.133,
              "y": 30.145,
              "z": 0.58
            },
            "gtin": "4014600208090",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546919",
        "height": 1.0102,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2164a",
            "leftCorner": {
              "x": 23.151,
              "y": 31.146,
              "z": 0.827
            },
            "rightCorner": {
              "x": 23.145,
              "y": 31.06,
              "z": 0.827
            },
            "gtin": "4014400928532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2164b",
            "leftCorner": {
              "x": 23.145,
              "y": 31.06,
              "z": 0.827
            },
            "rightCorner": {
              "x": 23.139,
              "y": 30.974,
              "z": 0.827
            },
            "gtin": "4014400928532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2164e",
            "leftCorner": {
              "x": 23.171,
              "y": 30.972,
              "z": 0.827
            },
            "rightCorner": {
              "x": 23.161,
              "y": 30.82,
              "z": 0.827
            },
            "gtin": "4014400937008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2164f",
            "leftCorner": {
              "x": 23.165,
              "y": 30.82,
              "z": 0.827
            },
            "rightCorner": {
              "x": 23.158,
              "y": 30.703,
              "z": 0.827
            },
            "gtin": "4014400926545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21650",
            "leftCorner": {
              "x": 23.158,
              "y": 30.703,
              "z": 0.827
            },
            "rightCorner": {
              "x": 23.149,
              "y": 30.587,
              "z": 0.827
            },
            "gtin": "4014400926545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21651",
            "leftCorner": {
              "x": 23.154,
              "y": 30.586,
              "z": 0.827
            },
            "rightCorner": {
              "x": 23.148,
              "y": 30.486,
              "z": 0.827
            },
            "gtin": "4250231162480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21652",
            "leftCorner": {
              "x": 23.148,
              "y": 30.486,
              "z": 0.827
            },
            "rightCorner": {
              "x": 23.14,
              "y": 30.386,
              "z": 0.827
            },
            "gtin": "4250231162480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21653",
            "leftCorner": {
              "x": 23.131,
              "y": 30.386,
              "z": 0.827
            },
            "rightCorner": {
              "x": 23.126,
              "y": 30.312,
              "z": 0.827
            },
            "gtin": "4000607577208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2164c",
            "leftCorner": {
              "x": 23.129,
              "y": 30.311,
              "z": 0.827
            },
            "rightCorner": {
              "x": 23.124,
              "y": 30.229,
              "z": 0.827
            },
            "gtin": "4000607577000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2164d",
            "leftCorner": {
              "x": 23.124,
              "y": 30.229,
              "z": 0.827
            },
            "rightCorner": {
              "x": 23.119,
              "y": 30.146,
              "z": 0.827
            },
            "gtin": "4000607577000",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546917",
        "height": 1.2608,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2163f",
            "leftCorner": {
              "x": 23.157,
              "y": 31.145,
              "z": 1.032
            },
            "rightCorner": {
              "x": 23.151,
              "y": 31.067,
              "z": 1.032
            },
            "gtin": "4014400926309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21640",
            "leftCorner": {
              "x": 23.151,
              "y": 31.067,
              "z": 1.032
            },
            "rightCorner": {
              "x": 23.146,
              "y": 30.989,
              "z": 1.032
            },
            "gtin": "4014400926309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21641",
            "leftCorner": {
              "x": 23.146,
              "y": 30.989,
              "z": 1.032
            },
            "rightCorner": {
              "x": 23.141,
              "y": 30.91,
              "z": 1.032
            },
            "gtin": "4014400926309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21646",
            "leftCorner": {
              "x": 23.178,
              "y": 30.907,
              "z": 1.032
            },
            "rightCorner": {
              "x": 23.169,
              "y": 30.777,
              "z": 1.032
            },
            "gtin": "4014400926279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21647",
            "leftCorner": {
              "x": 23.169,
              "y": 30.777,
              "z": 1.032
            },
            "rightCorner": {
              "x": 23.16,
              "y": 30.646,
              "z": 1.032
            },
            "gtin": "4014400926279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21648",
            "leftCorner": {
              "x": 23.163,
              "y": 30.646,
              "z": 1.032
            },
            "rightCorner": {
              "x": 23.156,
              "y": 30.556,
              "z": 1.032
            },
            "gtin": "4000607533204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21649",
            "leftCorner": {
              "x": 23.148,
              "y": 30.557,
              "z": 1.032
            },
            "rightCorner": {
              "x": 23.135,
              "y": 30.36,
              "z": 1.032
            },
            "gtin": "4000607562105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21642",
            "leftCorner": {
              "x": 23.136,
              "y": 30.36,
              "z": 1.032
            },
            "rightCorner": {
              "x": 23.133,
              "y": 30.306,
              "z": 1.032
            },
            "gtin": "4000607855108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21643",
            "leftCorner": {
              "x": 23.133,
              "y": 30.306,
              "z": 1.032
            },
            "rightCorner": {
              "x": 23.13,
              "y": 30.253,
              "z": 1.032
            },
            "gtin": "4000607855108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21644",
            "leftCorner": {
              "x": 23.13,
              "y": 30.253,
              "z": 1.032
            },
            "rightCorner": {
              "x": 23.125,
              "y": 30.199,
              "z": 1.032
            },
            "gtin": "4000607855108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21645",
            "leftCorner": {
              "x": 23.125,
              "y": 30.199,
              "z": 1.032
            },
            "rightCorner": {
              "x": 23.122,
              "y": 30.146,
              "z": 1.032
            },
            "gtin": "4000607855108",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546916",
        "height": 1.5104,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21636",
            "leftCorner": {
              "x": 23.152,
              "y": 31.146,
              "z": 1.236
            },
            "rightCorner": {
              "x": 23.146,
              "y": 31.073,
              "z": 1.236
            },
            "gtin": "87108729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21637",
            "leftCorner": {
              "x": 23.146,
              "y": 31.073,
              "z": 1.236
            },
            "rightCorner": {
              "x": 23.141,
              "y": 30.999,
              "z": 1.236
            },
            "gtin": "87108729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21639",
            "leftCorner": {
              "x": 23.181,
              "y": 30.996,
              "z": 1.236
            },
            "rightCorner": {
              "x": 23.171,
              "y": 30.851,
              "z": 1.236
            },
            "gtin": "87108675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2163a",
            "leftCorner": {
              "x": 23.174,
              "y": 30.851,
              "z": 1.236
            },
            "rightCorner": {
              "x": 23.169,
              "y": 30.765,
              "z": 1.236
            },
            "gtin": "87108743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2163b",
            "leftCorner": {
              "x": 23.169,
              "y": 30.765,
              "z": 1.236
            },
            "rightCorner": {
              "x": 23.163,
              "y": 30.679,
              "z": 1.236
            },
            "gtin": "87108743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2163c",
            "leftCorner": {
              "x": 23.164,
              "y": 30.679,
              "z": 1.236
            },
            "rightCorner": {
              "x": 23.151,
              "y": 30.496,
              "z": 1.236
            },
            "gtin": "8723400795780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2163d",
            "leftCorner": {
              "x": 23.147,
              "y": 30.498,
              "z": 1.236
            },
            "rightCorner": {
              "x": 23.141,
              "y": 30.405,
              "z": 1.236
            },
            "gtin": "8723400758518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2163e",
            "leftCorner": {
              "x": 23.128,
              "y": 30.406,
              "z": 1.236
            },
            "rightCorner": {
              "x": 23.122,
              "y": 30.3,
              "z": 1.236
            },
            "gtin": "8723400769828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21638",
            "leftCorner": {
              "x": 23.129,
              "y": 30.299,
              "z": 1.236
            },
            "rightCorner": {
              "x": 23.119,
              "y": 30.146,
              "z": 1.236
            },
            "gtin": "8723400829751",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546915",
        "height": 1.7598,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ea20",
            "leftCorner": {
              "x": 23.197,
              "y": 31.149,
              "z": 1.44
            },
            "rightCorner": {
              "x": 23.191,
              "y": 31.072,
              "z": 1.44
            },
            "gtin": "4009900546089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea21",
            "leftCorner": {
              "x": 23.191,
              "y": 31.072,
              "z": 1.44
            },
            "rightCorner": {
              "x": 23.186,
              "y": 30.994,
              "z": 1.44
            },
            "gtin": "4009900546089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea22",
            "leftCorner": {
              "x": 23.187,
              "y": 30.994,
              "z": 1.44
            },
            "rightCorner": {
              "x": 23.181,
              "y": 30.904,
              "z": 1.44
            },
            "gtin": "4063367397394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea23",
            "leftCorner": {
              "x": 23.181,
              "y": 30.904,
              "z": 1.44
            },
            "rightCorner": {
              "x": 23.175,
              "y": 30.815,
              "z": 1.44
            },
            "gtin": "4063367397394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea24",
            "leftCorner": {
              "x": 23.175,
              "y": 30.815,
              "z": 1.44
            },
            "rightCorner": {
              "x": 23.169,
              "y": 30.725,
              "z": 1.44
            },
            "gtin": "4063367397394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea25",
            "leftCorner": {
              "x": 23.162,
              "y": 30.725,
              "z": 1.44
            },
            "rightCorner": {
              "x": 23.152,
              "y": 30.582,
              "z": 1.44
            },
            "gtin": "4003840008324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea26",
            "leftCorner": {
              "x": 23.152,
              "y": 30.582,
              "z": 1.44
            },
            "rightCorner": {
              "x": 23.142,
              "y": 30.437,
              "z": 1.44
            },
            "gtin": "4003840008324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea27",
            "leftCorner": {
              "x": 23.145,
              "y": 30.437,
              "z": 1.44
            },
            "rightCorner": {
              "x": 23.14,
              "y": 30.349,
              "z": 1.44
            },
            "gtin": "4003840008317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea28",
            "leftCorner": {
              "x": 23.14,
              "y": 30.349,
              "z": 1.44
            },
            "rightCorner": {
              "x": 23.134,
              "y": 30.261,
              "z": 1.44
            },
            "gtin": "4003840008317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea29",
            "leftCorner": {
              "x": 23.134,
              "y": 30.261,
              "z": 1.44
            },
            "rightCorner": {
              "x": 23.128,
              "y": 30.173,
              "z": 1.44
            },
            "gtin": "4003840008317",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ddeda",
    "rightNeighborShelfId": "9300a"
  },
  {
    "id": "9300a",
    "name": "9300a",
    "x": 23.068,
    "y": 30.153,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73645,
      "w": 0.67649
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 46
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54691c",
        "height": 0.15668,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e9b1",
            "leftCorner": {
              "x": 23.094,
              "y": 30.099,
              "z": 0.128
            },
            "rightCorner": {
              "x": 23.083,
              "y": 29.976,
              "z": 0.128
            },
            "gtin": "4014400917789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9b2",
            "leftCorner": {
              "x": 23.083,
              "y": 29.976,
              "z": 0.128
            },
            "rightCorner": {
              "x": 23.072,
              "y": 29.851,
              "z": 0.128
            },
            "gtin": "4014400917789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9b3",
            "leftCorner": {
              "x": 23.072,
              "y": 29.851,
              "z": 0.128
            },
            "rightCorner": {
              "x": 23.061,
              "y": 29.727,
              "z": 0.128
            },
            "gtin": "4014400917789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9b4",
            "leftCorner": {
              "x": 23.068,
              "y": 29.726,
              "z": 0.128
            },
            "rightCorner": {
              "x": 23.049,
              "y": 29.499,
              "z": 0.128
            },
            "gtin": "4014400930009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9b5",
            "leftCorner": {
              "x": 23.044,
              "y": 29.499,
              "z": 0.128
            },
            "rightCorner": {
              "x": 23.017,
              "y": 29.174,
              "z": 0.128
            },
            "gtin": "4014400904307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9b6",
            "leftCorner": {
              "x": 23.005,
              "y": 29.176,
              "z": 0.128
            },
            "rightCorner": {
              "x": 22.979,
              "y": 28.876,
              "z": 0.128
            },
            "gtin": "4063367214097",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54691d",
        "height": 0.80254,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21660",
            "leftCorner": {
              "x": 23.073,
              "y": 30.152,
              "z": 0.657
            },
            "rightCorner": {
              "x": 23.046,
              "y": 29.842,
              "z": 0.657
            },
            "gtin": "4014400904390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21664",
            "leftCorner": {
              "x": 23.089,
              "y": 29.839,
              "z": 0.657
            },
            "rightCorner": {
              "x": 23.077,
              "y": 29.688,
              "z": 0.657
            },
            "gtin": "4014400904376",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21665",
            "leftCorner": {
              "x": 23.077,
              "y": 29.688,
              "z": 0.657
            },
            "rightCorner": {
              "x": 23.064,
              "y": 29.538,
              "z": 0.657
            },
            "gtin": "4014400904376",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21666",
            "leftCorner": {
              "x": 23.048,
              "y": 29.538,
              "z": 0.657
            },
            "rightCorner": {
              "x": 23.016,
              "y": 29.157,
              "z": 0.657
            },
            "gtin": "4014400904321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21661",
            "leftCorner": {
              "x": 23.025,
              "y": 29.157,
              "z": 0.657
            },
            "rightCorner": {
              "x": 23.017,
              "y": 29.073,
              "z": 0.657
            },
            "gtin": "4063367132582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21662",
            "leftCorner": {
              "x": 23.017,
              "y": 29.073,
              "z": 0.657
            },
            "rightCorner": {
              "x": 23.01,
              "y": 28.988,
              "z": 0.657
            },
            "gtin": "4063367132582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21663",
            "leftCorner": {
              "x": 23.01,
              "y": 28.988,
              "z": 0.657
            },
            "rightCorner": {
              "x": 23.003,
              "y": 28.904,
              "z": 0.657
            },
            "gtin": "4063367132582",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546920",
        "height": 1.1657,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21667",
            "leftCorner": {
              "x": 23.071,
              "y": 30.152,
              "z": 0.954
            },
            "rightCorner": {
              "x": 23.043,
              "y": 29.816,
              "z": 0.954
            },
            "gtin": "4014400904369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21668",
            "leftCorner": {
              "x": 23.043,
              "y": 29.816,
              "z": 0.954
            },
            "rightCorner": {
              "x": 23.014,
              "y": 29.48,
              "z": 0.954
            },
            "gtin": "4014400904369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2166a",
            "leftCorner": {
              "x": 23.054,
              "y": 29.477,
              "z": 0.954
            },
            "rightCorner": {
              "x": 23.028,
              "y": 29.177,
              "z": 0.954
            },
            "gtin": "4063367008955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21669",
            "leftCorner": {
              "x": 23.031,
              "y": 29.176,
              "z": 0.954
            },
            "rightCorner": {
              "x": 23.008,
              "y": 28.903,
              "z": 0.954
            },
            "gtin": "4337185520051",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54691b",
        "height": 1.4582,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21654",
            "leftCorner": {
              "x": 23.082,
              "y": 30.151,
              "z": 1.193
            },
            "rightCorner": {
              "x": 23.078,
              "y": 30.108,
              "z": 1.193
            },
            "gtin": "4004363210423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21655",
            "leftCorner": {
              "x": 23.078,
              "y": 30.108,
              "z": 1.193
            },
            "rightCorner": {
              "x": 23.074,
              "y": 30.064,
              "z": 1.193
            },
            "gtin": "4004363210423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21656",
            "leftCorner": {
              "x": 23.074,
              "y": 30.064,
              "z": 1.193
            },
            "rightCorner": {
              "x": 23.071,
              "y": 30.019,
              "z": 1.193
            },
            "gtin": "4004363210423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21659",
            "leftCorner": {
              "x": 23.108,
              "y": 30.016,
              "z": 1.193
            },
            "rightCorner": {
              "x": 23.099,
              "y": 29.905,
              "z": 1.193
            },
            "gtin": "4004363110426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2165a",
            "leftCorner": {
              "x": 23.099,
              "y": 29.905,
              "z": 1.193
            },
            "rightCorner": {
              "x": 23.09,
              "y": 29.795,
              "z": 1.193
            },
            "gtin": "4004363110426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2165b",
            "leftCorner": {
              "x": 23.088,
              "y": 29.795,
              "z": 1.193
            },
            "rightCorner": {
              "x": 23.08,
              "y": 29.704,
              "z": 1.193
            },
            "gtin": "4014522141703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2165c",
            "leftCorner": {
              "x": 23.08,
              "y": 29.704,
              "z": 1.193
            },
            "rightCorner": {
              "x": 23.072,
              "y": 29.613,
              "z": 1.193
            },
            "gtin": "4014522141703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2165d",
            "leftCorner": {
              "x": 23.072,
              "y": 29.613,
              "z": 1.193
            },
            "rightCorner": {
              "x": 23.065,
              "y": 29.523,
              "z": 1.193
            },
            "gtin": "4014522141703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2165e",
            "leftCorner": {
              "x": 23.06,
              "y": 29.523,
              "z": 1.193
            },
            "rightCorner": {
              "x": 23.045,
              "y": 29.357,
              "z": 1.193
            },
            "gtin": "4014600208236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2165f",
            "leftCorner": {
              "x": 23.045,
              "y": 29.357,
              "z": 1.193
            },
            "rightCorner": {
              "x": 23.031,
              "y": 29.19,
              "z": 1.193
            },
            "gtin": "4014600208236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21657",
            "leftCorner": {
              "x": 23.024,
              "y": 29.191,
              "z": 1.193
            },
            "rightCorner": {
              "x": 23.011,
              "y": 29.047,
              "z": 1.193
            },
            "gtin": "4014600208618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21658",
            "leftCorner": {
              "x": 23.011,
              "y": 29.047,
              "z": 1.193
            },
            "rightCorner": {
              "x": 22.999,
              "y": 28.904,
              "z": 1.193
            },
            "gtin": "4014600208618",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54691e",
        "height": 1.756,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ea2a",
            "leftCorner": {
              "x": 23.129,
              "y": 30.176,
              "z": 1.437
            },
            "rightCorner": {
              "x": 23.124,
              "y": 30.117,
              "z": 1.437
            },
            "gtin": "4003840008188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea2b",
            "leftCorner": {
              "x": 23.124,
              "y": 30.117,
              "z": 1.437
            },
            "rightCorner": {
              "x": 23.119,
              "y": 30.058,
              "z": 1.437
            },
            "gtin": "4003840008188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea2c",
            "leftCorner": {
              "x": 23.119,
              "y": 30.058,
              "z": 1.437
            },
            "rightCorner": {
              "x": 23.113,
              "y": 29.999,
              "z": 1.437
            },
            "gtin": "4003840008188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea2d",
            "leftCorner": {
              "x": 23.117,
              "y": 29.999,
              "z": 1.437
            },
            "rightCorner": {
              "x": 23.111,
              "y": 29.929,
              "z": 1.437
            },
            "gtin": "4003840008751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea2e",
            "leftCorner": {
              "x": 23.111,
              "y": 29.929,
              "z": 1.437
            },
            "rightCorner": {
              "x": 23.105,
              "y": 29.859,
              "z": 1.437
            },
            "gtin": "4003840008751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea2f",
            "leftCorner": {
              "x": 23.091,
              "y": 29.86,
              "z": 1.437
            },
            "rightCorner": {
              "x": 23.085,
              "y": 29.789,
              "z": 1.437
            },
            "gtin": "4003840008874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea30",
            "leftCorner": {
              "x": 23.085,
              "y": 29.789,
              "z": 1.437
            },
            "rightCorner": {
              "x": 23.079,
              "y": 29.718,
              "z": 1.437
            },
            "gtin": "4003840008874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea31",
            "leftCorner": {
              "x": 23.084,
              "y": 29.718,
              "z": 1.437
            },
            "rightCorner": {
              "x": 23.078,
              "y": 29.65,
              "z": 1.437
            },
            "gtin": "4003840008843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea32",
            "leftCorner": {
              "x": 23.078,
              "y": 29.65,
              "z": 1.437
            },
            "rightCorner": {
              "x": 23.072,
              "y": 29.584,
              "z": 1.437
            },
            "gtin": "4003840008843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea33",
            "leftCorner": {
              "x": 23.072,
              "y": 29.584,
              "z": 1.437
            },
            "rightCorner": {
              "x": 23.066,
              "y": 29.518,
              "z": 1.437
            },
            "gtin": "4003840008843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea34",
            "leftCorner": {
              "x": 23.066,
              "y": 29.518,
              "z": 1.437
            },
            "rightCorner": {
              "x": 23.061,
              "y": 29.451,
              "z": 1.437
            },
            "gtin": "4003840008843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea35",
            "leftCorner": {
              "x": 23.05,
              "y": 29.452,
              "z": 1.437
            },
            "rightCorner": {
              "x": 23.044,
              "y": 29.379,
              "z": 1.437
            },
            "gtin": "4100250006565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea36",
            "leftCorner": {
              "x": 23.044,
              "y": 29.379,
              "z": 1.437
            },
            "rightCorner": {
              "x": 23.038,
              "y": 29.305,
              "z": 1.437
            },
            "gtin": "4100250006565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea37",
            "leftCorner": {
              "x": 23.038,
              "y": 29.305,
              "z": 1.437
            },
            "rightCorner": {
              "x": 23.031,
              "y": 29.233,
              "z": 1.437
            },
            "gtin": "4100250006565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea38",
            "leftCorner": {
              "x": 23.022,
              "y": 29.233,
              "z": 1.437
            },
            "rightCorner": {
              "x": 23.013,
              "y": 29.124,
              "z": 1.437
            },
            "gtin": "4100250006541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea39",
            "leftCorner": {
              "x": 23.013,
              "y": 29.124,
              "z": 1.437
            },
            "rightCorner": {
              "x": 23.004,
              "y": 29.014,
              "z": 1.437
            },
            "gtin": "4100250006541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea3a",
            "leftCorner": {
              "x": 23.004,
              "y": 29.014,
              "z": 1.437
            },
            "rightCorner": {
              "x": 22.995,
              "y": 28.905,
              "z": 1.437
            },
            "gtin": "4100250006541",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "93009",
    "rightNeighborShelfId": "9300b"
  },
  {
    "id": "9300b",
    "name": "9300b",
    "x": 22.963,
    "y": 28.907,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73645,
      "w": 0.67649
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 52
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546926",
        "height": 0.14798,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e9b7",
            "leftCorner": {
              "x": 22.999,
              "y": 28.874,
              "z": 0.121
            },
            "rightCorner": {
              "x": 22.964,
              "y": 28.468,
              "z": 0.121
            },
            "gtin": "4337185467172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9b8",
            "leftCorner": {
              "x": 22.961,
              "y": 28.468,
              "z": 0.121
            },
            "rightCorner": {
              "x": 22.94,
              "y": 28.226,
              "z": 0.121
            },
            "gtin": "8002594001229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9b9",
            "leftCorner": {
              "x": 22.953,
              "y": 28.225,
              "z": 0.121
            },
            "rightCorner": {
              "x": 22.94,
              "y": 28.072,
              "z": 0.121
            },
            "gtin": "8002594002073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9ba",
            "leftCorner": {
              "x": 22.94,
              "y": 28.072,
              "z": 0.121
            },
            "rightCorner": {
              "x": 22.927,
              "y": 27.919,
              "z": 0.121
            },
            "gtin": "8002594002073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9bb",
            "leftCorner": {
              "x": 22.933,
              "y": 27.919,
              "z": 0.121
            },
            "rightCorner": {
              "x": 22.905,
              "y": 27.59,
              "z": 0.121
            },
            "gtin": "4337185719493",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546923",
        "height": 0.49795,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e9da",
            "leftCorner": {
              "x": 22.978,
              "y": 28.906,
              "z": 0.407
            },
            "rightCorner": {
              "x": 22.959,
              "y": 28.689,
              "z": 0.407
            },
            "gtin": "4014400924008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9db",
            "leftCorner": {
              "x": 22.959,
              "y": 28.689,
              "z": 0.407
            },
            "rightCorner": {
              "x": 22.941,
              "y": 28.472,
              "z": 0.407
            },
            "gtin": "4014400924008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9dc",
            "leftCorner": {
              "x": 22.941,
              "y": 28.472,
              "z": 0.407
            },
            "rightCorner": {
              "x": 22.922,
              "y": 28.254,
              "z": 0.407
            },
            "gtin": "4014400924008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9df",
            "leftCorner": {
              "x": 22.963,
              "y": 28.251,
              "z": 0.407
            },
            "rightCorner": {
              "x": 22.941,
              "y": 27.988,
              "z": 0.407
            },
            "gtin": "4014400935431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9e0",
            "leftCorner": {
              "x": 22.947,
              "y": 27.987,
              "z": 0.407
            },
            "rightCorner": {
              "x": 22.916,
              "y": 27.613,
              "z": 0.407
            },
            "gtin": "4014400932485",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546922",
        "height": 0.85589,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2166b",
            "leftCorner": {
              "x": 22.977,
              "y": 28.906,
              "z": 0.7
            },
            "rightCorner": {
              "x": 22.949,
              "y": 28.589,
              "z": 0.7
            },
            "gtin": "4014400908930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2166d",
            "leftCorner": {
              "x": 22.993,
              "y": 28.585,
              "z": 0.7
            },
            "rightCorner": {
              "x": 22.983,
              "y": 28.458,
              "z": 0.7
            },
            "gtin": "4014400932768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2166e",
            "leftCorner": {
              "x": 22.983,
              "y": 28.458,
              "z": 0.7
            },
            "rightCorner": {
              "x": 22.972,
              "y": 28.332,
              "z": 0.7
            },
            "gtin": "4014400932768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2166f",
            "leftCorner": {
              "x": 22.971,
              "y": 28.332,
              "z": 0.7
            },
            "rightCorner": {
              "x": 22.957,
              "y": 28.157,
              "z": 0.7
            },
            "gtin": "4014400925357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21670",
            "leftCorner": {
              "x": 22.957,
              "y": 28.157,
              "z": 0.7
            },
            "rightCorner": {
              "x": 22.942,
              "y": 27.981,
              "z": 0.7
            },
            "gtin": "4014400925357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21671",
            "leftCorner": {
              "x": 22.942,
              "y": 27.981,
              "z": 0.7
            },
            "rightCorner": {
              "x": 22.929,
              "y": 27.828,
              "z": 0.7
            },
            "gtin": "4014400909906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2166c",
            "leftCorner": {
              "x": 22.926,
              "y": 27.829,
              "z": 0.7
            },
            "rightCorner": {
              "x": 22.911,
              "y": 27.657,
              "z": 0.7
            },
            "gtin": "4014400925944",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546924",
        "height": 1.2025,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21672",
            "leftCorner": {
              "x": 22.972,
              "y": 28.907,
              "z": 0.984
            },
            "rightCorner": {
              "x": 22.962,
              "y": 28.797,
              "z": 0.984
            },
            "gtin": "4014400927597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21673",
            "leftCorner": {
              "x": 22.962,
              "y": 28.797,
              "z": 0.984
            },
            "rightCorner": {
              "x": 22.953,
              "y": 28.685,
              "z": 0.984
            },
            "gtin": "4014400927597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21674",
            "leftCorner": {
              "x": 22.953,
              "y": 28.685,
              "z": 0.984
            },
            "rightCorner": {
              "x": 22.944,
              "y": 28.575,
              "z": 0.984
            },
            "gtin": "4014400927597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21677",
            "leftCorner": {
              "x": 22.981,
              "y": 28.573,
              "z": 0.984
            },
            "rightCorner": {
              "x": 22.972,
              "y": 28.465,
              "z": 0.984
            },
            "gtin": "4014400914993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21678",
            "leftCorner": {
              "x": 22.972,
              "y": 28.465,
              "z": 0.984
            },
            "rightCorner": {
              "x": 22.962,
              "y": 28.356,
              "z": 0.984
            },
            "gtin": "4014400914993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21679",
            "leftCorner": {
              "x": 22.962,
              "y": 28.356,
              "z": 0.984
            },
            "rightCorner": {
              "x": 22.953,
              "y": 28.248,
              "z": 0.984
            },
            "gtin": "4014400914993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2167a",
            "leftCorner": {
              "x": 22.961,
              "y": 28.247,
              "z": 0.984
            },
            "rightCorner": {
              "x": 22.95,
              "y": 28.108,
              "z": 0.984
            },
            "gtin": "4014400927573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2167b",
            "leftCorner": {
              "x": 22.95,
              "y": 28.108,
              "z": 0.984
            },
            "rightCorner": {
              "x": 22.937,
              "y": 27.968,
              "z": 0.984
            },
            "gtin": "4014400927573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2167c",
            "leftCorner": {
              "x": 22.937,
              "y": 27.968,
              "z": 0.984
            },
            "rightCorner": {
              "x": 22.926,
              "y": 27.829,
              "z": 0.984
            },
            "gtin": "4014400927573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21675",
            "leftCorner": {
              "x": 22.919,
              "y": 27.829,
              "z": 0.984
            },
            "rightCorner": {
              "x": 22.912,
              "y": 27.744,
              "z": 0.984
            },
            "gtin": "4014400935882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21676",
            "leftCorner": {
              "x": 22.912,
              "y": 27.744,
              "z": 0.984
            },
            "rightCorner": {
              "x": 22.904,
              "y": 27.657,
              "z": 0.984
            },
            "gtin": "4014400935882",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546925",
        "height": 1.5123,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e9ea",
            "leftCorner": {
              "x": 22.971,
              "y": 28.907,
              "z": 1.237
            },
            "rightCorner": {
              "x": 22.954,
              "y": 28.712,
              "z": 1.237
            },
            "gtin": "40144993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9ec",
            "leftCorner": {
              "x": 22.992,
              "y": 28.71,
              "z": 1.237
            },
            "rightCorner": {
              "x": 22.981,
              "y": 28.578,
              "z": 1.237
            },
            "gtin": "4009703000313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9ed",
            "leftCorner": {
              "x": 22.981,
              "y": 28.578,
              "z": 1.237
            },
            "rightCorner": {
              "x": 22.97,
              "y": 28.446,
              "z": 1.237
            },
            "gtin": "4009703000313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9ee",
            "leftCorner": {
              "x": 22.97,
              "y": 28.446,
              "z": 1.237
            },
            "rightCorner": {
              "x": 22.961,
              "y": 28.331,
              "z": 1.237
            },
            "gtin": "4004363310550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9ef",
            "leftCorner": {
              "x": 22.961,
              "y": 28.331,
              "z": 1.237
            },
            "rightCorner": {
              "x": 22.95,
              "y": 28.215,
              "z": 1.237
            },
            "gtin": "4004363310550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9f0",
            "leftCorner": {
              "x": 22.956,
              "y": 28.214,
              "z": 1.237
            },
            "rightCorner": {
              "x": 22.948,
              "y": 28.122,
              "z": 1.237
            },
            "gtin": "4004363010559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9f1",
            "leftCorner": {
              "x": 22.948,
              "y": 28.122,
              "z": 1.237
            },
            "rightCorner": {
              "x": 22.94,
              "y": 28.028,
              "z": 1.237
            },
            "gtin": "4004363010559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9f2",
            "leftCorner": {
              "x": 22.929,
              "y": 28.029,
              "z": 1.237
            },
            "rightCorner": {
              "x": 22.917,
              "y": 27.889,
              "z": 1.237
            },
            "gtin": "4004363620130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9f3",
            "leftCorner": {
              "x": 22.917,
              "y": 27.889,
              "z": 1.237
            },
            "rightCorner": {
              "x": 22.905,
              "y": 27.75,
              "z": 1.237
            },
            "gtin": "4004363620130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9f4",
            "leftCorner": {
              "x": 22.903,
              "y": 27.75,
              "z": 1.237
            },
            "rightCorner": {
              "x": 22.896,
              "y": 27.665,
              "z": 1.237
            },
            "gtin": "4008713713299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9f5",
            "leftCorner": {
              "x": 22.896,
              "y": 27.665,
              "z": 1.237
            },
            "rightCorner": {
              "x": 22.889,
              "y": 27.58,
              "z": 1.237
            },
            "gtin": "4008713713299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9f6",
            "leftCorner": {
              "x": 22.889,
              "y": 27.58,
              "z": 1.237
            },
            "rightCorner": {
              "x": 22.881,
              "y": 27.495,
              "z": 1.237
            },
            "gtin": "4008713713299",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546921",
        "height": 1.7546,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ea3b",
            "leftCorner": {
              "x": 23.002,
              "y": 28.904,
              "z": 1.436
            },
            "rightCorner": {
              "x": 22.99,
              "y": 28.767,
              "z": 1.436
            },
            "gtin": "5700002255921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea3c",
            "leftCorner": {
              "x": 22.99,
              "y": 28.767,
              "z": 1.436
            },
            "rightCorner": {
              "x": 22.978,
              "y": 28.63,
              "z": 1.436
            },
            "gtin": "5700002255921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea3d",
            "leftCorner": {
              "x": 22.984,
              "y": 28.63,
              "z": 1.436
            },
            "rightCorner": {
              "x": 22.976,
              "y": 28.531,
              "z": 1.436
            },
            "gtin": "4009703001006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea3e",
            "leftCorner": {
              "x": 22.976,
              "y": 28.531,
              "z": 1.436
            },
            "rightCorner": {
              "x": 22.967,
              "y": 28.432,
              "z": 1.436
            },
            "gtin": "4009703001006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea3f",
            "leftCorner": {
              "x": 22.967,
              "y": 28.432,
              "z": 1.436
            },
            "rightCorner": {
              "x": 22.959,
              "y": 28.334,
              "z": 1.436
            },
            "gtin": "4009703001006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea40",
            "leftCorner": {
              "x": 22.959,
              "y": 28.334,
              "z": 1.436
            },
            "rightCorner": {
              "x": 22.95,
              "y": 28.235,
              "z": 1.436
            },
            "gtin": "4009703001006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea41",
            "leftCorner": {
              "x": 22.958,
              "y": 28.234,
              "z": 1.436
            },
            "rightCorner": {
              "x": 22.952,
              "y": 28.162,
              "z": 1.436
            },
            "gtin": "8717496860873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea42",
            "leftCorner": {
              "x": 22.944,
              "y": 28.162,
              "z": 1.436
            },
            "rightCorner": {
              "x": 22.929,
              "y": 27.985,
              "z": 1.436
            },
            "gtin": "8009650050405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea43",
            "leftCorner": {
              "x": 22.923,
              "y": 27.986,
              "z": 1.436
            },
            "rightCorner": {
              "x": 22.915,
              "y": 27.898,
              "z": 1.436
            },
            "gtin": "8723400798453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea44",
            "leftCorner": {
              "x": 22.915,
              "y": 27.898,
              "z": 1.436
            },
            "rightCorner": {
              "x": 22.908,
              "y": 27.811,
              "z": 1.436
            },
            "gtin": "8723400798453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea45",
            "leftCorner": {
              "x": 22.914,
              "y": 27.81,
              "z": 1.436
            },
            "rightCorner": {
              "x": 22.907,
              "y": 27.734,
              "z": 1.436
            },
            "gtin": "5900020030443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea46",
            "leftCorner": {
              "x": 22.907,
              "y": 27.734,
              "z": 1.436
            },
            "rightCorner": {
              "x": 22.901,
              "y": 27.659,
              "z": 1.436
            },
            "gtin": "5900020030443",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "9300a",
    "rightNeighborShelfId": "9300c"
  },
  {
    "id": "9300c",
    "name": "9300c",
    "x": 22.857,
    "y": 27.662,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73645,
      "w": 0.67649
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 39
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54692b",
        "height": 0.14756,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e9bc",
            "leftCorner": {
              "x": 22.927,
              "y": 27.589,
              "z": 0.121
            },
            "rightCorner": {
              "x": 22.907,
              "y": 27.34,
              "z": 0.121
            },
            "gtin": "4006529020167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9bd",
            "leftCorner": {
              "x": 22.907,
              "y": 27.34,
              "z": 0.121
            },
            "rightCorner": {
              "x": 22.885,
              "y": 27.091,
              "z": 0.121
            },
            "gtin": "4006529020167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9be",
            "leftCorner": {
              "x": 22.866,
              "y": 27.092,
              "z": 0.121
            },
            "rightCorner": {
              "x": 22.833,
              "y": 26.711,
              "z": 0.121
            },
            "gtin": "4018356035498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9bf",
            "leftCorner": {
              "x": 22.833,
              "y": 26.711,
              "z": 0.121
            },
            "rightCorner": {
              "x": 22.801,
              "y": 26.329,
              "z": 0.121
            },
            "gtin": "4018356035498",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546929",
        "height": 0.50471,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a546928",
        "height": 0.80036,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2167d",
            "leftCorner": {
              "x": 22.868,
              "y": 27.661,
              "z": 0.655
            },
            "rightCorner": {
              "x": 22.842,
              "y": 27.363,
              "z": 0.655
            },
            "gtin": "8015997002953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2167e",
            "leftCorner": {
              "x": 22.842,
              "y": 27.363,
              "z": 0.655
            },
            "rightCorner": {
              "x": 22.817,
              "y": 27.065,
              "z": 0.655
            },
            "gtin": "8015997002953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2167f",
            "leftCorner": {
              "x": 22.817,
              "y": 27.065,
              "z": 0.655
            },
            "rightCorner": {
              "x": 22.792,
              "y": 26.766,
              "z": 0.655
            },
            "gtin": "8015997002953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21680",
            "leftCorner": {
              "x": 22.829,
              "y": 26.764,
              "z": 0.655
            },
            "rightCorner": {
              "x": 22.82,
              "y": 26.647,
              "z": 0.655
            },
            "gtin": "8015997002915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21681",
            "leftCorner": {
              "x": 22.82,
              "y": 26.647,
              "z": 0.655
            },
            "rightCorner": {
              "x": 22.809,
              "y": 26.53,
              "z": 0.655
            },
            "gtin": "8015997002915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21682",
            "leftCorner": {
              "x": 22.809,
              "y": 26.53,
              "z": 0.655
            },
            "rightCorner": {
              "x": 22.799,
              "y": 26.413,
              "z": 0.655
            },
            "gtin": "8015997002915",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54692c",
        "height": 1.104,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21683",
            "leftCorner": {
              "x": 22.861,
              "y": 27.662,
              "z": 0.903
            },
            "rightCorner": {
              "x": 22.809,
              "y": 27.057,
              "z": 0.903
            },
            "gtin": "3173990058065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21685",
            "leftCorner": {
              "x": 22.836,
              "y": 27.054,
              "z": 0.903
            },
            "rightCorner": {
              "x": 22.825,
              "y": 26.924,
              "z": 0.903
            },
            "gtin": "8000895003379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21686",
            "leftCorner": {
              "x": 22.825,
              "y": 26.924,
              "z": 0.903
            },
            "rightCorner": {
              "x": 22.815,
              "y": 26.794,
              "z": 0.903
            },
            "gtin": "8000895003379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21687",
            "leftCorner": {
              "x": 22.826,
              "y": 26.793,
              "z": 0.903
            },
            "rightCorner": {
              "x": 22.815,
              "y": 26.666,
              "z": 0.903
            },
            "gtin": "8000895003355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21688",
            "leftCorner": {
              "x": 22.815,
              "y": 26.666,
              "z": 0.903
            },
            "rightCorner": {
              "x": 22.804,
              "y": 26.539,
              "z": 0.903
            },
            "gtin": "8000895003355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21684",
            "leftCorner": {
              "x": 22.806,
              "y": 26.539,
              "z": 0.903
            },
            "rightCorner": {
              "x": 22.795,
              "y": 26.413,
              "z": 0.903
            },
            "gtin": "8002590055417",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54692a",
        "height": 1.5056,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e9f7",
            "leftCorner": {
              "x": 22.88,
              "y": 27.495,
              "z": 1.232
            },
            "rightCorner": {
              "x": 22.865,
              "y": 27.314,
              "z": 1.232
            },
            "gtin": "4008713713282",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c865ed67a01d9a1e9f8",
            "leftCorner": {
              "x": 22.874,
              "y": 27.313,
              "z": 1.232
            },
            "rightCorner": {
              "x": 22.862,
              "y": 27.175,
              "z": 1.232
            },
            "gtin": "4008713713244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9f9",
            "leftCorner": {
              "x": 22.862,
              "y": 27.175,
              "z": 1.232
            },
            "rightCorner": {
              "x": 22.85,
              "y": 27.036,
              "z": 1.232
            },
            "gtin": "4008713713244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9fa",
            "leftCorner": {
              "x": 22.85,
              "y": 27.036,
              "z": 1.232
            },
            "rightCorner": {
              "x": 22.838,
              "y": 26.898,
              "z": 1.232
            },
            "gtin": "4008713713244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9fb",
            "leftCorner": {
              "x": 22.834,
              "y": 26.898,
              "z": 1.232
            },
            "rightCorner": {
              "x": 22.829,
              "y": 26.843,
              "z": 1.232
            },
            "gtin": "4008713713275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9fc",
            "leftCorner": {
              "x": 22.829,
              "y": 26.843,
              "z": 1.232
            },
            "rightCorner": {
              "x": 22.826,
              "y": 26.788,
              "z": 1.232
            },
            "gtin": "4008713713275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9fd",
            "leftCorner": {
              "x": 22.826,
              "y": 26.788,
              "z": 1.232
            },
            "rightCorner": {
              "x": 22.821,
              "y": 26.732,
              "z": 1.232
            },
            "gtin": "4008713713275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9fe",
            "leftCorner": {
              "x": 22.823,
              "y": 26.732,
              "z": 1.232
            },
            "rightCorner": {
              "x": 22.813,
              "y": 26.618,
              "z": 1.232
            },
            "gtin": "4008713713251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9ff",
            "leftCorner": {
              "x": 22.813,
              "y": 26.618,
              "z": 1.232
            },
            "rightCorner": {
              "x": 22.803,
              "y": 26.504,
              "z": 1.232
            },
            "gtin": "4008713713251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea00",
            "leftCorner": {
              "x": 22.794,
              "y": 26.504,
              "z": 1.232
            },
            "rightCorner": {
              "x": 22.786,
              "y": 26.414,
              "z": 1.232
            },
            "gtin": "4008713713268",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546927",
        "height": 1.753,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ea47",
            "leftCorner": {
              "x": 22.904,
              "y": 27.659,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.896,
              "y": 27.563,
              "z": 1.434
            },
            "gtin": "5900020028495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea48",
            "leftCorner": {
              "x": 22.896,
              "y": 27.563,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.888,
              "y": 27.469,
              "z": 1.434
            },
            "gtin": "5900020028495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea49",
            "leftCorner": {
              "x": 22.888,
              "y": 27.469,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.88,
              "y": 27.373,
              "z": 1.434
            },
            "gtin": "5900020028495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea4a",
            "leftCorner": {
              "x": 22.856,
              "y": 27.375,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.846,
              "y": 27.258,
              "z": 1.434
            },
            "gtin": "4063367235580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea4b",
            "leftCorner": {
              "x": 22.868,
              "y": 27.256,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.855,
              "y": 27.102,
              "z": 1.434
            },
            "gtin": "4063367235511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea4c",
            "leftCorner": {
              "x": 22.839,
              "y": 27.104,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.827,
              "y": 26.967,
              "z": 1.434
            },
            "gtin": "4063367235535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea4d",
            "leftCorner": {
              "x": 22.827,
              "y": 26.967,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.815,
              "y": 26.829,
              "z": 1.434
            },
            "gtin": "4063367235535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea4e",
            "leftCorner": {
              "x": 22.837,
              "y": 26.827,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.83,
              "y": 26.742,
              "z": 1.434
            },
            "gtin": "4063367235566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea4f",
            "leftCorner": {
              "x": 22.83,
              "y": 26.742,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.823,
              "y": 26.658,
              "z": 1.434
            },
            "gtin": "4063367235566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea50",
            "leftCorner": {
              "x": 22.816,
              "y": 26.658,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.812,
              "y": 26.608,
              "z": 1.434
            },
            "gtin": "4011800520052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea51",
            "leftCorner": {
              "x": 22.812,
              "y": 26.608,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.807,
              "y": 26.559,
              "z": 1.434
            },
            "gtin": "4011800520052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea52",
            "leftCorner": {
              "x": 22.807,
              "y": 26.559,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.803,
              "y": 26.509,
              "z": 1.434
            },
            "gtin": "4011800520052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea53",
            "leftCorner": {
              "x": 22.8,
              "y": 26.509,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.795,
              "y": 26.452,
              "z": 1.434
            },
            "gtin": "4011800524012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea54",
            "leftCorner": {
              "x": 22.795,
              "y": 26.452,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.791,
              "y": 26.395,
              "z": 1.434
            },
            "gtin": "4011800524012",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "9300b",
    "rightNeighborShelfId": "9300d"
  },
  {
    "id": "9300d",
    "name": "9300d",
    "x": 22.751,
    "y": 26.416,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73645,
      "w": 0.67649
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 60
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54640d",
        "height": 0.15224,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e9c0",
            "leftCorner": {
              "x": 22.803,
              "y": 26.328,
              "z": 0.125
            },
            "rightCorner": {
              "x": 22.786,
              "y": 26.141,
              "z": 0.125
            },
            "gtin": "8002594001229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9c1",
            "leftCorner": {
              "x": 22.783,
              "y": 26.141,
              "z": 0.125
            },
            "rightCorner": {
              "x": 22.766,
              "y": 25.926,
              "z": 0.125
            },
            "gtin": "4011800530013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9c2",
            "leftCorner": {
              "x": 22.775,
              "y": 25.925,
              "z": 0.125
            },
            "rightCorner": {
              "x": 22.764,
              "y": 25.79,
              "z": 0.125
            },
            "gtin": "4011800599614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9c3",
            "leftCorner": {
              "x": 22.748,
              "y": 25.791,
              "z": 0.125
            },
            "rightCorner": {
              "x": 22.737,
              "y": 25.666,
              "z": 0.125
            },
            "gtin": "4011800523817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9c4",
            "leftCorner": {
              "x": 22.744,
              "y": 25.665,
              "z": 0.125
            },
            "rightCorner": {
              "x": 22.725,
              "y": 25.449,
              "z": 0.125
            },
            "gtin": "4011800599713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9c5",
            "leftCorner": {
              "x": 22.72,
              "y": 25.45,
              "z": 0.125
            },
            "rightCorner": {
              "x": 22.71,
              "y": 25.335,
              "z": 0.125
            },
            "gtin": "4011800582319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9c6",
            "leftCorner": {
              "x": 22.715,
              "y": 25.334,
              "z": 0.125
            },
            "rightCorner": {
              "x": 22.706,
              "y": 25.237,
              "z": 0.125
            },
            "gtin": "4011800593810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9c7",
            "leftCorner": {
              "x": 22.706,
              "y": 25.237,
              "z": 0.125
            },
            "rightCorner": {
              "x": 22.698,
              "y": 25.14,
              "z": 0.125
            },
            "gtin": "4011800593810",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54640e",
        "height": 0.50234,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e9e1",
            "leftCorner": {
              "x": 22.799,
              "y": 26.365,
              "z": 0.411
            },
            "rightCorner": {
              "x": 22.787,
              "y": 26.222,
              "z": 0.411
            },
            "gtin": "4011800562212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9e2",
            "leftCorner": {
              "x": 22.787,
              "y": 26.222,
              "z": 0.411
            },
            "rightCorner": {
              "x": 22.775,
              "y": 26.079,
              "z": 0.411
            },
            "gtin": "4011800562212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9e3",
            "leftCorner": {
              "x": 22.775,
              "y": 26.079,
              "z": 0.411
            },
            "rightCorner": {
              "x": 22.762,
              "y": 25.936,
              "z": 0.411
            },
            "gtin": "4011800562212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9e4",
            "leftCorner": {
              "x": 22.762,
              "y": 25.936,
              "z": 0.411
            },
            "rightCorner": {
              "x": 22.75,
              "y": 25.792,
              "z": 0.411
            },
            "gtin": "4011800562212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9e5",
            "leftCorner": {
              "x": 22.748,
              "y": 25.792,
              "z": 0.411
            },
            "rightCorner": {
              "x": 22.735,
              "y": 25.642,
              "z": 0.411
            },
            "gtin": "4011800523916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9e6",
            "leftCorner": {
              "x": 22.735,
              "y": 25.642,
              "z": 0.411
            },
            "rightCorner": {
              "x": 22.722,
              "y": 25.493,
              "z": 0.411
            },
            "gtin": "4011800523916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9e7",
            "leftCorner": {
              "x": 22.731,
              "y": 25.491,
              "z": 0.411
            },
            "rightCorner": {
              "x": 22.725,
              "y": 25.431,
              "z": 0.411
            },
            "gtin": "4011800523312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9e8",
            "leftCorner": {
              "x": 22.725,
              "y": 25.431,
              "z": 0.411
            },
            "rightCorner": {
              "x": 22.721,
              "y": 25.37,
              "z": 0.411
            },
            "gtin": "4011800523312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9e9",
            "leftCorner": {
              "x": 22.721,
              "y": 25.37,
              "z": 0.411
            },
            "rightCorner": {
              "x": 22.716,
              "y": 25.31,
              "z": 0.411
            },
            "gtin": "4011800523312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9dd",
            "leftCorner": {
              "x": 22.717,
              "y": 25.31,
              "z": 0.411
            },
            "rightCorner": {
              "x": 22.711,
              "y": 25.237,
              "z": 0.411
            },
            "gtin": "4011800525316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9de",
            "leftCorner": {
              "x": 22.711,
              "y": 25.237,
              "z": 0.411
            },
            "rightCorner": {
              "x": 22.704,
              "y": 25.165,
              "z": 0.411
            },
            "gtin": "4011800525316",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546410",
        "height": 0.7557,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ea06",
            "leftCorner": {
              "x": 22.767,
              "y": 26.414,
              "z": 0.618
            },
            "rightCorner": {
              "x": 22.733,
              "y": 26.011,
              "z": 0.618
            },
            "gtin": "4011800521219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea0a",
            "leftCorner": {
              "x": 22.769,
              "y": 26.008,
              "z": 0.618
            },
            "rightCorner": {
              "x": 22.745,
              "y": 25.714,
              "z": 0.618
            },
            "gtin": "4011800571719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea0b",
            "leftCorner": {
              "x": 22.745,
              "y": 25.714,
              "z": 0.618
            },
            "rightCorner": {
              "x": 22.72,
              "y": 25.421,
              "z": 0.618
            },
            "gtin": "4011800571719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea0c",
            "leftCorner": {
              "x": 22.721,
              "y": 25.421,
              "z": 0.618
            },
            "rightCorner": {
              "x": 22.705,
              "y": 25.241,
              "z": 0.618
            },
            "gtin": "4011800562816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea0d",
            "leftCorner": {
              "x": 22.705,
              "y": 25.241,
              "z": 0.618
            },
            "rightCorner": {
              "x": 22.689,
              "y": 25.06,
              "z": 0.618
            },
            "gtin": "4011800562816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea0e",
            "leftCorner": {
              "x": 22.689,
              "y": 25.06,
              "z": 0.618
            },
            "rightCorner": {
              "x": 22.674,
              "y": 24.881,
              "z": 0.618
            },
            "gtin": "4011800562816",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546412",
        "height": 1.008,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ea8f",
            "leftCorner": {
              "x": 22.765,
              "y": 26.414,
              "z": 0.825
            },
            "rightCorner": {
              "x": 22.751,
              "y": 26.248,
              "z": 0.825
            },
            "gtin": "4011800524210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea90",
            "leftCorner": {
              "x": 22.751,
              "y": 26.248,
              "z": 0.825
            },
            "rightCorner": {
              "x": 22.737,
              "y": 26.081,
              "z": 0.825
            },
            "gtin": "4011800524210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea93",
            "leftCorner": {
              "x": 22.769,
              "y": 26.078,
              "z": 0.825
            },
            "rightCorner": {
              "x": 22.744,
              "y": 25.776,
              "z": 0.825
            },
            "gtin": "4011800522810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea94",
            "leftCorner": {
              "x": 22.733,
              "y": 25.777,
              "z": 0.825
            },
            "rightCorner": {
              "x": 22.716,
              "y": 25.583,
              "z": 0.825
            },
            "gtin": "4011800000103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea91",
            "leftCorner": {
              "x": 22.726,
              "y": 25.582,
              "z": 0.825
            },
            "rightCorner": {
              "x": 22.709,
              "y": 25.373,
              "z": 0.825
            },
            "gtin": "4011800523213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea92",
            "leftCorner": {
              "x": 22.709,
              "y": 25.373,
              "z": 0.825
            },
            "rightCorner": {
              "x": 22.691,
              "y": 25.166,
              "z": 0.825
            },
            "gtin": "4011800523213",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546413",
        "height": 1.2574,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ea95",
            "leftCorner": {
              "x": 22.765,
              "y": 26.414,
              "z": 1.029
            },
            "rightCorner": {
              "x": 22.749,
              "y": 26.242,
              "z": 1.029
            },
            "gtin": "4011800527211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea96",
            "leftCorner": {
              "x": 22.749,
              "y": 26.242,
              "z": 1.029
            },
            "rightCorner": {
              "x": 22.735,
              "y": 26.069,
              "z": 1.029
            },
            "gtin": "4011800527211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea99",
            "leftCorner": {
              "x": 22.76,
              "y": 26.067,
              "z": 1.029
            },
            "rightCorner": {
              "x": 22.752,
              "y": 25.965,
              "z": 1.029
            },
            "gtin": "4011800000134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea9a",
            "leftCorner": {
              "x": 22.762,
              "y": 25.964,
              "z": 1.029
            },
            "rightCorner": {
              "x": 22.746,
              "y": 25.766,
              "z": 1.029
            },
            "gtin": "4011800525217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea9b",
            "leftCorner": {
              "x": 22.754,
              "y": 25.766,
              "z": 1.029
            },
            "rightCorner": {
              "x": 22.747,
              "y": 25.681,
              "z": 1.029
            },
            "gtin": "4011800575212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea9c",
            "leftCorner": {
              "x": 22.747,
              "y": 25.681,
              "z": 1.029
            },
            "rightCorner": {
              "x": 22.739,
              "y": 25.595,
              "z": 1.029
            },
            "gtin": "4011800575212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea9d",
            "leftCorner": {
              "x": 22.74,
              "y": 25.595,
              "z": 1.029
            },
            "rightCorner": {
              "x": 22.729,
              "y": 25.466,
              "z": 1.029
            },
            "gtin": "687456214924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea9e",
            "leftCorner": {
              "x": 22.72,
              "y": 25.467,
              "z": 1.029
            },
            "rightCorner": {
              "x": 22.714,
              "y": 25.383,
              "z": 1.029
            },
            "gtin": "687456213583",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea9f",
            "leftCorner": {
              "x": 22.714,
              "y": 25.383,
              "z": 1.029
            },
            "rightCorner": {
              "x": 22.706,
              "y": 25.299,
              "z": 1.029
            },
            "gtin": "687456213583",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea97",
            "leftCorner": {
              "x": 22.708,
              "y": 25.299,
              "z": 1.029
            },
            "rightCorner": {
              "x": 22.703,
              "y": 25.233,
              "z": 1.029
            },
            "gtin": "687456213576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea98",
            "leftCorner": {
              "x": 22.703,
              "y": 25.233,
              "z": 1.029
            },
            "rightCorner": {
              "x": 22.698,
              "y": 25.165,
              "z": 1.029
            },
            "gtin": "687456213576",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54640f",
        "height": 1.5105,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ea01",
            "leftCorner": {
              "x": 22.792,
              "y": 26.412,
              "z": 1.236
            },
            "rightCorner": {
              "x": 22.787,
              "y": 26.362,
              "z": 1.236
            },
            "gtin": "4011800571214",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c865ed67a01d9a1ea02",
            "leftCorner": {
              "x": 22.799,
              "y": 26.361,
              "z": 1.236
            },
            "rightCorner": {
              "x": 22.781,
              "y": 26.145,
              "z": 1.236
            },
            "gtin": "4011800571214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea03",
            "leftCorner": {
              "x": 22.781,
              "y": 26.145,
              "z": 1.236
            },
            "rightCorner": {
              "x": 22.763,
              "y": 25.93,
              "z": 1.236
            },
            "gtin": "4011800571214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea04",
            "leftCorner": {
              "x": 22.76,
              "y": 25.93,
              "z": 1.236
            },
            "rightCorner": {
              "x": 22.736,
              "y": 25.656,
              "z": 1.236
            },
            "gtin": "4011800572211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea05",
            "leftCorner": {
              "x": 22.736,
              "y": 25.656,
              "z": 1.236
            },
            "rightCorner": {
              "x": 22.714,
              "y": 25.381,
              "z": 1.236
            },
            "gtin": "4011800572211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9eb",
            "leftCorner": {
              "x": 22.711,
              "y": 25.382,
              "z": 1.236
            },
            "rightCorner": {
              "x": 22.692,
              "y": 25.166,
              "z": 1.236
            },
            "gtin": "8410076601704",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546411",
        "height": 1.7558,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ea55",
            "leftCorner": {
              "x": 22.789,
              "y": 26.393,
              "z": 1.437
            },
            "rightCorner": {
              "x": 22.78,
              "y": 26.272,
              "z": 1.437
            },
            "gtin": "4011800545819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea56",
            "leftCorner": {
              "x": 22.786,
              "y": 26.271,
              "z": 1.437
            },
            "rightCorner": {
              "x": 22.778,
              "y": 26.179,
              "z": 1.437
            },
            "gtin": "4011800547813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea57",
            "leftCorner": {
              "x": 22.778,
              "y": 26.179,
              "z": 1.437
            },
            "rightCorner": {
              "x": 22.77,
              "y": 26.086,
              "z": 1.437
            },
            "gtin": "4011800547813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea58",
            "leftCorner": {
              "x": 22.757,
              "y": 26.087,
              "z": 1.437
            },
            "rightCorner": {
              "x": 22.747,
              "y": 25.965,
              "z": 1.437
            },
            "gtin": "4011800549411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea59",
            "leftCorner": {
              "x": 22.747,
              "y": 25.965,
              "z": 1.437
            },
            "rightCorner": {
              "x": 22.736,
              "y": 25.843,
              "z": 1.437
            },
            "gtin": "4011800549411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea5a",
            "leftCorner": {
              "x": 22.751,
              "y": 25.841,
              "z": 1.437
            },
            "rightCorner": {
              "x": 22.729,
              "y": 25.594,
              "z": 1.437
            },
            "gtin": "5907437369784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea5b",
            "leftCorner": {
              "x": 22.719,
              "y": 25.595,
              "z": 1.437
            },
            "rightCorner": {
              "x": 22.714,
              "y": 25.54,
              "z": 1.437
            },
            "gtin": "4337185902659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea5c",
            "leftCorner": {
              "x": 22.714,
              "y": 25.54,
              "z": 1.437
            },
            "rightCorner": {
              "x": 22.71,
              "y": 25.486,
              "z": 1.437
            },
            "gtin": "4337185902659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea5d",
            "leftCorner": {
              "x": 22.71,
              "y": 25.486,
              "z": 1.437
            },
            "rightCorner": {
              "x": 22.705,
              "y": 25.431,
              "z": 1.437
            },
            "gtin": "4337185902659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea5e",
            "leftCorner": {
              "x": 22.705,
              "y": 25.431,
              "z": 1.437
            },
            "rightCorner": {
              "x": 22.7,
              "y": 25.376,
              "z": 1.437
            },
            "gtin": "4337185902659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea5f",
            "leftCorner": {
              "x": 22.709,
              "y": 25.375,
              "z": 1.437
            },
            "rightCorner": {
              "x": 22.703,
              "y": 25.292,
              "z": 1.437
            },
            "gtin": "5907437369777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea60",
            "leftCorner": {
              "x": 22.703,
              "y": 25.292,
              "z": 1.437
            },
            "rightCorner": {
              "x": 22.695,
              "y": 25.208,
              "z": 1.437
            },
            "gtin": "5907437369777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea61",
            "leftCorner": {
              "x": 22.695,
              "y": 25.208,
              "z": 1.437
            },
            "rightCorner": {
              "x": 22.688,
              "y": 25.125,
              "z": 1.437
            },
            "gtin": "5907437369777",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "9300c",
    "rightNeighborShelfId": "9300e"
  },
  {
    "id": "9300e",
    "name": "9300e",
    "x": 22.645,
    "y": 25.171,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73645,
      "w": 0.67649
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 5,
      "unknownStockCount": 135
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546934",
        "height": 0.15579,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e9c8",
            "leftCorner": {
              "x": 22.691,
              "y": 25.142,
              "z": 0.127
            },
            "rightCorner": {
              "x": 22.681,
              "y": 25.037,
              "z": 0.127
            },
            "gtin": "4260044260464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9c9",
            "leftCorner": {
              "x": 22.689,
              "y": 25.037,
              "z": 0.127
            },
            "rightCorner": {
              "x": 22.684,
              "y": 24.982,
              "z": 0.127
            },
            "gtin": "4260044260402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9ca",
            "leftCorner": {
              "x": 22.684,
              "y": 24.982,
              "z": 0.127
            },
            "rightCorner": {
              "x": 22.679,
              "y": 24.926,
              "z": 0.127
            },
            "gtin": "4260044260402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9cb",
            "leftCorner": {
              "x": 22.68,
              "y": 24.926,
              "z": 0.127
            },
            "rightCorner": {
              "x": 22.674,
              "y": 24.852,
              "z": 0.127
            },
            "gtin": "4260044260228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9cc",
            "leftCorner": {
              "x": 22.674,
              "y": 24.852,
              "z": 0.127
            },
            "rightCorner": {
              "x": 22.667,
              "y": 24.778,
              "z": 0.127
            },
            "gtin": "4260044260228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9cd",
            "leftCorner": {
              "x": 22.665,
              "y": 24.778,
              "z": 0.127
            },
            "rightCorner": {
              "x": 22.661,
              "y": 24.734,
              "z": 0.127
            },
            "gtin": "8710283654624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9ce",
            "leftCorner": {
              "x": 22.661,
              "y": 24.734,
              "z": 0.127
            },
            "rightCorner": {
              "x": 22.658,
              "y": 24.69,
              "z": 0.127
            },
            "gtin": "8710283654624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9cf",
            "leftCorner": {
              "x": 22.655,
              "y": 24.69,
              "z": 0.127
            },
            "rightCorner": {
              "x": 22.646,
              "y": 24.585,
              "z": 0.127
            },
            "gtin": "8710283654587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9d0",
            "leftCorner": {
              "x": 22.646,
              "y": 24.585,
              "z": 0.127
            },
            "rightCorner": {
              "x": 22.637,
              "y": 24.481,
              "z": 0.127
            },
            "gtin": "8710283654587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9d1",
            "leftCorner": {
              "x": 22.638,
              "y": 24.48,
              "z": 0.127
            },
            "rightCorner": {
              "x": 22.624,
              "y": 24.31,
              "z": 0.127
            },
            "gtin": "8710283654594",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c865ed67a01d9a1e9d2",
            "leftCorner": {
              "x": 22.622,
              "y": 24.31,
              "z": 0.127
            },
            "rightCorner": {
              "x": 22.615,
              "y": 24.231,
              "z": 0.127
            },
            "gtin": "8710283654600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9d3",
            "leftCorner": {
              "x": 22.615,
              "y": 24.231,
              "z": 0.127
            },
            "rightCorner": {
              "x": 22.607,
              "y": 24.153,
              "z": 0.127
            },
            "gtin": "8710283654600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9d4",
            "leftCorner": {
              "x": 22.608,
              "y": 24.153,
              "z": 0.127
            },
            "rightCorner": {
              "x": 22.599,
              "y": 24.047,
              "z": 0.127
            },
            "gtin": "8710283654617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9d5",
            "leftCorner": {
              "x": 22.599,
              "y": 24.047,
              "z": 0.127
            },
            "rightCorner": {
              "x": 22.591,
              "y": 23.941,
              "z": 0.127
            },
            "gtin": "8710283654617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9d6",
            "leftCorner": {
              "x": 22.591,
              "y": 23.941,
              "z": 0.127
            },
            "rightCorner": {
              "x": 22.582,
              "y": 23.835,
              "z": 0.127
            },
            "gtin": "8710283654617",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546933",
        "height": 0.35743,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a216ca",
            "leftCorner": {
              "x": 22.664,
              "y": 25.17,
              "z": 0.292
            },
            "rightCorner": {
              "x": 22.656,
              "y": 25.077,
              "z": 0.292
            },
            "gtin": "4260654782882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216cb",
            "leftCorner": {
              "x": 22.656,
              "y": 25.077,
              "z": 0.292
            },
            "rightCorner": {
              "x": 22.648,
              "y": 24.985,
              "z": 0.292
            },
            "gtin": "4260654782882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216cd",
            "leftCorner": {
              "x": 22.696,
              "y": 24.981,
              "z": 0.292
            },
            "rightCorner": {
              "x": 22.686,
              "y": 24.868,
              "z": 0.292
            },
            "gtin": "4260044264455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216ce",
            "leftCorner": {
              "x": 22.686,
              "y": 24.868,
              "z": 0.292
            },
            "rightCorner": {
              "x": 22.677,
              "y": 24.754,
              "z": 0.292
            },
            "gtin": "4260044264455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216cf",
            "leftCorner": {
              "x": 22.665,
              "y": 24.755,
              "z": 0.292
            },
            "rightCorner": {
              "x": 22.658,
              "y": 24.66,
              "z": 0.292
            },
            "gtin": "4260044260471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216d0",
            "leftCorner": {
              "x": 22.658,
              "y": 24.66,
              "z": 0.292
            },
            "rightCorner": {
              "x": 22.649,
              "y": 24.564,
              "z": 0.292
            },
            "gtin": "4260044260471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216d1",
            "leftCorner": {
              "x": 22.649,
              "y": 24.564,
              "z": 0.292
            },
            "rightCorner": {
              "x": 22.641,
              "y": 24.469,
              "z": 0.292
            },
            "gtin": "4260044260471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216d2",
            "leftCorner": {
              "x": 22.644,
              "y": 24.469,
              "z": 0.292
            },
            "rightCorner": {
              "x": 22.64,
              "y": 24.421,
              "z": 0.292
            },
            "gtin": "4260044265018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216d3",
            "leftCorner": {
              "x": 22.64,
              "y": 24.421,
              "z": 0.292
            },
            "rightCorner": {
              "x": 22.636,
              "y": 24.374,
              "z": 0.292
            },
            "gtin": "4260044265018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216d4",
            "leftCorner": {
              "x": 22.636,
              "y": 24.374,
              "z": 0.292
            },
            "rightCorner": {
              "x": 22.632,
              "y": 24.326,
              "z": 0.292
            },
            "gtin": "4260044265018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216d5",
            "leftCorner": {
              "x": 22.629,
              "y": 24.327,
              "z": 0.292
            },
            "rightCorner": {
              "x": 22.625,
              "y": 24.282,
              "z": 0.292
            },
            "gtin": "4260044265056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216d6",
            "leftCorner": {
              "x": 22.625,
              "y": 24.282,
              "z": 0.292
            },
            "rightCorner": {
              "x": 22.621,
              "y": 24.236,
              "z": 0.292
            },
            "gtin": "4260044265056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216d7",
            "leftCorner": {
              "x": 22.621,
              "y": 24.236,
              "z": 0.292
            },
            "rightCorner": {
              "x": 22.617,
              "y": 24.192,
              "z": 0.292
            },
            "gtin": "4260044265056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216d8",
            "leftCorner": {
              "x": 22.621,
              "y": 24.191,
              "z": 0.292
            },
            "rightCorner": {
              "x": 22.614,
              "y": 24.111,
              "z": 0.292
            },
            "gtin": "4260044265131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216d9",
            "leftCorner": {
              "x": 22.614,
              "y": 24.111,
              "z": 0.292
            },
            "rightCorner": {
              "x": 22.608,
              "y": 24.032,
              "z": 0.292
            },
            "gtin": "4260044265131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216cc",
            "leftCorner": {
              "x": 22.621,
              "y": 24.031,
              "z": 0.292
            },
            "rightCorner": {
              "x": 22.611,
              "y": 23.92,
              "z": 0.292
            },
            "gtin": "4260044268026",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54692d",
        "height": 0.55456,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21689",
            "leftCorner": {
              "x": 22.658,
              "y": 25.17,
              "z": 0.454
            },
            "rightCorner": {
              "x": 22.65,
              "y": 25.083,
              "z": 0.454
            },
            "gtin": "4029679995741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2168a",
            "leftCorner": {
              "x": 22.65,
              "y": 25.083,
              "z": 0.454
            },
            "rightCorner": {
              "x": 22.643,
              "y": 24.996,
              "z": 0.454
            },
            "gtin": "4029679995741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2168c",
            "leftCorner": {
              "x": 22.689,
              "y": 24.992,
              "z": 0.454
            },
            "rightCorner": {
              "x": 22.682,
              "y": 24.899,
              "z": 0.454
            },
            "gtin": "4029679995727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2168d",
            "leftCorner": {
              "x": 22.682,
              "y": 24.899,
              "z": 0.454
            },
            "rightCorner": {
              "x": 22.674,
              "y": 24.806,
              "z": 0.454
            },
            "gtin": "4029679995727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2168e",
            "leftCorner": {
              "x": 22.668,
              "y": 24.806,
              "z": 0.454
            },
            "rightCorner": {
              "x": 22.661,
              "y": 24.721,
              "z": 0.454
            },
            "gtin": "4251105515173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2168f",
            "leftCorner": {
              "x": 22.661,
              "y": 24.721,
              "z": 0.454
            },
            "rightCorner": {
              "x": 22.653,
              "y": 24.637,
              "z": 0.454
            },
            "gtin": "4251105515173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21690",
            "leftCorner": {
              "x": 22.649,
              "y": 24.637,
              "z": 0.454
            },
            "rightCorner": {
              "x": 22.643,
              "y": 24.561,
              "z": 0.454
            },
            "gtin": "4251105517696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21691",
            "leftCorner": {
              "x": 22.643,
              "y": 24.561,
              "z": 0.454
            },
            "rightCorner": {
              "x": 22.636,
              "y": 24.484,
              "z": 0.454
            },
            "gtin": "4251105517696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21692",
            "leftCorner": {
              "x": 22.636,
              "y": 24.484,
              "z": 0.454
            },
            "rightCorner": {
              "x": 22.62,
              "y": 24.298,
              "z": 0.454
            },
            "gtin": "4036554703629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21693",
            "leftCorner": {
              "x": 22.621,
              "y": 24.298,
              "z": 0.454
            },
            "rightCorner": {
              "x": 22.615,
              "y": 24.226,
              "z": 0.454
            },
            "gtin": "4260648132495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21694",
            "leftCorner": {
              "x": 22.615,
              "y": 24.226,
              "z": 0.454
            },
            "rightCorner": {
              "x": 22.609,
              "y": 24.155,
              "z": 0.454
            },
            "gtin": "4260648132495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21695",
            "leftCorner": {
              "x": 22.615,
              "y": 24.154,
              "z": 0.454
            },
            "rightCorner": {
              "x": 22.604,
              "y": 24.021,
              "z": 0.454
            },
            "gtin": "4260044268040",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8b5ed67a01d9a2168b",
            "leftCorner": {
              "x": 22.607,
              "y": 24.021,
              "z": 0.454
            },
            "rightCorner": {
              "x": 22.598,
              "y": 23.92,
              "z": 0.454
            },
            "gtin": "4260044266923",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546935",
        "height": 0.75385,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ea0f",
            "leftCorner": {
              "x": 22.675,
              "y": 24.882,
              "z": 0.617
            },
            "rightCorner": {
              "x": 22.662,
              "y": 24.721,
              "z": 0.617
            },
            "gtin": "4011800584726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea10",
            "leftCorner": {
              "x": 22.655,
              "y": 24.723,
              "z": 0.617
            },
            "rightCorner": {
              "x": 22.643,
              "y": 24.579,
              "z": 0.617
            },
            "gtin": "4011800584627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea11",
            "leftCorner": {
              "x": 22.643,
              "y": 24.579,
              "z": 0.617
            },
            "rightCorner": {
              "x": 22.631,
              "y": 24.437,
              "z": 0.617
            },
            "gtin": "4011800584627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea12",
            "leftCorner": {
              "x": 22.634,
              "y": 24.437,
              "z": 0.617
            },
            "rightCorner": {
              "x": 22.629,
              "y": 24.376,
              "z": 0.617
            },
            "gtin": "5712840020050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea13",
            "leftCorner": {
              "x": 22.629,
              "y": 24.376,
              "z": 0.617
            },
            "rightCorner": {
              "x": 22.623,
              "y": 24.314,
              "z": 0.617
            },
            "gtin": "5712840020050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea14",
            "leftCorner": {
              "x": 22.608,
              "y": 24.315,
              "z": 0.617
            },
            "rightCorner": {
              "x": 22.599,
              "y": 24.212,
              "z": 0.617
            },
            "gtin": "5712840020012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea15",
            "leftCorner": {
              "x": 22.599,
              "y": 24.212,
              "z": 0.617
            },
            "rightCorner": {
              "x": 22.591,
              "y": 24.109,
              "z": 0.617
            },
            "gtin": "5712840020012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea16",
            "leftCorner": {
              "x": 22.591,
              "y": 24.109,
              "z": 0.617
            },
            "rightCorner": {
              "x": 22.582,
              "y": 24.005,
              "z": 0.617
            },
            "gtin": "5712840020012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea07",
            "leftCorner": {
              "x": 22.607,
              "y": 24.002,
              "z": 0.617
            },
            "rightCorner": {
              "x": 22.604,
              "y": 23.975,
              "z": 0.617
            },
            "gtin": "5712840020074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea08",
            "leftCorner": {
              "x": 22.604,
              "y": 23.975,
              "z": 0.617
            },
            "rightCorner": {
              "x": 22.602,
              "y": 23.947,
              "z": 0.617
            },
            "gtin": "5712840020074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea09",
            "leftCorner": {
              "x": 22.602,
              "y": 23.947,
              "z": 0.617
            },
            "rightCorner": {
              "x": 22.599,
              "y": 23.92,
              "z": 0.617
            },
            "gtin": "5712840020074",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54692f",
        "height": 0.95681,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a216a8",
            "leftCorner": {
              "x": 22.647,
              "y": 25.171,
              "z": 0.783
            },
            "rightCorner": {
              "x": 22.638,
              "y": 25.06,
              "z": 0.783
            },
            "gtin": "4260402485379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216a9",
            "leftCorner": {
              "x": 22.638,
              "y": 25.06,
              "z": 0.783
            },
            "rightCorner": {
              "x": 22.628,
              "y": 24.948,
              "z": 0.783
            },
            "gtin": "4260402485379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216ad",
            "leftCorner": {
              "x": 22.663,
              "y": 24.944,
              "z": 0.783
            },
            "rightCorner": {
              "x": 22.653,
              "y": 24.835,
              "z": 0.783
            },
            "gtin": "7340001804904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216ae",
            "leftCorner": {
              "x": 22.662,
              "y": 24.835,
              "z": 0.783
            },
            "rightCorner": {
              "x": 22.657,
              "y": 24.774,
              "z": 0.783
            },
            "gtin": "7340001805116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216af",
            "leftCorner": {
              "x": 22.657,
              "y": 24.774,
              "z": 0.783
            },
            "rightCorner": {
              "x": 22.652,
              "y": 24.711,
              "z": 0.783
            },
            "gtin": "7340001805116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216b0",
            "leftCorner": {
              "x": 22.635,
              "y": 24.713,
              "z": 0.783
            },
            "rightCorner": {
              "x": 22.631,
              "y": 24.665,
              "z": 0.783
            },
            "gtin": "7340001804843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216b1",
            "leftCorner": {
              "x": 22.631,
              "y": 24.665,
              "z": 0.783
            },
            "rightCorner": {
              "x": 22.627,
              "y": 24.617,
              "z": 0.783
            },
            "gtin": "7340001804843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216b2",
            "leftCorner": {
              "x": 22.627,
              "y": 24.617,
              "z": 0.783
            },
            "rightCorner": {
              "x": 22.623,
              "y": 24.569,
              "z": 0.783
            },
            "gtin": "7340001804843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216b3",
            "leftCorner": {
              "x": 22.627,
              "y": 24.569,
              "z": 0.783
            },
            "rightCorner": {
              "x": 22.623,
              "y": 24.521,
              "z": 0.783
            },
            "gtin": "4260648130224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216b4",
            "leftCorner": {
              "x": 22.623,
              "y": 24.521,
              "z": 0.783
            },
            "rightCorner": {
              "x": 22.618,
              "y": 24.474,
              "z": 0.783
            },
            "gtin": "4260648130224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216b5",
            "leftCorner": {
              "x": 22.618,
              "y": 24.474,
              "z": 0.783
            },
            "rightCorner": {
              "x": 22.614,
              "y": 24.428,
              "z": 0.783
            },
            "gtin": "4260648130224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216b6",
            "leftCorner": {
              "x": 22.626,
              "y": 24.427,
              "z": 0.783
            },
            "rightCorner": {
              "x": 22.621,
              "y": 24.365,
              "z": 0.783
            },
            "gtin": "4260644048820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216b7",
            "leftCorner": {
              "x": 22.607,
              "y": 24.367,
              "z": 0.783
            },
            "rightCorner": {
              "x": 22.603,
              "y": 24.322,
              "z": 0.783
            },
            "gtin": "4260644048806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216b8",
            "leftCorner": {
              "x": 22.603,
              "y": 24.322,
              "z": 0.783
            },
            "rightCorner": {
              "x": 22.6,
              "y": 24.277,
              "z": 0.783
            },
            "gtin": "4260644048806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216b9",
            "leftCorner": {
              "x": 22.6,
              "y": 24.277,
              "z": 0.783
            },
            "rightCorner": {
              "x": 22.596,
              "y": 24.233,
              "z": 0.783
            },
            "gtin": "4260644048806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216ba",
            "leftCorner": {
              "x": 22.607,
              "y": 24.232,
              "z": 0.783
            },
            "rightCorner": {
              "x": 22.602,
              "y": 24.184,
              "z": 0.783
            },
            "gtin": "4260644048783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216bb",
            "leftCorner": {
              "x": 22.602,
              "y": 24.184,
              "z": 0.783
            },
            "rightCorner": {
              "x": 22.598,
              "y": 24.136,
              "z": 0.783
            },
            "gtin": "4260644048783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216aa",
            "leftCorner": {
              "x": 22.604,
              "y": 24.136,
              "z": 0.783
            },
            "rightCorner": {
              "x": 22.599,
              "y": 24.064,
              "z": 0.783
            },
            "gtin": "5060221208048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216ab",
            "leftCorner": {
              "x": 22.599,
              "y": 24.064,
              "z": 0.783
            },
            "rightCorner": {
              "x": 22.592,
              "y": 23.993,
              "z": 0.783
            },
            "gtin": "5060221208048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216ac",
            "leftCorner": {
              "x": 22.592,
              "y": 23.993,
              "z": 0.783
            },
            "rightCorner": {
              "x": 22.586,
              "y": 23.921,
              "z": 0.783
            },
            "gtin": "5060221208048",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546930",
        "height": 1.1575,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2130f",
            "leftCorner": {
              "x": 22.649,
              "y": 25.171,
              "z": 0.947
            },
            "rightCorner": {
              "x": 22.643,
              "y": 25.097,
              "z": 0.947
            },
            "gtin": "4064888000701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21310",
            "leftCorner": {
              "x": 22.643,
              "y": 25.097,
              "z": 0.947
            },
            "rightCorner": {
              "x": 22.636,
              "y": 25.022,
              "z": 0.947
            },
            "gtin": "4064888000701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21312",
            "leftCorner": {
              "x": 22.685,
              "y": 25.018,
              "z": 0.947
            },
            "rightCorner": {
              "x": 22.68,
              "y": 24.962,
              "z": 0.947
            },
            "gtin": "4064888000763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21313",
            "leftCorner": {
              "x": 22.68,
              "y": 24.962,
              "z": 0.947
            },
            "rightCorner": {
              "x": 22.676,
              "y": 24.906,
              "z": 0.947
            },
            "gtin": "4064888000763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21314",
            "leftCorner": {
              "x": 22.675,
              "y": 24.906,
              "z": 0.947
            },
            "rightCorner": {
              "x": 22.667,
              "y": 24.816,
              "z": 0.947
            },
            "gtin": "4064888001258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21315",
            "leftCorner": {
              "x": 22.647,
              "y": 24.817,
              "z": 0.947
            },
            "rightCorner": {
              "x": 22.634,
              "y": 24.673,
              "z": 0.947
            },
            "gtin": "4250519647890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21316",
            "leftCorner": {
              "x": 22.642,
              "y": 24.672,
              "z": 0.947
            },
            "rightCorner": {
              "x": 22.634,
              "y": 24.572,
              "z": 0.947
            },
            "gtin": "4250519668222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21317",
            "leftCorner": {
              "x": 22.634,
              "y": 24.572,
              "z": 0.947
            },
            "rightCorner": {
              "x": 22.625,
              "y": 24.464,
              "z": 0.947
            },
            "gtin": "4250519672885",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8b5ed67a01d9a21318",
            "leftCorner": {
              "x": 22.631,
              "y": 24.463,
              "z": 0.947
            },
            "rightCorner": {
              "x": 22.618,
              "y": 24.316,
              "z": 0.947
            },
            "gtin": "4250519672892",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8b5ed67a01d9a21319",
            "leftCorner": {
              "x": 22.606,
              "y": 24.317,
              "z": 0.947
            },
            "rightCorner": {
              "x": 22.599,
              "y": 24.235,
              "z": 0.947
            },
            "gtin": "4260446585431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2131a",
            "leftCorner": {
              "x": 22.599,
              "y": 24.235,
              "z": 0.947
            },
            "rightCorner": {
              "x": 22.592,
              "y": 24.153,
              "z": 0.947
            },
            "gtin": "4260446585431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2131b",
            "leftCorner": {
              "x": 22.603,
              "y": 24.152,
              "z": 0.947
            },
            "rightCorner": {
              "x": 22.596,
              "y": 24.072,
              "z": 0.947
            },
            "gtin": "4260644581143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2131c",
            "leftCorner": {
              "x": 22.596,
              "y": 24.072,
              "z": 0.947
            },
            "rightCorner": {
              "x": 22.59,
              "y": 23.993,
              "z": 0.947
            },
            "gtin": "4260644581143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2131d",
            "leftCorner": {
              "x": 22.594,
              "y": 23.993,
              "z": 0.947
            },
            "rightCorner": {
              "x": 22.584,
              "y": 23.872,
              "z": 0.947
            },
            "gtin": "4260446585639",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546931",
        "height": 1.3601,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a216bc",
            "leftCorner": {
              "x": 22.646,
              "y": 25.171,
              "z": 1.113
            },
            "rightCorner": {
              "x": 22.635,
              "y": 25.052,
              "z": 1.113
            },
            "gtin": "4260648131252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216bf",
            "leftCorner": {
              "x": 22.673,
              "y": 25.049,
              "z": 1.113
            },
            "rightCorner": {
              "x": 22.665,
              "y": 24.953,
              "z": 1.113
            },
            "gtin": "4260648131269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216c0",
            "leftCorner": {
              "x": 22.665,
              "y": 24.953,
              "z": 1.113
            },
            "rightCorner": {
              "x": 22.657,
              "y": 24.857,
              "z": 1.113
            },
            "gtin": "4260648131269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216c1",
            "leftCorner": {
              "x": 22.661,
              "y": 24.857,
              "z": 1.113
            },
            "rightCorner": {
              "x": 22.655,
              "y": 24.795,
              "z": 1.113
            },
            "gtin": "4260648132440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216c2",
            "leftCorner": {
              "x": 22.655,
              "y": 24.795,
              "z": 1.113
            },
            "rightCorner": {
              "x": 22.65,
              "y": 24.732,
              "z": 1.113
            },
            "gtin": "4260648132440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216c3",
            "leftCorner": {
              "x": 22.646,
              "y": 24.733,
              "z": 1.113
            },
            "rightCorner": {
              "x": 22.633,
              "y": 24.581,
              "z": 1.113
            },
            "gtin": "7340001801101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216c4",
            "leftCorner": {
              "x": 22.631,
              "y": 24.581,
              "z": 1.113
            },
            "rightCorner": {
              "x": 22.626,
              "y": 24.52,
              "z": 1.113
            },
            "gtin": "4260701928010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216c5",
            "leftCorner": {
              "x": 22.626,
              "y": 24.52,
              "z": 1.113
            },
            "rightCorner": {
              "x": 22.621,
              "y": 24.459,
              "z": 1.113
            },
            "gtin": "4260701928010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216c6",
            "leftCorner": {
              "x": 22.616,
              "y": 24.459,
              "z": 1.113
            },
            "rightCorner": {
              "x": 22.612,
              "y": 24.404,
              "z": 1.113
            },
            "gtin": "4260363488402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216c7",
            "leftCorner": {
              "x": 22.612,
              "y": 24.404,
              "z": 1.113
            },
            "rightCorner": {
              "x": 22.606,
              "y": 24.35,
              "z": 1.113
            },
            "gtin": "4260363488402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216c8",
            "leftCorner": {
              "x": 22.606,
              "y": 24.35,
              "z": 1.113
            },
            "rightCorner": {
              "x": 22.592,
              "y": 24.177,
              "z": 1.113
            },
            "gtin": "4260363489270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216c9",
            "leftCorner": {
              "x": 22.589,
              "y": 24.177,
              "z": 1.113
            },
            "rightCorner": {
              "x": 22.576,
              "y": 24.018,
              "z": 1.113
            },
            "gtin": "4251105517696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216bd",
            "leftCorner": {
              "x": 22.59,
              "y": 24.017,
              "z": 1.113
            },
            "rightCorner": {
              "x": 22.585,
              "y": 23.969,
              "z": 1.113
            },
            "gtin": "4260334140049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216be",
            "leftCorner": {
              "x": 22.585,
              "y": 23.969,
              "z": 1.113
            },
            "rightCorner": {
              "x": 22.582,
              "y": 23.922,
              "z": 1.113
            },
            "gtin": "4260334140049",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54692e",
        "height": 1.566,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21696",
            "leftCorner": {
              "x": 22.647,
              "y": 25.171,
              "z": 1.281
            },
            "rightCorner": {
              "x": 22.642,
              "y": 25.105,
              "z": 1.281
            },
            "gtin": "4260556631943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21697",
            "leftCorner": {
              "x": 22.642,
              "y": 25.105,
              "z": 1.281
            },
            "rightCorner": {
              "x": 22.635,
              "y": 25.04,
              "z": 1.281
            },
            "gtin": "4260556631943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2169a",
            "leftCorner": {
              "x": 22.671,
              "y": 25.038,
              "z": 1.281
            },
            "rightCorner": {
              "x": 22.665,
              "y": 24.96,
              "z": 1.281
            },
            "gtin": "4260556631936",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2169b",
            "leftCorner": {
              "x": 22.665,
              "y": 24.96,
              "z": 1.281
            },
            "rightCorner": {
              "x": 22.658,
              "y": 24.883,
              "z": 1.281
            },
            "gtin": "4260556631936",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2169c",
            "leftCorner": {
              "x": 22.668,
              "y": 24.881,
              "z": 1.281
            },
            "rightCorner": {
              "x": 22.655,
              "y": 24.729,
              "z": 1.281
            },
            "gtin": "4260556631950",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2169d",
            "leftCorner": {
              "x": 22.652,
              "y": 24.729,
              "z": 1.281
            },
            "rightCorner": {
              "x": 22.649,
              "y": 24.687,
              "z": 1.281
            },
            "gtin": "4260562940176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2169e",
            "leftCorner": {
              "x": 22.649,
              "y": 24.687,
              "z": 1.281
            },
            "rightCorner": {
              "x": 22.646,
              "y": 24.645,
              "z": 1.281
            },
            "gtin": "4260562940176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2169f",
            "leftCorner": {
              "x": 22.646,
              "y": 24.645,
              "z": 1.281
            },
            "rightCorner": {
              "x": 22.642,
              "y": 24.603,
              "z": 1.281
            },
            "gtin": "4260562940176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216a0",
            "leftCorner": {
              "x": 22.639,
              "y": 24.604,
              "z": 1.281
            },
            "rightCorner": {
              "x": 22.631,
              "y": 24.514,
              "z": 1.281
            },
            "gtin": "4260562940183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216a1",
            "leftCorner": {
              "x": 22.631,
              "y": 24.514,
              "z": 1.281
            },
            "rightCorner": {
              "x": 22.624,
              "y": 24.424,
              "z": 1.281
            },
            "gtin": "4260562940183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216a2",
            "leftCorner": {
              "x": 22.62,
              "y": 24.425,
              "z": 1.281
            },
            "rightCorner": {
              "x": 22.616,
              "y": 24.372,
              "z": 1.281
            },
            "gtin": "4260562940169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216a3",
            "leftCorner": {
              "x": 22.616,
              "y": 24.372,
              "z": 1.281
            },
            "rightCorner": {
              "x": 22.611,
              "y": 24.319,
              "z": 1.281
            },
            "gtin": "4260562940169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216a4",
            "leftCorner": {
              "x": 22.604,
              "y": 24.32,
              "z": 1.281
            },
            "rightCorner": {
              "x": 22.598,
              "y": 24.24,
              "z": 1.281
            },
            "gtin": "4260562940275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216a5",
            "leftCorner": {
              "x": 22.598,
              "y": 24.24,
              "z": 1.281
            },
            "rightCorner": {
              "x": 22.591,
              "y": 24.159,
              "z": 1.281
            },
            "gtin": "4260562940275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216a6",
            "leftCorner": {
              "x": 22.599,
              "y": 24.158,
              "z": 1.281
            },
            "rightCorner": {
              "x": 22.594,
              "y": 24.097,
              "z": 1.281
            },
            "gtin": "4260562940268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216a7",
            "leftCorner": {
              "x": 22.594,
              "y": 24.097,
              "z": 1.281
            },
            "rightCorner": {
              "x": 22.589,
              "y": 24.037,
              "z": 1.281
            },
            "gtin": "4260562940268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21698",
            "leftCorner": {
              "x": 22.59,
              "y": 24.037,
              "z": 1.281
            },
            "rightCorner": {
              "x": 22.585,
              "y": 23.98,
              "z": 1.281
            },
            "gtin": "4260562940237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21699",
            "leftCorner": {
              "x": 22.585,
              "y": 23.98,
              "z": 1.281
            },
            "rightCorner": {
              "x": 22.58,
              "y": 23.923,
              "z": 1.281
            },
            "gtin": "4260562940237",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546932",
        "height": 1.7577,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ea62",
            "leftCorner": {
              "x": 22.684,
              "y": 25.127,
              "z": 1.438
            },
            "rightCorner": {
              "x": 22.678,
              "y": 25.058,
              "z": 1.438
            },
            "gtin": "4260648132747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea63",
            "leftCorner": {
              "x": 22.678,
              "y": 25.058,
              "z": 1.438
            },
            "rightCorner": {
              "x": 22.672,
              "y": 24.99,
              "z": 1.438
            },
            "gtin": "4260648132747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea64",
            "leftCorner": {
              "x": 22.68,
              "y": 24.989,
              "z": 1.438
            },
            "rightCorner": {
              "x": 22.674,
              "y": 24.906,
              "z": 1.438
            },
            "gtin": "4255582805505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea65",
            "leftCorner": {
              "x": 22.674,
              "y": 24.906,
              "z": 1.438
            },
            "rightCorner": {
              "x": 22.666,
              "y": 24.823,
              "z": 1.438
            },
            "gtin": "4255582805505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea66",
            "leftCorner": {
              "x": 22.652,
              "y": 24.824,
              "z": 1.438
            },
            "rightCorner": {
              "x": 22.648,
              "y": 24.772,
              "z": 1.438
            },
            "gtin": "4255582812527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea67",
            "leftCorner": {
              "x": 22.648,
              "y": 24.772,
              "z": 1.438
            },
            "rightCorner": {
              "x": 22.644,
              "y": 24.72,
              "z": 1.438
            },
            "gtin": "4255582812527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea68",
            "leftCorner": {
              "x": 22.644,
              "y": 24.72,
              "z": 1.438
            },
            "rightCorner": {
              "x": 22.639,
              "y": 24.668,
              "z": 1.438
            },
            "gtin": "4255582812527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea69",
            "leftCorner": {
              "x": 22.638,
              "y": 24.668,
              "z": 1.438
            },
            "rightCorner": {
              "x": 22.633,
              "y": 24.606,
              "z": 1.438
            },
            "gtin": "4255582812510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea6a",
            "leftCorner": {
              "x": 22.633,
              "y": 24.606,
              "z": 1.438
            },
            "rightCorner": {
              "x": 22.628,
              "y": 24.545,
              "z": 1.438
            },
            "gtin": "4255582812510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea6b",
            "leftCorner": {
              "x": 22.634,
              "y": 24.544,
              "z": 1.438
            },
            "rightCorner": {
              "x": 22.63,
              "y": 24.504,
              "z": 1.438
            },
            "gtin": "4260654789119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea6c",
            "leftCorner": {
              "x": 22.63,
              "y": 24.504,
              "z": 1.438
            },
            "rightCorner": {
              "x": 22.627,
              "y": 24.464,
              "z": 1.438
            },
            "gtin": "4260654789119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea6d",
            "leftCorner": {
              "x": 22.627,
              "y": 24.464,
              "z": 1.438
            },
            "rightCorner": {
              "x": 22.624,
              "y": 24.424,
              "z": 1.438
            },
            "gtin": "4260654789119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea6e",
            "leftCorner": {
              "x": 22.624,
              "y": 24.424,
              "z": 1.438
            },
            "rightCorner": {
              "x": 22.621,
              "y": 24.385,
              "z": 1.438
            },
            "gtin": "4260654789119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea6f",
            "leftCorner": {
              "x": 22.618,
              "y": 24.385,
              "z": 1.438
            },
            "rightCorner": {
              "x": 22.613,
              "y": 24.329,
              "z": 1.438
            },
            "gtin": "4260718295884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea70",
            "leftCorner": {
              "x": 22.613,
              "y": 24.329,
              "z": 1.438
            },
            "rightCorner": {
              "x": 22.608,
              "y": 24.273,
              "z": 1.438
            },
            "gtin": "4260718295884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea71",
            "leftCorner": {
              "x": 22.608,
              "y": 24.273,
              "z": 1.438
            },
            "rightCorner": {
              "x": 22.604,
              "y": 24.218,
              "z": 1.438
            },
            "gtin": "4260718295884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea72",
            "leftCorner": {
              "x": 22.604,
              "y": 24.218,
              "z": 1.438
            },
            "rightCorner": {
              "x": 22.598,
              "y": 24.162,
              "z": 1.438
            },
            "gtin": "4260718295884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea73",
            "leftCorner": {
              "x": 22.586,
              "y": 24.162,
              "z": 1.438
            },
            "rightCorner": {
              "x": 22.572,
              "y": 23.992,
              "z": 1.438
            },
            "gtin": "4255582800487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea74",
            "leftCorner": {
              "x": 22.583,
              "y": 23.99,
              "z": 1.438
            },
            "rightCorner": {
              "x": 22.574,
              "y": 23.893,
              "z": 1.438
            },
            "gtin": "4260648134314",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "9300d",
    "rightNeighborShelfId": "9300f"
  },
  {
    "id": "9300f",
    "name": "9300f",
    "x": 22.539,
    "y": 23.925,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73645,
      "w": 0.67649
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 41
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54693b",
        "height": 0.15694,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e9d7",
            "leftCorner": {
              "x": 22.587,
              "y": 23.833,
              "z": 0.128
            },
            "rightCorner": {
              "x": 22.563,
              "y": 23.555,
              "z": 0.128
            },
            "gtin": "4063367212833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9d8",
            "leftCorner": {
              "x": 22.563,
              "y": 23.555,
              "z": 0.128
            },
            "rightCorner": {
              "x": 22.54,
              "y": 23.276,
              "z": 0.128
            },
            "gtin": "4063367212833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9d9",
            "leftCorner": {
              "x": 22.546,
              "y": 23.276,
              "z": 0.128
            },
            "rightCorner": {
              "x": 22.515,
              "y": 22.92,
              "z": 0.128
            },
            "gtin": "4337185523717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9aa",
            "leftCorner": {
              "x": 22.5,
              "y": 22.922,
              "z": 0.128
            },
            "rightCorner": {
              "x": 22.489,
              "y": 22.799,
              "z": 0.128
            },
            "gtin": "4011676006001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e9ab",
            "leftCorner": {
              "x": 22.489,
              "y": 22.799,
              "z": 0.128
            },
            "rightCorner": {
              "x": 22.478,
              "y": 22.675,
              "z": 0.128
            },
            "gtin": "4011676006001",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546938",
        "height": 0.49783,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a212fd",
            "leftCorner": {
              "x": 22.538,
              "y": 23.925,
              "z": 0.407
            },
            "rightCorner": {
              "x": 22.501,
              "y": 23.498,
              "z": 0.407
            },
            "gtin": "4063367384066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21300",
            "leftCorner": {
              "x": 22.537,
              "y": 23.495,
              "z": 0.407
            },
            "rightCorner": {
              "x": 22.511,
              "y": 23.194,
              "z": 0.407
            },
            "gtin": "4063367341113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21301",
            "leftCorner": {
              "x": 22.531,
              "y": 23.193,
              "z": 0.407
            },
            "rightCorner": {
              "x": 22.519,
              "y": 23.046,
              "z": 0.407
            },
            "gtin": "4063367384080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21302",
            "leftCorner": {
              "x": 22.519,
              "y": 23.046,
              "z": 0.407
            },
            "rightCorner": {
              "x": 22.507,
              "y": 22.9,
              "z": 0.407
            },
            "gtin": "4063367384080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21303",
            "leftCorner": {
              "x": 22.507,
              "y": 22.9,
              "z": 0.407
            },
            "rightCorner": {
              "x": 22.494,
              "y": 22.754,
              "z": 0.407
            },
            "gtin": "4063367384080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21304",
            "leftCorner": {
              "x": 22.486,
              "y": 22.754,
              "z": 0.407
            },
            "rightCorner": {
              "x": 22.475,
              "y": 22.619,
              "z": 0.407
            },
            "gtin": "4000415000486",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546939",
        "height": 0.84721,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a216da",
            "leftCorner": {
              "x": 22.54,
              "y": 23.925,
              "z": 0.693
            },
            "rightCorner": {
              "x": 22.529,
              "y": 23.799,
              "z": 0.693
            },
            "gtin": "4017100219016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216db",
            "leftCorner": {
              "x": 22.529,
              "y": 23.799,
              "z": 0.693
            },
            "rightCorner": {
              "x": 22.519,
              "y": 23.674,
              "z": 0.693
            },
            "gtin": "4017100219016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216de",
            "leftCorner": {
              "x": 22.562,
              "y": 23.67,
              "z": 0.693
            },
            "rightCorner": {
              "x": 22.552,
              "y": 23.552,
              "z": 0.693
            },
            "gtin": "4017100254819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216df",
            "leftCorner": {
              "x": 22.552,
              "y": 23.552,
              "z": 0.693
            },
            "rightCorner": {
              "x": 22.541,
              "y": 23.433,
              "z": 0.693
            },
            "gtin": "4017100254819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216e0",
            "leftCorner": {
              "x": 22.538,
              "y": 23.434,
              "z": 0.693
            },
            "rightCorner": {
              "x": 22.515,
              "y": 23.159,
              "z": 0.693
            },
            "gtin": "4017100284410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216e1",
            "leftCorner": {
              "x": 22.517,
              "y": 23.159,
              "z": 0.693
            },
            "rightCorner": {
              "x": 22.498,
              "y": 22.924,
              "z": 0.693
            },
            "gtin": "4017100282812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216dc",
            "leftCorner": {
              "x": 22.501,
              "y": 22.923,
              "z": 0.693
            },
            "rightCorner": {
              "x": 22.49,
              "y": 22.799,
              "z": 0.693
            },
            "gtin": "4017100406317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216dd",
            "leftCorner": {
              "x": 22.49,
              "y": 22.799,
              "z": 0.693
            },
            "rightCorner": {
              "x": 22.48,
              "y": 22.675,
              "z": 0.693
            },
            "gtin": "4017100406317",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546936",
        "height": 1.1597,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2131e",
            "leftCorner": {
              "x": 22.576,
              "y": 23.872,
              "z": 0.949
            },
            "rightCorner": {
              "x": 22.567,
              "y": 23.77,
              "z": 0.949
            },
            "gtin": "7613287202833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2131f",
            "leftCorner": {
              "x": 22.567,
              "y": 23.77,
              "z": 0.949
            },
            "rightCorner": {
              "x": 22.559,
              "y": 23.668,
              "z": 0.949
            },
            "gtin": "7613287202833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21320",
            "leftCorner": {
              "x": 22.559,
              "y": 23.668,
              "z": 0.949
            },
            "rightCorner": {
              "x": 22.55,
              "y": 23.566,
              "z": 0.949
            },
            "gtin": "7613287202833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21321",
            "leftCorner": {
              "x": 22.55,
              "y": 23.566,
              "z": 0.949
            },
            "rightCorner": {
              "x": 22.541,
              "y": 23.465,
              "z": 0.949
            },
            "gtin": "7613287202833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21322",
            "leftCorner": {
              "x": 22.541,
              "y": 23.465,
              "z": 0.949
            },
            "rightCorner": {
              "x": 22.533,
              "y": 23.363,
              "z": 0.949
            },
            "gtin": "7613287202833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21323",
            "leftCorner": {
              "x": 22.53,
              "y": 23.363,
              "z": 0.949
            },
            "rightCorner": {
              "x": 22.505,
              "y": 23.059,
              "z": 0.949
            },
            "gtin": "7622202259463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21324",
            "leftCorner": {
              "x": 22.498,
              "y": 23.059,
              "z": 0.949
            },
            "rightCorner": {
              "x": 22.487,
              "y": 22.928,
              "z": 0.949
            },
            "gtin": "8420241150708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21325",
            "leftCorner": {
              "x": 22.487,
              "y": 22.928,
              "z": 0.949
            },
            "rightCorner": {
              "x": 22.476,
              "y": 22.797,
              "z": 0.949
            },
            "gtin": "8420241150708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21326",
            "leftCorner": {
              "x": 22.483,
              "y": 22.796,
              "z": 0.949
            },
            "rightCorner": {
              "x": 22.476,
              "y": 22.719,
              "z": 0.949
            },
            "gtin": "4000607000232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21327",
            "leftCorner": {
              "x": 22.476,
              "y": 22.719,
              "z": 0.949
            },
            "rightCorner": {
              "x": 22.469,
              "y": 22.643,
              "z": 0.949
            },
            "gtin": "4000607000232",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54693a",
        "height": 1.4527,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2133a",
            "leftCorner": {
              "x": 22.533,
              "y": 23.925,
              "z": 1.189
            },
            "rightCorner": {
              "x": 22.496,
              "y": 23.492,
              "z": 1.189
            },
            "gtin": "3800020453544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2133b",
            "leftCorner": {
              "x": 22.496,
              "y": 23.492,
              "z": 1.189
            },
            "rightCorner": {
              "x": 22.459,
              "y": 23.058,
              "z": 1.189
            },
            "gtin": "3800020453544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2133f",
            "leftCorner": {
              "x": 22.503,
              "y": 23.055,
              "z": 1.189
            },
            "rightCorner": {
              "x": 22.482,
              "y": 22.816,
              "z": 1.189
            },
            "gtin": "7613038427782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21340",
            "leftCorner": {
              "x": 22.482,
              "y": 22.816,
              "z": 1.189
            },
            "rightCorner": {
              "x": 22.462,
              "y": 22.576,
              "z": 1.189
            },
            "gtin": "7613038427782",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546937",
        "height": 1.7527,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ea75",
            "leftCorner": {
              "x": 22.566,
              "y": 23.893,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.558,
              "y": 23.803,
              "z": 1.434
            },
            "gtin": "4021700800529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea76",
            "leftCorner": {
              "x": 22.558,
              "y": 23.803,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.551,
              "y": 23.713,
              "z": 1.434
            },
            "gtin": "4021700800529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea77",
            "leftCorner": {
              "x": 22.555,
              "y": 23.713,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.546,
              "y": 23.605,
              "z": 1.434
            },
            "gtin": "4021700805043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea78",
            "leftCorner": {
              "x": 22.546,
              "y": 23.605,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.536,
              "y": 23.496,
              "z": 1.434
            },
            "gtin": "4021700805043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea79",
            "leftCorner": {
              "x": 22.531,
              "y": 23.498,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.507,
              "y": 23.212,
              "z": 1.434
            },
            "gtin": "7613287138651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea7a",
            "leftCorner": {
              "x": 22.507,
              "y": 23.212,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.483,
              "y": 22.927,
              "z": 1.434
            },
            "gtin": "7613287138651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea7b",
            "leftCorner": {
              "x": 22.484,
              "y": 22.927,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.472,
              "y": 22.791,
              "z": 1.434
            },
            "gtin": "3800020492956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea7c",
            "leftCorner": {
              "x": 22.472,
              "y": 22.791,
              "z": 1.434
            },
            "rightCorner": {
              "x": 22.461,
              "y": 22.653,
              "z": 1.434
            },
            "gtin": "3800020492956",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "9300e",
    "rightNeighborShelfId": "93010"
  },
  {
    "id": "93010",
    "name": "93010",
    "x": 22.433,
    "y": 22.68,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73645,
      "w": 0.67649
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 33
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54685c",
        "height": 0.14232,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21356",
            "leftCorner": {
              "x": 22.45,
              "y": 22.678,
              "z": 0.116
            },
            "rightCorner": {
              "x": 22.421,
              "y": 22.347,
              "z": 0.116
            },
            "gtin": "4063367211232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21357",
            "leftCorner": {
              "x": 22.421,
              "y": 22.347,
              "z": 0.116
            },
            "rightCorner": {
              "x": 22.394,
              "y": 22.017,
              "z": 0.116
            },
            "gtin": "4063367211232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21359",
            "leftCorner": {
              "x": 22.426,
              "y": 22.014,
              "z": 0.116
            },
            "rightCorner": {
              "x": 22.367,
              "y": 21.332,
              "z": 0.116
            },
            "gtin": "4063367211157",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546859",
        "height": 0.50353,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21305",
            "leftCorner": {
              "x": 22.466,
              "y": 22.62,
              "z": 0.412
            },
            "rightCorner": {
              "x": 22.448,
              "y": 22.418,
              "z": 0.412
            },
            "gtin": "4000607000065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21306",
            "leftCorner": {
              "x": 22.448,
              "y": 22.418,
              "z": 0.412
            },
            "rightCorner": {
              "x": 22.432,
              "y": 22.216,
              "z": 0.412
            },
            "gtin": "4000607000065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21307",
            "leftCorner": {
              "x": 22.444,
              "y": 22.215,
              "z": 0.412
            },
            "rightCorner": {
              "x": 22.351,
              "y": 21.115,
              "z": 0.412
            },
            "gtin": "4000607000102",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546857",
        "height": 0.85741,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a212ed",
            "leftCorner": {
              "x": 22.428,
              "y": 22.68,
              "z": 0.702
            },
            "rightCorner": {
              "x": 22.415,
              "y": 22.524,
              "z": 0.702
            },
            "gtin": "4017100406218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212ee",
            "leftCorner": {
              "x": 22.415,
              "y": 22.524,
              "z": 0.702
            },
            "rightCorner": {
              "x": 22.401,
              "y": 22.369,
              "z": 0.702
            },
            "gtin": "4017100406218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212f1",
            "leftCorner": {
              "x": 22.453,
              "y": 22.363,
              "z": 0.702
            },
            "rightCorner": {
              "x": 22.411,
              "y": 21.863,
              "z": 0.702
            },
            "gtin": "4063367211270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212f2",
            "leftCorner": {
              "x": 22.411,
              "y": 21.863,
              "z": 0.702
            },
            "rightCorner": {
              "x": 22.368,
              "y": 21.361,
              "z": 0.702
            },
            "gtin": "4063367211270",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54685a",
        "height": 1.1498,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21328",
            "leftCorner": {
              "x": 22.467,
              "y": 22.643,
              "z": 0.941
            },
            "rightCorner": {
              "x": 22.451,
              "y": 22.45,
              "z": 0.941
            },
            "gtin": "4337185180057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21329",
            "leftCorner": {
              "x": 22.451,
              "y": 22.45,
              "z": 0.941
            },
            "rightCorner": {
              "x": 22.434,
              "y": 22.258,
              "z": 0.941
            },
            "gtin": "4337185180057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2132a",
            "leftCorner": {
              "x": 22.434,
              "y": 22.258,
              "z": 0.941
            },
            "rightCorner": {
              "x": 22.418,
              "y": 22.066,
              "z": 0.941
            },
            "gtin": "4337185180057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2132b",
            "leftCorner": {
              "x": 22.418,
              "y": 22.066,
              "z": 0.941
            },
            "rightCorner": {
              "x": 22.401,
              "y": 21.873,
              "z": 0.941
            },
            "gtin": "4337185180057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2132c",
            "leftCorner": {
              "x": 22.401,
              "y": 21.873,
              "z": 0.941
            },
            "rightCorner": {
              "x": 22.386,
              "y": 21.681,
              "z": 0.941
            },
            "gtin": "4337185180057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2132d",
            "leftCorner": {
              "x": 22.382,
              "y": 21.681,
              "z": 0.941
            },
            "rightCorner": {
              "x": 22.354,
              "y": 21.352,
              "z": 0.941
            },
            "gtin": "4014400930429",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54685b",
        "height": 1.4504,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21341",
            "leftCorner": {
              "x": 22.453,
              "y": 22.577,
              "z": 1.187
            },
            "rightCorner": {
              "x": 22.445,
              "y": 22.481,
              "z": 1.187
            },
            "gtin": "4337185443558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21342",
            "leftCorner": {
              "x": 22.445,
              "y": 22.481,
              "z": 1.187
            },
            "rightCorner": {
              "x": 22.437,
              "y": 22.387,
              "z": 1.187
            },
            "gtin": "4337185443558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21343",
            "leftCorner": {
              "x": 22.437,
              "y": 22.387,
              "z": 1.187
            },
            "rightCorner": {
              "x": 22.429,
              "y": 22.291,
              "z": 1.187
            },
            "gtin": "4337185443558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21344",
            "leftCorner": {
              "x": 22.441,
              "y": 22.291,
              "z": 1.187
            },
            "rightCorner": {
              "x": 22.423,
              "y": 22.088,
              "z": 1.187
            },
            "gtin": "7622201790509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21345",
            "leftCorner": {
              "x": 22.423,
              "y": 22.088,
              "z": 1.187
            },
            "rightCorner": {
              "x": 22.413,
              "y": 21.97,
              "z": 1.187
            },
            "gtin": "7622201789527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21346",
            "leftCorner": {
              "x": 22.413,
              "y": 21.97,
              "z": 1.187
            },
            "rightCorner": {
              "x": 22.403,
              "y": 21.852,
              "z": 1.187
            },
            "gtin": "7622201789527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21347",
            "leftCorner": {
              "x": 22.395,
              "y": 21.853,
              "z": 1.187
            },
            "rightCorner": {
              "x": 22.377,
              "y": 21.646,
              "z": 1.187
            },
            "gtin": "4000607487903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21348",
            "leftCorner": {
              "x": 22.374,
              "y": 21.646,
              "z": 1.187
            },
            "rightCorner": {
              "x": 22.353,
              "y": 21.387,
              "z": 1.187
            },
            "gtin": "8593893769687",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546858",
        "height": 1.7486,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ea7d",
            "leftCorner": {
              "x": 22.458,
              "y": 22.654,
              "z": 1.431
            },
            "rightCorner": {
              "x": 22.45,
              "y": 22.562,
              "z": 1.431
            },
            "gtin": "3800020411957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea7e",
            "leftCorner": {
              "x": 22.45,
              "y": 22.562,
              "z": 1.431
            },
            "rightCorner": {
              "x": 22.442,
              "y": 22.469,
              "z": 1.431
            },
            "gtin": "3800020411957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea7f",
            "leftCorner": {
              "x": 22.446,
              "y": 22.469,
              "z": 1.431
            },
            "rightCorner": {
              "x": 22.439,
              "y": 22.389,
              "z": 1.431
            },
            "gtin": "7622210704764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea80",
            "leftCorner": {
              "x": 22.439,
              "y": 22.389,
              "z": 1.431
            },
            "rightCorner": {
              "x": 22.433,
              "y": 22.309,
              "z": 1.431
            },
            "gtin": "7622210704764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea81",
            "leftCorner": {
              "x": 22.433,
              "y": 22.309,
              "z": 1.431
            },
            "rightCorner": {
              "x": 22.422,
              "y": 22.186,
              "z": 1.431
            },
            "gtin": "7622210786128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea82",
            "leftCorner": {
              "x": 22.422,
              "y": 22.186,
              "z": 1.431
            },
            "rightCorner": {
              "x": 22.412,
              "y": 22.064,
              "z": 1.431
            },
            "gtin": "7622210786128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea83",
            "leftCorner": {
              "x": 22.406,
              "y": 22.064,
              "z": 1.431
            },
            "rightCorner": {
              "x": 22.37,
              "y": 21.642,
              "z": 1.431
            },
            "gtin": "7622210696861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea84",
            "leftCorner": {
              "x": 22.383,
              "y": 21.641,
              "z": 1.431
            },
            "rightCorner": {
              "x": 22.371,
              "y": 21.498,
              "z": 1.431
            },
            "gtin": "7622210696885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea85",
            "leftCorner": {
              "x": 22.371,
              "y": 21.498,
              "z": 1.431
            },
            "rightCorner": {
              "x": 22.36,
              "y": 21.356,
              "z": 1.431
            },
            "gtin": "7622210696885",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "9300f",
    "rightNeighborShelfId": "93011"
  },
  {
    "id": "93011",
    "name": "93011",
    "x": 22.327,
    "y": 21.434,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73645,
      "w": 0.67649
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546940",
        "height": 0.14977,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2135a",
            "leftCorner": {
              "x": 22.367,
              "y": 21.332,
              "z": 0.123
            },
            "rightCorner": {
              "x": 22.263,
              "y": 20.104,
              "z": 0.123
            },
            "gtin": "4000607000089",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546941",
        "height": 0.49355,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21308",
            "leftCorner": {
              "x": 22.342,
              "y": 21.116,
              "z": 0.404
            },
            "rightCorner": {
              "x": 22.289,
              "y": 20.499,
              "z": 0.404
            },
            "gtin": "4014400928907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21309",
            "leftCorner": {
              "x": 22.287,
              "y": 20.499,
              "z": 0.404
            },
            "rightCorner": {
              "x": 22.256,
              "y": 20.127,
              "z": 0.404
            },
            "gtin": "4014400928952",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54693f",
        "height": 0.85253,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a212f3",
            "leftCorner": {
              "x": 22.36,
              "y": 21.361,
              "z": 0.698
            },
            "rightCorner": {
              "x": 22.344,
              "y": 21.18,
              "z": 0.698
            },
            "gtin": "7613287109552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212f4",
            "leftCorner": {
              "x": 22.344,
              "y": 21.18,
              "z": 0.698
            },
            "rightCorner": {
              "x": 22.328,
              "y": 21.0,
              "z": 0.698
            },
            "gtin": "7613287109552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212f5",
            "leftCorner": {
              "x": 22.332,
              "y": 21.0,
              "z": 0.698
            },
            "rightCorner": {
              "x": 22.307,
              "y": 20.705,
              "z": 0.698
            },
            "gtin": "7613287199577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212f6",
            "leftCorner": {
              "x": 22.304,
              "y": 20.706,
              "z": 0.698
            },
            "rightCorner": {
              "x": 22.252,
              "y": 20.108,
              "z": 0.698
            },
            "gtin": "8445291425156",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54693e",
        "height": 1.1487,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2132e",
            "leftCorner": {
              "x": 22.356,
              "y": 21.351,
              "z": 0.94
            },
            "rightCorner": {
              "x": 22.329,
              "y": 21.041,
              "z": 0.94
            },
            "gtin": "4014400932355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2132f",
            "leftCorner": {
              "x": 22.329,
              "y": 21.041,
              "z": 0.94
            },
            "rightCorner": {
              "x": 22.31,
              "y": 20.82,
              "z": 0.94
            },
            "gtin": "4014400933833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21330",
            "leftCorner": {
              "x": 22.306,
              "y": 20.82,
              "z": 0.94
            },
            "rightCorner": {
              "x": 22.291,
              "y": 20.644,
              "z": 0.94
            },
            "gtin": "4014400931280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21331",
            "leftCorner": {
              "x": 22.291,
              "y": 20.644,
              "z": 0.94
            },
            "rightCorner": {
              "x": 22.276,
              "y": 20.466,
              "z": 0.94
            },
            "gtin": "4014400931280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21332",
            "leftCorner": {
              "x": 22.276,
              "y": 20.466,
              "z": 0.94
            },
            "rightCorner": {
              "x": 22.261,
              "y": 20.29,
              "z": 0.94
            },
            "gtin": "4014400931280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21333",
            "leftCorner": {
              "x": 22.261,
              "y": 20.29,
              "z": 0.94
            },
            "rightCorner": {
              "x": 22.246,
              "y": 20.113,
              "z": 0.94
            },
            "gtin": "4014400931280",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54693c",
        "height": 1.4565,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21349",
            "leftCorner": {
              "x": 22.341,
              "y": 21.388,
              "z": 1.192
            },
            "rightCorner": {
              "x": 22.326,
              "y": 21.212,
              "z": 1.192
            },
            "gtin": "4014400929065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2134a",
            "leftCorner": {
              "x": 22.326,
              "y": 21.212,
              "z": 1.192
            },
            "rightCorner": {
              "x": 22.311,
              "y": 21.035,
              "z": 1.192
            },
            "gtin": "4014400929065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2134b",
            "leftCorner": {
              "x": 22.323,
              "y": 21.033,
              "z": 1.192
            },
            "rightCorner": {
              "x": 22.284,
              "y": 20.576,
              "z": 1.192
            },
            "gtin": "5000159556637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2134c",
            "leftCorner": {
              "x": 22.284,
              "y": 20.576,
              "z": 1.192
            },
            "rightCorner": {
              "x": 22.245,
              "y": 20.12,
              "z": 1.192
            },
            "gtin": "5000159556637",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54693d",
        "height": 1.7503,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ea86",
            "leftCorner": {
              "x": 22.353,
              "y": 21.356,
              "z": 1.432
            },
            "rightCorner": {
              "x": 22.336,
              "y": 21.146,
              "z": 1.432
            },
            "gtin": "4014400929355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea87",
            "leftCorner": {
              "x": 22.333,
              "y": 21.146,
              "z": 1.432
            },
            "rightCorner": {
              "x": 22.325,
              "y": 21.056,
              "z": 1.432
            },
            "gtin": "4014400929379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea88",
            "leftCorner": {
              "x": 22.321,
              "y": 21.056,
              "z": 1.432
            },
            "rightCorner": {
              "x": 22.294,
              "y": 20.741,
              "z": 1.432
            },
            "gtin": "4014400929010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea89",
            "leftCorner": {
              "x": 22.294,
              "y": 20.741,
              "z": 1.432
            },
            "rightCorner": {
              "x": 22.268,
              "y": 20.425,
              "z": 1.432
            },
            "gtin": "4014400929010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea8a",
            "leftCorner": {
              "x": 22.268,
              "y": 20.425,
              "z": 1.432
            },
            "rightCorner": {
              "x": 22.242,
              "y": 20.111,
              "z": 1.432
            },
            "gtin": "4014400929010",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "93010",
    "rightNeighborShelfId": "93012"
  },
  {
    "id": "93012",
    "name": "93012",
    "x": 22.221,
    "y": 20.189,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.73645,
      "w": 0.67649
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 46
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546944",
        "height": 1.4596,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2134f",
            "leftCorner": {
              "x": 22.225,
              "y": 19.754,
              "z": 1.194
            },
            "rightCorner": {
              "x": 22.221,
              "y": 19.705,
              "z": 1.194
            },
            "gtin": "5000159557344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21350",
            "leftCorner": {
              "x": 22.219,
              "y": 19.705,
              "z": 1.194
            },
            "rightCorner": {
              "x": 22.207,
              "y": 19.572,
              "z": 1.194
            },
            "gtin": "5000159557702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21351",
            "leftCorner": {
              "x": 22.208,
              "y": 19.572,
              "z": 1.194
            },
            "rightCorner": {
              "x": 22.198,
              "y": 19.445,
              "z": 1.194
            },
            "gtin": "5000159556897",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21352",
            "leftCorner": {
              "x": 22.198,
              "y": 19.445,
              "z": 1.194
            },
            "rightCorner": {
              "x": 22.187,
              "y": 19.318,
              "z": 1.194
            },
            "gtin": "5000159556897",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21353",
            "leftCorner": {
              "x": 22.177,
              "y": 19.319,
              "z": 1.194
            },
            "rightCorner": {
              "x": 22.172,
              "y": 19.259,
              "z": 1.194
            },
            "gtin": "5000159472852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21354",
            "leftCorner": {
              "x": 22.172,
              "y": 19.259,
              "z": 1.194
            },
            "rightCorner": {
              "x": 22.167,
              "y": 19.2,
              "z": 1.194
            },
            "gtin": "5000159472852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21355",
            "leftCorner": {
              "x": 22.167,
              "y": 19.2,
              "z": 1.194
            },
            "rightCorner": {
              "x": 22.162,
              "y": 19.141,
              "z": 1.194
            },
            "gtin": "5000159472852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2133c",
            "leftCorner": {
              "x": 22.174,
              "y": 19.139,
              "z": 1.194
            },
            "rightCorner": {
              "x": 22.168,
              "y": 19.072,
              "z": 1.194
            },
            "gtin": "5000159474818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2133d",
            "leftCorner": {
              "x": 22.168,
              "y": 19.072,
              "z": 1.194
            },
            "rightCorner": {
              "x": 22.162,
              "y": 19.006,
              "z": 1.194
            },
            "gtin": "5000159474818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2133e",
            "leftCorner": {
              "x": 22.162,
              "y": 19.006,
              "z": 1.194
            },
            "rightCorner": {
              "x": 22.157,
              "y": 18.939,
              "z": 1.194
            },
            "gtin": "5000159474818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2134d",
            "leftCorner": {
              "x": 22.245,
              "y": 20.121,
              "z": 1.194
            },
            "rightCorner": {
              "x": 22.219,
              "y": 19.806,
              "z": 1.194
            },
            "gtin": "5900951311390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2134e",
            "leftCorner": {
              "x": 22.23,
              "y": 19.805,
              "z": 1.194
            },
            "rightCorner": {
              "x": 22.225,
              "y": 19.754,
              "z": 1.194
            },
            "gtin": "5000159557344",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546947",
        "height": 0.14977,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2135b",
            "leftCorner": {
              "x": 22.277,
              "y": 20.103,
              "z": 0.123
            },
            "rightCorner": {
              "x": 22.252,
              "y": 19.807,
              "z": 0.123
            },
            "gtin": "5000159557665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2135c",
            "leftCorner": {
              "x": 22.252,
              "y": 19.807,
              "z": 0.123
            },
            "rightCorner": {
              "x": 22.226,
              "y": 19.511,
              "z": 0.123
            },
            "gtin": "5000159557665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2135d",
            "leftCorner": {
              "x": 22.214,
              "y": 19.512,
              "z": 0.123
            },
            "rightCorner": {
              "x": 22.206,
              "y": 19.402,
              "z": 0.123
            },
            "gtin": "5000159561204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2135e",
            "leftCorner": {
              "x": 22.206,
              "y": 19.402,
              "z": 0.123
            },
            "rightCorner": {
              "x": 22.196,
              "y": 19.293,
              "z": 0.123
            },
            "gtin": "5000159561204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2135f",
            "leftCorner": {
              "x": 22.196,
              "y": 19.293,
              "z": 0.123
            },
            "rightCorner": {
              "x": 22.187,
              "y": 19.183,
              "z": 0.123
            },
            "gtin": "5000159561204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21358",
            "leftCorner": {
              "x": 22.168,
              "y": 19.184,
              "z": 0.123
            },
            "rightCorner": {
              "x": 22.147,
              "y": 18.94,
              "z": 0.123
            },
            "gtin": "7613287109583",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546942",
        "height": 0.49923,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2130a",
            "leftCorner": {
              "x": 22.255,
              "y": 20.128,
              "z": 0.408
            },
            "rightCorner": {
              "x": 22.241,
              "y": 19.974,
              "z": 0.408
            },
            "gtin": "5000159562294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2130b",
            "leftCorner": {
              "x": 22.241,
              "y": 19.974,
              "z": 0.408
            },
            "rightCorner": {
              "x": 22.229,
              "y": 19.82,
              "z": 0.408
            },
            "gtin": "5000159562294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2130c",
            "leftCorner": {
              "x": 22.238,
              "y": 19.818,
              "z": 0.408
            },
            "rightCorner": {
              "x": 22.209,
              "y": 19.48,
              "z": 0.408
            },
            "gtin": "5000159562232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2130d",
            "leftCorner": {
              "x": 22.199,
              "y": 19.481,
              "z": 0.408
            },
            "rightCorner": {
              "x": 22.185,
              "y": 19.324,
              "z": 0.408
            },
            "gtin": "5000159561464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2130e",
            "leftCorner": {
              "x": 22.185,
              "y": 19.324,
              "z": 0.408
            },
            "rightCorner": {
              "x": 22.173,
              "y": 19.167,
              "z": 0.408
            },
            "gtin": "5000159561464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212fe",
            "leftCorner": {
              "x": 22.181,
              "y": 19.166,
              "z": 0.408
            },
            "rightCorner": {
              "x": 22.172,
              "y": 19.052,
              "z": 0.408
            },
            "gtin": "5000159562676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212ff",
            "leftCorner": {
              "x": 22.172,
              "y": 19.052,
              "z": 0.408
            },
            "rightCorner": {
              "x": 22.162,
              "y": 18.939,
              "z": 0.408
            },
            "gtin": "5000159562676",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546946",
        "height": 0.85706,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a212f7",
            "leftCorner": {
              "x": 22.244,
              "y": 20.109,
              "z": 0.701
            },
            "rightCorner": {
              "x": 22.235,
              "y": 20.007,
              "z": 0.701
            },
            "gtin": "8445290470454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212f8",
            "leftCorner": {
              "x": 22.235,
              "y": 20.007,
              "z": 0.701
            },
            "rightCorner": {
              "x": 22.227,
              "y": 19.906,
              "z": 0.701
            },
            "gtin": "8445290470454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212f9",
            "leftCorner": {
              "x": 22.227,
              "y": 19.906,
              "z": 0.701
            },
            "rightCorner": {
              "x": 22.217,
              "y": 19.804,
              "z": 0.701
            },
            "gtin": "8445290470454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212fa",
            "leftCorner": {
              "x": 22.217,
              "y": 19.804,
              "z": 0.701
            },
            "rightCorner": {
              "x": 22.208,
              "y": 19.702,
              "z": 0.701
            },
            "gtin": "8445290470454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212fb",
            "leftCorner": {
              "x": 22.225,
              "y": 19.701,
              "z": 0.701
            },
            "rightCorner": {
              "x": 22.203,
              "y": 19.432,
              "z": 0.701
            },
            "gtin": "7613287109514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212fc",
            "leftCorner": {
              "x": 22.2,
              "y": 19.434,
              "z": 0.701
            },
            "rightCorner": {
              "x": 22.177,
              "y": 19.164,
              "z": 0.701
            },
            "gtin": "5000159562508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212ef",
            "leftCorner": {
              "x": 22.18,
              "y": 19.163,
              "z": 0.701
            },
            "rightCorner": {
              "x": 22.172,
              "y": 19.051,
              "z": 0.701
            },
            "gtin": "5000159562577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a212f0",
            "leftCorner": {
              "x": 22.172,
              "y": 19.051,
              "z": 0.701
            },
            "rightCorner": {
              "x": 22.162,
              "y": 18.939,
              "z": 0.701
            },
            "gtin": "5000159562577",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546943",
        "height": 1.1584,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21334",
            "leftCorner": {
              "x": 22.254,
              "y": 20.113,
              "z": 0.948
            },
            "rightCorner": {
              "x": 22.247,
              "y": 20.038,
              "z": 0.948
            },
            "gtin": "5900951310560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21335",
            "leftCorner": {
              "x": 22.247,
              "y": 20.038,
              "z": 0.948
            },
            "rightCorner": {
              "x": 22.24,
              "y": 19.963,
              "z": 0.948
            },
            "gtin": "5900951310560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21336",
            "leftCorner": {
              "x": 22.246,
              "y": 19.963,
              "z": 0.948
            },
            "rightCorner": {
              "x": 22.238,
              "y": 19.866,
              "z": 0.948
            },
            "gtin": "5000159560498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21337",
            "leftCorner": {
              "x": 22.238,
              "y": 19.866,
              "z": 0.948
            },
            "rightCorner": {
              "x": 22.23,
              "y": 19.77,
              "z": 0.948
            },
            "gtin": "5000159560498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21338",
            "leftCorner": {
              "x": 22.223,
              "y": 19.77,
              "z": 0.948
            },
            "rightCorner": {
              "x": 22.197,
              "y": 19.458,
              "z": 0.948
            },
            "gtin": "5000159550963",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21339",
            "leftCorner": {
              "x": 22.194,
              "y": 19.458,
              "z": 0.948
            },
            "rightCorner": {
              "x": 22.166,
              "y": 19.132,
              "z": 0.948
            },
            "gtin": "5000159562430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21311",
            "leftCorner": {
              "x": 22.161,
              "y": 19.132,
              "z": 0.948
            },
            "rightCorner": {
              "x": 22.145,
              "y": 18.94,
              "z": 0.948
            },
            "gtin": "5000159562454",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546945",
        "height": 1.7505,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ea8b",
            "leftCorner": {
              "x": 22.241,
              "y": 20.11,
              "z": 1.432
            },
            "rightCorner": {
              "x": 22.229,
              "y": 19.973,
              "z": 1.432
            },
            "gtin": "7622210959843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea8c",
            "leftCorner": {
              "x": 22.229,
              "y": 19.973,
              "z": 1.432
            },
            "rightCorner": {
              "x": 22.218,
              "y": 19.835,
              "z": 1.432
            },
            "gtin": "7622210959843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea8d",
            "leftCorner": {
              "x": 22.235,
              "y": 19.834,
              "z": 1.432
            },
            "rightCorner": {
              "x": 22.207,
              "y": 19.512,
              "z": 1.432
            },
            "gtin": "8445291271555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea8e",
            "leftCorner": {
              "x": 22.207,
              "y": 19.512,
              "z": 1.432
            },
            "rightCorner": {
              "x": 22.179,
              "y": 19.191,
              "z": 1.432
            },
            "gtin": "8445291271555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea18",
            "leftCorner": {
              "x": 22.166,
              "y": 19.191,
              "z": 1.432
            },
            "rightCorner": {
              "x": 22.159,
              "y": 19.107,
              "z": 1.432
            },
            "gtin": "5000159474856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea19",
            "leftCorner": {
              "x": 22.159,
              "y": 19.107,
              "z": 1.432
            },
            "rightCorner": {
              "x": 22.153,
              "y": 19.024,
              "z": 1.432
            },
            "gtin": "5000159474856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea1a",
            "leftCorner": {
              "x": 22.153,
              "y": 19.024,
              "z": 1.432
            },
            "rightCorner": {
              "x": 22.145,
              "y": 18.94,
              "z": 1.432
            },
            "gtin": "5000159474856",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "93011"
  },
  {
    "id": "9301a",
    "name": "9301a",
    "x": 21.888,
    "y": 15.557,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72515,
      "w": 0.68859
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 42
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546952",
        "height": 0.14112,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a54694f",
        "height": 0.64367,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef79",
            "leftCorner": {
              "x": 21.939,
              "y": 15.568,
              "z": 0.527
            },
            "rightCorner": {
              "x": 21.931,
              "y": 15.414,
              "z": 0.527
            },
            "gtin": "4002442819147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef7a",
            "leftCorner": {
              "x": 21.931,
              "y": 15.414,
              "z": 0.527
            },
            "rightCorner": {
              "x": 21.923,
              "y": 15.26,
              "z": 0.527
            },
            "gtin": "4002442819147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef7b",
            "leftCorner": {
              "x": 21.923,
              "y": 15.26,
              "z": 0.527
            },
            "rightCorner": {
              "x": 21.915,
              "y": 15.107,
              "z": 0.527
            },
            "gtin": "4002442819147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef7c",
            "leftCorner": {
              "x": 21.911,
              "y": 15.108,
              "z": 0.527
            },
            "rightCorner": {
              "x": 21.897,
              "y": 14.826,
              "z": 0.527
            },
            "gtin": "024000011484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef7d",
            "leftCorner": {
              "x": 21.897,
              "y": 14.826,
              "z": 0.527
            },
            "rightCorner": {
              "x": 21.882,
              "y": 14.544,
              "z": 0.527
            },
            "gtin": "024000011484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef7e",
            "leftCorner": {
              "x": 21.874,
              "y": 14.545,
              "z": 0.527
            },
            "rightCorner": {
              "x": 21.869,
              "y": 14.46,
              "z": 0.527
            },
            "gtin": "4019041004034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef7f",
            "leftCorner": {
              "x": 21.869,
              "y": 14.46,
              "z": 0.527
            },
            "rightCorner": {
              "x": 21.865,
              "y": 14.375,
              "z": 0.527
            },
            "gtin": "4019041004034",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54694e",
        "height": 1.1026,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f03a",
            "leftCorner": {
              "x": 21.893,
              "y": 15.557,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.888,
              "y": 15.451,
              "z": 0.902
            },
            "gtin": "024000110170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f03b",
            "leftCorner": {
              "x": 21.888,
              "y": 15.451,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.882,
              "y": 15.345,
              "z": 0.902
            },
            "gtin": "024000110170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f042",
            "leftCorner": {
              "x": 21.938,
              "y": 15.343,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.932,
              "y": 15.227,
              "z": 0.902
            },
            "gtin": "4006795315691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f043",
            "leftCorner": {
              "x": 21.932,
              "y": 15.227,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.926,
              "y": 15.112,
              "z": 0.902
            },
            "gtin": "4006795315691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f044",
            "leftCorner": {
              "x": 21.926,
              "y": 15.112,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.921,
              "y": 14.997,
              "z": 0.902
            },
            "gtin": "4006795315691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f045",
            "leftCorner": {
              "x": 21.907,
              "y": 14.998,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.904,
              "y": 14.948,
              "z": 0.902
            },
            "gtin": "4006795314694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f046",
            "leftCorner": {
              "x": 21.904,
              "y": 14.948,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.902,
              "y": 14.898,
              "z": 0.902
            },
            "gtin": "4006795314694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f047",
            "leftCorner": {
              "x": 21.902,
              "y": 14.898,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.898,
              "y": 14.848,
              "z": 0.902
            },
            "gtin": "4006795314694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f048",
            "leftCorner": {
              "x": 21.898,
              "y": 14.848,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.896,
              "y": 14.799,
              "z": 0.902
            },
            "gtin": "4006795314694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f049",
            "leftCorner": {
              "x": 21.896,
              "y": 14.799,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.893,
              "y": 14.749,
              "z": 0.902
            },
            "gtin": "4006795314694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f04a",
            "leftCorner": {
              "x": 21.893,
              "y": 14.749,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.891,
              "y": 14.699,
              "z": 0.902
            },
            "gtin": "4006795314694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f04b",
            "leftCorner": {
              "x": 21.859,
              "y": 14.7,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.854,
              "y": 14.6,
              "z": 0.902
            },
            "gtin": "4012712010129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f04c",
            "leftCorner": {
              "x": 21.854,
              "y": 14.6,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.849,
              "y": 14.498,
              "z": 0.902
            },
            "gtin": "4012712010129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f04d",
            "leftCorner": {
              "x": 21.849,
              "y": 14.498,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.845,
              "y": 14.426,
              "z": 0.902
            },
            "gtin": "4012712010280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f04e",
            "leftCorner": {
              "x": 21.845,
              "y": 14.426,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.841,
              "y": 14.354,
              "z": 0.902
            },
            "gtin": "4012712010280",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546951",
        "height": 1.4498,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1eff4",
            "leftCorner": {
              "x": 21.913,
              "y": 15.564,
              "z": 1.186
            },
            "rightCorner": {
              "x": 21.896,
              "y": 15.212,
              "z": 1.186
            },
            "gtin": "024000110156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eff5",
            "leftCorner": {
              "x": 21.896,
              "y": 15.212,
              "z": 1.186
            },
            "rightCorner": {
              "x": 21.877,
              "y": 14.861,
              "z": 1.186
            },
            "gtin": "024000110156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eff6",
            "leftCorner": {
              "x": 21.881,
              "y": 14.861,
              "z": 1.186
            },
            "rightCorner": {
              "x": 21.876,
              "y": 14.757,
              "z": 1.186
            },
            "gtin": "024000124962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eff7",
            "leftCorner": {
              "x": 21.876,
              "y": 14.757,
              "z": 1.186
            },
            "rightCorner": {
              "x": 21.87,
              "y": 14.653,
              "z": 1.186
            },
            "gtin": "024000124962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eff8",
            "leftCorner": {
              "x": 21.855,
              "y": 14.654,
              "z": 1.186
            },
            "rightCorner": {
              "x": 21.848,
              "y": 14.497,
              "z": 1.186
            },
            "gtin": "4012712011089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eff9",
            "leftCorner": {
              "x": 21.832,
              "y": 14.497,
              "z": 1.186
            },
            "rightCorner": {
              "x": 21.827,
              "y": 14.41,
              "z": 1.186
            },
            "gtin": "4012712010174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1effa",
            "leftCorner": {
              "x": 21.827,
              "y": 14.41,
              "z": 1.186
            },
            "rightCorner": {
              "x": 21.822,
              "y": 14.322,
              "z": 1.186
            },
            "gtin": "4012712010174",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546950",
        "height": 1.7002,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef9f",
            "leftCorner": {
              "x": 21.926,
              "y": 15.533,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.922,
              "y": 15.458,
              "z": 1.391
            },
            "gtin": "4042700800029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efa0",
            "leftCorner": {
              "x": 21.922,
              "y": 15.458,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.918,
              "y": 15.383,
              "z": 1.391
            },
            "gtin": "4042700800029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efa1",
            "leftCorner": {
              "x": 21.918,
              "y": 15.383,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.915,
              "y": 15.308,
              "z": 1.391
            },
            "gtin": "4042700800029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efa2",
            "leftCorner": {
              "x": 21.91,
              "y": 15.308,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.905,
              "y": 15.218,
              "z": 1.391
            },
            "gtin": "4063367420085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efa3",
            "leftCorner": {
              "x": 21.905,
              "y": 15.218,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.9,
              "y": 15.129,
              "z": 1.391
            },
            "gtin": "4063367420085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efa4",
            "leftCorner": {
              "x": 21.9,
              "y": 15.129,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.895,
              "y": 15.039,
              "z": 1.391
            },
            "gtin": "4063367420085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efa5",
            "leftCorner": {
              "x": 21.89,
              "y": 15.039,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.883,
              "y": 14.917,
              "z": 1.391
            },
            "gtin": "4063367420092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efa6",
            "leftCorner": {
              "x": 21.883,
              "y": 14.917,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.877,
              "y": 14.793,
              "z": 1.391
            },
            "gtin": "4063367420092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efa7",
            "leftCorner": {
              "x": 21.88,
              "y": 14.793,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.876,
              "y": 14.723,
              "z": 1.391
            },
            "gtin": "4063367239168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efa8",
            "leftCorner": {
              "x": 21.876,
              "y": 14.723,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.872,
              "y": 14.653,
              "z": 1.391
            },
            "gtin": "4063367239168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efa9",
            "leftCorner": {
              "x": 21.867,
              "y": 14.653,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.862,
              "y": 14.545,
              "z": 1.391
            },
            "gtin": "4337185632716",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efaa",
            "leftCorner": {
              "x": 21.862,
              "y": 14.545,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.856,
              "y": 14.438,
              "z": 1.391
            },
            "gtin": "4337185632716",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efab",
            "leftCorner": {
              "x": 21.856,
              "y": 14.438,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.851,
              "y": 14.33,
              "z": 1.391
            },
            "gtin": "4337185632716",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ddea5",
    "rightNeighborShelfId": "9301b"
  },
  {
    "id": "9301b",
    "name": "9301b",
    "x": 21.826,
    "y": 14.358,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72515,
      "w": 0.68859
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 51
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546957",
        "height": 0.14736,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f06f",
            "leftCorner": {
              "x": 21.848,
              "y": 14.021,
              "z": 0.121
            },
            "rightCorner": {
              "x": 21.835,
              "y": 13.751,
              "z": 0.121
            },
            "gtin": "4006795373691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f070",
            "leftCorner": {
              "x": 21.842,
              "y": 13.75,
              "z": 0.121
            },
            "rightCorner": {
              "x": 21.833,
              "y": 13.553,
              "z": 0.121
            },
            "gtin": "4028286742328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f071",
            "leftCorner": {
              "x": 21.833,
              "y": 13.553,
              "z": 0.121
            },
            "rightCorner": {
              "x": 21.823,
              "y": 13.355,
              "z": 0.121
            },
            "gtin": "4028286742328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f072",
            "leftCorner": {
              "x": 21.823,
              "y": 13.355,
              "z": 0.121
            },
            "rightCorner": {
              "x": 21.812,
              "y": 13.158,
              "z": 0.121
            },
            "gtin": "4028286742328",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546953",
        "height": 0.647,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef80",
            "leftCorner": {
              "x": 21.875,
              "y": 14.375,
              "z": 0.529
            },
            "rightCorner": {
              "x": 21.828,
              "y": 13.462,
              "z": 0.529
            },
            "gtin": "4063367184314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef81",
            "leftCorner": {
              "x": 21.827,
              "y": 13.462,
              "z": 0.529
            },
            "rightCorner": {
              "x": 21.81,
              "y": 13.142,
              "z": 0.529
            },
            "gtin": "4002442819871",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546954",
        "height": 1.0995,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f04f",
            "leftCorner": {
              "x": 21.857,
              "y": 14.352,
              "z": 0.9
            },
            "rightCorner": {
              "x": 21.853,
              "y": 14.287,
              "z": 0.9
            },
            "gtin": "024000196310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f050",
            "leftCorner": {
              "x": 21.853,
              "y": 14.287,
              "z": 0.9
            },
            "rightCorner": {
              "x": 21.85,
              "y": 14.222,
              "z": 0.9
            },
            "gtin": "024000196310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f051",
            "leftCorner": {
              "x": 21.85,
              "y": 14.222,
              "z": 0.9
            },
            "rightCorner": {
              "x": 21.846,
              "y": 14.157,
              "z": 0.9
            },
            "gtin": "024000196310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f052",
            "leftCorner": {
              "x": 21.842,
              "y": 14.157,
              "z": 0.9
            },
            "rightCorner": {
              "x": 21.833,
              "y": 14.0,
              "z": 0.9
            },
            "gtin": "024000148081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f053",
            "leftCorner": {
              "x": 21.833,
              "y": 14.0,
              "z": 0.9
            },
            "rightCorner": {
              "x": 21.825,
              "y": 13.843,
              "z": 0.9
            },
            "gtin": "024000148081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f054",
            "leftCorner": {
              "x": 21.825,
              "y": 13.843,
              "z": 0.9
            },
            "rightCorner": {
              "x": 21.817,
              "y": 13.688,
              "z": 0.9
            },
            "gtin": "024000148081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f055",
            "leftCorner": {
              "x": 21.818,
              "y": 13.688,
              "z": 0.9
            },
            "rightCorner": {
              "x": 21.808,
              "y": 13.486,
              "z": 0.9
            },
            "gtin": "024000024385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f056",
            "leftCorner": {
              "x": 21.803,
              "y": 13.486,
              "z": 0.9
            },
            "rightCorner": {
              "x": 21.8,
              "y": 13.418,
              "z": 0.9
            },
            "gtin": "4012712000205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f057",
            "leftCorner": {
              "x": 21.8,
              "y": 13.418,
              "z": 0.9
            },
            "rightCorner": {
              "x": 21.796,
              "y": 13.35,
              "z": 0.9
            },
            "gtin": "4012712000205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f058",
            "leftCorner": {
              "x": 21.796,
              "y": 13.35,
              "z": 0.9
            },
            "rightCorner": {
              "x": 21.793,
              "y": 13.282,
              "z": 0.9
            },
            "gtin": "4012712000205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f059",
            "leftCorner": {
              "x": 21.802,
              "y": 13.282,
              "z": 0.9
            },
            "rightCorner": {
              "x": 21.799,
              "y": 13.219,
              "z": 0.9
            },
            "gtin": "4002442919243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f05a",
            "leftCorner": {
              "x": 21.799,
              "y": 13.219,
              "z": 0.9
            },
            "rightCorner": {
              "x": 21.796,
              "y": 13.157,
              "z": 0.9
            },
            "gtin": "4002442919243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f05b",
            "leftCorner": {
              "x": 21.796,
              "y": 13.157,
              "z": 0.9
            },
            "rightCorner": {
              "x": 21.792,
              "y": 13.094,
              "z": 0.9
            },
            "gtin": "4002442919243",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546956",
        "height": 1.4571,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1effb",
            "leftCorner": {
              "x": 21.852,
              "y": 14.32,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.85,
              "y": 14.275,
              "z": 1.192
            },
            "gtin": "4012712010952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1effc",
            "leftCorner": {
              "x": 21.85,
              "y": 14.275,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.848,
              "y": 14.229,
              "z": 1.192
            },
            "gtin": "4012712010952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1effd",
            "leftCorner": {
              "x": 21.848,
              "y": 14.229,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.845,
              "y": 14.183,
              "z": 1.192
            },
            "gtin": "4012712010952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1effe",
            "leftCorner": {
              "x": 21.845,
              "y": 14.183,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.843,
              "y": 14.137,
              "z": 1.192
            },
            "gtin": "4012712010952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efff",
            "leftCorner": {
              "x": 21.84,
              "y": 14.137,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.836,
              "y": 14.058,
              "z": 1.192
            },
            "gtin": "4012712010921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f000",
            "leftCorner": {
              "x": 21.836,
              "y": 14.058,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.832,
              "y": 13.978,
              "z": 1.192
            },
            "gtin": "4012712010921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f001",
            "leftCorner": {
              "x": 21.832,
              "y": 13.978,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.828,
              "y": 13.898,
              "z": 1.192
            },
            "gtin": "4012712010921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f002",
            "leftCorner": {
              "x": 21.828,
              "y": 13.898,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.824,
              "y": 13.818,
              "z": 1.192
            },
            "gtin": "4012712010921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f003",
            "leftCorner": {
              "x": 21.824,
              "y": 13.818,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.82,
              "y": 13.739,
              "z": 1.192
            },
            "gtin": "4012712010921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f004",
            "leftCorner": {
              "x": 21.818,
              "y": 13.739,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.814,
              "y": 13.668,
              "z": 1.192
            },
            "gtin": "024000124948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f005",
            "leftCorner": {
              "x": 21.814,
              "y": 13.668,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.811,
              "y": 13.597,
              "z": 1.192
            },
            "gtin": "024000124948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f006",
            "leftCorner": {
              "x": 21.811,
              "y": 13.597,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.807,
              "y": 13.526,
              "z": 1.192
            },
            "gtin": "024000124948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f007",
            "leftCorner": {
              "x": 21.819,
              "y": 13.525,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.816,
              "y": 13.454,
              "z": 1.192
            },
            "gtin": "4063367077708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f008",
            "leftCorner": {
              "x": 21.816,
              "y": 13.454,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.812,
              "y": 13.384,
              "z": 1.192
            },
            "gtin": "4063367077708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f009",
            "leftCorner": {
              "x": 21.812,
              "y": 13.384,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.808,
              "y": 13.314,
              "z": 1.192
            },
            "gtin": "4063367077708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f00a",
            "leftCorner": {
              "x": 21.808,
              "y": 13.314,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.804,
              "y": 13.243,
              "z": 1.192
            },
            "gtin": "4063367077708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f00b",
            "leftCorner": {
              "x": 21.801,
              "y": 13.243,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.797,
              "y": 13.173,
              "z": 1.192
            },
            "gtin": "4063367208546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f00c",
            "leftCorner": {
              "x": 21.797,
              "y": 13.173,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.794,
              "y": 13.104,
              "z": 1.192
            },
            "gtin": "4063367208546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f00d",
            "leftCorner": {
              "x": 21.794,
              "y": 13.104,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.79,
              "y": 13.034,
              "z": 1.192
            },
            "gtin": "4063367208546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f00e",
            "leftCorner": {
              "x": 21.79,
              "y": 13.034,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.787,
              "y": 12.964,
              "z": 1.192
            },
            "gtin": "4063367208546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f00f",
            "leftCorner": {
              "x": 21.787,
              "y": 12.964,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.783,
              "y": 12.894,
              "z": 1.192
            },
            "gtin": "4063367208546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f010",
            "leftCorner": {
              "x": 21.783,
              "y": 12.894,
              "z": 1.192
            },
            "rightCorner": {
              "x": 21.779,
              "y": 12.825,
              "z": 1.192
            },
            "gtin": "4063367208546",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546955",
        "height": 1.6994,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1efac",
            "leftCorner": {
              "x": 21.84,
              "y": 14.33,
              "z": 1.39
            },
            "rightCorner": {
              "x": 21.833,
              "y": 14.215,
              "z": 1.39
            },
            "gtin": "024000124023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efad",
            "leftCorner": {
              "x": 21.833,
              "y": 14.215,
              "z": 1.39
            },
            "rightCorner": {
              "x": 21.827,
              "y": 14.1,
              "z": 1.39
            },
            "gtin": "024000124023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efae",
            "leftCorner": {
              "x": 21.827,
              "y": 14.1,
              "z": 1.39
            },
            "rightCorner": {
              "x": 21.821,
              "y": 13.985,
              "z": 1.39
            },
            "gtin": "024000124023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efaf",
            "leftCorner": {
              "x": 21.834,
              "y": 13.984,
              "z": 1.39
            },
            "rightCorner": {
              "x": 21.829,
              "y": 13.884,
              "z": 1.39
            },
            "gtin": "8017995100310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efb0",
            "leftCorner": {
              "x": 21.829,
              "y": 13.884,
              "z": 1.39
            },
            "rightCorner": {
              "x": 21.823,
              "y": 13.785,
              "z": 1.39
            },
            "gtin": "8017995100310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efb1",
            "leftCorner": {
              "x": 21.823,
              "y": 13.785,
              "z": 1.39
            },
            "rightCorner": {
              "x": 21.818,
              "y": 13.687,
              "z": 1.39
            },
            "gtin": "8017995100310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efb2",
            "leftCorner": {
              "x": 21.819,
              "y": 13.686,
              "z": 1.39
            },
            "rightCorner": {
              "x": 21.81,
              "y": 13.497,
              "z": 1.39
            },
            "gtin": "4063367396229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efb3",
            "leftCorner": {
              "x": 21.81,
              "y": 13.497,
              "z": 1.39
            },
            "rightCorner": {
              "x": 21.799,
              "y": 13.308,
              "z": 1.39
            },
            "gtin": "4063367396229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efb4",
            "leftCorner": {
              "x": 21.798,
              "y": 13.308,
              "z": 1.39
            },
            "rightCorner": {
              "x": 21.794,
              "y": 13.227,
              "z": 1.39
            },
            "gtin": "4063367396212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efb5",
            "leftCorner": {
              "x": 21.794,
              "y": 13.227,
              "z": 1.39
            },
            "rightCorner": {
              "x": 21.789,
              "y": 13.145,
              "z": 1.39
            },
            "gtin": "4063367396212",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "9301a",
    "rightNeighborShelfId": "9301c"
  },
  {
    "id": "9301c",
    "name": "9301c",
    "x": 21.764,
    "y": 13.16,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72515,
      "w": 0.68859
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 36
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54695b",
        "height": 0.14596,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a546958",
        "height": 0.64885,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef82",
            "leftCorner": {
              "x": 21.806,
              "y": 13.143,
              "z": 0.531
            },
            "rightCorner": {
              "x": 21.792,
              "y": 12.875,
              "z": 0.531
            },
            "gtin": "4063367005985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef83",
            "leftCorner": {
              "x": 21.795,
              "y": 12.875,
              "z": 0.531
            },
            "rightCorner": {
              "x": 21.789,
              "y": 12.774,
              "z": 0.531
            },
            "gtin": "4006795364699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef84",
            "leftCorner": {
              "x": 21.789,
              "y": 12.774,
              "z": 0.531
            },
            "rightCorner": {
              "x": 21.784,
              "y": 12.674,
              "z": 0.531
            },
            "gtin": "4006795364699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef85",
            "leftCorner": {
              "x": 21.784,
              "y": 12.674,
              "z": 0.531
            },
            "rightCorner": {
              "x": 21.78,
              "y": 12.59,
              "z": 0.531
            },
            "gtin": "4002442820617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef86",
            "leftCorner": {
              "x": 21.78,
              "y": 12.59,
              "z": 0.531
            },
            "rightCorner": {
              "x": 21.775,
              "y": 12.505,
              "z": 0.531
            },
            "gtin": "4002442820617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef87",
            "leftCorner": {
              "x": 21.779,
              "y": 12.505,
              "z": 0.531
            },
            "rightCorner": {
              "x": 21.772,
              "y": 12.372,
              "z": 0.531
            },
            "gtin": "4337185688942",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef88",
            "leftCorner": {
              "x": 21.772,
              "y": 12.372,
              "z": 0.531
            },
            "rightCorner": {
              "x": 21.766,
              "y": 12.24,
              "z": 0.531
            },
            "gtin": "4337185688942",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef89",
            "leftCorner": {
              "x": 21.766,
              "y": 12.24,
              "z": 0.531
            },
            "rightCorner": {
              "x": 21.759,
              "y": 12.107,
              "z": 0.531
            },
            "gtin": "4337185688942",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef8a",
            "leftCorner": {
              "x": 21.759,
              "y": 12.107,
              "z": 0.531
            },
            "rightCorner": {
              "x": 21.752,
              "y": 11.974,
              "z": 0.531
            },
            "gtin": "4337185688942",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54695a",
        "height": 1.1078,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f05c",
            "leftCorner": {
              "x": 21.795,
              "y": 13.094,
              "z": 0.906
            },
            "rightCorner": {
              "x": 21.786,
              "y": 12.914,
              "z": 0.906
            },
            "gtin": "4063367389740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f05d",
            "leftCorner": {
              "x": 21.786,
              "y": 12.914,
              "z": 0.906
            },
            "rightCorner": {
              "x": 21.776,
              "y": 12.735,
              "z": 0.906
            },
            "gtin": "4063367389740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f05e",
            "leftCorner": {
              "x": 21.776,
              "y": 12.735,
              "z": 0.906
            },
            "rightCorner": {
              "x": 21.767,
              "y": 12.556,
              "z": 0.906
            },
            "gtin": "4063367389740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f05f",
            "leftCorner": {
              "x": 21.767,
              "y": 12.556,
              "z": 0.906
            },
            "rightCorner": {
              "x": 21.758,
              "y": 12.376,
              "z": 0.906
            },
            "gtin": "4063367389740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f060",
            "leftCorner": {
              "x": 21.755,
              "y": 12.376,
              "z": 0.906
            },
            "rightCorner": {
              "x": 21.751,
              "y": 12.291,
              "z": 0.906
            },
            "gtin": "4008122021169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f061",
            "leftCorner": {
              "x": 21.751,
              "y": 12.291,
              "z": 0.906
            },
            "rightCorner": {
              "x": 21.746,
              "y": 12.207,
              "z": 0.906
            },
            "gtin": "4008122021169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f062",
            "leftCorner": {
              "x": 21.746,
              "y": 12.207,
              "z": 0.906
            },
            "rightCorner": {
              "x": 21.742,
              "y": 12.122,
              "z": 0.906
            },
            "gtin": "4008122021169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f063",
            "leftCorner": {
              "x": 21.742,
              "y": 12.122,
              "z": 0.906
            },
            "rightCorner": {
              "x": 21.737,
              "y": 12.037,
              "z": 0.906
            },
            "gtin": "4008122021169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f064",
            "leftCorner": {
              "x": 21.737,
              "y": 12.037,
              "z": 0.906
            },
            "rightCorner": {
              "x": 21.733,
              "y": 11.952,
              "z": 0.906
            },
            "gtin": "4008122021169",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54695c",
        "height": 1.4532,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f011",
            "leftCorner": {
              "x": 21.766,
              "y": 12.826,
              "z": 1.189
            },
            "rightCorner": {
              "x": 21.762,
              "y": 12.743,
              "z": 1.189
            },
            "gtin": "4063367005923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f012",
            "leftCorner": {
              "x": 21.762,
              "y": 12.743,
              "z": 1.189
            },
            "rightCorner": {
              "x": 21.758,
              "y": 12.659,
              "z": 1.189
            },
            "gtin": "4063367005923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f013",
            "leftCorner": {
              "x": 21.758,
              "y": 12.659,
              "z": 1.189
            },
            "rightCorner": {
              "x": 21.753,
              "y": 12.576,
              "z": 1.189
            },
            "gtin": "4063367005923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f014",
            "leftCorner": {
              "x": 21.753,
              "y": 12.576,
              "z": 1.189
            },
            "rightCorner": {
              "x": 21.749,
              "y": 12.492,
              "z": 1.189
            },
            "gtin": "4063367005923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f015",
            "leftCorner": {
              "x": 21.749,
              "y": 12.492,
              "z": 1.189
            },
            "rightCorner": {
              "x": 21.744,
              "y": 12.409,
              "z": 1.189
            },
            "gtin": "4063367005923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f016",
            "leftCorner": {
              "x": 21.744,
              "y": 12.409,
              "z": 1.189
            },
            "rightCorner": {
              "x": 21.74,
              "y": 12.325,
              "z": 1.189
            },
            "gtin": "4063367005923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f017",
            "leftCorner": {
              "x": 21.74,
              "y": 12.325,
              "z": 1.189
            },
            "rightCorner": {
              "x": 21.736,
              "y": 12.242,
              "z": 1.189
            },
            "gtin": "4063367005923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f018",
            "leftCorner": {
              "x": 21.735,
              "y": 12.242,
              "z": 1.189
            },
            "rightCorner": {
              "x": 21.728,
              "y": 12.085,
              "z": 1.189
            },
            "gtin": "4012712001127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f019",
            "leftCorner": {
              "x": 21.728,
              "y": 12.085,
              "z": 1.189
            },
            "rightCorner": {
              "x": 21.72,
              "y": 11.927,
              "z": 1.189
            },
            "gtin": "4012712001127",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546959",
        "height": 1.6996,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1efb6",
            "leftCorner": {
              "x": 21.786,
              "y": 13.146,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.775,
              "y": 12.944,
              "z": 1.391
            },
            "gtin": "4011800189426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efb7",
            "leftCorner": {
              "x": 21.775,
              "y": 12.944,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.764,
              "y": 12.742,
              "z": 1.391
            },
            "gtin": "4011800189426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efb8",
            "leftCorner": {
              "x": 21.764,
              "y": 12.742,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.754,
              "y": 12.539,
              "z": 1.391
            },
            "gtin": "4011800189426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efb9",
            "leftCorner": {
              "x": 21.763,
              "y": 12.539,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.76,
              "y": 12.469,
              "z": 1.391
            },
            "gtin": "42010180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efba",
            "leftCorner": {
              "x": 21.76,
              "y": 12.469,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.756,
              "y": 12.398,
              "z": 1.391
            },
            "gtin": "42010180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efbb",
            "leftCorner": {
              "x": 21.756,
              "y": 12.398,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.753,
              "y": 12.328,
              "z": 1.391
            },
            "gtin": "42010180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efbc",
            "leftCorner": {
              "x": 21.753,
              "y": 12.328,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.749,
              "y": 12.257,
              "z": 1.391
            },
            "gtin": "42010180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efbd",
            "leftCorner": {
              "x": 21.739,
              "y": 12.257,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.731,
              "y": 12.105,
              "z": 1.391
            },
            "gtin": "4008122022500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efbe",
            "leftCorner": {
              "x": 21.731,
              "y": 12.105,
              "z": 1.391
            },
            "rightCorner": {
              "x": 21.723,
              "y": 11.952,
              "z": 1.391
            },
            "gtin": "4008122022500",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "9301b",
    "rightNeighborShelfId": "9301d"
  },
  {
    "id": "9301d",
    "name": "9301d",
    "x": 21.702,
    "y": 11.962,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72515,
      "w": 0.68859
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 43
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546467",
        "height": 0.14988,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a546463",
        "height": 0.64832,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef8b",
            "leftCorner": {
              "x": 21.743,
              "y": 11.974,
              "z": 0.53
            },
            "rightCorner": {
              "x": 21.734,
              "y": 11.807,
              "z": 0.53
            },
            "gtin": "4045317052577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef8c",
            "leftCorner": {
              "x": 21.734,
              "y": 11.807,
              "z": 0.53
            },
            "rightCorner": {
              "x": 21.726,
              "y": 11.639,
              "z": 0.53
            },
            "gtin": "4045317052577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef8d",
            "leftCorner": {
              "x": 21.726,
              "y": 11.639,
              "z": 0.53
            },
            "rightCorner": {
              "x": 21.717,
              "y": 11.471,
              "z": 0.53
            },
            "gtin": "4045317052577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef8e",
            "leftCorner": {
              "x": 21.727,
              "y": 11.471,
              "z": 0.53
            },
            "rightCorner": {
              "x": 21.719,
              "y": 11.304,
              "z": 0.53
            },
            "gtin": "4045317052539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef8f",
            "leftCorner": {
              "x": 21.719,
              "y": 11.304,
              "z": 0.53
            },
            "rightCorner": {
              "x": 21.709,
              "y": 11.137,
              "z": 0.53
            },
            "gtin": "4045317052539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef90",
            "leftCorner": {
              "x": 21.709,
              "y": 11.137,
              "z": 0.53
            },
            "rightCorner": {
              "x": 21.701,
              "y": 10.97,
              "z": 0.53
            },
            "gtin": "4045317052539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef91",
            "leftCorner": {
              "x": 21.704,
              "y": 10.97,
              "z": 0.53
            },
            "rightCorner": {
              "x": 21.697,
              "y": 10.827,
              "z": 0.53
            },
            "gtin": "4045317052584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef92",
            "leftCorner": {
              "x": 21.697,
              "y": 10.827,
              "z": 0.53
            },
            "rightCorner": {
              "x": 21.689,
              "y": 10.686,
              "z": 0.53
            },
            "gtin": "4045317052584",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546466",
        "height": 1.1021,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f065",
            "leftCorner": {
              "x": 21.721,
              "y": 11.953,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.713,
              "y": 11.8,
              "z": 0.902
            },
            "gtin": "4045317050283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f066",
            "leftCorner": {
              "x": 21.713,
              "y": 11.8,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.705,
              "y": 11.649,
              "z": 0.902
            },
            "gtin": "4045317050283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f067",
            "leftCorner": {
              "x": 21.705,
              "y": 11.649,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.697,
              "y": 11.496,
              "z": 0.902
            },
            "gtin": "4045317050283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f068",
            "leftCorner": {
              "x": 21.697,
              "y": 11.496,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.689,
              "y": 11.343,
              "z": 0.902
            },
            "gtin": "4045317050283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f069",
            "leftCorner": {
              "x": 21.714,
              "y": 11.342,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.683,
              "y": 10.743,
              "z": 0.902
            },
            "gtin": "4045317050290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f06a",
            "leftCorner": {
              "x": 21.683,
              "y": 10.743,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.652,
              "y": 10.144,
              "z": 0.902
            },
            "gtin": "4045317050290",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546465",
        "height": 1.4548,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f01a",
            "leftCorner": {
              "x": 21.72,
              "y": 11.927,
              "z": 1.19
            },
            "rightCorner": {
              "x": 21.716,
              "y": 11.853,
              "z": 1.19
            },
            "gtin": "4062800006206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f01b",
            "leftCorner": {
              "x": 21.716,
              "y": 11.853,
              "z": 1.19
            },
            "rightCorner": {
              "x": 21.713,
              "y": 11.78,
              "z": 1.19
            },
            "gtin": "4062800006206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f01c",
            "leftCorner": {
              "x": 21.713,
              "y": 11.78,
              "z": 1.19
            },
            "rightCorner": {
              "x": 21.706,
              "y": 11.657,
              "z": 1.19
            },
            "gtin": "4008230208001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f01d",
            "leftCorner": {
              "x": 21.706,
              "y": 11.657,
              "z": 1.19
            },
            "rightCorner": {
              "x": 21.7,
              "y": 11.534,
              "z": 1.19
            },
            "gtin": "4008230208001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f01e",
            "leftCorner": {
              "x": 21.711,
              "y": 11.533,
              "z": 1.19
            },
            "rightCorner": {
              "x": 21.705,
              "y": 11.403,
              "z": 1.19
            },
            "gtin": "4034900007001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f01f",
            "leftCorner": {
              "x": 21.705,
              "y": 11.403,
              "z": 1.19
            },
            "rightCorner": {
              "x": 21.698,
              "y": 11.275,
              "z": 1.19
            },
            "gtin": "4034900007001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f020",
            "leftCorner": {
              "x": 21.698,
              "y": 11.275,
              "z": 1.19
            },
            "rightCorner": {
              "x": 21.691,
              "y": 11.145,
              "z": 1.19
            },
            "gtin": "4034900007001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f021",
            "leftCorner": {
              "x": 21.71,
              "y": 11.144,
              "z": 1.19
            },
            "rightCorner": {
              "x": 21.704,
              "y": 11.037,
              "z": 1.19
            },
            "gtin": "4335896563329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f022",
            "leftCorner": {
              "x": 21.704,
              "y": 11.037,
              "z": 1.19
            },
            "rightCorner": {
              "x": 21.699,
              "y": 10.93,
              "z": 1.19
            },
            "gtin": "4335896563329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f023",
            "leftCorner": {
              "x": 21.699,
              "y": 10.93,
              "z": 1.19
            },
            "rightCorner": {
              "x": 21.692,
              "y": 10.824,
              "z": 1.19
            },
            "gtin": "4335896563329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f024",
            "leftCorner": {
              "x": 21.692,
              "y": 10.824,
              "z": 1.19
            },
            "rightCorner": {
              "x": 21.687,
              "y": 10.718,
              "z": 1.19
            },
            "gtin": "4335896563329",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546464",
        "height": 1.7044,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1efbf",
            "leftCorner": {
              "x": 21.736,
              "y": 11.951,
              "z": 1.395
            },
            "rightCorner": {
              "x": 21.731,
              "y": 11.869,
              "z": 1.395
            },
            "gtin": "4008230010901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efc0",
            "leftCorner": {
              "x": 21.731,
              "y": 11.869,
              "z": 1.395
            },
            "rightCorner": {
              "x": 21.727,
              "y": 11.788,
              "z": 1.395
            },
            "gtin": "4008230010901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efc1",
            "leftCorner": {
              "x": 21.727,
              "y": 11.788,
              "z": 1.395
            },
            "rightCorner": {
              "x": 21.722,
              "y": 11.706,
              "z": 1.395
            },
            "gtin": "4008230010901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efc2",
            "leftCorner": {
              "x": 21.72,
              "y": 11.706,
              "z": 1.395
            },
            "rightCorner": {
              "x": 21.711,
              "y": 11.515,
              "z": 1.395
            },
            "gtin": "4036300047304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efc3",
            "leftCorner": {
              "x": 21.723,
              "y": 11.515,
              "z": 1.395
            },
            "rightCorner": {
              "x": 21.72,
              "y": 11.453,
              "z": 1.395
            },
            "gtin": "4036300220950",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efc4",
            "leftCorner": {
              "x": 21.72,
              "y": 11.453,
              "z": 1.395
            },
            "rightCorner": {
              "x": 21.716,
              "y": 11.392,
              "z": 1.395
            },
            "gtin": "4036300220950",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efc5",
            "leftCorner": {
              "x": 21.716,
              "y": 11.392,
              "z": 1.395
            },
            "rightCorner": {
              "x": 21.713,
              "y": 11.33,
              "z": 1.395
            },
            "gtin": "4036300220950",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efc6",
            "leftCorner": {
              "x": 21.713,
              "y": 11.33,
              "z": 1.395
            },
            "rightCorner": {
              "x": 21.709,
              "y": 11.269,
              "z": 1.395
            },
            "gtin": "4036300220950",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efc7",
            "leftCorner": {
              "x": 21.711,
              "y": 11.269,
              "z": 1.395
            },
            "rightCorner": {
              "x": 21.71,
              "y": 11.221,
              "z": 1.395
            },
            "gtin": "4260024180102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efc8",
            "leftCorner": {
              "x": 21.71,
              "y": 11.221,
              "z": 1.395
            },
            "rightCorner": {
              "x": 21.707,
              "y": 11.174,
              "z": 1.395
            },
            "gtin": "4260024180102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efc9",
            "leftCorner": {
              "x": 21.707,
              "y": 11.174,
              "z": 1.395
            },
            "rightCorner": {
              "x": 21.704,
              "y": 11.126,
              "z": 1.395
            },
            "gtin": "4260024180102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efca",
            "leftCorner": {
              "x": 21.705,
              "y": 11.126,
              "z": 1.395
            },
            "rightCorner": {
              "x": 21.703,
              "y": 11.087,
              "z": 1.395
            },
            "gtin": "4045317053017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efcb",
            "leftCorner": {
              "x": 21.703,
              "y": 11.087,
              "z": 1.395
            },
            "rightCorner": {
              "x": 21.7,
              "y": 11.047,
              "z": 1.395
            },
            "gtin": "4045317053017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efcc",
            "leftCorner": {
              "x": 21.7,
              "y": 11.047,
              "z": 1.395
            },
            "rightCorner": {
              "x": 21.698,
              "y": 11.007,
              "z": 1.395
            },
            "gtin": "4045317053017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efcd",
            "leftCorner": {
              "x": 21.698,
              "y": 11.007,
              "z": 1.395
            },
            "rightCorner": {
              "x": 21.696,
              "y": 10.967,
              "z": 1.395
            },
            "gtin": "4045317053017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efce",
            "leftCorner": {
              "x": 21.696,
              "y": 10.967,
              "z": 1.395
            },
            "rightCorner": {
              "x": 21.694,
              "y": 10.928,
              "z": 1.395
            },
            "gtin": "4045317053017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efcf",
            "leftCorner": {
              "x": 21.702,
              "y": 10.927,
              "z": 1.395
            },
            "rightCorner": {
              "x": 21.697,
              "y": 10.821,
              "z": 1.395
            },
            "gtin": "4045317053024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efd0",
            "leftCorner": {
              "x": 21.697,
              "y": 10.821,
              "z": 1.395
            },
            "rightCorner": {
              "x": 21.691,
              "y": 10.715,
              "z": 1.395
            },
            "gtin": "4045317053024",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "9301c",
    "rightNeighborShelfId": "9301e"
  },
  {
    "id": "9301e",
    "name": "9301e",
    "x": 21.64,
    "y": 10.763,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72515,
      "w": 0.68859
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 23
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546960",
        "height": 0.14666,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f073",
            "leftCorner": {
              "x": 21.693,
              "y": 10.719,
              "z": 0.12
            },
            "rightCorner": {
              "x": 21.672,
              "y": 10.324,
              "z": 0.12
            },
            "gtin": "4337185471896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f074",
            "leftCorner": {
              "x": 21.672,
              "y": 10.324,
              "z": 0.12
            },
            "rightCorner": {
              "x": 21.652,
              "y": 9.931,
              "z": 0.12
            },
            "gtin": "4337185471896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f06d",
            "leftCorner": {
              "x": 21.641,
              "y": 9.93,
              "z": 0.12
            },
            "rightCorner": {
              "x": 21.621,
              "y": 9.562,
              "z": 0.12
            },
            "gtin": "4337185471810",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54695f",
        "height": 0.65076,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef93",
            "leftCorner": {
              "x": 21.69,
              "y": 10.684,
              "z": 0.532
            },
            "rightCorner": {
              "x": 21.67,
              "y": 10.294,
              "z": 0.532
            },
            "gtin": "4337185465994",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef94",
            "leftCorner": {
              "x": 21.67,
              "y": 10.294,
              "z": 0.532
            },
            "rightCorner": {
              "x": 21.649,
              "y": 9.904,
              "z": 0.532
            },
            "gtin": "4337185465994",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef95",
            "leftCorner": {
              "x": 21.649,
              "y": 9.904,
              "z": 0.532
            },
            "rightCorner": {
              "x": 21.629,
              "y": 9.514,
              "z": 0.532
            },
            "gtin": "4337185465994",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546961",
        "height": 1.1028,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f03c",
            "leftCorner": {
              "x": 21.651,
              "y": 10.142,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.645,
              "y": 10.045,
              "z": 0.902
            },
            "gtin": "8710283654303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f03d",
            "leftCorner": {
              "x": 21.645,
              "y": 10.045,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.641,
              "y": 9.949,
              "z": 0.902
            },
            "gtin": "8710283654303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f03e",
            "leftCorner": {
              "x": 21.641,
              "y": 9.949,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.635,
              "y": 9.853,
              "z": 0.902
            },
            "gtin": "8710283654303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f03f",
            "leftCorner": {
              "x": 21.635,
              "y": 9.853,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.631,
              "y": 9.756,
              "z": 0.902
            },
            "gtin": "8710283654303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f040",
            "leftCorner": {
              "x": 21.631,
              "y": 9.756,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.625,
              "y": 9.659,
              "z": 0.902
            },
            "gtin": "8710283654303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f041",
            "leftCorner": {
              "x": 21.625,
              "y": 9.659,
              "z": 0.902
            },
            "rightCorner": {
              "x": 21.621,
              "y": 9.562,
              "z": 0.902
            },
            "gtin": "8710283654303",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54695e",
        "height": 1.4539,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f025",
            "leftCorner": {
              "x": 21.671,
              "y": 10.717,
              "z": 1.19
            },
            "rightCorner": {
              "x": 21.633,
              "y": 10.002,
              "z": 1.19
            },
            "gtin": "40273938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f026",
            "leftCorner": {
              "x": 21.623,
              "y": 10.003,
              "z": 1.19
            },
            "rightCorner": {
              "x": 21.61,
              "y": 9.763,
              "z": 1.19
            },
            "gtin": "40273426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f027",
            "leftCorner": {
              "x": 21.61,
              "y": 9.763,
              "z": 1.19
            },
            "rightCorner": {
              "x": 21.598,
              "y": 9.525,
              "z": 1.19
            },
            "gtin": "40273426",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54695d",
        "height": 1.7059,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1efd1",
            "leftCorner": {
              "x": 21.683,
              "y": 10.714,
              "z": 1.396
            },
            "rightCorner": {
              "x": 21.675,
              "y": 10.543,
              "z": 1.396
            },
            "gtin": "4027300325004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efd2",
            "leftCorner": {
              "x": 21.675,
              "y": 10.543,
              "z": 1.396
            },
            "rightCorner": {
              "x": 21.666,
              "y": 10.37,
              "z": 1.396
            },
            "gtin": "4027300325004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efd3",
            "leftCorner": {
              "x": 21.666,
              "y": 10.37,
              "z": 1.396
            },
            "rightCorner": {
              "x": 21.657,
              "y": 10.197,
              "z": 1.396
            },
            "gtin": "4027300325004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efd4",
            "leftCorner": {
              "x": 21.652,
              "y": 10.197,
              "z": 1.396
            },
            "rightCorner": {
              "x": 21.646,
              "y": 10.076,
              "z": 1.396
            },
            "gtin": "40273952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efd5",
            "leftCorner": {
              "x": 21.646,
              "y": 10.076,
              "z": 1.396
            },
            "rightCorner": {
              "x": 21.64,
              "y": 9.957,
              "z": 1.396
            },
            "gtin": "40273952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efd6",
            "leftCorner": {
              "x": 21.64,
              "y": 9.957,
              "z": 1.396
            },
            "rightCorner": {
              "x": 21.634,
              "y": 9.836,
              "z": 1.396
            },
            "gtin": "40273952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efd7",
            "leftCorner": {
              "x": 21.634,
              "y": 9.836,
              "z": 1.396
            },
            "rightCorner": {
              "x": 21.628,
              "y": 9.715,
              "z": 1.396
            },
            "gtin": "40273952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efd8",
            "leftCorner": {
              "x": 21.628,
              "y": 9.715,
              "z": 1.396
            },
            "rightCorner": {
              "x": 21.621,
              "y": 9.594,
              "z": 1.396
            },
            "gtin": "40273952",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "9301d",
    "rightNeighborShelfId": "9301f"
  },
  {
    "id": "9301f",
    "name": "9301f",
    "x": 21.578,
    "y": 9.565,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72515,
      "w": 0.68859
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546965",
        "height": 0.65487,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef75",
            "leftCorner": {
              "x": 21.611,
              "y": 9.515,
              "z": 0.536
            },
            "rightCorner": {
              "x": 21.582,
              "y": 8.94,
              "z": 0.536
            },
            "gtin": "4337185471780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef76",
            "leftCorner": {
              "x": 21.582,
              "y": 8.94,
              "z": 0.536
            },
            "rightCorner": {
              "x": 21.552,
              "y": 8.365,
              "z": 0.536
            },
            "gtin": "4337185471780",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546962",
        "height": 1.114,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a546964",
        "height": 1.4533,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f028",
            "leftCorner": {
              "x": 21.607,
              "y": 9.525,
              "z": 1.189
            },
            "rightCorner": {
              "x": 21.593,
              "y": 9.247,
              "z": 1.189
            },
            "gtin": "40273907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f029",
            "leftCorner": {
              "x": 21.586,
              "y": 9.247,
              "z": 1.189
            },
            "rightCorner": {
              "x": 21.577,
              "y": 9.098,
              "z": 1.189
            },
            "gtin": "40273433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f02a",
            "leftCorner": {
              "x": 21.577,
              "y": 9.098,
              "z": 1.189
            },
            "rightCorner": {
              "x": 21.57,
              "y": 8.95,
              "z": 1.189
            },
            "gtin": "40273433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f02b",
            "leftCorner": {
              "x": 21.576,
              "y": 8.949,
              "z": 1.189
            },
            "rightCorner": {
              "x": 21.568,
              "y": 8.801,
              "z": 1.189
            },
            "gtin": "4021155201261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f02c",
            "leftCorner": {
              "x": 21.568,
              "y": 8.801,
              "z": 1.189
            },
            "rightCorner": {
              "x": 21.561,
              "y": 8.653,
              "z": 1.189
            },
            "gtin": "4021155201261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f02d",
            "leftCorner": {
              "x": 21.561,
              "y": 8.653,
              "z": 1.189
            },
            "rightCorner": {
              "x": 21.552,
              "y": 8.505,
              "z": 1.189
            },
            "gtin": "4021155201261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f02e",
            "leftCorner": {
              "x": 21.552,
              "y": 8.505,
              "z": 1.189
            },
            "rightCorner": {
              "x": 21.545,
              "y": 8.357,
              "z": 1.189
            },
            "gtin": "4021155201261",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546963",
        "height": 1.7068,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1efd9",
            "leftCorner": {
              "x": 21.612,
              "y": 9.595,
              "z": 1.396
            },
            "rightCorner": {
              "x": 21.602,
              "y": 9.423,
              "z": 1.396
            },
            "gtin": "4300175742085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efda",
            "leftCorner": {
              "x": 21.602,
              "y": 9.423,
              "z": 1.396
            },
            "rightCorner": {
              "x": 21.594,
              "y": 9.249,
              "z": 1.396
            },
            "gtin": "4300175742085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efdb",
            "leftCorner": {
              "x": 21.594,
              "y": 9.249,
              "z": 1.396
            },
            "rightCorner": {
              "x": 21.584,
              "y": 9.075,
              "z": 1.396
            },
            "gtin": "4300175742085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efdc",
            "leftCorner": {
              "x": 21.584,
              "y": 9.075,
              "z": 1.396
            },
            "rightCorner": {
              "x": 21.576,
              "y": 8.902,
              "z": 1.396
            },
            "gtin": "4300175742085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efdd",
            "leftCorner": {
              "x": 21.576,
              "y": 8.902,
              "z": 1.396
            },
            "rightCorner": {
              "x": 21.566,
              "y": 8.728,
              "z": 1.396
            },
            "gtin": "4300175742085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efde",
            "leftCorner": {
              "x": 21.566,
              "y": 8.728,
              "z": 1.396
            },
            "rightCorner": {
              "x": 21.558,
              "y": 8.555,
              "z": 1.396
            },
            "gtin": "4300175742085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efdf",
            "leftCorner": {
              "x": 21.56,
              "y": 8.555,
              "z": 1.396
            },
            "rightCorner": {
              "x": 21.556,
              "y": 8.493,
              "z": 1.396
            },
            "gtin": "4005500081128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efe0",
            "leftCorner": {
              "x": 21.556,
              "y": 8.493,
              "z": 1.396
            },
            "rightCorner": {
              "x": 21.553,
              "y": 8.431,
              "z": 1.396
            },
            "gtin": "4005500081128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efe1",
            "leftCorner": {
              "x": 21.553,
              "y": 8.431,
              "z": 1.396
            },
            "rightCorner": {
              "x": 21.55,
              "y": 8.369,
              "z": 1.396
            },
            "gtin": "4005500081128",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "9301e",
    "rightNeighborShelfId": "93020"
  },
  {
    "id": "93020",
    "name": "93020",
    "x": 21.404,
    "y": 8.378,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72734,
      "w": 0.68628
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 38
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546968",
        "height": 1.6981,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1efe4",
            "leftCorner": {
              "x": 21.421,
              "y": 8.066,
              "z": 1.389
            },
            "rightCorner": {
              "x": 21.413,
              "y": 7.935,
              "z": 1.389
            },
            "gtin": "4008837290072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efe5",
            "leftCorner": {
              "x": 21.418,
              "y": 7.935,
              "z": 1.389
            },
            "rightCorner": {
              "x": 21.41,
              "y": 7.795,
              "z": 1.389
            },
            "gtin": "4008837950129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efe6",
            "leftCorner": {
              "x": 21.41,
              "y": 7.795,
              "z": 1.389
            },
            "rightCorner": {
              "x": 21.402,
              "y": 7.655,
              "z": 1.389
            },
            "gtin": "4008837950129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efe7",
            "leftCorner": {
              "x": 21.402,
              "y": 7.655,
              "z": 1.389
            },
            "rightCorner": {
              "x": 21.395,
              "y": 7.515,
              "z": 1.389
            },
            "gtin": "4008837950129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efe8",
            "leftCorner": {
              "x": 21.395,
              "y": 7.515,
              "z": 1.389
            },
            "rightCorner": {
              "x": 21.387,
              "y": 7.376,
              "z": 1.389
            },
            "gtin": "4008837950129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efe9",
            "leftCorner": {
              "x": 21.379,
              "y": 7.376,
              "z": 1.389
            },
            "rightCorner": {
              "x": 21.372,
              "y": 7.258,
              "z": 1.389
            },
            "gtin": "4009452005010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efea",
            "leftCorner": {
              "x": 21.372,
              "y": 7.258,
              "z": 1.389
            },
            "rightCorner": {
              "x": 21.365,
              "y": 7.139,
              "z": 1.389
            },
            "gtin": "4009452005010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef9a",
            "leftCorner": {
              "x": 21.363,
              "y": 7.139,
              "z": 1.389
            },
            "rightCorner": {
              "x": 21.357,
              "y": 7.028,
              "z": 1.389
            },
            "gtin": "4009452000510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efe2",
            "leftCorner": {
              "x": 21.436,
              "y": 8.381,
              "z": 1.389
            },
            "rightCorner": {
              "x": 21.433,
              "y": 8.319,
              "z": 1.389
            },
            "gtin": "4030716051023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efe3",
            "leftCorner": {
              "x": 21.437,
              "y": 8.318,
              "z": 1.389
            },
            "rightCorner": {
              "x": 21.422,
              "y": 8.066,
              "z": 1.389
            },
            "gtin": "4030716051016",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54696a",
        "height": 0.20215,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a216f8",
            "leftCorner": {
              "x": 21.455,
              "y": 8.352,
              "z": 0.165
            },
            "rightCorner": {
              "x": 21.378,
              "y": 7.027,
              "z": 0.165
            },
            "gtin": "4337185517228",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546966",
        "height": 0.70208,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a216ea",
            "leftCorner": {
              "x": 21.438,
              "y": 8.35,
              "z": 0.574
            },
            "rightCorner": {
              "x": 21.399,
              "y": 7.689,
              "z": 0.574
            },
            "gtin": "4337185517198",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216eb",
            "leftCorner": {
              "x": 21.399,
              "y": 7.689,
              "z": 0.574
            },
            "rightCorner": {
              "x": 21.361,
              "y": 7.028,
              "z": 0.574
            },
            "gtin": "4337185517198",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546967",
        "height": 1.1551,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a216ec",
            "leftCorner": {
              "x": 21.402,
              "y": 8.378,
              "z": 0.945
            },
            "rightCorner": {
              "x": 21.396,
              "y": 8.288,
              "z": 0.945
            },
            "gtin": "4006508206810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216ed",
            "leftCorner": {
              "x": 21.396,
              "y": 8.288,
              "z": 0.945
            },
            "rightCorner": {
              "x": 21.392,
              "y": 8.198,
              "z": 0.945
            },
            "gtin": "4006508206810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216ee",
            "leftCorner": {
              "x": 21.392,
              "y": 8.198,
              "z": 0.945
            },
            "rightCorner": {
              "x": 21.386,
              "y": 8.108,
              "z": 0.945
            },
            "gtin": "4006508206810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216f2",
            "leftCorner": {
              "x": 21.43,
              "y": 8.106,
              "z": 0.945
            },
            "rightCorner": {
              "x": 21.424,
              "y": 8.001,
              "z": 0.945
            },
            "gtin": "4006508206834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216f3",
            "leftCorner": {
              "x": 21.424,
              "y": 8.001,
              "z": 0.945
            },
            "rightCorner": {
              "x": 21.418,
              "y": 7.896,
              "z": 0.945
            },
            "gtin": "4006508206834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216f4",
            "leftCorner": {
              "x": 21.418,
              "y": 7.896,
              "z": 0.945
            },
            "rightCorner": {
              "x": 21.412,
              "y": 7.791,
              "z": 0.945
            },
            "gtin": "4006508206834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216f5",
            "leftCorner": {
              "x": 21.407,
              "y": 7.791,
              "z": 0.945
            },
            "rightCorner": {
              "x": 21.398,
              "y": 7.632,
              "z": 0.945
            },
            "gtin": "4006508208814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216f6",
            "leftCorner": {
              "x": 21.399,
              "y": 7.632,
              "z": 0.945
            },
            "rightCorner": {
              "x": 21.389,
              "y": 7.457,
              "z": 0.945
            },
            "gtin": "4006508206827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216f7",
            "leftCorner": {
              "x": 21.389,
              "y": 7.457,
              "z": 0.945
            },
            "rightCorner": {
              "x": 21.379,
              "y": 7.282,
              "z": 0.945
            },
            "gtin": "4006508206827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216ef",
            "leftCorner": {
              "x": 21.375,
              "y": 7.282,
              "z": 0.945
            },
            "rightCorner": {
              "x": 21.37,
              "y": 7.198,
              "z": 0.945
            },
            "gtin": "4006508123834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216f0",
            "leftCorner": {
              "x": 21.37,
              "y": 7.198,
              "z": 0.945
            },
            "rightCorner": {
              "x": 21.364,
              "y": 7.113,
              "z": 0.945
            },
            "gtin": "4006508123834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216f1",
            "leftCorner": {
              "x": 21.364,
              "y": 7.113,
              "z": 0.945
            },
            "rightCorner": {
              "x": 21.36,
              "y": 7.028,
              "z": 0.945
            },
            "gtin": "4006508123834",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546969",
        "height": 1.4582,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f02f",
            "leftCorner": {
              "x": 21.437,
              "y": 8.367,
              "z": 1.193
            },
            "rightCorner": {
              "x": 21.43,
              "y": 8.231,
              "z": 1.193
            },
            "gtin": "4006508208838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f030",
            "leftCorner": {
              "x": 21.43,
              "y": 8.231,
              "z": 1.193
            },
            "rightCorner": {
              "x": 21.422,
              "y": 8.096,
              "z": 1.193
            },
            "gtin": "4006508208838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f031",
            "leftCorner": {
              "x": 21.425,
              "y": 8.096,
              "z": 1.193
            },
            "rightCorner": {
              "x": 21.417,
              "y": 7.973,
              "z": 1.193
            },
            "gtin": "4006508178087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f032",
            "leftCorner": {
              "x": 21.417,
              "y": 7.973,
              "z": 1.193
            },
            "rightCorner": {
              "x": 21.41,
              "y": 7.849,
              "z": 1.193
            },
            "gtin": "4006508178087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f033",
            "leftCorner": {
              "x": 21.411,
              "y": 7.849,
              "z": 1.193
            },
            "rightCorner": {
              "x": 21.405,
              "y": 7.757,
              "z": 1.193
            },
            "gtin": "4006508206926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f034",
            "leftCorner": {
              "x": 21.405,
              "y": 7.757,
              "z": 1.193
            },
            "rightCorner": {
              "x": 21.401,
              "y": 7.665,
              "z": 1.193
            },
            "gtin": "4006508206926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f035",
            "leftCorner": {
              "x": 21.401,
              "y": 7.665,
              "z": 1.193
            },
            "rightCorner": {
              "x": 21.395,
              "y": 7.573,
              "z": 1.193
            },
            "gtin": "4006508206926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f036",
            "leftCorner": {
              "x": 21.399,
              "y": 7.573,
              "z": 1.193
            },
            "rightCorner": {
              "x": 21.391,
              "y": 7.438,
              "z": 1.193
            },
            "gtin": "4006508125999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f037",
            "leftCorner": {
              "x": 21.391,
              "y": 7.438,
              "z": 1.193
            },
            "rightCorner": {
              "x": 21.383,
              "y": 7.303,
              "z": 1.193
            },
            "gtin": "4006508125999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f038",
            "leftCorner": {
              "x": 21.381,
              "y": 7.304,
              "z": 1.193
            },
            "rightCorner": {
              "x": 21.376,
              "y": 7.224,
              "z": 1.193
            },
            "gtin": "4006508126033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f039",
            "leftCorner": {
              "x": 21.376,
              "y": 7.224,
              "z": 1.193
            },
            "rightCorner": {
              "x": 21.372,
              "y": 7.144,
              "z": 1.193
            },
            "gtin": "4006508126033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efed",
            "leftCorner": {
              "x": 21.362,
              "y": 7.144,
              "z": 1.193
            },
            "rightCorner": {
              "x": 21.359,
              "y": 7.086,
              "z": 1.193
            },
            "gtin": "4006508204335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efee",
            "leftCorner": {
              "x": 21.359,
              "y": 7.086,
              "z": 1.193
            },
            "rightCorner": {
              "x": 21.355,
              "y": 7.029,
              "z": 1.193
            },
            "gtin": "4006508204335",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "9301f",
    "rightNeighborShelfId": "ddeae"
  },
  {
    "id": "99d6a",
    "name": "99d6a",
    "x": 1.825,
    "y": 6.298,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69124,
      "w": 0.72263
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 46
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546213",
        "height": 0.14329,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1dabf",
            "leftCorner": {
              "x": 1.78,
              "y": 6.343,
              "z": 0.117
            },
            "rightCorner": {
              "x": 1.817,
              "y": 7.182,
              "z": 0.117
            },
            "gtin": "8445291248403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dac0",
            "leftCorner": {
              "x": 1.807,
              "y": 7.182,
              "z": 0.117
            },
            "rightCorner": {
              "x": 1.82,
              "y": 7.49,
              "z": 0.117
            },
            "gtin": "8445291306516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dac1",
            "leftCorner": {
              "x": 1.82,
              "y": 7.49,
              "z": 0.117
            },
            "rightCorner": {
              "x": 1.834,
              "y": 7.798,
              "z": 0.117
            },
            "gtin": "8445291306516",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546212",
        "height": 0.54707,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1daeb",
            "leftCorner": {
              "x": 1.832,
              "y": 6.298,
              "z": 0.448
            },
            "rightCorner": {
              "x": 1.846,
              "y": 6.592,
              "z": 0.448
            },
            "gtin": "8445291238701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daee",
            "leftCorner": {
              "x": 1.814,
              "y": 6.594,
              "z": 0.448
            },
            "rightCorner": {
              "x": 1.82,
              "y": 6.74,
              "z": 0.448
            },
            "gtin": "4052700022901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daef",
            "leftCorner": {
              "x": 1.808,
              "y": 6.74,
              "z": 0.448
            },
            "rightCorner": {
              "x": 1.816,
              "y": 6.929,
              "z": 0.448
            },
            "gtin": "4052700022956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daf0",
            "leftCorner": {
              "x": 1.816,
              "y": 6.929,
              "z": 0.448
            },
            "rightCorner": {
              "x": 1.825,
              "y": 7.118,
              "z": 0.448
            },
            "gtin": "4052700022956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daf1",
            "leftCorner": {
              "x": 1.83,
              "y": 7.118,
              "z": 0.448
            },
            "rightCorner": {
              "x": 1.837,
              "y": 7.27,
              "z": 0.448
            },
            "gtin": "4052700022925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daec",
            "leftCorner": {
              "x": 1.851,
              "y": 7.269,
              "z": 0.448
            },
            "rightCorner": {
              "x": 1.857,
              "y": 7.408,
              "z": 0.448
            },
            "gtin": "4052700022932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daed",
            "leftCorner": {
              "x": 1.857,
              "y": 7.408,
              "z": 0.448
            },
            "rightCorner": {
              "x": 1.863,
              "y": 7.548,
              "z": 0.448
            },
            "gtin": "4052700022932",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546210",
        "height": 0.95139,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1da96",
            "leftCorner": {
              "x": 1.795,
              "y": 6.288,
              "z": 0.778
            },
            "rightCorner": {
              "x": 1.806,
              "y": 6.544,
              "z": 0.778
            },
            "gtin": "015700050026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da97",
            "leftCorner": {
              "x": 1.8,
              "y": 6.544,
              "z": 0.778
            },
            "rightCorner": {
              "x": 1.805,
              "y": 6.644,
              "z": 0.778
            },
            "gtin": "4052700079097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da98",
            "leftCorner": {
              "x": 1.805,
              "y": 6.644,
              "z": 0.778
            },
            "rightCorner": {
              "x": 1.809,
              "y": 6.744,
              "z": 0.778
            },
            "gtin": "4052700079097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da99",
            "leftCorner": {
              "x": 1.815,
              "y": 6.743,
              "z": 0.778
            },
            "rightCorner": {
              "x": 1.825,
              "y": 6.977,
              "z": 0.778
            },
            "gtin": "4052700083438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da9a",
            "leftCorner": {
              "x": 1.827,
              "y": 6.977,
              "z": 0.778
            },
            "rightCorner": {
              "x": 1.835,
              "y": 7.169,
              "z": 0.778
            },
            "gtin": "4052700085722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da9b",
            "leftCorner": {
              "x": 1.833,
              "y": 7.169,
              "z": 0.778
            },
            "rightCorner": {
              "x": 1.842,
              "y": 7.37,
              "z": 0.778
            },
            "gtin": "4052700083421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da9c",
            "leftCorner": {
              "x": 1.847,
              "y": 7.37,
              "z": 0.778
            },
            "rightCorner": {
              "x": 1.855,
              "y": 7.553,
              "z": 0.778
            },
            "gtin": "4063367124716",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546211",
        "height": 1.3993,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1dace",
            "leftCorner": {
              "x": 1.837,
              "y": 6.297,
              "z": 1.145
            },
            "rightCorner": {
              "x": 1.842,
              "y": 6.413,
              "z": 1.145
            },
            "gtin": "7610700603024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dacf",
            "leftCorner": {
              "x": 1.842,
              "y": 6.413,
              "z": 1.145
            },
            "rightCorner": {
              "x": 1.848,
              "y": 6.528,
              "z": 1.145
            },
            "gtin": "7610700603024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dad1",
            "leftCorner": {
              "x": 1.8,
              "y": 6.53,
              "z": 1.145
            },
            "rightCorner": {
              "x": 1.803,
              "y": 6.594,
              "z": 1.145
            },
            "gtin": "4045178011294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dad2",
            "leftCorner": {
              "x": 1.803,
              "y": 6.594,
              "z": 1.145
            },
            "rightCorner": {
              "x": 1.806,
              "y": 6.659,
              "z": 1.145
            },
            "gtin": "4045178011294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dad3",
            "leftCorner": {
              "x": 1.81,
              "y": 6.659,
              "z": 1.145
            },
            "rightCorner": {
              "x": 1.817,
              "y": 6.81,
              "z": 1.145
            },
            "gtin": "4045178011270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dad4",
            "leftCorner": {
              "x": 1.818,
              "y": 6.81,
              "z": 1.145
            },
            "rightCorner": {
              "x": 1.824,
              "y": 6.954,
              "z": 1.145
            },
            "gtin": "4045178011331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dad5",
            "leftCorner": {
              "x": 1.829,
              "y": 6.954,
              "z": 1.145
            },
            "rightCorner": {
              "x": 1.833,
              "y": 7.04,
              "z": 1.145
            },
            "gtin": "4045178011355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dad6",
            "leftCorner": {
              "x": 1.848,
              "y": 7.039,
              "z": 1.145
            },
            "rightCorner": {
              "x": 1.852,
              "y": 7.119,
              "z": 1.145
            },
            "gtin": "5021991940934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dad7",
            "leftCorner": {
              "x": 1.854,
              "y": 7.119,
              "z": 1.145
            },
            "rightCorner": {
              "x": 1.859,
              "y": 7.216,
              "z": 1.145
            },
            "gtin": "5021991944765",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dad8",
            "leftCorner": {
              "x": 1.84,
              "y": 7.217,
              "z": 1.145
            },
            "rightCorner": {
              "x": 1.844,
              "y": 7.295,
              "z": 1.145
            },
            "gtin": "5021991939051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dad9",
            "leftCorner": {
              "x": 1.853,
              "y": 7.295,
              "z": 1.145
            },
            "rightCorner": {
              "x": 1.858,
              "y": 7.396,
              "z": 1.145
            },
            "gtin": "5021991939648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dada",
            "leftCorner": {
              "x": 1.861,
              "y": 7.396,
              "z": 1.145
            },
            "rightCorner": {
              "x": 1.865,
              "y": 7.483,
              "z": 1.145
            },
            "gtin": "5021991944604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dadb",
            "leftCorner": {
              "x": 1.873,
              "y": 7.482,
              "z": 1.145
            },
            "rightCorner": {
              "x": 1.875,
              "y": 7.529,
              "z": 1.145
            },
            "gtin": "5021991944789",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54620f",
        "height": 1.705,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1da4d",
            "leftCorner": {
              "x": 1.809,
              "y": 6.286,
              "z": 1.395
            },
            "rightCorner": {
              "x": 1.812,
              "y": 6.353,
              "z": 1.395
            },
            "gtin": "4260272250091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da4e",
            "leftCorner": {
              "x": 1.812,
              "y": 6.353,
              "z": 1.395
            },
            "rightCorner": {
              "x": 1.815,
              "y": 6.42,
              "z": 1.395
            },
            "gtin": "4260272250091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da4f",
            "leftCorner": {
              "x": 1.807,
              "y": 6.421,
              "z": 1.395
            },
            "rightCorner": {
              "x": 1.812,
              "y": 6.542,
              "z": 1.395
            },
            "gtin": "5056357914458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da50",
            "leftCorner": {
              "x": 1.819,
              "y": 6.541,
              "z": 1.395
            },
            "rightCorner": {
              "x": 1.824,
              "y": 6.65,
              "z": 1.395
            },
            "gtin": "5060122039123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da51",
            "leftCorner": {
              "x": 1.825,
              "y": 6.65,
              "z": 1.395
            },
            "rightCorner": {
              "x": 1.828,
              "y": 6.719,
              "z": 1.395
            },
            "gtin": "5060122039284",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da52",
            "leftCorner": {
              "x": 1.828,
              "y": 6.719,
              "z": 1.395
            },
            "rightCorner": {
              "x": 1.831,
              "y": 6.788,
              "z": 1.395
            },
            "gtin": "5060122039284",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da53",
            "leftCorner": {
              "x": 1.835,
              "y": 6.788,
              "z": 1.395
            },
            "rightCorner": {
              "x": 1.838,
              "y": 6.856,
              "z": 1.395
            },
            "gtin": "5999565271596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da54",
            "leftCorner": {
              "x": 1.839,
              "y": 6.855,
              "z": 1.395
            },
            "rightCorner": {
              "x": 1.842,
              "y": 6.93,
              "z": 1.395
            },
            "gtin": "5999565271619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da55",
            "leftCorner": {
              "x": 1.849,
              "y": 6.929,
              "z": 1.395
            },
            "rightCorner": {
              "x": 1.852,
              "y": 7.008,
              "z": 1.395
            },
            "gtin": "5999565271602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da56",
            "leftCorner": {
              "x": 1.852,
              "y": 7.008,
              "z": 1.395
            },
            "rightCorner": {
              "x": 1.856,
              "y": 7.086,
              "z": 1.395
            },
            "gtin": "5999565271602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da57",
            "leftCorner": {
              "x": 1.842,
              "y": 7.086,
              "z": 1.395
            },
            "rightCorner": {
              "x": 1.845,
              "y": 7.15,
              "z": 1.395
            },
            "gtin": "4030716642252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da58",
            "leftCorner": {
              "x": 1.845,
              "y": 7.15,
              "z": 1.395
            },
            "rightCorner": {
              "x": 1.848,
              "y": 7.214,
              "z": 1.395
            },
            "gtin": "4030716642252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da59",
            "leftCorner": {
              "x": 1.848,
              "y": 7.214,
              "z": 1.395
            },
            "rightCorner": {
              "x": 1.851,
              "y": 7.278,
              "z": 1.395
            },
            "gtin": "4030716642252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da5a",
            "leftCorner": {
              "x": 1.85,
              "y": 7.278,
              "z": 1.395
            },
            "rightCorner": {
              "x": 1.855,
              "y": 7.403,
              "z": 1.395
            },
            "gtin": "4030716642030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da5b",
            "leftCorner": {
              "x": 1.864,
              "y": 7.402,
              "z": 1.395
            },
            "rightCorner": {
              "x": 1.867,
              "y": 7.467,
              "z": 1.395
            },
            "gtin": "4030716641606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da5c",
            "leftCorner": {
              "x": 1.867,
              "y": 7.467,
              "z": 1.395
            },
            "rightCorner": {
              "x": 1.87,
              "y": 7.532,
              "z": 1.395
            },
            "gtin": "4030716641606",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "dde69",
    "rightNeighborShelfId": "99d6b"
  },
  {
    "id": "99d6b",
    "name": "99d6b",
    "x": 1.88,
    "y": 7.547,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69124,
      "w": 0.72263
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 79
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546219",
        "height": 0.1414,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1dac2",
            "leftCorner": {
              "x": 1.835,
              "y": 7.799,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.841,
              "y": 7.937,
              "z": 0.116
            },
            "gtin": "4337185536823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dac3",
            "leftCorner": {
              "x": 1.841,
              "y": 7.937,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.848,
              "y": 8.075,
              "z": 0.116
            },
            "gtin": "4337185536823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dac4",
            "leftCorner": {
              "x": 1.85,
              "y": 8.075,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.861,
              "y": 8.328,
              "z": 0.116
            },
            "gtin": "4337185539664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dac5",
            "leftCorner": {
              "x": 1.861,
              "y": 8.328,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.873,
              "y": 8.581,
              "z": 0.116
            },
            "gtin": "4337185539664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dac6",
            "leftCorner": {
              "x": 1.873,
              "y": 8.581,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.884,
              "y": 8.834,
              "z": 0.116
            },
            "gtin": "4337185539664",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546218",
        "height": 0.65184,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1db07",
            "leftCorner": {
              "x": 1.875,
              "y": 7.547,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.88,
              "y": 7.642,
              "z": 0.533
            },
            "gtin": "8445291233126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db08",
            "leftCorner": {
              "x": 1.88,
              "y": 7.642,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.884,
              "y": 7.737,
              "z": 0.533
            },
            "gtin": "8445291233126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db09",
            "leftCorner": {
              "x": 1.884,
              "y": 7.737,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.888,
              "y": 7.831,
              "z": 0.533
            },
            "gtin": "8445291233126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db0a",
            "leftCorner": {
              "x": 1.851,
              "y": 7.833,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.853,
              "y": 7.893,
              "z": 0.533
            },
            "gtin": "4008071042918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db0b",
            "leftCorner": {
              "x": 1.853,
              "y": 7.893,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.856,
              "y": 7.954,
              "z": 0.533
            },
            "gtin": "4008071042918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db0c",
            "leftCorner": {
              "x": 1.856,
              "y": 7.954,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.859,
              "y": 8.014,
              "z": 0.533
            },
            "gtin": "4008071042918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db0d",
            "leftCorner": {
              "x": 1.859,
              "y": 8.014,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.861,
              "y": 8.074,
              "z": 0.533
            },
            "gtin": "4008071042918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db0e",
            "leftCorner": {
              "x": 1.861,
              "y": 8.074,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.864,
              "y": 8.134,
              "z": 0.533
            },
            "gtin": "4008071042918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db0f",
            "leftCorner": {
              "x": 1.864,
              "y": 8.134,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.867,
              "y": 8.195,
              "z": 0.533
            },
            "gtin": "4008071042918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db10",
            "leftCorner": {
              "x": 1.868,
              "y": 8.195,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.869,
              "y": 8.223,
              "z": 0.533
            },
            "gtin": "4008071090469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db11",
            "leftCorner": {
              "x": 1.869,
              "y": 8.223,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.87,
              "y": 8.252,
              "z": 0.533
            },
            "gtin": "4008071090469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db12",
            "leftCorner": {
              "x": 1.87,
              "y": 8.252,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.872,
              "y": 8.281,
              "z": 0.533
            },
            "gtin": "4008071090469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db13",
            "leftCorner": {
              "x": 1.872,
              "y": 8.281,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.873,
              "y": 8.31,
              "z": 0.533
            },
            "gtin": "4008071090469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db14",
            "leftCorner": {
              "x": 1.872,
              "y": 8.31,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.875,
              "y": 8.386,
              "z": 0.533
            },
            "gtin": "4002221041530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db15",
            "leftCorner": {
              "x": 1.875,
              "y": 8.386,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.879,
              "y": 8.463,
              "z": 0.533
            },
            "gtin": "4002221041530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db16",
            "leftCorner": {
              "x": 1.881,
              "y": 8.463,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.886,
              "y": 8.575,
              "z": 0.533
            },
            "gtin": "4063367330568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db17",
            "leftCorner": {
              "x": 1.886,
              "y": 8.575,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.888,
              "y": 8.612,
              "z": 0.533
            },
            "gtin": "4063367330582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db18",
            "leftCorner": {
              "x": 1.888,
              "y": 8.612,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.889,
              "y": 8.648,
              "z": 0.533
            },
            "gtin": "4063367330582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db19",
            "leftCorner": {
              "x": 1.889,
              "y": 8.648,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.891,
              "y": 8.684,
              "z": 0.533
            },
            "gtin": "4063367330582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db1a",
            "leftCorner": {
              "x": 1.889,
              "y": 8.684,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.891,
              "y": 8.73,
              "z": 0.533
            },
            "gtin": "4063367330544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db1b",
            "leftCorner": {
              "x": 1.891,
              "y": 8.73,
              "z": 0.533
            },
            "rightCorner": {
              "x": 1.893,
              "y": 8.776,
              "z": 0.533
            },
            "gtin": "4063367330544",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546214",
        "height": 0.94831,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1da9d",
            "leftCorner": {
              "x": 1.845,
              "y": 7.554,
              "z": 0.776
            },
            "rightCorner": {
              "x": 1.848,
              "y": 7.615,
              "z": 0.776
            },
            "gtin": "5060229014351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da9e",
            "leftCorner": {
              "x": 1.869,
              "y": 7.614,
              "z": 0.776
            },
            "rightCorner": {
              "x": 1.873,
              "y": 7.713,
              "z": 0.776
            },
            "gtin": "5063270102022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da9f",
            "leftCorner": {
              "x": 1.855,
              "y": 7.714,
              "z": 0.776
            },
            "rightCorner": {
              "x": 1.859,
              "y": 7.8,
              "z": 0.776
            },
            "gtin": "5060229014160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daa0",
            "leftCorner": {
              "x": 1.859,
              "y": 7.8,
              "z": 0.776
            },
            "rightCorner": {
              "x": 1.863,
              "y": 7.887,
              "z": 0.776
            },
            "gtin": "5060229014160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daa1",
            "leftCorner": {
              "x": 1.875,
              "y": 7.886,
              "z": 0.776
            },
            "rightCorner": {
              "x": 1.878,
              "y": 7.96,
              "z": 0.776
            },
            "gtin": "5060229014290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daa2",
            "leftCorner": {
              "x": 1.863,
              "y": 7.96,
              "z": 0.776
            },
            "rightCorner": {
              "x": 1.865,
              "y": 8.007,
              "z": 0.776
            },
            "gtin": "5060229014122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daa3",
            "leftCorner": {
              "x": 1.865,
              "y": 8.007,
              "z": 0.776
            },
            "rightCorner": {
              "x": 1.867,
              "y": 8.053,
              "z": 0.776
            },
            "gtin": "5060229014122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daa4",
            "leftCorner": {
              "x": 1.867,
              "y": 8.053,
              "z": 0.776
            },
            "rightCorner": {
              "x": 1.87,
              "y": 8.099,
              "z": 0.776
            },
            "gtin": "5060229014122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daa5",
            "leftCorner": {
              "x": 1.876,
              "y": 8.099,
              "z": 0.776
            },
            "rightCorner": {
              "x": 1.891,
              "y": 8.433,
              "z": 0.776
            },
            "gtin": "4009300012078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daa6",
            "leftCorner": {
              "x": 1.894,
              "y": 8.433,
              "z": 0.776
            },
            "rightCorner": {
              "x": 1.896,
              "y": 8.479,
              "z": 0.776
            },
            "gtin": "4009300017592",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daa7",
            "leftCorner": {
              "x": 1.896,
              "y": 8.479,
              "z": 0.776
            },
            "rightCorner": {
              "x": 1.898,
              "y": 8.525,
              "z": 0.776
            },
            "gtin": "4009300017592",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daa8",
            "leftCorner": {
              "x": 1.9,
              "y": 8.525,
              "z": 0.776
            },
            "rightCorner": {
              "x": 1.906,
              "y": 8.663,
              "z": 0.776
            },
            "gtin": "4009300017608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daa9",
            "leftCorner": {
              "x": 1.906,
              "y": 8.663,
              "z": 0.776
            },
            "rightCorner": {
              "x": 1.912,
              "y": 8.8,
              "z": 0.776
            },
            "gtin": "4009300017608",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546215",
        "height": 1.1956,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1daf2",
            "leftCorner": {
              "x": 1.893,
              "y": 7.547,
              "z": 0.978
            },
            "rightCorner": {
              "x": 1.897,
              "y": 7.63,
              "z": 0.978
            },
            "gtin": "4009932009644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daf3",
            "leftCorner": {
              "x": 1.897,
              "y": 7.63,
              "z": 0.978
            },
            "rightCorner": {
              "x": 1.901,
              "y": 7.713,
              "z": 0.978
            },
            "gtin": "4009932009644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daf6",
            "leftCorner": {
              "x": 1.865,
              "y": 7.714,
              "z": 0.978
            },
            "rightCorner": {
              "x": 1.87,
              "y": 7.818,
              "z": 0.978
            },
            "gtin": "4009932007886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daf7",
            "leftCorner": {
              "x": 1.87,
              "y": 7.818,
              "z": 0.978
            },
            "rightCorner": {
              "x": 1.874,
              "y": 7.922,
              "z": 0.978
            },
            "gtin": "4009932007886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daf8",
            "leftCorner": {
              "x": 1.872,
              "y": 7.922,
              "z": 0.978
            },
            "rightCorner": {
              "x": 1.877,
              "y": 8.05,
              "z": 0.978
            },
            "gtin": "4009932007756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daf9",
            "leftCorner": {
              "x": 1.867,
              "y": 8.051,
              "z": 0.978
            },
            "rightCorner": {
              "x": 1.871,
              "y": 8.145,
              "z": 0.978
            },
            "gtin": "4009932007909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dafa",
            "leftCorner": {
              "x": 1.871,
              "y": 8.145,
              "z": 0.978
            },
            "rightCorner": {
              "x": 1.875,
              "y": 8.239,
              "z": 0.978
            },
            "gtin": "4009932007909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dafb",
            "leftCorner": {
              "x": 1.882,
              "y": 8.238,
              "z": 0.978
            },
            "rightCorner": {
              "x": 1.889,
              "y": 8.4,
              "z": 0.978
            },
            "gtin": "4047036004448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dafc",
            "leftCorner": {
              "x": 1.889,
              "y": 8.4,
              "z": 0.978
            },
            "rightCorner": {
              "x": 1.896,
              "y": 8.548,
              "z": 0.978
            },
            "gtin": "4009300021070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dafd",
            "leftCorner": {
              "x": 1.895,
              "y": 8.548,
              "z": 0.978
            },
            "rightCorner": {
              "x": 1.901,
              "y": 8.68,
              "z": 0.978
            },
            "gtin": "4009300019060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dafe",
            "leftCorner": {
              "x": 1.9,
              "y": 8.68,
              "z": 0.978
            },
            "rightCorner": {
              "x": 1.91,
              "y": 8.897,
              "z": 0.978
            },
            "gtin": "4009300017530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daff",
            "leftCorner": {
              "x": 1.91,
              "y": 8.897,
              "z": 0.978
            },
            "rightCorner": {
              "x": 1.92,
              "y": 9.115,
              "z": 0.978
            },
            "gtin": "4009300017530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db00",
            "leftCorner": {
              "x": 1.92,
              "y": 9.115,
              "z": 0.978
            },
            "rightCorner": {
              "x": 1.929,
              "y": 9.332,
              "z": 0.978
            },
            "gtin": "4009300017530",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546217",
        "height": 1.3988,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1dadc",
            "leftCorner": {
              "x": 1.864,
              "y": 7.53,
              "z": 1.144
            },
            "rightCorner": {
              "x": 1.868,
              "y": 7.62,
              "z": 1.144
            },
            "gtin": "5021991939044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dadd",
            "leftCorner": {
              "x": 1.875,
              "y": 7.62,
              "z": 1.144
            },
            "rightCorner": {
              "x": 1.877,
              "y": 7.669,
              "z": 1.144
            },
            "gtin": "5021991940231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dade",
            "leftCorner": {
              "x": 1.877,
              "y": 7.669,
              "z": 1.144
            },
            "rightCorner": {
              "x": 1.879,
              "y": 7.718,
              "z": 1.144
            },
            "gtin": "5021991940231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dadf",
            "leftCorner": {
              "x": 1.873,
              "y": 7.719,
              "z": 1.144
            },
            "rightCorner": {
              "x": 1.877,
              "y": 7.812,
              "z": 1.144
            },
            "gtin": "4012824401211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dae0",
            "leftCorner": {
              "x": 1.872,
              "y": 7.813,
              "z": 1.144
            },
            "rightCorner": {
              "x": 1.875,
              "y": 7.876,
              "z": 1.144
            },
            "gtin": "4012824404120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dae1",
            "leftCorner": {
              "x": 1.88,
              "y": 7.876,
              "z": 1.144
            },
            "rightCorner": {
              "x": 1.884,
              "y": 7.962,
              "z": 1.144
            },
            "gtin": "4012824401303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dae2",
            "leftCorner": {
              "x": 1.873,
              "y": 7.962,
              "z": 1.144
            },
            "rightCorner": {
              "x": 1.876,
              "y": 8.043,
              "z": 1.144
            },
            "gtin": "4012824401921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dae3",
            "leftCorner": {
              "x": 1.874,
              "y": 8.043,
              "z": 1.144
            },
            "rightCorner": {
              "x": 1.877,
              "y": 8.117,
              "z": 1.144
            },
            "gtin": "4012824401464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dae4",
            "leftCorner": {
              "x": 1.877,
              "y": 8.117,
              "z": 1.144
            },
            "rightCorner": {
              "x": 1.88,
              "y": 8.19,
              "z": 1.144
            },
            "gtin": "4012824401464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dae5",
            "leftCorner": {
              "x": 1.878,
              "y": 8.19,
              "z": 1.144
            },
            "rightCorner": {
              "x": 1.883,
              "y": 8.291,
              "z": 1.144
            },
            "gtin": "4012824401648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dae6",
            "leftCorner": {
              "x": 1.89,
              "y": 8.291,
              "z": 1.144
            },
            "rightCorner": {
              "x": 1.892,
              "y": 8.337,
              "z": 1.144
            },
            "gtin": "4012824400016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dae7",
            "leftCorner": {
              "x": 1.888,
              "y": 8.338,
              "z": 1.144
            },
            "rightCorner": {
              "x": 1.893,
              "y": 8.443,
              "z": 1.144
            },
            "gtin": "4012824406285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dae8",
            "leftCorner": {
              "x": 1.889,
              "y": 8.443,
              "z": 1.144
            },
            "rightCorner": {
              "x": 1.892,
              "y": 8.531,
              "z": 1.144
            },
            "gtin": "4012824404243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dae9",
            "leftCorner": {
              "x": 1.89,
              "y": 8.532,
              "z": 1.144
            },
            "rightCorner": {
              "x": 1.895,
              "y": 8.644,
              "z": 1.144
            },
            "gtin": "4012824400115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daea",
            "leftCorner": {
              "x": 1.904,
              "y": 8.643,
              "z": 1.144
            },
            "rightCorner": {
              "x": 1.907,
              "y": 8.727,
              "z": 1.144
            },
            "gtin": "4012824401396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dad0",
            "leftCorner": {
              "x": 1.908,
              "y": 8.727,
              "z": 1.144
            },
            "rightCorner": {
              "x": 1.911,
              "y": 8.797,
              "z": 1.144
            },
            "gtin": "4047036004431",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546216",
        "height": 1.6978,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1da5d",
            "leftCorner": {
              "x": 1.852,
              "y": 7.533,
              "z": 1.389
            },
            "rightCorner": {
              "x": 1.854,
              "y": 7.585,
              "z": 1.389
            },
            "gtin": "4030716641729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da5e",
            "leftCorner": {
              "x": 1.854,
              "y": 7.585,
              "z": 1.389
            },
            "rightCorner": {
              "x": 1.856,
              "y": 7.636,
              "z": 1.389
            },
            "gtin": "4030716641729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da5f",
            "leftCorner": {
              "x": 1.858,
              "y": 7.636,
              "z": 1.389
            },
            "rightCorner": {
              "x": 1.867,
              "y": 7.848,
              "z": 1.389
            },
            "gtin": "4030716641750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da60",
            "leftCorner": {
              "x": 1.863,
              "y": 7.848,
              "z": 1.389
            },
            "rightCorner": {
              "x": 1.866,
              "y": 7.915,
              "z": 1.389
            },
            "gtin": "4030716641965",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da61",
            "leftCorner": {
              "x": 1.866,
              "y": 7.915,
              "z": 1.389
            },
            "rightCorner": {
              "x": 1.869,
              "y": 7.981,
              "z": 1.389
            },
            "gtin": "4030716641965",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da62",
            "leftCorner": {
              "x": 1.867,
              "y": 7.982,
              "z": 1.389
            },
            "rightCorner": {
              "x": 1.874,
              "y": 8.154,
              "z": 1.389
            },
            "gtin": "4030716642221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da63",
            "leftCorner": {
              "x": 1.875,
              "y": 8.154,
              "z": 1.389
            },
            "rightCorner": {
              "x": 1.882,
              "y": 8.304,
              "z": 1.389
            },
            "gtin": "4030716642047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da64",
            "leftCorner": {
              "x": 1.882,
              "y": 8.304,
              "z": 1.389
            },
            "rightCorner": {
              "x": 1.888,
              "y": 8.455,
              "z": 1.389
            },
            "gtin": "4030716642047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da65",
            "leftCorner": {
              "x": 1.891,
              "y": 8.454,
              "z": 1.389
            },
            "rightCorner": {
              "x": 1.896,
              "y": 8.563,
              "z": 1.389
            },
            "gtin": "4030716641132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da66",
            "leftCorner": {
              "x": 1.896,
              "y": 8.563,
              "z": 1.389
            },
            "rightCorner": {
              "x": 1.901,
              "y": 8.671,
              "z": 1.389
            },
            "gtin": "4030716641132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da67",
            "leftCorner": {
              "x": 1.901,
              "y": 8.671,
              "z": 1.389
            },
            "rightCorner": {
              "x": 1.906,
              "y": 8.779,
              "z": 1.389
            },
            "gtin": "4030716641132",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "99d6a",
    "rightNeighborShelfId": "99d6c"
  },
  {
    "id": "99d6c",
    "name": "99d6c",
    "x": 1.936,
    "y": 8.796,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69124,
      "w": 0.72263
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 68
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54621d",
        "height": 0.14161,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1dac7",
            "leftCorner": {
              "x": 1.892,
              "y": 8.833,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.898,
              "y": 8.968,
              "z": 0.116
            },
            "gtin": "4300175154123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dac8",
            "leftCorner": {
              "x": 1.898,
              "y": 8.968,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.904,
              "y": 9.102,
              "z": 0.116
            },
            "gtin": "4300175154123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dac9",
            "leftCorner": {
              "x": 1.904,
              "y": 9.102,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.91,
              "y": 9.237,
              "z": 0.116
            },
            "gtin": "4300175154123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daca",
            "leftCorner": {
              "x": 1.897,
              "y": 9.237,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.903,
              "y": 9.384,
              "z": 0.116
            },
            "gtin": "4300175154031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dacb",
            "leftCorner": {
              "x": 1.903,
              "y": 9.384,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.91,
              "y": 9.531,
              "z": 0.116
            },
            "gtin": "4300175154031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dacc",
            "leftCorner": {
              "x": 1.91,
              "y": 9.531,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.916,
              "y": 9.678,
              "z": 0.116
            },
            "gtin": "4300175154031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dacd",
            "leftCorner": {
              "x": 1.916,
              "y": 9.678,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.923,
              "y": 9.826,
              "z": 0.116
            },
            "gtin": "4300175154031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dabb",
            "leftCorner": {
              "x": 1.919,
              "y": 9.826,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.922,
              "y": 9.9,
              "z": 0.116
            },
            "gtin": "4337185634598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dabc",
            "leftCorner": {
              "x": 1.922,
              "y": 9.9,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.926,
              "y": 9.974,
              "z": 0.116
            },
            "gtin": "4337185634598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dabd",
            "leftCorner": {
              "x": 1.926,
              "y": 9.974,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.929,
              "y": 10.048,
              "z": 0.116
            },
            "gtin": "4337185634598",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54621b",
        "height": 0.64929,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1db1c",
            "leftCorner": {
              "x": 1.901,
              "y": 8.776,
              "z": 0.531
            },
            "rightCorner": {
              "x": 1.904,
              "y": 8.832,
              "z": 0.531
            },
            "gtin": "4008137002474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db1d",
            "leftCorner": {
              "x": 1.904,
              "y": 8.832,
              "z": 0.531
            },
            "rightCorner": {
              "x": 1.906,
              "y": 8.888,
              "z": 0.531
            },
            "gtin": "4008137002474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db1e",
            "leftCorner": {
              "x": 1.908,
              "y": 8.888,
              "z": 0.531
            },
            "rightCorner": {
              "x": 1.913,
              "y": 9.006,
              "z": 0.531
            },
            "gtin": "4008137002429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db1f",
            "leftCorner": {
              "x": 1.913,
              "y": 9.006,
              "z": 0.531
            },
            "rightCorner": {
              "x": 1.919,
              "y": 9.123,
              "z": 0.531
            },
            "gtin": "4008137002429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db20",
            "leftCorner": {
              "x": 1.91,
              "y": 9.124,
              "z": 0.531
            },
            "rightCorner": {
              "x": 1.913,
              "y": 9.19,
              "z": 0.531
            },
            "gtin": "4008137007653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db21",
            "leftCorner": {
              "x": 1.913,
              "y": 9.19,
              "z": 0.531
            },
            "rightCorner": {
              "x": 1.916,
              "y": 9.257,
              "z": 0.531
            },
            "gtin": "4008137007653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db22",
            "leftCorner": {
              "x": 1.929,
              "y": 9.256,
              "z": 0.531
            },
            "rightCorner": {
              "x": 1.935,
              "y": 9.381,
              "z": 0.531
            },
            "gtin": "4306188358718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db23",
            "leftCorner": {
              "x": 1.92,
              "y": 9.382,
              "z": 0.531
            },
            "rightCorner": {
              "x": 1.924,
              "y": 9.473,
              "z": 0.531
            },
            "gtin": "4002221051232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db24",
            "leftCorner": {
              "x": 1.918,
              "y": 9.474,
              "z": 0.531
            },
            "rightCorner": {
              "x": 1.922,
              "y": 9.563,
              "z": 0.531
            },
            "gtin": "4002221051218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db25",
            "leftCorner": {
              "x": 1.913,
              "y": 9.564,
              "z": 0.531
            },
            "rightCorner": {
              "x": 1.916,
              "y": 9.625,
              "z": 0.531
            },
            "gtin": "4002221051195",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db26",
            "leftCorner": {
              "x": 1.914,
              "y": 9.625,
              "z": 0.531
            },
            "rightCorner": {
              "x": 1.919,
              "y": 9.749,
              "z": 0.531
            },
            "gtin": "4002221049321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db27",
            "leftCorner": {
              "x": 1.928,
              "y": 9.748,
              "z": 0.531
            },
            "rightCorner": {
              "x": 1.936,
              "y": 9.913,
              "z": 0.531
            },
            "gtin": "4002221049284",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db28",
            "leftCorner": {
              "x": 1.946,
              "y": 9.913,
              "z": 0.531
            },
            "rightCorner": {
              "x": 1.95,
              "y": 10.012,
              "z": 0.531
            },
            "gtin": "4002221049260",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54621c",
        "height": 0.93971,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1daaa",
            "leftCorner": {
              "x": 1.922,
              "y": 8.8,
              "z": 0.769
            },
            "rightCorner": {
              "x": 1.924,
              "y": 8.845,
              "z": 0.769
            },
            "gtin": "4008137005512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daab",
            "leftCorner": {
              "x": 1.924,
              "y": 8.845,
              "z": 0.769
            },
            "rightCorner": {
              "x": 1.926,
              "y": 8.889,
              "z": 0.769
            },
            "gtin": "4008137005512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daac",
            "leftCorner": {
              "x": 1.901,
              "y": 8.89,
              "z": 0.769
            },
            "rightCorner": {
              "x": 1.906,
              "y": 8.983,
              "z": 0.769
            },
            "gtin": "4008137002399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daad",
            "leftCorner": {
              "x": 1.906,
              "y": 8.983,
              "z": 0.769
            },
            "rightCorner": {
              "x": 1.91,
              "y": 9.077,
              "z": 0.769
            },
            "gtin": "4008137002399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daae",
            "leftCorner": {
              "x": 1.91,
              "y": 9.077,
              "z": 0.769
            },
            "rightCorner": {
              "x": 1.914,
              "y": 9.17,
              "z": 0.769
            },
            "gtin": "4008137002399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daaf",
            "leftCorner": {
              "x": 1.914,
              "y": 9.17,
              "z": 0.769
            },
            "rightCorner": {
              "x": 1.918,
              "y": 9.263,
              "z": 0.769
            },
            "gtin": "4008137002399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dab0",
            "leftCorner": {
              "x": 1.918,
              "y": 9.263,
              "z": 0.769
            },
            "rightCorner": {
              "x": 1.921,
              "y": 9.319,
              "z": 0.769
            },
            "gtin": "4008137002498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dab1",
            "leftCorner": {
              "x": 1.921,
              "y": 9.319,
              "z": 0.769
            },
            "rightCorner": {
              "x": 1.923,
              "y": 9.375,
              "z": 0.769
            },
            "gtin": "4008137002498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dab2",
            "leftCorner": {
              "x": 1.923,
              "y": 9.375,
              "z": 0.769
            },
            "rightCorner": {
              "x": 1.926,
              "y": 9.431,
              "z": 0.769
            },
            "gtin": "4008137002498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dab3",
            "leftCorner": {
              "x": 1.918,
              "y": 9.431,
              "z": 0.769
            },
            "rightCorner": {
              "x": 1.922,
              "y": 9.516,
              "z": 0.769
            },
            "gtin": "4008137007103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dab4",
            "leftCorner": {
              "x": 1.925,
              "y": 9.516,
              "z": 0.769
            },
            "rightCorner": {
              "x": 1.928,
              "y": 9.591,
              "z": 0.769
            },
            "gtin": "4008137002559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dab5",
            "leftCorner": {
              "x": 1.928,
              "y": 9.591,
              "z": 0.769
            },
            "rightCorner": {
              "x": 1.932,
              "y": 9.665,
              "z": 0.769
            },
            "gtin": "4008137002559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dab6",
            "leftCorner": {
              "x": 1.926,
              "y": 9.666,
              "z": 0.769
            },
            "rightCorner": {
              "x": 1.93,
              "y": 9.764,
              "z": 0.769
            },
            "gtin": "4008137007417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dab7",
            "leftCorner": {
              "x": 1.93,
              "y": 9.764,
              "z": 0.769
            },
            "rightCorner": {
              "x": 1.934,
              "y": 9.862,
              "z": 0.769
            },
            "gtin": "4008137007417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dab8",
            "leftCorner": {
              "x": 1.934,
              "y": 9.862,
              "z": 0.769
            },
            "rightCorner": {
              "x": 1.939,
              "y": 9.96,
              "z": 0.769
            },
            "gtin": "4008137007417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da8e",
            "leftCorner": {
              "x": 1.953,
              "y": 9.96,
              "z": 0.769
            },
            "rightCorner": {
              "x": 1.957,
              "y": 10.046,
              "z": 0.769
            },
            "gtin": "4008137008056",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54621f",
        "height": 1.1915,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1db01",
            "leftCorner": {
              "x": 1.923,
              "y": 9.333,
              "z": 0.975
            },
            "rightCorner": {
              "x": 1.927,
              "y": 9.417,
              "z": 0.975
            },
            "gtin": "4008137007752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db02",
            "leftCorner": {
              "x": 1.927,
              "y": 9.417,
              "z": 0.975
            },
            "rightCorner": {
              "x": 1.931,
              "y": 9.502,
              "z": 0.975
            },
            "gtin": "4008137007752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db03",
            "leftCorner": {
              "x": 1.931,
              "y": 9.502,
              "z": 0.975
            },
            "rightCorner": {
              "x": 1.934,
              "y": 9.586,
              "z": 0.975
            },
            "gtin": "4008137007752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db04",
            "leftCorner": {
              "x": 1.925,
              "y": 9.587,
              "z": 0.975
            },
            "rightCorner": {
              "x": 1.929,
              "y": 9.663,
              "z": 0.975
            },
            "gtin": "4008137007356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db05",
            "leftCorner": {
              "x": 1.929,
              "y": 9.663,
              "z": 0.975
            },
            "rightCorner": {
              "x": 1.932,
              "y": 9.74,
              "z": 0.975
            },
            "gtin": "4008137007356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db06",
            "leftCorner": {
              "x": 1.932,
              "y": 9.74,
              "z": 0.975
            },
            "rightCorner": {
              "x": 1.936,
              "y": 9.817,
              "z": 0.975
            },
            "gtin": "4008137007356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daf4",
            "leftCorner": {
              "x": 1.935,
              "y": 9.817,
              "z": 0.975
            },
            "rightCorner": {
              "x": 1.94,
              "y": 9.932,
              "z": 0.975
            },
            "gtin": "4008137002894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daf5",
            "leftCorner": {
              "x": 1.94,
              "y": 9.932,
              "z": 0.975
            },
            "rightCorner": {
              "x": 1.945,
              "y": 10.047,
              "z": 0.975
            },
            "gtin": "4008137002894",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54621e",
        "height": 1.4415,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1db29",
            "leftCorner": {
              "x": 1.942,
              "y": 8.796,
              "z": 1.179
            },
            "rightCorner": {
              "x": 1.946,
              "y": 8.884,
              "z": 1.179
            },
            "gtin": "4008137002528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db2a",
            "leftCorner": {
              "x": 1.946,
              "y": 8.884,
              "z": 1.179
            },
            "rightCorner": {
              "x": 1.95,
              "y": 8.973,
              "z": 1.179
            },
            "gtin": "4008137002528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db2b",
            "leftCorner": {
              "x": 1.95,
              "y": 8.973,
              "z": 1.179
            },
            "rightCorner": {
              "x": 1.954,
              "y": 9.062,
              "z": 1.179
            },
            "gtin": "4008137002528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db2c",
            "leftCorner": {
              "x": 1.954,
              "y": 9.062,
              "z": 1.179
            },
            "rightCorner": {
              "x": 1.958,
              "y": 9.151,
              "z": 1.179
            },
            "gtin": "4008137002528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db2d",
            "leftCorner": {
              "x": 1.907,
              "y": 9.153,
              "z": 1.179
            },
            "rightCorner": {
              "x": 1.923,
              "y": 9.523,
              "z": 1.179
            },
            "gtin": "4008137007509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db2e",
            "leftCorner": {
              "x": 1.923,
              "y": 9.523,
              "z": 1.179
            },
            "rightCorner": {
              "x": 1.939,
              "y": 9.893,
              "z": 1.179
            },
            "gtin": "4008137007509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db2f",
            "leftCorner": {
              "x": 1.952,
              "y": 9.892,
              "z": 1.179
            },
            "rightCorner": {
              "x": 1.955,
              "y": 9.961,
              "z": 1.179
            },
            "gtin": "4008137002238",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db30",
            "leftCorner": {
              "x": 1.955,
              "y": 9.961,
              "z": 1.179
            },
            "rightCorner": {
              "x": 1.958,
              "y": 10.03,
              "z": 1.179
            },
            "gtin": "4008137002238",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54621a",
        "height": 1.6986,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1da68",
            "leftCorner": {
              "x": 1.895,
              "y": 8.78,
              "z": 1.39
            },
            "rightCorner": {
              "x": 1.9,
              "y": 8.896,
              "z": 1.39
            },
            "gtin": "7610700603024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da69",
            "leftCorner": {
              "x": 1.9,
              "y": 8.896,
              "z": 1.39
            },
            "rightCorner": {
              "x": 1.906,
              "y": 9.013,
              "z": 1.39
            },
            "gtin": "7610700603024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da6a",
            "leftCorner": {
              "x": 1.906,
              "y": 9.013,
              "z": 1.39
            },
            "rightCorner": {
              "x": 1.911,
              "y": 9.129,
              "z": 1.39
            },
            "gtin": "7610700603024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da6b",
            "leftCorner": {
              "x": 1.902,
              "y": 9.129,
              "z": 1.39
            },
            "rightCorner": {
              "x": 1.905,
              "y": 9.191,
              "z": 1.39
            },
            "gtin": "4306188358633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da6c",
            "leftCorner": {
              "x": 1.905,
              "y": 9.191,
              "z": 1.39
            },
            "rightCorner": {
              "x": 1.908,
              "y": 9.253,
              "z": 1.39
            },
            "gtin": "4306188358633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da6d",
            "leftCorner": {
              "x": 1.901,
              "y": 9.253,
              "z": 1.39
            },
            "rightCorner": {
              "x": 1.904,
              "y": 9.309,
              "z": 1.39
            },
            "gtin": "4008137017010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da6e",
            "leftCorner": {
              "x": 1.904,
              "y": 9.309,
              "z": 1.39
            },
            "rightCorner": {
              "x": 1.906,
              "y": 9.365,
              "z": 1.39
            },
            "gtin": "4008137017010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da6f",
            "leftCorner": {
              "x": 1.906,
              "y": 9.365,
              "z": 1.39
            },
            "rightCorner": {
              "x": 1.912,
              "y": 9.502,
              "z": 1.39
            },
            "gtin": "4008137017027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da70",
            "leftCorner": {
              "x": 1.914,
              "y": 9.502,
              "z": 1.39
            },
            "rightCorner": {
              "x": 1.917,
              "y": 9.571,
              "z": 1.39
            },
            "gtin": "4008137017003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da71",
            "leftCorner": {
              "x": 1.917,
              "y": 9.571,
              "z": 1.39
            },
            "rightCorner": {
              "x": 1.92,
              "y": 9.64,
              "z": 1.39
            },
            "gtin": "4008137017003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da72",
            "leftCorner": {
              "x": 1.932,
              "y": 9.64,
              "z": 1.39
            },
            "rightCorner": {
              "x": 1.938,
              "y": 9.777,
              "z": 1.39
            },
            "gtin": "4008137017034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da73",
            "leftCorner": {
              "x": 1.931,
              "y": 9.778,
              "z": 1.39
            },
            "rightCorner": {
              "x": 1.937,
              "y": 9.909,
              "z": 1.39
            },
            "gtin": "4008137017041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da74",
            "leftCorner": {
              "x": 1.928,
              "y": 9.91,
              "z": 1.39
            },
            "rightCorner": {
              "x": 1.933,
              "y": 10.015,
              "z": 1.39
            },
            "gtin": "4008137015047",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "99d6b",
    "rightNeighborShelfId": "99d6d"
  },
  {
    "id": "99d6d",
    "name": "99d6d",
    "x": 1.991,
    "y": 10.044,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69124,
      "w": 0.72263
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 4
    },
    "layers": [
      {
        "id": "682ffddfd15af3232a54699d",
        "height": 0.12839,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21808",
            "leftCorner": {
              "x": 1.89,
              "y": 10.048,
              "z": 0.105
            },
            "rightCorner": {
              "x": 1.896,
              "y": 10.176,
              "z": 0.105
            },
            "gtin": "4052700090498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21809",
            "leftCorner": {
              "x": 1.864,
              "y": 10.178,
              "z": 0.105
            },
            "rightCorner": {
              "x": 1.886,
              "y": 10.68,
              "z": 0.105
            },
            "gtin": "4052700090498",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a54699e",
        "height": 0.68547,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2180a",
            "leftCorner": {
              "x": 1.936,
              "y": 10.047,
              "z": 0.561
            },
            "rightCorner": {
              "x": 1.95,
              "y": 10.361,
              "z": 0.561
            },
            "gtin": "4063367382062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2180b",
            "leftCorner": {
              "x": 1.95,
              "y": 10.361,
              "z": 0.561
            },
            "rightCorner": {
              "x": 1.964,
              "y": 10.676,
              "z": 0.561
            },
            "gtin": "4063367382062",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "99d6c"
  },
  {
    "id": "99d6e",
    "name": "99d6e",
    "x": 1.1,
    "y": -4.675,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68906,
      "w": 0.72471
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 78
    },
    "layers": [
      {
        "id": "682ffddbd15af3232a54614c",
        "height": 1.239,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1ce4f",
            "leftCorner": {
              "x": 1.064,
              "y": -4.393,
              "z": 1.014
            },
            "rightCorner": {
              "x": 1.07,
              "y": -4.276,
              "z": 1.014
            },
            "gtin": "4008495711346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce50",
            "leftCorner": {
              "x": 1.07,
              "y": -4.276,
              "z": 1.014
            },
            "rightCorner": {
              "x": 1.076,
              "y": -4.16,
              "z": 1.014
            },
            "gtin": "4008495711346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce51",
            "leftCorner": {
              "x": 1.062,
              "y": -4.159,
              "z": 1.014
            },
            "rightCorner": {
              "x": 1.069,
              "y": -4.028,
              "z": 1.014
            },
            "gtin": "4008495711209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce52",
            "leftCorner": {
              "x": 1.069,
              "y": -4.028,
              "z": 1.014
            },
            "rightCorner": {
              "x": 1.075,
              "y": -3.896,
              "z": 1.014
            },
            "gtin": "4008495711209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce53",
            "leftCorner": {
              "x": 1.089,
              "y": -3.897,
              "z": 1.014
            },
            "rightCorner": {
              "x": 1.093,
              "y": -3.824,
              "z": 1.014
            },
            "gtin": "4008495711339",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce54",
            "leftCorner": {
              "x": 1.093,
              "y": -3.824,
              "z": 1.014
            },
            "rightCorner": {
              "x": 1.097,
              "y": -3.752,
              "z": 1.014
            },
            "gtin": "4008495711339",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce55",
            "leftCorner": {
              "x": 1.097,
              "y": -3.752,
              "z": 1.014
            },
            "rightCorner": {
              "x": 1.1,
              "y": -3.68,
              "z": 1.014
            },
            "gtin": "4008495711339",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce56",
            "leftCorner": {
              "x": 1.102,
              "y": -3.68,
              "z": 1.014
            },
            "rightCorner": {
              "x": 1.108,
              "y": -3.558,
              "z": 1.014
            },
            "gtin": "4008495711124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce57",
            "leftCorner": {
              "x": 1.108,
              "y": -3.558,
              "z": 1.014
            },
            "rightCorner": {
              "x": 1.114,
              "y": -3.437,
              "z": 1.014
            },
            "gtin": "4008495711124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce4a",
            "leftCorner": {
              "x": 1.089,
              "y": -4.675,
              "z": 1.014
            },
            "rightCorner": {
              "x": 1.094,
              "y": -4.581,
              "z": 1.014
            },
            "gtin": "4337185925986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce4b",
            "leftCorner": {
              "x": 1.094,
              "y": -4.581,
              "z": 1.014
            },
            "rightCorner": {
              "x": 1.099,
              "y": -4.488,
              "z": 1.014
            },
            "gtin": "4337185925986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce4c",
            "leftCorner": {
              "x": 1.099,
              "y": -4.488,
              "z": 1.014
            },
            "rightCorner": {
              "x": 1.103,
              "y": -4.395,
              "z": 1.014
            },
            "gtin": "4337185925986",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a54614e",
        "height": 0.17192,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1ceb9",
            "leftCorner": {
              "x": 1.087,
              "y": -4.674,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.089,
              "y": -4.626,
              "z": 0.141
            },
            "gtin": "4014995463500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceba",
            "leftCorner": {
              "x": 1.089,
              "y": -4.626,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.092,
              "y": -4.578,
              "z": 0.141
            },
            "gtin": "4014995463500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cebb",
            "leftCorner": {
              "x": 1.092,
              "y": -4.578,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.094,
              "y": -4.53,
              "z": 0.141
            },
            "gtin": "4014995463500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cebc",
            "leftCorner": {
              "x": 1.094,
              "y": -4.53,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.097,
              "y": -4.482,
              "z": 0.141
            },
            "gtin": "4014995463500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cec0",
            "leftCorner": {
              "x": 1.066,
              "y": -4.48,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.073,
              "y": -4.345,
              "z": 0.141
            },
            "gtin": "4014995463517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cec1",
            "leftCorner": {
              "x": 1.073,
              "y": -4.345,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.08,
              "y": -4.21,
              "z": 0.141
            },
            "gtin": "4014995463517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cec2",
            "leftCorner": {
              "x": 1.073,
              "y": -4.209,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.082,
              "y": -4.037,
              "z": 0.141
            },
            "gtin": "4014995463524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cec3",
            "leftCorner": {
              "x": 1.083,
              "y": -4.037,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.092,
              "y": -3.852,
              "z": 0.141
            },
            "gtin": "4014995463562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cec4",
            "leftCorner": {
              "x": 1.085,
              "y": -3.851,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.089,
              "y": -3.782,
              "z": 0.141
            },
            "gtin": "4014995463654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cec5",
            "leftCorner": {
              "x": 1.089,
              "y": -3.782,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.092,
              "y": -3.712,
              "z": 0.141
            },
            "gtin": "4014995463654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cec6",
            "leftCorner": {
              "x": 1.092,
              "y": -3.712,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.096,
              "y": -3.642,
              "z": 0.141
            },
            "gtin": "4014995463654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cec7",
            "leftCorner": {
              "x": 1.097,
              "y": -3.642,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.102,
              "y": -3.534,
              "z": 0.141
            },
            "gtin": "4014995463623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cec8",
            "leftCorner": {
              "x": 1.102,
              "y": -3.534,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.108,
              "y": -3.426,
              "z": 0.141
            },
            "gtin": "4014995463623",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546148",
        "height": 0.4896,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cd98",
            "leftCorner": {
              "x": 1.095,
              "y": -4.675,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.1,
              "y": -4.58,
              "z": 0.401
            },
            "gtin": "4260078624065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd99",
            "leftCorner": {
              "x": 1.1,
              "y": -4.58,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.104,
              "y": -4.486,
              "z": 0.401
            },
            "gtin": "4260078624065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd9b",
            "leftCorner": {
              "x": 1.049,
              "y": -4.483,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.056,
              "y": -4.347,
              "z": 0.401
            },
            "gtin": "4260078624041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd9c",
            "leftCorner": {
              "x": 1.056,
              "y": -4.347,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.063,
              "y": -4.21,
              "z": 0.401
            },
            "gtin": "4260078624041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd9d",
            "leftCorner": {
              "x": 1.07,
              "y": -4.211,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.073,
              "y": -4.154,
              "z": 0.401
            },
            "gtin": "4014995289117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd9e",
            "leftCorner": {
              "x": 1.087,
              "y": -4.154,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.09,
              "y": -4.082,
              "z": 0.401
            },
            "gtin": "4014995253750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd9f",
            "leftCorner": {
              "x": 1.085,
              "y": -4.082,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.088,
              "y": -4.02,
              "z": 0.401
            },
            "gtin": "4014995407795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cda0",
            "leftCorner": {
              "x": 1.088,
              "y": -4.02,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.091,
              "y": -3.959,
              "z": 0.401
            },
            "gtin": "4014995407795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cda1",
            "leftCorner": {
              "x": 1.099,
              "y": -3.959,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.103,
              "y": -3.876,
              "z": 0.401
            },
            "gtin": "8717847185570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cda2",
            "leftCorner": {
              "x": 1.103,
              "y": -3.876,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.107,
              "y": -3.792,
              "z": 0.401
            },
            "gtin": "8717847185570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cda3",
            "leftCorner": {
              "x": 1.107,
              "y": -3.792,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.111,
              "y": -3.708,
              "z": 0.401
            },
            "gtin": "8717847185570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cda4",
            "leftCorner": {
              "x": 1.111,
              "y": -3.708,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.115,
              "y": -3.625,
              "z": 0.401
            },
            "gtin": "8717847185570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cda5",
            "leftCorner": {
              "x": 1.109,
              "y": -3.625,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.113,
              "y": -3.536,
              "z": 0.401
            },
            "gtin": "4335896604503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cda6",
            "leftCorner": {
              "x": 1.113,
              "y": -3.536,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.118,
              "y": -3.448,
              "z": 0.401
            },
            "gtin": "4335896604503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cda7",
            "leftCorner": {
              "x": 1.118,
              "y": -3.448,
              "z": 0.401
            },
            "rightCorner": {
              "x": 1.122,
              "y": -3.36,
              "z": 0.401
            },
            "gtin": "4335896604503",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a54614b",
        "height": 0.78661,
        "facings": []
      },
      {
        "id": "682ffddbd15af3232a54614f",
        "height": 0.8848,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1ced9",
            "leftCorner": {
              "x": 1.095,
              "y": -4.675,
              "z": 0.724
            },
            "rightCorner": {
              "x": 1.137,
              "y": -3.859,
              "z": 0.724
            }
          },
          {
            "id": "68300c835ed67a01d9a1ceda",
            "leftCorner": {
              "x": 1.096,
              "y": -3.857,
              "z": 0.724
            },
            "rightCorner": {
              "x": 1.118,
              "y": -3.424,
              "z": 0.724
            },
            "gtin": "4337185266553",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a54614a",
        "height": 0.98755,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cdfa",
            "leftCorner": {
              "x": 1.087,
              "y": -4.674,
              "z": 0.808
            },
            "rightCorner": {
              "x": 1.093,
              "y": -4.554,
              "z": 0.808
            },
            "gtin": "4008495750666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdfb",
            "leftCorner": {
              "x": 1.093,
              "y": -4.554,
              "z": 0.808
            },
            "rightCorner": {
              "x": 1.099,
              "y": -4.434,
              "z": 0.808
            },
            "gtin": "4008495750666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdfc",
            "leftCorner": {
              "x": 1.099,
              "y": -4.434,
              "z": 0.808
            },
            "rightCorner": {
              "x": 1.105,
              "y": -4.314,
              "z": 0.808
            },
            "gtin": "4008495750666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdfe",
            "leftCorner": {
              "x": 1.059,
              "y": -4.312,
              "z": 0.808
            },
            "rightCorner": {
              "x": 1.07,
              "y": -4.095,
              "z": 0.808
            },
            "gtin": "4337185266508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdff",
            "leftCorner": {
              "x": 1.07,
              "y": -4.095,
              "z": 0.808
            },
            "rightCorner": {
              "x": 1.081,
              "y": -3.879,
              "z": 0.808
            },
            "gtin": "4337185266508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce00",
            "leftCorner": {
              "x": 1.081,
              "y": -3.879,
              "z": 0.808
            },
            "rightCorner": {
              "x": 1.092,
              "y": -3.663,
              "z": 0.808
            },
            "gtin": "4337185266508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce01",
            "leftCorner": {
              "x": 1.092,
              "y": -3.663,
              "z": 0.808
            },
            "rightCorner": {
              "x": 1.103,
              "y": -3.446,
              "z": 0.808
            },
            "gtin": "4337185266508",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546149",
        "height": 1.4456,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cdc7",
            "leftCorner": {
              "x": 1.078,
              "y": -4.207,
              "z": 1.183
            },
            "rightCorner": {
              "x": 1.084,
              "y": -4.078,
              "z": 1.183
            },
            "gtin": "4008495712275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdc1",
            "leftCorner": {
              "x": 1.093,
              "y": -4.675,
              "z": 1.183
            },
            "rightCorner": {
              "x": 1.098,
              "y": -4.585,
              "z": 1.183
            },
            "gtin": "8717847136237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdc2",
            "leftCorner": {
              "x": 1.098,
              "y": -4.585,
              "z": 1.183
            },
            "rightCorner": {
              "x": 1.103,
              "y": -4.495,
              "z": 1.183
            },
            "gtin": "8717847136237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdc3",
            "leftCorner": {
              "x": 1.103,
              "y": -4.495,
              "z": 1.183
            },
            "rightCorner": {
              "x": 1.107,
              "y": -4.406,
              "z": 1.183
            },
            "gtin": "8717847136237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdc5",
            "leftCorner": {
              "x": 1.063,
              "y": -4.403,
              "z": 1.183
            },
            "rightCorner": {
              "x": 1.068,
              "y": -4.305,
              "z": 1.183
            },
            "gtin": "8717847136251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdc6",
            "leftCorner": {
              "x": 1.068,
              "y": -4.305,
              "z": 1.183
            },
            "rightCorner": {
              "x": 1.073,
              "y": -4.206,
              "z": 1.183
            },
            "gtin": "8717847136251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdc8",
            "leftCorner": {
              "x": 1.084,
              "y": -4.078,
              "z": 1.183
            },
            "rightCorner": {
              "x": 1.091,
              "y": -3.95,
              "z": 1.183
            },
            "gtin": "4008495712275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdc9",
            "leftCorner": {
              "x": 1.101,
              "y": -3.951,
              "z": 1.183
            },
            "rightCorner": {
              "x": 1.107,
              "y": -3.815,
              "z": 1.183
            },
            "gtin": "4008495711308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdca",
            "leftCorner": {
              "x": 1.107,
              "y": -3.815,
              "z": 1.183
            },
            "rightCorner": {
              "x": 1.114,
              "y": -3.679,
              "z": 1.183
            },
            "gtin": "4008495711308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdcb",
            "leftCorner": {
              "x": 1.104,
              "y": -3.678,
              "z": 1.183
            },
            "rightCorner": {
              "x": 1.111,
              "y": -3.542,
              "z": 1.183
            },
            "gtin": "4337185926037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdcc",
            "leftCorner": {
              "x": 1.111,
              "y": -3.542,
              "z": 1.183
            },
            "rightCorner": {
              "x": 1.118,
              "y": -3.406,
              "z": 1.183
            },
            "gtin": "4337185926037",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a54614d",
        "height": 1.7419,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1ce82",
            "leftCorner": {
              "x": 1.09,
              "y": -4.674,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.094,
              "y": -4.594,
              "z": 1.425
            },
            "gtin": "8717847089847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce83",
            "leftCorner": {
              "x": 1.094,
              "y": -4.594,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.099,
              "y": -4.512,
              "z": 1.425
            },
            "gtin": "8717847089847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce86",
            "leftCorner": {
              "x": 1.079,
              "y": -4.511,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.082,
              "y": -4.452,
              "z": 1.425
            },
            "gtin": "8717847089861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce87",
            "leftCorner": {
              "x": 1.082,
              "y": -4.452,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.085,
              "y": -4.392,
              "z": 1.425
            },
            "gtin": "8717847089861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce88",
            "leftCorner": {
              "x": 1.058,
              "y": -4.39,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.061,
              "y": -4.346,
              "z": 1.425
            },
            "gtin": "8717847089632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce89",
            "leftCorner": {
              "x": 1.061,
              "y": -4.346,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.063,
              "y": -4.301,
              "z": 1.425
            },
            "gtin": "8717847089632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce8a",
            "leftCorner": {
              "x": 1.063,
              "y": -4.301,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.065,
              "y": -4.257,
              "z": 1.425
            },
            "gtin": "8717847089632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce8b",
            "leftCorner": {
              "x": 1.067,
              "y": -4.257,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.072,
              "y": -4.161,
              "z": 1.425
            },
            "gtin": "8717847089885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce8c",
            "leftCorner": {
              "x": 1.072,
              "y": -4.161,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.076,
              "y": -4.066,
              "z": 1.425
            },
            "gtin": "8717847089885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce8d",
            "leftCorner": {
              "x": 1.078,
              "y": -4.066,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.082,
              "y": -3.987,
              "z": 1.425
            },
            "gtin": "4008495712978",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce8e",
            "leftCorner": {
              "x": 1.082,
              "y": -3.987,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.086,
              "y": -3.909,
              "z": 1.425
            },
            "gtin": "4008495712978",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce8f",
            "leftCorner": {
              "x": 1.086,
              "y": -3.909,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.09,
              "y": -3.83,
              "z": 1.425
            },
            "gtin": "4008495712978",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce90",
            "leftCorner": {
              "x": 1.094,
              "y": -3.831,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.098,
              "y": -3.764,
              "z": 1.425
            },
            "gtin": "4008495712985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce91",
            "leftCorner": {
              "x": 1.098,
              "y": -3.764,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.101,
              "y": -3.697,
              "z": 1.425
            },
            "gtin": "4008495712985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce92",
            "leftCorner": {
              "x": 1.101,
              "y": -3.697,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.104,
              "y": -3.63,
              "z": 1.425
            },
            "gtin": "4008495712985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce93",
            "leftCorner": {
              "x": 1.104,
              "y": -3.63,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.108,
              "y": -3.563,
              "z": 1.425
            },
            "gtin": "4008495712985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce94",
            "leftCorner": {
              "x": 1.109,
              "y": -3.563,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.114,
              "y": -3.473,
              "z": 1.425
            },
            "gtin": "4063367442728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce95",
            "leftCorner": {
              "x": 1.114,
              "y": -3.473,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.118,
              "y": -3.383,
              "z": 1.425
            },
            "gtin": "4063367442728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce96",
            "leftCorner": {
              "x": 1.118,
              "y": -3.383,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.123,
              "y": -3.292,
              "z": 1.425
            },
            "gtin": "4063367442728",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "dde68",
    "rightNeighborShelfId": "99d73"
  },
  {
    "id": "99d73",
    "name": "99d73",
    "x": 1.163,
    "y": -3.426,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68906,
      "w": 0.72471
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 105
    },
    "layers": [
      {
        "id": "682ffddbd15af3232a546155",
        "height": 0.17399,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cec9",
            "leftCorner": {
              "x": 1.123,
              "y": -3.426,
              "z": 0.142
            },
            "rightCorner": {
              "x": 1.126,
              "y": -3.357,
              "z": 0.142
            },
            "gtin": "4063367445064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceca",
            "leftCorner": {
              "x": 1.129,
              "y": -3.357,
              "z": 0.142
            },
            "rightCorner": {
              "x": 1.134,
              "y": -3.27,
              "z": 0.142
            },
            "gtin": "4063367444999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cecb",
            "leftCorner": {
              "x": 1.111,
              "y": -3.269,
              "z": 0.142
            },
            "rightCorner": {
              "x": 1.114,
              "y": -3.206,
              "z": 0.142
            },
            "gtin": "4063367444975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cecc",
            "leftCorner": {
              "x": 1.119,
              "y": -3.206,
              "z": 0.142
            },
            "rightCorner": {
              "x": 1.121,
              "y": -3.16,
              "z": 0.142
            },
            "gtin": "4063367445026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cecd",
            "leftCorner": {
              "x": 1.121,
              "y": -3.16,
              "z": 0.142
            },
            "rightCorner": {
              "x": 1.123,
              "y": -3.114,
              "z": 0.142
            },
            "gtin": "4063367445026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cece",
            "leftCorner": {
              "x": 1.135,
              "y": -3.114,
              "z": 0.142
            },
            "rightCorner": {
              "x": 1.139,
              "y": -3.024,
              "z": 0.142
            },
            "gtin": "4063367444920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cecf",
            "leftCorner": {
              "x": 1.139,
              "y": -3.024,
              "z": 0.142
            },
            "rightCorner": {
              "x": 1.143,
              "y": -2.936,
              "z": 0.142
            },
            "gtin": "4063367444883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ced0",
            "leftCorner": {
              "x": 1.141,
              "y": -2.936,
              "z": 0.142
            },
            "rightCorner": {
              "x": 1.149,
              "y": -2.767,
              "z": 0.142
            },
            "gtin": "4063367444838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ced1",
            "leftCorner": {
              "x": 1.151,
              "y": -2.767,
              "z": 0.142
            },
            "rightCorner": {
              "x": 1.163,
              "y": -2.527,
              "z": 0.142
            },
            "gtin": "4063367444906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ced2",
            "leftCorner": {
              "x": 1.163,
              "y": -2.527,
              "z": 0.142
            },
            "rightCorner": {
              "x": 1.175,
              "y": -2.286,
              "z": 0.142
            },
            "gtin": "4063367444906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ced3",
            "leftCorner": {
              "x": 1.175,
              "y": -2.286,
              "z": 0.142
            },
            "rightCorner": {
              "x": 1.179,
              "y": -2.208,
              "z": 0.142
            },
            "gtin": "4063367113734",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546153",
        "height": 0.48579,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cda8",
            "leftCorner": {
              "x": 1.108,
              "y": -3.359,
              "z": 0.397
            },
            "rightCorner": {
              "x": 1.112,
              "y": -3.265,
              "z": 0.397
            },
            "gtin": "4009078128759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cda9",
            "leftCorner": {
              "x": 1.119,
              "y": -3.265,
              "z": 0.397
            },
            "rightCorner": {
              "x": 1.127,
              "y": -3.111,
              "z": 0.397
            },
            "gtin": "4009078275118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdaa",
            "leftCorner": {
              "x": 1.121,
              "y": -3.11,
              "z": 0.397
            },
            "rightCorner": {
              "x": 1.124,
              "y": -3.04,
              "z": 0.397
            },
            "gtin": "4009078736411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdab",
            "leftCorner": {
              "x": 1.134,
              "y": -3.04,
              "z": 0.397
            },
            "rightCorner": {
              "x": 1.138,
              "y": -2.963,
              "z": 0.397
            },
            "gtin": "4009078275132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdac",
            "leftCorner": {
              "x": 1.138,
              "y": -2.963,
              "z": 0.397
            },
            "rightCorner": {
              "x": 1.142,
              "y": -2.89,
              "z": 0.397
            },
            "gtin": "4009078128773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdad",
            "leftCorner": {
              "x": 1.145,
              "y": -2.89,
              "z": 0.397
            },
            "rightCorner": {
              "x": 1.148,
              "y": -2.836,
              "z": 0.397
            },
            "gtin": "4009078867726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdae",
            "leftCorner": {
              "x": 1.146,
              "y": -2.836,
              "z": 0.397
            },
            "rightCorner": {
              "x": 1.15,
              "y": -2.76,
              "z": 0.397
            },
            "gtin": "4009078172400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdaf",
            "leftCorner": {
              "x": 1.148,
              "y": -2.76,
              "z": 0.397
            },
            "rightCorner": {
              "x": 1.151,
              "y": -2.691,
              "z": 0.397
            },
            "gtin": "4009078172325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdb0",
            "leftCorner": {
              "x": 1.154,
              "y": -2.691,
              "z": 0.397
            },
            "rightCorner": {
              "x": 1.157,
              "y": -2.614,
              "z": 0.397
            },
            "gtin": "4009078976084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdb1",
            "leftCorner": {
              "x": 1.157,
              "y": -2.614,
              "z": 0.397
            },
            "rightCorner": {
              "x": 1.161,
              "y": -2.537,
              "z": 0.397
            },
            "gtin": "4009078976084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdb2",
            "leftCorner": {
              "x": 1.184,
              "y": -2.539,
              "z": 0.397
            },
            "rightCorner": {
              "x": 1.187,
              "y": -2.469,
              "z": 0.397
            },
            "gtin": "4009078922470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdb3",
            "leftCorner": {
              "x": 1.187,
              "y": -2.469,
              "z": 0.397
            },
            "rightCorner": {
              "x": 1.191,
              "y": -2.399,
              "z": 0.397
            },
            "gtin": "4009078922470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdb4",
            "leftCorner": {
              "x": 1.191,
              "y": -2.399,
              "z": 0.397
            },
            "rightCorner": {
              "x": 1.194,
              "y": -2.329,
              "z": 0.397
            },
            "gtin": "4009078922470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdb5",
            "leftCorner": {
              "x": 1.185,
              "y": -2.328,
              "z": 0.397
            },
            "rightCorner": {
              "x": 1.192,
              "y": -2.193,
              "z": 0.397
            },
            "gtin": "4009078976107",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546154",
        "height": 0.7874,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1ce2b",
            "leftCorner": {
              "x": 1.113,
              "y": -3.332,
              "z": 0.644
            },
            "rightCorner": {
              "x": 1.119,
              "y": -3.21,
              "z": 0.644
            },
            "gtin": "4337185266539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce2c",
            "leftCorner": {
              "x": 1.119,
              "y": -3.21,
              "z": 0.644
            },
            "rightCorner": {
              "x": 1.126,
              "y": -3.088,
              "z": 0.644
            },
            "gtin": "4337185266539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce2d",
            "leftCorner": {
              "x": 1.126,
              "y": -3.088,
              "z": 0.644
            },
            "rightCorner": {
              "x": 1.132,
              "y": -2.967,
              "z": 0.644
            },
            "gtin": "4337185266539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce2e",
            "leftCorner": {
              "x": 1.132,
              "y": -2.967,
              "z": 0.644
            },
            "rightCorner": {
              "x": 1.138,
              "y": -2.845,
              "z": 0.644
            },
            "gtin": "4337185266539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce2f",
            "leftCorner": {
              "x": 1.138,
              "y": -2.845,
              "z": 0.644
            },
            "rightCorner": {
              "x": 1.144,
              "y": -2.723,
              "z": 0.644
            },
            "gtin": "4337185266539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce30",
            "leftCorner": {
              "x": 1.144,
              "y": -2.723,
              "z": 0.644
            },
            "rightCorner": {
              "x": 1.15,
              "y": -2.601,
              "z": 0.644
            },
            "gtin": "4337185266539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce31",
            "leftCorner": {
              "x": 1.175,
              "y": -2.603,
              "z": 0.644
            },
            "rightCorner": {
              "x": 1.18,
              "y": -2.506,
              "z": 0.644
            },
            "gtin": "4009078663281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce32",
            "leftCorner": {
              "x": 1.183,
              "y": -2.506,
              "z": 0.644
            },
            "rightCorner": {
              "x": 1.19,
              "y": -2.377,
              "z": 0.644
            },
            "gtin": "4002653094692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce33",
            "leftCorner": {
              "x": 1.185,
              "y": -2.377,
              "z": 0.644
            },
            "rightCorner": {
              "x": 1.191,
              "y": -2.271,
              "z": 0.644
            },
            "gtin": "4002653094685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce34",
            "leftCorner": {
              "x": 1.183,
              "y": -2.271,
              "z": 0.644
            },
            "rightCorner": {
              "x": 1.187,
              "y": -2.188,
              "z": 0.644
            },
            "gtin": "4009078911719",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546150",
        "height": 0.98528,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1ce02",
            "leftCorner": {
              "x": 1.105,
              "y": -3.446,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.113,
              "y": -3.289,
              "z": 0.806
            },
            "gtin": "8717847150097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce03",
            "leftCorner": {
              "x": 1.117,
              "y": -3.289,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.122,
              "y": -3.191,
              "z": 0.806
            },
            "gtin": "8717847150073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce04",
            "leftCorner": {
              "x": 1.129,
              "y": -3.191,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.131,
              "y": -3.146,
              "z": 0.806
            },
            "gtin": "4008542506147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce05",
            "leftCorner": {
              "x": 1.125,
              "y": -3.146,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.128,
              "y": -3.075,
              "z": 0.806
            },
            "gtin": "4008542506000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce06",
            "leftCorner": {
              "x": 1.128,
              "y": -3.075,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.132,
              "y": -3.005,
              "z": 0.806
            },
            "gtin": "4008542506000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce07",
            "leftCorner": {
              "x": 1.135,
              "y": -3.006,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.139,
              "y": -2.922,
              "z": 0.806
            },
            "gtin": "4008542461279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce08",
            "leftCorner": {
              "x": 1.147,
              "y": -2.923,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.149,
              "y": -2.877,
              "z": 0.806
            },
            "gtin": "4062196917346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce09",
            "leftCorner": {
              "x": 1.148,
              "y": -2.877,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.151,
              "y": -2.813,
              "z": 0.806
            },
            "gtin": "4057824301222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce0a",
            "leftCorner": {
              "x": 1.153,
              "y": -2.813,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.157,
              "y": -2.724,
              "z": 0.806
            },
            "gtin": "4008542017735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce0b",
            "leftCorner": {
              "x": 1.157,
              "y": -2.724,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.162,
              "y": -2.634,
              "z": 0.806
            },
            "gtin": "4008542017735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce0c",
            "leftCorner": {
              "x": 1.165,
              "y": -2.634,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.17,
              "y": -2.54,
              "z": 0.806
            },
            "gtin": "4008542017643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce0d",
            "leftCorner": {
              "x": 1.167,
              "y": -2.54,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.169,
              "y": -2.49,
              "z": 0.806
            },
            "gtin": "4002653056966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce0e",
            "leftCorner": {
              "x": 1.169,
              "y": -2.49,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.172,
              "y": -2.44,
              "z": 0.806
            },
            "gtin": "4002653056966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce0f",
            "leftCorner": {
              "x": 1.188,
              "y": -2.441,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.189,
              "y": -2.407,
              "z": 0.806
            },
            "gtin": "4002653056980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce10",
            "leftCorner": {
              "x": 1.189,
              "y": -2.407,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.191,
              "y": -2.373,
              "z": 0.806
            },
            "gtin": "4002653056980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce11",
            "leftCorner": {
              "x": 1.18,
              "y": -2.372,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.184,
              "y": -2.286,
              "z": 0.806
            },
            "gtin": "4002653057901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce12",
            "leftCorner": {
              "x": 1.177,
              "y": -2.285,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.18,
              "y": -2.219,
              "z": 0.806
            },
            "gtin": "4002653057796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce13",
            "leftCorner": {
              "x": 1.193,
              "y": -2.219,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.195,
              "y": -2.179,
              "z": 0.806
            },
            "gtin": "4002653058052",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546152",
        "height": 1.2365,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1ce58",
            "leftCorner": {
              "x": 1.112,
              "y": -3.436,
              "z": 1.012
            },
            "rightCorner": {
              "x": 1.116,
              "y": -3.36,
              "z": 1.012
            },
            "gtin": "4008495711100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce59",
            "leftCorner": {
              "x": 1.119,
              "y": -3.36,
              "z": 1.012
            },
            "rightCorner": {
              "x": 1.124,
              "y": -3.264,
              "z": 1.012
            },
            "gtin": "4063367442247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce5a",
            "leftCorner": {
              "x": 1.109,
              "y": -3.263,
              "z": 1.012
            },
            "rightCorner": {
              "x": 1.111,
              "y": -3.227,
              "z": 1.012
            },
            "gtin": "4063367442223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce5b",
            "leftCorner": {
              "x": 1.111,
              "y": -3.227,
              "z": 1.012
            },
            "rightCorner": {
              "x": 1.113,
              "y": -3.191,
              "z": 1.012
            },
            "gtin": "4063367442223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce5c",
            "leftCorner": {
              "x": 1.13,
              "y": -3.192,
              "z": 1.012
            },
            "rightCorner": {
              "x": 1.133,
              "y": -3.123,
              "z": 1.012
            },
            "gtin": "4063367442261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce5d",
            "leftCorner": {
              "x": 1.131,
              "y": -3.123,
              "z": 1.012
            },
            "rightCorner": {
              "x": 1.134,
              "y": -3.057,
              "z": 1.012
            },
            "gtin": "4063367442209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce5e",
            "leftCorner": {
              "x": 1.129,
              "y": -3.057,
              "z": 1.012
            },
            "rightCorner": {
              "x": 1.132,
              "y": -3.003,
              "z": 1.012
            },
            "gtin": "4337185741821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce5f",
            "leftCorner": {
              "x": 1.132,
              "y": -3.003,
              "z": 1.012
            },
            "rightCorner": {
              "x": 1.135,
              "y": -2.949,
              "z": 1.012
            },
            "gtin": "4337185741821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce60",
            "leftCorner": {
              "x": 1.142,
              "y": -2.95,
              "z": 1.012
            },
            "rightCorner": {
              "x": 1.149,
              "y": -2.808,
              "z": 1.012
            },
            "gtin": "4063367442094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce61",
            "leftCorner": {
              "x": 1.157,
              "y": -2.808,
              "z": 1.012
            },
            "rightCorner": {
              "x": 1.161,
              "y": -2.725,
              "z": 1.012
            },
            "gtin": "4063367442124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce62",
            "leftCorner": {
              "x": 1.168,
              "y": -2.725,
              "z": 1.012
            },
            "rightCorner": {
              "x": 1.17,
              "y": -2.679,
              "z": 1.012
            },
            "gtin": "8717847142894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce63",
            "leftCorner": {
              "x": 1.17,
              "y": -2.679,
              "z": 1.012
            },
            "rightCorner": {
              "x": 1.173,
              "y": -2.632,
              "z": 1.012
            },
            "gtin": "8717847142894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce64",
            "leftCorner": {
              "x": 1.166,
              "y": -2.632,
              "z": 1.012
            },
            "rightCorner": {
              "x": 1.168,
              "y": -2.592,
              "z": 1.012
            },
            "gtin": "4063367442070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce65",
            "leftCorner": {
              "x": 1.168,
              "y": -2.592,
              "z": 1.012
            },
            "rightCorner": {
              "x": 1.17,
              "y": -2.551,
              "z": 1.012
            },
            "gtin": "4063367442070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce66",
            "leftCorner": {
              "x": 1.185,
              "y": -2.552,
              "z": 1.012
            },
            "rightCorner": {
              "x": 1.195,
              "y": -2.349,
              "z": 1.012
            },
            "gtin": "4002653058144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce67",
            "leftCorner": {
              "x": 1.194,
              "y": -2.349,
              "z": 1.012
            },
            "rightCorner": {
              "x": 1.198,
              "y": -2.274,
              "z": 1.012
            },
            "gtin": "4002653058410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce68",
            "leftCorner": {
              "x": 1.176,
              "y": -2.273,
              "z": 1.012
            },
            "rightCorner": {
              "x": 1.179,
              "y": -2.208,
              "z": 1.012
            },
            "gtin": "8717847115973",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546151",
        "height": 1.4379,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cdcd",
            "leftCorner": {
              "x": 1.127,
              "y": -3.406,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.129,
              "y": -3.367,
              "z": 1.176
            },
            "gtin": "4063367442421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdce",
            "leftCorner": {
              "x": 1.129,
              "y": -3.367,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.13,
              "y": -3.328,
              "z": 1.176
            },
            "gtin": "4063367442421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdcf",
            "leftCorner": {
              "x": 1.129,
              "y": -3.328,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.134,
              "y": -3.227,
              "z": 1.176
            },
            "gtin": "4063367442445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdd0",
            "leftCorner": {
              "x": 1.134,
              "y": -3.227,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.139,
              "y": -3.126,
              "z": 1.176
            },
            "gtin": "4063367442445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdd1",
            "leftCorner": {
              "x": 1.135,
              "y": -3.126,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.138,
              "y": -3.067,
              "z": 1.176
            },
            "gtin": "4063367442469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdd2",
            "leftCorner": {
              "x": 1.147,
              "y": -3.067,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.151,
              "y": -2.982,
              "z": 1.176
            },
            "gtin": "4063367442544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdd3",
            "leftCorner": {
              "x": 1.148,
              "y": -2.982,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.152,
              "y": -2.889,
              "z": 1.176
            },
            "gtin": "4063367442520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdd4",
            "leftCorner": {
              "x": 1.152,
              "y": -2.889,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.157,
              "y": -2.797,
              "z": 1.176
            },
            "gtin": "4063367442520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdd5",
            "leftCorner": {
              "x": 1.16,
              "y": -2.797,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.165,
              "y": -2.693,
              "z": 1.176
            },
            "gtin": "4063367442483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdd6",
            "leftCorner": {
              "x": 1.163,
              "y": -2.693,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.166,
              "y": -2.628,
              "z": 1.176
            },
            "gtin": "4063367442322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdd7",
            "leftCorner": {
              "x": 1.169,
              "y": -2.628,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.172,
              "y": -2.569,
              "z": 1.176
            },
            "gtin": "4063367442308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdd8",
            "leftCorner": {
              "x": 1.176,
              "y": -2.57,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.178,
              "y": -2.531,
              "z": 1.176
            },
            "gtin": "4063367442285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdd9",
            "leftCorner": {
              "x": 1.178,
              "y": -2.531,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.18,
              "y": -2.493,
              "z": 1.176
            },
            "gtin": "4063367442285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdda",
            "leftCorner": {
              "x": 1.194,
              "y": -2.494,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.196,
              "y": -2.455,
              "z": 1.176
            },
            "gtin": "4063367442384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cddb",
            "leftCorner": {
              "x": 1.196,
              "y": -2.455,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.198,
              "y": -2.416,
              "z": 1.176
            },
            "gtin": "4063367442384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cddc",
            "leftCorner": {
              "x": 1.185,
              "y": -2.416,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.188,
              "y": -2.366,
              "z": 1.176
            },
            "gtin": "4063367442346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cddd",
            "leftCorner": {
              "x": 1.204,
              "y": -2.367,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.207,
              "y": -2.299,
              "z": 1.176
            },
            "gtin": "4008542028090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdde",
            "leftCorner": {
              "x": 1.207,
              "y": -2.299,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.211,
              "y": -2.23,
              "z": 1.176
            },
            "gtin": "4008542028090",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546156",
        "height": 1.7339,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1ce97",
            "leftCorner": {
              "x": 1.122,
              "y": -3.292,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.126,
              "y": -3.221,
              "z": 1.419
            },
            "gtin": "4063367442704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce98",
            "leftCorner": {
              "x": 1.126,
              "y": -3.221,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.129,
              "y": -3.15,
              "z": 1.419
            },
            "gtin": "4063367442704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce99",
            "leftCorner": {
              "x": 1.129,
              "y": -3.15,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.133,
              "y": -3.079,
              "z": 1.419
            },
            "gtin": "4063367442704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce9a",
            "leftCorner": {
              "x": 1.133,
              "y": -3.079,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.136,
              "y": -3.009,
              "z": 1.419
            },
            "gtin": "4063367442704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce9b",
            "leftCorner": {
              "x": 1.132,
              "y": -3.008,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.135,
              "y": -2.961,
              "z": 1.419
            },
            "gtin": "4063367442568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce9c",
            "leftCorner": {
              "x": 1.135,
              "y": -2.961,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.137,
              "y": -2.913,
              "z": 1.419
            },
            "gtin": "4063367442568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce9d",
            "leftCorner": {
              "x": 1.153,
              "y": -2.914,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.155,
              "y": -2.856,
              "z": 1.419
            },
            "gtin": "4063367442667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce9e",
            "leftCorner": {
              "x": 1.155,
              "y": -2.856,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.158,
              "y": -2.798,
              "z": 1.419
            },
            "gtin": "4063367442667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce9f",
            "leftCorner": {
              "x": 1.145,
              "y": -2.797,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.148,
              "y": -2.733,
              "z": 1.419
            },
            "gtin": "4063367442681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cea0",
            "leftCorner": {
              "x": 1.162,
              "y": -2.733,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.165,
              "y": -2.672,
              "z": 1.419
            },
            "gtin": "4063367442643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cea1",
            "leftCorner": {
              "x": 1.165,
              "y": -2.672,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.168,
              "y": -2.611,
              "z": 1.419
            },
            "gtin": "4063367442605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cea2",
            "leftCorner": {
              "x": 1.168,
              "y": -2.611,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.171,
              "y": -2.55,
              "z": 1.419
            },
            "gtin": "4063367442605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cea3",
            "leftCorner": {
              "x": 1.171,
              "y": -2.55,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.174,
              "y": -2.489,
              "z": 1.419
            },
            "gtin": "4063367442605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cea4",
            "leftCorner": {
              "x": 1.174,
              "y": -2.489,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.177,
              "y": -2.428,
              "z": 1.419
            },
            "gtin": "4063367442605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cea5",
            "leftCorner": {
              "x": 1.197,
              "y": -2.429,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.2,
              "y": -2.361,
              "z": 1.419
            },
            "gtin": "4002653056997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cea6",
            "leftCorner": {
              "x": 1.175,
              "y": -2.36,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.182,
              "y": -2.234,
              "z": 1.419
            },
            "gtin": "4002653057215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cea7",
            "leftCorner": {
              "x": 1.21,
              "y": -2.236,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.212,
              "y": -2.201,
              "z": 1.419
            },
            "gtin": "4002653056928",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "99d6e",
    "rightNeighborShelfId": "99d74"
  },
  {
    "id": "99d74",
    "name": "99d74",
    "x": 1.226,
    "y": -2.178,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68906,
      "w": 0.72471
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 96
    },
    "layers": [
      {
        "id": "682ffddbd15af3232a54615d",
        "height": 0.17207,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1ced4",
            "leftCorner": {
              "x": 1.193,
              "y": -2.21,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.195,
              "y": -2.153,
              "z": 0.141
            },
            "gtin": "4063367113635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ced5",
            "leftCorner": {
              "x": 1.195,
              "y": -2.153,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.198,
              "y": -2.096,
              "z": 0.141
            },
            "gtin": "4063367113635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ced6",
            "leftCorner": {
              "x": 1.198,
              "y": -2.096,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.201,
              "y": -2.039,
              "z": 0.141
            },
            "gtin": "4063367113635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ced7",
            "leftCorner": {
              "x": 1.201,
              "y": -2.039,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.204,
              "y": -1.982,
              "z": 0.141
            },
            "gtin": "4063367113635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ced8",
            "leftCorner": {
              "x": 1.189,
              "y": -1.982,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.201,
              "y": -1.736,
              "z": 0.141
            },
            "gtin": "4009864067033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cebd",
            "leftCorner": {
              "x": 1.213,
              "y": -1.737,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.227,
              "y": -1.467,
              "z": 0.141
            },
            "gtin": "4337185667015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cebe",
            "leftCorner": {
              "x": 1.227,
              "y": -1.467,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.241,
              "y": -1.198,
              "z": 0.141
            },
            "gtin": "4337185667015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cebf",
            "leftCorner": {
              "x": 1.241,
              "y": -1.198,
              "z": 0.141
            },
            "rightCorner": {
              "x": 1.254,
              "y": -0.928,
              "z": 0.141
            },
            "gtin": "4337185667015",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a54615a",
        "height": 0.48262,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cdb6",
            "leftCorner": {
              "x": 1.167,
              "y": -2.192,
              "z": 0.395
            },
            "rightCorner": {
              "x": 1.172,
              "y": -2.097,
              "z": 0.395
            },
            "gtin": "5411708164843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdb7",
            "leftCorner": {
              "x": 1.189,
              "y": -2.098,
              "z": 0.395
            },
            "rightCorner": {
              "x": 1.202,
              "y": -1.841,
              "z": 0.395
            },
            "gtin": "4067776054466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdb8",
            "leftCorner": {
              "x": 1.202,
              "y": -1.841,
              "z": 0.395
            },
            "rightCorner": {
              "x": 1.215,
              "y": -1.584,
              "z": 0.395
            },
            "gtin": "4067776054466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdb9",
            "leftCorner": {
              "x": 1.215,
              "y": -1.584,
              "z": 0.395
            },
            "rightCorner": {
              "x": 1.228,
              "y": -1.328,
              "z": 0.395
            },
            "gtin": "4067776054466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdba",
            "leftCorner": {
              "x": 1.239,
              "y": -1.328,
              "z": 0.395
            },
            "rightCorner": {
              "x": 1.252,
              "y": -1.068,
              "z": 0.395
            },
            "gtin": "4067776054589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdbb",
            "leftCorner": {
              "x": 1.252,
              "y": -1.068,
              "z": 0.395
            },
            "rightCorner": {
              "x": 1.265,
              "y": -0.808,
              "z": 0.395
            },
            "gtin": "4067776054589",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546157",
        "height": 0.78448,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1ce35",
            "leftCorner": {
              "x": 1.185,
              "y": -2.189,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.189,
              "y": -2.121,
              "z": 0.642
            },
            "gtin": "4009078574648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce36",
            "leftCorner": {
              "x": 1.194,
              "y": -2.121,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.199,
              "y": -2.04,
              "z": 0.642
            },
            "gtin": "8717847148919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce37",
            "leftCorner": {
              "x": 1.197,
              "y": -2.04,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.2,
              "y": -1.982,
              "z": 0.642
            },
            "gtin": "8717847148018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce38",
            "leftCorner": {
              "x": 1.203,
              "y": -1.982,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.206,
              "y": -1.931,
              "z": 0.642
            },
            "gtin": "8717847148025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce39",
            "leftCorner": {
              "x": 1.206,
              "y": -1.931,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.209,
              "y": -1.879,
              "z": 0.642
            },
            "gtin": "8717847148025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce3a",
            "leftCorner": {
              "x": 1.201,
              "y": -1.879,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.203,
              "y": -1.834,
              "z": 0.642
            },
            "gtin": "8717847142894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce3b",
            "leftCorner": {
              "x": 1.203,
              "y": -1.834,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.205,
              "y": -1.79,
              "z": 0.642
            },
            "gtin": "8717847142894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce3c",
            "leftCorner": {
              "x": 1.205,
              "y": -1.79,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.208,
              "y": -1.745,
              "z": 0.642
            },
            "gtin": "8717847142894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce3d",
            "leftCorner": {
              "x": 1.217,
              "y": -1.745,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.218,
              "y": -1.71,
              "z": 0.642
            },
            "gtin": "8717847154545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce3e",
            "leftCorner": {
              "x": 1.218,
              "y": -1.71,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.22,
              "y": -1.675,
              "z": 0.642
            },
            "gtin": "8717847154545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce3f",
            "leftCorner": {
              "x": 1.222,
              "y": -1.675,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.223,
              "y": -1.637,
              "z": 0.642
            },
            "gtin": "8717847147998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce40",
            "leftCorner": {
              "x": 1.223,
              "y": -1.637,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.225,
              "y": -1.599,
              "z": 0.642
            },
            "gtin": "8717847147998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce41",
            "leftCorner": {
              "x": 1.242,
              "y": -1.6,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.245,
              "y": -1.536,
              "z": 0.642
            },
            "gtin": "8717847142856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce42",
            "leftCorner": {
              "x": 1.235,
              "y": -1.536,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.239,
              "y": -1.471,
              "z": 0.642
            },
            "gtin": "4009078631877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce43",
            "leftCorner": {
              "x": 1.249,
              "y": -1.472,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.251,
              "y": -1.426,
              "z": 0.642
            },
            "gtin": "4009078631891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce44",
            "leftCorner": {
              "x": 1.251,
              "y": -1.426,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.253,
              "y": -1.381,
              "z": 0.642
            },
            "gtin": "4009078631891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce45",
            "leftCorner": {
              "x": 1.252,
              "y": -1.381,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.256,
              "y": -1.299,
              "z": 0.642
            },
            "gtin": "4009078631884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce46",
            "leftCorner": {
              "x": 1.252,
              "y": -1.299,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.256,
              "y": -1.215,
              "z": 0.642
            },
            "gtin": "4009078501880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce47",
            "leftCorner": {
              "x": 1.236,
              "y": -1.214,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.241,
              "y": -1.129,
              "z": 0.642
            },
            "gtin": "4009078946575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce48",
            "leftCorner": {
              "x": 1.257,
              "y": -1.13,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.26,
              "y": -1.067,
              "z": 0.642
            },
            "gtin": "4009078735087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce49",
            "leftCorner": {
              "x": 1.265,
              "y": -1.067,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.269,
              "y": -0.991,
              "z": 0.642
            },
            "gtin": "4009078501798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce2a",
            "leftCorner": {
              "x": 1.254,
              "y": -0.99,
              "z": 0.642
            },
            "rightCorner": {
              "x": 1.257,
              "y": -0.928,
              "z": 0.642
            },
            "gtin": "4009078118989",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a54615c",
        "height": 0.98376,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1ce14",
            "leftCorner": {
              "x": 1.191,
              "y": -2.179,
              "z": 0.805
            },
            "rightCorner": {
              "x": 1.195,
              "y": -2.097,
              "z": 0.805
            },
            "gtin": "4002653057789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce15",
            "leftCorner": {
              "x": 1.19,
              "y": -2.097,
              "z": 0.805
            },
            "rightCorner": {
              "x": 1.194,
              "y": -2.023,
              "z": 0.805
            },
            "gtin": "8717847142962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce16",
            "leftCorner": {
              "x": 1.198,
              "y": -2.023,
              "z": 0.805
            },
            "rightCorner": {
              "x": 1.202,
              "y": -1.945,
              "z": 0.805
            },
            "gtin": "8717847148094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce17",
            "leftCorner": {
              "x": 1.194,
              "y": -1.945,
              "z": 0.805
            },
            "rightCorner": {
              "x": 1.198,
              "y": -1.858,
              "z": 0.805
            },
            "gtin": "8717847156198",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce18",
            "leftCorner": {
              "x": 1.209,
              "y": -1.859,
              "z": 0.805
            },
            "rightCorner": {
              "x": 1.211,
              "y": -1.807,
              "z": 0.805
            },
            "gtin": "8717847148070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce19",
            "leftCorner": {
              "x": 1.211,
              "y": -1.807,
              "z": 0.805
            },
            "rightCorner": {
              "x": 1.214,
              "y": -1.754,
              "z": 0.805
            },
            "gtin": "8717847148070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce1a",
            "leftCorner": {
              "x": 1.226,
              "y": -1.755,
              "z": 0.805
            },
            "rightCorner": {
              "x": 1.23,
              "y": -1.677,
              "z": 0.805
            },
            "gtin": "8717847154668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce1b",
            "leftCorner": {
              "x": 1.217,
              "y": -1.676,
              "z": 0.805
            },
            "rightCorner": {
              "x": 1.221,
              "y": -1.594,
              "z": 0.805
            },
            "gtin": "8717847149329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce1c",
            "leftCorner": {
              "x": 1.22,
              "y": -1.594,
              "z": 0.805
            },
            "rightCorner": {
              "x": 1.224,
              "y": -1.526,
              "z": 0.805
            },
            "gtin": "8717847142924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce1d",
            "leftCorner": {
              "x": 1.244,
              "y": -1.526,
              "z": 0.805
            },
            "rightCorner": {
              "x": 1.248,
              "y": -1.44,
              "z": 0.805
            },
            "gtin": "4009078860840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce1e",
            "leftCorner": {
              "x": 1.238,
              "y": -1.439,
              "z": 0.805
            },
            "rightCorner": {
              "x": 1.242,
              "y": -1.347,
              "z": 0.805
            },
            "gtin": "4009078860857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce1f",
            "leftCorner": {
              "x": 1.229,
              "y": -1.347,
              "z": 0.805
            },
            "rightCorner": {
              "x": 1.232,
              "y": -1.285,
              "z": 0.805
            },
            "gtin": "4009078860864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce20",
            "leftCorner": {
              "x": 1.232,
              "y": -1.285,
              "z": 0.805
            },
            "rightCorner": {
              "x": 1.235,
              "y": -1.223,
              "z": 0.805
            },
            "gtin": "4009078860864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce21",
            "leftCorner": {
              "x": 1.245,
              "y": -1.224,
              "z": 0.805
            },
            "rightCorner": {
              "x": 1.25,
              "y": -1.126,
              "z": 0.805
            },
            "gtin": "4009078221399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce22",
            "leftCorner": {
              "x": 1.251,
              "y": -1.127,
              "z": 0.805
            },
            "rightCorner": {
              "x": 1.254,
              "y": -1.068,
              "z": 0.805
            },
            "gtin": "4009078946520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce23",
            "leftCorner": {
              "x": 1.254,
              "y": -1.068,
              "z": 0.805
            },
            "rightCorner": {
              "x": 1.265,
              "y": -0.853,
              "z": 0.805
            },
            "gtin": "4009078501545",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a54615b",
        "height": 1.2348,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1ce69",
            "leftCorner": {
              "x": 1.195,
              "y": -2.209,
              "z": 1.01
            },
            "rightCorner": {
              "x": 1.199,
              "y": -2.127,
              "z": 1.01
            },
            "gtin": "4008495017707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce6a",
            "leftCorner": {
              "x": 1.198,
              "y": -2.127,
              "z": 1.01
            },
            "rightCorner": {
              "x": 1.204,
              "y": -2.01,
              "z": 1.01
            },
            "gtin": "4008495017660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce6b",
            "leftCorner": {
              "x": 1.201,
              "y": -2.01,
              "z": 1.01
            },
            "rightCorner": {
              "x": 1.206,
              "y": -1.928,
              "z": 1.01
            },
            "gtin": "4008495017684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce6c",
            "leftCorner": {
              "x": 1.215,
              "y": -1.929,
              "z": 1.01
            },
            "rightCorner": {
              "x": 1.222,
              "y": -1.802,
              "z": 1.01
            },
            "gtin": "4009078976497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce6d",
            "leftCorner": {
              "x": 1.225,
              "y": -1.802,
              "z": 1.01
            },
            "rightCorner": {
              "x": 1.229,
              "y": -1.733,
              "z": 1.01
            },
            "gtin": "4009078922999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce6e",
            "leftCorner": {
              "x": 1.229,
              "y": -1.733,
              "z": 1.01
            },
            "rightCorner": {
              "x": 1.232,
              "y": -1.664,
              "z": 1.01
            },
            "gtin": "4009078922999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce6f",
            "leftCorner": {
              "x": 1.232,
              "y": -1.664,
              "z": 1.01
            },
            "rightCorner": {
              "x": 1.236,
              "y": -1.595,
              "z": 1.01
            },
            "gtin": "4009078922999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce70",
            "leftCorner": {
              "x": 1.234,
              "y": -1.595,
              "z": 1.01
            },
            "rightCorner": {
              "x": 1.24,
              "y": -1.482,
              "z": 1.01
            },
            "gtin": "4009078976558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce71",
            "leftCorner": {
              "x": 1.245,
              "y": -1.483,
              "z": 1.01
            },
            "rightCorner": {
              "x": 1.249,
              "y": -1.389,
              "z": 1.01
            },
            "gtin": "4009078976534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce72",
            "leftCorner": {
              "x": 1.241,
              "y": -1.389,
              "z": 1.01
            },
            "rightCorner": {
              "x": 1.251,
              "y": -1.199,
              "z": 1.01
            },
            "gtin": "4009078976640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce73",
            "leftCorner": {
              "x": 1.245,
              "y": -1.198,
              "z": 1.01
            },
            "rightCorner": {
              "x": 1.25,
              "y": -1.116,
              "z": 1.01
            },
            "gtin": "4009078976183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce74",
            "leftCorner": {
              "x": 1.25,
              "y": -1.116,
              "z": 1.01
            },
            "rightCorner": {
              "x": 1.253,
              "y": -1.056,
              "z": 1.01
            },
            "gtin": "4009078976206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce75",
            "leftCorner": {
              "x": 1.253,
              "y": -1.056,
              "z": 1.01
            },
            "rightCorner": {
              "x": 1.256,
              "y": -0.997,
              "z": 1.01
            },
            "gtin": "4009078976206",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546159",
        "height": 1.4355,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cddf",
            "leftCorner": {
              "x": 1.194,
              "y": -2.21,
              "z": 1.175
            },
            "rightCorner": {
              "x": 1.197,
              "y": -2.153,
              "z": 1.175
            },
            "gtin": "4008542006104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cde0",
            "leftCorner": {
              "x": 1.207,
              "y": -2.153,
              "z": 1.175
            },
            "rightCorner": {
              "x": 1.21,
              "y": -2.087,
              "z": 1.175
            },
            "gtin": "4008542024450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cde1",
            "leftCorner": {
              "x": 1.21,
              "y": -2.087,
              "z": 1.175
            },
            "rightCorner": {
              "x": 1.214,
              "y": -2.021,
              "z": 1.175
            },
            "gtin": "4008542024450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cde2",
            "leftCorner": {
              "x": 1.199,
              "y": -2.02,
              "z": 1.175
            },
            "rightCorner": {
              "x": 1.202,
              "y": -1.971,
              "z": 1.175
            },
            "gtin": "4008542022272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cde3",
            "leftCorner": {
              "x": 1.205,
              "y": -1.971,
              "z": 1.175
            },
            "rightCorner": {
              "x": 1.209,
              "y": -1.903,
              "z": 1.175
            },
            "gtin": "4008542017766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cde4",
            "leftCorner": {
              "x": 1.213,
              "y": -1.903,
              "z": 1.175
            },
            "rightCorner": {
              "x": 1.218,
              "y": -1.81,
              "z": 1.175
            },
            "gtin": "4008542017827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cde5",
            "leftCorner": {
              "x": 1.215,
              "y": -1.81,
              "z": 1.175
            },
            "rightCorner": {
              "x": 1.218,
              "y": -1.755,
              "z": 1.175
            },
            "gtin": "4002653057840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cde6",
            "leftCorner": {
              "x": 1.244,
              "y": -1.756,
              "z": 1.175
            },
            "rightCorner": {
              "x": 1.246,
              "y": -1.712,
              "z": 1.175
            },
            "gtin": "4002653057826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cde7",
            "leftCorner": {
              "x": 1.246,
              "y": -1.712,
              "z": 1.175
            },
            "rightCorner": {
              "x": 1.248,
              "y": -1.668,
              "z": 1.175
            },
            "gtin": "4002653057826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cde8",
            "leftCorner": {
              "x": 1.22,
              "y": -1.666,
              "z": 1.175
            },
            "rightCorner": {
              "x": 1.222,
              "y": -1.622,
              "z": 1.175
            },
            "gtin": "4002653057819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cde9",
            "leftCorner": {
              "x": 1.237,
              "y": -1.623,
              "z": 1.175
            },
            "rightCorner": {
              "x": 1.24,
              "y": -1.552,
              "z": 1.175
            },
            "gtin": "4002653058427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdea",
            "leftCorner": {
              "x": 1.228,
              "y": -1.551,
              "z": 1.175
            },
            "rightCorner": {
              "x": 1.231,
              "y": -1.483,
              "z": 1.175
            },
            "gtin": "8717847148155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdeb",
            "leftCorner": {
              "x": 1.244,
              "y": -1.484,
              "z": 1.175
            },
            "rightCorner": {
              "x": 1.248,
              "y": -1.398,
              "z": 1.175
            },
            "gtin": "8717847146748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdec",
            "leftCorner": {
              "x": 1.24,
              "y": -1.398,
              "z": 1.175
            },
            "rightCorner": {
              "x": 1.243,
              "y": -1.339,
              "z": 1.175
            },
            "gtin": "8717847143006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cded",
            "leftCorner": {
              "x": 1.267,
              "y": -1.34,
              "z": 1.175
            },
            "rightCorner": {
              "x": 1.272,
              "y": -1.235,
              "z": 1.175
            },
            "gtin": "4008495016564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdee",
            "leftCorner": {
              "x": 1.253,
              "y": -1.234,
              "z": 1.175
            },
            "rightCorner": {
              "x": 1.26,
              "y": -1.109,
              "z": 1.175
            },
            "gtin": "4009078895743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdef",
            "leftCorner": {
              "x": 1.247,
              "y": -1.108,
              "z": 1.175
            },
            "rightCorner": {
              "x": 1.251,
              "y": -1.018,
              "z": 1.175
            },
            "gtin": "4009078895910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdf0",
            "leftCorner": {
              "x": 1.25,
              "y": -1.018,
              "z": 1.175
            },
            "rightCorner": {
              "x": 1.251,
              "y": -0.98,
              "z": 1.175
            },
            "gtin": "4009078895873",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546158",
        "height": 1.7295,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cea8",
            "leftCorner": {
              "x": 1.172,
              "y": -2.199,
              "z": 1.415
            },
            "rightCorner": {
              "x": 1.176,
              "y": -2.114,
              "z": 1.415
            },
            "gtin": "4009078955089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cea9",
            "leftCorner": {
              "x": 1.176,
              "y": -2.114,
              "z": 1.415
            },
            "rightCorner": {
              "x": 1.18,
              "y": -2.03,
              "z": 1.415
            },
            "gtin": "4009078955089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceaa",
            "leftCorner": {
              "x": 1.2,
              "y": -2.03,
              "z": 1.415
            },
            "rightCorner": {
              "x": 1.205,
              "y": -1.926,
              "z": 1.415
            },
            "gtin": "4009078921800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceab",
            "leftCorner": {
              "x": 1.205,
              "y": -1.926,
              "z": 1.415
            },
            "rightCorner": {
              "x": 1.21,
              "y": -1.821,
              "z": 1.415
            },
            "gtin": "4009078921800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceac",
            "leftCorner": {
              "x": 1.216,
              "y": -1.821,
              "z": 1.415
            },
            "rightCorner": {
              "x": 1.22,
              "y": -1.737,
              "z": 1.415
            },
            "gtin": "4009078036658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cead",
            "leftCorner": {
              "x": 1.22,
              "y": -1.737,
              "z": 1.415
            },
            "rightCorner": {
              "x": 1.224,
              "y": -1.654,
              "z": 1.415
            },
            "gtin": "4009078036658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceae",
            "leftCorner": {
              "x": 1.224,
              "y": -1.654,
              "z": 1.415
            },
            "rightCorner": {
              "x": 1.228,
              "y": -1.57,
              "z": 1.415
            },
            "gtin": "4009078036658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceaf",
            "leftCorner": {
              "x": 1.231,
              "y": -1.57,
              "z": 1.415
            },
            "rightCorner": {
              "x": 1.24,
              "y": -1.392,
              "z": 1.415
            },
            "gtin": "4009078135061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceb0",
            "leftCorner": {
              "x": 1.245,
              "y": -1.392,
              "z": 1.415
            },
            "rightCorner": {
              "x": 1.249,
              "y": -1.31,
              "z": 1.415
            },
            "gtin": "4009078946438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceb1",
            "leftCorner": {
              "x": 1.242,
              "y": -1.31,
              "z": 1.415
            },
            "rightCorner": {
              "x": 1.246,
              "y": -1.236,
              "z": 1.415
            },
            "gtin": "4009078170727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceb2",
            "leftCorner": {
              "x": 1.247,
              "y": -1.236,
              "z": 1.415
            },
            "rightCorner": {
              "x": 1.251,
              "y": -1.151,
              "z": 1.415
            },
            "gtin": "4009078070720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceb3",
            "leftCorner": {
              "x": 1.254,
              "y": -1.152,
              "z": 1.415
            },
            "rightCorner": {
              "x": 1.258,
              "y": -1.072,
              "z": 1.415
            },
            "gtin": "4009078036634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceb4",
            "leftCorner": {
              "x": 1.256,
              "y": -1.072,
              "z": 1.415
            },
            "rightCorner": {
              "x": 1.261,
              "y": -0.974,
              "z": 1.415
            },
            "gtin": "4009078736398",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "99d73"
  },
  {
    "id": "99d75",
    "name": "99d75",
    "x": 1.289,
    "y": -0.929,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68906,
      "w": 0.72471
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 56
    },
    "layers": [
      {
        "id": "682ffddbd15af3232a546163",
        "height": 0.48528,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cdbc",
            "leftCorner": {
              "x": 1.237,
              "y": -0.807,
              "z": 0.397
            },
            "rightCorner": {
              "x": 1.243,
              "y": -0.697,
              "z": 0.397
            },
            "gtin": "8717847137463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdbd",
            "leftCorner": {
              "x": 1.266,
              "y": -0.698,
              "z": 0.397
            },
            "rightCorner": {
              "x": 1.273,
              "y": -0.556,
              "z": 0.397
            },
            "gtin": "8717847137500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdbe",
            "leftCorner": {
              "x": 1.261,
              "y": -0.555,
              "z": 0.397
            },
            "rightCorner": {
              "x": 1.267,
              "y": -0.438,
              "z": 0.397
            },
            "gtin": "4008495312956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdbf",
            "leftCorner": {
              "x": 1.27,
              "y": -0.438,
              "z": 0.397
            },
            "rightCorner": {
              "x": 1.273,
              "y": -0.385,
              "z": 0.397
            },
            "gtin": "4008495313892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdc0",
            "leftCorner": {
              "x": 1.273,
              "y": -0.385,
              "z": 0.397
            },
            "rightCorner": {
              "x": 1.276,
              "y": -0.332,
              "z": 0.397
            },
            "gtin": "4008495313892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd9a",
            "leftCorner": {
              "x": 1.285,
              "y": -0.333,
              "z": 0.397
            },
            "rightCorner": {
              "x": 1.318,
              "y": 0.321,
              "z": 0.397
            },
            "gtin": "4008495313809",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546161",
        "height": 0.73633,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cedb",
            "leftCorner": {
              "x": 1.277,
              "y": -0.928,
              "z": 0.602
            },
            "rightCorner": {
              "x": 1.279,
              "y": -0.887,
              "z": 0.602
            },
            "gtin": "4008495313816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cedc",
            "leftCorner": {
              "x": 1.279,
              "y": -0.887,
              "z": 0.602
            },
            "rightCorner": {
              "x": 1.281,
              "y": -0.846,
              "z": 0.602
            },
            "gtin": "4008495313816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cede",
            "leftCorner": {
              "x": 1.253,
              "y": -0.845,
              "z": 0.602
            },
            "rightCorner": {
              "x": 1.255,
              "y": -0.796,
              "z": 0.602
            },
            "gtin": "4008495017523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cedf",
            "leftCorner": {
              "x": 1.255,
              "y": -0.796,
              "z": 0.602
            },
            "rightCorner": {
              "x": 1.258,
              "y": -0.747,
              "z": 0.602
            },
            "gtin": "4008495017523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cee0",
            "leftCorner": {
              "x": 1.263,
              "y": -0.747,
              "z": 0.602
            },
            "rightCorner": {
              "x": 1.268,
              "y": -0.656,
              "z": 0.602
            },
            "gtin": "4008495017585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cee1",
            "leftCorner": {
              "x": 1.26,
              "y": -0.655,
              "z": 0.602
            },
            "rightCorner": {
              "x": 1.263,
              "y": -0.59,
              "z": 0.602
            },
            "gtin": "4008495017561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cee2",
            "leftCorner": {
              "x": 1.263,
              "y": -0.59,
              "z": 0.602
            },
            "rightCorner": {
              "x": 1.267,
              "y": -0.524,
              "z": 0.602
            },
            "gtin": "4008495017561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cee3",
            "leftCorner": {
              "x": 1.255,
              "y": -0.523,
              "z": 0.602
            },
            "rightCorner": {
              "x": 1.257,
              "y": -0.485,
              "z": 0.602
            },
            "gtin": "4008495017547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cee4",
            "leftCorner": {
              "x": 1.257,
              "y": -0.485,
              "z": 0.602
            },
            "rightCorner": {
              "x": 1.259,
              "y": -0.447,
              "z": 0.602
            },
            "gtin": "4008495017547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cee5",
            "leftCorner": {
              "x": 1.268,
              "y": -0.447,
              "z": 0.602
            },
            "rightCorner": {
              "x": 1.274,
              "y": -0.325,
              "z": 0.602
            },
            "gtin": "4008495308874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cee6",
            "leftCorner": {
              "x": 1.261,
              "y": -0.325,
              "z": 0.602
            },
            "rightCorner": {
              "x": 1.266,
              "y": -0.23,
              "z": 0.602
            },
            "gtin": "4008495308867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cedd",
            "leftCorner": {
              "x": 1.271,
              "y": -0.23,
              "z": 0.602
            },
            "rightCorner": {
              "x": 1.299,
              "y": 0.322,
              "z": 0.602
            },
            "gtin": "4008495307310",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546162",
        "height": 0.98548,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1ce24",
            "leftCorner": {
              "x": 1.256,
              "y": -0.852,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.261,
              "y": -0.766,
              "z": 0.806
            },
            "gtin": "8717847139184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce25",
            "leftCorner": {
              "x": 1.261,
              "y": -0.766,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.265,
              "y": -0.68,
              "z": 0.806
            },
            "gtin": "8717847139184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce26",
            "leftCorner": {
              "x": 1.277,
              "y": -0.681,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.283,
              "y": -0.575,
              "z": 0.806
            },
            "gtin": "8717847139146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce27",
            "leftCorner": {
              "x": 1.254,
              "y": -0.573,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.259,
              "y": -0.464,
              "z": 0.806
            },
            "gtin": "4009078200417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce28",
            "leftCorner": {
              "x": 1.261,
              "y": -0.464,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.265,
              "y": -0.393,
              "z": 0.806
            },
            "gtin": "4008495017486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce29",
            "leftCorner": {
              "x": 1.269,
              "y": -0.393,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.274,
              "y": -0.282,
              "z": 0.806
            },
            "gtin": "4008495018230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdfd",
            "leftCorner": {
              "x": 1.278,
              "y": -0.282,
              "z": 0.806
            },
            "rightCorner": {
              "x": 1.308,
              "y": 0.322,
              "z": 0.806
            },
            "gtin": "4008495018254",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546160",
        "height": 1.2329,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1ce76",
            "leftCorner": {
              "x": 1.261,
              "y": -0.977,
              "z": 1.009
            },
            "rightCorner": {
              "x": 1.267,
              "y": -0.86,
              "z": 1.009
            },
            "gtin": "4008495000853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce77",
            "leftCorner": {
              "x": 1.269,
              "y": -0.86,
              "z": 1.009
            },
            "rightCorner": {
              "x": 1.271,
              "y": -0.821,
              "z": 1.009
            },
            "gtin": "4008495000563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce78",
            "leftCorner": {
              "x": 1.271,
              "y": -0.821,
              "z": 1.009
            },
            "rightCorner": {
              "x": 1.273,
              "y": -0.781,
              "z": 1.009
            },
            "gtin": "4008495000563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce79",
            "leftCorner": {
              "x": 1.273,
              "y": -0.781,
              "z": 1.009
            },
            "rightCorner": {
              "x": 1.275,
              "y": -0.742,
              "z": 1.009
            },
            "gtin": "4008495000563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce7a",
            "leftCorner": {
              "x": 1.261,
              "y": -0.741,
              "z": 1.009
            },
            "rightCorner": {
              "x": 1.266,
              "y": -0.643,
              "z": 1.009
            },
            "gtin": "4008495000808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce7b",
            "leftCorner": {
              "x": 1.267,
              "y": -0.643,
              "z": 1.009
            },
            "rightCorner": {
              "x": 1.27,
              "y": -0.576,
              "z": 1.009
            },
            "gtin": "4008495001317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce7c",
            "leftCorner": {
              "x": 1.264,
              "y": -0.575,
              "z": 1.009
            },
            "rightCorner": {
              "x": 1.266,
              "y": -0.528,
              "z": 1.009
            },
            "gtin": "4057824922687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce7d",
            "leftCorner": {
              "x": 1.266,
              "y": -0.528,
              "z": 1.009
            },
            "rightCorner": {
              "x": 1.268,
              "y": -0.481,
              "z": 1.009
            },
            "gtin": "4057824922687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce7e",
            "leftCorner": {
              "x": 1.264,
              "y": -0.481,
              "z": 1.009
            },
            "rightCorner": {
              "x": 1.269,
              "y": -0.371,
              "z": 1.009
            },
            "gtin": "4008495017455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce7f",
            "leftCorner": {
              "x": 1.277,
              "y": -0.372,
              "z": 1.009
            },
            "rightCorner": {
              "x": 1.279,
              "y": -0.336,
              "z": 1.009
            }
          },
          {
            "id": "68300c835ed67a01d9a1ce80",
            "leftCorner": {
              "x": 1.275,
              "y": -0.336,
              "z": 1.009
            },
            "rightCorner": {
              "x": 1.279,
              "y": -0.267,
              "z": 1.009
            },
            "gtin": "4057824922922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce81",
            "leftCorner": {
              "x": 1.273,
              "y": -0.267,
              "z": 1.009
            },
            "rightCorner": {
              "x": 1.281,
              "y": -0.106,
              "z": 1.009
            },
            "gtin": "4008495001362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce4d",
            "leftCorner": {
              "x": 1.291,
              "y": -0.107,
              "z": 1.009
            },
            "rightCorner": {
              "x": 1.301,
              "y": 0.107,
              "z": 1.009
            },
            "gtin": "4008495018520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce4e",
            "leftCorner": {
              "x": 1.301,
              "y": 0.107,
              "z": 1.009
            },
            "rightCorner": {
              "x": 1.312,
              "y": 0.321,
              "z": 1.009
            },
            "gtin": "4008495018520",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a54615e",
        "height": 1.4371,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cdf1",
            "leftCorner": {
              "x": 1.267,
              "y": -0.98,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.27,
              "y": -0.908,
              "z": 1.176
            },
            "gtin": "4009078895781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdf2",
            "leftCorner": {
              "x": 1.268,
              "y": -0.908,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.273,
              "y": -0.814,
              "z": 1.176
            },
            "gtin": "4002653057703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdf3",
            "leftCorner": {
              "x": 1.268,
              "y": -0.813,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.271,
              "y": -0.761,
              "z": 1.176
            },
            "gtin": "4002653057734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdf4",
            "leftCorner": {
              "x": 1.271,
              "y": -0.761,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.273,
              "y": -0.708,
              "z": 1.176
            },
            "gtin": "4002653057734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdf5",
            "leftCorner": {
              "x": 1.279,
              "y": -0.687,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.283,
              "y": -0.614,
              "z": 1.176
            },
            "gtin": "4002653095552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdf6",
            "leftCorner": {
              "x": 1.283,
              "y": -0.614,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.286,
              "y": -0.542,
              "z": 1.176
            },
            "gtin": "4002653095552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdf7",
            "leftCorner": {
              "x": 1.264,
              "y": -0.541,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.27,
              "y": -0.418,
              "z": 1.176
            },
            "gtin": "4002653058427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdf8",
            "leftCorner": {
              "x": 1.264,
              "y": -0.417,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.267,
              "y": -0.348,
              "z": 1.176
            },
            "gtin": "4002653058144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdf9",
            "leftCorner": {
              "x": 1.283,
              "y": -0.349,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.286,
              "y": -0.276,
              "z": 1.176
            },
            "gtin": "4002653057857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cdc4",
            "leftCorner": {
              "x": 1.286,
              "y": -0.25,
              "z": 1.176
            },
            "rightCorner": {
              "x": 1.315,
              "y": 0.321,
              "z": 1.176
            },
            "gtin": "4008495432616",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546164",
        "height": 1.7069,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cee7",
            "leftCorner": {
              "x": 1.204,
              "y": -0.925,
              "z": 1.397
            },
            "rightCorner": {
              "x": 1.232,
              "y": -0.365,
              "z": 1.397
            },
            "gtin": "4057824916044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cee8",
            "leftCorner": {
              "x": 1.192,
              "y": -0.363,
              "z": 1.397
            },
            "rightCorner": {
              "x": 1.227,
              "y": 0.326,
              "z": 1.397
            },
            "gtin": "4057824916044",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a54615f",
        "height": 1.7345,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1ceb5",
            "leftCorner": {
              "x": 1.266,
              "y": -0.967,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.276,
              "y": -0.778,
              "z": 1.419
            },
            "gtin": "4057824647047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceb6",
            "leftCorner": {
              "x": 1.276,
              "y": -0.778,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.28,
              "y": -0.691,
              "z": 1.419
            },
            "gtin": "4057824647078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceb7",
            "leftCorner": {
              "x": 1.275,
              "y": -0.691,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.283,
              "y": -0.539,
              "z": 1.419
            },
            "gtin": "4057824647054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceb8",
            "leftCorner": {
              "x": 1.278,
              "y": -0.538,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.286,
              "y": -0.382,
              "z": 1.419
            },
            "gtin": "4057824916013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce84",
            "leftCorner": {
              "x": 1.285,
              "y": -0.382,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.303,
              "y": -0.03,
              "z": 1.419
            },
            "gtin": "4057824916808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ce85",
            "leftCorner": {
              "x": 1.303,
              "y": -0.03,
              "z": 1.419
            },
            "rightCorner": {
              "x": 1.321,
              "y": 0.321,
              "z": 1.419
            },
            "gtin": "4057824916808",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "99d76"
  },
  {
    "id": "99d76",
    "name": "99d76",
    "x": 1.352,
    "y": 0.319,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68906,
      "w": 0.72471
    },

    "layers": [],
    "leftNeighborShelfId": "99d75"
  },
  {
    "id": "99d78",
    "name": "99d78",
    "x": 19.929,
    "y": 0.265,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9992,
      "w": 0.040097
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 53
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54677c",
        "height": 0.14679,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1df86",
            "leftCorner": {
              "x": 19.928,
              "y": 0.251,
              "z": 0.12
            },
            "rightCorner": {
              "x": 19.505,
              "y": 0.285,
              "z": 0.12
            },
            "gtin": "4008671814458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df87",
            "leftCorner": {
              "x": 19.505,
              "y": 0.285,
              "z": 0.12
            },
            "rightCorner": {
              "x": 19.083,
              "y": 0.319,
              "z": 0.12
            },
            "gtin": "4008671814458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df8b",
            "leftCorner": {
              "x": 19.078,
              "y": 0.275,
              "z": 0.12
            },
            "rightCorner": {
              "x": 18.737,
              "y": 0.302,
              "z": 0.12
            },
            "gtin": "4008671064105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df8c",
            "leftCorner": {
              "x": 18.737,
              "y": 0.302,
              "z": 0.12
            },
            "rightCorner": {
              "x": 18.395,
              "y": 0.33,
              "z": 0.12
            },
            "gtin": "4008671064105",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54677d",
        "height": 0.69299,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a2105a",
            "leftCorner": {
              "x": 19.929,
              "y": 0.262,
              "z": 0.567
            },
            "rightCorner": {
              "x": 19.466,
              "y": 0.299,
              "z": 0.567
            },
            "gtin": "4008671024000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2105b",
            "leftCorner": {
              "x": 19.466,
              "y": 0.299,
              "z": 0.567
            },
            "rightCorner": {
              "x": 19.003,
              "y": 0.336,
              "z": 0.567
            },
            "gtin": "4008671024000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2105c",
            "leftCorner": {
              "x": 19.001,
              "y": 0.3,
              "z": 0.567
            },
            "rightCorner": {
              "x": 18.865,
              "y": 0.311,
              "z": 0.567
            },
            "gtin": "4008671038007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2105d",
            "leftCorner": {
              "x": 18.865,
              "y": 0.311,
              "z": 0.567
            },
            "rightCorner": {
              "x": 18.73,
              "y": 0.322,
              "z": 0.567
            },
            "gtin": "4008671038007",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546779",
        "height": 1.045,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a21017",
            "leftCorner": {
              "x": 19.929,
              "y": 0.265,
              "z": 0.855
            },
            "rightCorner": {
              "x": 19.807,
              "y": 0.275,
              "z": 0.855
            },
            "gtin": "4008671821906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21018",
            "leftCorner": {
              "x": 19.807,
              "y": 0.275,
              "z": 0.855
            },
            "rightCorner": {
              "x": 19.685,
              "y": 0.284,
              "z": 0.855
            },
            "gtin": "4008671821906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21019",
            "leftCorner": {
              "x": 19.685,
              "y": 0.284,
              "z": 0.855
            },
            "rightCorner": {
              "x": 19.563,
              "y": 0.294,
              "z": 0.855
            },
            "gtin": "4008671821906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2101a",
            "leftCorner": {
              "x": 19.563,
              "y": 0.294,
              "z": 0.855
            },
            "rightCorner": {
              "x": 19.44,
              "y": 0.304,
              "z": 0.855
            },
            "gtin": "4008671821906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2101b",
            "leftCorner": {
              "x": 19.44,
              "y": 0.304,
              "z": 0.855
            },
            "rightCorner": {
              "x": 19.319,
              "y": 0.314,
              "z": 0.855
            },
            "gtin": "4008671821906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21020",
            "leftCorner": {
              "x": 19.314,
              "y": 0.269,
              "z": 0.855
            },
            "rightCorner": {
              "x": 19.024,
              "y": 0.292,
              "z": 0.855
            },
            "gtin": "4000521731106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21021",
            "leftCorner": {
              "x": 19.024,
              "y": 0.292,
              "z": 0.855
            },
            "rightCorner": {
              "x": 18.733,
              "y": 0.315,
              "z": 0.855
            },
            "gtin": "4000521731106",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54677a",
        "height": 1.2979,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a2102a",
            "leftCorner": {
              "x": 19.929,
              "y": 0.27,
              "z": 1.062
            },
            "rightCorner": {
              "x": 19.797,
              "y": 0.281,
              "z": 1.062
            },
            "gtin": "4008671725990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2102b",
            "leftCorner": {
              "x": 19.797,
              "y": 0.281,
              "z": 1.062
            },
            "rightCorner": {
              "x": 19.663,
              "y": 0.292,
              "z": 1.062
            },
            "gtin": "4008671725990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2102c",
            "leftCorner": {
              "x": 19.663,
              "y": 0.292,
              "z": 1.062
            },
            "rightCorner": {
              "x": 19.529,
              "y": 0.302,
              "z": 1.062
            },
            "gtin": "4008671725990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2102d",
            "leftCorner": {
              "x": 19.529,
              "y": 0.302,
              "z": 1.062
            },
            "rightCorner": {
              "x": 19.396,
              "y": 0.313,
              "z": 1.062
            },
            "gtin": "4008671725990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21031",
            "leftCorner": {
              "x": 19.393,
              "y": 0.272,
              "z": 1.062
            },
            "rightCorner": {
              "x": 19.159,
              "y": 0.291,
              "z": 1.062
            },
            "gtin": "4008671030001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21032",
            "leftCorner": {
              "x": 19.159,
              "y": 0.291,
              "z": 1.062
            },
            "rightCorner": {
              "x": 18.927,
              "y": 0.31,
              "z": 1.062
            },
            "gtin": "4008671030001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21033",
            "leftCorner": {
              "x": 18.927,
              "y": 0.31,
              "z": 1.062
            },
            "rightCorner": {
              "x": 18.694,
              "y": 0.329,
              "z": 1.062
            },
            "gtin": "4008671030001",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54677b",
        "height": 1.5012,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a21043",
            "leftCorner": {
              "x": 19.929,
              "y": 0.233,
              "z": 1.228
            },
            "rightCorner": {
              "x": 19.84,
              "y": 0.24,
              "z": 1.228
            },
            "gtin": "4008671821807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2103f",
            "leftCorner": {
              "x": 19.929,
              "y": 0.272,
              "z": 1.228
            },
            "rightCorner": {
              "x": 19.334,
              "y": 0.32,
              "z": 1.228
            },
            "gtin": "4000521700713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21044",
            "leftCorner": {
              "x": 19.84,
              "y": 0.24,
              "z": 1.228
            },
            "rightCorner": {
              "x": 19.751,
              "y": 0.247,
              "z": 1.228
            },
            "gtin": "4008671821807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21045",
            "leftCorner": {
              "x": 19.751,
              "y": 0.247,
              "z": 1.228
            },
            "rightCorner": {
              "x": 19.662,
              "y": 0.254,
              "z": 1.228
            },
            "gtin": "4008671821807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21046",
            "leftCorner": {
              "x": 19.662,
              "y": 0.255,
              "z": 1.228
            },
            "rightCorner": {
              "x": 19.579,
              "y": 0.261,
              "z": 1.228
            },
            "gtin": "4000521700713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21047",
            "leftCorner": {
              "x": 19.579,
              "y": 0.261,
              "z": 1.228
            },
            "rightCorner": {
              "x": 19.498,
              "y": 0.268,
              "z": 1.228
            },
            "gtin": "4000521700713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21048",
            "leftCorner": {
              "x": 19.498,
              "y": 0.267,
              "z": 1.228
            },
            "rightCorner": {
              "x": 19.316,
              "y": 0.282,
              "z": 1.228
            },
            "gtin": "4002809004476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21049",
            "leftCorner": {
              "x": 19.316,
              "y": 0.276,
              "z": 1.228
            },
            "rightCorner": {
              "x": 19.268,
              "y": 0.28,
              "z": 1.228
            },
            "gtin": "4002809004483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2104a",
            "leftCorner": {
              "x": 19.268,
              "y": 0.28,
              "z": 1.228
            },
            "rightCorner": {
              "x": 19.221,
              "y": 0.284,
              "z": 1.228
            },
            "gtin": "4002809004483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2104b",
            "leftCorner": {
              "x": 19.221,
              "y": 0.284,
              "z": 1.228
            },
            "rightCorner": {
              "x": 19.173,
              "y": 0.288,
              "z": 1.228
            },
            "gtin": "4002809004483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2104c",
            "leftCorner": {
              "x": 19.173,
              "y": 0.288,
              "z": 1.228
            },
            "rightCorner": {
              "x": 19.126,
              "y": 0.292,
              "z": 1.228
            },
            "gtin": "4002809004483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2104d",
            "leftCorner": {
              "x": 19.126,
              "y": 0.289,
              "z": 1.228
            },
            "rightCorner": {
              "x": 19.06,
              "y": 0.295,
              "z": 1.228
            },
            "gtin": "4000521711603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2104e",
            "leftCorner": {
              "x": 19.06,
              "y": 0.295,
              "z": 1.228
            },
            "rightCorner": {
              "x": 18.995,
              "y": 0.3,
              "z": 1.228
            },
            "gtin": "4000521711603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2104f",
            "leftCorner": {
              "x": 18.995,
              "y": 0.3,
              "z": 1.228
            },
            "rightCorner": {
              "x": 18.929,
              "y": 0.305,
              "z": 1.228
            },
            "gtin": "4000521711603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21050",
            "leftCorner": {
              "x": 18.929,
              "y": 0.316,
              "z": 1.228
            },
            "rightCorner": {
              "x": 18.855,
              "y": 0.322,
              "z": 1.228
            },
            "gtin": "4000521712006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21051",
            "leftCorner": {
              "x": 18.855,
              "y": 0.322,
              "z": 1.228
            },
            "rightCorner": {
              "x": 18.782,
              "y": 0.328,
              "z": 1.228
            },
            "gtin": "4000521712006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21052",
            "leftCorner": {
              "x": 18.78,
              "y": 0.32,
              "z": 1.228
            },
            "rightCorner": {
              "x": 18.737,
              "y": 0.324,
              "z": 1.228
            },
            "gtin": "4002809946332",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546778",
        "height": 1.7005,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1df0b",
            "leftCorner": {
              "x": 19.942,
              "y": 0.24,
              "z": 1.391
            },
            "rightCorner": {
              "x": 19.855,
              "y": 0.247,
              "z": 1.391
            },
            "gtin": "4008671053000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df0c",
            "leftCorner": {
              "x": 19.855,
              "y": 0.247,
              "z": 1.391
            },
            "rightCorner": {
              "x": 19.768,
              "y": 0.254,
              "z": 1.391
            },
            "gtin": "4008671053000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df0d",
            "leftCorner": {
              "x": 19.768,
              "y": 0.249,
              "z": 1.391
            },
            "rightCorner": {
              "x": 19.682,
              "y": 0.255,
              "z": 1.391
            },
            "gtin": "4008671015022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df0e",
            "leftCorner": {
              "x": 19.682,
              "y": 0.255,
              "z": 1.391
            },
            "rightCorner": {
              "x": 19.596,
              "y": 0.262,
              "z": 1.391
            },
            "gtin": "4008671015022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df0f",
            "leftCorner": {
              "x": 19.596,
              "y": 0.262,
              "z": 1.391
            },
            "rightCorner": {
              "x": 19.512,
              "y": 0.269,
              "z": 1.391
            },
            "gtin": "4008671015022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df10",
            "leftCorner": {
              "x": 19.512,
              "y": 0.269,
              "z": 1.391
            },
            "rightCorner": {
              "x": 19.426,
              "y": 0.276,
              "z": 1.391
            },
            "gtin": "4008671015022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df11",
            "leftCorner": {
              "x": 19.426,
              "y": 0.272,
              "z": 1.391
            },
            "rightCorner": {
              "x": 19.34,
              "y": 0.279,
              "z": 1.391
            },
            "gtin": "4008671023003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df12",
            "leftCorner": {
              "x": 19.34,
              "y": 0.279,
              "z": 1.391
            },
            "rightCorner": {
              "x": 19.254,
              "y": 0.286,
              "z": 1.391
            },
            "gtin": "4008671023003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df13",
            "leftCorner": {
              "x": 19.254,
              "y": 0.282,
              "z": 1.391
            },
            "rightCorner": {
              "x": 19.131,
              "y": 0.292,
              "z": 1.391
            },
            "gtin": "4008671016104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df14",
            "leftCorner": {
              "x": 19.131,
              "y": 0.292,
              "z": 1.391
            },
            "rightCorner": {
              "x": 19.008,
              "y": 0.302,
              "z": 1.391
            },
            "gtin": "4008671016104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df15",
            "leftCorner": {
              "x": 19.008,
              "y": 0.299,
              "z": 1.391
            },
            "rightCorner": {
              "x": 18.934,
              "y": 0.305,
              "z": 1.391
            },
            "gtin": "4001726004309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df16",
            "leftCorner": {
              "x": 18.934,
              "y": 0.305,
              "z": 1.391
            },
            "rightCorner": {
              "x": 18.86,
              "y": 0.311,
              "z": 1.391
            },
            "gtin": "4001726004309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df17",
            "leftCorner": {
              "x": 18.86,
              "y": 0.311,
              "z": 1.391
            },
            "rightCorner": {
              "x": 18.787,
              "y": 0.317,
              "z": 1.391
            },
            "gtin": "4001726004309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df18",
            "leftCorner": {
              "x": 18.787,
              "y": 0.317,
              "z": 1.391
            },
            "rightCorner": {
              "x": 18.713,
              "y": 0.323,
              "z": 1.391
            },
            "gtin": "4001726004309",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "dde9c",
    "rightNeighborShelfId": "e0255"
  },
  {
    "id": "a6d4e",
    "name": "a6d4e",
    "x": -0.581,
    "y": 31.202,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9998,
      "w": 0.019756
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 110
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546603",
        "height": 0.16678,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2075d",
            "leftCorner": {
              "x": -0.589,
              "y": 31.164,
              "z": 0.136
            },
            "rightCorner": {
              "x": -0.638,
              "y": 31.166,
              "z": 0.136
            },
            "gtin": "8717524074951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2075e",
            "leftCorner": {
              "x": -0.638,
              "y": 31.166,
              "z": 0.136
            },
            "rightCorner": {
              "x": -0.687,
              "y": 31.168,
              "z": 0.136
            },
            "gtin": "8717524074951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2075f",
            "leftCorner": {
              "x": -0.687,
              "y": 31.166,
              "z": 0.136
            },
            "rightCorner": {
              "x": -0.732,
              "y": 31.168,
              "z": 0.136
            },
            "gtin": "4262429770346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20760",
            "leftCorner": {
              "x": -0.732,
              "y": 31.168,
              "z": 0.136
            },
            "rightCorner": {
              "x": -0.777,
              "y": 31.17,
              "z": 0.136
            },
            "gtin": "4262429770346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20761",
            "leftCorner": {
              "x": -0.777,
              "y": 31.17,
              "z": 0.136
            },
            "rightCorner": {
              "x": -0.822,
              "y": 31.172,
              "z": 0.136
            },
            "gtin": "4262429770346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20762",
            "leftCorner": {
              "x": -0.822,
              "y": 31.168,
              "z": 0.136
            },
            "rightCorner": {
              "x": -0.879,
              "y": 31.17,
              "z": 0.136
            },
            "gtin": "4262429770360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20763",
            "leftCorner": {
              "x": -0.879,
              "y": 31.17,
              "z": 0.136
            },
            "rightCorner": {
              "x": -0.937,
              "y": 31.173,
              "z": 0.136
            },
            "gtin": "4262429770360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20764",
            "leftCorner": {
              "x": -0.937,
              "y": 31.173,
              "z": 0.136
            },
            "rightCorner": {
              "x": -0.994,
              "y": 31.175,
              "z": 0.136
            },
            "gtin": "4262429770360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20765",
            "leftCorner": {
              "x": -0.994,
              "y": 31.175,
              "z": 0.136
            },
            "rightCorner": {
              "x": -1.051,
              "y": 31.177,
              "z": 0.136
            },
            "gtin": "4262429770360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20766",
            "leftCorner": {
              "x": -1.051,
              "y": 31.174,
              "z": 0.136
            },
            "rightCorner": {
              "x": -1.106,
              "y": 31.176,
              "z": 0.136
            },
            "gtin": "4262429770353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20767",
            "leftCorner": {
              "x": -1.106,
              "y": 31.176,
              "z": 0.136
            },
            "rightCorner": {
              "x": -1.16,
              "y": 31.178,
              "z": 0.136
            },
            "gtin": "4262429770353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20768",
            "leftCorner": {
              "x": -1.16,
              "y": 31.178,
              "z": 0.136
            },
            "rightCorner": {
              "x": -1.215,
              "y": 31.18,
              "z": 0.136
            },
            "gtin": "4262429770353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20769",
            "leftCorner": {
              "x": -1.215,
              "y": 31.178,
              "z": 0.136
            },
            "rightCorner": {
              "x": -1.265,
              "y": 31.18,
              "z": 0.136
            },
            "gtin": "4262429770377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2076a",
            "leftCorner": {
              "x": -1.265,
              "y": 31.18,
              "z": 0.136
            },
            "rightCorner": {
              "x": -1.314,
              "y": 31.182,
              "z": 0.136
            },
            "gtin": "4262429770377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2076b",
            "leftCorner": {
              "x": -1.314,
              "y": 31.182,
              "z": 0.136
            },
            "rightCorner": {
              "x": -1.364,
              "y": 31.184,
              "z": 0.136
            },
            "gtin": "4262429770377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2076c",
            "leftCorner": {
              "x": -1.364,
              "y": 31.188,
              "z": 0.136
            },
            "rightCorner": {
              "x": -1.418,
              "y": 31.19,
              "z": 0.136
            },
            "gtin": "8710447484265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2076d",
            "leftCorner": {
              "x": -1.418,
              "y": 31.19,
              "z": 0.136
            },
            "rightCorner": {
              "x": -1.473,
              "y": 31.192,
              "z": 0.136
            },
            "gtin": "8710447484265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2076e",
            "leftCorner": {
              "x": -1.473,
              "y": 31.192,
              "z": 0.136
            },
            "rightCorner": {
              "x": -1.527,
              "y": 31.194,
              "z": 0.136
            },
            "gtin": "8710447484265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2076f",
            "leftCorner": {
              "x": -1.527,
              "y": 31.194,
              "z": 0.136
            },
            "rightCorner": {
              "x": -1.582,
              "y": 31.196,
              "z": 0.136
            },
            "gtin": "8710447484265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20770",
            "leftCorner": {
              "x": -1.58,
              "y": 31.227,
              "z": 0.136
            },
            "rightCorner": {
              "x": -1.622,
              "y": 31.228,
              "z": 0.136
            },
            "gtin": "8720181425943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20771",
            "leftCorner": {
              "x": -1.622,
              "y": 31.228,
              "z": 0.136
            },
            "rightCorner": {
              "x": -1.663,
              "y": 31.23,
              "z": 0.136
            },
            "gtin": "8720181425943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20772",
            "leftCorner": {
              "x": -1.663,
              "y": 31.23,
              "z": 0.136
            },
            "rightCorner": {
              "x": -1.704,
              "y": 31.232,
              "z": 0.136
            },
            "gtin": "8720181425943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20744",
            "leftCorner": {
              "x": -1.706,
              "y": 31.192,
              "z": 0.136
            },
            "rightCorner": {
              "x": -1.744,
              "y": 31.194,
              "z": 0.136
            },
            "gtin": "8720181590832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20745",
            "leftCorner": {
              "x": -1.744,
              "y": 31.194,
              "z": 0.136
            },
            "rightCorner": {
              "x": -1.782,
              "y": 31.195,
              "z": 0.136
            },
            "gtin": "8720181590832",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546601",
        "height": 0.45239,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f887",
            "leftCorner": {
              "x": -0.585,
              "y": 31.098,
              "z": 0.37
            },
            "rightCorner": {
              "x": -0.722,
              "y": 31.103,
              "z": 0.37
            },
            "gtin": "4015100429008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f888",
            "leftCorner": {
              "x": -0.722,
              "y": 31.103,
              "z": 0.37
            },
            "rightCorner": {
              "x": -0.858,
              "y": 31.109,
              "z": 0.37
            },
            "gtin": "4015100429008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f88a",
            "leftCorner": {
              "x": -0.86,
              "y": 31.066,
              "z": 0.37
            },
            "rightCorner": {
              "x": -0.936,
              "y": 31.068,
              "z": 0.37
            },
            "gtin": "4015100429268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f88b",
            "leftCorner": {
              "x": -0.936,
              "y": 31.068,
              "z": 0.37
            },
            "rightCorner": {
              "x": -1.011,
              "y": 31.072,
              "z": 0.37
            },
            "gtin": "4015100429268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f88c",
            "leftCorner": {
              "x": -1.011,
              "y": 31.072,
              "z": 0.37
            },
            "rightCorner": {
              "x": -1.087,
              "y": 31.075,
              "z": 0.37
            },
            "gtin": "4015100429268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f88d",
            "leftCorner": {
              "x": -1.087,
              "y": 31.075,
              "z": 0.37
            },
            "rightCorner": {
              "x": -1.162,
              "y": 31.077,
              "z": 0.37
            },
            "gtin": "4015100429268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f88e",
            "leftCorner": {
              "x": -1.162,
              "y": 31.082,
              "z": 0.37
            },
            "rightCorner": {
              "x": -1.231,
              "y": 31.086,
              "z": 0.37
            },
            "gtin": "4015100428988",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f88f",
            "leftCorner": {
              "x": -1.231,
              "y": 31.086,
              "z": 0.37
            },
            "rightCorner": {
              "x": -1.299,
              "y": 31.088,
              "z": 0.37
            },
            "gtin": "4015100428988",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f890",
            "leftCorner": {
              "x": -1.299,
              "y": 31.088,
              "z": 0.37
            },
            "rightCorner": {
              "x": -1.368,
              "y": 31.091,
              "z": 0.37
            },
            "gtin": "4015100428988",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f891",
            "leftCorner": {
              "x": -1.368,
              "y": 31.09,
              "z": 0.37
            },
            "rightCorner": {
              "x": -1.442,
              "y": 31.092,
              "z": 0.37
            },
            "gtin": "4015100428964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f892",
            "leftCorner": {
              "x": -1.442,
              "y": 31.092,
              "z": 0.37
            },
            "rightCorner": {
              "x": -1.516,
              "y": 31.096,
              "z": 0.37
            },
            "gtin": "4015100428964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f893",
            "leftCorner": {
              "x": -1.516,
              "y": 31.096,
              "z": 0.37
            },
            "rightCorner": {
              "x": -1.59,
              "y": 31.098,
              "z": 0.37
            },
            "gtin": "4015100428964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f894",
            "leftCorner": {
              "x": -1.59,
              "y": 31.098,
              "z": 0.37
            },
            "rightCorner": {
              "x": -1.664,
              "y": 31.101,
              "z": 0.37
            },
            "gtin": "4015100428964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f895",
            "leftCorner": {
              "x": -1.663,
              "y": 31.106,
              "z": 0.37
            },
            "rightCorner": {
              "x": -1.71,
              "y": 31.108,
              "z": 0.37
            },
            "gtin": "4006000094137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f896",
            "leftCorner": {
              "x": -1.71,
              "y": 31.108,
              "z": 0.37
            },
            "rightCorner": {
              "x": -1.756,
              "y": 31.11,
              "z": 0.37
            },
            "gtin": "4006000094137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f897",
            "leftCorner": {
              "x": -1.756,
              "y": 31.11,
              "z": 0.37
            },
            "rightCorner": {
              "x": -1.802,
              "y": 31.111,
              "z": 0.37
            },
            "gtin": "4006000094137",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465ff",
        "height": 0.70307,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f80d",
            "leftCorner": {
              "x": -0.585,
              "y": 31.1,
              "z": 0.575
            },
            "rightCorner": {
              "x": -0.645,
              "y": 31.102,
              "z": 0.575
            },
            "gtin": "3600523715350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f80e",
            "leftCorner": {
              "x": -0.645,
              "y": 31.102,
              "z": 0.575
            },
            "rightCorner": {
              "x": -0.706,
              "y": 31.105,
              "z": 0.575
            },
            "gtin": "3600523715350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f810",
            "leftCorner": {
              "x": -0.707,
              "y": 31.066,
              "z": 0.575
            },
            "rightCorner": {
              "x": -0.761,
              "y": 31.068,
              "z": 0.575
            },
            "gtin": "3616302035397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f811",
            "leftCorner": {
              "x": -0.761,
              "y": 31.068,
              "z": 0.575
            },
            "rightCorner": {
              "x": -0.816,
              "y": 31.07,
              "z": 0.575
            },
            "gtin": "3616302035397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f812",
            "leftCorner": {
              "x": -0.816,
              "y": 31.071,
              "z": 0.575
            },
            "rightCorner": {
              "x": -0.896,
              "y": 31.074,
              "z": 0.575
            },
            "gtin": "3616302035410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f813",
            "leftCorner": {
              "x": -0.896,
              "y": 31.074,
              "z": 0.575
            },
            "rightCorner": {
              "x": -0.977,
              "y": 31.077,
              "z": 0.575
            },
            "gtin": "3616302035410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f814",
            "leftCorner": {
              "x": -0.977,
              "y": 31.088,
              "z": 0.575
            },
            "rightCorner": {
              "x": -1.042,
              "y": 31.091,
              "z": 0.575
            },
            "gtin": "3616302035458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f815",
            "leftCorner": {
              "x": -1.042,
              "y": 31.091,
              "z": 0.575
            },
            "rightCorner": {
              "x": -1.107,
              "y": 31.093,
              "z": 0.575
            },
            "gtin": "3616302035458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f816",
            "leftCorner": {
              "x": -1.107,
              "y": 31.093,
              "z": 0.575
            },
            "rightCorner": {
              "x": -1.173,
              "y": 31.095,
              "z": 0.575
            },
            "gtin": "3616302035458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f817",
            "leftCorner": {
              "x": -1.173,
              "y": 31.088,
              "z": 0.575
            },
            "rightCorner": {
              "x": -1.256,
              "y": 31.091,
              "z": 0.575
            },
            "gtin": "3616302035434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f818",
            "leftCorner": {
              "x": -1.256,
              "y": 31.091,
              "z": 0.575
            },
            "rightCorner": {
              "x": -1.339,
              "y": 31.095,
              "z": 0.575
            },
            "gtin": "3616302035434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f819",
            "leftCorner": {
              "x": -1.339,
              "y": 31.095,
              "z": 0.575
            },
            "rightCorner": {
              "x": -1.423,
              "y": 31.098,
              "z": 0.575
            },
            "gtin": "3616302035434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f81a",
            "leftCorner": {
              "x": -1.423,
              "y": 31.099,
              "z": 0.575
            },
            "rightCorner": {
              "x": -1.478,
              "y": 31.101,
              "z": 0.575
            },
            "gtin": "3616302035427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f81b",
            "leftCorner": {
              "x": -1.478,
              "y": 31.101,
              "z": 0.575
            },
            "rightCorner": {
              "x": -1.533,
              "y": 31.103,
              "z": 0.575
            },
            "gtin": "3616302035427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f81c",
            "leftCorner": {
              "x": -1.533,
              "y": 31.103,
              "z": 0.575
            },
            "rightCorner": {
              "x": -1.588,
              "y": 31.105,
              "z": 0.575
            },
            "gtin": "3616302035427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f81d",
            "leftCorner": {
              "x": -1.589,
              "y": 31.1,
              "z": 0.575
            },
            "rightCorner": {
              "x": -1.672,
              "y": 31.104,
              "z": 0.575
            },
            "gtin": "3616304696046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f81e",
            "leftCorner": {
              "x": -1.672,
              "y": 31.104,
              "z": 0.575
            },
            "rightCorner": {
              "x": -1.756,
              "y": 31.107,
              "z": 0.575
            },
            "gtin": "3616304696046",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546604",
        "height": 0.94893,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f845",
            "leftCorner": {
              "x": -0.589,
              "y": 30.999,
              "z": 0.776
            },
            "rightCorner": {
              "x": -0.661,
              "y": 31.002,
              "z": 0.776
            },
            "gtin": "3600524076672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f846",
            "leftCorner": {
              "x": -0.661,
              "y": 31.002,
              "z": 0.776
            },
            "rightCorner": {
              "x": -0.733,
              "y": 31.004,
              "z": 0.776
            },
            "gtin": "3600524076672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f847",
            "leftCorner": {
              "x": -0.733,
              "y": 31.004,
              "z": 0.776
            },
            "rightCorner": {
              "x": -0.805,
              "y": 31.008,
              "z": 0.776
            },
            "gtin": "3600524076672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f848",
            "leftCorner": {
              "x": -0.805,
              "y": 31.008,
              "z": 0.776
            },
            "rightCorner": {
              "x": -0.877,
              "y": 31.01,
              "z": 0.776
            },
            "gtin": "3600524076672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f84a",
            "leftCorner": {
              "x": -0.878,
              "y": 30.964,
              "z": 0.776
            },
            "rightCorner": {
              "x": -0.952,
              "y": 30.968,
              "z": 0.776
            },
            "gtin": "3600523715558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f84b",
            "leftCorner": {
              "x": -0.952,
              "y": 30.968,
              "z": 0.776
            },
            "rightCorner": {
              "x": -1.026,
              "y": 30.97,
              "z": 0.776
            },
            "gtin": "3600523715558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f84c",
            "leftCorner": {
              "x": -1.026,
              "y": 30.97,
              "z": 0.776
            },
            "rightCorner": {
              "x": -1.099,
              "y": 30.973,
              "z": 0.776
            },
            "gtin": "3600523715558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f84d",
            "leftCorner": {
              "x": -1.099,
              "y": 30.978,
              "z": 0.776
            },
            "rightCorner": {
              "x": -1.156,
              "y": 30.98,
              "z": 0.776
            },
            "gtin": "3600523715398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f84e",
            "leftCorner": {
              "x": -1.156,
              "y": 30.98,
              "z": 0.776
            },
            "rightCorner": {
              "x": -1.213,
              "y": 30.982,
              "z": 0.776
            },
            "gtin": "3600523715398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f84f",
            "leftCorner": {
              "x": -1.213,
              "y": 30.982,
              "z": 0.776
            },
            "rightCorner": {
              "x": -1.27,
              "y": 30.985,
              "z": 0.776
            },
            "gtin": "3600523715398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f850",
            "leftCorner": {
              "x": -1.27,
              "y": 30.985,
              "z": 0.776
            },
            "rightCorner": {
              "x": -1.328,
              "y": 30.987,
              "z": 0.776
            },
            "gtin": "3600523715398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f851",
            "leftCorner": {
              "x": -1.327,
              "y": 30.992,
              "z": 0.776
            },
            "rightCorner": {
              "x": -1.425,
              "y": 30.996,
              "z": 0.776
            },
            "gtin": "3600523715473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f852",
            "leftCorner": {
              "x": -1.425,
              "y": 30.996,
              "z": 0.776
            },
            "rightCorner": {
              "x": -1.523,
              "y": 30.999,
              "z": 0.776
            },
            "gtin": "3600523715473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f853",
            "leftCorner": {
              "x": -1.523,
              "y": 30.999,
              "z": 0.776
            },
            "rightCorner": {
              "x": -1.62,
              "y": 31.003,
              "z": 0.776
            },
            "gtin": "3600523715473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f854",
            "leftCorner": {
              "x": -1.62,
              "y": 31.003,
              "z": 0.776
            },
            "rightCorner": {
              "x": -1.718,
              "y": 31.007,
              "z": 0.776
            },
            "gtin": "3600523715473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f855",
            "leftCorner": {
              "x": -1.718,
              "y": 30.99,
              "z": 0.776
            },
            "rightCorner": {
              "x": -1.771,
              "y": 30.992,
              "z": 0.776
            },
            "gtin": "3600523715435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f856",
            "leftCorner": {
              "x": -1.771,
              "y": 30.992,
              "z": 0.776
            },
            "rightCorner": {
              "x": -1.823,
              "y": 30.994,
              "z": 0.776
            },
            "gtin": "3600523715435",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546600",
        "height": 1.1998,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f7e2",
            "leftCorner": {
              "x": -0.589,
              "y": 30.992,
              "z": 0.982
            },
            "rightCorner": {
              "x": -0.659,
              "y": 30.996,
              "z": 0.982
            },
            "gtin": "4006000099231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7e3",
            "leftCorner": {
              "x": -0.659,
              "y": 30.996,
              "z": 0.982
            },
            "rightCorner": {
              "x": -0.729,
              "y": 30.998,
              "z": 0.982
            },
            "gtin": "4006000099231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7e6",
            "leftCorner": {
              "x": -0.73,
              "y": 30.988,
              "z": 0.982
            },
            "rightCorner": {
              "x": -0.92,
              "y": 30.996,
              "z": 0.982
            },
            "gtin": "42449249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7e7",
            "leftCorner": {
              "x": -0.922,
              "y": 30.959,
              "z": 0.982
            },
            "rightCorner": {
              "x": -1.033,
              "y": 30.964,
              "z": 0.982
            },
            "gtin": "42449331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7e8",
            "leftCorner": {
              "x": -1.033,
              "y": 30.985,
              "z": 0.982
            },
            "rightCorner": {
              "x": -1.197,
              "y": 30.991,
              "z": 0.982
            },
            "gtin": "42449409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7e9",
            "leftCorner": {
              "x": -1.197,
              "y": 30.981,
              "z": 0.982
            },
            "rightCorner": {
              "x": -1.474,
              "y": 30.992,
              "z": 0.982
            },
            "gtin": "42449508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7ea",
            "leftCorner": {
              "x": -1.474,
              "y": 30.997,
              "z": 0.982
            },
            "rightCorner": {
              "x": -1.666,
              "y": 31.005,
              "z": 0.982
            },
            "gtin": "42449348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7eb",
            "leftCorner": {
              "x": -1.667,
              "y": 30.985,
              "z": 0.982
            },
            "rightCorner": {
              "x": -1.752,
              "y": 30.989,
              "z": 0.982
            },
            "gtin": "42449294",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546602",
        "height": 1.3988,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f7b0",
            "leftCorner": {
              "x": -0.589,
              "y": 30.998,
              "z": 1.144
            },
            "rightCorner": {
              "x": -0.677,
              "y": 31.001,
              "z": 1.144
            },
            "gtin": "4045612000013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7b2",
            "leftCorner": {
              "x": -0.678,
              "y": 30.96,
              "z": 1.144
            },
            "rightCorner": {
              "x": -0.738,
              "y": 30.962,
              "z": 1.144
            },
            "gtin": "4006000129792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7b3",
            "leftCorner": {
              "x": -0.738,
              "y": 30.962,
              "z": 1.144
            },
            "rightCorner": {
              "x": -0.792,
              "y": 30.964,
              "z": 1.144
            },
            "gtin": "4006000129846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7b4",
            "leftCorner": {
              "x": -0.792,
              "y": 30.964,
              "z": 1.144
            },
            "rightCorner": {
              "x": -0.946,
              "y": 30.971,
              "z": 1.144
            },
            "gtin": "42449928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7b5",
            "leftCorner": {
              "x": -0.946,
              "y": 30.974,
              "z": 1.144
            },
            "rightCorner": {
              "x": -1.116,
              "y": 30.98,
              "z": 1.144
            },
            "gtin": "42449980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7b6",
            "leftCorner": {
              "x": -1.116,
              "y": 30.98,
              "z": 1.144
            },
            "rightCorner": {
              "x": -1.216,
              "y": 30.984,
              "z": 1.144
            },
            "gtin": "42449997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7b7",
            "leftCorner": {
              "x": -1.216,
              "y": 30.979,
              "z": 1.144
            },
            "rightCorner": {
              "x": -1.335,
              "y": 30.984,
              "z": 1.144
            },
            "gtin": "42449942",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7b8",
            "leftCorner": {
              "x": -1.334,
              "y": 30.992,
              "z": 1.144
            },
            "rightCorner": {
              "x": -1.429,
              "y": 30.995,
              "z": 1.144
            },
            "gtin": "4015100811896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7b9",
            "leftCorner": {
              "x": -1.429,
              "y": 30.995,
              "z": 1.144
            },
            "rightCorner": {
              "x": -1.524,
              "y": 30.999,
              "z": 1.144
            },
            "gtin": "4015100811896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7ba",
            "leftCorner": {
              "x": -1.524,
              "y": 30.999,
              "z": 1.144
            },
            "rightCorner": {
              "x": -1.619,
              "y": 31.003,
              "z": 1.144
            },
            "gtin": "4015100811896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7bb",
            "leftCorner": {
              "x": -1.619,
              "y": 30.996,
              "z": 1.144
            },
            "rightCorner": {
              "x": -1.716,
              "y": 31.0,
              "z": 1.144
            },
            "gtin": "4063367280764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7bc",
            "leftCorner": {
              "x": -1.717,
              "y": 30.991,
              "z": 1.144
            },
            "rightCorner": {
              "x": -1.805,
              "y": 30.994,
              "z": 1.144
            },
            "gtin": "4063367280757",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465fe",
        "height": 1.6091,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20773",
            "leftCorner": {
              "x": -0.589,
              "y": 30.992,
              "z": 1.317
            },
            "rightCorner": {
              "x": -0.669,
              "y": 30.995,
              "z": 1.317
            },
            "gtin": "8006540424230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20775",
            "leftCorner": {
              "x": -0.671,
              "y": 30.956,
              "z": 1.317
            },
            "rightCorner": {
              "x": -0.729,
              "y": 30.958,
              "z": 1.317
            },
            "gtin": "8001841923840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20776",
            "leftCorner": {
              "x": -0.729,
              "y": 30.953,
              "z": 1.317
            },
            "rightCorner": {
              "x": -0.785,
              "y": 30.955,
              "z": 1.317
            },
            "gtin": "8700216203838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20777",
            "leftCorner": {
              "x": -0.785,
              "y": 30.962,
              "z": 1.317
            },
            "rightCorner": {
              "x": -0.842,
              "y": 30.964,
              "z": 1.317
            },
            "gtin": "8001841923802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20778",
            "leftCorner": {
              "x": -0.842,
              "y": 30.978,
              "z": 1.317
            },
            "rightCorner": {
              "x": -0.92,
              "y": 30.981,
              "z": 1.317
            },
            "gtin": "8001841923727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20779",
            "leftCorner": {
              "x": -0.92,
              "y": 30.981,
              "z": 1.317
            },
            "rightCorner": {
              "x": -0.997,
              "y": 30.985,
              "z": 1.317
            },
            "gtin": "8001841923727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2077a",
            "leftCorner": {
              "x": -0.998,
              "y": 30.971,
              "z": 1.317
            },
            "rightCorner": {
              "x": -1.048,
              "y": 30.972,
              "z": 1.317
            },
            "gtin": "8700216606288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2077b",
            "leftCorner": {
              "x": -1.048,
              "y": 30.972,
              "z": 1.317
            },
            "rightCorner": {
              "x": -1.098,
              "y": 30.974,
              "z": 1.317
            },
            "gtin": "8700216606288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2077c",
            "leftCorner": {
              "x": -1.098,
              "y": 30.982,
              "z": 1.317
            },
            "rightCorner": {
              "x": -1.191,
              "y": 30.985,
              "z": 1.317
            },
            "gtin": "8700216606134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2077d",
            "leftCorner": {
              "x": -1.192,
              "y": 30.973,
              "z": 1.317
            },
            "rightCorner": {
              "x": -1.28,
              "y": 30.977,
              "z": 1.317
            },
            "gtin": "8700216606356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2077e",
            "leftCorner": {
              "x": -1.28,
              "y": 30.977,
              "z": 1.317
            },
            "rightCorner": {
              "x": -1.363,
              "y": 30.979,
              "z": 1.317
            },
            "gtin": "8700216606257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2077f",
            "leftCorner": {
              "x": -1.363,
              "y": 31.003,
              "z": 1.317
            },
            "rightCorner": {
              "x": -1.44,
              "y": 31.007,
              "z": 1.317
            },
            "gtin": "3600524076726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20780",
            "leftCorner": {
              "x": -1.44,
              "y": 31.007,
              "z": 1.317
            },
            "rightCorner": {
              "x": -1.517,
              "y": 31.01,
              "z": 1.317
            },
            "gtin": "3600524076726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20781",
            "leftCorner": {
              "x": -1.517,
              "y": 31.013,
              "z": 1.317
            },
            "rightCorner": {
              "x": -1.584,
              "y": 31.015,
              "z": 1.317
            },
            "gtin": "3600523741465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20782",
            "leftCorner": {
              "x": -1.585,
              "y": 30.989,
              "z": 1.317
            },
            "rightCorner": {
              "x": -1.677,
              "y": 30.993,
              "z": 1.317
            },
            "gtin": "3600523741502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20783",
            "leftCorner": {
              "x": -1.677,
              "y": 31.01,
              "z": 1.317
            },
            "rightCorner": {
              "x": -1.76,
              "y": 31.014,
              "z": 1.317
            },
            "gtin": "3600523741380",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468c5",
    "rightNeighborShelfId": "a6d4f"
  },
  {
    "id": "a6d4f",
    "name": "a6d4f",
    "x": -1.77,
    "y": 31.268,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99957,
      "w": 0.029317
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 129
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546608",
        "height": 1.4003,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f7bf",
            "leftCorner": {
              "x": -2.158,
              "y": 31.046,
              "z": 1.146
            },
            "rightCorner": {
              "x": -2.305,
              "y": 31.055,
              "z": 1.146
            },
            "gtin": "59097730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7bd",
            "leftCorner": {
              "x": -1.799,
              "y": 31.024,
              "z": 1.146
            },
            "rightCorner": {
              "x": -1.879,
              "y": 31.029,
              "z": 1.146
            },
            "gtin": "59097983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7be",
            "leftCorner": {
              "x": -1.88,
              "y": 31.027,
              "z": 1.146
            },
            "rightCorner": {
              "x": -2.159,
              "y": 31.043,
              "z": 1.146
            },
            "gtin": "59097747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7c0",
            "leftCorner": {
              "x": -2.305,
              "y": 31.057,
              "z": 1.146
            },
            "rightCorner": {
              "x": -2.341,
              "y": 31.059,
              "z": 1.146
            },
            "gtin": "59095521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7c1",
            "leftCorner": {
              "x": -2.341,
              "y": 31.059,
              "z": 1.146
            },
            "rightCorner": {
              "x": -2.376,
              "y": 31.061,
              "z": 1.146
            },
            "gtin": "59095521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7c2",
            "leftCorner": {
              "x": -2.377,
              "y": 31.046,
              "z": 1.146
            },
            "rightCorner": {
              "x": -2.488,
              "y": 31.053,
              "z": 1.146
            },
            "gtin": "59095491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7c3",
            "leftCorner": {
              "x": -2.488,
              "y": 31.053,
              "z": 1.146
            },
            "rightCorner": {
              "x": -2.599,
              "y": 31.06,
              "z": 1.146
            },
            "gtin": "59095491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7c4",
            "leftCorner": {
              "x": -2.598,
              "y": 31.075,
              "z": 1.146
            },
            "rightCorner": {
              "x": -2.656,
              "y": 31.078,
              "z": 1.146
            },
            "gtin": "8718114202402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7c5",
            "leftCorner": {
              "x": -2.656,
              "y": 31.078,
              "z": 1.146
            },
            "rightCorner": {
              "x": -2.714,
              "y": 31.082,
              "z": 1.146
            },
            "gtin": "8718114202402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7c6",
            "leftCorner": {
              "x": -2.715,
              "y": 31.067,
              "z": 1.146
            },
            "rightCorner": {
              "x": -2.781,
              "y": 31.071,
              "z": 1.146
            },
            "gtin": "8712561521840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7c7",
            "leftCorner": {
              "x": -2.781,
              "y": 31.071,
              "z": 1.146
            },
            "rightCorner": {
              "x": -2.847,
              "y": 31.074,
              "z": 1.146
            },
            "gtin": "8712561521840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7c8",
            "leftCorner": {
              "x": -2.847,
              "y": 31.084,
              "z": 1.146
            },
            "rightCorner": {
              "x": -2.94,
              "y": 31.089,
              "z": 1.146
            },
            "gtin": "8718114202372",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54660b",
        "height": 0.184,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20796",
            "leftCorner": {
              "x": -1.77,
              "y": 31.259,
              "z": 0.151
            },
            "rightCorner": {
              "x": -1.82,
              "y": 31.262,
              "z": 0.151
            },
            "gtin": "8720181192098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20797",
            "leftCorner": {
              "x": -1.82,
              "y": 31.262,
              "z": 0.151
            },
            "rightCorner": {
              "x": -1.869,
              "y": 31.265,
              "z": 0.151
            },
            "gtin": "8720181192098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20798",
            "leftCorner": {
              "x": -1.869,
              "y": 31.265,
              "z": 0.151
            },
            "rightCorner": {
              "x": -1.919,
              "y": 31.268,
              "z": 0.151
            },
            "gtin": "8720181192098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20799",
            "leftCorner": {
              "x": -1.919,
              "y": 31.268,
              "z": 0.151
            },
            "rightCorner": {
              "x": -1.968,
              "y": 31.271,
              "z": 0.151
            },
            "gtin": "8720181192098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2079b",
            "leftCorner": {
              "x": -1.97,
              "y": 31.235,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.017,
              "y": 31.238,
              "z": 0.151
            },
            "gtin": "8710847901768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2079c",
            "leftCorner": {
              "x": -2.017,
              "y": 31.238,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.065,
              "y": 31.24,
              "z": 0.151
            },
            "gtin": "8710847901768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2079d",
            "leftCorner": {
              "x": -2.065,
              "y": 31.24,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.112,
              "y": 31.243,
              "z": 0.151
            },
            "gtin": "8710847901768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2079e",
            "leftCorner": {
              "x": -2.113,
              "y": 31.23,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.171,
              "y": 31.234,
              "z": 0.151
            },
            "gtin": "8710522368541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2079f",
            "leftCorner": {
              "x": -2.171,
              "y": 31.234,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.23,
              "y": 31.236,
              "z": 0.151
            },
            "gtin": "8710522368541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207a0",
            "leftCorner": {
              "x": -2.23,
              "y": 31.236,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.289,
              "y": 31.24,
              "z": 0.151
            },
            "gtin": "8710522368541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207a1",
            "leftCorner": {
              "x": -2.289,
              "y": 31.252,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.334,
              "y": 31.254,
              "z": 0.151
            },
            "gtin": "8720181205378",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207a2",
            "leftCorner": {
              "x": -2.334,
              "y": 31.254,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.38,
              "y": 31.257,
              "z": 0.151
            },
            "gtin": "8720181205378",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207a3",
            "leftCorner": {
              "x": -2.379,
              "y": 31.274,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.425,
              "y": 31.277,
              "z": 0.151
            },
            "gtin": "8717163640777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207a4",
            "leftCorner": {
              "x": -2.425,
              "y": 31.277,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.471,
              "y": 31.28,
              "z": 0.151
            },
            "gtin": "8717163640777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207a5",
            "leftCorner": {
              "x": -2.471,
              "y": 31.28,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.517,
              "y": 31.283,
              "z": 0.151
            },
            "gtin": "8717163640777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207a6",
            "leftCorner": {
              "x": -2.519,
              "y": 31.241,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.566,
              "y": 31.244,
              "z": 0.151
            },
            "gtin": "8720181297564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207a7",
            "leftCorner": {
              "x": -2.566,
              "y": 31.244,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.612,
              "y": 31.246,
              "z": 0.151
            },
            "gtin": "8720181297564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207a8",
            "leftCorner": {
              "x": -2.611,
              "y": 31.263,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.674,
              "y": 31.266,
              "z": 0.151
            },
            "gtin": "8720181418402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207a9",
            "leftCorner": {
              "x": -2.674,
              "y": 31.266,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.737,
              "y": 31.27,
              "z": 0.151
            },
            "gtin": "8720181418402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207aa",
            "leftCorner": {
              "x": -2.737,
              "y": 31.28,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.77,
              "y": 31.282,
              "z": 0.151
            },
            "gtin": "8720181555626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207ab",
            "leftCorner": {
              "x": -2.77,
              "y": 31.282,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.804,
              "y": 31.284,
              "z": 0.151
            },
            "gtin": "8720181555626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207ac",
            "leftCorner": {
              "x": -2.804,
              "y": 31.284,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.837,
              "y": 31.286,
              "z": 0.151
            },
            "gtin": "8720181555626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207ad",
            "leftCorner": {
              "x": -2.837,
              "y": 31.289,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.869,
              "y": 31.29,
              "z": 0.151
            },
            "gtin": "4008268043674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207ae",
            "leftCorner": {
              "x": -2.869,
              "y": 31.29,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.9,
              "y": 31.292,
              "z": 0.151
            },
            "gtin": "4008268043674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2079a",
            "leftCorner": {
              "x": -2.9,
              "y": 31.3,
              "z": 0.151
            },
            "rightCorner": {
              "x": -2.97,
              "y": 31.305,
              "z": 0.151
            },
            "gtin": "4008268043568",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546609",
        "height": 0.44747,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f898",
            "leftCorner": {
              "x": -1.795,
              "y": 31.12,
              "z": 0.366
            },
            "rightCorner": {
              "x": -1.835,
              "y": 31.123,
              "z": 0.366
            },
            "gtin": "4006000094403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f899",
            "leftCorner": {
              "x": -1.835,
              "y": 31.123,
              "z": 0.366
            },
            "rightCorner": {
              "x": -1.876,
              "y": 31.125,
              "z": 0.366
            },
            "gtin": "4006000094403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f89a",
            "leftCorner": {
              "x": -1.876,
              "y": 31.125,
              "z": 0.366
            },
            "rightCorner": {
              "x": -1.916,
              "y": 31.127,
              "z": 0.366
            },
            "gtin": "4006000094403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f89b",
            "leftCorner": {
              "x": -1.916,
              "y": 31.126,
              "z": 0.366
            },
            "rightCorner": {
              "x": -1.973,
              "y": 31.13,
              "z": 0.366
            },
            "gtin": "4006000094328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f89c",
            "leftCorner": {
              "x": -1.973,
              "y": 31.13,
              "z": 0.366
            },
            "rightCorner": {
              "x": -2.03,
              "y": 31.133,
              "z": 0.366
            },
            "gtin": "4006000094328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f89d",
            "leftCorner": {
              "x": -2.03,
              "y": 31.133,
              "z": 0.366
            },
            "rightCorner": {
              "x": -2.086,
              "y": 31.136,
              "z": 0.366
            },
            "gtin": "4006000094328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f89e",
            "leftCorner": {
              "x": -2.086,
              "y": 31.136,
              "z": 0.366
            },
            "rightCorner": {
              "x": -2.143,
              "y": 31.14,
              "z": 0.366
            },
            "gtin": "4006000094328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f89f",
            "leftCorner": {
              "x": -2.142,
              "y": 31.154,
              "z": 0.366
            },
            "rightCorner": {
              "x": -2.198,
              "y": 31.156,
              "z": 0.366
            },
            "gtin": "4006000092775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8a0",
            "leftCorner": {
              "x": -2.198,
              "y": 31.156,
              "z": 0.366
            },
            "rightCorner": {
              "x": -2.253,
              "y": 31.16,
              "z": 0.366
            },
            "gtin": "4006000092775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8a1",
            "leftCorner": {
              "x": -2.253,
              "y": 31.16,
              "z": 0.366
            },
            "rightCorner": {
              "x": -2.308,
              "y": 31.163,
              "z": 0.366
            },
            "gtin": "4006000092775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8a2",
            "leftCorner": {
              "x": -2.309,
              "y": 31.152,
              "z": 0.366
            },
            "rightCorner": {
              "x": -2.362,
              "y": 31.156,
              "z": 0.366
            },
            "gtin": "4006000094212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8a3",
            "leftCorner": {
              "x": -2.362,
              "y": 31.156,
              "z": 0.366
            },
            "rightCorner": {
              "x": -2.415,
              "y": 31.159,
              "z": 0.366
            },
            "gtin": "4006000094212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8a4",
            "leftCorner": {
              "x": -2.415,
              "y": 31.159,
              "z": 0.366
            },
            "rightCorner": {
              "x": -2.468,
              "y": 31.161,
              "z": 0.366
            },
            "gtin": "4006000094212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8a5",
            "leftCorner": {
              "x": -2.468,
              "y": 31.168,
              "z": 0.366
            },
            "rightCorner": {
              "x": -2.544,
              "y": 31.173,
              "z": 0.366
            },
            "gtin": "4006000083070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8a6",
            "leftCorner": {
              "x": -2.544,
              "y": 31.173,
              "z": 0.366
            },
            "rightCorner": {
              "x": -2.62,
              "y": 31.178,
              "z": 0.366
            },
            "gtin": "4006000083070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8a7",
            "leftCorner": {
              "x": -2.62,
              "y": 31.179,
              "z": 0.366
            },
            "rightCorner": {
              "x": -2.671,
              "y": 31.182,
              "z": 0.366
            },
            "gtin": "4006000094175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8a8",
            "leftCorner": {
              "x": -2.671,
              "y": 31.182,
              "z": 0.366
            },
            "rightCorner": {
              "x": -2.721,
              "y": 31.186,
              "z": 0.366
            },
            "gtin": "4006000094175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8a9",
            "leftCorner": {
              "x": -2.721,
              "y": 31.186,
              "z": 0.366
            },
            "rightCorner": {
              "x": -2.772,
              "y": 31.188,
              "z": 0.366
            },
            "gtin": "4006000094175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8aa",
            "leftCorner": {
              "x": -2.771,
              "y": 31.197,
              "z": 0.366
            },
            "rightCorner": {
              "x": -2.828,
              "y": 31.201,
              "z": 0.366
            },
            "gtin": "4006000083117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8ab",
            "leftCorner": {
              "x": -2.828,
              "y": 31.201,
              "z": 0.366
            },
            "rightCorner": {
              "x": -2.885,
              "y": 31.204,
              "z": 0.366
            },
            "gtin": "4006000083117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8ac",
            "leftCorner": {
              "x": -2.886,
              "y": 31.2,
              "z": 0.366
            },
            "rightCorner": {
              "x": -2.948,
              "y": 31.204,
              "z": 0.366
            },
            "gtin": "4006000094526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8ad",
            "leftCorner": {
              "x": -2.948,
              "y": 31.204,
              "z": 0.366
            },
            "rightCorner": {
              "x": -3.011,
              "y": 31.207,
              "z": 0.366
            },
            "gtin": "4006000094526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8ae",
            "leftCorner": {
              "x": -3.011,
              "y": 31.207,
              "z": 0.366
            },
            "rightCorner": {
              "x": -3.073,
              "y": 31.211,
              "z": 0.366
            },
            "gtin": "4006000094526",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546607",
        "height": 0.69597,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f81f",
            "leftCorner": {
              "x": -1.749,
              "y": 31.119,
              "z": 0.569
            },
            "rightCorner": {
              "x": -1.844,
              "y": 31.125,
              "z": 0.569
            },
            "gtin": "3616302035465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f820",
            "leftCorner": {
              "x": -1.844,
              "y": 31.123,
              "z": 0.569
            },
            "rightCorner": {
              "x": -1.929,
              "y": 31.128,
              "z": 0.569
            },
            "gtin": "5050456007509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f821",
            "leftCorner": {
              "x": -1.929,
              "y": 31.128,
              "z": 0.569
            },
            "rightCorner": {
              "x": -2.014,
              "y": 31.133,
              "z": 0.569
            },
            "gtin": "5050456007509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f822",
            "leftCorner": {
              "x": -2.014,
              "y": 31.13,
              "z": 0.569
            },
            "rightCorner": {
              "x": -2.084,
              "y": 31.134,
              "z": 0.569
            },
            "gtin": "5050456006793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f823",
            "leftCorner": {
              "x": -2.084,
              "y": 31.134,
              "z": 0.569
            },
            "rightCorner": {
              "x": -2.155,
              "y": 31.138,
              "z": 0.569
            },
            "gtin": "5050456006793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f824",
            "leftCorner": {
              "x": -2.155,
              "y": 31.138,
              "z": 0.569
            },
            "rightCorner": {
              "x": -2.225,
              "y": 31.142,
              "z": 0.569
            },
            "gtin": "5050456006793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f825",
            "leftCorner": {
              "x": -2.225,
              "y": 31.14,
              "z": 0.569
            },
            "rightCorner": {
              "x": -2.264,
              "y": 31.142,
              "z": 0.569
            },
            "gtin": "5050456006823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f826",
            "leftCorner": {
              "x": -2.264,
              "y": 31.142,
              "z": 0.569
            },
            "rightCorner": {
              "x": -2.304,
              "y": 31.144,
              "z": 0.569
            },
            "gtin": "5050456006823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f827",
            "leftCorner": {
              "x": -2.304,
              "y": 31.144,
              "z": 0.569
            },
            "rightCorner": {
              "x": -2.343,
              "y": 31.146,
              "z": 0.569
            },
            "gtin": "5050456006823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f828",
            "leftCorner": {
              "x": -2.343,
              "y": 31.147,
              "z": 0.569
            },
            "rightCorner": {
              "x": -2.403,
              "y": 31.151,
              "z": 0.569
            },
            "gtin": "8710447493953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f829",
            "leftCorner": {
              "x": -2.403,
              "y": 31.151,
              "z": 0.569
            },
            "rightCorner": {
              "x": -2.463,
              "y": 31.155,
              "z": 0.569
            },
            "gtin": "8710447493953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f82a",
            "leftCorner": {
              "x": -2.463,
              "y": 31.158,
              "z": 0.569
            },
            "rightCorner": {
              "x": -2.536,
              "y": 31.163,
              "z": 0.569
            },
            "gtin": "8710447493915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f82b",
            "leftCorner": {
              "x": -2.535,
              "y": 31.174,
              "z": 0.569
            },
            "rightCorner": {
              "x": -2.589,
              "y": 31.177,
              "z": 0.569
            },
            "gtin": "8720181438752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f82c",
            "leftCorner": {
              "x": -2.589,
              "y": 31.177,
              "z": 0.569
            },
            "rightCorner": {
              "x": -2.643,
              "y": 31.181,
              "z": 0.569
            },
            "gtin": "8720181438752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f82d",
            "leftCorner": {
              "x": -2.643,
              "y": 31.181,
              "z": 0.569
            },
            "rightCorner": {
              "x": -2.698,
              "y": 31.184,
              "z": 0.569
            },
            "gtin": "8720181438752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f82e",
            "leftCorner": {
              "x": -2.698,
              "y": 31.184,
              "z": 0.569
            },
            "rightCorner": {
              "x": -2.752,
              "y": 31.187,
              "z": 0.569
            },
            "gtin": "8720181438752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f82f",
            "leftCorner": {
              "x": -2.752,
              "y": 31.187,
              "z": 0.569
            },
            "rightCorner": {
              "x": -2.796,
              "y": 31.188,
              "z": 0.569
            },
            "gtin": "8720181438769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f830",
            "leftCorner": {
              "x": -2.796,
              "y": 31.188,
              "z": 0.569
            },
            "rightCorner": {
              "x": -2.84,
              "y": 31.191,
              "z": 0.569
            },
            "gtin": "8720181438769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f831",
            "leftCorner": {
              "x": -2.84,
              "y": 31.191,
              "z": 0.569
            },
            "rightCorner": {
              "x": -2.885,
              "y": 31.194,
              "z": 0.569
            },
            "gtin": "8720181438769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f832",
            "leftCorner": {
              "x": -2.885,
              "y": 31.189,
              "z": 0.569
            },
            "rightCorner": {
              "x": -2.923,
              "y": 31.192,
              "z": 0.569
            },
            "gtin": "3600542227292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f833",
            "leftCorner": {
              "x": -2.923,
              "y": 31.192,
              "z": 0.569
            },
            "rightCorner": {
              "x": -2.961,
              "y": 31.193,
              "z": 0.569
            },
            "gtin": "3600542227292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f834",
            "leftCorner": {
              "x": -2.961,
              "y": 31.193,
              "z": 0.569
            },
            "rightCorner": {
              "x": -2.999,
              "y": 31.195,
              "z": 0.569
            },
            "gtin": "3600542227292",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54660a",
        "height": 0.95619,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f857",
            "leftCorner": {
              "x": -1.818,
              "y": 31.019,
              "z": 0.782
            },
            "rightCorner": {
              "x": -1.885,
              "y": 31.023,
              "z": 0.782
            },
            "gtin": "3600523715596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f858",
            "leftCorner": {
              "x": -1.885,
              "y": 31.023,
              "z": 0.782
            },
            "rightCorner": {
              "x": -1.953,
              "y": 31.027,
              "z": 0.782
            },
            "gtin": "3600523715596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f859",
            "leftCorner": {
              "x": -1.953,
              "y": 31.031,
              "z": 0.782
            },
            "rightCorner": {
              "x": -2.011,
              "y": 31.035,
              "z": 0.782
            },
            "gtin": "3600524027032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f85a",
            "leftCorner": {
              "x": -2.011,
              "y": 31.035,
              "z": 0.782
            },
            "rightCorner": {
              "x": -2.069,
              "y": 31.039,
              "z": 0.782
            },
            "gtin": "3600524027032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f85b",
            "leftCorner": {
              "x": -2.069,
              "y": 31.039,
              "z": 0.782
            },
            "rightCorner": {
              "x": -2.128,
              "y": 31.041,
              "z": 0.782
            },
            "gtin": "3600524027032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f85c",
            "leftCorner": {
              "x": -2.128,
              "y": 31.031,
              "z": 0.782
            },
            "rightCorner": {
              "x": -2.216,
              "y": 31.036,
              "z": 0.782
            },
            "gtin": "8720181570056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f85d",
            "leftCorner": {
              "x": -2.216,
              "y": 31.036,
              "z": 0.782
            },
            "rightCorner": {
              "x": -2.304,
              "y": 31.042,
              "z": 0.782
            },
            "gtin": "8720181570056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f85e",
            "leftCorner": {
              "x": -2.305,
              "y": 31.036,
              "z": 0.782
            },
            "rightCorner": {
              "x": -2.362,
              "y": 31.039,
              "z": 0.782
            },
            "gtin": "8720181284366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f85f",
            "leftCorner": {
              "x": -2.362,
              "y": 31.039,
              "z": 0.782
            },
            "rightCorner": {
              "x": -2.419,
              "y": 31.043,
              "z": 0.782
            },
            "gtin": "8720181284366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f860",
            "leftCorner": {
              "x": -2.419,
              "y": 31.043,
              "z": 0.782
            },
            "rightCorner": {
              "x": -2.476,
              "y": 31.046,
              "z": 0.782
            },
            "gtin": "8720181284366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f861",
            "leftCorner": {
              "x": -2.476,
              "y": 31.045,
              "z": 0.782
            },
            "rightCorner": {
              "x": -2.569,
              "y": 31.051,
              "z": 0.782
            },
            "gtin": "8712561254595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f862",
            "leftCorner": {
              "x": -2.569,
              "y": 31.054,
              "z": 0.782
            },
            "rightCorner": {
              "x": -2.666,
              "y": 31.06,
              "z": 0.782
            },
            "gtin": "8720181296642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f863",
            "leftCorner": {
              "x": -2.666,
              "y": 31.06,
              "z": 0.782
            },
            "rightCorner": {
              "x": -2.762,
              "y": 31.065,
              "z": 0.782
            },
            "gtin": "8720181296642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f864",
            "leftCorner": {
              "x": -2.762,
              "y": 31.072,
              "z": 0.782
            },
            "rightCorner": {
              "x": -2.87,
              "y": 31.078,
              "z": 0.782
            },
            "gtin": "8720181340574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f865",
            "leftCorner": {
              "x": -2.869,
              "y": 31.082,
              "z": 0.782
            },
            "rightCorner": {
              "x": -2.928,
              "y": 31.086,
              "z": 0.782
            },
            "gtin": "4005900982209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f866",
            "leftCorner": {
              "x": -2.928,
              "y": 31.086,
              "z": 0.782
            },
            "rightCorner": {
              "x": -2.986,
              "y": 31.088,
              "z": 0.782
            },
            "gtin": "4005900982209",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546606",
        "height": 1.2013,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f7ec",
            "leftCorner": {
              "x": -1.747,
              "y": 31.018,
              "z": 0.983
            },
            "rightCorner": {
              "x": -1.836,
              "y": 31.024,
              "z": 0.983
            },
            "gtin": "42449751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7ed",
            "leftCorner": {
              "x": -1.836,
              "y": 31.023,
              "z": 0.983
            },
            "rightCorner": {
              "x": -1.893,
              "y": 31.026,
              "z": 0.983
            },
            "gtin": "42449744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7ee",
            "leftCorner": {
              "x": -1.893,
              "y": 31.026,
              "z": 0.983
            },
            "rightCorner": {
              "x": -1.95,
              "y": 31.029,
              "z": 0.983
            },
            "gtin": "42449744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7ef",
            "leftCorner": {
              "x": -1.95,
              "y": 31.029,
              "z": 0.983
            },
            "rightCorner": {
              "x": -2.165,
              "y": 31.042,
              "z": 0.983
            },
            "gtin": "59092575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7f0",
            "leftCorner": {
              "x": -2.166,
              "y": 31.035,
              "z": 0.983
            },
            "rightCorner": {
              "x": -2.292,
              "y": 31.042,
              "z": 0.983
            },
            "gtin": "59095927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7f1",
            "leftCorner": {
              "x": -2.29,
              "y": 31.079,
              "z": 0.983
            },
            "rightCorner": {
              "x": -2.46,
              "y": 31.089,
              "z": 0.983
            },
            "gtin": "59083856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7f2",
            "leftCorner": {
              "x": -2.462,
              "y": 31.069,
              "z": 0.983
            },
            "rightCorner": {
              "x": -2.521,
              "y": 31.073,
              "z": 0.983
            },
            "gtin": "59095842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7f3",
            "leftCorner": {
              "x": -2.521,
              "y": 31.073,
              "z": 0.983
            },
            "rightCorner": {
              "x": -2.581,
              "y": 31.075,
              "z": 0.983
            },
            "gtin": "59095842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7f4",
            "leftCorner": {
              "x": -2.581,
              "y": 31.075,
              "z": 0.983
            },
            "rightCorner": {
              "x": -2.641,
              "y": 31.079,
              "z": 0.983
            },
            "gtin": "59095842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7f5",
            "leftCorner": {
              "x": -2.641,
              "y": 31.075,
              "z": 0.983
            },
            "rightCorner": {
              "x": -2.776,
              "y": 31.083,
              "z": 0.983
            },
            "gtin": "42449317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7f6",
            "leftCorner": {
              "x": -2.776,
              "y": 31.076,
              "z": 0.983
            },
            "rightCorner": {
              "x": -2.909,
              "y": 31.083,
              "z": 0.983
            },
            "gtin": "42449386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7f7",
            "leftCorner": {
              "x": -2.909,
              "y": 31.085,
              "z": 0.983
            },
            "rightCorner": {
              "x": -2.952,
              "y": 31.088,
              "z": 0.983
            },
            "gtin": "42449300",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546605",
        "height": 1.6098,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20784",
            "leftCorner": {
              "x": -1.755,
              "y": 31.022,
              "z": 1.317
            },
            "rightCorner": {
              "x": -1.826,
              "y": 31.026,
              "z": 1.317
            },
            "gtin": "3600524093068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20785",
            "leftCorner": {
              "x": -1.826,
              "y": 31.017,
              "z": 1.317
            },
            "rightCorner": {
              "x": -1.968,
              "y": 31.025,
              "z": 1.317
            },
            "gtin": "3600523741588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20786",
            "leftCorner": {
              "x": -1.968,
              "y": 31.032,
              "z": 1.317
            },
            "rightCorner": {
              "x": -2.011,
              "y": 31.034,
              "z": 1.317
            },
            "gtin": "3600523741540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20787",
            "leftCorner": {
              "x": -2.011,
              "y": 31.034,
              "z": 1.317
            },
            "rightCorner": {
              "x": -2.053,
              "y": 31.037,
              "z": 1.317
            },
            "gtin": "3600523741540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20788",
            "leftCorner": {
              "x": -2.054,
              "y": 31.026,
              "z": 1.317
            },
            "rightCorner": {
              "x": -2.121,
              "y": 31.029,
              "z": 1.317
            },
            "gtin": "3600523741427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20789",
            "leftCorner": {
              "x": -2.121,
              "y": 31.029,
              "z": 1.317
            },
            "rightCorner": {
              "x": -2.189,
              "y": 31.033,
              "z": 1.317
            },
            "gtin": "3600523741427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2078a",
            "leftCorner": {
              "x": -2.187,
              "y": 31.057,
              "z": 1.317
            },
            "rightCorner": {
              "x": -2.255,
              "y": 31.062,
              "z": 1.317
            },
            "gtin": "8720181452628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2078b",
            "leftCorner": {
              "x": -2.255,
              "y": 31.051,
              "z": 1.317
            },
            "rightCorner": {
              "x": -2.325,
              "y": 31.055,
              "z": 1.317
            },
            "gtin": "8720181452604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2078c",
            "leftCorner": {
              "x": -2.326,
              "y": 31.034,
              "z": 1.317
            },
            "rightCorner": {
              "x": -2.38,
              "y": 31.037,
              "z": 1.317
            },
            "gtin": "4006000131467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2078d",
            "leftCorner": {
              "x": -2.38,
              "y": 31.037,
              "z": 1.317
            },
            "rightCorner": {
              "x": -2.434,
              "y": 31.04,
              "z": 1.317
            },
            "gtin": "4006000131467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2078e",
            "leftCorner": {
              "x": -2.433,
              "y": 31.056,
              "z": 1.317
            },
            "rightCorner": {
              "x": -2.5,
              "y": 31.06,
              "z": 1.317
            },
            "gtin": "4006000131801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2078f",
            "leftCorner": {
              "x": -2.5,
              "y": 31.06,
              "z": 1.317
            },
            "rightCorner": {
              "x": -2.567,
              "y": 31.065,
              "z": 1.317
            },
            "gtin": "4006000131801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20790",
            "leftCorner": {
              "x": -2.567,
              "y": 31.065,
              "z": 1.317
            },
            "rightCorner": {
              "x": -2.634,
              "y": 31.068,
              "z": 1.317
            },
            "gtin": "4006000131801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20791",
            "leftCorner": {
              "x": -2.633,
              "y": 31.08,
              "z": 1.317
            },
            "rightCorner": {
              "x": -2.691,
              "y": 31.083,
              "z": 1.317
            },
            "gtin": "4006000121062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20792",
            "leftCorner": {
              "x": -2.691,
              "y": 31.083,
              "z": 1.317
            },
            "rightCorner": {
              "x": -2.748,
              "y": 31.087,
              "z": 1.317
            },
            "gtin": "4006000121062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20793",
            "leftCorner": {
              "x": -2.748,
              "y": 31.087,
              "z": 1.317
            },
            "rightCorner": {
              "x": -2.806,
              "y": 31.09,
              "z": 1.317
            },
            "gtin": "4006000121062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20794",
            "leftCorner": {
              "x": -2.806,
              "y": 31.077,
              "z": 1.317
            },
            "rightCorner": {
              "x": -2.848,
              "y": 31.08,
              "z": 1.317
            },
            "gtin": "4006000127767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20795",
            "leftCorner": {
              "x": -2.848,
              "y": 31.08,
              "z": 1.317
            },
            "rightCorner": {
              "x": -2.889,
              "y": 31.082,
              "z": 1.317
            },
            "gtin": "4006000127767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20774",
            "leftCorner": {
              "x": -2.889,
              "y": 31.08,
              "z": 1.317
            },
            "rightCorner": {
              "x": -2.983,
              "y": 31.086,
              "z": 1.317
            },
            "gtin": "4001638097079",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d4e",
    "rightNeighborShelfId": "a6d53"
  },
  {
    "id": "a6d53",
    "name": "a6d53",
    "x": -2.968,
    "y": 31.338,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99957,
      "w": 0.029317
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 108
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a54651c",
        "height": 0.16698,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f910",
            "leftCorner": {
              "x": -2.968,
              "y": 31.335,
              "z": 0.137
            },
            "rightCorner": {
              "x": -3.015,
              "y": 31.338,
              "z": 0.137
            },
            "gtin": "4015100429060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f911",
            "leftCorner": {
              "x": -3.015,
              "y": 31.338,
              "z": 0.137
            },
            "rightCorner": {
              "x": -3.063,
              "y": 31.34,
              "z": 0.137
            },
            "gtin": "4015100429060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f912",
            "leftCorner": {
              "x": -3.063,
              "y": 31.34,
              "z": 0.137
            },
            "rightCorner": {
              "x": -3.11,
              "y": 31.344,
              "z": 0.137
            },
            "gtin": "4015100429060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f913",
            "leftCorner": {
              "x": -3.11,
              "y": 31.344,
              "z": 0.137
            },
            "rightCorner": {
              "x": -3.157,
              "y": 31.347,
              "z": 0.137
            },
            "gtin": "4015100429060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f918",
            "leftCorner": {
              "x": -3.16,
              "y": 31.304,
              "z": 0.137
            },
            "rightCorner": {
              "x": -3.217,
              "y": 31.308,
              "z": 0.137
            },
            "gtin": "4015100429121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f919",
            "leftCorner": {
              "x": -3.217,
              "y": 31.308,
              "z": 0.137
            },
            "rightCorner": {
              "x": -3.274,
              "y": 31.311,
              "z": 0.137
            },
            "gtin": "4015100429121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f91a",
            "leftCorner": {
              "x": -3.274,
              "y": 31.311,
              "z": 0.137
            },
            "rightCorner": {
              "x": -3.332,
              "y": 31.314,
              "z": 0.137
            },
            "gtin": "4015100429121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f91b",
            "leftCorner": {
              "x": -3.332,
              "y": 31.314,
              "z": 0.137
            },
            "rightCorner": {
              "x": -3.389,
              "y": 31.318,
              "z": 0.137
            },
            "gtin": "4015100429121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f91c",
            "leftCorner": {
              "x": -3.389,
              "y": 31.318,
              "z": 0.137
            },
            "rightCorner": {
              "x": -3.447,
              "y": 31.321,
              "z": 0.137
            },
            "gtin": "4015100429121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f91d",
            "leftCorner": {
              "x": -3.446,
              "y": 31.335,
              "z": 0.137
            },
            "rightCorner": {
              "x": -3.501,
              "y": 31.339,
              "z": 0.137
            },
            "gtin": "4015100429107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f91e",
            "leftCorner": {
              "x": -3.501,
              "y": 31.339,
              "z": 0.137
            },
            "rightCorner": {
              "x": -3.555,
              "y": 31.343,
              "z": 0.137
            },
            "gtin": "4015100429107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f91f",
            "leftCorner": {
              "x": -3.555,
              "y": 31.343,
              "z": 0.137
            },
            "rightCorner": {
              "x": -3.61,
              "y": 31.345,
              "z": 0.137
            },
            "gtin": "4015100429107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f920",
            "leftCorner": {
              "x": -3.61,
              "y": 31.345,
              "z": 0.137
            },
            "rightCorner": {
              "x": -3.664,
              "y": 31.349,
              "z": 0.137
            },
            "gtin": "4015100429107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f921",
            "leftCorner": {
              "x": -3.664,
              "y": 31.349,
              "z": 0.137
            },
            "rightCorner": {
              "x": -3.719,
              "y": 31.352,
              "z": 0.137
            },
            "gtin": "4015100429107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f922",
            "leftCorner": {
              "x": -3.719,
              "y": 31.346,
              "z": 0.137
            },
            "rightCorner": {
              "x": -3.797,
              "y": 31.351,
              "z": 0.137
            },
            "gtin": "4015100429084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f923",
            "leftCorner": {
              "x": -3.797,
              "y": 31.351,
              "z": 0.137
            },
            "rightCorner": {
              "x": -3.875,
              "y": 31.356,
              "z": 0.137
            },
            "gtin": "4015100429084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f924",
            "leftCorner": {
              "x": -3.875,
              "y": 31.356,
              "z": 0.137
            },
            "rightCorner": {
              "x": -3.953,
              "y": 31.36,
              "z": 0.137
            },
            "gtin": "4015100429084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f925",
            "leftCorner": {
              "x": -3.954,
              "y": 31.345,
              "z": 0.137
            },
            "rightCorner": {
              "x": -4.001,
              "y": 31.348,
              "z": 0.137
            },
            "gtin": "4015100428940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f926",
            "leftCorner": {
              "x": -4.001,
              "y": 31.348,
              "z": 0.137
            },
            "rightCorner": {
              "x": -4.049,
              "y": 31.351,
              "z": 0.137
            },
            "gtin": "4015100428940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f927",
            "leftCorner": {
              "x": -4.049,
              "y": 31.351,
              "z": 0.137
            },
            "rightCorner": {
              "x": -4.097,
              "y": 31.354,
              "z": 0.137
            },
            "gtin": "4015100428940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f928",
            "leftCorner": {
              "x": -4.097,
              "y": 31.354,
              "z": 0.137
            },
            "rightCorner": {
              "x": -4.146,
              "y": 31.356,
              "z": 0.137
            },
            "gtin": "4015100428940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f929",
            "leftCorner": {
              "x": -4.146,
              "y": 31.356,
              "z": 0.137
            },
            "rightCorner": {
              "x": -4.193,
              "y": 31.36,
              "z": 0.137
            },
            "gtin": "4015100428940",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54651b",
        "height": 0.45263,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f8af",
            "leftCorner": {
              "x": -3.073,
              "y": 31.205,
              "z": 0.37
            },
            "rightCorner": {
              "x": -3.182,
              "y": 31.211,
              "z": 0.37
            },
            "gtin": "4006000150277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8b0",
            "leftCorner": {
              "x": -3.182,
              "y": 31.211,
              "z": 0.37
            },
            "rightCorner": {
              "x": -3.29,
              "y": 31.217,
              "z": 0.37
            },
            "gtin": "4006000150277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8b1",
            "leftCorner": {
              "x": -3.29,
              "y": 31.212,
              "z": 0.37
            },
            "rightCorner": {
              "x": -3.353,
              "y": 31.215,
              "z": 0.37
            },
            "gtin": "4006000092706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8b2",
            "leftCorner": {
              "x": -3.353,
              "y": 31.215,
              "z": 0.37
            },
            "rightCorner": {
              "x": -3.416,
              "y": 31.219,
              "z": 0.37
            },
            "gtin": "4006000092706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8b3",
            "leftCorner": {
              "x": -3.416,
              "y": 31.219,
              "z": 0.37
            },
            "rightCorner": {
              "x": -3.478,
              "y": 31.223,
              "z": 0.37
            },
            "gtin": "4006000092706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8b4",
            "leftCorner": {
              "x": -3.478,
              "y": 31.231,
              "z": 0.37
            },
            "rightCorner": {
              "x": -3.584,
              "y": 31.237,
              "z": 0.37
            },
            "gtin": "4006000092584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8b5",
            "leftCorner": {
              "x": -3.583,
              "y": 31.239,
              "z": 0.37
            },
            "rightCorner": {
              "x": -3.643,
              "y": 31.243,
              "z": 0.37
            },
            "gtin": "4006000092898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8b6",
            "leftCorner": {
              "x": -3.643,
              "y": 31.243,
              "z": 0.37
            },
            "rightCorner": {
              "x": -3.702,
              "y": 31.246,
              "z": 0.37
            },
            "gtin": "4006000092898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8b7",
            "leftCorner": {
              "x": -3.702,
              "y": 31.246,
              "z": 0.37
            },
            "rightCorner": {
              "x": -3.762,
              "y": 31.249,
              "z": 0.37
            },
            "gtin": "4006000092898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8b8",
            "leftCorner": {
              "x": -3.763,
              "y": 31.234,
              "z": 0.37
            },
            "rightCorner": {
              "x": -3.865,
              "y": 31.24,
              "z": 0.37
            },
            "gtin": "4006000092621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8b9",
            "leftCorner": {
              "x": -3.865,
              "y": 31.24,
              "z": 0.37
            },
            "rightCorner": {
              "x": -3.967,
              "y": 31.246,
              "z": 0.37
            },
            "gtin": "4006000092621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8ba",
            "leftCorner": {
              "x": -3.967,
              "y": 31.246,
              "z": 0.37
            },
            "rightCorner": {
              "x": -4.069,
              "y": 31.252,
              "z": 0.37
            },
            "gtin": "4006000092621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8bb",
            "leftCorner": {
              "x": -4.069,
              "y": 31.252,
              "z": 0.37
            },
            "rightCorner": {
              "x": -4.171,
              "y": 31.258,
              "z": 0.37
            },
            "gtin": "4006000092621",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546519",
        "height": 0.70263,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f835",
            "leftCorner": {
              "x": -2.999,
              "y": 31.202,
              "z": 0.575
            },
            "rightCorner": {
              "x": -3.046,
              "y": 31.206,
              "z": 0.575
            },
            "gtin": "3600542227308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f836",
            "leftCorner": {
              "x": -3.046,
              "y": 31.206,
              "z": 0.575
            },
            "rightCorner": {
              "x": -3.094,
              "y": 31.208,
              "z": 0.575
            },
            "gtin": "3600542227308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f837",
            "leftCorner": {
              "x": -3.094,
              "y": 31.208,
              "z": 0.575
            },
            "rightCorner": {
              "x": -3.141,
              "y": 31.211,
              "z": 0.575
            },
            "gtin": "3600542227308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f838",
            "leftCorner": {
              "x": -3.141,
              "y": 31.212,
              "z": 0.575
            },
            "rightCorner": {
              "x": -3.224,
              "y": 31.217,
              "z": 0.575
            },
            "gtin": "8720181437762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f839",
            "leftCorner": {
              "x": -3.224,
              "y": 31.221,
              "z": 0.575
            },
            "rightCorner": {
              "x": -3.302,
              "y": 31.226,
              "z": 0.575
            },
            "gtin": "8720181452567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f83a",
            "leftCorner": {
              "x": -3.302,
              "y": 31.222,
              "z": 0.575
            },
            "rightCorner": {
              "x": -3.374,
              "y": 31.226,
              "z": 0.575
            },
            "gtin": "8720181437731",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f83b",
            "leftCorner": {
              "x": -3.374,
              "y": 31.226,
              "z": 0.575
            },
            "rightCorner": {
              "x": -3.446,
              "y": 31.23,
              "z": 0.575
            },
            "gtin": "8720181437731",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f83c",
            "leftCorner": {
              "x": -3.446,
              "y": 31.232,
              "z": 0.575
            },
            "rightCorner": {
              "x": -3.504,
              "y": 31.235,
              "z": 0.575
            },
            "gtin": "8720181438646",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f83d",
            "leftCorner": {
              "x": -3.504,
              "y": 31.235,
              "z": 0.575
            },
            "rightCorner": {
              "x": -3.562,
              "y": 31.239,
              "z": 0.575
            },
            "gtin": "8720181438646",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f83e",
            "leftCorner": {
              "x": -3.562,
              "y": 31.239,
              "z": 0.575
            },
            "rightCorner": {
              "x": -3.62,
              "y": 31.243,
              "z": 0.575
            },
            "gtin": "8720181438646",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f83f",
            "leftCorner": {
              "x": -3.621,
              "y": 31.235,
              "z": 0.575
            },
            "rightCorner": {
              "x": -3.676,
              "y": 31.237,
              "z": 0.575
            },
            "gtin": "8710447492239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f840",
            "leftCorner": {
              "x": -3.676,
              "y": 31.237,
              "z": 0.575
            },
            "rightCorner": {
              "x": -3.731,
              "y": 31.241,
              "z": 0.575
            },
            "gtin": "8710447492239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f841",
            "leftCorner": {
              "x": -3.731,
              "y": 31.242,
              "z": 0.575
            },
            "rightCorner": {
              "x": -3.82,
              "y": 31.247,
              "z": 0.575
            },
            "gtin": "8720181005749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f842",
            "leftCorner": {
              "x": -3.82,
              "y": 31.247,
              "z": 0.575
            },
            "rightCorner": {
              "x": -3.909,
              "y": 31.252,
              "z": 0.575
            },
            "gtin": "8720181005749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f843",
            "leftCorner": {
              "x": -3.909,
              "y": 31.243,
              "z": 0.575
            },
            "rightCorner": {
              "x": -3.982,
              "y": 31.248,
              "z": 0.575
            },
            "gtin": "8710447492246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f844",
            "leftCorner": {
              "x": -3.982,
              "y": 31.248,
              "z": 0.575
            },
            "rightCorner": {
              "x": -4.055,
              "y": 31.251,
              "z": 0.575
            },
            "gtin": "8710447492246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f80f",
            "leftCorner": {
              "x": -4.055,
              "y": 31.258,
              "z": 0.575
            },
            "rightCorner": {
              "x": -4.174,
              "y": 31.265,
              "z": 0.575
            },
            "gtin": "8710447492253",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54651a",
        "height": 0.94811,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f867",
            "leftCorner": {
              "x": -2.985,
              "y": 31.104,
              "z": 0.776
            },
            "rightCorner": {
              "x": -3.047,
              "y": 31.107,
              "z": 0.776
            },
            "gtin": "3616304693748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f868",
            "leftCorner": {
              "x": -3.047,
              "y": 31.107,
              "z": 0.776
            },
            "rightCorner": {
              "x": -3.109,
              "y": 31.111,
              "z": 0.776
            },
            "gtin": "3616304693748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f869",
            "leftCorner": {
              "x": -3.11,
              "y": 31.096,
              "z": 0.776
            },
            "rightCorner": {
              "x": -3.15,
              "y": 31.098,
              "z": 0.776
            },
            "gtin": "3616303842192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f86a",
            "leftCorner": {
              "x": -3.15,
              "y": 31.098,
              "z": 0.776
            },
            "rightCorner": {
              "x": -3.19,
              "y": 31.101,
              "z": 0.776
            },
            "gtin": "3616303842192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f86b",
            "leftCorner": {
              "x": -3.19,
              "y": 31.116,
              "z": 0.776
            },
            "rightCorner": {
              "x": -3.241,
              "y": 31.12,
              "z": 0.776
            },
            "gtin": "3616303842314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f86c",
            "leftCorner": {
              "x": -3.241,
              "y": 31.12,
              "z": 0.776
            },
            "rightCorner": {
              "x": -3.292,
              "y": 31.122,
              "z": 0.776
            },
            "gtin": "3616303842314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f86d",
            "leftCorner": {
              "x": -3.292,
              "y": 31.122,
              "z": 0.776
            },
            "rightCorner": {
              "x": -3.343,
              "y": 31.125,
              "z": 0.776
            },
            "gtin": "3616303842314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f86e",
            "leftCorner": {
              "x": -3.343,
              "y": 31.115,
              "z": 0.776
            },
            "rightCorner": {
              "x": -3.433,
              "y": 31.121,
              "z": 0.776
            },
            "gtin": "3616303440428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f86f",
            "leftCorner": {
              "x": -3.433,
              "y": 31.121,
              "z": 0.776
            },
            "rightCorner": {
              "x": -3.522,
              "y": 31.127,
              "z": 0.776
            },
            "gtin": "3616303440428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f870",
            "leftCorner": {
              "x": -3.522,
              "y": 31.131,
              "z": 0.776
            },
            "rightCorner": {
              "x": -3.607,
              "y": 31.136,
              "z": 0.776
            },
            "gtin": "3616303441067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f871",
            "leftCorner": {
              "x": -3.606,
              "y": 31.154,
              "z": 0.776
            },
            "rightCorner": {
              "x": -3.668,
              "y": 31.157,
              "z": 0.776
            },
            "gtin": "3616303440800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f872",
            "leftCorner": {
              "x": -3.668,
              "y": 31.157,
              "z": 0.776
            },
            "rightCorner": {
              "x": -3.73,
              "y": 31.161,
              "z": 0.776
            },
            "gtin": "3616303440800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f873",
            "leftCorner": {
              "x": -3.731,
              "y": 31.137,
              "z": 0.776
            },
            "rightCorner": {
              "x": -3.806,
              "y": 31.141,
              "z": 0.776
            },
            "gtin": "3616303441586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f874",
            "leftCorner": {
              "x": -3.806,
              "y": 31.141,
              "z": 0.776
            },
            "rightCorner": {
              "x": -3.88,
              "y": 31.146,
              "z": 0.776
            },
            "gtin": "3616303441586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f875",
            "leftCorner": {
              "x": -3.881,
              "y": 31.143,
              "z": 0.776
            },
            "rightCorner": {
              "x": -3.963,
              "y": 31.148,
              "z": 0.776
            },
            "gtin": "3616303440558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f876",
            "leftCorner": {
              "x": -3.963,
              "y": 31.148,
              "z": 0.776
            },
            "rightCorner": {
              "x": -4.045,
              "y": 31.152,
              "z": 0.776
            },
            "gtin": "3616303440558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f877",
            "leftCorner": {
              "x": -4.045,
              "y": 31.148,
              "z": 0.776
            },
            "rightCorner": {
              "x": -4.146,
              "y": 31.154,
              "z": 0.776
            },
            "gtin": "4005900982162",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546518",
        "height": 1.2001,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f7f8",
            "leftCorner": {
              "x": -2.951,
              "y": 31.1,
              "z": 0.982
            },
            "rightCorner": {
              "x": -3.029,
              "y": 31.105,
              "z": 0.982
            },
            "gtin": "42467175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7f9",
            "leftCorner": {
              "x": -3.028,
              "y": 31.134,
              "z": 0.982
            },
            "rightCorner": {
              "x": -3.09,
              "y": 31.138,
              "z": 0.982
            },
            "gtin": "42449720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7fa",
            "leftCorner": {
              "x": -3.092,
              "y": 31.105,
              "z": 0.982
            },
            "rightCorner": {
              "x": -3.174,
              "y": 31.109,
              "z": 0.982
            },
            "gtin": "42389651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7fb",
            "leftCorner": {
              "x": -3.174,
              "y": 31.102,
              "z": 0.982
            },
            "rightCorner": {
              "x": -3.301,
              "y": 31.109,
              "z": 0.982
            },
            "gtin": "42449324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7fc",
            "leftCorner": {
              "x": -3.301,
              "y": 31.109,
              "z": 0.982
            },
            "rightCorner": {
              "x": -3.428,
              "y": 31.117,
              "z": 0.982
            },
            "gtin": "42449324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7fd",
            "leftCorner": {
              "x": -3.428,
              "y": 31.117,
              "z": 0.982
            },
            "rightCorner": {
              "x": -3.555,
              "y": 31.124,
              "z": 0.982
            },
            "gtin": "42449324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7fe",
            "leftCorner": {
              "x": -3.555,
              "y": 31.124,
              "z": 0.982
            },
            "rightCorner": {
              "x": -3.682,
              "y": 31.132,
              "z": 0.982
            },
            "gtin": "42449324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7ff",
            "leftCorner": {
              "x": -3.682,
              "y": 31.139,
              "z": 0.982
            },
            "rightCorner": {
              "x": -3.801,
              "y": 31.146,
              "z": 0.982
            },
            "gtin": "42449270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f800",
            "leftCorner": {
              "x": -3.801,
              "y": 31.146,
              "z": 0.982
            },
            "rightCorner": {
              "x": -3.919,
              "y": 31.153,
              "z": 0.982
            },
            "gtin": "42449270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f801",
            "leftCorner": {
              "x": -3.919,
              "y": 31.149,
              "z": 0.982
            },
            "rightCorner": {
              "x": -4.053,
              "y": 31.158,
              "z": 0.982
            },
            "gtin": "42449492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f802",
            "leftCorner": {
              "x": -4.052,
              "y": 31.17,
              "z": 0.982
            },
            "rightCorner": {
              "x": -4.126,
              "y": 31.174,
              "z": 0.982
            },
            "gtin": "42449263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f803",
            "leftCorner": {
              "x": -4.126,
              "y": 31.174,
              "z": 0.982
            },
            "rightCorner": {
              "x": -4.2,
              "y": 31.179,
              "z": 0.982
            },
            "gtin": "42449263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f804",
            "leftCorner": {
              "x": -4.2,
              "y": 31.179,
              "z": 0.982
            },
            "rightCorner": {
              "x": -4.274,
              "y": 31.183,
              "z": 0.982
            },
            "gtin": "42449263",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546517",
        "height": 1.4005,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f7c9",
            "leftCorner": {
              "x": -2.94,
              "y": 31.095,
              "z": 1.146
            },
            "rightCorner": {
              "x": -3.037,
              "y": 31.101,
              "z": 1.146
            },
            "gtin": "59097976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7ca",
            "leftCorner": {
              "x": -3.036,
              "y": 31.119,
              "z": 1.146
            },
            "rightCorner": {
              "x": -3.133,
              "y": 31.124,
              "z": 1.146
            },
            "gtin": "8720181452567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7cb",
            "leftCorner": {
              "x": -3.133,
              "y": 31.113,
              "z": 1.146
            },
            "rightCorner": {
              "x": -3.184,
              "y": 31.116,
              "z": 1.146
            },
            "gtin": "8720181452581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7cc",
            "leftCorner": {
              "x": -3.184,
              "y": 31.116,
              "z": 1.146
            },
            "rightCorner": {
              "x": -3.236,
              "y": 31.118,
              "z": 1.146
            },
            "gtin": "8720181452581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7cd",
            "leftCorner": {
              "x": -3.237,
              "y": 31.093,
              "z": 1.146
            },
            "rightCorner": {
              "x": -3.345,
              "y": 31.1,
              "z": 1.146
            },
            "gtin": "8720181452574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7ce",
            "leftCorner": {
              "x": -3.344,
              "y": 31.129,
              "z": 1.146
            },
            "rightCorner": {
              "x": -3.574,
              "y": 31.142,
              "z": 1.146
            },
            "gtin": "42449393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7cf",
            "leftCorner": {
              "x": -3.574,
              "y": 31.143,
              "z": 1.146
            },
            "rightCorner": {
              "x": -3.72,
              "y": 31.152,
              "z": 1.146
            },
            "gtin": "42449423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7d0",
            "leftCorner": {
              "x": -3.72,
              "y": 31.153,
              "z": 1.146
            },
            "rightCorner": {
              "x": -3.793,
              "y": 31.158,
              "z": 1.146
            },
            "gtin": "4006000111537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7d1",
            "leftCorner": {
              "x": -3.794,
              "y": 31.145,
              "z": 1.146
            },
            "rightCorner": {
              "x": -3.834,
              "y": 31.146,
              "z": 1.146
            },
            "gtin": "42449881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7d2",
            "leftCorner": {
              "x": -3.834,
              "y": 31.144,
              "z": 1.146
            },
            "rightCorner": {
              "x": -3.891,
              "y": 31.148,
              "z": 1.146
            },
            "gtin": "42449775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7d3",
            "leftCorner": {
              "x": -3.891,
              "y": 31.148,
              "z": 1.146
            },
            "rightCorner": {
              "x": -3.947,
              "y": 31.152,
              "z": 1.146
            },
            "gtin": "42449775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7d4",
            "leftCorner": {
              "x": -3.947,
              "y": 31.144,
              "z": 1.146
            },
            "rightCorner": {
              "x": -4.034,
              "y": 31.149,
              "z": 1.146
            },
            "gtin": "59097891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7d5",
            "leftCorner": {
              "x": -4.034,
              "y": 31.149,
              "z": 1.146
            },
            "rightCorner": {
              "x": -4.12,
              "y": 31.154,
              "z": 1.146
            },
            "gtin": "59097891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7d6",
            "leftCorner": {
              "x": -4.119,
              "y": 31.17,
              "z": 1.146
            },
            "rightCorner": {
              "x": -4.152,
              "y": 31.171,
              "z": 1.146
            },
            "gtin": "59097976",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546516",
        "height": 1.599,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f794",
            "leftCorner": {
              "x": -3.011,
              "y": 31.11,
              "z": 1.308
            },
            "rightCorner": {
              "x": -3.107,
              "y": 31.115,
              "z": 1.308
            },
            "gtin": "4001638500203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f795",
            "leftCorner": {
              "x": -3.107,
              "y": 31.102,
              "z": 1.308
            },
            "rightCorner": {
              "x": -3.29,
              "y": 31.113,
              "z": 1.308
            },
            "gtin": "4063367265891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f796",
            "leftCorner": {
              "x": -3.29,
              "y": 31.106,
              "z": 1.308
            },
            "rightCorner": {
              "x": -3.336,
              "y": 31.109,
              "z": 1.308
            },
            "gtin": "4068829441509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f797",
            "leftCorner": {
              "x": -3.336,
              "y": 31.109,
              "z": 1.308
            },
            "rightCorner": {
              "x": -3.382,
              "y": 31.111,
              "z": 1.308
            },
            "gtin": "4068829441509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f798",
            "leftCorner": {
              "x": -3.381,
              "y": 31.116,
              "z": 1.308
            },
            "rightCorner": {
              "x": -3.455,
              "y": 31.121,
              "z": 1.308
            },
            "gtin": "4068829441608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f799",
            "leftCorner": {
              "x": -3.455,
              "y": 31.121,
              "z": 1.308
            },
            "rightCorner": {
              "x": -3.529,
              "y": 31.124,
              "z": 1.308
            },
            "gtin": "4068829441608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f79a",
            "leftCorner": {
              "x": -3.529,
              "y": 31.124,
              "z": 1.308
            },
            "rightCorner": {
              "x": -3.602,
              "y": 31.129,
              "z": 1.308
            },
            "gtin": "4068829441608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f79b",
            "leftCorner": {
              "x": -3.602,
              "y": 31.134,
              "z": 1.308
            },
            "rightCorner": {
              "x": -3.693,
              "y": 31.14,
              "z": 1.308
            },
            "gtin": "59095620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f79c",
            "leftCorner": {
              "x": -3.693,
              "y": 31.14,
              "z": 1.308
            },
            "rightCorner": {
              "x": -3.784,
              "y": 31.145,
              "z": 1.308
            },
            "gtin": "59095620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f79d",
            "leftCorner": {
              "x": -3.784,
              "y": 31.151,
              "z": 1.308
            },
            "rightCorner": {
              "x": -3.882,
              "y": 31.157,
              "z": 1.308
            },
            "gtin": "59097754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f79e",
            "leftCorner": {
              "x": -3.882,
              "y": 31.157,
              "z": 1.308
            },
            "rightCorner": {
              "x": -3.98,
              "y": 31.162,
              "z": 1.308
            },
            "gtin": "59097754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f79f",
            "leftCorner": {
              "x": -3.98,
              "y": 31.159,
              "z": 1.308
            },
            "rightCorner": {
              "x": -4.149,
              "y": 31.169,
              "z": 1.308
            },
            "gtin": "59095668",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d4f",
    "rightNeighborShelfId": "a6d54"
  },
  {
    "id": "a6d54",
    "name": "a6d54",
    "x": -4.166,
    "y": 31.409,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99957,
      "w": 0.029317
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 109
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546612",
        "height": 0.16503,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f92a",
            "leftCorner": {
              "x": -4.193,
              "y": 31.368,
              "z": 0.135
            },
            "rightCorner": {
              "x": -4.263,
              "y": 31.372,
              "z": 0.135
            },
            "gtin": "4015100429022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f92b",
            "leftCorner": {
              "x": -4.263,
              "y": 31.372,
              "z": 0.135
            },
            "rightCorner": {
              "x": -4.332,
              "y": 31.376,
              "z": 0.135
            },
            "gtin": "4015100429022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f92c",
            "leftCorner": {
              "x": -4.332,
              "y": 31.376,
              "z": 0.135
            },
            "rightCorner": {
              "x": -4.402,
              "y": 31.379,
              "z": 0.135
            },
            "gtin": "4015100429022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f92d",
            "leftCorner": {
              "x": -4.402,
              "y": 31.379,
              "z": 0.135
            },
            "rightCorner": {
              "x": -4.471,
              "y": 31.383,
              "z": 0.135
            },
            "gtin": "4015100429022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f92e",
            "leftCorner": {
              "x": -4.472,
              "y": 31.372,
              "z": 0.135
            },
            "rightCorner": {
              "x": -4.545,
              "y": 31.377,
              "z": 0.135
            },
            "gtin": "4262429770407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f92f",
            "leftCorner": {
              "x": -4.545,
              "y": 31.383,
              "z": 0.135
            },
            "rightCorner": {
              "x": -4.578,
              "y": 31.384,
              "z": 0.135
            },
            "gtin": "4262429770391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f930",
            "leftCorner": {
              "x": -4.578,
              "y": 31.384,
              "z": 0.135
            },
            "rightCorner": {
              "x": -4.612,
              "y": 31.387,
              "z": 0.135
            },
            "gtin": "4262429770391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f931",
            "leftCorner": {
              "x": -4.612,
              "y": 31.382,
              "z": 0.135
            },
            "rightCorner": {
              "x": -4.691,
              "y": 31.387,
              "z": 0.135
            },
            "gtin": "4262429770414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f932",
            "leftCorner": {
              "x": -4.691,
              "y": 31.387,
              "z": 0.135
            },
            "rightCorner": {
              "x": -4.77,
              "y": 31.391,
              "z": 0.135
            },
            "gtin": "4262429770414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f933",
            "leftCorner": {
              "x": -4.77,
              "y": 31.395,
              "z": 0.135
            },
            "rightCorner": {
              "x": -4.829,
              "y": 31.4,
              "z": 0.135
            },
            "gtin": "4006000092546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f934",
            "leftCorner": {
              "x": -4.829,
              "y": 31.4,
              "z": 0.135
            },
            "rightCorner": {
              "x": -4.887,
              "y": 31.403,
              "z": 0.135
            },
            "gtin": "4006000092546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f935",
            "leftCorner": {
              "x": -4.888,
              "y": 31.399,
              "z": 0.135
            },
            "rightCorner": {
              "x": -4.935,
              "y": 31.402,
              "z": 0.135
            },
            "gtin": "4262429770797",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f936",
            "leftCorner": {
              "x": -4.935,
              "y": 31.402,
              "z": 0.135
            },
            "rightCorner": {
              "x": -4.983,
              "y": 31.405,
              "z": 0.135
            },
            "gtin": "4262429770797",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f937",
            "leftCorner": {
              "x": -4.983,
              "y": 31.405,
              "z": 0.135
            },
            "rightCorner": {
              "x": -5.031,
              "y": 31.408,
              "z": 0.135
            },
            "gtin": "4262429770797",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f938",
            "leftCorner": {
              "x": -5.031,
              "y": 31.403,
              "z": 0.135
            },
            "rightCorner": {
              "x": -5.091,
              "y": 31.406,
              "z": 0.135
            },
            "gtin": "4262429770810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f939",
            "leftCorner": {
              "x": -5.091,
              "y": 31.406,
              "z": 0.135
            },
            "rightCorner": {
              "x": -5.152,
              "y": 31.41,
              "z": 0.135
            },
            "gtin": "4262429770810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f93a",
            "leftCorner": {
              "x": -5.152,
              "y": 31.411,
              "z": 0.135
            },
            "rightCorner": {
              "x": -5.244,
              "y": 31.416,
              "z": 0.135
            },
            "gtin": "4262429770384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f93b",
            "leftCorner": {
              "x": -5.244,
              "y": 31.416,
              "z": 0.135
            },
            "rightCorner": {
              "x": -5.336,
              "y": 31.422,
              "z": 0.135
            },
            "gtin": "4262429770384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f93c",
            "leftCorner": {
              "x": -5.336,
              "y": 31.422,
              "z": 0.135
            },
            "rightCorner": {
              "x": -5.428,
              "y": 31.427,
              "z": 0.135
            },
            "gtin": "4262429770384",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54660d",
        "height": 0.44449,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f8bc",
            "leftCorner": {
              "x": -4.17,
              "y": 31.269,
              "z": 0.364
            },
            "rightCorner": {
              "x": -4.218,
              "y": 31.271,
              "z": 0.364
            },
            "gtin": "4005900843494",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8bd",
            "leftCorner": {
              "x": -4.218,
              "y": 31.271,
              "z": 0.364
            },
            "rightCorner": {
              "x": -4.266,
              "y": 31.274,
              "z": 0.364
            },
            "gtin": "4005900843494",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8be",
            "leftCorner": {
              "x": -4.266,
              "y": 31.273,
              "z": 0.364
            },
            "rightCorner": {
              "x": -4.331,
              "y": 31.277,
              "z": 0.364
            },
            "gtin": "4006000094250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8bf",
            "leftCorner": {
              "x": -4.331,
              "y": 31.277,
              "z": 0.364
            },
            "rightCorner": {
              "x": -4.395,
              "y": 31.281,
              "z": 0.364
            },
            "gtin": "4006000094250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8c0",
            "leftCorner": {
              "x": -4.395,
              "y": 31.281,
              "z": 0.364
            },
            "rightCorner": {
              "x": -4.46,
              "y": 31.284,
              "z": 0.364
            },
            "gtin": "4006000094250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8c1",
            "leftCorner": {
              "x": -4.46,
              "y": 31.289,
              "z": 0.364
            },
            "rightCorner": {
              "x": -4.524,
              "y": 31.293,
              "z": 0.364
            },
            "gtin": "4006000092973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8c2",
            "leftCorner": {
              "x": -4.524,
              "y": 31.293,
              "z": 0.364
            },
            "rightCorner": {
              "x": -4.587,
              "y": 31.297,
              "z": 0.364
            },
            "gtin": "4006000092973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8c3",
            "leftCorner": {
              "x": -4.588,
              "y": 31.292,
              "z": 0.364
            },
            "rightCorner": {
              "x": -4.66,
              "y": 31.296,
              "z": 0.364
            },
            "gtin": "4006000092546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8c4",
            "leftCorner": {
              "x": -4.66,
              "y": 31.296,
              "z": 0.364
            },
            "rightCorner": {
              "x": -4.733,
              "y": 31.3,
              "z": 0.364
            },
            "gtin": "4006000092546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8c5",
            "leftCorner": {
              "x": -4.733,
              "y": 31.3,
              "z": 0.364
            },
            "rightCorner": {
              "x": -4.805,
              "y": 31.305,
              "z": 0.364
            },
            "gtin": "4006000092546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8c6",
            "leftCorner": {
              "x": -4.806,
              "y": 31.304,
              "z": 0.364
            },
            "rightCorner": {
              "x": -4.89,
              "y": 31.309,
              "z": 0.364
            },
            "gtin": "4006000092935",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8c7",
            "leftCorner": {
              "x": -4.89,
              "y": 31.309,
              "z": 0.364
            },
            "rightCorner": {
              "x": -4.974,
              "y": 31.313,
              "z": 0.364
            },
            "gtin": "4006000092935",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8c8",
            "leftCorner": {
              "x": -4.974,
              "y": 31.313,
              "z": 0.364
            },
            "rightCorner": {
              "x": -5.058,
              "y": 31.318,
              "z": 0.364
            },
            "gtin": "4006000092935",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8c9",
            "leftCorner": {
              "x": -5.058,
              "y": 31.327,
              "z": 0.364
            },
            "rightCorner": {
              "x": -5.145,
              "y": 31.333,
              "z": 0.364
            },
            "gtin": "8720181566820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8ca",
            "leftCorner": {
              "x": -5.145,
              "y": 31.322,
              "z": 0.364
            },
            "rightCorner": {
              "x": -5.208,
              "y": 31.326,
              "z": 0.364
            },
            "gtin": "5050456006830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8cb",
            "leftCorner": {
              "x": -5.207,
              "y": 31.336,
              "z": 0.364
            },
            "rightCorner": {
              "x": -5.289,
              "y": 31.341,
              "z": 0.364
            },
            "gtin": "5050456006847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8cc",
            "leftCorner": {
              "x": -5.29,
              "y": 31.327,
              "z": 0.364
            },
            "rightCorner": {
              "x": -5.334,
              "y": 31.33,
              "z": 0.364
            },
            "gtin": "5050456006854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8cd",
            "leftCorner": {
              "x": -5.334,
              "y": 31.33,
              "z": 0.364
            },
            "rightCorner": {
              "x": -5.378,
              "y": 31.333,
              "z": 0.364
            },
            "gtin": "5050456006854",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546610",
        "height": 0.69202,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a207af",
            "leftCorner": {
              "x": -4.172,
              "y": 31.31,
              "z": 0.566
            },
            "rightCorner": {
              "x": -4.246,
              "y": 31.315,
              "z": 0.566
            },
            "gtin": "8712561820899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207b0",
            "leftCorner": {
              "x": -4.246,
              "y": 31.315,
              "z": 0.566
            },
            "rightCorner": {
              "x": -4.32,
              "y": 31.318,
              "z": 0.566
            },
            "gtin": "8712561820899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207b3",
            "leftCorner": {
              "x": -4.322,
              "y": 31.282,
              "z": 0.566
            },
            "rightCorner": {
              "x": -4.361,
              "y": 31.285,
              "z": 0.566
            },
            "gtin": "8720181347092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207b4",
            "leftCorner": {
              "x": -4.361,
              "y": 31.285,
              "z": 0.566
            },
            "rightCorner": {
              "x": -4.4,
              "y": 31.287,
              "z": 0.566
            },
            "gtin": "8720181347092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207b5",
            "leftCorner": {
              "x": -4.399,
              "y": 31.29,
              "z": 0.566
            },
            "rightCorner": {
              "x": -4.458,
              "y": 31.293,
              "z": 0.566
            },
            "gtin": "8712561316040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207b6",
            "leftCorner": {
              "x": -4.458,
              "y": 31.293,
              "z": 0.566
            },
            "rightCorner": {
              "x": -4.516,
              "y": 31.296,
              "z": 0.566
            },
            "gtin": "8712561316040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207b7",
            "leftCorner": {
              "x": -4.516,
              "y": 31.291,
              "z": 0.566
            },
            "rightCorner": {
              "x": -4.617,
              "y": 31.298,
              "z": 0.566
            },
            "gtin": "8720181565878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207b8",
            "leftCorner": {
              "x": -4.617,
              "y": 31.297,
              "z": 0.566
            },
            "rightCorner": {
              "x": -4.692,
              "y": 31.301,
              "z": 0.566
            },
            "gtin": "8712561315975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207b9",
            "leftCorner": {
              "x": -4.692,
              "y": 31.3,
              "z": 0.566
            },
            "rightCorner": {
              "x": -4.795,
              "y": 31.307,
              "z": 0.566
            },
            "gtin": "8720181566844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207ba",
            "leftCorner": {
              "x": -4.795,
              "y": 31.306,
              "z": 0.566
            },
            "rightCorner": {
              "x": -4.838,
              "y": 31.309,
              "z": 0.566
            },
            "gtin": "8720181291890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207bb",
            "leftCorner": {
              "x": -4.838,
              "y": 31.309,
              "z": 0.566
            },
            "rightCorner": {
              "x": -4.881,
              "y": 31.311,
              "z": 0.566
            },
            "gtin": "8720181291890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207bc",
            "leftCorner": {
              "x": -4.881,
              "y": 31.302,
              "z": 0.566
            },
            "rightCorner": {
              "x": -4.992,
              "y": 31.308,
              "z": 0.566
            },
            "gtin": "8720181291593",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207bd",
            "leftCorner": {
              "x": -4.991,
              "y": 31.312,
              "z": 0.566
            },
            "rightCorner": {
              "x": -5.085,
              "y": 31.317,
              "z": 0.566
            },
            "gtin": "8720181277771",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207be",
            "leftCorner": {
              "x": -5.085,
              "y": 31.317,
              "z": 0.566
            },
            "rightCorner": {
              "x": -5.178,
              "y": 31.323,
              "z": 0.566
            },
            "gtin": "8720181565816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207bf",
            "leftCorner": {
              "x": -5.179,
              "y": 31.314,
              "z": 0.566
            },
            "rightCorner": {
              "x": -5.277,
              "y": 31.319,
              "z": 0.566
            },
            "gtin": "8720181277764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207b1",
            "leftCorner": {
              "x": -5.276,
              "y": 31.338,
              "z": 0.566
            },
            "rightCorner": {
              "x": -5.324,
              "y": 31.342,
              "z": 0.566
            },
            "gtin": "8720181291920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207b2",
            "leftCorner": {
              "x": -5.324,
              "y": 31.342,
              "z": 0.566
            },
            "rightCorner": {
              "x": -5.372,
              "y": 31.345,
              "z": 0.566
            },
            "gtin": "8720181291920",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54660e",
        "height": 0.94538,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f878",
            "leftCorner": {
              "x": -4.146,
              "y": 31.154,
              "z": 0.773
            },
            "rightCorner": {
              "x": -4.227,
              "y": 31.159,
              "z": 0.773
            },
            "gtin": "4005900982285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f879",
            "leftCorner": {
              "x": -4.227,
              "y": 31.159,
              "z": 0.773
            },
            "rightCorner": {
              "x": -4.307,
              "y": 31.164,
              "z": 0.773
            },
            "gtin": "4005900982285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f87a",
            "leftCorner": {
              "x": -4.307,
              "y": 31.173,
              "z": 0.773
            },
            "rightCorner": {
              "x": -4.359,
              "y": 31.176,
              "z": 0.773
            },
            "gtin": "4005900982124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f87b",
            "leftCorner": {
              "x": -4.359,
              "y": 31.176,
              "z": 0.773
            },
            "rightCorner": {
              "x": -4.411,
              "y": 31.178,
              "z": 0.773
            },
            "gtin": "4005900982124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f87c",
            "leftCorner": {
              "x": -4.41,
              "y": 31.19,
              "z": 0.773
            },
            "rightCorner": {
              "x": -4.476,
              "y": 31.194,
              "z": 0.773
            },
            "gtin": "4006000131573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f87d",
            "leftCorner": {
              "x": -4.476,
              "y": 31.194,
              "z": 0.773
            },
            "rightCorner": {
              "x": -4.542,
              "y": 31.198,
              "z": 0.773
            },
            "gtin": "4006000131573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f87e",
            "leftCorner": {
              "x": -4.542,
              "y": 31.195,
              "z": 0.773
            },
            "rightCorner": {
              "x": -4.604,
              "y": 31.199,
              "z": 0.773
            },
            "gtin": "4006000131511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f87f",
            "leftCorner": {
              "x": -4.604,
              "y": 31.199,
              "z": 0.773
            },
            "rightCorner": {
              "x": -4.666,
              "y": 31.202,
              "z": 0.773
            },
            "gtin": "4006000131511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f880",
            "leftCorner": {
              "x": -4.667,
              "y": 31.187,
              "z": 0.773
            },
            "rightCorner": {
              "x": -4.744,
              "y": 31.192,
              "z": 0.773
            },
            "gtin": "3616303479558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f881",
            "leftCorner": {
              "x": -4.743,
              "y": 31.201,
              "z": 0.773
            },
            "rightCorner": {
              "x": -4.81,
              "y": 31.205,
              "z": 0.773
            },
            "gtin": "3616303479565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f882",
            "leftCorner": {
              "x": -4.81,
              "y": 31.201,
              "z": 0.773
            },
            "rightCorner": {
              "x": -4.884,
              "y": 31.205,
              "z": 0.773
            },
            "gtin": "3616303479541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f883",
            "leftCorner": {
              "x": -4.884,
              "y": 31.205,
              "z": 0.773
            },
            "rightCorner": {
              "x": -4.958,
              "y": 31.21,
              "z": 0.773
            },
            "gtin": "3616303479541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f884",
            "leftCorner": {
              "x": -4.957,
              "y": 31.22,
              "z": 0.773
            },
            "rightCorner": {
              "x": -5.099,
              "y": 31.228,
              "z": 0.773
            },
            "gtin": "4045612001652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f885",
            "leftCorner": {
              "x": -5.1,
              "y": 31.22,
              "z": 0.773
            },
            "rightCorner": {
              "x": -5.196,
              "y": 31.226,
              "z": 0.773
            },
            "gtin": "5000468000609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f886",
            "leftCorner": {
              "x": -5.196,
              "y": 31.226,
              "z": 0.773
            },
            "rightCorner": {
              "x": -5.292,
              "y": 31.231,
              "z": 0.773
            },
            "gtin": "5000468000609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f849",
            "leftCorner": {
              "x": -5.291,
              "y": 31.241,
              "z": 0.773
            },
            "rightCorner": {
              "x": -5.378,
              "y": 31.247,
              "z": 0.773
            },
            "gtin": "50262816",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54660c",
        "height": 1.2034,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f805",
            "leftCorner": {
              "x": -4.274,
              "y": 31.181,
              "z": 0.985
            },
            "rightCorner": {
              "x": -4.331,
              "y": 31.185,
              "z": 0.985
            },
            "gtin": "4006000102962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f806",
            "leftCorner": {
              "x": -4.331,
              "y": 31.185,
              "z": 0.985
            },
            "rightCorner": {
              "x": -4.389,
              "y": 31.188,
              "z": 0.985
            },
            "gtin": "4006000102962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f807",
            "leftCorner": {
              "x": -4.389,
              "y": 31.184,
              "z": 0.985
            },
            "rightCorner": {
              "x": -4.568,
              "y": 31.194,
              "z": 0.985
            },
            "gtin": "4006000111537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f808",
            "leftCorner": {
              "x": -4.567,
              "y": 31.193,
              "z": 0.985
            },
            "rightCorner": {
              "x": -4.683,
              "y": 31.199,
              "z": 0.985
            },
            "gtin": "4063367383663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f809",
            "leftCorner": {
              "x": -4.684,
              "y": 31.192,
              "z": 0.985
            },
            "rightCorner": {
              "x": -4.773,
              "y": 31.197,
              "z": 0.985
            },
            "gtin": "4063367280665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f80a",
            "leftCorner": {
              "x": -4.773,
              "y": 31.196,
              "z": 0.985
            },
            "rightCorner": {
              "x": -5.1,
              "y": 31.215,
              "z": 0.985
            },
            "gtin": "4063367280641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f80b",
            "leftCorner": {
              "x": -5.099,
              "y": 31.233,
              "z": 0.985
            },
            "rightCorner": {
              "x": -5.169,
              "y": 31.237,
              "z": 0.985
            },
            "gtin": "4063367383663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f80c",
            "leftCorner": {
              "x": -5.169,
              "y": 31.23,
              "z": 0.985
            },
            "rightCorner": {
              "x": -5.259,
              "y": 31.236,
              "z": 0.985
            },
            "gtin": "59095842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7e4",
            "leftCorner": {
              "x": -5.259,
              "y": 31.233,
              "z": 0.985
            },
            "rightCorner": {
              "x": -5.319,
              "y": 31.236,
              "z": 0.985
            },
            "gtin": "80466437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7e5",
            "leftCorner": {
              "x": -5.319,
              "y": 31.236,
              "z": 0.985
            },
            "rightCorner": {
              "x": -5.378,
              "y": 31.24,
              "z": 0.985
            },
            "gtin": "80466437",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546611",
        "height": 1.4018,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f7d7",
            "leftCorner": {
              "x": -4.152,
              "y": 31.184,
              "z": 1.147
            },
            "rightCorner": {
              "x": -4.251,
              "y": 31.191,
              "z": 1.147
            },
            "gtin": "3600542227339",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7d8",
            "leftCorner": {
              "x": -4.252,
              "y": 31.175,
              "z": 1.147
            },
            "rightCorner": {
              "x": -4.424,
              "y": 31.185,
              "z": 1.147
            },
            "gtin": "3600542227384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7d9",
            "leftCorner": {
              "x": -4.425,
              "y": 31.184,
              "z": 1.147
            },
            "rightCorner": {
              "x": -4.51,
              "y": 31.19,
              "z": 1.147
            },
            "gtin": "3600542227322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7da",
            "leftCorner": {
              "x": -4.51,
              "y": 31.187,
              "z": 1.147
            },
            "rightCorner": {
              "x": -4.647,
              "y": 31.194,
              "z": 1.147
            },
            "gtin": "3600542475297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7db",
            "leftCorner": {
              "x": -4.647,
              "y": 31.194,
              "z": 1.147
            },
            "rightCorner": {
              "x": -4.784,
              "y": 31.202,
              "z": 1.147
            },
            "gtin": "3600542475297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7dc",
            "leftCorner": {
              "x": -4.784,
              "y": 31.202,
              "z": 1.147
            },
            "rightCorner": {
              "x": -4.868,
              "y": 31.207,
              "z": 1.147
            },
            "gtin": "4021457638789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7dd",
            "leftCorner": {
              "x": -4.868,
              "y": 31.207,
              "z": 1.147
            },
            "rightCorner": {
              "x": -4.951,
              "y": 31.212,
              "z": 1.147
            },
            "gtin": "4021457638789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7de",
            "leftCorner": {
              "x": -4.952,
              "y": 31.206,
              "z": 1.147
            },
            "rightCorner": {
              "x": -4.996,
              "y": 31.209,
              "z": 1.147
            },
            "gtin": "4021457638932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7df",
            "leftCorner": {
              "x": -4.996,
              "y": 31.218,
              "z": 1.147
            },
            "rightCorner": {
              "x": -5.073,
              "y": 31.222,
              "z": 1.147
            },
            "gtin": "4045612001768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7e0",
            "leftCorner": {
              "x": -5.074,
              "y": 31.202,
              "z": 1.147
            },
            "rightCorner": {
              "x": -5.199,
              "y": 31.21,
              "z": 1.147
            },
            "gtin": "5014697017086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7e1",
            "leftCorner": {
              "x": -5.199,
              "y": 31.221,
              "z": 1.147
            },
            "rightCorner": {
              "x": -5.257,
              "y": 31.225,
              "z": 1.147
            },
            "gtin": "4045612001638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7b1",
            "leftCorner": {
              "x": -5.257,
              "y": 31.227,
              "z": 1.147
            },
            "rightCorner": {
              "x": -5.378,
              "y": 31.234,
              "z": 1.147
            },
            "gtin": "4045612009337",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54660f",
        "height": 1.5989,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f7a0",
            "leftCorner": {
              "x": -4.15,
              "y": 31.156,
              "z": 1.308
            },
            "rightCorner": {
              "x": -4.201,
              "y": 31.159,
              "z": 1.308
            },
            "gtin": "4009800001602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7a1",
            "leftCorner": {
              "x": -4.201,
              "y": 31.166,
              "z": 1.308
            },
            "rightCorner": {
              "x": -4.283,
              "y": 31.171,
              "z": 1.308
            },
            "gtin": "4009800001671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7a2",
            "leftCorner": {
              "x": -4.283,
              "y": 31.174,
              "z": 1.308
            },
            "rightCorner": {
              "x": -4.369,
              "y": 31.179,
              "z": 1.308
            },
            "gtin": "4028615070054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7a3",
            "leftCorner": {
              "x": -4.368,
              "y": 31.189,
              "z": 1.308
            },
            "rightCorner": {
              "x": -4.469,
              "y": 31.196,
              "z": 1.308
            },
            "gtin": "4008890001257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7a4",
            "leftCorner": {
              "x": -4.469,
              "y": 31.19,
              "z": 1.308
            },
            "rightCorner": {
              "x": -4.577,
              "y": 31.196,
              "z": 1.308
            },
            "gtin": "4008890001455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7a5",
            "leftCorner": {
              "x": -4.577,
              "y": 31.196,
              "z": 1.308
            },
            "rightCorner": {
              "x": -4.684,
              "y": 31.203,
              "z": 1.308
            },
            "gtin": "4008890001455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7a6",
            "leftCorner": {
              "x": -4.684,
              "y": 31.203,
              "z": 1.308
            },
            "rightCorner": {
              "x": -4.792,
              "y": 31.209,
              "z": 1.308
            },
            "gtin": "4008890001455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7a7",
            "leftCorner": {
              "x": -4.792,
              "y": 31.214,
              "z": 1.308
            },
            "rightCorner": {
              "x": -4.864,
              "y": 31.219,
              "z": 1.308
            },
            "gtin": "4103040036728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7a8",
            "leftCorner": {
              "x": -4.864,
              "y": 31.213,
              "z": 1.308
            },
            "rightCorner": {
              "x": -4.929,
              "y": 31.217,
              "z": 1.308
            },
            "gtin": "4103040231017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7a9",
            "leftCorner": {
              "x": -4.929,
              "y": 31.217,
              "z": 1.308
            },
            "rightCorner": {
              "x": -4.994,
              "y": 31.22,
              "z": 1.308
            },
            "gtin": "4103040231017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7aa",
            "leftCorner": {
              "x": -4.993,
              "y": 31.226,
              "z": 1.308
            },
            "rightCorner": {
              "x": -5.059,
              "y": 31.23,
              "z": 1.308
            },
            "gtin": "4103040919724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7ab",
            "leftCorner": {
              "x": -5.059,
              "y": 31.23,
              "z": 1.308
            },
            "rightCorner": {
              "x": -5.124,
              "y": 31.234,
              "z": 1.308
            },
            "gtin": "4103040919724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7ac",
            "leftCorner": {
              "x": -5.125,
              "y": 31.225,
              "z": 1.308
            },
            "rightCorner": {
              "x": -5.178,
              "y": 31.229,
              "z": 1.308
            },
            "gtin": "4045612009351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7ad",
            "leftCorner": {
              "x": -5.178,
              "y": 31.229,
              "z": 1.308
            },
            "rightCorner": {
              "x": -5.231,
              "y": 31.232,
              "z": 1.308
            },
            "gtin": "4045612009351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7ae",
            "leftCorner": {
              "x": -5.23,
              "y": 31.236,
              "z": 1.308
            },
            "rightCorner": {
              "x": -5.279,
              "y": 31.239,
              "z": 1.308
            },
            "gtin": "4045612007555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f7af",
            "leftCorner": {
              "x": -5.279,
              "y": 31.239,
              "z": 1.308
            },
            "rightCorner": {
              "x": -5.329,
              "y": 31.242,
              "z": 1.308
            },
            "gtin": "4045612007555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f793",
            "leftCorner": {
              "x": -5.329,
              "y": 31.24,
              "z": 1.308
            },
            "rightCorner": {
              "x": -5.378,
              "y": 31.243,
              "z": 1.308
            },
            "gtin": "4045612007586",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d53",
    "rightNeighborShelfId": "a6d5b"
  },
  {
    "id": "a6d5b",
    "name": "a6d5b",
    "x": -5.363,
    "y": 31.479,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99957,
      "w": 0.029317
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 104
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546618",
        "height": 0.16537,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f93d",
            "leftCorner": {
              "x": -5.43,
              "y": 31.427,
              "z": 0.135
            },
            "rightCorner": {
              "x": -5.55,
              "y": 31.433,
              "z": 0.135
            },
            "gtin": "4337185933882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f93e",
            "leftCorner": {
              "x": -5.55,
              "y": 31.433,
              "z": 0.135
            },
            "rightCorner": {
              "x": -5.669,
              "y": 31.441,
              "z": 0.135
            },
            "gtin": "4337185933882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f93f",
            "leftCorner": {
              "x": -5.669,
              "y": 31.441,
              "z": 0.135
            },
            "rightCorner": {
              "x": -5.789,
              "y": 31.448,
              "z": 0.135
            },
            "gtin": "4337185933882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f940",
            "leftCorner": {
              "x": -5.789,
              "y": 31.448,
              "z": 0.135
            },
            "rightCorner": {
              "x": -5.908,
              "y": 31.455,
              "z": 0.135
            },
            "gtin": "4337185933882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f941",
            "leftCorner": {
              "x": -5.906,
              "y": 31.5,
              "z": 0.135
            },
            "rightCorner": {
              "x": -5.976,
              "y": 31.504,
              "z": 0.135
            },
            "gtin": "4337185933981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f942",
            "leftCorner": {
              "x": -5.976,
              "y": 31.504,
              "z": 0.135
            },
            "rightCorner": {
              "x": -6.045,
              "y": 31.508,
              "z": 0.135
            },
            "gtin": "4337185933981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f943",
            "leftCorner": {
              "x": -6.045,
              "y": 31.508,
              "z": 0.135
            },
            "rightCorner": {
              "x": -6.115,
              "y": 31.512,
              "z": 0.135
            },
            "gtin": "4337185933981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f944",
            "leftCorner": {
              "x": -6.115,
              "y": 31.512,
              "z": 0.135
            },
            "rightCorner": {
              "x": -6.185,
              "y": 31.517,
              "z": 0.135
            },
            "gtin": "4337185933981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f945",
            "leftCorner": {
              "x": -6.185,
              "y": 31.517,
              "z": 0.135
            },
            "rightCorner": {
              "x": -6.255,
              "y": 31.521,
              "z": 0.135
            },
            "gtin": "4337185933981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f946",
            "leftCorner": {
              "x": -6.257,
              "y": 31.494,
              "z": 0.135
            },
            "rightCorner": {
              "x": -6.328,
              "y": 31.497,
              "z": 0.135
            },
            "gtin": "5902357007358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f947",
            "leftCorner": {
              "x": -6.328,
              "y": 31.497,
              "z": 0.135
            },
            "rightCorner": {
              "x": -6.4,
              "y": 31.501,
              "z": 0.135
            },
            "gtin": "5902357007358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f948",
            "leftCorner": {
              "x": -6.4,
              "y": 31.501,
              "z": 0.135
            },
            "rightCorner": {
              "x": -6.471,
              "y": 31.506,
              "z": 0.135
            },
            "gtin": "5902357007358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f949",
            "leftCorner": {
              "x": -6.471,
              "y": 31.506,
              "z": 0.135
            },
            "rightCorner": {
              "x": -6.542,
              "y": 31.51,
              "z": 0.135
            },
            "gtin": "5902357007358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f94a",
            "leftCorner": {
              "x": -6.543,
              "y": 31.494,
              "z": 0.135
            },
            "rightCorner": {
              "x": -6.623,
              "y": 31.499,
              "z": 0.135
            },
            "gtin": "4337185933745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f94b",
            "leftCorner": {
              "x": -6.623,
              "y": 31.499,
              "z": 0.135
            },
            "rightCorner": {
              "x": -6.704,
              "y": 31.503,
              "z": 0.135
            },
            "gtin": "4337185933745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f94c",
            "leftCorner": {
              "x": -6.704,
              "y": 31.503,
              "z": 0.135
            },
            "rightCorner": {
              "x": -6.784,
              "y": 31.509,
              "z": 0.135
            },
            "gtin": "4337185933745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f94d",
            "leftCorner": {
              "x": -6.784,
              "y": 31.509,
              "z": 0.135
            },
            "rightCorner": {
              "x": -6.864,
              "y": 31.513,
              "z": 0.135
            },
            "gtin": "4337185933745",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546615",
        "height": 0.44161,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f8d8",
            "leftCorner": {
              "x": -6.12,
              "y": 31.368,
              "z": 0.361
            },
            "rightCorner": {
              "x": -6.204,
              "y": 31.372,
              "z": 0.361
            },
            "gtin": "4063367384868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8ce",
            "leftCorner": {
              "x": -5.377,
              "y": 31.332,
              "z": 0.361
            },
            "rightCorner": {
              "x": -5.447,
              "y": 31.337,
              "z": 0.361
            },
            "gtin": "4003583218042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8cf",
            "leftCorner": {
              "x": -5.447,
              "y": 31.337,
              "z": 0.361
            },
            "rightCorner": {
              "x": -5.516,
              "y": 31.341,
              "z": 0.361
            },
            "gtin": "4003583218042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8d0",
            "leftCorner": {
              "x": -5.516,
              "y": 31.341,
              "z": 0.361
            },
            "rightCorner": {
              "x": -5.585,
              "y": 31.345,
              "z": 0.361
            },
            "gtin": "4003583218042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8d1",
            "leftCorner": {
              "x": -5.586,
              "y": 31.344,
              "z": 0.361
            },
            "rightCorner": {
              "x": -5.659,
              "y": 31.348,
              "z": 0.361
            },
            "gtin": "4003583218035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8d2",
            "leftCorner": {
              "x": -5.659,
              "y": 31.348,
              "z": 0.361
            },
            "rightCorner": {
              "x": -5.732,
              "y": 31.352,
              "z": 0.361
            },
            "gtin": "4003583218035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8d3",
            "leftCorner": {
              "x": -5.732,
              "y": 31.352,
              "z": 0.361
            },
            "rightCorner": {
              "x": -5.805,
              "y": 31.356,
              "z": 0.361
            },
            "gtin": "4003583218035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8d4",
            "leftCorner": {
              "x": -5.805,
              "y": 31.358,
              "z": 0.361
            },
            "rightCorner": {
              "x": -5.879,
              "y": 31.363,
              "z": 0.361
            },
            "gtin": "4063367384844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8d5",
            "leftCorner": {
              "x": -5.879,
              "y": 31.363,
              "z": 0.361
            },
            "rightCorner": {
              "x": -5.952,
              "y": 31.367,
              "z": 0.361
            },
            "gtin": "4063367384844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8d6",
            "leftCorner": {
              "x": -5.952,
              "y": 31.358,
              "z": 0.361
            },
            "rightCorner": {
              "x": -6.036,
              "y": 31.363,
              "z": 0.361
            },
            "gtin": "4063367384868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8d7",
            "leftCorner": {
              "x": -6.036,
              "y": 31.363,
              "z": 0.361
            },
            "rightCorner": {
              "x": -6.12,
              "y": 31.368,
              "z": 0.361
            },
            "gtin": "4063367384868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8d9",
            "leftCorner": {
              "x": -6.204,
              "y": 31.38,
              "z": 0.361
            },
            "rightCorner": {
              "x": -6.271,
              "y": 31.384,
              "z": 0.361
            },
            "gtin": "4063367263545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8da",
            "leftCorner": {
              "x": -6.271,
              "y": 31.384,
              "z": 0.361
            },
            "rightCorner": {
              "x": -6.339,
              "y": 31.388,
              "z": 0.361
            },
            "gtin": "4063367263545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8db",
            "leftCorner": {
              "x": -6.338,
              "y": 31.397,
              "z": 0.361
            },
            "rightCorner": {
              "x": -6.418,
              "y": 31.402,
              "z": 0.361
            },
            "gtin": "4063367117237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8dc",
            "leftCorner": {
              "x": -6.418,
              "y": 31.403,
              "z": 0.361
            },
            "rightCorner": {
              "x": -6.478,
              "y": 31.406,
              "z": 0.361
            },
            "gtin": "4063367117251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8dd",
            "leftCorner": {
              "x": -6.478,
              "y": 31.406,
              "z": 0.361
            },
            "rightCorner": {
              "x": -6.538,
              "y": 31.41,
              "z": 0.361
            },
            "gtin": "4063367117251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8de",
            "leftCorner": {
              "x": -6.539,
              "y": 31.392,
              "z": 0.361
            },
            "rightCorner": {
              "x": -6.604,
              "y": 31.396,
              "z": 0.361
            },
            "gtin": "5902357007518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8df",
            "leftCorner": {
              "x": -6.604,
              "y": 31.396,
              "z": 0.361
            },
            "rightCorner": {
              "x": -6.67,
              "y": 31.4,
              "z": 0.361
            },
            "gtin": "5902357007518",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546617",
        "height": 0.74812,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a208ad",
            "leftCorner": {
              "x": -5.369,
              "y": 31.378,
              "z": 0.612
            },
            "rightCorner": {
              "x": -5.433,
              "y": 31.383,
              "z": 0.612
            },
            "gtin": "4015100427806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208ae",
            "leftCorner": {
              "x": -5.433,
              "y": 31.383,
              "z": 0.612
            },
            "rightCorner": {
              "x": -5.498,
              "y": 31.386,
              "z": 0.612
            },
            "gtin": "4015100427806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208af",
            "leftCorner": {
              "x": -5.498,
              "y": 31.386,
              "z": 0.612
            },
            "rightCorner": {
              "x": -5.562,
              "y": 31.39,
              "z": 0.612
            },
            "gtin": "4015100427806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208b0",
            "leftCorner": {
              "x": -5.562,
              "y": 31.39,
              "z": 0.612
            },
            "rightCorner": {
              "x": -5.627,
              "y": 31.393,
              "z": 0.612
            },
            "gtin": "4015100427806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208b1",
            "leftCorner": {
              "x": -5.627,
              "y": 31.393,
              "z": 0.612
            },
            "rightCorner": {
              "x": -5.691,
              "y": 31.397,
              "z": 0.612
            },
            "gtin": "4015100427806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208b7",
            "leftCorner": {
              "x": -5.693,
              "y": 31.363,
              "z": 0.612
            },
            "rightCorner": {
              "x": -5.766,
              "y": 31.368,
              "z": 0.612
            },
            "gtin": "4015100427424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208b8",
            "leftCorner": {
              "x": -5.766,
              "y": 31.368,
              "z": 0.612
            },
            "rightCorner": {
              "x": -5.838,
              "y": 31.372,
              "z": 0.612
            },
            "gtin": "4015100427424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208b9",
            "leftCorner": {
              "x": -5.838,
              "y": 31.372,
              "z": 0.612
            },
            "rightCorner": {
              "x": -5.91,
              "y": 31.377,
              "z": 0.612
            },
            "gtin": "4015100427424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208ba",
            "leftCorner": {
              "x": -5.91,
              "y": 31.377,
              "z": 0.612
            },
            "rightCorner": {
              "x": -5.983,
              "y": 31.381,
              "z": 0.612
            },
            "gtin": "4015100427424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208bb",
            "leftCorner": {
              "x": -5.983,
              "y": 31.381,
              "z": 0.612
            },
            "rightCorner": {
              "x": -6.055,
              "y": 31.384,
              "z": 0.612
            },
            "gtin": "4015100427424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208bc",
            "leftCorner": {
              "x": -6.055,
              "y": 31.384,
              "z": 0.612
            },
            "rightCorner": {
              "x": -6.127,
              "y": 31.389,
              "z": 0.612
            },
            "gtin": "4015100427424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208bd",
            "leftCorner": {
              "x": -6.127,
              "y": 31.397,
              "z": 0.612
            },
            "rightCorner": {
              "x": -6.18,
              "y": 31.4,
              "z": 0.612
            },
            "gtin": "4015100427400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208be",
            "leftCorner": {
              "x": -6.18,
              "y": 31.4,
              "z": 0.612
            },
            "rightCorner": {
              "x": -6.232,
              "y": 31.404,
              "z": 0.612
            },
            "gtin": "4015100427400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208bf",
            "leftCorner": {
              "x": -6.234,
              "y": 31.38,
              "z": 0.612
            },
            "rightCorner": {
              "x": -6.297,
              "y": 31.383,
              "z": 0.612
            },
            "gtin": "4015100427301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208c0",
            "leftCorner": {
              "x": -6.297,
              "y": 31.383,
              "z": 0.612
            },
            "rightCorner": {
              "x": -6.36,
              "y": 31.387,
              "z": 0.612
            },
            "gtin": "4015100427301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208c1",
            "leftCorner": {
              "x": -6.36,
              "y": 31.387,
              "z": 0.612
            },
            "rightCorner": {
              "x": -6.423,
              "y": 31.39,
              "z": 0.612
            },
            "gtin": "4015100427301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208c2",
            "leftCorner": {
              "x": -6.423,
              "y": 31.394,
              "z": 0.612
            },
            "rightCorner": {
              "x": -6.562,
              "y": 31.403,
              "z": 0.612
            },
            "gtin": "8720181333996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208c3",
            "leftCorner": {
              "x": -6.562,
              "y": 31.396,
              "z": 0.612
            },
            "rightCorner": {
              "x": -6.597,
              "y": 31.398,
              "z": 0.612
            },
            "gtin": "8720181334580",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546614",
        "height": 0.99914,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a2080a",
            "leftCorner": {
              "x": -5.369,
              "y": 31.384,
              "z": 0.817
            },
            "rightCorner": {
              "x": -5.437,
              "y": 31.389,
              "z": 0.817
            },
            "gtin": "8720181302053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2080b",
            "leftCorner": {
              "x": -5.437,
              "y": 31.389,
              "z": 0.817
            },
            "rightCorner": {
              "x": -5.505,
              "y": 31.393,
              "z": 0.817
            },
            "gtin": "8720181302053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2080c",
            "leftCorner": {
              "x": -5.505,
              "y": 31.393,
              "z": 0.817
            },
            "rightCorner": {
              "x": -5.573,
              "y": 31.396,
              "z": 0.817
            },
            "gtin": "8720181302053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20812",
            "leftCorner": {
              "x": -5.576,
              "y": 31.347,
              "z": 0.817
            },
            "rightCorner": {
              "x": -5.626,
              "y": 31.35,
              "z": 0.817
            },
            "gtin": "8720181301995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20813",
            "leftCorner": {
              "x": -5.626,
              "y": 31.35,
              "z": 0.817
            },
            "rightCorner": {
              "x": -5.676,
              "y": 31.353,
              "z": 0.817
            },
            "gtin": "8720181301995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20814",
            "leftCorner": {
              "x": -5.676,
              "y": 31.353,
              "z": 0.817
            },
            "rightCorner": {
              "x": -5.727,
              "y": 31.356,
              "z": 0.817
            },
            "gtin": "8720181301995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20815",
            "leftCorner": {
              "x": -5.727,
              "y": 31.353,
              "z": 0.817
            },
            "rightCorner": {
              "x": -5.804,
              "y": 31.358,
              "z": 0.817
            },
            "gtin": "8720181302015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20816",
            "leftCorner": {
              "x": -5.803,
              "y": 31.369,
              "z": 0.817
            },
            "rightCorner": {
              "x": -5.859,
              "y": 31.373,
              "z": 0.817
            },
            "gtin": "8720181302008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20817",
            "leftCorner": {
              "x": -5.859,
              "y": 31.373,
              "z": 0.817
            },
            "rightCorner": {
              "x": -5.916,
              "y": 31.376,
              "z": 0.817
            },
            "gtin": "8720181302008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20818",
            "leftCorner": {
              "x": -5.916,
              "y": 31.384,
              "z": 0.817
            },
            "rightCorner": {
              "x": -5.987,
              "y": 31.388,
              "z": 0.817
            },
            "gtin": "4015100427363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20819",
            "leftCorner": {
              "x": -5.987,
              "y": 31.388,
              "z": 0.817
            },
            "rightCorner": {
              "x": -6.058,
              "y": 31.392,
              "z": 0.817
            },
            "gtin": "4015100427363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2081a",
            "leftCorner": {
              "x": -6.058,
              "y": 31.392,
              "z": 0.817
            },
            "rightCorner": {
              "x": -6.129,
              "y": 31.396,
              "z": 0.817
            },
            "gtin": "4015100427363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2081b",
            "leftCorner": {
              "x": -6.129,
              "y": 31.396,
              "z": 0.817
            },
            "rightCorner": {
              "x": -6.2,
              "y": 31.4,
              "z": 0.817
            },
            "gtin": "4015100427363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2081c",
            "leftCorner": {
              "x": -6.2,
              "y": 31.395,
              "z": 0.817
            },
            "rightCorner": {
              "x": -6.291,
              "y": 31.401,
              "z": 0.817
            },
            "gtin": "4015100428063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2081d",
            "leftCorner": {
              "x": -6.291,
              "y": 31.401,
              "z": 0.817
            },
            "rightCorner": {
              "x": -6.382,
              "y": 31.405,
              "z": 0.817
            },
            "gtin": "4015100428063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2081e",
            "leftCorner": {
              "x": -6.382,
              "y": 31.402,
              "z": 0.817
            },
            "rightCorner": {
              "x": -6.471,
              "y": 31.408,
              "z": 0.817
            },
            "gtin": "8718951076990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2081f",
            "leftCorner": {
              "x": -6.47,
              "y": 31.413,
              "z": 0.817
            },
            "rightCorner": {
              "x": -6.551,
              "y": 31.418,
              "z": 0.817
            },
            "gtin": "8718951077133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20820",
            "leftCorner": {
              "x": -6.552,
              "y": 31.401,
              "z": 0.817
            },
            "rightCorner": {
              "x": -6.607,
              "y": 31.404,
              "z": 0.817
            },
            "gtin": "8720181431173",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546616",
        "height": 1.2449,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a2085a",
            "leftCorner": {
              "x": -5.375,
              "y": 31.28,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.447,
              "y": 31.284,
              "z": 1.019
            },
            "gtin": "3616305448422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2085b",
            "leftCorner": {
              "x": -5.447,
              "y": 31.284,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.52,
              "y": 31.288,
              "z": 1.019
            },
            "gtin": "3616305448422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20860",
            "leftCorner": {
              "x": -5.522,
              "y": 31.245,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.609,
              "y": 31.251,
              "z": 1.019
            },
            "gtin": "3616304696091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20861",
            "leftCorner": {
              "x": -5.609,
              "y": 31.251,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.695,
              "y": 31.256,
              "z": 1.019
            },
            "gtin": "3616304696091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20862",
            "leftCorner": {
              "x": -5.694,
              "y": 31.278,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.758,
              "y": 31.282,
              "z": 1.019
            },
            "gtin": "3616305448378",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20863",
            "leftCorner": {
              "x": -5.758,
              "y": 31.282,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.821,
              "y": 31.285,
              "z": 1.019
            },
            "gtin": "3616305448378",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20864",
            "leftCorner": {
              "x": -5.821,
              "y": 31.285,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.885,
              "y": 31.289,
              "z": 1.019
            },
            "gtin": "3616305448378",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20865",
            "leftCorner": {
              "x": -5.885,
              "y": 31.285,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.958,
              "y": 31.289,
              "z": 1.019
            },
            "gtin": "3616305448286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20866",
            "leftCorner": {
              "x": -5.958,
              "y": 31.289,
              "z": 1.019
            },
            "rightCorner": {
              "x": -6.032,
              "y": 31.292,
              "z": 1.019
            },
            "gtin": "3616305448286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20867",
            "leftCorner": {
              "x": -6.033,
              "y": 31.278,
              "z": 1.019
            },
            "rightCorner": {
              "x": -6.142,
              "y": 31.285,
              "z": 1.019
            },
            "gtin": "3616305448521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20868",
            "leftCorner": {
              "x": -6.142,
              "y": 31.285,
              "z": 1.019
            },
            "rightCorner": {
              "x": -6.252,
              "y": 31.291,
              "z": 1.019
            },
            "gtin": "3616305448521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20869",
            "leftCorner": {
              "x": -6.252,
              "y": 31.304,
              "z": 1.019
            },
            "rightCorner": {
              "x": -6.498,
              "y": 31.318,
              "z": 1.019
            },
            "gtin": "4006000063836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2086a",
            "leftCorner": {
              "x": -6.498,
              "y": 31.305,
              "z": 1.019
            },
            "rightCorner": {
              "x": -6.565,
              "y": 31.309,
              "z": 1.019
            },
            "gtin": "4006000063874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2086b",
            "leftCorner": {
              "x": -6.565,
              "y": 31.309,
              "z": 1.019
            },
            "rightCorner": {
              "x": -6.632,
              "y": 31.313,
              "z": 1.019
            },
            "gtin": "4006000063874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2086c",
            "leftCorner": {
              "x": -6.632,
              "y": 31.313,
              "z": 1.019
            },
            "rightCorner": {
              "x": -6.699,
              "y": 31.317,
              "z": 1.019
            },
            "gtin": "4006000063874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2086d",
            "leftCorner": {
              "x": -6.699,
              "y": 31.317,
              "z": 1.019
            },
            "rightCorner": {
              "x": -6.766,
              "y": 31.321,
              "z": 1.019
            },
            "gtin": "4006000063874",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546613",
        "height": 1.5025,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a207c0",
            "leftCorner": {
              "x": -5.374,
              "y": 31.287,
              "z": 1.229
            },
            "rightCorner": {
              "x": -5.45,
              "y": 31.292,
              "z": 1.229
            },
            "gtin": "8006540842454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207c4",
            "leftCorner": {
              "x": -5.453,
              "y": 31.248,
              "z": 1.229
            },
            "rightCorner": {
              "x": -5.529,
              "y": 31.253,
              "z": 1.229
            },
            "gtin": "8006540838914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207c5",
            "leftCorner": {
              "x": -5.528,
              "y": 31.267,
              "z": 1.229
            },
            "rightCorner": {
              "x": -5.589,
              "y": 31.271,
              "z": 1.229
            },
            "gtin": "8006540838945",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207c6",
            "leftCorner": {
              "x": -5.589,
              "y": 31.271,
              "z": 1.229
            },
            "rightCorner": {
              "x": -5.649,
              "y": 31.274,
              "z": 1.229
            },
            "gtin": "8006540838945",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207c7",
            "leftCorner": {
              "x": -5.649,
              "y": 31.268,
              "z": 1.229
            },
            "rightCorner": {
              "x": -5.732,
              "y": 31.273,
              "z": 1.229
            },
            "gtin": "8006540842409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207c8",
            "leftCorner": {
              "x": -5.732,
              "y": 31.273,
              "z": 1.229
            },
            "rightCorner": {
              "x": -5.815,
              "y": 31.278,
              "z": 1.229
            },
            "gtin": "8006540842409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207c9",
            "leftCorner": {
              "x": -5.815,
              "y": 31.28,
              "z": 1.229
            },
            "rightCorner": {
              "x": -5.862,
              "y": 31.283,
              "z": 1.229
            },
            "gtin": "8006540838976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207ca",
            "leftCorner": {
              "x": -5.862,
              "y": 31.278,
              "z": 1.229
            },
            "rightCorner": {
              "x": -5.934,
              "y": 31.282,
              "z": 1.229
            },
            "gtin": "8700216752589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207cb",
            "leftCorner": {
              "x": -5.934,
              "y": 31.282,
              "z": 1.229
            },
            "rightCorner": {
              "x": -6.006,
              "y": 31.285,
              "z": 1.229
            },
            "gtin": "8700216752589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207cc",
            "leftCorner": {
              "x": -6.006,
              "y": 31.282,
              "z": 1.229
            },
            "rightCorner": {
              "x": -6.058,
              "y": 31.286,
              "z": 1.229
            },
            "gtin": "8720181331244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207cd",
            "leftCorner": {
              "x": -6.058,
              "y": 31.286,
              "z": 1.229
            },
            "rightCorner": {
              "x": -6.11,
              "y": 31.289,
              "z": 1.229
            },
            "gtin": "8720181331244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207ce",
            "leftCorner": {
              "x": -6.111,
              "y": 31.278,
              "z": 1.229
            },
            "rightCorner": {
              "x": -6.213,
              "y": 31.284,
              "z": 1.229
            },
            "gtin": "8720181325397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207cf",
            "leftCorner": {
              "x": -6.213,
              "y": 31.284,
              "z": 1.229
            },
            "rightCorner": {
              "x": -6.315,
              "y": 31.29,
              "z": 1.229
            },
            "gtin": "8720181325397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207d0",
            "leftCorner": {
              "x": -6.315,
              "y": 31.29,
              "z": 1.229
            },
            "rightCorner": {
              "x": -6.417,
              "y": 31.296,
              "z": 1.229
            },
            "gtin": "8720181325397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207d1",
            "leftCorner": {
              "x": -6.416,
              "y": 31.308,
              "z": 1.229
            },
            "rightCorner": {
              "x": -6.491,
              "y": 31.313,
              "z": 1.229
            },
            "gtin": "4008268043605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207d2",
            "leftCorner": {
              "x": -6.491,
              "y": 31.313,
              "z": 1.229
            },
            "rightCorner": {
              "x": -6.566,
              "y": 31.317,
              "z": 1.229
            },
            "gtin": "4008268043605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207d3",
            "leftCorner": {
              "x": -6.566,
              "y": 31.317,
              "z": 1.229
            },
            "rightCorner": {
              "x": -6.641,
              "y": 31.321,
              "z": 1.229
            },
            "gtin": "4008268043605",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d54",
    "rightNeighborShelfId": "a6d5c"
  },
  {
    "id": "a6d5c",
    "name": "a6d5c",
    "x": -6.611,
    "y": 31.552,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99957,
      "w": 0.029317
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 88
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a54661a",
        "height": 0.16535,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f94e",
            "leftCorner": {
              "x": -6.863,
              "y": 31.528,
              "z": 0.135
            },
            "rightCorner": {
              "x": -6.941,
              "y": 31.532,
              "z": 0.135
            },
            "gtin": "4337185933677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f94f",
            "leftCorner": {
              "x": -6.941,
              "y": 31.532,
              "z": 0.135
            },
            "rightCorner": {
              "x": -7.018,
              "y": 31.536,
              "z": 0.135
            },
            "gtin": "4337185933677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f950",
            "leftCorner": {
              "x": -7.019,
              "y": 31.533,
              "z": 0.135
            },
            "rightCorner": {
              "x": -7.116,
              "y": 31.539,
              "z": 0.135
            },
            "gtin": "4063367384844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f951",
            "leftCorner": {
              "x": -7.115,
              "y": 31.55,
              "z": 0.135
            },
            "rightCorner": {
              "x": -7.175,
              "y": 31.554,
              "z": 0.135
            },
            "gtin": "5902357007440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f952",
            "leftCorner": {
              "x": -7.175,
              "y": 31.554,
              "z": 0.135
            },
            "rightCorner": {
              "x": -7.235,
              "y": 31.557,
              "z": 0.135
            },
            "gtin": "5902357007440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f953",
            "leftCorner": {
              "x": -7.235,
              "y": 31.557,
              "z": 0.135
            },
            "rightCorner": {
              "x": -7.295,
              "y": 31.561,
              "z": 0.135
            },
            "gtin": "5902357007440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f954",
            "leftCorner": {
              "x": -7.295,
              "y": 31.561,
              "z": 0.135
            },
            "rightCorner": {
              "x": -7.355,
              "y": 31.564,
              "z": 0.135
            },
            "gtin": "5902357007440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f955",
            "leftCorner": {
              "x": -7.355,
              "y": 31.573,
              "z": 0.135
            },
            "rightCorner": {
              "x": -7.423,
              "y": 31.577,
              "z": 0.135
            },
            "gtin": "4337185933769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f956",
            "leftCorner": {
              "x": -7.423,
              "y": 31.577,
              "z": 0.135
            },
            "rightCorner": {
              "x": -7.491,
              "y": 31.581,
              "z": 0.135
            },
            "gtin": "4337185933769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f957",
            "leftCorner": {
              "x": -7.491,
              "y": 31.581,
              "z": 0.135
            },
            "rightCorner": {
              "x": -7.56,
              "y": 31.586,
              "z": 0.135
            },
            "gtin": "4337185933769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f958",
            "leftCorner": {
              "x": -7.561,
              "y": 31.568,
              "z": 0.135
            },
            "rightCorner": {
              "x": -7.642,
              "y": 31.573,
              "z": 0.135
            },
            "gtin": "4337185933653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f959",
            "leftCorner": {
              "x": -7.642,
              "y": 31.573,
              "z": 0.135
            },
            "rightCorner": {
              "x": -7.724,
              "y": 31.578,
              "z": 0.135
            },
            "gtin": "4337185933653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f95a",
            "leftCorner": {
              "x": -7.724,
              "y": 31.578,
              "z": 0.135
            },
            "rightCorner": {
              "x": -7.918,
              "y": 31.589,
              "z": 0.135
            },
            "gtin": "4337185934001",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546619",
        "height": 0.43734,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f8e0",
            "leftCorner": {
              "x": -6.669,
              "y": 31.412,
              "z": 0.358
            },
            "rightCorner": {
              "x": -6.738,
              "y": 31.416,
              "z": 0.358
            },
            "gtin": "5902357007525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8e1",
            "leftCorner": {
              "x": -6.738,
              "y": 31.416,
              "z": 0.358
            },
            "rightCorner": {
              "x": -6.806,
              "y": 31.42,
              "z": 0.358
            },
            "gtin": "5902357007525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8e2",
            "leftCorner": {
              "x": -6.806,
              "y": 31.419,
              "z": 0.358
            },
            "rightCorner": {
              "x": -6.865,
              "y": 31.423,
              "z": 0.358
            },
            "gtin": "4015100800715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8e3",
            "leftCorner": {
              "x": -6.865,
              "y": 31.423,
              "z": 0.358
            },
            "rightCorner": {
              "x": -6.924,
              "y": 31.426,
              "z": 0.358
            },
            "gtin": "4015100800715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8e4",
            "leftCorner": {
              "x": -6.924,
              "y": 31.437,
              "z": 0.358
            },
            "rightCorner": {
              "x": -7.024,
              "y": 31.443,
              "z": 0.358
            },
            "gtin": "4015100427783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8e5",
            "leftCorner": {
              "x": -7.024,
              "y": 31.443,
              "z": 0.358
            },
            "rightCorner": {
              "x": -7.125,
              "y": 31.449,
              "z": 0.358
            },
            "gtin": "4015100427783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8e6",
            "leftCorner": {
              "x": -7.125,
              "y": 31.443,
              "z": 0.358
            },
            "rightCorner": {
              "x": -7.225,
              "y": 31.449,
              "z": 0.358
            },
            "gtin": "8411114090481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8e7",
            "leftCorner": {
              "x": -7.225,
              "y": 31.454,
              "z": 0.358
            },
            "rightCorner": {
              "x": -7.286,
              "y": 31.457,
              "z": 0.358
            },
            "gtin": "8411114084725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8e8",
            "leftCorner": {
              "x": -7.286,
              "y": 31.457,
              "z": 0.358
            },
            "rightCorner": {
              "x": -7.347,
              "y": 31.461,
              "z": 0.358
            },
            "gtin": "8411114084725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8e9",
            "leftCorner": {
              "x": -7.347,
              "y": 31.465,
              "z": 0.358
            },
            "rightCorner": {
              "x": -7.454,
              "y": 31.472,
              "z": 0.358
            },
            "gtin": "8411114078953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8ea",
            "leftCorner": {
              "x": -7.454,
              "y": 31.47,
              "z": 0.358
            },
            "rightCorner": {
              "x": -7.543,
              "y": 31.474,
              "z": 0.358
            },
            "gtin": "8411114063362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8eb",
            "leftCorner": {
              "x": -7.543,
              "y": 31.474,
              "z": 0.358
            },
            "rightCorner": {
              "x": -7.632,
              "y": 31.48,
              "z": 0.358
            },
            "gtin": "8411114063362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8ec",
            "leftCorner": {
              "x": -7.632,
              "y": 31.477,
              "z": 0.358
            },
            "rightCorner": {
              "x": -7.74,
              "y": 31.484,
              "z": 0.358
            },
            "gtin": "8720181334108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8ed",
            "leftCorner": {
              "x": -7.74,
              "y": 31.484,
              "z": 0.358
            },
            "rightCorner": {
              "x": -7.848,
              "y": 31.49,
              "z": 0.358
            },
            "gtin": "8720181334108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8ee",
            "leftCorner": {
              "x": -7.848,
              "y": 31.49,
              "z": 0.358
            },
            "rightCorner": {
              "x": -7.955,
              "y": 31.497,
              "z": 0.358
            },
            "gtin": "8720181334108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8ef",
            "leftCorner": {
              "x": -7.955,
              "y": 31.497,
              "z": 0.358
            },
            "rightCorner": {
              "x": -8.063,
              "y": 31.502,
              "z": 0.358
            },
            "gtin": "8720181334108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8f0",
            "leftCorner": {
              "x": -8.063,
              "y": 31.502,
              "z": 0.358
            },
            "rightCorner": {
              "x": -8.17,
              "y": 31.509,
              "z": 0.358
            },
            "gtin": "8720181334108",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54661b",
        "height": 0.74126,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a208c4",
            "leftCorner": {
              "x": -6.596,
              "y": 31.418,
              "z": 0.606
            },
            "rightCorner": {
              "x": -6.748,
              "y": 31.428,
              "z": 0.606
            },
            "gtin": "8720181334597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208c5",
            "leftCorner": {
              "x": -6.749,
              "y": 31.42,
              "z": 0.606
            },
            "rightCorner": {
              "x": -6.924,
              "y": 31.43,
              "z": 0.606
            },
            "gtin": "8720181325380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208c6",
            "leftCorner": {
              "x": -6.924,
              "y": 31.431,
              "z": 0.606
            },
            "rightCorner": {
              "x": -7.047,
              "y": 31.438,
              "z": 0.606
            },
            "gtin": "8720181334153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208c7",
            "leftCorner": {
              "x": -7.047,
              "y": 31.438,
              "z": 0.606
            },
            "rightCorner": {
              "x": -7.17,
              "y": 31.446,
              "z": 0.606
            },
            "gtin": "8720181334153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208c8",
            "leftCorner": {
              "x": -7.17,
              "y": 31.447,
              "z": 0.606
            },
            "rightCorner": {
              "x": -7.262,
              "y": 31.452,
              "z": 0.606
            },
            "gtin": "8411114087276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208c9",
            "leftCorner": {
              "x": -7.262,
              "y": 31.452,
              "z": 0.606
            },
            "rightCorner": {
              "x": -7.354,
              "y": 31.457,
              "z": 0.606
            },
            "gtin": "8411114087276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208ca",
            "leftCorner": {
              "x": -7.353,
              "y": 31.46,
              "z": 0.606
            },
            "rightCorner": {
              "x": -7.448,
              "y": 31.465,
              "z": 0.606
            },
            "gtin": "8411114090474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208cb",
            "leftCorner": {
              "x": -7.448,
              "y": 31.465,
              "z": 0.606
            },
            "rightCorner": {
              "x": -7.542,
              "y": 31.471,
              "z": 0.606
            },
            "gtin": "8411114090474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208cc",
            "leftCorner": {
              "x": -7.542,
              "y": 31.47,
              "z": 0.606
            },
            "rightCorner": {
              "x": -7.627,
              "y": 31.475,
              "z": 0.606
            },
            "gtin": "8411114079035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208cd",
            "leftCorner": {
              "x": -7.627,
              "y": 31.475,
              "z": 0.606
            },
            "rightCorner": {
              "x": -7.713,
              "y": 31.48,
              "z": 0.606
            },
            "gtin": "8411114079035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208ce",
            "leftCorner": {
              "x": -7.713,
              "y": 31.48,
              "z": 0.606
            },
            "rightCorner": {
              "x": -7.799,
              "y": 31.485,
              "z": 0.606
            },
            "gtin": "8411114079035",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54661d",
        "height": 1.0015,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20821",
            "leftCorner": {
              "x": -6.605,
              "y": 31.433,
              "z": 0.819
            },
            "rightCorner": {
              "x": -6.667,
              "y": 31.436,
              "z": 0.819
            },
            "gtin": "8710447276600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20822",
            "leftCorner": {
              "x": -6.667,
              "y": 31.433,
              "z": 0.819
            },
            "rightCorner": {
              "x": -6.734,
              "y": 31.437,
              "z": 0.819
            },
            "gtin": "8717163648681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20823",
            "leftCorner": {
              "x": -6.734,
              "y": 31.437,
              "z": 0.819
            },
            "rightCorner": {
              "x": -6.801,
              "y": 31.441,
              "z": 0.819
            },
            "gtin": "8717163648681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20824",
            "leftCorner": {
              "x": -6.801,
              "y": 31.441,
              "z": 0.819
            },
            "rightCorner": {
              "x": -6.868,
              "y": 31.445,
              "z": 0.819
            },
            "gtin": "8717163648681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20825",
            "leftCorner": {
              "x": -6.868,
              "y": 31.435,
              "z": 0.819
            },
            "rightCorner": {
              "x": -6.942,
              "y": 31.439,
              "z": 0.819
            },
            "gtin": "8710447276594",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20826",
            "leftCorner": {
              "x": -6.941,
              "y": 31.446,
              "z": 0.819
            },
            "rightCorner": {
              "x": -7.007,
              "y": 31.45,
              "z": 0.819
            },
            "gtin": "8710447276587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20827",
            "leftCorner": {
              "x": -7.007,
              "y": 31.45,
              "z": 0.819
            },
            "rightCorner": {
              "x": -7.074,
              "y": 31.453,
              "z": 0.819
            },
            "gtin": "8710447276587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20828",
            "leftCorner": {
              "x": -7.074,
              "y": 31.453,
              "z": 0.819
            },
            "rightCorner": {
              "x": -7.14,
              "y": 31.457,
              "z": 0.819
            },
            "gtin": "8710447276587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20829",
            "leftCorner": {
              "x": -7.14,
              "y": 31.457,
              "z": 0.819
            },
            "rightCorner": {
              "x": -7.206,
              "y": 31.461,
              "z": 0.819
            },
            "gtin": "8710447276587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2082a",
            "leftCorner": {
              "x": -7.206,
              "y": 31.461,
              "z": 0.819
            },
            "rightCorner": {
              "x": -7.272,
              "y": 31.465,
              "z": 0.819
            },
            "gtin": "8710447276587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2082b",
            "leftCorner": {
              "x": -7.272,
              "y": 31.465,
              "z": 0.819
            },
            "rightCorner": {
              "x": -7.331,
              "y": 31.468,
              "z": 0.819
            },
            "gtin": "8720181204081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2082c",
            "leftCorner": {
              "x": -7.331,
              "y": 31.468,
              "z": 0.819
            },
            "rightCorner": {
              "x": -7.391,
              "y": 31.472,
              "z": 0.819
            },
            "gtin": "8720181204081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2082d",
            "leftCorner": {
              "x": -7.391,
              "y": 31.472,
              "z": 0.819
            },
            "rightCorner": {
              "x": -7.451,
              "y": 31.475,
              "z": 0.819
            },
            "gtin": "8720181204081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2082e",
            "leftCorner": {
              "x": -7.45,
              "y": 31.478,
              "z": 0.819
            },
            "rightCorner": {
              "x": -7.509,
              "y": 31.482,
              "z": 0.819
            },
            "gtin": "8720181208096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2082f",
            "leftCorner": {
              "x": -7.509,
              "y": 31.482,
              "z": 0.819
            },
            "rightCorner": {
              "x": -7.567,
              "y": 31.485,
              "z": 0.819
            },
            "gtin": "8720181208096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20830",
            "leftCorner": {
              "x": -7.567,
              "y": 31.486,
              "z": 0.819
            },
            "rightCorner": {
              "x": -7.645,
              "y": 31.491,
              "z": 0.819
            },
            "gtin": "8710447276570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20831",
            "leftCorner": {
              "x": -7.645,
              "y": 31.491,
              "z": 0.819
            },
            "rightCorner": {
              "x": -7.723,
              "y": 31.495,
              "z": 0.819
            },
            "gtin": "8710447276570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20832",
            "leftCorner": {
              "x": -7.724,
              "y": 31.485,
              "z": 0.819
            },
            "rightCorner": {
              "x": -7.79,
              "y": 31.489,
              "z": 0.819
            },
            "gtin": "8710447284117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20833",
            "leftCorner": {
              "x": -7.79,
              "y": 31.489,
              "z": 0.819
            },
            "rightCorner": {
              "x": -7.857,
              "y": 31.493,
              "z": 0.819
            },
            "gtin": "8710447284117",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54661e",
        "height": 1.2499,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a2086e",
            "leftCorner": {
              "x": -6.765,
              "y": 31.327,
              "z": 1.023
            },
            "rightCorner": {
              "x": -6.863,
              "y": 31.333,
              "z": 1.023
            },
            "gtin": "4006000063676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2086f",
            "leftCorner": {
              "x": -6.863,
              "y": 31.333,
              "z": 1.023
            },
            "rightCorner": {
              "x": -6.96,
              "y": 31.339,
              "z": 1.023
            },
            "gtin": "4006000063676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20870",
            "leftCorner": {
              "x": -6.96,
              "y": 31.346,
              "z": 1.023
            },
            "rightCorner": {
              "x": -7.045,
              "y": 31.35,
              "z": 1.023
            },
            "gtin": "4006000063591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20871",
            "leftCorner": {
              "x": -7.045,
              "y": 31.35,
              "z": 1.023
            },
            "rightCorner": {
              "x": -7.131,
              "y": 31.355,
              "z": 1.023
            },
            "gtin": "4006000063591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20872",
            "leftCorner": {
              "x": -7.131,
              "y": 31.355,
              "z": 1.023
            },
            "rightCorner": {
              "x": -7.217,
              "y": 31.36,
              "z": 1.023
            },
            "gtin": "4006000063591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20873",
            "leftCorner": {
              "x": -7.217,
              "y": 31.36,
              "z": 1.023
            },
            "rightCorner": {
              "x": -7.302,
              "y": 31.365,
              "z": 1.023
            },
            "gtin": "4006000063591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20874",
            "leftCorner": {
              "x": -7.302,
              "y": 31.366,
              "z": 1.023
            },
            "rightCorner": {
              "x": -7.369,
              "y": 31.37,
              "z": 1.023
            },
            "gtin": "4006000063553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20875",
            "leftCorner": {
              "x": -7.369,
              "y": 31.37,
              "z": 1.023
            },
            "rightCorner": {
              "x": -7.437,
              "y": 31.374,
              "z": 1.023
            },
            "gtin": "4006000063553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20876",
            "leftCorner": {
              "x": -7.437,
              "y": 31.369,
              "z": 1.023
            },
            "rightCorner": {
              "x": -7.503,
              "y": 31.373,
              "z": 1.023
            },
            "gtin": "4006000063713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20877",
            "leftCorner": {
              "x": -7.503,
              "y": 31.373,
              "z": 1.023
            },
            "rightCorner": {
              "x": -7.569,
              "y": 31.376,
              "z": 1.023
            },
            "gtin": "4006000063713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20878",
            "leftCorner": {
              "x": -7.569,
              "y": 31.376,
              "z": 1.023
            },
            "rightCorner": {
              "x": -7.636,
              "y": 31.38,
              "z": 1.023
            },
            "gtin": "4006000063713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20879",
            "leftCorner": {
              "x": -7.636,
              "y": 31.38,
              "z": 1.023
            },
            "rightCorner": {
              "x": -7.702,
              "y": 31.384,
              "z": 1.023
            },
            "gtin": "4006000063713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2087a",
            "leftCorner": {
              "x": -7.702,
              "y": 31.373,
              "z": 1.023
            },
            "rightCorner": {
              "x": -7.761,
              "y": 31.376,
              "z": 1.023
            },
            "gtin": "4006000063911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2087b",
            "leftCorner": {
              "x": -7.761,
              "y": 31.376,
              "z": 1.023
            },
            "rightCorner": {
              "x": -7.82,
              "y": 31.38,
              "z": 1.023
            },
            "gtin": "4006000063911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2087c",
            "leftCorner": {
              "x": -7.82,
              "y": 31.38,
              "z": 1.023
            },
            "rightCorner": {
              "x": -7.878,
              "y": 31.383,
              "z": 1.023
            },
            "gtin": "4006000063911",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54661c",
        "height": 1.4993,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a207d4",
            "leftCorner": {
              "x": -6.64,
              "y": 31.338,
              "z": 1.227
            },
            "rightCorner": {
              "x": -6.72,
              "y": 31.342,
              "z": 1.227
            },
            "gtin": "4008268044459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207d5",
            "leftCorner": {
              "x": -6.72,
              "y": 31.342,
              "z": 1.227
            },
            "rightCorner": {
              "x": -6.8,
              "y": 31.348,
              "z": 1.227
            },
            "gtin": "4008268044459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207d6",
            "leftCorner": {
              "x": -6.8,
              "y": 31.348,
              "z": 1.227
            },
            "rightCorner": {
              "x": -6.879,
              "y": 31.352,
              "z": 1.227
            },
            "gtin": "4008268044459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207d7",
            "leftCorner": {
              "x": -6.88,
              "y": 31.342,
              "z": 1.227
            },
            "rightCorner": {
              "x": -6.993,
              "y": 31.349,
              "z": 1.227
            },
            "gtin": "5050456006885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207d8",
            "leftCorner": {
              "x": -6.994,
              "y": 31.338,
              "z": 1.227
            },
            "rightCorner": {
              "x": -7.052,
              "y": 31.341,
              "z": 1.227
            },
            "gtin": "4008890006436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207d9",
            "leftCorner": {
              "x": -7.052,
              "y": 31.341,
              "z": 1.227
            },
            "rightCorner": {
              "x": -7.111,
              "y": 31.345,
              "z": 1.227
            },
            "gtin": "4008890006436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207da",
            "leftCorner": {
              "x": -7.111,
              "y": 31.347,
              "z": 1.227
            },
            "rightCorner": {
              "x": -7.171,
              "y": 31.351,
              "z": 1.227
            },
            "gtin": "4008890006191",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207db",
            "leftCorner": {
              "x": -7.169,
              "y": 31.378,
              "z": 1.227
            },
            "rightCorner": {
              "x": -7.27,
              "y": 31.384,
              "z": 1.227
            },
            "gtin": "4009800001480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207dc",
            "leftCorner": {
              "x": -7.271,
              "y": 31.374,
              "z": 1.227
            },
            "rightCorner": {
              "x": -7.436,
              "y": 31.384,
              "z": 1.227
            },
            "gtin": "8710447284094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207dd",
            "leftCorner": {
              "x": -7.436,
              "y": 31.386,
              "z": 1.227
            },
            "rightCorner": {
              "x": -7.536,
              "y": 31.392,
              "z": 1.227
            },
            "gtin": "8710447284117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207de",
            "leftCorner": {
              "x": -7.536,
              "y": 31.392,
              "z": 1.227
            },
            "rightCorner": {
              "x": -7.636,
              "y": 31.398,
              "z": 1.227
            },
            "gtin": "8710447284117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207df",
            "leftCorner": {
              "x": -7.636,
              "y": 31.398,
              "z": 1.227
            },
            "rightCorner": {
              "x": -7.736,
              "y": 31.403,
              "z": 1.227
            },
            "gtin": "8710447284117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207e0",
            "leftCorner": {
              "x": -7.736,
              "y": 31.403,
              "z": 1.227
            },
            "rightCorner": {
              "x": -7.836,
              "y": 31.41,
              "z": 1.227
            },
            "gtin": "8710447284117",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d5b",
    "rightNeighborShelfId": "a6d5d"
  },
  {
    "id": "a6d5d",
    "name": "a6d5d",
    "x": -7.859,
    "y": 31.625,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99957,
      "w": 0.029317
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 96
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a54662a",
        "height": 0.17472,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f95b",
            "leftCorner": {
              "x": -7.919,
              "y": 31.583,
              "z": 0.143
            },
            "rightCorner": {
              "x": -7.996,
              "y": 31.587,
              "z": 0.143
            },
            "gtin": "8720181334085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f95c",
            "leftCorner": {
              "x": -7.996,
              "y": 31.587,
              "z": 0.143
            },
            "rightCorner": {
              "x": -8.073,
              "y": 31.592,
              "z": 0.143
            },
            "gtin": "8720181334085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f95d",
            "leftCorner": {
              "x": -8.073,
              "y": 31.592,
              "z": 0.143
            },
            "rightCorner": {
              "x": -8.15,
              "y": 31.597,
              "z": 0.143
            },
            "gtin": "8720181334085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f95e",
            "leftCorner": {
              "x": -8.15,
              "y": 31.597,
              "z": 0.143
            },
            "rightCorner": {
              "x": -8.227,
              "y": 31.601,
              "z": 0.143
            },
            "gtin": "8720181334085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f95f",
            "leftCorner": {
              "x": -8.227,
              "y": 31.601,
              "z": 0.143
            },
            "rightCorner": {
              "x": -8.304,
              "y": 31.605,
              "z": 0.143
            },
            "gtin": "8720181334085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f960",
            "leftCorner": {
              "x": -8.304,
              "y": 31.61,
              "z": 0.143
            },
            "rightCorner": {
              "x": -8.364,
              "y": 31.614,
              "z": 0.143
            },
            "gtin": "8720181334061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f961",
            "leftCorner": {
              "x": -8.364,
              "y": 31.614,
              "z": 0.143
            },
            "rightCorner": {
              "x": -8.424,
              "y": 31.617,
              "z": 0.143
            },
            "gtin": "8720181334061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f962",
            "leftCorner": {
              "x": -8.424,
              "y": 31.617,
              "z": 0.143
            },
            "rightCorner": {
              "x": -8.486,
              "y": 31.621,
              "z": 0.143
            },
            "gtin": "8720181334061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f963",
            "leftCorner": {
              "x": -8.486,
              "y": 31.621,
              "z": 0.143
            },
            "rightCorner": {
              "x": -8.546,
              "y": 31.624,
              "z": 0.143
            },
            "gtin": "8720181334061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f964",
            "leftCorner": {
              "x": -8.546,
              "y": 31.629,
              "z": 0.143
            },
            "rightCorner": {
              "x": -8.622,
              "y": 31.634,
              "z": 0.143
            },
            "gtin": "8720181334030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f965",
            "leftCorner": {
              "x": -8.622,
              "y": 31.634,
              "z": 0.143
            },
            "rightCorner": {
              "x": -8.697,
              "y": 31.638,
              "z": 0.143
            },
            "gtin": "8720181334030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f966",
            "leftCorner": {
              "x": -8.697,
              "y": 31.638,
              "z": 0.143
            },
            "rightCorner": {
              "x": -8.774,
              "y": 31.643,
              "z": 0.143
            },
            "gtin": "8720181334030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f914",
            "leftCorner": {
              "x": -8.775,
              "y": 31.629,
              "z": 0.143
            },
            "rightCorner": {
              "x": -8.858,
              "y": 31.634,
              "z": 0.143
            },
            "gtin": "8720181334122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f915",
            "leftCorner": {
              "x": -8.858,
              "y": 31.634,
              "z": 0.143
            },
            "rightCorner": {
              "x": -8.943,
              "y": 31.639,
              "z": 0.143
            },
            "gtin": "8720181334122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f916",
            "leftCorner": {
              "x": -8.943,
              "y": 31.639,
              "z": 0.143
            },
            "rightCorner": {
              "x": -9.026,
              "y": 31.644,
              "z": 0.143
            },
            "gtin": "8720181334122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f917",
            "leftCorner": {
              "x": -9.026,
              "y": 31.644,
              "z": 0.143
            },
            "rightCorner": {
              "x": -9.11,
              "y": 31.649,
              "z": 0.143
            },
            "gtin": "8720181334122",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54662b",
        "height": 0.44153,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f8f1",
            "leftCorner": {
              "x": -8.171,
              "y": 31.504,
              "z": 0.361
            },
            "rightCorner": {
              "x": -8.232,
              "y": 31.508,
              "z": 0.361
            },
            "gtin": "8720181334016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8f2",
            "leftCorner": {
              "x": -8.232,
              "y": 31.508,
              "z": 0.361
            },
            "rightCorner": {
              "x": -8.293,
              "y": 31.511,
              "z": 0.361
            },
            "gtin": "8720181334016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8f3",
            "leftCorner": {
              "x": -8.293,
              "y": 31.511,
              "z": 0.361
            },
            "rightCorner": {
              "x": -8.354,
              "y": 31.515,
              "z": 0.361
            },
            "gtin": "8720181334016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8f4",
            "leftCorner": {
              "x": -8.354,
              "y": 31.508,
              "z": 0.361
            },
            "rightCorner": {
              "x": -8.4,
              "y": 31.511,
              "z": 0.361
            },
            "gtin": "4017512170660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8f5",
            "leftCorner": {
              "x": -8.399,
              "y": 31.529,
              "z": 0.361
            },
            "rightCorner": {
              "x": -8.475,
              "y": 31.532,
              "z": 0.361
            },
            "gtin": "4017512170271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8f6",
            "leftCorner": {
              "x": -8.476,
              "y": 31.515,
              "z": 0.361
            },
            "rightCorner": {
              "x": -8.573,
              "y": 31.52,
              "z": 0.361
            },
            "gtin": "4008233165523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8f7",
            "leftCorner": {
              "x": -8.573,
              "y": 31.52,
              "z": 0.361
            },
            "rightCorner": {
              "x": -8.648,
              "y": 31.525,
              "z": 0.361
            },
            "gtin": "4008233159812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8f8",
            "leftCorner": {
              "x": -8.648,
              "y": 31.522,
              "z": 0.361
            },
            "rightCorner": {
              "x": -8.739,
              "y": 31.528,
              "z": 0.361
            },
            "gtin": "4008233171791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8f9",
            "leftCorner": {
              "x": -8.738,
              "y": 31.536,
              "z": 0.361
            },
            "rightCorner": {
              "x": -8.843,
              "y": 31.543,
              "z": 0.361
            },
            "gtin": "4008233169170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8fa",
            "leftCorner": {
              "x": -8.844,
              "y": 31.534,
              "z": 0.361
            },
            "rightCorner": {
              "x": -8.894,
              "y": 31.537,
              "z": 0.361
            },
            "gtin": "4008233114781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8fb",
            "leftCorner": {
              "x": -8.894,
              "y": 31.537,
              "z": 0.361
            },
            "rightCorner": {
              "x": -8.944,
              "y": 31.54,
              "z": 0.361
            },
            "gtin": "4008233114781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8fc",
            "leftCorner": {
              "x": -8.943,
              "y": 31.541,
              "z": 0.361
            },
            "rightCorner": {
              "x": -9.008,
              "y": 31.544,
              "z": 0.361
            },
            "gtin": "4008233114804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8fd",
            "leftCorner": {
              "x": -9.008,
              "y": 31.544,
              "z": 0.361
            },
            "rightCorner": {
              "x": -9.071,
              "y": 31.548,
              "z": 0.361
            },
            "gtin": "4008233114804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f8fe",
            "leftCorner": {
              "x": -9.071,
              "y": 31.561,
              "z": 0.361
            },
            "rightCorner": {
              "x": -9.106,
              "y": 31.563,
              "z": 0.361
            },
            "gtin": "4008233170398",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546628",
        "height": 0.74316,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a208cf",
            "leftCorner": {
              "x": -7.823,
              "y": 31.5,
              "z": 0.608
            },
            "rightCorner": {
              "x": -7.931,
              "y": 31.506,
              "z": 0.608
            },
            "gtin": "4013162019236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208d0",
            "leftCorner": {
              "x": -7.932,
              "y": 31.483,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.032,
              "y": 31.489,
              "z": 0.608
            },
            "gtin": "3574661384306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208d1",
            "leftCorner": {
              "x": -8.032,
              "y": 31.498,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.13,
              "y": 31.504,
              "z": 0.608
            },
            "gtin": "3574661384382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208d2",
            "leftCorner": {
              "x": -8.13,
              "y": 31.504,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.228,
              "y": 31.51,
              "z": 0.608
            },
            "gtin": "3574661384382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208d3",
            "leftCorner": {
              "x": -8.227,
              "y": 31.529,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.301,
              "y": 31.534,
              "z": 0.608
            },
            "gtin": "4045612009313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208d4",
            "leftCorner": {
              "x": -8.303,
              "y": 31.51,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.408,
              "y": 31.516,
              "z": 0.608
            },
            "gtin": "4045612009320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208d5",
            "leftCorner": {
              "x": -8.408,
              "y": 31.515,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.468,
              "y": 31.519,
              "z": 0.608
            },
            "gtin": "4006000137513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208d6",
            "leftCorner": {
              "x": -8.468,
              "y": 31.519,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.528,
              "y": 31.523,
              "z": 0.608
            },
            "gtin": "4006000137513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208d7",
            "leftCorner": {
              "x": -8.528,
              "y": 31.523,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.59,
              "y": 31.526,
              "z": 0.608
            },
            "gtin": "4006000137513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208d8",
            "leftCorner": {
              "x": -8.589,
              "y": 31.529,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.673,
              "y": 31.533,
              "z": 0.608
            },
            "gtin": "4006000137674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208d9",
            "leftCorner": {
              "x": -8.673,
              "y": 31.533,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.756,
              "y": 31.539,
              "z": 0.608
            },
            "gtin": "4006000137674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208da",
            "leftCorner": {
              "x": -8.756,
              "y": 31.539,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.835,
              "y": 31.543,
              "z": 0.608
            },
            "gtin": "4006000137599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208db",
            "leftCorner": {
              "x": -8.835,
              "y": 31.543,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.915,
              "y": 31.548,
              "z": 0.608
            },
            "gtin": "4006000137599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208dc",
            "leftCorner": {
              "x": -8.915,
              "y": 31.55,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.959,
              "y": 31.553,
              "z": 0.608
            },
            "gtin": "4006000137780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208dd",
            "leftCorner": {
              "x": -8.959,
              "y": 31.553,
              "z": 0.608
            },
            "rightCorner": {
              "x": -9.005,
              "y": 31.555,
              "z": 0.608
            },
            "gtin": "4006000137780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208de",
            "leftCorner": {
              "x": -9.005,
              "y": 31.563,
              "z": 0.608
            },
            "rightCorner": {
              "x": -9.059,
              "y": 31.566,
              "z": 0.608
            },
            "gtin": "4006000137827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208df",
            "leftCorner": {
              "x": -9.059,
              "y": 31.566,
              "z": 0.608
            },
            "rightCorner": {
              "x": -9.114,
              "y": 31.569,
              "z": 0.608
            },
            "gtin": "4006000137827",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546627",
        "height": 0.99967,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20834",
            "leftCorner": {
              "x": -7.857,
              "y": 31.488,
              "z": 0.818
            },
            "rightCorner": {
              "x": -7.915,
              "y": 31.491,
              "z": 0.818
            },
            "gtin": "8710447284100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20835",
            "leftCorner": {
              "x": -7.914,
              "y": 31.496,
              "z": 0.818
            },
            "rightCorner": {
              "x": -7.986,
              "y": 31.501,
              "z": 0.818
            },
            "gtin": "3600524036638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20836",
            "leftCorner": {
              "x": -7.986,
              "y": 31.501,
              "z": 0.818
            },
            "rightCorner": {
              "x": -8.057,
              "y": 31.505,
              "z": 0.818
            },
            "gtin": "3600524036638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20837",
            "leftCorner": {
              "x": -8.057,
              "y": 31.5,
              "z": 0.818
            },
            "rightCorner": {
              "x": -8.127,
              "y": 31.504,
              "z": 0.818
            },
            "gtin": "3600524036607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20838",
            "leftCorner": {
              "x": -8.127,
              "y": 31.505,
              "z": 0.818
            },
            "rightCorner": {
              "x": -8.207,
              "y": 31.51,
              "z": 0.818
            },
            "gtin": "3600524036591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20839",
            "leftCorner": {
              "x": -8.207,
              "y": 31.513,
              "z": 0.818
            },
            "rightCorner": {
              "x": -8.292,
              "y": 31.518,
              "z": 0.818
            },
            "gtin": "3600524036621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2083a",
            "leftCorner": {
              "x": -8.292,
              "y": 31.517,
              "z": 0.818
            },
            "rightCorner": {
              "x": -8.38,
              "y": 31.523,
              "z": 0.818
            },
            "gtin": "3600524070328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2083b",
            "leftCorner": {
              "x": -8.38,
              "y": 31.523,
              "z": 0.818
            },
            "rightCorner": {
              "x": -8.469,
              "y": 31.528,
              "z": 0.818
            },
            "gtin": "3600524070328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2083c",
            "leftCorner": {
              "x": -8.47,
              "y": 31.522,
              "z": 0.818
            },
            "rightCorner": {
              "x": -8.53,
              "y": 31.526,
              "z": 0.818
            },
            "gtin": "3600524070335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2083d",
            "leftCorner": {
              "x": -8.53,
              "y": 31.526,
              "z": 0.818
            },
            "rightCorner": {
              "x": -8.591,
              "y": 31.53,
              "z": 0.818
            },
            "gtin": "3600524070335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2083e",
            "leftCorner": {
              "x": -8.591,
              "y": 31.535,
              "z": 0.818
            },
            "rightCorner": {
              "x": -8.668,
              "y": 31.539,
              "z": 0.818
            },
            "gtin": "3600523980499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2083f",
            "leftCorner": {
              "x": -8.668,
              "y": 31.539,
              "z": 0.818
            },
            "rightCorner": {
              "x": -8.745,
              "y": 31.544,
              "z": 0.818
            },
            "gtin": "3600523980499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20840",
            "leftCorner": {
              "x": -8.746,
              "y": 31.534,
              "z": 0.818
            },
            "rightCorner": {
              "x": -8.825,
              "y": 31.539,
              "z": 0.818
            },
            "gtin": "3600523881598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20841",
            "leftCorner": {
              "x": -8.825,
              "y": 31.539,
              "z": 0.818
            },
            "rightCorner": {
              "x": -8.903,
              "y": 31.544,
              "z": 0.818
            },
            "gtin": "3600523881598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20842",
            "leftCorner": {
              "x": -8.903,
              "y": 31.543,
              "z": 0.818
            },
            "rightCorner": {
              "x": -8.979,
              "y": 31.547,
              "z": 0.818
            },
            "gtin": "4063367180286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20843",
            "leftCorner": {
              "x": -8.978,
              "y": 31.558,
              "z": 0.818
            },
            "rightCorner": {
              "x": -9.079,
              "y": 31.564,
              "z": 0.818
            },
            "gtin": "7611916153600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20844",
            "leftCorner": {
              "x": -9.078,
              "y": 31.575,
              "z": 0.818
            },
            "rightCorner": {
              "x": -9.154,
              "y": 31.58,
              "z": 0.818
            },
            "gtin": "4008233129518",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546629",
        "height": 1.2488,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a2087d",
            "leftCorner": {
              "x": -7.878,
              "y": 31.389,
              "z": 1.022
            },
            "rightCorner": {
              "x": -7.934,
              "y": 31.392,
              "z": 1.022
            },
            "gtin": "4006000063997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2087e",
            "leftCorner": {
              "x": -7.934,
              "y": 31.392,
              "z": 1.022
            },
            "rightCorner": {
              "x": -7.99,
              "y": 31.396,
              "z": 1.022
            },
            "gtin": "4006000063997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2087f",
            "leftCorner": {
              "x": -7.989,
              "y": 31.402,
              "z": 1.022
            },
            "rightCorner": {
              "x": -8.069,
              "y": 31.406,
              "z": 1.022
            },
            "gtin": "4008890007013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20880",
            "leftCorner": {
              "x": -8.069,
              "y": 31.406,
              "z": 1.022
            },
            "rightCorner": {
              "x": -8.148,
              "y": 31.41,
              "z": 1.022
            },
            "gtin": "4008890007013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20881",
            "leftCorner": {
              "x": -8.149,
              "y": 31.392,
              "z": 1.022
            },
            "rightCorner": {
              "x": -8.233,
              "y": 31.397,
              "z": 1.022
            },
            "gtin": "3616305263247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20882",
            "leftCorner": {
              "x": -8.233,
              "y": 31.397,
              "z": 1.022
            },
            "rightCorner": {
              "x": -8.318,
              "y": 31.403,
              "z": 1.022
            },
            "gtin": "3616305263247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20883",
            "leftCorner": {
              "x": -8.317,
              "y": 31.417,
              "z": 1.022
            },
            "rightCorner": {
              "x": -8.378,
              "y": 31.42,
              "z": 1.022
            },
            "gtin": "3616305263254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20884",
            "leftCorner": {
              "x": -8.378,
              "y": 31.42,
              "z": 1.022
            },
            "rightCorner": {
              "x": -8.438,
              "y": 31.423,
              "z": 1.022
            },
            "gtin": "3616305263254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20885",
            "leftCorner": {
              "x": -8.439,
              "y": 31.407,
              "z": 1.022
            },
            "rightCorner": {
              "x": -8.515,
              "y": 31.412,
              "z": 1.022
            },
            "gtin": "3616305276292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20886",
            "leftCorner": {
              "x": -8.515,
              "y": 31.412,
              "z": 1.022
            },
            "rightCorner": {
              "x": -8.592,
              "y": 31.416,
              "z": 1.022
            },
            "gtin": "3616305276292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20887",
            "leftCorner": {
              "x": -8.592,
              "y": 31.413,
              "z": 1.022
            },
            "rightCorner": {
              "x": -8.66,
              "y": 31.417,
              "z": 1.022
            },
            "gtin": "3616303458959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20888",
            "leftCorner": {
              "x": -8.66,
              "y": 31.417,
              "z": 1.022
            },
            "rightCorner": {
              "x": -8.726,
              "y": 31.422,
              "z": 1.022
            },
            "gtin": "3616303458959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20889",
            "leftCorner": {
              "x": -8.726,
              "y": 31.422,
              "z": 1.022
            },
            "rightCorner": {
              "x": -8.794,
              "y": 31.426,
              "z": 1.022
            },
            "gtin": "3616303458959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2088a",
            "leftCorner": {
              "x": -8.793,
              "y": 31.45,
              "z": 1.022
            },
            "rightCorner": {
              "x": -8.883,
              "y": 31.455,
              "z": 1.022
            },
            "gtin": "3616303459314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2088b",
            "leftCorner": {
              "x": -8.883,
              "y": 31.455,
              "z": 1.022
            },
            "rightCorner": {
              "x": -8.974,
              "y": 31.461,
              "z": 1.022
            },
            "gtin": "3616303459314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2088c",
            "leftCorner": {
              "x": -8.975,
              "y": 31.445,
              "z": 1.022
            },
            "rightCorner": {
              "x": -9.042,
              "y": 31.449,
              "z": 1.022
            },
            "gtin": "3616303458881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2088d",
            "leftCorner": {
              "x": -9.042,
              "y": 31.449,
              "z": 1.022
            },
            "rightCorner": {
              "x": -9.11,
              "y": 31.453,
              "z": 1.022
            },
            "gtin": "3616303458881",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546626",
        "height": 1.4989,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a207e1",
            "leftCorner": {
              "x": -7.837,
              "y": 31.396,
              "z": 1.226
            },
            "rightCorner": {
              "x": -7.93,
              "y": 31.402,
              "z": 1.226
            },
            "gtin": "4001499943973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207e2",
            "leftCorner": {
              "x": -7.93,
              "y": 31.402,
              "z": 1.226
            },
            "rightCorner": {
              "x": -8.023,
              "y": 31.408,
              "z": 1.226
            },
            "gtin": "4001499943973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207e3",
            "leftCorner": {
              "x": -8.024,
              "y": 31.392,
              "z": 1.226
            },
            "rightCorner": {
              "x": -8.136,
              "y": 31.398,
              "z": 1.226
            },
            "gtin": "4001499949180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207e4",
            "leftCorner": {
              "x": -8.136,
              "y": 31.398,
              "z": 1.226
            },
            "rightCorner": {
              "x": -8.24,
              "y": 31.405,
              "z": 1.226
            },
            "gtin": "4103040341013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207e5",
            "leftCorner": {
              "x": -8.24,
              "y": 31.405,
              "z": 1.226
            },
            "rightCorner": {
              "x": -8.345,
              "y": 31.411,
              "z": 1.226
            },
            "gtin": "4103040341013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207e6",
            "leftCorner": {
              "x": -8.344,
              "y": 31.418,
              "z": 1.226
            },
            "rightCorner": {
              "x": -8.456,
              "y": 31.424,
              "z": 1.226
            },
            "gtin": "4103040375018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207e7",
            "leftCorner": {
              "x": -8.456,
              "y": 31.424,
              "z": 1.226
            },
            "rightCorner": {
              "x": -8.567,
              "y": 31.431,
              "z": 1.226
            },
            "gtin": "4103040375018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207e8",
            "leftCorner": {
              "x": -8.567,
              "y": 31.431,
              "z": 1.226
            },
            "rightCorner": {
              "x": -8.678,
              "y": 31.438,
              "z": 1.226
            },
            "gtin": "4103040375018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207e9",
            "leftCorner": {
              "x": -8.678,
              "y": 31.45,
              "z": 1.226
            },
            "rightCorner": {
              "x": -8.737,
              "y": 31.453,
              "z": 1.226
            },
            "gtin": "4103040041937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207ea",
            "leftCorner": {
              "x": -8.737,
              "y": 31.453,
              "z": 1.226
            },
            "rightCorner": {
              "x": -8.795,
              "y": 31.457,
              "z": 1.226
            },
            "gtin": "4103040041937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207eb",
            "leftCorner": {
              "x": -8.796,
              "y": 31.446,
              "z": 1.226
            },
            "rightCorner": {
              "x": -8.897,
              "y": 31.452,
              "z": 1.226
            },
            "gtin": "4103040040565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207ec",
            "leftCorner": {
              "x": -8.897,
              "y": 31.442,
              "z": 1.226
            },
            "rightCorner": {
              "x": -8.975,
              "y": 31.446,
              "z": 1.226
            },
            "gtin": "4103040040589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207ed",
            "leftCorner": {
              "x": -8.975,
              "y": 31.446,
              "z": 1.226
            },
            "rightCorner": {
              "x": -9.053,
              "y": 31.451,
              "z": 1.226
            },
            "gtin": "4103040040589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207ee",
            "leftCorner": {
              "x": -9.053,
              "y": 31.451,
              "z": 1.226
            },
            "rightCorner": {
              "x": -9.131,
              "y": 31.455,
              "z": 1.226
            },
            "gtin": "4103040040589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207ef",
            "leftCorner": {
              "x": -9.131,
              "y": 31.455,
              "z": 1.226
            },
            "rightCorner": {
              "x": -9.209,
              "y": 31.46,
              "z": 1.226
            },
            "gtin": "4103040040589",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d5c",
    "rightNeighborShelfId": "a6d5e"
  },
  {
    "id": "a6d5e",
    "name": "a6d5e",
    "x": -9.107,
    "y": 31.699,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99957,
      "w": 0.029317
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 104
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546631",
        "height": 0.16315,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a208ee",
            "leftCorner": {
              "x": -9.108,
              "y": 31.688,
              "z": 0.133
            },
            "rightCorner": {
              "x": -9.18,
              "y": 31.692,
              "z": 0.133
            },
            "gtin": "8720181400254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208ef",
            "leftCorner": {
              "x": -9.18,
              "y": 31.692,
              "z": 0.133
            },
            "rightCorner": {
              "x": -9.254,
              "y": 31.696,
              "z": 0.133
            },
            "gtin": "8720181400254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208f0",
            "leftCorner": {
              "x": -9.254,
              "y": 31.696,
              "z": 0.133
            },
            "rightCorner": {
              "x": -9.327,
              "y": 31.7,
              "z": 0.133
            },
            "gtin": "8720181400254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208f1",
            "leftCorner": {
              "x": -9.327,
              "y": 31.7,
              "z": 0.133
            },
            "rightCorner": {
              "x": -9.4,
              "y": 31.705,
              "z": 0.133
            },
            "gtin": "8720181400254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208f5",
            "leftCorner": {
              "x": -9.402,
              "y": 31.667,
              "z": 0.133
            },
            "rightCorner": {
              "x": -9.534,
              "y": 31.675,
              "z": 0.133
            },
            "gtin": "8720181334139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208f6",
            "leftCorner": {
              "x": -9.534,
              "y": 31.675,
              "z": 0.133
            },
            "rightCorner": {
              "x": -9.665,
              "y": 31.683,
              "z": 0.133
            },
            "gtin": "8720181334139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208f7",
            "leftCorner": {
              "x": -9.665,
              "y": 31.683,
              "z": 0.133
            },
            "rightCorner": {
              "x": -9.797,
              "y": 31.69,
              "z": 0.133
            },
            "gtin": "8720181334139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208f8",
            "leftCorner": {
              "x": -9.797,
              "y": 31.69,
              "z": 0.133
            },
            "rightCorner": {
              "x": -9.928,
              "y": 31.698,
              "z": 0.133
            },
            "gtin": "8720181334139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208f9",
            "leftCorner": {
              "x": -9.929,
              "y": 31.686,
              "z": 0.133
            },
            "rightCorner": {
              "x": -9.994,
              "y": 31.69,
              "z": 0.133
            },
            "gtin": "8720181331268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208fa",
            "leftCorner": {
              "x": -9.993,
              "y": 31.699,
              "z": 0.133
            },
            "rightCorner": {
              "x": -10.106,
              "y": 31.705,
              "z": 0.133
            },
            "gtin": "8001280012464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208fb",
            "leftCorner": {
              "x": -10.106,
              "y": 31.703,
              "z": 0.133
            },
            "rightCorner": {
              "x": -10.181,
              "y": 31.707,
              "z": 0.133
            },
            "gtin": "4063367180248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208fc",
            "leftCorner": {
              "x": -10.181,
              "y": 31.713,
              "z": 0.133
            },
            "rightCorner": {
              "x": -10.237,
              "y": 31.716,
              "z": 0.133
            },
            "gtin": "4063367180224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208fd",
            "leftCorner": {
              "x": -10.237,
              "y": 31.716,
              "z": 0.133
            },
            "rightCorner": {
              "x": -10.293,
              "y": 31.72,
              "z": 0.133
            },
            "gtin": "4063367180224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208fe",
            "leftCorner": {
              "x": -10.293,
              "y": 31.719,
              "z": 0.133
            },
            "rightCorner": {
              "x": -10.355,
              "y": 31.723,
              "z": 0.133
            },
            "gtin": "4008268096977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208ff",
            "leftCorner": {
              "x": -10.355,
              "y": 31.723,
              "z": 0.133
            },
            "rightCorner": {
              "x": -10.416,
              "y": 31.726,
              "z": 0.133
            },
            "gtin": "4008268096977",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54662e",
        "height": 0.44917,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f8ff",
            "leftCorner": {
              "x": -9.105,
              "y": 31.553,
              "z": 0.368
            },
            "rightCorner": {
              "x": -9.159,
              "y": 31.555,
              "z": 0.368
            },
            "gtin": "4008233042541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f900",
            "leftCorner": {
              "x": -9.159,
              "y": 31.555,
              "z": 0.368
            },
            "rightCorner": {
              "x": -9.211,
              "y": 31.558,
              "z": 0.368
            },
            "gtin": "4008233042541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f901",
            "leftCorner": {
              "x": -9.211,
              "y": 31.553,
              "z": 0.368
            },
            "rightCorner": {
              "x": -9.272,
              "y": 31.557,
              "z": 0.368
            },
            "gtin": "4008233143583",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f902",
            "leftCorner": {
              "x": -9.272,
              "y": 31.557,
              "z": 0.368
            },
            "rightCorner": {
              "x": -9.334,
              "y": 31.56,
              "z": 0.368
            },
            "gtin": "4008233143583",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f903",
            "leftCorner": {
              "x": -9.333,
              "y": 31.571,
              "z": 0.368
            },
            "rightCorner": {
              "x": -9.391,
              "y": 31.574,
              "z": 0.368
            },
            "gtin": "4008233176901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f904",
            "leftCorner": {
              "x": -9.391,
              "y": 31.571,
              "z": 0.368
            },
            "rightCorner": {
              "x": -9.485,
              "y": 31.577,
              "z": 0.368
            },
            "gtin": "4008233168739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f905",
            "leftCorner": {
              "x": -9.485,
              "y": 31.568,
              "z": 0.368
            },
            "rightCorner": {
              "x": -9.571,
              "y": 31.572,
              "z": 0.368
            },
            "gtin": "4025089080701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f906",
            "leftCorner": {
              "x": -9.57,
              "y": 31.585,
              "z": 0.368
            },
            "rightCorner": {
              "x": -9.625,
              "y": 31.588,
              "z": 0.368
            },
            "gtin": "4025089081036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f907",
            "leftCorner": {
              "x": -9.625,
              "y": 31.582,
              "z": 0.368
            },
            "rightCorner": {
              "x": -9.71,
              "y": 31.586,
              "z": 0.368
            },
            "gtin": "5000101100468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f908",
            "leftCorner": {
              "x": -9.709,
              "y": 31.592,
              "z": 0.368
            },
            "rightCorner": {
              "x": -9.795,
              "y": 31.596,
              "z": 0.368
            },
            "gtin": "5000101845208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f909",
            "leftCorner": {
              "x": -9.795,
              "y": 31.588,
              "z": 0.368
            },
            "rightCorner": {
              "x": -9.865,
              "y": 31.593,
              "z": 0.368
            },
            "gtin": "5000101844997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f90a",
            "leftCorner": {
              "x": -9.865,
              "y": 31.593,
              "z": 0.368
            },
            "rightCorner": {
              "x": -9.935,
              "y": 31.597,
              "z": 0.368
            },
            "gtin": "5000101844997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f90b",
            "leftCorner": {
              "x": -9.935,
              "y": 31.596,
              "z": 0.368
            },
            "rightCorner": {
              "x": -10.004,
              "y": 31.6,
              "z": 0.368
            },
            "gtin": "5000101077005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f90c",
            "leftCorner": {
              "x": -10.004,
              "y": 31.6,
              "z": 0.368
            },
            "rightCorner": {
              "x": -10.073,
              "y": 31.604,
              "z": 0.368
            },
            "gtin": "5000101077005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f90d",
            "leftCorner": {
              "x": -10.072,
              "y": 31.611,
              "z": 0.368
            },
            "rightCorner": {
              "x": -10.137,
              "y": 31.615,
              "z": 0.368
            },
            "gtin": "5000101845116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f90e",
            "leftCorner": {
              "x": -10.137,
              "y": 31.613,
              "z": 0.368
            },
            "rightCorner": {
              "x": -10.185,
              "y": 31.616,
              "z": 0.368
            },
            "gtin": "5000101152672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f90f",
            "leftCorner": {
              "x": -10.185,
              "y": 31.616,
              "z": 0.368
            },
            "rightCorner": {
              "x": -10.233,
              "y": 31.619,
              "z": 0.368
            },
            "gtin": "5000101152672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f889",
            "leftCorner": {
              "x": -10.233,
              "y": 31.604,
              "z": 0.368
            },
            "rightCorner": {
              "x": -10.364,
              "y": 31.612,
              "z": 0.368
            },
            "gtin": "8714789732916",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54662f",
        "height": 0.74293,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a208e0",
            "leftCorner": {
              "x": -9.114,
              "y": 31.564,
              "z": 0.608
            },
            "rightCorner": {
              "x": -9.199,
              "y": 31.569,
              "z": 0.608
            },
            "gtin": "4006000137476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208e1",
            "leftCorner": {
              "x": -9.2,
              "y": 31.565,
              "z": 0.608
            },
            "rightCorner": {
              "x": -9.278,
              "y": 31.569,
              "z": 0.608
            },
            "gtin": "4006000137551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208e2",
            "leftCorner": {
              "x": -9.278,
              "y": 31.569,
              "z": 0.608
            },
            "rightCorner": {
              "x": -9.356,
              "y": 31.574,
              "z": 0.608
            },
            "gtin": "4006000137551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208e3",
            "leftCorner": {
              "x": -9.356,
              "y": 31.574,
              "z": 0.608
            },
            "rightCorner": {
              "x": -9.434,
              "y": 31.579,
              "z": 0.608
            },
            "gtin": "4006000137551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208e4",
            "leftCorner": {
              "x": -9.434,
              "y": 31.573,
              "z": 0.608
            },
            "rightCorner": {
              "x": -9.507,
              "y": 31.577,
              "z": 0.608
            },
            "gtin": "4005900972750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208e5",
            "leftCorner": {
              "x": -9.507,
              "y": 31.57,
              "z": 0.608
            },
            "rightCorner": {
              "x": -9.604,
              "y": 31.576,
              "z": 0.608
            },
            "gtin": "8714789939780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208e6",
            "leftCorner": {
              "x": -9.604,
              "y": 31.576,
              "z": 0.608
            },
            "rightCorner": {
              "x": -9.7,
              "y": 31.582,
              "z": 0.608
            },
            "gtin": "8714789939780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208e7",
            "leftCorner": {
              "x": -9.7,
              "y": 31.582,
              "z": 0.608
            },
            "rightCorner": {
              "x": -9.796,
              "y": 31.587,
              "z": 0.608
            },
            "gtin": "8714789939780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208e8",
            "leftCorner": {
              "x": -9.796,
              "y": 31.585,
              "z": 0.608
            },
            "rightCorner": {
              "x": -9.908,
              "y": 31.592,
              "z": 0.608
            },
            "gtin": "8718951427471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208e9",
            "leftCorner": {
              "x": -9.908,
              "y": 31.592,
              "z": 0.608
            },
            "rightCorner": {
              "x": -10.02,
              "y": 31.598,
              "z": 0.608
            },
            "gtin": "8718951427471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208ea",
            "leftCorner": {
              "x": -10.019,
              "y": 31.608,
              "z": 0.608
            },
            "rightCorner": {
              "x": -10.124,
              "y": 31.614,
              "z": 0.608
            },
            "gtin": "8714789732947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208eb",
            "leftCorner": {
              "x": -10.124,
              "y": 31.614,
              "z": 0.608
            },
            "rightCorner": {
              "x": -10.229,
              "y": 31.62,
              "z": 0.608
            },
            "gtin": "8714789732947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208ec",
            "leftCorner": {
              "x": -10.229,
              "y": 31.62,
              "z": 0.608
            },
            "rightCorner": {
              "x": -10.335,
              "y": 31.626,
              "z": 0.608
            },
            "gtin": "8714789732947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208ed",
            "leftCorner": {
              "x": -10.335,
              "y": 31.626,
              "z": 0.608
            },
            "rightCorner": {
              "x": -10.44,
              "y": 31.632,
              "z": 0.608
            },
            "gtin": "8714789732947",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54662c",
        "height": 0.99251,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20845",
            "leftCorner": {
              "x": -9.154,
              "y": 31.58,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.228,
              "y": 31.584,
              "z": 0.812
            },
            "gtin": "4017512170271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20846",
            "leftCorner": {
              "x": -9.228,
              "y": 31.577,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.299,
              "y": 31.581,
              "z": 0.812
            },
            "gtin": "4021457648443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20847",
            "leftCorner": {
              "x": -9.299,
              "y": 31.583,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.373,
              "y": 31.588,
              "z": 0.812
            },
            "gtin": "4021457648429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20848",
            "leftCorner": {
              "x": -9.373,
              "y": 31.582,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.424,
              "y": 31.585,
              "z": 0.812
            },
            "gtin": "4021457648412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20849",
            "leftCorner": {
              "x": -9.424,
              "y": 31.589,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.501,
              "y": 31.594,
              "z": 0.812
            },
            "gtin": "4021457648436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2084a",
            "leftCorner": {
              "x": -9.501,
              "y": 31.581,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.56,
              "y": 31.584,
              "z": 0.812
            },
            "gtin": "7611916124501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2084b",
            "leftCorner": {
              "x": -9.56,
              "y": 31.584,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.625,
              "y": 31.588,
              "z": 0.812
            },
            "gtin": "7611916125720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2084c",
            "leftCorner": {
              "x": -9.625,
              "y": 31.588,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.691,
              "y": 31.592,
              "z": 0.812
            },
            "gtin": "7611916125720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2084d",
            "leftCorner": {
              "x": -9.69,
              "y": 31.599,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.754,
              "y": 31.603,
              "z": 0.812
            },
            "gtin": "7611916160769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2084e",
            "leftCorner": {
              "x": -9.754,
              "y": 31.594,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.822,
              "y": 31.598,
              "z": 0.812
            },
            "gtin": "8008970056609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2084f",
            "leftCorner": {
              "x": -9.822,
              "y": 31.598,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.89,
              "y": 31.602,
              "z": 0.812
            },
            "gtin": "8008970056609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20850",
            "leftCorner": {
              "x": -9.89,
              "y": 31.594,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.95,
              "y": 31.598,
              "z": 0.812
            },
            "gtin": "8008970056586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20851",
            "leftCorner": {
              "x": -9.95,
              "y": 31.598,
              "z": 0.812
            },
            "rightCorner": {
              "x": -10.009,
              "y": 31.601,
              "z": 0.812
            },
            "gtin": "8008970056586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20852",
            "leftCorner": {
              "x": -10.009,
              "y": 31.601,
              "z": 0.812
            },
            "rightCorner": {
              "x": -10.069,
              "y": 31.604,
              "z": 0.812
            },
            "gtin": "8008970056586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20853",
            "leftCorner": {
              "x": -10.069,
              "y": 31.604,
              "z": 0.812
            },
            "rightCorner": {
              "x": -10.128,
              "y": 31.608,
              "z": 0.812
            },
            "gtin": "8008970056586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20854",
            "leftCorner": {
              "x": -10.128,
              "y": 31.604,
              "z": 0.812
            },
            "rightCorner": {
              "x": -10.234,
              "y": 31.61,
              "z": 0.812
            },
            "gtin": "4015100427561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20855",
            "leftCorner": {
              "x": -10.234,
              "y": 31.61,
              "z": 0.812
            },
            "rightCorner": {
              "x": -10.34,
              "y": 31.616,
              "z": 0.812
            },
            "gtin": "4015100427561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20856",
            "leftCorner": {
              "x": -10.34,
              "y": 31.616,
              "z": 0.812
            },
            "rightCorner": {
              "x": -10.446,
              "y": 31.623,
              "z": 0.812
            },
            "gtin": "4015100427561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20857",
            "leftCorner": {
              "x": -10.446,
              "y": 31.623,
              "z": 0.812
            },
            "rightCorner": {
              "x": -10.552,
              "y": 31.628,
              "z": 0.812
            },
            "gtin": "4015100427561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20858",
            "leftCorner": {
              "x": -10.552,
              "y": 31.628,
              "z": 0.812
            },
            "rightCorner": {
              "x": -10.659,
              "y": 31.635,
              "z": 0.812
            },
            "gtin": "4015100427561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20859",
            "leftCorner": {
              "x": -10.659,
              "y": 31.635,
              "z": 0.812
            },
            "rightCorner": {
              "x": -10.765,
              "y": 31.641,
              "z": 0.812
            },
            "gtin": "4015100427561",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54662d",
        "height": 1.2533,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a2088e",
            "leftCorner": {
              "x": -9.109,
              "y": 31.46,
              "z": 1.025
            },
            "rightCorner": {
              "x": -9.165,
              "y": 31.463,
              "z": 1.025
            },
            "gtin": "3616305824868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2088f",
            "leftCorner": {
              "x": -9.165,
              "y": 31.463,
              "z": 1.025
            },
            "rightCorner": {
              "x": -9.221,
              "y": 31.466,
              "z": 1.025
            },
            "gtin": "3616305824868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20890",
            "leftCorner": {
              "x": -9.222,
              "y": 31.46,
              "z": 1.025
            },
            "rightCorner": {
              "x": -9.288,
              "y": 31.464,
              "z": 1.025
            },
            "gtin": "3616303459123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20891",
            "leftCorner": {
              "x": -9.288,
              "y": 31.464,
              "z": 1.025
            },
            "rightCorner": {
              "x": -9.354,
              "y": 31.468,
              "z": 1.025
            },
            "gtin": "3616303459123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20892",
            "leftCorner": {
              "x": -9.354,
              "y": 31.471,
              "z": 1.025
            },
            "rightCorner": {
              "x": -9.402,
              "y": 31.473,
              "z": 1.025
            },
            "gtin": "4063367425240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20893",
            "leftCorner": {
              "x": -9.403,
              "y": 31.468,
              "z": 1.025
            },
            "rightCorner": {
              "x": -9.455,
              "y": 31.472,
              "z": 1.025
            },
            "gtin": "4063367425202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20894",
            "leftCorner": {
              "x": -9.454,
              "y": 31.49,
              "z": 1.025
            },
            "rightCorner": {
              "x": -9.525,
              "y": 31.494,
              "z": 1.025
            },
            "gtin": "8720181458033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20895",
            "leftCorner": {
              "x": -9.525,
              "y": 31.494,
              "z": 1.025
            },
            "rightCorner": {
              "x": -9.598,
              "y": 31.497,
              "z": 1.025
            },
            "gtin": "8720181458033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20896",
            "leftCorner": {
              "x": -9.598,
              "y": 31.497,
              "z": 1.025
            },
            "rightCorner": {
              "x": -9.671,
              "y": 31.502,
              "z": 1.025
            },
            "gtin": "8720181458033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20897",
            "leftCorner": {
              "x": -9.671,
              "y": 31.484,
              "z": 1.025
            },
            "rightCorner": {
              "x": -9.748,
              "y": 31.488,
              "z": 1.025
            },
            "gtin": "8720181443459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20898",
            "leftCorner": {
              "x": -9.748,
              "y": 31.488,
              "z": 1.025
            },
            "rightCorner": {
              "x": -9.825,
              "y": 31.493,
              "z": 1.025
            },
            "gtin": "8720181443459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20899",
            "leftCorner": {
              "x": -9.825,
              "y": 31.493,
              "z": 1.025
            },
            "rightCorner": {
              "x": -9.901,
              "y": 31.498,
              "z": 1.025
            },
            "gtin": "8720181443459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2089a",
            "leftCorner": {
              "x": -9.901,
              "y": 31.498,
              "z": 1.025
            },
            "rightCorner": {
              "x": -9.978,
              "y": 31.502,
              "z": 1.025
            },
            "gtin": "8720181443459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2089b",
            "leftCorner": {
              "x": -9.978,
              "y": 31.499,
              "z": 1.025
            },
            "rightCorner": {
              "x": -10.061,
              "y": 31.504,
              "z": 1.025
            },
            "gtin": "8720181456855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2089c",
            "leftCorner": {
              "x": -10.061,
              "y": 31.504,
              "z": 1.025
            },
            "rightCorner": {
              "x": -10.143,
              "y": 31.509,
              "z": 1.025
            },
            "gtin": "8720181456855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2089d",
            "leftCorner": {
              "x": -10.142,
              "y": 31.523,
              "z": 1.025
            },
            "rightCorner": {
              "x": -10.209,
              "y": 31.527,
              "z": 1.025
            },
            "gtin": "8720181507281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2089e",
            "leftCorner": {
              "x": -10.209,
              "y": 31.527,
              "z": 1.025
            },
            "rightCorner": {
              "x": -10.276,
              "y": 31.531,
              "z": 1.025
            },
            "gtin": "8720181507281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2089f",
            "leftCorner": {
              "x": -10.275,
              "y": 31.54,
              "z": 1.025
            },
            "rightCorner": {
              "x": -10.33,
              "y": 31.544,
              "z": 1.025
            },
            "gtin": "8720181608278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208a0",
            "leftCorner": {
              "x": -10.33,
              "y": 31.544,
              "z": 1.025
            },
            "rightCorner": {
              "x": -10.386,
              "y": 31.547,
              "z": 1.025
            },
            "gtin": "8720181608278",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546630",
        "height": 1.502,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a207f0",
            "leftCorner": {
              "x": -9.209,
              "y": 31.466,
              "z": 1.229
            },
            "rightCorner": {
              "x": -9.279,
              "y": 31.47,
              "z": 1.229
            },
            "gtin": "4103040102744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207f1",
            "leftCorner": {
              "x": -9.279,
              "y": 31.47,
              "z": 1.229
            },
            "rightCorner": {
              "x": -9.347,
              "y": 31.474,
              "z": 1.229
            },
            "gtin": "4103040102744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207f2",
            "leftCorner": {
              "x": -9.347,
              "y": 31.472,
              "z": 1.229
            },
            "rightCorner": {
              "x": -9.415,
              "y": 31.476,
              "z": 1.229
            },
            "gtin": "8720181491948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207f3",
            "leftCorner": {
              "x": -9.415,
              "y": 31.476,
              "z": 1.229
            },
            "rightCorner": {
              "x": -9.482,
              "y": 31.479,
              "z": 1.229
            },
            "gtin": "8720181491948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207f4",
            "leftCorner": {
              "x": -9.483,
              "y": 31.472,
              "z": 1.229
            },
            "rightCorner": {
              "x": -9.56,
              "y": 31.477,
              "z": 1.229
            },
            "gtin": "8720181460029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207f5",
            "leftCorner": {
              "x": -9.56,
              "y": 31.477,
              "z": 1.229
            },
            "rightCorner": {
              "x": -9.637,
              "y": 31.482,
              "z": 1.229
            },
            "gtin": "8720181460029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207f6",
            "leftCorner": {
              "x": -9.637,
              "y": 31.482,
              "z": 1.229
            },
            "rightCorner": {
              "x": -9.715,
              "y": 31.486,
              "z": 1.229
            },
            "gtin": "8720181460029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207f7",
            "leftCorner": {
              "x": -9.714,
              "y": 31.501,
              "z": 1.229
            },
            "rightCorner": {
              "x": -9.794,
              "y": 31.506,
              "z": 1.229
            },
            "gtin": "8720181465826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207f8",
            "leftCorner": {
              "x": -9.795,
              "y": 31.486,
              "z": 1.229
            },
            "rightCorner": {
              "x": -9.864,
              "y": 31.49,
              "z": 1.229
            },
            "gtin": "8720181466526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207f9",
            "leftCorner": {
              "x": -9.864,
              "y": 31.49,
              "z": 1.229
            },
            "rightCorner": {
              "x": -9.932,
              "y": 31.495,
              "z": 1.229
            },
            "gtin": "8720181466526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207fa",
            "leftCorner": {
              "x": -9.932,
              "y": 31.506,
              "z": 1.229
            },
            "rightCorner": {
              "x": -10.062,
              "y": 31.513,
              "z": 1.229
            },
            "gtin": "8720181657498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207fb",
            "leftCorner": {
              "x": -10.062,
              "y": 31.505,
              "z": 1.229
            },
            "rightCorner": {
              "x": -10.131,
              "y": 31.51,
              "z": 1.229
            },
            "gtin": "8720181468520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207fc",
            "leftCorner": {
              "x": -10.131,
              "y": 31.51,
              "z": 1.229
            },
            "rightCorner": {
              "x": -10.2,
              "y": 31.514,
              "z": 1.229
            },
            "gtin": "8720181468520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207fd",
            "leftCorner": {
              "x": -10.2,
              "y": 31.523,
              "z": 1.229
            },
            "rightCorner": {
              "x": -10.27,
              "y": 31.527,
              "z": 1.229
            },
            "gtin": "8720181471629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207fe",
            "leftCorner": {
              "x": -10.27,
              "y": 31.527,
              "z": 1.229
            },
            "rightCorner": {
              "x": -10.339,
              "y": 31.531,
              "z": 1.229
            },
            "gtin": "8720181471629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207ff",
            "leftCorner": {
              "x": -10.339,
              "y": 31.531,
              "z": 1.229
            },
            "rightCorner": {
              "x": -10.409,
              "y": 31.535,
              "z": 1.229
            },
            "gtin": "8720181471629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20800",
            "leftCorner": {
              "x": -10.409,
              "y": 31.535,
              "z": 1.229
            },
            "rightCorner": {
              "x": -10.478,
              "y": 31.54,
              "z": 1.229
            },
            "gtin": "8720181471629",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d5d",
    "rightNeighborShelfId": "a6d5f"
  },
  {
    "id": "a6d5f",
    "name": "a6d5f",
    "x": -10.355,
    "y": 31.772,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99957,
      "w": 0.029317
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 65
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546635",
        "height": 0.16277,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20900",
            "leftCorner": {
              "x": -10.417,
              "y": 31.718,
              "z": 0.133
            },
            "rightCorner": {
              "x": -10.506,
              "y": 31.723,
              "z": 0.133
            },
            "gtin": "8714789732879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20901",
            "leftCorner": {
              "x": -10.506,
              "y": 31.723,
              "z": 0.133
            },
            "rightCorner": {
              "x": -10.593,
              "y": 31.729,
              "z": 0.133
            },
            "gtin": "8714789732879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20902",
            "leftCorner": {
              "x": -10.593,
              "y": 31.729,
              "z": 0.133
            },
            "rightCorner": {
              "x": -10.68,
              "y": 31.733,
              "z": 0.133
            },
            "gtin": "8714789732879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20903",
            "leftCorner": {
              "x": -10.68,
              "y": 31.733,
              "z": 0.133
            },
            "rightCorner": {
              "x": -10.769,
              "y": 31.739,
              "z": 0.133
            },
            "gtin": "8714789732879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20904",
            "leftCorner": {
              "x": -10.769,
              "y": 31.74,
              "z": 0.133
            },
            "rightCorner": {
              "x": -10.84,
              "y": 31.745,
              "z": 0.133
            },
            "gtin": "8714789732893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20905",
            "leftCorner": {
              "x": -10.84,
              "y": 31.745,
              "z": 0.133
            },
            "rightCorner": {
              "x": -10.912,
              "y": 31.749,
              "z": 0.133
            },
            "gtin": "8714789732893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20906",
            "leftCorner": {
              "x": -10.912,
              "y": 31.749,
              "z": 0.133
            },
            "rightCorner": {
              "x": -10.985,
              "y": 31.753,
              "z": 0.133
            },
            "gtin": "8714789732893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20907",
            "leftCorner": {
              "x": -10.985,
              "y": 31.749,
              "z": 0.133
            },
            "rightCorner": {
              "x": -11.081,
              "y": 31.756,
              "z": 0.133
            },
            "gtin": "8718951424647",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20908",
            "leftCorner": {
              "x": -11.081,
              "y": 31.756,
              "z": 0.133
            },
            "rightCorner": {
              "x": -11.177,
              "y": 31.761,
              "z": 0.133
            },
            "gtin": "8718951424647",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20909",
            "leftCorner": {
              "x": -11.177,
              "y": 31.761,
              "z": 0.133
            },
            "rightCorner": {
              "x": -11.272,
              "y": 31.767,
              "z": 0.133
            },
            "gtin": "8718951424647",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2090a",
            "leftCorner": {
              "x": -11.272,
              "y": 31.767,
              "z": 0.133
            },
            "rightCorner": {
              "x": -11.368,
              "y": 31.772,
              "z": 0.133
            },
            "gtin": "8718951424647",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208f2",
            "leftCorner": {
              "x": -11.368,
              "y": 31.771,
              "z": 0.133
            },
            "rightCorner": {
              "x": -11.448,
              "y": 31.775,
              "z": 0.133
            },
            "gtin": "8718951076181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208f3",
            "leftCorner": {
              "x": -11.448,
              "y": 31.775,
              "z": 0.133
            },
            "rightCorner": {
              "x": -11.527,
              "y": 31.78,
              "z": 0.133
            },
            "gtin": "8718951076181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208f4",
            "leftCorner": {
              "x": -11.527,
              "y": 31.78,
              "z": 0.133
            },
            "rightCorner": {
              "x": -11.607,
              "y": 31.784,
              "z": 0.133
            },
            "gtin": "8718951076181",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546636",
        "height": 0.43843,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a2090b",
            "leftCorner": {
              "x": -10.362,
              "y": 31.654,
              "z": 0.359
            },
            "rightCorner": {
              "x": -10.496,
              "y": 31.661,
              "z": 0.359
            },
            "gtin": "8714789732886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2090c",
            "leftCorner": {
              "x": -10.496,
              "y": 31.661,
              "z": 0.359
            },
            "rightCorner": {
              "x": -10.631,
              "y": 31.669,
              "z": 0.359
            },
            "gtin": "8714789732886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2090d",
            "leftCorner": {
              "x": -10.631,
              "y": 31.669,
              "z": 0.359
            },
            "rightCorner": {
              "x": -10.766,
              "y": 31.678,
              "z": 0.359
            },
            "gtin": "8714789732886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2090e",
            "leftCorner": {
              "x": -10.766,
              "y": 31.678,
              "z": 0.359
            },
            "rightCorner": {
              "x": -10.9,
              "y": 31.686,
              "z": 0.359
            },
            "gtin": "8714789732886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2090f",
            "leftCorner": {
              "x": -10.9,
              "y": 31.686,
              "z": 0.359
            },
            "rightCorner": {
              "x": -11.034,
              "y": 31.693,
              "z": 0.359
            },
            "gtin": "8714789732886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20915",
            "leftCorner": {
              "x": -11.036,
              "y": 31.652,
              "z": 0.359
            },
            "rightCorner": {
              "x": -11.115,
              "y": 31.657,
              "z": 0.359
            },
            "gtin": "8714789732923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20916",
            "leftCorner": {
              "x": -11.115,
              "y": 31.657,
              "z": 0.359
            },
            "rightCorner": {
              "x": -11.193,
              "y": 31.661,
              "z": 0.359
            },
            "gtin": "8714789732923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20917",
            "leftCorner": {
              "x": -11.193,
              "y": 31.661,
              "z": 0.359
            },
            "rightCorner": {
              "x": -11.272,
              "y": 31.667,
              "z": 0.359
            },
            "gtin": "8714789732923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20910",
            "leftCorner": {
              "x": -11.272,
              "y": 31.664,
              "z": 0.359
            },
            "rightCorner": {
              "x": -11.34,
              "y": 31.667,
              "z": 0.359
            },
            "gtin": "8718951076228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20911",
            "leftCorner": {
              "x": -11.34,
              "y": 31.667,
              "z": 0.359
            },
            "rightCorner": {
              "x": -11.409,
              "y": 31.672,
              "z": 0.359
            },
            "gtin": "8718951076228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20912",
            "leftCorner": {
              "x": -11.409,
              "y": 31.672,
              "z": 0.359
            },
            "rightCorner": {
              "x": -11.476,
              "y": 31.675,
              "z": 0.359
            },
            "gtin": "8718951076228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20913",
            "leftCorner": {
              "x": -11.476,
              "y": 31.675,
              "z": 0.359
            },
            "rightCorner": {
              "x": -11.545,
              "y": 31.68,
              "z": 0.359
            },
            "gtin": "8718951076228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20914",
            "leftCorner": {
              "x": -11.545,
              "y": 31.68,
              "z": 0.359
            },
            "rightCorner": {
              "x": -11.612,
              "y": 31.684,
              "z": 0.359
            },
            "gtin": "8718951076228",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546633",
        "height": 0.73952,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a208b2",
            "leftCorner": {
              "x": -10.44,
              "y": 31.631,
              "z": 0.605
            },
            "rightCorner": {
              "x": -10.675,
              "y": 31.645,
              "z": 0.605
            },
            "gtin": "4015100428087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208b3",
            "leftCorner": {
              "x": -10.675,
              "y": 31.645,
              "z": 0.605
            },
            "rightCorner": {
              "x": -10.909,
              "y": 31.658,
              "z": 0.605
            },
            "gtin": "4015100428087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208b4",
            "leftCorner": {
              "x": -10.909,
              "y": 31.658,
              "z": 0.605
            },
            "rightCorner": {
              "x": -11.143,
              "y": 31.673,
              "z": 0.605
            },
            "gtin": "4015100428087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208b5",
            "leftCorner": {
              "x": -11.143,
              "y": 31.673,
              "z": 0.605
            },
            "rightCorner": {
              "x": -11.378,
              "y": 31.686,
              "z": 0.605
            },
            "gtin": "4015100428087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208b6",
            "leftCorner": {
              "x": -11.378,
              "y": 31.686,
              "z": 0.605
            },
            "rightCorner": {
              "x": -11.612,
              "y": 31.7,
              "z": 0.605
            },
            "gtin": "4015100428087",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546637",
        "height": 0.99349,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a2080d",
            "leftCorner": {
              "x": -10.764,
              "y": 31.656,
              "z": 0.813
            },
            "rightCorner": {
              "x": -10.933,
              "y": 31.666,
              "z": 0.813
            },
            "gtin": "4015100427967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2080e",
            "leftCorner": {
              "x": -10.933,
              "y": 31.666,
              "z": 0.813
            },
            "rightCorner": {
              "x": -11.103,
              "y": 31.676,
              "z": 0.813
            },
            "gtin": "4015100427967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2080f",
            "leftCorner": {
              "x": -11.103,
              "y": 31.676,
              "z": 0.813
            },
            "rightCorner": {
              "x": -11.272,
              "y": 31.686,
              "z": 0.813
            },
            "gtin": "4015100427967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20810",
            "leftCorner": {
              "x": -11.272,
              "y": 31.686,
              "z": 0.813
            },
            "rightCorner": {
              "x": -11.442,
              "y": 31.696,
              "z": 0.813
            },
            "gtin": "4015100427967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20811",
            "leftCorner": {
              "x": -11.442,
              "y": 31.696,
              "z": 0.813
            },
            "rightCorner": {
              "x": -11.611,
              "y": 31.706,
              "z": 0.813
            },
            "gtin": "4015100427967",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546632",
        "height": 1.2545,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a208a1",
            "leftCorner": {
              "x": -10.388,
              "y": 31.53,
              "z": 1.026
            },
            "rightCorner": {
              "x": -10.462,
              "y": 31.535,
              "z": 1.026
            },
            "gtin": "5060591038320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208a2",
            "leftCorner": {
              "x": -10.462,
              "y": 31.535,
              "z": 1.026
            },
            "rightCorner": {
              "x": -10.537,
              "y": 31.539,
              "z": 1.026
            },
            "gtin": "5060591038320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208a3",
            "leftCorner": {
              "x": -10.537,
              "y": 31.536,
              "z": 1.026
            },
            "rightCorner": {
              "x": -10.611,
              "y": 31.541,
              "z": 1.026
            },
            "gtin": "5060591038337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208a4",
            "leftCorner": {
              "x": -10.611,
              "y": 31.541,
              "z": 1.026
            },
            "rightCorner": {
              "x": -10.685,
              "y": 31.545,
              "z": 1.026
            },
            "gtin": "5060591038337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208a5",
            "leftCorner": {
              "x": -10.685,
              "y": 31.545,
              "z": 1.026
            },
            "rightCorner": {
              "x": -10.84,
              "y": 31.554,
              "z": 1.026
            },
            "gtin": "5060591038344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208a6",
            "leftCorner": {
              "x": -10.841,
              "y": 31.543,
              "z": 1.026
            },
            "rightCorner": {
              "x": -10.921,
              "y": 31.548,
              "z": 1.026
            },
            "gtin": "4015100427981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208a7",
            "leftCorner": {
              "x": -10.921,
              "y": 31.546,
              "z": 1.026
            },
            "rightCorner": {
              "x": -10.992,
              "y": 31.549,
              "z": 1.026
            },
            "gtin": "4015100428001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208a8",
            "leftCorner": {
              "x": -10.992,
              "y": 31.549,
              "z": 1.026
            },
            "rightCorner": {
              "x": -11.062,
              "y": 31.554,
              "z": 1.026
            },
            "gtin": "4015100428001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208a9",
            "leftCorner": {
              "x": -11.062,
              "y": 31.554,
              "z": 1.026
            },
            "rightCorner": {
              "x": -11.133,
              "y": 31.558,
              "z": 1.026
            },
            "gtin": "4015100428001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208aa",
            "leftCorner": {
              "x": -11.133,
              "y": 31.558,
              "z": 1.026
            },
            "rightCorner": {
              "x": -11.204,
              "y": 31.563,
              "z": 1.026
            },
            "gtin": "4015100428001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208ab",
            "leftCorner": {
              "x": -11.204,
              "y": 31.563,
              "z": 1.026
            },
            "rightCorner": {
              "x": -11.274,
              "y": 31.567,
              "z": 1.026
            },
            "gtin": "4015100428001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a208ac",
            "leftCorner": {
              "x": -11.274,
              "y": 31.567,
              "z": 1.026
            },
            "rightCorner": {
              "x": -11.345,
              "y": 31.57,
              "z": 1.026
            },
            "gtin": "4015100428001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2085c",
            "leftCorner": {
              "x": -11.344,
              "y": 31.585,
              "z": 1.026
            },
            "rightCorner": {
              "x": -11.413,
              "y": 31.589,
              "z": 1.026
            },
            "gtin": "4015100427547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2085d",
            "leftCorner": {
              "x": -11.413,
              "y": 31.589,
              "z": 1.026
            },
            "rightCorner": {
              "x": -11.481,
              "y": 31.594,
              "z": 1.026
            },
            "gtin": "4015100427547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2085e",
            "leftCorner": {
              "x": -11.481,
              "y": 31.594,
              "z": 1.026
            },
            "rightCorner": {
              "x": -11.549,
              "y": 31.597,
              "z": 1.026
            },
            "gtin": "4015100427547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2085f",
            "leftCorner": {
              "x": -11.549,
              "y": 31.597,
              "z": 1.026
            },
            "rightCorner": {
              "x": -11.618,
              "y": 31.602,
              "z": 1.026
            },
            "gtin": "4015100427547",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546634",
        "height": 1.5002,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20801",
            "leftCorner": {
              "x": -10.479,
              "y": 31.539,
              "z": 1.227
            },
            "rightCorner": {
              "x": -10.546,
              "y": 31.543,
              "z": 1.227
            },
            "gtin": "8720181657504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20802",
            "leftCorner": {
              "x": -10.546,
              "y": 31.543,
              "z": 1.227
            },
            "rightCorner": {
              "x": -10.615,
              "y": 31.547,
              "z": 1.227
            },
            "gtin": "8720181657504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20803",
            "leftCorner": {
              "x": -10.616,
              "y": 31.536,
              "z": 1.227
            },
            "rightCorner": {
              "x": -10.758,
              "y": 31.544,
              "z": 1.227
            },
            "gtin": "8720181466373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20804",
            "leftCorner": {
              "x": -10.758,
              "y": 31.544,
              "z": 1.227
            },
            "rightCorner": {
              "x": -10.901,
              "y": 31.553,
              "z": 1.227
            },
            "gtin": "8720181466373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20805",
            "leftCorner": {
              "x": -10.901,
              "y": 31.553,
              "z": 1.227
            },
            "rightCorner": {
              "x": -11.042,
              "y": 31.56,
              "z": 1.227
            },
            "gtin": "8720181466373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20806",
            "leftCorner": {
              "x": -11.041,
              "y": 31.575,
              "z": 1.227
            },
            "rightCorner": {
              "x": -11.116,
              "y": 31.579,
              "z": 1.227
            },
            "gtin": "3616303444495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20807",
            "leftCorner": {
              "x": -11.116,
              "y": 31.579,
              "z": 1.227
            },
            "rightCorner": {
              "x": -11.191,
              "y": 31.584,
              "z": 1.227
            },
            "gtin": "3616303444495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20808",
            "leftCorner": {
              "x": -11.192,
              "y": 31.566,
              "z": 1.227
            },
            "rightCorner": {
              "x": -11.261,
              "y": 31.57,
              "z": 1.227
            },
            "gtin": "3616303444105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20809",
            "leftCorner": {
              "x": -11.261,
              "y": 31.57,
              "z": 1.227
            },
            "rightCorner": {
              "x": -11.329,
              "y": 31.574,
              "z": 1.227
            },
            "gtin": "3616303444105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207c1",
            "leftCorner": {
              "x": -11.328,
              "y": 31.596,
              "z": 1.227
            },
            "rightCorner": {
              "x": -11.425,
              "y": 31.602,
              "z": 1.227
            },
            "gtin": "3616305259370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207c2",
            "leftCorner": {
              "x": -11.425,
              "y": 31.602,
              "z": 1.227
            },
            "rightCorner": {
              "x": -11.52,
              "y": 31.608,
              "z": 1.227
            },
            "gtin": "3616305259370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a207c3",
            "leftCorner": {
              "x": -11.52,
              "y": 31.608,
              "z": 1.227
            },
            "rightCorner": {
              "x": -11.617,
              "y": 31.613,
              "z": 1.227
            },
            "gtin": "3616305259370",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d5e"
  },
  {
    "id": "a6d60",
    "name": "a6d60",
    "x": -6.694,
    "y": 30.583,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.035929,
      "w": 0.99935
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 77
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5465ed",
        "height": 0.15953,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20692",
            "leftCorner": {
              "x": -6.591,
              "y": 30.613,
              "z": 0.131
            },
            "rightCorner": {
              "x": -6.305,
              "y": 30.593,
              "z": 0.131
            },
            "gtin": "8700216557603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20693",
            "leftCorner": {
              "x": -6.305,
              "y": 30.593,
              "z": 0.131
            },
            "rightCorner": {
              "x": -6.019,
              "y": 30.572,
              "z": 0.131
            },
            "gtin": "8700216557603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20694",
            "leftCorner": {
              "x": -6.018,
              "y": 30.579,
              "z": 0.131
            },
            "rightCorner": {
              "x": -5.844,
              "y": 30.566,
              "z": 0.131
            },
            "gtin": "8700216529389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20695",
            "leftCorner": {
              "x": -5.844,
              "y": 30.566,
              "z": 0.131
            },
            "rightCorner": {
              "x": -5.67,
              "y": 30.554,
              "z": 0.131
            },
            "gtin": "8700216529389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20696",
            "leftCorner": {
              "x": -5.669,
              "y": 30.563,
              "z": 0.131
            },
            "rightCorner": {
              "x": -5.402,
              "y": 30.545,
              "z": 0.131
            },
            "gtin": "8700216155700",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465ec",
        "height": 0.48817,
        "facings": [
          {
            "id": "68300c895ed67a01d9a205c9",
            "leftCorner": {
              "x": -6.267,
              "y": 30.699,
              "z": 0.399
            },
            "rightCorner": {
              "x": -6.227,
              "y": 30.697,
              "z": 0.399
            },
            "gtin": "42447597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205ca",
            "leftCorner": {
              "x": -6.227,
              "y": 30.697,
              "z": 0.399
            },
            "rightCorner": {
              "x": -6.187,
              "y": 30.694,
              "z": 0.399
            },
            "gtin": "42447597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205cb",
            "leftCorner": {
              "x": -6.186,
              "y": 30.696,
              "z": 0.399
            },
            "rightCorner": {
              "x": -6.135,
              "y": 30.692,
              "z": 0.399
            },
            "gtin": "42447559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205cc",
            "leftCorner": {
              "x": -6.135,
              "y": 30.692,
              "z": 0.399
            },
            "rightCorner": {
              "x": -6.084,
              "y": 30.688,
              "z": 0.399
            },
            "gtin": "42447559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205cd",
            "leftCorner": {
              "x": -6.084,
              "y": 30.687,
              "z": 0.399
            },
            "rightCorner": {
              "x": -6.039,
              "y": 30.683,
              "z": 0.399
            },
            "gtin": "42447573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205ce",
            "leftCorner": {
              "x": -6.039,
              "y": 30.683,
              "z": 0.399
            },
            "rightCorner": {
              "x": -5.993,
              "y": 30.68,
              "z": 0.399
            },
            "gtin": "42447573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205cf",
            "leftCorner": {
              "x": -5.994,
              "y": 30.664,
              "z": 0.399
            },
            "rightCorner": {
              "x": -5.951,
              "y": 30.662,
              "z": 0.399
            },
            "gtin": "42447580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205d0",
            "leftCorner": {
              "x": -5.951,
              "y": 30.662,
              "z": 0.399
            },
            "rightCorner": {
              "x": -5.909,
              "y": 30.659,
              "z": 0.399
            },
            "gtin": "42447580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205d1",
            "leftCorner": {
              "x": -5.909,
              "y": 30.652,
              "z": 0.399
            },
            "rightCorner": {
              "x": -5.804,
              "y": 30.644,
              "z": 0.399
            },
            "gtin": "42447603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205d2",
            "leftCorner": {
              "x": -5.803,
              "y": 30.667,
              "z": 0.399
            },
            "rightCorner": {
              "x": -5.768,
              "y": 30.665,
              "z": 0.399
            },
            "gtin": "3600523193226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205d3",
            "leftCorner": {
              "x": -5.768,
              "y": 30.665,
              "z": 0.399
            },
            "rightCorner": {
              "x": -5.733,
              "y": 30.662,
              "z": 0.399
            },
            "gtin": "3600523193226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205d4",
            "leftCorner": {
              "x": -5.733,
              "y": 30.66,
              "z": 0.399
            },
            "rightCorner": {
              "x": -5.684,
              "y": 30.657,
              "z": 0.399
            },
            "gtin": "3600523193196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205d5",
            "leftCorner": {
              "x": -5.684,
              "y": 30.657,
              "z": 0.399
            },
            "rightCorner": {
              "x": -5.634,
              "y": 30.653,
              "z": 0.399
            },
            "gtin": "3600523193196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205d6",
            "leftCorner": {
              "x": -5.634,
              "y": 30.653,
              "z": 0.399
            },
            "rightCorner": {
              "x": -5.584,
              "y": 30.65,
              "z": 0.399
            },
            "gtin": "3600523193196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205d7",
            "leftCorner": {
              "x": -5.584,
              "y": 30.647,
              "z": 0.399
            },
            "rightCorner": {
              "x": -5.537,
              "y": 30.643,
              "z": 0.399
            },
            "gtin": "3600524026264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205d8",
            "leftCorner": {
              "x": -5.537,
              "y": 30.643,
              "z": 0.399
            },
            "rightCorner": {
              "x": -5.489,
              "y": 30.639,
              "z": 0.399
            },
            "gtin": "3600524026264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205d9",
            "leftCorner": {
              "x": -5.489,
              "y": 30.639,
              "z": 0.399
            },
            "rightCorner": {
              "x": -5.447,
              "y": 30.637,
              "z": 0.399
            },
            "gtin": "3600523193219",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465ea",
        "height": 0.74086,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20518",
            "leftCorner": {
              "x": -6.647,
              "y": 30.726,
              "z": 0.606
            },
            "rightCorner": {
              "x": -6.564,
              "y": 30.721,
              "z": 0.606
            },
            "gtin": "4015100814279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20519",
            "leftCorner": {
              "x": -6.564,
              "y": 30.717,
              "z": 0.606
            },
            "rightCorner": {
              "x": -6.468,
              "y": 30.71,
              "z": 0.606
            },
            "gtin": "4015100814316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2051a",
            "leftCorner": {
              "x": -6.467,
              "y": 30.717,
              "z": 0.606
            },
            "rightCorner": {
              "x": -6.364,
              "y": 30.711,
              "z": 0.606
            },
            "gtin": "4015100814330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2051b",
            "leftCorner": {
              "x": -6.365,
              "y": 30.704,
              "z": 0.606
            },
            "rightCorner": {
              "x": -6.26,
              "y": 30.696,
              "z": 0.606
            },
            "gtin": "4015100814255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2051c",
            "leftCorner": {
              "x": -6.26,
              "y": 30.695,
              "z": 0.606
            },
            "rightCorner": {
              "x": -6.19,
              "y": 30.69,
              "z": 0.606
            },
            "gtin": "4015100192247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2051d",
            "leftCorner": {
              "x": -6.19,
              "y": 30.694,
              "z": 0.606
            },
            "rightCorner": {
              "x": -6.083,
              "y": 30.687,
              "z": 0.606
            },
            "gtin": "4015100803044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2051e",
            "leftCorner": {
              "x": -6.083,
              "y": 30.684,
              "z": 0.606
            },
            "rightCorner": {
              "x": -5.984,
              "y": 30.678,
              "z": 0.606
            },
            "gtin": "4015100803068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2051f",
            "leftCorner": {
              "x": -5.983,
              "y": 30.682,
              "z": 0.606
            },
            "rightCorner": {
              "x": -5.89,
              "y": 30.676,
              "z": 0.606
            },
            "gtin": "4015000529136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20520",
            "leftCorner": {
              "x": -5.89,
              "y": 30.673,
              "z": 0.606
            },
            "rightCorner": {
              "x": -5.801,
              "y": 30.667,
              "z": 0.606
            },
            "gtin": "4015000529150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20521",
            "leftCorner": {
              "x": -5.801,
              "y": 30.667,
              "z": 0.606
            },
            "rightCorner": {
              "x": -5.712,
              "y": 30.66,
              "z": 0.606
            },
            "gtin": "4015000529150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20522",
            "leftCorner": {
              "x": -5.712,
              "y": 30.656,
              "z": 0.606
            },
            "rightCorner": {
              "x": -5.599,
              "y": 30.648,
              "z": 0.606
            },
            "gtin": "4015000529167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20523",
            "leftCorner": {
              "x": -5.599,
              "y": 30.648,
              "z": 0.606
            },
            "rightCorner": {
              "x": -5.486,
              "y": 30.64,
              "z": 0.606
            },
            "gtin": "4015000529167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20524",
            "leftCorner": {
              "x": -5.486,
              "y": 30.634,
              "z": 0.606
            },
            "rightCorner": {
              "x": -5.4,
              "y": 30.628,
              "z": 0.606
            },
            "gtin": "4015000529174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20525",
            "leftCorner": {
              "x": -5.4,
              "y": 30.628,
              "z": 0.606
            },
            "rightCorner": {
              "x": -5.314,
              "y": 30.622,
              "z": 0.606
            },
            "gtin": "4015000529174",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465e9",
        "height": 0.98994,
        "facings": [
          {
            "id": "68300c895ed67a01d9a204df",
            "leftCorner": {
              "x": -6.692,
              "y": 30.727,
              "z": 0.81
            },
            "rightCorner": {
              "x": -6.606,
              "y": 30.721,
              "z": 0.81
            },
            "gtin": "4015100441369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204e0",
            "leftCorner": {
              "x": -6.606,
              "y": 30.721,
              "z": 0.81
            },
            "rightCorner": {
              "x": -6.519,
              "y": 30.715,
              "z": 0.81
            },
            "gtin": "4015100441369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204e1",
            "leftCorner": {
              "x": -6.52,
              "y": 30.713,
              "z": 0.81
            },
            "rightCorner": {
              "x": -6.42,
              "y": 30.705,
              "z": 0.81
            },
            "gtin": "4015100441321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204e2",
            "leftCorner": {
              "x": -6.42,
              "y": 30.705,
              "z": 0.81
            },
            "rightCorner": {
              "x": -6.32,
              "y": 30.699,
              "z": 0.81
            },
            "gtin": "4015100441321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204e3",
            "leftCorner": {
              "x": -6.32,
              "y": 30.701,
              "z": 0.81
            },
            "rightCorner": {
              "x": -6.201,
              "y": 30.693,
              "z": 0.81
            },
            "gtin": "4015100441475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204e4",
            "leftCorner": {
              "x": -6.202,
              "y": 30.689,
              "z": 0.81
            },
            "rightCorner": {
              "x": -6.101,
              "y": 30.681,
              "z": 0.81
            },
            "gtin": "4015100441512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204e5",
            "leftCorner": {
              "x": -6.101,
              "y": 30.677,
              "z": 0.81
            },
            "rightCorner": {
              "x": -6.003,
              "y": 30.671,
              "z": 0.81
            },
            "gtin": "4015100441499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204e6",
            "leftCorner": {
              "x": -6.003,
              "y": 30.671,
              "z": 0.81
            },
            "rightCorner": {
              "x": -5.905,
              "y": 30.664,
              "z": 0.81
            },
            "gtin": "4015100441499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204e7",
            "leftCorner": {
              "x": -5.905,
              "y": 30.662,
              "z": 0.81
            },
            "rightCorner": {
              "x": -5.791,
              "y": 30.653,
              "z": 0.81
            },
            "gtin": "4015100441697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204e8",
            "leftCorner": {
              "x": -5.791,
              "y": 30.647,
              "z": 0.81
            },
            "rightCorner": {
              "x": -5.694,
              "y": 30.641,
              "z": 0.81
            },
            "gtin": "4015100441673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204e9",
            "leftCorner": {
              "x": -5.693,
              "y": 30.647,
              "z": 0.81
            },
            "rightCorner": {
              "x": -5.59,
              "y": 30.639,
              "z": 0.81
            },
            "gtin": "4015100441659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204ea",
            "leftCorner": {
              "x": -5.59,
              "y": 30.639,
              "z": 0.81
            },
            "rightCorner": {
              "x": -5.486,
              "y": 30.632,
              "z": 0.81
            },
            "gtin": "4015100441659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204eb",
            "leftCorner": {
              "x": -5.486,
              "y": 30.638,
              "z": 0.81
            },
            "rightCorner": {
              "x": -5.428,
              "y": 30.634,
              "z": 0.81
            },
            "gtin": "4015100441710",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465e8",
        "height": 1.2454,
        "facings": [
          {
            "id": "68300c895ed67a01d9a204a6",
            "leftCorner": {
              "x": -6.697,
              "y": 30.73,
              "z": 1.019
            },
            "rightCorner": {
              "x": -6.623,
              "y": 30.726,
              "z": 1.019
            },
            "gtin": "4015100817669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204a7",
            "leftCorner": {
              "x": -6.623,
              "y": 30.726,
              "z": 1.019
            },
            "rightCorner": {
              "x": -6.549,
              "y": 30.72,
              "z": 1.019
            },
            "gtin": "4015100817669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204a8",
            "leftCorner": {
              "x": -6.549,
              "y": 30.72,
              "z": 1.019
            },
            "rightCorner": {
              "x": -6.476,
              "y": 30.715,
              "z": 1.019
            },
            "gtin": "4015100817669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204a9",
            "leftCorner": {
              "x": -6.475,
              "y": 30.716,
              "z": 1.019
            },
            "rightCorner": {
              "x": -6.389,
              "y": 30.709,
              "z": 1.019
            },
            "gtin": "4015100817720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204aa",
            "leftCorner": {
              "x": -6.389,
              "y": 30.703,
              "z": 1.019
            },
            "rightCorner": {
              "x": -6.298,
              "y": 30.696,
              "z": 1.019
            },
            "gtin": "4015100817348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204ab",
            "leftCorner": {
              "x": -6.299,
              "y": 30.691,
              "z": 1.019
            },
            "rightCorner": {
              "x": -6.215,
              "y": 30.685,
              "z": 1.019
            },
            "gtin": "4015100817645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204ac",
            "leftCorner": {
              "x": -6.215,
              "y": 30.685,
              "z": 1.019
            },
            "rightCorner": {
              "x": -6.132,
              "y": 30.679,
              "z": 1.019
            },
            "gtin": "4015100817645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204ad",
            "leftCorner": {
              "x": -6.131,
              "y": 30.685,
              "z": 1.019
            },
            "rightCorner": {
              "x": -6.027,
              "y": 30.679,
              "z": 1.019
            },
            "gtin": "4015100817447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204ae",
            "leftCorner": {
              "x": -6.027,
              "y": 30.678,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.913,
              "y": 30.669,
              "z": 1.019
            },
            "gtin": "3600542563758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204af",
            "leftCorner": {
              "x": -5.913,
              "y": 30.673,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.801,
              "y": 30.665,
              "z": 1.019
            },
            "gtin": "3600542563727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204b0",
            "leftCorner": {
              "x": -5.801,
              "y": 30.657,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.692,
              "y": 30.649,
              "z": 1.019
            },
            "gtin": "3600542563741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204b1",
            "leftCorner": {
              "x": -5.692,
              "y": 30.646,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.6,
              "y": 30.639,
              "z": 1.019
            },
            "gtin": "3600542563734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204b2",
            "leftCorner": {
              "x": -5.6,
              "y": 30.639,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.508,
              "y": 30.632,
              "z": 1.019
            },
            "gtin": "3600542563734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204b3",
            "leftCorner": {
              "x": -5.508,
              "y": 30.637,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.436,
              "y": 30.632,
              "z": 1.019
            },
            "gtin": "4015100441512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204b4",
            "leftCorner": {
              "x": -5.436,
              "y": 30.632,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.365,
              "y": 30.626,
              "z": 1.019
            },
            "gtin": "4015100441512",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465eb",
        "height": 1.4961,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2056c",
            "leftCorner": {
              "x": -6.677,
              "y": 30.712,
              "z": 1.224
            },
            "rightCorner": {
              "x": -6.555,
              "y": 30.703,
              "z": 1.224
            },
            "gtin": "3600523714544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2056d",
            "leftCorner": {
              "x": -6.554,
              "y": 30.709,
              "z": 1.224
            },
            "rightCorner": {
              "x": -6.447,
              "y": 30.701,
              "z": 1.224
            },
            "gtin": "3600523714551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2056e",
            "leftCorner": {
              "x": -6.448,
              "y": 30.695,
              "z": 1.224
            },
            "rightCorner": {
              "x": -6.378,
              "y": 30.691,
              "z": 1.224
            },
            "gtin": "3600523714490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2056f",
            "leftCorner": {
              "x": -6.378,
              "y": 30.692,
              "z": 1.224
            },
            "rightCorner": {
              "x": -6.237,
              "y": 30.681,
              "z": 1.224
            },
            "gtin": "3600523714476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20570",
            "leftCorner": {
              "x": -6.237,
              "y": 30.685,
              "z": 1.224
            },
            "rightCorner": {
              "x": -6.14,
              "y": 30.679,
              "z": 1.224
            },
            "gtin": "3600523714537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20571",
            "leftCorner": {
              "x": -6.141,
              "y": 30.66,
              "z": 1.224
            },
            "rightCorner": {
              "x": -6.039,
              "y": 30.652,
              "z": 1.224
            },
            "gtin": "3600523714414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20572",
            "leftCorner": {
              "x": -6.038,
              "y": 30.666,
              "z": 1.224
            },
            "rightCorner": {
              "x": -5.924,
              "y": 30.658,
              "z": 1.224
            },
            "gtin": "3600523714506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20573",
            "leftCorner": {
              "x": -5.924,
              "y": 30.664,
              "z": 1.224
            },
            "rightCorner": {
              "x": -5.822,
              "y": 30.657,
              "z": 1.224
            },
            "gtin": "3600523714438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20574",
            "leftCorner": {
              "x": -5.821,
              "y": 30.659,
              "z": 1.224
            },
            "rightCorner": {
              "x": -5.76,
              "y": 30.655,
              "z": 1.224
            },
            "gtin": "3600523714513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20575",
            "leftCorner": {
              "x": -5.76,
              "y": 30.655,
              "z": 1.224
            },
            "rightCorner": {
              "x": -5.698,
              "y": 30.65,
              "z": 1.224
            },
            "gtin": "3600523714513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20576",
            "leftCorner": {
              "x": -5.698,
              "y": 30.646,
              "z": 1.224
            },
            "rightCorner": {
              "x": -5.586,
              "y": 30.638,
              "z": 1.224
            },
            "gtin": "3600523941063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20577",
            "leftCorner": {
              "x": -5.586,
              "y": 30.642,
              "z": 1.224
            },
            "rightCorner": {
              "x": -5.486,
              "y": 30.635,
              "z": 1.224
            },
            "gtin": "3600523941117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20578",
            "leftCorner": {
              "x": -5.486,
              "y": 30.631,
              "z": 1.224
            },
            "rightCorner": {
              "x": -5.42,
              "y": 30.627,
              "z": 1.224
            },
            "gtin": "3600523940967",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "468c8",
    "rightNeighborShelfId": "a6d61"
  },
  {
    "id": "a6d61",
    "name": "a6d61",
    "x": -5.447,
    "y": 30.494,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.035929,
      "w": 0.99935
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 90
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546655",
        "height": 0.16423,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20697",
            "leftCorner": {
              "x": -5.403,
              "y": 30.53,
              "z": 0.134
            },
            "rightCorner": {
              "x": -5.33,
              "y": 30.524,
              "z": 0.134
            },
            "gtin": "8001090896049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20698",
            "leftCorner": {
              "x": -5.33,
              "y": 30.524,
              "z": 0.134
            },
            "rightCorner": {
              "x": -5.258,
              "y": 30.519,
              "z": 0.134
            },
            "gtin": "8001090896049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20699",
            "leftCorner": {
              "x": -5.257,
              "y": 30.533,
              "z": 0.134
            },
            "rightCorner": {
              "x": -5.15,
              "y": 30.525,
              "z": 0.134
            },
            "gtin": "8001090896599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2069a",
            "leftCorner": {
              "x": -5.149,
              "y": 30.533,
              "z": 0.134
            },
            "rightCorner": {
              "x": -5.053,
              "y": 30.526,
              "z": 0.134
            },
            "gtin": "8001090896735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2069b",
            "leftCorner": {
              "x": -5.053,
              "y": 30.526,
              "z": 0.134
            },
            "rightCorner": {
              "x": -4.956,
              "y": 30.52,
              "z": 0.134
            },
            "gtin": "8001090896735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2069c",
            "leftCorner": {
              "x": -4.956,
              "y": 30.521,
              "z": 0.134
            },
            "rightCorner": {
              "x": -4.873,
              "y": 30.515,
              "z": 0.134
            },
            "gtin": "8001090896216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2069d",
            "leftCorner": {
              "x": -4.873,
              "y": 30.515,
              "z": 0.134
            },
            "rightCorner": {
              "x": -4.79,
              "y": 30.508,
              "z": 0.134
            },
            "gtin": "8001090896216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2069e",
            "leftCorner": {
              "x": -4.791,
              "y": 30.504,
              "z": 0.134
            },
            "rightCorner": {
              "x": -4.713,
              "y": 30.5,
              "z": 0.134
            },
            "gtin": "8001090896315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2069f",
            "leftCorner": {
              "x": -4.713,
              "y": 30.5,
              "z": 0.134
            },
            "rightCorner": {
              "x": -4.635,
              "y": 30.494,
              "z": 0.134
            },
            "gtin": "8001090896315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206a0",
            "leftCorner": {
              "x": -4.636,
              "y": 30.487,
              "z": 0.134
            },
            "rightCorner": {
              "x": -4.56,
              "y": 30.481,
              "z": 0.134
            },
            "gtin": "8001090895806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206a1",
            "leftCorner": {
              "x": -4.56,
              "y": 30.481,
              "z": 0.134
            },
            "rightCorner": {
              "x": -4.485,
              "y": 30.477,
              "z": 0.134
            },
            "gtin": "8001090895806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206a2",
            "leftCorner": {
              "x": -4.484,
              "y": 30.48,
              "z": 0.134
            },
            "rightCorner": {
              "x": -4.307,
              "y": 30.466,
              "z": 0.134
            },
            "gtin": "8001090941848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206a3",
            "leftCorner": {
              "x": -4.308,
              "y": 30.459,
              "z": 0.134
            },
            "rightCorner": {
              "x": -4.237,
              "y": 30.454,
              "z": 0.134
            },
            "gtin": "8001090891334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206a4",
            "leftCorner": {
              "x": -4.237,
              "y": 30.454,
              "z": 0.134
            },
            "rightCorner": {
              "x": -4.165,
              "y": 30.45,
              "z": 0.134
            },
            "gtin": "8001090891334",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546650",
        "height": 0.48897,
        "facings": [
          {
            "id": "68300c895ed67a01d9a205da",
            "leftCorner": {
              "x": -5.446,
              "y": 30.646,
              "z": 0.4
            },
            "rightCorner": {
              "x": -5.411,
              "y": 30.644,
              "z": 0.4
            },
            "gtin": "3600523193202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205db",
            "leftCorner": {
              "x": -5.411,
              "y": 30.644,
              "z": 0.4
            },
            "rightCorner": {
              "x": -5.376,
              "y": 30.641,
              "z": 0.4
            },
            "gtin": "3600523193202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205dc",
            "leftCorner": {
              "x": -5.376,
              "y": 30.639,
              "z": 0.4
            },
            "rightCorner": {
              "x": -5.342,
              "y": 30.637,
              "z": 0.4
            },
            "gtin": "3600523193189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205dd",
            "leftCorner": {
              "x": -5.342,
              "y": 30.637,
              "z": 0.4
            },
            "rightCorner": {
              "x": -5.308,
              "y": 30.634,
              "z": 0.4
            },
            "gtin": "3600523193189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205de",
            "leftCorner": {
              "x": -5.308,
              "y": 30.634,
              "z": 0.4
            },
            "rightCorner": {
              "x": -5.274,
              "y": 30.632,
              "z": 0.4
            },
            "gtin": "3600523193189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205df",
            "leftCorner": {
              "x": -5.275,
              "y": 30.617,
              "z": 0.4
            },
            "rightCorner": {
              "x": -5.196,
              "y": 30.611,
              "z": 0.4
            },
            "gtin": "3600523337477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205e0",
            "leftCorner": {
              "x": -5.196,
              "y": 30.608,
              "z": 0.4
            },
            "rightCorner": {
              "x": -5.154,
              "y": 30.605,
              "z": 0.4
            },
            "gtin": "4015100863499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205e1",
            "leftCorner": {
              "x": -5.154,
              "y": 30.605,
              "z": 0.4
            },
            "rightCorner": {
              "x": -5.112,
              "y": 30.601,
              "z": 0.4
            },
            "gtin": "4015100863499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205e2",
            "leftCorner": {
              "x": -5.112,
              "y": 30.601,
              "z": 0.4
            },
            "rightCorner": {
              "x": -5.07,
              "y": 30.599,
              "z": 0.4
            },
            "gtin": "4015100863499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205e3",
            "leftCorner": {
              "x": -5.07,
              "y": 30.608,
              "z": 0.4
            },
            "rightCorner": {
              "x": -5.02,
              "y": 30.605,
              "z": 0.4
            },
            "gtin": "4015100863482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205e4",
            "leftCorner": {
              "x": -5.02,
              "y": 30.605,
              "z": 0.4
            },
            "rightCorner": {
              "x": -4.971,
              "y": 30.601,
              "z": 0.4
            },
            "gtin": "4015100863482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205e5",
            "leftCorner": {
              "x": -4.97,
              "y": 30.617,
              "z": 0.4
            },
            "rightCorner": {
              "x": -4.908,
              "y": 30.612,
              "z": 0.4
            },
            "gtin": "4015100863512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205e6",
            "leftCorner": {
              "x": -4.909,
              "y": 30.606,
              "z": 0.4
            },
            "rightCorner": {
              "x": -4.845,
              "y": 30.602,
              "z": 0.4
            },
            "gtin": "4015100863505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205e7",
            "leftCorner": {
              "x": -4.845,
              "y": 30.608,
              "z": 0.4
            },
            "rightCorner": {
              "x": -4.679,
              "y": 30.596,
              "z": 0.4
            },
            "gtin": "3600524043537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205e8",
            "leftCorner": {
              "x": -4.68,
              "y": 30.579,
              "z": 0.4
            },
            "rightCorner": {
              "x": -4.598,
              "y": 30.573,
              "z": 0.4
            },
            "gtin": "3600524043636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205e9",
            "leftCorner": {
              "x": -4.598,
              "y": 30.573,
              "z": 0.4
            },
            "rightCorner": {
              "x": -4.515,
              "y": 30.567,
              "z": 0.4
            },
            "gtin": "3600524043636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205ea",
            "leftCorner": {
              "x": -4.515,
              "y": 30.567,
              "z": 0.4
            },
            "rightCorner": {
              "x": -4.424,
              "y": 30.561,
              "z": 0.4
            },
            "gtin": "3600524043834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205eb",
            "leftCorner": {
              "x": -4.424,
              "y": 30.561,
              "z": 0.4
            },
            "rightCorner": {
              "x": -4.332,
              "y": 30.555,
              "z": 0.4
            },
            "gtin": "3600524043834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205ec",
            "leftCorner": {
              "x": -4.331,
              "y": 30.571,
              "z": 0.4
            },
            "rightCorner": {
              "x": -4.233,
              "y": 30.564,
              "z": 0.4
            },
            "gtin": "40058139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205ed",
            "leftCorner": {
              "x": -4.233,
              "y": 30.566,
              "z": 0.4
            },
            "rightCorner": {
              "x": -4.161,
              "y": 30.561,
              "z": 0.4
            },
            "gtin": "4063367433429",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546653",
        "height": 0.7416,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20526",
            "leftCorner": {
              "x": -5.313,
              "y": 30.632,
              "z": 0.607
            },
            "rightCorner": {
              "x": -5.177,
              "y": 30.623,
              "z": 0.607
            },
            "gtin": "4015100728880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20527",
            "leftCorner": {
              "x": -5.177,
              "y": 30.623,
              "z": 0.607
            },
            "rightCorner": {
              "x": -5.042,
              "y": 30.613,
              "z": 0.607
            },
            "gtin": "4015100728880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20528",
            "leftCorner": {
              "x": -5.042,
              "y": 30.613,
              "z": 0.607
            },
            "rightCorner": {
              "x": -4.907,
              "y": 30.603,
              "z": 0.607
            },
            "gtin": "4015100728880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20529",
            "leftCorner": {
              "x": -4.906,
              "y": 30.612,
              "z": 0.607
            },
            "rightCorner": {
              "x": -4.776,
              "y": 30.603,
              "z": 0.607
            },
            "gtin": "4015100802948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2052a",
            "leftCorner": {
              "x": -4.776,
              "y": 30.603,
              "z": 0.607
            },
            "rightCorner": {
              "x": -4.646,
              "y": 30.593,
              "z": 0.607
            },
            "gtin": "4015100802948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2052b",
            "leftCorner": {
              "x": -4.646,
              "y": 30.593,
              "z": 0.607
            },
            "rightCorner": {
              "x": -4.515,
              "y": 30.584,
              "z": 0.607
            },
            "gtin": "4015100802948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2052c",
            "leftCorner": {
              "x": -4.515,
              "y": 30.584,
              "z": 0.607
            },
            "rightCorner": {
              "x": -4.385,
              "y": 30.574,
              "z": 0.607
            },
            "gtin": "4015100802948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204fc",
            "leftCorner": {
              "x": -4.385,
              "y": 30.575,
              "z": 0.607
            },
            "rightCorner": {
              "x": -4.32,
              "y": 30.571,
              "z": 0.607
            },
            "gtin": "4015100432251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204fd",
            "leftCorner": {
              "x": -4.32,
              "y": 30.571,
              "z": 0.607
            },
            "rightCorner": {
              "x": -4.254,
              "y": 30.566,
              "z": 0.607
            },
            "gtin": "4015100432251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204fe",
            "leftCorner": {
              "x": -4.254,
              "y": 30.566,
              "z": 0.607
            },
            "rightCorner": {
              "x": -4.189,
              "y": 30.562,
              "z": 0.607
            },
            "gtin": "4015100432251",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546651",
        "height": 0.99324,
        "facings": [
          {
            "id": "68300c895ed67a01d9a204ec",
            "leftCorner": {
              "x": -5.427,
              "y": 30.644,
              "z": 0.813
            },
            "rightCorner": {
              "x": -5.347,
              "y": 30.639,
              "z": 0.813
            },
            "gtin": "4025089000501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204ed",
            "leftCorner": {
              "x": -5.348,
              "y": 30.63,
              "z": 0.813
            },
            "rightCorner": {
              "x": -5.271,
              "y": 30.624,
              "z": 0.813
            },
            "gtin": "4025089000518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204ee",
            "leftCorner": {
              "x": -5.27,
              "y": 30.63,
              "z": 0.813
            },
            "rightCorner": {
              "x": -5.178,
              "y": 30.624,
              "z": 0.813
            },
            "gtin": "4025089000488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204ef",
            "leftCorner": {
              "x": -5.178,
              "y": 30.624,
              "z": 0.813
            },
            "rightCorner": {
              "x": -5.085,
              "y": 30.617,
              "z": 0.813
            },
            "gtin": "4025089000488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204f0",
            "leftCorner": {
              "x": -5.084,
              "y": 30.624,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.961,
              "y": 30.615,
              "z": 0.813
            },
            "gtin": "4025089041870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204f1",
            "leftCorner": {
              "x": -4.962,
              "y": 30.603,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.851,
              "y": 30.595,
              "z": 0.813
            },
            "gtin": "4015100817089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204f2",
            "leftCorner": {
              "x": -4.851,
              "y": 30.588,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.795,
              "y": 30.584,
              "z": 0.813
            },
            "gtin": "4015100812138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204f3",
            "leftCorner": {
              "x": -4.795,
              "y": 30.584,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.74,
              "y": 30.58,
              "z": 0.813
            },
            "gtin": "4015100812138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204f4",
            "leftCorner": {
              "x": -4.738,
              "y": 30.604,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.69,
              "y": 30.601,
              "z": 0.813
            },
            "gtin": "4015100738100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204f5",
            "leftCorner": {
              "x": -4.69,
              "y": 30.601,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.642,
              "y": 30.598,
              "z": 0.813
            },
            "gtin": "4015100738100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204f6",
            "leftCorner": {
              "x": -4.643,
              "y": 30.592,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.567,
              "y": 30.586,
              "z": 0.813
            },
            "gtin": "4015100738124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204f7",
            "leftCorner": {
              "x": -4.568,
              "y": 30.579,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.479,
              "y": 30.572,
              "z": 0.813
            },
            "gtin": "4015100816426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204f8",
            "leftCorner": {
              "x": -4.48,
              "y": 30.563,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.415,
              "y": 30.559,
              "z": 0.813
            },
            "gtin": "4015100816402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204f9",
            "leftCorner": {
              "x": -4.415,
              "y": 30.564,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.335,
              "y": 30.558,
              "z": 0.813
            },
            "gtin": "4015100816365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204fa",
            "leftCorner": {
              "x": -4.336,
              "y": 30.551,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.237,
              "y": 30.544,
              "z": 0.813
            },
            "gtin": "4015100816341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204c4",
            "leftCorner": {
              "x": -4.236,
              "y": 30.551,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.19,
              "y": 30.548,
              "z": 0.813
            },
            "gtin": "7750075055438",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546654",
        "height": 1.2451,
        "facings": [
          {
            "id": "68300c895ed67a01d9a204b5",
            "leftCorner": {
              "x": -5.365,
              "y": 30.627,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.286,
              "y": 30.622,
              "z": 1.019
            },
            "gtin": "3600541374232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204b6",
            "leftCorner": {
              "x": -5.285,
              "y": 30.628,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.206,
              "y": 30.623,
              "z": 1.019
            },
            "gtin": "3600541374089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204b7",
            "leftCorner": {
              "x": -5.206,
              "y": 30.626,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.08,
              "y": 30.618,
              "z": 1.019
            },
            "gtin": "5029066011251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204b8",
            "leftCorner": {
              "x": -5.08,
              "y": 30.618,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.985,
              "y": 30.612,
              "z": 1.019
            },
            "gtin": "5057566628075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204b9",
            "leftCorner": {
              "x": -4.985,
              "y": 30.612,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.89,
              "y": 30.605,
              "z": 1.019
            },
            "gtin": "5057566628075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204ba",
            "leftCorner": {
              "x": -4.89,
              "y": 30.605,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.795,
              "y": 30.598,
              "z": 1.019
            },
            "gtin": "5057566628075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204bb",
            "leftCorner": {
              "x": -4.796,
              "y": 30.587,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.728,
              "y": 30.582,
              "z": 1.019
            },
            "gtin": "4015100215168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204bc",
            "leftCorner": {
              "x": -4.728,
              "y": 30.591,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.653,
              "y": 30.586,
              "z": 1.019
            },
            "gtin": "4015100215182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204bd",
            "leftCorner": {
              "x": -4.653,
              "y": 30.586,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.575,
              "y": 30.581,
              "z": 1.019
            },
            "gtin": "4104260075412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204be",
            "leftCorner": {
              "x": -4.574,
              "y": 30.588,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.509,
              "y": 30.583,
              "z": 1.019
            },
            "gtin": "4104260075405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204bf",
            "leftCorner": {
              "x": -4.51,
              "y": 30.574,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.421,
              "y": 30.567,
              "z": 1.019
            },
            "gtin": "4008890006405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204c0",
            "leftCorner": {
              "x": -4.421,
              "y": 30.562,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.372,
              "y": 30.559,
              "z": 1.019
            },
            "gtin": "4008890004128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a204c1",
            "leftCorner": {
              "x": -4.372,
              "y": 30.559,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.323,
              "y": 30.556,
              "z": 1.019
            },
            "gtin": "4008890004128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2048e",
            "leftCorner": {
              "x": -4.322,
              "y": 30.559,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.256,
              "y": 30.554,
              "z": 1.019
            },
            "gtin": "4008890006429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2048f",
            "leftCorner": {
              "x": -4.256,
              "y": 30.554,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.19,
              "y": 30.55,
              "z": 1.019
            },
            "gtin": "4008890006429",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546652",
        "height": 1.4939,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20579",
            "leftCorner": {
              "x": -5.418,
              "y": 30.642,
              "z": 1.222
            },
            "rightCorner": {
              "x": -5.329,
              "y": 30.636,
              "z": 1.222
            },
            "gtin": "3600523941018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2057a",
            "leftCorner": {
              "x": -5.33,
              "y": 30.631,
              "z": 1.222
            },
            "rightCorner": {
              "x": -5.221,
              "y": 30.623,
              "z": 1.222
            },
            "gtin": "3600523714452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2057b",
            "leftCorner": {
              "x": -5.222,
              "y": 30.616,
              "z": 1.222
            },
            "rightCorner": {
              "x": -5.115,
              "y": 30.608,
              "z": 1.222
            },
            "gtin": "3600523714445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2057c",
            "leftCorner": {
              "x": -5.115,
              "y": 30.608,
              "z": 1.222
            },
            "rightCorner": {
              "x": -5.008,
              "y": 30.6,
              "z": 1.222
            },
            "gtin": "3600523714445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2057d",
            "leftCorner": {
              "x": -5.008,
              "y": 30.599,
              "z": 1.222
            },
            "rightCorner": {
              "x": -4.886,
              "y": 30.59,
              "z": 1.222
            },
            "gtin": "3600523714407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2057e",
            "leftCorner": {
              "x": -4.886,
              "y": 30.598,
              "z": 1.222
            },
            "rightCorner": {
              "x": -4.794,
              "y": 30.592,
              "z": 1.222
            },
            "gtin": "3600523738137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2057f",
            "leftCorner": {
              "x": -4.794,
              "y": 30.594,
              "z": 1.222
            },
            "rightCorner": {
              "x": -4.704,
              "y": 30.587,
              "z": 1.222
            },
            "gtin": "4104260074804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20580",
            "leftCorner": {
              "x": -4.704,
              "y": 30.589,
              "z": 1.222
            },
            "rightCorner": {
              "x": -4.66,
              "y": 30.586,
              "z": 1.222
            },
            "gtin": "4104260074811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20581",
            "leftCorner": {
              "x": -4.66,
              "y": 30.586,
              "z": 1.222
            },
            "rightCorner": {
              "x": -4.615,
              "y": 30.583,
              "z": 1.222
            },
            "gtin": "4104260074811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20582",
            "leftCorner": {
              "x": -4.616,
              "y": 30.581,
              "z": 1.222
            },
            "rightCorner": {
              "x": -4.56,
              "y": 30.576,
              "z": 1.222
            },
            "gtin": "4104260074866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20583",
            "leftCorner": {
              "x": -4.561,
              "y": 30.567,
              "z": 1.222
            },
            "rightCorner": {
              "x": -4.49,
              "y": 30.563,
              "z": 1.222
            },
            "gtin": "4104260072107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20584",
            "leftCorner": {
              "x": -4.49,
              "y": 30.563,
              "z": 1.222
            },
            "rightCorner": {
              "x": -4.419,
              "y": 30.558,
              "z": 1.222
            },
            "gtin": "4104260072107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20585",
            "leftCorner": {
              "x": -4.419,
              "y": 30.557,
              "z": 1.222
            },
            "rightCorner": {
              "x": -4.348,
              "y": 30.552,
              "z": 1.222
            },
            "gtin": "4104260076501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20586",
            "leftCorner": {
              "x": -4.348,
              "y": 30.552,
              "z": 1.222
            },
            "rightCorner": {
              "x": -4.277,
              "y": 30.547,
              "z": 1.222
            },
            "gtin": "4104260076501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2052f",
            "leftCorner": {
              "x": -4.277,
              "y": 30.552,
              "z": 1.222
            },
            "rightCorner": {
              "x": -4.19,
              "y": 30.547,
              "z": 1.222
            },
            "gtin": "4036581526871",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d60",
    "rightNeighborShelfId": "a6d62"
  },
  {
    "id": "a6d62",
    "name": "a6d62",
    "x": -4.2,
    "y": 30.404,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.035929,
      "w": 0.99935
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 113
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a54665a",
        "height": 0.16439,
        "facings": [
          {
            "id": "68300c895ed67a01d9a206a5",
            "leftCorner": {
              "x": -4.166,
              "y": 30.435,
              "z": 0.135
            },
            "rightCorner": {
              "x": -4.09,
              "y": 30.429,
              "z": 0.135
            },
            "gtin": "8001090890528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206a6",
            "leftCorner": {
              "x": -4.089,
              "y": 30.442,
              "z": 0.135
            },
            "rightCorner": {
              "x": -4.011,
              "y": 30.436,
              "z": 0.135
            },
            "gtin": "8001090895349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206a7",
            "leftCorner": {
              "x": -4.011,
              "y": 30.436,
              "z": 0.135
            },
            "rightCorner": {
              "x": -3.934,
              "y": 30.431,
              "z": 0.135
            },
            "gtin": "8001090895349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206a8",
            "leftCorner": {
              "x": -3.933,
              "y": 30.44,
              "z": 0.135
            },
            "rightCorner": {
              "x": -3.857,
              "y": 30.435,
              "z": 0.135
            },
            "gtin": "8001090894366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206a9",
            "leftCorner": {
              "x": -3.857,
              "y": 30.435,
              "z": 0.135
            },
            "rightCorner": {
              "x": -3.781,
              "y": 30.429,
              "z": 0.135
            },
            "gtin": "8001090894366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206aa",
            "leftCorner": {
              "x": -3.782,
              "y": 30.409,
              "z": 0.135
            },
            "rightCorner": {
              "x": -3.696,
              "y": 30.403,
              "z": 0.135
            },
            "gtin": "8001090894991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206ab",
            "leftCorner": {
              "x": -3.696,
              "y": 30.403,
              "z": 0.135
            },
            "rightCorner": {
              "x": -3.61,
              "y": 30.397,
              "z": 0.135
            },
            "gtin": "8001090894991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206ac",
            "leftCorner": {
              "x": -3.611,
              "y": 30.396,
              "z": 0.135
            },
            "rightCorner": {
              "x": -3.549,
              "y": 30.391,
              "z": 0.135
            },
            "gtin": "8001090894878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206ad",
            "leftCorner": {
              "x": -3.549,
              "y": 30.391,
              "z": 0.135
            },
            "rightCorner": {
              "x": -3.488,
              "y": 30.386,
              "z": 0.135
            },
            "gtin": "8001090894878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206ae",
            "leftCorner": {
              "x": -3.487,
              "y": 30.398,
              "z": 0.135
            },
            "rightCorner": {
              "x": -3.414,
              "y": 30.393,
              "z": 0.135
            },
            "gtin": "8001090890054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206af",
            "leftCorner": {
              "x": -3.414,
              "y": 30.393,
              "z": 0.135
            },
            "rightCorner": {
              "x": -3.341,
              "y": 30.387,
              "z": 0.135
            },
            "gtin": "8001090890054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206b0",
            "leftCorner": {
              "x": -3.341,
              "y": 30.387,
              "z": 0.135
            },
            "rightCorner": {
              "x": -3.268,
              "y": 30.382,
              "z": 0.135
            },
            "gtin": "8001090890054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206b1",
            "leftCorner": {
              "x": -3.268,
              "y": 30.389,
              "z": 0.135
            },
            "rightCorner": {
              "x": -3.193,
              "y": 30.384,
              "z": 0.135
            },
            "gtin": "8001090892584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206b2",
            "leftCorner": {
              "x": -3.192,
              "y": 30.398,
              "z": 0.135
            },
            "rightCorner": {
              "x": -3.129,
              "y": 30.393,
              "z": 0.135
            },
            "gtin": "8001090892843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206b3",
            "leftCorner": {
              "x": -3.129,
              "y": 30.393,
              "z": 0.135
            },
            "rightCorner": {
              "x": -3.067,
              "y": 30.389,
              "z": 0.135
            },
            "gtin": "8001090892843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206b4",
            "leftCorner": {
              "x": -3.069,
              "y": 30.361,
              "z": 0.135
            },
            "rightCorner": {
              "x": -2.919,
              "y": 30.35,
              "z": 0.135
            },
            "gtin": "3600542511049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206b5",
            "leftCorner": {
              "x": -2.919,
              "y": 30.35,
              "z": 0.135
            },
            "rightCorner": {
              "x": -2.769,
              "y": 30.339,
              "z": 0.135
            },
            "gtin": "3600542511049",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546658",
        "height": 0.49597,
        "facings": [
          {
            "id": "68300c895ed67a01d9a205ee",
            "leftCorner": {
              "x": -4.161,
              "y": 30.553,
              "z": 0.406
            },
            "rightCorner": {
              "x": -4.104,
              "y": 30.549,
              "z": 0.406
            },
            "gtin": "4063367433443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205ef",
            "leftCorner": {
              "x": -4.104,
              "y": 30.549,
              "z": 0.406
            },
            "rightCorner": {
              "x": -4.046,
              "y": 30.545,
              "z": 0.406
            },
            "gtin": "4063367433443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205f0",
            "leftCorner": {
              "x": -4.046,
              "y": 30.546,
              "z": 0.406
            },
            "rightCorner": {
              "x": -3.998,
              "y": 30.542,
              "z": 0.406
            },
            "gtin": "8006540423202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205f1",
            "leftCorner": {
              "x": -3.998,
              "y": 30.536,
              "z": 0.406
            },
            "rightCorner": {
              "x": -3.927,
              "y": 30.531,
              "z": 0.406
            },
            "gtin": "8700216495981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205f2",
            "leftCorner": {
              "x": -3.927,
              "y": 30.533,
              "z": 0.406
            },
            "rightCorner": {
              "x": -3.85,
              "y": 30.528,
              "z": 0.406
            },
            "gtin": "8700216328661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205f3",
            "leftCorner": {
              "x": -3.85,
              "y": 30.525,
              "z": 0.406
            },
            "rightCorner": {
              "x": -3.795,
              "y": 30.521,
              "z": 0.406
            },
            "gtin": "8700216328760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205f4",
            "leftCorner": {
              "x": -3.796,
              "y": 30.514,
              "z": 0.406
            },
            "rightCorner": {
              "x": -3.727,
              "y": 30.509,
              "z": 0.406
            },
            "gtin": "8700216328609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205f5",
            "leftCorner": {
              "x": -3.727,
              "y": 30.51,
              "z": 0.406
            },
            "rightCorner": {
              "x": -3.655,
              "y": 30.504,
              "z": 0.406
            },
            "gtin": "8700216328746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205f6",
            "leftCorner": {
              "x": -3.655,
              "y": 30.507,
              "z": 0.406
            },
            "rightCorner": {
              "x": -3.591,
              "y": 30.503,
              "z": 0.406
            },
            "gtin": "3600542040037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205f7",
            "leftCorner": {
              "x": -3.592,
              "y": 30.492,
              "z": 0.406
            },
            "rightCorner": {
              "x": -3.53,
              "y": 30.487,
              "z": 0.406
            },
            "gtin": "3600542040150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205f8",
            "leftCorner": {
              "x": -3.531,
              "y": 30.482,
              "z": 0.406
            },
            "rightCorner": {
              "x": -3.487,
              "y": 30.478,
              "z": 0.406
            },
            "gtin": "3600542040013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205f9",
            "leftCorner": {
              "x": -3.487,
              "y": 30.475,
              "z": 0.406
            },
            "rightCorner": {
              "x": -3.436,
              "y": 30.472,
              "z": 0.406
            },
            "gtin": "3600542430289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205fa",
            "leftCorner": {
              "x": -3.436,
              "y": 30.472,
              "z": 0.406
            },
            "rightCorner": {
              "x": -3.386,
              "y": 30.468,
              "z": 0.406
            },
            "gtin": "3600542430289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205fb",
            "leftCorner": {
              "x": -3.385,
              "y": 30.473,
              "z": 0.406
            },
            "rightCorner": {
              "x": -3.324,
              "y": 30.468,
              "z": 0.406
            },
            "gtin": "3600542039970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205fc",
            "leftCorner": {
              "x": -3.323,
              "y": 30.481,
              "z": 0.406
            },
            "rightCorner": {
              "x": -3.251,
              "y": 30.475,
              "z": 0.406
            },
            "gtin": "3600542040129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205fd",
            "leftCorner": {
              "x": -3.251,
              "y": 30.467,
              "z": 0.406
            },
            "rightCorner": {
              "x": -3.17,
              "y": 30.462,
              "z": 0.406
            },
            "gtin": "3600542040068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205fe",
            "leftCorner": {
              "x": -3.17,
              "y": 30.459,
              "z": 0.406
            },
            "rightCorner": {
              "x": -3.127,
              "y": 30.456,
              "z": 0.406
            },
            "gtin": "3600542040075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a205ff",
            "leftCorner": {
              "x": -3.127,
              "y": 30.456,
              "z": 0.406
            },
            "rightCorner": {
              "x": -3.084,
              "y": 30.452,
              "z": 0.406
            },
            "gtin": "3600542040075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20600",
            "leftCorner": {
              "x": -3.083,
              "y": 30.461,
              "z": 0.406
            },
            "rightCorner": {
              "x": -2.994,
              "y": 30.456,
              "z": 0.406
            },
            "gtin": "3600542039994",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20601",
            "leftCorner": {
              "x": -2.993,
              "y": 30.478,
              "z": 0.406
            },
            "rightCorner": {
              "x": -2.924,
              "y": 30.472,
              "z": 0.406
            },
            "gtin": "3600542117920",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546656",
        "height": 0.79176,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a2097b",
            "leftCorner": {
              "x": -4.193,
              "y": 30.506,
              "z": 0.648
            },
            "rightCorner": {
              "x": -4.131,
              "y": 30.502,
              "z": 0.648
            },
            "gtin": "3600542397896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2097c",
            "leftCorner": {
              "x": -4.131,
              "y": 30.502,
              "z": 0.648
            },
            "rightCorner": {
              "x": -4.07,
              "y": 30.497,
              "z": 0.648
            },
            "gtin": "3600542397896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2097d",
            "leftCorner": {
              "x": -4.07,
              "y": 30.497,
              "z": 0.648
            },
            "rightCorner": {
              "x": -4.009,
              "y": 30.493,
              "z": 0.648
            },
            "gtin": "3600542397896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2097f",
            "leftCorner": {
              "x": -4.006,
              "y": 30.529,
              "z": 0.648
            },
            "rightCorner": {
              "x": -3.949,
              "y": 30.524,
              "z": 0.648
            },
            "gtin": "3600542397902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20980",
            "leftCorner": {
              "x": -3.949,
              "y": 30.524,
              "z": 0.648
            },
            "rightCorner": {
              "x": -3.891,
              "y": 30.521,
              "z": 0.648
            },
            "gtin": "3600542397902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20981",
            "leftCorner": {
              "x": -3.891,
              "y": 30.521,
              "z": 0.648
            },
            "rightCorner": {
              "x": -3.834,
              "y": 30.516,
              "z": 0.648
            },
            "gtin": "3600542397902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20982",
            "leftCorner": {
              "x": -3.832,
              "y": 30.531,
              "z": 0.648
            },
            "rightCorner": {
              "x": -3.765,
              "y": 30.527,
              "z": 0.648
            },
            "gtin": "3600542398022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20983",
            "leftCorner": {
              "x": -3.765,
              "y": 30.527,
              "z": 0.648
            },
            "rightCorner": {
              "x": -3.698,
              "y": 30.522,
              "z": 0.648
            },
            "gtin": "3600542398022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20984",
            "leftCorner": {
              "x": -3.699,
              "y": 30.499,
              "z": 0.648
            },
            "rightCorner": {
              "x": -3.643,
              "y": 30.496,
              "z": 0.648
            },
            "gtin": "3600542398039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20985",
            "leftCorner": {
              "x": -3.643,
              "y": 30.496,
              "z": 0.648
            },
            "rightCorner": {
              "x": -3.586,
              "y": 30.491,
              "z": 0.648
            },
            "gtin": "3600542398039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20986",
            "leftCorner": {
              "x": -3.586,
              "y": 30.493,
              "z": 0.648
            },
            "rightCorner": {
              "x": -3.538,
              "y": 30.489,
              "z": 0.648
            },
            "gtin": "3600542552981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20987",
            "leftCorner": {
              "x": -3.538,
              "y": 30.489,
              "z": 0.648
            },
            "rightCorner": {
              "x": -3.489,
              "y": 30.486,
              "z": 0.648
            },
            "gtin": "3600542552981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20988",
            "leftCorner": {
              "x": -3.489,
              "y": 30.493,
              "z": 0.648
            },
            "rightCorner": {
              "x": -3.404,
              "y": 30.486,
              "z": 0.648
            },
            "gtin": "3600542020053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20989",
            "leftCorner": {
              "x": -3.404,
              "y": 30.492,
              "z": 0.648
            },
            "rightCorner": {
              "x": -3.315,
              "y": 30.486,
              "z": 0.648
            },
            "gtin": "3600541550445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2098a",
            "leftCorner": {
              "x": -3.316,
              "y": 30.475,
              "z": 0.648
            },
            "rightCorner": {
              "x": -3.224,
              "y": 30.469,
              "z": 0.648
            },
            "gtin": "3600542020060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2098b",
            "leftCorner": {
              "x": -3.223,
              "y": 30.481,
              "z": 0.648
            },
            "rightCorner": {
              "x": -3.115,
              "y": 30.473,
              "z": 0.648
            },
            "gtin": "3600542463386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2098c",
            "leftCorner": {
              "x": -3.115,
              "y": 30.474,
              "z": 0.648
            },
            "rightCorner": {
              "x": -3.024,
              "y": 30.468,
              "z": 0.648
            },
            "gtin": "3600542460347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2098d",
            "leftCorner": {
              "x": -3.024,
              "y": 30.468,
              "z": 0.648
            },
            "rightCorner": {
              "x": -2.933,
              "y": 30.461,
              "z": 0.648
            },
            "gtin": "3600542460347",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546657",
        "height": 1.0447,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a209d9",
            "leftCorner": {
              "x": -4.193,
              "y": 30.505,
              "z": 0.855
            },
            "rightCorner": {
              "x": -4.126,
              "y": 30.501,
              "z": 0.855
            },
            "gtin": "4008666218001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209dc",
            "leftCorner": {
              "x": -4.124,
              "y": 30.527,
              "z": 0.855
            },
            "rightCorner": {
              "x": -4.059,
              "y": 30.523,
              "z": 0.855
            },
            "gtin": "4008666211217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209dd",
            "leftCorner": {
              "x": -4.059,
              "y": 30.523,
              "z": 0.855
            },
            "rightCorner": {
              "x": -3.995,
              "y": 30.518,
              "z": 0.855
            },
            "gtin": "4008666211217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209de",
            "leftCorner": {
              "x": -3.993,
              "y": 30.536,
              "z": 0.855
            },
            "rightCorner": {
              "x": -3.958,
              "y": 30.534,
              "z": 0.855
            },
            "gtin": "4008666200174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209df",
            "leftCorner": {
              "x": -3.958,
              "y": 30.534,
              "z": 0.855
            },
            "rightCorner": {
              "x": -3.924,
              "y": 30.531,
              "z": 0.855
            },
            "gtin": "4008666200174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209e0",
            "leftCorner": {
              "x": -3.925,
              "y": 30.513,
              "z": 0.855
            },
            "rightCorner": {
              "x": -3.848,
              "y": 30.508,
              "z": 0.855
            },
            "gtin": "4008666223654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209e1",
            "leftCorner": {
              "x": -3.847,
              "y": 30.524,
              "z": 0.855
            },
            "rightCorner": {
              "x": -3.79,
              "y": 30.521,
              "z": 0.855
            },
            "gtin": "4008666203663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209e2",
            "leftCorner": {
              "x": -3.79,
              "y": 30.518,
              "z": 0.855
            },
            "rightCorner": {
              "x": -3.713,
              "y": 30.512,
              "z": 0.855
            },
            "gtin": "4008666209016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209e3",
            "leftCorner": {
              "x": -3.714,
              "y": 30.494,
              "z": 0.855
            },
            "rightCorner": {
              "x": -3.68,
              "y": 30.491,
              "z": 0.855
            },
            "gtin": "4008666271211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209e4",
            "leftCorner": {
              "x": -3.68,
              "y": 30.491,
              "z": 0.855
            },
            "rightCorner": {
              "x": -3.645,
              "y": 30.489,
              "z": 0.855
            },
            "gtin": "4008666271211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209e5",
            "leftCorner": {
              "x": -3.645,
              "y": 30.499,
              "z": 0.855
            },
            "rightCorner": {
              "x": -3.558,
              "y": 30.492,
              "z": 0.855
            },
            "gtin": "4008666213327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209e6",
            "leftCorner": {
              "x": -3.558,
              "y": 30.495,
              "z": 0.855
            },
            "rightCorner": {
              "x": -3.483,
              "y": 30.49,
              "z": 0.855
            },
            "gtin": "4008666210517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209e7",
            "leftCorner": {
              "x": -3.483,
              "y": 30.495,
              "z": 0.855
            },
            "rightCorner": {
              "x": -3.404,
              "y": 30.49,
              "z": 0.855
            },
            "gtin": "4063528064967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209e8",
            "leftCorner": {
              "x": -3.405,
              "y": 30.486,
              "z": 0.855
            },
            "rightCorner": {
              "x": -3.317,
              "y": 30.479,
              "z": 0.855
            },
            "gtin": "4063528071361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209e9",
            "leftCorner": {
              "x": -3.316,
              "y": 30.485,
              "z": 0.855
            },
            "rightCorner": {
              "x": -3.237,
              "y": 30.479,
              "z": 0.855
            },
            "gtin": "4063528071545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209ea",
            "leftCorner": {
              "x": -3.236,
              "y": 30.485,
              "z": 0.855
            },
            "rightCorner": {
              "x": -3.14,
              "y": 30.479,
              "z": 0.855
            },
            "gtin": "4063528071484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209eb",
            "leftCorner": {
              "x": -3.139,
              "y": 30.482,
              "z": 0.855
            },
            "rightCorner": {
              "x": -3.042,
              "y": 30.474,
              "z": 0.855
            },
            "gtin": "3600542372350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209ec",
            "leftCorner": {
              "x": -3.043,
              "y": 30.465,
              "z": 0.855
            },
            "rightCorner": {
              "x": -2.962,
              "y": 30.46,
              "z": 0.855
            },
            "gtin": "3600542372794",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546659",
        "height": 1.2951,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20a44",
            "leftCorner": {
              "x": -4.185,
              "y": 30.613,
              "z": 1.06
            },
            "rightCorner": {
              "x": -4.112,
              "y": 30.609,
              "z": 1.06
            },
            "gtin": "4008666205506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a45",
            "leftCorner": {
              "x": -4.112,
              "y": 30.609,
              "z": 1.06
            },
            "rightCorner": {
              "x": -4.04,
              "y": 30.603,
              "z": 1.06
            },
            "gtin": "4008666205506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a47",
            "leftCorner": {
              "x": -4.038,
              "y": 30.634,
              "z": 1.06
            },
            "rightCorner": {
              "x": -3.952,
              "y": 30.629,
              "z": 1.06
            },
            "gtin": "4012800003743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a48",
            "leftCorner": {
              "x": -3.952,
              "y": 30.629,
              "z": 1.06
            },
            "rightCorner": {
              "x": -3.866,
              "y": 30.622,
              "z": 1.06
            },
            "gtin": "4012800003743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a49",
            "leftCorner": {
              "x": -3.865,
              "y": 30.635,
              "z": 1.06
            },
            "rightCorner": {
              "x": -3.789,
              "y": 30.63,
              "z": 1.06
            },
            "gtin": "4008666203137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a4a",
            "leftCorner": {
              "x": -3.789,
              "y": 30.63,
              "z": 1.06
            },
            "rightCorner": {
              "x": -3.713,
              "y": 30.624,
              "z": 1.06
            },
            "gtin": "4008666203137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a4b",
            "leftCorner": {
              "x": -3.713,
              "y": 30.618,
              "z": 1.06
            },
            "rightCorner": {
              "x": -3.649,
              "y": 30.613,
              "z": 1.06
            },
            "gtin": "4025089085034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a4c",
            "leftCorner": {
              "x": -3.649,
              "y": 30.615,
              "z": 1.06
            },
            "rightCorner": {
              "x": -3.527,
              "y": 30.606,
              "z": 1.06
            },
            "gtin": "4055297220620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a4d",
            "leftCorner": {
              "x": -3.527,
              "y": 30.597,
              "z": 1.06
            },
            "rightCorner": {
              "x": -3.414,
              "y": 30.588,
              "z": 1.06
            },
            "gtin": "4055297220088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a4e",
            "leftCorner": {
              "x": -3.413,
              "y": 30.595,
              "z": 1.06
            },
            "rightCorner": {
              "x": -3.347,
              "y": 30.59,
              "z": 1.06
            },
            "gtin": "4055297220804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a4f",
            "leftCorner": {
              "x": -3.347,
              "y": 30.59,
              "z": 1.06
            },
            "rightCorner": {
              "x": -3.281,
              "y": 30.585,
              "z": 1.06
            },
            "gtin": "4055297220804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a50",
            "leftCorner": {
              "x": -3.281,
              "y": 30.576,
              "z": 1.06
            },
            "rightCorner": {
              "x": -3.236,
              "y": 30.572,
              "z": 1.06
            },
            "gtin": "4055297221580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a51",
            "leftCorner": {
              "x": -3.236,
              "y": 30.572,
              "z": 1.06
            },
            "rightCorner": {
              "x": -3.19,
              "y": 30.569,
              "z": 1.06
            },
            "gtin": "4055297221580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a52",
            "leftCorner": {
              "x": -3.191,
              "y": 30.55,
              "z": 1.06
            },
            "rightCorner": {
              "x": -3.157,
              "y": 30.548,
              "z": 1.06
            },
            "gtin": "4055297221283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a53",
            "leftCorner": {
              "x": -3.157,
              "y": 30.548,
              "z": 1.06
            },
            "rightCorner": {
              "x": -3.123,
              "y": 30.546,
              "z": 1.06
            },
            "gtin": "4055297221283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a54",
            "leftCorner": {
              "x": -3.12,
              "y": 30.585,
              "z": 1.06
            },
            "rightCorner": {
              "x": -3.078,
              "y": 30.581,
              "z": 1.06
            },
            "gtin": "4055297221467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a55",
            "leftCorner": {
              "x": -3.078,
              "y": 30.584,
              "z": 1.06
            },
            "rightCorner": {
              "x": -3.028,
              "y": 30.581,
              "z": 1.06
            },
            "gtin": "4055297220262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a56",
            "leftCorner": {
              "x": -3.028,
              "y": 30.581,
              "z": 1.06
            },
            "rightCorner": {
              "x": -2.978,
              "y": 30.578,
              "z": 1.06
            },
            "gtin": "4055297220262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a57",
            "leftCorner": {
              "x": -2.979,
              "y": 30.57,
              "z": 1.06
            },
            "rightCorner": {
              "x": -2.943,
              "y": 30.567,
              "z": 1.06
            },
            "gtin": "4055297220088",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54665b",
        "height": 1.5467,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20a9c",
            "leftCorner": {
              "x": -4.185,
              "y": 30.605,
              "z": 1.265
            },
            "rightCorner": {
              "x": -4.115,
              "y": 30.6,
              "z": 1.265
            },
            "gtin": "4008666704702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a9d",
            "leftCorner": {
              "x": -4.115,
              "y": 30.6,
              "z": 1.265
            },
            "rightCorner": {
              "x": -4.045,
              "y": 30.596,
              "z": 1.265
            },
            "gtin": "4008666704702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a9e",
            "leftCorner": {
              "x": -4.045,
              "y": 30.596,
              "z": 1.265
            },
            "rightCorner": {
              "x": -3.975,
              "y": 30.59,
              "z": 1.265
            },
            "gtin": "4008666704702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a9f",
            "leftCorner": {
              "x": -3.975,
              "y": 30.59,
              "z": 1.265
            },
            "rightCorner": {
              "x": -3.905,
              "y": 30.585,
              "z": 1.265
            },
            "gtin": "4008666704702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aa2",
            "leftCorner": {
              "x": -3.901,
              "y": 30.629,
              "z": 1.265
            },
            "rightCorner": {
              "x": -3.842,
              "y": 30.624,
              "z": 1.265
            },
            "gtin": "4008666700209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aa3",
            "leftCorner": {
              "x": -3.842,
              "y": 30.624,
              "z": 1.265
            },
            "rightCorner": {
              "x": -3.782,
              "y": 30.621,
              "z": 1.265
            },
            "gtin": "4008666700209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aa4",
            "leftCorner": {
              "x": -3.784,
              "y": 30.605,
              "z": 1.265
            },
            "rightCorner": {
              "x": -3.715,
              "y": 30.6,
              "z": 1.265
            },
            "gtin": "4008666701602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aa5",
            "leftCorner": {
              "x": -3.715,
              "y": 30.6,
              "z": 1.265
            },
            "rightCorner": {
              "x": -3.646,
              "y": 30.595,
              "z": 1.265
            },
            "gtin": "4008666701602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aa6",
            "leftCorner": {
              "x": -3.646,
              "y": 30.6,
              "z": 1.265
            },
            "rightCorner": {
              "x": -3.588,
              "y": 30.596,
              "z": 1.265
            },
            "gtin": "4008666700001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aa7",
            "leftCorner": {
              "x": -3.588,
              "y": 30.596,
              "z": 1.265
            },
            "rightCorner": {
              "x": -3.53,
              "y": 30.592,
              "z": 1.265
            },
            "gtin": "4008666700001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aa8",
            "leftCorner": {
              "x": -3.529,
              "y": 30.609,
              "z": 1.265
            },
            "rightCorner": {
              "x": -3.463,
              "y": 30.604,
              "z": 1.265
            },
            "gtin": "4008666700902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aa9",
            "leftCorner": {
              "x": -3.464,
              "y": 30.591,
              "z": 1.265
            },
            "rightCorner": {
              "x": -3.401,
              "y": 30.586,
              "z": 1.265
            },
            "gtin": "4008666701701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aaa",
            "leftCorner": {
              "x": -3.4,
              "y": 30.61,
              "z": 1.265
            },
            "rightCorner": {
              "x": -3.326,
              "y": 30.605,
              "z": 1.265
            },
            "gtin": "4008666710000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aab",
            "leftCorner": {
              "x": -3.326,
              "y": 30.605,
              "z": 1.265
            },
            "rightCorner": {
              "x": -3.253,
              "y": 30.599,
              "z": 1.265
            },
            "gtin": "4008666710000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aac",
            "leftCorner": {
              "x": -3.253,
              "y": 30.599,
              "z": 1.265
            },
            "rightCorner": {
              "x": -3.179,
              "y": 30.594,
              "z": 1.265
            },
            "gtin": "4008666710000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aad",
            "leftCorner": {
              "x": -3.179,
              "y": 30.594,
              "z": 1.265
            },
            "rightCorner": {
              "x": -3.106,
              "y": 30.589,
              "z": 1.265
            },
            "gtin": "4008666710000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aae",
            "leftCorner": {
              "x": -3.107,
              "y": 30.583,
              "z": 1.265
            },
            "rightCorner": {
              "x": -2.998,
              "y": 30.575,
              "z": 1.265
            },
            "gtin": "4008666750389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aaf",
            "leftCorner": {
              "x": -2.998,
              "y": 30.574,
              "z": 1.265
            },
            "rightCorner": {
              "x": -2.927,
              "y": 30.57,
              "z": 1.265
            },
            "gtin": "4103040048967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ab0",
            "leftCorner": {
              "x": -2.927,
              "y": 30.57,
              "z": 1.265
            },
            "rightCorner": {
              "x": -2.856,
              "y": 30.564,
              "z": 1.265
            },
            "gtin": "4103040048967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ab1",
            "leftCorner": {
              "x": -2.856,
              "y": 30.564,
              "z": 1.265
            },
            "rightCorner": {
              "x": -2.785,
              "y": 30.559,
              "z": 1.265
            },
            "gtin": "4103040048967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ab2",
            "leftCorner": {
              "x": -2.785,
              "y": 30.559,
              "z": 1.265
            },
            "rightCorner": {
              "x": -2.714,
              "y": 30.554,
              "z": 1.265
            },
            "gtin": "4103040048967",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d61",
    "rightNeighborShelfId": "a6d63"
  },
  {
    "id": "a6d63",
    "name": "a6d63",
    "x": -2.951,
    "y": 30.304,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.026369,
      "w": 0.99965
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 88
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546661",
        "height": 0.16197,
        "facings": [
          {
            "id": "68300c895ed67a01d9a206b6",
            "leftCorner": {
              "x": -2.767,
              "y": 30.34,
              "z": 0.133
            },
            "rightCorner": {
              "x": -2.5,
              "y": 30.325,
              "z": 0.133
            },
            "gtin": "3600542511100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206b7",
            "leftCorner": {
              "x": -2.5,
              "y": 30.325,
              "z": 0.133
            },
            "rightCorner": {
              "x": -2.232,
              "y": 30.311,
              "z": 0.133
            },
            "gtin": "3600542511100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206b8",
            "leftCorner": {
              "x": -2.232,
              "y": 30.311,
              "z": 0.133
            },
            "rightCorner": {
              "x": -1.965,
              "y": 30.298,
              "z": 0.133
            },
            "gtin": "3600542511100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206b9",
            "leftCorner": {
              "x": -1.964,
              "y": 30.309,
              "z": 0.133
            },
            "rightCorner": {
              "x": -1.918,
              "y": 30.307,
              "z": 0.133
            },
            "gtin": "3600542509572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206ba",
            "leftCorner": {
              "x": -1.918,
              "y": 30.307,
              "z": 0.133
            },
            "rightCorner": {
              "x": -1.871,
              "y": 30.304,
              "z": 0.133
            },
            "gtin": "3600542509572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206bb",
            "leftCorner": {
              "x": -1.871,
              "y": 30.304,
              "z": 0.133
            },
            "rightCorner": {
              "x": -1.792,
              "y": 30.299,
              "z": 0.133
            },
            "gtin": "4063367117077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206bc",
            "leftCorner": {
              "x": -1.792,
              "y": 30.299,
              "z": 0.133
            },
            "rightCorner": {
              "x": -1.712,
              "y": 30.295,
              "z": 0.133
            },
            "gtin": "4063367117077",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54665d",
        "height": 0.49133,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20602",
            "leftCorner": {
              "x": -2.926,
              "y": 30.449,
              "z": 0.402
            },
            "rightCorner": {
              "x": -2.847,
              "y": 30.445,
              "z": 0.402
            },
            "gtin": "8700216173520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20603",
            "leftCorner": {
              "x": -2.847,
              "y": 30.443,
              "z": 0.402
            },
            "rightCorner": {
              "x": -2.787,
              "y": 30.44,
              "z": 0.402
            },
            "gtin": "8700216151535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20604",
            "leftCorner": {
              "x": -2.787,
              "y": 30.425,
              "z": 0.402
            },
            "rightCorner": {
              "x": -2.718,
              "y": 30.421,
              "z": 0.402
            },
            "gtin": "8700216500821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20605",
            "leftCorner": {
              "x": -2.718,
              "y": 30.432,
              "z": 0.402
            },
            "rightCorner": {
              "x": -2.656,
              "y": 30.429,
              "z": 0.402
            },
            "gtin": "8700216170260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20606",
            "leftCorner": {
              "x": -2.656,
              "y": 30.429,
              "z": 0.402
            },
            "rightCorner": {
              "x": -2.594,
              "y": 30.426,
              "z": 0.402
            },
            "gtin": "8700216170260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20607",
            "leftCorner": {
              "x": -2.594,
              "y": 30.434,
              "z": 0.402
            },
            "rightCorner": {
              "x": -2.516,
              "y": 30.429,
              "z": 0.402
            },
            "gtin": "8700216173476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20608",
            "leftCorner": {
              "x": -2.517,
              "y": 30.425,
              "z": 0.402
            },
            "rightCorner": {
              "x": -2.412,
              "y": 30.419,
              "z": 0.402
            },
            "gtin": "8700216547857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20609",
            "leftCorner": {
              "x": -2.411,
              "y": 30.429,
              "z": 0.402
            },
            "rightCorner": {
              "x": -2.37,
              "y": 30.428,
              "z": 0.402
            },
            "gtin": "8700216173261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2060a",
            "leftCorner": {
              "x": -2.37,
              "y": 30.428,
              "z": 0.402
            },
            "rightCorner": {
              "x": -2.329,
              "y": 30.425,
              "z": 0.402
            },
            "gtin": "8700216173261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2060b",
            "leftCorner": {
              "x": -2.33,
              "y": 30.407,
              "z": 0.402
            },
            "rightCorner": {
              "x": -2.274,
              "y": 30.404,
              "z": 0.402
            },
            "gtin": "8700216547772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2060c",
            "leftCorner": {
              "x": -2.274,
              "y": 30.404,
              "z": 0.402
            },
            "rightCorner": {
              "x": -2.217,
              "y": 30.401,
              "z": 0.402
            },
            "gtin": "8700216547772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2060d",
            "leftCorner": {
              "x": -2.216,
              "y": 30.41,
              "z": 0.402
            },
            "rightCorner": {
              "x": -2.148,
              "y": 30.406,
              "z": 0.402
            },
            "gtin": "8700216502672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2060e",
            "leftCorner": {
              "x": -2.148,
              "y": 30.408,
              "z": 0.402
            },
            "rightCorner": {
              "x": -2.062,
              "y": 30.403,
              "z": 0.402
            },
            "gtin": "8700216212786",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2060f",
            "leftCorner": {
              "x": -2.062,
              "y": 30.403,
              "z": 0.402
            },
            "rightCorner": {
              "x": -1.975,
              "y": 30.399,
              "z": 0.402
            },
            "gtin": "8700216212786",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20610",
            "leftCorner": {
              "x": -1.975,
              "y": 30.408,
              "z": 0.402
            },
            "rightCorner": {
              "x": -1.905,
              "y": 30.404,
              "z": 0.402
            },
            "gtin": "8700216212847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20611",
            "leftCorner": {
              "x": -1.905,
              "y": 30.404,
              "z": 0.402
            },
            "rightCorner": {
              "x": -1.835,
              "y": 30.401,
              "z": 0.402
            },
            "gtin": "8700216212847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20612",
            "leftCorner": {
              "x": -1.834,
              "y": 30.409,
              "z": 0.402
            },
            "rightCorner": {
              "x": -1.756,
              "y": 30.405,
              "z": 0.402
            },
            "gtin": "8001841896113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20613",
            "leftCorner": {
              "x": -1.757,
              "y": 30.383,
              "z": 0.402
            },
            "rightCorner": {
              "x": -1.72,
              "y": 30.381,
              "z": 0.402
            },
            "gtin": "8700216170390",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54665f",
        "height": 0.79435,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a2098e",
            "leftCorner": {
              "x": -2.933,
              "y": 30.455,
              "z": 0.65
            },
            "rightCorner": {
              "x": -2.867,
              "y": 30.452,
              "z": 0.65
            },
            "gtin": "8700216212724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2098f",
            "leftCorner": {
              "x": -2.869,
              "y": 30.415,
              "z": 0.65
            },
            "rightCorner": {
              "x": -2.742,
              "y": 30.408,
              "z": 0.65
            },
            "gtin": "8700216227018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20990",
            "leftCorner": {
              "x": -2.742,
              "y": 30.408,
              "z": 0.65
            },
            "rightCorner": {
              "x": -2.615,
              "y": 30.402,
              "z": 0.65
            },
            "gtin": "8700216227018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20991",
            "leftCorner": {
              "x": -2.613,
              "y": 30.427,
              "z": 0.65
            },
            "rightCorner": {
              "x": -2.549,
              "y": 30.423,
              "z": 0.65
            },
            "gtin": "8700216210508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20992",
            "leftCorner": {
              "x": -2.549,
              "y": 30.423,
              "z": 0.65
            },
            "rightCorner": {
              "x": -2.485,
              "y": 30.42,
              "z": 0.65
            },
            "gtin": "8700216210508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20993",
            "leftCorner": {
              "x": -2.485,
              "y": 30.413,
              "z": 0.65
            },
            "rightCorner": {
              "x": -2.41,
              "y": 30.409,
              "z": 0.65
            },
            "gtin": "8700216210546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20994",
            "leftCorner": {
              "x": -2.41,
              "y": 30.404,
              "z": 0.65
            },
            "rightCorner": {
              "x": -2.356,
              "y": 30.401,
              "z": 0.65
            },
            "gtin": "8700216210607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20995",
            "leftCorner": {
              "x": -2.356,
              "y": 30.401,
              "z": 0.65
            },
            "rightCorner": {
              "x": -2.301,
              "y": 30.398,
              "z": 0.65
            },
            "gtin": "8700216210607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20996",
            "leftCorner": {
              "x": -2.301,
              "y": 30.404,
              "z": 0.65
            },
            "rightCorner": {
              "x": -2.255,
              "y": 30.401,
              "z": 0.65
            },
            "gtin": "8700216631662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20997",
            "leftCorner": {
              "x": -2.255,
              "y": 30.401,
              "z": 0.65
            },
            "rightCorner": {
              "x": -2.208,
              "y": 30.399,
              "z": 0.65
            },
            "gtin": "8700216631662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20998",
            "leftCorner": {
              "x": -2.207,
              "y": 30.415,
              "z": 0.65
            },
            "rightCorner": {
              "x": -2.099,
              "y": 30.409,
              "z": 0.65
            },
            "gtin": "8700216631761",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20999",
            "leftCorner": {
              "x": -2.098,
              "y": 30.411,
              "z": 0.65
            },
            "rightCorner": {
              "x": -2.039,
              "y": 30.407,
              "z": 0.65
            },
            "gtin": "8700216631730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2099a",
            "leftCorner": {
              "x": -2.039,
              "y": 30.407,
              "z": 0.65
            },
            "rightCorner": {
              "x": -1.979,
              "y": 30.405,
              "z": 0.65
            },
            "gtin": "8700216631730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2099b",
            "leftCorner": {
              "x": -1.979,
              "y": 30.41,
              "z": 0.65
            },
            "rightCorner": {
              "x": -1.914,
              "y": 30.407,
              "z": 0.65
            },
            "gtin": "8700216212748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2099c",
            "leftCorner": {
              "x": -1.914,
              "y": 30.406,
              "z": 0.65
            },
            "rightCorner": {
              "x": -1.831,
              "y": 30.402,
              "z": 0.65
            },
            "gtin": "8700216558730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2099d",
            "leftCorner": {
              "x": -1.831,
              "y": 30.393,
              "z": 0.65
            },
            "rightCorner": {
              "x": -1.763,
              "y": 30.389,
              "z": 0.65
            },
            "gtin": "8006540456316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2099e",
            "leftCorner": {
              "x": -1.762,
              "y": 30.399,
              "z": 0.65
            },
            "rightCorner": {
              "x": -1.684,
              "y": 30.395,
              "z": 0.65
            },
            "gtin": "8700216558761",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54665c",
        "height": 1.0443,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a209ed",
            "leftCorner": {
              "x": -2.964,
              "y": 30.439,
              "z": 0.854
            },
            "rightCorner": {
              "x": -2.891,
              "y": 30.435,
              "z": 0.854
            },
            "gtin": "3600542460750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209ee",
            "leftCorner": {
              "x": -2.892,
              "y": 30.412,
              "z": 0.854
            },
            "rightCorner": {
              "x": -2.795,
              "y": 30.407,
              "z": 0.854
            },
            "gtin": "3600542462228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209ef",
            "leftCorner": {
              "x": -2.794,
              "y": 30.418,
              "z": 0.854
            },
            "rightCorner": {
              "x": -2.731,
              "y": 30.415,
              "z": 0.854
            },
            "gtin": "3600542462556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209f0",
            "leftCorner": {
              "x": -2.731,
              "y": 30.416,
              "z": 0.854
            },
            "rightCorner": {
              "x": -2.584,
              "y": 30.408,
              "z": 0.854
            },
            "gtin": "3600542460835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209f1",
            "leftCorner": {
              "x": -2.583,
              "y": 30.42,
              "z": 0.854
            },
            "rightCorner": {
              "x": -2.449,
              "y": 30.413,
              "z": 0.854
            },
            "gtin": "3600542461382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209f2",
            "leftCorner": {
              "x": -2.449,
              "y": 30.412,
              "z": 0.854
            },
            "rightCorner": {
              "x": -2.372,
              "y": 30.408,
              "z": 0.854
            },
            "gtin": "3600542461658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209f3",
            "leftCorner": {
              "x": -2.372,
              "y": 30.408,
              "z": 0.854
            },
            "rightCorner": {
              "x": -2.296,
              "y": 30.403,
              "z": 0.854
            },
            "gtin": "3600542461658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209f4",
            "leftCorner": {
              "x": -2.297,
              "y": 30.395,
              "z": 0.854
            },
            "rightCorner": {
              "x": -2.156,
              "y": 30.388,
              "z": 0.854
            },
            "gtin": "3600542462372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209f5",
            "leftCorner": {
              "x": -2.156,
              "y": 30.397,
              "z": 0.854
            },
            "rightCorner": {
              "x": -2.08,
              "y": 30.393,
              "z": 0.854
            },
            "gtin": "3600542461856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209f6",
            "leftCorner": {
              "x": -2.08,
              "y": 30.396,
              "z": 0.854
            },
            "rightCorner": {
              "x": -1.986,
              "y": 30.39,
              "z": 0.854
            },
            "gtin": "3600542512466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209f7",
            "leftCorner": {
              "x": -1.986,
              "y": 30.396,
              "z": 0.854
            },
            "rightCorner": {
              "x": -1.922,
              "y": 30.393,
              "z": 0.854
            },
            "gtin": "8700216821155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209f8",
            "leftCorner": {
              "x": -1.922,
              "y": 30.393,
              "z": 0.854
            },
            "rightCorner": {
              "x": -1.859,
              "y": 30.39,
              "z": 0.854
            },
            "gtin": "8700216821155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209f9",
            "leftCorner": {
              "x": -1.858,
              "y": 30.395,
              "z": 0.854
            },
            "rightCorner": {
              "x": -1.792,
              "y": 30.391,
              "z": 0.854
            },
            "gtin": "8700216558037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209fa",
            "leftCorner": {
              "x": -1.792,
              "y": 30.391,
              "z": 0.854
            },
            "rightCorner": {
              "x": -1.725,
              "y": 30.388,
              "z": 0.854
            },
            "gtin": "8700216558037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209fb",
            "leftCorner": {
              "x": -1.725,
              "y": 30.388,
              "z": 0.854
            },
            "rightCorner": {
              "x": -1.658,
              "y": 30.384,
              "z": 0.854
            },
            "gtin": "8700216558037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209fc",
            "leftCorner": {
              "x": -1.658,
              "y": 30.384,
              "z": 0.854
            },
            "rightCorner": {
              "x": -1.592,
              "y": 30.381,
              "z": 0.854
            },
            "gtin": "8700216558037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209fd",
            "leftCorner": {
              "x": -1.592,
              "y": 30.381,
              "z": 0.854
            },
            "rightCorner": {
              "x": -1.525,
              "y": 30.377,
              "z": 0.854
            },
            "gtin": "8700216558037",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54665e",
        "height": 1.296,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20a58",
            "leftCorner": {
              "x": -2.946,
              "y": 30.557,
              "z": 1.06
            },
            "rightCorner": {
              "x": -2.848,
              "y": 30.552,
              "z": 1.06
            },
            "gtin": "3600542460262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a59",
            "leftCorner": {
              "x": -2.848,
              "y": 30.552,
              "z": 1.06
            },
            "rightCorner": {
              "x": -2.75,
              "y": 30.547,
              "z": 1.06
            },
            "gtin": "3600542460262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a5a",
            "leftCorner": {
              "x": -2.751,
              "y": 30.526,
              "z": 1.06
            },
            "rightCorner": {
              "x": -2.633,
              "y": 30.52,
              "z": 1.06
            },
            "gtin": "3600542461115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a5b",
            "leftCorner": {
              "x": -2.634,
              "y": 30.498,
              "z": 1.06
            },
            "rightCorner": {
              "x": -2.546,
              "y": 30.494,
              "z": 1.06
            },
            "gtin": "3600542462150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a5c",
            "leftCorner": {
              "x": -2.546,
              "y": 30.494,
              "z": 1.06
            },
            "rightCorner": {
              "x": -2.457,
              "y": 30.489,
              "z": 1.06
            },
            "gtin": "3600542462150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a5d",
            "leftCorner": {
              "x": -2.455,
              "y": 30.519,
              "z": 1.06
            },
            "rightCorner": {
              "x": -2.345,
              "y": 30.513,
              "z": 1.06
            },
            "gtin": "3600542462839",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a5e",
            "leftCorner": {
              "x": -2.345,
              "y": 30.513,
              "z": 1.06
            },
            "rightCorner": {
              "x": -2.235,
              "y": 30.508,
              "z": 1.06
            },
            "gtin": "3600542462839",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a5f",
            "leftCorner": {
              "x": -2.235,
              "y": 30.515,
              "z": 1.06
            },
            "rightCorner": {
              "x": -2.135,
              "y": 30.51,
              "z": 1.06
            },
            "gtin": "3600542512213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a60",
            "leftCorner": {
              "x": -2.135,
              "y": 30.506,
              "z": 1.06
            },
            "rightCorner": {
              "x": -2.045,
              "y": 30.501,
              "z": 1.06
            },
            "gtin": "3600542461900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a61",
            "leftCorner": {
              "x": -2.045,
              "y": 30.493,
              "z": 1.06
            },
            "rightCorner": {
              "x": -1.967,
              "y": 30.488,
              "z": 1.06
            },
            "gtin": "3600542461313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a62",
            "leftCorner": {
              "x": -1.967,
              "y": 30.495,
              "z": 1.06
            },
            "rightCorner": {
              "x": -1.881,
              "y": 30.49,
              "z": 1.06
            },
            "gtin": "8700216557764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a63",
            "leftCorner": {
              "x": -1.881,
              "y": 30.49,
              "z": 1.06
            },
            "rightCorner": {
              "x": -1.794,
              "y": 30.485,
              "z": 1.06
            },
            "gtin": "8700216557764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a64",
            "leftCorner": {
              "x": -1.794,
              "y": 30.487,
              "z": 1.06
            },
            "rightCorner": {
              "x": -1.645,
              "y": 30.48,
              "z": 1.06
            },
            "gtin": "8700216557689",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546660",
        "height": 1.5489,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ab3",
            "leftCorner": {
              "x": -2.718,
              "y": 30.532,
              "z": 1.267
            },
            "rightCorner": {
              "x": -2.646,
              "y": 30.528,
              "z": 1.267
            },
            "gtin": "4103040048943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ab4",
            "leftCorner": {
              "x": -2.646,
              "y": 30.528,
              "z": 1.267
            },
            "rightCorner": {
              "x": -2.574,
              "y": 30.524,
              "z": 1.267
            },
            "gtin": "4103040048943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ab5",
            "leftCorner": {
              "x": -2.574,
              "y": 30.525,
              "z": 1.267
            },
            "rightCorner": {
              "x": -2.491,
              "y": 30.52,
              "z": 1.267
            },
            "gtin": "4103040048882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ab6",
            "leftCorner": {
              "x": -2.491,
              "y": 30.524,
              "z": 1.267
            },
            "rightCorner": {
              "x": -2.404,
              "y": 30.52,
              "z": 1.267
            },
            "gtin": "4103040048905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ab7",
            "leftCorner": {
              "x": -2.404,
              "y": 30.52,
              "z": 1.267
            },
            "rightCorner": {
              "x": -2.317,
              "y": 30.515,
              "z": 1.267
            },
            "gtin": "4103040048905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ab8",
            "leftCorner": {
              "x": -2.317,
              "y": 30.515,
              "z": 1.267
            },
            "rightCorner": {
              "x": -2.23,
              "y": 30.511,
              "z": 1.267
            },
            "gtin": "4103040048905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ab9",
            "leftCorner": {
              "x": -2.231,
              "y": 30.498,
              "z": 1.267
            },
            "rightCorner": {
              "x": -2.172,
              "y": 30.494,
              "z": 1.267
            },
            "gtin": "4103040019349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aba",
            "leftCorner": {
              "x": -2.172,
              "y": 30.494,
              "z": 1.267
            },
            "rightCorner": {
              "x": -2.113,
              "y": 30.491,
              "z": 1.267
            },
            "gtin": "4103040019349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20abb",
            "leftCorner": {
              "x": -2.113,
              "y": 30.491,
              "z": 1.267
            },
            "rightCorner": {
              "x": -2.055,
              "y": 30.488,
              "z": 1.267
            },
            "gtin": "4103040019349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20abc",
            "leftCorner": {
              "x": -2.055,
              "y": 30.488,
              "z": 1.267
            },
            "rightCorner": {
              "x": -1.996,
              "y": 30.485,
              "z": 1.267
            },
            "gtin": "4103040019349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20abd",
            "leftCorner": {
              "x": -1.995,
              "y": 30.498,
              "z": 1.267
            },
            "rightCorner": {
              "x": -1.925,
              "y": 30.494,
              "z": 1.267
            },
            "gtin": "8700216151412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20abe",
            "leftCorner": {
              "x": -1.925,
              "y": 30.494,
              "z": 1.267
            },
            "rightCorner": {
              "x": -1.856,
              "y": 30.491,
              "z": 1.267
            },
            "gtin": "8700216151412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20abf",
            "leftCorner": {
              "x": -1.855,
              "y": 30.503,
              "z": 1.267
            },
            "rightCorner": {
              "x": -1.809,
              "y": 30.5,
              "z": 1.267
            },
            "gtin": "8700216151504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ac0",
            "leftCorner": {
              "x": -1.809,
              "y": 30.5,
              "z": 1.267
            },
            "rightCorner": {
              "x": -1.763,
              "y": 30.498,
              "z": 1.267
            },
            "gtin": "8700216151504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ac1",
            "leftCorner": {
              "x": -1.763,
              "y": 30.496,
              "z": 1.267
            },
            "rightCorner": {
              "x": -1.713,
              "y": 30.493,
              "z": 1.267
            },
            "gtin": "8700216151443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ac2",
            "leftCorner": {
              "x": -1.713,
              "y": 30.502,
              "z": 1.267
            },
            "rightCorner": {
              "x": -1.657,
              "y": 30.499,
              "z": 1.267
            },
            "gtin": "8700216151382",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d62",
    "rightNeighborShelfId": "a6d64"
  },
  {
    "id": "a6d64",
    "name": "a6d64",
    "x": -1.703,
    "y": 30.238,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.026369,
      "w": 0.99965
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 95
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546666",
        "height": 0.17137,
        "facings": [
          {
            "id": "68300c895ed67a01d9a206bd",
            "leftCorner": {
              "x": -1.712,
              "y": 30.29,
              "z": 0.14
            },
            "rightCorner": {
              "x": -1.666,
              "y": 30.287,
              "z": 0.14
            },
            "gtin": "4063367117114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206be",
            "leftCorner": {
              "x": -1.666,
              "y": 30.285,
              "z": 0.14
            },
            "rightCorner": {
              "x": -1.575,
              "y": 30.281,
              "z": 0.14
            },
            "gtin": "4063367117091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206bf",
            "leftCorner": {
              "x": -1.575,
              "y": 30.281,
              "z": 0.14
            },
            "rightCorner": {
              "x": -1.483,
              "y": 30.276,
              "z": 0.14
            },
            "gtin": "4063367117091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206c0",
            "leftCorner": {
              "x": -1.484,
              "y": 30.274,
              "z": 0.14
            },
            "rightCorner": {
              "x": -1.43,
              "y": 30.271,
              "z": 0.14
            },
            "gtin": "4003583221271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206c1",
            "leftCorner": {
              "x": -1.43,
              "y": 30.271,
              "z": 0.14
            },
            "rightCorner": {
              "x": -1.376,
              "y": 30.269,
              "z": 0.14
            },
            "gtin": "4003583221271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206c2",
            "leftCorner": {
              "x": -1.377,
              "y": 30.24,
              "z": 0.14
            },
            "rightCorner": {
              "x": -1.332,
              "y": 30.237,
              "z": 0.14
            },
            "gtin": "4003583221233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206c3",
            "leftCorner": {
              "x": -1.332,
              "y": 30.237,
              "z": 0.14
            },
            "rightCorner": {
              "x": -1.286,
              "y": 30.235,
              "z": 0.14
            },
            "gtin": "4003583221233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206c4",
            "leftCorner": {
              "x": -1.286,
              "y": 30.237,
              "z": 0.14
            },
            "rightCorner": {
              "x": -1.208,
              "y": 30.232,
              "z": 0.14
            },
            "gtin": "4003583221110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206c5",
            "leftCorner": {
              "x": -1.208,
              "y": 30.232,
              "z": 0.14
            },
            "rightCorner": {
              "x": -1.129,
              "y": 30.228,
              "z": 0.14
            },
            "gtin": "4003583221110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206c6",
            "leftCorner": {
              "x": -1.129,
              "y": 30.228,
              "z": 0.14
            },
            "rightCorner": {
              "x": -1.051,
              "y": 30.224,
              "z": 0.14
            },
            "gtin": "4003583221110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206c7",
            "leftCorner": {
              "x": -1.051,
              "y": 30.224,
              "z": 0.14
            },
            "rightCorner": {
              "x": -0.973,
              "y": 30.221,
              "z": 0.14
            },
            "gtin": "4003583221110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206c8",
            "leftCorner": {
              "x": -0.972,
              "y": 30.244,
              "z": 0.14
            },
            "rightCorner": {
              "x": -0.909,
              "y": 30.24,
              "z": 0.14
            },
            "gtin": "4003583221073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206c9",
            "leftCorner": {
              "x": -0.909,
              "y": 30.24,
              "z": 0.14
            },
            "rightCorner": {
              "x": -0.846,
              "y": 30.237,
              "z": 0.14
            },
            "gtin": "4003583221073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206ca",
            "leftCorner": {
              "x": -0.846,
              "y": 30.237,
              "z": 0.14
            },
            "rightCorner": {
              "x": -0.783,
              "y": 30.233,
              "z": 0.14
            },
            "gtin": "4003583221073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206cb",
            "leftCorner": {
              "x": -0.782,
              "y": 30.242,
              "z": 0.14
            },
            "rightCorner": {
              "x": -0.715,
              "y": 30.239,
              "z": 0.14
            },
            "gtin": "4063367263415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206cc",
            "leftCorner": {
              "x": -0.715,
              "y": 30.239,
              "z": 0.14
            },
            "rightCorner": {
              "x": -0.648,
              "y": 30.234,
              "z": 0.14
            },
            "gtin": "4063367263415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a206cd",
            "leftCorner": {
              "x": -0.648,
              "y": 30.234,
              "z": 0.14
            },
            "rightCorner": {
              "x": -0.58,
              "y": 30.231,
              "z": 0.14
            },
            "gtin": "4063367263415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20661",
            "leftCorner": {
              "x": -0.58,
              "y": 30.23,
              "z": 0.14
            },
            "rightCorner": {
              "x": -0.516,
              "y": 30.227,
              "z": 0.14
            },
            "gtin": "4003583216079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20662",
            "leftCorner": {
              "x": -0.516,
              "y": 30.227,
              "z": 0.14
            },
            "rightCorner": {
              "x": -0.452,
              "y": 30.223,
              "z": 0.14
            },
            "gtin": "4003583216079",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546662",
        "height": 0.49042,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20614",
            "leftCorner": {
              "x": -1.72,
              "y": 30.385,
              "z": 0.401
            },
            "rightCorner": {
              "x": -1.685,
              "y": 30.383,
              "z": 0.401
            },
            "gtin": "8700216170291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20615",
            "leftCorner": {
              "x": -1.685,
              "y": 30.372,
              "z": 0.401
            },
            "rightCorner": {
              "x": -1.634,
              "y": 30.37,
              "z": 0.401
            },
            "gtin": "8700216170291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20616",
            "leftCorner": {
              "x": -1.634,
              "y": 30.376,
              "z": 0.401
            },
            "rightCorner": {
              "x": -1.572,
              "y": 30.373,
              "z": 0.401
            },
            "gtin": "8700216170345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20617",
            "leftCorner": {
              "x": -1.572,
              "y": 30.373,
              "z": 0.401
            },
            "rightCorner": {
              "x": -1.51,
              "y": 30.37,
              "z": 0.401
            },
            "gtin": "8700216170345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20618",
            "leftCorner": {
              "x": -1.51,
              "y": 30.364,
              "z": 0.401
            },
            "rightCorner": {
              "x": -1.45,
              "y": 30.361,
              "z": 0.401
            },
            "gtin": "4068829387708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20619",
            "leftCorner": {
              "x": -1.45,
              "y": 30.361,
              "z": 0.401
            },
            "rightCorner": {
              "x": -1.391,
              "y": 30.358,
              "z": 0.401
            },
            "gtin": "4068829387708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2061a",
            "leftCorner": {
              "x": -1.391,
              "y": 30.358,
              "z": 0.401
            },
            "rightCorner": {
              "x": -1.331,
              "y": 30.355,
              "z": 0.401
            },
            "gtin": "4068829387708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2061b",
            "leftCorner": {
              "x": -1.331,
              "y": 30.36,
              "z": 0.401
            },
            "rightCorner": {
              "x": -1.268,
              "y": 30.355,
              "z": 0.401
            },
            "gtin": "4068829387609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2061c",
            "leftCorner": {
              "x": -1.268,
              "y": 30.355,
              "z": 0.401
            },
            "rightCorner": {
              "x": -1.204,
              "y": 30.352,
              "z": 0.401
            },
            "gtin": "4068829387609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2061d",
            "leftCorner": {
              "x": -1.204,
              "y": 30.357,
              "z": 0.401
            },
            "rightCorner": {
              "x": -1.152,
              "y": 30.355,
              "z": 0.401
            },
            "gtin": "4068829387500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2061e",
            "leftCorner": {
              "x": -1.152,
              "y": 30.355,
              "z": 0.401
            },
            "rightCorner": {
              "x": -1.1,
              "y": 30.352,
              "z": 0.401
            },
            "gtin": "4068829387500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2061f",
            "leftCorner": {
              "x": -1.101,
              "y": 30.338,
              "z": 0.401
            },
            "rightCorner": {
              "x": -1.024,
              "y": 30.334,
              "z": 0.401
            },
            "gtin": "4063367140488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20620",
            "leftCorner": {
              "x": -1.023,
              "y": 30.349,
              "z": 0.401
            },
            "rightCorner": {
              "x": -0.961,
              "y": 30.345,
              "z": 0.401
            },
            "gtin": "4063367117152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20621",
            "leftCorner": {
              "x": -0.961,
              "y": 30.342,
              "z": 0.401
            },
            "rightCorner": {
              "x": -0.866,
              "y": 30.337,
              "z": 0.401
            },
            "gtin": "4003583221318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20622",
            "leftCorner": {
              "x": -0.866,
              "y": 30.337,
              "z": 0.401
            },
            "rightCorner": {
              "x": -0.771,
              "y": 30.332,
              "z": 0.401
            },
            "gtin": "4003583221318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20623",
            "leftCorner": {
              "x": -0.771,
              "y": 30.332,
              "z": 0.401
            },
            "rightCorner": {
              "x": -0.676,
              "y": 30.327,
              "z": 0.401
            },
            "gtin": "4003583221318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20624",
            "leftCorner": {
              "x": -0.676,
              "y": 30.319,
              "z": 0.401
            },
            "rightCorner": {
              "x": -0.611,
              "y": 30.315,
              "z": 0.401
            },
            "gtin": "4011609011454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20625",
            "leftCorner": {
              "x": -0.611,
              "y": 30.323,
              "z": 0.401
            },
            "rightCorner": {
              "x": -0.541,
              "y": 30.318,
              "z": 0.401
            },
            "gtin": "4015100428407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20626",
            "leftCorner": {
              "x": -0.541,
              "y": 30.318,
              "z": 0.401
            },
            "rightCorner": {
              "x": -0.482,
              "y": 30.315,
              "z": 0.401
            },
            "gtin": "4015100404128",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546663",
        "height": 0.79156,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a2099f",
            "leftCorner": {
              "x": -1.685,
              "y": 30.371,
              "z": 0.648
            },
            "rightCorner": {
              "x": -1.607,
              "y": 30.367,
              "z": 0.648
            },
            "gtin": "8700216422413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209a0",
            "leftCorner": {
              "x": -1.608,
              "y": 30.355,
              "z": 0.648
            },
            "rightCorner": {
              "x": -1.55,
              "y": 30.352,
              "z": 0.648
            },
            "gtin": "8700216422314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209a1",
            "leftCorner": {
              "x": -1.55,
              "y": 30.352,
              "z": 0.648
            },
            "rightCorner": {
              "x": -1.491,
              "y": 30.35,
              "z": 0.648
            },
            "gtin": "8700216422314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209a2",
            "leftCorner": {
              "x": -1.491,
              "y": 30.363,
              "z": 0.648
            },
            "rightCorner": {
              "x": -1.404,
              "y": 30.358,
              "z": 0.648
            },
            "gtin": "8700216821216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209a3",
            "leftCorner": {
              "x": -1.405,
              "y": 30.348,
              "z": 0.648
            },
            "rightCorner": {
              "x": -1.34,
              "y": 30.344,
              "z": 0.648
            },
            "gtin": "8700216558334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209a4",
            "leftCorner": {
              "x": -1.339,
              "y": 30.357,
              "z": 0.648
            },
            "rightCorner": {
              "x": -1.231,
              "y": 30.351,
              "z": 0.648
            },
            "gtin": "8700216821087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209a5",
            "leftCorner": {
              "x": -1.232,
              "y": 30.344,
              "z": 0.648
            },
            "rightCorner": {
              "x": -1.13,
              "y": 30.339,
              "z": 0.648
            },
            "gtin": "4015100816464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209a6",
            "leftCorner": {
              "x": -1.129,
              "y": 30.351,
              "z": 0.648
            },
            "rightCorner": {
              "x": -1.052,
              "y": 30.347,
              "z": 0.648
            },
            "gtin": "4015100865059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209a7",
            "leftCorner": {
              "x": -1.052,
              "y": 30.347,
              "z": 0.648
            },
            "rightCorner": {
              "x": -0.976,
              "y": 30.343,
              "z": 0.648
            },
            "gtin": "4015100865059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209a8",
            "leftCorner": {
              "x": -0.976,
              "y": 30.334,
              "z": 0.648
            },
            "rightCorner": {
              "x": -0.823,
              "y": 30.326,
              "z": 0.648
            },
            "gtin": "4015100864977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209a9",
            "leftCorner": {
              "x": -0.822,
              "y": 30.331,
              "z": 0.648
            },
            "rightCorner": {
              "x": -0.637,
              "y": 30.321,
              "z": 0.648
            },
            "gtin": "4015100864939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209aa",
            "leftCorner": {
              "x": -0.637,
              "y": 30.315,
              "z": 0.648
            },
            "rightCorner": {
              "x": -0.514,
              "y": 30.309,
              "z": 0.648
            },
            "gtin": "4015100865011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209ab",
            "leftCorner": {
              "x": -0.513,
              "y": 30.311,
              "z": 0.648
            },
            "rightCorner": {
              "x": -0.487,
              "y": 30.309,
              "z": 0.648
            },
            "gtin": "4015100862881",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546665",
        "height": 1.0446,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a209fe",
            "leftCorner": {
              "x": -1.527,
              "y": 30.351,
              "z": 0.855
            },
            "rightCorner": {
              "x": -1.46,
              "y": 30.348,
              "z": 0.855
            },
            "gtin": "8700216558259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209ff",
            "leftCorner": {
              "x": -1.46,
              "y": 30.348,
              "z": 0.855
            },
            "rightCorner": {
              "x": -1.393,
              "y": 30.345,
              "z": 0.855
            },
            "gtin": "8700216558259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a00",
            "leftCorner": {
              "x": -1.392,
              "y": 30.35,
              "z": 0.855
            },
            "rightCorner": {
              "x": -1.318,
              "y": 30.346,
              "z": 0.855
            },
            "gtin": "8700216558471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a01",
            "leftCorner": {
              "x": -1.318,
              "y": 30.346,
              "z": 0.855
            },
            "rightCorner": {
              "x": -1.244,
              "y": 30.342,
              "z": 0.855
            },
            "gtin": "8700216558471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a02",
            "leftCorner": {
              "x": -1.244,
              "y": 30.342,
              "z": 0.855
            },
            "rightCorner": {
              "x": -1.17,
              "y": 30.338,
              "z": 0.855
            },
            "gtin": "8700216558471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a03",
            "leftCorner": {
              "x": -1.171,
              "y": 30.325,
              "z": 0.855
            },
            "rightCorner": {
              "x": -1.098,
              "y": 30.321,
              "z": 0.855
            },
            "gtin": "8700216558082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a04",
            "leftCorner": {
              "x": -1.097,
              "y": 30.342,
              "z": 0.855
            },
            "rightCorner": {
              "x": -1.0,
              "y": 30.337,
              "z": 0.855
            },
            "gtin": "8700216422437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a05",
            "leftCorner": {
              "x": -1.0,
              "y": 30.337,
              "z": 0.855
            },
            "rightCorner": {
              "x": -0.904,
              "y": 30.332,
              "z": 0.855
            },
            "gtin": "8700216422437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a06",
            "leftCorner": {
              "x": -0.904,
              "y": 30.336,
              "z": 0.855
            },
            "rightCorner": {
              "x": -0.82,
              "y": 30.332,
              "z": 0.855
            },
            "gtin": "4005900910066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a07",
            "leftCorner": {
              "x": -0.821,
              "y": 30.325,
              "z": 0.855
            },
            "rightCorner": {
              "x": -0.736,
              "y": 30.321,
              "z": 0.855
            },
            "gtin": "4005900910141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a08",
            "leftCorner": {
              "x": -0.736,
              "y": 30.321,
              "z": 0.855
            },
            "rightCorner": {
              "x": -0.652,
              "y": 30.316,
              "z": 0.855
            },
            "gtin": "4005900910141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a09",
            "leftCorner": {
              "x": -0.652,
              "y": 30.316,
              "z": 0.855
            },
            "rightCorner": {
              "x": -0.589,
              "y": 30.313,
              "z": 0.855
            },
            "gtin": "4006000029702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a0a",
            "leftCorner": {
              "x": -0.589,
              "y": 30.313,
              "z": 0.855
            },
            "rightCorner": {
              "x": -0.525,
              "y": 30.309,
              "z": 0.855
            },
            "gtin": "4006000029702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a0b",
            "leftCorner": {
              "x": -0.525,
              "y": 30.319,
              "z": 0.855
            },
            "rightCorner": {
              "x": -0.412,
              "y": 30.313,
              "z": 0.855
            },
            "gtin": "4006000114743",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546667",
        "height": 1.3038,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20a65",
            "leftCorner": {
              "x": -1.645,
              "y": 30.478,
              "z": 1.067
            },
            "rightCorner": {
              "x": -1.543,
              "y": 30.473,
              "z": 1.067
            },
            "gtin": "8700216557658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a66",
            "leftCorner": {
              "x": -1.543,
              "y": 30.473,
              "z": 1.067
            },
            "rightCorner": {
              "x": -1.441,
              "y": 30.467,
              "z": 1.067
            },
            "gtin": "8700216557658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a67",
            "leftCorner": {
              "x": -1.442,
              "y": 30.458,
              "z": 1.067
            },
            "rightCorner": {
              "x": -1.356,
              "y": 30.454,
              "z": 1.067
            },
            "gtin": "8700216422116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a68",
            "leftCorner": {
              "x": -1.356,
              "y": 30.454,
              "z": 1.067
            },
            "rightCorner": {
              "x": -1.27,
              "y": 30.45,
              "z": 1.067
            },
            "gtin": "8700216422116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a69",
            "leftCorner": {
              "x": -1.269,
              "y": 30.47,
              "z": 1.067
            },
            "rightCorner": {
              "x": -1.17,
              "y": 30.465,
              "z": 1.067
            },
            "gtin": "8700216557696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a6a",
            "leftCorner": {
              "x": -1.17,
              "y": 30.465,
              "z": 1.067
            },
            "rightCorner": {
              "x": -1.072,
              "y": 30.459,
              "z": 1.067
            },
            "gtin": "8700216557696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a6b",
            "leftCorner": {
              "x": -1.072,
              "y": 30.459,
              "z": 1.067
            },
            "rightCorner": {
              "x": -0.973,
              "y": 30.454,
              "z": 1.067
            },
            "gtin": "8700216557696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a6c",
            "leftCorner": {
              "x": -0.974,
              "y": 30.442,
              "z": 1.067
            },
            "rightCorner": {
              "x": -0.914,
              "y": 30.439,
              "z": 1.067
            },
            "gtin": "8700216557955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a6d",
            "leftCorner": {
              "x": -0.914,
              "y": 30.439,
              "z": 1.067
            },
            "rightCorner": {
              "x": -0.853,
              "y": 30.435,
              "z": 1.067
            },
            "gtin": "8700216557955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a6e",
            "leftCorner": {
              "x": -0.853,
              "y": 30.435,
              "z": 1.067
            },
            "rightCorner": {
              "x": -0.793,
              "y": 30.432,
              "z": 1.067
            },
            "gtin": "8700216557955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a6f",
            "leftCorner": {
              "x": -0.793,
              "y": 30.432,
              "z": 1.067
            },
            "rightCorner": {
              "x": -0.733,
              "y": 30.429,
              "z": 1.067
            },
            "gtin": "8700216557955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a70",
            "leftCorner": {
              "x": -0.732,
              "y": 30.446,
              "z": 1.067
            },
            "rightCorner": {
              "x": -0.663,
              "y": 30.442,
              "z": 1.067
            },
            "gtin": "8700216558136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a71",
            "leftCorner": {
              "x": -0.663,
              "y": 30.442,
              "z": 1.067
            },
            "rightCorner": {
              "x": -0.595,
              "y": 30.439,
              "z": 1.067
            },
            "gtin": "8700216558136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a72",
            "leftCorner": {
              "x": -0.595,
              "y": 30.439,
              "z": 1.067
            },
            "rightCorner": {
              "x": -0.526,
              "y": 30.436,
              "z": 1.067
            },
            "gtin": "8700216558136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a73",
            "leftCorner": {
              "x": -0.526,
              "y": 30.436,
              "z": 1.067
            },
            "rightCorner": {
              "x": -0.458,
              "y": 30.432,
              "z": 1.067
            },
            "gtin": "8700216558136",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546664",
        "height": 1.5458,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ac3",
            "leftCorner": {
              "x": -1.66,
              "y": 30.462,
              "z": 1.265
            },
            "rightCorner": {
              "x": -1.586,
              "y": 30.458,
              "z": 1.265
            },
            "gtin": "4063367425226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ac4",
            "leftCorner": {
              "x": -1.586,
              "y": 30.458,
              "z": 1.265
            },
            "rightCorner": {
              "x": -1.513,
              "y": 30.455,
              "z": 1.265
            },
            "gtin": "4063367425226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ac5",
            "leftCorner": {
              "x": -1.513,
              "y": 30.444,
              "z": 1.265
            },
            "rightCorner": {
              "x": -1.448,
              "y": 30.441,
              "z": 1.265
            },
            "gtin": "4104260073005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ac6",
            "leftCorner": {
              "x": -1.448,
              "y": 30.437,
              "z": 1.265
            },
            "rightCorner": {
              "x": -1.349,
              "y": 30.432,
              "z": 1.265
            },
            "gtin": "42071389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ac7",
            "leftCorner": {
              "x": -1.348,
              "y": 30.451,
              "z": 1.265
            },
            "rightCorner": {
              "x": -1.175,
              "y": 30.442,
              "z": 1.265
            },
            "gtin": "41042649",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ac8",
            "leftCorner": {
              "x": -1.176,
              "y": 30.43,
              "z": 1.265
            },
            "rightCorner": {
              "x": -1.123,
              "y": 30.426,
              "z": 1.265
            },
            "gtin": "4021457655151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ac9",
            "leftCorner": {
              "x": -1.123,
              "y": 30.426,
              "z": 1.265
            },
            "rightCorner": {
              "x": -1.069,
              "y": 30.424,
              "z": 1.265
            },
            "gtin": "4021457655151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aca",
            "leftCorner": {
              "x": -1.069,
              "y": 30.43,
              "z": 1.265
            },
            "rightCorner": {
              "x": -0.976,
              "y": 30.425,
              "z": 1.265
            },
            "gtin": "4021457655113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20acb",
            "leftCorner": {
              "x": -0.975,
              "y": 30.44,
              "z": 1.265
            },
            "rightCorner": {
              "x": -0.909,
              "y": 30.436,
              "z": 1.265
            },
            "gtin": "4021457655120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20acc",
            "leftCorner": {
              "x": -0.909,
              "y": 30.436,
              "z": 1.265
            },
            "rightCorner": {
              "x": -0.842,
              "y": 30.432,
              "z": 1.265
            },
            "gtin": "4021457655120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20acd",
            "leftCorner": {
              "x": -0.842,
              "y": 30.432,
              "z": 1.265
            },
            "rightCorner": {
              "x": -0.783,
              "y": 30.429,
              "z": 1.265
            },
            "gtin": "4021457655137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ace",
            "leftCorner": {
              "x": -0.783,
              "y": 30.429,
              "z": 1.265
            },
            "rightCorner": {
              "x": -0.724,
              "y": 30.426,
              "z": 1.265
            },
            "gtin": "4021457655137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20acf",
            "leftCorner": {
              "x": -0.724,
              "y": 30.426,
              "z": 1.265
            },
            "rightCorner": {
              "x": -0.656,
              "y": 30.423,
              "z": 1.265
            },
            "gtin": "4021457647620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ad0",
            "leftCorner": {
              "x": -0.656,
              "y": 30.423,
              "z": 1.265
            },
            "rightCorner": {
              "x": -0.588,
              "y": 30.42,
              "z": 1.265
            },
            "gtin": "4021457647620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ad1",
            "leftCorner": {
              "x": -0.588,
              "y": 30.417,
              "z": 1.265
            },
            "rightCorner": {
              "x": -0.476,
              "y": 30.41,
              "z": 1.265
            },
            "gtin": "4021457655144",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d63",
    "rightNeighborShelfId": "a6d65"
  },
  {
    "id": "a6d65",
    "name": "a6d65",
    "x": -0.455,
    "y": 30.172,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.026369,
      "w": 0.99965
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 91
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546674",
        "height": 0.1605,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20b40",
            "leftCorner": {
              "x": -0.455,
              "y": 30.175,
              "z": 0.131
            },
            "rightCorner": {
              "x": -0.386,
              "y": 30.171,
              "z": 0.131
            },
            "gtin": "4009737385554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b41",
            "leftCorner": {
              "x": -0.386,
              "y": 30.171,
              "z": 0.131
            },
            "rightCorner": {
              "x": -0.317,
              "y": 30.167,
              "z": 0.131
            },
            "gtin": "4009737385554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b42",
            "leftCorner": {
              "x": -0.317,
              "y": 30.167,
              "z": 0.131
            },
            "rightCorner": {
              "x": -0.248,
              "y": 30.163,
              "z": 0.131
            },
            "gtin": "4009737385554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b44",
            "leftCorner": {
              "x": -0.245,
              "y": 30.207,
              "z": 0.131
            },
            "rightCorner": {
              "x": -0.147,
              "y": 30.202,
              "z": 0.131
            },
            "gtin": "4009737385530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b45",
            "leftCorner": {
              "x": -0.147,
              "y": 30.202,
              "z": 0.131
            },
            "rightCorner": {
              "x": -0.049,
              "y": 30.197,
              "z": 0.131
            },
            "gtin": "4009737385530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b46",
            "leftCorner": {
              "x": -0.049,
              "y": 30.198,
              "z": 0.131
            },
            "rightCorner": {
              "x": 0.066,
              "y": 30.192,
              "z": 0.131
            },
            "gtin": "4009737385547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b47",
            "leftCorner": {
              "x": 0.066,
              "y": 30.192,
              "z": 0.131
            },
            "rightCorner": {
              "x": 0.181,
              "y": 30.186,
              "z": 0.131
            },
            "gtin": "4009737385547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b48",
            "leftCorner": {
              "x": 0.181,
              "y": 30.186,
              "z": 0.131
            },
            "rightCorner": {
              "x": 0.296,
              "y": 30.18,
              "z": 0.131
            },
            "gtin": "4009737385547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b49",
            "leftCorner": {
              "x": 0.295,
              "y": 30.17,
              "z": 0.131
            },
            "rightCorner": {
              "x": 0.47,
              "y": 30.161,
              "z": 0.131
            },
            "gtin": "3600523649457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b4a",
            "leftCorner": {
              "x": 0.47,
              "y": 30.161,
              "z": 0.131
            },
            "rightCorner": {
              "x": 0.645,
              "y": 30.151,
              "z": 0.131
            },
            "gtin": "3600523649457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b4b",
            "leftCorner": {
              "x": 0.645,
              "y": 30.15,
              "z": 0.131
            },
            "rightCorner": {
              "x": 0.698,
              "y": 30.148,
              "z": 0.131
            },
            "gtin": "3600524030780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b4c",
            "leftCorner": {
              "x": 0.698,
              "y": 30.148,
              "z": 0.131
            },
            "rightCorner": {
              "x": 0.752,
              "y": 30.145,
              "z": 0.131
            },
            "gtin": "3600524030780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b4d",
            "leftCorner": {
              "x": 0.752,
              "y": 30.145,
              "z": 0.131
            },
            "rightCorner": {
              "x": 0.806,
              "y": 30.143,
              "z": 0.131
            },
            "gtin": "3600524030780",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54666f",
        "height": 0.49334,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20627",
            "leftCorner": {
              "x": -0.482,
              "y": 30.323,
              "z": 0.404
            },
            "rightCorner": {
              "x": -0.416,
              "y": 30.32,
              "z": 0.404
            },
            "gtin": "4015100403664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20628",
            "leftCorner": {
              "x": -0.417,
              "y": 30.296,
              "z": 0.404
            },
            "rightCorner": {
              "x": -0.333,
              "y": 30.292,
              "z": 0.404
            },
            "gtin": "4015100404548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20629",
            "leftCorner": {
              "x": -0.333,
              "y": 30.291,
              "z": 0.404
            },
            "rightCorner": {
              "x": -0.263,
              "y": 30.287,
              "z": 0.404
            },
            "gtin": "4015100812251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2062a",
            "leftCorner": {
              "x": -0.263,
              "y": 30.29,
              "z": 0.404
            },
            "rightCorner": {
              "x": -0.155,
              "y": 30.284,
              "z": 0.404
            },
            "gtin": "4015100812398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2062b",
            "leftCorner": {
              "x": -0.155,
              "y": 30.284,
              "z": 0.404
            },
            "rightCorner": {
              "x": -0.074,
              "y": 30.28,
              "z": 0.404
            },
            "gtin": "4015100812510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2062c",
            "leftCorner": {
              "x": -0.073,
              "y": 30.292,
              "z": 0.404
            },
            "rightCorner": {
              "x": -0.029,
              "y": 30.29,
              "z": 0.404
            },
            "gtin": "4015100812312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2062d",
            "leftCorner": {
              "x": -0.029,
              "y": 30.291,
              "z": 0.404
            },
            "rightCorner": {
              "x": 0.033,
              "y": 30.287,
              "z": 0.404
            },
            "gtin": "4015100812350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2062e",
            "leftCorner": {
              "x": 0.032,
              "y": 30.26,
              "z": 0.404
            },
            "rightCorner": {
              "x": 0.203,
              "y": 30.251,
              "z": 0.404
            },
            "gtin": "4015100813111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2062f",
            "leftCorner": {
              "x": 0.204,
              "y": 30.277,
              "z": 0.404
            },
            "rightCorner": {
              "x": 0.26,
              "y": 30.274,
              "z": 0.404
            },
            "gtin": "4015100812237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20630",
            "leftCorner": {
              "x": 0.259,
              "y": 30.267,
              "z": 0.404
            },
            "rightCorner": {
              "x": 0.318,
              "y": 30.263,
              "z": 0.404
            },
            "gtin": "4015100812336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20631",
            "leftCorner": {
              "x": 0.318,
              "y": 30.263,
              "z": 0.404
            },
            "rightCorner": {
              "x": 0.377,
              "y": 30.261,
              "z": 0.404
            },
            "gtin": "4015100812336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20632",
            "leftCorner": {
              "x": 0.378,
              "y": 30.266,
              "z": 0.404
            },
            "rightCorner": {
              "x": 0.444,
              "y": 30.263,
              "z": 0.404
            },
            "gtin": "4015100813098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20633",
            "leftCorner": {
              "x": 0.444,
              "y": 30.26,
              "z": 0.404
            },
            "rightCorner": {
              "x": 0.502,
              "y": 30.257,
              "z": 0.404
            },
            "gtin": "4015100812435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20634",
            "leftCorner": {
              "x": 0.502,
              "y": 30.258,
              "z": 0.404
            },
            "rightCorner": {
              "x": 0.642,
              "y": 30.251,
              "z": 0.404
            },
            "gtin": "4015100812275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20635",
            "leftCorner": {
              "x": 0.642,
              "y": 30.249,
              "z": 0.404
            },
            "rightCorner": {
              "x": 0.683,
              "y": 30.246,
              "z": 0.404
            },
            "gtin": "4015100812473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20636",
            "leftCorner": {
              "x": 0.683,
              "y": 30.232,
              "z": 0.404
            },
            "rightCorner": {
              "x": 0.733,
              "y": 30.23,
              "z": 0.404
            },
            "gtin": "4015100812572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20637",
            "leftCorner": {
              "x": 0.733,
              "y": 30.23,
              "z": 0.404
            },
            "rightCorner": {
              "x": 0.784,
              "y": 30.227,
              "z": 0.404
            },
            "gtin": "4015100812572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20638",
            "leftCorner": {
              "x": 0.785,
              "y": 30.245,
              "z": 0.404
            },
            "rightCorner": {
              "x": 0.837,
              "y": 30.242,
              "z": 0.404
            },
            "gtin": "4015100814095",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546670",
        "height": 0.78893,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a209ac",
            "leftCorner": {
              "x": -0.488,
              "y": 30.301,
              "z": 0.645
            },
            "rightCorner": {
              "x": -0.403,
              "y": 30.297,
              "z": 0.645
            },
            "gtin": "4015100815498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209ad",
            "leftCorner": {
              "x": -0.402,
              "y": 30.305,
              "z": 0.645
            },
            "rightCorner": {
              "x": -0.233,
              "y": 30.296,
              "z": 0.645
            },
            "gtin": "4015100864953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209ae",
            "leftCorner": {
              "x": -0.233,
              "y": 30.297,
              "z": 0.645
            },
            "rightCorner": {
              "x": -0.101,
              "y": 30.289,
              "z": 0.645
            },
            "gtin": "4015100864793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209af",
            "leftCorner": {
              "x": -0.101,
              "y": 30.289,
              "z": 0.645
            },
            "rightCorner": {
              "x": 0.042,
              "y": 30.282,
              "z": 0.645
            },
            "gtin": "4015100865073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209b0",
            "leftCorner": {
              "x": 0.042,
              "y": 30.27,
              "z": 0.645
            },
            "rightCorner": {
              "x": 0.18,
              "y": 30.262,
              "z": 0.645
            },
            "gtin": "4015100864991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209b1",
            "leftCorner": {
              "x": 0.181,
              "y": 30.273,
              "z": 0.645
            },
            "rightCorner": {
              "x": 0.306,
              "y": 30.267,
              "z": 0.645
            },
            "gtin": "4015100864830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209b2",
            "leftCorner": {
              "x": 0.306,
              "y": 30.263,
              "z": 0.645
            },
            "rightCorner": {
              "x": 0.376,
              "y": 30.259,
              "z": 0.645
            },
            "gtin": "4015100865035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209b3",
            "leftCorner": {
              "x": 0.376,
              "y": 30.259,
              "z": 0.645
            },
            "rightCorner": {
              "x": 0.446,
              "y": 30.256,
              "z": 0.645
            },
            "gtin": "4015100865035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209b4",
            "leftCorner": {
              "x": 0.446,
              "y": 30.26,
              "z": 0.645
            },
            "rightCorner": {
              "x": 0.55,
              "y": 30.254,
              "z": 0.645
            },
            "gtin": "4015100864816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209b5",
            "leftCorner": {
              "x": 0.55,
              "y": 30.256,
              "z": 0.645
            },
            "rightCorner": {
              "x": 0.625,
              "y": 30.253,
              "z": 0.645
            },
            "gtin": "4015100862904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209b6",
            "leftCorner": {
              "x": 0.625,
              "y": 30.253,
              "z": 0.645
            },
            "rightCorner": {
              "x": 0.7,
              "y": 30.249,
              "z": 0.645
            },
            "gtin": "4015100862904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209b7",
            "leftCorner": {
              "x": 0.7,
              "y": 30.245,
              "z": 0.645
            },
            "rightCorner": {
              "x": 0.773,
              "y": 30.241,
              "z": 0.645
            },
            "gtin": "4015100805048",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546671",
        "height": 1.04,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20a0c",
            "leftCorner": {
              "x": -0.413,
              "y": 30.294,
              "z": 0.851
            },
            "rightCorner": {
              "x": -0.357,
              "y": 30.292,
              "z": 0.851
            },
            "gtin": "4005900917782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a0d",
            "leftCorner": {
              "x": -0.357,
              "y": 30.292,
              "z": 0.851
            },
            "rightCorner": {
              "x": -0.3,
              "y": 30.289,
              "z": 0.851
            },
            "gtin": "4005900917782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a0e",
            "leftCorner": {
              "x": -0.3,
              "y": 30.296,
              "z": 0.851
            },
            "rightCorner": {
              "x": -0.251,
              "y": 30.292,
              "z": 0.851
            },
            "gtin": "4005900917744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a0f",
            "leftCorner": {
              "x": -0.251,
              "y": 30.292,
              "z": 0.851
            },
            "rightCorner": {
              "x": -0.201,
              "y": 30.29,
              "z": 0.851
            },
            "gtin": "4005900917744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a10",
            "leftCorner": {
              "x": -0.201,
              "y": 30.29,
              "z": 0.851
            },
            "rightCorner": {
              "x": -0.151,
              "y": 30.287,
              "z": 0.851
            },
            "gtin": "4005900917744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a11",
            "leftCorner": {
              "x": -0.151,
              "y": 30.291,
              "z": 0.851
            },
            "rightCorner": {
              "x": -0.091,
              "y": 30.288,
              "z": 0.851
            },
            "gtin": "4005900917829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a12",
            "leftCorner": {
              "x": -0.091,
              "y": 30.288,
              "z": 0.851
            },
            "rightCorner": {
              "x": -0.03,
              "y": 30.284,
              "z": 0.851
            },
            "gtin": "4005900917829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a13",
            "leftCorner": {
              "x": -0.03,
              "y": 30.276,
              "z": 0.851
            },
            "rightCorner": {
              "x": 0.01,
              "y": 30.274,
              "z": 0.851
            },
            "gtin": "4005900917959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a14",
            "leftCorner": {
              "x": 0.01,
              "y": 30.274,
              "z": 0.851
            },
            "rightCorner": {
              "x": 0.05,
              "y": 30.272,
              "z": 0.851
            },
            "gtin": "4005900917959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a15",
            "leftCorner": {
              "x": 0.05,
              "y": 30.281,
              "z": 0.851
            },
            "rightCorner": {
              "x": 0.092,
              "y": 30.278,
              "z": 0.851
            },
            "gtin": "4005900910301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a16",
            "leftCorner": {
              "x": 0.092,
              "y": 30.278,
              "z": 0.851
            },
            "rightCorner": {
              "x": 0.133,
              "y": 30.276,
              "z": 0.851
            },
            "gtin": "4005900910301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a17",
            "leftCorner": {
              "x": 0.133,
              "y": 30.275,
              "z": 0.851
            },
            "rightCorner": {
              "x": 0.191,
              "y": 30.272,
              "z": 0.851
            },
            "gtin": "4005900910226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a18",
            "leftCorner": {
              "x": 0.191,
              "y": 30.272,
              "z": 0.851
            },
            "rightCorner": {
              "x": 0.248,
              "y": 30.269,
              "z": 0.851
            },
            "gtin": "4005900910226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a19",
            "leftCorner": {
              "x": 0.248,
              "y": 30.261,
              "z": 0.851
            },
            "rightCorner": {
              "x": 0.305,
              "y": 30.258,
              "z": 0.851
            },
            "gtin": "4005900910103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a1a",
            "leftCorner": {
              "x": 0.305,
              "y": 30.258,
              "z": 0.851
            },
            "rightCorner": {
              "x": 0.362,
              "y": 30.254,
              "z": 0.851
            },
            "gtin": "4005900910103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a1b",
            "leftCorner": {
              "x": 0.362,
              "y": 30.254,
              "z": 0.851
            },
            "rightCorner": {
              "x": 0.419,
              "y": 30.252,
              "z": 0.851
            },
            "gtin": "4005900910103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a1c",
            "leftCorner": {
              "x": 0.419,
              "y": 30.252,
              "z": 0.851
            },
            "rightCorner": {
              "x": 0.476,
              "y": 30.249,
              "z": 0.851
            },
            "gtin": "4005900910103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a1d",
            "leftCorner": {
              "x": 0.476,
              "y": 30.255,
              "z": 0.851
            },
            "rightCorner": {
              "x": 0.537,
              "y": 30.251,
              "z": 0.851
            },
            "gtin": "4005900910349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a1e",
            "leftCorner": {
              "x": 0.537,
              "y": 30.251,
              "z": 0.851
            },
            "rightCorner": {
              "x": 0.598,
              "y": 30.247,
              "z": 0.851
            },
            "gtin": "4005900910349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a1f",
            "leftCorner": {
              "x": 0.598,
              "y": 30.247,
              "z": 0.851
            },
            "rightCorner": {
              "x": 0.659,
              "y": 30.245,
              "z": 0.851
            },
            "gtin": "4005900910349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a20",
            "leftCorner": {
              "x": 0.658,
              "y": 30.238,
              "z": 0.851
            },
            "rightCorner": {
              "x": 0.74,
              "y": 30.233,
              "z": 0.851
            },
            "gtin": "3600523950225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a21",
            "leftCorner": {
              "x": 0.74,
              "y": 30.227,
              "z": 0.851
            },
            "rightCorner": {
              "x": 0.816,
              "y": 30.223,
              "z": 0.851
            },
            "gtin": "3600524137564",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546673",
        "height": 1.3082,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20a74",
            "leftCorner": {
              "x": -0.46,
              "y": 30.383,
              "z": 1.07
            },
            "rightCorner": {
              "x": -0.348,
              "y": 30.378,
              "z": 1.07
            },
            "gtin": "8710908832192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a75",
            "leftCorner": {
              "x": -0.348,
              "y": 30.378,
              "z": 1.07
            },
            "rightCorner": {
              "x": -0.235,
              "y": 30.372,
              "z": 1.07
            },
            "gtin": "8710908832192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a76",
            "leftCorner": {
              "x": -0.235,
              "y": 30.372,
              "z": 1.07
            },
            "rightCorner": {
              "x": -0.123,
              "y": 30.365,
              "z": 1.07
            },
            "gtin": "8710908832192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a77",
            "leftCorner": {
              "x": -0.121,
              "y": 30.394,
              "z": 1.07
            },
            "rightCorner": {
              "x": 0.059,
              "y": 30.385,
              "z": 1.07
            },
            "gtin": "8710908832048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a78",
            "leftCorner": {
              "x": 0.059,
              "y": 30.385,
              "z": 1.07
            },
            "rightCorner": {
              "x": 0.239,
              "y": 30.376,
              "z": 1.07
            },
            "gtin": "8710908832048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a79",
            "leftCorner": {
              "x": 0.239,
              "y": 30.378,
              "z": 1.07
            },
            "rightCorner": {
              "x": 0.521,
              "y": 30.363,
              "z": 1.07
            },
            "gtin": "4005900917669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a7a",
            "leftCorner": {
              "x": 0.522,
              "y": 30.369,
              "z": 1.07
            },
            "rightCorner": {
              "x": 0.718,
              "y": 30.358,
              "z": 1.07
            },
            "gtin": "4005900917706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a7b",
            "leftCorner": {
              "x": 0.718,
              "y": 30.352,
              "z": 1.07
            },
            "rightCorner": {
              "x": 0.791,
              "y": 30.348,
              "z": 1.07
            },
            "gtin": "5012008741101",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546672",
        "height": 1.5461,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ad2",
            "leftCorner": {
              "x": -0.477,
              "y": 30.391,
              "z": 1.265
            },
            "rightCorner": {
              "x": -0.394,
              "y": 30.387,
              "z": 1.265
            },
            "gtin": "4021457655281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ad3",
            "leftCorner": {
              "x": -0.394,
              "y": 30.387,
              "z": 1.265
            },
            "rightCorner": {
              "x": -0.312,
              "y": 30.382,
              "z": 1.265
            },
            "gtin": "4021457655281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ad4",
            "leftCorner": {
              "x": -0.311,
              "y": 30.389,
              "z": 1.265
            },
            "rightCorner": {
              "x": -0.229,
              "y": 30.386,
              "z": 1.265
            },
            "gtin": "4021457655304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ad5",
            "leftCorner": {
              "x": -0.229,
              "y": 30.403,
              "z": 1.265
            },
            "rightCorner": {
              "x": -0.111,
              "y": 30.396,
              "z": 1.265
            },
            "gtin": "4084500390089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ad6",
            "leftCorner": {
              "x": -0.111,
              "y": 30.399,
              "z": 1.265
            },
            "rightCorner": {
              "x": -0.051,
              "y": 30.396,
              "z": 1.265
            },
            "gtin": "4084500084971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ad7",
            "leftCorner": {
              "x": -0.052,
              "y": 30.387,
              "z": 1.265
            },
            "rightCorner": {
              "x": 0.038,
              "y": 30.382,
              "z": 1.265
            },
            "gtin": "4084500085350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ad8",
            "leftCorner": {
              "x": 0.038,
              "y": 30.387,
              "z": 1.265
            },
            "rightCorner": {
              "x": 0.109,
              "y": 30.383,
              "z": 1.265
            },
            "gtin": "8001841890012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ad9",
            "leftCorner": {
              "x": 0.109,
              "y": 30.383,
              "z": 1.265
            },
            "rightCorner": {
              "x": 0.179,
              "y": 30.38,
              "z": 1.265
            },
            "gtin": "8001841890012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ada",
            "leftCorner": {
              "x": 0.179,
              "y": 30.38,
              "z": 1.265
            },
            "rightCorner": {
              "x": 0.249,
              "y": 30.376,
              "z": 1.265
            },
            "gtin": "8001841890012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20adb",
            "leftCorner": {
              "x": 0.249,
              "y": 30.381,
              "z": 1.265
            },
            "rightCorner": {
              "x": 0.313,
              "y": 30.378,
              "z": 1.265
            },
            "gtin": "4015100813579",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20adc",
            "leftCorner": {
              "x": 0.313,
              "y": 30.378,
              "z": 1.265
            },
            "rightCorner": {
              "x": 0.376,
              "y": 30.375,
              "z": 1.265
            },
            "gtin": "4015100813579",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20add",
            "leftCorner": {
              "x": 0.375,
              "y": 30.362,
              "z": 1.265
            },
            "rightCorner": {
              "x": 0.455,
              "y": 30.358,
              "z": 1.265
            },
            "gtin": "4015100338683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ade",
            "leftCorner": {
              "x": 0.456,
              "y": 30.37,
              "z": 1.265
            },
            "rightCorner": {
              "x": 0.525,
              "y": 30.367,
              "z": 1.265
            },
            "gtin": "4015100813951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20adf",
            "leftCorner": {
              "x": 0.525,
              "y": 30.361,
              "z": 1.265
            },
            "rightCorner": {
              "x": 0.57,
              "y": 30.358,
              "z": 1.265
            },
            "gtin": "4015100813999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ae0",
            "leftCorner": {
              "x": 0.57,
              "y": 30.358,
              "z": 1.265
            },
            "rightCorner": {
              "x": 0.615,
              "y": 30.356,
              "z": 1.265
            },
            "gtin": "4015100813999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ae1",
            "leftCorner": {
              "x": 0.615,
              "y": 30.358,
              "z": 1.265
            },
            "rightCorner": {
              "x": 0.675,
              "y": 30.355,
              "z": 1.265
            },
            "gtin": "4015100813890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ae2",
            "leftCorner": {
              "x": 0.675,
              "y": 30.355,
              "z": 1.265
            },
            "rightCorner": {
              "x": 0.734,
              "y": 30.352,
              "z": 1.265
            },
            "gtin": "4015100813890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ae3",
            "leftCorner": {
              "x": 0.734,
              "y": 30.346,
              "z": 1.265
            },
            "rightCorner": {
              "x": 0.792,
              "y": 30.342,
              "z": 1.265
            },
            "gtin": "4015100814118",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d64",
    "rightNeighborShelfId": "a6d66"
  },
  {
    "id": "a6d66",
    "name": "a6d66",
    "x": 0.794,
    "y": 30.106,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.026369,
      "w": 0.99965
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 109
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a54667a",
        "height": 0.1625,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20b4e",
            "leftCorner": {
              "x": 0.807,
              "y": 30.156,
              "z": 0.133
            },
            "rightCorner": {
              "x": 0.917,
              "y": 30.15,
              "z": 0.133
            },
            "gtin": "3600523682874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b4f",
            "leftCorner": {
              "x": 0.916,
              "y": 30.137,
              "z": 0.133
            },
            "rightCorner": {
              "x": 1.015,
              "y": 30.132,
              "z": 0.133
            },
            "gtin": "3600523900664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b50",
            "leftCorner": {
              "x": 1.015,
              "y": 30.135,
              "z": 0.133
            },
            "rightCorner": {
              "x": 1.07,
              "y": 30.132,
              "z": 0.133
            },
            "gtin": "3600524078300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b51",
            "leftCorner": {
              "x": 1.069,
              "y": 30.116,
              "z": 0.133
            },
            "rightCorner": {
              "x": 1.128,
              "y": 30.112,
              "z": 0.133
            },
            "gtin": "4015100860986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b52",
            "leftCorner": {
              "x": 1.128,
              "y": 30.112,
              "z": 0.133
            },
            "rightCorner": {
              "x": 1.187,
              "y": 30.109,
              "z": 0.133
            },
            "gtin": "4015100860986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b53",
            "leftCorner": {
              "x": 1.188,
              "y": 30.119,
              "z": 0.133
            },
            "rightCorner": {
              "x": 1.242,
              "y": 30.116,
              "z": 0.133
            },
            "gtin": "4015100860467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b54",
            "leftCorner": {
              "x": 1.242,
              "y": 30.116,
              "z": 0.133
            },
            "rightCorner": {
              "x": 1.297,
              "y": 30.113,
              "z": 0.133
            },
            "gtin": "4015100860467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b55",
            "leftCorner": {
              "x": 1.297,
              "y": 30.113,
              "z": 0.133
            },
            "rightCorner": {
              "x": 1.355,
              "y": 30.11,
              "z": 0.133
            },
            "gtin": "4015100860344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b56",
            "leftCorner": {
              "x": 1.355,
              "y": 30.118,
              "z": 0.133
            },
            "rightCorner": {
              "x": 1.437,
              "y": 30.114,
              "z": 0.133
            },
            "gtin": "4015100860481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b57",
            "leftCorner": {
              "x": 1.437,
              "y": 30.114,
              "z": 0.133
            },
            "rightCorner": {
              "x": 1.52,
              "y": 30.11,
              "z": 0.133
            },
            "gtin": "4015100860481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b58",
            "leftCorner": {
              "x": 1.52,
              "y": 30.11,
              "z": 0.133
            },
            "rightCorner": {
              "x": 1.602,
              "y": 30.105,
              "z": 0.133
            },
            "gtin": "4015100860481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b59",
            "leftCorner": {
              "x": 1.602,
              "y": 30.106,
              "z": 0.133
            },
            "rightCorner": {
              "x": 1.702,
              "y": 30.101,
              "z": 0.133
            },
            "gtin": "4015100860443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b5a",
            "leftCorner": {
              "x": 1.702,
              "y": 30.097,
              "z": 0.133
            },
            "rightCorner": {
              "x": 1.817,
              "y": 30.091,
              "z": 0.133
            },
            "gtin": "4895248003984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b5b",
            "leftCorner": {
              "x": 1.817,
              "y": 30.088,
              "z": 0.133
            },
            "rightCorner": {
              "x": 1.923,
              "y": 30.082,
              "z": 0.133
            },
            "gtin": "4895248003991",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20b5c",
            "leftCorner": {
              "x": 1.924,
              "y": 30.094,
              "z": 0.133
            },
            "rightCorner": {
              "x": 2.009,
              "y": 30.089,
              "z": 0.133
            },
            "gtin": "4895248005179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b5d",
            "leftCorner": {
              "x": 2.009,
              "y": 30.089,
              "z": 0.133
            },
            "rightCorner": {
              "x": 2.068,
              "y": 30.086,
              "z": 0.133
            },
            "gtin": "4895248005162",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546679",
        "height": 0.48948,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20639",
            "leftCorner": {
              "x": 0.838,
              "y": 30.238,
              "z": 0.4
            },
            "rightCorner": {
              "x": 0.903,
              "y": 30.235,
              "z": 0.4
            },
            "gtin": "4015100813319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2063a",
            "leftCorner": {
              "x": 0.903,
              "y": 30.23,
              "z": 0.4
            },
            "rightCorner": {
              "x": 0.957,
              "y": 30.228,
              "z": 0.4
            },
            "gtin": "4015100813333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2063b",
            "leftCorner": {
              "x": 0.957,
              "y": 30.223,
              "z": 0.4
            },
            "rightCorner": {
              "x": 1.033,
              "y": 30.219,
              "z": 0.4
            },
            "gtin": "3600523587841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2063c",
            "leftCorner": {
              "x": 1.033,
              "y": 30.223,
              "z": 0.4
            },
            "rightCorner": {
              "x": 1.124,
              "y": 30.219,
              "z": 0.4
            },
            "gtin": "3600523682775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2063d",
            "leftCorner": {
              "x": 1.125,
              "y": 30.228,
              "z": 0.4
            },
            "rightCorner": {
              "x": 1.195,
              "y": 30.224,
              "z": 0.4
            },
            "gtin": "4037900021503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2063e",
            "leftCorner": {
              "x": 1.195,
              "y": 30.21,
              "z": 0.4
            },
            "rightCorner": {
              "x": 1.254,
              "y": 30.208,
              "z": 0.4
            },
            "gtin": "3600523709946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2063f",
            "leftCorner": {
              "x": 1.255,
              "y": 30.217,
              "z": 0.4
            },
            "rightCorner": {
              "x": 1.329,
              "y": 30.213,
              "z": 0.4
            },
            "gtin": "3600523472628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20640",
            "leftCorner": {
              "x": 1.329,
              "y": 30.215,
              "z": 0.4
            },
            "rightCorner": {
              "x": 1.395,
              "y": 30.212,
              "z": 0.4
            },
            "gtin": "3600524074654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20641",
            "leftCorner": {
              "x": 1.395,
              "y": 30.212,
              "z": 0.4
            },
            "rightCorner": {
              "x": 1.461,
              "y": 30.208,
              "z": 0.4
            },
            "gtin": "3600524074654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20642",
            "leftCorner": {
              "x": 1.46,
              "y": 30.197,
              "z": 0.4
            },
            "rightCorner": {
              "x": 1.522,
              "y": 30.194,
              "z": 0.4
            },
            "gtin": "3600524075576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20643",
            "leftCorner": {
              "x": 1.522,
              "y": 30.194,
              "z": 0.4
            },
            "rightCorner": {
              "x": 1.583,
              "y": 30.19,
              "z": 0.4
            },
            "gtin": "3600524075576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20644",
            "leftCorner": {
              "x": 1.584,
              "y": 30.21,
              "z": 0.4
            },
            "rightCorner": {
              "x": 1.626,
              "y": 30.208,
              "z": 0.4
            },
            "gtin": "3600524074517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20645",
            "leftCorner": {
              "x": 1.626,
              "y": 30.208,
              "z": 0.4
            },
            "rightCorner": {
              "x": 1.668,
              "y": 30.205,
              "z": 0.4
            },
            "gtin": "3600524074517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20646",
            "leftCorner": {
              "x": 1.667,
              "y": 30.183,
              "z": 0.4
            },
            "rightCorner": {
              "x": 1.724,
              "y": 30.181,
              "z": 0.4
            },
            "gtin": "3600524030865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20647",
            "leftCorner": {
              "x": 1.724,
              "y": 30.181,
              "z": 0.4
            },
            "rightCorner": {
              "x": 1.782,
              "y": 30.178,
              "z": 0.4
            },
            "gtin": "3600524030865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20648",
            "leftCorner": {
              "x": 1.783,
              "y": 30.199,
              "z": 0.4
            },
            "rightCorner": {
              "x": 1.822,
              "y": 30.197,
              "z": 0.4
            },
            "gtin": "3600524144036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20649",
            "leftCorner": {
              "x": 1.822,
              "y": 30.197,
              "z": 0.4
            },
            "rightCorner": {
              "x": 1.862,
              "y": 30.195,
              "z": 0.4
            },
            "gtin": "3600524144036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2064a",
            "leftCorner": {
              "x": 1.862,
              "y": 30.196,
              "z": 0.4
            },
            "rightCorner": {
              "x": 1.935,
              "y": 30.192,
              "z": 0.4
            },
            "gtin": "3600524135430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2064b",
            "leftCorner": {
              "x": 1.935,
              "y": 30.19,
              "z": 0.4
            },
            "rightCorner": {
              "x": 1.995,
              "y": 30.187,
              "z": 0.4
            },
            "gtin": "3600524128005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2064c",
            "leftCorner": {
              "x": 1.995,
              "y": 30.195,
              "z": 0.4
            },
            "rightCorner": {
              "x": 2.051,
              "y": 30.192,
              "z": 0.4
            },
            "gtin": "5012008721509",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546677",
        "height": 0.79051,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a209b8",
            "leftCorner": {
              "x": 0.773,
              "y": 30.231,
              "z": 0.647
            },
            "rightCorner": {
              "x": 0.855,
              "y": 30.227,
              "z": 0.647
            },
            "gtin": "3600524142087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209b9",
            "leftCorner": {
              "x": 0.855,
              "y": 30.221,
              "z": 0.647
            },
            "rightCorner": {
              "x": 0.934,
              "y": 30.217,
              "z": 0.647
            },
            "gtin": "3600524141899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209ba",
            "leftCorner": {
              "x": 0.934,
              "y": 30.21,
              "z": 0.647
            },
            "rightCorner": {
              "x": 0.993,
              "y": 30.207,
              "z": 0.647
            },
            "gtin": "3600524142612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209bb",
            "leftCorner": {
              "x": 0.995,
              "y": 30.23,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.069,
              "y": 30.226,
              "z": 0.647
            },
            "gtin": "3600524142223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209bc",
            "leftCorner": {
              "x": 1.069,
              "y": 30.226,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.143,
              "y": 30.221,
              "z": 0.647
            },
            "gtin": "3600524142223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209bd",
            "leftCorner": {
              "x": 1.143,
              "y": 30.221,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.217,
              "y": 30.217,
              "z": 0.647
            },
            "gtin": "3600524142223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209be",
            "leftCorner": {
              "x": 1.216,
              "y": 30.212,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.299,
              "y": 30.208,
              "z": 0.647
            },
            "gtin": "3600524142575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209bf",
            "leftCorner": {
              "x": 1.299,
              "y": 30.206,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.371,
              "y": 30.202,
              "z": 0.647
            },
            "gtin": "3600524142988",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209c0",
            "leftCorner": {
              "x": 1.371,
              "y": 30.202,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.443,
              "y": 30.199,
              "z": 0.647
            },
            "gtin": "3600524142988",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209c1",
            "leftCorner": {
              "x": 1.443,
              "y": 30.204,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.517,
              "y": 30.2,
              "z": 0.647
            },
            "gtin": "3600524142889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209c2",
            "leftCorner": {
              "x": 1.517,
              "y": 30.2,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.592,
              "y": 30.196,
              "z": 0.647
            },
            "gtin": "3600524142889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209c3",
            "leftCorner": {
              "x": 1.592,
              "y": 30.196,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.666,
              "y": 30.192,
              "z": 0.647
            },
            "gtin": "3600524142889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209c4",
            "leftCorner": {
              "x": 1.667,
              "y": 30.196,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.74,
              "y": 30.193,
              "z": 0.647
            },
            "gtin": "3600524140069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209c5",
            "leftCorner": {
              "x": 1.74,
              "y": 30.193,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.813,
              "y": 30.189,
              "z": 0.647
            },
            "gtin": "3600524140069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209c6",
            "leftCorner": {
              "x": 1.813,
              "y": 30.186,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.88,
              "y": 30.182,
              "z": 0.647
            },
            "gtin": "3600524160463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209c7",
            "leftCorner": {
              "x": 1.88,
              "y": 30.182,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.947,
              "y": 30.179,
              "z": 0.647
            },
            "gtin": "3600524160463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209c8",
            "leftCorner": {
              "x": 1.947,
              "y": 30.179,
              "z": 0.647
            },
            "rightCorner": {
              "x": 1.996,
              "y": 30.176,
              "z": 0.647
            },
            "gtin": "3600524142315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209c9",
            "leftCorner": {
              "x": 1.996,
              "y": 30.176,
              "z": 0.647
            },
            "rightCorner": {
              "x": 2.045,
              "y": 30.174,
              "z": 0.647
            },
            "gtin": "3600524142315",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546678",
        "height": 1.0418,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20a22",
            "leftCorner": {
              "x": 0.818,
              "y": 30.243,
              "z": 0.852
            },
            "rightCorner": {
              "x": 0.886,
              "y": 30.24,
              "z": 0.852
            },
            "gtin": "3600524137823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a23",
            "leftCorner": {
              "x": 0.886,
              "y": 30.24,
              "z": 0.852
            },
            "rightCorner": {
              "x": 0.955,
              "y": 30.236,
              "z": 0.852
            },
            "gtin": "3600524137823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a24",
            "leftCorner": {
              "x": 0.954,
              "y": 30.213,
              "z": 0.852
            },
            "rightCorner": {
              "x": 1.01,
              "y": 30.21,
              "z": 0.852
            },
            "gtin": "3600524160456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a25",
            "leftCorner": {
              "x": 1.01,
              "y": 30.21,
              "z": 0.852
            },
            "rightCorner": {
              "x": 1.067,
              "y": 30.207,
              "z": 0.852
            },
            "gtin": "3600524160456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a26",
            "leftCorner": {
              "x": 1.067,
              "y": 30.216,
              "z": 0.852
            },
            "rightCorner": {
              "x": 1.131,
              "y": 30.212,
              "z": 0.852
            },
            "gtin": "3600524138868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a27",
            "leftCorner": {
              "x": 1.131,
              "y": 30.212,
              "z": 0.852
            },
            "rightCorner": {
              "x": 1.195,
              "y": 30.209,
              "z": 0.852
            },
            "gtin": "3600524138868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a28",
            "leftCorner": {
              "x": 1.195,
              "y": 30.205,
              "z": 0.852
            },
            "rightCorner": {
              "x": 1.278,
              "y": 30.201,
              "z": 0.852
            },
            "gtin": "3600524137465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a29",
            "leftCorner": {
              "x": 1.279,
              "y": 30.206,
              "z": 0.852
            },
            "rightCorner": {
              "x": 1.372,
              "y": 30.201,
              "z": 0.852
            },
            "gtin": "3600524137960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a2a",
            "leftCorner": {
              "x": 1.372,
              "y": 30.207,
              "z": 0.852
            },
            "rightCorner": {
              "x": 1.428,
              "y": 30.204,
              "z": 0.852
            },
            "gtin": "3600524138530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a2b",
            "leftCorner": {
              "x": 1.428,
              "y": 30.204,
              "z": 0.852
            },
            "rightCorner": {
              "x": 1.483,
              "y": 30.201,
              "z": 0.852
            },
            "gtin": "3600524138530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a2c",
            "leftCorner": {
              "x": 1.483,
              "y": 30.2,
              "z": 0.852
            },
            "rightCorner": {
              "x": 1.551,
              "y": 30.197,
              "z": 0.852
            },
            "gtin": "3600524142681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a2d",
            "leftCorner": {
              "x": 1.551,
              "y": 30.201,
              "z": 0.852
            },
            "rightCorner": {
              "x": 1.618,
              "y": 30.197,
              "z": 0.852
            },
            "gtin": "3600524160470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a2e",
            "leftCorner": {
              "x": 1.618,
              "y": 30.197,
              "z": 0.852
            },
            "rightCorner": {
              "x": 1.685,
              "y": 30.194,
              "z": 0.852
            },
            "gtin": "3600524160470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a2f",
            "leftCorner": {
              "x": 1.685,
              "y": 30.194,
              "z": 0.852
            },
            "rightCorner": {
              "x": 1.752,
              "y": 30.19,
              "z": 0.852
            },
            "gtin": "3600524160470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a30",
            "leftCorner": {
              "x": 1.752,
              "y": 30.184,
              "z": 0.852
            },
            "rightCorner": {
              "x": 1.86,
              "y": 30.178,
              "z": 0.852
            },
            "gtin": "3600524139742",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a31",
            "leftCorner": {
              "x": 1.86,
              "y": 30.179,
              "z": 0.852
            },
            "rightCorner": {
              "x": 1.928,
              "y": 30.175,
              "z": 0.852
            },
            "gtin": "3600524139674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a32",
            "leftCorner": {
              "x": 1.928,
              "y": 30.168,
              "z": 0.852
            },
            "rightCorner": {
              "x": 2.018,
              "y": 30.164,
              "z": 0.852
            },
            "gtin": "4072600282199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a33",
            "leftCorner": {
              "x": 2.018,
              "y": 30.167,
              "z": 0.852
            },
            "rightCorner": {
              "x": 2.049,
              "y": 30.165,
              "z": 0.852
            },
            "gtin": "4072600720219",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546675",
        "height": 1.3028,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20a7c",
            "leftCorner": {
              "x": 0.791,
              "y": 30.345,
              "z": 1.066
            },
            "rightCorner": {
              "x": 0.867,
              "y": 30.34,
              "z": 1.066
            },
            "gtin": "3600524142223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a7d",
            "leftCorner": {
              "x": 0.867,
              "y": 30.34,
              "z": 1.066
            },
            "rightCorner": {
              "x": 0.942,
              "y": 30.337,
              "z": 1.066
            },
            "gtin": "3600524142223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a7e",
            "leftCorner": {
              "x": 0.942,
              "y": 30.337,
              "z": 1.066
            },
            "rightCorner": {
              "x": 1.017,
              "y": 30.333,
              "z": 1.066
            },
            "gtin": "3600524142223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a7f",
            "leftCorner": {
              "x": 1.017,
              "y": 30.325,
              "z": 1.066
            },
            "rightCorner": {
              "x": 1.079,
              "y": 30.321,
              "z": 1.066
            },
            "gtin": "5012008672009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a80",
            "leftCorner": {
              "x": 1.079,
              "y": 30.321,
              "z": 1.066
            },
            "rightCorner": {
              "x": 1.141,
              "y": 30.318,
              "z": 1.066
            },
            "gtin": "5012008672009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a81",
            "leftCorner": {
              "x": 1.141,
              "y": 30.318,
              "z": 1.066
            },
            "rightCorner": {
              "x": 1.204,
              "y": 30.315,
              "z": 1.066
            },
            "gtin": "5012008672009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a82",
            "leftCorner": {
              "x": 1.203,
              "y": 30.31,
              "z": 1.066
            },
            "rightCorner": {
              "x": 1.281,
              "y": 30.305,
              "z": 1.066
            },
            "gtin": "5012008591904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a83",
            "leftCorner": {
              "x": 1.281,
              "y": 30.305,
              "z": 1.066
            },
            "rightCorner": {
              "x": 1.359,
              "y": 30.301,
              "z": 1.066
            },
            "gtin": "5012008591904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a84",
            "leftCorner": {
              "x": 1.359,
              "y": 30.301,
              "z": 1.066
            },
            "rightCorner": {
              "x": 1.437,
              "y": 30.297,
              "z": 1.066
            },
            "gtin": "5012008591904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a85",
            "leftCorner": {
              "x": 1.437,
              "y": 30.297,
              "z": 1.066
            },
            "rightCorner": {
              "x": 1.514,
              "y": 30.293,
              "z": 1.066
            },
            "gtin": "5012008591904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a86",
            "leftCorner": {
              "x": 1.514,
              "y": 30.293,
              "z": 1.066
            },
            "rightCorner": {
              "x": 1.592,
              "y": 30.289,
              "z": 1.066
            },
            "gtin": "5012008591904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a87",
            "leftCorner": {
              "x": 1.593,
              "y": 30.306,
              "z": 1.066
            },
            "rightCorner": {
              "x": 1.655,
              "y": 30.303,
              "z": 1.066
            },
            "gtin": "5012008592604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a88",
            "leftCorner": {
              "x": 1.655,
              "y": 30.303,
              "z": 1.066
            },
            "rightCorner": {
              "x": 1.718,
              "y": 30.299,
              "z": 1.066
            },
            "gtin": "5012008592604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a89",
            "leftCorner": {
              "x": 1.718,
              "y": 30.304,
              "z": 1.066
            },
            "rightCorner": {
              "x": 1.793,
              "y": 30.301,
              "z": 1.066
            },
            "gtin": "5012008592505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a8a",
            "leftCorner": {
              "x": 1.793,
              "y": 30.301,
              "z": 1.066
            },
            "rightCorner": {
              "x": 1.867,
              "y": 30.297,
              "z": 1.066
            },
            "gtin": "5012008592505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a8b",
            "leftCorner": {
              "x": 1.867,
              "y": 30.293,
              "z": 1.066
            },
            "rightCorner": {
              "x": 1.947,
              "y": 30.289,
              "z": 1.066
            },
            "gtin": "4104260074804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a8c",
            "leftCorner": {
              "x": 1.947,
              "y": 30.287,
              "z": 1.066
            },
            "rightCorner": {
              "x": 2.029,
              "y": 30.283,
              "z": 1.066
            },
            "gtin": "4104260076501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a8d",
            "leftCorner": {
              "x": 2.029,
              "y": 30.283,
              "z": 1.066
            },
            "rightCorner": {
              "x": 2.11,
              "y": 30.279,
              "z": 1.066
            },
            "gtin": "4104260076501",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546676",
        "height": 1.5484,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ae4",
            "leftCorner": {
              "x": 0.794,
              "y": 30.351,
              "z": 1.267
            },
            "rightCorner": {
              "x": 0.848,
              "y": 30.348,
              "z": 1.267
            },
            "gtin": "4015100813791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ae5",
            "leftCorner": {
              "x": 0.847,
              "y": 30.344,
              "z": 1.267
            },
            "rightCorner": {
              "x": 0.899,
              "y": 30.341,
              "z": 1.267
            },
            "gtin": "4015100813418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ae6",
            "leftCorner": {
              "x": 0.899,
              "y": 30.341,
              "z": 1.267
            },
            "rightCorner": {
              "x": 0.951,
              "y": 30.338,
              "z": 1.267
            },
            "gtin": "4015100813418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ae7",
            "leftCorner": {
              "x": 0.951,
              "y": 30.338,
              "z": 1.267
            },
            "rightCorner": {
              "x": 1.065,
              "y": 30.333,
              "z": 1.267
            },
            "gtin": "4015100813470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ae8",
            "leftCorner": {
              "x": 1.065,
              "y": 30.328,
              "z": 1.267
            },
            "rightCorner": {
              "x": 1.132,
              "y": 30.324,
              "z": 1.267
            },
            "gtin": "4015100813432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ae9",
            "leftCorner": {
              "x": 1.132,
              "y": 30.322,
              "z": 1.267
            },
            "rightCorner": {
              "x": 1.172,
              "y": 30.32,
              "z": 1.267
            },
            "gtin": "4015100813395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aea",
            "leftCorner": {
              "x": 1.172,
              "y": 30.32,
              "z": 1.267
            },
            "rightCorner": {
              "x": 1.212,
              "y": 30.318,
              "z": 1.267
            },
            "gtin": "4015100813395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aeb",
            "leftCorner": {
              "x": 1.212,
              "y": 30.317,
              "z": 1.267
            },
            "rightCorner": {
              "x": 1.287,
              "y": 30.314,
              "z": 1.267
            },
            "gtin": "4015100861785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aec",
            "leftCorner": {
              "x": 1.287,
              "y": 30.309,
              "z": 1.267
            },
            "rightCorner": {
              "x": 1.399,
              "y": 30.303,
              "z": 1.267
            },
            "gtin": "4015100813456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aed",
            "leftCorner": {
              "x": 1.4,
              "y": 30.321,
              "z": 1.267
            },
            "rightCorner": {
              "x": 1.448,
              "y": 30.319,
              "z": 1.267
            },
            "gtin": "5012008741101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aee",
            "leftCorner": {
              "x": 1.448,
              "y": 30.321,
              "z": 1.267
            },
            "rightCorner": {
              "x": 1.504,
              "y": 30.317,
              "z": 1.267
            },
            "gtin": "3600524034160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aef",
            "leftCorner": {
              "x": 1.503,
              "y": 30.299,
              "z": 1.267
            },
            "rightCorner": {
              "x": 1.581,
              "y": 30.295,
              "z": 1.267
            },
            "gtin": "3600523733088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20af0",
            "leftCorner": {
              "x": 1.581,
              "y": 30.295,
              "z": 1.267
            },
            "rightCorner": {
              "x": 1.658,
              "y": 30.291,
              "z": 1.267
            },
            "gtin": "3600523733088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20af1",
            "leftCorner": {
              "x": 1.659,
              "y": 30.31,
              "z": 1.267
            },
            "rightCorner": {
              "x": 1.74,
              "y": 30.305,
              "z": 1.267
            },
            "gtin": "3600523749188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20af2",
            "leftCorner": {
              "x": 1.739,
              "y": 30.296,
              "z": 1.267
            },
            "rightCorner": {
              "x": 1.808,
              "y": 30.292,
              "z": 1.267
            },
            "gtin": "3600523800674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20af3",
            "leftCorner": {
              "x": 1.808,
              "y": 30.292,
              "z": 1.267
            },
            "rightCorner": {
              "x": 1.876,
              "y": 30.289,
              "z": 1.267
            },
            "gtin": "3600523800674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20af4",
            "leftCorner": {
              "x": 1.876,
              "y": 30.297,
              "z": 1.267
            },
            "rightCorner": {
              "x": 1.931,
              "y": 30.293,
              "z": 1.267
            },
            "gtin": "3574661563312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20af5",
            "leftCorner": {
              "x": 1.931,
              "y": 30.293,
              "z": 1.267
            },
            "rightCorner": {
              "x": 1.986,
              "y": 30.29,
              "z": 1.267
            },
            "gtin": "3574661563312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20af6",
            "leftCorner": {
              "x": 1.986,
              "y": 30.279,
              "z": 1.267
            },
            "rightCorner": {
              "x": 2.064,
              "y": 30.275,
              "z": 1.267
            },
            "gtin": "3600523970605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20af7",
            "leftCorner": {
              "x": 2.064,
              "y": 30.275,
              "z": 1.267
            },
            "rightCorner": {
              "x": 2.143,
              "y": 30.271,
              "z": 1.267
            },
            "gtin": "3600523970605",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d65",
    "rightNeighborShelfId": "a6d67"
  },
  {
    "id": "a6d67",
    "name": "a6d67",
    "x": 2.042,
    "y": 30.04,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.026369,
      "w": 0.99965
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 99
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546686",
        "height": 1.042,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20a41",
            "leftCorner": {
              "x": 3.015,
              "y": 30.117,
              "z": 0.853
            },
            "rightCorner": {
              "x": 3.065,
              "y": 30.115,
              "z": 0.853
            },
            "gtin": "42447504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a34",
            "leftCorner": {
              "x": 2.049,
              "y": 30.171,
              "z": 0.853
            },
            "rightCorner": {
              "x": 2.133,
              "y": 30.166,
              "z": 0.853
            },
            "gtin": "4072600282496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a35",
            "leftCorner": {
              "x": 2.133,
              "y": 30.159,
              "z": 0.853
            },
            "rightCorner": {
              "x": 2.219,
              "y": 30.154,
              "z": 0.853
            },
            "gtin": "4072600382349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a36",
            "leftCorner": {
              "x": 2.22,
              "y": 30.163,
              "z": 0.853
            },
            "rightCorner": {
              "x": 2.295,
              "y": 30.16,
              "z": 0.853
            },
            "gtin": "4072600282274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a37",
            "leftCorner": {
              "x": 2.295,
              "y": 30.16,
              "z": 0.853
            },
            "rightCorner": {
              "x": 2.37,
              "y": 30.156,
              "z": 0.853
            },
            "gtin": "4072600282274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a38",
            "leftCorner": {
              "x": 2.37,
              "y": 30.158,
              "z": 0.853
            },
            "rightCorner": {
              "x": 2.425,
              "y": 30.154,
              "z": 0.853
            },
            "gtin": "4072600703304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a39",
            "leftCorner": {
              "x": 2.425,
              "y": 30.151,
              "z": 0.853
            },
            "rightCorner": {
              "x": 2.488,
              "y": 30.147,
              "z": 0.853
            },
            "gtin": "4072600282281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a3a",
            "leftCorner": {
              "x": 2.488,
              "y": 30.147,
              "z": 0.853
            },
            "rightCorner": {
              "x": 2.551,
              "y": 30.145,
              "z": 0.853
            },
            "gtin": "4072600282281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a3b",
            "leftCorner": {
              "x": 2.55,
              "y": 30.141,
              "z": 0.853
            },
            "rightCorner": {
              "x": 2.633,
              "y": 30.136,
              "z": 0.853
            },
            "gtin": "4072600283172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a3c",
            "leftCorner": {
              "x": 2.633,
              "y": 30.136,
              "z": 0.853
            },
            "rightCorner": {
              "x": 2.716,
              "y": 30.132,
              "z": 0.853
            },
            "gtin": "4072600283172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a3d",
            "leftCorner": {
              "x": 2.717,
              "y": 30.138,
              "z": 0.853
            },
            "rightCorner": {
              "x": 2.794,
              "y": 30.134,
              "z": 0.853
            },
            "gtin": "4072600282205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a3e",
            "leftCorner": {
              "x": 2.794,
              "y": 30.126,
              "z": 0.853
            },
            "rightCorner": {
              "x": 2.878,
              "y": 30.121,
              "z": 0.853
            },
            "gtin": "4072600282373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a3f",
            "leftCorner": {
              "x": 2.879,
              "y": 30.131,
              "z": 0.853
            },
            "rightCorner": {
              "x": 2.941,
              "y": 30.128,
              "z": 0.853
            },
            "gtin": "4072600701201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a40",
            "leftCorner": {
              "x": 2.941,
              "y": 30.128,
              "z": 0.853
            },
            "rightCorner": {
              "x": 3.015,
              "y": 30.124,
              "z": 0.853
            },
            "gtin": "4072600701218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a42",
            "leftCorner": {
              "x": 3.065,
              "y": 30.12,
              "z": 0.853
            },
            "rightCorner": {
              "x": 3.148,
              "y": 30.116,
              "z": 0.853
            },
            "gtin": "5037156292176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a43",
            "leftCorner": {
              "x": 3.148,
              "y": 30.116,
              "z": 0.853
            },
            "rightCorner": {
              "x": 3.23,
              "y": 30.111,
              "z": 0.853
            },
            "gtin": "5037156292176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209da",
            "leftCorner": {
              "x": 3.229,
              "y": 30.084,
              "z": 0.853
            },
            "rightCorner": {
              "x": 3.262,
              "y": 30.082,
              "z": 0.853
            },
            "gtin": "4072600720097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209db",
            "leftCorner": {
              "x": 3.262,
              "y": 30.082,
              "z": 0.853
            },
            "rightCorner": {
              "x": 3.296,
              "y": 30.081,
              "z": 0.853
            },
            "gtin": "4072600720097",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546687",
        "height": 0.16267,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20b5e",
            "leftCorner": {
              "x": 2.067,
              "y": 30.073,
              "z": 0.133
            },
            "rightCorner": {
              "x": 2.176,
              "y": 30.068,
              "z": 0.133
            },
            "gtin": "4897097266404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b5f",
            "leftCorner": {
              "x": 2.176,
              "y": 30.071,
              "z": 0.133
            },
            "rightCorner": {
              "x": 2.264,
              "y": 30.067,
              "z": 0.133
            },
            "gtin": "4897097266329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b60",
            "leftCorner": {
              "x": 2.264,
              "y": 30.078,
              "z": 0.133
            },
            "rightCorner": {
              "x": 2.357,
              "y": 30.073,
              "z": 0.133
            },
            "gtin": "4897097266428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b61",
            "leftCorner": {
              "x": 2.356,
              "y": 30.065,
              "z": 0.133
            },
            "rightCorner": {
              "x": 2.436,
              "y": 30.061,
              "z": 0.133
            },
            "gtin": "4897097266343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b62",
            "leftCorner": {
              "x": 2.437,
              "y": 30.077,
              "z": 0.133
            },
            "rightCorner": {
              "x": 2.524,
              "y": 30.072,
              "z": 0.133
            },
            "gtin": "4897097266336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b63",
            "leftCorner": {
              "x": 2.525,
              "y": 30.077,
              "z": 0.133
            },
            "rightCorner": {
              "x": 2.593,
              "y": 30.073,
              "z": 0.133
            },
            "gtin": "4897097266411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b64",
            "leftCorner": {
              "x": 2.593,
              "y": 30.067,
              "z": 0.133
            },
            "rightCorner": {
              "x": 2.714,
              "y": 30.061,
              "z": 0.133
            },
            "gtin": "4897097266398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b65",
            "leftCorner": {
              "x": 2.713,
              "y": 30.055,
              "z": 0.133
            },
            "rightCorner": {
              "x": 2.789,
              "y": 30.051,
              "z": 0.133
            },
            "gtin": "4897097266312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b66",
            "leftCorner": {
              "x": 2.788,
              "y": 30.049,
              "z": 0.133
            },
            "rightCorner": {
              "x": 2.878,
              "y": 30.044,
              "z": 0.133
            },
            "gtin": "022796976123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b67",
            "leftCorner": {
              "x": 2.878,
              "y": 30.044,
              "z": 0.133
            },
            "rightCorner": {
              "x": 2.971,
              "y": 30.04,
              "z": 0.133
            },
            "gtin": "022796976116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b68",
            "leftCorner": {
              "x": 2.97,
              "y": 30.03,
              "z": 0.133
            },
            "rightCorner": {
              "x": 3.084,
              "y": 30.024,
              "z": 0.133
            },
            "gtin": "3574661799162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b69",
            "leftCorner": {
              "x": 3.085,
              "y": 30.032,
              "z": 0.133
            },
            "rightCorner": {
              "x": 3.171,
              "y": 30.028,
              "z": 0.133
            },
            "gtin": "022796976024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b43",
            "leftCorner": {
              "x": 3.17,
              "y": 29.994,
              "z": 0.133
            },
            "rightCorner": {
              "x": 3.291,
              "y": 29.987,
              "z": 0.133
            },
            "gtin": "3600523899869",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546684",
        "height": 0.49826,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2064d",
            "leftCorner": {
              "x": 2.05,
              "y": 30.186,
              "z": 0.408
            },
            "rightCorner": {
              "x": 2.118,
              "y": 30.182,
              "z": 0.408
            },
            "gtin": "5012008735001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2064e",
            "leftCorner": {
              "x": 2.117,
              "y": 30.173,
              "z": 0.408
            },
            "rightCorner": {
              "x": 2.194,
              "y": 30.169,
              "z": 0.408
            },
            "gtin": "5012008735100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2064f",
            "leftCorner": {
              "x": 2.194,
              "y": 30.167,
              "z": 0.408
            },
            "rightCorner": {
              "x": 2.226,
              "y": 30.165,
              "z": 0.408
            },
            "gtin": "5012008721202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20650",
            "leftCorner": {
              "x": 2.226,
              "y": 30.165,
              "z": 0.408
            },
            "rightCorner": {
              "x": 2.258,
              "y": 30.163,
              "z": 0.408
            },
            "gtin": "5012008721202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20651",
            "leftCorner": {
              "x": 2.258,
              "y": 30.174,
              "z": 0.408
            },
            "rightCorner": {
              "x": 2.309,
              "y": 30.171,
              "z": 0.408
            },
            "gtin": "5012008721004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20652",
            "leftCorner": {
              "x": 2.309,
              "y": 30.175,
              "z": 0.408
            },
            "rightCorner": {
              "x": 2.344,
              "y": 30.173,
              "z": 0.408
            },
            "gtin": "5012008765008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20653",
            "leftCorner": {
              "x": 2.344,
              "y": 30.173,
              "z": 0.408
            },
            "rightCorner": {
              "x": 2.38,
              "y": 30.171,
              "z": 0.408
            },
            "gtin": "5012008765008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20654",
            "leftCorner": {
              "x": 2.38,
              "y": 30.168,
              "z": 0.408
            },
            "rightCorner": {
              "x": 2.431,
              "y": 30.166,
              "z": 0.408
            },
            "gtin": "5012008742504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20655",
            "leftCorner": {
              "x": 2.431,
              "y": 30.16,
              "z": 0.408
            },
            "rightCorner": {
              "x": 2.491,
              "y": 30.157,
              "z": 0.408
            },
            "gtin": "022796976017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20656",
            "leftCorner": {
              "x": 2.491,
              "y": 30.157,
              "z": 0.408
            },
            "rightCorner": {
              "x": 2.551,
              "y": 30.154,
              "z": 0.408
            },
            "gtin": "022796976017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20657",
            "leftCorner": {
              "x": 2.55,
              "y": 30.141,
              "z": 0.408
            },
            "rightCorner": {
              "x": 2.678,
              "y": 30.134,
              "z": 0.408
            },
            "gtin": "3574661798448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20658",
            "leftCorner": {
              "x": 2.679,
              "y": 30.152,
              "z": 0.408
            },
            "rightCorner": {
              "x": 2.727,
              "y": 30.149,
              "z": 0.408
            },
            "gtin": "022796976703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20659",
            "leftCorner": {
              "x": 2.727,
              "y": 30.149,
              "z": 0.408
            },
            "rightCorner": {
              "x": 2.775,
              "y": 30.146,
              "z": 0.408
            },
            "gtin": "022796976703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2065a",
            "leftCorner": {
              "x": 2.774,
              "y": 30.131,
              "z": 0.408
            },
            "rightCorner": {
              "x": 2.837,
              "y": 30.128,
              "z": 0.408
            },
            "gtin": "3574661799506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2065b",
            "leftCorner": {
              "x": 2.837,
              "y": 30.128,
              "z": 0.408
            },
            "rightCorner": {
              "x": 2.899,
              "y": 30.125,
              "z": 0.408
            },
            "gtin": "3574661799506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2065c",
            "leftCorner": {
              "x": 2.899,
              "y": 30.125,
              "z": 0.408
            },
            "rightCorner": {
              "x": 2.962,
              "y": 30.122,
              "z": 0.408
            },
            "gtin": "3574661799506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2065d",
            "leftCorner": {
              "x": 2.962,
              "y": 30.132,
              "z": 0.408
            },
            "rightCorner": {
              "x": 3.051,
              "y": 30.126,
              "z": 0.408
            },
            "gtin": "022796970053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2065e",
            "leftCorner": {
              "x": 3.05,
              "y": 30.117,
              "z": 0.408
            },
            "rightCorner": {
              "x": 3.165,
              "y": 30.111,
              "z": 0.408
            },
            "gtin": "022796976017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2058b",
            "leftCorner": {
              "x": 3.166,
              "y": 30.124,
              "z": 0.408
            },
            "rightCorner": {
              "x": 3.232,
              "y": 30.12,
              "z": 0.408
            },
            "gtin": "3574661685144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2058c",
            "leftCorner": {
              "x": 3.232,
              "y": 30.12,
              "z": 0.408
            },
            "rightCorner": {
              "x": 3.298,
              "y": 30.117,
              "z": 0.408
            },
            "gtin": "3574661685144",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546685",
        "height": 0.78969,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a209ca",
            "leftCorner": {
              "x": 2.044,
              "y": 30.173,
              "z": 0.646
            },
            "rightCorner": {
              "x": 2.136,
              "y": 30.168,
              "z": 0.646
            },
            "gtin": "4072600282458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209cb",
            "leftCorner": {
              "x": 2.136,
              "y": 30.169,
              "z": 0.646
            },
            "rightCorner": {
              "x": 2.225,
              "y": 30.165,
              "z": 0.646
            },
            "gtin": "4072600282304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209cc",
            "leftCorner": {
              "x": 2.225,
              "y": 30.166,
              "z": 0.646
            },
            "rightCorner": {
              "x": 2.315,
              "y": 30.161,
              "z": 0.646
            },
            "gtin": "4072600282427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209cd",
            "leftCorner": {
              "x": 2.315,
              "y": 30.161,
              "z": 0.646
            },
            "rightCorner": {
              "x": 2.404,
              "y": 30.157,
              "z": 0.646
            },
            "gtin": "4072600282427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209ce",
            "leftCorner": {
              "x": 2.404,
              "y": 30.153,
              "z": 0.646
            },
            "rightCorner": {
              "x": 2.468,
              "y": 30.149,
              "z": 0.646
            },
            "gtin": "4072600731505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209cf",
            "leftCorner": {
              "x": 2.468,
              "y": 30.149,
              "z": 0.646
            },
            "rightCorner": {
              "x": 2.532,
              "y": 30.146,
              "z": 0.646
            },
            "gtin": "4072600731505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209d0",
            "leftCorner": {
              "x": 2.532,
              "y": 30.148,
              "z": 0.646
            },
            "rightCorner": {
              "x": 2.605,
              "y": 30.144,
              "z": 0.646
            },
            "gtin": "4072600703403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209d1",
            "leftCorner": {
              "x": 2.605,
              "y": 30.144,
              "z": 0.646
            },
            "rightCorner": {
              "x": 2.677,
              "y": 30.14,
              "z": 0.646
            },
            "gtin": "4072600703403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209d2",
            "leftCorner": {
              "x": 2.676,
              "y": 30.133,
              "z": 0.646
            },
            "rightCorner": {
              "x": 2.727,
              "y": 30.13,
              "z": 0.646
            },
            "gtin": "4072600282267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209d3",
            "leftCorner": {
              "x": 2.728,
              "y": 30.14,
              "z": 0.646
            },
            "rightCorner": {
              "x": 2.823,
              "y": 30.135,
              "z": 0.646
            },
            "gtin": "4072600282380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209d4",
            "leftCorner": {
              "x": 2.823,
              "y": 30.129,
              "z": 0.646
            },
            "rightCorner": {
              "x": 2.908,
              "y": 30.124,
              "z": 0.646
            },
            "gtin": "4072600282335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209d5",
            "leftCorner": {
              "x": 2.908,
              "y": 30.119,
              "z": 0.646
            },
            "rightCorner": {
              "x": 2.988,
              "y": 30.115,
              "z": 0.646
            },
            "gtin": "4072600282298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209d6",
            "leftCorner": {
              "x": 2.988,
              "y": 30.115,
              "z": 0.646
            },
            "rightCorner": {
              "x": 3.068,
              "y": 30.111,
              "z": 0.646
            },
            "gtin": "4072600282298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209d7",
            "leftCorner": {
              "x": 3.069,
              "y": 30.116,
              "z": 0.646
            },
            "rightCorner": {
              "x": 3.141,
              "y": 30.113,
              "z": 0.646
            },
            "gtin": "4072600282465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a209d8",
            "leftCorner": {
              "x": 3.141,
              "y": 30.115,
              "z": 0.646
            },
            "rightCorner": {
              "x": 3.21,
              "y": 30.111,
              "z": 0.646
            },
            "gtin": "4072600282236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2097e",
            "leftCorner": {
              "x": 3.21,
              "y": 30.108,
              "z": 0.646
            },
            "rightCorner": {
              "x": 3.297,
              "y": 30.103,
              "z": 0.646
            },
            "gtin": "4072600282250",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546682",
        "height": 1.2948,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20a8e",
            "leftCorner": {
              "x": 2.109,
              "y": 30.27,
              "z": 1.059
            },
            "rightCorner": {
              "x": 2.166,
              "y": 30.268,
              "z": 1.059
            },
            "gtin": "4037900021503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a8f",
            "leftCorner": {
              "x": 2.165,
              "y": 30.242,
              "z": 1.059
            },
            "rightCorner": {
              "x": 2.255,
              "y": 30.237,
              "z": 1.059
            },
            "gtin": "5037156275292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a90",
            "leftCorner": {
              "x": 2.255,
              "y": 30.237,
              "z": 1.059
            },
            "rightCorner": {
              "x": 2.345,
              "y": 30.231,
              "z": 1.059
            },
            "gtin": "5037156275292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a91",
            "leftCorner": {
              "x": 2.347,
              "y": 30.264,
              "z": 1.059
            },
            "rightCorner": {
              "x": 2.418,
              "y": 30.26,
              "z": 1.059
            },
            "gtin": "50008605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a92",
            "leftCorner": {
              "x": 2.419,
              "y": 30.271,
              "z": 1.059
            },
            "rightCorner": {
              "x": 2.486,
              "y": 30.267,
              "z": 1.059
            },
            "gtin": "3574661563312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a93",
            "leftCorner": {
              "x": 2.486,
              "y": 30.267,
              "z": 1.059
            },
            "rightCorner": {
              "x": 2.599,
              "y": 30.261,
              "z": 1.059
            },
            "gtin": "5037156292985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a94",
            "leftCorner": {
              "x": 2.599,
              "y": 30.254,
              "z": 1.059
            },
            "rightCorner": {
              "x": 2.672,
              "y": 30.25,
              "z": 1.059
            },
            "gtin": "5037156292992",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a95",
            "leftCorner": {
              "x": 2.672,
              "y": 30.25,
              "z": 1.059
            },
            "rightCorner": {
              "x": 2.746,
              "y": 30.247,
              "z": 1.059
            },
            "gtin": "5037156292992",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a96",
            "leftCorner": {
              "x": 2.747,
              "y": 30.253,
              "z": 1.059
            },
            "rightCorner": {
              "x": 2.792,
              "y": 30.251,
              "z": 1.059
            },
            "gtin": "5037156263961",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a97",
            "leftCorner": {
              "x": 2.792,
              "y": 30.251,
              "z": 1.059
            },
            "rightCorner": {
              "x": 2.838,
              "y": 30.248,
              "z": 1.059
            },
            "gtin": "5037156263961",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a98",
            "leftCorner": {
              "x": 2.837,
              "y": 30.246,
              "z": 1.059
            },
            "rightCorner": {
              "x": 2.93,
              "y": 30.242,
              "z": 1.059
            },
            "gtin": "5037156285321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a99",
            "leftCorner": {
              "x": 2.929,
              "y": 30.225,
              "z": 1.059
            },
            "rightCorner": {
              "x": 3.019,
              "y": 30.22,
              "z": 1.059
            },
            "gtin": "5037156285352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a9a",
            "leftCorner": {
              "x": 3.02,
              "y": 30.236,
              "z": 1.059
            },
            "rightCorner": {
              "x": 3.113,
              "y": 30.232,
              "z": 1.059
            },
            "gtin": "5037156262346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a9b",
            "leftCorner": {
              "x": 3.113,
              "y": 30.231,
              "z": 1.059
            },
            "rightCorner": {
              "x": 3.197,
              "y": 30.226,
              "z": 1.059
            },
            "gtin": "5037156225495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20a46",
            "leftCorner": {
              "x": 3.197,
              "y": 30.225,
              "z": 1.059
            },
            "rightCorner": {
              "x": 3.303,
              "y": 30.219,
              "z": 1.059
            },
            "gtin": "5037156225488",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546683",
        "height": 1.5459,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20af8",
            "leftCorner": {
              "x": 2.142,
              "y": 30.268,
              "z": 1.265
            },
            "rightCorner": {
              "x": 2.225,
              "y": 30.264,
              "z": 1.265
            },
            "gtin": "3600523472628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20af9",
            "leftCorner": {
              "x": 2.224,
              "y": 30.259,
              "z": 1.265
            },
            "rightCorner": {
              "x": 2.287,
              "y": 30.256,
              "z": 1.265
            },
            "gtin": "5037156294255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20afa",
            "leftCorner": {
              "x": 2.287,
              "y": 30.253,
              "z": 1.265
            },
            "rightCorner": {
              "x": 2.355,
              "y": 30.25,
              "z": 1.265
            },
            "gtin": "5037156225440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20afb",
            "leftCorner": {
              "x": 2.355,
              "y": 30.251,
              "z": 1.265
            },
            "rightCorner": {
              "x": 2.426,
              "y": 30.248,
              "z": 1.265
            },
            "gtin": "5037156225457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20afc",
            "leftCorner": {
              "x": 2.426,
              "y": 30.265,
              "z": 1.265
            },
            "rightCorner": {
              "x": 2.493,
              "y": 30.261,
              "z": 1.265
            },
            "gtin": "5037156294262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20afd",
            "leftCorner": {
              "x": 2.493,
              "y": 30.261,
              "z": 1.265
            },
            "rightCorner": {
              "x": 2.559,
              "y": 30.257,
              "z": 1.265
            },
            "gtin": "5037156294262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20afe",
            "leftCorner": {
              "x": 2.558,
              "y": 30.245,
              "z": 1.265
            },
            "rightCorner": {
              "x": 2.628,
              "y": 30.241,
              "z": 1.265
            },
            "gtin": "5037156267907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aff",
            "leftCorner": {
              "x": 2.628,
              "y": 30.241,
              "z": 1.265
            },
            "rightCorner": {
              "x": 2.699,
              "y": 30.238,
              "z": 1.265
            },
            "gtin": "5037156267907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b00",
            "leftCorner": {
              "x": 2.699,
              "y": 30.24,
              "z": 1.265
            },
            "rightCorner": {
              "x": 2.77,
              "y": 30.236,
              "z": 1.265
            },
            "gtin": "5037156267914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b01",
            "leftCorner": {
              "x": 2.771,
              "y": 30.249,
              "z": 1.265
            },
            "rightCorner": {
              "x": 2.819,
              "y": 30.247,
              "z": 1.265
            },
            "gtin": "5037156225044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b02",
            "leftCorner": {
              "x": 2.819,
              "y": 30.238,
              "z": 1.265
            },
            "rightCorner": {
              "x": 2.88,
              "y": 30.235,
              "z": 1.265
            },
            "gtin": "5037156225051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b03",
            "leftCorner": {
              "x": 2.88,
              "y": 30.225,
              "z": 1.265
            },
            "rightCorner": {
              "x": 2.943,
              "y": 30.222,
              "z": 1.265
            },
            "gtin": "5037156225440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b04",
            "leftCorner": {
              "x": 2.943,
              "y": 30.225,
              "z": 1.265
            },
            "rightCorner": {
              "x": 3.029,
              "y": 30.22,
              "z": 1.265
            },
            "gtin": "5037156279450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b05",
            "leftCorner": {
              "x": 3.029,
              "y": 30.215,
              "z": 1.265
            },
            "rightCorner": {
              "x": 3.116,
              "y": 30.21,
              "z": 1.265
            },
            "gtin": "5037156254273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b06",
            "leftCorner": {
              "x": 3.117,
              "y": 30.225,
              "z": 1.265
            },
            "rightCorner": {
              "x": 3.178,
              "y": 30.223,
              "z": 1.265
            },
            "gtin": "5037156225518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aa0",
            "leftCorner": {
              "x": 3.178,
              "y": 30.227,
              "z": 1.265
            },
            "rightCorner": {
              "x": 3.241,
              "y": 30.223,
              "z": 1.265
            },
            "gtin": "4001638095587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20aa1",
            "leftCorner": {
              "x": 3.241,
              "y": 30.223,
              "z": 1.265
            },
            "rightCorner": {
              "x": 3.303,
              "y": 30.22,
              "z": 1.265
            },
            "gtin": "4001638095587",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d66"
  },
  {
    "id": "a6d6c",
    "name": "a6d6c",
    "x": -3.239,
    "y": 28.359,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99972,
      "w": 0.023542
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 79
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546697",
        "height": 0.17472,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c03",
            "leftCorner": {
              "x": -3.27,
              "y": 28.303,
              "z": 0.143
            },
            "rightCorner": {
              "x": -3.366,
              "y": 28.308,
              "z": 0.143
            },
            "gtin": "4063367428074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c04",
            "leftCorner": {
              "x": -3.366,
              "y": 28.308,
              "z": 0.143
            },
            "rightCorner": {
              "x": -3.462,
              "y": 28.313,
              "z": 0.143
            },
            "gtin": "4063367428074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c05",
            "leftCorner": {
              "x": -3.462,
              "y": 28.313,
              "z": 0.143
            },
            "rightCorner": {
              "x": -3.558,
              "y": 28.317,
              "z": 0.143
            },
            "gtin": "4063367428074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c06",
            "leftCorner": {
              "x": -3.558,
              "y": 28.317,
              "z": 0.143
            },
            "rightCorner": {
              "x": -3.654,
              "y": 28.321,
              "z": 0.143
            },
            "gtin": "4063367428074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c07",
            "leftCorner": {
              "x": -3.654,
              "y": 28.32,
              "z": 0.143
            },
            "rightCorner": {
              "x": -3.79,
              "y": 28.327,
              "z": 0.143
            },
            "gtin": "3600541944664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c08",
            "leftCorner": {
              "x": -3.79,
              "y": 28.336,
              "z": 0.143
            },
            "rightCorner": {
              "x": -3.842,
              "y": 28.339,
              "z": 0.143
            },
            "gtin": "3600541943506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c09",
            "leftCorner": {
              "x": -3.842,
              "y": 28.339,
              "z": 0.143
            },
            "rightCorner": {
              "x": -3.894,
              "y": 28.341,
              "z": 0.143
            },
            "gtin": "3600541943506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c0a",
            "leftCorner": {
              "x": -3.894,
              "y": 28.338,
              "z": 0.143
            },
            "rightCorner": {
              "x": -3.975,
              "y": 28.342,
              "z": 0.143
            },
            "gtin": "3600542383455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c0b",
            "leftCorner": {
              "x": -3.975,
              "y": 28.342,
              "z": 0.143
            },
            "rightCorner": {
              "x": -4.057,
              "y": 28.345,
              "z": 0.143
            },
            "gtin": "3600542383455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c0c",
            "leftCorner": {
              "x": -4.057,
              "y": 28.345,
              "z": 0.143
            },
            "rightCorner": {
              "x": -4.138,
              "y": 28.349,
              "z": 0.143
            },
            "gtin": "3600542383455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bfe",
            "leftCorner": {
              "x": -4.138,
              "y": 28.342,
              "z": 0.143
            },
            "rightCorner": {
              "x": -4.241,
              "y": 28.347,
              "z": 0.143
            },
            "gtin": "3600542461719",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546696",
        "height": 0.49689,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c29",
            "leftCorner": {
              "x": -3.245,
              "y": 28.24,
              "z": 0.407
            },
            "rightCorner": {
              "x": -3.356,
              "y": 28.245,
              "z": 0.407
            },
            "gtin": "083800042784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c2b",
            "leftCorner": {
              "x": -3.357,
              "y": 28.211,
              "z": 0.407
            },
            "rightCorner": {
              "x": -3.444,
              "y": 28.216,
              "z": 0.407
            },
            "gtin": "4008890008393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c2c",
            "leftCorner": {
              "x": -3.444,
              "y": 28.212,
              "z": 0.407
            },
            "rightCorner": {
              "x": -3.52,
              "y": 28.216,
              "z": 0.407
            },
            "gtin": "4008890008386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c2d",
            "leftCorner": {
              "x": -3.52,
              "y": 28.216,
              "z": 0.407
            },
            "rightCorner": {
              "x": -3.596,
              "y": 28.22,
              "z": 0.407
            },
            "gtin": "4008890008386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c2e",
            "leftCorner": {
              "x": -3.595,
              "y": 28.244,
              "z": 0.407
            },
            "rightCorner": {
              "x": -3.691,
              "y": 28.248,
              "z": 0.407
            },
            "gtin": "4003573124063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c2f",
            "leftCorner": {
              "x": -3.692,
              "y": 28.221,
              "z": 0.407
            },
            "rightCorner": {
              "x": -3.807,
              "y": 28.227,
              "z": 0.407
            },
            "gtin": "4051424582654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c30",
            "leftCorner": {
              "x": -3.807,
              "y": 28.225,
              "z": 0.407
            },
            "rightCorner": {
              "x": -3.88,
              "y": 28.229,
              "z": 0.407
            },
            "gtin": "4051424582647",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c31",
            "leftCorner": {
              "x": -3.879,
              "y": 28.243,
              "z": 0.407
            },
            "rightCorner": {
              "x": -3.963,
              "y": 28.247,
              "z": 0.407
            },
            "gtin": "4003583213993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c32",
            "leftCorner": {
              "x": -3.964,
              "y": 28.232,
              "z": 0.407
            },
            "rightCorner": {
              "x": -4.036,
              "y": 28.236,
              "z": 0.407
            },
            "gtin": "4021457638512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c33",
            "leftCorner": {
              "x": -4.037,
              "y": 28.233,
              "z": 0.407
            },
            "rightCorner": {
              "x": -4.134,
              "y": 28.237,
              "z": 0.407
            },
            "gtin": "4021457632022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c2a",
            "leftCorner": {
              "x": -4.133,
              "y": 28.247,
              "z": 0.407
            },
            "rightCorner": {
              "x": -4.245,
              "y": 28.253,
              "z": 0.407
            },
            "gtin": "4021457632053",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546698",
        "height": 0.79947,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c34",
            "leftCorner": {
              "x": -3.244,
              "y": 28.256,
              "z": 0.654
            },
            "rightCorner": {
              "x": -3.438,
              "y": 28.265,
              "z": 0.654
            },
            "gtin": "3600542380591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c35",
            "leftCorner": {
              "x": -3.44,
              "y": 28.228,
              "z": 0.654
            },
            "rightCorner": {
              "x": -3.541,
              "y": 28.233,
              "z": 0.654
            },
            "gtin": "4003573021850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c36",
            "leftCorner": {
              "x": -3.541,
              "y": 28.244,
              "z": 0.654
            },
            "rightCorner": {
              "x": -3.624,
              "y": 28.248,
              "z": 0.654
            },
            "gtin": "4003573020860",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c37",
            "leftCorner": {
              "x": -3.625,
              "y": 28.231,
              "z": 0.654
            },
            "rightCorner": {
              "x": -3.676,
              "y": 28.232,
              "z": 0.654
            },
            "gtin": "4003573020044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c38",
            "leftCorner": {
              "x": -3.676,
              "y": 28.232,
              "z": 0.654
            },
            "rightCorner": {
              "x": -3.727,
              "y": 28.235,
              "z": 0.654
            },
            "gtin": "4003573020044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c39",
            "leftCorner": {
              "x": -3.727,
              "y": 28.23,
              "z": 0.654
            },
            "rightCorner": {
              "x": -3.773,
              "y": 28.232,
              "z": 0.654
            },
            "gtin": "4003573020037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c3a",
            "leftCorner": {
              "x": -3.773,
              "y": 28.232,
              "z": 0.654
            },
            "rightCorner": {
              "x": -3.819,
              "y": 28.235,
              "z": 0.654
            },
            "gtin": "4003573020037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c3b",
            "leftCorner": {
              "x": -3.817,
              "y": 28.259,
              "z": 0.654
            },
            "rightCorner": {
              "x": -3.888,
              "y": 28.263,
              "z": 0.654
            },
            "gtin": "4003573121512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c3c",
            "leftCorner": {
              "x": -3.889,
              "y": 28.248,
              "z": 0.654
            },
            "rightCorner": {
              "x": -3.978,
              "y": 28.252,
              "z": 0.654
            },
            "gtin": "4003573020068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c3d",
            "leftCorner": {
              "x": -3.978,
              "y": 28.252,
              "z": 0.654
            },
            "rightCorner": {
              "x": -4.067,
              "y": 28.257,
              "z": 0.654
            },
            "gtin": "4003573020068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c3e",
            "leftCorner": {
              "x": -4.067,
              "y": 28.258,
              "z": 0.654
            },
            "rightCorner": {
              "x": -4.137,
              "y": 28.261,
              "z": 0.654
            },
            "gtin": "4003573022000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c3f",
            "leftCorner": {
              "x": -4.136,
              "y": 28.28,
              "z": 0.654
            },
            "rightCorner": {
              "x": -4.187,
              "y": 28.281,
              "z": 0.654
            },
            "gtin": "4003573022154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c40",
            "leftCorner": {
              "x": -4.187,
              "y": 28.281,
              "z": 0.654
            },
            "rightCorner": {
              "x": -4.238,
              "y": 28.284,
              "z": 0.654
            },
            "gtin": "4003573022154",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546699",
        "height": 1.0546,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20bc6",
            "leftCorner": {
              "x": -3.558,
              "y": 28.239,
              "z": 0.863
            },
            "rightCorner": {
              "x": -3.684,
              "y": 28.245,
              "z": 0.863
            },
            "gtin": "4003573021331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bc7",
            "leftCorner": {
              "x": -3.684,
              "y": 28.256,
              "z": 0.863
            },
            "rightCorner": {
              "x": -3.912,
              "y": 28.267,
              "z": 0.863
            },
            "gtin": "4003573021737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bc8",
            "leftCorner": {
              "x": -3.913,
              "y": 28.24,
              "z": 0.863
            },
            "rightCorner": {
              "x": -3.99,
              "y": 28.243,
              "z": 0.863
            },
            "gtin": "3600542387224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bc9",
            "leftCorner": {
              "x": -3.99,
              "y": 28.242,
              "z": 0.863
            },
            "rightCorner": {
              "x": -4.071,
              "y": 28.246,
              "z": 0.863
            },
            "gtin": "3600542387262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bba",
            "leftCorner": {
              "x": -4.07,
              "y": 28.264,
              "z": 0.863
            },
            "rightCorner": {
              "x": -4.157,
              "y": 28.268,
              "z": 0.863
            },
            "gtin": "3600542461764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bbb",
            "leftCorner": {
              "x": -4.157,
              "y": 28.268,
              "z": 0.863
            },
            "rightCorner": {
              "x": -4.244,
              "y": 28.272,
              "z": 0.863
            },
            "gtin": "3600542461764",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546693",
        "height": 1.3083,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20bd6",
            "leftCorner": {
              "x": -3.279,
              "y": 28.228,
              "z": 1.07
            },
            "rightCorner": {
              "x": -3.37,
              "y": 28.232,
              "z": 1.07
            },
            "gtin": "3600523704385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bd7",
            "leftCorner": {
              "x": -3.369,
              "y": 28.241,
              "z": 1.07
            },
            "rightCorner": {
              "x": -3.445,
              "y": 28.245,
              "z": 1.07
            },
            "gtin": "083800042821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bd8",
            "leftCorner": {
              "x": -3.445,
              "y": 28.24,
              "z": 1.07
            },
            "rightCorner": {
              "x": -3.493,
              "y": 28.242,
              "z": 1.07
            },
            "gtin": "083800042791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bd9",
            "leftCorner": {
              "x": -3.493,
              "y": 28.242,
              "z": 1.07
            },
            "rightCorner": {
              "x": -3.541,
              "y": 28.245,
              "z": 1.07
            },
            "gtin": "083800042791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bda",
            "leftCorner": {
              "x": -3.542,
              "y": 28.232,
              "z": 1.07
            },
            "rightCorner": {
              "x": -3.636,
              "y": 28.236,
              "z": 1.07
            },
            "gtin": "083800035892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bdb",
            "leftCorner": {
              "x": -3.636,
              "y": 28.244,
              "z": 1.07
            },
            "rightCorner": {
              "x": -3.724,
              "y": 28.249,
              "z": 1.07
            },
            "gtin": "083800066735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bdc",
            "leftCorner": {
              "x": -3.723,
              "y": 28.254,
              "z": 1.07
            },
            "rightCorner": {
              "x": -3.812,
              "y": 28.258,
              "z": 1.07
            },
            "gtin": "083800018291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bdd",
            "leftCorner": {
              "x": -3.812,
              "y": 28.257,
              "z": 1.07
            },
            "rightCorner": {
              "x": -3.902,
              "y": 28.261,
              "z": 1.07
            },
            "gtin": "083800066643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bde",
            "leftCorner": {
              "x": -3.902,
              "y": 28.252,
              "z": 1.07
            },
            "rightCorner": {
              "x": -3.981,
              "y": 28.257,
              "z": 1.07
            },
            "gtin": "083800061327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bdf",
            "leftCorner": {
              "x": -3.981,
              "y": 28.25,
              "z": 1.07
            },
            "rightCorner": {
              "x": -4.055,
              "y": 28.253,
              "z": 1.07
            },
            "gtin": "4005120412036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20be0",
            "leftCorner": {
              "x": -4.055,
              "y": 28.252,
              "z": 1.07
            },
            "rightCorner": {
              "x": -4.147,
              "y": 28.256,
              "z": 1.07
            },
            "gtin": "4005120151041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20be1",
            "leftCorner": {
              "x": -4.146,
              "y": 28.259,
              "z": 1.07
            },
            "rightCorner": {
              "x": -4.235,
              "y": 28.263,
              "z": 1.07
            },
            "gtin": "083800066735",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546694",
        "height": 1.5569,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20bf1",
            "leftCorner": {
              "x": -3.319,
              "y": 28.237,
              "z": 1.274
            },
            "rightCorner": {
              "x": -3.376,
              "y": 28.241,
              "z": 1.274
            },
            "gtin": "3574661671888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bf2",
            "leftCorner": {
              "x": -3.376,
              "y": 28.241,
              "z": 1.274
            },
            "rightCorner": {
              "x": -3.434,
              "y": 28.243,
              "z": 1.274
            },
            "gtin": "3574661671888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bf3",
            "leftCorner": {
              "x": -3.434,
              "y": 28.24,
              "z": 1.274
            },
            "rightCorner": {
              "x": -3.498,
              "y": 28.242,
              "z": 1.274
            },
            "gtin": "4006000002415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bf4",
            "leftCorner": {
              "x": -3.498,
              "y": 28.242,
              "z": 1.274
            },
            "rightCorner": {
              "x": -3.562,
              "y": 28.246,
              "z": 1.274
            },
            "gtin": "4006000002415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bf5",
            "leftCorner": {
              "x": -3.562,
              "y": 28.246,
              "z": 1.274
            },
            "rightCorner": {
              "x": -3.661,
              "y": 28.251,
              "z": 1.274
            },
            "gtin": "4006000002330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bf6",
            "leftCorner": {
              "x": -3.661,
              "y": 28.25,
              "z": 1.274
            },
            "rightCorner": {
              "x": -3.732,
              "y": 28.253,
              "z": 1.274
            },
            "gtin": "4006000002378",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bf7",
            "leftCorner": {
              "x": -3.732,
              "y": 28.253,
              "z": 1.274
            },
            "rightCorner": {
              "x": -3.788,
              "y": 28.255,
              "z": 1.274
            },
            "gtin": "4006000107585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bf8",
            "leftCorner": {
              "x": -3.788,
              "y": 28.255,
              "z": 1.274
            },
            "rightCorner": {
              "x": -3.844,
              "y": 28.258,
              "z": 1.274
            },
            "gtin": "4006000107585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bf9",
            "leftCorner": {
              "x": -3.844,
              "y": 28.25,
              "z": 1.274
            },
            "rightCorner": {
              "x": -3.96,
              "y": 28.256,
              "z": 1.274
            },
            "gtin": "4006000080925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bfa",
            "leftCorner": {
              "x": -3.96,
              "y": 28.258,
              "z": 1.274
            },
            "rightCorner": {
              "x": -4.019,
              "y": 28.261,
              "z": 1.274
            },
            "gtin": "4006000107622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bfb",
            "leftCorner": {
              "x": -4.019,
              "y": 28.263,
              "z": 1.274
            },
            "rightCorner": {
              "x": -4.087,
              "y": 28.267,
              "z": 1.274
            },
            "gtin": "4006000080888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bfc",
            "leftCorner": {
              "x": -4.088,
              "y": 28.253,
              "z": 1.274
            },
            "rightCorner": {
              "x": -4.164,
              "y": 28.256,
              "z": 1.274
            },
            "gtin": "4063367151897",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20be4",
            "leftCorner": {
              "x": -4.163,
              "y": 28.276,
              "z": 1.274
            },
            "rightCorner": {
              "x": -4.244,
              "y": 28.28,
              "z": 1.274
            },
            "gtin": "4063367151910",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546695",
        "height": 1.752,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c1d",
            "leftCorner": {
              "x": -3.362,
              "y": 28.253,
              "z": 1.433
            },
            "rightCorner": {
              "x": -3.473,
              "y": 28.258,
              "z": 1.433
            },
            "gtin": "4006000002255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c1e",
            "leftCorner": {
              "x": -3.474,
              "y": 28.235,
              "z": 1.433
            },
            "rightCorner": {
              "x": -3.54,
              "y": 28.238,
              "z": 1.433
            },
            "gtin": "4006000082646",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c1f",
            "leftCorner": {
              "x": -3.54,
              "y": 28.241,
              "z": 1.433
            },
            "rightCorner": {
              "x": -3.611,
              "y": 28.245,
              "z": 1.433
            },
            "gtin": "4006000079394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c20",
            "leftCorner": {
              "x": -3.611,
              "y": 28.237,
              "z": 1.433
            },
            "rightCorner": {
              "x": -3.685,
              "y": 28.241,
              "z": 1.433
            },
            "gtin": "3600523718207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c21",
            "leftCorner": {
              "x": -3.684,
              "y": 28.254,
              "z": 1.433
            },
            "rightCorner": {
              "x": -3.739,
              "y": 28.256,
              "z": 1.433
            },
            "gtin": "3600524070755",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c22",
            "leftCorner": {
              "x": -3.739,
              "y": 28.249,
              "z": 1.433
            },
            "rightCorner": {
              "x": -3.795,
              "y": 28.251,
              "z": 1.433
            },
            "gtin": "3600524071004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c23",
            "leftCorner": {
              "x": -3.795,
              "y": 28.252,
              "z": 1.433
            },
            "rightCorner": {
              "x": -3.846,
              "y": 28.255,
              "z": 1.433
            },
            "gtin": "3600524070793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c24",
            "leftCorner": {
              "x": -3.856,
              "y": 28.251,
              "z": 1.433
            },
            "rightCorner": {
              "x": -3.917,
              "y": 28.253,
              "z": 1.433
            },
            "gtin": "3610524074783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c25",
            "leftCorner": {
              "x": -3.918,
              "y": 28.251,
              "z": 1.433
            },
            "rightCorner": {
              "x": -3.972,
              "y": 28.253,
              "z": 1.433
            },
            "gtin": "3600524070762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c26",
            "leftCorner": {
              "x": -3.972,
              "y": 28.253,
              "z": 1.433
            },
            "rightCorner": {
              "x": -4.026,
              "y": 28.256,
              "z": 1.433
            },
            "gtin": "3600524070762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c27",
            "leftCorner": {
              "x": -4.026,
              "y": 28.261,
              "z": 1.433
            },
            "rightCorner": {
              "x": -4.093,
              "y": 28.264,
              "z": 1.433
            },
            "gtin": "3600524071011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c28",
            "leftCorner": {
              "x": -4.092,
              "y": 28.274,
              "z": 1.433
            },
            "rightCorner": {
              "x": -4.153,
              "y": 28.277,
              "z": 1.433
            },
            "gtin": "3600524070786",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c0e",
            "leftCorner": {
              "x": -4.154,
              "y": 28.269,
              "z": 1.433
            },
            "rightCorner": {
              "x": -4.244,
              "y": 28.273,
              "z": 1.433
            },
            "gtin": "3600523950102",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d13cf",
    "rightNeighborShelfId": "34a48"
  },
  {
    "id": "a6d6d",
    "name": "a6d6d",
    "x": -4.731,
    "y": 28.429,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99968,
      "w": 0.025148
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 110
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5465ba",
        "height": 1.76,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1fff2",
            "leftCorner": {
              "x": -5.307,
              "y": 28.341,
              "z": 1.44
            },
            "rightCorner": {
              "x": -5.343,
              "y": 28.343,
              "z": 1.44
            },
            "gtin": "4021457649174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fff3",
            "leftCorner": {
              "x": -5.343,
              "y": 28.343,
              "z": 1.44
            },
            "rightCorner": {
              "x": -5.379,
              "y": 28.344,
              "z": 1.44
            },
            "gtin": "4021457649174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fff4",
            "leftCorner": {
              "x": -5.38,
              "y": 28.337,
              "z": 1.44
            },
            "rightCorner": {
              "x": -5.463,
              "y": 28.341,
              "z": 1.44
            },
            "gtin": "4021457650064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fff5",
            "leftCorner": {
              "x": -5.463,
              "y": 28.35,
              "z": 1.44
            },
            "rightCorner": {
              "x": -5.549,
              "y": 28.355,
              "z": 1.44
            },
            "gtin": "4021457649853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fff6",
            "leftCorner": {
              "x": -5.549,
              "y": 28.354,
              "z": 1.44
            },
            "rightCorner": {
              "x": -5.621,
              "y": 28.358,
              "z": 1.44
            },
            "gtin": "4021457638369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fff7",
            "leftCorner": {
              "x": -5.621,
              "y": 28.358,
              "z": 1.44
            },
            "rightCorner": {
              "x": -5.693,
              "y": 28.361,
              "z": 1.44
            },
            "gtin": "4021457638369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fff8",
            "leftCorner": {
              "x": -5.693,
              "y": 28.361,
              "z": 1.44
            },
            "rightCorner": {
              "x": -5.764,
              "y": 28.365,
              "z": 1.44
            },
            "gtin": "4021457638369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fff9",
            "leftCorner": {
              "x": -5.765,
              "y": 28.349,
              "z": 1.44
            },
            "rightCorner": {
              "x": -5.85,
              "y": 28.353,
              "z": 1.44
            },
            "gtin": "4021457653522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fffa",
            "leftCorner": {
              "x": -5.85,
              "y": 28.369,
              "z": 1.44
            },
            "rightCorner": {
              "x": -5.947,
              "y": 28.373,
              "z": 1.44
            },
            "gtin": "4021457653508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fffb",
            "leftCorner": {
              "x": -5.948,
              "y": 28.351,
              "z": 1.44
            },
            "rightCorner": {
              "x": -5.98,
              "y": 28.353,
              "z": 1.44
            },
            "gtin": "4021457653515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffec",
            "leftCorner": {
              "x": -4.761,
              "y": 28.305,
              "z": 1.44
            },
            "rightCorner": {
              "x": -4.835,
              "y": 28.309,
              "z": 1.44
            },
            "gtin": "4021457638338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffed",
            "leftCorner": {
              "x": -4.835,
              "y": 28.305,
              "z": 1.44
            },
            "rightCorner": {
              "x": -4.947,
              "y": 28.31,
              "z": 1.44
            },
            "gtin": "4021457652471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffee",
            "leftCorner": {
              "x": -4.947,
              "y": 28.302,
              "z": 1.44
            },
            "rightCorner": {
              "x": -5.048,
              "y": 28.307,
              "z": 1.44
            },
            "gtin": "4021457649266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffef",
            "leftCorner": {
              "x": -5.048,
              "y": 28.307,
              "z": 1.44
            },
            "rightCorner": {
              "x": -5.119,
              "y": 28.311,
              "z": 1.44
            },
            "gtin": "4021457649235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fff0",
            "leftCorner": {
              "x": -5.118,
              "y": 28.326,
              "z": 1.44
            },
            "rightCorner": {
              "x": -5.217,
              "y": 28.332,
              "z": 1.44
            },
            "gtin": "4021457649204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fff1",
            "leftCorner": {
              "x": -5.218,
              "y": 28.319,
              "z": 1.44
            },
            "rightCorner": {
              "x": -5.308,
              "y": 28.323,
              "z": 1.44
            },
            "gtin": "4021457639526",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465be",
        "height": 0.16987,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2013c",
            "leftCorner": {
              "x": -4.732,
              "y": 28.417,
              "z": 0.139
            },
            "rightCorner": {
              "x": -4.82,
              "y": 28.422,
              "z": 0.139
            },
            "gtin": "4063367255809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2013e",
            "leftCorner": {
              "x": -4.822,
              "y": 28.381,
              "z": 0.139
            },
            "rightCorner": {
              "x": -4.936,
              "y": 28.387,
              "z": 0.139
            },
            "gtin": "4008890007822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2013f",
            "leftCorner": {
              "x": -4.936,
              "y": 28.384,
              "z": 0.139
            },
            "rightCorner": {
              "x": -5.009,
              "y": 28.387,
              "z": 0.139
            },
            "gtin": "4063367148736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20140",
            "leftCorner": {
              "x": -5.009,
              "y": 28.387,
              "z": 0.139
            },
            "rightCorner": {
              "x": -5.082,
              "y": 28.391,
              "z": 0.139
            },
            "gtin": "4063367148736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20141",
            "leftCorner": {
              "x": -5.082,
              "y": 28.391,
              "z": 0.139
            },
            "rightCorner": {
              "x": -5.156,
              "y": 28.394,
              "z": 0.139
            },
            "gtin": "4063367148736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20142",
            "leftCorner": {
              "x": -5.156,
              "y": 28.393,
              "z": 0.139
            },
            "rightCorner": {
              "x": -5.277,
              "y": 28.399,
              "z": 0.139
            },
            "gtin": "4063367255465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20143",
            "leftCorner": {
              "x": -5.277,
              "y": 28.404,
              "z": 0.139
            },
            "rightCorner": {
              "x": -5.362,
              "y": 28.408,
              "z": 0.139
            },
            "gtin": "4063367255786",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20144",
            "leftCorner": {
              "x": -5.362,
              "y": 28.408,
              "z": 0.139
            },
            "rightCorner": {
              "x": -5.448,
              "y": 28.412,
              "z": 0.139
            },
            "gtin": "4063367255786",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20145",
            "leftCorner": {
              "x": -5.448,
              "y": 28.412,
              "z": 0.139
            },
            "rightCorner": {
              "x": -5.534,
              "y": 28.417,
              "z": 0.139
            },
            "gtin": "4063367255786",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20146",
            "leftCorner": {
              "x": -5.534,
              "y": 28.421,
              "z": 0.139
            },
            "rightCorner": {
              "x": -5.593,
              "y": 28.425,
              "z": 0.139
            },
            "gtin": "4063367254819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20147",
            "leftCorner": {
              "x": -5.593,
              "y": 28.425,
              "z": 0.139
            },
            "rightCorner": {
              "x": -5.651,
              "y": 28.427,
              "z": 0.139
            },
            "gtin": "4063367254819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20148",
            "leftCorner": {
              "x": -5.651,
              "y": 28.427,
              "z": 0.139
            },
            "rightCorner": {
              "x": -5.747,
              "y": 28.432,
              "z": 0.139
            },
            "gtin": "4063367393907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20149",
            "leftCorner": {
              "x": -5.746,
              "y": 28.453,
              "z": 0.139
            },
            "rightCorner": {
              "x": -5.855,
              "y": 28.458,
              "z": 0.139
            },
            "gtin": "4063367254840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2014a",
            "leftCorner": {
              "x": -5.855,
              "y": 28.44,
              "z": 0.139
            },
            "rightCorner": {
              "x": -5.919,
              "y": 28.443,
              "z": 0.139
            },
            "gtin": "4063367266270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2014b",
            "leftCorner": {
              "x": -5.918,
              "y": 28.457,
              "z": 0.139
            },
            "rightCorner": {
              "x": -5.987,
              "y": 28.46,
              "z": 0.139
            },
            "gtin": "4046104000368",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465bb",
        "height": 0.50365,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2004e",
            "leftCorner": {
              "x": -4.77,
              "y": 28.275,
              "z": 0.412
            },
            "rightCorner": {
              "x": -4.852,
              "y": 28.28,
              "z": 0.412
            },
            "gtin": "4003583214167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2004f",
            "leftCorner": {
              "x": -4.852,
              "y": 28.284,
              "z": 0.412
            },
            "rightCorner": {
              "x": -4.915,
              "y": 28.286,
              "z": 0.412
            },
            "gtin": "3574661690483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20050",
            "leftCorner": {
              "x": -4.915,
              "y": 28.284,
              "z": 0.412
            },
            "rightCorner": {
              "x": -5.006,
              "y": 28.289,
              "z": 0.412
            },
            "gtin": "3574661690490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20051",
            "leftCorner": {
              "x": -5.006,
              "y": 28.288,
              "z": 0.412
            },
            "rightCorner": {
              "x": -5.128,
              "y": 28.294,
              "z": 0.412
            },
            "gtin": "3574661690513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20052",
            "leftCorner": {
              "x": -5.128,
              "y": 28.29,
              "z": 0.412
            },
            "rightCorner": {
              "x": -5.202,
              "y": 28.293,
              "z": 0.412
            },
            "gtin": "3574661690506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20053",
            "leftCorner": {
              "x": -5.202,
              "y": 28.293,
              "z": 0.412
            },
            "rightCorner": {
              "x": -5.276,
              "y": 28.297,
              "z": 0.412
            },
            "gtin": "3574661690506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20054",
            "leftCorner": {
              "x": -5.275,
              "y": 28.305,
              "z": 0.412
            },
            "rightCorner": {
              "x": -5.397,
              "y": 28.311,
              "z": 0.412
            },
            "gtin": "3574661690520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20055",
            "leftCorner": {
              "x": -5.397,
              "y": 28.313,
              "z": 0.412
            },
            "rightCorner": {
              "x": -5.515,
              "y": 28.319,
              "z": 0.412
            },
            "gtin": "3574661690544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20056",
            "leftCorner": {
              "x": -5.516,
              "y": 28.316,
              "z": 0.412
            },
            "rightCorner": {
              "x": -5.612,
              "y": 28.321,
              "z": 0.412
            },
            "gtin": "3574661690537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20057",
            "leftCorner": {
              "x": -5.612,
              "y": 28.321,
              "z": 0.412
            },
            "rightCorner": {
              "x": -5.708,
              "y": 28.326,
              "z": 0.412
            },
            "gtin": "3574661690537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20058",
            "leftCorner": {
              "x": -5.708,
              "y": 28.326,
              "z": 0.412
            },
            "rightCorner": {
              "x": -5.805,
              "y": 28.331,
              "z": 0.412
            },
            "gtin": "3574661690537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20059",
            "leftCorner": {
              "x": -5.805,
              "y": 28.325,
              "z": 0.412
            },
            "rightCorner": {
              "x": -5.866,
              "y": 28.328,
              "z": 0.412
            },
            "gtin": "4002448044116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2005a",
            "leftCorner": {
              "x": -5.866,
              "y": 28.33,
              "z": 0.412
            },
            "rightCorner": {
              "x": -5.957,
              "y": 28.336,
              "z": 0.412
            },
            "gtin": "4002448044185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2005b",
            "leftCorner": {
              "x": -5.957,
              "y": 28.335,
              "z": 0.412
            },
            "rightCorner": {
              "x": -5.99,
              "y": 28.336,
              "z": 0.412
            },
            "gtin": "4002448068112",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465b8",
        "height": 0.80283,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1ff4b",
            "leftCorner": {
              "x": -4.736,
              "y": 28.328,
              "z": 0.657
            },
            "rightCorner": {
              "x": -4.78,
              "y": 28.33,
              "z": 0.657
            },
            "gtin": "4260199892503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff4d",
            "leftCorner": {
              "x": -4.782,
              "y": 28.288,
              "z": 0.657
            },
            "rightCorner": {
              "x": -4.844,
              "y": 28.291,
              "z": 0.657
            },
            "gtin": "3574661320700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff4e",
            "leftCorner": {
              "x": -4.843,
              "y": 28.301,
              "z": 0.657
            },
            "rightCorner": {
              "x": -4.945,
              "y": 28.306,
              "z": 0.657
            },
            "gtin": "3574661554297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff4f",
            "leftCorner": {
              "x": -4.944,
              "y": 28.309,
              "z": 0.657
            },
            "rightCorner": {
              "x": -5.026,
              "y": 28.313,
              "z": 0.657
            },
            "gtin": "3574661554280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff50",
            "leftCorner": {
              "x": -5.026,
              "y": 28.302,
              "z": 0.657
            },
            "rightCorner": {
              "x": -5.061,
              "y": 28.304,
              "z": 0.657
            },
            "gtin": "3574661554709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff51",
            "leftCorner": {
              "x": -5.061,
              "y": 28.304,
              "z": 0.657
            },
            "rightCorner": {
              "x": -5.097,
              "y": 28.306,
              "z": 0.657
            },
            "gtin": "3574661554709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff52",
            "leftCorner": {
              "x": -5.096,
              "y": 28.316,
              "z": 0.657
            },
            "rightCorner": {
              "x": -5.183,
              "y": 28.32,
              "z": 0.657
            },
            "gtin": "3574661751627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff53",
            "leftCorner": {
              "x": -5.183,
              "y": 28.307,
              "z": 0.657
            },
            "rightCorner": {
              "x": -5.248,
              "y": 28.31,
              "z": 0.657
            },
            "gtin": "3574661333625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff54",
            "leftCorner": {
              "x": -5.248,
              "y": 28.311,
              "z": 0.657
            },
            "rightCorner": {
              "x": -5.324,
              "y": 28.315,
              "z": 0.657
            },
            "gtin": "3574661332536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff55",
            "leftCorner": {
              "x": -5.324,
              "y": 28.316,
              "z": 0.657
            },
            "rightCorner": {
              "x": -5.399,
              "y": 28.319,
              "z": 0.657
            },
            "gtin": "3574661332574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff56",
            "leftCorner": {
              "x": -5.399,
              "y": 28.319,
              "z": 0.657
            },
            "rightCorner": {
              "x": -5.48,
              "y": 28.323,
              "z": 0.657
            },
            "gtin": "3574661336640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff57",
            "leftCorner": {
              "x": -5.479,
              "y": 28.34,
              "z": 0.657
            },
            "rightCorner": {
              "x": -5.576,
              "y": 28.346,
              "z": 0.657
            },
            "gtin": "3574661332628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff58",
            "leftCorner": {
              "x": -5.576,
              "y": 28.34,
              "z": 0.657
            },
            "rightCorner": {
              "x": -5.659,
              "y": 28.344,
              "z": 0.657
            },
            "gtin": "4051424600006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff59",
            "leftCorner": {
              "x": -5.659,
              "y": 28.326,
              "z": 0.657
            },
            "rightCorner": {
              "x": -5.787,
              "y": 28.332,
              "z": 0.657
            },
            "gtin": "4051424600099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff5a",
            "leftCorner": {
              "x": -5.786,
              "y": 28.343,
              "z": 0.657
            },
            "rightCorner": {
              "x": -5.912,
              "y": 28.349,
              "z": 0.657
            },
            "gtin": "4051424600082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff5b",
            "leftCorner": {
              "x": -5.912,
              "y": 28.34,
              "z": 0.657
            },
            "rightCorner": {
              "x": -5.979,
              "y": 28.343,
              "z": 0.657
            },
            "gtin": "4051424600044",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465b9",
        "height": 1.0533,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1ffb8",
            "leftCorner": {
              "x": -4.736,
              "y": 28.331,
              "z": 0.862
            },
            "rightCorner": {
              "x": -4.789,
              "y": 28.334,
              "z": 0.862
            },
            "gtin": "4260199890691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffba",
            "leftCorner": {
              "x": -4.791,
              "y": 28.297,
              "z": 0.862
            },
            "rightCorner": {
              "x": -4.883,
              "y": 28.301,
              "z": 0.862
            },
            "gtin": "4025089084617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffbb",
            "leftCorner": {
              "x": -4.884,
              "y": 28.293,
              "z": 0.862
            },
            "rightCorner": {
              "x": -4.972,
              "y": 28.297,
              "z": 0.862
            },
            "gtin": "4025089084662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffbc",
            "leftCorner": {
              "x": -4.971,
              "y": 28.309,
              "z": 0.862
            },
            "rightCorner": {
              "x": -5.06,
              "y": 28.313,
              "z": 0.862
            },
            "gtin": "4025089084556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffbd",
            "leftCorner": {
              "x": -5.06,
              "y": 28.301,
              "z": 0.862
            },
            "rightCorner": {
              "x": -5.123,
              "y": 28.305,
              "z": 0.862
            },
            "gtin": "4025089084631",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffbe",
            "leftCorner": {
              "x": -5.122,
              "y": 28.315,
              "z": 0.862
            },
            "rightCorner": {
              "x": -5.177,
              "y": 28.318,
              "z": 0.862
            },
            "gtin": "4025089084570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffbf",
            "leftCorner": {
              "x": -5.177,
              "y": 28.317,
              "z": 0.862
            },
            "rightCorner": {
              "x": -5.234,
              "y": 28.32,
              "z": 0.862
            },
            "gtin": "4025089084686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffc0",
            "leftCorner": {
              "x": -5.233,
              "y": 28.326,
              "z": 0.862
            },
            "rightCorner": {
              "x": -5.299,
              "y": 28.329,
              "z": 0.862
            },
            "gtin": "4055297219426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffc1",
            "leftCorner": {
              "x": -5.299,
              "y": 28.328,
              "z": 0.862
            },
            "rightCorner": {
              "x": -5.352,
              "y": 28.33,
              "z": 0.862
            },
            "gtin": "4055297218030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffc2",
            "leftCorner": {
              "x": -5.352,
              "y": 28.33,
              "z": 0.862
            },
            "rightCorner": {
              "x": -5.405,
              "y": 28.333,
              "z": 0.862
            },
            "gtin": "4055297218030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffc3",
            "leftCorner": {
              "x": -5.405,
              "y": 28.326,
              "z": 0.862
            },
            "rightCorner": {
              "x": -5.542,
              "y": 28.332,
              "z": 0.862
            },
            "gtin": "4055297219723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffc4",
            "leftCorner": {
              "x": -5.543,
              "y": 28.326,
              "z": 0.862
            },
            "rightCorner": {
              "x": -5.612,
              "y": 28.329,
              "z": 0.862
            },
            "gtin": "4055297217859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffc5",
            "leftCorner": {
              "x": -5.612,
              "y": 28.336,
              "z": 0.862
            },
            "rightCorner": {
              "x": -5.676,
              "y": 28.339,
              "z": 0.862
            },
            "gtin": "4055297219365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffc6",
            "leftCorner": {
              "x": -5.676,
              "y": 28.33,
              "z": 0.862
            },
            "rightCorner": {
              "x": -5.786,
              "y": 28.337,
              "z": 0.862
            },
            "gtin": "3600542562485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffc7",
            "leftCorner": {
              "x": -5.786,
              "y": 28.349,
              "z": 0.862
            },
            "rightCorner": {
              "x": -5.913,
              "y": 28.356,
              "z": 0.862
            },
            "gtin": "3600542442893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffc8",
            "leftCorner": {
              "x": -5.914,
              "y": 28.339,
              "z": 0.862
            },
            "rightCorner": {
              "x": -6.01,
              "y": 28.344,
              "z": 0.862
            },
            "gtin": "3600542326254",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465bd",
        "height": 1.3091,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20119",
            "leftCorner": {
              "x": -4.735,
              "y": 28.343,
              "z": 1.071
            },
            "rightCorner": {
              "x": -4.815,
              "y": 28.347,
              "z": 1.071
            },
            "gtin": "4001638590082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2011a",
            "leftCorner": {
              "x": -4.815,
              "y": 28.347,
              "z": 1.071
            },
            "rightCorner": {
              "x": -4.894,
              "y": 28.351,
              "z": 1.071
            },
            "gtin": "4001638590082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2011b",
            "leftCorner": {
              "x": -4.894,
              "y": 28.351,
              "z": 1.071
            },
            "rightCorner": {
              "x": -4.973,
              "y": 28.354,
              "z": 1.071
            },
            "gtin": "4001638590082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2011d",
            "leftCorner": {
              "x": -4.974,
              "y": 28.329,
              "z": 1.071
            },
            "rightCorner": {
              "x": -5.046,
              "y": 28.334,
              "z": 1.071
            },
            "gtin": "4001638590075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2011e",
            "leftCorner": {
              "x": -5.046,
              "y": 28.334,
              "z": 1.071
            },
            "rightCorner": {
              "x": -5.118,
              "y": 28.337,
              "z": 1.071
            },
            "gtin": "4001638590075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2011f",
            "leftCorner": {
              "x": -5.118,
              "y": 28.331,
              "z": 1.071
            },
            "rightCorner": {
              "x": -5.182,
              "y": 28.334,
              "z": 1.071
            },
            "gtin": "4001638095723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20120",
            "leftCorner": {
              "x": -5.182,
              "y": 28.334,
              "z": 1.071
            },
            "rightCorner": {
              "x": -5.246,
              "y": 28.338,
              "z": 1.071
            },
            "gtin": "4001638095723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20121",
            "leftCorner": {
              "x": -5.246,
              "y": 28.338,
              "z": 1.071
            },
            "rightCorner": {
              "x": -5.31,
              "y": 28.341,
              "z": 1.071
            },
            "gtin": "4001638095723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20122",
            "leftCorner": {
              "x": -5.31,
              "y": 28.341,
              "z": 1.071
            },
            "rightCorner": {
              "x": -5.374,
              "y": 28.344,
              "z": 1.071
            },
            "gtin": "4001638095723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20123",
            "leftCorner": {
              "x": -5.374,
              "y": 28.34,
              "z": 1.071
            },
            "rightCorner": {
              "x": -5.475,
              "y": 28.345,
              "z": 1.071
            },
            "gtin": "4001638590099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20124",
            "leftCorner": {
              "x": -5.475,
              "y": 28.335,
              "z": 1.071
            },
            "rightCorner": {
              "x": -5.554,
              "y": 28.339,
              "z": 1.071
            },
            "gtin": "4051424570033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20125",
            "leftCorner": {
              "x": -5.554,
              "y": 28.345,
              "z": 1.071
            },
            "rightCorner": {
              "x": -5.652,
              "y": 28.349,
              "z": 1.071
            },
            "gtin": "4051424570040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20126",
            "leftCorner": {
              "x": -5.653,
              "y": 28.334,
              "z": 1.071
            },
            "rightCorner": {
              "x": -5.739,
              "y": 28.338,
              "z": 1.071
            },
            "gtin": "4051424570002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20127",
            "leftCorner": {
              "x": -5.739,
              "y": 28.336,
              "z": 1.071
            },
            "rightCorner": {
              "x": -5.873,
              "y": 28.344,
              "z": 1.071
            },
            "gtin": "4051424570019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20128",
            "leftCorner": {
              "x": -5.873,
              "y": 28.345,
              "z": 1.071
            },
            "rightCorner": {
              "x": -5.942,
              "y": 28.348,
              "z": 1.071
            },
            "gtin": "4051424570125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20129",
            "leftCorner": {
              "x": -5.941,
              "y": 28.36,
              "z": 1.071
            },
            "rightCorner": {
              "x": -5.982,
              "y": 28.362,
              "z": 1.071
            },
            "gtin": "4021457649945",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465bc",
        "height": 1.5588,
        "facings": [
          {
            "id": "68300c895ed67a01d9a200b7",
            "leftCorner": {
              "x": -4.735,
              "y": 28.342,
              "z": 1.275
            },
            "rightCorner": {
              "x": -4.776,
              "y": 28.344,
              "z": 1.275
            }
          },
          {
            "id": "68300c895ed67a01d9a200ba",
            "leftCorner": {
              "x": -4.777,
              "y": 28.319,
              "z": 1.275
            },
            "rightCorner": {
              "x": -4.891,
              "y": 28.324,
              "z": 1.275
            },
            "gtin": "4001638590129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200bb",
            "leftCorner": {
              "x": -4.892,
              "y": 28.307,
              "z": 1.275
            },
            "rightCorner": {
              "x": -4.969,
              "y": 28.311,
              "z": 1.275
            },
            "gtin": "4001638080088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200bc",
            "leftCorner": {
              "x": -4.969,
              "y": 28.318,
              "z": 1.275
            },
            "rightCorner": {
              "x": -5.053,
              "y": 28.322,
              "z": 1.275
            },
            "gtin": "4001638089654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200bd",
            "leftCorner": {
              "x": -5.053,
              "y": 28.317,
              "z": 1.275
            },
            "rightCorner": {
              "x": -5.149,
              "y": 28.323,
              "z": 1.275
            },
            "gtin": "4001638086011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200be",
            "leftCorner": {
              "x": -5.149,
              "y": 28.319,
              "z": 1.275
            },
            "rightCorner": {
              "x": -5.233,
              "y": 28.323,
              "z": 1.275
            },
            "gtin": "4001638590105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200bf",
            "leftCorner": {
              "x": -5.233,
              "y": 28.327,
              "z": 1.275
            },
            "rightCorner": {
              "x": -5.314,
              "y": 28.33,
              "z": 1.275
            },
            "gtin": "4001638590112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200c0",
            "leftCorner": {
              "x": -5.314,
              "y": 28.331,
              "z": 1.275
            },
            "rightCorner": {
              "x": -5.403,
              "y": 28.336,
              "z": 1.275
            },
            "gtin": "4021457650859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200c1",
            "leftCorner": {
              "x": -5.403,
              "y": 28.336,
              "z": 1.275
            },
            "rightCorner": {
              "x": -5.491,
              "y": 28.341,
              "z": 1.275
            },
            "gtin": "4021457650859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200c2",
            "leftCorner": {
              "x": -5.491,
              "y": 28.346,
              "z": 1.275
            },
            "rightCorner": {
              "x": -5.585,
              "y": 28.35,
              "z": 1.275
            },
            "gtin": "4021457639588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200c3",
            "leftCorner": {
              "x": -5.585,
              "y": 28.342,
              "z": 1.275
            },
            "rightCorner": {
              "x": -5.656,
              "y": 28.346,
              "z": 1.275
            },
            "gtin": "4021457650033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200c4",
            "leftCorner": {
              "x": -5.656,
              "y": 28.352,
              "z": 1.275
            },
            "rightCorner": {
              "x": -5.693,
              "y": 28.353,
              "z": 1.275
            },
            "gtin": "4021457649914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200c5",
            "leftCorner": {
              "x": -5.693,
              "y": 28.353,
              "z": 1.275
            },
            "rightCorner": {
              "x": -5.729,
              "y": 28.355,
              "z": 1.275
            },
            "gtin": "4021457649914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200c6",
            "leftCorner": {
              "x": -5.729,
              "y": 28.35,
              "z": 1.275
            },
            "rightCorner": {
              "x": -5.773,
              "y": 28.353,
              "z": 1.275
            },
            "gtin": "4021457650095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200c7",
            "leftCorner": {
              "x": -5.773,
              "y": 28.353,
              "z": 1.275
            },
            "rightCorner": {
              "x": -5.817,
              "y": 28.355,
              "z": 1.275
            },
            "gtin": "4021457650095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200c8",
            "leftCorner": {
              "x": -5.817,
              "y": 28.355,
              "z": 1.275
            },
            "rightCorner": {
              "x": -5.861,
              "y": 28.357,
              "z": 1.275
            },
            "gtin": "4021457650095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200c9",
            "leftCorner": {
              "x": -5.861,
              "y": 28.345,
              "z": 1.275
            },
            "rightCorner": {
              "x": -5.922,
              "y": 28.348,
              "z": 1.275
            },
            "gtin": "4021457653492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200ca",
            "leftCorner": {
              "x": -5.922,
              "y": 28.348,
              "z": 1.275
            },
            "rightCorner": {
              "x": -5.982,
              "y": 28.352,
              "z": 1.275
            },
            "gtin": "4021457653492",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "34a48",
    "rightNeighborShelfId": "a6d6e"
  },
  {
    "id": "a6d6e",
    "name": "a6d6e",
    "x": -5.979,
    "y": 28.492,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99968,
      "w": 0.025148
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 112
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546625",
        "height": 0.17079,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2014c",
            "leftCorner": {
              "x": -5.987,
              "y": 28.449,
              "z": 0.14
            },
            "rightCorner": {
              "x": -6.076,
              "y": 28.454,
              "z": 0.14
            },
            "gtin": "4103040019899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2014d",
            "leftCorner": {
              "x": -6.076,
              "y": 28.454,
              "z": 0.14
            },
            "rightCorner": {
              "x": -6.166,
              "y": 28.459,
              "z": 0.14
            },
            "gtin": "4103040019899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2014e",
            "leftCorner": {
              "x": -6.166,
              "y": 28.459,
              "z": 0.14
            },
            "rightCorner": {
              "x": -6.256,
              "y": 28.463,
              "z": 0.14
            },
            "gtin": "4103040019899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2014f",
            "leftCorner": {
              "x": -6.256,
              "y": 28.463,
              "z": 0.14
            },
            "rightCorner": {
              "x": -6.345,
              "y": 28.467,
              "z": 0.14
            },
            "gtin": "4103040019899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20150",
            "leftCorner": {
              "x": -6.345,
              "y": 28.467,
              "z": 0.14
            },
            "rightCorner": {
              "x": -6.435,
              "y": 28.472,
              "z": 0.14
            },
            "gtin": "4103040019899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20151",
            "leftCorner": {
              "x": -6.435,
              "y": 28.473,
              "z": 0.14
            },
            "rightCorner": {
              "x": -6.541,
              "y": 28.478,
              "z": 0.14
            },
            "gtin": "4103040019752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20152",
            "leftCorner": {
              "x": -6.541,
              "y": 28.478,
              "z": 0.14
            },
            "rightCorner": {
              "x": -6.646,
              "y": 28.483,
              "z": 0.14
            },
            "gtin": "4103040019752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20153",
            "leftCorner": {
              "x": -6.647,
              "y": 28.473,
              "z": 0.14
            },
            "rightCorner": {
              "x": -6.824,
              "y": 28.482,
              "z": 0.14
            },
            "gtin": "4063367151491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20154",
            "leftCorner": {
              "x": -6.824,
              "y": 28.482,
              "z": 0.14
            },
            "rightCorner": {
              "x": -7.001,
              "y": 28.491,
              "z": 0.14
            },
            "gtin": "4063367151491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2013d",
            "leftCorner": {
              "x": -7.001,
              "y": 28.488,
              "z": 0.14
            },
            "rightCorner": {
              "x": -7.23,
              "y": 28.499,
              "z": 0.14
            },
            "gtin": "4011609012093",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546620",
        "height": 0.5077,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2005c",
            "leftCorner": {
              "x": -5.988,
              "y": 28.366,
              "z": 0.415
            },
            "rightCorner": {
              "x": -6.076,
              "y": 28.371,
              "z": 0.415
            },
            "gtin": "3600542449595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2005d",
            "leftCorner": {
              "x": -6.076,
              "y": 28.371,
              "z": 0.415
            },
            "rightCorner": {
              "x": -6.164,
              "y": 28.376,
              "z": 0.415
            },
            "gtin": "3600542449595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2005e",
            "leftCorner": {
              "x": -6.165,
              "y": 28.366,
              "z": 0.415
            },
            "rightCorner": {
              "x": -6.241,
              "y": 28.37,
              "z": 0.415
            },
            "gtin": "3600542514118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2005f",
            "leftCorner": {
              "x": -6.241,
              "y": 28.373,
              "z": 0.415
            },
            "rightCorner": {
              "x": -6.316,
              "y": 28.377,
              "z": 0.415
            },
            "gtin": "3600542648615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20060",
            "leftCorner": {
              "x": -6.316,
              "y": 28.37,
              "z": 0.415
            },
            "rightCorner": {
              "x": -6.38,
              "y": 28.372,
              "z": 0.415
            },
            "gtin": "3600542453103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20061",
            "leftCorner": {
              "x": -6.379,
              "y": 28.389,
              "z": 0.415
            },
            "rightCorner": {
              "x": -6.461,
              "y": 28.393,
              "z": 0.415
            },
            "gtin": "3600541163645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20062",
            "leftCorner": {
              "x": -6.461,
              "y": 28.379,
              "z": 0.415
            },
            "rightCorner": {
              "x": -6.53,
              "y": 28.382,
              "z": 0.415
            },
            "gtin": "3600541163638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20063",
            "leftCorner": {
              "x": -6.53,
              "y": 28.382,
              "z": 0.415
            },
            "rightCorner": {
              "x": -6.598,
              "y": 28.386,
              "z": 0.415
            },
            "gtin": "3600541163638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20064",
            "leftCorner": {
              "x": -6.598,
              "y": 28.375,
              "z": 0.415
            },
            "rightCorner": {
              "x": -6.676,
              "y": 28.379,
              "z": 0.415
            },
            "gtin": "8717524075231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20065",
            "leftCorner": {
              "x": -6.675,
              "y": 28.386,
              "z": 0.415
            },
            "rightCorner": {
              "x": -6.737,
              "y": 28.39,
              "z": 0.415
            },
            "gtin": "8717524075316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20066",
            "leftCorner": {
              "x": -6.737,
              "y": 28.389,
              "z": 0.415
            },
            "rightCorner": {
              "x": -6.776,
              "y": 28.392,
              "z": 0.415
            },
            "gtin": "8717524075279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20067",
            "leftCorner": {
              "x": -6.776,
              "y": 28.392,
              "z": 0.415
            },
            "rightCorner": {
              "x": -6.816,
              "y": 28.393,
              "z": 0.415
            },
            "gtin": "8717524075279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20068",
            "leftCorner": {
              "x": -6.816,
              "y": 28.381,
              "z": 0.415
            },
            "rightCorner": {
              "x": -6.961,
              "y": 28.389,
              "z": 0.415
            },
            "gtin": "8717524075255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20069",
            "leftCorner": {
              "x": -6.961,
              "y": 28.391,
              "z": 0.415
            },
            "rightCorner": {
              "x": -7.018,
              "y": 28.394,
              "z": 0.415
            },
            "gtin": "4005900973962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2006a",
            "leftCorner": {
              "x": -7.018,
              "y": 28.396,
              "z": 0.415
            },
            "rightCorner": {
              "x": -7.087,
              "y": 28.399,
              "z": 0.415
            },
            "gtin": "4006000019215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2006b",
            "leftCorner": {
              "x": -7.086,
              "y": 28.412,
              "z": 0.415
            },
            "rightCorner": {
              "x": -7.129,
              "y": 28.414,
              "z": 0.415
            },
            "gtin": "4006000004433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2006c",
            "leftCorner": {
              "x": -7.129,
              "y": 28.414,
              "z": 0.415
            },
            "rightCorner": {
              "x": -7.171,
              "y": 28.417,
              "z": 0.415
            },
            "gtin": "4006000004433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2006d",
            "leftCorner": {
              "x": -7.172,
              "y": 28.402,
              "z": 0.415
            },
            "rightCorner": {
              "x": -7.206,
              "y": 28.403,
              "z": 0.415
            },
            "gtin": "4006000019178",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54661f",
        "height": 0.80261,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1ff5c",
            "leftCorner": {
              "x": -5.978,
              "y": 28.353,
              "z": 0.657
            },
            "rightCorner": {
              "x": -6.052,
              "y": 28.356,
              "z": 0.657
            },
            "gtin": "4084200110505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff5d",
            "leftCorner": {
              "x": -6.052,
              "y": 28.347,
              "z": 0.657
            },
            "rightCorner": {
              "x": -6.096,
              "y": 28.349,
              "z": 0.657
            },
            "gtin": "3600542497916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff5e",
            "leftCorner": {
              "x": -6.096,
              "y": 28.349,
              "z": 0.657
            },
            "rightCorner": {
              "x": -6.141,
              "y": 28.352,
              "z": 0.657
            },
            "gtin": "3600542497916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff5f",
            "leftCorner": {
              "x": -6.14,
              "y": 28.362,
              "z": 0.657
            },
            "rightCorner": {
              "x": -6.18,
              "y": 28.364,
              "z": 0.657
            },
            "gtin": "3600542317016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff60",
            "leftCorner": {
              "x": -6.18,
              "y": 28.364,
              "z": 0.657
            },
            "rightCorner": {
              "x": -6.22,
              "y": 28.366,
              "z": 0.657
            },
            "gtin": "3600542317016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff61",
            "leftCorner": {
              "x": -6.221,
              "y": 28.353,
              "z": 0.657
            },
            "rightCorner": {
              "x": -6.271,
              "y": 28.356,
              "z": 0.657
            },
            "gtin": "3600542168618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff62",
            "leftCorner": {
              "x": -6.27,
              "y": 28.366,
              "z": 0.657
            },
            "rightCorner": {
              "x": -6.316,
              "y": 28.368,
              "z": 0.657
            },
            "gtin": "3600542405799",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff63",
            "leftCorner": {
              "x": -6.316,
              "y": 28.368,
              "z": 0.657
            },
            "rightCorner": {
              "x": -6.363,
              "y": 28.371,
              "z": 0.657
            },
            "gtin": "3600542405799",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff64",
            "leftCorner": {
              "x": -6.363,
              "y": 28.359,
              "z": 0.657
            },
            "rightCorner": {
              "x": -6.411,
              "y": 28.361,
              "z": 0.657
            },
            "gtin": "4084200774905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff65",
            "leftCorner": {
              "x": -6.411,
              "y": 28.361,
              "z": 0.657
            },
            "rightCorner": {
              "x": -6.459,
              "y": 28.364,
              "z": 0.657
            },
            "gtin": "4084200774905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff66",
            "leftCorner": {
              "x": -6.459,
              "y": 28.367,
              "z": 0.657
            },
            "rightCorner": {
              "x": -6.526,
              "y": 28.369,
              "z": 0.657
            },
            "gtin": "4084200772901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff67",
            "leftCorner": {
              "x": -6.526,
              "y": 28.369,
              "z": 0.657
            },
            "rightCorner": {
              "x": -6.593,
              "y": 28.373,
              "z": 0.657
            },
            "gtin": "4084200772901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff68",
            "leftCorner": {
              "x": -6.592,
              "y": 28.382,
              "z": 0.657
            },
            "rightCorner": {
              "x": -6.671,
              "y": 28.385,
              "z": 0.657
            },
            "gtin": "4084200771904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff69",
            "leftCorner": {
              "x": -6.671,
              "y": 28.385,
              "z": 0.657
            },
            "rightCorner": {
              "x": -6.75,
              "y": 28.39,
              "z": 0.657
            },
            "gtin": "4084200771904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff6a",
            "leftCorner": {
              "x": -6.75,
              "y": 28.401,
              "z": 0.657
            },
            "rightCorner": {
              "x": -6.832,
              "y": 28.405,
              "z": 0.657
            },
            "gtin": "3600542541398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff6b",
            "leftCorner": {
              "x": -6.832,
              "y": 28.405,
              "z": 0.657
            },
            "rightCorner": {
              "x": -6.914,
              "y": 28.408,
              "z": 0.657
            },
            "gtin": "3600542541398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff6c",
            "leftCorner": {
              "x": -6.914,
              "y": 28.398,
              "z": 0.657
            },
            "rightCorner": {
              "x": -6.991,
              "y": 28.402,
              "z": 0.657
            },
            "gtin": "3600542573061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff6d",
            "leftCorner": {
              "x": -6.992,
              "y": 28.389,
              "z": 0.657
            },
            "rightCorner": {
              "x": -7.049,
              "y": 28.392,
              "z": 0.657
            },
            "gtin": "3600540885036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff6e",
            "leftCorner": {
              "x": -7.049,
              "y": 28.392,
              "z": 0.657
            },
            "rightCorner": {
              "x": -7.106,
              "y": 28.395,
              "z": 0.657
            },
            "gtin": "3600540885036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff6f",
            "leftCorner": {
              "x": -7.106,
              "y": 28.404,
              "z": 0.657
            },
            "rightCorner": {
              "x": -7.177,
              "y": 28.407,
              "z": 0.657
            },
            "gtin": "3600542442909",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546624",
        "height": 1.0607,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1ffc9",
            "leftCorner": {
              "x": -6.009,
              "y": 28.366,
              "z": 0.868
            },
            "rightCorner": {
              "x": -6.058,
              "y": 28.368,
              "z": 0.868
            },
            "gtin": "3600541594821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffca",
            "leftCorner": {
              "x": -6.058,
              "y": 28.368,
              "z": 0.868
            },
            "rightCorner": {
              "x": -6.108,
              "y": 28.371,
              "z": 0.868
            },
            "gtin": "3600541594821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffcb",
            "leftCorner": {
              "x": -6.108,
              "y": 28.362,
              "z": 0.868
            },
            "rightCorner": {
              "x": -6.184,
              "y": 28.365,
              "z": 0.868
            },
            "gtin": "3600541594814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffcc",
            "leftCorner": {
              "x": -6.184,
              "y": 28.365,
              "z": 0.868
            },
            "rightCorner": {
              "x": -6.26,
              "y": 28.369,
              "z": 0.868
            },
            "gtin": "3600541594814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffcd",
            "leftCorner": {
              "x": -6.26,
              "y": 28.37,
              "z": 0.868
            },
            "rightCorner": {
              "x": -6.338,
              "y": 28.375,
              "z": 0.868
            },
            "gtin": "3600542450225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffce",
            "leftCorner": {
              "x": -6.337,
              "y": 28.388,
              "z": 0.868
            },
            "rightCorner": {
              "x": -6.391,
              "y": 28.39,
              "z": 0.868
            },
            "gtin": "3600542444026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffcf",
            "leftCorner": {
              "x": -6.391,
              "y": 28.39,
              "z": 0.868
            },
            "rightCorner": {
              "x": -6.444,
              "y": 28.393,
              "z": 0.868
            },
            "gtin": "3600542444026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffd0",
            "leftCorner": {
              "x": -6.445,
              "y": 28.38,
              "z": 0.868
            },
            "rightCorner": {
              "x": -6.533,
              "y": 28.385,
              "z": 0.868
            },
            "gtin": "3600542098052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffd1",
            "leftCorner": {
              "x": -6.533,
              "y": 28.391,
              "z": 0.868
            },
            "rightCorner": {
              "x": -6.626,
              "y": 28.395,
              "z": 0.868
            },
            "gtin": "3600541698482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffd2",
            "leftCorner": {
              "x": -6.627,
              "y": 28.385,
              "z": 0.868
            },
            "rightCorner": {
              "x": -6.703,
              "y": 28.39,
              "z": 0.868
            },
            "gtin": "3600542411608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffd3",
            "leftCorner": {
              "x": -6.703,
              "y": 28.39,
              "z": 0.868
            },
            "rightCorner": {
              "x": -6.779,
              "y": 28.394,
              "z": 0.868
            },
            "gtin": "3600542411608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffd4",
            "leftCorner": {
              "x": -6.779,
              "y": 28.395,
              "z": 0.868
            },
            "rightCorner": {
              "x": -6.834,
              "y": 28.398,
              "z": 0.868
            },
            "gtin": "3600541594838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffd5",
            "leftCorner": {
              "x": -6.834,
              "y": 28.398,
              "z": 0.868
            },
            "rightCorner": {
              "x": -6.889,
              "y": 28.4,
              "z": 0.868
            },
            "gtin": "3600541594838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffd6",
            "leftCorner": {
              "x": -6.889,
              "y": 28.4,
              "z": 0.868
            },
            "rightCorner": {
              "x": -6.944,
              "y": 28.404,
              "z": 0.868
            },
            "gtin": "3600541594838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffd7",
            "leftCorner": {
              "x": -6.944,
              "y": 28.41,
              "z": 0.868
            },
            "rightCorner": {
              "x": -7.018,
              "y": 28.413,
              "z": 0.868
            },
            "gtin": "3600541744554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffd8",
            "leftCorner": {
              "x": -7.018,
              "y": 28.413,
              "z": 0.868
            },
            "rightCorner": {
              "x": -7.091,
              "y": 28.417,
              "z": 0.868
            },
            "gtin": "3600541744554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffd9",
            "leftCorner": {
              "x": -7.091,
              "y": 28.417,
              "z": 0.868
            },
            "rightCorner": {
              "x": -7.171,
              "y": 28.421,
              "z": 0.868
            },
            "gtin": "3600542048477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffda",
            "leftCorner": {
              "x": -7.171,
              "y": 28.421,
              "z": 0.868
            },
            "rightCorner": {
              "x": -7.198,
              "y": 28.423,
              "z": 0.868
            },
            "gtin": "4005900737427",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546621",
        "height": 1.3047,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2012a",
            "leftCorner": {
              "x": -5.981,
              "y": 28.369,
              "z": 1.067
            },
            "rightCorner": {
              "x": -6.015,
              "y": 28.37,
              "z": 1.067
            },
            "gtin": "3600523814053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2012b",
            "leftCorner": {
              "x": -6.015,
              "y": 28.37,
              "z": 1.067
            },
            "rightCorner": {
              "x": -6.05,
              "y": 28.373,
              "z": 1.067
            },
            "gtin": "3600523814053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2012c",
            "leftCorner": {
              "x": -6.05,
              "y": 28.375,
              "z": 1.067
            },
            "rightCorner": {
              "x": -6.098,
              "y": 28.378,
              "z": 1.067
            },
            "gtin": "3600523814060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2012d",
            "leftCorner": {
              "x": -6.098,
              "y": 28.378,
              "z": 1.067
            },
            "rightCorner": {
              "x": -6.146,
              "y": 28.38,
              "z": 1.067
            },
            "gtin": "3600523814060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2012e",
            "leftCorner": {
              "x": -6.146,
              "y": 28.373,
              "z": 1.067
            },
            "rightCorner": {
              "x": -6.205,
              "y": 28.375,
              "z": 1.067
            },
            "gtin": "3600523525249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2012f",
            "leftCorner": {
              "x": -6.206,
              "y": 28.367,
              "z": 1.067
            },
            "rightCorner": {
              "x": -6.258,
              "y": 28.369,
              "z": 1.067
            },
            "gtin": "3600523970834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20130",
            "leftCorner": {
              "x": -6.258,
              "y": 28.371,
              "z": 1.067
            },
            "rightCorner": {
              "x": -6.303,
              "y": 28.374,
              "z": 1.067
            },
            "gtin": "3600523216468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20131",
            "leftCorner": {
              "x": -6.303,
              "y": 28.377,
              "z": 1.067
            },
            "rightCorner": {
              "x": -6.403,
              "y": 28.382,
              "z": 1.067
            },
            "gtin": "3600523242696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20132",
            "leftCorner": {
              "x": -6.403,
              "y": 28.378,
              "z": 1.067
            },
            "rightCorner": {
              "x": -6.487,
              "y": 28.383,
              "z": 1.067
            },
            "gtin": "3600523639465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20133",
            "leftCorner": {
              "x": -6.487,
              "y": 28.38,
              "z": 1.067
            },
            "rightCorner": {
              "x": -6.568,
              "y": 28.383,
              "z": 1.067
            },
            "gtin": "3600523639458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20134",
            "leftCorner": {
              "x": -6.568,
              "y": 28.397,
              "z": 1.067
            },
            "rightCorner": {
              "x": -6.633,
              "y": 28.4,
              "z": 1.067
            },
            "gtin": "3600523216451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20135",
            "leftCorner": {
              "x": -6.634,
              "y": 28.385,
              "z": 1.067
            },
            "rightCorner": {
              "x": -6.709,
              "y": 28.388,
              "z": 1.067
            },
            "gtin": "3600542184687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20136",
            "leftCorner": {
              "x": -6.709,
              "y": 28.388,
              "z": 1.067
            },
            "rightCorner": {
              "x": -6.784,
              "y": 28.392,
              "z": 1.067
            },
            "gtin": "3600542184687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20137",
            "leftCorner": {
              "x": -6.784,
              "y": 28.393,
              "z": 1.067
            },
            "rightCorner": {
              "x": -6.852,
              "y": 28.397,
              "z": 1.067
            },
            "gtin": "3600542361149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20138",
            "leftCorner": {
              "x": -6.852,
              "y": 28.397,
              "z": 1.067
            },
            "rightCorner": {
              "x": -6.921,
              "y": 28.401,
              "z": 1.067
            },
            "gtin": "3600542361149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20139",
            "leftCorner": {
              "x": -6.921,
              "y": 28.401,
              "z": 1.067
            },
            "rightCorner": {
              "x": -6.99,
              "y": 28.403,
              "z": 1.067
            },
            "gtin": "3600542361149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2013a",
            "leftCorner": {
              "x": -6.99,
              "y": 28.403,
              "z": 1.067
            },
            "rightCorner": {
              "x": -7.059,
              "y": 28.407,
              "z": 1.067
            },
            "gtin": "3600542361149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2013b",
            "leftCorner": {
              "x": -7.059,
              "y": 28.402,
              "z": 1.067
            },
            "rightCorner": {
              "x": -7.155,
              "y": 28.407,
              "z": 1.067
            },
            "gtin": "4006000066226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2011c",
            "leftCorner": {
              "x": -7.155,
              "y": 28.411,
              "z": 1.067
            },
            "rightCorner": {
              "x": -7.234,
              "y": 28.415,
              "z": 1.067
            },
            "gtin": "4006000085128",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546622",
        "height": 1.5551,
        "facings": [
          {
            "id": "68300c895ed67a01d9a200cb",
            "leftCorner": {
              "x": -5.981,
              "y": 28.371,
              "z": 1.272
            },
            "rightCorner": {
              "x": -6.087,
              "y": 28.376,
              "z": 1.272
            },
            "gtin": "3600523970827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200cc",
            "leftCorner": {
              "x": -6.087,
              "y": 28.376,
              "z": 1.272
            },
            "rightCorner": {
              "x": -6.194,
              "y": 28.382,
              "z": 1.272
            },
            "gtin": "3600523970827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200cd",
            "leftCorner": {
              "x": -6.194,
              "y": 28.382,
              "z": 1.272
            },
            "rightCorner": {
              "x": -6.301,
              "y": 28.387,
              "z": 1.272
            },
            "gtin": "3600523970827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200ce",
            "leftCorner": {
              "x": -6.301,
              "y": 28.387,
              "z": 1.272
            },
            "rightCorner": {
              "x": -6.408,
              "y": 28.392,
              "z": 1.272
            },
            "gtin": "3600523970827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200cf",
            "leftCorner": {
              "x": -6.407,
              "y": 28.395,
              "z": 1.272
            },
            "rightCorner": {
              "x": -6.577,
              "y": 28.403,
              "z": 1.272
            },
            "gtin": "3600523350186",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200d0",
            "leftCorner": {
              "x": -6.577,
              "y": 28.403,
              "z": 1.272
            },
            "rightCorner": {
              "x": -6.746,
              "y": 28.412,
              "z": 1.272
            },
            "gtin": "3600523350186",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200d1",
            "leftCorner": {
              "x": -6.746,
              "y": 28.412,
              "z": 1.272
            },
            "rightCorner": {
              "x": -6.915,
              "y": 28.42,
              "z": 1.272
            },
            "gtin": "3600523350186",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200d2",
            "leftCorner": {
              "x": -6.915,
              "y": 28.419,
              "z": 1.272
            },
            "rightCorner": {
              "x": -6.98,
              "y": 28.423,
              "z": 1.272
            },
            "gtin": "3600523428045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200d3",
            "leftCorner": {
              "x": -6.98,
              "y": 28.423,
              "z": 1.272
            },
            "rightCorner": {
              "x": -7.045,
              "y": 28.426,
              "z": 1.272
            },
            "gtin": "3600523428045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200d4",
            "leftCorner": {
              "x": -7.045,
              "y": 28.426,
              "z": 1.272
            },
            "rightCorner": {
              "x": -7.111,
              "y": 28.429,
              "z": 1.272
            },
            "gtin": "3600523428045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200d5",
            "leftCorner": {
              "x": -7.112,
              "y": 28.403,
              "z": 1.272
            },
            "rightCorner": {
              "x": -7.205,
              "y": 28.408,
              "z": 1.272
            },
            "gtin": "3600523997527",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546623",
        "height": 1.7625,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1fffc",
            "leftCorner": {
              "x": -5.98,
              "y": 28.359,
              "z": 1.442
            },
            "rightCorner": {
              "x": -6.073,
              "y": 28.364,
              "z": 1.442
            },
            "gtin": "3600523436064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fffd",
            "leftCorner": {
              "x": -6.072,
              "y": 28.393,
              "z": 1.442
            },
            "rightCorner": {
              "x": -6.155,
              "y": 28.396,
              "z": 1.442
            },
            "gtin": "3600523971923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fffe",
            "leftCorner": {
              "x": -6.156,
              "y": 28.363,
              "z": 1.442
            },
            "rightCorner": {
              "x": -6.255,
              "y": 28.368,
              "z": 1.442
            },
            "gtin": "3600522249238",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffff",
            "leftCorner": {
              "x": -6.255,
              "y": 28.365,
              "z": 1.442
            },
            "rightCorner": {
              "x": -6.296,
              "y": 28.367,
              "z": 1.442
            },
            "gtin": "3600523873814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20000",
            "leftCorner": {
              "x": -6.295,
              "y": 28.381,
              "z": 1.442
            },
            "rightCorner": {
              "x": -6.379,
              "y": 28.385,
              "z": 1.442
            },
            "gtin": "3600523201587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20001",
            "leftCorner": {
              "x": -6.379,
              "y": 28.378,
              "z": 1.442
            },
            "rightCorner": {
              "x": -6.452,
              "y": 28.381,
              "z": 1.442
            },
            "gtin": "3600524055721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20002",
            "leftCorner": {
              "x": -6.451,
              "y": 28.396,
              "z": 1.442
            },
            "rightCorner": {
              "x": -6.538,
              "y": 28.401,
              "z": 1.442
            },
            "gtin": "3600524055745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20003",
            "leftCorner": {
              "x": -6.539,
              "y": 28.384,
              "z": 1.442
            },
            "rightCorner": {
              "x": -6.583,
              "y": 28.386,
              "z": 1.442
            },
            "gtin": "3600524003975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20004",
            "leftCorner": {
              "x": -6.583,
              "y": 28.386,
              "z": 1.442
            },
            "rightCorner": {
              "x": -6.627,
              "y": 28.389,
              "z": 1.442
            },
            "gtin": "3600524003975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20005",
            "leftCorner": {
              "x": -6.627,
              "y": 28.387,
              "z": 1.442
            },
            "rightCorner": {
              "x": -6.723,
              "y": 28.391,
              "z": 1.442
            },
            "gtin": "3600523985319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20006",
            "leftCorner": {
              "x": -6.722,
              "y": 28.407,
              "z": 1.442
            },
            "rightCorner": {
              "x": -6.835,
              "y": 28.413,
              "z": 1.442
            },
            "gtin": "3600523716487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20007",
            "leftCorner": {
              "x": -6.836,
              "y": 28.399,
              "z": 1.442
            },
            "rightCorner": {
              "x": -6.917,
              "y": 28.403,
              "z": 1.442
            },
            "gtin": "3600523670642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20008",
            "leftCorner": {
              "x": -6.917,
              "y": 28.403,
              "z": 1.442
            },
            "rightCorner": {
              "x": -6.999,
              "y": 28.408,
              "z": 1.442
            },
            "gtin": "3600523670611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20009",
            "leftCorner": {
              "x": -6.999,
              "y": 28.417,
              "z": 1.442
            },
            "rightCorner": {
              "x": -7.083,
              "y": 28.42,
              "z": 1.442
            },
            "gtin": "3600523670628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2000a",
            "leftCorner": {
              "x": -7.083,
              "y": 28.423,
              "z": 1.442
            },
            "rightCorner": {
              "x": -7.157,
              "y": 28.427,
              "z": 1.442
            },
            "gtin": "3600521719541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2000b",
            "leftCorner": {
              "x": -7.158,
              "y": 28.421,
              "z": 1.442
            },
            "rightCorner": {
              "x": -7.232,
              "y": 28.425,
              "z": 1.442
            },
            "gtin": "3600522020837",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d6d",
    "rightNeighborShelfId": "a6d6f"
  },
  {
    "id": "a6d6f",
    "name": "a6d6f",
    "x": -7.228,
    "y": 28.555,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99968,
      "w": 0.025148
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 105
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546681",
        "height": 0.18252,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ba8",
            "leftCorner": {
              "x": -7.229,
              "y": 28.544,
              "z": 0.149
            },
            "rightCorner": {
              "x": -7.376,
              "y": 28.552,
              "z": 0.149
            },
            "gtin": "4063367151538",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ba9",
            "leftCorner": {
              "x": -7.376,
              "y": 28.552,
              "z": 0.149
            },
            "rightCorner": {
              "x": -7.524,
              "y": 28.559,
              "z": 0.149
            },
            "gtin": "4063367151538",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bab",
            "leftCorner": {
              "x": -7.526,
              "y": 28.523,
              "z": 0.149
            },
            "rightCorner": {
              "x": -7.66,
              "y": 28.529,
              "z": 0.149
            },
            "gtin": "4063367151552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bac",
            "leftCorner": {
              "x": -7.66,
              "y": 28.526,
              "z": 0.149
            },
            "rightCorner": {
              "x": -7.721,
              "y": 28.528,
              "z": 0.149
            },
            "gtin": "4063367143427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bad",
            "leftCorner": {
              "x": -7.721,
              "y": 28.528,
              "z": 0.149
            },
            "rightCorner": {
              "x": -7.781,
              "y": 28.531,
              "z": 0.149
            },
            "gtin": "4063367143427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bae",
            "leftCorner": {
              "x": -7.78,
              "y": 28.549,
              "z": 0.149
            },
            "rightCorner": {
              "x": -7.901,
              "y": 28.555,
              "z": 0.149
            },
            "gtin": "4063367143366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20baf",
            "leftCorner": {
              "x": -7.901,
              "y": 28.554,
              "z": 0.149
            },
            "rightCorner": {
              "x": -8.016,
              "y": 28.559,
              "z": 0.149
            },
            "gtin": "4063367143380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bb0",
            "leftCorner": {
              "x": -8.017,
              "y": 28.543,
              "z": 0.149
            },
            "rightCorner": {
              "x": -8.11,
              "y": 28.548,
              "z": 0.149
            },
            "gtin": "4063367143403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bb1",
            "leftCorner": {
              "x": -8.11,
              "y": 28.544,
              "z": 0.149
            },
            "rightCorner": {
              "x": -8.234,
              "y": 28.549,
              "z": 0.149
            },
            "gtin": "4005900897367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20baa",
            "leftCorner": {
              "x": -8.234,
              "y": 28.547,
              "z": 0.149
            },
            "rightCorner": {
              "x": -8.479,
              "y": 28.559,
              "z": 0.149
            },
            "gtin": "4005900897305",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54667d",
        "height": 0.50807,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2006e",
            "leftCorner": {
              "x": -7.206,
              "y": 28.42,
              "z": 0.416
            },
            "rightCorner": {
              "x": -7.286,
              "y": 28.423,
              "z": 0.416
            },
            "gtin": "4006000019963",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2006f",
            "leftCorner": {
              "x": -7.287,
              "y": 28.404,
              "z": 0.416
            },
            "rightCorner": {
              "x": -7.379,
              "y": 28.408,
              "z": 0.416
            },
            "gtin": "4005900680792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20070",
            "leftCorner": {
              "x": -7.377,
              "y": 28.438,
              "z": 0.416
            },
            "rightCorner": {
              "x": -7.459,
              "y": 28.442,
              "z": 0.416
            },
            "gtin": "4006000068237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20071",
            "leftCorner": {
              "x": -7.459,
              "y": 28.453,
              "z": 0.416
            },
            "rightCorner": {
              "x": -7.555,
              "y": 28.457,
              "z": 0.416
            },
            "gtin": "4006000068275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20072",
            "leftCorner": {
              "x": -7.557,
              "y": 28.413,
              "z": 0.416
            },
            "rightCorner": {
              "x": -7.628,
              "y": 28.416,
              "z": 0.416
            },
            "gtin": "4005900801609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20073",
            "leftCorner": {
              "x": -7.628,
              "y": 28.416,
              "z": 0.416
            },
            "rightCorner": {
              "x": -7.7,
              "y": 28.42,
              "z": 0.416
            },
            "gtin": "4005900801609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20074",
            "leftCorner": {
              "x": -7.699,
              "y": 28.434,
              "z": 0.416
            },
            "rightCorner": {
              "x": -7.747,
              "y": 28.436,
              "z": 0.416
            },
            "gtin": "4063367263453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20075",
            "leftCorner": {
              "x": -7.747,
              "y": 28.435,
              "z": 0.416
            },
            "rightCorner": {
              "x": -7.811,
              "y": 28.439,
              "z": 0.416
            },
            "gtin": "4063367263484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20076",
            "leftCorner": {
              "x": -7.81,
              "y": 28.455,
              "z": 0.416
            },
            "rightCorner": {
              "x": -7.873,
              "y": 28.457,
              "z": 0.416
            },
            "gtin": "4063367241819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20077",
            "leftCorner": {
              "x": -7.873,
              "y": 28.443,
              "z": 0.416
            },
            "rightCorner": {
              "x": -8.037,
              "y": 28.452,
              "z": 0.416
            },
            "gtin": "4063367151415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20078",
            "leftCorner": {
              "x": -8.037,
              "y": 28.456,
              "z": 0.416
            },
            "rightCorner": {
              "x": -8.08,
              "y": 28.457,
              "z": 0.416
            },
            "gtin": "4063367151354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20079",
            "leftCorner": {
              "x": -8.08,
              "y": 28.455,
              "z": 0.416
            },
            "rightCorner": {
              "x": -8.15,
              "y": 28.459,
              "z": 0.416
            },
            "gtin": "4063367151408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2007a",
            "leftCorner": {
              "x": -8.15,
              "y": 28.462,
              "z": 0.416
            },
            "rightCorner": {
              "x": -8.189,
              "y": 28.464,
              "z": 0.416
            },
            "gtin": "4063367149672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2007b",
            "leftCorner": {
              "x": -8.189,
              "y": 28.467,
              "z": 0.416
            },
            "rightCorner": {
              "x": -8.273,
              "y": 28.471,
              "z": 0.416
            },
            "gtin": "4063367151248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2007c",
            "leftCorner": {
              "x": -8.274,
              "y": 28.465,
              "z": 0.416
            },
            "rightCorner": {
              "x": -8.334,
              "y": 28.467,
              "z": 0.416
            },
            "gtin": "4337185213359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2007d",
            "leftCorner": {
              "x": -8.335,
              "y": 28.454,
              "z": 0.416
            },
            "rightCorner": {
              "x": -8.424,
              "y": 28.459,
              "z": 0.416
            },
            "gtin": "4011609012079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2007e",
            "leftCorner": {
              "x": -8.424,
              "y": 28.453,
              "z": 0.416
            },
            "rightCorner": {
              "x": -8.486,
              "y": 28.456,
              "z": 0.416
            }
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546680",
        "height": 0.80552,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1ff70",
            "leftCorner": {
              "x": -7.202,
              "y": 28.417,
              "z": 0.659
            },
            "rightCorner": {
              "x": -7.262,
              "y": 28.421,
              "z": 0.659
            },
            "gtin": "4006000004662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff71",
            "leftCorner": {
              "x": -7.262,
              "y": 28.421,
              "z": 0.659
            },
            "rightCorner": {
              "x": -7.323,
              "y": 28.423,
              "z": 0.659
            },
            "gtin": "4006000004662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff72",
            "leftCorner": {
              "x": -7.323,
              "y": 28.425,
              "z": 0.659
            },
            "rightCorner": {
              "x": -7.387,
              "y": 28.428,
              "z": 0.659
            },
            "gtin": "4006000004471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff73",
            "leftCorner": {
              "x": -7.387,
              "y": 28.428,
              "z": 0.659
            },
            "rightCorner": {
              "x": -7.451,
              "y": 28.431,
              "z": 0.659
            },
            "gtin": "4006000004471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff74",
            "leftCorner": {
              "x": -7.451,
              "y": 28.431,
              "z": 0.659
            },
            "rightCorner": {
              "x": -7.515,
              "y": 28.434,
              "z": 0.659
            },
            "gtin": "4006000004471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff75",
            "leftCorner": {
              "x": -7.515,
              "y": 28.434,
              "z": 0.659
            },
            "rightCorner": {
              "x": -7.579,
              "y": 28.437,
              "z": 0.659
            },
            "gtin": "4006000004471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff76",
            "leftCorner": {
              "x": -7.579,
              "y": 28.434,
              "z": 0.659
            },
            "rightCorner": {
              "x": -7.65,
              "y": 28.438,
              "z": 0.659
            },
            "gtin": "4006000019253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff77",
            "leftCorner": {
              "x": -7.65,
              "y": 28.432,
              "z": 0.659
            },
            "rightCorner": {
              "x": -7.745,
              "y": 28.437,
              "z": 0.659
            },
            "gtin": "4006000112695",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff78",
            "leftCorner": {
              "x": -7.744,
              "y": 28.45,
              "z": 0.659
            },
            "rightCorner": {
              "x": -7.852,
              "y": 28.456,
              "z": 0.659
            },
            "gtin": "4006000093222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff79",
            "leftCorner": {
              "x": -7.852,
              "y": 28.456,
              "z": 0.659
            },
            "rightCorner": {
              "x": -7.94,
              "y": 28.461,
              "z": 0.659
            },
            "gtin": "4005900935304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff7a",
            "leftCorner": {
              "x": -7.941,
              "y": 28.446,
              "z": 0.659
            },
            "rightCorner": {
              "x": -8.017,
              "y": 28.449,
              "z": 0.659
            },
            "gtin": "4005900954763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff7b",
            "leftCorner": {
              "x": -8.016,
              "y": 28.464,
              "z": 0.659
            },
            "rightCorner": {
              "x": -8.126,
              "y": 28.468,
              "z": 0.659
            },
            "gtin": "4006000111650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff7c",
            "leftCorner": {
              "x": -8.126,
              "y": 28.452,
              "z": 0.659
            },
            "rightCorner": {
              "x": -8.226,
              "y": 28.458,
              "z": 0.659
            },
            "gtin": "4006000111698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff7d",
            "leftCorner": {
              "x": -8.226,
              "y": 28.459,
              "z": 0.659
            },
            "rightCorner": {
              "x": -8.274,
              "y": 28.461,
              "z": 0.659
            },
            "gtin": "4006000019437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff7e",
            "leftCorner": {
              "x": -8.274,
              "y": 28.461,
              "z": 0.659
            },
            "rightCorner": {
              "x": -8.321,
              "y": 28.463,
              "z": 0.659
            },
            "gtin": "4006000019437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff7f",
            "leftCorner": {
              "x": -8.32,
              "y": 28.474,
              "z": 0.659
            },
            "rightCorner": {
              "x": -8.394,
              "y": 28.478,
              "z": 0.659
            },
            "gtin": "4006000130132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff80",
            "leftCorner": {
              "x": -8.394,
              "y": 28.485,
              "z": 0.659
            },
            "rightCorner": {
              "x": -8.456,
              "y": 28.488,
              "z": 0.659
            },
            "gtin": "4006000018041",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54667e",
        "height": 1.0654,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1ffdb",
            "leftCorner": {
              "x": -7.199,
              "y": 28.412,
              "z": 0.872
            },
            "rightCorner": {
              "x": -7.297,
              "y": 28.417,
              "z": 0.872
            },
            "gtin": "4005900841674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffdc",
            "leftCorner": {
              "x": -7.297,
              "y": 28.412,
              "z": 0.872
            },
            "rightCorner": {
              "x": -7.384,
              "y": 28.417,
              "z": 0.872
            },
            "gtin": "4005900841551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffdd",
            "leftCorner": {
              "x": -7.384,
              "y": 28.414,
              "z": 0.872
            },
            "rightCorner": {
              "x": -7.454,
              "y": 28.418,
              "z": 0.872
            },
            "gtin": "4055297217804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffde",
            "leftCorner": {
              "x": -7.453,
              "y": 28.421,
              "z": 0.872
            },
            "rightCorner": {
              "x": -7.55,
              "y": 28.426,
              "z": 0.872
            },
            "gtin": "4005808195862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffdf",
            "leftCorner": {
              "x": -7.55,
              "y": 28.425,
              "z": 0.872
            },
            "rightCorner": {
              "x": -7.587,
              "y": 28.427,
              "z": 0.872
            },
            "gtin": "4005900935267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffe0",
            "leftCorner": {
              "x": -7.587,
              "y": 28.427,
              "z": 0.872
            },
            "rightCorner": {
              "x": -7.625,
              "y": 28.429,
              "z": 0.872
            },
            "gtin": "4005900935267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffe1",
            "leftCorner": {
              "x": -7.624,
              "y": 28.441,
              "z": 0.872
            },
            "rightCorner": {
              "x": -7.742,
              "y": 28.447,
              "z": 0.872
            },
            "gtin": "4005900935540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffe2",
            "leftCorner": {
              "x": -7.742,
              "y": 28.451,
              "z": 0.872
            },
            "rightCorner": {
              "x": -7.804,
              "y": 28.454,
              "z": 0.872
            },
            "gtin": "4005900935342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffe3",
            "leftCorner": {
              "x": -7.804,
              "y": 28.454,
              "z": 0.872
            },
            "rightCorner": {
              "x": -7.866,
              "y": 28.458,
              "z": 0.872
            },
            "gtin": "4005900935342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffe4",
            "leftCorner": {
              "x": -7.867,
              "y": 28.446,
              "z": 0.872
            },
            "rightCorner": {
              "x": -7.965,
              "y": 28.451,
              "z": 0.872
            },
            "gtin": "4005900935465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffe5",
            "leftCorner": {
              "x": -7.965,
              "y": 28.45,
              "z": 0.872
            },
            "rightCorner": {
              "x": -8.053,
              "y": 28.455,
              "z": 0.872
            },
            "gtin": "4005900935502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffe6",
            "leftCorner": {
              "x": -8.052,
              "y": 28.471,
              "z": 0.872
            },
            "rightCorner": {
              "x": -8.11,
              "y": 28.475,
              "z": 0.872
            },
            "gtin": "4005900973924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffe7",
            "leftCorner": {
              "x": -8.11,
              "y": 28.475,
              "z": 0.872
            },
            "rightCorner": {
              "x": -8.168,
              "y": 28.478,
              "z": 0.872
            },
            "gtin": "4005900973924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffe8",
            "leftCorner": {
              "x": -8.169,
              "y": 28.465,
              "z": 0.872
            },
            "rightCorner": {
              "x": -8.238,
              "y": 28.468,
              "z": 0.872
            },
            "gtin": "4005900935380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffe9",
            "leftCorner": {
              "x": -8.238,
              "y": 28.458,
              "z": 0.872
            },
            "rightCorner": {
              "x": -8.322,
              "y": 28.463,
              "z": 0.872
            },
            "gtin": "4005900935427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffea",
            "leftCorner": {
              "x": -8.322,
              "y": 28.462,
              "z": 0.872
            },
            "rightCorner": {
              "x": -8.409,
              "y": 28.466,
              "z": 0.872
            },
            "gtin": "4006000085289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffb9",
            "leftCorner": {
              "x": -8.409,
              "y": 28.464,
              "z": 0.872
            },
            "rightCorner": {
              "x": -8.484,
              "y": 28.468,
              "z": 0.872
            },
            "gtin": "4006000085166",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54667f",
        "height": 1.3172,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20b6a",
            "leftCorner": {
              "x": -7.233,
              "y": 28.462,
              "z": 1.078
            },
            "rightCorner": {
              "x": -7.296,
              "y": 28.465,
              "z": 1.078
            },
            "gtin": "4006000111735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b6b",
            "leftCorner": {
              "x": -7.296,
              "y": 28.465,
              "z": 1.078
            },
            "rightCorner": {
              "x": -7.358,
              "y": 28.469,
              "z": 1.078
            },
            "gtin": "4006000111735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b6e",
            "leftCorner": {
              "x": -7.36,
              "y": 28.429,
              "z": 1.078
            },
            "rightCorner": {
              "x": -7.456,
              "y": 28.434,
              "z": 1.078
            },
            "gtin": "4006000085517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b6f",
            "leftCorner": {
              "x": -7.456,
              "y": 28.434,
              "z": 1.078
            },
            "rightCorner": {
              "x": -7.552,
              "y": 28.438,
              "z": 1.078
            },
            "gtin": "4006000085517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b70",
            "leftCorner": {
              "x": -7.552,
              "y": 28.432,
              "z": 1.078
            },
            "rightCorner": {
              "x": -7.65,
              "y": 28.437,
              "z": 1.078
            },
            "gtin": "4006000085036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b71",
            "leftCorner": {
              "x": -7.65,
              "y": 28.437,
              "z": 1.078
            },
            "rightCorner": {
              "x": -7.748,
              "y": 28.442,
              "z": 1.078
            },
            "gtin": "4006000085036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b72",
            "leftCorner": {
              "x": -7.748,
              "y": 28.443,
              "z": 1.078
            },
            "rightCorner": {
              "x": -7.833,
              "y": 28.448,
              "z": 1.078
            },
            "gtin": "4006000085241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b73",
            "leftCorner": {
              "x": -7.833,
              "y": 28.448,
              "z": 1.078
            },
            "rightCorner": {
              "x": -7.918,
              "y": 28.452,
              "z": 1.078
            },
            "gtin": "4006000085241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b74",
            "leftCorner": {
              "x": -7.918,
              "y": 28.465,
              "z": 1.078
            },
            "rightCorner": {
              "x": -8.014,
              "y": 28.471,
              "z": 1.078
            },
            "gtin": "4006000085203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b75",
            "leftCorner": {
              "x": -8.015,
              "y": 28.468,
              "z": 1.078
            },
            "rightCorner": {
              "x": -8.064,
              "y": 28.47,
              "z": 1.078
            },
            "gtin": "4006000085074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b76",
            "leftCorner": {
              "x": -8.064,
              "y": 28.47,
              "z": 1.078
            },
            "rightCorner": {
              "x": -8.113,
              "y": 28.473,
              "z": 1.078
            },
            "gtin": "4006000085074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b77",
            "leftCorner": {
              "x": -8.113,
              "y": 28.473,
              "z": 1.078
            },
            "rightCorner": {
              "x": -8.162,
              "y": 28.474,
              "z": 1.078
            },
            "gtin": "4006000085074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b78",
            "leftCorner": {
              "x": -8.162,
              "y": 28.473,
              "z": 1.078
            },
            "rightCorner": {
              "x": -8.257,
              "y": 28.477,
              "z": 1.078
            },
            "gtin": "4006000111773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b79",
            "leftCorner": {
              "x": -8.257,
              "y": 28.479,
              "z": 1.078
            },
            "rightCorner": {
              "x": -8.351,
              "y": 28.484,
              "z": 1.078
            },
            "gtin": "4006000043364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b7a",
            "leftCorner": {
              "x": -8.353,
              "y": 28.461,
              "z": 1.078
            },
            "rightCorner": {
              "x": -8.435,
              "y": 28.465,
              "z": 1.078
            },
            "gtin": "4006000043128",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54667c",
        "height": 1.5612,
        "facings": [
          {
            "id": "68300c895ed67a01d9a200d6",
            "leftCorner": {
              "x": -7.204,
              "y": 28.428,
              "z": 1.277
            },
            "rightCorner": {
              "x": -7.316,
              "y": 28.434,
              "z": 1.277
            },
            "gtin": "4006000054957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200d7",
            "leftCorner": {
              "x": -7.317,
              "y": 28.423,
              "z": 1.277
            },
            "rightCorner": {
              "x": -7.396,
              "y": 28.427,
              "z": 1.277
            },
            "gtin": "4006000043326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200d8",
            "leftCorner": {
              "x": -7.396,
              "y": 28.427,
              "z": 1.277
            },
            "rightCorner": {
              "x": -7.474,
              "y": 28.43,
              "z": 1.277
            },
            "gtin": "4006000043326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200d9",
            "leftCorner": {
              "x": -7.474,
              "y": 28.433,
              "z": 1.277
            },
            "rightCorner": {
              "x": -7.561,
              "y": 28.437,
              "z": 1.277
            },
            "gtin": "4006000054919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200da",
            "leftCorner": {
              "x": -7.561,
              "y": 28.437,
              "z": 1.277
            },
            "rightCorner": {
              "x": -7.647,
              "y": 28.442,
              "z": 1.277
            },
            "gtin": "4006000054919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200db",
            "leftCorner": {
              "x": -7.647,
              "y": 28.442,
              "z": 1.277
            },
            "rightCorner": {
              "x": -7.733,
              "y": 28.446,
              "z": 1.277
            },
            "gtin": "4006000054919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200dc",
            "leftCorner": {
              "x": -7.733,
              "y": 28.447,
              "z": 1.277
            },
            "rightCorner": {
              "x": -7.84,
              "y": 28.452,
              "z": 1.277
            },
            "gtin": "4005900715982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200dd",
            "leftCorner": {
              "x": -7.84,
              "y": 28.458,
              "z": 1.277
            },
            "rightCorner": {
              "x": -7.917,
              "y": 28.462,
              "z": 1.277
            },
            "gtin": "4005900803238",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200de",
            "leftCorner": {
              "x": -7.917,
              "y": 28.462,
              "z": 1.277
            },
            "rightCorner": {
              "x": -7.995,
              "y": 28.466,
              "z": 1.277
            },
            "gtin": "4005900803238",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200df",
            "leftCorner": {
              "x": -7.995,
              "y": 28.461,
              "z": 1.277
            },
            "rightCorner": {
              "x": -8.115,
              "y": 28.468,
              "z": 1.277
            },
            "gtin": "4006000043241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200e0",
            "leftCorner": {
              "x": -8.115,
              "y": 28.468,
              "z": 1.277
            },
            "rightCorner": {
              "x": -8.234,
              "y": 28.474,
              "z": 1.277
            },
            "gtin": "4006000043241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200e1",
            "leftCorner": {
              "x": -8.234,
              "y": 28.474,
              "z": 1.277
            },
            "rightCorner": {
              "x": -8.354,
              "y": 28.48,
              "z": 1.277
            },
            "gtin": "4006000043241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200e2",
            "leftCorner": {
              "x": -8.354,
              "y": 28.475,
              "z": 1.277
            },
            "rightCorner": {
              "x": -8.462,
              "y": 28.479,
              "z": 1.277
            },
            "gtin": "4055297219365",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54667b",
        "height": 1.7596,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2000c",
            "leftCorner": {
              "x": -7.233,
              "y": 28.424,
              "z": 1.44
            },
            "rightCorner": {
              "x": -7.306,
              "y": 28.428,
              "z": 1.44
            },
            "gtin": "3600523970834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2000d",
            "leftCorner": {
              "x": -7.306,
              "y": 28.428,
              "z": 1.44
            },
            "rightCorner": {
              "x": -7.379,
              "y": 28.432,
              "z": 1.44
            },
            "gtin": "3600523970834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2000e",
            "leftCorner": {
              "x": -7.379,
              "y": 28.442,
              "z": 1.44
            },
            "rightCorner": {
              "x": -7.438,
              "y": 28.445,
              "z": 1.44
            },
            "gtin": "4005900972156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2000f",
            "leftCorner": {
              "x": -7.438,
              "y": 28.445,
              "z": 1.44
            },
            "rightCorner": {
              "x": -7.498,
              "y": 28.448,
              "z": 1.44
            },
            "gtin": "4005900972156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20010",
            "leftCorner": {
              "x": -7.498,
              "y": 28.45,
              "z": 1.44
            },
            "rightCorner": {
              "x": -7.608,
              "y": 28.456,
              "z": 1.44
            },
            "gtin": "4005900108623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20011",
            "leftCorner": {
              "x": -7.609,
              "y": 28.44,
              "z": 1.44
            },
            "rightCorner": {
              "x": -7.7,
              "y": 28.445,
              "z": 1.44
            },
            "gtin": "4005900108678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20012",
            "leftCorner": {
              "x": -7.699,
              "y": 28.458,
              "z": 1.44
            },
            "rightCorner": {
              "x": -7.772,
              "y": 28.462,
              "z": 1.44
            },
            "gtin": "4005900108548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20013",
            "leftCorner": {
              "x": -7.772,
              "y": 28.452,
              "z": 1.44
            },
            "rightCorner": {
              "x": -7.88,
              "y": 28.456,
              "z": 1.44
            },
            "gtin": "4005900108586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20014",
            "leftCorner": {
              "x": -7.88,
              "y": 28.459,
              "z": 1.44
            },
            "rightCorner": {
              "x": -7.984,
              "y": 28.465,
              "z": 1.44
            },
            "gtin": "3600524030780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20015",
            "leftCorner": {
              "x": -7.984,
              "y": 28.476,
              "z": 1.44
            },
            "rightCorner": {
              "x": -8.072,
              "y": 28.48,
              "z": 1.44
            },
            "gtin": "4005900108302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20016",
            "leftCorner": {
              "x": -8.073,
              "y": 28.462,
              "z": 1.44
            },
            "rightCorner": {
              "x": -8.157,
              "y": 28.466,
              "z": 1.44
            },
            "gtin": "4260189522830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20017",
            "leftCorner": {
              "x": -8.157,
              "y": 28.462,
              "z": 1.44
            },
            "rightCorner": {
              "x": -8.21,
              "y": 28.465,
              "z": 1.44
            },
            "gtin": "4260189522847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20018",
            "leftCorner": {
              "x": -8.21,
              "y": 28.465,
              "z": 1.44
            },
            "rightCorner": {
              "x": -8.263,
              "y": 28.468,
              "z": 1.44
            },
            "gtin": "4260189522847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20019",
            "leftCorner": {
              "x": -8.263,
              "y": 28.474,
              "z": 1.44
            },
            "rightCorner": {
              "x": -8.336,
              "y": 28.478,
              "z": 1.44
            },
            "gtin": "4260189522816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2001a",
            "leftCorner": {
              "x": -8.336,
              "y": 28.473,
              "z": 1.44
            },
            "rightCorner": {
              "x": -8.408,
              "y": 28.476,
              "z": 1.44
            },
            "gtin": "4036581539062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2001b",
            "leftCorner": {
              "x": -8.408,
              "y": 28.475,
              "z": 1.44
            },
            "rightCorner": {
              "x": -8.463,
              "y": 28.478,
              "z": 1.44
            },
            "gtin": "4036581539109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2001c",
            "leftCorner": {
              "x": -8.463,
              "y": 28.478,
              "z": 1.44
            },
            "rightCorner": {
              "x": -8.518,
              "y": 28.481,
              "z": 1.44
            },
            "gtin": "4036581539109",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d6e",
    "rightNeighborShelfId": "a6d70"
  },
  {
    "id": "a6d70",
    "name": "a6d70",
    "x": -8.476,
    "y": 28.618,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99968,
      "w": 0.025148
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 120
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5466ac",
        "height": 0.16932,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20cd7",
            "leftCorner": {
              "x": -8.477,
              "y": 28.605,
              "z": 0.139
            },
            "rightCorner": {
              "x": -8.524,
              "y": 28.608,
              "z": 0.139
            },
            "gtin": "4005900108142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cd8",
            "leftCorner": {
              "x": -8.524,
              "y": 28.608,
              "z": 0.139
            },
            "rightCorner": {
              "x": -8.571,
              "y": 28.609,
              "z": 0.139
            },
            "gtin": "4005900108142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cdb",
            "leftCorner": {
              "x": -8.573,
              "y": 28.567,
              "z": 0.139
            },
            "rightCorner": {
              "x": -8.635,
              "y": 28.57,
              "z": 0.139
            },
            "gtin": "4005900107893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cdc",
            "leftCorner": {
              "x": -8.635,
              "y": 28.57,
              "z": 0.139
            },
            "rightCorner": {
              "x": -8.697,
              "y": 28.573,
              "z": 0.139
            },
            "gtin": "4005900107893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cdd",
            "leftCorner": {
              "x": -8.696,
              "y": 28.582,
              "z": 0.139
            },
            "rightCorner": {
              "x": -8.802,
              "y": 28.588,
              "z": 0.139
            },
            "gtin": "4046104000382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cde",
            "leftCorner": {
              "x": -8.802,
              "y": 28.594,
              "z": 0.139
            },
            "rightCorner": {
              "x": -8.904,
              "y": 28.598,
              "z": 0.139
            },
            "gtin": "4046104000405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cdf",
            "leftCorner": {
              "x": -8.904,
              "y": 28.595,
              "z": 0.139
            },
            "rightCorner": {
              "x": -8.997,
              "y": 28.6,
              "z": 0.139
            },
            "gtin": "4046104000443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ce0",
            "leftCorner": {
              "x": -8.997,
              "y": 28.6,
              "z": 0.139
            },
            "rightCorner": {
              "x": -9.09,
              "y": 28.605,
              "z": 0.139
            },
            "gtin": "4046104000443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ce1",
            "leftCorner": {
              "x": -9.09,
              "y": 28.601,
              "z": 0.139
            },
            "rightCorner": {
              "x": -9.166,
              "y": 28.605,
              "z": 0.139
            },
            "gtin": "4000196031099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ce2",
            "leftCorner": {
              "x": -9.166,
              "y": 28.605,
              "z": 0.139
            },
            "rightCorner": {
              "x": -9.243,
              "y": 28.608,
              "z": 0.139
            },
            "gtin": "4000196031099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ce3",
            "leftCorner": {
              "x": -9.244,
              "y": 28.602,
              "z": 0.139
            },
            "rightCorner": {
              "x": -9.356,
              "y": 28.608,
              "z": 0.139
            },
            "gtin": "4063367357343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ce4",
            "leftCorner": {
              "x": -9.356,
              "y": 28.608,
              "z": 0.139
            },
            "rightCorner": {
              "x": -9.454,
              "y": 28.613,
              "z": 0.139
            },
            "gtin": "4063367357268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ce5",
            "leftCorner": {
              "x": -9.454,
              "y": 28.613,
              "z": 0.139
            },
            "rightCorner": {
              "x": -9.551,
              "y": 28.618,
              "z": 0.139
            },
            "gtin": "4063367357268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ce6",
            "leftCorner": {
              "x": -9.551,
              "y": 28.604,
              "z": 0.139
            },
            "rightCorner": {
              "x": -9.65,
              "y": 28.609,
              "z": 0.139
            },
            "gtin": "4063367357305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ce7",
            "leftCorner": {
              "x": -9.649,
              "y": 28.625,
              "z": 0.139
            },
            "rightCorner": {
              "x": -9.727,
              "y": 28.629,
              "z": 0.139
            },
            "gtin": "4063367263330",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466aa",
        "height": 0.50207,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2007f",
            "leftCorner": {
              "x": -8.484,
              "y": 28.475,
              "z": 0.411
            },
            "rightCorner": {
              "x": -8.535,
              "y": 28.478,
              "z": 0.411
            },
            "gtin": "4046104000139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20080",
            "leftCorner": {
              "x": -8.535,
              "y": 28.478,
              "z": 0.411
            },
            "rightCorner": {
              "x": -8.585,
              "y": 28.481,
              "z": 0.411
            },
            "gtin": "4046104000139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20081",
            "leftCorner": {
              "x": -8.585,
              "y": 28.481,
              "z": 0.411
            },
            "rightCorner": {
              "x": -8.636,
              "y": 28.484,
              "z": 0.411
            },
            "gtin": "4046104000139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20082",
            "leftCorner": {
              "x": -8.636,
              "y": 28.486,
              "z": 0.411
            },
            "rightCorner": {
              "x": -8.688,
              "y": 28.488,
              "z": 0.411
            },
            "gtin": "4063367143588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20083",
            "leftCorner": {
              "x": -8.687,
              "y": 28.493,
              "z": 0.411
            },
            "rightCorner": {
              "x": -8.76,
              "y": 28.496,
              "z": 0.411
            },
            "gtin": "4063367143564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20084",
            "leftCorner": {
              "x": -8.761,
              "y": 28.477,
              "z": 0.411
            },
            "rightCorner": {
              "x": -8.818,
              "y": 28.48,
              "z": 0.411
            },
            "gtin": "4046104000429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20085",
            "leftCorner": {
              "x": -8.817,
              "y": 28.502,
              "z": 0.411
            },
            "rightCorner": {
              "x": -8.863,
              "y": 28.504,
              "z": 0.411
            },
            "gtin": "4046104000115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20086",
            "leftCorner": {
              "x": -8.862,
              "y": 28.501,
              "z": 0.411
            },
            "rightCorner": {
              "x": -8.93,
              "y": 28.504,
              "z": 0.411
            },
            "gtin": "4063367143540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20087",
            "leftCorner": {
              "x": -8.93,
              "y": 28.506,
              "z": 0.411
            },
            "rightCorner": {
              "x": -9.001,
              "y": 28.508,
              "z": 0.411
            },
            "gtin": "3600542561402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20088",
            "leftCorner": {
              "x": -9.001,
              "y": 28.508,
              "z": 0.411
            },
            "rightCorner": {
              "x": -9.071,
              "y": 28.512,
              "z": 0.411
            },
            "gtin": "3600542561402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20089",
            "leftCorner": {
              "x": -9.072,
              "y": 28.498,
              "z": 0.411
            },
            "rightCorner": {
              "x": -9.148,
              "y": 28.502,
              "z": 0.411
            },
            "gtin": "3574661685977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2008a",
            "leftCorner": {
              "x": -9.147,
              "y": 28.515,
              "z": 0.411
            },
            "rightCorner": {
              "x": -9.211,
              "y": 28.518,
              "z": 0.411
            },
            "gtin": "3574661687049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2008b",
            "leftCorner": {
              "x": -9.211,
              "y": 28.518,
              "z": 0.411
            },
            "rightCorner": {
              "x": -9.275,
              "y": 28.521,
              "z": 0.411
            },
            "gtin": "3574661687049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2008c",
            "leftCorner": {
              "x": -9.276,
              "y": 28.514,
              "z": 0.411
            },
            "rightCorner": {
              "x": -9.326,
              "y": 28.516,
              "z": 0.411
            },
            "gtin": "3574661685984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2008d",
            "leftCorner": {
              "x": -9.326,
              "y": 28.516,
              "z": 0.411
            },
            "rightCorner": {
              "x": -9.376,
              "y": 28.519,
              "z": 0.411
            },
            "gtin": "3574661685984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2008e",
            "leftCorner": {
              "x": -9.375,
              "y": 28.515,
              "z": 0.411
            },
            "rightCorner": {
              "x": -9.444,
              "y": 28.519,
              "z": 0.411
            },
            "gtin": "8717163917770",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2008f",
            "leftCorner": {
              "x": -9.444,
              "y": 28.523,
              "z": 0.411
            },
            "rightCorner": {
              "x": -9.491,
              "y": 28.525,
              "z": 0.411
            },
            "gtin": "8710522415702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20090",
            "leftCorner": {
              "x": -9.49,
              "y": 28.541,
              "z": 0.411
            },
            "rightCorner": {
              "x": -9.557,
              "y": 28.544,
              "z": 0.411
            },
            "gtin": "42390022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20091",
            "leftCorner": {
              "x": -9.557,
              "y": 28.531,
              "z": 0.411
            },
            "rightCorner": {
              "x": -9.609,
              "y": 28.534,
              "z": 0.411
            },
            "gtin": "42417521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20092",
            "leftCorner": {
              "x": -9.61,
              "y": 28.532,
              "z": 0.411
            },
            "rightCorner": {
              "x": -9.679,
              "y": 28.535,
              "z": 0.411
            },
            "gtin": "42419785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20093",
            "leftCorner": {
              "x": -9.679,
              "y": 28.54,
              "z": 0.411
            },
            "rightCorner": {
              "x": -9.708,
              "y": 28.541,
              "z": 0.411
            },
            "gtin": "42398172",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466a6",
        "height": 0.8056,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1ff81",
            "leftCorner": {
              "x": -8.457,
              "y": 28.47,
              "z": 0.659
            },
            "rightCorner": {
              "x": -8.526,
              "y": 28.474,
              "z": 0.659
            },
            "gtin": "5060896573595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff82",
            "leftCorner": {
              "x": -8.526,
              "y": 28.469,
              "z": 0.659
            },
            "rightCorner": {
              "x": -8.583,
              "y": 28.472,
              "z": 0.659
            },
            "gtin": "4025089081319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff83",
            "leftCorner": {
              "x": -8.582,
              "y": 28.485,
              "z": 0.659
            },
            "rightCorner": {
              "x": -8.629,
              "y": 28.487,
              "z": 0.659
            },
            "gtin": "4025089081289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff84",
            "leftCorner": {
              "x": -8.629,
              "y": 28.487,
              "z": 0.659
            },
            "rightCorner": {
              "x": -8.675,
              "y": 28.489,
              "z": 0.659
            },
            "gtin": "4025089081289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff85",
            "leftCorner": {
              "x": -8.676,
              "y": 28.475,
              "z": 0.659
            },
            "rightCorner": {
              "x": -8.744,
              "y": 28.478,
              "z": 0.659
            },
            "gtin": "4021457650033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff86",
            "leftCorner": {
              "x": -8.744,
              "y": 28.485,
              "z": 0.659
            },
            "rightCorner": {
              "x": -8.798,
              "y": 28.487,
              "z": 0.659
            },
            "gtin": "4021457645022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff87",
            "leftCorner": {
              "x": -8.797,
              "y": 28.512,
              "z": 0.659
            },
            "rightCorner": {
              "x": -8.855,
              "y": 28.516,
              "z": 0.659
            },
            "gtin": "3600542561402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff88",
            "leftCorner": {
              "x": -8.855,
              "y": 28.516,
              "z": 0.659
            },
            "rightCorner": {
              "x": -8.912,
              "y": 28.519,
              "z": 0.659
            },
            "gtin": "3600542561402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff89",
            "leftCorner": {
              "x": -8.913,
              "y": 28.508,
              "z": 0.659
            },
            "rightCorner": {
              "x": -8.967,
              "y": 28.511,
              "z": 0.659
            },
            "gtin": "4021457645145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff8a",
            "leftCorner": {
              "x": -8.967,
              "y": 28.511,
              "z": 0.659
            },
            "rightCorner": {
              "x": -9.022,
              "y": 28.514,
              "z": 0.659
            },
            "gtin": "4021457645145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff8b",
            "leftCorner": {
              "x": -9.022,
              "y": 28.508,
              "z": 0.659
            },
            "rightCorner": {
              "x": -9.066,
              "y": 28.51,
              "z": 0.659
            },
            "gtin": "4021457645084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff8c",
            "leftCorner": {
              "x": -9.066,
              "y": 28.51,
              "z": 0.659
            },
            "rightCorner": {
              "x": -9.11,
              "y": 28.511,
              "z": 0.659
            },
            "gtin": "4021457645084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff8d",
            "leftCorner": {
              "x": -9.11,
              "y": 28.508,
              "z": 0.659
            },
            "rightCorner": {
              "x": -9.163,
              "y": 28.511,
              "z": 0.659
            },
            "gtin": "4008233164946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff8e",
            "leftCorner": {
              "x": -9.163,
              "y": 28.511,
              "z": 0.659
            },
            "rightCorner": {
              "x": -9.216,
              "y": 28.513,
              "z": 0.659
            },
            "gtin": "4008233164946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff8f",
            "leftCorner": {
              "x": -9.216,
              "y": 28.514,
              "z": 0.659
            },
            "rightCorner": {
              "x": -9.261,
              "y": 28.517,
              "z": 0.659
            },
            "gtin": "4008233146706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff90",
            "leftCorner": {
              "x": -9.261,
              "y": 28.517,
              "z": 0.659
            },
            "rightCorner": {
              "x": -9.307,
              "y": 28.519,
              "z": 0.659
            },
            "gtin": "4008233146706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff91",
            "leftCorner": {
              "x": -9.307,
              "y": 28.517,
              "z": 0.659
            },
            "rightCorner": {
              "x": -9.393,
              "y": 28.521,
              "z": 0.659
            },
            "gtin": "4008233133614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff92",
            "leftCorner": {
              "x": -9.393,
              "y": 28.517,
              "z": 0.659
            },
            "rightCorner": {
              "x": -9.493,
              "y": 28.521,
              "z": 0.659
            },
            "gtin": "4008233149288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff93",
            "leftCorner": {
              "x": -9.493,
              "y": 28.521,
              "z": 0.659
            },
            "rightCorner": {
              "x": -9.578,
              "y": 28.525,
              "z": 0.659
            },
            "gtin": "4051424570057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff94",
            "leftCorner": {
              "x": -9.578,
              "y": 28.523,
              "z": 0.659
            },
            "rightCorner": {
              "x": -9.615,
              "y": 28.524,
              "z": 0.659
            },
            "gtin": "3600551043203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff95",
            "leftCorner": {
              "x": -9.615,
              "y": 28.524,
              "z": 0.659
            },
            "rightCorner": {
              "x": -9.654,
              "y": 28.526,
              "z": 0.659
            },
            "gtin": "3600551043203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff96",
            "leftCorner": {
              "x": -9.654,
              "y": 28.524,
              "z": 0.659
            },
            "rightCorner": {
              "x": -9.697,
              "y": 28.527,
              "z": 0.659
            },
            "gtin": "3600551101743",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466a9",
        "height": 1.052,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ca4",
            "leftCorner": {
              "x": -8.481,
              "y": 28.524,
              "z": 0.861
            },
            "rightCorner": {
              "x": -8.523,
              "y": 28.526,
              "z": 0.861
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20ca6",
            "leftCorner": {
              "x": -8.526,
              "y": 28.484,
              "z": 0.861
            },
            "rightCorner": {
              "x": -8.623,
              "y": 28.488,
              "z": 0.861
            },
            "gtin": "5704947016661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ca7",
            "leftCorner": {
              "x": -8.623,
              "y": 28.488,
              "z": 0.861
            },
            "rightCorner": {
              "x": -8.721,
              "y": 28.493,
              "z": 0.861
            },
            "gtin": "5704947016661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ca8",
            "leftCorner": {
              "x": -8.72,
              "y": 28.498,
              "z": 0.861
            },
            "rightCorner": {
              "x": -8.82,
              "y": 28.504,
              "z": 0.861
            },
            "gtin": "5704947015862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ca9",
            "leftCorner": {
              "x": -8.82,
              "y": 28.505,
              "z": 0.861
            },
            "rightCorner": {
              "x": -8.941,
              "y": 28.51,
              "z": 0.861
            },
            "gtin": "4000196031136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20caa",
            "leftCorner": {
              "x": -8.94,
              "y": 28.507,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.015,
              "y": 28.511,
              "z": 0.861
            },
            "gtin": "4063367180422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cab",
            "leftCorner": {
              "x": -9.015,
              "y": 28.511,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.09,
              "y": 28.514,
              "z": 0.861
            },
            "gtin": "4063367180422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cac",
            "leftCorner": {
              "x": -9.09,
              "y": 28.519,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.15,
              "y": 28.522,
              "z": 0.861
            },
            "gtin": "4006000057927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cad",
            "leftCorner": {
              "x": -9.15,
              "y": 28.523,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.213,
              "y": 28.525,
              "z": 0.861
            },
            "gtin": "4001638088459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cae",
            "leftCorner": {
              "x": -9.213,
              "y": 28.518,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.461,
              "y": 28.531,
              "z": 0.861
            },
            "gtin": "4001638523028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20caf",
            "leftCorner": {
              "x": -9.462,
              "y": 28.524,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.554,
              "y": 28.528,
              "z": 0.861
            },
            "gtin": "4005900109019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cb0",
            "leftCorner": {
              "x": -9.555,
              "y": 28.523,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.623,
              "y": 28.527,
              "z": 0.861
            },
            "gtin": "4003583216598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cb1",
            "leftCorner": {
              "x": -9.623,
              "y": 28.528,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.679,
              "y": 28.53,
              "z": 0.861
            },
            "gtin": "4003583217724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cb2",
            "leftCorner": {
              "x": -9.678,
              "y": 28.543,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.711,
              "y": 28.545,
              "z": 0.861
            },
            "gtin": "4003583217724",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466a8",
        "height": 1.3077,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20b7b",
            "leftCorner": {
              "x": -8.459,
              "y": 28.483,
              "z": 1.07
            },
            "rightCorner": {
              "x": -8.563,
              "y": 28.488,
              "z": 1.07
            },
            "gtin": "3574661444123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b7c",
            "leftCorner": {
              "x": -8.563,
              "y": 28.488,
              "z": 1.07
            },
            "rightCorner": {
              "x": -8.666,
              "y": 28.493,
              "z": 1.07
            },
            "gtin": "3574661444123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b7d",
            "leftCorner": {
              "x": -8.666,
              "y": 28.496,
              "z": 1.07
            },
            "rightCorner": {
              "x": -8.739,
              "y": 28.5,
              "z": 1.07
            },
            "gtin": "4013718021188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b7e",
            "leftCorner": {
              "x": -8.739,
              "y": 28.5,
              "z": 1.07
            },
            "rightCorner": {
              "x": -8.812,
              "y": 28.503,
              "z": 1.07
            },
            "gtin": "4013718021188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b7f",
            "leftCorner": {
              "x": -8.811,
              "y": 28.521,
              "z": 1.07
            },
            "rightCorner": {
              "x": -8.864,
              "y": 28.523,
              "z": 1.07
            },
            "gtin": "4013718021904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b80",
            "leftCorner": {
              "x": -8.864,
              "y": 28.523,
              "z": 1.07
            },
            "rightCorner": {
              "x": -8.917,
              "y": 28.526,
              "z": 1.07
            },
            "gtin": "4013718021904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b81",
            "leftCorner": {
              "x": -8.918,
              "y": 28.518,
              "z": 1.07
            },
            "rightCorner": {
              "x": -8.987,
              "y": 28.522,
              "z": 1.07
            },
            "gtin": "4008233004556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b82",
            "leftCorner": {
              "x": -8.987,
              "y": 28.52,
              "z": 1.07
            },
            "rightCorner": {
              "x": -9.103,
              "y": 28.525,
              "z": 1.07
            },
            "gtin": "4006000038896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b83",
            "leftCorner": {
              "x": -9.103,
              "y": 28.517,
              "z": 1.07
            },
            "rightCorner": {
              "x": -9.352,
              "y": 28.53,
              "z": 1.07
            },
            "gtin": "4006000038933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b84",
            "leftCorner": {
              "x": -9.351,
              "y": 28.543,
              "z": 1.07
            },
            "rightCorner": {
              "x": -9.404,
              "y": 28.545,
              "z": 1.07
            },
            "gtin": "4005900997401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b85",
            "leftCorner": {
              "x": -9.404,
              "y": 28.545,
              "z": 1.07
            },
            "rightCorner": {
              "x": -9.457,
              "y": 28.547,
              "z": 1.07
            },
            "gtin": "4005900997401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b86",
            "leftCorner": {
              "x": -9.458,
              "y": 28.531,
              "z": 1.07
            },
            "rightCorner": {
              "x": -9.551,
              "y": 28.536,
              "z": 1.07
            },
            "gtin": "42449829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b87",
            "leftCorner": {
              "x": -9.551,
              "y": 28.54,
              "z": 1.07
            },
            "rightCorner": {
              "x": -9.647,
              "y": 28.545,
              "z": 1.07
            },
            "gtin": "42449836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b88",
            "leftCorner": {
              "x": -9.648,
              "y": 28.533,
              "z": 1.07
            },
            "rightCorner": {
              "x": -9.724,
              "y": 28.537,
              "z": 1.07
            },
            "gtin": "4103040902146",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466a7",
        "height": 1.5546,
        "facings": [
          {
            "id": "68300c895ed67a01d9a200e3",
            "leftCorner": {
              "x": -8.461,
              "y": 28.49,
              "z": 1.272
            },
            "rightCorner": {
              "x": -8.527,
              "y": 28.493,
              "z": 1.272
            },
            "gtin": "4021457637478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200e4",
            "leftCorner": {
              "x": -8.527,
              "y": 28.493,
              "z": 1.272
            },
            "rightCorner": {
              "x": -8.593,
              "y": 28.496,
              "z": 1.272
            },
            "gtin": "4021457637478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200e5",
            "leftCorner": {
              "x": -8.594,
              "y": 28.489,
              "z": 1.272
            },
            "rightCorner": {
              "x": -8.636,
              "y": 28.492,
              "z": 1.272
            },
            "gtin": "3574661750521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200e6",
            "leftCorner": {
              "x": -8.636,
              "y": 28.492,
              "z": 1.272
            },
            "rightCorner": {
              "x": -8.679,
              "y": 28.494,
              "z": 1.272
            },
            "gtin": "3574661750521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200e7",
            "leftCorner": {
              "x": -8.679,
              "y": 28.494,
              "z": 1.272
            },
            "rightCorner": {
              "x": -8.722,
              "y": 28.496,
              "z": 1.272
            },
            "gtin": "3574661750521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200e8",
            "leftCorner": {
              "x": -8.722,
              "y": 28.489,
              "z": 1.272
            },
            "rightCorner": {
              "x": -8.861,
              "y": 28.496,
              "z": 1.272
            },
            "gtin": "4005900964441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200e9",
            "leftCorner": {
              "x": -8.861,
              "y": 28.507,
              "z": 1.272
            },
            "rightCorner": {
              "x": -8.953,
              "y": 28.512,
              "z": 1.272
            },
            "gtin": "4005900964403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200ea",
            "leftCorner": {
              "x": -8.952,
              "y": 28.529,
              "z": 1.272
            },
            "rightCorner": {
              "x": -9.001,
              "y": 28.532,
              "z": 1.272
            },
            "gtin": "4005900964526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200eb",
            "leftCorner": {
              "x": -9.001,
              "y": 28.532,
              "z": 1.272
            },
            "rightCorner": {
              "x": -9.051,
              "y": 28.534,
              "z": 1.272
            },
            "gtin": "4005900964526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200ec",
            "leftCorner": {
              "x": -9.052,
              "y": 28.522,
              "z": 1.272
            },
            "rightCorner": {
              "x": -9.147,
              "y": 28.527,
              "z": 1.272
            },
            "gtin": "4005900917171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200ed",
            "leftCorner": {
              "x": -9.146,
              "y": 28.524,
              "z": 1.272
            },
            "rightCorner": {
              "x": -9.221,
              "y": 28.529,
              "z": 1.272
            },
            "gtin": "4005900917218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200ee",
            "leftCorner": {
              "x": -9.221,
              "y": 28.529,
              "z": 1.272
            },
            "rightCorner": {
              "x": -9.294,
              "y": 28.532,
              "z": 1.272
            },
            "gtin": "4005900917218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200ef",
            "leftCorner": {
              "x": -9.295,
              "y": 28.522,
              "z": 1.272
            },
            "rightCorner": {
              "x": -9.386,
              "y": 28.526,
              "z": 1.272
            },
            "gtin": "42428985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200f0",
            "leftCorner": {
              "x": -9.385,
              "y": 28.536,
              "z": 1.272
            },
            "rightCorner": {
              "x": -9.444,
              "y": 28.539,
              "z": 1.272
            },
            "gtin": "4005900917133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200f1",
            "leftCorner": {
              "x": -9.444,
              "y": 28.539,
              "z": 1.272
            },
            "rightCorner": {
              "x": -9.504,
              "y": 28.542,
              "z": 1.272
            },
            "gtin": "4005900917133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200f2",
            "leftCorner": {
              "x": -9.504,
              "y": 28.53,
              "z": 1.272
            },
            "rightCorner": {
              "x": -9.589,
              "y": 28.535,
              "z": 1.272
            },
            "gtin": "4005900107305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200f3",
            "leftCorner": {
              "x": -9.588,
              "y": 28.547,
              "z": 1.272
            },
            "rightCorner": {
              "x": -9.678,
              "y": 28.551,
              "z": 1.272
            },
            "gtin": "9005800239972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200f4",
            "leftCorner": {
              "x": -9.678,
              "y": 28.553,
              "z": 1.272
            },
            "rightCorner": {
              "x": -9.745,
              "y": 28.555,
              "z": 1.272
            },
            "gtin": "4055297150620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200f5",
            "leftCorner": {
              "x": -9.745,
              "y": 28.555,
              "z": 1.272
            },
            "rightCorner": {
              "x": -9.811,
              "y": 28.559,
              "z": 1.272
            },
            "gtin": "4055297150620",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466ab",
        "height": 1.7567,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2001d",
            "leftCorner": {
              "x": -8.517,
              "y": 28.489,
              "z": 1.437
            },
            "rightCorner": {
              "x": -8.583,
              "y": 28.493,
              "z": 1.437
            },
            "gtin": "4009737385561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2001e",
            "leftCorner": {
              "x": -8.583,
              "y": 28.493,
              "z": 1.437
            },
            "rightCorner": {
              "x": -8.649,
              "y": 28.496,
              "z": 1.437
            },
            "gtin": "4009737385561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2001f",
            "leftCorner": {
              "x": -8.649,
              "y": 28.495,
              "z": 1.437
            },
            "rightCorner": {
              "x": -8.78,
              "y": 28.501,
              "z": 1.437
            },
            "gtin": "4009737385523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20020",
            "leftCorner": {
              "x": -8.779,
              "y": 28.509,
              "z": 1.437
            },
            "rightCorner": {
              "x": -8.836,
              "y": 28.511,
              "z": 1.437
            },
            "gtin": "4000196001146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20021",
            "leftCorner": {
              "x": -8.836,
              "y": 28.511,
              "z": 1.437
            },
            "rightCorner": {
              "x": -8.892,
              "y": 28.515,
              "z": 1.437
            },
            "gtin": "4000196001146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20022",
            "leftCorner": {
              "x": -8.892,
              "y": 28.512,
              "z": 1.437
            },
            "rightCorner": {
              "x": -8.979,
              "y": 28.516,
              "z": 1.437
            },
            "gtin": "4004704104091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20023",
            "leftCorner": {
              "x": -8.979,
              "y": 28.527,
              "z": 1.437
            },
            "rightCorner": {
              "x": -9.055,
              "y": 28.531,
              "z": 1.437
            },
            "gtin": "4008233029368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20024",
            "leftCorner": {
              "x": -9.055,
              "y": 28.531,
              "z": 1.437
            },
            "rightCorner": {
              "x": -9.119,
              "y": 28.535,
              "z": 1.437
            },
            "gtin": "4008233081519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20025",
            "leftCorner": {
              "x": -9.119,
              "y": 28.535,
              "z": 1.437
            },
            "rightCorner": {
              "x": -9.184,
              "y": 28.539,
              "z": 1.437
            },
            "gtin": "4008233081519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20026",
            "leftCorner": {
              "x": -9.185,
              "y": 28.52,
              "z": 1.437
            },
            "rightCorner": {
              "x": -9.258,
              "y": 28.523,
              "z": 1.437
            },
            "gtin": "4008233081175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20027",
            "leftCorner": {
              "x": -9.258,
              "y": 28.523,
              "z": 1.437
            },
            "rightCorner": {
              "x": -9.332,
              "y": 28.527,
              "z": 1.437
            },
            "gtin": "4008233081175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20028",
            "leftCorner": {
              "x": -9.332,
              "y": 28.53,
              "z": 1.437
            },
            "rightCorner": {
              "x": -9.45,
              "y": 28.535,
              "z": 1.437
            },
            "gtin": "4001638500807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20029",
            "leftCorner": {
              "x": -9.45,
              "y": 28.536,
              "z": 1.437
            },
            "rightCorner": {
              "x": -9.516,
              "y": 28.539,
              "z": 1.437
            },
            "gtin": "4001638500814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2002a",
            "leftCorner": {
              "x": -9.516,
              "y": 28.539,
              "z": 1.437
            },
            "rightCorner": {
              "x": -9.582,
              "y": 28.542,
              "z": 1.437
            },
            "gtin": "4001638500814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2002b",
            "leftCorner": {
              "x": -9.582,
              "y": 28.538,
              "z": 1.437
            },
            "rightCorner": {
              "x": -9.65,
              "y": 28.542,
              "z": 1.437
            },
            "gtin": "4001638500838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2002c",
            "leftCorner": {
              "x": -9.649,
              "y": 28.549,
              "z": 1.437
            },
            "rightCorner": {
              "x": -9.708,
              "y": 28.552,
              "z": 1.437
            },
            "gtin": "6001159111375",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d6f",
    "rightNeighborShelfId": "a6d71"
  },
  {
    "id": "a6d71",
    "name": "a6d71",
    "x": -9.724,
    "y": 28.68,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99968,
      "w": 0.025148
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 121
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5466b3",
        "height": 0.16652,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ce8",
            "leftCorner": {
              "x": -9.727,
              "y": 28.629,
              "z": 0.136
            },
            "rightCorner": {
              "x": -9.845,
              "y": 28.635,
              "z": 0.136
            },
            "gtin": "4063367358494",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ce9",
            "leftCorner": {
              "x": -9.845,
              "y": 28.628,
              "z": 0.136
            },
            "rightCorner": {
              "x": -9.909,
              "y": 28.631,
              "z": 0.136
            },
            "gtin": "4011609011591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cea",
            "leftCorner": {
              "x": -9.908,
              "y": 28.638,
              "z": 0.136
            },
            "rightCorner": {
              "x": -10.021,
              "y": 28.644,
              "z": 0.136
            },
            "gtin": "4008268096984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ceb",
            "leftCorner": {
              "x": -10.021,
              "y": 28.659,
              "z": 0.136
            },
            "rightCorner": {
              "x": -10.244,
              "y": 28.67,
              "z": 0.136
            },
            "gtin": "3574661687841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cec",
            "leftCorner": {
              "x": -10.245,
              "y": 28.662,
              "z": 0.136
            },
            "rightCorner": {
              "x": -10.326,
              "y": 28.666,
              "z": 0.136
            },
            "gtin": "4063367263378",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ced",
            "leftCorner": {
              "x": -10.326,
              "y": 28.67,
              "z": 0.136
            },
            "rightCorner": {
              "x": -10.448,
              "y": 28.676,
              "z": 0.136
            },
            "gtin": "4003583217649",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cee",
            "leftCorner": {
              "x": -10.447,
              "y": 28.726,
              "z": 0.136
            },
            "rightCorner": {
              "x": -10.517,
              "y": 28.729,
              "z": 0.136
            },
            "gtin": "4003583217601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cef",
            "leftCorner": {
              "x": -10.517,
              "y": 28.729,
              "z": 0.136
            },
            "rightCorner": {
              "x": -10.586,
              "y": 28.732,
              "z": 0.136
            },
            "gtin": "4003583217601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cf0",
            "leftCorner": {
              "x": -10.588,
              "y": 28.714,
              "z": 0.136
            },
            "rightCorner": {
              "x": -10.666,
              "y": 28.719,
              "z": 0.136
            },
            "gtin": "4003583217663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cf1",
            "leftCorner": {
              "x": -10.666,
              "y": 28.707,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.275,
              "y": 28.738,
              "z": 0.136
            },
            "gtin": "4003583217625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cf2",
            "leftCorner": {
              "x": -11.275,
              "y": 28.738,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.883,
              "y": 28.769,
              "z": 0.136
            },
            "gtin": "4003583217625",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466ae",
        "height": 0.49728,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20094",
            "leftCorner": {
              "x": -9.708,
              "y": 28.533,
              "z": 0.407
            },
            "rightCorner": {
              "x": -9.773,
              "y": 28.538,
              "z": 0.407
            },
            "gtin": "42398165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20095",
            "leftCorner": {
              "x": -9.773,
              "y": 28.552,
              "z": 0.407
            },
            "rightCorner": {
              "x": -9.836,
              "y": 28.555,
              "z": 0.407
            },
            "gtin": "4013162025534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20096",
            "leftCorner": {
              "x": -9.836,
              "y": 28.555,
              "z": 0.407
            },
            "rightCorner": {
              "x": -9.9,
              "y": 28.559,
              "z": 0.407
            },
            "gtin": "4013162025534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20097",
            "leftCorner": {
              "x": -9.9,
              "y": 28.549,
              "z": 0.407
            },
            "rightCorner": {
              "x": -9.975,
              "y": 28.552,
              "z": 0.407
            },
            "gtin": "3574661751603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20098",
            "leftCorner": {
              "x": -9.974,
              "y": 28.555,
              "z": 0.407
            },
            "rightCorner": {
              "x": -10.023,
              "y": 28.558,
              "z": 0.407
            },
            "gtin": "3574661751627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20099",
            "leftCorner": {
              "x": -10.022,
              "y": 28.567,
              "z": 0.407
            },
            "rightCorner": {
              "x": -10.095,
              "y": 28.57,
              "z": 0.407
            },
            "gtin": "3574661199276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2009a",
            "leftCorner": {
              "x": -10.096,
              "y": 28.553,
              "z": 0.407
            },
            "rightCorner": {
              "x": -10.187,
              "y": 28.558,
              "z": 0.407
            },
            "gtin": "3574661785318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2009b",
            "leftCorner": {
              "x": -10.188,
              "y": 28.551,
              "z": 0.407
            },
            "rightCorner": {
              "x": -10.266,
              "y": 28.556,
              "z": 0.407
            },
            "gtin": "3574661783390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2009c",
            "leftCorner": {
              "x": -10.264,
              "y": 28.566,
              "z": 0.407
            },
            "rightCorner": {
              "x": -10.339,
              "y": 28.57,
              "z": 0.407
            },
            "gtin": "8001280026225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2009d",
            "leftCorner": {
              "x": -10.339,
              "y": 28.567,
              "z": 0.407
            },
            "rightCorner": {
              "x": -10.421,
              "y": 28.572,
              "z": 0.407
            },
            "gtin": "3600551033204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2009e",
            "leftCorner": {
              "x": -10.421,
              "y": 28.578,
              "z": 0.407
            },
            "rightCorner": {
              "x": -10.481,
              "y": 28.581,
              "z": 0.407
            },
            "gtin": "3600551101750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2009f",
            "leftCorner": {
              "x": -10.48,
              "y": 28.591,
              "z": 0.407
            },
            "rightCorner": {
              "x": -10.583,
              "y": 28.596,
              "z": 0.407
            },
            "gtin": "3600551033082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200a0",
            "leftCorner": {
              "x": -10.583,
              "y": 28.589,
              "z": 0.407
            },
            "rightCorner": {
              "x": -10.64,
              "y": 28.592,
              "z": 0.407
            },
            "gtin": "4063367180408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200a1",
            "leftCorner": {
              "x": -10.64,
              "y": 28.592,
              "z": 0.407
            },
            "rightCorner": {
              "x": -10.706,
              "y": 28.595,
              "z": 0.407
            },
            "gtin": "4063367180385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200a2",
            "leftCorner": {
              "x": -10.706,
              "y": 28.598,
              "z": 0.407
            },
            "rightCorner": {
              "x": -10.815,
              "y": 28.603,
              "z": 0.407
            },
            "gtin": "4063367419621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200a3",
            "leftCorner": {
              "x": -10.816,
              "y": 28.598,
              "z": 0.407
            },
            "rightCorner": {
              "x": -10.87,
              "y": 28.6,
              "z": 0.407
            },
            "gtin": "4063367419584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200a4",
            "leftCorner": {
              "x": -10.87,
              "y": 28.6,
              "z": 0.407
            },
            "rightCorner": {
              "x": -10.924,
              "y": 28.603,
              "z": 0.407
            },
            "gtin": "4063367419584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200a5",
            "leftCorner": {
              "x": -10.924,
              "y": 28.612,
              "z": 0.407
            },
            "rightCorner": {
              "x": -10.961,
              "y": 28.613,
              "z": 0.407
            },
            "gtin": "4003583223008",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466af",
        "height": 0.80097,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1ff97",
            "leftCorner": {
              "x": -9.695,
              "y": 28.553,
              "z": 0.655
            },
            "rightCorner": {
              "x": -9.777,
              "y": 28.557,
              "z": 0.655
            },
            "gtin": "4006000083391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff98",
            "leftCorner": {
              "x": -9.777,
              "y": 28.546,
              "z": 0.655
            },
            "rightCorner": {
              "x": -9.84,
              "y": 28.549,
              "z": 0.655
            },
            "gtin": "4006000083476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff99",
            "leftCorner": {
              "x": -9.84,
              "y": 28.549,
              "z": 0.655
            },
            "rightCorner": {
              "x": -9.902,
              "y": 28.552,
              "z": 0.655
            },
            "gtin": "4006000083476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff9a",
            "leftCorner": {
              "x": -9.902,
              "y": 28.552,
              "z": 0.655
            },
            "rightCorner": {
              "x": -9.964,
              "y": 28.556,
              "z": 0.655
            },
            "gtin": "4006000083476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff9b",
            "leftCorner": {
              "x": -9.964,
              "y": 28.564,
              "z": 0.655
            },
            "rightCorner": {
              "x": -10.025,
              "y": 28.567,
              "z": 0.655
            },
            "gtin": "4006000083162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff9c",
            "leftCorner": {
              "x": -10.025,
              "y": 28.563,
              "z": 0.655
            },
            "rightCorner": {
              "x": -10.146,
              "y": 28.569,
              "z": 0.655
            },
            "gtin": "3600540299178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff9d",
            "leftCorner": {
              "x": -10.146,
              "y": 28.577,
              "z": 0.655
            },
            "rightCorner": {
              "x": -10.259,
              "y": 28.582,
              "z": 0.655
            },
            "gtin": "3600542317009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff9e",
            "leftCorner": {
              "x": -10.26,
              "y": 28.56,
              "z": 0.655
            },
            "rightCorner": {
              "x": -10.364,
              "y": 28.566,
              "z": 0.655
            },
            "gtin": "3600541334496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff9f",
            "leftCorner": {
              "x": -10.364,
              "y": 28.561,
              "z": 0.655
            },
            "rightCorner": {
              "x": -10.489,
              "y": 28.568,
              "z": 0.655
            },
            "gtin": "3600541544024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffa0",
            "leftCorner": {
              "x": -10.489,
              "y": 28.585,
              "z": 0.655
            },
            "rightCorner": {
              "x": -10.522,
              "y": 28.587,
              "z": 0.655
            },
            "gtin": "4005808911110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffa1",
            "leftCorner": {
              "x": -10.522,
              "y": 28.584,
              "z": 0.655
            },
            "rightCorner": {
              "x": -10.603,
              "y": 28.589,
              "z": 0.655
            },
            "gtin": "4005808802623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffa2",
            "leftCorner": {
              "x": -10.603,
              "y": 28.589,
              "z": 0.655
            },
            "rightCorner": {
              "x": -10.684,
              "y": 28.592,
              "z": 0.655
            },
            "gtin": "4005808802623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffa3",
            "leftCorner": {
              "x": -10.684,
              "y": 28.605,
              "z": 0.655
            },
            "rightCorner": {
              "x": -10.738,
              "y": 28.608,
              "z": 0.655
            },
            "gtin": "4003583223268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffa4",
            "leftCorner": {
              "x": -10.737,
              "y": 28.612,
              "z": 0.655
            },
            "rightCorner": {
              "x": -10.809,
              "y": 28.615,
              "z": 0.655
            },
            "gtin": "4003583223121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffa5",
            "leftCorner": {
              "x": -10.809,
              "y": 28.607,
              "z": 0.655
            },
            "rightCorner": {
              "x": -10.864,
              "y": 28.61,
              "z": 0.655
            },
            "gtin": "4003583223312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffa6",
            "leftCorner": {
              "x": -10.864,
              "y": 28.61,
              "z": 0.655
            },
            "rightCorner": {
              "x": -10.926,
              "y": 28.613,
              "z": 0.655
            },
            "gtin": "4003583223282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffa7",
            "leftCorner": {
              "x": -10.926,
              "y": 28.605,
              "z": 0.655
            },
            "rightCorner": {
              "x": -10.97,
              "y": 28.608,
              "z": 0.655
            },
            "gtin": "4003583223282",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466b1",
        "height": 1.0522,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20cb3",
            "leftCorner": {
              "x": -9.71,
              "y": 28.56,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.766,
              "y": 28.563,
              "z": 0.861
            },
            "gtin": "8717163693162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cb4",
            "leftCorner": {
              "x": -9.766,
              "y": 28.563,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.822,
              "y": 28.566,
              "z": 0.861
            },
            "gtin": "8717163693162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cb5",
            "leftCorner": {
              "x": -9.822,
              "y": 28.566,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.88,
              "y": 28.569,
              "z": 0.861
            },
            "gtin": "8717163693162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cb6",
            "leftCorner": {
              "x": -9.88,
              "y": 28.555,
              "z": 0.861
            },
            "rightCorner": {
              "x": -9.96,
              "y": 28.559,
              "z": 0.861
            },
            "gtin": "4006000083315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cb7",
            "leftCorner": {
              "x": -9.96,
              "y": 28.559,
              "z": 0.861
            },
            "rightCorner": {
              "x": -10.039,
              "y": 28.563,
              "z": 0.861
            },
            "gtin": "4006000083315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cb8",
            "leftCorner": {
              "x": -10.039,
              "y": 28.563,
              "z": 0.861
            },
            "rightCorner": {
              "x": -10.119,
              "y": 28.567,
              "z": 0.861
            },
            "gtin": "4006000083315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cb9",
            "leftCorner": {
              "x": -10.119,
              "y": 28.567,
              "z": 0.861
            },
            "rightCorner": {
              "x": -10.2,
              "y": 28.57,
              "z": 0.861
            },
            "gtin": "4006000083315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cba",
            "leftCorner": {
              "x": -10.2,
              "y": 28.57,
              "z": 0.861
            },
            "rightCorner": {
              "x": -10.28,
              "y": 28.575,
              "z": 0.861
            },
            "gtin": "4006000083315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cbb",
            "leftCorner": {
              "x": -10.28,
              "y": 28.572,
              "z": 0.861
            },
            "rightCorner": {
              "x": -10.37,
              "y": 28.577,
              "z": 0.861
            },
            "gtin": "4006000083353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cbc",
            "leftCorner": {
              "x": -10.37,
              "y": 28.577,
              "z": 0.861
            },
            "rightCorner": {
              "x": -10.462,
              "y": 28.581,
              "z": 0.861
            },
            "gtin": "4006000083353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cbd",
            "leftCorner": {
              "x": -10.461,
              "y": 28.594,
              "z": 0.861
            },
            "rightCorner": {
              "x": -10.537,
              "y": 28.599,
              "z": 0.861
            },
            "gtin": "4006000083650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cbe",
            "leftCorner": {
              "x": -10.537,
              "y": 28.599,
              "z": 0.861
            },
            "rightCorner": {
              "x": -10.613,
              "y": 28.602,
              "z": 0.861
            },
            "gtin": "4006000083650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cbf",
            "leftCorner": {
              "x": -10.612,
              "y": 28.612,
              "z": 0.861
            },
            "rightCorner": {
              "x": -10.694,
              "y": 28.617,
              "z": 0.861
            },
            "gtin": "4006000083896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cc0",
            "leftCorner": {
              "x": -10.694,
              "y": 28.617,
              "z": 0.861
            },
            "rightCorner": {
              "x": -10.776,
              "y": 28.62,
              "z": 0.861
            },
            "gtin": "4006000083896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cc1",
            "leftCorner": {
              "x": -10.777,
              "y": 28.617,
              "z": 0.861
            },
            "rightCorner": {
              "x": -10.826,
              "y": 28.62,
              "z": 0.861
            },
            "gtin": "4006000083773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cc2",
            "leftCorner": {
              "x": -10.826,
              "y": 28.62,
              "z": 0.861
            },
            "rightCorner": {
              "x": -10.875,
              "y": 28.623,
              "z": 0.861
            },
            "gtin": "4006000083773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cc3",
            "leftCorner": {
              "x": -10.876,
              "y": 28.619,
              "z": 0.861
            },
            "rightCorner": {
              "x": -10.937,
              "y": 28.622,
              "z": 0.861
            },
            "gtin": "4006000083698",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466b0",
        "height": 1.2991,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20b89",
            "leftCorner": {
              "x": -9.723,
              "y": 28.559,
              "z": 1.063
            },
            "rightCorner": {
              "x": -9.782,
              "y": 28.562,
              "z": 1.063
            },
            "gtin": "4103040104601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b8a",
            "leftCorner": {
              "x": -9.782,
              "y": 28.553,
              "z": 1.063
            },
            "rightCorner": {
              "x": -9.862,
              "y": 28.556,
              "z": 1.063
            },
            "gtin": "4103040306012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b8b",
            "leftCorner": {
              "x": -9.862,
              "y": 28.554,
              "z": 1.063
            },
            "rightCorner": {
              "x": -9.925,
              "y": 28.557,
              "z": 1.063
            },
            "gtin": "8720182260437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b8c",
            "leftCorner": {
              "x": -9.925,
              "y": 28.56,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.003,
              "y": 28.565,
              "z": 1.063
            },
            "gtin": "8720181405594",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b8d",
            "leftCorner": {
              "x": -10.002,
              "y": 28.574,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.077,
              "y": 28.578,
              "z": 1.063
            },
            "gtin": "8720181085666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b8e",
            "leftCorner": {
              "x": -10.077,
              "y": 28.579,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.114,
              "y": 28.582,
              "z": 1.063
            },
            "gtin": "8720181380006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b8f",
            "leftCorner": {
              "x": -10.114,
              "y": 28.582,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.151,
              "y": 28.583,
              "z": 1.063
            },
            "gtin": "8720181380006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b90",
            "leftCorner": {
              "x": -10.152,
              "y": 28.565,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.226,
              "y": 28.568,
              "z": 1.063
            },
            "gtin": "8720181414282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b91",
            "leftCorner": {
              "x": -10.226,
              "y": 28.568,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.298,
              "y": 28.573,
              "z": 1.063
            },
            "gtin": "8720181414282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b92",
            "leftCorner": {
              "x": -10.298,
              "y": 28.573,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.371,
              "y": 28.576,
              "z": 1.063
            },
            "gtin": "8720181414282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b93",
            "leftCorner": {
              "x": -10.371,
              "y": 28.576,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.445,
              "y": 28.58,
              "z": 1.063
            },
            "gtin": "8720181414282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b94",
            "leftCorner": {
              "x": -10.445,
              "y": 28.589,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.504,
              "y": 28.591,
              "z": 1.063
            },
            "gtin": "8720181085642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b95",
            "leftCorner": {
              "x": -10.504,
              "y": 28.591,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.565,
              "y": 28.594,
              "z": 1.063
            },
            "gtin": "8720181085642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b96",
            "leftCorner": {
              "x": -10.564,
              "y": 28.601,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.639,
              "y": 28.605,
              "z": 1.063
            },
            "gtin": "4006000083971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b97",
            "leftCorner": {
              "x": -10.639,
              "y": 28.605,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.742,
              "y": 28.61,
              "z": 1.063
            },
            "gtin": "4006000083599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b98",
            "leftCorner": {
              "x": -10.742,
              "y": 28.606,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.804,
              "y": 28.61,
              "z": 1.063
            },
            "gtin": "4006000121116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b99",
            "leftCorner": {
              "x": -10.804,
              "y": 28.614,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.864,
              "y": 28.617,
              "z": 1.063
            },
            "gtin": "4006000083735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b9a",
            "leftCorner": {
              "x": -10.864,
              "y": 28.617,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.924,
              "y": 28.62,
              "z": 1.063
            },
            "gtin": "4006000083735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b9b",
            "leftCorner": {
              "x": -10.925,
              "y": 28.613,
              "z": 1.063
            },
            "rightCorner": {
              "x": -11.003,
              "y": 28.618,
              "z": 1.063
            },
            "gtin": "4008890006443",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466ad",
        "height": 1.5498,
        "facings": [
          {
            "id": "68300c895ed67a01d9a200f6",
            "leftCorner": {
              "x": -9.81,
              "y": 28.559,
              "z": 1.268
            },
            "rightCorner": {
              "x": -9.886,
              "y": 28.563,
              "z": 1.268
            },
            "gtin": "5000204093957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200f7",
            "leftCorner": {
              "x": -9.886,
              "y": 28.554,
              "z": 1.268
            },
            "rightCorner": {
              "x": -9.943,
              "y": 28.557,
              "z": 1.268
            },
            "gtin": "5000204093711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200f8",
            "leftCorner": {
              "x": -9.943,
              "y": 28.557,
              "z": 1.268
            },
            "rightCorner": {
              "x": -9.998,
              "y": 28.56,
              "z": 1.268
            },
            "gtin": "5000204093711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200f9",
            "leftCorner": {
              "x": -9.997,
              "y": 28.567,
              "z": 1.268
            },
            "rightCorner": {
              "x": -10.067,
              "y": 28.57,
              "z": 1.268
            },
            "gtin": "5000204285802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200fa",
            "leftCorner": {
              "x": -10.067,
              "y": 28.561,
              "z": 1.268
            },
            "rightCorner": {
              "x": -10.142,
              "y": 28.566,
              "z": 1.268
            },
            "gtin": "5000204253009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200fb",
            "leftCorner": {
              "x": -10.142,
              "y": 28.566,
              "z": 1.268
            },
            "rightCorner": {
              "x": -10.217,
              "y": 28.569,
              "z": 1.268
            },
            "gtin": "5000204253009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200fc",
            "leftCorner": {
              "x": -10.217,
              "y": 28.581,
              "z": 1.268
            },
            "rightCorner": {
              "x": -10.301,
              "y": 28.585,
              "z": 1.268
            },
            "gtin": "5000204094015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200fd",
            "leftCorner": {
              "x": -10.302,
              "y": 28.574,
              "z": 1.268
            },
            "rightCorner": {
              "x": -10.357,
              "y": 28.577,
              "z": 1.268
            },
            "gtin": "5000204093681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200fe",
            "leftCorner": {
              "x": -10.357,
              "y": 28.577,
              "z": 1.268
            },
            "rightCorner": {
              "x": -10.424,
              "y": 28.58,
              "z": 1.268
            },
            "gtin": "4059186100444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200ff",
            "leftCorner": {
              "x": -10.424,
              "y": 28.584,
              "z": 1.268
            },
            "rightCorner": {
              "x": -10.455,
              "y": 28.585,
              "z": 1.268
            },
            "gtin": "4059186101458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20100",
            "leftCorner": {
              "x": -10.455,
              "y": 28.602,
              "z": 1.268
            },
            "rightCorner": {
              "x": -10.504,
              "y": 28.604,
              "z": 1.268
            },
            "gtin": "4059186101120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20101",
            "leftCorner": {
              "x": -10.504,
              "y": 28.604,
              "z": 1.268
            },
            "rightCorner": {
              "x": -10.554,
              "y": 28.607,
              "z": 1.268
            },
            "gtin": "4059186101120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20102",
            "leftCorner": {
              "x": -10.554,
              "y": 28.598,
              "z": 1.268
            },
            "rightCorner": {
              "x": -10.626,
              "y": 28.601,
              "z": 1.268
            },
            "gtin": "4059186101441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20103",
            "leftCorner": {
              "x": -10.626,
              "y": 28.601,
              "z": 1.268
            },
            "rightCorner": {
              "x": -10.697,
              "y": 28.605,
              "z": 1.268
            },
            "gtin": "4059186101441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20104",
            "leftCorner": {
              "x": -10.697,
              "y": 28.605,
              "z": 1.268
            },
            "rightCorner": {
              "x": -10.768,
              "y": 28.608,
              "z": 1.268
            },
            "gtin": "4059186101441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20105",
            "leftCorner": {
              "x": -10.769,
              "y": 28.6,
              "z": 1.268
            },
            "rightCorner": {
              "x": -10.825,
              "y": 28.603,
              "z": 1.268
            },
            "gtin": "4059186101434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20106",
            "leftCorner": {
              "x": -10.825,
              "y": 28.603,
              "z": 1.268
            },
            "rightCorner": {
              "x": -10.88,
              "y": 28.606,
              "z": 1.268
            },
            "gtin": "4059186101434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20107",
            "leftCorner": {
              "x": -10.88,
              "y": 28.606,
              "z": 1.268
            },
            "rightCorner": {
              "x": -10.936,
              "y": 28.609,
              "z": 1.268
            },
            "gtin": "4059186101434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20108",
            "leftCorner": {
              "x": -10.936,
              "y": 28.609,
              "z": 1.268
            },
            "rightCorner": {
              "x": -10.991,
              "y": 28.611,
              "z": 1.268
            },
            "gtin": "4059186101434",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466b2",
        "height": 1.7513,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2002d",
            "leftCorner": {
              "x": -9.706,
              "y": 28.566,
              "z": 1.433
            },
            "rightCorner": {
              "x": -9.827,
              "y": 28.572,
              "z": 1.433
            },
            "gtin": "4001638526708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2002e",
            "leftCorner": {
              "x": -9.827,
              "y": 28.578,
              "z": 1.433
            },
            "rightCorner": {
              "x": -9.879,
              "y": 28.581,
              "z": 1.433
            },
            "gtin": "4001638093989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2002f",
            "leftCorner": {
              "x": -9.879,
              "y": 28.581,
              "z": 1.433
            },
            "rightCorner": {
              "x": -9.931,
              "y": 28.584,
              "z": 1.433
            },
            "gtin": "4001638093989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20030",
            "leftCorner": {
              "x": -9.931,
              "y": 28.584,
              "z": 1.433
            },
            "rightCorner": {
              "x": -9.982,
              "y": 28.586,
              "z": 1.433
            },
            "gtin": "4001638093989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20031",
            "leftCorner": {
              "x": -9.983,
              "y": 28.57,
              "z": 1.433
            },
            "rightCorner": {
              "x": -10.029,
              "y": 28.573,
              "z": 1.433
            },
            "gtin": "4063367180446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20032",
            "leftCorner": {
              "x": -10.029,
              "y": 28.573,
              "z": 1.433
            },
            "rightCorner": {
              "x": -10.073,
              "y": 28.575,
              "z": 1.433
            },
            "gtin": "4063367180446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20033",
            "leftCorner": {
              "x": -10.073,
              "y": 28.573,
              "z": 1.433
            },
            "rightCorner": {
              "x": -10.194,
              "y": 28.579,
              "z": 1.433
            },
            "gtin": "4001638500852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20034",
            "leftCorner": {
              "x": -10.194,
              "y": 28.582,
              "z": 1.433
            },
            "rightCorner": {
              "x": -10.257,
              "y": 28.585,
              "z": 1.433
            },
            "gtin": "4001638529396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20035",
            "leftCorner": {
              "x": -10.257,
              "y": 28.585,
              "z": 1.433
            },
            "rightCorner": {
              "x": -10.321,
              "y": 28.588,
              "z": 1.433
            },
            "gtin": "4001638529396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20036",
            "leftCorner": {
              "x": -10.321,
              "y": 28.588,
              "z": 1.433
            },
            "rightCorner": {
              "x": -10.383,
              "y": 28.593,
              "z": 1.433
            },
            "gtin": "4001638529396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20037",
            "leftCorner": {
              "x": -10.383,
              "y": 28.605,
              "z": 1.433
            },
            "rightCorner": {
              "x": -10.447,
              "y": 28.609,
              "z": 1.433
            },
            "gtin": "4001638529372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20038",
            "leftCorner": {
              "x": -10.448,
              "y": 28.59,
              "z": 1.433
            },
            "rightCorner": {
              "x": -10.511,
              "y": 28.593,
              "z": 1.433
            },
            "gtin": "4025089086178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20039",
            "leftCorner": {
              "x": -10.511,
              "y": 28.596,
              "z": 1.433
            },
            "rightCorner": {
              "x": -10.553,
              "y": 28.597,
              "z": 1.433
            },
            "gtin": "4025089086185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2003a",
            "leftCorner": {
              "x": -10.552,
              "y": 28.607,
              "z": 1.433
            },
            "rightCorner": {
              "x": -10.6,
              "y": 28.609,
              "z": 1.433
            },
            "gtin": "4021457637447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2003b",
            "leftCorner": {
              "x": -10.598,
              "y": 28.626,
              "z": 1.433
            },
            "rightCorner": {
              "x": -10.653,
              "y": 28.628,
              "z": 1.433
            },
            "gtin": "4021457637447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2003c",
            "leftCorner": {
              "x": -10.653,
              "y": 28.617,
              "z": 1.433
            },
            "rightCorner": {
              "x": -10.715,
              "y": 28.62,
              "z": 1.433
            },
            "gtin": "4021457637485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2003d",
            "leftCorner": {
              "x": -10.715,
              "y": 28.618,
              "z": 1.433
            },
            "rightCorner": {
              "x": -10.786,
              "y": 28.622,
              "z": 1.433
            },
            "gtin": "4021457637454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2003e",
            "leftCorner": {
              "x": -10.786,
              "y": 28.622,
              "z": 1.433
            },
            "rightCorner": {
              "x": -10.856,
              "y": 28.625,
              "z": 1.433
            },
            "gtin": "4021457637454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2003f",
            "leftCorner": {
              "x": -10.857,
              "y": 28.606,
              "z": 1.433
            },
            "rightCorner": {
              "x": -10.935,
              "y": 28.61,
              "z": 1.433
            },
            "gtin": "4021457637461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20040",
            "leftCorner": {
              "x": -10.935,
              "y": 28.603,
              "z": 1.433
            },
            "rightCorner": {
              "x": -10.976,
              "y": 28.605,
              "z": 1.433
            },
            "gtin": "4008890006825",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d70",
    "rightNeighborShelfId": "a6d72"
  },
  {
    "id": "a6d72",
    "name": "a6d72",
    "x": -10.973,
    "y": 28.743,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99968,
      "w": 0.025148
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 107
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5466b9",
        "height": 1.3,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ba1",
            "leftCorner": {
              "x": -11.452,
              "y": 28.607,
              "z": 1.064
            },
            "rightCorner": {
              "x": -11.532,
              "y": 28.611,
              "z": 1.064
            },
            "gtin": "4005900967688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ba2",
            "leftCorner": {
              "x": -11.531,
              "y": 28.623,
              "z": 1.064
            },
            "rightCorner": {
              "x": -11.647,
              "y": 28.628,
              "z": 1.064
            },
            "gtin": "4005900980922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ba3",
            "leftCorner": {
              "x": -11.647,
              "y": 28.622,
              "z": 1.064
            },
            "rightCorner": {
              "x": -11.747,
              "y": 28.626,
              "z": 1.064
            },
            "gtin": "4006000098012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ba4",
            "leftCorner": {
              "x": -11.747,
              "y": 28.626,
              "z": 1.064
            },
            "rightCorner": {
              "x": -11.846,
              "y": 28.632,
              "z": 1.064
            },
            "gtin": "4006000098012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ba5",
            "leftCorner": {
              "x": -11.846,
              "y": 28.632,
              "z": 1.064
            },
            "rightCorner": {
              "x": -11.946,
              "y": 28.636,
              "z": 1.064
            },
            "gtin": "4006000098012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ba6",
            "leftCorner": {
              "x": -11.946,
              "y": 28.642,
              "z": 1.064
            },
            "rightCorner": {
              "x": -12.007,
              "y": 28.645,
              "z": 1.064
            },
            "gtin": "4337185694462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ba7",
            "leftCorner": {
              "x": -12.006,
              "y": 28.665,
              "z": 1.064
            },
            "rightCorner": {
              "x": -12.099,
              "y": 28.67,
              "z": 1.064
            },
            "gtin": "4069177000080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b6c",
            "leftCorner": {
              "x": -12.099,
              "y": 28.661,
              "z": 1.064
            },
            "rightCorner": {
              "x": -12.164,
              "y": 28.664,
              "z": 1.064
            },
            "gtin": "4063367424687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b6d",
            "leftCorner": {
              "x": -12.164,
              "y": 28.664,
              "z": 1.064
            },
            "rightCorner": {
              "x": -12.228,
              "y": 28.667,
              "z": 1.064
            },
            "gtin": "4063367424687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b9c",
            "leftCorner": {
              "x": -11.003,
              "y": 28.614,
              "z": 1.064
            },
            "rightCorner": {
              "x": -11.084,
              "y": 28.618,
              "z": 1.064
            },
            "gtin": "3600542397735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b9d",
            "leftCorner": {
              "x": -11.085,
              "y": 28.595,
              "z": 1.064
            },
            "rightCorner": {
              "x": -11.147,
              "y": 28.598,
              "z": 1.064
            },
            "gtin": "083078811174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b9e",
            "leftCorner": {
              "x": -11.147,
              "y": 28.599,
              "z": 1.064
            },
            "rightCorner": {
              "x": -11.236,
              "y": 28.603,
              "z": 1.064
            },
            "gtin": "4005900967626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b9f",
            "leftCorner": {
              "x": -11.236,
              "y": 28.601,
              "z": 1.064
            },
            "rightCorner": {
              "x": -11.342,
              "y": 28.606,
              "z": 1.064
            },
            "gtin": "4005900967657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ba0",
            "leftCorner": {
              "x": -11.342,
              "y": 28.612,
              "z": 1.064
            },
            "rightCorner": {
              "x": -11.45,
              "y": 28.617,
              "z": 1.064
            },
            "gtin": "4005900967565",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466ba",
        "height": 0.16649,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20cf3",
            "leftCorner": {
              "x": -11.885,
              "y": 28.741,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.917,
              "y": 28.742,
              "z": 0.136
            },
            "gtin": "4063367420047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cf4",
            "leftCorner": {
              "x": -11.917,
              "y": 28.742,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.948,
              "y": 28.745,
              "z": 0.136
            },
            "gtin": "4063367420047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cf5",
            "leftCorner": {
              "x": -11.948,
              "y": 28.76,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.02,
              "y": 28.763,
              "z": 0.136
            },
            "gtin": "4063367419867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cf6",
            "leftCorner": {
              "x": -12.02,
              "y": 28.755,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.071,
              "y": 28.758,
              "z": 0.136
            },
            "gtin": "4063367419669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cf7",
            "leftCorner": {
              "x": -12.072,
              "y": 28.742,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.129,
              "y": 28.745,
              "z": 0.136
            },
            "gtin": "4063367419706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cd9",
            "leftCorner": {
              "x": -12.128,
              "y": 28.769,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.176,
              "y": 28.771,
              "z": 0.136
            },
            "gtin": "4005900691774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cda",
            "leftCorner": {
              "x": -12.176,
              "y": 28.771,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.224,
              "y": 28.773,
              "z": 0.136
            },
            "gtin": "4005900691774",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466b7",
        "height": 0.49134,
        "facings": [
          {
            "id": "68300c895ed67a01d9a200a6",
            "leftCorner": {
              "x": -10.962,
              "y": 28.615,
              "z": 0.402
            },
            "rightCorner": {
              "x": -11.04,
              "y": 28.618,
              "z": 0.402
            },
            "gtin": "42360698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200a7",
            "leftCorner": {
              "x": -11.04,
              "y": 28.618,
              "z": 0.402
            },
            "rightCorner": {
              "x": -11.117,
              "y": 28.622,
              "z": 0.402
            },
            "gtin": "42360698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200a8",
            "leftCorner": {
              "x": -11.119,
              "y": 28.592,
              "z": 0.402
            },
            "rightCorner": {
              "x": -11.205,
              "y": 28.597,
              "z": 0.402
            },
            "gtin": "4005900481597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200a9",
            "leftCorner": {
              "x": -11.205,
              "y": 28.593,
              "z": 0.402
            },
            "rightCorner": {
              "x": -11.278,
              "y": 28.597,
              "z": 0.402
            },
            "gtin": "4005900599100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200aa",
            "leftCorner": {
              "x": -11.278,
              "y": 28.607,
              "z": 0.402
            },
            "rightCorner": {
              "x": -11.367,
              "y": 28.611,
              "z": 0.402
            },
            "gtin": "3600542520300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200ab",
            "leftCorner": {
              "x": -11.367,
              "y": 28.622,
              "z": 0.402
            },
            "rightCorner": {
              "x": -11.447,
              "y": 28.626,
              "z": 0.402
            },
            "gtin": "4006000139395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200ac",
            "leftCorner": {
              "x": -11.447,
              "y": 28.618,
              "z": 0.402
            },
            "rightCorner": {
              "x": -11.52,
              "y": 28.621,
              "z": 0.402
            },
            "gtin": "4005900868534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200ad",
            "leftCorner": {
              "x": -11.52,
              "y": 28.614,
              "z": 0.402
            },
            "rightCorner": {
              "x": -11.623,
              "y": 28.619,
              "z": 0.402
            },
            "gtin": "4006000130958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200ae",
            "leftCorner": {
              "x": -11.624,
              "y": 28.611,
              "z": 0.402
            },
            "rightCorner": {
              "x": -11.685,
              "y": 28.614,
              "z": 0.402
            },
            "gtin": "4006000130873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200af",
            "leftCorner": {
              "x": -11.685,
              "y": 28.614,
              "z": 0.402
            },
            "rightCorner": {
              "x": -11.745,
              "y": 28.617,
              "z": 0.402
            },
            "gtin": "4006000130873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200b0",
            "leftCorner": {
              "x": -11.745,
              "y": 28.631,
              "z": 0.402
            },
            "rightCorner": {
              "x": -11.783,
              "y": 28.634,
              "z": 0.402
            },
            "gtin": "4005809854027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200b1",
            "leftCorner": {
              "x": -11.783,
              "y": 28.643,
              "z": 0.402
            },
            "rightCorner": {
              "x": -11.857,
              "y": 28.646,
              "z": 0.402
            },
            "gtin": "4006000139487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200b2",
            "leftCorner": {
              "x": -11.858,
              "y": 28.633,
              "z": 0.402
            },
            "rightCorner": {
              "x": -11.93,
              "y": 28.637,
              "z": 0.402
            },
            "gtin": "4006000130750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200b3",
            "leftCorner": {
              "x": -11.93,
              "y": 28.642,
              "z": 0.402
            },
            "rightCorner": {
              "x": -11.98,
              "y": 28.645,
              "z": 0.402
            },
            "gtin": "42417941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200b4",
            "leftCorner": {
              "x": -11.98,
              "y": 28.65,
              "z": 0.402
            },
            "rightCorner": {
              "x": -12.056,
              "y": 28.653,
              "z": 0.402
            },
            "gtin": "4006000136264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200b5",
            "leftCorner": {
              "x": -12.056,
              "y": 28.662,
              "z": 0.402
            },
            "rightCorner": {
              "x": -12.104,
              "y": 28.665,
              "z": 0.402
            },
            "gtin": "4005900249401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200b6",
            "leftCorner": {
              "x": -12.104,
              "y": 28.663,
              "z": 0.402
            },
            "rightCorner": {
              "x": -12.174,
              "y": 28.666,
              "z": 0.402
            },
            "gtin": "4005900249401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2004d",
            "leftCorner": {
              "x": -12.174,
              "y": 28.664,
              "z": 0.402
            },
            "rightCorner": {
              "x": -12.228,
              "y": 28.667,
              "z": 0.402
            },
            "gtin": "4003583223107",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466b6",
        "height": 0.79277,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1ffa8",
            "leftCorner": {
              "x": -10.971,
              "y": 28.597,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.041,
              "y": 28.6,
              "z": 0.649
            },
            "gtin": "3600542450676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffa9",
            "leftCorner": {
              "x": -11.041,
              "y": 28.602,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.127,
              "y": 28.607,
              "z": 0.649
            },
            "gtin": "3600542452519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffaa",
            "leftCorner": {
              "x": -11.127,
              "y": 28.596,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.202,
              "y": 28.601,
              "z": 0.649
            },
            "gtin": "3600542298261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffab",
            "leftCorner": {
              "x": -11.203,
              "y": 28.583,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.267,
              "y": 28.586,
              "z": 0.649
            },
            "gtin": "3600540134318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffac",
            "leftCorner": {
              "x": -11.266,
              "y": 28.608,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.36,
              "y": 28.613,
              "z": 0.649
            },
            "gtin": "3600542222792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffad",
            "leftCorner": {
              "x": -11.361,
              "y": 28.594,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.443,
              "y": 28.599,
              "z": 0.649
            },
            "gtin": "4005900692030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffae",
            "leftCorner": {
              "x": -11.442,
              "y": 28.613,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.512,
              "y": 28.616,
              "z": 0.649
            },
            "gtin": "3600542298209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffaf",
            "leftCorner": {
              "x": -11.512,
              "y": 28.608,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.586,
              "y": 28.612,
              "z": 0.649
            },
            "gtin": "3600541992474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffb0",
            "leftCorner": {
              "x": -11.585,
              "y": 28.624,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.648,
              "y": 28.627,
              "z": 0.649
            },
            "gtin": "4003583223312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffb1",
            "leftCorner": {
              "x": -11.648,
              "y": 28.627,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.693,
              "y": 28.629,
              "z": 0.649
            },
            "gtin": "4006000128221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffb2",
            "leftCorner": {
              "x": -11.693,
              "y": 28.628,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.782,
              "y": 28.634,
              "z": 0.649
            },
            "gtin": "42417941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffb3",
            "leftCorner": {
              "x": -11.782,
              "y": 28.634,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.872,
              "y": 28.638,
              "z": 0.649
            },
            "gtin": "42417941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffb4",
            "leftCorner": {
              "x": -11.87,
              "y": 28.656,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.996,
              "y": 28.662,
              "z": 0.649
            },
            "gtin": "4005900475626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffb5",
            "leftCorner": {
              "x": -11.997,
              "y": 28.651,
              "z": 0.649
            },
            "rightCorner": {
              "x": -12.045,
              "y": 28.654,
              "z": 0.649
            },
            "gtin": "4005900599100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffb6",
            "leftCorner": {
              "x": -12.045,
              "y": 28.654,
              "z": 0.649
            },
            "rightCorner": {
              "x": -12.094,
              "y": 28.656,
              "z": 0.649
            },
            "gtin": "4005900599100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffb7",
            "leftCorner": {
              "x": -12.094,
              "y": 28.665,
              "z": 0.649
            },
            "rightCorner": {
              "x": -12.159,
              "y": 28.668,
              "z": 0.649
            },
            "gtin": "3600542520416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ff4c",
            "leftCorner": {
              "x": -12.159,
              "y": 28.656,
              "z": 0.649
            },
            "rightCorner": {
              "x": -12.229,
              "y": 28.659,
              "z": 0.649
            },
            "gtin": "3600542520249",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466b4",
        "height": 1.0594,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20cc4",
            "leftCorner": {
              "x": -10.939,
              "y": 28.614,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.021,
              "y": 28.618,
              "z": 0.867
            },
            "gtin": "4005900870407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cc5",
            "leftCorner": {
              "x": -11.022,
              "y": 28.601,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.096,
              "y": 28.604,
              "z": 0.867
            },
            "gtin": "3600542572729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cc6",
            "leftCorner": {
              "x": -11.095,
              "y": 28.605,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.148,
              "y": 28.607,
              "z": 0.867
            },
            "gtin": "3600540569158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cc7",
            "leftCorner": {
              "x": -11.148,
              "y": 28.607,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.203,
              "y": 28.61,
              "z": 0.867
            },
            "gtin": "4021457657018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cc8",
            "leftCorner": {
              "x": -11.203,
              "y": 28.61,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.258,
              "y": 28.613,
              "z": 0.867
            },
            "gtin": "4021457657018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cc9",
            "leftCorner": {
              "x": -11.258,
              "y": 28.601,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.324,
              "y": 28.604,
              "z": 0.867
            },
            "gtin": "4021457657001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cca",
            "leftCorner": {
              "x": -11.324,
              "y": 28.61,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.381,
              "y": 28.613,
              "z": 0.867
            },
            "gtin": "4021457656998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ccb",
            "leftCorner": {
              "x": -11.381,
              "y": 28.604,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.44,
              "y": 28.607,
              "z": 0.867
            },
            "gtin": "4021457657032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ccc",
            "leftCorner": {
              "x": -11.439,
              "y": 28.613,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.493,
              "y": 28.616,
              "z": 0.867
            },
            "gtin": "5099821001858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ccd",
            "leftCorner": {
              "x": -11.493,
              "y": 28.621,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.57,
              "y": 28.625,
              "z": 0.867
            },
            "gtin": "5099821001070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cce",
            "leftCorner": {
              "x": -11.57,
              "y": 28.626,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.653,
              "y": 28.63,
              "z": 0.867
            },
            "gtin": "5099821001230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ccf",
            "leftCorner": {
              "x": -11.654,
              "y": 28.613,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.714,
              "y": 28.616,
              "z": 0.867
            },
            "gtin": "5099821001834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cd0",
            "leftCorner": {
              "x": -11.714,
              "y": 28.623,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.802,
              "y": 28.627,
              "z": 0.867
            },
            "gtin": "3600540362025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cd1",
            "leftCorner": {
              "x": -11.802,
              "y": 28.643,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.863,
              "y": 28.646,
              "z": 0.867
            },
            "gtin": "3600542297790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cd2",
            "leftCorner": {
              "x": -11.863,
              "y": 28.641,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.924,
              "y": 28.644,
              "z": 0.867
            },
            "gtin": "3600540134387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cd3",
            "leftCorner": {
              "x": -11.924,
              "y": 28.65,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.979,
              "y": 28.653,
              "z": 0.867
            },
            "gtin": "3600542624909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cd4",
            "leftCorner": {
              "x": -11.979,
              "y": 28.653,
              "z": 0.867
            },
            "rightCorner": {
              "x": -12.035,
              "y": 28.656,
              "z": 0.867
            },
            "gtin": "3600542624909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cd5",
            "leftCorner": {
              "x": -12.035,
              "y": 28.656,
              "z": 0.867
            },
            "rightCorner": {
              "x": -12.091,
              "y": 28.658,
              "z": 0.867
            },
            "gtin": "3600542624909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cd6",
            "leftCorner": {
              "x": -12.091,
              "y": 28.672,
              "z": 0.867
            },
            "rightCorner": {
              "x": -12.163,
              "y": 28.675,
              "z": 0.867
            },
            "gtin": "3600542624664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ca5",
            "leftCorner": {
              "x": -12.164,
              "y": 28.669,
              "z": 0.867
            },
            "rightCorner": {
              "x": -12.228,
              "y": 28.672,
              "z": 0.867
            },
            "gtin": "4003583223305",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466b5",
        "height": 1.5517,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20109",
            "leftCorner": {
              "x": -10.993,
              "y": 28.612,
              "z": 1.27
            },
            "rightCorner": {
              "x": -11.084,
              "y": 28.616,
              "z": 1.27
            },
            "gtin": "4059186101489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2010a",
            "leftCorner": {
              "x": -11.084,
              "y": 28.597,
              "z": 1.27
            },
            "rightCorner": {
              "x": -11.14,
              "y": 28.6,
              "z": 1.27
            },
            "gtin": "4059186101472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2010b",
            "leftCorner": {
              "x": -11.14,
              "y": 28.6,
              "z": 1.27
            },
            "rightCorner": {
              "x": -11.197,
              "y": 28.603,
              "z": 1.27
            },
            "gtin": "4059186101472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2010c",
            "leftCorner": {
              "x": -11.197,
              "y": 28.599,
              "z": 1.27
            },
            "rightCorner": {
              "x": -11.272,
              "y": 28.602,
              "z": 1.27
            },
            "gtin": "4059186101120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2010d",
            "leftCorner": {
              "x": -11.271,
              "y": 28.61,
              "z": 1.27
            },
            "rightCorner": {
              "x": -11.338,
              "y": 28.614,
              "z": 1.27
            },
            "gtin": "4059186101663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2010e",
            "leftCorner": {
              "x": -11.338,
              "y": 28.618,
              "z": 1.27
            },
            "rightCorner": {
              "x": -11.448,
              "y": 28.623,
              "z": 1.27
            },
            "gtin": "4051424600136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2010f",
            "leftCorner": {
              "x": -11.449,
              "y": 28.606,
              "z": 1.27
            },
            "rightCorner": {
              "x": -11.507,
              "y": 28.609,
              "z": 1.27
            },
            "gtin": "3574661663555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20110",
            "leftCorner": {
              "x": -11.507,
              "y": 28.609,
              "z": 1.27
            },
            "rightCorner": {
              "x": -11.564,
              "y": 28.611,
              "z": 1.27
            },
            "gtin": "3574661663555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20111",
            "leftCorner": {
              "x": -11.564,
              "y": 28.617,
              "z": 1.27
            },
            "rightCorner": {
              "x": -11.618,
              "y": 28.62,
              "z": 1.27
            },
            "gtin": "3574661664880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20112",
            "leftCorner": {
              "x": -11.618,
              "y": 28.62,
              "z": 1.27
            },
            "rightCorner": {
              "x": -11.672,
              "y": 28.623,
              "z": 1.27
            },
            "gtin": "3574661664880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20113",
            "leftCorner": {
              "x": -11.672,
              "y": 28.625,
              "z": 1.27
            },
            "rightCorner": {
              "x": -11.786,
              "y": 28.631,
              "z": 1.27
            },
            "gtin": "3574661664859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20114",
            "leftCorner": {
              "x": -11.785,
              "y": 28.638,
              "z": 1.27
            },
            "rightCorner": {
              "x": -11.83,
              "y": 28.64,
              "z": 1.27
            },
            "gtin": "3574661664866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20115",
            "leftCorner": {
              "x": -11.83,
              "y": 28.64,
              "z": 1.27
            },
            "rightCorner": {
              "x": -11.875,
              "y": 28.643,
              "z": 1.27
            },
            "gtin": "3574661664866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20116",
            "leftCorner": {
              "x": -11.875,
              "y": 28.643,
              "z": 1.27
            },
            "rightCorner": {
              "x": -11.92,
              "y": 28.644,
              "z": 1.27
            },
            "gtin": "3574661664866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20117",
            "leftCorner": {
              "x": -11.918,
              "y": 28.652,
              "z": 1.27
            },
            "rightCorner": {
              "x": -12.002,
              "y": 28.656,
              "z": 1.27
            },
            "gtin": "3574660085563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20118",
            "leftCorner": {
              "x": -12.002,
              "y": 28.655,
              "z": 1.27
            },
            "rightCorner": {
              "x": -12.088,
              "y": 28.659,
              "z": 1.27
            },
            "gtin": "4021457655977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200b8",
            "leftCorner": {
              "x": -12.088,
              "y": 28.651,
              "z": 1.27
            },
            "rightCorner": {
              "x": -12.159,
              "y": 28.655,
              "z": 1.27
            },
            "gtin": "4063367161490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a200b9",
            "leftCorner": {
              "x": -12.159,
              "y": 28.655,
              "z": 1.27
            },
            "rightCorner": {
              "x": -12.229,
              "y": 28.658,
              "z": 1.27
            },
            "gtin": "4063367161490",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466b8",
        "height": 1.7497,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20041",
            "leftCorner": {
              "x": -10.977,
              "y": 28.594,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.098,
              "y": 28.6,
              "z": 1.432
            },
            "gtin": "4008890005385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20042",
            "leftCorner": {
              "x": -11.098,
              "y": 28.606,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.206,
              "y": 28.612,
              "z": 1.432
            },
            "gtin": "083078811143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20043",
            "leftCorner": {
              "x": -11.206,
              "y": 28.599,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.32,
              "y": 28.604,
              "z": 1.432
            },
            "gtin": "4021457655991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20044",
            "leftCorner": {
              "x": -11.319,
              "y": 28.613,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.387,
              "y": 28.616,
              "z": 1.432
            },
            "gtin": "4001638088381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20045",
            "leftCorner": {
              "x": -11.387,
              "y": 28.623,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.501,
              "y": 28.629,
              "z": 1.432
            },
            "gtin": "4008455036717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20046",
            "leftCorner": {
              "x": -11.5,
              "y": 28.639,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.576,
              "y": 28.643,
              "z": 1.432
            },
            "gtin": "4008455003030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20047",
            "leftCorner": {
              "x": -11.576,
              "y": 28.643,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.651,
              "y": 28.647,
              "z": 1.432
            },
            "gtin": "4008455003030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20048",
            "leftCorner": {
              "x": -11.651,
              "y": 28.631,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.745,
              "y": 28.636,
              "z": 1.432
            },
            "gtin": "4008455013510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20049",
            "leftCorner": {
              "x": -11.745,
              "y": 28.633,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.868,
              "y": 28.64,
              "z": 1.432
            },
            "gtin": "4008455061818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2004a",
            "leftCorner": {
              "x": -11.868,
              "y": 28.64,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.991,
              "y": 28.646,
              "z": 1.432
            },
            "gtin": "4008455061818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2004b",
            "leftCorner": {
              "x": -11.991,
              "y": 28.651,
              "z": 1.432
            },
            "rightCorner": {
              "x": -12.071,
              "y": 28.655,
              "z": 1.432
            },
            "gtin": "852598003235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2004c",
            "leftCorner": {
              "x": -12.071,
              "y": 28.656,
              "z": 1.432
            },
            "rightCorner": {
              "x": -12.133,
              "y": 28.659,
              "z": 1.432
            },
            "gtin": "852598003587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1ffeb",
            "leftCorner": {
              "x": -12.133,
              "y": 28.663,
              "z": 1.432
            },
            "rightCorner": {
              "x": -12.228,
              "y": 28.668,
              "z": 1.432
            },
            "gtin": "852598003563",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d71"
  },
  {
    "id": "a6d73",
    "name": "a6d73",
    "x": -10.994,
    "y": 27.639,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.030163,
      "w": 0.99954
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 30,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546692",
        "height": 0.14378,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e63f",
            "leftCorner": {
              "x": -10.459,
              "y": 27.672,
              "z": 0.118
            },
            "rightCorner": {
              "x": -10.241,
              "y": 27.659,
              "z": 0.118
            },
            "gtin": "4337185635403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e640",
            "leftCorner": {
              "x": -10.241,
              "y": 27.648,
              "z": 0.118
            },
            "rightCorner": {
              "x": -9.99,
              "y": 27.633,
              "z": 0.118
            },
            "gtin": "4337185635335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e641",
            "leftCorner": {
              "x": -9.99,
              "y": 27.633,
              "z": 0.118
            },
            "rightCorner": {
              "x": -9.738,
              "y": 27.618,
              "z": 0.118
            },
            "gtin": "4337185635335",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54668f",
        "height": 0.54178,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e612",
            "leftCorner": {
              "x": -10.993,
              "y": 27.65,
              "z": 0.443
            },
            "rightCorner": {
              "x": -10.754,
              "y": 27.635,
              "z": 0.443
            },
            "gtin": "8714789952581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e613",
            "leftCorner": {
              "x": -10.754,
              "y": 27.635,
              "z": 0.443
            },
            "rightCorner": {
              "x": -10.516,
              "y": 27.622,
              "z": 0.443
            },
            "gtin": "8714789952581",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54668e",
        "height": 0.94728,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e5a5",
            "leftCorner": {
              "x": -10.976,
              "y": 27.692,
              "z": 0.775
            },
            "rightCorner": {
              "x": -10.853,
              "y": 27.685,
              "z": 0.775
            },
            "gtin": "8714789952543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5a6",
            "leftCorner": {
              "x": -10.853,
              "y": 27.685,
              "z": 0.775
            },
            "rightCorner": {
              "x": -10.73,
              "y": 27.677,
              "z": 0.775
            },
            "gtin": "8714789952543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5a7",
            "leftCorner": {
              "x": -10.73,
              "y": 27.677,
              "z": 0.775
            },
            "rightCorner": {
              "x": -10.607,
              "y": 27.67,
              "z": 0.775
            },
            "gtin": "8714789952543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5a8",
            "leftCorner": {
              "x": -10.607,
              "y": 27.672,
              "z": 0.775
            },
            "rightCorner": {
              "x": -10.468,
              "y": 27.664,
              "z": 0.775
            },
            "gtin": "8718951324640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5a9",
            "leftCorner": {
              "x": -10.468,
              "y": 27.664,
              "z": 0.775
            },
            "rightCorner": {
              "x": -10.327,
              "y": 27.656,
              "z": 0.775
            },
            "gtin": "8718951324640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5aa",
            "leftCorner": {
              "x": -10.327,
              "y": 27.656,
              "z": 0.775
            },
            "rightCorner": {
              "x": -10.187,
              "y": 27.647,
              "z": 0.775
            },
            "gtin": "8718951324640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5ab",
            "leftCorner": {
              "x": -10.188,
              "y": 27.636,
              "z": 0.775
            },
            "rightCorner": {
              "x": -9.79,
              "y": 27.612,
              "z": 0.775
            },
            "gtin": "4015200035369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5ac",
            "leftCorner": {
              "x": -9.79,
              "y": 27.612,
              "z": 0.775
            },
            "rightCorner": {
              "x": -9.392,
              "y": 27.588,
              "z": 0.775
            },
            "gtin": "4015200035369",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546690",
        "height": 1.3579,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e77a",
            "leftCorner": {
              "x": -11.012,
              "y": 27.688,
              "z": 1.111
            },
            "rightCorner": {
              "x": -10.853,
              "y": 27.678,
              "z": 1.111
            },
            "gtin": "4001499961519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e77b",
            "leftCorner": {
              "x": -10.853,
              "y": 27.674,
              "z": 1.111
            },
            "rightCorner": {
              "x": -10.769,
              "y": 27.669,
              "z": 1.111
            },
            "gtin": "4001499960178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e77c",
            "leftCorner": {
              "x": -10.769,
              "y": 27.669,
              "z": 1.111
            },
            "rightCorner": {
              "x": -10.685,
              "y": 27.664,
              "z": 1.111
            },
            "gtin": "4001499960178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e77d",
            "leftCorner": {
              "x": -10.684,
              "y": 27.674,
              "z": 1.111
            },
            "rightCorner": {
              "x": -10.589,
              "y": 27.668,
              "z": 1.111
            },
            "gtin": "4001499960161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e77e",
            "leftCorner": {
              "x": -10.589,
              "y": 27.668,
              "z": 1.111
            },
            "rightCorner": {
              "x": -10.492,
              "y": 27.662,
              "z": 1.111
            },
            "gtin": "4001499960161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e77f",
            "leftCorner": {
              "x": -10.493,
              "y": 27.66,
              "z": 1.111
            },
            "rightCorner": {
              "x": -10.348,
              "y": 27.652,
              "z": 1.111
            },
            "gtin": "4001499192791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e780",
            "leftCorner": {
              "x": -10.348,
              "y": 27.652,
              "z": 1.111
            },
            "rightCorner": {
              "x": -10.204,
              "y": 27.642,
              "z": 1.111
            },
            "gtin": "4001499192791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e781",
            "leftCorner": {
              "x": -10.204,
              "y": 27.643,
              "z": 1.111
            },
            "rightCorner": {
              "x": -10.038,
              "y": 27.634,
              "z": 1.111
            },
            "gtin": "8700216624688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e782",
            "leftCorner": {
              "x": -10.038,
              "y": 27.634,
              "z": 1.111
            },
            "rightCorner": {
              "x": -9.874,
              "y": 27.624,
              "z": 1.111
            },
            "gtin": "8700216624688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e783",
            "leftCorner": {
              "x": -9.874,
              "y": 27.624,
              "z": 1.111
            },
            "rightCorner": {
              "x": -9.709,
              "y": 27.614,
              "z": 1.111
            },
            "gtin": "8700216624688",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546691",
        "height": 1.7424,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e5e0",
            "leftCorner": {
              "x": -10.984,
              "y": 27.683,
              "z": 1.426
            },
            "rightCorner": {
              "x": -10.661,
              "y": 27.663,
              "z": 1.426
            },
            "gtin": "4251758405807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5e1",
            "leftCorner": {
              "x": -10.66,
              "y": 27.676,
              "z": 1.426
            },
            "rightCorner": {
              "x": -10.462,
              "y": 27.665,
              "z": 1.426
            },
            "gtin": "4251758404619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5e2",
            "leftCorner": {
              "x": -10.462,
              "y": 27.665,
              "z": 1.426
            },
            "rightCorner": {
              "x": -10.263,
              "y": 27.653,
              "z": 1.426
            },
            "gtin": "4251758404619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5e3",
            "leftCorner": {
              "x": -10.264,
              "y": 27.64,
              "z": 1.426
            },
            "rightCorner": {
              "x": -10.145,
              "y": 27.632,
              "z": 1.426
            },
            "gtin": "4002448033943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5e4",
            "leftCorner": {
              "x": -10.145,
              "y": 27.632,
              "z": 1.426
            },
            "rightCorner": {
              "x": -10.025,
              "y": 27.626,
              "z": 1.426
            },
            "gtin": "4002448033943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5e5",
            "leftCorner": {
              "x": -10.025,
              "y": 27.63,
              "z": 1.426
            },
            "rightCorner": {
              "x": -9.865,
              "y": 27.621,
              "z": 1.426
            },
            "gtin": "8714789246871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5e6",
            "leftCorner": {
              "x": -9.865,
              "y": 27.621,
              "z": 1.426
            },
            "rightCorner": {
              "x": -9.706,
              "y": 27.611,
              "z": 1.426
            },
            "gtin": "8714789246871",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d13c4",
    "rightNeighborShelfId": "a6d74"
  },
  {
    "id": "a6d74",
    "name": "a6d74",
    "x": -9.746,
    "y": 27.564,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.030163,
      "w": 0.99954
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 27,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463d9",
        "height": 0.14028,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e642",
            "leftCorner": {
              "x": -9.738,
              "y": 27.61,
              "z": 0.115
            },
            "rightCorner": {
              "x": -9.65,
              "y": 27.605,
              "z": 0.115
            },
            "gtin": "4001499139796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e643",
            "leftCorner": {
              "x": -9.65,
              "y": 27.605,
              "z": 0.115
            },
            "rightCorner": {
              "x": -9.561,
              "y": 27.599,
              "z": 0.115
            },
            "gtin": "4001499139796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e644",
            "leftCorner": {
              "x": -9.561,
              "y": 27.6,
              "z": 0.115
            },
            "rightCorner": {
              "x": -9.44,
              "y": 27.592,
              "z": 0.115
            },
            "gtin": "4001499957611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e645",
            "leftCorner": {
              "x": -9.44,
              "y": 27.592,
              "z": 0.115
            },
            "rightCorner": {
              "x": -9.317,
              "y": 27.585,
              "z": 0.115
            },
            "gtin": "4001499957611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e646",
            "leftCorner": {
              "x": -9.317,
              "y": 27.585,
              "z": 0.115
            },
            "rightCorner": {
              "x": -9.194,
              "y": 27.578,
              "z": 0.115
            },
            "gtin": "4001499957611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e647",
            "leftCorner": {
              "x": -9.194,
              "y": 27.58,
              "z": 0.115
            },
            "rightCorner": {
              "x": -8.948,
              "y": 27.565,
              "z": 0.115
            },
            "gtin": "4015000010320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e648",
            "leftCorner": {
              "x": -8.948,
              "y": 27.565,
              "z": 0.115
            },
            "rightCorner": {
              "x": -8.7,
              "y": 27.551,
              "z": 0.115
            },
            "gtin": "4015000010320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e649",
            "leftCorner": {
              "x": -8.7,
              "y": 27.551,
              "z": 0.115
            },
            "rightCorner": {
              "x": -8.453,
              "y": 27.535,
              "z": 0.115
            },
            "gtin": "4015000010320",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463db",
        "height": 0.54127,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e615",
            "leftCorner": {
              "x": -9.092,
              "y": 27.57,
              "z": 0.443
            },
            "rightCorner": {
              "x": -8.924,
              "y": 27.559,
              "z": 0.443
            },
            "gtin": "8720181239915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e616",
            "leftCorner": {
              "x": -8.925,
              "y": 27.55,
              "z": 0.443
            },
            "rightCorner": {
              "x": -8.476,
              "y": 27.523,
              "z": 0.443
            },
            "gtin": "8720181239908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e617",
            "leftCorner": {
              "x": -8.476,
              "y": 27.523,
              "z": 0.443
            },
            "rightCorner": {
              "x": -8.027,
              "y": 27.496,
              "z": 0.443
            },
            "gtin": "8720181239908",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463da",
        "height": 0.94161,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e5ad",
            "leftCorner": {
              "x": -9.392,
              "y": 27.584,
              "z": 0.77
            },
            "rightCorner": {
              "x": -9.207,
              "y": 27.573,
              "z": 0.77
            },
            "gtin": "4015200035352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5ae",
            "leftCorner": {
              "x": -9.207,
              "y": 27.573,
              "z": 0.77
            },
            "rightCorner": {
              "x": -9.021,
              "y": 27.561,
              "z": 0.77
            },
            "gtin": "4015200035352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5af",
            "leftCorner": {
              "x": -9.021,
              "y": 27.561,
              "z": 0.77
            },
            "rightCorner": {
              "x": -8.836,
              "y": 27.55,
              "z": 0.77
            },
            "gtin": "4015200035352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5b0",
            "leftCorner": {
              "x": -8.835,
              "y": 27.566,
              "z": 0.77
            },
            "rightCorner": {
              "x": -8.457,
              "y": 27.543,
              "z": 0.77
            },
            "gtin": "4251758404459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5b1",
            "leftCorner": {
              "x": -8.457,
              "y": 27.543,
              "z": 0.77
            },
            "rightCorner": {
              "x": -8.078,
              "y": 27.52,
              "z": 0.77
            },
            "gtin": "4251758404459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5b2",
            "leftCorner": {
              "x": -8.078,
              "y": 27.52,
              "z": 0.77
            },
            "rightCorner": {
              "x": -7.699,
              "y": 27.498,
              "z": 0.77
            },
            "gtin": "4251758404459",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463d7",
        "height": 1.3557,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e784",
            "leftCorner": {
              "x": -9.709,
              "y": 27.608,
              "z": 1.109
            },
            "rightCorner": {
              "x": -9.504,
              "y": 27.595,
              "z": 1.109
            },
            "gtin": "8700216624718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e785",
            "leftCorner": {
              "x": -9.504,
              "y": 27.595,
              "z": 1.109
            },
            "rightCorner": {
              "x": -9.299,
              "y": 27.583,
              "z": 1.109
            },
            "gtin": "8700216624718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e786",
            "leftCorner": {
              "x": -9.299,
              "y": 27.583,
              "z": 1.109
            },
            "rightCorner": {
              "x": -9.096,
              "y": 27.57,
              "z": 1.109
            },
            "gtin": "8700216624718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e787",
            "leftCorner": {
              "x": -9.095,
              "y": 27.573,
              "z": 1.109
            },
            "rightCorner": {
              "x": -8.786,
              "y": 27.554,
              "z": 1.109
            },
            "gtin": "8700216661584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e788",
            "leftCorner": {
              "x": -8.786,
              "y": 27.554,
              "z": 1.109
            },
            "rightCorner": {
              "x": -8.476,
              "y": 27.535,
              "z": 1.109
            },
            "gtin": "8700216661584",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463d8",
        "height": 1.7438,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e5e7",
            "leftCorner": {
              "x": -9.705,
              "y": 27.612,
              "z": 1.427
            },
            "rightCorner": {
              "x": -9.395,
              "y": 27.593,
              "z": 1.427
            },
            "gtin": "4063367396908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5e8",
            "leftCorner": {
              "x": -9.395,
              "y": 27.593,
              "z": 1.427
            },
            "rightCorner": {
              "x": -9.085,
              "y": 27.574,
              "z": 1.427
            },
            "gtin": "4063367396908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5e9",
            "leftCorner": {
              "x": -9.085,
              "y": 27.574,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.925,
              "y": 27.564,
              "z": 1.427
            },
            "gtin": "4337185511974",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c865ed67a01d9a1e5ea",
            "leftCorner": {
              "x": -8.925,
              "y": 27.563,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.754,
              "y": 27.552,
              "z": 1.427
            },
            "gtin": "8720182777171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5eb",
            "leftCorner": {
              "x": -8.754,
              "y": 27.552,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.583,
              "y": 27.542,
              "z": 1.427
            },
            "gtin": "8720182777171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5ec",
            "leftCorner": {
              "x": -8.583,
              "y": 27.542,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.412,
              "y": 27.532,
              "z": 1.427
            },
            "gtin": "8720182777171",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d73",
    "rightNeighborShelfId": "a6d75"
  },
  {
    "id": "a6d75",
    "name": "a6d75",
    "x": -8.498,
    "y": 27.489,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.030163,
      "w": 0.99954
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 26,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463b3",
        "height": 0.14454,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e64a",
            "leftCorner": {
              "x": -8.454,
              "y": 27.533,
              "z": 0.118
            },
            "rightCorner": {
              "x": -8.237,
              "y": 27.52,
              "z": 0.118
            },
            "gtin": "4015000970921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e64b",
            "leftCorner": {
              "x": -8.237,
              "y": 27.52,
              "z": 0.118
            },
            "rightCorner": {
              "x": -8.021,
              "y": 27.507,
              "z": 0.118
            },
            "gtin": "4015000970921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e64c",
            "leftCorner": {
              "x": -8.021,
              "y": 27.507,
              "z": 0.118
            },
            "rightCorner": {
              "x": -7.805,
              "y": 27.493,
              "z": 0.118
            },
            "gtin": "4015000970921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e64d",
            "leftCorner": {
              "x": -7.804,
              "y": 27.503,
              "z": 0.118
            },
            "rightCorner": {
              "x": -7.544,
              "y": 27.488,
              "z": 0.118
            },
            "gtin": "8714789929415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e64e",
            "leftCorner": {
              "x": -7.544,
              "y": 27.488,
              "z": 0.118
            },
            "rightCorner": {
              "x": -7.284,
              "y": 27.472,
              "z": 0.118
            },
            "gtin": "8714789929415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e64f",
            "leftCorner": {
              "x": -7.284,
              "y": 27.472,
              "z": 0.118
            },
            "rightCorner": {
              "x": -7.024,
              "y": 27.456,
              "z": 0.118
            },
            "gtin": "8714789929415",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463b4",
        "height": 0.54541,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e618",
            "leftCorner": {
              "x": -8.026,
              "y": 27.512,
              "z": 0.446
            },
            "rightCorner": {
              "x": -7.88,
              "y": 27.504,
              "z": 0.446
            },
            "gtin": "4015000971157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e619",
            "leftCorner": {
              "x": -7.88,
              "y": 27.504,
              "z": 0.446
            },
            "rightCorner": {
              "x": -7.733,
              "y": 27.495,
              "z": 0.446
            },
            "gtin": "4015000971157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e61a",
            "leftCorner": {
              "x": -7.733,
              "y": 27.495,
              "z": 0.446
            },
            "rightCorner": {
              "x": -7.587,
              "y": 27.487,
              "z": 0.446
            },
            "gtin": "4015000971157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e61b",
            "leftCorner": {
              "x": -7.588,
              "y": 27.471,
              "z": 0.446
            },
            "rightCorner": {
              "x": -7.379,
              "y": 27.457,
              "z": 0.446
            },
            "gtin": "8700216710633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e61c",
            "leftCorner": {
              "x": -7.378,
              "y": 27.468,
              "z": 0.446
            },
            "rightCorner": {
              "x": -7.266,
              "y": 27.461,
              "z": 0.446
            },
            "gtin": "8006540171110",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463b5",
        "height": 0.94519,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e5b3",
            "leftCorner": {
              "x": -7.7,
              "y": 27.493,
              "z": 0.773
            },
            "rightCorner": {
              "x": -7.574,
              "y": 27.486,
              "z": 0.773
            },
            "gtin": "4015000969741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5b4",
            "leftCorner": {
              "x": -7.574,
              "y": 27.473,
              "z": 0.773
            },
            "rightCorner": {
              "x": -7.237,
              "y": 27.453,
              "z": 0.773
            },
            "gtin": "4001499961540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5b5",
            "leftCorner": {
              "x": -7.237,
              "y": 27.453,
              "z": 0.773
            },
            "rightCorner": {
              "x": -6.901,
              "y": 27.432,
              "z": 0.773
            },
            "gtin": "4001499961540",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463b1",
        "height": 1.3515,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e789",
            "leftCorner": {
              "x": -8.476,
              "y": 27.531,
              "z": 1.106
            },
            "rightCorner": {
              "x": -8.228,
              "y": 27.516,
              "z": 1.106
            },
            "gtin": "8700216710671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e78a",
            "leftCorner": {
              "x": -8.227,
              "y": 27.524,
              "z": 1.106
            },
            "rightCorner": {
              "x": -8.099,
              "y": 27.516,
              "z": 1.106
            },
            "gtin": "8700216663892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e78b",
            "leftCorner": {
              "x": -8.099,
              "y": 27.516,
              "z": 1.106
            },
            "rightCorner": {
              "x": -7.972,
              "y": 27.508,
              "z": 1.106
            },
            "gtin": "8700216663892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e78c",
            "leftCorner": {
              "x": -7.972,
              "y": 27.509,
              "z": 1.106
            },
            "rightCorner": {
              "x": -7.737,
              "y": 27.494,
              "z": 1.106
            },
            "gtin": "8700216663762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e773",
            "leftCorner": {
              "x": -7.737,
              "y": 27.485,
              "z": 1.106
            },
            "rightCorner": {
              "x": -7.493,
              "y": 27.47,
              "z": 1.106
            },
            "gtin": "8700216663854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e774",
            "leftCorner": {
              "x": -7.493,
              "y": 27.47,
              "z": 1.106
            },
            "rightCorner": {
              "x": -7.248,
              "y": 27.456,
              "z": 1.106
            },
            "gtin": "8700216663854",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463b2",
        "height": 1.7485,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e5ed",
            "leftCorner": {
              "x": -8.412,
              "y": 27.537,
              "z": 1.431
            },
            "rightCorner": {
              "x": -8.161,
              "y": 27.521,
              "z": 1.431
            },
            "gtin": "8720182315182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5ee",
            "leftCorner": {
              "x": -8.161,
              "y": 27.521,
              "z": 1.431
            },
            "rightCorner": {
              "x": -7.91,
              "y": 27.506,
              "z": 1.431
            },
            "gtin": "8720182315182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5ef",
            "leftCorner": {
              "x": -7.91,
              "y": 27.506,
              "z": 1.431
            },
            "rightCorner": {
              "x": -7.659,
              "y": 27.491,
              "z": 1.431
            },
            "gtin": "8720182315182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5f0",
            "leftCorner": {
              "x": -7.659,
              "y": 27.487,
              "z": 1.431
            },
            "rightCorner": {
              "x": -7.538,
              "y": 27.48,
              "z": 1.431
            },
            "gtin": "8720182302526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5f1",
            "leftCorner": {
              "x": -7.538,
              "y": 27.48,
              "z": 1.431
            },
            "rightCorner": {
              "x": -7.417,
              "y": 27.472,
              "z": 1.431
            },
            "gtin": "8720182302526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5f2",
            "leftCorner": {
              "x": -7.417,
              "y": 27.475,
              "z": 1.431
            },
            "rightCorner": {
              "x": -7.209,
              "y": 27.463,
              "z": 1.431
            },
            "gtin": "5000204147018",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d74",
    "rightNeighborShelfId": "a6d76"
  },
  {
    "id": "a6d76",
    "name": "a6d76",
    "x": -7.251,
    "y": 27.413,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.030163,
      "w": 0.99954
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 43,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5466c9",
        "height": 0.14634,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e650",
            "leftCorner": {
              "x": -7.026,
              "y": 27.444,
              "z": 0.12
            },
            "rightCorner": {
              "x": -6.88,
              "y": 27.435,
              "z": 0.12
            },
            "gtin": "4337185555473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e651",
            "leftCorner": {
              "x": -6.88,
              "y": 27.435,
              "z": 0.12
            },
            "rightCorner": {
              "x": -6.733,
              "y": 27.426,
              "z": 0.12
            },
            "gtin": "4337185555473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e652",
            "leftCorner": {
              "x": -6.733,
              "y": 27.426,
              "z": 0.12
            },
            "rightCorner": {
              "x": -6.587,
              "y": 27.417,
              "z": 0.12
            },
            "gtin": "4337185555473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e653",
            "leftCorner": {
              "x": -6.587,
              "y": 27.419,
              "z": 0.12
            },
            "rightCorner": {
              "x": -6.49,
              "y": 27.412,
              "z": 0.12
            },
            "gtin": "4337185627637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e654",
            "leftCorner": {
              "x": -6.49,
              "y": 27.412,
              "z": 0.12
            },
            "rightCorner": {
              "x": -6.392,
              "y": 27.407,
              "z": 0.12
            },
            "gtin": "4337185627637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e655",
            "leftCorner": {
              "x": -6.392,
              "y": 27.407,
              "z": 0.12
            },
            "rightCorner": {
              "x": -6.294,
              "y": 27.401,
              "z": 0.12
            },
            "gtin": "4337185627637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e656",
            "leftCorner": {
              "x": -6.294,
              "y": 27.401,
              "z": 0.12
            },
            "rightCorner": {
              "x": -6.197,
              "y": 27.395,
              "z": 0.12
            },
            "gtin": "4337185627637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e657",
            "leftCorner": {
              "x": -6.196,
              "y": 27.399,
              "z": 0.12
            },
            "rightCorner": {
              "x": -6.08,
              "y": 27.391,
              "z": 0.12
            },
            "gtin": "4015000973885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e658",
            "leftCorner": {
              "x": -6.08,
              "y": 27.391,
              "z": 0.12
            },
            "rightCorner": {
              "x": -5.964,
              "y": 27.384,
              "z": 0.12
            },
            "gtin": "4015000973885",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466c7",
        "height": 0.54495,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e61d",
            "leftCorner": {
              "x": -7.267,
              "y": 27.459,
              "z": 0.446
            },
            "rightCorner": {
              "x": -6.998,
              "y": 27.443,
              "z": 0.446
            },
            "gtin": "8700216663816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e61e",
            "leftCorner": {
              "x": -6.999,
              "y": 27.438,
              "z": 0.446
            },
            "rightCorner": {
              "x": -6.754,
              "y": 27.423,
              "z": 0.446
            },
            "gtin": "8700216710718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e61f",
            "leftCorner": {
              "x": -6.753,
              "y": 27.443,
              "z": 0.446
            },
            "rightCorner": {
              "x": -6.524,
              "y": 27.43,
              "z": 0.446
            },
            "gtin": "4251758408709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e620",
            "leftCorner": {
              "x": -6.524,
              "y": 27.425,
              "z": 0.446
            },
            "rightCorner": {
              "x": -6.34,
              "y": 27.414,
              "z": 0.446
            },
            "gtin": "4251758408648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e621",
            "leftCorner": {
              "x": -6.34,
              "y": 27.414,
              "z": 0.446
            },
            "rightCorner": {
              "x": -6.156,
              "y": 27.403,
              "z": 0.446
            },
            "gtin": "4251758408648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e622",
            "leftCorner": {
              "x": -6.156,
              "y": 27.403,
              "z": 0.446
            },
            "rightCorner": {
              "x": -5.972,
              "y": 27.392,
              "z": 0.446
            },
            "gtin": "4251758408648",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466c8",
        "height": 0.95013,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e5b6",
            "leftCorner": {
              "x": -6.901,
              "y": 27.443,
              "z": 0.777
            },
            "rightCorner": {
              "x": -6.814,
              "y": 27.438,
              "z": 0.777
            },
            "gtin": "4001499953958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5b7",
            "leftCorner": {
              "x": -6.814,
              "y": 27.438,
              "z": 0.777
            },
            "rightCorner": {
              "x": -6.726,
              "y": 27.433,
              "z": 0.777
            },
            "gtin": "4001499953958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5b8",
            "leftCorner": {
              "x": -6.726,
              "y": 27.433,
              "z": 0.777
            },
            "rightCorner": {
              "x": -6.639,
              "y": 27.428,
              "z": 0.777
            },
            "gtin": "4001499953958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5b9",
            "leftCorner": {
              "x": -6.64,
              "y": 27.427,
              "z": 0.777
            },
            "rightCorner": {
              "x": -6.544,
              "y": 27.421,
              "z": 0.777
            },
            "gtin": "4001499961526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5ba",
            "leftCorner": {
              "x": -6.545,
              "y": 27.408,
              "z": 0.777
            },
            "rightCorner": {
              "x": -6.332,
              "y": 27.396,
              "z": 0.777
            },
            "gtin": "4001499957635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5bb",
            "leftCorner": {
              "x": -6.332,
              "y": 27.398,
              "z": 0.777
            },
            "rightCorner": {
              "x": -6.154,
              "y": 27.386,
              "z": 0.777
            },
            "gtin": "5412533003888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5bc",
            "leftCorner": {
              "x": -6.154,
              "y": 27.394,
              "z": 0.777
            },
            "rightCorner": {
              "x": -6.055,
              "y": 27.388,
              "z": 0.777
            },
            "gtin": "5000204592320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5bd",
            "leftCorner": {
              "x": -6.055,
              "y": 27.388,
              "z": 0.777
            },
            "rightCorner": {
              "x": -5.957,
              "y": 27.382,
              "z": 0.777
            },
            "gtin": "5000204592320",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466c6",
        "height": 1.3971,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20cfd",
            "leftCorner": {
              "x": -7.25,
              "y": 27.429,
              "z": 1.143
            },
            "rightCorner": {
              "x": -7.116,
              "y": 27.42,
              "z": 1.143
            },
            "gtin": "4001499961472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cfe",
            "leftCorner": {
              "x": -7.116,
              "y": 27.42,
              "z": 1.143
            },
            "rightCorner": {
              "x": -6.982,
              "y": 27.412,
              "z": 1.143
            },
            "gtin": "4001499961472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d03",
            "leftCorner": {
              "x": -6.98,
              "y": 27.45,
              "z": 1.143
            },
            "rightCorner": {
              "x": -6.679,
              "y": 27.432,
              "z": 1.143
            },
            "gtin": "4001499953866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d04",
            "leftCorner": {
              "x": -6.679,
              "y": 27.432,
              "z": 1.143
            },
            "rightCorner": {
              "x": -6.377,
              "y": 27.413,
              "z": 1.143
            },
            "gtin": "4001499953866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cff",
            "leftCorner": {
              "x": -6.377,
              "y": 27.408,
              "z": 1.143
            },
            "rightCorner": {
              "x": -6.283,
              "y": 27.402,
              "z": 1.143
            },
            "gtin": "4001499961465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d00",
            "leftCorner": {
              "x": -6.283,
              "y": 27.402,
              "z": 1.143
            },
            "rightCorner": {
              "x": -6.189,
              "y": 27.396,
              "z": 1.143
            },
            "gtin": "4001499961465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d01",
            "leftCorner": {
              "x": -6.189,
              "y": 27.396,
              "z": 1.143
            },
            "rightCorner": {
              "x": -6.095,
              "y": 27.391,
              "z": 1.143
            },
            "gtin": "4001499961465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d02",
            "leftCorner": {
              "x": -6.095,
              "y": 27.391,
              "z": 1.143
            },
            "rightCorner": {
              "x": -6.0,
              "y": 27.386,
              "z": 1.143
            },
            "gtin": "4001499961465",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466c5",
        "height": 1.7513,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e5f3",
            "leftCorner": {
              "x": -7.21,
              "y": 27.458,
              "z": 1.433
            },
            "rightCorner": {
              "x": -7.11,
              "y": 27.452,
              "z": 1.433
            },
            "gtin": "5000204150735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5f4",
            "leftCorner": {
              "x": -7.11,
              "y": 27.452,
              "z": 1.433
            },
            "rightCorner": {
              "x": -7.009,
              "y": 27.445,
              "z": 1.433
            },
            "gtin": "5000204150735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5f5",
            "leftCorner": {
              "x": -7.009,
              "y": 27.445,
              "z": 1.433
            },
            "rightCorner": {
              "x": -6.909,
              "y": 27.44,
              "z": 1.433
            },
            "gtin": "5000204150735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5f6",
            "leftCorner": {
              "x": -6.908,
              "y": 27.454,
              "z": 1.433
            },
            "rightCorner": {
              "x": -6.821,
              "y": 27.448,
              "z": 1.433
            },
            "gtin": "4022142114007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5f7",
            "leftCorner": {
              "x": -6.821,
              "y": 27.448,
              "z": 1.433
            },
            "rightCorner": {
              "x": -6.734,
              "y": 27.443,
              "z": 1.433
            },
            "gtin": "4022142114007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5f8",
            "leftCorner": {
              "x": -6.734,
              "y": 27.443,
              "z": 1.433
            },
            "rightCorner": {
              "x": -6.647,
              "y": 27.438,
              "z": 1.433
            },
            "gtin": "4022142114007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5f9",
            "leftCorner": {
              "x": -6.647,
              "y": 27.438,
              "z": 1.433
            },
            "rightCorner": {
              "x": -6.56,
              "y": 27.433,
              "z": 1.433
            },
            "gtin": "4022142114007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5fa",
            "leftCorner": {
              "x": -6.561,
              "y": 27.412,
              "z": 1.433
            },
            "rightCorner": {
              "x": -6.43,
              "y": 27.404,
              "z": 1.433
            },
            "gtin": "4000602152998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5fb",
            "leftCorner": {
              "x": -6.43,
              "y": 27.404,
              "z": 1.433
            },
            "rightCorner": {
              "x": -6.3,
              "y": 27.396,
              "z": 1.433
            },
            "gtin": "4000602152998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5fc",
            "leftCorner": {
              "x": -6.3,
              "y": 27.396,
              "z": 1.433
            },
            "rightCorner": {
              "x": -6.17,
              "y": 27.389,
              "z": 1.433
            },
            "gtin": "4000602152998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5fd",
            "leftCorner": {
              "x": -6.17,
              "y": 27.386,
              "z": 1.433
            },
            "rightCorner": {
              "x": -6.081,
              "y": 27.381,
              "z": 1.433
            },
            "gtin": "5000204155259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5fe",
            "leftCorner": {
              "x": -6.081,
              "y": 27.381,
              "z": 1.433
            },
            "rightCorner": {
              "x": -5.993,
              "y": 27.375,
              "z": 1.433
            },
            "gtin": "5000204155259",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d75",
    "rightNeighborShelfId": "a6d77"
  },
  {
    "id": "a6d77",
    "name": "a6d77",
    "x": -6.003,
    "y": 27.338,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.030163,
      "w": 0.99954
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 39,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5466d5",
        "height": 0.1474,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a5466d3",
        "height": 0.54089,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e623",
            "leftCorner": {
              "x": -5.972,
              "y": 27.389,
              "z": 0.443
            },
            "rightCorner": {
              "x": -5.836,
              "y": 27.381,
              "z": 0.443
            },
            "gtin": "5000204096989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e624",
            "leftCorner": {
              "x": -5.836,
              "y": 27.381,
              "z": 0.443
            },
            "rightCorner": {
              "x": -5.7,
              "y": 27.372,
              "z": 0.443
            },
            "gtin": "5000204096989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e625",
            "leftCorner": {
              "x": -5.7,
              "y": 27.372,
              "z": 0.443
            },
            "rightCorner": {
              "x": -5.564,
              "y": 27.365,
              "z": 0.443
            },
            "gtin": "5000204096989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e626",
            "leftCorner": {
              "x": -5.564,
              "y": 27.368,
              "z": 0.443
            },
            "rightCorner": {
              "x": -5.347,
              "y": 27.355,
              "z": 0.443
            },
            "gtin": "5000204096958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e627",
            "leftCorner": {
              "x": -5.347,
              "y": 27.355,
              "z": 0.443
            },
            "rightCorner": {
              "x": -5.129,
              "y": 27.342,
              "z": 0.443
            },
            "gtin": "5000204096958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e628",
            "leftCorner": {
              "x": -5.129,
              "y": 27.342,
              "z": 0.443
            },
            "rightCorner": {
              "x": -4.912,
              "y": 27.328,
              "z": 0.443
            },
            "gtin": "5000204096958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e629",
            "leftCorner": {
              "x": -4.912,
              "y": 27.328,
              "z": 0.443
            },
            "rightCorner": {
              "x": -4.695,
              "y": 27.315,
              "z": 0.443
            },
            "gtin": "5000204096958",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466d4",
        "height": 0.9481,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e5be",
            "leftCorner": {
              "x": -5.957,
              "y": 27.39,
              "z": 0.776
            },
            "rightCorner": {
              "x": -5.87,
              "y": 27.384,
              "z": 0.776
            },
            "gtin": "8720182432353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5bf",
            "leftCorner": {
              "x": -5.87,
              "y": 27.384,
              "z": 0.776
            },
            "rightCorner": {
              "x": -5.784,
              "y": 27.379,
              "z": 0.776
            },
            "gtin": "8720182432353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5c0",
            "leftCorner": {
              "x": -5.784,
              "y": 27.379,
              "z": 0.776
            },
            "rightCorner": {
              "x": -5.698,
              "y": 27.373,
              "z": 0.776
            },
            "gtin": "8720182432353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5c1",
            "leftCorner": {
              "x": -5.698,
              "y": 27.373,
              "z": 0.776
            },
            "rightCorner": {
              "x": -5.611,
              "y": 27.368,
              "z": 0.776
            },
            "gtin": "8720182432353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5c2",
            "leftCorner": {
              "x": -5.611,
              "y": 27.367,
              "z": 0.776
            },
            "rightCorner": {
              "x": -5.471,
              "y": 27.36,
              "z": 0.776
            },
            "gtin": "8720182432360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5c3",
            "leftCorner": {
              "x": -5.471,
              "y": 27.36,
              "z": 0.776
            },
            "rightCorner": {
              "x": -5.331,
              "y": 27.351,
              "z": 0.776
            },
            "gtin": "8720182432360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5c4",
            "leftCorner": {
              "x": -5.331,
              "y": 27.355,
              "z": 0.776
            },
            "rightCorner": {
              "x": -5.245,
              "y": 27.349,
              "z": 0.776
            },
            "gtin": "8720182432353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5c5",
            "leftCorner": {
              "x": -5.245,
              "y": 27.349,
              "z": 0.776
            },
            "rightCorner": {
              "x": -5.159,
              "y": 27.344,
              "z": 0.776
            },
            "gtin": "8720182432353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5c6",
            "leftCorner": {
              "x": -5.159,
              "y": 27.344,
              "z": 0.776
            },
            "rightCorner": {
              "x": -5.074,
              "y": 27.338,
              "z": 0.776
            },
            "gtin": "8720182432353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5c7",
            "leftCorner": {
              "x": -5.074,
              "y": 27.331,
              "z": 0.776
            },
            "rightCorner": {
              "x": -4.921,
              "y": 27.322,
              "z": 0.776
            },
            "gtin": "8720182432377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5c8",
            "leftCorner": {
              "x": -4.921,
              "y": 27.322,
              "z": 0.776
            },
            "rightCorner": {
              "x": -4.768,
              "y": 27.312,
              "z": 0.776
            },
            "gtin": "8720182432377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5c9",
            "leftCorner": {
              "x": -4.768,
              "y": 27.312,
              "z": 0.776
            },
            "rightCorner": {
              "x": -4.615,
              "y": 27.304,
              "z": 0.776
            },
            "gtin": "8720182432377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5ca",
            "leftCorner": {
              "x": -4.615,
              "y": 27.304,
              "z": 0.776
            },
            "rightCorner": {
              "x": -4.462,
              "y": 27.294,
              "z": 0.776
            },
            "gtin": "8720182432377",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466d2",
        "height": 1.3595,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e631",
            "leftCorner": {
              "x": -6.002,
              "y": 27.362,
              "z": 1.112
            },
            "rightCorner": {
              "x": -5.836,
              "y": 27.352,
              "z": 1.112
            },
            "gtin": "4013162000692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e634",
            "leftCorner": {
              "x": -5.834,
              "y": 27.384,
              "z": 1.112
            },
            "rightCorner": {
              "x": -5.686,
              "y": 27.374,
              "z": 1.112
            },
            "gtin": "4001499954986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e635",
            "leftCorner": {
              "x": -5.686,
              "y": 27.374,
              "z": 1.112
            },
            "rightCorner": {
              "x": -5.539,
              "y": 27.365,
              "z": 1.112
            },
            "gtin": "4001499954986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e636",
            "leftCorner": {
              "x": -5.539,
              "y": 27.365,
              "z": 1.112
            },
            "rightCorner": {
              "x": -5.391,
              "y": 27.356,
              "z": 1.112
            },
            "gtin": "4001499954986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e637",
            "leftCorner": {
              "x": -5.391,
              "y": 27.356,
              "z": 1.112
            },
            "rightCorner": {
              "x": -5.244,
              "y": 27.348,
              "z": 1.112
            },
            "gtin": "4001499954986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e638",
            "leftCorner": {
              "x": -5.244,
              "y": 27.353,
              "z": 1.112
            },
            "rightCorner": {
              "x": -4.921,
              "y": 27.334,
              "z": 1.112
            },
            "gtin": "4001499954993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e639",
            "leftCorner": {
              "x": -4.921,
              "y": 27.33,
              "z": 1.112
            },
            "rightCorner": {
              "x": -4.842,
              "y": 27.326,
              "z": 1.112
            },
            "gtin": "4251758404633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e63a",
            "leftCorner": {
              "x": -4.842,
              "y": 27.326,
              "z": 1.112
            },
            "rightCorner": {
              "x": -4.763,
              "y": 27.32,
              "z": 1.112
            },
            "gtin": "4251758404633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e63b",
            "leftCorner": {
              "x": -4.763,
              "y": 27.32,
              "z": 1.112
            },
            "rightCorner": {
              "x": -4.683,
              "y": 27.316,
              "z": 1.112
            },
            "gtin": "4251758404633",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466d1",
        "height": 1.7466,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e5ff",
            "leftCorner": {
              "x": -5.991,
              "y": 27.39,
              "z": 1.429
            },
            "rightCorner": {
              "x": -5.834,
              "y": 27.381,
              "z": 1.429
            },
            "gtin": "4001499168314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e600",
            "leftCorner": {
              "x": -5.836,
              "y": 27.362,
              "z": 1.429
            },
            "rightCorner": {
              "x": -5.713,
              "y": 27.354,
              "z": 1.429
            },
            "gtin": "5000204347555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e601",
            "leftCorner": {
              "x": -5.713,
              "y": 27.354,
              "z": 1.429
            },
            "rightCorner": {
              "x": -5.59,
              "y": 27.347,
              "z": 1.429
            },
            "gtin": "5000204347555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e602",
            "leftCorner": {
              "x": -5.589,
              "y": 27.372,
              "z": 1.429
            },
            "rightCorner": {
              "x": -5.468,
              "y": 27.364,
              "z": 1.429
            },
            "gtin": "5000204150735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e603",
            "leftCorner": {
              "x": -5.468,
              "y": 27.359,
              "z": 1.429
            },
            "rightCorner": {
              "x": -5.35,
              "y": 27.352,
              "z": 1.429
            },
            "gtin": "5000204347555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e604",
            "leftCorner": {
              "x": -5.35,
              "y": 27.352,
              "z": 1.429
            },
            "rightCorner": {
              "x": -5.231,
              "y": 27.344,
              "z": 1.429
            },
            "gtin": "5000204347555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e605",
            "leftCorner": {
              "x": -5.231,
              "y": 27.344,
              "z": 1.429
            },
            "rightCorner": {
              "x": -5.112,
              "y": 27.338,
              "z": 1.429
            },
            "gtin": "5000204347555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e606",
            "leftCorner": {
              "x": -5.112,
              "y": 27.338,
              "z": 1.429
            },
            "rightCorner": {
              "x": -4.992,
              "y": 27.33,
              "z": 1.429
            },
            "gtin": "4250445600761",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e607",
            "leftCorner": {
              "x": -4.992,
              "y": 27.33,
              "z": 1.429
            },
            "rightCorner": {
              "x": -4.872,
              "y": 27.322,
              "z": 1.429
            },
            "gtin": "4250445600761",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e608",
            "leftCorner": {
              "x": -4.872,
              "y": 27.322,
              "z": 1.429
            },
            "rightCorner": {
              "x": -4.752,
              "y": 27.316,
              "z": 1.429
            },
            "gtin": "4250445600761",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d76",
    "rightNeighborShelfId": "a6d78"
  },
  {
    "id": "a6d78",
    "name": "a6d78",
    "x": -4.755,
    "y": 27.263,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.030163,
      "w": 0.99954
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 23,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546356",
        "height": 0.14187,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e659",
            "leftCorner": {
              "x": -4.01,
              "y": 27.275,
              "z": 0.116
            },
            "rightCorner": {
              "x": -3.827,
              "y": 27.264,
              "z": 0.116
            },
            "gtin": "4011200662901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e65a",
            "leftCorner": {
              "x": -3.827,
              "y": 27.264,
              "z": 0.116
            },
            "rightCorner": {
              "x": -3.645,
              "y": 27.253,
              "z": 0.116
            },
            "gtin": "4011200662901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e65b",
            "leftCorner": {
              "x": -3.645,
              "y": 27.253,
              "z": 0.116
            },
            "rightCorner": {
              "x": -3.462,
              "y": 27.241,
              "z": 0.116
            },
            "gtin": "4011200662901",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546354",
        "height": 0.54374,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e62a",
            "leftCorner": {
              "x": -4.695,
              "y": 27.306,
              "z": 0.445
            },
            "rightCorner": {
              "x": -4.452,
              "y": 27.292,
              "z": 0.445
            },
            "gtin": "5000204366754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e62b",
            "leftCorner": {
              "x": -4.452,
              "y": 27.292,
              "z": 0.445
            },
            "rightCorner": {
              "x": -4.21,
              "y": 27.277,
              "z": 0.445
            },
            "gtin": "5000204366754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e62c",
            "leftCorner": {
              "x": -4.209,
              "y": 27.296,
              "z": 0.445
            },
            "rightCorner": {
              "x": -4.019,
              "y": 27.285,
              "z": 0.445
            },
            "gtin": "5000204096781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e62d",
            "leftCorner": {
              "x": -4.019,
              "y": 27.285,
              "z": 0.445
            },
            "rightCorner": {
              "x": -3.83,
              "y": 27.274,
              "z": 0.445
            },
            "gtin": "5000204096781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e62e",
            "leftCorner": {
              "x": -3.83,
              "y": 27.274,
              "z": 0.445
            },
            "rightCorner": {
              "x": -3.641,
              "y": 27.262,
              "z": 0.445
            },
            "gtin": "5000204096781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e62f",
            "leftCorner": {
              "x": -3.641,
              "y": 27.262,
              "z": 0.445
            },
            "rightCorner": {
              "x": -3.452,
              "y": 27.25,
              "z": 0.445
            },
            "gtin": "5000204096781",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546352",
        "height": 0.94564,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e5cb",
            "leftCorner": {
              "x": -4.461,
              "y": 27.297,
              "z": 0.774
            },
            "rightCorner": {
              "x": -4.239,
              "y": 27.283,
              "z": 0.774
            },
            "gtin": "4015000971836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5cc",
            "leftCorner": {
              "x": -4.239,
              "y": 27.283,
              "z": 0.774
            },
            "rightCorner": {
              "x": -4.018,
              "y": 27.27,
              "z": 0.774
            },
            "gtin": "4015000971836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5cd",
            "leftCorner": {
              "x": -4.018,
              "y": 27.27,
              "z": 0.774
            },
            "rightCorner": {
              "x": -3.796,
              "y": 27.257,
              "z": 0.774
            },
            "gtin": "4015000971836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5ce",
            "leftCorner": {
              "x": -3.795,
              "y": 27.277,
              "z": 0.774
            },
            "rightCorner": {
              "x": -3.7,
              "y": 27.271,
              "z": 0.774
            },
            "gtin": "5000204096675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5cf",
            "leftCorner": {
              "x": -3.7,
              "y": 27.271,
              "z": 0.774
            },
            "rightCorner": {
              "x": -3.605,
              "y": 27.265,
              "z": 0.774
            },
            "gtin": "5000204096675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5d0",
            "leftCorner": {
              "x": -3.604,
              "y": 27.279,
              "z": 0.774
            },
            "rightCorner": {
              "x": -3.43,
              "y": 27.269,
              "z": 0.774
            },
            "gtin": "5000204096705",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546355",
        "height": 1.3504,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e63c",
            "leftCorner": {
              "x": -4.685,
              "y": 27.285,
              "z": 1.105
            },
            "rightCorner": {
              "x": -3.713,
              "y": 27.226,
              "z": 1.105
            },
            "gtin": "5000204242522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e632",
            "leftCorner": {
              "x": -3.711,
              "y": 27.273,
              "z": 1.105
            },
            "rightCorner": {
              "x": -3.607,
              "y": 27.266,
              "z": 1.105
            },
            "gtin": "5000204096736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e633",
            "leftCorner": {
              "x": -3.607,
              "y": 27.266,
              "z": 1.105
            },
            "rightCorner": {
              "x": -3.503,
              "y": 27.261,
              "z": 1.105
            },
            "gtin": "5000204096736",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546353",
        "height": 1.7459,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e609",
            "leftCorner": {
              "x": -4.751,
              "y": 27.328,
              "z": 1.428
            },
            "rightCorner": {
              "x": -4.589,
              "y": 27.318,
              "z": 1.428
            },
            "gtin": "4001499969270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e60a",
            "leftCorner": {
              "x": -4.589,
              "y": 27.318,
              "z": 1.428
            },
            "rightCorner": {
              "x": -4.427,
              "y": 27.308,
              "z": 1.428
            },
            "gtin": "4001499969270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e60b",
            "leftCorner": {
              "x": -4.428,
              "y": 27.289,
              "z": 1.428
            },
            "rightCorner": {
              "x": -4.206,
              "y": 27.275,
              "z": 1.428
            },
            "gtin": "4001499969287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e60c",
            "leftCorner": {
              "x": -4.206,
              "y": 27.275,
              "z": 1.428
            },
            "rightCorner": {
              "x": -3.983,
              "y": 27.262,
              "z": 1.428
            },
            "gtin": "4001499969287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e60d",
            "leftCorner": {
              "x": -3.982,
              "y": 27.284,
              "z": 1.428
            },
            "rightCorner": {
              "x": -3.464,
              "y": 27.253,
              "z": 1.428
            },
            "gtin": "4337185377921",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d77",
    "rightNeighborShelfId": "a6d79"
  },
  {
    "id": "a6d79",
    "name": "a6d79",
    "x": -3.507,
    "y": 27.187,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.030163,
      "w": 0.99954
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 25,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5466da",
        "height": 0.14559,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e65c",
            "leftCorner": {
              "x": -3.462,
              "y": 27.235,
              "z": 0.119
            },
            "rightCorner": {
              "x": -3.401,
              "y": 27.232,
              "z": 0.119
            },
            "gtin": "4015000969512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e65d",
            "leftCorner": {
              "x": -3.401,
              "y": 27.232,
              "z": 0.119
            },
            "rightCorner": {
              "x": -3.341,
              "y": 27.228,
              "z": 0.119
            },
            "gtin": "4015000969512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e65e",
            "leftCorner": {
              "x": -3.341,
              "y": 27.228,
              "z": 0.119
            },
            "rightCorner": {
              "x": -3.28,
              "y": 27.224,
              "z": 0.119
            },
            "gtin": "4015000969512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e65f",
            "leftCorner": {
              "x": -3.28,
              "y": 27.224,
              "z": 0.119
            },
            "rightCorner": {
              "x": -3.22,
              "y": 27.221,
              "z": 0.119
            },
            "gtin": "4015000969512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e660",
            "leftCorner": {
              "x": -3.22,
              "y": 27.221,
              "z": 0.119
            },
            "rightCorner": {
              "x": -3.159,
              "y": 27.217,
              "z": 0.119
            },
            "gtin": "4015000969512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e63d",
            "leftCorner": {
              "x": -3.158,
              "y": 27.24,
              "z": 0.119
            },
            "rightCorner": {
              "x": -2.706,
              "y": 27.213,
              "z": 0.119
            },
            "gtin": "4015000969550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e63e",
            "leftCorner": {
              "x": -2.706,
              "y": 27.213,
              "z": 0.119
            },
            "rightCorner": {
              "x": -2.255,
              "y": 27.186,
              "z": 0.119
            },
            "gtin": "4015000969550",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466d6",
        "height": 0.54069,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e630",
            "leftCorner": {
              "x": -3.453,
              "y": 27.231,
              "z": 0.442
            },
            "rightCorner": {
              "x": -3.291,
              "y": 27.22,
              "z": 0.442
            },
            "gtin": "4015200036311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e614",
            "leftCorner": {
              "x": -3.289,
              "y": 27.25,
              "z": 0.442
            },
            "rightCorner": {
              "x": -2.255,
              "y": 27.188,
              "z": 0.442
            },
            "gtin": "4015000969635",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466d9",
        "height": 0.94733,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e5d1",
            "leftCorner": {
              "x": -3.432,
              "y": 27.239,
              "z": 0.775
            },
            "rightCorner": {
              "x": -3.17,
              "y": 27.224,
              "z": 0.775
            },
            "gtin": "4015000969536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5a3",
            "leftCorner": {
              "x": -3.169,
              "y": 27.248,
              "z": 0.775
            },
            "rightCorner": {
              "x": -2.712,
              "y": 27.22,
              "z": 0.775
            },
            "gtin": "4015000969604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5a4",
            "leftCorner": {
              "x": -2.712,
              "y": 27.22,
              "z": 0.775
            },
            "rightCorner": {
              "x": -2.254,
              "y": 27.193,
              "z": 0.775
            },
            "gtin": "4015000969604",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466d7",
        "height": 1.401,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20d45",
            "leftCorner": {
              "x": -3.505,
              "y": 27.214,
              "z": 1.146
            },
            "rightCorner": {
              "x": -3.434,
              "y": 27.21,
              "z": 1.146
            },
            "gtin": "4015200032825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d46",
            "leftCorner": {
              "x": -3.434,
              "y": 27.21,
              "z": 1.146
            },
            "rightCorner": {
              "x": -3.362,
              "y": 27.206,
              "z": 1.146
            },
            "gtin": "4015200032825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d47",
            "leftCorner": {
              "x": -3.362,
              "y": 27.206,
              "z": 1.146
            },
            "rightCorner": {
              "x": -3.29,
              "y": 27.201,
              "z": 1.146
            },
            "gtin": "4015200032825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d48",
            "leftCorner": {
              "x": -3.29,
              "y": 27.201,
              "z": 1.146
            },
            "rightCorner": {
              "x": -3.219,
              "y": 27.197,
              "z": 1.146
            },
            "gtin": "4015200032825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d4c",
            "leftCorner": {
              "x": -3.216,
              "y": 27.24,
              "z": 1.146
            },
            "rightCorner": {
              "x": -3.069,
              "y": 27.231,
              "z": 1.146
            },
            "gtin": "4015200032801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d49",
            "leftCorner": {
              "x": -3.066,
              "y": 27.272,
              "z": 1.146
            },
            "rightCorner": {
              "x": -2.795,
              "y": 27.256,
              "z": 1.146
            },
            "gtin": "4015000969185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d4a",
            "leftCorner": {
              "x": -2.795,
              "y": 27.256,
              "z": 1.146
            },
            "rightCorner": {
              "x": -2.524,
              "y": 27.24,
              "z": 1.146
            },
            "gtin": "4015000969185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d4b",
            "leftCorner": {
              "x": -2.524,
              "y": 27.24,
              "z": 1.146
            },
            "rightCorner": {
              "x": -2.252,
              "y": 27.223,
              "z": 1.146
            },
            "gtin": "4015000969185",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466d8",
        "height": 1.7469,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e60e",
            "leftCorner": {
              "x": -3.465,
              "y": 27.234,
              "z": 1.429
            },
            "rightCorner": {
              "x": -3.363,
              "y": 27.228,
              "z": 1.429
            },
            "gtin": "4002448114307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e60f",
            "leftCorner": {
              "x": -3.363,
              "y": 27.228,
              "z": 1.429
            },
            "rightCorner": {
              "x": -3.261,
              "y": 27.221,
              "z": 1.429
            },
            "gtin": "4002448114307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e610",
            "leftCorner": {
              "x": -3.261,
              "y": 27.221,
              "z": 1.429
            },
            "rightCorner": {
              "x": -3.159,
              "y": 27.216,
              "z": 1.429
            },
            "gtin": "4002448114307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e611",
            "leftCorner": {
              "x": -3.156,
              "y": 27.258,
              "z": 1.429
            },
            "rightCorner": {
              "x": -2.968,
              "y": 27.247,
              "z": 1.429
            },
            "gtin": "4002448106623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5d4",
            "leftCorner": {
              "x": -2.967,
              "y": 27.257,
              "z": 1.429
            },
            "rightCorner": {
              "x": -2.253,
              "y": 27.213,
              "z": 1.429
            },
            "gtin": "4251758408358",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d78",
    "rightNeighborShelfId": "a6d7a"
  },
  {
    "id": "a6d7a",
    "name": "a6d7a",
    "x": -2.26,
    "y": 27.112,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.030163,
      "w": 0.99954
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 42,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5466df",
        "height": 0.14864,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20d6e",
            "leftCorner": {
              "x": -2.254,
              "y": 27.205,
              "z": 0.122
            },
            "rightCorner": {
              "x": -2.044,
              "y": 27.193,
              "z": 0.122
            },
            "gtin": "4063367422249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d6f",
            "leftCorner": {
              "x": -2.044,
              "y": 27.193,
              "z": 0.122
            },
            "rightCorner": {
              "x": -1.833,
              "y": 27.18,
              "z": 0.122
            },
            "gtin": "4063367422249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d71",
            "leftCorner": {
              "x": -1.83,
              "y": 27.235,
              "z": 0.122
            },
            "rightCorner": {
              "x": -1.718,
              "y": 27.228,
              "z": 0.122
            },
            "gtin": "4063367446320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d72",
            "leftCorner": {
              "x": -1.72,
              "y": 27.201,
              "z": 0.122
            },
            "rightCorner": {
              "x": -1.606,
              "y": 27.194,
              "z": 0.122
            },
            "gtin": "4063367461347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d73",
            "leftCorner": {
              "x": -1.606,
              "y": 27.194,
              "z": 0.122
            },
            "rightCorner": {
              "x": -1.492,
              "y": 27.187,
              "z": 0.122
            },
            "gtin": "4063367461347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d74",
            "leftCorner": {
              "x": -1.492,
              "y": 27.187,
              "z": 0.122
            },
            "rightCorner": {
              "x": -1.378,
              "y": 27.181,
              "z": 0.122
            },
            "gtin": "4063367461347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d75",
            "leftCorner": {
              "x": -1.38,
              "y": 27.153,
              "z": 0.122
            },
            "rightCorner": {
              "x": -1.25,
              "y": 27.145,
              "z": 0.122
            },
            "gtin": "4063367461354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d76",
            "leftCorner": {
              "x": -1.25,
              "y": 27.145,
              "z": 0.122
            },
            "rightCorner": {
              "x": -1.119,
              "y": 27.137,
              "z": 0.122
            },
            "gtin": "4063367461354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d70",
            "leftCorner": {
              "x": -1.121,
              "y": 27.108,
              "z": 0.122
            },
            "rightCorner": {
              "x": -1.008,
              "y": 27.101,
              "z": 0.122
            },
            "gtin": "4063367437502",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466de",
        "height": 0.54482,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20d68",
            "leftCorner": {
              "x": -2.255,
              "y": 27.199,
              "z": 0.446
            },
            "rightCorner": {
              "x": -1.914,
              "y": 27.179,
              "z": 0.446
            },
            "gtin": "8720182899477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d6b",
            "leftCorner": {
              "x": -1.91,
              "y": 27.243,
              "z": 0.446
            },
            "rightCorner": {
              "x": -1.67,
              "y": 27.229,
              "z": 0.446
            },
            "gtin": "8720181133480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d6c",
            "leftCorner": {
              "x": -1.67,
              "y": 27.229,
              "z": 0.446
            },
            "rightCorner": {
              "x": -1.429,
              "y": 27.213,
              "z": 0.446
            },
            "gtin": "8720181133480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d6d",
            "leftCorner": {
              "x": -1.432,
              "y": 27.167,
              "z": 0.446
            },
            "rightCorner": {
              "x": -1.288,
              "y": 27.158,
              "z": 0.446
            },
            "gtin": "8720182899446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d69",
            "leftCorner": {
              "x": -1.288,
              "y": 27.155,
              "z": 0.446
            },
            "rightCorner": {
              "x": -1.147,
              "y": 27.147,
              "z": 0.446
            },
            "gtin": "8720182899453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d6a",
            "leftCorner": {
              "x": -1.147,
              "y": 27.147,
              "z": 0.446
            },
            "rightCorner": {
              "x": -1.006,
              "y": 27.138,
              "z": 0.446
            },
            "gtin": "8720182899453",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466dd",
        "height": 0.94972,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20d62",
            "leftCorner": {
              "x": -2.254,
              "y": 27.209,
              "z": 0.777
            },
            "rightCorner": {
              "x": -1.861,
              "y": 27.186,
              "z": 0.777
            },
            "gtin": "8720182894892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d65",
            "leftCorner": {
              "x": -1.859,
              "y": 27.22,
              "z": 0.777
            },
            "rightCorner": {
              "x": -1.772,
              "y": 27.214,
              "z": 0.777
            },
            "gtin": "8720182871114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d66",
            "leftCorner": {
              "x": -1.771,
              "y": 27.221,
              "z": 0.777
            },
            "rightCorner": {
              "x": -1.697,
              "y": 27.216,
              "z": 0.777
            },
            "gtin": "8720182899453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d67",
            "leftCorner": {
              "x": -1.698,
              "y": 27.205,
              "z": 0.777
            },
            "rightCorner": {
              "x": -1.404,
              "y": 27.187,
              "z": 0.777
            },
            "gtin": "8720182894823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d63",
            "leftCorner": {
              "x": -1.406,
              "y": 27.151,
              "z": 0.777
            },
            "rightCorner": {
              "x": -1.206,
              "y": 27.139,
              "z": 0.777
            },
            "gtin": "8720182894830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d64",
            "leftCorner": {
              "x": -1.206,
              "y": 27.139,
              "z": 0.777
            },
            "rightCorner": {
              "x": -1.007,
              "y": 27.127,
              "z": 0.777
            },
            "gtin": "8720182894830",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466db",
        "height": 1.3976,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20d4d",
            "leftCorner": {
              "x": -2.255,
              "y": 27.198,
              "z": 1.143
            },
            "rightCorner": {
              "x": -1.931,
              "y": 27.179,
              "z": 1.143
            },
            "gtin": "5000204329469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d50",
            "leftCorner": {
              "x": -1.928,
              "y": 27.219,
              "z": 1.143
            },
            "rightCorner": {
              "x": -1.799,
              "y": 27.211,
              "z": 1.143
            },
            "gtin": "5000204331424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d51",
            "leftCorner": {
              "x": -1.799,
              "y": 27.216,
              "z": 1.143
            },
            "rightCorner": {
              "x": -1.73,
              "y": 27.212,
              "z": 1.143
            },
            "gtin": "5000204339888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d52",
            "leftCorner": {
              "x": -1.73,
              "y": 27.212,
              "z": 1.143
            },
            "rightCorner": {
              "x": -1.662,
              "y": 27.208,
              "z": 1.143
            },
            "gtin": "5000204339888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d53",
            "leftCorner": {
              "x": -1.662,
              "y": 27.198,
              "z": 1.143
            },
            "rightCorner": {
              "x": -1.566,
              "y": 27.192,
              "z": 1.143
            },
            "gtin": "5000204814651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d54",
            "leftCorner": {
              "x": -1.566,
              "y": 27.192,
              "z": 1.143
            },
            "rightCorner": {
              "x": -1.469,
              "y": 27.186,
              "z": 1.143
            },
            "gtin": "5000204814651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d55",
            "leftCorner": {
              "x": -1.47,
              "y": 27.177,
              "z": 1.143
            },
            "rightCorner": {
              "x": -1.359,
              "y": 27.17,
              "z": 1.143
            },
            "gtin": "5000204668995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d56",
            "leftCorner": {
              "x": -1.359,
              "y": 27.17,
              "z": 1.143
            },
            "rightCorner": {
              "x": -1.248,
              "y": 27.164,
              "z": 1.143
            },
            "gtin": "5000204668995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d57",
            "leftCorner": {
              "x": -1.25,
              "y": 27.134,
              "z": 1.143
            },
            "rightCorner": {
              "x": -1.119,
              "y": 27.126,
              "z": 1.143
            },
            "gtin": "5000204019742",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d4e",
            "leftCorner": {
              "x": -1.12,
              "y": 27.116,
              "z": 1.143
            },
            "rightCorner": {
              "x": -1.064,
              "y": 27.113,
              "z": 1.143
            },
            "gtin": "5000204019711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d4f",
            "leftCorner": {
              "x": -1.064,
              "y": 27.113,
              "z": 1.143
            },
            "rightCorner": {
              "x": -1.008,
              "y": 27.109,
              "z": 1.143
            },
            "gtin": "5000204019711",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466dc",
        "height": 1.7471,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20d58",
            "leftCorner": {
              "x": -2.256,
              "y": 27.171,
              "z": 1.429
            },
            "rightCorner": {
              "x": -1.665,
              "y": 27.136,
              "z": 1.429
            },
            "gtin": "5000204331455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d5a",
            "leftCorner": {
              "x": -1.661,
              "y": 27.21,
              "z": 1.429
            },
            "rightCorner": {
              "x": -1.54,
              "y": 27.203,
              "z": 1.429
            },
            "gtin": "5000204199550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d5b",
            "leftCorner": {
              "x": -1.542,
              "y": 27.177,
              "z": 1.429
            },
            "rightCorner": {
              "x": -1.432,
              "y": 27.17,
              "z": 1.429
            },
            "gtin": "5000204369137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d5c",
            "leftCorner": {
              "x": -1.433,
              "y": 27.156,
              "z": 1.429
            },
            "rightCorner": {
              "x": -1.388,
              "y": 27.153,
              "z": 1.429
            },
            "gtin": "5000204593310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d5d",
            "leftCorner": {
              "x": -1.388,
              "y": 27.153,
              "z": 1.429
            },
            "rightCorner": {
              "x": -1.343,
              "y": 27.151,
              "z": 1.429
            },
            "gtin": "5000204593310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d5e",
            "leftCorner": {
              "x": -1.344,
              "y": 27.142,
              "z": 1.429
            },
            "rightCorner": {
              "x": -1.283,
              "y": 27.138,
              "z": 1.429
            },
            "gtin": "5000204656343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d5f",
            "leftCorner": {
              "x": -1.283,
              "y": 27.138,
              "z": 1.429
            },
            "rightCorner": {
              "x": -1.221,
              "y": 27.134,
              "z": 1.429
            },
            "gtin": "5000204656343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d60",
            "leftCorner": {
              "x": -1.222,
              "y": 27.126,
              "z": 1.429
            },
            "rightCorner": {
              "x": -1.143,
              "y": 27.122,
              "z": 1.429
            },
            "gtin": "5000204814590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d61",
            "leftCorner": {
              "x": -1.143,
              "y": 27.122,
              "z": 1.429
            },
            "rightCorner": {
              "x": -1.064,
              "y": 27.117,
              "z": 1.429
            },
            "gtin": "5000204814590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d59",
            "leftCorner": {
              "x": -1.067,
              "y": 27.073,
              "z": 1.429
            },
            "rightCorner": {
              "x": -1.01,
              "y": 27.07,
              "z": 1.429
            },
            "gtin": "5000204669022",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d79",
    "rightNeighborShelfId": "a6d7b"
  },
  {
    "id": "a6d7b",
    "name": "a6d7b",
    "x": -1.012,
    "y": 27.036,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.030163,
      "w": 0.99954
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 100,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5466e2",
        "height": 1.4953,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20d9b",
            "leftCorner": {
              "x": -0.908,
              "y": 27.031,
              "z": 1.223
            },
            "rightCorner": {
              "x": -0.804,
              "y": 27.026,
              "z": 1.223
            },
            "gtin": "4251758415455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d9a",
            "leftCorner": {
              "x": -1.012,
              "y": 27.038,
              "z": 1.223
            },
            "rightCorner": {
              "x": -0.908,
              "y": 27.031,
              "z": 1.223
            },
            "gtin": "4251758415455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d9d",
            "leftCorner": {
              "x": -0.801,
              "y": 27.08,
              "z": 1.223
            },
            "rightCorner": {
              "x": -0.705,
              "y": 27.074,
              "z": 1.223
            },
            "gtin": "4251758433312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d9e",
            "leftCorner": {
              "x": -0.705,
              "y": 27.074,
              "z": 1.223
            },
            "rightCorner": {
              "x": -0.609,
              "y": 27.068,
              "z": 1.223
            },
            "gtin": "4251758433312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d9f",
            "leftCorner": {
              "x": -0.61,
              "y": 27.053,
              "z": 1.223
            },
            "rightCorner": {
              "x": -0.507,
              "y": 27.047,
              "z": 1.223
            },
            "gtin": "4251758415479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20da0",
            "leftCorner": {
              "x": -0.507,
              "y": 27.053,
              "z": 1.223
            },
            "rightCorner": {
              "x": -0.439,
              "y": 27.049,
              "z": 1.223
            },
            "gtin": "4251758422088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20da1",
            "leftCorner": {
              "x": -0.439,
              "y": 27.049,
              "z": 1.223
            },
            "rightCorner": {
              "x": -0.37,
              "y": 27.044,
              "z": 1.223
            },
            "gtin": "4251758422088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20da2",
            "leftCorner": {
              "x": -0.37,
              "y": 27.044,
              "z": 1.223
            },
            "rightCorner": {
              "x": -0.302,
              "y": 27.04,
              "z": 1.223
            },
            "gtin": "4251758422088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20da3",
            "leftCorner": {
              "x": -0.303,
              "y": 27.035,
              "z": 1.223
            },
            "rightCorner": {
              "x": -0.237,
              "y": 27.031,
              "z": 1.223
            },
            "gtin": "4251758422026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20da4",
            "leftCorner": {
              "x": -0.237,
              "y": 27.031,
              "z": 1.223
            },
            "rightCorner": {
              "x": -0.171,
              "y": 27.027,
              "z": 1.223
            },
            "gtin": "4251758422026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20da5",
            "leftCorner": {
              "x": -0.171,
              "y": 27.03,
              "z": 1.223
            },
            "rightCorner": {
              "x": -0.023,
              "y": 27.02,
              "z": 1.223
            },
            "gtin": "4251758433725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20da6",
            "leftCorner": {
              "x": -0.023,
              "y": 27.02,
              "z": 1.223
            },
            "rightCorner": {
              "x": 0.126,
              "y": 27.012,
              "z": 1.223
            },
            "gtin": "4251758433725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20da7",
            "leftCorner": {
              "x": 0.126,
              "y": 27.02,
              "z": 1.223
            },
            "rightCorner": {
              "x": 0.16,
              "y": 27.018,
              "z": 1.223
            },
            "gtin": "4036889005832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d9c",
            "leftCorner": {
              "x": 0.159,
              "y": 26.996,
              "z": 1.223
            },
            "rightCorner": {
              "x": 0.238,
              "y": 26.991,
              "z": 1.223
            },
            "gtin": "4036889005825",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466e4",
        "height": 1.746,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20dc0",
            "leftCorner": {
              "x": -0.213,
              "y": 27.015,
              "z": 1.429
            },
            "rightCorner": {
              "x": -0.149,
              "y": 27.011,
              "z": 1.429
            },
            "gtin": "5000204219388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dc1",
            "leftCorner": {
              "x": -0.148,
              "y": 27.025,
              "z": 1.429
            },
            "rightCorner": {
              "x": -0.11,
              "y": 27.023,
              "z": 1.429
            },
            "gtin": "5000204219418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dc2",
            "leftCorner": {
              "x": -0.11,
              "y": 27.023,
              "z": 1.429
            },
            "rightCorner": {
              "x": -0.072,
              "y": 27.02,
              "z": 1.429
            },
            "gtin": "5000204219418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dc3",
            "leftCorner": {
              "x": -0.072,
              "y": 27.017,
              "z": 1.429
            },
            "rightCorner": {
              "x": 0.017,
              "y": 27.012,
              "z": 1.429
            },
            "gtin": "5000204332322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dc4",
            "leftCorner": {
              "x": 0.017,
              "y": 27.012,
              "z": 1.429
            },
            "rightCorner": {
              "x": 0.105,
              "y": 27.007,
              "z": 1.429
            },
            "gtin": "5000204332322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dc5",
            "leftCorner": {
              "x": 0.105,
              "y": 27.007,
              "z": 1.429
            },
            "rightCorner": {
              "x": 0.193,
              "y": 27.001,
              "z": 1.429
            },
            "gtin": "5000204332322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dc6",
            "leftCorner": {
              "x": 0.194,
              "y": 27.012,
              "z": 1.429
            },
            "rightCorner": {
              "x": 0.252,
              "y": 27.009,
              "z": 1.429
            },
            "gtin": "5000204075267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20db6",
            "leftCorner": {
              "x": -1.012,
              "y": 27.042,
              "z": 1.429
            },
            "rightCorner": {
              "x": -0.946,
              "y": 27.038,
              "z": 1.429
            },
            "gtin": "4001499943782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20db8",
            "leftCorner": {
              "x": -0.945,
              "y": 27.062,
              "z": 1.429
            },
            "rightCorner": {
              "x": -0.839,
              "y": 27.056,
              "z": 1.429
            },
            "gtin": "4001499116896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20db9",
            "leftCorner": {
              "x": -0.838,
              "y": 27.084,
              "z": 1.429
            },
            "rightCorner": {
              "x": -0.729,
              "y": 27.078,
              "z": 1.429
            },
            "gtin": "4001499914607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dba",
            "leftCorner": {
              "x": -0.728,
              "y": 27.088,
              "z": 1.429
            },
            "rightCorner": {
              "x": -0.661,
              "y": 27.084,
              "z": 1.429
            },
            "gtin": "4337185805127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dbb",
            "leftCorner": {
              "x": -0.662,
              "y": 27.066,
              "z": 1.429
            },
            "rightCorner": {
              "x": -0.543,
              "y": 27.058,
              "z": 1.429
            },
            "gtin": "4063367431500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dbc",
            "leftCorner": {
              "x": -0.543,
              "y": 27.063,
              "z": 1.429
            },
            "rightCorner": {
              "x": -0.434,
              "y": 27.057,
              "z": 1.429
            },
            "gtin": "4337185498404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dbd",
            "leftCorner": {
              "x": -0.433,
              "y": 27.067,
              "z": 1.429
            },
            "rightCorner": {
              "x": -0.359,
              "y": 27.063,
              "z": 1.429
            },
            "gtin": "5000204219890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dbe",
            "leftCorner": {
              "x": -0.36,
              "y": 27.038,
              "z": 1.429
            },
            "rightCorner": {
              "x": -0.285,
              "y": 27.034,
              "z": 1.429
            },
            "gtin": "5000204227079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dbf",
            "leftCorner": {
              "x": -0.285,
              "y": 27.042,
              "z": 1.429
            },
            "rightCorner": {
              "x": -0.211,
              "y": 27.037,
              "z": 1.429
            },
            "gtin": "5000204219357",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466e3",
        "height": 0.94386,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20da8",
            "leftCorner": {
              "x": -1.012,
              "y": 27.042,
              "z": 0.772
            },
            "rightCorner": {
              "x": -0.967,
              "y": 27.039,
              "z": 0.772
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20daa",
            "leftCorner": {
              "x": -0.965,
              "y": 27.07,
              "z": 0.772
            },
            "rightCorner": {
              "x": -0.852,
              "y": 27.064,
              "z": 0.772
            },
            "gtin": "4036889005856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dab",
            "leftCorner": {
              "x": -0.851,
              "y": 27.076,
              "z": 0.772
            },
            "rightCorner": {
              "x": -0.721,
              "y": 27.068,
              "z": 0.772
            },
            "gtin": "5000204408119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dac",
            "leftCorner": {
              "x": -0.721,
              "y": 27.063,
              "z": 0.772
            },
            "rightCorner": {
              "x": -0.636,
              "y": 27.057,
              "z": 0.772
            },
            "gtin": "5000204094169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dad",
            "leftCorner": {
              "x": -0.636,
              "y": 27.056,
              "z": 0.772
            },
            "rightCorner": {
              "x": -0.55,
              "y": 27.052,
              "z": 0.772
            },
            "gtin": "5000204094220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dae",
            "leftCorner": {
              "x": -0.55,
              "y": 27.052,
              "z": 0.772
            },
            "rightCorner": {
              "x": -0.464,
              "y": 27.046,
              "z": 0.772
            },
            "gtin": "5000204094220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20daf",
            "leftCorner": {
              "x": -0.463,
              "y": 27.056,
              "z": 0.772
            },
            "rightCorner": {
              "x": -0.402,
              "y": 27.052,
              "z": 0.772
            },
            "gtin": "5000204094190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20db0",
            "leftCorner": {
              "x": -0.402,
              "y": 27.052,
              "z": 0.772
            },
            "rightCorner": {
              "x": -0.34,
              "y": 27.049,
              "z": 0.772
            },
            "gtin": "5000204094190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20db1",
            "leftCorner": {
              "x": -0.341,
              "y": 27.038,
              "z": 0.772
            },
            "rightCorner": {
              "x": -0.251,
              "y": 27.033,
              "z": 0.772
            },
            "gtin": "4251758415660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20db2",
            "leftCorner": {
              "x": -0.251,
              "y": 27.033,
              "z": 0.772
            },
            "rightCorner": {
              "x": -0.161,
              "y": 27.027,
              "z": 0.772
            },
            "gtin": "4251758415660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20db3",
            "leftCorner": {
              "x": -0.161,
              "y": 27.024,
              "z": 0.772
            },
            "rightCorner": {
              "x": 0.031,
              "y": 27.013,
              "z": 0.772
            },
            "gtin": "4251758415721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20db4",
            "leftCorner": {
              "x": 0.031,
              "y": 27.018,
              "z": 0.772
            },
            "rightCorner": {
              "x": 0.092,
              "y": 27.014,
              "z": 0.772
            },
            "gtin": "4251758432049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20db5",
            "leftCorner": {
              "x": 0.092,
              "y": 27.014,
              "z": 0.772
            },
            "rightCorner": {
              "x": 0.153,
              "y": 27.011,
              "z": 0.772
            },
            "gtin": "4251758432049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20da9",
            "leftCorner": {
              "x": 0.153,
              "y": 27.008,
              "z": 0.772
            },
            "rightCorner": {
              "x": 0.238,
              "y": 27.004,
              "z": 0.772
            },
            "gtin": "4251758415707",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466e6",
        "height": 0.14598,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20de6",
            "leftCorner": {
              "x": -1.011,
              "y": 27.046,
              "z": 0.119
            },
            "rightCorner": {
              "x": -0.649,
              "y": 27.024,
              "z": 0.119
            },
            "gtin": "4063367437526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20de7",
            "leftCorner": {
              "x": -0.649,
              "y": 27.024,
              "z": 0.119
            },
            "rightCorner": {
              "x": -0.287,
              "y": 27.003,
              "z": 0.119
            },
            "gtin": "4063367437526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20de8",
            "leftCorner": {
              "x": -0.287,
              "y": 27.003,
              "z": 0.119
            },
            "rightCorner": {
              "x": 0.075,
              "y": 26.981,
              "z": 0.119
            },
            "gtin": "4063367437526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20deb",
            "leftCorner": {
              "x": 0.077,
              "y": 27.021,
              "z": 0.119
            },
            "rightCorner": {
              "x": 0.236,
              "y": 27.012,
              "z": 0.119
            },
            "gtin": "5000204771893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dec",
            "leftCorner": {
              "x": 0.236,
              "y": 27.012,
              "z": 0.119
            },
            "rightCorner": {
              "x": 0.394,
              "y": 27.002,
              "z": 0.119
            },
            "gtin": "5000204771893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ded",
            "leftCorner": {
              "x": 0.394,
              "y": 27.002,
              "z": 0.119
            },
            "rightCorner": {
              "x": 0.553,
              "y": 26.993,
              "z": 0.119
            },
            "gtin": "5000204771893",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466e0",
        "height": 0.44122,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20d77",
            "leftCorner": {
              "x": -1.011,
              "y": 27.045,
              "z": 0.361
            },
            "rightCorner": {
              "x": -0.933,
              "y": 27.04,
              "z": 0.361
            },
            "gtin": "5000204337426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d79",
            "leftCorner": {
              "x": -0.93,
              "y": 27.08,
              "z": 0.361
            },
            "rightCorner": {
              "x": -0.901,
              "y": 27.078,
              "z": 0.361
            },
            "gtin": "5000204078442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d7a",
            "leftCorner": {
              "x": -0.901,
              "y": 27.078,
              "z": 0.361
            },
            "rightCorner": {
              "x": -0.872,
              "y": 27.076,
              "z": 0.361
            },
            "gtin": "5000204078442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d7b",
            "leftCorner": {
              "x": -0.872,
              "y": 27.074,
              "z": 0.361
            },
            "rightCorner": {
              "x": -0.786,
              "y": 27.069,
              "z": 0.361
            },
            "gtin": "5000204337457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d7c",
            "leftCorner": {
              "x": -0.786,
              "y": 27.072,
              "z": 0.361
            },
            "rightCorner": {
              "x": -0.716,
              "y": 27.067,
              "z": 0.361
            },
            "gtin": "5000204078473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d7d",
            "leftCorner": {
              "x": -0.717,
              "y": 27.052,
              "z": 0.361
            },
            "rightCorner": {
              "x": -0.665,
              "y": 27.049,
              "z": 0.361
            },
            "gtin": "5000204157734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d7e",
            "leftCorner": {
              "x": -0.664,
              "y": 27.066,
              "z": 0.361
            },
            "rightCorner": {
              "x": -0.614,
              "y": 27.063,
              "z": 0.361
            },
            "gtin": "5000204378900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d7f",
            "leftCorner": {
              "x": -0.614,
              "y": 27.063,
              "z": 0.361
            },
            "rightCorner": {
              "x": -0.564,
              "y": 27.061,
              "z": 0.361
            },
            "gtin": "5000204378900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d80",
            "leftCorner": {
              "x": -0.564,
              "y": 27.066,
              "z": 0.361
            },
            "rightCorner": {
              "x": -0.494,
              "y": 27.062,
              "z": 0.361
            },
            "gtin": "5000204078565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d81",
            "leftCorner": {
              "x": -0.494,
              "y": 27.062,
              "z": 0.361
            },
            "rightCorner": {
              "x": -0.424,
              "y": 27.058,
              "z": 0.361
            },
            "gtin": "5000204078565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d82",
            "leftCorner": {
              "x": -0.424,
              "y": 27.053,
              "z": 0.361
            },
            "rightCorner": {
              "x": -0.362,
              "y": 27.05,
              "z": 0.361
            },
            "gtin": "5000204319729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d83",
            "leftCorner": {
              "x": -0.362,
              "y": 27.053,
              "z": 0.361
            },
            "rightCorner": {
              "x": -0.25,
              "y": 27.046,
              "z": 0.361
            },
            "gtin": "5000204078381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d84",
            "leftCorner": {
              "x": -0.251,
              "y": 27.034,
              "z": 0.361
            },
            "rightCorner": {
              "x": -0.154,
              "y": 27.027,
              "z": 0.361
            },
            "gtin": "5000204078329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d85",
            "leftCorner": {
              "x": -0.154,
              "y": 27.014,
              "z": 0.361
            },
            "rightCorner": {
              "x": -0.073,
              "y": 27.009,
              "z": 0.361
            },
            "gtin": "5000204256475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d86",
            "leftCorner": {
              "x": -0.073,
              "y": 27.011,
              "z": 0.361
            },
            "rightCorner": {
              "x": 0.004,
              "y": 27.007,
              "z": 0.361
            },
            "gtin": "5000204078251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d87",
            "leftCorner": {
              "x": 0.004,
              "y": 27.007,
              "z": 0.361
            },
            "rightCorner": {
              "x": 0.08,
              "y": 27.003,
              "z": 0.361
            },
            "gtin": "5000204078251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d88",
            "leftCorner": {
              "x": 0.081,
              "y": 27.016,
              "z": 0.361
            },
            "rightCorner": {
              "x": 0.14,
              "y": 27.013,
              "z": 0.361
            },
            "gtin": "5000204076844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d78",
            "leftCorner": {
              "x": 0.141,
              "y": 27.029,
              "z": 0.361
            },
            "rightCorner": {
              "x": 0.239,
              "y": 27.023,
              "z": 0.361
            },
            "gtin": "5000204361254",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466e1",
        "height": 0.69775,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20d89",
            "leftCorner": {
              "x": -1.011,
              "y": 27.051,
              "z": 0.571
            },
            "rightCorner": {
              "x": -0.949,
              "y": 27.048,
              "z": 0.571
            },
            "gtin": "5000204598711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d8c",
            "leftCorner": {
              "x": -0.947,
              "y": 27.086,
              "z": 0.571
            },
            "rightCorner": {
              "x": -0.906,
              "y": 27.083,
              "z": 0.571
            },
            "gtin": "5000204256598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d8d",
            "leftCorner": {
              "x": -0.906,
              "y": 27.083,
              "z": 0.571
            },
            "rightCorner": {
              "x": -0.866,
              "y": 27.082,
              "z": 0.571
            },
            "gtin": "5000204256598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d8e",
            "leftCorner": {
              "x": -0.865,
              "y": 27.091,
              "z": 0.571
            },
            "rightCorner": {
              "x": -0.736,
              "y": 27.083,
              "z": 0.571
            },
            "gtin": "5000204598926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d8f",
            "leftCorner": {
              "x": -0.736,
              "y": 27.075,
              "z": 0.571
            },
            "rightCorner": {
              "x": -0.665,
              "y": 27.07,
              "z": 0.571
            },
            "gtin": "5000204075892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d90",
            "leftCorner": {
              "x": -0.665,
              "y": 27.07,
              "z": 0.571
            },
            "rightCorner": {
              "x": -0.594,
              "y": 27.066,
              "z": 0.571
            },
            "gtin": "5000204075892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d91",
            "leftCorner": {
              "x": -0.595,
              "y": 27.06,
              "z": 0.571
            },
            "rightCorner": {
              "x": -0.522,
              "y": 27.056,
              "z": 0.571
            },
            "gtin": "5000204075960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d92",
            "leftCorner": {
              "x": -0.522,
              "y": 27.056,
              "z": 0.571
            },
            "rightCorner": {
              "x": -0.449,
              "y": 27.051,
              "z": 0.571
            },
            "gtin": "5000204075960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d93",
            "leftCorner": {
              "x": -0.449,
              "y": 27.056,
              "z": 0.571
            },
            "rightCorner": {
              "x": -0.37,
              "y": 27.051,
              "z": 0.571
            },
            "gtin": "5000204256505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d94",
            "leftCorner": {
              "x": -0.37,
              "y": 27.043,
              "z": 0.571
            },
            "rightCorner": {
              "x": -0.3,
              "y": 27.039,
              "z": 0.571
            },
            "gtin": "4036889005863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d95",
            "leftCorner": {
              "x": -0.3,
              "y": 27.039,
              "z": 0.571
            },
            "rightCorner": {
              "x": -0.23,
              "y": 27.034,
              "z": 0.571
            },
            "gtin": "4036889005863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d96",
            "leftCorner": {
              "x": -0.231,
              "y": 27.021,
              "z": 0.571
            },
            "rightCorner": {
              "x": -0.105,
              "y": 27.013,
              "z": 0.571
            },
            "gtin": "4337185291807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d97",
            "leftCorner": {
              "x": -0.105,
              "y": 27.014,
              "z": 0.571
            },
            "rightCorner": {
              "x": -0.032,
              "y": 27.01,
              "z": 0.571
            },
            "gtin": "4337185291821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d98",
            "leftCorner": {
              "x": -0.032,
              "y": 27.01,
              "z": 0.571
            },
            "rightCorner": {
              "x": 0.041,
              "y": 27.005,
              "z": 0.571
            },
            "gtin": "4337185291821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d99",
            "leftCorner": {
              "x": 0.042,
              "y": 27.02,
              "z": 0.571
            },
            "rightCorner": {
              "x": 0.161,
              "y": 27.012,
              "z": 0.571
            },
            "gtin": "4337185291845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d8a",
            "leftCorner": {
              "x": 0.161,
              "y": 27.006,
              "z": 0.571
            },
            "rightCorner": {
              "x": 0.2,
              "y": 27.004,
              "z": 0.571
            },
            "gtin": "5000204378870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d8b",
            "leftCorner": {
              "x": 0.2,
              "y": 27.004,
              "z": 0.571
            },
            "rightCorner": {
              "x": 0.238,
              "y": 27.002,
              "z": 0.571
            },
            "gtin": "5000204378870",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466e5",
        "height": 1.2045,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20dd6",
            "leftCorner": {
              "x": -1.012,
              "y": 27.045,
              "z": 0.985
            },
            "rightCorner": {
              "x": -0.889,
              "y": 27.038,
              "z": 0.985
            },
            "gtin": "5000204364477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dd7",
            "leftCorner": {
              "x": -0.887,
              "y": 27.077,
              "z": 0.985
            },
            "rightCorner": {
              "x": -0.831,
              "y": 27.074,
              "z": 0.985
            },
            "gtin": "5000204256260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dd8",
            "leftCorner": {
              "x": -0.831,
              "y": 27.078,
              "z": 0.985
            },
            "rightCorner": {
              "x": -0.734,
              "y": 27.072,
              "z": 0.985
            },
            "gtin": "5000204732368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dd9",
            "leftCorner": {
              "x": -0.734,
              "y": 27.071,
              "z": 0.985
            },
            "rightCorner": {
              "x": -0.66,
              "y": 27.068,
              "z": 0.985
            },
            "gtin": "5000204731651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dda",
            "leftCorner": {
              "x": -0.66,
              "y": 27.068,
              "z": 0.985
            },
            "rightCorner": {
              "x": -0.612,
              "y": 27.065,
              "z": 0.985
            },
            "gtin": "5000204073010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ddb",
            "leftCorner": {
              "x": -0.612,
              "y": 27.056,
              "z": 0.985
            },
            "rightCorner": {
              "x": -0.52,
              "y": 27.05,
              "z": 0.985
            },
            "gtin": "5000204379082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ddc",
            "leftCorner": {
              "x": -0.519,
              "y": 27.062,
              "z": 0.985
            },
            "rightCorner": {
              "x": -0.459,
              "y": 27.058,
              "z": 0.985
            },
            "gtin": "4251758415370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ddd",
            "leftCorner": {
              "x": -0.459,
              "y": 27.058,
              "z": 0.985
            },
            "rightCorner": {
              "x": -0.398,
              "y": 27.055,
              "z": 0.985
            },
            "gtin": "4251758415370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dde",
            "leftCorner": {
              "x": -0.399,
              "y": 27.04,
              "z": 0.985
            },
            "rightCorner": {
              "x": -0.294,
              "y": 27.033,
              "z": 0.985
            },
            "gtin": "4251758432025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ddf",
            "leftCorner": {
              "x": -0.294,
              "y": 27.033,
              "z": 0.985
            },
            "rightCorner": {
              "x": -0.188,
              "y": 27.027,
              "z": 0.985
            },
            "gtin": "4251758432025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20de0",
            "leftCorner": {
              "x": -0.189,
              "y": 27.019,
              "z": 0.985
            },
            "rightCorner": {
              "x": -0.113,
              "y": 27.014,
              "z": 0.985
            },
            "gtin": "4251758422446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20de1",
            "leftCorner": {
              "x": -0.113,
              "y": 27.014,
              "z": 0.985
            },
            "rightCorner": {
              "x": -0.038,
              "y": 27.01,
              "z": 0.985
            },
            "gtin": "4251758422446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20de2",
            "leftCorner": {
              "x": -0.037,
              "y": 27.024,
              "z": 0.985
            },
            "rightCorner": {
              "x": 0.022,
              "y": 27.02,
              "z": 0.985
            },
            "gtin": "4251758415325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20de3",
            "leftCorner": {
              "x": 0.022,
              "y": 27.02,
              "z": 0.985
            },
            "rightCorner": {
              "x": 0.081,
              "y": 27.017,
              "z": 0.985
            },
            "gtin": "4251758415325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20de4",
            "leftCorner": {
              "x": 0.081,
              "y": 27.017,
              "z": 0.985
            },
            "rightCorner": {
              "x": 0.139,
              "y": 27.013,
              "z": 0.985
            },
            "gtin": "4251758415325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20de5",
            "leftCorner": {
              "x": 0.14,
              "y": 27.022,
              "z": 0.985
            },
            "rightCorner": {
              "x": 0.215,
              "y": 27.017,
              "z": 0.985
            },
            "gtin": "4251758422484",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d7a",
    "rightNeighborShelfId": "a6d7c"
  },
  {
    "id": "a6d7c",
    "name": "a6d7c",
    "x": 0.236,
    "y": 26.961,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.030163,
      "w": 0.99954
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 100,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5466ed",
        "height": 0.14187,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20dee",
            "leftCorner": {
              "x": 0.551,
              "y": 26.95,
              "z": 0.116
            },
            "rightCorner": {
              "x": 0.728,
              "y": 26.939,
              "z": 0.116
            },
            "gtin": "8700216287876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20def",
            "leftCorner": {
              "x": 0.73,
              "y": 26.972,
              "z": 0.116
            },
            "rightCorner": {
              "x": 0.818,
              "y": 26.967,
              "z": 0.116
            },
            "gtin": "8700216238977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20df0",
            "leftCorner": {
              "x": 0.818,
              "y": 26.967,
              "z": 0.116
            },
            "rightCorner": {
              "x": 0.906,
              "y": 26.961,
              "z": 0.116
            },
            "gtin": "8700216238977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20df1",
            "leftCorner": {
              "x": 0.906,
              "y": 26.961,
              "z": 0.116
            },
            "rightCorner": {
              "x": 0.995,
              "y": 26.956,
              "z": 0.116
            },
            "gtin": "8700216238977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20df2",
            "leftCorner": {
              "x": 0.995,
              "y": 26.956,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.083,
              "y": 26.951,
              "z": 0.116
            },
            "gtin": "8700216238977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20df3",
            "leftCorner": {
              "x": 1.084,
              "y": 26.966,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.182,
              "y": 26.959,
              "z": 0.116
            },
            "gtin": "4262429770506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20df4",
            "leftCorner": {
              "x": 1.182,
              "y": 26.962,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.291,
              "y": 26.956,
              "z": 0.116
            },
            "gtin": "4337185627699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20df5",
            "leftCorner": {
              "x": 1.291,
              "y": 26.956,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.4,
              "y": 26.949,
              "z": 0.116
            },
            "gtin": "4337185627699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20de9",
            "leftCorner": {
              "x": 1.4,
              "y": 26.948,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.444,
              "y": 26.946,
              "z": 0.116
            },
            "gtin": "4337185627644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dea",
            "leftCorner": {
              "x": 1.444,
              "y": 26.946,
              "z": 0.116
            },
            "rightCorner": {
              "x": 1.487,
              "y": 26.943,
              "z": 0.116
            },
            "gtin": "4337185627644",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466ea",
        "height": 0.54149,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e16",
            "leftCorner": {
              "x": 0.237,
              "y": 26.973,
              "z": 0.443
            },
            "rightCorner": {
              "x": 0.353,
              "y": 26.965,
              "z": 0.443
            },
            "gtin": "4036889002848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e17",
            "leftCorner": {
              "x": 0.353,
              "y": 26.965,
              "z": 0.443
            },
            "rightCorner": {
              "x": 0.469,
              "y": 26.958,
              "z": 0.443
            },
            "gtin": "4036889002848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e18",
            "leftCorner": {
              "x": 0.469,
              "y": 26.958,
              "z": 0.443
            },
            "rightCorner": {
              "x": 0.586,
              "y": 26.952,
              "z": 0.443
            },
            "gtin": "4036889002848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e1a",
            "leftCorner": {
              "x": 0.587,
              "y": 26.979,
              "z": 0.443
            },
            "rightCorner": {
              "x": 0.699,
              "y": 26.972,
              "z": 0.443
            },
            "gtin": "4022142300813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e1b",
            "leftCorner": {
              "x": 0.699,
              "y": 26.981,
              "z": 0.443
            },
            "rightCorner": {
              "x": 0.769,
              "y": 26.976,
              "z": 0.443
            },
            "gtin": "4002448027225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e1c",
            "leftCorner": {
              "x": 0.769,
              "y": 26.979,
              "z": 0.443
            },
            "rightCorner": {
              "x": 0.926,
              "y": 26.969,
              "z": 0.443
            },
            "gtin": "4002448026167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e1d",
            "leftCorner": {
              "x": 0.927,
              "y": 26.983,
              "z": 0.443
            },
            "rightCorner": {
              "x": 0.98,
              "y": 26.98,
              "z": 0.443
            },
            "gtin": "3059946079363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e1e",
            "leftCorner": {
              "x": 0.98,
              "y": 26.971,
              "z": 0.443
            },
            "rightCorner": {
              "x": 1.066,
              "y": 26.966,
              "z": 0.443
            },
            "gtin": "3059946079356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e1f",
            "leftCorner": {
              "x": 1.066,
              "y": 26.963,
              "z": 0.443
            },
            "rightCorner": {
              "x": 1.173,
              "y": 26.956,
              "z": 0.443
            },
            "gtin": "8700216731287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e20",
            "leftCorner": {
              "x": 1.174,
              "y": 26.966,
              "z": 0.443
            },
            "rightCorner": {
              "x": 1.267,
              "y": 26.96,
              "z": 0.443
            },
            "gtin": "8700216657143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e21",
            "leftCorner": {
              "x": 1.267,
              "y": 26.954,
              "z": 0.443
            },
            "rightCorner": {
              "x": 1.396,
              "y": 26.946,
              "z": 0.443
            },
            "gtin": "8700216657075",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20e19",
            "leftCorner": {
              "x": 1.394,
              "y": 26.925,
              "z": 0.443
            },
            "rightCorner": {
              "x": 1.486,
              "y": 26.919,
              "z": 0.443
            },
            "gtin": "4337185055386",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466e7",
        "height": 0.84063,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20df6",
            "leftCorner": {
              "x": 0.236,
              "y": 26.96,
              "z": 0.688
            },
            "rightCorner": {
              "x": 0.317,
              "y": 26.955,
              "z": 0.688
            },
            "gtin": "5000204332476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20df8",
            "leftCorner": {
              "x": 0.319,
              "y": 26.982,
              "z": 0.688
            },
            "rightCorner": {
              "x": 0.362,
              "y": 26.98,
              "z": 0.688
            },
            "gtin": "5000204333107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20df9",
            "leftCorner": {
              "x": 0.363,
              "y": 26.988,
              "z": 0.688
            },
            "rightCorner": {
              "x": 0.424,
              "y": 26.984,
              "z": 0.688
            },
            "gtin": "5000204332773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dfa",
            "leftCorner": {
              "x": 0.422,
              "y": 26.964,
              "z": 0.688
            },
            "rightCorner": {
              "x": 0.475,
              "y": 26.96,
              "z": 0.688
            },
            "gtin": "5000204364446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dfb",
            "leftCorner": {
              "x": 0.475,
              "y": 26.96,
              "z": 0.688
            },
            "rightCorner": {
              "x": 0.528,
              "y": 26.957,
              "z": 0.688
            },
            "gtin": "5000204364446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dfc",
            "leftCorner": {
              "x": 0.529,
              "y": 26.98,
              "z": 0.688
            },
            "rightCorner": {
              "x": 0.632,
              "y": 26.974,
              "z": 0.688
            },
            "gtin": "5000204378931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dfd",
            "leftCorner": {
              "x": 0.632,
              "y": 26.973,
              "z": 0.688
            },
            "rightCorner": {
              "x": 0.705,
              "y": 26.969,
              "z": 0.688
            },
            "gtin": "4008455105314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dfe",
            "leftCorner": {
              "x": 0.705,
              "y": 26.969,
              "z": 0.688
            },
            "rightCorner": {
              "x": 0.779,
              "y": 26.965,
              "z": 0.688
            },
            "gtin": "4008455105314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dff",
            "leftCorner": {
              "x": 0.779,
              "y": 26.973,
              "z": 0.688
            },
            "rightCorner": {
              "x": 0.948,
              "y": 26.962,
              "z": 0.688
            },
            "gtin": "8700216833875",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e00",
            "leftCorner": {
              "x": 0.949,
              "y": 26.975,
              "z": 0.688
            },
            "rightCorner": {
              "x": 1.008,
              "y": 26.971,
              "z": 0.688
            },
            "gtin": "8700216483216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e01",
            "leftCorner": {
              "x": 1.008,
              "y": 26.971,
              "z": 0.688
            },
            "rightCorner": {
              "x": 1.067,
              "y": 26.968,
              "z": 0.688
            },
            "gtin": "8700216483216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e02",
            "leftCorner": {
              "x": 1.068,
              "y": 26.977,
              "z": 0.688
            },
            "rightCorner": {
              "x": 1.177,
              "y": 26.97,
              "z": 0.688
            },
            "gtin": "8700216483162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e03",
            "leftCorner": {
              "x": 1.177,
              "y": 26.959,
              "z": 0.688
            },
            "rightCorner": {
              "x": 1.241,
              "y": 26.956,
              "z": 0.688
            },
            "gtin": "8700216483230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e04",
            "leftCorner": {
              "x": 1.241,
              "y": 26.956,
              "z": 0.688
            },
            "rightCorner": {
              "x": 1.304,
              "y": 26.952,
              "z": 0.688
            },
            "gtin": "8700216483230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e05",
            "leftCorner": {
              "x": 1.304,
              "y": 26.944,
              "z": 0.688
            },
            "rightCorner": {
              "x": 1.385,
              "y": 26.939,
              "z": 0.688
            },
            "gtin": "8006540542248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20df7",
            "leftCorner": {
              "x": 1.386,
              "y": 26.956,
              "z": 0.688
            },
            "rightCorner": {
              "x": 1.488,
              "y": 26.95,
              "z": 0.688
            },
            "gtin": "8001090839305",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466eb",
        "height": 1.1414,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e22",
            "leftCorner": {
              "x": 0.237,
              "y": 26.972,
              "z": 0.934
            },
            "rightCorner": {
              "x": 0.318,
              "y": 26.967,
              "z": 0.934
            },
            "gtin": "4251758414663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e23",
            "leftCorner": {
              "x": 0.318,
              "y": 26.967,
              "z": 0.934
            },
            "rightCorner": {
              "x": 0.399,
              "y": 26.962,
              "z": 0.934
            },
            "gtin": "4251758414663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e24",
            "leftCorner": {
              "x": 0.399,
              "y": 26.962,
              "z": 0.934
            },
            "rightCorner": {
              "x": 0.481,
              "y": 26.957,
              "z": 0.934
            },
            "gtin": "4251758414663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e25",
            "leftCorner": {
              "x": 0.482,
              "y": 26.982,
              "z": 0.934
            },
            "rightCorner": {
              "x": 0.556,
              "y": 26.978,
              "z": 0.934
            },
            "gtin": "4251758433619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e26",
            "leftCorner": {
              "x": 0.556,
              "y": 26.971,
              "z": 0.934
            },
            "rightCorner": {
              "x": 0.703,
              "y": 26.963,
              "z": 0.934
            },
            "gtin": "4251758433473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e27",
            "leftCorner": {
              "x": 0.704,
              "y": 26.98,
              "z": 0.934
            },
            "rightCorner": {
              "x": 0.824,
              "y": 26.973,
              "z": 0.934
            },
            "gtin": "4251758433596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e28",
            "leftCorner": {
              "x": 0.824,
              "y": 26.976,
              "z": 0.934
            },
            "rightCorner": {
              "x": 0.901,
              "y": 26.971,
              "z": 0.934
            },
            "gtin": "4251758433459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e29",
            "leftCorner": {
              "x": 0.902,
              "y": 26.979,
              "z": 0.934
            },
            "rightCorner": {
              "x": 0.946,
              "y": 26.976,
              "z": 0.934
            },
            "gtin": "4251758432841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e2a",
            "leftCorner": {
              "x": 0.945,
              "y": 26.968,
              "z": 0.934
            },
            "rightCorner": {
              "x": 1.009,
              "y": 26.964,
              "z": 0.934
            },
            "gtin": "4251758414472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e2b",
            "leftCorner": {
              "x": 1.009,
              "y": 26.968,
              "z": 0.934
            },
            "rightCorner": {
              "x": 1.117,
              "y": 26.962,
              "z": 0.934
            },
            "gtin": "4251758414496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e2c",
            "leftCorner": {
              "x": 1.117,
              "y": 26.962,
              "z": 0.934
            },
            "rightCorner": {
              "x": 1.167,
              "y": 26.959,
              "z": 0.934
            },
            "gtin": "4251758423122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e2d",
            "leftCorner": {
              "x": 1.167,
              "y": 26.959,
              "z": 0.934
            },
            "rightCorner": {
              "x": 1.217,
              "y": 26.955,
              "z": 0.934
            },
            "gtin": "4251758423122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e2e",
            "leftCorner": {
              "x": 1.217,
              "y": 26.965,
              "z": 0.934
            },
            "rightCorner": {
              "x": 1.257,
              "y": 26.962,
              "z": 0.934
            },
            "gtin": "4251758433497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e2f",
            "leftCorner": {
              "x": 1.257,
              "y": 26.962,
              "z": 0.934
            },
            "rightCorner": {
              "x": 1.297,
              "y": 26.96,
              "z": 0.934
            },
            "gtin": "4251758433497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e30",
            "leftCorner": {
              "x": 1.297,
              "y": 26.95,
              "z": 0.934
            },
            "rightCorner": {
              "x": 1.383,
              "y": 26.945,
              "z": 0.934
            },
            "gtin": "4251758433510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e31",
            "leftCorner": {
              "x": 1.383,
              "y": 26.953,
              "z": 0.934
            },
            "rightCorner": {
              "x": 1.455,
              "y": 26.949,
              "z": 0.934
            },
            "gtin": "4251758433800",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466ec",
        "height": 1.3613,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e32",
            "leftCorner": {
              "x": 0.236,
              "y": 26.968,
              "z": 1.114
            },
            "rightCorner": {
              "x": 0.329,
              "y": 26.963,
              "z": 1.114
            },
            "gtin": "4251758432315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e33",
            "leftCorner": {
              "x": 0.329,
              "y": 26.963,
              "z": 1.114
            },
            "rightCorner": {
              "x": 0.421,
              "y": 26.958,
              "z": 1.114
            },
            "gtin": "4251758432315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e34",
            "leftCorner": {
              "x": 0.421,
              "y": 26.958,
              "z": 1.114
            },
            "rightCorner": {
              "x": 0.513,
              "y": 26.951,
              "z": 1.114
            },
            "gtin": "4251758432315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e35",
            "leftCorner": {
              "x": 0.513,
              "y": 26.951,
              "z": 1.114
            },
            "rightCorner": {
              "x": 0.605,
              "y": 26.946,
              "z": 1.114
            },
            "gtin": "4251758432315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e37",
            "leftCorner": {
              "x": 0.606,
              "y": 26.959,
              "z": 1.114
            },
            "rightCorner": {
              "x": 0.732,
              "y": 26.951,
              "z": 1.114
            },
            "gtin": "5000204349818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e38",
            "leftCorner": {
              "x": 0.731,
              "y": 26.942,
              "z": 1.114
            },
            "rightCorner": {
              "x": 0.845,
              "y": 26.935,
              "z": 1.114
            },
            "gtin": "5000204355444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e39",
            "leftCorner": {
              "x": 0.847,
              "y": 26.971,
              "z": 1.114
            },
            "rightCorner": {
              "x": 0.942,
              "y": 26.966,
              "z": 1.114
            },
            "gtin": "4002448048848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e3a",
            "leftCorner": {
              "x": 0.941,
              "y": 26.962,
              "z": 1.114
            },
            "rightCorner": {
              "x": 1.026,
              "y": 26.957,
              "z": 1.114
            },
            "gtin": "4251758432780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e3b",
            "leftCorner": {
              "x": 1.027,
              "y": 26.964,
              "z": 1.114
            },
            "rightCorner": {
              "x": 1.103,
              "y": 26.959,
              "z": 1.114
            },
            "gtin": "4251758423863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e3c",
            "leftCorner": {
              "x": 1.103,
              "y": 26.953,
              "z": 1.114
            },
            "rightCorner": {
              "x": 1.176,
              "y": 26.949,
              "z": 1.114
            },
            "gtin": "4002448062288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e3d",
            "leftCorner": {
              "x": 1.176,
              "y": 26.952,
              "z": 1.114
            },
            "rightCorner": {
              "x": 1.233,
              "y": 26.949,
              "z": 1.114
            },
            "gtin": "4002448086147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e3e",
            "leftCorner": {
              "x": 1.233,
              "y": 26.949,
              "z": 1.114
            },
            "rightCorner": {
              "x": 1.289,
              "y": 26.946,
              "z": 1.114
            },
            "gtin": "4002448086147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e3f",
            "leftCorner": {
              "x": 1.289,
              "y": 26.932,
              "z": 1.114
            },
            "rightCorner": {
              "x": 1.359,
              "y": 26.927,
              "z": 1.114
            },
            "gtin": "4251758403155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e40",
            "leftCorner": {
              "x": 1.36,
              "y": 26.948,
              "z": 1.114
            },
            "rightCorner": {
              "x": 1.447,
              "y": 26.942,
              "z": 1.114
            },
            "gtin": "4251758433435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e36",
            "leftCorner": {
              "x": 1.447,
              "y": 26.942,
              "z": 1.114
            },
            "rightCorner": {
              "x": 1.487,
              "y": 26.94,
              "z": 1.114
            },
            "gtin": "4251758433411",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466e8",
        "height": 1.5441,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e06",
            "leftCorner": {
              "x": 0.237,
              "y": 26.973,
              "z": 1.263
            },
            "rightCorner": {
              "x": 0.362,
              "y": 26.966,
              "z": 1.263
            },
            "gtin": "5000204356656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e07",
            "leftCorner": {
              "x": 0.362,
              "y": 26.966,
              "z": 1.263
            },
            "rightCorner": {
              "x": 0.487,
              "y": 26.958,
              "z": 1.263
            },
            "gtin": "5000204356656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e08",
            "leftCorner": {
              "x": 0.487,
              "y": 26.958,
              "z": 1.263
            },
            "rightCorner": {
              "x": 0.612,
              "y": 26.951,
              "z": 1.263
            },
            "gtin": "5000204356656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e0a",
            "leftCorner": {
              "x": 0.613,
              "y": 26.981,
              "z": 1.263
            },
            "rightCorner": {
              "x": 0.683,
              "y": 26.977,
              "z": 1.263
            },
            "gtin": "5000204960686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e0b",
            "leftCorner": {
              "x": 0.683,
              "y": 26.982,
              "z": 1.263
            },
            "rightCorner": {
              "x": 0.732,
              "y": 26.979,
              "z": 1.263
            },
            "gtin": "5000204357103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e0c",
            "leftCorner": {
              "x": 0.732,
              "y": 26.979,
              "z": 1.263
            },
            "rightCorner": {
              "x": 0.781,
              "y": 26.977,
              "z": 1.263
            },
            "gtin": "5000204357103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e0d",
            "leftCorner": {
              "x": 0.78,
              "y": 26.968,
              "z": 1.263
            },
            "rightCorner": {
              "x": 0.839,
              "y": 26.964,
              "z": 1.263
            },
            "gtin": "5000204356502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e0e",
            "leftCorner": {
              "x": 0.839,
              "y": 26.964,
              "z": 1.263
            },
            "rightCorner": {
              "x": 0.898,
              "y": 26.961,
              "z": 1.263
            },
            "gtin": "5000204356502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e0f",
            "leftCorner": {
              "x": 0.898,
              "y": 26.961,
              "z": 1.263
            },
            "rightCorner": {
              "x": 0.957,
              "y": 26.958,
              "z": 1.263
            },
            "gtin": "5000204356502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e10",
            "leftCorner": {
              "x": 0.958,
              "y": 26.98,
              "z": 1.263
            },
            "rightCorner": {
              "x": 1.044,
              "y": 26.975,
              "z": 1.263
            },
            "gtin": "5000204356380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e11",
            "leftCorner": {
              "x": 1.044,
              "y": 26.975,
              "z": 1.263
            },
            "rightCorner": {
              "x": 1.13,
              "y": 26.969,
              "z": 1.263
            },
            "gtin": "5000204356380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e12",
            "leftCorner": {
              "x": 1.13,
              "y": 26.967,
              "z": 1.263
            },
            "rightCorner": {
              "x": 1.182,
              "y": 26.964,
              "z": 1.263
            },
            "gtin": "4251758422842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e13",
            "leftCorner": {
              "x": 1.182,
              "y": 26.964,
              "z": 1.263
            },
            "rightCorner": {
              "x": 1.233,
              "y": 26.961,
              "z": 1.263
            },
            "gtin": "4251758422842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e14",
            "leftCorner": {
              "x": 1.233,
              "y": 26.959,
              "z": 1.263
            },
            "rightCorner": {
              "x": 1.334,
              "y": 26.954,
              "z": 1.263
            },
            "gtin": "5000204356809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e15",
            "leftCorner": {
              "x": 1.334,
              "y": 26.956,
              "z": 1.263
            },
            "rightCorner": {
              "x": 1.439,
              "y": 26.95,
              "z": 1.263
            },
            "gtin": "5000204362817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e09",
            "leftCorner": {
              "x": 1.439,
              "y": 26.951,
              "z": 1.263
            },
            "rightCorner": {
              "x": 1.487,
              "y": 26.948,
              "z": 1.263
            },
            "gtin": "5000204378542",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466e9",
        "height": 1.7411,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20dc7",
            "leftCorner": {
              "x": 0.252,
              "y": 27.006,
              "z": 1.425
            },
            "rightCorner": {
              "x": 0.311,
              "y": 27.002,
              "z": 1.425
            },
            "gtin": "4000869031845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dc8",
            "leftCorner": {
              "x": 0.311,
              "y": 27.002,
              "z": 1.425
            },
            "rightCorner": {
              "x": 0.37,
              "y": 26.999,
              "z": 1.425
            },
            "gtin": "4000869031845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dc9",
            "leftCorner": {
              "x": 0.37,
              "y": 26.993,
              "z": 1.425
            },
            "rightCorner": {
              "x": 0.445,
              "y": 26.988,
              "z": 1.425
            },
            "gtin": "4000869031821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dca",
            "leftCorner": {
              "x": 0.445,
              "y": 26.988,
              "z": 1.425
            },
            "rightCorner": {
              "x": 0.519,
              "y": 26.984,
              "z": 1.425
            },
            "gtin": "4000869031821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dcb",
            "leftCorner": {
              "x": 0.519,
              "y": 26.973,
              "z": 1.425
            },
            "rightCorner": {
              "x": 0.566,
              "y": 26.97,
              "z": 1.425
            },
            "gtin": "5000204378542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dcc",
            "leftCorner": {
              "x": 0.566,
              "y": 26.97,
              "z": 1.425
            },
            "rightCorner": {
              "x": 0.613,
              "y": 26.967,
              "z": 1.425
            },
            "gtin": "5000204378542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dcd",
            "leftCorner": {
              "x": 0.613,
              "y": 26.974,
              "z": 1.425
            },
            "rightCorner": {
              "x": 0.731,
              "y": 26.966,
              "z": 1.425
            },
            "gtin": "5000204378481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dce",
            "leftCorner": {
              "x": 0.732,
              "y": 26.984,
              "z": 1.425
            },
            "rightCorner": {
              "x": 0.81,
              "y": 26.979,
              "z": 1.425
            },
            "gtin": "5000204362848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dcf",
            "leftCorner": {
              "x": 0.81,
              "y": 26.979,
              "z": 1.425
            },
            "rightCorner": {
              "x": 0.888,
              "y": 26.974,
              "z": 1.425
            },
            "gtin": "5000204362848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dd0",
            "leftCorner": {
              "x": 0.889,
              "y": 26.98,
              "z": 1.425
            },
            "rightCorner": {
              "x": 0.989,
              "y": 26.975,
              "z": 1.425
            },
            "gtin": "5000204378511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dd1",
            "leftCorner": {
              "x": 0.988,
              "y": 26.959,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.08,
              "y": 26.953,
              "z": 1.425
            },
            "gtin": "5000204336733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dd2",
            "leftCorner": {
              "x": 1.08,
              "y": 26.953,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.173,
              "y": 26.947,
              "z": 1.425
            },
            "gtin": "5000204336733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dd3",
            "leftCorner": {
              "x": 1.174,
              "y": 26.962,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.229,
              "y": 26.959,
              "z": 1.425
            },
            "gtin": "5000204362909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dd4",
            "leftCorner": {
              "x": 1.229,
              "y": 26.959,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.284,
              "y": 26.956,
              "z": 1.425
            },
            "gtin": "5000204362909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20dd5",
            "leftCorner": {
              "x": 1.284,
              "y": 26.956,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.34,
              "y": 26.952,
              "z": 1.425
            },
            "gtin": "5000204362909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20db7",
            "leftCorner": {
              "x": 1.34,
              "y": 26.95,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.487,
              "y": 26.942,
              "z": 1.425
            },
            "gtin": "5000204362879",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d7b",
    "rightNeighborShelfId": "a6d7d"
  },
  {
    "id": "a6d7d",
    "name": "a6d7d",
    "x": 1.471,
    "y": 26.724,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.019512,
      "w": 0.99981
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 32,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5466f1",
        "height": 0.13,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e5e",
            "leftCorner": {
              "x": 1.471,
              "y": 26.714,
              "z": 0.106
            },
            "rightCorner": {
              "x": 1.948,
              "y": 26.695,
              "z": 0.106
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e5f",
            "leftCorner": {
              "x": 1.948,
              "y": 26.695,
              "z": 0.106
            },
            "rightCorner": {
              "x": 2.425,
              "y": 26.676,
              "z": 0.106
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e60",
            "leftCorner": {
              "x": 2.426,
              "y": 26.716,
              "z": 0.106
            },
            "rightCorner": {
              "x": 2.525,
              "y": 26.712,
              "z": 0.106
            },
            "gtin": "4051281982000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e61",
            "leftCorner": {
              "x": 2.525,
              "y": 26.712,
              "z": 0.106
            },
            "rightCorner": {
              "x": 2.623,
              "y": 26.708,
              "z": 0.106
            },
            "gtin": "4051281982000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e62",
            "leftCorner": {
              "x": 2.623,
              "y": 26.708,
              "z": 0.106
            },
            "rightCorner": {
              "x": 2.721,
              "y": 26.705,
              "z": 0.106
            },
            "gtin": "4051281982000",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466ee",
        "height": 0.47226,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e41",
            "leftCorner": {
              "x": 1.471,
              "y": 26.719,
              "z": 0.386
            },
            "rightCorner": {
              "x": 1.629,
              "y": 26.712,
              "z": 0.386
            },
            "gtin": "4051281981904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e44",
            "leftCorner": {
              "x": 1.631,
              "y": 26.756,
              "z": 0.386
            },
            "rightCorner": {
              "x": 1.773,
              "y": 26.75,
              "z": 0.386
            },
            "gtin": "4051281961920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e45",
            "leftCorner": {
              "x": 1.772,
              "y": 26.739,
              "z": 0.386
            },
            "rightCorner": {
              "x": 1.903,
              "y": 26.735,
              "z": 0.386
            },
            "gtin": "4051281981867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e46",
            "leftCorner": {
              "x": 1.903,
              "y": 26.744,
              "z": 0.386
            },
            "rightCorner": {
              "x": 2.066,
              "y": 26.738,
              "z": 0.386
            },
            "gtin": "4051281981782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e47",
            "leftCorner": {
              "x": 2.066,
              "y": 26.739,
              "z": 0.386
            },
            "rightCorner": {
              "x": 2.128,
              "y": 26.736,
              "z": 0.386
            },
            "gtin": "4051281962026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e48",
            "leftCorner": {
              "x": 2.128,
              "y": 26.738,
              "z": 0.386
            },
            "rightCorner": {
              "x": 2.201,
              "y": 26.735,
              "z": 0.386
            },
            "gtin": "4051281981768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e49",
            "leftCorner": {
              "x": 2.201,
              "y": 26.73,
              "z": 0.386
            },
            "rightCorner": {
              "x": 2.332,
              "y": 26.725,
              "z": 0.386
            },
            "gtin": "4051281981966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e4a",
            "leftCorner": {
              "x": 2.331,
              "y": 26.718,
              "z": 0.386
            },
            "rightCorner": {
              "x": 2.422,
              "y": 26.713,
              "z": 0.386
            },
            "gtin": "4051281961869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e42",
            "leftCorner": {
              "x": 2.422,
              "y": 26.717,
              "z": 0.386
            },
            "rightCorner": {
              "x": 2.572,
              "y": 26.712,
              "z": 0.386
            },
            "gtin": "4051281981928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e43",
            "leftCorner": {
              "x": 2.572,
              "y": 26.712,
              "z": 0.386
            },
            "rightCorner": {
              "x": 2.721,
              "y": 26.706,
              "z": 0.386
            },
            "gtin": "4051281981928",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466f0",
        "height": 0.79274,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e58",
            "leftCorner": {
              "x": 1.472,
              "y": 26.757,
              "z": 0.649
            },
            "rightCorner": {
              "x": 1.808,
              "y": 26.744,
              "z": 0.649
            },
            "gtin": "4051281982048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e59",
            "leftCorner": {
              "x": 1.808,
              "y": 26.744,
              "z": 0.649
            },
            "rightCorner": {
              "x": 2.144,
              "y": 26.731,
              "z": 0.649
            },
            "gtin": "4051281982048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e5a",
            "leftCorner": {
              "x": 2.145,
              "y": 26.768,
              "z": 0.649
            },
            "rightCorner": {
              "x": 2.29,
              "y": 26.763,
              "z": 0.649
            },
            "gtin": "4051281982024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e5b",
            "leftCorner": {
              "x": 2.29,
              "y": 26.763,
              "z": 0.649
            },
            "rightCorner": {
              "x": 2.434,
              "y": 26.757,
              "z": 0.649
            },
            "gtin": "4051281982024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e5c",
            "leftCorner": {
              "x": 2.434,
              "y": 26.757,
              "z": 0.649
            },
            "rightCorner": {
              "x": 2.578,
              "y": 26.752,
              "z": 0.649
            },
            "gtin": "4051281982024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e5d",
            "leftCorner": {
              "x": 2.578,
              "y": 26.752,
              "z": 0.649
            },
            "rightCorner": {
              "x": 2.723,
              "y": 26.746,
              "z": 0.649
            },
            "gtin": "4051281982024",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466ef",
        "height": 1.0037,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e4b",
            "leftCorner": {
              "x": 1.472,
              "y": 26.741,
              "z": 0.821
            },
            "rightCorner": {
              "x": 1.574,
              "y": 26.737,
              "z": 0.821
            },
            "gtin": "4051281920149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e4c",
            "leftCorner": {
              "x": 1.574,
              "y": 26.737,
              "z": 0.821
            },
            "rightCorner": {
              "x": 1.677,
              "y": 26.734,
              "z": 0.821
            },
            "gtin": "4051281920149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e4d",
            "leftCorner": {
              "x": 1.677,
              "y": 26.734,
              "z": 0.821
            },
            "rightCorner": {
              "x": 1.779,
              "y": 26.729,
              "z": 0.821
            },
            "gtin": "4051281920149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e4f",
            "leftCorner": {
              "x": 1.781,
              "y": 26.777,
              "z": 0.821
            },
            "rightCorner": {
              "x": 1.851,
              "y": 26.774,
              "z": 0.821
            },
            "gtin": "4051281920163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e50",
            "leftCorner": {
              "x": 1.851,
              "y": 26.774,
              "z": 0.821
            },
            "rightCorner": {
              "x": 1.922,
              "y": 26.772,
              "z": 0.821
            },
            "gtin": "4051281920163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e51",
            "leftCorner": {
              "x": 1.921,
              "y": 26.75,
              "z": 0.821
            },
            "rightCorner": {
              "x": 2.009,
              "y": 26.745,
              "z": 0.821
            },
            "gtin": "4051281981522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e52",
            "leftCorner": {
              "x": 2.009,
              "y": 26.757,
              "z": 0.821
            },
            "rightCorner": {
              "x": 2.08,
              "y": 26.756,
              "z": 0.821
            },
            "gtin": "4051281981669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e53",
            "leftCorner": {
              "x": 2.08,
              "y": 26.759,
              "z": 0.821
            },
            "rightCorner": {
              "x": 2.216,
              "y": 26.753,
              "z": 0.821
            },
            "gtin": "4051281981546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e54",
            "leftCorner": {
              "x": 2.216,
              "y": 26.753,
              "z": 0.821
            },
            "rightCorner": {
              "x": 2.351,
              "y": 26.747,
              "z": 0.821
            },
            "gtin": "4051281981546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e55",
            "leftCorner": {
              "x": 2.351,
              "y": 26.747,
              "z": 0.821
            },
            "rightCorner": {
              "x": 2.403,
              "y": 26.745,
              "z": 0.821
            },
            "gtin": "4051281981621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e56",
            "leftCorner": {
              "x": 2.403,
              "y": 26.745,
              "z": 0.821
            },
            "rightCorner": {
              "x": 2.455,
              "y": 26.743,
              "z": 0.821
            },
            "gtin": "4051281981621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e57",
            "leftCorner": {
              "x": 2.454,
              "y": 26.718,
              "z": 0.821
            },
            "rightCorner": {
              "x": 2.59,
              "y": 26.712,
              "z": 0.821
            },
            "gtin": "4051281981720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e4e",
            "leftCorner": {
              "x": 2.59,
              "y": 26.713,
              "z": 0.821
            },
            "rightCorner": {
              "x": 2.721,
              "y": 26.708,
              "z": 0.821
            },
            "gtin": "4051281981683",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d7c"
  },
  {
    "id": "a6d7e",
    "name": "a6d7e",
    "x": -11.295,
    "y": 24.406,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.037315,
      "w": 0.9993
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 45,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546754",
        "height": 0.15232,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20fe8",
            "leftCorner": {
              "x": -11.295,
              "y": 24.402,
              "z": 0.125
            },
            "rightCorner": {
              "x": -11.093,
              "y": 24.387,
              "z": 0.125
            },
            "gtin": "4001499967160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fe9",
            "leftCorner": {
              "x": -11.093,
              "y": 24.387,
              "z": 0.125
            },
            "rightCorner": {
              "x": -10.89,
              "y": 24.372,
              "z": 0.125
            },
            "gtin": "4001499967160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fea",
            "leftCorner": {
              "x": -10.89,
              "y": 24.372,
              "z": 0.125
            },
            "rightCorner": {
              "x": -10.688,
              "y": 24.357,
              "z": 0.125
            },
            "gtin": "4001499967160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20feb",
            "leftCorner": {
              "x": -10.686,
              "y": 24.39,
              "z": 0.125
            },
            "rightCorner": {
              "x": -10.473,
              "y": 24.373,
              "z": 0.125
            },
            "gtin": "4001499967160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fec",
            "leftCorner": {
              "x": -10.473,
              "y": 24.373,
              "z": 0.125
            },
            "rightCorner": {
              "x": -10.26,
              "y": 24.357,
              "z": 0.125
            },
            "gtin": "4001499967160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fed",
            "leftCorner": {
              "x": -10.26,
              "y": 24.357,
              "z": 0.125
            },
            "rightCorner": {
              "x": -10.046,
              "y": 24.341,
              "z": 0.125
            },
            "gtin": "4001499967160",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546750",
        "height": 0.5985,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20fcf",
            "leftCorner": {
              "x": -11.295,
              "y": 24.408,
              "z": 0.49
            },
            "rightCorner": {
              "x": -11.09,
              "y": 24.393,
              "z": 0.49
            },
            "gtin": "4251758407016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fd0",
            "leftCorner": {
              "x": -11.09,
              "y": 24.393,
              "z": 0.49
            },
            "rightCorner": {
              "x": -10.886,
              "y": 24.377,
              "z": 0.49
            },
            "gtin": "4251758407016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fd1",
            "leftCorner": {
              "x": -10.886,
              "y": 24.377,
              "z": 0.49
            },
            "rightCorner": {
              "x": -10.682,
              "y": 24.363,
              "z": 0.49
            },
            "gtin": "4251758407016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fd6",
            "leftCorner": {
              "x": -10.678,
              "y": 24.407,
              "z": 0.49
            },
            "rightCorner": {
              "x": -10.55,
              "y": 24.397,
              "z": 0.49
            },
            "gtin": "4251758407054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fd2",
            "leftCorner": {
              "x": -10.55,
              "y": 24.387,
              "z": 0.49
            },
            "rightCorner": {
              "x": -10.423,
              "y": 24.378,
              "z": 0.49
            },
            "gtin": "4001499944710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fd3",
            "leftCorner": {
              "x": -10.423,
              "y": 24.378,
              "z": 0.49
            },
            "rightCorner": {
              "x": -10.298,
              "y": 24.368,
              "z": 0.49
            },
            "gtin": "4001499944710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fd4",
            "leftCorner": {
              "x": -10.298,
              "y": 24.368,
              "z": 0.49
            },
            "rightCorner": {
              "x": -10.172,
              "y": 24.359,
              "z": 0.49
            },
            "gtin": "4001499944710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fd5",
            "leftCorner": {
              "x": -10.172,
              "y": 24.359,
              "z": 0.49
            },
            "rightCorner": {
              "x": -10.045,
              "y": 24.35,
              "z": 0.49
            },
            "gtin": "4001499944710",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546752",
        "height": 1.0013,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20fd7",
            "leftCorner": {
              "x": -11.295,
              "y": 24.411,
              "z": 0.819
            },
            "rightCorner": {
              "x": -11.207,
              "y": 24.404,
              "z": 0.819
            },
            "gtin": "4008455085111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fd8",
            "leftCorner": {
              "x": -11.207,
              "y": 24.404,
              "z": 0.819
            },
            "rightCorner": {
              "x": -11.12,
              "y": 24.398,
              "z": 0.819
            },
            "gtin": "4008455085111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fd9",
            "leftCorner": {
              "x": -11.12,
              "y": 24.398,
              "z": 0.819
            },
            "rightCorner": {
              "x": -11.033,
              "y": 24.391,
              "z": 0.819
            },
            "gtin": "4008455085111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fdd",
            "leftCorner": {
              "x": -11.03,
              "y": 24.428,
              "z": 0.819
            },
            "rightCorner": {
              "x": -10.92,
              "y": 24.42,
              "z": 0.819
            },
            "gtin": "4251758407726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fde",
            "leftCorner": {
              "x": -10.92,
              "y": 24.42,
              "z": 0.819
            },
            "rightCorner": {
              "x": -10.809,
              "y": 24.412,
              "z": 0.819
            },
            "gtin": "4251758407726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fdf",
            "leftCorner": {
              "x": -10.809,
              "y": 24.412,
              "z": 0.819
            },
            "rightCorner": {
              "x": -10.698,
              "y": 24.404,
              "z": 0.819
            },
            "gtin": "4251758407726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fda",
            "leftCorner": {
              "x": -10.698,
              "y": 24.408,
              "z": 0.819
            },
            "rightCorner": {
              "x": -10.48,
              "y": 24.391,
              "z": 0.819
            },
            "gtin": "4001499944734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fdb",
            "leftCorner": {
              "x": -10.48,
              "y": 24.391,
              "z": 0.819
            },
            "rightCorner": {
              "x": -10.263,
              "y": 24.375,
              "z": 0.819
            },
            "gtin": "4001499944734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fdc",
            "leftCorner": {
              "x": -10.263,
              "y": 24.375,
              "z": 0.819
            },
            "rightCorner": {
              "x": -10.045,
              "y": 24.358,
              "z": 0.819
            },
            "gtin": "4001499944734",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546753",
        "height": 1.3988,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20fe0",
            "leftCorner": {
              "x": -11.295,
              "y": 24.399,
              "z": 1.144
            },
            "rightCorner": {
              "x": -11.151,
              "y": 24.389,
              "z": 1.144
            },
            "gtin": "4000290001004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fe1",
            "leftCorner": {
              "x": -11.151,
              "y": 24.389,
              "z": 1.144
            },
            "rightCorner": {
              "x": -11.007,
              "y": 24.378,
              "z": 1.144
            },
            "gtin": "4000290001004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fe2",
            "leftCorner": {
              "x": -11.007,
              "y": 24.378,
              "z": 1.144
            },
            "rightCorner": {
              "x": -10.862,
              "y": 24.367,
              "z": 1.144
            },
            "gtin": "4000290001004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fe4",
            "leftCorner": {
              "x": -10.859,
              "y": 24.413,
              "z": 1.144
            },
            "rightCorner": {
              "x": -10.678,
              "y": 24.399,
              "z": 1.144
            },
            "gtin": "5000204545203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fe5",
            "leftCorner": {
              "x": -10.678,
              "y": 24.399,
              "z": 1.144
            },
            "rightCorner": {
              "x": -10.497,
              "y": 24.385,
              "z": 1.144
            },
            "gtin": "5000204545203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fe6",
            "leftCorner": {
              "x": -10.497,
              "y": 24.378,
              "z": 1.144
            },
            "rightCorner": {
              "x": -10.372,
              "y": 24.369,
              "z": 1.144
            },
            "gtin": "4008455048413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fe7",
            "leftCorner": {
              "x": -10.372,
              "y": 24.369,
              "z": 1.144
            },
            "rightCorner": {
              "x": -10.246,
              "y": 24.359,
              "z": 1.144
            },
            "gtin": "4008455048413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fe3",
            "leftCorner": {
              "x": -10.246,
              "y": 24.359,
              "z": 1.144
            },
            "rightCorner": {
              "x": -10.046,
              "y": 24.344,
              "z": 1.144
            },
            "gtin": "4001499965715",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546751",
        "height": 1.7504,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1eeb2",
            "leftCorner": {
              "x": -11.295,
              "y": 24.397,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.229,
              "y": 24.392,
              "z": 1.432
            },
            "gtin": "5000204158403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeb3",
            "leftCorner": {
              "x": -11.229,
              "y": 24.392,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.164,
              "y": 24.388,
              "z": 1.432
            },
            "gtin": "5000204158403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeb4",
            "leftCorner": {
              "x": -11.164,
              "y": 24.388,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.097,
              "y": 24.383,
              "z": 1.432
            },
            "gtin": "5000204158403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeb5",
            "leftCorner": {
              "x": -11.097,
              "y": 24.383,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.032,
              "y": 24.377,
              "z": 1.432
            },
            "gtin": "5000204158403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeb7",
            "leftCorner": {
              "x": -11.029,
              "y": 24.413,
              "z": 1.432
            },
            "rightCorner": {
              "x": -10.82,
              "y": 24.397,
              "z": 1.432
            },
            "gtin": "4016100621515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeb8",
            "leftCorner": {
              "x": -10.819,
              "y": 24.407,
              "z": 1.432
            },
            "rightCorner": {
              "x": -10.738,
              "y": 24.401,
              "z": 1.432
            },
            "gtin": "40161181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeb9",
            "leftCorner": {
              "x": -10.739,
              "y": 24.384,
              "z": 1.432
            },
            "rightCorner": {
              "x": -10.601,
              "y": 24.373,
              "z": 1.432
            },
            "gtin": "40161310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeba",
            "leftCorner": {
              "x": -10.599,
              "y": 24.394,
              "z": 1.432
            },
            "rightCorner": {
              "x": -10.476,
              "y": 24.384,
              "z": 1.432
            },
            "gtin": "40161334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eebb",
            "leftCorner": {
              "x": -10.478,
              "y": 24.366,
              "z": 1.432
            },
            "rightCorner": {
              "x": -10.375,
              "y": 24.36,
              "z": 1.432
            },
            "gtin": "4016100810117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eebc",
            "leftCorner": {
              "x": -10.375,
              "y": 24.36,
              "z": 1.432
            },
            "rightCorner": {
              "x": -10.273,
              "y": 24.352,
              "z": 1.432
            },
            "gtin": "4016100810117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eebd",
            "leftCorner": {
              "x": -10.272,
              "y": 24.354,
              "z": 1.432
            },
            "rightCorner": {
              "x": -10.214,
              "y": 24.35,
              "z": 1.432
            },
            "gtin": "4052400033054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eebe",
            "leftCorner": {
              "x": -10.214,
              "y": 24.35,
              "z": 1.432
            },
            "rightCorner": {
              "x": -10.157,
              "y": 24.345,
              "z": 1.432
            },
            "gtin": "4052400033054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eebf",
            "leftCorner": {
              "x": -10.157,
              "y": 24.345,
              "z": 1.432
            },
            "rightCorner": {
              "x": -10.099,
              "y": 24.341,
              "z": 1.432
            },
            "gtin": "4052400033054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eec0",
            "leftCorner": {
              "x": -10.099,
              "y": 24.341,
              "z": 1.432
            },
            "rightCorner": {
              "x": -10.041,
              "y": 24.337,
              "z": 1.432
            },
            "gtin": "4052400033054",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d13a0",
    "rightNeighborShelfId": "a6d7f"
  },
  {
    "id": "a6d7f",
    "name": "a6d7f",
    "x": -10.048,
    "y": 24.313,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.037315,
      "w": 0.9993
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 20,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546758",
        "height": 0.55073,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ffa",
            "leftCorner": {
              "x": -10.047,
              "y": 24.327,
              "z": 0.451
            },
            "rightCorner": {
              "x": -9.014,
              "y": 24.249,
              "z": 0.451
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20ffb",
            "leftCorner": {
              "x": -9.01,
              "y": 24.291,
              "z": 0.451
            },
            "rightCorner": {
              "x": -8.798,
              "y": 24.275,
              "z": 0.451
            },
            "gtin": "4063367271908",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546755",
        "height": 0.94593,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20fee",
            "leftCorner": {
              "x": -10.048,
              "y": 24.318,
              "z": 0.774
            },
            "rightCorner": {
              "x": -9.858,
              "y": 24.304,
              "z": 0.774
            },
            "gtin": "4001499181085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fef",
            "leftCorner": {
              "x": -9.858,
              "y": 24.304,
              "z": 0.774
            },
            "rightCorner": {
              "x": -9.666,
              "y": 24.29,
              "z": 0.774
            },
            "gtin": "4001499181085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ff0",
            "leftCorner": {
              "x": -9.666,
              "y": 24.29,
              "z": 0.774
            },
            "rightCorner": {
              "x": -9.475,
              "y": 24.275,
              "z": 0.774
            },
            "gtin": "4001499181085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ff1",
            "leftCorner": {
              "x": -9.472,
              "y": 24.32,
              "z": 0.774
            },
            "rightCorner": {
              "x": -9.135,
              "y": 24.294,
              "z": 0.774
            },
            "gtin": "4001499013225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ff2",
            "leftCorner": {
              "x": -9.135,
              "y": 24.294,
              "z": 0.774
            },
            "rightCorner": {
              "x": -8.798,
              "y": 24.269,
              "z": 0.774
            },
            "gtin": "4001499013225",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546757",
        "height": 1.3547,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ff3",
            "leftCorner": {
              "x": -10.047,
              "y": 24.324,
              "z": 1.108
            },
            "rightCorner": {
              "x": -9.842,
              "y": 24.308,
              "z": 1.108
            },
            "gtin": "4022142114977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ff4",
            "leftCorner": {
              "x": -9.842,
              "y": 24.308,
              "z": 1.108
            },
            "rightCorner": {
              "x": -9.636,
              "y": 24.293,
              "z": 1.108
            },
            "gtin": "4022142114977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ff5",
            "leftCorner": {
              "x": -9.636,
              "y": 24.293,
              "z": 1.108
            },
            "rightCorner": {
              "x": -9.43,
              "y": 24.277,
              "z": 1.108
            },
            "gtin": "4022142114977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ff8",
            "leftCorner": {
              "x": -9.428,
              "y": 24.311,
              "z": 1.108
            },
            "rightCorner": {
              "x": -9.305,
              "y": 24.302,
              "z": 1.108
            },
            "gtin": "4001499944697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ff9",
            "leftCorner": {
              "x": -9.305,
              "y": 24.302,
              "z": 1.108
            },
            "rightCorner": {
              "x": -9.181,
              "y": 24.294,
              "z": 1.108
            },
            "gtin": "4001499944697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ff6",
            "leftCorner": {
              "x": -9.181,
              "y": 24.293,
              "z": 1.108
            },
            "rightCorner": {
              "x": -8.99,
              "y": 24.278,
              "z": 1.108
            },
            "gtin": "4001499944703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ff7",
            "leftCorner": {
              "x": -8.99,
              "y": 24.278,
              "z": 1.108
            },
            "rightCorner": {
              "x": -8.799,
              "y": 24.263,
              "z": 1.108
            },
            "gtin": "4001499944703",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546756",
        "height": 1.7475,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1eec1",
            "leftCorner": {
              "x": -10.04,
              "y": 24.349,
              "z": 1.43
            },
            "rightCorner": {
              "x": -9.902,
              "y": 24.338,
              "z": 1.43
            },
            "gtin": "4016100242413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eec2",
            "leftCorner": {
              "x": -9.902,
              "y": 24.338,
              "z": 1.43
            },
            "rightCorner": {
              "x": -9.763,
              "y": 24.328,
              "z": 1.43
            },
            "gtin": "4016100242413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eec3",
            "leftCorner": {
              "x": -9.763,
              "y": 24.335,
              "z": 1.43
            },
            "rightCorner": {
              "x": -9.66,
              "y": 24.327,
              "z": 1.43
            },
            "gtin": "4016100293019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eec4",
            "leftCorner": {
              "x": -9.661,
              "y": 24.318,
              "z": 1.43
            },
            "rightCorner": {
              "x": -9.422,
              "y": 24.301,
              "z": 1.43
            },
            "gtin": "4001499013560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eec5",
            "leftCorner": {
              "x": -9.422,
              "y": 24.301,
              "z": 1.43
            },
            "rightCorner": {
              "x": -9.182,
              "y": 24.283,
              "z": 1.43
            },
            "gtin": "4001499013560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eec6",
            "leftCorner": {
              "x": -9.182,
              "y": 24.283,
              "z": 1.43
            },
            "rightCorner": {
              "x": -8.943,
              "y": 24.265,
              "z": 1.43
            },
            "gtin": "4001499013560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eec7",
            "leftCorner": {
              "x": -8.942,
              "y": 24.273,
              "z": 1.43
            },
            "rightCorner": {
              "x": -8.797,
              "y": 24.263,
              "z": 1.43
            },
            "gtin": "4251758417695",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eec8",
            "leftCorner": {
              "x": -8.797,
              "y": 24.263,
              "z": 1.43
            },
            "rightCorner": {
              "x": -8.651,
              "y": 24.252,
              "z": 1.43
            },
            "gtin": "4251758417695",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d7e",
    "rightNeighborShelfId": "a6d80"
  },
  {
    "id": "a6d80",
    "name": "a6d80",
    "x": -8.801,
    "y": 24.22,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.037315,
      "w": 0.9993
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 67
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5466d0",
        "height": 0.14469,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a5466ce",
        "height": 0.18582,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20d3e",
            "leftCorner": {
              "x": -8.762,
              "y": 24.268,
              "z": 0.152
            },
            "rightCorner": {
              "x": -7.551,
              "y": 24.178,
              "z": 0.152
            },
            "gtin": "5000204868241",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466cf",
        "height": 0.39446,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20d3f",
            "leftCorner": {
              "x": -8.801,
              "y": 24.224,
              "z": 0.323
            },
            "rightCorner": {
              "x": -8.18,
              "y": 24.178,
              "z": 0.323
            },
            "gtin": "742042735334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d41",
            "leftCorner": {
              "x": -8.177,
              "y": 24.221,
              "z": 0.323
            },
            "rightCorner": {
              "x": -8.128,
              "y": 24.217,
              "z": 0.323
            },
            "gtin": "7640108100993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d42",
            "leftCorner": {
              "x": -8.128,
              "y": 24.217,
              "z": 0.323
            },
            "rightCorner": {
              "x": -8.08,
              "y": 24.213,
              "z": 0.323
            },
            "gtin": "7640108100993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d43",
            "leftCorner": {
              "x": -8.08,
              "y": 24.209,
              "z": 0.323
            },
            "rightCorner": {
              "x": -8.017,
              "y": 24.205,
              "z": 0.323
            },
            "gtin": "7640108100962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d44",
            "leftCorner": {
              "x": -8.017,
              "y": 24.205,
              "z": 0.323
            },
            "rightCorner": {
              "x": -7.953,
              "y": 24.2,
              "z": 0.323
            },
            "gtin": "7640108100962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d40",
            "leftCorner": {
              "x": -7.953,
              "y": 24.203,
              "z": 0.323
            },
            "rightCorner": {
              "x": -7.551,
              "y": 24.173,
              "z": 0.323
            },
            "gtin": "7640162950251",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466ca",
        "height": 0.74342,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20d05",
            "leftCorner": {
              "x": -8.801,
              "y": 24.223,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.724,
              "y": 24.218,
              "z": 0.608
            },
            "gtin": "4027600194416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d06",
            "leftCorner": {
              "x": -8.724,
              "y": 24.218,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.647,
              "y": 24.211,
              "z": 0.608
            },
            "gtin": "4027600194416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d0a",
            "leftCorner": {
              "x": -8.644,
              "y": 24.248,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.468,
              "y": 24.235,
              "z": 0.608
            },
            "gtin": "4027600753408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d0b",
            "leftCorner": {
              "x": -8.469,
              "y": 24.223,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.409,
              "y": 24.218,
              "z": 0.608
            },
            "gtin": "4027600444405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d0c",
            "leftCorner": {
              "x": -8.409,
              "y": 24.218,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.348,
              "y": 24.214,
              "z": 0.608
            },
            "gtin": "4027600444405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d0d",
            "leftCorner": {
              "x": -8.347,
              "y": 24.228,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.294,
              "y": 24.224,
              "z": 0.608
            },
            "gtin": "4027600234402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d0e",
            "leftCorner": {
              "x": -8.294,
              "y": 24.224,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.24,
              "y": 24.221,
              "z": 0.608
            },
            "gtin": "4027600234402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d0f",
            "leftCorner": {
              "x": -8.24,
              "y": 24.221,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.186,
              "y": 24.216,
              "z": 0.608
            },
            "gtin": "4027600234402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d10",
            "leftCorner": {
              "x": -8.186,
              "y": 24.216,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.132,
              "y": 24.212,
              "z": 0.608
            },
            "gtin": "4027600234402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d11",
            "leftCorner": {
              "x": -8.132,
              "y": 24.218,
              "z": 0.608
            },
            "rightCorner": {
              "x": -8.035,
              "y": 24.211,
              "z": 0.608
            },
            "gtin": "4027600364406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d12",
            "leftCorner": {
              "x": -8.035,
              "y": 24.214,
              "z": 0.608
            },
            "rightCorner": {
              "x": -7.943,
              "y": 24.207,
              "z": 0.608
            },
            "gtin": "4027600494516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d13",
            "leftCorner": {
              "x": -7.944,
              "y": 24.193,
              "z": 0.608
            },
            "rightCorner": {
              "x": -7.837,
              "y": 24.185,
              "z": 0.608
            },
            "gtin": "40276908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d14",
            "leftCorner": {
              "x": -7.836,
              "y": 24.198,
              "z": 0.608
            },
            "rightCorner": {
              "x": -7.735,
              "y": 24.19,
              "z": 0.608
            },
            "gtin": "4027600924716",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d15",
            "leftCorner": {
              "x": -7.736,
              "y": 24.186,
              "z": 0.608
            },
            "rightCorner": {
              "x": -7.677,
              "y": 24.182,
              "z": 0.608
            },
            "gtin": "4027600504512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d07",
            "leftCorner": {
              "x": -7.677,
              "y": 24.182,
              "z": 0.608
            },
            "rightCorner": {
              "x": -7.635,
              "y": 24.178,
              "z": 0.608
            },
            "gtin": "4027600514511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d08",
            "leftCorner": {
              "x": -7.635,
              "y": 24.178,
              "z": 0.608
            },
            "rightCorner": {
              "x": -7.593,
              "y": 24.176,
              "z": 0.608
            },
            "gtin": "4027600514511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d09",
            "leftCorner": {
              "x": -7.593,
              "y": 24.176,
              "z": 0.608
            },
            "rightCorner": {
              "x": -7.551,
              "y": 24.173,
              "z": 0.608
            },
            "gtin": "4027600514511",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466cb",
        "height": 1.0977,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20d16",
            "leftCorner": {
              "x": -8.801,
              "y": 24.22,
              "z": 0.898
            },
            "rightCorner": {
              "x": -8.713,
              "y": 24.214,
              "z": 0.898
            },
            "gtin": "4027600204719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d18",
            "leftCorner": {
              "x": -8.711,
              "y": 24.246,
              "z": 0.898
            },
            "rightCorner": {
              "x": -8.65,
              "y": 24.241,
              "z": 0.898
            },
            "gtin": "4027600484517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d19",
            "leftCorner": {
              "x": -8.65,
              "y": 24.241,
              "z": 0.898
            },
            "rightCorner": {
              "x": -8.589,
              "y": 24.237,
              "z": 0.898
            },
            "gtin": "4027600484517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d1a",
            "leftCorner": {
              "x": -8.589,
              "y": 24.234,
              "z": 0.898
            },
            "rightCorner": {
              "x": -8.481,
              "y": 24.226,
              "z": 0.898
            },
            "gtin": "4027600764718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d1b",
            "leftCorner": {
              "x": -8.481,
              "y": 24.219,
              "z": 0.898
            },
            "rightCorner": {
              "x": -8.428,
              "y": 24.215,
              "z": 0.898
            },
            "gtin": "4062700437216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d1c",
            "leftCorner": {
              "x": -8.428,
              "y": 24.215,
              "z": 0.898
            },
            "rightCorner": {
              "x": -8.374,
              "y": 24.211,
              "z": 0.898
            },
            "gtin": "4062700437216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d1d",
            "leftCorner": {
              "x": -8.373,
              "y": 24.224,
              "z": 0.898
            },
            "rightCorner": {
              "x": -8.279,
              "y": 24.217,
              "z": 0.898
            },
            "gtin": "4062700862025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d1e",
            "leftCorner": {
              "x": -8.278,
              "y": 24.225,
              "z": 0.898
            },
            "rightCorner": {
              "x": -8.222,
              "y": 24.221,
              "z": 0.898
            },
            "gtin": "4062700636305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d1f",
            "leftCorner": {
              "x": -8.222,
              "y": 24.221,
              "z": 0.898
            },
            "rightCorner": {
              "x": -8.166,
              "y": 24.216,
              "z": 0.898
            },
            "gtin": "4062700636305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d20",
            "leftCorner": {
              "x": -8.166,
              "y": 24.214,
              "z": 0.898
            },
            "rightCorner": {
              "x": -8.116,
              "y": 24.21,
              "z": 0.898
            },
            "gtin": "4062700837269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d21",
            "leftCorner": {
              "x": -8.116,
              "y": 24.21,
              "z": 0.898
            },
            "rightCorner": {
              "x": -8.066,
              "y": 24.206,
              "z": 0.898
            },
            "gtin": "4062700837269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d22",
            "leftCorner": {
              "x": -8.066,
              "y": 24.206,
              "z": 0.898
            },
            "rightCorner": {
              "x": -8.016,
              "y": 24.203,
              "z": 0.898
            },
            "gtin": "4062700837269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d23",
            "leftCorner": {
              "x": -8.017,
              "y": 24.199,
              "z": 0.898
            },
            "rightCorner": {
              "x": -7.949,
              "y": 24.194,
              "z": 0.898
            },
            "gtin": "4062700836118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d24",
            "leftCorner": {
              "x": -7.949,
              "y": 24.194,
              "z": 0.898
            },
            "rightCorner": {
              "x": -7.881,
              "y": 24.189,
              "z": 0.898
            },
            "gtin": "4062700836118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d25",
            "leftCorner": {
              "x": -7.882,
              "y": 24.183,
              "z": 0.898
            },
            "rightCorner": {
              "x": -7.802,
              "y": 24.176,
              "z": 0.898
            },
            "gtin": "4062700439043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d26",
            "leftCorner": {
              "x": -7.802,
              "y": 24.178,
              "z": 0.898
            },
            "rightCorner": {
              "x": -7.714,
              "y": 24.172,
              "z": 0.898
            },
            "gtin": "4062700439029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d27",
            "leftCorner": {
              "x": -7.714,
              "y": 24.172,
              "z": 0.898
            },
            "rightCorner": {
              "x": -7.625,
              "y": 24.165,
              "z": 0.898
            },
            "gtin": "4062700439029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d17",
            "leftCorner": {
              "x": -7.624,
              "y": 24.18,
              "z": 0.898
            },
            "rightCorner": {
              "x": -7.551,
              "y": 24.174,
              "z": 0.898
            },
            "gtin": "4062700839041",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466cc",
        "height": 1.4513,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20d28",
            "leftCorner": {
              "x": -8.801,
              "y": 24.218,
              "z": 1.187
            },
            "rightCorner": {
              "x": -8.682,
              "y": 24.209,
              "z": 1.187
            },
            "gtin": "5000204305203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d29",
            "leftCorner": {
              "x": -8.682,
              "y": 24.209,
              "z": 1.187
            },
            "rightCorner": {
              "x": -8.562,
              "y": 24.2,
              "z": 1.187
            },
            "gtin": "5000204305203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d2c",
            "leftCorner": {
              "x": -8.56,
              "y": 24.233,
              "z": 1.187
            },
            "rightCorner": {
              "x": -8.441,
              "y": 24.224,
              "z": 1.187
            },
            "gtin": "5000204752939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d2d",
            "leftCorner": {
              "x": -8.441,
              "y": 24.23,
              "z": 1.187
            },
            "rightCorner": {
              "x": -8.304,
              "y": 24.22,
              "z": 1.187
            },
            "gtin": "5000204343519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d2e",
            "leftCorner": {
              "x": -8.304,
              "y": 24.22,
              "z": 1.187
            },
            "rightCorner": {
              "x": -8.168,
              "y": 24.21,
              "z": 1.187
            },
            "gtin": "5000204343519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d2f",
            "leftCorner": {
              "x": -8.167,
              "y": 24.211,
              "z": 1.187
            },
            "rightCorner": {
              "x": -8.114,
              "y": 24.207,
              "z": 1.187
            },
            "gtin": "5000204343571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d30",
            "leftCorner": {
              "x": -8.114,
              "y": 24.207,
              "z": 1.187
            },
            "rightCorner": {
              "x": -8.061,
              "y": 24.203,
              "z": 1.187
            },
            "gtin": "5000204343571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d31",
            "leftCorner": {
              "x": -8.061,
              "y": 24.203,
              "z": 1.187
            },
            "rightCorner": {
              "x": -8.008,
              "y": 24.199,
              "z": 1.187
            },
            "gtin": "5000204343571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d32",
            "leftCorner": {
              "x": -8.008,
              "y": 24.199,
              "z": 1.187
            },
            "rightCorner": {
              "x": -7.955,
              "y": 24.195,
              "z": 1.187
            },
            "gtin": "5000204343571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d33",
            "leftCorner": {
              "x": -7.954,
              "y": 24.204,
              "z": 1.187
            },
            "rightCorner": {
              "x": -7.877,
              "y": 24.197,
              "z": 1.187
            },
            "gtin": "5000204206210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d34",
            "leftCorner": {
              "x": -7.877,
              "y": 24.197,
              "z": 1.187
            },
            "rightCorner": {
              "x": -7.8,
              "y": 24.192,
              "z": 1.187
            },
            "gtin": "5000204206210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d35",
            "leftCorner": {
              "x": -7.8,
              "y": 24.183,
              "z": 1.187
            },
            "rightCorner": {
              "x": -7.757,
              "y": 24.179,
              "z": 1.187
            },
            "gtin": "4062700836293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d36",
            "leftCorner": {
              "x": -7.757,
              "y": 24.177,
              "z": 1.187
            },
            "rightCorner": {
              "x": -7.704,
              "y": 24.173,
              "z": 1.187
            },
            "gtin": "4062700835050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d37",
            "leftCorner": {
              "x": -7.704,
              "y": 24.173,
              "z": 1.187
            },
            "rightCorner": {
              "x": -7.651,
              "y": 24.169,
              "z": 1.187
            },
            "gtin": "4062700835050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d38",
            "leftCorner": {
              "x": -7.651,
              "y": 24.171,
              "z": 1.187
            },
            "rightCorner": {
              "x": -7.578,
              "y": 24.166,
              "z": 1.187
            },
            "gtin": "4062700836590",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466cd",
        "height": 1.7474,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1eec9",
            "leftCorner": {
              "x": -8.65,
              "y": 24.245,
              "z": 1.43
            },
            "rightCorner": {
              "x": -8.562,
              "y": 24.239,
              "z": 1.43
            },
            "gtin": "5000204203158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeca",
            "leftCorner": {
              "x": -8.562,
              "y": 24.238,
              "z": 1.43
            },
            "rightCorner": {
              "x": -8.495,
              "y": 24.233,
              "z": 1.43
            },
            "gtin": "4027600454510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eecb",
            "leftCorner": {
              "x": -8.495,
              "y": 24.233,
              "z": 1.43
            },
            "rightCorner": {
              "x": -8.428,
              "y": 24.228,
              "z": 1.43
            },
            "gtin": "4027600454510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eecc",
            "leftCorner": {
              "x": -8.428,
              "y": 24.226,
              "z": 1.43
            },
            "rightCorner": {
              "x": -8.184,
              "y": 24.207,
              "z": 1.43
            },
            "gtin": "4000290001608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eecd",
            "leftCorner": {
              "x": -8.183,
              "y": 24.215,
              "z": 1.43
            },
            "rightCorner": {
              "x": -8.09,
              "y": 24.208,
              "z": 1.43
            },
            "gtin": "5000204343540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eece",
            "leftCorner": {
              "x": -8.09,
              "y": 24.208,
              "z": 1.43
            },
            "rightCorner": {
              "x": -7.996,
              "y": 24.201,
              "z": 1.43
            },
            "gtin": "5000204343540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eecf",
            "leftCorner": {
              "x": -7.996,
              "y": 24.201,
              "z": 1.43
            },
            "rightCorner": {
              "x": -7.902,
              "y": 24.194,
              "z": 1.43
            },
            "gtin": "5000204343540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eed0",
            "leftCorner": {
              "x": -7.902,
              "y": 24.194,
              "z": 1.43
            },
            "rightCorner": {
              "x": -7.808,
              "y": 24.187,
              "z": 1.43
            },
            "gtin": "5000204343540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eed1",
            "leftCorner": {
              "x": -7.808,
              "y": 24.193,
              "z": 1.43
            },
            "rightCorner": {
              "x": -7.695,
              "y": 24.185,
              "z": 1.43
            },
            "gtin": "5000204090109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eed2",
            "leftCorner": {
              "x": -7.695,
              "y": 24.185,
              "z": 1.43
            },
            "rightCorner": {
              "x": -7.583,
              "y": 24.176,
              "z": 1.43
            },
            "gtin": "5000204090109",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d7f",
    "rightNeighborShelfId": "a6d81"
  },
  {
    "id": "a6d81",
    "name": "a6d81",
    "x": -7.555,
    "y": 24.127,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.037315,
      "w": 0.9993
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 40
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54675b",
        "height": 0.14181,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef52",
            "leftCorner": {
              "x": -7.501,
              "y": 24.173,
              "z": 0.116
            },
            "rightCorner": {
              "x": -7.227,
              "y": 24.153,
              "z": 0.116
            },
            "gtin": "4063367500367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef53",
            "leftCorner": {
              "x": -7.228,
              "y": 24.144,
              "z": 0.116
            },
            "rightCorner": {
              "x": -7.043,
              "y": 24.129,
              "z": 0.116
            },
            "gtin": "4337185834912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef54",
            "leftCorner": {
              "x": -7.043,
              "y": 24.132,
              "z": 0.116
            },
            "rightCorner": {
              "x": -6.744,
              "y": 24.11,
              "z": 0.116
            },
            "gtin": "4063367564154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef55",
            "leftCorner": {
              "x": -6.743,
              "y": 24.125,
              "z": 0.116
            },
            "rightCorner": {
              "x": -6.596,
              "y": 24.113,
              "z": 0.116
            },
            "gtin": "4337185622847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef56",
            "leftCorner": {
              "x": -6.596,
              "y": 24.114,
              "z": 0.116
            },
            "rightCorner": {
              "x": -6.467,
              "y": 24.105,
              "z": 0.116
            },
            "gtin": "4337185624537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef57",
            "leftCorner": {
              "x": -6.467,
              "y": 24.105,
              "z": 0.116
            },
            "rightCorner": {
              "x": -6.338,
              "y": 24.096,
              "z": 0.116
            },
            "gtin": "4337185624537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef58",
            "leftCorner": {
              "x": -6.338,
              "y": 24.096,
              "z": 0.116
            },
            "rightCorner": {
              "x": -6.209,
              "y": 24.086,
              "z": 0.116
            },
            "gtin": "4337185624537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef59",
            "leftCorner": {
              "x": -6.209,
              "y": 24.086,
              "z": 0.116
            },
            "rightCorner": {
              "x": -6.08,
              "y": 24.076,
              "z": 0.116
            },
            "gtin": "4337185624537",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54675a",
        "height": 0.64226,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef1a",
            "leftCorner": {
              "x": -7.554,
              "y": 24.144,
              "z": 0.525
            },
            "rightCorner": {
              "x": -7.457,
              "y": 24.137,
              "z": 0.525
            },
            "gtin": "4063367500367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef1b",
            "leftCorner": {
              "x": -7.457,
              "y": 24.137,
              "z": 0.525
            },
            "rightCorner": {
              "x": -7.361,
              "y": 24.129,
              "z": 0.525
            },
            "gtin": "4063367500367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef1e",
            "leftCorner": {
              "x": -7.358,
              "y": 24.169,
              "z": 0.525
            },
            "rightCorner": {
              "x": -7.24,
              "y": 24.161,
              "z": 0.525
            },
            "gtin": "4063367500329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef1f",
            "leftCorner": {
              "x": -7.24,
              "y": 24.162,
              "z": 0.525
            },
            "rightCorner": {
              "x": -7.082,
              "y": 24.15,
              "z": 0.525
            },
            "gtin": "4063367503115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef20",
            "leftCorner": {
              "x": -7.083,
              "y": 24.146,
              "z": 0.525
            },
            "rightCorner": {
              "x": -6.931,
              "y": 24.134,
              "z": 0.525
            },
            "gtin": "4337185624537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef21",
            "leftCorner": {
              "x": -6.931,
              "y": 24.134,
              "z": 0.525
            },
            "rightCorner": {
              "x": -6.779,
              "y": 24.123,
              "z": 0.525
            },
            "gtin": "4337185624537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef22",
            "leftCorner": {
              "x": -6.779,
              "y": 24.123,
              "z": 0.525
            },
            "rightCorner": {
              "x": -6.627,
              "y": 24.111,
              "z": 0.525
            },
            "gtin": "4337185624537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef23",
            "leftCorner": {
              "x": -6.627,
              "y": 24.111,
              "z": 0.525
            },
            "rightCorner": {
              "x": -6.475,
              "y": 24.101,
              "z": 0.525
            },
            "gtin": "4337185624537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef24",
            "leftCorner": {
              "x": -6.475,
              "y": 24.101,
              "z": 0.525
            },
            "rightCorner": {
              "x": -6.323,
              "y": 24.09,
              "z": 0.525
            },
            "gtin": "4337185624537",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54675c",
        "height": 0.9936,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ffc",
            "leftCorner": {
              "x": -7.554,
              "y": 24.14,
              "z": 0.813
            },
            "rightCorner": {
              "x": -7.47,
              "y": 24.134,
              "z": 0.813
            },
            "gtin": "4063367503153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ffd",
            "leftCorner": {
              "x": -7.47,
              "y": 24.134,
              "z": 0.813
            },
            "rightCorner": {
              "x": -7.387,
              "y": 24.128,
              "z": 0.813
            },
            "gtin": "4063367503153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21000",
            "leftCorner": {
              "x": -7.384,
              "y": 24.16,
              "z": 0.813
            },
            "rightCorner": {
              "x": -7.22,
              "y": 24.147,
              "z": 0.813
            },
            "gtin": "4337185813702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21001",
            "leftCorner": {
              "x": -7.22,
              "y": 24.152,
              "z": 0.813
            },
            "rightCorner": {
              "x": -6.82,
              "y": 24.121,
              "z": 0.813
            },
            "gtin": "4337185621345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21002",
            "leftCorner": {
              "x": -6.82,
              "y": 24.126,
              "z": 0.813
            },
            "rightCorner": {
              "x": -6.709,
              "y": 24.118,
              "z": 0.813
            },
            "gtin": "4337185621307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21003",
            "leftCorner": {
              "x": -6.709,
              "y": 24.118,
              "z": 0.813
            },
            "rightCorner": {
              "x": -6.597,
              "y": 24.109,
              "z": 0.813
            },
            "gtin": "4337185621307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ffe",
            "leftCorner": {
              "x": -6.597,
              "y": 24.11,
              "z": 0.813
            },
            "rightCorner": {
              "x": -6.451,
              "y": 24.099,
              "z": 0.813
            },
            "gtin": "4063367500343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fff",
            "leftCorner": {
              "x": -6.451,
              "y": 24.099,
              "z": 0.813
            },
            "rightCorner": {
              "x": -6.304,
              "y": 24.088,
              "z": 0.813
            },
            "gtin": "4063367500343",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54675d",
        "height": 1.4481,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20d39",
            "leftCorner": {
              "x": -7.577,
              "y": 24.181,
              "z": 1.185
            },
            "rightCorner": {
              "x": -7.359,
              "y": 24.164,
              "z": 1.185
            },
            "gtin": "4004753036411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d3a",
            "leftCorner": {
              "x": -7.359,
              "y": 24.164,
              "z": 1.185
            },
            "rightCorner": {
              "x": -7.14,
              "y": 24.147,
              "z": 1.185
            },
            "gtin": "4004753036411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d3b",
            "leftCorner": {
              "x": -7.141,
              "y": 24.135,
              "z": 1.185
            },
            "rightCorner": {
              "x": -6.884,
              "y": 24.116,
              "z": 1.185
            },
            "gtin": "4004753905489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d3c",
            "leftCorner": {
              "x": -6.883,
              "y": 24.128,
              "z": 1.185
            },
            "rightCorner": {
              "x": -6.7,
              "y": 24.114,
              "z": 1.185
            },
            "gtin": "4004753007138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d3d",
            "leftCorner": {
              "x": -6.7,
              "y": 24.114,
              "z": 1.185
            },
            "rightCorner": {
              "x": -6.517,
              "y": 24.101,
              "z": 1.185
            },
            "gtin": "4004753007138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d2a",
            "leftCorner": {
              "x": -6.517,
              "y": 24.101,
              "z": 1.185
            },
            "rightCorner": {
              "x": -6.411,
              "y": 24.092,
              "z": 1.185
            },
            "gtin": "4012425186012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20d2b",
            "leftCorner": {
              "x": -6.411,
              "y": 24.092,
              "z": 1.185
            },
            "rightCorner": {
              "x": -6.305,
              "y": 24.084,
              "z": 1.185
            },
            "gtin": "4012425186012",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546759",
        "height": 1.7483,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1eed3",
            "leftCorner": {
              "x": -7.583,
              "y": 24.176,
              "z": 1.43
            },
            "rightCorner": {
              "x": -7.473,
              "y": 24.168,
              "z": 1.43
            },
            "gtin": "4022364063008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eed4",
            "leftCorner": {
              "x": -7.473,
              "y": 24.168,
              "z": 1.43
            },
            "rightCorner": {
              "x": -7.363,
              "y": 24.16,
              "z": 1.43
            },
            "gtin": "4022364063008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eed5",
            "leftCorner": {
              "x": -7.363,
              "y": 24.16,
              "z": 1.43
            },
            "rightCorner": {
              "x": -7.253,
              "y": 24.151,
              "z": 1.43
            },
            "gtin": "4022364063008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eed6",
            "leftCorner": {
              "x": -7.253,
              "y": 24.151,
              "z": 1.43
            },
            "rightCorner": {
              "x": -7.143,
              "y": 24.144,
              "z": 1.43
            },
            "gtin": "4022364063008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eed7",
            "leftCorner": {
              "x": -7.142,
              "y": 24.15,
              "z": 1.43
            },
            "rightCorner": {
              "x": -7.079,
              "y": 24.144,
              "z": 1.43
            },
            "gtin": "7640162950039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eed8",
            "leftCorner": {
              "x": -7.079,
              "y": 24.144,
              "z": 1.43
            },
            "rightCorner": {
              "x": -7.016,
              "y": 24.139,
              "z": 1.43
            },
            "gtin": "7640162950039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eed9",
            "leftCorner": {
              "x": -7.017,
              "y": 24.118,
              "z": 1.43
            },
            "rightCorner": {
              "x": -6.667,
              "y": 24.092,
              "z": 1.43
            },
            "gtin": "7640162950251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeda",
            "leftCorner": {
              "x": -6.667,
              "y": 24.092,
              "z": 1.43
            },
            "rightCorner": {
              "x": -6.317,
              "y": 24.066,
              "z": 1.43
            },
            "gtin": "7640162950251",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d80",
    "rightNeighborShelfId": "a6d82"
  },
  {
    "id": "a6d82",
    "name": "a6d82",
    "x": -6.308,
    "y": 24.033,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.037315,
      "w": 0.9993
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 54,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5466c4",
        "height": 0.14581,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef5a",
            "leftCorner": {
              "x": -6.08,
              "y": 24.073,
              "z": 0.119
            },
            "rightCorner": {
              "x": -5.86,
              "y": 24.057,
              "z": 0.119
            },
            "gtin": "4015200034485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef5b",
            "leftCorner": {
              "x": -5.86,
              "y": 24.057,
              "z": 0.119
            },
            "rightCorner": {
              "x": -5.64,
              "y": 24.041,
              "z": 0.119
            },
            "gtin": "4015200034485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef5c",
            "leftCorner": {
              "x": -5.641,
              "y": 24.032,
              "z": 0.119
            },
            "rightCorner": {
              "x": -5.036,
              "y": 23.986,
              "z": 0.119
            },
            "gtin": "4015200035710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef5d",
            "leftCorner": {
              "x": -5.036,
              "y": 23.986,
              "z": 0.119
            },
            "rightCorner": {
              "x": -4.431,
              "y": 23.941,
              "z": 0.119
            },
            "gtin": "4015200035710",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466c1",
        "height": 0.64398,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef25",
            "leftCorner": {
              "x": -6.322,
              "y": 24.089,
              "z": 0.527
            },
            "rightCorner": {
              "x": -6.204,
              "y": 24.08,
              "z": 0.527
            },
            "gtin": "4015200034461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef26",
            "leftCorner": {
              "x": -6.204,
              "y": 24.08,
              "z": 0.527
            },
            "rightCorner": {
              "x": -6.087,
              "y": 24.072,
              "z": 0.527
            },
            "gtin": "4015200034461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef27",
            "leftCorner": {
              "x": -6.087,
              "y": 24.072,
              "z": 0.527
            },
            "rightCorner": {
              "x": -5.969,
              "y": 24.063,
              "z": 0.527
            },
            "gtin": "4015200034461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef28",
            "leftCorner": {
              "x": -5.969,
              "y": 24.063,
              "z": 0.527
            },
            "rightCorner": {
              "x": -5.851,
              "y": 24.054,
              "z": 0.527
            },
            "gtin": "4015200034461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef29",
            "leftCorner": {
              "x": -5.851,
              "y": 24.064,
              "z": 0.527
            },
            "rightCorner": {
              "x": -5.58,
              "y": 24.044,
              "z": 0.527
            },
            "gtin": "4015200035567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef2a",
            "leftCorner": {
              "x": -5.58,
              "y": 24.044,
              "z": 0.527
            },
            "rightCorner": {
              "x": -5.31,
              "y": 24.024,
              "z": 0.527
            },
            "gtin": "4015200035567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef2b",
            "leftCorner": {
              "x": -5.31,
              "y": 24.024,
              "z": 0.527
            },
            "rightCorner": {
              "x": -5.04,
              "y": 24.004,
              "z": 0.527
            },
            "gtin": "4015200035567",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466c2",
        "height": 1.0493,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee44",
            "leftCorner": {
              "x": -6.307,
              "y": 24.047,
              "z": 0.859
            },
            "rightCorner": {
              "x": -6.22,
              "y": 24.041,
              "z": 0.859
            },
            "gtin": "4062196101493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee45",
            "leftCorner": {
              "x": -6.22,
              "y": 24.041,
              "z": 0.859
            },
            "rightCorner": {
              "x": -6.132,
              "y": 24.034,
              "z": 0.859
            },
            "gtin": "4062196101493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee49",
            "leftCorner": {
              "x": -6.129,
              "y": 24.074,
              "z": 0.859
            },
            "rightCorner": {
              "x": -6.074,
              "y": 24.07,
              "z": 0.859
            },
            "gtin": "4001499968549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee4a",
            "leftCorner": {
              "x": -6.074,
              "y": 24.07,
              "z": 0.859
            },
            "rightCorner": {
              "x": -6.019,
              "y": 24.066,
              "z": 0.859
            },
            "gtin": "4001499968549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee4b",
            "leftCorner": {
              "x": -6.019,
              "y": 24.066,
              "z": 0.859
            },
            "rightCorner": {
              "x": -5.964,
              "y": 24.062,
              "z": 0.859
            },
            "gtin": "4001499968549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee4c",
            "leftCorner": {
              "x": -5.965,
              "y": 24.056,
              "z": 0.859
            },
            "rightCorner": {
              "x": -5.89,
              "y": 24.051,
              "z": 0.859
            },
            "gtin": "4015000019040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee4d",
            "leftCorner": {
              "x": -5.89,
              "y": 24.051,
              "z": 0.859
            },
            "rightCorner": {
              "x": -5.814,
              "y": 24.044,
              "z": 0.859
            },
            "gtin": "4015000019040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee4e",
            "leftCorner": {
              "x": -5.814,
              "y": 24.044,
              "z": 0.859
            },
            "rightCorner": {
              "x": -5.739,
              "y": 24.039,
              "z": 0.859
            },
            "gtin": "4015000019040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee4f",
            "leftCorner": {
              "x": -5.739,
              "y": 24.039,
              "z": 0.859
            },
            "rightCorner": {
              "x": -5.664,
              "y": 24.033,
              "z": 0.859
            },
            "gtin": "4015000019040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee50",
            "leftCorner": {
              "x": -5.664,
              "y": 24.036,
              "z": 0.859
            },
            "rightCorner": {
              "x": -5.577,
              "y": 24.03,
              "z": 0.859
            },
            "gtin": "4008455096117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee51",
            "leftCorner": {
              "x": -5.577,
              "y": 24.03,
              "z": 0.859
            },
            "rightCorner": {
              "x": -5.491,
              "y": 24.023,
              "z": 0.859
            },
            "gtin": "4008455096117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee52",
            "leftCorner": {
              "x": -5.491,
              "y": 24.023,
              "z": 0.859
            },
            "rightCorner": {
              "x": -5.234,
              "y": 24.005,
              "z": 0.859
            },
            "gtin": "4008455029719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee53",
            "leftCorner": {
              "x": -5.233,
              "y": 24.013,
              "z": 0.859
            },
            "rightCorner": {
              "x": -4.994,
              "y": 23.996,
              "z": 0.859
            },
            "gtin": "4008455029115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee54",
            "leftCorner": {
              "x": -4.994,
              "y": 23.996,
              "z": 0.859
            },
            "rightCorner": {
              "x": -4.755,
              "y": 23.977,
              "z": 0.859
            },
            "gtin": "4008455029115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee55",
            "leftCorner": {
              "x": -4.755,
              "y": 23.977,
              "z": 0.859
            },
            "rightCorner": {
              "x": -4.516,
              "y": 23.96,
              "z": 0.859
            },
            "gtin": "4008455029115",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466c3",
        "height": 1.3993,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee79",
            "leftCorner": {
              "x": -6.307,
              "y": 24.048,
              "z": 1.145
            },
            "rightCorner": {
              "x": -6.158,
              "y": 24.038,
              "z": 1.145
            },
            "gtin": "4022142114991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee7d",
            "leftCorner": {
              "x": -6.156,
              "y": 24.071,
              "z": 1.145
            },
            "rightCorner": {
              "x": -6.083,
              "y": 24.064,
              "z": 1.145
            },
            "gtin": "4062196082235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee7e",
            "leftCorner": {
              "x": -6.083,
              "y": 24.064,
              "z": 1.145
            },
            "rightCorner": {
              "x": -6.009,
              "y": 24.059,
              "z": 1.145
            },
            "gtin": "4062196082235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee7f",
            "leftCorner": {
              "x": -6.009,
              "y": 24.059,
              "z": 1.145
            },
            "rightCorner": {
              "x": -5.936,
              "y": 24.054,
              "z": 1.145
            },
            "gtin": "4062196082235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee80",
            "leftCorner": {
              "x": -5.936,
              "y": 24.054,
              "z": 1.145
            },
            "rightCorner": {
              "x": -5.863,
              "y": 24.048,
              "z": 1.145
            },
            "gtin": "4062196082235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee81",
            "leftCorner": {
              "x": -5.862,
              "y": 24.058,
              "z": 1.145
            },
            "rightCorner": {
              "x": -5.808,
              "y": 24.054,
              "z": 1.145
            },
            "gtin": "4062196082884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee82",
            "leftCorner": {
              "x": -5.808,
              "y": 24.054,
              "z": 1.145
            },
            "rightCorner": {
              "x": -5.755,
              "y": 24.05,
              "z": 1.145
            },
            "gtin": "4062196082884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee83",
            "leftCorner": {
              "x": -5.755,
              "y": 24.045,
              "z": 1.145
            },
            "rightCorner": {
              "x": -5.665,
              "y": 24.038,
              "z": 1.145
            },
            "gtin": "4052400033634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee84",
            "leftCorner": {
              "x": -5.665,
              "y": 24.038,
              "z": 1.145
            },
            "rightCorner": {
              "x": -5.575,
              "y": 24.031,
              "z": 1.145
            },
            "gtin": "4052400033634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee85",
            "leftCorner": {
              "x": -5.575,
              "y": 24.031,
              "z": 1.145
            },
            "rightCorner": {
              "x": -5.485,
              "y": 24.025,
              "z": 1.145
            },
            "gtin": "4052400033634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee86",
            "leftCorner": {
              "x": -5.484,
              "y": 24.037,
              "z": 1.145
            },
            "rightCorner": {
              "x": -5.367,
              "y": 24.028,
              "z": 1.145
            },
            "gtin": "4015000019033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee87",
            "leftCorner": {
              "x": -5.367,
              "y": 24.028,
              "z": 1.145
            },
            "rightCorner": {
              "x": -5.249,
              "y": 24.02,
              "z": 1.145
            },
            "gtin": "4015000019033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee88",
            "leftCorner": {
              "x": -5.249,
              "y": 24.019,
              "z": 1.145
            },
            "rightCorner": {
              "x": -5.131,
              "y": 24.01,
              "z": 1.145
            },
            "gtin": "4008455002057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee89",
            "leftCorner": {
              "x": -5.131,
              "y": 24.01,
              "z": 1.145
            },
            "rightCorner": {
              "x": -5.013,
              "y": 24.002,
              "z": 1.145
            },
            "gtin": "4008455002057",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466c0",
        "height": 1.7481,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1eedb",
            "leftCorner": {
              "x": -6.315,
              "y": 24.086,
              "z": 1.43
            },
            "rightCorner": {
              "x": -6.213,
              "y": 24.079,
              "z": 1.43
            },
            "gtin": "4009412096096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eedc",
            "leftCorner": {
              "x": -6.213,
              "y": 24.079,
              "z": 1.43
            },
            "rightCorner": {
              "x": -6.111,
              "y": 24.071,
              "z": 1.43
            },
            "gtin": "4009412096096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eedd",
            "leftCorner": {
              "x": -6.111,
              "y": 24.067,
              "z": 1.43
            },
            "rightCorner": {
              "x": -6.015,
              "y": 24.06,
              "z": 1.43
            },
            "gtin": "4009412096102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eede",
            "leftCorner": {
              "x": -6.015,
              "y": 24.06,
              "z": 1.43
            },
            "rightCorner": {
              "x": -5.918,
              "y": 24.052,
              "z": 1.43
            },
            "gtin": "4009412096102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eedf",
            "leftCorner": {
              "x": -5.916,
              "y": 24.075,
              "z": 1.43
            },
            "rightCorner": {
              "x": -5.855,
              "y": 24.071,
              "z": 1.43
            },
            "gtin": "4008455048314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eee0",
            "leftCorner": {
              "x": -5.855,
              "y": 24.071,
              "z": 1.43
            },
            "rightCorner": {
              "x": -5.793,
              "y": 24.066,
              "z": 1.43
            },
            "gtin": "4008455048314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eee1",
            "leftCorner": {
              "x": -5.793,
              "y": 24.066,
              "z": 1.43
            },
            "rightCorner": {
              "x": -5.731,
              "y": 24.062,
              "z": 1.43
            },
            "gtin": "4008455048314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eee2",
            "leftCorner": {
              "x": -5.731,
              "y": 24.062,
              "z": 1.43
            },
            "rightCorner": {
              "x": -5.669,
              "y": 24.057,
              "z": 1.43
            },
            "gtin": "4008455048314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eee3",
            "leftCorner": {
              "x": -5.67,
              "y": 24.043,
              "z": 1.43
            },
            "rightCorner": {
              "x": -5.532,
              "y": 24.034,
              "z": 1.43
            },
            "gtin": "4000869110144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eee4",
            "leftCorner": {
              "x": -5.531,
              "y": 24.046,
              "z": 1.43
            },
            "rightCorner": {
              "x": -5.448,
              "y": 24.04,
              "z": 1.43
            },
            "gtin": "4052400033627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eee5",
            "leftCorner": {
              "x": -5.448,
              "y": 24.04,
              "z": 1.43
            },
            "rightCorner": {
              "x": -5.365,
              "y": 24.033,
              "z": 1.43
            },
            "gtin": "4052400033627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eee6",
            "leftCorner": {
              "x": -5.365,
              "y": 24.033,
              "z": 1.43
            },
            "rightCorner": {
              "x": -5.281,
              "y": 24.028,
              "z": 1.43
            },
            "gtin": "4052400033627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eee7",
            "leftCorner": {
              "x": -5.281,
              "y": 24.028,
              "z": 1.43
            },
            "rightCorner": {
              "x": -5.198,
              "y": 24.021,
              "z": 1.43
            },
            "gtin": "4052400033627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eee8",
            "leftCorner": {
              "x": -5.199,
              "y": 24.005,
              "z": 1.43
            },
            "rightCorner": {
              "x": -5.019,
              "y": 23.991,
              "z": 1.43
            },
            "gtin": "4002448006473",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d81",
    "rightNeighborShelfId": "a6d83"
  },
  {
    "id": "a6d83",
    "name": "a6d83",
    "x": -5.062,
    "y": 23.94,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.037315,
      "w": 0.9993
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 31,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546762",
        "height": 0.14253,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef5e",
            "leftCorner": {
              "x": -4.431,
              "y": 23.948,
              "z": 0.117
            },
            "rightCorner": {
              "x": -4.107,
              "y": 23.924,
              "z": 0.117
            },
            "gtin": "4015200035550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef5f",
            "leftCorner": {
              "x": -4.107,
              "y": 23.924,
              "z": 0.117
            },
            "rightCorner": {
              "x": -3.783,
              "y": 23.901,
              "z": 0.117
            },
            "gtin": "4015200035550",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54675f",
        "height": 0.64542,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef2c",
            "leftCorner": {
              "x": -5.041,
              "y": 23.99,
              "z": 0.528
            },
            "rightCorner": {
              "x": -4.887,
              "y": 23.978,
              "z": 0.528
            },
            "gtin": "8001090510327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef2d",
            "leftCorner": {
              "x": -4.887,
              "y": 23.978,
              "z": 0.528
            },
            "rightCorner": {
              "x": -4.733,
              "y": 23.967,
              "z": 0.528
            },
            "gtin": "8001090510327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef2e",
            "leftCorner": {
              "x": -4.733,
              "y": 23.967,
              "z": 0.528
            },
            "rightCorner": {
              "x": -4.579,
              "y": 23.955,
              "z": 0.528
            },
            "gtin": "8001090510327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef2f",
            "leftCorner": {
              "x": -4.579,
              "y": 23.955,
              "z": 0.528
            },
            "rightCorner": {
              "x": -4.425,
              "y": 23.944,
              "z": 0.528
            },
            "gtin": "8001090510327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef30",
            "leftCorner": {
              "x": -4.425,
              "y": 23.943,
              "z": 0.528
            },
            "rightCorner": {
              "x": -4.049,
              "y": 23.915,
              "z": 0.528
            },
            "gtin": "8001090502216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef31",
            "leftCorner": {
              "x": -4.049,
              "y": 23.915,
              "z": 0.528
            },
            "rightCorner": {
              "x": -3.672,
              "y": 23.887,
              "z": 0.528
            },
            "gtin": "8001090502216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef32",
            "leftCorner": {
              "x": -3.672,
              "y": 23.887,
              "z": 0.528
            },
            "rightCorner": {
              "x": -3.296,
              "y": 23.859,
              "z": 0.528
            },
            "gtin": "8001090502216",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546761",
        "height": 1.0483,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee56",
            "leftCorner": {
              "x": -4.518,
              "y": 23.941,
              "z": 0.858
            },
            "rightCorner": {
              "x": -4.324,
              "y": 23.926,
              "z": 0.858
            },
            "gtin": "4015200035574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee57",
            "leftCorner": {
              "x": -4.324,
              "y": 23.926,
              "z": 0.858
            },
            "rightCorner": {
              "x": -4.129,
              "y": 23.912,
              "z": 0.858
            },
            "gtin": "4015200035574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee58",
            "leftCorner": {
              "x": -4.129,
              "y": 23.912,
              "z": 0.858
            },
            "rightCorner": {
              "x": -3.934,
              "y": 23.897,
              "z": 0.858
            },
            "gtin": "4015200035574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee59",
            "leftCorner": {
              "x": -3.934,
              "y": 23.897,
              "z": 0.858
            },
            "rightCorner": {
              "x": -3.74,
              "y": 23.882,
              "z": 0.858
            },
            "gtin": "4015200035574",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54675e",
        "height": 1.4014,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee8a",
            "leftCorner": {
              "x": -5.014,
              "y": 23.997,
              "z": 1.147
            },
            "rightCorner": {
              "x": -4.831,
              "y": 23.984,
              "z": 1.147
            },
            "gtin": "4015200035581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee8b",
            "leftCorner": {
              "x": -4.831,
              "y": 23.984,
              "z": 1.147
            },
            "rightCorner": {
              "x": -4.648,
              "y": 23.97,
              "z": 1.147
            },
            "gtin": "4015200035581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee8c",
            "leftCorner": {
              "x": -4.648,
              "y": 23.97,
              "z": 1.147
            },
            "rightCorner": {
              "x": -4.465,
              "y": 23.956,
              "z": 1.147
            },
            "gtin": "4015200035581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee8d",
            "leftCorner": {
              "x": -4.468,
              "y": 23.928,
              "z": 1.147
            },
            "rightCorner": {
              "x": -4.366,
              "y": 23.92,
              "z": 1.147
            },
            "gtin": "8001090502209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee8e",
            "leftCorner": {
              "x": -4.366,
              "y": 23.92,
              "z": 1.147
            },
            "rightCorner": {
              "x": -4.264,
              "y": 23.913,
              "z": 1.147
            },
            "gtin": "8001090502209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee8f",
            "leftCorner": {
              "x": -4.263,
              "y": 23.924,
              "z": 1.147
            },
            "rightCorner": {
              "x": -4.105,
              "y": 23.912,
              "z": 1.147
            },
            "gtin": "8001090502094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee90",
            "leftCorner": {
              "x": -4.105,
              "y": 23.912,
              "z": 1.147
            },
            "rightCorner": {
              "x": -3.948,
              "y": 23.901,
              "z": 1.147
            },
            "gtin": "8001090502094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee91",
            "leftCorner": {
              "x": -3.948,
              "y": 23.901,
              "z": 1.147
            },
            "rightCorner": {
              "x": -3.79,
              "y": 23.889,
              "z": 1.147
            },
            "gtin": "8001090502094",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546760",
        "height": 1.7496,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1eee9",
            "leftCorner": {
              "x": -5.019,
              "y": 23.988,
              "z": 1.431
            },
            "rightCorner": {
              "x": -4.884,
              "y": 23.978,
              "z": 1.431
            },
            "gtin": "7610243002667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeea",
            "leftCorner": {
              "x": -4.884,
              "y": 23.978,
              "z": 1.431
            },
            "rightCorner": {
              "x": -4.749,
              "y": 23.968,
              "z": 1.431
            },
            "gtin": "7610243002667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeeb",
            "leftCorner": {
              "x": -4.749,
              "y": 23.968,
              "z": 1.431
            },
            "rightCorner": {
              "x": -4.615,
              "y": 23.958,
              "z": 1.431
            },
            "gtin": "7610243002667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeec",
            "leftCorner": {
              "x": -4.616,
              "y": 23.932,
              "z": 1.431
            },
            "rightCorner": {
              "x": -4.551,
              "y": 23.927,
              "z": 1.431
            },
            "gtin": "7640170984248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeed",
            "leftCorner": {
              "x": -4.551,
              "y": 23.927,
              "z": 1.431
            },
            "rightCorner": {
              "x": -4.486,
              "y": 23.922,
              "z": 1.431
            },
            "gtin": "7640170984248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeee",
            "leftCorner": {
              "x": -4.486,
              "y": 23.915,
              "z": 1.431
            },
            "rightCorner": {
              "x": -4.314,
              "y": 23.902,
              "z": 1.431
            },
            "gtin": "7610243009727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeef",
            "leftCorner": {
              "x": -4.314,
              "y": 23.902,
              "z": 1.431
            },
            "rightCorner": {
              "x": -4.143,
              "y": 23.89,
              "z": 1.431
            },
            "gtin": "7610243009727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eef0",
            "leftCorner": {
              "x": -4.143,
              "y": 23.89,
              "z": 1.431
            },
            "rightCorner": {
              "x": -3.971,
              "y": 23.876,
              "z": 1.431
            },
            "gtin": "7610243009727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eef1",
            "leftCorner": {
              "x": -3.969,
              "y": 23.903,
              "z": 1.431
            },
            "rightCorner": {
              "x": -3.866,
              "y": 23.896,
              "z": 1.431
            },
            "gtin": "4006508217700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eef2",
            "leftCorner": {
              "x": -3.866,
              "y": 23.896,
              "z": 1.431
            },
            "rightCorner": {
              "x": -3.763,
              "y": 23.888,
              "z": 1.431
            },
            "gtin": "4006508217700",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d82",
    "rightNeighborShelfId": "a6d84"
  },
  {
    "id": "a6d84",
    "name": "a6d84",
    "x": -3.815,
    "y": 23.847,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.037315,
      "w": 0.9993
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 48,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546766",
        "height": 0.15197,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef60",
            "leftCorner": {
              "x": -3.785,
              "y": 23.87,
              "z": 0.124
            },
            "rightCorner": {
              "x": -3.37,
              "y": 23.838,
              "z": 0.124
            },
            "gtin": "4015200035734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef61",
            "leftCorner": {
              "x": -3.37,
              "y": 23.838,
              "z": 0.124
            },
            "rightCorner": {
              "x": -2.955,
              "y": 23.808,
              "z": 0.124
            },
            "gtin": "4015200035734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef62",
            "leftCorner": {
              "x": -2.955,
              "y": 23.808,
              "z": 0.124
            },
            "rightCorner": {
              "x": -2.54,
              "y": 23.777,
              "z": 0.124
            },
            "gtin": "4015200035734",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546767",
        "height": 0.65373,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef33",
            "leftCorner": {
              "x": -3.297,
              "y": 23.842,
              "z": 0.535
            },
            "rightCorner": {
              "x": -3.21,
              "y": 23.837,
              "z": 0.535
            },
            "gtin": "8001090900883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef34",
            "leftCorner": {
              "x": -3.21,
              "y": 23.837,
              "z": 0.535
            },
            "rightCorner": {
              "x": -3.123,
              "y": 23.83,
              "z": 0.535
            },
            "gtin": "8001090900883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef35",
            "leftCorner": {
              "x": -3.123,
              "y": 23.83,
              "z": 0.535
            },
            "rightCorner": {
              "x": -3.036,
              "y": 23.823,
              "z": 0.535
            },
            "gtin": "8001090900883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef36",
            "leftCorner": {
              "x": -3.035,
              "y": 23.838,
              "z": 0.535
            },
            "rightCorner": {
              "x": -2.914,
              "y": 23.829,
              "z": 0.535
            },
            "gtin": "8700216136297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef37",
            "leftCorner": {
              "x": -2.914,
              "y": 23.829,
              "z": 0.535
            },
            "rightCorner": {
              "x": -2.794,
              "y": 23.82,
              "z": 0.535
            },
            "gtin": "8700216136297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef38",
            "leftCorner": {
              "x": -2.794,
              "y": 23.82,
              "z": 0.535
            },
            "rightCorner": {
              "x": -2.673,
              "y": 23.811,
              "z": 0.535
            },
            "gtin": "8700216136297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef39",
            "leftCorner": {
              "x": -2.673,
              "y": 23.811,
              "z": 0.535
            },
            "rightCorner": {
              "x": -2.553,
              "y": 23.802,
              "z": 0.535
            },
            "gtin": "8700216136297",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546765",
        "height": 1.0488,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee5a",
            "leftCorner": {
              "x": -3.739,
              "y": 23.885,
              "z": 0.858
            },
            "rightCorner": {
              "x": -3.636,
              "y": 23.877,
              "z": 0.858
            },
            "gtin": "4013162034987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee5b",
            "leftCorner": {
              "x": -3.636,
              "y": 23.877,
              "z": 0.858
            },
            "rightCorner": {
              "x": -3.534,
              "y": 23.869,
              "z": 0.858
            },
            "gtin": "4013162034987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee5c",
            "leftCorner": {
              "x": -3.534,
              "y": 23.869,
              "z": 0.858
            },
            "rightCorner": {
              "x": -3.431,
              "y": 23.862,
              "z": 0.858
            },
            "gtin": "4013162034987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee5d",
            "leftCorner": {
              "x": -3.431,
              "y": 23.862,
              "z": 0.858
            },
            "rightCorner": {
              "x": -3.329,
              "y": 23.855,
              "z": 0.858
            },
            "gtin": "4013162034987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee5e",
            "leftCorner": {
              "x": -3.33,
              "y": 23.841,
              "z": 0.858
            },
            "rightCorner": {
              "x": -3.059,
              "y": 23.821,
              "z": 0.858
            },
            "gtin": "4013162028993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee5f",
            "leftCorner": {
              "x": -3.057,
              "y": 23.844,
              "z": 0.858
            },
            "rightCorner": {
              "x": -2.975,
              "y": 23.837,
              "z": 0.858
            },
            "gtin": "4013162028856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee60",
            "leftCorner": {
              "x": -2.975,
              "y": 23.837,
              "z": 0.858
            },
            "rightCorner": {
              "x": -2.893,
              "y": 23.831,
              "z": 0.858
            },
            "gtin": "4013162028856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee61",
            "leftCorner": {
              "x": -2.893,
              "y": 23.831,
              "z": 0.858
            },
            "rightCorner": {
              "x": -2.811,
              "y": 23.825,
              "z": 0.858
            },
            "gtin": "4013162028856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee62",
            "leftCorner": {
              "x": -2.812,
              "y": 23.817,
              "z": 0.858
            },
            "rightCorner": {
              "x": -2.603,
              "y": 23.802,
              "z": 0.858
            },
            "gtin": "4013162029150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee63",
            "leftCorner": {
              "x": -2.603,
              "y": 23.802,
              "z": 0.858
            },
            "rightCorner": {
              "x": -2.394,
              "y": 23.786,
              "z": 0.858
            },
            "gtin": "4013162029150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee64",
            "leftCorner": {
              "x": -2.394,
              "y": 23.786,
              "z": 0.858
            },
            "rightCorner": {
              "x": -2.185,
              "y": 23.77,
              "z": 0.858
            },
            "gtin": "4013162029150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee65",
            "leftCorner": {
              "x": -2.185,
              "y": 23.77,
              "z": 0.858
            },
            "rightCorner": {
              "x": -1.975,
              "y": 23.755,
              "z": 0.858
            },
            "gtin": "4013162029150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee66",
            "leftCorner": {
              "x": -1.975,
              "y": 23.755,
              "z": 0.858
            },
            "rightCorner": {
              "x": -1.766,
              "y": 23.739,
              "z": 0.858
            },
            "gtin": "4013162029150",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546763",
        "height": 1.4045,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee92",
            "leftCorner": {
              "x": -3.79,
              "y": 23.882,
              "z": 1.149
            },
            "rightCorner": {
              "x": -3.687,
              "y": 23.875,
              "z": 1.149
            },
            "gtin": "4013162029112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee93",
            "leftCorner": {
              "x": -3.687,
              "y": 23.875,
              "z": 1.149
            },
            "rightCorner": {
              "x": -3.585,
              "y": 23.867,
              "z": 1.149
            },
            "gtin": "4013162029112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee94",
            "leftCorner": {
              "x": -3.585,
              "y": 23.867,
              "z": 1.149
            },
            "rightCorner": {
              "x": -3.482,
              "y": 23.859,
              "z": 1.149
            },
            "gtin": "4013162029112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee95",
            "leftCorner": {
              "x": -3.482,
              "y": 23.854,
              "z": 1.149
            },
            "rightCorner": {
              "x": -3.335,
              "y": 23.843,
              "z": 1.149
            },
            "gtin": "4013162029136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee96",
            "leftCorner": {
              "x": -3.335,
              "y": 23.843,
              "z": 1.149
            },
            "rightCorner": {
              "x": -3.188,
              "y": 23.831,
              "z": 1.149
            },
            "gtin": "4013162029136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee97",
            "leftCorner": {
              "x": -3.191,
              "y": 23.792,
              "z": 1.149
            },
            "rightCorner": {
              "x": -3.134,
              "y": 23.788,
              "z": 1.149
            },
            "gtin": "4013162033027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee98",
            "leftCorner": {
              "x": -3.134,
              "y": 23.788,
              "z": 1.149
            },
            "rightCorner": {
              "x": -3.077,
              "y": 23.784,
              "z": 1.149
            },
            "gtin": "4013162033027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee99",
            "leftCorner": {
              "x": -3.077,
              "y": 23.784,
              "z": 1.149
            },
            "rightCorner": {
              "x": -3.02,
              "y": 23.78,
              "z": 1.149
            },
            "gtin": "4013162033027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee9a",
            "leftCorner": {
              "x": -3.017,
              "y": 23.826,
              "z": 1.149
            },
            "rightCorner": {
              "x": -2.95,
              "y": 23.82,
              "z": 1.149
            },
            "gtin": "4013162028894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee9b",
            "leftCorner": {
              "x": -2.95,
              "y": 23.82,
              "z": 1.149
            },
            "rightCorner": {
              "x": -2.882,
              "y": 23.816,
              "z": 1.149
            },
            "gtin": "4013162028894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee9c",
            "leftCorner": {
              "x": -2.882,
              "y": 23.816,
              "z": 1.149
            },
            "rightCorner": {
              "x": -2.815,
              "y": 23.81,
              "z": 1.149
            },
            "gtin": "4013162028894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee9d",
            "leftCorner": {
              "x": -2.815,
              "y": 23.81,
              "z": 1.149
            },
            "rightCorner": {
              "x": -2.748,
              "y": 23.806,
              "z": 1.149
            },
            "gtin": "4013162028894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee9e",
            "leftCorner": {
              "x": -2.747,
              "y": 23.81,
              "z": 1.149
            },
            "rightCorner": {
              "x": -2.641,
              "y": 23.802,
              "z": 1.149
            },
            "gtin": "4001499964428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee9f",
            "leftCorner": {
              "x": -2.641,
              "y": 23.802,
              "z": 1.149
            },
            "rightCorner": {
              "x": -2.534,
              "y": 23.794,
              "z": 1.149
            },
            "gtin": "4001499964428",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546764",
        "height": 1.7492,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1eef3",
            "leftCorner": {
              "x": -3.764,
              "y": 23.876,
              "z": 1.431
            },
            "rightCorner": {
              "x": -3.648,
              "y": 23.867,
              "z": 1.431
            },
            "gtin": "4013162023929",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eef4",
            "leftCorner": {
              "x": -3.648,
              "y": 23.867,
              "z": 1.431
            },
            "rightCorner": {
              "x": -3.532,
              "y": 23.859,
              "z": 1.431
            },
            "gtin": "4013162023929",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eef5",
            "leftCorner": {
              "x": -3.533,
              "y": 23.854,
              "z": 1.431
            },
            "rightCorner": {
              "x": -3.47,
              "y": 23.849,
              "z": 1.431
            },
            "gtin": "4013162023967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eef6",
            "leftCorner": {
              "x": -3.47,
              "y": 23.849,
              "z": 1.431
            },
            "rightCorner": {
              "x": -3.406,
              "y": 23.845,
              "z": 1.431
            },
            "gtin": "4013162023967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eef7",
            "leftCorner": {
              "x": -3.406,
              "y": 23.845,
              "z": 1.431
            },
            "rightCorner": {
              "x": -3.343,
              "y": 23.84,
              "z": 1.431
            },
            "gtin": "4013162023967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eef8",
            "leftCorner": {
              "x": -3.344,
              "y": 23.831,
              "z": 1.431
            },
            "rightCorner": {
              "x": -3.213,
              "y": 23.821,
              "z": 1.431
            },
            "gtin": "4013162031962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eef9",
            "leftCorner": {
              "x": -3.213,
              "y": 23.821,
              "z": 1.431
            },
            "rightCorner": {
              "x": -3.082,
              "y": 23.811,
              "z": 1.431
            },
            "gtin": "4013162031962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eefa",
            "leftCorner": {
              "x": -3.082,
              "y": 23.811,
              "z": 1.431
            },
            "rightCorner": {
              "x": -2.951,
              "y": 23.801,
              "z": 1.431
            },
            "gtin": "4013162031962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eefb",
            "leftCorner": {
              "x": -2.949,
              "y": 23.833,
              "z": 1.431
            },
            "rightCorner": {
              "x": -2.808,
              "y": 23.823,
              "z": 1.431
            },
            "gtin": "4013162029075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eefc",
            "leftCorner": {
              "x": -2.808,
              "y": 23.823,
              "z": 1.431
            },
            "rightCorner": {
              "x": -2.667,
              "y": 23.813,
              "z": 1.431
            },
            "gtin": "4013162029075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eefd",
            "leftCorner": {
              "x": -2.667,
              "y": 23.813,
              "z": 1.431
            },
            "rightCorner": {
              "x": -2.526,
              "y": 23.802,
              "z": 1.431
            },
            "gtin": "4013162029075",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d83",
    "rightNeighborShelfId": "a6d85"
  },
  {
    "id": "a6d85",
    "name": "a6d85",
    "x": -2.569,
    "y": 23.754,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.037315,
      "w": 0.9993
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 32,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54676a",
        "height": 0.14828,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef65",
            "leftCorner": {
              "x": -2.325,
              "y": 23.796,
              "z": 0.121
            },
            "rightCorner": {
              "x": -2.192,
              "y": 23.786,
              "z": 0.121
            },
            "gtin": "4011200576901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef63",
            "leftCorner": {
              "x": -2.539,
              "y": 23.798,
              "z": 0.121
            },
            "rightCorner": {
              "x": -2.432,
              "y": 23.791,
              "z": 0.121
            },
            "gtin": "8718951666405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef64",
            "leftCorner": {
              "x": -2.432,
              "y": 23.791,
              "z": 0.121
            },
            "rightCorner": {
              "x": -2.326,
              "y": 23.783,
              "z": 0.121
            },
            "gtin": "8718951666405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef66",
            "leftCorner": {
              "x": -2.192,
              "y": 23.786,
              "z": 0.121
            },
            "rightCorner": {
              "x": -2.06,
              "y": 23.776,
              "z": 0.121
            },
            "gtin": "4011200576901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef67",
            "leftCorner": {
              "x": -2.06,
              "y": 23.776,
              "z": 0.121
            },
            "rightCorner": {
              "x": -1.928,
              "y": 23.766,
              "z": 0.121
            },
            "gtin": "4011200576901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef68",
            "leftCorner": {
              "x": -1.929,
              "y": 23.755,
              "z": 0.121
            },
            "rightCorner": {
              "x": -1.266,
              "y": 23.706,
              "z": 0.121
            },
            "gtin": "8718951666436",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54676b",
        "height": 0.64707,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef3a",
            "leftCorner": {
              "x": -2.552,
              "y": 23.819,
              "z": 0.529
            },
            "rightCorner": {
              "x": -2.429,
              "y": 23.81,
              "z": 0.529
            },
            "gtin": "4063367409233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef3b",
            "leftCorner": {
              "x": -2.429,
              "y": 23.81,
              "z": 0.529
            },
            "rightCorner": {
              "x": -2.306,
              "y": 23.801,
              "z": 0.529
            },
            "gtin": "4063367409233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef3c",
            "leftCorner": {
              "x": -2.307,
              "y": 23.79,
              "z": 0.529
            },
            "rightCorner": {
              "x": -2.089,
              "y": 23.773,
              "z": 0.529
            },
            "gtin": "4063367454615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef3d",
            "leftCorner": {
              "x": -2.089,
              "y": 23.773,
              "z": 0.529
            },
            "rightCorner": {
              "x": -1.871,
              "y": 23.757,
              "z": 0.529
            },
            "gtin": "4063367454615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef3e",
            "leftCorner": {
              "x": -1.871,
              "y": 23.757,
              "z": 0.529
            },
            "rightCorner": {
              "x": -1.654,
              "y": 23.74,
              "z": 0.529
            },
            "gtin": "4063367454615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef3f",
            "leftCorner": {
              "x": -1.654,
              "y": 23.74,
              "z": 0.529
            },
            "rightCorner": {
              "x": -1.436,
              "y": 23.724,
              "z": 0.529
            },
            "gtin": "4063367454615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef40",
            "leftCorner": {
              "x": -1.436,
              "y": 23.724,
              "z": 0.529
            },
            "rightCorner": {
              "x": -1.218,
              "y": 23.708,
              "z": 0.529
            },
            "gtin": "4063367454615",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54676c",
        "height": 1.0512,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee67",
            "leftCorner": {
              "x": -1.766,
              "y": 23.75,
              "z": 0.86
            },
            "rightCorner": {
              "x": -1.567,
              "y": 23.735,
              "z": 0.86
            },
            "gtin": "4002448143314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee68",
            "leftCorner": {
              "x": -1.568,
              "y": 23.725,
              "z": 0.86
            },
            "rightCorner": {
              "x": -1.451,
              "y": 23.716,
              "z": 0.86
            },
            "gtin": "4013162010493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee69",
            "leftCorner": {
              "x": -1.451,
              "y": 23.716,
              "z": 0.86
            },
            "rightCorner": {
              "x": -1.334,
              "y": 23.707,
              "z": 0.86
            },
            "gtin": "4013162010493",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546768",
        "height": 1.4037,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1eea0",
            "leftCorner": {
              "x": -2.534,
              "y": 23.798,
              "z": 1.148
            },
            "rightCorner": {
              "x": -2.402,
              "y": 23.788,
              "z": 1.148
            },
            "gtin": "4001499964541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eea1",
            "leftCorner": {
              "x": -2.402,
              "y": 23.788,
              "z": 1.148
            },
            "rightCorner": {
              "x": -2.27,
              "y": 23.778,
              "z": 1.148
            },
            "gtin": "4001499964541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eea2",
            "leftCorner": {
              "x": -2.27,
              "y": 23.778,
              "z": 1.148
            },
            "rightCorner": {
              "x": -2.137,
              "y": 23.768,
              "z": 1.148
            },
            "gtin": "4001499964541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eea3",
            "leftCorner": {
              "x": -2.137,
              "y": 23.768,
              "z": 1.148
            },
            "rightCorner": {
              "x": -2.005,
              "y": 23.758,
              "z": 1.148
            },
            "gtin": "4001499964541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eea4",
            "leftCorner": {
              "x": -2.005,
              "y": 23.762,
              "z": 1.148
            },
            "rightCorner": {
              "x": -1.905,
              "y": 23.754,
              "z": 1.148
            },
            "gtin": "4001499958694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eea5",
            "leftCorner": {
              "x": -1.905,
              "y": 23.754,
              "z": 1.148
            },
            "rightCorner": {
              "x": -1.805,
              "y": 23.747,
              "z": 1.148
            },
            "gtin": "4001499958694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eea6",
            "leftCorner": {
              "x": -1.805,
              "y": 23.747,
              "z": 1.148
            },
            "rightCorner": {
              "x": -1.524,
              "y": 23.726,
              "z": 1.148
            },
            "gtin": "4001499963339",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eea7",
            "leftCorner": {
              "x": -1.525,
              "y": 23.725,
              "z": 1.148
            },
            "rightCorner": {
              "x": -1.311,
              "y": 23.709,
              "z": 1.148
            },
            "gtin": "4015200033884",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546769",
        "height": 1.7486,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1eefe",
            "leftCorner": {
              "x": -2.527,
              "y": 23.8,
              "z": 1.431
            },
            "rightCorner": {
              "x": -2.319,
              "y": 23.784,
              "z": 1.431
            },
            "gtin": "4001499964534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeff",
            "leftCorner": {
              "x": -2.319,
              "y": 23.784,
              "z": 1.431
            },
            "rightCorner": {
              "x": -2.112,
              "y": 23.769,
              "z": 1.431
            },
            "gtin": "4001499964534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef00",
            "leftCorner": {
              "x": -2.112,
              "y": 23.769,
              "z": 1.431
            },
            "rightCorner": {
              "x": -1.904,
              "y": 23.753,
              "z": 1.431
            },
            "gtin": "4001499964534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef01",
            "leftCorner": {
              "x": -1.904,
              "y": 23.753,
              "z": 1.431
            },
            "rightCorner": {
              "x": -1.696,
              "y": 23.738,
              "z": 1.431
            },
            "gtin": "4001499964534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef02",
            "leftCorner": {
              "x": -1.696,
              "y": 23.743,
              "z": 1.431
            },
            "rightCorner": {
              "x": -1.593,
              "y": 23.734,
              "z": 1.431
            },
            "gtin": "4001499964510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef03",
            "leftCorner": {
              "x": -1.593,
              "y": 23.734,
              "z": 1.431
            },
            "rightCorner": {
              "x": -1.491,
              "y": 23.727,
              "z": 1.431
            },
            "gtin": "4001499964510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef04",
            "leftCorner": {
              "x": -1.49,
              "y": 23.73,
              "z": 1.431
            },
            "rightCorner": {
              "x": -1.385,
              "y": 23.722,
              "z": 1.431
            },
            "gtin": "4001499963506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef05",
            "leftCorner": {
              "x": -1.385,
              "y": 23.722,
              "z": 1.431
            },
            "rightCorner": {
              "x": -1.279,
              "y": 23.714,
              "z": 1.431
            },
            "gtin": "4001499963506",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d84",
    "rightNeighborShelfId": "a6d86"
  },
  {
    "id": "a6d86",
    "name": "a6d86",
    "x": -1.322,
    "y": 23.66,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.037315,
      "w": 0.9993
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 31,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546461",
        "height": 0.1461,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef69",
            "leftCorner": {
              "x": -1.266,
              "y": 23.706,
              "z": 0.12
            },
            "rightCorner": {
              "x": -0.894,
              "y": 23.677,
              "z": 0.12
            },
            "gtin": "4015200034171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef6a",
            "leftCorner": {
              "x": -0.893,
              "y": 23.687,
              "z": 0.12
            },
            "rightCorner": {
              "x": -0.457,
              "y": 23.655,
              "z": 0.12
            },
            "gtin": "4015200034164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef6b",
            "leftCorner": {
              "x": -0.458,
              "y": 23.633,
              "z": 0.12
            },
            "rightCorner": {
              "x": -0.337,
              "y": 23.624,
              "z": 0.12
            },
            "gtin": "4013162016167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef6c",
            "leftCorner": {
              "x": -0.336,
              "y": 23.635,
              "z": 0.12
            },
            "rightCorner": {
              "x": 0.082,
              "y": 23.604,
              "z": 0.12
            },
            "gtin": "4251758437358",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546462",
        "height": 0.20352,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef70",
            "leftCorner": {
              "x": -1.337,
              "y": 23.458,
              "z": 0.167
            },
            "rightCorner": {
              "x": -0.698,
              "y": 23.41,
              "z": 0.167
            },
            "gtin": "4262429770223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef71",
            "leftCorner": {
              "x": -0.695,
              "y": 23.447,
              "z": 0.167
            },
            "rightCorner": {
              "x": -0.391,
              "y": 23.425,
              "z": 0.167
            },
            "gtin": "4262429770223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef72",
            "leftCorner": {
              "x": -0.391,
              "y": 23.425,
              "z": 0.167
            },
            "rightCorner": {
              "x": -0.088,
              "y": 23.403,
              "z": 0.167
            },
            "gtin": "4262429770223",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546460",
        "height": 0.6441,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef41",
            "leftCorner": {
              "x": -1.219,
              "y": 23.695,
              "z": 0.527
            },
            "rightCorner": {
              "x": -1.067,
              "y": 23.684,
              "z": 0.527
            },
            "gtin": "4251758437792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef42",
            "leftCorner": {
              "x": -1.067,
              "y": 23.681,
              "z": 0.527
            },
            "rightCorner": {
              "x": -0.9,
              "y": 23.669,
              "z": 0.527
            },
            "gtin": "4251758427403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef43",
            "leftCorner": {
              "x": -0.9,
              "y": 23.669,
              "z": 0.527
            },
            "rightCorner": {
              "x": -0.732,
              "y": 23.657,
              "z": 0.527
            },
            "gtin": "4251758427403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef44",
            "leftCorner": {
              "x": -0.731,
              "y": 23.667,
              "z": 0.527
            },
            "rightCorner": {
              "x": -0.484,
              "y": 23.648,
              "z": 0.527
            },
            "gtin": "4013162035335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef45",
            "leftCorner": {
              "x": -0.485,
              "y": 23.644,
              "z": 0.527
            },
            "rightCorner": {
              "x": -0.072,
              "y": 23.613,
              "z": 0.527
            },
            "gtin": "4013162035649",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54645d",
        "height": 1.0477,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee6a",
            "leftCorner": {
              "x": -1.334,
              "y": 23.699,
              "z": 0.857
            },
            "rightCorner": {
              "x": -1.218,
              "y": 23.69,
              "z": 0.857
            },
            "gtin": "4013162035359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee6b",
            "leftCorner": {
              "x": -1.218,
              "y": 23.69,
              "z": 0.857
            },
            "rightCorner": {
              "x": -1.102,
              "y": 23.682,
              "z": 0.857
            },
            "gtin": "4013162035359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee6c",
            "leftCorner": {
              "x": -1.102,
              "y": 23.677,
              "z": 0.857
            },
            "rightCorner": {
              "x": -0.863,
              "y": 23.659,
              "z": 0.857
            },
            "gtin": "4013162035601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee6d",
            "leftCorner": {
              "x": -0.864,
              "y": 23.654,
              "z": 0.857
            },
            "rightCorner": {
              "x": -0.729,
              "y": 23.644,
              "z": 0.857
            },
            "gtin": "4251758437372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee6e",
            "leftCorner": {
              "x": -0.729,
              "y": 23.647,
              "z": 0.857
            },
            "rightCorner": {
              "x": -0.577,
              "y": 23.636,
              "z": 0.857
            },
            "gtin": "4251758436498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee6f",
            "leftCorner": {
              "x": -0.577,
              "y": 23.634,
              "z": 0.857
            },
            "rightCorner": {
              "x": -0.408,
              "y": 23.621,
              "z": 0.857
            },
            "gtin": "4251758436573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee70",
            "leftCorner": {
              "x": -0.409,
              "y": 23.618,
              "z": 0.857
            },
            "rightCorner": {
              "x": -0.264,
              "y": 23.607,
              "z": 0.857
            },
            "gtin": "4251758436450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee71",
            "leftCorner": {
              "x": -0.264,
              "y": 23.607,
              "z": 0.857
            },
            "rightCorner": {
              "x": -0.119,
              "y": 23.597,
              "z": 0.857
            },
            "gtin": "4251758436450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee72",
            "leftCorner": {
              "x": -0.119,
              "y": 23.597,
              "z": 0.857
            },
            "rightCorner": {
              "x": 0.026,
              "y": 23.585,
              "z": 0.857
            },
            "gtin": "4251758436450",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54645e",
        "height": 1.4009,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1eea8",
            "leftCorner": {
              "x": -1.311,
              "y": 23.702,
              "z": 1.146
            },
            "rightCorner": {
              "x": -1.131,
              "y": 23.69,
              "z": 1.146
            },
            "gtin": "4015000970228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eea9",
            "leftCorner": {
              "x": -1.132,
              "y": 23.681,
              "z": 1.146
            },
            "rightCorner": {
              "x": -1.01,
              "y": 23.671,
              "z": 1.146
            },
            "gtin": "4015200034164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeaa",
            "leftCorner": {
              "x": -1.009,
              "y": 23.685,
              "z": 1.146
            },
            "rightCorner": {
              "x": -0.642,
              "y": 23.657,
              "z": 1.146
            },
            "gtin": "4002448144717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeab",
            "leftCorner": {
              "x": -0.643,
              "y": 23.647,
              "z": 1.146
            },
            "rightCorner": {
              "x": -0.341,
              "y": 23.624,
              "z": 1.146
            },
            "gtin": "4251758427441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeac",
            "leftCorner": {
              "x": -0.341,
              "y": 23.624,
              "z": 1.146
            },
            "rightCorner": {
              "x": -0.038,
              "y": 23.602,
              "z": 1.146
            },
            "gtin": "4251758427441",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54645f",
        "height": 1.7484,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef06",
            "leftCorner": {
              "x": -1.279,
              "y": 23.703,
              "z": 1.43
            },
            "rightCorner": {
              "x": -1.21,
              "y": 23.697,
              "z": 1.43
            },
            "gtin": "4015200031156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef07",
            "leftCorner": {
              "x": -1.21,
              "y": 23.695,
              "z": 1.43
            },
            "rightCorner": {
              "x": -1.156,
              "y": 23.691,
              "z": 1.43
            },
            "gtin": "4015000302494",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef08",
            "leftCorner": {
              "x": -1.156,
              "y": 23.691,
              "z": 1.43
            },
            "rightCorner": {
              "x": -1.102,
              "y": 23.687,
              "z": 1.43
            },
            "gtin": "4015000302494",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef09",
            "leftCorner": {
              "x": -1.102,
              "y": 23.682,
              "z": 1.43
            },
            "rightCorner": {
              "x": -0.578,
              "y": 23.643,
              "z": 1.43
            },
            "gtin": "4015200035727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef0a",
            "leftCorner": {
              "x": -0.578,
              "y": 23.643,
              "z": 1.43
            },
            "rightCorner": {
              "x": -0.054,
              "y": 23.604,
              "z": 1.43
            },
            "gtin": "4015200035727",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d85",
    "rightNeighborShelfId": "a6d87"
  },
  {
    "id": "a6d87",
    "name": "a6d87",
    "x": -0.076,
    "y": 23.567,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.037315,
      "w": 0.9993
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 29,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffddfd15af3232a5469c0",
        "height": 0.14926,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef6d",
            "leftCorner": {
              "x": 0.082,
              "y": 23.61,
              "z": 0.122
            },
            "rightCorner": {
              "x": 0.172,
              "y": 23.603,
              "z": 0.122
            },
            "gtin": "4251758419781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef6e",
            "leftCorner": {
              "x": 0.172,
              "y": 23.603,
              "z": 0.122
            },
            "rightCorner": {
              "x": 0.262,
              "y": 23.597,
              "z": 0.122
            },
            "gtin": "4251758419781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef6f",
            "leftCorner": {
              "x": 0.262,
              "y": 23.594,
              "z": 0.122
            },
            "rightCorner": {
              "x": 1.197,
              "y": 23.524,
              "z": 0.122
            },
            "gtin": "4002448046424",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469be",
        "height": 0.64687,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef46",
            "leftCorner": {
              "x": -0.071,
              "y": 23.634,
              "z": 0.529
            },
            "rightCorner": {
              "x": 0.053,
              "y": 23.625,
              "z": 0.529
            },
            "gtin": "4015200033952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef47",
            "leftCorner": {
              "x": 0.053,
              "y": 23.621,
              "z": 0.529
            },
            "rightCorner": {
              "x": 0.17,
              "y": 23.612,
              "z": 0.529
            },
            "gtin": "4015200035512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef48",
            "leftCorner": {
              "x": 0.17,
              "y": 23.612,
              "z": 0.529
            },
            "rightCorner": {
              "x": 0.286,
              "y": 23.603,
              "z": 0.529
            },
            "gtin": "4015200035512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef49",
            "leftCorner": {
              "x": 0.286,
              "y": 23.598,
              "z": 0.529
            },
            "rightCorner": {
              "x": 0.61,
              "y": 23.574,
              "z": 0.529
            },
            "gtin": "4015200035444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef4a",
            "leftCorner": {
              "x": 0.61,
              "y": 23.581,
              "z": 0.529
            },
            "rightCorner": {
              "x": 0.709,
              "y": 23.573,
              "z": 0.529
            },
            "gtin": "4015200033938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef4b",
            "leftCorner": {
              "x": 0.709,
              "y": 23.573,
              "z": 0.529
            },
            "rightCorner": {
              "x": 0.901,
              "y": 23.559,
              "z": 0.529
            },
            "gtin": "4015200033921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef4c",
            "leftCorner": {
              "x": 0.901,
              "y": 23.559,
              "z": 0.529
            },
            "rightCorner": {
              "x": 1.094,
              "y": 23.545,
              "z": 0.529
            },
            "gtin": "4015200033921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef4d",
            "leftCorner": {
              "x": 1.094,
              "y": 23.539,
              "z": 0.529
            },
            "rightCorner": {
              "x": 1.256,
              "y": 23.527,
              "z": 0.529
            },
            "gtin": "4015200035451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef4e",
            "leftCorner": {
              "x": 1.256,
              "y": 23.527,
              "z": 0.529
            },
            "rightCorner": {
              "x": 1.419,
              "y": 23.515,
              "z": 0.529
            },
            "gtin": "4015200035451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef4f",
            "leftCorner": {
              "x": 1.419,
              "y": 23.515,
              "z": 0.529
            },
            "rightCorner": {
              "x": 1.582,
              "y": 23.503,
              "z": 0.529
            },
            "gtin": "4015200035451",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469bf",
        "height": 1.042,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee73",
            "leftCorner": {
              "x": 0.028,
              "y": 23.618,
              "z": 0.853
            },
            "rightCorner": {
              "x": 0.244,
              "y": 23.602,
              "z": 0.853
            },
            "gtin": "4251758412874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee74",
            "leftCorner": {
              "x": 0.244,
              "y": 23.602,
              "z": 0.853
            },
            "rightCorner": {
              "x": 0.46,
              "y": 23.585,
              "z": 0.853
            },
            "gtin": "4251758412874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee75",
            "leftCorner": {
              "x": 0.459,
              "y": 23.574,
              "z": 0.853
            },
            "rightCorner": {
              "x": 0.749,
              "y": 23.553,
              "z": 0.853
            },
            "gtin": "4251758419545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee76",
            "leftCorner": {
              "x": 0.749,
              "y": 23.553,
              "z": 0.853
            },
            "rightCorner": {
              "x": 1.039,
              "y": 23.531,
              "z": 0.853
            },
            "gtin": "4251758419545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee77",
            "leftCorner": {
              "x": 1.039,
              "y": 23.528,
              "z": 0.853
            },
            "rightCorner": {
              "x": 1.145,
              "y": 23.52,
              "z": 0.853
            },
            "gtin": "4251758436726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee78",
            "leftCorner": {
              "x": 1.145,
              "y": 23.52,
              "z": 0.853
            },
            "rightCorner": {
              "x": 1.251,
              "y": 23.512,
              "z": 0.853
            },
            "gtin": "4251758436726",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469bd",
        "height": 1.396,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1eead",
            "leftCorner": {
              "x": -0.038,
              "y": 23.616,
              "z": 1.142
            },
            "rightCorner": {
              "x": 0.194,
              "y": 23.599,
              "z": 1.142
            },
            "gtin": "4251758427786",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeae",
            "leftCorner": {
              "x": 0.194,
              "y": 23.599,
              "z": 1.142
            },
            "rightCorner": {
              "x": 0.426,
              "y": 23.581,
              "z": 1.142
            },
            "gtin": "4251758427786",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeaf",
            "leftCorner": {
              "x": 0.425,
              "y": 23.575,
              "z": 1.142
            },
            "rightCorner": {
              "x": 0.703,
              "y": 23.554,
              "z": 1.142
            },
            "gtin": "4251758418784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeb0",
            "leftCorner": {
              "x": 0.703,
              "y": 23.554,
              "z": 1.142
            },
            "rightCorner": {
              "x": 0.981,
              "y": 23.533,
              "z": 1.142
            },
            "gtin": "4251758418784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeb1",
            "leftCorner": {
              "x": 0.981,
              "y": 23.533,
              "z": 1.142
            },
            "rightCorner": {
              "x": 1.258,
              "y": 23.512,
              "z": 1.142
            },
            "gtin": "4251758418784",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469bc",
        "height": 1.7473,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef0b",
            "leftCorner": {
              "x": -0.053,
              "y": 23.616,
              "z": 1.43
            },
            "rightCorner": {
              "x": 0.252,
              "y": 23.593,
              "z": 1.43
            },
            "gtin": "4251758427502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef0c",
            "leftCorner": {
              "x": 0.252,
              "y": 23.593,
              "z": 1.43
            },
            "rightCorner": {
              "x": 0.556,
              "y": 23.571,
              "z": 1.43
            },
            "gtin": "4251758427502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef0d",
            "leftCorner": {
              "x": 0.556,
              "y": 23.571,
              "z": 1.43
            },
            "rightCorner": {
              "x": 0.861,
              "y": 23.547,
              "z": 1.43
            },
            "gtin": "4251758427502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef0e",
            "leftCorner": {
              "x": 0.862,
              "y": 23.549,
              "z": 1.43
            },
            "rightCorner": {
              "x": 1.04,
              "y": 23.536,
              "z": 1.43
            },
            "gtin": "4251758427366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef0f",
            "leftCorner": {
              "x": 1.039,
              "y": 23.531,
              "z": 1.43
            },
            "rightCorner": {
              "x": 1.18,
              "y": 23.521,
              "z": 1.43
            },
            "gtin": "4251758436436",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d86",
    "rightNeighborShelfId": "a6d88"
  },
  {
    "id": "a6d88",
    "name": "a6d88",
    "x": 1.171,
    "y": 23.474,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.037315,
      "w": 0.9993
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 21
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546770",
        "height": 0.1484,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef50",
            "leftCorner": {
              "x": 1.198,
              "y": 23.526,
              "z": 0.121
            },
            "rightCorner": {
              "x": 1.81,
              "y": 23.481,
              "z": 0.121
            },
            "gtin": "4262429771015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef51",
            "leftCorner": {
              "x": 1.81,
              "y": 23.481,
              "z": 0.121
            },
            "rightCorner": {
              "x": 2.422,
              "y": 23.435,
              "z": 0.121
            },
            "gtin": "4262429771015",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546771",
        "height": 0.64156,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef1c",
            "leftCorner": {
              "x": 1.582,
              "y": 23.497,
              "z": 0.525
            },
            "rightCorner": {
              "x": 2.002,
              "y": 23.466,
              "z": 0.525
            },
            "gtin": "4063367397523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef1d",
            "leftCorner": {
              "x": 2.002,
              "y": 23.466,
              "z": 0.525
            },
            "rightCorner": {
              "x": 2.422,
              "y": 23.435,
              "z": 0.525
            },
            "gtin": "4063367397523",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54676e",
        "height": 1.0519,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee46",
            "leftCorner": {
              "x": 1.253,
              "y": 23.519,
              "z": 0.861
            },
            "rightCorner": {
              "x": 1.642,
              "y": 23.49,
              "z": 0.861
            },
            "gtin": "4063367420399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee47",
            "leftCorner": {
              "x": 1.642,
              "y": 23.49,
              "z": 0.861
            },
            "rightCorner": {
              "x": 2.032,
              "y": 23.461,
              "z": 0.861
            },
            "gtin": "4063367420399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee48",
            "leftCorner": {
              "x": 2.032,
              "y": 23.461,
              "z": 0.861
            },
            "rightCorner": {
              "x": 2.421,
              "y": 23.432,
              "z": 0.861
            },
            "gtin": "4063367420399",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54676f",
        "height": 1.3935,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee7a",
            "leftCorner": {
              "x": 1.259,
              "y": 23.511,
              "z": 1.14
            },
            "rightCorner": {
              "x": 1.646,
              "y": 23.482,
              "z": 1.14
            },
            "gtin": "4063367443145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee7b",
            "leftCorner": {
              "x": 1.646,
              "y": 23.482,
              "z": 1.14
            },
            "rightCorner": {
              "x": 2.033,
              "y": 23.453,
              "z": 1.14
            },
            "gtin": "4063367443145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee7c",
            "leftCorner": {
              "x": 2.033,
              "y": 23.453,
              "z": 1.14
            },
            "rightCorner": {
              "x": 2.421,
              "y": 23.424,
              "z": 1.14
            },
            "gtin": "4063367443145",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54676d",
        "height": 1.7438,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef10",
            "leftCorner": {
              "x": 1.18,
              "y": 23.512,
              "z": 1.427
            },
            "rightCorner": {
              "x": 1.367,
              "y": 23.497,
              "z": 1.427
            },
            "gtin": "4251758400451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef11",
            "leftCorner": {
              "x": 1.367,
              "y": 23.504,
              "z": 1.427
            },
            "rightCorner": {
              "x": 1.491,
              "y": 23.495,
              "z": 1.427
            },
            "gtin": "4251758400475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef12",
            "leftCorner": {
              "x": 1.492,
              "y": 23.503,
              "z": 1.427
            },
            "rightCorner": {
              "x": 1.592,
              "y": 23.496,
              "z": 1.427
            },
            "gtin": "4002448028284",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef13",
            "leftCorner": {
              "x": 1.591,
              "y": 23.493,
              "z": 1.427
            },
            "rightCorner": {
              "x": 1.703,
              "y": 23.485,
              "z": 1.427
            },
            "gtin": "4002448046462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef14",
            "leftCorner": {
              "x": 1.704,
              "y": 23.498,
              "z": 1.427
            },
            "rightCorner": {
              "x": 1.82,
              "y": 23.489,
              "z": 1.427
            },
            "gtin": "4002448046486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef15",
            "leftCorner": {
              "x": 1.82,
              "y": 23.488,
              "z": 1.427
            },
            "rightCorner": {
              "x": 1.959,
              "y": 23.478,
              "z": 1.427
            },
            "gtin": "4251758400574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef16",
            "leftCorner": {
              "x": 1.959,
              "y": 23.481,
              "z": 1.427
            },
            "rightCorner": {
              "x": 2.098,
              "y": 23.47,
              "z": 1.427
            },
            "gtin": "4337185486562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef17",
            "leftCorner": {
              "x": 2.098,
              "y": 23.47,
              "z": 1.427
            },
            "rightCorner": {
              "x": 2.237,
              "y": 23.459,
              "z": 1.427
            },
            "gtin": "4337185486562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef18",
            "leftCorner": {
              "x": 2.235,
              "y": 23.432,
              "z": 1.427
            },
            "rightCorner": {
              "x": 2.308,
              "y": 23.427,
              "z": 1.427
            },
            "gtin": "4337185550010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef19",
            "leftCorner": {
              "x": 2.308,
              "y": 23.427,
              "z": 1.427
            },
            "rightCorner": {
              "x": 2.381,
              "y": 23.422,
              "z": 1.427
            },
            "gtin": "4337185550010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eeb6",
            "leftCorner": {
              "x": 2.383,
              "y": 23.446,
              "z": 1.427
            },
            "rightCorner": {
              "x": 2.422,
              "y": 23.443,
              "z": 1.427
            },
            "gtin": "4063367304200",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d87"
  },
  {
    "id": "a6d8b",
    "name": "a6d8b",
    "x": 1.26,
    "y": 24.597,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99967,
      "w": 0.025645
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 9,
      "unknownStockCount": 16
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546702",
        "height": 0.14313,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c80",
            "leftCorner": {
              "x": 1.215,
              "y": 24.556,
              "z": 0.117
            },
            "rightCorner": {
              "x": 1.145,
              "y": 24.56,
              "z": 0.117
            },
            "gtin": "4006501510006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c81",
            "leftCorner": {
              "x": 1.145,
              "y": 24.56,
              "z": 0.117
            },
            "rightCorner": {
              "x": 1.075,
              "y": 24.563,
              "z": 0.117
            },
            "gtin": "4006501510006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c82",
            "leftCorner": {
              "x": 1.076,
              "y": 24.564,
              "z": 0.117
            },
            "rightCorner": {
              "x": 0.982,
              "y": 24.569,
              "z": 0.117
            },
            "gtin": "4006501414144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c83",
            "leftCorner": {
              "x": 0.982,
              "y": 24.569,
              "z": 0.117
            },
            "rightCorner": {
              "x": 0.889,
              "y": 24.574,
              "z": 0.117
            },
            "gtin": "4006501414144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c84",
            "leftCorner": {
              "x": 0.889,
              "y": 24.566,
              "z": 0.117
            },
            "rightCorner": {
              "x": -0.312,
              "y": 24.628,
              "z": 0.117
            },
            "gtin": "4006501555137",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546709",
        "height": 0.57978,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e88",
            "leftCorner": {
              "x": 1.257,
              "y": 24.546,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.158,
              "y": 24.603,
              "z": 0.474
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e89",
            "leftCorner": {
              "x": 0.156,
              "y": 24.565,
              "z": 0.474
            },
            "rightCorner": {
              "x": 0.007,
              "y": 24.573,
              "z": 0.474
            },
            "gtin": "4023103125742",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546707",
        "height": 0.69865,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e84",
            "leftCorner": {
              "x": 1.259,
              "y": 24.573,
              "z": 0.572
            },
            "rightCorner": {
              "x": 0.402,
              "y": 24.617,
              "z": 0.572
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e85",
            "leftCorner": {
              "x": 0.4,
              "y": 24.576,
              "z": 0.572
            },
            "rightCorner": {
              "x": 0.008,
              "y": 24.597,
              "z": 0.572
            },
            "gtin": "4023103172326",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546703",
        "height": 0.73636,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e7c",
            "leftCorner": {
              "x": 1.256,
              "y": 24.52,
              "z": 0.602
            },
            "rightCorner": {
              "x": 1.056,
              "y": 24.53,
              "z": 0.602
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e7d",
            "leftCorner": {
              "x": 1.056,
              "y": 24.53,
              "z": 0.602
            },
            "rightCorner": {
              "x": 0.857,
              "y": 24.54,
              "z": 0.602
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e7e",
            "leftCorner": {
              "x": 0.855,
              "y": 24.501,
              "z": 0.602
            },
            "rightCorner": {
              "x": 0.43,
              "y": 24.523,
              "z": 0.602
            },
            "gtin": "4006501414144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e7f",
            "leftCorner": {
              "x": 0.43,
              "y": 24.523,
              "z": 0.602
            },
            "rightCorner": {
              "x": 0.006,
              "y": 24.545,
              "z": 0.602
            },
            "gtin": "4006501414144",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546700",
        "height": 0.93565,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e7a",
            "leftCorner": {
              "x": 1.258,
              "y": 24.563,
              "z": 0.766
            },
            "rightCorner": {
              "x": 1.078,
              "y": 24.572,
              "z": 0.766
            },
            "gtin": "4006501513205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e7b",
            "leftCorner": {
              "x": 1.076,
              "y": 24.532,
              "z": 0.766
            },
            "rightCorner": {
              "x": 0.008,
              "y": 24.587,
              "z": 0.766
            },
            "gtin": "4023103195189",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546705",
        "height": 1.4078,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c72",
            "leftCorner": {
              "x": 1.258,
              "y": 24.559,
              "z": 1.152
            },
            "rightCorner": {
              "x": 0.893,
              "y": 24.578,
              "z": 1.152
            },
            "gtin": "4006501417022",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546708",
        "height": 1.581,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e86",
            "leftCorner": {
              "x": 1.259,
              "y": 24.576,
              "z": 1.294
            },
            "rightCorner": {
              "x": 0.259,
              "y": 24.628,
              "z": 1.294
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e87",
            "leftCorner": {
              "x": 0.258,
              "y": 24.597,
              "z": 1.294
            },
            "rightCorner": {
              "x": 0.009,
              "y": 24.61,
              "z": 1.294
            },
            "gtin": "4023103212138",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546706",
        "height": 1.6634,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e82",
            "leftCorner": {
              "x": 1.258,
              "y": 24.56,
              "z": 1.361
            },
            "rightCorner": {
              "x": 0.419,
              "y": 24.603,
              "z": 1.361
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e83",
            "leftCorner": {
              "x": 0.417,
              "y": 24.564,
              "z": 1.361
            },
            "rightCorner": {
              "x": 0.008,
              "y": 24.584,
              "z": 1.361
            },
            "gtin": "4023103095755",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546704",
        "height": 1.6994,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e80",
            "leftCorner": {
              "x": 1.258,
              "y": 24.558,
              "z": 1.39
            },
            "rightCorner": {
              "x": 0.866,
              "y": 24.579,
              "z": 1.39
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e81",
            "leftCorner": {
              "x": 0.864,
              "y": 24.539,
              "z": 1.39
            },
            "rightCorner": {
              "x": 0.008,
              "y": 24.582,
              "z": 1.39
            },
            "gtin": "4006501450326",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466fe",
        "height": 1.7289,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e77",
            "leftCorner": {
              "x": 1.258,
              "y": 24.563,
              "z": 1.415
            },
            "rightCorner": {
              "x": 1.172,
              "y": 24.567,
              "z": 1.415
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e78",
            "leftCorner": {
              "x": 1.171,
              "y": 24.53,
              "z": 1.415
            },
            "rightCorner": {
              "x": 0.589,
              "y": 24.56,
              "z": 1.415
            },
            "gtin": "4006501417015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e79",
            "leftCorner": {
              "x": 0.589,
              "y": 24.56,
              "z": 1.415
            },
            "rightCorner": {
              "x": 0.008,
              "y": 24.589,
              "z": 1.415
            },
            "gtin": "4006501417015",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546701",
        "height": 1.9194,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c50",
            "leftCorner": {
              "x": 1.021,
              "y": 24.564,
              "z": 1.57
            },
            "rightCorner": {
              "x": 0.795,
              "y": 24.576,
              "z": 1.57
            },
            "gtin": "4006501550453",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20c51",
            "leftCorner": {
              "x": 0.795,
              "y": 24.575,
              "z": 1.57
            },
            "rightCorner": {
              "x": 0.716,
              "y": 24.579,
              "z": 1.57
            },
            "gtin": "4006501566737",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20c52",
            "leftCorner": {
              "x": 0.715,
              "y": 24.561,
              "z": 1.57
            },
            "rightCorner": {
              "x": 0.659,
              "y": 24.564,
              "z": 1.57
            },
            "gtin": "4006501415226",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20c53",
            "leftCorner": {
              "x": 0.659,
              "y": 24.567,
              "z": 1.57
            },
            "rightCorner": {
              "x": 0.597,
              "y": 24.57,
              "z": 1.57
            },
            "gtin": "4006501415233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c54",
            "leftCorner": {
              "x": 0.597,
              "y": 24.568,
              "z": 1.57
            },
            "rightCorner": {
              "x": 0.539,
              "y": 24.572,
              "z": 1.57
            },
            "gtin": "4006501450227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c55",
            "leftCorner": {
              "x": 0.539,
              "y": 24.575,
              "z": 1.57
            },
            "rightCorner": {
              "x": 0.351,
              "y": 24.584,
              "z": 1.57
            },
            "gtin": "4023103131217",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20c56",
            "leftCorner": {
              "x": 0.351,
              "y": 24.583,
              "z": 1.57
            },
            "rightCorner": {
              "x": 0.126,
              "y": 24.595,
              "z": 1.57
            },
            "gtin": "4003790014697",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20c57",
            "leftCorner": {
              "x": 0.128,
              "y": 24.619,
              "z": 1.57
            },
            "rightCorner": {
              "x": 0.023,
              "y": 24.624,
              "z": 1.57
            },
            "gtin": "4003790014703",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d13b7",
    "rightNeighborShelfId": "a6d8c"
  },
  {
    "id": "a6d8c",
    "name": "a6d8c",
    "x": 0.012,
    "y": 24.661,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99967,
      "w": 0.025645
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 17
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54670a",
        "height": 1.7416,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e8a",
            "leftCorner": {
              "x": 0.01,
              "y": 24.618,
              "z": 1.425
            },
            "rightCorner": {
              "x": -0.079,
              "y": 24.622,
              "z": 1.425
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e8b",
            "leftCorner": {
              "x": -0.081,
              "y": 24.585,
              "z": 1.425
            },
            "rightCorner": {
              "x": -0.661,
              "y": 24.614,
              "z": 1.425
            },
            "gtin": "4023103195189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e8c",
            "leftCorner": {
              "x": -0.661,
              "y": 24.614,
              "z": 1.425
            },
            "rightCorner": {
              "x": -1.241,
              "y": 24.644,
              "z": 1.425
            },
            "gtin": "4023103195189",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546711",
        "height": 0.1455,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a546712",
        "height": 0.7979,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e99",
            "leftCorner": {
              "x": 0.009,
              "y": 24.603,
              "z": 0.653
            },
            "rightCorner": {
              "x": -0.291,
              "y": 24.618,
              "z": 0.653
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e9a",
            "leftCorner": {
              "x": -0.291,
              "y": 24.618,
              "z": 0.653
            },
            "rightCorner": {
              "x": -0.59,
              "y": 24.634,
              "z": 0.653
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e9b",
            "leftCorner": {
              "x": -0.592,
              "y": 24.595,
              "z": 0.653
            },
            "rightCorner": {
              "x": -0.917,
              "y": 24.612,
              "z": 0.653
            },
            "gtin": "4003790014772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e9c",
            "leftCorner": {
              "x": -0.917,
              "y": 24.612,
              "z": 0.653
            },
            "rightCorner": {
              "x": -1.241,
              "y": 24.628,
              "z": 0.653
            },
            "gtin": "4003790014772",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54670d",
        "height": 0.97845,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e8f",
            "leftCorner": {
              "x": 0.01,
              "y": 24.628,
              "z": 0.801
            },
            "rightCorner": {
              "x": -0.133,
              "y": 24.635,
              "z": 0.801
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e90",
            "leftCorner": {
              "x": -0.135,
              "y": 24.598,
              "z": 0.801
            },
            "rightCorner": {
              "x": -1.24,
              "y": 24.655,
              "z": 0.801
            },
            "gtin": "4023103201262",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54670e",
        "height": 1.0548,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e91",
            "leftCorner": {
              "x": 0.01,
              "y": 24.63,
              "z": 0.863
            },
            "rightCorner": {
              "x": -0.48,
              "y": 24.655,
              "z": 0.863
            },
            "gtin": "4023103201262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e92",
            "leftCorner": {
              "x": -0.48,
              "y": 24.655,
              "z": 0.863
            },
            "rightCorner": {
              "x": -0.97,
              "y": 24.681,
              "z": 0.863
            },
            "gtin": "4023103201262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e93",
            "leftCorner": {
              "x": -0.972,
              "y": 24.651,
              "z": 0.863
            },
            "rightCorner": {
              "x": -1.106,
              "y": 24.657,
              "z": 0.863
            },
            "gtin": "4023103212664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e94",
            "leftCorner": {
              "x": -1.106,
              "y": 24.657,
              "z": 0.863
            },
            "rightCorner": {
              "x": -1.239,
              "y": 24.664,
              "z": 0.863
            },
            "gtin": "4023103212664",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546710",
        "height": 1.3493,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e97",
            "leftCorner": {
              "x": 0.009,
              "y": 24.607,
              "z": 1.104
            },
            "rightCorner": {
              "x": -0.369,
              "y": 24.627,
              "z": 1.104
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e98",
            "leftCorner": {
              "x": -0.372,
              "y": 24.584,
              "z": 1.104
            },
            "rightCorner": {
              "x": -1.241,
              "y": 24.628,
              "z": 1.104
            },
            "gtin": "4003790110993",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54670c",
        "height": 1.3754,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e8d",
            "leftCorner": {
              "x": 0.01,
              "y": 24.618,
              "z": 1.125
            },
            "rightCorner": {
              "x": -0.579,
              "y": 24.648,
              "z": 1.125
            },
            "gtin": "4023103143616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e8e",
            "leftCorner": {
              "x": -0.581,
              "y": 24.609,
              "z": 1.125
            },
            "rightCorner": {
              "x": -1.241,
              "y": 24.644,
              "z": 1.125
            },
            "gtin": "4023103072213",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546714",
        "height": 1.4042,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c74",
            "leftCorner": {
              "x": -0.979,
              "y": 24.638,
              "z": 1.149
            },
            "rightCorner": {
              "x": -1.881,
              "y": 24.684,
              "z": 1.149
            },
            "gtin": "4023103212060",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546713",
        "height": 1.4321,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e9d",
            "leftCorner": {
              "x": 0.01,
              "y": 24.631,
              "z": 1.172
            },
            "rightCorner": {
              "x": -0.751,
              "y": 24.67,
              "z": 1.172
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e9e",
            "leftCorner": {
              "x": -0.753,
              "y": 24.63,
              "z": 1.172
            },
            "rightCorner": {
              "x": -1.24,
              "y": 24.655,
              "z": 1.172
            },
            "gtin": "4023103242555",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54670f",
        "height": 1.6513,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e95",
            "leftCorner": {
              "x": 0.01,
              "y": 24.617,
              "z": 1.351
            },
            "rightCorner": {
              "x": -0.37,
              "y": 24.637,
              "z": 1.351
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e96",
            "leftCorner": {
              "x": -0.372,
              "y": 24.597,
              "z": 1.351
            },
            "rightCorner": {
              "x": -1.241,
              "y": 24.642,
              "z": 1.351
            },
            "gtin": "4023103243453",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54670b",
        "height": 1.9281,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c58",
            "leftCorner": {
              "x": 0.021,
              "y": 24.582,
              "z": 1.578
            },
            "rightCorner": {
              "x": -0.472,
              "y": 24.607,
              "z": 1.578
            },
            "gtin": "4023103094192",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20c59",
            "leftCorner": {
              "x": -0.47,
              "y": 24.645,
              "z": 1.578
            },
            "rightCorner": {
              "x": -0.662,
              "y": 24.655,
              "z": 1.578
            },
            "gtin": "4003790014734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c5a",
            "leftCorner": {
              "x": -0.663,
              "y": 24.627,
              "z": 1.578
            },
            "rightCorner": {
              "x": -0.835,
              "y": 24.636,
              "z": 1.578
            },
            "gtin": "4023103212046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c5b",
            "leftCorner": {
              "x": -0.834,
              "y": 24.654,
              "z": 1.578
            },
            "rightCorner": {
              "x": -1.044,
              "y": 24.665,
              "z": 1.578
            },
            "gtin": "4023103143593",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c5c",
            "leftCorner": {
              "x": -1.043,
              "y": 24.683,
              "z": 1.578
            },
            "rightCorner": {
              "x": -1.263,
              "y": 24.695,
              "z": 1.578
            },
            "gtin": "4023103199200",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d8b",
    "rightNeighborShelfId": "a6d8d"
  },
  {
    "id": "a6d8d",
    "name": "a6d8d",
    "x": -1.237,
    "y": 24.725,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99967,
      "w": 0.025645
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 7,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546718",
        "height": 0.15198,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c85",
            "leftCorner": {
              "x": -1.562,
              "y": 24.699,
              "z": 0.124
            },
            "rightCorner": {
              "x": -1.826,
              "y": 24.713,
              "z": 0.124
            },
            "gtin": "4023103201415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c86",
            "leftCorner": {
              "x": -1.825,
              "y": 24.727,
              "z": 0.124
            },
            "rightCorner": {
              "x": -2.06,
              "y": 24.739,
              "z": 0.124
            },
            "gtin": "4003790105111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c87",
            "leftCorner": {
              "x": -2.06,
              "y": 24.739,
              "z": 0.124
            },
            "rightCorner": {
              "x": -2.296,
              "y": 24.751,
              "z": 0.124
            },
            "gtin": "4003790105111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c88",
            "leftCorner": {
              "x": -2.297,
              "y": 24.717,
              "z": 0.124
            },
            "rightCorner": {
              "x": -2.747,
              "y": 24.741,
              "z": 0.124
            },
            "gtin": "4004617552415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c89",
            "leftCorner": {
              "x": -2.747,
              "y": 24.741,
              "z": 0.124
            },
            "rightCorner": {
              "x": -3.196,
              "y": 24.763,
              "z": 0.124
            },
            "gtin": "4004617552415",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54671c",
        "height": 0.96183,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ea6",
            "leftCorner": {
              "x": -1.238,
              "y": 24.711,
              "z": 0.787
            },
            "rightCorner": {
              "x": -2.149,
              "y": 24.758,
              "z": 0.787
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20ea7",
            "leftCorner": {
              "x": -2.151,
              "y": 24.717,
              "z": 0.787
            },
            "rightCorner": {
              "x": -2.488,
              "y": 24.734,
              "z": 0.787
            },
            "gtin": "4001438117229",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54671d",
        "height": 0.99463,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ea8",
            "leftCorner": {
              "x": -1.239,
              "y": 24.689,
              "z": 0.814
            },
            "rightCorner": {
              "x": -2.362,
              "y": 24.747,
              "z": 0.814
            },
            "gtin": "4066632058570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ea9",
            "leftCorner": {
              "x": -2.363,
              "y": 24.722,
              "z": 0.814
            },
            "rightCorner": {
              "x": -2.488,
              "y": 24.728,
              "z": 0.814
            },
            "gtin": "4066633061616",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546717",
        "height": 1.0725,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e9f",
            "leftCorner": {
              "x": -1.239,
              "y": 24.691,
              "z": 0.877
            },
            "rightCorner": {
              "x": -1.552,
              "y": 24.707,
              "z": 0.877
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20ea0",
            "leftCorner": {
              "x": -1.554,
              "y": 24.669,
              "z": 0.877
            },
            "rightCorner": {
              "x": -2.022,
              "y": 24.692,
              "z": 0.877
            },
            "gtin": "4001438880468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ea1",
            "leftCorner": {
              "x": -2.022,
              "y": 24.692,
              "z": 0.877
            },
            "rightCorner": {
              "x": -2.489,
              "y": 24.716,
              "z": 0.877
            },
            "gtin": "4001438880468",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54671a",
        "height": 1.2893,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a54671b",
        "height": 1.4093,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c75",
            "leftCorner": {
              "x": -1.882,
              "y": 24.689,
              "z": 1.153
            },
            "rightCorner": {
              "x": -2.854,
              "y": 24.739,
              "z": 1.153
            },
            "gtin": "8711252476841",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546715",
        "height": 1.4591,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c43",
            "leftCorner": {
              "x": -1.238,
              "y": 24.698,
              "z": 1.194
            },
            "rightCorner": {
              "x": -1.986,
              "y": 24.736,
              "z": 1.194
            },
            "gtin": "4004617000527",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20c46",
            "leftCorner": {
              "x": -1.988,
              "y": 24.698,
              "z": 1.194
            },
            "rightCorner": {
              "x": -2.137,
              "y": 24.705,
              "z": 1.194
            },
            "gtin": "4001438880468",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20c47",
            "leftCorner": {
              "x": -2.137,
              "y": 24.7,
              "z": 1.194
            },
            "rightCorner": {
              "x": -2.353,
              "y": 24.71,
              "z": 1.194
            },
            "gtin": "4001438880383",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20c48",
            "leftCorner": {
              "x": -2.353,
              "y": 24.717,
              "z": 1.194
            },
            "rightCorner": {
              "x": -2.574,
              "y": 24.729,
              "z": 1.194
            },
            "gtin": "4001438880185",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546719",
        "height": 1.6012,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ea2",
            "leftCorner": {
              "x": -1.238,
              "y": 24.698,
              "z": 1.31
            },
            "rightCorner": {
              "x": -1.458,
              "y": 24.71,
              "z": 1.31
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20ea3",
            "leftCorner": {
              "x": -1.458,
              "y": 24.71,
              "z": 1.31
            },
            "rightCorner": {
              "x": -1.678,
              "y": 24.721,
              "z": 1.31
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20ea4",
            "leftCorner": {
              "x": -1.68,
              "y": 24.683,
              "z": 1.31
            },
            "rightCorner": {
              "x": -2.085,
              "y": 24.703,
              "z": 1.31
            },
            "gtin": "4066627344466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ea5",
            "leftCorner": {
              "x": -2.085,
              "y": 24.703,
              "z": 1.31
            },
            "rightCorner": {
              "x": -2.489,
              "y": 24.724,
              "z": 1.31
            },
            "gtin": "4066627344466",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546716",
        "height": 1.9242,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c5d",
            "leftCorner": {
              "x": -1.265,
              "y": 24.669,
              "z": 1.574
            },
            "rightCorner": {
              "x": -1.402,
              "y": 24.677,
              "z": 1.574
            },
            "gtin": "4001438168566",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20c5e",
            "leftCorner": {
              "x": -1.401,
              "y": 24.698,
              "z": 1.574
            },
            "rightCorner": {
              "x": -1.508,
              "y": 24.703,
              "z": 1.574
            },
            "gtin": "4001438880505",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20c5f",
            "leftCorner": {
              "x": -1.509,
              "y": 24.698,
              "z": 1.574
            },
            "rightCorner": {
              "x": -1.705,
              "y": 24.708,
              "z": 1.574
            },
            "gtin": "4337185849787",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20c60",
            "leftCorner": {
              "x": -1.705,
              "y": 24.709,
              "z": 1.574
            },
            "rightCorner": {
              "x": -1.867,
              "y": 24.717,
              "z": 1.574
            },
            "gtin": "4023103199217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c61",
            "leftCorner": {
              "x": -1.868,
              "y": 24.704,
              "z": 1.574
            },
            "rightCorner": {
              "x": -1.978,
              "y": 24.709,
              "z": 1.574
            },
            "gtin": "4001438670106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c62",
            "leftCorner": {
              "x": -1.978,
              "y": 24.714,
              "z": 1.574
            },
            "rightCorner": {
              "x": -2.06,
              "y": 24.719,
              "z": 1.574
            },
            "gtin": "4001438168559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c63",
            "leftCorner": {
              "x": -2.06,
              "y": 24.719,
              "z": 1.574
            },
            "rightCorner": {
              "x": -2.142,
              "y": 24.723,
              "z": 1.574
            },
            "gtin": "4001438168559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c64",
            "leftCorner": {
              "x": -2.142,
              "y": 24.729,
              "z": 1.574
            },
            "rightCorner": {
              "x": -2.204,
              "y": 24.732,
              "z": 1.574
            },
            "gtin": "4004617100104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c65",
            "leftCorner": {
              "x": -2.204,
              "y": 24.732,
              "z": 1.574
            },
            "rightCorner": {
              "x": -2.266,
              "y": 24.735,
              "z": 1.574
            },
            "gtin": "4004617100104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c66",
            "leftCorner": {
              "x": -2.266,
              "y": 24.737,
              "z": 1.574
            },
            "rightCorner": {
              "x": -2.362,
              "y": 24.743,
              "z": 1.574
            },
            "gtin": "4004617016702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c67",
            "leftCorner": {
              "x": -2.363,
              "y": 24.728,
              "z": 1.574
            },
            "rightCorner": {
              "x": -2.438,
              "y": 24.732,
              "z": 1.574
            },
            "gtin": "4001438880109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c68",
            "leftCorner": {
              "x": -2.438,
              "y": 24.735,
              "z": 1.574
            },
            "rightCorner": {
              "x": -2.55,
              "y": 24.741,
              "z": 1.574
            },
            "gtin": "4001438880147",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d8c",
    "rightNeighborShelfId": "a6d8e"
  },
  {
    "id": "a6d8e",
    "name": "a6d8e",
    "x": -2.485,
    "y": 24.789,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99967,
      "w": 0.025645
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 4,
      "unknownStockCount": 16
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5466a1",
        "height": 0.69927,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c77",
            "leftCorner": {
              "x": -2.487,
              "y": 24.747,
              "z": 0.572
            },
            "rightCorner": {
              "x": -3.046,
              "y": 24.776,
              "z": 0.572
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20c78",
            "leftCorner": {
              "x": -3.048,
              "y": 24.736,
              "z": 0.572
            },
            "rightCorner": {
              "x": -3.738,
              "y": 24.771,
              "z": 0.572
            },
            "gtin": "4004617730998",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466a3",
        "height": 0.15049,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c8a",
            "leftCorner": {
              "x": -3.195,
              "y": 24.772,
              "z": 0.123
            },
            "rightCorner": {
              "x": -3.831,
              "y": 24.804,
              "z": 0.123
            },
            "gtin": "4025427006707",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466a2",
        "height": 0.86283,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c79",
            "leftCorner": {
              "x": -2.487,
              "y": 24.758,
              "z": 0.706
            },
            "rightCorner": {
              "x": -3.201,
              "y": 24.794,
              "z": 0.706
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20c7a",
            "leftCorner": {
              "x": -3.203,
              "y": 24.751,
              "z": 0.706
            },
            "rightCorner": {
              "x": -3.737,
              "y": 24.779,
              "z": 0.706
            },
            "gtin": "4066631046820",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54669d",
        "height": 1.0273,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c6e",
            "leftCorner": {
              "x": -2.492,
              "y": 24.646,
              "z": 0.841
            },
            "rightCorner": {
              "x": -2.64,
              "y": 24.653,
              "z": 0.841
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20c6f",
            "leftCorner": {
              "x": -2.642,
              "y": 24.615,
              "z": 0.841
            },
            "rightCorner": {
              "x": -3.743,
              "y": 24.671,
              "z": 0.841
            },
            "gtin": "4066627416149",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466a4",
        "height": 1.1441,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a54669a",
        "height": 1.2293,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c41",
            "leftCorner": {
              "x": -2.487,
              "y": 24.757,
              "z": 1.006
            },
            "rightCorner": {
              "x": -3.407,
              "y": 24.804,
              "z": 1.006
            },
            "gtin": "4004617000527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c42",
            "leftCorner": {
              "x": -3.409,
              "y": 24.765,
              "z": 1.006
            },
            "rightCorner": {
              "x": -3.737,
              "y": 24.782,
              "z": 1.006
            },
            "gtin": "4004617714004",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466a5",
        "height": 1.2964,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ca3",
            "leftCorner": {
              "x": -3.595,
              "y": 24.759,
              "z": 1.061
            },
            "rightCorner": {
              "x": -3.738,
              "y": 24.766,
              "z": 1.061
            },
            "gtin": "4337185877568",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54669f",
        "height": 1.4024,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c76",
            "leftCorner": {
              "x": -2.853,
              "y": 24.74,
              "z": 1.147
            },
            "rightCorner": {
              "x": -2.953,
              "y": 24.745,
              "z": 1.147
            },
            "gtin": "4300175180719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c73",
            "leftCorner": {
              "x": -2.954,
              "y": 24.732,
              "z": 1.147
            },
            "rightCorner": {
              "x": -3.738,
              "y": 24.772,
              "z": 1.147
            },
            "gtin": "4004617721903",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54669b",
        "height": 1.4603,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c49",
            "leftCorner": {
              "x": -2.573,
              "y": 24.727,
              "z": 1.195
            },
            "rightCorner": {
              "x": -2.67,
              "y": 24.732,
              "z": 1.195
            },
            "gtin": "4004617110141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c44",
            "leftCorner": {
              "x": -2.671,
              "y": 24.725,
              "z": 1.195
            },
            "rightCorner": {
              "x": -3.204,
              "y": 24.752,
              "z": 1.195
            },
            "gtin": "4004617016702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c45",
            "leftCorner": {
              "x": -3.204,
              "y": 24.752,
              "z": 1.195
            },
            "rightCorner": {
              "x": -3.737,
              "y": 24.78,
              "z": 1.195
            },
            "gtin": "4004617016702",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54669c",
        "height": 1.9337,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c69",
            "leftCorner": {
              "x": -2.549,
              "y": 24.755,
              "z": 1.582
            },
            "rightCorner": {
              "x": -2.668,
              "y": 24.761,
              "z": 1.582
            },
            "gtin": "4004617662725",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20c6a",
            "leftCorner": {
              "x": -2.669,
              "y": 24.741,
              "z": 1.582
            },
            "rightCorner": {
              "x": -2.895,
              "y": 24.752,
              "z": 1.582
            },
            "gtin": "4084500980150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c6b",
            "leftCorner": {
              "x": -2.895,
              "y": 24.755,
              "z": 1.582
            },
            "rightCorner": {
              "x": -3.148,
              "y": 24.769,
              "z": 1.582
            },
            "gtin": "8001090630612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c6c",
            "leftCorner": {
              "x": -3.148,
              "y": 24.767,
              "z": 1.582
            },
            "rightCorner": {
              "x": -3.31,
              "y": 24.776,
              "z": 1.582
            },
            "gtin": "4004617556505",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20c6d",
            "leftCorner": {
              "x": -3.31,
              "y": 24.772,
              "z": 1.582
            },
            "rightCorner": {
              "x": -3.487,
              "y": 24.781,
              "z": 1.582
            },
            "gtin": "8006540040843",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20c4b",
            "leftCorner": {
              "x": -3.487,
              "y": 24.775,
              "z": 1.582
            },
            "rightCorner": {
              "x": -3.737,
              "y": 24.788,
              "z": 1.582
            },
            "gtin": "8001090630612",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54669e",
        "height": 1.9712,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c70",
            "leftCorner": {
              "x": -2.485,
              "y": 24.78,
              "z": 1.613
            },
            "rightCorner": {
              "x": -3.634,
              "y": 24.84,
              "z": 1.613
            },
            "gtin": "4014529306419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c71",
            "leftCorner": {
              "x": -3.637,
              "y": 24.78,
              "z": 1.613
            },
            "rightCorner": {
              "x": -3.737,
              "y": 24.785,
              "z": 1.613
            },
            "gtin": "8001090380210",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d8d",
    "rightNeighborShelfId": "a6d8f"
  },
  {
    "id": "a6d8f",
    "name": "a6d8f",
    "x": -3.733,
    "y": 24.853,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99967,
      "w": 0.025645
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 6,
      "unknownStockCount": 42
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546724",
        "height": 0.14852,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c8b",
            "leftCorner": {
              "x": -3.831,
              "y": 24.799,
              "z": 0.122
            },
            "rightCorner": {
              "x": -4.333,
              "y": 24.824,
              "z": 0.122
            },
            "gtin": "5413149750470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c8c",
            "leftCorner": {
              "x": -4.333,
              "y": 24.824,
              "z": 0.122
            },
            "rightCorner": {
              "x": -4.836,
              "y": 24.85,
              "z": 0.122
            },
            "gtin": "5413149750470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c8d",
            "leftCorner": {
              "x": -4.835,
              "y": 24.857,
              "z": 0.122
            },
            "rightCorner": {
              "x": -4.929,
              "y": 24.862,
              "z": 0.122
            },
            "gtin": "5413149750425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c8e",
            "leftCorner": {
              "x": -4.929,
              "y": 24.862,
              "z": 0.122
            },
            "rightCorner": {
              "x": -5.023,
              "y": 24.867,
              "z": 0.122
            },
            "gtin": "5413149750425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c8f",
            "leftCorner": {
              "x": -5.023,
              "y": 24.867,
              "z": 0.122
            },
            "rightCorner": {
              "x": -5.117,
              "y": 24.872,
              "z": 0.122
            },
            "gtin": "5413149750425",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546720",
        "height": 0.49229,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20eaa",
            "leftCorner": {
              "x": -3.734,
              "y": 24.835,
              "z": 0.403
            },
            "rightCorner": {
              "x": -3.808,
              "y": 24.839,
              "z": 0.403
            },
            "gtin": "5410076702923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20eab",
            "leftCorner": {
              "x": -3.808,
              "y": 24.839,
              "z": 0.403
            },
            "rightCorner": {
              "x": -3.882,
              "y": 24.843,
              "z": 0.403
            },
            "gtin": "5410076702923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ead",
            "leftCorner": {
              "x": -3.884,
              "y": 24.794,
              "z": 0.403
            },
            "rightCorner": {
              "x": -4.007,
              "y": 24.8,
              "z": 0.403
            },
            "gtin": "8700216676793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20eae",
            "leftCorner": {
              "x": -4.007,
              "y": 24.8,
              "z": 0.403
            },
            "rightCorner": {
              "x": -4.13,
              "y": 24.806,
              "z": 0.403
            },
            "gtin": "8700216676793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20eaf",
            "leftCorner": {
              "x": -4.13,
              "y": 24.806,
              "z": 0.403
            },
            "rightCorner": {
              "x": -4.253,
              "y": 24.813,
              "z": 0.403
            },
            "gtin": "8700216676793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20eb0",
            "leftCorner": {
              "x": -4.252,
              "y": 24.82,
              "z": 0.403
            },
            "rightCorner": {
              "x": -4.39,
              "y": 24.827,
              "z": 0.403
            },
            "gtin": "4063367553950",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20eb1",
            "leftCorner": {
              "x": -4.39,
              "y": 24.829,
              "z": 0.403
            },
            "rightCorner": {
              "x": -4.524,
              "y": 24.837,
              "z": 0.403
            },
            "gtin": "4063367553936",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20eb2",
            "leftCorner": {
              "x": -4.523,
              "y": 24.84,
              "z": 0.403
            },
            "rightCorner": {
              "x": -4.678,
              "y": 24.848,
              "z": 0.403
            },
            "gtin": "4064791013706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20eb3",
            "leftCorner": {
              "x": -4.678,
              "y": 24.848,
              "z": 0.403
            },
            "rightCorner": {
              "x": -4.833,
              "y": 24.856,
              "z": 0.403
            },
            "gtin": "4064791013706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20eac",
            "leftCorner": {
              "x": -4.833,
              "y": 24.859,
              "z": 0.403
            },
            "rightCorner": {
              "x": -4.984,
              "y": 24.867,
              "z": 0.403
            },
            "gtin": "4066633091873",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546722",
        "height": 0.79455,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20eb4",
            "leftCorner": {
              "x": -3.733,
              "y": 24.846,
              "z": 0.65
            },
            "rightCorner": {
              "x": -3.922,
              "y": 24.856,
              "z": 0.65
            },
            "gtin": "8700216677387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20eb5",
            "leftCorner": {
              "x": -3.922,
              "y": 24.856,
              "z": 0.65
            },
            "rightCorner": {
              "x": -4.111,
              "y": 24.865,
              "z": 0.65
            },
            "gtin": "8700216677387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20eb6",
            "leftCorner": {
              "x": -4.111,
              "y": 24.865,
              "z": 0.65
            },
            "rightCorner": {
              "x": -4.3,
              "y": 24.875,
              "z": 0.65
            },
            "gtin": "8700216677387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20eb9",
            "leftCorner": {
              "x": -4.301,
              "y": 24.842,
              "z": 0.65
            },
            "rightCorner": {
              "x": -4.502,
              "y": 24.852,
              "z": 0.65
            },
            "gtin": "5413149232754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20eb7",
            "leftCorner": {
              "x": -4.502,
              "y": 24.841,
              "z": 0.65
            },
            "rightCorner": {
              "x": -4.743,
              "y": 24.854,
              "z": 0.65
            },
            "gtin": "5410076545353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20eb8",
            "leftCorner": {
              "x": -4.743,
              "y": 24.854,
              "z": 0.65
            },
            "rightCorner": {
              "x": -4.984,
              "y": 24.865,
              "z": 0.65
            },
            "gtin": "5410076545353",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546721",
        "height": 1.1488,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c9a",
            "leftCorner": {
              "x": -3.684,
              "y": 24.81,
              "z": 0.94
            },
            "rightCorner": {
              "x": -3.76,
              "y": 24.814,
              "z": 0.94
            },
            "gtin": "8006540001257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c97",
            "leftCorner": {
              "x": -3.733,
              "y": 24.846,
              "z": 0.94
            },
            "rightCorner": {
              "x": -4.332,
              "y": 24.876,
              "z": 0.94
            },
            "gtin": "4004617039602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c9b",
            "leftCorner": {
              "x": -3.76,
              "y": 24.814,
              "z": 0.94
            },
            "rightCorner": {
              "x": -3.837,
              "y": 24.818,
              "z": 0.94
            },
            "gtin": "8006540001257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c9c",
            "leftCorner": {
              "x": -3.837,
              "y": 24.818,
              "z": 0.94
            },
            "rightCorner": {
              "x": -3.913,
              "y": 24.822,
              "z": 0.94
            },
            "gtin": "8006540001257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c9d",
            "leftCorner": {
              "x": -3.913,
              "y": 24.813,
              "z": 0.94
            },
            "rightCorner": {
              "x": -4.034,
              "y": 24.819,
              "z": 0.94
            },
            "gtin": "8001090380401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c9e",
            "leftCorner": {
              "x": -4.035,
              "y": 24.804,
              "z": 0.94
            },
            "rightCorner": {
              "x": -4.162,
              "y": 24.81,
              "z": 0.94
            },
            "gtin": "5410076542284",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c9f",
            "leftCorner": {
              "x": -4.162,
              "y": 24.823,
              "z": 0.94
            },
            "rightCorner": {
              "x": -4.366,
              "y": 24.833,
              "z": 0.94
            },
            "gtin": "4066634066269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c98",
            "leftCorner": {
              "x": -4.332,
              "y": 24.876,
              "z": 0.94
            },
            "rightCorner": {
              "x": -4.931,
              "y": 24.907,
              "z": 0.94
            },
            "gtin": "4004617039602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ca0",
            "leftCorner": {
              "x": -4.366,
              "y": 24.838,
              "z": 0.94
            },
            "rightCorner": {
              "x": -4.473,
              "y": 24.844,
              "z": 0.94
            },
            "gtin": "4014529155161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ca1",
            "leftCorner": {
              "x": -4.473,
              "y": 24.854,
              "z": 0.94
            },
            "rightCorner": {
              "x": -4.598,
              "y": 24.86,
              "z": 0.94
            },
            "gtin": "4004617870632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ca2",
            "leftCorner": {
              "x": -4.598,
              "y": 24.851,
              "z": 0.94
            },
            "rightCorner": {
              "x": -4.817,
              "y": 24.862,
              "z": 0.94
            },
            "gtin": "4006664292610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c99",
            "leftCorner": {
              "x": -4.817,
              "y": 24.865,
              "z": 0.94
            },
            "rightCorner": {
              "x": -4.984,
              "y": 24.872,
              "z": 0.94
            },
            "gtin": "4004617039602",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546726",
        "height": 1.5358,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ec3",
            "leftCorner": {
              "x": -3.734,
              "y": 24.827,
              "z": 1.257
            },
            "rightCorner": {
              "x": -4.665,
              "y": 24.876,
              "z": 1.257
            },
            "gtin": "4335896630786",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ec5",
            "leftCorner": {
              "x": -4.667,
              "y": 24.837,
              "z": 1.257
            },
            "rightCorner": {
              "x": -4.972,
              "y": 24.853,
              "z": 1.257
            },
            "gtin": "4014529155161",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546727",
        "height": 1.5644,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ec7",
            "leftCorner": {
              "x": -3.734,
              "y": 24.835,
              "z": 1.28
            },
            "rightCorner": {
              "x": -4.288,
              "y": 24.863,
              "z": 1.28
            },
            "gtin": "4066633061616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ec8",
            "leftCorner": {
              "x": -4.288,
              "y": 24.863,
              "z": 1.28
            },
            "rightCorner": {
              "x": -4.843,
              "y": 24.892,
              "z": 1.28
            },
            "gtin": "4066633061616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20eca",
            "leftCorner": {
              "x": -4.845,
              "y": 24.85,
              "z": 1.28
            },
            "rightCorner": {
              "x": -4.923,
              "y": 24.854,
              "z": 1.28
            },
            "gtin": "4004617781907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ec9",
            "leftCorner": {
              "x": -4.924,
              "y": 24.836,
              "z": 1.28
            },
            "rightCorner": {
              "x": -4.985,
              "y": 24.838,
              "z": 1.28
            },
            "gtin": "4014529514401",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546723",
        "height": 1.8389,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20eba",
            "leftCorner": {
              "x": -3.735,
              "y": 24.816,
              "z": 1.505
            },
            "rightCorner": {
              "x": -3.868,
              "y": 24.822,
              "z": 1.505
            },
            "gtin": "4004617034102",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20ebc",
            "leftCorner": {
              "x": -3.87,
              "y": 24.795,
              "z": 1.505
            },
            "rightCorner": {
              "x": -4.005,
              "y": 24.802,
              "z": 1.505
            },
            "gtin": "4066632036431",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20ebd",
            "leftCorner": {
              "x": -4.006,
              "y": 24.79,
              "z": 1.505
            },
            "rightCorner": {
              "x": -4.135,
              "y": 24.796,
              "z": 1.505
            },
            "gtin": "4004617111261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ebe",
            "leftCorner": {
              "x": -4.135,
              "y": 24.801,
              "z": 1.505
            },
            "rightCorner": {
              "x": -4.297,
              "y": 24.81,
              "z": 1.505
            },
            "gtin": "4004617000558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ebf",
            "leftCorner": {
              "x": -4.297,
              "y": 24.801,
              "z": 1.505
            },
            "rightCorner": {
              "x": -4.407,
              "y": 24.806,
              "z": 1.505
            },
            "gtin": "4337185854286",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20ec0",
            "leftCorner": {
              "x": -4.407,
              "y": 24.802,
              "z": 1.505
            },
            "rightCorner": {
              "x": -4.601,
              "y": 24.812,
              "z": 1.505
            },
            "gtin": "4004617039602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ec1",
            "leftCorner": {
              "x": -4.6,
              "y": 24.83,
              "z": 1.505
            },
            "rightCorner": {
              "x": -4.689,
              "y": 24.835,
              "z": 1.505
            },
            "gtin": "4014529908019",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20ec2",
            "leftCorner": {
              "x": -4.689,
              "y": 24.822,
              "z": 1.505
            },
            "rightCorner": {
              "x": -4.89,
              "y": 24.832,
              "z": 1.505
            },
            "gtin": "4004617840628",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20ebb",
            "leftCorner": {
              "x": -4.89,
              "y": 24.836,
              "z": 1.505
            },
            "rightCorner": {
              "x": -4.985,
              "y": 24.84,
              "z": 1.505
            },
            "gtin": "4337185865831",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d8e",
    "rightNeighborShelfId": "a6d90"
  },
  {
    "id": "a6d90",
    "name": "a6d90",
    "x": -4.973,
    "y": 24.924,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99961,
      "w": 0.027895
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 10,
      "unknownStockCount": 36
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54672d",
        "height": 0.14701,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c90",
            "leftCorner": {
              "x": -5.109,
              "y": 24.877,
              "z": 0.12
            },
            "rightCorner": {
              "x": -5.231,
              "y": 24.884,
              "z": 0.12
            },
            "gtin": "4066634057649",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c91",
            "leftCorner": {
              "x": -5.23,
              "y": 24.904,
              "z": 0.12
            },
            "rightCorner": {
              "x": -5.447,
              "y": 24.916,
              "z": 0.12
            },
            "gtin": "4022551642061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c92",
            "leftCorner": {
              "x": -5.448,
              "y": 24.897,
              "z": 0.12
            },
            "rightCorner": {
              "x": -5.573,
              "y": 24.904,
              "z": 0.12
            },
            "gtin": "4004617331539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c93",
            "leftCorner": {
              "x": -5.573,
              "y": 24.904,
              "z": 0.12
            },
            "rightCorner": {
              "x": -5.697,
              "y": 24.911,
              "z": 0.12
            },
            "gtin": "4004617331539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c94",
            "leftCorner": {
              "x": -5.697,
              "y": 24.911,
              "z": 0.12
            },
            "rightCorner": {
              "x": -5.821,
              "y": 24.918,
              "z": 0.12
            },
            "gtin": "4004617331539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c95",
            "leftCorner": {
              "x": -5.822,
              "y": 24.912,
              "z": 0.12
            },
            "rightCorner": {
              "x": -6.298,
              "y": 24.939,
              "z": 0.12
            },
            "gtin": "4337185877452",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546729",
        "height": 0.69628,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ed2",
            "leftCorner": {
              "x": -4.974,
              "y": 24.907,
              "z": 0.57
            },
            "rightCorner": {
              "x": -5.096,
              "y": 24.914,
              "z": 0.57
            },
            "gtin": "4052926064303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ed5",
            "leftCorner": {
              "x": -5.098,
              "y": 24.878,
              "z": 0.57
            },
            "rightCorner": {
              "x": -5.238,
              "y": 24.886,
              "z": 0.57
            },
            "gtin": "4004617097961",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ed6",
            "leftCorner": {
              "x": -5.239,
              "y": 24.884,
              "z": 0.57
            },
            "rightCorner": {
              "x": -5.44,
              "y": 24.895,
              "z": 0.57
            },
            "gtin": "4337185865329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ed7",
            "leftCorner": {
              "x": -5.44,
              "y": 24.908,
              "z": 0.57
            },
            "rightCorner": {
              "x": -5.636,
              "y": 24.919,
              "z": 0.57
            },
            "gtin": "4066633074395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ed8",
            "leftCorner": {
              "x": -5.636,
              "y": 24.916,
              "z": 0.57
            },
            "rightCorner": {
              "x": -5.739,
              "y": 24.922,
              "z": 0.57
            },
            "gtin": "4300175051200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ed9",
            "leftCorner": {
              "x": -5.739,
              "y": 24.922,
              "z": 0.57
            },
            "rightCorner": {
              "x": -5.841,
              "y": 24.928,
              "z": 0.57
            },
            "gtin": "4300175051200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20eda",
            "leftCorner": {
              "x": -5.841,
              "y": 24.924,
              "z": 0.57
            },
            "rightCorner": {
              "x": -6.052,
              "y": 24.935,
              "z": 0.57
            },
            "gtin": "4066634093609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ed3",
            "leftCorner": {
              "x": -6.052,
              "y": 24.934,
              "z": 0.57
            },
            "rightCorner": {
              "x": -6.138,
              "y": 24.938,
              "z": 0.57
            },
            "gtin": "4004617000169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ed4",
            "leftCorner": {
              "x": -6.138,
              "y": 24.938,
              "z": 0.57
            },
            "rightCorner": {
              "x": -6.224,
              "y": 24.943,
              "z": 0.57
            },
            "gtin": "4004617000169",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54672a",
        "height": 1.0474,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20edc",
            "leftCorner": {
              "x": -5.008,
              "y": 24.891,
              "z": 0.857
            },
            "rightCorner": {
              "x": -5.055,
              "y": 24.893,
              "z": 0.857
            },
            "gtin": "4005437022652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20edd",
            "leftCorner": {
              "x": -5.055,
              "y": 24.893,
              "z": 0.857
            },
            "rightCorner": {
              "x": -5.103,
              "y": 24.895,
              "z": 0.857
            },
            "gtin": "4005437022652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ede",
            "leftCorner": {
              "x": -5.103,
              "y": 24.891,
              "z": 0.857
            },
            "rightCorner": {
              "x": -5.172,
              "y": 24.894,
              "z": 0.857
            },
            "gtin": "4005437022683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20edf",
            "leftCorner": {
              "x": -5.173,
              "y": 24.886,
              "z": 0.857
            },
            "rightCorner": {
              "x": -5.228,
              "y": 24.889,
              "z": 0.857
            },
            "gtin": "4005437022713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ee0",
            "leftCorner": {
              "x": -5.228,
              "y": 24.893,
              "z": 0.857
            },
            "rightCorner": {
              "x": -5.362,
              "y": 24.9,
              "z": 0.857
            },
            "gtin": "4005437821408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ee1",
            "leftCorner": {
              "x": -5.362,
              "y": 24.9,
              "z": 0.857
            },
            "rightCorner": {
              "x": -5.497,
              "y": 24.909,
              "z": 0.857
            },
            "gtin": "4005437821408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ee2",
            "leftCorner": {
              "x": -5.497,
              "y": 24.905,
              "z": 0.857
            },
            "rightCorner": {
              "x": -5.915,
              "y": 24.928,
              "z": 0.857
            },
            "gtin": "4335896677125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20edb",
            "leftCorner": {
              "x": -5.914,
              "y": 24.934,
              "z": 0.857
            },
            "rightCorner": {
              "x": -6.223,
              "y": 24.95,
              "z": 0.857
            },
            "gtin": "4262379093724",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54672e",
        "height": 1.4483,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ee3",
            "leftCorner": {
              "x": -4.975,
              "y": 24.895,
              "z": 1.185
            },
            "rightCorner": {
              "x": -5.408,
              "y": 24.92,
              "z": 1.185
            },
            "gtin": "4004617540306",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20ee5",
            "leftCorner": {
              "x": -5.411,
              "y": 24.878,
              "z": 1.185
            },
            "rightCorner": {
              "x": -5.672,
              "y": 24.892,
              "z": 1.185
            },
            "gtin": "4004617540207",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20ee4",
            "leftCorner": {
              "x": -5.672,
              "y": 24.889,
              "z": 1.185
            },
            "rightCorner": {
              "x": -6.225,
              "y": 24.92,
              "z": 1.185
            },
            "gtin": "4004617771991",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546730",
        "height": 1.491,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ee6",
            "leftCorner": {
              "x": -4.975,
              "y": 24.894,
              "z": 1.22
            },
            "rightCorner": {
              "x": -5.767,
              "y": 24.939,
              "z": 1.22
            },
            "gtin": "4004617501000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ee7",
            "leftCorner": {
              "x": -5.769,
              "y": 24.899,
              "z": 1.22
            },
            "rightCorner": {
              "x": -6.225,
              "y": 24.924,
              "z": 1.22
            },
            "gtin": "4004617771809",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54672b",
        "height": 1.5315,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ec6",
            "leftCorner": {
              "x": -4.965,
              "y": 24.848,
              "z": 1.253
            },
            "rightCorner": {
              "x": -5.13,
              "y": 24.856,
              "z": 1.253
            },
            "gtin": "4337185859243",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20ec4",
            "leftCorner": {
              "x": -5.13,
              "y": 24.866,
              "z": 1.253
            },
            "rightCorner": {
              "x": -6.225,
              "y": 24.927,
              "z": 1.253
            },
            "gtin": "4004617870601",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546733",
        "height": 1.6132,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20eed",
            "leftCorner": {
              "x": -4.975,
              "y": 24.895,
              "z": 1.32
            },
            "rightCorner": {
              "x": -5.93,
              "y": 24.948,
              "z": 1.32
            },
            "gtin": "4008033612166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20eef",
            "leftCorner": {
              "x": -5.932,
              "y": 24.915,
              "z": 1.32
            },
            "rightCorner": {
              "x": -6.032,
              "y": 24.92,
              "z": 1.32
            },
            "gtin": "4008033612173",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20ef0",
            "leftCorner": {
              "x": -6.033,
              "y": 24.916,
              "z": 1.32
            },
            "rightCorner": {
              "x": -6.15,
              "y": 24.923,
              "z": 1.32
            },
            "gtin": "4008033614542",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20eee",
            "leftCorner": {
              "x": -6.15,
              "y": 24.917,
              "z": 1.32
            },
            "rightCorner": {
              "x": -6.225,
              "y": 24.921,
              "z": 1.32
            },
            "gtin": "4008033611350",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546731",
        "height": 1.6562,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ee8",
            "leftCorner": {
              "x": -4.974,
              "y": 24.902,
              "z": 1.355
            },
            "rightCorner": {
              "x": -5.203,
              "y": 24.915,
              "z": 1.355
            },
            "gtin": "4008033610407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ee9",
            "leftCorner": {
              "x": -5.203,
              "y": 24.915,
              "z": 1.355
            },
            "rightCorner": {
              "x": -5.431,
              "y": 24.928,
              "z": 1.355
            },
            "gtin": "4008033610407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20eea",
            "leftCorner": {
              "x": -5.431,
              "y": 24.928,
              "z": 1.355
            },
            "rightCorner": {
              "x": -5.659,
              "y": 24.941,
              "z": 1.355
            },
            "gtin": "4008033610407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20eeb",
            "leftCorner": {
              "x": -5.661,
              "y": 24.902,
              "z": 1.355
            },
            "rightCorner": {
              "x": -5.943,
              "y": 24.918,
              "z": 1.355
            },
            "gtin": "4008033610544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20eec",
            "leftCorner": {
              "x": -5.943,
              "y": 24.918,
              "z": 1.355
            },
            "rightCorner": {
              "x": -6.224,
              "y": 24.933,
              "z": 1.355
            },
            "gtin": "4008033610544",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546728",
        "height": 1.9231,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ecb",
            "leftCorner": {
              "x": -4.973,
              "y": 24.919,
              "z": 1.573
            },
            "rightCorner": {
              "x": -5.035,
              "y": 24.923,
              "z": 1.573
            },
            "gtin": "4004617840604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ecd",
            "leftCorner": {
              "x": -5.038,
              "y": 24.88,
              "z": 1.573
            },
            "rightCorner": {
              "x": -5.219,
              "y": 24.89,
              "z": 1.573
            },
            "gtin": "4052926052065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ece",
            "leftCorner": {
              "x": -5.219,
              "y": 24.894,
              "z": 1.573
            },
            "rightCorner": {
              "x": -5.446,
              "y": 24.906,
              "z": 1.573
            },
            "gtin": "4066632036431",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20ecf",
            "leftCorner": {
              "x": -5.445,
              "y": 24.92,
              "z": 1.573
            },
            "rightCorner": {
              "x": -5.657,
              "y": 24.931,
              "z": 1.573
            },
            "gtin": "4262402770028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ed0",
            "leftCorner": {
              "x": -5.658,
              "y": 24.916,
              "z": 1.573
            },
            "rightCorner": {
              "x": -5.861,
              "y": 24.928,
              "z": 1.573
            },
            "gtin": "4062326999990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ed1",
            "leftCorner": {
              "x": -5.861,
              "y": 24.929,
              "z": 1.573
            },
            "rightCorner": {
              "x": -6.072,
              "y": 24.941,
              "z": 1.573
            },
            "gtin": "4009977521583",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20ecc",
            "leftCorner": {
              "x": -6.071,
              "y": 24.948,
              "z": 1.573
            },
            "rightCorner": {
              "x": -6.223,
              "y": 24.956,
              "z": 1.573
            },
            "gtin": "4009977913586",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d8f",
    "rightNeighborShelfId": "a6d92"
  },
  {
    "id": "a6d92",
    "name": "a6d92",
    "x": -6.221,
    "y": 24.994,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99961,
      "w": 0.027895
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 10
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546736",
        "height": 0.14625,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a546735",
        "height": 0.70727,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20efa",
            "leftCorner": {
              "x": -6.222,
              "y": 24.98,
              "z": 0.579
            },
            "rightCorner": {
              "x": -6.274,
              "y": 24.983,
              "z": 0.579
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20efb",
            "leftCorner": {
              "x": -6.276,
              "y": 24.947,
              "z": 0.579
            },
            "rightCorner": {
              "x": -7.472,
              "y": 25.014,
              "z": 0.579
            },
            "gtin": "5410076302475",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546734",
        "height": 1.2482,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20ef1",
            "leftCorner": {
              "x": -6.222,
              "y": 24.983,
              "z": 1.021
            },
            "rightCorner": {
              "x": -6.312,
              "y": 24.988,
              "z": 1.021
            },
            "gtin": "8700216711043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ef2",
            "leftCorner": {
              "x": -6.312,
              "y": 24.988,
              "z": 1.021
            },
            "rightCorner": {
              "x": -6.403,
              "y": 24.993,
              "z": 1.021
            },
            "gtin": "8700216711043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ef5",
            "leftCorner": {
              "x": -6.405,
              "y": 24.958,
              "z": 1.021
            },
            "rightCorner": {
              "x": -6.631,
              "y": 24.971,
              "z": 1.021
            },
            "gtin": "8700216676793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ef6",
            "leftCorner": {
              "x": -6.631,
              "y": 24.971,
              "z": 1.021
            },
            "rightCorner": {
              "x": -6.856,
              "y": 24.983,
              "z": 1.021
            },
            "gtin": "8700216676793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ef7",
            "leftCorner": {
              "x": -6.856,
              "y": 24.983,
              "z": 1.021
            },
            "rightCorner": {
              "x": -7.082,
              "y": 24.996,
              "z": 1.021
            },
            "gtin": "8700216676793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ef8",
            "leftCorner": {
              "x": -7.082,
              "y": 24.996,
              "z": 1.021
            },
            "rightCorner": {
              "x": -7.201,
              "y": 25.002,
              "z": 1.021
            },
            "gtin": "8700216656122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ef9",
            "leftCorner": {
              "x": -7.201,
              "y": 25.002,
              "z": 1.021
            },
            "rightCorner": {
              "x": -7.319,
              "y": 25.009,
              "z": 1.021
            },
            "gtin": "8700216656122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ef3",
            "leftCorner": {
              "x": -7.319,
              "y": 25.002,
              "z": 1.021
            },
            "rightCorner": {
              "x": -7.396,
              "y": 25.007,
              "z": 1.021
            },
            "gtin": "8700216301435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20ef4",
            "leftCorner": {
              "x": -7.396,
              "y": 25.007,
              "z": 1.021
            },
            "rightCorner": {
              "x": -7.472,
              "y": 25.011,
              "z": 1.021
            },
            "gtin": "8700216301435",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d90",
    "rightNeighborShelfId": "a6d93"
  },
  {
    "id": "a6d93",
    "name": "a6d93",
    "x": -7.469,
    "y": 25.063,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99961,
      "w": 0.027895
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 39
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54673b",
        "height": 0.14663,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c96",
            "leftCorner": {
              "x": -7.563,
              "y": 25.011,
              "z": 0.12
            },
            "rightCorner": {
              "x": -8.144,
              "y": 25.043,
              "z": 0.12
            },
            "gtin": "4009412312622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c7c",
            "leftCorner": {
              "x": -8.142,
              "y": 25.078,
              "z": 0.12
            },
            "rightCorner": {
              "x": -8.43,
              "y": 25.094,
              "z": 0.12
            },
            "gtin": "4337185509025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c7d",
            "leftCorner": {
              "x": -8.43,
              "y": 25.094,
              "z": 0.12
            },
            "rightCorner": {
              "x": -8.718,
              "y": 25.109,
              "z": 0.12
            },
            "gtin": "4337185509025",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546738",
        "height": 0.65668,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20f1a",
            "leftCorner": {
              "x": -7.47,
              "y": 25.042,
              "z": 0.537
            },
            "rightCorner": {
              "x": -7.675,
              "y": 25.054,
              "z": 0.537
            },
            "gtin": "4003790001444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f1b",
            "leftCorner": {
              "x": -7.675,
              "y": 25.054,
              "z": 0.537
            },
            "rightCorner": {
              "x": -7.88,
              "y": 25.065,
              "z": 0.537
            },
            "gtin": "4003790001444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f1e",
            "leftCorner": {
              "x": -7.882,
              "y": 25.032,
              "z": 0.537
            },
            "rightCorner": {
              "x": -7.988,
              "y": 25.037,
              "z": 0.537
            },
            "gtin": "4009911501527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f1f",
            "leftCorner": {
              "x": -7.988,
              "y": 25.037,
              "z": 0.537
            },
            "rightCorner": {
              "x": -8.093,
              "y": 25.043,
              "z": 0.537
            },
            "gtin": "4009911501527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f20",
            "leftCorner": {
              "x": -8.093,
              "y": 25.044,
              "z": 0.537
            },
            "rightCorner": {
              "x": -8.283,
              "y": 25.055,
              "z": 0.537
            },
            "gtin": "4009911501626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f21",
            "leftCorner": {
              "x": -8.283,
              "y": 25.061,
              "z": 0.537
            },
            "rightCorner": {
              "x": -8.425,
              "y": 25.069,
              "z": 0.537
            },
            "gtin": "4009911501657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f22",
            "leftCorner": {
              "x": -8.425,
              "y": 25.069,
              "z": 0.537
            },
            "rightCorner": {
              "x": -8.567,
              "y": 25.077,
              "z": 0.537
            },
            "gtin": "4009911501657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f1c",
            "leftCorner": {
              "x": -8.567,
              "y": 25.071,
              "z": 0.537
            },
            "rightCorner": {
              "x": -8.644,
              "y": 25.075,
              "z": 0.537
            },
            "gtin": "4009911401162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f1d",
            "leftCorner": {
              "x": -8.644,
              "y": 25.075,
              "z": 0.537
            },
            "rightCorner": {
              "x": -8.72,
              "y": 25.078,
              "z": 0.537
            },
            "gtin": "4009911401162",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546737",
        "height": 0.99375,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20efc",
            "leftCorner": {
              "x": -7.47,
              "y": 25.047,
              "z": 0.813
            },
            "rightCorner": {
              "x": -7.581,
              "y": 25.054,
              "z": 0.813
            },
            "gtin": "4063367397899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20efd",
            "leftCorner": {
              "x": -7.581,
              "y": 25.054,
              "z": 0.813
            },
            "rightCorner": {
              "x": -7.691,
              "y": 25.06,
              "z": 0.813
            },
            "gtin": "4063367397899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20efe",
            "leftCorner": {
              "x": -7.691,
              "y": 25.06,
              "z": 0.813
            },
            "rightCorner": {
              "x": -7.802,
              "y": 25.066,
              "z": 0.813
            },
            "gtin": "4063367397899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f01",
            "leftCorner": {
              "x": -7.804,
              "y": 25.035,
              "z": 0.813
            },
            "rightCorner": {
              "x": -7.963,
              "y": 25.043,
              "z": 0.813
            },
            "gtin": "4009412024259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f02",
            "leftCorner": {
              "x": -7.963,
              "y": 25.043,
              "z": 0.813
            },
            "rightCorner": {
              "x": -8.122,
              "y": 25.052,
              "z": 0.813
            },
            "gtin": "4009412024259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f03",
            "leftCorner": {
              "x": -8.122,
              "y": 25.051,
              "z": 0.813
            },
            "rightCorner": {
              "x": -8.218,
              "y": 25.056,
              "z": 0.813
            },
            "gtin": "4023103238992",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f04",
            "leftCorner": {
              "x": -8.218,
              "y": 25.056,
              "z": 0.813
            },
            "rightCorner": {
              "x": -8.313,
              "y": 25.062,
              "z": 0.813
            },
            "gtin": "4023103238992",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f05",
            "leftCorner": {
              "x": -8.313,
              "y": 25.069,
              "z": 0.813
            },
            "rightCorner": {
              "x": -8.516,
              "y": 25.08,
              "z": 0.813
            },
            "gtin": "4009412011273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f06",
            "leftCorner": {
              "x": -8.516,
              "y": 25.08,
              "z": 0.813
            },
            "rightCorner": {
              "x": -8.719,
              "y": 25.091,
              "z": 0.813
            },
            "gtin": "4009412011273",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546739",
        "height": 1.3961,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20f23",
            "leftCorner": {
              "x": -7.469,
              "y": 25.062,
              "z": 1.142
            },
            "rightCorner": {
              "x": -7.536,
              "y": 25.066,
              "z": 1.142
            },
            "gtin": "4008600081876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f24",
            "leftCorner": {
              "x": -7.536,
              "y": 25.066,
              "z": 1.142
            },
            "rightCorner": {
              "x": -7.603,
              "y": 25.07,
              "z": 1.142
            },
            "gtin": "4008600081876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f25",
            "leftCorner": {
              "x": -7.603,
              "y": 25.07,
              "z": 1.142
            },
            "rightCorner": {
              "x": -7.67,
              "y": 25.073,
              "z": 1.142
            },
            "gtin": "4008600081876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f26",
            "leftCorner": {
              "x": -7.67,
              "y": 25.073,
              "z": 1.142
            },
            "rightCorner": {
              "x": -7.736,
              "y": 25.077,
              "z": 1.142
            },
            "gtin": "4008600081876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f28",
            "leftCorner": {
              "x": -7.738,
              "y": 25.041,
              "z": 1.142
            },
            "rightCorner": {
              "x": -7.996,
              "y": 25.056,
              "z": 1.142
            },
            "gtin": "4337185719790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f29",
            "leftCorner": {
              "x": -7.996,
              "y": 25.056,
              "z": 1.142
            },
            "rightCorner": {
              "x": -8.253,
              "y": 25.07,
              "z": 1.142
            },
            "gtin": "4337185719790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f2a",
            "leftCorner": {
              "x": -8.253,
              "y": 25.07,
              "z": 1.142
            },
            "rightCorner": {
              "x": -8.51,
              "y": 25.085,
              "z": 1.142
            },
            "gtin": "4337185719790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f2b",
            "leftCorner": {
              "x": -8.51,
              "y": 25.088,
              "z": 1.142
            },
            "rightCorner": {
              "x": -8.736,
              "y": 25.1,
              "z": 1.142
            },
            "gtin": "4009412040440",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54673a",
        "height": 1.7448,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20f42",
            "leftCorner": {
              "x": -7.469,
              "y": 25.054,
              "z": 1.428
            },
            "rightCorner": {
              "x": -7.602,
              "y": 25.062,
              "z": 1.428
            },
            "gtin": "4009412015660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f43",
            "leftCorner": {
              "x": -7.602,
              "y": 25.062,
              "z": 1.428
            },
            "rightCorner": {
              "x": -7.735,
              "y": 25.069,
              "z": 1.428
            },
            "gtin": "4009412015660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f44",
            "leftCorner": {
              "x": -7.735,
              "y": 25.069,
              "z": 1.428
            },
            "rightCorner": {
              "x": -7.868,
              "y": 25.077,
              "z": 1.428
            },
            "gtin": "4009412015660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f47",
            "leftCorner": {
              "x": -7.87,
              "y": 25.05,
              "z": 1.428
            },
            "rightCorner": {
              "x": -7.948,
              "y": 25.054,
              "z": 1.428
            },
            "gtin": "4008600090984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f48",
            "leftCorner": {
              "x": -7.948,
              "y": 25.054,
              "z": 1.428
            },
            "rightCorner": {
              "x": -8.026,
              "y": 25.058,
              "z": 1.428
            },
            "gtin": "4008600090984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f49",
            "leftCorner": {
              "x": -8.026,
              "y": 25.05,
              "z": 1.428
            },
            "rightCorner": {
              "x": -8.125,
              "y": 25.055,
              "z": 1.428
            },
            "gtin": "3384124703090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f4a",
            "leftCorner": {
              "x": -8.125,
              "y": 25.055,
              "z": 1.428
            },
            "rightCorner": {
              "x": -8.225,
              "y": 25.061,
              "z": 1.428
            },
            "gtin": "3384124703090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f4b",
            "leftCorner": {
              "x": -8.225,
              "y": 25.061,
              "z": 1.428
            },
            "rightCorner": {
              "x": -8.389,
              "y": 25.07,
              "z": 1.428
            },
            "gtin": "4003364506306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f4c",
            "leftCorner": {
              "x": -8.389,
              "y": 25.07,
              "z": 1.428
            },
            "rightCorner": {
              "x": -8.554,
              "y": 25.079,
              "z": 1.428
            },
            "gtin": "4003364506306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f4d",
            "leftCorner": {
              "x": -8.554,
              "y": 25.079,
              "z": 1.428
            },
            "rightCorner": {
              "x": -8.718,
              "y": 25.088,
              "z": 1.428
            },
            "gtin": "4003364506306",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d92",
    "rightNeighborShelfId": "a6d94"
  },
  {
    "id": "a6d94",
    "name": "a6d94",
    "x": -8.717,
    "y": 25.133,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99961,
      "w": 0.027895
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 28
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54673d",
        "height": 0.64222,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20f6b",
            "leftCorner": {
              "x": -8.718,
              "y": 25.119,
              "z": 0.525
            },
            "rightCorner": {
              "x": -9.045,
              "y": 25.137,
              "z": 0.525
            },
            "gtin": "4009911554134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f6c",
            "leftCorner": {
              "x": -9.045,
              "y": 25.137,
              "z": 0.525
            },
            "rightCorner": {
              "x": -9.372,
              "y": 25.156,
              "z": 0.525
            },
            "gtin": "4009911554134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f6f",
            "leftCorner": {
              "x": -9.374,
              "y": 25.114,
              "z": 0.525
            },
            "rightCorner": {
              "x": -9.663,
              "y": 25.13,
              "z": 0.525
            },
            "gtin": "4009412220347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f70",
            "leftCorner": {
              "x": -9.663,
              "y": 25.13,
              "z": 0.525
            },
            "rightCorner": {
              "x": -9.951,
              "y": 25.145,
              "z": 0.525
            },
            "gtin": "4009412220347",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54673f",
        "height": 1.0031,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20f07",
            "leftCorner": {
              "x": -8.718,
              "y": 25.099,
              "z": 0.821
            },
            "rightCorner": {
              "x": -9.024,
              "y": 25.117,
              "z": 0.821
            },
            "gtin": "4009911601975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f08",
            "leftCorner": {
              "x": -9.024,
              "y": 25.117,
              "z": 0.821
            },
            "rightCorner": {
              "x": -9.329,
              "y": 25.133,
              "z": 0.821
            },
            "gtin": "4009911601975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f09",
            "leftCorner": {
              "x": -9.329,
              "y": 25.133,
              "z": 0.821
            },
            "rightCorner": {
              "x": -9.633,
              "y": 25.151,
              "z": 0.821
            },
            "gtin": "4009911601975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f0a",
            "leftCorner": {
              "x": -9.633,
              "y": 25.151,
              "z": 0.821
            },
            "rightCorner": {
              "x": -9.939,
              "y": 25.168,
              "z": 0.821
            },
            "gtin": "4009911601975",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54673e",
        "height": 1.3929,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20f2c",
            "leftCorner": {
              "x": -8.736,
              "y": 25.091,
              "z": 1.14
            },
            "rightCorner": {
              "x": -8.85,
              "y": 25.097,
              "z": 1.14
            },
            "gtin": "4063367463884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f2d",
            "leftCorner": {
              "x": -8.85,
              "y": 25.097,
              "z": 1.14
            },
            "rightCorner": {
              "x": -8.964,
              "y": 25.103,
              "z": 1.14
            },
            "gtin": "4063367463884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f2e",
            "leftCorner": {
              "x": -8.964,
              "y": 25.103,
              "z": 1.14
            },
            "rightCorner": {
              "x": -9.077,
              "y": 25.109,
              "z": 1.14
            },
            "gtin": "4063367463884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f2f",
            "leftCorner": {
              "x": -9.077,
              "y": 25.104,
              "z": 1.14
            },
            "rightCorner": {
              "x": -9.247,
              "y": 25.114,
              "z": 1.14
            },
            "gtin": "4063367397912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f30",
            "leftCorner": {
              "x": -9.247,
              "y": 25.115,
              "z": 1.14
            },
            "rightCorner": {
              "x": -9.369,
              "y": 25.121,
              "z": 1.14
            },
            "gtin": "4063367355103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f31",
            "leftCorner": {
              "x": -9.369,
              "y": 25.121,
              "z": 1.14
            },
            "rightCorner": {
              "x": -9.489,
              "y": 25.129,
              "z": 1.14
            },
            "gtin": "4063367355103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f32",
            "leftCorner": {
              "x": -9.489,
              "y": 25.14,
              "z": 1.14
            },
            "rightCorner": {
              "x": -9.642,
              "y": 25.148,
              "z": 1.14
            },
            "gtin": "4337185504969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f33",
            "leftCorner": {
              "x": -9.642,
              "y": 25.148,
              "z": 1.14
            },
            "rightCorner": {
              "x": -9.795,
              "y": 25.157,
              "z": 1.14
            },
            "gtin": "4337185504969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f34",
            "leftCorner": {
              "x": -9.795,
              "y": 25.157,
              "z": 1.14
            },
            "rightCorner": {
              "x": -9.948,
              "y": 25.165,
              "z": 1.14
            },
            "gtin": "4337185504969",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54673c",
        "height": 1.7442,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20f4e",
            "leftCorner": {
              "x": -8.718,
              "y": 25.09,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.81,
              "y": 25.095,
              "z": 1.427
            },
            "gtin": "4023103140431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f4f",
            "leftCorner": {
              "x": -8.81,
              "y": 25.095,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.901,
              "y": 25.1,
              "z": 1.427
            },
            "gtin": "4023103140431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f50",
            "leftCorner": {
              "x": -8.901,
              "y": 25.1,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.993,
              "y": 25.105,
              "z": 1.427
            },
            "gtin": "4023103140431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f51",
            "leftCorner": {
              "x": -8.993,
              "y": 25.105,
              "z": 1.427
            },
            "rightCorner": {
              "x": -9.084,
              "y": 25.111,
              "z": 1.427
            },
            "gtin": "4023103140431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f52",
            "leftCorner": {
              "x": -9.084,
              "y": 25.111,
              "z": 1.427
            },
            "rightCorner": {
              "x": -9.176,
              "y": 25.116,
              "z": 1.427
            },
            "gtin": "4023103140431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f53",
            "leftCorner": {
              "x": -9.176,
              "y": 25.119,
              "z": 1.427
            },
            "rightCorner": {
              "x": -9.293,
              "y": 25.126,
              "z": 1.427
            },
            "gtin": "4009412026208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f54",
            "leftCorner": {
              "x": -9.293,
              "y": 25.126,
              "z": 1.427
            },
            "rightCorner": {
              "x": -9.412,
              "y": 25.132,
              "z": 1.427
            },
            "gtin": "4009412026208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f55",
            "leftCorner": {
              "x": -9.412,
              "y": 25.123,
              "z": 1.427
            },
            "rightCorner": {
              "x": -9.566,
              "y": 25.132,
              "z": 1.427
            },
            "gtin": "4003364506405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f56",
            "leftCorner": {
              "x": -9.567,
              "y": 25.119,
              "z": 1.427
            },
            "rightCorner": {
              "x": -9.755,
              "y": 25.13,
              "z": 1.427
            },
            "gtin": "4003364281906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f57",
            "leftCorner": {
              "x": -9.755,
              "y": 25.128,
              "z": 1.427
            },
            "rightCorner": {
              "x": -9.854,
              "y": 25.133,
              "z": 1.427
            },
            "gtin": "4003364281807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f58",
            "leftCorner": {
              "x": -9.854,
              "y": 25.133,
              "z": 1.427
            },
            "rightCorner": {
              "x": -9.953,
              "y": 25.138,
              "z": 1.427
            },
            "gtin": "4003364281807",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d93",
    "rightNeighborShelfId": "a6d95"
  },
  {
    "id": "a6d95",
    "name": "a6d95",
    "x": -9.965,
    "y": 25.203,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99961,
      "w": 0.027895
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 34
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546744",
        "height": 0.14182,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20f7c",
            "leftCorner": {
              "x": -9.966,
              "y": 25.184,
              "z": 0.116
            },
            "rightCorner": {
              "x": -10.379,
              "y": 25.208,
              "z": 0.116
            },
            "gtin": "4063367380853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f7d",
            "leftCorner": {
              "x": -10.379,
              "y": 25.208,
              "z": 0.116
            },
            "rightCorner": {
              "x": -10.792,
              "y": 25.23,
              "z": 0.116
            },
            "gtin": "4063367380853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f80",
            "leftCorner": {
              "x": -10.794,
              "y": 25.196,
              "z": 0.116
            },
            "rightCorner": {
              "x": -11.036,
              "y": 25.211,
              "z": 0.116
            },
            "gtin": "4009412312639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f81",
            "leftCorner": {
              "x": -11.036,
              "y": 25.211,
              "z": 0.116
            },
            "rightCorner": {
              "x": -11.278,
              "y": 25.224,
              "z": 0.116
            },
            "gtin": "4009412312639",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546740",
        "height": 0.64156,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20f71",
            "leftCorner": {
              "x": -9.951,
              "y": 25.152,
              "z": 0.525
            },
            "rightCorner": {
              "x": -10.15,
              "y": 25.163,
              "z": 0.525
            },
            "gtin": "4023103110755",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f72",
            "leftCorner": {
              "x": -10.15,
              "y": 25.163,
              "z": 0.525
            },
            "rightCorner": {
              "x": -10.348,
              "y": 25.175,
              "z": 0.525
            },
            "gtin": "4023103110755",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f73",
            "leftCorner": {
              "x": -10.349,
              "y": 25.168,
              "z": 0.525
            },
            "rightCorner": {
              "x": -10.496,
              "y": 25.176,
              "z": 0.525
            },
            "gtin": "8001940001432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f74",
            "leftCorner": {
              "x": -10.496,
              "y": 25.176,
              "z": 0.525
            },
            "rightCorner": {
              "x": -10.644,
              "y": 25.185,
              "z": 0.525
            },
            "gtin": "8001940001432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f75",
            "leftCorner": {
              "x": -10.644,
              "y": 25.194,
              "z": 0.525
            },
            "rightCorner": {
              "x": -10.831,
              "y": 25.204,
              "z": 0.525
            },
            "gtin": "4023103238992",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f76",
            "leftCorner": {
              "x": -10.831,
              "y": 25.198,
              "z": 0.525
            },
            "rightCorner": {
              "x": -11.007,
              "y": 25.208,
              "z": 0.525
            },
            "gtin": "3384127001582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f77",
            "leftCorner": {
              "x": -11.007,
              "y": 25.209,
              "z": 0.525
            },
            "rightCorner": {
              "x": -11.241,
              "y": 25.222,
              "z": 0.525
            },
            "gtin": "3384125000174",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546743",
        "height": 0.99424,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20f0b",
            "leftCorner": {
              "x": -9.941,
              "y": 25.155,
              "z": 0.813
            },
            "rightCorner": {
              "x": -10.097,
              "y": 25.163,
              "z": 0.813
            },
            "gtin": "4063367005602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f0c",
            "leftCorner": {
              "x": -10.097,
              "y": 25.154,
              "z": 0.813
            },
            "rightCorner": {
              "x": -10.22,
              "y": 25.161,
              "z": 0.813
            },
            "gtin": "4063367355110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f0d",
            "leftCorner": {
              "x": -10.219,
              "y": 25.175,
              "z": 0.813
            },
            "rightCorner": {
              "x": -10.328,
              "y": 25.181,
              "z": 0.813
            },
            "gtin": "4023103144675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f0e",
            "leftCorner": {
              "x": -10.328,
              "y": 25.181,
              "z": 0.813
            },
            "rightCorner": {
              "x": -10.438,
              "y": 25.187,
              "z": 0.813
            },
            "gtin": "4023103144675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f0f",
            "leftCorner": {
              "x": -10.438,
              "y": 25.187,
              "z": 0.813
            },
            "rightCorner": {
              "x": -10.659,
              "y": 25.199,
              "z": 0.813
            },
            "gtin": "4003790006296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f10",
            "leftCorner": {
              "x": -10.66,
              "y": 25.181,
              "z": 0.813
            },
            "rightCorner": {
              "x": -10.74,
              "y": 25.186,
              "z": 0.813
            },
            "gtin": "4023103228634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f11",
            "leftCorner": {
              "x": -10.74,
              "y": 25.186,
              "z": 0.813
            },
            "rightCorner": {
              "x": -10.82,
              "y": 25.191,
              "z": 0.813
            },
            "gtin": "4023103228634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f12",
            "leftCorner": {
              "x": -10.819,
              "y": 25.202,
              "z": 0.813
            },
            "rightCorner": {
              "x": -11.086,
              "y": 25.216,
              "z": 0.813
            },
            "gtin": "4063367005596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f13",
            "leftCorner": {
              "x": -11.085,
              "y": 25.229,
              "z": 0.813
            },
            "rightCorner": {
              "x": -11.152,
              "y": 25.233,
              "z": 0.813
            },
            "gtin": "3384129002105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f14",
            "leftCorner": {
              "x": -11.152,
              "y": 25.233,
              "z": 0.813
            },
            "rightCorner": {
              "x": -11.219,
              "y": 25.238,
              "z": 0.813
            },
            "gtin": "3384129002105",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546741",
        "height": 1.3952,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20f35",
            "leftCorner": {
              "x": -9.949,
              "y": 25.15,
              "z": 1.142
            },
            "rightCorner": {
              "x": -10.05,
              "y": 25.156,
              "z": 1.142
            },
            "gtin": "4008600139430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f36",
            "leftCorner": {
              "x": -10.05,
              "y": 25.156,
              "z": 1.142
            },
            "rightCorner": {
              "x": -10.152,
              "y": 25.161,
              "z": 1.142
            },
            "gtin": "4008600139430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f37",
            "leftCorner": {
              "x": -10.152,
              "y": 25.168,
              "z": 1.142
            },
            "rightCorner": {
              "x": -10.322,
              "y": 25.178,
              "z": 1.142
            },
            "gtin": "4009412220316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f38",
            "leftCorner": {
              "x": -10.322,
              "y": 25.178,
              "z": 1.142
            },
            "rightCorner": {
              "x": -10.493,
              "y": 25.187,
              "z": 1.142
            },
            "gtin": "4009412220316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f39",
            "leftCorner": {
              "x": -10.491,
              "y": 25.215,
              "z": 1.142
            },
            "rightCorner": {
              "x": -10.828,
              "y": 25.234,
              "z": 1.142
            },
            "gtin": "4009412040983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f3a",
            "leftCorner": {
              "x": -10.829,
              "y": 25.219,
              "z": 1.142
            },
            "rightCorner": {
              "x": -11.02,
              "y": 25.23,
              "z": 1.142
            },
            "gtin": "4009412220309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f3b",
            "leftCorner": {
              "x": -11.02,
              "y": 25.23,
              "z": 1.142
            },
            "rightCorner": {
              "x": -11.213,
              "y": 25.24,
              "z": 1.142
            },
            "gtin": "4009412220309",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546742",
        "height": 1.7446,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20f59",
            "leftCorner": {
              "x": -9.952,
              "y": 25.153,
              "z": 1.427
            },
            "rightCorner": {
              "x": -10.029,
              "y": 25.158,
              "z": 1.427
            },
            "gtin": "4008508451504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f5a",
            "leftCorner": {
              "x": -10.029,
              "y": 25.158,
              "z": 1.427
            },
            "rightCorner": {
              "x": -10.106,
              "y": 25.163,
              "z": 1.427
            },
            "gtin": "4008508451504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f5b",
            "leftCorner": {
              "x": -10.106,
              "y": 25.156,
              "z": 1.427
            },
            "rightCorner": {
              "x": -10.297,
              "y": 25.166,
              "z": 1.427
            },
            "gtin": "4003364285539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f5c",
            "leftCorner": {
              "x": -10.296,
              "y": 25.181,
              "z": 1.427
            },
            "rightCorner": {
              "x": -10.497,
              "y": 25.192,
              "z": 1.427
            },
            "gtin": "4003364506115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f5d",
            "leftCorner": {
              "x": -10.497,
              "y": 25.193,
              "z": 1.427
            },
            "rightCorner": {
              "x": -11.003,
              "y": 25.221,
              "z": 1.427
            },
            "gtin": "4009412054904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f5e",
            "leftCorner": {
              "x": -11.002,
              "y": 25.232,
              "z": 1.427
            },
            "rightCorner": {
              "x": -11.198,
              "y": 25.244,
              "z": 1.427
            },
            "gtin": "4063367380877",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d94",
    "rightNeighborShelfId": "a6d96"
  },
  {
    "id": "a6d96",
    "name": "a6d96",
    "x": -11.213,
    "y": 25.273,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99961,
      "w": 0.027895
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 38
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546749",
        "height": 0.13832,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20f82",
            "leftCorner": {
              "x": -11.278,
              "y": 25.227,
              "z": 0.113
            },
            "rightCorner": {
              "x": -11.512,
              "y": 25.239,
              "z": 0.113
            },
            "gtin": "4337185831782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f83",
            "leftCorner": {
              "x": -11.512,
              "y": 25.239,
              "z": 0.113
            },
            "rightCorner": {
              "x": -11.746,
              "y": 25.252,
              "z": 0.113
            },
            "gtin": "4337185831782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f7e",
            "leftCorner": {
              "x": -11.745,
              "y": 25.261,
              "z": 0.113
            },
            "rightCorner": {
              "x": -12.105,
              "y": 25.282,
              "z": 0.113
            },
            "gtin": "4063367021329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f7f",
            "leftCorner": {
              "x": -12.105,
              "y": 25.282,
              "z": 0.113
            },
            "rightCorner": {
              "x": -12.464,
              "y": 25.302,
              "z": 0.113
            },
            "gtin": "4063367021329",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546748",
        "height": 0.63929,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20f78",
            "leftCorner": {
              "x": -11.241,
              "y": 25.217,
              "z": 0.523
            },
            "rightCorner": {
              "x": -11.494,
              "y": 25.231,
              "z": 0.523
            },
            "gtin": "4063367365485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f79",
            "leftCorner": {
              "x": -11.494,
              "y": 25.231,
              "z": 0.523
            },
            "rightCorner": {
              "x": -11.747,
              "y": 25.245,
              "z": 0.523
            },
            "gtin": "4063367365485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f7a",
            "leftCorner": {
              "x": -11.747,
              "y": 25.245,
              "z": 0.523
            },
            "rightCorner": {
              "x": -11.991,
              "y": 25.259,
              "z": 0.523
            },
            "gtin": "4063367365447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f7b",
            "leftCorner": {
              "x": -11.991,
              "y": 25.259,
              "z": 0.523
            },
            "rightCorner": {
              "x": -12.234,
              "y": 25.273,
              "z": 0.523
            },
            "gtin": "4063367365447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f6d",
            "leftCorner": {
              "x": -12.234,
              "y": 25.264,
              "z": 0.523
            },
            "rightCorner": {
              "x": -12.35,
              "y": 25.271,
              "z": 0.523
            },
            "gtin": "4063367365461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f6e",
            "leftCorner": {
              "x": -12.35,
              "y": 25.271,
              "z": 0.523
            },
            "rightCorner": {
              "x": -12.465,
              "y": 25.277,
              "z": 0.523
            },
            "gtin": "4063367365461",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546746",
        "height": 0.99375,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20f15",
            "leftCorner": {
              "x": -11.219,
              "y": 25.226,
              "z": 0.813
            },
            "rightCorner": {
              "x": -11.395,
              "y": 25.236,
              "z": 0.813
            },
            "gtin": "4002448107637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f16",
            "leftCorner": {
              "x": -11.395,
              "y": 25.236,
              "z": 0.813
            },
            "rightCorner": {
              "x": -11.572,
              "y": 25.246,
              "z": 0.813
            },
            "gtin": "4002448107637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f17",
            "leftCorner": {
              "x": -11.572,
              "y": 25.245,
              "z": 0.813
            },
            "rightCorner": {
              "x": -11.708,
              "y": 25.253,
              "z": 0.813
            },
            "gtin": "4002448140368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f18",
            "leftCorner": {
              "x": -11.708,
              "y": 25.253,
              "z": 0.813
            },
            "rightCorner": {
              "x": -11.846,
              "y": 25.261,
              "z": 0.813
            },
            "gtin": "4002448140368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f19",
            "leftCorner": {
              "x": -11.846,
              "y": 25.261,
              "z": 0.813
            },
            "rightCorner": {
              "x": -11.983,
              "y": 25.268,
              "z": 0.813
            },
            "gtin": "4002448140368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20eff",
            "leftCorner": {
              "x": -11.983,
              "y": 25.259,
              "z": 0.813
            },
            "rightCorner": {
              "x": -12.224,
              "y": 25.272,
              "z": 0.813
            },
            "gtin": "4063367304286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f00",
            "leftCorner": {
              "x": -12.224,
              "y": 25.272,
              "z": 0.813
            },
            "rightCorner": {
              "x": -12.464,
              "y": 25.286,
              "z": 0.813
            },
            "gtin": "4063367304286",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546747",
        "height": 1.3921,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20f3c",
            "leftCorner": {
              "x": -11.213,
              "y": 25.233,
              "z": 1.139
            },
            "rightCorner": {
              "x": -11.372,
              "y": 25.242,
              "z": 1.139
            },
            "gtin": "3245421402577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f3d",
            "leftCorner": {
              "x": -11.372,
              "y": 25.242,
              "z": 1.139
            },
            "rightCorner": {
              "x": -11.531,
              "y": 25.251,
              "z": 1.139
            },
            "gtin": "3245421402577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f3e",
            "leftCorner": {
              "x": -11.532,
              "y": 25.243,
              "z": 1.139
            },
            "rightCorner": {
              "x": -11.873,
              "y": 25.262,
              "z": 1.139
            },
            "gtin": "3245421402584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f3f",
            "leftCorner": {
              "x": -11.873,
              "y": 25.256,
              "z": 1.139
            },
            "rightCorner": {
              "x": -12.024,
              "y": 25.265,
              "z": 1.139
            },
            "gtin": "3384122490183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f40",
            "leftCorner": {
              "x": -12.024,
              "y": 25.265,
              "z": 1.139
            },
            "rightCorner": {
              "x": -12.175,
              "y": 25.274,
              "z": 1.139
            },
            "gtin": "3384122490183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f41",
            "leftCorner": {
              "x": -12.175,
              "y": 25.274,
              "z": 1.139
            },
            "rightCorner": {
              "x": -12.326,
              "y": 25.282,
              "z": 1.139
            },
            "gtin": "3384122490183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f27",
            "leftCorner": {
              "x": -12.325,
              "y": 25.295,
              "z": 1.139
            },
            "rightCorner": {
              "x": -12.464,
              "y": 25.303,
              "z": 1.139
            },
            "gtin": "3384122490176",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546745",
        "height": 1.7436,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20f5f",
            "leftCorner": {
              "x": -11.199,
              "y": 25.227,
              "z": 1.427
            },
            "rightCorner": {
              "x": -11.277,
              "y": 25.232,
              "z": 1.427
            },
            "gtin": "4337185509360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f60",
            "leftCorner": {
              "x": -11.277,
              "y": 25.232,
              "z": 1.427
            },
            "rightCorner": {
              "x": -11.356,
              "y": 25.235,
              "z": 1.427
            },
            "gtin": "4337185509360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f61",
            "leftCorner": {
              "x": -11.355,
              "y": 25.238,
              "z": 1.427
            },
            "rightCorner": {
              "x": -11.453,
              "y": 25.244,
              "z": 1.427
            },
            "gtin": "4337185509377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f62",
            "leftCorner": {
              "x": -11.453,
              "y": 25.244,
              "z": 1.427
            },
            "rightCorner": {
              "x": -11.552,
              "y": 25.249,
              "z": 1.427
            },
            "gtin": "4337185509377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f63",
            "leftCorner": {
              "x": -11.552,
              "y": 25.249,
              "z": 1.427
            },
            "rightCorner": {
              "x": -11.651,
              "y": 25.255,
              "z": 1.427
            },
            "gtin": "4337185509377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f64",
            "leftCorner": {
              "x": -11.651,
              "y": 25.26,
              "z": 1.427
            },
            "rightCorner": {
              "x": -11.762,
              "y": 25.265,
              "z": 1.427
            },
            "gtin": "4337185509421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f65",
            "leftCorner": {
              "x": -11.762,
              "y": 25.265,
              "z": 1.427
            },
            "rightCorner": {
              "x": -11.874,
              "y": 25.272,
              "z": 1.427
            },
            "gtin": "4337185509421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f66",
            "leftCorner": {
              "x": -11.874,
              "y": 25.272,
              "z": 1.427
            },
            "rightCorner": {
              "x": -11.985,
              "y": 25.278,
              "z": 1.427
            },
            "gtin": "4337185509421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f67",
            "leftCorner": {
              "x": -11.985,
              "y": 25.265,
              "z": 1.427
            },
            "rightCorner": {
              "x": -12.064,
              "y": 25.269,
              "z": 1.427
            },
            "gtin": "3384120009424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f68",
            "leftCorner": {
              "x": -12.064,
              "y": 25.269,
              "z": 1.427
            },
            "rightCorner": {
              "x": -12.143,
              "y": 25.274,
              "z": 1.427
            },
            "gtin": "3384120009424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f69",
            "leftCorner": {
              "x": -12.143,
              "y": 25.27,
              "z": 1.427
            },
            "rightCorner": {
              "x": -12.221,
              "y": 25.275,
              "z": 1.427
            },
            "gtin": "3384120009493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f6a",
            "leftCorner": {
              "x": -12.221,
              "y": 25.275,
              "z": 1.427
            },
            "rightCorner": {
              "x": -12.3,
              "y": 25.279,
              "z": 1.427
            },
            "gtin": "3384120009493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f45",
            "leftCorner": {
              "x": -12.299,
              "y": 25.296,
              "z": 1.427
            },
            "rightCorner": {
              "x": -12.381,
              "y": 25.301,
              "z": 1.427
            },
            "gtin": "3384120009530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f46",
            "leftCorner": {
              "x": -12.381,
              "y": 25.301,
              "z": 1.427
            },
            "rightCorner": {
              "x": -12.464,
              "y": 25.305,
              "z": 1.427
            },
            "gtin": "3384120009530",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6d95"
  },
  {
    "id": "b6f78",
    "name": "b6f78",
    "x": 10.503,
    "y": 6.678,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.040786,
      "w": 0.99917
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 60
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54623a",
        "height": 1.7114,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d851",
            "leftCorner": {
              "x": 10.846,
              "y": 6.684,
              "z": 1.4
            },
            "rightCorner": {
              "x": 11.0,
              "y": 6.672,
              "z": 1.4
            },
            "gtin": "4000286005009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d84c",
            "leftCorner": {
              "x": 10.532,
              "y": 6.696,
              "z": 1.4
            },
            "rightCorner": {
              "x": 10.584,
              "y": 6.692,
              "z": 1.4
            },
            "gtin": "4000286004989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d84d",
            "leftCorner": {
              "x": 10.584,
              "y": 6.692,
              "z": 1.4
            },
            "rightCorner": {
              "x": 10.636,
              "y": 6.688,
              "z": 1.4
            },
            "gtin": "4000286004989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d84e",
            "leftCorner": {
              "x": 10.636,
              "y": 6.688,
              "z": 1.4
            },
            "rightCorner": {
              "x": 10.689,
              "y": 6.684,
              "z": 1.4
            },
            "gtin": "4000286004989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d84f",
            "leftCorner": {
              "x": 10.69,
              "y": 6.699,
              "z": 1.4
            },
            "rightCorner": {
              "x": 10.769,
              "y": 6.692,
              "z": 1.4
            },
            "gtin": "4000286005023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d850",
            "leftCorner": {
              "x": 10.769,
              "y": 6.692,
              "z": 1.4
            },
            "rightCorner": {
              "x": 10.847,
              "y": 6.686,
              "z": 1.4
            },
            "gtin": "4000286005023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d852",
            "leftCorner": {
              "x": 11.0,
              "y": 6.666,
              "z": 1.4
            },
            "rightCorner": {
              "x": 11.145,
              "y": 6.654,
              "z": 1.4
            },
            "gtin": "4000286005047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d853",
            "leftCorner": {
              "x": 11.145,
              "y": 6.649,
              "z": 1.4
            },
            "rightCorner": {
              "x": 11.294,
              "y": 6.637,
              "z": 1.4
            },
            "gtin": "3760163670003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d854",
            "leftCorner": {
              "x": 11.294,
              "y": 6.637,
              "z": 1.4
            },
            "rightCorner": {
              "x": 11.444,
              "y": 6.625,
              "z": 1.4
            },
            "gtin": "3760163670003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d855",
            "leftCorner": {
              "x": 11.444,
              "y": 6.625,
              "z": 1.4
            },
            "rightCorner": {
              "x": 11.592,
              "y": 6.612,
              "z": 1.4
            },
            "gtin": "3760163670003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d856",
            "leftCorner": {
              "x": 11.591,
              "y": 6.603,
              "z": 1.4
            },
            "rightCorner": {
              "x": 11.639,
              "y": 6.599,
              "z": 1.4
            },
            "gtin": "3760163670027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d857",
            "leftCorner": {
              "x": 11.639,
              "y": 6.599,
              "z": 1.4
            },
            "rightCorner": {
              "x": 11.687,
              "y": 6.596,
              "z": 1.4
            },
            "gtin": "3760163670027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d858",
            "leftCorner": {
              "x": 11.687,
              "y": 6.596,
              "z": 1.4
            },
            "rightCorner": {
              "x": 11.735,
              "y": 6.592,
              "z": 1.4
            },
            "gtin": "3760163670027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d859",
            "leftCorner": {
              "x": 11.735,
              "y": 6.592,
              "z": 1.4
            },
            "rightCorner": {
              "x": 11.782,
              "y": 6.588,
              "z": 1.4
            },
            "gtin": "3760163670027",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54623b",
        "height": 0.14789,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d8e8",
            "leftCorner": {
              "x": 10.657,
              "y": 6.717,
              "z": 0.121
            },
            "rightCorner": {
              "x": 11.086,
              "y": 6.682,
              "z": 0.121
            },
            "gtin": "8017759644272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8e9",
            "leftCorner": {
              "x": 11.086,
              "y": 6.679,
              "z": 0.121
            },
            "rightCorner": {
              "x": 11.318,
              "y": 6.66,
              "z": 0.121
            },
            "gtin": "8017759070026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8ea",
            "leftCorner": {
              "x": 11.318,
              "y": 6.66,
              "z": 0.121
            },
            "rightCorner": {
              "x": 11.55,
              "y": 6.641,
              "z": 0.121
            },
            "gtin": "8017759070026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8eb",
            "leftCorner": {
              "x": 11.55,
              "y": 6.641,
              "z": 0.121
            },
            "rightCorner": {
              "x": 11.781,
              "y": 6.622,
              "z": 0.121
            },
            "gtin": "8017759070026",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546236",
        "height": 0.65394,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d7ee",
            "leftCorner": {
              "x": 10.504,
              "y": 6.688,
              "z": 0.535
            },
            "rightCorner": {
              "x": 10.608,
              "y": 6.68,
              "z": 0.535
            },
            "gtin": "8017759070040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7ef",
            "leftCorner": {
              "x": 10.608,
              "y": 6.68,
              "z": 0.535
            },
            "rightCorner": {
              "x": 10.712,
              "y": 6.671,
              "z": 0.535
            },
            "gtin": "8017759070040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7f0",
            "leftCorner": {
              "x": 10.712,
              "y": 6.671,
              "z": 0.535
            },
            "rightCorner": {
              "x": 10.817,
              "y": 6.663,
              "z": 0.535
            },
            "gtin": "8017759070040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7f1",
            "leftCorner": {
              "x": 10.817,
              "y": 6.663,
              "z": 0.535
            },
            "rightCorner": {
              "x": 10.92,
              "y": 6.654,
              "z": 0.535
            },
            "gtin": "8017759070040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7f3",
            "leftCorner": {
              "x": 10.923,
              "y": 6.69,
              "z": 0.535
            },
            "rightCorner": {
              "x": 11.014,
              "y": 6.683,
              "z": 0.535
            },
            "gtin": "8017759020014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7f4",
            "leftCorner": {
              "x": 11.014,
              "y": 6.683,
              "z": 0.535
            },
            "rightCorner": {
              "x": 11.105,
              "y": 6.676,
              "z": 0.535
            },
            "gtin": "8017759020014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7f5",
            "leftCorner": {
              "x": 11.105,
              "y": 6.676,
              "z": 0.535
            },
            "rightCorner": {
              "x": 11.195,
              "y": 6.668,
              "z": 0.535
            },
            "gtin": "8017759020014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7f6",
            "leftCorner": {
              "x": 11.195,
              "y": 6.668,
              "z": 0.535
            },
            "rightCorner": {
              "x": 11.286,
              "y": 6.661,
              "z": 0.535
            },
            "gtin": "8017759020014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7f7",
            "leftCorner": {
              "x": 11.286,
              "y": 6.663,
              "z": 0.535
            },
            "rightCorner": {
              "x": 11.424,
              "y": 6.651,
              "z": 0.535
            },
            "gtin": "8017759647365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7f8",
            "leftCorner": {
              "x": 11.424,
              "y": 6.651,
              "z": 0.535
            },
            "rightCorner": {
              "x": 11.562,
              "y": 6.64,
              "z": 0.535
            },
            "gtin": "8017759647365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7f9",
            "leftCorner": {
              "x": 11.562,
              "y": 6.64,
              "z": 0.535
            },
            "rightCorner": {
              "x": 11.7,
              "y": 6.629,
              "z": 0.535
            },
            "gtin": "8017759647365",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546239",
        "height": 0.95166,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d76b",
            "leftCorner": {
              "x": 10.503,
              "y": 6.682,
              "z": 0.779
            },
            "rightCorner": {
              "x": 10.635,
              "y": 6.671,
              "z": 0.779
            },
            "gtin": "8017759644357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d76c",
            "leftCorner": {
              "x": 10.635,
              "y": 6.671,
              "z": 0.779
            },
            "rightCorner": {
              "x": 10.765,
              "y": 6.661,
              "z": 0.779
            },
            "gtin": "8017759644357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d76e",
            "leftCorner": {
              "x": 10.769,
              "y": 6.703,
              "z": 0.779
            },
            "rightCorner": {
              "x": 10.874,
              "y": 6.695,
              "z": 0.779
            },
            "gtin": "8017759647242",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d76f",
            "leftCorner": {
              "x": 10.874,
              "y": 6.695,
              "z": 0.779
            },
            "rightCorner": {
              "x": 10.981,
              "y": 6.686,
              "z": 0.779
            },
            "gtin": "8017759647242",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d770",
            "leftCorner": {
              "x": 10.981,
              "y": 6.683,
              "z": 0.779
            },
            "rightCorner": {
              "x": 11.115,
              "y": 6.672,
              "z": 0.779
            },
            "gtin": "8017759020038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d771",
            "leftCorner": {
              "x": 11.115,
              "y": 6.672,
              "z": 0.779
            },
            "rightCorner": {
              "x": 11.251,
              "y": 6.661,
              "z": 0.779
            },
            "gtin": "8017759020038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d772",
            "leftCorner": {
              "x": 11.25,
              "y": 6.647,
              "z": 0.779
            },
            "rightCorner": {
              "x": 11.332,
              "y": 6.641,
              "z": 0.779
            },
            "gtin": "4019339235041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d773",
            "leftCorner": {
              "x": 11.332,
              "y": 6.652,
              "z": 0.779
            },
            "rightCorner": {
              "x": 11.442,
              "y": 6.643,
              "z": 0.779
            },
            "gtin": "8719632250326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d774",
            "leftCorner": {
              "x": 11.442,
              "y": 6.646,
              "z": 0.779
            },
            "rightCorner": {
              "x": 11.594,
              "y": 6.633,
              "z": 0.779
            },
            "gtin": "8719632250333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d775",
            "leftCorner": {
              "x": 11.593,
              "y": 6.62,
              "z": 0.779
            },
            "rightCorner": {
              "x": 11.681,
              "y": 6.613,
              "z": 0.779
            },
            "gtin": "4006237640404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d776",
            "leftCorner": {
              "x": 11.681,
              "y": 6.613,
              "z": 0.779
            },
            "rightCorner": {
              "x": 11.77,
              "y": 6.606,
              "z": 0.779
            },
            "gtin": "4006237640404",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546237",
        "height": 1.2069,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d7a9",
            "leftCorner": {
              "x": 10.503,
              "y": 6.677,
              "z": 0.987
            },
            "rightCorner": {
              "x": 10.643,
              "y": 6.666,
              "z": 0.987
            },
            "gtin": "3487400000019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7aa",
            "leftCorner": {
              "x": 10.643,
              "y": 6.666,
              "z": 0.987
            },
            "rightCorner": {
              "x": 10.783,
              "y": 6.655,
              "z": 0.987
            },
            "gtin": "3487400000019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7ae",
            "leftCorner": {
              "x": 10.787,
              "y": 6.697,
              "z": 0.987
            },
            "rightCorner": {
              "x": 10.88,
              "y": 6.69,
              "z": 0.987
            },
            "gtin": "8001420010114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7af",
            "leftCorner": {
              "x": 10.88,
              "y": 6.69,
              "z": 0.987
            },
            "rightCorner": {
              "x": 10.973,
              "y": 6.682,
              "z": 0.987
            },
            "gtin": "8001420010114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7b0",
            "leftCorner": {
              "x": 10.972,
              "y": 6.675,
              "z": 0.987
            },
            "rightCorner": {
              "x": 11.122,
              "y": 6.663,
              "z": 0.987
            },
            "gtin": "8001420011388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7b1",
            "leftCorner": {
              "x": 11.122,
              "y": 6.663,
              "z": 0.987
            },
            "rightCorner": {
              "x": 11.27,
              "y": 6.651,
              "z": 0.987
            },
            "gtin": "8001420011388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7b2",
            "leftCorner": {
              "x": 11.27,
              "y": 6.651,
              "z": 0.987
            },
            "rightCorner": {
              "x": 11.473,
              "y": 6.635,
              "z": 0.987
            },
            "gtin": "4006237641029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7b3",
            "leftCorner": {
              "x": 11.472,
              "y": 6.626,
              "z": 0.987
            },
            "rightCorner": {
              "x": 11.562,
              "y": 6.618,
              "z": 0.987
            },
            "gtin": "4006237641777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7b4",
            "leftCorner": {
              "x": 11.562,
              "y": 6.618,
              "z": 0.987
            },
            "rightCorner": {
              "x": 11.65,
              "y": 6.611,
              "z": 0.987
            },
            "gtin": "4006237641777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7b5",
            "leftCorner": {
              "x": 11.65,
              "y": 6.611,
              "z": 0.987
            },
            "rightCorner": {
              "x": 11.74,
              "y": 6.604,
              "z": 0.987
            },
            "gtin": "4006237641777",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546238",
        "height": 1.4583,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d89f",
            "leftCorner": {
              "x": 10.503,
              "y": 6.675,
              "z": 1.193
            },
            "rightCorner": {
              "x": 10.642,
              "y": 6.663,
              "z": 1.193
            },
            "gtin": "3487400000415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8a0",
            "leftCorner": {
              "x": 10.642,
              "y": 6.663,
              "z": 1.193
            },
            "rightCorner": {
              "x": 10.782,
              "y": 6.652,
              "z": 1.193
            },
            "gtin": "3487400000415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8a2",
            "leftCorner": {
              "x": 10.785,
              "y": 6.689,
              "z": 1.193
            },
            "rightCorner": {
              "x": 10.905,
              "y": 6.679,
              "z": 1.193
            },
            "gtin": "4005500319177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8a3",
            "leftCorner": {
              "x": 10.905,
              "y": 6.679,
              "z": 1.193
            },
            "rightCorner": {
              "x": 11.026,
              "y": 6.669,
              "z": 1.193
            },
            "gtin": "4005500319177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8a4",
            "leftCorner": {
              "x": 11.026,
              "y": 6.669,
              "z": 1.193
            },
            "rightCorner": {
              "x": 11.175,
              "y": 6.656,
              "z": 1.193
            },
            "gtin": "4005500319276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8a5",
            "leftCorner": {
              "x": 11.175,
              "y": 6.656,
              "z": 1.193
            },
            "rightCorner": {
              "x": 11.325,
              "y": 6.644,
              "z": 1.193
            },
            "gtin": "4005500319276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8a6",
            "leftCorner": {
              "x": 11.324,
              "y": 6.639,
              "z": 1.193
            },
            "rightCorner": {
              "x": 11.435,
              "y": 6.63,
              "z": 1.193
            },
            "gtin": "8410657100114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8a7",
            "leftCorner": {
              "x": 11.435,
              "y": 6.63,
              "z": 1.193
            },
            "rightCorner": {
              "x": 11.547,
              "y": 6.621,
              "z": 1.193
            },
            "gtin": "8410657100114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8a8",
            "leftCorner": {
              "x": 11.547,
              "y": 6.621,
              "z": 1.193
            },
            "rightCorner": {
              "x": 11.657,
              "y": 6.612,
              "z": 1.193
            },
            "gtin": "8410657100114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8a9",
            "leftCorner": {
              "x": 11.657,
              "y": 6.612,
              "z": 1.193
            },
            "rightCorner": {
              "x": 11.768,
              "y": 6.603,
              "z": 1.193
            },
            "gtin": "8410657100114",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e0269",
    "rightNeighborShelfId": "b6f79"
  },
  {
    "id": "b6f79",
    "name": "b6f79",
    "x": 11.699,
    "y": 6.58,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.040786,
      "w": 0.99917
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 45
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546241",
        "height": 0.14535,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a54623c",
        "height": 0.65038,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d7fa",
            "leftCorner": {
              "x": 11.7,
              "y": 6.632,
              "z": 0.532
            },
            "rightCorner": {
              "x": 11.994,
              "y": 6.608,
              "z": 0.532
            },
            "gtin": "5410673004307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7fb",
            "leftCorner": {
              "x": 11.994,
              "y": 6.608,
              "z": 0.532
            },
            "rightCorner": {
              "x": 12.287,
              "y": 6.584,
              "z": 0.532
            },
            "gtin": "5410673004307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7fc",
            "leftCorner": {
              "x": 12.286,
              "y": 6.575,
              "z": 0.532
            },
            "rightCorner": {
              "x": 12.49,
              "y": 6.558,
              "z": 0.532
            },
            "gtin": "5410673004444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7fd",
            "leftCorner": {
              "x": 12.49,
              "y": 6.558,
              "z": 0.532
            },
            "rightCorner": {
              "x": 12.693,
              "y": 6.542,
              "z": 0.532
            },
            "gtin": "5410673004444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7fe",
            "leftCorner": {
              "x": 12.694,
              "y": 6.55,
              "z": 0.532
            },
            "rightCorner": {
              "x": 12.919,
              "y": 6.532,
              "z": 0.532
            },
            "gtin": "5410673004475",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54623e",
        "height": 0.9519,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d777",
            "leftCorner": {
              "x": 11.771,
              "y": 6.613,
              "z": 0.779
            },
            "rightCorner": {
              "x": 11.909,
              "y": 6.602,
              "z": 0.779
            },
            "gtin": "4006237090094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d778",
            "leftCorner": {
              "x": 11.91,
              "y": 6.603,
              "z": 0.779
            },
            "rightCorner": {
              "x": 12.105,
              "y": 6.587,
              "z": 0.779
            },
            "gtin": "4006237090087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d779",
            "leftCorner": {
              "x": 12.105,
              "y": 6.587,
              "z": 0.779
            },
            "rightCorner": {
              "x": 12.299,
              "y": 6.571,
              "z": 0.779
            },
            "gtin": "4006237090087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d77a",
            "leftCorner": {
              "x": 12.299,
              "y": 6.571,
              "z": 0.779
            },
            "rightCorner": {
              "x": 12.493,
              "y": 6.555,
              "z": 0.779
            },
            "gtin": "4006237090087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d77b",
            "leftCorner": {
              "x": 12.494,
              "y": 6.557,
              "z": 0.779
            },
            "rightCorner": {
              "x": 12.666,
              "y": 6.543,
              "z": 0.779
            },
            "gtin": "5410673004574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d77c",
            "leftCorner": {
              "x": 12.667,
              "y": 6.554,
              "z": 0.779
            },
            "rightCorner": {
              "x": 12.801,
              "y": 6.543,
              "z": 0.779
            },
            "gtin": "5410673004673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d77d",
            "leftCorner": {
              "x": 12.801,
              "y": 6.541,
              "z": 0.779
            },
            "rightCorner": {
              "x": 12.958,
              "y": 6.528,
              "z": 0.779
            },
            "gtin": "5410673004314",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54623d",
        "height": 1.2035,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d7b6",
            "leftCorner": {
              "x": 11.74,
              "y": 6.609,
              "z": 0.985
            },
            "rightCorner": {
              "x": 11.815,
              "y": 6.602,
              "z": 0.985
            },
            "gtin": "4006237600019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7b7",
            "leftCorner": {
              "x": 11.815,
              "y": 6.602,
              "z": 0.985
            },
            "rightCorner": {
              "x": 11.889,
              "y": 6.596,
              "z": 0.985
            },
            "gtin": "4006237600019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7b8",
            "leftCorner": {
              "x": 11.889,
              "y": 6.596,
              "z": 0.985
            },
            "rightCorner": {
              "x": 11.964,
              "y": 6.59,
              "z": 0.985
            },
            "gtin": "4006237600019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7b9",
            "leftCorner": {
              "x": 11.964,
              "y": 6.59,
              "z": 0.985
            },
            "rightCorner": {
              "x": 12.037,
              "y": 6.584,
              "z": 0.985
            },
            "gtin": "4006237600019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7ba",
            "leftCorner": {
              "x": 12.038,
              "y": 6.59,
              "z": 0.985
            },
            "rightCorner": {
              "x": 12.159,
              "y": 6.58,
              "z": 0.985
            },
            "gtin": "4006237610018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7bb",
            "leftCorner": {
              "x": 12.159,
              "y": 6.574,
              "z": 0.985
            },
            "rightCorner": {
              "x": 12.23,
              "y": 6.569,
              "z": 0.985
            },
            "gtin": "4006237630016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7bc",
            "leftCorner": {
              "x": 12.23,
              "y": 6.569,
              "z": 0.985
            },
            "rightCorner": {
              "x": 12.3,
              "y": 6.563,
              "z": 0.985
            },
            "gtin": "4006237630016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7bd",
            "leftCorner": {
              "x": 12.301,
              "y": 6.565,
              "z": 0.985
            },
            "rightCorner": {
              "x": 12.383,
              "y": 6.559,
              "z": 0.985
            },
            "gtin": "4006237640336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7be",
            "leftCorner": {
              "x": 12.383,
              "y": 6.559,
              "z": 0.985
            },
            "rightCorner": {
              "x": 12.466,
              "y": 6.552,
              "z": 0.985
            },
            "gtin": "4006237640336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7bf",
            "leftCorner": {
              "x": 12.466,
              "y": 6.552,
              "z": 0.985
            },
            "rightCorner": {
              "x": 12.549,
              "y": 6.545,
              "z": 0.985
            },
            "gtin": "4006237640336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7c0",
            "leftCorner": {
              "x": 12.549,
              "y": 6.545,
              "z": 0.985
            },
            "rightCorner": {
              "x": 12.632,
              "y": 6.538,
              "z": 0.985
            },
            "gtin": "4006237640336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7c1",
            "leftCorner": {
              "x": 12.632,
              "y": 6.547,
              "z": 0.985
            },
            "rightCorner": {
              "x": 12.721,
              "y": 6.54,
              "z": 0.985
            },
            "gtin": "4006237640398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7c2",
            "leftCorner": {
              "x": 12.721,
              "y": 6.54,
              "z": 0.985
            },
            "rightCorner": {
              "x": 12.809,
              "y": 6.533,
              "z": 0.985
            },
            "gtin": "4006237640398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7c3",
            "leftCorner": {
              "x": 12.809,
              "y": 6.533,
              "z": 0.985
            },
            "rightCorner": {
              "x": 12.897,
              "y": 6.526,
              "z": 0.985
            },
            "gtin": "4006237640398",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54623f",
        "height": 1.4546,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d8aa",
            "leftCorner": {
              "x": 11.769,
              "y": 6.611,
              "z": 1.19
            },
            "rightCorner": {
              "x": 11.866,
              "y": 6.603,
              "z": 1.19
            },
            "gtin": "4006237640480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8ab",
            "leftCorner": {
              "x": 11.866,
              "y": 6.603,
              "z": 1.19
            },
            "rightCorner": {
              "x": 11.964,
              "y": 6.595,
              "z": 1.19
            },
            "gtin": "4006237640480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8ac",
            "leftCorner": {
              "x": 11.964,
              "y": 6.594,
              "z": 1.19
            },
            "rightCorner": {
              "x": 12.047,
              "y": 6.587,
              "z": 1.19
            },
            "gtin": "4006237640329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8ad",
            "leftCorner": {
              "x": 12.047,
              "y": 6.587,
              "z": 1.19
            },
            "rightCorner": {
              "x": 12.129,
              "y": 6.58,
              "z": 1.19
            },
            "gtin": "4006237640329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8ae",
            "leftCorner": {
              "x": 12.129,
              "y": 6.58,
              "z": 1.19
            },
            "rightCorner": {
              "x": 12.211,
              "y": 6.574,
              "z": 1.19
            },
            "gtin": "4006237640329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8af",
            "leftCorner": {
              "x": 12.21,
              "y": 6.565,
              "z": 1.19
            },
            "rightCorner": {
              "x": 12.288,
              "y": 6.558,
              "z": 1.19
            },
            "gtin": "4006237620017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8b0",
            "leftCorner": {
              "x": 12.288,
              "y": 6.558,
              "z": 1.19
            },
            "rightCorner": {
              "x": 12.366,
              "y": 6.552,
              "z": 1.19
            },
            "gtin": "4006237620017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8b1",
            "leftCorner": {
              "x": 12.366,
              "y": 6.552,
              "z": 1.19
            },
            "rightCorner": {
              "x": 12.444,
              "y": 6.546,
              "z": 1.19
            },
            "gtin": "4006237620017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8b2",
            "leftCorner": {
              "x": 12.444,
              "y": 6.546,
              "z": 1.19
            },
            "rightCorner": {
              "x": 12.521,
              "y": 6.539,
              "z": 1.19
            },
            "gtin": "4006237620017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8b3",
            "leftCorner": {
              "x": 12.522,
              "y": 6.551,
              "z": 1.19
            },
            "rightCorner": {
              "x": 12.682,
              "y": 6.538,
              "z": 1.19
            },
            "gtin": "4006237640312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8b4",
            "leftCorner": {
              "x": 12.682,
              "y": 6.538,
              "z": 1.19
            },
            "rightCorner": {
              "x": 12.841,
              "y": 6.525,
              "z": 1.19
            },
            "gtin": "4006237640312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8b5",
            "leftCorner": {
              "x": 12.841,
              "y": 6.525,
              "z": 1.19
            },
            "rightCorner": {
              "x": 13.001,
              "y": 6.512,
              "z": 1.19
            },
            "gtin": "4006237640312",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546240",
        "height": 1.7047,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d85a",
            "leftCorner": {
              "x": 11.783,
              "y": 6.601,
              "z": 1.395
            },
            "rightCorner": {
              "x": 11.933,
              "y": 6.588,
              "z": 1.395
            },
            "gtin": "3760163670041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d85b",
            "leftCorner": {
              "x": 11.933,
              "y": 6.588,
              "z": 1.395
            },
            "rightCorner": {
              "x": 12.084,
              "y": 6.576,
              "z": 1.395
            },
            "gtin": "3760163670041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d85c",
            "leftCorner": {
              "x": 12.084,
              "y": 6.576,
              "z": 1.395
            },
            "rightCorner": {
              "x": 12.234,
              "y": 6.564,
              "z": 1.395
            },
            "gtin": "3760163670041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d85d",
            "leftCorner": {
              "x": 12.235,
              "y": 6.568,
              "z": 1.395
            },
            "rightCorner": {
              "x": 12.433,
              "y": 6.551,
              "z": 1.395
            },
            "gtin": "3760163670010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d85e",
            "leftCorner": {
              "x": 12.433,
              "y": 6.551,
              "z": 1.395
            },
            "rightCorner": {
              "x": 12.63,
              "y": 6.535,
              "z": 1.395
            },
            "gtin": "3760163670010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d85f",
            "leftCorner": {
              "x": 12.63,
              "y": 6.535,
              "z": 1.395
            },
            "rightCorner": {
              "x": 12.829,
              "y": 6.519,
              "z": 1.395
            },
            "gtin": "3760163670010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d860",
            "leftCorner": {
              "x": 12.829,
              "y": 6.525,
              "z": 1.395
            },
            "rightCorner": {
              "x": 12.936,
              "y": 6.516,
              "z": 1.395
            },
            "gtin": "3760163670034",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f78",
    "rightNeighborShelfId": "b6f7a"
  },
  {
    "id": "b6f7a",
    "name": "b6f7a",
    "x": 12.895,
    "y": 6.482,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.040786,
      "w": 0.99917
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 56
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546247",
        "height": 0.14714,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d8ec",
            "leftCorner": {
              "x": 12.979,
              "y": 6.536,
              "z": 0.12
            },
            "rightCorner": {
              "x": 13.37,
              "y": 6.504,
              "z": 0.12
            },
            "gtin": "4337185459740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8ed",
            "leftCorner": {
              "x": 13.37,
              "y": 6.504,
              "z": 0.12
            },
            "rightCorner": {
              "x": 13.76,
              "y": 6.472,
              "z": 0.12
            },
            "gtin": "4337185459740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8ee",
            "leftCorner": {
              "x": 13.76,
              "y": 6.472,
              "z": 0.12
            },
            "rightCorner": {
              "x": 14.151,
              "y": 6.44,
              "z": 0.12
            },
            "gtin": "4337185459740",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546243",
        "height": 0.64777,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d7ff",
            "leftCorner": {
              "x": 12.918,
              "y": 6.531,
              "z": 0.53
            },
            "rightCorner": {
              "x": 13.066,
              "y": 6.519,
              "z": 0.53
            },
            "gtin": "5410673004406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d800",
            "leftCorner": {
              "x": 13.066,
              "y": 6.519,
              "z": 0.53
            },
            "rightCorner": {
              "x": 13.215,
              "y": 6.506,
              "z": 0.53
            },
            "gtin": "5410673004406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d801",
            "leftCorner": {
              "x": 13.215,
              "y": 6.516,
              "z": 0.53
            },
            "rightCorner": {
              "x": 13.308,
              "y": 6.509,
              "z": 0.53
            },
            "gtin": "5410673004277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d802",
            "leftCorner": {
              "x": 13.308,
              "y": 6.509,
              "z": 0.53
            },
            "rightCorner": {
              "x": 13.4,
              "y": 6.501,
              "z": 0.53
            },
            "gtin": "5410673004277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d803",
            "leftCorner": {
              "x": 13.399,
              "y": 6.488,
              "z": 0.53
            },
            "rightCorner": {
              "x": 13.614,
              "y": 6.471,
              "z": 0.53
            },
            "gtin": "5410673004635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d804",
            "leftCorner": {
              "x": 13.614,
              "y": 6.471,
              "z": 0.53
            },
            "rightCorner": {
              "x": 13.829,
              "y": 6.453,
              "z": 0.53
            },
            "gtin": "5410673004635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d805",
            "leftCorner": {
              "x": 13.829,
              "y": 6.459,
              "z": 0.53
            },
            "rightCorner": {
              "x": 13.905,
              "y": 6.453,
              "z": 0.53
            },
            "gtin": "5410673004437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d806",
            "leftCorner": {
              "x": 13.905,
              "y": 6.453,
              "z": 0.53
            },
            "rightCorner": {
              "x": 13.982,
              "y": 6.447,
              "z": 0.53
            },
            "gtin": "5410673004437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d807",
            "leftCorner": {
              "x": 13.982,
              "y": 6.447,
              "z": 0.53
            },
            "rightCorner": {
              "x": 14.058,
              "y": 6.441,
              "z": 0.53
            },
            "gtin": "5410673004437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d808",
            "leftCorner": {
              "x": 14.058,
              "y": 6.441,
              "z": 0.53
            },
            "rightCorner": {
              "x": 14.134,
              "y": 6.434,
              "z": 0.53
            },
            "gtin": "5410673004437",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546244",
        "height": 0.95907,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d77e",
            "leftCorner": {
              "x": 12.958,
              "y": 6.527,
              "z": 0.785
            },
            "rightCorner": {
              "x": 13.078,
              "y": 6.517,
              "z": 0.785
            },
            "gtin": "4006237642637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d77f",
            "leftCorner": {
              "x": 13.078,
              "y": 6.515,
              "z": 0.785
            },
            "rightCorner": {
              "x": 13.208,
              "y": 6.504,
              "z": 0.785
            },
            "gtin": "4006237642903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d780",
            "leftCorner": {
              "x": 13.208,
              "y": 6.509,
              "z": 0.785
            },
            "rightCorner": {
              "x": 13.313,
              "y": 6.5,
              "z": 0.785
            },
            "gtin": "4006237642897",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d781",
            "leftCorner": {
              "x": 13.312,
              "y": 6.483,
              "z": 0.785
            },
            "rightCorner": {
              "x": 13.387,
              "y": 6.477,
              "z": 0.785
            },
            "gtin": "4006237642880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d782",
            "leftCorner": {
              "x": 13.387,
              "y": 6.477,
              "z": 0.785
            },
            "rightCorner": {
              "x": 13.462,
              "y": 6.471,
              "z": 0.785
            },
            "gtin": "4006237642880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d783",
            "leftCorner": {
              "x": 13.462,
              "y": 6.473,
              "z": 0.785
            },
            "rightCorner": {
              "x": 13.614,
              "y": 6.461,
              "z": 0.785
            },
            "gtin": "4006237642118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d784",
            "leftCorner": {
              "x": 13.614,
              "y": 6.465,
              "z": 0.785
            },
            "rightCorner": {
              "x": 13.735,
              "y": 6.455,
              "z": 0.785
            },
            "gtin": "4006237642125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d785",
            "leftCorner": {
              "x": 13.735,
              "y": 6.455,
              "z": 0.785
            },
            "rightCorner": {
              "x": 13.855,
              "y": 6.445,
              "z": 0.785
            },
            "gtin": "4006237642125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d786",
            "leftCorner": {
              "x": 13.856,
              "y": 6.447,
              "z": 0.785
            },
            "rightCorner": {
              "x": 14.02,
              "y": 6.434,
              "z": 0.785
            },
            "gtin": "4006237642552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d787",
            "leftCorner": {
              "x": 14.02,
              "y": 6.437,
              "z": 0.785
            },
            "rightCorner": {
              "x": 14.135,
              "y": 6.428,
              "z": 0.785
            },
            "gtin": "3487400006363",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546245",
        "height": 1.2006,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d7c4",
            "leftCorner": {
              "x": 12.897,
              "y": 6.522,
              "z": 0.982
            },
            "rightCorner": {
              "x": 13.038,
              "y": 6.51,
              "z": 0.982
            },
            "gtin": "3487400005342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7c5",
            "leftCorner": {
              "x": 13.037,
              "y": 6.506,
              "z": 0.982
            },
            "rightCorner": {
              "x": 13.113,
              "y": 6.5,
              "z": 0.982
            },
            "gtin": "3487400005083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7c6",
            "leftCorner": {
              "x": 13.113,
              "y": 6.5,
              "z": 0.982
            },
            "rightCorner": {
              "x": 13.189,
              "y": 6.494,
              "z": 0.982
            },
            "gtin": "3487400005083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7c7",
            "leftCorner": {
              "x": 13.19,
              "y": 6.509,
              "z": 0.982
            },
            "rightCorner": {
              "x": 13.278,
              "y": 6.502,
              "z": 0.982
            },
            "gtin": "5010034014749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7c8",
            "leftCorner": {
              "x": 13.278,
              "y": 6.5,
              "z": 0.982
            },
            "rightCorner": {
              "x": 13.451,
              "y": 6.485,
              "z": 0.982
            },
            "gtin": "5010034014756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7c9",
            "leftCorner": {
              "x": 13.45,
              "y": 6.478,
              "z": 0.982
            },
            "rightCorner": {
              "x": 13.521,
              "y": 6.472,
              "z": 0.982
            },
            "gtin": "3487400006370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7ca",
            "leftCorner": {
              "x": 13.521,
              "y": 6.472,
              "z": 0.982
            },
            "rightCorner": {
              "x": 13.593,
              "y": 6.467,
              "z": 0.982
            },
            "gtin": "3487400006370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7cb",
            "leftCorner": {
              "x": 13.593,
              "y": 6.464,
              "z": 0.982
            },
            "rightCorner": {
              "x": 13.69,
              "y": 6.456,
              "z": 0.982
            },
            "gtin": "3487400006332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7cc",
            "leftCorner": {
              "x": 13.69,
              "y": 6.463,
              "z": 0.982
            },
            "rightCorner": {
              "x": 13.785,
              "y": 6.455,
              "z": 0.982
            },
            "gtin": "3487400006325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7cd",
            "leftCorner": {
              "x": 13.785,
              "y": 6.455,
              "z": 0.982
            },
            "rightCorner": {
              "x": 13.879,
              "y": 6.447,
              "z": 0.982
            },
            "gtin": "3487400006325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7ce",
            "leftCorner": {
              "x": 13.879,
              "y": 6.458,
              "z": 0.982
            },
            "rightCorner": {
              "x": 13.988,
              "y": 6.449,
              "z": 0.982
            },
            "gtin": "5010034011946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7cf",
            "leftCorner": {
              "x": 13.987,
              "y": 6.437,
              "z": 0.982
            },
            "rightCorner": {
              "x": 14.091,
              "y": 6.429,
              "z": 0.982
            },
            "gtin": "3487400006387",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546246",
        "height": 1.4553,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d8b6",
            "leftCorner": {
              "x": 13.001,
              "y": 6.52,
              "z": 1.191
            },
            "rightCorner": {
              "x": 13.225,
              "y": 6.502,
              "z": 1.191
            },
            "gtin": "3487400006394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8b7",
            "leftCorner": {
              "x": 13.225,
              "y": 6.501,
              "z": 1.191
            },
            "rightCorner": {
              "x": 13.367,
              "y": 6.489,
              "z": 1.191
            },
            "gtin": "5010034015982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8b8",
            "leftCorner": {
              "x": 13.367,
              "y": 6.489,
              "z": 1.191
            },
            "rightCorner": {
              "x": 13.51,
              "y": 6.478,
              "z": 1.191
            },
            "gtin": "5010034015982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8b9",
            "leftCorner": {
              "x": 13.51,
              "y": 6.478,
              "z": 1.191
            },
            "rightCorner": {
              "x": 13.594,
              "y": 6.471,
              "z": 1.191
            },
            "gtin": "3487400006400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8ba",
            "leftCorner": {
              "x": 13.594,
              "y": 6.471,
              "z": 1.191
            },
            "rightCorner": {
              "x": 13.677,
              "y": 6.464,
              "z": 1.191
            },
            "gtin": "3487400006400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8bb",
            "leftCorner": {
              "x": 13.677,
              "y": 6.464,
              "z": 1.191
            },
            "rightCorner": {
              "x": 13.761,
              "y": 6.457,
              "z": 1.191
            },
            "gtin": "3487400006400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8bc",
            "leftCorner": {
              "x": 13.761,
              "y": 6.457,
              "z": 1.191
            },
            "rightCorner": {
              "x": 13.846,
              "y": 6.45,
              "z": 1.191
            },
            "gtin": "3487400006400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8bd",
            "leftCorner": {
              "x": 13.846,
              "y": 6.456,
              "z": 1.191
            },
            "rightCorner": {
              "x": 13.943,
              "y": 6.448,
              "z": 1.191
            },
            "gtin": "5010034016323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8be",
            "leftCorner": {
              "x": 13.943,
              "y": 6.448,
              "z": 1.191
            },
            "rightCorner": {
              "x": 14.039,
              "y": 6.44,
              "z": 1.191
            },
            "gtin": "5010034016323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8bf",
            "leftCorner": {
              "x": 14.039,
              "y": 6.44,
              "z": 1.191
            },
            "rightCorner": {
              "x": 14.136,
              "y": 6.432,
              "z": 1.191
            },
            "gtin": "5010034016323",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546242",
        "height": 1.7061,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d861",
            "leftCorner": {
              "x": 12.936,
              "y": 6.517,
              "z": 1.396
            },
            "rightCorner": {
              "x": 13.027,
              "y": 6.509,
              "z": 1.396
            },
            "gtin": "5010034012004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d862",
            "leftCorner": {
              "x": 13.027,
              "y": 6.509,
              "z": 1.396
            },
            "rightCorner": {
              "x": 13.116,
              "y": 6.502,
              "z": 1.396
            },
            "gtin": "5010034012004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d863",
            "leftCorner": {
              "x": 13.116,
              "y": 6.502,
              "z": 1.396
            },
            "rightCorner": {
              "x": 13.207,
              "y": 6.494,
              "z": 1.396
            },
            "gtin": "5010034012004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d864",
            "leftCorner": {
              "x": 13.209,
              "y": 6.507,
              "z": 1.396
            },
            "rightCorner": {
              "x": 13.34,
              "y": 6.497,
              "z": 1.396
            },
            "gtin": "3487400006318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d865",
            "leftCorner": {
              "x": 13.339,
              "y": 6.492,
              "z": 1.396
            },
            "rightCorner": {
              "x": 13.431,
              "y": 6.485,
              "z": 1.396
            },
            "gtin": "3487400006356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d866",
            "leftCorner": {
              "x": 13.431,
              "y": 6.485,
              "z": 1.396
            },
            "rightCorner": {
              "x": 13.523,
              "y": 6.477,
              "z": 1.396
            },
            "gtin": "3487400006356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d867",
            "leftCorner": {
              "x": 13.523,
              "y": 6.477,
              "z": 1.396
            },
            "rightCorner": {
              "x": 13.615,
              "y": 6.47,
              "z": 1.396
            },
            "gtin": "3487400006356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d868",
            "leftCorner": {
              "x": 13.615,
              "y": 6.468,
              "z": 1.396
            },
            "rightCorner": {
              "x": 13.87,
              "y": 6.447,
              "z": 1.396
            },
            "gtin": "3487400006349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d869",
            "leftCorner": {
              "x": 13.87,
              "y": 6.449,
              "z": 1.396
            },
            "rightCorner": {
              "x": 13.956,
              "y": 6.442,
              "z": 1.396
            },
            "gtin": "5010034015180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d86a",
            "leftCorner": {
              "x": 13.956,
              "y": 6.442,
              "z": 1.396
            },
            "rightCorner": {
              "x": 14.042,
              "y": 6.435,
              "z": 1.396
            },
            "gtin": "5010034015180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d86b",
            "leftCorner": {
              "x": 14.042,
              "y": 6.435,
              "z": 1.396
            },
            "rightCorner": {
              "x": 14.128,
              "y": 6.428,
              "z": 1.396
            },
            "gtin": "5010034015180",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f79",
    "rightNeighborShelfId": "b6f7d"
  },
  {
    "id": "b6f7b",
    "name": "b6f7b",
    "x": 17.902,
    "y": 7.196,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99916,
      "w": 0.040899
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 7
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5461ae",
        "height": 0.15048,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d4aa",
            "leftCorner": {
              "x": 17.804,
              "y": 7.142,
              "z": 0.123
            },
            "rightCorner": {
              "x": 17.249,
              "y": 7.188,
              "z": 0.123
            },
            "gtin": "4013159604896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4ab",
            "leftCorner": {
              "x": 17.249,
              "y": 7.188,
              "z": 0.123
            },
            "rightCorner": {
              "x": 16.695,
              "y": 7.233,
              "z": 0.123
            },
            "gtin": "4013159604896",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461af",
        "height": 0.54849,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d48e",
            "leftCorner": {
              "x": 16.907,
              "y": 7.219,
              "z": 0.449
            },
            "rightCorner": {
              "x": 16.444,
              "y": 7.257,
              "z": 0.449
            },
            "gtin": "4300175035101",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461ac",
        "height": 0.95868,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d3fc",
            "leftCorner": {
              "x": 17.805,
              "y": 7.147,
              "z": 0.784
            },
            "rightCorner": {
              "x": 17.21,
              "y": 7.196,
              "z": 0.784
            },
            "gtin": "4337185619762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3fd",
            "leftCorner": {
              "x": 17.21,
              "y": 7.196,
              "z": 0.784
            },
            "rightCorner": {
              "x": 16.615,
              "y": 7.245,
              "z": 0.784
            },
            "gtin": "4337185619762",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461ab",
        "height": 1.3543,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d4ca",
            "leftCorner": {
              "x": 17.879,
              "y": 7.143,
              "z": 1.108
            },
            "rightCorner": {
              "x": 16.691,
              "y": 7.24,
              "z": 1.108
            },
            "gtin": "4337185619724",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461ad",
        "height": 1.706,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d415",
            "leftCorner": {
              "x": 17.76,
              "y": 7.154,
              "z": 1.396
            },
            "rightCorner": {
              "x": 16.657,
              "y": 7.245,
              "z": 1.396
            },
            "gtin": "4063367090936",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d1382",
    "rightNeighborShelfId": "b6f7c"
  },
  {
    "id": "b6f7c",
    "name": "b6f7c",
    "x": 16.706,
    "y": 7.294,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99916,
      "w": 0.040899
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 28
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546265",
        "height": 0.14913,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a546266",
        "height": 0.54779,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d48f",
            "leftCorner": {
              "x": 16.444,
              "y": 7.258,
              "z": 0.448
            },
            "rightCorner": {
              "x": 16.195,
              "y": 7.278,
              "z": 0.448
            },
            "gtin": "4337185702075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d490",
            "leftCorner": {
              "x": 16.194,
              "y": 7.266,
              "z": 0.448
            },
            "rightCorner": {
              "x": 15.991,
              "y": 7.283,
              "z": 0.448
            },
            "gtin": "4337185702044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d491",
            "leftCorner": {
              "x": 15.991,
              "y": 7.284,
              "z": 0.448
            },
            "rightCorner": {
              "x": 15.779,
              "y": 7.301,
              "z": 0.448
            },
            "gtin": "4006196029302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d492",
            "leftCorner": {
              "x": 15.779,
              "y": 7.301,
              "z": 0.448
            },
            "rightCorner": {
              "x": 15.567,
              "y": 7.319,
              "z": 0.448
            },
            "gtin": "4006196029302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d493",
            "leftCorner": {
              "x": 15.567,
              "y": 7.319,
              "z": 0.448
            },
            "rightCorner": {
              "x": 15.354,
              "y": 7.336,
              "z": 0.448
            },
            "gtin": "4006196029302",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546262",
        "height": 0.94947,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d3fe",
            "leftCorner": {
              "x": 16.615,
              "y": 7.246,
              "z": 0.777
            },
            "rightCorner": {
              "x": 16.04,
              "y": 7.293,
              "z": 0.777
            },
            "gtin": "4337185619762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3ff",
            "leftCorner": {
              "x": 16.04,
              "y": 7.293,
              "z": 0.777
            },
            "rightCorner": {
              "x": 15.465,
              "y": 7.34,
              "z": 0.777
            },
            "gtin": "4337185619762",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546263",
        "height": 1.3547,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d4cb",
            "leftCorner": {
              "x": 16.692,
              "y": 7.247,
              "z": 1.108
            },
            "rightCorner": {
              "x": 16.562,
              "y": 7.258,
              "z": 1.108
            },
            "gtin": "4337185663178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4cc",
            "leftCorner": {
              "x": 16.562,
              "y": 7.258,
              "z": 1.108
            },
            "rightCorner": {
              "x": 16.432,
              "y": 7.268,
              "z": 1.108
            },
            "gtin": "4337185663178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4cd",
            "leftCorner": {
              "x": 16.432,
              "y": 7.268,
              "z": 1.108
            },
            "rightCorner": {
              "x": 16.303,
              "y": 7.279,
              "z": 1.108
            },
            "gtin": "4337185663178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4ce",
            "leftCorner": {
              "x": 16.303,
              "y": 7.282,
              "z": 1.108
            },
            "rightCorner": {
              "x": 16.185,
              "y": 7.292,
              "z": 1.108
            },
            "gtin": "4337185662898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4cf",
            "leftCorner": {
              "x": 16.184,
              "y": 7.281,
              "z": 1.108
            },
            "rightCorner": {
              "x": 15.814,
              "y": 7.311,
              "z": 1.108
            },
            "gtin": "4001120198208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4d0",
            "leftCorner": {
              "x": 15.814,
              "y": 7.311,
              "z": 1.108
            },
            "rightCorner": {
              "x": 15.444,
              "y": 7.342,
              "z": 1.108
            },
            "gtin": "4001120198208",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546264",
        "height": 1.7048,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d416",
            "leftCorner": {
              "x": 16.659,
              "y": 7.261,
              "z": 1.395
            },
            "rightCorner": {
              "x": 16.595,
              "y": 7.266,
              "z": 1.395
            },
            "gtin": "4337185663116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d417",
            "leftCorner": {
              "x": 16.595,
              "y": 7.266,
              "z": 1.395
            },
            "rightCorner": {
              "x": 16.531,
              "y": 7.272,
              "z": 1.395
            },
            "gtin": "4337185663116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d418",
            "leftCorner": {
              "x": 16.531,
              "y": 7.272,
              "z": 1.395
            },
            "rightCorner": {
              "x": 16.467,
              "y": 7.277,
              "z": 1.395
            },
            "gtin": "4337185663116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d419",
            "leftCorner": {
              "x": 16.467,
              "y": 7.271,
              "z": 1.395
            },
            "rightCorner": {
              "x": 16.372,
              "y": 7.278,
              "z": 1.395
            },
            "gtin": "4337185663093",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d41a",
            "leftCorner": {
              "x": 16.372,
              "y": 7.278,
              "z": 1.395
            },
            "rightCorner": {
              "x": 16.277,
              "y": 7.286,
              "z": 1.395
            },
            "gtin": "4337185663093",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d41b",
            "leftCorner": {
              "x": 16.277,
              "y": 7.286,
              "z": 1.395
            },
            "rightCorner": {
              "x": 16.183,
              "y": 7.294,
              "z": 1.395
            },
            "gtin": "4337185663093",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d41c",
            "leftCorner": {
              "x": 16.183,
              "y": 7.295,
              "z": 1.395
            },
            "rightCorner": {
              "x": 16.049,
              "y": 7.305,
              "z": 1.395
            },
            "gtin": "4337185663055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d41d",
            "leftCorner": {
              "x": 16.049,
              "y": 7.305,
              "z": 1.395
            },
            "rightCorner": {
              "x": 15.916,
              "y": 7.316,
              "z": 1.395
            },
            "gtin": "4337185663055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d41e",
            "leftCorner": {
              "x": 15.916,
              "y": 7.32,
              "z": 1.395
            },
            "rightCorner": {
              "x": 15.861,
              "y": 7.324,
              "z": 1.395
            },
            "gtin": "4337185663024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d41f",
            "leftCorner": {
              "x": 15.861,
              "y": 7.324,
              "z": 1.395
            },
            "rightCorner": {
              "x": 15.806,
              "y": 7.329,
              "z": 1.395
            },
            "gtin": "4337185663024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d420",
            "leftCorner": {
              "x": 15.806,
              "y": 7.329,
              "z": 1.395
            },
            "rightCorner": {
              "x": 15.75,
              "y": 7.333,
              "z": 1.395
            },
            "gtin": "4337185663024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d421",
            "leftCorner": {
              "x": 15.75,
              "y": 7.333,
              "z": 1.395
            },
            "rightCorner": {
              "x": 15.696,
              "y": 7.338,
              "z": 1.395
            },
            "gtin": "4337185663024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d422",
            "leftCorner": {
              "x": 15.696,
              "y": 7.338,
              "z": 1.395
            },
            "rightCorner": {
              "x": 15.623,
              "y": 7.344,
              "z": 1.395
            },
            "gtin": "4337185662973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d423",
            "leftCorner": {
              "x": 15.623,
              "y": 7.344,
              "z": 1.395
            },
            "rightCorner": {
              "x": 15.55,
              "y": 7.35,
              "z": 1.395
            },
            "gtin": "4337185662973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d424",
            "leftCorner": {
              "x": 15.55,
              "y": 7.35,
              "z": 1.395
            },
            "rightCorner": {
              "x": 15.476,
              "y": 7.356,
              "z": 1.395
            },
            "gtin": "4337185662973",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f7b",
    "rightNeighborShelfId": "b6f81"
  },
  {
    "id": "b6f7d",
    "name": "b6f7d",
    "x": 14.091,
    "y": 6.384,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.040786,
      "w": 0.99917
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 71
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546200",
        "height": 0.14743,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d8ef",
            "leftCorner": {
              "x": 14.15,
              "y": 6.439,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.354,
              "y": 6.422,
              "z": 0.121
            },
            "gtin": "4300175167437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8f0",
            "leftCorner": {
              "x": 14.354,
              "y": 6.422,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.556,
              "y": 6.406,
              "z": 0.121
            },
            "gtin": "4300175167437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8f1",
            "leftCorner": {
              "x": 14.556,
              "y": 6.406,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.759,
              "y": 6.389,
              "z": 0.121
            },
            "gtin": "4300175167437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8e3",
            "leftCorner": {
              "x": 14.759,
              "y": 6.387,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.936,
              "y": 6.373,
              "z": 0.121
            },
            "gtin": "4063367137136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8e4",
            "leftCorner": {
              "x": 14.936,
              "y": 6.373,
              "z": 0.121
            },
            "rightCorner": {
              "x": 15.114,
              "y": 6.358,
              "z": 0.121
            },
            "gtin": "4063367137136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8e5",
            "leftCorner": {
              "x": 15.114,
              "y": 6.358,
              "z": 0.121
            },
            "rightCorner": {
              "x": 15.291,
              "y": 6.344,
              "z": 0.121
            },
            "gtin": "4063367137136",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461fd",
        "height": 0.65311,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d809",
            "leftCorner": {
              "x": 14.134,
              "y": 6.438,
              "z": 0.534
            },
            "rightCorner": {
              "x": 14.231,
              "y": 6.43,
              "z": 0.534
            },
            "gtin": "4063367006210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d80a",
            "leftCorner": {
              "x": 14.231,
              "y": 6.43,
              "z": 0.534
            },
            "rightCorner": {
              "x": 14.327,
              "y": 6.422,
              "z": 0.534
            },
            "gtin": "4063367006210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d80b",
            "leftCorner": {
              "x": 14.327,
              "y": 6.42,
              "z": 0.534
            },
            "rightCorner": {
              "x": 14.401,
              "y": 6.414,
              "z": 0.534
            },
            "gtin": "4063367379505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d80c",
            "leftCorner": {
              "x": 14.401,
              "y": 6.414,
              "z": 0.534
            },
            "rightCorner": {
              "x": 14.476,
              "y": 6.408,
              "z": 0.534
            },
            "gtin": "4063367379505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d80d",
            "leftCorner": {
              "x": 14.476,
              "y": 6.408,
              "z": 0.534
            },
            "rightCorner": {
              "x": 14.55,
              "y": 6.402,
              "z": 0.534
            },
            "gtin": "4063367379505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d80e",
            "leftCorner": {
              "x": 14.55,
              "y": 6.402,
              "z": 0.534
            },
            "rightCorner": {
              "x": 14.624,
              "y": 6.395,
              "z": 0.534
            },
            "gtin": "4063367379505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d80f",
            "leftCorner": {
              "x": 14.624,
              "y": 6.397,
              "z": 0.534
            },
            "rightCorner": {
              "x": 14.717,
              "y": 6.389,
              "z": 0.534
            },
            "gtin": "4337185654039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d810",
            "leftCorner": {
              "x": 14.717,
              "y": 6.389,
              "z": 0.534
            },
            "rightCorner": {
              "x": 14.81,
              "y": 6.382,
              "z": 0.534
            },
            "gtin": "4337185654039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d811",
            "leftCorner": {
              "x": 14.81,
              "y": 6.383,
              "z": 0.534
            },
            "rightCorner": {
              "x": 14.877,
              "y": 6.378,
              "z": 0.534
            },
            "gtin": "4063367137174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d812",
            "leftCorner": {
              "x": 14.877,
              "y": 6.378,
              "z": 0.534
            },
            "rightCorner": {
              "x": 14.943,
              "y": 6.372,
              "z": 0.534
            },
            "gtin": "4063367137174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d813",
            "leftCorner": {
              "x": 14.943,
              "y": 6.372,
              "z": 0.534
            },
            "rightCorner": {
              "x": 15.01,
              "y": 6.367,
              "z": 0.534
            },
            "gtin": "4063367137174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d814",
            "leftCorner": {
              "x": 15.011,
              "y": 6.373,
              "z": 0.534
            },
            "rightCorner": {
              "x": 15.162,
              "y": 6.361,
              "z": 0.534
            },
            "gtin": "8719632250951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d815",
            "leftCorner": {
              "x": 15.162,
              "y": 6.361,
              "z": 0.534
            },
            "rightCorner": {
              "x": 15.238,
              "y": 6.354,
              "z": 0.534
            },
            "gtin": "4019339239100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d816",
            "leftCorner": {
              "x": 15.238,
              "y": 6.354,
              "z": 0.534
            },
            "rightCorner": {
              "x": 15.313,
              "y": 6.348,
              "z": 0.534
            },
            "gtin": "4019339239100",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461fb",
        "height": 0.95269,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d788",
            "leftCorner": {
              "x": 14.135,
              "y": 6.436,
              "z": 0.779
            },
            "rightCorner": {
              "x": 14.291,
              "y": 6.423,
              "z": 0.779
            },
            "gtin": "3487400006394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d789",
            "leftCorner": {
              "x": 14.291,
              "y": 6.414,
              "z": 0.779
            },
            "rightCorner": {
              "x": 14.374,
              "y": 6.408,
              "z": 0.779
            },
            "gtin": "4045178011645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d78a",
            "leftCorner": {
              "x": 14.374,
              "y": 6.408,
              "z": 0.779
            },
            "rightCorner": {
              "x": 14.455,
              "y": 6.401,
              "z": 0.779
            },
            "gtin": "4045178011645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d78b",
            "leftCorner": {
              "x": 14.455,
              "y": 6.401,
              "z": 0.779
            },
            "rightCorner": {
              "x": 14.538,
              "y": 6.394,
              "z": 0.779
            },
            "gtin": "4045178011645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d78c",
            "leftCorner": {
              "x": 14.538,
              "y": 6.394,
              "z": 0.779
            },
            "rightCorner": {
              "x": 14.621,
              "y": 6.387,
              "z": 0.779
            },
            "gtin": "4045178011645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d78d",
            "leftCorner": {
              "x": 14.621,
              "y": 6.396,
              "z": 0.779
            },
            "rightCorner": {
              "x": 14.676,
              "y": 6.392,
              "z": 0.779
            },
            "gtin": "4019339235041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d78e",
            "leftCorner": {
              "x": 14.676,
              "y": 6.392,
              "z": 0.779
            },
            "rightCorner": {
              "x": 14.732,
              "y": 6.387,
              "z": 0.779
            },
            "gtin": "4019339235041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d78f",
            "leftCorner": {
              "x": 14.732,
              "y": 6.387,
              "z": 0.779
            },
            "rightCorner": {
              "x": 14.787,
              "y": 6.382,
              "z": 0.779
            },
            "gtin": "4019339235041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d790",
            "leftCorner": {
              "x": 14.787,
              "y": 6.38,
              "z": 0.779
            },
            "rightCorner": {
              "x": 14.855,
              "y": 6.375,
              "z": 0.779
            },
            "gtin": "8719632250883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d791",
            "leftCorner": {
              "x": 14.855,
              "y": 6.375,
              "z": 0.779
            },
            "rightCorner": {
              "x": 14.925,
              "y": 6.369,
              "z": 0.779
            },
            "gtin": "8719632250883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d792",
            "leftCorner": {
              "x": 14.925,
              "y": 6.369,
              "z": 0.779
            },
            "rightCorner": {
              "x": 14.994,
              "y": 6.363,
              "z": 0.779
            },
            "gtin": "8719632250883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d793",
            "leftCorner": {
              "x": 14.994,
              "y": 6.36,
              "z": 0.779
            },
            "rightCorner": {
              "x": 15.068,
              "y": 6.354,
              "z": 0.779
            },
            "gtin": "4019339220108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d794",
            "leftCorner": {
              "x": 15.068,
              "y": 6.354,
              "z": 0.779
            },
            "rightCorner": {
              "x": 15.144,
              "y": 6.348,
              "z": 0.779
            },
            "gtin": "4019339220108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d795",
            "leftCorner": {
              "x": 15.146,
              "y": 6.373,
              "z": 0.779
            },
            "rightCorner": {
              "x": 15.217,
              "y": 6.367,
              "z": 0.779
            },
            "gtin": "4019339233108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d796",
            "leftCorner": {
              "x": 15.217,
              "y": 6.367,
              "z": 0.779
            },
            "rightCorner": {
              "x": 15.289,
              "y": 6.361,
              "z": 0.779
            },
            "gtin": "4019339233108",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461fc",
        "height": 1.2021,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d7d0",
            "leftCorner": {
              "x": 14.092,
              "y": 6.434,
              "z": 0.984
            },
            "rightCorner": {
              "x": 14.167,
              "y": 6.427,
              "z": 0.984
            },
            "gtin": "4337185738524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7d1",
            "leftCorner": {
              "x": 14.167,
              "y": 6.427,
              "z": 0.984
            },
            "rightCorner": {
              "x": 14.243,
              "y": 6.421,
              "z": 0.984
            },
            "gtin": "4337185738524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7d2",
            "leftCorner": {
              "x": 14.243,
              "y": 6.421,
              "z": 0.984
            },
            "rightCorner": {
              "x": 14.319,
              "y": 6.415,
              "z": 0.984
            },
            "gtin": "4337185738524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7d3",
            "leftCorner": {
              "x": 14.319,
              "y": 6.415,
              "z": 0.984
            },
            "rightCorner": {
              "x": 14.395,
              "y": 6.409,
              "z": 0.984
            },
            "gtin": "4337185738524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7d4",
            "leftCorner": {
              "x": 14.394,
              "y": 6.401,
              "z": 0.984
            },
            "rightCorner": {
              "x": 14.657,
              "y": 6.379,
              "z": 0.984
            },
            "gtin": "8053630850004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7d5",
            "leftCorner": {
              "x": 14.658,
              "y": 6.386,
              "z": 0.984
            },
            "rightCorner": {
              "x": 14.814,
              "y": 6.374,
              "z": 0.984
            },
            "gtin": "4337185834820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7d6",
            "leftCorner": {
              "x": 14.814,
              "y": 6.374,
              "z": 0.984
            },
            "rightCorner": {
              "x": 14.972,
              "y": 6.361,
              "z": 0.984
            },
            "gtin": "4063367379475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7d7",
            "leftCorner": {
              "x": 14.972,
              "y": 6.365,
              "z": 0.984
            },
            "rightCorner": {
              "x": 15.065,
              "y": 6.357,
              "z": 0.984
            },
            "gtin": "4260380788936",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7d8",
            "leftCorner": {
              "x": 15.065,
              "y": 6.357,
              "z": 0.984
            },
            "rightCorner": {
              "x": 15.156,
              "y": 6.35,
              "z": 0.984
            },
            "gtin": "4260380788936",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7d9",
            "leftCorner": {
              "x": 15.156,
              "y": 6.349,
              "z": 0.984
            },
            "rightCorner": {
              "x": 15.214,
              "y": 6.344,
              "z": 0.984
            },
            "gtin": "4337185770920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7da",
            "leftCorner": {
              "x": 15.214,
              "y": 6.344,
              "z": 0.984
            },
            "rightCorner": {
              "x": 15.272,
              "y": 6.339,
              "z": 0.984
            },
            "gtin": "4337185770920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7db",
            "leftCorner": {
              "x": 15.272,
              "y": 6.339,
              "z": 0.984
            },
            "rightCorner": {
              "x": 15.33,
              "y": 6.335,
              "z": 0.984
            },
            "gtin": "4337185770920",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461ff",
        "height": 1.4564,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d8c0",
            "leftCorner": {
              "x": 14.135,
              "y": 6.428,
              "z": 1.192
            },
            "rightCorner": {
              "x": 14.205,
              "y": 6.423,
              "z": 1.192
            },
            "gtin": "4000286004644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8c1",
            "leftCorner": {
              "x": 14.205,
              "y": 6.423,
              "z": 1.192
            },
            "rightCorner": {
              "x": 14.274,
              "y": 6.417,
              "z": 1.192
            },
            "gtin": "4000286004644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8c2",
            "leftCorner": {
              "x": 14.274,
              "y": 6.414,
              "z": 1.192
            },
            "rightCorner": {
              "x": 14.393,
              "y": 6.404,
              "z": 1.192
            },
            "gtin": "4000286004682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8c3",
            "leftCorner": {
              "x": 14.394,
              "y": 6.409,
              "z": 1.192
            },
            "rightCorner": {
              "x": 14.462,
              "y": 6.403,
              "z": 1.192
            },
            "gtin": "4000286004705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8c4",
            "leftCorner": {
              "x": 14.462,
              "y": 6.403,
              "z": 1.192
            },
            "rightCorner": {
              "x": 14.531,
              "y": 6.398,
              "z": 1.192
            },
            "gtin": "4000286004705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8c5",
            "leftCorner": {
              "x": 14.531,
              "y": 6.398,
              "z": 1.192
            },
            "rightCorner": {
              "x": 14.6,
              "y": 6.392,
              "z": 1.192
            },
            "gtin": "4000286004705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8c6",
            "leftCorner": {
              "x": 14.6,
              "y": 6.391,
              "z": 1.192
            },
            "rightCorner": {
              "x": 14.676,
              "y": 6.385,
              "z": 1.192
            },
            "gtin": "4000286004743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8c7",
            "leftCorner": {
              "x": 14.676,
              "y": 6.385,
              "z": 1.192
            },
            "rightCorner": {
              "x": 14.752,
              "y": 6.378,
              "z": 1.192
            },
            "gtin": "4000286004743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8c8",
            "leftCorner": {
              "x": 14.753,
              "y": 6.384,
              "z": 1.192
            },
            "rightCorner": {
              "x": 14.846,
              "y": 6.377,
              "z": 1.192
            },
            "gtin": "4000286004729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8c9",
            "leftCorner": {
              "x": 14.846,
              "y": 6.377,
              "z": 1.192
            },
            "rightCorner": {
              "x": 14.939,
              "y": 6.369,
              "z": 1.192
            },
            "gtin": "4000286004729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8ca",
            "leftCorner": {
              "x": 14.939,
              "y": 6.368,
              "z": 1.192
            },
            "rightCorner": {
              "x": 15.032,
              "y": 6.36,
              "z": 1.192
            },
            "gtin": "4058700541503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8cb",
            "leftCorner": {
              "x": 15.032,
              "y": 6.36,
              "z": 1.192
            },
            "rightCorner": {
              "x": 15.123,
              "y": 6.352,
              "z": 1.192
            },
            "gtin": "4058700541503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8cc",
            "leftCorner": {
              "x": 15.123,
              "y": 6.339,
              "z": 1.192
            },
            "rightCorner": {
              "x": 15.205,
              "y": 6.332,
              "z": 1.192
            },
            "gtin": "5902481054471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8cd",
            "leftCorner": {
              "x": 15.205,
              "y": 6.332,
              "z": 1.192
            },
            "rightCorner": {
              "x": 15.288,
              "y": 6.326,
              "z": 1.192
            },
            "gtin": "5902481054471",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461fe",
        "height": 1.704,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d86c",
            "leftCorner": {
              "x": 14.129,
              "y": 6.435,
              "z": 1.394
            },
            "rightCorner": {
              "x": 14.234,
              "y": 6.426,
              "z": 1.394
            },
            "gtin": "8719632250913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d86d",
            "leftCorner": {
              "x": 14.234,
              "y": 6.426,
              "z": 1.394
            },
            "rightCorner": {
              "x": 14.34,
              "y": 6.418,
              "z": 1.394
            },
            "gtin": "8719632250913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d86e",
            "leftCorner": {
              "x": 14.34,
              "y": 6.418,
              "z": 1.394
            },
            "rightCorner": {
              "x": 14.446,
              "y": 6.409,
              "z": 1.394
            },
            "gtin": "8719632250913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d86f",
            "leftCorner": {
              "x": 14.445,
              "y": 6.4,
              "z": 1.394
            },
            "rightCorner": {
              "x": 14.591,
              "y": 6.389,
              "z": 1.394
            },
            "gtin": "8719632250906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d870",
            "leftCorner": {
              "x": 14.591,
              "y": 6.389,
              "z": 1.394
            },
            "rightCorner": {
              "x": 14.735,
              "y": 6.377,
              "z": 1.394
            },
            "gtin": "8719632250906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d871",
            "leftCorner": {
              "x": 14.736,
              "y": 6.382,
              "z": 1.394
            },
            "rightCorner": {
              "x": 14.829,
              "y": 6.374,
              "z": 1.394
            },
            "gtin": "4000286004620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d872",
            "leftCorner": {
              "x": 14.829,
              "y": 6.374,
              "z": 1.394
            },
            "rightCorner": {
              "x": 14.923,
              "y": 6.367,
              "z": 1.394
            },
            "gtin": "4000286004620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d873",
            "leftCorner": {
              "x": 14.923,
              "y": 6.367,
              "z": 1.394
            },
            "rightCorner": {
              "x": 15.017,
              "y": 6.359,
              "z": 1.394
            },
            "gtin": "4000286004620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d874",
            "leftCorner": {
              "x": 15.017,
              "y": 6.361,
              "z": 1.394
            },
            "rightCorner": {
              "x": 15.15,
              "y": 6.35,
              "z": 1.394
            },
            "gtin": "4000286004668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d875",
            "leftCorner": {
              "x": 15.15,
              "y": 6.35,
              "z": 1.394
            },
            "rightCorner": {
              "x": 15.284,
              "y": 6.339,
              "z": 1.394
            },
            "gtin": "4000286004668",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f7a",
    "rightNeighborShelfId": "b6f7e"
  },
  {
    "id": "b6f7e",
    "name": "b6f7e",
    "x": 15.287,
    "y": 6.287,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.040786,
      "w": 0.99917
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 61
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54624e",
        "height": 0.15832,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1db3a",
            "leftCorner": {
              "x": 15.288,
              "y": 6.29,
              "z": 0.13
            },
            "rightCorner": {
              "x": 15.603,
              "y": 6.264,
              "z": 0.13
            },
            "gtin": "8858306003520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db3b",
            "leftCorner": {
              "x": 15.603,
              "y": 6.264,
              "z": 0.13
            },
            "rightCorner": {
              "x": 15.918,
              "y": 6.239,
              "z": 0.13
            },
            "gtin": "8858306003520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db41",
            "leftCorner": {
              "x": 15.921,
              "y": 6.274,
              "z": 0.13
            },
            "rightCorner": {
              "x": 16.142,
              "y": 6.256,
              "z": 0.13
            },
            "gtin": "4337185459887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db42",
            "leftCorner": {
              "x": 16.142,
              "y": 6.256,
              "z": 0.13
            },
            "rightCorner": {
              "x": 16.363,
              "y": 6.237,
              "z": 0.13
            },
            "gtin": "4337185459887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db43",
            "leftCorner": {
              "x": 16.363,
              "y": 6.243,
              "z": 0.13
            },
            "rightCorner": {
              "x": 16.505,
              "y": 6.231,
              "z": 0.13
            },
            "gtin": "4006237090117",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54624b",
        "height": 0.65032,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d817",
            "leftCorner": {
              "x": 15.313,
              "y": 6.339,
              "z": 0.532
            },
            "rightCorner": {
              "x": 15.41,
              "y": 6.331,
              "z": 0.532
            },
            "gtin": "4063367435195",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d818",
            "leftCorner": {
              "x": 15.41,
              "y": 6.331,
              "z": 0.532
            },
            "rightCorner": {
              "x": 15.507,
              "y": 6.323,
              "z": 0.532
            },
            "gtin": "4063367435195",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d819",
            "leftCorner": {
              "x": 15.507,
              "y": 6.323,
              "z": 0.532
            },
            "rightCorner": {
              "x": 15.603,
              "y": 6.315,
              "z": 0.532
            },
            "gtin": "4063367435195",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d81a",
            "leftCorner": {
              "x": 15.603,
              "y": 6.315,
              "z": 0.532
            },
            "rightCorner": {
              "x": 15.7,
              "y": 6.307,
              "z": 0.532
            },
            "gtin": "4063367435195",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d81b",
            "leftCorner": {
              "x": 15.7,
              "y": 6.31,
              "z": 0.532
            },
            "rightCorner": {
              "x": 15.794,
              "y": 6.302,
              "z": 0.532
            },
            "gtin": "4063367435232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d81c",
            "leftCorner": {
              "x": 15.794,
              "y": 6.302,
              "z": 0.532
            },
            "rightCorner": {
              "x": 15.887,
              "y": 6.295,
              "z": 0.532
            },
            "gtin": "4063367435232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d81d",
            "leftCorner": {
              "x": 15.887,
              "y": 6.295,
              "z": 0.532
            },
            "rightCorner": {
              "x": 15.98,
              "y": 6.287,
              "z": 0.532
            },
            "gtin": "4063367435232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d81e",
            "leftCorner": {
              "x": 15.98,
              "y": 6.278,
              "z": 0.532
            },
            "rightCorner": {
              "x": 16.124,
              "y": 6.266,
              "z": 0.532
            },
            "gtin": "4063367435225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d81f",
            "leftCorner": {
              "x": 16.124,
              "y": 6.266,
              "z": 0.532
            },
            "rightCorner": {
              "x": 16.269,
              "y": 6.254,
              "z": 0.532
            },
            "gtin": "4063367435225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d820",
            "leftCorner": {
              "x": 16.269,
              "y": 6.256,
              "z": 0.532
            },
            "rightCorner": {
              "x": 16.379,
              "y": 6.247,
              "z": 0.532
            },
            "gtin": "4300175728515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d821",
            "leftCorner": {
              "x": 16.379,
              "y": 6.247,
              "z": 0.532
            },
            "rightCorner": {
              "x": 16.487,
              "y": 6.239,
              "z": 0.532
            },
            "gtin": "4300175728515",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54624a",
        "height": 0.95425,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d797",
            "leftCorner": {
              "x": 15.287,
              "y": 6.335,
              "z": 0.781
            },
            "rightCorner": {
              "x": 15.459,
              "y": 6.321,
              "z": 0.781
            },
            "gtin": "4000950576026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d798",
            "leftCorner": {
              "x": 15.459,
              "y": 6.312,
              "z": 0.781
            },
            "rightCorner": {
              "x": 15.623,
              "y": 6.298,
              "z": 0.781
            },
            "gtin": "4006363101558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d799",
            "leftCorner": {
              "x": 15.623,
              "y": 6.3,
              "z": 0.781
            },
            "rightCorner": {
              "x": 15.769,
              "y": 6.289,
              "z": 0.781
            },
            "gtin": "4006363102081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d79a",
            "leftCorner": {
              "x": 15.769,
              "y": 6.289,
              "z": 0.781
            },
            "rightCorner": {
              "x": 15.915,
              "y": 6.277,
              "z": 0.781
            },
            "gtin": "4006363102081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d79b",
            "leftCorner": {
              "x": 15.915,
              "y": 6.277,
              "z": 0.781
            },
            "rightCorner": {
              "x": 16.059,
              "y": 6.265,
              "z": 0.781
            },
            "gtin": "4006363102081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d79c",
            "leftCorner": {
              "x": 16.061,
              "y": 6.274,
              "z": 0.781
            },
            "rightCorner": {
              "x": 16.197,
              "y": 6.263,
              "z": 0.781
            },
            "gtin": "4006363101541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d79d",
            "leftCorner": {
              "x": 16.197,
              "y": 6.263,
              "z": 0.781
            },
            "rightCorner": {
              "x": 16.335,
              "y": 6.252,
              "z": 0.781
            },
            "gtin": "4006363101541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d79e",
            "leftCorner": {
              "x": 16.335,
              "y": 6.247,
              "z": 0.781
            },
            "rightCorner": {
              "x": 16.503,
              "y": 6.234,
              "z": 0.781
            },
            "gtin": "4000950670458",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54624d",
        "height": 1.2042,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d7dc",
            "leftCorner": {
              "x": 15.33,
              "y": 6.321,
              "z": 0.985
            },
            "rightCorner": {
              "x": 15.49,
              "y": 6.308,
              "z": 0.985
            },
            "gtin": "4063367444371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7dd",
            "leftCorner": {
              "x": 15.49,
              "y": 6.308,
              "z": 0.985
            },
            "rightCorner": {
              "x": 15.65,
              "y": 6.295,
              "z": 0.985
            },
            "gtin": "4063367444371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7de",
            "leftCorner": {
              "x": 15.65,
              "y": 6.297,
              "z": 0.985
            },
            "rightCorner": {
              "x": 15.743,
              "y": 6.289,
              "z": 0.985
            },
            "gtin": "4063367444395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7df",
            "leftCorner": {
              "x": 15.743,
              "y": 6.291,
              "z": 0.985
            },
            "rightCorner": {
              "x": 15.845,
              "y": 6.282,
              "z": 0.985
            },
            "gtin": "4337185770944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7e0",
            "leftCorner": {
              "x": 15.845,
              "y": 6.282,
              "z": 0.985
            },
            "rightCorner": {
              "x": 15.947,
              "y": 6.274,
              "z": 0.985
            },
            "gtin": "4337185770944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7e1",
            "leftCorner": {
              "x": 15.947,
              "y": 6.274,
              "z": 0.985
            },
            "rightCorner": {
              "x": 16.049,
              "y": 6.266,
              "z": 0.985
            },
            "gtin": "4337185770944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7e2",
            "leftCorner": {
              "x": 16.05,
              "y": 6.272,
              "z": 0.985
            },
            "rightCorner": {
              "x": 16.124,
              "y": 6.266,
              "z": 0.985
            },
            "gtin": "4063367444371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7e3",
            "leftCorner": {
              "x": 16.124,
              "y": 6.266,
              "z": 0.985
            },
            "rightCorner": {
              "x": 16.199,
              "y": 6.26,
              "z": 0.985
            },
            "gtin": "4063367444371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7e4",
            "leftCorner": {
              "x": 16.198,
              "y": 6.25,
              "z": 0.985
            },
            "rightCorner": {
              "x": 16.314,
              "y": 6.24,
              "z": 0.985
            },
            "gtin": "4063367444388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7e5",
            "leftCorner": {
              "x": 16.314,
              "y": 6.24,
              "z": 0.985
            },
            "rightCorner": {
              "x": 16.431,
              "y": 6.231,
              "z": 0.985
            },
            "gtin": "4063367444388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7e6",
            "leftCorner": {
              "x": 16.431,
              "y": 6.231,
              "z": 0.985
            },
            "rightCorner": {
              "x": 16.546,
              "y": 6.221,
              "z": 0.985
            },
            "gtin": "4063367444388",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54624c",
        "height": 1.4562,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d8ce",
            "leftCorner": {
              "x": 15.29,
              "y": 6.333,
              "z": 1.191
            },
            "rightCorner": {
              "x": 15.446,
              "y": 6.32,
              "z": 1.191
            },
            "gtin": "4000950072207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8cf",
            "leftCorner": {
              "x": 15.446,
              "y": 6.32,
              "z": 1.191
            },
            "rightCorner": {
              "x": 15.604,
              "y": 6.307,
              "z": 1.191
            },
            "gtin": "4000950072207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8d0",
            "leftCorner": {
              "x": 15.604,
              "y": 6.307,
              "z": 1.191
            },
            "rightCorner": {
              "x": 15.761,
              "y": 6.294,
              "z": 1.191
            },
            "gtin": "4000950072207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8d1",
            "leftCorner": {
              "x": 15.759,
              "y": 6.269,
              "z": 1.191
            },
            "rightCorner": {
              "x": 15.846,
              "y": 6.262,
              "z": 1.191
            },
            "gtin": "4000950103574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8d2",
            "leftCorner": {
              "x": 15.847,
              "y": 6.282,
              "z": 1.191
            },
            "rightCorner": {
              "x": 15.927,
              "y": 6.275,
              "z": 1.191
            },
            "gtin": "4000950103567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8d3",
            "leftCorner": {
              "x": 15.927,
              "y": 6.275,
              "z": 1.191
            },
            "rightCorner": {
              "x": 16.008,
              "y": 6.268,
              "z": 1.191
            },
            "gtin": "4000950103567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8d4",
            "leftCorner": {
              "x": 16.009,
              "y": 6.279,
              "z": 1.191
            },
            "rightCorner": {
              "x": 16.081,
              "y": 6.273,
              "z": 1.191
            },
            "gtin": "4335896760216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8d5",
            "leftCorner": {
              "x": 16.081,
              "y": 6.273,
              "z": 1.191
            },
            "rightCorner": {
              "x": 16.152,
              "y": 6.267,
              "z": 1.191
            },
            "gtin": "4335896760216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8d6",
            "leftCorner": {
              "x": 16.151,
              "y": 6.249,
              "z": 1.191
            },
            "rightCorner": {
              "x": 16.236,
              "y": 6.242,
              "z": 1.191
            },
            "gtin": "4063367444364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8d7",
            "leftCorner": {
              "x": 16.236,
              "y": 6.242,
              "z": 1.191
            },
            "rightCorner": {
              "x": 16.321,
              "y": 6.235,
              "z": 1.191
            },
            "gtin": "4063367444364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8d8",
            "leftCorner": {
              "x": 16.322,
              "y": 6.251,
              "z": 1.191
            },
            "rightCorner": {
              "x": 16.517,
              "y": 6.235,
              "z": 1.191
            },
            "gtin": "4002015000019",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546249",
        "height": 1.7093,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d876",
            "leftCorner": {
              "x": 15.283,
              "y": 6.32,
              "z": 1.399
            },
            "rightCorner": {
              "x": 15.351,
              "y": 6.315,
              "z": 1.399
            },
            "gtin": "4023900545682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d877",
            "leftCorner": {
              "x": 15.351,
              "y": 6.315,
              "z": 1.399
            },
            "rightCorner": {
              "x": 15.419,
              "y": 6.309,
              "z": 1.399
            },
            "gtin": "4023900545682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d878",
            "leftCorner": {
              "x": 15.419,
              "y": 6.31,
              "z": 1.399
            },
            "rightCorner": {
              "x": 15.557,
              "y": 6.299,
              "z": 1.399
            },
            "gtin": "4008258509029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d879",
            "leftCorner": {
              "x": 15.557,
              "y": 6.299,
              "z": 1.399
            },
            "rightCorner": {
              "x": 15.695,
              "y": 6.288,
              "z": 1.399
            },
            "gtin": "4008258509029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d87a",
            "leftCorner": {
              "x": 15.695,
              "y": 6.291,
              "z": 1.399
            },
            "rightCorner": {
              "x": 15.762,
              "y": 6.286,
              "z": 1.399
            },
            "gtin": "4008258510001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d87b",
            "leftCorner": {
              "x": 15.762,
              "y": 6.286,
              "z": 1.399
            },
            "rightCorner": {
              "x": 15.828,
              "y": 6.281,
              "z": 1.399
            },
            "gtin": "4008258510001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d87c",
            "leftCorner": {
              "x": 15.828,
              "y": 6.285,
              "z": 1.399
            },
            "rightCorner": {
              "x": 15.99,
              "y": 6.271,
              "z": 1.399
            },
            "gtin": "4008258502006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d87d",
            "leftCorner": {
              "x": 15.991,
              "y": 6.275,
              "z": 1.399
            },
            "rightCorner": {
              "x": 16.061,
              "y": 6.269,
              "z": 1.399
            },
            "gtin": "3830060862570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d87e",
            "leftCorner": {
              "x": 16.061,
              "y": 6.269,
              "z": 1.399
            },
            "rightCorner": {
              "x": 16.131,
              "y": 6.263,
              "z": 1.399
            },
            "gtin": "3830060862570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d87f",
            "leftCorner": {
              "x": 16.131,
              "y": 6.263,
              "z": 1.399
            },
            "rightCorner": {
              "x": 16.202,
              "y": 6.257,
              "z": 1.399
            },
            "gtin": "3830060862570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d880",
            "leftCorner": {
              "x": 16.202,
              "y": 6.26,
              "z": 1.399
            },
            "rightCorner": {
              "x": 16.261,
              "y": 6.255,
              "z": 1.399
            },
            "gtin": "4337185770920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d881",
            "leftCorner": {
              "x": 16.261,
              "y": 6.255,
              "z": 1.399
            },
            "rightCorner": {
              "x": 16.321,
              "y": 6.25,
              "z": 1.399
            },
            "gtin": "4337185770920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d882",
            "leftCorner": {
              "x": 16.321,
              "y": 6.25,
              "z": 1.399
            },
            "rightCorner": {
              "x": 16.379,
              "y": 6.245,
              "z": 1.399
            },
            "gtin": "4337185770920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d883",
            "leftCorner": {
              "x": 16.38,
              "y": 6.248,
              "z": 1.399
            },
            "rightCorner": {
              "x": 16.447,
              "y": 6.242,
              "z": 1.399
            },
            "gtin": "4260380788707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d884",
            "leftCorner": {
              "x": 16.447,
              "y": 6.242,
              "z": 1.399
            },
            "rightCorner": {
              "x": 16.514,
              "y": 6.237,
              "z": 1.399
            },
            "gtin": "4260380788707",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f7d",
    "rightNeighborShelfId": "b6f7f"
  },
  {
    "id": "b6f7f",
    "name": "b6f7f",
    "x": 16.483,
    "y": 6.189,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.040786,
      "w": 0.99917
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 62
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546259",
        "height": 0.15089,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1db44",
            "leftCorner": {
              "x": 16.506,
              "y": 6.245,
              "z": 0.123
            },
            "rightCorner": {
              "x": 16.651,
              "y": 6.233,
              "z": 0.123
            },
            "gtin": "3600900022460",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db45",
            "leftCorner": {
              "x": 16.651,
              "y": 6.233,
              "z": 0.123
            },
            "rightCorner": {
              "x": 16.796,
              "y": 6.222,
              "z": 0.123
            },
            "gtin": "3600900022460",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db46",
            "leftCorner": {
              "x": 16.796,
              "y": 6.227,
              "z": 0.123
            },
            "rightCorner": {
              "x": 16.992,
              "y": 6.211,
              "z": 0.123
            },
            "gtin": "3830060862112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db47",
            "leftCorner": {
              "x": 16.992,
              "y": 6.211,
              "z": 0.123
            },
            "rightCorner": {
              "x": 17.186,
              "y": 6.195,
              "z": 0.123
            },
            "gtin": "3830060862112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db48",
            "leftCorner": {
              "x": 17.188,
              "y": 6.211,
              "z": 0.123
            },
            "rightCorner": {
              "x": 17.369,
              "y": 6.196,
              "z": 0.123
            },
            "gtin": "8588009605065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db49",
            "leftCorner": {
              "x": 17.367,
              "y": 6.171,
              "z": 0.123
            },
            "rightCorner": {
              "x": 17.468,
              "y": 6.163,
              "z": 0.123
            },
            "gtin": "8588009605041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db4a",
            "leftCorner": {
              "x": 17.469,
              "y": 6.173,
              "z": 0.123
            },
            "rightCorner": {
              "x": 17.598,
              "y": 6.163,
              "z": 0.123
            },
            "gtin": "8595237403875",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db4b",
            "leftCorner": {
              "x": 17.598,
              "y": 6.163,
              "z": 0.123
            },
            "rightCorner": {
              "x": 17.727,
              "y": 6.152,
              "z": 0.123
            },
            "gtin": "8595237403875",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546255",
        "height": 0.65506,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d822",
            "leftCorner": {
              "x": 16.487,
              "y": 6.24,
              "z": 0.536
            },
            "rightCorner": {
              "x": 16.609,
              "y": 6.23,
              "z": 0.536
            },
            "gtin": "4006363102319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d823",
            "leftCorner": {
              "x": 16.609,
              "y": 6.23,
              "z": 0.536
            },
            "rightCorner": {
              "x": 16.73,
              "y": 6.221,
              "z": 0.536
            },
            "gtin": "4006363102319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d824",
            "leftCorner": {
              "x": 16.73,
              "y": 6.221,
              "z": 0.536
            },
            "rightCorner": {
              "x": 16.851,
              "y": 6.211,
              "z": 0.536
            },
            "gtin": "4006363102319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d825",
            "leftCorner": {
              "x": 16.852,
              "y": 6.218,
              "z": 0.536
            },
            "rightCorner": {
              "x": 17.074,
              "y": 6.2,
              "z": 0.536
            },
            "gtin": "3830060862099",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c845ed67a01d9a1d826",
            "leftCorner": {
              "x": 17.075,
              "y": 6.211,
              "z": 0.536
            },
            "rightCorner": {
              "x": 17.205,
              "y": 6.201,
              "z": 0.536
            },
            "gtin": "5902481399473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d827",
            "leftCorner": {
              "x": 17.205,
              "y": 6.201,
              "z": 0.536
            },
            "rightCorner": {
              "x": 17.335,
              "y": 6.19,
              "z": 0.536
            },
            "gtin": "5902481399473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d828",
            "leftCorner": {
              "x": 17.335,
              "y": 6.188,
              "z": 0.536
            },
            "rightCorner": {
              "x": 17.483,
              "y": 6.176,
              "z": 0.536
            },
            "gtin": "4032844050411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d829",
            "leftCorner": {
              "x": 17.483,
              "y": 6.176,
              "z": 0.536
            },
            "rightCorner": {
              "x": 17.631,
              "y": 6.164,
              "z": 0.536
            },
            "gtin": "4032844050411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7f2",
            "leftCorner": {
              "x": 17.63,
              "y": 6.157,
              "z": 0.536
            },
            "rightCorner": {
              "x": 17.684,
              "y": 6.152,
              "z": 0.536
            },
            "gtin": "4003488000254",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546256",
        "height": 0.95547,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d79f",
            "leftCorner": {
              "x": 16.503,
              "y": 6.232,
              "z": 0.782
            },
            "rightCorner": {
              "x": 16.623,
              "y": 6.222,
              "z": 0.782
            },
            "gtin": "8595237404544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7a0",
            "leftCorner": {
              "x": 16.623,
              "y": 6.222,
              "z": 0.782
            },
            "rightCorner": {
              "x": 16.742,
              "y": 6.213,
              "z": 0.782
            },
            "gtin": "8595237404544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7a1",
            "leftCorner": {
              "x": 16.742,
              "y": 6.213,
              "z": 0.782
            },
            "rightCorner": {
              "x": 16.862,
              "y": 6.203,
              "z": 0.782
            },
            "gtin": "8595237404544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7a2",
            "leftCorner": {
              "x": 16.863,
              "y": 6.217,
              "z": 0.782
            },
            "rightCorner": {
              "x": 16.923,
              "y": 6.212,
              "z": 0.782
            },
            "gtin": "4337185718687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7a3",
            "leftCorner": {
              "x": 16.923,
              "y": 6.212,
              "z": 0.782
            },
            "rightCorner": {
              "x": 16.983,
              "y": 6.207,
              "z": 0.782
            },
            "gtin": "4337185718687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7a4",
            "leftCorner": {
              "x": 16.983,
              "y": 6.207,
              "z": 0.782
            },
            "rightCorner": {
              "x": 17.044,
              "y": 6.202,
              "z": 0.782
            },
            "gtin": "4337185718687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7a5",
            "leftCorner": {
              "x": 17.044,
              "y": 6.206,
              "z": 0.782
            },
            "rightCorner": {
              "x": 17.159,
              "y": 6.196,
              "z": 0.782
            },
            "gtin": "5902481059674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7a6",
            "leftCorner": {
              "x": 17.159,
              "y": 6.196,
              "z": 0.782
            },
            "rightCorner": {
              "x": 17.275,
              "y": 6.187,
              "z": 0.782
            },
            "gtin": "5902481059674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7a7",
            "leftCorner": {
              "x": 17.275,
              "y": 6.187,
              "z": 0.782
            },
            "rightCorner": {
              "x": 17.389,
              "y": 6.177,
              "z": 0.782
            },
            "gtin": "5902481059674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7a8",
            "leftCorner": {
              "x": 17.389,
              "y": 6.177,
              "z": 0.782
            },
            "rightCorner": {
              "x": 17.505,
              "y": 6.168,
              "z": 0.782
            },
            "gtin": "5902481059674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d76d",
            "leftCorner": {
              "x": 17.504,
              "y": 6.162,
              "z": 0.782
            },
            "rightCorner": {
              "x": 17.684,
              "y": 6.147,
              "z": 0.782
            },
            "gtin": "4337185826450",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546258",
        "height": 1.2142,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d7e7",
            "leftCorner": {
              "x": 16.546,
              "y": 6.223,
              "z": 0.993
            },
            "rightCorner": {
              "x": 16.696,
              "y": 6.211,
              "z": 0.993
            },
            "gtin": "3830060862624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7e8",
            "leftCorner": {
              "x": 16.696,
              "y": 6.213,
              "z": 0.993
            },
            "rightCorner": {
              "x": 16.788,
              "y": 6.205,
              "z": 0.993
            },
            "gtin": "3600900022453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7e9",
            "leftCorner": {
              "x": 16.788,
              "y": 6.205,
              "z": 0.993
            },
            "rightCorner": {
              "x": 16.878,
              "y": 6.198,
              "z": 0.993
            },
            "gtin": "3600900022453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7ea",
            "leftCorner": {
              "x": 16.878,
              "y": 6.198,
              "z": 0.993
            },
            "rightCorner": {
              "x": 16.969,
              "y": 6.19,
              "z": 0.993
            },
            "gtin": "3600900022453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7eb",
            "leftCorner": {
              "x": 16.969,
              "y": 6.19,
              "z": 0.993
            },
            "rightCorner": {
              "x": 17.06,
              "y": 6.183,
              "z": 0.993
            },
            "gtin": "3600900022453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7ec",
            "leftCorner": {
              "x": 17.061,
              "y": 6.197,
              "z": 0.993
            },
            "rightCorner": {
              "x": 17.204,
              "y": 6.185,
              "z": 0.993
            },
            "gtin": "3600900022477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7ed",
            "leftCorner": {
              "x": 17.204,
              "y": 6.185,
              "z": 0.993
            },
            "rightCorner": {
              "x": 17.347,
              "y": 6.174,
              "z": 0.993
            },
            "gtin": "3600900022477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7ab",
            "leftCorner": {
              "x": 17.349,
              "y": 6.184,
              "z": 0.993
            },
            "rightCorner": {
              "x": 17.46,
              "y": 6.174,
              "z": 0.993
            },
            "gtin": "3600900022484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7ac",
            "leftCorner": {
              "x": 17.46,
              "y": 6.174,
              "z": 0.993
            },
            "rightCorner": {
              "x": 17.573,
              "y": 6.165,
              "z": 0.993
            },
            "gtin": "3600900022484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d7ad",
            "leftCorner": {
              "x": 17.573,
              "y": 6.165,
              "z": 0.993
            },
            "rightCorner": {
              "x": 17.684,
              "y": 6.156,
              "z": 0.993
            },
            "gtin": "3600900022484",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54625a",
        "height": 1.4608,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d8d9",
            "leftCorner": {
              "x": 16.516,
              "y": 6.228,
              "z": 1.195
            },
            "rightCorner": {
              "x": 16.668,
              "y": 6.215,
              "z": 1.195
            },
            "gtin": "4006363112387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8da",
            "leftCorner": {
              "x": 16.668,
              "y": 6.215,
              "z": 1.195
            },
            "rightCorner": {
              "x": 16.822,
              "y": 6.203,
              "z": 1.195
            },
            "gtin": "4006363112387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8db",
            "leftCorner": {
              "x": 16.82,
              "y": 6.196,
              "z": 1.195
            },
            "rightCorner": {
              "x": 16.926,
              "y": 6.187,
              "z": 1.195
            },
            "gtin": "4005009105479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8dc",
            "leftCorner": {
              "x": 16.926,
              "y": 6.187,
              "z": 1.195
            },
            "rightCorner": {
              "x": 17.031,
              "y": 6.179,
              "z": 1.195
            },
            "gtin": "4005009105479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8dd",
            "leftCorner": {
              "x": 17.032,
              "y": 6.201,
              "z": 1.195
            },
            "rightCorner": {
              "x": 17.154,
              "y": 6.191,
              "z": 1.195
            },
            "gtin": "4045178003206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8de",
            "leftCorner": {
              "x": 17.152,
              "y": 6.176,
              "z": 1.195
            },
            "rightCorner": {
              "x": 17.236,
              "y": 6.169,
              "z": 1.195
            },
            "gtin": "4045178002285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8df",
            "leftCorner": {
              "x": 17.236,
              "y": 6.169,
              "z": 1.195
            },
            "rightCorner": {
              "x": 17.321,
              "y": 6.162,
              "z": 1.195
            },
            "gtin": "4045178002285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8e0",
            "leftCorner": {
              "x": 17.321,
              "y": 6.158,
              "z": 1.195
            },
            "rightCorner": {
              "x": 17.385,
              "y": 6.153,
              "z": 1.195
            },
            "gtin": "4019339641170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8e1",
            "leftCorner": {
              "x": 17.385,
              "y": 6.153,
              "z": 1.195
            },
            "rightCorner": {
              "x": 17.447,
              "y": 6.147,
              "z": 1.195
            },
            "gtin": "4019339641170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8e2",
            "leftCorner": {
              "x": 17.448,
              "y": 6.159,
              "z": 1.195
            },
            "rightCorner": {
              "x": 17.597,
              "y": 6.147,
              "z": 1.195
            },
            "gtin": "4019339641262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8a1",
            "leftCorner": {
              "x": 17.596,
              "y": 6.143,
              "z": 1.195
            },
            "rightCorner": {
              "x": 17.683,
              "y": 6.136,
              "z": 1.195
            },
            "gtin": "4019339641149",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546257",
        "height": 1.7109,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d885",
            "leftCorner": {
              "x": 16.513,
              "y": 6.224,
              "z": 1.4
            },
            "rightCorner": {
              "x": 16.634,
              "y": 6.214,
              "z": 1.4
            },
            "gtin": "4033122007066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d886",
            "leftCorner": {
              "x": 16.634,
              "y": 6.214,
              "z": 1.4
            },
            "rightCorner": {
              "x": 16.756,
              "y": 6.204,
              "z": 1.4
            },
            "gtin": "4033122007066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d887",
            "leftCorner": {
              "x": 16.756,
              "y": 6.216,
              "z": 1.4
            },
            "rightCorner": {
              "x": 16.851,
              "y": 6.208,
              "z": 1.4
            },
            "gtin": "4260380788783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d888",
            "leftCorner": {
              "x": 16.851,
              "y": 6.208,
              "z": 1.4
            },
            "rightCorner": {
              "x": 16.947,
              "y": 6.2,
              "z": 1.4
            },
            "gtin": "4260380788783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d889",
            "leftCorner": {
              "x": 16.947,
              "y": 6.202,
              "z": 1.4
            },
            "rightCorner": {
              "x": 17.065,
              "y": 6.192,
              "z": 1.4
            },
            "gtin": "4260380788769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d88a",
            "leftCorner": {
              "x": 17.066,
              "y": 6.197,
              "z": 1.4
            },
            "rightCorner": {
              "x": 17.117,
              "y": 6.193,
              "z": 1.4
            },
            "gtin": "4005009104106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d88b",
            "leftCorner": {
              "x": 17.117,
              "y": 6.193,
              "z": 1.4
            },
            "rightCorner": {
              "x": 17.166,
              "y": 6.189,
              "z": 1.4
            },
            "gtin": "4005009104106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d88c",
            "leftCorner": {
              "x": 17.167,
              "y": 6.192,
              "z": 1.4
            },
            "rightCorner": {
              "x": 17.237,
              "y": 6.186,
              "z": 1.4
            },
            "gtin": "4008391021174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d88d",
            "leftCorner": {
              "x": 17.237,
              "y": 6.186,
              "z": 1.4
            },
            "rightCorner": {
              "x": 17.309,
              "y": 6.18,
              "z": 1.4
            },
            "gtin": "4008391021174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d88e",
            "leftCorner": {
              "x": 17.309,
              "y": 6.17,
              "z": 1.4
            },
            "rightCorner": {
              "x": 17.429,
              "y": 6.16,
              "z": 1.4
            },
            "gtin": "4005394200193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d88f",
            "leftCorner": {
              "x": 17.429,
              "y": 6.162,
              "z": 1.4
            },
            "rightCorner": {
              "x": 17.525,
              "y": 6.154,
              "z": 1.4
            },
            "gtin": "4005394200186",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d890",
            "leftCorner": {
              "x": 17.524,
              "y": 6.14,
              "z": 1.4
            },
            "rightCorner": {
              "x": 17.643,
              "y": 6.13,
              "z": 1.4
            },
            "gtin": "4005394287675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d891",
            "leftCorner": {
              "x": 17.645,
              "y": 6.15,
              "z": 1.4
            },
            "rightCorner": {
              "x": 17.689,
              "y": 6.146,
              "z": 1.4
            },
            "gtin": "4005009103925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d892",
            "leftCorner": {
              "x": 17.689,
              "y": 6.146,
              "z": 1.4
            },
            "rightCorner": {
              "x": 17.734,
              "y": 6.142,
              "z": 1.4
            },
            "gtin": "4005009103925",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f7e",
    "rightNeighborShelfId": "b6f80"
  },
  {
    "id": "b6f80",
    "name": "b6f80",
    "x": 17.679,
    "y": 6.091,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.040786,
      "w": 0.99917
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 81
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546261",
        "height": 0.14986,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1db4c",
            "leftCorner": {
              "x": 17.729,
              "y": 6.158,
              "z": 0.123
            },
            "rightCorner": {
              "x": 18.068,
              "y": 6.13,
              "z": 0.123
            },
            "gtin": "4337185693199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db4d",
            "leftCorner": {
              "x": 18.067,
              "y": 6.108,
              "z": 0.123
            },
            "rightCorner": {
              "x": 18.251,
              "y": 6.093,
              "z": 0.123
            },
            "gtin": "4337185693175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db4e",
            "leftCorner": {
              "x": 18.254,
              "y": 6.122,
              "z": 0.123
            },
            "rightCorner": {
              "x": 18.327,
              "y": 6.116,
              "z": 0.123
            },
            "gtin": "8595237404940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db4f",
            "leftCorner": {
              "x": 18.327,
              "y": 6.116,
              "z": 0.123
            },
            "rightCorner": {
              "x": 18.402,
              "y": 6.109,
              "z": 0.123
            },
            "gtin": "8595237404940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db3c",
            "leftCorner": {
              "x": 18.4,
              "y": 6.084,
              "z": 0.123
            },
            "rightCorner": {
              "x": 18.505,
              "y": 6.075,
              "z": 0.123
            },
            "gtin": "5902481058493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db3d",
            "leftCorner": {
              "x": 18.505,
              "y": 6.075,
              "z": 0.123
            },
            "rightCorner": {
              "x": 18.611,
              "y": 6.066,
              "z": 0.123
            },
            "gtin": "5902481058493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db3e",
            "leftCorner": {
              "x": 18.611,
              "y": 6.066,
              "z": 0.123
            },
            "rightCorner": {
              "x": 18.717,
              "y": 6.058,
              "z": 0.123
            },
            "gtin": "5902481058493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db3f",
            "leftCorner": {
              "x": 18.717,
              "y": 6.058,
              "z": 0.123
            },
            "rightCorner": {
              "x": 18.823,
              "y": 6.049,
              "z": 0.123
            },
            "gtin": "5902481058493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db40",
            "leftCorner": {
              "x": 18.823,
              "y": 6.049,
              "z": 0.123
            },
            "rightCorner": {
              "x": 18.929,
              "y": 6.04,
              "z": 0.123
            },
            "gtin": "5902481058493",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54625f",
        "height": 0.45136,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dc09",
            "leftCorner": {
              "x": 17.681,
              "y": 6.115,
              "z": 0.369
            },
            "rightCorner": {
              "x": 17.806,
              "y": 6.105,
              "z": 0.369
            },
            "gtin": "5902481057472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc0a",
            "leftCorner": {
              "x": 17.806,
              "y": 6.105,
              "z": 0.369
            },
            "rightCorner": {
              "x": 17.933,
              "y": 6.094,
              "z": 0.369
            },
            "gtin": "5902481057472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc0b",
            "leftCorner": {
              "x": 17.933,
              "y": 6.094,
              "z": 0.369
            },
            "rightCorner": {
              "x": 18.06,
              "y": 6.084,
              "z": 0.369
            },
            "gtin": "5902481057472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc0c",
            "leftCorner": {
              "x": 18.06,
              "y": 6.084,
              "z": 0.369
            },
            "rightCorner": {
              "x": 18.185,
              "y": 6.074,
              "z": 0.369
            },
            "gtin": "5902481057472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc0d",
            "leftCorner": {
              "x": 18.185,
              "y": 6.074,
              "z": 0.369
            },
            "rightCorner": {
              "x": 18.312,
              "y": 6.063,
              "z": 0.369
            },
            "gtin": "5902481057472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc0e",
            "leftCorner": {
              "x": 18.315,
              "y": 6.109,
              "z": 0.369
            },
            "rightCorner": {
              "x": 18.439,
              "y": 6.099,
              "z": 0.369
            },
            "gtin": "8595237405459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc0f",
            "leftCorner": {
              "x": 18.439,
              "y": 6.099,
              "z": 0.369
            },
            "rightCorner": {
              "x": 18.561,
              "y": 6.089,
              "z": 0.369
            },
            "gtin": "8595237405459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc10",
            "leftCorner": {
              "x": 18.561,
              "y": 6.089,
              "z": 0.369
            },
            "rightCorner": {
              "x": 18.684,
              "y": 6.079,
              "z": 0.369
            },
            "gtin": "8595237405459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc11",
            "leftCorner": {
              "x": 18.684,
              "y": 6.079,
              "z": 0.369
            },
            "rightCorner": {
              "x": 18.807,
              "y": 6.068,
              "z": 0.369
            },
            "gtin": "8595237405459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc12",
            "leftCorner": {
              "x": 18.807,
              "y": 6.068,
              "z": 0.369
            },
            "rightCorner": {
              "x": 18.93,
              "y": 6.058,
              "z": 0.369
            },
            "gtin": "8595237405459",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54625c",
        "height": 0.7526,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dbe3",
            "leftCorner": {
              "x": 17.681,
              "y": 6.113,
              "z": 0.616
            },
            "rightCorner": {
              "x": 17.753,
              "y": 6.107,
              "z": 0.616
            },
            "gtin": "4019339493106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbe4",
            "leftCorner": {
              "x": 17.753,
              "y": 6.107,
              "z": 0.616
            },
            "rightCorner": {
              "x": 17.825,
              "y": 6.101,
              "z": 0.616
            },
            "gtin": "4019339493106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbe5",
            "leftCorner": {
              "x": 17.825,
              "y": 6.101,
              "z": 0.616
            },
            "rightCorner": {
              "x": 17.898,
              "y": 6.095,
              "z": 0.616
            },
            "gtin": "4019339493106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbea",
            "leftCorner": {
              "x": 17.901,
              "y": 6.139,
              "z": 0.616
            },
            "rightCorner": {
              "x": 18.079,
              "y": 6.125,
              "z": 0.616
            },
            "gtin": "5902481399497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbeb",
            "leftCorner": {
              "x": 18.079,
              "y": 6.114,
              "z": 0.616
            },
            "rightCorner": {
              "x": 18.173,
              "y": 6.106,
              "z": 0.616
            },
            "gtin": "5902481059476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbec",
            "leftCorner": {
              "x": 18.173,
              "y": 6.106,
              "z": 0.616
            },
            "rightCorner": {
              "x": 18.269,
              "y": 6.098,
              "z": 0.616
            },
            "gtin": "5902481059476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbed",
            "leftCorner": {
              "x": 18.27,
              "y": 6.116,
              "z": 0.616
            },
            "rightCorner": {
              "x": 18.362,
              "y": 6.109,
              "z": 0.616
            },
            "gtin": "4779035852330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbee",
            "leftCorner": {
              "x": 18.362,
              "y": 6.109,
              "z": 0.616
            },
            "rightCorner": {
              "x": 18.455,
              "y": 6.101,
              "z": 0.616
            },
            "gtin": "4779035852330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbef",
            "leftCorner": {
              "x": 18.454,
              "y": 6.087,
              "z": 0.616
            },
            "rightCorner": {
              "x": 18.517,
              "y": 6.082,
              "z": 0.616
            },
            "gtin": "8595237405473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbf0",
            "leftCorner": {
              "x": 18.517,
              "y": 6.082,
              "z": 0.616
            },
            "rightCorner": {
              "x": 18.58,
              "y": 6.077,
              "z": 0.616
            },
            "gtin": "8595237405473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbe6",
            "leftCorner": {
              "x": 18.58,
              "y": 6.079,
              "z": 0.616
            },
            "rightCorner": {
              "x": 18.668,
              "y": 6.072,
              "z": 0.616
            },
            "gtin": "4002905200116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbe7",
            "leftCorner": {
              "x": 18.668,
              "y": 6.072,
              "z": 0.616
            },
            "rightCorner": {
              "x": 18.755,
              "y": 6.064,
              "z": 0.616
            },
            "gtin": "4002905200116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbe8",
            "leftCorner": {
              "x": 18.755,
              "y": 6.064,
              "z": 0.616
            },
            "rightCorner": {
              "x": 18.842,
              "y": 6.057,
              "z": 0.616
            },
            "gtin": "4002905200116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbe9",
            "leftCorner": {
              "x": 18.842,
              "y": 6.057,
              "z": 0.616
            },
            "rightCorner": {
              "x": 18.929,
              "y": 6.05,
              "z": 0.616
            },
            "gtin": "4002905200116",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546260",
        "height": 1.011,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dc13",
            "leftCorner": {
              "x": 17.681,
              "y": 6.115,
              "z": 0.827
            },
            "rightCorner": {
              "x": 17.805,
              "y": 6.104,
              "z": 0.827
            },
            "gtin": "4019339440100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc14",
            "leftCorner": {
              "x": 17.805,
              "y": 6.104,
              "z": 0.827
            },
            "rightCorner": {
              "x": 17.93,
              "y": 6.094,
              "z": 0.827
            },
            "gtin": "4019339440100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc1a",
            "leftCorner": {
              "x": 17.933,
              "y": 6.132,
              "z": 0.827
            },
            "rightCorner": {
              "x": 18.081,
              "y": 6.12,
              "z": 0.827
            },
            "gtin": "4019339485101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc1b",
            "leftCorner": {
              "x": 18.081,
              "y": 6.124,
              "z": 0.827
            },
            "rightCorner": {
              "x": 18.147,
              "y": 6.118,
              "z": 0.827
            },
            "gtin": "8595237405435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc1c",
            "leftCorner": {
              "x": 18.147,
              "y": 6.118,
              "z": 0.827
            },
            "rightCorner": {
              "x": 18.212,
              "y": 6.113,
              "z": 0.827
            },
            "gtin": "8595237405435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc1d",
            "leftCorner": {
              "x": 18.212,
              "y": 6.113,
              "z": 0.827
            },
            "rightCorner": {
              "x": 18.278,
              "y": 6.108,
              "z": 0.827
            },
            "gtin": "8595237405435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc15",
            "leftCorner": {
              "x": 18.278,
              "y": 6.111,
              "z": 0.827
            },
            "rightCorner": {
              "x": 18.408,
              "y": 6.1,
              "z": 0.827
            },
            "gtin": "5902481059995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc16",
            "leftCorner": {
              "x": 18.408,
              "y": 6.1,
              "z": 0.827
            },
            "rightCorner": {
              "x": 18.538,
              "y": 6.09,
              "z": 0.827
            },
            "gtin": "5902481059995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc17",
            "leftCorner": {
              "x": 18.538,
              "y": 6.09,
              "z": 0.827
            },
            "rightCorner": {
              "x": 18.669,
              "y": 6.079,
              "z": 0.827
            },
            "gtin": "5902481059995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc18",
            "leftCorner": {
              "x": 18.669,
              "y": 6.079,
              "z": 0.827
            },
            "rightCorner": {
              "x": 18.799,
              "y": 6.068,
              "z": 0.827
            },
            "gtin": "5902481059995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc19",
            "leftCorner": {
              "x": 18.799,
              "y": 6.068,
              "z": 0.827
            },
            "rightCorner": {
              "x": 18.93,
              "y": 6.058,
              "z": 0.827
            },
            "gtin": "5902481059995",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54625e",
        "height": 1.2562,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dbfb",
            "leftCorner": {
              "x": 17.681,
              "y": 6.114,
              "z": 1.028
            },
            "rightCorner": {
              "x": 17.76,
              "y": 6.107,
              "z": 1.028
            },
            "gtin": "4019339490105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbfc",
            "leftCorner": {
              "x": 17.76,
              "y": 6.107,
              "z": 1.028
            },
            "rightCorner": {
              "x": 17.838,
              "y": 6.101,
              "z": 1.028
            },
            "gtin": "4019339490105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc00",
            "leftCorner": {
              "x": 17.841,
              "y": 6.123,
              "z": 1.028
            },
            "rightCorner": {
              "x": 17.949,
              "y": 6.114,
              "z": 1.028
            },
            "gtin": "4019339437124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc01",
            "leftCorner": {
              "x": 17.949,
              "y": 6.114,
              "z": 1.028
            },
            "rightCorner": {
              "x": 18.057,
              "y": 6.106,
              "z": 1.028
            },
            "gtin": "4019339437124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc02",
            "leftCorner": {
              "x": 18.059,
              "y": 6.136,
              "z": 1.028
            },
            "rightCorner": {
              "x": 18.207,
              "y": 6.124,
              "z": 1.028
            },
            "gtin": "4019339437117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc03",
            "leftCorner": {
              "x": 18.206,
              "y": 6.114,
              "z": 1.028
            },
            "rightCorner": {
              "x": 18.259,
              "y": 6.11,
              "z": 1.028
            },
            "gtin": "4005009102034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc04",
            "leftCorner": {
              "x": 18.26,
              "y": 6.119,
              "z": 1.028
            },
            "rightCorner": {
              "x": 18.353,
              "y": 6.111,
              "z": 1.028
            },
            "gtin": "4005009102164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc05",
            "leftCorner": {
              "x": 18.352,
              "y": 6.093,
              "z": 1.028
            },
            "rightCorner": {
              "x": 18.441,
              "y": 6.086,
              "z": 1.028
            },
            "gtin": "4005009102003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc06",
            "leftCorner": {
              "x": 18.441,
              "y": 6.091,
              "z": 1.028
            },
            "rightCorner": {
              "x": 18.519,
              "y": 6.084,
              "z": 1.028
            },
            "gtin": "4005009101983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc07",
            "leftCorner": {
              "x": 18.519,
              "y": 6.077,
              "z": 1.028
            },
            "rightCorner": {
              "x": 18.648,
              "y": 6.066,
              "z": 1.028
            },
            "gtin": "4005009102188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc08",
            "leftCorner": {
              "x": 18.648,
              "y": 6.066,
              "z": 1.028
            },
            "rightCorner": {
              "x": 18.779,
              "y": 6.055,
              "z": 1.028
            },
            "gtin": "4005009102188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbfd",
            "leftCorner": {
              "x": 18.779,
              "y": 6.051,
              "z": 1.028
            },
            "rightCorner": {
              "x": 18.829,
              "y": 6.047,
              "z": 1.028
            },
            "gtin": "4005009103932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbfe",
            "leftCorner": {
              "x": 18.829,
              "y": 6.047,
              "z": 1.028
            },
            "rightCorner": {
              "x": 18.879,
              "y": 6.043,
              "z": 1.028
            },
            "gtin": "4005009103932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbff",
            "leftCorner": {
              "x": 18.879,
              "y": 6.043,
              "z": 1.028
            },
            "rightCorner": {
              "x": 18.928,
              "y": 6.039,
              "z": 1.028
            },
            "gtin": "4005009103932",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54625d",
        "height": 1.5086,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dbf1",
            "leftCorner": {
              "x": 17.68,
              "y": 6.102,
              "z": 1.234
            },
            "rightCorner": {
              "x": 17.81,
              "y": 6.092,
              "z": 1.234
            },
            "gtin": "4260119119550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbf3",
            "leftCorner": {
              "x": 17.813,
              "y": 6.137,
              "z": 1.234
            },
            "rightCorner": {
              "x": 17.934,
              "y": 6.127,
              "z": 1.234
            },
            "gtin": "4260119119598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbf4",
            "leftCorner": {
              "x": 17.934,
              "y": 6.121,
              "z": 1.234
            },
            "rightCorner": {
              "x": 18.084,
              "y": 6.109,
              "z": 1.234
            },
            "gtin": "4260119119611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbf5",
            "leftCorner": {
              "x": 18.084,
              "y": 6.109,
              "z": 1.234
            },
            "rightCorner": {
              "x": 18.236,
              "y": 6.096,
              "z": 1.234
            },
            "gtin": "4260119119611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbf6",
            "leftCorner": {
              "x": 18.237,
              "y": 6.114,
              "z": 1.234
            },
            "rightCorner": {
              "x": 18.353,
              "y": 6.104,
              "z": 1.234
            },
            "gtin": "4015637019345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbf7",
            "leftCorner": {
              "x": 18.352,
              "y": 6.098,
              "z": 1.234
            },
            "rightCorner": {
              "x": 18.504,
              "y": 6.085,
              "z": 1.234
            },
            "gtin": "4260661092356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbf8",
            "leftCorner": {
              "x": 18.504,
              "y": 6.085,
              "z": 1.234
            },
            "rightCorner": {
              "x": 18.654,
              "y": 6.073,
              "z": 1.234
            },
            "gtin": "4260661092356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbf9",
            "leftCorner": {
              "x": 18.653,
              "y": 6.059,
              "z": 1.234
            },
            "rightCorner": {
              "x": 18.725,
              "y": 6.053,
              "z": 1.234
            },
            "gtin": "4260661092165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbfa",
            "leftCorner": {
              "x": 18.725,
              "y": 6.053,
              "z": 1.234
            },
            "rightCorner": {
              "x": 18.796,
              "y": 6.047,
              "z": 1.234
            },
            "gtin": "4260661092165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbf2",
            "leftCorner": {
              "x": 18.796,
              "y": 6.04,
              "z": 1.234
            },
            "rightCorner": {
              "x": 18.928,
              "y": 6.029,
              "z": 1.234
            },
            "gtin": "4260661092141",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54625b",
        "height": 1.7073,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d893",
            "leftCorner": {
              "x": 17.735,
              "y": 6.141,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.847,
              "y": 6.132,
              "z": 1.397
            },
            "gtin": "4015637019284",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d894",
            "leftCorner": {
              "x": 17.847,
              "y": 6.133,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.973,
              "y": 6.123,
              "z": 1.397
            },
            "gtin": "4015637009407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d895",
            "leftCorner": {
              "x": 17.972,
              "y": 6.121,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.075,
              "y": 6.112,
              "z": 1.397
            },
            "gtin": "4015637822952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d896",
            "leftCorner": {
              "x": 18.076,
              "y": 6.126,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.198,
              "y": 6.116,
              "z": 1.397
            },
            "gtin": "4015637004945",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d897",
            "leftCorner": {
              "x": 18.198,
              "y": 6.116,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.32,
              "y": 6.106,
              "z": 1.397
            },
            "gtin": "4015637004945",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d898",
            "leftCorner": {
              "x": 18.32,
              "y": 6.103,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.418,
              "y": 6.095,
              "z": 1.397
            },
            "gtin": "4015637019307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d899",
            "leftCorner": {
              "x": 18.417,
              "y": 6.09,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.485,
              "y": 6.084,
              "z": 1.397
            },
            "gtin": "4064783109660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d89a",
            "leftCorner": {
              "x": 18.485,
              "y": 6.084,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.553,
              "y": 6.079,
              "z": 1.397
            },
            "gtin": "4064783109660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d89b",
            "leftCorner": {
              "x": 18.553,
              "y": 6.078,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.614,
              "y": 6.073,
              "z": 1.397
            },
            "gtin": "4064783109691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d89c",
            "leftCorner": {
              "x": 18.614,
              "y": 6.073,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.675,
              "y": 6.068,
              "z": 1.397
            },
            "gtin": "4064783109691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d89d",
            "leftCorner": {
              "x": 18.675,
              "y": 6.069,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.724,
              "y": 6.066,
              "z": 1.397
            },
            "gtin": "4064783109684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d89e",
            "leftCorner": {
              "x": 18.724,
              "y": 6.066,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.771,
              "y": 6.062,
              "z": 1.397
            },
            "gtin": "4064783109684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d82d",
            "leftCorner": {
              "x": 18.77,
              "y": 6.048,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.849,
              "y": 6.042,
              "z": 1.397
            },
            "gtin": "4064783109677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d82e",
            "leftCorner": {
              "x": 18.849,
              "y": 6.042,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.928,
              "y": 6.036,
              "z": 1.397
            },
            "gtin": "4064783109677",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f7f"
  },
  {
    "id": "b6f81",
    "name": "b6f81",
    "x": 15.51,
    "y": 7.392,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99916,
      "w": 0.040899
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 41
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54626b",
        "height": 0.14835,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d4ac",
            "leftCorner": {
              "x": 15.439,
              "y": 7.353,
              "z": 0.121
            },
            "rightCorner": {
              "x": 15.257,
              "y": 7.368,
              "z": 0.121
            },
            "gtin": "4337185865541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4ad",
            "leftCorner": {
              "x": 15.258,
              "y": 7.382,
              "z": 0.121
            },
            "rightCorner": {
              "x": 15.157,
              "y": 7.39,
              "z": 0.121
            },
            "gtin": "4063367147944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4ae",
            "leftCorner": {
              "x": 15.157,
              "y": 7.39,
              "z": 0.121
            },
            "rightCorner": {
              "x": 15.056,
              "y": 7.398,
              "z": 0.121
            },
            "gtin": "4063367147944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4af",
            "leftCorner": {
              "x": 15.056,
              "y": 7.398,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.956,
              "y": 7.407,
              "z": 0.121
            },
            "gtin": "4063367147944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4b0",
            "leftCorner": {
              "x": 14.953,
              "y": 7.387,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.749,
              "y": 7.404,
              "z": 0.121
            },
            "gtin": "4337185865404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4b1",
            "leftCorner": {
              "x": 14.749,
              "y": 7.401,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.506,
              "y": 7.421,
              "z": 0.121
            },
            "gtin": "4063367147999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4b2",
            "leftCorner": {
              "x": 14.506,
              "y": 7.421,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.264,
              "y": 7.441,
              "z": 0.121
            },
            "gtin": "4063367147999",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54626a",
        "height": 0.54657,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d494",
            "leftCorner": {
              "x": 15.356,
              "y": 7.347,
              "z": 0.447
            },
            "rightCorner": {
              "x": 15.006,
              "y": 7.375,
              "z": 0.447
            },
            "gtin": "4337185865589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d495",
            "leftCorner": {
              "x": 15.008,
              "y": 7.391,
              "z": 0.447
            },
            "rightCorner": {
              "x": 14.908,
              "y": 7.399,
              "z": 0.447
            },
            "gtin": "4032844050527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d496",
            "leftCorner": {
              "x": 14.908,
              "y": 7.399,
              "z": 0.447
            },
            "rightCorner": {
              "x": 14.809,
              "y": 7.407,
              "z": 0.447
            },
            "gtin": "4032844050527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d497",
            "leftCorner": {
              "x": 14.809,
              "y": 7.407,
              "z": 0.447
            },
            "rightCorner": {
              "x": 14.711,
              "y": 7.415,
              "z": 0.447
            },
            "gtin": "4032844050527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d498",
            "leftCorner": {
              "x": 14.711,
              "y": 7.415,
              "z": 0.447
            },
            "rightCorner": {
              "x": 14.611,
              "y": 7.424,
              "z": 0.447
            },
            "gtin": "4032844050527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d499",
            "leftCorner": {
              "x": 14.611,
              "y": 7.417,
              "z": 0.447
            },
            "rightCorner": {
              "x": 14.441,
              "y": 7.431,
              "z": 0.447
            },
            "gtin": "4337185865596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d49a",
            "leftCorner": {
              "x": 14.441,
              "y": 7.425,
              "z": 0.447
            },
            "rightCorner": {
              "x": 14.289,
              "y": 7.437,
              "z": 0.447
            },
            "gtin": "4337185865923",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546267",
        "height": 0.94962,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d400",
            "leftCorner": {
              "x": 15.466,
              "y": 7.346,
              "z": 0.777
            },
            "rightCorner": {
              "x": 15.167,
              "y": 7.371,
              "z": 0.777
            },
            "gtin": "4032844050510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d401",
            "leftCorner": {
              "x": 15.167,
              "y": 7.37,
              "z": 0.777
            },
            "rightCorner": {
              "x": 15.07,
              "y": 7.378,
              "z": 0.777
            },
            "gtin": "4001120189800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d402",
            "leftCorner": {
              "x": 15.07,
              "y": 7.378,
              "z": 0.777
            },
            "rightCorner": {
              "x": 14.973,
              "y": 7.385,
              "z": 0.777
            },
            "gtin": "4001120189800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d403",
            "leftCorner": {
              "x": 14.973,
              "y": 7.385,
              "z": 0.777
            },
            "rightCorner": {
              "x": 14.877,
              "y": 7.393,
              "z": 0.777
            },
            "gtin": "4001120189800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d404",
            "leftCorner": {
              "x": 14.877,
              "y": 7.39,
              "z": 0.777
            },
            "rightCorner": {
              "x": 14.591,
              "y": 7.414,
              "z": 0.777
            },
            "gtin": "4337185865572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d405",
            "leftCorner": {
              "x": 14.593,
              "y": 7.423,
              "z": 0.777
            },
            "rightCorner": {
              "x": 14.307,
              "y": 7.446,
              "z": 0.777
            },
            "gtin": "8717703638691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d406",
            "leftCorner": {
              "x": 14.307,
              "y": 7.446,
              "z": 0.777
            },
            "rightCorner": {
              "x": 14.021,
              "y": 7.47,
              "z": 0.777
            },
            "gtin": "8717703638691",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546269",
        "height": 1.3551,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d4d1",
            "leftCorner": {
              "x": 15.446,
              "y": 7.345,
              "z": 1.109
            },
            "rightCorner": {
              "x": 15.236,
              "y": 7.362,
              "z": 1.109
            },
            "gtin": "4001120198307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4d2",
            "leftCorner": {
              "x": 15.236,
              "y": 7.362,
              "z": 1.109
            },
            "rightCorner": {
              "x": 15.028,
              "y": 7.379,
              "z": 1.109
            },
            "gtin": "4001120198307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4d3",
            "leftCorner": {
              "x": 15.028,
              "y": 7.379,
              "z": 1.109
            },
            "rightCorner": {
              "x": 14.82,
              "y": 7.396,
              "z": 1.109
            },
            "gtin": "4001120198307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4d4",
            "leftCorner": {
              "x": 14.82,
              "y": 7.406,
              "z": 1.109
            },
            "rightCorner": {
              "x": 14.686,
              "y": 7.417,
              "z": 1.109
            },
            "gtin": "4063367227561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4d5",
            "leftCorner": {
              "x": 14.686,
              "y": 7.417,
              "z": 1.109
            },
            "rightCorner": {
              "x": 14.551,
              "y": 7.428,
              "z": 1.109
            },
            "gtin": "4063367227561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4d6",
            "leftCorner": {
              "x": 14.551,
              "y": 7.428,
              "z": 1.109
            },
            "rightCorner": {
              "x": 14.417,
              "y": 7.439,
              "z": 1.109
            },
            "gtin": "4063367227561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4d7",
            "leftCorner": {
              "x": 14.417,
              "y": 7.439,
              "z": 1.109
            },
            "rightCorner": {
              "x": 14.282,
              "y": 7.45,
              "z": 1.109
            },
            "gtin": "4063367227561",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546268",
        "height": 1.7059,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d425",
            "leftCorner": {
              "x": 15.477,
              "y": 7.348,
              "z": 1.396
            },
            "rightCorner": {
              "x": 15.43,
              "y": 7.352,
              "z": 1.396
            },
            "gtin": "4032844050350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d426",
            "leftCorner": {
              "x": 15.43,
              "y": 7.352,
              "z": 1.396
            },
            "rightCorner": {
              "x": 15.383,
              "y": 7.356,
              "z": 1.396
            },
            "gtin": "4032844050350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d427",
            "leftCorner": {
              "x": 15.383,
              "y": 7.356,
              "z": 1.396
            },
            "rightCorner": {
              "x": 15.336,
              "y": 7.359,
              "z": 1.396
            },
            "gtin": "4032844050350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d428",
            "leftCorner": {
              "x": 15.336,
              "y": 7.359,
              "z": 1.396
            },
            "rightCorner": {
              "x": 15.29,
              "y": 7.363,
              "z": 1.396
            },
            "gtin": "4032844050350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d429",
            "leftCorner": {
              "x": 15.29,
              "y": 7.365,
              "z": 1.396
            },
            "rightCorner": {
              "x": 15.209,
              "y": 7.372,
              "z": 1.396
            },
            "gtin": "4032844050343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d42a",
            "leftCorner": {
              "x": 15.209,
              "y": 7.372,
              "z": 1.396
            },
            "rightCorner": {
              "x": 15.127,
              "y": 7.378,
              "z": 1.396
            },
            "gtin": "4032844050343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d42b",
            "leftCorner": {
              "x": 15.127,
              "y": 7.378,
              "z": 1.396
            },
            "rightCorner": {
              "x": 15.047,
              "y": 7.385,
              "z": 1.396
            },
            "gtin": "4032844050343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d42c",
            "leftCorner": {
              "x": 15.046,
              "y": 7.383,
              "z": 1.396
            },
            "rightCorner": {
              "x": 14.925,
              "y": 7.393,
              "z": 1.396
            },
            "gtin": "4032844050367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d42d",
            "leftCorner": {
              "x": 14.925,
              "y": 7.393,
              "z": 1.396
            },
            "rightCorner": {
              "x": 14.804,
              "y": 7.402,
              "z": 1.396
            },
            "gtin": "4032844050367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d42e",
            "leftCorner": {
              "x": 14.804,
              "y": 7.405,
              "z": 1.396
            },
            "rightCorner": {
              "x": 14.657,
              "y": 7.417,
              "z": 1.396
            },
            "gtin": "4063367227592",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d42f",
            "leftCorner": {
              "x": 14.657,
              "y": 7.417,
              "z": 1.396
            },
            "rightCorner": {
              "x": 14.509,
              "y": 7.429,
              "z": 1.396
            },
            "gtin": "4063367227592",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d430",
            "leftCorner": {
              "x": 14.51,
              "y": 7.437,
              "z": 1.396
            },
            "rightCorner": {
              "x": 14.38,
              "y": 7.448,
              "z": 1.396
            },
            "gtin": "4063367227479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d431",
            "leftCorner": {
              "x": 14.38,
              "y": 7.448,
              "z": 1.396
            },
            "rightCorner": {
              "x": 14.251,
              "y": 7.459,
              "z": 1.396
            },
            "gtin": "4063367227479",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f7c",
    "rightNeighborShelfId": "b6f82"
  },
  {
    "id": "b6f82",
    "name": "b6f82",
    "x": 14.316,
    "y": 7.492,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99937,
      "w": 0.035554
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 40
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54626f",
        "height": 0.14498,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d4b3",
            "leftCorner": {
              "x": 14.265,
              "y": 7.439,
              "z": 0.119
            },
            "rightCorner": {
              "x": 14.06,
              "y": 7.454,
              "z": 0.119
            },
            "gtin": "8001250120342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4b4",
            "leftCorner": {
              "x": 14.06,
              "y": 7.458,
              "z": 0.119
            },
            "rightCorner": {
              "x": 13.791,
              "y": 7.477,
              "z": 0.119
            },
            "gtin": "8001250120243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4b5",
            "leftCorner": {
              "x": 13.791,
              "y": 7.478,
              "z": 0.119
            },
            "rightCorner": {
              "x": 13.596,
              "y": 7.492,
              "z": 0.119
            },
            "gtin": "8001250120410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4b6",
            "leftCorner": {
              "x": 13.596,
              "y": 7.492,
              "z": 0.119
            },
            "rightCorner": {
              "x": 13.4,
              "y": 7.506,
              "z": 0.119
            },
            "gtin": "8001250120410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4b7",
            "leftCorner": {
              "x": 13.401,
              "y": 7.509,
              "z": 0.119
            },
            "rightCorner": {
              "x": 13.212,
              "y": 7.522,
              "z": 0.119
            },
            "gtin": "8001250120502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4b8",
            "leftCorner": {
              "x": 13.212,
              "y": 7.522,
              "z": 0.119
            },
            "rightCorner": {
              "x": 13.024,
              "y": 7.536,
              "z": 0.119
            },
            "gtin": "8001250120502",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54626c",
        "height": 0.54584,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d49b",
            "leftCorner": {
              "x": 14.293,
              "y": 7.464,
              "z": 0.447
            },
            "rightCorner": {
              "x": 14.142,
              "y": 7.475,
              "z": 0.447
            },
            "gtin": "8001250120076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d49c",
            "leftCorner": {
              "x": 14.142,
              "y": 7.475,
              "z": 0.447
            },
            "rightCorner": {
              "x": 13.99,
              "y": 7.486,
              "z": 0.447
            },
            "gtin": "8001250120076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d49d",
            "leftCorner": {
              "x": 13.99,
              "y": 7.48,
              "z": 0.447
            },
            "rightCorner": {
              "x": 13.717,
              "y": 7.5,
              "z": 0.447
            },
            "gtin": "8001250120113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d49e",
            "leftCorner": {
              "x": 13.717,
              "y": 7.5,
              "z": 0.447
            },
            "rightCorner": {
              "x": 13.443,
              "y": 7.519,
              "z": 0.447
            },
            "gtin": "8001250120113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d49f",
            "leftCorner": {
              "x": 13.441,
              "y": 7.485,
              "z": 0.447
            },
            "rightCorner": {
              "x": 13.074,
              "y": 7.511,
              "z": 0.447
            },
            "gtin": "8001250120120",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546270",
        "height": 0.94819,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d407",
            "leftCorner": {
              "x": 14.022,
              "y": 7.462,
              "z": 0.776
            },
            "rightCorner": {
              "x": 13.939,
              "y": 7.468,
              "z": 0.776
            },
            "gtin": "4316734116037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d408",
            "leftCorner": {
              "x": 13.939,
              "y": 7.468,
              "z": 0.776
            },
            "rightCorner": {
              "x": 13.856,
              "y": 7.474,
              "z": 0.776
            },
            "gtin": "4316734116037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d409",
            "leftCorner": {
              "x": 13.857,
              "y": 7.477,
              "z": 0.776
            },
            "rightCorner": {
              "x": 13.614,
              "y": 7.494,
              "z": 0.776
            },
            "gtin": "4023900545460",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d40a",
            "leftCorner": {
              "x": 13.614,
              "y": 7.489,
              "z": 0.776
            },
            "rightCorner": {
              "x": 13.438,
              "y": 7.502,
              "z": 0.776
            },
            "gtin": "4023900545422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d40b",
            "leftCorner": {
              "x": 13.438,
              "y": 7.494,
              "z": 0.776
            },
            "rightCorner": {
              "x": 13.188,
              "y": 7.512,
              "z": 0.776
            },
            "gtin": "4032844050305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d40c",
            "leftCorner": {
              "x": 13.189,
              "y": 7.519,
              "z": 0.776
            },
            "rightCorner": {
              "x": 13.123,
              "y": 7.523,
              "z": 0.776
            },
            "gtin": "4023900545606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d40d",
            "leftCorner": {
              "x": 13.123,
              "y": 7.523,
              "z": 0.776
            },
            "rightCorner": {
              "x": 13.056,
              "y": 7.528,
              "z": 0.776
            },
            "gtin": "4023900545606",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54626d",
        "height": 1.3541,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d4d8",
            "leftCorner": {
              "x": 14.284,
              "y": 7.454,
              "z": 1.108
            },
            "rightCorner": {
              "x": 14.173,
              "y": 7.462,
              "z": 1.108
            },
            "gtin": "8004690158814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4d9",
            "leftCorner": {
              "x": 14.173,
              "y": 7.462,
              "z": 1.108
            },
            "rightCorner": {
              "x": 14.062,
              "y": 7.47,
              "z": 1.108
            },
            "gtin": "8004690158814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4da",
            "leftCorner": {
              "x": 14.063,
              "y": 7.474,
              "z": 1.108
            },
            "rightCorner": {
              "x": 13.954,
              "y": 7.481,
              "z": 1.108
            },
            "gtin": "5201013014502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4db",
            "leftCorner": {
              "x": 13.954,
              "y": 7.481,
              "z": 1.108
            },
            "rightCorner": {
              "x": 13.844,
              "y": 7.489,
              "z": 1.108
            },
            "gtin": "5201013014502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4dc",
            "leftCorner": {
              "x": 13.844,
              "y": 7.489,
              "z": 1.108
            },
            "rightCorner": {
              "x": 13.735,
              "y": 7.497,
              "z": 1.108
            },
            "gtin": "5201013014502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4dd",
            "leftCorner": {
              "x": 13.735,
              "y": 7.482,
              "z": 1.108
            },
            "rightCorner": {
              "x": 13.678,
              "y": 7.486,
              "z": 1.108
            },
            "gtin": "4023900545644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4de",
            "leftCorner": {
              "x": 13.678,
              "y": 7.486,
              "z": 1.108
            },
            "rightCorner": {
              "x": 13.621,
              "y": 7.49,
              "z": 1.108
            },
            "gtin": "4023900545644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4df",
            "leftCorner": {
              "x": 13.621,
              "y": 7.49,
              "z": 1.108
            },
            "rightCorner": {
              "x": 13.565,
              "y": 7.494,
              "z": 1.108
            },
            "gtin": "4023900545644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4e0",
            "leftCorner": {
              "x": 13.565,
              "y": 7.485,
              "z": 1.108
            },
            "rightCorner": {
              "x": 13.423,
              "y": 7.495,
              "z": 1.108
            },
            "gtin": "4023900545101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4e1",
            "leftCorner": {
              "x": 13.422,
              "y": 7.487,
              "z": 1.108
            },
            "rightCorner": {
              "x": 13.206,
              "y": 7.503,
              "z": 1.108
            },
            "gtin": "4023900545385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4e2",
            "leftCorner": {
              "x": 13.206,
              "y": 7.503,
              "z": 1.108
            },
            "rightCorner": {
              "x": 12.989,
              "y": 7.518,
              "z": 1.108
            },
            "gtin": "4023900545385",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54626e",
        "height": 1.7027,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d432",
            "leftCorner": {
              "x": 14.252,
              "y": 7.455,
              "z": 1.393
            },
            "rightCorner": {
              "x": 14.13,
              "y": 7.464,
              "z": 1.393
            },
            "gtin": "4063367283185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d433",
            "leftCorner": {
              "x": 14.13,
              "y": 7.464,
              "z": 1.393
            },
            "rightCorner": {
              "x": 14.009,
              "y": 7.473,
              "z": 1.393
            },
            "gtin": "4063367283185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d434",
            "leftCorner": {
              "x": 14.008,
              "y": 7.47,
              "z": 1.393
            },
            "rightCorner": {
              "x": 13.898,
              "y": 7.478,
              "z": 1.393
            },
            "gtin": "4063367315565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d435",
            "leftCorner": {
              "x": 13.898,
              "y": 7.478,
              "z": 1.393
            },
            "rightCorner": {
              "x": 13.786,
              "y": 7.486,
              "z": 1.393
            },
            "gtin": "4063367315565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d436",
            "leftCorner": {
              "x": 13.786,
              "y": 7.48,
              "z": 1.393
            },
            "rightCorner": {
              "x": 13.705,
              "y": 7.485,
              "z": 1.393
            },
            "gtin": "4006196099251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d437",
            "leftCorner": {
              "x": 13.705,
              "y": 7.485,
              "z": 1.393
            },
            "rightCorner": {
              "x": 13.625,
              "y": 7.491,
              "z": 1.393
            },
            "gtin": "4006196099251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d438",
            "leftCorner": {
              "x": 13.625,
              "y": 7.491,
              "z": 1.393
            },
            "rightCorner": {
              "x": 13.545,
              "y": 7.497,
              "z": 1.393
            },
            "gtin": "4006196099251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d439",
            "leftCorner": {
              "x": 13.545,
              "y": 7.49,
              "z": 1.393
            },
            "rightCorner": {
              "x": 13.354,
              "y": 7.503,
              "z": 1.393
            },
            "gtin": "4006196029531",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d43a",
            "leftCorner": {
              "x": 13.356,
              "y": 7.517,
              "z": 1.393
            },
            "rightCorner": {
              "x": 13.275,
              "y": 7.523,
              "z": 1.393
            },
            "gtin": "4006196029524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d43b",
            "leftCorner": {
              "x": 13.275,
              "y": 7.523,
              "z": 1.393
            },
            "rightCorner": {
              "x": 13.195,
              "y": 7.529,
              "z": 1.393
            },
            "gtin": "4006196029524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d43c",
            "leftCorner": {
              "x": 13.195,
              "y": 7.529,
              "z": 1.393
            },
            "rightCorner": {
              "x": 13.116,
              "y": 7.534,
              "z": 1.393
            },
            "gtin": "4006196029524",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f81",
    "rightNeighborShelfId": "b6f83"
  },
  {
    "id": "b6f83",
    "name": "b6f83",
    "x": 13.119,
    "y": 7.577,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99937,
      "w": 0.035554
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 45
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546275",
        "height": 0.14644,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d4b9",
            "leftCorner": {
              "x": 13.025,
              "y": 7.53,
              "z": 0.12
            },
            "rightCorner": {
              "x": 12.758,
              "y": 7.549,
              "z": 0.12
            },
            "gtin": "4006196029630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4ba",
            "leftCorner": {
              "x": 12.758,
              "y": 7.549,
              "z": 0.12
            },
            "rightCorner": {
              "x": 12.489,
              "y": 7.568,
              "z": 0.12
            },
            "gtin": "4006196029630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4bb",
            "leftCorner": {
              "x": 12.489,
              "y": 7.568,
              "z": 0.12
            },
            "rightCorner": {
              "x": 12.222,
              "y": 7.587,
              "z": 0.12
            },
            "gtin": "4006196029630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4bc",
            "leftCorner": {
              "x": 12.222,
              "y": 7.597,
              "z": 0.12
            },
            "rightCorner": {
              "x": 12.143,
              "y": 7.602,
              "z": 0.12
            },
            "gtin": "4006196029647",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4bd",
            "leftCorner": {
              "x": 12.143,
              "y": 7.602,
              "z": 0.12
            },
            "rightCorner": {
              "x": 12.063,
              "y": 7.608,
              "z": 0.12
            },
            "gtin": "4006196029647",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4be",
            "leftCorner": {
              "x": 12.063,
              "y": 7.608,
              "z": 0.12
            },
            "rightCorner": {
              "x": 11.983,
              "y": 7.614,
              "z": 0.12
            },
            "gtin": "4006196029647",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4bf",
            "leftCorner": {
              "x": 11.983,
              "y": 7.614,
              "z": 0.12
            },
            "rightCorner": {
              "x": 11.903,
              "y": 7.619,
              "z": 0.12
            },
            "gtin": "4006196029647",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546272",
        "height": 0.54503,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d4a0",
            "leftCorner": {
              "x": 13.075,
              "y": 7.526,
              "z": 0.446
            },
            "rightCorner": {
              "x": 12.829,
              "y": 7.543,
              "z": 0.446
            },
            "gtin": "8004690210666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4a1",
            "leftCorner": {
              "x": 12.83,
              "y": 7.546,
              "z": 0.446
            },
            "rightCorner": {
              "x": 12.715,
              "y": 7.554,
              "z": 0.446
            },
            "gtin": "8004690313190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4a2",
            "leftCorner": {
              "x": 12.715,
              "y": 7.554,
              "z": 0.446
            },
            "rightCorner": {
              "x": 12.6,
              "y": 7.562,
              "z": 0.446
            },
            "gtin": "8004690313190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4a3",
            "leftCorner": {
              "x": 12.6,
              "y": 7.562,
              "z": 0.446
            },
            "rightCorner": {
              "x": 12.485,
              "y": 7.57,
              "z": 0.446
            },
            "gtin": "8004690313190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4a4",
            "leftCorner": {
              "x": 12.485,
              "y": 7.572,
              "z": 0.446
            },
            "rightCorner": {
              "x": 12.176,
              "y": 7.594,
              "z": 0.446
            },
            "gtin": "8004690310625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d489",
            "leftCorner": {
              "x": 12.176,
              "y": 7.587,
              "z": 0.446
            },
            "rightCorner": {
              "x": 12.09,
              "y": 7.594,
              "z": 0.446
            },
            "gtin": "8004690313190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d48a",
            "leftCorner": {
              "x": 12.09,
              "y": 7.594,
              "z": 0.446
            },
            "rightCorner": {
              "x": 12.004,
              "y": 7.6,
              "z": 0.446
            },
            "gtin": "8004690313190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d48b",
            "leftCorner": {
              "x": 12.004,
              "y": 7.6,
              "z": 0.446
            },
            "rightCorner": {
              "x": 11.918,
              "y": 7.606,
              "z": 0.446
            },
            "gtin": "8004690313190",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546273",
        "height": 0.94788,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d40e",
            "leftCorner": {
              "x": 13.057,
              "y": 7.528,
              "z": 0.776
            },
            "rightCorner": {
              "x": 12.636,
              "y": 7.558,
              "z": 0.776
            },
            "gtin": "8004690312025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d40f",
            "leftCorner": {
              "x": 12.636,
              "y": 7.558,
              "z": 0.776
            },
            "rightCorner": {
              "x": 12.215,
              "y": 7.588,
              "z": 0.776
            },
            "gtin": "8004690312025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3f9",
            "leftCorner": {
              "x": 12.215,
              "y": 7.584,
              "z": 0.776
            },
            "rightCorner": {
              "x": 12.066,
              "y": 7.595,
              "z": 0.776
            },
            "gtin": "8004690311547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3fa",
            "leftCorner": {
              "x": 12.066,
              "y": 7.595,
              "z": 0.776
            },
            "rightCorner": {
              "x": 11.918,
              "y": 7.605,
              "z": 0.776
            },
            "gtin": "8004690311547",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546274",
        "height": 1.3524,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d4e3",
            "leftCorner": {
              "x": 12.99,
              "y": 7.539,
              "z": 1.107
            },
            "rightCorner": {
              "x": 12.83,
              "y": 7.55,
              "z": 1.107
            },
            "gtin": "8004690158869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4e4",
            "leftCorner": {
              "x": 12.83,
              "y": 7.55,
              "z": 1.107
            },
            "rightCorner": {
              "x": 12.67,
              "y": 7.561,
              "z": 1.107
            },
            "gtin": "8004690158869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4e5",
            "leftCorner": {
              "x": 12.668,
              "y": 7.546,
              "z": 1.107
            },
            "rightCorner": {
              "x": 12.554,
              "y": 7.554,
              "z": 1.107
            },
            "gtin": "4316734116044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4e6",
            "leftCorner": {
              "x": 12.554,
              "y": 7.559,
              "z": 1.107
            },
            "rightCorner": {
              "x": 12.451,
              "y": 7.567,
              "z": 1.107
            },
            "gtin": "4023900545361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4e7",
            "leftCorner": {
              "x": 12.451,
              "y": 7.567,
              "z": 1.107
            },
            "rightCorner": {
              "x": 12.348,
              "y": 7.574,
              "z": 1.107
            },
            "gtin": "4023900545361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4e8",
            "leftCorner": {
              "x": 12.348,
              "y": 7.574,
              "z": 1.107
            },
            "rightCorner": {
              "x": 12.246,
              "y": 7.581,
              "z": 1.107
            },
            "gtin": "4023900545361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4e9",
            "leftCorner": {
              "x": 12.246,
              "y": 7.592,
              "z": 1.107
            },
            "rightCorner": {
              "x": 12.11,
              "y": 7.602,
              "z": 1.107
            },
            "gtin": "4023900535409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4c8",
            "leftCorner": {
              "x": 12.11,
              "y": 7.607,
              "z": 1.107
            },
            "rightCorner": {
              "x": 12.015,
              "y": 7.613,
              "z": 1.107
            },
            "gtin": "4316734116044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4c9",
            "leftCorner": {
              "x": 12.015,
              "y": 7.613,
              "z": 1.107
            },
            "rightCorner": {
              "x": 11.919,
              "y": 7.62,
              "z": 1.107
            },
            "gtin": "4316734116044",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546271",
        "height": 1.7027,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d43d",
            "leftCorner": {
              "x": 13.115,
              "y": 7.528,
              "z": 1.393
            },
            "rightCorner": {
              "x": 12.996,
              "y": 7.537,
              "z": 1.393
            },
            "gtin": "4000186032204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d43e",
            "leftCorner": {
              "x": 12.996,
              "y": 7.537,
              "z": 1.393
            },
            "rightCorner": {
              "x": 12.878,
              "y": 7.545,
              "z": 1.393
            },
            "gtin": "4000186032204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d43f",
            "leftCorner": {
              "x": 12.877,
              "y": 7.539,
              "z": 1.393
            },
            "rightCorner": {
              "x": 12.784,
              "y": 7.546,
              "z": 1.393
            },
            "gtin": "4000186035502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d440",
            "leftCorner": {
              "x": 12.784,
              "y": 7.546,
              "z": 1.393
            },
            "rightCorner": {
              "x": 12.693,
              "y": 7.552,
              "z": 1.393
            },
            "gtin": "4000186035502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d441",
            "leftCorner": {
              "x": 12.692,
              "y": 7.549,
              "z": 1.393
            },
            "rightCorner": {
              "x": 12.596,
              "y": 7.556,
              "z": 1.393
            },
            "gtin": "4000186036899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d442",
            "leftCorner": {
              "x": 12.596,
              "y": 7.556,
              "z": 1.393
            },
            "rightCorner": {
              "x": 12.499,
              "y": 7.563,
              "z": 1.393
            },
            "gtin": "4000186036899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d443",
            "leftCorner": {
              "x": 12.499,
              "y": 7.56,
              "z": 1.393
            },
            "rightCorner": {
              "x": 12.452,
              "y": 7.564,
              "z": 1.393
            },
            "gtin": "4000186035809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d444",
            "leftCorner": {
              "x": 12.452,
              "y": 7.564,
              "z": 1.393
            },
            "rightCorner": {
              "x": 12.405,
              "y": 7.567,
              "z": 1.393
            },
            "gtin": "4000186035809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d445",
            "leftCorner": {
              "x": 12.405,
              "y": 7.567,
              "z": 1.393
            },
            "rightCorner": {
              "x": 12.358,
              "y": 7.57,
              "z": 1.393
            },
            "gtin": "4000186035809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d446",
            "leftCorner": {
              "x": 12.358,
              "y": 7.57,
              "z": 1.393
            },
            "rightCorner": {
              "x": 12.312,
              "y": 7.574,
              "z": 1.393
            },
            "gtin": "4000186035809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d447",
            "leftCorner": {
              "x": 12.313,
              "y": 7.581,
              "z": 1.393
            },
            "rightCorner": {
              "x": 12.261,
              "y": 7.585,
              "z": 1.393
            },
            "gtin": "4000186033065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d448",
            "leftCorner": {
              "x": 12.261,
              "y": 7.585,
              "z": 1.393
            },
            "rightCorner": {
              "x": 12.21,
              "y": 7.589,
              "z": 1.393
            },
            "gtin": "4000186033065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d449",
            "leftCorner": {
              "x": 12.21,
              "y": 7.589,
              "z": 1.393
            },
            "rightCorner": {
              "x": 12.159,
              "y": 7.592,
              "z": 1.393
            },
            "gtin": "4000186033065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d44a",
            "leftCorner": {
              "x": 12.159,
              "y": 7.592,
              "z": 1.393
            },
            "rightCorner": {
              "x": 12.107,
              "y": 7.596,
              "z": 1.393
            },
            "gtin": "4000186033065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d44b",
            "leftCorner": {
              "x": 12.107,
              "y": 7.598,
              "z": 1.393
            },
            "rightCorner": {
              "x": 12.043,
              "y": 7.603,
              "z": 1.393
            },
            "gtin": "4000186110568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d44c",
            "leftCorner": {
              "x": 12.043,
              "y": 7.603,
              "z": 1.393
            },
            "rightCorner": {
              "x": 11.978,
              "y": 7.607,
              "z": 1.393
            },
            "gtin": "4000186110568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d44d",
            "leftCorner": {
              "x": 11.978,
              "y": 7.607,
              "z": 1.393
            },
            "rightCorner": {
              "x": 11.913,
              "y": 7.612,
              "z": 1.393
            },
            "gtin": "4000186110568",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f82",
    "rightNeighborShelfId": "b6f84"
  },
  {
    "id": "b6f84",
    "name": "b6f84",
    "x": 11.922,
    "y": 7.663,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99937,
      "w": 0.035554
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 75
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546278",
        "height": 1.11,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dc59",
            "leftCorner": {
              "x": 11.741,
              "y": 7.627,
              "z": 0.908
            },
            "rightCorner": {
              "x": 11.651,
              "y": 7.633,
              "z": 0.908
            },
            "gtin": "42421801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc5a",
            "leftCorner": {
              "x": 11.651,
              "y": 7.633,
              "z": 0.908
            },
            "rightCorner": {
              "x": 11.561,
              "y": 7.64,
              "z": 0.908
            },
            "gtin": "42421801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc5b",
            "leftCorner": {
              "x": 11.56,
              "y": 7.623,
              "z": 0.908
            },
            "rightCorner": {
              "x": 11.491,
              "y": 7.628,
              "z": 0.908
            },
            "gtin": "4038700117595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc5c",
            "leftCorner": {
              "x": 11.491,
              "y": 7.628,
              "z": 0.908
            },
            "rightCorner": {
              "x": 11.422,
              "y": 7.632,
              "z": 0.908
            },
            "gtin": "4038700117595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc5d",
            "leftCorner": {
              "x": 11.423,
              "y": 7.638,
              "z": 0.908
            },
            "rightCorner": {
              "x": 11.366,
              "y": 7.642,
              "z": 0.908
            },
            "gtin": "4038700117373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc5e",
            "leftCorner": {
              "x": 11.366,
              "y": 7.642,
              "z": 0.908
            },
            "rightCorner": {
              "x": 11.31,
              "y": 7.646,
              "z": 0.908
            },
            "gtin": "4038700117373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc5f",
            "leftCorner": {
              "x": 11.31,
              "y": 7.646,
              "z": 0.908
            },
            "rightCorner": {
              "x": 11.254,
              "y": 7.65,
              "z": 0.908
            },
            "gtin": "4038700117373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc60",
            "leftCorner": {
              "x": 11.255,
              "y": 7.658,
              "z": 0.908
            },
            "rightCorner": {
              "x": 11.179,
              "y": 7.663,
              "z": 0.908
            },
            "gtin": "8710604725569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc61",
            "leftCorner": {
              "x": 11.179,
              "y": 7.663,
              "z": 0.908
            },
            "rightCorner": {
              "x": 11.104,
              "y": 7.669,
              "z": 0.908
            },
            "gtin": "8710604725569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc62",
            "leftCorner": {
              "x": 11.104,
              "y": 7.669,
              "z": 0.908
            },
            "rightCorner": {
              "x": 11.029,
              "y": 7.674,
              "z": 0.908
            },
            "gtin": "8710604725569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc63",
            "leftCorner": {
              "x": 11.029,
              "y": 7.676,
              "z": 0.908
            },
            "rightCorner": {
              "x": 10.977,
              "y": 7.68,
              "z": 0.908
            },
            "gtin": "4038700117403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc64",
            "leftCorner": {
              "x": 10.977,
              "y": 7.68,
              "z": 0.908
            },
            "rightCorner": {
              "x": 10.925,
              "y": 7.683,
              "z": 0.908
            },
            "gtin": "4038700117403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc65",
            "leftCorner": {
              "x": 10.925,
              "y": 7.683,
              "z": 0.908
            },
            "rightCorner": {
              "x": 10.873,
              "y": 7.687,
              "z": 0.908
            },
            "gtin": "4038700117403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc66",
            "leftCorner": {
              "x": 10.873,
              "y": 7.692,
              "z": 0.908
            },
            "rightCorner": {
              "x": 10.783,
              "y": 7.698,
              "z": 0.908
            },
            "gtin": "8712566237067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc67",
            "leftCorner": {
              "x": 10.783,
              "y": 7.698,
              "z": 0.908
            },
            "rightCorner": {
              "x": 10.693,
              "y": 7.705,
              "z": 0.908
            },
            "gtin": "8712566237067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc56",
            "leftCorner": {
              "x": 11.921,
              "y": 7.65,
              "z": 0.908
            },
            "rightCorner": {
              "x": 11.832,
              "y": 7.656,
              "z": 0.908
            },
            "gtin": "42421832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc57",
            "leftCorner": {
              "x": 11.832,
              "y": 7.656,
              "z": 0.908
            },
            "rightCorner": {
              "x": 11.743,
              "y": 7.662,
              "z": 0.908
            },
            "gtin": "42421832",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546277",
        "height": 1.4038,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dc1e",
            "leftCorner": {
              "x": 11.921,
              "y": 7.656,
              "z": 1.149
            },
            "rightCorner": {
              "x": 11.854,
              "y": 7.661,
              "z": 1.149
            },
            "gtin": "40056289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc1f",
            "leftCorner": {
              "x": 11.854,
              "y": 7.661,
              "z": 1.149
            },
            "rightCorner": {
              "x": 11.785,
              "y": 7.665,
              "z": 1.149
            },
            "gtin": "40056289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc21",
            "leftCorner": {
              "x": 11.782,
              "y": 7.627,
              "z": 1.149
            },
            "rightCorner": {
              "x": 11.63,
              "y": 7.638,
              "z": 1.149
            },
            "gtin": "42420989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc22",
            "leftCorner": {
              "x": 11.63,
              "y": 7.635,
              "z": 1.149
            },
            "rightCorner": {
              "x": 11.58,
              "y": 7.639,
              "z": 1.149
            },
            "gtin": "40057705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc23",
            "leftCorner": {
              "x": 11.58,
              "y": 7.639,
              "z": 1.149
            },
            "rightCorner": {
              "x": 11.529,
              "y": 7.642,
              "z": 1.149
            },
            "gtin": "40057705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc24",
            "leftCorner": {
              "x": 11.529,
              "y": 7.642,
              "z": 1.149
            },
            "rightCorner": {
              "x": 11.394,
              "y": 7.652,
              "z": 1.149
            },
            "gtin": "42353430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc25",
            "leftCorner": {
              "x": 11.394,
              "y": 7.65,
              "z": 1.149
            },
            "rightCorner": {
              "x": 11.233,
              "y": 7.662,
              "z": 1.149
            },
            "gtin": "40345628",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c855ed67a01d9a1dc26",
            "leftCorner": {
              "x": 11.233,
              "y": 7.664,
              "z": 1.149
            },
            "rightCorner": {
              "x": 11.074,
              "y": 7.675,
              "z": 1.149
            },
            "gtin": "40056265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc27",
            "leftCorner": {
              "x": 11.073,
              "y": 7.674,
              "z": 1.149
            },
            "rightCorner": {
              "x": 10.985,
              "y": 7.68,
              "z": 1.149
            },
            "gtin": "40052861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc28",
            "leftCorner": {
              "x": 10.986,
              "y": 7.692,
              "z": 1.149
            },
            "rightCorner": {
              "x": 10.891,
              "y": 7.698,
              "z": 1.149
            },
            "gtin": "40052168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc29",
            "leftCorner": {
              "x": 10.891,
              "y": 7.698,
              "z": 1.149
            },
            "rightCorner": {
              "x": 10.797,
              "y": 7.705,
              "z": 1.149
            },
            "gtin": "40052168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc2a",
            "leftCorner": {
              "x": 10.797,
              "y": 7.707,
              "z": 1.149
            },
            "rightCorner": {
              "x": 10.657,
              "y": 7.717,
              "z": 1.149
            },
            "gtin": "40056296",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546276",
        "height": 1.7034,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d44e",
            "leftCorner": {
              "x": 11.913,
              "y": 7.622,
              "z": 1.394
            },
            "rightCorner": {
              "x": 11.847,
              "y": 7.627,
              "z": 1.394
            },
            "gtin": "40057835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d44f",
            "leftCorner": {
              "x": 11.847,
              "y": 7.627,
              "z": 1.394
            },
            "rightCorner": {
              "x": 11.781,
              "y": 7.631,
              "z": 1.394
            },
            "gtin": "40057835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d450",
            "leftCorner": {
              "x": 11.781,
              "y": 7.629,
              "z": 1.394
            },
            "rightCorner": {
              "x": 11.706,
              "y": 7.634,
              "z": 1.394
            },
            "gtin": "40057842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d451",
            "leftCorner": {
              "x": 11.706,
              "y": 7.634,
              "z": 1.394
            },
            "rightCorner": {
              "x": 11.632,
              "y": 7.64,
              "z": 1.394
            },
            "gtin": "40057842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d452",
            "leftCorner": {
              "x": 11.632,
              "y": 7.637,
              "z": 1.394
            },
            "rightCorner": {
              "x": 11.558,
              "y": 7.642,
              "z": 1.394
            },
            "gtin": "40052229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d453",
            "leftCorner": {
              "x": 11.558,
              "y": 7.642,
              "z": 1.394
            },
            "rightCorner": {
              "x": 11.484,
              "y": 7.648,
              "z": 1.394
            },
            "gtin": "40052229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d454",
            "leftCorner": {
              "x": 11.484,
              "y": 7.648,
              "z": 1.394
            },
            "rightCorner": {
              "x": 11.41,
              "y": 7.653,
              "z": 1.394
            },
            "gtin": "40052229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d455",
            "leftCorner": {
              "x": 11.41,
              "y": 7.651,
              "z": 1.394
            },
            "rightCorner": {
              "x": 11.34,
              "y": 7.656,
              "z": 1.394
            },
            "gtin": "40345031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d456",
            "leftCorner": {
              "x": 11.34,
              "y": 7.656,
              "z": 1.394
            },
            "rightCorner": {
              "x": 11.27,
              "y": 7.661,
              "z": 1.394
            },
            "gtin": "40345031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d457",
            "leftCorner": {
              "x": 11.27,
              "y": 7.661,
              "z": 1.394
            },
            "rightCorner": {
              "x": 11.129,
              "y": 7.671,
              "z": 1.394
            },
            "gtin": "40056272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d458",
            "leftCorner": {
              "x": 11.129,
              "y": 7.672,
              "z": 1.394
            },
            "rightCorner": {
              "x": 10.995,
              "y": 7.682,
              "z": 1.394
            },
            "gtin": "40052472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d459",
            "leftCorner": {
              "x": 10.995,
              "y": 7.686,
              "z": 1.394
            },
            "rightCorner": {
              "x": 10.827,
              "y": 7.698,
              "z": 1.394
            },
            "gtin": "4030800076642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d45a",
            "leftCorner": {
              "x": 10.827,
              "y": 7.698,
              "z": 1.394
            },
            "rightCorner": {
              "x": 10.657,
              "y": 7.71,
              "z": 1.394
            },
            "gtin": "4030800076642",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54627b",
        "height": 0.14729,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d4c0",
            "leftCorner": {
              "x": 11.903,
              "y": 7.609,
              "z": 0.121
            },
            "rightCorner": {
              "x": 11.757,
              "y": 7.62,
              "z": 0.121
            },
            "gtin": "4008585103174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4c1",
            "leftCorner": {
              "x": 11.757,
              "y": 7.62,
              "z": 0.121
            },
            "rightCorner": {
              "x": 11.612,
              "y": 7.63,
              "z": 0.121
            },
            "gtin": "4008585103174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4c2",
            "leftCorner": {
              "x": 11.612,
              "y": 7.63,
              "z": 0.121
            },
            "rightCorner": {
              "x": 11.521,
              "y": 7.637,
              "z": 0.121
            },
            "gtin": "4008585103198",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4c3",
            "leftCorner": {
              "x": 11.521,
              "y": 7.637,
              "z": 0.121
            },
            "rightCorner": {
              "x": 11.43,
              "y": 7.643,
              "z": 0.121
            },
            "gtin": "4008585103198",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4c4",
            "leftCorner": {
              "x": 11.43,
              "y": 7.643,
              "z": 0.121
            },
            "rightCorner": {
              "x": 11.339,
              "y": 7.649,
              "z": 0.121
            },
            "gtin": "4008585103198",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4c5",
            "leftCorner": {
              "x": 11.339,
              "y": 7.648,
              "z": 0.121
            },
            "rightCorner": {
              "x": 11.225,
              "y": 7.656,
              "z": 0.121
            },
            "gtin": "4008585103181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4c6",
            "leftCorner": {
              "x": 11.225,
              "y": 7.656,
              "z": 0.121
            },
            "rightCorner": {
              "x": 11.113,
              "y": 7.664,
              "z": 0.121
            },
            "gtin": "4008585103181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4c7",
            "leftCorner": {
              "x": 11.113,
              "y": 7.664,
              "z": 0.121
            },
            "rightCorner": {
              "x": 11.0,
              "y": 7.672,
              "z": 0.121
            },
            "gtin": "4008585103181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4a5",
            "leftCorner": {
              "x": 11.0,
              "y": 7.674,
              "z": 0.121
            },
            "rightCorner": {
              "x": 10.944,
              "y": 7.678,
              "z": 0.121
            },
            "gtin": "4030800064410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4a6",
            "leftCorner": {
              "x": 10.944,
              "y": 7.678,
              "z": 0.121
            },
            "rightCorner": {
              "x": 10.888,
              "y": 7.682,
              "z": 0.121
            },
            "gtin": "4030800064410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4a7",
            "leftCorner": {
              "x": 10.888,
              "y": 7.682,
              "z": 0.121
            },
            "rightCorner": {
              "x": 10.833,
              "y": 7.686,
              "z": 0.121
            },
            "gtin": "4030800064410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4a8",
            "leftCorner": {
              "x": 10.833,
              "y": 7.686,
              "z": 0.121
            },
            "rightCorner": {
              "x": 10.778,
              "y": 7.689,
              "z": 0.121
            },
            "gtin": "4030800064410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4a9",
            "leftCorner": {
              "x": 10.778,
              "y": 7.689,
              "z": 0.121
            },
            "rightCorner": {
              "x": 10.722,
              "y": 7.693,
              "z": 0.121
            },
            "gtin": "4030800064410",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54627a",
        "height": 0.44821,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dc91",
            "leftCorner": {
              "x": 11.921,
              "y": 7.65,
              "z": 0.367
            },
            "rightCorner": {
              "x": 11.631,
              "y": 7.671,
              "z": 0.367
            },
            "gtin": "8004690313138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc92",
            "leftCorner": {
              "x": 11.631,
              "y": 7.671,
              "z": 0.367
            },
            "rightCorner": {
              "x": 11.339,
              "y": 7.691,
              "z": 0.367
            },
            "gtin": "8004690313138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc93",
            "leftCorner": {
              "x": 11.339,
              "y": 7.691,
              "z": 0.367
            },
            "rightCorner": {
              "x": 11.049,
              "y": 7.712,
              "z": 0.367
            },
            "gtin": "8004690313138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc94",
            "leftCorner": {
              "x": 11.046,
              "y": 7.672,
              "z": 0.367
            },
            "rightCorner": {
              "x": 10.884,
              "y": 7.683,
              "z": 0.367
            },
            "gtin": "8004690158845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc95",
            "leftCorner": {
              "x": 10.884,
              "y": 7.683,
              "z": 0.367
            },
            "rightCorner": {
              "x": 10.722,
              "y": 7.695,
              "z": 0.367
            },
            "gtin": "8004690158845",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546279",
        "height": 0.74935,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dc81",
            "leftCorner": {
              "x": 11.921,
              "y": 7.646,
              "z": 0.613
            },
            "rightCorner": {
              "x": 11.835,
              "y": 7.652,
              "z": 0.613
            },
            "gtin": "8714100890363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc82",
            "leftCorner": {
              "x": 11.835,
              "y": 7.652,
              "z": 0.613
            },
            "rightCorner": {
              "x": 11.748,
              "y": 7.658,
              "z": 0.613
            },
            "gtin": "8714100890363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc83",
            "leftCorner": {
              "x": 11.748,
              "y": 7.658,
              "z": 0.613
            },
            "rightCorner": {
              "x": 11.661,
              "y": 7.664,
              "z": 0.613
            },
            "gtin": "8714100890363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc86",
            "leftCorner": {
              "x": 11.659,
              "y": 7.619,
              "z": 0.613
            },
            "rightCorner": {
              "x": 11.599,
              "y": 7.623,
              "z": 0.613
            },
            "gtin": "4063367431838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc87",
            "leftCorner": {
              "x": 11.599,
              "y": 7.623,
              "z": 0.613
            },
            "rightCorner": {
              "x": 11.54,
              "y": 7.627,
              "z": 0.613
            },
            "gtin": "4063367431838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc88",
            "leftCorner": {
              "x": 11.54,
              "y": 7.627,
              "z": 0.613
            },
            "rightCorner": {
              "x": 11.481,
              "y": 7.631,
              "z": 0.613
            },
            "gtin": "4063367431838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc89",
            "leftCorner": {
              "x": 11.481,
              "y": 7.631,
              "z": 0.613
            },
            "rightCorner": {
              "x": 11.422,
              "y": 7.635,
              "z": 0.613
            },
            "gtin": "4063367431838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc8a",
            "leftCorner": {
              "x": 11.422,
              "y": 7.635,
              "z": 0.613
            },
            "rightCorner": {
              "x": 11.363,
              "y": 7.64,
              "z": 0.613
            },
            "gtin": "4063367431838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc8b",
            "leftCorner": {
              "x": 11.363,
              "y": 7.645,
              "z": 0.613
            },
            "rightCorner": {
              "x": 11.225,
              "y": 7.655,
              "z": 0.613
            },
            "gtin": "8711200457274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc8c",
            "leftCorner": {
              "x": 11.225,
              "y": 7.652,
              "z": 0.613
            },
            "rightCorner": {
              "x": 11.153,
              "y": 7.657,
              "z": 0.613
            },
            "gtin": "8710604725545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc8d",
            "leftCorner": {
              "x": 11.153,
              "y": 7.657,
              "z": 0.613
            },
            "rightCorner": {
              "x": 11.083,
              "y": 7.662,
              "z": 0.613
            },
            "gtin": "8710604725545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc8e",
            "leftCorner": {
              "x": 11.083,
              "y": 7.662,
              "z": 0.613
            },
            "rightCorner": {
              "x": 11.011,
              "y": 7.667,
              "z": 0.613
            },
            "gtin": "8710604725545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc8f",
            "leftCorner": {
              "x": 11.012,
              "y": 7.682,
              "z": 0.613
            },
            "rightCorner": {
              "x": 10.917,
              "y": 7.688,
              "z": 0.613
            },
            "gtin": "8032793343400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc90",
            "leftCorner": {
              "x": 10.917,
              "y": 7.688,
              "z": 0.613
            },
            "rightCorner": {
              "x": 10.821,
              "y": 7.695,
              "z": 0.613
            },
            "gtin": "8032793343400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc84",
            "leftCorner": {
              "x": 10.821,
              "y": 7.696,
              "z": 0.613
            },
            "rightCorner": {
              "x": 10.771,
              "y": 7.699,
              "z": 0.613
            },
            "gtin": "8001440133602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc85",
            "leftCorner": {
              "x": 10.771,
              "y": 7.699,
              "z": 0.613
            },
            "rightCorner": {
              "x": 10.723,
              "y": 7.703,
              "z": 0.613
            },
            "gtin": "8001440133602",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f83",
    "rightNeighborShelfId": "b6f85"
  },
  {
    "id": "b6f85",
    "name": "b6f85",
    "x": 10.719,
    "y": 7.747,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99976,
      "w": 0.021902
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 69
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54627e",
        "height": 0.15919,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dca3",
            "leftCorner": {
              "x": 10.718,
              "y": 7.732,
              "z": 0.13
            },
            "rightCorner": {
              "x": 10.619,
              "y": 7.737,
              "z": 0.13
            },
            "gtin": "8076809581868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dca4",
            "leftCorner": {
              "x": 10.619,
              "y": 7.737,
              "z": 0.13
            },
            "rightCorner": {
              "x": 10.52,
              "y": 7.741,
              "z": 0.13
            },
            "gtin": "8076809581868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dca6",
            "leftCorner": {
              "x": 10.519,
              "y": 7.711,
              "z": 0.13
            },
            "rightCorner": {
              "x": 10.423,
              "y": 7.715,
              "z": 0.13
            },
            "gtin": "8076809576598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dca7",
            "leftCorner": {
              "x": 10.423,
              "y": 7.715,
              "z": 0.13
            },
            "rightCorner": {
              "x": 10.327,
              "y": 7.719,
              "z": 0.13
            },
            "gtin": "8076809576598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dca8",
            "leftCorner": {
              "x": 10.327,
              "y": 7.705,
              "z": 0.13
            },
            "rightCorner": {
              "x": 10.12,
              "y": 7.714,
              "z": 0.13
            },
            "gtin": "8076809578264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dca9",
            "leftCorner": {
              "x": 10.12,
              "y": 7.713,
              "z": 0.13
            },
            "rightCorner": {
              "x": 9.997,
              "y": 7.718,
              "z": 0.13
            },
            "gtin": "8076809580724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcaa",
            "leftCorner": {
              "x": 9.997,
              "y": 7.718,
              "z": 0.13
            },
            "rightCorner": {
              "x": 9.875,
              "y": 7.723,
              "z": 0.13
            },
            "gtin": "8076809580724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcab",
            "leftCorner": {
              "x": 9.875,
              "y": 7.722,
              "z": 0.13
            },
            "rightCorner": {
              "x": 9.792,
              "y": 7.725,
              "z": 0.13
            },
            "gtin": "8076809545396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcac",
            "leftCorner": {
              "x": 9.792,
              "y": 7.725,
              "z": 0.13
            },
            "rightCorner": {
              "x": 9.709,
              "y": 7.729,
              "z": 0.13
            },
            "gtin": "8076809545396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcad",
            "leftCorner": {
              "x": 9.71,
              "y": 7.744,
              "z": 0.13
            },
            "rightCorner": {
              "x": 9.649,
              "y": 7.747,
              "z": 0.13
            },
            "gtin": "8076809513746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcae",
            "leftCorner": {
              "x": 9.649,
              "y": 7.747,
              "z": 0.13
            },
            "rightCorner": {
              "x": 9.588,
              "y": 7.749,
              "z": 0.13
            },
            "gtin": "8076809513746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcaf",
            "leftCorner": {
              "x": 9.588,
              "y": 7.749,
              "z": 0.13
            },
            "rightCorner": {
              "x": 9.527,
              "y": 7.752,
              "z": 0.13
            },
            "gtin": "8076809513746",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54627d",
        "height": 0.49942,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dc96",
            "leftCorner": {
              "x": 10.719,
              "y": 7.747,
              "z": 0.409
            },
            "rightCorner": {
              "x": 10.577,
              "y": 7.753,
              "z": 0.409
            },
            "gtin": "8076809580458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc97",
            "leftCorner": {
              "x": 10.577,
              "y": 7.753,
              "z": 0.409
            },
            "rightCorner": {
              "x": 10.436,
              "y": 7.759,
              "z": 0.409
            },
            "gtin": "8076809580458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc9c",
            "leftCorner": {
              "x": 10.434,
              "y": 7.718,
              "z": 0.409
            },
            "rightCorner": {
              "x": 10.253,
              "y": 7.726,
              "z": 0.409
            },
            "gtin": "8076809582643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc9d",
            "leftCorner": {
              "x": 10.253,
              "y": 7.726,
              "z": 0.409
            },
            "rightCorner": {
              "x": 10.072,
              "y": 7.734,
              "z": 0.409
            },
            "gtin": "8076809582643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc9e",
            "leftCorner": {
              "x": 10.071,
              "y": 7.726,
              "z": 0.409
            },
            "rightCorner": {
              "x": 9.982,
              "y": 7.73,
              "z": 0.409
            },
            "gtin": "8076809523547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc9f",
            "leftCorner": {
              "x": 9.982,
              "y": 7.73,
              "z": 0.409
            },
            "rightCorner": {
              "x": 9.893,
              "y": 7.733,
              "z": 0.409
            },
            "gtin": "8076809523547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dca0",
            "leftCorner": {
              "x": 9.893,
              "y": 7.744,
              "z": 0.409
            },
            "rightCorner": {
              "x": 9.83,
              "y": 7.747,
              "z": 0.409
            },
            "gtin": "8001250010940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dca1",
            "leftCorner": {
              "x": 9.83,
              "y": 7.747,
              "z": 0.409
            },
            "rightCorner": {
              "x": 9.767,
              "y": 7.75,
              "z": 0.409
            },
            "gtin": "8001250010940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dca2",
            "leftCorner": {
              "x": 9.767,
              "y": 7.75,
              "z": 0.409
            },
            "rightCorner": {
              "x": 9.704,
              "y": 7.752,
              "z": 0.409
            },
            "gtin": "8001250010940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc98",
            "leftCorner": {
              "x": 9.705,
              "y": 7.753,
              "z": 0.409
            },
            "rightCorner": {
              "x": 9.658,
              "y": 7.755,
              "z": 0.409
            },
            "gtin": "8001250016522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc99",
            "leftCorner": {
              "x": 9.658,
              "y": 7.755,
              "z": 0.409
            },
            "rightCorner": {
              "x": 9.612,
              "y": 7.757,
              "z": 0.409
            },
            "gtin": "8001250016522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc9a",
            "leftCorner": {
              "x": 9.612,
              "y": 7.757,
              "z": 0.409
            },
            "rightCorner": {
              "x": 9.565,
              "y": 7.759,
              "z": 0.409
            },
            "gtin": "8001250016522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc9b",
            "leftCorner": {
              "x": 9.565,
              "y": 7.759,
              "z": 0.409
            },
            "rightCorner": {
              "x": 9.518,
              "y": 7.761,
              "z": 0.409
            },
            "gtin": "8001250016522",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546281",
        "height": 0.8482,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dcbe",
            "leftCorner": {
              "x": 10.719,
              "y": 7.743,
              "z": 0.694
            },
            "rightCorner": {
              "x": 10.614,
              "y": 7.748,
              "z": 0.694
            },
            "gtin": "8076809517881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcbf",
            "leftCorner": {
              "x": 10.614,
              "y": 7.748,
              "z": 0.694
            },
            "rightCorner": {
              "x": 10.51,
              "y": 7.752,
              "z": 0.694
            },
            "gtin": "8076809517881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcc0",
            "leftCorner": {
              "x": 10.51,
              "y": 7.752,
              "z": 0.694
            },
            "rightCorner": {
              "x": 10.405,
              "y": 7.757,
              "z": 0.694
            },
            "gtin": "8076809517881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcc1",
            "leftCorner": {
              "x": 10.405,
              "y": 7.757,
              "z": 0.694
            },
            "rightCorner": {
              "x": 10.3,
              "y": 7.761,
              "z": 0.694
            },
            "gtin": "8076809517881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcc3",
            "leftCorner": {
              "x": 10.299,
              "y": 7.723,
              "z": 0.694
            },
            "rightCorner": {
              "x": 10.218,
              "y": 7.727,
              "z": 0.694
            },
            "gtin": "8076809541091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcc4",
            "leftCorner": {
              "x": 10.218,
              "y": 7.727,
              "z": 0.694
            },
            "rightCorner": {
              "x": 10.138,
              "y": 7.73,
              "z": 0.694
            },
            "gtin": "8076809541091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcc5",
            "leftCorner": {
              "x": 10.138,
              "y": 7.73,
              "z": 0.694
            },
            "rightCorner": {
              "x": 10.058,
              "y": 7.734,
              "z": 0.694
            },
            "gtin": "8076809541091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcc6",
            "leftCorner": {
              "x": 10.058,
              "y": 7.73,
              "z": 0.694
            },
            "rightCorner": {
              "x": 9.911,
              "y": 7.736,
              "z": 0.694
            },
            "gtin": "8076809517751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcc7",
            "leftCorner": {
              "x": 9.911,
              "y": 7.736,
              "z": 0.694
            },
            "rightCorner": {
              "x": 9.764,
              "y": 7.743,
              "z": 0.694
            },
            "gtin": "8076809517751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcc8",
            "leftCorner": {
              "x": 9.764,
              "y": 7.743,
              "z": 0.694
            },
            "rightCorner": {
              "x": 9.617,
              "y": 7.749,
              "z": 0.694
            },
            "gtin": "8076809517751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcc9",
            "leftCorner": {
              "x": 9.617,
              "y": 7.749,
              "z": 0.694
            },
            "rightCorner": {
              "x": 9.469,
              "y": 7.756,
              "z": 0.694
            },
            "gtin": "8076809517751",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54627c",
        "height": 1.1058,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dc68",
            "leftCorner": {
              "x": 10.688,
              "y": 7.712,
              "z": 0.905
            },
            "rightCorner": {
              "x": 10.568,
              "y": 7.717,
              "z": 0.905
            },
            "gtin": "8015559005842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc69",
            "leftCorner": {
              "x": 10.568,
              "y": 7.71,
              "z": 0.905
            },
            "rightCorner": {
              "x": 10.469,
              "y": 7.715,
              "z": 0.905
            },
            "gtin": "8015559005590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc6a",
            "leftCorner": {
              "x": 10.469,
              "y": 7.716,
              "z": 0.905
            },
            "rightCorner": {
              "x": 10.38,
              "y": 7.72,
              "z": 0.905
            },
            "gtin": "8015559004999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc6b",
            "leftCorner": {
              "x": 10.38,
              "y": 7.724,
              "z": 0.905
            },
            "rightCorner": {
              "x": 10.237,
              "y": 7.73,
              "z": 0.905
            },
            "gtin": "8720791222161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc6c",
            "leftCorner": {
              "x": 10.237,
              "y": 7.718,
              "z": 0.905
            },
            "rightCorner": {
              "x": 10.176,
              "y": 7.721,
              "z": 0.905
            },
            "gtin": "4063367513428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc6d",
            "leftCorner": {
              "x": 10.176,
              "y": 7.721,
              "z": 0.905
            },
            "rightCorner": {
              "x": 10.116,
              "y": 7.723,
              "z": 0.905
            },
            "gtin": "4063367513428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc6e",
            "leftCorner": {
              "x": 10.116,
              "y": 7.725,
              "z": 0.905
            },
            "rightCorner": {
              "x": 10.033,
              "y": 7.729,
              "z": 0.905
            },
            "gtin": "4063367513442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc6f",
            "leftCorner": {
              "x": 10.033,
              "y": 7.729,
              "z": 0.905
            },
            "rightCorner": {
              "x": 9.95,
              "y": 7.732,
              "z": 0.905
            },
            "gtin": "4063367513442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc70",
            "leftCorner": {
              "x": 9.95,
              "y": 7.728,
              "z": 0.905
            },
            "rightCorner": {
              "x": 9.814,
              "y": 7.734,
              "z": 0.905
            },
            "gtin": "8001060043039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc71",
            "leftCorner": {
              "x": 9.815,
              "y": 7.76,
              "z": 0.905
            },
            "rightCorner": {
              "x": 9.674,
              "y": 7.766,
              "z": 0.905
            },
            "gtin": "8001060043022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc72",
            "leftCorner": {
              "x": 9.673,
              "y": 7.751,
              "z": 0.905
            },
            "rightCorner": {
              "x": 9.474,
              "y": 7.76,
              "z": 0.905
            },
            "gtin": "8001060043015",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546280",
        "height": 1.4069,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dc2b",
            "leftCorner": {
              "x": 10.652,
              "y": 7.711,
              "z": 1.151
            },
            "rightCorner": {
              "x": 10.525,
              "y": 7.717,
              "z": 1.151
            },
            "gtin": "4002359015151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc2c",
            "leftCorner": {
              "x": 10.525,
              "y": 7.717,
              "z": 1.151
            },
            "rightCorner": {
              "x": 10.399,
              "y": 7.723,
              "z": 1.151
            },
            "gtin": "4002359015151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc2d",
            "leftCorner": {
              "x": 10.399,
              "y": 7.725,
              "z": 1.151
            },
            "rightCorner": {
              "x": 10.275,
              "y": 7.731,
              "z": 1.151
            },
            "gtin": "4002359015168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc2e",
            "leftCorner": {
              "x": 10.275,
              "y": 7.731,
              "z": 1.151
            },
            "rightCorner": {
              "x": 10.153,
              "y": 7.736,
              "z": 1.151
            },
            "gtin": "4002359015168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc2f",
            "leftCorner": {
              "x": 10.153,
              "y": 7.735,
              "z": 1.151
            },
            "rightCorner": {
              "x": 10.062,
              "y": 7.739,
              "z": 1.151
            },
            "gtin": "4002359015182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc30",
            "leftCorner": {
              "x": 10.062,
              "y": 7.739,
              "z": 1.151
            },
            "rightCorner": {
              "x": 9.971,
              "y": 7.743,
              "z": 1.151
            },
            "gtin": "4002359015182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc31",
            "leftCorner": {
              "x": 9.971,
              "y": 7.741,
              "z": 1.151
            },
            "rightCorner": {
              "x": 9.825,
              "y": 7.747,
              "z": 1.151
            },
            "gtin": "42421535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc32",
            "leftCorner": {
              "x": 9.825,
              "y": 7.746,
              "z": 1.151
            },
            "rightCorner": {
              "x": 9.758,
              "y": 7.749,
              "z": 1.151
            },
            "gtin": "42421559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc33",
            "leftCorner": {
              "x": 9.758,
              "y": 7.749,
              "z": 1.151
            },
            "rightCorner": {
              "x": 9.69,
              "y": 7.752,
              "z": 1.151
            },
            "gtin": "42421559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc34",
            "leftCorner": {
              "x": 9.691,
              "y": 7.768,
              "z": 1.151
            },
            "rightCorner": {
              "x": 9.541,
              "y": 7.775,
              "z": 1.151
            },
            "gtin": "42421542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc35",
            "leftCorner": {
              "x": 9.541,
              "y": 7.775,
              "z": 1.151
            },
            "rightCorner": {
              "x": 9.392,
              "y": 7.781,
              "z": 1.151
            },
            "gtin": "42421542",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54627f",
        "height": 1.7085,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d45b",
            "leftCorner": {
              "x": 10.652,
              "y": 7.715,
              "z": 1.398
            },
            "rightCorner": {
              "x": 10.57,
              "y": 7.719,
              "z": 1.398
            },
            "gtin": "4002359015267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d45c",
            "leftCorner": {
              "x": 10.57,
              "y": 7.719,
              "z": 1.398
            },
            "rightCorner": {
              "x": 10.489,
              "y": 7.723,
              "z": 1.398
            },
            "gtin": "4002359015267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d45d",
            "leftCorner": {
              "x": 10.489,
              "y": 7.723,
              "z": 1.398
            },
            "rightCorner": {
              "x": 10.408,
              "y": 7.726,
              "z": 1.398
            },
            "gtin": "4002359015267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d45e",
            "leftCorner": {
              "x": 10.408,
              "y": 7.726,
              "z": 1.398
            },
            "rightCorner": {
              "x": 10.326,
              "y": 7.73,
              "z": 1.398
            },
            "gtin": "4002359015267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d45f",
            "leftCorner": {
              "x": 10.326,
              "y": 7.73,
              "z": 1.398
            },
            "rightCorner": {
              "x": 10.246,
              "y": 7.733,
              "z": 1.398
            },
            "gtin": "4002359015267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d460",
            "leftCorner": {
              "x": 10.246,
              "y": 7.737,
              "z": 1.398
            },
            "rightCorner": {
              "x": 10.176,
              "y": 7.74,
              "z": 1.398
            },
            "gtin": "4002359015250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d461",
            "leftCorner": {
              "x": 10.176,
              "y": 7.74,
              "z": 1.398
            },
            "rightCorner": {
              "x": 10.107,
              "y": 7.743,
              "z": 1.398
            },
            "gtin": "4002359015250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d462",
            "leftCorner": {
              "x": 10.107,
              "y": 7.743,
              "z": 1.398
            },
            "rightCorner": {
              "x": 10.037,
              "y": 7.746,
              "z": 1.398
            },
            "gtin": "4002359015250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d463",
            "leftCorner": {
              "x": 10.037,
              "y": 7.742,
              "z": 1.398
            },
            "rightCorner": {
              "x": 9.813,
              "y": 7.752,
              "z": 1.398
            },
            "gtin": "4002359015229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d464",
            "leftCorner": {
              "x": 9.813,
              "y": 7.754,
              "z": 1.398
            },
            "rightCorner": {
              "x": 9.666,
              "y": 7.761,
              "z": 1.398
            },
            "gtin": "4002359015199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d465",
            "leftCorner": {
              "x": 9.666,
              "y": 7.761,
              "z": 1.398
            },
            "rightCorner": {
              "x": 9.52,
              "y": 7.767,
              "z": 1.398
            },
            "gtin": "4002359015199",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f84",
    "rightNeighborShelfId": "b6f8a"
  },
  {
    "id": "b6f8a",
    "name": "b6f8a",
    "x": 9.52,
    "y": 7.799,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99976,
      "w": 0.021902
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 91
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546285",
        "height": 0.15945,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dcb0",
            "leftCorner": {
              "x": 9.527,
              "y": 7.747,
              "z": 0.13
            },
            "rightCorner": {
              "x": 9.479,
              "y": 7.75,
              "z": 0.13
            },
            "gtin": "7640143671113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcb1",
            "leftCorner": {
              "x": 9.479,
              "y": 7.75,
              "z": 0.13
            },
            "rightCorner": {
              "x": 9.431,
              "y": 7.752,
              "z": 0.13
            },
            "gtin": "7640143671113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcb2",
            "leftCorner": {
              "x": 9.432,
              "y": 7.771,
              "z": 0.13
            },
            "rightCorner": {
              "x": 9.373,
              "y": 7.773,
              "z": 0.13
            },
            "gtin": "7640143671168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcb3",
            "leftCorner": {
              "x": 9.373,
              "y": 7.773,
              "z": 0.13
            },
            "rightCorner": {
              "x": 9.313,
              "y": 7.776,
              "z": 0.13
            },
            "gtin": "7640143671168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcb4",
            "leftCorner": {
              "x": 9.312,
              "y": 7.75,
              "z": 0.13
            },
            "rightCorner": {
              "x": 9.209,
              "y": 7.754,
              "z": 0.13
            },
            "gtin": "8076809572569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcb5",
            "leftCorner": {
              "x": 9.21,
              "y": 7.756,
              "z": 0.13
            },
            "rightCorner": {
              "x": 9.11,
              "y": 7.76,
              "z": 0.13
            },
            "gtin": "8076809576574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcb6",
            "leftCorner": {
              "x": 9.11,
              "y": 7.752,
              "z": 0.13
            },
            "rightCorner": {
              "x": 9.016,
              "y": 7.756,
              "z": 0.13
            },
            "gtin": "8076809576581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcb7",
            "leftCorner": {
              "x": 9.016,
              "y": 7.753,
              "z": 0.13
            },
            "rightCorner": {
              "x": 8.926,
              "y": 7.757,
              "z": 0.13
            },
            "gtin": "8076809572552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcb8",
            "leftCorner": {
              "x": 8.927,
              "y": 7.783,
              "z": 0.13
            },
            "rightCorner": {
              "x": 8.847,
              "y": 7.787,
              "z": 0.13
            },
            "gtin": "8712247232879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcb9",
            "leftCorner": {
              "x": 8.847,
              "y": 7.787,
              "z": 0.13
            },
            "rightCorner": {
              "x": 8.767,
              "y": 7.79,
              "z": 0.13
            },
            "gtin": "8712247232879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcba",
            "leftCorner": {
              "x": 8.766,
              "y": 7.781,
              "z": 0.13
            },
            "rightCorner": {
              "x": 8.679,
              "y": 7.785,
              "z": 0.13
            },
            "gtin": "8712247232794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcbb",
            "leftCorner": {
              "x": 8.679,
              "y": 7.785,
              "z": 0.13
            },
            "rightCorner": {
              "x": 8.593,
              "y": 7.789,
              "z": 0.13
            },
            "gtin": "8712247232794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcbc",
            "leftCorner": {
              "x": 8.592,
              "y": 7.782,
              "z": 0.13
            },
            "rightCorner": {
              "x": 8.522,
              "y": 7.785,
              "z": 0.13
            },
            "gtin": "8712247232756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcbd",
            "leftCorner": {
              "x": 8.522,
              "y": 7.785,
              "z": 0.13
            },
            "rightCorner": {
              "x": 8.451,
              "y": 7.788,
              "z": 0.13
            },
            "gtin": "8712247232756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dca5",
            "leftCorner": {
              "x": 8.452,
              "y": 7.794,
              "z": 0.13
            },
            "rightCorner": {
              "x": 8.319,
              "y": 7.799,
              "z": 0.13
            },
            "gtin": "8712247232770",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546282",
        "height": 0.51103,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dce4",
            "leftCorner": {
              "x": 9.52,
              "y": 7.79,
              "z": 0.418
            },
            "rightCorner": {
              "x": 9.461,
              "y": 7.792,
              "z": 0.418
            },
            "gtin": "8076809572996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dce5",
            "leftCorner": {
              "x": 9.461,
              "y": 7.792,
              "z": 0.418
            },
            "rightCorner": {
              "x": 9.402,
              "y": 7.795,
              "z": 0.418
            },
            "gtin": "8076809572996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dce6",
            "leftCorner": {
              "x": 9.402,
              "y": 7.795,
              "z": 0.418
            },
            "rightCorner": {
              "x": 9.343,
              "y": 7.797,
              "z": 0.418
            },
            "gtin": "8076809572996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dce8",
            "leftCorner": {
              "x": 9.342,
              "y": 7.76,
              "z": 0.418
            },
            "rightCorner": {
              "x": 9.243,
              "y": 7.764,
              "z": 0.418
            },
            "gtin": "8076809513388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dce9",
            "leftCorner": {
              "x": 9.243,
              "y": 7.764,
              "z": 0.418
            },
            "rightCorner": {
              "x": 9.145,
              "y": 7.768,
              "z": 0.418
            },
            "gtin": "8076809513388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcea",
            "leftCorner": {
              "x": 9.145,
              "y": 7.768,
              "z": 0.418
            },
            "rightCorner": {
              "x": 9.047,
              "y": 7.773,
              "z": 0.418
            },
            "gtin": "8076809513388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dceb",
            "leftCorner": {
              "x": 9.046,
              "y": 7.758,
              "z": 0.418
            },
            "rightCorner": {
              "x": 8.89,
              "y": 7.765,
              "z": 0.418
            },
            "gtin": "8076809569095",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c855ed67a01d9a1dcec",
            "leftCorner": {
              "x": 8.89,
              "y": 7.775,
              "z": 0.418
            },
            "rightCorner": {
              "x": 8.727,
              "y": 7.782,
              "z": 0.418
            },
            "gtin": "8076809513654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dced",
            "leftCorner": {
              "x": 8.727,
              "y": 7.786,
              "z": 0.418
            },
            "rightCorner": {
              "x": 8.644,
              "y": 7.789,
              "z": 0.418
            },
            "gtin": "8076809513722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcee",
            "leftCorner": {
              "x": 8.644,
              "y": 7.789,
              "z": 0.418
            },
            "rightCorner": {
              "x": 8.562,
              "y": 7.793,
              "z": 0.418
            },
            "gtin": "8076809513722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcef",
            "leftCorner": {
              "x": 8.561,
              "y": 7.781,
              "z": 0.418
            },
            "rightCorner": {
              "x": 8.511,
              "y": 7.783,
              "z": 0.418
            },
            "gtin": "8076809521543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcf0",
            "leftCorner": {
              "x": 8.511,
              "y": 7.783,
              "z": 0.418
            },
            "rightCorner": {
              "x": 8.46,
              "y": 7.786,
              "z": 0.418
            },
            "gtin": "8076809521543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcf1",
            "leftCorner": {
              "x": 8.46,
              "y": 7.786,
              "z": 0.418
            },
            "rightCorner": {
              "x": 8.41,
              "y": 7.788,
              "z": 0.418
            },
            "gtin": "8076809521543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dce7",
            "leftCorner": {
              "x": 8.41,
              "y": 7.803,
              "z": 0.418
            },
            "rightCorner": {
              "x": 8.319,
              "y": 7.807,
              "z": 0.418
            },
            "gtin": "8076809513395",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546286",
        "height": 0.85438,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dcca",
            "leftCorner": {
              "x": 9.469,
              "y": 7.762,
              "z": 0.699
            },
            "rightCorner": {
              "x": 9.375,
              "y": 7.766,
              "z": 0.699
            },
            "gtin": "8076809583749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dccb",
            "leftCorner": {
              "x": 9.375,
              "y": 7.766,
              "z": 0.699
            },
            "rightCorner": {
              "x": 9.28,
              "y": 7.771,
              "z": 0.699
            },
            "gtin": "8076809583749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dccc",
            "leftCorner": {
              "x": 9.28,
              "y": 7.771,
              "z": 0.699
            },
            "rightCorner": {
              "x": 9.185,
              "y": 7.775,
              "z": 0.699
            },
            "gtin": "8076809583749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dccd",
            "leftCorner": {
              "x": 9.186,
              "y": 7.788,
              "z": 0.699
            },
            "rightCorner": {
              "x": 9.117,
              "y": 7.791,
              "z": 0.699
            },
            "gtin": "8076809513692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcce",
            "leftCorner": {
              "x": 9.117,
              "y": 7.791,
              "z": 0.699
            },
            "rightCorner": {
              "x": 9.049,
              "y": 7.794,
              "z": 0.699
            },
            "gtin": "8076809513692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dccf",
            "leftCorner": {
              "x": 9.049,
              "y": 7.794,
              "z": 0.699
            },
            "rightCorner": {
              "x": 8.98,
              "y": 7.797,
              "z": 0.699
            },
            "gtin": "8076809513692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcd0",
            "leftCorner": {
              "x": 8.98,
              "y": 7.787,
              "z": 0.699
            },
            "rightCorner": {
              "x": 8.867,
              "y": 7.792,
              "z": 0.699
            },
            "gtin": "8076809513678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcd1",
            "leftCorner": {
              "x": 8.867,
              "y": 7.792,
              "z": 0.699
            },
            "rightCorner": {
              "x": 8.753,
              "y": 7.797,
              "z": 0.699
            },
            "gtin": "8076809513678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcd2",
            "leftCorner": {
              "x": 8.753,
              "y": 7.797,
              "z": 0.699
            },
            "rightCorner": {
              "x": 8.64,
              "y": 7.802,
              "z": 0.699
            },
            "gtin": "8076809513678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcd3",
            "leftCorner": {
              "x": 8.64,
              "y": 7.802,
              "z": 0.699
            },
            "rightCorner": {
              "x": 8.527,
              "y": 7.807,
              "z": 0.699
            },
            "gtin": "8076809513678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcd4",
            "leftCorner": {
              "x": 8.527,
              "y": 7.807,
              "z": 0.699
            },
            "rightCorner": {
              "x": 8.414,
              "y": 7.812,
              "z": 0.699
            },
            "gtin": "8076809513678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcd5",
            "leftCorner": {
              "x": 8.413,
              "y": 7.806,
              "z": 0.699
            },
            "rightCorner": {
              "x": 8.368,
              "y": 7.808,
              "z": 0.699
            },
            "gtin": "4002359006043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcd6",
            "leftCorner": {
              "x": 8.368,
              "y": 7.808,
              "z": 0.699
            },
            "rightCorner": {
              "x": 8.323,
              "y": 7.81,
              "z": 0.699
            },
            "gtin": "4002359006043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcd7",
            "leftCorner": {
              "x": 8.323,
              "y": 7.81,
              "z": 0.699
            },
            "rightCorner": {
              "x": 8.277,
              "y": 7.812,
              "z": 0.699
            },
            "gtin": "4002359006043",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546284",
        "height": 1.1135,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dc73",
            "leftCorner": {
              "x": 9.474,
              "y": 7.766,
              "z": 0.911
            },
            "rightCorner": {
              "x": 9.367,
              "y": 7.771,
              "z": 0.911
            },
            "gtin": "8076809523561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc74",
            "leftCorner": {
              "x": 9.367,
              "y": 7.771,
              "z": 0.911
            },
            "rightCorner": {
              "x": 9.26,
              "y": 7.776,
              "z": 0.911
            },
            "gtin": "8076809523561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc75",
            "leftCorner": {
              "x": 9.26,
              "y": 7.774,
              "z": 0.911
            },
            "rightCorner": {
              "x": 9.19,
              "y": 7.777,
              "z": 0.911
            },
            "gtin": "8001250219169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc76",
            "leftCorner": {
              "x": 9.19,
              "y": 7.777,
              "z": 0.911
            },
            "rightCorner": {
              "x": 9.119,
              "y": 7.78,
              "z": 0.911
            },
            "gtin": "8001250219169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc77",
            "leftCorner": {
              "x": 9.119,
              "y": 7.78,
              "z": 0.911
            },
            "rightCorner": {
              "x": 9.049,
              "y": 7.783,
              "z": 0.911
            },
            "gtin": "8001250219169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc78",
            "leftCorner": {
              "x": 9.049,
              "y": 7.78,
              "z": 0.911
            },
            "rightCorner": {
              "x": 8.993,
              "y": 7.783,
              "z": 0.911
            },
            "gtin": "8001250219145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc79",
            "leftCorner": {
              "x": 8.993,
              "y": 7.783,
              "z": 0.911
            },
            "rightCorner": {
              "x": 8.936,
              "y": 7.785,
              "z": 0.911
            },
            "gtin": "8001250219145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc7a",
            "leftCorner": {
              "x": 8.936,
              "y": 7.785,
              "z": 0.911
            },
            "rightCorner": {
              "x": 8.88,
              "y": 7.788,
              "z": 0.911
            },
            "gtin": "8001250219145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc7b",
            "leftCorner": {
              "x": 8.879,
              "y": 7.783,
              "z": 0.911
            },
            "rightCorner": {
              "x": 8.807,
              "y": 7.786,
              "z": 0.911
            },
            "gtin": "8001250219138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc7c",
            "leftCorner": {
              "x": 8.807,
              "y": 7.786,
              "z": 0.911
            },
            "rightCorner": {
              "x": 8.734,
              "y": 7.789,
              "z": 0.911
            },
            "gtin": "8001250219138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc7d",
            "leftCorner": {
              "x": 8.734,
              "y": 7.785,
              "z": 0.911
            },
            "rightCorner": {
              "x": 8.673,
              "y": 7.787,
              "z": 0.911
            },
            "gtin": "8005110000775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc7e",
            "leftCorner": {
              "x": 8.673,
              "y": 7.787,
              "z": 0.911
            },
            "rightCorner": {
              "x": 8.613,
              "y": 7.79,
              "z": 0.911
            },
            "gtin": "8005110000775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc7f",
            "leftCorner": {
              "x": 8.613,
              "y": 7.804,
              "z": 0.911
            },
            "rightCorner": {
              "x": 8.531,
              "y": 7.807,
              "z": 0.911
            },
            "gtin": "8005110517006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc80",
            "leftCorner": {
              "x": 8.531,
              "y": 7.807,
              "z": 0.911
            },
            "rightCorner": {
              "x": 8.448,
              "y": 7.811,
              "z": 0.911
            },
            "gtin": "8005110517006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc58",
            "leftCorner": {
              "x": 8.447,
              "y": 7.796,
              "z": 0.911
            },
            "rightCorner": {
              "x": 8.319,
              "y": 7.802,
              "z": 0.911
            },
            "gtin": "8005110519000",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546287",
        "height": 1.4119,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dc36",
            "leftCorner": {
              "x": 9.391,
              "y": 7.759,
              "z": 1.155
            },
            "rightCorner": {
              "x": 9.319,
              "y": 7.762,
              "z": 1.155
            },
            "gtin": "9002600655025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc37",
            "leftCorner": {
              "x": 9.319,
              "y": 7.762,
              "z": 1.155
            },
            "rightCorner": {
              "x": 9.247,
              "y": 7.766,
              "z": 1.155
            },
            "gtin": "9002600655025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc38",
            "leftCorner": {
              "x": 9.247,
              "y": 7.768,
              "z": 1.155
            },
            "rightCorner": {
              "x": 9.106,
              "y": 7.774,
              "z": 1.155
            },
            "gtin": "9002600655049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc39",
            "leftCorner": {
              "x": 9.106,
              "y": 7.767,
              "z": 1.155
            },
            "rightCorner": {
              "x": 9.022,
              "y": 7.771,
              "z": 1.155
            },
            "gtin": "9002600655063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc3a",
            "leftCorner": {
              "x": 9.022,
              "y": 7.771,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.938,
              "y": 7.774,
              "z": 1.155
            },
            "gtin": "9002600655063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc3b",
            "leftCorner": {
              "x": 8.938,
              "y": 7.782,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.853,
              "y": 7.786,
              "z": 1.155
            },
            "gtin": "8901552021760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc3c",
            "leftCorner": {
              "x": 8.853,
              "y": 7.786,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.768,
              "y": 7.789,
              "z": 1.155
            },
            "gtin": "8901552021760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc3d",
            "leftCorner": {
              "x": 8.768,
              "y": 7.788,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.721,
              "y": 7.79,
              "z": 1.155
            },
            "gtin": "4063367406805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc3e",
            "leftCorner": {
              "x": 8.721,
              "y": 7.79,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.673,
              "y": 7.792,
              "z": 1.155
            },
            "gtin": "4063367406805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc3f",
            "leftCorner": {
              "x": 8.673,
              "y": 7.792,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.626,
              "y": 7.794,
              "z": 1.155
            },
            "gtin": "4063367406805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc40",
            "leftCorner": {
              "x": 8.625,
              "y": 7.786,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.552,
              "y": 7.789,
              "z": 1.155
            },
            "gtin": "4063367406782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc41",
            "leftCorner": {
              "x": 8.552,
              "y": 7.789,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.478,
              "y": 7.793,
              "z": 1.155
            },
            "gtin": "4063367406782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc42",
            "leftCorner": {
              "x": 8.478,
              "y": 7.794,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.415,
              "y": 7.797,
              "z": 1.155
            },
            "gtin": "4063367406829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc43",
            "leftCorner": {
              "x": 8.415,
              "y": 7.797,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.352,
              "y": 7.8,
              "z": 1.155
            },
            "gtin": "4063367406829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc44",
            "leftCorner": {
              "x": 8.352,
              "y": 7.8,
              "z": 1.155
            },
            "rightCorner": {
              "x": 8.289,
              "y": 7.802,
              "z": 1.155
            },
            "gtin": "4063367406829",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546283",
        "height": 1.7076,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d466",
            "leftCorner": {
              "x": 9.52,
              "y": 7.77,
              "z": 1.397
            },
            "rightCorner": {
              "x": 9.451,
              "y": 7.773,
              "z": 1.397
            },
            "gtin": "8001060033559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d467",
            "leftCorner": {
              "x": 9.451,
              "y": 7.773,
              "z": 1.397
            },
            "rightCorner": {
              "x": 9.382,
              "y": 7.776,
              "z": 1.397
            },
            "gtin": "8001060033559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d468",
            "leftCorner": {
              "x": 9.381,
              "y": 7.766,
              "z": 1.397
            },
            "rightCorner": {
              "x": 9.315,
              "y": 7.769,
              "z": 1.397
            },
            "gtin": "8001060026759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d469",
            "leftCorner": {
              "x": 9.315,
              "y": 7.769,
              "z": 1.397
            },
            "rightCorner": {
              "x": 9.249,
              "y": 7.772,
              "z": 1.397
            },
            "gtin": "8001060026759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d46a",
            "leftCorner": {
              "x": 9.249,
              "y": 7.764,
              "z": 1.397
            },
            "rightCorner": {
              "x": 9.185,
              "y": 7.767,
              "z": 1.397
            },
            "gtin": "8001060033573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d46b",
            "leftCorner": {
              "x": 9.185,
              "y": 7.767,
              "z": 1.397
            },
            "rightCorner": {
              "x": 9.121,
              "y": 7.77,
              "z": 1.397
            },
            "gtin": "8001060033573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d46c",
            "leftCorner": {
              "x": 9.121,
              "y": 7.77,
              "z": 1.397
            },
            "rightCorner": {
              "x": 9.077,
              "y": 7.772,
              "z": 1.397
            },
            "gtin": "8001060027367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d46d",
            "leftCorner": {
              "x": 9.077,
              "y": 7.772,
              "z": 1.397
            },
            "rightCorner": {
              "x": 9.033,
              "y": 7.774,
              "z": 1.397
            },
            "gtin": "8001060027367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d46e",
            "leftCorner": {
              "x": 9.033,
              "y": 7.774,
              "z": 1.397
            },
            "rightCorner": {
              "x": 8.989,
              "y": 7.776,
              "z": 1.397
            },
            "gtin": "8001060027367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d46f",
            "leftCorner": {
              "x": 8.989,
              "y": 7.776,
              "z": 1.397
            },
            "rightCorner": {
              "x": 8.863,
              "y": 7.781,
              "z": 1.397
            },
            "gtin": "8001060038837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d470",
            "leftCorner": {
              "x": 8.863,
              "y": 7.781,
              "z": 1.397
            },
            "rightCorner": {
              "x": 8.736,
              "y": 7.787,
              "z": 1.397
            },
            "gtin": "8001060038837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d471",
            "leftCorner": {
              "x": 8.736,
              "y": 7.79,
              "z": 1.397
            },
            "rightCorner": {
              "x": 8.687,
              "y": 7.793,
              "z": 1.397
            },
            "gtin": "8002170562410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d472",
            "leftCorner": {
              "x": 8.687,
              "y": 7.793,
              "z": 1.397
            },
            "rightCorner": {
              "x": 8.637,
              "y": 7.795,
              "z": 1.397
            },
            "gtin": "8002170562410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d473",
            "leftCorner": {
              "x": 8.637,
              "y": 7.795,
              "z": 1.397
            },
            "rightCorner": {
              "x": 8.587,
              "y": 7.797,
              "z": 1.397
            },
            "gtin": "8002170562410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d474",
            "leftCorner": {
              "x": 8.587,
              "y": 7.79,
              "z": 1.397
            },
            "rightCorner": {
              "x": 8.526,
              "y": 7.793,
              "z": 1.397
            },
            "gtin": "8002170562274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d475",
            "leftCorner": {
              "x": 8.526,
              "y": 7.793,
              "z": 1.397
            },
            "rightCorner": {
              "x": 8.464,
              "y": 7.796,
              "z": 1.397
            },
            "gtin": "8002170562274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d476",
            "leftCorner": {
              "x": 8.464,
              "y": 7.797,
              "z": 1.397
            },
            "rightCorner": {
              "x": 8.39,
              "y": 7.8,
              "z": 1.397
            },
            "gtin": "8002170562403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d477",
            "leftCorner": {
              "x": 8.39,
              "y": 7.8,
              "z": 1.397
            },
            "rightCorner": {
              "x": 8.316,
              "y": 7.804,
              "z": 1.397
            },
            "gtin": "8002170562403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d478",
            "leftCorner": {
              "x": 8.316,
              "y": 7.804,
              "z": 1.397
            },
            "rightCorner": {
              "x": 8.242,
              "y": 7.807,
              "z": 1.397
            },
            "gtin": "8002170562403",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f85",
    "rightNeighborShelfId": "b6f8b"
  },
  {
    "id": "b6f8b",
    "name": "b6f8b",
    "x": 8.322,
    "y": 7.852,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99976,
      "w": 0.021902
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 79
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54628c",
        "height": 0.49743,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dcff",
            "leftCorner": {
              "x": 8.191,
              "y": 7.843,
              "z": 0.407
            },
            "rightCorner": {
              "x": 8.126,
              "y": 7.846,
              "z": 0.407
            },
            "gtin": "7640143674107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd0b",
            "leftCorner": {
              "x": 7.347,
              "y": 7.841,
              "z": 0.407
            },
            "rightCorner": {
              "x": 7.291,
              "y": 7.844,
              "z": 0.407
            },
            "gtin": "4028856014138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcfd",
            "leftCorner": {
              "x": 8.321,
              "y": 7.838,
              "z": 0.407
            },
            "rightCorner": {
              "x": 8.256,
              "y": 7.841,
              "z": 0.407
            },
            "gtin": "7640143674107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcfe",
            "leftCorner": {
              "x": 8.256,
              "y": 7.841,
              "z": 0.407
            },
            "rightCorner": {
              "x": 8.191,
              "y": 7.843,
              "z": 0.407
            },
            "gtin": "7640143674107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd00",
            "leftCorner": {
              "x": 8.126,
              "y": 7.846,
              "z": 0.407
            },
            "rightCorner": {
              "x": 8.061,
              "y": 7.849,
              "z": 0.407
            },
            "gtin": "7640143674107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd02",
            "leftCorner": {
              "x": 8.059,
              "y": 7.807,
              "z": 0.407
            },
            "rightCorner": {
              "x": 7.982,
              "y": 7.81,
              "z": 0.407
            },
            "gtin": "7640143674114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd03",
            "leftCorner": {
              "x": 7.982,
              "y": 7.81,
              "z": 0.407
            },
            "rightCorner": {
              "x": 7.905,
              "y": 7.813,
              "z": 0.407
            },
            "gtin": "7640143674114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd04",
            "leftCorner": {
              "x": 7.905,
              "y": 7.813,
              "z": 0.407
            },
            "rightCorner": {
              "x": 7.828,
              "y": 7.817,
              "z": 0.407
            },
            "gtin": "7640143674114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd05",
            "leftCorner": {
              "x": 7.828,
              "y": 7.813,
              "z": 0.407
            },
            "rightCorner": {
              "x": 7.636,
              "y": 7.822,
              "z": 0.407
            },
            "gtin": "7640143674121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd06",
            "leftCorner": {
              "x": 7.637,
              "y": 7.831,
              "z": 0.407
            },
            "rightCorner": {
              "x": 7.578,
              "y": 7.834,
              "z": 0.407
            },
            "gtin": "4400139009725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd07",
            "leftCorner": {
              "x": 7.578,
              "y": 7.834,
              "z": 0.407
            },
            "rightCorner": {
              "x": 7.519,
              "y": 7.836,
              "z": 0.407
            },
            "gtin": "4400139009725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd08",
            "leftCorner": {
              "x": 7.519,
              "y": 7.836,
              "z": 0.407
            },
            "rightCorner": {
              "x": 7.459,
              "y": 7.839,
              "z": 0.407
            },
            "gtin": "4400139009725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd09",
            "leftCorner": {
              "x": 7.459,
              "y": 7.836,
              "z": 0.407
            },
            "rightCorner": {
              "x": 7.403,
              "y": 7.839,
              "z": 0.407
            },
            "gtin": "4028856014138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd0a",
            "leftCorner": {
              "x": 7.403,
              "y": 7.839,
              "z": 0.407
            },
            "rightCorner": {
              "x": 7.347,
              "y": 7.841,
              "z": 0.407
            },
            "gtin": "4028856014138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd0c",
            "leftCorner": {
              "x": 7.291,
              "y": 7.838,
              "z": 0.407
            },
            "rightCorner": {
              "x": 7.252,
              "y": 7.84,
              "z": 0.407
            },
            "gtin": "4028856014435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd0d",
            "leftCorner": {
              "x": 7.252,
              "y": 7.84,
              "z": 0.407
            },
            "rightCorner": {
              "x": 7.214,
              "y": 7.842,
              "z": 0.407
            },
            "gtin": "4028856014435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd0e",
            "leftCorner": {
              "x": 7.214,
              "y": 7.842,
              "z": 0.407
            },
            "rightCorner": {
              "x": 7.175,
              "y": 7.843,
              "z": 0.407
            },
            "gtin": "4028856014435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd01",
            "leftCorner": {
              "x": 7.175,
              "y": 7.849,
              "z": 0.407
            },
            "rightCorner": {
              "x": 7.071,
              "y": 7.854,
              "z": 0.407
            },
            "gtin": "4028856014459",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54628a",
        "height": 1.1027,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dcf5",
            "leftCorner": {
              "x": 7.954,
              "y": 7.826,
              "z": 0.902
            },
            "rightCorner": {
              "x": 7.805,
              "y": 7.833,
              "z": 0.902
            },
            "gtin": "4260712320704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcf6",
            "leftCorner": {
              "x": 7.805,
              "y": 7.825,
              "z": 0.902
            },
            "rightCorner": {
              "x": 7.654,
              "y": 7.832,
              "z": 0.902
            },
            "gtin": "4260712320728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcf7",
            "leftCorner": {
              "x": 7.654,
              "y": 7.832,
              "z": 0.902
            },
            "rightCorner": {
              "x": 7.502,
              "y": 7.838,
              "z": 0.902
            },
            "gtin": "4260712320728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcf8",
            "leftCorner": {
              "x": 7.503,
              "y": 7.841,
              "z": 0.902
            },
            "rightCorner": {
              "x": 7.4,
              "y": 7.845,
              "z": 0.902
            },
            "gtin": "4063367433160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcf9",
            "leftCorner": {
              "x": 7.4,
              "y": 7.845,
              "z": 0.902
            },
            "rightCorner": {
              "x": 7.296,
              "y": 7.85,
              "z": 0.902
            },
            "gtin": "4063367433160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcfa",
            "leftCorner": {
              "x": 7.297,
              "y": 7.853,
              "z": 0.902
            },
            "rightCorner": {
              "x": 7.213,
              "y": 7.857,
              "z": 0.902
            },
            "gtin": "4005009106742",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcfb",
            "leftCorner": {
              "x": 7.213,
              "y": 7.857,
              "z": 0.902
            },
            "rightCorner": {
              "x": 7.13,
              "y": 7.861,
              "z": 0.902
            },
            "gtin": "4005009106742",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcfc",
            "leftCorner": {
              "x": 7.13,
              "y": 7.85,
              "z": 0.902
            },
            "rightCorner": {
              "x": 7.084,
              "y": 7.852,
              "z": 0.902
            },
            "gtin": "4045178012338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcf2",
            "leftCorner": {
              "x": 8.322,
              "y": 7.843,
              "z": 0.902
            },
            "rightCorner": {
              "x": 8.222,
              "y": 7.847,
              "z": 0.902
            },
            "gtin": "4063367433108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcf3",
            "leftCorner": {
              "x": 8.222,
              "y": 7.847,
              "z": 0.902
            },
            "rightCorner": {
              "x": 8.122,
              "y": 7.851,
              "z": 0.902
            },
            "gtin": "4063367433108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcf4",
            "leftCorner": {
              "x": 8.12,
              "y": 7.807,
              "z": 0.902
            },
            "rightCorner": {
              "x": 7.954,
              "y": 7.814,
              "z": 0.902
            },
            "gtin": "4063367433184",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546289",
        "height": 1.4025,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dc45",
            "leftCorner": {
              "x": 8.289,
              "y": 7.803,
              "z": 1.147
            },
            "rightCorner": {
              "x": 8.218,
              "y": 7.806,
              "z": 1.147
            },
            "gtin": "4063367406768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc46",
            "leftCorner": {
              "x": 8.218,
              "y": 7.806,
              "z": 1.147
            },
            "rightCorner": {
              "x": 8.147,
              "y": 7.809,
              "z": 1.147
            },
            "gtin": "4063367406768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc47",
            "leftCorner": {
              "x": 8.147,
              "y": 7.81,
              "z": 1.147
            },
            "rightCorner": {
              "x": 8.07,
              "y": 7.813,
              "z": 1.147
            },
            "gtin": "4028856014503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc48",
            "leftCorner": {
              "x": 8.07,
              "y": 7.813,
              "z": 1.147
            },
            "rightCorner": {
              "x": 7.992,
              "y": 7.817,
              "z": 1.147
            },
            "gtin": "4028856014503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc49",
            "leftCorner": {
              "x": 7.992,
              "y": 7.817,
              "z": 1.147
            },
            "rightCorner": {
              "x": 7.842,
              "y": 7.823,
              "z": 1.147
            },
            "gtin": "4028856014527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc4a",
            "leftCorner": {
              "x": 7.842,
              "y": 7.819,
              "z": 1.147
            },
            "rightCorner": {
              "x": 7.8,
              "y": 7.82,
              "z": 1.147
            },
            "gtin": "4028856014541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc4b",
            "leftCorner": {
              "x": 7.8,
              "y": 7.82,
              "z": 1.147
            },
            "rightCorner": {
              "x": 7.758,
              "y": 7.822,
              "z": 1.147
            },
            "gtin": "4028856014541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc4c",
            "leftCorner": {
              "x": 7.758,
              "y": 7.822,
              "z": 1.147
            },
            "rightCorner": {
              "x": 7.716,
              "y": 7.824,
              "z": 1.147
            },
            "gtin": "4028856014541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc4d",
            "leftCorner": {
              "x": 7.716,
              "y": 7.824,
              "z": 1.147
            },
            "rightCorner": {
              "x": 7.674,
              "y": 7.826,
              "z": 1.147
            },
            "gtin": "4028856014541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc4e",
            "leftCorner": {
              "x": 7.675,
              "y": 7.839,
              "z": 1.147
            },
            "rightCorner": {
              "x": 7.622,
              "y": 7.841,
              "z": 1.147
            },
            "gtin": "4337185923814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc4f",
            "leftCorner": {
              "x": 7.622,
              "y": 7.841,
              "z": 1.147
            },
            "rightCorner": {
              "x": 7.569,
              "y": 7.843,
              "z": 1.147
            },
            "gtin": "4337185923814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc50",
            "leftCorner": {
              "x": 7.569,
              "y": 7.843,
              "z": 1.147
            },
            "rightCorner": {
              "x": 7.517,
              "y": 7.845,
              "z": 1.147
            },
            "gtin": "4337185923814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc51",
            "leftCorner": {
              "x": 7.516,
              "y": 7.842,
              "z": 1.147
            },
            "rightCorner": {
              "x": 7.422,
              "y": 7.847,
              "z": 1.147
            },
            "gtin": "4337185923777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc52",
            "leftCorner": {
              "x": 7.422,
              "y": 7.847,
              "z": 1.147
            },
            "rightCorner": {
              "x": 7.328,
              "y": 7.851,
              "z": 1.147
            },
            "gtin": "4337185923777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc53",
            "leftCorner": {
              "x": 7.327,
              "y": 7.842,
              "z": 1.147
            },
            "rightCorner": {
              "x": 7.259,
              "y": 7.845,
              "z": 1.147
            },
            "gtin": "4028856014305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc54",
            "leftCorner": {
              "x": 7.259,
              "y": 7.845,
              "z": 1.147
            },
            "rightCorner": {
              "x": 7.191,
              "y": 7.848,
              "z": 1.147
            },
            "gtin": "4028856014305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc55",
            "leftCorner": {
              "x": 7.191,
              "y": 7.856,
              "z": 1.147
            },
            "rightCorner": {
              "x": 7.116,
              "y": 7.859,
              "z": 1.147
            },
            "gtin": "4028856014282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dc20",
            "leftCorner": {
              "x": 7.116,
              "y": 7.847,
              "z": 1.147
            },
            "rightCorner": {
              "x": 7.071,
              "y": 7.849,
              "z": 1.147
            },
            "gtin": "4028856014268",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54628b",
        "height": 1.7025,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d479",
            "leftCorner": {
              "x": 8.239,
              "y": 7.805,
              "z": 1.393
            },
            "rightCorner": {
              "x": 8.167,
              "y": 7.809,
              "z": 1.393
            },
            "gtin": "8015559006474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d47a",
            "leftCorner": {
              "x": 8.167,
              "y": 7.809,
              "z": 1.393
            },
            "rightCorner": {
              "x": 8.094,
              "y": 7.812,
              "z": 1.393
            },
            "gtin": "8015559006474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d47b",
            "leftCorner": {
              "x": 8.094,
              "y": 7.812,
              "z": 1.393
            },
            "rightCorner": {
              "x": 8.021,
              "y": 7.815,
              "z": 1.393
            },
            "gtin": "8015559006474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d47c",
            "leftCorner": {
              "x": 8.021,
              "y": 7.814,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.885,
              "y": 7.82,
              "z": 1.393
            },
            "gtin": "8015559001172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d47d",
            "leftCorner": {
              "x": 7.885,
              "y": 7.82,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.749,
              "y": 7.826,
              "z": 1.393
            },
            "gtin": "8015559001172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d47e",
            "leftCorner": {
              "x": 7.749,
              "y": 7.819,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.685,
              "y": 7.821,
              "z": 1.393
            },
            "gtin": "8015559009079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d47f",
            "leftCorner": {
              "x": 7.685,
              "y": 7.821,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.622,
              "y": 7.824,
              "z": 1.393
            },
            "gtin": "8015559009079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d480",
            "leftCorner": {
              "x": 7.622,
              "y": 7.824,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.558,
              "y": 7.827,
              "z": 1.393
            },
            "gtin": "8015559009079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d481",
            "leftCorner": {
              "x": 7.559,
              "y": 7.841,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.455,
              "y": 7.846,
              "z": 1.393
            },
            "gtin": "8712247232930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d482",
            "leftCorner": {
              "x": 7.455,
              "y": 7.846,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.351,
              "y": 7.85,
              "z": 1.393
            },
            "gtin": "8712247232930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d483",
            "leftCorner": {
              "x": 7.351,
              "y": 7.85,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.247,
              "y": 7.855,
              "z": 1.393
            },
            "gtin": "8712247232930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d484",
            "leftCorner": {
              "x": 7.247,
              "y": 7.861,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.136,
              "y": 7.866,
              "z": 1.393
            },
            "gtin": "8712247232954",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d412",
            "leftCorner": {
              "x": 7.135,
              "y": 7.844,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.071,
              "y": 7.846,
              "z": 1.393
            },
            "gtin": "8712247232978",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54628d",
        "height": 0.14942,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd0f",
            "leftCorner": {
              "x": 8.321,
              "y": 7.84,
              "z": 0.122
            },
            "rightCorner": {
              "x": 7.963,
              "y": 7.856,
              "z": 0.122
            },
            "gtin": "8002920017627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd15",
            "leftCorner": {
              "x": 7.961,
              "y": 7.813,
              "z": 0.122
            },
            "rightCorner": {
              "x": 7.613,
              "y": 7.829,
              "z": 0.122
            },
            "gtin": "8002920017610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd10",
            "leftCorner": {
              "x": 7.613,
              "y": 7.838,
              "z": 0.122
            },
            "rightCorner": {
              "x": 7.505,
              "y": 7.843,
              "z": 0.122
            },
            "gtin": "8002920017634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd11",
            "leftCorner": {
              "x": 7.505,
              "y": 7.843,
              "z": 0.122
            },
            "rightCorner": {
              "x": 7.396,
              "y": 7.848,
              "z": 0.122
            },
            "gtin": "8002920017634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd12",
            "leftCorner": {
              "x": 7.396,
              "y": 7.848,
              "z": 0.122
            },
            "rightCorner": {
              "x": 7.288,
              "y": 7.853,
              "z": 0.122
            },
            "gtin": "8002920017634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd13",
            "leftCorner": {
              "x": 7.288,
              "y": 7.853,
              "z": 0.122
            },
            "rightCorner": {
              "x": 7.18,
              "y": 7.858,
              "z": 0.122
            },
            "gtin": "8002920017634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd14",
            "leftCorner": {
              "x": 7.18,
              "y": 7.858,
              "z": 0.122
            },
            "rightCorner": {
              "x": 7.071,
              "y": 7.862,
              "z": 0.122
            },
            "gtin": "8002920017634",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546288",
        "height": 0.84838,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dcd8",
            "leftCorner": {
              "x": 8.276,
              "y": 7.805,
              "z": 0.694
            },
            "rightCorner": {
              "x": 8.211,
              "y": 7.808,
              "z": 0.694
            },
            "gtin": "4002359006005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcd9",
            "leftCorner": {
              "x": 8.211,
              "y": 7.808,
              "z": 0.694
            },
            "rightCorner": {
              "x": 8.146,
              "y": 7.811,
              "z": 0.694
            },
            "gtin": "4002359006005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcda",
            "leftCorner": {
              "x": 8.146,
              "y": 7.811,
              "z": 0.694
            },
            "rightCorner": {
              "x": 8.082,
              "y": 7.814,
              "z": 0.694
            },
            "gtin": "4002359006005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcdb",
            "leftCorner": {
              "x": 8.082,
              "y": 7.814,
              "z": 0.694
            },
            "rightCorner": {
              "x": 8.017,
              "y": 7.817,
              "z": 0.694
            },
            "gtin": "4002359006005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcdc",
            "leftCorner": {
              "x": 8.017,
              "y": 7.818,
              "z": 0.694
            },
            "rightCorner": {
              "x": 7.953,
              "y": 7.821,
              "z": 0.694
            },
            "gtin": "4002359006029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcdd",
            "leftCorner": {
              "x": 7.953,
              "y": 7.821,
              "z": 0.694
            },
            "rightCorner": {
              "x": 7.889,
              "y": 7.824,
              "z": 0.694
            },
            "gtin": "4002359006029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcde",
            "leftCorner": {
              "x": 7.889,
              "y": 7.824,
              "z": 0.694
            },
            "rightCorner": {
              "x": 7.826,
              "y": 7.827,
              "z": 0.694
            },
            "gtin": "4002359006029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcdf",
            "leftCorner": {
              "x": 7.826,
              "y": 7.827,
              "z": 0.694
            },
            "rightCorner": {
              "x": 7.762,
              "y": 7.829,
              "z": 0.694
            },
            "gtin": "4002359006029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dce0",
            "leftCorner": {
              "x": 7.762,
              "y": 7.829,
              "z": 0.694
            },
            "rightCorner": {
              "x": 7.698,
              "y": 7.832,
              "z": 0.694
            },
            "gtin": "4002359006029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dce1",
            "leftCorner": {
              "x": 7.698,
              "y": 7.832,
              "z": 0.694
            },
            "rightCorner": {
              "x": 7.523,
              "y": 7.84,
              "z": 0.694
            },
            "gtin": "4002359006180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dce2",
            "leftCorner": {
              "x": 7.523,
              "y": 7.842,
              "z": 0.694
            },
            "rightCorner": {
              "x": 7.374,
              "y": 7.849,
              "z": 0.694
            },
            "gtin": "4002359006081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dce3",
            "leftCorner": {
              "x": 7.374,
              "y": 7.849,
              "z": 0.694
            },
            "rightCorner": {
              "x": 7.224,
              "y": 7.855,
              "z": 0.694
            },
            "gtin": "4002359006081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dcc2",
            "leftCorner": {
              "x": 7.224,
              "y": 7.853,
              "z": 0.694
            },
            "rightCorner": {
              "x": 7.071,
              "y": 7.86,
              "z": 0.694
            },
            "gtin": "4002359006067",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f8a"
  },
  {
    "id": "b6f8c",
    "name": "b6f8c",
    "x": 18.149,
    "y": 10.355,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99911,
      "w": 0.042277
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 54
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5462bd",
        "height": 1.7069,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d270",
            "leftCorner": {
              "x": 17.382,
              "y": 10.39,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.318,
              "y": 10.394,
              "z": 1.397
            },
            "gtin": "5011546460451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d269",
            "leftCorner": {
              "x": 18.146,
              "y": 10.329,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.029,
              "y": 10.34,
              "z": 1.397
            },
            "gtin": "5011546483443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d26a",
            "leftCorner": {
              "x": 18.028,
              "y": 10.334,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.803,
              "y": 10.352,
              "z": 1.397
            },
            "gtin": "7613034172181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d26b",
            "leftCorner": {
              "x": 17.803,
              "y": 10.349,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.702,
              "y": 10.358,
              "z": 1.397
            },
            "gtin": "5011546468730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d26c",
            "leftCorner": {
              "x": 17.702,
              "y": 10.358,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.603,
              "y": 10.366,
              "z": 1.397
            },
            "gtin": "5011546468730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d26d",
            "leftCorner": {
              "x": 17.602,
              "y": 10.357,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.522,
              "y": 10.363,
              "z": 1.397
            },
            "gtin": "5011546460444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d26e",
            "leftCorner": {
              "x": 17.522,
              "y": 10.363,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.443,
              "y": 10.37,
              "z": 1.397
            },
            "gtin": "5011546460444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d26f",
            "leftCorner": {
              "x": 17.444,
              "y": 10.384,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.382,
              "y": 10.39,
              "z": 1.397
            },
            "gtin": "5011546460451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d271",
            "leftCorner": {
              "x": 17.318,
              "y": 10.394,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.256,
              "y": 10.4,
              "z": 1.397
            },
            "gtin": "5011546460451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d272",
            "leftCorner": {
              "x": 17.256,
              "y": 10.399,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.171,
              "y": 10.406,
              "z": 1.397
            },
            "gtin": "5011546460437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d273",
            "leftCorner": {
              "x": 17.171,
              "y": 10.406,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.087,
              "y": 10.413,
              "z": 1.397
            },
            "gtin": "5011546460437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d274",
            "leftCorner": {
              "x": 17.087,
              "y": 10.413,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.002,
              "y": 10.421,
              "z": 1.397
            },
            "gtin": "5011546460437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d275",
            "leftCorner": {
              "x": 17.002,
              "y": 10.422,
              "z": 1.397
            },
            "rightCorner": {
              "x": 16.862,
              "y": 10.434,
              "z": 1.397
            },
            "gtin": "8711000454145",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462c0",
        "height": 0.16093,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d20b",
            "leftCorner": {
              "x": 18.152,
              "y": 10.304,
              "z": 0.132
            },
            "rightCorner": {
              "x": 17.991,
              "y": 10.318,
              "z": 0.132
            },
            "gtin": "4009041108863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d20c",
            "leftCorner": {
              "x": 17.991,
              "y": 10.318,
              "z": 0.132
            },
            "rightCorner": {
              "x": 17.83,
              "y": 10.331,
              "z": 0.132
            },
            "gtin": "4009041108863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d20d",
            "leftCorner": {
              "x": 17.83,
              "y": 10.331,
              "z": 0.132
            },
            "rightCorner": {
              "x": 17.669,
              "y": 10.345,
              "z": 0.132
            },
            "gtin": "4009041108863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d20e",
            "leftCorner": {
              "x": 17.669,
              "y": 10.345,
              "z": 0.132
            },
            "rightCorner": {
              "x": 17.507,
              "y": 10.358,
              "z": 0.132
            },
            "gtin": "4009041108863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d20f",
            "leftCorner": {
              "x": 17.507,
              "y": 10.358,
              "z": 0.132
            },
            "rightCorner": {
              "x": 17.346,
              "y": 10.372,
              "z": 0.132
            },
            "gtin": "4009041108863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d210",
            "leftCorner": {
              "x": 17.346,
              "y": 10.365,
              "z": 0.132
            },
            "rightCorner": {
              "x": 17.23,
              "y": 10.375,
              "z": 0.132
            },
            "gtin": "7613034831712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d211",
            "leftCorner": {
              "x": 17.23,
              "y": 10.375,
              "z": 0.132
            },
            "rightCorner": {
              "x": 17.115,
              "y": 10.384,
              "z": 0.132
            },
            "gtin": "7613034831712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d212",
            "leftCorner": {
              "x": 17.115,
              "y": 10.384,
              "z": 0.132
            },
            "rightCorner": {
              "x": 17.0,
              "y": 10.395,
              "z": 0.132
            },
            "gtin": "7613034831712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d213",
            "leftCorner": {
              "x": 17.0,
              "y": 10.395,
              "z": 0.132
            },
            "rightCorner": {
              "x": 16.884,
              "y": 10.404,
              "z": 0.132
            },
            "gtin": "7613034831712",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462be",
        "height": 0.5053,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d1e4",
            "leftCorner": {
              "x": 18.13,
              "y": 10.309,
              "z": 0.413
            },
            "rightCorner": {
              "x": 17.978,
              "y": 10.322,
              "z": 0.413
            },
            "gtin": "4052700086224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1e5",
            "leftCorner": {
              "x": 17.978,
              "y": 10.322,
              "z": 0.413
            },
            "rightCorner": {
              "x": 17.826,
              "y": 10.335,
              "z": 0.413
            },
            "gtin": "4052700086224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1e6",
            "leftCorner": {
              "x": 17.826,
              "y": 10.335,
              "z": 0.413
            },
            "rightCorner": {
              "x": 17.674,
              "y": 10.348,
              "z": 0.413
            },
            "gtin": "4052700086224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1e7",
            "leftCorner": {
              "x": 17.676,
              "y": 10.366,
              "z": 0.413
            },
            "rightCorner": {
              "x": 17.582,
              "y": 10.374,
              "z": 0.413
            },
            "gtin": "4052700093444",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c835ed67a01d9a1d1e8",
            "leftCorner": {
              "x": 17.581,
              "y": 10.355,
              "z": 0.413
            },
            "rightCorner": {
              "x": 17.42,
              "y": 10.369,
              "z": 0.413
            },
            "gtin": "4052700086217",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c835ed67a01d9a1d1e9",
            "leftCorner": {
              "x": 17.42,
              "y": 10.376,
              "z": 0.413
            },
            "rightCorner": {
              "x": 17.289,
              "y": 10.387,
              "z": 0.413
            },
            "gtin": "8711000506448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1ea",
            "leftCorner": {
              "x": 17.289,
              "y": 10.387,
              "z": 0.413
            },
            "rightCorner": {
              "x": 17.157,
              "y": 10.398,
              "z": 0.413
            },
            "gtin": "8711000506448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1eb",
            "leftCorner": {
              "x": 17.157,
              "y": 10.398,
              "z": 0.413
            },
            "rightCorner": {
              "x": 17.025,
              "y": 10.409,
              "z": 0.413
            },
            "gtin": "8711000506448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1ec",
            "leftCorner": {
              "x": 17.024,
              "y": 10.4,
              "z": 0.413
            },
            "rightCorner": {
              "x": 16.934,
              "y": 10.408,
              "z": 0.413
            },
            "gtin": "4052700093437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1ed",
            "leftCorner": {
              "x": 16.934,
              "y": 10.408,
              "z": 0.413
            },
            "rightCorner": {
              "x": 16.844,
              "y": 10.415,
              "z": 0.413
            },
            "gtin": "4052700093437",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462c2",
        "height": 0.80784,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d1b8",
            "leftCorner": {
              "x": 18.082,
              "y": 10.326,
              "z": 0.661
            },
            "rightCorner": {
              "x": 17.78,
              "y": 10.351,
              "z": 0.661
            },
            "gtin": "8711000506325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1b9",
            "leftCorner": {
              "x": 17.78,
              "y": 10.351,
              "z": 0.661
            },
            "rightCorner": {
              "x": 17.478,
              "y": 10.377,
              "z": 0.661
            },
            "gtin": "8711000506325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1ba",
            "leftCorner": {
              "x": 17.478,
              "y": 10.375,
              "z": 0.661
            },
            "rightCorner": {
              "x": 17.363,
              "y": 10.384,
              "z": 0.661
            },
            "gtin": "8711000496312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1bb",
            "leftCorner": {
              "x": 17.363,
              "y": 10.384,
              "z": 0.661
            },
            "rightCorner": {
              "x": 17.247,
              "y": 10.395,
              "z": 0.661
            },
            "gtin": "8711000496312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1bc",
            "leftCorner": {
              "x": 17.246,
              "y": 10.386,
              "z": 0.661
            },
            "rightCorner": {
              "x": 17.07,
              "y": 10.401,
              "z": 0.661
            },
            "gtin": "8711000506417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1bd",
            "leftCorner": {
              "x": 17.07,
              "y": 10.401,
              "z": 0.661
            },
            "rightCorner": {
              "x": 16.894,
              "y": 10.416,
              "z": 0.661
            },
            "gtin": "8711000506417",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462bf",
        "height": 1.1061,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d18e",
            "leftCorner": {
              "x": 18.141,
              "y": 10.326,
              "z": 0.905
            },
            "rightCorner": {
              "x": 18.034,
              "y": 10.334,
              "z": 0.905
            },
            "gtin": "4005500216063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d18f",
            "leftCorner": {
              "x": 18.034,
              "y": 10.334,
              "z": 0.905
            },
            "rightCorner": {
              "x": 17.926,
              "y": 10.343,
              "z": 0.905
            },
            "gtin": "4005500216063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d190",
            "leftCorner": {
              "x": 17.926,
              "y": 10.341,
              "z": 0.905
            },
            "rightCorner": {
              "x": 17.848,
              "y": 10.348,
              "z": 0.905
            },
            "gtin": "8711000566848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d191",
            "leftCorner": {
              "x": 17.848,
              "y": 10.348,
              "z": 0.905
            },
            "rightCorner": {
              "x": 17.769,
              "y": 10.354,
              "z": 0.905
            },
            "gtin": "8711000566848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d192",
            "leftCorner": {
              "x": 17.769,
              "y": 10.354,
              "z": 0.905
            },
            "rightCorner": {
              "x": 17.69,
              "y": 10.361,
              "z": 0.905
            },
            "gtin": "8711000566848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d193",
            "leftCorner": {
              "x": 17.691,
              "y": 10.369,
              "z": 0.905
            },
            "rightCorner": {
              "x": 17.428,
              "y": 10.39,
              "z": 0.905
            },
            "gtin": "4000508050008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d194",
            "leftCorner": {
              "x": 17.428,
              "y": 10.39,
              "z": 0.905
            },
            "rightCorner": {
              "x": 17.164,
              "y": 10.413,
              "z": 0.905
            },
            "gtin": "4000508050008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d195",
            "leftCorner": {
              "x": 17.164,
              "y": 10.413,
              "z": 0.905
            },
            "rightCorner": {
              "x": 16.9,
              "y": 10.435,
              "z": 0.905
            },
            "gtin": "4000508050008",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462c1",
        "height": 1.4129,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d239",
            "leftCorner": {
              "x": 18.049,
              "y": 10.336,
              "z": 1.156
            },
            "rightCorner": {
              "x": 17.915,
              "y": 10.348,
              "z": 1.156
            },
            "gtin": "8445290914200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d23a",
            "leftCorner": {
              "x": 17.915,
              "y": 10.348,
              "z": 1.156
            },
            "rightCorner": {
              "x": 17.78,
              "y": 10.359,
              "z": 1.156
            },
            "gtin": "8445290914200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d23b",
            "leftCorner": {
              "x": 17.78,
              "y": 10.359,
              "z": 1.156
            },
            "rightCorner": {
              "x": 17.645,
              "y": 10.37,
              "z": 1.156
            },
            "gtin": "8445290914200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d23c",
            "leftCorner": {
              "x": 17.645,
              "y": 10.37,
              "z": 1.156
            },
            "rightCorner": {
              "x": 17.51,
              "y": 10.382,
              "z": 1.156
            },
            "gtin": "8445290914200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d23d",
            "leftCorner": {
              "x": 17.509,
              "y": 10.376,
              "z": 1.156
            },
            "rightCorner": {
              "x": 17.398,
              "y": 10.385,
              "z": 1.156
            },
            "gtin": "7613036900072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d23e",
            "leftCorner": {
              "x": 17.398,
              "y": 10.385,
              "z": 1.156
            },
            "rightCorner": {
              "x": 17.287,
              "y": 10.395,
              "z": 1.156
            },
            "gtin": "7613036900072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d23f",
            "leftCorner": {
              "x": 17.287,
              "y": 10.395,
              "z": 1.156
            },
            "rightCorner": {
              "x": 17.176,
              "y": 10.404,
              "z": 1.156
            },
            "gtin": "7613036900072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d240",
            "leftCorner": {
              "x": 17.176,
              "y": 10.397,
              "z": 1.156
            },
            "rightCorner": {
              "x": 17.071,
              "y": 10.406,
              "z": 1.156
            },
            "gtin": "7613036960298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d241",
            "leftCorner": {
              "x": 17.071,
              "y": 10.406,
              "z": 1.156
            },
            "rightCorner": {
              "x": 16.966,
              "y": 10.414,
              "z": 1.156
            },
            "gtin": "7613036960298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d242",
            "leftCorner": {
              "x": 16.966,
              "y": 10.414,
              "z": 1.156
            },
            "rightCorner": {
              "x": 16.861,
              "y": 10.423,
              "z": 1.156
            },
            "gtin": "7613036960298",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "dded1",
    "rightNeighborShelfId": "b6f8d"
  },
  {
    "id": "b6f8d",
    "name": "b6f8d",
    "x": 16.903,
    "y": 10.461,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99911,
      "w": 0.042277
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 54
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546184",
        "height": 0.15519,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d214",
            "leftCorner": {
              "x": 16.885,
              "y": 10.422,
              "z": 0.127
            },
            "rightCorner": {
              "x": 16.779,
              "y": 10.431,
              "z": 0.127
            },
            "gtin": "4009041108931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d215",
            "leftCorner": {
              "x": 16.779,
              "y": 10.428,
              "z": 0.127
            },
            "rightCorner": {
              "x": 16.676,
              "y": 10.437,
              "z": 0.127
            },
            "gtin": "4009041108894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d216",
            "leftCorner": {
              "x": 16.676,
              "y": 10.437,
              "z": 0.127
            },
            "rightCorner": {
              "x": 16.574,
              "y": 10.445,
              "z": 0.127
            },
            "gtin": "4009041108894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d217",
            "leftCorner": {
              "x": 16.574,
              "y": 10.445,
              "z": 0.127
            },
            "rightCorner": {
              "x": 16.472,
              "y": 10.454,
              "z": 0.127
            },
            "gtin": "4009041108894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d218",
            "leftCorner": {
              "x": 16.472,
              "y": 10.454,
              "z": 0.127
            },
            "rightCorner": {
              "x": 16.371,
              "y": 10.462,
              "z": 0.127
            },
            "gtin": "4009041108894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d219",
            "leftCorner": {
              "x": 16.371,
              "y": 10.462,
              "z": 0.127
            },
            "rightCorner": {
              "x": 16.269,
              "y": 10.471,
              "z": 0.127
            },
            "gtin": "4009041108894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d21a",
            "leftCorner": {
              "x": 16.269,
              "y": 10.471,
              "z": 0.127
            },
            "rightCorner": {
              "x": 16.167,
              "y": 10.479,
              "z": 0.127
            },
            "gtin": "4009041108894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d21b",
            "leftCorner": {
              "x": 16.168,
              "y": 10.49,
              "z": 0.127
            },
            "rightCorner": {
              "x": 16.076,
              "y": 10.497,
              "z": 0.127
            },
            "gtin": "4009041108924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d21c",
            "leftCorner": {
              "x": 16.076,
              "y": 10.497,
              "z": 0.127
            },
            "rightCorner": {
              "x": 15.986,
              "y": 10.506,
              "z": 0.127
            },
            "gtin": "4009041108924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d21d",
            "leftCorner": {
              "x": 15.985,
              "y": 10.489,
              "z": 0.127
            },
            "rightCorner": {
              "x": 15.85,
              "y": 10.5,
              "z": 0.127
            },
            "gtin": "4052700005065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d21e",
            "leftCorner": {
              "x": 15.85,
              "y": 10.504,
              "z": 0.127
            },
            "rightCorner": {
              "x": 15.568,
              "y": 10.528,
              "z": 0.127
            },
            "gtin": "4052700008165",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546183",
        "height": 0.49779,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d1ee",
            "leftCorner": {
              "x": 16.844,
              "y": 10.427,
              "z": 0.407
            },
            "rightCorner": {
              "x": 16.742,
              "y": 10.436,
              "z": 0.407
            },
            "gtin": "4052700005041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1ef",
            "leftCorner": {
              "x": 16.742,
              "y": 10.436,
              "z": 0.407
            },
            "rightCorner": {
              "x": 16.639,
              "y": 10.444,
              "z": 0.407
            },
            "gtin": "4052700005041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1f0",
            "leftCorner": {
              "x": 16.639,
              "y": 10.444,
              "z": 0.407
            },
            "rightCorner": {
              "x": 16.536,
              "y": 10.453,
              "z": 0.407
            },
            "gtin": "4052700005041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1f1",
            "leftCorner": {
              "x": 16.536,
              "y": 10.453,
              "z": 0.407
            },
            "rightCorner": {
              "x": 16.433,
              "y": 10.462,
              "z": 0.407
            },
            "gtin": "4052700005041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1f2",
            "leftCorner": {
              "x": 16.433,
              "y": 10.464,
              "z": 0.407
            },
            "rightCorner": {
              "x": 16.372,
              "y": 10.468,
              "z": 0.407
            },
            "gtin": "4052700005096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1f3",
            "leftCorner": {
              "x": 16.372,
              "y": 10.468,
              "z": 0.407
            },
            "rightCorner": {
              "x": 16.311,
              "y": 10.473,
              "z": 0.407
            },
            "gtin": "4052700005096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1f4",
            "leftCorner": {
              "x": 16.311,
              "y": 10.473,
              "z": 0.407
            },
            "rightCorner": {
              "x": 16.25,
              "y": 10.478,
              "z": 0.407
            },
            "gtin": "4052700005096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1f5",
            "leftCorner": {
              "x": 16.25,
              "y": 10.478,
              "z": 0.407
            },
            "rightCorner": {
              "x": 16.189,
              "y": 10.484,
              "z": 0.407
            },
            "gtin": "4052700005096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1f6",
            "leftCorner": {
              "x": 16.189,
              "y": 10.484,
              "z": 0.407
            },
            "rightCorner": {
              "x": 16.128,
              "y": 10.489,
              "z": 0.407
            },
            "gtin": "4052700005096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1f7",
            "leftCorner": {
              "x": 16.127,
              "y": 10.478,
              "z": 0.407
            },
            "rightCorner": {
              "x": 16.029,
              "y": 10.486,
              "z": 0.407
            },
            "gtin": "4052700005034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1f8",
            "leftCorner": {
              "x": 16.029,
              "y": 10.486,
              "z": 0.407
            },
            "rightCorner": {
              "x": 15.93,
              "y": 10.495,
              "z": 0.407
            },
            "gtin": "4052700005034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1f9",
            "leftCorner": {
              "x": 15.93,
              "y": 10.495,
              "z": 0.407
            },
            "rightCorner": {
              "x": 15.833,
              "y": 10.502,
              "z": 0.407
            },
            "gtin": "4052700005034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1fa",
            "leftCorner": {
              "x": 15.833,
              "y": 10.502,
              "z": 0.407
            },
            "rightCorner": {
              "x": 15.734,
              "y": 10.511,
              "z": 0.407
            },
            "gtin": "4052700005034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1fb",
            "leftCorner": {
              "x": 15.734,
              "y": 10.511,
              "z": 0.407
            },
            "rightCorner": {
              "x": 15.635,
              "y": 10.519,
              "z": 0.407
            },
            "gtin": "4052700005034",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546182",
        "height": 0.80352,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d1be",
            "leftCorner": {
              "x": 16.893,
              "y": 10.414,
              "z": 0.657
            },
            "rightCorner": {
              "x": 16.798,
              "y": 10.421,
              "z": 0.657
            },
            "gtin": "4052700072951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1bf",
            "leftCorner": {
              "x": 16.798,
              "y": 10.421,
              "z": 0.657
            },
            "rightCorner": {
              "x": 16.702,
              "y": 10.43,
              "z": 0.657
            },
            "gtin": "4052700072951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1c0",
            "leftCorner": {
              "x": 16.702,
              "y": 10.43,
              "z": 0.657
            },
            "rightCorner": {
              "x": 16.427,
              "y": 10.453,
              "z": 0.657
            },
            "gtin": "4052700069753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1c1",
            "leftCorner": {
              "x": 16.427,
              "y": 10.453,
              "z": 0.657
            },
            "rightCorner": {
              "x": 16.151,
              "y": 10.476,
              "z": 0.657
            },
            "gtin": "4052700069753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1c2",
            "leftCorner": {
              "x": 16.151,
              "y": 10.476,
              "z": 0.657
            },
            "rightCorner": {
              "x": 15.876,
              "y": 10.5,
              "z": 0.657
            },
            "gtin": "4052700069753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1c3",
            "leftCorner": {
              "x": 15.876,
              "y": 10.5,
              "z": 0.657
            },
            "rightCorner": {
              "x": 15.6,
              "y": 10.524,
              "z": 0.657
            },
            "gtin": "4052700069753",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546181",
        "height": 1.1063,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d196",
            "leftCorner": {
              "x": 16.898,
              "y": 10.416,
              "z": 0.905
            },
            "rightCorner": {
              "x": 16.665,
              "y": 10.436,
              "z": 0.905
            },
            "gtin": "4052700072159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d197",
            "leftCorner": {
              "x": 16.665,
              "y": 10.436,
              "z": 0.905
            },
            "rightCorner": {
              "x": 16.433,
              "y": 10.456,
              "z": 0.905
            },
            "gtin": "4052700072159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d198",
            "leftCorner": {
              "x": 16.433,
              "y": 10.455,
              "z": 0.905
            },
            "rightCorner": {
              "x": 16.161,
              "y": 10.479,
              "z": 0.905
            },
            "gtin": "4052700068398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d199",
            "leftCorner": {
              "x": 16.161,
              "y": 10.479,
              "z": 0.905
            },
            "rightCorner": {
              "x": 15.889,
              "y": 10.502,
              "z": 0.905
            },
            "gtin": "4052700068398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d19a",
            "leftCorner": {
              "x": 15.889,
              "y": 10.502,
              "z": 0.905
            },
            "rightCorner": {
              "x": 15.617,
              "y": 10.524,
              "z": 0.905
            },
            "gtin": "4052700068398",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546185",
        "height": 1.4099,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d243",
            "leftCorner": {
              "x": 16.861,
              "y": 10.424,
              "z": 1.154
            },
            "rightCorner": {
              "x": 16.689,
              "y": 10.438,
              "z": 1.154
            },
            "gtin": "4052700023526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d244",
            "leftCorner": {
              "x": 16.689,
              "y": 10.438,
              "z": 1.154
            },
            "rightCorner": {
              "x": 16.518,
              "y": 10.453,
              "z": 1.154
            },
            "gtin": "4052700023526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d245",
            "leftCorner": {
              "x": 16.518,
              "y": 10.449,
              "z": 1.154
            },
            "rightCorner": {
              "x": 16.223,
              "y": 10.474,
              "z": 1.154
            },
            "gtin": "4052700069746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d246",
            "leftCorner": {
              "x": 16.223,
              "y": 10.474,
              "z": 1.154
            },
            "rightCorner": {
              "x": 15.928,
              "y": 10.499,
              "z": 1.154
            },
            "gtin": "4052700069746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d247",
            "leftCorner": {
              "x": 15.928,
              "y": 10.499,
              "z": 1.154
            },
            "rightCorner": {
              "x": 15.634,
              "y": 10.524,
              "z": 1.154
            },
            "gtin": "4052700069746",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546186",
        "height": 1.704,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d276",
            "leftCorner": {
              "x": 16.862,
              "y": 10.442,
              "z": 1.394
            },
            "rightCorner": {
              "x": 16.723,
              "y": 10.453,
              "z": 1.394
            },
            "gtin": "4052700085074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d277",
            "leftCorner": {
              "x": 16.723,
              "y": 10.453,
              "z": 1.394
            },
            "rightCorner": {
              "x": 16.584,
              "y": 10.465,
              "z": 1.394
            },
            "gtin": "4052700085074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d278",
            "leftCorner": {
              "x": 16.584,
              "y": 10.465,
              "z": 1.394
            },
            "rightCorner": {
              "x": 16.445,
              "y": 10.477,
              "z": 1.394
            },
            "gtin": "4052700085074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d279",
            "leftCorner": {
              "x": 16.443,
              "y": 10.459,
              "z": 1.394
            },
            "rightCorner": {
              "x": 16.37,
              "y": 10.465,
              "z": 1.394
            },
            "gtin": "7613032569532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d27a",
            "leftCorner": {
              "x": 16.37,
              "y": 10.465,
              "z": 1.394
            },
            "rightCorner": {
              "x": 16.297,
              "y": 10.471,
              "z": 1.394
            },
            "gtin": "7613032569532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d27b",
            "leftCorner": {
              "x": 16.297,
              "y": 10.47,
              "z": 1.394
            },
            "rightCorner": {
              "x": 16.217,
              "y": 10.477,
              "z": 1.394
            },
            "gtin": "7613032569570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d27c",
            "leftCorner": {
              "x": 16.217,
              "y": 10.477,
              "z": 1.394
            },
            "rightCorner": {
              "x": 16.138,
              "y": 10.483,
              "z": 1.394
            },
            "gtin": "7613032569570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d27d",
            "leftCorner": {
              "x": 16.138,
              "y": 10.483,
              "z": 1.394
            },
            "rightCorner": {
              "x": 16.058,
              "y": 10.491,
              "z": 1.394
            },
            "gtin": "7613032569570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d27e",
            "leftCorner": {
              "x": 16.058,
              "y": 10.491,
              "z": 1.394
            },
            "rightCorner": {
              "x": 15.978,
              "y": 10.497,
              "z": 1.394
            },
            "gtin": "7613032569570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d27f",
            "leftCorner": {
              "x": 15.979,
              "y": 10.503,
              "z": 1.394
            },
            "rightCorner": {
              "x": 15.899,
              "y": 10.51,
              "z": 1.394
            },
            "gtin": "8445290603708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d280",
            "leftCorner": {
              "x": 15.899,
              "y": 10.51,
              "z": 1.394
            },
            "rightCorner": {
              "x": 15.82,
              "y": 10.516,
              "z": 1.394
            },
            "gtin": "8445290603708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d281",
            "leftCorner": {
              "x": 15.82,
              "y": 10.513,
              "z": 1.394
            },
            "rightCorner": {
              "x": 15.713,
              "y": 10.523,
              "z": 1.394
            },
            "gtin": "8445290603876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d282",
            "leftCorner": {
              "x": 15.713,
              "y": 10.523,
              "z": 1.394
            },
            "rightCorner": {
              "x": 15.605,
              "y": 10.531,
              "z": 1.394
            },
            "gtin": "8445290603876",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f8c",
    "rightNeighborShelfId": "b6f8e"
  },
  {
    "id": "b6f8e",
    "name": "b6f8e",
    "x": 15.658,
    "y": 10.566,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99911,
      "w": 0.042277
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 34
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5462a2",
        "height": 0.14913,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d21f",
            "leftCorner": {
              "x": 15.569,
              "y": 10.521,
              "z": 0.122
            },
            "rightCorner": {
              "x": 15.478,
              "y": 10.528,
              "z": 0.122
            },
            "gtin": "4063367035005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d220",
            "leftCorner": {
              "x": 15.478,
              "y": 10.528,
              "z": 0.122
            },
            "rightCorner": {
              "x": 15.387,
              "y": 10.535,
              "z": 0.122
            },
            "gtin": "4063367035005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d221",
            "leftCorner": {
              "x": 15.387,
              "y": 10.535,
              "z": 0.122
            },
            "rightCorner": {
              "x": 15.296,
              "y": 10.543,
              "z": 0.122
            },
            "gtin": "4063367035005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d222",
            "leftCorner": {
              "x": 15.296,
              "y": 10.547,
              "z": 0.122
            },
            "rightCorner": {
              "x": 15.088,
              "y": 10.565,
              "z": 0.122
            },
            "gtin": "4005500274995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d223",
            "leftCorner": {
              "x": 15.088,
              "y": 10.565,
              "z": 0.122
            },
            "rightCorner": {
              "x": 14.879,
              "y": 10.583,
              "z": 0.122
            },
            "gtin": "4005500274995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d224",
            "leftCorner": {
              "x": 14.879,
              "y": 10.583,
              "z": 0.122
            },
            "rightCorner": {
              "x": 14.67,
              "y": 10.601,
              "z": 0.122
            },
            "gtin": "4005500274995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d225",
            "leftCorner": {
              "x": 14.67,
              "y": 10.591,
              "z": 0.122
            },
            "rightCorner": {
              "x": 14.569,
              "y": 10.599,
              "z": 0.122
            },
            "gtin": "4037014965502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d226",
            "leftCorner": {
              "x": 14.569,
              "y": 10.599,
              "z": 0.122
            },
            "rightCorner": {
              "x": 14.468,
              "y": 10.608,
              "z": 0.122
            },
            "gtin": "4037014965502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d227",
            "leftCorner": {
              "x": 14.468,
              "y": 10.608,
              "z": 0.122
            },
            "rightCorner": {
              "x": 14.368,
              "y": 10.617,
              "z": 0.122
            },
            "gtin": "4037014965502",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54629d",
        "height": 0.4997,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a54629e",
        "height": 0.80303,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d1c4",
            "leftCorner": {
              "x": 15.601,
              "y": 10.518,
              "z": 0.657
            },
            "rightCorner": {
              "x": 15.463,
              "y": 10.531,
              "z": 0.657
            },
            "gtin": "4063367408410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1c5",
            "leftCorner": {
              "x": 15.463,
              "y": 10.531,
              "z": 0.657
            },
            "rightCorner": {
              "x": 15.325,
              "y": 10.542,
              "z": 0.657
            },
            "gtin": "4063367408410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1c6",
            "leftCorner": {
              "x": 15.325,
              "y": 10.542,
              "z": 0.657
            },
            "rightCorner": {
              "x": 15.187,
              "y": 10.554,
              "z": 0.657
            },
            "gtin": "4063367408410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1c7",
            "leftCorner": {
              "x": 15.186,
              "y": 10.546,
              "z": 0.657
            },
            "rightCorner": {
              "x": 14.906,
              "y": 10.57,
              "z": 0.657
            },
            "gtin": "4063367408397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1c8",
            "leftCorner": {
              "x": 14.906,
              "y": 10.57,
              "z": 0.657
            },
            "rightCorner": {
              "x": 14.625,
              "y": 10.593,
              "z": 0.657
            },
            "gtin": "4063367408397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1c9",
            "leftCorner": {
              "x": 14.625,
              "y": 10.593,
              "z": 0.657
            },
            "rightCorner": {
              "x": 14.345,
              "y": 10.617,
              "z": 0.657
            },
            "gtin": "4063367408397",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54629f",
        "height": 1.1031,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d19b",
            "leftCorner": {
              "x": 15.618,
              "y": 10.531,
              "z": 0.903
            },
            "rightCorner": {
              "x": 15.469,
              "y": 10.543,
              "z": 0.903
            },
            "gtin": "4337185899485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d19c",
            "leftCorner": {
              "x": 15.469,
              "y": 10.543,
              "z": 0.903
            },
            "rightCorner": {
              "x": 15.321,
              "y": 10.555,
              "z": 0.903
            },
            "gtin": "4337185899485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d19d",
            "leftCorner": {
              "x": 15.321,
              "y": 10.554,
              "z": 0.903
            },
            "rightCorner": {
              "x": 15.208,
              "y": 10.564,
              "z": 0.903
            },
            "gtin": "4063367208577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d19e",
            "leftCorner": {
              "x": 15.208,
              "y": 10.564,
              "z": 0.903
            },
            "rightCorner": {
              "x": 15.096,
              "y": 10.574,
              "z": 0.903
            },
            "gtin": "4063367208577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d19f",
            "leftCorner": {
              "x": 15.095,
              "y": 10.562,
              "z": 0.903
            },
            "rightCorner": {
              "x": 14.852,
              "y": 10.582,
              "z": 0.903
            },
            "gtin": "4063367004155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1a0",
            "leftCorner": {
              "x": 14.852,
              "y": 10.592,
              "z": 0.903
            },
            "rightCorner": {
              "x": 14.609,
              "y": 10.613,
              "z": 0.903
            },
            "gtin": "4337185766268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1a1",
            "leftCorner": {
              "x": 14.609,
              "y": 10.613,
              "z": 0.903
            },
            "rightCorner": {
              "x": 14.365,
              "y": 10.634,
              "z": 0.903
            },
            "gtin": "4337185766268",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462a1",
        "height": 1.4062,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d248",
            "leftCorner": {
              "x": 15.635,
              "y": 10.533,
              "z": 1.151
            },
            "rightCorner": {
              "x": 15.422,
              "y": 10.551,
              "z": 1.151
            },
            "gtin": "4052700083902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d249",
            "leftCorner": {
              "x": 15.422,
              "y": 10.551,
              "z": 1.151
            },
            "rightCorner": {
              "x": 15.208,
              "y": 10.569,
              "z": 1.151
            },
            "gtin": "4052700083902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d24a",
            "leftCorner": {
              "x": 15.208,
              "y": 10.569,
              "z": 1.151
            },
            "rightCorner": {
              "x": 14.994,
              "y": 10.587,
              "z": 1.151
            },
            "gtin": "4052700083902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d24b",
            "leftCorner": {
              "x": 14.993,
              "y": 10.569,
              "z": 1.151
            },
            "rightCorner": {
              "x": 14.798,
              "y": 10.586,
              "z": 1.151
            },
            "gtin": "4052700073453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d24c",
            "leftCorner": {
              "x": 14.798,
              "y": 10.586,
              "z": 1.151
            },
            "rightCorner": {
              "x": 14.603,
              "y": 10.602,
              "z": 1.151
            },
            "gtin": "4052700073453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d24d",
            "leftCorner": {
              "x": 14.603,
              "y": 10.602,
              "z": 1.151
            },
            "rightCorner": {
              "x": 14.407,
              "y": 10.619,
              "z": 1.151
            },
            "gtin": "4052700073453",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462a0",
        "height": 1.7037,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d283",
            "leftCorner": {
              "x": 15.606,
              "y": 10.525,
              "z": 1.394
            },
            "rightCorner": {
              "x": 15.347,
              "y": 10.547,
              "z": 1.394
            },
            "gtin": "4052700023502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d284",
            "leftCorner": {
              "x": 15.347,
              "y": 10.547,
              "z": 1.394
            },
            "rightCorner": {
              "x": 15.089,
              "y": 10.569,
              "z": 1.394
            },
            "gtin": "4052700023502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d285",
            "leftCorner": {
              "x": 15.089,
              "y": 10.572,
              "z": 1.394
            },
            "rightCorner": {
              "x": 14.908,
              "y": 10.587,
              "z": 1.394
            },
            "gtin": "4006581001753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d286",
            "leftCorner": {
              "x": 14.908,
              "y": 10.587,
              "z": 1.394
            },
            "rightCorner": {
              "x": 14.729,
              "y": 10.602,
              "z": 1.394
            },
            "gtin": "4006581001753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d287",
            "leftCorner": {
              "x": 14.729,
              "y": 10.602,
              "z": 1.394
            },
            "rightCorner": {
              "x": 14.548,
              "y": 10.617,
              "z": 1.394
            },
            "gtin": "4006581001753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d288",
            "leftCorner": {
              "x": 14.548,
              "y": 10.617,
              "z": 1.394
            },
            "rightCorner": {
              "x": 14.369,
              "y": 10.633,
              "z": 1.394
            },
            "gtin": "4006581001753",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f8d",
    "rightNeighborShelfId": "b6f8f"
  },
  {
    "id": "b6f8f",
    "name": "b6f8f",
    "x": 14.412,
    "y": 10.672,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99911,
      "w": 0.042277
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 39
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5462cc",
        "height": 0.14887,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d228",
            "leftCorner": {
              "x": 14.368,
              "y": 10.632,
              "z": 0.122
            },
            "rightCorner": {
              "x": 14.247,
              "y": 10.643,
              "z": 0.122
            },
            "gtin": "4037014004409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d229",
            "leftCorner": {
              "x": 14.247,
              "y": 10.643,
              "z": 0.122
            },
            "rightCorner": {
              "x": 14.125,
              "y": 10.653,
              "z": 0.122
            },
            "gtin": "4037014004409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d22a",
            "leftCorner": {
              "x": 14.125,
              "y": 10.653,
              "z": 0.122
            },
            "rightCorner": {
              "x": 14.005,
              "y": 10.664,
              "z": 0.122
            },
            "gtin": "4037014004409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d22b",
            "leftCorner": {
              "x": 14.005,
              "y": 10.662,
              "z": 0.122
            },
            "rightCorner": {
              "x": 13.602,
              "y": 10.696,
              "z": 0.122
            },
            "gtin": "4037014004508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d22c",
            "leftCorner": {
              "x": 13.602,
              "y": 10.696,
              "z": 0.122
            },
            "rightCorner": {
              "x": 13.2,
              "y": 10.73,
              "z": 0.122
            },
            "gtin": "4037014004508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d22d",
            "leftCorner": {
              "x": 13.2,
              "y": 10.73,
              "z": 0.122
            },
            "rightCorner": {
              "x": 12.799,
              "y": 10.764,
              "z": 0.122
            },
            "gtin": "4037014004508",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462cd",
        "height": 0.49467,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d1fc",
            "leftCorner": {
              "x": 14.143,
              "y": 10.645,
              "z": 0.405
            },
            "rightCorner": {
              "x": 13.998,
              "y": 10.657,
              "z": 0.405
            },
            "gtin": "9001810011607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1fd",
            "leftCorner": {
              "x": 13.998,
              "y": 10.658,
              "z": 0.405
            },
            "rightCorner": {
              "x": 13.71,
              "y": 10.683,
              "z": 0.405
            },
            "gtin": "9001810003701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1fe",
            "leftCorner": {
              "x": 13.71,
              "y": 10.683,
              "z": 0.405
            },
            "rightCorner": {
              "x": 13.42,
              "y": 10.707,
              "z": 0.405
            },
            "gtin": "9001810003701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1ff",
            "leftCorner": {
              "x": 13.42,
              "y": 10.707,
              "z": 0.405
            },
            "rightCorner": {
              "x": 13.131,
              "y": 10.731,
              "z": 0.405
            },
            "gtin": "9001810003701",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462cb",
        "height": 0.80473,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d1ca",
            "leftCorner": {
              "x": 14.346,
              "y": 10.642,
              "z": 0.658
            },
            "rightCorner": {
              "x": 14.132,
              "y": 10.661,
              "z": 0.658
            },
            "gtin": "4008167154679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1cb",
            "leftCorner": {
              "x": 14.132,
              "y": 10.661,
              "z": 0.658
            },
            "rightCorner": {
              "x": 13.917,
              "y": 10.678,
              "z": 0.658
            },
            "gtin": "4008167154679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1cc",
            "leftCorner": {
              "x": 13.917,
              "y": 10.678,
              "z": 0.658
            },
            "rightCorner": {
              "x": 13.703,
              "y": 10.696,
              "z": 0.658
            },
            "gtin": "4008167154679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1cd",
            "leftCorner": {
              "x": 13.703,
              "y": 10.685,
              "z": 0.658
            },
            "rightCorner": {
              "x": 13.494,
              "y": 10.702,
              "z": 0.658
            },
            "gtin": "8003410311089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1ce",
            "leftCorner": {
              "x": 13.494,
              "y": 10.702,
              "z": 0.658
            },
            "rightCorner": {
              "x": 13.285,
              "y": 10.721,
              "z": 0.658
            },
            "gtin": "8003410311089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1cf",
            "leftCorner": {
              "x": 13.285,
              "y": 10.717,
              "z": 0.658
            },
            "rightCorner": {
              "x": 13.114,
              "y": 10.731,
              "z": 0.658
            },
            "gtin": "8003410311171",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462c9",
        "height": 1.1068,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d1a2",
            "leftCorner": {
              "x": 14.365,
              "y": 10.644,
              "z": 0.906
            },
            "rightCorner": {
              "x": 14.16,
              "y": 10.661,
              "z": 0.906
            },
            "gtin": "4008167042709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1a3",
            "leftCorner": {
              "x": 14.16,
              "y": 10.661,
              "z": 0.906
            },
            "rightCorner": {
              "x": 13.955,
              "y": 10.679,
              "z": 0.906
            },
            "gtin": "4008167042709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1a4",
            "leftCorner": {
              "x": 13.955,
              "y": 10.679,
              "z": 0.906
            },
            "rightCorner": {
              "x": 13.83,
              "y": 10.689,
              "z": 0.906
            },
            "gtin": "4008167152729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1a5",
            "leftCorner": {
              "x": 13.83,
              "y": 10.689,
              "z": 0.906
            },
            "rightCorner": {
              "x": 13.707,
              "y": 10.7,
              "z": 0.906
            },
            "gtin": "4008167152729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1a6",
            "leftCorner": {
              "x": 13.706,
              "y": 10.693,
              "z": 0.906
            },
            "rightCorner": {
              "x": 13.538,
              "y": 10.707,
              "z": 0.906
            },
            "gtin": "4008167055105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1a7",
            "leftCorner": {
              "x": 13.538,
              "y": 10.707,
              "z": 0.906
            },
            "rightCorner": {
              "x": 13.371,
              "y": 10.721,
              "z": 0.906
            },
            "gtin": "4008167055105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1a8",
            "leftCorner": {
              "x": 13.371,
              "y": 10.722,
              "z": 0.906
            },
            "rightCorner": {
              "x": 13.127,
              "y": 10.743,
              "z": 0.906
            },
            "gtin": "4008167035503",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462c8",
        "height": 1.4,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d24e",
            "leftCorner": {
              "x": 14.409,
              "y": 10.642,
              "z": 1.145
            },
            "rightCorner": {
              "x": 14.02,
              "y": 10.674,
              "z": 1.145
            },
            "gtin": "4006581020846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d24f",
            "leftCorner": {
              "x": 14.02,
              "y": 10.664,
              "z": 1.145
            },
            "rightCorner": {
              "x": 13.866,
              "y": 10.677,
              "z": 1.145
            },
            "gtin": "4006581017716",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d250",
            "leftCorner": {
              "x": 13.866,
              "y": 10.677,
              "z": 1.145
            },
            "rightCorner": {
              "x": 13.711,
              "y": 10.691,
              "z": 1.145
            },
            "gtin": "4006581017716",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d251",
            "leftCorner": {
              "x": 13.712,
              "y": 10.695,
              "z": 1.145
            },
            "rightCorner": {
              "x": 13.5,
              "y": 10.713,
              "z": 1.145
            },
            "gtin": "4006581506272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d252",
            "leftCorner": {
              "x": 13.5,
              "y": 10.713,
              "z": 1.145
            },
            "rightCorner": {
              "x": 13.288,
              "y": 10.731,
              "z": 1.145
            },
            "gtin": "4006581506272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d253",
            "leftCorner": {
              "x": 13.288,
              "y": 10.731,
              "z": 1.145
            },
            "rightCorner": {
              "x": 13.075,
              "y": 10.749,
              "z": 1.145
            },
            "gtin": "4006581506272",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462ca",
        "height": 1.7038,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d289",
            "leftCorner": {
              "x": 14.369,
              "y": 10.645,
              "z": 1.394
            },
            "rightCorner": {
              "x": 14.237,
              "y": 10.656,
              "z": 1.394
            },
            "gtin": "4008167043805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d28a",
            "leftCorner": {
              "x": 14.237,
              "y": 10.656,
              "z": 1.394
            },
            "rightCorner": {
              "x": 14.105,
              "y": 10.667,
              "z": 1.394
            },
            "gtin": "4008167043805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d28b",
            "leftCorner": {
              "x": 14.105,
              "y": 10.667,
              "z": 1.394
            },
            "rightCorner": {
              "x": 13.975,
              "y": 10.678,
              "z": 1.394
            },
            "gtin": "4008167043805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d28c",
            "leftCorner": {
              "x": 13.975,
              "y": 10.678,
              "z": 1.394
            },
            "rightCorner": {
              "x": 13.843,
              "y": 10.689,
              "z": 1.394
            },
            "gtin": "4008167043805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d28d",
            "leftCorner": {
              "x": 13.843,
              "y": 10.687,
              "z": 1.394
            },
            "rightCorner": {
              "x": 13.706,
              "y": 10.699,
              "z": 1.394
            },
            "gtin": "4008167040002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d28e",
            "leftCorner": {
              "x": 13.706,
              "y": 10.699,
              "z": 1.394
            },
            "rightCorner": {
              "x": 13.568,
              "y": 10.711,
              "z": 1.394
            },
            "gtin": "4008167040002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d28f",
            "leftCorner": {
              "x": 13.568,
              "y": 10.711,
              "z": 1.394
            },
            "rightCorner": {
              "x": 13.431,
              "y": 10.722,
              "z": 1.394
            },
            "gtin": "4008167040002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d290",
            "leftCorner": {
              "x": 13.431,
              "y": 10.724,
              "z": 1.394
            },
            "rightCorner": {
              "x": 13.333,
              "y": 10.733,
              "z": 1.394
            },
            "gtin": "4008167045205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d291",
            "leftCorner": {
              "x": 13.333,
              "y": 10.733,
              "z": 1.394
            },
            "rightCorner": {
              "x": 13.237,
              "y": 10.742,
              "z": 1.394
            },
            "gtin": "4008167045205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d292",
            "leftCorner": {
              "x": 13.237,
              "y": 10.742,
              "z": 1.394
            },
            "rightCorner": {
              "x": 13.14,
              "y": 10.749,
              "z": 1.394
            },
            "gtin": "4008167045205",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f8e",
    "rightNeighborShelfId": "b6f90"
  },
  {
    "id": "b6f90",
    "name": "b6f90",
    "x": 13.167,
    "y": 10.777,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99911,
      "w": 0.042277
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 28
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5462d3",
        "height": 0.15598,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d22e",
            "leftCorner": {
              "x": 12.8,
              "y": 10.771,
              "z": 0.128
            },
            "rightCorner": {
              "x": 12.599,
              "y": 10.789,
              "z": 0.128
            },
            "gtin": "4006581017815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d22f",
            "leftCorner": {
              "x": 12.599,
              "y": 10.789,
              "z": 0.128
            },
            "rightCorner": {
              "x": 12.397,
              "y": 10.806,
              "z": 0.128
            },
            "gtin": "4006581017815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d230",
            "leftCorner": {
              "x": 12.397,
              "y": 10.806,
              "z": 0.128
            },
            "rightCorner": {
              "x": 12.195,
              "y": 10.823,
              "z": 0.128
            },
            "gtin": "4006581017815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d231",
            "leftCorner": {
              "x": 12.194,
              "y": 10.809,
              "z": 0.128
            },
            "rightCorner": {
              "x": 12.106,
              "y": 10.816,
              "z": 0.128
            },
            "gtin": "8711000891704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d232",
            "leftCorner": {
              "x": 12.106,
              "y": 10.816,
              "z": 0.128
            },
            "rightCorner": {
              "x": 12.017,
              "y": 10.824,
              "z": 0.128
            },
            "gtin": "8711000891704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d206",
            "leftCorner": {
              "x": 12.016,
              "y": 10.818,
              "z": 0.128
            },
            "rightCorner": {
              "x": 11.916,
              "y": 10.827,
              "z": 0.128
            },
            "gtin": "8711000891735",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462cf",
        "height": 0.50004,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d1d9",
            "leftCorner": {
              "x": 13.132,
              "y": 10.737,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.829,
              "y": 10.762,
              "z": 0.409
            },
            "gtin": "4002720008102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1da",
            "leftCorner": {
              "x": 12.829,
              "y": 10.762,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.525,
              "y": 10.788,
              "z": 0.409
            },
            "gtin": "4002720008102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1db",
            "leftCorner": {
              "x": 12.525,
              "y": 10.788,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.222,
              "y": 10.814,
              "z": 0.409
            },
            "gtin": "4002720008102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1dc",
            "leftCorner": {
              "x": 12.222,
              "y": 10.814,
              "z": 0.409
            },
            "rightCorner": {
              "x": 11.918,
              "y": 10.84,
              "z": 0.409
            },
            "gtin": "4002720008102",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462d0",
        "height": 0.80312,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d1d0",
            "leftCorner": {
              "x": 13.115,
              "y": 10.743,
              "z": 0.657
            },
            "rightCorner": {
              "x": 12.792,
              "y": 10.77,
              "z": 0.657
            },
            "gtin": "4002720008300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1d1",
            "leftCorner": {
              "x": 12.792,
              "y": 10.77,
              "z": 0.657
            },
            "rightCorner": {
              "x": 12.469,
              "y": 10.797,
              "z": 0.657
            },
            "gtin": "4002720008300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1d2",
            "leftCorner": {
              "x": 12.469,
              "y": 10.797,
              "z": 0.657
            },
            "rightCorner": {
              "x": 12.146,
              "y": 10.824,
              "z": 0.657
            },
            "gtin": "4002720008300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1d3",
            "leftCorner": {
              "x": 12.146,
              "y": 10.825,
              "z": 0.657
            },
            "rightCorner": {
              "x": 12.009,
              "y": 10.838,
              "z": 0.657
            },
            "gtin": "4002720008027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1af",
            "leftCorner": {
              "x": 12.009,
              "y": 10.834,
              "z": 0.657
            },
            "rightCorner": {
              "x": 11.919,
              "y": 10.842,
              "z": 0.657
            },
            "gtin": "4002720008164",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462d1",
        "height": 1.1063,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d1a9",
            "leftCorner": {
              "x": 13.129,
              "y": 10.753,
              "z": 0.905
            },
            "rightCorner": {
              "x": 12.979,
              "y": 10.765,
              "z": 0.905
            },
            "gtin": "4008167734802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1aa",
            "leftCorner": {
              "x": 12.979,
              "y": 10.765,
              "z": 0.905
            },
            "rightCorner": {
              "x": 12.83,
              "y": 10.778,
              "z": 0.905
            },
            "gtin": "4008167734802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d182",
            "leftCorner": {
              "x": 12.829,
              "y": 10.769,
              "z": 0.905
            },
            "rightCorner": {
              "x": 12.525,
              "y": 10.795,
              "z": 0.905
            },
            "gtin": "4002720009741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d183",
            "leftCorner": {
              "x": 12.525,
              "y": 10.795,
              "z": 0.905
            },
            "rightCorner": {
              "x": 12.222,
              "y": 10.821,
              "z": 0.905
            },
            "gtin": "4002720009741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d184",
            "leftCorner": {
              "x": 12.222,
              "y": 10.821,
              "z": 0.905
            },
            "rightCorner": {
              "x": 11.919,
              "y": 10.847,
              "z": 0.905
            },
            "gtin": "4002720009741",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462d2",
        "height": 1.4031,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d254",
            "leftCorner": {
              "x": 13.077,
              "y": 10.76,
              "z": 1.148
            },
            "rightCorner": {
              "x": 12.817,
              "y": 10.782,
              "z": 1.148
            },
            "gtin": "4002720008508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d255",
            "leftCorner": {
              "x": 12.817,
              "y": 10.785,
              "z": 1.148
            },
            "rightCorner": {
              "x": 12.496,
              "y": 10.812,
              "z": 1.148
            },
            "gtin": "4002720008096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d256",
            "leftCorner": {
              "x": 12.495,
              "y": 10.805,
              "z": 1.148
            },
            "rightCorner": {
              "x": 12.237,
              "y": 10.827,
              "z": 1.148
            },
            "gtin": "4002720009727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d257",
            "leftCorner": {
              "x": 12.237,
              "y": 10.827,
              "z": 1.148
            },
            "rightCorner": {
              "x": 11.978,
              "y": 10.849,
              "z": 1.148
            },
            "gtin": "4002720009727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d237",
            "leftCorner": {
              "x": 11.979,
              "y": 10.854,
              "z": 1.148
            },
            "rightCorner": {
              "x": 11.92,
              "y": 10.859,
              "z": 1.148
            },
            "gtin": "8000070027336",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462ce",
        "height": 1.7005,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d293",
            "leftCorner": {
              "x": 13.142,
              "y": 10.759,
              "z": 1.391
            },
            "rightCorner": {
              "x": 12.839,
              "y": 10.785,
              "z": 1.391
            },
            "gtin": "4008167043904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d294",
            "leftCorner": {
              "x": 12.839,
              "y": 10.785,
              "z": 1.391
            },
            "rightCorner": {
              "x": 12.536,
              "y": 10.81,
              "z": 1.391
            },
            "gtin": "4008167043904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d25c",
            "leftCorner": {
              "x": 12.535,
              "y": 10.804,
              "z": 1.391
            },
            "rightCorner": {
              "x": 12.227,
              "y": 10.831,
              "z": 1.391
            },
            "gtin": "8003410311171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d25d",
            "leftCorner": {
              "x": 12.227,
              "y": 10.831,
              "z": 1.391
            },
            "rightCorner": {
              "x": 11.92,
              "y": 10.857,
              "z": 1.391
            },
            "gtin": "8003410311171",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f8f"
  },
  {
    "id": "b6f91",
    "name": "b6f91",
    "x": 8.273,
    "y": 9.989,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.029064,
      "w": 0.99958
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 26
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54628f",
        "height": 1.7177,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd39",
            "leftCorner": {
              "x": 8.753,
              "y": 9.991,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.835,
              "y": 9.986,
              "z": 1.405
            },
            "gtin": "4001762070016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd3a",
            "leftCorner": {
              "x": 8.835,
              "y": 9.986,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.917,
              "y": 9.982,
              "z": 1.405
            },
            "gtin": "4001762070016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd3b",
            "leftCorner": {
              "x": 8.917,
              "y": 9.982,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.999,
              "y": 9.976,
              "z": 1.405
            },
            "gtin": "4001762070016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd28",
            "leftCorner": {
              "x": 8.999,
              "y": 9.981,
              "z": 1.405
            },
            "rightCorner": {
              "x": 9.136,
              "y": 9.973,
              "z": 1.405
            },
            "gtin": "4001762060260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd29",
            "leftCorner": {
              "x": 9.136,
              "y": 9.973,
              "z": 1.405
            },
            "rightCorner": {
              "x": 9.273,
              "y": 9.965,
              "z": 1.405
            },
            "gtin": "4001762060260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd35",
            "leftCorner": {
              "x": 8.399,
              "y": 10.016,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.49,
              "y": 10.012,
              "z": 1.405
            },
            "gtin": "4001762060215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd36",
            "leftCorner": {
              "x": 8.49,
              "y": 10.012,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.581,
              "y": 10.006,
              "z": 1.405
            },
            "gtin": "4001762060215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd37",
            "leftCorner": {
              "x": 8.581,
              "y": 10.006,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.672,
              "y": 10.0,
              "z": 1.405
            },
            "gtin": "4001762060215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd38",
            "leftCorner": {
              "x": 8.672,
              "y": 9.996,
              "z": 1.405
            },
            "rightCorner": {
              "x": 8.753,
              "y": 9.991,
              "z": 1.405
            },
            "gtin": "4001762070016",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546292",
        "height": 0.16179,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd56",
            "leftCorner": {
              "x": 9.015,
              "y": 9.993,
              "z": 0.132
            },
            "rightCorner": {
              "x": 9.145,
              "y": 9.986,
              "z": 0.132
            },
            "gtin": "4032844250118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd57",
            "leftCorner": {
              "x": 9.145,
              "y": 9.986,
              "z": 0.132
            },
            "rightCorner": {
              "x": 9.274,
              "y": 9.978,
              "z": 0.132
            },
            "gtin": "4032844250118",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546291",
        "height": 0.5594,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd53",
            "leftCorner": {
              "x": 8.467,
              "y": 10.029,
              "z": 0.458
            },
            "rightCorner": {
              "x": 8.686,
              "y": 10.017,
              "z": 0.458
            },
            "gtin": "4032844250071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd54",
            "leftCorner": {
              "x": 8.686,
              "y": 10.017,
              "z": 0.458
            },
            "rightCorner": {
              "x": 9.035,
              "y": 9.996,
              "z": 0.458
            },
            "gtin": "4032844050664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd4a",
            "leftCorner": {
              "x": 9.035,
              "y": 9.988,
              "z": 0.458
            },
            "rightCorner": {
              "x": 9.274,
              "y": 9.975,
              "z": 0.458
            },
            "gtin": "4032844050022",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546290",
        "height": 0.96048,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd44",
            "leftCorner": {
              "x": 8.431,
              "y": 10.024,
              "z": 0.786
            },
            "rightCorner": {
              "x": 8.57,
              "y": 10.016,
              "z": 0.786
            },
            "gtin": "4032844387807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd45",
            "leftCorner": {
              "x": 8.57,
              "y": 10.016,
              "z": 0.786
            },
            "rightCorner": {
              "x": 8.709,
              "y": 10.007,
              "z": 0.786
            },
            "gtin": "4032844387807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd46",
            "leftCorner": {
              "x": 8.709,
              "y": 10.013,
              "z": 0.786
            },
            "rightCorner": {
              "x": 8.887,
              "y": 10.003,
              "z": 0.786
            },
            "gtin": "4032844388101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd47",
            "leftCorner": {
              "x": 8.887,
              "y": 10.003,
              "z": 0.786
            },
            "rightCorner": {
              "x": 9.065,
              "y": 9.993,
              "z": 0.786
            },
            "gtin": "4032844388101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd3e",
            "leftCorner": {
              "x": 9.064,
              "y": 9.978,
              "z": 0.786
            },
            "rightCorner": {
              "x": 9.169,
              "y": 9.971,
              "z": 0.786
            },
            "gtin": "4032844555114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd3f",
            "leftCorner": {
              "x": 9.169,
              "y": 9.971,
              "z": 0.786
            },
            "rightCorner": {
              "x": 9.273,
              "y": 9.966,
              "z": 0.786
            },
            "gtin": "4032844555114",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54628e",
        "height": 1.3644,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd21",
            "leftCorner": {
              "x": 8.213,
              "y": 10.027,
              "z": 1.116
            },
            "rightCorner": {
              "x": 8.474,
              "y": 10.012,
              "z": 1.116
            },
            "gtin": "4036554704022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd22",
            "leftCorner": {
              "x": 8.474,
              "y": 10.012,
              "z": 1.116
            },
            "rightCorner": {
              "x": 8.735,
              "y": 9.997,
              "z": 1.116
            },
            "gtin": "4036554704022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd23",
            "leftCorner": {
              "x": 8.736,
              "y": 10.009,
              "z": 1.116
            },
            "rightCorner": {
              "x": 8.871,
              "y": 10.002,
              "z": 1.116
            },
            "gtin": "4001762060277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd24",
            "leftCorner": {
              "x": 8.871,
              "y": 10.002,
              "z": 1.116
            },
            "rightCorner": {
              "x": 9.007,
              "y": 9.994,
              "z": 1.116
            },
            "gtin": "4001762060277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd19",
            "leftCorner": {
              "x": 9.007,
              "y": 9.983,
              "z": 1.116
            },
            "rightCorner": {
              "x": 9.14,
              "y": 9.975,
              "z": 1.116
            },
            "gtin": "4001762060253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd1a",
            "leftCorner": {
              "x": 9.14,
              "y": 9.975,
              "z": 1.116
            },
            "rightCorner": {
              "x": 9.273,
              "y": 9.968,
              "z": 1.116
            },
            "gtin": "4001762060253",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ddeca",
    "rightNeighborShelfId": "ddec7"
  },
  {
    "id": "b6f92",
    "name": "b6f92",
    "x": 10.752,
    "y": 9.767,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03987,
      "w": 0.9992
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 34
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54629c",
        "height": 0.15354,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d369",
            "leftCorner": {
              "x": 10.823,
              "y": 9.81,
              "z": 0.126
            },
            "rightCorner": {
              "x": 10.958,
              "y": 9.799,
              "z": 0.126
            },
            "gtin": "4000398254265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d36a",
            "leftCorner": {
              "x": 10.959,
              "y": 9.803,
              "z": 0.126
            },
            "rightCorner": {
              "x": 11.201,
              "y": 9.784,
              "z": 0.126
            },
            "gtin": "4000398255132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d36b",
            "leftCorner": {
              "x": 11.201,
              "y": 9.784,
              "z": 0.126
            },
            "rightCorner": {
              "x": 11.443,
              "y": 9.764,
              "z": 0.126
            },
            "gtin": "4000398255132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d36c",
            "leftCorner": {
              "x": 11.443,
              "y": 9.766,
              "z": 0.126
            },
            "rightCorner": {
              "x": 11.583,
              "y": 9.755,
              "z": 0.126
            },
            "gtin": "4000398254111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d36d",
            "leftCorner": {
              "x": 11.583,
              "y": 9.755,
              "z": 0.126
            },
            "rightCorner": {
              "x": 11.723,
              "y": 9.744,
              "z": 0.126
            },
            "gtin": "4000398254111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d36e",
            "leftCorner": {
              "x": 11.722,
              "y": 9.726,
              "z": 0.126
            },
            "rightCorner": {
              "x": 11.869,
              "y": 9.715,
              "z": 0.126
            },
            "gtin": "4000398254210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d36f",
            "leftCorner": {
              "x": 11.869,
              "y": 9.715,
              "z": 0.126
            },
            "rightCorner": {
              "x": 12.015,
              "y": 9.703,
              "z": 0.126
            },
            "gtin": "4000398254210",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546298",
        "height": 0.55254,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d30d",
            "leftCorner": {
              "x": 10.759,
              "y": 9.814,
              "z": 0.452
            },
            "rightCorner": {
              "x": 10.865,
              "y": 9.805,
              "z": 0.452
            },
            "gtin": "4002861654176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d30e",
            "leftCorner": {
              "x": 10.865,
              "y": 9.805,
              "z": 0.452
            },
            "rightCorner": {
              "x": 10.97,
              "y": 9.797,
              "z": 0.452
            },
            "gtin": "4002861654176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d30f",
            "leftCorner": {
              "x": 10.97,
              "y": 9.802,
              "z": 0.452
            },
            "rightCorner": {
              "x": 11.212,
              "y": 9.783,
              "z": 0.452
            },
            "gtin": "4002861654022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d310",
            "leftCorner": {
              "x": 11.213,
              "y": 9.791,
              "z": 0.452
            },
            "rightCorner": {
              "x": 11.361,
              "y": 9.779,
              "z": 0.452
            },
            "gtin": "4002861654145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d311",
            "leftCorner": {
              "x": 11.361,
              "y": 9.774,
              "z": 0.452
            },
            "rightCorner": {
              "x": 11.657,
              "y": 9.751,
              "z": 0.452
            },
            "gtin": "4002861654169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d312",
            "leftCorner": {
              "x": 11.657,
              "y": 9.751,
              "z": 0.452
            },
            "rightCorner": {
              "x": 11.953,
              "y": 9.727,
              "z": 0.452
            },
            "gtin": "4002861654169",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54629b",
        "height": 0.95532,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d2df",
            "leftCorner": {
              "x": 10.796,
              "y": 9.807,
              "z": 0.782
            },
            "rightCorner": {
              "x": 10.95,
              "y": 9.795,
              "z": 0.782
            },
            "gtin": "4002676212172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2e0",
            "leftCorner": {
              "x": 10.95,
              "y": 9.795,
              "z": 0.782
            },
            "rightCorner": {
              "x": 11.105,
              "y": 9.783,
              "z": 0.782
            },
            "gtin": "4002676212172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2e1",
            "leftCorner": {
              "x": 11.105,
              "y": 9.789,
              "z": 0.782
            },
            "rightCorner": {
              "x": 11.196,
              "y": 9.781,
              "z": 0.782
            },
            "gtin": "4002676212165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2e2",
            "leftCorner": {
              "x": 11.196,
              "y": 9.781,
              "z": 0.782
            },
            "rightCorner": {
              "x": 11.286,
              "y": 9.774,
              "z": 0.782
            },
            "gtin": "4002676212165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2e3",
            "leftCorner": {
              "x": 11.286,
              "y": 9.774,
              "z": 0.782
            },
            "rightCorner": {
              "x": 11.376,
              "y": 9.766,
              "z": 0.782
            },
            "gtin": "4002676212165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2e4",
            "leftCorner": {
              "x": 11.376,
              "y": 9.766,
              "z": 0.782
            },
            "rightCorner": {
              "x": 11.539,
              "y": 9.754,
              "z": 0.782
            },
            "gtin": "4002676232019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2e5",
            "leftCorner": {
              "x": 11.539,
              "y": 9.754,
              "z": 0.782
            },
            "rightCorner": {
              "x": 11.7,
              "y": 9.74,
              "z": 0.782
            },
            "gtin": "4002676232019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2e6",
            "leftCorner": {
              "x": 11.701,
              "y": 9.752,
              "z": 0.782
            },
            "rightCorner": {
              "x": 11.847,
              "y": 9.74,
              "z": 0.782
            },
            "gtin": "4002676212189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2e7",
            "leftCorner": {
              "x": 11.847,
              "y": 9.74,
              "z": 0.782
            },
            "rightCorner": {
              "x": 11.995,
              "y": 9.728,
              "z": 0.782
            },
            "gtin": "4002676212189",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546299",
        "height": 1.3595,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d2a2",
            "leftCorner": {
              "x": 10.789,
              "y": 9.795,
              "z": 1.112
            },
            "rightCorner": {
              "x": 11.075,
              "y": 9.773,
              "z": 1.112
            },
            "gtin": "4002676212875",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2a3",
            "leftCorner": {
              "x": 11.076,
              "y": 9.786,
              "z": 1.112
            },
            "rightCorner": {
              "x": 11.23,
              "y": 9.773,
              "z": 1.112
            },
            "gtin": "4002676212042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2a4",
            "leftCorner": {
              "x": 11.23,
              "y": 9.773,
              "z": 1.112
            },
            "rightCorner": {
              "x": 11.385,
              "y": 9.761,
              "z": 1.112
            },
            "gtin": "4002676212042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2a5",
            "leftCorner": {
              "x": 11.384,
              "y": 9.752,
              "z": 1.112
            },
            "rightCorner": {
              "x": 11.514,
              "y": 9.742,
              "z": 1.112
            },
            "gtin": "4002676212035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2a6",
            "leftCorner": {
              "x": 11.514,
              "y": 9.742,
              "z": 1.112
            },
            "rightCorner": {
              "x": 11.643,
              "y": 9.731,
              "z": 1.112
            },
            "gtin": "4002676212035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2a7",
            "leftCorner": {
              "x": 11.645,
              "y": 9.745,
              "z": 1.112
            },
            "rightCorner": {
              "x": 11.761,
              "y": 9.736,
              "z": 1.112
            },
            "gtin": "4002676212073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2a8",
            "leftCorner": {
              "x": 11.761,
              "y": 9.736,
              "z": 1.112
            },
            "rightCorner": {
              "x": 11.877,
              "y": 9.727,
              "z": 1.112
            },
            "gtin": "4002676212073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2a9",
            "leftCorner": {
              "x": 11.877,
              "y": 9.727,
              "z": 1.112
            },
            "rightCorner": {
              "x": 11.992,
              "y": 9.718,
              "z": 1.112
            },
            "gtin": "4002676212073",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54629a",
        "height": 1.7107,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d340",
            "leftCorner": {
              "x": 10.787,
              "y": 9.801,
              "z": 1.4
            },
            "rightCorner": {
              "x": 11.077,
              "y": 9.778,
              "z": 1.4
            },
            "gtin": "4002676212028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d341",
            "leftCorner": {
              "x": 11.077,
              "y": 9.778,
              "z": 1.4
            },
            "rightCorner": {
              "x": 11.367,
              "y": 9.755,
              "z": 1.4
            },
            "gtin": "4002676212028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d342",
            "leftCorner": {
              "x": 11.368,
              "y": 9.769,
              "z": 1.4
            },
            "rightCorner": {
              "x": 11.689,
              "y": 9.743,
              "z": 1.4
            },
            "gtin": "4002676212134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d343",
            "leftCorner": {
              "x": 11.689,
              "y": 9.743,
              "z": 1.4
            },
            "rightCorner": {
              "x": 12.01,
              "y": 9.717,
              "z": 1.4
            },
            "gtin": "4002676212134",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ddec7",
    "rightNeighborShelfId": "b6f93"
  },
  {
    "id": "b6f93",
    "name": "b6f93",
    "x": 11.949,
    "y": 9.671,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03987,
      "w": 0.9992
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 46
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54618b",
        "height": 0.15206,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d370",
            "leftCorner": {
              "x": 12.018,
              "y": 9.721,
              "z": 0.124
            },
            "rightCorner": {
              "x": 12.172,
              "y": 9.708,
              "z": 0.124
            },
            "gtin": "4000398254005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d371",
            "leftCorner": {
              "x": 12.172,
              "y": 9.708,
              "z": 0.124
            },
            "rightCorner": {
              "x": 12.326,
              "y": 9.696,
              "z": 0.124
            },
            "gtin": "4000398254005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d372",
            "leftCorner": {
              "x": 12.326,
              "y": 9.696,
              "z": 0.124
            },
            "rightCorner": {
              "x": 12.48,
              "y": 9.684,
              "z": 0.124
            },
            "gtin": "4000398254005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d373",
            "leftCorner": {
              "x": 12.479,
              "y": 9.675,
              "z": 0.124
            },
            "rightCorner": {
              "x": 12.591,
              "y": 9.667,
              "z": 0.124
            },
            "gtin": "4000398254258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d374",
            "leftCorner": {
              "x": 12.591,
              "y": 9.661,
              "z": 0.124
            },
            "rightCorner": {
              "x": 12.857,
              "y": 9.64,
              "z": 0.124
            },
            "gtin": "8000755020287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d375",
            "leftCorner": {
              "x": 12.857,
              "y": 9.646,
              "z": 0.124
            },
            "rightCorner": {
              "x": 12.939,
              "y": 9.639,
              "z": 0.124
            },
            "gtin": "8000755020423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d376",
            "leftCorner": {
              "x": 12.939,
              "y": 9.639,
              "z": 0.124
            },
            "rightCorner": {
              "x": 13.021,
              "y": 9.632,
              "z": 0.124
            },
            "gtin": "8000755020423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d377",
            "leftCorner": {
              "x": 13.021,
              "y": 9.632,
              "z": 0.124
            },
            "rightCorner": {
              "x": 13.103,
              "y": 9.626,
              "z": 0.124
            },
            "gtin": "8000755020423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d378",
            "leftCorner": {
              "x": 13.103,
              "y": 9.626,
              "z": 0.124
            },
            "rightCorner": {
              "x": 13.184,
              "y": 9.619,
              "z": 0.124
            },
            "gtin": "8000755020423",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546189",
        "height": 0.54815,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d313",
            "leftCorner": {
              "x": 11.954,
              "y": 9.736,
              "z": 0.448
            },
            "rightCorner": {
              "x": 12.031,
              "y": 9.729,
              "z": 0.448
            },
            "gtin": "4000398254043",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c845ed67a01d9a1d314",
            "leftCorner": {
              "x": 12.032,
              "y": 9.737,
              "z": 0.448
            },
            "rightCorner": {
              "x": 12.194,
              "y": 9.723,
              "z": 0.448
            },
            "gtin": "4000398254043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d315",
            "leftCorner": {
              "x": 12.194,
              "y": 9.719,
              "z": 0.448
            },
            "rightCorner": {
              "x": 12.293,
              "y": 9.711,
              "z": 0.448
            },
            "gtin": "4000398254074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d316",
            "leftCorner": {
              "x": 12.293,
              "y": 9.711,
              "z": 0.448
            },
            "rightCorner": {
              "x": 12.392,
              "y": 9.703,
              "z": 0.448
            },
            "gtin": "4000398254074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d317",
            "leftCorner": {
              "x": 12.392,
              "y": 9.703,
              "z": 0.448
            },
            "rightCorner": {
              "x": 12.491,
              "y": 9.695,
              "z": 0.448
            },
            "gtin": "4000398254074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d318",
            "leftCorner": {
              "x": 12.491,
              "y": 9.695,
              "z": 0.448
            },
            "rightCorner": {
              "x": 12.606,
              "y": 9.687,
              "z": 0.448
            },
            "gtin": "4000398254104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d319",
            "leftCorner": {
              "x": 12.606,
              "y": 9.687,
              "z": 0.448
            },
            "rightCorner": {
              "x": 12.722,
              "y": 9.677,
              "z": 0.448
            },
            "gtin": "4000398254104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d31a",
            "leftCorner": {
              "x": 12.722,
              "y": 9.677,
              "z": 0.448
            },
            "rightCorner": {
              "x": 12.839,
              "y": 9.668,
              "z": 0.448
            },
            "gtin": "4000398254104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d31b",
            "leftCorner": {
              "x": 12.839,
              "y": 9.668,
              "z": 0.448
            },
            "rightCorner": {
              "x": 12.954,
              "y": 9.659,
              "z": 0.448
            },
            "gtin": "4000398254104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d31c",
            "leftCorner": {
              "x": 12.954,
              "y": 9.654,
              "z": 0.448
            },
            "rightCorner": {
              "x": 13.025,
              "y": 9.648,
              "z": 0.448
            },
            "gtin": "4000398254142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d31d",
            "leftCorner": {
              "x": 13.025,
              "y": 9.648,
              "z": 0.448
            },
            "rightCorner": {
              "x": 13.097,
              "y": 9.642,
              "z": 0.448
            },
            "gtin": "4000398254142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d31e",
            "leftCorner": {
              "x": 13.097,
              "y": 9.642,
              "z": 0.448
            },
            "rightCorner": {
              "x": 13.167,
              "y": 9.636,
              "z": 0.448
            },
            "gtin": "4000398254142",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546188",
        "height": 0.94993,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d2e8",
            "leftCorner": {
              "x": 11.996,
              "y": 9.732,
              "z": 0.777
            },
            "rightCorner": {
              "x": 12.263,
              "y": 9.71,
              "z": 0.777
            },
            "gtin": "4000398255040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2e9",
            "leftCorner": {
              "x": 12.263,
              "y": 9.705,
              "z": 0.777
            },
            "rightCorner": {
              "x": 12.59,
              "y": 9.68,
              "z": 0.777
            },
            "gtin": "4000398255101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2ea",
            "leftCorner": {
              "x": 12.59,
              "y": 9.681,
              "z": 0.777
            },
            "rightCorner": {
              "x": 12.808,
              "y": 9.663,
              "z": 0.777
            },
            "gtin": "4000398254289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2eb",
            "leftCorner": {
              "x": 12.808,
              "y": 9.663,
              "z": 0.777
            },
            "rightCorner": {
              "x": 13.028,
              "y": 9.646,
              "z": 0.777
            },
            "gtin": "4000398254289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2ec",
            "leftCorner": {
              "x": 13.028,
              "y": 9.646,
              "z": 0.777
            },
            "rightCorner": {
              "x": 13.246,
              "y": 9.628,
              "z": 0.777
            },
            "gtin": "4000398254289",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546187",
        "height": 1.3547,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d2aa",
            "leftCorner": {
              "x": 11.993,
              "y": 9.719,
              "z": 1.108
            },
            "rightCorner": {
              "x": 12.092,
              "y": 9.712,
              "z": 1.108
            },
            "gtin": "4000398152004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2ab",
            "leftCorner": {
              "x": 12.092,
              "y": 9.712,
              "z": 1.108
            },
            "rightCorner": {
              "x": 12.191,
              "y": 9.704,
              "z": 1.108
            },
            "gtin": "4000398152004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2ac",
            "leftCorner": {
              "x": 12.191,
              "y": 9.704,
              "z": 1.108
            },
            "rightCorner": {
              "x": 12.289,
              "y": 9.696,
              "z": 1.108
            },
            "gtin": "4000398152004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2ad",
            "leftCorner": {
              "x": 12.289,
              "y": 9.698,
              "z": 1.108
            },
            "rightCorner": {
              "x": 12.367,
              "y": 9.691,
              "z": 1.108
            },
            "gtin": "4000398152103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2ae",
            "leftCorner": {
              "x": 12.367,
              "y": 9.691,
              "z": 1.108
            },
            "rightCorner": {
              "x": 12.446,
              "y": 9.684,
              "z": 1.108
            },
            "gtin": "4000398152103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2af",
            "leftCorner": {
              "x": 12.446,
              "y": 9.684,
              "z": 1.108
            },
            "rightCorner": {
              "x": 12.524,
              "y": 9.678,
              "z": 1.108
            },
            "gtin": "4000398152103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2b0",
            "leftCorner": {
              "x": 12.524,
              "y": 9.683,
              "z": 1.108
            },
            "rightCorner": {
              "x": 12.589,
              "y": 9.678,
              "z": 1.108
            },
            "gtin": "4000398152073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2b1",
            "leftCorner": {
              "x": 12.589,
              "y": 9.678,
              "z": 1.108
            },
            "rightCorner": {
              "x": 12.654,
              "y": 9.673,
              "z": 1.108
            },
            "gtin": "4000398152073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2b2",
            "leftCorner": {
              "x": 12.654,
              "y": 9.673,
              "z": 1.108
            },
            "rightCorner": {
              "x": 12.718,
              "y": 9.668,
              "z": 1.108
            },
            "gtin": "4000398152073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2b3",
            "leftCorner": {
              "x": 12.718,
              "y": 9.668,
              "z": 1.108
            },
            "rightCorner": {
              "x": 12.831,
              "y": 9.66,
              "z": 1.108
            },
            "gtin": "4000398152134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2b4",
            "leftCorner": {
              "x": 12.831,
              "y": 9.66,
              "z": 1.108
            },
            "rightCorner": {
              "x": 12.944,
              "y": 9.65,
              "z": 1.108
            },
            "gtin": "4000398152134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2b5",
            "leftCorner": {
              "x": 12.944,
              "y": 9.649,
              "z": 1.108
            },
            "rightCorner": {
              "x": 13.06,
              "y": 9.64,
              "z": 1.108
            },
            "gtin": "4000398753003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2b6",
            "leftCorner": {
              "x": 13.06,
              "y": 9.64,
              "z": 1.108
            },
            "rightCorner": {
              "x": 13.178,
              "y": 9.631,
              "z": 1.108
            },
            "gtin": "4000398753003",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54618a",
        "height": 1.7043,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d344",
            "leftCorner": {
              "x": 12.012,
              "y": 9.735,
              "z": 1.394
            },
            "rightCorner": {
              "x": 12.225,
              "y": 9.718,
              "z": 1.394
            },
            "gtin": "4000398152141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d345",
            "leftCorner": {
              "x": 12.225,
              "y": 9.718,
              "z": 1.394
            },
            "rightCorner": {
              "x": 12.437,
              "y": 9.701,
              "z": 1.394
            },
            "gtin": "4000398152141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d346",
            "leftCorner": {
              "x": 12.436,
              "y": 9.692,
              "z": 1.394
            },
            "rightCorner": {
              "x": 12.602,
              "y": 9.678,
              "z": 1.394
            },
            "gtin": "4000398152097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d347",
            "leftCorner": {
              "x": 12.602,
              "y": 9.678,
              "z": 1.394
            },
            "rightCorner": {
              "x": 12.768,
              "y": 9.665,
              "z": 1.394
            },
            "gtin": "4000398152097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d348",
            "leftCorner": {
              "x": 12.768,
              "y": 9.665,
              "z": 1.394
            },
            "rightCorner": {
              "x": 12.934,
              "y": 9.652,
              "z": 1.394
            },
            "gtin": "4000398152097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d349",
            "leftCorner": {
              "x": 12.934,
              "y": 9.652,
              "z": 1.394
            },
            "rightCorner": {
              "x": 13.023,
              "y": 9.645,
              "z": 1.394
            },
            "gtin": "4000398152042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d34a",
            "leftCorner": {
              "x": 13.023,
              "y": 9.645,
              "z": 1.394
            },
            "rightCorner": {
              "x": 13.111,
              "y": 9.638,
              "z": 1.394
            },
            "gtin": "4000398152042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d34b",
            "leftCorner": {
              "x": 13.111,
              "y": 9.638,
              "z": 1.394
            },
            "rightCorner": {
              "x": 13.2,
              "y": 9.63,
              "z": 1.394
            },
            "gtin": "4000398152042",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f92",
    "rightNeighborShelfId": "b6f94"
  },
  {
    "id": "b6f94",
    "name": "b6f94",
    "x": 13.145,
    "y": 9.575,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03987,
      "w": 0.9992
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 44
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546235",
        "height": 0.14759,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d379",
            "leftCorner": {
              "x": 13.185,
              "y": 9.626,
              "z": 0.121
            },
            "rightCorner": {
              "x": 13.285,
              "y": 9.617,
              "z": 0.121
            },
            "gtin": "8000755020386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d37a",
            "leftCorner": {
              "x": 13.285,
              "y": 9.617,
              "z": 0.121
            },
            "rightCorner": {
              "x": 13.385,
              "y": 9.61,
              "z": 0.121
            },
            "gtin": "8000755020386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d37b",
            "leftCorner": {
              "x": 13.385,
              "y": 9.61,
              "z": 0.121
            },
            "rightCorner": {
              "x": 13.486,
              "y": 9.602,
              "z": 0.121
            },
            "gtin": "8000755020386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d37c",
            "leftCorner": {
              "x": 13.485,
              "y": 9.592,
              "z": 0.121
            },
            "rightCorner": {
              "x": 13.765,
              "y": 9.569,
              "z": 0.121
            },
            "gtin": "8000755261697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d37d",
            "leftCorner": {
              "x": 13.764,
              "y": 9.563,
              "z": 0.121
            },
            "rightCorner": {
              "x": 13.9,
              "y": 9.553,
              "z": 0.121
            },
            "gtin": "8000755020331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d37e",
            "leftCorner": {
              "x": 13.9,
              "y": 9.553,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.035,
              "y": 9.542,
              "z": 0.121
            },
            "gtin": "8000755020331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d37f",
            "leftCorner": {
              "x": 14.036,
              "y": 9.557,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.167,
              "y": 9.546,
              "z": 0.121
            },
            "gtin": "8000755261789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d380",
            "leftCorner": {
              "x": 14.167,
              "y": 9.546,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.297,
              "y": 9.536,
              "z": 0.121
            },
            "gtin": "8000755261789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d381",
            "leftCorner": {
              "x": 14.297,
              "y": 9.536,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.427,
              "y": 9.525,
              "z": 0.121
            },
            "gtin": "8000755261789",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546232",
        "height": 0.54686,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d31f",
            "leftCorner": {
              "x": 13.167,
              "y": 9.625,
              "z": 0.447
            },
            "rightCorner": {
              "x": 13.259,
              "y": 9.617,
              "z": 0.447
            },
            "gtin": "8000755020522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d320",
            "leftCorner": {
              "x": 13.259,
              "y": 9.617,
              "z": 0.447
            },
            "rightCorner": {
              "x": 13.352,
              "y": 9.61,
              "z": 0.447
            },
            "gtin": "8000755020522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d321",
            "leftCorner": {
              "x": 13.352,
              "y": 9.61,
              "z": 0.447
            },
            "rightCorner": {
              "x": 13.445,
              "y": 9.603,
              "z": 0.447
            },
            "gtin": "8000755020522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d322",
            "leftCorner": {
              "x": 13.445,
              "y": 9.603,
              "z": 0.447
            },
            "rightCorner": {
              "x": 13.538,
              "y": 9.595,
              "z": 0.447
            },
            "gtin": "8000755020522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d323",
            "leftCorner": {
              "x": 13.538,
              "y": 9.609,
              "z": 0.447
            },
            "rightCorner": {
              "x": 13.797,
              "y": 9.588,
              "z": 0.447
            },
            "gtin": "8000755020461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d324",
            "leftCorner": {
              "x": 13.795,
              "y": 9.575,
              "z": 0.447
            },
            "rightCorner": {
              "x": 14.132,
              "y": 9.547,
              "z": 0.447
            },
            "gtin": "8000755020454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d325",
            "leftCorner": {
              "x": 14.132,
              "y": 9.539,
              "z": 0.447
            },
            "rightCorner": {
              "x": 14.216,
              "y": 9.533,
              "z": 0.447
            },
            "gtin": "8000755570461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d326",
            "leftCorner": {
              "x": 14.216,
              "y": 9.533,
              "z": 0.447
            },
            "rightCorner": {
              "x": 14.301,
              "y": 9.526,
              "z": 0.447
            },
            "gtin": "8000755570461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d327",
            "leftCorner": {
              "x": 14.301,
              "y": 9.526,
              "z": 0.447
            },
            "rightCorner": {
              "x": 14.386,
              "y": 9.519,
              "z": 0.447
            },
            "gtin": "8000755570461",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546234",
        "height": 0.9508,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d2ed",
            "leftCorner": {
              "x": 13.245,
              "y": 9.611,
              "z": 0.778
            },
            "rightCorner": {
              "x": 13.392,
              "y": 9.6,
              "z": 0.778
            },
            "gtin": "8000755576463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2ee",
            "leftCorner": {
              "x": 13.392,
              "y": 9.6,
              "z": 0.778
            },
            "rightCorner": {
              "x": 13.537,
              "y": 9.588,
              "z": 0.778
            },
            "gtin": "8000755576463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2ef",
            "leftCorner": {
              "x": 13.539,
              "y": 9.602,
              "z": 0.778
            },
            "rightCorner": {
              "x": 13.683,
              "y": 9.591,
              "z": 0.778
            },
            "gtin": "8000755570287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2f0",
            "leftCorner": {
              "x": 13.683,
              "y": 9.591,
              "z": 0.778
            },
            "rightCorner": {
              "x": 13.827,
              "y": 9.579,
              "z": 0.778
            },
            "gtin": "8000755570287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2f1",
            "leftCorner": {
              "x": 13.827,
              "y": 9.57,
              "z": 0.778
            },
            "rightCorner": {
              "x": 13.956,
              "y": 9.559,
              "z": 0.778
            },
            "gtin": "8000755576333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2f2",
            "leftCorner": {
              "x": 13.956,
              "y": 9.559,
              "z": 0.778
            },
            "rightCorner": {
              "x": 14.086,
              "y": 9.549,
              "z": 0.778
            },
            "gtin": "8000755576333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2f3",
            "leftCorner": {
              "x": 14.086,
              "y": 9.545,
              "z": 0.778
            },
            "rightCorner": {
              "x": 14.186,
              "y": 9.537,
              "z": 0.778
            },
            "gtin": "8000755570331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2f4",
            "leftCorner": {
              "x": 14.186,
              "y": 9.537,
              "z": 0.778
            },
            "rightCorner": {
              "x": 14.287,
              "y": 9.529,
              "z": 0.778
            },
            "gtin": "8000755570331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2f5",
            "leftCorner": {
              "x": 14.287,
              "y": 9.529,
              "z": 0.778
            },
            "rightCorner": {
              "x": 14.388,
              "y": 9.521,
              "z": 0.778
            },
            "gtin": "8000755570331",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546233",
        "height": 1.3545,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d2b7",
            "leftCorner": {
              "x": 13.178,
              "y": 9.623,
              "z": 1.108
            },
            "rightCorner": {
              "x": 13.477,
              "y": 9.599,
              "z": 1.108
            },
            "gtin": "8076809529457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2b8",
            "leftCorner": {
              "x": 13.477,
              "y": 9.601,
              "z": 1.108
            },
            "rightCorner": {
              "x": 13.618,
              "y": 9.59,
              "z": 1.108
            },
            "gtin": "8076809529433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2b9",
            "leftCorner": {
              "x": 13.618,
              "y": 9.59,
              "z": 1.108
            },
            "rightCorner": {
              "x": 13.757,
              "y": 9.579,
              "z": 1.108
            },
            "gtin": "8076809529433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2ba",
            "leftCorner": {
              "x": 13.757,
              "y": 9.577,
              "z": 1.108
            },
            "rightCorner": {
              "x": 13.865,
              "y": 9.569,
              "z": 1.108
            },
            "gtin": "8076809578363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2bb",
            "leftCorner": {
              "x": 13.865,
              "y": 9.569,
              "z": 1.108
            },
            "rightCorner": {
              "x": 13.971,
              "y": 9.56,
              "z": 1.108
            },
            "gtin": "8076809578363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2bc",
            "leftCorner": {
              "x": 13.971,
              "y": 9.56,
              "z": 1.108
            },
            "rightCorner": {
              "x": 14.079,
              "y": 9.551,
              "z": 1.108
            },
            "gtin": "8076809578363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2bd",
            "leftCorner": {
              "x": 14.078,
              "y": 9.544,
              "z": 1.108
            },
            "rightCorner": {
              "x": 14.152,
              "y": 9.538,
              "z": 1.108
            },
            "gtin": "8076809529419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2be",
            "leftCorner": {
              "x": 14.152,
              "y": 9.538,
              "z": 1.108
            },
            "rightCorner": {
              "x": 14.226,
              "y": 9.532,
              "z": 1.108
            },
            "gtin": "8076809529419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2bf",
            "leftCorner": {
              "x": 14.226,
              "y": 9.532,
              "z": 1.108
            },
            "rightCorner": {
              "x": 14.3,
              "y": 9.526,
              "z": 1.108
            },
            "gtin": "8076809529419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2c0",
            "leftCorner": {
              "x": 14.3,
              "y": 9.526,
              "z": 1.108
            },
            "rightCorner": {
              "x": 14.374,
              "y": 9.52,
              "z": 1.108
            },
            "gtin": "8076809529419",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546231",
        "height": 1.705,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d34c",
            "leftCorner": {
              "x": 13.199,
              "y": 9.617,
              "z": 1.395
            },
            "rightCorner": {
              "x": 13.303,
              "y": 9.608,
              "z": 1.395
            },
            "gtin": "4000398152066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d34d",
            "leftCorner": {
              "x": 13.303,
              "y": 9.608,
              "z": 1.395
            },
            "rightCorner": {
              "x": 13.406,
              "y": 9.601,
              "z": 1.395
            },
            "gtin": "4000398152066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d34e",
            "leftCorner": {
              "x": 13.406,
              "y": 9.606,
              "z": 1.395
            },
            "rightCorner": {
              "x": 13.655,
              "y": 9.585,
              "z": 1.395
            },
            "gtin": "4000398152196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d34f",
            "leftCorner": {
              "x": 13.655,
              "y": 9.581,
              "z": 1.395
            },
            "rightCorner": {
              "x": 13.915,
              "y": 9.56,
              "z": 1.395
            },
            "gtin": "4000398152172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d350",
            "leftCorner": {
              "x": 13.916,
              "y": 9.567,
              "z": 1.395
            },
            "rightCorner": {
              "x": 14.072,
              "y": 9.555,
              "z": 1.395
            },
            "gtin": "4000398152189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d351",
            "leftCorner": {
              "x": 14.072,
              "y": 9.555,
              "z": 1.395
            },
            "rightCorner": {
              "x": 14.228,
              "y": 9.542,
              "z": 1.395
            },
            "gtin": "4000398152189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d352",
            "leftCorner": {
              "x": 14.228,
              "y": 9.542,
              "z": 1.395
            },
            "rightCorner": {
              "x": 14.384,
              "y": 9.53,
              "z": 1.395
            },
            "gtin": "4000398152189",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f93",
    "rightNeighborShelfId": "b6f95"
  },
  {
    "id": "b6f95",
    "name": "b6f95",
    "x": 14.341,
    "y": 9.48,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03987,
      "w": 0.9992
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 38
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5462a7",
        "height": 0.14902,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d382",
            "leftCorner": {
              "x": 14.427,
              "y": 9.53,
              "z": 0.122
            },
            "rightCorner": {
              "x": 14.546,
              "y": 9.521,
              "z": 0.122
            },
            "gtin": "8076809523509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d383",
            "leftCorner": {
              "x": 14.546,
              "y": 9.521,
              "z": 0.122
            },
            "rightCorner": {
              "x": 14.666,
              "y": 9.511,
              "z": 0.122
            },
            "gtin": "8076809523509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d384",
            "leftCorner": {
              "x": 14.666,
              "y": 9.513,
              "z": 0.122
            },
            "rightCorner": {
              "x": 14.804,
              "y": 9.503,
              "z": 0.122
            },
            "gtin": "8076809584920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d385",
            "leftCorner": {
              "x": 14.804,
              "y": 9.503,
              "z": 0.122
            },
            "rightCorner": {
              "x": 14.94,
              "y": 9.491,
              "z": 0.122
            },
            "gtin": "8076809584920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d386",
            "leftCorner": {
              "x": 14.94,
              "y": 9.483,
              "z": 0.122
            },
            "rightCorner": {
              "x": 15.093,
              "y": 9.471,
              "z": 0.122
            },
            "gtin": "8076809523707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d387",
            "leftCorner": {
              "x": 15.093,
              "y": 9.471,
              "z": 0.122
            },
            "rightCorner": {
              "x": 15.247,
              "y": 9.458,
              "z": 0.122
            },
            "gtin": "8076809523707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d388",
            "leftCorner": {
              "x": 15.247,
              "y": 9.463,
              "z": 0.122
            },
            "rightCorner": {
              "x": 15.369,
              "y": 9.454,
              "z": 0.122
            },
            "gtin": "8076809583503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d389",
            "leftCorner": {
              "x": 15.369,
              "y": 9.454,
              "z": 0.122
            },
            "rightCorner": {
              "x": 15.49,
              "y": 9.444,
              "z": 0.122
            },
            "gtin": "8076809583503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d38a",
            "leftCorner": {
              "x": 15.49,
              "y": 9.444,
              "z": 0.122
            },
            "rightCorner": {
              "x": 15.612,
              "y": 9.434,
              "z": 0.122
            },
            "gtin": "8076809583503",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462a3",
        "height": 0.54902,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d328",
            "leftCorner": {
              "x": 14.386,
              "y": 9.535,
              "z": 0.449
            },
            "rightCorner": {
              "x": 14.476,
              "y": 9.528,
              "z": 0.449
            },
            "gtin": "8076809519960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d329",
            "leftCorner": {
              "x": 14.476,
              "y": 9.528,
              "z": 0.449
            },
            "rightCorner": {
              "x": 14.564,
              "y": 9.52,
              "z": 0.449
            },
            "gtin": "8076809519960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d32a",
            "leftCorner": {
              "x": 14.564,
              "y": 9.52,
              "z": 0.449
            },
            "rightCorner": {
              "x": 14.653,
              "y": 9.513,
              "z": 0.449
            },
            "gtin": "8076809519960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d32b",
            "leftCorner": {
              "x": 14.653,
              "y": 9.512,
              "z": 0.449
            },
            "rightCorner": {
              "x": 14.805,
              "y": 9.5,
              "z": 0.449
            },
            "gtin": "8076809574631",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d32c",
            "leftCorner": {
              "x": 14.805,
              "y": 9.5,
              "z": 0.449
            },
            "rightCorner": {
              "x": 14.955,
              "y": 9.488,
              "z": 0.449
            },
            "gtin": "8076809574631",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d32d",
            "leftCorner": {
              "x": 14.955,
              "y": 9.481,
              "z": 0.449
            },
            "rightCorner": {
              "x": 15.232,
              "y": 9.459,
              "z": 0.449
            },
            "gtin": "8076809519977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d32e",
            "leftCorner": {
              "x": 15.232,
              "y": 9.462,
              "z": 0.449
            },
            "rightCorner": {
              "x": 15.57,
              "y": 9.436,
              "z": 0.449
            },
            "gtin": "8076809579445",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462a5",
        "height": 0.95107,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d2f6",
            "leftCorner": {
              "x": 14.388,
              "y": 9.532,
              "z": 0.778
            },
            "rightCorner": {
              "x": 14.726,
              "y": 9.505,
              "z": 0.778
            },
            "gtin": "8076809523714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2f7",
            "leftCorner": {
              "x": 14.726,
              "y": 9.505,
              "z": 0.778
            },
            "rightCorner": {
              "x": 14.897,
              "y": 9.492,
              "z": 0.778
            },
            "gtin": "8076809523776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2f8",
            "leftCorner": {
              "x": 14.897,
              "y": 9.492,
              "z": 0.778
            },
            "rightCorner": {
              "x": 15.069,
              "y": 9.478,
              "z": 0.778
            },
            "gtin": "8076809523776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2f9",
            "leftCorner": {
              "x": 15.068,
              "y": 9.472,
              "z": 0.778
            },
            "rightCorner": {
              "x": 15.315,
              "y": 9.452,
              "z": 0.778
            },
            "gtin": "8076808070882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2fa",
            "leftCorner": {
              "x": 15.315,
              "y": 9.448,
              "z": 0.778
            },
            "rightCorner": {
              "x": 15.586,
              "y": 9.427,
              "z": 0.778
            },
            "gtin": "8076809580144",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462a6",
        "height": 1.3555,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d2c6",
            "leftCorner": {
              "x": 15.001,
              "y": 9.475,
              "z": 1.109
            },
            "rightCorner": {
              "x": 15.164,
              "y": 9.461,
              "z": 1.109
            },
            "gtin": "8076809583848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2c1",
            "leftCorner": {
              "x": 14.374,
              "y": 9.53,
              "z": 1.109
            },
            "rightCorner": {
              "x": 14.507,
              "y": 9.519,
              "z": 1.109
            },
            "gtin": "8076809523738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2c2",
            "leftCorner": {
              "x": 14.507,
              "y": 9.519,
              "z": 1.109
            },
            "rightCorner": {
              "x": 14.641,
              "y": 9.509,
              "z": 1.109
            },
            "gtin": "8076809523738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2c3",
            "leftCorner": {
              "x": 14.639,
              "y": 9.505,
              "z": 1.109
            },
            "rightCorner": {
              "x": 14.76,
              "y": 9.496,
              "z": 1.109
            },
            "gtin": "8076809501415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2c4",
            "leftCorner": {
              "x": 14.76,
              "y": 9.496,
              "z": 1.109
            },
            "rightCorner": {
              "x": 14.881,
              "y": 9.486,
              "z": 1.109
            },
            "gtin": "8076809501415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2c5",
            "leftCorner": {
              "x": 14.881,
              "y": 9.486,
              "z": 1.109
            },
            "rightCorner": {
              "x": 15.001,
              "y": 9.476,
              "z": 1.109
            },
            "gtin": "8076809501415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2c7",
            "leftCorner": {
              "x": 15.164,
              "y": 9.461,
              "z": 1.109
            },
            "rightCorner": {
              "x": 15.327,
              "y": 9.449,
              "z": 1.109
            },
            "gtin": "8076809583848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2c8",
            "leftCorner": {
              "x": 15.327,
              "y": 9.451,
              "z": 1.109
            },
            "rightCorner": {
              "x": 15.555,
              "y": 9.433,
              "z": 1.109
            },
            "gtin": "8076809580151",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462a4",
        "height": 1.7053,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d353",
            "leftCorner": {
              "x": 14.383,
              "y": 9.533,
              "z": 1.395
            },
            "rightCorner": {
              "x": 14.506,
              "y": 9.524,
              "z": 1.395
            },
            "gtin": "8076809545440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d354",
            "leftCorner": {
              "x": 14.507,
              "y": 9.527,
              "z": 1.395
            },
            "rightCorner": {
              "x": 14.606,
              "y": 9.519,
              "z": 1.395
            },
            "gtin": "8076809545457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d355",
            "leftCorner": {
              "x": 14.606,
              "y": 9.519,
              "z": 1.395
            },
            "rightCorner": {
              "x": 14.705,
              "y": 9.512,
              "z": 1.395
            },
            "gtin": "8076809545457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d356",
            "leftCorner": {
              "x": 14.705,
              "y": 9.507,
              "z": 1.395
            },
            "rightCorner": {
              "x": 14.845,
              "y": 9.496,
              "z": 1.395
            },
            "gtin": "8076809585217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d357",
            "leftCorner": {
              "x": 14.845,
              "y": 9.496,
              "z": 1.395
            },
            "rightCorner": {
              "x": 14.987,
              "y": 9.485,
              "z": 1.395
            },
            "gtin": "8076809585217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d358",
            "leftCorner": {
              "x": 14.987,
              "y": 9.485,
              "z": 1.395
            },
            "rightCorner": {
              "x": 15.124,
              "y": 9.474,
              "z": 1.395
            },
            "gtin": "8076809585224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d359",
            "leftCorner": {
              "x": 15.124,
              "y": 9.474,
              "z": 1.395
            },
            "rightCorner": {
              "x": 15.259,
              "y": 9.463,
              "z": 1.395
            },
            "gtin": "8076809585224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d35a",
            "leftCorner": {
              "x": 15.259,
              "y": 9.458,
              "z": 1.395
            },
            "rightCorner": {
              "x": 15.426,
              "y": 9.445,
              "z": 1.395
            },
            "gtin": "8076809585194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d35b",
            "leftCorner": {
              "x": 15.426,
              "y": 9.445,
              "z": 1.395
            },
            "rightCorner": {
              "x": 15.595,
              "y": 9.431,
              "z": 1.395
            },
            "gtin": "8076809585194",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f94",
    "rightNeighborShelfId": "b6f96"
  },
  {
    "id": "b6f96",
    "name": "b6f96",
    "x": 15.537,
    "y": 9.384,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03987,
      "w": 0.9992
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 33
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546230",
        "height": 0.14783,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d38b",
            "leftCorner": {
              "x": 15.612,
              "y": 9.438,
              "z": 0.121
            },
            "rightCorner": {
              "x": 15.757,
              "y": 9.427,
              "z": 0.121
            },
            "gtin": "8076802085981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d38c",
            "leftCorner": {
              "x": 15.757,
              "y": 9.427,
              "z": 0.121
            },
            "rightCorner": {
              "x": 15.902,
              "y": 9.416,
              "z": 0.121
            },
            "gtin": "8076802085981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d38d",
            "leftCorner": {
              "x": 15.902,
              "y": 9.416,
              "z": 0.121
            },
            "rightCorner": {
              "x": 16.045,
              "y": 9.404,
              "z": 0.121
            },
            "gtin": "8076802085981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d38e",
            "leftCorner": {
              "x": 16.045,
              "y": 9.404,
              "z": 0.121
            },
            "rightCorner": {
              "x": 16.19,
              "y": 9.392,
              "z": 0.121
            },
            "gtin": "8076802085981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d38f",
            "leftCorner": {
              "x": 16.189,
              "y": 9.389,
              "z": 0.121
            },
            "rightCorner": {
              "x": 16.764,
              "y": 9.344,
              "z": 0.121
            },
            "gtin": "8076802085738",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54622e",
        "height": 0.54644,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d32f",
            "leftCorner": {
              "x": 15.57,
              "y": 9.44,
              "z": 0.447
            },
            "rightCorner": {
              "x": 15.716,
              "y": 9.427,
              "z": 0.447
            },
            "gtin": "8076808150072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d330",
            "leftCorner": {
              "x": 15.716,
              "y": 9.427,
              "z": 0.447
            },
            "rightCorner": {
              "x": 15.86,
              "y": 9.416,
              "z": 0.447
            },
            "gtin": "8076808150072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d331",
            "leftCorner": {
              "x": 15.86,
              "y": 9.416,
              "z": 0.447
            },
            "rightCorner": {
              "x": 16.005,
              "y": 9.405,
              "z": 0.447
            },
            "gtin": "8076808150072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d332",
            "leftCorner": {
              "x": 16.005,
              "y": 9.405,
              "z": 0.447
            },
            "rightCorner": {
              "x": 16.151,
              "y": 9.393,
              "z": 0.447
            },
            "gtin": "8076808150072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d333",
            "leftCorner": {
              "x": 16.15,
              "y": 9.39,
              "z": 0.447
            },
            "rightCorner": {
              "x": 16.309,
              "y": 9.377,
              "z": 0.447
            },
            "gtin": "8076800195033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d334",
            "leftCorner": {
              "x": 16.309,
              "y": 9.377,
              "z": 0.447
            },
            "rightCorner": {
              "x": 16.468,
              "y": 9.365,
              "z": 0.447
            },
            "gtin": "8076800195033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d335",
            "leftCorner": {
              "x": 16.468,
              "y": 9.362,
              "z": 0.447
            },
            "rightCorner": {
              "x": 16.751,
              "y": 9.34,
              "z": 0.447
            },
            "gtin": "8076800195057",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54622f",
        "height": 0.94872,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d2fb",
            "leftCorner": {
              "x": 15.587,
              "y": 9.435,
              "z": 0.776
            },
            "rightCorner": {
              "x": 15.899,
              "y": 9.41,
              "z": 0.776
            },
            "gtin": "8076800195019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2fc",
            "leftCorner": {
              "x": 15.899,
              "y": 9.41,
              "z": 0.776
            },
            "rightCorner": {
              "x": 16.211,
              "y": 9.386,
              "z": 0.776
            },
            "gtin": "8076800195019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2fd",
            "leftCorner": {
              "x": 16.211,
              "y": 9.381,
              "z": 0.776
            },
            "rightCorner": {
              "x": 16.39,
              "y": 9.367,
              "z": 0.776
            },
            "gtin": "8076808050440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2fe",
            "leftCorner": {
              "x": 16.39,
              "y": 9.367,
              "z": 0.776
            },
            "rightCorner": {
              "x": 16.569,
              "y": 9.352,
              "z": 0.776
            },
            "gtin": "8076808050440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2ff",
            "leftCorner": {
              "x": 16.569,
              "y": 9.352,
              "z": 0.776
            },
            "rightCorner": {
              "x": 16.748,
              "y": 9.338,
              "z": 0.776
            },
            "gtin": "8076808050440",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54622c",
        "height": 1.3537,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d2c9",
            "leftCorner": {
              "x": 15.555,
              "y": 9.435,
              "z": 1.108
            },
            "rightCorner": {
              "x": 15.695,
              "y": 9.424,
              "z": 1.108
            },
            "gtin": "8076809523721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2ca",
            "leftCorner": {
              "x": 15.695,
              "y": 9.428,
              "z": 1.108
            },
            "rightCorner": {
              "x": 15.807,
              "y": 9.419,
              "z": 1.108
            },
            "gtin": "8076809585217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2cb",
            "leftCorner": {
              "x": 15.807,
              "y": 9.419,
              "z": 1.108
            },
            "rightCorner": {
              "x": 15.917,
              "y": 9.411,
              "z": 1.108
            },
            "gtin": "8076809585217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2cc",
            "leftCorner": {
              "x": 15.917,
              "y": 9.404,
              "z": 1.108
            },
            "rightCorner": {
              "x": 16.211,
              "y": 9.38,
              "z": 1.108
            },
            "gtin": "8076809512732",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2cd",
            "leftCorner": {
              "x": 16.21,
              "y": 9.376,
              "z": 1.108
            },
            "rightCorner": {
              "x": 16.376,
              "y": 9.363,
              "z": 1.108
            },
            "gtin": "8076809521628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2ce",
            "leftCorner": {
              "x": 16.376,
              "y": 9.363,
              "z": 1.108
            },
            "rightCorner": {
              "x": 16.541,
              "y": 9.349,
              "z": 1.108
            },
            "gtin": "8076809521628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2cf",
            "leftCorner": {
              "x": 16.542,
              "y": 9.356,
              "z": 1.108
            },
            "rightCorner": {
              "x": 16.652,
              "y": 9.346,
              "z": 1.108
            },
            "gtin": "8000270010329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2d0",
            "leftCorner": {
              "x": 16.652,
              "y": 9.346,
              "z": 1.108
            },
            "rightCorner": {
              "x": 16.763,
              "y": 9.338,
              "z": 1.108
            },
            "gtin": "8000270010329",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54622d",
        "height": 1.7029,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d35c",
            "leftCorner": {
              "x": 15.595,
              "y": 9.431,
              "z": 1.393
            },
            "rightCorner": {
              "x": 15.705,
              "y": 9.422,
              "z": 1.393
            },
            "gtin": "8076809585224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d35d",
            "leftCorner": {
              "x": 15.705,
              "y": 9.422,
              "z": 1.393
            },
            "rightCorner": {
              "x": 15.816,
              "y": 9.413,
              "z": 1.393
            },
            "gtin": "8076809585224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d35e",
            "leftCorner": {
              "x": 15.816,
              "y": 9.413,
              "z": 1.393
            },
            "rightCorner": {
              "x": 15.927,
              "y": 9.405,
              "z": 1.393
            },
            "gtin": "8076809585224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d35f",
            "leftCorner": {
              "x": 15.927,
              "y": 9.405,
              "z": 1.393
            },
            "rightCorner": {
              "x": 16.037,
              "y": 9.396,
              "z": 1.393
            },
            "gtin": "8076809585224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d360",
            "leftCorner": {
              "x": 16.037,
              "y": 9.392,
              "z": 1.393
            },
            "rightCorner": {
              "x": 16.21,
              "y": 9.378,
              "z": 1.393
            },
            "gtin": "8076809512268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d361",
            "leftCorner": {
              "x": 16.21,
              "y": 9.378,
              "z": 1.393
            },
            "rightCorner": {
              "x": 16.382,
              "y": 9.364,
              "z": 1.393
            },
            "gtin": "8076809512268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d362",
            "leftCorner": {
              "x": 16.382,
              "y": 9.361,
              "z": 1.393
            },
            "rightCorner": {
              "x": 16.597,
              "y": 9.344,
              "z": 1.393
            },
            "gtin": "8076809579100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d363",
            "leftCorner": {
              "x": 16.597,
              "y": 9.344,
              "z": 1.393
            },
            "rightCorner": {
              "x": 16.813,
              "y": 9.327,
              "z": 1.393
            },
            "gtin": "8076809579100",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f95",
    "rightNeighborShelfId": "b6f97"
  },
  {
    "id": "b6f97",
    "name": "b6f97",
    "x": 16.733,
    "y": 9.289,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03987,
      "w": 0.9992
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 8
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5462ac",
        "height": 0.14568,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d390",
            "leftCorner": {
              "x": 16.764,
              "y": 9.349,
              "z": 0.119
            },
            "rightCorner": {
              "x": 17.195,
              "y": 9.315,
              "z": 0.119
            },
            "gtin": "8000270016291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d391",
            "leftCorner": {
              "x": 17.195,
              "y": 9.315,
              "z": 0.119
            },
            "rightCorner": {
              "x": 17.625,
              "y": 9.28,
              "z": 0.119
            },
            "gtin": "8000270016291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d392",
            "leftCorner": {
              "x": 17.625,
              "y": 9.281,
              "z": 0.119
            },
            "rightCorner": {
              "x": 17.788,
              "y": 9.268,
              "z": 0.119
            },
            "gtin": "8000270016284",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d393",
            "leftCorner": {
              "x": 17.788,
              "y": 9.268,
              "z": 0.119
            },
            "rightCorner": {
              "x": 17.95,
              "y": 9.256,
              "z": 0.119
            },
            "gtin": "8000270016284",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462a8",
        "height": 0.54635,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a5462a9",
        "height": 0.94751,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a5462aa",
        "height": 1.3527,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d2d1",
            "leftCorner": {
              "x": 16.763,
              "y": 9.335,
              "z": 1.107
            },
            "rightCorner": {
              "x": 17.207,
              "y": 9.299,
              "z": 1.107
            },
            "gtin": "8000270706468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2d2",
            "leftCorner": {
              "x": 17.207,
              "y": 9.299,
              "z": 1.107
            },
            "rightCorner": {
              "x": 17.65,
              "y": 9.264,
              "z": 1.107
            },
            "gtin": "8000270706468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2d3",
            "leftCorner": {
              "x": 17.65,
              "y": 9.263,
              "z": 1.107
            },
            "rightCorner": {
              "x": 17.795,
              "y": 9.252,
              "z": 1.107
            },
            "gtin": "8000270013078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2d4",
            "leftCorner": {
              "x": 17.795,
              "y": 9.252,
              "z": 1.107
            },
            "rightCorner": {
              "x": 17.939,
              "y": 9.24,
              "z": 1.107
            },
            "gtin": "8000270013078",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462ab",
        "height": 1.7035,
        "facings": []
      }
    ],
    "leftNeighborShelfId": "b6f96",
    "rightNeighborShelfId": "b6f98"
  },
  {
    "id": "b6f98",
    "name": "b6f98",
    "x": 17.929,
    "y": 9.193,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03987,
      "w": 0.9992
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 20
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5462b3",
        "height": 0.14763,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d394",
            "leftCorner": {
              "x": 17.95,
              "y": 9.241,
              "z": 0.121
            },
            "rightCorner": {
              "x": 18.034,
              "y": 9.234,
              "z": 0.121
            },
            "gtin": "8000270010671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d395",
            "leftCorner": {
              "x": 18.034,
              "y": 9.234,
              "z": 0.121
            },
            "rightCorner": {
              "x": 18.119,
              "y": 9.227,
              "z": 0.121
            },
            "gtin": "8000270010671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d366",
            "leftCorner": {
              "x": 18.121,
              "y": 9.234,
              "z": 0.121
            },
            "rightCorner": {
              "x": 19.179,
              "y": 9.15,
              "z": 0.121
            },
            "gtin": "8000270706406",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462b5",
        "height": 0.54855,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d336",
            "leftCorner": {
              "x": 18.365,
              "y": 9.219,
              "z": 0.449
            },
            "rightCorner": {
              "x": 18.571,
              "y": 9.202,
              "z": 0.449
            },
            "gtin": "8000270013221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d337",
            "leftCorner": {
              "x": 18.571,
              "y": 9.202,
              "z": 0.449
            },
            "rightCorner": {
              "x": 18.777,
              "y": 9.186,
              "z": 0.449
            },
            "gtin": "8000270013221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d307",
            "leftCorner": {
              "x": 18.777,
              "y": 9.182,
              "z": 0.449
            },
            "rightCorner": {
              "x": 18.977,
              "y": 9.165,
              "z": 0.449
            },
            "gtin": "8000270706505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d308",
            "leftCorner": {
              "x": 18.977,
              "y": 9.165,
              "z": 0.449
            },
            "rightCorner": {
              "x": 19.179,
              "y": 9.15,
              "z": 0.449
            },
            "gtin": "8000270706505",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462b2",
        "height": 0.94814,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d300",
            "leftCorner": {
              "x": 17.995,
              "y": 9.229,
              "z": 0.776
            },
            "rightCorner": {
              "x": 18.273,
              "y": 9.207,
              "z": 0.776
            },
            "gtin": "8000270013115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d301",
            "leftCorner": {
              "x": 18.273,
              "y": 9.207,
              "z": 0.776
            },
            "rightCorner": {
              "x": 18.553,
              "y": 9.185,
              "z": 0.776
            },
            "gtin": "8000270013115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d302",
            "leftCorner": {
              "x": 18.553,
              "y": 9.185,
              "z": 0.776
            },
            "rightCorner": {
              "x": 18.832,
              "y": 9.162,
              "z": 0.776
            },
            "gtin": "8000270013115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d303",
            "leftCorner": {
              "x": 18.832,
              "y": 9.162,
              "z": 0.776
            },
            "rightCorner": {
              "x": 19.11,
              "y": 9.14,
              "z": 0.776
            },
            "gtin": "8000270013115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2d9",
            "leftCorner": {
              "x": 19.111,
              "y": 9.143,
              "z": 0.776
            },
            "rightCorner": {
              "x": 19.178,
              "y": 9.138,
              "z": 0.776
            },
            "gtin": "8000270013504",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462b1",
        "height": 1.354,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d2d5",
            "leftCorner": {
              "x": 17.939,
              "y": 9.238,
              "z": 1.108
            },
            "rightCorner": {
              "x": 18.143,
              "y": 9.223,
              "z": 1.108
            },
            "gtin": "8000270013245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2d6",
            "leftCorner": {
              "x": 18.143,
              "y": 9.223,
              "z": 1.108
            },
            "rightCorner": {
              "x": 18.346,
              "y": 9.206,
              "z": 1.108
            },
            "gtin": "8000270013245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d298",
            "leftCorner": {
              "x": 18.347,
              "y": 9.211,
              "z": 1.108
            },
            "rightCorner": {
              "x": 18.624,
              "y": 9.19,
              "z": 1.108
            },
            "gtin": "8000270704518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d299",
            "leftCorner": {
              "x": 18.624,
              "y": 9.19,
              "z": 1.108
            },
            "rightCorner": {
              "x": 18.901,
              "y": 9.167,
              "z": 1.108
            },
            "gtin": "8000270704518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d29a",
            "leftCorner": {
              "x": 18.901,
              "y": 9.167,
              "z": 1.108
            },
            "rightCorner": {
              "x": 19.179,
              "y": 9.145,
              "z": 1.108
            },
            "gtin": "8000270704518",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462b4",
        "height": 1.7057,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d33a",
            "leftCorner": {
              "x": 18.367,
              "y": 9.213,
              "z": 1.396
            },
            "rightCorner": {
              "x": 18.638,
              "y": 9.191,
              "z": 1.396
            },
            "gtin": "8000270706352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d33b",
            "leftCorner": {
              "x": 18.638,
              "y": 9.191,
              "z": 1.396
            },
            "rightCorner": {
              "x": 18.908,
              "y": 9.169,
              "z": 1.396
            },
            "gtin": "8000270706352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d33c",
            "leftCorner": {
              "x": 18.908,
              "y": 9.169,
              "z": 1.396
            },
            "rightCorner": {
              "x": 19.179,
              "y": 9.148,
              "z": 1.396
            },
            "gtin": "8000270706352",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f97"
  },
  {
    "id": "b6f9b",
    "name": "b6f9b",
    "x": 18.633,
    "y": 13.452,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99896,
      "w": 0.045607
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 69
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546316",
        "height": 1.34,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e417",
            "leftCorner": {
              "x": 18.168,
              "y": 13.442,
              "z": 1.096
            },
            "rightCorner": {
              "x": 18.101,
              "y": 13.449,
              "z": 1.096
            },
            "gtin": "4030387760620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e418",
            "leftCorner": {
              "x": 18.101,
              "y": 13.452,
              "z": 1.096
            },
            "rightCorner": {
              "x": 18.007,
              "y": 13.46,
              "z": 1.096
            },
            "gtin": "4337185623714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e419",
            "leftCorner": {
              "x": 18.007,
              "y": 13.46,
              "z": 1.096
            },
            "rightCorner": {
              "x": 17.914,
              "y": 13.469,
              "z": 1.096
            },
            "gtin": "4337185623714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e41a",
            "leftCorner": {
              "x": 17.914,
              "y": 13.464,
              "z": 1.096
            },
            "rightCorner": {
              "x": 17.847,
              "y": 13.47,
              "z": 1.096
            },
            "gtin": "4063367324758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e41b",
            "leftCorner": {
              "x": 17.847,
              "y": 13.47,
              "z": 1.096
            },
            "rightCorner": {
              "x": 17.781,
              "y": 13.476,
              "z": 1.096
            },
            "gtin": "4063367324758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e41c",
            "leftCorner": {
              "x": 17.781,
              "y": 13.476,
              "z": 1.096
            },
            "rightCorner": {
              "x": 17.714,
              "y": 13.483,
              "z": 1.096
            },
            "gtin": "4063367324758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e41d",
            "leftCorner": {
              "x": 17.715,
              "y": 13.492,
              "z": 1.096
            },
            "rightCorner": {
              "x": 17.627,
              "y": 13.5,
              "z": 1.096
            },
            "gtin": "4062800018216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e41e",
            "leftCorner": {
              "x": 17.627,
              "y": 13.5,
              "z": 1.096
            },
            "rightCorner": {
              "x": 17.538,
              "y": 13.507,
              "z": 1.096
            },
            "gtin": "4062800018216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e41f",
            "leftCorner": {
              "x": 17.538,
              "y": 13.499,
              "z": 1.096
            },
            "rightCorner": {
              "x": 17.402,
              "y": 13.511,
              "z": 1.096
            },
            "gtin": "4335896559537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e413",
            "leftCorner": {
              "x": 18.612,
              "y": 13.409,
              "z": 1.096
            },
            "rightCorner": {
              "x": 18.479,
              "y": 13.422,
              "z": 1.096
            },
            "gtin": "4030387760590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e414",
            "leftCorner": {
              "x": 18.479,
              "y": 13.424,
              "z": 1.096
            },
            "rightCorner": {
              "x": 18.367,
              "y": 13.434,
              "z": 1.096
            },
            "gtin": "4030387760606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e415",
            "leftCorner": {
              "x": 18.367,
              "y": 13.429,
              "z": 1.096
            },
            "rightCorner": {
              "x": 18.237,
              "y": 13.441,
              "z": 1.096
            },
            "gtin": "4030387760613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e416",
            "leftCorner": {
              "x": 18.237,
              "y": 13.436,
              "z": 1.096
            },
            "rightCorner": {
              "x": 18.168,
              "y": 13.442,
              "z": 1.096
            },
            "gtin": "4030387760620",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546318",
        "height": 0.13361,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e3a0",
            "leftCorner": {
              "x": 18.601,
              "y": 13.399,
              "z": 0.109
            },
            "rightCorner": {
              "x": 18.515,
              "y": 13.407,
              "z": 0.109
            },
            "gtin": "4002309014753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3a1",
            "leftCorner": {
              "x": 18.515,
              "y": 13.407,
              "z": 0.109
            },
            "rightCorner": {
              "x": 18.427,
              "y": 13.415,
              "z": 0.109
            },
            "gtin": "4002309014753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3a2",
            "leftCorner": {
              "x": 18.427,
              "y": 13.415,
              "z": 0.109
            },
            "rightCorner": {
              "x": 18.312,
              "y": 13.426,
              "z": 0.109
            },
            "gtin": "4018087009331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3a3",
            "leftCorner": {
              "x": 18.312,
              "y": 13.426,
              "z": 0.109
            },
            "rightCorner": {
              "x": 18.197,
              "y": 13.436,
              "z": 0.109
            },
            "gtin": "4018087009331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3a4",
            "leftCorner": {
              "x": 18.197,
              "y": 13.435,
              "z": 0.109
            },
            "rightCorner": {
              "x": 18.026,
              "y": 13.451,
              "z": 0.109
            },
            "gtin": "4018087001755",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3a5",
            "leftCorner": {
              "x": 18.026,
              "y": 13.451,
              "z": 0.109
            },
            "rightCorner": {
              "x": 17.856,
              "y": 13.467,
              "z": 0.109
            },
            "gtin": "4018087001755",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3a6",
            "leftCorner": {
              "x": 17.856,
              "y": 13.467,
              "z": 0.109
            },
            "rightCorner": {
              "x": 17.762,
              "y": 13.475,
              "z": 0.109
            },
            "gtin": "7622201127206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3a7",
            "leftCorner": {
              "x": 17.762,
              "y": 13.475,
              "z": 0.109
            },
            "rightCorner": {
              "x": 17.667,
              "y": 13.484,
              "z": 0.109
            },
            "gtin": "7622201127206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3a8",
            "leftCorner": {
              "x": 17.667,
              "y": 13.484,
              "z": 0.109
            },
            "rightCorner": {
              "x": 17.572,
              "y": 13.494,
              "z": 0.109
            },
            "gtin": "7622201127206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3a9",
            "leftCorner": {
              "x": 17.574,
              "y": 13.499,
              "z": 0.109
            },
            "rightCorner": {
              "x": 17.47,
              "y": 13.509,
              "z": 0.109
            },
            "gtin": "7622201400972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3aa",
            "leftCorner": {
              "x": 17.47,
              "y": 13.509,
              "z": 0.109
            },
            "rightCorner": {
              "x": 17.368,
              "y": 13.518,
              "z": 0.109
            },
            "gtin": "7622201400972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3ab",
            "leftCorner": {
              "x": 17.368,
              "y": 13.518,
              "z": 0.109
            },
            "rightCorner": {
              "x": 17.264,
              "y": 13.527,
              "z": 0.109
            },
            "gtin": "7622201400972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3ac",
            "leftCorner": {
              "x": 17.264,
              "y": 13.527,
              "z": 0.109
            },
            "rightCorner": {
              "x": 17.161,
              "y": 13.537,
              "z": 0.109
            },
            "gtin": "7622201400972",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546314",
        "height": 0.58399,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e284",
            "leftCorner": {
              "x": 18.621,
              "y": 13.404,
              "z": 0.478
            },
            "rightCorner": {
              "x": 18.526,
              "y": 13.412,
              "z": 0.478
            },
            "gtin": "4018087117715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e285",
            "leftCorner": {
              "x": 18.526,
              "y": 13.412,
              "z": 0.478
            },
            "rightCorner": {
              "x": 18.431,
              "y": 13.421,
              "z": 0.478
            },
            "gtin": "4018087117715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e286",
            "leftCorner": {
              "x": 18.43,
              "y": 13.415,
              "z": 0.478
            },
            "rightCorner": {
              "x": 18.351,
              "y": 13.422,
              "z": 0.478
            },
            "gtin": "4018087117708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e287",
            "leftCorner": {
              "x": 18.351,
              "y": 13.422,
              "z": 0.478
            },
            "rightCorner": {
              "x": 18.272,
              "y": 13.43,
              "z": 0.478
            },
            "gtin": "4018087117708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e288",
            "leftCorner": {
              "x": 18.272,
              "y": 13.431,
              "z": 0.478
            },
            "rightCorner": {
              "x": 18.089,
              "y": 13.448,
              "z": 0.478
            },
            "gtin": "4260562940626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e289",
            "leftCorner": {
              "x": 18.092,
              "y": 13.466,
              "z": 0.478
            },
            "rightCorner": {
              "x": 17.951,
              "y": 13.478,
              "z": 0.478
            },
            "gtin": "8006040277374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e28a",
            "leftCorner": {
              "x": 17.951,
              "y": 13.478,
              "z": 0.478
            },
            "rightCorner": {
              "x": 17.812,
              "y": 13.491,
              "z": 0.478
            },
            "gtin": "8006040277374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e28b",
            "leftCorner": {
              "x": 17.811,
              "y": 13.475,
              "z": 0.478
            },
            "rightCorner": {
              "x": 17.726,
              "y": 13.483,
              "z": 0.478
            },
            "gtin": "80841197",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e28c",
            "leftCorner": {
              "x": 17.726,
              "y": 13.483,
              "z": 0.478
            },
            "rightCorner": {
              "x": 17.641,
              "y": 13.491,
              "z": 0.478
            },
            "gtin": "80841197",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e28d",
            "leftCorner": {
              "x": 17.641,
              "y": 13.481,
              "z": 0.478
            },
            "rightCorner": {
              "x": 17.548,
              "y": 13.489,
              "z": 0.478
            },
            "gtin": "8017139119130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e28e",
            "leftCorner": {
              "x": 17.548,
              "y": 13.489,
              "z": 0.478
            },
            "rightCorner": {
              "x": 17.456,
              "y": 13.498,
              "z": 0.478
            },
            "gtin": "8017139119130",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546315",
        "height": 0.98504,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e320",
            "leftCorner": {
              "x": 18.62,
              "y": 13.417,
              "z": 0.806
            },
            "rightCorner": {
              "x": 18.505,
              "y": 13.428,
              "z": 0.806
            },
            "gtin": "4006040005810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e321",
            "leftCorner": {
              "x": 18.505,
              "y": 13.421,
              "z": 0.806
            },
            "rightCorner": {
              "x": 18.36,
              "y": 13.435,
              "z": 0.806
            },
            "gtin": "4006040007999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e322",
            "leftCorner": {
              "x": 18.358,
              "y": 13.425,
              "z": 0.806
            },
            "rightCorner": {
              "x": 18.31,
              "y": 13.429,
              "z": 0.806
            },
            "gtin": "4063367185427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e323",
            "leftCorner": {
              "x": 18.31,
              "y": 13.429,
              "z": 0.806
            },
            "rightCorner": {
              "x": 18.261,
              "y": 13.434,
              "z": 0.806
            },
            "gtin": "4063367185427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e324",
            "leftCorner": {
              "x": 18.261,
              "y": 13.434,
              "z": 0.806
            },
            "rightCorner": {
              "x": 18.212,
              "y": 13.438,
              "z": 0.806
            },
            "gtin": "4063367185427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e325",
            "leftCorner": {
              "x": 18.212,
              "y": 13.435,
              "z": 0.806
            },
            "rightCorner": {
              "x": 18.135,
              "y": 13.441,
              "z": 0.806
            },
            "gtin": "3608580101932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e326",
            "leftCorner": {
              "x": 18.135,
              "y": 13.441,
              "z": 0.806
            },
            "rightCorner": {
              "x": 18.058,
              "y": 13.449,
              "z": 0.806
            },
            "gtin": "3608580101932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e327",
            "leftCorner": {
              "x": 18.06,
              "y": 13.459,
              "z": 0.806
            },
            "rightCorner": {
              "x": 17.97,
              "y": 13.467,
              "z": 0.806
            },
            "gtin": "4002575639698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e328",
            "leftCorner": {
              "x": 17.97,
              "y": 13.467,
              "z": 0.806
            },
            "rightCorner": {
              "x": 17.882,
              "y": 13.475,
              "z": 0.806
            },
            "gtin": "4002575639698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e329",
            "leftCorner": {
              "x": 17.881,
              "y": 13.472,
              "z": 0.806
            },
            "rightCorner": {
              "x": 17.803,
              "y": 13.479,
              "z": 0.806
            },
            "gtin": "4067987001112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e32a",
            "leftCorner": {
              "x": 17.803,
              "y": 13.479,
              "z": 0.806
            },
            "rightCorner": {
              "x": 17.725,
              "y": 13.486,
              "z": 0.806
            },
            "gtin": "4067987001112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e32b",
            "leftCorner": {
              "x": 17.725,
              "y": 13.489,
              "z": 0.806
            },
            "rightCorner": {
              "x": 17.554,
              "y": 13.504,
              "z": 0.806
            },
            "gtin": "4002575639773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e32c",
            "leftCorner": {
              "x": 17.553,
              "y": 13.5,
              "z": 0.806
            },
            "rightCorner": {
              "x": 17.484,
              "y": 13.506,
              "z": 0.806
            },
            "gtin": "7612100918326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e32d",
            "leftCorner": {
              "x": 17.484,
              "y": 13.506,
              "z": 0.806
            },
            "rightCorner": {
              "x": 17.415,
              "y": 13.513,
              "z": 0.806
            },
            "gtin": "7612100918326",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546317",
        "height": 1.6915,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e2cb",
            "leftCorner": {
              "x": 18.589,
              "y": 13.41,
              "z": 1.384
            },
            "rightCorner": {
              "x": 18.542,
              "y": 13.414,
              "z": 1.384
            },
            "gtin": "4006375008142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2cc",
            "leftCorner": {
              "x": 18.542,
              "y": 13.414,
              "z": 1.384
            },
            "rightCorner": {
              "x": 18.495,
              "y": 13.418,
              "z": 1.384
            },
            "gtin": "4006375008142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2cd",
            "leftCorner": {
              "x": 18.496,
              "y": 13.421,
              "z": 1.384
            },
            "rightCorner": {
              "x": 18.419,
              "y": 13.428,
              "z": 1.384
            },
            "gtin": "4006375008234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2ce",
            "leftCorner": {
              "x": 18.419,
              "y": 13.428,
              "z": 1.384
            },
            "rightCorner": {
              "x": 18.342,
              "y": 13.435,
              "z": 1.384
            },
            "gtin": "4006375008234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2cf",
            "leftCorner": {
              "x": 18.341,
              "y": 13.426,
              "z": 1.384
            },
            "rightCorner": {
              "x": 18.3,
              "y": 13.43,
              "z": 1.384
            },
            "gtin": "4006375008197",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2d0",
            "leftCorner": {
              "x": 18.3,
              "y": 13.43,
              "z": 1.384
            },
            "rightCorner": {
              "x": 18.258,
              "y": 13.434,
              "z": 1.384
            },
            "gtin": "4006375008197",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2d1",
            "leftCorner": {
              "x": 18.258,
              "y": 13.434,
              "z": 1.384
            },
            "rightCorner": {
              "x": 18.216,
              "y": 13.438,
              "z": 1.384
            },
            "gtin": "4006375008197",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2d2",
            "leftCorner": {
              "x": 18.216,
              "y": 13.444,
              "z": 1.384
            },
            "rightCorner": {
              "x": 18.105,
              "y": 13.454,
              "z": 1.384
            },
            "gtin": "4006375008173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2d3",
            "leftCorner": {
              "x": 18.105,
              "y": 13.456,
              "z": 1.384
            },
            "rightCorner": {
              "x": 18.054,
              "y": 13.46,
              "z": 1.384
            },
            "gtin": "4006375008203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2d4",
            "leftCorner": {
              "x": 18.054,
              "y": 13.46,
              "z": 1.384
            },
            "rightCorner": {
              "x": 18.002,
              "y": 13.465,
              "z": 1.384
            },
            "gtin": "4006375008203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2d5",
            "leftCorner": {
              "x": 18.002,
              "y": 13.465,
              "z": 1.384
            },
            "rightCorner": {
              "x": 17.951,
              "y": 13.469,
              "z": 1.384
            },
            "gtin": "4006375008203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2d6",
            "leftCorner": {
              "x": 17.95,
              "y": 13.467,
              "z": 1.384
            },
            "rightCorner": {
              "x": 17.897,
              "y": 13.472,
              "z": 1.384
            },
            "gtin": "4251837800349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2d7",
            "leftCorner": {
              "x": 17.897,
              "y": 13.472,
              "z": 1.384
            },
            "rightCorner": {
              "x": 17.842,
              "y": 13.477,
              "z": 1.384
            },
            "gtin": "4251837800349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2d8",
            "leftCorner": {
              "x": 17.842,
              "y": 13.477,
              "z": 1.384
            },
            "rightCorner": {
              "x": 17.787,
              "y": 13.482,
              "z": 1.384
            },
            "gtin": "4251837800349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2d9",
            "leftCorner": {
              "x": 17.788,
              "y": 13.485,
              "z": 1.384
            },
            "rightCorner": {
              "x": 17.651,
              "y": 13.497,
              "z": 1.384
            },
            "gtin": "4251837804873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2da",
            "leftCorner": {
              "x": 17.651,
              "y": 13.497,
              "z": 1.384
            },
            "rightCorner": {
              "x": 17.513,
              "y": 13.51,
              "z": 1.384
            },
            "gtin": "4251837804873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2db",
            "leftCorner": {
              "x": 17.513,
              "y": 13.512,
              "z": 1.384
            },
            "rightCorner": {
              "x": 17.459,
              "y": 13.517,
              "z": 1.384
            },
            "gtin": "8052575090551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2dc",
            "leftCorner": {
              "x": 17.459,
              "y": 13.517,
              "z": 1.384
            },
            "rightCorner": {
              "x": 17.404,
              "y": 13.521,
              "z": 1.384
            },
            "gtin": "8052575090551",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "cde0c",
    "rightNeighborShelfId": "b6f9c"
  },
  {
    "id": "b6f9c",
    "name": "b6f9c",
    "x": 17.438,
    "y": 13.562,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99896,
      "w": 0.045607
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 52
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546320",
        "height": 0.13946,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e3ad",
            "leftCorner": {
              "x": 17.161,
              "y": 13.525,
              "z": 0.114
            },
            "rightCorner": {
              "x": 17.053,
              "y": 13.534,
              "z": 0.114
            },
            "gtin": "4008400401621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3ae",
            "leftCorner": {
              "x": 17.053,
              "y": 13.534,
              "z": 0.114
            },
            "rightCorner": {
              "x": 16.946,
              "y": 13.544,
              "z": 0.114
            },
            "gtin": "4008400401621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3af",
            "leftCorner": {
              "x": 16.946,
              "y": 13.544,
              "z": 0.114
            },
            "rightCorner": {
              "x": 16.839,
              "y": 13.554,
              "z": 0.114
            },
            "gtin": "4008400401621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3b0",
            "leftCorner": {
              "x": 16.839,
              "y": 13.554,
              "z": 0.114
            },
            "rightCorner": {
              "x": 16.732,
              "y": 13.564,
              "z": 0.114
            },
            "gtin": "4008400401621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3b1",
            "leftCorner": {
              "x": 16.734,
              "y": 13.585,
              "z": 0.114
            },
            "rightCorner": {
              "x": 16.403,
              "y": 13.615,
              "z": 0.114
            },
            "gtin": "4008400404127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3b2",
            "leftCorner": {
              "x": 16.403,
              "y": 13.615,
              "z": 0.114
            },
            "rightCorner": {
              "x": 16.071,
              "y": 13.646,
              "z": 0.114
            },
            "gtin": "4008400404127",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54631c",
        "height": 0.58762,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e294",
            "leftCorner": {
              "x": 16.72,
              "y": 13.578,
              "z": 0.481
            },
            "rightCorner": {
              "x": 16.594,
              "y": 13.59,
              "z": 0.481
            },
            "gtin": "4000412017401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e28f",
            "leftCorner": {
              "x": 17.458,
              "y": 13.512,
              "z": 0.481
            },
            "rightCorner": {
              "x": 17.394,
              "y": 13.518,
              "z": 0.481
            },
            "gtin": "8000500426494",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e290",
            "leftCorner": {
              "x": 17.394,
              "y": 13.518,
              "z": 0.481
            },
            "rightCorner": {
              "x": 17.328,
              "y": 13.524,
              "z": 0.481
            },
            "gtin": "8000500426494",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e291",
            "leftCorner": {
              "x": 17.329,
              "y": 13.53,
              "z": 0.481
            },
            "rightCorner": {
              "x": 17.126,
              "y": 13.549,
              "z": 0.481
            },
            "gtin": "4000412010266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e292",
            "leftCorner": {
              "x": 17.126,
              "y": 13.549,
              "z": 0.481
            },
            "rightCorner": {
              "x": 16.924,
              "y": 13.567,
              "z": 0.481
            },
            "gtin": "4000412010266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e293",
            "leftCorner": {
              "x": 16.924,
              "y": 13.567,
              "z": 0.481
            },
            "rightCorner": {
              "x": 16.721,
              "y": 13.586,
              "z": 0.481
            },
            "gtin": "4000412010266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e295",
            "leftCorner": {
              "x": 16.594,
              "y": 13.59,
              "z": 0.481
            },
            "rightCorner": {
              "x": 16.467,
              "y": 13.602,
              "z": 0.481
            },
            "gtin": "4000412017401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e296",
            "leftCorner": {
              "x": 16.467,
              "y": 13.602,
              "z": 0.481
            },
            "rightCorner": {
              "x": 16.34,
              "y": 13.613,
              "z": 0.481
            },
            "gtin": "4000412017401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e297",
            "leftCorner": {
              "x": 16.34,
              "y": 13.613,
              "z": 0.481
            },
            "rightCorner": {
              "x": 16.213,
              "y": 13.624,
              "z": 0.481
            },
            "gtin": "4000412017401",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54631d",
        "height": 0.98617,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e32e",
            "leftCorner": {
              "x": 17.417,
              "y": 13.526,
              "z": 0.807
            },
            "rightCorner": {
              "x": 17.27,
              "y": 13.539,
              "z": 0.807
            },
            "gtin": "8056737784470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e32f",
            "leftCorner": {
              "x": 17.269,
              "y": 13.529,
              "z": 0.807
            },
            "rightCorner": {
              "x": 17.155,
              "y": 13.54,
              "z": 0.807
            },
            "gtin": "4063367284960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e330",
            "leftCorner": {
              "x": 17.155,
              "y": 13.54,
              "z": 0.807
            },
            "rightCorner": {
              "x": 17.041,
              "y": 13.55,
              "z": 0.807
            },
            "gtin": "4063367284960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e331",
            "leftCorner": {
              "x": 17.041,
              "y": 13.55,
              "z": 0.807
            },
            "rightCorner": {
              "x": 16.927,
              "y": 13.561,
              "z": 0.807
            },
            "gtin": "4063367284960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e332",
            "leftCorner": {
              "x": 16.927,
              "y": 13.563,
              "z": 0.807
            },
            "rightCorner": {
              "x": 16.873,
              "y": 13.567,
              "z": 0.807
            },
            "gtin": "4013034730061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e333",
            "leftCorner": {
              "x": 16.873,
              "y": 13.567,
              "z": 0.807
            },
            "rightCorner": {
              "x": 16.818,
              "y": 13.572,
              "z": 0.807
            },
            "gtin": "4013034730061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e334",
            "leftCorner": {
              "x": 16.818,
              "y": 13.572,
              "z": 0.807
            },
            "rightCorner": {
              "x": 16.764,
              "y": 13.577,
              "z": 0.807
            },
            "gtin": "4013034730061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e335",
            "leftCorner": {
              "x": 16.765,
              "y": 13.582,
              "z": 0.807
            },
            "rightCorner": {
              "x": 16.69,
              "y": 13.589,
              "z": 0.807
            },
            "gtin": "4000412050606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e336",
            "leftCorner": {
              "x": 16.69,
              "y": 13.589,
              "z": 0.807
            },
            "rightCorner": {
              "x": 16.614,
              "y": 13.596,
              "z": 0.807
            },
            "gtin": "4000412050606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e337",
            "leftCorner": {
              "x": 16.614,
              "y": 13.596,
              "z": 0.807
            },
            "rightCorner": {
              "x": 16.54,
              "y": 13.602,
              "z": 0.807
            },
            "gtin": "4000412050606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e338",
            "leftCorner": {
              "x": 16.54,
              "y": 13.607,
              "z": 0.807
            },
            "rightCorner": {
              "x": 16.443,
              "y": 13.615,
              "z": 0.807
            },
            "gtin": "4000412010907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e339",
            "leftCorner": {
              "x": 16.443,
              "y": 13.615,
              "z": 0.807
            },
            "rightCorner": {
              "x": 16.348,
              "y": 13.624,
              "z": 0.807
            },
            "gtin": "4000412010907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e33a",
            "leftCorner": {
              "x": 16.348,
              "y": 13.624,
              "z": 0.807
            },
            "rightCorner": {
              "x": 16.251,
              "y": 13.634,
              "z": 0.807
            },
            "gtin": "4000412010907",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54631f",
        "height": 1.3406,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e420",
            "leftCorner": {
              "x": 17.404,
              "y": 13.525,
              "z": 1.097
            },
            "rightCorner": {
              "x": 17.324,
              "y": 13.533,
              "z": 1.097
            },
            "gtin": "4039076089455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e421",
            "leftCorner": {
              "x": 17.324,
              "y": 13.533,
              "z": 1.097
            },
            "rightCorner": {
              "x": 17.243,
              "y": 13.54,
              "z": 1.097
            },
            "gtin": "4039076089455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e422",
            "leftCorner": {
              "x": 17.242,
              "y": 13.529,
              "z": 1.097
            },
            "rightCorner": {
              "x": 17.103,
              "y": 13.543,
              "z": 1.097
            },
            "gtin": "4039076089370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e423",
            "leftCorner": {
              "x": 17.103,
              "y": 13.55,
              "z": 1.097
            },
            "rightCorner": {
              "x": 16.945,
              "y": 13.564,
              "z": 1.097
            },
            "gtin": "4039076089431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e424",
            "leftCorner": {
              "x": 16.944,
              "y": 13.559,
              "z": 1.097
            },
            "rightCorner": {
              "x": 16.769,
              "y": 13.575,
              "z": 1.097
            },
            "gtin": "4039076089356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e425",
            "leftCorner": {
              "x": 16.769,
              "y": 13.576,
              "z": 1.097
            },
            "rightCorner": {
              "x": 16.599,
              "y": 13.592,
              "z": 1.097
            },
            "gtin": "4039076089394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e426",
            "leftCorner": {
              "x": 16.599,
              "y": 13.594,
              "z": 1.097
            },
            "rightCorner": {
              "x": 16.512,
              "y": 13.601,
              "z": 1.097
            },
            "gtin": "4039076089479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e427",
            "leftCorner": {
              "x": 16.512,
              "y": 13.601,
              "z": 1.097
            },
            "rightCorner": {
              "x": 16.425,
              "y": 13.61,
              "z": 1.097
            },
            "gtin": "4039076089479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e428",
            "leftCorner": {
              "x": 16.425,
              "y": 13.615,
              "z": 1.097
            },
            "rightCorner": {
              "x": 16.331,
              "y": 13.624,
              "z": 1.097
            },
            "gtin": "4039076089417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e429",
            "leftCorner": {
              "x": 16.331,
              "y": 13.624,
              "z": 1.097
            },
            "rightCorner": {
              "x": 16.236,
              "y": 13.633,
              "z": 1.097
            },
            "gtin": "4039076089417",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54631e",
        "height": 1.6901,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e2dd",
            "leftCorner": {
              "x": 17.405,
              "y": 13.521,
              "z": 1.383
            },
            "rightCorner": {
              "x": 17.14,
              "y": 13.546,
              "z": 1.383
            },
            "gtin": "4011316013307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2de",
            "leftCorner": {
              "x": 17.14,
              "y": 13.54,
              "z": 1.383
            },
            "rightCorner": {
              "x": 17.062,
              "y": 13.547,
              "z": 1.383
            },
            "gtin": "4337185754364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2df",
            "leftCorner": {
              "x": 17.062,
              "y": 13.547,
              "z": 1.383
            },
            "rightCorner": {
              "x": 16.985,
              "y": 13.553,
              "z": 1.383
            },
            "gtin": "4337185754364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2e0",
            "leftCorner": {
              "x": 16.985,
              "y": 13.554,
              "z": 1.383
            },
            "rightCorner": {
              "x": 16.915,
              "y": 13.56,
              "z": 1.383
            },
            "gtin": "4063367185465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2e1",
            "leftCorner": {
              "x": 16.915,
              "y": 13.56,
              "z": 1.383
            },
            "rightCorner": {
              "x": 16.846,
              "y": 13.567,
              "z": 1.383
            },
            "gtin": "4063367185465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2e2",
            "leftCorner": {
              "x": 16.846,
              "y": 13.571,
              "z": 1.383
            },
            "rightCorner": {
              "x": 16.78,
              "y": 13.576,
              "z": 1.383
            },
            "gtin": "4046869000597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2e3",
            "leftCorner": {
              "x": 16.78,
              "y": 13.576,
              "z": 1.383
            },
            "rightCorner": {
              "x": 16.715,
              "y": 13.582,
              "z": 1.383
            },
            "gtin": "4046869000597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2e4",
            "leftCorner": {
              "x": 16.715,
              "y": 13.582,
              "z": 1.383
            },
            "rightCorner": {
              "x": 16.649,
              "y": 13.588,
              "z": 1.383
            },
            "gtin": "4046869000597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2e5",
            "leftCorner": {
              "x": 16.649,
              "y": 13.594,
              "z": 1.383
            },
            "rightCorner": {
              "x": 16.571,
              "y": 13.601,
              "z": 1.383
            },
            "gtin": "4337185754340",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2e6",
            "leftCorner": {
              "x": 16.571,
              "y": 13.601,
              "z": 1.383
            },
            "rightCorner": {
              "x": 16.492,
              "y": 13.609,
              "z": 1.383
            },
            "gtin": "4337185754340",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2e7",
            "leftCorner": {
              "x": 16.492,
              "y": 13.606,
              "z": 1.383
            },
            "rightCorner": {
              "x": 16.434,
              "y": 13.611,
              "z": 1.383
            },
            "gtin": "4063367179105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2e8",
            "leftCorner": {
              "x": 16.434,
              "y": 13.611,
              "z": 1.383
            },
            "rightCorner": {
              "x": 16.376,
              "y": 13.616,
              "z": 1.383
            },
            "gtin": "4063367179105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2e9",
            "leftCorner": {
              "x": 16.376,
              "y": 13.616,
              "z": 1.383
            },
            "rightCorner": {
              "x": 16.319,
              "y": 13.622,
              "z": 1.383
            },
            "gtin": "4063367179105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2ea",
            "leftCorner": {
              "x": 16.319,
              "y": 13.621,
              "z": 1.383
            },
            "rightCorner": {
              "x": 16.249,
              "y": 13.627,
              "z": 1.383
            },
            "gtin": "4046869000252",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f9b",
    "rightNeighborShelfId": "b6f9d"
  },
  {
    "id": "b6f9d",
    "name": "b6f9d",
    "x": 16.243,
    "y": 13.671,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99896,
      "w": 0.045607
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 59
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546325",
        "height": 0.13511,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e3b3",
            "leftCorner": {
              "x": 16.07,
              "y": 13.64,
              "z": 0.111
            },
            "rightCorner": {
              "x": 15.805,
              "y": 13.664,
              "z": 0.111
            },
            "gtin": "4063367182006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3b4",
            "leftCorner": {
              "x": 15.805,
              "y": 13.664,
              "z": 0.111
            },
            "rightCorner": {
              "x": 15.54,
              "y": 13.688,
              "z": 0.111
            },
            "gtin": "4063367182006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3b5",
            "leftCorner": {
              "x": 15.54,
              "y": 13.692,
              "z": 0.111
            },
            "rightCorner": {
              "x": 15.426,
              "y": 13.703,
              "z": 0.111
            },
            "gtin": "4063367181962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3b6",
            "leftCorner": {
              "x": 15.426,
              "y": 13.703,
              "z": 0.111
            },
            "rightCorner": {
              "x": 15.314,
              "y": 13.713,
              "z": 0.111
            },
            "gtin": "4063367181962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3b7",
            "leftCorner": {
              "x": 15.314,
              "y": 13.713,
              "z": 0.111
            },
            "rightCorner": {
              "x": 15.2,
              "y": 13.724,
              "z": 0.111
            },
            "gtin": "4063367181962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3b8",
            "leftCorner": {
              "x": 15.199,
              "y": 13.707,
              "z": 0.111
            },
            "rightCorner": {
              "x": 15.129,
              "y": 13.713,
              "z": 0.111
            },
            "gtin": "4046869000269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3b9",
            "leftCorner": {
              "x": 15.129,
              "y": 13.713,
              "z": 0.111
            },
            "rightCorner": {
              "x": 15.059,
              "y": 13.72,
              "z": 0.111
            },
            "gtin": "4046869000269",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546324",
        "height": 0.58319,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e298",
            "leftCorner": {
              "x": 16.213,
              "y": 13.626,
              "z": 0.477
            },
            "rightCorner": {
              "x": 16.104,
              "y": 13.636,
              "z": 0.477
            },
            "gtin": "4055500017689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e299",
            "leftCorner": {
              "x": 16.104,
              "y": 13.636,
              "z": 0.477
            },
            "rightCorner": {
              "x": 15.997,
              "y": 13.646,
              "z": 0.477
            },
            "gtin": "4055500017689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e29a",
            "leftCorner": {
              "x": 15.997,
              "y": 13.646,
              "z": 0.477
            },
            "rightCorner": {
              "x": 15.889,
              "y": 13.656,
              "z": 0.477
            },
            "gtin": "4055500017689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e29b",
            "leftCorner": {
              "x": 15.889,
              "y": 13.656,
              "z": 0.477
            },
            "rightCorner": {
              "x": 15.782,
              "y": 13.666,
              "z": 0.477
            },
            "gtin": "4055500017689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e29c",
            "leftCorner": {
              "x": 15.782,
              "y": 13.663,
              "z": 0.477
            },
            "rightCorner": {
              "x": 15.552,
              "y": 13.684,
              "z": 0.477
            },
            "gtin": "4055500017696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e29d",
            "leftCorner": {
              "x": 15.552,
              "y": 13.684,
              "z": 0.477
            },
            "rightCorner": {
              "x": 15.323,
              "y": 13.705,
              "z": 0.477
            },
            "gtin": "4055500017696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e29e",
            "leftCorner": {
              "x": 15.325,
              "y": 13.712,
              "z": 0.477
            },
            "rightCorner": {
              "x": 15.255,
              "y": 13.718,
              "z": 0.477
            },
            "gtin": "4055500027671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e29f",
            "leftCorner": {
              "x": 15.255,
              "y": 13.718,
              "z": 0.477
            },
            "rightCorner": {
              "x": 15.185,
              "y": 13.725,
              "z": 0.477
            },
            "gtin": "4055500027671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2a0",
            "leftCorner": {
              "x": 15.185,
              "y": 13.722,
              "z": 0.477
            },
            "rightCorner": {
              "x": 15.095,
              "y": 13.73,
              "z": 0.477
            },
            "gtin": "4260096390492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2a1",
            "leftCorner": {
              "x": 15.095,
              "y": 13.724,
              "z": 0.477
            },
            "rightCorner": {
              "x": 15.001,
              "y": 13.732,
              "z": 0.477
            },
            "gtin": "4028700150012",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546323",
        "height": 0.98682,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e33b",
            "leftCorner": {
              "x": 16.249,
              "y": 13.63,
              "z": 0.807
            },
            "rightCorner": {
              "x": 16.218,
              "y": 13.633,
              "z": 0.807
            },
            "gtin": "4023300910509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e33c",
            "leftCorner": {
              "x": 16.217,
              "y": 13.629,
              "z": 0.807
            },
            "rightCorner": {
              "x": 16.139,
              "y": 13.636,
              "z": 0.807
            },
            "gtin": "4023300901002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e33d",
            "leftCorner": {
              "x": 16.139,
              "y": 13.636,
              "z": 0.807
            },
            "rightCorner": {
              "x": 16.061,
              "y": 13.642,
              "z": 0.807
            },
            "gtin": "4023300901002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e33e",
            "leftCorner": {
              "x": 16.061,
              "y": 13.652,
              "z": 0.807
            },
            "rightCorner": {
              "x": 15.977,
              "y": 13.66,
              "z": 0.807
            },
            "gtin": "4023300910400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e33f",
            "leftCorner": {
              "x": 15.976,
              "y": 13.642,
              "z": 0.807
            },
            "rightCorner": {
              "x": 15.913,
              "y": 13.647,
              "z": 0.807
            },
            "gtin": "4023300901101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e340",
            "leftCorner": {
              "x": 15.913,
              "y": 13.649,
              "z": 0.807
            },
            "rightCorner": {
              "x": 15.841,
              "y": 13.655,
              "z": 0.807
            },
            "gtin": "4023300901507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e341",
            "leftCorner": {
              "x": 15.841,
              "y": 13.655,
              "z": 0.807
            },
            "rightCorner": {
              "x": 15.769,
              "y": 13.662,
              "z": 0.807
            },
            "gtin": "4023300901507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e342",
            "leftCorner": {
              "x": 15.77,
              "y": 13.663,
              "z": 0.807
            },
            "rightCorner": {
              "x": 15.726,
              "y": 13.667,
              "z": 0.807
            },
            "gtin": "4023300901705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e343",
            "leftCorner": {
              "x": 15.726,
              "y": 13.668,
              "z": 0.807
            },
            "rightCorner": {
              "x": 15.644,
              "y": 13.676,
              "z": 0.807
            },
            "gtin": "4023300901804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e344",
            "leftCorner": {
              "x": 15.644,
              "y": 13.671,
              "z": 0.807
            },
            "rightCorner": {
              "x": 15.577,
              "y": 13.676,
              "z": 0.807
            },
            "gtin": "4023300929808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e345",
            "leftCorner": {
              "x": 15.577,
              "y": 13.673,
              "z": 0.807
            },
            "rightCorner": {
              "x": 15.498,
              "y": 13.68,
              "z": 0.807
            },
            "gtin": "4023300919908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e346",
            "leftCorner": {
              "x": 15.499,
              "y": 13.69,
              "z": 0.807
            },
            "rightCorner": {
              "x": 15.44,
              "y": 13.696,
              "z": 0.807
            },
            "gtin": "4023300903105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e347",
            "leftCorner": {
              "x": 15.44,
              "y": 13.696,
              "z": 0.807
            },
            "rightCorner": {
              "x": 15.382,
              "y": 13.701,
              "z": 0.807
            },
            "gtin": "4023300903105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e348",
            "leftCorner": {
              "x": 15.384,
              "y": 13.725,
              "z": 0.807
            },
            "rightCorner": {
              "x": 15.31,
              "y": 13.732,
              "z": 0.807
            },
            "gtin": "4023300929709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e349",
            "leftCorner": {
              "x": 15.307,
              "y": 13.705,
              "z": 0.807
            },
            "rightCorner": {
              "x": 15.23,
              "y": 13.712,
              "z": 0.807
            },
            "gtin": "4023300941107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e34a",
            "leftCorner": {
              "x": 15.23,
              "y": 13.712,
              "z": 0.807
            },
            "rightCorner": {
              "x": 15.151,
              "y": 13.719,
              "z": 0.807
            },
            "gtin": "4023300941107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e34b",
            "leftCorner": {
              "x": 15.151,
              "y": 13.722,
              "z": 0.807
            },
            "rightCorner": {
              "x": 15.092,
              "y": 13.728,
              "z": 0.807
            },
            "gtin": "4023300900906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e34c",
            "leftCorner": {
              "x": 15.092,
              "y": 13.731,
              "z": 0.807
            },
            "rightCorner": {
              "x": 15.005,
              "y": 13.738,
              "z": 0.807
            },
            "gtin": "4023300900401",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546322",
        "height": 1.3408,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e42a",
            "leftCorner": {
              "x": 16.236,
              "y": 13.641,
              "z": 1.097
            },
            "rightCorner": {
              "x": 16.086,
              "y": 13.656,
              "z": 1.097
            },
            "gtin": "4260096398009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e42b",
            "leftCorner": {
              "x": 16.083,
              "y": 13.635,
              "z": 1.097
            },
            "rightCorner": {
              "x": 15.855,
              "y": 13.656,
              "z": 1.097
            },
            "gtin": "4260130290092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e42c",
            "leftCorner": {
              "x": 15.856,
              "y": 13.666,
              "z": 1.097
            },
            "rightCorner": {
              "x": 15.778,
              "y": 13.673,
              "z": 1.097
            },
            "gtin": "4023300925800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e42d",
            "leftCorner": {
              "x": 15.778,
              "y": 13.673,
              "z": 1.097
            },
            "rightCorner": {
              "x": 15.701,
              "y": 13.681,
              "z": 1.097
            },
            "gtin": "4023300925800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e42e",
            "leftCorner": {
              "x": 15.7,
              "y": 13.67,
              "z": 1.097
            },
            "rightCorner": {
              "x": 15.567,
              "y": 13.683,
              "z": 1.097
            },
            "gtin": "4270000767616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e42f",
            "leftCorner": {
              "x": 15.567,
              "y": 13.683,
              "z": 1.097
            },
            "rightCorner": {
              "x": 15.435,
              "y": 13.695,
              "z": 1.097
            },
            "gtin": "4270000767616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e430",
            "leftCorner": {
              "x": 15.435,
              "y": 13.695,
              "z": 1.097
            },
            "rightCorner": {
              "x": 15.301,
              "y": 13.706,
              "z": 1.097
            },
            "gtin": "4270000767616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e431",
            "leftCorner": {
              "x": 15.301,
              "y": 13.706,
              "z": 1.097
            },
            "rightCorner": {
              "x": 15.169,
              "y": 13.719,
              "z": 1.097
            },
            "gtin": "4270000767616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e432",
            "leftCorner": {
              "x": 15.171,
              "y": 13.731,
              "z": 1.097
            },
            "rightCorner": {
              "x": 15.106,
              "y": 13.737,
              "z": 1.097
            },
            "gtin": "4063367181986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e433",
            "leftCorner": {
              "x": 15.106,
              "y": 13.737,
              "z": 1.097
            },
            "rightCorner": {
              "x": 15.041,
              "y": 13.743,
              "z": 1.097
            },
            "gtin": "4063367181986",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546321",
        "height": 1.6899,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e2eb",
            "leftCorner": {
              "x": 16.247,
              "y": 13.629,
              "z": 1.383
            },
            "rightCorner": {
              "x": 16.161,
              "y": 13.637,
              "z": 1.383
            },
            "gtin": "9421904664654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2ec",
            "leftCorner": {
              "x": 16.16,
              "y": 13.631,
              "z": 1.383
            },
            "rightCorner": {
              "x": 16.065,
              "y": 13.64,
              "z": 1.383
            },
            "gtin": "4260096390881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2ed",
            "leftCorner": {
              "x": 16.065,
              "y": 13.642,
              "z": 1.383
            },
            "rightCorner": {
              "x": 15.979,
              "y": 13.65,
              "z": 1.383
            },
            "gtin": "9421904449220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2ee",
            "leftCorner": {
              "x": 15.981,
              "y": 13.661,
              "z": 1.383
            },
            "rightCorner": {
              "x": 15.846,
              "y": 13.673,
              "z": 1.383
            },
            "gtin": "4028700010538",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2ef",
            "leftCorner": {
              "x": 15.845,
              "y": 13.657,
              "z": 1.383
            },
            "rightCorner": {
              "x": 15.719,
              "y": 13.668,
              "z": 1.383
            },
            "gtin": "4009265031404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2f0",
            "leftCorner": {
              "x": 15.719,
              "y": 13.666,
              "z": 1.383
            },
            "rightCorner": {
              "x": 15.613,
              "y": 13.676,
              "z": 1.383
            },
            "gtin": "4251791701225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2f1",
            "leftCorner": {
              "x": 15.615,
              "y": 13.686,
              "z": 1.383
            },
            "rightCorner": {
              "x": 15.56,
              "y": 13.69,
              "z": 1.383
            },
            "gtin": "4028700006708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2f2",
            "leftCorner": {
              "x": 15.56,
              "y": 13.69,
              "z": 1.383
            },
            "rightCorner": {
              "x": 15.506,
              "y": 13.696,
              "z": 1.383
            },
            "gtin": "4028700006708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2f3",
            "leftCorner": {
              "x": 15.506,
              "y": 13.696,
              "z": 1.383
            },
            "rightCorner": {
              "x": 15.451,
              "y": 13.7,
              "z": 1.383
            },
            "gtin": "4028700006708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2f4",
            "leftCorner": {
              "x": 15.453,
              "y": 13.708,
              "z": 1.383
            },
            "rightCorner": {
              "x": 15.359,
              "y": 13.716,
              "z": 1.383
            },
            "gtin": "4028700061059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2f5",
            "leftCorner": {
              "x": 15.359,
              "y": 13.716,
              "z": 1.383
            },
            "rightCorner": {
              "x": 15.266,
              "y": 13.725,
              "z": 1.383
            },
            "gtin": "4028700061059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2f6",
            "leftCorner": {
              "x": 15.266,
              "y": 13.725,
              "z": 1.383
            },
            "rightCorner": {
              "x": 15.19,
              "y": 13.732,
              "z": 1.383
            },
            "gtin": "4028700035807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2f7",
            "leftCorner": {
              "x": 15.19,
              "y": 13.734,
              "z": 1.383
            },
            "rightCorner": {
              "x": 15.112,
              "y": 13.74,
              "z": 1.383
            },
            "gtin": "4028700035821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2f8",
            "leftCorner": {
              "x": 15.112,
              "y": 13.731,
              "z": 1.383
            },
            "rightCorner": {
              "x": 15.051,
              "y": 13.737,
              "z": 1.383
            },
            "gtin": "4028700035814",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f9c",
    "rightNeighborShelfId": "b6f9e"
  },
  {
    "id": "b6f9e",
    "name": "b6f9e",
    "x": 15.048,
    "y": 13.78,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99896,
      "w": 0.045607
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 56
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54632a",
        "height": 0.13414,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e3ba",
            "leftCorner": {
              "x": 15.061,
              "y": 13.733,
              "z": 0.11
            },
            "rightCorner": {
              "x": 14.971,
              "y": 13.741,
              "z": 0.11
            },
            "gtin": "40555027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3bb",
            "leftCorner": {
              "x": 14.971,
              "y": 13.741,
              "z": 0.11
            },
            "rightCorner": {
              "x": 14.882,
              "y": 13.749,
              "z": 0.11
            },
            "gtin": "40555027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3bc",
            "leftCorner": {
              "x": 14.882,
              "y": 13.745,
              "z": 0.11
            },
            "rightCorner": {
              "x": 14.778,
              "y": 13.755,
              "z": 0.11
            },
            "gtin": "40555133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3bd",
            "leftCorner": {
              "x": 14.778,
              "y": 13.755,
              "z": 0.11
            },
            "rightCorner": {
              "x": 14.675,
              "y": 13.764,
              "z": 0.11
            },
            "gtin": "40555133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3be",
            "leftCorner": {
              "x": 14.675,
              "y": 13.76,
              "z": 0.11
            },
            "rightCorner": {
              "x": 14.587,
              "y": 13.769,
              "z": 0.11
            },
            "gtin": "4009265002206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3bf",
            "leftCorner": {
              "x": 14.587,
              "y": 13.769,
              "z": 0.11
            },
            "rightCorner": {
              "x": 14.501,
              "y": 13.776,
              "z": 0.11
            },
            "gtin": "4009265002206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3c0",
            "leftCorner": {
              "x": 14.501,
              "y": 13.782,
              "z": 0.11
            },
            "rightCorner": {
              "x": 14.432,
              "y": 13.788,
              "z": 0.11
            },
            "gtin": "4055500012967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3c1",
            "leftCorner": {
              "x": 14.432,
              "y": 13.788,
              "z": 0.11
            },
            "rightCorner": {
              "x": 14.363,
              "y": 13.795,
              "z": 0.11
            },
            "gtin": "4055500012967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3c2",
            "leftCorner": {
              "x": 14.362,
              "y": 13.793,
              "z": 0.11
            },
            "rightCorner": {
              "x": 14.28,
              "y": 13.8,
              "z": 0.11
            },
            "gtin": "40555126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3c3",
            "leftCorner": {
              "x": 14.28,
              "y": 13.8,
              "z": 0.11
            },
            "rightCorner": {
              "x": 14.196,
              "y": 13.807,
              "z": 0.11
            },
            "gtin": "40555126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3c4",
            "leftCorner": {
              "x": 14.195,
              "y": 13.798,
              "z": 0.11
            },
            "rightCorner": {
              "x": 14.099,
              "y": 13.807,
              "z": 0.11
            },
            "gtin": "4055500011694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3c5",
            "leftCorner": {
              "x": 14.099,
              "y": 13.807,
              "z": 0.11
            },
            "rightCorner": {
              "x": 14.002,
              "y": 13.816,
              "z": 0.11
            },
            "gtin": "4055500011694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3c6",
            "leftCorner": {
              "x": 14.002,
              "y": 13.818,
              "z": 0.11
            },
            "rightCorner": {
              "x": 13.913,
              "y": 13.826,
              "z": 0.11
            },
            "gtin": "4055500012578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3c7",
            "leftCorner": {
              "x": 13.913,
              "y": 13.826,
              "z": 0.11
            },
            "rightCorner": {
              "x": 13.824,
              "y": 13.835,
              "z": 0.11
            },
            "gtin": "4055500012578",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546329",
        "height": 0.5843,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e2a2",
            "leftCorner": {
              "x": 15.002,
              "y": 13.732,
              "z": 0.478
            },
            "rightCorner": {
              "x": 14.84,
              "y": 13.747,
              "z": 0.478
            },
            "gtin": "4009265001100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2a3",
            "leftCorner": {
              "x": 14.84,
              "y": 13.747,
              "z": 0.478
            },
            "rightCorner": {
              "x": 14.676,
              "y": 13.762,
              "z": 0.478
            },
            "gtin": "4009265001100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2a4",
            "leftCorner": {
              "x": 14.676,
              "y": 13.753,
              "z": 0.478
            },
            "rightCorner": {
              "x": 14.526,
              "y": 13.767,
              "z": 0.478
            },
            "gtin": "4009265002503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2a5",
            "leftCorner": {
              "x": 14.527,
              "y": 13.775,
              "z": 0.478
            },
            "rightCorner": {
              "x": 14.439,
              "y": 13.783,
              "z": 0.478
            },
            "gtin": "4009265002404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2a6",
            "leftCorner": {
              "x": 14.439,
              "y": 13.783,
              "z": 0.478
            },
            "rightCorner": {
              "x": 14.352,
              "y": 13.791,
              "z": 0.478
            },
            "gtin": "4009265002404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2a7",
            "leftCorner": {
              "x": 14.352,
              "y": 13.787,
              "z": 0.478
            },
            "rightCorner": {
              "x": 14.283,
              "y": 13.793,
              "z": 0.478
            },
            "gtin": "4009265003609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2a8",
            "leftCorner": {
              "x": 14.283,
              "y": 13.793,
              "z": 0.478
            },
            "rightCorner": {
              "x": 14.215,
              "y": 13.8,
              "z": 0.478
            },
            "gtin": "4009265003609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2a9",
            "leftCorner": {
              "x": 14.215,
              "y": 13.808,
              "z": 0.478
            },
            "rightCorner": {
              "x": 14.113,
              "y": 13.817,
              "z": 0.478
            },
            "gtin": "40555232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2aa",
            "leftCorner": {
              "x": 14.113,
              "y": 13.817,
              "z": 0.478
            },
            "rightCorner": {
              "x": 14.01,
              "y": 13.826,
              "z": 0.478
            },
            "gtin": "40555232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2ab",
            "leftCorner": {
              "x": 14.01,
              "y": 13.824,
              "z": 0.478
            },
            "rightCorner": {
              "x": 13.932,
              "y": 13.831,
              "z": 0.478
            },
            "gtin": "4055500012974",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2ac",
            "leftCorner": {
              "x": 13.932,
              "y": 13.831,
              "z": 0.478
            },
            "rightCorner": {
              "x": 13.854,
              "y": 13.838,
              "z": 0.478
            },
            "gtin": "4055500012974",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546328",
        "height": 0.98849,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e34d",
            "leftCorner": {
              "x": 15.006,
              "y": 13.742,
              "z": 0.809
            },
            "rightCorner": {
              "x": 14.855,
              "y": 13.755,
              "z": 0.809
            },
            "gtin": "4055500012004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e34e",
            "leftCorner": {
              "x": 14.855,
              "y": 13.754,
              "z": 0.809
            },
            "rightCorner": {
              "x": 14.776,
              "y": 13.761,
              "z": 0.809
            },
            "gtin": "40555058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e34f",
            "leftCorner": {
              "x": 14.776,
              "y": 13.761,
              "z": 0.809
            },
            "rightCorner": {
              "x": 14.698,
              "y": 13.769,
              "z": 0.809
            },
            "gtin": "40555058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e350",
            "leftCorner": {
              "x": 14.698,
              "y": 13.768,
              "z": 0.809
            },
            "rightCorner": {
              "x": 14.464,
              "y": 13.789,
              "z": 0.809
            },
            "gtin": "4055500012820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e351",
            "leftCorner": {
              "x": 14.464,
              "y": 13.783,
              "z": 0.809
            },
            "rightCorner": {
              "x": 14.377,
              "y": 13.792,
              "z": 0.809
            },
            "gtin": "4009265001704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e352",
            "leftCorner": {
              "x": 14.377,
              "y": 13.792,
              "z": 0.809
            },
            "rightCorner": {
              "x": 14.29,
              "y": 13.799,
              "z": 0.809
            },
            "gtin": "4009265001704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e353",
            "leftCorner": {
              "x": 14.29,
              "y": 13.809,
              "z": 0.809
            },
            "rightCorner": {
              "x": 14.154,
              "y": 13.821,
              "z": 0.809
            },
            "gtin": "4055500012981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e354",
            "leftCorner": {
              "x": 14.152,
              "y": 13.809,
              "z": 0.809
            },
            "rightCorner": {
              "x": 13.96,
              "y": 13.826,
              "z": 0.809
            },
            "gtin": "40555584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e355",
            "leftCorner": {
              "x": 13.96,
              "y": 13.826,
              "z": 0.809
            },
            "rightCorner": {
              "x": 13.848,
              "y": 13.835,
              "z": 0.809
            },
            "gtin": "40555157",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546327",
        "height": 1.3413,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e43c",
            "leftCorner": {
              "x": 14.068,
              "y": 13.819,
              "z": 1.097
            },
            "rightCorner": {
              "x": 13.961,
              "y": 13.828,
              "z": 1.097
            },
            "gtin": "4023300490117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e434",
            "leftCorner": {
              "x": 15.044,
              "y": 13.757,
              "z": 1.097
            },
            "rightCorner": {
              "x": 14.845,
              "y": 13.776,
              "z": 1.097
            },
            "gtin": "40287157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e435",
            "leftCorner": {
              "x": 14.843,
              "y": 13.752,
              "z": 1.097
            },
            "rightCorner": {
              "x": 14.663,
              "y": 13.768,
              "z": 1.097
            },
            "gtin": "40555621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e436",
            "leftCorner": {
              "x": 14.662,
              "y": 13.767,
              "z": 1.097
            },
            "rightCorner": {
              "x": 14.589,
              "y": 13.773,
              "z": 1.097
            },
            "gtin": "4009265001407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e437",
            "leftCorner": {
              "x": 14.589,
              "y": 13.773,
              "z": 1.097
            },
            "rightCorner": {
              "x": 14.514,
              "y": 13.781,
              "z": 1.097
            },
            "gtin": "4009265001407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e438",
            "leftCorner": {
              "x": 14.514,
              "y": 13.785,
              "z": 1.097
            },
            "rightCorner": {
              "x": 14.402,
              "y": 13.796,
              "z": 1.097
            },
            "gtin": "4023300492135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e439",
            "leftCorner": {
              "x": 14.402,
              "y": 13.796,
              "z": 1.097
            },
            "rightCorner": {
              "x": 14.288,
              "y": 13.806,
              "z": 1.097
            },
            "gtin": "4023300492135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e43a",
            "leftCorner": {
              "x": 14.288,
              "y": 13.806,
              "z": 1.097
            },
            "rightCorner": {
              "x": 14.176,
              "y": 13.816,
              "z": 1.097
            },
            "gtin": "4023300492135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e43b",
            "leftCorner": {
              "x": 14.175,
              "y": 13.809,
              "z": 1.097
            },
            "rightCorner": {
              "x": 14.068,
              "y": 13.819,
              "z": 1.097
            },
            "gtin": "4023300490117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e43d",
            "leftCorner": {
              "x": 13.961,
              "y": 13.828,
              "z": 1.097
            },
            "rightCorner": {
              "x": 13.853,
              "y": 13.838,
              "z": 1.097
            },
            "gtin": "4023300490117",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546326",
        "height": 1.6927,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e2f9",
            "leftCorner": {
              "x": 15.053,
              "y": 13.754,
              "z": 1.385
            },
            "rightCorner": {
              "x": 14.982,
              "y": 13.76,
              "z": 1.385
            },
            "gtin": "40287324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2fa",
            "leftCorner": {
              "x": 14.982,
              "y": 13.76,
              "z": 1.385
            },
            "rightCorner": {
              "x": 14.91,
              "y": 13.767,
              "z": 1.385
            },
            "gtin": "40287324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2fb",
            "leftCorner": {
              "x": 14.908,
              "y": 13.753,
              "z": 1.385
            },
            "rightCorner": {
              "x": 14.703,
              "y": 13.771,
              "z": 1.385
            },
            "gtin": "4028700010897",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2fc",
            "leftCorner": {
              "x": 14.703,
              "y": 13.77,
              "z": 1.385
            },
            "rightCorner": {
              "x": 14.561,
              "y": 13.783,
              "z": 1.385
            },
            "gtin": "4028700010903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2fd",
            "leftCorner": {
              "x": 14.561,
              "y": 13.781,
              "z": 1.385
            },
            "rightCorner": {
              "x": 14.416,
              "y": 13.794,
              "z": 1.385
            },
            "gtin": "40287164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2fe",
            "leftCorner": {
              "x": 14.416,
              "y": 13.804,
              "z": 1.385
            },
            "rightCorner": {
              "x": 14.353,
              "y": 13.81,
              "z": 1.385
            },
            "gtin": "40287133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2ff",
            "leftCorner": {
              "x": 14.353,
              "y": 13.81,
              "z": 1.385
            },
            "rightCorner": {
              "x": 14.288,
              "y": 13.816,
              "z": 1.385
            },
            "gtin": "40287133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e300",
            "leftCorner": {
              "x": 14.286,
              "y": 13.8,
              "z": 1.385
            },
            "rightCorner": {
              "x": 14.168,
              "y": 13.812,
              "z": 1.385
            },
            "gtin": "4023300925800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e301",
            "leftCorner": {
              "x": 14.168,
              "y": 13.815,
              "z": 1.385
            },
            "rightCorner": {
              "x": 14.097,
              "y": 13.821,
              "z": 1.385
            },
            "gtin": "4260536476304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e302",
            "leftCorner": {
              "x": 14.097,
              "y": 13.821,
              "z": 1.385
            },
            "rightCorner": {
              "x": 14.025,
              "y": 13.828,
              "z": 1.385
            },
            "gtin": "4260536476304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e303",
            "leftCorner": {
              "x": 14.024,
              "y": 13.821,
              "z": 1.385
            },
            "rightCorner": {
              "x": 13.922,
              "y": 13.83,
              "z": 1.385
            },
            "gtin": "4009265011703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e304",
            "leftCorner": {
              "x": 13.922,
              "y": 13.83,
              "z": 1.385
            },
            "rightCorner": {
              "x": 13.82,
              "y": 13.839,
              "z": 1.385
            },
            "gtin": "4009265011703",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f9d",
    "rightNeighborShelfId": "b6f9f"
  },
  {
    "id": "b6f9f",
    "name": "b6f9f",
    "x": 13.853,
    "y": 13.89,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99896,
      "w": 0.045607
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 73
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54632f",
        "height": 0.14225,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e3c8",
            "leftCorner": {
              "x": 13.824,
              "y": 13.841,
              "z": 0.116
            },
            "rightCorner": {
              "x": 13.774,
              "y": 13.846,
              "z": 0.116
            },
            "gtin": "4063367319235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3c9",
            "leftCorner": {
              "x": 13.774,
              "y": 13.846,
              "z": 0.116
            },
            "rightCorner": {
              "x": 13.724,
              "y": 13.85,
              "z": 0.116
            },
            "gtin": "4063367319235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3ca",
            "leftCorner": {
              "x": 13.724,
              "y": 13.85,
              "z": 0.116
            },
            "rightCorner": {
              "x": 13.658,
              "y": 13.856,
              "z": 0.116
            },
            "gtin": "4063367319259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3cb",
            "leftCorner": {
              "x": 13.658,
              "y": 13.856,
              "z": 0.116
            },
            "rightCorner": {
              "x": 13.593,
              "y": 13.862,
              "z": 0.116
            },
            "gtin": "4063367319259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3cc",
            "leftCorner": {
              "x": 13.593,
              "y": 13.858,
              "z": 0.116
            },
            "rightCorner": {
              "x": 13.528,
              "y": 13.864,
              "z": 0.116
            },
            "gtin": "4063367319211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3cd",
            "leftCorner": {
              "x": 13.528,
              "y": 13.864,
              "z": 0.116
            },
            "rightCorner": {
              "x": 13.463,
              "y": 13.87,
              "z": 0.116
            },
            "gtin": "4063367319211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3ce",
            "leftCorner": {
              "x": 13.464,
              "y": 13.882,
              "z": 0.116
            },
            "rightCorner": {
              "x": 13.376,
              "y": 13.89,
              "z": 0.116
            },
            "gtin": "4003740031507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3cf",
            "leftCorner": {
              "x": 13.375,
              "y": 13.878,
              "z": 0.116
            },
            "rightCorner": {
              "x": 13.286,
              "y": 13.886,
              "z": 0.116
            },
            "gtin": "4003740006307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3d0",
            "leftCorner": {
              "x": 13.286,
              "y": 13.886,
              "z": 0.116
            },
            "rightCorner": {
              "x": 13.198,
              "y": 13.895,
              "z": 0.116
            },
            "gtin": "4003740006307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3d1",
            "leftCorner": {
              "x": 13.198,
              "y": 13.89,
              "z": 0.116
            },
            "rightCorner": {
              "x": 13.112,
              "y": 13.897,
              "z": 0.116
            },
            "gtin": "4002575627435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3d2",
            "leftCorner": {
              "x": 13.112,
              "y": 13.897,
              "z": 0.116
            },
            "rightCorner": {
              "x": 13.028,
              "y": 13.905,
              "z": 0.116
            },
            "gtin": "4002575627435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3d3",
            "leftCorner": {
              "x": 13.027,
              "y": 13.902,
              "z": 0.116
            },
            "rightCorner": {
              "x": 12.971,
              "y": 13.907,
              "z": 0.116
            },
            "gtin": "4063367436055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3d4",
            "leftCorner": {
              "x": 12.971,
              "y": 13.907,
              "z": 0.116
            },
            "rightCorner": {
              "x": 12.914,
              "y": 13.913,
              "z": 0.116
            },
            "gtin": "4063367436055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3d5",
            "leftCorner": {
              "x": 12.914,
              "y": 13.915,
              "z": 0.116
            },
            "rightCorner": {
              "x": 12.848,
              "y": 13.921,
              "z": 0.116
            },
            "gtin": "4063367436031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3d6",
            "leftCorner": {
              "x": 12.848,
              "y": 13.921,
              "z": 0.116
            },
            "rightCorner": {
              "x": 12.783,
              "y": 13.926,
              "z": 0.116
            },
            "gtin": "4063367436031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3d7",
            "leftCorner": {
              "x": 12.783,
              "y": 13.93,
              "z": 0.116
            },
            "rightCorner": {
              "x": 12.713,
              "y": 13.936,
              "z": 0.116
            },
            "gtin": "4063367233005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3d8",
            "leftCorner": {
              "x": 12.713,
              "y": 13.936,
              "z": 0.116
            },
            "rightCorner": {
              "x": 12.642,
              "y": 13.943,
              "z": 0.116
            },
            "gtin": "4063367233005",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54632d",
        "height": 0.5895,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e2ad",
            "leftCorner": {
              "x": 13.855,
              "y": 13.85,
              "z": 0.482
            },
            "rightCorner": {
              "x": 13.775,
              "y": 13.857,
              "z": 0.482
            },
            "gtin": "4026701000305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2ae",
            "leftCorner": {
              "x": 13.775,
              "y": 13.857,
              "z": 0.482
            },
            "rightCorner": {
              "x": 13.695,
              "y": 13.864,
              "z": 0.482
            },
            "gtin": "4026701000305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2af",
            "leftCorner": {
              "x": 13.692,
              "y": 13.846,
              "z": 0.482
            },
            "rightCorner": {
              "x": 13.618,
              "y": 13.853,
              "z": 0.482
            },
            "gtin": "4026701006505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2b0",
            "leftCorner": {
              "x": 13.618,
              "y": 13.853,
              "z": 0.482
            },
            "rightCorner": {
              "x": 13.545,
              "y": 13.86,
              "z": 0.482
            },
            "gtin": "4026701006505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2b1",
            "leftCorner": {
              "x": 13.545,
              "y": 13.86,
              "z": 0.482
            },
            "rightCorner": {
              "x": 13.471,
              "y": 13.866,
              "z": 0.482
            },
            "gtin": "4026701006505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2b2",
            "leftCorner": {
              "x": 13.471,
              "y": 13.862,
              "z": 0.482
            },
            "rightCorner": {
              "x": 13.4,
              "y": 13.869,
              "z": 0.482
            },
            "gtin": "4026701000404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2b3",
            "leftCorner": {
              "x": 13.4,
              "y": 13.869,
              "z": 0.482
            },
            "rightCorner": {
              "x": 13.328,
              "y": 13.875,
              "z": 0.482
            },
            "gtin": "4026701000404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2b4",
            "leftCorner": {
              "x": 13.33,
              "y": 13.886,
              "z": 0.482
            },
            "rightCorner": {
              "x": 13.245,
              "y": 13.894,
              "z": 0.482
            },
            "gtin": "4026701000107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2b5",
            "leftCorner": {
              "x": 13.245,
              "y": 13.894,
              "z": 0.482
            },
            "rightCorner": {
              "x": 13.16,
              "y": 13.903,
              "z": 0.482
            },
            "gtin": "4026701000107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2b6",
            "leftCorner": {
              "x": 13.159,
              "y": 13.892,
              "z": 0.482
            },
            "rightCorner": {
              "x": 13.093,
              "y": 13.898,
              "z": 0.482
            },
            "gtin": "4026701022222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2b7",
            "leftCorner": {
              "x": 13.093,
              "y": 13.898,
              "z": 0.482
            },
            "rightCorner": {
              "x": 13.029,
              "y": 13.904,
              "z": 0.482
            },
            "gtin": "4026701022222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2b8",
            "leftCorner": {
              "x": 13.029,
              "y": 13.904,
              "z": 0.482
            },
            "rightCorner": {
              "x": 12.963,
              "y": 13.91,
              "z": 0.482
            },
            "gtin": "4026701022222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2b9",
            "leftCorner": {
              "x": 12.963,
              "y": 13.918,
              "z": 0.482
            },
            "rightCorner": {
              "x": 12.87,
              "y": 13.926,
              "z": 0.482
            },
            "gtin": "4026701003337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2ba",
            "leftCorner": {
              "x": 12.87,
              "y": 13.926,
              "z": 0.482
            },
            "rightCorner": {
              "x": 12.776,
              "y": 13.935,
              "z": 0.482
            },
            "gtin": "4026701003337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e279",
            "leftCorner": {
              "x": 12.775,
              "y": 13.917,
              "z": 0.482
            },
            "rightCorner": {
              "x": 12.652,
              "y": 13.929,
              "z": 0.482
            },
            "gtin": "4026701011110",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54632c",
        "height": 0.99495,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e356",
            "leftCorner": {
              "x": 13.848,
              "y": 13.831,
              "z": 0.814
            },
            "rightCorner": {
              "x": 13.806,
              "y": 13.835,
              "z": 0.814
            },
            "gtin": "4006375000382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e357",
            "leftCorner": {
              "x": 13.808,
              "y": 13.856,
              "z": 0.814
            },
            "rightCorner": {
              "x": 13.705,
              "y": 13.865,
              "z": 0.814
            },
            "gtin": "4006375000382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e358",
            "leftCorner": {
              "x": 13.704,
              "y": 13.857,
              "z": 0.814
            },
            "rightCorner": {
              "x": 13.626,
              "y": 13.864,
              "z": 0.814
            },
            "gtin": "4006375000399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e359",
            "leftCorner": {
              "x": 13.626,
              "y": 13.864,
              "z": 0.814
            },
            "rightCorner": {
              "x": 13.55,
              "y": 13.871,
              "z": 0.814
            },
            "gtin": "4006375000399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e35a",
            "leftCorner": {
              "x": 13.548,
              "y": 13.866,
              "z": 0.814
            },
            "rightCorner": {
              "x": 13.421,
              "y": 13.878,
              "z": 0.814
            },
            "gtin": "4006375000290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e35b",
            "leftCorner": {
              "x": 13.421,
              "y": 13.878,
              "z": 0.814
            },
            "rightCorner": {
              "x": 13.277,
              "y": 13.891,
              "z": 0.814
            },
            "gtin": "4006375000306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e35c",
            "leftCorner": {
              "x": 13.277,
              "y": 13.89,
              "z": 0.814
            },
            "rightCorner": {
              "x": 13.144,
              "y": 13.903,
              "z": 0.814
            },
            "gtin": "4006375000122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e35d",
            "leftCorner": {
              "x": 13.144,
              "y": 13.903,
              "z": 0.814
            },
            "rightCorner": {
              "x": 13.01,
              "y": 13.915,
              "z": 0.814
            },
            "gtin": "4006375000122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e35e",
            "leftCorner": {
              "x": 13.01,
              "y": 13.915,
              "z": 0.814
            },
            "rightCorner": {
              "x": 12.913,
              "y": 13.924,
              "z": 0.814
            },
            "gtin": "4006375000238",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e35f",
            "leftCorner": {
              "x": 12.913,
              "y": 13.923,
              "z": 0.814
            },
            "rightCorner": {
              "x": 12.779,
              "y": 13.935,
              "z": 0.814
            },
            "gtin": "4006375000030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e360",
            "leftCorner": {
              "x": 12.779,
              "y": 13.926,
              "z": 0.814
            },
            "rightCorner": {
              "x": 12.636,
              "y": 13.939,
              "z": 0.814
            },
            "gtin": "4002575602838",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54632b",
        "height": 1.3478,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e43e",
            "leftCorner": {
              "x": 13.855,
              "y": 13.855,
              "z": 1.103
            },
            "rightCorner": {
              "x": 13.799,
              "y": 13.86,
              "z": 1.103
            },
            "gtin": "4045178002827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e43f",
            "leftCorner": {
              "x": 13.8,
              "y": 13.88,
              "z": 1.103
            },
            "rightCorner": {
              "x": 13.733,
              "y": 13.886,
              "z": 1.103
            },
            "gtin": "4045178001400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e440",
            "leftCorner": {
              "x": 13.73,
              "y": 13.86,
              "z": 1.103
            },
            "rightCorner": {
              "x": 13.633,
              "y": 13.869,
              "z": 1.103
            },
            "gtin": "4045178009192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e441",
            "leftCorner": {
              "x": 13.631,
              "y": 13.864,
              "z": 1.103
            },
            "rightCorner": {
              "x": 13.577,
              "y": 13.869,
              "z": 1.103
            },
            "gtin": "4045178001424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e442",
            "leftCorner": {
              "x": 13.576,
              "y": 13.868,
              "z": 1.103
            },
            "rightCorner": {
              "x": 13.518,
              "y": 13.874,
              "z": 1.103
            },
            "gtin": "4045178002841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e443",
            "leftCorner": {
              "x": 13.518,
              "y": 13.874,
              "z": 1.103
            },
            "rightCorner": {
              "x": 13.461,
              "y": 13.878,
              "z": 1.103
            },
            "gtin": "3492390020367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e444",
            "leftCorner": {
              "x": 13.461,
              "y": 13.878,
              "z": 1.103
            },
            "rightCorner": {
              "x": 13.409,
              "y": 13.883,
              "z": 1.103
            },
            "gtin": "3388600000062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e445",
            "leftCorner": {
              "x": 13.409,
              "y": 13.883,
              "z": 1.103
            },
            "rightCorner": {
              "x": 13.358,
              "y": 13.888,
              "z": 1.103
            },
            "gtin": "3388600000062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e446",
            "leftCorner": {
              "x": 13.358,
              "y": 13.888,
              "z": 1.103
            },
            "rightCorner": {
              "x": 13.309,
              "y": 13.893,
              "z": 1.103
            },
            "gtin": "3492390008990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e447",
            "leftCorner": {
              "x": 13.309,
              "y": 13.893,
              "z": 1.103
            },
            "rightCorner": {
              "x": 13.26,
              "y": 13.897,
              "z": 1.103
            },
            "gtin": "3492390008990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e448",
            "leftCorner": {
              "x": 13.26,
              "y": 13.9,
              "z": 1.103
            },
            "rightCorner": {
              "x": 13.132,
              "y": 13.912,
              "z": 1.103
            },
            "gtin": "3392390009068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e449",
            "leftCorner": {
              "x": 13.131,
              "y": 13.904,
              "z": 1.103
            },
            "rightCorner": {
              "x": 13.065,
              "y": 13.91,
              "z": 1.103
            },
            "gtin": "3492390003698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e44a",
            "leftCorner": {
              "x": 13.065,
              "y": 13.91,
              "z": 1.103
            },
            "rightCorner": {
              "x": 12.999,
              "y": 13.916,
              "z": 1.103
            },
            "gtin": "3492390003698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e44b",
            "leftCorner": {
              "x": 12.998,
              "y": 13.914,
              "z": 1.103
            },
            "rightCorner": {
              "x": 12.946,
              "y": 13.919,
              "z": 1.103
            },
            "gtin": "3492390009003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e44c",
            "leftCorner": {
              "x": 12.946,
              "y": 13.919,
              "z": 1.103
            },
            "rightCorner": {
              "x": 12.893,
              "y": 13.923,
              "z": 1.103
            },
            "gtin": "3492390009003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e44d",
            "leftCorner": {
              "x": 12.893,
              "y": 13.932,
              "z": 1.103
            },
            "rightCorner": {
              "x": 12.828,
              "y": 13.938,
              "z": 1.103
            },
            "gtin": "3388600000468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e44e",
            "leftCorner": {
              "x": 12.828,
              "y": 13.938,
              "z": 1.103
            },
            "rightCorner": {
              "x": 12.763,
              "y": 13.944,
              "z": 1.103
            },
            "gtin": "3388600000468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e40a",
            "leftCorner": {
              "x": 12.761,
              "y": 13.927,
              "z": 1.103
            },
            "rightCorner": {
              "x": 12.653,
              "y": 13.938,
              "z": 1.103
            },
            "gtin": "3492390001038",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54632e",
        "height": 1.6997,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e305",
            "leftCorner": {
              "x": 13.821,
              "y": 13.855,
              "z": 1.391
            },
            "rightCorner": {
              "x": 13.687,
              "y": 13.868,
              "z": 1.391
            },
            "gtin": "8001505007022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e306",
            "leftCorner": {
              "x": 13.686,
              "y": 13.857,
              "z": 1.391
            },
            "rightCorner": {
              "x": 13.565,
              "y": 13.867,
              "z": 1.391
            },
            "gtin": "8001505007015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e307",
            "leftCorner": {
              "x": 13.566,
              "y": 13.88,
              "z": 1.391
            },
            "rightCorner": {
              "x": 13.489,
              "y": 13.887,
              "z": 1.391
            },
            "gtin": "8001505007169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e308",
            "leftCorner": {
              "x": 13.489,
              "y": 13.887,
              "z": 1.391
            },
            "rightCorner": {
              "x": 13.41,
              "y": 13.894,
              "z": 1.391
            },
            "gtin": "8001505007169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e309",
            "leftCorner": {
              "x": 13.409,
              "y": 13.881,
              "z": 1.391
            },
            "rightCorner": {
              "x": 13.287,
              "y": 13.892,
              "z": 1.391
            },
            "gtin": "8001505007329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e30a",
            "leftCorner": {
              "x": 13.287,
              "y": 13.89,
              "z": 1.391
            },
            "rightCorner": {
              "x": 13.217,
              "y": 13.896,
              "z": 1.391
            },
            "gtin": "8001505007121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e30b",
            "leftCorner": {
              "x": 13.217,
              "y": 13.896,
              "z": 1.391
            },
            "rightCorner": {
              "x": 13.146,
              "y": 13.903,
              "z": 1.391
            },
            "gtin": "8001505007121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e30c",
            "leftCorner": {
              "x": 13.146,
              "y": 13.902,
              "z": 1.391
            },
            "rightCorner": {
              "x": 13.021,
              "y": 13.913,
              "z": 1.391
            },
            "gtin": "8001505007145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e30d",
            "leftCorner": {
              "x": 13.022,
              "y": 13.917,
              "z": 1.391
            },
            "rightCorner": {
              "x": 12.886,
              "y": 13.93,
              "z": 1.391
            },
            "gtin": "8001505007039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e30e",
            "leftCorner": {
              "x": 12.886,
              "y": 13.924,
              "z": 1.391
            },
            "rightCorner": {
              "x": 12.816,
              "y": 13.93,
              "z": 1.391
            },
            "gtin": "8001505007091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e30f",
            "leftCorner": {
              "x": 12.816,
              "y": 13.93,
              "z": 1.391
            },
            "rightCorner": {
              "x": 12.746,
              "y": 13.937,
              "z": 1.391
            },
            "gtin": "8001505007091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2bd",
            "leftCorner": {
              "x": 12.746,
              "y": 13.939,
              "z": 1.391
            },
            "rightCorner": {
              "x": 12.654,
              "y": 13.947,
              "z": 1.391
            },
            "gtin": "8001505007176",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f9e",
    "rightNeighborShelfId": "b6fa0"
  },
  {
    "id": "b6fa0",
    "name": "b6fa0",
    "x": 12.658,
    "y": 13.999,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99896,
      "w": 0.045607
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 51
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546334",
        "height": 0.1504,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e3d9",
            "leftCorner": {
              "x": 12.643,
              "y": 13.948,
              "z": 0.123
            },
            "rightCorner": {
              "x": 12.435,
              "y": 13.967,
              "z": 0.123
            },
            "gtin": "4063367321184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3da",
            "leftCorner": {
              "x": 12.435,
              "y": 13.967,
              "z": 0.123
            },
            "rightCorner": {
              "x": 12.227,
              "y": 13.986,
              "z": 0.123
            },
            "gtin": "4063367321184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3db",
            "leftCorner": {
              "x": 12.226,
              "y": 13.979,
              "z": 0.123
            },
            "rightCorner": {
              "x": 12.123,
              "y": 13.989,
              "z": 0.123
            },
            "gtin": "4006424956332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3dc",
            "leftCorner": {
              "x": 12.123,
              "y": 13.989,
              "z": 0.123
            },
            "rightCorner": {
              "x": 12.018,
              "y": 13.999,
              "z": 0.123
            },
            "gtin": "4006424956332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3dd",
            "leftCorner": {
              "x": 12.018,
              "y": 13.999,
              "z": 0.123
            },
            "rightCorner": {
              "x": 11.915,
              "y": 14.008,
              "z": 0.123
            },
            "gtin": "4006424956332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3de",
            "leftCorner": {
              "x": 11.915,
              "y": 14.008,
              "z": 0.123
            },
            "rightCorner": {
              "x": 11.811,
              "y": 14.017,
              "z": 0.123
            },
            "gtin": "4006424956332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3df",
            "leftCorner": {
              "x": 11.811,
              "y": 14.013,
              "z": 0.123
            },
            "rightCorner": {
              "x": 11.69,
              "y": 14.023,
              "z": 0.123
            },
            "gtin": "4063367321207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3e0",
            "leftCorner": {
              "x": 11.691,
              "y": 14.029,
              "z": 0.123
            },
            "rightCorner": {
              "x": 11.543,
              "y": 14.042,
              "z": 0.123
            },
            "gtin": "4006424966560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3e1",
            "leftCorner": {
              "x": 11.544,
              "y": 14.054,
              "z": 0.123
            },
            "rightCorner": {
              "x": 11.447,
              "y": 14.063,
              "z": 0.123
            },
            "gtin": "4063367321238",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546331",
        "height": 0.6017,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e4ac",
            "leftCorner": {
              "x": 12.656,
              "y": 13.978,
              "z": 0.492
            },
            "rightCorner": {
              "x": 12.584,
              "y": 13.984,
              "z": 0.492
            },
            "gtin": "4337185875083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4ad",
            "leftCorner": {
              "x": 12.584,
              "y": 13.984,
              "z": 0.492
            },
            "rightCorner": {
              "x": 12.511,
              "y": 13.992,
              "z": 0.492
            },
            "gtin": "4337185875083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4af",
            "leftCorner": {
              "x": 12.508,
              "y": 13.949,
              "z": 0.492
            },
            "rightCorner": {
              "x": 12.456,
              "y": 13.954,
              "z": 0.492
            },
            "gtin": "4337185875830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4b0",
            "leftCorner": {
              "x": 12.456,
              "y": 13.954,
              "z": 0.492
            },
            "rightCorner": {
              "x": 12.404,
              "y": 13.958,
              "z": 0.492
            },
            "gtin": "4337185875830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4b1",
            "leftCorner": {
              "x": 12.404,
              "y": 13.958,
              "z": 0.492
            },
            "rightCorner": {
              "x": 12.353,
              "y": 13.962,
              "z": 0.492
            },
            "gtin": "4337185875830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4b2",
            "leftCorner": {
              "x": 12.353,
              "y": 13.963,
              "z": 0.492
            },
            "rightCorner": {
              "x": 12.23,
              "y": 13.974,
              "z": 0.492
            },
            "gtin": "4337185875786",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4b3",
            "leftCorner": {
              "x": 12.231,
              "y": 13.985,
              "z": 0.492
            },
            "rightCorner": {
              "x": 12.165,
              "y": 13.992,
              "z": 0.492
            },
            "gtin": "4063367399886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4b4",
            "leftCorner": {
              "x": 12.165,
              "y": 13.992,
              "z": 0.492
            },
            "rightCorner": {
              "x": 12.099,
              "y": 13.998,
              "z": 0.492
            },
            "gtin": "4063367399886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4b5",
            "leftCorner": {
              "x": 12.099,
              "y": 13.99,
              "z": 0.492
            },
            "rightCorner": {
              "x": 11.932,
              "y": 14.005,
              "z": 0.492
            },
            "gtin": "4063367179082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4b6",
            "leftCorner": {
              "x": 11.932,
              "y": 14.005,
              "z": 0.492
            },
            "rightCorner": {
              "x": 11.841,
              "y": 14.013,
              "z": 0.492
            },
            "gtin": "4006424664565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4b7",
            "leftCorner": {
              "x": 11.841,
              "y": 14.013,
              "z": 0.492
            },
            "rightCorner": {
              "x": 11.749,
              "y": 14.022,
              "z": 0.492
            },
            "gtin": "4006424664565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4b8",
            "leftCorner": {
              "x": 11.749,
              "y": 14.016,
              "z": 0.492
            },
            "rightCorner": {
              "x": 11.568,
              "y": 14.032,
              "z": 0.492
            },
            "gtin": "4006424664572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4ae",
            "leftCorner": {
              "x": 11.568,
              "y": 14.044,
              "z": 0.492
            },
            "rightCorner": {
              "x": 11.459,
              "y": 14.054,
              "z": 0.492
            },
            "gtin": "4006424664558",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546332",
        "height": 1.0031,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e361",
            "leftCorner": {
              "x": 12.637,
              "y": 13.949,
              "z": 0.821
            },
            "rightCorner": {
              "x": 12.512,
              "y": 13.962,
              "z": 0.821
            },
            "gtin": "3045320092141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e362",
            "leftCorner": {
              "x": 12.512,
              "y": 13.962,
              "z": 0.821
            },
            "rightCorner": {
              "x": 12.309,
              "y": 13.979,
              "z": 0.821
            },
            "gtin": "3045320090062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e363",
            "leftCorner": {
              "x": 12.309,
              "y": 13.982,
              "z": 0.821
            },
            "rightCorner": {
              "x": 12.233,
              "y": 13.99,
              "z": 0.821
            },
            "gtin": "3045320090079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e364",
            "leftCorner": {
              "x": 12.233,
              "y": 13.99,
              "z": 0.821
            },
            "rightCorner": {
              "x": 12.158,
              "y": 13.996,
              "z": 0.821
            },
            "gtin": "3045320090079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e365",
            "leftCorner": {
              "x": 12.158,
              "y": 13.994,
              "z": 0.821
            },
            "rightCorner": {
              "x": 12.061,
              "y": 14.003,
              "z": 0.821
            },
            "gtin": "3045320090055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e366",
            "leftCorner": {
              "x": 12.061,
              "y": 14.003,
              "z": 0.821
            },
            "rightCorner": {
              "x": 11.964,
              "y": 14.013,
              "z": 0.821
            },
            "gtin": "3045320090055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e367",
            "leftCorner": {
              "x": 11.964,
              "y": 14.016,
              "z": 0.821
            },
            "rightCorner": {
              "x": 11.794,
              "y": 14.031,
              "z": 0.821
            },
            "gtin": "3045320090024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e368",
            "leftCorner": {
              "x": 11.792,
              "y": 14.023,
              "z": 0.821
            },
            "rightCorner": {
              "x": 11.568,
              "y": 14.043,
              "z": 0.821
            },
            "gtin": "3045320092073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e369",
            "leftCorner": {
              "x": 11.568,
              "y": 14.042,
              "z": 0.821
            },
            "rightCorner": {
              "x": 11.466,
              "y": 14.052,
              "z": 0.821
            },
            "gtin": "3608580069096",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546333",
        "height": 1.3662,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e4b9",
            "leftCorner": {
              "x": 12.657,
              "y": 13.983,
              "z": 1.118
            },
            "rightCorner": {
              "x": 12.484,
              "y": 13.999,
              "z": 1.118
            },
            "gtin": "3045320092066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4bb",
            "leftCorner": {
              "x": 12.48,
              "y": 13.962,
              "z": 1.118
            },
            "rightCorner": {
              "x": 12.379,
              "y": 13.971,
              "z": 1.118
            },
            "gtin": "3045320092080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4bc",
            "leftCorner": {
              "x": 12.379,
              "y": 13.971,
              "z": 1.118
            },
            "rightCorner": {
              "x": 12.279,
              "y": 13.98,
              "z": 1.118
            },
            "gtin": "3045320092080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4bd",
            "leftCorner": {
              "x": 12.277,
              "y": 13.976,
              "z": 1.118
            },
            "rightCorner": {
              "x": 12.125,
              "y": 13.989,
              "z": 1.118
            },
            "gtin": "3045320090048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4be",
            "leftCorner": {
              "x": 12.125,
              "y": 13.995,
              "z": 1.118
            },
            "rightCorner": {
              "x": 11.95,
              "y": 14.012,
              "z": 1.118
            },
            "gtin": "3608580000785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4bf",
            "leftCorner": {
              "x": 11.95,
              "y": 14.011,
              "z": 1.118
            },
            "rightCorner": {
              "x": 11.789,
              "y": 14.025,
              "z": 1.118
            },
            "gtin": "3608580706410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4c0",
            "leftCorner": {
              "x": 11.789,
              "y": 14.025,
              "z": 1.118
            },
            "rightCorner": {
              "x": 11.626,
              "y": 14.04,
              "z": 1.118
            },
            "gtin": "3608580706410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4c1",
            "leftCorner": {
              "x": 11.626,
              "y": 14.037,
              "z": 1.118
            },
            "rightCorner": {
              "x": 11.44,
              "y": 14.054,
              "z": 1.118
            },
            "gtin": "3045320098051",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546330",
        "height": 1.7116,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e477",
            "leftCorner": {
              "x": 12.657,
              "y": 13.986,
              "z": 1.4
            },
            "rightCorner": {
              "x": 12.586,
              "y": 13.992,
              "z": 1.4
            },
            "gtin": "80242376",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e478",
            "leftCorner": {
              "x": 12.586,
              "y": 13.992,
              "z": 1.4
            },
            "rightCorner": {
              "x": 12.515,
              "y": 13.998,
              "z": 1.4
            },
            "gtin": "80242376",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e47b",
            "leftCorner": {
              "x": 12.511,
              "y": 13.958,
              "z": 1.4
            },
            "rightCorner": {
              "x": 12.432,
              "y": 13.964,
              "z": 1.4
            },
            "gtin": "80298311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e47c",
            "leftCorner": {
              "x": 12.432,
              "y": 13.964,
              "z": 1.4
            },
            "rightCorner": {
              "x": 12.354,
              "y": 13.972,
              "z": 1.4
            },
            "gtin": "80298311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e47d",
            "leftCorner": {
              "x": 12.355,
              "y": 13.978,
              "z": 1.4
            },
            "rightCorner": {
              "x": 12.186,
              "y": 13.993,
              "z": 1.4
            },
            "gtin": "80298403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e47e",
            "leftCorner": {
              "x": 12.188,
              "y": 14.007,
              "z": 1.4
            },
            "rightCorner": {
              "x": 12.01,
              "y": 14.023,
              "z": 1.4
            },
            "gtin": "80298342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e47f",
            "leftCorner": {
              "x": 12.009,
              "y": 14.004,
              "z": 1.4
            },
            "rightCorner": {
              "x": 11.916,
              "y": 14.013,
              "z": 1.4
            },
            "gtin": "80298359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e480",
            "leftCorner": {
              "x": 11.916,
              "y": 14.013,
              "z": 1.4
            },
            "rightCorner": {
              "x": 11.824,
              "y": 14.022,
              "z": 1.4
            },
            "gtin": "80298359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e481",
            "leftCorner": {
              "x": 11.825,
              "y": 14.027,
              "z": 1.4
            },
            "rightCorner": {
              "x": 11.674,
              "y": 14.041,
              "z": 1.4
            },
            "gtin": "5016935000126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e482",
            "leftCorner": {
              "x": 11.674,
              "y": 14.039,
              "z": 1.4
            },
            "rightCorner": {
              "x": 11.61,
              "y": 14.045,
              "z": 1.4
            },
            "gtin": "5016935000065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e483",
            "leftCorner": {
              "x": 11.61,
              "y": 14.045,
              "z": 1.4
            },
            "rightCorner": {
              "x": 11.545,
              "y": 14.051,
              "z": 1.4
            },
            "gtin": "5016935000065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e484",
            "leftCorner": {
              "x": 11.545,
              "y": 14.05,
              "z": 1.4
            },
            "rightCorner": {
              "x": 11.434,
              "y": 14.06,
              "z": 1.4
            },
            "gtin": "5016935000102",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f9f",
    "rightNeighborShelfId": "b6fa1"
  },
  {
    "id": "b6fa1",
    "name": "b6fa1",
    "x": 11.463,
    "y": 14.108,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99896,
      "w": 0.045607
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 59
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546340",
        "height": 0.15648,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e3e2",
            "leftCorner": {
              "x": 11.446,
              "y": 14.053,
              "z": 0.128
            },
            "rightCorner": {
              "x": 11.367,
              "y": 14.06,
              "z": 0.128
            },
            "gtin": "3859893692482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3e3",
            "leftCorner": {
              "x": 11.367,
              "y": 14.06,
              "z": 0.128
            },
            "rightCorner": {
              "x": 11.288,
              "y": 14.067,
              "z": 0.128
            },
            "gtin": "3859893692482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3e4",
            "leftCorner": {
              "x": 11.287,
              "y": 14.058,
              "z": 0.128
            },
            "rightCorner": {
              "x": 11.202,
              "y": 14.066,
              "z": 0.128
            },
            "gtin": "3859893692420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3e5",
            "leftCorner": {
              "x": 11.202,
              "y": 14.066,
              "z": 0.128
            },
            "rightCorner": {
              "x": 11.118,
              "y": 14.074,
              "z": 0.128
            },
            "gtin": "3859893692420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3e6",
            "leftCorner": {
              "x": 11.118,
              "y": 14.074,
              "z": 0.128
            },
            "rightCorner": {
              "x": 11.034,
              "y": 14.081,
              "z": 0.128
            },
            "gtin": "3859893692420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3e7",
            "leftCorner": {
              "x": 11.035,
              "y": 14.102,
              "z": 0.128
            },
            "rightCorner": {
              "x": 10.924,
              "y": 14.112,
              "z": 0.128
            },
            "gtin": "4337185928260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3e8",
            "leftCorner": {
              "x": 10.924,
              "y": 14.112,
              "z": 0.128
            },
            "rightCorner": {
              "x": 10.811,
              "y": 14.123,
              "z": 0.128
            },
            "gtin": "4337185928260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3e9",
            "leftCorner": {
              "x": 10.811,
              "y": 14.123,
              "z": 0.128
            },
            "rightCorner": {
              "x": 10.7,
              "y": 14.133,
              "z": 0.128
            },
            "gtin": "4337185928260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3ea",
            "leftCorner": {
              "x": 10.699,
              "y": 14.13,
              "z": 0.128
            },
            "rightCorner": {
              "x": 10.599,
              "y": 14.139,
              "z": 0.128
            },
            "gtin": "3859893692871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3eb",
            "leftCorner": {
              "x": 10.599,
              "y": 14.139,
              "z": 0.128
            },
            "rightCorner": {
              "x": 10.499,
              "y": 14.149,
              "z": 0.128
            },
            "gtin": "3859893692871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3ec",
            "leftCorner": {
              "x": 10.499,
              "y": 14.149,
              "z": 0.128
            },
            "rightCorner": {
              "x": 10.398,
              "y": 14.158,
              "z": 0.128
            },
            "gtin": "3859893692871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3ed",
            "leftCorner": {
              "x": 10.398,
              "y": 14.153,
              "z": 0.128
            },
            "rightCorner": {
              "x": 10.324,
              "y": 14.159,
              "z": 0.128
            },
            "gtin": "4006424666866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3ee",
            "leftCorner": {
              "x": 10.324,
              "y": 14.159,
              "z": 0.128
            },
            "rightCorner": {
              "x": 10.251,
              "y": 14.166,
              "z": 0.128
            },
            "gtin": "4006424666866",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54633d",
        "height": 0.61304,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e587",
            "leftCorner": {
              "x": 11.462,
              "y": 14.093,
              "z": 0.502
            },
            "rightCorner": {
              "x": 11.321,
              "y": 14.105,
              "z": 0.502
            },
            "gtin": "5098732012656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e589",
            "leftCorner": {
              "x": 11.318,
              "y": 14.066,
              "z": 0.502
            },
            "rightCorner": {
              "x": 11.152,
              "y": 14.081,
              "z": 0.502
            },
            "gtin": "5098732004842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e58a",
            "leftCorner": {
              "x": 11.152,
              "y": 14.081,
              "z": 0.502
            },
            "rightCorner": {
              "x": 11.017,
              "y": 14.093,
              "z": 0.502
            },
            "gtin": "5098732012670",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e58b",
            "leftCorner": {
              "x": 11.015,
              "y": 14.085,
              "z": 0.502
            },
            "rightCorner": {
              "x": 10.825,
              "y": 14.103,
              "z": 0.502
            },
            "gtin": "4002575475104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e58c",
            "leftCorner": {
              "x": 10.825,
              "y": 14.103,
              "z": 0.502
            },
            "rightCorner": {
              "x": 10.634,
              "y": 14.12,
              "z": 0.502
            },
            "gtin": "4002575475104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e58d",
            "leftCorner": {
              "x": 10.636,
              "y": 14.138,
              "z": 0.502
            },
            "rightCorner": {
              "x": 10.497,
              "y": 14.151,
              "z": 0.502
            },
            "gtin": "4002575631401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e58e",
            "leftCorner": {
              "x": 10.496,
              "y": 14.147,
              "z": 0.502
            },
            "rightCorner": {
              "x": 10.37,
              "y": 14.158,
              "z": 0.502
            },
            "gtin": "4002575631425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e58f",
            "leftCorner": {
              "x": 10.371,
              "y": 14.161,
              "z": 0.502
            },
            "rightCorner": {
              "x": 10.285,
              "y": 14.169,
              "z": 0.502
            },
            "gtin": "4002575631371",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54633c",
        "height": 1.0116,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e36a",
            "leftCorner": {
              "x": 11.467,
              "y": 14.067,
              "z": 0.828
            },
            "rightCorner": {
              "x": 11.406,
              "y": 14.072,
              "z": 0.828
            },
            "gtin": "5098732012663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e36b",
            "leftCorner": {
              "x": 11.406,
              "y": 14.072,
              "z": 0.828
            },
            "rightCorner": {
              "x": 11.345,
              "y": 14.078,
              "z": 0.828
            },
            "gtin": "5098732012663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e36c",
            "leftCorner": {
              "x": 11.343,
              "y": 14.063,
              "z": 0.828
            },
            "rightCorner": {
              "x": 11.187,
              "y": 14.077,
              "z": 0.828
            },
            "gtin": "5098732004811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e36d",
            "leftCorner": {
              "x": 11.189,
              "y": 14.087,
              "z": 0.828
            },
            "rightCorner": {
              "x": 11.117,
              "y": 14.094,
              "z": 0.828
            },
            "gtin": "4260137741603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e36e",
            "leftCorner": {
              "x": 11.117,
              "y": 14.094,
              "z": 0.828
            },
            "rightCorner": {
              "x": 11.046,
              "y": 14.1,
              "z": 0.828
            },
            "gtin": "4260137741603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e36f",
            "leftCorner": {
              "x": 11.046,
              "y": 14.1,
              "z": 0.828
            },
            "rightCorner": {
              "x": 11.004,
              "y": 14.103,
              "z": 0.828
            },
            "gtin": "4260137741535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e370",
            "leftCorner": {
              "x": 11.004,
              "y": 14.103,
              "z": 0.828
            },
            "rightCorner": {
              "x": 10.963,
              "y": 14.108,
              "z": 0.828
            },
            "gtin": "4260137741535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e371",
            "leftCorner": {
              "x": 10.963,
              "y": 14.108,
              "z": 0.828
            },
            "rightCorner": {
              "x": 10.921,
              "y": 14.112,
              "z": 0.828
            },
            "gtin": "4260137741535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e372",
            "leftCorner": {
              "x": 10.921,
              "y": 14.118,
              "z": 0.828
            },
            "rightCorner": {
              "x": 10.862,
              "y": 14.123,
              "z": 0.828
            },
            "gtin": "4011800843113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e373",
            "leftCorner": {
              "x": 10.862,
              "y": 14.123,
              "z": 0.828
            },
            "rightCorner": {
              "x": 10.803,
              "y": 14.128,
              "z": 0.828
            },
            "gtin": "4011800843113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e374",
            "leftCorner": {
              "x": 10.803,
              "y": 14.129,
              "z": 0.828
            },
            "rightCorner": {
              "x": 10.628,
              "y": 14.145,
              "z": 0.828
            },
            "gtin": "4011800000240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e375",
            "leftCorner": {
              "x": 10.628,
              "y": 14.148,
              "z": 0.828
            },
            "rightCorner": {
              "x": 10.529,
              "y": 14.157,
              "z": 0.828
            },
            "gtin": "4011800000264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e376",
            "leftCorner": {
              "x": 10.529,
              "y": 14.157,
              "z": 0.828
            },
            "rightCorner": {
              "x": 10.43,
              "y": 14.166,
              "z": 0.828
            },
            "gtin": "4011800000264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e377",
            "leftCorner": {
              "x": 10.43,
              "y": 14.164,
              "z": 0.828
            },
            "rightCorner": {
              "x": 10.374,
              "y": 14.169,
              "z": 0.828
            },
            "gtin": "4011800843014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e378",
            "leftCorner": {
              "x": 10.374,
              "y": 14.169,
              "z": 0.828
            },
            "rightCorner": {
              "x": 10.319,
              "y": 14.174,
              "z": 0.828
            },
            "gtin": "4011800843014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e379",
            "leftCorner": {
              "x": 10.318,
              "y": 14.172,
              "z": 0.828
            },
            "rightCorner": {
              "x": 10.212,
              "y": 14.182,
              "z": 0.828
            },
            "gtin": "4011800843311",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54633e",
        "height": 1.3619,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e4c2",
            "leftCorner": {
              "x": 11.44,
              "y": 14.066,
              "z": 1.114
            },
            "rightCorner": {
              "x": 11.353,
              "y": 14.074,
              "z": 1.114
            },
            "gtin": "3608580069126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4c3",
            "leftCorner": {
              "x": 11.353,
              "y": 14.074,
              "z": 1.114
            },
            "rightCorner": {
              "x": 11.267,
              "y": 14.081,
              "z": 1.114
            },
            "gtin": "3608580069126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4c4",
            "leftCorner": {
              "x": 11.267,
              "y": 14.081,
              "z": 1.114
            },
            "rightCorner": {
              "x": 11.18,
              "y": 14.09,
              "z": 1.114
            },
            "gtin": "3608580069126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4c5",
            "leftCorner": {
              "x": 11.18,
              "y": 14.095,
              "z": 1.114
            },
            "rightCorner": {
              "x": 11.02,
              "y": 14.109,
              "z": 1.114
            },
            "gtin": "5701116215009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4c6",
            "leftCorner": {
              "x": 11.02,
              "y": 14.107,
              "z": 1.114
            },
            "rightCorner": {
              "x": 10.912,
              "y": 14.117,
              "z": 1.114
            },
            "gtin": "4000243108194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4c7",
            "leftCorner": {
              "x": 10.912,
              "y": 14.117,
              "z": 1.114
            },
            "rightCorner": {
              "x": 10.806,
              "y": 14.127,
              "z": 1.114
            },
            "gtin": "4000243108194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4c8",
            "leftCorner": {
              "x": 10.806,
              "y": 14.133,
              "z": 1.114
            },
            "rightCorner": {
              "x": 10.649,
              "y": 14.148,
              "z": 1.114
            },
            "gtin": "42388982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4c9",
            "leftCorner": {
              "x": 10.649,
              "y": 14.151,
              "z": 1.114
            },
            "rightCorner": {
              "x": 10.518,
              "y": 14.162,
              "z": 1.114
            },
            "gtin": "42388968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4ca",
            "leftCorner": {
              "x": 10.517,
              "y": 14.154,
              "z": 1.114
            },
            "rightCorner": {
              "x": 10.396,
              "y": 14.165,
              "z": 1.114
            },
            "gtin": "42388975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4cb",
            "leftCorner": {
              "x": 10.396,
              "y": 14.167,
              "z": 1.114
            },
            "rightCorner": {
              "x": 10.189,
              "y": 14.185,
              "z": 1.114
            },
            "gtin": "42388951",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54633f",
        "height": 1.7139,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e485",
            "leftCorner": {
              "x": 11.436,
              "y": 14.078,
              "z": 1.402
            },
            "rightCorner": {
              "x": 11.303,
              "y": 14.091,
              "z": 1.402
            },
            "gtin": "9001432002281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e486",
            "leftCorner": {
              "x": 11.303,
              "y": 14.093,
              "z": 1.402
            },
            "rightCorner": {
              "x": 11.137,
              "y": 14.108,
              "z": 1.402
            },
            "gtin": "9001432002205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e487",
            "leftCorner": {
              "x": 11.137,
              "y": 14.1,
              "z": 1.402
            },
            "rightCorner": {
              "x": 11.053,
              "y": 14.107,
              "z": 1.402
            },
            "gtin": "9001432002229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e488",
            "leftCorner": {
              "x": 11.053,
              "y": 14.107,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.968,
              "y": 14.115,
              "z": 1.402
            },
            "gtin": "9001432002229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e489",
            "leftCorner": {
              "x": 10.968,
              "y": 14.115,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.833,
              "y": 14.127,
              "z": 1.402
            },
            "gtin": "9001432039058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e48a",
            "leftCorner": {
              "x": 10.834,
              "y": 14.138,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.753,
              "y": 14.146,
              "z": 1.402
            },
            "gtin": "9001432002335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e48b",
            "leftCorner": {
              "x": 10.753,
              "y": 14.146,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.672,
              "y": 14.153,
              "z": 1.402
            },
            "gtin": "9001432002335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e48c",
            "leftCorner": {
              "x": 10.672,
              "y": 14.153,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.591,
              "y": 14.161,
              "z": 1.402
            },
            "gtin": "9001432002335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e48d",
            "leftCorner": {
              "x": 10.591,
              "y": 14.161,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.458,
              "y": 14.174,
              "z": 1.402
            },
            "gtin": "9001432002236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e48e",
            "leftCorner": {
              "x": 10.457,
              "y": 14.167,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.346,
              "y": 14.177,
              "z": 1.402
            },
            "gtin": "4002575618198",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e48f",
            "leftCorner": {
              "x": 10.345,
              "y": 14.169,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.294,
              "y": 14.174,
              "z": 1.402
            },
            "gtin": "3492390022651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e490",
            "leftCorner": {
              "x": 10.294,
              "y": 14.174,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.243,
              "y": 14.178,
              "z": 1.402
            },
            "gtin": "3492390022651",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6fa0",
    "rightNeighborShelfId": "b6fa2"
  },
  {
    "id": "b6fa2",
    "name": "b6fa2",
    "x": 10.268,
    "y": 14.218,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99896,
      "w": 0.045607
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 63
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546343",
        "height": 0.15687,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e3ef",
            "leftCorner": {
              "x": 10.25,
              "y": 14.157,
              "z": 0.128
            },
            "rightCorner": {
              "x": 10.11,
              "y": 14.17,
              "z": 0.128
            },
            "gtin": "3859893692383",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3f0",
            "leftCorner": {
              "x": 10.112,
              "y": 14.183,
              "z": 0.128
            },
            "rightCorner": {
              "x": 10.041,
              "y": 14.188,
              "z": 0.128
            },
            "gtin": "3859893692642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3f1",
            "leftCorner": {
              "x": 10.041,
              "y": 14.188,
              "z": 0.128
            },
            "rightCorner": {
              "x": 9.971,
              "y": 14.195,
              "z": 0.128
            },
            "gtin": "3859893692642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3f2",
            "leftCorner": {
              "x": 9.97,
              "y": 14.183,
              "z": 0.128
            },
            "rightCorner": {
              "x": 9.92,
              "y": 14.188,
              "z": 0.128
            },
            "gtin": "4063367438837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3f3",
            "leftCorner": {
              "x": 9.92,
              "y": 14.188,
              "z": 0.128
            },
            "rightCorner": {
              "x": 9.871,
              "y": 14.193,
              "z": 0.128
            },
            "gtin": "4063367438837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3f4",
            "leftCorner": {
              "x": 9.871,
              "y": 14.193,
              "z": 0.128
            },
            "rightCorner": {
              "x": 9.821,
              "y": 14.196,
              "z": 0.128
            },
            "gtin": "4063367438837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3f5",
            "leftCorner": {
              "x": 9.821,
              "y": 14.196,
              "z": 0.128
            },
            "rightCorner": {
              "x": 9.771,
              "y": 14.201,
              "z": 0.128
            },
            "gtin": "4063367438837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3f6",
            "leftCorner": {
              "x": 9.772,
              "y": 14.214,
              "z": 0.128
            },
            "rightCorner": {
              "x": 9.721,
              "y": 14.219,
              "z": 0.128
            },
            "gtin": "4006424966850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3f7",
            "leftCorner": {
              "x": 9.721,
              "y": 14.219,
              "z": 0.128
            },
            "rightCorner": {
              "x": 9.669,
              "y": 14.224,
              "z": 0.128
            },
            "gtin": "4006424966850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3f8",
            "leftCorner": {
              "x": 9.669,
              "y": 14.224,
              "z": 0.128
            },
            "rightCorner": {
              "x": 9.455,
              "y": 14.243,
              "z": 0.128
            },
            "gtin": "3859893692567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3f9",
            "leftCorner": {
              "x": 9.455,
              "y": 14.243,
              "z": 0.128
            },
            "rightCorner": {
              "x": 9.241,
              "y": 14.264,
              "z": 0.128
            },
            "gtin": "3859893692567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3fa",
            "leftCorner": {
              "x": 9.241,
              "y": 14.264,
              "z": 0.128
            },
            "rightCorner": {
              "x": 9.026,
              "y": 14.283,
              "z": 0.128
            },
            "gtin": "3859893692567",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546341",
        "height": 0.60503,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e590",
            "leftCorner": {
              "x": 10.283,
              "y": 14.153,
              "z": 0.495
            },
            "rightCorner": {
              "x": 10.04,
              "y": 14.175,
              "z": 0.495
            },
            "gtin": "4002575475142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e591",
            "leftCorner": {
              "x": 10.041,
              "y": 14.182,
              "z": 0.495
            },
            "rightCorner": {
              "x": 9.963,
              "y": 14.189,
              "z": 0.495
            },
            "gtin": "4002575475227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e592",
            "leftCorner": {
              "x": 9.963,
              "y": 14.189,
              "z": 0.495
            },
            "rightCorner": {
              "x": 9.885,
              "y": 14.196,
              "z": 0.495
            },
            "gtin": "4002575475227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e593",
            "leftCorner": {
              "x": 9.885,
              "y": 14.195,
              "z": 0.495
            },
            "rightCorner": {
              "x": 9.744,
              "y": 14.208,
              "z": 0.495
            },
            "gtin": "4002575311129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e594",
            "leftCorner": {
              "x": 9.744,
              "y": 14.208,
              "z": 0.495
            },
            "rightCorner": {
              "x": 9.603,
              "y": 14.221,
              "z": 0.495
            },
            "gtin": "4002575311129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e595",
            "leftCorner": {
              "x": 9.603,
              "y": 14.226,
              "z": 0.495
            },
            "rightCorner": {
              "x": 9.47,
              "y": 14.239,
              "z": 0.495
            },
            "gtin": "4002575475166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e596",
            "leftCorner": {
              "x": 9.47,
              "y": 14.239,
              "z": 0.495
            },
            "rightCorner": {
              "x": 9.336,
              "y": 14.251,
              "z": 0.495
            },
            "gtin": "4002575475166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e597",
            "leftCorner": {
              "x": 9.336,
              "y": 14.25,
              "z": 0.495
            },
            "rightCorner": {
              "x": 9.034,
              "y": 14.277,
              "z": 0.495
            },
            "gtin": "4002575311143",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546344",
        "height": 1.0087,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e37a",
            "leftCorner": {
              "x": 10.211,
              "y": 14.171,
              "z": 0.825
            },
            "rightCorner": {
              "x": 10.155,
              "y": 14.176,
              "z": 0.825
            },
            "gtin": "4011800843212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e37b",
            "leftCorner": {
              "x": 10.155,
              "y": 14.176,
              "z": 0.825
            },
            "rightCorner": {
              "x": 10.1,
              "y": 14.182,
              "z": 0.825
            },
            "gtin": "4011800843212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e37c",
            "leftCorner": {
              "x": 10.1,
              "y": 14.182,
              "z": 0.825
            },
            "rightCorner": {
              "x": 10.009,
              "y": 14.19,
              "z": 0.825
            },
            "gtin": "4011800844110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e37d",
            "leftCorner": {
              "x": 10.009,
              "y": 14.19,
              "z": 0.825
            },
            "rightCorner": {
              "x": 9.919,
              "y": 14.198,
              "z": 0.825
            },
            "gtin": "4011800844110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e37e",
            "leftCorner": {
              "x": 9.919,
              "y": 14.201,
              "z": 0.825
            },
            "rightCorner": {
              "x": 9.848,
              "y": 14.207,
              "z": 0.825
            },
            "gtin": "4011800844417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e37f",
            "leftCorner": {
              "x": 9.848,
              "y": 14.207,
              "z": 0.825
            },
            "rightCorner": {
              "x": 9.778,
              "y": 14.213,
              "z": 0.825
            },
            "gtin": "4011800844417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e380",
            "leftCorner": {
              "x": 9.779,
              "y": 14.22,
              "z": 0.825
            },
            "rightCorner": {
              "x": 9.612,
              "y": 14.235,
              "z": 0.825
            },
            "gtin": "4011800844714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e381",
            "leftCorner": {
              "x": 9.612,
              "y": 14.236,
              "z": 0.825
            },
            "rightCorner": {
              "x": 9.531,
              "y": 14.243,
              "z": 0.825
            },
            "gtin": "4011800844011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e382",
            "leftCorner": {
              "x": 9.531,
              "y": 14.243,
              "z": 0.825
            },
            "rightCorner": {
              "x": 9.449,
              "y": 14.251,
              "z": 0.825
            },
            "gtin": "4011800844011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e383",
            "leftCorner": {
              "x": 9.449,
              "y": 14.249,
              "z": 0.825
            },
            "rightCorner": {
              "x": 9.391,
              "y": 14.254,
              "z": 0.825
            },
            "gtin": "4011800848019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e384",
            "leftCorner": {
              "x": 9.391,
              "y": 14.254,
              "z": 0.825
            },
            "rightCorner": {
              "x": 9.333,
              "y": 14.26,
              "z": 0.825
            },
            "gtin": "4011800848019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e385",
            "leftCorner": {
              "x": 9.333,
              "y": 14.257,
              "z": 0.825
            },
            "rightCorner": {
              "x": 9.256,
              "y": 14.264,
              "z": 0.825
            },
            "gtin": "4011800841812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e386",
            "leftCorner": {
              "x": 9.256,
              "y": 14.264,
              "z": 0.825
            },
            "rightCorner": {
              "x": 9.179,
              "y": 14.272,
              "z": 0.825
            },
            "gtin": "4011800841812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e387",
            "leftCorner": {
              "x": 9.179,
              "y": 14.281,
              "z": 0.825
            },
            "rightCorner": {
              "x": 9.039,
              "y": 14.293,
              "z": 0.825
            },
            "gtin": "4011800841218",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546345",
        "height": 1.3672,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e4cc",
            "leftCorner": {
              "x": 10.188,
              "y": 14.175,
              "z": 1.119
            },
            "rightCorner": {
              "x": 10.091,
              "y": 14.185,
              "z": 1.119
            },
            "gtin": "4011800200022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4cd",
            "leftCorner": {
              "x": 10.091,
              "y": 14.19,
              "z": 1.119
            },
            "rightCorner": {
              "x": 10.005,
              "y": 14.198,
              "z": 1.119
            },
            "gtin": "4011800201029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4ce",
            "leftCorner": {
              "x": 10.005,
              "y": 14.198,
              "z": 1.119
            },
            "rightCorner": {
              "x": 9.919,
              "y": 14.206,
              "z": 1.119
            },
            "gtin": "4011800201029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4cf",
            "leftCorner": {
              "x": 9.919,
              "y": 14.204,
              "z": 1.119
            },
            "rightCorner": {
              "x": 9.799,
              "y": 14.214,
              "z": 1.119
            },
            "gtin": "4011800202026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4d0",
            "leftCorner": {
              "x": 9.798,
              "y": 14.211,
              "z": 1.119
            },
            "rightCorner": {
              "x": 9.688,
              "y": 14.221,
              "z": 1.119
            },
            "gtin": "4011800200220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4d1",
            "leftCorner": {
              "x": 9.69,
              "y": 14.246,
              "z": 1.119
            },
            "rightCorner": {
              "x": 9.615,
              "y": 14.253,
              "z": 1.119
            },
            "gtin": "4011800203023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4d2",
            "leftCorner": {
              "x": 9.615,
              "y": 14.253,
              "z": 1.119
            },
            "rightCorner": {
              "x": 9.54,
              "y": 14.26,
              "z": 1.119
            },
            "gtin": "4011800203023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4d3",
            "leftCorner": {
              "x": 9.538,
              "y": 14.239,
              "z": 1.119
            },
            "rightCorner": {
              "x": 9.459,
              "y": 14.247,
              "z": 1.119
            },
            "gtin": "4011800212018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4d4",
            "leftCorner": {
              "x": 9.459,
              "y": 14.247,
              "z": 1.119
            },
            "rightCorner": {
              "x": 9.379,
              "y": 14.254,
              "z": 1.119
            },
            "gtin": "4011800212018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4d5",
            "leftCorner": {
              "x": 9.38,
              "y": 14.259,
              "z": 1.119
            },
            "rightCorner": {
              "x": 9.31,
              "y": 14.266,
              "z": 1.119
            },
            "gtin": "4011800001445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4d6",
            "leftCorner": {
              "x": 9.309,
              "y": 14.257,
              "z": 1.119
            },
            "rightCorner": {
              "x": 9.242,
              "y": 14.264,
              "z": 1.119
            },
            "gtin": "4011800228910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4d7",
            "leftCorner": {
              "x": 9.242,
              "y": 14.264,
              "z": 1.119
            },
            "rightCorner": {
              "x": 9.175,
              "y": 14.269,
              "z": 1.119
            },
            "gtin": "4011800228910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4d8",
            "leftCorner": {
              "x": 9.174,
              "y": 14.264,
              "z": 1.119
            },
            "rightCorner": {
              "x": 9.071,
              "y": 14.273,
              "z": 1.119
            },
            "gtin": "4011800220020",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546342",
        "height": 1.7102,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e491",
            "leftCorner": {
              "x": 10.243,
              "y": 14.173,
              "z": 1.399
            },
            "rightCorner": {
              "x": 10.182,
              "y": 14.179,
              "z": 1.399
            },
            "gtin": "9001432050060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e492",
            "leftCorner": {
              "x": 10.182,
              "y": 14.179,
              "z": 1.399
            },
            "rightCorner": {
              "x": 10.122,
              "y": 14.185,
              "z": 1.399
            },
            "gtin": "9001432050060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e493",
            "leftCorner": {
              "x": 10.122,
              "y": 14.185,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.988,
              "y": 14.197,
              "z": 1.399
            },
            "gtin": "9001432050077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e494",
            "leftCorner": {
              "x": 9.988,
              "y": 14.202,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.908,
              "y": 14.21,
              "z": 1.399
            },
            "gtin": "9001432050053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e495",
            "leftCorner": {
              "x": 9.908,
              "y": 14.21,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.828,
              "y": 14.217,
              "z": 1.399
            },
            "gtin": "9001432050053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e496",
            "leftCorner": {
              "x": 9.827,
              "y": 14.213,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.749,
              "y": 14.219,
              "z": 1.399
            },
            "gtin": "9001432050084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e497",
            "leftCorner": {
              "x": 9.75,
              "y": 14.221,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.686,
              "y": 14.227,
              "z": 1.399
            },
            "gtin": "9001432048418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e498",
            "leftCorner": {
              "x": 9.686,
              "y": 14.227,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.622,
              "y": 14.232,
              "z": 1.399
            },
            "gtin": "9001432048418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e499",
            "leftCorner": {
              "x": 9.622,
              "y": 14.235,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.557,
              "y": 14.241,
              "z": 1.399
            },
            "gtin": "4011800189129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e49a",
            "leftCorner": {
              "x": 9.557,
              "y": 14.241,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.493,
              "y": 14.248,
              "z": 1.399
            },
            "gtin": "4011800189129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e49b",
            "leftCorner": {
              "x": 9.493,
              "y": 14.248,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.428,
              "y": 14.253,
              "z": 1.399
            },
            "gtin": "4011800189129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e49c",
            "leftCorner": {
              "x": 9.428,
              "y": 14.253,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.363,
              "y": 14.259,
              "z": 1.399
            },
            "gtin": "4011800189129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e49d",
            "leftCorner": {
              "x": 9.364,
              "y": 14.263,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.289,
              "y": 14.27,
              "z": 1.399
            },
            "gtin": "4011800177416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e49e",
            "leftCorner": {
              "x": 9.289,
              "y": 14.27,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.214,
              "y": 14.276,
              "z": 1.399
            },
            "gtin": "4011800177416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e49f",
            "leftCorner": {
              "x": 9.214,
              "y": 14.276,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.14,
              "y": 14.283,
              "z": 1.399
            },
            "gtin": "4011800177416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4a0",
            "leftCorner": {
              "x": 9.14,
              "y": 14.283,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.065,
              "y": 14.29,
              "z": 1.399
            },
            "gtin": "4011800177416",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6fa1",
    "rightNeighborShelfId": "b6fa3"
  },
  {
    "id": "b6fa3",
    "name": "b6fa3",
    "x": 9.073,
    "y": 14.327,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99896,
      "w": 0.045607
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 57
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54634a",
        "height": 0.15347,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e3fb",
            "leftCorner": {
              "x": 9.027,
              "y": 14.288,
              "z": 0.126
            },
            "rightCorner": {
              "x": 8.915,
              "y": 14.299,
              "z": 0.126
            },
            "gtin": "4002575629217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3fc",
            "leftCorner": {
              "x": 8.913,
              "y": 14.285,
              "z": 0.126
            },
            "rightCorner": {
              "x": 8.825,
              "y": 14.293,
              "z": 0.126
            },
            "gtin": "4002575629071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3fd",
            "leftCorner": {
              "x": 8.825,
              "y": 14.293,
              "z": 0.126
            },
            "rightCorner": {
              "x": 8.738,
              "y": 14.301,
              "z": 0.126
            },
            "gtin": "4002575629071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3fe",
            "leftCorner": {
              "x": 8.737,
              "y": 14.297,
              "z": 0.126
            },
            "rightCorner": {
              "x": 8.657,
              "y": 14.304,
              "z": 0.126
            },
            "gtin": "4002575629132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e3ff",
            "leftCorner": {
              "x": 8.657,
              "y": 14.304,
              "z": 0.126
            },
            "rightCorner": {
              "x": 8.576,
              "y": 14.312,
              "z": 0.126
            },
            "gtin": "4002575629132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e400",
            "leftCorner": {
              "x": 8.577,
              "y": 14.317,
              "z": 0.126
            },
            "rightCorner": {
              "x": 8.529,
              "y": 14.321,
              "z": 0.126
            },
            "gtin": "4002575629170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e401",
            "leftCorner": {
              "x": 8.529,
              "y": 14.321,
              "z": 0.126
            },
            "rightCorner": {
              "x": 8.48,
              "y": 14.325,
              "z": 0.126
            },
            "gtin": "4002575629170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e402",
            "leftCorner": {
              "x": 8.48,
              "y": 14.325,
              "z": 0.126
            },
            "rightCorner": {
              "x": 8.432,
              "y": 14.331,
              "z": 0.126
            },
            "gtin": "4002575629170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e403",
            "leftCorner": {
              "x": 8.433,
              "y": 14.338,
              "z": 0.126
            },
            "rightCorner": {
              "x": 8.36,
              "y": 14.345,
              "z": 0.126
            },
            "gtin": "4002575629118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e404",
            "leftCorner": {
              "x": 8.36,
              "y": 14.345,
              "z": 0.126
            },
            "rightCorner": {
              "x": 8.287,
              "y": 14.352,
              "z": 0.126
            },
            "gtin": "4002575629118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e405",
            "leftCorner": {
              "x": 8.288,
              "y": 14.36,
              "z": 0.126
            },
            "rightCorner": {
              "x": 8.217,
              "y": 14.367,
              "z": 0.126
            },
            "gtin": "4002575629231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e406",
            "leftCorner": {
              "x": 8.217,
              "y": 14.367,
              "z": 0.126
            },
            "rightCorner": {
              "x": 8.146,
              "y": 14.374,
              "z": 0.126
            },
            "gtin": "4002575629231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e394",
            "leftCorner": {
              "x": 8.145,
              "y": 14.36,
              "z": 0.126
            },
            "rightCorner": {
              "x": 7.873,
              "y": 14.386,
              "z": 0.126
            },
            "gtin": "4002575629057",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546348",
        "height": 0.61209,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e598",
            "leftCorner": {
              "x": 9.033,
              "y": 14.268,
              "z": 0.501
            },
            "rightCorner": {
              "x": 8.879,
              "y": 14.282,
              "z": 0.501
            },
            "gtin": "4011800841614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e599",
            "leftCorner": {
              "x": 8.879,
              "y": 14.288,
              "z": 0.501
            },
            "rightCorner": {
              "x": 8.76,
              "y": 14.298,
              "z": 0.501
            },
            "gtin": "4011800841713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e59a",
            "leftCorner": {
              "x": 8.759,
              "y": 14.287,
              "z": 0.501
            },
            "rightCorner": {
              "x": 8.585,
              "y": 14.303,
              "z": 0.501
            },
            "gtin": "4011800840617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e59b",
            "leftCorner": {
              "x": 8.585,
              "y": 14.309,
              "z": 0.501
            },
            "rightCorner": {
              "x": 8.523,
              "y": 14.314,
              "z": 0.501
            },
            "gtin": "4011800840518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e59c",
            "leftCorner": {
              "x": 8.523,
              "y": 14.314,
              "z": 0.501
            },
            "rightCorner": {
              "x": 8.461,
              "y": 14.32,
              "z": 0.501
            },
            "gtin": "4011800840518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e59d",
            "leftCorner": {
              "x": 8.461,
              "y": 14.32,
              "z": 0.501
            },
            "rightCorner": {
              "x": 8.298,
              "y": 14.335,
              "z": 0.501
            },
            "gtin": "4011800101619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e59e",
            "leftCorner": {
              "x": 8.298,
              "y": 14.34,
              "z": 0.501
            },
            "rightCorner": {
              "x": 8.202,
              "y": 14.348,
              "z": 0.501
            },
            "gtin": "4011800109615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e59f",
            "leftCorner": {
              "x": 8.202,
              "y": 14.348,
              "z": 0.501
            },
            "rightCorner": {
              "x": 8.106,
              "y": 14.357,
              "z": 0.501
            },
            "gtin": "4011800109615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e588",
            "leftCorner": {
              "x": 8.107,
              "y": 14.366,
              "z": 0.501
            },
            "rightCorner": {
              "x": 7.874,
              "y": 14.388,
              "z": 0.501
            },
            "gtin": "4011800803018",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546349",
        "height": 1.0077,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e388",
            "leftCorner": {
              "x": 9.038,
              "y": 14.281,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.872,
              "y": 14.297,
              "z": 0.824
            },
            "gtin": "4011800840211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e389",
            "leftCorner": {
              "x": 8.872,
              "y": 14.294,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.802,
              "y": 14.3,
              "z": 0.824
            },
            "gtin": "4011800840310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e38a",
            "leftCorner": {
              "x": 8.802,
              "y": 14.3,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.732,
              "y": 14.307,
              "z": 0.824
            },
            "gtin": "4011800840310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e38b",
            "leftCorner": {
              "x": 8.731,
              "y": 14.301,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.634,
              "y": 14.311,
              "z": 0.824
            },
            "gtin": "4011800841010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e38c",
            "leftCorner": {
              "x": 8.634,
              "y": 14.311,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.537,
              "y": 14.319,
              "z": 0.824
            },
            "gtin": "4011800841010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e38d",
            "leftCorner": {
              "x": 8.538,
              "y": 14.329,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.497,
              "y": 14.333,
              "z": 0.824
            },
            "gtin": "4011800840914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e38e",
            "leftCorner": {
              "x": 8.497,
              "y": 14.333,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.456,
              "y": 14.337,
              "z": 0.824
            },
            "gtin": "4011800840914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e38f",
            "leftCorner": {
              "x": 8.456,
              "y": 14.337,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.415,
              "y": 14.341,
              "z": 0.824
            },
            "gtin": "4011800840914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e390",
            "leftCorner": {
              "x": 8.416,
              "y": 14.344,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.322,
              "y": 14.352,
              "z": 0.824
            },
            "gtin": "4011800841515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e391",
            "leftCorner": {
              "x": 8.322,
              "y": 14.352,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.228,
              "y": 14.361,
              "z": 0.824
            },
            "gtin": "4011800841515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e313",
            "leftCorner": {
              "x": 8.228,
              "y": 14.359,
              "z": 0.824
            },
            "rightCorner": {
              "x": 8.051,
              "y": 14.375,
              "z": 0.824
            },
            "gtin": "4011800841416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e314",
            "leftCorner": {
              "x": 8.051,
              "y": 14.375,
              "z": 0.824
            },
            "rightCorner": {
              "x": 7.874,
              "y": 14.391,
              "z": 0.824
            },
            "gtin": "4011800841416",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546347",
        "height": 1.3588,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e4d9",
            "leftCorner": {
              "x": 9.071,
              "y": 14.274,
              "z": 1.112
            },
            "rightCorner": {
              "x": 8.96,
              "y": 14.285,
              "z": 1.112
            },
            "gtin": "4011800840112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4da",
            "leftCorner": {
              "x": 8.96,
              "y": 14.285,
              "z": 1.112
            },
            "rightCorner": {
              "x": 8.849,
              "y": 14.295,
              "z": 1.112
            },
            "gtin": "4011800840112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4db",
            "leftCorner": {
              "x": 8.849,
              "y": 14.295,
              "z": 1.112
            },
            "rightCorner": {
              "x": 8.735,
              "y": 14.306,
              "z": 1.112
            },
            "gtin": "4011800176310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4dc",
            "leftCorner": {
              "x": 8.735,
              "y": 14.304,
              "z": 1.112
            },
            "rightCorner": {
              "x": 8.622,
              "y": 14.315,
              "z": 1.112
            },
            "gtin": "4011800176419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4dd",
            "leftCorner": {
              "x": 8.622,
              "y": 14.317,
              "z": 1.112
            },
            "rightCorner": {
              "x": 8.441,
              "y": 14.333,
              "z": 1.112
            },
            "gtin": "4011800176914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4de",
            "leftCorner": {
              "x": 8.442,
              "y": 14.345,
              "z": 1.112
            },
            "rightCorner": {
              "x": 8.36,
              "y": 14.353,
              "z": 1.112
            },
            "gtin": "4011800176211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4df",
            "leftCorner": {
              "x": 8.36,
              "y": 14.349,
              "z": 1.112
            },
            "rightCorner": {
              "x": 8.308,
              "y": 14.353,
              "z": 1.112
            },
            "gtin": "4011800176815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4e0",
            "leftCorner": {
              "x": 8.308,
              "y": 14.353,
              "z": 1.112
            },
            "rightCorner": {
              "x": 8.257,
              "y": 14.358,
              "z": 1.112
            },
            "gtin": "4011800176815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4e1",
            "leftCorner": {
              "x": 8.257,
              "y": 14.358,
              "z": 1.112
            },
            "rightCorner": {
              "x": 8.205,
              "y": 14.362,
              "z": 1.112
            },
            "gtin": "4011800176815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4ba",
            "leftCorner": {
              "x": 8.205,
              "y": 14.357,
              "z": 1.112
            },
            "rightCorner": {
              "x": 7.873,
              "y": 14.387,
              "z": 1.112
            },
            "gtin": "4011800176112",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546346",
        "height": 1.7103,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e4a1",
            "leftCorner": {
              "x": 9.064,
              "y": 14.28,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.016,
              "y": 14.285,
              "z": 1.399
            },
            "gtin": "4011800177911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4a2",
            "leftCorner": {
              "x": 9.016,
              "y": 14.285,
              "z": 1.399
            },
            "rightCorner": {
              "x": 8.967,
              "y": 14.289,
              "z": 1.399
            },
            "gtin": "4011800177911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4a3",
            "leftCorner": {
              "x": 8.967,
              "y": 14.289,
              "z": 1.399
            },
            "rightCorner": {
              "x": 8.918,
              "y": 14.293,
              "z": 1.399
            },
            "gtin": "4011800177911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4a4",
            "leftCorner": {
              "x": 8.918,
              "y": 14.293,
              "z": 1.399
            },
            "rightCorner": {
              "x": 8.722,
              "y": 14.311,
              "z": 1.399
            },
            "gtin": "4011800177317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4a5",
            "leftCorner": {
              "x": 8.721,
              "y": 14.308,
              "z": 1.399
            },
            "rightCorner": {
              "x": 8.589,
              "y": 14.32,
              "z": 1.399
            },
            "gtin": "4011800176716",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4a6",
            "leftCorner": {
              "x": 8.588,
              "y": 14.318,
              "z": 1.399
            },
            "rightCorner": {
              "x": 8.466,
              "y": 14.329,
              "z": 1.399
            },
            "gtin": "4011800178819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4a7",
            "leftCorner": {
              "x": 8.467,
              "y": 14.348,
              "z": 1.399
            },
            "rightCorner": {
              "x": 8.401,
              "y": 14.354,
              "z": 1.399
            },
            "gtin": "4011800177010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4a8",
            "leftCorner": {
              "x": 8.401,
              "y": 14.348,
              "z": 1.399
            },
            "rightCorner": {
              "x": 8.32,
              "y": 14.355,
              "z": 1.399
            },
            "gtin": "4011800174316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4a9",
            "leftCorner": {
              "x": 8.32,
              "y": 14.355,
              "z": 1.399
            },
            "rightCorner": {
              "x": 8.24,
              "y": 14.363,
              "z": 1.399
            },
            "gtin": "4011800174316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4aa",
            "leftCorner": {
              "x": 8.24,
              "y": 14.36,
              "z": 1.399
            },
            "rightCorner": {
              "x": 8.149,
              "y": 14.368,
              "z": 1.399
            },
            "gtin": "4011800174415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e4ab",
            "leftCorner": {
              "x": 8.149,
              "y": 14.368,
              "z": 1.399
            },
            "rightCorner": {
              "x": 8.059,
              "y": 14.376,
              "z": 1.399
            },
            "gtin": "4011800174415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e479",
            "leftCorner": {
              "x": 8.06,
              "y": 14.386,
              "z": 1.399
            },
            "rightCorner": {
              "x": 7.968,
              "y": 14.394,
              "z": 1.399
            },
            "gtin": "4011800174217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e47a",
            "leftCorner": {
              "x": 7.968,
              "y": 14.394,
              "z": 1.399
            },
            "rightCorner": {
              "x": 7.875,
              "y": 14.404,
              "z": 1.399
            },
            "gtin": "4011800174217",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6fa2"
  },
  {
    "id": "b6fa4",
    "name": "b6fa4",
    "x": 17.343,
    "y": 12.531,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.051796,
      "w": 0.99866
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 46
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546300",
        "height": 0.13407,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e019",
            "leftCorner": {
              "x": 17.329,
              "y": 12.593,
              "z": 0.11
            },
            "rightCorner": {
              "x": 17.443,
              "y": 12.581,
              "z": 0.11
            },
            "gtin": "4063367130632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e01a",
            "leftCorner": {
              "x": 17.443,
              "y": 12.581,
              "z": 0.11
            },
            "rightCorner": {
              "x": 17.557,
              "y": 12.569,
              "z": 0.11
            },
            "gtin": "4063367130632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e01b",
            "leftCorner": {
              "x": 17.556,
              "y": 12.56,
              "z": 0.11
            },
            "rightCorner": {
              "x": 17.642,
              "y": 12.551,
              "z": 0.11
            },
            "gtin": "4061691000430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e01c",
            "leftCorner": {
              "x": 17.643,
              "y": 12.554,
              "z": 0.11
            },
            "rightCorner": {
              "x": 17.787,
              "y": 12.539,
              "z": 0.11
            },
            "gtin": "7616500938021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e01d",
            "leftCorner": {
              "x": 17.787,
              "y": 12.543,
              "z": 0.11
            },
            "rightCorner": {
              "x": 17.91,
              "y": 12.53,
              "z": 0.11
            },
            "gtin": "7616500938014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e01e",
            "leftCorner": {
              "x": 17.91,
              "y": 12.53,
              "z": 0.11
            },
            "rightCorner": {
              "x": 18.034,
              "y": 12.517,
              "z": 0.11
            },
            "gtin": "7616500938014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e01f",
            "leftCorner": {
              "x": 18.033,
              "y": 12.51,
              "z": 0.11
            },
            "rightCorner": {
              "x": 18.164,
              "y": 12.496,
              "z": 0.11
            },
            "gtin": "7616500938038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e020",
            "leftCorner": {
              "x": 18.164,
              "y": 12.496,
              "z": 0.11
            },
            "rightCorner": {
              "x": 18.296,
              "y": 12.482,
              "z": 0.11
            },
            "gtin": "7616500938038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e021",
            "leftCorner": {
              "x": 18.295,
              "y": 12.479,
              "z": 0.11
            },
            "rightCorner": {
              "x": 18.436,
              "y": 12.464,
              "z": 0.11
            },
            "gtin": "7613037491173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e022",
            "leftCorner": {
              "x": 18.436,
              "y": 12.464,
              "z": 0.11
            },
            "rightCorner": {
              "x": 18.577,
              "y": 12.45,
              "z": 0.11
            },
            "gtin": "7613037491173",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462ff",
        "height": 0.58777,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e11d",
            "leftCorner": {
              "x": 17.367,
              "y": 12.578,
              "z": 0.481
            },
            "rightCorner": {
              "x": 17.583,
              "y": 12.555,
              "z": 0.481
            },
            "gtin": "7613032827014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e11e",
            "leftCorner": {
              "x": 17.583,
              "y": 12.548,
              "z": 0.481
            },
            "rightCorner": {
              "x": 17.704,
              "y": 12.536,
              "z": 0.481
            },
            "gtin": "7613033091391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e11f",
            "leftCorner": {
              "x": 17.704,
              "y": 12.536,
              "z": 0.481
            },
            "rightCorner": {
              "x": 17.824,
              "y": 12.522,
              "z": 0.481
            },
            "gtin": "7613033091391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e120",
            "leftCorner": {
              "x": 17.826,
              "y": 12.536,
              "z": 0.481
            },
            "rightCorner": {
              "x": 18.007,
              "y": 12.518,
              "z": 0.481
            },
            "gtin": "7613033659782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e121",
            "leftCorner": {
              "x": 18.007,
              "y": 12.518,
              "z": 0.481
            },
            "rightCorner": {
              "x": 18.188,
              "y": 12.499,
              "z": 0.481
            },
            "gtin": "7613033659782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e122",
            "leftCorner": {
              "x": 18.187,
              "y": 12.489,
              "z": 0.481
            },
            "rightCorner": {
              "x": 18.27,
              "y": 12.48,
              "z": 0.481
            },
            "gtin": "7613038642024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e123",
            "leftCorner": {
              "x": 18.27,
              "y": 12.48,
              "z": 0.481
            },
            "rightCorner": {
              "x": 18.354,
              "y": 12.472,
              "z": 0.481
            },
            "gtin": "7613038642024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e124",
            "leftCorner": {
              "x": 18.353,
              "y": 12.469,
              "z": 0.481
            },
            "rightCorner": {
              "x": 18.415,
              "y": 12.462,
              "z": 0.481
            },
            "gtin": "7613038641539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e125",
            "leftCorner": {
              "x": 18.415,
              "y": 12.462,
              "z": 0.481
            },
            "rightCorner": {
              "x": 18.477,
              "y": 12.456,
              "z": 0.481
            },
            "gtin": "7613038641539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e126",
            "leftCorner": {
              "x": 18.477,
              "y": 12.456,
              "z": 0.481
            },
            "rightCorner": {
              "x": 18.539,
              "y": 12.449,
              "z": 0.481
            },
            "gtin": "7613038641539",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462fe",
        "height": 1.0421,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e141",
            "leftCorner": {
              "x": 17.364,
              "y": 12.573,
              "z": 0.853
            },
            "rightCorner": {
              "x": 17.474,
              "y": 12.562,
              "z": 0.853
            },
            "gtin": "7613036318143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e142",
            "leftCorner": {
              "x": 17.473,
              "y": 12.557,
              "z": 0.853
            },
            "rightCorner": {
              "x": 17.582,
              "y": 12.545,
              "z": 0.853
            },
            "gtin": "7613036318068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e143",
            "leftCorner": {
              "x": 17.582,
              "y": 12.542,
              "z": 0.853
            },
            "rightCorner": {
              "x": 17.719,
              "y": 12.528,
              "z": 0.853
            },
            "gtin": "7613033157776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e144",
            "leftCorner": {
              "x": 17.719,
              "y": 12.528,
              "z": 0.853
            },
            "rightCorner": {
              "x": 17.857,
              "y": 12.514,
              "z": 0.853
            },
            "gtin": "7613033157776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e145",
            "leftCorner": {
              "x": 17.857,
              "y": 12.514,
              "z": 0.853
            },
            "rightCorner": {
              "x": 18.069,
              "y": 12.492,
              "z": 0.853
            },
            "gtin": "8445291542136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e146",
            "leftCorner": {
              "x": 18.069,
              "y": 12.496,
              "z": 0.853
            },
            "rightCorner": {
              "x": 18.309,
              "y": 12.471,
              "z": 0.853
            },
            "gtin": "8445291179301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e147",
            "leftCorner": {
              "x": 18.307,
              "y": 12.456,
              "z": 0.853
            },
            "rightCorner": {
              "x": 18.42,
              "y": 12.445,
              "z": 0.853
            },
            "gtin": "8445290310576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e148",
            "leftCorner": {
              "x": 18.42,
              "y": 12.445,
              "z": 0.853
            },
            "rightCorner": {
              "x": 18.533,
              "y": 12.433,
              "z": 0.853
            },
            "gtin": "8445290310576",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462fd",
        "height": 1.4923,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e15a",
            "leftCorner": {
              "x": 17.347,
              "y": 12.576,
              "z": 1.221
            },
            "rightCorner": {
              "x": 17.469,
              "y": 12.563,
              "z": 1.221
            },
            "gtin": "7613036959001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e15b",
            "leftCorner": {
              "x": 17.468,
              "y": 12.559,
              "z": 1.221
            },
            "rightCorner": {
              "x": 17.585,
              "y": 12.547,
              "z": 1.221
            },
            "gtin": "7613287302137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e15c",
            "leftCorner": {
              "x": 17.585,
              "y": 12.549,
              "z": 1.221
            },
            "rightCorner": {
              "x": 17.712,
              "y": 12.536,
              "z": 1.221
            },
            "gtin": "7613036961721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e15d",
            "leftCorner": {
              "x": 17.712,
              "y": 12.536,
              "z": 1.221
            },
            "rightCorner": {
              "x": 17.84,
              "y": 12.523,
              "z": 1.221
            },
            "gtin": "7613036961721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e15e",
            "leftCorner": {
              "x": 17.841,
              "y": 12.524,
              "z": 1.221
            },
            "rightCorner": {
              "x": 18.003,
              "y": 12.506,
              "z": 1.221
            },
            "gtin": "8445290154507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e15f",
            "leftCorner": {
              "x": 18.003,
              "y": 12.506,
              "z": 1.221
            },
            "rightCorner": {
              "x": 18.165,
              "y": 12.49,
              "z": 1.221
            },
            "gtin": "8445290154507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e160",
            "leftCorner": {
              "x": 18.164,
              "y": 12.481,
              "z": 1.221
            },
            "rightCorner": {
              "x": 18.359,
              "y": 12.46,
              "z": 1.221
            },
            "gtin": "8445290156105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e161",
            "leftCorner": {
              "x": 18.358,
              "y": 12.453,
              "z": 1.221
            },
            "rightCorner": {
              "x": 18.459,
              "y": 12.444,
              "z": 1.221
            },
            "gtin": "7613036961608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e162",
            "leftCorner": {
              "x": 18.459,
              "y": 12.444,
              "z": 1.221
            },
            "rightCorner": {
              "x": 18.559,
              "y": 12.433,
              "z": 1.221
            },
            "gtin": "7613036961608",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462fc",
        "height": 1.7494,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e0b7",
            "leftCorner": {
              "x": 17.361,
              "y": 12.579,
              "z": 1.431
            },
            "rightCorner": {
              "x": 17.406,
              "y": 12.574,
              "z": 1.431
            },
            "gtin": "4053528008757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0b8",
            "leftCorner": {
              "x": 17.406,
              "y": 12.574,
              "z": 1.431
            },
            "rightCorner": {
              "x": 17.452,
              "y": 12.569,
              "z": 1.431
            },
            "gtin": "4053528008757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0b9",
            "leftCorner": {
              "x": 17.451,
              "y": 12.562,
              "z": 1.431
            },
            "rightCorner": {
              "x": 17.527,
              "y": 12.554,
              "z": 1.431
            },
            "gtin": "7613287607607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0ba",
            "leftCorner": {
              "x": 17.527,
              "y": 12.554,
              "z": 1.431
            },
            "rightCorner": {
              "x": 17.602,
              "y": 12.547,
              "z": 1.431
            },
            "gtin": "7613287607607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0bb",
            "leftCorner": {
              "x": 17.602,
              "y": 12.547,
              "z": 1.431
            },
            "rightCorner": {
              "x": 17.677,
              "y": 12.538,
              "z": 1.431
            },
            "gtin": "7613287607607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0bc",
            "leftCorner": {
              "x": 17.678,
              "y": 12.548,
              "z": 1.431
            },
            "rightCorner": {
              "x": 17.793,
              "y": 12.536,
              "z": 1.431
            },
            "gtin": "7613287607270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0bd",
            "leftCorner": {
              "x": 17.793,
              "y": 12.536,
              "z": 1.431
            },
            "rightCorner": {
              "x": 17.907,
              "y": 12.525,
              "z": 1.431
            },
            "gtin": "7613287607270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0be",
            "leftCorner": {
              "x": 17.907,
              "y": 12.525,
              "z": 1.431
            },
            "rightCorner": {
              "x": 18.022,
              "y": 12.513,
              "z": 1.431
            },
            "gtin": "7613287607270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0bf",
            "leftCorner": {
              "x": 18.021,
              "y": 12.5,
              "z": 1.431
            },
            "rightCorner": {
              "x": 18.576,
              "y": 12.442,
              "z": 1.431
            },
            "gtin": "7613036961660",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "6ebb3",
    "rightNeighborShelfId": "cde16"
  },
  {
    "id": "cde05",
    "name": "cde05",
    "x": 8.493,
    "y": 45.387,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72741,
      "w": 0.6862
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 66
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a54653c",
        "height": 0.1929,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f9d5",
            "leftCorner": {
              "x": 8.406,
              "y": 44.922,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.401,
              "y": 44.84,
              "z": 0.158
            },
            "gtin": "4337185215612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9d6",
            "leftCorner": {
              "x": 8.411,
              "y": 44.839,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.391,
              "y": 44.493,
              "z": 0.158
            },
            "gtin": "4337185215537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9cf",
            "leftCorner": {
              "x": 8.449,
              "y": 44.49,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.438,
              "y": 44.314,
              "z": 0.158
            },
            "gtin": "4337185215513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9d0",
            "leftCorner": {
              "x": 8.438,
              "y": 44.314,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.428,
              "y": 44.138,
              "z": 0.158
            },
            "gtin": "4337185215513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9ce",
            "leftCorner": {
              "x": 8.384,
              "y": 45.393,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.38,
              "y": 45.336,
              "z": 0.158
            }
          },
          {
            "id": "68300c885ed67a01d9a1f9d1",
            "leftCorner": {
              "x": 8.341,
              "y": 45.338,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.335,
              "y": 45.224,
              "z": 0.158
            },
            "gtin": "4337185215650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9d2",
            "leftCorner": {
              "x": 8.372,
              "y": 45.223,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.366,
              "y": 45.126,
              "z": 0.158
            },
            "gtin": "4022551352762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9d3",
            "leftCorner": {
              "x": 8.366,
              "y": 45.126,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.36,
              "y": 45.029,
              "z": 0.158
            },
            "gtin": "4022551352762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9d4",
            "leftCorner": {
              "x": 8.39,
              "y": 45.028,
              "z": 0.158
            },
            "rightCorner": {
              "x": 8.384,
              "y": 44.924,
              "z": 0.158
            },
            "gtin": "4337185215551",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546538",
        "height": 1.716,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f99b",
            "leftCorner": {
              "x": 8.486,
              "y": 44.882,
              "z": 1.404
            },
            "rightCorner": {
              "x": 8.48,
              "y": 44.791,
              "z": 1.404
            },
            "gtin": "4022551352854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f99c",
            "leftCorner": {
              "x": 8.503,
              "y": 44.789,
              "z": 1.404
            },
            "rightCorner": {
              "x": 8.498,
              "y": 44.694,
              "z": 1.404
            },
            "gtin": "4063367218767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f99d",
            "leftCorner": {
              "x": 8.499,
              "y": 44.694,
              "z": 1.404
            },
            "rightCorner": {
              "x": 8.493,
              "y": 44.59,
              "z": 1.404
            },
            "gtin": "5054563114099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f99e",
            "leftCorner": {
              "x": 8.507,
              "y": 44.588,
              "z": 1.404
            },
            "rightCorner": {
              "x": 8.502,
              "y": 44.498,
              "z": 1.404
            },
            "gtin": "5054563114167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f99f",
            "leftCorner": {
              "x": 8.515,
              "y": 44.497,
              "z": 1.404
            },
            "rightCorner": {
              "x": 8.51,
              "y": 44.414,
              "z": 1.404
            },
            "gtin": "5054563114068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9a0",
            "leftCorner": {
              "x": 8.535,
              "y": 44.411,
              "z": 1.404
            },
            "rightCorner": {
              "x": 8.531,
              "y": 44.335,
              "z": 1.404
            },
            "gtin": "4101160130500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9a1",
            "leftCorner": {
              "x": 8.537,
              "y": 44.335,
              "z": 1.404
            },
            "rightCorner": {
              "x": 8.533,
              "y": 44.274,
              "z": 1.404
            },
            "gtin": "4101160840027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f993",
            "leftCorner": {
              "x": 8.535,
              "y": 44.273,
              "z": 1.404
            },
            "rightCorner": {
              "x": 8.531,
              "y": 44.203,
              "z": 1.404
            },
            "gtin": "5016221012567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f994",
            "leftCorner": {
              "x": 8.531,
              "y": 44.203,
              "z": 1.404
            },
            "rightCorner": {
              "x": 8.527,
              "y": 44.133,
              "z": 1.404
            },
            "gtin": "5016221012567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f995",
            "leftCorner": {
              "x": 8.45,
              "y": 45.363,
              "z": 1.404
            },
            "rightCorner": {
              "x": 8.446,
              "y": 45.293,
              "z": 1.404
            },
            "gtin": "8006540860236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f996",
            "leftCorner": {
              "x": 8.453,
              "y": 45.292,
              "z": 1.404
            },
            "rightCorner": {
              "x": 8.447,
              "y": 45.195,
              "z": 1.404
            },
            "gtin": "8700216014052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f997",
            "leftCorner": {
              "x": 8.459,
              "y": 45.194,
              "z": 1.404
            },
            "rightCorner": {
              "x": 8.455,
              "y": 45.117,
              "z": 1.404
            },
            "gtin": "8006540804759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f998",
            "leftCorner": {
              "x": 8.467,
              "y": 45.116,
              "z": 1.404
            },
            "rightCorner": {
              "x": 8.462,
              "y": 45.034,
              "z": 1.404
            },
            "gtin": "7350075694073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f999",
            "leftCorner": {
              "x": 8.462,
              "y": 45.034,
              "z": 1.404
            },
            "rightCorner": {
              "x": 8.457,
              "y": 44.951,
              "z": 1.404
            },
            "gtin": "7350075694073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f99a",
            "leftCorner": {
              "x": 8.469,
              "y": 44.951,
              "z": 1.404
            },
            "rightCorner": {
              "x": 8.465,
              "y": 44.884,
              "z": 1.404
            },
            "gtin": "4022551352847",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54653b",
        "height": 0.50913,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f9bf",
            "leftCorner": {
              "x": 8.498,
              "y": 45.387,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.493,
              "y": 45.314,
              "z": 0.417
            },
            "gtin": "7350075693922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9c0",
            "leftCorner": {
              "x": 8.458,
              "y": 45.317,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.453,
              "y": 45.229,
              "z": 0.417
            },
            "gtin": "7350075690396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9c1",
            "leftCorner": {
              "x": 8.472,
              "y": 45.228,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.465,
              "y": 45.112,
              "z": 0.417
            },
            "gtin": "7350075691782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9c2",
            "leftCorner": {
              "x": 8.473,
              "y": 45.111,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.464,
              "y": 44.959,
              "z": 0.417
            },
            "gtin": "7317400026244",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c885ed67a01d9a1f9c3",
            "leftCorner": {
              "x": 8.49,
              "y": 44.958,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.484,
              "y": 44.855,
              "z": 0.417
            },
            "gtin": "8714789365152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9c4",
            "leftCorner": {
              "x": 8.5,
              "y": 44.854,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.493,
              "y": 44.747,
              "z": 0.417
            },
            "gtin": "8718951241169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9c5",
            "leftCorner": {
              "x": 8.519,
              "y": 44.746,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.516,
              "y": 44.683,
              "z": 0.417
            },
            "gtin": "8714789973852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9c6",
            "leftCorner": {
              "x": 8.516,
              "y": 44.683,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.512,
              "y": 44.621,
              "z": 0.417
            },
            "gtin": "8714789973852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9c7",
            "leftCorner": {
              "x": 8.526,
              "y": 44.62,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.524,
              "y": 44.574,
              "z": 0.417
            },
            "gtin": "8714789447018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9c8",
            "leftCorner": {
              "x": 8.524,
              "y": 44.574,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.521,
              "y": 44.528,
              "z": 0.417
            },
            "gtin": "8714789447018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9c9",
            "leftCorner": {
              "x": 8.53,
              "y": 44.528,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.523,
              "y": 44.404,
              "z": 0.417
            },
            "gtin": "5054563041463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9ca",
            "leftCorner": {
              "x": 8.552,
              "y": 44.402,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.546,
              "y": 44.301,
              "z": 0.417
            },
            "gtin": "4007965112102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9cb",
            "leftCorner": {
              "x": 8.555,
              "y": 44.301,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.552,
              "y": 44.255,
              "z": 0.417
            },
            "gtin": "7350075690204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9cc",
            "leftCorner": {
              "x": 8.552,
              "y": 44.255,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.55,
              "y": 44.208,
              "z": 0.417
            },
            "gtin": "7350075690204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9cd",
            "leftCorner": {
              "x": 8.55,
              "y": 44.208,
              "z": 0.417
            },
            "rightCorner": {
              "x": 8.547,
              "y": 44.16,
              "z": 0.417
            },
            "gtin": "7350075690204",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54653a",
        "height": 0.91254,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f9b0",
            "leftCorner": {
              "x": 8.432,
              "y": 45.37,
              "z": 0.747
            },
            "rightCorner": {
              "x": 8.424,
              "y": 45.224,
              "z": 0.747
            },
            "gtin": "5054563929587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9b1",
            "leftCorner": {
              "x": 8.452,
              "y": 45.223,
              "z": 0.747
            },
            "rightCorner": {
              "x": 8.448,
              "y": 45.149,
              "z": 0.747
            },
            "gtin": "5054563122810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9b2",
            "leftCorner": {
              "x": 8.463,
              "y": 45.148,
              "z": 0.747
            },
            "rightCorner": {
              "x": 8.459,
              "y": 45.089,
              "z": 0.747
            },
            "gtin": "5054563924513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9b3",
            "leftCorner": {
              "x": 8.473,
              "y": 45.088,
              "z": 0.747
            },
            "rightCorner": {
              "x": 8.469,
              "y": 45.01,
              "z": 0.747
            },
            "gtin": "5054563924476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9b4",
            "leftCorner": {
              "x": 8.472,
              "y": 45.01,
              "z": 0.747
            },
            "rightCorner": {
              "x": 8.467,
              "y": 44.928,
              "z": 0.747
            },
            "gtin": "5054563925022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9b5",
            "leftCorner": {
              "x": 8.488,
              "y": 44.926,
              "z": 0.747
            },
            "rightCorner": {
              "x": 8.484,
              "y": 44.861,
              "z": 0.747
            },
            "gtin": "5054563925534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9b6",
            "leftCorner": {
              "x": 8.484,
              "y": 44.861,
              "z": 0.747
            },
            "rightCorner": {
              "x": 8.48,
              "y": 44.796,
              "z": 0.747
            },
            "gtin": "5054563925534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9b7",
            "leftCorner": {
              "x": 8.506,
              "y": 44.794,
              "z": 0.747
            },
            "rightCorner": {
              "x": 8.503,
              "y": 44.734,
              "z": 0.747
            },
            "gtin": "5054563925381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9b8",
            "leftCorner": {
              "x": 8.5,
              "y": 44.733,
              "z": 0.747
            },
            "rightCorner": {
              "x": 8.496,
              "y": 44.657,
              "z": 0.747
            },
            "gtin": "5054563924667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9b9",
            "leftCorner": {
              "x": 8.521,
              "y": 44.656,
              "z": 0.747
            },
            "rightCorner": {
              "x": 8.518,
              "y": 44.596,
              "z": 0.747
            },
            "gtin": "5054563924995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9ba",
            "leftCorner": {
              "x": 8.519,
              "y": 44.596,
              "z": 0.747
            },
            "rightCorner": {
              "x": 8.516,
              "y": 44.54,
              "z": 0.747
            },
            "gtin": "5054563924995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9bb",
            "leftCorner": {
              "x": 8.529,
              "y": 44.539,
              "z": 0.747
            },
            "rightCorner": {
              "x": 8.524,
              "y": 44.463,
              "z": 0.747
            },
            "gtin": "5054563924759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9bc",
            "leftCorner": {
              "x": 8.524,
              "y": 44.463,
              "z": 0.747
            },
            "rightCorner": {
              "x": 8.521,
              "y": 44.407,
              "z": 0.747
            },
            "gtin": "5054563924933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9bd",
            "leftCorner": {
              "x": 8.543,
              "y": 44.407,
              "z": 0.747
            },
            "rightCorner": {
              "x": 8.539,
              "y": 44.338,
              "z": 0.747
            },
            "gtin": "5054563924841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9be",
            "leftCorner": {
              "x": 8.55,
              "y": 44.338,
              "z": 0.747
            },
            "rightCorner": {
              "x": 8.547,
              "y": 44.278,
              "z": 0.747
            },
            "gtin": "5054563925145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9af",
            "leftCorner": {
              "x": 8.552,
              "y": 44.278,
              "z": 0.747
            },
            "rightCorner": {
              "x": 8.544,
              "y": 44.131,
              "z": 0.747
            },
            "gtin": "5054563924537",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546539",
        "height": 1.2572,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f9a2",
            "leftCorner": {
              "x": 8.483,
              "y": 45.388,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.478,
              "y": 45.295,
              "z": 1.029
            },
            "gtin": "8700216012935",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9a4",
            "leftCorner": {
              "x": 8.433,
              "y": 45.298,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.429,
              "y": 45.229,
              "z": 1.029
            },
            "gtin": "4210201446392",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9a5",
            "leftCorner": {
              "x": 8.429,
              "y": 45.229,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.425,
              "y": 45.159,
              "z": 1.029
            },
            "gtin": "4210201446392",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9a6",
            "leftCorner": {
              "x": 8.456,
              "y": 45.158,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.451,
              "y": 45.075,
              "z": 1.029
            },
            "gtin": "4210201427063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9a7",
            "leftCorner": {
              "x": 8.451,
              "y": 45.075,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.446,
              "y": 44.991,
              "z": 1.029
            },
            "gtin": "4210201427063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9a8",
            "leftCorner": {
              "x": 8.469,
              "y": 44.989,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.465,
              "y": 44.923,
              "z": 1.029
            },
            "gtin": "8006540743027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9a9",
            "leftCorner": {
              "x": 8.465,
              "y": 44.923,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.461,
              "y": 44.856,
              "z": 1.029
            },
            "gtin": "8006540743027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9aa",
            "leftCorner": {
              "x": 8.461,
              "y": 44.856,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.457,
              "y": 44.79,
              "z": 1.029
            },
            "gtin": "8006540743027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9ab",
            "leftCorner": {
              "x": 8.476,
              "y": 44.789,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.468,
              "y": 44.641,
              "z": 1.029
            },
            "gtin": "8006540772768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9ac",
            "leftCorner": {
              "x": 8.492,
              "y": 44.64,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.485,
              "y": 44.526,
              "z": 1.029
            },
            "gtin": "8006540772409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9ad",
            "leftCorner": {
              "x": 8.522,
              "y": 44.525,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.515,
              "y": 44.393,
              "z": 1.029
            },
            "gtin": "8720689036757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9ae",
            "leftCorner": {
              "x": 8.542,
              "y": 44.391,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.536,
              "y": 44.296,
              "z": 1.029
            },
            "gtin": "8720689036894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f9a3",
            "leftCorner": {
              "x": 8.55,
              "y": 44.295,
              "z": 1.029
            },
            "rightCorner": {
              "x": 8.541,
              "y": 44.132,
              "z": 1.029
            },
            "gtin": "4210201293873",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "4689f"
  },
  {
    "id": "cde0c",
    "name": "cde0c",
    "x": 19.828,
    "y": 13.343,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99896,
      "w": 0.045607
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 64
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546312",
        "height": 0.13738,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e392",
            "leftCorner": {
              "x": 19.827,
              "y": 13.335,
              "z": 0.112
            },
            "rightCorner": {
              "x": 19.708,
              "y": 13.346,
              "z": 0.112
            },
            "gtin": "4063367321269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e393",
            "leftCorner": {
              "x": 19.708,
              "y": 13.346,
              "z": 0.112
            },
            "rightCorner": {
              "x": 19.588,
              "y": 13.357,
              "z": 0.112
            },
            "gtin": "4063367321269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e395",
            "leftCorner": {
              "x": 19.584,
              "y": 13.311,
              "z": 0.112
            },
            "rightCorner": {
              "x": 19.514,
              "y": 13.318,
              "z": 0.112
            },
            "gtin": "4063367321276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e396",
            "leftCorner": {
              "x": 19.514,
              "y": 13.318,
              "z": 0.112
            },
            "rightCorner": {
              "x": 19.443,
              "y": 13.324,
              "z": 0.112
            },
            "gtin": "4063367321276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e397",
            "leftCorner": {
              "x": 19.443,
              "y": 13.324,
              "z": 0.112
            },
            "rightCorner": {
              "x": 19.372,
              "y": 13.331,
              "z": 0.112
            },
            "gtin": "4063367321276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e398",
            "leftCorner": {
              "x": 19.373,
              "y": 13.339,
              "z": 0.112
            },
            "rightCorner": {
              "x": 19.257,
              "y": 13.35,
              "z": 0.112
            },
            "gtin": "4002309014876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e399",
            "leftCorner": {
              "x": 19.257,
              "y": 13.35,
              "z": 0.112
            },
            "rightCorner": {
              "x": 19.142,
              "y": 13.36,
              "z": 0.112
            },
            "gtin": "4002309014876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e39a",
            "leftCorner": {
              "x": 19.142,
              "y": 13.36,
              "z": 0.112
            },
            "rightCorner": {
              "x": 19.04,
              "y": 13.369,
              "z": 0.112
            },
            "gtin": "4002309014845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e39b",
            "leftCorner": {
              "x": 19.04,
              "y": 13.369,
              "z": 0.112
            },
            "rightCorner": {
              "x": 18.939,
              "y": 13.379,
              "z": 0.112
            },
            "gtin": "4002309014845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e39c",
            "leftCorner": {
              "x": 18.939,
              "y": 13.379,
              "z": 0.112
            },
            "rightCorner": {
              "x": 18.838,
              "y": 13.387,
              "z": 0.112
            },
            "gtin": "4002309014845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e39d",
            "leftCorner": {
              "x": 18.838,
              "y": 13.387,
              "z": 0.112
            },
            "rightCorner": {
              "x": 18.759,
              "y": 13.394,
              "z": 0.112
            },
            "gtin": "4002309014487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e39e",
            "leftCorner": {
              "x": 18.759,
              "y": 13.394,
              "z": 0.112
            },
            "rightCorner": {
              "x": 18.68,
              "y": 13.402,
              "z": 0.112
            },
            "gtin": "4002309014487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e39f",
            "leftCorner": {
              "x": 18.68,
              "y": 13.402,
              "z": 0.112
            },
            "rightCorner": {
              "x": 18.603,
              "y": 13.409,
              "z": 0.112
            },
            "gtin": "4002309014487",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54630f",
        "height": 0.58979,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e278",
            "leftCorner": {
              "x": 19.826,
              "y": 13.331,
              "z": 0.483
            },
            "rightCorner": {
              "x": 19.707,
              "y": 13.342,
              "z": 0.483
            },
            "gtin": "037600106009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e27a",
            "leftCorner": {
              "x": 19.703,
              "y": 13.3,
              "z": 0.483
            },
            "rightCorner": {
              "x": 19.621,
              "y": 13.308,
              "z": 0.483
            },
            "gtin": "037600106412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e27b",
            "leftCorner": {
              "x": 19.621,
              "y": 13.308,
              "z": 0.483
            },
            "rightCorner": {
              "x": 19.54,
              "y": 13.315,
              "z": 0.483
            },
            "gtin": "037600106412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e27c",
            "leftCorner": {
              "x": 19.539,
              "y": 13.313,
              "z": 0.483
            },
            "rightCorner": {
              "x": 19.43,
              "y": 13.323,
              "z": 0.483
            },
            "gtin": "3608580125389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e27d",
            "leftCorner": {
              "x": 19.43,
              "y": 13.325,
              "z": 0.483
            },
            "rightCorner": {
              "x": 19.257,
              "y": 13.341,
              "z": 0.483
            },
            "gtin": "7612100909591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e27e",
            "leftCorner": {
              "x": 19.259,
              "y": 13.356,
              "z": 0.483
            },
            "rightCorner": {
              "x": 19.047,
              "y": 13.375,
              "z": 0.483
            },
            "gtin": "5410126726954",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e27f",
            "leftCorner": {
              "x": 19.047,
              "y": 13.368,
              "z": 0.483
            },
            "rightCorner": {
              "x": 18.955,
              "y": 13.377,
              "z": 0.483
            },
            "gtin": "5410126726947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e280",
            "leftCorner": {
              "x": 18.955,
              "y": 13.377,
              "z": 0.483
            },
            "rightCorner": {
              "x": 18.863,
              "y": 13.386,
              "z": 0.483
            },
            "gtin": "5410126726947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e281",
            "leftCorner": {
              "x": 18.863,
              "y": 13.391,
              "z": 0.483
            },
            "rightCorner": {
              "x": 18.782,
              "y": 13.398,
              "z": 0.483
            },
            "gtin": "4260654781366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e282",
            "leftCorner": {
              "x": 18.782,
              "y": 13.398,
              "z": 0.483
            },
            "rightCorner": {
              "x": 18.702,
              "y": 13.405,
              "z": 0.483
            },
            "gtin": "4260654781366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e283",
            "leftCorner": {
              "x": 18.702,
              "y": 13.405,
              "z": 0.483
            },
            "rightCorner": {
              "x": 18.621,
              "y": 13.413,
              "z": 0.483
            },
            "gtin": "4260654781366",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546311",
        "height": 0.99211,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e310",
            "leftCorner": {
              "x": 19.828,
              "y": 13.338,
              "z": 0.812
            },
            "rightCorner": {
              "x": 19.772,
              "y": 13.343,
              "z": 0.812
            },
            "gtin": "4018087003667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e311",
            "leftCorner": {
              "x": 19.772,
              "y": 13.343,
              "z": 0.812
            },
            "rightCorner": {
              "x": 19.716,
              "y": 13.348,
              "z": 0.812
            },
            "gtin": "4018087003667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e312",
            "leftCorner": {
              "x": 19.716,
              "y": 13.348,
              "z": 0.812
            },
            "rightCorner": {
              "x": 19.66,
              "y": 13.353,
              "z": 0.812
            },
            "gtin": "4018087003667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e315",
            "leftCorner": {
              "x": 19.657,
              "y": 13.316,
              "z": 0.812
            },
            "rightCorner": {
              "x": 19.604,
              "y": 13.321,
              "z": 0.812
            },
            "gtin": "4002575610659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e316",
            "leftCorner": {
              "x": 19.604,
              "y": 13.321,
              "z": 0.812
            },
            "rightCorner": {
              "x": 19.551,
              "y": 13.326,
              "z": 0.812
            },
            "gtin": "4002575610659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e317",
            "leftCorner": {
              "x": 19.551,
              "y": 13.326,
              "z": 0.812
            },
            "rightCorner": {
              "x": 19.499,
              "y": 13.331,
              "z": 0.812
            },
            "gtin": "4002575610659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e318",
            "leftCorner": {
              "x": 19.499,
              "y": 13.331,
              "z": 0.812
            },
            "rightCorner": {
              "x": 19.401,
              "y": 13.339,
              "z": 0.812
            },
            "gtin": "4002575610635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e319",
            "leftCorner": {
              "x": 19.401,
              "y": 13.339,
              "z": 0.812
            },
            "rightCorner": {
              "x": 19.303,
              "y": 13.349,
              "z": 0.812
            },
            "gtin": "4002575610635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e31a",
            "leftCorner": {
              "x": 19.305,
              "y": 13.354,
              "z": 0.812
            },
            "rightCorner": {
              "x": 19.218,
              "y": 13.362,
              "z": 0.812
            },
            "gtin": "4004980896802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e31b",
            "leftCorner": {
              "x": 19.218,
              "y": 13.362,
              "z": 0.812
            },
            "rightCorner": {
              "x": 19.131,
              "y": 13.37,
              "z": 0.812
            },
            "gtin": "4004980896802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e31c",
            "leftCorner": {
              "x": 19.131,
              "y": 13.37,
              "z": 0.812
            },
            "rightCorner": {
              "x": 18.983,
              "y": 13.383,
              "z": 0.812
            },
            "gtin": "4004980896703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e31d",
            "leftCorner": {
              "x": 18.983,
              "y": 13.382,
              "z": 0.812
            },
            "rightCorner": {
              "x": 18.86,
              "y": 13.393,
              "z": 0.812
            },
            "gtin": "4045178007822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e31e",
            "leftCorner": {
              "x": 18.86,
              "y": 13.388,
              "z": 0.812
            },
            "rightCorner": {
              "x": 18.745,
              "y": 13.398,
              "z": 0.812
            },
            "gtin": "4260562940602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e31f",
            "leftCorner": {
              "x": 18.745,
              "y": 13.398,
              "z": 0.812
            },
            "rightCorner": {
              "x": 18.619,
              "y": 13.41,
              "z": 0.812
            },
            "gtin": "4000281327502",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546313",
        "height": 1.3467,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e407",
            "leftCorner": {
              "x": 19.829,
              "y": 13.352,
              "z": 1.102
            },
            "rightCorner": {
              "x": 19.689,
              "y": 13.365,
              "z": 1.102
            },
            "gtin": "052600412752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e408",
            "leftCorner": {
              "x": 19.689,
              "y": 13.365,
              "z": 1.102
            },
            "rightCorner": {
              "x": 19.549,
              "y": 13.378,
              "z": 1.102
            },
            "gtin": "052600412752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e409",
            "leftCorner": {
              "x": 19.549,
              "y": 13.378,
              "z": 1.102
            },
            "rightCorner": {
              "x": 19.409,
              "y": 13.391,
              "z": 1.102
            },
            "gtin": "052600412752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e40b",
            "leftCorner": {
              "x": 19.404,
              "y": 13.338,
              "z": 1.102
            },
            "rightCorner": {
              "x": 19.254,
              "y": 13.352,
              "z": 1.102
            },
            "gtin": "052600751219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e40c",
            "leftCorner": {
              "x": 19.255,
              "y": 13.365,
              "z": 1.102
            },
            "rightCorner": {
              "x": 19.104,
              "y": 13.379,
              "z": 1.102
            },
            "gtin": "4011800103927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e40d",
            "leftCorner": {
              "x": 19.104,
              "y": 13.38,
              "z": 1.102
            },
            "rightCorner": {
              "x": 19.025,
              "y": 13.387,
              "z": 1.102
            },
            "gtin": "4011800102920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e40e",
            "leftCorner": {
              "x": 19.025,
              "y": 13.387,
              "z": 1.102
            },
            "rightCorner": {
              "x": 18.947,
              "y": 13.394,
              "z": 1.102
            },
            "gtin": "4011800102920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e40f",
            "leftCorner": {
              "x": 18.948,
              "y": 13.397,
              "z": 1.102
            },
            "rightCorner": {
              "x": 18.838,
              "y": 13.407,
              "z": 1.102
            },
            "gtin": "4011800104924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e410",
            "leftCorner": {
              "x": 18.838,
              "y": 13.407,
              "z": 1.102
            },
            "rightCorner": {
              "x": 18.729,
              "y": 13.418,
              "z": 1.102
            },
            "gtin": "4011800104924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e411",
            "leftCorner": {
              "x": 18.728,
              "y": 13.406,
              "z": 1.102
            },
            "rightCorner": {
              "x": 18.67,
              "y": 13.411,
              "z": 1.102
            },
            "gtin": "4260654783414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e412",
            "leftCorner": {
              "x": 18.67,
              "y": 13.411,
              "z": 1.102
            },
            "rightCorner": {
              "x": 18.613,
              "y": 13.416,
              "z": 1.102
            },
            "gtin": "4260654783414",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546310",
        "height": 1.6967,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e2bb",
            "leftCorner": {
              "x": 19.828,
              "y": 13.343,
              "z": 1.388
            },
            "rightCorner": {
              "x": 19.76,
              "y": 13.349,
              "z": 1.388
            },
            "gtin": "8013108699320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2bc",
            "leftCorner": {
              "x": 19.76,
              "y": 13.349,
              "z": 1.388
            },
            "rightCorner": {
              "x": 19.693,
              "y": 13.356,
              "z": 1.388
            },
            "gtin": "8013108699320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2be",
            "leftCorner": {
              "x": 19.689,
              "y": 13.314,
              "z": 1.388
            },
            "rightCorner": {
              "x": 19.607,
              "y": 13.321,
              "z": 1.388
            },
            "gtin": "8013108699313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2bf",
            "leftCorner": {
              "x": 19.607,
              "y": 13.321,
              "z": 1.388
            },
            "rightCorner": {
              "x": 19.524,
              "y": 13.329,
              "z": 1.388
            },
            "gtin": "8013108699313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2c0",
            "leftCorner": {
              "x": 19.524,
              "y": 13.329,
              "z": 1.388
            },
            "rightCorner": {
              "x": 19.443,
              "y": 13.337,
              "z": 1.388
            },
            "gtin": "8013108699313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2c1",
            "leftCorner": {
              "x": 19.443,
              "y": 13.342,
              "z": 1.388
            },
            "rightCorner": {
              "x": 19.393,
              "y": 13.347,
              "z": 1.388
            },
            "gtin": "4004363008808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2c2",
            "leftCorner": {
              "x": 19.393,
              "y": 13.347,
              "z": 1.388
            },
            "rightCorner": {
              "x": 19.342,
              "y": 13.351,
              "z": 1.388
            },
            "gtin": "4004363008808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2c3",
            "leftCorner": {
              "x": 19.342,
              "y": 13.351,
              "z": 1.388
            },
            "rightCorner": {
              "x": 19.293,
              "y": 13.355,
              "z": 1.388
            },
            "gtin": "4004363008808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2c4",
            "leftCorner": {
              "x": 19.293,
              "y": 13.355,
              "z": 1.388
            },
            "rightCorner": {
              "x": 19.242,
              "y": 13.361,
              "z": 1.388
            },
            "gtin": "4004363008808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2c5",
            "leftCorner": {
              "x": 19.242,
              "y": 13.362,
              "z": 1.388
            },
            "rightCorner": {
              "x": 19.122,
              "y": 13.373,
              "z": 1.388
            },
            "gtin": "5056357904664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2c6",
            "leftCorner": {
              "x": 19.122,
              "y": 13.37,
              "z": 1.388
            },
            "rightCorner": {
              "x": 18.963,
              "y": 13.384,
              "z": 1.388
            },
            "gtin": "5056357904640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2c7",
            "leftCorner": {
              "x": 18.963,
              "y": 13.388,
              "z": 1.388
            },
            "rightCorner": {
              "x": 18.902,
              "y": 13.393,
              "z": 1.388
            },
            "gtin": "5056357910764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2c8",
            "leftCorner": {
              "x": 18.901,
              "y": 13.386,
              "z": 1.388
            },
            "rightCorner": {
              "x": 18.763,
              "y": 13.398,
              "z": 1.388
            },
            "gtin": "5056357904626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2c9",
            "leftCorner": {
              "x": 18.763,
              "y": 13.397,
              "z": 1.388
            },
            "rightCorner": {
              "x": 18.677,
              "y": 13.405,
              "z": 1.388
            },
            "gtin": "5056357908617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e2ca",
            "leftCorner": {
              "x": 18.677,
              "y": 13.405,
              "z": 1.388
            },
            "rightCorner": {
              "x": 18.589,
              "y": 13.414,
              "z": 1.388
            },
            "gtin": "5056357908617",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "b6f9b"
  },
  {
    "id": "cde16",
    "name": "cde16",
    "x": 18.536,
    "y": 12.407,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.051796,
      "w": 0.99866
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 34
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546308",
        "height": 1.4994,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e163",
            "leftCorner": {
              "x": 18.561,
              "y": 12.456,
              "z": 1.227
            },
            "rightCorner": {
              "x": 18.829,
              "y": 12.427,
              "z": 1.227
            },
            "gtin": "7613287186829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e164",
            "leftCorner": {
              "x": 18.829,
              "y": 12.427,
              "z": 1.227
            },
            "rightCorner": {
              "x": 18.983,
              "y": 12.411,
              "z": 1.227
            },
            "gtin": "8445290814722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e165",
            "leftCorner": {
              "x": 18.983,
              "y": 12.41,
              "z": 1.227
            },
            "rightCorner": {
              "x": 19.095,
              "y": 12.398,
              "z": 1.227
            },
            "gtin": "8445291451780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e166",
            "leftCorner": {
              "x": 19.097,
              "y": 12.411,
              "z": 1.227
            },
            "rightCorner": {
              "x": 19.224,
              "y": 12.398,
              "z": 1.227
            },
            "gtin": "7613036957120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e167",
            "leftCorner": {
              "x": 19.223,
              "y": 12.394,
              "z": 1.227
            },
            "rightCorner": {
              "x": 19.39,
              "y": 12.376,
              "z": 1.227
            },
            "gtin": "7613036961806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e153",
            "leftCorner": {
              "x": 19.389,
              "y": 12.358,
              "z": 1.227
            },
            "rightCorner": {
              "x": 19.734,
              "y": 12.322,
              "z": 1.227
            },
            "gtin": "7630311506910",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546307",
        "height": 1.7499,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e0c0",
            "leftCorner": {
              "x": 18.577,
              "y": 12.449,
              "z": 1.432
            },
            "rightCorner": {
              "x": 18.738,
              "y": 12.432,
              "z": 1.432
            },
            "gtin": "7613036943659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0c1",
            "leftCorner": {
              "x": 18.738,
              "y": 12.432,
              "z": 1.432
            },
            "rightCorner": {
              "x": 18.899,
              "y": 12.415,
              "z": 1.432
            },
            "gtin": "7613036943659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0c2",
            "leftCorner": {
              "x": 18.899,
              "y": 12.415,
              "z": 1.432
            },
            "rightCorner": {
              "x": 19.061,
              "y": 12.399,
              "z": 1.432
            },
            "gtin": "7613036943659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0c3",
            "leftCorner": {
              "x": 19.061,
              "y": 12.399,
              "z": 1.432
            },
            "rightCorner": {
              "x": 19.222,
              "y": 12.382,
              "z": 1.432
            },
            "gtin": "7613036943659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0c4",
            "leftCorner": {
              "x": 19.224,
              "y": 12.395,
              "z": 1.432
            },
            "rightCorner": {
              "x": 19.508,
              "y": 12.366,
              "z": 1.432
            },
            "gtin": "7613287335159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0c5",
            "leftCorner": {
              "x": 19.508,
              "y": 12.364,
              "z": 1.432
            },
            "rightCorner": {
              "x": 19.558,
              "y": 12.359,
              "z": 1.432
            },
            "gtin": "7613036943529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e0c6",
            "leftCorner": {
              "x": 19.558,
              "y": 12.359,
              "z": 1.432
            },
            "rightCorner": {
              "x": 19.607,
              "y": 12.354,
              "z": 1.432
            },
            "gtin": "7613036943529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e085",
            "leftCorner": {
              "x": 19.607,
              "y": 12.351,
              "z": 1.432
            },
            "rightCorner": {
              "x": 19.735,
              "y": 12.337,
              "z": 1.432
            },
            "gtin": "8445290396860",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546309",
        "height": 0.14071,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e023",
            "leftCorner": {
              "x": 18.578,
              "y": 12.466,
              "z": 0.115
            },
            "rightCorner": {
              "x": 18.916,
              "y": 12.43,
              "z": 0.115
            },
            "gtin": "7613036306294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e024",
            "leftCorner": {
              "x": 18.916,
              "y": 12.43,
              "z": 0.115
            },
            "rightCorner": {
              "x": 19.252,
              "y": 12.395,
              "z": 0.115
            },
            "gtin": "7613036306294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dff5",
            "leftCorner": {
              "x": 19.253,
              "y": 12.411,
              "z": 0.115
            },
            "rightCorner": {
              "x": 19.496,
              "y": 12.385,
              "z": 0.115
            },
            "gtin": "8445290456410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dff6",
            "leftCorner": {
              "x": 19.496,
              "y": 12.385,
              "z": 0.115
            },
            "rightCorner": {
              "x": 19.738,
              "y": 12.36,
              "z": 0.115
            },
            "gtin": "8445290456410",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546305",
        "height": 0.59315,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e127",
            "leftCorner": {
              "x": 18.541,
              "y": 12.469,
              "z": 0.485
            },
            "rightCorner": {
              "x": 18.66,
              "y": 12.456,
              "z": 0.485
            },
            "gtin": "7613037929485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e128",
            "leftCorner": {
              "x": 18.66,
              "y": 12.456,
              "z": 0.485
            },
            "rightCorner": {
              "x": 18.778,
              "y": 12.444,
              "z": 0.485
            },
            "gtin": "7613037929485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e129",
            "leftCorner": {
              "x": 18.778,
              "y": 12.445,
              "z": 0.485
            },
            "rightCorner": {
              "x": 18.997,
              "y": 12.422,
              "z": 0.485
            },
            "gtin": "7613031794331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e12a",
            "leftCorner": {
              "x": 18.997,
              "y": 12.423,
              "z": 0.485
            },
            "rightCorner": {
              "x": 19.152,
              "y": 12.407,
              "z": 0.485
            },
            "gtin": "8445290859549",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c855ed67a01d9a1e12b",
            "leftCorner": {
              "x": 19.153,
              "y": 12.411,
              "z": 0.485
            },
            "rightCorner": {
              "x": 19.277,
              "y": 12.398,
              "z": 0.485
            },
            "gtin": "7613033174704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e12c",
            "leftCorner": {
              "x": 19.277,
              "y": 12.398,
              "z": 0.485
            },
            "rightCorner": {
              "x": 19.401,
              "y": 12.386,
              "z": 0.485
            },
            "gtin": "7613033174704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e105",
            "leftCorner": {
              "x": 19.4,
              "y": 12.376,
              "z": 0.485
            },
            "rightCorner": {
              "x": 19.568,
              "y": 12.359,
              "z": 0.485
            },
            "gtin": "7613037401707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e106",
            "leftCorner": {
              "x": 19.568,
              "y": 12.359,
              "z": 0.485
            },
            "rightCorner": {
              "x": 19.736,
              "y": 12.341,
              "z": 0.485
            },
            "gtin": "7613037401707",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546306",
        "height": 1.0462,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e149",
            "leftCorner": {
              "x": 18.535,
              "y": 12.456,
              "z": 0.856
            },
            "rightCorner": {
              "x": 18.648,
              "y": 12.445,
              "z": 0.856
            },
            "gtin": "8445290537744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e14a",
            "leftCorner": {
              "x": 18.648,
              "y": 12.448,
              "z": 0.856
            },
            "rightCorner": {
              "x": 18.766,
              "y": 12.435,
              "z": 0.856
            },
            "gtin": "8445290537645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e14b",
            "leftCorner": {
              "x": 18.767,
              "y": 12.438,
              "z": 0.856
            },
            "rightCorner": {
              "x": 18.888,
              "y": 12.426,
              "z": 0.856
            },
            "gtin": "7613036675680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e14c",
            "leftCorner": {
              "x": 18.888,
              "y": 12.426,
              "z": 0.856
            },
            "rightCorner": {
              "x": 19.009,
              "y": 12.413,
              "z": 0.856
            },
            "gtin": "7613036675680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e14d",
            "leftCorner": {
              "x": 19.01,
              "y": 12.417,
              "z": 0.856
            },
            "rightCorner": {
              "x": 19.172,
              "y": 12.4,
              "z": 0.856
            },
            "gtin": "7613036828444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e14e",
            "leftCorner": {
              "x": 19.172,
              "y": 12.401,
              "z": 0.856
            },
            "rightCorner": {
              "x": 19.287,
              "y": 12.389,
              "z": 0.856
            },
            "gtin": "7613035690660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e14f",
            "leftCorner": {
              "x": 19.287,
              "y": 12.389,
              "z": 0.856
            },
            "rightCorner": {
              "x": 19.404,
              "y": 12.377,
              "z": 0.856
            },
            "gtin": "7613035690660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e150",
            "leftCorner": {
              "x": 19.404,
              "y": 12.377,
              "z": 0.856
            },
            "rightCorner": {
              "x": 19.519,
              "y": 12.365,
              "z": 0.856
            },
            "gtin": "7613035690660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e136",
            "leftCorner": {
              "x": 19.519,
              "y": 12.362,
              "z": 0.856
            },
            "rightCorner": {
              "x": 19.735,
              "y": 12.339,
              "z": 0.856
            },
            "gtin": "7613037788884",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6fa4"
  },
  {
    "id": "cde33",
    "name": "cde33",
    "x": 7.513,
    "y": 16.506,
    "width": 0.65,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036216,
      "w": 0.99934
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 6
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54634d",
        "height": 0.18656,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a54634c",
        "height": 0.80607,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a54634b",
        "height": 1.718,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e168",
            "leftCorner": {
              "x": 7.526,
              "y": 16.691,
              "z": 1.406
            },
            "rightCorner": {
              "x": 7.714,
              "y": 16.677,
              "z": 1.406
            },
            "gtin": "4063367388446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e16a",
            "leftCorner": {
              "x": 7.717,
              "y": 16.708,
              "z": 1.406
            },
            "rightCorner": {
              "x": 7.771,
              "y": 16.704,
              "z": 1.406
            },
            "gtin": "4045178005811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e16b",
            "leftCorner": {
              "x": 7.771,
              "y": 16.704,
              "z": 1.406
            },
            "rightCorner": {
              "x": 7.825,
              "y": 16.7,
              "z": 1.406
            },
            "gtin": "4045178005811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e16c",
            "leftCorner": {
              "x": 7.825,
              "y": 16.7,
              "z": 1.406
            },
            "rightCorner": {
              "x": 7.879,
              "y": 16.696,
              "z": 1.406
            },
            "gtin": "4045178005811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e16d",
            "leftCorner": {
              "x": 7.879,
              "y": 16.703,
              "z": 1.406
            },
            "rightCorner": {
              "x": 8.032,
              "y": 16.693,
              "z": 1.406
            },
            "gtin": "4045178005873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e16e",
            "leftCorner": {
              "x": 8.032,
              "y": 16.693,
              "z": 1.406
            },
            "rightCorner": {
              "x": 8.16,
              "y": 16.684,
              "z": 1.406
            },
            "gtin": "4045178005835",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "34a5e"
  },
  {
    "id": "d1349",
    "name": "d1349",
    "x": 20.224,
    "y": 23.03,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99914,
      "w": 0.041492
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 41
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54680e",
        "height": 0.14658,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2110a",
            "leftCorner": {
              "x": 20.224,
              "y": 23.023,
              "z": 0.12
            },
            "rightCorner": {
              "x": 19.933,
              "y": 23.047,
              "z": 0.12
            },
            "gtin": "4008400351926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2110b",
            "leftCorner": {
              "x": 19.933,
              "y": 23.047,
              "z": 0.12
            },
            "rightCorner": {
              "x": 19.641,
              "y": 23.071,
              "z": 0.12
            },
            "gtin": "4008400351926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2110d",
            "leftCorner": {
              "x": 19.638,
              "y": 23.023,
              "z": 0.12
            },
            "rightCorner": {
              "x": 19.5,
              "y": 23.036,
              "z": 0.12
            },
            "gtin": "8000500272442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2110e",
            "leftCorner": {
              "x": 19.5,
              "y": 23.036,
              "z": 0.12
            },
            "rightCorner": {
              "x": 19.363,
              "y": 23.047,
              "z": 0.12
            },
            "gtin": "8000500272442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2110f",
            "leftCorner": {
              "x": 19.363,
              "y": 23.047,
              "z": 0.12
            },
            "rightCorner": {
              "x": 19.226,
              "y": 23.058,
              "z": 0.12
            },
            "gtin": "8000500272442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21110",
            "leftCorner": {
              "x": 19.226,
              "y": 23.058,
              "z": 0.12
            },
            "rightCorner": {
              "x": 19.088,
              "y": 23.07,
              "z": 0.12
            },
            "gtin": "8000500272442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21111",
            "leftCorner": {
              "x": 19.088,
              "y": 23.07,
              "z": 0.12
            },
            "rightCorner": {
              "x": 18.951,
              "y": 23.081,
              "z": 0.12
            },
            "gtin": "8000500272442",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546809",
        "height": 0.49316,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2106e",
            "leftCorner": {
              "x": 20.222,
              "y": 23.006,
              "z": 0.403
            },
            "rightCorner": {
              "x": 20.13,
              "y": 23.013,
              "z": 0.403
            },
            "gtin": "8000500331798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2106f",
            "leftCorner": {
              "x": 20.13,
              "y": 23.013,
              "z": 0.403
            },
            "rightCorner": {
              "x": 20.038,
              "y": 23.021,
              "z": 0.403
            },
            "gtin": "8000500331798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21070",
            "leftCorner": {
              "x": 20.038,
              "y": 23.021,
              "z": 0.403
            },
            "rightCorner": {
              "x": 19.946,
              "y": 23.029,
              "z": 0.403
            },
            "gtin": "8000500331798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21072",
            "leftCorner": {
              "x": 19.944,
              "y": 23.011,
              "z": 0.403
            },
            "rightCorner": {
              "x": 19.868,
              "y": 23.018,
              "z": 0.403
            },
            "gtin": "8000500422083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21073",
            "leftCorner": {
              "x": 19.868,
              "y": 23.018,
              "z": 0.403
            },
            "rightCorner": {
              "x": 19.791,
              "y": 23.024,
              "z": 0.403
            },
            "gtin": "8000500422083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21074",
            "leftCorner": {
              "x": 19.791,
              "y": 23.024,
              "z": 0.403
            },
            "rightCorner": {
              "x": 19.714,
              "y": 23.031,
              "z": 0.403
            },
            "gtin": "8000500422083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21075",
            "leftCorner": {
              "x": 19.714,
              "y": 23.031,
              "z": 0.403
            },
            "rightCorner": {
              "x": 19.637,
              "y": 23.037,
              "z": 0.403
            },
            "gtin": "8000500422083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21076",
            "leftCorner": {
              "x": 19.637,
              "y": 23.037,
              "z": 0.403
            },
            "rightCorner": {
              "x": 19.561,
              "y": 23.044,
              "z": 0.403
            },
            "gtin": "8000500422083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21077",
            "leftCorner": {
              "x": 19.561,
              "y": 23.044,
              "z": 0.403
            },
            "rightCorner": {
              "x": 19.484,
              "y": 23.05,
              "z": 0.403
            },
            "gtin": "8000500422083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21078",
            "leftCorner": {
              "x": 19.482,
              "y": 23.03,
              "z": 0.403
            },
            "rightCorner": {
              "x": 19.353,
              "y": 23.04,
              "z": 0.403
            },
            "gtin": "4008400671529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21079",
            "leftCorner": {
              "x": 19.353,
              "y": 23.04,
              "z": 0.403
            },
            "rightCorner": {
              "x": 19.224,
              "y": 23.051,
              "z": 0.403
            },
            "gtin": "4008400671529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2107a",
            "leftCorner": {
              "x": 19.224,
              "y": 23.051,
              "z": 0.403
            },
            "rightCorner": {
              "x": 19.095,
              "y": 23.061,
              "z": 0.403
            },
            "gtin": "4008400671529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2107b",
            "leftCorner": {
              "x": 19.095,
              "y": 23.061,
              "z": 0.403
            },
            "rightCorner": {
              "x": 18.966,
              "y": 23.072,
              "z": 0.403
            },
            "gtin": "4008400671529",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54680d",
        "height": 0.84001,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2126b",
            "leftCorner": {
              "x": 20.224,
              "y": 23.027,
              "z": 0.687
            },
            "rightCorner": {
              "x": 20.054,
              "y": 23.041,
              "z": 0.687
            },
            "gtin": "8000500276679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2126c",
            "leftCorner": {
              "x": 20.054,
              "y": 23.041,
              "z": 0.687
            },
            "rightCorner": {
              "x": 19.885,
              "y": 23.055,
              "z": 0.687
            },
            "gtin": "8000500276679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21270",
            "leftCorner": {
              "x": 19.881,
              "y": 23.009,
              "z": 0.687
            },
            "rightCorner": {
              "x": 19.685,
              "y": 23.026,
              "z": 0.687
            },
            "gtin": "4008400301020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21271",
            "leftCorner": {
              "x": 19.685,
              "y": 23.026,
              "z": 0.687
            },
            "rightCorner": {
              "x": 19.488,
              "y": 23.042,
              "z": 0.687
            },
            "gtin": "4008400301020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21272",
            "leftCorner": {
              "x": 19.488,
              "y": 23.042,
              "z": 0.687
            },
            "rightCorner": {
              "x": 19.292,
              "y": 23.059,
              "z": 0.687
            },
            "gtin": "4008400301020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21273",
            "leftCorner": {
              "x": 19.293,
              "y": 23.068,
              "z": 0.687
            },
            "rightCorner": {
              "x": 18.977,
              "y": 23.094,
              "z": 0.687
            },
            "gtin": "4008400302829",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54680a",
        "height": 1.1978,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21228",
            "leftCorner": {
              "x": 20.223,
              "y": 23.021,
              "z": 0.98
            },
            "rightCorner": {
              "x": 19.998,
              "y": 23.04,
              "z": 0.98
            },
            "gtin": "8000500423523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2122b",
            "leftCorner": {
              "x": 19.995,
              "y": 22.998,
              "z": 0.98
            },
            "rightCorner": {
              "x": 19.85,
              "y": 23.01,
              "z": 0.98
            },
            "gtin": "8000500423530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2122c",
            "leftCorner": {
              "x": 19.85,
              "y": 23.013,
              "z": 0.98
            },
            "rightCorner": {
              "x": 19.768,
              "y": 23.02,
              "z": 0.98
            },
            "gtin": "4008400221021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2122d",
            "leftCorner": {
              "x": 19.768,
              "y": 23.02,
              "z": 0.98
            },
            "rightCorner": {
              "x": 19.685,
              "y": 23.027,
              "z": 0.98
            },
            "gtin": "4008400221021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2122e",
            "leftCorner": {
              "x": 19.685,
              "y": 23.027,
              "z": 0.98
            },
            "rightCorner": {
              "x": 19.602,
              "y": 23.034,
              "z": 0.98
            },
            "gtin": "4008400221021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2122f",
            "leftCorner": {
              "x": 19.602,
              "y": 23.028,
              "z": 0.98
            },
            "rightCorner": {
              "x": 19.407,
              "y": 23.043,
              "z": 0.98
            },
            "gtin": "4008400221823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21230",
            "leftCorner": {
              "x": 19.407,
              "y": 23.043,
              "z": 0.98
            },
            "rightCorner": {
              "x": 19.214,
              "y": 23.059,
              "z": 0.98
            },
            "gtin": "4008400221823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21231",
            "leftCorner": {
              "x": 19.214,
              "y": 23.059,
              "z": 0.98
            },
            "rightCorner": {
              "x": 19.02,
              "y": 23.076,
              "z": 0.98
            },
            "gtin": "4008400221823",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54680b",
        "height": 1.4991,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a54680c",
        "height": 1.7424,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2115f",
            "leftCorner": {
              "x": 20.223,
              "y": 23.018,
              "z": 1.426
            },
            "rightCorner": {
              "x": 20.066,
              "y": 23.031,
              "z": 1.426
            },
            "gtin": "8000500273470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21160",
            "leftCorner": {
              "x": 20.066,
              "y": 23.031,
              "z": 1.426
            },
            "rightCorner": {
              "x": 19.908,
              "y": 23.045,
              "z": 1.426
            },
            "gtin": "8000500273470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21164",
            "leftCorner": {
              "x": 19.905,
              "y": 23.008,
              "z": 1.426
            },
            "rightCorner": {
              "x": 19.733,
              "y": 23.022,
              "z": 1.426
            },
            "gtin": "4008400322728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21165",
            "leftCorner": {
              "x": 19.733,
              "y": 23.022,
              "z": 1.426
            },
            "rightCorner": {
              "x": 19.559,
              "y": 23.037,
              "z": 1.426
            },
            "gtin": "4008400322728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21166",
            "leftCorner": {
              "x": 19.559,
              "y": 23.037,
              "z": 1.426
            },
            "rightCorner": {
              "x": 19.386,
              "y": 23.051,
              "z": 1.426
            },
            "gtin": "4008400322728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21167",
            "leftCorner": {
              "x": 19.386,
              "y": 23.047,
              "z": 1.426
            },
            "rightCorner": {
              "x": 19.2,
              "y": 23.063,
              "z": 1.426
            },
            "gtin": "8000500273449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21168",
            "leftCorner": {
              "x": 19.2,
              "y": 23.063,
              "z": 1.426
            },
            "rightCorner": {
              "x": 19.016,
              "y": 23.078,
              "z": 1.426
            },
            "gtin": "8000500273449",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "50a10"
  },
  {
    "id": "d135f",
    "name": "d135f",
    "x": 7.989,
    "y": 22.703,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.039521,
      "w": 0.99922
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 15
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5467dd",
        "height": 0.14947,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a5467dc",
        "height": 0.59652,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a5467db",
        "height": 0.945,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a5467da",
        "height": 1.4005,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e6c1",
            "leftCorner": {
              "x": 7.994,
              "y": 22.764,
              "z": 1.146
            },
            "rightCorner": {
              "x": 8.172,
              "y": 22.75,
              "z": 1.146
            },
            "gtin": "4031446402611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6c2",
            "leftCorner": {
              "x": 8.172,
              "y": 22.75,
              "z": 1.146
            },
            "rightCorner": {
              "x": 8.35,
              "y": 22.736,
              "z": 1.146
            },
            "gtin": "4031446402611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6c3",
            "leftCorner": {
              "x": 8.35,
              "y": 22.736,
              "z": 1.146
            },
            "rightCorner": {
              "x": 8.527,
              "y": 22.721,
              "z": 1.146
            },
            "gtin": "4031446402611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6c7",
            "leftCorner": {
              "x": 8.531,
              "y": 22.763,
              "z": 1.146
            },
            "rightCorner": {
              "x": 8.695,
              "y": 22.75,
              "z": 1.146
            },
            "gtin": "4031446835693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6c8",
            "leftCorner": {
              "x": 8.695,
              "y": 22.75,
              "z": 1.146
            },
            "rightCorner": {
              "x": 8.858,
              "y": 22.737,
              "z": 1.146
            },
            "gtin": "4031446835693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6c9",
            "leftCorner": {
              "x": 8.856,
              "y": 22.711,
              "z": 1.146
            },
            "rightCorner": {
              "x": 9.233,
              "y": 22.682,
              "z": 1.146
            },
            "gtin": "4031446887814",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5467d9",
        "height": 1.7486,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e6fc",
            "leftCorner": {
              "x": 7.992,
              "y": 22.743,
              "z": 1.431
            },
            "rightCorner": {
              "x": 8.22,
              "y": 22.725,
              "z": 1.431
            },
            "gtin": "8690504818571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e6fd",
            "leftCorner": {
              "x": 8.22,
              "y": 22.725,
              "z": 1.431
            },
            "rightCorner": {
              "x": 8.447,
              "y": 22.707,
              "z": 1.431
            },
            "gtin": "8690504818571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e701",
            "leftCorner": {
              "x": 8.452,
              "y": 22.774,
              "z": 1.431
            },
            "rightCorner": {
              "x": 8.65,
              "y": 22.758,
              "z": 1.431
            },
            "gtin": "4031446887654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e702",
            "leftCorner": {
              "x": 8.65,
              "y": 22.758,
              "z": 1.431
            },
            "rightCorner": {
              "x": 8.847,
              "y": 22.743,
              "z": 1.431
            },
            "gtin": "4031446887654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e703",
            "leftCorner": {
              "x": 8.845,
              "y": 22.713,
              "z": 1.431
            },
            "rightCorner": {
              "x": 8.883,
              "y": 22.71,
              "z": 1.431
            },
            "gtin": "4260168310076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e704",
            "leftCorner": {
              "x": 8.883,
              "y": 22.71,
              "z": 1.431
            },
            "rightCorner": {
              "x": 8.921,
              "y": 22.707,
              "z": 1.431
            },
            "gtin": "4260168310076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e705",
            "leftCorner": {
              "x": 8.921,
              "y": 22.707,
              "z": 1.431
            },
            "rightCorner": {
              "x": 8.958,
              "y": 22.703,
              "z": 1.431
            },
            "gtin": "4260168310076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e706",
            "leftCorner": {
              "x": 8.957,
              "y": 22.688,
              "z": 1.431
            },
            "rightCorner": {
              "x": 9.058,
              "y": 22.679,
              "z": 1.431
            },
            "gtin": "4031446802114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e707",
            "leftCorner": {
              "x": 9.059,
              "y": 22.689,
              "z": 1.431
            },
            "rightCorner": {
              "x": 9.233,
              "y": 22.676,
              "z": 1.431
            },
            "gtin": "4031446802015",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "50a19"
  },
  {
    "id": "d1360",
    "name": "d1360",
    "x": 20.459,
    "y": 26.345,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99968,
      "w": 0.02547
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 49
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54687a",
        "height": 1.017,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20158",
            "leftCorner": {
              "x": 20.115,
              "y": 26.309,
              "z": 0.832
            },
            "rightCorner": {
              "x": 19.986,
              "y": 26.315,
              "z": 0.832
            },
            "gtin": "9000331624273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20159",
            "leftCorner": {
              "x": 19.986,
              "y": 26.32,
              "z": 0.832
            },
            "rightCorner": {
              "x": 19.685,
              "y": 26.336,
              "z": 0.832
            },
            "gtin": "8717496862532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2015a",
            "leftCorner": {
              "x": 19.685,
              "y": 26.337,
              "z": 0.832
            },
            "rightCorner": {
              "x": 19.538,
              "y": 26.344,
              "z": 0.832
            },
            "gtin": "4001450143541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2015b",
            "leftCorner": {
              "x": 19.538,
              "y": 26.344,
              "z": 0.832
            },
            "rightCorner": {
              "x": 19.389,
              "y": 26.352,
              "z": 0.832
            },
            "gtin": "4001450143541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2015c",
            "leftCorner": {
              "x": 19.389,
              "y": 26.352,
              "z": 0.832
            },
            "rightCorner": {
              "x": 19.241,
              "y": 26.359,
              "z": 0.832
            },
            "gtin": "4001450143541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20155",
            "leftCorner": {
              "x": 20.459,
              "y": 26.335,
              "z": 0.832
            },
            "rightCorner": {
              "x": 20.117,
              "y": 26.353,
              "z": 0.832
            },
            "gtin": "8001585008056",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54687d",
        "height": 0.16362,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20285",
            "leftCorner": {
              "x": 20.459,
              "y": 26.33,
              "z": 0.134
            },
            "rightCorner": {
              "x": 20.262,
              "y": 26.341,
              "z": 0.134
            },
            "gtin": "4335896686905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20286",
            "leftCorner": {
              "x": 20.262,
              "y": 26.341,
              "z": 0.134
            },
            "rightCorner": {
              "x": 20.065,
              "y": 26.35,
              "z": 0.134
            },
            "gtin": "4335896686905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20288",
            "leftCorner": {
              "x": 20.063,
              "y": 26.302,
              "z": 0.134
            },
            "rightCorner": {
              "x": 19.837,
              "y": 26.314,
              "z": 0.134
            },
            "gtin": "4337185767845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20289",
            "leftCorner": {
              "x": 19.837,
              "y": 26.328,
              "z": 0.134
            },
            "rightCorner": {
              "x": 19.725,
              "y": 26.334,
              "z": 0.134
            },
            "gtin": "4337185767838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2028a",
            "leftCorner": {
              "x": 19.725,
              "y": 26.334,
              "z": 0.134
            },
            "rightCorner": {
              "x": 19.613,
              "y": 26.339,
              "z": 0.134
            },
            "gtin": "4337185767838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2028b",
            "leftCorner": {
              "x": 19.613,
              "y": 26.327,
              "z": 0.134
            },
            "rightCorner": {
              "x": 19.363,
              "y": 26.34,
              "z": 0.134
            },
            "gtin": "4337185466618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2028c",
            "leftCorner": {
              "x": 19.363,
              "y": 26.334,
              "z": 0.134
            },
            "rightCorner": {
              "x": 19.147,
              "y": 26.345,
              "z": 0.134
            },
            "gtin": "4337185466601",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54687c",
        "height": 0.65836,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2019c",
            "leftCorner": {
              "x": 20.458,
              "y": 26.318,
              "z": 0.539
            },
            "rightCorner": {
              "x": 20.195,
              "y": 26.331,
              "z": 0.539
            },
            "gtin": "8001585008063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2019f",
            "leftCorner": {
              "x": 20.192,
              "y": 26.294,
              "z": 0.539
            },
            "rightCorner": {
              "x": 20.033,
              "y": 26.302,
              "z": 0.539
            },
            "gtin": "8001585008070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201a0",
            "leftCorner": {
              "x": 20.033,
              "y": 26.302,
              "z": 0.539
            },
            "rightCorner": {
              "x": 19.873,
              "y": 26.311,
              "z": 0.539
            },
            "gtin": "8001585008070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201a1",
            "leftCorner": {
              "x": 19.873,
              "y": 26.305,
              "z": 0.539
            },
            "rightCorner": {
              "x": 19.695,
              "y": 26.314,
              "z": 0.539
            },
            "gtin": "4001450143732",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201a2",
            "leftCorner": {
              "x": 19.695,
              "y": 26.314,
              "z": 0.539
            },
            "rightCorner": {
              "x": 19.517,
              "y": 26.323,
              "z": 0.539
            },
            "gtin": "4001450143732",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201a3",
            "leftCorner": {
              "x": 19.517,
              "y": 26.323,
              "z": 0.539
            },
            "rightCorner": {
              "x": 19.338,
              "y": 26.332,
              "z": 0.539
            },
            "gtin": "4001450143732",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201a4",
            "leftCorner": {
              "x": 19.338,
              "y": 26.332,
              "z": 0.539
            },
            "rightCorner": {
              "x": 19.16,
              "y": 26.341,
              "z": 0.539
            },
            "gtin": "4001450143732",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546879",
        "height": 1.3662,
        "facings": [
          {
            "id": "68300c895ed67a01d9a201d7",
            "leftCorner": {
              "x": 20.458,
              "y": 26.326,
              "z": 1.118
            },
            "rightCorner": {
              "x": 20.385,
              "y": 26.33,
              "z": 1.118
            },
            "gtin": "4063367358012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201d8",
            "leftCorner": {
              "x": 20.385,
              "y": 26.33,
              "z": 1.118
            },
            "rightCorner": {
              "x": 20.311,
              "y": 26.334,
              "z": 1.118
            },
            "gtin": "4063367358012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201d9",
            "leftCorner": {
              "x": 20.311,
              "y": 26.334,
              "z": 1.118
            },
            "rightCorner": {
              "x": 20.238,
              "y": 26.337,
              "z": 1.118
            },
            "gtin": "4063367358012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201da",
            "leftCorner": {
              "x": 20.238,
              "y": 26.337,
              "z": 1.118
            },
            "rightCorner": {
              "x": 20.164,
              "y": 26.341,
              "z": 1.118
            },
            "gtin": "4063367358012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201dd",
            "leftCorner": {
              "x": 20.162,
              "y": 26.298,
              "z": 1.118
            },
            "rightCorner": {
              "x": 20.083,
              "y": 26.303,
              "z": 1.118
            },
            "gtin": "4012836000907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201de",
            "leftCorner": {
              "x": 20.083,
              "y": 26.303,
              "z": 1.118
            },
            "rightCorner": {
              "x": 20.004,
              "y": 26.307,
              "z": 1.118
            },
            "gtin": "4012836000907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201df",
            "leftCorner": {
              "x": 20.004,
              "y": 26.309,
              "z": 1.118
            },
            "rightCorner": {
              "x": 19.955,
              "y": 26.311,
              "z": 1.118
            },
            "gtin": "4012836000334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201e0",
            "leftCorner": {
              "x": 19.955,
              "y": 26.311,
              "z": 1.118
            },
            "rightCorner": {
              "x": 19.907,
              "y": 26.314,
              "z": 1.118
            },
            "gtin": "4012836000334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201e1",
            "leftCorner": {
              "x": 19.907,
              "y": 26.314,
              "z": 1.118
            },
            "rightCorner": {
              "x": 19.786,
              "y": 26.32,
              "z": 1.118
            },
            "gtin": "4012836000570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201e2",
            "leftCorner": {
              "x": 19.788,
              "y": 26.338,
              "z": 1.118
            },
            "rightCorner": {
              "x": 19.732,
              "y": 26.342,
              "z": 1.118
            },
            "gtin": "4015537002720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201e3",
            "leftCorner": {
              "x": 19.732,
              "y": 26.342,
              "z": 1.118
            },
            "rightCorner": {
              "x": 19.676,
              "y": 26.344,
              "z": 1.118
            },
            "gtin": "4015537002720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201e4",
            "leftCorner": {
              "x": 19.675,
              "y": 26.324,
              "z": 1.118
            },
            "rightCorner": {
              "x": 19.587,
              "y": 26.329,
              "z": 1.118
            },
            "gtin": "4015537002744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201e5",
            "leftCorner": {
              "x": 19.589,
              "y": 26.345,
              "z": 1.118
            },
            "rightCorner": {
              "x": 19.473,
              "y": 26.35,
              "z": 1.118
            },
            "gtin": "4015537002737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201e6",
            "leftCorner": {
              "x": 19.473,
              "y": 26.346,
              "z": 1.118
            },
            "rightCorner": {
              "x": 19.321,
              "y": 26.353,
              "z": 1.118
            },
            "gtin": "8717496860491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a201e7",
            "leftCorner": {
              "x": 19.321,
              "y": 26.354,
              "z": 1.118
            },
            "rightCorner": {
              "x": 19.233,
              "y": 26.359,
              "z": 1.118
            },
            "gtin": "8717496861429",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54687b",
        "height": 1.6665,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20226",
            "leftCorner": {
              "x": 20.458,
              "y": 26.327,
              "z": 1.364
            },
            "rightCorner": {
              "x": 20.39,
              "y": 26.33,
              "z": 1.364
            },
            "gtin": "5908234813661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20227",
            "leftCorner": {
              "x": 20.39,
              "y": 26.33,
              "z": 1.364
            },
            "rightCorner": {
              "x": 20.322,
              "y": 26.334,
              "z": 1.364
            },
            "gtin": "5908234813661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20228",
            "leftCorner": {
              "x": 20.322,
              "y": 26.334,
              "z": 1.364
            },
            "rightCorner": {
              "x": 20.254,
              "y": 26.338,
              "z": 1.364
            },
            "gtin": "5908234813661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2022a",
            "leftCorner": {
              "x": 20.252,
              "y": 26.311,
              "z": 1.364
            },
            "rightCorner": {
              "x": 20.137,
              "y": 26.316,
              "z": 1.364
            },
            "gtin": "5908234813647",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2022b",
            "leftCorner": {
              "x": 20.137,
              "y": 26.316,
              "z": 1.364
            },
            "rightCorner": {
              "x": 20.022,
              "y": 26.322,
              "z": 1.364
            },
            "gtin": "5908234813647",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2022c",
            "leftCorner": {
              "x": 20.021,
              "y": 26.303,
              "z": 1.364
            },
            "rightCorner": {
              "x": 19.877,
              "y": 26.31,
              "z": 1.364
            },
            "gtin": "4260689480203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2022d",
            "leftCorner": {
              "x": 19.878,
              "y": 26.319,
              "z": 1.364
            },
            "rightCorner": {
              "x": 19.731,
              "y": 26.328,
              "z": 1.364
            },
            "gtin": "4260689480241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2022e",
            "leftCorner": {
              "x": 19.731,
              "y": 26.326,
              "z": 1.364
            },
            "rightCorner": {
              "x": 19.655,
              "y": 26.33,
              "z": 1.364
            },
            "gtin": "4015537001112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2022f",
            "leftCorner": {
              "x": 19.655,
              "y": 26.327,
              "z": 1.364
            },
            "rightCorner": {
              "x": 19.538,
              "y": 26.333,
              "z": 1.364
            },
            "gtin": "8008698004708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20230",
            "leftCorner": {
              "x": 19.538,
              "y": 26.339,
              "z": 1.364
            },
            "rightCorner": {
              "x": 19.484,
              "y": 26.342,
              "z": 1.364
            },
            "gtin": "8008698005286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20231",
            "leftCorner": {
              "x": 19.484,
              "y": 26.342,
              "z": 1.364
            },
            "rightCorner": {
              "x": 19.432,
              "y": 26.344,
              "z": 1.364
            },
            "gtin": "8008698005286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20232",
            "leftCorner": {
              "x": 19.431,
              "y": 26.338,
              "z": 1.364
            },
            "rightCorner": {
              "x": 19.323,
              "y": 26.344,
              "z": 1.364
            },
            "gtin": "8008698026281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20233",
            "leftCorner": {
              "x": 19.322,
              "y": 26.341,
              "z": 1.364
            },
            "rightCorner": {
              "x": 19.249,
              "y": 26.345,
              "z": 1.364
            },
            "gtin": "8008698012956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20234",
            "leftCorner": {
              "x": 19.249,
              "y": 26.345,
              "z": 1.364
            },
            "rightCorner": {
              "x": 19.174,
              "y": 26.348,
              "z": 1.364
            },
            "gtin": "8008698012956",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "41a94"
  },
  {
    "id": "d1381",
    "name": "d1381",
    "x": 8.172,
    "y": 26.02,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.029623,
      "w": 0.99956
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 51
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546848",
        "height": 0.14638,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eca8",
            "leftCorner": {
              "x": 8.171,
              "y": 25.997,
              "z": 0.12
            },
            "rightCorner": {
              "x": 8.265,
              "y": 25.992,
              "z": 0.12
            },
            "gtin": "7622210007469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eca9",
            "leftCorner": {
              "x": 8.265,
              "y": 25.992,
              "z": 0.12
            },
            "rightCorner": {
              "x": 8.359,
              "y": 25.986,
              "z": 0.12
            },
            "gtin": "7622210007469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecaa",
            "leftCorner": {
              "x": 8.359,
              "y": 25.986,
              "z": 0.12
            },
            "rightCorner": {
              "x": 8.453,
              "y": 25.981,
              "z": 0.12
            },
            "gtin": "7622210007469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecab",
            "leftCorner": {
              "x": 8.453,
              "y": 25.981,
              "z": 0.12
            },
            "rightCorner": {
              "x": 8.547,
              "y": 25.975,
              "z": 0.12
            },
            "gtin": "7622210007469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecad",
            "leftCorner": {
              "x": 8.548,
              "y": 25.985,
              "z": 0.12
            },
            "rightCorner": {
              "x": 8.93,
              "y": 25.962,
              "z": 0.12
            },
            "gtin": "7622210826251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecae",
            "leftCorner": {
              "x": 8.933,
              "y": 26.009,
              "z": 0.12
            },
            "rightCorner": {
              "x": 9.163,
              "y": 25.995,
              "z": 0.12
            },
            "gtin": "7622300617820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecaf",
            "leftCorner": {
              "x": 9.163,
              "y": 26.005,
              "z": 0.12
            },
            "rightCorner": {
              "x": 9.326,
              "y": 25.996,
              "z": 0.12
            },
            "gtin": "7622201120931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecb0",
            "leftCorner": {
              "x": 9.326,
              "y": 25.996,
              "z": 0.12
            },
            "rightCorner": {
              "x": 9.489,
              "y": 25.986,
              "z": 0.12
            },
            "gtin": "7622201120931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ecb1",
            "leftCorner": {
              "x": 9.489,
              "y": 25.986,
              "z": 0.12
            },
            "rightCorner": {
              "x": 9.651,
              "y": 25.976,
              "z": 0.12
            },
            "gtin": "7622201120931",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546846",
        "height": 0.44572,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ed14",
            "leftCorner": {
              "x": 8.171,
              "y": 26.002,
              "z": 0.365
            },
            "rightCorner": {
              "x": 8.299,
              "y": 25.995,
              "z": 0.365
            },
            "gtin": "7622300291785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed15",
            "leftCorner": {
              "x": 8.299,
              "y": 25.995,
              "z": 0.365
            },
            "rightCorner": {
              "x": 8.426,
              "y": 25.987,
              "z": 0.365
            },
            "gtin": "7622300291785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed16",
            "leftCorner": {
              "x": 8.426,
              "y": 25.987,
              "z": 0.365
            },
            "rightCorner": {
              "x": 8.554,
              "y": 25.98,
              "z": 0.365
            },
            "gtin": "7622300291785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed1b",
            "leftCorner": {
              "x": 8.555,
              "y": 26.001,
              "z": 0.365
            },
            "rightCorner": {
              "x": 8.721,
              "y": 25.991,
              "z": 0.365
            },
            "gtin": "7622400005190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed1c",
            "leftCorner": {
              "x": 8.722,
              "y": 26.007,
              "z": 0.365
            },
            "rightCorner": {
              "x": 8.82,
              "y": 26.002,
              "z": 0.365
            },
            "gtin": "7622400719066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed1d",
            "leftCorner": {
              "x": 8.82,
              "y": 26.002,
              "z": 0.365
            },
            "rightCorner": {
              "x": 8.917,
              "y": 25.995,
              "z": 0.365
            },
            "gtin": "7622400719066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed1e",
            "leftCorner": {
              "x": 8.918,
              "y": 26.007,
              "z": 0.365
            },
            "rightCorner": {
              "x": 9.034,
              "y": 26.0,
              "z": 0.365
            },
            "gtin": "3045140280902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed1f",
            "leftCorner": {
              "x": 9.034,
              "y": 26.0,
              "z": 0.365
            },
            "rightCorner": {
              "x": 9.151,
              "y": 25.994,
              "z": 0.365
            },
            "gtin": "3045140280902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed20",
            "leftCorner": {
              "x": 9.152,
              "y": 26.01,
              "z": 0.365
            },
            "rightCorner": {
              "x": 9.255,
              "y": 26.003,
              "z": 0.365
            },
            "gtin": "4025700001962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed21",
            "leftCorner": {
              "x": 9.255,
              "y": 26.003,
              "z": 0.365
            },
            "rightCorner": {
              "x": 9.357,
              "y": 25.997,
              "z": 0.365
            },
            "gtin": "4025700001962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ed22",
            "leftCorner": {
              "x": 9.357,
              "y": 25.997,
              "z": 0.365
            },
            "rightCorner": {
              "x": 9.46,
              "y": 25.991,
              "z": 0.365
            },
            "gtin": "4025700001962",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546845",
        "height": 0.75066,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eb6e",
            "leftCorner": {
              "x": 8.171,
              "y": 26.006,
              "z": 0.614
            },
            "rightCorner": {
              "x": 8.319,
              "y": 25.998,
              "z": 0.614
            },
            "gtin": "7622201814083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb6f",
            "leftCorner": {
              "x": 8.319,
              "y": 25.998,
              "z": 0.614
            },
            "rightCorner": {
              "x": 8.467,
              "y": 25.989,
              "z": 0.614
            },
            "gtin": "7622201814083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb70",
            "leftCorner": {
              "x": 8.467,
              "y": 25.989,
              "z": 0.614
            },
            "rightCorner": {
              "x": 8.615,
              "y": 25.979,
              "z": 0.614
            },
            "gtin": "7622201814083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb71",
            "leftCorner": {
              "x": 8.615,
              "y": 25.979,
              "z": 0.614
            },
            "rightCorner": {
              "x": 8.763,
              "y": 25.971,
              "z": 0.614
            },
            "gtin": "7622201814083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb74",
            "leftCorner": {
              "x": 8.765,
              "y": 26.002,
              "z": 0.614
            },
            "rightCorner": {
              "x": 8.845,
              "y": 25.998,
              "z": 0.614
            },
            "gtin": "7622201814038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb75",
            "leftCorner": {
              "x": 8.845,
              "y": 25.998,
              "z": 0.614
            },
            "rightCorner": {
              "x": 8.925,
              "y": 25.993,
              "z": 0.614
            },
            "gtin": "7622201814038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb76",
            "leftCorner": {
              "x": 8.926,
              "y": 26.002,
              "z": 0.614
            },
            "rightCorner": {
              "x": 9.037,
              "y": 25.995,
              "z": 0.614
            },
            "gtin": "7622201813598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb77",
            "leftCorner": {
              "x": 9.037,
              "y": 25.995,
              "z": 0.614
            },
            "rightCorner": {
              "x": 9.149,
              "y": 25.989,
              "z": 0.614
            },
            "gtin": "7622201813598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb78",
            "leftCorner": {
              "x": 9.15,
              "y": 26.005,
              "z": 0.614
            },
            "rightCorner": {
              "x": 9.236,
              "y": 26.0,
              "z": 0.614
            },
            "gtin": "7622201753009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb79",
            "leftCorner": {
              "x": 9.236,
              "y": 26.0,
              "z": 0.614
            },
            "rightCorner": {
              "x": 9.322,
              "y": 25.994,
              "z": 0.614
            },
            "gtin": "7622201753009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb7a",
            "leftCorner": {
              "x": 9.322,
              "y": 25.994,
              "z": 0.614
            },
            "rightCorner": {
              "x": 9.409,
              "y": 25.989,
              "z": 0.614
            },
            "gtin": "7622201753009",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546844",
        "height": 0.99574,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eb27",
            "leftCorner": {
              "x": 8.17,
              "y": 25.99,
              "z": 0.815
            },
            "rightCorner": {
              "x": 8.37,
              "y": 25.978,
              "z": 0.815
            },
            "gtin": "7622300134532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb28",
            "leftCorner": {
              "x": 8.37,
              "y": 25.978,
              "z": 0.815
            },
            "rightCorner": {
              "x": 8.57,
              "y": 25.966,
              "z": 0.815
            },
            "gtin": "7622300134532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb29",
            "leftCorner": {
              "x": 8.57,
              "y": 25.966,
              "z": 0.815
            },
            "rightCorner": {
              "x": 8.77,
              "y": 25.954,
              "z": 0.815
            },
            "gtin": "7622300134532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb2c",
            "leftCorner": {
              "x": 8.772,
              "y": 25.988,
              "z": 0.815
            },
            "rightCorner": {
              "x": 9.055,
              "y": 25.971,
              "z": 0.815
            },
            "gtin": "7622202258091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb2d",
            "leftCorner": {
              "x": 9.056,
              "y": 25.999,
              "z": 0.815
            },
            "rightCorner": {
              "x": 9.233,
              "y": 25.989,
              "z": 0.815
            },
            "gtin": "7622210653215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eb2e",
            "leftCorner": {
              "x": 9.233,
              "y": 25.989,
              "z": 0.815
            },
            "rightCorner": {
              "x": 9.41,
              "y": 25.978,
              "z": 0.815
            },
            "gtin": "7622210653215",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546843",
        "height": 1.2558,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ebda",
            "leftCorner": {
              "x": 8.169,
              "y": 25.976,
              "z": 1.027
            },
            "rightCorner": {
              "x": 8.367,
              "y": 25.965,
              "z": 1.027
            },
            "gtin": "7622300695477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebdb",
            "leftCorner": {
              "x": 8.367,
              "y": 25.965,
              "z": 1.027
            },
            "rightCorner": {
              "x": 8.565,
              "y": 25.952,
              "z": 1.027
            },
            "gtin": "7622300695477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebdc",
            "leftCorner": {
              "x": 8.565,
              "y": 25.952,
              "z": 1.027
            },
            "rightCorner": {
              "x": 8.763,
              "y": 25.94,
              "z": 1.027
            },
            "gtin": "7622300695477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebe0",
            "leftCorner": {
              "x": 8.767,
              "y": 25.995,
              "z": 1.027
            },
            "rightCorner": {
              "x": 8.975,
              "y": 25.984,
              "z": 1.027
            },
            "gtin": "7622201638948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebe1",
            "leftCorner": {
              "x": 8.975,
              "y": 25.984,
              "z": 1.027
            },
            "rightCorner": {
              "x": 9.184,
              "y": 25.971,
              "z": 1.027
            },
            "gtin": "7622201638948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ebe2",
            "leftCorner": {
              "x": 9.184,
              "y": 25.971,
              "z": 1.027
            },
            "rightCorner": {
              "x": 9.393,
              "y": 25.959,
              "z": 1.027
            },
            "gtin": "7622201638948",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546847",
        "height": 1.4985,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ec43",
            "leftCorner": {
              "x": 8.17,
              "y": 25.987,
              "z": 1.226
            },
            "rightCorner": {
              "x": 8.466,
              "y": 25.97,
              "z": 1.226
            },
            "gtin": "7622210609830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec44",
            "leftCorner": {
              "x": 8.466,
              "y": 25.97,
              "z": 1.226
            },
            "rightCorner": {
              "x": 8.762,
              "y": 25.952,
              "z": 1.226
            },
            "gtin": "7622210609830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec47",
            "leftCorner": {
              "x": 8.764,
              "y": 25.99,
              "z": 1.226
            },
            "rightCorner": {
              "x": 8.912,
              "y": 25.982,
              "z": 1.226
            },
            "gtin": "7622200004515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec48",
            "leftCorner": {
              "x": 8.912,
              "y": 25.982,
              "z": 1.226
            },
            "rightCorner": {
              "x": 9.06,
              "y": 25.973,
              "z": 1.226
            },
            "gtin": "7622200004515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ec49",
            "leftCorner": {
              "x": 9.061,
              "y": 25.987,
              "z": 1.226
            },
            "rightCorner": {
              "x": 9.387,
              "y": 25.968,
              "z": 1.226
            },
            "gtin": "7622210732507",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546849",
        "height": 1.7484,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eac7",
            "leftCorner": {
              "x": 8.17,
              "y": 25.992,
              "z": 1.43
            },
            "rightCorner": {
              "x": 8.604,
              "y": 25.966,
              "z": 1.43
            },
            "gtin": "7622200009084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eac8",
            "leftCorner": {
              "x": 8.604,
              "y": 25.966,
              "z": 1.43
            },
            "rightCorner": {
              "x": 9.038,
              "y": 25.94,
              "z": 1.43
            },
            "gtin": "7622200009084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eacb",
            "leftCorner": {
              "x": 9.04,
              "y": 25.983,
              "z": 1.43
            },
            "rightCorner": {
              "x": 9.39,
              "y": 25.963,
              "z": 1.43
            },
            "gtin": "7622210277503",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "41a81"
  },
  {
    "id": "d1382",
    "name": "d1382",
    "x": 19.098,
    "y": 7.098,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99916,
      "w": 0.040899
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 12
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5461a3",
        "height": 0.14734,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a5461a2",
        "height": 0.55046,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d485",
            "leftCorner": {
              "x": 19.097,
              "y": 7.081,
              "z": 0.45
            },
            "rightCorner": {
              "x": 18.844,
              "y": 7.102,
              "z": 0.45
            },
            "gtin": "4337185460562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d486",
            "leftCorner": {
              "x": 18.844,
              "y": 7.102,
              "z": 0.45
            },
            "rightCorner": {
              "x": 18.591,
              "y": 7.122,
              "z": 0.45
            },
            "gtin": "4337185460562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d487",
            "leftCorner": {
              "x": 18.591,
              "y": 7.122,
              "z": 0.45
            },
            "rightCorner": {
              "x": 18.336,
              "y": 7.143,
              "z": 0.45
            },
            "gtin": "4337185460562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d488",
            "leftCorner": {
              "x": 18.336,
              "y": 7.143,
              "z": 0.45
            },
            "rightCorner": {
              "x": 18.083,
              "y": 7.164,
              "z": 0.45
            },
            "gtin": "4337185460562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d48c",
            "leftCorner": {
              "x": 18.081,
              "y": 7.125,
              "z": 0.45
            },
            "rightCorner": {
              "x": 17.493,
              "y": 7.173,
              "z": 0.45
            },
            "gtin": "8594003464263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d48d",
            "leftCorner": {
              "x": 17.493,
              "y": 7.173,
              "z": 0.45
            },
            "rightCorner": {
              "x": 16.907,
              "y": 7.221,
              "z": 0.45
            },
            "gtin": "8594003464263",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461a0",
        "height": 0.95346,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d3f8",
            "leftCorner": {
              "x": 19.097,
              "y": 7.083,
              "z": 0.78
            },
            "rightCorner": {
              "x": 18.45,
              "y": 7.136,
              "z": 0.78
            },
            "gtin": "4337185460531",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3fb",
            "leftCorner": {
              "x": 18.446,
              "y": 7.096,
              "z": 0.78
            },
            "rightCorner": {
              "x": 17.807,
              "y": 7.149,
              "z": 0.78
            },
            "gtin": "4006196029111",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461a4",
        "height": 1.3553,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a5461a1",
        "height": 1.7073,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d410",
            "leftCorner": {
              "x": 19.097,
              "y": 7.086,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.678,
              "y": 7.12,
              "z": 1.397
            },
            "gtin": "4337185457043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d411",
            "leftCorner": {
              "x": 18.678,
              "y": 7.12,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.258,
              "y": 7.155,
              "z": 1.397
            },
            "gtin": "4337185457043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d413",
            "leftCorner": {
              "x": 18.255,
              "y": 7.112,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.008,
              "y": 7.133,
              "z": 1.397
            },
            "gtin": "4337185460630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d414",
            "leftCorner": {
              "x": 18.008,
              "y": 7.133,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.76,
              "y": 7.153,
              "z": 1.397
            },
            "gtin": "4337185460630",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "b6f7b"
  },
  {
    "id": "d1384",
    "name": "d1384",
    "x": 18.926,
    "y": 3.828,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99942,
      "w": 0.034036
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 21
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5461c5",
        "height": 0.14937,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d59d",
            "leftCorner": {
              "x": 18.926,
              "y": 3.822,
              "z": 0.122
            },
            "rightCorner": {
              "x": 18.7,
              "y": 3.837,
              "z": 0.122
            },
            "gtin": "4337185593321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d59e",
            "leftCorner": {
              "x": 18.7,
              "y": 3.837,
              "z": 0.122
            },
            "rightCorner": {
              "x": 18.476,
              "y": 3.853,
              "z": 0.122
            },
            "gtin": "4337185593321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5a0",
            "leftCorner": {
              "x": 18.472,
              "y": 3.799,
              "z": 0.122
            },
            "rightCorner": {
              "x": 18.285,
              "y": 3.811,
              "z": 0.122
            },
            "gtin": "5414624098278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5a1",
            "leftCorner": {
              "x": 18.285,
              "y": 3.811,
              "z": 0.122
            },
            "rightCorner": {
              "x": 18.098,
              "y": 3.824,
              "z": 0.122
            },
            "gtin": "5414624098278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5a2",
            "leftCorner": {
              "x": 18.1,
              "y": 3.845,
              "z": 0.122
            },
            "rightCorner": {
              "x": 17.887,
              "y": 3.859,
              "z": 0.122
            },
            "gtin": "8595564521280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5a3",
            "leftCorner": {
              "x": 17.887,
              "y": 3.859,
              "z": 0.122
            },
            "rightCorner": {
              "x": 17.675,
              "y": 3.874,
              "z": 0.122
            },
            "gtin": "8595564521280",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461c4",
        "height": 0.84917,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d595",
            "leftCorner": {
              "x": 18.925,
              "y": 3.818,
              "z": 0.695
            },
            "rightCorner": {
              "x": 18.819,
              "y": 3.826,
              "z": 0.695
            },
            "gtin": "4008713712971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d596",
            "leftCorner": {
              "x": 18.819,
              "y": 3.826,
              "z": 0.695
            },
            "rightCorner": {
              "x": 18.713,
              "y": 3.833,
              "z": 0.695
            },
            "gtin": "4008713712971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d598",
            "leftCorner": {
              "x": 18.71,
              "y": 3.792,
              "z": 0.695
            },
            "rightCorner": {
              "x": 18.385,
              "y": 3.814,
              "z": 0.695
            },
            "gtin": "8595564521303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d599",
            "leftCorner": {
              "x": 18.385,
              "y": 3.814,
              "z": 0.695
            },
            "rightCorner": {
              "x": 18.061,
              "y": 3.836,
              "z": 0.695
            },
            "gtin": "8595564521303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d59a",
            "leftCorner": {
              "x": 18.061,
              "y": 3.836,
              "z": 0.695
            },
            "rightCorner": {
              "x": 17.736,
              "y": 3.858,
              "z": 0.695
            },
            "gtin": "8595564521303",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461c3",
        "height": 1.2541,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d589",
            "leftCorner": {
              "x": 18.925,
              "y": 3.816,
              "z": 1.026
            },
            "rightCorner": {
              "x": 18.712,
              "y": 3.83,
              "z": 1.026
            },
            "gtin": "4005528126313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d58a",
            "leftCorner": {
              "x": 18.712,
              "y": 3.83,
              "z": 1.026
            },
            "rightCorner": {
              "x": 18.499,
              "y": 3.845,
              "z": 1.026
            },
            "gtin": "4005528126313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d58d",
            "leftCorner": {
              "x": 18.497,
              "y": 3.81,
              "z": 1.026
            },
            "rightCorner": {
              "x": 18.302,
              "y": 3.824,
              "z": 1.026
            },
            "gtin": "4063367448003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d58e",
            "leftCorner": {
              "x": 18.302,
              "y": 3.824,
              "z": 1.026
            },
            "rightCorner": {
              "x": 18.106,
              "y": 3.837,
              "z": 1.026
            },
            "gtin": "4063367448003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d58f",
            "leftCorner": {
              "x": 18.106,
              "y": 3.836,
              "z": 1.026
            },
            "rightCorner": {
              "x": 17.885,
              "y": 3.851,
              "z": 1.026
            },
            "gtin": "4005528127372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d590",
            "leftCorner": {
              "x": 17.885,
              "y": 3.851,
              "z": 1.026
            },
            "rightCorner": {
              "x": 17.665,
              "y": 3.866,
              "z": 1.026
            },
            "gtin": "4005528127372",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461c2",
        "height": 1.7088,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d55f",
            "leftCorner": {
              "x": 18.924,
              "y": 3.81,
              "z": 1.398
            },
            "rightCorner": {
              "x": 18.715,
              "y": 3.824,
              "z": 1.398
            },
            "gtin": "4005528119865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d560",
            "leftCorner": {
              "x": 18.715,
              "y": 3.824,
              "z": 1.398
            },
            "rightCorner": {
              "x": 18.506,
              "y": 3.839,
              "z": 1.398
            },
            "gtin": "4005528119865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d562",
            "leftCorner": {
              "x": 18.503,
              "y": 3.799,
              "z": 1.398
            },
            "rightCorner": {
              "x": 18.094,
              "y": 3.826,
              "z": 1.398
            },
            "gtin": "8595564521266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d563",
            "leftCorner": {
              "x": 18.094,
              "y": 3.83,
              "z": 1.398
            },
            "rightCorner": {
              "x": 17.68,
              "y": 3.858,
              "z": 1.398
            },
            "gtin": "8595564521327",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "e025f"
  },
  {
    "id": "d1391",
    "name": "d1391",
    "x": 8.457,
    "y": 29.046,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.035676,
      "w": 0.99936
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 57
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a54666d",
        "height": 0.49766,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20b3b",
            "leftCorner": {
              "x": 8.468,
              "y": 29.201,
              "z": 0.407
            },
            "rightCorner": {
              "x": 8.769,
              "y": 29.179,
              "z": 0.407
            },
            "gtin": "4066627164750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b3d",
            "leftCorner": {
              "x": 8.772,
              "y": 29.221,
              "z": 0.407
            },
            "rightCorner": {
              "x": 9.314,
              "y": 29.182,
              "z": 0.407
            },
            "gtin": "4066627090448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b3e",
            "leftCorner": {
              "x": 9.314,
              "y": 29.182,
              "z": 0.407
            },
            "rightCorner": {
              "x": 9.486,
              "y": 29.169,
              "z": 0.407
            },
            "gtin": "4066632042432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b3f",
            "leftCorner": {
              "x": 9.486,
              "y": 29.17,
              "z": 0.407
            },
            "rightCorner": {
              "x": 9.66,
              "y": 29.157,
              "z": 0.407
            },
            "gtin": "4066627164767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b3c",
            "leftCorner": {
              "x": 9.659,
              "y": 29.15,
              "z": 0.407
            },
            "rightCorner": {
              "x": 9.817,
              "y": 29.139,
              "z": 0.407
            },
            "gtin": "4066627299476",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54666b",
        "height": 0.55561,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20b29",
            "leftCorner": {
              "x": 8.469,
              "y": 29.21,
              "z": 0.455
            },
            "rightCorner": {
              "x": 8.644,
              "y": 29.198,
              "z": 0.455
            },
            "gtin": "4066632042425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b2b",
            "leftCorner": {
              "x": 8.648,
              "y": 29.247,
              "z": 0.455
            },
            "rightCorner": {
              "x": 8.772,
              "y": 29.238,
              "z": 0.455
            },
            "gtin": "4066627311536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b2c",
            "leftCorner": {
              "x": 8.772,
              "y": 29.235,
              "z": 0.455
            },
            "rightCorner": {
              "x": 9.157,
              "y": 29.208,
              "z": 0.455
            },
            "gtin": "4066627311529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b2d",
            "leftCorner": {
              "x": 9.156,
              "y": 29.198,
              "z": 0.455
            },
            "rightCorner": {
              "x": 9.198,
              "y": 29.195,
              "z": 0.455
            },
            "gtin": "4066627311420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b2e",
            "leftCorner": {
              "x": 9.199,
              "y": 29.207,
              "z": 0.455
            },
            "rightCorner": {
              "x": 9.366,
              "y": 29.194,
              "z": 0.455
            },
            "gtin": "4066627165498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b2f",
            "leftCorner": {
              "x": 9.366,
              "y": 29.194,
              "z": 0.455
            },
            "rightCorner": {
              "x": 9.533,
              "y": 29.183,
              "z": 0.455
            },
            "gtin": "4066627165498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b30",
            "leftCorner": {
              "x": 9.532,
              "y": 29.17,
              "z": 0.455
            },
            "rightCorner": {
              "x": 9.675,
              "y": 29.159,
              "z": 0.455
            },
            "gtin": "4066627249440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b2a",
            "leftCorner": {
              "x": 9.675,
              "y": 29.159,
              "z": 0.455
            },
            "rightCorner": {
              "x": 9.818,
              "y": 29.149,
              "z": 0.455
            },
            "gtin": "4066627249457",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54666c",
        "height": 0.79578,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20b31",
            "leftCorner": {
              "x": 8.468,
              "y": 29.204,
              "z": 0.651
            },
            "rightCorner": {
              "x": 8.551,
              "y": 29.197,
              "z": 0.651
            },
            "gtin": "4066627165221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b32",
            "leftCorner": {
              "x": 8.551,
              "y": 29.197,
              "z": 0.651
            },
            "rightCorner": {
              "x": 8.634,
              "y": 29.191,
              "z": 0.651
            },
            "gtin": "4066627165221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b34",
            "leftCorner": {
              "x": 8.638,
              "y": 29.241,
              "z": 0.651
            },
            "rightCorner": {
              "x": 8.758,
              "y": 29.233,
              "z": 0.651
            },
            "gtin": "4066627299445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b35",
            "leftCorner": {
              "x": 8.758,
              "y": 29.233,
              "z": 0.651
            },
            "rightCorner": {
              "x": 8.878,
              "y": 29.224,
              "z": 0.651
            },
            "gtin": "4066627299445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b36",
            "leftCorner": {
              "x": 8.878,
              "y": 29.224,
              "z": 0.651
            },
            "rightCorner": {
              "x": 8.998,
              "y": 29.215,
              "z": 0.651
            },
            "gtin": "4066627299445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b37",
            "leftCorner": {
              "x": 8.997,
              "y": 29.205,
              "z": 0.651
            },
            "rightCorner": {
              "x": 9.304,
              "y": 29.184,
              "z": 0.651
            },
            "gtin": "4066627311482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b38",
            "leftCorner": {
              "x": 9.304,
              "y": 29.18,
              "z": 0.651
            },
            "rightCorner": {
              "x": 9.547,
              "y": 29.163,
              "z": 0.651
            },
            "gtin": "4066627299438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b39",
            "leftCorner": {
              "x": 9.546,
              "y": 29.145,
              "z": 0.651
            },
            "rightCorner": {
              "x": 9.61,
              "y": 29.141,
              "z": 0.651
            },
            "gtin": "4066627311437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b3a",
            "leftCorner": {
              "x": 9.611,
              "y": 29.165,
              "z": 0.651
            },
            "rightCorner": {
              "x": 9.712,
              "y": 29.158,
              "z": 0.651
            },
            "gtin": "4066627242878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b33",
            "leftCorner": {
              "x": 9.711,
              "y": 29.141,
              "z": 0.651
            },
            "rightCorner": {
              "x": 9.817,
              "y": 29.133,
              "z": 0.651
            },
            "gtin": "4066632049295",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546669",
        "height": 1.1094,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20b13",
            "leftCorner": {
              "x": 8.468,
              "y": 29.203,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.616,
              "y": 29.192,
              "z": 0.908
            },
            "gtin": "4066627299469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b15",
            "leftCorner": {
              "x": 8.619,
              "y": 29.234,
              "z": 0.908
            },
            "rightCorner": {
              "x": 8.8,
              "y": 29.221,
              "z": 0.908
            },
            "gtin": "4066627183973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b16",
            "leftCorner": {
              "x": 8.8,
              "y": 29.216,
              "z": 0.908
            },
            "rightCorner": {
              "x": 9.031,
              "y": 29.2,
              "z": 0.908
            },
            "gtin": "4066627165160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b17",
            "leftCorner": {
              "x": 9.032,
              "y": 29.207,
              "z": 0.908
            },
            "rightCorner": {
              "x": 9.168,
              "y": 29.197,
              "z": 0.908
            },
            "gtin": "4066627299278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b18",
            "leftCorner": {
              "x": 9.167,
              "y": 29.186,
              "z": 0.908
            },
            "rightCorner": {
              "x": 9.281,
              "y": 29.178,
              "z": 0.908
            },
            "gtin": "4066627299261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b19",
            "leftCorner": {
              "x": 9.282,
              "y": 29.187,
              "z": 0.908
            },
            "rightCorner": {
              "x": 9.398,
              "y": 29.179,
              "z": 0.908
            },
            "gtin": "4066627299247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b1a",
            "leftCorner": {
              "x": 9.398,
              "y": 29.175,
              "z": 0.908
            },
            "rightCorner": {
              "x": 9.615,
              "y": 29.16,
              "z": 0.908
            },
            "gtin": "4066632042760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b1b",
            "leftCorner": {
              "x": 9.614,
              "y": 29.152,
              "z": 0.908
            },
            "rightCorner": {
              "x": 9.734,
              "y": 29.143,
              "z": 0.908
            },
            "gtin": "4066627311321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b14",
            "leftCorner": {
              "x": 9.734,
              "y": 29.144,
              "z": 0.908
            },
            "rightCorner": {
              "x": 9.817,
              "y": 29.138,
              "z": 0.908
            },
            "gtin": "4066627311338",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54666a",
        "height": 1.4538,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20b1c",
            "leftCorner": {
              "x": 8.468,
              "y": 29.199,
              "z": 1.189
            },
            "rightCorner": {
              "x": 8.545,
              "y": 29.194,
              "z": 1.189
            },
            "gtin": "4066627164439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b1e",
            "leftCorner": {
              "x": 8.548,
              "y": 29.231,
              "z": 1.189
            },
            "rightCorner": {
              "x": 8.674,
              "y": 29.221,
              "z": 1.189
            },
            "gtin": "4066632081899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b1f",
            "leftCorner": {
              "x": 8.674,
              "y": 29.229,
              "z": 1.189
            },
            "rightCorner": {
              "x": 8.784,
              "y": 29.221,
              "z": 1.189
            },
            "gtin": "4066627295522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b20",
            "leftCorner": {
              "x": 8.783,
              "y": 29.217,
              "z": 1.189
            },
            "rightCorner": {
              "x": 8.891,
              "y": 29.209,
              "z": 1.189
            },
            "gtin": "4066627295539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b21",
            "leftCorner": {
              "x": 8.891,
              "y": 29.209,
              "z": 1.189
            },
            "rightCorner": {
              "x": 9.0,
              "y": 29.201,
              "z": 1.189
            },
            "gtin": "4066627295539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b22",
            "leftCorner": {
              "x": 8.999,
              "y": 29.194,
              "z": 1.189
            },
            "rightCorner": {
              "x": 9.192,
              "y": 29.18,
              "z": 1.189
            },
            "gtin": "4066627295737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b23",
            "leftCorner": {
              "x": 9.192,
              "y": 29.173,
              "z": 1.189
            },
            "rightCorner": {
              "x": 9.273,
              "y": 29.168,
              "z": 1.189
            },
            "gtin": "4066632042579",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b24",
            "leftCorner": {
              "x": 9.273,
              "y": 29.168,
              "z": 1.189
            },
            "rightCorner": {
              "x": 9.354,
              "y": 29.162,
              "z": 1.189
            },
            "gtin": "4066632042579",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b25",
            "leftCorner": {
              "x": 9.355,
              "y": 29.178,
              "z": 1.189
            },
            "rightCorner": {
              "x": 9.472,
              "y": 29.169,
              "z": 1.189
            },
            "gtin": "4066627164408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b26",
            "leftCorner": {
              "x": 9.471,
              "y": 29.167,
              "z": 1.189
            },
            "rightCorner": {
              "x": 9.554,
              "y": 29.162,
              "z": 1.189
            },
            "gtin": "4066627164422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b27",
            "leftCorner": {
              "x": 9.554,
              "y": 29.162,
              "z": 1.189
            },
            "rightCorner": {
              "x": 9.637,
              "y": 29.155,
              "z": 1.189
            },
            "gtin": "4066627164422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b28",
            "leftCorner": {
              "x": 9.637,
              "y": 29.155,
              "z": 1.189
            },
            "rightCorner": {
              "x": 9.72,
              "y": 29.149,
              "z": 1.189
            },
            "gtin": "4066627164422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b1d",
            "leftCorner": {
              "x": 9.719,
              "y": 29.142,
              "z": 1.189
            },
            "rightCorner": {
              "x": 9.817,
              "y": 29.135,
              "z": 1.189
            },
            "gtin": "767523543352",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546668",
        "height": 1.7571,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20b07",
            "leftCorner": {
              "x": 8.468,
              "y": 29.201,
              "z": 1.438
            },
            "rightCorner": {
              "x": 8.593,
              "y": 29.192,
              "z": 1.438
            },
            "gtin": "4066627183676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b08",
            "leftCorner": {
              "x": 8.593,
              "y": 29.192,
              "z": 1.438
            },
            "rightCorner": {
              "x": 8.717,
              "y": 29.183,
              "z": 1.438
            },
            "gtin": "4066627183676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b0a",
            "leftCorner": {
              "x": 8.72,
              "y": 29.217,
              "z": 1.438
            },
            "rightCorner": {
              "x": 8.809,
              "y": 29.21,
              "z": 1.438
            },
            "gtin": "4066632045990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b0b",
            "leftCorner": {
              "x": 8.809,
              "y": 29.21,
              "z": 1.438
            },
            "rightCorner": {
              "x": 8.898,
              "y": 29.204,
              "z": 1.438
            },
            "gtin": "4066632045990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b0c",
            "leftCorner": {
              "x": 8.898,
              "y": 29.209,
              "z": 1.438
            },
            "rightCorner": {
              "x": 9.028,
              "y": 29.2,
              "z": 1.438
            },
            "gtin": "4066627295324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b0d",
            "leftCorner": {
              "x": 9.029,
              "y": 29.21,
              "z": 1.438
            },
            "rightCorner": {
              "x": 9.19,
              "y": 29.198,
              "z": 1.438
            },
            "gtin": "4066627311499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b0e",
            "leftCorner": {
              "x": 9.189,
              "y": 29.187,
              "z": 1.438
            },
            "rightCorner": {
              "x": 9.281,
              "y": 29.18,
              "z": 1.438
            },
            "gtin": "4066627295867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b0f",
            "leftCorner": {
              "x": 9.281,
              "y": 29.18,
              "z": 1.438
            },
            "rightCorner": {
              "x": 9.372,
              "y": 29.174,
              "z": 1.438
            },
            "gtin": "4066627295867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b10",
            "leftCorner": {
              "x": 9.372,
              "y": 29.18,
              "z": 1.438
            },
            "rightCorner": {
              "x": 9.465,
              "y": 29.173,
              "z": 1.438
            },
            "gtin": "4066627165238",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b11",
            "leftCorner": {
              "x": 9.465,
              "y": 29.167,
              "z": 1.438
            },
            "rightCorner": {
              "x": 9.585,
              "y": 29.159,
              "z": 1.438
            },
            "gtin": "4066627165177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b12",
            "leftCorner": {
              "x": 9.585,
              "y": 29.164,
              "z": 1.438
            },
            "rightCorner": {
              "x": 9.72,
              "y": 29.154,
              "z": 1.438
            },
            "gtin": "4066627204715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20b09",
            "leftCorner": {
              "x": 9.719,
              "y": 29.139,
              "z": 1.438
            },
            "rightCorner": {
              "x": 9.817,
              "y": 29.132,
              "z": 1.438
            },
            "gtin": "4066627165498",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "34a90"
  },
  {
    "id": "d13a0",
    "name": "d13a0",
    "x": -12.541,
    "y": 24.499,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.037315,
      "w": 0.9993
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 75
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54674c",
        "height": 0.17693,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20f9c",
            "leftCorner": {
              "x": -12.538,
              "y": 24.535,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.419,
              "y": 24.526,
              "z": 0.145
            },
            "gtin": "40161747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f9d",
            "leftCorner": {
              "x": -12.419,
              "y": 24.526,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.301,
              "y": 24.517,
              "z": 0.145
            },
            "gtin": "40161747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f9e",
            "leftCorner": {
              "x": -12.301,
              "y": 24.517,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.184,
              "y": 24.508,
              "z": 0.145
            },
            "gtin": "40161747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f9f",
            "leftCorner": {
              "x": -12.184,
              "y": 24.508,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.066,
              "y": 24.499,
              "z": 0.145
            },
            "gtin": "40161747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fa0",
            "leftCorner": {
              "x": -12.061,
              "y": 24.56,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.803,
              "y": 24.541,
              "z": 0.145
            },
            "gtin": "4001499921629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fa1",
            "leftCorner": {
              "x": -11.803,
              "y": 24.541,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.545,
              "y": 24.522,
              "z": 0.145
            },
            "gtin": "4001499921629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fa2",
            "leftCorner": {
              "x": -11.545,
              "y": 24.522,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.287,
              "y": 24.503,
              "z": 0.145
            },
            "gtin": "4001499921629",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54674e",
        "height": 0.59827,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20fb3",
            "leftCorner": {
              "x": -12.537,
              "y": 24.553,
              "z": 0.489
            },
            "rightCorner": {
              "x": -12.46,
              "y": 24.547,
              "z": 0.489
            },
            "gtin": "4001499946721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fb4",
            "leftCorner": {
              "x": -12.46,
              "y": 24.547,
              "z": 0.489
            },
            "rightCorner": {
              "x": -12.385,
              "y": 24.542,
              "z": 0.489
            },
            "gtin": "4001499946721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fb5",
            "leftCorner": {
              "x": -12.385,
              "y": 24.542,
              "z": 0.489
            },
            "rightCorner": {
              "x": -12.308,
              "y": 24.536,
              "z": 0.489
            },
            "gtin": "4001499946721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fb6",
            "leftCorner": {
              "x": -12.308,
              "y": 24.536,
              "z": 0.489
            },
            "rightCorner": {
              "x": -12.232,
              "y": 24.53,
              "z": 0.489
            },
            "gtin": "4001499946721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fb7",
            "leftCorner": {
              "x": -12.232,
              "y": 24.53,
              "z": 0.489
            },
            "rightCorner": {
              "x": -12.156,
              "y": 24.524,
              "z": 0.489
            },
            "gtin": "4001499946721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fb8",
            "leftCorner": {
              "x": -12.156,
              "y": 24.524,
              "z": 0.489
            },
            "rightCorner": {
              "x": -12.079,
              "y": 24.519,
              "z": 0.489
            },
            "gtin": "4001499946721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fbb",
            "leftCorner": {
              "x": -12.077,
              "y": 24.555,
              "z": 0.489
            },
            "rightCorner": {
              "x": -12.026,
              "y": 24.551,
              "z": 0.489
            },
            "gtin": "4001499946776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fbc",
            "leftCorner": {
              "x": -12.026,
              "y": 24.551,
              "z": 0.489
            },
            "rightCorner": {
              "x": -11.975,
              "y": 24.547,
              "z": 0.489
            },
            "gtin": "4001499946776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fbd",
            "leftCorner": {
              "x": -11.975,
              "y": 24.547,
              "z": 0.489
            },
            "rightCorner": {
              "x": -11.925,
              "y": 24.543,
              "z": 0.489
            },
            "gtin": "4001499946776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fbe",
            "leftCorner": {
              "x": -11.925,
              "y": 24.54,
              "z": 0.489
            },
            "rightCorner": {
              "x": -11.864,
              "y": 24.536,
              "z": 0.489
            },
            "gtin": "4001499946752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fbf",
            "leftCorner": {
              "x": -11.864,
              "y": 24.536,
              "z": 0.489
            },
            "rightCorner": {
              "x": -11.805,
              "y": 24.531,
              "z": 0.489
            },
            "gtin": "4001499946752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fc0",
            "leftCorner": {
              "x": -11.805,
              "y": 24.531,
              "z": 0.489
            },
            "rightCorner": {
              "x": -11.744,
              "y": 24.527,
              "z": 0.489
            },
            "gtin": "4001499946752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fc1",
            "leftCorner": {
              "x": -11.744,
              "y": 24.527,
              "z": 0.489
            },
            "rightCorner": {
              "x": -11.683,
              "y": 24.522,
              "z": 0.489
            },
            "gtin": "4001499946752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fc2",
            "leftCorner": {
              "x": -11.683,
              "y": 24.522,
              "z": 0.489
            },
            "rightCorner": {
              "x": -11.623,
              "y": 24.518,
              "z": 0.489
            },
            "gtin": "4001499946752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fc3",
            "leftCorner": {
              "x": -11.623,
              "y": 24.518,
              "z": 0.489
            },
            "rightCorner": {
              "x": -11.563,
              "y": 24.513,
              "z": 0.489
            },
            "gtin": "4001499946752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fb9",
            "leftCorner": {
              "x": -11.56,
              "y": 24.55,
              "z": 0.489
            },
            "rightCorner": {
              "x": -11.422,
              "y": 24.539,
              "z": 0.489
            },
            "gtin": "4001499962127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fba",
            "leftCorner": {
              "x": -11.422,
              "y": 24.539,
              "z": 0.489
            },
            "rightCorner": {
              "x": -11.285,
              "y": 24.529,
              "z": 0.489
            },
            "gtin": "4001499962127",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54674d",
        "height": 0.94995,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20fa3",
            "leftCorner": {
              "x": -12.537,
              "y": 24.548,
              "z": 0.777
            },
            "rightCorner": {
              "x": -12.47,
              "y": 24.543,
              "z": 0.777
            },
            "gtin": "4051089931446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fa4",
            "leftCorner": {
              "x": -12.47,
              "y": 24.543,
              "z": 0.777
            },
            "rightCorner": {
              "x": -12.404,
              "y": 24.538,
              "z": 0.777
            },
            "gtin": "4051089931446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fa5",
            "leftCorner": {
              "x": -12.404,
              "y": 24.538,
              "z": 0.777
            },
            "rightCorner": {
              "x": -12.338,
              "y": 24.534,
              "z": 0.777
            },
            "gtin": "4051089931446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fa6",
            "leftCorner": {
              "x": -12.338,
              "y": 24.534,
              "z": 0.777
            },
            "rightCorner": {
              "x": -12.273,
              "y": 24.528,
              "z": 0.777
            },
            "gtin": "4051089931446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fab",
            "leftCorner": {
              "x": -12.27,
              "y": 24.563,
              "z": 0.777
            },
            "rightCorner": {
              "x": -12.17,
              "y": 24.555,
              "z": 0.777
            },
            "gtin": "4051089931453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fac",
            "leftCorner": {
              "x": -12.17,
              "y": 24.555,
              "z": 0.777
            },
            "rightCorner": {
              "x": -12.07,
              "y": 24.548,
              "z": 0.777
            },
            "gtin": "4051089931453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fad",
            "leftCorner": {
              "x": -12.07,
              "y": 24.548,
              "z": 0.777
            },
            "rightCorner": {
              "x": -11.971,
              "y": 24.54,
              "z": 0.777
            },
            "gtin": "4051089931453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fae",
            "leftCorner": {
              "x": -11.971,
              "y": 24.54,
              "z": 0.777
            },
            "rightCorner": {
              "x": -11.871,
              "y": 24.532,
              "z": 0.777
            },
            "gtin": "4051089931453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20faf",
            "leftCorner": {
              "x": -11.871,
              "y": 24.543,
              "z": 0.777
            },
            "rightCorner": {
              "x": -11.801,
              "y": 24.538,
              "z": 0.777
            },
            "gtin": "4001499014260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fb0",
            "leftCorner": {
              "x": -11.801,
              "y": 24.538,
              "z": 0.777
            },
            "rightCorner": {
              "x": -11.732,
              "y": 24.533,
              "z": 0.777
            },
            "gtin": "4001499014260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fb1",
            "leftCorner": {
              "x": -11.732,
              "y": 24.533,
              "z": 0.777
            },
            "rightCorner": {
              "x": -11.662,
              "y": 24.528,
              "z": 0.777
            },
            "gtin": "4001499014260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fb2",
            "leftCorner": {
              "x": -11.662,
              "y": 24.528,
              "z": 0.777
            },
            "rightCorner": {
              "x": -11.593,
              "y": 24.522,
              "z": 0.777
            },
            "gtin": "4001499014260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fa7",
            "leftCorner": {
              "x": -11.59,
              "y": 24.554,
              "z": 0.777
            },
            "rightCorner": {
              "x": -11.514,
              "y": 24.548,
              "z": 0.777
            },
            "gtin": "4001499143694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fa8",
            "leftCorner": {
              "x": -11.514,
              "y": 24.548,
              "z": 0.777
            },
            "rightCorner": {
              "x": -11.437,
              "y": 24.543,
              "z": 0.777
            },
            "gtin": "4001499143694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fa9",
            "leftCorner": {
              "x": -11.437,
              "y": 24.543,
              "z": 0.777
            },
            "rightCorner": {
              "x": -11.361,
              "y": 24.537,
              "z": 0.777
            },
            "gtin": "4001499143694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20faa",
            "leftCorner": {
              "x": -11.361,
              "y": 24.537,
              "z": 0.777
            },
            "rightCorner": {
              "x": -11.284,
              "y": 24.531,
              "z": 0.777
            },
            "gtin": "4001499143694",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54674b",
        "height": 1.2017,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20f98",
            "leftCorner": {
              "x": -12.538,
              "y": 24.529,
              "z": 0.983
            },
            "rightCorner": {
              "x": -12.281,
              "y": 24.51,
              "z": 0.983
            },
            "gtin": "4001499947667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f99",
            "leftCorner": {
              "x": -12.281,
              "y": 24.51,
              "z": 0.983
            },
            "rightCorner": {
              "x": -12.025,
              "y": 24.491,
              "z": 0.983
            },
            "gtin": "4001499947667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f9a",
            "leftCorner": {
              "x": -12.025,
              "y": 24.491,
              "z": 0.983
            },
            "rightCorner": {
              "x": -11.767,
              "y": 24.472,
              "z": 0.983
            },
            "gtin": "4001499947667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f9b",
            "leftCorner": {
              "x": -11.763,
              "y": 24.531,
              "z": 0.983
            },
            "rightCorner": {
              "x": -11.288,
              "y": 24.495,
              "z": 0.983
            },
            "gtin": "4001499011665",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54674a",
        "height": 1.4517,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20f84",
            "leftCorner": {
              "x": -12.537,
              "y": 24.546,
              "z": 1.188
            },
            "rightCorner": {
              "x": -12.408,
              "y": 24.537,
              "z": 1.188
            },
            "gtin": "4051089935024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f87",
            "leftCorner": {
              "x": -12.408,
              "y": 24.539,
              "z": 1.188
            },
            "rightCorner": {
              "x": -12.364,
              "y": 24.536,
              "z": 1.188
            },
            "gtin": "4051089932115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f88",
            "leftCorner": {
              "x": -12.364,
              "y": 24.536,
              "z": 1.188
            },
            "rightCorner": {
              "x": -12.32,
              "y": 24.532,
              "z": 1.188
            },
            "gtin": "4051089932115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f89",
            "leftCorner": {
              "x": -12.318,
              "y": 24.546,
              "z": 1.188
            },
            "rightCorner": {
              "x": -12.265,
              "y": 24.543,
              "z": 1.188
            },
            "gtin": "4051089935031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f8a",
            "leftCorner": {
              "x": -12.265,
              "y": 24.543,
              "z": 1.188
            },
            "rightCorner": {
              "x": -12.211,
              "y": 24.538,
              "z": 1.188
            },
            "gtin": "4051089935031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f8b",
            "leftCorner": {
              "x": -12.211,
              "y": 24.538,
              "z": 1.188
            },
            "rightCorner": {
              "x": -12.156,
              "y": 24.534,
              "z": 1.188
            },
            "gtin": "4051089935031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f8c",
            "leftCorner": {
              "x": -12.155,
              "y": 24.558,
              "z": 1.188
            },
            "rightCorner": {
              "x": -12.11,
              "y": 24.555,
              "z": 1.188
            },
            "gtin": "4051089935048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f8d",
            "leftCorner": {
              "x": -12.11,
              "y": 24.555,
              "z": 1.188
            },
            "rightCorner": {
              "x": -12.066,
              "y": 24.551,
              "z": 1.188
            },
            "gtin": "4051089935048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f8e",
            "leftCorner": {
              "x": -12.066,
              "y": 24.551,
              "z": 1.188
            },
            "rightCorner": {
              "x": -12.021,
              "y": 24.548,
              "z": 1.188
            },
            "gtin": "4051089935048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f8f",
            "leftCorner": {
              "x": -12.021,
              "y": 24.55,
              "z": 1.188
            },
            "rightCorner": {
              "x": -11.951,
              "y": 24.545,
              "z": 1.188
            },
            "gtin": "4001499946561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f90",
            "leftCorner": {
              "x": -11.951,
              "y": 24.545,
              "z": 1.188
            },
            "rightCorner": {
              "x": -11.881,
              "y": 24.54,
              "z": 1.188
            },
            "gtin": "4001499946561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f91",
            "leftCorner": {
              "x": -11.88,
              "y": 24.546,
              "z": 1.188
            },
            "rightCorner": {
              "x": -11.815,
              "y": 24.541,
              "z": 1.188
            },
            "gtin": "4001499946714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f92",
            "leftCorner": {
              "x": -11.815,
              "y": 24.541,
              "z": 1.188
            },
            "rightCorner": {
              "x": -11.748,
              "y": 24.537,
              "z": 1.188
            },
            "gtin": "4001499946714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f93",
            "leftCorner": {
              "x": -11.748,
              "y": 24.537,
              "z": 1.188
            },
            "rightCorner": {
              "x": -11.681,
              "y": 24.531,
              "z": 1.188
            },
            "gtin": "4001499946714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f94",
            "leftCorner": {
              "x": -11.681,
              "y": 24.531,
              "z": 1.188
            },
            "rightCorner": {
              "x": -11.615,
              "y": 24.526,
              "z": 1.188
            },
            "gtin": "4001499946714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f95",
            "leftCorner": {
              "x": -11.615,
              "y": 24.526,
              "z": 1.188
            },
            "rightCorner": {
              "x": -11.548,
              "y": 24.521,
              "z": 1.188
            },
            "gtin": "4001499946714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f96",
            "leftCorner": {
              "x": -11.548,
              "y": 24.521,
              "z": 1.188
            },
            "rightCorner": {
              "x": -11.482,
              "y": 24.517,
              "z": 1.188
            },
            "gtin": "4001499946714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f97",
            "leftCorner": {
              "x": -11.482,
              "y": 24.517,
              "z": 1.188
            },
            "rightCorner": {
              "x": -11.415,
              "y": 24.512,
              "z": 1.188
            },
            "gtin": "4001499946714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f85",
            "leftCorner": {
              "x": -11.412,
              "y": 24.558,
              "z": 1.188
            },
            "rightCorner": {
              "x": -11.347,
              "y": 24.552,
              "z": 1.188
            },
            "gtin": "4001499197659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20f86",
            "leftCorner": {
              "x": -11.347,
              "y": 24.552,
              "z": 1.188
            },
            "rightCorner": {
              "x": -11.283,
              "y": 24.548,
              "z": 1.188
            },
            "gtin": "4001499197659",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54674f",
        "height": 1.7506,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20fc4",
            "leftCorner": {
              "x": -12.537,
              "y": 24.556,
              "z": 1.432
            },
            "rightCorner": {
              "x": -12.346,
              "y": 24.542,
              "z": 1.432
            },
            "gtin": "4001499130755",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fc5",
            "leftCorner": {
              "x": -12.346,
              "y": 24.542,
              "z": 1.432
            },
            "rightCorner": {
              "x": -12.156,
              "y": 24.527,
              "z": 1.432
            },
            "gtin": "4001499130755",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fc9",
            "leftCorner": {
              "x": -12.156,
              "y": 24.531,
              "z": 1.432
            },
            "rightCorner": {
              "x": -12.038,
              "y": 24.522,
              "z": 1.432
            },
            "gtin": "4016100252016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fca",
            "leftCorner": {
              "x": -12.038,
              "y": 24.522,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.921,
              "y": 24.514,
              "z": 1.432
            },
            "gtin": "4016100252016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fcb",
            "leftCorner": {
              "x": -11.918,
              "y": 24.544,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.805,
              "y": 24.536,
              "z": 1.432
            },
            "gtin": "4016100810117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fcc",
            "leftCorner": {
              "x": -11.805,
              "y": 24.539,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.686,
              "y": 24.53,
              "z": 1.432
            },
            "gtin": "40161808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fcd",
            "leftCorner": {
              "x": -11.686,
              "y": 24.53,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.567,
              "y": 24.521,
              "z": 1.432
            },
            "gtin": "40161808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fce",
            "leftCorner": {
              "x": -11.566,
              "y": 24.547,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.456,
              "y": 24.539,
              "z": 1.432
            },
            "gtin": "40161754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fc6",
            "leftCorner": {
              "x": -11.455,
              "y": 24.554,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.398,
              "y": 24.55,
              "z": 1.432
            },
            "gtin": "4016100521518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fc7",
            "leftCorner": {
              "x": -11.398,
              "y": 24.55,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.34,
              "y": 24.546,
              "z": 1.432
            },
            "gtin": "4016100521518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20fc8",
            "leftCorner": {
              "x": -11.34,
              "y": 24.546,
              "z": 1.432
            },
            "rightCorner": {
              "x": -11.284,
              "y": 24.541,
              "z": 1.432
            },
            "gtin": "4016100521518",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "a6d7e"
  },
  {
    "id": "d13b7",
    "name": "d13b7",
    "x": 2.508,
    "y": 24.533,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99967,
      "w": 0.025645
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 4,
      "unknownStockCount": 16
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5466f9",
        "height": 0.67798,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e6b",
            "leftCorner": {
              "x": 1.89,
              "y": 24.554,
              "z": 0.555
            },
            "rightCorner": {
              "x": 1.582,
              "y": 24.57,
              "z": 0.555
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e69",
            "leftCorner": {
              "x": 2.507,
              "y": 24.523,
              "z": 0.555
            },
            "rightCorner": {
              "x": 2.199,
              "y": 24.539,
              "z": 0.555
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e6a",
            "leftCorner": {
              "x": 2.199,
              "y": 24.539,
              "z": 0.555
            },
            "rightCorner": {
              "x": 1.89,
              "y": 24.554,
              "z": 0.555
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e6c",
            "leftCorner": {
              "x": 1.58,
              "y": 24.532,
              "z": 0.555
            },
            "rightCorner": {
              "x": 1.419,
              "y": 24.541,
              "z": 0.555
            },
            "gtin": "4006501521040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e6d",
            "leftCorner": {
              "x": 1.419,
              "y": 24.541,
              "z": 0.555
            },
            "rightCorner": {
              "x": 1.257,
              "y": 24.549,
              "z": 0.555
            },
            "gtin": "4006501521040",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466f4",
        "height": 1.51,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e66",
            "leftCorner": {
              "x": 2.304,
              "y": 24.478,
              "z": 1.235
            },
            "rightCorner": {
              "x": 1.256,
              "y": 24.531,
              "z": 1.235
            },
            "gtin": "4006501551269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e65",
            "leftCorner": {
              "x": 2.506,
              "y": 24.502,
              "z": 1.235
            },
            "rightCorner": {
              "x": 2.306,
              "y": 24.513,
              "z": 1.235
            }
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466fd",
        "height": 1.5355,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e72",
            "leftCorner": {
              "x": 2.506,
              "y": 24.5,
              "z": 1.256
            },
            "rightCorner": {
              "x": 2.315,
              "y": 24.509,
              "z": 1.256
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e73",
            "leftCorner": {
              "x": 2.315,
              "y": 24.509,
              "z": 1.256
            },
            "rightCorner": {
              "x": 2.125,
              "y": 24.519,
              "z": 1.256
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e74",
            "leftCorner": {
              "x": 2.125,
              "y": 24.519,
              "z": 1.256
            },
            "rightCorner": {
              "x": 1.934,
              "y": 24.529,
              "z": 1.256
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e75",
            "leftCorner": {
              "x": 1.932,
              "y": 24.488,
              "z": 1.256
            },
            "rightCorner": {
              "x": 1.594,
              "y": 24.505,
              "z": 1.256
            },
            "gtin": "4006501521224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e76",
            "leftCorner": {
              "x": 1.594,
              "y": 24.505,
              "z": 1.256
            },
            "rightCorner": {
              "x": 1.256,
              "y": 24.523,
              "z": 1.256
            },
            "gtin": "4006501521224",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466f6",
        "height": 0.14246,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c7b",
            "leftCorner": {
              "x": 2.508,
              "y": 24.525,
              "z": 0.117
            },
            "rightCorner": {
              "x": 1.944,
              "y": 24.555,
              "z": 0.117
            },
            "gtin": "4006501555151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c7e",
            "leftCorner": {
              "x": 1.941,
              "y": 24.497,
              "z": 0.117
            },
            "rightCorner": {
              "x": 1.394,
              "y": 24.525,
              "z": 0.117
            },
            "gtin": "4006501550767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c7f",
            "leftCorner": {
              "x": 1.395,
              "y": 24.546,
              "z": 0.117
            },
            "rightCorner": {
              "x": 1.215,
              "y": 24.554,
              "z": 0.117
            },
            "gtin": "4006501414014",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466f8",
        "height": 1.1065,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e67",
            "leftCorner": {
              "x": 2.506,
              "y": 24.496,
              "z": 0.905
            },
            "rightCorner": {
              "x": 1.759,
              "y": 24.534,
              "z": 0.905
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20e68",
            "leftCorner": {
              "x": 1.757,
              "y": 24.497,
              "z": 0.905
            },
            "rightCorner": {
              "x": 1.256,
              "y": 24.522,
              "z": 0.905
            },
            "gtin": "4006501521040",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466f2",
        "height": 1.1584,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e63",
            "leftCorner": {
              "x": 2.506,
              "y": 24.491,
              "z": 0.948
            },
            "rightCorner": {
              "x": 2.172,
              "y": 24.509,
              "z": 0.948
            },
            "gtin": "4006501551160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e64",
            "leftCorner": {
              "x": 2.17,
              "y": 24.477,
              "z": 0.948
            },
            "rightCorner": {
              "x": 1.256,
              "y": 24.524,
              "z": 0.948
            },
            "gtin": "4006501551177",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466fc",
        "height": 1.2121,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e70",
            "leftCorner": {
              "x": 2.507,
              "y": 24.52,
              "z": 0.992
            },
            "rightCorner": {
              "x": 1.386,
              "y": 24.578,
              "z": 0.992
            },
            "gtin": "4006501513250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e71",
            "leftCorner": {
              "x": 1.384,
              "y": 24.537,
              "z": 0.992
            },
            "rightCorner": {
              "x": 1.257,
              "y": 24.544,
              "z": 0.992
            },
            "gtin": "4006501416506",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466fa",
        "height": 1.4256,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20e6e",
            "leftCorner": {
              "x": 2.506,
              "y": 24.492,
              "z": 1.166
            },
            "rightCorner": {
              "x": 1.65,
              "y": 24.536,
              "z": 1.166
            },
            "gtin": "4006501566713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20e6f",
            "leftCorner": {
              "x": 1.648,
              "y": 24.497,
              "z": 1.166
            },
            "rightCorner": {
              "x": 1.256,
              "y": 24.517,
              "z": 1.166
            },
            "gtin": "4006501564221",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466f5",
        "height": 1.9123,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c4a",
            "leftCorner": {
              "x": 2.508,
              "y": 24.526,
              "z": 1.565
            },
            "rightCorner": {
              "x": 1.892,
              "y": 24.558,
              "z": 1.565
            },
            "gtin": "4006501551269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c4c",
            "leftCorner": {
              "x": 1.89,
              "y": 24.523,
              "z": 1.565
            },
            "rightCorner": {
              "x": 1.769,
              "y": 24.529,
              "z": 1.565
            },
            "gtin": "4006501521231",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20c4d",
            "leftCorner": {
              "x": 1.769,
              "y": 24.525,
              "z": 1.565
            },
            "rightCorner": {
              "x": 1.599,
              "y": 24.533,
              "z": 1.565
            },
            "gtin": "4006501415240",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20c4e",
            "leftCorner": {
              "x": 1.6,
              "y": 24.542,
              "z": 1.565
            },
            "rightCorner": {
              "x": 1.317,
              "y": 24.556,
              "z": 1.565
            },
            "gtin": "4006501415202",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8a5ed67a01d9a20c4f",
            "leftCorner": {
              "x": 1.317,
              "y": 24.544,
              "z": 1.565
            },
            "rightCorner": {
              "x": 1.02,
              "y": 24.56,
              "z": 1.565
            },
            "gtin": "4006501552105",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "a6d8b"
  },
  {
    "id": "d13c4",
    "name": "d13c4",
    "x": -12.241,
    "y": 27.715,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.030163,
      "w": 0.99954
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 25
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5466bc",
        "height": 0.15083,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a5466bb",
        "height": 0.5531,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20cf8",
            "leftCorner": {
              "x": -12.241,
              "y": 27.723,
              "z": 0.453
            },
            "rightCorner": {
              "x": -12.179,
              "y": 27.718,
              "z": 0.453
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20cf9",
            "leftCorner": {
              "x": -12.177,
              "y": 27.76,
              "z": 0.453
            },
            "rightCorner": {
              "x": -11.88,
              "y": 27.743,
              "z": 0.453
            },
            "gtin": "4337185511820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cfa",
            "leftCorner": {
              "x": -11.88,
              "y": 27.743,
              "z": 0.453
            },
            "rightCorner": {
              "x": -11.583,
              "y": 27.724,
              "z": 0.453
            },
            "gtin": "4337185511820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cfb",
            "leftCorner": {
              "x": -11.583,
              "y": 27.724,
              "z": 0.453
            },
            "rightCorner": {
              "x": -11.287,
              "y": 27.707,
              "z": 0.453
            },
            "gtin": "4337185511820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20cfc",
            "leftCorner": {
              "x": -11.287,
              "y": 27.707,
              "z": 0.453
            },
            "rightCorner": {
              "x": -10.99,
              "y": 27.689,
              "z": 0.453
            },
            "gtin": "4337185511820",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466be",
        "height": 0.95219,
        "facings": []
      },
      {
        "id": "682ffdded15af3232a5466bf",
        "height": 1.3504,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e770",
            "leftCorner": {
              "x": -12.241,
              "y": 27.723,
              "z": 1.105
            },
            "rightCorner": {
              "x": -12.041,
              "y": 27.71,
              "z": 1.105
            },
            "gtin": "4063367304309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e771",
            "leftCorner": {
              "x": -12.041,
              "y": 27.71,
              "z": 1.105
            },
            "rightCorner": {
              "x": -11.841,
              "y": 27.699,
              "z": 1.105
            },
            "gtin": "4063367304309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e772",
            "leftCorner": {
              "x": -11.841,
              "y": 27.699,
              "z": 1.105
            },
            "rightCorner": {
              "x": -11.642,
              "y": 27.687,
              "z": 1.105
            },
            "gtin": "4063367304309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e775",
            "leftCorner": {
              "x": -11.64,
              "y": 27.72,
              "z": 1.105
            },
            "rightCorner": {
              "x": -11.458,
              "y": 27.709,
              "z": 1.105
            },
            "gtin": "4251758404657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e776",
            "leftCorner": {
              "x": -11.458,
              "y": 27.709,
              "z": 1.105
            },
            "rightCorner": {
              "x": -11.276,
              "y": 27.698,
              "z": 1.105
            },
            "gtin": "4251758404657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e777",
            "leftCorner": {
              "x": -11.276,
              "y": 27.7,
              "z": 1.105
            },
            "rightCorner": {
              "x": -11.187,
              "y": 27.694,
              "z": 1.105
            },
            "gtin": "4002448047834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e778",
            "leftCorner": {
              "x": -11.187,
              "y": 27.694,
              "z": 1.105
            },
            "rightCorner": {
              "x": -11.1,
              "y": 27.689,
              "z": 1.105
            },
            "gtin": "4002448047834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e779",
            "leftCorner": {
              "x": -11.1,
              "y": 27.689,
              "z": 1.105
            },
            "rightCorner": {
              "x": -11.013,
              "y": 27.684,
              "z": 1.105
            },
            "gtin": "4002448047834",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5466bd",
        "height": 1.7464,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e5d2",
            "leftCorner": {
              "x": -12.24,
              "y": 27.736,
              "z": 1.429
            },
            "rightCorner": {
              "x": -12.186,
              "y": 27.733,
              "z": 1.429
            },
            "gtin": "4036581536535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5d3",
            "leftCorner": {
              "x": -12.186,
              "y": 27.733,
              "z": 1.429
            },
            "rightCorner": {
              "x": -12.132,
              "y": 27.73,
              "z": 1.429
            },
            "gtin": "4036581536535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5d5",
            "leftCorner": {
              "x": -12.129,
              "y": 27.771,
              "z": 1.429
            },
            "rightCorner": {
              "x": -12.07,
              "y": 27.767,
              "z": 1.429
            },
            "gtin": "4053700260218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5d6",
            "leftCorner": {
              "x": -12.07,
              "y": 27.767,
              "z": 1.429
            },
            "rightCorner": {
              "x": -12.01,
              "y": 27.764,
              "z": 1.429
            },
            "gtin": "4053700260218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5d7",
            "leftCorner": {
              "x": -12.01,
              "y": 27.764,
              "z": 1.429
            },
            "rightCorner": {
              "x": -11.95,
              "y": 27.76,
              "z": 1.429
            },
            "gtin": "4053700260218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5d8",
            "leftCorner": {
              "x": -11.95,
              "y": 27.76,
              "z": 1.429
            },
            "rightCorner": {
              "x": -11.89,
              "y": 27.757,
              "z": 1.429
            },
            "gtin": "4053700260218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5d9",
            "leftCorner": {
              "x": -11.889,
              "y": 27.768,
              "z": 1.429
            },
            "rightCorner": {
              "x": -11.82,
              "y": 27.763,
              "z": 1.429
            },
            "gtin": "4010054004875",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5da",
            "leftCorner": {
              "x": -11.82,
              "y": 27.763,
              "z": 1.429
            },
            "rightCorner": {
              "x": -11.75,
              "y": 27.759,
              "z": 1.429
            },
            "gtin": "4010054004875",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5db",
            "leftCorner": {
              "x": -11.75,
              "y": 27.759,
              "z": 1.429
            },
            "rightCorner": {
              "x": -11.679,
              "y": 27.755,
              "z": 1.429
            },
            "gtin": "4010054004875",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5dc",
            "leftCorner": {
              "x": -11.679,
              "y": 27.755,
              "z": 1.429
            },
            "rightCorner": {
              "x": -11.61,
              "y": 27.751,
              "z": 1.429
            },
            "gtin": "4010054004875",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5dd",
            "leftCorner": {
              "x": -11.61,
              "y": 27.74,
              "z": 1.429
            },
            "rightCorner": {
              "x": -11.178,
              "y": 27.714,
              "z": 1.429
            },
            "gtin": "4063367273599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5de",
            "leftCorner": {
              "x": -11.178,
              "y": 27.709,
              "z": 1.429
            },
            "rightCorner": {
              "x": -11.08,
              "y": 27.703,
              "z": 1.429
            },
            "gtin": "4251758417084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e5df",
            "leftCorner": {
              "x": -11.08,
              "y": 27.703,
              "z": 1.429
            },
            "rightCorner": {
              "x": -10.984,
              "y": 27.697,
              "z": 1.429
            },
            "gtin": "4251758417084",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "a6d73"
  },
  {
    "id": "d13cf",
    "name": "d13cf",
    "x": -2.234,
    "y": 28.303,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99968,
      "w": 0.025148
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 63
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a54668c",
        "height": 0.16865,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20bfd",
            "leftCorner": {
              "x": -2.234,
              "y": 28.299,
              "z": 0.138
            },
            "rightCorner": {
              "x": -2.628,
              "y": 28.319,
              "z": 0.138
            },
            "gtin": "4000851012999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bff",
            "leftCorner": {
              "x": -2.63,
              "y": 28.278,
              "z": 0.138
            },
            "rightCorner": {
              "x": -2.905,
              "y": 28.292,
              "z": 0.138
            },
            "gtin": "4000576396909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c00",
            "leftCorner": {
              "x": -2.904,
              "y": 28.296,
              "z": 0.138
            },
            "rightCorner": {
              "x": -3.024,
              "y": 28.302,
              "z": 0.138
            },
            "gtin": "4063367441028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c01",
            "leftCorner": {
              "x": -3.024,
              "y": 28.302,
              "z": 0.138
            },
            "rightCorner": {
              "x": -3.143,
              "y": 28.308,
              "z": 0.138
            },
            "gtin": "4063367441028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c02",
            "leftCorner": {
              "x": -3.143,
              "y": 28.308,
              "z": 0.138
            },
            "rightCorner": {
              "x": -3.263,
              "y": 28.314,
              "z": 0.138
            },
            "gtin": "4063367441028",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546688",
        "height": 0.69721,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20bb2",
            "leftCorner": {
              "x": -2.239,
              "y": 28.199,
              "z": 0.57
            },
            "rightCorner": {
              "x": -2.437,
              "y": 28.21,
              "z": 0.57
            },
            "gtin": "4000576395612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bb4",
            "leftCorner": {
              "x": -2.439,
              "y": 28.169,
              "z": 0.57
            },
            "rightCorner": {
              "x": -2.62,
              "y": 28.178,
              "z": 0.57
            },
            "gtin": "4063367439254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bb5",
            "leftCorner": {
              "x": -2.62,
              "y": 28.186,
              "z": 0.57
            },
            "rightCorner": {
              "x": -2.792,
              "y": 28.195,
              "z": 0.57
            },
            "gtin": "4000851013033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bb6",
            "leftCorner": {
              "x": -2.792,
              "y": 28.195,
              "z": 0.57
            },
            "rightCorner": {
              "x": -2.964,
              "y": 28.204,
              "z": 0.57
            },
            "gtin": "4000851013033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bb7",
            "leftCorner": {
              "x": -2.964,
              "y": 28.202,
              "z": 0.57
            },
            "rightCorner": {
              "x": -3.032,
              "y": 28.205,
              "z": 0.57
            },
            "gtin": "4063367451140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bb8",
            "leftCorner": {
              "x": -3.032,
              "y": 28.205,
              "z": 0.57
            },
            "rightCorner": {
              "x": -3.099,
              "y": 28.208,
              "z": 0.57
            },
            "gtin": "4063367451140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bb3",
            "leftCorner": {
              "x": -3.1,
              "y": 28.2,
              "z": 0.57
            },
            "rightCorner": {
              "x": -3.24,
              "y": 28.208,
              "z": 0.57
            },
            "gtin": "4260712960306",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546689",
        "height": 1.0557,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20bb9",
            "leftCorner": {
              "x": -2.238,
              "y": 28.216,
              "z": 0.864
            },
            "rightCorner": {
              "x": -2.307,
              "y": 28.219,
              "z": 0.864
            },
            "gtin": "4003583217687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bbc",
            "leftCorner": {
              "x": -2.309,
              "y": 28.163,
              "z": 0.864
            },
            "rightCorner": {
              "x": -2.364,
              "y": 28.166,
              "z": 0.864
            },
            "gtin": "4063367407734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bbd",
            "leftCorner": {
              "x": -2.363,
              "y": 28.186,
              "z": 0.864
            },
            "rightCorner": {
              "x": -2.427,
              "y": 28.19,
              "z": 0.864
            },
            "gtin": "4063367407741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bbe",
            "leftCorner": {
              "x": -2.427,
              "y": 28.188,
              "z": 0.864
            },
            "rightCorner": {
              "x": -2.498,
              "y": 28.191,
              "z": 0.864
            },
            "gtin": "4337185644412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bbf",
            "leftCorner": {
              "x": -2.498,
              "y": 28.183,
              "z": 0.864
            },
            "rightCorner": {
              "x": -2.575,
              "y": 28.187,
              "z": 0.864
            },
            "gtin": "4063367256752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bc0",
            "leftCorner": {
              "x": -2.574,
              "y": 28.2,
              "z": 0.864
            },
            "rightCorner": {
              "x": -2.784,
              "y": 28.211,
              "z": 0.864
            },
            "gtin": "4051089812905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bc1",
            "leftCorner": {
              "x": -2.784,
              "y": 28.211,
              "z": 0.864
            },
            "rightCorner": {
              "x": -2.994,
              "y": 28.221,
              "z": 0.864
            },
            "gtin": "4051089812905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bc2",
            "leftCorner": {
              "x": -2.994,
              "y": 28.221,
              "z": 0.864
            },
            "rightCorner": {
              "x": -3.204,
              "y": 28.231,
              "z": 0.864
            },
            "gtin": "4051089812905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bc3",
            "leftCorner": {
              "x": -3.204,
              "y": 28.212,
              "z": 0.864
            },
            "rightCorner": {
              "x": -3.32,
              "y": 28.219,
              "z": 0.864
            },
            "gtin": "4003573020143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bc4",
            "leftCorner": {
              "x": -3.32,
              "y": 28.219,
              "z": 0.864
            },
            "rightCorner": {
              "x": -3.437,
              "y": 28.225,
              "z": 0.864
            },
            "gtin": "4003573020143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bc5",
            "leftCorner": {
              "x": -3.437,
              "y": 28.225,
              "z": 0.864
            },
            "rightCorner": {
              "x": -3.553,
              "y": 28.23,
              "z": 0.864
            },
            "gtin": "4003573020143",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54668a",
        "height": 1.3051,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20bca",
            "leftCorner": {
              "x": -2.239,
              "y": 28.207,
              "z": 1.068
            },
            "rightCorner": {
              "x": -2.311,
              "y": 28.211,
              "z": 1.068
            },
            "gtin": "4002857008075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bcb",
            "leftCorner": {
              "x": -2.311,
              "y": 28.211,
              "z": 1.068
            },
            "rightCorner": {
              "x": -2.383,
              "y": 28.214,
              "z": 1.068
            },
            "gtin": "4002857008075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bcc",
            "leftCorner": {
              "x": -2.383,
              "y": 28.214,
              "z": 1.068
            },
            "rightCorner": {
              "x": -2.455,
              "y": 28.218,
              "z": 1.068
            },
            "gtin": "4002857008075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bcd",
            "leftCorner": {
              "x": -2.455,
              "y": 28.218,
              "z": 1.068
            },
            "rightCorner": {
              "x": -2.527,
              "y": 28.222,
              "z": 1.068
            },
            "gtin": "4002857008075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bce",
            "leftCorner": {
              "x": -2.529,
              "y": 28.185,
              "z": 1.068
            },
            "rightCorner": {
              "x": -2.777,
              "y": 28.197,
              "z": 1.068
            },
            "gtin": "4337185822179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bcf",
            "leftCorner": {
              "x": -2.776,
              "y": 28.198,
              "z": 1.068
            },
            "rightCorner": {
              "x": -2.854,
              "y": 28.203,
              "z": 1.068
            },
            "gtin": "4006000084787",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bd0",
            "leftCorner": {
              "x": -2.854,
              "y": 28.203,
              "z": 1.068
            },
            "rightCorner": {
              "x": -2.932,
              "y": 28.207,
              "z": 1.068
            },
            "gtin": "4006000084787",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bd1",
            "leftCorner": {
              "x": -2.932,
              "y": 28.207,
              "z": 1.068
            },
            "rightCorner": {
              "x": -3.007,
              "y": 28.211,
              "z": 1.068
            },
            "gtin": "4005900774699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bd2",
            "leftCorner": {
              "x": -3.007,
              "y": 28.211,
              "z": 1.068
            },
            "rightCorner": {
              "x": -3.082,
              "y": 28.215,
              "z": 1.068
            },
            "gtin": "4005900774699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bd3",
            "leftCorner": {
              "x": -3.082,
              "y": 28.207,
              "z": 1.068
            },
            "rightCorner": {
              "x": -3.146,
              "y": 28.21,
              "z": 1.068
            },
            "gtin": "4006000084725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bd4",
            "leftCorner": {
              "x": -3.146,
              "y": 28.21,
              "z": 1.068
            },
            "rightCorner": {
              "x": -3.21,
              "y": 28.213,
              "z": 1.068
            },
            "gtin": "4006000084725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bd5",
            "leftCorner": {
              "x": -3.21,
              "y": 28.213,
              "z": 1.068
            },
            "rightCorner": {
              "x": -3.274,
              "y": 28.216,
              "z": 1.068
            },
            "gtin": "4006000084725",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54668b",
        "height": 1.5661,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20be2",
            "leftCorner": {
              "x": -2.239,
              "y": 28.212,
              "z": 1.281
            },
            "rightCorner": {
              "x": -2.341,
              "y": 28.217,
              "z": 1.281
            },
            "gtin": "3574661671741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20be3",
            "leftCorner": {
              "x": -2.341,
              "y": 28.217,
              "z": 1.281
            },
            "rightCorner": {
              "x": -2.444,
              "y": 28.222,
              "z": 1.281
            },
            "gtin": "3574661671741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20be5",
            "leftCorner": {
              "x": -2.445,
              "y": 28.204,
              "z": 1.281
            },
            "rightCorner": {
              "x": -2.526,
              "y": 28.209,
              "z": 1.281
            },
            "gtin": "3574661826073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20be6",
            "leftCorner": {
              "x": -2.526,
              "y": 28.209,
              "z": 1.281
            },
            "rightCorner": {
              "x": -2.608,
              "y": 28.213,
              "z": 1.281
            },
            "gtin": "3574661826073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20be7",
            "leftCorner": {
              "x": -2.608,
              "y": 28.213,
              "z": 1.281
            },
            "rightCorner": {
              "x": -2.689,
              "y": 28.217,
              "z": 1.281
            },
            "gtin": "3574661826073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20be8",
            "leftCorner": {
              "x": -2.689,
              "y": 28.217,
              "z": 1.281
            },
            "rightCorner": {
              "x": -2.77,
              "y": 28.221,
              "z": 1.281
            },
            "gtin": "3574661826073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20be9",
            "leftCorner": {
              "x": -2.771,
              "y": 28.202,
              "z": 1.281
            },
            "rightCorner": {
              "x": -2.838,
              "y": 28.206,
              "z": 1.281
            },
            "gtin": "3574661824390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bea",
            "leftCorner": {
              "x": -2.838,
              "y": 28.206,
              "z": 1.281
            },
            "rightCorner": {
              "x": -2.905,
              "y": 28.21,
              "z": 1.281
            },
            "gtin": "3574661824390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20beb",
            "leftCorner": {
              "x": -2.905,
              "y": 28.205,
              "z": 1.281
            },
            "rightCorner": {
              "x": -2.961,
              "y": 28.208,
              "z": 1.281
            },
            "gtin": "3574661826165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bec",
            "leftCorner": {
              "x": -2.961,
              "y": 28.208,
              "z": 1.281
            },
            "rightCorner": {
              "x": -3.016,
              "y": 28.21,
              "z": 1.281
            },
            "gtin": "3574661826165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bed",
            "leftCorner": {
              "x": -3.016,
              "y": 28.21,
              "z": 1.281
            },
            "rightCorner": {
              "x": -3.072,
              "y": 28.213,
              "z": 1.281
            },
            "gtin": "3574661826165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bee",
            "leftCorner": {
              "x": -3.072,
              "y": 28.213,
              "z": 1.281
            },
            "rightCorner": {
              "x": -3.127,
              "y": 28.215,
              "z": 1.281
            },
            "gtin": "3574661826165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bef",
            "leftCorner": {
              "x": -3.126,
              "y": 28.232,
              "z": 1.281
            },
            "rightCorner": {
              "x": -3.219,
              "y": 28.237,
              "z": 1.281
            },
            "gtin": "3574661826103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20bf0",
            "leftCorner": {
              "x": -3.219,
              "y": 28.237,
              "z": 1.281
            },
            "rightCorner": {
              "x": -3.313,
              "y": 28.242,
              "z": 1.281
            },
            "gtin": "3574661826103",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54668d",
        "height": 1.7542,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20c0d",
            "leftCorner": {
              "x": -2.238,
              "y": 28.219,
              "z": 1.435
            },
            "rightCorner": {
              "x": -2.314,
              "y": 28.222,
              "z": 1.435
            }
          },
          {
            "id": "68300c8a5ed67a01d9a20c0f",
            "leftCorner": {
              "x": -2.315,
              "y": 28.188,
              "z": 1.435
            },
            "rightCorner": {
              "x": -2.378,
              "y": 28.192,
              "z": 1.435
            },
            "gtin": "4063367233388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c10",
            "leftCorner": {
              "x": -2.378,
              "y": 28.192,
              "z": 1.435
            },
            "rightCorner": {
              "x": -2.441,
              "y": 28.194,
              "z": 1.435
            },
            "gtin": "4063367233388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c11",
            "leftCorner": {
              "x": -2.441,
              "y": 28.194,
              "z": 1.435
            },
            "rightCorner": {
              "x": -2.504,
              "y": 28.198,
              "z": 1.435
            },
            "gtin": "4063367233388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c12",
            "leftCorner": {
              "x": -2.504,
              "y": 28.207,
              "z": 1.435
            },
            "rightCorner": {
              "x": -2.541,
              "y": 28.209,
              "z": 1.435
            },
            "gtin": "4005900841612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c13",
            "leftCorner": {
              "x": -2.541,
              "y": 28.209,
              "z": 1.435
            },
            "rightCorner": {
              "x": -2.579,
              "y": 28.211,
              "z": 1.435
            },
            "gtin": "4005900841612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c14",
            "leftCorner": {
              "x": -2.579,
              "y": 28.208,
              "z": 1.435
            },
            "rightCorner": {
              "x": -2.641,
              "y": 28.211,
              "z": 1.435
            },
            "gtin": "4005900805966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c15",
            "leftCorner": {
              "x": -2.641,
              "y": 28.204,
              "z": 1.435
            },
            "rightCorner": {
              "x": -2.692,
              "y": 28.207,
              "z": 1.435
            },
            "gtin": "4005900805928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c16",
            "leftCorner": {
              "x": -2.692,
              "y": 28.204,
              "z": 1.435
            },
            "rightCorner": {
              "x": -2.744,
              "y": 28.206,
              "z": 1.435
            },
            "gtin": "4005900788573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c17",
            "leftCorner": {
              "x": -2.744,
              "y": 28.206,
              "z": 1.435
            },
            "rightCorner": {
              "x": -2.793,
              "y": 28.209,
              "z": 1.435
            },
            "gtin": "4084200550202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c18",
            "leftCorner": {
              "x": -2.793,
              "y": 28.203,
              "z": 1.435
            },
            "rightCorner": {
              "x": -2.861,
              "y": 28.206,
              "z": 1.435
            },
            "gtin": "4037900013041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c19",
            "leftCorner": {
              "x": -2.861,
              "y": 28.206,
              "z": 1.435
            },
            "rightCorner": {
              "x": -2.93,
              "y": 28.21,
              "z": 1.435
            },
            "gtin": "4037900013041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c1a",
            "leftCorner": {
              "x": -2.93,
              "y": 28.21,
              "z": 1.435
            },
            "rightCorner": {
              "x": -3.013,
              "y": 28.214,
              "z": 1.435
            },
            "gtin": "3600541698475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c1b",
            "leftCorner": {
              "x": -3.013,
              "y": 28.211,
              "z": 1.435
            },
            "rightCorner": {
              "x": -3.22,
              "y": 28.221,
              "z": 1.435
            },
            "gtin": "4063367395918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20c1c",
            "leftCorner": {
              "x": -3.219,
              "y": 28.231,
              "z": 1.435
            },
            "rightCorner": {
              "x": -3.357,
              "y": 28.238,
              "z": 1.435
            },
            "gtin": "4006000002217",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "a6d6c"
  },
  {
    "id": "d13d0",
    "name": "d13d0",
    "x": -11.682,
    "y": 30.879,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.026709,
      "w": 0.99964
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 107
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a54663d",
        "height": 0.16645,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2065f",
            "leftCorner": {
              "x": -11.682,
              "y": 30.885,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.641,
              "y": 30.882,
              "z": 0.136
            },
            "gtin": "5016155264568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20660",
            "leftCorner": {
              "x": -11.641,
              "y": 30.882,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.601,
              "y": 30.88,
              "z": 0.136
            },
            "gtin": "5016155264568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20663",
            "leftCorner": {
              "x": -11.599,
              "y": 30.924,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.488,
              "y": 30.918,
              "z": 0.136
            },
            "gtin": "5016155119806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20664",
            "leftCorner": {
              "x": -11.488,
              "y": 30.92,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.429,
              "y": 30.918,
              "z": 0.136
            },
            "gtin": "4063367218033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20665",
            "leftCorner": {
              "x": -11.429,
              "y": 30.918,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.37,
              "y": 30.915,
              "z": 0.136
            },
            "gtin": "4063367218033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20666",
            "leftCorner": {
              "x": -11.37,
              "y": 30.915,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.312,
              "y": 30.911,
              "z": 0.136
            },
            "gtin": "4063367218033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20667",
            "leftCorner": {
              "x": -11.312,
              "y": 30.906,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.248,
              "y": 30.903,
              "z": 0.136
            },
            "gtin": "4063367424625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20668",
            "leftCorner": {
              "x": -11.247,
              "y": 30.899,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.089,
              "y": 30.89,
              "z": 0.136
            },
            "gtin": "4011609011850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20669",
            "leftCorner": {
              "x": -11.089,
              "y": 30.89,
              "z": 0.136
            },
            "rightCorner": {
              "x": -10.93,
              "y": 30.882,
              "z": 0.136
            },
            "gtin": "4011609011850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2066a",
            "leftCorner": {
              "x": -10.93,
              "y": 30.885,
              "z": 0.136
            },
            "rightCorner": {
              "x": -10.838,
              "y": 30.879,
              "z": 0.136
            },
            "gtin": "4064666847863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2066b",
            "leftCorner": {
              "x": -10.838,
              "y": 30.879,
              "z": 0.136
            },
            "rightCorner": {
              "x": -10.746,
              "y": 30.874,
              "z": 0.136
            },
            "gtin": "4064666847863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2066c",
            "leftCorner": {
              "x": -10.746,
              "y": 30.874,
              "z": 0.136
            },
            "rightCorner": {
              "x": -10.655,
              "y": 30.87,
              "z": 0.136
            },
            "gtin": "4064666847863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2066d",
            "leftCorner": {
              "x": -10.655,
              "y": 30.87,
              "z": 0.136
            },
            "rightCorner": {
              "x": -10.533,
              "y": 30.863,
              "z": 0.136
            },
            "gtin": "4064666847931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2066e",
            "leftCorner": {
              "x": -10.533,
              "y": 30.863,
              "z": 0.136
            },
            "rightCorner": {
              "x": -10.413,
              "y": 30.856,
              "z": 0.136
            },
            "gtin": "4064666847931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2066f",
            "leftCorner": {
              "x": -10.413,
              "y": 30.856,
              "z": 0.136
            },
            "rightCorner": {
              "x": -10.291,
              "y": 30.849,
              "z": 0.136
            },
            "gtin": "4064666847931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20670",
            "leftCorner": {
              "x": -10.291,
              "y": 30.849,
              "z": 0.136
            },
            "rightCorner": {
              "x": -10.17,
              "y": 30.843,
              "z": 0.136
            },
            "gtin": "4064666847931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20671",
            "leftCorner": {
              "x": -10.17,
              "y": 30.843,
              "z": 0.136
            },
            "rightCorner": {
              "x": -10.048,
              "y": 30.837,
              "z": 0.136
            },
            "gtin": "4064666847931",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546639",
        "height": 0.49004,
        "facings": [
          {
            "id": "68300c895ed67a01d9a20587",
            "leftCorner": {
              "x": -11.677,
              "y": 30.974,
              "z": 0.401
            },
            "rightCorner": {
              "x": -11.633,
              "y": 30.971,
              "z": 0.401
            },
            "gtin": "5016155128518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20588",
            "leftCorner": {
              "x": -11.633,
              "y": 30.971,
              "z": 0.401
            },
            "rightCorner": {
              "x": -11.591,
              "y": 30.969,
              "z": 0.401
            },
            "gtin": "5016155128518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20589",
            "leftCorner": {
              "x": -11.591,
              "y": 30.969,
              "z": 0.401
            },
            "rightCorner": {
              "x": -11.547,
              "y": 30.966,
              "z": 0.401
            },
            "gtin": "5016155128518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2058a",
            "leftCorner": {
              "x": -11.547,
              "y": 30.966,
              "z": 0.401
            },
            "rightCorner": {
              "x": -11.504,
              "y": 30.964,
              "z": 0.401
            },
            "gtin": "5016155128518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2058d",
            "leftCorner": {
              "x": -11.501,
              "y": 31.019,
              "z": 0.401
            },
            "rightCorner": {
              "x": -11.419,
              "y": 31.014,
              "z": 0.401
            },
            "gtin": "5016155264582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2058e",
            "leftCorner": {
              "x": -11.419,
              "y": 31.011,
              "z": 0.401
            },
            "rightCorner": {
              "x": -11.304,
              "y": 31.005,
              "z": 0.401
            },
            "gtin": "5010724526798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2058f",
            "leftCorner": {
              "x": -11.305,
              "y": 30.988,
              "z": 0.401
            },
            "rightCorner": {
              "x": -11.228,
              "y": 30.983,
              "z": 0.401
            },
            "gtin": "5010724539446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20590",
            "leftCorner": {
              "x": -11.229,
              "y": 30.978,
              "z": 0.401
            },
            "rightCorner": {
              "x": -11.175,
              "y": 30.975,
              "z": 0.401
            },
            "gtin": "5010724527375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20591",
            "leftCorner": {
              "x": -11.175,
              "y": 30.975,
              "z": 0.401
            },
            "rightCorner": {
              "x": -11.12,
              "y": 30.973,
              "z": 0.401
            },
            "gtin": "5010724527375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20592",
            "leftCorner": {
              "x": -11.12,
              "y": 30.984,
              "z": 0.401
            },
            "rightCorner": {
              "x": -11.009,
              "y": 30.978,
              "z": 0.401
            },
            "gtin": "5010724527450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20593",
            "leftCorner": {
              "x": -11.009,
              "y": 30.981,
              "z": 0.401
            },
            "rightCorner": {
              "x": -10.886,
              "y": 30.974,
              "z": 0.401
            },
            "gtin": "5010724527481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20594",
            "leftCorner": {
              "x": -10.887,
              "y": 30.967,
              "z": 0.401
            },
            "rightCorner": {
              "x": -10.83,
              "y": 30.963,
              "z": 0.401
            },
            "gtin": "5010724544693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20595",
            "leftCorner": {
              "x": -10.83,
              "y": 30.963,
              "z": 0.401
            },
            "rightCorner": {
              "x": -10.771,
              "y": 30.96,
              "z": 0.401
            },
            "gtin": "5010724544693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20596",
            "leftCorner": {
              "x": -10.771,
              "y": 30.959,
              "z": 0.401
            },
            "rightCorner": {
              "x": -10.714,
              "y": 30.956,
              "z": 0.401
            },
            "gtin": "5010724532966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20597",
            "leftCorner": {
              "x": -10.714,
              "y": 30.956,
              "z": 0.401
            },
            "rightCorner": {
              "x": -10.658,
              "y": 30.953,
              "z": 0.401
            },
            "gtin": "5010724532966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20598",
            "leftCorner": {
              "x": -10.657,
              "y": 30.948,
              "z": 0.401
            },
            "rightCorner": {
              "x": -10.586,
              "y": 30.944,
              "z": 0.401
            },
            "gtin": "5010724527443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20599",
            "leftCorner": {
              "x": -10.586,
              "y": 30.945,
              "z": 0.401
            },
            "rightCorner": {
              "x": -10.511,
              "y": 30.94,
              "z": 0.401
            },
            "gtin": "5010724527467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2059a",
            "leftCorner": {
              "x": -10.511,
              "y": 30.94,
              "z": 0.401
            },
            "rightCorner": {
              "x": -10.436,
              "y": 30.936,
              "z": 0.401
            },
            "gtin": "5010724527467",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54663b",
        "height": 0.79347,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20940",
            "leftCorner": {
              "x": -11.677,
              "y": 30.976,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.63,
              "y": 30.973,
              "z": 0.649
            },
            "gtin": "4015100810349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20941",
            "leftCorner": {
              "x": -11.63,
              "y": 30.973,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.582,
              "y": 30.971,
              "z": 0.649
            },
            "gtin": "4015100810349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20943",
            "leftCorner": {
              "x": -11.58,
              "y": 31.01,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.517,
              "y": 31.007,
              "z": 0.649
            },
            "gtin": "5903719640213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20944",
            "leftCorner": {
              "x": -11.517,
              "y": 31.007,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.453,
              "y": 31.004,
              "z": 0.649
            },
            "gtin": "5903719640213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20945",
            "leftCorner": {
              "x": -11.453,
              "y": 31.004,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.39,
              "y": 31.0,
              "z": 0.649
            },
            "gtin": "5903719640213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20946",
            "leftCorner": {
              "x": -11.39,
              "y": 30.994,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.312,
              "y": 30.99,
              "z": 0.649
            },
            "gtin": "4015100800128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20947",
            "leftCorner": {
              "x": -11.312,
              "y": 30.99,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.235,
              "y": 30.986,
              "z": 0.649
            },
            "gtin": "4015100800128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20948",
            "leftCorner": {
              "x": -11.235,
              "y": 30.979,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.14,
              "y": 30.973,
              "z": 0.649
            },
            "gtin": "4013162033447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20949",
            "leftCorner": {
              "x": -11.14,
              "y": 30.981,
              "z": 0.649
            },
            "rightCorner": {
              "x": -11.06,
              "y": 30.976,
              "z": 0.649
            },
            "gtin": "4072600721704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2094a",
            "leftCorner": {
              "x": -11.06,
              "y": 30.976,
              "z": 0.649
            },
            "rightCorner": {
              "x": -10.979,
              "y": 30.972,
              "z": 0.649
            },
            "gtin": "4072600721704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2094b",
            "leftCorner": {
              "x": -10.979,
              "y": 30.978,
              "z": 0.649
            },
            "rightCorner": {
              "x": -10.907,
              "y": 30.975,
              "z": 0.649
            },
            "gtin": "4072600721902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2094c",
            "leftCorner": {
              "x": -10.907,
              "y": 30.975,
              "z": 0.649
            },
            "rightCorner": {
              "x": -10.835,
              "y": 30.971,
              "z": 0.649
            },
            "gtin": "4072600721902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2094d",
            "leftCorner": {
              "x": -10.835,
              "y": 30.971,
              "z": 0.649
            },
            "rightCorner": {
              "x": -10.764,
              "y": 30.968,
              "z": 0.649
            },
            "gtin": "4072600721902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2094e",
            "leftCorner": {
              "x": -10.763,
              "y": 30.974,
              "z": 0.649
            },
            "rightCorner": {
              "x": -10.704,
              "y": 30.97,
              "z": 0.649
            },
            "gtin": "4015100800609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2094f",
            "leftCorner": {
              "x": -10.704,
              "y": 30.966,
              "z": 0.649
            },
            "rightCorner": {
              "x": -10.627,
              "y": 30.962,
              "z": 0.649
            },
            "gtin": "3600522506805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20950",
            "leftCorner": {
              "x": -10.627,
              "y": 30.961,
              "z": 0.649
            },
            "rightCorner": {
              "x": -10.532,
              "y": 30.956,
              "z": 0.649
            },
            "gtin": "5010724538616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20951",
            "leftCorner": {
              "x": -10.532,
              "y": 30.955,
              "z": 0.649
            },
            "rightCorner": {
              "x": -10.458,
              "y": 30.951,
              "z": 0.649
            },
            "gtin": "5010724538593",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20952",
            "leftCorner": {
              "x": -10.458,
              "y": 30.951,
              "z": 0.649
            },
            "rightCorner": {
              "x": -10.384,
              "y": 30.947,
              "z": 0.649
            },
            "gtin": "5010724538593",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20953",
            "leftCorner": {
              "x": -10.384,
              "y": 30.947,
              "z": 0.649
            },
            "rightCorner": {
              "x": -10.311,
              "y": 30.943,
              "z": 0.649
            },
            "gtin": "5010724538593",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546638",
        "height": 1.0433,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20918",
            "leftCorner": {
              "x": -11.677,
              "y": 30.978,
              "z": 0.854
            },
            "rightCorner": {
              "x": -11.628,
              "y": 30.975,
              "z": 0.854
            },
            "gtin": "4072600282243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2091c",
            "leftCorner": {
              "x": -11.624,
              "y": 31.021,
              "z": 0.854
            },
            "rightCorner": {
              "x": -11.58,
              "y": 31.019,
              "z": 0.854
            },
            "gtin": "4072600282441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2091d",
            "leftCorner": {
              "x": -11.58,
              "y": 31.014,
              "z": 0.854
            },
            "rightCorner": {
              "x": -11.53,
              "y": 31.01,
              "z": 0.854
            },
            "gtin": "4063367104497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2091e",
            "leftCorner": {
              "x": -11.53,
              "y": 31.01,
              "z": 0.854
            },
            "rightCorner": {
              "x": -11.481,
              "y": 31.008,
              "z": 0.854
            },
            "gtin": "4063367104497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2091f",
            "leftCorner": {
              "x": -11.482,
              "y": 31.0,
              "z": 0.854
            },
            "rightCorner": {
              "x": -11.439,
              "y": 30.998,
              "z": 0.854
            },
            "gtin": "4015100860146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20920",
            "leftCorner": {
              "x": -11.439,
              "y": 30.998,
              "z": 0.854
            },
            "rightCorner": {
              "x": -11.397,
              "y": 30.996,
              "z": 0.854
            },
            "gtin": "4015100860146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20921",
            "leftCorner": {
              "x": -11.396,
              "y": 30.998,
              "z": 0.854
            },
            "rightCorner": {
              "x": -11.316,
              "y": 30.994,
              "z": 0.854
            },
            "gtin": "4015100800180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20922",
            "leftCorner": {
              "x": -11.316,
              "y": 31.0,
              "z": 0.854
            },
            "rightCorner": {
              "x": -11.225,
              "y": 30.994,
              "z": 0.854
            },
            "gtin": "4015100810684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20923",
            "leftCorner": {
              "x": -11.226,
              "y": 30.991,
              "z": 0.854
            },
            "rightCorner": {
              "x": -11.182,
              "y": 30.989,
              "z": 0.854
            },
            "gtin": "4015100815788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20924",
            "leftCorner": {
              "x": -11.182,
              "y": 30.989,
              "z": 0.854
            },
            "rightCorner": {
              "x": -11.137,
              "y": 30.986,
              "z": 0.854
            },
            "gtin": "4015100815788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20925",
            "leftCorner": {
              "x": -11.137,
              "y": 30.99,
              "z": 0.854
            },
            "rightCorner": {
              "x": -11.06,
              "y": 30.985,
              "z": 0.854
            },
            "gtin": "4015100815627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20926",
            "leftCorner": {
              "x": -11.06,
              "y": 30.987,
              "z": 0.854
            },
            "rightCorner": {
              "x": -11.011,
              "y": 30.985,
              "z": 0.854
            },
            "gtin": "4015100810400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20927",
            "leftCorner": {
              "x": -11.011,
              "y": 30.985,
              "z": 0.854
            },
            "rightCorner": {
              "x": -10.962,
              "y": 30.982,
              "z": 0.854
            },
            "gtin": "4015100810400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20928",
            "leftCorner": {
              "x": -10.962,
              "y": 30.982,
              "z": 0.854
            },
            "rightCorner": {
              "x": -10.913,
              "y": 30.98,
              "z": 0.854
            },
            "gtin": "4015100810400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20929",
            "leftCorner": {
              "x": -10.913,
              "y": 30.987,
              "z": 0.854
            },
            "rightCorner": {
              "x": -10.853,
              "y": 30.983,
              "z": 0.854
            },
            "gtin": "3614226254283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2092a",
            "leftCorner": {
              "x": -10.853,
              "y": 30.983,
              "z": 0.854
            },
            "rightCorner": {
              "x": -10.794,
              "y": 30.98,
              "z": 0.854
            },
            "gtin": "3614226254283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2092b",
            "leftCorner": {
              "x": -10.795,
              "y": 30.971,
              "z": 0.854
            },
            "rightCorner": {
              "x": -10.668,
              "y": 30.964,
              "z": 0.854
            },
            "gtin": "4011609011713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2092c",
            "leftCorner": {
              "x": -10.668,
              "y": 30.95,
              "z": 0.854
            },
            "rightCorner": {
              "x": -10.609,
              "y": 30.947,
              "z": 0.854
            },
            "gtin": "4015100811025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2092d",
            "leftCorner": {
              "x": -10.609,
              "y": 30.947,
              "z": 0.854
            },
            "rightCorner": {
              "x": -10.55,
              "y": 30.944,
              "z": 0.854
            },
            "gtin": "4015100811025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2092e",
            "leftCorner": {
              "x": -10.55,
              "y": 30.949,
              "z": 0.854
            },
            "rightCorner": {
              "x": -10.487,
              "y": 30.946,
              "z": 0.854
            },
            "gtin": "4015100810844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2092f",
            "leftCorner": {
              "x": -10.487,
              "y": 30.946,
              "z": 0.854
            },
            "rightCorner": {
              "x": -10.425,
              "y": 30.942,
              "z": 0.854
            },
            "gtin": "4015100810844",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54663c",
        "height": 1.2995,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a20962",
            "leftCorner": {
              "x": -11.671,
              "y": 31.084,
              "z": 1.063
            },
            "rightCorner": {
              "x": -11.53,
              "y": 31.077,
              "z": 1.063
            },
            "gtin": "4015100800067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20964",
            "leftCorner": {
              "x": -11.529,
              "y": 31.115,
              "z": 1.063
            },
            "rightCorner": {
              "x": -11.451,
              "y": 31.111,
              "z": 1.063
            },
            "gtin": "4015100800500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20965",
            "leftCorner": {
              "x": -11.451,
              "y": 31.111,
              "z": 1.063
            },
            "rightCorner": {
              "x": -11.373,
              "y": 31.106,
              "z": 1.063
            },
            "gtin": "4015100800500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20966",
            "leftCorner": {
              "x": -11.372,
              "y": 31.11,
              "z": 1.063
            },
            "rightCorner": {
              "x": -11.254,
              "y": 31.104,
              "z": 1.063
            },
            "gtin": "4015100863208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20967",
            "leftCorner": {
              "x": -11.254,
              "y": 31.104,
              "z": 1.063
            },
            "rightCorner": {
              "x": -11.135,
              "y": 31.097,
              "z": 1.063
            },
            "gtin": "4015100863208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20968",
            "leftCorner": {
              "x": -11.136,
              "y": 31.088,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.963,
              "y": 31.079,
              "z": 1.063
            },
            "gtin": "4015100800388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a20969",
            "leftCorner": {
              "x": -10.962,
              "y": 31.09,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.862,
              "y": 31.085,
              "z": 1.063
            },
            "gtin": "4015100800265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2096a",
            "leftCorner": {
              "x": -10.862,
              "y": 31.085,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.763,
              "y": 31.08,
              "z": 1.063
            },
            "gtin": "4015100800265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2096b",
            "leftCorner": {
              "x": -10.763,
              "y": 31.077,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.686,
              "y": 31.073,
              "z": 1.063
            },
            "gtin": "4011609011928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2096c",
            "leftCorner": {
              "x": -10.686,
              "y": 31.073,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.609,
              "y": 31.069,
              "z": 1.063
            },
            "gtin": "4011609011928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2096d",
            "leftCorner": {
              "x": -10.609,
              "y": 31.066,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.53,
              "y": 31.062,
              "z": 1.063
            },
            "gtin": "4015100811001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2096e",
            "leftCorner": {
              "x": -10.531,
              "y": 31.053,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.464,
              "y": 31.05,
              "z": 1.063
            },
            "gtin": "30177819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2096f",
            "leftCorner": {
              "x": -10.463,
              "y": 31.059,
              "z": 1.063
            },
            "rightCorner": {
              "x": -10.389,
              "y": 31.055,
              "z": 1.063
            },
            "gtin": "30177703",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54663a",
        "height": 1.4969,
        "facings": [
          {
            "id": "68300c895ed67a01d9a2052d",
            "leftCorner": {
              "x": -11.671,
              "y": 31.08,
              "z": 1.225
            },
            "rightCorner": {
              "x": -11.627,
              "y": 31.078,
              "z": 1.225
            },
            "gtin": "3600522471714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2052e",
            "leftCorner": {
              "x": -11.627,
              "y": 31.078,
              "z": 1.225
            },
            "rightCorner": {
              "x": -11.583,
              "y": 31.075,
              "z": 1.225
            },
            "gtin": "3600522471714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20530",
            "leftCorner": {
              "x": -11.581,
              "y": 31.113,
              "z": 1.225
            },
            "rightCorner": {
              "x": -11.478,
              "y": 31.108,
              "z": 1.225
            },
            "gtin": "4015100817188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20531",
            "leftCorner": {
              "x": -11.478,
              "y": 31.103,
              "z": 1.225
            },
            "rightCorner": {
              "x": -11.41,
              "y": 31.099,
              "z": 1.225
            },
            "gtin": "4104260064508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20532",
            "leftCorner": {
              "x": -11.41,
              "y": 31.099,
              "z": 1.225
            },
            "rightCorner": {
              "x": -11.342,
              "y": 31.096,
              "z": 1.225
            },
            "gtin": "4104260064508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20533",
            "leftCorner": {
              "x": -11.341,
              "y": 31.105,
              "z": 1.225
            },
            "rightCorner": {
              "x": -11.274,
              "y": 31.102,
              "z": 1.225
            },
            "gtin": "3600522471806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20534",
            "leftCorner": {
              "x": -11.274,
              "y": 31.102,
              "z": 1.225
            },
            "rightCorner": {
              "x": -11.205,
              "y": 31.098,
              "z": 1.225
            },
            "gtin": "3600522471806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20535",
            "leftCorner": {
              "x": -11.205,
              "y": 31.098,
              "z": 1.225
            },
            "rightCorner": {
              "x": -11.136,
              "y": 31.094,
              "z": 1.225
            },
            "gtin": "3600522471806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20536",
            "leftCorner": {
              "x": -11.136,
              "y": 31.097,
              "z": 1.225
            },
            "rightCorner": {
              "x": -11.063,
              "y": 31.093,
              "z": 1.225
            },
            "gtin": "4011609011775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20537",
            "leftCorner": {
              "x": -11.063,
              "y": 31.093,
              "z": 1.225
            },
            "rightCorner": {
              "x": -10.991,
              "y": 31.089,
              "z": 1.225
            },
            "gtin": "4011609011775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20538",
            "leftCorner": {
              "x": -10.99,
              "y": 31.094,
              "z": 1.225
            },
            "rightCorner": {
              "x": -10.918,
              "y": 31.09,
              "z": 1.225
            },
            "gtin": "4011609012031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20539",
            "leftCorner": {
              "x": -10.918,
              "y": 31.09,
              "z": 1.225
            },
            "rightCorner": {
              "x": -10.847,
              "y": 31.087,
              "z": 1.225
            },
            "gtin": "4011609012031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2053a",
            "leftCorner": {
              "x": -10.847,
              "y": 31.087,
              "z": 1.225
            },
            "rightCorner": {
              "x": -10.775,
              "y": 31.083,
              "z": 1.225
            },
            "gtin": "4011609012031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2053b",
            "leftCorner": {
              "x": -10.775,
              "y": 31.083,
              "z": 1.225
            },
            "rightCorner": {
              "x": -10.703,
              "y": 31.079,
              "z": 1.225
            },
            "gtin": "4011609012031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2053c",
            "leftCorner": {
              "x": -10.704,
              "y": 31.072,
              "z": 1.225
            },
            "rightCorner": {
              "x": -10.64,
              "y": 31.068,
              "z": 1.225
            },
            "gtin": "4011609011942",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2053d",
            "leftCorner": {
              "x": -10.64,
              "y": 31.068,
              "z": 1.225
            },
            "rightCorner": {
              "x": -10.578,
              "y": 31.064,
              "z": 1.225
            },
            "gtin": "4011609011942",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2053e",
            "leftCorner": {
              "x": -10.578,
              "y": 31.055,
              "z": 1.225
            },
            "rightCorner": {
              "x": -10.52,
              "y": 31.051,
              "z": 1.225
            },
            "gtin": "4011609011812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a2053f",
            "leftCorner": {
              "x": -10.52,
              "y": 31.051,
              "z": 1.225
            },
            "rightCorner": {
              "x": -10.461,
              "y": 31.048,
              "z": 1.225
            },
            "gtin": "4011609011812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a20540",
            "leftCorner": {
              "x": -10.461,
              "y": 31.042,
              "z": 1.225
            },
            "rightCorner": {
              "x": -10.405,
              "y": 31.039,
              "z": 1.225
            },
            "gtin": "4104260064492",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "468c6"
  },
  {
    "id": "d9f57",
    "name": "d9f57",
    "x": -12.954,
    "y": 42.78,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69589,
      "w": 0.71815
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 12
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463f7",
        "height": 0.16974,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e979",
            "leftCorner": {
              "x": -13.002,
              "y": 42.792,
              "z": 0.139
            },
            "rightCorner": {
              "x": -12.996,
              "y": 42.986,
              "z": 0.139
            },
            "gtin": "4000270695759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e97a",
            "leftCorner": {
              "x": -12.996,
              "y": 42.986,
              "z": 0.139
            },
            "rightCorner": {
              "x": -12.989,
              "y": 43.179,
              "z": 0.139
            },
            "gtin": "4000270695759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e974",
            "leftCorner": {
              "x": -12.992,
              "y": 43.179,
              "z": 0.139
            },
            "rightCorner": {
              "x": -12.965,
              "y": 44.031,
              "z": 0.139
            },
            "gtin": "4001515084499",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463f5",
        "height": 0.69871,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e96a",
            "leftCorner": {
              "x": -12.964,
              "y": 42.781,
              "z": 0.572
            },
            "rightCorner": {
              "x": -12.955,
              "y": 43.082,
              "z": 0.572
            },
            "gtin": "4052396028720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e96b",
            "leftCorner": {
              "x": -12.955,
              "y": 43.082,
              "z": 0.572
            },
            "rightCorner": {
              "x": -12.945,
              "y": 43.384,
              "z": 0.572
            },
            "gtin": "4052396028720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e96e",
            "leftCorner": {
              "x": -12.974,
              "y": 43.385,
              "z": 0.572
            },
            "rightCorner": {
              "x": -12.962,
              "y": 43.786,
              "z": 0.572
            },
            "gtin": "4052396028720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e96c",
            "leftCorner": {
              "x": -12.98,
              "y": 43.787,
              "z": 0.572
            },
            "rightCorner": {
              "x": -12.977,
              "y": 43.909,
              "z": 0.572
            },
            "gtin": "4052396028720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e96d",
            "leftCorner": {
              "x": -12.977,
              "y": 43.909,
              "z": 0.572
            },
            "rightCorner": {
              "x": -12.973,
              "y": 44.032,
              "z": 0.572
            },
            "gtin": "4052396028720",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463f6",
        "height": 1.1955,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e972",
            "leftCorner": {
              "x": -12.987,
              "y": 42.819,
              "z": 0.978
            },
            "rightCorner": {
              "x": -12.961,
              "y": 43.635,
              "z": 0.978
            },
            "gtin": "4052396028720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e970",
            "leftCorner": {
              "x": -12.944,
              "y": 43.635,
              "z": 0.978
            },
            "rightCorner": {
              "x": -12.931,
              "y": 44.031,
              "z": 0.978
            },
            "gtin": "8013183117542",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463f8",
        "height": 1.599,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e97b",
            "leftCorner": {
              "x": -12.932,
              "y": 42.78,
              "z": 1.308
            },
            "rightCorner": {
              "x": -12.926,
              "y": 42.962,
              "z": 1.308
            }
          },
          {
            "id": "68300c865ed67a01d9a1e97c",
            "leftCorner": {
              "x": -12.926,
              "y": 42.962,
              "z": 1.308
            },
            "rightCorner": {
              "x": -12.921,
              "y": 43.145,
              "z": 1.308
            }
          },
          {
            "id": "68300c865ed67a01d9a1e97d",
            "leftCorner": {
              "x": -12.921,
              "y": 43.145,
              "z": 1.308
            },
            "rightCorner": {
              "x": -12.914,
              "y": 43.327,
              "z": 1.308
            }
          },
          {
            "id": "68300c865ed67a01d9a1e97e",
            "leftCorner": {
              "x": -12.914,
              "y": 43.327,
              "z": 1.308
            },
            "rightCorner": {
              "x": -12.909,
              "y": 43.509,
              "z": 1.308
            }
          },
          {
            "id": "68300c865ed67a01d9a1e97f",
            "leftCorner": {
              "x": -12.941,
              "y": 43.51,
              "z": 1.308
            },
            "rightCorner": {
              "x": -12.932,
              "y": 43.77,
              "z": 1.308
            },
            "gtin": "5900791000317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e980",
            "leftCorner": {
              "x": -12.932,
              "y": 43.77,
              "z": 1.308
            },
            "rightCorner": {
              "x": -12.923,
              "y": 44.03,
              "z": 1.308
            },
            "gtin": "5900791000317",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ededa",
    "rightNeighborShelfId": "d9f58"
  },
  {
    "id": "d9f58",
    "name": "d9f58",
    "x": -12.915,
    "y": 44.03,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69589,
      "w": 0.71815
    },

    "layers": [],
    "leftNeighborShelfId": "d9f57",
    "rightNeighborShelfId": "d9f59"
  },
  {
    "id": "d9f59",
    "name": "d9f59",
    "x": -12.876,
    "y": 45.279,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69589,
      "w": 0.71815
    },

    "layers": [],
    "leftNeighborShelfId": "d9f58",
    "rightNeighborShelfId": "edee1"
  },
  {
    "id": "d9f62",
    "name": "d9f62",
    "x": -12.54,
    "y": 52.751,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69635,
      "w": 0.71771
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 50
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a54649f",
        "height": 0.16214,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f26f",
            "leftCorner": {
              "x": -12.598,
              "y": 52.944,
              "z": 0.133
            },
            "rightCorner": {
              "x": -12.595,
              "y": 53.044,
              "z": 0.133
            },
            "gtin": "4300175511841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f270",
            "leftCorner": {
              "x": -12.595,
              "y": 53.044,
              "z": 0.133
            },
            "rightCorner": {
              "x": -12.592,
              "y": 53.143,
              "z": 0.133
            },
            "gtin": "4300175511841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f271",
            "leftCorner": {
              "x": -12.594,
              "y": 53.143,
              "z": 0.133
            },
            "rightCorner": {
              "x": -12.591,
              "y": 53.231,
              "z": 0.133
            },
            "gtin": "4018833952683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f272",
            "leftCorner": {
              "x": -12.592,
              "y": 53.231,
              "z": 0.133
            },
            "rightCorner": {
              "x": -12.578,
              "y": 53.72,
              "z": 0.133
            },
            "gtin": "8005989248186",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f273",
            "leftCorner": {
              "x": -12.572,
              "y": 53.719,
              "z": 0.133
            },
            "rightCorner": {
              "x": -12.571,
              "y": 53.781,
              "z": 0.133
            },
            "gtin": "4004617388724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f274",
            "leftCorner": {
              "x": -12.571,
              "y": 53.781,
              "z": 0.133
            },
            "rightCorner": {
              "x": -12.569,
              "y": 53.842,
              "z": 0.133
            },
            "gtin": "4004617388724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f275",
            "leftCorner": {
              "x": -12.568,
              "y": 53.842,
              "z": 0.133
            },
            "rightCorner": {
              "x": -12.562,
              "y": 54.028,
              "z": 0.133
            },
            "gtin": "4018833952607",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54649e",
        "height": 0.48845,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f21a",
            "leftCorner": {
              "x": -12.597,
              "y": 52.706,
              "z": 0.4
            },
            "rightCorner": {
              "x": -12.592,
              "y": 52.853,
              "z": 0.4
            },
            "gtin": "4337185909818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f21b",
            "leftCorner": {
              "x": -12.592,
              "y": 52.853,
              "z": 0.4
            },
            "rightCorner": {
              "x": -12.588,
              "y": 52.999,
              "z": 0.4
            },
            "gtin": "4337185909818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f21c",
            "leftCorner": {
              "x": -12.6,
              "y": 52.999,
              "z": 0.4
            },
            "rightCorner": {
              "x": -12.593,
              "y": 53.227,
              "z": 0.4
            },
            "gtin": "4337185909832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f21d",
            "leftCorner": {
              "x": -12.593,
              "y": 53.227,
              "z": 0.4
            },
            "rightCorner": {
              "x": -12.591,
              "y": 53.329,
              "z": 0.4
            },
            "gtin": "4009049303239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f21e",
            "leftCorner": {
              "x": -12.591,
              "y": 53.329,
              "z": 0.4
            },
            "rightCorner": {
              "x": -12.587,
              "y": 53.43,
              "z": 0.4
            },
            "gtin": "4009049303239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f21f",
            "leftCorner": {
              "x": -12.571,
              "y": 53.43,
              "z": 0.4
            },
            "rightCorner": {
              "x": -12.563,
              "y": 53.696,
              "z": 0.4
            },
            "gtin": "4009049303109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f20b",
            "leftCorner": {
              "x": -12.579,
              "y": 53.697,
              "z": 0.4
            },
            "rightCorner": {
              "x": -12.573,
              "y": 53.85,
              "z": 0.4
            },
            "gtin": "8807246005828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f20c",
            "leftCorner": {
              "x": -12.573,
              "y": 53.85,
              "z": 0.4
            },
            "rightCorner": {
              "x": -12.569,
              "y": 54.003,
              "z": 0.4
            },
            "gtin": "8807246005828",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54649d",
        "height": 0.79057,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f231",
            "leftCorner": {
              "x": -12.588,
              "y": 52.749,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.583,
              "y": 52.93,
              "z": 0.647
            },
            "gtin": "4009049378824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f232",
            "leftCorner": {
              "x": -12.597,
              "y": 52.93,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.593,
              "y": 53.046,
              "z": 0.647
            },
            "gtin": "8807246005071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f233",
            "leftCorner": {
              "x": -12.595,
              "y": 53.046,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.593,
              "y": 53.115,
              "z": 0.647
            },
            "gtin": "8807246005279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f234",
            "leftCorner": {
              "x": -12.593,
              "y": 53.115,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.591,
              "y": 53.182,
              "z": 0.647
            },
            "gtin": "8807246005279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f235",
            "leftCorner": {
              "x": -12.59,
              "y": 53.182,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.587,
              "y": 53.301,
              "z": 0.647
            },
            "gtin": "8807246005897",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f236",
            "leftCorner": {
              "x": -12.587,
              "y": 53.301,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.583,
              "y": 53.42,
              "z": 0.647
            },
            "gtin": "8807246005897",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f237",
            "leftCorner": {
              "x": -12.577,
              "y": 53.419,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.574,
              "y": 53.518,
              "z": 0.647
            },
            "gtin": "4009049365756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f238",
            "leftCorner": {
              "x": -12.574,
              "y": 53.518,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.571,
              "y": 53.617,
              "z": 0.647
            },
            "gtin": "4009049365756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f224",
            "leftCorner": {
              "x": -12.57,
              "y": 53.617,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.565,
              "y": 53.81,
              "z": 0.647
            },
            "gtin": "4004617388007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f225",
            "leftCorner": {
              "x": -12.565,
              "y": 53.81,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.559,
              "y": 54.002,
              "z": 0.647
            },
            "gtin": "4004617388007",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464a0",
        "height": 1.0417,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f261",
            "leftCorner": {
              "x": -12.589,
              "y": 52.731,
              "z": 0.852
            },
            "rightCorner": {
              "x": -12.583,
              "y": 52.912,
              "z": 0.852
            },
            "gtin": "4009049303239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f262",
            "leftCorner": {
              "x": -12.58,
              "y": 52.912,
              "z": 0.852
            },
            "rightCorner": {
              "x": -12.577,
              "y": 53.01,
              "z": 0.852
            },
            "gtin": "4009049344621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f263",
            "leftCorner": {
              "x": -12.577,
              "y": 53.01,
              "z": 0.852
            },
            "rightCorner": {
              "x": -12.574,
              "y": 53.108,
              "z": 0.852
            },
            "gtin": "4009049344621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f25a",
            "leftCorner": {
              "x": -12.589,
              "y": 53.108,
              "z": 0.852
            },
            "rightCorner": {
              "x": -12.576,
              "y": 53.555,
              "z": 0.852
            },
            "gtin": "4009049303185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f25b",
            "leftCorner": {
              "x": -12.576,
              "y": 53.555,
              "z": 0.852
            },
            "rightCorner": {
              "x": -12.562,
              "y": 54.003,
              "z": 0.852
            },
            "gtin": "4009049303185",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464a1",
        "height": 1.4431,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f27f",
            "leftCorner": {
              "x": -12.553,
              "y": 52.751,
              "z": 1.181
            },
            "rightCorner": {
              "x": -12.547,
              "y": 52.943,
              "z": 1.181
            },
            "gtin": "4018833952997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f283",
            "leftCorner": {
              "x": -12.589,
              "y": 52.945,
              "z": 1.181
            },
            "rightCorner": {
              "x": -12.582,
              "y": 53.198,
              "z": 1.181
            },
            "gtin": "4009049363684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f284",
            "leftCorner": {
              "x": -12.584,
              "y": 53.198,
              "z": 1.181
            },
            "rightCorner": {
              "x": -12.578,
              "y": 53.385,
              "z": 1.181
            },
            "gtin": "4009049363660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f285",
            "leftCorner": {
              "x": -12.578,
              "y": 53.385,
              "z": 1.181
            },
            "rightCorner": {
              "x": -12.572,
              "y": 53.572,
              "z": 1.181
            },
            "gtin": "4009049363660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f286",
            "leftCorner": {
              "x": -12.568,
              "y": 53.572,
              "z": 1.181
            },
            "rightCorner": {
              "x": -12.565,
              "y": 53.674,
              "z": 1.181
            },
            "gtin": "4009049363653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f287",
            "leftCorner": {
              "x": -12.565,
              "y": 53.674,
              "z": 1.181
            },
            "rightCorner": {
              "x": -12.562,
              "y": 53.776,
              "z": 1.181
            },
            "gtin": "4009049363653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f280",
            "leftCorner": {
              "x": -12.564,
              "y": 53.776,
              "z": 1.181
            },
            "rightCorner": {
              "x": -12.561,
              "y": 53.851,
              "z": 1.181
            },
            "gtin": "4009049359717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f281",
            "leftCorner": {
              "x": -12.561,
              "y": 53.851,
              "z": 1.181
            },
            "rightCorner": {
              "x": -12.56,
              "y": 53.927,
              "z": 1.181
            },
            "gtin": "4009049359717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f282",
            "leftCorner": {
              "x": -12.56,
              "y": 53.927,
              "z": 1.181
            },
            "rightCorner": {
              "x": -12.557,
              "y": 54.002,
              "z": 1.181
            },
            "gtin": "4009049359717",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464a2",
        "height": 1.744,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f246",
            "leftCorner": {
              "x": -12.586,
              "y": 52.752,
              "z": 1.427
            },
            "rightCorner": {
              "x": -12.581,
              "y": 52.9,
              "z": 1.427
            },
            "gtin": "3253920116017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f247",
            "leftCorner": {
              "x": -12.581,
              "y": 52.9,
              "z": 1.427
            },
            "rightCorner": {
              "x": -12.577,
              "y": 53.049,
              "z": 1.427
            },
            "gtin": "3253920116017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f248",
            "leftCorner": {
              "x": -12.577,
              "y": 53.049,
              "z": 1.427
            },
            "rightCorner": {
              "x": -12.572,
              "y": 53.199,
              "z": 1.427
            },
            "gtin": "3253920116017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f249",
            "leftCorner": {
              "x": -12.57,
              "y": 53.199,
              "z": 1.427
            },
            "rightCorner": {
              "x": -12.568,
              "y": 53.276,
              "z": 1.427
            },
            "gtin": "3253920117014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f24a",
            "leftCorner": {
              "x": -12.568,
              "y": 53.276,
              "z": 1.427
            },
            "rightCorner": {
              "x": -12.566,
              "y": 53.352,
              "z": 1.427
            },
            "gtin": "3253920117014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f24b",
            "leftCorner": {
              "x": -12.572,
              "y": 53.353,
              "z": 1.427
            },
            "rightCorner": {
              "x": -12.57,
              "y": 53.408,
              "z": 1.427
            },
            "gtin": "3253920115010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f24c",
            "leftCorner": {
              "x": -12.57,
              "y": 53.408,
              "z": 1.427
            },
            "rightCorner": {
              "x": -12.568,
              "y": 53.462,
              "z": 1.427
            },
            "gtin": "3253920115010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f24d",
            "leftCorner": {
              "x": -12.568,
              "y": 53.462,
              "z": 1.427
            },
            "rightCorner": {
              "x": -12.567,
              "y": 53.516,
              "z": 1.427
            },
            "gtin": "3253920115010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f24e",
            "leftCorner": {
              "x": -12.57,
              "y": 53.516,
              "z": 1.427
            },
            "rightCorner": {
              "x": -12.565,
              "y": 53.692,
              "z": 1.427
            },
            "gtin": "8004360008043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f24f",
            "leftCorner": {
              "x": -12.565,
              "y": 53.692,
              "z": 1.427
            },
            "rightCorner": {
              "x": -12.56,
              "y": 53.869,
              "z": 1.427
            },
            "gtin": "8004360008043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f250",
            "leftCorner": {
              "x": -12.56,
              "y": 53.869,
              "z": 1.427
            },
            "rightCorner": {
              "x": -12.554,
              "y": 54.045,
              "z": 1.427
            },
            "gtin": "8004360008043",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "edee5",
    "rightNeighborShelfId": "d9f63"
  },
  {
    "id": "d9f63",
    "name": "d9f63",
    "x": -12.502,
    "y": 54.0,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69635,
      "w": 0.71771
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 53
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5464a6",
        "height": 0.1652,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f276",
            "leftCorner": {
              "x": -12.564,
              "y": 54.027,
              "z": 0.135
            },
            "rightCorner": {
              "x": -12.562,
              "y": 54.091,
              "z": 0.135
            },
            "gtin": "4018833954540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f277",
            "leftCorner": {
              "x": -12.562,
              "y": 54.091,
              "z": 0.135
            },
            "rightCorner": {
              "x": -12.56,
              "y": 54.153,
              "z": 0.135
            },
            "gtin": "4018833954540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f278",
            "leftCorner": {
              "x": -12.56,
              "y": 54.153,
              "z": 0.135
            },
            "rightCorner": {
              "x": -12.558,
              "y": 54.217,
              "z": 0.135
            },
            "gtin": "4018833954540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f279",
            "leftCorner": {
              "x": -12.558,
              "y": 54.217,
              "z": 0.135
            },
            "rightCorner": {
              "x": -12.556,
              "y": 54.281,
              "z": 0.135
            },
            "gtin": "4018833954540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f27a",
            "leftCorner": {
              "x": -12.556,
              "y": 54.281,
              "z": 0.135
            },
            "rightCorner": {
              "x": -12.555,
              "y": 54.344,
              "z": 0.135
            },
            "gtin": "4018833954540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f27b",
            "leftCorner": {
              "x": -12.546,
              "y": 54.344,
              "z": 0.135
            },
            "rightCorner": {
              "x": -12.542,
              "y": 54.465,
              "z": 0.135
            },
            "gtin": "4066627181634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f27c",
            "leftCorner": {
              "x": -12.566,
              "y": 54.467,
              "z": 0.135
            },
            "rightCorner": {
              "x": -12.561,
              "y": 54.627,
              "z": 0.135
            },
            "gtin": "4066627181665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f27d",
            "leftCorner": {
              "x": -12.561,
              "y": 54.627,
              "z": 0.135
            },
            "rightCorner": {
              "x": -12.556,
              "y": 54.788,
              "z": 0.135
            },
            "gtin": "4066627181665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f27e",
            "leftCorner": {
              "x": -12.556,
              "y": 54.788,
              "z": 0.135
            },
            "rightCorner": {
              "x": -12.551,
              "y": 54.947,
              "z": 0.135
            },
            "gtin": "4066627181665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f266",
            "leftCorner": {
              "x": -12.533,
              "y": 54.947,
              "z": 0.135
            },
            "rightCorner": {
              "x": -12.529,
              "y": 55.099,
              "z": 0.135
            },
            "gtin": "4066627181658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f267",
            "leftCorner": {
              "x": -12.529,
              "y": 55.099,
              "z": 0.135
            },
            "rightCorner": {
              "x": -12.525,
              "y": 55.251,
              "z": 0.135
            },
            "gtin": "4066627181658",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464a4",
        "height": 0.54071,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f288",
            "leftCorner": {
              "x": -12.514,
              "y": 54.0,
              "z": 0.442
            },
            "rightCorner": {
              "x": -12.502,
              "y": 54.417,
              "z": 0.442
            },
            "gtin": "9001794735063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f28a",
            "leftCorner": {
              "x": -12.549,
              "y": 54.419,
              "z": 0.442
            },
            "rightCorner": {
              "x": -12.544,
              "y": 54.55,
              "z": 0.442
            },
            "gtin": "8693357068575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f28b",
            "leftCorner": {
              "x": -12.545,
              "y": 54.55,
              "z": 0.442
            },
            "rightCorner": {
              "x": -12.543,
              "y": 54.653,
              "z": 0.442
            },
            "gtin": "8693357036765",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f28c",
            "leftCorner": {
              "x": -12.524,
              "y": 54.652,
              "z": 0.442
            },
            "rightCorner": {
              "x": -12.519,
              "y": 54.8,
              "z": 0.442
            },
            "gtin": "8693357034198",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f28d",
            "leftCorner": {
              "x": -12.518,
              "y": 54.8,
              "z": 0.442
            },
            "rightCorner": {
              "x": -12.516,
              "y": 54.875,
              "z": 0.442
            },
            "gtin": "8693357034150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f28e",
            "leftCorner": {
              "x": -12.516,
              "y": 54.875,
              "z": 0.442
            },
            "rightCorner": {
              "x": -12.514,
              "y": 54.95,
              "z": 0.442
            },
            "gtin": "8693357034150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f28f",
            "leftCorner": {
              "x": -12.52,
              "y": 54.95,
              "z": 0.442
            },
            "rightCorner": {
              "x": -12.518,
              "y": 55.045,
              "z": 0.442
            },
            "gtin": "8693357034167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f290",
            "leftCorner": {
              "x": -12.518,
              "y": 55.045,
              "z": 0.442
            },
            "rightCorner": {
              "x": -12.515,
              "y": 55.139,
              "z": 0.442
            },
            "gtin": "8693357034167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f289",
            "leftCorner": {
              "x": -12.51,
              "y": 55.139,
              "z": 0.442
            },
            "rightCorner": {
              "x": -12.507,
              "y": 55.25,
              "z": 0.442
            },
            "gtin": "8693357034174",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464a5",
        "height": 0.91988,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f291",
            "leftCorner": {
              "x": -12.529,
              "y": 54.0,
              "z": 0.753
            },
            "rightCorner": {
              "x": -12.526,
              "y": 54.116,
              "z": 0.753
            },
            "gtin": "4009275050396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f292",
            "leftCorner": {
              "x": -12.526,
              "y": 54.116,
              "z": 0.753
            },
            "rightCorner": {
              "x": -12.523,
              "y": 54.231,
              "z": 0.753
            },
            "gtin": "4009275050396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f293",
            "leftCorner": {
              "x": -12.523,
              "y": 54.231,
              "z": 0.753
            },
            "rightCorner": {
              "x": -12.518,
              "y": 54.346,
              "z": 0.753
            },
            "gtin": "4009275050396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f297",
            "leftCorner": {
              "x": -12.564,
              "y": 54.348,
              "z": 0.753
            },
            "rightCorner": {
              "x": -12.56,
              "y": 54.498,
              "z": 0.753
            },
            "gtin": "4044935032305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f298",
            "leftCorner": {
              "x": -12.563,
              "y": 54.498,
              "z": 0.753
            },
            "rightCorner": {
              "x": -12.56,
              "y": 54.615,
              "z": 0.753
            },
            "gtin": "4002942477939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f299",
            "leftCorner": {
              "x": -12.56,
              "y": 54.615,
              "z": 0.753
            },
            "rightCorner": {
              "x": -12.557,
              "y": 54.732,
              "z": 0.753
            },
            "gtin": "4002942477939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f294",
            "leftCorner": {
              "x": -12.542,
              "y": 54.731,
              "z": 0.753
            },
            "rightCorner": {
              "x": -12.536,
              "y": 54.904,
              "z": 0.753
            },
            "gtin": "4009275050006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f295",
            "leftCorner": {
              "x": -12.536,
              "y": 54.904,
              "z": 0.753
            },
            "rightCorner": {
              "x": -12.531,
              "y": 55.078,
              "z": 0.753
            },
            "gtin": "4009275050006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f296",
            "leftCorner": {
              "x": -12.531,
              "y": 55.078,
              "z": 0.753
            },
            "rightCorner": {
              "x": -12.526,
              "y": 55.251,
              "z": 0.753
            },
            "gtin": "4009275050006",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464a7",
        "height": 1.3978,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f29a",
            "leftCorner": {
              "x": -12.491,
              "y": 53.999,
              "z": 1.144
            },
            "rightCorner": {
              "x": -12.483,
              "y": 54.264,
              "z": 1.144
            },
            "gtin": "8004360054392",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f29e",
            "leftCorner": {
              "x": -12.519,
              "y": 54.265,
              "z": 1.144
            },
            "rightCorner": {
              "x": -12.516,
              "y": 54.361,
              "z": 1.144
            },
            "gtin": "8001023362900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f29f",
            "leftCorner": {
              "x": -12.516,
              "y": 54.361,
              "z": 1.144
            },
            "rightCorner": {
              "x": -12.514,
              "y": 54.456,
              "z": 1.144
            },
            "gtin": "8001023362900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2a0",
            "leftCorner": {
              "x": -12.514,
              "y": 54.456,
              "z": 1.144
            },
            "rightCorner": {
              "x": -12.51,
              "y": 54.55,
              "z": 1.144
            },
            "gtin": "8001023362900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2a1",
            "leftCorner": {
              "x": -12.522,
              "y": 54.551,
              "z": 1.144
            },
            "rightCorner": {
              "x": -12.52,
              "y": 54.612,
              "z": 1.144
            },
            "gtin": "8004360061208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2a2",
            "leftCorner": {
              "x": -12.52,
              "y": 54.612,
              "z": 1.144
            },
            "rightCorner": {
              "x": -12.519,
              "y": 54.675,
              "z": 1.144
            },
            "gtin": "8004360061208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2a3",
            "leftCorner": {
              "x": -12.506,
              "y": 54.674,
              "z": 1.144
            },
            "rightCorner": {
              "x": -12.504,
              "y": 54.77,
              "z": 1.144
            },
            "gtin": "4011162744806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2a4",
            "leftCorner": {
              "x": -12.504,
              "y": 54.77,
              "z": 1.144
            },
            "rightCorner": {
              "x": -12.5,
              "y": 54.866,
              "z": 1.144
            },
            "gtin": "4011162744806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2a5",
            "leftCorner": {
              "x": -12.5,
              "y": 54.866,
              "z": 1.144
            },
            "rightCorner": {
              "x": -12.497,
              "y": 54.961,
              "z": 1.144
            },
            "gtin": "4011162744806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2a6",
            "leftCorner": {
              "x": -12.494,
              "y": 54.96,
              "z": 1.144
            },
            "rightCorner": {
              "x": -12.493,
              "y": 55.026,
              "z": 1.144
            },
            "gtin": "4011162762800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2a7",
            "leftCorner": {
              "x": -12.493,
              "y": 55.026,
              "z": 1.144
            },
            "rightCorner": {
              "x": -12.49,
              "y": 55.091,
              "z": 1.144
            },
            "gtin": "4011162762800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f29b",
            "leftCorner": {
              "x": -12.494,
              "y": 55.091,
              "z": 1.144
            },
            "rightCorner": {
              "x": -12.493,
              "y": 55.144,
              "z": 1.144
            },
            "gtin": "4037839387701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f29c",
            "leftCorner": {
              "x": -12.493,
              "y": 55.144,
              "z": 1.144
            },
            "rightCorner": {
              "x": -12.492,
              "y": 55.197,
              "z": 1.144
            },
            "gtin": "4037839387701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f29d",
            "leftCorner": {
              "x": -12.492,
              "y": 55.197,
              "z": 1.144
            },
            "rightCorner": {
              "x": -12.49,
              "y": 55.25,
              "z": 1.144
            },
            "gtin": "4037839387701",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464a3",
        "height": 1.7484,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f251",
            "leftCorner": {
              "x": -12.522,
              "y": 54.044,
              "z": 1.431
            },
            "rightCorner": {
              "x": -12.52,
              "y": 54.117,
              "z": 1.431
            },
            "gtin": "8004360008043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f252",
            "leftCorner": {
              "x": -12.52,
              "y": 54.117,
              "z": 1.431
            },
            "rightCorner": {
              "x": -12.518,
              "y": 54.189,
              "z": 1.431
            },
            "gtin": "8004360008043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f253",
            "leftCorner": {
              "x": -12.518,
              "y": 54.189,
              "z": 1.431
            },
            "rightCorner": {
              "x": -12.515,
              "y": 54.262,
              "z": 1.431
            },
            "gtin": "8004360008043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f254",
            "leftCorner": {
              "x": -12.517,
              "y": 54.262,
              "z": 1.431
            },
            "rightCorner": {
              "x": -12.514,
              "y": 54.399,
              "z": 1.431
            },
            "gtin": "8004360008005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f255",
            "leftCorner": {
              "x": -12.514,
              "y": 54.399,
              "z": 1.431
            },
            "rightCorner": {
              "x": -12.509,
              "y": 54.537,
              "z": 1.431
            },
            "gtin": "8004360008005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f256",
            "leftCorner": {
              "x": -12.509,
              "y": 54.537,
              "z": 1.431
            },
            "rightCorner": {
              "x": -12.505,
              "y": 54.674,
              "z": 1.431
            },
            "gtin": "8004360008005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f257",
            "leftCorner": {
              "x": -12.505,
              "y": 54.674,
              "z": 1.431
            },
            "rightCorner": {
              "x": -12.5,
              "y": 54.811,
              "z": 1.431
            },
            "gtin": "8004360008005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f23b",
            "leftCorner": {
              "x": -12.508,
              "y": 54.811,
              "z": 1.431
            },
            "rightCorner": {
              "x": -12.503,
              "y": 54.958,
              "z": 1.431
            },
            "gtin": "4037839387725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f23c",
            "leftCorner": {
              "x": -12.503,
              "y": 54.958,
              "z": 1.431
            },
            "rightCorner": {
              "x": -12.5,
              "y": 55.104,
              "z": 1.431
            },
            "gtin": "4037839387725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f23d",
            "leftCorner": {
              "x": -12.5,
              "y": 55.104,
              "z": 1.431
            },
            "rightCorner": {
              "x": -12.495,
              "y": 55.249,
              "z": 1.431
            },
            "gtin": "4037839387725",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d9f62",
    "rightNeighborShelfId": "d9f64"
  },
  {
    "id": "d9f64",
    "name": "d9f64",
    "x": -12.464,
    "y": 55.25,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69635,
      "w": 0.71771
    },

    "layers": [],
    "leftNeighborShelfId": "d9f63",
    "rightNeighborShelfId": "d9f65"
  },
  {
    "id": "d9f65",
    "name": "d9f65",
    "x": -12.413,
    "y": 56.611,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69307,
      "w": 0.72087
    },

    "layers": [],
    "leftNeighborShelfId": "d9f64"
  },
  {
    "id": "d9f66",
    "name": "d9f66",
    "x": -12.745,
    "y": 47.198,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69209,
      "w": 0.72181
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 7
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546491",
        "height": 0.16135,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e26d",
            "leftCorner": {
              "x": -12.763,
              "y": 47.199,
              "z": 0.132
            },
            "rightCorner": {
              "x": -12.732,
              "y": 47.937,
              "z": 0.132
            },
            "gtin": "4006501830463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e26f",
            "leftCorner": {
              "x": -12.785,
              "y": 47.939,
              "z": 0.132
            },
            "rightCorner": {
              "x": -12.758,
              "y": 48.566,
              "z": 0.132
            },
            "gtin": "4006501814135",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546490",
        "height": 0.56858,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f1f0",
            "leftCorner": {
              "x": -12.747,
              "y": 47.198,
              "z": 0.465
            },
            "rightCorner": {
              "x": -12.723,
              "y": 47.779,
              "z": 0.465
            },
            "gtin": "4023103218963",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1f2",
            "leftCorner": {
              "x": -12.781,
              "y": 47.781,
              "z": 0.465
            },
            "rightCorner": {
              "x": -12.777,
              "y": 47.879,
              "z": 0.465
            },
            "gtin": "9007741014052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1f3",
            "leftCorner": {
              "x": -12.777,
              "y": 47.879,
              "z": 0.465
            },
            "rightCorner": {
              "x": -12.773,
              "y": 47.975,
              "z": 0.465
            },
            "gtin": "9007741014052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1f4",
            "leftCorner": {
              "x": -12.773,
              "y": 47.975,
              "z": 0.465
            },
            "rightCorner": {
              "x": -12.768,
              "y": 48.073,
              "z": 0.465
            },
            "gtin": "9007741014052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1f1",
            "leftCorner": {
              "x": -12.752,
              "y": 48.072,
              "z": 0.465
            },
            "rightCorner": {
              "x": -12.736,
              "y": 48.449,
              "z": 0.465
            },
            "gtin": "9007741025218",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "edee1",
    "rightNeighborShelfId": "d9f69"
  },
  {
    "id": "d9f69",
    "name": "d9f69",
    "x": -12.693,
    "y": 48.447,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69209,
      "w": 0.72181
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 39
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546496",
        "height": 0.15662,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e270",
            "leftCorner": {
              "x": -12.749,
              "y": 48.565,
              "z": 0.128
            },
            "rightCorner": {
              "x": -12.741,
              "y": 48.748,
              "z": 0.128
            },
            "gtin": "4052396087352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e271",
            "leftCorner": {
              "x": -12.734,
              "y": 48.747,
              "z": 0.128
            },
            "rightCorner": {
              "x": -12.717,
              "y": 49.146,
              "z": 0.128
            },
            "gtin": "4052396082548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e272",
            "leftCorner": {
              "x": -12.711,
              "y": 49.146,
              "z": 0.128
            },
            "rightCorner": {
              "x": -12.7,
              "y": 49.405,
              "z": 0.128
            },
            "gtin": "4001515552011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e273",
            "leftCorner": {
              "x": -12.704,
              "y": 49.405,
              "z": 0.128
            },
            "rightCorner": {
              "x": -12.697,
              "y": 49.564,
              "z": 0.128
            },
            "gtin": "4001515551014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e274",
            "leftCorner": {
              "x": -12.7,
              "y": 49.564,
              "z": 0.128
            },
            "rightCorner": {
              "x": -12.688,
              "y": 49.842,
              "z": 0.128
            },
            "gtin": "4001515553018",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546493",
        "height": 0.63206,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e263",
            "leftCorner": {
              "x": -12.705,
              "y": 48.448,
              "z": 0.517
            },
            "rightCorner": {
              "x": -12.699,
              "y": 48.588,
              "z": 0.517
            },
            "gtin": "4052396084795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e265",
            "leftCorner": {
              "x": -12.74,
              "y": 48.59,
              "z": 0.517
            },
            "rightCorner": {
              "x": -12.735,
              "y": 48.707,
              "z": 0.517
            },
            "gtin": "4001515586016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e266",
            "leftCorner": {
              "x": -12.735,
              "y": 48.707,
              "z": 0.517
            },
            "rightCorner": {
              "x": -12.718,
              "y": 49.105,
              "z": 0.517
            },
            "gtin": "8009404272237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e267",
            "leftCorner": {
              "x": -12.714,
              "y": 49.105,
              "z": 0.517
            },
            "rightCorner": {
              "x": -12.698,
              "y": 49.474,
              "z": 0.517
            },
            "gtin": "4005437313873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e268",
            "leftCorner": {
              "x": -12.705,
              "y": 49.475,
              "z": 0.517
            },
            "rightCorner": {
              "x": -12.69,
              "y": 49.807,
              "z": 0.517
            },
            "gtin": "4005437313842",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546495",
        "height": 1.0053,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f1f5",
            "leftCorner": {
              "x": -12.731,
              "y": 48.448,
              "z": 0.823
            },
            "rightCorner": {
              "x": -12.717,
              "y": 48.765,
              "z": 0.823
            },
            "gtin": "4001515586016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1f8",
            "leftCorner": {
              "x": -12.758,
              "y": 48.767,
              "z": 0.823
            },
            "rightCorner": {
              "x": -12.751,
              "y": 48.937,
              "z": 0.823
            },
            "gtin": "4255651202563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1f9",
            "leftCorner": {
              "x": -12.748,
              "y": 48.937,
              "z": 0.823
            },
            "rightCorner": {
              "x": -12.741,
              "y": 49.109,
              "z": 0.823
            },
            "gtin": "4004617140001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1fa",
            "leftCorner": {
              "x": -12.736,
              "y": 49.109,
              "z": 0.823
            },
            "rightCorner": {
              "x": -12.733,
              "y": 49.196,
              "z": 0.823
            },
            "gtin": "8009404166796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1fb",
            "leftCorner": {
              "x": -12.733,
              "y": 49.196,
              "z": 0.823
            },
            "rightCorner": {
              "x": -12.729,
              "y": 49.282,
              "z": 0.823
            },
            "gtin": "8009404166796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1fc",
            "leftCorner": {
              "x": -12.729,
              "y": 49.282,
              "z": 0.823
            },
            "rightCorner": {
              "x": -12.725,
              "y": 49.368,
              "z": 0.823
            },
            "gtin": "8009404166796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1f6",
            "leftCorner": {
              "x": -12.734,
              "y": 49.369,
              "z": 0.823
            },
            "rightCorner": {
              "x": -12.727,
              "y": 49.534,
              "z": 0.823
            },
            "gtin": "4004617662954",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1f7",
            "leftCorner": {
              "x": -12.727,
              "y": 49.534,
              "z": 0.823
            },
            "rightCorner": {
              "x": -12.72,
              "y": 49.699,
              "z": 0.823
            },
            "gtin": "4004617662954",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546492",
        "height": 1.4374,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e24d",
            "leftCorner": {
              "x": -12.696,
              "y": 48.447,
              "z": 1.176
            },
            "rightCorner": {
              "x": -12.69,
              "y": 48.589,
              "z": 1.176
            },
            "gtin": "5412657175577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e24e",
            "leftCorner": {
              "x": -12.69,
              "y": 48.589,
              "z": 1.176
            },
            "rightCorner": {
              "x": -12.685,
              "y": 48.73,
              "z": 1.176
            },
            "gtin": "5412657175577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e250",
            "leftCorner": {
              "x": -12.716,
              "y": 48.732,
              "z": 1.176
            },
            "rightCorner": {
              "x": -12.713,
              "y": 48.816,
              "z": 1.176
            },
            "gtin": "4021523168394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e251",
            "leftCorner": {
              "x": -12.719,
              "y": 48.816,
              "z": 1.176
            },
            "rightCorner": {
              "x": -12.715,
              "y": 48.921,
              "z": 1.176
            },
            "gtin": "4021523168387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e252",
            "leftCorner": {
              "x": -12.715,
              "y": 48.921,
              "z": 1.176
            },
            "rightCorner": {
              "x": -12.71,
              "y": 49.027,
              "z": 1.176
            },
            "gtin": "4021523168387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e253",
            "leftCorner": {
              "x": -12.716,
              "y": 49.027,
              "z": 1.176
            },
            "rightCorner": {
              "x": -12.71,
              "y": 49.17,
              "z": 1.176
            },
            "gtin": "8717266342349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e254",
            "leftCorner": {
              "x": -12.707,
              "y": 49.17,
              "z": 1.176
            },
            "rightCorner": {
              "x": -12.701,
              "y": 49.295,
              "z": 1.176
            },
            "gtin": "4335896674117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e255",
            "leftCorner": {
              "x": -12.701,
              "y": 49.295,
              "z": 1.176
            },
            "rightCorner": {
              "x": -12.696,
              "y": 49.419,
              "z": 1.176
            },
            "gtin": "4335896674117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e256",
            "leftCorner": {
              "x": -12.696,
              "y": 49.419,
              "z": 1.176
            },
            "rightCorner": {
              "x": -12.692,
              "y": 49.544,
              "z": 1.176
            },
            "gtin": "4335896674117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e257",
            "leftCorner": {
              "x": -12.688,
              "y": 49.544,
              "z": 1.176
            },
            "rightCorner": {
              "x": -12.68,
              "y": 49.735,
              "z": 1.176
            },
            "gtin": "4066628058928",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546494",
        "height": 1.7374,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e22b",
            "leftCorner": {
              "x": -12.695,
              "y": 48.447,
              "z": 1.422
            },
            "rightCorner": {
              "x": -12.689,
              "y": 48.592,
              "z": 1.422
            },
            "gtin": "4335896696584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e22c",
            "leftCorner": {
              "x": -12.689,
              "y": 48.592,
              "z": 1.422
            },
            "rightCorner": {
              "x": -12.683,
              "y": 48.737,
              "z": 1.422
            },
            "gtin": "4335896696584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e230",
            "leftCorner": {
              "x": -12.712,
              "y": 48.739,
              "z": 1.422
            },
            "rightCorner": {
              "x": -12.707,
              "y": 48.847,
              "z": 1.422
            },
            "gtin": "4335896696614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e231",
            "leftCorner": {
              "x": -12.707,
              "y": 48.847,
              "z": 1.422
            },
            "rightCorner": {
              "x": -12.703,
              "y": 48.956,
              "z": 1.422
            },
            "gtin": "4335896696614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e232",
            "leftCorner": {
              "x": -12.715,
              "y": 48.957,
              "z": 1.422
            },
            "rightCorner": {
              "x": -12.707,
              "y": 49.154,
              "z": 1.422
            },
            "gtin": "4021523168356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e233",
            "leftCorner": {
              "x": -12.696,
              "y": 49.154,
              "z": 1.422
            },
            "rightCorner": {
              "x": -12.692,
              "y": 49.251,
              "z": 1.422
            },
            "gtin": "4000603215005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e234",
            "leftCorner": {
              "x": -12.692,
              "y": 49.251,
              "z": 1.422
            },
            "rightCorner": {
              "x": -12.688,
              "y": 49.348,
              "z": 1.422
            },
            "gtin": "4000603215005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e235",
            "leftCorner": {
              "x": -12.705,
              "y": 49.349,
              "z": 1.422
            },
            "rightCorner": {
              "x": -12.7,
              "y": 49.441,
              "z": 1.422
            },
            "gtin": "8593419204364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e236",
            "leftCorner": {
              "x": -12.7,
              "y": 49.441,
              "z": 1.422
            },
            "rightCorner": {
              "x": -12.697,
              "y": 49.535,
              "z": 1.422
            },
            "gtin": "8593419204364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e237",
            "leftCorner": {
              "x": -12.7,
              "y": 49.535,
              "z": 1.422
            },
            "rightCorner": {
              "x": -12.696,
              "y": 49.634,
              "z": 1.422
            },
            "gtin": "8593419204418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e238",
            "leftCorner": {
              "x": -12.696,
              "y": 49.634,
              "z": 1.422
            },
            "rightCorner": {
              "x": -12.692,
              "y": 49.734,
              "z": 1.422
            },
            "gtin": "8593419204418",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d9f66",
    "rightNeighborShelfId": "d9f6a"
  },
  {
    "id": "d9f6a",
    "name": "d9f6a",
    "x": -12.64,
    "y": 49.695,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69209,
      "w": 0.72181
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 44
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54630e",
        "height": 0.15909,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e275",
            "leftCorner": {
              "x": -12.697,
              "y": 49.842,
              "z": 0.13
            },
            "rightCorner": {
              "x": -12.686,
              "y": 50.111,
              "z": 0.13
            },
            "gtin": "4001515532013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e276",
            "leftCorner": {
              "x": -12.68,
              "y": 50.111,
              "z": 0.13
            },
            "rightCorner": {
              "x": -12.672,
              "y": 50.301,
              "z": 0.13
            },
            "gtin": "4018833952478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e277",
            "leftCorner": {
              "x": -12.66,
              "y": 50.3,
              "z": 0.13
            },
            "rightCorner": {
              "x": -12.648,
              "y": 50.602,
              "z": 0.13
            },
            "gtin": "4066635065315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e26e",
            "leftCorner": {
              "x": -12.667,
              "y": 50.603,
              "z": 0.13
            },
            "rightCorner": {
              "x": -12.653,
              "y": 50.947,
              "z": 0.13
            },
            "gtin": "7610859168481",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54630d",
        "height": 0.63846,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e269",
            "leftCorner": {
              "x": -12.677,
              "y": 49.806,
              "z": 0.522
            },
            "rightCorner": {
              "x": -12.666,
              "y": 50.06,
              "z": 0.522
            },
            "gtin": "4004617154831",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e26a",
            "leftCorner": {
              "x": -12.656,
              "y": 50.059,
              "z": 0.522
            },
            "rightCorner": {
              "x": -12.648,
              "y": 50.244,
              "z": 0.522
            },
            "gtin": "4009049346724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e26b",
            "leftCorner": {
              "x": -12.648,
              "y": 50.244,
              "z": 0.522
            },
            "rightCorner": {
              "x": -12.641,
              "y": 50.427,
              "z": 0.522
            },
            "gtin": "4009049346724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e26c",
            "leftCorner": {
              "x": -12.632,
              "y": 50.426,
              "z": 0.522
            },
            "rightCorner": {
              "x": -12.622,
              "y": 50.65,
              "z": 0.522
            },
            "gtin": "4018833000322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e264",
            "leftCorner": {
              "x": -12.642,
              "y": 50.651,
              "z": 0.522
            },
            "rightCorner": {
              "x": -12.63,
              "y": 50.945,
              "z": 0.522
            },
            "gtin": "4018833003880",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54630b",
        "height": 1.0345,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e241",
            "leftCorner": {
              "x": -12.655,
              "y": 49.696,
              "z": 0.846
            },
            "rightCorner": {
              "x": -12.647,
              "y": 49.889,
              "z": 0.846
            },
            "gtin": "4018833953833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e244",
            "leftCorner": {
              "x": -12.69,
              "y": 49.891,
              "z": 0.846
            },
            "rightCorner": {
              "x": -12.679,
              "y": 50.171,
              "z": 0.846
            },
            "gtin": "7610859252845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e245",
            "leftCorner": {
              "x": -12.673,
              "y": 50.17,
              "z": 0.846
            },
            "rightCorner": {
              "x": -12.669,
              "y": 50.231,
              "z": 0.846
            },
            "gtin": "7610859153913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e246",
            "leftCorner": {
              "x": -12.669,
              "y": 50.231,
              "z": 0.846
            },
            "rightCorner": {
              "x": -12.667,
              "y": 50.292,
              "z": 0.846
            },
            "gtin": "7610859153913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e247",
            "leftCorner": {
              "x": -12.667,
              "y": 50.292,
              "z": 0.846
            },
            "rightCorner": {
              "x": -12.664,
              "y": 50.352,
              "z": 0.846
            },
            "gtin": "7610859153913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e248",
            "leftCorner": {
              "x": -12.664,
              "y": 50.352,
              "z": 0.846
            },
            "rightCorner": {
              "x": -12.662,
              "y": 50.413,
              "z": 0.846
            },
            "gtin": "7610859153913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e249",
            "leftCorner": {
              "x": -12.666,
              "y": 50.413,
              "z": 0.846
            },
            "rightCorner": {
              "x": -12.662,
              "y": 50.517,
              "z": 0.846
            },
            "gtin": "7610859153906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e24a",
            "leftCorner": {
              "x": -12.662,
              "y": 50.517,
              "z": 0.846
            },
            "rightCorner": {
              "x": -12.657,
              "y": 50.621,
              "z": 0.846
            },
            "gtin": "7610859153906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e24b",
            "leftCorner": {
              "x": -12.658,
              "y": 50.621,
              "z": 0.846
            },
            "rightCorner": {
              "x": -12.653,
              "y": 50.729,
              "z": 0.846
            },
            "gtin": "7610859153920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e24c",
            "leftCorner": {
              "x": -12.653,
              "y": 50.729,
              "z": 0.846
            },
            "rightCorner": {
              "x": -12.648,
              "y": 50.838,
              "z": 0.846
            },
            "gtin": "7610859153920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e242",
            "leftCorner": {
              "x": -12.641,
              "y": 50.837,
              "z": 0.846
            },
            "rightCorner": {
              "x": -12.64,
              "y": 50.892,
              "z": 0.846
            },
            "gtin": "7610859153937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e243",
            "leftCorner": {
              "x": -12.64,
              "y": 50.892,
              "z": 0.846
            },
            "rightCorner": {
              "x": -12.637,
              "y": 50.946,
              "z": 0.846
            },
            "gtin": "7610859153937",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54630c",
        "height": 1.4405,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e258",
            "leftCorner": {
              "x": -12.679,
              "y": 49.735,
              "z": 1.179
            },
            "rightCorner": {
              "x": -12.674,
              "y": 49.842,
              "z": 1.179
            },
            "gtin": "4021523168400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e259",
            "leftCorner": {
              "x": -12.686,
              "y": 49.842,
              "z": 1.179
            },
            "rightCorner": {
              "x": -12.682,
              "y": 49.935,
              "z": 1.179
            },
            "gtin": "7610859153968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e25a",
            "leftCorner": {
              "x": -12.682,
              "y": 49.935,
              "z": 1.179
            },
            "rightCorner": {
              "x": -12.678,
              "y": 50.028,
              "z": 1.179
            },
            "gtin": "7610859153968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e25b",
            "leftCorner": {
              "x": -12.679,
              "y": 50.029,
              "z": 1.179
            },
            "rightCorner": {
              "x": -12.678,
              "y": 50.07,
              "z": 1.179
            },
            "gtin": "4004617154008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e25c",
            "leftCorner": {
              "x": -12.678,
              "y": 50.07,
              "z": 1.179
            },
            "rightCorner": {
              "x": -12.677,
              "y": 50.113,
              "z": 1.179
            },
            "gtin": "4004617154008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e25d",
            "leftCorner": {
              "x": -12.677,
              "y": 50.113,
              "z": 1.179
            },
            "rightCorner": {
              "x": -12.675,
              "y": 50.155,
              "z": 1.179
            },
            "gtin": "4004617154008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e25e",
            "leftCorner": {
              "x": -12.664,
              "y": 50.154,
              "z": 1.179
            },
            "rightCorner": {
              "x": -12.659,
              "y": 50.261,
              "z": 1.179
            },
            "gtin": "8807246007327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e25f",
            "leftCorner": {
              "x": -12.668,
              "y": 50.261,
              "z": 1.179
            },
            "rightCorner": {
              "x": -12.664,
              "y": 50.352,
              "z": 1.179
            },
            "gtin": "7610859257499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e260",
            "leftCorner": {
              "x": -12.652,
              "y": 50.352,
              "z": 1.179
            },
            "rightCorner": {
              "x": -12.647,
              "y": 50.464,
              "z": 1.179
            },
            "gtin": "7610859221339",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e261",
            "leftCorner": {
              "x": -12.646,
              "y": 50.464,
              "z": 1.179
            },
            "rightCorner": {
              "x": -12.642,
              "y": 50.557,
              "z": 1.179
            },
            "gtin": "4004617154749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e262",
            "leftCorner": {
              "x": -12.639,
              "y": 50.557,
              "z": 1.179
            },
            "rightCorner": {
              "x": -12.629,
              "y": 50.795,
              "z": 1.179
            },
            "gtin": "4005437329942",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e24f",
            "leftCorner": {
              "x": -12.642,
              "y": 50.796,
              "z": 1.179
            },
            "rightCorner": {
              "x": -12.636,
              "y": 50.946,
              "z": 1.179
            },
            "gtin": "4052396081282",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54630a",
        "height": 1.7372,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1e239",
            "leftCorner": {
              "x": -12.68,
              "y": 49.733,
              "z": 1.421
            },
            "rightCorner": {
              "x": -12.674,
              "y": 49.863,
              "z": 1.421
            },
            "gtin": "8593419204470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e23a",
            "leftCorner": {
              "x": -12.674,
              "y": 49.863,
              "z": 1.421
            },
            "rightCorner": {
              "x": -12.671,
              "y": 49.961,
              "z": 1.421
            },
            "gtin": "8593419204388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e23b",
            "leftCorner": {
              "x": -12.671,
              "y": 49.961,
              "z": 1.421
            },
            "rightCorner": {
              "x": -12.666,
              "y": 50.058,
              "z": 1.421
            },
            "gtin": "8593419204388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e23c",
            "leftCorner": {
              "x": -12.666,
              "y": 50.058,
              "z": 1.421
            },
            "rightCorner": {
              "x": -12.662,
              "y": 50.154,
              "z": 1.421
            },
            "gtin": "8593419204388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e23d",
            "leftCorner": {
              "x": -12.661,
              "y": 50.154,
              "z": 1.421
            },
            "rightCorner": {
              "x": -12.656,
              "y": 50.273,
              "z": 1.421
            },
            "gtin": "4018833952355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e23e",
            "leftCorner": {
              "x": -12.656,
              "y": 50.273,
              "z": 1.421
            },
            "rightCorner": {
              "x": -12.651,
              "y": 50.393,
              "z": 1.421
            },
            "gtin": "4018833952355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e23f",
            "leftCorner": {
              "x": -12.646,
              "y": 50.392,
              "z": 1.421
            },
            "rightCorner": {
              "x": -12.643,
              "y": 50.472,
              "z": 1.421
            },
            "gtin": "4018833952362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e240",
            "leftCorner": {
              "x": -12.643,
              "y": 50.472,
              "z": 1.421
            },
            "rightCorner": {
              "x": -12.639,
              "y": 50.55,
              "z": 1.421
            },
            "gtin": "4018833952362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e22d",
            "leftCorner": {
              "x": -12.645,
              "y": 50.551,
              "z": 1.421
            },
            "rightCorner": {
              "x": -12.64,
              "y": 50.682,
              "z": 1.421
            },
            "gtin": "4018833952379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e22e",
            "leftCorner": {
              "x": -12.64,
              "y": 50.682,
              "z": 1.421
            },
            "rightCorner": {
              "x": -12.634,
              "y": 50.814,
              "z": 1.421
            },
            "gtin": "4018833952379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1e22f",
            "leftCorner": {
              "x": -12.634,
              "y": 50.814,
              "z": 1.421
            },
            "rightCorner": {
              "x": -12.629,
              "y": 50.945,
              "z": 1.421
            },
            "gtin": "4018833952379",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d9f69",
    "rightNeighborShelfId": "edee5"
  },
  {
    "id": "d9f7c",
    "name": "d9f7c",
    "x": -10.222,
    "y": 40.985,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.020803,
      "w": 0.99978
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 101,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5464ad",
        "height": 0.1421,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f41c",
            "leftCorner": {
              "x": -10.221,
              "y": 41.001,
              "z": 0.116
            },
            "rightCorner": {
              "x": -10.149,
              "y": 40.998,
              "z": 0.116
            },
            "gtin": "4262367681629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f41d",
            "leftCorner": {
              "x": -10.149,
              "y": 40.998,
              "z": 0.116
            },
            "rightCorner": {
              "x": -10.078,
              "y": 40.995,
              "z": 0.116
            },
            "gtin": "4262367681629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f41f",
            "leftCorner": {
              "x": -10.075,
              "y": 41.038,
              "z": 0.116
            },
            "rightCorner": {
              "x": -9.984,
              "y": 41.034,
              "z": 0.116
            },
            "gtin": "4260249140103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f420",
            "leftCorner": {
              "x": -9.984,
              "y": 41.034,
              "z": 0.116
            },
            "rightCorner": {
              "x": -9.891,
              "y": 41.03,
              "z": 0.116
            },
            "gtin": "4260249140103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f421",
            "leftCorner": {
              "x": -9.891,
              "y": 41.034,
              "z": 0.116
            },
            "rightCorner": {
              "x": -9.802,
              "y": 41.029,
              "z": 0.116
            },
            "gtin": "4262367681360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f422",
            "leftCorner": {
              "x": -9.802,
              "y": 41.029,
              "z": 0.116
            },
            "rightCorner": {
              "x": -9.712,
              "y": 41.026,
              "z": 0.116
            },
            "gtin": "4262367681360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f423",
            "leftCorner": {
              "x": -9.712,
              "y": 41.026,
              "z": 0.116
            },
            "rightCorner": {
              "x": -9.624,
              "y": 41.022,
              "z": 0.116
            },
            "gtin": "4262367681360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f424",
            "leftCorner": {
              "x": -9.624,
              "y": 41.016,
              "z": 0.116
            },
            "rightCorner": {
              "x": -9.553,
              "y": 41.013,
              "z": 0.116
            },
            "gtin": "4262367681568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f425",
            "leftCorner": {
              "x": -9.553,
              "y": 41.012,
              "z": 0.116
            },
            "rightCorner": {
              "x": -9.493,
              "y": 41.01,
              "z": 0.116
            },
            "gtin": "4260249140035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f426",
            "leftCorner": {
              "x": -9.493,
              "y": 41.01,
              "z": 0.116
            },
            "rightCorner": {
              "x": -9.432,
              "y": 41.007,
              "z": 0.116
            },
            "gtin": "4260249140035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f427",
            "leftCorner": {
              "x": -9.432,
              "y": 41.01,
              "z": 0.116
            },
            "rightCorner": {
              "x": -9.336,
              "y": 41.006,
              "z": 0.116
            },
            "gtin": "4262367681865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f428",
            "leftCorner": {
              "x": -9.336,
              "y": 41.006,
              "z": 0.116
            },
            "rightCorner": {
              "x": -9.241,
              "y": 41.002,
              "z": 0.116
            },
            "gtin": "4262367681865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f429",
            "leftCorner": {
              "x": -9.241,
              "y": 40.973,
              "z": 0.116
            },
            "rightCorner": {
              "x": -9.09,
              "y": 40.967,
              "z": 0.116
            },
            "gtin": "4260618528600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f42a",
            "leftCorner": {
              "x": -9.089,
              "y": 40.992,
              "z": 0.116
            },
            "rightCorner": {
              "x": -8.972,
              "y": 40.988,
              "z": 0.116
            },
            "gtin": "4260249140172",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464ae",
        "height": 0.39241,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f47c",
            "leftCorner": {
              "x": -10.221,
              "y": 41.006,
              "z": 0.321
            },
            "rightCorner": {
              "x": -10.085,
              "y": 41.0,
              "z": 0.321
            },
            "gtin": "4260249140028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f47f",
            "leftCorner": {
              "x": -10.084,
              "y": 41.037,
              "z": 0.321
            },
            "rightCorner": {
              "x": -10.021,
              "y": 41.035,
              "z": 0.321
            },
            "gtin": "4262367681247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f480",
            "leftCorner": {
              "x": -10.021,
              "y": 41.035,
              "z": 0.321
            },
            "rightCorner": {
              "x": -9.96,
              "y": 41.032,
              "z": 0.321
            },
            "gtin": "4262367681247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f481",
            "leftCorner": {
              "x": -9.959,
              "y": 41.046,
              "z": 0.321
            },
            "rightCorner": {
              "x": -9.875,
              "y": 41.042,
              "z": 0.321
            },
            "gtin": "4260249142329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f482",
            "leftCorner": {
              "x": -9.875,
              "y": 41.042,
              "z": 0.321
            },
            "rightCorner": {
              "x": -9.79,
              "y": 41.038,
              "z": 0.321
            },
            "gtin": "4260249142329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f483",
            "leftCorner": {
              "x": -9.791,
              "y": 41.018,
              "z": 0.321
            },
            "rightCorner": {
              "x": -9.716,
              "y": 41.015,
              "z": 0.321
            },
            "gtin": "4260249147126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f484",
            "leftCorner": {
              "x": -9.716,
              "y": 41.015,
              "z": 0.321
            },
            "rightCorner": {
              "x": -9.641,
              "y": 41.012,
              "z": 0.321
            },
            "gtin": "4260249147126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f485",
            "leftCorner": {
              "x": -9.64,
              "y": 41.027,
              "z": 0.321
            },
            "rightCorner": {
              "x": -9.527,
              "y": 41.022,
              "z": 0.321
            },
            "gtin": "4262367681582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f486",
            "leftCorner": {
              "x": -9.527,
              "y": 41.01,
              "z": 0.321
            },
            "rightCorner": {
              "x": -9.405,
              "y": 41.005,
              "z": 0.321
            },
            "gtin": "4260249143647",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c875ed67a01d9a1f487",
            "leftCorner": {
              "x": -9.406,
              "y": 40.997,
              "z": 0.321
            },
            "rightCorner": {
              "x": -9.327,
              "y": 40.994,
              "z": 0.321
            },
            "gtin": "4262367681605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f488",
            "leftCorner": {
              "x": -9.327,
              "y": 40.994,
              "z": 0.321
            },
            "rightCorner": {
              "x": -9.248,
              "y": 40.99,
              "z": 0.321
            },
            "gtin": "4262367681605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f489",
            "leftCorner": {
              "x": -9.248,
              "y": 40.988,
              "z": 0.321
            },
            "rightCorner": {
              "x": -9.171,
              "y": 40.986,
              "z": 0.321
            },
            "gtin": "4260249142343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f48a",
            "leftCorner": {
              "x": -9.171,
              "y": 40.986,
              "z": 0.321
            },
            "rightCorner": {
              "x": -9.095,
              "y": 40.982,
              "z": 0.321
            },
            "gtin": "4260249142343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f48b",
            "leftCorner": {
              "x": -9.094,
              "y": 40.986,
              "z": 0.321
            },
            "rightCorner": {
              "x": -8.956,
              "y": 40.98,
              "z": 0.321
            },
            "gtin": "4262367681759",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464a9",
        "height": 0.69362,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f348",
            "leftCorner": {
              "x": -10.221,
              "y": 41.004,
              "z": 0.568
            },
            "rightCorner": {
              "x": -10.137,
              "y": 41.001,
              "z": 0.568
            },
            "gtin": "4260618520574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f349",
            "leftCorner": {
              "x": -10.137,
              "y": 41.001,
              "z": 0.568
            },
            "rightCorner": {
              "x": -10.053,
              "y": 40.997,
              "z": 0.568
            },
            "gtin": "4260618520574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f34e",
            "leftCorner": {
              "x": -10.052,
              "y": 41.036,
              "z": 0.568
            },
            "rightCorner": {
              "x": -9.981,
              "y": 41.033,
              "z": 0.568
            },
            "gtin": "4260249140288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f34f",
            "leftCorner": {
              "x": -9.981,
              "y": 41.037,
              "z": 0.568
            },
            "rightCorner": {
              "x": -9.912,
              "y": 41.035,
              "z": 0.568
            },
            "gtin": "4260618523094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f350",
            "leftCorner": {
              "x": -9.912,
              "y": 41.035,
              "z": 0.568
            },
            "rightCorner": {
              "x": -9.843,
              "y": 41.031,
              "z": 0.568
            },
            "gtin": "4260618523094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f351",
            "leftCorner": {
              "x": -9.843,
              "y": 41.028,
              "z": 0.568
            },
            "rightCorner": {
              "x": -9.745,
              "y": 41.024,
              "z": 0.568
            },
            "gtin": "4262367684972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f352",
            "leftCorner": {
              "x": -9.745,
              "y": 41.024,
              "z": 0.568
            },
            "rightCorner": {
              "x": -9.648,
              "y": 41.02,
              "z": 0.568
            },
            "gtin": "4262367684972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f353",
            "leftCorner": {
              "x": -9.648,
              "y": 41.016,
              "z": 0.568
            },
            "rightCorner": {
              "x": -9.467,
              "y": 41.008,
              "z": 0.568
            },
            "gtin": "4262367684873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f354",
            "leftCorner": {
              "x": -9.467,
              "y": 41.008,
              "z": 0.568
            },
            "rightCorner": {
              "x": -9.285,
              "y": 41.001,
              "z": 0.568
            },
            "gtin": "4262367684873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f355",
            "leftCorner": {
              "x": -9.285,
              "y": 40.995,
              "z": 0.568
            },
            "rightCorner": {
              "x": -9.12,
              "y": 40.988,
              "z": 0.568
            },
            "gtin": "4260249143333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f356",
            "leftCorner": {
              "x": -9.12,
              "y": 40.987,
              "z": 0.568
            },
            "rightCorner": {
              "x": -9.04,
              "y": 40.984,
              "z": 0.568
            },
            "gtin": "4260618526033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f357",
            "leftCorner": {
              "x": -9.04,
              "y": 40.984,
              "z": 0.568
            },
            "rightCorner": {
              "x": -8.959,
              "y": 40.98,
              "z": 0.568
            },
            "gtin": "4260618526033",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464aa",
        "height": 0.99258,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f389",
            "leftCorner": {
              "x": -10.221,
              "y": 41.003,
              "z": 0.812
            },
            "rightCorner": {
              "x": -10.053,
              "y": 40.997,
              "z": 0.812
            },
            "gtin": "9120111881976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f38d",
            "leftCorner": {
              "x": -10.052,
              "y": 41.04,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.996,
              "y": 41.038,
              "z": 0.812
            },
            "gtin": "9120111881822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f38e",
            "leftCorner": {
              "x": -9.996,
              "y": 41.038,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.94,
              "y": 41.035,
              "z": 0.812
            },
            "gtin": "9120111881822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f38f",
            "leftCorner": {
              "x": -9.94,
              "y": 41.031,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.869,
              "y": 41.028,
              "z": 0.812
            },
            "gtin": "9120111881433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f390",
            "leftCorner": {
              "x": -9.869,
              "y": 41.028,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.799,
              "y": 41.025,
              "z": 0.812
            },
            "gtin": "9120111881433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f391",
            "leftCorner": {
              "x": -9.798,
              "y": 41.029,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.594,
              "y": 41.021,
              "z": 0.812
            },
            "gtin": "9120111881396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f392",
            "leftCorner": {
              "x": -9.595,
              "y": 41.011,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.452,
              "y": 41.005,
              "z": 0.812
            },
            "gtin": "4260249143029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f393",
            "leftCorner": {
              "x": -9.452,
              "y": 41.005,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.311,
              "y": 40.999,
              "z": 0.812
            },
            "gtin": "4260249143029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f394",
            "leftCorner": {
              "x": -9.311,
              "y": 40.99,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.199,
              "y": 40.985,
              "z": 0.812
            },
            "gtin": "4262367682688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f395",
            "leftCorner": {
              "x": -9.199,
              "y": 40.985,
              "z": 0.812
            },
            "rightCorner": {
              "x": -9.073,
              "y": 40.98,
              "z": 0.812
            },
            "gtin": "4262367680196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f396",
            "leftCorner": {
              "x": -9.072,
              "y": 40.988,
              "z": 0.812
            },
            "rightCorner": {
              "x": -8.962,
              "y": 40.983,
              "z": 0.812
            },
            "gtin": "4260618524213",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464ab",
        "height": 1.1935,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f3c5",
            "leftCorner": {
              "x": -10.221,
              "y": 40.998,
              "z": 0.976
            },
            "rightCorner": {
              "x": -10.16,
              "y": 40.995,
              "z": 0.976
            },
            "gtin": "4063367440588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3c6",
            "leftCorner": {
              "x": -10.16,
              "y": 40.995,
              "z": 0.976
            },
            "rightCorner": {
              "x": -10.099,
              "y": 40.993,
              "z": 0.976
            },
            "gtin": "4063367440588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3c7",
            "leftCorner": {
              "x": -10.099,
              "y": 40.993,
              "z": 0.976
            },
            "rightCorner": {
              "x": -10.038,
              "y": 40.99,
              "z": 0.976
            },
            "gtin": "4063367440588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3ca",
            "leftCorner": {
              "x": -10.036,
              "y": 41.037,
              "z": 0.976
            },
            "rightCorner": {
              "x": -9.988,
              "y": 41.035,
              "z": 0.976
            },
            "gtin": "4063367440229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3cb",
            "leftCorner": {
              "x": -9.988,
              "y": 41.035,
              "z": 0.976
            },
            "rightCorner": {
              "x": -9.941,
              "y": 41.033,
              "z": 0.976
            },
            "gtin": "4063367440229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3cc",
            "leftCorner": {
              "x": -9.941,
              "y": 41.034,
              "z": 0.976
            },
            "rightCorner": {
              "x": -9.864,
              "y": 41.031,
              "z": 0.976
            },
            "gtin": "4063367440243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3cd",
            "leftCorner": {
              "x": -9.864,
              "y": 41.031,
              "z": 0.976
            },
            "rightCorner": {
              "x": -9.787,
              "y": 41.028,
              "z": 0.976
            },
            "gtin": "4063367440243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3ce",
            "leftCorner": {
              "x": -9.787,
              "y": 41.035,
              "z": 0.976
            },
            "rightCorner": {
              "x": -9.715,
              "y": 41.032,
              "z": 0.976
            },
            "gtin": "4063367440564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3cf",
            "leftCorner": {
              "x": -9.715,
              "y": 41.032,
              "z": 0.976
            },
            "rightCorner": {
              "x": -9.644,
              "y": 41.029,
              "z": 0.976
            },
            "gtin": "4063367440564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3d0",
            "leftCorner": {
              "x": -9.644,
              "y": 41.029,
              "z": 0.976
            },
            "rightCorner": {
              "x": -9.572,
              "y": 41.026,
              "z": 0.976
            },
            "gtin": "4063367440564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3d1",
            "leftCorner": {
              "x": -9.573,
              "y": 41.01,
              "z": 0.976
            },
            "rightCorner": {
              "x": -9.446,
              "y": 41.004,
              "z": 0.976
            },
            "gtin": "4063367440328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3d2",
            "leftCorner": {
              "x": -9.446,
              "y": 41.004,
              "z": 0.976
            },
            "rightCorner": {
              "x": -9.319,
              "y": 40.999,
              "z": 0.976
            },
            "gtin": "4063367440328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3d3",
            "leftCorner": {
              "x": -9.318,
              "y": 40.996,
              "z": 0.976
            },
            "rightCorner": {
              "x": -9.251,
              "y": 40.993,
              "z": 0.976
            },
            "gtin": "4063367440267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3d4",
            "leftCorner": {
              "x": -9.251,
              "y": 40.993,
              "z": 0.976
            },
            "rightCorner": {
              "x": -9.183,
              "y": 40.99,
              "z": 0.976
            },
            "gtin": "4063367440267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3d5",
            "leftCorner": {
              "x": -9.184,
              "y": 40.975,
              "z": 0.976
            },
            "rightCorner": {
              "x": -9.084,
              "y": 40.971,
              "z": 0.976
            },
            "gtin": "4063367440281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3c8",
            "leftCorner": {
              "x": -9.083,
              "y": 40.985,
              "z": 0.976
            },
            "rightCorner": {
              "x": -9.027,
              "y": 40.982,
              "z": 0.976
            },
            "gtin": "4063367440304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3c9",
            "leftCorner": {
              "x": -9.027,
              "y": 40.982,
              "z": 0.976
            },
            "rightCorner": {
              "x": -8.972,
              "y": 40.981,
              "z": 0.976
            },
            "gtin": "4063367440304",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464ac",
        "height": 1.497,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f3d6",
            "leftCorner": {
              "x": -10.222,
              "y": 40.992,
              "z": 1.225
            },
            "rightCorner": {
              "x": -10.145,
              "y": 40.988,
              "z": 1.225
            },
            "gtin": "4063367440526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3d7",
            "leftCorner": {
              "x": -10.145,
              "y": 40.988,
              "z": 1.225
            },
            "rightCorner": {
              "x": -10.069,
              "y": 40.985,
              "z": 1.225
            },
            "gtin": "4063367440526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3da",
            "leftCorner": {
              "x": -10.067,
              "y": 41.025,
              "z": 1.225
            },
            "rightCorner": {
              "x": -10.019,
              "y": 41.024,
              "z": 1.225
            },
            "gtin": "4063367440540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3db",
            "leftCorner": {
              "x": -10.019,
              "y": 41.024,
              "z": 1.225
            },
            "rightCorner": {
              "x": -9.971,
              "y": 41.022,
              "z": 1.225
            },
            "gtin": "4063367440540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3dc",
            "leftCorner": {
              "x": -9.97,
              "y": 41.034,
              "z": 1.225
            },
            "rightCorner": {
              "x": -9.82,
              "y": 41.029,
              "z": 1.225
            },
            "gtin": "4063367440168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3dd",
            "leftCorner": {
              "x": -9.82,
              "y": 41.017,
              "z": 1.225
            },
            "rightCorner": {
              "x": -9.733,
              "y": 41.014,
              "z": 1.225
            },
            "gtin": "4063367440144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3de",
            "leftCorner": {
              "x": -9.733,
              "y": 41.014,
              "z": 1.225
            },
            "rightCorner": {
              "x": -9.646,
              "y": 41.01,
              "z": 1.225
            },
            "gtin": "4063367440144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3df",
            "leftCorner": {
              "x": -9.646,
              "y": 41.015,
              "z": 1.225
            },
            "rightCorner": {
              "x": -9.577,
              "y": 41.013,
              "z": 1.225
            },
            "gtin": "4063367440564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3e0",
            "leftCorner": {
              "x": -9.577,
              "y": 41.013,
              "z": 1.225
            },
            "rightCorner": {
              "x": -9.509,
              "y": 41.01,
              "z": 1.225
            },
            "gtin": "4063367440564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3e1",
            "leftCorner": {
              "x": -9.51,
              "y": 41.004,
              "z": 1.225
            },
            "rightCorner": {
              "x": -9.433,
              "y": 41.002,
              "z": 1.225
            },
            "gtin": "4063367440120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3e2",
            "leftCorner": {
              "x": -9.433,
              "y": 41.002,
              "z": 1.225
            },
            "rightCorner": {
              "x": -9.356,
              "y": 40.998,
              "z": 1.225
            },
            "gtin": "4063367440120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3e3",
            "leftCorner": {
              "x": -9.356,
              "y": 40.994,
              "z": 1.225
            },
            "rightCorner": {
              "x": -9.266,
              "y": 40.99,
              "z": 1.225
            },
            "gtin": "4063367440182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3e4",
            "leftCorner": {
              "x": -9.266,
              "y": 40.99,
              "z": 1.225
            },
            "rightCorner": {
              "x": -9.177,
              "y": 40.986,
              "z": 1.225
            },
            "gtin": "4063367440182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3e5",
            "leftCorner": {
              "x": -9.177,
              "y": 40.986,
              "z": 1.225
            },
            "rightCorner": {
              "x": -9.086,
              "y": 40.982,
              "z": 1.225
            },
            "gtin": "4063367440182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3e6",
            "leftCorner": {
              "x": -9.086,
              "y": 40.979,
              "z": 1.225
            },
            "rightCorner": {
              "x": -9.046,
              "y": 40.977,
              "z": 1.225
            },
            "gtin": "4063367440205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3e7",
            "leftCorner": {
              "x": -9.046,
              "y": 40.977,
              "z": 1.225
            },
            "rightCorner": {
              "x": -9.004,
              "y": 40.976,
              "z": 1.225
            },
            "gtin": "4063367440205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3e8",
            "leftCorner": {
              "x": -9.004,
              "y": 40.976,
              "z": 1.225
            },
            "rightCorner": {
              "x": -8.964,
              "y": 40.974,
              "z": 1.225
            },
            "gtin": "4063367440205",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464a8",
        "height": 1.7422,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f2a8",
            "leftCorner": {
              "x": -10.221,
              "y": 40.998,
              "z": 1.425
            },
            "rightCorner": {
              "x": -10.139,
              "y": 40.995,
              "z": 1.425
            },
            "gtin": "4063367440380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2a9",
            "leftCorner": {
              "x": -10.139,
              "y": 40.995,
              "z": 1.425
            },
            "rightCorner": {
              "x": -10.057,
              "y": 40.992,
              "z": 1.425
            },
            "gtin": "4063367440380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2ac",
            "leftCorner": {
              "x": -10.055,
              "y": 41.036,
              "z": 1.425
            },
            "rightCorner": {
              "x": -10.001,
              "y": 41.033,
              "z": 1.425
            },
            "gtin": "4063367440403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2ad",
            "leftCorner": {
              "x": -10.001,
              "y": 41.033,
              "z": 1.425
            },
            "rightCorner": {
              "x": -9.946,
              "y": 41.031,
              "z": 1.425
            },
            "gtin": "4063367440403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2ae",
            "leftCorner": {
              "x": -9.946,
              "y": 41.035,
              "z": 1.425
            },
            "rightCorner": {
              "x": -9.899,
              "y": 41.033,
              "z": 1.425
            },
            "gtin": "4063367440366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2af",
            "leftCorner": {
              "x": -9.899,
              "y": 41.033,
              "z": 1.425
            },
            "rightCorner": {
              "x": -9.851,
              "y": 41.032,
              "z": 1.425
            },
            "gtin": "4063367440366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2b0",
            "leftCorner": {
              "x": -9.851,
              "y": 41.032,
              "z": 1.425
            },
            "rightCorner": {
              "x": -9.805,
              "y": 41.029,
              "z": 1.425
            },
            "gtin": "4063367440366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2b1",
            "leftCorner": {
              "x": -9.804,
              "y": 41.038,
              "z": 1.425
            },
            "rightCorner": {
              "x": -9.733,
              "y": 41.035,
              "z": 1.425
            },
            "gtin": "4063367440427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2b2",
            "leftCorner": {
              "x": -9.733,
              "y": 41.035,
              "z": 1.425
            },
            "rightCorner": {
              "x": -9.664,
              "y": 41.032,
              "z": 1.425
            },
            "gtin": "4063367440427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2b3",
            "leftCorner": {
              "x": -9.664,
              "y": 41.019,
              "z": 1.425
            },
            "rightCorner": {
              "x": -9.593,
              "y": 41.016,
              "z": 1.425
            },
            "gtin": "4063367440441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2b4",
            "leftCorner": {
              "x": -9.593,
              "y": 41.016,
              "z": 1.425
            },
            "rightCorner": {
              "x": -9.521,
              "y": 41.013,
              "z": 1.425
            },
            "gtin": "4063367440441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2b5",
            "leftCorner": {
              "x": -9.521,
              "y": 41.006,
              "z": 1.425
            },
            "rightCorner": {
              "x": -9.38,
              "y": 41.0,
              "z": 1.425
            },
            "gtin": "4063367440465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2b6",
            "leftCorner": {
              "x": -9.38,
              "y": 40.998,
              "z": 1.425
            },
            "rightCorner": {
              "x": -9.309,
              "y": 40.995,
              "z": 1.425
            },
            "gtin": "4063367440342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2b7",
            "leftCorner": {
              "x": -9.309,
              "y": 40.995,
              "z": 1.425
            },
            "rightCorner": {
              "x": -9.238,
              "y": 40.992,
              "z": 1.425
            },
            "gtin": "4063367440342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2b8",
            "leftCorner": {
              "x": -9.239,
              "y": 40.973,
              "z": 1.425
            },
            "rightCorner": {
              "x": -9.161,
              "y": 40.97,
              "z": 1.425
            },
            "gtin": "4063367440502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2b9",
            "leftCorner": {
              "x": -9.161,
              "y": 40.97,
              "z": 1.425
            },
            "rightCorner": {
              "x": -9.083,
              "y": 40.967,
              "z": 1.425
            },
            "gtin": "4063367440502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2ba",
            "leftCorner": {
              "x": -9.082,
              "y": 40.979,
              "z": 1.425
            },
            "rightCorner": {
              "x": -8.94,
              "y": 40.973,
              "z": 1.425
            },
            "gtin": "4063367440489",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "da3d8",
    "rightNeighborShelfId": "d9f7d"
  },
  {
    "id": "d9f7d",
    "name": "d9f7d",
    "x": -8.974,
    "y": 40.933,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.020803,
      "w": 0.99978
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 96,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5464b5",
        "height": 0.14465,
        "facings": []
      },
      {
        "id": "682ffdddd15af3232a5464b3",
        "height": 0.39647,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f48c",
            "leftCorner": {
              "x": -8.956,
              "y": 40.988,
              "z": 0.324
            },
            "rightCorner": {
              "x": -8.888,
              "y": 40.985,
              "z": 0.324
            },
            "gtin": "4251099845157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f48d",
            "leftCorner": {
              "x": -8.888,
              "y": 40.985,
              "z": 0.324
            },
            "rightCorner": {
              "x": -8.819,
              "y": 40.983,
              "z": 0.324
            },
            "gtin": "4251099845157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f48e",
            "leftCorner": {
              "x": -8.819,
              "y": 40.983,
              "z": 0.324
            },
            "rightCorner": {
              "x": -8.749,
              "y": 40.98,
              "z": 0.324
            },
            "gtin": "4251099845157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f48f",
            "leftCorner": {
              "x": -8.749,
              "y": 40.98,
              "z": 0.324
            },
            "rightCorner": {
              "x": -8.68,
              "y": 40.977,
              "z": 0.324
            },
            "gtin": "4251099845157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f490",
            "leftCorner": {
              "x": -8.68,
              "y": 40.987,
              "z": 0.324
            },
            "rightCorner": {
              "x": -8.548,
              "y": 40.982,
              "z": 0.324
            },
            "gtin": "4251099707417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f491",
            "leftCorner": {
              "x": -8.548,
              "y": 40.98,
              "z": 0.324
            },
            "rightCorner": {
              "x": -8.179,
              "y": 40.964,
              "z": 0.324
            },
            "gtin": "4251099707158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f492",
            "leftCorner": {
              "x": -8.18,
              "y": 40.962,
              "z": 0.324
            },
            "rightCorner": {
              "x": -7.997,
              "y": 40.954,
              "z": 0.324
            },
            "gtin": "4251099603900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f493",
            "leftCorner": {
              "x": -7.997,
              "y": 40.962,
              "z": 0.324
            },
            "rightCorner": {
              "x": -7.845,
              "y": 40.956,
              "z": 0.324
            },
            "gtin": "4251099707219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f494",
            "leftCorner": {
              "x": -7.845,
              "y": 40.956,
              "z": 0.324
            },
            "rightCorner": {
              "x": -7.693,
              "y": 40.949,
              "z": 0.324
            },
            "gtin": "4251099707219",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464af",
        "height": 0.69479,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f362",
            "leftCorner": {
              "x": -8.189,
              "y": 40.963,
              "z": 0.568
            },
            "rightCorner": {
              "x": -8.143,
              "y": 40.962,
              "z": 0.568
            },
            "gtin": "4251099708599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f358",
            "leftCorner": {
              "x": -8.96,
              "y": 40.984,
              "z": 0.568
            },
            "rightCorner": {
              "x": -8.906,
              "y": 40.982,
              "z": 0.568
            },
            "gtin": "4251099601081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f359",
            "leftCorner": {
              "x": -8.906,
              "y": 40.982,
              "z": 0.568
            },
            "rightCorner": {
              "x": -8.85,
              "y": 40.979,
              "z": 0.568
            },
            "gtin": "4251099601081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f35a",
            "leftCorner": {
              "x": -8.85,
              "y": 40.981,
              "z": 0.568
            },
            "rightCorner": {
              "x": -8.774,
              "y": 40.978,
              "z": 0.568
            },
            "gtin": "4251099603139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f35b",
            "leftCorner": {
              "x": -8.774,
              "y": 40.978,
              "z": 0.568
            },
            "rightCorner": {
              "x": -8.698,
              "y": 40.975,
              "z": 0.568
            },
            "gtin": "4251099603139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f35c",
            "leftCorner": {
              "x": -8.698,
              "y": 40.976,
              "z": 0.568
            },
            "rightCorner": {
              "x": -8.647,
              "y": 40.974,
              "z": 0.568
            },
            "gtin": "4251099707769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f35d",
            "leftCorner": {
              "x": -8.647,
              "y": 40.974,
              "z": 0.568
            },
            "rightCorner": {
              "x": -8.596,
              "y": 40.972,
              "z": 0.568
            },
            "gtin": "4251099707769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f35e",
            "leftCorner": {
              "x": -8.596,
              "y": 40.976,
              "z": 0.568
            },
            "rightCorner": {
              "x": -8.42,
              "y": 40.968,
              "z": 0.568
            },
            "gtin": "4251099609612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f35f",
            "leftCorner": {
              "x": -8.42,
              "y": 40.969,
              "z": 0.568
            },
            "rightCorner": {
              "x": -8.281,
              "y": 40.963,
              "z": 0.568
            },
            "gtin": "4251099609599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f360",
            "leftCorner": {
              "x": -8.28,
              "y": 40.967,
              "z": 0.568
            },
            "rightCorner": {
              "x": -8.235,
              "y": 40.965,
              "z": 0.568
            },
            "gtin": "4251099708599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f361",
            "leftCorner": {
              "x": -8.235,
              "y": 40.965,
              "z": 0.568
            },
            "rightCorner": {
              "x": -8.189,
              "y": 40.963,
              "z": 0.568
            },
            "gtin": "4251099708599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f363",
            "leftCorner": {
              "x": -8.143,
              "y": 40.972,
              "z": 0.568
            },
            "rightCorner": {
              "x": -8.062,
              "y": 40.968,
              "z": 0.568
            },
            "gtin": "4251099708582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f364",
            "leftCorner": {
              "x": -8.062,
              "y": 40.968,
              "z": 0.568
            },
            "rightCorner": {
              "x": -7.982,
              "y": 40.965,
              "z": 0.568
            },
            "gtin": "4251099708582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f365",
            "leftCorner": {
              "x": -7.982,
              "y": 40.962,
              "z": 0.568
            },
            "rightCorner": {
              "x": -7.885,
              "y": 40.958,
              "z": 0.568
            },
            "gtin": "4251099705833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f366",
            "leftCorner": {
              "x": -7.885,
              "y": 40.958,
              "z": 0.568
            },
            "rightCorner": {
              "x": -7.787,
              "y": 40.953,
              "z": 0.568
            },
            "gtin": "4251099705833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f367",
            "leftCorner": {
              "x": -7.787,
              "y": 40.953,
              "z": 0.568
            },
            "rightCorner": {
              "x": -7.69,
              "y": 40.949,
              "z": 0.568
            },
            "gtin": "4251099705833",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464b0",
        "height": 0.99405,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f397",
            "leftCorner": {
              "x": -8.963,
              "y": 40.983,
              "z": 0.813
            },
            "rightCorner": {
              "x": -8.865,
              "y": 40.98,
              "z": 0.813
            },
            "gtin": "4251099706076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f398",
            "leftCorner": {
              "x": -8.865,
              "y": 40.98,
              "z": 0.813
            },
            "rightCorner": {
              "x": -8.767,
              "y": 40.976,
              "z": 0.813
            },
            "gtin": "4251099706076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f399",
            "leftCorner": {
              "x": -8.768,
              "y": 40.966,
              "z": 0.813
            },
            "rightCorner": {
              "x": -8.619,
              "y": 40.96,
              "z": 0.813
            },
            "gtin": "4251099706090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f39a",
            "leftCorner": {
              "x": -8.618,
              "y": 40.972,
              "z": 0.813
            },
            "rightCorner": {
              "x": -8.521,
              "y": 40.968,
              "z": 0.813
            },
            "gtin": "4251099706120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f39b",
            "leftCorner": {
              "x": -8.521,
              "y": 40.968,
              "z": 0.813
            },
            "rightCorner": {
              "x": -8.425,
              "y": 40.964,
              "z": 0.813
            },
            "gtin": "4251099706120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f39c",
            "leftCorner": {
              "x": -8.425,
              "y": 40.964,
              "z": 0.813
            },
            "rightCorner": {
              "x": -8.327,
              "y": 40.96,
              "z": 0.813
            },
            "gtin": "4251099706120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f39d",
            "leftCorner": {
              "x": -8.327,
              "y": 40.968,
              "z": 0.813
            },
            "rightCorner": {
              "x": -8.189,
              "y": 40.962,
              "z": 0.813
            },
            "gtin": "4251099706045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f39e",
            "leftCorner": {
              "x": -8.189,
              "y": 40.962,
              "z": 0.813
            },
            "rightCorner": {
              "x": -8.051,
              "y": 40.957,
              "z": 0.813
            },
            "gtin": "4251099706045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f39f",
            "leftCorner": {
              "x": -8.051,
              "y": 40.964,
              "z": 0.813
            },
            "rightCorner": {
              "x": -7.993,
              "y": 40.962,
              "z": 0.813
            },
            "gtin": "4251099609537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3a0",
            "leftCorner": {
              "x": -7.993,
              "y": 40.962,
              "z": 0.813
            },
            "rightCorner": {
              "x": -7.933,
              "y": 40.959,
              "z": 0.813
            },
            "gtin": "4251099609537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3a1",
            "leftCorner": {
              "x": -7.933,
              "y": 40.959,
              "z": 0.813
            },
            "rightCorner": {
              "x": -7.875,
              "y": 40.957,
              "z": 0.813
            },
            "gtin": "4251099609537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3a2",
            "leftCorner": {
              "x": -7.875,
              "y": 40.957,
              "z": 0.813
            },
            "rightCorner": {
              "x": -7.817,
              "y": 40.954,
              "z": 0.813
            },
            "gtin": "4251099609537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3a3",
            "leftCorner": {
              "x": -7.817,
              "y": 40.954,
              "z": 0.813
            },
            "rightCorner": {
              "x": -7.758,
              "y": 40.952,
              "z": 0.813
            },
            "gtin": "4251099609537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3a4",
            "leftCorner": {
              "x": -7.758,
              "y": 40.952,
              "z": 0.813
            },
            "rightCorner": {
              "x": -7.699,
              "y": 40.95,
              "z": 0.813
            },
            "gtin": "4251099609537",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464b4",
        "height": 1.2464,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f4b5",
            "leftCorner": {
              "x": -8.974,
              "y": 40.953,
              "z": 1.02
            },
            "rightCorner": {
              "x": -8.891,
              "y": 40.949,
              "z": 1.02
            },
            "gtin": "4251099706083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4b6",
            "leftCorner": {
              "x": -8.891,
              "y": 40.949,
              "z": 1.02
            },
            "rightCorner": {
              "x": -8.808,
              "y": 40.946,
              "z": 1.02
            },
            "gtin": "4251099706083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4b7",
            "leftCorner": {
              "x": -8.808,
              "y": 40.946,
              "z": 1.02
            },
            "rightCorner": {
              "x": -8.726,
              "y": 40.943,
              "z": 1.02
            },
            "gtin": "4251099706083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4b8",
            "leftCorner": {
              "x": -8.726,
              "y": 40.943,
              "z": 1.02
            },
            "rightCorner": {
              "x": -8.644,
              "y": 40.939,
              "z": 1.02
            },
            "gtin": "4251099706083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4bc",
            "leftCorner": {
              "x": -8.642,
              "y": 40.966,
              "z": 1.02
            },
            "rightCorner": {
              "x": -8.483,
              "y": 40.959,
              "z": 1.02
            },
            "gtin": "4251099706021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4bd",
            "leftCorner": {
              "x": -8.483,
              "y": 40.966,
              "z": 1.02
            },
            "rightCorner": {
              "x": -8.434,
              "y": 40.964,
              "z": 1.02
            },
            "gtin": "4251099706106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4be",
            "leftCorner": {
              "x": -8.434,
              "y": 40.964,
              "z": 1.02
            },
            "rightCorner": {
              "x": -8.385,
              "y": 40.962,
              "z": 1.02
            },
            "gtin": "4251099706106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4bf",
            "leftCorner": {
              "x": -8.385,
              "y": 40.962,
              "z": 1.02
            },
            "rightCorner": {
              "x": -8.336,
              "y": 40.96,
              "z": 1.02
            },
            "gtin": "4251099706106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4c0",
            "leftCorner": {
              "x": -8.335,
              "y": 40.973,
              "z": 1.02
            },
            "rightCorner": {
              "x": -8.28,
              "y": 40.97,
              "z": 1.02
            },
            "gtin": "4251099707387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4c1",
            "leftCorner": {
              "x": -8.28,
              "y": 40.97,
              "z": 1.02
            },
            "rightCorner": {
              "x": -8.225,
              "y": 40.968,
              "z": 1.02
            },
            "gtin": "4251099707387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4c2",
            "leftCorner": {
              "x": -8.225,
              "y": 40.968,
              "z": 1.02
            },
            "rightCorner": {
              "x": -8.17,
              "y": 40.966,
              "z": 1.02
            },
            "gtin": "4251099707387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4c3",
            "leftCorner": {
              "x": -8.17,
              "y": 40.965,
              "z": 1.02
            },
            "rightCorner": {
              "x": -8.107,
              "y": 40.963,
              "z": 1.02
            },
            "gtin": "4251099707394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4c4",
            "leftCorner": {
              "x": -8.107,
              "y": 40.963,
              "z": 1.02
            },
            "rightCorner": {
              "x": -8.044,
              "y": 40.96,
              "z": 1.02
            },
            "gtin": "4251099707394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4c5",
            "leftCorner": {
              "x": -8.044,
              "y": 40.96,
              "z": 1.02
            },
            "rightCorner": {
              "x": -7.98,
              "y": 40.958,
              "z": 1.02
            },
            "gtin": "4251099707394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4c6",
            "leftCorner": {
              "x": -7.98,
              "y": 40.958,
              "z": 1.02
            },
            "rightCorner": {
              "x": -7.913,
              "y": 40.955,
              "z": 1.02
            },
            "gtin": "4251099707400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4c7",
            "leftCorner": {
              "x": -7.913,
              "y": 40.955,
              "z": 1.02
            },
            "rightCorner": {
              "x": -7.845,
              "y": 40.953,
              "z": 1.02
            },
            "gtin": "4251099707400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4c8",
            "leftCorner": {
              "x": -7.845,
              "y": 40.953,
              "z": 1.02
            },
            "rightCorner": {
              "x": -7.777,
              "y": 40.95,
              "z": 1.02
            },
            "gtin": "4251099707400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4c9",
            "leftCorner": {
              "x": -7.777,
              "y": 40.95,
              "z": 1.02
            },
            "rightCorner": {
              "x": -7.709,
              "y": 40.946,
              "z": 1.02
            },
            "gtin": "4251099707400",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464b2",
        "height": 1.496,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f3e9",
            "leftCorner": {
              "x": -8.964,
              "y": 40.975,
              "z": 1.224
            },
            "rightCorner": {
              "x": -8.905,
              "y": 40.972,
              "z": 1.224
            },
            "gtin": "4251099600497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3ea",
            "leftCorner": {
              "x": -8.905,
              "y": 40.972,
              "z": 1.224
            },
            "rightCorner": {
              "x": -8.846,
              "y": 40.97,
              "z": 1.224
            },
            "gtin": "4251099600497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3eb",
            "leftCorner": {
              "x": -8.845,
              "y": 40.979,
              "z": 1.224
            },
            "rightCorner": {
              "x": -8.707,
              "y": 40.974,
              "z": 1.224
            },
            "gtin": "4251099705888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3ec",
            "leftCorner": {
              "x": -8.707,
              "y": 40.974,
              "z": 1.224
            },
            "rightCorner": {
              "x": -8.579,
              "y": 40.968,
              "z": 1.224
            },
            "gtin": "4251099600473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3ed",
            "leftCorner": {
              "x": -8.578,
              "y": 40.973,
              "z": 1.224
            },
            "rightCorner": {
              "x": -8.521,
              "y": 40.969,
              "z": 1.224
            },
            "gtin": "4251099705987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3ee",
            "leftCorner": {
              "x": -8.521,
              "y": 40.969,
              "z": 1.224
            },
            "rightCorner": {
              "x": -8.465,
              "y": 40.967,
              "z": 1.224
            },
            "gtin": "4251099705987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3ef",
            "leftCorner": {
              "x": -8.465,
              "y": 40.972,
              "z": 1.224
            },
            "rightCorner": {
              "x": -8.42,
              "y": 40.97,
              "z": 1.224
            },
            "gtin": "4251099613350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3f0",
            "leftCorner": {
              "x": -8.42,
              "y": 40.97,
              "z": 1.224
            },
            "rightCorner": {
              "x": -8.375,
              "y": 40.968,
              "z": 1.224
            },
            "gtin": "4251099613350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3f1",
            "leftCorner": {
              "x": -8.375,
              "y": 40.968,
              "z": 1.224
            },
            "rightCorner": {
              "x": -8.332,
              "y": 40.966,
              "z": 1.224
            },
            "gtin": "4251099613350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3f2",
            "leftCorner": {
              "x": -8.331,
              "y": 40.969,
              "z": 1.224
            },
            "rightCorner": {
              "x": -8.277,
              "y": 40.967,
              "z": 1.224
            },
            "gtin": "4251099705895",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3f3",
            "leftCorner": {
              "x": -8.277,
              "y": 40.967,
              "z": 1.224
            },
            "rightCorner": {
              "x": -8.223,
              "y": 40.965,
              "z": 1.224
            },
            "gtin": "4251099705895",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3f4",
            "leftCorner": {
              "x": -8.224,
              "y": 40.955,
              "z": 1.224
            },
            "rightCorner": {
              "x": -8.155,
              "y": 40.952,
              "z": 1.224
            },
            "gtin": "4251099610410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3f5",
            "leftCorner": {
              "x": -8.155,
              "y": 40.952,
              "z": 1.224
            },
            "rightCorner": {
              "x": -8.086,
              "y": 40.95,
              "z": 1.224
            },
            "gtin": "4251099610410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3f6",
            "leftCorner": {
              "x": -8.086,
              "y": 40.957,
              "z": 1.224
            },
            "rightCorner": {
              "x": -8.017,
              "y": 40.954,
              "z": 1.224
            },
            "gtin": "4251099603177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3f7",
            "leftCorner": {
              "x": -8.017,
              "y": 40.954,
              "z": 1.224
            },
            "rightCorner": {
              "x": -7.947,
              "y": 40.951,
              "z": 1.224
            },
            "gtin": "4251099603177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3f8",
            "leftCorner": {
              "x": -7.948,
              "y": 40.941,
              "z": 1.224
            },
            "rightCorner": {
              "x": -7.877,
              "y": 40.938,
              "z": 1.224
            },
            "gtin": "4251099705956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3f9",
            "leftCorner": {
              "x": -7.877,
              "y": 40.938,
              "z": 1.224
            },
            "rightCorner": {
              "x": -7.805,
              "y": 40.935,
              "z": 1.224
            },
            "gtin": "4251099705956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3fa",
            "leftCorner": {
              "x": -7.806,
              "y": 40.918,
              "z": 1.224
            },
            "rightCorner": {
              "x": -7.679,
              "y": 40.914,
              "z": 1.224
            },
            "gtin": "4251099600817",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464b1",
        "height": 1.7436,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f2bb",
            "leftCorner": {
              "x": -8.941,
              "y": 40.977,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.894,
              "y": 40.976,
              "z": 1.427
            },
            "gtin": "4251099602309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2bc",
            "leftCorner": {
              "x": -8.894,
              "y": 40.976,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.848,
              "y": 40.973,
              "z": 1.427
            },
            "gtin": "4251099602309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2bd",
            "leftCorner": {
              "x": -8.848,
              "y": 40.973,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.802,
              "y": 40.972,
              "z": 1.427
            },
            "gtin": "4251099602309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2be",
            "leftCorner": {
              "x": -8.802,
              "y": 40.971,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.751,
              "y": 40.968,
              "z": 1.427
            },
            "gtin": "4251099603405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2bf",
            "leftCorner": {
              "x": -8.751,
              "y": 40.968,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.701,
              "y": 40.966,
              "z": 1.427
            },
            "gtin": "4251099603405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2c0",
            "leftCorner": {
              "x": -8.701,
              "y": 40.966,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.651,
              "y": 40.964,
              "z": 1.427
            },
            "gtin": "4251099603405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2c1",
            "leftCorner": {
              "x": -8.65,
              "y": 40.977,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.588,
              "y": 40.975,
              "z": 1.427
            },
            "gtin": "4251099705918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2c2",
            "leftCorner": {
              "x": -8.588,
              "y": 40.975,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.526,
              "y": 40.973,
              "z": 1.427
            },
            "gtin": "4251099705918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2c3",
            "leftCorner": {
              "x": -8.527,
              "y": 40.962,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.459,
              "y": 40.959,
              "z": 1.427
            },
            "gtin": "4251099705925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2c4",
            "leftCorner": {
              "x": -8.459,
              "y": 40.959,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.393,
              "y": 40.956,
              "z": 1.427
            },
            "gtin": "4251099705925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2c5",
            "leftCorner": {
              "x": -8.393,
              "y": 40.952,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.332,
              "y": 40.95,
              "z": 1.427
            },
            "gtin": "4251099705949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2c6",
            "leftCorner": {
              "x": -8.332,
              "y": 40.95,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.271,
              "y": 40.948,
              "z": 1.427
            },
            "gtin": "4251099705949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2c7",
            "leftCorner": {
              "x": -8.271,
              "y": 40.966,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.201,
              "y": 40.963,
              "z": 1.427
            },
            "gtin": "4251099705864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2c8",
            "leftCorner": {
              "x": -8.201,
              "y": 40.963,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.133,
              "y": 40.959,
              "z": 1.427
            },
            "gtin": "4251099705864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2c9",
            "leftCorner": {
              "x": -8.132,
              "y": 40.965,
              "z": 1.427
            },
            "rightCorner": {
              "x": -8.062,
              "y": 40.961,
              "z": 1.427
            },
            "gtin": "4251099705871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2ca",
            "leftCorner": {
              "x": -8.062,
              "y": 40.961,
              "z": 1.427
            },
            "rightCorner": {
              "x": -7.991,
              "y": 40.959,
              "z": 1.427
            },
            "gtin": "4251099705871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2cb",
            "leftCorner": {
              "x": -7.991,
              "y": 40.96,
              "z": 1.427
            },
            "rightCorner": {
              "x": -7.926,
              "y": 40.957,
              "z": 1.427
            },
            "gtin": "4251099705857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2cc",
            "leftCorner": {
              "x": -7.926,
              "y": 40.957,
              "z": 1.427
            },
            "rightCorner": {
              "x": -7.862,
              "y": 40.954,
              "z": 1.427
            },
            "gtin": "4251099705857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2cd",
            "leftCorner": {
              "x": -7.862,
              "y": 40.947,
              "z": 1.427
            },
            "rightCorner": {
              "x": -7.81,
              "y": 40.945,
              "z": 1.427
            },
            "gtin": "4251099705932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2ce",
            "leftCorner": {
              "x": -7.81,
              "y": 40.945,
              "z": 1.427
            },
            "rightCorner": {
              "x": -7.757,
              "y": 40.943,
              "z": 1.427
            },
            "gtin": "4251099705932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2cf",
            "leftCorner": {
              "x": -7.757,
              "y": 40.943,
              "z": 1.427
            },
            "rightCorner": {
              "x": -7.704,
              "y": 40.94,
              "z": 1.427
            },
            "gtin": "4251099705932",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d9f7c",
    "rightNeighborShelfId": "d9f7e"
  },
  {
    "id": "d9f7e",
    "name": "d9f7e",
    "x": -7.725,
    "y": 40.881,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.020803,
      "w": 0.99978
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 96,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5464bc",
        "height": 0.14707,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f42b",
            "leftCorner": {
              "x": -7.682,
              "y": 40.914,
              "z": 0.12
            },
            "rightCorner": {
              "x": -7.55,
              "y": 40.908,
              "z": 0.12
            },
            "gtin": "7640230490801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f42c",
            "leftCorner": {
              "x": -7.55,
              "y": 40.908,
              "z": 0.12
            },
            "rightCorner": {
              "x": -7.418,
              "y": 40.903,
              "z": 0.12
            },
            "gtin": "7640230490801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f42d",
            "leftCorner": {
              "x": -7.418,
              "y": 40.903,
              "z": 0.12
            },
            "rightCorner": {
              "x": -7.286,
              "y": 40.897,
              "z": 0.12
            },
            "gtin": "7640230490801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f42e",
            "leftCorner": {
              "x": -7.286,
              "y": 40.897,
              "z": 0.12
            },
            "rightCorner": {
              "x": -7.153,
              "y": 40.892,
              "z": 0.12
            },
            "gtin": "7640230490801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f42f",
            "leftCorner": {
              "x": -7.153,
              "y": 40.91,
              "z": 0.12
            },
            "rightCorner": {
              "x": -7.077,
              "y": 40.906,
              "z": 0.12
            },
            "gtin": "7640230490849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f430",
            "leftCorner": {
              "x": -7.077,
              "y": 40.906,
              "z": 0.12
            },
            "rightCorner": {
              "x": -7.0,
              "y": 40.904,
              "z": 0.12
            },
            "gtin": "7640230490849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f431",
            "leftCorner": {
              "x": -7.001,
              "y": 40.898,
              "z": 0.12
            },
            "rightCorner": {
              "x": -6.857,
              "y": 40.891,
              "z": 0.12
            },
            "gtin": "7640230490801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f432",
            "leftCorner": {
              "x": -6.857,
              "y": 40.891,
              "z": 0.12
            },
            "rightCorner": {
              "x": -6.712,
              "y": 40.886,
              "z": 0.12
            },
            "gtin": "7640230490801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f433",
            "leftCorner": {
              "x": -6.712,
              "y": 40.886,
              "z": 0.12
            },
            "rightCorner": {
              "x": -6.568,
              "y": 40.879,
              "z": 0.12
            },
            "gtin": "7640230490801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f434",
            "leftCorner": {
              "x": -6.568,
              "y": 40.879,
              "z": 0.12
            },
            "rightCorner": {
              "x": -6.424,
              "y": 40.874,
              "z": 0.12
            },
            "gtin": "7640230490801",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464b9",
        "height": 0.39656,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f495",
            "leftCorner": {
              "x": -7.694,
              "y": 40.924,
              "z": 0.324
            },
            "rightCorner": {
              "x": -7.643,
              "y": 40.922,
              "z": 0.324
            },
            "gtin": "7640104956211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f496",
            "leftCorner": {
              "x": -7.643,
              "y": 40.922,
              "z": 0.324
            },
            "rightCorner": {
              "x": -7.592,
              "y": 40.92,
              "z": 0.324
            },
            "gtin": "7640104956211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f497",
            "leftCorner": {
              "x": -7.592,
              "y": 40.92,
              "z": 0.324
            },
            "rightCorner": {
              "x": -7.541,
              "y": 40.918,
              "z": 0.324
            },
            "gtin": "7640104956211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f498",
            "leftCorner": {
              "x": -7.541,
              "y": 40.918,
              "z": 0.324
            },
            "rightCorner": {
              "x": -7.491,
              "y": 40.915,
              "z": 0.324
            },
            "gtin": "7640104956211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f499",
            "leftCorner": {
              "x": -7.491,
              "y": 40.915,
              "z": 0.324
            },
            "rightCorner": {
              "x": -7.44,
              "y": 40.913,
              "z": 0.324
            },
            "gtin": "7640104956211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f49a",
            "leftCorner": {
              "x": -7.44,
              "y": 40.915,
              "z": 0.324
            },
            "rightCorner": {
              "x": -7.214,
              "y": 40.906,
              "z": 0.324
            },
            "gtin": "7640104956235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f49b",
            "leftCorner": {
              "x": -7.214,
              "y": 40.906,
              "z": 0.324
            },
            "rightCorner": {
              "x": -6.988,
              "y": 40.896,
              "z": 0.324
            },
            "gtin": "7640104956235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f49c",
            "leftCorner": {
              "x": -6.989,
              "y": 40.889,
              "z": 0.324
            },
            "rightCorner": {
              "x": -6.832,
              "y": 40.882,
              "z": 0.324
            },
            "gtin": "7640104954835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f49d",
            "leftCorner": {
              "x": -6.832,
              "y": 40.882,
              "z": 0.324
            },
            "rightCorner": {
              "x": -6.676,
              "y": 40.875,
              "z": 0.324
            },
            "gtin": "7640104954835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f49e",
            "leftCorner": {
              "x": -6.675,
              "y": 40.884,
              "z": 0.324
            },
            "rightCorner": {
              "x": -6.595,
              "y": 40.88,
              "z": 0.324
            },
            "gtin": "7640230491785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f49f",
            "leftCorner": {
              "x": -6.595,
              "y": 40.88,
              "z": 0.324
            },
            "rightCorner": {
              "x": -6.515,
              "y": 40.877,
              "z": 0.324
            },
            "gtin": "7640230491785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4a0",
            "leftCorner": {
              "x": -6.515,
              "y": 40.877,
              "z": 0.324
            },
            "rightCorner": {
              "x": -6.435,
              "y": 40.874,
              "z": 0.324
            },
            "gtin": "7640230491785",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464bb",
        "height": 0.69602,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f368",
            "leftCorner": {
              "x": -7.69,
              "y": 40.93,
              "z": 0.569
            },
            "rightCorner": {
              "x": -7.566,
              "y": 40.924,
              "z": 0.569
            },
            "gtin": "7640230490948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f369",
            "leftCorner": {
              "x": -7.566,
              "y": 40.92,
              "z": 0.569
            },
            "rightCorner": {
              "x": -7.503,
              "y": 40.918,
              "z": 0.569
            },
            "gtin": "7640230491457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f36a",
            "leftCorner": {
              "x": -7.503,
              "y": 40.918,
              "z": 0.569
            },
            "rightCorner": {
              "x": -7.44,
              "y": 40.915,
              "z": 0.569
            },
            "gtin": "7640230491457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f36b",
            "leftCorner": {
              "x": -7.441,
              "y": 40.909,
              "z": 0.569
            },
            "rightCorner": {
              "x": -7.37,
              "y": 40.907,
              "z": 0.569
            },
            "gtin": "7640161876828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f36c",
            "leftCorner": {
              "x": -7.37,
              "y": 40.907,
              "z": 0.569
            },
            "rightCorner": {
              "x": -7.3,
              "y": 40.904,
              "z": 0.569
            },
            "gtin": "7640161876828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f36d",
            "leftCorner": {
              "x": -7.3,
              "y": 40.905,
              "z": 0.569
            },
            "rightCorner": {
              "x": -7.242,
              "y": 40.903,
              "z": 0.569
            },
            "gtin": "7640161876705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f36e",
            "leftCorner": {
              "x": -7.242,
              "y": 40.903,
              "z": 0.569
            },
            "rightCorner": {
              "x": -7.184,
              "y": 40.9,
              "z": 0.569
            },
            "gtin": "7640161876705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f36f",
            "leftCorner": {
              "x": -7.184,
              "y": 40.901,
              "z": 0.569
            },
            "rightCorner": {
              "x": -7.102,
              "y": 40.898,
              "z": 0.569
            },
            "gtin": "7640230490962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f370",
            "leftCorner": {
              "x": -7.102,
              "y": 40.898,
              "z": 0.569
            },
            "rightCorner": {
              "x": -7.021,
              "y": 40.895,
              "z": 0.569
            },
            "gtin": "7640230490962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f371",
            "leftCorner": {
              "x": -7.021,
              "y": 40.895,
              "z": 0.569
            },
            "rightCorner": {
              "x": -6.94,
              "y": 40.892,
              "z": 0.569
            },
            "gtin": "7640230490962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f372",
            "leftCorner": {
              "x": -6.94,
              "y": 40.892,
              "z": 0.569
            },
            "rightCorner": {
              "x": -6.859,
              "y": 40.888,
              "z": 0.569
            },
            "gtin": "7640230490962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f373",
            "leftCorner": {
              "x": -6.859,
              "y": 40.888,
              "z": 0.569
            },
            "rightCorner": {
              "x": -6.778,
              "y": 40.885,
              "z": 0.569
            },
            "gtin": "7640230490962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f374",
            "leftCorner": {
              "x": -6.778,
              "y": 40.885,
              "z": 0.569
            },
            "rightCorner": {
              "x": -6.697,
              "y": 40.882,
              "z": 0.569
            },
            "gtin": "7640230490962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f375",
            "leftCorner": {
              "x": -6.696,
              "y": 40.885,
              "z": 0.569
            },
            "rightCorner": {
              "x": -6.63,
              "y": 40.882,
              "z": 0.569
            },
            "gtin": "7640230491471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f376",
            "leftCorner": {
              "x": -6.63,
              "y": 40.882,
              "z": 0.569
            },
            "rightCorner": {
              "x": -6.563,
              "y": 40.88,
              "z": 0.569
            },
            "gtin": "7640230491471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f377",
            "leftCorner": {
              "x": -6.563,
              "y": 40.88,
              "z": 0.569
            },
            "rightCorner": {
              "x": -6.496,
              "y": 40.877,
              "z": 0.569
            },
            "gtin": "7640230491471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f378",
            "leftCorner": {
              "x": -6.496,
              "y": 40.877,
              "z": 0.569
            },
            "rightCorner": {
              "x": -6.43,
              "y": 40.874,
              "z": 0.569
            },
            "gtin": "7640230491471",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464b6",
        "height": 0.99633,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f3a5",
            "leftCorner": {
              "x": -7.7,
              "y": 40.927,
              "z": 0.815
            },
            "rightCorner": {
              "x": -7.633,
              "y": 40.925,
              "z": 0.815
            },
            "gtin": "7640104952695",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3a6",
            "leftCorner": {
              "x": -7.633,
              "y": 40.925,
              "z": 0.815
            },
            "rightCorner": {
              "x": -7.566,
              "y": 40.922,
              "z": 0.815
            },
            "gtin": "7640104952695",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3a7",
            "leftCorner": {
              "x": -7.566,
              "y": 40.907,
              "z": 0.815
            },
            "rightCorner": {
              "x": -7.427,
              "y": 40.901,
              "z": 0.815
            },
            "gtin": "7640104956273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3a8",
            "leftCorner": {
              "x": -7.426,
              "y": 40.914,
              "z": 0.815
            },
            "rightCorner": {
              "x": -7.351,
              "y": 40.911,
              "z": 0.815
            },
            "gtin": "7640230491006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3a9",
            "leftCorner": {
              "x": -7.351,
              "y": 40.911,
              "z": 0.815
            },
            "rightCorner": {
              "x": -7.277,
              "y": 40.908,
              "z": 0.815
            },
            "gtin": "7640230491006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3aa",
            "leftCorner": {
              "x": -7.277,
              "y": 40.908,
              "z": 0.815
            },
            "rightCorner": {
              "x": -7.202,
              "y": 40.905,
              "z": 0.815
            },
            "gtin": "7640230491006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3ab",
            "leftCorner": {
              "x": -7.202,
              "y": 40.905,
              "z": 0.815
            },
            "rightCorner": {
              "x": -7.127,
              "y": 40.901,
              "z": 0.815
            },
            "gtin": "7640230491006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3ac",
            "leftCorner": {
              "x": -7.129,
              "y": 40.865,
              "z": 0.815
            },
            "rightCorner": {
              "x": -7.076,
              "y": 40.863,
              "z": 0.815
            },
            "gtin": "7640161875715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3ad",
            "leftCorner": {
              "x": -7.076,
              "y": 40.863,
              "z": 0.815
            },
            "rightCorner": {
              "x": -7.023,
              "y": 40.861,
              "z": 0.815
            },
            "gtin": "7640161875715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3ae",
            "leftCorner": {
              "x": -7.023,
              "y": 40.861,
              "z": 0.815
            },
            "rightCorner": {
              "x": -6.971,
              "y": 40.859,
              "z": 0.815
            },
            "gtin": "7640161875715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3af",
            "leftCorner": {
              "x": -6.97,
              "y": 40.885,
              "z": 0.815
            },
            "rightCorner": {
              "x": -6.823,
              "y": 40.88,
              "z": 0.815
            },
            "gtin": "7640104954934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3b0",
            "leftCorner": {
              "x": -6.822,
              "y": 40.885,
              "z": 0.815
            },
            "rightCorner": {
              "x": -6.746,
              "y": 40.881,
              "z": 0.815
            },
            "gtin": "7640230490986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3b1",
            "leftCorner": {
              "x": -6.746,
              "y": 40.881,
              "z": 0.815
            },
            "rightCorner": {
              "x": -6.669,
              "y": 40.878,
              "z": 0.815
            },
            "gtin": "7640230490986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3b2",
            "leftCorner": {
              "x": -6.669,
              "y": 40.882,
              "z": 0.815
            },
            "rightCorner": {
              "x": -6.539,
              "y": 40.876,
              "z": 0.815
            },
            "gtin": "7640230492294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3b3",
            "leftCorner": {
              "x": -6.539,
              "y": 40.874,
              "z": 0.815
            },
            "rightCorner": {
              "x": -6.415,
              "y": 40.869,
              "z": 0.815
            },
            "gtin": "7640230491730",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464b7",
        "height": 1.2496,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f4ca",
            "leftCorner": {
              "x": -7.709,
              "y": 40.936,
              "z": 1.022
            },
            "rightCorner": {
              "x": -7.611,
              "y": 40.933,
              "z": 1.022
            },
            "gtin": "4260311984659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4cb",
            "leftCorner": {
              "x": -7.612,
              "y": 40.912,
              "z": 1.022
            },
            "rightCorner": {
              "x": -7.572,
              "y": 40.91,
              "z": 1.022
            },
            "gtin": "4260311984673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4cc",
            "leftCorner": {
              "x": -7.572,
              "y": 40.91,
              "z": 1.022
            },
            "rightCorner": {
              "x": -7.532,
              "y": 40.909,
              "z": 1.022
            },
            "gtin": "4260311984673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4cd",
            "leftCorner": {
              "x": -7.532,
              "y": 40.905,
              "z": 1.022
            },
            "rightCorner": {
              "x": -7.388,
              "y": 40.898,
              "z": 1.022
            },
            "gtin": "4260311984697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4ce",
            "leftCorner": {
              "x": -7.388,
              "y": 40.898,
              "z": 1.022
            },
            "rightCorner": {
              "x": -7.245,
              "y": 40.893,
              "z": 1.022
            },
            "gtin": "4260311984697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4cf",
            "leftCorner": {
              "x": -7.245,
              "y": 40.893,
              "z": 1.022
            },
            "rightCorner": {
              "x": -7.101,
              "y": 40.886,
              "z": 1.022
            },
            "gtin": "4260311984697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4d0",
            "leftCorner": {
              "x": -7.101,
              "y": 40.892,
              "z": 1.022
            },
            "rightCorner": {
              "x": -7.014,
              "y": 40.889,
              "z": 1.022
            },
            "gtin": "7640161877085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4d1",
            "leftCorner": {
              "x": -7.014,
              "y": 40.887,
              "z": 1.022
            },
            "rightCorner": {
              "x": -6.898,
              "y": 40.883,
              "z": 1.022
            },
            "gtin": "7640161877214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4d2",
            "leftCorner": {
              "x": -6.898,
              "y": 40.879,
              "z": 1.022
            },
            "rightCorner": {
              "x": -6.838,
              "y": 40.876,
              "z": 1.022
            },
            "gtin": "4260526594285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4d3",
            "leftCorner": {
              "x": -6.838,
              "y": 40.876,
              "z": 1.022
            },
            "rightCorner": {
              "x": -6.778,
              "y": 40.874,
              "z": 1.022
            },
            "gtin": "4260526594285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4d4",
            "leftCorner": {
              "x": -6.778,
              "y": 40.882,
              "z": 1.022
            },
            "rightCorner": {
              "x": -6.713,
              "y": 40.88,
              "z": 1.022
            },
            "gtin": "4260526594254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4d5",
            "leftCorner": {
              "x": -6.713,
              "y": 40.879,
              "z": 1.022
            },
            "rightCorner": {
              "x": -6.66,
              "y": 40.877,
              "z": 1.022
            },
            "gtin": "4260526593059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4d6",
            "leftCorner": {
              "x": -6.66,
              "y": 40.877,
              "z": 1.022
            },
            "rightCorner": {
              "x": -6.608,
              "y": 40.875,
              "z": 1.022
            },
            "gtin": "4260526593059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4d7",
            "leftCorner": {
              "x": -6.608,
              "y": 40.869,
              "z": 1.022
            },
            "rightCorner": {
              "x": -6.548,
              "y": 40.866,
              "z": 1.022
            },
            "gtin": "4260526594162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4d8",
            "leftCorner": {
              "x": -6.547,
              "y": 40.878,
              "z": 1.022
            },
            "rightCorner": {
              "x": -6.431,
              "y": 40.874,
              "z": 1.022
            },
            "gtin": "4260526593073",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464ba",
        "height": 1.4976,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f3fb",
            "leftCorner": {
              "x": -7.678,
              "y": 40.927,
              "z": 1.225
            },
            "rightCorner": {
              "x": -7.623,
              "y": 40.925,
              "z": 1.225
            },
            "gtin": "4260526594698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3fc",
            "leftCorner": {
              "x": -7.623,
              "y": 40.925,
              "z": 1.225
            },
            "rightCorner": {
              "x": -7.569,
              "y": 40.922,
              "z": 1.225
            },
            "gtin": "4260526594698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3fd",
            "leftCorner": {
              "x": -7.569,
              "y": 40.913,
              "z": 1.225
            },
            "rightCorner": {
              "x": -7.384,
              "y": 40.905,
              "z": 1.225
            },
            "gtin": "4260311984017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3fe",
            "leftCorner": {
              "x": -7.385,
              "y": 40.881,
              "z": 1.225
            },
            "rightCorner": {
              "x": -7.237,
              "y": 40.874,
              "z": 1.225
            },
            "gtin": "4260311980286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3ff",
            "leftCorner": {
              "x": -7.237,
              "y": 40.874,
              "z": 1.225
            },
            "rightCorner": {
              "x": -7.089,
              "y": 40.869,
              "z": 1.225
            },
            "gtin": "4260311980286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f400",
            "leftCorner": {
              "x": -7.089,
              "y": 40.869,
              "z": 1.225
            },
            "rightCorner": {
              "x": -6.94,
              "y": 40.862,
              "z": 1.225
            },
            "gtin": "4260311980286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f401",
            "leftCorner": {
              "x": -6.939,
              "y": 40.881,
              "z": 1.225
            },
            "rightCorner": {
              "x": -6.788,
              "y": 40.875,
              "z": 1.225
            },
            "gtin": "4260311980262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f402",
            "leftCorner": {
              "x": -6.789,
              "y": 40.858,
              "z": 1.225
            },
            "rightCorner": {
              "x": -6.709,
              "y": 40.855,
              "z": 1.225
            },
            "gtin": "4260311983584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f403",
            "leftCorner": {
              "x": -6.709,
              "y": 40.855,
              "z": 1.225
            },
            "rightCorner": {
              "x": -6.629,
              "y": 40.852,
              "z": 1.225
            },
            "gtin": "4260311983584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f404",
            "leftCorner": {
              "x": -6.628,
              "y": 40.877,
              "z": 1.225
            },
            "rightCorner": {
              "x": -6.548,
              "y": 40.873,
              "z": 1.225
            },
            "gtin": "4260526594193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f405",
            "leftCorner": {
              "x": -6.548,
              "y": 40.873,
              "z": 1.225
            },
            "rightCorner": {
              "x": -6.468,
              "y": 40.87,
              "z": 1.225
            },
            "gtin": "4260526594193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f406",
            "leftCorner": {
              "x": -6.468,
              "y": 40.87,
              "z": 1.225
            },
            "rightCorner": {
              "x": -6.389,
              "y": 40.867,
              "z": 1.225
            },
            "gtin": "4260526594193",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464b8",
        "height": 1.7472,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f2d0",
            "leftCorner": {
              "x": -7.705,
              "y": 40.91,
              "z": 1.43
            },
            "rightCorner": {
              "x": -7.565,
              "y": 40.905,
              "z": 1.43
            },
            "gtin": "4260311980026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2d1",
            "leftCorner": {
              "x": -7.565,
              "y": 40.906,
              "z": 1.43
            },
            "rightCorner": {
              "x": -7.476,
              "y": 40.903,
              "z": 1.43
            },
            "gtin": "4260311981412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2d2",
            "leftCorner": {
              "x": -7.476,
              "y": 40.903,
              "z": 1.43
            },
            "rightCorner": {
              "x": -7.387,
              "y": 40.898,
              "z": 1.43
            },
            "gtin": "4260311981412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2d3",
            "leftCorner": {
              "x": -7.387,
              "y": 40.907,
              "z": 1.43
            },
            "rightCorner": {
              "x": -7.294,
              "y": 40.903,
              "z": 1.43
            },
            "gtin": "4260311984536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2d4",
            "leftCorner": {
              "x": -7.294,
              "y": 40.903,
              "z": 1.43
            },
            "rightCorner": {
              "x": -7.201,
              "y": 40.899,
              "z": 1.43
            },
            "gtin": "4260311984536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2d5",
            "leftCorner": {
              "x": -7.201,
              "y": 40.899,
              "z": 1.43
            },
            "rightCorner": {
              "x": -7.109,
              "y": 40.896,
              "z": 1.43
            },
            "gtin": "4260311984536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2d6",
            "leftCorner": {
              "x": -7.109,
              "y": 40.886,
              "z": 1.43
            },
            "rightCorner": {
              "x": -7.018,
              "y": 40.881,
              "z": 1.43
            },
            "gtin": "4260526592564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2d7",
            "leftCorner": {
              "x": -7.018,
              "y": 40.881,
              "z": 1.43
            },
            "rightCorner": {
              "x": -6.928,
              "y": 40.878,
              "z": 1.43
            },
            "gtin": "4260526592564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2d8",
            "leftCorner": {
              "x": -6.928,
              "y": 40.878,
              "z": 1.43
            },
            "rightCorner": {
              "x": -6.837,
              "y": 40.874,
              "z": 1.43
            },
            "gtin": "4260526592564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2d9",
            "leftCorner": {
              "x": -6.837,
              "y": 40.874,
              "z": 1.43
            },
            "rightCorner": {
              "x": -6.747,
              "y": 40.87,
              "z": 1.43
            },
            "gtin": "4260526592564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2da",
            "leftCorner": {
              "x": -6.747,
              "y": 40.873,
              "z": 1.43
            },
            "rightCorner": {
              "x": -6.686,
              "y": 40.871,
              "z": 1.43
            },
            "gtin": "4260526594414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2db",
            "leftCorner": {
              "x": -6.686,
              "y": 40.871,
              "z": 1.43
            },
            "rightCorner": {
              "x": -6.626,
              "y": 40.868,
              "z": 1.43
            },
            "gtin": "4260526594414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2dc",
            "leftCorner": {
              "x": -6.626,
              "y": 40.868,
              "z": 1.43
            },
            "rightCorner": {
              "x": -6.565,
              "y": 40.866,
              "z": 1.43
            },
            "gtin": "4260526594414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2dd",
            "leftCorner": {
              "x": -6.564,
              "y": 40.886,
              "z": 1.43
            },
            "rightCorner": {
              "x": -6.516,
              "y": 40.884,
              "z": 1.43
            },
            "gtin": "4260526593608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2de",
            "leftCorner": {
              "x": -6.516,
              "y": 40.884,
              "z": 1.43
            },
            "rightCorner": {
              "x": -6.468,
              "y": 40.882,
              "z": 1.43
            },
            "gtin": "4260526593608",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d9f7d",
    "rightNeighborShelfId": "d9f7f"
  },
  {
    "id": "d9f7f",
    "name": "d9f7f",
    "x": -6.476,
    "y": 40.812,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.026273,
      "w": 0.99965
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 81,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5464c3",
        "height": 0.14646,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f435",
            "leftCorner": {
              "x": -6.424,
              "y": 40.856,
              "z": 0.12
            },
            "rightCorner": {
              "x": -6.322,
              "y": 40.851,
              "z": 0.12
            },
            "gtin": "4062300439665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f436",
            "leftCorner": {
              "x": -6.322,
              "y": 40.851,
              "z": 0.12
            },
            "rightCorner": {
              "x": -6.22,
              "y": 40.845,
              "z": 0.12
            },
            "gtin": "4062300439665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f437",
            "leftCorner": {
              "x": -6.22,
              "y": 40.845,
              "z": 0.12
            },
            "rightCorner": {
              "x": -6.118,
              "y": 40.84,
              "z": 0.12
            },
            "gtin": "4062300439665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f438",
            "leftCorner": {
              "x": -6.118,
              "y": 40.846,
              "z": 0.12
            },
            "rightCorner": {
              "x": -5.943,
              "y": 40.836,
              "z": 0.12
            },
            "gtin": "4062300463196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f439",
            "leftCorner": {
              "x": -5.943,
              "y": 40.836,
              "z": 0.12
            },
            "rightCorner": {
              "x": -5.769,
              "y": 40.828,
              "z": 0.12
            },
            "gtin": "4062300463196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f43a",
            "leftCorner": {
              "x": -5.769,
              "y": 40.828,
              "z": 0.12
            },
            "rightCorner": {
              "x": -5.594,
              "y": 40.818,
              "z": 0.12
            },
            "gtin": "4062300463196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f43b",
            "leftCorner": {
              "x": -5.593,
              "y": 40.841,
              "z": 0.12
            },
            "rightCorner": {
              "x": -5.48,
              "y": 40.835,
              "z": 0.12
            },
            "gtin": "4062300259829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f43c",
            "leftCorner": {
              "x": -5.48,
              "y": 40.835,
              "z": 0.12
            },
            "rightCorner": {
              "x": -5.366,
              "y": 40.829,
              "z": 0.12
            },
            "gtin": "4062300259829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f43d",
            "leftCorner": {
              "x": -5.366,
              "y": 40.829,
              "z": 0.12
            },
            "rightCorner": {
              "x": -5.252,
              "y": 40.823,
              "z": 0.12
            },
            "gtin": "4062300259829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f43e",
            "leftCorner": {
              "x": -5.252,
              "y": 40.823,
              "z": 0.12
            },
            "rightCorner": {
              "x": -5.139,
              "y": 40.817,
              "z": 0.12
            },
            "gtin": "4062300259829",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464bf",
        "height": 0.39372,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f4a1",
            "leftCorner": {
              "x": -6.434,
              "y": 40.867,
              "z": 0.322
            },
            "rightCorner": {
              "x": -6.369,
              "y": 40.864,
              "z": 0.322
            },
            "gtin": "4062300266117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4a2",
            "leftCorner": {
              "x": -6.369,
              "y": 40.864,
              "z": 0.322
            },
            "rightCorner": {
              "x": -6.304,
              "y": 40.86,
              "z": 0.322
            },
            "gtin": "4062300266117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4a3",
            "leftCorner": {
              "x": -6.304,
              "y": 40.86,
              "z": 0.322
            },
            "rightCorner": {
              "x": -6.239,
              "y": 40.857,
              "z": 0.322
            },
            "gtin": "4062300266117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4a4",
            "leftCorner": {
              "x": -6.239,
              "y": 40.842,
              "z": 0.322
            },
            "rightCorner": {
              "x": -6.04,
              "y": 40.831,
              "z": 0.322
            },
            "gtin": "4062300265967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4a5",
            "leftCorner": {
              "x": -6.04,
              "y": 40.831,
              "z": 0.322
            },
            "rightCorner": {
              "x": -5.84,
              "y": 40.821,
              "z": 0.322
            },
            "gtin": "4062300265967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4a6",
            "leftCorner": {
              "x": -5.839,
              "y": 40.838,
              "z": 0.322
            },
            "rightCorner": {
              "x": -5.5,
              "y": 40.82,
              "z": 0.322
            },
            "gtin": "4062300198838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4a7",
            "leftCorner": {
              "x": -5.5,
              "y": 40.82,
              "z": 0.322
            },
            "rightCorner": {
              "x": -5.161,
              "y": 40.802,
              "z": 0.322
            },
            "gtin": "4062300198838",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464c1",
        "height": 0.69281,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f379",
            "leftCorner": {
              "x": -6.429,
              "y": 40.855,
              "z": 0.567
            },
            "rightCorner": {
              "x": -6.365,
              "y": 40.851,
              "z": 0.567
            },
            "gtin": "4062300240995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f37a",
            "leftCorner": {
              "x": -6.365,
              "y": 40.851,
              "z": 0.567
            },
            "rightCorner": {
              "x": -6.301,
              "y": 40.847,
              "z": 0.567
            },
            "gtin": "4062300240995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f37b",
            "leftCorner": {
              "x": -6.301,
              "y": 40.85,
              "z": 0.567
            },
            "rightCorner": {
              "x": -6.242,
              "y": 40.847,
              "z": 0.567
            },
            "gtin": "4062300266148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f37c",
            "leftCorner": {
              "x": -6.242,
              "y": 40.847,
              "z": 0.567
            },
            "rightCorner": {
              "x": -6.183,
              "y": 40.844,
              "z": 0.567
            },
            "gtin": "4062300266148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f37d",
            "leftCorner": {
              "x": -6.183,
              "y": 40.835,
              "z": 0.567
            },
            "rightCorner": {
              "x": -5.872,
              "y": 40.819,
              "z": 0.567
            },
            "gtin": "4062300265998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f37e",
            "leftCorner": {
              "x": -5.872,
              "y": 40.819,
              "z": 0.567
            },
            "rightCorner": {
              "x": -5.561,
              "y": 40.802,
              "z": 0.567
            },
            "gtin": "4062300265998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f37f",
            "leftCorner": {
              "x": -5.561,
              "y": 40.802,
              "z": 0.567
            },
            "rightCorner": {
              "x": -5.25,
              "y": 40.787,
              "z": 0.567
            },
            "gtin": "4062300265998",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464c2",
        "height": 0.99932,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f3b4",
            "leftCorner": {
              "x": -6.414,
              "y": 40.853,
              "z": 0.818
            },
            "rightCorner": {
              "x": -6.259,
              "y": 40.844,
              "z": 0.818
            },
            "gtin": "4062300025318",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c875ed67a01d9a1f3b5",
            "leftCorner": {
              "x": -6.259,
              "y": 40.842,
              "z": 0.818
            },
            "rightCorner": {
              "x": -6.148,
              "y": 40.837,
              "z": 0.818
            },
            "gtin": "4062300266230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3b6",
            "leftCorner": {
              "x": -6.148,
              "y": 40.837,
              "z": 0.818
            },
            "rightCorner": {
              "x": -6.038,
              "y": 40.831,
              "z": 0.818
            },
            "gtin": "4062300266230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3b7",
            "leftCorner": {
              "x": -6.038,
              "y": 40.831,
              "z": 0.818
            },
            "rightCorner": {
              "x": -5.928,
              "y": 40.826,
              "z": 0.818
            },
            "gtin": "4062300266230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3b8",
            "leftCorner": {
              "x": -5.928,
              "y": 40.825,
              "z": 0.818
            },
            "rightCorner": {
              "x": -5.699,
              "y": 40.813,
              "z": 0.818
            },
            "gtin": "4062300463141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3b9",
            "leftCorner": {
              "x": -5.699,
              "y": 40.813,
              "z": 0.818
            },
            "rightCorner": {
              "x": -5.47,
              "y": 40.801,
              "z": 0.818
            },
            "gtin": "4062300463141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3ba",
            "leftCorner": {
              "x": -5.469,
              "y": 40.82,
              "z": 0.818
            },
            "rightCorner": {
              "x": -5.177,
              "y": 40.804,
              "z": 0.818
            },
            "gtin": "4062300427372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3bb",
            "leftCorner": {
              "x": -5.177,
              "y": 40.804,
              "z": 0.818
            },
            "rightCorner": {
              "x": -4.885,
              "y": 40.788,
              "z": 0.818
            },
            "gtin": "4062300427372",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464bd",
        "height": 1.2493,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f4d9",
            "leftCorner": {
              "x": -6.431,
              "y": 40.862,
              "z": 1.022
            },
            "rightCorner": {
              "x": -6.299,
              "y": 40.855,
              "z": 1.022
            },
            "gtin": "4062300409064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4da",
            "leftCorner": {
              "x": -6.3,
              "y": 40.849,
              "z": 1.022
            },
            "rightCorner": {
              "x": -6.24,
              "y": 40.846,
              "z": 1.022
            },
            "gtin": "4062300349445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4db",
            "leftCorner": {
              "x": -6.24,
              "y": 40.846,
              "z": 1.022
            },
            "rightCorner": {
              "x": -6.181,
              "y": 40.843,
              "z": 1.022
            },
            "gtin": "4062300349445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4dc",
            "leftCorner": {
              "x": -6.181,
              "y": 40.842,
              "z": 1.022
            },
            "rightCorner": {
              "x": -6.068,
              "y": 40.837,
              "z": 1.022
            },
            "gtin": "4062300379657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4dd",
            "leftCorner": {
              "x": -6.068,
              "y": 40.837,
              "z": 1.022
            },
            "rightCorner": {
              "x": -5.956,
              "y": 40.831,
              "z": 1.022
            },
            "gtin": "4062300379657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4de",
            "leftCorner": {
              "x": -5.956,
              "y": 40.831,
              "z": 1.022
            },
            "rightCorner": {
              "x": -5.843,
              "y": 40.824,
              "z": 1.022
            },
            "gtin": "4062300379657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4df",
            "leftCorner": {
              "x": -5.842,
              "y": 40.833,
              "z": 1.022
            },
            "rightCorner": {
              "x": -5.778,
              "y": 40.83,
              "z": 1.022
            },
            "gtin": "4062300336582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4e0",
            "leftCorner": {
              "x": -5.778,
              "y": 40.83,
              "z": 1.022
            },
            "rightCorner": {
              "x": -5.713,
              "y": 40.827,
              "z": 1.022
            },
            "gtin": "4062300336582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4e1",
            "leftCorner": {
              "x": -5.713,
              "y": 40.826,
              "z": 1.022
            },
            "rightCorner": {
              "x": -5.629,
              "y": 40.822,
              "z": 1.022
            },
            "gtin": "4062300266346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4e2",
            "leftCorner": {
              "x": -5.629,
              "y": 40.822,
              "z": 1.022
            },
            "rightCorner": {
              "x": -5.545,
              "y": 40.817,
              "z": 1.022
            },
            "gtin": "4062300266346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4e3",
            "leftCorner": {
              "x": -5.545,
              "y": 40.817,
              "z": 1.022
            },
            "rightCorner": {
              "x": -5.461,
              "y": 40.812,
              "z": 1.022
            },
            "gtin": "4062300266346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4e4",
            "leftCorner": {
              "x": -5.461,
              "y": 40.806,
              "z": 1.022
            },
            "rightCorner": {
              "x": -5.411,
              "y": 40.804,
              "z": 1.022
            },
            "gtin": "4062300266353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4e5",
            "leftCorner": {
              "x": -5.411,
              "y": 40.804,
              "z": 1.022
            },
            "rightCorner": {
              "x": -5.361,
              "y": 40.801,
              "z": 1.022
            },
            "gtin": "4062300266353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4e6",
            "leftCorner": {
              "x": -5.361,
              "y": 40.801,
              "z": 1.022
            },
            "rightCorner": {
              "x": -5.311,
              "y": 40.798,
              "z": 1.022
            },
            "gtin": "4062300266353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4e7",
            "leftCorner": {
              "x": -5.311,
              "y": 40.791,
              "z": 1.022
            },
            "rightCorner": {
              "x": -5.187,
              "y": 40.784,
              "z": 1.022
            },
            "gtin": "4062300208193",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464be",
        "height": 1.4973,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f407",
            "leftCorner": {
              "x": -6.388,
              "y": 40.848,
              "z": 1.225
            },
            "rightCorner": {
              "x": -6.282,
              "y": 40.842,
              "z": 1.225
            },
            "gtin": "4062300406612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f408",
            "leftCorner": {
              "x": -6.282,
              "y": 40.842,
              "z": 1.225
            },
            "rightCorner": {
              "x": -6.175,
              "y": 40.837,
              "z": 1.225
            },
            "gtin": "4062300406612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f409",
            "leftCorner": {
              "x": -6.174,
              "y": 40.848,
              "z": 1.225
            },
            "rightCorner": {
              "x": -6.053,
              "y": 40.842,
              "z": 1.225
            },
            "gtin": "4062300269880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f40a",
            "leftCorner": {
              "x": -6.053,
              "y": 40.842,
              "z": 1.225
            },
            "rightCorner": {
              "x": -5.931,
              "y": 40.836,
              "z": 1.225
            },
            "gtin": "4062300269880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f40b",
            "leftCorner": {
              "x": -5.931,
              "y": 40.831,
              "z": 1.225
            },
            "rightCorner": {
              "x": -5.85,
              "y": 40.827,
              "z": 1.225
            },
            "gtin": "4062300441422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f40c",
            "leftCorner": {
              "x": -5.85,
              "y": 40.827,
              "z": 1.225
            },
            "rightCorner": {
              "x": -5.769,
              "y": 40.823,
              "z": 1.225
            },
            "gtin": "4062300441422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f40d",
            "leftCorner": {
              "x": -5.769,
              "y": 40.823,
              "z": 1.225
            },
            "rightCorner": {
              "x": -5.688,
              "y": 40.819,
              "z": 1.225
            },
            "gtin": "4062300441422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f40e",
            "leftCorner": {
              "x": -5.687,
              "y": 40.829,
              "z": 1.225
            },
            "rightCorner": {
              "x": -5.628,
              "y": 40.825,
              "z": 1.225
            },
            "gtin": "4062300427181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f40f",
            "leftCorner": {
              "x": -5.628,
              "y": 40.825,
              "z": 1.225
            },
            "rightCorner": {
              "x": -5.57,
              "y": 40.822,
              "z": 1.225
            },
            "gtin": "4062300427181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f410",
            "leftCorner": {
              "x": -5.57,
              "y": 40.808,
              "z": 1.225
            },
            "rightCorner": {
              "x": -5.496,
              "y": 40.804,
              "z": 1.225
            },
            "gtin": "4062300367715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f411",
            "leftCorner": {
              "x": -5.496,
              "y": 40.804,
              "z": 1.225
            },
            "rightCorner": {
              "x": -5.421,
              "y": 40.8,
              "z": 1.225
            },
            "gtin": "4062300367715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f412",
            "leftCorner": {
              "x": -5.421,
              "y": 40.799,
              "z": 1.225
            },
            "rightCorner": {
              "x": -5.357,
              "y": 40.796,
              "z": 1.225
            },
            "gtin": "4062300406490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f413",
            "leftCorner": {
              "x": -5.357,
              "y": 40.796,
              "z": 1.225
            },
            "rightCorner": {
              "x": -5.294,
              "y": 40.793,
              "z": 1.225
            },
            "gtin": "4062300406490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f414",
            "leftCorner": {
              "x": -5.294,
              "y": 40.787,
              "z": 1.225
            },
            "rightCorner": {
              "x": -5.206,
              "y": 40.782,
              "z": 1.225
            },
            "gtin": "4062300441453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f415",
            "leftCorner": {
              "x": -5.206,
              "y": 40.782,
              "z": 1.225
            },
            "rightCorner": {
              "x": -5.117,
              "y": 40.778,
              "z": 1.225
            },
            "gtin": "4062300441453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f416",
            "leftCorner": {
              "x": -5.117,
              "y": 40.778,
              "z": 1.225
            },
            "rightCorner": {
              "x": -5.029,
              "y": 40.773,
              "z": 1.225
            },
            "gtin": "4062300441453",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464c0",
        "height": 1.7426,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f2df",
            "leftCorner": {
              "x": -6.47,
              "y": 40.815,
              "z": 1.426
            },
            "rightCorner": {
              "x": -6.402,
              "y": 40.81,
              "z": 1.426
            },
            "gtin": "4062300297036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2e0",
            "leftCorner": {
              "x": -6.402,
              "y": 40.81,
              "z": 1.426
            },
            "rightCorner": {
              "x": -6.335,
              "y": 40.807,
              "z": 1.426
            },
            "gtin": "4062300297036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2e1",
            "leftCorner": {
              "x": -6.333,
              "y": 40.837,
              "z": 1.426
            },
            "rightCorner": {
              "x": -6.268,
              "y": 40.834,
              "z": 1.426
            },
            "gtin": "4062300297043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2e2",
            "leftCorner": {
              "x": -6.268,
              "y": 40.834,
              "z": 1.426
            },
            "rightCorner": {
              "x": -6.203,
              "y": 40.83,
              "z": 1.426
            },
            "gtin": "4062300297043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2e3",
            "leftCorner": {
              "x": -6.203,
              "y": 40.843,
              "z": 1.426
            },
            "rightCorner": {
              "x": -6.137,
              "y": 40.839,
              "z": 1.426
            },
            "gtin": "4062300379411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2e4",
            "leftCorner": {
              "x": -6.137,
              "y": 40.839,
              "z": 1.426
            },
            "rightCorner": {
              "x": -6.072,
              "y": 40.836,
              "z": 1.426
            },
            "gtin": "4062300379411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2e5",
            "leftCorner": {
              "x": -6.071,
              "y": 40.852,
              "z": 1.426
            },
            "rightCorner": {
              "x": -6.023,
              "y": 40.849,
              "z": 1.426
            },
            "gtin": "4062300290136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2e6",
            "leftCorner": {
              "x": -6.023,
              "y": 40.849,
              "z": 1.426
            },
            "rightCorner": {
              "x": -5.974,
              "y": 40.847,
              "z": 1.426
            },
            "gtin": "4062300290136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2e7",
            "leftCorner": {
              "x": -5.974,
              "y": 40.847,
              "z": 1.426
            },
            "rightCorner": {
              "x": -5.925,
              "y": 40.844,
              "z": 1.426
            },
            "gtin": "4062300290136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2e8",
            "leftCorner": {
              "x": -5.926,
              "y": 40.833,
              "z": 1.426
            },
            "rightCorner": {
              "x": -5.849,
              "y": 40.829,
              "z": 1.426
            },
            "gtin": "4062300441170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2e9",
            "leftCorner": {
              "x": -5.849,
              "y": 40.829,
              "z": 1.426
            },
            "rightCorner": {
              "x": -5.772,
              "y": 40.824,
              "z": 1.426
            },
            "gtin": "4062300441170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2ea",
            "leftCorner": {
              "x": -5.772,
              "y": 40.82,
              "z": 1.426
            },
            "rightCorner": {
              "x": -5.72,
              "y": 40.817,
              "z": 1.426
            },
            "gtin": "4062300441576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2eb",
            "leftCorner": {
              "x": -5.72,
              "y": 40.817,
              "z": 1.426
            },
            "rightCorner": {
              "x": -5.667,
              "y": 40.815,
              "z": 1.426
            },
            "gtin": "4062300441576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2ec",
            "leftCorner": {
              "x": -5.667,
              "y": 40.815,
              "z": 1.426
            },
            "rightCorner": {
              "x": -5.615,
              "y": 40.811,
              "z": 1.426
            },
            "gtin": "4062300441576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2ed",
            "leftCorner": {
              "x": -5.615,
              "y": 40.817,
              "z": 1.426
            },
            "rightCorner": {
              "x": -5.545,
              "y": 40.813,
              "z": 1.426
            },
            "gtin": "4062300441316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2ee",
            "leftCorner": {
              "x": -5.545,
              "y": 40.813,
              "z": 1.426
            },
            "rightCorner": {
              "x": -5.476,
              "y": 40.81,
              "z": 1.426
            },
            "gtin": "4062300441316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2ef",
            "leftCorner": {
              "x": -5.476,
              "y": 40.808,
              "z": 1.426
            },
            "rightCorner": {
              "x": -5.377,
              "y": 40.803,
              "z": 1.426
            },
            "gtin": "4062300293779",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2f0",
            "leftCorner": {
              "x": -5.377,
              "y": 40.803,
              "z": 1.426
            },
            "rightCorner": {
              "x": -5.278,
              "y": 40.798,
              "z": 1.426
            },
            "gtin": "4062300293779",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2f1",
            "leftCorner": {
              "x": -5.278,
              "y": 40.798,
              "z": 1.426
            },
            "rightCorner": {
              "x": -5.179,
              "y": 40.792,
              "z": 1.426
            },
            "gtin": "4062300293779",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d9f7e",
    "rightNeighborShelfId": "d9f82"
  },
  {
    "id": "d9f82",
    "name": "d9f82",
    "x": -5.228,
    "y": 40.746,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.026273,
      "w": 0.99965
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 72,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5464c8",
        "height": 0.13902,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f43f",
            "leftCorner": {
              "x": -5.14,
              "y": 40.796,
              "z": 0.114
            },
            "rightCorner": {
              "x": -4.987,
              "y": 40.789,
              "z": 0.114
            },
            "gtin": "4062300166738",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c875ed67a01d9a1f440",
            "leftCorner": {
              "x": -4.987,
              "y": 40.793,
              "z": 0.114
            },
            "rightCorner": {
              "x": -4.687,
              "y": 40.777,
              "z": 0.114
            },
            "gtin": "4062300255142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f441",
            "leftCorner": {
              "x": -4.687,
              "y": 40.78,
              "z": 0.114
            },
            "rightCorner": {
              "x": -4.458,
              "y": 40.768,
              "z": 0.114
            },
            "gtin": "4062300377455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f442",
            "leftCorner": {
              "x": -4.458,
              "y": 40.768,
              "z": 0.114
            },
            "rightCorner": {
              "x": -4.228,
              "y": 40.756,
              "z": 0.114
            },
            "gtin": "4062300377455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f443",
            "leftCorner": {
              "x": -4.229,
              "y": 40.727,
              "z": 0.114
            },
            "rightCorner": {
              "x": -4.128,
              "y": 40.721,
              "z": 0.114
            },
            "gtin": "4062300255029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f444",
            "leftCorner": {
              "x": -4.128,
              "y": 40.721,
              "z": 0.114
            },
            "rightCorner": {
              "x": -4.027,
              "y": 40.716,
              "z": 0.114
            },
            "gtin": "4062300255029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f445",
            "leftCorner": {
              "x": -4.027,
              "y": 40.716,
              "z": 0.114
            },
            "rightCorner": {
              "x": -3.927,
              "y": 40.711,
              "z": 0.114
            },
            "gtin": "4062300255029",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464c7",
        "height": 0.39166,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f4a8",
            "leftCorner": {
              "x": -5.163,
              "y": 40.782,
              "z": 0.32
            },
            "rightCorner": {
              "x": -5.051,
              "y": 40.776,
              "z": 0.32
            },
            "gtin": "4062300262515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4a9",
            "leftCorner": {
              "x": -5.051,
              "y": 40.776,
              "z": 0.32
            },
            "rightCorner": {
              "x": -4.94,
              "y": 40.771,
              "z": 0.32
            },
            "gtin": "4062300262515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4aa",
            "leftCorner": {
              "x": -4.939,
              "y": 40.791,
              "z": 0.32
            },
            "rightCorner": {
              "x": -4.53,
              "y": 40.769,
              "z": 0.32
            },
            "gtin": "4062300036710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4ab",
            "leftCorner": {
              "x": -4.53,
              "y": 40.769,
              "z": 0.32
            },
            "rightCorner": {
              "x": -4.121,
              "y": 40.747,
              "z": 0.32
            },
            "gtin": "4062300036710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4ac",
            "leftCorner": {
              "x": -4.121,
              "y": 40.734,
              "z": 0.32
            },
            "rightCorner": {
              "x": -3.921,
              "y": 40.723,
              "z": 0.32
            },
            "gtin": "4062300255357",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464c9",
        "height": 0.69417,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f380",
            "leftCorner": {
              "x": -5.251,
              "y": 40.77,
              "z": 0.568
            },
            "rightCorner": {
              "x": -5.091,
              "y": 40.761,
              "z": 0.568
            },
            "gtin": "4062300266179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f381",
            "leftCorner": {
              "x": -5.091,
              "y": 40.761,
              "z": 0.568
            },
            "rightCorner": {
              "x": -4.93,
              "y": 40.753,
              "z": 0.568
            },
            "gtin": "4062300266179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f382",
            "leftCorner": {
              "x": -4.928,
              "y": 40.789,
              "z": 0.568
            },
            "rightCorner": {
              "x": -4.794,
              "y": 40.782,
              "z": 0.568
            },
            "gtin": "4062300462892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f383",
            "leftCorner": {
              "x": -4.795,
              "y": 40.778,
              "z": 0.568
            },
            "rightCorner": {
              "x": -4.723,
              "y": 40.774,
              "z": 0.568
            },
            "gtin": "4062300259638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f384",
            "leftCorner": {
              "x": -4.723,
              "y": 40.774,
              "z": 0.568
            },
            "rightCorner": {
              "x": -4.652,
              "y": 40.771,
              "z": 0.568
            },
            "gtin": "4062300259638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f385",
            "leftCorner": {
              "x": -4.652,
              "y": 40.775,
              "z": 0.568
            },
            "rightCorner": {
              "x": -4.569,
              "y": 40.77,
              "z": 0.568
            },
            "gtin": "4062300463059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f386",
            "leftCorner": {
              "x": -4.569,
              "y": 40.77,
              "z": 0.568
            },
            "rightCorner": {
              "x": -4.487,
              "y": 40.767,
              "z": 0.568
            },
            "gtin": "4062300463059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f387",
            "leftCorner": {
              "x": -4.488,
              "y": 40.759,
              "z": 0.568
            },
            "rightCorner": {
              "x": -4.413,
              "y": 40.755,
              "z": 0.568
            },
            "gtin": "4062300463646",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f388",
            "leftCorner": {
              "x": -4.413,
              "y": 40.755,
              "z": 0.568
            },
            "rightCorner": {
              "x": -4.34,
              "y": 40.751,
              "z": 0.568
            },
            "gtin": "4062300463646",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f34a",
            "leftCorner": {
              "x": -4.339,
              "y": 40.752,
              "z": 0.568
            },
            "rightCorner": {
              "x": -4.249,
              "y": 40.747,
              "z": 0.568
            },
            "gtin": "4062300439481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f34b",
            "leftCorner": {
              "x": -4.249,
              "y": 40.747,
              "z": 0.568
            },
            "rightCorner": {
              "x": -4.158,
              "y": 40.742,
              "z": 0.568
            },
            "gtin": "4062300439481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f34c",
            "leftCorner": {
              "x": -4.158,
              "y": 40.742,
              "z": 0.568
            },
            "rightCorner": {
              "x": -4.068,
              "y": 40.737,
              "z": 0.568
            },
            "gtin": "4062300439481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f34d",
            "leftCorner": {
              "x": -4.068,
              "y": 40.737,
              "z": 0.568
            },
            "rightCorner": {
              "x": -3.977,
              "y": 40.733,
              "z": 0.568
            },
            "gtin": "4062300439481",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464ca",
        "height": 0.99377,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f3bc",
            "leftCorner": {
              "x": -4.885,
              "y": 40.786,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.798,
              "y": 40.781,
              "z": 0.813
            },
            "gtin": "4062300455993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3bd",
            "leftCorner": {
              "x": -4.798,
              "y": 40.781,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.711,
              "y": 40.777,
              "z": 0.813
            },
            "gtin": "4062300455993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3be",
            "leftCorner": {
              "x": -4.711,
              "y": 40.775,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.644,
              "y": 40.771,
              "z": 0.813
            },
            "gtin": "4062300437517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3bf",
            "leftCorner": {
              "x": -4.644,
              "y": 40.771,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.578,
              "y": 40.768,
              "z": 0.813
            },
            "gtin": "4062300437517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3c0",
            "leftCorner": {
              "x": -4.578,
              "y": 40.768,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.511,
              "y": 40.764,
              "z": 0.813
            },
            "gtin": "4062300437517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3c1",
            "leftCorner": {
              "x": -4.511,
              "y": 40.764,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.444,
              "y": 40.76,
              "z": 0.813
            },
            "gtin": "4062300437517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3c2",
            "leftCorner": {
              "x": -4.444,
              "y": 40.76,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.377,
              "y": 40.757,
              "z": 0.813
            },
            "gtin": "4062300437517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3c3",
            "leftCorner": {
              "x": -4.377,
              "y": 40.751,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.295,
              "y": 40.747,
              "z": 0.813
            },
            "gtin": "4062300455887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3c4",
            "leftCorner": {
              "x": -4.295,
              "y": 40.747,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.212,
              "y": 40.742,
              "z": 0.813
            },
            "gtin": "4062300455887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f38a",
            "leftCorner": {
              "x": -4.212,
              "y": 40.743,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.134,
              "y": 40.74,
              "z": 0.813
            },
            "gtin": "4062300456020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f38b",
            "leftCorner": {
              "x": -4.134,
              "y": 40.74,
              "z": 0.813
            },
            "rightCorner": {
              "x": -4.055,
              "y": 40.735,
              "z": 0.813
            },
            "gtin": "4062300456020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f38c",
            "leftCorner": {
              "x": -4.055,
              "y": 40.735,
              "z": 0.813
            },
            "rightCorner": {
              "x": -3.977,
              "y": 40.731,
              "z": 0.813
            },
            "gtin": "4062300456020",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464c6",
        "height": 1.245,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f4e8",
            "leftCorner": {
              "x": -5.188,
              "y": 40.779,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.138,
              "y": 40.777,
              "z": 1.019
            },
            "gtin": "4062300350403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4e9",
            "leftCorner": {
              "x": -5.138,
              "y": 40.777,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.089,
              "y": 40.774,
              "z": 1.019
            },
            "gtin": "4062300350403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4ea",
            "leftCorner": {
              "x": -5.089,
              "y": 40.774,
              "z": 1.019
            },
            "rightCorner": {
              "x": -5.04,
              "y": 40.772,
              "z": 1.019
            },
            "gtin": "4062300350403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4eb",
            "leftCorner": {
              "x": -5.039,
              "y": 40.778,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.987,
              "y": 40.775,
              "z": 1.019
            },
            "gtin": "4062300021112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4ec",
            "leftCorner": {
              "x": -4.987,
              "y": 40.775,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.935,
              "y": 40.772,
              "z": 1.019
            },
            "gtin": "4062300021112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4ed",
            "leftCorner": {
              "x": -4.935,
              "y": 40.772,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.882,
              "y": 40.769,
              "z": 1.019
            },
            "gtin": "4062300021112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4ee",
            "leftCorner": {
              "x": -4.882,
              "y": 40.769,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.81,
              "y": 40.765,
              "z": 1.019
            },
            "gtin": "4062300020313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4ef",
            "leftCorner": {
              "x": -4.81,
              "y": 40.765,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.738,
              "y": 40.761,
              "z": 1.019
            },
            "gtin": "4062300020313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4f0",
            "leftCorner": {
              "x": -4.738,
              "y": 40.762,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.598,
              "y": 40.755,
              "z": 1.019
            },
            "gtin": "4062300379060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4f1",
            "leftCorner": {
              "x": -4.597,
              "y": 40.772,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.499,
              "y": 40.766,
              "z": 1.019
            },
            "gtin": "4062300024816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4b9",
            "leftCorner": {
              "x": -4.5,
              "y": 40.748,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.326,
              "y": 40.739,
              "z": 1.019
            },
            "gtin": "4062300266247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4ba",
            "leftCorner": {
              "x": -4.326,
              "y": 40.739,
              "z": 1.019
            },
            "rightCorner": {
              "x": -4.152,
              "y": 40.729,
              "z": 1.019
            },
            "gtin": "4062300266247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4bb",
            "leftCorner": {
              "x": -4.152,
              "y": 40.729,
              "z": 1.019
            },
            "rightCorner": {
              "x": -3.978,
              "y": 40.721,
              "z": 1.019
            },
            "gtin": "4062300266247",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464cb",
        "height": 1.4956,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f417",
            "leftCorner": {
              "x": -5.029,
              "y": 40.778,
              "z": 1.224
            },
            "rightCorner": {
              "x": -4.899,
              "y": 40.772,
              "z": 1.224
            },
            "gtin": "4062300258655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f418",
            "leftCorner": {
              "x": -4.9,
              "y": 40.754,
              "z": 1.224
            },
            "rightCorner": {
              "x": -4.75,
              "y": 40.746,
              "z": 1.224
            },
            "gtin": "4062300123175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f419",
            "leftCorner": {
              "x": -4.75,
              "y": 40.752,
              "z": 1.224
            },
            "rightCorner": {
              "x": -4.651,
              "y": 40.748,
              "z": 1.224
            },
            "gtin": "4062300123205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f41a",
            "leftCorner": {
              "x": -4.651,
              "y": 40.748,
              "z": 1.224
            },
            "rightCorner": {
              "x": -4.553,
              "y": 40.743,
              "z": 1.224
            },
            "gtin": "4062300123205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f41b",
            "leftCorner": {
              "x": -4.553,
              "y": 40.743,
              "z": 1.224
            },
            "rightCorner": {
              "x": -4.454,
              "y": 40.737,
              "z": 1.224
            },
            "gtin": "4062300123205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3d8",
            "leftCorner": {
              "x": -4.454,
              "y": 40.745,
              "z": 1.224
            },
            "rightCorner": {
              "x": -4.216,
              "y": 40.733,
              "z": 1.224
            },
            "gtin": "4062300265813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f3d9",
            "leftCorner": {
              "x": -4.216,
              "y": 40.733,
              "z": 1.224
            },
            "rightCorner": {
              "x": -3.978,
              "y": 40.721,
              "z": 1.224
            },
            "gtin": "4062300265813",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464c5",
        "height": 1.7467,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f2f2",
            "leftCorner": {
              "x": -5.18,
              "y": 40.776,
              "z": 1.429
            },
            "rightCorner": {
              "x": -5.111,
              "y": 40.772,
              "z": 1.429
            },
            "gtin": "4062300323926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2f3",
            "leftCorner": {
              "x": -5.111,
              "y": 40.772,
              "z": 1.429
            },
            "rightCorner": {
              "x": -5.043,
              "y": 40.768,
              "z": 1.429
            },
            "gtin": "4062300323926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2f4",
            "leftCorner": {
              "x": -5.043,
              "y": 40.776,
              "z": 1.429
            },
            "rightCorner": {
              "x": -4.902,
              "y": 40.768,
              "z": 1.429
            },
            "gtin": "4062300440937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2f5",
            "leftCorner": {
              "x": -4.902,
              "y": 40.768,
              "z": 1.429
            },
            "rightCorner": {
              "x": -4.761,
              "y": 40.761,
              "z": 1.429
            },
            "gtin": "4062300440937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2f6",
            "leftCorner": {
              "x": -4.761,
              "y": 40.767,
              "z": 1.429
            },
            "rightCorner": {
              "x": -4.601,
              "y": 40.759,
              "z": 1.429
            },
            "gtin": "4062300269804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2f7",
            "leftCorner": {
              "x": -4.602,
              "y": 40.747,
              "z": 1.429
            },
            "rightCorner": {
              "x": -4.523,
              "y": 40.742,
              "z": 1.429
            },
            "gtin": "4062300269835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2f8",
            "leftCorner": {
              "x": -4.523,
              "y": 40.742,
              "z": 1.429
            },
            "rightCorner": {
              "x": -4.445,
              "y": 40.738,
              "z": 1.429
            },
            "gtin": "4062300269835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2f9",
            "leftCorner": {
              "x": -4.444,
              "y": 40.75,
              "z": 1.429
            },
            "rightCorner": {
              "x": -4.381,
              "y": 40.747,
              "z": 1.429
            },
            "gtin": "4062300269842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2fa",
            "leftCorner": {
              "x": -4.381,
              "y": 40.747,
              "z": 1.429
            },
            "rightCorner": {
              "x": -4.317,
              "y": 40.744,
              "z": 1.429
            },
            "gtin": "4062300269842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2fb",
            "leftCorner": {
              "x": -4.318,
              "y": 40.733,
              "z": 1.429
            },
            "rightCorner": {
              "x": -4.258,
              "y": 40.729,
              "z": 1.429
            },
            "gtin": "4062300406483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2fc",
            "leftCorner": {
              "x": -4.258,
              "y": 40.729,
              "z": 1.429
            },
            "rightCorner": {
              "x": -4.199,
              "y": 40.726,
              "z": 1.429
            },
            "gtin": "4062300406483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2fd",
            "leftCorner": {
              "x": -4.2,
              "y": 40.713,
              "z": 1.429
            },
            "rightCorner": {
              "x": -4.164,
              "y": 40.711,
              "z": 1.429
            },
            "gtin": "4062300406476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2fe",
            "leftCorner": {
              "x": -4.164,
              "y": 40.711,
              "z": 1.429
            },
            "rightCorner": {
              "x": -4.128,
              "y": 40.709,
              "z": 1.429
            },
            "gtin": "4062300406476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2ff",
            "leftCorner": {
              "x": -4.128,
              "y": 40.709,
              "z": 1.429
            },
            "rightCorner": {
              "x": -4.092,
              "y": 40.708,
              "z": 1.429
            },
            "gtin": "4062300406476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f300",
            "leftCorner": {
              "x": -4.092,
              "y": 40.708,
              "z": 1.429
            },
            "rightCorner": {
              "x": -4.056,
              "y": 40.705,
              "z": 1.429
            },
            "gtin": "4062300406476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f301",
            "leftCorner": {
              "x": -4.055,
              "y": 40.72,
              "z": 1.429
            },
            "rightCorner": {
              "x": -3.924,
              "y": 40.713,
              "z": 1.429
            },
            "gtin": "4062300406469",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d9f7f",
    "rightNeighborShelfId": "d9f83"
  },
  {
    "id": "d9f83",
    "name": "d9f83",
    "x": -3.979,
    "y": 40.681,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.026273,
      "w": 0.99965
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 92,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5464d2",
        "height": 0.1432,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f446",
            "leftCorner": {
              "x": -3.926,
              "y": 40.705,
              "z": 0.117
            },
            "rightCorner": {
              "x": -3.8,
              "y": 40.699,
              "z": 0.117
            },
            "gtin": "4062300276437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f447",
            "leftCorner": {
              "x": -3.8,
              "y": 40.699,
              "z": 0.117
            },
            "rightCorner": {
              "x": -3.674,
              "y": 40.692,
              "z": 0.117
            },
            "gtin": "4062300276437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f448",
            "leftCorner": {
              "x": -3.674,
              "y": 40.692,
              "z": 0.117
            },
            "rightCorner": {
              "x": -3.549,
              "y": 40.686,
              "z": 0.117
            },
            "gtin": "4062300276437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f449",
            "leftCorner": {
              "x": -3.547,
              "y": 40.723,
              "z": 0.117
            },
            "rightCorner": {
              "x": -3.403,
              "y": 40.714,
              "z": 0.117
            },
            "gtin": "4062300167032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f44a",
            "leftCorner": {
              "x": -3.403,
              "y": 40.714,
              "z": 0.117
            },
            "rightCorner": {
              "x": -3.26,
              "y": 40.707,
              "z": 0.117
            },
            "gtin": "4062300167032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f44b",
            "leftCorner": {
              "x": -3.26,
              "y": 40.699,
              "z": 0.117
            },
            "rightCorner": {
              "x": -3.188,
              "y": 40.695,
              "z": 0.117
            },
            "gtin": "4062300431959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f44c",
            "leftCorner": {
              "x": -3.188,
              "y": 40.695,
              "z": 0.117
            },
            "rightCorner": {
              "x": -3.115,
              "y": 40.692,
              "z": 0.117
            },
            "gtin": "4062300431959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f44d",
            "leftCorner": {
              "x": -3.116,
              "y": 40.681,
              "z": 0.117
            },
            "rightCorner": {
              "x": -2.922,
              "y": 40.671,
              "z": 0.117
            },
            "gtin": "4062300265608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f44e",
            "leftCorner": {
              "x": -2.922,
              "y": 40.671,
              "z": 0.117
            },
            "rightCorner": {
              "x": -2.728,
              "y": 40.661,
              "z": 0.117
            },
            "gtin": "4062300265608",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464cf",
        "height": 0.40034,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f4ad",
            "leftCorner": {
              "x": -3.92,
              "y": 40.732,
              "z": 0.328
            },
            "rightCorner": {
              "x": -3.789,
              "y": 40.725,
              "z": 0.328
            },
            "gtin": "4062300255203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4ae",
            "leftCorner": {
              "x": -3.789,
              "y": 40.725,
              "z": 0.328
            },
            "rightCorner": {
              "x": -3.659,
              "y": 40.719,
              "z": 0.328
            },
            "gtin": "4062300255203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4af",
            "leftCorner": {
              "x": -3.658,
              "y": 40.731,
              "z": 0.328
            },
            "rightCorner": {
              "x": -3.446,
              "y": 40.72,
              "z": 0.328
            },
            "gtin": "4062300255081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4b0",
            "leftCorner": {
              "x": -3.446,
              "y": 40.719,
              "z": 0.328
            },
            "rightCorner": {
              "x": -3.394,
              "y": 40.716,
              "z": 0.328
            },
            "gtin": "4062300375178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4b1",
            "leftCorner": {
              "x": -3.394,
              "y": 40.716,
              "z": 0.328
            },
            "rightCorner": {
              "x": -3.342,
              "y": 40.712,
              "z": 0.328
            },
            "gtin": "4062300375178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4b2",
            "leftCorner": {
              "x": -3.342,
              "y": 40.709,
              "z": 0.328
            },
            "rightCorner": {
              "x": -3.206,
              "y": 40.702,
              "z": 0.328
            },
            "gtin": "4062300255234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4b3",
            "leftCorner": {
              "x": -3.206,
              "y": 40.702,
              "z": 0.328
            },
            "rightCorner": {
              "x": -3.07,
              "y": 40.695,
              "z": 0.328
            },
            "gtin": "4062300255234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4b4",
            "leftCorner": {
              "x": -3.07,
              "y": 40.695,
              "z": 0.328
            },
            "rightCorner": {
              "x": -2.933,
              "y": 40.688,
              "z": 0.328
            },
            "gtin": "4062300255234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f47d",
            "leftCorner": {
              "x": -2.933,
              "y": 40.686,
              "z": 0.328
            },
            "rightCorner": {
              "x": -2.831,
              "y": 40.681,
              "z": 0.328
            },
            "gtin": "4062300241619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f47e",
            "leftCorner": {
              "x": -2.831,
              "y": 40.681,
              "z": 0.328
            },
            "rightCorner": {
              "x": -2.728,
              "y": 40.676,
              "z": 0.328
            },
            "gtin": "4062300241619",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464cc",
        "height": 0.64175,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f4f2",
            "leftCorner": {
              "x": -3.978,
              "y": 40.701,
              "z": 0.525
            },
            "rightCorner": {
              "x": -3.879,
              "y": 40.696,
              "z": 0.525
            },
            "gtin": "4018852030546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4f3",
            "leftCorner": {
              "x": -3.879,
              "y": 40.696,
              "z": 0.525
            },
            "rightCorner": {
              "x": -3.781,
              "y": 40.691,
              "z": 0.525
            },
            "gtin": "4018852030546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4f7",
            "leftCorner": {
              "x": -3.779,
              "y": 40.731,
              "z": 0.525
            },
            "rightCorner": {
              "x": -3.699,
              "y": 40.727,
              "z": 0.525
            },
            "gtin": "4018852030522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4f8",
            "leftCorner": {
              "x": -3.699,
              "y": 40.727,
              "z": 0.525
            },
            "rightCorner": {
              "x": -3.62,
              "y": 40.723,
              "z": 0.525
            },
            "gtin": "4018852030522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4f9",
            "leftCorner": {
              "x": -3.62,
              "y": 40.729,
              "z": 0.525
            },
            "rightCorner": {
              "x": -3.499,
              "y": 40.722,
              "z": 0.525
            },
            "gtin": "4018852030539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4fa",
            "leftCorner": {
              "x": -3.499,
              "y": 40.715,
              "z": 0.525
            },
            "rightCorner": {
              "x": -3.417,
              "y": 40.711,
              "z": 0.525
            },
            "gtin": "4018852030492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4fb",
            "leftCorner": {
              "x": -3.417,
              "y": 40.711,
              "z": 0.525
            },
            "rightCorner": {
              "x": -3.334,
              "y": 40.707,
              "z": 0.525
            },
            "gtin": "4018852030492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4fc",
            "leftCorner": {
              "x": -3.334,
              "y": 40.707,
              "z": 0.525
            },
            "rightCorner": {
              "x": -3.19,
              "y": 40.699,
              "z": 0.525
            },
            "gtin": "4018852030553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4fd",
            "leftCorner": {
              "x": -3.19,
              "y": 40.693,
              "z": 0.525
            },
            "rightCorner": {
              "x": -3.126,
              "y": 40.69,
              "z": 0.525
            },
            "gtin": "4018852035978",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4fe",
            "leftCorner": {
              "x": -3.126,
              "y": 40.69,
              "z": 0.525
            },
            "rightCorner": {
              "x": -3.062,
              "y": 40.687,
              "z": 0.525
            },
            "gtin": "4018852035978",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4ff",
            "leftCorner": {
              "x": -3.062,
              "y": 40.694,
              "z": 0.525
            },
            "rightCorner": {
              "x": -2.971,
              "y": 40.689,
              "z": 0.525
            },
            "gtin": "4018852030577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f500",
            "leftCorner": {
              "x": -2.971,
              "y": 40.684,
              "z": 0.525
            },
            "rightCorner": {
              "x": -2.932,
              "y": 40.682,
              "z": 0.525
            },
            "gtin": "4018852014959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f501",
            "leftCorner": {
              "x": -2.932,
              "y": 40.682,
              "z": 0.525
            },
            "rightCorner": {
              "x": -2.892,
              "y": 40.68,
              "z": 0.525
            },
            "gtin": "4018852014959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f502",
            "leftCorner": {
              "x": -2.892,
              "y": 40.68,
              "z": 0.525
            },
            "rightCorner": {
              "x": -2.853,
              "y": 40.678,
              "z": 0.525
            },
            "gtin": "4018852014959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4f4",
            "leftCorner": {
              "x": -2.854,
              "y": 40.666,
              "z": 0.525
            },
            "rightCorner": {
              "x": -2.812,
              "y": 40.664,
              "z": 0.525
            },
            "gtin": "4018852014928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4f5",
            "leftCorner": {
              "x": -2.812,
              "y": 40.664,
              "z": 0.525
            },
            "rightCorner": {
              "x": -2.77,
              "y": 40.662,
              "z": 0.525
            },
            "gtin": "4018852014928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f4f6",
            "leftCorner": {
              "x": -2.77,
              "y": 40.662,
              "z": 0.525
            },
            "rightCorner": {
              "x": -2.728,
              "y": 40.66,
              "z": 0.525
            },
            "gtin": "4018852014928",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464d0",
        "height": 0.94368,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f510",
            "leftCorner": {
              "x": -3.978,
              "y": 40.694,
              "z": 0.772
            },
            "rightCorner": {
              "x": -3.88,
              "y": 40.689,
              "z": 0.772
            },
            "gtin": "4018852030003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f511",
            "leftCorner": {
              "x": -3.88,
              "y": 40.689,
              "z": 0.772
            },
            "rightCorner": {
              "x": -3.781,
              "y": 40.684,
              "z": 0.772
            },
            "gtin": "4018852030003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f512",
            "leftCorner": {
              "x": -3.781,
              "y": 40.684,
              "z": 0.772
            },
            "rightCorner": {
              "x": -3.682,
              "y": 40.679,
              "z": 0.772
            },
            "gtin": "4018852030003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f514",
            "leftCorner": {
              "x": -3.68,
              "y": 40.724,
              "z": 0.772
            },
            "rightCorner": {
              "x": -3.556,
              "y": 40.716,
              "z": 0.772
            },
            "gtin": "4018852029977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f515",
            "leftCorner": {
              "x": -3.556,
              "y": 40.714,
              "z": 0.772
            },
            "rightCorner": {
              "x": -3.492,
              "y": 40.711,
              "z": 0.772
            },
            "gtin": "4018852030157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f516",
            "leftCorner": {
              "x": -3.492,
              "y": 40.711,
              "z": 0.772
            },
            "rightCorner": {
              "x": -3.428,
              "y": 40.708,
              "z": 0.772
            },
            "gtin": "4018852030157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f517",
            "leftCorner": {
              "x": -3.428,
              "y": 40.706,
              "z": 0.772
            },
            "rightCorner": {
              "x": -3.359,
              "y": 40.702,
              "z": 0.772
            },
            "gtin": "4018852035558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f518",
            "leftCorner": {
              "x": -3.359,
              "y": 40.702,
              "z": 0.772
            },
            "rightCorner": {
              "x": -3.291,
              "y": 40.699,
              "z": 0.772
            },
            "gtin": "4018852035558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f519",
            "leftCorner": {
              "x": -3.291,
              "y": 40.689,
              "z": 0.772
            },
            "rightCorner": {
              "x": -3.181,
              "y": 40.683,
              "z": 0.772
            },
            "gtin": "4018852035497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f51a",
            "leftCorner": {
              "x": -3.181,
              "y": 40.692,
              "z": 0.772
            },
            "rightCorner": {
              "x": -3.118,
              "y": 40.689,
              "z": 0.772
            },
            "gtin": "4018852030171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f51b",
            "leftCorner": {
              "x": -3.118,
              "y": 40.689,
              "z": 0.772
            },
            "rightCorner": {
              "x": -3.055,
              "y": 40.685,
              "z": 0.772
            },
            "gtin": "4018852030171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f51c",
            "leftCorner": {
              "x": -3.055,
              "y": 40.69,
              "z": 0.772
            },
            "rightCorner": {
              "x": -3.002,
              "y": 40.688,
              "z": 0.772
            },
            "gtin": "4018852030164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f51d",
            "leftCorner": {
              "x": -3.002,
              "y": 40.688,
              "z": 0.772
            },
            "rightCorner": {
              "x": -2.949,
              "y": 40.685,
              "z": 0.772
            },
            "gtin": "4018852030164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f51e",
            "leftCorner": {
              "x": -2.949,
              "y": 40.68,
              "z": 0.772
            },
            "rightCorner": {
              "x": -2.874,
              "y": 40.676,
              "z": 0.772
            },
            "gtin": "4018852030485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f51f",
            "leftCorner": {
              "x": -2.874,
              "y": 40.676,
              "z": 0.772
            },
            "rightCorner": {
              "x": -2.799,
              "y": 40.672,
              "z": 0.772
            },
            "gtin": "4018852030485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f513",
            "leftCorner": {
              "x": -2.8,
              "y": 40.66,
              "z": 0.772
            },
            "rightCorner": {
              "x": -2.729,
              "y": 40.657,
              "z": 0.772
            },
            "gtin": "4018852035527",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464d1",
        "height": 1.1964,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f520",
            "leftCorner": {
              "x": -3.979,
              "y": 40.687,
              "z": 0.979
            },
            "rightCorner": {
              "x": -3.833,
              "y": 40.679,
              "z": 0.979
            },
            "gtin": "4018852036302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f521",
            "leftCorner": {
              "x": -3.833,
              "y": 40.679,
              "z": 0.979
            },
            "rightCorner": {
              "x": -3.687,
              "y": 40.672,
              "z": 0.979
            },
            "gtin": "4018852036302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f523",
            "leftCorner": {
              "x": -3.684,
              "y": 40.716,
              "z": 0.979
            },
            "rightCorner": {
              "x": -3.63,
              "y": 40.713,
              "z": 0.979
            },
            "gtin": "4018852034223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f524",
            "leftCorner": {
              "x": -3.63,
              "y": 40.713,
              "z": 0.979
            },
            "rightCorner": {
              "x": -3.576,
              "y": 40.71,
              "z": 0.979
            },
            "gtin": "4018852034223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f525",
            "leftCorner": {
              "x": -3.575,
              "y": 40.711,
              "z": 0.979
            },
            "rightCorner": {
              "x": -3.502,
              "y": 40.707,
              "z": 0.979
            },
            "gtin": "4018852036005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f526",
            "leftCorner": {
              "x": -3.502,
              "y": 40.707,
              "z": 0.979
            },
            "rightCorner": {
              "x": -3.429,
              "y": 40.703,
              "z": 0.979
            },
            "gtin": "4018852036005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f527",
            "leftCorner": {
              "x": -3.429,
              "y": 40.704,
              "z": 0.979
            },
            "rightCorner": {
              "x": -3.371,
              "y": 40.701,
              "z": 0.979
            },
            "gtin": "4018852034117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f528",
            "leftCorner": {
              "x": -3.371,
              "y": 40.701,
              "z": 0.979
            },
            "rightCorner": {
              "x": -3.312,
              "y": 40.698,
              "z": 0.979
            },
            "gtin": "4018852034117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f529",
            "leftCorner": {
              "x": -3.313,
              "y": 40.677,
              "z": 0.979
            },
            "rightCorner": {
              "x": -3.229,
              "y": 40.672,
              "z": 0.979
            },
            "gtin": "4018852036234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f52a",
            "leftCorner": {
              "x": -3.229,
              "y": 40.672,
              "z": 0.979
            },
            "rightCorner": {
              "x": -3.145,
              "y": 40.668,
              "z": 0.979
            },
            "gtin": "4018852036234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f52b",
            "leftCorner": {
              "x": -3.144,
              "y": 40.68,
              "z": 0.979
            },
            "rightCorner": {
              "x": -3.024,
              "y": 40.674,
              "z": 0.979
            },
            "gtin": "4018852035282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f52c",
            "leftCorner": {
              "x": -3.024,
              "y": 40.674,
              "z": 0.979
            },
            "rightCorner": {
              "x": -2.904,
              "y": 40.668,
              "z": 0.979
            },
            "gtin": "4018852035282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f52d",
            "leftCorner": {
              "x": -2.903,
              "y": 40.673,
              "z": 0.979
            },
            "rightCorner": {
              "x": -2.842,
              "y": 40.67,
              "z": 0.979
            },
            "gtin": "4018852035343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f52e",
            "leftCorner": {
              "x": -2.842,
              "y": 40.67,
              "z": 0.979
            },
            "rightCorner": {
              "x": -2.782,
              "y": 40.666,
              "z": 0.979
            },
            "gtin": "4018852035343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f522",
            "leftCorner": {
              "x": -2.782,
              "y": 40.657,
              "z": 0.979
            },
            "rightCorner": {
              "x": -2.729,
              "y": 40.655,
              "z": 0.979
            },
            "gtin": "4018852030027",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464cd",
        "height": 1.4469,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f503",
            "leftCorner": {
              "x": -3.979,
              "y": 40.681,
              "z": 1.184
            },
            "rightCorner": {
              "x": -3.81,
              "y": 40.671,
              "z": 1.184
            },
            "gtin": "4018852036456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f505",
            "leftCorner": {
              "x": -3.808,
              "y": 40.711,
              "z": 1.184
            },
            "rightCorner": {
              "x": -3.73,
              "y": 40.707,
              "z": 1.184
            },
            "gtin": "4018852036333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f506",
            "leftCorner": {
              "x": -3.73,
              "y": 40.701,
              "z": 1.184
            },
            "rightCorner": {
              "x": -3.669,
              "y": 40.698,
              "z": 1.184
            },
            "gtin": "4018852036128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f507",
            "leftCorner": {
              "x": -3.669,
              "y": 40.698,
              "z": 1.184
            },
            "rightCorner": {
              "x": -3.607,
              "y": 40.695,
              "z": 1.184
            },
            "gtin": "4018852036128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f508",
            "leftCorner": {
              "x": -3.607,
              "y": 40.71,
              "z": 1.184
            },
            "rightCorner": {
              "x": -3.498,
              "y": 40.704,
              "z": 1.184
            },
            "gtin": "4018852036517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f509",
            "leftCorner": {
              "x": -3.499,
              "y": 40.7,
              "z": 1.184
            },
            "rightCorner": {
              "x": -3.4,
              "y": 40.695,
              "z": 1.184
            },
            "gtin": "4018852029229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f50a",
            "leftCorner": {
              "x": -3.4,
              "y": 40.697,
              "z": 1.184
            },
            "rightCorner": {
              "x": -3.287,
              "y": 40.691,
              "z": 1.184
            },
            "gtin": "4018852036364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f50b",
            "leftCorner": {
              "x": -3.287,
              "y": 40.683,
              "z": 1.184
            },
            "rightCorner": {
              "x": -3.16,
              "y": 40.677,
              "z": 1.184
            },
            "gtin": "4018852029243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f50c",
            "leftCorner": {
              "x": -3.16,
              "y": 40.676,
              "z": 1.184
            },
            "rightCorner": {
              "x": -3.08,
              "y": 40.671,
              "z": 1.184
            },
            "gtin": "4018852029250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f50d",
            "leftCorner": {
              "x": -3.08,
              "y": 40.671,
              "z": 1.184
            },
            "rightCorner": {
              "x": -3.0,
              "y": 40.667,
              "z": 1.184
            },
            "gtin": "4018852029250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f50e",
            "leftCorner": {
              "x": -3.0,
              "y": 40.667,
              "z": 1.184
            },
            "rightCorner": {
              "x": -2.92,
              "y": 40.662,
              "z": 1.184
            },
            "gtin": "4018852029250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f50f",
            "leftCorner": {
              "x": -2.92,
              "y": 40.661,
              "z": 1.184
            },
            "rightCorner": {
              "x": -2.809,
              "y": 40.656,
              "z": 1.184
            },
            "gtin": "4018852029359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f504",
            "leftCorner": {
              "x": -2.809,
              "y": 40.65,
              "z": 1.184
            },
            "rightCorner": {
              "x": -2.729,
              "y": 40.646,
              "z": 1.184
            },
            "gtin": "4018852029342",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464ce",
        "height": 1.7459,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f302",
            "leftCorner": {
              "x": -3.923,
              "y": 40.709,
              "z": 1.428
            },
            "rightCorner": {
              "x": -3.843,
              "y": 40.705,
              "z": 1.428
            },
            "gtin": "4018852016861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f303",
            "leftCorner": {
              "x": -3.843,
              "y": 40.705,
              "z": 1.428
            },
            "rightCorner": {
              "x": -3.762,
              "y": 40.701,
              "z": 1.428
            },
            "gtin": "4018852016861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f304",
            "leftCorner": {
              "x": -3.762,
              "y": 40.703,
              "z": 1.428
            },
            "rightCorner": {
              "x": -3.565,
              "y": 40.693,
              "z": 1.428
            },
            "gtin": "4018852034575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f305",
            "leftCorner": {
              "x": -3.564,
              "y": 40.699,
              "z": 1.428
            },
            "rightCorner": {
              "x": -3.406,
              "y": 40.691,
              "z": 1.428
            },
            "gtin": "4018852034391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f306",
            "leftCorner": {
              "x": -3.406,
              "y": 40.691,
              "z": 1.428
            },
            "rightCorner": {
              "x": -3.247,
              "y": 40.682,
              "z": 1.428
            },
            "gtin": "4018852034391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f307",
            "leftCorner": {
              "x": -3.246,
              "y": 40.689,
              "z": 1.428
            },
            "rightCorner": {
              "x": -3.146,
              "y": 40.684,
              "z": 1.428
            },
            "gtin": "4018852018377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f308",
            "leftCorner": {
              "x": -3.146,
              "y": 40.684,
              "z": 1.428
            },
            "rightCorner": {
              "x": -3.047,
              "y": 40.679,
              "z": 1.428
            },
            "gtin": "4018852018377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f309",
            "leftCorner": {
              "x": -3.047,
              "y": 40.664,
              "z": 1.428
            },
            "rightCorner": {
              "x": -2.997,
              "y": 40.661,
              "z": 1.428
            },
            "gtin": "4018852034452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f30a",
            "leftCorner": {
              "x": -2.997,
              "y": 40.661,
              "z": 1.428
            },
            "rightCorner": {
              "x": -2.947,
              "y": 40.659,
              "z": 1.428
            },
            "gtin": "4018852034452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f30b",
            "leftCorner": {
              "x": -2.947,
              "y": 40.665,
              "z": 1.428
            },
            "rightCorner": {
              "x": -2.844,
              "y": 40.66,
              "z": 1.428
            },
            "gtin": "4018852017271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f30c",
            "leftCorner": {
              "x": -2.844,
              "y": 40.66,
              "z": 1.428
            },
            "rightCorner": {
              "x": -2.786,
              "y": 40.657,
              "z": 1.428
            },
            "gtin": "4018852017240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f30d",
            "leftCorner": {
              "x": -2.786,
              "y": 40.657,
              "z": 1.428
            },
            "rightCorner": {
              "x": -2.729,
              "y": 40.653,
              "z": 1.428
            },
            "gtin": "4018852017240",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d9f82",
    "rightNeighborShelfId": "d9f84"
  },
  {
    "id": "d9f84",
    "name": "d9f84",
    "x": -2.731,
    "y": 40.615,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.026273,
      "w": 0.99965
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 68
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5464d6",
        "height": 0.14711,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f44f",
            "leftCorner": {
              "x": -2.728,
              "y": 40.676,
              "z": 0.12
            },
            "rightCorner": {
              "x": -2.67,
              "y": 40.673,
              "z": 0.12
            },
            "gtin": "4063367332678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f450",
            "leftCorner": {
              "x": -2.67,
              "y": 40.671,
              "z": 0.12
            },
            "rightCorner": {
              "x": -2.547,
              "y": 40.665,
              "z": 0.12
            },
            "gtin": "4063367332678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f451",
            "leftCorner": {
              "x": -2.547,
              "y": 40.665,
              "z": 0.12
            },
            "rightCorner": {
              "x": -2.423,
              "y": 40.658,
              "z": 0.12
            },
            "gtin": "4063367332678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f452",
            "leftCorner": {
              "x": -2.424,
              "y": 40.647,
              "z": 0.12
            },
            "rightCorner": {
              "x": -2.283,
              "y": 40.639,
              "z": 0.12
            },
            "gtin": "4260342238974",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f453",
            "leftCorner": {
              "x": -2.283,
              "y": 40.649,
              "z": 0.12
            },
            "rightCorner": {
              "x": -2.133,
              "y": 40.642,
              "z": 0.12
            },
            "gtin": "4260342238721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f454",
            "leftCorner": {
              "x": -2.132,
              "y": 40.66,
              "z": 0.12
            },
            "rightCorner": {
              "x": -1.91,
              "y": 40.648,
              "z": 0.12
            },
            "gtin": "8719325866469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f455",
            "leftCorner": {
              "x": -1.91,
              "y": 40.646,
              "z": 0.12
            },
            "rightCorner": {
              "x": -1.801,
              "y": 40.64,
              "z": 0.12
            },
            "gtin": "8719325866476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f456",
            "leftCorner": {
              "x": -1.801,
              "y": 40.64,
              "z": 0.12
            },
            "rightCorner": {
              "x": -1.692,
              "y": 40.635,
              "z": 0.12
            },
            "gtin": "8719325866476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f457",
            "leftCorner": {
              "x": -1.692,
              "y": 40.633,
              "z": 0.12
            },
            "rightCorner": {
              "x": -1.584,
              "y": 40.627,
              "z": 0.12
            },
            "gtin": "5700002255921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f458",
            "leftCorner": {
              "x": -1.584,
              "y": 40.627,
              "z": 0.12
            },
            "rightCorner": {
              "x": -1.476,
              "y": 40.621,
              "z": 0.12
            },
            "gtin": "5700002255921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f459",
            "leftCorner": {
              "x": -1.476,
              "y": 40.621,
              "z": 0.12
            },
            "rightCorner": {
              "x": -1.368,
              "y": 40.616,
              "z": 0.12
            },
            "gtin": "5700002255921",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464d5",
        "height": 0.5456,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f55d",
            "leftCorner": {
              "x": -2.73,
              "y": 40.639,
              "z": 0.446
            },
            "rightCorner": {
              "x": -2.684,
              "y": 40.637,
              "z": 0.446
            },
            "gtin": "4063367332715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f55e",
            "leftCorner": {
              "x": -2.684,
              "y": 40.637,
              "z": 0.446
            },
            "rightCorner": {
              "x": -2.638,
              "y": 40.634,
              "z": 0.446
            },
            "gtin": "4063367332715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f560",
            "leftCorner": {
              "x": -2.637,
              "y": 40.663,
              "z": 0.446
            },
            "rightCorner": {
              "x": -2.473,
              "y": 40.654,
              "z": 0.446
            },
            "gtin": "4063367332685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f561",
            "leftCorner": {
              "x": -2.473,
              "y": 40.658,
              "z": 0.446
            },
            "rightCorner": {
              "x": -2.44,
              "y": 40.657,
              "z": 0.446
            },
            "gtin": "4063367332753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f562",
            "leftCorner": {
              "x": -2.441,
              "y": 40.648,
              "z": 0.446
            },
            "rightCorner": {
              "x": -2.387,
              "y": 40.644,
              "z": 0.446
            },
            "gtin": "4260342238684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f563",
            "leftCorner": {
              "x": -2.387,
              "y": 40.644,
              "z": 0.446
            },
            "rightCorner": {
              "x": -2.333,
              "y": 40.642,
              "z": 0.446
            },
            "gtin": "4260342238684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f564",
            "leftCorner": {
              "x": -2.332,
              "y": 40.655,
              "z": 0.446
            },
            "rightCorner": {
              "x": -2.267,
              "y": 40.651,
              "z": 0.446
            },
            "gtin": "4260342238677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f565",
            "leftCorner": {
              "x": -2.267,
              "y": 40.655,
              "z": 0.446
            },
            "rightCorner": {
              "x": -2.19,
              "y": 40.65,
              "z": 0.446
            },
            "gtin": "4260342238691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f566",
            "leftCorner": {
              "x": -2.19,
              "y": 40.65,
              "z": 0.446
            },
            "rightCorner": {
              "x": -2.146,
              "y": 40.648,
              "z": 0.446
            },
            "gtin": "4063367332449",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c875ed67a01d9a1f567",
            "leftCorner": {
              "x": -2.146,
              "y": 40.643,
              "z": 0.446
            },
            "rightCorner": {
              "x": -2.089,
              "y": 40.64,
              "z": 0.446
            },
            "gtin": "4260133234932",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c875ed67a01d9a1f568",
            "leftCorner": {
              "x": -2.089,
              "y": 40.648,
              "z": 0.446
            },
            "rightCorner": {
              "x": -2.036,
              "y": 40.646,
              "z": 0.446
            },
            "gtin": "4260133234864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f569",
            "leftCorner": {
              "x": -2.036,
              "y": 40.649,
              "z": 0.446
            },
            "rightCorner": {
              "x": -1.981,
              "y": 40.645,
              "z": 0.446
            },
            "gtin": "4260249144408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f56a",
            "leftCorner": {
              "x": -1.981,
              "y": 40.64,
              "z": 0.446
            },
            "rightCorner": {
              "x": -1.92,
              "y": 40.636,
              "z": 0.446
            },
            "gtin": "4260249144316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f56b",
            "leftCorner": {
              "x": -1.92,
              "y": 40.629,
              "z": 0.446
            },
            "rightCorner": {
              "x": -1.877,
              "y": 40.627,
              "z": 0.446
            },
            "gtin": "4251099706359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f56c",
            "leftCorner": {
              "x": -1.876,
              "y": 40.636,
              "z": 0.446
            },
            "rightCorner": {
              "x": -1.808,
              "y": 40.633,
              "z": 0.446
            },
            "gtin": "4251099706335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f56d",
            "leftCorner": {
              "x": -1.807,
              "y": 40.637,
              "z": 0.446
            },
            "rightCorner": {
              "x": -1.723,
              "y": 40.633,
              "z": 0.446
            },
            "gtin": "4260249146907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f56e",
            "leftCorner": {
              "x": -1.724,
              "y": 40.63,
              "z": 0.446
            },
            "rightCorner": {
              "x": -1.639,
              "y": 40.625,
              "z": 0.446
            },
            "gtin": "4062300419490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f56f",
            "leftCorner": {
              "x": -1.639,
              "y": 40.625,
              "z": 0.446
            },
            "rightCorner": {
              "x": -1.555,
              "y": 40.622,
              "z": 0.446
            },
            "gtin": "4062300419490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f570",
            "leftCorner": {
              "x": -1.555,
              "y": 40.622,
              "z": 0.446
            },
            "rightCorner": {
              "x": -1.47,
              "y": 40.617,
              "z": 0.446
            },
            "gtin": "4062300419490",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464d7",
        "height": 0.84662,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f57f",
            "leftCorner": {
              "x": -2.73,
              "y": 40.627,
              "z": 0.693
            },
            "rightCorner": {
              "x": -2.628,
              "y": 40.622,
              "z": 0.693
            },
            "gtin": "4062300362239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f580",
            "leftCorner": {
              "x": -2.628,
              "y": 40.622,
              "z": 0.693
            },
            "rightCorner": {
              "x": -2.525,
              "y": 40.616,
              "z": 0.693
            },
            "gtin": "4062300362239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f583",
            "leftCorner": {
              "x": -2.524,
              "y": 40.635,
              "z": 0.693
            },
            "rightCorner": {
              "x": -2.45,
              "y": 40.632,
              "z": 0.693
            },
            "gtin": "4062300446069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f584",
            "leftCorner": {
              "x": -2.45,
              "y": 40.639,
              "z": 0.693
            },
            "rightCorner": {
              "x": -2.364,
              "y": 40.634,
              "z": 0.693
            },
            "gtin": "42428435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f585",
            "leftCorner": {
              "x": -2.363,
              "y": 40.646,
              "z": 0.693
            },
            "rightCorner": {
              "x": -2.317,
              "y": 40.644,
              "z": 0.693
            },
            "gtin": "4018852026969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f586",
            "leftCorner": {
              "x": -2.317,
              "y": 40.644,
              "z": 0.693
            },
            "rightCorner": {
              "x": -2.271,
              "y": 40.642,
              "z": 0.693
            },
            "gtin": "4018852026969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f587",
            "leftCorner": {
              "x": -2.271,
              "y": 40.646,
              "z": 0.693
            },
            "rightCorner": {
              "x": -2.237,
              "y": 40.644,
              "z": 0.693
            },
            "gtin": "4063367330520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f588",
            "leftCorner": {
              "x": -2.237,
              "y": 40.644,
              "z": 0.693
            },
            "rightCorner": {
              "x": -2.204,
              "y": 40.643,
              "z": 0.693
            },
            "gtin": "4063367330520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f589",
            "leftCorner": {
              "x": -2.204,
              "y": 40.638,
              "z": 0.693
            },
            "rightCorner": {
              "x": -2.135,
              "y": 40.634,
              "z": 0.693
            },
            "gtin": "4063367330506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f58a",
            "leftCorner": {
              "x": -2.135,
              "y": 40.637,
              "z": 0.693
            },
            "rightCorner": {
              "x": -1.954,
              "y": 40.628,
              "z": 0.693
            },
            "gtin": "4260350925453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f58b",
            "leftCorner": {
              "x": -1.954,
              "y": 40.636,
              "z": 0.693
            },
            "rightCorner": {
              "x": -1.889,
              "y": 40.633,
              "z": 0.693
            },
            "gtin": "4260350925736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f58c",
            "leftCorner": {
              "x": -1.889,
              "y": 40.623,
              "z": 0.693
            },
            "rightCorner": {
              "x": -1.817,
              "y": 40.62,
              "z": 0.693
            },
            "gtin": "4260350926382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f58d",
            "leftCorner": {
              "x": -1.816,
              "y": 40.634,
              "z": 0.693
            },
            "rightCorner": {
              "x": -1.725,
              "y": 40.629,
              "z": 0.693
            },
            "gtin": "4260350925651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f58e",
            "leftCorner": {
              "x": -1.725,
              "y": 40.627,
              "z": 0.693
            },
            "rightCorner": {
              "x": -1.655,
              "y": 40.623,
              "z": 0.693
            },
            "gtin": "4260350925576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f58f",
            "leftCorner": {
              "x": -1.655,
              "y": 40.623,
              "z": 0.693
            },
            "rightCorner": {
              "x": -1.585,
              "y": 40.62,
              "z": 0.693
            },
            "gtin": "4260350925576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f590",
            "leftCorner": {
              "x": -1.585,
              "y": 40.628,
              "z": 0.693
            },
            "rightCorner": {
              "x": -1.46,
              "y": 40.621,
              "z": 0.693
            },
            "gtin": "4260350925552",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464d4",
        "height": 1.1526,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f52f",
            "leftCorner": {
              "x": -2.73,
              "y": 40.627,
              "z": 0.943
            },
            "rightCorner": {
              "x": -2.548,
              "y": 40.618,
              "z": 0.943
            },
            "gtin": "4260133232525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f531",
            "leftCorner": {
              "x": -2.546,
              "y": 40.636,
              "z": 0.943
            },
            "rightCorner": {
              "x": -2.405,
              "y": 40.629,
              "z": 0.943
            },
            "gtin": "4260133231870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f532",
            "leftCorner": {
              "x": -2.405,
              "y": 40.629,
              "z": 0.943
            },
            "rightCorner": {
              "x": -2.264,
              "y": 40.622,
              "z": 0.943
            },
            "gtin": "4260133231870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f533",
            "leftCorner": {
              "x": -2.264,
              "y": 40.622,
              "z": 0.943
            },
            "rightCorner": {
              "x": -2.122,
              "y": 40.615,
              "z": 0.943
            },
            "gtin": "4260133231870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f534",
            "leftCorner": {
              "x": -2.122,
              "y": 40.615,
              "z": 0.943
            },
            "rightCorner": {
              "x": -1.981,
              "y": 40.607,
              "z": 0.943
            },
            "gtin": "4260133231870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f535",
            "leftCorner": {
              "x": -1.98,
              "y": 40.629,
              "z": 0.943
            },
            "rightCorner": {
              "x": -1.809,
              "y": 40.62,
              "z": 0.943
            },
            "gtin": "4260133232501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f536",
            "leftCorner": {
              "x": -1.81,
              "y": 40.619,
              "z": 0.943
            },
            "rightCorner": {
              "x": -1.699,
              "y": 40.613,
              "z": 0.943
            },
            "gtin": "4260133232723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f537",
            "leftCorner": {
              "x": -1.699,
              "y": 40.621,
              "z": 0.943
            },
            "rightCorner": {
              "x": -1.651,
              "y": 40.619,
              "z": 0.943
            },
            "gtin": "4104060031908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f538",
            "leftCorner": {
              "x": -1.651,
              "y": 40.616,
              "z": 0.943
            },
            "rightCorner": {
              "x": -1.578,
              "y": 40.612,
              "z": 0.943
            },
            "gtin": "4104060031922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f539",
            "leftCorner": {
              "x": -1.578,
              "y": 40.613,
              "z": 0.943
            },
            "rightCorner": {
              "x": -1.501,
              "y": 40.608,
              "z": 0.943
            },
            "gtin": "4104060031915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f53a",
            "leftCorner": {
              "x": -1.501,
              "y": 40.608,
              "z": 0.943
            },
            "rightCorner": {
              "x": -1.424,
              "y": 40.604,
              "z": 0.943
            },
            "gtin": "4104060031915",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464d3",
        "height": 1.751,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f30e",
            "leftCorner": {
              "x": -2.728,
              "y": 40.675,
              "z": 1.433
            },
            "rightCorner": {
              "x": -2.674,
              "y": 40.672,
              "z": 1.433
            },
            "gtin": "4062300362260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f30f",
            "leftCorner": {
              "x": -2.674,
              "y": 40.656,
              "z": 1.433
            },
            "rightCorner": {
              "x": -2.565,
              "y": 40.651,
              "z": 1.433
            },
            "gtin": "4062300362260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f310",
            "leftCorner": {
              "x": -2.565,
              "y": 40.651,
              "z": 1.433
            },
            "rightCorner": {
              "x": -2.457,
              "y": 40.645,
              "z": 1.433
            },
            "gtin": "4062300362260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f311",
            "leftCorner": {
              "x": -2.457,
              "y": 40.634,
              "z": 1.433
            },
            "rightCorner": {
              "x": -2.339,
              "y": 40.628,
              "z": 1.433
            },
            "gtin": "4062300303430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f312",
            "leftCorner": {
              "x": -2.338,
              "y": 40.651,
              "z": 1.433
            },
            "rightCorner": {
              "x": -2.242,
              "y": 40.645,
              "z": 1.433
            },
            "gtin": "4062300278646",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f313",
            "leftCorner": {
              "x": -2.242,
              "y": 40.645,
              "z": 1.433
            },
            "rightCorner": {
              "x": -2.147,
              "y": 40.64,
              "z": 1.433
            },
            "gtin": "4062300278646",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f314",
            "leftCorner": {
              "x": -2.146,
              "y": 40.647,
              "z": 1.433
            },
            "rightCorner": {
              "x": -2.065,
              "y": 40.642,
              "z": 1.433
            },
            "gtin": "4062300343450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f315",
            "leftCorner": {
              "x": -2.065,
              "y": 40.642,
              "z": 1.433
            },
            "rightCorner": {
              "x": -1.983,
              "y": 40.638,
              "z": 1.433
            },
            "gtin": "4062300343450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f316",
            "leftCorner": {
              "x": -1.984,
              "y": 40.635,
              "z": 1.433
            },
            "rightCorner": {
              "x": -1.866,
              "y": 40.63,
              "z": 1.433
            },
            "gtin": "4062300462175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f317",
            "leftCorner": {
              "x": -1.866,
              "y": 40.63,
              "z": 1.433
            },
            "rightCorner": {
              "x": -1.748,
              "y": 40.623,
              "z": 1.433
            },
            "gtin": "4062300462175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f318",
            "leftCorner": {
              "x": -1.748,
              "y": 40.626,
              "z": 1.433
            },
            "rightCorner": {
              "x": -1.638,
              "y": 40.62,
              "z": 1.433
            },
            "gtin": "4062300450097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f319",
            "leftCorner": {
              "x": -1.638,
              "y": 40.62,
              "z": 1.433
            },
            "rightCorner": {
              "x": -1.528,
              "y": 40.614,
              "z": 1.433
            },
            "gtin": "4062300450097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f31a",
            "leftCorner": {
              "x": -1.528,
              "y": 40.61,
              "z": 1.433
            },
            "rightCorner": {
              "x": -1.441,
              "y": 40.605,
              "z": 1.433
            },
            "gtin": "4062300289437",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d9f83",
    "rightNeighborShelfId": "d9f85"
  },
  {
    "id": "d9f85",
    "name": "d9f85",
    "x": -1.483,
    "y": 40.549,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.026273,
      "w": 0.99965
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 75,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5464dc",
        "height": 0.15105,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f45a",
            "leftCorner": {
              "x": -1.369,
              "y": 40.587,
              "z": 0.124
            },
            "rightCorner": {
              "x": -1.239,
              "y": 40.58,
              "z": 0.124
            },
            "gtin": "7640417940013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f45b",
            "leftCorner": {
              "x": -1.239,
              "y": 40.575,
              "z": 0.124
            },
            "rightCorner": {
              "x": -1.114,
              "y": 40.569,
              "z": 0.124
            },
            "gtin": "4260453446374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f45c",
            "leftCorner": {
              "x": -1.114,
              "y": 40.569,
              "z": 0.124
            },
            "rightCorner": {
              "x": -0.989,
              "y": 40.562,
              "z": 0.124
            },
            "gtin": "4260453446374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f45d",
            "leftCorner": {
              "x": -0.988,
              "y": 40.571,
              "z": 0.124
            },
            "rightCorner": {
              "x": -0.813,
              "y": 40.561,
              "z": 0.124
            },
            "gtin": "7640417940020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f45e",
            "leftCorner": {
              "x": -0.813,
              "y": 40.561,
              "z": 0.124
            },
            "rightCorner": {
              "x": -0.637,
              "y": 40.553,
              "z": 0.124
            },
            "gtin": "7640417940020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f45f",
            "leftCorner": {
              "x": -0.638,
              "y": 40.534,
              "z": 0.124
            },
            "rightCorner": {
              "x": -0.436,
              "y": 40.523,
              "z": 0.124
            },
            "gtin": "7640417940297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f460",
            "leftCorner": {
              "x": -0.436,
              "y": 40.523,
              "z": 0.124
            },
            "rightCorner": {
              "x": -0.233,
              "y": 40.513,
              "z": 0.124
            },
            "gtin": "7640417940297",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464d9",
        "height": 0.54407,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f571",
            "leftCorner": {
              "x": -1.471,
              "y": 40.602,
              "z": 0.445
            },
            "rightCorner": {
              "x": -1.338,
              "y": 40.595,
              "z": 0.445
            },
            "gtin": "4260133233416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f572",
            "leftCorner": {
              "x": -1.338,
              "y": 40.595,
              "z": 0.445
            },
            "rightCorner": {
              "x": -1.205,
              "y": 40.588,
              "z": 0.445
            },
            "gtin": "4260133233416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f573",
            "leftCorner": {
              "x": -1.205,
              "y": 40.585,
              "z": 0.445
            },
            "rightCorner": {
              "x": -1.144,
              "y": 40.581,
              "z": 0.445
            },
            "gtin": "4260133231399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f574",
            "leftCorner": {
              "x": -1.144,
              "y": 40.581,
              "z": 0.445
            },
            "rightCorner": {
              "x": -1.083,
              "y": 40.578,
              "z": 0.445
            },
            "gtin": "4260133231399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f575",
            "leftCorner": {
              "x": -1.083,
              "y": 40.583,
              "z": 0.445
            },
            "rightCorner": {
              "x": -1.04,
              "y": 40.581,
              "z": 0.445
            },
            "gtin": "4260133233409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f576",
            "leftCorner": {
              "x": -1.04,
              "y": 40.581,
              "z": 0.445
            },
            "rightCorner": {
              "x": -0.997,
              "y": 40.578,
              "z": 0.445
            },
            "gtin": "4260133233409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f577",
            "leftCorner": {
              "x": -0.997,
              "y": 40.574,
              "z": 0.445
            },
            "rightCorner": {
              "x": -0.932,
              "y": 40.571,
              "z": 0.445
            },
            "gtin": "7640161879645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f578",
            "leftCorner": {
              "x": -0.932,
              "y": 40.571,
              "z": 0.445
            },
            "rightCorner": {
              "x": -0.868,
              "y": 40.568,
              "z": 0.445
            },
            "gtin": "7640161879645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f579",
            "leftCorner": {
              "x": -0.868,
              "y": 40.569,
              "z": 0.445
            },
            "rightCorner": {
              "x": -0.797,
              "y": 40.566,
              "z": 0.445
            },
            "gtin": "4063367330841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f57a",
            "leftCorner": {
              "x": -0.797,
              "y": 40.566,
              "z": 0.445
            },
            "rightCorner": {
              "x": -0.727,
              "y": 40.562,
              "z": 0.445
            },
            "gtin": "4063367330841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f57b",
            "leftCorner": {
              "x": -0.727,
              "y": 40.562,
              "z": 0.445
            },
            "rightCorner": {
              "x": -0.657,
              "y": 40.559,
              "z": 0.445
            },
            "gtin": "4063367330841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f57c",
            "leftCorner": {
              "x": -0.657,
              "y": 40.56,
              "z": 0.445
            },
            "rightCorner": {
              "x": -0.59,
              "y": 40.556,
              "z": 0.445
            },
            "gtin": "4063367330865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f57d",
            "leftCorner": {
              "x": -0.59,
              "y": 40.545,
              "z": 0.445
            },
            "rightCorner": {
              "x": -0.485,
              "y": 40.539,
              "z": 0.445
            },
            "gtin": "4063367574610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f57e",
            "leftCorner": {
              "x": -0.484,
              "y": 40.55,
              "z": 0.445
            },
            "rightCorner": {
              "x": -0.388,
              "y": 40.545,
              "z": 0.445
            },
            "gtin": "4260434141014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f55f",
            "leftCorner": {
              "x": -0.387,
              "y": 40.557,
              "z": 0.445
            },
            "rightCorner": {
              "x": -0.231,
              "y": 40.55,
              "z": 0.445
            },
            "gtin": "4260434141083",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464d8",
        "height": 0.84649,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f591",
            "leftCorner": {
              "x": -1.462,
              "y": 40.595,
              "z": 0.693
            },
            "rightCorner": {
              "x": -1.41,
              "y": 40.592,
              "z": 0.693
            },
            "gtin": "4260133234918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f592",
            "leftCorner": {
              "x": -1.41,
              "y": 40.592,
              "z": 0.693
            },
            "rightCorner": {
              "x": -1.358,
              "y": 40.589,
              "z": 0.693
            },
            "gtin": "4260133234918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f593",
            "leftCorner": {
              "x": -1.358,
              "y": 40.593,
              "z": 0.693
            },
            "rightCorner": {
              "x": -1.318,
              "y": 40.591,
              "z": 0.693
            },
            "gtin": "4260133233324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f594",
            "leftCorner": {
              "x": -1.318,
              "y": 40.591,
              "z": 0.693
            },
            "rightCorner": {
              "x": -1.279,
              "y": 40.589,
              "z": 0.693
            },
            "gtin": "4260133233324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f595",
            "leftCorner": {
              "x": -1.279,
              "y": 40.589,
              "z": 0.693
            },
            "rightCorner": {
              "x": -1.239,
              "y": 40.587,
              "z": 0.693
            },
            "gtin": "4260133233324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f596",
            "leftCorner": {
              "x": -1.24,
              "y": 40.571,
              "z": 0.693
            },
            "rightCorner": {
              "x": -1.19,
              "y": 40.569,
              "z": 0.693
            },
            "gtin": "4260133232402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f597",
            "leftCorner": {
              "x": -1.19,
              "y": 40.569,
              "z": 0.693
            },
            "rightCorner": {
              "x": -1.141,
              "y": 40.566,
              "z": 0.693
            },
            "gtin": "4260133232402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f598",
            "leftCorner": {
              "x": -1.141,
              "y": 40.565,
              "z": 0.693
            },
            "rightCorner": {
              "x": -1.074,
              "y": 40.562,
              "z": 0.693
            },
            "gtin": "4260133231290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f599",
            "leftCorner": {
              "x": -1.074,
              "y": 40.562,
              "z": 0.693
            },
            "rightCorner": {
              "x": -1.007,
              "y": 40.558,
              "z": 0.693
            },
            "gtin": "4260133231290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f59a",
            "leftCorner": {
              "x": -1.007,
              "y": 40.551,
              "z": 0.693
            },
            "rightCorner": {
              "x": -0.948,
              "y": 40.548,
              "z": 0.693
            },
            "gtin": "4260133230750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f59b",
            "leftCorner": {
              "x": -0.948,
              "y": 40.548,
              "z": 0.693
            },
            "rightCorner": {
              "x": -0.889,
              "y": 40.545,
              "z": 0.693
            },
            "gtin": "4260133230750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f59c",
            "leftCorner": {
              "x": -0.889,
              "y": 40.545,
              "z": 0.693
            },
            "rightCorner": {
              "x": -0.83,
              "y": 40.541,
              "z": 0.693
            },
            "gtin": "4260133230750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f59d",
            "leftCorner": {
              "x": -0.83,
              "y": 40.546,
              "z": 0.693
            },
            "rightCorner": {
              "x": -0.763,
              "y": 40.543,
              "z": 0.693
            },
            "gtin": "4260133231252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f59e",
            "leftCorner": {
              "x": -0.763,
              "y": 40.543,
              "z": 0.693
            },
            "rightCorner": {
              "x": -0.697,
              "y": 40.539,
              "z": 0.693
            },
            "gtin": "4260133231252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f59f",
            "leftCorner": {
              "x": -0.696,
              "y": 40.549,
              "z": 0.693
            },
            "rightCorner": {
              "x": -0.641,
              "y": 40.546,
              "z": 0.693
            },
            "gtin": "4260133232754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f5a0",
            "leftCorner": {
              "x": -0.641,
              "y": 40.546,
              "z": 0.693
            },
            "rightCorner": {
              "x": -0.585,
              "y": 40.543,
              "z": 0.693
            },
            "gtin": "4260133232754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f5a1",
            "leftCorner": {
              "x": -0.585,
              "y": 40.545,
              "z": 0.693
            },
            "rightCorner": {
              "x": -0.489,
              "y": 40.54,
              "z": 0.693
            },
            "gtin": "4062300399518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f5a2",
            "leftCorner": {
              "x": -0.489,
              "y": 40.54,
              "z": 0.693
            },
            "rightCorner": {
              "x": -0.394,
              "y": 40.534,
              "z": 0.693
            },
            "gtin": "4062300399518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f5a3",
            "leftCorner": {
              "x": -0.394,
              "y": 40.534,
              "z": 0.693
            },
            "rightCorner": {
              "x": -0.298,
              "y": 40.53,
              "z": 0.693
            },
            "gtin": "4062300399518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f5a4",
            "leftCorner": {
              "x": -0.298,
              "y": 40.53,
              "z": 0.693
            },
            "rightCorner": {
              "x": -0.203,
              "y": 40.525,
              "z": 0.693
            },
            "gtin": "4062300399518",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464db",
        "height": 1.1496,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f53b",
            "leftCorner": {
              "x": -1.426,
              "y": 40.586,
              "z": 0.941
            },
            "rightCorner": {
              "x": -1.302,
              "y": 40.579,
              "z": 0.941
            },
            "gtin": "4062300376199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f53c",
            "leftCorner": {
              "x": -1.302,
              "y": 40.579,
              "z": 0.941
            },
            "rightCorner": {
              "x": -1.179,
              "y": 40.573,
              "z": 0.941
            },
            "gtin": "4062300376199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f53d",
            "leftCorner": {
              "x": -1.179,
              "y": 40.571,
              "z": 0.941
            },
            "rightCorner": {
              "x": -0.95,
              "y": 40.559,
              "z": 0.941
            },
            "gtin": "4062300376182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f53e",
            "leftCorner": {
              "x": -0.95,
              "y": 40.559,
              "z": 0.941
            },
            "rightCorner": {
              "x": -0.721,
              "y": 40.547,
              "z": 0.941
            },
            "gtin": "4062300376182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f53f",
            "leftCorner": {
              "x": -0.721,
              "y": 40.556,
              "z": 0.941
            },
            "rightCorner": {
              "x": -0.627,
              "y": 40.551,
              "z": 0.941
            },
            "gtin": "4062300376205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f540",
            "leftCorner": {
              "x": -0.627,
              "y": 40.551,
              "z": 0.941
            },
            "rightCorner": {
              "x": -0.532,
              "y": 40.547,
              "z": 0.941
            },
            "gtin": "4062300376205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f541",
            "leftCorner": {
              "x": -0.533,
              "y": 40.545,
              "z": 0.941
            },
            "rightCorner": {
              "x": -0.465,
              "y": 40.541,
              "z": 0.941
            },
            "gtin": "4062300429710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f542",
            "leftCorner": {
              "x": -0.465,
              "y": 40.541,
              "z": 0.941
            },
            "rightCorner": {
              "x": -0.398,
              "y": 40.538,
              "z": 0.941
            },
            "gtin": "4062300429710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f543",
            "leftCorner": {
              "x": -0.398,
              "y": 40.538,
              "z": 0.941
            },
            "rightCorner": {
              "x": -0.331,
              "y": 40.534,
              "z": 0.941
            },
            "gtin": "4062300429710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f544",
            "leftCorner": {
              "x": -0.331,
              "y": 40.534,
              "z": 0.941
            },
            "rightCorner": {
              "x": -0.263,
              "y": 40.53,
              "z": 0.941
            },
            "gtin": "4062300429710",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464dd",
        "height": 1.4541,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f5b7",
            "leftCorner": {
              "x": -1.483,
              "y": 40.551,
              "z": 1.19
            },
            "rightCorner": {
              "x": -1.355,
              "y": 40.544,
              "z": 1.19
            },
            "gtin": "4260133236325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5b8",
            "leftCorner": {
              "x": -1.355,
              "y": 40.544,
              "z": 1.19
            },
            "rightCorner": {
              "x": -1.228,
              "y": 40.538,
              "z": 1.19
            },
            "gtin": "4260133236325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5b9",
            "leftCorner": {
              "x": -1.228,
              "y": 40.538,
              "z": 1.19
            },
            "rightCorner": {
              "x": -1.1,
              "y": 40.531,
              "z": 1.19
            },
            "gtin": "4260133236325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5bb",
            "leftCorner": {
              "x": -1.098,
              "y": 40.578,
              "z": 1.19
            },
            "rightCorner": {
              "x": -0.921,
              "y": 40.569,
              "z": 1.19
            },
            "gtin": "4260133232341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5bc",
            "leftCorner": {
              "x": -0.921,
              "y": 40.561,
              "z": 1.19
            },
            "rightCorner": {
              "x": -0.844,
              "y": 40.557,
              "z": 1.19
            },
            "gtin": "4009176340930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5bd",
            "leftCorner": {
              "x": -0.844,
              "y": 40.557,
              "z": 1.19
            },
            "rightCorner": {
              "x": -0.766,
              "y": 40.553,
              "z": 1.19
            },
            "gtin": "4009176340930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5be",
            "leftCorner": {
              "x": -0.766,
              "y": 40.554,
              "z": 1.19
            },
            "rightCorner": {
              "x": -0.65,
              "y": 40.547,
              "z": 1.19
            },
            "gtin": "4062300399570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5bf",
            "leftCorner": {
              "x": -0.65,
              "y": 40.547,
              "z": 1.19
            },
            "rightCorner": {
              "x": -0.534,
              "y": 40.541,
              "z": 1.19
            },
            "gtin": "4062300399570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5c0",
            "leftCorner": {
              "x": -0.534,
              "y": 40.541,
              "z": 1.19
            },
            "rightCorner": {
              "x": -0.418,
              "y": 40.536,
              "z": 1.19
            },
            "gtin": "4062300399570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5c1",
            "leftCorner": {
              "x": -0.419,
              "y": 40.512,
              "z": 1.19
            },
            "rightCorner": {
              "x": -0.31,
              "y": 40.506,
              "z": 1.19
            },
            "gtin": "4260133234727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5c2",
            "leftCorner": {
              "x": -0.31,
              "y": 40.506,
              "z": 1.19
            },
            "rightCorner": {
              "x": -0.201,
              "y": 40.5,
              "z": 1.19
            },
            "gtin": "4260133234727",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464da",
        "height": 1.7531,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f31b",
            "leftCorner": {
              "x": -1.442,
              "y": 40.586,
              "z": 1.434
            },
            "rightCorner": {
              "x": -1.367,
              "y": 40.583,
              "z": 1.434
            },
            "gtin": "4260133234550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f31c",
            "leftCorner": {
              "x": -1.367,
              "y": 40.583,
              "z": 1.434
            },
            "rightCorner": {
              "x": -1.293,
              "y": 40.579,
              "z": 1.434
            },
            "gtin": "4260133234550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f31d",
            "leftCorner": {
              "x": -1.293,
              "y": 40.581,
              "z": 1.434
            },
            "rightCorner": {
              "x": -1.218,
              "y": 40.577,
              "z": 1.434
            },
            "gtin": "4260133236127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f31e",
            "leftCorner": {
              "x": -1.218,
              "y": 40.577,
              "z": 1.434
            },
            "rightCorner": {
              "x": -1.143,
              "y": 40.572,
              "z": 1.434
            },
            "gtin": "4260133236127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f31f",
            "leftCorner": {
              "x": -1.143,
              "y": 40.572,
              "z": 1.434
            },
            "rightCorner": {
              "x": -1.068,
              "y": 40.568,
              "z": 1.434
            },
            "gtin": "4260133236127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f320",
            "leftCorner": {
              "x": -1.068,
              "y": 40.568,
              "z": 1.434
            },
            "rightCorner": {
              "x": -0.993,
              "y": 40.564,
              "z": 1.434
            },
            "gtin": "4260133236127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f321",
            "leftCorner": {
              "x": -0.993,
              "y": 40.564,
              "z": 1.434
            },
            "rightCorner": {
              "x": -0.835,
              "y": 40.556,
              "z": 1.434
            },
            "gtin": "4260133232259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f322",
            "leftCorner": {
              "x": -0.835,
              "y": 40.556,
              "z": 1.434
            },
            "rightCorner": {
              "x": -0.676,
              "y": 40.548,
              "z": 1.434
            },
            "gtin": "4260133232259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f323",
            "leftCorner": {
              "x": -0.676,
              "y": 40.547,
              "z": 1.434
            },
            "rightCorner": {
              "x": -0.529,
              "y": 40.54,
              "z": 1.434
            },
            "gtin": "4260133236400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f324",
            "leftCorner": {
              "x": -0.529,
              "y": 40.54,
              "z": 1.434
            },
            "rightCorner": {
              "x": -0.381,
              "y": 40.532,
              "z": 1.434
            },
            "gtin": "4260133236400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f325",
            "leftCorner": {
              "x": -0.382,
              "y": 40.517,
              "z": 1.434
            },
            "rightCorner": {
              "x": -0.313,
              "y": 40.514,
              "z": 1.434
            },
            "gtin": "4260133236387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f326",
            "leftCorner": {
              "x": -0.313,
              "y": 40.514,
              "z": 1.434
            },
            "rightCorner": {
              "x": -0.244,
              "y": 40.51,
              "z": 1.434
            },
            "gtin": "4260133236387",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d9f84",
    "rightNeighborShelfId": "d9f86"
  },
  {
    "id": "d9f86",
    "name": "d9f86",
    "x": -0.235,
    "y": 40.484,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.026273,
      "w": 0.99965
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 54,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5464e7",
        "height": 0.1512,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f461",
            "leftCorner": {
              "x": -0.233,
              "y": 40.517,
              "z": 0.124
            },
            "rightCorner": {
              "x": -0.149,
              "y": 40.513,
              "z": 0.124
            },
            "gtin": "4063367323102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f462",
            "leftCorner": {
              "x": -0.149,
              "y": 40.513,
              "z": 0.124
            },
            "rightCorner": {
              "x": -0.064,
              "y": 40.51,
              "z": 0.124
            },
            "gtin": "4063367323102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f463",
            "leftCorner": {
              "x": -0.064,
              "y": 40.512,
              "z": 0.124
            },
            "rightCorner": {
              "x": 0.102,
              "y": 40.503,
              "z": 0.124
            },
            "gtin": "4063367323102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f464",
            "leftCorner": {
              "x": 0.102,
              "y": 40.494,
              "z": 0.124
            },
            "rightCorner": {
              "x": 0.234,
              "y": 40.487,
              "z": 0.124
            },
            "gtin": "4063367322600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f465",
            "leftCorner": {
              "x": 0.234,
              "y": 40.487,
              "z": 0.124
            },
            "rightCorner": {
              "x": 0.367,
              "y": 40.479,
              "z": 0.124
            },
            "gtin": "4063367322600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f466",
            "leftCorner": {
              "x": 0.368,
              "y": 40.51,
              "z": 0.124
            },
            "rightCorner": {
              "x": 0.515,
              "y": 40.503,
              "z": 0.124
            },
            "gtin": "4009176340954",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f467",
            "leftCorner": {
              "x": 0.515,
              "y": 40.502,
              "z": 0.124
            },
            "rightCorner": {
              "x": 0.813,
              "y": 40.486,
              "z": 0.124
            },
            "gtin": "4063367382901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f468",
            "leftCorner": {
              "x": 0.812,
              "y": 40.477,
              "z": 0.124
            },
            "rightCorner": {
              "x": 0.902,
              "y": 40.472,
              "z": 0.124
            },
            "gtin": "4063367382925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f469",
            "leftCorner": {
              "x": 0.902,
              "y": 40.472,
              "z": 0.124
            },
            "rightCorner": {
              "x": 0.992,
              "y": 40.467,
              "z": 0.124
            },
            "gtin": "4063367382925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f46a",
            "leftCorner": {
              "x": 0.992,
              "y": 40.467,
              "z": 0.124
            },
            "rightCorner": {
              "x": 1.081,
              "y": 40.462,
              "z": 0.124
            },
            "gtin": "4063367382925",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464e2",
        "height": 0.60362,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f68d",
            "leftCorner": {
              "x": -0.235,
              "y": 40.482,
              "z": 0.494
            },
            "rightCorner": {
              "x": -0.085,
              "y": 40.473,
              "z": 0.494
            },
            "gtin": "4018852036845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f68e",
            "leftCorner": {
              "x": -0.085,
              "y": 40.473,
              "z": 0.494
            },
            "rightCorner": {
              "x": 0.065,
              "y": 40.466,
              "z": 0.494
            },
            "gtin": "4018852036845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f690",
            "leftCorner": {
              "x": 0.067,
              "y": 40.503,
              "z": 0.494
            },
            "rightCorner": {
              "x": 0.141,
              "y": 40.499,
              "z": 0.494
            },
            "gtin": "4018852030072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f691",
            "leftCorner": {
              "x": 0.141,
              "y": 40.499,
              "z": 0.494
            },
            "rightCorner": {
              "x": 0.216,
              "y": 40.495,
              "z": 0.494
            },
            "gtin": "4018852030072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f692",
            "leftCorner": {
              "x": 0.216,
              "y": 40.5,
              "z": 0.494
            },
            "rightCorner": {
              "x": 0.337,
              "y": 40.494,
              "z": 0.494
            },
            "gtin": "4018852029526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f693",
            "leftCorner": {
              "x": 0.337,
              "y": 40.488,
              "z": 0.494
            },
            "rightCorner": {
              "x": 0.419,
              "y": 40.484,
              "z": 0.494
            },
            "gtin": "4018852026914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f694",
            "leftCorner": {
              "x": 0.419,
              "y": 40.484,
              "z": 0.494
            },
            "rightCorner": {
              "x": 0.5,
              "y": 40.48,
              "z": 0.494
            },
            "gtin": "4018852026914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f695",
            "leftCorner": {
              "x": 0.5,
              "y": 40.48,
              "z": 0.494
            },
            "rightCorner": {
              "x": 0.582,
              "y": 40.475,
              "z": 0.494
            },
            "gtin": "4018852026914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f696",
            "leftCorner": {
              "x": 0.582,
              "y": 40.481,
              "z": 0.494
            },
            "rightCorner": {
              "x": 0.691,
              "y": 40.475,
              "z": 0.494
            },
            "gtin": "4018852030201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f697",
            "leftCorner": {
              "x": 0.691,
              "y": 40.475,
              "z": 0.494
            },
            "rightCorner": {
              "x": 0.799,
              "y": 40.469,
              "z": 0.494
            },
            "gtin": "4018852030201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f698",
            "leftCorner": {
              "x": 0.8,
              "y": 40.482,
              "z": 0.494
            },
            "rightCorner": {
              "x": 1.068,
              "y": 40.469,
              "z": 0.494
            },
            "gtin": "4018852030348",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464e3",
        "height": 0.85324,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f5a5",
            "leftCorner": {
              "x": -0.204,
              "y": 40.507,
              "z": 0.698
            },
            "rightCorner": {
              "x": 0.066,
              "y": 40.493,
              "z": 0.698
            },
            "gtin": "4018852021117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f5a6",
            "leftCorner": {
              "x": 0.066,
              "y": 40.493,
              "z": 0.698
            },
            "rightCorner": {
              "x": 0.336,
              "y": 40.479,
              "z": 0.698
            },
            "gtin": "4018852021117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f5a7",
            "leftCorner": {
              "x": 0.336,
              "y": 40.473,
              "z": 0.698
            },
            "rightCorner": {
              "x": 0.463,
              "y": 40.466,
              "z": 0.698
            },
            "gtin": "4018852033745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f5a8",
            "leftCorner": {
              "x": 0.463,
              "y": 40.466,
              "z": 0.698
            },
            "rightCorner": {
              "x": 0.59,
              "y": 40.46,
              "z": 0.698
            },
            "gtin": "4018852033745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f5a9",
            "leftCorner": {
              "x": 0.591,
              "y": 40.484,
              "z": 0.698
            },
            "rightCorner": {
              "x": 0.836,
              "y": 40.471,
              "z": 0.698
            },
            "gtin": "4018852033462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f5aa",
            "leftCorner": {
              "x": 0.836,
              "y": 40.471,
              "z": 0.698
            },
            "rightCorner": {
              "x": 1.08,
              "y": 40.458,
              "z": 0.698
            },
            "gtin": "4018852033462",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464e4",
        "height": 1.1527,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f545",
            "leftCorner": {
              "x": -0.265,
              "y": 40.502,
              "z": 0.943
            },
            "rightCorner": {
              "x": -0.047,
              "y": 40.491,
              "z": 0.943
            },
            "gtin": "4018852029762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f546",
            "leftCorner": {
              "x": -0.047,
              "y": 40.491,
              "z": 0.943
            },
            "rightCorner": {
              "x": 0.171,
              "y": 40.479,
              "z": 0.943
            },
            "gtin": "4018852029762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f547",
            "leftCorner": {
              "x": 0.171,
              "y": 40.479,
              "z": 0.943
            },
            "rightCorner": {
              "x": 0.39,
              "y": 40.468,
              "z": 0.943
            },
            "gtin": "4018852029762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f548",
            "leftCorner": {
              "x": 0.391,
              "y": 40.493,
              "z": 0.943
            },
            "rightCorner": {
              "x": 0.597,
              "y": 40.482,
              "z": 0.943
            },
            "gtin": "4062300437159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f549",
            "leftCorner": {
              "x": 0.597,
              "y": 40.482,
              "z": 0.943
            },
            "rightCorner": {
              "x": 0.804,
              "y": 40.471,
              "z": 0.943
            },
            "gtin": "4062300437159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f54a",
            "leftCorner": {
              "x": 0.804,
              "y": 40.465,
              "z": 0.943
            },
            "rightCorner": {
              "x": 0.909,
              "y": 40.46,
              "z": 0.943
            },
            "gtin": "4018852021063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f54b",
            "leftCorner": {
              "x": 0.909,
              "y": 40.46,
              "z": 0.943
            },
            "rightCorner": {
              "x": 1.015,
              "y": 40.454,
              "z": 0.943
            },
            "gtin": "4018852021063",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464e6",
        "height": 1.4536,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f5c3",
            "leftCorner": {
              "x": -0.201,
              "y": 40.502,
              "z": 1.189
            },
            "rightCorner": {
              "x": -0.088,
              "y": 40.496,
              "z": 1.189
            },
            "gtin": "7640230491143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5c4",
            "leftCorner": {
              "x": -0.088,
              "y": 40.497,
              "z": 1.189
            },
            "rightCorner": {
              "x": 0.045,
              "y": 40.49,
              "z": 1.189
            },
            "gtin": "7640230493253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5c5",
            "leftCorner": {
              "x": 0.045,
              "y": 40.495,
              "z": 1.189
            },
            "rightCorner": {
              "x": 0.207,
              "y": 40.487,
              "z": 1.189
            },
            "gtin": "7640230491877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5c6",
            "leftCorner": {
              "x": 0.207,
              "y": 40.494,
              "z": 1.189
            },
            "rightCorner": {
              "x": 0.328,
              "y": 40.487,
              "z": 1.189
            },
            "gtin": "7640230492010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5c7",
            "leftCorner": {
              "x": 0.329,
              "y": 40.509,
              "z": 1.189
            },
            "rightCorner": {
              "x": 0.452,
              "y": 40.503,
              "z": 1.189
            },
            "gtin": "7640104951308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5c8",
            "leftCorner": {
              "x": 0.453,
              "y": 40.508,
              "z": 1.189
            },
            "rightCorner": {
              "x": 0.591,
              "y": 40.5,
              "z": 1.189
            },
            "gtin": "7640104951247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5c9",
            "leftCorner": {
              "x": 0.59,
              "y": 40.477,
              "z": 1.189
            },
            "rightCorner": {
              "x": 0.684,
              "y": 40.473,
              "z": 1.189
            },
            "gtin": "7640230492409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5ca",
            "leftCorner": {
              "x": 0.684,
              "y": 40.473,
              "z": 1.189
            },
            "rightCorner": {
              "x": 0.778,
              "y": 40.467,
              "z": 1.189
            },
            "gtin": "7640230492409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5cb",
            "leftCorner": {
              "x": 0.778,
              "y": 40.473,
              "z": 1.189
            },
            "rightCorner": {
              "x": 0.92,
              "y": 40.466,
              "z": 1.189
            },
            "gtin": "7640230492423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5cc",
            "leftCorner": {
              "x": 0.92,
              "y": 40.466,
              "z": 1.189
            },
            "rightCorner": {
              "x": 1.062,
              "y": 40.458,
              "z": 1.189
            },
            "gtin": "7640230492423",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464e5",
        "height": 1.7534,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f327",
            "leftCorner": {
              "x": -0.244,
              "y": 40.5,
              "z": 1.435
            },
            "rightCorner": {
              "x": -0.061,
              "y": 40.49,
              "z": 1.435
            },
            "gtin": "4031244004291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f328",
            "leftCorner": {
              "x": -0.061,
              "y": 40.49,
              "z": 1.435
            },
            "rightCorner": {
              "x": 0.122,
              "y": 40.481,
              "z": 1.435
            },
            "gtin": "4031244004291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f329",
            "leftCorner": {
              "x": 0.122,
              "y": 40.481,
              "z": 1.435
            },
            "rightCorner": {
              "x": 0.306,
              "y": 40.471,
              "z": 1.435
            },
            "gtin": "4031244004291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f32a",
            "leftCorner": {
              "x": 0.306,
              "y": 40.485,
              "z": 1.435
            },
            "rightCorner": {
              "x": 0.43,
              "y": 40.479,
              "z": 1.435
            },
            "gtin": "4031244004239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f32b",
            "leftCorner": {
              "x": 0.43,
              "y": 40.479,
              "z": 1.435
            },
            "rightCorner": {
              "x": 0.554,
              "y": 40.472,
              "z": 1.435
            },
            "gtin": "4031244004239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f32c",
            "leftCorner": {
              "x": 0.553,
              "y": 40.461,
              "z": 1.435
            },
            "rightCorner": {
              "x": 0.648,
              "y": 40.457,
              "z": 1.435
            },
            "gtin": "4031244004178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f32d",
            "leftCorner": {
              "x": 0.648,
              "y": 40.457,
              "z": 1.435
            },
            "rightCorner": {
              "x": 0.742,
              "y": 40.452,
              "z": 1.435
            },
            "gtin": "4031244004178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f32e",
            "leftCorner": {
              "x": 0.742,
              "y": 40.457,
              "z": 1.435
            },
            "rightCorner": {
              "x": 0.812,
              "y": 40.453,
              "z": 1.435
            },
            "gtin": "7640161879829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f32f",
            "leftCorner": {
              "x": 0.812,
              "y": 40.453,
              "z": 1.435
            },
            "rightCorner": {
              "x": 0.883,
              "y": 40.45,
              "z": 1.435
            },
            "gtin": "7640161879829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f330",
            "leftCorner": {
              "x": 0.883,
              "y": 40.455,
              "z": 1.435
            },
            "rightCorner": {
              "x": 1.02,
              "y": 40.448,
              "z": 1.435
            },
            "gtin": "7640230491068",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d9f85",
    "rightNeighborShelfId": "d9f87"
  },
  {
    "id": "d9f87",
    "name": "d9f87",
    "x": 1.014,
    "y": 40.418,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.026273,
      "w": 0.99965
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 56,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5464ed",
        "height": 0.15371,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f46b",
            "leftCorner": {
              "x": 1.082,
              "y": 40.465,
              "z": 0.126
            },
            "rightCorner": {
              "x": 1.188,
              "y": 40.46,
              "z": 0.126
            },
            "gtin": "4063367354694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f46c",
            "leftCorner": {
              "x": 1.188,
              "y": 40.46,
              "z": 0.126
            },
            "rightCorner": {
              "x": 1.293,
              "y": 40.454,
              "z": 0.126
            },
            "gtin": "4063367354694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f46d",
            "leftCorner": {
              "x": 1.293,
              "y": 40.451,
              "z": 0.126
            },
            "rightCorner": {
              "x": 1.45,
              "y": 40.443,
              "z": 0.126
            },
            "gtin": "4000540002508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f46e",
            "leftCorner": {
              "x": 1.45,
              "y": 40.445,
              "z": 0.126
            },
            "rightCorner": {
              "x": 1.561,
              "y": 40.439,
              "z": 0.126
            },
            "gtin": "4000540002560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f46f",
            "leftCorner": {
              "x": 1.561,
              "y": 40.434,
              "z": 0.126
            },
            "rightCorner": {
              "x": 1.63,
              "y": 40.43,
              "z": 0.126
            },
            "gtin": "4000540002546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f470",
            "leftCorner": {
              "x": 1.63,
              "y": 40.421,
              "z": 0.126
            },
            "rightCorner": {
              "x": 1.757,
              "y": 40.415,
              "z": 0.126
            },
            "gtin": "4008976091271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f471",
            "leftCorner": {
              "x": 1.757,
              "y": 40.415,
              "z": 0.126
            },
            "rightCorner": {
              "x": 1.884,
              "y": 40.408,
              "z": 0.126
            },
            "gtin": "4008976091271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f472",
            "leftCorner": {
              "x": 1.884,
              "y": 40.42,
              "z": 0.126
            },
            "rightCorner": {
              "x": 1.973,
              "y": 40.415,
              "z": 0.126
            },
            "gtin": "4056631002735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f473",
            "leftCorner": {
              "x": 1.973,
              "y": 40.415,
              "z": 0.126
            },
            "rightCorner": {
              "x": 2.061,
              "y": 40.41,
              "z": 0.126
            },
            "gtin": "4056631002735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f474",
            "leftCorner": {
              "x": 2.062,
              "y": 40.414,
              "z": 0.126
            },
            "rightCorner": {
              "x": 2.387,
              "y": 40.397,
              "z": 0.126
            },
            "gtin": "4056631002834",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464eb",
        "height": 0.60352,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f699",
            "leftCorner": {
              "x": 1.069,
              "y": 40.472,
              "z": 0.494
            },
            "rightCorner": {
              "x": 1.208,
              "y": 40.465,
              "z": 0.494
            },
            "gtin": "4062300392366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f69a",
            "leftCorner": {
              "x": 1.208,
              "y": 40.465,
              "z": 0.494
            },
            "rightCorner": {
              "x": 1.347,
              "y": 40.457,
              "z": 0.494
            },
            "gtin": "4062300392366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f69b",
            "leftCorner": {
              "x": 1.347,
              "y": 40.464,
              "z": 0.494
            },
            "rightCorner": {
              "x": 1.481,
              "y": 40.457,
              "z": 0.494
            },
            "gtin": "4062300392243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f69c",
            "leftCorner": {
              "x": 1.481,
              "y": 40.452,
              "z": 0.494
            },
            "rightCorner": {
              "x": 1.59,
              "y": 40.446,
              "z": 0.494
            },
            "gtin": "4062300392335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f69d",
            "leftCorner": {
              "x": 1.59,
              "y": 40.444,
              "z": 0.494
            },
            "rightCorner": {
              "x": 1.714,
              "y": 40.438,
              "z": 0.494
            },
            "gtin": "4062300392397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f69e",
            "leftCorner": {
              "x": 1.714,
              "y": 40.438,
              "z": 0.494
            },
            "rightCorner": {
              "x": 1.838,
              "y": 40.431,
              "z": 0.494
            },
            "gtin": "4062300392397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f69f",
            "leftCorner": {
              "x": 1.837,
              "y": 40.426,
              "z": 0.494
            },
            "rightCorner": {
              "x": 2.019,
              "y": 40.417,
              "z": 0.494
            },
            "gtin": "4062300392274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6a0",
            "leftCorner": {
              "x": 2.019,
              "y": 40.417,
              "z": 0.494
            },
            "rightCorner": {
              "x": 2.136,
              "y": 40.41,
              "z": 0.494
            },
            "gtin": "4062300344877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6a1",
            "leftCorner": {
              "x": 2.136,
              "y": 40.41,
              "z": 0.494
            },
            "rightCorner": {
              "x": 2.253,
              "y": 40.404,
              "z": 0.494
            },
            "gtin": "4062300344877",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464ea",
        "height": 0.85671,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f5ab",
            "leftCorner": {
              "x": 1.081,
              "y": 40.462,
              "z": 0.701
            },
            "rightCorner": {
              "x": 1.221,
              "y": 40.454,
              "z": 0.701
            },
            "gtin": "4062300464261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f5ac",
            "leftCorner": {
              "x": 1.221,
              "y": 40.461,
              "z": 0.701
            },
            "rightCorner": {
              "x": 1.387,
              "y": 40.452,
              "z": 0.701
            },
            "gtin": "4062300343108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f5ad",
            "leftCorner": {
              "x": 1.386,
              "y": 40.447,
              "z": 0.701
            },
            "rightCorner": {
              "x": 1.491,
              "y": 40.442,
              "z": 0.701
            },
            "gtin": "4062300294523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f5ae",
            "leftCorner": {
              "x": 1.491,
              "y": 40.445,
              "z": 0.701
            },
            "rightCorner": {
              "x": 1.73,
              "y": 40.432,
              "z": 0.701
            },
            "gtin": "4062300294585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f5af",
            "leftCorner": {
              "x": 1.73,
              "y": 40.426,
              "z": 0.701
            },
            "rightCorner": {
              "x": 1.87,
              "y": 40.419,
              "z": 0.701
            },
            "gtin": "4062300433939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f5b0",
            "leftCorner": {
              "x": 1.87,
              "y": 40.422,
              "z": 0.701
            },
            "rightCorner": {
              "x": 2.019,
              "y": 40.414,
              "z": 0.701
            },
            "gtin": "4062300367890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f5b1",
            "leftCorner": {
              "x": 2.018,
              "y": 40.397,
              "z": 0.701
            },
            "rightCorner": {
              "x": 2.171,
              "y": 40.389,
              "z": 0.701
            },
            "gtin": "4062300378391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f5b2",
            "leftCorner": {
              "x": 2.172,
              "y": 40.404,
              "z": 0.701
            },
            "rightCorner": {
              "x": 2.312,
              "y": 40.397,
              "z": 0.701
            },
            "gtin": "4062300256385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f5b3",
            "leftCorner": {
              "x": 2.312,
              "y": 40.397,
              "z": 0.701
            },
            "rightCorner": {
              "x": 2.451,
              "y": 40.39,
              "z": 0.701
            },
            "gtin": "4062300256385",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464ec",
        "height": 1.1572,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f54c",
            "leftCorner": {
              "x": 1.016,
              "y": 40.457,
              "z": 0.947
            },
            "rightCorner": {
              "x": 1.107,
              "y": 40.451,
              "z": 0.947
            },
            "gtin": "4062300392212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f54d",
            "leftCorner": {
              "x": 1.107,
              "y": 40.451,
              "z": 0.947
            },
            "rightCorner": {
              "x": 1.219,
              "y": 40.445,
              "z": 0.947
            },
            "gtin": "4062300392212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f54e",
            "leftCorner": {
              "x": 1.22,
              "y": 40.456,
              "z": 0.947
            },
            "rightCorner": {
              "x": 1.426,
              "y": 40.445,
              "z": 0.947
            },
            "gtin": "4062300414310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f54f",
            "leftCorner": {
              "x": 1.425,
              "y": 40.442,
              "z": 0.947
            },
            "rightCorner": {
              "x": 1.565,
              "y": 40.435,
              "z": 0.947
            },
            "gtin": "4062300414327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f550",
            "leftCorner": {
              "x": 1.565,
              "y": 40.435,
              "z": 0.947
            },
            "rightCorner": {
              "x": 1.704,
              "y": 40.427,
              "z": 0.947
            },
            "gtin": "4062300414327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f551",
            "leftCorner": {
              "x": 1.704,
              "y": 40.417,
              "z": 0.947
            },
            "rightCorner": {
              "x": 1.882,
              "y": 40.408,
              "z": 0.947
            },
            "gtin": "4062300355422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f552",
            "leftCorner": {
              "x": 1.882,
              "y": 40.408,
              "z": 0.947
            },
            "rightCorner": {
              "x": 2.061,
              "y": 40.398,
              "z": 0.947
            },
            "gtin": "4062300355422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f553",
            "leftCorner": {
              "x": 2.062,
              "y": 40.41,
              "z": 0.947
            },
            "rightCorner": {
              "x": 2.303,
              "y": 40.399,
              "z": 0.947
            },
            "gtin": "4062300355439",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464e9",
        "height": 1.4597,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f5cd",
            "leftCorner": {
              "x": 1.062,
              "y": 40.46,
              "z": 1.194
            },
            "rightCorner": {
              "x": 1.195,
              "y": 40.453,
              "z": 1.194
            },
            "gtin": "4062300398900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5ce",
            "leftCorner": {
              "x": 1.195,
              "y": 40.453,
              "z": 1.194
            },
            "rightCorner": {
              "x": 1.328,
              "y": 40.446,
              "z": 1.194
            },
            "gtin": "4062300398900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5cf",
            "leftCorner": {
              "x": 1.328,
              "y": 40.447,
              "z": 1.194
            },
            "rightCorner": {
              "x": 1.724,
              "y": 40.426,
              "z": 1.194
            },
            "gtin": "4062300398917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5d0",
            "leftCorner": {
              "x": 1.723,
              "y": 40.408,
              "z": 1.194
            },
            "rightCorner": {
              "x": 1.814,
              "y": 40.403,
              "z": 1.194
            },
            "gtin": "4062300398894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5d1",
            "leftCorner": {
              "x": 1.814,
              "y": 40.403,
              "z": 1.194
            },
            "rightCorner": {
              "x": 1.906,
              "y": 40.399,
              "z": 1.194
            },
            "gtin": "4062300398894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5d2",
            "leftCorner": {
              "x": 1.907,
              "y": 40.419,
              "z": 1.194
            },
            "rightCorner": {
              "x": 2.156,
              "y": 40.405,
              "z": 1.194
            },
            "gtin": "4062300405714",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c885ed67a01d9a1f5d3",
            "leftCorner": {
              "x": 2.156,
              "y": 40.407,
              "z": 1.194
            },
            "rightCorner": {
              "x": 2.249,
              "y": 40.402,
              "z": 1.194
            },
            "gtin": "4056631003961",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464e8",
        "height": 1.754,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f331",
            "leftCorner": {
              "x": 1.021,
              "y": 40.458,
              "z": 1.435
            },
            "rightCorner": {
              "x": 1.065,
              "y": 40.455,
              "z": 1.435
            },
            "gtin": "4062300406254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f332",
            "leftCorner": {
              "x": 1.065,
              "y": 40.455,
              "z": 1.435
            },
            "rightCorner": {
              "x": 1.109,
              "y": 40.453,
              "z": 1.435
            },
            "gtin": "4062300406254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f333",
            "leftCorner": {
              "x": 1.109,
              "y": 40.453,
              "z": 1.435
            },
            "rightCorner": {
              "x": 1.152,
              "y": 40.451,
              "z": 1.435
            },
            "gtin": "4062300406254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f334",
            "leftCorner": {
              "x": 1.153,
              "y": 40.461,
              "z": 1.435
            },
            "rightCorner": {
              "x": 1.22,
              "y": 40.457,
              "z": 1.435
            },
            "gtin": "4062300406247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f335",
            "leftCorner": {
              "x": 1.22,
              "y": 40.457,
              "z": 1.435
            },
            "rightCorner": {
              "x": 1.288,
              "y": 40.454,
              "z": 1.435
            },
            "gtin": "4062300406247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f336",
            "leftCorner": {
              "x": 1.288,
              "y": 40.454,
              "z": 1.435
            },
            "rightCorner": {
              "x": 1.399,
              "y": 40.448,
              "z": 1.435
            },
            "gtin": "4062300402782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f337",
            "leftCorner": {
              "x": 1.399,
              "y": 40.447,
              "z": 1.435
            },
            "rightCorner": {
              "x": 1.473,
              "y": 40.443,
              "z": 1.435
            },
            "gtin": "4062300402799",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f338",
            "leftCorner": {
              "x": 1.473,
              "y": 40.443,
              "z": 1.435
            },
            "rightCorner": {
              "x": 1.547,
              "y": 40.439,
              "z": 1.435
            },
            "gtin": "4062300402799",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f339",
            "leftCorner": {
              "x": 1.546,
              "y": 40.427,
              "z": 1.435
            },
            "rightCorner": {
              "x": 1.705,
              "y": 40.418,
              "z": 1.435
            },
            "gtin": "4062300402805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f33a",
            "leftCorner": {
              "x": 1.705,
              "y": 40.414,
              "z": 1.435
            },
            "rightCorner": {
              "x": 1.793,
              "y": 40.41,
              "z": 1.435
            },
            "gtin": "4062300447240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f33b",
            "leftCorner": {
              "x": 1.793,
              "y": 40.41,
              "z": 1.435
            },
            "rightCorner": {
              "x": 1.882,
              "y": 40.405,
              "z": 1.435
            },
            "gtin": "4062300447240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f33c",
            "leftCorner": {
              "x": 1.883,
              "y": 40.415,
              "z": 1.435
            },
            "rightCorner": {
              "x": 2.019,
              "y": 40.408,
              "z": 1.435
            },
            "gtin": "4062300447233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f33d",
            "leftCorner": {
              "x": 2.019,
              "y": 40.408,
              "z": 1.435
            },
            "rightCorner": {
              "x": 2.155,
              "y": 40.4,
              "z": 1.435
            },
            "gtin": "4062300447233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f33e",
            "leftCorner": {
              "x": 2.155,
              "y": 40.393,
              "z": 1.435
            },
            "rightCorner": {
              "x": 2.296,
              "y": 40.386,
              "z": 1.435
            },
            "gtin": "4062300355446",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d9f86",
    "rightNeighborShelfId": "d9f88"
  },
  {
    "id": "d9f88",
    "name": "d9f88",
    "x": 2.262,
    "y": 40.352,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.026273,
      "w": 0.99965
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 54,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5464f3",
        "height": 0.15233,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f475",
            "leftCorner": {
              "x": 2.386,
              "y": 40.393,
              "z": 0.125
            },
            "rightCorner": {
              "x": 2.539,
              "y": 40.385,
              "z": 0.125
            },
            "gtin": "4008976032861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f476",
            "leftCorner": {
              "x": 2.538,
              "y": 40.365,
              "z": 0.125
            },
            "rightCorner": {
              "x": 2.672,
              "y": 40.358,
              "z": 0.125
            },
            "gtin": "4056631001790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f477",
            "leftCorner": {
              "x": 2.673,
              "y": 40.367,
              "z": 0.125
            },
            "rightCorner": {
              "x": 2.816,
              "y": 40.36,
              "z": 0.125
            },
            "gtin": "4056631001813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f478",
            "leftCorner": {
              "x": 2.816,
              "y": 40.357,
              "z": 0.125
            },
            "rightCorner": {
              "x": 2.946,
              "y": 40.351,
              "z": 0.125
            },
            "gtin": "4056631003435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f479",
            "leftCorner": {
              "x": 2.947,
              "y": 40.36,
              "z": 0.125
            },
            "rightCorner": {
              "x": 3.08,
              "y": 40.352,
              "z": 0.125
            },
            "gtin": "4056631003459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f47a",
            "leftCorner": {
              "x": 3.08,
              "y": 40.351,
              "z": 0.125
            },
            "rightCorner": {
              "x": 3.243,
              "y": 40.342,
              "z": 0.125
            },
            "gtin": "4056631003473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f47b",
            "leftCorner": {
              "x": 3.244,
              "y": 40.347,
              "z": 0.125
            },
            "rightCorner": {
              "x": 3.395,
              "y": 40.339,
              "z": 0.125
            },
            "gtin": "4056631002223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f41e",
            "leftCorner": {
              "x": 3.396,
              "y": 40.344,
              "z": 0.125
            },
            "rightCorner": {
              "x": 3.513,
              "y": 40.337,
              "z": 0.125
            },
            "gtin": "4056631002209",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464ef",
        "height": 0.60039,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f6a2",
            "leftCorner": {
              "x": 2.252,
              "y": 40.394,
              "z": 0.491
            },
            "rightCorner": {
              "x": 2.413,
              "y": 40.386,
              "z": 0.491
            },
            "gtin": "4056631002414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6a3",
            "leftCorner": {
              "x": 2.413,
              "y": 40.386,
              "z": 0.491
            },
            "rightCorner": {
              "x": 2.573,
              "y": 40.377,
              "z": 0.491
            },
            "gtin": "4056631002414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6a4",
            "leftCorner": {
              "x": 2.574,
              "y": 40.389,
              "z": 0.491
            },
            "rightCorner": {
              "x": 2.724,
              "y": 40.381,
              "z": 0.491
            },
            "gtin": "4056631003794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6a5",
            "leftCorner": {
              "x": 2.724,
              "y": 40.381,
              "z": 0.491
            },
            "rightCorner": {
              "x": 2.873,
              "y": 40.374,
              "z": 0.491
            },
            "gtin": "4056631003794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6a6",
            "leftCorner": {
              "x": 2.873,
              "y": 40.369,
              "z": 0.491
            },
            "rightCorner": {
              "x": 3.026,
              "y": 40.361,
              "z": 0.491
            },
            "gtin": "4056631000472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6a7",
            "leftCorner": {
              "x": 3.026,
              "y": 40.361,
              "z": 0.491
            },
            "rightCorner": {
              "x": 3.18,
              "y": 40.354,
              "z": 0.491
            },
            "gtin": "4056631000472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6a8",
            "leftCorner": {
              "x": 3.179,
              "y": 40.345,
              "z": 0.491
            },
            "rightCorner": {
              "x": 3.302,
              "y": 40.338,
              "z": 0.491
            },
            "gtin": "4056631000496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6a9",
            "leftCorner": {
              "x": 3.302,
              "y": 40.338,
              "z": 0.491
            },
            "rightCorner": {
              "x": 3.425,
              "y": 40.332,
              "z": 0.491
            },
            "gtin": "4056631000496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f68f",
            "leftCorner": {
              "x": 3.426,
              "y": 40.337,
              "z": 0.491
            },
            "rightCorner": {
              "x": 3.513,
              "y": 40.332,
              "z": 0.491
            },
            "gtin": "4056631000519",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464f2",
        "height": 0.85305,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f5b4",
            "leftCorner": {
              "x": 2.45,
              "y": 40.378,
              "z": 0.698
            },
            "rightCorner": {
              "x": 2.833,
              "y": 40.357,
              "z": 0.698
            },
            "gtin": "4056631001240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f5b5",
            "leftCorner": {
              "x": 2.833,
              "y": 40.36,
              "z": 0.698
            },
            "rightCorner": {
              "x": 3.006,
              "y": 40.35,
              "z": 0.698
            },
            "gtin": "4056631001264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5b6",
            "leftCorner": {
              "x": 3.006,
              "y": 40.35,
              "z": 0.698
            },
            "rightCorner": {
              "x": 3.18,
              "y": 40.342,
              "z": 0.698
            },
            "gtin": "4056631001264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f581",
            "leftCorner": {
              "x": 3.179,
              "y": 40.32,
              "z": 0.698
            },
            "rightCorner": {
              "x": 3.345,
              "y": 40.311,
              "z": 0.698
            },
            "gtin": "4056631003299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f582",
            "leftCorner": {
              "x": 3.345,
              "y": 40.311,
              "z": 0.698
            },
            "rightCorner": {
              "x": 3.511,
              "y": 40.302,
              "z": 0.698
            },
            "gtin": "4056631003299",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464f0",
        "height": 1.1529,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f554",
            "leftCorner": {
              "x": 2.302,
              "y": 40.39,
              "z": 0.943
            },
            "rightCorner": {
              "x": 2.362,
              "y": 40.387,
              "z": 0.943
            },
            "gtin": "8445291074309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f555",
            "leftCorner": {
              "x": 2.362,
              "y": 40.385,
              "z": 0.943
            },
            "rightCorner": {
              "x": 2.482,
              "y": 40.377,
              "z": 0.943
            },
            "gtin": "8445290478153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f556",
            "leftCorner": {
              "x": 2.482,
              "y": 40.378,
              "z": 0.943
            },
            "rightCorner": {
              "x": 2.639,
              "y": 40.37,
              "z": 0.943
            },
            "gtin": "8445291618527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f557",
            "leftCorner": {
              "x": 2.639,
              "y": 40.374,
              "z": 0.943
            },
            "rightCorner": {
              "x": 2.777,
              "y": 40.366,
              "z": 0.943
            },
            "gtin": "8445290945648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f558",
            "leftCorner": {
              "x": 2.777,
              "y": 40.366,
              "z": 0.943
            },
            "rightCorner": {
              "x": 2.907,
              "y": 40.36,
              "z": 0.943
            },
            "gtin": "4056631003701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f559",
            "leftCorner": {
              "x": 2.907,
              "y": 40.358,
              "z": 0.943
            },
            "rightCorner": {
              "x": 3.053,
              "y": 40.35,
              "z": 0.943
            },
            "gtin": "4056631001226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f55a",
            "leftCorner": {
              "x": 3.053,
              "y": 40.35,
              "z": 0.943
            },
            "rightCorner": {
              "x": 3.199,
              "y": 40.342,
              "z": 0.943
            },
            "gtin": "4056631001226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f55b",
            "leftCorner": {
              "x": 3.199,
              "y": 40.334,
              "z": 0.943
            },
            "rightCorner": {
              "x": 3.27,
              "y": 40.329,
              "z": 0.943
            },
            "gtin": "4056631003541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f55c",
            "leftCorner": {
              "x": 3.27,
              "y": 40.329,
              "z": 0.943
            },
            "rightCorner": {
              "x": 3.341,
              "y": 40.326,
              "z": 0.943
            },
            "gtin": "4056631003541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f530",
            "leftCorner": {
              "x": 3.341,
              "y": 40.329,
              "z": 0.943
            },
            "rightCorner": {
              "x": 3.512,
              "y": 40.32,
              "z": 0.943
            },
            "gtin": "4056631001202",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464ee",
        "height": 1.4569,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f5d4",
            "leftCorner": {
              "x": 2.248,
              "y": 40.391,
              "z": 1.192
            },
            "rightCorner": {
              "x": 2.315,
              "y": 40.387,
              "z": 1.192
            },
            "gtin": "8445290064868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5d5",
            "leftCorner": {
              "x": 2.315,
              "y": 40.387,
              "z": 1.192
            },
            "rightCorner": {
              "x": 2.381,
              "y": 40.384,
              "z": 1.192
            },
            "gtin": "8445290064868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5d6",
            "leftCorner": {
              "x": 2.381,
              "y": 40.384,
              "z": 1.192
            },
            "rightCorner": {
              "x": 2.448,
              "y": 40.38,
              "z": 1.192
            },
            "gtin": "8445290064868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5d7",
            "leftCorner": {
              "x": 2.448,
              "y": 40.377,
              "z": 1.192
            },
            "rightCorner": {
              "x": 2.61,
              "y": 40.368,
              "z": 1.192
            },
            "gtin": "7613038463681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5d8",
            "leftCorner": {
              "x": 2.61,
              "y": 40.368,
              "z": 1.192
            },
            "rightCorner": {
              "x": 2.772,
              "y": 40.361,
              "z": 1.192
            },
            "gtin": "7613038463681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5d9",
            "leftCorner": {
              "x": 2.772,
              "y": 40.361,
              "z": 1.192
            },
            "rightCorner": {
              "x": 2.934,
              "y": 40.352,
              "z": 1.192
            },
            "gtin": "7613038463681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5da",
            "leftCorner": {
              "x": 2.934,
              "y": 40.344,
              "z": 1.192
            },
            "rightCorner": {
              "x": 3.095,
              "y": 40.335,
              "z": 1.192
            },
            "gtin": "8445290917751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5db",
            "leftCorner": {
              "x": 3.095,
              "y": 40.338,
              "z": 1.192
            },
            "rightCorner": {
              "x": 3.178,
              "y": 40.334,
              "z": 1.192
            },
            "gtin": "8445290917607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5dc",
            "leftCorner": {
              "x": 3.178,
              "y": 40.334,
              "z": 1.192
            },
            "rightCorner": {
              "x": 3.26,
              "y": 40.33,
              "z": 1.192
            },
            "gtin": "8445290917607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5dd",
            "leftCorner": {
              "x": 3.26,
              "y": 40.331,
              "z": 1.192
            },
            "rightCorner": {
              "x": 3.443,
              "y": 40.321,
              "z": 1.192
            },
            "gtin": "8445290917928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f5ba",
            "leftCorner": {
              "x": 3.443,
              "y": 40.319,
              "z": 1.192
            },
            "rightCorner": {
              "x": 3.512,
              "y": 40.316,
              "z": 1.192
            },
            "gtin": "8445290917959",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464f1",
        "height": 1.7514,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f33f",
            "leftCorner": {
              "x": 2.297,
              "y": 40.404,
              "z": 1.433
            },
            "rightCorner": {
              "x": 2.419,
              "y": 40.398,
              "z": 1.433
            },
            "gtin": "7613038463582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f340",
            "leftCorner": {
              "x": 2.419,
              "y": 40.398,
              "z": 1.433
            },
            "rightCorner": {
              "x": 2.541,
              "y": 40.391,
              "z": 1.433
            },
            "gtin": "7613038463582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f341",
            "leftCorner": {
              "x": 2.541,
              "y": 40.391,
              "z": 1.433
            },
            "rightCorner": {
              "x": 2.663,
              "y": 40.384,
              "z": 1.433
            },
            "gtin": "7613038463582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f342",
            "leftCorner": {
              "x": 2.662,
              "y": 40.374,
              "z": 1.433
            },
            "rightCorner": {
              "x": 2.716,
              "y": 40.371,
              "z": 1.433
            },
            "gtin": "7613038463070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f343",
            "leftCorner": {
              "x": 2.716,
              "y": 40.371,
              "z": 1.433
            },
            "rightCorner": {
              "x": 2.771,
              "y": 40.369,
              "z": 1.433
            },
            "gtin": "7613038463070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f344",
            "leftCorner": {
              "x": 2.771,
              "y": 40.373,
              "z": 1.433
            },
            "rightCorner": {
              "x": 2.87,
              "y": 40.367,
              "z": 1.433
            },
            "gtin": "7613038463384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f345",
            "leftCorner": {
              "x": 2.87,
              "y": 40.367,
              "z": 1.433
            },
            "rightCorner": {
              "x": 2.969,
              "y": 40.362,
              "z": 1.433
            },
            "gtin": "7613038463384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f346",
            "leftCorner": {
              "x": 2.968,
              "y": 40.352,
              "z": 1.433
            },
            "rightCorner": {
              "x": 3.146,
              "y": 40.343,
              "z": 1.433
            },
            "gtin": "7613038464244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f347",
            "leftCorner": {
              "x": 3.146,
              "y": 40.343,
              "z": 1.433
            },
            "rightCorner": {
              "x": 3.323,
              "y": 40.333,
              "z": 1.433
            },
            "gtin": "7613038464244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2aa",
            "leftCorner": {
              "x": 3.323,
              "y": 40.327,
              "z": 1.433
            },
            "rightCorner": {
              "x": 3.417,
              "y": 40.321,
              "z": 1.433
            },
            "gtin": "7613038463353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f2ab",
            "leftCorner": {
              "x": 3.417,
              "y": 40.321,
              "z": 1.433
            },
            "rightCorner": {
              "x": 3.512,
              "y": 40.316,
              "z": 1.433
            },
            "gtin": "7613038463353",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d9f87"
  },
  {
    "id": "da3a1",
    "name": "da3a1",
    "x": 3.022,
    "y": 31.031,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99979,
      "w": 0.020576
    },

    "layers": [],
    "rightNeighborShelfId": "468c4"
  },
  {
    "id": "da3a2",
    "name": "da3a2",
    "x": -11.843,
    "y": 34.008,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.029335,
      "w": 0.99957
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 76
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5465ab",
        "height": 0.18444,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1fedb",
            "leftCorner": {
              "x": -11.843,
              "y": 34.005,
              "z": 0.151
            },
            "rightCorner": {
              "x": -11.625,
              "y": 33.992,
              "z": 0.151
            },
            "gtin": "4048976172648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fedc",
            "leftCorner": {
              "x": -11.625,
              "y": 33.992,
              "z": 0.151
            },
            "rightCorner": {
              "x": -11.406,
              "y": 33.979,
              "z": 0.151
            },
            "gtin": "4048976172648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fedd",
            "leftCorner": {
              "x": -11.406,
              "y": 33.979,
              "z": 0.151
            },
            "rightCorner": {
              "x": -11.188,
              "y": 33.966,
              "z": 0.151
            },
            "gtin": "4048976172648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fedf",
            "leftCorner": {
              "x": -11.187,
              "y": 33.985,
              "z": 0.151
            },
            "rightCorner": {
              "x": -11.123,
              "y": 33.981,
              "z": 0.151
            },
            "gtin": "3574661730943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fee0",
            "leftCorner": {
              "x": -11.123,
              "y": 33.981,
              "z": 0.151
            },
            "rightCorner": {
              "x": -11.059,
              "y": 33.978,
              "z": 0.151
            },
            "gtin": "3574661730943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fee1",
            "leftCorner": {
              "x": -11.059,
              "y": 33.978,
              "z": 0.151
            },
            "rightCorner": {
              "x": -10.995,
              "y": 33.974,
              "z": 0.151
            },
            "gtin": "3574661730943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fee2",
            "leftCorner": {
              "x": -10.994,
              "y": 33.998,
              "z": 0.151
            },
            "rightCorner": {
              "x": -10.847,
              "y": 33.989,
              "z": 0.151
            },
            "gtin": "3574661745008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fee3",
            "leftCorner": {
              "x": -10.849,
              "y": 33.977,
              "z": 0.151
            },
            "rightCorner": {
              "x": -10.512,
              "y": 33.958,
              "z": 0.151
            },
            "gtin": "42389231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fee4",
            "leftCorner": {
              "x": -10.512,
              "y": 33.958,
              "z": 0.151
            },
            "rightCorner": {
              "x": -10.174,
              "y": 33.938,
              "z": 0.151
            },
            "gtin": "42389231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fee5",
            "leftCorner": {
              "x": -10.174,
              "y": 33.938,
              "z": 0.151
            },
            "rightCorner": {
              "x": -9.837,
              "y": 33.918,
              "z": 0.151
            },
            "gtin": "42389231",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465a7",
        "height": 0.43014,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fdf6",
            "leftCorner": {
              "x": -11.834,
              "y": 34.158,
              "z": 0.352
            },
            "rightCorner": {
              "x": -11.733,
              "y": 34.152,
              "z": 0.352
            },
            "gtin": "4062300446670",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdf7",
            "leftCorner": {
              "x": -11.733,
              "y": 34.152,
              "z": 0.352
            },
            "rightCorner": {
              "x": -11.633,
              "y": 34.146,
              "z": 0.352
            },
            "gtin": "4062300446670",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdf8",
            "leftCorner": {
              "x": -11.633,
              "y": 34.146,
              "z": 0.352
            },
            "rightCorner": {
              "x": -11.532,
              "y": 34.141,
              "z": 0.352
            },
            "gtin": "4062300446670",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdfd",
            "leftCorner": {
              "x": -11.53,
              "y": 34.182,
              "z": 0.352
            },
            "rightCorner": {
              "x": -11.351,
              "y": 34.171,
              "z": 0.352
            },
            "gtin": "42428978",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdfe",
            "leftCorner": {
              "x": -11.351,
              "y": 34.169,
              "z": 0.352
            },
            "rightCorner": {
              "x": -11.243,
              "y": 34.163,
              "z": 0.352
            },
            "gtin": "42269663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdff",
            "leftCorner": {
              "x": -11.243,
              "y": 34.163,
              "z": 0.352
            },
            "rightCorner": {
              "x": -11.135,
              "y": 34.157,
              "z": 0.352
            },
            "gtin": "42269663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe00",
            "leftCorner": {
              "x": -11.136,
              "y": 34.152,
              "z": 0.352
            },
            "rightCorner": {
              "x": -11.04,
              "y": 34.147,
              "z": 0.352
            },
            "gtin": "3616305274137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe01",
            "leftCorner": {
              "x": -11.04,
              "y": 34.147,
              "z": 0.352
            },
            "rightCorner": {
              "x": -10.945,
              "y": 34.141,
              "z": 0.352
            },
            "gtin": "3616305274137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdf9",
            "leftCorner": {
              "x": -10.945,
              "y": 34.152,
              "z": 0.352
            },
            "rightCorner": {
              "x": -10.854,
              "y": 34.147,
              "z": 0.352
            },
            "gtin": "4013162008216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdfa",
            "leftCorner": {
              "x": -10.854,
              "y": 34.147,
              "z": 0.352
            },
            "rightCorner": {
              "x": -10.764,
              "y": 34.142,
              "z": 0.352
            },
            "gtin": "4013162008216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdfb",
            "leftCorner": {
              "x": -10.764,
              "y": 34.142,
              "z": 0.352
            },
            "rightCorner": {
              "x": -10.673,
              "y": 34.136,
              "z": 0.352
            },
            "gtin": "4013162008216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdfc",
            "leftCorner": {
              "x": -10.673,
              "y": 34.136,
              "z": 0.352
            },
            "rightCorner": {
              "x": -10.584,
              "y": 34.131,
              "z": 0.352
            },
            "gtin": "4013162008216",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465a9",
        "height": 0.72977,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1fe8c",
            "leftCorner": {
              "x": -11.834,
              "y": 34.155,
              "z": 0.597
            },
            "rightCorner": {
              "x": -11.774,
              "y": 34.151,
              "z": 0.597
            },
            "gtin": "50099962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe8d",
            "leftCorner": {
              "x": -11.774,
              "y": 34.151,
              "z": 0.597
            },
            "rightCorner": {
              "x": -11.715,
              "y": 34.148,
              "z": 0.597
            },
            "gtin": "50099962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe8e",
            "leftCorner": {
              "x": -11.715,
              "y": 34.148,
              "z": 0.597
            },
            "rightCorner": {
              "x": -11.654,
              "y": 34.144,
              "z": 0.597
            },
            "gtin": "50099962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe91",
            "leftCorner": {
              "x": -11.652,
              "y": 34.173,
              "z": 0.597
            },
            "rightCorner": {
              "x": -11.541,
              "y": 34.166,
              "z": 0.597
            },
            "gtin": "42467007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe92",
            "leftCorner": {
              "x": -11.54,
              "y": 34.175,
              "z": 0.597
            },
            "rightCorner": {
              "x": -11.446,
              "y": 34.169,
              "z": 0.597
            },
            "gtin": "8001090735126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe93",
            "leftCorner": {
              "x": -11.446,
              "y": 34.169,
              "z": 0.597
            },
            "rightCorner": {
              "x": -11.352,
              "y": 34.163,
              "z": 0.597
            },
            "gtin": "8001090735126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe94",
            "leftCorner": {
              "x": -11.352,
              "y": 34.168,
              "z": 0.597
            },
            "rightCorner": {
              "x": -11.291,
              "y": 34.165,
              "z": 0.597
            },
            "gtin": "4103040790019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe95",
            "leftCorner": {
              "x": -11.291,
              "y": 34.165,
              "z": 0.597
            },
            "rightCorner": {
              "x": -11.231,
              "y": 34.162,
              "z": 0.597
            },
            "gtin": "4103040790019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe96",
            "leftCorner": {
              "x": -11.231,
              "y": 34.162,
              "z": 0.597
            },
            "rightCorner": {
              "x": -11.17,
              "y": 34.158,
              "z": 0.597
            },
            "gtin": "4103040790019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe97",
            "leftCorner": {
              "x": -11.17,
              "y": 34.158,
              "z": 0.597
            },
            "rightCorner": {
              "x": -11.109,
              "y": 34.155,
              "z": 0.597
            },
            "gtin": "4103040790019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe98",
            "leftCorner": {
              "x": -11.109,
              "y": 34.159,
              "z": 0.597
            },
            "rightCorner": {
              "x": -11.022,
              "y": 34.154,
              "z": 0.597
            },
            "gtin": "4103040802019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe99",
            "leftCorner": {
              "x": -11.022,
              "y": 34.154,
              "z": 0.597
            },
            "rightCorner": {
              "x": -10.934,
              "y": 34.149,
              "z": 0.597
            },
            "gtin": "4103040802019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe9a",
            "leftCorner": {
              "x": -10.933,
              "y": 34.153,
              "z": 0.597
            },
            "rightCorner": {
              "x": -10.85,
              "y": 34.148,
              "z": 0.597
            },
            "gtin": "4011448001005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe9b",
            "leftCorner": {
              "x": -10.85,
              "y": 34.148,
              "z": 0.597
            },
            "rightCorner": {
              "x": -10.767,
              "y": 34.143,
              "z": 0.597
            },
            "gtin": "4011448001005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe9c",
            "leftCorner": {
              "x": -10.768,
              "y": 34.129,
              "z": 0.597
            },
            "rightCorner": {
              "x": -10.708,
              "y": 34.126,
              "z": 0.597
            },
            "gtin": "5054563208491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe9d",
            "leftCorner": {
              "x": -10.708,
              "y": 34.126,
              "z": 0.597
            },
            "rightCorner": {
              "x": -10.649,
              "y": 34.122,
              "z": 0.597
            },
            "gtin": "5054563208491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fe9e",
            "leftCorner": {
              "x": -10.649,
              "y": 34.122,
              "z": 0.597
            },
            "rightCorner": {
              "x": -10.59,
              "y": 34.119,
              "z": 0.597
            },
            "gtin": "5054563208491",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465aa",
        "height": 0.98096,
        "facings": [
          {
            "id": "68300c895ed67a01d9a1feba",
            "leftCorner": {
              "x": -11.835,
              "y": 34.134,
              "z": 0.803
            },
            "rightCorner": {
              "x": -11.72,
              "y": 34.127,
              "z": 0.803
            },
            "gtin": "4065331001009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1febb",
            "leftCorner": {
              "x": -11.72,
              "y": 34.127,
              "z": 0.803
            },
            "rightCorner": {
              "x": -11.604,
              "y": 34.121,
              "z": 0.803
            },
            "gtin": "4065331001009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1febc",
            "leftCorner": {
              "x": -11.604,
              "y": 34.121,
              "z": 0.803
            },
            "rightCorner": {
              "x": -11.489,
              "y": 34.114,
              "z": 0.803
            },
            "gtin": "4065331001009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1febd",
            "leftCorner": {
              "x": -11.489,
              "y": 34.114,
              "z": 0.803
            },
            "rightCorner": {
              "x": -11.373,
              "y": 34.107,
              "z": 0.803
            },
            "gtin": "4065331001009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fec2",
            "leftCorner": {
              "x": -11.372,
              "y": 34.144,
              "z": 0.803
            },
            "rightCorner": {
              "x": -11.213,
              "y": 34.135,
              "z": 0.803
            },
            "gtin": "4065331000927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fec3",
            "leftCorner": {
              "x": -11.213,
              "y": 34.135,
              "z": 0.803
            },
            "rightCorner": {
              "x": -11.055,
              "y": 34.125,
              "z": 0.803
            },
            "gtin": "4065331000927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fec4",
            "leftCorner": {
              "x": -11.054,
              "y": 34.132,
              "z": 0.803
            },
            "rightCorner": {
              "x": -10.979,
              "y": 34.128,
              "z": 0.803
            },
            "gtin": "59097679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fec5",
            "leftCorner": {
              "x": -10.979,
              "y": 34.128,
              "z": 0.803
            },
            "rightCorner": {
              "x": -10.903,
              "y": 34.123,
              "z": 0.803
            },
            "gtin": "59097679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fec6",
            "leftCorner": {
              "x": -10.903,
              "y": 34.128,
              "z": 0.803
            },
            "rightCorner": {
              "x": -10.795,
              "y": 34.121,
              "z": 0.803
            },
            "gtin": "8720181505515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fec7",
            "leftCorner": {
              "x": -10.795,
              "y": 34.121,
              "z": 0.803
            },
            "rightCorner": {
              "x": -10.687,
              "y": 34.115,
              "z": 0.803
            },
            "gtin": "8720181505515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c895ed67a01d9a1fec8",
            "leftCorner": {
              "x": -10.687,
              "y": 34.115,
              "z": 0.803
            },
            "rightCorner": {
              "x": -10.579,
              "y": 34.109,
              "z": 0.803
            },
            "gtin": "8720181505515",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465a6",
        "height": 1.2849,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fdd4",
            "leftCorner": {
              "x": -11.835,
              "y": 34.143,
              "z": 1.051
            },
            "rightCorner": {
              "x": -11.772,
              "y": 34.139,
              "z": 1.051
            },
            "gtin": "3574661821344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdd5",
            "leftCorner": {
              "x": -11.772,
              "y": 34.139,
              "z": 1.051
            },
            "rightCorner": {
              "x": -11.709,
              "y": 34.135,
              "z": 1.051
            },
            "gtin": "3574661821344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdd7",
            "leftCorner": {
              "x": -11.708,
              "y": 34.162,
              "z": 1.051
            },
            "rightCorner": {
              "x": -11.536,
              "y": 34.152,
              "z": 1.051
            },
            "gtin": "42241201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdd8",
            "leftCorner": {
              "x": -11.536,
              "y": 34.152,
              "z": 1.051
            },
            "rightCorner": {
              "x": -11.365,
              "y": 34.142,
              "z": 1.051
            },
            "gtin": "42241201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdd9",
            "leftCorner": {
              "x": -11.364,
              "y": 34.147,
              "z": 1.051
            },
            "rightCorner": {
              "x": -11.262,
              "y": 34.141,
              "z": 1.051
            },
            "gtin": "5029053575155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdda",
            "leftCorner": {
              "x": -11.262,
              "y": 34.141,
              "z": 1.051
            },
            "rightCorner": {
              "x": -11.159,
              "y": 34.134,
              "z": 1.051
            },
            "gtin": "5029053575155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fddb",
            "leftCorner": {
              "x": -11.159,
              "y": 34.143,
              "z": 1.051
            },
            "rightCorner": {
              "x": -11.065,
              "y": 34.138,
              "z": 1.051
            },
            "gtin": "4337185927584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fddc",
            "leftCorner": {
              "x": -11.065,
              "y": 34.138,
              "z": 1.051
            },
            "rightCorner": {
              "x": -10.973,
              "y": 34.131,
              "z": 1.051
            },
            "gtin": "4337185927584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fddd",
            "leftCorner": {
              "x": -10.973,
              "y": 34.128,
              "z": 1.051
            },
            "rightCorner": {
              "x": -10.81,
              "y": 34.119,
              "z": 1.051
            },
            "gtin": "42449515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fdde",
            "leftCorner": {
              "x": -10.809,
              "y": 34.141,
              "z": 1.051
            },
            "rightCorner": {
              "x": -10.733,
              "y": 34.136,
              "z": 1.051
            },
            "gtin": "4037900643255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fddf",
            "leftCorner": {
              "x": -10.733,
              "y": 34.136,
              "z": 1.051
            },
            "rightCorner": {
              "x": -10.656,
              "y": 34.132,
              "z": 1.051
            },
            "gtin": "4037900643255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fde0",
            "leftCorner": {
              "x": -10.656,
              "y": 34.132,
              "z": 1.051
            },
            "rightCorner": {
              "x": -10.58,
              "y": 34.127,
              "z": 1.051
            },
            "gtin": "4037900643255",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5465a8",
        "height": 1.6627,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fe02",
            "leftCorner": {
              "x": -11.837,
              "y": 34.116,
              "z": 1.36
            },
            "rightCorner": {
              "x": -11.764,
              "y": 34.111,
              "z": 1.36
            },
            "gtin": "3616303474027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe04",
            "leftCorner": {
              "x": -11.762,
              "y": 34.152,
              "z": 1.36
            },
            "rightCorner": {
              "x": -11.701,
              "y": 34.15,
              "z": 1.36
            },
            "gtin": "3616305254610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe05",
            "leftCorner": {
              "x": -11.701,
              "y": 34.15,
              "z": 1.36
            },
            "rightCorner": {
              "x": -11.64,
              "y": 34.146,
              "z": 1.36
            },
            "gtin": "3616305254610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe06",
            "leftCorner": {
              "x": -11.64,
              "y": 34.142,
              "z": 1.36
            },
            "rightCorner": {
              "x": -11.567,
              "y": 34.137,
              "z": 1.36
            },
            "gtin": "3616305254627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe07",
            "leftCorner": {
              "x": -11.567,
              "y": 34.137,
              "z": 1.36
            },
            "rightCorner": {
              "x": -11.495,
              "y": 34.133,
              "z": 1.36
            },
            "gtin": "3616305254627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe08",
            "leftCorner": {
              "x": -11.495,
              "y": 34.129,
              "z": 1.36
            },
            "rightCorner": {
              "x": -11.394,
              "y": 34.122,
              "z": 1.36
            },
            "gtin": "3616305254566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe09",
            "leftCorner": {
              "x": -11.394,
              "y": 34.122,
              "z": 1.36
            },
            "rightCorner": {
              "x": -11.292,
              "y": 34.116,
              "z": 1.36
            },
            "gtin": "3616305254566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe0a",
            "leftCorner": {
              "x": -11.291,
              "y": 34.125,
              "z": 1.36
            },
            "rightCorner": {
              "x": -11.23,
              "y": 34.121,
              "z": 1.36
            },
            "gtin": "3616303474041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe0b",
            "leftCorner": {
              "x": -11.23,
              "y": 34.121,
              "z": 1.36
            },
            "rightCorner": {
              "x": -11.17,
              "y": 34.118,
              "z": 1.36
            },
            "gtin": "3616303474041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe0c",
            "leftCorner": {
              "x": -11.17,
              "y": 34.116,
              "z": 1.36
            },
            "rightCorner": {
              "x": -11.093,
              "y": 34.111,
              "z": 1.36
            },
            "gtin": "3616305254603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe0d",
            "leftCorner": {
              "x": -11.093,
              "y": 34.111,
              "z": 1.36
            },
            "rightCorner": {
              "x": -11.016,
              "y": 34.106,
              "z": 1.36
            },
            "gtin": "3616305254603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe0e",
            "leftCorner": {
              "x": -11.016,
              "y": 34.106,
              "z": 1.36
            },
            "rightCorner": {
              "x": -10.879,
              "y": 34.098,
              "z": 1.36
            },
            "gtin": "6924574508721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe0f",
            "leftCorner": {
              "x": -10.879,
              "y": 34.098,
              "z": 1.36
            },
            "rightCorner": {
              "x": -10.741,
              "y": 34.09,
              "z": 1.36
            },
            "gtin": "6924574508721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fe10",
            "leftCorner": {
              "x": -10.741,
              "y": 34.094,
              "z": 1.36
            },
            "rightCorner": {
              "x": -10.54,
              "y": 34.081,
              "z": 1.36
            },
            "gtin": "8720182847072",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "468b3"
  },
  {
    "id": "da3bb",
    "name": "da3bb",
    "x": 3.111,
    "y": 34.387,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9998,
      "w": 0.019817
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 37
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463ee",
        "height": 0.15881,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e901",
            "leftCorner": {
              "x": 3.11,
              "y": 34.372,
              "z": 0.13
            },
            "rightCorner": {
              "x": 3.032,
              "y": 34.375,
              "z": 0.13
            }
          },
          {
            "id": "68300c865ed67a01d9a1e902",
            "leftCorner": {
              "x": 3.031,
              "y": 34.344,
              "z": 0.13
            },
            "rightCorner": {
              "x": 2.446,
              "y": 34.368,
              "z": 0.13
            },
            "gtin": "4002857008037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e903",
            "leftCorner": {
              "x": 2.446,
              "y": 34.368,
              "z": 0.13
            },
            "rightCorner": {
              "x": 1.86,
              "y": 34.39,
              "z": 0.13
            },
            "gtin": "4002857008037",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463ec",
        "height": 1.2556,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e8f4",
            "leftCorner": {
              "x": 3.111,
              "y": 34.377,
              "z": 1.027
            },
            "rightCorner": {
              "x": 2.784,
              "y": 34.39,
              "z": 1.027
            },
            "gtin": "5029053583921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8f5",
            "leftCorner": {
              "x": 2.784,
              "y": 34.39,
              "z": 1.027
            },
            "rightCorner": {
              "x": 2.457,
              "y": 34.402,
              "z": 1.027
            },
            "gtin": "5029053583921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8f7",
            "leftCorner": {
              "x": 2.455,
              "y": 34.365,
              "z": 1.027
            },
            "rightCorner": {
              "x": 2.229,
              "y": 34.374,
              "z": 1.027
            },
            "gtin": "5029053584331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8f8",
            "leftCorner": {
              "x": 2.229,
              "y": 34.374,
              "z": 1.027
            },
            "rightCorner": {
              "x": 2.003,
              "y": 34.383,
              "z": 1.027
            },
            "gtin": "5029053584331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8f6",
            "leftCorner": {
              "x": 2.003,
              "y": 34.39,
              "z": 1.027
            },
            "rightCorner": {
              "x": 1.86,
              "y": 34.396,
              "z": 1.027
            },
            "gtin": "5029053583945",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463ed",
        "height": 0.65505,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e8f9",
            "leftCorner": {
              "x": 3.11,
              "y": 34.366,
              "z": 0.536
            },
            "rightCorner": {
              "x": 2.981,
              "y": 34.371,
              "z": 0.536
            },
            "gtin": "4064791013904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8fa",
            "leftCorner": {
              "x": 2.981,
              "y": 34.371,
              "z": 0.536
            },
            "rightCorner": {
              "x": 2.852,
              "y": 34.377,
              "z": 0.536
            },
            "gtin": "4064791013904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8fb",
            "leftCorner": {
              "x": 2.852,
              "y": 34.377,
              "z": 0.536
            },
            "rightCorner": {
              "x": 2.723,
              "y": 34.381,
              "z": 0.536
            },
            "gtin": "4064791013904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8fc",
            "leftCorner": {
              "x": 2.723,
              "y": 34.381,
              "z": 0.536
            },
            "rightCorner": {
              "x": 2.594,
              "y": 34.387,
              "z": 0.536
            },
            "gtin": "4064791013904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8ff",
            "leftCorner": {
              "x": 2.593,
              "y": 34.351,
              "z": 0.536
            },
            "rightCorner": {
              "x": 2.426,
              "y": 34.357,
              "z": 0.536
            },
            "gtin": "4063367426452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e900",
            "leftCorner": {
              "x": 2.426,
              "y": 34.357,
              "z": 0.536
            },
            "rightCorner": {
              "x": 2.26,
              "y": 34.364,
              "z": 0.536
            },
            "gtin": "4063367426452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8fd",
            "leftCorner": {
              "x": 2.259,
              "y": 34.359,
              "z": 0.536
            },
            "rightCorner": {
              "x": 2.059,
              "y": 34.367,
              "z": 0.536
            },
            "gtin": "4063367426438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8fe",
            "leftCorner": {
              "x": 2.059,
              "y": 34.367,
              "z": 0.536
            },
            "rightCorner": {
              "x": 1.86,
              "y": 34.374,
              "z": 0.536
            },
            "gtin": "4063367426438",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463eb",
        "height": 0.95638,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e8ea",
            "leftCorner": {
              "x": 3.11,
              "y": 34.368,
              "z": 0.782
            },
            "rightCorner": {
              "x": 2.983,
              "y": 34.373,
              "z": 0.782
            },
            "gtin": "5029053583907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8eb",
            "leftCorner": {
              "x": 2.983,
              "y": 34.373,
              "z": 0.782
            },
            "rightCorner": {
              "x": 2.856,
              "y": 34.379,
              "z": 0.782
            },
            "gtin": "5029053583907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8ed",
            "leftCorner": {
              "x": 2.854,
              "y": 34.341,
              "z": 0.782
            },
            "rightCorner": {
              "x": 2.679,
              "y": 34.348,
              "z": 0.782
            },
            "gtin": "7322540907520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8ee",
            "leftCorner": {
              "x": 2.679,
              "y": 34.342,
              "z": 0.782
            },
            "rightCorner": {
              "x": 2.618,
              "y": 34.345,
              "z": 0.782
            },
            "gtin": "7322540907551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8ef",
            "leftCorner": {
              "x": 2.618,
              "y": 34.345,
              "z": 0.782
            },
            "rightCorner": {
              "x": 2.558,
              "y": 34.347,
              "z": 0.782
            },
            "gtin": "7322540907551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8f0",
            "leftCorner": {
              "x": 2.558,
              "y": 34.358,
              "z": 0.782
            },
            "rightCorner": {
              "x": 2.346,
              "y": 34.367,
              "z": 0.782
            },
            "gtin": "7322540907582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8f1",
            "leftCorner": {
              "x": 2.346,
              "y": 34.36,
              "z": 0.782
            },
            "rightCorner": {
              "x": 2.219,
              "y": 34.364,
              "z": 0.782
            },
            "gtin": "5029053583969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8f2",
            "leftCorner": {
              "x": 2.219,
              "y": 34.364,
              "z": 0.782
            },
            "rightCorner": {
              "x": 2.093,
              "y": 34.37,
              "z": 0.782
            },
            "gtin": "5029053583969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8f3",
            "leftCorner": {
              "x": 2.093,
              "y": 34.37,
              "z": 0.782
            },
            "rightCorner": {
              "x": 1.967,
              "y": 34.375,
              "z": 0.782
            },
            "gtin": "5029053583969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8ec",
            "leftCorner": {
              "x": 1.967,
              "y": 34.377,
              "z": 0.782
            },
            "rightCorner": {
              "x": 1.86,
              "y": 34.381,
              "z": 0.782
            },
            "gtin": "4063367426513",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463ef",
        "height": 1.7072,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e904",
            "leftCorner": {
              "x": 3.11,
              "y": 34.372,
              "z": 1.397
            },
            "rightCorner": {
              "x": 3.039,
              "y": 34.375,
              "z": 1.397
            },
            "gtin": "5029053583891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e905",
            "leftCorner": {
              "x": 3.039,
              "y": 34.375,
              "z": 1.397
            },
            "rightCorner": {
              "x": 2.967,
              "y": 34.378,
              "z": 1.397
            },
            "gtin": "5029053583891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e906",
            "leftCorner": {
              "x": 2.967,
              "y": 34.378,
              "z": 1.397
            },
            "rightCorner": {
              "x": 2.895,
              "y": 34.381,
              "z": 1.397
            },
            "gtin": "5029053583891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e907",
            "leftCorner": {
              "x": 2.895,
              "y": 34.381,
              "z": 1.397
            },
            "rightCorner": {
              "x": 2.824,
              "y": 34.383,
              "z": 1.397
            },
            "gtin": "5029053583891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e909",
            "leftCorner": {
              "x": 2.822,
              "y": 34.348,
              "z": 1.397
            },
            "rightCorner": {
              "x": 2.655,
              "y": 34.354,
              "z": 1.397
            },
            "gtin": "5029053583938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e90a",
            "leftCorner": {
              "x": 2.655,
              "y": 34.354,
              "z": 1.397
            },
            "rightCorner": {
              "x": 2.488,
              "y": 34.361,
              "z": 1.397
            },
            "gtin": "5029053583938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e90b",
            "leftCorner": {
              "x": 2.488,
              "y": 34.361,
              "z": 1.397
            },
            "rightCorner": {
              "x": 2.321,
              "y": 34.368,
              "z": 1.397
            },
            "gtin": "5029053583938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e90c",
            "leftCorner": {
              "x": 2.321,
              "y": 34.365,
              "z": 1.397
            },
            "rightCorner": {
              "x": 2.246,
              "y": 34.368,
              "z": 1.397
            },
            "gtin": "5029053583952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e90d",
            "leftCorner": {
              "x": 2.246,
              "y": 34.368,
              "z": 1.397
            },
            "rightCorner": {
              "x": 2.171,
              "y": 34.371,
              "z": 1.397
            },
            "gtin": "5029053583952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e90e",
            "leftCorner": {
              "x": 2.171,
              "y": 34.371,
              "z": 1.397
            },
            "rightCorner": {
              "x": 2.096,
              "y": 34.374,
              "z": 1.397
            },
            "gtin": "5029053583952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e90f",
            "leftCorner": {
              "x": 2.096,
              "y": 34.374,
              "z": 1.397
            },
            "rightCorner": {
              "x": 2.021,
              "y": 34.378,
              "z": 1.397
            },
            "gtin": "5029053583952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e910",
            "leftCorner": {
              "x": 2.021,
              "y": 34.389,
              "z": 1.397
            },
            "rightCorner": {
              "x": 1.809,
              "y": 34.397,
              "z": 1.397
            },
            "gtin": "4260344220816",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "468a6"
  },
  {
    "id": "da3c7",
    "name": "da3c7",
    "x": 3.244,
    "y": 37.89,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9997,
      "w": 0.024319
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 6,
      "unknownStockCount": 43
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a5464fa",
        "height": 0.14826,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f6c9",
            "leftCorner": {
              "x": 3.247,
              "y": 37.961,
              "z": 0.121
            },
            "rightCorner": {
              "x": 3.097,
              "y": 37.967,
              "z": 0.121
            },
            "gtin": "4337185901782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6ca",
            "leftCorner": {
              "x": 3.097,
              "y": 37.967,
              "z": 0.121
            },
            "rightCorner": {
              "x": 2.947,
              "y": 37.975,
              "z": 0.121
            },
            "gtin": "4337185901782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6cb",
            "leftCorner": {
              "x": 2.947,
              "y": 37.975,
              "z": 0.121
            },
            "rightCorner": {
              "x": 2.797,
              "y": 37.982,
              "z": 0.121
            },
            "gtin": "4337185901782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6cd",
            "leftCorner": {
              "x": 2.799,
              "y": 38.011,
              "z": 0.121
            },
            "rightCorner": {
              "x": 2.743,
              "y": 38.014,
              "z": 0.121
            },
            "gtin": "4337185901768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6ce",
            "leftCorner": {
              "x": 2.743,
              "y": 38.014,
              "z": 0.121
            },
            "rightCorner": {
              "x": 2.688,
              "y": 38.016,
              "z": 0.121
            },
            "gtin": "4337185901768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6cf",
            "leftCorner": {
              "x": 2.686,
              "y": 37.984,
              "z": 0.121
            },
            "rightCorner": {
              "x": 2.505,
              "y": 37.993,
              "z": 0.121
            },
            "gtin": "4337185901805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6d0",
            "leftCorner": {
              "x": 2.504,
              "y": 37.963,
              "z": 0.121
            },
            "rightCorner": {
              "x": 2.423,
              "y": 37.967,
              "z": 0.121
            },
            "gtin": "4337185901744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6d1",
            "leftCorner": {
              "x": 2.423,
              "y": 37.962,
              "z": 0.121
            },
            "rightCorner": {
              "x": 2.323,
              "y": 37.966,
              "z": 0.121
            },
            "gtin": "4337185901720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6d2",
            "leftCorner": {
              "x": 2.323,
              "y": 37.966,
              "z": 0.121
            },
            "rightCorner": {
              "x": 2.224,
              "y": 37.971,
              "z": 0.121
            },
            "gtin": "4337185901720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6d3",
            "leftCorner": {
              "x": 2.223,
              "y": 37.953,
              "z": 0.121
            },
            "rightCorner": {
              "x": 2.159,
              "y": 37.955,
              "z": 0.121
            },
            "gtin": "4000821351035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6d4",
            "leftCorner": {
              "x": 2.158,
              "y": 37.949,
              "z": 0.121
            },
            "rightCorner": {
              "x": 2.061,
              "y": 37.954,
              "z": 0.121
            },
            "gtin": "4337185901829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6cc",
            "leftCorner": {
              "x": 2.06,
              "y": 37.918,
              "z": 0.121
            },
            "rightCorner": {
              "x": 1.994,
              "y": 37.921,
              "z": 0.121
            },
            "gtin": "4008600382232",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464f7",
        "height": 0.73297,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f6bc",
            "leftCorner": {
              "x": 3.247,
              "y": 37.949,
              "z": 0.6
            },
            "rightCorner": {
              "x": 2.957,
              "y": 37.963,
              "z": 0.6
            },
            "gtin": "4008600083641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6be",
            "leftCorner": {
              "x": 2.955,
              "y": 37.925,
              "z": 0.6
            },
            "rightCorner": {
              "x": 2.844,
              "y": 37.931,
              "z": 0.6
            },
            "gtin": "4008600090205",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c885ed67a01d9a1f6bf",
            "leftCorner": {
              "x": 2.842,
              "y": 37.887,
              "z": 0.6
            },
            "rightCorner": {
              "x": 2.733,
              "y": 37.891,
              "z": 0.6
            },
            "gtin": "4008600215769",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c885ed67a01d9a1f6c0",
            "leftCorner": {
              "x": 2.732,
              "y": 37.878,
              "z": 0.6
            },
            "rightCorner": {
              "x": 2.367,
              "y": 37.896,
              "z": 0.6
            },
            "gtin": "4008600119111",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c885ed67a01d9a1f6bd",
            "leftCorner": {
              "x": 2.364,
              "y": 37.837,
              "z": 0.6
            },
            "rightCorner": {
              "x": 1.991,
              "y": 37.854,
              "z": 0.6
            },
            "gtin": "4000821370630",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464fc",
        "height": 0.76775,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f6db",
            "leftCorner": {
              "x": 3.239,
              "y": 37.783,
              "z": 0.628
            },
            "rightCorner": {
              "x": 2.689,
              "y": 37.809,
              "z": 0.628
            }
          },
          {
            "id": "68300c885ed67a01d9a1f6dc",
            "leftCorner": {
              "x": 2.689,
              "y": 37.809,
              "z": 0.628
            },
            "rightCorner": {
              "x": 2.14,
              "y": 37.836,
              "z": 0.628
            }
          },
          {
            "id": "68300c885ed67a01d9a1f6dd",
            "leftCorner": {
              "x": 2.138,
              "y": 37.803,
              "z": 0.628
            },
            "rightCorner": {
              "x": 1.989,
              "y": 37.811,
              "z": 0.628
            },
            "gtin": "4000821370616",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464f5",
        "height": 1.0133,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f6ac",
            "leftCorner": {
              "x": 3.245,
              "y": 37.904,
              "z": 0.829
            },
            "rightCorner": {
              "x": 3.081,
              "y": 37.912,
              "z": 0.829
            },
            "gtin": "4008600382201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6ae",
            "leftCorner": {
              "x": 3.081,
              "y": 37.916,
              "z": 0.829
            },
            "rightCorner": {
              "x": 2.914,
              "y": 37.925,
              "z": 0.829
            },
            "gtin": "4008600251101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6af",
            "leftCorner": {
              "x": 2.914,
              "y": 37.914,
              "z": 0.829
            },
            "rightCorner": {
              "x": 2.771,
              "y": 37.921,
              "z": 0.829
            },
            "gtin": "4008600434337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6b0",
            "leftCorner": {
              "x": 2.771,
              "y": 37.921,
              "z": 0.829
            },
            "rightCorner": {
              "x": 2.629,
              "y": 37.928,
              "z": 0.829
            },
            "gtin": "4008600434337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6b1",
            "leftCorner": {
              "x": 2.626,
              "y": 37.865,
              "z": 0.829
            },
            "rightCorner": {
              "x": 2.462,
              "y": 37.873,
              "z": 0.829
            },
            "gtin": "4008600434351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6b2",
            "leftCorner": {
              "x": 2.461,
              "y": 37.855,
              "z": 0.829
            },
            "rightCorner": {
              "x": 2.195,
              "y": 37.868,
              "z": 0.829
            },
            "gtin": "8710103989615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6ad",
            "leftCorner": {
              "x": 2.192,
              "y": 37.805,
              "z": 0.829
            },
            "rightCorner": {
              "x": 1.989,
              "y": 37.814,
              "z": 0.829
            },
            "gtin": "8710103989646",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464f6",
        "height": 1.2836,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f6b3",
            "leftCorner": {
              "x": 3.244,
              "y": 37.897,
              "z": 1.05
            },
            "rightCorner": {
              "x": 2.947,
              "y": 37.911,
              "z": 1.05
            },
            "gtin": "9001616664113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6b5",
            "leftCorner": {
              "x": 2.947,
              "y": 37.919,
              "z": 1.05
            },
            "rightCorner": {
              "x": 2.874,
              "y": 37.922,
              "z": 1.05
            },
            "gtin": "9001616664151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6b6",
            "leftCorner": {
              "x": 2.874,
              "y": 37.922,
              "z": 1.05
            },
            "rightCorner": {
              "x": 2.8,
              "y": 37.925,
              "z": 1.05
            },
            "gtin": "9001616664151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6b7",
            "leftCorner": {
              "x": 2.799,
              "y": 37.905,
              "z": 1.05
            },
            "rightCorner": {
              "x": 2.673,
              "y": 37.912,
              "z": 1.05
            },
            "gtin": "4337185892752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6b8",
            "leftCorner": {
              "x": 2.672,
              "y": 37.886,
              "z": 1.05
            },
            "rightCorner": {
              "x": 2.548,
              "y": 37.892,
              "z": 1.05
            },
            "gtin": "4337185901683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6b9",
            "leftCorner": {
              "x": 2.548,
              "y": 37.884,
              "z": 1.05
            },
            "rightCorner": {
              "x": 2.399,
              "y": 37.892,
              "z": 1.05
            },
            "gtin": "4337185901706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6ba",
            "leftCorner": {
              "x": 2.397,
              "y": 37.84,
              "z": 1.05
            },
            "rightCorner": {
              "x": 2.293,
              "y": 37.845,
              "z": 1.05
            },
            "gtin": "4337185901669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6bb",
            "leftCorner": {
              "x": 2.293,
              "y": 37.845,
              "z": 1.05
            },
            "rightCorner": {
              "x": 2.189,
              "y": 37.85,
              "z": 1.05
            },
            "gtin": "4337185901669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6b4",
            "leftCorner": {
              "x": 2.187,
              "y": 37.816,
              "z": 1.05
            },
            "rightCorner": {
              "x": 1.99,
              "y": 37.826,
              "z": 1.05
            },
            "gtin": "4008600283386",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464f9",
        "height": 1.5326,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f6c1",
            "leftCorner": {
              "x": 3.244,
              "y": 37.897,
              "z": 1.254
            },
            "rightCorner": {
              "x": 2.87,
              "y": 37.915,
              "z": 1.254
            },
            "gtin": "4337185897412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6c3",
            "leftCorner": {
              "x": 2.869,
              "y": 37.902,
              "z": 1.254
            },
            "rightCorner": {
              "x": 2.772,
              "y": 37.906,
              "z": 1.254
            },
            "gtin": "4337185892790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6c4",
            "leftCorner": {
              "x": 2.771,
              "y": 37.883,
              "z": 1.254
            },
            "rightCorner": {
              "x": 2.64,
              "y": 37.89,
              "z": 1.254
            },
            "gtin": "4337185892899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6c5",
            "leftCorner": {
              "x": 2.64,
              "y": 37.894,
              "z": 1.254
            },
            "rightCorner": {
              "x": 2.537,
              "y": 37.899,
              "z": 1.254
            },
            "gtin": "4337185892967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6c6",
            "leftCorner": {
              "x": 2.536,
              "y": 37.863,
              "z": 1.254
            },
            "rightCorner": {
              "x": 2.29,
              "y": 37.874,
              "z": 1.254
            },
            "gtin": "4337185891557",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6c7",
            "leftCorner": {
              "x": 2.288,
              "y": 37.838,
              "z": 1.254
            },
            "rightCorner": {
              "x": 2.176,
              "y": 37.844,
              "z": 1.254
            },
            "gtin": "4000821370050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6c8",
            "leftCorner": {
              "x": 2.175,
              "y": 37.824,
              "z": 1.254
            },
            "rightCorner": {
              "x": 2.089,
              "y": 37.828,
              "z": 1.254
            },
            "gtin": "4000821910331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6c2",
            "leftCorner": {
              "x": 2.088,
              "y": 37.802,
              "z": 1.254
            },
            "rightCorner": {
              "x": 1.989,
              "y": 37.807,
              "z": 1.254
            },
            "gtin": "4000821910324",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464f4",
        "height": 1.7416,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f6aa",
            "leftCorner": {
              "x": 3.246,
              "y": 37.938,
              "z": 1.425
            },
            "rightCorner": {
              "x": 3.022,
              "y": 37.948,
              "z": 1.425
            }
          },
          {
            "id": "68300c885ed67a01d9a1f6ab",
            "leftCorner": {
              "x": 3.021,
              "y": 37.914,
              "z": 1.425
            },
            "rightCorner": {
              "x": 1.996,
              "y": 37.964,
              "z": 1.425
            },
            "gtin": "4000821370920",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a5464fb",
        "height": 1.8286,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1f6d5",
            "leftCorner": {
              "x": 3.242,
              "y": 37.842,
              "z": 1.496
            },
            "rightCorner": {
              "x": 2.616,
              "y": 37.873,
              "z": 1.496
            },
            "gtin": "4008600421481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6d7",
            "leftCorner": {
              "x": 2.616,
              "y": 37.878,
              "z": 1.496
            },
            "rightCorner": {
              "x": 2.406,
              "y": 37.888,
              "z": 1.496
            },
            "gtin": "048526053971",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c885ed67a01d9a1f6d8",
            "leftCorner": {
              "x": 2.404,
              "y": 37.85,
              "z": 1.496
            },
            "rightCorner": {
              "x": 2.308,
              "y": 37.854,
              "z": 1.496
            },
            "gtin": "4337185901843",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c885ed67a01d9a1f6d9",
            "leftCorner": {
              "x": 2.308,
              "y": 37.849,
              "z": 1.496
            },
            "rightCorner": {
              "x": 2.197,
              "y": 37.855,
              "z": 1.496
            },
            "gtin": "4337185901867",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c885ed67a01d9a1f6da",
            "leftCorner": {
              "x": 2.195,
              "y": 37.821,
              "z": 1.496
            },
            "rightCorner": {
              "x": 2.091,
              "y": 37.827,
              "z": 1.496
            },
            "gtin": "4337185901881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1f6d6",
            "leftCorner": {
              "x": 2.09,
              "y": 37.795,
              "z": 1.496
            },
            "rightCorner": {
              "x": 1.988,
              "y": 37.8,
              "z": 1.496
            },
            "gtin": "4000821370661",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "46886"
  },
  {
    "id": "da3c8",
    "name": "da3c8",
    "x": -11.564,
    "y": 36.882,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.021195,
      "w": 0.99978
    },

    "layers": [],
    "rightNeighborShelfId": "46891"
  },
  {
    "id": "da3d8",
    "name": "da3d8",
    "x": -11.471,
    "y": 41.037,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.020803,
      "w": 0.99978
    },

    "layers": [],
    "rightNeighborShelfId": "d9f7c"
  },
  {
    "id": "da3e4",
    "name": "da3e4",
    "x": 8.962,
    "y": 13.274,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.03565,
      "w": 0.99936
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 36
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5462d7",
        "height": 0.15735,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dee9",
            "leftCorner": {
              "x": 8.963,
              "y": 13.292,
              "z": 0.129
            },
            "rightCorner": {
              "x": 9.171,
              "y": 13.277,
              "z": 0.129
            },
            "gtin": "4008167113713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1deea",
            "leftCorner": {
              "x": 9.171,
              "y": 13.277,
              "z": 0.129
            },
            "rightCorner": {
              "x": 9.378,
              "y": 13.262,
              "z": 0.129
            },
            "gtin": "4008167113713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1deeb",
            "leftCorner": {
              "x": 9.378,
              "y": 13.262,
              "z": 0.129
            },
            "rightCorner": {
              "x": 9.586,
              "y": 13.247,
              "z": 0.129
            },
            "gtin": "4008167113713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1deee",
            "leftCorner": {
              "x": 9.589,
              "y": 13.29,
              "z": 0.129
            },
            "rightCorner": {
              "x": 9.802,
              "y": 13.275,
              "z": 0.129
            },
            "gtin": "4008167103219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1deef",
            "leftCorner": {
              "x": 9.802,
              "y": 13.275,
              "z": 0.129
            },
            "rightCorner": {
              "x": 10.016,
              "y": 13.259,
              "z": 0.129
            },
            "gtin": "4008167103219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1deec",
            "leftCorner": {
              "x": 10.015,
              "y": 13.254,
              "z": 0.129
            },
            "rightCorner": {
              "x": 10.089,
              "y": 13.248,
              "z": 0.129
            },
            "gtin": "4008167112235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1deed",
            "leftCorner": {
              "x": 10.089,
              "y": 13.248,
              "z": 0.129
            },
            "rightCorner": {
              "x": 10.163,
              "y": 13.244,
              "z": 0.129
            },
            "gtin": "4008167112235",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462d5",
        "height": 0.75901,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1ded8",
            "leftCorner": {
              "x": 8.963,
              "y": 13.286,
              "z": 0.621
            },
            "rightCorner": {
              "x": 9.371,
              "y": 13.257,
              "z": 0.621
            },
            "gtin": "4006581012407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ded9",
            "leftCorner": {
              "x": 9.371,
              "y": 13.257,
              "z": 0.621
            },
            "rightCorner": {
              "x": 9.779,
              "y": 13.227,
              "z": 0.621
            },
            "gtin": "4006581012407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dedb",
            "leftCorner": {
              "x": 9.782,
              "y": 13.266,
              "z": 0.621
            },
            "rightCorner": {
              "x": 9.875,
              "y": 13.259,
              "z": 0.621
            },
            "gtin": "4006581001777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dedc",
            "leftCorner": {
              "x": 9.875,
              "y": 13.259,
              "z": 0.621
            },
            "rightCorner": {
              "x": 9.968,
              "y": 13.253,
              "z": 0.621
            },
            "gtin": "4006581001777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1deda",
            "leftCorner": {
              "x": 9.968,
              "y": 13.251,
              "z": 0.621
            },
            "rightCorner": {
              "x": 10.163,
              "y": 13.238,
              "z": 0.621
            },
            "gtin": "4006581170077",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462d4",
        "height": 1.2608,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1decc",
            "leftCorner": {
              "x": 8.963,
              "y": 13.285,
              "z": 1.032
            },
            "rightCorner": {
              "x": 9.177,
              "y": 13.269,
              "z": 1.032
            },
            "gtin": "4008167023500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1decd",
            "leftCorner": {
              "x": 9.177,
              "y": 13.269,
              "z": 1.032
            },
            "rightCorner": {
              "x": 9.392,
              "y": 13.254,
              "z": 1.032
            },
            "gtin": "4008167023500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ded3",
            "leftCorner": {
              "x": 9.394,
              "y": 13.289,
              "z": 1.032
            },
            "rightCorner": {
              "x": 9.456,
              "y": 13.285,
              "z": 1.032
            },
            "gtin": "4008167023906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ded4",
            "leftCorner": {
              "x": 9.456,
              "y": 13.285,
              "z": 1.032
            },
            "rightCorner": {
              "x": 9.518,
              "y": 13.281,
              "z": 1.032
            },
            "gtin": "4008167023906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ded5",
            "leftCorner": {
              "x": 9.518,
              "y": 13.281,
              "z": 1.032
            },
            "rightCorner": {
              "x": 9.579,
              "y": 13.276,
              "z": 1.032
            },
            "gtin": "4008167023906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ded6",
            "leftCorner": {
              "x": 9.58,
              "y": 13.283,
              "z": 1.032
            },
            "rightCorner": {
              "x": 9.69,
              "y": 13.275,
              "z": 1.032
            },
            "gtin": "4008167023609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ded7",
            "leftCorner": {
              "x": 9.69,
              "y": 13.275,
              "z": 1.032
            },
            "rightCorner": {
              "x": 9.8,
              "y": 13.267,
              "z": 1.032
            },
            "gtin": "4008167023609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dece",
            "leftCorner": {
              "x": 9.8,
              "y": 13.267,
              "z": 1.032
            },
            "rightCorner": {
              "x": 9.873,
              "y": 13.261,
              "z": 1.032
            },
            "gtin": "4008167103905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1decf",
            "leftCorner": {
              "x": 9.873,
              "y": 13.261,
              "z": 1.032
            },
            "rightCorner": {
              "x": 9.945,
              "y": 13.257,
              "z": 1.032
            },
            "gtin": "4008167103905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ded0",
            "leftCorner": {
              "x": 9.945,
              "y": 13.257,
              "z": 1.032
            },
            "rightCorner": {
              "x": 10.018,
              "y": 13.251,
              "z": 1.032
            },
            "gtin": "4008167103905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ded1",
            "leftCorner": {
              "x": 10.018,
              "y": 13.251,
              "z": 1.032
            },
            "rightCorner": {
              "x": 10.09,
              "y": 13.246,
              "z": 1.032
            },
            "gtin": "4008167103905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1ded2",
            "leftCorner": {
              "x": 10.09,
              "y": 13.246,
              "z": 1.032
            },
            "rightCorner": {
              "x": 10.163,
              "y": 13.241,
              "z": 1.032
            },
            "gtin": "4008167103905",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462d6",
        "height": 1.761,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dedd",
            "leftCorner": {
              "x": 8.963,
              "y": 13.287,
              "z": 1.441
            },
            "rightCorner": {
              "x": 9.133,
              "y": 13.275,
              "z": 1.441
            },
            "gtin": "4011800330514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dede",
            "leftCorner": {
              "x": 9.133,
              "y": 13.275,
              "z": 1.441
            },
            "rightCorner": {
              "x": 9.303,
              "y": 13.263,
              "z": 1.441
            },
            "gtin": "4011800330514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dedf",
            "leftCorner": {
              "x": 9.303,
              "y": 13.263,
              "z": 1.441
            },
            "rightCorner": {
              "x": 9.473,
              "y": 13.251,
              "z": 1.441
            },
            "gtin": "4011800330514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dee2",
            "leftCorner": {
              "x": 9.475,
              "y": 13.279,
              "z": 1.441
            },
            "rightCorner": {
              "x": 9.554,
              "y": 13.274,
              "z": 1.441
            },
            "gtin": "4011800330118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dee3",
            "leftCorner": {
              "x": 9.554,
              "y": 13.274,
              "z": 1.441
            },
            "rightCorner": {
              "x": 9.631,
              "y": 13.268,
              "z": 1.441
            },
            "gtin": "4011800330118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dee4",
            "leftCorner": {
              "x": 9.633,
              "y": 13.297,
              "z": 1.441
            },
            "rightCorner": {
              "x": 9.725,
              "y": 13.291,
              "z": 1.441
            },
            "gtin": "4000269001264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dee5",
            "leftCorner": {
              "x": 9.725,
              "y": 13.28,
              "z": 1.441
            },
            "rightCorner": {
              "x": 9.8,
              "y": 13.275,
              "z": 1.441
            },
            "gtin": "4000269001226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dee6",
            "leftCorner": {
              "x": 9.799,
              "y": 13.252,
              "z": 1.441
            },
            "rightCorner": {
              "x": 9.905,
              "y": 13.244,
              "z": 1.441
            },
            "gtin": "4000269001288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dee7",
            "leftCorner": {
              "x": 9.906,
              "y": 13.268,
              "z": 1.441
            },
            "rightCorner": {
              "x": 9.981,
              "y": 13.263,
              "z": 1.441
            },
            "gtin": "4000269001189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dee8",
            "leftCorner": {
              "x": 9.981,
              "y": 13.263,
              "z": 1.441
            },
            "rightCorner": {
              "x": 10.056,
              "y": 13.258,
              "z": 1.441
            },
            "gtin": "4000269001189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dee0",
            "leftCorner": {
              "x": 10.056,
              "y": 13.252,
              "z": 1.441
            },
            "rightCorner": {
              "x": 10.109,
              "y": 13.248,
              "z": 1.441
            },
            "gtin": "4000269001202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dee1",
            "leftCorner": {
              "x": 10.109,
              "y": 13.248,
              "z": 1.441
            },
            "rightCorner": {
              "x": 10.163,
              "y": 13.245,
              "z": 1.441
            },
            "gtin": "4000269001202",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "6ebb8"
  },
  {
    "id": "dde68",
    "name": "dde68",
    "x": 1.044,
    "y": -5.92,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69148,
      "w": 0.72239
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 45
    },
    "layers": [
      {
        "id": "682ffddbd15af3232a54613b",
        "height": 1.2469,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cd7c",
            "leftCorner": {
              "x": 0.992,
              "y": -5.918,
              "z": 1.02
            },
            "rightCorner": {
              "x": 1.009,
              "y": -5.516,
              "z": 1.02
            }
          },
          {
            "id": "68300c835ed67a01d9a1cd7d",
            "leftCorner": {
              "x": 0.973,
              "y": -5.514,
              "z": 1.02
            },
            "rightCorner": {
              "x": 1.01,
              "y": -4.667,
              "z": 1.02
            },
            "gtin": "194099000826",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546136",
        "height": 1.833,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cd61",
            "leftCorner": {
              "x": 0.946,
              "y": -4.84,
              "z": 1.5
            },
            "rightCorner": {
              "x": 0.954,
              "y": -4.665,
              "z": 1.5
            },
            "gtin": "013051738891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd60",
            "leftCorner": {
              "x": 0.964,
              "y": -5.916,
              "z": 1.5
            },
            "rightCorner": {
              "x": 0.981,
              "y": -5.521,
              "z": 1.5
            },
            "gtin": "194099002660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd62",
            "leftCorner": {
              "x": 0.982,
              "y": -5.521,
              "z": 1.5
            },
            "rightCorner": {
              "x": 0.998,
              "y": -5.165,
              "z": 1.5
            },
            "gtin": "194099000840",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c835ed67a01d9a1cd63",
            "leftCorner": {
              "x": 0.957,
              "y": -5.163,
              "z": 1.5
            },
            "rightCorner": {
              "x": 0.964,
              "y": -4.997,
              "z": 1.5
            },
            "gtin": "013051743451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd64",
            "leftCorner": {
              "x": 0.953,
              "y": -4.997,
              "z": 1.5
            },
            "rightCorner": {
              "x": 0.96,
              "y": -4.841,
              "z": 1.5
            },
            "gtin": "013051743413",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546138",
        "height": 0.18073,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cd6a",
            "leftCorner": {
              "x": 1.089,
              "y": -5.922,
              "z": 0.148
            },
            "rightCorner": {
              "x": 1.097,
              "y": -5.724,
              "z": 0.148
            },
            "gtin": "194099000789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd6b",
            "leftCorner": {
              "x": 1.097,
              "y": -5.724,
              "z": 0.148
            },
            "rightCorner": {
              "x": 1.106,
              "y": -5.526,
              "z": 0.148
            },
            "gtin": "194099000789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd6e",
            "leftCorner": {
              "x": 1.081,
              "y": -5.525,
              "z": 0.148
            },
            "rightCorner": {
              "x": 1.084,
              "y": -5.46,
              "z": 0.148
            },
            "gtin": "194099086004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd6f",
            "leftCorner": {
              "x": 1.084,
              "y": -5.46,
              "z": 0.148
            },
            "rightCorner": {
              "x": 1.087,
              "y": -5.394,
              "z": 0.148
            },
            "gtin": "194099086004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd70",
            "leftCorner": {
              "x": 1.079,
              "y": -5.394,
              "z": 0.148
            },
            "rightCorner": {
              "x": 1.083,
              "y": -5.304,
              "z": 0.148
            },
            "gtin": "013051864125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd71",
            "leftCorner": {
              "x": 1.083,
              "y": -5.304,
              "z": 0.148
            },
            "rightCorner": {
              "x": 1.087,
              "y": -5.213,
              "z": 0.148
            },
            "gtin": "013051864125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd72",
            "leftCorner": {
              "x": 1.069,
              "y": -5.212,
              "z": 0.148
            },
            "rightCorner": {
              "x": 1.075,
              "y": -5.092,
              "z": 0.148
            },
            "gtin": "194099085960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd73",
            "leftCorner": {
              "x": 1.075,
              "y": -5.092,
              "z": 0.148
            },
            "rightCorner": {
              "x": 1.08,
              "y": -4.971,
              "z": 0.148
            },
            "gtin": "194099085960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd74",
            "leftCorner": {
              "x": 1.074,
              "y": -4.971,
              "z": 0.148
            },
            "rightCorner": {
              "x": 1.076,
              "y": -4.92,
              "z": 0.148
            },
            "gtin": "194099085892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd75",
            "leftCorner": {
              "x": 1.076,
              "y": -4.92,
              "z": 0.148
            },
            "rightCorner": {
              "x": 1.078,
              "y": -4.87,
              "z": 0.148
            },
            "gtin": "194099085892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd6c",
            "leftCorner": {
              "x": 1.065,
              "y": -4.869,
              "z": 0.148
            },
            "rightCorner": {
              "x": 1.069,
              "y": -4.77,
              "z": 0.148
            },
            "gtin": "013051738846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd6d",
            "leftCorner": {
              "x": 1.069,
              "y": -4.77,
              "z": 0.148
            },
            "rightCorner": {
              "x": 1.073,
              "y": -4.67,
              "z": 0.148
            },
            "gtin": "013051738846",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a54613d",
        "height": 0.44161,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cd80",
            "leftCorner": {
              "x": 1.078,
              "y": -5.921,
              "z": 0.361
            },
            "rightCorner": {
              "x": 1.089,
              "y": -5.66,
              "z": 0.361
            },
            "gtin": "194099002615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd81",
            "leftCorner": {
              "x": 1.089,
              "y": -5.66,
              "z": 0.361
            },
            "rightCorner": {
              "x": 1.101,
              "y": -5.398,
              "z": 0.361
            },
            "gtin": "194099002615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd83",
            "leftCorner": {
              "x": 1.077,
              "y": -5.397,
              "z": 0.361
            },
            "rightCorner": {
              "x": 1.082,
              "y": -5.277,
              "z": 0.361
            },
            "gtin": "194099067768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd84",
            "leftCorner": {
              "x": 1.082,
              "y": -5.277,
              "z": 0.361
            },
            "rightCorner": {
              "x": 1.087,
              "y": -5.158,
              "z": 0.361
            },
            "gtin": "194099067768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd85",
            "leftCorner": {
              "x": 1.07,
              "y": -5.157,
              "z": 0.361
            },
            "rightCorner": {
              "x": 1.076,
              "y": -5.025,
              "z": 0.361
            },
            "gtin": "194099067805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd86",
            "leftCorner": {
              "x": 1.076,
              "y": -5.025,
              "z": 0.361
            },
            "rightCorner": {
              "x": 1.082,
              "y": -4.893,
              "z": 0.361
            },
            "gtin": "194099067805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd82",
            "leftCorner": {
              "x": 1.071,
              "y": -4.892,
              "z": 0.361
            },
            "rightCorner": {
              "x": 1.081,
              "y": -4.67,
              "z": 0.361
            },
            "gtin": "013051738969",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546142",
        "height": 0.81125,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cd8e",
            "leftCorner": {
              "x": 0.937,
              "y": -5.915,
              "z": 0.664
            },
            "rightCorner": {
              "x": 0.971,
              "y": -5.143,
              "z": 0.664
            }
          },
          {
            "id": "68300c835ed67a01d9a1cd8f",
            "leftCorner": {
              "x": 0.932,
              "y": -5.141,
              "z": 0.664
            },
            "rightCorner": {
              "x": 0.953,
              "y": -4.665,
              "z": 0.664
            },
            "gtin": "194099084642",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546139",
        "height": 0.87705,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cd76",
            "leftCorner": {
              "x": 0.967,
              "y": -5.917,
              "z": 0.718
            },
            "rightCorner": {
              "x": 0.985,
              "y": -5.496,
              "z": 0.718
            },
            "gtin": "013051487294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd78",
            "leftCorner": {
              "x": 0.953,
              "y": -5.494,
              "z": 0.718
            },
            "rightCorner": {
              "x": 0.962,
              "y": -5.29,
              "z": 0.718
            },
            "gtin": "194099000895",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd79",
            "leftCorner": {
              "x": 0.946,
              "y": -5.29,
              "z": 0.718
            },
            "rightCorner": {
              "x": 0.959,
              "y": -5.0,
              "z": 0.718
            },
            "gtin": "013051864262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd77",
            "leftCorner": {
              "x": 0.96,
              "y": -5.0,
              "z": 0.718
            },
            "rightCorner": {
              "x": 0.975,
              "y": -4.666,
              "z": 0.718
            },
            "gtin": "013051864309",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546144",
        "height": 0.91721,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cd90",
            "leftCorner": {
              "x": 0.93,
              "y": -5.915,
              "z": 0.75
            },
            "rightCorner": {
              "x": 0.979,
              "y": -4.799,
              "z": 0.75
            }
          },
          {
            "id": "68300c835ed67a01d9a1cd91",
            "leftCorner": {
              "x": 0.941,
              "y": -4.798,
              "z": 0.75
            },
            "rightCorner": {
              "x": 0.947,
              "y": -4.665,
              "z": 0.75
            },
            "gtin": "013051423117",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546141",
        "height": 1.0445,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cd8c",
            "leftCorner": {
              "x": 0.938,
              "y": -5.915,
              "z": 0.855
            },
            "rightCorner": {
              "x": 0.972,
              "y": -5.155,
              "z": 0.855
            }
          },
          {
            "id": "68300c835ed67a01d9a1cd8d",
            "leftCorner": {
              "x": 0.935,
              "y": -5.153,
              "z": 0.855
            },
            "rightCorner": {
              "x": 0.957,
              "y": -4.665,
              "z": 0.855
            },
            "gtin": "013051733063",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546147",
        "height": 1.1452,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cd96",
            "leftCorner": {
              "x": 0.937,
              "y": -5.915,
              "z": 0.937
            },
            "rightCorner": {
              "x": 0.984,
              "y": -4.833,
              "z": 0.937
            }
          },
          {
            "id": "68300c835ed67a01d9a1cd97",
            "leftCorner": {
              "x": 0.949,
              "y": -4.831,
              "z": 0.937
            },
            "rightCorner": {
              "x": 0.956,
              "y": -4.665,
              "z": 0.937
            },
            "gtin": "013051741990",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a54613c",
        "height": 1.1713,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cd7e",
            "leftCorner": {
              "x": 1.004,
              "y": -5.918,
              "z": 0.958
            },
            "rightCorner": {
              "x": 1.03,
              "y": -5.311,
              "z": 0.958
            },
            "gtin": "194099000871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd7f",
            "leftCorner": {
              "x": 0.963,
              "y": -5.309,
              "z": 0.958
            },
            "rightCorner": {
              "x": 0.991,
              "y": -4.666,
              "z": 0.958
            },
            "gtin": "194099084635",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546140",
        "height": 1.3058,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cd8a",
            "leftCorner": {
              "x": 0.969,
              "y": -5.917,
              "z": 1.068
            },
            "rightCorner": {
              "x": 1.003,
              "y": -5.139,
              "z": 1.068
            }
          },
          {
            "id": "68300c835ed67a01d9a1cd8b",
            "leftCorner": {
              "x": 0.96,
              "y": -5.138,
              "z": 1.068
            },
            "rightCorner": {
              "x": 0.981,
              "y": -4.666,
              "z": 1.068
            },
            "gtin": "013051864231",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546146",
        "height": 1.343,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cd94",
            "leftCorner": {
              "x": 0.936,
              "y": -5.915,
              "z": 1.099
            },
            "rightCorner": {
              "x": 0.984,
              "y": -4.827,
              "z": 1.099
            }
          },
          {
            "id": "68300c835ed67a01d9a1cd95",
            "leftCorner": {
              "x": 0.945,
              "y": -4.825,
              "z": 1.099
            },
            "rightCorner": {
              "x": 0.952,
              "y": -4.665,
              "z": 1.099
            },
            "gtin": "013051738945",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a54613a",
        "height": 1.4191,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cd7a",
            "leftCorner": {
              "x": 1.009,
              "y": -5.918,
              "z": 1.161
            },
            "rightCorner": {
              "x": 1.019,
              "y": -5.685,
              "z": 1.161
            }
          },
          {
            "id": "68300c835ed67a01d9a1cd7b",
            "leftCorner": {
              "x": 0.989,
              "y": -5.684,
              "z": 1.161
            },
            "rightCorner": {
              "x": 1.033,
              "y": -4.668,
              "z": 1.161
            },
            "gtin": "194099000864",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a54613e",
        "height": 1.5176,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cd87",
            "leftCorner": {
              "x": 0.982,
              "y": -5.917,
              "z": 1.242
            },
            "rightCorner": {
              "x": 1.009,
              "y": -5.321,
              "z": 1.242
            },
            "gtin": "194099000888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd89",
            "leftCorner": {
              "x": 0.962,
              "y": -5.319,
              "z": 1.242
            },
            "rightCorner": {
              "x": 0.971,
              "y": -5.125,
              "z": 1.242
            },
            "gtin": "194099084611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd88",
            "leftCorner": {
              "x": 0.96,
              "y": -5.124,
              "z": 1.242
            },
            "rightCorner": {
              "x": 0.98,
              "y": -4.666,
              "z": 1.242
            },
            "gtin": "013051743444",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546145",
        "height": 1.5485,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cd92",
            "leftCorner": {
              "x": 0.932,
              "y": -5.915,
              "z": 1.267
            },
            "rightCorner": {
              "x": 0.979,
              "y": -4.835,
              "z": 1.267
            }
          },
          {
            "id": "68300c835ed67a01d9a1cd93",
            "leftCorner": {
              "x": 0.948,
              "y": -4.833,
              "z": 1.267
            },
            "rightCorner": {
              "x": 0.955,
              "y": -4.665,
              "z": 1.267
            },
            "gtin": "192937013786",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546137",
        "height": 1.6162,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cd65",
            "leftCorner": {
              "x": 1.017,
              "y": -5.919,
              "z": 1.322
            },
            "rightCorner": {
              "x": 1.028,
              "y": -5.664,
              "z": 1.322
            }
          },
          {
            "id": "68300c835ed67a01d9a1cd66",
            "leftCorner": {
              "x": 0.993,
              "y": -5.663,
              "z": 1.322
            },
            "rightCorner": {
              "x": 1.004,
              "y": -5.414,
              "z": 1.322
            },
            "gtin": "194099002691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd67",
            "leftCorner": {
              "x": 1.004,
              "y": -5.414,
              "z": 1.322
            },
            "rightCorner": {
              "x": 1.015,
              "y": -5.166,
              "z": 1.322
            },
            "gtin": "194099002691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd68",
            "leftCorner": {
              "x": 1.015,
              "y": -5.166,
              "z": 1.322
            },
            "rightCorner": {
              "x": 1.026,
              "y": -4.917,
              "z": 1.322
            },
            "gtin": "194099002691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cd69",
            "leftCorner": {
              "x": 1.026,
              "y": -4.917,
              "z": 1.322
            },
            "rightCorner": {
              "x": 1.036,
              "y": -4.668,
              "z": 1.322
            },
            "gtin": "194099002691",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "99d6e"
  },
  {
    "id": "dde69",
    "name": "dde69",
    "x": 1.77,
    "y": 5.049,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69124,
      "w": 0.72263
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 51
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54620b",
        "height": 0.5613,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1da7a",
            "leftCorner": {
              "x": 1.74,
              "y": 5.54,
              "z": 0.459
            },
            "rightCorner": {
              "x": 1.743,
              "y": 5.607,
              "z": 0.459
            },
            "gtin": "7613036300261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da7b",
            "leftCorner": {
              "x": 1.743,
              "y": 5.607,
              "z": 0.459
            },
            "rightCorner": {
              "x": 1.746,
              "y": 5.674,
              "z": 0.459
            },
            "gtin": "7613036300261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da7c",
            "leftCorner": {
              "x": 1.744,
              "y": 5.674,
              "z": 0.459
            },
            "rightCorner": {
              "x": 1.747,
              "y": 5.76,
              "z": 0.459
            },
            "gtin": "7613037001297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da7d",
            "leftCorner": {
              "x": 1.747,
              "y": 5.76,
              "z": 0.459
            },
            "rightCorner": {
              "x": 1.751,
              "y": 5.845,
              "z": 0.459
            },
            "gtin": "7613037001297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da7e",
            "leftCorner": {
              "x": 1.752,
              "y": 5.845,
              "z": 0.459
            },
            "rightCorner": {
              "x": 1.754,
              "y": 5.904,
              "z": 0.459
            },
            "gtin": "4052700079899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da7f",
            "leftCorner": {
              "x": 1.754,
              "y": 5.904,
              "z": 0.459
            },
            "rightCorner": {
              "x": 1.757,
              "y": 5.963,
              "z": 0.459
            },
            "gtin": "4052700079899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da80",
            "leftCorner": {
              "x": 1.757,
              "y": 5.963,
              "z": 0.459
            },
            "rightCorner": {
              "x": 1.76,
              "y": 6.022,
              "z": 0.459
            },
            "gtin": "4052700079899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da78",
            "leftCorner": {
              "x": 1.764,
              "y": 6.022,
              "z": 0.459
            },
            "rightCorner": {
              "x": 1.777,
              "y": 6.3,
              "z": 0.459
            },
            "gtin": "4052700022970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da79",
            "leftCorner": {
              "x": 1.737,
              "y": 5.473,
              "z": 0.459
            },
            "rightCorner": {
              "x": 1.74,
              "y": 5.54,
              "z": 0.459
            },
            "gtin": "7613036300261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da75",
            "leftCorner": {
              "x": 1.755,
              "y": 5.05,
              "z": 0.459
            },
            "rightCorner": {
              "x": 1.761,
              "y": 5.19,
              "z": 0.459
            },
            "gtin": "7612100906262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da76",
            "leftCorner": {
              "x": 1.761,
              "y": 5.19,
              "z": 0.459
            },
            "rightCorner": {
              "x": 1.768,
              "y": 5.331,
              "z": 0.459
            },
            "gtin": "7612100906262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da77",
            "leftCorner": {
              "x": 1.768,
              "y": 5.331,
              "z": 0.459
            },
            "rightCorner": {
              "x": 1.774,
              "y": 5.471,
              "z": 0.459
            },
            "gtin": "7612100906262",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54620c",
        "height": 1.3533,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1da83",
            "leftCorner": {
              "x": 1.778,
              "y": 5.346,
              "z": 1.107
            },
            "rightCorner": {
              "x": 1.785,
              "y": 5.495,
              "z": 1.107
            },
            "gtin": "4063367398568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da85",
            "leftCorner": {
              "x": 1.743,
              "y": 5.497,
              "z": 1.107
            },
            "rightCorner": {
              "x": 1.748,
              "y": 5.613,
              "z": 1.107
            },
            "gtin": "4001743754539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da86",
            "leftCorner": {
              "x": 1.748,
              "y": 5.613,
              "z": 1.107
            },
            "rightCorner": {
              "x": 1.754,
              "y": 5.73,
              "z": 1.107
            },
            "gtin": "4001743754539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da87",
            "leftCorner": {
              "x": 1.756,
              "y": 5.729,
              "z": 1.107
            },
            "rightCorner": {
              "x": 1.76,
              "y": 5.81,
              "z": 1.107
            },
            "gtin": "4000521037031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da88",
            "leftCorner": {
              "x": 1.758,
              "y": 5.81,
              "z": 1.107
            },
            "rightCorner": {
              "x": 1.762,
              "y": 5.906,
              "z": 1.107
            },
            "gtin": "4000521005450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da89",
            "leftCorner": {
              "x": 1.762,
              "y": 5.906,
              "z": 1.107
            },
            "rightCorner": {
              "x": 1.766,
              "y": 6.002,
              "z": 1.107
            },
            "gtin": "4000521005450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da8a",
            "leftCorner": {
              "x": 1.766,
              "y": 6.002,
              "z": 1.107
            },
            "rightCorner": {
              "x": 1.77,
              "y": 6.098,
              "z": 1.107
            },
            "gtin": "4000521005450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da8b",
            "leftCorner": {
              "x": 1.779,
              "y": 6.098,
              "z": 1.107
            },
            "rightCorner": {
              "x": 1.782,
              "y": 6.16,
              "z": 1.107
            },
            "gtin": "4063367096266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da8c",
            "leftCorner": {
              "x": 1.782,
              "y": 6.16,
              "z": 1.107
            },
            "rightCorner": {
              "x": 1.785,
              "y": 6.222,
              "z": 1.107
            },
            "gtin": "4063367096266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da84",
            "leftCorner": {
              "x": 1.783,
              "y": 6.222,
              "z": 1.107
            },
            "rightCorner": {
              "x": 1.787,
              "y": 6.3,
              "z": 1.107
            },
            "gtin": "7610369422059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da81",
            "leftCorner": {
              "x": 1.765,
              "y": 5.049,
              "z": 1.107
            },
            "rightCorner": {
              "x": 1.772,
              "y": 5.198,
              "z": 1.107
            },
            "gtin": "4063367398568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da82",
            "leftCorner": {
              "x": 1.772,
              "y": 5.198,
              "z": 1.107
            },
            "rightCorner": {
              "x": 1.778,
              "y": 5.346,
              "z": 1.107
            },
            "gtin": "4063367398568",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54620a",
        "height": 1.7021,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1da3d",
            "leftCorner": {
              "x": 1.769,
              "y": 5.049,
              "z": 1.393
            },
            "rightCorner": {
              "x": 1.774,
              "y": 5.145,
              "z": 1.393
            },
            "gtin": "40093345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da3e",
            "leftCorner": {
              "x": 1.774,
              "y": 5.145,
              "z": 1.393
            },
            "rightCorner": {
              "x": 1.778,
              "y": 5.242,
              "z": 1.393
            },
            "gtin": "40093345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da3f",
            "leftCorner": {
              "x": 1.743,
              "y": 5.243,
              "z": 1.393
            },
            "rightCorner": {
              "x": 1.747,
              "y": 5.329,
              "z": 1.393
            },
            "gtin": "4260407953798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da40",
            "leftCorner": {
              "x": 1.747,
              "y": 5.329,
              "z": 1.393
            },
            "rightCorner": {
              "x": 1.751,
              "y": 5.416,
              "z": 1.393
            },
            "gtin": "4260407953798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da41",
            "leftCorner": {
              "x": 1.736,
              "y": 5.416,
              "z": 1.393
            },
            "rightCorner": {
              "x": 1.74,
              "y": 5.512,
              "z": 1.393
            },
            "gtin": "4260407950926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da42",
            "leftCorner": {
              "x": 1.744,
              "y": 5.512,
              "z": 1.393
            },
            "rightCorner": {
              "x": 1.747,
              "y": 5.574,
              "z": 1.393
            },
            "gtin": "4260407953804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da43",
            "leftCorner": {
              "x": 1.747,
              "y": 5.574,
              "z": 1.393
            },
            "rightCorner": {
              "x": 1.749,
              "y": 5.636,
              "z": 1.393
            },
            "gtin": "4260407953804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da44",
            "leftCorner": {
              "x": 1.756,
              "y": 5.636,
              "z": 1.393
            },
            "rightCorner": {
              "x": 1.764,
              "y": 5.811,
              "z": 1.393
            },
            "gtin": "4260407953552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da45",
            "leftCorner": {
              "x": 1.762,
              "y": 5.811,
              "z": 1.393
            },
            "rightCorner": {
              "x": 1.765,
              "y": 5.87,
              "z": 1.393
            },
            "gtin": "4260407954467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da46",
            "leftCorner": {
              "x": 1.765,
              "y": 5.87,
              "z": 1.393
            },
            "rightCorner": {
              "x": 1.768,
              "y": 5.929,
              "z": 1.393
            },
            "gtin": "4260407954467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da47",
            "leftCorner": {
              "x": 1.773,
              "y": 5.929,
              "z": 1.393
            },
            "rightCorner": {
              "x": 1.776,
              "y": 5.992,
              "z": 1.393
            },
            "gtin": "4260407954450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da48",
            "leftCorner": {
              "x": 1.776,
              "y": 5.992,
              "z": 1.393
            },
            "rightCorner": {
              "x": 1.778,
              "y": 6.055,
              "z": 1.393
            },
            "gtin": "4260407954450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da49",
            "leftCorner": {
              "x": 1.779,
              "y": 6.055,
              "z": 1.393
            },
            "rightCorner": {
              "x": 1.782,
              "y": 6.114,
              "z": 1.393
            },
            "gtin": "4260407954443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da4a",
            "leftCorner": {
              "x": 1.782,
              "y": 6.114,
              "z": 1.393
            },
            "rightCorner": {
              "x": 1.784,
              "y": 6.173,
              "z": 1.393
            },
            "gtin": "4260407954443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da4b",
            "leftCorner": {
              "x": 1.79,
              "y": 6.173,
              "z": 1.393
            },
            "rightCorner": {
              "x": 1.792,
              "y": 6.229,
              "z": 1.393
            },
            "gtin": "4260175671887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da4c",
            "leftCorner": {
              "x": 1.785,
              "y": 6.229,
              "z": 1.393
            },
            "rightCorner": {
              "x": 1.788,
              "y": 6.287,
              "z": 1.393
            },
            "gtin": "4013320214817",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54620e",
        "height": 0.14832,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1dab9",
            "leftCorner": {
              "x": 1.755,
              "y": 5.05,
              "z": 0.121
            },
            "rightCorner": {
              "x": 1.769,
              "y": 5.37,
              "z": 0.121
            },
            "gtin": "4052700092287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1daba",
            "leftCorner": {
              "x": 1.769,
              "y": 5.37,
              "z": 0.121
            },
            "rightCorner": {
              "x": 1.783,
              "y": 5.691,
              "z": 0.121
            },
            "gtin": "4052700092287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1dabe",
            "leftCorner": {
              "x": 1.743,
              "y": 5.693,
              "z": 0.121
            },
            "rightCorner": {
              "x": 1.772,
              "y": 6.343,
              "z": 0.121
            },
            "gtin": "8445291232891",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54620d",
        "height": 0.94935,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1da8d",
            "leftCorner": {
              "x": 1.767,
              "y": 5.049,
              "z": 0.777
            },
            "rightCorner": {
              "x": 1.777,
              "y": 5.273,
              "z": 0.777
            },
            "gtin": "7612100909690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da8f",
            "leftCorner": {
              "x": 1.748,
              "y": 5.274,
              "z": 0.777
            },
            "rightCorner": {
              "x": 1.756,
              "y": 5.459,
              "z": 0.777
            },
            "gtin": "7612100909911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da90",
            "leftCorner": {
              "x": 1.756,
              "y": 5.459,
              "z": 0.777
            },
            "rightCorner": {
              "x": 1.764,
              "y": 5.643,
              "z": 0.777
            },
            "gtin": "7612100909911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da91",
            "leftCorner": {
              "x": 1.754,
              "y": 5.644,
              "z": 0.777
            },
            "rightCorner": {
              "x": 1.76,
              "y": 5.782,
              "z": 0.777
            },
            "gtin": "7612100906163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da92",
            "leftCorner": {
              "x": 1.76,
              "y": 5.782,
              "z": 0.777
            },
            "rightCorner": {
              "x": 1.766,
              "y": 5.92,
              "z": 0.777
            },
            "gtin": "7612100906163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da93",
            "leftCorner": {
              "x": 1.758,
              "y": 5.92,
              "z": 0.777
            },
            "rightCorner": {
              "x": 1.766,
              "y": 6.107,
              "z": 0.777
            },
            "gtin": "7612100906125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da94",
            "leftCorner": {
              "x": 1.774,
              "y": 6.107,
              "z": 0.777
            },
            "rightCorner": {
              "x": 1.777,
              "y": 6.176,
              "z": 0.777
            },
            "gtin": "4063367205392",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1da95",
            "leftCorner": {
              "x": 1.779,
              "y": 6.176,
              "z": 0.777
            },
            "rightCorner": {
              "x": 1.784,
              "y": 6.288,
              "z": 0.777
            },
            "gtin": "4052700004808",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "99d6a"
  },
  {
    "id": "dde6e",
    "name": "dde6e",
    "x": 6.903,
    "y": 6.917,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.026168,
      "w": 0.99966
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 16
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546222",
        "height": 0.14745,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a546221",
        "height": 0.59928,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a546223",
        "height": 0.84784,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a546224",
        "height": 1.0963,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a546225",
        "height": 1.3987,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1db31",
            "leftCorner": {
              "x": 6.903,
              "y": 6.927,
              "z": 1.144
            },
            "rightCorner": {
              "x": 7.092,
              "y": 6.917,
              "z": 1.144
            },
            "gtin": "4000400130792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db32",
            "leftCorner": {
              "x": 7.092,
              "y": 6.917,
              "z": 1.144
            },
            "rightCorner": {
              "x": 7.281,
              "y": 6.908,
              "z": 1.144
            },
            "gtin": "4000400130792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db37",
            "leftCorner": {
              "x": 7.282,
              "y": 6.93,
              "z": 1.144
            },
            "rightCorner": {
              "x": 7.431,
              "y": 6.922,
              "z": 1.144
            },
            "gtin": "4000400130822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db38",
            "leftCorner": {
              "x": 7.431,
              "y": 6.922,
              "z": 1.144
            },
            "rightCorner": {
              "x": 7.58,
              "y": 6.914,
              "z": 1.144
            },
            "gtin": "4000400130822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db39",
            "leftCorner": {
              "x": 7.58,
              "y": 6.914,
              "z": 1.144
            },
            "rightCorner": {
              "x": 7.729,
              "y": 6.907,
              "z": 1.144
            },
            "gtin": "4000400130822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db33",
            "leftCorner": {
              "x": 7.73,
              "y": 6.925,
              "z": 1.144
            },
            "rightCorner": {
              "x": 7.824,
              "y": 6.92,
              "z": 1.144
            },
            "gtin": "4012448396740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db34",
            "leftCorner": {
              "x": 7.824,
              "y": 6.92,
              "z": 1.144
            },
            "rightCorner": {
              "x": 7.917,
              "y": 6.915,
              "z": 1.144
            },
            "gtin": "4012448396740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db35",
            "leftCorner": {
              "x": 7.917,
              "y": 6.915,
              "z": 1.144
            },
            "rightCorner": {
              "x": 8.011,
              "y": 6.91,
              "z": 1.144
            },
            "gtin": "4012448396740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1db36",
            "leftCorner": {
              "x": 8.011,
              "y": 6.91,
              "z": 1.144
            },
            "rightCorner": {
              "x": 8.104,
              "y": 6.905,
              "z": 1.144
            },
            "gtin": "4012448396740",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546220",
        "height": 1.7034,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d82a",
            "leftCorner": {
              "x": 6.904,
              "y": 6.934,
              "z": 1.394
            },
            "rightCorner": {
              "x": 7.066,
              "y": 6.926,
              "z": 1.394
            },
            "gtin": "4005500325154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d82b",
            "leftCorner": {
              "x": 7.066,
              "y": 6.926,
              "z": 1.394
            },
            "rightCorner": {
              "x": 7.229,
              "y": 6.917,
              "z": 1.394
            },
            "gtin": "4005500325154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d82c",
            "leftCorner": {
              "x": 7.229,
              "y": 6.917,
              "z": 1.394
            },
            "rightCorner": {
              "x": 7.392,
              "y": 6.909,
              "z": 1.394
            },
            "gtin": "4005500325154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d82f",
            "leftCorner": {
              "x": 7.394,
              "y": 6.947,
              "z": 1.394
            },
            "rightCorner": {
              "x": 7.587,
              "y": 6.937,
              "z": 1.394
            },
            "gtin": "4005500325352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d830",
            "leftCorner": {
              "x": 7.587,
              "y": 6.937,
              "z": 1.394
            },
            "rightCorner": {
              "x": 7.78,
              "y": 6.927,
              "z": 1.394
            },
            "gtin": "4005500325352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d831",
            "leftCorner": {
              "x": 7.78,
              "y": 6.925,
              "z": 1.394
            },
            "rightCorner": {
              "x": 7.938,
              "y": 6.916,
              "z": 1.394
            },
            "gtin": "4000137021806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d832",
            "leftCorner": {
              "x": 7.938,
              "y": 6.916,
              "z": 1.394
            },
            "rightCorner": {
              "x": 8.096,
              "y": 6.908,
              "z": 1.394
            },
            "gtin": "4000137021806",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "e0268"
  },
  {
    "id": "dde9c",
    "name": "dde9c",
    "x": 20.724,
    "y": 0.235,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99963,
      "w": 0.027067
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 12
    },
    "layers": [
      {
        "id": "682ffddfd15af3232a5469cc",
        "height": 0.15761,
        "facings": []
      },
      {
        "id": "682ffddfd15af3232a5469cb",
        "height": 0.67744,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2189a",
            "leftCorner": {
              "x": 20.729,
              "y": 0.313,
              "z": 0.554
            },
            "rightCorner": {
              "x": 20.672,
              "y": 0.316,
              "z": 0.554
            }
          },
          {
            "id": "68300c8b5ed67a01d9a2189b",
            "leftCorner": {
              "x": 20.67,
              "y": 0.277,
              "z": 0.554
            },
            "rightCorner": {
              "x": 20.298,
              "y": 0.297,
              "z": 0.554
            },
            "gtin": "4008671050009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2189c",
            "leftCorner": {
              "x": 20.298,
              "y": 0.297,
              "z": 0.554
            },
            "rightCorner": {
              "x": 19.927,
              "y": 0.317,
              "z": 0.554
            },
            "gtin": "4008671050009",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469cd",
        "height": 1.0733,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2189d",
            "leftCorner": {
              "x": 20.728,
              "y": 0.288,
              "z": 0.878
            },
            "rightCorner": {
              "x": 20.334,
              "y": 0.309,
              "z": 0.878
            },
            "gtin": "4008671025106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2189e",
            "leftCorner": {
              "x": 20.332,
              "y": 0.285,
              "z": 0.878
            },
            "rightCorner": {
              "x": 20.197,
              "y": 0.292,
              "z": 0.878
            },
            "gtin": "4008671025106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2189f",
            "leftCorner": {
              "x": 20.197,
              "y": 0.292,
              "z": 0.878
            },
            "rightCorner": {
              "x": 20.062,
              "y": 0.299,
              "z": 0.878
            },
            "gtin": "4008671025106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a218a0",
            "leftCorner": {
              "x": 20.062,
              "y": 0.299,
              "z": 0.878
            },
            "rightCorner": {
              "x": 19.928,
              "y": 0.307,
              "z": 0.878
            },
            "gtin": "4008671025106",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469ce",
        "height": 1.5093,
        "facings": []
      },
      {
        "id": "682ffddfd15af3232a5469cf",
        "height": 1.7091,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1df00",
            "leftCorner": {
              "x": 20.727,
              "y": 0.283,
              "z": 1.398
            },
            "rightCorner": {
              "x": 20.602,
              "y": 0.29,
              "z": 1.398
            },
            "gtin": "4008671070229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df01",
            "leftCorner": {
              "x": 20.602,
              "y": 0.29,
              "z": 1.398
            },
            "rightCorner": {
              "x": 20.478,
              "y": 0.297,
              "z": 1.398
            },
            "gtin": "4008671070229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df02",
            "leftCorner": {
              "x": 20.478,
              "y": 0.297,
              "z": 1.398
            },
            "rightCorner": {
              "x": 20.354,
              "y": 0.303,
              "z": 1.398
            },
            "gtin": "4008671070229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df03",
            "leftCorner": {
              "x": 20.354,
              "y": 0.303,
              "z": 1.398
            },
            "rightCorner": {
              "x": 20.23,
              "y": 0.31,
              "z": 1.398
            },
            "gtin": "4008671070229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df04",
            "leftCorner": {
              "x": 20.23,
              "y": 0.31,
              "z": 1.398
            },
            "rightCorner": {
              "x": 20.105,
              "y": 0.317,
              "z": 1.398
            },
            "gtin": "4008671070229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df0a",
            "leftCorner": {
              "x": 20.102,
              "y": 0.276,
              "z": 1.398
            },
            "rightCorner": {
              "x": 19.946,
              "y": 0.284,
              "z": 1.398
            },
            "gtin": "4008671014056",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "99d78"
  },
  {
    "id": "ddea5",
    "name": "ddea5",
    "x": 21.95,
    "y": 16.755,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72515,
      "w": 0.68859
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 29
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546949",
        "height": 1.0922,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a216e4",
            "leftCorner": {
              "x": 21.95,
              "y": 15.95,
              "z": 0.894
            },
            "rightCorner": {
              "x": 21.94,
              "y": 15.752,
              "z": 0.894
            },
            "gtin": "024000100812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216e5",
            "leftCorner": {
              "x": 21.94,
              "y": 15.752,
              "z": 0.894
            },
            "rightCorner": {
              "x": 21.93,
              "y": 15.555,
              "z": 0.894
            },
            "gtin": "024000100812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216e2",
            "leftCorner": {
              "x": 21.975,
              "y": 16.754,
              "z": 0.894
            },
            "rightCorner": {
              "x": 21.968,
              "y": 16.617,
              "z": 0.894
            },
            "gtin": "024000012559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216e3",
            "leftCorner": {
              "x": 21.968,
              "y": 16.617,
              "z": 0.894
            },
            "rightCorner": {
              "x": 21.96,
              "y": 16.481,
              "z": 0.894
            },
            "gtin": "024000012559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216e6",
            "leftCorner": {
              "x": 21.998,
              "y": 16.479,
              "z": 0.894
            },
            "rightCorner": {
              "x": 21.992,
              "y": 16.347,
              "z": 0.894
            },
            "gtin": "024000003649",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216e7",
            "leftCorner": {
              "x": 21.992,
              "y": 16.347,
              "z": 0.894
            },
            "rightCorner": {
              "x": 21.985,
              "y": 16.214,
              "z": 0.894
            },
            "gtin": "024000003649",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216e8",
            "leftCorner": {
              "x": 21.985,
              "y": 16.214,
              "z": 0.894
            },
            "rightCorner": {
              "x": 21.978,
              "y": 16.082,
              "z": 0.894
            },
            "gtin": "024000003649",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216e9",
            "leftCorner": {
              "x": 21.978,
              "y": 16.082,
              "z": 0.894
            },
            "rightCorner": {
              "x": 21.971,
              "y": 15.949,
              "z": 0.894
            },
            "gtin": "024000003649",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54694b",
        "height": 1.4449,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1efeb",
            "leftCorner": {
              "x": 21.956,
              "y": 16.755,
              "z": 1.182
            },
            "rightCorner": {
              "x": 21.948,
              "y": 16.594,
              "z": 1.182
            },
            "gtin": "024000001966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efec",
            "leftCorner": {
              "x": 21.948,
              "y": 16.594,
              "z": 1.182
            },
            "rightCorner": {
              "x": 21.939,
              "y": 16.433,
              "z": 1.182
            },
            "gtin": "024000001966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1efef",
            "leftCorner": {
              "x": 21.978,
              "y": 16.43,
              "z": 1.182
            },
            "rightCorner": {
              "x": 21.964,
              "y": 16.144,
              "z": 1.182
            },
            "gtin": "024000011859",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c875ed67a01d9a1eff0",
            "leftCorner": {
              "x": 21.964,
              "y": 16.144,
              "z": 1.182
            },
            "rightCorner": {
              "x": 21.957,
              "y": 15.998,
              "z": 1.182
            },
            "gtin": "024000001645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eff1",
            "leftCorner": {
              "x": 21.957,
              "y": 15.998,
              "z": 1.182
            },
            "rightCorner": {
              "x": 21.95,
              "y": 15.853,
              "z": 1.182
            },
            "gtin": "024000001645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eff2",
            "leftCorner": {
              "x": 21.95,
              "y": 15.853,
              "z": 1.182
            },
            "rightCorner": {
              "x": 21.942,
              "y": 15.707,
              "z": 1.182
            },
            "gtin": "024000001645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1eff3",
            "leftCorner": {
              "x": 21.942,
              "y": 15.707,
              "z": 1.182
            },
            "rightCorner": {
              "x": 21.934,
              "y": 15.561,
              "z": 1.182
            },
            "gtin": "024000001645",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54694a",
        "height": 1.6989,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef96",
            "leftCorner": {
              "x": 21.966,
              "y": 16.754,
              "z": 1.39
            },
            "rightCorner": {
              "x": 21.963,
              "y": 16.698,
              "z": 1.39
            },
            "gtin": "4063367420375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef97",
            "leftCorner": {
              "x": 21.963,
              "y": 16.698,
              "z": 1.39
            },
            "rightCorner": {
              "x": 21.96,
              "y": 16.642,
              "z": 1.39
            },
            "gtin": "4063367420375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef98",
            "leftCorner": {
              "x": 21.96,
              "y": 16.642,
              "z": 1.39
            },
            "rightCorner": {
              "x": 21.957,
              "y": 16.586,
              "z": 1.39
            },
            "gtin": "4063367420375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef99",
            "leftCorner": {
              "x": 21.957,
              "y": 16.586,
              "z": 1.39
            },
            "rightCorner": {
              "x": 21.955,
              "y": 16.53,
              "z": 1.39
            },
            "gtin": "4063367420375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef9b",
            "leftCorner": {
              "x": 21.988,
              "y": 16.528,
              "z": 1.39
            },
            "rightCorner": {
              "x": 21.979,
              "y": 16.354,
              "z": 1.39
            },
            "gtin": "4063367420368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef9c",
            "leftCorner": {
              "x": 21.979,
              "y": 16.354,
              "z": 1.39
            },
            "rightCorner": {
              "x": 21.97,
              "y": 16.18,
              "z": 1.39
            },
            "gtin": "4063367420368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef9d",
            "leftCorner": {
              "x": 21.97,
              "y": 16.18,
              "z": 1.39
            },
            "rightCorner": {
              "x": 21.961,
              "y": 16.007,
              "z": 1.39
            },
            "gtin": "4063367420368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef9e",
            "leftCorner": {
              "x": 21.967,
              "y": 16.006,
              "z": 1.39
            },
            "rightCorner": {
              "x": 21.942,
              "y": 15.531,
              "z": 1.39
            },
            "gtin": "4063367420382",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54694d",
        "height": 0.14081,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f06b",
            "leftCorner": {
              "x": 21.959,
              "y": 16.755,
              "z": 0.115
            },
            "rightCorner": {
              "x": 21.935,
              "y": 16.294,
              "z": 0.115
            },
            "gtin": "4063367437861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f06c",
            "leftCorner": {
              "x": 21.935,
              "y": 16.294,
              "z": 0.115
            },
            "rightCorner": {
              "x": 21.911,
              "y": 15.834,
              "z": 0.115
            },
            "gtin": "4063367437861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f06e",
            "leftCorner": {
              "x": 21.945,
              "y": 15.832,
              "z": 0.115
            },
            "rightCorner": {
              "x": 21.925,
              "y": 15.439,
              "z": 0.115
            },
            "gtin": "4063367437854",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54694c",
        "height": 0.63746,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ef73",
            "leftCorner": {
              "x": 21.975,
              "y": 16.754,
              "z": 0.522
            },
            "rightCorner": {
              "x": 21.969,
              "y": 16.632,
              "z": 0.522
            },
            "gtin": "4008638263756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef74",
            "leftCorner": {
              "x": 21.969,
              "y": 16.632,
              "z": 0.522
            },
            "rightCorner": {
              "x": 21.963,
              "y": 16.51,
              "z": 0.522
            },
            "gtin": "4008638263756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef77",
            "leftCorner": {
              "x": 21.999,
              "y": 16.508,
              "z": 0.522
            },
            "rightCorner": {
              "x": 21.974,
              "y": 16.037,
              "z": 0.522
            },
            "gtin": "024000012313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ef78",
            "leftCorner": {
              "x": 21.974,
              "y": 16.037,
              "z": 0.522
            },
            "rightCorner": {
              "x": 21.95,
              "y": 15.566,
              "z": 0.522
            },
            "gtin": "024000012313",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "9301a"
  },
  {
    "id": "ddeae",
    "name": "ddeae",
    "x": 21.122,
    "y": 7.092,
    "width": 1.35,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.72834,
      "w": 0.68522
    },

    "layers": [],
    "leftNeighborShelfId": "93020",
    "rightNeighborShelfId": "34a49"
  },
  {
    "id": "ddec7",
    "name": "ddec7",
    "x": 9.758,
    "y": 9.816,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.019285,
      "w": 0.99981
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 33
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546297",
        "height": 0.15443,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d364",
            "leftCorner": {
              "x": 9.759,
              "y": 9.834,
              "z": 0.126
            },
            "rightCorner": {
              "x": 10.099,
              "y": 9.822,
              "z": 0.126
            },
            "gtin": "4001762030409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d365",
            "leftCorner": {
              "x": 10.099,
              "y": 9.822,
              "z": 0.126
            },
            "rightCorner": {
              "x": 10.439,
              "y": 9.808,
              "z": 0.126
            },
            "gtin": "4001762030409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d367",
            "leftCorner": {
              "x": 10.441,
              "y": 9.853,
              "z": 0.126
            },
            "rightCorner": {
              "x": 10.634,
              "y": 9.846,
              "z": 0.126
            },
            "gtin": "4001762030454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d368",
            "leftCorner": {
              "x": 10.634,
              "y": 9.846,
              "z": 0.126
            },
            "rightCorner": {
              "x": 10.827,
              "y": 9.838,
              "z": 0.126
            },
            "gtin": "4001762030454",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546293",
        "height": 0.55314,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d304",
            "leftCorner": {
              "x": 9.758,
              "y": 9.83,
              "z": 0.453
            },
            "rightCorner": {
              "x": 9.903,
              "y": 9.824,
              "z": 0.453
            },
            "gtin": "4001762010050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d305",
            "leftCorner": {
              "x": 9.903,
              "y": 9.824,
              "z": 0.453
            },
            "rightCorner": {
              "x": 10.048,
              "y": 9.819,
              "z": 0.453
            },
            "gtin": "4001762010050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d306",
            "leftCorner": {
              "x": 10.048,
              "y": 9.819,
              "z": 0.453
            },
            "rightCorner": {
              "x": 10.193,
              "y": 9.813,
              "z": 0.453
            },
            "gtin": "4001762010050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d309",
            "leftCorner": {
              "x": 10.194,
              "y": 9.863,
              "z": 0.453
            },
            "rightCorner": {
              "x": 10.336,
              "y": 9.858,
              "z": 0.453
            },
            "gtin": "4001762010098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d30a",
            "leftCorner": {
              "x": 10.336,
              "y": 9.858,
              "z": 0.453
            },
            "rightCorner": {
              "x": 10.477,
              "y": 9.852,
              "z": 0.453
            },
            "gtin": "4001762010098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d30b",
            "leftCorner": {
              "x": 10.477,
              "y": 9.84,
              "z": 0.453
            },
            "rightCorner": {
              "x": 10.62,
              "y": 9.835,
              "z": 0.453
            },
            "gtin": "4001762030508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d30c",
            "leftCorner": {
              "x": 10.62,
              "y": 9.835,
              "z": 0.453
            },
            "rightCorner": {
              "x": 10.762,
              "y": 9.829,
              "z": 0.453
            },
            "gtin": "4001762030508",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546295",
        "height": 0.95522,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d2d7",
            "leftCorner": {
              "x": 9.759,
              "y": 9.832,
              "z": 0.782
            },
            "rightCorner": {
              "x": 9.899,
              "y": 9.827,
              "z": 0.782
            },
            "gtin": "4001762010180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2d8",
            "leftCorner": {
              "x": 9.899,
              "y": 9.827,
              "z": 0.782
            },
            "rightCorner": {
              "x": 10.04,
              "y": 9.821,
              "z": 0.782
            },
            "gtin": "4001762010180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2da",
            "leftCorner": {
              "x": 10.041,
              "y": 9.849,
              "z": 0.782
            },
            "rightCorner": {
              "x": 10.196,
              "y": 9.843,
              "z": 0.782
            },
            "gtin": "4001762010029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2db",
            "leftCorner": {
              "x": 10.196,
              "y": 9.843,
              "z": 0.782
            },
            "rightCorner": {
              "x": 10.351,
              "y": 9.837,
              "z": 0.782
            },
            "gtin": "4001762010029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2dc",
            "leftCorner": {
              "x": 10.351,
              "y": 9.849,
              "z": 0.782
            },
            "rightCorner": {
              "x": 10.501,
              "y": 9.843,
              "z": 0.782
            },
            "gtin": "4002861654015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2dd",
            "leftCorner": {
              "x": 10.501,
              "y": 9.843,
              "z": 0.782
            },
            "rightCorner": {
              "x": 10.65,
              "y": 9.837,
              "z": 0.782
            },
            "gtin": "4002861654015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2de",
            "leftCorner": {
              "x": 10.65,
              "y": 9.837,
              "z": 0.782
            },
            "rightCorner": {
              "x": 10.8,
              "y": 9.832,
              "z": 0.782
            },
            "gtin": "4002861654015",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546296",
        "height": 1.3622,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d295",
            "leftCorner": {
              "x": 9.758,
              "y": 9.829,
              "z": 1.115
            },
            "rightCorner": {
              "x": 9.841,
              "y": 9.826,
              "z": 1.115
            },
            "gtin": "8003007827320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d296",
            "leftCorner": {
              "x": 9.841,
              "y": 9.826,
              "z": 1.115
            },
            "rightCorner": {
              "x": 9.923,
              "y": 9.823,
              "z": 1.115
            },
            "gtin": "8003007827320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d297",
            "leftCorner": {
              "x": 9.923,
              "y": 9.823,
              "z": 1.115
            },
            "rightCorner": {
              "x": 10.005,
              "y": 9.82,
              "z": 1.115
            },
            "gtin": "8003007827320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d29b",
            "leftCorner": {
              "x": 10.006,
              "y": 9.86,
              "z": 1.115
            },
            "rightCorner": {
              "x": 10.118,
              "y": 9.855,
              "z": 1.115
            },
            "gtin": "8003007827313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d29c",
            "leftCorner": {
              "x": 10.118,
              "y": 9.855,
              "z": 1.115
            },
            "rightCorner": {
              "x": 10.229,
              "y": 9.851,
              "z": 1.115
            },
            "gtin": "8003007827313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d29d",
            "leftCorner": {
              "x": 10.23,
              "y": 9.867,
              "z": 1.115
            },
            "rightCorner": {
              "x": 10.433,
              "y": 9.859,
              "z": 1.115
            },
            "gtin": "8003007827344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d29e",
            "leftCorner": {
              "x": 10.432,
              "y": 9.822,
              "z": 1.115
            },
            "rightCorner": {
              "x": 10.542,
              "y": 9.818,
              "z": 1.115
            },
            "gtin": "8076809574983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d29f",
            "leftCorner": {
              "x": 10.542,
              "y": 9.82,
              "z": 1.115
            },
            "rightCorner": {
              "x": 10.626,
              "y": 9.816,
              "z": 1.115
            },
            "gtin": "4002861654121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2a0",
            "leftCorner": {
              "x": 10.626,
              "y": 9.816,
              "z": 1.115
            },
            "rightCorner": {
              "x": 10.71,
              "y": 9.813,
              "z": 1.115
            },
            "gtin": "4002861654121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d2a1",
            "leftCorner": {
              "x": 10.71,
              "y": 9.813,
              "z": 1.115
            },
            "rightCorner": {
              "x": 10.792,
              "y": 9.81,
              "z": 1.115
            },
            "gtin": "4002861654121",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546294",
        "height": 1.7099,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d338",
            "leftCorner": {
              "x": 9.758,
              "y": 9.829,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.903,
              "y": 9.823,
              "z": 1.399
            },
            "gtin": "4002676212004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d339",
            "leftCorner": {
              "x": 9.903,
              "y": 9.823,
              "z": 1.399
            },
            "rightCorner": {
              "x": 10.048,
              "y": 9.817,
              "z": 1.399
            },
            "gtin": "4002676212004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d33d",
            "leftCorner": {
              "x": 10.049,
              "y": 9.854,
              "z": 1.399
            },
            "rightCorner": {
              "x": 10.495,
              "y": 9.837,
              "z": 1.399
            },
            "gtin": "4002676212011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d33e",
            "leftCorner": {
              "x": 10.495,
              "y": 9.836,
              "z": 1.399
            },
            "rightCorner": {
              "x": 10.643,
              "y": 9.831,
              "z": 1.399
            },
            "gtin": "4002676232002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d33f",
            "leftCorner": {
              "x": 10.643,
              "y": 9.831,
              "z": 1.399
            },
            "rightCorner": {
              "x": 10.791,
              "y": 9.825,
              "z": 1.399
            },
            "gtin": "4002676232002",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "b6f91",
    "rightNeighborShelfId": "b6f92"
  },
  {
    "id": "ddeca",
    "name": "ddeca",
    "x": 7.025,
    "y": 10.062,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.029064,
      "w": 0.99958
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 45
    },
    "layers": [
      {
        "id": "682ffddfd15af3232a5469a1",
        "height": 0.16682,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd55",
            "leftCorner": {
              "x": 7.027,
              "y": 10.103,
              "z": 0.136
            },
            "rightCorner": {
              "x": 7.346,
              "y": 10.084,
              "z": 0.136
            },
            "gtin": "4032844388903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd58",
            "leftCorner": {
              "x": 7.349,
              "y": 10.125,
              "z": 0.136
            },
            "rightCorner": {
              "x": 7.611,
              "y": 10.11,
              "z": 0.136
            },
            "gtin": "4032844385100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd59",
            "leftCorner": {
              "x": 7.611,
              "y": 10.11,
              "z": 0.136
            },
            "rightCorner": {
              "x": 7.873,
              "y": 10.094,
              "z": 0.136
            },
            "gtin": "4032844385100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd5a",
            "leftCorner": {
              "x": 7.872,
              "y": 10.079,
              "z": 0.136
            },
            "rightCorner": {
              "x": 7.999,
              "y": 10.072,
              "z": 0.136
            },
            "gtin": "4032844380600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd5b",
            "leftCorner": {
              "x": 7.999,
              "y": 10.072,
              "z": 0.136
            },
            "rightCorner": {
              "x": 8.126,
              "y": 10.065,
              "z": 0.136
            },
            "gtin": "4032844380600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd5c",
            "leftCorner": {
              "x": 8.127,
              "y": 10.085,
              "z": 0.136
            },
            "rightCorner": {
              "x": 9.048,
              "y": 10.03,
              "z": 0.136
            },
            "gtin": "4260541683759",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469a0",
        "height": 0.55835,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd48",
            "leftCorner": {
              "x": 7.027,
              "y": 10.094,
              "z": 0.457
            },
            "rightCorner": {
              "x": 7.152,
              "y": 10.087,
              "z": 0.457
            },
            "gtin": "4260541683759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd49",
            "leftCorner": {
              "x": 7.152,
              "y": 10.087,
              "z": 0.457
            },
            "rightCorner": {
              "x": 7.278,
              "y": 10.079,
              "z": 0.457
            },
            "gtin": "4260541683759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd4b",
            "leftCorner": {
              "x": 7.28,
              "y": 10.116,
              "z": 0.457
            },
            "rightCorner": {
              "x": 7.376,
              "y": 10.111,
              "z": 0.457
            },
            "gtin": "9180007870989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd4c",
            "leftCorner": {
              "x": 7.376,
              "y": 10.111,
              "z": 0.457
            },
            "rightCorner": {
              "x": 7.472,
              "y": 10.105,
              "z": 0.457
            },
            "gtin": "9180007870989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd4d",
            "leftCorner": {
              "x": 7.472,
              "y": 10.113,
              "z": 0.457
            },
            "rightCorner": {
              "x": 7.607,
              "y": 10.105,
              "z": 0.457
            },
            "gtin": "9180007870187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd4e",
            "leftCorner": {
              "x": 7.607,
              "y": 10.105,
              "z": 0.457
            },
            "rightCorner": {
              "x": 7.741,
              "y": 10.097,
              "z": 0.457
            },
            "gtin": "9180007870187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd4f",
            "leftCorner": {
              "x": 7.741,
              "y": 10.097,
              "z": 0.457
            },
            "rightCorner": {
              "x": 7.876,
              "y": 10.089,
              "z": 0.457
            },
            "gtin": "9180007870187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd50",
            "leftCorner": {
              "x": 7.876,
              "y": 10.089,
              "z": 0.457
            },
            "rightCorner": {
              "x": 8.01,
              "y": 10.081,
              "z": 0.457
            },
            "gtin": "9180007870187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd51",
            "leftCorner": {
              "x": 8.009,
              "y": 10.057,
              "z": 0.457
            },
            "rightCorner": {
              "x": 8.242,
              "y": 10.043,
              "z": 0.457
            },
            "gtin": "4032844050657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd52",
            "leftCorner": {
              "x": 8.242,
              "y": 10.043,
              "z": 0.457
            },
            "rightCorner": {
              "x": 8.475,
              "y": 10.03,
              "z": 0.457
            },
            "gtin": "4032844050657",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469a2",
        "height": 0.95846,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd3c",
            "leftCorner": {
              "x": 7.026,
              "y": 10.083,
              "z": 0.784
            },
            "rightCorner": {
              "x": 7.154,
              "y": 10.075,
              "z": 0.784
            },
            "gtin": "4045178000038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd3d",
            "leftCorner": {
              "x": 7.154,
              "y": 10.075,
              "z": 0.784
            },
            "rightCorner": {
              "x": 7.282,
              "y": 10.068,
              "z": 0.784
            },
            "gtin": "4045178000038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd40",
            "leftCorner": {
              "x": 7.284,
              "y": 10.1,
              "z": 0.784
            },
            "rightCorner": {
              "x": 7.462,
              "y": 10.089,
              "z": 0.784
            },
            "gtin": "4337185380839",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd41",
            "leftCorner": {
              "x": 7.462,
              "y": 10.097,
              "z": 0.784
            },
            "rightCorner": {
              "x": 7.633,
              "y": 10.087,
              "z": 0.784
            },
            "gtin": "4337185380884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd42",
            "leftCorner": {
              "x": 7.633,
              "y": 10.087,
              "z": 0.784
            },
            "rightCorner": {
              "x": 7.803,
              "y": 10.077,
              "z": 0.784
            },
            "gtin": "4337185380884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd43",
            "leftCorner": {
              "x": 7.803,
              "y": 10.074,
              "z": 0.784
            },
            "rightCorner": {
              "x": 8.438,
              "y": 10.037,
              "z": 0.784
            },
            "gtin": "4337185380860",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a5469a3",
        "height": 1.3652,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd16",
            "leftCorner": {
              "x": 7.026,
              "y": 10.081,
              "z": 1.117
            },
            "rightCorner": {
              "x": 7.225,
              "y": 10.069,
              "z": 1.117
            },
            "gtin": "4045178000014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd17",
            "leftCorner": {
              "x": 7.225,
              "y": 10.069,
              "z": 1.117
            },
            "rightCorner": {
              "x": 7.423,
              "y": 10.058,
              "z": 1.117
            },
            "gtin": "4045178000014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd18",
            "leftCorner": {
              "x": 7.423,
              "y": 10.058,
              "z": 1.117
            },
            "rightCorner": {
              "x": 7.621,
              "y": 10.047,
              "z": 1.117
            },
            "gtin": "4045178000014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd1b",
            "leftCorner": {
              "x": 7.623,
              "y": 10.082,
              "z": 1.117
            },
            "rightCorner": {
              "x": 7.724,
              "y": 10.076,
              "z": 1.117
            },
            "gtin": "4260651480033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd1c",
            "leftCorner": {
              "x": 7.724,
              "y": 10.076,
              "z": 1.117
            },
            "rightCorner": {
              "x": 7.825,
              "y": 10.07,
              "z": 1.117
            },
            "gtin": "4260651480033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd1d",
            "leftCorner": {
              "x": 7.825,
              "y": 10.07,
              "z": 1.117
            },
            "rightCorner": {
              "x": 7.926,
              "y": 10.064,
              "z": 1.117
            },
            "gtin": "4260651480033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd1e",
            "leftCorner": {
              "x": 7.927,
              "y": 10.064,
              "z": 1.117
            },
            "rightCorner": {
              "x": 8.021,
              "y": 10.059,
              "z": 1.117
            },
            "gtin": "4260651480019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd1f",
            "leftCorner": {
              "x": 8.021,
              "y": 10.059,
              "z": 1.117
            },
            "rightCorner": {
              "x": 8.116,
              "y": 10.054,
              "z": 1.117
            },
            "gtin": "4260651480019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd20",
            "leftCorner": {
              "x": 8.116,
              "y": 10.054,
              "z": 1.117
            },
            "rightCorner": {
              "x": 8.211,
              "y": 10.048,
              "z": 1.117
            },
            "gtin": "4260651480019",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a54699f",
        "height": 1.7143,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dd25",
            "leftCorner": {
              "x": 7.027,
              "y": 10.087,
              "z": 1.403
            },
            "rightCorner": {
              "x": 7.058,
              "y": 10.086,
              "z": 1.403
            },
            "gtin": "4260383940058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd26",
            "leftCorner": {
              "x": 7.058,
              "y": 10.086,
              "z": 1.403
            },
            "rightCorner": {
              "x": 7.089,
              "y": 10.084,
              "z": 1.403
            },
            "gtin": "4260383940058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd27",
            "leftCorner": {
              "x": 7.089,
              "y": 10.084,
              "z": 1.403
            },
            "rightCorner": {
              "x": 7.12,
              "y": 10.081,
              "z": 1.403
            },
            "gtin": "4260383940058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd2a",
            "leftCorner": {
              "x": 7.123,
              "y": 10.119,
              "z": 1.403
            },
            "rightCorner": {
              "x": 7.264,
              "y": 10.111,
              "z": 1.403
            },
            "gtin": "4260383940027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd2b",
            "leftCorner": {
              "x": 7.264,
              "y": 10.108,
              "z": 1.403
            },
            "rightCorner": {
              "x": 7.325,
              "y": 10.104,
              "z": 1.403
            },
            "gtin": "4032844584107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd2c",
            "leftCorner": {
              "x": 7.325,
              "y": 10.104,
              "z": 1.403
            },
            "rightCorner": {
              "x": 7.386,
              "y": 10.101,
              "z": 1.403
            },
            "gtin": "4032844584107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd2d",
            "leftCorner": {
              "x": 7.386,
              "y": 10.105,
              "z": 1.403
            },
            "rightCorner": {
              "x": 7.529,
              "y": 10.097,
              "z": 1.403
            },
            "gtin": "4018722344353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd2e",
            "leftCorner": {
              "x": 7.529,
              "y": 10.084,
              "z": 1.403
            },
            "rightCorner": {
              "x": 7.591,
              "y": 10.08,
              "z": 1.403
            },
            "gtin": "4018722344377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd2f",
            "leftCorner": {
              "x": 7.591,
              "y": 10.08,
              "z": 1.403
            },
            "rightCorner": {
              "x": 7.653,
              "y": 10.077,
              "z": 1.403
            },
            "gtin": "4018722344377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd30",
            "leftCorner": {
              "x": 7.653,
              "y": 10.075,
              "z": 1.403
            },
            "rightCorner": {
              "x": 7.782,
              "y": 10.068,
              "z": 1.403
            },
            "gtin": "4018722010814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd31",
            "leftCorner": {
              "x": 7.782,
              "y": 10.068,
              "z": 1.403
            },
            "rightCorner": {
              "x": 7.912,
              "y": 10.06,
              "z": 1.403
            },
            "gtin": "4018722010814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd32",
            "leftCorner": {
              "x": 7.912,
              "y": 10.069,
              "z": 1.403
            },
            "rightCorner": {
              "x": 8.064,
              "y": 10.06,
              "z": 1.403
            },
            "gtin": "4015537002768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd33",
            "leftCorner": {
              "x": 8.064,
              "y": 10.064,
              "z": 1.403
            },
            "rightCorner": {
              "x": 8.235,
              "y": 10.054,
              "z": 1.403
            },
            "gtin": "4015537270365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dd34",
            "leftCorner": {
              "x": 8.235,
              "y": 10.054,
              "z": 1.403
            },
            "rightCorner": {
              "x": 8.406,
              "y": 10.044,
              "z": 1.403
            },
            "gtin": "4015537270365",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "b6f91"
  },
  {
    "id": "dded1",
    "name": "dded1",
    "x": 19.394,
    "y": 10.249,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99911,
      "w": 0.042277
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 68
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5462b6",
        "height": 1.1152,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d18a",
            "leftCorner": {
              "x": 18.426,
              "y": 10.293,
              "z": 0.912
            },
            "rightCorner": {
              "x": 18.355,
              "y": 10.3,
              "z": 0.912
            },
            "gtin": "7613036246675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d18b",
            "leftCorner": {
              "x": 18.355,
              "y": 10.3,
              "z": 0.912
            },
            "rightCorner": {
              "x": 18.283,
              "y": 10.305,
              "z": 0.912
            },
            "gtin": "7613036246675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d18c",
            "leftCorner": {
              "x": 18.283,
              "y": 10.305,
              "z": 0.912
            },
            "rightCorner": {
              "x": 18.21,
              "y": 10.312,
              "z": 0.912
            },
            "gtin": "7613036246675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d18d",
            "leftCorner": {
              "x": 18.21,
              "y": 10.312,
              "z": 0.912
            },
            "rightCorner": {
              "x": 18.139,
              "y": 10.318,
              "z": 0.912
            },
            "gtin": "7613036246675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d17d",
            "leftCorner": {
              "x": 19.394,
              "y": 10.248,
              "z": 0.912
            },
            "rightCorner": {
              "x": 19.29,
              "y": 10.257,
              "z": 0.912
            },
            "gtin": "4005500005827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d17e",
            "leftCorner": {
              "x": 19.29,
              "y": 10.257,
              "z": 0.912
            },
            "rightCorner": {
              "x": 19.187,
              "y": 10.265,
              "z": 0.912
            },
            "gtin": "4005500005827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d17f",
            "leftCorner": {
              "x": 19.187,
              "y": 10.265,
              "z": 0.912
            },
            "rightCorner": {
              "x": 19.085,
              "y": 10.275,
              "z": 0.912
            },
            "gtin": "4005500005827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d180",
            "leftCorner": {
              "x": 19.085,
              "y": 10.275,
              "z": 0.912
            },
            "rightCorner": {
              "x": 18.982,
              "y": 10.283,
              "z": 0.912
            },
            "gtin": "4005500005827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d181",
            "leftCorner": {
              "x": 18.982,
              "y": 10.283,
              "z": 0.912
            },
            "rightCorner": {
              "x": 18.878,
              "y": 10.292,
              "z": 0.912
            },
            "gtin": "4005500005827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d185",
            "leftCorner": {
              "x": 18.875,
              "y": 10.244,
              "z": 0.912
            },
            "rightCorner": {
              "x": 18.795,
              "y": 10.251,
              "z": 0.912
            },
            "gtin": "7613031514793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d186",
            "leftCorner": {
              "x": 18.795,
              "y": 10.251,
              "z": 0.912
            },
            "rightCorner": {
              "x": 18.715,
              "y": 10.259,
              "z": 0.912
            },
            "gtin": "7613031514793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d187",
            "leftCorner": {
              "x": 18.716,
              "y": 10.267,
              "z": 0.912
            },
            "rightCorner": {
              "x": 18.569,
              "y": 10.279,
              "z": 0.912
            },
            "gtin": "7613036457712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d188",
            "leftCorner": {
              "x": 18.57,
              "y": 10.282,
              "z": 0.912
            },
            "rightCorner": {
              "x": 18.498,
              "y": 10.287,
              "z": 0.912
            },
            "gtin": "7613036246675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d189",
            "leftCorner": {
              "x": 18.498,
              "y": 10.287,
              "z": 0.912
            },
            "rightCorner": {
              "x": 18.426,
              "y": 10.293,
              "z": 0.912
            },
            "gtin": "7613036246675",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462bb",
        "height": 1.4114,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d233",
            "leftCorner": {
              "x": 19.393,
              "y": 10.237,
              "z": 1.155
            },
            "rightCorner": {
              "x": 19.118,
              "y": 10.261,
              "z": 1.155
            },
            "gtin": "4000508040306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d234",
            "leftCorner": {
              "x": 19.118,
              "y": 10.261,
              "z": 1.155
            },
            "rightCorner": {
              "x": 18.843,
              "y": 10.283,
              "z": 1.155
            },
            "gtin": "4000508040306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d235",
            "leftCorner": {
              "x": 18.843,
              "y": 10.283,
              "z": 1.155
            },
            "rightCorner": {
              "x": 18.568,
              "y": 10.307,
              "z": 1.155
            },
            "gtin": "4000508040306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d236",
            "leftCorner": {
              "x": 18.568,
              "y": 10.307,
              "z": 1.155
            },
            "rightCorner": {
              "x": 18.294,
              "y": 10.33,
              "z": 1.155
            },
            "gtin": "4000508040306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d238",
            "leftCorner": {
              "x": 18.29,
              "y": 10.29,
              "z": 1.155
            },
            "rightCorner": {
              "x": 18.046,
              "y": 10.31,
              "z": 1.155
            },
            "gtin": "4005500086208",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462b7",
        "height": 1.7077,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d258",
            "leftCorner": {
              "x": 19.393,
              "y": 10.242,
              "z": 1.397
            },
            "rightCorner": {
              "x": 19.317,
              "y": 10.249,
              "z": 1.397
            },
            "gtin": "8711000506509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d259",
            "leftCorner": {
              "x": 19.317,
              "y": 10.249,
              "z": 1.397
            },
            "rightCorner": {
              "x": 19.24,
              "y": 10.255,
              "z": 1.397
            },
            "gtin": "8711000506509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d25a",
            "leftCorner": {
              "x": 19.24,
              "y": 10.255,
              "z": 1.397
            },
            "rightCorner": {
              "x": 19.163,
              "y": 10.262,
              "z": 1.397
            },
            "gtin": "8711000506509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d25b",
            "leftCorner": {
              "x": 19.163,
              "y": 10.262,
              "z": 1.397
            },
            "rightCorner": {
              "x": 19.086,
              "y": 10.268,
              "z": 1.397
            },
            "gtin": "8711000506509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d25e",
            "leftCorner": {
              "x": 19.083,
              "y": 10.229,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.952,
              "y": 10.239,
              "z": 1.397
            },
            "gtin": "4045178000236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d25f",
            "leftCorner": {
              "x": 18.951,
              "y": 10.233,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.807,
              "y": 10.245,
              "z": 1.397
            },
            "gtin": "8711000509005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d260",
            "leftCorner": {
              "x": 18.807,
              "y": 10.249,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.724,
              "y": 10.256,
              "z": 1.397
            },
            "gtin": "4063367396809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d261",
            "leftCorner": {
              "x": 18.724,
              "y": 10.256,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.641,
              "y": 10.263,
              "z": 1.397
            },
            "gtin": "4063367396809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d262",
            "leftCorner": {
              "x": 18.641,
              "y": 10.263,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.558,
              "y": 10.27,
              "z": 1.397
            },
            "gtin": "4063367396809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d263",
            "leftCorner": {
              "x": 18.559,
              "y": 10.278,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.48,
              "y": 10.284,
              "z": 1.397
            },
            "gtin": "7613036310116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d264",
            "leftCorner": {
              "x": 18.48,
              "y": 10.284,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.4,
              "y": 10.291,
              "z": 1.397
            },
            "gtin": "7613036310116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d265",
            "leftCorner": {
              "x": 18.399,
              "y": 10.285,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.337,
              "y": 10.29,
              "z": 1.397
            },
            "gtin": "7613036600996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d266",
            "leftCorner": {
              "x": 18.337,
              "y": 10.29,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.275,
              "y": 10.296,
              "z": 1.397
            },
            "gtin": "7613036600996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d267",
            "leftCorner": {
              "x": 18.275,
              "y": 10.296,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.213,
              "y": 10.302,
              "z": 1.397
            },
            "gtin": "7613036600996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d268",
            "leftCorner": {
              "x": 18.213,
              "y": 10.308,
              "z": 1.397
            },
            "rightCorner": {
              "x": 18.145,
              "y": 10.314,
              "z": 1.397
            },
            "gtin": "7613036914321",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462bc",
        "height": 0.16372,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d200",
            "leftCorner": {
              "x": 19.394,
              "y": 10.245,
              "z": 0.134
            },
            "rightCorner": {
              "x": 19.259,
              "y": 10.256,
              "z": 0.134
            },
            "gtin": "4337185459481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d201",
            "leftCorner": {
              "x": 19.259,
              "y": 10.256,
              "z": 0.134
            },
            "rightCorner": {
              "x": 19.125,
              "y": 10.268,
              "z": 0.134
            },
            "gtin": "4337185459481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d202",
            "leftCorner": {
              "x": 19.125,
              "y": 10.268,
              "z": 0.134
            },
            "rightCorner": {
              "x": 18.99,
              "y": 10.279,
              "z": 0.134
            },
            "gtin": "4337185459481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d203",
            "leftCorner": {
              "x": 18.99,
              "y": 10.279,
              "z": 0.134
            },
            "rightCorner": {
              "x": 18.856,
              "y": 10.291,
              "z": 0.134
            },
            "gtin": "4337185459481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d204",
            "leftCorner": {
              "x": 18.856,
              "y": 10.291,
              "z": 0.134
            },
            "rightCorner": {
              "x": 18.722,
              "y": 10.302,
              "z": 0.134
            },
            "gtin": "4337185459481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d205",
            "leftCorner": {
              "x": 18.722,
              "y": 10.302,
              "z": 0.134
            },
            "rightCorner": {
              "x": 18.587,
              "y": 10.313,
              "z": 0.134
            },
            "gtin": "4337185459481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d207",
            "leftCorner": {
              "x": 18.584,
              "y": 10.279,
              "z": 0.134
            },
            "rightCorner": {
              "x": 18.476,
              "y": 10.288,
              "z": 0.134
            },
            "gtin": "4337185459214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d208",
            "leftCorner": {
              "x": 18.476,
              "y": 10.288,
              "z": 0.134
            },
            "rightCorner": {
              "x": 18.368,
              "y": 10.298,
              "z": 0.134
            },
            "gtin": "4337185459214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d209",
            "leftCorner": {
              "x": 18.368,
              "y": 10.298,
              "z": 0.134
            },
            "rightCorner": {
              "x": 18.26,
              "y": 10.306,
              "z": 0.134
            },
            "gtin": "4337185459214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d20a",
            "leftCorner": {
              "x": 18.26,
              "y": 10.306,
              "z": 0.134
            },
            "rightCorner": {
              "x": 18.152,
              "y": 10.316,
              "z": 0.134
            },
            "gtin": "4337185459214",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462b9",
        "height": 0.49949,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d1d4",
            "leftCorner": {
              "x": 19.393,
              "y": 10.236,
              "z": 0.409
            },
            "rightCorner": {
              "x": 19.258,
              "y": 10.247,
              "z": 0.409
            },
            "gtin": "4063367435492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1d5",
            "leftCorner": {
              "x": 19.258,
              "y": 10.247,
              "z": 0.409
            },
            "rightCorner": {
              "x": 19.123,
              "y": 10.258,
              "z": 0.409
            },
            "gtin": "4063367435492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1d6",
            "leftCorner": {
              "x": 19.123,
              "y": 10.258,
              "z": 0.409
            },
            "rightCorner": {
              "x": 18.988,
              "y": 10.27,
              "z": 0.409
            },
            "gtin": "4063367435492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1d7",
            "leftCorner": {
              "x": 18.988,
              "y": 10.27,
              "z": 0.409
            },
            "rightCorner": {
              "x": 18.853,
              "y": 10.281,
              "z": 0.409
            },
            "gtin": "4063367435492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1d8",
            "leftCorner": {
              "x": 18.853,
              "y": 10.281,
              "z": 0.409
            },
            "rightCorner": {
              "x": 18.718,
              "y": 10.292,
              "z": 0.409
            },
            "gtin": "4063367435492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1dd",
            "leftCorner": {
              "x": 18.714,
              "y": 10.244,
              "z": 0.409
            },
            "rightCorner": {
              "x": 18.615,
              "y": 10.252,
              "z": 0.409
            },
            "gtin": "4063367435515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1de",
            "leftCorner": {
              "x": 18.615,
              "y": 10.252,
              "z": 0.409
            },
            "rightCorner": {
              "x": 18.516,
              "y": 10.26,
              "z": 0.409
            },
            "gtin": "4063367435515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1df",
            "leftCorner": {
              "x": 18.516,
              "y": 10.26,
              "z": 0.409
            },
            "rightCorner": {
              "x": 18.418,
              "y": 10.269,
              "z": 0.409
            },
            "gtin": "4063367435515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1e0",
            "leftCorner": {
              "x": 18.42,
              "y": 10.291,
              "z": 0.409
            },
            "rightCorner": {
              "x": 18.322,
              "y": 10.299,
              "z": 0.409
            },
            "gtin": "4008167037002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1e1",
            "leftCorner": {
              "x": 18.322,
              "y": 10.299,
              "z": 0.409
            },
            "rightCorner": {
              "x": 18.226,
              "y": 10.307,
              "z": 0.409
            },
            "gtin": "4008167037002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1e2",
            "leftCorner": {
              "x": 18.226,
              "y": 10.307,
              "z": 0.409
            },
            "rightCorner": {
              "x": 18.178,
              "y": 10.312,
              "z": 0.409
            },
            "gtin": "4337185671173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1e3",
            "leftCorner": {
              "x": 18.178,
              "y": 10.312,
              "z": 0.409
            },
            "rightCorner": {
              "x": 18.13,
              "y": 10.315,
              "z": 0.409
            },
            "gtin": "4337185671173",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462b8",
        "height": 0.80173,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d1ab",
            "leftCorner": {
              "x": 19.394,
              "y": 10.244,
              "z": 0.656
            },
            "rightCorner": {
              "x": 19.217,
              "y": 10.26,
              "z": 0.656
            },
            "gtin": "8445291739659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1ac",
            "leftCorner": {
              "x": 19.217,
              "y": 10.26,
              "z": 0.656
            },
            "rightCorner": {
              "x": 19.042,
              "y": 10.275,
              "z": 0.656
            },
            "gtin": "8445291739659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1ad",
            "leftCorner": {
              "x": 19.042,
              "y": 10.275,
              "z": 0.656
            },
            "rightCorner": {
              "x": 18.866,
              "y": 10.289,
              "z": 0.656
            },
            "gtin": "8445291739659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1ae",
            "leftCorner": {
              "x": 18.866,
              "y": 10.289,
              "z": 0.656
            },
            "rightCorner": {
              "x": 18.69,
              "y": 10.304,
              "z": 0.656
            },
            "gtin": "8445291739659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1b0",
            "leftCorner": {
              "x": 18.687,
              "y": 10.265,
              "z": 0.656
            },
            "rightCorner": {
              "x": 18.605,
              "y": 10.272,
              "z": 0.656
            },
            "gtin": "7613036305846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1b1",
            "leftCorner": {
              "x": 18.605,
              "y": 10.272,
              "z": 0.656
            },
            "rightCorner": {
              "x": 18.523,
              "y": 10.279,
              "z": 0.656
            },
            "gtin": "7613036305846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1b2",
            "leftCorner": {
              "x": 18.523,
              "y": 10.279,
              "z": 0.656
            },
            "rightCorner": {
              "x": 18.442,
              "y": 10.286,
              "z": 0.656
            },
            "gtin": "7613036305846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1b3",
            "leftCorner": {
              "x": 18.443,
              "y": 10.288,
              "z": 0.656
            },
            "rightCorner": {
              "x": 18.37,
              "y": 10.294,
              "z": 0.656
            },
            "gtin": "7613036347310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1b4",
            "leftCorner": {
              "x": 18.37,
              "y": 10.294,
              "z": 0.656
            },
            "rightCorner": {
              "x": 18.297,
              "y": 10.301,
              "z": 0.656
            },
            "gtin": "7613036347310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1b5",
            "leftCorner": {
              "x": 18.297,
              "y": 10.301,
              "z": 0.656
            },
            "rightCorner": {
              "x": 18.226,
              "y": 10.306,
              "z": 0.656
            },
            "gtin": "7613036347310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1b6",
            "leftCorner": {
              "x": 18.226,
              "y": 10.306,
              "z": 0.656
            },
            "rightCorner": {
              "x": 18.153,
              "y": 10.313,
              "z": 0.656
            },
            "gtin": "7613036347310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d1b7",
            "leftCorner": {
              "x": 18.153,
              "y": 10.313,
              "z": 0.656
            },
            "rightCorner": {
              "x": 18.081,
              "y": 10.319,
              "z": 0.656
            },
            "gtin": "7613036347310",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "b6f8c"
  },
  {
    "id": "ddeda",
    "name": "ddeda",
    "x": 23.173,
    "y": 31.771,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.7305,
      "w": 0.68292
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546911",
        "height": 0.71336,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2161f",
            "leftCorner": {
              "x": 23.189,
              "y": 31.77,
              "z": 0.584
            },
            "rightCorner": {
              "x": 23.184,
              "y": 31.7,
              "z": 0.584
            },
            "gtin": "4001686536025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21620",
            "leftCorner": {
              "x": 23.184,
              "y": 31.7,
              "z": 0.584
            },
            "rightCorner": {
              "x": 23.179,
              "y": 31.631,
              "z": 0.584
            },
            "gtin": "4001686536025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21621",
            "leftCorner": {
              "x": 23.179,
              "y": 31.631,
              "z": 0.584
            },
            "rightCorner": {
              "x": 23.174,
              "y": 31.561,
              "z": 0.584
            },
            "gtin": "4001686536025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21622",
            "leftCorner": {
              "x": 23.174,
              "y": 31.561,
              "z": 0.584
            },
            "rightCorner": {
              "x": 23.169,
              "y": 31.492,
              "z": 0.584
            },
            "gtin": "4001686536025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21625",
            "leftCorner": {
              "x": 23.208,
              "y": 31.49,
              "z": 0.584
            },
            "rightCorner": {
              "x": 23.196,
              "y": 31.292,
              "z": 0.584
            },
            "gtin": "4001686535561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21626",
            "leftCorner": {
              "x": 23.196,
              "y": 31.292,
              "z": 0.584
            },
            "rightCorner": {
              "x": 23.182,
              "y": 31.094,
              "z": 0.584
            },
            "gtin": "4001686535561",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546914",
        "height": 1.1166,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21632",
            "leftCorner": {
              "x": 23.2,
              "y": 31.769,
              "z": 0.914
            },
            "rightCorner": {
              "x": 23.188,
              "y": 31.597,
              "z": 0.914
            },
            "gtin": "4001686505021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21633",
            "leftCorner": {
              "x": 23.188,
              "y": 31.597,
              "z": 0.914
            },
            "rightCorner": {
              "x": 23.177,
              "y": 31.425,
              "z": 0.914
            },
            "gtin": "4001686505021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21634",
            "leftCorner": {
              "x": 23.177,
              "y": 31.425,
              "z": 0.914
            },
            "rightCorner": {
              "x": 23.165,
              "y": 31.253,
              "z": 0.914
            },
            "gtin": "4001686505021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21635",
            "leftCorner": {
              "x": 23.196,
              "y": 31.252,
              "z": 0.914
            },
            "rightCorner": {
              "x": 23.189,
              "y": 31.138,
              "z": 0.914
            },
            "gtin": "745092014428",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546913",
        "height": 1.4664,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2162e",
            "leftCorner": {
              "x": 23.196,
              "y": 31.769,
              "z": 1.2
            },
            "rightCorner": {
              "x": 23.184,
              "y": 31.595,
              "z": 1.2
            },
            "gtin": "4001686502075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2162f",
            "leftCorner": {
              "x": 23.184,
              "y": 31.595,
              "z": 1.2
            },
            "rightCorner": {
              "x": 23.173,
              "y": 31.422,
              "z": 1.2
            },
            "gtin": "4001686502075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21630",
            "leftCorner": {
              "x": 23.173,
              "y": 31.422,
              "z": 1.2
            },
            "rightCorner": {
              "x": 23.161,
              "y": 31.248,
              "z": 1.2
            },
            "gtin": "4001686502075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21631",
            "leftCorner": {
              "x": 23.193,
              "y": 31.247,
              "z": 1.2
            },
            "rightCorner": {
              "x": 23.186,
              "y": 31.139,
              "z": 1.2
            },
            "gtin": "4000607523106",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546912",
        "height": 1.7613,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1ea17",
            "leftCorner": {
              "x": 23.196,
              "y": 31.769,
              "z": 1.441
            },
            "rightCorner": {
              "x": 23.182,
              "y": 31.567,
              "z": 1.441
            },
            "gtin": "4063367404702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea1b",
            "leftCorner": {
              "x": 23.204,
              "y": 31.565,
              "z": 1.441
            },
            "rightCorner": {
              "x": 23.2,
              "y": 31.526,
              "z": 1.441
            },
            "gtin": "4337185686672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea1c",
            "leftCorner": {
              "x": 23.2,
              "y": 31.526,
              "z": 1.441
            },
            "rightCorner": {
              "x": 23.198,
              "y": 31.487,
              "z": 1.441
            },
            "gtin": "4337185686672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea1d",
            "leftCorner": {
              "x": 23.208,
              "y": 31.487,
              "z": 1.441
            },
            "rightCorner": {
              "x": 23.201,
              "y": 31.375,
              "z": 1.441
            },
            "gtin": "4337185932960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea1e",
            "leftCorner": {
              "x": 23.205,
              "y": 31.375,
              "z": 1.441
            },
            "rightCorner": {
              "x": 23.198,
              "y": 31.279,
              "z": 1.441
            },
            "gtin": "4337185933011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1ea1f",
            "leftCorner": {
              "x": 23.195,
              "y": 31.279,
              "z": 1.441
            },
            "rightCorner": {
              "x": 23.186,
              "y": 31.144,
              "z": 1.441
            },
            "gtin": "4009900546102",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "93009"
  },
  {
    "id": "e024c",
    "name": "e024c",
    "x": 7.947,
    "y": 3.452,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036766,
      "w": 0.99932
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 87
    },
    "layers": [
      {
        "id": "682ffddbd15af3232a54616c",
        "height": 0.15169,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d14a",
            "leftCorner": {
              "x": 7.98,
              "y": 3.512,
              "z": 0.124
            },
            "rightCorner": {
              "x": 8.241,
              "y": 3.493,
              "z": 0.124
            },
            "gtin": "4000521102517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d14b",
            "leftCorner": {
              "x": 8.241,
              "y": 3.493,
              "z": 0.124
            },
            "rightCorner": {
              "x": 8.412,
              "y": 3.481,
              "z": 0.124
            },
            "gtin": "4000521103019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d14c",
            "leftCorner": {
              "x": 8.412,
              "y": 3.481,
              "z": 0.124
            },
            "rightCorner": {
              "x": 8.583,
              "y": 3.468,
              "z": 0.124
            },
            "gtin": "4000521103019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d14d",
            "leftCorner": {
              "x": 8.583,
              "y": 3.469,
              "z": 0.124
            },
            "rightCorner": {
              "x": 8.722,
              "y": 3.459,
              "z": 0.124
            },
            "gtin": "4063367507649",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d14e",
            "leftCorner": {
              "x": 8.722,
              "y": 3.459,
              "z": 0.124
            },
            "rightCorner": {
              "x": 8.86,
              "y": 3.448,
              "z": 0.124
            },
            "gtin": "4063367507649",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d14f",
            "leftCorner": {
              "x": 8.86,
              "y": 3.448,
              "z": 0.124
            },
            "rightCorner": {
              "x": 8.999,
              "y": 3.438,
              "z": 0.124
            },
            "gtin": "4063367507649",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d150",
            "leftCorner": {
              "x": 8.999,
              "y": 3.438,
              "z": 0.124
            },
            "rightCorner": {
              "x": 9.138,
              "y": 3.428,
              "z": 0.124
            },
            "gtin": "4063367507649",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a54616d",
        "height": 0.4924,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d0b7",
            "leftCorner": {
              "x": 7.949,
              "y": 3.517,
              "z": 0.403
            },
            "rightCorner": {
              "x": 8.031,
              "y": 3.511,
              "z": 0.403
            },
            "gtin": "4002809022098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0b8",
            "leftCorner": {
              "x": 8.031,
              "y": 3.511,
              "z": 0.403
            },
            "rightCorner": {
              "x": 8.113,
              "y": 3.505,
              "z": 0.403
            },
            "gtin": "4002809022098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0b9",
            "leftCorner": {
              "x": 8.113,
              "y": 3.505,
              "z": 0.403
            },
            "rightCorner": {
              "x": 8.225,
              "y": 3.497,
              "z": 0.403
            },
            "gtin": "4063367041075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0ba",
            "leftCorner": {
              "x": 8.225,
              "y": 3.497,
              "z": 0.403
            },
            "rightCorner": {
              "x": 8.338,
              "y": 3.489,
              "z": 0.403
            },
            "gtin": "4063367041075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0bb",
            "leftCorner": {
              "x": 8.338,
              "y": 3.489,
              "z": 0.403
            },
            "rightCorner": {
              "x": 8.451,
              "y": 3.48,
              "z": 0.403
            },
            "gtin": "4063367041075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0bc",
            "leftCorner": {
              "x": 8.451,
              "y": 3.482,
              "z": 0.403
            },
            "rightCorner": {
              "x": 8.648,
              "y": 3.468,
              "z": 0.403
            },
            "gtin": "8710706106518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0bd",
            "leftCorner": {
              "x": 8.647,
              "y": 3.455,
              "z": 0.403
            },
            "rightCorner": {
              "x": 8.788,
              "y": 3.445,
              "z": 0.403
            },
            "gtin": "8710706306864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0be",
            "leftCorner": {
              "x": 8.789,
              "y": 3.462,
              "z": 0.403
            },
            "rightCorner": {
              "x": 8.876,
              "y": 3.456,
              "z": 0.403
            },
            "gtin": "8710706006511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0bf",
            "leftCorner": {
              "x": 8.876,
              "y": 3.456,
              "z": 0.403
            },
            "rightCorner": {
              "x": 8.962,
              "y": 3.449,
              "z": 0.403
            },
            "gtin": "8710706006511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0c0",
            "leftCorner": {
              "x": 8.962,
              "y": 3.442,
              "z": 0.403
            },
            "rightCorner": {
              "x": 9.111,
              "y": 3.431,
              "z": 0.403
            },
            "gtin": "8710706608562",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a54616f",
        "height": 0.74511,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d044",
            "leftCorner": {
              "x": 7.976,
              "y": 3.51,
              "z": 0.61
            },
            "rightCorner": {
              "x": 8.024,
              "y": 3.506,
              "z": 0.61
            },
            "gtin": "4063367397325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d045",
            "leftCorner": {
              "x": 8.024,
              "y": 3.506,
              "z": 0.61
            },
            "rightCorner": {
              "x": 8.073,
              "y": 3.503,
              "z": 0.61
            },
            "gtin": "4063367397325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d046",
            "leftCorner": {
              "x": 8.073,
              "y": 3.503,
              "z": 0.61
            },
            "rightCorner": {
              "x": 8.136,
              "y": 3.498,
              "z": 0.61
            },
            "gtin": "4000521160418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d047",
            "leftCorner": {
              "x": 8.136,
              "y": 3.498,
              "z": 0.61
            },
            "rightCorner": {
              "x": 8.2,
              "y": 3.493,
              "z": 0.61
            },
            "gtin": "4000521160418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d048",
            "leftCorner": {
              "x": 8.199,
              "y": 3.49,
              "z": 0.61
            },
            "rightCorner": {
              "x": 8.279,
              "y": 3.484,
              "z": 0.61
            },
            "gtin": "4000521021603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d049",
            "leftCorner": {
              "x": 8.279,
              "y": 3.484,
              "z": 0.61
            },
            "rightCorner": {
              "x": 8.358,
              "y": 3.478,
              "z": 0.61
            },
            "gtin": "4000521021603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d04a",
            "leftCorner": {
              "x": 8.359,
              "y": 3.483,
              "z": 0.61
            },
            "rightCorner": {
              "x": 8.482,
              "y": 3.474,
              "z": 0.61
            },
            "gtin": "4000521164317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d04b",
            "leftCorner": {
              "x": 8.482,
              "y": 3.474,
              "z": 0.61
            },
            "rightCorner": {
              "x": 8.605,
              "y": 3.465,
              "z": 0.61
            },
            "gtin": "4000521164317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d04c",
            "leftCorner": {
              "x": 8.606,
              "y": 3.471,
              "z": 0.61
            },
            "rightCorner": {
              "x": 8.678,
              "y": 3.466,
              "z": 0.61
            },
            "gtin": "40352879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d04d",
            "leftCorner": {
              "x": 8.678,
              "y": 3.466,
              "z": 0.61
            },
            "rightCorner": {
              "x": 8.75,
              "y": 3.461,
              "z": 0.61
            },
            "gtin": "40352879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d04e",
            "leftCorner": {
              "x": 8.75,
              "y": 3.454,
              "z": 0.61
            },
            "rightCorner": {
              "x": 8.809,
              "y": 3.45,
              "z": 0.61
            },
            "gtin": "4000521130107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d04f",
            "leftCorner": {
              "x": 8.809,
              "y": 3.45,
              "z": 0.61
            },
            "rightCorner": {
              "x": 8.868,
              "y": 3.446,
              "z": 0.61
            },
            "gtin": "4000521130107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d050",
            "leftCorner": {
              "x": 8.868,
              "y": 3.446,
              "z": 0.61
            },
            "rightCorner": {
              "x": 8.927,
              "y": 3.441,
              "z": 0.61
            },
            "gtin": "4000521130107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d051",
            "leftCorner": {
              "x": 8.927,
              "y": 3.442,
              "z": 0.61
            },
            "rightCorner": {
              "x": 8.976,
              "y": 3.438,
              "z": 0.61
            },
            "gtin": "4002809022401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d052",
            "leftCorner": {
              "x": 8.976,
              "y": 3.438,
              "z": 0.61
            },
            "rightCorner": {
              "x": 9.026,
              "y": 3.435,
              "z": 0.61
            },
            "gtin": "4002809022401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d053",
            "leftCorner": {
              "x": 9.025,
              "y": 3.427,
              "z": 0.61
            },
            "rightCorner": {
              "x": 9.094,
              "y": 3.422,
              "z": 0.61
            },
            "gtin": "4000521034436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d054",
            "leftCorner": {
              "x": 9.094,
              "y": 3.422,
              "z": 0.61
            },
            "rightCorner": {
              "x": 9.163,
              "y": 3.417,
              "z": 0.61
            },
            "gtin": "4000521034436",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a54616e",
        "height": 0.99632,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cfe5",
            "leftCorner": {
              "x": 7.963,
              "y": 3.513,
              "z": 0.815
            },
            "rightCorner": {
              "x": 8.022,
              "y": 3.508,
              "z": 0.815
            },
            "gtin": "4000521721619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfe6",
            "leftCorner": {
              "x": 8.021,
              "y": 3.496,
              "z": 0.815
            },
            "rightCorner": {
              "x": 8.114,
              "y": 3.489,
              "z": 0.815
            },
            "gtin": "4000521722609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfe7",
            "leftCorner": {
              "x": 8.114,
              "y": 3.489,
              "z": 0.815
            },
            "rightCorner": {
              "x": 8.206,
              "y": 3.483,
              "z": 0.815
            },
            "gtin": "4000521722609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfe8",
            "leftCorner": {
              "x": 8.207,
              "y": 3.492,
              "z": 0.815
            },
            "rightCorner": {
              "x": 8.248,
              "y": 3.489,
              "z": 0.815
            },
            "gtin": "4000521741006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfe9",
            "leftCorner": {
              "x": 8.248,
              "y": 3.489,
              "z": 0.815
            },
            "rightCorner": {
              "x": 8.29,
              "y": 3.486,
              "z": 0.815
            },
            "gtin": "4000521741006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfea",
            "leftCorner": {
              "x": 8.29,
              "y": 3.487,
              "z": 0.815
            },
            "rightCorner": {
              "x": 8.374,
              "y": 3.481,
              "z": 0.815
            },
            "gtin": "4337185504488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfeb",
            "leftCorner": {
              "x": 8.374,
              "y": 3.481,
              "z": 0.815
            },
            "rightCorner": {
              "x": 8.459,
              "y": 3.475,
              "z": 0.815
            },
            "gtin": "4337185504488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfec",
            "leftCorner": {
              "x": 8.459,
              "y": 3.475,
              "z": 0.815
            },
            "rightCorner": {
              "x": 8.543,
              "y": 3.468,
              "z": 0.815
            },
            "gtin": "4337185504488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfed",
            "leftCorner": {
              "x": 8.544,
              "y": 3.475,
              "z": 0.815
            },
            "rightCorner": {
              "x": 8.602,
              "y": 3.471,
              "z": 0.815
            },
            "gtin": "4002809945328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfee",
            "leftCorner": {
              "x": 8.602,
              "y": 3.471,
              "z": 0.815
            },
            "rightCorner": {
              "x": 8.66,
              "y": 3.467,
              "z": 0.815
            },
            "gtin": "4002809945328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfef",
            "leftCorner": {
              "x": 8.659,
              "y": 3.457,
              "z": 0.815
            },
            "rightCorner": {
              "x": 8.73,
              "y": 3.452,
              "z": 0.815
            },
            "gtin": "4000521003357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cff0",
            "leftCorner": {
              "x": 8.73,
              "y": 3.452,
              "z": 0.815
            },
            "rightCorner": {
              "x": 8.8,
              "y": 3.447,
              "z": 0.815
            },
            "gtin": "4000521003357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cff1",
            "leftCorner": {
              "x": 8.8,
              "y": 3.447,
              "z": 0.815
            },
            "rightCorner": {
              "x": 8.871,
              "y": 3.442,
              "z": 0.815
            },
            "gtin": "4000521003357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cff2",
            "leftCorner": {
              "x": 8.87,
              "y": 3.425,
              "z": 0.815
            },
            "rightCorner": {
              "x": 8.909,
              "y": 3.423,
              "z": 0.815
            },
            "gtin": "4000147002819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cff3",
            "leftCorner": {
              "x": 8.909,
              "y": 3.423,
              "z": 0.815
            },
            "rightCorner": {
              "x": 8.948,
              "y": 3.42,
              "z": 0.815
            },
            "gtin": "4000147002819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cff4",
            "leftCorner": {
              "x": 8.949,
              "y": 3.43,
              "z": 0.815
            },
            "rightCorner": {
              "x": 9.023,
              "y": 3.425,
              "z": 0.815
            },
            "gtin": "4002809050107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cff5",
            "leftCorner": {
              "x": 9.024,
              "y": 3.431,
              "z": 0.815
            },
            "rightCorner": {
              "x": 9.115,
              "y": 3.424,
              "z": 0.815
            },
            "gtin": "4337185504549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cff6",
            "leftCorner": {
              "x": 9.115,
              "y": 3.424,
              "z": 0.815
            },
            "rightCorner": {
              "x": 9.207,
              "y": 3.417,
              "z": 0.815
            },
            "gtin": "4337185504549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cff7",
            "leftCorner": {
              "x": 9.207,
              "y": 3.417,
              "z": 0.815
            },
            "rightCorner": {
              "x": 9.299,
              "y": 3.41,
              "z": 0.815
            },
            "gtin": "4337185504549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cff8",
            "leftCorner": {
              "x": 9.299,
              "y": 3.41,
              "z": 0.815
            },
            "rightCorner": {
              "x": 9.39,
              "y": 3.404,
              "z": 0.815
            },
            "gtin": "4337185504549",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546172",
        "height": 1.2519,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cf8d",
            "leftCorner": {
              "x": 8.031,
              "y": 3.509,
              "z": 1.024
            },
            "rightCorner": {
              "x": 8.14,
              "y": 3.501,
              "z": 1.024
            },
            "gtin": "4067776048328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf8e",
            "leftCorner": {
              "x": 8.14,
              "y": 3.5,
              "z": 1.024
            },
            "rightCorner": {
              "x": 8.253,
              "y": 3.492,
              "z": 1.024
            },
            "gtin": "4337185504570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf8f",
            "leftCorner": {
              "x": 8.253,
              "y": 3.492,
              "z": 1.024
            },
            "rightCorner": {
              "x": 8.366,
              "y": 3.484,
              "z": 1.024
            },
            "gtin": "4337185504570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf90",
            "leftCorner": {
              "x": 8.366,
              "y": 3.484,
              "z": 1.024
            },
            "rightCorner": {
              "x": 8.479,
              "y": 3.475,
              "z": 1.024
            },
            "gtin": "4337185504570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf91",
            "leftCorner": {
              "x": 8.479,
              "y": 3.475,
              "z": 1.024
            },
            "rightCorner": {
              "x": 8.572,
              "y": 3.468,
              "z": 1.024
            },
            "gtin": "4002809945304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf92",
            "leftCorner": {
              "x": 8.572,
              "y": 3.468,
              "z": 1.024
            },
            "rightCorner": {
              "x": 8.665,
              "y": 3.461,
              "z": 1.024
            },
            "gtin": "4002809945304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf93",
            "leftCorner": {
              "x": 8.665,
              "y": 3.461,
              "z": 1.024
            },
            "rightCorner": {
              "x": 8.758,
              "y": 3.454,
              "z": 1.024
            },
            "gtin": "4002809945304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf94",
            "leftCorner": {
              "x": 8.757,
              "y": 3.452,
              "z": 1.024
            },
            "rightCorner": {
              "x": 8.858,
              "y": 3.444,
              "z": 1.024
            },
            "gtin": "4002809050091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf95",
            "leftCorner": {
              "x": 8.858,
              "y": 3.444,
              "z": 1.024
            },
            "rightCorner": {
              "x": 8.939,
              "y": 3.438,
              "z": 1.024
            },
            "gtin": "4250448352896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf96",
            "leftCorner": {
              "x": 8.939,
              "y": 3.438,
              "z": 1.024
            },
            "rightCorner": {
              "x": 9.02,
              "y": 3.432,
              "z": 1.024
            },
            "gtin": "4250448352896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf97",
            "leftCorner": {
              "x": 9.019,
              "y": 3.43,
              "z": 1.024
            },
            "rightCorner": {
              "x": 9.107,
              "y": 3.423,
              "z": 1.024
            },
            "gtin": "4250448341661",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546171",
        "height": 1.503,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d111",
            "leftCorner": {
              "x": 7.963,
              "y": 3.5,
              "z": 1.23
            },
            "rightCorner": {
              "x": 8.041,
              "y": 3.495,
              "z": 1.23
            },
            "gtin": "4002809021916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d112",
            "leftCorner": {
              "x": 8.042,
              "y": 3.503,
              "z": 1.23
            },
            "rightCorner": {
              "x": 8.13,
              "y": 3.497,
              "z": 1.23
            },
            "gtin": "4002809021756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d113",
            "leftCorner": {
              "x": 8.13,
              "y": 3.497,
              "z": 1.23
            },
            "rightCorner": {
              "x": 8.218,
              "y": 3.49,
              "z": 1.23
            },
            "gtin": "4002809021756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d114",
            "leftCorner": {
              "x": 8.218,
              "y": 3.49,
              "z": 1.23
            },
            "rightCorner": {
              "x": 8.307,
              "y": 3.484,
              "z": 1.23
            },
            "gtin": "4002809021756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d115",
            "leftCorner": {
              "x": 8.306,
              "y": 3.477,
              "z": 1.23
            },
            "rightCorner": {
              "x": 8.513,
              "y": 3.462,
              "z": 1.23
            },
            "gtin": "4000521170608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d116",
            "leftCorner": {
              "x": 8.513,
              "y": 3.462,
              "z": 1.23
            },
            "rightCorner": {
              "x": 8.72,
              "y": 3.446,
              "z": 1.23
            },
            "gtin": "4000521170608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d117",
            "leftCorner": {
              "x": 8.72,
              "y": 3.441,
              "z": 1.23
            },
            "rightCorner": {
              "x": 8.85,
              "y": 3.432,
              "z": 1.23
            },
            "gtin": "4000521170516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d118",
            "leftCorner": {
              "x": 8.85,
              "y": 3.432,
              "z": 1.23
            },
            "rightCorner": {
              "x": 8.979,
              "y": 3.422,
              "z": 1.23
            },
            "gtin": "4000521170516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d119",
            "leftCorner": {
              "x": 8.979,
              "y": 3.422,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.109,
              "y": 3.413,
              "z": 1.23
            },
            "gtin": "4000521170516",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546170",
        "height": 1.7052,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cefc",
            "leftCorner": {
              "x": 7.949,
              "y": 3.507,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.042,
              "y": 3.5,
              "z": 1.395
            },
            "gtin": "40356709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cefd",
            "leftCorner": {
              "x": 8.041,
              "y": 3.487,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.113,
              "y": 3.482,
              "z": 1.395
            },
            "gtin": "4035600906403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cefe",
            "leftCorner": {
              "x": 8.114,
              "y": 3.497,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.211,
              "y": 3.49,
              "z": 1.395
            },
            "gtin": "4002809003905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceff",
            "leftCorner": {
              "x": 8.211,
              "y": 3.485,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.297,
              "y": 3.478,
              "z": 1.395
            },
            "gtin": "4002809001253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf00",
            "leftCorner": {
              "x": 8.297,
              "y": 3.472,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.353,
              "y": 3.468,
              "z": 1.395
            },
            "gtin": "4002809021923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf01",
            "leftCorner": {
              "x": 8.353,
              "y": 3.468,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.41,
              "y": 3.464,
              "z": 1.395
            },
            "gtin": "4002809021923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf02",
            "leftCorner": {
              "x": 8.41,
              "y": 3.462,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.54,
              "y": 3.453,
              "z": 1.395
            },
            "gtin": "4000521034375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf03",
            "leftCorner": {
              "x": 8.541,
              "y": 3.463,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.637,
              "y": 3.456,
              "z": 1.395
            },
            "gtin": "4000521034412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf04",
            "leftCorner": {
              "x": 8.637,
              "y": 3.456,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.733,
              "y": 3.449,
              "z": 1.395
            },
            "gtin": "4000521034412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf05",
            "leftCorner": {
              "x": 8.733,
              "y": 3.452,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.835,
              "y": 3.444,
              "z": 1.395
            },
            "gtin": "4000521034399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf06",
            "leftCorner": {
              "x": 8.835,
              "y": 3.446,
              "z": 1.395
            },
            "rightCorner": {
              "x": 8.918,
              "y": 3.44,
              "z": 1.395
            },
            "gtin": "4000521034351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf07",
            "leftCorner": {
              "x": 8.917,
              "y": 3.434,
              "z": 1.395
            },
            "rightCorner": {
              "x": 9.024,
              "y": 3.426,
              "z": 1.395
            },
            "gtin": "4002809001215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf08",
            "leftCorner": {
              "x": 9.023,
              "y": 3.416,
              "z": 1.395
            },
            "rightCorner": {
              "x": 9.128,
              "y": 3.408,
              "z": 1.395
            },
            "gtin": "4250038942605",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "06075",
    "rightNeighborShelfId": "e024d"
  },
  {
    "id": "e024d",
    "name": "e024d",
    "x": 9.144,
    "y": 3.363,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036766,
      "w": 0.99932
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 75
    },
    "layers": [
      {
        "id": "682ffddbd15af3232a546178",
        "height": 0.15785,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d151",
            "leftCorner": {
              "x": 9.137,
              "y": 3.418,
              "z": 0.129
            },
            "rightCorner": {
              "x": 9.214,
              "y": 3.412,
              "z": 0.129
            },
            "gtin": "4337185462054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d152",
            "leftCorner": {
              "x": 9.214,
              "y": 3.412,
              "z": 0.129
            },
            "rightCorner": {
              "x": 9.29,
              "y": 3.407,
              "z": 0.129
            },
            "gtin": "4337185462054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d153",
            "leftCorner": {
              "x": 9.29,
              "y": 3.407,
              "z": 0.129
            },
            "rightCorner": {
              "x": 9.366,
              "y": 3.401,
              "z": 0.129
            },
            "gtin": "4337185462054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d154",
            "leftCorner": {
              "x": 9.366,
              "y": 3.395,
              "z": 0.129
            },
            "rightCorner": {
              "x": 9.71,
              "y": 3.37,
              "z": 0.129
            },
            "gtin": "4038934516980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d155",
            "leftCorner": {
              "x": 9.709,
              "y": 3.361,
              "z": 0.129
            },
            "rightCorner": {
              "x": 9.944,
              "y": 3.343,
              "z": 0.129
            },
            "gtin": "4038934507988",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d156",
            "leftCorner": {
              "x": 9.945,
              "y": 3.357,
              "z": 0.129
            },
            "rightCorner": {
              "x": 10.167,
              "y": 3.34,
              "z": 0.129
            },
            "gtin": "4063367507045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d157",
            "leftCorner": {
              "x": 10.167,
              "y": 3.34,
              "z": 0.129
            },
            "rightCorner": {
              "x": 10.389,
              "y": 3.324,
              "z": 0.129
            },
            "gtin": "4063367507045",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546173",
        "height": 0.49751,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d0c1",
            "leftCorner": {
              "x": 9.111,
              "y": 3.427,
              "z": 0.407
            },
            "rightCorner": {
              "x": 9.291,
              "y": 3.414,
              "z": 0.407
            },
            "gtin": "8586012820994",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0c2",
            "leftCorner": {
              "x": 9.291,
              "y": 3.414,
              "z": 0.407
            },
            "rightCorner": {
              "x": 9.472,
              "y": 3.401,
              "z": 0.407
            },
            "gtin": "8586012820994",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0c3",
            "leftCorner": {
              "x": 9.471,
              "y": 3.378,
              "z": 0.407
            },
            "rightCorner": {
              "x": 9.688,
              "y": 3.362,
              "z": 0.407
            },
            "gtin": "4038934516966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0c4",
            "leftCorner": {
              "x": 9.689,
              "y": 3.376,
              "z": 0.407
            },
            "rightCorner": {
              "x": 9.811,
              "y": 3.367,
              "z": 0.407
            },
            "gtin": "4337185618208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0c5",
            "leftCorner": {
              "x": 9.811,
              "y": 3.367,
              "z": 0.407
            },
            "rightCorner": {
              "x": 9.935,
              "y": 3.358,
              "z": 0.407
            },
            "gtin": "4337185618208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0c6",
            "leftCorner": {
              "x": 9.935,
              "y": 3.358,
              "z": 0.407
            },
            "rightCorner": {
              "x": 10.057,
              "y": 3.349,
              "z": 0.407
            },
            "gtin": "4337185618208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0c7",
            "leftCorner": {
              "x": 10.057,
              "y": 3.341,
              "z": 0.407
            },
            "rightCorner": {
              "x": 10.167,
              "y": 3.333,
              "z": 0.407
            },
            "gtin": "4337185618178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0c8",
            "leftCorner": {
              "x": 10.167,
              "y": 3.333,
              "z": 0.407
            },
            "rightCorner": {
              "x": 10.279,
              "y": 3.325,
              "z": 0.407
            },
            "gtin": "4337185618178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0c9",
            "leftCorner": {
              "x": 10.279,
              "y": 3.325,
              "z": 0.407
            },
            "rightCorner": {
              "x": 10.39,
              "y": 3.317,
              "z": 0.407
            },
            "gtin": "4337185618178",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546177",
        "height": 0.75068,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d055",
            "leftCorner": {
              "x": 9.163,
              "y": 3.418,
              "z": 0.614
            },
            "rightCorner": {
              "x": 9.272,
              "y": 3.41,
              "z": 0.614
            },
            "gtin": "4000521020224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d056",
            "leftCorner": {
              "x": 9.272,
              "y": 3.41,
              "z": 0.614
            },
            "rightCorner": {
              "x": 9.38,
              "y": 3.402,
              "z": 0.614
            },
            "gtin": "4000521020224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d057",
            "leftCorner": {
              "x": 9.38,
              "y": 3.402,
              "z": 0.614
            },
            "rightCorner": {
              "x": 9.489,
              "y": 3.394,
              "z": 0.614
            },
            "gtin": "4000521020224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d058",
            "leftCorner": {
              "x": 9.488,
              "y": 3.392,
              "z": 0.614
            },
            "rightCorner": {
              "x": 9.545,
              "y": 3.388,
              "z": 0.614
            },
            "gtin": "4260110085052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d059",
            "leftCorner": {
              "x": 9.545,
              "y": 3.388,
              "z": 0.614
            },
            "rightCorner": {
              "x": 9.601,
              "y": 3.383,
              "z": 0.614
            },
            "gtin": "4260110085052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d05a",
            "leftCorner": {
              "x": 9.6,
              "y": 3.375,
              "z": 0.614
            },
            "rightCorner": {
              "x": 9.721,
              "y": 3.366,
              "z": 0.614
            },
            "gtin": "4000521007065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d05b",
            "leftCorner": {
              "x": 9.722,
              "y": 3.377,
              "z": 0.614
            },
            "rightCorner": {
              "x": 9.788,
              "y": 3.372,
              "z": 0.614
            },
            "gtin": "4000521024604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d05c",
            "leftCorner": {
              "x": 9.788,
              "y": 3.372,
              "z": 0.614
            },
            "rightCorner": {
              "x": 9.853,
              "y": 3.367,
              "z": 0.614
            },
            "gtin": "4000521024604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d05d",
            "leftCorner": {
              "x": 9.853,
              "y": 3.366,
              "z": 0.614
            },
            "rightCorner": {
              "x": 9.899,
              "y": 3.363,
              "z": 0.614
            },
            "gtin": "4000521026417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d05e",
            "leftCorner": {
              "x": 9.899,
              "y": 3.363,
              "z": 0.614
            },
            "rightCorner": {
              "x": 9.944,
              "y": 3.36,
              "z": 0.614
            },
            "gtin": "4000521026417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d05f",
            "leftCorner": {
              "x": 9.944,
              "y": 3.36,
              "z": 0.614
            },
            "rightCorner": {
              "x": 10.128,
              "y": 3.346,
              "z": 0.614
            },
            "gtin": "4000521026448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d060",
            "leftCorner": {
              "x": 10.128,
              "y": 3.341,
              "z": 0.614
            },
            "rightCorner": {
              "x": 10.2,
              "y": 3.336,
              "z": 0.614
            },
            "gtin": "4000521041946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d061",
            "leftCorner": {
              "x": 10.2,
              "y": 3.335,
              "z": 0.614
            },
            "rightCorner": {
              "x": 10.288,
              "y": 3.328,
              "z": 0.614
            },
            "gtin": "4000521037130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d062",
            "leftCorner": {
              "x": 10.288,
              "y": 3.328,
              "z": 0.614
            },
            "rightCorner": {
              "x": 10.376,
              "y": 3.322,
              "z": 0.614
            },
            "gtin": "4000521037130",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546179",
        "height": 1.002,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cff9",
            "leftCorner": {
              "x": 9.39,
              "y": 3.396,
              "z": 0.82
            },
            "rightCorner": {
              "x": 9.462,
              "y": 3.39,
              "z": 0.82
            },
            "gtin": "4000521007041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cffa",
            "leftCorner": {
              "x": 9.462,
              "y": 3.39,
              "z": 0.82
            },
            "rightCorner": {
              "x": 9.534,
              "y": 3.385,
              "z": 0.82
            },
            "gtin": "4000521007041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cffb",
            "leftCorner": {
              "x": 9.534,
              "y": 3.374,
              "z": 0.82
            },
            "rightCorner": {
              "x": 9.588,
              "y": 3.37,
              "z": 0.82
            },
            "gtin": "8720964430690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cffc",
            "leftCorner": {
              "x": 9.588,
              "y": 3.37,
              "z": 0.82
            },
            "rightCorner": {
              "x": 9.642,
              "y": 3.366,
              "z": 0.82
            },
            "gtin": "8720964430690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cffd",
            "leftCorner": {
              "x": 9.643,
              "y": 3.378,
              "z": 0.82
            },
            "rightCorner": {
              "x": 9.747,
              "y": 3.37,
              "z": 0.82
            },
            "gtin": "4000266490061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cffe",
            "leftCorner": {
              "x": 9.746,
              "y": 3.361,
              "z": 0.82
            },
            "rightCorner": {
              "x": 9.855,
              "y": 3.353,
              "z": 0.82
            },
            "gtin": "8720964430706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfff",
            "leftCorner": {
              "x": 9.856,
              "y": 3.362,
              "z": 0.82
            },
            "rightCorner": {
              "x": 10.099,
              "y": 3.344,
              "z": 0.82
            },
            "gtin": "4250448347847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d000",
            "leftCorner": {
              "x": 10.099,
              "y": 3.342,
              "z": 0.82
            },
            "rightCorner": {
              "x": 10.189,
              "y": 3.335,
              "z": 0.82
            },
            "gtin": "4000521022297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d001",
            "leftCorner": {
              "x": 10.189,
              "y": 3.335,
              "z": 0.82
            },
            "rightCorner": {
              "x": 10.278,
              "y": 3.329,
              "z": 0.82
            },
            "gtin": "4000521022297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d002",
            "leftCorner": {
              "x": 10.278,
              "y": 3.329,
              "z": 0.82
            },
            "rightCorner": {
              "x": 10.368,
              "y": 3.322,
              "z": 0.82
            },
            "gtin": "4000521022297",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546175",
        "height": 1.2556,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cf98",
            "leftCorner": {
              "x": 9.107,
              "y": 3.414,
              "z": 1.027
            },
            "rightCorner": {
              "x": 9.236,
              "y": 3.404,
              "z": 1.027
            },
            "gtin": "4000266250115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf99",
            "leftCorner": {
              "x": 9.236,
              "y": 3.403,
              "z": 1.027
            },
            "rightCorner": {
              "x": 9.376,
              "y": 3.393,
              "z": 1.027
            },
            "gtin": "4000521035099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf9a",
            "leftCorner": {
              "x": 9.376,
              "y": 3.391,
              "z": 1.027
            },
            "rightCorner": {
              "x": 9.546,
              "y": 3.379,
              "z": 1.027
            },
            "gtin": "4000521035112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf9b",
            "leftCorner": {
              "x": 9.546,
              "y": 3.376,
              "z": 1.027
            },
            "rightCorner": {
              "x": 9.675,
              "y": 3.366,
              "z": 1.027
            },
            "gtin": "4000521030919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf9c",
            "leftCorner": {
              "x": 9.675,
              "y": 3.371,
              "z": 1.027
            },
            "rightCorner": {
              "x": 9.743,
              "y": 3.366,
              "z": 1.027
            },
            "gtin": "4000521030896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf9d",
            "leftCorner": {
              "x": 9.743,
              "y": 3.366,
              "z": 1.027
            },
            "rightCorner": {
              "x": 9.812,
              "y": 3.361,
              "z": 1.027
            },
            "gtin": "4000521030896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf9e",
            "leftCorner": {
              "x": 9.812,
              "y": 3.362,
              "z": 1.027
            },
            "rightCorner": {
              "x": 9.891,
              "y": 3.356,
              "z": 1.027
            },
            "gtin": "4000521006969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf9f",
            "leftCorner": {
              "x": 9.891,
              "y": 3.356,
              "z": 1.027
            },
            "rightCorner": {
              "x": 9.97,
              "y": 3.35,
              "z": 1.027
            },
            "gtin": "4000521006969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfa0",
            "leftCorner": {
              "x": 9.97,
              "y": 3.348,
              "z": 1.027
            },
            "rightCorner": {
              "x": 10.048,
              "y": 3.342,
              "z": 1.027
            },
            "gtin": "4000266490030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfa1",
            "leftCorner": {
              "x": 10.048,
              "y": 3.348,
              "z": 1.027
            },
            "rightCorner": {
              "x": 10.144,
              "y": 3.341,
              "z": 1.027
            },
            "gtin": "4000521022273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfa2",
            "leftCorner": {
              "x": 10.144,
              "y": 3.335,
              "z": 1.027
            },
            "rightCorner": {
              "x": 10.346,
              "y": 3.32,
              "z": 1.027
            },
            "gtin": "4337185756641",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546174",
        "height": 1.503,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d11a",
            "leftCorner": {
              "x": 9.11,
              "y": 3.423,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.227,
              "y": 3.415,
              "z": 1.23
            },
            "gtin": "4000266520515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d11b",
            "leftCorner": {
              "x": 9.227,
              "y": 3.415,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.344,
              "y": 3.406,
              "z": 1.23
            },
            "gtin": "4000266520515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d11c",
            "leftCorner": {
              "x": 9.344,
              "y": 3.402,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.405,
              "y": 3.397,
              "z": 1.23
            },
            "gtin": "4000266410403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d11d",
            "leftCorner": {
              "x": 9.405,
              "y": 3.397,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.466,
              "y": 3.393,
              "z": 1.23
            },
            "gtin": "4000266410403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d11e",
            "leftCorner": {
              "x": 9.465,
              "y": 3.39,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.705,
              "y": 3.372,
              "z": 1.23
            },
            "gtin": "4000266610506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d11f",
            "leftCorner": {
              "x": 9.705,
              "y": 3.371,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.821,
              "y": 3.362,
              "z": 1.23
            },
            "gtin": "4000266810753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d120",
            "leftCorner": {
              "x": 9.821,
              "y": 3.362,
              "z": 1.23
            },
            "rightCorner": {
              "x": 9.937,
              "y": 3.354,
              "z": 1.23
            },
            "gtin": "4000266810753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d121",
            "leftCorner": {
              "x": 9.938,
              "y": 3.36,
              "z": 1.23
            },
            "rightCorner": {
              "x": 10.141,
              "y": 3.345,
              "z": 1.23
            },
            "gtin": "4000266750509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d122",
            "leftCorner": {
              "x": 10.141,
              "y": 3.345,
              "z": 1.23
            },
            "rightCorner": {
              "x": 10.344,
              "y": 3.33,
              "z": 1.23
            },
            "gtin": "4000266750509",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a546176",
        "height": 1.7096,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cf09",
            "leftCorner": {
              "x": 9.128,
              "y": 3.41,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.231,
              "y": 3.403,
              "z": 1.399
            },
            "gtin": "5060234989279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf0a",
            "leftCorner": {
              "x": 9.231,
              "y": 3.402,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.286,
              "y": 3.398,
              "z": 1.399
            },
            "gtin": "4260175671665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf0b",
            "leftCorner": {
              "x": 9.286,
              "y": 3.398,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.342,
              "y": 3.393,
              "z": 1.399
            },
            "gtin": "4260175671665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf0c",
            "leftCorner": {
              "x": 9.342,
              "y": 3.396,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.471,
              "y": 3.387,
              "z": 1.399
            },
            "gtin": "4260175671177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf0d",
            "leftCorner": {
              "x": 9.471,
              "y": 3.384,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.6,
              "y": 3.374,
              "z": 1.399
            },
            "gtin": "4260175671528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf0e",
            "leftCorner": {
              "x": 9.6,
              "y": 3.377,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.682,
              "y": 3.371,
              "z": 1.399
            },
            "gtin": "4260175671030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf0f",
            "leftCorner": {
              "x": 9.682,
              "y": 3.371,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.764,
              "y": 3.365,
              "z": 1.399
            },
            "gtin": "4260175671030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf10",
            "leftCorner": {
              "x": 9.763,
              "y": 3.361,
              "z": 1.399
            },
            "rightCorner": {
              "x": 9.923,
              "y": 3.349,
              "z": 1.399
            },
            "gtin": "4260175671009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf11",
            "leftCorner": {
              "x": 9.923,
              "y": 3.355,
              "z": 1.399
            },
            "rightCorner": {
              "x": 10.092,
              "y": 3.342,
              "z": 1.399
            },
            "gtin": "4337185834257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf12",
            "leftCorner": {
              "x": 10.092,
              "y": 3.338,
              "z": 1.399
            },
            "rightCorner": {
              "x": 10.133,
              "y": 3.335,
              "z": 1.399
            },
            "gtin": "4337185527142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf13",
            "leftCorner": {
              "x": 10.133,
              "y": 3.335,
              "z": 1.399
            },
            "rightCorner": {
              "x": 10.176,
              "y": 3.332,
              "z": 1.399
            },
            "gtin": "4337185527142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf14",
            "leftCorner": {
              "x": 10.176,
              "y": 3.332,
              "z": 1.399
            },
            "rightCorner": {
              "x": 10.218,
              "y": 3.329,
              "z": 1.399
            },
            "gtin": "4337185527142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf15",
            "leftCorner": {
              "x": 10.218,
              "y": 3.329,
              "z": 1.399
            },
            "rightCorner": {
              "x": 10.26,
              "y": 3.325,
              "z": 1.399
            },
            "gtin": "4337185527142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf16",
            "leftCorner": {
              "x": 10.261,
              "y": 3.339,
              "z": 1.399
            },
            "rightCorner": {
              "x": 10.307,
              "y": 3.335,
              "z": 1.399
            },
            "gtin": "4063367397356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf17",
            "leftCorner": {
              "x": 10.307,
              "y": 3.335,
              "z": 1.399
            },
            "rightCorner": {
              "x": 10.352,
              "y": 3.332,
              "z": 1.399
            },
            "gtin": "4063367397356",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e024c",
    "rightNeighborShelfId": "e024e"
  },
  {
    "id": "e024e",
    "name": "e024e",
    "x": 10.341,
    "y": 3.275,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036766,
      "w": 0.99932
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 94
    },
    "layers": [
      {
        "id": "682ffddbd15af3232a54617b",
        "height": 1.5056,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d128",
            "leftCorner": {
              "x": 10.728,
              "y": 3.276,
              "z": 1.232
            },
            "rightCorner": {
              "x": 10.795,
              "y": 3.271,
              "z": 1.232
            },
            "gtin": "40225104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d129",
            "leftCorner": {
              "x": 10.795,
              "y": 3.271,
              "z": 1.232
            },
            "rightCorner": {
              "x": 10.863,
              "y": 3.266,
              "z": 1.232
            },
            "gtin": "40225104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d12a",
            "leftCorner": {
              "x": 10.864,
              "y": 3.279,
              "z": 1.232
            },
            "rightCorner": {
              "x": 10.919,
              "y": 3.275,
              "z": 1.232
            },
            "gtin": "40225159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d12b",
            "leftCorner": {
              "x": 10.919,
              "y": 3.275,
              "z": 1.232
            },
            "rightCorner": {
              "x": 10.974,
              "y": 3.27,
              "z": 1.232
            },
            "gtin": "40225159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d12c",
            "leftCorner": {
              "x": 10.974,
              "y": 3.27,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.03,
              "y": 3.266,
              "z": 1.232
            },
            "gtin": "40225159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d12d",
            "leftCorner": {
              "x": 11.029,
              "y": 3.248,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.113,
              "y": 3.242,
              "z": 1.232
            },
            "gtin": "40225128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d12e",
            "leftCorner": {
              "x": 11.113,
              "y": 3.242,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.196,
              "y": 3.236,
              "z": 1.232
            },
            "gtin": "40225128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d123",
            "leftCorner": {
              "x": 10.343,
              "y": 3.315,
              "z": 1.232
            },
            "rightCorner": {
              "x": 10.413,
              "y": 3.31,
              "z": 1.232
            },
            "gtin": "40225487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d124",
            "leftCorner": {
              "x": 10.413,
              "y": 3.31,
              "z": 1.232
            },
            "rightCorner": {
              "x": 10.481,
              "y": 3.305,
              "z": 1.232
            },
            "gtin": "40225487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d125",
            "leftCorner": {
              "x": 10.481,
              "y": 3.303,
              "z": 1.232
            },
            "rightCorner": {
              "x": 10.571,
              "y": 3.296,
              "z": 1.232
            },
            "gtin": "40225012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d126",
            "leftCorner": {
              "x": 10.571,
              "y": 3.296,
              "z": 1.232
            },
            "rightCorner": {
              "x": 10.661,
              "y": 3.29,
              "z": 1.232
            },
            "gtin": "40225012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d127",
            "leftCorner": {
              "x": 10.66,
              "y": 3.281,
              "z": 1.232
            },
            "rightCorner": {
              "x": 10.728,
              "y": 3.276,
              "z": 1.232
            },
            "gtin": "40225104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d12f",
            "leftCorner": {
              "x": 11.198,
              "y": 3.259,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.26,
              "y": 3.254,
              "z": 1.232
            },
            "gtin": "4000521006549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d130",
            "leftCorner": {
              "x": 11.26,
              "y": 3.254,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.322,
              "y": 3.25,
              "z": 1.232
            },
            "gtin": "4000521006549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d131",
            "leftCorner": {
              "x": 11.322,
              "y": 3.25,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.383,
              "y": 3.245,
              "z": 1.232
            },
            "gtin": "4000521006549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d132",
            "leftCorner": {
              "x": 11.383,
              "y": 3.236,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.462,
              "y": 3.23,
              "z": 1.232
            },
            "gtin": "4000521006563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d133",
            "leftCorner": {
              "x": 11.462,
              "y": 3.23,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.54,
              "y": 3.224,
              "z": 1.232
            },
            "gtin": "4000521006563",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546180",
        "height": 0.15914,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d158",
            "leftCorner": {
              "x": 10.39,
              "y": 3.324,
              "z": 0.13
            },
            "rightCorner": {
              "x": 10.514,
              "y": 3.315,
              "z": 0.13
            },
            "gtin": "4337185462764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d159",
            "leftCorner": {
              "x": 10.514,
              "y": 3.315,
              "z": 0.13
            },
            "rightCorner": {
              "x": 10.638,
              "y": 3.306,
              "z": 0.13
            },
            "gtin": "4337185462764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d15a",
            "leftCorner": {
              "x": 10.638,
              "y": 3.306,
              "z": 0.13
            },
            "rightCorner": {
              "x": 10.762,
              "y": 3.297,
              "z": 0.13
            },
            "gtin": "4337185462764",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54617f",
        "height": 0.49977,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d0ca",
            "leftCorner": {
              "x": 10.389,
              "y": 3.302,
              "z": 0.409
            },
            "rightCorner": {
              "x": 10.441,
              "y": 3.298,
              "z": 0.409
            },
            "gtin": "4000521007522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0cb",
            "leftCorner": {
              "x": 10.441,
              "y": 3.298,
              "z": 0.409
            },
            "rightCorner": {
              "x": 10.493,
              "y": 3.294,
              "z": 0.409
            },
            "gtin": "4000521007522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0cc",
            "leftCorner": {
              "x": 10.493,
              "y": 3.294,
              "z": 0.409
            },
            "rightCorner": {
              "x": 10.545,
              "y": 3.291,
              "z": 0.409
            },
            "gtin": "4000521007522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0cd",
            "leftCorner": {
              "x": 10.545,
              "y": 3.291,
              "z": 0.409
            },
            "rightCorner": {
              "x": 10.595,
              "y": 3.287,
              "z": 0.409
            },
            "gtin": "4000521007522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0ce",
            "leftCorner": {
              "x": 10.598,
              "y": 3.309,
              "z": 0.409
            },
            "rightCorner": {
              "x": 10.647,
              "y": 3.306,
              "z": 0.409
            },
            "gtin": "4000521007102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0cf",
            "leftCorner": {
              "x": 10.647,
              "y": 3.306,
              "z": 0.409
            },
            "rightCorner": {
              "x": 10.697,
              "y": 3.302,
              "z": 0.409
            },
            "gtin": "4000521007102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0d0",
            "leftCorner": {
              "x": 10.697,
              "y": 3.302,
              "z": 0.409
            },
            "rightCorner": {
              "x": 10.747,
              "y": 3.298,
              "z": 0.409
            },
            "gtin": "4000521007102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0d1",
            "leftCorner": {
              "x": 10.747,
              "y": 3.298,
              "z": 0.409
            },
            "rightCorner": {
              "x": 10.796,
              "y": 3.295,
              "z": 0.409
            },
            "gtin": "4000521007102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0d2",
            "leftCorner": {
              "x": 10.796,
              "y": 3.295,
              "z": 0.409
            },
            "rightCorner": {
              "x": 10.846,
              "y": 3.291,
              "z": 0.409
            },
            "gtin": "4000521007102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0d3",
            "leftCorner": {
              "x": 10.846,
              "y": 3.288,
              "z": 0.409
            },
            "rightCorner": {
              "x": 10.998,
              "y": 3.277,
              "z": 0.409
            },
            "gtin": "4000521007126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0d4",
            "leftCorner": {
              "x": 10.998,
              "y": 3.277,
              "z": 0.409
            },
            "rightCorner": {
              "x": 11.149,
              "y": 3.266,
              "z": 0.409
            },
            "gtin": "4000521007126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0d5",
            "leftCorner": {
              "x": 11.149,
              "y": 3.266,
              "z": 0.409
            },
            "rightCorner": {
              "x": 11.301,
              "y": 3.255,
              "z": 0.409
            },
            "gtin": "4000521007126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0d6",
            "leftCorner": {
              "x": 11.3,
              "y": 3.242,
              "z": 0.409
            },
            "rightCorner": {
              "x": 11.353,
              "y": 3.238,
              "z": 0.409
            },
            "gtin": "4038934977675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0d7",
            "leftCorner": {
              "x": 11.353,
              "y": 3.238,
              "z": 0.409
            },
            "rightCorner": {
              "x": 11.407,
              "y": 3.234,
              "z": 0.409
            },
            "gtin": "4038934977675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0d8",
            "leftCorner": {
              "x": 11.407,
              "y": 3.245,
              "z": 0.409
            },
            "rightCorner": {
              "x": 11.493,
              "y": 3.238,
              "z": 0.409
            },
            "gtin": "4250448351103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0d9",
            "leftCorner": {
              "x": 11.493,
              "y": 3.238,
              "z": 0.409
            },
            "rightCorner": {
              "x": 11.578,
              "y": 3.232,
              "z": 0.409
            },
            "gtin": "4250448351103",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54617e",
        "height": 0.74999,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d063",
            "leftCorner": {
              "x": 10.377,
              "y": 3.318,
              "z": 0.614
            },
            "rightCorner": {
              "x": 10.485,
              "y": 3.31,
              "z": 0.614
            },
            "gtin": "4000521024581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d064",
            "leftCorner": {
              "x": 10.485,
              "y": 3.311,
              "z": 0.614
            },
            "rightCorner": {
              "x": 10.558,
              "y": 3.306,
              "z": 0.614
            },
            "gtin": "4000521007164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d065",
            "leftCorner": {
              "x": 10.558,
              "y": 3.306,
              "z": 0.614
            },
            "rightCorner": {
              "x": 10.631,
              "y": 3.3,
              "z": 0.614
            },
            "gtin": "4000521007164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d066",
            "leftCorner": {
              "x": 10.631,
              "y": 3.3,
              "z": 0.614
            },
            "rightCorner": {
              "x": 10.705,
              "y": 3.295,
              "z": 0.614
            },
            "gtin": "4000521007164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d067",
            "leftCorner": {
              "x": 10.705,
              "y": 3.297,
              "z": 0.614
            },
            "rightCorner": {
              "x": 10.763,
              "y": 3.293,
              "z": 0.614
            },
            "gtin": "4000521007140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d068",
            "leftCorner": {
              "x": 10.763,
              "y": 3.293,
              "z": 0.614
            },
            "rightCorner": {
              "x": 10.821,
              "y": 3.288,
              "z": 0.614
            },
            "gtin": "4000521007140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d069",
            "leftCorner": {
              "x": 10.821,
              "y": 3.288,
              "z": 0.614
            },
            "rightCorner": {
              "x": 10.879,
              "y": 3.284,
              "z": 0.614
            },
            "gtin": "4000521007140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d06a",
            "leftCorner": {
              "x": 10.879,
              "y": 3.284,
              "z": 0.614
            },
            "rightCorner": {
              "x": 10.937,
              "y": 3.28,
              "z": 0.614
            },
            "gtin": "4000521007140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d06b",
            "leftCorner": {
              "x": 10.937,
              "y": 3.276,
              "z": 0.614
            },
            "rightCorner": {
              "x": 11.135,
              "y": 3.262,
              "z": 0.614
            },
            "gtin": "4000521007089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d06c",
            "leftCorner": {
              "x": 11.135,
              "y": 3.262,
              "z": 0.614
            },
            "rightCorner": {
              "x": 11.333,
              "y": 3.247,
              "z": 0.614
            },
            "gtin": "4000521007089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d06d",
            "leftCorner": {
              "x": 11.334,
              "y": 3.248,
              "z": 0.614
            },
            "rightCorner": {
              "x": 11.446,
              "y": 3.24,
              "z": 0.614
            },
            "gtin": "4000521007188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d06e",
            "leftCorner": {
              "x": 11.446,
              "y": 3.24,
              "z": 0.614
            },
            "rightCorner": {
              "x": 11.558,
              "y": 3.231,
              "z": 0.614
            },
            "gtin": "4000521007188",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a54617d",
        "height": 0.9997,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d003",
            "leftCorner": {
              "x": 10.368,
              "y": 3.313,
              "z": 0.818
            },
            "rightCorner": {
              "x": 10.473,
              "y": 3.305,
              "z": 0.818
            },
            "gtin": "4000539454004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d004",
            "leftCorner": {
              "x": 10.473,
              "y": 3.302,
              "z": 0.818
            },
            "rightCorner": {
              "x": 10.55,
              "y": 3.296,
              "z": 0.818
            },
            "gtin": "4000539454103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d005",
            "leftCorner": {
              "x": 10.55,
              "y": 3.296,
              "z": 0.818
            },
            "rightCorner": {
              "x": 10.628,
              "y": 3.29,
              "z": 0.818
            },
            "gtin": "4000539454103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d006",
            "leftCorner": {
              "x": 10.628,
              "y": 3.287,
              "z": 0.818
            },
            "rightCorner": {
              "x": 10.669,
              "y": 3.283,
              "z": 0.818
            },
            "gtin": "3046920022248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d007",
            "leftCorner": {
              "x": 10.669,
              "y": 3.283,
              "z": 0.818
            },
            "rightCorner": {
              "x": 10.711,
              "y": 3.28,
              "z": 0.818
            },
            "gtin": "3046920022248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d008",
            "leftCorner": {
              "x": 10.712,
              "y": 3.291,
              "z": 0.818
            },
            "rightCorner": {
              "x": 10.751,
              "y": 3.288,
              "z": 0.818
            },
            "gtin": "4002809004346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d009",
            "leftCorner": {
              "x": 10.751,
              "y": 3.288,
              "z": 0.818
            },
            "rightCorner": {
              "x": 10.79,
              "y": 3.285,
              "z": 0.818
            },
            "gtin": "4002809004346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d00a",
            "leftCorner": {
              "x": 10.79,
              "y": 3.284,
              "z": 0.818
            },
            "rightCorner": {
              "x": 10.831,
              "y": 3.281,
              "z": 0.818
            },
            "gtin": "4049583110825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d00b",
            "leftCorner": {
              "x": 10.831,
              "y": 3.281,
              "z": 0.818
            },
            "rightCorner": {
              "x": 10.872,
              "y": 3.278,
              "z": 0.818
            },
            "gtin": "4049583110825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d00c",
            "leftCorner": {
              "x": 10.87,
              "y": 3.263,
              "z": 0.818
            },
            "rightCorner": {
              "x": 10.963,
              "y": 3.257,
              "z": 0.818
            },
            "gtin": "4049583110870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d00d",
            "leftCorner": {
              "x": 10.963,
              "y": 3.248,
              "z": 0.818
            },
            "rightCorner": {
              "x": 11.082,
              "y": 3.239,
              "z": 0.818
            },
            "gtin": "4049583110887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d00e",
            "leftCorner": {
              "x": 11.082,
              "y": 3.239,
              "z": 0.818
            },
            "rightCorner": {
              "x": 11.202,
              "y": 3.23,
              "z": 0.818
            },
            "gtin": "4049583110887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d00f",
            "leftCorner": {
              "x": 11.205,
              "y": 3.252,
              "z": 0.818
            },
            "rightCorner": {
              "x": 11.288,
              "y": 3.246,
              "z": 0.818
            },
            "gtin": "4049583110818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d010",
            "leftCorner": {
              "x": 11.288,
              "y": 3.246,
              "z": 0.818
            },
            "rightCorner": {
              "x": 11.372,
              "y": 3.24,
              "z": 0.818
            },
            "gtin": "4049583110818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d011",
            "leftCorner": {
              "x": 11.372,
              "y": 3.242,
              "z": 0.818
            },
            "rightCorner": {
              "x": 11.456,
              "y": 3.236,
              "z": 0.818
            },
            "gtin": "4049583110832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d012",
            "leftCorner": {
              "x": 11.457,
              "y": 3.244,
              "z": 0.818
            },
            "rightCorner": {
              "x": 11.545,
              "y": 3.237,
              "z": 0.818
            },
            "gtin": "4000521021450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d013",
            "leftCorner": {
              "x": 11.545,
              "y": 3.237,
              "z": 0.818
            },
            "rightCorner": {
              "x": 11.633,
              "y": 3.231,
              "z": 0.818
            },
            "gtin": "4000521021450",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a54617a",
        "height": 1.257,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cfa3",
            "leftCorner": {
              "x": 10.346,
              "y": 3.319,
              "z": 1.028
            },
            "rightCorner": {
              "x": 10.409,
              "y": 3.314,
              "z": 1.028
            },
            "gtin": "4000521010065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfa4",
            "leftCorner": {
              "x": 10.409,
              "y": 3.314,
              "z": 1.028
            },
            "rightCorner": {
              "x": 10.471,
              "y": 3.31,
              "z": 1.028
            },
            "gtin": "4000521010065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfa5",
            "leftCorner": {
              "x": 10.471,
              "y": 3.306,
              "z": 1.028
            },
            "rightCorner": {
              "x": 10.585,
              "y": 3.298,
              "z": 1.028
            },
            "gtin": "4000521010041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfa6",
            "leftCorner": {
              "x": 10.585,
              "y": 3.298,
              "z": 1.028
            },
            "rightCorner": {
              "x": 10.699,
              "y": 3.29,
              "z": 1.028
            },
            "gtin": "4000521010041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfa7",
            "leftCorner": {
              "x": 10.698,
              "y": 3.278,
              "z": 1.028
            },
            "rightCorner": {
              "x": 10.866,
              "y": 3.266,
              "z": 1.028
            },
            "gtin": "4000521007263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfa8",
            "leftCorner": {
              "x": 10.866,
              "y": 3.264,
              "z": 1.028
            },
            "rightCorner": {
              "x": 10.956,
              "y": 3.258,
              "z": 1.028
            },
            "gtin": "4000521007287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfa9",
            "leftCorner": {
              "x": 10.956,
              "y": 3.258,
              "z": 1.028
            },
            "rightCorner": {
              "x": 11.047,
              "y": 3.251,
              "z": 1.028
            },
            "gtin": "4000521007287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfaa",
            "leftCorner": {
              "x": 11.048,
              "y": 3.27,
              "z": 1.028
            },
            "rightCorner": {
              "x": 11.112,
              "y": 3.265,
              "z": 1.028
            },
            "gtin": "4000521007027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfab",
            "leftCorner": {
              "x": 11.112,
              "y": 3.265,
              "z": 1.028
            },
            "rightCorner": {
              "x": 11.176,
              "y": 3.261,
              "z": 1.028
            },
            "gtin": "4000521007027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfac",
            "leftCorner": {
              "x": 11.176,
              "y": 3.253,
              "z": 1.028
            },
            "rightCorner": {
              "x": 11.248,
              "y": 3.248,
              "z": 1.028
            },
            "gtin": "4000521007003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfad",
            "leftCorner": {
              "x": 11.248,
              "y": 3.248,
              "z": 1.028
            },
            "rightCorner": {
              "x": 11.321,
              "y": 3.243,
              "z": 1.028
            },
            "gtin": "4000521007003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfae",
            "leftCorner": {
              "x": 11.321,
              "y": 3.242,
              "z": 1.028
            },
            "rightCorner": {
              "x": 11.38,
              "y": 3.237,
              "z": 1.028
            },
            "gtin": "4000521007249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfaf",
            "leftCorner": {
              "x": 11.38,
              "y": 3.237,
              "z": 1.028
            },
            "rightCorner": {
              "x": 11.438,
              "y": 3.233,
              "z": 1.028
            },
            "gtin": "4000521007249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfb0",
            "leftCorner": {
              "x": 11.438,
              "y": 3.233,
              "z": 1.028
            },
            "rightCorner": {
              "x": 11.497,
              "y": 3.229,
              "z": 1.028
            },
            "gtin": "4000521007249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfb1",
            "leftCorner": {
              "x": 11.497,
              "y": 3.235,
              "z": 1.028
            },
            "rightCorner": {
              "x": 11.564,
              "y": 3.23,
              "z": 1.028
            },
            "gtin": "5060234982843",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddbd15af3232a54617c",
        "height": 1.7045,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cf18",
            "leftCorner": {
              "x": 10.351,
              "y": 3.311,
              "z": 1.395
            },
            "rightCorner": {
              "x": 10.442,
              "y": 3.304,
              "z": 1.395
            },
            "gtin": "4002809025587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf19",
            "leftCorner": {
              "x": 10.442,
              "y": 3.306,
              "z": 1.395
            },
            "rightCorner": {
              "x": 10.497,
              "y": 3.301,
              "z": 1.395
            },
            "gtin": "4000521031671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf1a",
            "leftCorner": {
              "x": 10.497,
              "y": 3.301,
              "z": 1.395
            },
            "rightCorner": {
              "x": 10.552,
              "y": 3.297,
              "z": 1.395
            },
            "gtin": "4000521031671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf1b",
            "leftCorner": {
              "x": 10.552,
              "y": 3.293,
              "z": 1.395
            },
            "rightCorner": {
              "x": 10.663,
              "y": 3.285,
              "z": 1.395
            },
            "gtin": "4337185756627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf1c",
            "leftCorner": {
              "x": 10.664,
              "y": 3.289,
              "z": 1.395
            },
            "rightCorner": {
              "x": 10.853,
              "y": 3.275,
              "z": 1.395
            },
            "gtin": "4000607000515",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c835ed67a01d9a1cf1d",
            "leftCorner": {
              "x": 10.853,
              "y": 3.269,
              "z": 1.395
            },
            "rightCorner": {
              "x": 10.907,
              "y": 3.265,
              "z": 1.395
            },
            "gtin": "4001743762015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf1e",
            "leftCorner": {
              "x": 10.907,
              "y": 3.265,
              "z": 1.395
            },
            "rightCorner": {
              "x": 10.961,
              "y": 3.261,
              "z": 1.395
            },
            "gtin": "4001743762015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf1f",
            "leftCorner": {
              "x": 10.961,
              "y": 3.265,
              "z": 1.395
            },
            "rightCorner": {
              "x": 11.009,
              "y": 3.262,
              "z": 1.395
            },
            "gtin": "4001743762039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf20",
            "leftCorner": {
              "x": 11.009,
              "y": 3.262,
              "z": 1.395
            },
            "rightCorner": {
              "x": 11.057,
              "y": 3.258,
              "z": 1.395
            },
            "gtin": "4001743762039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf21",
            "leftCorner": {
              "x": 11.058,
              "y": 3.274,
              "z": 1.395
            },
            "rightCorner": {
              "x": 11.119,
              "y": 3.27,
              "z": 1.395
            },
            "gtin": "4000539454301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf22",
            "leftCorner": {
              "x": 11.119,
              "y": 3.27,
              "z": 1.395
            },
            "rightCorner": {
              "x": 11.179,
              "y": 3.265,
              "z": 1.395
            },
            "gtin": "4000539454301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf23",
            "leftCorner": {
              "x": 11.178,
              "y": 3.252,
              "z": 1.395
            },
            "rightCorner": {
              "x": 11.238,
              "y": 3.247,
              "z": 1.395
            },
            "gtin": "4000539453601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf24",
            "leftCorner": {
              "x": 11.238,
              "y": 3.247,
              "z": 1.395
            },
            "rightCorner": {
              "x": 11.298,
              "y": 3.243,
              "z": 1.395
            },
            "gtin": "4000539453601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf25",
            "leftCorner": {
              "x": 11.298,
              "y": 3.247,
              "z": 1.395
            },
            "rightCorner": {
              "x": 11.435,
              "y": 3.237,
              "z": 1.395
            },
            "gtin": "4337185891823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf26",
            "leftCorner": {
              "x": 11.436,
              "y": 3.245,
              "z": 1.395
            },
            "rightCorner": {
              "x": 11.595,
              "y": 3.233,
              "z": 1.395
            },
            "gtin": "4337185891847",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e024d",
    "rightNeighborShelfId": "e024f"
  },
  {
    "id": "e024f",
    "name": "e024f",
    "x": 11.538,
    "y": 3.187,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036766,
      "w": 0.99932
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 101
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546192",
        "height": 0.15911,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d15b",
            "leftCorner": {
              "x": 12.108,
              "y": 3.208,
              "z": 0.13
            },
            "rightCorner": {
              "x": 12.203,
              "y": 3.201,
              "z": 0.13
            },
            "gtin": "4337185462795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d15c",
            "leftCorner": {
              "x": 12.203,
              "y": 3.201,
              "z": 0.13
            },
            "rightCorner": {
              "x": 12.299,
              "y": 3.194,
              "z": 0.13
            },
            "gtin": "4337185462795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d15d",
            "leftCorner": {
              "x": 12.299,
              "y": 3.194,
              "z": 0.13
            },
            "rightCorner": {
              "x": 12.395,
              "y": 3.187,
              "z": 0.13
            },
            "gtin": "4337185462795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d15e",
            "leftCorner": {
              "x": 12.394,
              "y": 3.177,
              "z": 0.13
            },
            "rightCorner": {
              "x": 12.587,
              "y": 3.163,
              "z": 0.13
            },
            "gtin": "4337185684760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d15f",
            "leftCorner": {
              "x": 12.587,
              "y": 3.163,
              "z": 0.13
            },
            "rightCorner": {
              "x": 12.779,
              "y": 3.149,
              "z": 0.13
            },
            "gtin": "4337185684760",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54618e",
        "height": 0.49945,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d0da",
            "leftCorner": {
              "x": 11.579,
              "y": 3.233,
              "z": 0.409
            },
            "rightCorner": {
              "x": 11.608,
              "y": 3.231,
              "z": 0.409
            },
            "gtin": "4000521026509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0db",
            "leftCorner": {
              "x": 11.608,
              "y": 3.231,
              "z": 0.409
            },
            "rightCorner": {
              "x": 11.638,
              "y": 3.229,
              "z": 0.409
            },
            "gtin": "4000521026509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0dc",
            "leftCorner": {
              "x": 11.638,
              "y": 3.229,
              "z": 0.409
            },
            "rightCorner": {
              "x": 11.667,
              "y": 3.226,
              "z": 0.409
            },
            "gtin": "4000521026509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0dd",
            "leftCorner": {
              "x": 11.668,
              "y": 3.237,
              "z": 0.409
            },
            "rightCorner": {
              "x": 11.712,
              "y": 3.234,
              "z": 0.409
            },
            "gtin": "4000521026530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0de",
            "leftCorner": {
              "x": 11.712,
              "y": 3.234,
              "z": 0.409
            },
            "rightCorner": {
              "x": 11.757,
              "y": 3.23,
              "z": 0.409
            },
            "gtin": "4000521026530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0df",
            "leftCorner": {
              "x": 11.758,
              "y": 3.234,
              "z": 0.409
            },
            "rightCorner": {
              "x": 11.806,
              "y": 3.231,
              "z": 0.409
            },
            "gtin": "4000521020385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0e0",
            "leftCorner": {
              "x": 11.804,
              "y": 3.202,
              "z": 0.409
            },
            "rightCorner": {
              "x": 11.87,
              "y": 3.197,
              "z": 0.409
            },
            "gtin": "4000521006426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0e1",
            "leftCorner": {
              "x": 11.87,
              "y": 3.197,
              "z": 0.409
            },
            "rightCorner": {
              "x": 11.937,
              "y": 3.192,
              "z": 0.409
            },
            "gtin": "4000521006426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0e2",
            "leftCorner": {
              "x": 11.937,
              "y": 3.19,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.004,
              "y": 3.185,
              "z": 0.409
            },
            "gtin": "4000521006921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0e3",
            "leftCorner": {
              "x": 12.004,
              "y": 3.185,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.072,
              "y": 3.18,
              "z": 0.409
            },
            "gtin": "4000521006921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0e4",
            "leftCorner": {
              "x": 12.072,
              "y": 3.18,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.14,
              "y": 3.175,
              "z": 0.409
            },
            "gtin": "4000521006921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0e5",
            "leftCorner": {
              "x": 12.141,
              "y": 3.19,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.262,
              "y": 3.181,
              "z": 0.409
            },
            "gtin": "4000521038021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0e6",
            "leftCorner": {
              "x": 12.262,
              "y": 3.185,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.354,
              "y": 3.179,
              "z": 0.409
            },
            "gtin": "4250448317116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0e7",
            "leftCorner": {
              "x": 12.353,
              "y": 3.168,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.434,
              "y": 3.162,
              "z": 0.409
            },
            "gtin": "4250448329621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0e8",
            "leftCorner": {
              "x": 12.434,
              "y": 3.156,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.509,
              "y": 3.151,
              "z": 0.409
            },
            "gtin": "4000521006822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0e9",
            "leftCorner": {
              "x": 12.511,
              "y": 3.167,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.585,
              "y": 3.162,
              "z": 0.409
            },
            "gtin": "4000521027001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0ea",
            "leftCorner": {
              "x": 12.585,
              "y": 3.162,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.66,
              "y": 3.156,
              "z": 0.409
            },
            "gtin": "4000521027001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0eb",
            "leftCorner": {
              "x": 12.66,
              "y": 3.156,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.735,
              "y": 3.151,
              "z": 0.409
            },
            "gtin": "4000521027001",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54618d",
        "height": 0.75309,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d06f",
            "leftCorner": {
              "x": 11.559,
              "y": 3.243,
              "z": 0.616
            },
            "rightCorner": {
              "x": 11.625,
              "y": 3.238,
              "z": 0.616
            },
            "gtin": "4250448351127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d070",
            "leftCorner": {
              "x": 11.625,
              "y": 3.238,
              "z": 0.616
            },
            "rightCorner": {
              "x": 11.689,
              "y": 3.234,
              "z": 0.616
            },
            "gtin": "4250448351127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d071",
            "leftCorner": {
              "x": 11.689,
              "y": 3.229,
              "z": 0.616
            },
            "rightCorner": {
              "x": 11.764,
              "y": 3.224,
              "z": 0.616
            },
            "gtin": "4002809025730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d072",
            "leftCorner": {
              "x": 11.764,
              "y": 3.224,
              "z": 0.616
            },
            "rightCorner": {
              "x": 11.839,
              "y": 3.218,
              "z": 0.616
            },
            "gtin": "4002809025730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d073",
            "leftCorner": {
              "x": 11.838,
              "y": 3.213,
              "z": 0.616
            },
            "rightCorner": {
              "x": 11.879,
              "y": 3.21,
              "z": 0.616
            },
            "gtin": "4002809025747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d074",
            "leftCorner": {
              "x": 11.879,
              "y": 3.21,
              "z": 0.616
            },
            "rightCorner": {
              "x": 11.919,
              "y": 3.207,
              "z": 0.616
            },
            "gtin": "4002809025747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d075",
            "leftCorner": {
              "x": 11.919,
              "y": 3.204,
              "z": 0.616
            },
            "rightCorner": {
              "x": 11.999,
              "y": 3.198,
              "z": 0.616
            },
            "gtin": "4000521025397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d076",
            "leftCorner": {
              "x": 11.999,
              "y": 3.188,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.078,
              "y": 3.183,
              "z": 0.616
            },
            "gtin": "4000521037116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d077",
            "leftCorner": {
              "x": 12.079,
              "y": 3.186,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.138,
              "y": 3.181,
              "z": 0.616
            },
            "gtin": "4000521034245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d078",
            "leftCorner": {
              "x": 12.138,
              "y": 3.185,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.238,
              "y": 3.178,
              "z": 0.616
            },
            "gtin": "4000521016685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d079",
            "leftCorner": {
              "x": 12.236,
              "y": 3.163,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.298,
              "y": 3.158,
              "z": 0.616
            },
            "gtin": "4000521033828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d07a",
            "leftCorner": {
              "x": 12.299,
              "y": 3.172,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.339,
              "y": 3.169,
              "z": 0.616
            },
            "gtin": "4000521037987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d07b",
            "leftCorner": {
              "x": 12.339,
              "y": 3.169,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.378,
              "y": 3.166,
              "z": 0.616
            },
            "gtin": "4000521037987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d07c",
            "leftCorner": {
              "x": 12.378,
              "y": 3.157,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.428,
              "y": 3.153,
              "z": 0.616
            },
            "gtin": "4000521030872",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d07d",
            "leftCorner": {
              "x": 12.428,
              "y": 3.153,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.479,
              "y": 3.149,
              "z": 0.616
            },
            "gtin": "4000521030872",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d07e",
            "leftCorner": {
              "x": 12.479,
              "y": 3.146,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.565,
              "y": 3.14,
              "z": 0.616
            },
            "gtin": "4064285103654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d07f",
            "leftCorner": {
              "x": 12.566,
              "y": 3.152,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.615,
              "y": 3.149,
              "z": 0.616
            },
            "gtin": "4000521033804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d080",
            "leftCorner": {
              "x": 12.615,
              "y": 3.149,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.664,
              "y": 3.145,
              "z": 0.616
            },
            "gtin": "4000521033804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d081",
            "leftCorner": {
              "x": 12.665,
              "y": 3.139,
              "z": 0.616
            },
            "rightCorner": {
              "x": 12.721,
              "y": 3.135,
              "z": 0.616
            },
            "gtin": "4000521038007",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546191",
        "height": 1.0029,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d014",
            "leftCorner": {
              "x": 11.635,
              "y": 3.24,
              "z": 0.821
            },
            "rightCorner": {
              "x": 11.712,
              "y": 3.234,
              "z": 0.821
            },
            "gtin": "4000521025373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d015",
            "leftCorner": {
              "x": 11.71,
              "y": 3.209,
              "z": 0.821
            },
            "rightCorner": {
              "x": 11.754,
              "y": 3.206,
              "z": 0.821
            },
            "gtin": "4000521031077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d016",
            "leftCorner": {
              "x": 11.754,
              "y": 3.206,
              "z": 0.821
            },
            "rightCorner": {
              "x": 11.798,
              "y": 3.203,
              "z": 0.821
            },
            "gtin": "4000521031077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d017",
            "leftCorner": {
              "x": 11.799,
              "y": 3.208,
              "z": 0.821
            },
            "rightCorner": {
              "x": 11.879,
              "y": 3.202,
              "z": 0.821
            },
            "gtin": "4000521008895",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d018",
            "leftCorner": {
              "x": 11.88,
              "y": 3.204,
              "z": 0.821
            },
            "rightCorner": {
              "x": 11.974,
              "y": 3.197,
              "z": 0.821
            },
            "gtin": "4000521018573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d019",
            "leftCorner": {
              "x": 11.974,
              "y": 3.193,
              "z": 0.821
            },
            "rightCorner": {
              "x": 12.04,
              "y": 3.188,
              "z": 0.821
            },
            "gtin": "4000521019099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d01a",
            "leftCorner": {
              "x": 12.04,
              "y": 3.188,
              "z": 0.821
            },
            "rightCorner": {
              "x": 12.106,
              "y": 3.184,
              "z": 0.821
            },
            "gtin": "4000521019099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d01b",
            "leftCorner": {
              "x": 12.105,
              "y": 3.178,
              "z": 0.821
            },
            "rightCorner": {
              "x": 12.148,
              "y": 3.175,
              "z": 0.821
            },
            "gtin": "4000521006303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d01c",
            "leftCorner": {
              "x": 12.148,
              "y": 3.175,
              "z": 0.821
            },
            "rightCorner": {
              "x": 12.192,
              "y": 3.172,
              "z": 0.821
            },
            "gtin": "4000521006303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d01d",
            "leftCorner": {
              "x": 12.192,
              "y": 3.177,
              "z": 0.821
            },
            "rightCorner": {
              "x": 12.263,
              "y": 3.171,
              "z": 0.821
            },
            "gtin": "4000521024567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d01e",
            "leftCorner": {
              "x": 12.263,
              "y": 3.166,
              "z": 0.821
            },
            "rightCorner": {
              "x": 12.319,
              "y": 3.162,
              "z": 0.821
            },
            "gtin": "4250448352971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d01f",
            "leftCorner": {
              "x": 12.318,
              "y": 3.157,
              "z": 0.821
            },
            "rightCorner": {
              "x": 12.387,
              "y": 3.152,
              "z": 0.821
            },
            "gtin": "4250448354128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d020",
            "leftCorner": {
              "x": 12.387,
              "y": 3.151,
              "z": 0.821
            },
            "rightCorner": {
              "x": 12.445,
              "y": 3.147,
              "z": 0.821
            },
            "gtin": "4250448354142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d021",
            "leftCorner": {
              "x": 12.446,
              "y": 3.157,
              "z": 0.821
            },
            "rightCorner": {
              "x": 12.559,
              "y": 3.148,
              "z": 0.821
            },
            "gtin": "4064285106495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d022",
            "leftCorner": {
              "x": 12.56,
              "y": 3.151,
              "z": 0.821
            },
            "rightCorner": {
              "x": 12.672,
              "y": 3.143,
              "z": 0.821
            },
            "gtin": "4064285103074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d023",
            "leftCorner": {
              "x": 12.673,
              "y": 3.151,
              "z": 0.821
            },
            "rightCorner": {
              "x": 12.733,
              "y": 3.146,
              "z": 0.821
            },
            "gtin": "4049583112584",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54618c",
        "height": 1.2543,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cfb2",
            "leftCorner": {
              "x": 11.565,
              "y": 3.239,
              "z": 1.026
            },
            "rightCorner": {
              "x": 11.633,
              "y": 3.234,
              "z": 1.026
            },
            "gtin": "4000521006686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfb3",
            "leftCorner": {
              "x": 11.633,
              "y": 3.232,
              "z": 1.026
            },
            "rightCorner": {
              "x": 11.735,
              "y": 3.224,
              "z": 1.026
            },
            "gtin": "4000521007225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfb4",
            "leftCorner": {
              "x": 11.734,
              "y": 3.218,
              "z": 1.026
            },
            "rightCorner": {
              "x": 11.778,
              "y": 3.214,
              "z": 1.026
            },
            "gtin": "4000521006662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfb5",
            "leftCorner": {
              "x": 11.778,
              "y": 3.214,
              "z": 1.026
            },
            "rightCorner": {
              "x": 11.822,
              "y": 3.211,
              "z": 1.026
            },
            "gtin": "4000521006662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfb6",
            "leftCorner": {
              "x": 11.822,
              "y": 3.207,
              "z": 1.026
            },
            "rightCorner": {
              "x": 11.877,
              "y": 3.203,
              "z": 1.026
            },
            "gtin": "4000521019211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfb7",
            "leftCorner": {
              "x": 11.877,
              "y": 3.203,
              "z": 1.026
            },
            "rightCorner": {
              "x": 11.932,
              "y": 3.199,
              "z": 1.026
            },
            "gtin": "4000521019211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfb8",
            "leftCorner": {
              "x": 11.932,
              "y": 3.19,
              "z": 1.026
            },
            "rightCorner": {
              "x": 12.042,
              "y": 3.182,
              "z": 1.026
            },
            "gtin": "4000521006600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfb9",
            "leftCorner": {
              "x": 12.042,
              "y": 3.184,
              "z": 1.026
            },
            "rightCorner": {
              "x": 12.124,
              "y": 3.178,
              "z": 1.026
            },
            "gtin": "4000521006709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfba",
            "leftCorner": {
              "x": 12.125,
              "y": 3.181,
              "z": 1.026
            },
            "rightCorner": {
              "x": 12.192,
              "y": 3.176,
              "z": 1.026
            },
            "gtin": "4000521006280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfbb",
            "leftCorner": {
              "x": 12.192,
              "y": 3.171,
              "z": 1.026
            },
            "rightCorner": {
              "x": 12.269,
              "y": 3.166,
              "z": 1.026
            },
            "gtin": "4000521021450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfbc",
            "leftCorner": {
              "x": 12.269,
              "y": 3.165,
              "z": 1.026
            },
            "rightCorner": {
              "x": 12.371,
              "y": 3.157,
              "z": 1.026
            },
            "gtin": "5410768023589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfbd",
            "leftCorner": {
              "x": 12.371,
              "y": 3.154,
              "z": 1.026
            },
            "rightCorner": {
              "x": 12.458,
              "y": 3.147,
              "z": 1.026
            },
            "gtin": "4000521006587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfbe",
            "leftCorner": {
              "x": 12.459,
              "y": 3.155,
              "z": 1.026
            },
            "rightCorner": {
              "x": 12.558,
              "y": 3.148,
              "z": 1.026
            },
            "gtin": "4000521042226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfbf",
            "leftCorner": {
              "x": 12.558,
              "y": 3.15,
              "z": 1.026
            },
            "rightCorner": {
              "x": 12.667,
              "y": 3.142,
              "z": 1.026
            },
            "gtin": "4000521042189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfc0",
            "leftCorner": {
              "x": 12.667,
              "y": 3.14,
              "z": 1.026
            },
            "rightCorner": {
              "x": 12.728,
              "y": 3.135,
              "z": 1.026
            },
            "gtin": "4000521042202",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54618f",
        "height": 1.506,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d134",
            "leftCorner": {
              "x": 11.541,
              "y": 3.223,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.575,
              "y": 3.22,
              "z": 1.232
            },
            "gtin": "4002809004094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d135",
            "leftCorner": {
              "x": 11.577,
              "y": 3.242,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.673,
              "y": 3.235,
              "z": 1.232
            },
            "gtin": "4002809004094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d136",
            "leftCorner": {
              "x": 11.672,
              "y": 3.215,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.801,
              "y": 3.206,
              "z": 1.232
            },
            "gtin": "4337185331091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d137",
            "leftCorner": {
              "x": 11.801,
              "y": 3.206,
              "z": 1.232
            },
            "rightCorner": {
              "x": 11.931,
              "y": 3.196,
              "z": 1.232
            },
            "gtin": "4337185331091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d138",
            "leftCorner": {
              "x": 11.931,
              "y": 3.2,
              "z": 1.232
            },
            "rightCorner": {
              "x": 12.048,
              "y": 3.191,
              "z": 1.232
            },
            "gtin": "4337185527463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d139",
            "leftCorner": {
              "x": 12.047,
              "y": 3.181,
              "z": 1.232
            },
            "rightCorner": {
              "x": 12.131,
              "y": 3.174,
              "z": 1.232
            },
            "gtin": "4337185527487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d13a",
            "leftCorner": {
              "x": 12.131,
              "y": 3.174,
              "z": 1.232
            },
            "rightCorner": {
              "x": 12.214,
              "y": 3.168,
              "z": 1.232
            },
            "gtin": "4337185527487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d13b",
            "leftCorner": {
              "x": 12.214,
              "y": 3.173,
              "z": 1.232
            },
            "rightCorner": {
              "x": 12.42,
              "y": 3.158,
              "z": 1.232
            },
            "gtin": "4337185527531",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d13c",
            "leftCorner": {
              "x": 12.42,
              "y": 3.166,
              "z": 1.232
            },
            "rightCorner": {
              "x": 12.497,
              "y": 3.161,
              "z": 1.232
            },
            "gtin": "4063367223006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d13d",
            "leftCorner": {
              "x": 12.497,
              "y": 3.155,
              "z": 1.232
            },
            "rightCorner": {
              "x": 12.594,
              "y": 3.148,
              "z": 1.232
            },
            "gtin": "4337185720598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0fc",
            "leftCorner": {
              "x": 12.593,
              "y": 3.137,
              "z": 1.232
            },
            "rightCorner": {
              "x": 12.665,
              "y": 3.131,
              "z": 1.232
            },
            "gtin": "4002809024016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0fd",
            "leftCorner": {
              "x": 12.665,
              "y": 3.131,
              "z": 1.232
            },
            "rightCorner": {
              "x": 12.737,
              "y": 3.126,
              "z": 1.232
            },
            "gtin": "4002809024016",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546190",
        "height": 1.7076,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cf27",
            "leftCorner": {
              "x": 11.596,
              "y": 3.236,
              "z": 1.397
            },
            "rightCorner": {
              "x": 11.688,
              "y": 3.229,
              "z": 1.397
            },
            "gtin": "4008521000826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf28",
            "leftCorner": {
              "x": 11.688,
              "y": 3.229,
              "z": 1.397
            },
            "rightCorner": {
              "x": 11.781,
              "y": 3.222,
              "z": 1.397
            },
            "gtin": "4008521000826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf29",
            "leftCorner": {
              "x": 11.78,
              "y": 3.215,
              "z": 1.397
            },
            "rightCorner": {
              "x": 11.842,
              "y": 3.21,
              "z": 1.397
            },
            "gtin": "4008521001823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf2a",
            "leftCorner": {
              "x": 11.842,
              "y": 3.21,
              "z": 1.397
            },
            "rightCorner": {
              "x": 11.905,
              "y": 3.205,
              "z": 1.397
            },
            "gtin": "4008521001823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf2b",
            "leftCorner": {
              "x": 11.904,
              "y": 3.192,
              "z": 1.397
            },
            "rightCorner": {
              "x": 11.999,
              "y": 3.184,
              "z": 1.397
            },
            "gtin": "4008521000208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf2c",
            "leftCorner": {
              "x": 11.999,
              "y": 3.184,
              "z": 1.397
            },
            "rightCorner": {
              "x": 12.095,
              "y": 3.177,
              "z": 1.397
            },
            "gtin": "4008521000208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf2d",
            "leftCorner": {
              "x": 12.095,
              "y": 3.182,
              "z": 1.397
            },
            "rightCorner": {
              "x": 12.142,
              "y": 3.178,
              "z": 1.397
            },
            "gtin": "4063367222986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf2e",
            "leftCorner": {
              "x": 12.142,
              "y": 3.178,
              "z": 1.397
            },
            "rightCorner": {
              "x": 12.189,
              "y": 3.175,
              "z": 1.397
            },
            "gtin": "4063367222986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf2f",
            "leftCorner": {
              "x": 12.189,
              "y": 3.169,
              "z": 1.397
            },
            "rightCorner": {
              "x": 12.245,
              "y": 3.165,
              "z": 1.397
            },
            "gtin": "4063367222948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf30",
            "leftCorner": {
              "x": 12.245,
              "y": 3.165,
              "z": 1.397
            },
            "rightCorner": {
              "x": 12.3,
              "y": 3.161,
              "z": 1.397
            },
            "gtin": "4063367222948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf31",
            "leftCorner": {
              "x": 12.301,
              "y": 3.166,
              "z": 1.397
            },
            "rightCorner": {
              "x": 12.353,
              "y": 3.163,
              "z": 1.397
            },
            "gtin": "4063367309168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf32",
            "leftCorner": {
              "x": 12.353,
              "y": 3.163,
              "z": 1.397
            },
            "rightCorner": {
              "x": 12.405,
              "y": 3.159,
              "z": 1.397
            },
            "gtin": "4063367309168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf33",
            "leftCorner": {
              "x": 12.405,
              "y": 3.16,
              "z": 1.397
            },
            "rightCorner": {
              "x": 12.477,
              "y": 3.155,
              "z": 1.397
            },
            "gtin": "4063367222962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf34",
            "leftCorner": {
              "x": 12.477,
              "y": 3.155,
              "z": 1.397
            },
            "rightCorner": {
              "x": 12.549,
              "y": 3.15,
              "z": 1.397
            },
            "gtin": "4063367222962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf35",
            "leftCorner": {
              "x": 12.55,
              "y": 3.154,
              "z": 1.397
            },
            "rightCorner": {
              "x": 12.659,
              "y": 3.146,
              "z": 1.397
            },
            "gtin": "4250448326804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf36",
            "leftCorner": {
              "x": 12.659,
              "y": 3.143,
              "z": 1.397
            },
            "rightCorner": {
              "x": 12.717,
              "y": 3.139,
              "z": 1.397
            },
            "gtin": "4250448342118",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e024e",
    "rightNeighborShelfId": "e0250"
  },
  {
    "id": "e0250",
    "name": "e0250",
    "x": 12.734,
    "y": 3.099,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036766,
      "w": 0.99932
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 107
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546199",
        "height": 0.15658,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d160",
            "leftCorner": {
              "x": 12.777,
              "y": 3.132,
              "z": 0.128
            },
            "rightCorner": {
              "x": 12.972,
              "y": 3.118,
              "z": 0.128
            },
            "gtin": "4337185609480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d161",
            "leftCorner": {
              "x": 12.973,
              "y": 3.132,
              "z": 0.128
            },
            "rightCorner": {
              "x": 13.23,
              "y": 3.113,
              "z": 0.128
            },
            "gtin": "4063367507526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d162",
            "leftCorner": {
              "x": 13.228,
              "y": 3.094,
              "z": 0.128
            },
            "rightCorner": {
              "x": 13.364,
              "y": 3.084,
              "z": 0.128
            },
            "gtin": "4038934506981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d163",
            "leftCorner": {
              "x": 13.364,
              "y": 3.084,
              "z": 0.128
            },
            "rightCorner": {
              "x": 13.501,
              "y": 3.074,
              "z": 0.128
            },
            "gtin": "4038934506981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d164",
            "leftCorner": {
              "x": 13.501,
              "y": 3.077,
              "z": 0.128
            },
            "rightCorner": {
              "x": 13.756,
              "y": 3.058,
              "z": 0.128
            },
            "gtin": "4038934290507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d165",
            "leftCorner": {
              "x": 13.758,
              "y": 3.073,
              "z": 0.128
            },
            "rightCorner": {
              "x": 14.034,
              "y": 3.053,
              "z": 0.128
            },
            "gtin": "4063367441387",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546198",
        "height": 0.50597,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d0ec",
            "leftCorner": {
              "x": 12.734,
              "y": 3.146,
              "z": 0.414
            },
            "rightCorner": {
              "x": 12.797,
              "y": 3.141,
              "z": 0.414
            },
            "gtin": "4064285106327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0ed",
            "leftCorner": {
              "x": 12.797,
              "y": 3.141,
              "z": 0.414
            },
            "rightCorner": {
              "x": 12.859,
              "y": 3.136,
              "z": 0.414
            },
            "gtin": "4064285106327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0ee",
            "leftCorner": {
              "x": 12.858,
              "y": 3.134,
              "z": 0.414
            },
            "rightCorner": {
              "x": 12.978,
              "y": 3.125,
              "z": 0.414
            },
            "gtin": "4064285106785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0ef",
            "leftCorner": {
              "x": 12.977,
              "y": 3.112,
              "z": 0.414
            },
            "rightCorner": {
              "x": 13.025,
              "y": 3.109,
              "z": 0.414
            },
            "gtin": "4064285106303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0f0",
            "leftCorner": {
              "x": 13.025,
              "y": 3.109,
              "z": 0.414
            },
            "rightCorner": {
              "x": 13.072,
              "y": 3.105,
              "z": 0.414
            },
            "gtin": "4064285106303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0f1",
            "leftCorner": {
              "x": 13.073,
              "y": 3.115,
              "z": 0.414
            },
            "rightCorner": {
              "x": 13.135,
              "y": 3.11,
              "z": 0.414
            },
            "gtin": "4064285106310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0f2",
            "leftCorner": {
              "x": 13.136,
              "y": 3.116,
              "z": 0.414
            },
            "rightCorner": {
              "x": 13.204,
              "y": 3.111,
              "z": 0.414
            },
            "gtin": "4002809025907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0f3",
            "leftCorner": {
              "x": 13.204,
              "y": 3.111,
              "z": 0.414
            },
            "rightCorner": {
              "x": 13.271,
              "y": 3.106,
              "z": 0.414
            },
            "gtin": "4002809025907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0f4",
            "leftCorner": {
              "x": 13.27,
              "y": 3.096,
              "z": 0.414
            },
            "rightCorner": {
              "x": 13.328,
              "y": 3.092,
              "z": 0.414
            },
            "gtin": "4002809025921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0f5",
            "leftCorner": {
              "x": 13.328,
              "y": 3.094,
              "z": 0.414
            },
            "rightCorner": {
              "x": 13.401,
              "y": 3.089,
              "z": 0.414
            },
            "gtin": "4002809025891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0f6",
            "leftCorner": {
              "x": 13.4,
              "y": 3.078,
              "z": 0.414
            },
            "rightCorner": {
              "x": 13.46,
              "y": 3.074,
              "z": 0.414
            },
            "gtin": "4064285106570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0f7",
            "leftCorner": {
              "x": 13.46,
              "y": 3.08,
              "z": 0.414
            },
            "rightCorner": {
              "x": 13.519,
              "y": 3.076,
              "z": 0.414
            },
            "gtin": "4052400021105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0f8",
            "leftCorner": {
              "x": 13.519,
              "y": 3.077,
              "z": 0.414
            },
            "rightCorner": {
              "x": 13.628,
              "y": 3.069,
              "z": 0.414
            },
            "gtin": "4052400021129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0f9",
            "leftCorner": {
              "x": 13.628,
              "y": 3.073,
              "z": 0.414
            },
            "rightCorner": {
              "x": 13.687,
              "y": 3.069,
              "z": 0.414
            },
            "gtin": "4052400021136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0fa",
            "leftCorner": {
              "x": 13.687,
              "y": 3.069,
              "z": 0.414
            },
            "rightCorner": {
              "x": 13.747,
              "y": 3.064,
              "z": 0.414
            },
            "gtin": "4052400021136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0ae",
            "leftCorner": {
              "x": 13.746,
              "y": 3.071,
              "z": 0.414
            },
            "rightCorner": {
              "x": 13.809,
              "y": 3.067,
              "z": 0.414
            },
            "gtin": "4052400021204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0af",
            "leftCorner": {
              "x": 13.809,
              "y": 3.067,
              "z": 0.414
            },
            "rightCorner": {
              "x": 13.872,
              "y": 3.062,
              "z": 0.414
            },
            "gtin": "4052400021204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0b0",
            "leftCorner": {
              "x": 13.872,
              "y": 3.062,
              "z": 0.414
            },
            "rightCorner": {
              "x": 13.935,
              "y": 3.057,
              "z": 0.414
            },
            "gtin": "4052400021204",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546193",
        "height": 0.74871,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d082",
            "leftCorner": {
              "x": 12.721,
              "y": 3.15,
              "z": 0.613
            },
            "rightCorner": {
              "x": 12.813,
              "y": 3.144,
              "z": 0.613
            },
            "gtin": "4000521031671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d083",
            "leftCorner": {
              "x": 12.813,
              "y": 3.144,
              "z": 0.613
            },
            "rightCorner": {
              "x": 12.904,
              "y": 3.137,
              "z": 0.613
            },
            "gtin": "4000521031671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d084",
            "leftCorner": {
              "x": 12.903,
              "y": 3.132,
              "z": 0.613
            },
            "rightCorner": {
              "x": 12.979,
              "y": 3.126,
              "z": 0.613
            },
            "gtin": "4049583113901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d085",
            "leftCorner": {
              "x": 12.979,
              "y": 3.128,
              "z": 0.613
            },
            "rightCorner": {
              "x": 13.047,
              "y": 3.123,
              "z": 0.613
            },
            "gtin": "4022500142291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d086",
            "leftCorner": {
              "x": 13.047,
              "y": 3.118,
              "z": 0.613
            },
            "rightCorner": {
              "x": 13.151,
              "y": 3.111,
              "z": 0.613
            },
            "gtin": "40225883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d087",
            "leftCorner": {
              "x": 13.151,
              "y": 3.115,
              "z": 0.613
            },
            "rightCorner": {
              "x": 13.211,
              "y": 3.111,
              "z": 0.613
            },
            "gtin": "4022500142321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d088",
            "leftCorner": {
              "x": 13.21,
              "y": 3.095,
              "z": 0.613
            },
            "rightCorner": {
              "x": 13.285,
              "y": 3.089,
              "z": 0.613
            },
            "gtin": "4022500142536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d089",
            "leftCorner": {
              "x": 13.285,
              "y": 3.085,
              "z": 0.613
            },
            "rightCorner": {
              "x": 13.379,
              "y": 3.078,
              "z": 0.613
            },
            "gtin": "4022500140297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d08a",
            "leftCorner": {
              "x": 13.378,
              "y": 3.076,
              "z": 0.613
            },
            "rightCorner": {
              "x": 13.547,
              "y": 3.063,
              "z": 0.613
            },
            "gtin": "4022500140204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d08b",
            "leftCorner": {
              "x": 13.546,
              "y": 3.056,
              "z": 0.613
            },
            "rightCorner": {
              "x": 13.577,
              "y": 3.054,
              "z": 0.613
            },
            "gtin": "4009853650130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d08c",
            "leftCorner": {
              "x": 13.577,
              "y": 3.054,
              "z": 0.613
            },
            "rightCorner": {
              "x": 13.608,
              "y": 3.052,
              "z": 0.613
            },
            "gtin": "4009853650130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d08d",
            "leftCorner": {
              "x": 13.608,
              "y": 3.052,
              "z": 0.613
            },
            "rightCorner": {
              "x": 13.64,
              "y": 3.049,
              "z": 0.613
            },
            "gtin": "4009853650130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d08e",
            "leftCorner": {
              "x": 13.641,
              "y": 3.068,
              "z": 0.613
            },
            "rightCorner": {
              "x": 13.733,
              "y": 3.061,
              "z": 0.613
            },
            "gtin": "4009853650192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d08f",
            "leftCorner": {
              "x": 13.734,
              "y": 3.064,
              "z": 0.613
            },
            "rightCorner": {
              "x": 13.847,
              "y": 3.056,
              "z": 0.613
            },
            "gtin": "4009853657276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d090",
            "leftCorner": {
              "x": 13.848,
              "y": 3.061,
              "z": 0.613
            },
            "rightCorner": {
              "x": 13.958,
              "y": 3.053,
              "z": 0.613
            },
            "gtin": "4009853657290",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546195",
        "height": 1.0016,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d024",
            "leftCorner": {
              "x": 12.731,
              "y": 3.13,
              "z": 0.819
            },
            "rightCorner": {
              "x": 12.783,
              "y": 3.126,
              "z": 0.819
            },
            "gtin": "4009853114090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d025",
            "leftCorner": {
              "x": 12.783,
              "y": 3.135,
              "z": 0.819
            },
            "rightCorner": {
              "x": 12.84,
              "y": 3.131,
              "z": 0.819
            },
            "gtin": "4009853114106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d026",
            "leftCorner": {
              "x": 12.84,
              "y": 3.129,
              "z": 0.819
            },
            "rightCorner": {
              "x": 12.897,
              "y": 3.124,
              "z": 0.819
            },
            "gtin": "4009853114113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d027",
            "leftCorner": {
              "x": 12.896,
              "y": 3.12,
              "z": 0.819
            },
            "rightCorner": {
              "x": 12.946,
              "y": 3.117,
              "z": 0.819
            },
            "gtin": "4009853114120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d028",
            "leftCorner": {
              "x": 12.948,
              "y": 3.135,
              "z": 0.819
            },
            "rightCorner": {
              "x": 12.985,
              "y": 3.132,
              "z": 0.819
            },
            "gtin": "4009853114137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d029",
            "leftCorner": {
              "x": 12.983,
              "y": 3.112,
              "z": 0.819
            },
            "rightCorner": {
              "x": 13.052,
              "y": 3.107,
              "z": 0.819
            },
            "gtin": "4009853114144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d02a",
            "leftCorner": {
              "x": 13.052,
              "y": 3.122,
              "z": 0.819
            },
            "rightCorner": {
              "x": 13.109,
              "y": 3.118,
              "z": 0.819
            },
            "gtin": "4009853114151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d02b",
            "leftCorner": {
              "x": 13.108,
              "y": 3.107,
              "z": 0.819
            },
            "rightCorner": {
              "x": 13.166,
              "y": 3.103,
              "z": 0.819
            },
            "gtin": "4009853114168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d02c",
            "leftCorner": {
              "x": 13.165,
              "y": 3.093,
              "z": 0.819
            },
            "rightCorner": {
              "x": 13.22,
              "y": 3.089,
              "z": 0.819
            },
            "gtin": "4009853114175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d02d",
            "leftCorner": {
              "x": 13.22,
              "y": 3.084,
              "z": 0.819
            },
            "rightCorner": {
              "x": 13.283,
              "y": 3.079,
              "z": 0.819
            },
            "gtin": "4009853114182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d02e",
            "leftCorner": {
              "x": 13.284,
              "y": 3.083,
              "z": 0.819
            },
            "rightCorner": {
              "x": 13.387,
              "y": 3.075,
              "z": 0.819
            },
            "gtin": "4064285106457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d02f",
            "leftCorner": {
              "x": 13.387,
              "y": 3.068,
              "z": 0.819
            },
            "rightCorner": {
              "x": 13.439,
              "y": 3.064,
              "z": 0.819
            },
            "gtin": "4064285106464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d030",
            "leftCorner": {
              "x": 13.439,
              "y": 3.064,
              "z": 0.819
            },
            "rightCorner": {
              "x": 13.49,
              "y": 3.06,
              "z": 0.819
            },
            "gtin": "4064285106464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d031",
            "leftCorner": {
              "x": 13.491,
              "y": 3.063,
              "z": 0.819
            },
            "rightCorner": {
              "x": 13.617,
              "y": 3.053,
              "z": 0.819
            },
            "gtin": "4064285106488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d032",
            "leftCorner": {
              "x": 13.618,
              "y": 3.058,
              "z": 0.819
            },
            "rightCorner": {
              "x": 13.765,
              "y": 3.047,
              "z": 0.819
            },
            "gtin": "4009853657313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d033",
            "leftCorner": {
              "x": 13.768,
              "y": 3.074,
              "z": 0.819
            },
            "rightCorner": {
              "x": 13.866,
              "y": 3.067,
              "z": 0.819
            },
            "gtin": "4009853650154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfd7",
            "leftCorner": {
              "x": 13.865,
              "y": 3.053,
              "z": 0.819
            },
            "rightCorner": {
              "x": 13.934,
              "y": 3.048,
              "z": 0.819
            },
            "gtin": "4009853650178",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546196",
        "height": 1.2549,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cfc1",
            "leftCorner": {
              "x": 12.728,
              "y": 3.14,
              "z": 1.027
            },
            "rightCorner": {
              "x": 12.811,
              "y": 3.134,
              "z": 1.027
            },
            "gtin": "4000521025458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfc2",
            "leftCorner": {
              "x": 12.811,
              "y": 3.136,
              "z": 1.027
            },
            "rightCorner": {
              "x": 12.91,
              "y": 3.129,
              "z": 1.027
            },
            "gtin": "4000521042240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfc3",
            "leftCorner": {
              "x": 12.91,
              "y": 3.131,
              "z": 1.027
            },
            "rightCorner": {
              "x": 13.036,
              "y": 3.122,
              "z": 1.027
            },
            "gtin": "4049583117527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfc4",
            "leftCorner": {
              "x": 13.037,
              "y": 3.128,
              "z": 1.027
            },
            "rightCorner": {
              "x": 13.13,
              "y": 3.121,
              "z": 1.027
            },
            "gtin": "8001780498423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfc5",
            "leftCorner": {
              "x": 13.129,
              "y": 3.11,
              "z": 1.027
            },
            "rightCorner": {
              "x": 13.171,
              "y": 3.107,
              "z": 1.027
            },
            "gtin": "4000521035532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfc6",
            "leftCorner": {
              "x": 13.171,
              "y": 3.107,
              "z": 1.027
            },
            "rightCorner": {
              "x": 13.213,
              "y": 3.104,
              "z": 1.027
            },
            "gtin": "4000521035532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfc7",
            "leftCorner": {
              "x": 13.212,
              "y": 3.087,
              "z": 1.027
            },
            "rightCorner": {
              "x": 13.272,
              "y": 3.083,
              "z": 1.027
            },
            "gtin": "4063367421907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfc8",
            "leftCorner": {
              "x": 13.272,
              "y": 3.084,
              "z": 1.027
            },
            "rightCorner": {
              "x": 13.309,
              "y": 3.081,
              "z": 1.027
            },
            "gtin": "4063367421914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfc9",
            "leftCorner": {
              "x": 13.309,
              "y": 3.081,
              "z": 1.027
            },
            "rightCorner": {
              "x": 13.346,
              "y": 3.078,
              "z": 1.027
            },
            "gtin": "4063367421914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfca",
            "leftCorner": {
              "x": 13.346,
              "y": 3.078,
              "z": 1.027
            },
            "rightCorner": {
              "x": 13.381,
              "y": 3.076,
              "z": 1.027
            },
            "gtin": "4063367421914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfcb",
            "leftCorner": {
              "x": 13.382,
              "y": 3.069,
              "z": 1.027
            },
            "rightCorner": {
              "x": 13.425,
              "y": 3.066,
              "z": 1.027
            },
            "gtin": "4063367421921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfcc",
            "leftCorner": {
              "x": 13.425,
              "y": 3.066,
              "z": 1.027
            },
            "rightCorner": {
              "x": 13.468,
              "y": 3.062,
              "z": 1.027
            },
            "gtin": "4063367421921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfcd",
            "leftCorner": {
              "x": 13.468,
              "y": 3.068,
              "z": 1.027
            },
            "rightCorner": {
              "x": 13.497,
              "y": 3.066,
              "z": 1.027
            },
            "gtin": "4063367421938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfce",
            "leftCorner": {
              "x": 13.497,
              "y": 3.066,
              "z": 1.027
            },
            "rightCorner": {
              "x": 13.527,
              "y": 3.064,
              "z": 1.027
            },
            "gtin": "4063367421938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfcf",
            "leftCorner": {
              "x": 13.526,
              "y": 3.052,
              "z": 1.027
            },
            "rightCorner": {
              "x": 13.566,
              "y": 3.049,
              "z": 1.027
            },
            "gtin": "4250448350380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfd0",
            "leftCorner": {
              "x": 13.566,
              "y": 3.049,
              "z": 1.027
            },
            "rightCorner": {
              "x": 13.605,
              "y": 3.046,
              "z": 1.027
            },
            "gtin": "4250448350380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfd1",
            "leftCorner": {
              "x": 13.606,
              "y": 3.077,
              "z": 1.027
            },
            "rightCorner": {
              "x": 13.656,
              "y": 3.073,
              "z": 1.027
            },
            "gtin": "4250448350342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfd2",
            "leftCorner": {
              "x": 13.656,
              "y": 3.073,
              "z": 1.027
            },
            "rightCorner": {
              "x": 13.706,
              "y": 3.07,
              "z": 1.027
            },
            "gtin": "4049583116605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfd3",
            "leftCorner": {
              "x": 13.706,
              "y": 3.07,
              "z": 1.027
            },
            "rightCorner": {
              "x": 13.757,
              "y": 3.066,
              "z": 1.027
            },
            "gtin": "4049583116605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cfd4",
            "leftCorner": {
              "x": 13.758,
              "y": 3.074,
              "z": 1.027
            },
            "rightCorner": {
              "x": 13.831,
              "y": 3.069,
              "z": 1.027
            },
            "gtin": "4009853110566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf7a",
            "leftCorner": {
              "x": 13.831,
              "y": 3.058,
              "z": 1.027
            },
            "rightCorner": {
              "x": 13.882,
              "y": 3.054,
              "z": 1.027
            },
            "gtin": "4009853110573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf7b",
            "leftCorner": {
              "x": 13.882,
              "y": 3.054,
              "z": 1.027
            },
            "rightCorner": {
              "x": 13.934,
              "y": 3.05,
              "z": 1.027
            },
            "gtin": "4009853110573",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546194",
        "height": 1.4694,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d396",
            "leftCorner": {
              "x": 12.734,
              "y": 3.094,
              "z": 1.202
            },
            "rightCorner": {
              "x": 12.811,
              "y": 3.089,
              "z": 1.202
            },
            "gtin": "4049583117015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d397",
            "leftCorner": {
              "x": 12.811,
              "y": 3.089,
              "z": 1.202
            },
            "rightCorner": {
              "x": 12.889,
              "y": 3.083,
              "z": 1.202
            },
            "gtin": "4049583117015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d398",
            "leftCorner": {
              "x": 12.889,
              "y": 3.083,
              "z": 1.202
            },
            "rightCorner": {
              "x": 12.966,
              "y": 3.077,
              "z": 1.202
            },
            "gtin": "4049583117015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d39a",
            "leftCorner": {
              "x": 12.97,
              "y": 3.118,
              "z": 1.202
            },
            "rightCorner": {
              "x": 13.084,
              "y": 3.11,
              "z": 1.202
            },
            "gtin": "4049583115349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d39b",
            "leftCorner": {
              "x": 13.084,
              "y": 3.112,
              "z": 1.202
            },
            "rightCorner": {
              "x": 13.131,
              "y": 3.109,
              "z": 1.202
            },
            "gtin": "4064285106723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d39c",
            "leftCorner": {
              "x": 13.131,
              "y": 3.109,
              "z": 1.202
            },
            "rightCorner": {
              "x": 13.177,
              "y": 3.106,
              "z": 1.202
            },
            "gtin": "4064285106723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d39d",
            "leftCorner": {
              "x": 13.177,
              "y": 3.105,
              "z": 1.202
            },
            "rightCorner": {
              "x": 13.256,
              "y": 3.1,
              "z": 1.202
            },
            "gtin": "4049583111754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d39e",
            "leftCorner": {
              "x": 13.254,
              "y": 3.077,
              "z": 1.202
            },
            "rightCorner": {
              "x": 13.316,
              "y": 3.073,
              "z": 1.202
            },
            "gtin": "4064285103449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d39f",
            "leftCorner": {
              "x": 13.316,
              "y": 3.073,
              "z": 1.202
            },
            "rightCorner": {
              "x": 13.377,
              "y": 3.068,
              "z": 1.202
            },
            "gtin": "4064285103449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3a0",
            "leftCorner": {
              "x": 13.378,
              "y": 3.079,
              "z": 1.202
            },
            "rightCorner": {
              "x": 13.495,
              "y": 3.07,
              "z": 1.202
            },
            "gtin": "4049583117060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3a1",
            "leftCorner": {
              "x": 13.495,
              "y": 3.06,
              "z": 1.202
            },
            "rightCorner": {
              "x": 13.614,
              "y": 3.052,
              "z": 1.202
            },
            "gtin": "4049583117145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3a2",
            "leftCorner": {
              "x": 13.615,
              "y": 3.061,
              "z": 1.202
            },
            "rightCorner": {
              "x": 13.72,
              "y": 3.053,
              "z": 1.202
            },
            "gtin": "4049583117404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3a3",
            "leftCorner": {
              "x": 13.721,
              "y": 3.068,
              "z": 1.202
            },
            "rightCorner": {
              "x": 13.829,
              "y": 3.06,
              "z": 1.202
            },
            "gtin": "4064285106495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d399",
            "leftCorner": {
              "x": 13.828,
              "y": 3.053,
              "z": 1.202
            },
            "rightCorner": {
              "x": 13.934,
              "y": 3.046,
              "z": 1.202
            },
            "gtin": "4049583117442",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546197",
        "height": 1.7132,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cf37",
            "leftCorner": {
              "x": 12.716,
              "y": 3.132,
              "z": 1.402
            },
            "rightCorner": {
              "x": 12.844,
              "y": 3.122,
              "z": 1.402
            },
            "gtin": "4049583115684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf38",
            "leftCorner": {
              "x": 12.846,
              "y": 3.154,
              "z": 1.402
            },
            "rightCorner": {
              "x": 12.917,
              "y": 3.149,
              "z": 1.402
            },
            "gtin": "4250448320604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf39",
            "leftCorner": {
              "x": 12.917,
              "y": 3.149,
              "z": 1.402
            },
            "rightCorner": {
              "x": 12.987,
              "y": 3.143,
              "z": 1.402
            },
            "gtin": "4250448320604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf3a",
            "leftCorner": {
              "x": 12.987,
              "y": 3.141,
              "z": 1.402
            },
            "rightCorner": {
              "x": 13.1,
              "y": 3.133,
              "z": 1.402
            },
            "gtin": "4250448325562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf3b",
            "leftCorner": {
              "x": 13.1,
              "y": 3.13,
              "z": 1.402
            },
            "rightCorner": {
              "x": 13.185,
              "y": 3.124,
              "z": 1.402
            },
            "gtin": "4250448325593",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf3c",
            "leftCorner": {
              "x": 13.184,
              "y": 3.111,
              "z": 1.402
            },
            "rightCorner": {
              "x": 13.243,
              "y": 3.107,
              "z": 1.402
            },
            "gtin": "4250448342941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf3d",
            "leftCorner": {
              "x": 13.243,
              "y": 3.107,
              "z": 1.402
            },
            "rightCorner": {
              "x": 13.3,
              "y": 3.102,
              "z": 1.402
            },
            "gtin": "4250448342941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf3e",
            "leftCorner": {
              "x": 13.3,
              "y": 3.099,
              "z": 1.402
            },
            "rightCorner": {
              "x": 13.407,
              "y": 3.091,
              "z": 1.402
            },
            "gtin": "4250448324206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf3f",
            "leftCorner": {
              "x": 13.407,
              "y": 3.089,
              "z": 1.402
            },
            "rightCorner": {
              "x": 13.49,
              "y": 3.083,
              "z": 1.402
            },
            "gtin": "4064285111796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf40",
            "leftCorner": {
              "x": 13.489,
              "y": 3.072,
              "z": 1.402
            },
            "rightCorner": {
              "x": 13.647,
              "y": 3.06,
              "z": 1.402
            },
            "gtin": "4064285106549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf41",
            "leftCorner": {
              "x": 13.649,
              "y": 3.094,
              "z": 1.402
            },
            "rightCorner": {
              "x": 13.7,
              "y": 3.09,
              "z": 1.402
            },
            "gtin": "4009853116025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf42",
            "leftCorner": {
              "x": 13.7,
              "y": 3.09,
              "z": 1.402
            },
            "rightCorner": {
              "x": 13.75,
              "y": 3.087,
              "z": 1.402
            },
            "gtin": "4009853116025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf43",
            "leftCorner": {
              "x": 13.75,
              "y": 3.091,
              "z": 1.402
            },
            "rightCorner": {
              "x": 13.839,
              "y": 3.085,
              "z": 1.402
            },
            "gtin": "4064285103685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf44",
            "leftCorner": {
              "x": 13.839,
              "y": 3.084,
              "z": 1.402
            },
            "rightCorner": {
              "x": 13.889,
              "y": 3.08,
              "z": 1.402
            },
            "gtin": "4049583111327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf45",
            "leftCorner": {
              "x": 13.888,
              "y": 3.072,
              "z": 1.402
            },
            "rightCorner": {
              "x": 13.929,
              "y": 3.069,
              "z": 1.402
            },
            "gtin": "4064285103470",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e024f",
    "rightNeighborShelfId": "e0251"
  },
  {
    "id": "e0251",
    "name": "e0251",
    "x": 13.931,
    "y": 3.011,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036766,
      "w": 0.99932
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 58
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54619f",
        "height": 0.15284,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d166",
            "leftCorner": {
              "x": 14.034,
              "y": 3.05,
              "z": 0.125
            },
            "rightCorner": {
              "x": 14.145,
              "y": 3.042,
              "z": 0.125
            },
            "gtin": "4000521030001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d167",
            "leftCorner": {
              "x": 14.145,
              "y": 3.042,
              "z": 0.125
            },
            "rightCorner": {
              "x": 14.256,
              "y": 3.034,
              "z": 0.125
            },
            "gtin": "4000521030001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d168",
            "leftCorner": {
              "x": 14.256,
              "y": 3.037,
              "z": 0.125
            },
            "rightCorner": {
              "x": 14.424,
              "y": 3.025,
              "z": 0.125
            },
            "gtin": "4000521030025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d169",
            "leftCorner": {
              "x": 14.424,
              "y": 3.025,
              "z": 0.125
            },
            "rightCorner": {
              "x": 14.59,
              "y": 3.013,
              "z": 0.125
            },
            "gtin": "4000521030025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d16a",
            "leftCorner": {
              "x": 14.59,
              "y": 3.005,
              "z": 0.125
            },
            "rightCorner": {
              "x": 14.891,
              "y": 2.983,
              "z": 0.125
            },
            "gtin": "4000521030216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d16b",
            "leftCorner": {
              "x": 14.891,
              "y": 2.983,
              "z": 0.125
            },
            "rightCorner": {
              "x": 15.192,
              "y": 2.961,
              "z": 0.125
            },
            "gtin": "4000521030216",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54619d",
        "height": 0.44905,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d3c3",
            "leftCorner": {
              "x": 13.932,
              "y": 3.025,
              "z": 0.367
            },
            "rightCorner": {
              "x": 14.024,
              "y": 3.018,
              "z": 0.367
            },
            "gtin": "4000521029982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3c4",
            "leftCorner": {
              "x": 14.024,
              "y": 3.018,
              "z": 0.367
            },
            "rightCorner": {
              "x": 14.115,
              "y": 3.011,
              "z": 0.367
            },
            "gtin": "4000521029982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3c5",
            "leftCorner": {
              "x": 14.115,
              "y": 3.011,
              "z": 0.367
            },
            "rightCorner": {
              "x": 14.206,
              "y": 3.005,
              "z": 0.367
            },
            "gtin": "4000521029982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3c8",
            "leftCorner": {
              "x": 14.21,
              "y": 3.045,
              "z": 0.367
            },
            "rightCorner": {
              "x": 14.3,
              "y": 3.038,
              "z": 0.367
            },
            "gtin": "4000521855802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3c9",
            "leftCorner": {
              "x": 14.3,
              "y": 3.038,
              "z": 0.367
            },
            "rightCorner": {
              "x": 14.391,
              "y": 3.031,
              "z": 0.367
            },
            "gtin": "4000521855802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3ca",
            "leftCorner": {
              "x": 14.39,
              "y": 3.015,
              "z": 0.367
            },
            "rightCorner": {
              "x": 14.795,
              "y": 2.985,
              "z": 0.367
            },
            "gtin": "4000521037932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3cb",
            "leftCorner": {
              "x": 14.795,
              "y": 2.985,
              "z": 0.367
            },
            "rightCorner": {
              "x": 15.2,
              "y": 2.955,
              "z": 0.367
            },
            "gtin": "4000521037932",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54619c",
        "height": 0.7513,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d091",
            "leftCorner": {
              "x": 13.958,
              "y": 3.063,
              "z": 0.615
            },
            "rightCorner": {
              "x": 14.095,
              "y": 3.053,
              "z": 0.615
            },
            "gtin": "4000521029968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d092",
            "leftCorner": {
              "x": 14.095,
              "y": 3.053,
              "z": 0.615
            },
            "rightCorner": {
              "x": 14.231,
              "y": 3.043,
              "z": 0.615
            },
            "gtin": "4000521029968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d093",
            "leftCorner": {
              "x": 14.23,
              "y": 3.031,
              "z": 0.615
            },
            "rightCorner": {
              "x": 14.384,
              "y": 3.019,
              "z": 0.615
            },
            "gtin": "4000521029944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d094",
            "leftCorner": {
              "x": 14.384,
              "y": 3.019,
              "z": 0.615
            },
            "rightCorner": {
              "x": 14.54,
              "y": 3.008,
              "z": 0.615
            },
            "gtin": "4000521029944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d095",
            "leftCorner": {
              "x": 14.539,
              "y": 2.996,
              "z": 0.615
            },
            "rightCorner": {
              "x": 14.627,
              "y": 2.99,
              "z": 0.615
            },
            "gtin": "4000521029920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d096",
            "leftCorner": {
              "x": 14.627,
              "y": 2.99,
              "z": 0.615
            },
            "rightCorner": {
              "x": 14.716,
              "y": 2.983,
              "z": 0.615
            },
            "gtin": "4000521029920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d097",
            "leftCorner": {
              "x": 14.717,
              "y": 2.995,
              "z": 0.615
            },
            "rightCorner": {
              "x": 14.853,
              "y": 2.985,
              "z": 0.615
            },
            "gtin": "4000521034337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d098",
            "leftCorner": {
              "x": 14.853,
              "y": 2.985,
              "z": 0.615
            },
            "rightCorner": {
              "x": 14.991,
              "y": 2.974,
              "z": 0.615
            },
            "gtin": "4000521034337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d099",
            "leftCorner": {
              "x": 14.991,
              "y": 2.981,
              "z": 0.615
            },
            "rightCorner": {
              "x": 15.079,
              "y": 2.974,
              "z": 0.615
            },
            "gtin": "4000521037956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d09a",
            "leftCorner": {
              "x": 15.079,
              "y": 2.974,
              "z": 0.615
            },
            "rightCorner": {
              "x": 15.166,
              "y": 2.968,
              "z": 0.615
            },
            "gtin": "4000521037956",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54619a",
        "height": 1.055,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d3a4",
            "leftCorner": {
              "x": 13.93,
              "y": 3.0,
              "z": 0.863
            },
            "rightCorner": {
              "x": 14.081,
              "y": 2.989,
              "z": 0.863
            },
            "gtin": "4000521856007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3a6",
            "leftCorner": {
              "x": 14.085,
              "y": 3.052,
              "z": 0.863
            },
            "rightCorner": {
              "x": 14.212,
              "y": 3.043,
              "z": 0.863
            },
            "gtin": "4000521004804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3a7",
            "leftCorner": {
              "x": 14.212,
              "y": 3.043,
              "z": 0.863
            },
            "rightCorner": {
              "x": 14.339,
              "y": 3.033,
              "z": 0.863
            },
            "gtin": "4000521004804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3a8",
            "leftCorner": {
              "x": 14.339,
              "y": 3.033,
              "z": 0.863
            },
            "rightCorner": {
              "x": 14.466,
              "y": 3.024,
              "z": 0.863
            },
            "gtin": "4000521004804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3a9",
            "leftCorner": {
              "x": 14.463,
              "y": 2.995,
              "z": 0.863
            },
            "rightCorner": {
              "x": 14.627,
              "y": 2.983,
              "z": 0.863
            },
            "gtin": "4000521024642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3aa",
            "leftCorner": {
              "x": 14.627,
              "y": 2.989,
              "z": 0.863
            },
            "rightCorner": {
              "x": 14.785,
              "y": 2.977,
              "z": 0.863
            },
            "gtin": "4002809037795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3ab",
            "leftCorner": {
              "x": 14.785,
              "y": 2.977,
              "z": 0.863
            },
            "rightCorner": {
              "x": 14.942,
              "y": 2.966,
              "z": 0.863
            },
            "gtin": "4002809037795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3ac",
            "leftCorner": {
              "x": 14.942,
              "y": 2.959,
              "z": 0.863
            },
            "rightCorner": {
              "x": 15.007,
              "y": 2.954,
              "z": 0.863
            },
            "gtin": "4000521014766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3ad",
            "leftCorner": {
              "x": 15.007,
              "y": 2.954,
              "z": 0.863
            },
            "rightCorner": {
              "x": 15.071,
              "y": 2.95,
              "z": 0.863
            },
            "gtin": "4000521014766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3ae",
            "leftCorner": {
              "x": 15.071,
              "y": 2.95,
              "z": 0.863
            },
            "rightCorner": {
              "x": 15.136,
              "y": 2.945,
              "z": 0.863
            },
            "gtin": "4000521014766",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54619e",
        "height": 1.3555,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d3da",
            "leftCorner": {
              "x": 13.931,
              "y": 3.013,
              "z": 1.109
            },
            "rightCorner": {
              "x": 14.024,
              "y": 3.006,
              "z": 1.109
            },
            "gtin": "4000521004828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3db",
            "leftCorner": {
              "x": 14.024,
              "y": 3.006,
              "z": 1.109
            },
            "rightCorner": {
              "x": 14.118,
              "y": 2.999,
              "z": 1.109
            },
            "gtin": "4000521004828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3dc",
            "leftCorner": {
              "x": 14.118,
              "y": 2.999,
              "z": 1.109
            },
            "rightCorner": {
              "x": 14.21,
              "y": 2.992,
              "z": 1.109
            },
            "gtin": "4000521004828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3df",
            "leftCorner": {
              "x": 14.213,
              "y": 3.035,
              "z": 1.109
            },
            "rightCorner": {
              "x": 14.331,
              "y": 3.027,
              "z": 1.109
            },
            "gtin": "4000521854102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3e0",
            "leftCorner": {
              "x": 14.33,
              "y": 3.02,
              "z": 1.109
            },
            "rightCorner": {
              "x": 14.507,
              "y": 3.007,
              "z": 1.109
            },
            "gtin": "4000521005986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3e1",
            "leftCorner": {
              "x": 14.507,
              "y": 3.007,
              "z": 1.109
            },
            "rightCorner": {
              "x": 14.684,
              "y": 2.993,
              "z": 1.109
            },
            "gtin": "4000521005986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3e2",
            "leftCorner": {
              "x": 14.684,
              "y": 2.993,
              "z": 1.109
            },
            "rightCorner": {
              "x": 14.862,
              "y": 2.98,
              "z": 1.109
            },
            "gtin": "4000521005986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3e3",
            "leftCorner": {
              "x": 14.86,
              "y": 2.95,
              "z": 1.109
            },
            "rightCorner": {
              "x": 15.045,
              "y": 2.936,
              "z": 1.109
            },
            "gtin": "4063367309182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3e4",
            "leftCorner": {
              "x": 15.046,
              "y": 2.967,
              "z": 1.109
            },
            "rightCorner": {
              "x": 15.133,
              "y": 2.961,
              "z": 1.109
            },
            "gtin": "4000521032340",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54619b",
        "height": 1.7082,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cf46",
            "leftCorner": {
              "x": 13.929,
              "y": 3.066,
              "z": 1.398
            },
            "rightCorner": {
              "x": 13.976,
              "y": 3.063,
              "z": 1.398
            },
            "gtin": "4000521013103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf47",
            "leftCorner": {
              "x": 13.976,
              "y": 3.063,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.024,
              "y": 3.059,
              "z": 1.398
            },
            "gtin": "4000521013103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf48",
            "leftCorner": {
              "x": 14.024,
              "y": 3.057,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.101,
              "y": 3.051,
              "z": 1.398
            },
            "gtin": "4000521017163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf49",
            "leftCorner": {
              "x": 14.1,
              "y": 3.044,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.17,
              "y": 3.039,
              "z": 1.398
            },
            "gtin": "4000521037581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf4a",
            "leftCorner": {
              "x": 14.17,
              "y": 3.039,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.24,
              "y": 3.033,
              "z": 1.398
            },
            "gtin": "4000521037581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf4b",
            "leftCorner": {
              "x": 14.239,
              "y": 3.023,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.416,
              "y": 3.01,
              "z": 1.398
            },
            "gtin": "4000521037499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf4c",
            "leftCorner": {
              "x": 14.415,
              "y": 3.003,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.594,
              "y": 2.989,
              "z": 1.398
            },
            "gtin": "4002809037696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf4d",
            "leftCorner": {
              "x": 14.595,
              "y": 2.992,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.665,
              "y": 2.987,
              "z": 1.398
            },
            "gtin": "4000521009113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf4e",
            "leftCorner": {
              "x": 14.665,
              "y": 2.987,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.735,
              "y": 2.982,
              "z": 1.398
            },
            "gtin": "4000521009113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf4f",
            "leftCorner": {
              "x": 14.735,
              "y": 2.985,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.802,
              "y": 2.98,
              "z": 1.398
            },
            "gtin": "4002809035722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf50",
            "leftCorner": {
              "x": 14.802,
              "y": 2.98,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.869,
              "y": 2.975,
              "z": 1.398
            },
            "gtin": "4002809035722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf51",
            "leftCorner": {
              "x": 14.869,
              "y": 2.981,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.928,
              "y": 2.977,
              "z": 1.398
            },
            "gtin": "4002809027666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf52",
            "leftCorner": {
              "x": 14.928,
              "y": 2.977,
              "z": 1.398
            },
            "rightCorner": {
              "x": 14.987,
              "y": 2.972,
              "z": 1.398
            },
            "gtin": "4002809027666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf53",
            "leftCorner": {
              "x": 14.987,
              "y": 2.978,
              "z": 1.398
            },
            "rightCorner": {
              "x": 15.048,
              "y": 2.973,
              "z": 1.398
            },
            "gtin": "4002809040160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf54",
            "leftCorner": {
              "x": 15.048,
              "y": 2.973,
              "z": 1.398
            },
            "rightCorner": {
              "x": 15.108,
              "y": 2.969,
              "z": 1.398
            },
            "gtin": "4002809040160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf55",
            "leftCorner": {
              "x": 15.108,
              "y": 2.969,
              "z": 1.398
            },
            "rightCorner": {
              "x": 15.169,
              "y": 2.964,
              "z": 1.398
            },
            "gtin": "4002809040160",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e0250",
    "rightNeighborShelfId": "e0252"
  },
  {
    "id": "e0252",
    "name": "e0252",
    "x": 15.128,
    "y": 2.923,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.036766,
      "w": 0.99932
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 53
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5461aa",
        "height": 0.1537,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d16c",
            "leftCorner": {
              "x": 15.194,
              "y": 2.979,
              "z": 0.126
            },
            "rightCorner": {
              "x": 15.467,
              "y": 2.959,
              "z": 0.126
            },
            "gtin": "4000521030131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d16d",
            "leftCorner": {
              "x": 15.465,
              "y": 2.929,
              "z": 0.126
            },
            "rightCorner": {
              "x": 15.53,
              "y": 2.924,
              "z": 0.126
            },
            "gtin": "4000521030230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d16e",
            "leftCorner": {
              "x": 15.53,
              "y": 2.924,
              "z": 0.126
            },
            "rightCorner": {
              "x": 15.596,
              "y": 2.92,
              "z": 0.126
            },
            "gtin": "4000521030230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d16f",
            "leftCorner": {
              "x": 15.596,
              "y": 2.929,
              "z": 0.126
            },
            "rightCorner": {
              "x": 15.982,
              "y": 2.9,
              "z": 0.126
            },
            "gtin": "4000521030155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d170",
            "leftCorner": {
              "x": 15.982,
              "y": 2.9,
              "z": 0.126
            },
            "rightCorner": {
              "x": 16.369,
              "y": 2.872,
              "z": 0.126
            },
            "gtin": "4000521030155",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461a9",
        "height": 0.4508,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d3cc",
            "leftCorner": {
              "x": 15.202,
              "y": 2.972,
              "z": 0.369
            },
            "rightCorner": {
              "x": 15.395,
              "y": 2.958,
              "z": 0.369
            },
            "gtin": "4000521030193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3cd",
            "leftCorner": {
              "x": 15.395,
              "y": 2.958,
              "z": 0.369
            },
            "rightCorner": {
              "x": 15.59,
              "y": 2.943,
              "z": 0.369
            },
            "gtin": "4000521030193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3ce",
            "leftCorner": {
              "x": 15.588,
              "y": 2.93,
              "z": 0.369
            },
            "rightCorner": {
              "x": 15.815,
              "y": 2.913,
              "z": 0.369
            },
            "gtin": "4000521034627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3cf",
            "leftCorner": {
              "x": 15.815,
              "y": 2.913,
              "z": 0.369
            },
            "rightCorner": {
              "x": 16.042,
              "y": 2.896,
              "z": 0.369
            },
            "gtin": "4000521034627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3d0",
            "leftCorner": {
              "x": 16.041,
              "y": 2.886,
              "z": 0.369
            },
            "rightCorner": {
              "x": 16.172,
              "y": 2.876,
              "z": 0.369
            },
            "gtin": "4000521030117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3d1",
            "leftCorner": {
              "x": 16.172,
              "y": 2.876,
              "z": 0.369
            },
            "rightCorner": {
              "x": 16.304,
              "y": 2.867,
              "z": 0.369
            },
            "gtin": "4000521030117",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461a7",
        "height": 0.75267,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d09b",
            "leftCorner": {
              "x": 15.167,
              "y": 2.969,
              "z": 0.616
            },
            "rightCorner": {
              "x": 15.303,
              "y": 2.959,
              "z": 0.616
            },
            "gtin": "4000521038878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d09c",
            "leftCorner": {
              "x": 15.303,
              "y": 2.959,
              "z": 0.616
            },
            "rightCorner": {
              "x": 15.44,
              "y": 2.949,
              "z": 0.616
            },
            "gtin": "4000521038878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d09d",
            "leftCorner": {
              "x": 15.44,
              "y": 2.952,
              "z": 0.616
            },
            "rightCorner": {
              "x": 15.6,
              "y": 2.94,
              "z": 0.616
            },
            "gtin": "4000521030179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d09e",
            "leftCorner": {
              "x": 15.6,
              "y": 2.94,
              "z": 0.616
            },
            "rightCorner": {
              "x": 15.76,
              "y": 2.928,
              "z": 0.616
            },
            "gtin": "4000521030179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d09f",
            "leftCorner": {
              "x": 15.76,
              "y": 2.928,
              "z": 0.616
            },
            "rightCorner": {
              "x": 15.921,
              "y": 2.916,
              "z": 0.616
            },
            "gtin": "4000521030179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0a0",
            "leftCorner": {
              "x": 15.918,
              "y": 2.892,
              "z": 0.616
            },
            "rightCorner": {
              "x": 16.02,
              "y": 2.885,
              "z": 0.616
            },
            "gtin": "9180007870569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0a1",
            "leftCorner": {
              "x": 16.02,
              "y": 2.885,
              "z": 0.616
            },
            "rightCorner": {
              "x": 16.122,
              "y": 2.877,
              "z": 0.616
            },
            "gtin": "9180007870569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0a2",
            "leftCorner": {
              "x": 16.124,
              "y": 2.893,
              "z": 0.616
            },
            "rightCorner": {
              "x": 16.243,
              "y": 2.885,
              "z": 0.616
            },
            "gtin": "9180007870583",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0a3",
            "leftCorner": {
              "x": 16.241,
              "y": 2.883,
              "z": 0.616
            },
            "rightCorner": {
              "x": 16.31,
              "y": 2.878,
              "z": 0.616
            },
            "gtin": "9180007870668",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461a5",
        "height": 1.0568,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d3af",
            "leftCorner": {
              "x": 15.138,
              "y": 2.965,
              "z": 0.865
            },
            "rightCorner": {
              "x": 15.25,
              "y": 2.957,
              "z": 0.865
            },
            "gtin": "4000521500207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3b0",
            "leftCorner": {
              "x": 15.25,
              "y": 2.957,
              "z": 0.865
            },
            "rightCorner": {
              "x": 15.362,
              "y": 2.949,
              "z": 0.865
            },
            "gtin": "4000521500207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3b1",
            "leftCorner": {
              "x": 15.363,
              "y": 2.951,
              "z": 0.865
            },
            "rightCorner": {
              "x": 15.436,
              "y": 2.946,
              "z": 0.865
            },
            "gtin": "4000521885007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3b2",
            "leftCorner": {
              "x": 15.436,
              "y": 2.946,
              "z": 0.865
            },
            "rightCorner": {
              "x": 15.509,
              "y": 2.94,
              "z": 0.865
            },
            "gtin": "4000521885007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3b3",
            "leftCorner": {
              "x": 15.509,
              "y": 2.94,
              "z": 0.865
            },
            "rightCorner": {
              "x": 15.581,
              "y": 2.935,
              "z": 0.865
            },
            "gtin": "4000521885007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3b4",
            "leftCorner": {
              "x": 15.581,
              "y": 2.925,
              "z": 0.865
            },
            "rightCorner": {
              "x": 15.64,
              "y": 2.921,
              "z": 0.865
            },
            "gtin": "4002809034503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3b5",
            "leftCorner": {
              "x": 15.64,
              "y": 2.921,
              "z": 0.865
            },
            "rightCorner": {
              "x": 15.698,
              "y": 2.916,
              "z": 0.865
            },
            "gtin": "4002809034503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3b6",
            "leftCorner": {
              "x": 15.699,
              "y": 2.917,
              "z": 0.865
            },
            "rightCorner": {
              "x": 15.808,
              "y": 2.909,
              "z": 0.865
            },
            "gtin": "4002809034473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3b7",
            "leftCorner": {
              "x": 15.808,
              "y": 2.903,
              "z": 0.865
            },
            "rightCorner": {
              "x": 16.083,
              "y": 2.883,
              "z": 0.865
            },
            "gtin": "4002809035692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3b8",
            "leftCorner": {
              "x": 16.083,
              "y": 2.883,
              "z": 0.865
            },
            "rightCorner": {
              "x": 16.359,
              "y": 2.863,
              "z": 0.865
            },
            "gtin": "4002809035692",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461a6",
        "height": 1.3618,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d3e5",
            "leftCorner": {
              "x": 15.135,
              "y": 2.971,
              "z": 1.114
            },
            "rightCorner": {
              "x": 15.192,
              "y": 2.967,
              "z": 1.114
            },
            "gtin": "4002809027840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3e6",
            "leftCorner": {
              "x": 15.192,
              "y": 2.967,
              "z": 1.114
            },
            "rightCorner": {
              "x": 15.248,
              "y": 2.963,
              "z": 1.114
            },
            "gtin": "4002809027840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3e7",
            "leftCorner": {
              "x": 15.248,
              "y": 2.96,
              "z": 1.114
            },
            "rightCorner": {
              "x": 15.397,
              "y": 2.949,
              "z": 1.114
            },
            "gtin": "4002809004018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3e8",
            "leftCorner": {
              "x": 15.397,
              "y": 2.947,
              "z": 1.114
            },
            "rightCorner": {
              "x": 15.512,
              "y": 2.938,
              "z": 1.114
            },
            "gtin": "4002809004056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3e9",
            "leftCorner": {
              "x": 15.512,
              "y": 2.936,
              "z": 1.114
            },
            "rightCorner": {
              "x": 15.631,
              "y": 2.927,
              "z": 1.114
            },
            "gtin": "4002809004025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3ea",
            "leftCorner": {
              "x": 15.631,
              "y": 2.923,
              "z": 1.114
            },
            "rightCorner": {
              "x": 15.709,
              "y": 2.917,
              "z": 1.114
            },
            "gtin": "4002809027642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3eb",
            "leftCorner": {
              "x": 15.709,
              "y": 2.917,
              "z": 1.114
            },
            "rightCorner": {
              "x": 15.787,
              "y": 2.911,
              "z": 1.114
            },
            "gtin": "4002809027642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3ec",
            "leftCorner": {
              "x": 15.786,
              "y": 2.9,
              "z": 1.114
            },
            "rightCorner": {
              "x": 15.968,
              "y": 2.887,
              "z": 1.114
            },
            "gtin": "4002809027635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3ed",
            "leftCorner": {
              "x": 15.969,
              "y": 2.896,
              "z": 1.114
            },
            "rightCorner": {
              "x": 16.132,
              "y": 2.884,
              "z": 1.114
            },
            "gtin": "4002809027956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3ee",
            "leftCorner": {
              "x": 16.133,
              "y": 2.898,
              "z": 1.114
            },
            "rightCorner": {
              "x": 16.228,
              "y": 2.891,
              "z": 1.114
            },
            "gtin": "4002809004032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3ef",
            "leftCorner": {
              "x": 16.228,
              "y": 2.891,
              "z": 1.114
            },
            "rightCorner": {
              "x": 16.323,
              "y": 2.884,
              "z": 1.114
            },
            "gtin": "4002809004032",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461a8",
        "height": 1.7077,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cf56",
            "leftCorner": {
              "x": 15.169,
              "y": 2.968,
              "z": 1.397
            },
            "rightCorner": {
              "x": 15.222,
              "y": 2.964,
              "z": 1.397
            },
            "gtin": "4000521004842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf57",
            "leftCorner": {
              "x": 15.222,
              "y": 2.964,
              "z": 1.397
            },
            "rightCorner": {
              "x": 15.275,
              "y": 2.96,
              "z": 1.397
            },
            "gtin": "4000521004842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf58",
            "leftCorner": {
              "x": 15.275,
              "y": 2.96,
              "z": 1.397
            },
            "rightCorner": {
              "x": 15.328,
              "y": 2.956,
              "z": 1.397
            },
            "gtin": "4000521004842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf59",
            "leftCorner": {
              "x": 15.328,
              "y": 2.959,
              "z": 1.397
            },
            "rightCorner": {
              "x": 15.4,
              "y": 2.954,
              "z": 1.397
            },
            "gtin": "4000521880002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf5a",
            "leftCorner": {
              "x": 15.4,
              "y": 2.954,
              "z": 1.397
            },
            "rightCorner": {
              "x": 15.472,
              "y": 2.948,
              "z": 1.397
            },
            "gtin": "4000521880002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf5b",
            "leftCorner": {
              "x": 15.472,
              "y": 2.948,
              "z": 1.397
            },
            "rightCorner": {
              "x": 15.544,
              "y": 2.943,
              "z": 1.397
            },
            "gtin": "4000521880002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf5c",
            "leftCorner": {
              "x": 15.543,
              "y": 2.936,
              "z": 1.397
            },
            "rightCorner": {
              "x": 15.624,
              "y": 2.93,
              "z": 1.397
            },
            "gtin": "4000521014896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf5d",
            "leftCorner": {
              "x": 15.624,
              "y": 2.93,
              "z": 1.397
            },
            "rightCorner": {
              "x": 15.705,
              "y": 2.925,
              "z": 1.397
            },
            "gtin": "4000521014896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf5e",
            "leftCorner": {
              "x": 15.705,
              "y": 2.925,
              "z": 1.397
            },
            "rightCorner": {
              "x": 15.787,
              "y": 2.919,
              "z": 1.397
            },
            "gtin": "4000521014896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf5f",
            "leftCorner": {
              "x": 15.787,
              "y": 2.919,
              "z": 1.397
            },
            "rightCorner": {
              "x": 15.868,
              "y": 2.913,
              "z": 1.397
            },
            "gtin": "4000521014896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf60",
            "leftCorner": {
              "x": 15.867,
              "y": 2.905,
              "z": 1.397
            },
            "rightCorner": {
              "x": 16.194,
              "y": 2.881,
              "z": 1.397
            },
            "gtin": "4002809037641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf61",
            "leftCorner": {
              "x": 16.195,
              "y": 2.897,
              "z": 1.397
            },
            "rightCorner": {
              "x": 16.352,
              "y": 2.886,
              "z": 1.397
            },
            "gtin": "4002809037276",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e0251",
    "rightNeighborShelfId": "e0253"
  },
  {
    "id": "e0253",
    "name": "e0253",
    "x": 16.317,
    "y": 2.772,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.044979,
      "w": 0.99899
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 60
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5461b5",
        "height": 0.15995,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d171",
            "leftCorner": {
              "x": 16.363,
              "y": 2.817,
              "z": 0.131
            },
            "rightCorner": {
              "x": 16.48,
              "y": 2.806,
              "z": 0.131
            },
            "gtin": "4063367366567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d172",
            "leftCorner": {
              "x": 16.48,
              "y": 2.806,
              "z": 0.131
            },
            "rightCorner": {
              "x": 16.597,
              "y": 2.796,
              "z": 0.131
            },
            "gtin": "4063367366567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d173",
            "leftCorner": {
              "x": 16.597,
              "y": 2.796,
              "z": 0.131
            },
            "rightCorner": {
              "x": 16.715,
              "y": 2.785,
              "z": 0.131
            },
            "gtin": "4063367366567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d174",
            "leftCorner": {
              "x": 16.715,
              "y": 2.785,
              "z": 0.131
            },
            "rightCorner": {
              "x": 16.833,
              "y": 2.775,
              "z": 0.131
            },
            "gtin": "4063367366567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d175",
            "leftCorner": {
              "x": 16.833,
              "y": 2.787,
              "z": 0.131
            },
            "rightCorner": {
              "x": 16.957,
              "y": 2.776,
              "z": 0.131
            },
            "gtin": "4002809531033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d176",
            "leftCorner": {
              "x": 16.958,
              "y": 2.778,
              "z": 0.131
            },
            "rightCorner": {
              "x": 17.059,
              "y": 2.769,
              "z": 0.131
            },
            "gtin": "4013109018520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d177",
            "leftCorner": {
              "x": 17.059,
              "y": 2.769,
              "z": 0.131
            },
            "rightCorner": {
              "x": 17.159,
              "y": 2.76,
              "z": 0.131
            },
            "gtin": "4013109018520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d178",
            "leftCorner": {
              "x": 17.159,
              "y": 2.76,
              "z": 0.131
            },
            "rightCorner": {
              "x": 17.261,
              "y": 2.751,
              "z": 0.131
            },
            "gtin": "4013109018520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d179",
            "leftCorner": {
              "x": 17.259,
              "y": 2.733,
              "z": 0.131
            },
            "rightCorner": {
              "x": 17.434,
              "y": 2.717,
              "z": 0.131
            },
            "gtin": "4063367366574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d17a",
            "leftCorner": {
              "x": 17.434,
              "y": 2.717,
              "z": 0.131
            },
            "rightCorner": {
              "x": 17.609,
              "y": 2.701,
              "z": 0.131
            },
            "gtin": "4063367366574",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461b0",
        "height": 0.4474,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d3d2",
            "leftCorner": {
              "x": 16.297,
              "y": 2.811,
              "z": 0.366
            },
            "rightCorner": {
              "x": 16.396,
              "y": 2.802,
              "z": 0.366
            },
            "gtin": "4002809035692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3d3",
            "leftCorner": {
              "x": 16.396,
              "y": 2.802,
              "z": 0.366
            },
            "rightCorner": {
              "x": 16.497,
              "y": 2.792,
              "z": 0.366
            },
            "gtin": "4002809035692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3d4",
            "leftCorner": {
              "x": 16.499,
              "y": 2.807,
              "z": 0.366
            },
            "rightCorner": {
              "x": 16.58,
              "y": 2.8,
              "z": 0.366
            },
            "gtin": "4063367366550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3d5",
            "leftCorner": {
              "x": 16.58,
              "y": 2.8,
              "z": 0.366
            },
            "rightCorner": {
              "x": 16.663,
              "y": 2.792,
              "z": 0.366
            },
            "gtin": "4063367366550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3d6",
            "leftCorner": {
              "x": 16.663,
              "y": 2.792,
              "z": 0.366
            },
            "rightCorner": {
              "x": 16.746,
              "y": 2.785,
              "z": 0.366
            },
            "gtin": "4063367366550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3d7",
            "leftCorner": {
              "x": 16.746,
              "y": 2.785,
              "z": 0.366
            },
            "rightCorner": {
              "x": 16.828,
              "y": 2.778,
              "z": 0.366
            },
            "gtin": "4063367366550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3d8",
            "leftCorner": {
              "x": 16.827,
              "y": 2.771,
              "z": 0.366
            },
            "rightCorner": {
              "x": 17.06,
              "y": 2.75,
              "z": 0.366
            },
            "gtin": "4013109018506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3d9",
            "leftCorner": {
              "x": 17.06,
              "y": 2.75,
              "z": 0.366
            },
            "rightCorner": {
              "x": 17.292,
              "y": 2.729,
              "z": 0.366
            },
            "gtin": "4013109018506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3c6",
            "leftCorner": {
              "x": 17.294,
              "y": 2.751,
              "z": 0.366
            },
            "rightCorner": {
              "x": 17.406,
              "y": 2.741,
              "z": 0.366
            },
            "gtin": "4002809531040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3c7",
            "leftCorner": {
              "x": 17.406,
              "y": 2.741,
              "z": 0.366
            },
            "rightCorner": {
              "x": 17.518,
              "y": 2.73,
              "z": 0.366
            },
            "gtin": "4002809531040",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461b4",
        "height": 0.75129,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d0a4",
            "leftCorner": {
              "x": 16.304,
              "y": 2.82,
              "z": 0.615
            },
            "rightCorner": {
              "x": 16.559,
              "y": 2.797,
              "z": 0.615
            },
            "gtin": "4000521035211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0a5",
            "leftCorner": {
              "x": 16.559,
              "y": 2.797,
              "z": 0.615
            },
            "rightCorner": {
              "x": 16.814,
              "y": 2.774,
              "z": 0.615
            },
            "gtin": "4000521035211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0a6",
            "leftCorner": {
              "x": 16.814,
              "y": 2.775,
              "z": 0.615
            },
            "rightCorner": {
              "x": 17.125,
              "y": 2.747,
              "z": 0.615
            },
            "gtin": "4002809030345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0a7",
            "leftCorner": {
              "x": 17.125,
              "y": 2.75,
              "z": 0.615
            },
            "rightCorner": {
              "x": 17.245,
              "y": 2.739,
              "z": 0.615
            },
            "gtin": "4005394200889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0a8",
            "leftCorner": {
              "x": 17.245,
              "y": 2.739,
              "z": 0.615
            },
            "rightCorner": {
              "x": 17.366,
              "y": 2.728,
              "z": 0.615
            },
            "gtin": "4005394200889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d0a9",
            "leftCorner": {
              "x": 17.367,
              "y": 2.735,
              "z": 0.615
            },
            "rightCorner": {
              "x": 17.472,
              "y": 2.726,
              "z": 0.615
            },
            "gtin": "4337185387708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d035",
            "leftCorner": {
              "x": 17.472,
              "y": 2.723,
              "z": 0.615
            },
            "rightCorner": {
              "x": 17.517,
              "y": 2.719,
              "z": 0.615
            },
            "gtin": "4015637824901",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461b1",
        "height": 1.0506,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d3b9",
            "leftCorner": {
              "x": 16.352,
              "y": 2.81,
              "z": 0.86
            },
            "rightCorner": {
              "x": 16.437,
              "y": 2.802,
              "z": 0.86
            },
            "gtin": "4337185370083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3ba",
            "leftCorner": {
              "x": 16.437,
              "y": 2.802,
              "z": 0.86
            },
            "rightCorner": {
              "x": 16.523,
              "y": 2.795,
              "z": 0.86
            },
            "gtin": "4337185370083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3bb",
            "leftCorner": {
              "x": 16.523,
              "y": 2.796,
              "z": 0.86
            },
            "rightCorner": {
              "x": 16.658,
              "y": 2.784,
              "z": 0.86
            },
            "gtin": "4337185384356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3bc",
            "leftCorner": {
              "x": 16.658,
              "y": 2.784,
              "z": 0.86
            },
            "rightCorner": {
              "x": 16.793,
              "y": 2.772,
              "z": 0.86
            },
            "gtin": "4337185384356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3bd",
            "leftCorner": {
              "x": 16.794,
              "y": 2.776,
              "z": 0.86
            },
            "rightCorner": {
              "x": 16.888,
              "y": 2.767,
              "z": 0.86
            },
            "gtin": "4015637013329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3be",
            "leftCorner": {
              "x": 16.888,
              "y": 2.767,
              "z": 0.86
            },
            "rightCorner": {
              "x": 16.984,
              "y": 2.759,
              "z": 0.86
            },
            "gtin": "4015637013329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3bf",
            "leftCorner": {
              "x": 16.984,
              "y": 2.759,
              "z": 0.86
            },
            "rightCorner": {
              "x": 17.051,
              "y": 2.753,
              "z": 0.86
            },
            "gtin": "4015637822990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3c0",
            "leftCorner": {
              "x": 17.051,
              "y": 2.753,
              "z": 0.86
            },
            "rightCorner": {
              "x": 17.118,
              "y": 2.747,
              "z": 0.86
            },
            "gtin": "4015637822990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3c1",
            "leftCorner": {
              "x": 17.118,
              "y": 2.755,
              "z": 0.86
            },
            "rightCorner": {
              "x": 17.277,
              "y": 2.74,
              "z": 0.86
            },
            "gtin": "4015637013343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3c2",
            "leftCorner": {
              "x": 17.277,
              "y": 2.74,
              "z": 0.86
            },
            "rightCorner": {
              "x": 17.434,
              "y": 2.726,
              "z": 0.86
            },
            "gtin": "4015637013343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3a5",
            "leftCorner": {
              "x": 17.434,
              "y": 2.722,
              "z": 0.86
            },
            "rightCorner": {
              "x": 17.517,
              "y": 2.714,
              "z": 0.86
            },
            "gtin": "4015637013268",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461b3",
        "height": 1.3565,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d3f0",
            "leftCorner": {
              "x": 16.313,
              "y": 2.799,
              "z": 1.11
            },
            "rightCorner": {
              "x": 16.45,
              "y": 2.787,
              "z": 1.11
            },
            "gtin": "4002809034398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3f1",
            "leftCorner": {
              "x": 16.451,
              "y": 2.796,
              "z": 1.11
            },
            "rightCorner": {
              "x": 16.641,
              "y": 2.779,
              "z": 1.11
            },
            "gtin": "4002809030277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3f2",
            "leftCorner": {
              "x": 16.64,
              "y": 2.775,
              "z": 1.11
            },
            "rightCorner": {
              "x": 16.728,
              "y": 2.767,
              "z": 1.11
            },
            "gtin": "4015637821498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3f3",
            "leftCorner": {
              "x": 16.728,
              "y": 2.767,
              "z": 1.11
            },
            "rightCorner": {
              "x": 16.817,
              "y": 2.759,
              "z": 1.11
            },
            "gtin": "4015637821498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3f4",
            "leftCorner": {
              "x": 16.818,
              "y": 2.769,
              "z": 1.11
            },
            "rightCorner": {
              "x": 16.887,
              "y": 2.762,
              "z": 1.11
            },
            "gtin": "4337185387708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3f5",
            "leftCorner": {
              "x": 16.887,
              "y": 2.762,
              "z": 1.11
            },
            "rightCorner": {
              "x": 16.956,
              "y": 2.756,
              "z": 1.11
            },
            "gtin": "4337185387708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3f6",
            "leftCorner": {
              "x": 16.956,
              "y": 2.748,
              "z": 1.11
            },
            "rightCorner": {
              "x": 17.069,
              "y": 2.738,
              "z": 1.11
            },
            "gtin": "4337185382536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3f7",
            "leftCorner": {
              "x": 17.07,
              "y": 2.749,
              "z": 1.11
            },
            "rightCorner": {
              "x": 17.294,
              "y": 2.728,
              "z": 1.11
            },
            "gtin": "4008391024014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3dd",
            "leftCorner": {
              "x": 17.294,
              "y": 2.732,
              "z": 1.11
            },
            "rightCorner": {
              "x": 17.406,
              "y": 2.722,
              "z": 1.11
            },
            "gtin": "4000521037192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d3de",
            "leftCorner": {
              "x": 17.406,
              "y": 2.722,
              "z": 1.11
            },
            "rightCorner": {
              "x": 17.517,
              "y": 2.712,
              "z": 1.11
            },
            "gtin": "4000521037192",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461b2",
        "height": 1.7074,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cf62",
            "leftCorner": {
              "x": 16.343,
              "y": 2.803,
              "z": 1.397
            },
            "rightCorner": {
              "x": 16.466,
              "y": 2.791,
              "z": 1.397
            },
            "gtin": "4005394200858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf63",
            "leftCorner": {
              "x": 16.465,
              "y": 2.783,
              "z": 1.397
            },
            "rightCorner": {
              "x": 16.585,
              "y": 2.772,
              "z": 1.397
            },
            "gtin": "4000521031015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf64",
            "leftCorner": {
              "x": 16.587,
              "y": 2.781,
              "z": 1.397
            },
            "rightCorner": {
              "x": 16.635,
              "y": 2.776,
              "z": 1.397
            },
            "gtin": "4000521030995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf65",
            "leftCorner": {
              "x": 16.635,
              "y": 2.776,
              "z": 1.397
            },
            "rightCorner": {
              "x": 16.685,
              "y": 2.772,
              "z": 1.397
            },
            "gtin": "4000521030995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf66",
            "leftCorner": {
              "x": 16.685,
              "y": 2.772,
              "z": 1.397
            },
            "rightCorner": {
              "x": 16.735,
              "y": 2.767,
              "z": 1.397
            },
            "gtin": "4000521030995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf67",
            "leftCorner": {
              "x": 16.735,
              "y": 2.77,
              "z": 1.397
            },
            "rightCorner": {
              "x": 16.839,
              "y": 2.761,
              "z": 1.397
            },
            "gtin": "4002809030253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf68",
            "leftCorner": {
              "x": 16.839,
              "y": 2.767,
              "z": 1.397
            },
            "rightCorner": {
              "x": 16.967,
              "y": 2.756,
              "z": 1.397
            },
            "gtin": "4002809030338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf69",
            "leftCorner": {
              "x": 16.967,
              "y": 2.76,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.034,
              "y": 2.754,
              "z": 1.397
            },
            "gtin": "4002809030260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf6a",
            "leftCorner": {
              "x": 17.034,
              "y": 2.754,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.102,
              "y": 2.748,
              "z": 1.397
            },
            "gtin": "4002809030260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf6b",
            "leftCorner": {
              "x": 17.102,
              "y": 2.75,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.207,
              "y": 2.741,
              "z": 1.397
            },
            "gtin": "4000521030063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf6c",
            "leftCorner": {
              "x": 17.207,
              "y": 2.74,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.413,
              "y": 2.721,
              "z": 1.397
            },
            "gtin": "4008391024014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf6d",
            "leftCorner": {
              "x": 17.413,
              "y": 2.722,
              "z": 1.397
            },
            "rightCorner": {
              "x": 17.546,
              "y": 2.71,
              "z": 1.397
            },
            "gtin": "4008391085152",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e0252",
    "rightNeighborShelfId": "e0254"
  },
  {
    "id": "e0254",
    "name": "e0254",
    "x": 17.508,
    "y": 2.668,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.045232,
      "w": 0.99898
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 57
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5461bb",
        "height": 0.15466,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1d17b",
            "leftCorner": {
              "x": 17.607,
              "y": 2.723,
              "z": 0.127
            },
            "rightCorner": {
              "x": 17.777,
              "y": 2.708,
              "z": 0.127
            },
            "gtin": "4337185613289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d17c",
            "leftCorner": {
              "x": 17.777,
              "y": 2.709,
              "z": 0.127
            },
            "rightCorner": {
              "x": 18.046,
              "y": 2.684,
              "z": 0.127
            },
            "gtin": "4337185613418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d141",
            "leftCorner": {
              "x": 18.044,
              "y": 2.666,
              "z": 0.127
            },
            "rightCorner": {
              "x": 18.21,
              "y": 2.651,
              "z": 0.127
            },
            "gtin": "4337185613272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d142",
            "leftCorner": {
              "x": 18.21,
              "y": 2.651,
              "z": 0.127
            },
            "rightCorner": {
              "x": 18.375,
              "y": 2.636,
              "z": 0.127
            },
            "gtin": "4337185613272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d143",
            "leftCorner": {
              "x": 18.375,
              "y": 2.636,
              "z": 0.127
            },
            "rightCorner": {
              "x": 18.541,
              "y": 2.621,
              "z": 0.127
            },
            "gtin": "4337185613272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1d144",
            "leftCorner": {
              "x": 18.541,
              "y": 2.621,
              "z": 0.127
            },
            "rightCorner": {
              "x": 18.708,
              "y": 2.606,
              "z": 0.127
            },
            "gtin": "4337185613272",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461b6",
        "height": 0.54953,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d4ea",
            "leftCorner": {
              "x": 17.51,
              "y": 2.686,
              "z": 0.45
            },
            "rightCorner": {
              "x": 17.691,
              "y": 2.67,
              "z": 0.45
            },
            "gtin": "4337185613425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4eb",
            "leftCorner": {
              "x": 17.691,
              "y": 2.67,
              "z": 0.45
            },
            "rightCorner": {
              "x": 17.872,
              "y": 2.653,
              "z": 0.45
            },
            "gtin": "4337185613425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4ec",
            "leftCorner": {
              "x": 17.872,
              "y": 2.653,
              "z": 0.45
            },
            "rightCorner": {
              "x": 18.052,
              "y": 2.637,
              "z": 0.45
            },
            "gtin": "4337185613425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4f1",
            "leftCorner": {
              "x": 18.056,
              "y": 2.677,
              "z": 0.45
            },
            "rightCorner": {
              "x": 18.15,
              "y": 2.668,
              "z": 0.45
            },
            "gtin": "4006363113681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4f2",
            "leftCorner": {
              "x": 18.15,
              "y": 2.668,
              "z": 0.45
            },
            "rightCorner": {
              "x": 18.244,
              "y": 2.66,
              "z": 0.45
            },
            "gtin": "4006363113681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4ed",
            "leftCorner": {
              "x": 18.244,
              "y": 2.656,
              "z": 0.45
            },
            "rightCorner": {
              "x": 18.36,
              "y": 2.646,
              "z": 0.45
            },
            "gtin": "4337185613432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4ee",
            "leftCorner": {
              "x": 18.36,
              "y": 2.646,
              "z": 0.45
            },
            "rightCorner": {
              "x": 18.475,
              "y": 2.635,
              "z": 0.45
            },
            "gtin": "4337185613432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4ef",
            "leftCorner": {
              "x": 18.475,
              "y": 2.635,
              "z": 0.45
            },
            "rightCorner": {
              "x": 18.592,
              "y": 2.625,
              "z": 0.45
            },
            "gtin": "4337185613432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4f0",
            "leftCorner": {
              "x": 18.592,
              "y": 2.625,
              "z": 0.45
            },
            "rightCorner": {
              "x": 18.708,
              "y": 2.614,
              "z": 0.45
            },
            "gtin": "4337185613432",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461ba",
        "height": 0.95449,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d506",
            "leftCorner": {
              "x": 17.509,
              "y": 2.679,
              "z": 0.781
            },
            "rightCorner": {
              "x": 17.753,
              "y": 2.657,
              "z": 0.781
            },
            "gtin": "4015537441321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d50a",
            "leftCorner": {
              "x": 17.757,
              "y": 2.705,
              "z": 0.781
            },
            "rightCorner": {
              "x": 17.857,
              "y": 2.696,
              "z": 0.781
            },
            "gtin": "4015637015286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d50b",
            "leftCorner": {
              "x": 17.857,
              "y": 2.696,
              "z": 0.781
            },
            "rightCorner": {
              "x": 17.957,
              "y": 2.687,
              "z": 0.781
            },
            "gtin": "4015637015286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d50c",
            "leftCorner": {
              "x": 17.957,
              "y": 2.687,
              "z": 0.781
            },
            "rightCorner": {
              "x": 18.056,
              "y": 2.678,
              "z": 0.781
            },
            "gtin": "4015637015286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d50d",
            "leftCorner": {
              "x": 18.055,
              "y": 2.666,
              "z": 0.781
            },
            "rightCorner": {
              "x": 18.129,
              "y": 2.659,
              "z": 0.781
            },
            "gtin": "4015637017853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d50e",
            "leftCorner": {
              "x": 18.129,
              "y": 2.659,
              "z": 0.781
            },
            "rightCorner": {
              "x": 18.203,
              "y": 2.653,
              "z": 0.781
            },
            "gtin": "4015637017853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d50f",
            "leftCorner": {
              "x": 18.203,
              "y": 2.653,
              "z": 0.781
            },
            "rightCorner": {
              "x": 18.277,
              "y": 2.646,
              "z": 0.781
            },
            "gtin": "4015637017853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d507",
            "leftCorner": {
              "x": 18.276,
              "y": 2.64,
              "z": 0.781
            },
            "rightCorner": {
              "x": 18.419,
              "y": 2.627,
              "z": 0.781
            },
            "gtin": "4015637826417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d508",
            "leftCorner": {
              "x": 18.419,
              "y": 2.627,
              "z": 0.781
            },
            "rightCorner": {
              "x": 18.563,
              "y": 2.614,
              "z": 0.781
            },
            "gtin": "4015637826417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d509",
            "leftCorner": {
              "x": 18.563,
              "y": 2.614,
              "z": 0.781
            },
            "rightCorner": {
              "x": 18.707,
              "y": 2.601,
              "z": 0.781
            },
            "gtin": "4015637826417",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461b7",
        "height": 1.2504,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d4f3",
            "leftCorner": {
              "x": 17.509,
              "y": 2.681,
              "z": 1.023
            },
            "rightCorner": {
              "x": 17.723,
              "y": 2.662,
              "z": 1.023
            },
            "gtin": "4006363103309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4f5",
            "leftCorner": {
              "x": 17.727,
              "y": 2.708,
              "z": 1.023
            },
            "rightCorner": {
              "x": 17.948,
              "y": 2.688,
              "z": 1.023
            },
            "gtin": "4015637015323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4f6",
            "leftCorner": {
              "x": 17.948,
              "y": 2.684,
              "z": 1.023
            },
            "rightCorner": {
              "x": 18.103,
              "y": 2.67,
              "z": 1.023
            },
            "gtin": "4015637824796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4f7",
            "leftCorner": {
              "x": 18.103,
              "y": 2.662,
              "z": 1.023
            },
            "rightCorner": {
              "x": 18.205,
              "y": 2.653,
              "z": 1.023
            },
            "gtin": "4015637827445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4f8",
            "leftCorner": {
              "x": 18.205,
              "y": 2.653,
              "z": 1.023
            },
            "rightCorner": {
              "x": 18.308,
              "y": 2.644,
              "z": 1.023
            },
            "gtin": "4015637827445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4f9",
            "leftCorner": {
              "x": 18.308,
              "y": 2.644,
              "z": 1.023
            },
            "rightCorner": {
              "x": 18.389,
              "y": 2.636,
              "z": 1.023
            },
            "gtin": "4015637827377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4fa",
            "leftCorner": {
              "x": 18.389,
              "y": 2.636,
              "z": 1.023
            },
            "rightCorner": {
              "x": 18.47,
              "y": 2.629,
              "z": 1.023
            },
            "gtin": "4015637827377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4fb",
            "leftCorner": {
              "x": 18.47,
              "y": 2.629,
              "z": 1.023
            },
            "rightCorner": {
              "x": 18.552,
              "y": 2.621,
              "z": 1.023
            },
            "gtin": "4015637827377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4f4",
            "leftCorner": {
              "x": 18.552,
              "y": 2.625,
              "z": 1.023
            },
            "rightCorner": {
              "x": 18.708,
              "y": 2.611,
              "z": 1.023
            },
            "gtin": "4015637007250",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461b9",
        "height": 1.502,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d4fc",
            "leftCorner": {
              "x": 17.508,
              "y": 2.674,
              "z": 1.229
            },
            "rightCorner": {
              "x": 17.573,
              "y": 2.668,
              "z": 1.229
            },
            "gtin": "4000521028152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4fd",
            "leftCorner": {
              "x": 17.573,
              "y": 2.668,
              "z": 1.229
            },
            "rightCorner": {
              "x": 17.637,
              "y": 2.662,
              "z": 1.229
            },
            "gtin": "4000521028152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4ff",
            "leftCorner": {
              "x": 17.641,
              "y": 2.707,
              "z": 1.229
            },
            "rightCorner": {
              "x": 17.752,
              "y": 2.697,
              "z": 1.229
            },
            "gtin": "4035731805408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d500",
            "leftCorner": {
              "x": 17.752,
              "y": 2.697,
              "z": 1.229
            },
            "rightCorner": {
              "x": 17.863,
              "y": 2.687,
              "z": 1.229
            },
            "gtin": "4035731805408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d501",
            "leftCorner": {
              "x": 17.861,
              "y": 2.667,
              "z": 1.229
            },
            "rightCorner": {
              "x": 18.091,
              "y": 2.646,
              "z": 1.229
            },
            "gtin": "4063367429699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d502",
            "leftCorner": {
              "x": 18.091,
              "y": 2.646,
              "z": 1.229
            },
            "rightCorner": {
              "x": 18.321,
              "y": 2.626,
              "z": 1.229
            },
            "gtin": "4063367429699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d503",
            "leftCorner": {
              "x": 18.321,
              "y": 2.633,
              "z": 1.229
            },
            "rightCorner": {
              "x": 18.397,
              "y": 2.626,
              "z": 1.229
            },
            "gtin": "4000406073505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d504",
            "leftCorner": {
              "x": 18.397,
              "y": 2.626,
              "z": 1.229
            },
            "rightCorner": {
              "x": 18.472,
              "y": 2.62,
              "z": 1.229
            },
            "gtin": "4000406073505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d505",
            "leftCorner": {
              "x": 18.472,
              "y": 2.62,
              "z": 1.229
            },
            "rightCorner": {
              "x": 18.548,
              "y": 2.613,
              "z": 1.229
            },
            "gtin": "4000406073505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d4fe",
            "leftCorner": {
              "x": 18.548,
              "y": 2.622,
              "z": 1.229
            },
            "rightCorner": {
              "x": 18.708,
              "y": 2.607,
              "z": 1.229
            },
            "gtin": "4000406072904",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461b8",
        "height": 1.7009,
        "facings": [
          {
            "id": "68300c835ed67a01d9a1cf6e",
            "leftCorner": {
              "x": 17.542,
              "y": 2.72,
              "z": 1.392
            },
            "rightCorner": {
              "x": 17.635,
              "y": 2.711,
              "z": 1.392
            },
            "gtin": "4000521849108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf6f",
            "leftCorner": {
              "x": 17.635,
              "y": 2.711,
              "z": 1.392
            },
            "rightCorner": {
              "x": 17.727,
              "y": 2.703,
              "z": 1.392
            },
            "gtin": "4000521849108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf70",
            "leftCorner": {
              "x": 17.727,
              "y": 2.703,
              "z": 1.392
            },
            "rightCorner": {
              "x": 17.801,
              "y": 2.696,
              "z": 1.392
            },
            "gtin": "4002809037719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf71",
            "leftCorner": {
              "x": 17.801,
              "y": 2.696,
              "z": 1.392
            },
            "rightCorner": {
              "x": 17.874,
              "y": 2.689,
              "z": 1.392
            },
            "gtin": "4002809037719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf72",
            "leftCorner": {
              "x": 17.874,
              "y": 2.691,
              "z": 1.392
            },
            "rightCorner": {
              "x": 17.951,
              "y": 2.684,
              "z": 1.392
            },
            "gtin": "4000406003168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf73",
            "leftCorner": {
              "x": 17.951,
              "y": 2.684,
              "z": 1.392
            },
            "rightCorner": {
              "x": 18.027,
              "y": 2.677,
              "z": 1.392
            },
            "gtin": "4000406003168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf74",
            "leftCorner": {
              "x": 18.027,
              "y": 2.669,
              "z": 1.392
            },
            "rightCorner": {
              "x": 18.127,
              "y": 2.66,
              "z": 1.392
            },
            "gtin": "4000406003120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf75",
            "leftCorner": {
              "x": 18.127,
              "y": 2.66,
              "z": 1.392
            },
            "rightCorner": {
              "x": 18.227,
              "y": 2.651,
              "z": 1.392
            },
            "gtin": "4000406003120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf76",
            "leftCorner": {
              "x": 18.227,
              "y": 2.651,
              "z": 1.392
            },
            "rightCorner": {
              "x": 18.327,
              "y": 2.642,
              "z": 1.392
            },
            "gtin": "4000406003120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf77",
            "leftCorner": {
              "x": 18.327,
              "y": 2.64,
              "z": 1.392
            },
            "rightCorner": {
              "x": 18.392,
              "y": 2.634,
              "z": 1.392
            },
            "gtin": "4006363108908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cf78",
            "leftCorner": {
              "x": 18.392,
              "y": 2.634,
              "z": 1.392
            },
            "rightCorner": {
              "x": 18.457,
              "y": 2.628,
              "z": 1.392
            },
            "gtin": "4006363108908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1cee9",
            "leftCorner": {
              "x": 18.456,
              "y": 2.618,
              "z": 1.392
            },
            "rightCorner": {
              "x": 18.54,
              "y": 2.61,
              "z": 1.392
            },
            "gtin": "4006363109578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceea",
            "leftCorner": {
              "x": 18.54,
              "y": 2.61,
              "z": 1.392
            },
            "rightCorner": {
              "x": 18.623,
              "y": 2.603,
              "z": 1.392
            },
            "gtin": "4006363109578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c835ed67a01d9a1ceeb",
            "leftCorner": {
              "x": 18.623,
              "y": 2.603,
              "z": 1.392
            },
            "rightCorner": {
              "x": 18.706,
              "y": 2.595,
              "z": 1.392
            },
            "gtin": "4006363109578",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e0253"
  },
  {
    "id": "e0255",
    "name": "e0255",
    "x": 18.733,
    "y": 0.361,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9992,
      "w": 0.040097
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 73
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546971",
        "height": 0.14549,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1df8d",
            "leftCorner": {
              "x": 18.396,
              "y": 0.326,
              "z": 0.119
            },
            "rightCorner": {
              "x": 18.22,
              "y": 0.34,
              "z": 0.119
            },
            "gtin": "4046800113416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df8e",
            "leftCorner": {
              "x": 18.22,
              "y": 0.34,
              "z": 0.119
            },
            "rightCorner": {
              "x": 18.045,
              "y": 0.355,
              "z": 0.119
            },
            "gtin": "4046800113416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df8f",
            "leftCorner": {
              "x": 18.045,
              "y": 0.355,
              "z": 0.119
            },
            "rightCorner": {
              "x": 17.868,
              "y": 0.369,
              "z": 0.119
            },
            "gtin": "4046800113416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df90",
            "leftCorner": {
              "x": 17.87,
              "y": 0.374,
              "z": 0.119
            },
            "rightCorner": {
              "x": 17.774,
              "y": 0.382,
              "z": 0.119
            },
            "gtin": "9012500000306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df91",
            "leftCorner": {
              "x": 17.774,
              "y": 0.382,
              "z": 0.119
            },
            "rightCorner": {
              "x": 17.679,
              "y": 0.389,
              "z": 0.119
            },
            "gtin": "9012500000306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df92",
            "leftCorner": {
              "x": 17.68,
              "y": 0.391,
              "z": 0.119
            },
            "rightCorner": {
              "x": 17.572,
              "y": 0.399,
              "z": 0.119
            },
            "gtin": "9012500000320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df93",
            "leftCorner": {
              "x": 17.572,
              "y": 0.399,
              "z": 0.119
            },
            "rightCorner": {
              "x": 17.464,
              "y": 0.408,
              "z": 0.119
            },
            "gtin": "9012500000320",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54696d",
        "height": 0.54312,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21704",
            "leftCorner": {
              "x": 18.732,
              "y": 0.35,
              "z": 0.444
            },
            "rightCorner": {
              "x": 18.615,
              "y": 0.36,
              "z": 0.444
            },
            "gtin": "4250554712171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21705",
            "leftCorner": {
              "x": 18.615,
              "y": 0.36,
              "z": 0.444
            },
            "rightCorner": {
              "x": 18.496,
              "y": 0.369,
              "z": 0.444
            },
            "gtin": "4250554712171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21708",
            "leftCorner": {
              "x": 18.493,
              "y": 0.325,
              "z": 0.444
            },
            "rightCorner": {
              "x": 18.385,
              "y": 0.333,
              "z": 0.444
            },
            "gtin": "7640122997555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21709",
            "leftCorner": {
              "x": 18.385,
              "y": 0.333,
              "z": 0.444
            },
            "rightCorner": {
              "x": 18.278,
              "y": 0.342,
              "z": 0.444
            },
            "gtin": "7640122997555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21706",
            "leftCorner": {
              "x": 18.278,
              "y": 0.343,
              "z": 0.444
            },
            "rightCorner": {
              "x": 17.905,
              "y": 0.373,
              "z": 0.444
            },
            "gtin": "7640122997531",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21707",
            "leftCorner": {
              "x": 17.905,
              "y": 0.373,
              "z": 0.444
            },
            "rightCorner": {
              "x": 17.533,
              "y": 0.403,
              "z": 0.444
            },
            "gtin": "7640122997531",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54696c",
        "height": 0.79142,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a216f9",
            "leftCorner": {
              "x": 18.732,
              "y": 0.347,
              "z": 0.648
            },
            "rightCorner": {
              "x": 18.645,
              "y": 0.354,
              "z": 0.648
            },
            "gtin": "4000521005474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216fa",
            "leftCorner": {
              "x": 18.645,
              "y": 0.354,
              "z": 0.648
            },
            "rightCorner": {
              "x": 18.56,
              "y": 0.361,
              "z": 0.648
            },
            "gtin": "4000521005474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216fb",
            "leftCorner": {
              "x": 18.56,
              "y": 0.361,
              "z": 0.648
            },
            "rightCorner": {
              "x": 18.473,
              "y": 0.368,
              "z": 0.648
            },
            "gtin": "4000521005474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21700",
            "leftCorner": {
              "x": 18.469,
              "y": 0.326,
              "z": 0.648
            },
            "rightCorner": {
              "x": 18.325,
              "y": 0.337,
              "z": 0.648
            },
            "gtin": "4000521003371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21701",
            "leftCorner": {
              "x": 18.325,
              "y": 0.337,
              "z": 0.648
            },
            "rightCorner": {
              "x": 18.182,
              "y": 0.349,
              "z": 0.648
            },
            "gtin": "4000521003371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21702",
            "leftCorner": {
              "x": 18.182,
              "y": 0.349,
              "z": 0.648
            },
            "rightCorner": {
              "x": 18.038,
              "y": 0.36,
              "z": 0.648
            },
            "gtin": "4000521003371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21703",
            "leftCorner": {
              "x": 18.038,
              "y": 0.36,
              "z": 0.648
            },
            "rightCorner": {
              "x": 17.894,
              "y": 0.372,
              "z": 0.648
            },
            "gtin": "4000521003371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216fc",
            "leftCorner": {
              "x": 17.895,
              "y": 0.387,
              "z": 0.648
            },
            "rightCorner": {
              "x": 17.805,
              "y": 0.394,
              "z": 0.648
            },
            "gtin": "7640122997517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216fd",
            "leftCorner": {
              "x": 17.805,
              "y": 0.394,
              "z": 0.648
            },
            "rightCorner": {
              "x": 17.714,
              "y": 0.401,
              "z": 0.648
            },
            "gtin": "7640122997517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216fe",
            "leftCorner": {
              "x": 17.714,
              "y": 0.401,
              "z": 0.648
            },
            "rightCorner": {
              "x": 17.625,
              "y": 0.408,
              "z": 0.648
            },
            "gtin": "7640122997517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a216ff",
            "leftCorner": {
              "x": 17.625,
              "y": 0.408,
              "z": 0.648
            },
            "rightCorner": {
              "x": 17.534,
              "y": 0.416,
              "z": 0.648
            },
            "gtin": "7640122997517",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54696e",
        "height": 1.0443,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a21022",
            "leftCorner": {
              "x": 18.734,
              "y": 0.313,
              "z": 0.854
            },
            "rightCorner": {
              "x": 18.603,
              "y": 0.324,
              "z": 0.854
            },
            "gtin": "4000521011314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21023",
            "leftCorner": {
              "x": 18.603,
              "y": 0.324,
              "z": 0.854
            },
            "rightCorner": {
              "x": 18.472,
              "y": 0.335,
              "z": 0.854
            },
            "gtin": "4000521011314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21024",
            "leftCorner": {
              "x": 18.471,
              "y": 0.324,
              "z": 0.854
            },
            "rightCorner": {
              "x": 18.422,
              "y": 0.328,
              "z": 0.854
            },
            "gtin": "7640122997579",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21025",
            "leftCorner": {
              "x": 18.422,
              "y": 0.328,
              "z": 0.854
            },
            "rightCorner": {
              "x": 18.374,
              "y": 0.332,
              "z": 0.854
            },
            "gtin": "7640122997579",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21026",
            "leftCorner": {
              "x": 18.375,
              "y": 0.339,
              "z": 0.854
            },
            "rightCorner": {
              "x": 18.291,
              "y": 0.346,
              "z": 0.854
            },
            "gtin": "4000521730307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21027",
            "leftCorner": {
              "x": 18.291,
              "y": 0.346,
              "z": 0.854
            },
            "rightCorner": {
              "x": 18.207,
              "y": 0.353,
              "z": 0.854
            },
            "gtin": "4000521730307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21028",
            "leftCorner": {
              "x": 18.207,
              "y": 0.353,
              "z": 0.854
            },
            "rightCorner": {
              "x": 18.122,
              "y": 0.359,
              "z": 0.854
            },
            "gtin": "4000521730307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21029",
            "leftCorner": {
              "x": 18.122,
              "y": 0.359,
              "z": 0.854
            },
            "rightCorner": {
              "x": 18.039,
              "y": 0.366,
              "z": 0.854
            },
            "gtin": "4000521730307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2101c",
            "leftCorner": {
              "x": 18.039,
              "y": 0.368,
              "z": 0.854
            },
            "rightCorner": {
              "x": 17.912,
              "y": 0.379,
              "z": 0.854
            },
            "gtin": "4000521730000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2101d",
            "leftCorner": {
              "x": 17.912,
              "y": 0.379,
              "z": 0.854
            },
            "rightCorner": {
              "x": 17.787,
              "y": 0.389,
              "z": 0.854
            },
            "gtin": "4000521730000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2101e",
            "leftCorner": {
              "x": 17.787,
              "y": 0.389,
              "z": 0.854
            },
            "rightCorner": {
              "x": 17.66,
              "y": 0.399,
              "z": 0.854
            },
            "gtin": "4000521730000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2101f",
            "leftCorner": {
              "x": 17.66,
              "y": 0.399,
              "z": 0.854
            },
            "rightCorner": {
              "x": 17.533,
              "y": 0.409,
              "z": 0.854
            },
            "gtin": "4000521730000",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54696b",
        "height": 1.2967,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a21034",
            "leftCorner": {
              "x": 18.694,
              "y": 0.316,
              "z": 1.061
            },
            "rightCorner": {
              "x": 18.637,
              "y": 0.32,
              "z": 1.061
            },
            "gtin": "4002809021619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21035",
            "leftCorner": {
              "x": 18.637,
              "y": 0.32,
              "z": 1.061
            },
            "rightCorner": {
              "x": 18.579,
              "y": 0.325,
              "z": 1.061
            },
            "gtin": "4002809021619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21036",
            "leftCorner": {
              "x": 18.579,
              "y": 0.325,
              "z": 1.061
            },
            "rightCorner": {
              "x": 18.522,
              "y": 0.33,
              "z": 1.061
            },
            "gtin": "4002809021619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21037",
            "leftCorner": {
              "x": 18.524,
              "y": 0.344,
              "z": 1.061
            },
            "rightCorner": {
              "x": 18.461,
              "y": 0.349,
              "z": 1.061
            },
            "gtin": "4002809021930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21038",
            "leftCorner": {
              "x": 18.461,
              "y": 0.349,
              "z": 1.061
            },
            "rightCorner": {
              "x": 18.398,
              "y": 0.354,
              "z": 1.061
            },
            "gtin": "4002809021930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21039",
            "leftCorner": {
              "x": 18.396,
              "y": 0.333,
              "z": 1.061
            },
            "rightCorner": {
              "x": 18.294,
              "y": 0.342,
              "z": 1.061
            },
            "gtin": "4015537450002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2103a",
            "leftCorner": {
              "x": 18.294,
              "y": 0.342,
              "z": 1.061
            },
            "rightCorner": {
              "x": 18.191,
              "y": 0.35,
              "z": 1.061
            },
            "gtin": "4015537450002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2103b",
            "leftCorner": {
              "x": 18.191,
              "y": 0.35,
              "z": 1.061
            },
            "rightCorner": {
              "x": 18.089,
              "y": 0.358,
              "z": 1.061
            },
            "gtin": "4015537450002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2103c",
            "leftCorner": {
              "x": 18.089,
              "y": 0.358,
              "z": 1.061
            },
            "rightCorner": {
              "x": 17.987,
              "y": 0.366,
              "z": 1.061
            },
            "gtin": "4015537450002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2103d",
            "leftCorner": {
              "x": 17.987,
              "y": 0.366,
              "z": 1.061
            },
            "rightCorner": {
              "x": 17.885,
              "y": 0.374,
              "z": 1.061
            },
            "gtin": "4015537450002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2103e",
            "leftCorner": {
              "x": 17.885,
              "y": 0.381,
              "z": 1.061
            },
            "rightCorner": {
              "x": 17.79,
              "y": 0.389,
              "z": 1.061
            },
            "gtin": "4005394287675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2102e",
            "leftCorner": {
              "x": 17.79,
              "y": 0.398,
              "z": 1.061
            },
            "rightCorner": {
              "x": 17.706,
              "y": 0.404,
              "z": 1.061
            },
            "gtin": "4000521701215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a2102f",
            "leftCorner": {
              "x": 17.706,
              "y": 0.404,
              "z": 1.061
            },
            "rightCorner": {
              "x": 17.62,
              "y": 0.411,
              "z": 1.061
            },
            "gtin": "4000521701215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21030",
            "leftCorner": {
              "x": 17.62,
              "y": 0.411,
              "z": 1.061
            },
            "rightCorner": {
              "x": 17.534,
              "y": 0.418,
              "z": 1.061
            },
            "gtin": "4000521701215",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54696f",
        "height": 1.497,
        "facings": [
          {
            "id": "68300c8a5ed67a01d9a21053",
            "leftCorner": {
              "x": 18.738,
              "y": 0.322,
              "z": 1.225
            },
            "rightCorner": {
              "x": 18.639,
              "y": 0.33,
              "z": 1.225
            },
            "gtin": "4000521711801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21054",
            "leftCorner": {
              "x": 18.639,
              "y": 0.33,
              "z": 1.225
            },
            "rightCorner": {
              "x": 18.539,
              "y": 0.338,
              "z": 1.225
            },
            "gtin": "4000521711801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21055",
            "leftCorner": {
              "x": 18.539,
              "y": 0.338,
              "z": 1.225
            },
            "rightCorner": {
              "x": 18.438,
              "y": 0.346,
              "z": 1.225
            },
            "gtin": "4000521711801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21056",
            "leftCorner": {
              "x": 18.438,
              "y": 0.338,
              "z": 1.225
            },
            "rightCorner": {
              "x": 18.309,
              "y": 0.349,
              "z": 1.225
            },
            "gtin": "4260248061256",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21057",
            "leftCorner": {
              "x": 18.309,
              "y": 0.349,
              "z": 1.225
            },
            "rightCorner": {
              "x": 18.181,
              "y": 0.359,
              "z": 1.225
            },
            "gtin": "4260248061256",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21058",
            "leftCorner": {
              "x": 18.181,
              "y": 0.359,
              "z": 1.225
            },
            "rightCorner": {
              "x": 18.052,
              "y": 0.369,
              "z": 1.225
            },
            "gtin": "4260248061256",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21059",
            "leftCorner": {
              "x": 18.052,
              "y": 0.369,
              "z": 1.225
            },
            "rightCorner": {
              "x": 17.923,
              "y": 0.38,
              "z": 1.225
            },
            "gtin": "4260248061256",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21040",
            "leftCorner": {
              "x": 17.924,
              "y": 0.388,
              "z": 1.225
            },
            "rightCorner": {
              "x": 17.794,
              "y": 0.398,
              "z": 1.225
            },
            "gtin": "4260248061720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21041",
            "leftCorner": {
              "x": 17.794,
              "y": 0.398,
              "z": 1.225
            },
            "rightCorner": {
              "x": 17.664,
              "y": 0.409,
              "z": 1.225
            },
            "gtin": "4260248061720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8a5ed67a01d9a21042",
            "leftCorner": {
              "x": 17.664,
              "y": 0.409,
              "z": 1.225
            },
            "rightCorner": {
              "x": 17.534,
              "y": 0.419,
              "z": 1.225
            },
            "gtin": "4260248061720",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546970",
        "height": 1.6977,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1df19",
            "leftCorner": {
              "x": 18.713,
              "y": 0.319,
              "z": 1.389
            },
            "rightCorner": {
              "x": 18.631,
              "y": 0.326,
              "z": 1.389
            },
            "gtin": "4250554712607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df1a",
            "leftCorner": {
              "x": 18.631,
              "y": 0.326,
              "z": 1.389
            },
            "rightCorner": {
              "x": 18.549,
              "y": 0.333,
              "z": 1.389
            },
            "gtin": "4250554712607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df1b",
            "leftCorner": {
              "x": 18.549,
              "y": 0.333,
              "z": 1.389
            },
            "rightCorner": {
              "x": 18.467,
              "y": 0.339,
              "z": 1.389
            },
            "gtin": "4250554712607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df1c",
            "leftCorner": {
              "x": 18.466,
              "y": 0.334,
              "z": 1.389
            },
            "rightCorner": {
              "x": 18.277,
              "y": 0.349,
              "z": 1.389
            },
            "gtin": "4250554712218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df1d",
            "leftCorner": {
              "x": 18.277,
              "y": 0.349,
              "z": 1.389
            },
            "rightCorner": {
              "x": 18.087,
              "y": 0.364,
              "z": 1.389
            },
            "gtin": "4250554712218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df1e",
            "leftCorner": {
              "x": 18.087,
              "y": 0.367,
              "z": 1.389
            },
            "rightCorner": {
              "x": 18.012,
              "y": 0.373,
              "z": 1.389
            },
            "gtin": "4337185452987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df1f",
            "leftCorner": {
              "x": 18.012,
              "y": 0.373,
              "z": 1.389
            },
            "rightCorner": {
              "x": 17.937,
              "y": 0.379,
              "z": 1.389
            },
            "gtin": "4337185452987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df20",
            "leftCorner": {
              "x": 17.937,
              "y": 0.379,
              "z": 1.389
            },
            "rightCorner": {
              "x": 17.863,
              "y": 0.385,
              "z": 1.389
            },
            "gtin": "4337185452987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df21",
            "leftCorner": {
              "x": 17.863,
              "y": 0.385,
              "z": 1.389
            },
            "rightCorner": {
              "x": 17.788,
              "y": 0.391,
              "z": 1.389
            },
            "gtin": "4337185452987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df22",
            "leftCorner": {
              "x": 17.788,
              "y": 0.391,
              "z": 1.389
            },
            "rightCorner": {
              "x": 17.713,
              "y": 0.397,
              "z": 1.389
            },
            "gtin": "4337185452987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df23",
            "leftCorner": {
              "x": 17.713,
              "y": 0.4,
              "z": 1.389
            },
            "rightCorner": {
              "x": 17.647,
              "y": 0.406,
              "z": 1.389
            },
            "gtin": "4035731820005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df24",
            "leftCorner": {
              "x": 17.647,
              "y": 0.406,
              "z": 1.389
            },
            "rightCorner": {
              "x": 17.58,
              "y": 0.411,
              "z": 1.389
            },
            "gtin": "4035731820005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df25",
            "leftCorner": {
              "x": 17.58,
              "y": 0.411,
              "z": 1.389
            },
            "rightCorner": {
              "x": 17.512,
              "y": 0.417,
              "z": 1.389
            },
            "gtin": "4035731820005",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "99d78",
    "rightNeighborShelfId": "e0256"
  },
  {
    "id": "e0256",
    "name": "e0256",
    "x": 17.536,
    "y": 0.457,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9992,
      "w": 0.040097
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 57
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546976",
        "height": 0.14256,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1df94",
            "leftCorner": {
              "x": 17.463,
              "y": 0.412,
              "z": 0.117
            },
            "rightCorner": {
              "x": 17.183,
              "y": 0.434,
              "z": 0.117
            },
            "gtin": "4337185610370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df95",
            "leftCorner": {
              "x": 17.183,
              "y": 0.434,
              "z": 0.117
            },
            "rightCorner": {
              "x": 16.903,
              "y": 0.457,
              "z": 0.117
            },
            "gtin": "4337185610370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df96",
            "leftCorner": {
              "x": 16.901,
              "y": 0.444,
              "z": 0.117
            },
            "rightCorner": {
              "x": 16.332,
              "y": 0.49,
              "z": 0.117
            },
            "gtin": "4337185913914",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546974",
        "height": 0.65203,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21718",
            "leftCorner": {
              "x": 17.533,
              "y": 0.422,
              "z": 0.533
            },
            "rightCorner": {
              "x": 17.424,
              "y": 0.43,
              "z": 0.533
            },
            "gtin": "4001475101601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21719",
            "leftCorner": {
              "x": 17.424,
              "y": 0.43,
              "z": 0.533
            },
            "rightCorner": {
              "x": 17.315,
              "y": 0.439,
              "z": 0.533
            },
            "gtin": "4001475101601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2171a",
            "leftCorner": {
              "x": 17.315,
              "y": 0.439,
              "z": 0.533
            },
            "rightCorner": {
              "x": 17.206,
              "y": 0.448,
              "z": 0.533
            },
            "gtin": "4001475101601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21720",
            "leftCorner": {
              "x": 17.203,
              "y": 0.413,
              "z": 0.533
            },
            "rightCorner": {
              "x": 17.106,
              "y": 0.421,
              "z": 0.533
            },
            "gtin": "4001475102608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21721",
            "leftCorner": {
              "x": 17.106,
              "y": 0.421,
              "z": 0.533
            },
            "rightCorner": {
              "x": 17.009,
              "y": 0.428,
              "z": 0.533
            },
            "gtin": "4001475102608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21722",
            "leftCorner": {
              "x": 17.009,
              "y": 0.428,
              "z": 0.533
            },
            "rightCorner": {
              "x": 16.912,
              "y": 0.436,
              "z": 0.533
            },
            "gtin": "4001475102608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21723",
            "leftCorner": {
              "x": 16.912,
              "y": 0.436,
              "z": 0.533
            },
            "rightCorner": {
              "x": 16.814,
              "y": 0.444,
              "z": 0.533
            },
            "gtin": "4001475102608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21724",
            "leftCorner": {
              "x": 16.814,
              "y": 0.444,
              "z": 0.533
            },
            "rightCorner": {
              "x": 16.717,
              "y": 0.452,
              "z": 0.533
            },
            "gtin": "4001475102608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2171b",
            "leftCorner": {
              "x": 16.717,
              "y": 0.444,
              "z": 0.533
            },
            "rightCorner": {
              "x": 16.64,
              "y": 0.451,
              "z": 0.533
            },
            "gtin": "4001475105609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2171c",
            "leftCorner": {
              "x": 16.64,
              "y": 0.451,
              "z": 0.533
            },
            "rightCorner": {
              "x": 16.563,
              "y": 0.457,
              "z": 0.533
            },
            "gtin": "4001475105609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2171d",
            "leftCorner": {
              "x": 16.563,
              "y": 0.457,
              "z": 0.533
            },
            "rightCorner": {
              "x": 16.487,
              "y": 0.463,
              "z": 0.533
            },
            "gtin": "4001475105609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2171e",
            "leftCorner": {
              "x": 16.487,
              "y": 0.463,
              "z": 0.533
            },
            "rightCorner": {
              "x": 16.41,
              "y": 0.469,
              "z": 0.533
            },
            "gtin": "4001475105609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2171f",
            "leftCorner": {
              "x": 16.41,
              "y": 0.469,
              "z": 0.533
            },
            "rightCorner": {
              "x": 16.333,
              "y": 0.475,
              "z": 0.533
            },
            "gtin": "4001475105609",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546973",
        "height": 0.99348,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2170a",
            "leftCorner": {
              "x": 17.534,
              "y": 0.433,
              "z": 0.813
            },
            "rightCorner": {
              "x": 17.456,
              "y": 0.439,
              "z": 0.813
            },
            "gtin": "4063367010439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2170b",
            "leftCorner": {
              "x": 17.456,
              "y": 0.439,
              "z": 0.813
            },
            "rightCorner": {
              "x": 17.377,
              "y": 0.446,
              "z": 0.813
            },
            "gtin": "4063367010439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2170c",
            "leftCorner": {
              "x": 17.377,
              "y": 0.446,
              "z": 0.813
            },
            "rightCorner": {
              "x": 17.299,
              "y": 0.452,
              "z": 0.813
            },
            "gtin": "4063367010439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2170d",
            "leftCorner": {
              "x": 17.299,
              "y": 0.452,
              "z": 0.813
            },
            "rightCorner": {
              "x": 17.221,
              "y": 0.458,
              "z": 0.813
            },
            "gtin": "4063367010439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2170e",
            "leftCorner": {
              "x": 17.221,
              "y": 0.458,
              "z": 0.813
            },
            "rightCorner": {
              "x": 17.142,
              "y": 0.464,
              "z": 0.813
            },
            "gtin": "4063367010439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21712",
            "leftCorner": {
              "x": 17.14,
              "y": 0.427,
              "z": 0.813
            },
            "rightCorner": {
              "x": 16.995,
              "y": 0.438,
              "z": 0.813
            },
            "gtin": "4063367010477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21713",
            "leftCorner": {
              "x": 16.995,
              "y": 0.44,
              "z": 0.813
            },
            "rightCorner": {
              "x": 16.93,
              "y": 0.446,
              "z": 0.813
            },
            "gtin": "4063367010484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21714",
            "leftCorner": {
              "x": 16.93,
              "y": 0.446,
              "z": 0.813
            },
            "rightCorner": {
              "x": 16.866,
              "y": 0.451,
              "z": 0.813
            },
            "gtin": "4063367010484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21715",
            "leftCorner": {
              "x": 16.866,
              "y": 0.451,
              "z": 0.813
            },
            "rightCorner": {
              "x": 16.801,
              "y": 0.456,
              "z": 0.813
            },
            "gtin": "4063367010484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21716",
            "leftCorner": {
              "x": 16.801,
              "y": 0.456,
              "z": 0.813
            },
            "rightCorner": {
              "x": 16.736,
              "y": 0.461,
              "z": 0.813
            },
            "gtin": "4063367010484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21717",
            "leftCorner": {
              "x": 16.736,
              "y": 0.459,
              "z": 0.813
            },
            "rightCorner": {
              "x": 16.541,
              "y": 0.475,
              "z": 0.813
            },
            "gtin": "4001475209635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2170f",
            "leftCorner": {
              "x": 16.542,
              "y": 0.476,
              "z": 0.813
            },
            "rightCorner": {
              "x": 16.473,
              "y": 0.481,
              "z": 0.813
            },
            "gtin": "4001475208638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21710",
            "leftCorner": {
              "x": 16.473,
              "y": 0.481,
              "z": 0.813
            },
            "rightCorner": {
              "x": 16.404,
              "y": 0.487,
              "z": 0.813
            },
            "gtin": "4001475208638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21711",
            "leftCorner": {
              "x": 16.404,
              "y": 0.487,
              "z": 0.813
            },
            "rightCorner": {
              "x": 16.335,
              "y": 0.493,
              "z": 0.813
            },
            "gtin": "4001475208638",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546975",
        "height": 1.3501,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1df6f",
            "leftCorner": {
              "x": 17.534,
              "y": 0.434,
              "z": 1.105
            },
            "rightCorner": {
              "x": 17.355,
              "y": 0.449,
              "z": 1.105
            },
            "gtin": "4005924000019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df70",
            "leftCorner": {
              "x": 17.355,
              "y": 0.449,
              "z": 1.105
            },
            "rightCorner": {
              "x": 17.177,
              "y": 0.463,
              "z": 1.105
            },
            "gtin": "4005924000019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df72",
            "leftCorner": {
              "x": 17.174,
              "y": 0.423,
              "z": 1.105
            },
            "rightCorner": {
              "x": 17.104,
              "y": 0.429,
              "z": 1.105
            },
            "gtin": "4001475105708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df73",
            "leftCorner": {
              "x": 17.104,
              "y": 0.429,
              "z": 1.105
            },
            "rightCorner": {
              "x": 17.035,
              "y": 0.434,
              "z": 1.105
            },
            "gtin": "4001475105708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df74",
            "leftCorner": {
              "x": 17.035,
              "y": 0.436,
              "z": 1.105
            },
            "rightCorner": {
              "x": 16.972,
              "y": 0.441,
              "z": 1.105
            },
            "gtin": "4001475101670",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df75",
            "leftCorner": {
              "x": 16.972,
              "y": 0.441,
              "z": 1.105
            },
            "rightCorner": {
              "x": 16.909,
              "y": 0.446,
              "z": 1.105
            },
            "gtin": "4001475101670",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df76",
            "leftCorner": {
              "x": 16.909,
              "y": 0.446,
              "z": 1.105
            },
            "rightCorner": {
              "x": 16.847,
              "y": 0.451,
              "z": 1.105
            },
            "gtin": "4001475101670",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df77",
            "leftCorner": {
              "x": 16.847,
              "y": 0.451,
              "z": 1.105
            },
            "rightCorner": {
              "x": 16.783,
              "y": 0.456,
              "z": 1.105
            },
            "gtin": "4001475101670",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df78",
            "leftCorner": {
              "x": 16.784,
              "y": 0.457,
              "z": 1.105
            },
            "rightCorner": {
              "x": 16.709,
              "y": 0.464,
              "z": 1.105
            },
            "gtin": "4001475104671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df79",
            "leftCorner": {
              "x": 16.709,
              "y": 0.464,
              "z": 1.105
            },
            "rightCorner": {
              "x": 16.635,
              "y": 0.469,
              "z": 1.105
            },
            "gtin": "4001475104671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df7a",
            "leftCorner": {
              "x": 16.635,
              "y": 0.469,
              "z": 1.105
            },
            "rightCorner": {
              "x": 16.562,
              "y": 0.475,
              "z": 1.105
            },
            "gtin": "4001475104671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df7b",
            "leftCorner": {
              "x": 16.562,
              "y": 0.475,
              "z": 1.105
            },
            "rightCorner": {
              "x": 16.488,
              "y": 0.481,
              "z": 1.105
            },
            "gtin": "4001475104671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df7c",
            "leftCorner": {
              "x": 16.488,
              "y": 0.479,
              "z": 1.105
            },
            "rightCorner": {
              "x": 16.304,
              "y": 0.494,
              "z": 1.105
            },
            "gtin": "4001475102677",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546972",
        "height": 1.6968,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1df26",
            "leftCorner": {
              "x": 17.51,
              "y": 0.412,
              "z": 1.388
            },
            "rightCorner": {
              "x": 17.421,
              "y": 0.42,
              "z": 1.388
            },
            "gtin": "3183280021860",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df27",
            "leftCorner": {
              "x": 17.421,
              "y": 0.42,
              "z": 1.388
            },
            "rightCorner": {
              "x": 17.33,
              "y": 0.427,
              "z": 1.388
            },
            "gtin": "3183280021860",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df28",
            "leftCorner": {
              "x": 17.33,
              "y": 0.427,
              "z": 1.388
            },
            "rightCorner": {
              "x": 17.24,
              "y": 0.434,
              "z": 1.388
            },
            "gtin": "3183280021860",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df29",
            "leftCorner": {
              "x": 17.238,
              "y": 0.42,
              "z": 1.388
            },
            "rightCorner": {
              "x": 17.152,
              "y": 0.427,
              "z": 1.388
            },
            "gtin": "3183280021921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df2a",
            "leftCorner": {
              "x": 17.152,
              "y": 0.427,
              "z": 1.388
            },
            "rightCorner": {
              "x": 17.066,
              "y": 0.434,
              "z": 1.388
            },
            "gtin": "3183280021921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df2b",
            "leftCorner": {
              "x": 17.066,
              "y": 0.434,
              "z": 1.388
            },
            "rightCorner": {
              "x": 16.979,
              "y": 0.441,
              "z": 1.388
            },
            "gtin": "3183280021921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df2c",
            "leftCorner": {
              "x": 16.98,
              "y": 0.45,
              "z": 1.388
            },
            "rightCorner": {
              "x": 16.823,
              "y": 0.462,
              "z": 1.388
            },
            "gtin": "3183280021891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df2d",
            "leftCorner": {
              "x": 16.823,
              "y": 0.46,
              "z": 1.388
            },
            "rightCorner": {
              "x": 16.737,
              "y": 0.467,
              "z": 1.388
            },
            "gtin": "4001475107610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df2e",
            "leftCorner": {
              "x": 16.737,
              "y": 0.467,
              "z": 1.388
            },
            "rightCorner": {
              "x": 16.652,
              "y": 0.474,
              "z": 1.388
            },
            "gtin": "4001475107610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df2f",
            "leftCorner": {
              "x": 16.652,
              "y": 0.474,
              "z": 1.388
            },
            "rightCorner": {
              "x": 16.565,
              "y": 0.481,
              "z": 1.388
            },
            "gtin": "4001475107610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df30",
            "leftCorner": {
              "x": 16.564,
              "y": 0.469,
              "z": 1.388
            },
            "rightCorner": {
              "x": 16.512,
              "y": 0.473,
              "z": 1.388
            },
            "gtin": "3183280021983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df31",
            "leftCorner": {
              "x": 16.512,
              "y": 0.473,
              "z": 1.388
            },
            "rightCorner": {
              "x": 16.46,
              "y": 0.477,
              "z": 1.388
            },
            "gtin": "3183280021983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df32",
            "leftCorner": {
              "x": 16.46,
              "y": 0.477,
              "z": 1.388
            },
            "rightCorner": {
              "x": 16.408,
              "y": 0.481,
              "z": 1.388
            },
            "gtin": "3183280021983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df33",
            "leftCorner": {
              "x": 16.408,
              "y": 0.481,
              "z": 1.388
            },
            "rightCorner": {
              "x": 16.356,
              "y": 0.486,
              "z": 1.388
            },
            "gtin": "3183280021983",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e0255",
    "rightNeighborShelfId": "e0257"
  },
  {
    "id": "e0257",
    "name": "e0257",
    "x": 16.34,
    "y": 0.553,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9992,
      "w": 0.040097
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 62
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5462dc",
        "height": 0.14833,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1df97",
            "leftCorner": {
              "x": 16.332,
              "y": 0.492,
              "z": 0.121
            },
            "rightCorner": {
              "x": 16.107,
              "y": 0.51,
              "z": 0.121
            },
            "gtin": "4337185610387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df98",
            "leftCorner": {
              "x": 16.107,
              "y": 0.514,
              "z": 0.121
            },
            "rightCorner": {
              "x": 15.849,
              "y": 0.535,
              "z": 0.121
            },
            "gtin": "4337185610226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df99",
            "leftCorner": {
              "x": 15.849,
              "y": 0.535,
              "z": 0.121
            },
            "rightCorner": {
              "x": 15.59,
              "y": 0.556,
              "z": 0.121
            },
            "gtin": "4337185610226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df9a",
            "leftCorner": {
              "x": 15.59,
              "y": 0.556,
              "z": 0.121
            },
            "rightCorner": {
              "x": 15.332,
              "y": 0.577,
              "z": 0.121
            },
            "gtin": "4337185610226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df9b",
            "leftCorner": {
              "x": 15.332,
              "y": 0.577,
              "z": 0.121
            },
            "rightCorner": {
              "x": 15.072,
              "y": 0.597,
              "z": 0.121
            },
            "gtin": "4337185610226",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462da",
        "height": 0.64162,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1df5a",
            "leftCorner": {
              "x": 16.339,
              "y": 0.542,
              "z": 0.525
            },
            "rightCorner": {
              "x": 16.3,
              "y": 0.546,
              "z": 0.525
            },
            "gtin": "4001475104602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df5b",
            "leftCorner": {
              "x": 16.3,
              "y": 0.546,
              "z": 0.525
            },
            "rightCorner": {
              "x": 16.26,
              "y": 0.549,
              "z": 0.525
            },
            "gtin": "4001475104602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df5c",
            "leftCorner": {
              "x": 16.26,
              "y": 0.549,
              "z": 0.525
            },
            "rightCorner": {
              "x": 16.221,
              "y": 0.552,
              "z": 0.525
            },
            "gtin": "4001475104602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df5d",
            "leftCorner": {
              "x": 16.221,
              "y": 0.552,
              "z": 0.525
            },
            "rightCorner": {
              "x": 16.181,
              "y": 0.555,
              "z": 0.525
            },
            "gtin": "4001475104602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df60",
            "leftCorner": {
              "x": 16.178,
              "y": 0.519,
              "z": 0.525
            },
            "rightCorner": {
              "x": 15.957,
              "y": 0.537,
              "z": 0.525
            },
            "gtin": "4001475107627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df61",
            "leftCorner": {
              "x": 15.957,
              "y": 0.537,
              "z": 0.525
            },
            "rightCorner": {
              "x": 15.737,
              "y": 0.554,
              "z": 0.525
            },
            "gtin": "4001475107627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df62",
            "leftCorner": {
              "x": 15.737,
              "y": 0.556,
              "z": 0.525
            },
            "rightCorner": {
              "x": 15.647,
              "y": 0.563,
              "z": 0.525
            },
            "gtin": "4250077980811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df63",
            "leftCorner": {
              "x": 15.647,
              "y": 0.563,
              "z": 0.525
            },
            "rightCorner": {
              "x": 15.559,
              "y": 0.57,
              "z": 0.525
            },
            "gtin": "4250077980811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df64",
            "leftCorner": {
              "x": 15.559,
              "y": 0.57,
              "z": 0.525
            },
            "rightCorner": {
              "x": 15.47,
              "y": 0.577,
              "z": 0.525
            },
            "gtin": "4250077980811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df65",
            "leftCorner": {
              "x": 15.47,
              "y": 0.572,
              "z": 0.525
            },
            "rightCorner": {
              "x": 15.346,
              "y": 0.582,
              "z": 0.525
            },
            "gtin": "4250077980828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df66",
            "leftCorner": {
              "x": 15.346,
              "y": 0.582,
              "z": 0.525
            },
            "rightCorner": {
              "x": 15.222,
              "y": 0.592,
              "z": 0.525
            },
            "gtin": "4250077980828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df67",
            "leftCorner": {
              "x": 15.222,
              "y": 0.593,
              "z": 0.525
            },
            "rightCorner": {
              "x": 15.149,
              "y": 0.599,
              "z": 0.525
            },
            "gtin": "4001475205613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df68",
            "leftCorner": {
              "x": 15.149,
              "y": 0.599,
              "z": 0.525
            },
            "rightCorner": {
              "x": 15.074,
              "y": 0.605,
              "z": 0.525
            },
            "gtin": "4001475205613",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462d8",
        "height": 1.0113,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1def0",
            "leftCorner": {
              "x": 16.34,
              "y": 0.545,
              "z": 0.827
            },
            "rightCorner": {
              "x": 16.273,
              "y": 0.55,
              "z": 0.827
            },
            "gtin": "4001475201721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1def1",
            "leftCorner": {
              "x": 16.273,
              "y": 0.55,
              "z": 0.827
            },
            "rightCorner": {
              "x": 16.205,
              "y": 0.556,
              "z": 0.827
            },
            "gtin": "4001475201721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1def5",
            "leftCorner": {
              "x": 16.202,
              "y": 0.516,
              "z": 0.827
            },
            "rightCorner": {
              "x": 16.102,
              "y": 0.524,
              "z": 0.827
            },
            "gtin": "4001475201769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1def6",
            "leftCorner": {
              "x": 16.102,
              "y": 0.523,
              "z": 0.827
            },
            "rightCorner": {
              "x": 16.033,
              "y": 0.529,
              "z": 0.827
            },
            "gtin": "4001475201691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1def7",
            "leftCorner": {
              "x": 16.033,
              "y": 0.529,
              "z": 0.827
            },
            "rightCorner": {
              "x": 15.963,
              "y": 0.535,
              "z": 0.827
            },
            "gtin": "4001475201691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1def8",
            "leftCorner": {
              "x": 15.963,
              "y": 0.532,
              "z": 0.827
            },
            "rightCorner": {
              "x": 15.905,
              "y": 0.537,
              "z": 0.827
            },
            "gtin": "4001475110665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1def9",
            "leftCorner": {
              "x": 15.905,
              "y": 0.537,
              "z": 0.827
            },
            "rightCorner": {
              "x": 15.848,
              "y": 0.542,
              "z": 0.827
            },
            "gtin": "4001475110665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1defa",
            "leftCorner": {
              "x": 15.848,
              "y": 0.542,
              "z": 0.827
            },
            "rightCorner": {
              "x": 15.791,
              "y": 0.546,
              "z": 0.827
            },
            "gtin": "4001475110665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1defb",
            "leftCorner": {
              "x": 15.791,
              "y": 0.546,
              "z": 0.827
            },
            "rightCorner": {
              "x": 15.734,
              "y": 0.551,
              "z": 0.827
            },
            "gtin": "4001475110665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1defc",
            "leftCorner": {
              "x": 15.735,
              "y": 0.565,
              "z": 0.827
            },
            "rightCorner": {
              "x": 15.644,
              "y": 0.572,
              "z": 0.827
            },
            "gtin": "4001475118777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1defd",
            "leftCorner": {
              "x": 15.644,
              "y": 0.572,
              "z": 0.827
            },
            "rightCorner": {
              "x": 15.553,
              "y": 0.579,
              "z": 0.827
            },
            "gtin": "4001475118777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1defe",
            "leftCorner": {
              "x": 15.553,
              "y": 0.571,
              "z": 0.827
            },
            "rightCorner": {
              "x": 15.429,
              "y": 0.581,
              "z": 0.827
            },
            "gtin": "4001475119774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1deff",
            "leftCorner": {
              "x": 15.429,
              "y": 0.581,
              "z": 0.827
            },
            "rightCorner": {
              "x": 15.305,
              "y": 0.591,
              "z": 0.827
            },
            "gtin": "4001475119774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1def2",
            "leftCorner": {
              "x": 15.305,
              "y": 0.588,
              "z": 0.827
            },
            "rightCorner": {
              "x": 15.25,
              "y": 0.592,
              "z": 0.827
            },
            "gtin": "4001475116773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1def3",
            "leftCorner": {
              "x": 15.25,
              "y": 0.592,
              "z": 0.827
            },
            "rightCorner": {
              "x": 15.196,
              "y": 0.597,
              "z": 0.827
            },
            "gtin": "4001475116773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1def4",
            "leftCorner": {
              "x": 15.196,
              "y": 0.597,
              "z": 0.827
            },
            "rightCorner": {
              "x": 15.14,
              "y": 0.601,
              "z": 0.827
            },
            "gtin": "4001475116773",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462db",
        "height": 1.3587,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1df7d",
            "leftCorner": {
              "x": 16.306,
              "y": 0.513,
              "z": 1.112
            },
            "rightCorner": {
              "x": 16.229,
              "y": 0.519,
              "z": 1.112
            },
            "gtin": "4260114119203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df7e",
            "leftCorner": {
              "x": 16.229,
              "y": 0.519,
              "z": 1.112
            },
            "rightCorner": {
              "x": 16.151,
              "y": 0.525,
              "z": 1.112
            },
            "gtin": "4260114119203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df7f",
            "leftCorner": {
              "x": 16.151,
              "y": 0.524,
              "z": 1.112
            },
            "rightCorner": {
              "x": 16.09,
              "y": 0.529,
              "z": 1.112
            },
            "gtin": "4260114119036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df80",
            "leftCorner": {
              "x": 16.09,
              "y": 0.529,
              "z": 1.112
            },
            "rightCorner": {
              "x": 16.03,
              "y": 0.534,
              "z": 1.112
            },
            "gtin": "4260114119036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df81",
            "leftCorner": {
              "x": 16.03,
              "y": 0.534,
              "z": 1.112
            },
            "rightCorner": {
              "x": 15.97,
              "y": 0.539,
              "z": 1.112
            },
            "gtin": "4260114119036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df82",
            "leftCorner": {
              "x": 15.969,
              "y": 0.531,
              "z": 1.112
            },
            "rightCorner": {
              "x": 15.853,
              "y": 0.54,
              "z": 1.112
            },
            "gtin": "4001475115745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df83",
            "leftCorner": {
              "x": 15.854,
              "y": 0.547,
              "z": 1.112
            },
            "rightCorner": {
              "x": 15.757,
              "y": 0.554,
              "z": 1.112
            },
            "gtin": "4001475119743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df84",
            "leftCorner": {
              "x": 15.759,
              "y": 0.574,
              "z": 1.112
            },
            "rightCorner": {
              "x": 15.387,
              "y": 0.604,
              "z": 1.112
            },
            "gtin": "4001475116742",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df85",
            "leftCorner": {
              "x": 15.385,
              "y": 0.588,
              "z": 1.112
            },
            "rightCorner": {
              "x": 15.181,
              "y": 0.604,
              "z": 1.112
            },
            "gtin": "4001475118739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df71",
            "leftCorner": {
              "x": 15.181,
              "y": 0.605,
              "z": 1.112
            },
            "rightCorner": {
              "x": 15.141,
              "y": 0.608,
              "z": 1.112
            },
            "gtin": "4001475119750",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5462d9",
        "height": 1.6968,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1df34",
            "leftCorner": {
              "x": 16.359,
              "y": 0.518,
              "z": 1.388
            },
            "rightCorner": {
              "x": 16.314,
              "y": 0.521,
              "z": 1.388
            },
            "gtin": "4001475109324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df35",
            "leftCorner": {
              "x": 16.314,
              "y": 0.521,
              "z": 1.388
            },
            "rightCorner": {
              "x": 16.269,
              "y": 0.525,
              "z": 1.388
            },
            "gtin": "4001475109324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df36",
            "leftCorner": {
              "x": 16.269,
              "y": 0.518,
              "z": 1.388
            },
            "rightCorner": {
              "x": 16.182,
              "y": 0.524,
              "z": 1.388
            },
            "gtin": "4001475215476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df37",
            "leftCorner": {
              "x": 16.182,
              "y": 0.524,
              "z": 1.388
            },
            "rightCorner": {
              "x": 16.096,
              "y": 0.531,
              "z": 1.388
            },
            "gtin": "4001475215476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df38",
            "leftCorner": {
              "x": 16.096,
              "y": 0.532,
              "z": 1.388
            },
            "rightCorner": {
              "x": 16.028,
              "y": 0.537,
              "z": 1.388
            },
            "gtin": "4250077900390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df39",
            "leftCorner": {
              "x": 16.027,
              "y": 0.528,
              "z": 1.388
            },
            "rightCorner": {
              "x": 15.963,
              "y": 0.533,
              "z": 1.388
            },
            "gtin": "3183280003491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df3a",
            "leftCorner": {
              "x": 15.963,
              "y": 0.533,
              "z": 1.388
            },
            "rightCorner": {
              "x": 15.898,
              "y": 0.538,
              "z": 1.388
            },
            "gtin": "3183280003491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df3b",
            "leftCorner": {
              "x": 15.898,
              "y": 0.538,
              "z": 1.388
            },
            "rightCorner": {
              "x": 15.835,
              "y": 0.543,
              "z": 1.388
            },
            "gtin": "3183280003491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df3c",
            "leftCorner": {
              "x": 15.835,
              "y": 0.552,
              "z": 1.388
            },
            "rightCorner": {
              "x": 15.783,
              "y": 0.556,
              "z": 1.388
            },
            "gtin": "4001475112638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df3d",
            "leftCorner": {
              "x": 15.783,
              "y": 0.556,
              "z": 1.388
            },
            "rightCorner": {
              "x": 15.731,
              "y": 0.56,
              "z": 1.388
            },
            "gtin": "4001475112638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df3e",
            "leftCorner": {
              "x": 15.731,
              "y": 0.56,
              "z": 1.388
            },
            "rightCorner": {
              "x": 15.68,
              "y": 0.565,
              "z": 1.388
            },
            "gtin": "4001475112638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df3f",
            "leftCorner": {
              "x": 15.68,
              "y": 0.565,
              "z": 1.388
            },
            "rightCorner": {
              "x": 15.628,
              "y": 0.569,
              "z": 1.388
            },
            "gtin": "4001475112638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df40",
            "leftCorner": {
              "x": 15.628,
              "y": 0.57,
              "z": 1.388
            },
            "rightCorner": {
              "x": 15.494,
              "y": 0.58,
              "z": 1.388
            },
            "gtin": "4001475211621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df41",
            "leftCorner": {
              "x": 15.494,
              "y": 0.582,
              "z": 1.388
            },
            "rightCorner": {
              "x": 15.373,
              "y": 0.592,
              "z": 1.388
            },
            "gtin": "4001475112607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df42",
            "leftCorner": {
              "x": 15.373,
              "y": 0.592,
              "z": 1.388
            },
            "rightCorner": {
              "x": 15.252,
              "y": 0.602,
              "z": 1.388
            },
            "gtin": "4001475112607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df43",
            "leftCorner": {
              "x": 15.252,
              "y": 0.597,
              "z": 1.388
            },
            "rightCorner": {
              "x": 15.205,
              "y": 0.601,
              "z": 1.388
            },
            "gtin": "4001475211638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df44",
            "leftCorner": {
              "x": 15.205,
              "y": 0.601,
              "z": 1.388
            },
            "rightCorner": {
              "x": 15.158,
              "y": 0.605,
              "z": 1.388
            },
            "gtin": "4001475211638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df45",
            "leftCorner": {
              "x": 15.158,
              "y": 0.605,
              "z": 1.388
            },
            "rightCorner": {
              "x": 15.111,
              "y": 0.609,
              "z": 1.388
            },
            "gtin": "4001475211638",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e0256",
    "rightNeighborShelfId": "e0258"
  },
  {
    "id": "e0258",
    "name": "e0258",
    "x": 15.144,
    "y": 0.649,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9992,
      "w": 0.040097
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 30
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54697b",
        "height": 0.14809,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1df9c",
            "leftCorner": {
              "x": 15.074,
              "y": 0.622,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.975,
              "y": 0.63,
              "z": 0.121
            },
            "gtin": "4046800110903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df9d",
            "leftCorner": {
              "x": 14.975,
              "y": 0.63,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.876,
              "y": 0.638,
              "z": 0.121
            },
            "gtin": "4046800110903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df9e",
            "leftCorner": {
              "x": 14.876,
              "y": 0.638,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.776,
              "y": 0.646,
              "z": 0.121
            },
            "gtin": "4046800110903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df9f",
            "leftCorner": {
              "x": 14.774,
              "y": 0.625,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.674,
              "y": 0.633,
              "z": 0.121
            },
            "gtin": "4046800110125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfa0",
            "leftCorner": {
              "x": 14.674,
              "y": 0.633,
              "z": 0.121
            },
            "rightCorner": {
              "x": 14.573,
              "y": 0.641,
              "z": 0.121
            },
            "gtin": "4046800110125",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54697a",
        "height": 0.64737,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1df69",
            "leftCorner": {
              "x": 15.073,
              "y": 0.597,
              "z": 0.53
            },
            "rightCorner": {
              "x": 14.944,
              "y": 0.607,
              "z": 0.53
            },
            "gtin": "4046800110927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df6a",
            "leftCorner": {
              "x": 14.944,
              "y": 0.608,
              "z": 0.53
            },
            "rightCorner": {
              "x": 14.645,
              "y": 0.632,
              "z": 0.53
            },
            "gtin": "4063367350016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df6b",
            "leftCorner": {
              "x": 14.645,
              "y": 0.632,
              "z": 0.53
            },
            "rightCorner": {
              "x": 14.345,
              "y": 0.656,
              "z": 0.53
            },
            "gtin": "4063367350016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df6c",
            "leftCorner": {
              "x": 14.345,
              "y": 0.657,
              "z": 0.53
            },
            "rightCorner": {
              "x": 13.984,
              "y": 0.686,
              "z": 0.53
            },
            "gtin": "4063367350030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df6d",
            "leftCorner": {
              "x": 13.984,
              "y": 0.686,
              "z": 0.53
            },
            "rightCorner": {
              "x": 13.623,
              "y": 0.715,
              "z": 0.53
            },
            "gtin": "4063367350030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df6e",
            "leftCorner": {
              "x": 13.623,
              "y": 0.715,
              "z": 0.53
            },
            "rightCorner": {
              "x": 13.262,
              "y": 0.744,
              "z": 0.53
            },
            "gtin": "4063367350030",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546977",
        "height": 0.94826,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21535",
            "leftCorner": {
              "x": 15.007,
              "y": 0.646,
              "z": 0.776
            },
            "rightCorner": {
              "x": 14.873,
              "y": 0.657,
              "z": 0.776
            },
            "gtin": "4337185453021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21534",
            "leftCorner": {
              "x": 15.143,
              "y": 0.635,
              "z": 0.776
            },
            "rightCorner": {
              "x": 15.007,
              "y": 0.646,
              "z": 0.776
            },
            "gtin": "4337185453021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21536",
            "leftCorner": {
              "x": 14.873,
              "y": 0.657,
              "z": 0.776
            },
            "rightCorner": {
              "x": 14.738,
              "y": 0.668,
              "z": 0.776
            },
            "gtin": "4337185453021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2153a",
            "leftCorner": {
              "x": 14.735,
              "y": 0.628,
              "z": 0.776
            },
            "rightCorner": {
              "x": 14.528,
              "y": 0.645,
              "z": 0.776
            },
            "gtin": "4337185609626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2153b",
            "leftCorner": {
              "x": 14.528,
              "y": 0.645,
              "z": 0.776
            },
            "rightCorner": {
              "x": 14.322,
              "y": 0.661,
              "z": 0.776
            },
            "gtin": "4337185609626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2153c",
            "leftCorner": {
              "x": 14.322,
              "y": 0.657,
              "z": 0.776
            },
            "rightCorner": {
              "x": 14.131,
              "y": 0.673,
              "z": 0.776
            },
            "gtin": "4003160040516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2153d",
            "leftCorner": {
              "x": 14.132,
              "y": 0.679,
              "z": 0.776
            },
            "rightCorner": {
              "x": 13.93,
              "y": 0.695,
              "z": 0.776
            },
            "gtin": "4046800111047",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546979",
        "height": 1.3015,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21725",
            "leftCorner": {
              "x": 15.143,
              "y": 0.642,
              "z": 1.065
            },
            "rightCorner": {
              "x": 15.061,
              "y": 0.648,
              "z": 1.065
            },
            "gtin": "4000521191009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21726",
            "leftCorner": {
              "x": 15.061,
              "y": 0.648,
              "z": 1.065
            },
            "rightCorner": {
              "x": 14.979,
              "y": 0.655,
              "z": 1.065
            },
            "gtin": "4000521191009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21727",
            "leftCorner": {
              "x": 14.975,
              "y": 0.613,
              "z": 1.065
            },
            "rightCorner": {
              "x": 13.943,
              "y": 0.696,
              "z": 1.065
            },
            "gtin": "4006363100131",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546978",
        "height": 1.6957,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1df46",
            "leftCorner": {
              "x": 15.111,
              "y": 0.609,
              "z": 1.387
            },
            "rightCorner": {
              "x": 14.936,
              "y": 0.623,
              "z": 1.387
            },
            "gtin": "4006363113971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df47",
            "leftCorner": {
              "x": 14.936,
              "y": 0.623,
              "z": 1.387
            },
            "rightCorner": {
              "x": 14.76,
              "y": 0.637,
              "z": 1.387
            },
            "gtin": "4006363113971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df48",
            "leftCorner": {
              "x": 14.76,
              "y": 0.637,
              "z": 1.387
            },
            "rightCorner": {
              "x": 14.585,
              "y": 0.651,
              "z": 1.387
            },
            "gtin": "4006363113971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df49",
            "leftCorner": {
              "x": 14.584,
              "y": 0.637,
              "z": 1.387
            },
            "rightCorner": {
              "x": 14.488,
              "y": 0.645,
              "z": 1.387
            },
            "gtin": "4260039763628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df4a",
            "leftCorner": {
              "x": 14.489,
              "y": 0.66,
              "z": 1.387
            },
            "rightCorner": {
              "x": 14.417,
              "y": 0.666,
              "z": 1.387
            },
            "gtin": "4015637836072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df4b",
            "leftCorner": {
              "x": 14.417,
              "y": 0.666,
              "z": 1.387
            },
            "rightCorner": {
              "x": 14.346,
              "y": 0.672,
              "z": 1.387
            },
            "gtin": "4015637836072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df4c",
            "leftCorner": {
              "x": 14.345,
              "y": 0.661,
              "z": 1.387
            },
            "rightCorner": {
              "x": 14.207,
              "y": 0.672,
              "z": 1.387
            },
            "gtin": "4260039763635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df4d",
            "leftCorner": {
              "x": 14.207,
              "y": 0.672,
              "z": 1.387
            },
            "rightCorner": {
              "x": 14.07,
              "y": 0.683,
              "z": 1.387
            },
            "gtin": "4260039763635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df4e",
            "leftCorner": {
              "x": 14.07,
              "y": 0.683,
              "z": 1.387
            },
            "rightCorner": {
              "x": 13.932,
              "y": 0.694,
              "z": 1.387
            },
            "gtin": "4260039763635",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e0257",
    "rightNeighborShelfId": "e0259"
  },
  {
    "id": "e0259",
    "name": "e0259",
    "x": 13.948,
    "y": 0.746,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9992,
      "w": 0.040097
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54697c",
        "height": 0.14573,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dfa1",
            "leftCorner": {
              "x": 13.354,
              "y": 0.737,
              "z": 0.119
            },
            "rightCorner": {
              "x": 13.13,
              "y": 0.755,
              "z": 0.119
            },
            "gtin": "4046800110927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfa2",
            "leftCorner": {
              "x": 13.13,
              "y": 0.755,
              "z": 0.119
            },
            "rightCorner": {
              "x": 12.908,
              "y": 0.773,
              "z": 0.119
            },
            "gtin": "4046800110927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfa3",
            "leftCorner": {
              "x": 12.908,
              "y": 0.773,
              "z": 0.119
            },
            "rightCorner": {
              "x": 12.685,
              "y": 0.791,
              "z": 0.119
            },
            "gtin": "4046800110927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfa4",
            "leftCorner": {
              "x": 12.685,
              "y": 0.791,
              "z": 0.119
            },
            "rightCorner": {
              "x": 12.462,
              "y": 0.808,
              "z": 0.119
            },
            "gtin": "4046800110927",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546980",
        "height": 0.64351,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1df5e",
            "leftCorner": {
              "x": 13.264,
              "y": 0.767,
              "z": 0.527
            },
            "rightCorner": {
              "x": 13.007,
              "y": 0.788,
              "z": 0.527
            },
            "gtin": "4006363114282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df5f",
            "leftCorner": {
              "x": 13.007,
              "y": 0.788,
              "z": 0.527
            },
            "rightCorner": {
              "x": 12.748,
              "y": 0.808,
              "z": 0.527
            },
            "gtin": "4006363114282",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54697e",
        "height": 0.94201,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2153e",
            "leftCorner": {
              "x": 13.932,
              "y": 0.713,
              "z": 0.771
            },
            "rightCorner": {
              "x": 13.827,
              "y": 0.721,
              "z": 0.771
            },
            "gtin": "4006363102388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2153f",
            "leftCorner": {
              "x": 13.827,
              "y": 0.721,
              "z": 0.771
            },
            "rightCorner": {
              "x": 13.722,
              "y": 0.73,
              "z": 0.771
            },
            "gtin": "4006363102388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21540",
            "leftCorner": {
              "x": 13.722,
              "y": 0.728,
              "z": 0.771
            },
            "rightCorner": {
              "x": 13.622,
              "y": 0.737,
              "z": 0.771
            },
            "gtin": "4000406002246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21541",
            "leftCorner": {
              "x": 13.622,
              "y": 0.737,
              "z": 0.771
            },
            "rightCorner": {
              "x": 13.522,
              "y": 0.745,
              "z": 0.771
            },
            "gtin": "4000406002246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21542",
            "leftCorner": {
              "x": 13.522,
              "y": 0.745,
              "z": 0.771
            },
            "rightCorner": {
              "x": 13.421,
              "y": 0.753,
              "z": 0.771
            },
            "gtin": "4000406002246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21543",
            "leftCorner": {
              "x": 13.422,
              "y": 0.767,
              "z": 0.771
            },
            "rightCorner": {
              "x": 13.308,
              "y": 0.776,
              "z": 0.771
            },
            "gtin": "4000406002277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21544",
            "leftCorner": {
              "x": 13.308,
              "y": 0.776,
              "z": 0.771
            },
            "rightCorner": {
              "x": 13.195,
              "y": 0.785,
              "z": 0.771
            },
            "gtin": "4000406002277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21545",
            "leftCorner": {
              "x": 13.195,
              "y": 0.789,
              "z": 0.771
            },
            "rightCorner": {
              "x": 13.076,
              "y": 0.798,
              "z": 0.771
            },
            "gtin": "4006363114299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21546",
            "leftCorner": {
              "x": 13.076,
              "y": 0.798,
              "z": 0.771
            },
            "rightCorner": {
              "x": 12.957,
              "y": 0.808,
              "z": 0.771
            },
            "gtin": "4006363114299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21547",
            "leftCorner": {
              "x": 12.957,
              "y": 0.808,
              "z": 0.771
            },
            "rightCorner": {
              "x": 12.837,
              "y": 0.818,
              "z": 0.771
            },
            "gtin": "4006363114299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21548",
            "leftCorner": {
              "x": 12.837,
              "y": 0.818,
              "z": 0.771
            },
            "rightCorner": {
              "x": 12.718,
              "y": 0.827,
              "z": 0.771
            },
            "gtin": "4006363114299",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54697f",
        "height": 1.2495,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21728",
            "leftCorner": {
              "x": 13.948,
              "y": 0.75,
              "z": 1.022
            },
            "rightCorner": {
              "x": 13.7,
              "y": 0.77,
              "z": 1.022
            },
            "gtin": "4000186010400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2172a",
            "leftCorner": {
              "x": 13.696,
              "y": 0.728,
              "z": 1.022
            },
            "rightCorner": {
              "x": 13.339,
              "y": 0.757,
              "z": 1.022
            },
            "gtin": "4000186016402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2172b",
            "leftCorner": {
              "x": 13.34,
              "y": 0.762,
              "z": 1.022
            },
            "rightCorner": {
              "x": 13.175,
              "y": 0.775,
              "z": 1.022
            },
            "gtin": "4000186014408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2172c",
            "leftCorner": {
              "x": 13.175,
              "y": 0.775,
              "z": 1.022
            },
            "rightCorner": {
              "x": 13.011,
              "y": 0.788,
              "z": 1.022
            },
            "gtin": "4000186014408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21729",
            "leftCorner": {
              "x": 13.01,
              "y": 0.785,
              "z": 1.022
            },
            "rightCorner": {
              "x": 12.748,
              "y": 0.806,
              "z": 1.022
            },
            "gtin": "4000186011407",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54697d",
        "height": 1.6964,
        "facings": []
      }
    ],
    "leftNeighborShelfId": "e0258",
    "rightNeighborShelfId": "e025a"
  },
  {
    "id": "e025a",
    "name": "e025a",
    "x": 12.752,
    "y": 0.842,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9992,
      "w": 0.040097
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 69
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5468fb",
        "height": 1.4469,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21571",
            "leftCorner": {
              "x": 12.698,
              "y": 0.849,
              "z": 1.184
            },
            "rightCorner": {
              "x": 12.645,
              "y": 0.853,
              "z": 1.184
            },
            "gtin": "4000186011032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21572",
            "leftCorner": {
              "x": 12.645,
              "y": 0.853,
              "z": 1.184
            },
            "rightCorner": {
              "x": 12.591,
              "y": 0.858,
              "z": 1.184
            },
            "gtin": "4000186011032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21574",
            "leftCorner": {
              "x": 12.587,
              "y": 0.816,
              "z": 1.184
            },
            "rightCorner": {
              "x": 12.506,
              "y": 0.822,
              "z": 1.184
            },
            "gtin": "4000186020201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21575",
            "leftCorner": {
              "x": 12.506,
              "y": 0.822,
              "z": 1.184
            },
            "rightCorner": {
              "x": 12.425,
              "y": 0.829,
              "z": 1.184
            },
            "gtin": "4000186020201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21576",
            "leftCorner": {
              "x": 12.426,
              "y": 0.842,
              "z": 1.184
            },
            "rightCorner": {
              "x": 12.303,
              "y": 0.852,
              "z": 1.184
            },
            "gtin": "4000186021208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21577",
            "leftCorner": {
              "x": 12.303,
              "y": 0.852,
              "z": 1.184
            },
            "rightCorner": {
              "x": 12.181,
              "y": 0.862,
              "z": 1.184
            },
            "gtin": "4000186021208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21579",
            "leftCorner": {
              "x": 11.967,
              "y": 0.877,
              "z": 1.184
            },
            "rightCorner": {
              "x": 11.754,
              "y": 0.894,
              "z": 1.184
            },
            "gtin": "4000186037919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2157a",
            "leftCorner": {
              "x": 11.752,
              "y": 0.874,
              "z": 1.184
            },
            "rightCorner": {
              "x": 11.391,
              "y": 0.903,
              "z": 1.184
            },
            "gtin": "4000186010509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21578",
            "leftCorner": {
              "x": 12.181,
              "y": 0.859,
              "z": 1.184
            },
            "rightCorner": {
              "x": 11.967,
              "y": 0.877,
              "z": 1.184
            },
            "gtin": "4000186037919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21570",
            "leftCorner": {
              "x": 12.752,
              "y": 0.845,
              "z": 1.184
            },
            "rightCorner": {
              "x": 12.698,
              "y": 0.849,
              "z": 1.184
            },
            "gtin": "4000186011032",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468fa",
        "height": 1.7015,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1df4f",
            "leftCorner": {
              "x": 12.718,
              "y": 0.817,
              "z": 1.392
            },
            "rightCorner": {
              "x": 12.572,
              "y": 0.828,
              "z": 1.392
            },
            "gtin": "4000186014507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df50",
            "leftCorner": {
              "x": 12.572,
              "y": 0.828,
              "z": 1.392
            },
            "rightCorner": {
              "x": 12.427,
              "y": 0.84,
              "z": 1.392
            },
            "gtin": "4000186014507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df51",
            "leftCorner": {
              "x": 12.427,
              "y": 0.837,
              "z": 1.392
            },
            "rightCorner": {
              "x": 12.146,
              "y": 0.859,
              "z": 1.392
            },
            "gtin": "4000186046201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df52",
            "leftCorner": {
              "x": 12.146,
              "y": 0.859,
              "z": 1.392
            },
            "rightCorner": {
              "x": 11.865,
              "y": 0.882,
              "z": 1.392
            },
            "gtin": "4000186046201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df53",
            "leftCorner": {
              "x": 11.865,
              "y": 0.88,
              "z": 1.392
            },
            "rightCorner": {
              "x": 11.676,
              "y": 0.895,
              "z": 1.392
            },
            "gtin": "8801068371550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df54",
            "leftCorner": {
              "x": 11.676,
              "y": 0.895,
              "z": 1.392
            },
            "rightCorner": {
              "x": 11.487,
              "y": 0.91,
              "z": 1.392
            },
            "gtin": "8801068371550",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468fc",
        "height": 0.14453,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dfa5",
            "leftCorner": {
              "x": 12.463,
              "y": 0.817,
              "z": 0.118
            },
            "rightCorner": {
              "x": 12.312,
              "y": 0.829,
              "z": 0.118
            },
            "gtin": "4000521036775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfa6",
            "leftCorner": {
              "x": 12.312,
              "y": 0.829,
              "z": 0.118
            },
            "rightCorner": {
              "x": 12.159,
              "y": 0.842,
              "z": 0.118
            },
            "gtin": "4000521036775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfa7",
            "leftCorner": {
              "x": 12.159,
              "y": 0.835,
              "z": 0.118
            },
            "rightCorner": {
              "x": 12.091,
              "y": 0.84,
              "z": 0.118
            },
            "gtin": "4046800110750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfa8",
            "leftCorner": {
              "x": 12.091,
              "y": 0.84,
              "z": 0.118
            },
            "rightCorner": {
              "x": 12.024,
              "y": 0.846,
              "z": 0.118
            },
            "gtin": "4046800110750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfa9",
            "leftCorner": {
              "x": 12.024,
              "y": 0.846,
              "z": 0.118
            },
            "rightCorner": {
              "x": 11.957,
              "y": 0.851,
              "z": 0.118
            },
            "gtin": "4046800110750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfaa",
            "leftCorner": {
              "x": 11.957,
              "y": 0.851,
              "z": 0.118
            },
            "rightCorner": {
              "x": 11.891,
              "y": 0.857,
              "z": 0.118
            },
            "gtin": "4046800110750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfab",
            "leftCorner": {
              "x": 11.891,
              "y": 0.857,
              "z": 0.118
            },
            "rightCorner": {
              "x": 11.803,
              "y": 0.864,
              "z": 0.118
            },
            "gtin": "4046800110743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfac",
            "leftCorner": {
              "x": 11.803,
              "y": 0.871,
              "z": 0.118
            },
            "rightCorner": {
              "x": 11.702,
              "y": 0.879,
              "z": 0.118
            },
            "gtin": "4046800110811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfad",
            "leftCorner": {
              "x": 11.702,
              "y": 0.879,
              "z": 0.118
            },
            "rightCorner": {
              "x": 11.6,
              "y": 0.887,
              "z": 0.118
            },
            "gtin": "4046800110811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfae",
            "leftCorner": {
              "x": 11.6,
              "y": 0.887,
              "z": 0.118
            },
            "rightCorner": {
              "x": 11.498,
              "y": 0.895,
              "z": 0.118
            },
            "gtin": "4046800110811",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468f6",
        "height": 0.39379,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2151d",
            "leftCorner": {
              "x": 12.751,
              "y": 0.83,
              "z": 0.322
            },
            "rightCorner": {
              "x": 12.598,
              "y": 0.843,
              "z": 0.322
            },
            "gtin": "4002809021206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21522",
            "leftCorner": {
              "x": 12.594,
              "y": 0.801,
              "z": 0.322
            },
            "rightCorner": {
              "x": 12.475,
              "y": 0.811,
              "z": 0.322
            },
            "gtin": "4002809021220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21523",
            "leftCorner": {
              "x": 12.475,
              "y": 0.811,
              "z": 0.322
            },
            "rightCorner": {
              "x": 12.326,
              "y": 0.823,
              "z": 0.322
            },
            "gtin": "4002809018053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21524",
            "leftCorner": {
              "x": 12.326,
              "y": 0.823,
              "z": 0.322
            },
            "rightCorner": {
              "x": 12.179,
              "y": 0.835,
              "z": 0.322
            },
            "gtin": "4002809018053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21525",
            "leftCorner": {
              "x": 12.179,
              "y": 0.84,
              "z": 0.322
            },
            "rightCorner": {
              "x": 12.098,
              "y": 0.847,
              "z": 0.322
            },
            "gtin": "4000521013769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21526",
            "leftCorner": {
              "x": 12.098,
              "y": 0.847,
              "z": 0.322
            },
            "rightCorner": {
              "x": 12.019,
              "y": 0.853,
              "z": 0.322
            },
            "gtin": "4000521013769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2151e",
            "leftCorner": {
              "x": 12.018,
              "y": 0.849,
              "z": 0.322
            },
            "rightCorner": {
              "x": 11.902,
              "y": 0.859,
              "z": 0.322
            },
            "gtin": "4337185513763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2151f",
            "leftCorner": {
              "x": 11.902,
              "y": 0.859,
              "z": 0.322
            },
            "rightCorner": {
              "x": 11.785,
              "y": 0.868,
              "z": 0.322
            },
            "gtin": "4337185513763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21520",
            "leftCorner": {
              "x": 11.785,
              "y": 0.868,
              "z": 0.322
            },
            "rightCorner": {
              "x": 11.668,
              "y": 0.877,
              "z": 0.322
            },
            "gtin": "4337185513763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21521",
            "leftCorner": {
              "x": 11.668,
              "y": 0.877,
              "z": 0.322
            },
            "rightCorner": {
              "x": 11.552,
              "y": 0.887,
              "z": 0.322
            },
            "gtin": "4337185513763",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468f7",
        "height": 0.69297,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21531",
            "leftCorner": {
              "x": 11.987,
              "y": 0.857,
              "z": 0.567
            },
            "rightCorner": {
              "x": 11.921,
              "y": 0.862,
              "z": 0.567
            },
            "gtin": "4000521770006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21527",
            "leftCorner": {
              "x": 12.751,
              "y": 0.835,
              "z": 0.567
            },
            "rightCorner": {
              "x": 12.648,
              "y": 0.843,
              "z": 0.567
            },
            "gtin": "4002809018046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21528",
            "leftCorner": {
              "x": 12.648,
              "y": 0.843,
              "z": 0.567
            },
            "rightCorner": {
              "x": 12.544,
              "y": 0.852,
              "z": 0.567
            },
            "gtin": "4002809018046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21529",
            "leftCorner": {
              "x": 12.544,
              "y": 0.852,
              "z": 0.567
            },
            "rightCorner": {
              "x": 12.439,
              "y": 0.86,
              "z": 0.567
            },
            "gtin": "4002809018046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2152d",
            "leftCorner": {
              "x": 12.437,
              "y": 0.826,
              "z": 0.567
            },
            "rightCorner": {
              "x": 12.315,
              "y": 0.835,
              "z": 0.567
            },
            "gtin": "4000521770808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2152e",
            "leftCorner": {
              "x": 12.315,
              "y": 0.835,
              "z": 0.567
            },
            "rightCorner": {
              "x": 12.195,
              "y": 0.845,
              "z": 0.567
            },
            "gtin": "4000521770808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2152f",
            "leftCorner": {
              "x": 12.194,
              "y": 0.842,
              "z": 0.567
            },
            "rightCorner": {
              "x": 12.091,
              "y": 0.851,
              "z": 0.567
            },
            "gtin": "4000521013745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21530",
            "leftCorner": {
              "x": 12.091,
              "y": 0.851,
              "z": 0.567
            },
            "rightCorner": {
              "x": 11.987,
              "y": 0.859,
              "z": 0.567
            },
            "gtin": "4000521013745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21532",
            "leftCorner": {
              "x": 11.921,
              "y": 0.862,
              "z": 0.567
            },
            "rightCorner": {
              "x": 11.856,
              "y": 0.867,
              "z": 0.567
            },
            "gtin": "4000521770006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21533",
            "leftCorner": {
              "x": 11.856,
              "y": 0.867,
              "z": 0.567
            },
            "rightCorner": {
              "x": 11.79,
              "y": 0.872,
              "z": 0.567
            },
            "gtin": "4000521770006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2152a",
            "leftCorner": {
              "x": 11.79,
              "y": 0.866,
              "z": 0.567
            },
            "rightCorner": {
              "x": 11.711,
              "y": 0.872,
              "z": 0.567
            },
            "gtin": "4000521008956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2152b",
            "leftCorner": {
              "x": 11.711,
              "y": 0.872,
              "z": 0.567
            },
            "rightCorner": {
              "x": 11.631,
              "y": 0.879,
              "z": 0.567
            },
            "gtin": "4000521008956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2152c",
            "leftCorner": {
              "x": 11.631,
              "y": 0.879,
              "z": 0.567
            },
            "rightCorner": {
              "x": 11.552,
              "y": 0.885,
              "z": 0.567
            },
            "gtin": "4000521008956",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468f8",
        "height": 0.94351,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21549",
            "leftCorner": {
              "x": 12.717,
              "y": 0.802,
              "z": 0.772
            },
            "rightCorner": {
              "x": 12.607,
              "y": 0.811,
              "z": 0.772
            },
            "gtin": "4045178008348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2154a",
            "leftCorner": {
              "x": 12.607,
              "y": 0.811,
              "z": 0.772
            },
            "rightCorner": {
              "x": 12.499,
              "y": 0.82,
              "z": 0.772
            },
            "gtin": "4045178008348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2154b",
            "leftCorner": {
              "x": 12.499,
              "y": 0.82,
              "z": 0.772
            },
            "rightCorner": {
              "x": 12.389,
              "y": 0.829,
              "z": 0.772
            },
            "gtin": "4045178008348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2154c",
            "leftCorner": {
              "x": 12.389,
              "y": 0.829,
              "z": 0.772
            },
            "rightCorner": {
              "x": 12.279,
              "y": 0.838,
              "z": 0.772
            },
            "gtin": "4045178008348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2154d",
            "leftCorner": {
              "x": 12.279,
              "y": 0.838,
              "z": 0.772
            },
            "rightCorner": {
              "x": 12.185,
              "y": 0.846,
              "z": 0.772
            },
            "gtin": "4045178008362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2154e",
            "leftCorner": {
              "x": 12.185,
              "y": 0.846,
              "z": 0.772
            },
            "rightCorner": {
              "x": 12.089,
              "y": 0.854,
              "z": 0.772
            },
            "gtin": "4045178008362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2154f",
            "leftCorner": {
              "x": 12.089,
              "y": 0.855,
              "z": 0.772
            },
            "rightCorner": {
              "x": 12.022,
              "y": 0.86,
              "z": 0.772
            },
            "gtin": "4000521771003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21550",
            "leftCorner": {
              "x": 12.022,
              "y": 0.86,
              "z": 0.772
            },
            "rightCorner": {
              "x": 11.956,
              "y": 0.866,
              "z": 0.772
            },
            "gtin": "4000521771003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21551",
            "leftCorner": {
              "x": 11.956,
              "y": 0.866,
              "z": 0.772
            },
            "rightCorner": {
              "x": 11.89,
              "y": 0.871,
              "z": 0.772
            },
            "gtin": "4000521771003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21552",
            "leftCorner": {
              "x": 11.889,
              "y": 0.868,
              "z": 0.772
            },
            "rightCorner": {
              "x": 11.768,
              "y": 0.878,
              "z": 0.772
            },
            "gtin": "4000521771102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21553",
            "leftCorner": {
              "x": 11.768,
              "y": 0.878,
              "z": 0.772
            },
            "rightCorner": {
              "x": 11.646,
              "y": 0.888,
              "z": 0.772
            },
            "gtin": "4000521771102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21554",
            "leftCorner": {
              "x": 11.646,
              "y": 0.888,
              "z": 0.772
            },
            "rightCorner": {
              "x": 11.526,
              "y": 0.898,
              "z": 0.772
            },
            "gtin": "4000521771102",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468f9",
        "height": 1.1999,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2155e",
            "leftCorner": {
              "x": 12.753,
              "y": 0.853,
              "z": 0.982
            },
            "rightCorner": {
              "x": 12.544,
              "y": 0.87,
              "z": 0.982
            },
            "gtin": "4000186036240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2155f",
            "leftCorner": {
              "x": 12.544,
              "y": 0.87,
              "z": 0.982
            },
            "rightCorner": {
              "x": 12.335,
              "y": 0.887,
              "z": 0.982
            },
            "gtin": "4000186036240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21563",
            "leftCorner": {
              "x": 12.331,
              "y": 0.848,
              "z": 0.982
            },
            "rightCorner": {
              "x": 12.109,
              "y": 0.866,
              "z": 0.982
            },
            "gtin": "4000186037544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21564",
            "leftCorner": {
              "x": 12.109,
              "y": 0.866,
              "z": 0.982
            },
            "rightCorner": {
              "x": 11.886,
              "y": 0.884,
              "z": 0.982
            },
            "gtin": "4000186037544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21565",
            "leftCorner": {
              "x": 11.885,
              "y": 0.874,
              "z": 0.982
            },
            "rightCorner": {
              "x": 11.829,
              "y": 0.879,
              "z": 0.982
            },
            "gtin": "4045178008157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21566",
            "leftCorner": {
              "x": 11.829,
              "y": 0.879,
              "z": 0.982
            },
            "rightCorner": {
              "x": 11.773,
              "y": 0.883,
              "z": 0.982
            },
            "gtin": "4045178008157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21567",
            "leftCorner": {
              "x": 11.774,
              "y": 0.896,
              "z": 0.982
            },
            "rightCorner": {
              "x": 11.661,
              "y": 0.905,
              "z": 0.982
            },
            "gtin": "4000521031787",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21568",
            "leftCorner": {
              "x": 11.661,
              "y": 0.905,
              "z": 0.982
            },
            "rightCorner": {
              "x": 11.546,
              "y": 0.915,
              "z": 0.982
            },
            "gtin": "4000521031787",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e0259",
    "rightNeighborShelfId": "e025b"
  },
  {
    "id": "e025b",
    "name": "e025b",
    "x": 11.556,
    "y": 0.938,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9992,
      "w": 0.040097
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 78
    },
    "layers": [
      {
        "id": "682ffdded15af3232a546986",
        "height": 0.14373,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dfaf",
            "leftCorner": {
              "x": 11.497,
              "y": 0.882,
              "z": 0.118
            },
            "rightCorner": {
              "x": 11.388,
              "y": 0.891,
              "z": 0.118
            },
            "gtin": "8717496861979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfb0",
            "leftCorner": {
              "x": 11.388,
              "y": 0.891,
              "z": 0.118
            },
            "rightCorner": {
              "x": 11.28,
              "y": 0.9,
              "z": 0.118
            },
            "gtin": "8717496861979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfb1",
            "leftCorner": {
              "x": 11.281,
              "y": 0.915,
              "z": 0.118
            },
            "rightCorner": {
              "x": 11.135,
              "y": 0.927,
              "z": 0.118
            },
            "gtin": "8717496861887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfb2",
            "leftCorner": {
              "x": 11.135,
              "y": 0.927,
              "z": 0.118
            },
            "rightCorner": {
              "x": 10.989,
              "y": 0.939,
              "z": 0.118
            },
            "gtin": "8717496861887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfb3",
            "leftCorner": {
              "x": 10.988,
              "y": 0.928,
              "z": 0.118
            },
            "rightCorner": {
              "x": 10.906,
              "y": 0.934,
              "z": 0.118
            },
            "gtin": "4002676650080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfb4",
            "leftCorner": {
              "x": 10.906,
              "y": 0.934,
              "z": 0.118
            },
            "rightCorner": {
              "x": 10.825,
              "y": 0.941,
              "z": 0.118
            },
            "gtin": "4002676650080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfb5",
            "leftCorner": {
              "x": 10.825,
              "y": 0.941,
              "z": 0.118
            },
            "rightCorner": {
              "x": 10.742,
              "y": 0.948,
              "z": 0.118
            },
            "gtin": "4002676650080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfb6",
            "leftCorner": {
              "x": 10.742,
              "y": 0.948,
              "z": 0.118
            },
            "rightCorner": {
              "x": 10.66,
              "y": 0.954,
              "z": 0.118
            },
            "gtin": "4002676650080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfb7",
            "leftCorner": {
              "x": 10.659,
              "y": 0.94,
              "z": 0.118
            },
            "rightCorner": {
              "x": 10.532,
              "y": 0.95,
              "z": 0.118
            },
            "gtin": "4002676650066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfb8",
            "leftCorner": {
              "x": 10.532,
              "y": 0.95,
              "z": 0.118
            },
            "rightCorner": {
              "x": 10.407,
              "y": 0.96,
              "z": 0.118
            },
            "gtin": "4002676650066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfb9",
            "leftCorner": {
              "x": 10.407,
              "y": 0.96,
              "z": 0.118
            },
            "rightCorner": {
              "x": 10.28,
              "y": 0.97,
              "z": 0.118
            },
            "gtin": "4002676650066",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546981",
        "height": 0.40427,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2172d",
            "leftCorner": {
              "x": 11.554,
              "y": 0.914,
              "z": 0.331
            },
            "rightCorner": {
              "x": 11.429,
              "y": 0.924,
              "z": 0.331
            },
            "gtin": "4000521775001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2172e",
            "leftCorner": {
              "x": 11.429,
              "y": 0.924,
              "z": 0.331
            },
            "rightCorner": {
              "x": 11.305,
              "y": 0.934,
              "z": 0.331
            },
            "gtin": "4000521775001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2172f",
            "leftCorner": {
              "x": 11.305,
              "y": 0.934,
              "z": 0.331
            },
            "rightCorner": {
              "x": 11.179,
              "y": 0.944,
              "z": 0.331
            },
            "gtin": "4000521775001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21734",
            "leftCorner": {
              "x": 11.177,
              "y": 0.904,
              "z": 0.331
            },
            "rightCorner": {
              "x": 11.016,
              "y": 0.917,
              "z": 0.331
            },
            "gtin": "4000521774400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21735",
            "leftCorner": {
              "x": 11.016,
              "y": 0.917,
              "z": 0.331
            },
            "rightCorner": {
              "x": 10.855,
              "y": 0.93,
              "z": 0.331
            },
            "gtin": "4000521774400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21730",
            "leftCorner": {
              "x": 10.855,
              "y": 0.933,
              "z": 0.331
            },
            "rightCorner": {
              "x": 10.73,
              "y": 0.943,
              "z": 0.331
            },
            "gtin": "4000521031749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21731",
            "leftCorner": {
              "x": 10.73,
              "y": 0.943,
              "z": 0.331
            },
            "rightCorner": {
              "x": 10.605,
              "y": 0.953,
              "z": 0.331
            },
            "gtin": "4000521031749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21732",
            "leftCorner": {
              "x": 10.605,
              "y": 0.953,
              "z": 0.331
            },
            "rightCorner": {
              "x": 10.48,
              "y": 0.963,
              "z": 0.331
            },
            "gtin": "4000521031749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21733",
            "leftCorner": {
              "x": 10.48,
              "y": 0.963,
              "z": 0.331
            },
            "rightCorner": {
              "x": 10.355,
              "y": 0.973,
              "z": 0.331
            },
            "gtin": "4000521031749",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546985",
        "height": 0.63961,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21736",
            "leftCorner": {
              "x": 11.554,
              "y": 0.92,
              "z": 0.523
            },
            "rightCorner": {
              "x": 11.46,
              "y": 0.928,
              "z": 0.523
            },
            "gtin": "4000521774004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21737",
            "leftCorner": {
              "x": 11.46,
              "y": 0.928,
              "z": 0.523
            },
            "rightCorner": {
              "x": 11.365,
              "y": 0.935,
              "z": 0.523
            },
            "gtin": "4000521774004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21738",
            "leftCorner": {
              "x": 11.365,
              "y": 0.935,
              "z": 0.523
            },
            "rightCorner": {
              "x": 11.271,
              "y": 0.943,
              "z": 0.523
            },
            "gtin": "4000521774004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2173c",
            "leftCorner": {
              "x": 11.268,
              "y": 0.909,
              "z": 0.523
            },
            "rightCorner": {
              "x": 11.119,
              "y": 0.921,
              "z": 0.523
            },
            "gtin": "4002676651155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2173d",
            "leftCorner": {
              "x": 11.119,
              "y": 0.922,
              "z": 0.523
            },
            "rightCorner": {
              "x": 11.05,
              "y": 0.927,
              "z": 0.523
            },
            "gtin": "4002676651254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2173e",
            "leftCorner": {
              "x": 11.05,
              "y": 0.927,
              "z": 0.523
            },
            "rightCorner": {
              "x": 10.981,
              "y": 0.933,
              "z": 0.523
            },
            "gtin": "4002676651254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2173f",
            "leftCorner": {
              "x": 10.981,
              "y": 0.927,
              "z": 0.523
            },
            "rightCorner": {
              "x": 10.917,
              "y": 0.932,
              "z": 0.523
            },
            "gtin": "4002676651179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21740",
            "leftCorner": {
              "x": 10.917,
              "y": 0.932,
              "z": 0.523
            },
            "rightCorner": {
              "x": 10.853,
              "y": 0.937,
              "z": 0.523
            },
            "gtin": "4002676651179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21741",
            "leftCorner": {
              "x": 10.853,
              "y": 0.936,
              "z": 0.523
            },
            "rightCorner": {
              "x": 10.779,
              "y": 0.942,
              "z": 0.523
            },
            "gtin": "4000521031763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21742",
            "leftCorner": {
              "x": 10.779,
              "y": 0.942,
              "z": 0.523
            },
            "rightCorner": {
              "x": 10.706,
              "y": 0.948,
              "z": 0.523
            },
            "gtin": "4000521031763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21743",
            "leftCorner": {
              "x": 10.706,
              "y": 0.948,
              "z": 0.523
            },
            "rightCorner": {
              "x": 10.632,
              "y": 0.954,
              "z": 0.523
            },
            "gtin": "4000521031763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21739",
            "leftCorner": {
              "x": 10.631,
              "y": 0.938,
              "z": 0.523
            },
            "rightCorner": {
              "x": 10.539,
              "y": 0.945,
              "z": 0.523
            },
            "gtin": "4000521775506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2173a",
            "leftCorner": {
              "x": 10.539,
              "y": 0.945,
              "z": 0.523
            },
            "rightCorner": {
              "x": 10.446,
              "y": 0.953,
              "z": 0.523
            },
            "gtin": "4000521775506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2173b",
            "leftCorner": {
              "x": 10.446,
              "y": 0.953,
              "z": 0.523
            },
            "rightCorner": {
              "x": 10.353,
              "y": 0.96,
              "z": 0.523
            },
            "gtin": "4000521775506",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546983",
        "height": 0.94052,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21555",
            "leftCorner": {
              "x": 11.525,
              "y": 0.891,
              "z": 0.77
            },
            "rightCorner": {
              "x": 11.404,
              "y": 0.901,
              "z": 0.77
            },
            "gtin": "4002809018657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21556",
            "leftCorner": {
              "x": 11.404,
              "y": 0.901,
              "z": 0.77
            },
            "rightCorner": {
              "x": 11.285,
              "y": 0.91,
              "z": 0.77
            },
            "gtin": "4002809018657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21557",
            "leftCorner": {
              "x": 11.285,
              "y": 0.91,
              "z": 0.77
            },
            "rightCorner": {
              "x": 11.164,
              "y": 0.92,
              "z": 0.77
            },
            "gtin": "4002809018657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21558",
            "leftCorner": {
              "x": 11.164,
              "y": 0.924,
              "z": 0.77
            },
            "rightCorner": {
              "x": 11.071,
              "y": 0.932,
              "z": 0.77
            },
            "gtin": "4002809018664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21559",
            "leftCorner": {
              "x": 11.071,
              "y": 0.932,
              "z": 0.77
            },
            "rightCorner": {
              "x": 10.978,
              "y": 0.939,
              "z": 0.77
            },
            "gtin": "4002809018664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2155a",
            "leftCorner": {
              "x": 10.978,
              "y": 0.939,
              "z": 0.77
            },
            "rightCorner": {
              "x": 10.884,
              "y": 0.947,
              "z": 0.77
            },
            "gtin": "4002809018664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2155b",
            "leftCorner": {
              "x": 10.883,
              "y": 0.937,
              "z": 0.77
            },
            "rightCorner": {
              "x": 10.795,
              "y": 0.944,
              "z": 0.77
            },
            "gtin": "4046800110767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2155c",
            "leftCorner": {
              "x": 10.795,
              "y": 0.944,
              "z": 0.77
            },
            "rightCorner": {
              "x": 10.705,
              "y": 0.951,
              "z": 0.77
            },
            "gtin": "4046800110767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2155d",
            "leftCorner": {
              "x": 10.705,
              "y": 0.951,
              "z": 0.77
            },
            "rightCorner": {
              "x": 10.616,
              "y": 0.958,
              "z": 0.77
            },
            "gtin": "4046800110767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21537",
            "leftCorner": {
              "x": 10.617,
              "y": 0.967,
              "z": 0.77
            },
            "rightCorner": {
              "x": 10.53,
              "y": 0.974,
              "z": 0.77
            },
            "gtin": "4015637826554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21538",
            "leftCorner": {
              "x": 10.53,
              "y": 0.974,
              "z": 0.77
            },
            "rightCorner": {
              "x": 10.443,
              "y": 0.981,
              "z": 0.77
            },
            "gtin": "4015637826554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21539",
            "leftCorner": {
              "x": 10.443,
              "y": 0.981,
              "z": 0.77
            },
            "rightCorner": {
              "x": 10.356,
              "y": 0.988,
              "z": 0.77
            },
            "gtin": "4015637826554",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546982",
        "height": 1.1943,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21569",
            "leftCorner": {
              "x": 11.544,
              "y": 0.887,
              "z": 0.977
            },
            "rightCorner": {
              "x": 11.454,
              "y": 0.894,
              "z": 0.977
            },
            "gtin": "4000521029487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2156a",
            "leftCorner": {
              "x": 11.454,
              "y": 0.894,
              "z": 0.977
            },
            "rightCorner": {
              "x": 11.364,
              "y": 0.901,
              "z": 0.977
            },
            "gtin": "4000521029487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2156b",
            "leftCorner": {
              "x": 11.364,
              "y": 0.901,
              "z": 0.977
            },
            "rightCorner": {
              "x": 11.273,
              "y": 0.909,
              "z": 0.977
            },
            "gtin": "4000521029487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2156c",
            "leftCorner": {
              "x": 11.274,
              "y": 0.913,
              "z": 0.977
            },
            "rightCorner": {
              "x": 11.218,
              "y": 0.918,
              "z": 0.977
            },
            "gtin": "4000521029500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2156d",
            "leftCorner": {
              "x": 11.218,
              "y": 0.918,
              "z": 0.977
            },
            "rightCorner": {
              "x": 11.162,
              "y": 0.922,
              "z": 0.977
            },
            "gtin": "4000521029500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2156e",
            "leftCorner": {
              "x": 11.162,
              "y": 0.922,
              "z": 0.977
            },
            "rightCorner": {
              "x": 11.037,
              "y": 0.932,
              "z": 0.977
            },
            "gtin": "4000521027421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2156f",
            "leftCorner": {
              "x": 11.037,
              "y": 0.932,
              "z": 0.977
            },
            "rightCorner": {
              "x": 10.912,
              "y": 0.942,
              "z": 0.977
            },
            "gtin": "4000521027421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21560",
            "leftCorner": {
              "x": 10.911,
              "y": 0.933,
              "z": 0.977
            },
            "rightCorner": {
              "x": 10.726,
              "y": 0.948,
              "z": 0.977
            },
            "gtin": "4002676650202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21561",
            "leftCorner": {
              "x": 10.726,
              "y": 0.948,
              "z": 0.977
            },
            "rightCorner": {
              "x": 10.54,
              "y": 0.963,
              "z": 0.977
            },
            "gtin": "4002676650202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21562",
            "leftCorner": {
              "x": 10.54,
              "y": 0.963,
              "z": 0.977
            },
            "rightCorner": {
              "x": 10.355,
              "y": 0.978,
              "z": 0.977
            },
            "gtin": "4002676650202",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546987",
        "height": 1.4445,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2157b",
            "leftCorner": {
              "x": 11.391,
              "y": 0.914,
              "z": 1.182
            },
            "rightCorner": {
              "x": 11.35,
              "y": 0.917,
              "z": 1.182
            },
            "gtin": "4005394200544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2157c",
            "leftCorner": {
              "x": 11.351,
              "y": 0.921,
              "z": 1.182
            },
            "rightCorner": {
              "x": 11.289,
              "y": 0.926,
              "z": 1.182
            },
            "gtin": "4005394200551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2157d",
            "leftCorner": {
              "x": 11.287,
              "y": 0.901,
              "z": 1.182
            },
            "rightCorner": {
              "x": 11.247,
              "y": 0.904,
              "z": 1.182
            },
            "gtin": "4000521031589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2157e",
            "leftCorner": {
              "x": 11.247,
              "y": 0.904,
              "z": 1.182
            },
            "rightCorner": {
              "x": 11.208,
              "y": 0.907,
              "z": 1.182
            },
            "gtin": "4000521031589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2157f",
            "leftCorner": {
              "x": 11.209,
              "y": 0.923,
              "z": 1.182
            },
            "rightCorner": {
              "x": 11.109,
              "y": 0.931,
              "z": 1.182
            },
            "gtin": "4000521031565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21580",
            "leftCorner": {
              "x": 11.108,
              "y": 0.921,
              "z": 1.182
            },
            "rightCorner": {
              "x": 11.018,
              "y": 0.928,
              "z": 1.182
            },
            "gtin": "4000521033750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21581",
            "leftCorner": {
              "x": 11.019,
              "y": 0.936,
              "z": 1.182
            },
            "rightCorner": {
              "x": 10.912,
              "y": 0.945,
              "z": 1.182
            },
            "gtin": "4000521033712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21582",
            "leftCorner": {
              "x": 10.911,
              "y": 0.927,
              "z": 1.182
            },
            "rightCorner": {
              "x": 10.824,
              "y": 0.934,
              "z": 1.182
            },
            "gtin": "4000521033699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21583",
            "leftCorner": {
              "x": 10.826,
              "y": 0.956,
              "z": 1.182
            },
            "rightCorner": {
              "x": 10.706,
              "y": 0.965,
              "z": 1.182
            },
            "gtin": "4000521033736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21584",
            "leftCorner": {
              "x": 10.706,
              "y": 0.965,
              "z": 1.182
            },
            "rightCorner": {
              "x": 10.588,
              "y": 0.975,
              "z": 1.182
            },
            "gtin": "4000521033736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21585",
            "leftCorner": {
              "x": 10.587,
              "y": 0.972,
              "z": 1.182
            },
            "rightCorner": {
              "x": 10.48,
              "y": 0.98,
              "z": 1.182
            },
            "gtin": "4000521033675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21573",
            "leftCorner": {
              "x": 10.479,
              "y": 0.976,
              "z": 1.182
            },
            "rightCorner": {
              "x": 10.356,
              "y": 0.985,
              "z": 1.182
            },
            "gtin": "4035731817043",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546984",
        "height": 1.6968,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1df55",
            "leftCorner": {
              "x": 11.486,
              "y": 0.894,
              "z": 1.388
            },
            "rightCorner": {
              "x": 11.339,
              "y": 0.905,
              "z": 1.388
            },
            "gtin": "4337185513787",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df56",
            "leftCorner": {
              "x": 11.339,
              "y": 0.905,
              "z": 1.388
            },
            "rightCorner": {
              "x": 11.193,
              "y": 0.917,
              "z": 1.388
            },
            "gtin": "4337185513787",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df57",
            "leftCorner": {
              "x": 11.193,
              "y": 0.917,
              "z": 1.388
            },
            "rightCorner": {
              "x": 11.046,
              "y": 0.929,
              "z": 1.388
            },
            "gtin": "4337185513787",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df58",
            "leftCorner": {
              "x": 11.046,
              "y": 0.929,
              "z": 1.388
            },
            "rightCorner": {
              "x": 10.9,
              "y": 0.941,
              "z": 1.388
            },
            "gtin": "4337185513787",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df59",
            "leftCorner": {
              "x": 10.9,
              "y": 0.941,
              "z": 1.388
            },
            "rightCorner": {
              "x": 10.753,
              "y": 0.952,
              "z": 1.388
            },
            "gtin": "4337185513787",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df05",
            "leftCorner": {
              "x": 10.752,
              "y": 0.943,
              "z": 1.388
            },
            "rightCorner": {
              "x": 10.674,
              "y": 0.949,
              "z": 1.388
            },
            "gtin": "4337185513749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df06",
            "leftCorner": {
              "x": 10.674,
              "y": 0.949,
              "z": 1.388
            },
            "rightCorner": {
              "x": 10.594,
              "y": 0.956,
              "z": 1.388
            },
            "gtin": "4337185513749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df07",
            "leftCorner": {
              "x": 10.594,
              "y": 0.956,
              "z": 1.388
            },
            "rightCorner": {
              "x": 10.514,
              "y": 0.962,
              "z": 1.388
            },
            "gtin": "4337185513749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df08",
            "leftCorner": {
              "x": 10.514,
              "y": 0.962,
              "z": 1.388
            },
            "rightCorner": {
              "x": 10.434,
              "y": 0.968,
              "z": 1.388
            },
            "gtin": "4337185513749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df09",
            "leftCorner": {
              "x": 10.434,
              "y": 0.968,
              "z": 1.388
            },
            "rightCorner": {
              "x": 10.355,
              "y": 0.975,
              "z": 1.388
            },
            "gtin": "4337185513749",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e025a",
    "rightNeighborShelfId": "e025c"
  },
  {
    "id": "e025c",
    "name": "e025c",
    "x": 10.36,
    "y": 1.034,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9992,
      "w": 0.040097
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 77
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54698d",
        "height": 0.14848,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dfba",
            "leftCorner": {
              "x": 10.282,
              "y": 0.997,
              "z": 0.121
            },
            "rightCorner": {
              "x": 10.062,
              "y": 1.014,
              "z": 0.121
            },
            "gtin": "4000521040116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfbb",
            "leftCorner": {
              "x": 10.061,
              "y": 1.006,
              "z": 0.121
            },
            "rightCorner": {
              "x": 9.793,
              "y": 1.027,
              "z": 0.121
            },
            "gtin": "4000521040130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfbc",
            "leftCorner": {
              "x": 9.794,
              "y": 1.038,
              "z": 0.121
            },
            "rightCorner": {
              "x": 9.561,
              "y": 1.057,
              "z": 0.121
            },
            "gtin": "4000521040154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfbd",
            "leftCorner": {
              "x": 9.561,
              "y": 1.057,
              "z": 0.121
            },
            "rightCorner": {
              "x": 9.327,
              "y": 1.076,
              "z": 0.121
            },
            "gtin": "4000521040154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfbe",
            "leftCorner": {
              "x": 9.326,
              "y": 1.061,
              "z": 0.121
            },
            "rightCorner": {
              "x": 9.247,
              "y": 1.067,
              "z": 0.121
            },
            "gtin": "4260583930224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfbf",
            "leftCorner": {
              "x": 9.247,
              "y": 1.067,
              "z": 0.121
            },
            "rightCorner": {
              "x": 9.169,
              "y": 1.073,
              "z": 0.121
            },
            "gtin": "4260583930224",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54698c",
        "height": 0.49284,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2177d",
            "leftCorner": {
              "x": 10.359,
              "y": 1.016,
              "z": 0.403
            },
            "rightCorner": {
              "x": 10.227,
              "y": 1.026,
              "z": 0.403
            },
            "gtin": "4337185877810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2177e",
            "leftCorner": {
              "x": 10.227,
              "y": 1.026,
              "z": 0.403
            },
            "rightCorner": {
              "x": 10.095,
              "y": 1.037,
              "z": 0.403
            },
            "gtin": "4337185877810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2177f",
            "leftCorner": {
              "x": 10.095,
              "y": 1.037,
              "z": 0.403
            },
            "rightCorner": {
              "x": 9.963,
              "y": 1.048,
              "z": 0.403
            },
            "gtin": "4337185877810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21780",
            "leftCorner": {
              "x": 9.963,
              "y": 1.048,
              "z": 0.403
            },
            "rightCorner": {
              "x": 9.831,
              "y": 1.058,
              "z": 0.403
            },
            "gtin": "4337185877810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21782",
            "leftCorner": {
              "x": 9.827,
              "y": 1.004,
              "z": 0.403
            },
            "rightCorner": {
              "x": 9.632,
              "y": 1.02,
              "z": 0.403
            },
            "gtin": "4000521009441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21783",
            "leftCorner": {
              "x": 9.632,
              "y": 1.02,
              "z": 0.403
            },
            "rightCorner": {
              "x": 9.437,
              "y": 1.035,
              "z": 0.403
            },
            "gtin": "4000521009441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21781",
            "leftCorner": {
              "x": 9.439,
              "y": 1.068,
              "z": 0.403
            },
            "rightCorner": {
              "x": 9.161,
              "y": 1.09,
              "z": 0.403
            },
            "gtin": "4000521607500",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546988",
        "height": 0.74516,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21744",
            "leftCorner": {
              "x": 10.359,
              "y": 1.017,
              "z": 0.61
            },
            "rightCorner": {
              "x": 10.28,
              "y": 1.024,
              "z": 0.61
            },
            "gtin": "4000521364205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21745",
            "leftCorner": {
              "x": 10.28,
              "y": 1.024,
              "z": 0.61
            },
            "rightCorner": {
              "x": 10.2,
              "y": 1.03,
              "z": 0.61
            },
            "gtin": "4000521364205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21746",
            "leftCorner": {
              "x": 10.2,
              "y": 1.03,
              "z": 0.61
            },
            "rightCorner": {
              "x": 10.122,
              "y": 1.036,
              "z": 0.61
            },
            "gtin": "4000521364205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21748",
            "leftCorner": {
              "x": 10.118,
              "y": 0.999,
              "z": 0.61
            },
            "rightCorner": {
              "x": 10.044,
              "y": 1.005,
              "z": 0.61
            },
            "gtin": "40352473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21749",
            "leftCorner": {
              "x": 10.044,
              "y": 1.005,
              "z": 0.61
            },
            "rightCorner": {
              "x": 9.97,
              "y": 1.011,
              "z": 0.61
            },
            "gtin": "40352473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2174a",
            "leftCorner": {
              "x": 9.97,
              "y": 1.011,
              "z": 0.61
            },
            "rightCorner": {
              "x": 9.895,
              "y": 1.017,
              "z": 0.61
            },
            "gtin": "40352473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2174b",
            "leftCorner": {
              "x": 9.895,
              "y": 1.017,
              "z": 0.61
            },
            "rightCorner": {
              "x": 9.82,
              "y": 1.023,
              "z": 0.61
            },
            "gtin": "40352473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2174c",
            "leftCorner": {
              "x": 9.82,
              "y": 1.017,
              "z": 0.61
            },
            "rightCorner": {
              "x": 9.701,
              "y": 1.027,
              "z": 0.61
            },
            "gtin": "4002809010088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2174d",
            "leftCorner": {
              "x": 9.702,
              "y": 1.03,
              "z": 0.61
            },
            "rightCorner": {
              "x": 9.633,
              "y": 1.035,
              "z": 0.61
            },
            "gtin": "4000521364700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2174e",
            "leftCorner": {
              "x": 9.633,
              "y": 1.035,
              "z": 0.61
            },
            "rightCorner": {
              "x": 9.565,
              "y": 1.041,
              "z": 0.61
            },
            "gtin": "4000521364700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2174f",
            "leftCorner": {
              "x": 9.565,
              "y": 1.041,
              "z": 0.61
            },
            "rightCorner": {
              "x": 9.497,
              "y": 1.046,
              "z": 0.61
            },
            "gtin": "4000521364700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21750",
            "leftCorner": {
              "x": 9.498,
              "y": 1.059,
              "z": 0.61
            },
            "rightCorner": {
              "x": 9.383,
              "y": 1.068,
              "z": 0.61
            },
            "gtin": "4000521034436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21751",
            "leftCorner": {
              "x": 9.383,
              "y": 1.068,
              "z": 0.61
            },
            "rightCorner": {
              "x": 9.269,
              "y": 1.077,
              "z": 0.61
            },
            "gtin": "4000521034436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21747",
            "leftCorner": {
              "x": 9.268,
              "y": 1.071,
              "z": 0.61
            },
            "rightCorner": {
              "x": 9.16,
              "y": 1.08,
              "z": 0.61
            },
            "gtin": "4000521005177",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546989",
        "height": 0.99673,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21752",
            "leftCorner": {
              "x": 10.359,
              "y": 1.02,
              "z": 0.816
            },
            "rightCorner": {
              "x": 10.266,
              "y": 1.028,
              "z": 0.816
            },
            "gtin": "40352282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21755",
            "leftCorner": {
              "x": 10.263,
              "y": 0.987,
              "z": 0.816
            },
            "rightCorner": {
              "x": 10.166,
              "y": 0.995,
              "z": 0.816
            },
            "gtin": "40352275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21756",
            "leftCorner": {
              "x": 10.166,
              "y": 0.995,
              "z": 0.816
            },
            "rightCorner": {
              "x": 10.068,
              "y": 1.003,
              "z": 0.816
            },
            "gtin": "40352275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21757",
            "leftCorner": {
              "x": 10.068,
              "y": 1.001,
              "z": 0.816
            },
            "rightCorner": {
              "x": 9.996,
              "y": 1.007,
              "z": 0.816
            },
            "gtin": "4000521301712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21758",
            "leftCorner": {
              "x": 9.996,
              "y": 1.007,
              "z": 0.816
            },
            "rightCorner": {
              "x": 9.925,
              "y": 1.013,
              "z": 0.816
            },
            "gtin": "4000521301712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21759",
            "leftCorner": {
              "x": 9.925,
              "y": 1.013,
              "z": 0.816
            },
            "rightCorner": {
              "x": 9.852,
              "y": 1.019,
              "z": 0.816
            },
            "gtin": "4000521301712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2175a",
            "leftCorner": {
              "x": 9.853,
              "y": 1.024,
              "z": 0.816
            },
            "rightCorner": {
              "x": 9.721,
              "y": 1.034,
              "z": 0.816
            },
            "gtin": "40352336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2175b",
            "leftCorner": {
              "x": 9.721,
              "y": 1.034,
              "z": 0.816
            },
            "rightCorner": {
              "x": 9.59,
              "y": 1.045,
              "z": 0.816
            },
            "gtin": "40352336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2175c",
            "leftCorner": {
              "x": 9.591,
              "y": 1.056,
              "z": 0.816
            },
            "rightCorner": {
              "x": 9.523,
              "y": 1.062,
              "z": 0.816
            },
            "gtin": "40352329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2175d",
            "leftCorner": {
              "x": 9.523,
              "y": 1.062,
              "z": 0.816
            },
            "rightCorner": {
              "x": 9.455,
              "y": 1.067,
              "z": 0.816
            },
            "gtin": "40352329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2175e",
            "leftCorner": {
              "x": 9.455,
              "y": 1.067,
              "z": 0.816
            },
            "rightCorner": {
              "x": 9.388,
              "y": 1.073,
              "z": 0.816
            },
            "gtin": "40352329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2175f",
            "leftCorner": {
              "x": 9.388,
              "y": 1.073,
              "z": 0.816
            },
            "rightCorner": {
              "x": 9.32,
              "y": 1.078,
              "z": 0.816
            },
            "gtin": "40352329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21753",
            "leftCorner": {
              "x": 9.32,
              "y": 1.069,
              "z": 0.816
            },
            "rightCorner": {
              "x": 9.24,
              "y": 1.075,
              "z": 0.816
            },
            "gtin": "40352312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21754",
            "leftCorner": {
              "x": 9.24,
              "y": 1.075,
              "z": 0.816
            },
            "rightCorner": {
              "x": 9.16,
              "y": 1.082,
              "z": 0.816
            },
            "gtin": "40352312",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54698a",
        "height": 1.2497,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21760",
            "leftCorner": {
              "x": 10.359,
              "y": 1.023,
              "z": 1.022
            },
            "rightCorner": {
              "x": 10.273,
              "y": 1.03,
              "z": 1.022
            },
            "gtin": "4000521026769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21761",
            "leftCorner": {
              "x": 10.273,
              "y": 1.03,
              "z": 1.022
            },
            "rightCorner": {
              "x": 10.187,
              "y": 1.037,
              "z": 1.022
            },
            "gtin": "4000521026769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21764",
            "leftCorner": {
              "x": 10.184,
              "y": 0.997,
              "z": 1.022
            },
            "rightCorner": {
              "x": 10.015,
              "y": 1.011,
              "z": 1.022
            },
            "gtin": "4000521026745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21765",
            "leftCorner": {
              "x": 10.016,
              "y": 1.026,
              "z": 1.022
            },
            "rightCorner": {
              "x": 9.948,
              "y": 1.032,
              "z": 1.022
            },
            "gtin": "4000521026721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21766",
            "leftCorner": {
              "x": 9.948,
              "y": 1.032,
              "z": 1.022
            },
            "rightCorner": {
              "x": 9.881,
              "y": 1.037,
              "z": 1.022
            },
            "gtin": "4000521026721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21767",
            "leftCorner": {
              "x": 9.881,
              "y": 1.037,
              "z": 1.022
            },
            "rightCorner": {
              "x": 9.813,
              "y": 1.043,
              "z": 1.022
            },
            "gtin": "4000521026721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21768",
            "leftCorner": {
              "x": 9.812,
              "y": 1.026,
              "z": 1.022
            },
            "rightCorner": {
              "x": 9.704,
              "y": 1.035,
              "z": 1.022
            },
            "gtin": "4000521003159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21769",
            "leftCorner": {
              "x": 9.704,
              "y": 1.038,
              "z": 1.022
            },
            "rightCorner": {
              "x": 9.594,
              "y": 1.047,
              "z": 1.022
            },
            "gtin": "4000521003173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2176a",
            "leftCorner": {
              "x": 9.594,
              "y": 1.044,
              "z": 1.022
            },
            "rightCorner": {
              "x": 9.492,
              "y": 1.052,
              "z": 1.022
            },
            "gtin": "40352404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2176b",
            "leftCorner": {
              "x": 9.492,
              "y": 1.052,
              "z": 1.022
            },
            "rightCorner": {
              "x": 9.389,
              "y": 1.06,
              "z": 1.022
            },
            "gtin": "40352404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2176c",
            "leftCorner": {
              "x": 9.389,
              "y": 1.06,
              "z": 1.022
            },
            "rightCorner": {
              "x": 9.287,
              "y": 1.069,
              "z": 1.022
            },
            "gtin": "40352404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21762",
            "leftCorner": {
              "x": 9.287,
              "y": 1.068,
              "z": 1.022
            },
            "rightCorner": {
              "x": 9.223,
              "y": 1.073,
              "z": 1.022
            },
            "gtin": "40352398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21763",
            "leftCorner": {
              "x": 9.223,
              "y": 1.073,
              "z": 1.022
            },
            "rightCorner": {
              "x": 9.16,
              "y": 1.078,
              "z": 1.022
            },
            "gtin": "40352398",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54698b",
        "height": 1.499,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2176d",
            "leftCorner": {
              "x": 10.359,
              "y": 1.023,
              "z": 1.226
            },
            "rightCorner": {
              "x": 10.297,
              "y": 1.028,
              "z": 1.226
            },
            "gtin": "4002809018985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2176e",
            "leftCorner": {
              "x": 10.297,
              "y": 1.028,
              "z": 1.226
            },
            "rightCorner": {
              "x": 10.236,
              "y": 1.033,
              "z": 1.226
            },
            "gtin": "4002809018985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21771",
            "leftCorner": {
              "x": 10.233,
              "y": 1.0,
              "z": 1.226
            },
            "rightCorner": {
              "x": 10.157,
              "y": 1.006,
              "z": 1.226
            },
            "gtin": "4002809018879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21772",
            "leftCorner": {
              "x": 10.157,
              "y": 1.006,
              "z": 1.226
            },
            "rightCorner": {
              "x": 10.079,
              "y": 1.012,
              "z": 1.226
            },
            "gtin": "4002809018879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21773",
            "leftCorner": {
              "x": 10.078,
              "y": 1.003,
              "z": 1.226
            },
            "rightCorner": {
              "x": 10.021,
              "y": 1.008,
              "z": 1.226
            },
            "gtin": "4002809018909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21774",
            "leftCorner": {
              "x": 10.021,
              "y": 1.008,
              "z": 1.226
            },
            "rightCorner": {
              "x": 9.964,
              "y": 1.012,
              "z": 1.226
            },
            "gtin": "4002809018909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21775",
            "leftCorner": {
              "x": 9.964,
              "y": 1.012,
              "z": 1.226
            },
            "rightCorner": {
              "x": 9.907,
              "y": 1.017,
              "z": 1.226
            },
            "gtin": "4002809018909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21776",
            "leftCorner": {
              "x": 9.907,
              "y": 1.017,
              "z": 1.226
            },
            "rightCorner": {
              "x": 9.825,
              "y": 1.024,
              "z": 1.226
            },
            "gtin": "4002809018862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21777",
            "leftCorner": {
              "x": 9.825,
              "y": 1.024,
              "z": 1.226
            },
            "rightCorner": {
              "x": 9.743,
              "y": 1.031,
              "z": 1.226
            },
            "gtin": "4002809018862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21778",
            "leftCorner": {
              "x": 9.743,
              "y": 1.031,
              "z": 1.226
            },
            "rightCorner": {
              "x": 9.662,
              "y": 1.037,
              "z": 1.226
            },
            "gtin": "4002809018862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21779",
            "leftCorner": {
              "x": 9.662,
              "y": 1.036,
              "z": 1.226
            },
            "rightCorner": {
              "x": 9.576,
              "y": 1.043,
              "z": 1.226
            },
            "gtin": "4002809018893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2177a",
            "leftCorner": {
              "x": 9.576,
              "y": 1.043,
              "z": 1.226
            },
            "rightCorner": {
              "x": 9.491,
              "y": 1.05,
              "z": 1.226
            },
            "gtin": "4002809018893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2177b",
            "leftCorner": {
              "x": 9.491,
              "y": 1.056,
              "z": 1.226
            },
            "rightCorner": {
              "x": 9.421,
              "y": 1.062,
              "z": 1.226
            },
            "gtin": "4002809021503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2177c",
            "leftCorner": {
              "x": 9.421,
              "y": 1.062,
              "z": 1.226
            },
            "rightCorner": {
              "x": 9.351,
              "y": 1.067,
              "z": 1.226
            },
            "gtin": "4002809021503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2176f",
            "leftCorner": {
              "x": 9.351,
              "y": 1.064,
              "z": 1.226
            },
            "rightCorner": {
              "x": 9.256,
              "y": 1.072,
              "z": 1.226
            },
            "gtin": "4002809021510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21770",
            "leftCorner": {
              "x": 9.256,
              "y": 1.072,
              "z": 1.226
            },
            "rightCorner": {
              "x": 9.16,
              "y": 1.08,
              "z": 1.226
            },
            "gtin": "4002809021510",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a54698e",
        "height": 1.7171,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21784",
            "leftCorner": {
              "x": 10.359,
              "y": 1.024,
              "z": 1.405
            },
            "rightCorner": {
              "x": 10.202,
              "y": 1.037,
              "z": 1.405
            },
            "gtin": "4000521820206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21785",
            "leftCorner": {
              "x": 10.202,
              "y": 1.037,
              "z": 1.405
            },
            "rightCorner": {
              "x": 10.044,
              "y": 1.05,
              "z": 1.405
            },
            "gtin": "4000521820206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21786",
            "leftCorner": {
              "x": 10.044,
              "y": 1.05,
              "z": 1.405
            },
            "rightCorner": {
              "x": 9.887,
              "y": 1.062,
              "z": 1.405
            },
            "gtin": "4000521820206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21788",
            "leftCorner": {
              "x": 9.883,
              "y": 1.019,
              "z": 1.405
            },
            "rightCorner": {
              "x": 9.618,
              "y": 1.041,
              "z": 1.405
            },
            "gtin": "4000521823207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21789",
            "leftCorner": {
              "x": 9.619,
              "y": 1.047,
              "z": 1.405
            },
            "rightCorner": {
              "x": 9.503,
              "y": 1.056,
              "z": 1.405
            },
            "gtin": "4000521007997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2178a",
            "leftCorner": {
              "x": 9.503,
              "y": 1.056,
              "z": 1.405
            },
            "rightCorner": {
              "x": 9.388,
              "y": 1.065,
              "z": 1.405
            },
            "gtin": "4000521007997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2178b",
            "leftCorner": {
              "x": 9.388,
              "y": 1.067,
              "z": 1.405
            },
            "rightCorner": {
              "x": 9.249,
              "y": 1.078,
              "z": 1.405
            },
            "gtin": "4000521012670",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21787",
            "leftCorner": {
              "x": 9.248,
              "y": 1.074,
              "z": 1.405
            },
            "rightCorner": {
              "x": 9.16,
              "y": 1.081,
              "z": 1.405
            },
            "gtin": "4000521008031",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e025b",
    "rightNeighborShelfId": "e025d"
  },
  {
    "id": "e025d",
    "name": "e025d",
    "x": 9.164,
    "y": 1.13,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9992,
      "w": 0.040097
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 78
    },
    "layers": [
      {
        "id": "682ffdded15af3232a54698f",
        "height": 0.1447,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dfc0",
            "leftCorner": {
              "x": 9.169,
              "y": 1.073,
              "z": 0.118
            },
            "rightCorner": {
              "x": 9.105,
              "y": 1.078,
              "z": 0.118
            },
            "gtin": "4260583930156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfc1",
            "leftCorner": {
              "x": 9.105,
              "y": 1.078,
              "z": 0.118
            },
            "rightCorner": {
              "x": 9.041,
              "y": 1.083,
              "z": 0.118
            },
            "gtin": "4260583930156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfc2",
            "leftCorner": {
              "x": 9.041,
              "y": 1.083,
              "z": 0.118
            },
            "rightCorner": {
              "x": 8.977,
              "y": 1.089,
              "z": 0.118
            },
            "gtin": "4260583930156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfc3",
            "leftCorner": {
              "x": 8.977,
              "y": 1.089,
              "z": 0.118
            },
            "rightCorner": {
              "x": 8.912,
              "y": 1.094,
              "z": 0.118
            },
            "gtin": "4260583930156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfc4",
            "leftCorner": {
              "x": 8.912,
              "y": 1.094,
              "z": 0.118
            },
            "rightCorner": {
              "x": 8.848,
              "y": 1.099,
              "z": 0.118
            },
            "gtin": "4260583930156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfc5",
            "leftCorner": {
              "x": 8.849,
              "y": 1.107,
              "z": 0.118
            },
            "rightCorner": {
              "x": 8.724,
              "y": 1.117,
              "z": 0.118
            },
            "gtin": "4002809001062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfc6",
            "leftCorner": {
              "x": 8.724,
              "y": 1.117,
              "z": 0.118
            },
            "rightCorner": {
              "x": 8.6,
              "y": 1.127,
              "z": 0.118
            },
            "gtin": "4002809001062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfc7",
            "leftCorner": {
              "x": 8.6,
              "y": 1.125,
              "z": 0.118
            },
            "rightCorner": {
              "x": 8.417,
              "y": 1.14,
              "z": 0.118
            },
            "gtin": "4002809001093",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfc8",
            "leftCorner": {
              "x": 8.417,
              "y": 1.14,
              "z": 0.118
            },
            "rightCorner": {
              "x": 8.234,
              "y": 1.154,
              "z": 0.118
            },
            "gtin": "4002809001093",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfc9",
            "leftCorner": {
              "x": 8.232,
              "y": 1.131,
              "z": 0.118
            },
            "rightCorner": {
              "x": 7.988,
              "y": 1.151,
              "z": 0.118
            },
            "gtin": "4337185531996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dfca",
            "leftCorner": {
              "x": 7.988,
              "y": 1.151,
              "z": 0.118
            },
            "rightCorner": {
              "x": 7.744,
              "y": 1.171,
              "z": 0.118
            },
            "gtin": "4337185531996",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a546994",
        "height": 0.44557,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a217e3",
            "leftCorner": {
              "x": 9.162,
              "y": 1.11,
              "z": 0.365
            },
            "rightCorner": {
              "x": 8.92,
              "y": 1.13,
              "z": 0.365
            },
            "gtin": "4000521005009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217e4",
            "leftCorner": {
              "x": 8.92,
              "y": 1.13,
              "z": 0.365
            },
            "rightCorner": {
              "x": 8.677,
              "y": 1.149,
              "z": 0.365
            },
            "gtin": "4000521005009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217e6",
            "leftCorner": {
              "x": 8.674,
              "y": 1.111,
              "z": 0.365
            },
            "rightCorner": {
              "x": 8.606,
              "y": 1.116,
              "z": 0.365
            },
            "gtin": "4000521025052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217e7",
            "leftCorner": {
              "x": 8.606,
              "y": 1.116,
              "z": 0.365
            },
            "rightCorner": {
              "x": 8.537,
              "y": 1.122,
              "z": 0.365
            },
            "gtin": "4000521025052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217e8",
            "leftCorner": {
              "x": 8.537,
              "y": 1.121,
              "z": 0.365
            },
            "rightCorner": {
              "x": 8.436,
              "y": 1.129,
              "z": 0.365
            },
            "gtin": "4000521025014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217e9",
            "leftCorner": {
              "x": 8.436,
              "y": 1.129,
              "z": 0.365
            },
            "rightCorner": {
              "x": 8.334,
              "y": 1.137,
              "z": 0.365
            },
            "gtin": "4000521025014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217ea",
            "leftCorner": {
              "x": 8.334,
              "y": 1.137,
              "z": 0.365
            },
            "rightCorner": {
              "x": 8.217,
              "y": 1.147,
              "z": 0.365
            },
            "gtin": "4337185531989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217eb",
            "leftCorner": {
              "x": 8.217,
              "y": 1.147,
              "z": 0.365
            },
            "rightCorner": {
              "x": 8.1,
              "y": 1.156,
              "z": 0.365
            },
            "gtin": "4337185531989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217ec",
            "leftCorner": {
              "x": 8.1,
              "y": 1.157,
              "z": 0.365
            },
            "rightCorner": {
              "x": 7.988,
              "y": 1.166,
              "z": 0.365
            },
            "gtin": "4002809042362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217ed",
            "leftCorner": {
              "x": 7.988,
              "y": 1.166,
              "z": 0.365
            },
            "rightCorner": {
              "x": 7.877,
              "y": 1.175,
              "z": 0.365
            },
            "gtin": "4002809042362",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546990",
        "height": 0.69235,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2178c",
            "leftCorner": {
              "x": 9.163,
              "y": 1.119,
              "z": 0.566
            },
            "rightCorner": {
              "x": 9.045,
              "y": 1.128,
              "z": 0.566
            },
            "gtin": "40352145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2178d",
            "leftCorner": {
              "x": 9.045,
              "y": 1.128,
              "z": 0.566
            },
            "rightCorner": {
              "x": 8.927,
              "y": 1.138,
              "z": 0.566
            },
            "gtin": "40352145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2178e",
            "leftCorner": {
              "x": 8.927,
              "y": 1.138,
              "z": 0.566
            },
            "rightCorner": {
              "x": 8.809,
              "y": 1.147,
              "z": 0.566
            },
            "gtin": "40352145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21790",
            "leftCorner": {
              "x": 8.806,
              "y": 1.106,
              "z": 0.566
            },
            "rightCorner": {
              "x": 8.689,
              "y": 1.115,
              "z": 0.566
            },
            "gtin": "40352169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21791",
            "leftCorner": {
              "x": 8.689,
              "y": 1.115,
              "z": 0.566
            },
            "rightCorner": {
              "x": 8.572,
              "y": 1.125,
              "z": 0.566
            },
            "gtin": "40352169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21792",
            "leftCorner": {
              "x": 8.571,
              "y": 1.122,
              "z": 0.566
            },
            "rightCorner": {
              "x": 8.454,
              "y": 1.132,
              "z": 0.566
            },
            "gtin": "40352114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21793",
            "leftCorner": {
              "x": 8.454,
              "y": 1.132,
              "z": 0.566
            },
            "rightCorner": {
              "x": 8.336,
              "y": 1.141,
              "z": 0.566
            },
            "gtin": "40352114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21794",
            "leftCorner": {
              "x": 8.336,
              "y": 1.141,
              "z": 0.566
            },
            "rightCorner": {
              "x": 8.219,
              "y": 1.151,
              "z": 0.566
            },
            "gtin": "40352114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21795",
            "leftCorner": {
              "x": 8.219,
              "y": 1.155,
              "z": 0.566
            },
            "rightCorner": {
              "x": 8.147,
              "y": 1.161,
              "z": 0.566
            },
            "gtin": "4035731817340",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21796",
            "leftCorner": {
              "x": 8.147,
              "y": 1.161,
              "z": 0.566
            },
            "rightCorner": {
              "x": 8.075,
              "y": 1.167,
              "z": 0.566
            },
            "gtin": "4035731817340",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21797",
            "leftCorner": {
              "x": 8.075,
              "y": 1.163,
              "z": 0.566
            },
            "rightCorner": {
              "x": 8.01,
              "y": 1.168,
              "z": 0.566
            },
            "gtin": "4035731817326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21798",
            "leftCorner": {
              "x": 8.01,
              "y": 1.168,
              "z": 0.566
            },
            "rightCorner": {
              "x": 7.945,
              "y": 1.173,
              "z": 0.566
            },
            "gtin": "4035731817326",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a546992",
        "height": 0.94333,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a217b6",
            "leftCorner": {
              "x": 9.163,
              "y": 1.122,
              "z": 0.772
            },
            "rightCorner": {
              "x": 9.063,
              "y": 1.13,
              "z": 0.772
            },
            "gtin": "4000521005412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217b7",
            "leftCorner": {
              "x": 9.063,
              "y": 1.13,
              "z": 0.772
            },
            "rightCorner": {
              "x": 8.963,
              "y": 1.138,
              "z": 0.772
            },
            "gtin": "4000521005412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217b8",
            "leftCorner": {
              "x": 8.963,
              "y": 1.138,
              "z": 0.772
            },
            "rightCorner": {
              "x": 8.863,
              "y": 1.146,
              "z": 0.772
            },
            "gtin": "4000521005412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217ba",
            "leftCorner": {
              "x": 8.86,
              "y": 1.11,
              "z": 0.772
            },
            "rightCorner": {
              "x": 8.778,
              "y": 1.116,
              "z": 0.772
            },
            "gtin": "4002809021008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217bb",
            "leftCorner": {
              "x": 8.778,
              "y": 1.116,
              "z": 0.772
            },
            "rightCorner": {
              "x": 8.697,
              "y": 1.123,
              "z": 0.772
            },
            "gtin": "4002809021008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217bc",
            "leftCorner": {
              "x": 8.697,
              "y": 1.123,
              "z": 0.772
            },
            "rightCorner": {
              "x": 8.615,
              "y": 1.13,
              "z": 0.772
            },
            "gtin": "4002809021008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217bd",
            "leftCorner": {
              "x": 8.615,
              "y": 1.125,
              "z": 0.772
            },
            "rightCorner": {
              "x": 8.539,
              "y": 1.132,
              "z": 0.772
            },
            "gtin": "4002809001109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217be",
            "leftCorner": {
              "x": 8.539,
              "y": 1.132,
              "z": 0.772
            },
            "rightCorner": {
              "x": 8.463,
              "y": 1.138,
              "z": 0.772
            },
            "gtin": "4002809001109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217bf",
            "leftCorner": {
              "x": 8.463,
              "y": 1.138,
              "z": 0.772
            },
            "rightCorner": {
              "x": 8.387,
              "y": 1.144,
              "z": 0.772
            },
            "gtin": "4002809001109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217c0",
            "leftCorner": {
              "x": 8.387,
              "y": 1.141,
              "z": 0.772
            },
            "rightCorner": {
              "x": 8.276,
              "y": 1.15,
              "z": 0.772
            },
            "gtin": "4002809021183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217c1",
            "leftCorner": {
              "x": 8.276,
              "y": 1.15,
              "z": 0.772
            },
            "rightCorner": {
              "x": 8.165,
              "y": 1.159,
              "z": 0.772
            },
            "gtin": "4002809021183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217c2",
            "leftCorner": {
              "x": 8.165,
              "y": 1.165,
              "z": 0.772
            },
            "rightCorner": {
              "x": 8.063,
              "y": 1.173,
              "z": 0.772
            },
            "gtin": "4000521221010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217c3",
            "leftCorner": {
              "x": 8.063,
              "y": 1.173,
              "z": 0.772
            },
            "rightCorner": {
              "x": 7.96,
              "y": 1.181,
              "z": 0.772
            },
            "gtin": "4000521221010",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a546991",
        "height": 1.196,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a217a3",
            "leftCorner": {
              "x": 9.163,
              "y": 1.123,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.829,
              "y": 1.149,
              "z": 0.979
            },
            "gtin": "8003340038865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217a5",
            "leftCorner": {
              "x": 8.826,
              "y": 1.109,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.725,
              "y": 1.117,
              "z": 0.979
            },
            "gtin": "4000521475000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217a6",
            "leftCorner": {
              "x": 8.725,
              "y": 1.117,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.624,
              "y": 1.125,
              "z": 0.979
            },
            "gtin": "4000521475000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217a7",
            "leftCorner": {
              "x": 8.624,
              "y": 1.126,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.455,
              "y": 1.14,
              "z": 0.979
            },
            "gtin": "4000521022648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217a8",
            "leftCorner": {
              "x": 8.455,
              "y": 1.133,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.274,
              "y": 1.148,
              "z": 0.979
            },
            "gtin": "4000521476007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217a9",
            "leftCorner": {
              "x": 8.274,
              "y": 1.148,
              "z": 0.979
            },
            "rightCorner": {
              "x": 8.093,
              "y": 1.162,
              "z": 0.979
            },
            "gtin": "4000521476007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217aa",
            "leftCorner": {
              "x": 8.093,
              "y": 1.162,
              "z": 0.979
            },
            "rightCorner": {
              "x": 7.96,
              "y": 1.173,
              "z": 0.979
            },
            "gtin": "4000521474102",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a546993",
        "height": 1.456,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a217ce",
            "leftCorner": {
              "x": 9.164,
              "y": 1.124,
              "z": 1.191
            },
            "rightCorner": {
              "x": 9.058,
              "y": 1.132,
              "z": 1.191
            },
            "gtin": "4000521035075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217cf",
            "leftCorner": {
              "x": 9.058,
              "y": 1.132,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.952,
              "y": 1.141,
              "z": 1.191
            },
            "gtin": "4000521035075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217d0",
            "leftCorner": {
              "x": 8.952,
              "y": 1.141,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.846,
              "y": 1.149,
              "z": 1.191
            },
            "gtin": "4000521035075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217d2",
            "leftCorner": {
              "x": 8.843,
              "y": 1.112,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.749,
              "y": 1.12,
              "z": 1.191
            },
            "gtin": "4000521475505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217d3",
            "leftCorner": {
              "x": 8.749,
              "y": 1.12,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.654,
              "y": 1.127,
              "z": 1.191
            },
            "gtin": "4000521475505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217d4",
            "leftCorner": {
              "x": 8.654,
              "y": 1.128,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.522,
              "y": 1.138,
              "z": 1.191
            },
            "gtin": "4000521005641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217d5",
            "leftCorner": {
              "x": 8.522,
              "y": 1.138,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.389,
              "y": 1.149,
              "z": 1.191
            },
            "gtin": "4000521005641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217d6",
            "leftCorner": {
              "x": 8.388,
              "y": 1.143,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.274,
              "y": 1.152,
              "z": 1.191
            },
            "gtin": "4000521466503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217d7",
            "leftCorner": {
              "x": 8.274,
              "y": 1.152,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.16,
              "y": 1.161,
              "z": 1.191
            },
            "gtin": "4000521466503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217d8",
            "leftCorner": {
              "x": 8.16,
              "y": 1.161,
              "z": 1.191
            },
            "rightCorner": {
              "x": 8.045,
              "y": 1.171,
              "z": 1.191
            },
            "gtin": "4000521466503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217d9",
            "leftCorner": {
              "x": 8.046,
              "y": 1.176,
              "z": 1.191
            },
            "rightCorner": {
              "x": 7.99,
              "y": 1.18,
              "z": 1.191
            },
            "gtin": "4000521035990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217da",
            "leftCorner": {
              "x": 7.99,
              "y": 1.18,
              "z": 1.191
            },
            "rightCorner": {
              "x": 7.935,
              "y": 1.185,
              "z": 1.191
            },
            "gtin": "4000521035990",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a546995",
        "height": 1.7024,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a217f2",
            "leftCorner": {
              "x": 9.163,
              "y": 1.122,
              "z": 1.393
            },
            "rightCorner": {
              "x": 9.022,
              "y": 1.133,
              "z": 1.393
            },
            "gtin": "4000521464400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217f3",
            "leftCorner": {
              "x": 9.022,
              "y": 1.133,
              "z": 1.393
            },
            "rightCorner": {
              "x": 8.881,
              "y": 1.144,
              "z": 1.393
            },
            "gtin": "4000521464400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217f5",
            "leftCorner": {
              "x": 8.878,
              "y": 1.104,
              "z": 1.393
            },
            "rightCorner": {
              "x": 8.769,
              "y": 1.113,
              "z": 1.393
            },
            "gtin": "4000521466404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217f6",
            "leftCorner": {
              "x": 8.77,
              "y": 1.12,
              "z": 1.393
            },
            "rightCorner": {
              "x": 8.698,
              "y": 1.125,
              "z": 1.393
            },
            "gtin": "4000521467401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217f7",
            "leftCorner": {
              "x": 8.698,
              "y": 1.125,
              "z": 1.393
            },
            "rightCorner": {
              "x": 8.626,
              "y": 1.131,
              "z": 1.393
            },
            "gtin": "4000521467401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217f8",
            "leftCorner": {
              "x": 8.626,
              "y": 1.129,
              "z": 1.393
            },
            "rightCorner": {
              "x": 8.535,
              "y": 1.136,
              "z": 1.393
            },
            "gtin": "4000521002930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217f9",
            "leftCorner": {
              "x": 8.535,
              "y": 1.136,
              "z": 1.393
            },
            "rightCorner": {
              "x": 8.444,
              "y": 1.143,
              "z": 1.393
            },
            "gtin": "4000521002930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217fa",
            "leftCorner": {
              "x": 8.443,
              "y": 1.136,
              "z": 1.393
            },
            "rightCorner": {
              "x": 8.37,
              "y": 1.142,
              "z": 1.393
            },
            "gtin": "4000521463502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217fb",
            "leftCorner": {
              "x": 8.37,
              "y": 1.142,
              "z": 1.393
            },
            "rightCorner": {
              "x": 8.298,
              "y": 1.148,
              "z": 1.393
            },
            "gtin": "4000521463502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217fc",
            "leftCorner": {
              "x": 8.298,
              "y": 1.151,
              "z": 1.393
            },
            "rightCorner": {
              "x": 8.186,
              "y": 1.16,
              "z": 1.393
            },
            "gtin": "4000521465407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217fd",
            "leftCorner": {
              "x": 8.186,
              "y": 1.16,
              "z": 1.393
            },
            "rightCorner": {
              "x": 8.074,
              "y": 1.169,
              "z": 1.393
            },
            "gtin": "4000521465407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217fe",
            "leftCorner": {
              "x": 8.074,
              "y": 1.169,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.962,
              "y": 1.178,
              "z": 1.393
            },
            "gtin": "4000521465407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217ff",
            "leftCorner": {
              "x": 7.962,
              "y": 1.178,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.85,
              "y": 1.187,
              "z": 1.393
            },
            "gtin": "4000521465407",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e025c",
    "rightNeighborShelfId": "e025e"
  },
  {
    "id": "e025e",
    "name": "e025e",
    "x": 7.967,
    "y": 1.226,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9992,
      "w": 0.040097
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 59
    },
    "layers": [
      {
        "id": "682ffddfd15af3232a54699c",
        "height": 0.14583,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1df88",
            "leftCorner": {
              "x": 7.744,
              "y": 1.178,
              "z": 0.119
            },
            "rightCorner": {
              "x": 7.417,
              "y": 1.204,
              "z": 0.119
            },
            "gtin": "4337185532016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df89",
            "leftCorner": {
              "x": 7.417,
              "y": 1.204,
              "z": 0.119
            },
            "rightCorner": {
              "x": 7.091,
              "y": 1.23,
              "z": 0.119
            },
            "gtin": "4337185532016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1df8a",
            "leftCorner": {
              "x": 7.091,
              "y": 1.23,
              "z": 0.119
            },
            "rightCorner": {
              "x": 6.766,
              "y": 1.256,
              "z": 0.119
            },
            "gtin": "4337185532016",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a546999",
        "height": 0.44386,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a217ee",
            "leftCorner": {
              "x": 7.875,
              "y": 1.161,
              "z": 0.363
            },
            "rightCorner": {
              "x": 7.681,
              "y": 1.176,
              "z": 0.363
            },
            "gtin": "4000521200213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217ef",
            "leftCorner": {
              "x": 7.681,
              "y": 1.176,
              "z": 0.363
            },
            "rightCorner": {
              "x": 7.488,
              "y": 1.192,
              "z": 0.363
            },
            "gtin": "4000521200213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217f0",
            "leftCorner": {
              "x": 7.488,
              "y": 1.192,
              "z": 0.363
            },
            "rightCorner": {
              "x": 7.295,
              "y": 1.207,
              "z": 0.363
            },
            "gtin": "4000521200213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217f1",
            "leftCorner": {
              "x": 7.295,
              "y": 1.207,
              "z": 0.363
            },
            "rightCorner": {
              "x": 7.101,
              "y": 1.223,
              "z": 0.363
            },
            "gtin": "4000521200213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217e5",
            "leftCorner": {
              "x": 7.104,
              "y": 1.263,
              "z": 0.363
            },
            "rightCorner": {
              "x": 6.768,
              "y": 1.29,
              "z": 0.363
            },
            "gtin": "4000521211011",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a546996",
        "height": 0.69518,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21799",
            "leftCorner": {
              "x": 7.943,
              "y": 1.16,
              "z": 0.569
            },
            "rightCorner": {
              "x": 7.741,
              "y": 1.176,
              "z": 0.569
            },
            "gtin": "4000521225407",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8b5ed67a01d9a2179a",
            "leftCorner": {
              "x": 7.742,
              "y": 1.185,
              "z": 0.569
            },
            "rightCorner": {
              "x": 7.65,
              "y": 1.192,
              "z": 0.569
            },
            "gtin": "4000521040352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2179b",
            "leftCorner": {
              "x": 7.65,
              "y": 1.192,
              "z": 0.569
            },
            "rightCorner": {
              "x": 7.558,
              "y": 1.199,
              "z": 0.569
            },
            "gtin": "4000521040352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2179c",
            "leftCorner": {
              "x": 7.558,
              "y": 1.199,
              "z": 0.569
            },
            "rightCorner": {
              "x": 7.465,
              "y": 1.207,
              "z": 0.569
            },
            "gtin": "4000521040352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2179d",
            "leftCorner": {
              "x": 7.467,
              "y": 1.222,
              "z": 0.569
            },
            "rightCorner": {
              "x": 7.392,
              "y": 1.228,
              "z": 0.569
            },
            "gtin": "4337185764264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2179e",
            "leftCorner": {
              "x": 7.393,
              "y": 1.235,
              "z": 0.569
            },
            "rightCorner": {
              "x": 7.329,
              "y": 1.24,
              "z": 0.569
            },
            "gtin": "40352152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2179f",
            "leftCorner": {
              "x": 7.329,
              "y": 1.24,
              "z": 0.569
            },
            "rightCorner": {
              "x": 7.266,
              "y": 1.245,
              "z": 0.569
            },
            "gtin": "40352152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217a0",
            "leftCorner": {
              "x": 7.266,
              "y": 1.245,
              "z": 0.569
            },
            "rightCorner": {
              "x": 7.203,
              "y": 1.25,
              "z": 0.569
            },
            "gtin": "40352152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217a1",
            "leftCorner": {
              "x": 7.204,
              "y": 1.264,
              "z": 0.569
            },
            "rightCorner": {
              "x": 7.133,
              "y": 1.269,
              "z": 0.569
            },
            "gtin": "4000521202118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217a2",
            "leftCorner": {
              "x": 7.133,
              "y": 1.269,
              "z": 0.569
            },
            "rightCorner": {
              "x": 7.062,
              "y": 1.275,
              "z": 0.569
            },
            "gtin": "4000521202118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2178f",
            "leftCorner": {
              "x": 7.062,
              "y": 1.274,
              "z": 0.569
            },
            "rightCorner": {
              "x": 6.769,
              "y": 1.297,
              "z": 0.569
            },
            "gtin": "4000521201319",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a546997",
        "height": 0.94591,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a217c4",
            "leftCorner": {
              "x": 7.958,
              "y": 1.17,
              "z": 0.774
            },
            "rightCorner": {
              "x": 7.75,
              "y": 1.187,
              "z": 0.774
            },
            "gtin": "4000521040390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217c5",
            "leftCorner": {
              "x": 7.751,
              "y": 1.197,
              "z": 0.774
            },
            "rightCorner": {
              "x": 7.693,
              "y": 1.202,
              "z": 0.774
            },
            "gtin": "4000521224011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217c6",
            "leftCorner": {
              "x": 7.693,
              "y": 1.202,
              "z": 0.774
            },
            "rightCorner": {
              "x": 7.636,
              "y": 1.206,
              "z": 0.774
            },
            "gtin": "4000521224011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217c7",
            "leftCorner": {
              "x": 7.635,
              "y": 1.202,
              "z": 0.774
            },
            "rightCorner": {
              "x": 7.578,
              "y": 1.207,
              "z": 0.774
            },
            "gtin": "4000521223014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217c8",
            "leftCorner": {
              "x": 7.578,
              "y": 1.207,
              "z": 0.774
            },
            "rightCorner": {
              "x": 7.52,
              "y": 1.211,
              "z": 0.774
            },
            "gtin": "4000521223014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217c9",
            "leftCorner": {
              "x": 7.52,
              "y": 1.211,
              "z": 0.774
            },
            "rightCorner": {
              "x": 7.463,
              "y": 1.216,
              "z": 0.774
            },
            "gtin": "4000521223014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217ca",
            "leftCorner": {
              "x": 7.463,
              "y": 1.216,
              "z": 0.774
            },
            "rightCorner": {
              "x": 7.405,
              "y": 1.22,
              "z": 0.774
            },
            "gtin": "4000521223014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217cb",
            "leftCorner": {
              "x": 7.407,
              "y": 1.239,
              "z": 0.774
            },
            "rightCorner": {
              "x": 7.31,
              "y": 1.247,
              "z": 0.774
            },
            "gtin": "4000521225506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217cc",
            "leftCorner": {
              "x": 7.31,
              "y": 1.247,
              "z": 0.774
            },
            "rightCorner": {
              "x": 7.178,
              "y": 1.257,
              "z": 0.774
            },
            "gtin": "4000521222406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217cd",
            "leftCorner": {
              "x": 7.179,
              "y": 1.27,
              "z": 0.774
            },
            "rightCorner": {
              "x": 7.082,
              "y": 1.277,
              "z": 0.774
            },
            "gtin": "4002809042355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217b9",
            "leftCorner": {
              "x": 7.082,
              "y": 1.275,
              "z": 0.774
            },
            "rightCorner": {
              "x": 6.769,
              "y": 1.3,
              "z": 0.774
            },
            "gtin": "4000521401603",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a54699a",
        "height": 1.1986,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a217ab",
            "leftCorner": {
              "x": 7.959,
              "y": 1.171,
              "z": 0.981
            },
            "rightCorner": {
              "x": 7.889,
              "y": 1.177,
              "z": 0.981
            },
            "gtin": "4002809018527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217ac",
            "leftCorner": {
              "x": 7.889,
              "y": 1.177,
              "z": 0.981
            },
            "rightCorner": {
              "x": 7.819,
              "y": 1.182,
              "z": 0.981
            },
            "gtin": "4002809018527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217ad",
            "leftCorner": {
              "x": 7.82,
              "y": 1.191,
              "z": 0.981
            },
            "rightCorner": {
              "x": 7.721,
              "y": 1.199,
              "z": 0.981
            },
            "gtin": "4002809018510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217ae",
            "leftCorner": {
              "x": 7.721,
              "y": 1.199,
              "z": 0.981
            },
            "rightCorner": {
              "x": 7.623,
              "y": 1.207,
              "z": 0.981
            },
            "gtin": "4002809018510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217af",
            "leftCorner": {
              "x": 7.623,
              "y": 1.207,
              "z": 0.981
            },
            "rightCorner": {
              "x": 7.556,
              "y": 1.213,
              "z": 0.981
            },
            "gtin": "4002809018930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217b0",
            "leftCorner": {
              "x": 7.556,
              "y": 1.213,
              "z": 0.981
            },
            "rightCorner": {
              "x": 7.489,
              "y": 1.218,
              "z": 0.981
            },
            "gtin": "4002809018930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217b1",
            "leftCorner": {
              "x": 7.489,
              "y": 1.228,
              "z": 0.981
            },
            "rightCorner": {
              "x": 7.429,
              "y": 1.233,
              "z": 0.981
            },
            "gtin": "4000521021320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217b2",
            "leftCorner": {
              "x": 7.429,
              "y": 1.233,
              "z": 0.981
            },
            "rightCorner": {
              "x": 7.369,
              "y": 1.238,
              "z": 0.981
            },
            "gtin": "4000521021320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217b3",
            "leftCorner": {
              "x": 7.369,
              "y": 1.239,
              "z": 0.981
            },
            "rightCorner": {
              "x": 7.326,
              "y": 1.242,
              "z": 0.981
            },
            "gtin": "4000521021306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217b4",
            "leftCorner": {
              "x": 7.326,
              "y": 1.242,
              "z": 0.981
            },
            "rightCorner": {
              "x": 7.283,
              "y": 1.246,
              "z": 0.981
            },
            "gtin": "4000521021306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217b5",
            "leftCorner": {
              "x": 7.284,
              "y": 1.257,
              "z": 0.981
            },
            "rightCorner": {
              "x": 7.194,
              "y": 1.264,
              "z": 0.981
            },
            "gtin": "4000521038830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217a4",
            "leftCorner": {
              "x": 7.194,
              "y": 1.257,
              "z": 0.981
            },
            "rightCorner": {
              "x": 6.768,
              "y": 1.292,
              "z": 0.981
            },
            "gtin": "4000521021344",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a546998",
        "height": 1.4501,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a217db",
            "leftCorner": {
              "x": 7.934,
              "y": 1.18,
              "z": 1.186
            },
            "rightCorner": {
              "x": 7.828,
              "y": 1.188,
              "z": 1.186
            },
            "gtin": "4000521037864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217dc",
            "leftCorner": {
              "x": 7.83,
              "y": 1.206,
              "z": 1.186
            },
            "rightCorner": {
              "x": 7.743,
              "y": 1.213,
              "z": 1.186
            },
            "gtin": "4000521037840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217dd",
            "leftCorner": {
              "x": 7.743,
              "y": 1.213,
              "z": 1.186
            },
            "rightCorner": {
              "x": 7.657,
              "y": 1.22,
              "z": 1.186
            },
            "gtin": "4000521037840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217de",
            "leftCorner": {
              "x": 7.657,
              "y": 1.219,
              "z": 1.186
            },
            "rightCorner": {
              "x": 7.511,
              "y": 1.231,
              "z": 1.186
            },
            "gtin": "4000521037888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217df",
            "leftCorner": {
              "x": 7.51,
              "y": 1.22,
              "z": 1.186
            },
            "rightCorner": {
              "x": 7.389,
              "y": 1.23,
              "z": 1.186
            },
            "gtin": "4000521453602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217e0",
            "leftCorner": {
              "x": 7.389,
              "y": 1.239,
              "z": 1.186
            },
            "rightCorner": {
              "x": 7.221,
              "y": 1.252,
              "z": 1.186
            },
            "gtin": "4000521458607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217e1",
            "leftCorner": {
              "x": 7.221,
              "y": 1.262,
              "z": 1.186
            },
            "rightCorner": {
              "x": 7.155,
              "y": 1.267,
              "z": 1.186
            },
            "gtin": "4000521024970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217e2",
            "leftCorner": {
              "x": 7.155,
              "y": 1.267,
              "z": 1.186
            },
            "rightCorner": {
              "x": 7.089,
              "y": 1.272,
              "z": 1.186
            },
            "gtin": "4000521024970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217d1",
            "leftCorner": {
              "x": 7.089,
              "y": 1.275,
              "z": 1.186
            },
            "rightCorner": {
              "x": 6.769,
              "y": 1.301,
              "z": 1.186
            },
            "gtin": "4000521024994",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddfd15af3232a54699b",
        "height": 1.702,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21800",
            "leftCorner": {
              "x": 7.85,
              "y": 1.19,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.737,
              "y": 1.199,
              "z": 1.393
            },
            "gtin": "4000521027445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21801",
            "leftCorner": {
              "x": 7.737,
              "y": 1.199,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.625,
              "y": 1.208,
              "z": 1.393
            },
            "gtin": "4000521027445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21802",
            "leftCorner": {
              "x": 7.625,
              "y": 1.208,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.512,
              "y": 1.217,
              "z": 1.393
            },
            "gtin": "4000521027445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21803",
            "leftCorner": {
              "x": 7.512,
              "y": 1.217,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.4,
              "y": 1.226,
              "z": 1.393
            },
            "gtin": "4000521027445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21804",
            "leftCorner": {
              "x": 7.401,
              "y": 1.24,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.352,
              "y": 1.244,
              "z": 1.393
            },
            "gtin": "4002809020308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21805",
            "leftCorner": {
              "x": 7.352,
              "y": 1.244,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.303,
              "y": 1.248,
              "z": 1.393
            },
            "gtin": "4002809020308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21806",
            "leftCorner": {
              "x": 7.304,
              "y": 1.261,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.203,
              "y": 1.269,
              "z": 1.393
            },
            "gtin": "4002809020773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21807",
            "leftCorner": {
              "x": 7.203,
              "y": 1.269,
              "z": 1.393
            },
            "rightCorner": {
              "x": 7.101,
              "y": 1.278,
              "z": 1.393
            },
            "gtin": "4002809020773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a217f4",
            "leftCorner": {
              "x": 7.101,
              "y": 1.276,
              "z": 1.393
            },
            "rightCorner": {
              "x": 6.769,
              "y": 1.303,
              "z": 1.393
            },
            "gtin": "4002809020780",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e025d"
  },
  {
    "id": "e025f",
    "name": "e025f",
    "x": 17.728,
    "y": 3.909,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99942,
      "w": 0.034036
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 20
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5461c9",
        "height": 0.1485,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d5a4",
            "leftCorner": {
              "x": 17.673,
              "y": 3.859,
              "z": 0.122
            },
            "rightCorner": {
              "x": 17.356,
              "y": 3.88,
              "z": 0.122
            },
            "gtin": "4005528126238",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5a5",
            "leftCorner": {
              "x": 17.355,
              "y": 3.871,
              "z": 0.122
            },
            "rightCorner": {
              "x": 17.146,
              "y": 3.885,
              "z": 0.122
            },
            "gtin": "8595564521341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5a6",
            "leftCorner": {
              "x": 17.146,
              "y": 3.885,
              "z": 0.122
            },
            "rightCorner": {
              "x": 16.936,
              "y": 3.899,
              "z": 0.122
            },
            "gtin": "8595564521341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5a7",
            "leftCorner": {
              "x": 16.937,
              "y": 3.904,
              "z": 0.122
            },
            "rightCorner": {
              "x": 16.618,
              "y": 3.925,
              "z": 0.122
            },
            "gtin": "4005528126160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5a8",
            "leftCorner": {
              "x": 16.618,
              "y": 3.925,
              "z": 0.122
            },
            "rightCorner": {
              "x": 16.301,
              "y": 3.947,
              "z": 0.122
            },
            "gtin": "4005528126160",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461c7",
        "height": 0.85221,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d59b",
            "leftCorner": {
              "x": 17.736,
              "y": 3.862,
              "z": 0.697
            },
            "rightCorner": {
              "x": 17.546,
              "y": 3.875,
              "z": 0.697
            },
            "gtin": "5414624096915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d59c",
            "leftCorner": {
              "x": 17.546,
              "y": 3.875,
              "z": 0.697
            },
            "rightCorner": {
              "x": 17.356,
              "y": 3.888,
              "z": 0.697
            },
            "gtin": "5414624096915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d597",
            "leftCorner": {
              "x": 17.355,
              "y": 3.873,
              "z": 0.697
            },
            "rightCorner": {
              "x": 16.526,
              "y": 3.929,
              "z": 0.697
            },
            "gtin": "4005528123367",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461c8",
        "height": 1.2557,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d591",
            "leftCorner": {
              "x": 17.663,
              "y": 3.855,
              "z": 1.027
            },
            "rightCorner": {
              "x": 17.511,
              "y": 3.865,
              "z": 1.027
            },
            "gtin": "4008713713213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d592",
            "leftCorner": {
              "x": 17.511,
              "y": 3.865,
              "z": 1.027
            },
            "rightCorner": {
              "x": 17.36,
              "y": 3.876,
              "z": 1.027
            },
            "gtin": "4008713713213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d593",
            "leftCorner": {
              "x": 17.359,
              "y": 3.871,
              "z": 1.027
            },
            "rightCorner": {
              "x": 17.14,
              "y": 3.886,
              "z": 1.027
            },
            "gtin": "4335896759715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d594",
            "leftCorner": {
              "x": 17.14,
              "y": 3.886,
              "z": 1.027
            },
            "rightCorner": {
              "x": 16.919,
              "y": 3.901,
              "z": 1.027
            },
            "gtin": "4335896759715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d58b",
            "leftCorner": {
              "x": 16.921,
              "y": 3.916,
              "z": 1.027
            },
            "rightCorner": {
              "x": 16.725,
              "y": 3.93,
              "z": 1.027
            },
            "gtin": "4005528119841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d58c",
            "leftCorner": {
              "x": 16.725,
              "y": 3.93,
              "z": 1.027
            },
            "rightCorner": {
              "x": 16.527,
              "y": 3.943,
              "z": 1.027
            },
            "gtin": "4005528119841",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461c6",
        "height": 1.7085,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d564",
            "leftCorner": {
              "x": 17.679,
              "y": 3.864,
              "z": 1.398
            },
            "rightCorner": {
              "x": 17.514,
              "y": 3.875,
              "z": 1.398
            },
            "gtin": "4005528119858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d565",
            "leftCorner": {
              "x": 17.514,
              "y": 3.875,
              "z": 1.398
            },
            "rightCorner": {
              "x": 17.348,
              "y": 3.886,
              "z": 1.398
            },
            "gtin": "4005528119858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d566",
            "leftCorner": {
              "x": 17.347,
              "y": 3.866,
              "z": 1.398
            },
            "rightCorner": {
              "x": 16.915,
              "y": 3.895,
              "z": 1.398
            },
            "gtin": "4005528126207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d567",
            "leftCorner": {
              "x": 16.916,
              "y": 3.915,
              "z": 1.398
            },
            "rightCorner": {
              "x": 16.702,
              "y": 3.929,
              "z": 1.398
            },
            "gtin": "4260582961786",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d568",
            "leftCorner": {
              "x": 16.701,
              "y": 3.926,
              "z": 1.398
            },
            "rightCorner": {
              "x": 16.596,
              "y": 3.933,
              "z": 1.398
            },
            "gtin": "4260582961809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d569",
            "leftCorner": {
              "x": 16.596,
              "y": 3.933,
              "z": 1.398
            },
            "rightCorner": {
              "x": 16.489,
              "y": 3.94,
              "z": 1.398
            },
            "gtin": "4260582961809",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d1384",
    "rightNeighborShelfId": "e0260"
  },
  {
    "id": "e0260",
    "name": "e0260",
    "x": 16.536,
    "y": 3.991,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99908,
      "w": 0.04287
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 26
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5461ce",
        "height": 0.14899,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d5a9",
            "leftCorner": {
              "x": 16.306,
              "y": 3.971,
              "z": 0.122
            },
            "rightCorner": {
              "x": 15.94,
              "y": 4.003,
              "z": 0.122
            },
            "gtin": "5738001092490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5aa",
            "leftCorner": {
              "x": 15.94,
              "y": 4.003,
              "z": 0.122
            },
            "rightCorner": {
              "x": 15.573,
              "y": 4.035,
              "z": 0.122
            },
            "gtin": "5738001092490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5ab",
            "leftCorner": {
              "x": 15.572,
              "y": 4.027,
              "z": 0.122
            },
            "rightCorner": {
              "x": 14.937,
              "y": 4.081,
              "z": 0.122
            },
            "gtin": "5059319023670",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461ca",
        "height": 0.5515,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d5c5",
            "leftCorner": {
              "x": 16.536,
              "y": 3.987,
              "z": 0.451
            },
            "rightCorner": {
              "x": 16.314,
              "y": 4.006,
              "z": 0.451
            },
            "gtin": "5059319023960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5c6",
            "leftCorner": {
              "x": 16.314,
              "y": 4.006,
              "z": 0.451
            },
            "rightCorner": {
              "x": 16.093,
              "y": 4.025,
              "z": 0.451
            },
            "gtin": "5059319023960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5c8",
            "leftCorner": {
              "x": 16.09,
              "y": 3.985,
              "z": 0.451
            },
            "rightCorner": {
              "x": 15.736,
              "y": 4.016,
              "z": 0.451
            },
            "gtin": "5059319030760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5c9",
            "leftCorner": {
              "x": 15.736,
              "y": 4.021,
              "z": 0.451
            },
            "rightCorner": {
              "x": 15.309,
              "y": 4.058,
              "z": 0.451
            },
            "gtin": "5059319030616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5ca",
            "leftCorner": {
              "x": 15.309,
              "y": 4.058,
              "z": 0.451
            },
            "rightCorner": {
              "x": 14.881,
              "y": 4.094,
              "z": 0.451
            },
            "gtin": "5059319030616",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461cb",
        "height": 0.95435,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d5d4",
            "leftCorner": {
              "x": 16.536,
              "y": 3.985,
              "z": 0.781
            },
            "rightCorner": {
              "x": 16.158,
              "y": 4.018,
              "z": 0.781
            },
            "gtin": "5059319030883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5d6",
            "leftCorner": {
              "x": 16.155,
              "y": 3.98,
              "z": 0.781
            },
            "rightCorner": {
              "x": 15.932,
              "y": 3.999,
              "z": 0.781
            },
            "gtin": "5053827199568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5d7",
            "leftCorner": {
              "x": 15.932,
              "y": 3.999,
              "z": 0.781
            },
            "rightCorner": {
              "x": 15.71,
              "y": 4.018,
              "z": 0.781
            },
            "gtin": "5053827199568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5d8",
            "leftCorner": {
              "x": 15.71,
              "y": 4.022,
              "z": 0.781
            },
            "rightCorner": {
              "x": 15.497,
              "y": 4.041,
              "z": 0.781
            },
            "gtin": "5059319030791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5d9",
            "leftCorner": {
              "x": 15.497,
              "y": 4.041,
              "z": 0.781
            },
            "rightCorner": {
              "x": 15.284,
              "y": 4.059,
              "z": 0.781
            },
            "gtin": "5059319030791",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461cd",
        "height": 1.3058,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d5eb",
            "leftCorner": {
              "x": 16.536,
              "y": 3.986,
              "z": 1.068
            },
            "rightCorner": {
              "x": 16.431,
              "y": 3.995,
              "z": 1.068
            },
            "gtin": "4000540005028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5ec",
            "leftCorner": {
              "x": 16.431,
              "y": 3.995,
              "z": 1.068
            },
            "rightCorner": {
              "x": 16.327,
              "y": 4.004,
              "z": 1.068
            },
            "gtin": "4000540005028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5ef",
            "leftCorner": {
              "x": 16.324,
              "y": 3.972,
              "z": 1.068
            },
            "rightCorner": {
              "x": 16.131,
              "y": 3.988,
              "z": 1.068
            },
            "gtin": "4000540025217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5f0",
            "leftCorner": {
              "x": 16.131,
              "y": 3.988,
              "z": 1.068
            },
            "rightCorner": {
              "x": 15.938,
              "y": 4.005,
              "z": 1.068
            },
            "gtin": "4000540025217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5f1",
            "leftCorner": {
              "x": 15.938,
              "y": 4.005,
              "z": 1.068
            },
            "rightCorner": {
              "x": 15.744,
              "y": 4.022,
              "z": 1.068
            },
            "gtin": "4000540025217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5f2",
            "leftCorner": {
              "x": 15.744,
              "y": 4.017,
              "z": 1.068
            },
            "rightCorner": {
              "x": 15.311,
              "y": 4.054,
              "z": 1.068
            },
            "gtin": "8445291360068",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461cc",
        "height": 1.7112,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d56a",
            "leftCorner": {
              "x": 16.495,
              "y": 3.953,
              "z": 1.4
            },
            "rightCorner": {
              "x": 16.326,
              "y": 3.967,
              "z": 1.4
            },
            "gtin": "4260582961519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d56b",
            "leftCorner": {
              "x": 16.326,
              "y": 3.97,
              "z": 1.4
            },
            "rightCorner": {
              "x": 16.116,
              "y": 3.988,
              "z": 1.4
            },
            "gtin": "4260582961502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d56c",
            "leftCorner": {
              "x": 16.115,
              "y": 3.983,
              "z": 1.4
            },
            "rightCorner": {
              "x": 15.886,
              "y": 4.003,
              "z": 1.4
            },
            "gtin": "4000540015157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d56d",
            "leftCorner": {
              "x": 15.886,
              "y": 4.007,
              "z": 1.4
            },
            "rightCorner": {
              "x": 15.703,
              "y": 4.023,
              "z": 1.4
            },
            "gtin": "4000540005059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d56e",
            "leftCorner": {
              "x": 15.703,
              "y": 4.023,
              "z": 1.4
            },
            "rightCorner": {
              "x": 15.522,
              "y": 4.038,
              "z": 1.4
            },
            "gtin": "4000540005059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d56f",
            "leftCorner": {
              "x": 15.522,
              "y": 4.038,
              "z": 1.4
            },
            "rightCorner": {
              "x": 15.397,
              "y": 4.049,
              "z": 1.4
            },
            "gtin": "4262367680400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d570",
            "leftCorner": {
              "x": 15.397,
              "y": 4.049,
              "z": 1.4
            },
            "rightCorner": {
              "x": 15.273,
              "y": 4.06,
              "z": 1.4
            },
            "gtin": "4262367680400",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e025f",
    "rightNeighborShelfId": "e0261"
  },
  {
    "id": "e0261",
    "name": "e0261",
    "x": 15.34,
    "y": 4.093,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99908,
      "w": 0.04287
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 30
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5461d3",
        "height": 0.15504,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d5ac",
            "leftCorner": {
              "x": 14.938,
              "y": 4.098,
              "z": 0.127
            },
            "rightCorner": {
              "x": 14.843,
              "y": 4.106,
              "z": 0.127
            },
            "gtin": "3387390320190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5ad",
            "leftCorner": {
              "x": 14.843,
              "y": 4.106,
              "z": 0.127
            },
            "rightCorner": {
              "x": 14.748,
              "y": 4.114,
              "z": 0.127
            },
            "gtin": "3387390320190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5ae",
            "leftCorner": {
              "x": 14.748,
              "y": 4.114,
              "z": 0.127
            },
            "rightCorner": {
              "x": 14.653,
              "y": 4.122,
              "z": 0.127
            },
            "gtin": "3387390320190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5af",
            "leftCorner": {
              "x": 14.652,
              "y": 4.104,
              "z": 0.127
            },
            "rightCorner": {
              "x": 14.347,
              "y": 4.13,
              "z": 0.127
            },
            "gtin": "3387390325621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5b0",
            "leftCorner": {
              "x": 14.347,
              "y": 4.13,
              "z": 0.127
            },
            "rightCorner": {
              "x": 14.042,
              "y": 4.156,
              "z": 0.127
            },
            "gtin": "3387390325621",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461d2",
        "height": 0.55123,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d5cb",
            "leftCorner": {
              "x": 14.879,
              "y": 4.078,
              "z": 0.451
            },
            "rightCorner": {
              "x": 14.684,
              "y": 4.095,
              "z": 0.451
            },
            "gtin": "8445290263278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5cc",
            "leftCorner": {
              "x": 14.684,
              "y": 4.095,
              "z": 0.451
            },
            "rightCorner": {
              "x": 14.489,
              "y": 4.112,
              "z": 0.451
            },
            "gtin": "8445290263278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5cd",
            "leftCorner": {
              "x": 14.489,
              "y": 4.119,
              "z": 0.451
            },
            "rightCorner": {
              "x": 14.293,
              "y": 4.136,
              "z": 0.451
            },
            "gtin": "7613031570126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5ce",
            "leftCorner": {
              "x": 14.293,
              "y": 4.136,
              "z": 0.451
            },
            "rightCorner": {
              "x": 14.098,
              "y": 4.153,
              "z": 0.451
            },
            "gtin": "7613031570126",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461d0",
        "height": 0.95698,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d5da",
            "leftCorner": {
              "x": 15.282,
              "y": 4.049,
              "z": 0.783
            },
            "rightCorner": {
              "x": 15.169,
              "y": 4.059,
              "z": 0.783
            },
            "gtin": "4015537002935",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5db",
            "leftCorner": {
              "x": 15.169,
              "y": 4.064,
              "z": 0.783
            },
            "rightCorner": {
              "x": 15.037,
              "y": 4.075,
              "z": 0.783
            },
            "gtin": "7613033212949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5dc",
            "leftCorner": {
              "x": 15.037,
              "y": 4.075,
              "z": 0.783
            },
            "rightCorner": {
              "x": 14.903,
              "y": 4.087,
              "z": 0.783
            },
            "gtin": "7613033212949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5dd",
            "leftCorner": {
              "x": 14.903,
              "y": 4.087,
              "z": 0.783
            },
            "rightCorner": {
              "x": 14.77,
              "y": 4.098,
              "z": 0.783
            },
            "gtin": "7613033212949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5de",
            "leftCorner": {
              "x": 14.771,
              "y": 4.11,
              "z": 0.783
            },
            "rightCorner": {
              "x": 14.64,
              "y": 4.121,
              "z": 0.783
            },
            "gtin": "7613287433633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5df",
            "leftCorner": {
              "x": 14.64,
              "y": 4.121,
              "z": 0.783
            },
            "rightCorner": {
              "x": 14.509,
              "y": 4.132,
              "z": 0.783
            },
            "gtin": "7613287433633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5e0",
            "leftCorner": {
              "x": 14.508,
              "y": 4.13,
              "z": 0.783
            },
            "rightCorner": {
              "x": 14.376,
              "y": 4.141,
              "z": 0.783
            },
            "gtin": "5011546457277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5e1",
            "leftCorner": {
              "x": 14.376,
              "y": 4.141,
              "z": 0.783
            },
            "rightCorner": {
              "x": 14.243,
              "y": 4.153,
              "z": 0.783
            },
            "gtin": "5011546457277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5e2",
            "leftCorner": {
              "x": 14.243,
              "y": 4.153,
              "z": 0.783
            },
            "rightCorner": {
              "x": 14.111,
              "y": 4.164,
              "z": 0.783
            },
            "gtin": "5011546457277",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461cf",
        "height": 1.3116,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d5f3",
            "leftCorner": {
              "x": 15.311,
              "y": 4.055,
              "z": 1.073
            },
            "rightCorner": {
              "x": 15.188,
              "y": 4.066,
              "z": 1.073
            },
            "gtin": "4260582961908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5f4",
            "leftCorner": {
              "x": 15.188,
              "y": 4.062,
              "z": 1.073
            },
            "rightCorner": {
              "x": 15.06,
              "y": 4.073,
              "z": 1.073
            },
            "gtin": "4260582961892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5f5",
            "leftCorner": {
              "x": 15.059,
              "y": 4.071,
              "z": 1.073
            },
            "rightCorner": {
              "x": 14.884,
              "y": 4.086,
              "z": 1.073
            },
            "gtin": "4260582961939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5f6",
            "leftCorner": {
              "x": 14.884,
              "y": 4.087,
              "z": 1.073
            },
            "rightCorner": {
              "x": 14.104,
              "y": 4.154,
              "z": 1.073
            },
            "gtin": "3387390333008",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461d1",
        "height": 1.7103,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d571",
            "leftCorner": {
              "x": 15.271,
              "y": 4.051,
              "z": 1.399
            },
            "rightCorner": {
              "x": 15.104,
              "y": 4.066,
              "z": 1.399
            },
            "gtin": "7613287308870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d572",
            "leftCorner": {
              "x": 15.105,
              "y": 4.083,
              "z": 1.399
            },
            "rightCorner": {
              "x": 14.839,
              "y": 4.106,
              "z": 1.399
            },
            "gtin": "7613287309228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d573",
            "leftCorner": {
              "x": 14.838,
              "y": 4.091,
              "z": 1.399
            },
            "rightCorner": {
              "x": 14.647,
              "y": 4.107,
              "z": 1.399
            },
            "gtin": "3387390339499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d574",
            "leftCorner": {
              "x": 14.647,
              "y": 4.11,
              "z": 1.399
            },
            "rightCorner": {
              "x": 14.565,
              "y": 4.117,
              "z": 1.399
            },
            "gtin": "7613031517817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d575",
            "leftCorner": {
              "x": 14.565,
              "y": 4.117,
              "z": 1.399
            },
            "rightCorner": {
              "x": 14.485,
              "y": 4.124,
              "z": 1.399
            },
            "gtin": "7613031517817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d576",
            "leftCorner": {
              "x": 14.485,
              "y": 4.13,
              "z": 1.399
            },
            "rightCorner": {
              "x": 14.362,
              "y": 4.14,
              "z": 1.399
            },
            "gtin": "5900020043481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d577",
            "leftCorner": {
              "x": 14.362,
              "y": 4.14,
              "z": 1.399
            },
            "rightCorner": {
              "x": 14.238,
              "y": 4.151,
              "z": 1.399
            },
            "gtin": "5900020043481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d578",
            "leftCorner": {
              "x": 14.238,
              "y": 4.145,
              "z": 1.399
            },
            "rightCorner": {
              "x": 14.023,
              "y": 4.163,
              "z": 1.399
            },
            "gtin": "8008698007709",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e0260",
    "rightNeighborShelfId": "e0262"
  },
  {
    "id": "e0262",
    "name": "e0262",
    "x": 14.144,
    "y": 4.196,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99908,
      "w": 0.04287
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 39
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5461d8",
        "height": 0.15389,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d5b1",
            "leftCorner": {
              "x": 14.041,
              "y": 4.146,
              "z": 0.126
            },
            "rightCorner": {
              "x": 13.937,
              "y": 4.155,
              "z": 0.126
            },
            "gtin": "4251680805300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5b2",
            "leftCorner": {
              "x": 13.937,
              "y": 4.155,
              "z": 0.126
            },
            "rightCorner": {
              "x": 13.834,
              "y": 4.164,
              "z": 0.126
            },
            "gtin": "4251680805300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5b3",
            "leftCorner": {
              "x": 13.836,
              "y": 4.181,
              "z": 0.126
            },
            "rightCorner": {
              "x": 13.732,
              "y": 4.19,
              "z": 0.126
            },
            "gtin": "4260188785670",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5b4",
            "leftCorner": {
              "x": 13.732,
              "y": 4.189,
              "z": 0.126
            },
            "rightCorner": {
              "x": 13.623,
              "y": 4.198,
              "z": 0.126
            },
            "gtin": "4260188785588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5b5",
            "leftCorner": {
              "x": 13.621,
              "y": 4.184,
              "z": 0.126
            },
            "rightCorner": {
              "x": 13.515,
              "y": 4.193,
              "z": 0.126
            },
            "gtin": "4260188784215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5b6",
            "leftCorner": {
              "x": 13.516,
              "y": 4.203,
              "z": 0.126
            },
            "rightCorner": {
              "x": 13.41,
              "y": 4.212,
              "z": 0.126
            },
            "gtin": "4251680804099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5b7",
            "leftCorner": {
              "x": 13.41,
              "y": 4.212,
              "z": 0.126
            },
            "rightCorner": {
              "x": 13.305,
              "y": 4.221,
              "z": 0.126
            },
            "gtin": "4251680804099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5b8",
            "leftCorner": {
              "x": 13.304,
              "y": 4.208,
              "z": 0.126
            },
            "rightCorner": {
              "x": 13.188,
              "y": 4.218,
              "z": 0.126
            },
            "gtin": "4260188785564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5b9",
            "leftCorner": {
              "x": 13.19,
              "y": 4.244,
              "z": 0.126
            },
            "rightCorner": {
              "x": 13.135,
              "y": 4.249,
              "z": 0.126
            },
            "gtin": "4251680812506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5ba",
            "leftCorner": {
              "x": 13.135,
              "y": 4.249,
              "z": 0.126
            },
            "rightCorner": {
              "x": 13.08,
              "y": 4.254,
              "z": 0.126
            },
            "gtin": "4251680812506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5bb",
            "leftCorner": {
              "x": 13.078,
              "y": 4.234,
              "z": 0.126
            },
            "rightCorner": {
              "x": 12.988,
              "y": 4.242,
              "z": 0.126
            },
            "gtin": "4260188785540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5bc",
            "leftCorner": {
              "x": 12.988,
              "y": 4.242,
              "z": 0.126
            },
            "rightCorner": {
              "x": 12.899,
              "y": 4.25,
              "z": 0.126
            },
            "gtin": "4260188785540",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461d7",
        "height": 0.55145,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d5cf",
            "leftCorner": {
              "x": 14.097,
              "y": 4.141,
              "z": 0.451
            },
            "rightCorner": {
              "x": 13.939,
              "y": 4.154,
              "z": 0.451
            },
            "gtin": "7613039115220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5d0",
            "leftCorner": {
              "x": 13.941,
              "y": 4.173,
              "z": 0.451
            },
            "rightCorner": {
              "x": 13.796,
              "y": 4.185,
              "z": 0.451
            },
            "gtin": "8445290728791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5d1",
            "leftCorner": {
              "x": 13.796,
              "y": 4.185,
              "z": 0.451
            },
            "rightCorner": {
              "x": 13.653,
              "y": 4.198,
              "z": 0.451
            },
            "gtin": "8445290728791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5d2",
            "leftCorner": {
              "x": 13.652,
              "y": 4.186,
              "z": 0.451
            },
            "rightCorner": {
              "x": 13.376,
              "y": 4.21,
              "z": 0.451
            },
            "gtin": "4008391212145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5d3",
            "leftCorner": {
              "x": 13.376,
              "y": 4.21,
              "z": 0.451
            },
            "rightCorner": {
              "x": 13.101,
              "y": 4.234,
              "z": 0.451
            },
            "gtin": "4008391212145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5c7",
            "leftCorner": {
              "x": 13.101,
              "y": 4.234,
              "z": 0.451
            },
            "rightCorner": {
              "x": 12.945,
              "y": 4.248,
              "z": 0.451
            },
            "gtin": "4008391212770",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461d5",
        "height": 0.95358,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d5e3",
            "leftCorner": {
              "x": 14.109,
              "y": 4.143,
              "z": 0.78
            },
            "rightCorner": {
              "x": 14.027,
              "y": 4.15,
              "z": 0.78
            },
            "gtin": "7613287476678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5e4",
            "leftCorner": {
              "x": 14.027,
              "y": 4.15,
              "z": 0.78
            },
            "rightCorner": {
              "x": 13.947,
              "y": 4.157,
              "z": 0.78
            },
            "gtin": "7613287476678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5e5",
            "leftCorner": {
              "x": 13.947,
              "y": 4.166,
              "z": 0.78
            },
            "rightCorner": {
              "x": 13.825,
              "y": 4.177,
              "z": 0.78
            },
            "gtin": "5900020011213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5e6",
            "leftCorner": {
              "x": 13.825,
              "y": 4.177,
              "z": 0.78
            },
            "rightCorner": {
              "x": 13.702,
              "y": 4.187,
              "z": 0.78
            },
            "gtin": "5900020011213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5e7",
            "leftCorner": {
              "x": 13.702,
              "y": 4.182,
              "z": 0.78
            },
            "rightCorner": {
              "x": 13.604,
              "y": 4.19,
              "z": 0.78
            },
            "gtin": "8445290336552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5e8",
            "leftCorner": {
              "x": 13.604,
              "y": 4.19,
              "z": 0.78
            },
            "rightCorner": {
              "x": 13.507,
              "y": 4.198,
              "z": 0.78
            },
            "gtin": "8445290336552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5e9",
            "leftCorner": {
              "x": 13.506,
              "y": 4.196,
              "z": 0.78
            },
            "rightCorner": {
              "x": 13.313,
              "y": 4.213,
              "z": 0.78
            },
            "gtin": "3387390321067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5ea",
            "leftCorner": {
              "x": 13.313,
              "y": 4.213,
              "z": 0.78
            },
            "rightCorner": {
              "x": 13.121,
              "y": 4.229,
              "z": 0.78
            },
            "gtin": "3387390321067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5d5",
            "leftCorner": {
              "x": 13.121,
              "y": 4.239,
              "z": 0.78
            },
            "rightCorner": {
              "x": 12.945,
              "y": 4.254,
              "z": 0.78
            },
            "gtin": "7613038529929",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461d6",
        "height": 1.3071,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d5f7",
            "leftCorner": {
              "x": 14.104,
              "y": 4.162,
              "z": 1.069
            },
            "rightCorner": {
              "x": 13.333,
              "y": 4.228,
              "z": 1.069
            },
            "gtin": "5900020042804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5ed",
            "leftCorner": {
              "x": 13.332,
              "y": 4.217,
              "z": 1.069
            },
            "rightCorner": {
              "x": 13.138,
              "y": 4.234,
              "z": 1.069
            },
            "gtin": "7613031847433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5ee",
            "leftCorner": {
              "x": 13.138,
              "y": 4.234,
              "z": 1.069
            },
            "rightCorner": {
              "x": 12.945,
              "y": 4.25,
              "z": 1.069
            },
            "gtin": "7613031847433",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461d4",
        "height": 1.7103,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d579",
            "leftCorner": {
              "x": 14.023,
              "y": 4.155,
              "z": 1.399
            },
            "rightCorner": {
              "x": 13.834,
              "y": 4.171,
              "z": 1.399
            },
            "gtin": "8445290292056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d57a",
            "leftCorner": {
              "x": 13.834,
              "y": 4.171,
              "z": 1.399
            },
            "rightCorner": {
              "x": 13.647,
              "y": 4.187,
              "z": 1.399
            },
            "gtin": "8445290292056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d57b",
            "leftCorner": {
              "x": 13.648,
              "y": 4.199,
              "z": 1.399
            },
            "rightCorner": {
              "x": 13.48,
              "y": 4.213,
              "z": 1.399
            },
            "gtin": "4260582961908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d57c",
            "leftCorner": {
              "x": 13.48,
              "y": 4.215,
              "z": 1.399
            },
            "rightCorner": {
              "x": 13.375,
              "y": 4.224,
              "z": 1.399
            },
            "gtin": "4000521031701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d57d",
            "leftCorner": {
              "x": 13.375,
              "y": 4.224,
              "z": 1.399
            },
            "rightCorner": {
              "x": 13.269,
              "y": 4.233,
              "z": 1.399
            },
            "gtin": "4000521031701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d57e",
            "leftCorner": {
              "x": 13.27,
              "y": 4.238,
              "z": 1.399
            },
            "rightCorner": {
              "x": 13.153,
              "y": 4.248,
              "z": 1.399
            },
            "gtin": "4000521027032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d57f",
            "leftCorner": {
              "x": 13.153,
              "y": 4.242,
              "z": 1.399
            },
            "rightCorner": {
              "x": 13.079,
              "y": 4.249,
              "z": 1.399
            },
            "gtin": "4008713713312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d580",
            "leftCorner": {
              "x": 13.079,
              "y": 4.249,
              "z": 1.399
            },
            "rightCorner": {
              "x": 13.005,
              "y": 4.255,
              "z": 1.399
            },
            "gtin": "4008713713312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d581",
            "leftCorner": {
              "x": 13.005,
              "y": 4.252,
              "z": 1.399
            },
            "rightCorner": {
              "x": 12.916,
              "y": 4.26,
              "z": 1.399
            },
            "gtin": "4063367231292",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e0261",
    "rightNeighborShelfId": "e0263"
  },
  {
    "id": "e0263",
    "name": "e0263",
    "x": 12.949,
    "y": 4.299,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99908,
      "w": 0.04287
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 68
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5461dc",
        "height": 1.461,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d616",
            "leftCorner": {
              "x": 12.718,
              "y": 4.309,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.586,
              "y": 4.32,
              "z": 1.195
            },
            "gtin": "4337185395987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d611",
            "leftCorner": {
              "x": 12.95,
              "y": 4.311,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.912,
              "y": 4.314,
              "z": 1.195
            },
            "gtin": "4260462983617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d612",
            "leftCorner": {
              "x": 12.912,
              "y": 4.314,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.873,
              "y": 4.317,
              "z": 1.195
            },
            "gtin": "4260462983617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d614",
            "leftCorner": {
              "x": 12.869,
              "y": 4.277,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.811,
              "y": 4.282,
              "z": 1.195
            },
            "gtin": "4260462982108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d615",
            "leftCorner": {
              "x": 12.812,
              "y": 4.297,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.718,
              "y": 4.305,
              "z": 1.195
            },
            "gtin": "4337185396045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d617",
            "leftCorner": {
              "x": 12.583,
              "y": 4.303,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.524,
              "y": 4.308,
              "z": 1.195
            },
            "gtin": "42305156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d618",
            "leftCorner": {
              "x": 12.524,
              "y": 4.308,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.463,
              "y": 4.314,
              "z": 1.195
            },
            "gtin": "42305156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d619",
            "leftCorner": {
              "x": 12.462,
              "y": 4.307,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.33,
              "y": 4.318,
              "z": 1.195
            },
            "gtin": "4045178010495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d61a",
            "leftCorner": {
              "x": 12.33,
              "y": 4.325,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.271,
              "y": 4.331,
              "z": 1.195
            },
            "gtin": "4045178010457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d61b",
            "leftCorner": {
              "x": 12.27,
              "y": 4.32,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.193,
              "y": 4.326,
              "z": 1.195
            },
            "gtin": "9000331606101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d61c",
            "leftCorner": {
              "x": 12.193,
              "y": 4.326,
              "z": 1.195
            },
            "rightCorner": {
              "x": 12.115,
              "y": 4.333,
              "z": 1.195
            },
            "gtin": "9000331606101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d61d",
            "leftCorner": {
              "x": 12.116,
              "y": 4.338,
              "z": 1.195
            },
            "rightCorner": {
              "x": 11.967,
              "y": 4.351,
              "z": 1.195
            },
            "gtin": "4260188781191",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d61e",
            "leftCorner": {
              "x": 11.967,
              "y": 4.351,
              "z": 1.195
            },
            "rightCorner": {
              "x": 11.819,
              "y": 4.364,
              "z": 1.195
            },
            "gtin": "4260188781191",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d613",
            "leftCorner": {
              "x": 11.818,
              "y": 4.35,
              "z": 1.195
            },
            "rightCorner": {
              "x": 11.749,
              "y": 4.356,
              "z": 1.195
            },
            "gtin": "4260188781146",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461d9",
        "height": 0.15837,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d5bd",
            "leftCorner": {
              "x": 12.899,
              "y": 4.26,
              "z": 0.13
            },
            "rightCorner": {
              "x": 12.8,
              "y": 4.269,
              "z": 0.13
            },
            "gtin": "4251680805386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5be",
            "leftCorner": {
              "x": 12.799,
              "y": 4.257,
              "z": 0.13
            },
            "rightCorner": {
              "x": 12.702,
              "y": 4.266,
              "z": 0.13
            },
            "gtin": "4251680812520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5bf",
            "leftCorner": {
              "x": 12.702,
              "y": 4.263,
              "z": 0.13
            },
            "rightCorner": {
              "x": 12.619,
              "y": 4.27,
              "z": 0.13
            },
            "gtin": "4251680813107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5c0",
            "leftCorner": {
              "x": 12.62,
              "y": 4.276,
              "z": 0.13
            },
            "rightCorner": {
              "x": 12.501,
              "y": 4.287,
              "z": 0.13
            },
            "gtin": "4251680804099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5c1",
            "leftCorner": {
              "x": 12.501,
              "y": 4.284,
              "z": 0.13
            },
            "rightCorner": {
              "x": 12.428,
              "y": 4.29,
              "z": 0.13
            },
            "gtin": "4000540010121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5c2",
            "leftCorner": {
              "x": 12.428,
              "y": 4.29,
              "z": 0.13
            },
            "rightCorner": {
              "x": 12.355,
              "y": 4.296,
              "z": 0.13
            },
            "gtin": "4000540010121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5c3",
            "leftCorner": {
              "x": 12.355,
              "y": 4.294,
              "z": 0.13
            },
            "rightCorner": {
              "x": 12.201,
              "y": 4.307,
              "z": 0.13
            },
            "gtin": "4000540000108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5c4",
            "leftCorner": {
              "x": 12.201,
              "y": 4.307,
              "z": 0.13
            },
            "rightCorner": {
              "x": 12.046,
              "y": 4.321,
              "z": 0.13
            },
            "gtin": "4000540000108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d59f",
            "leftCorner": {
              "x": 12.046,
              "y": 4.318,
              "z": 0.13
            },
            "rightCorner": {
              "x": 11.748,
              "y": 4.344,
              "z": 0.13
            },
            "gtin": "4000540000306",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461da",
        "height": 0.50046,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d5f8",
            "leftCorner": {
              "x": 12.948,
              "y": 4.289,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.872,
              "y": 4.295,
              "z": 0.409
            },
            "gtin": "4008391005693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5f9",
            "leftCorner": {
              "x": 12.872,
              "y": 4.295,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.795,
              "y": 4.302,
              "z": 0.409
            },
            "gtin": "4008391005693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5fb",
            "leftCorner": {
              "x": 12.793,
              "y": 4.269,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.667,
              "y": 4.28,
              "z": 0.409
            },
            "gtin": "4008391051508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5fc",
            "leftCorner": {
              "x": 12.667,
              "y": 4.282,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.561,
              "y": 4.291,
              "z": 0.409
            },
            "gtin": "4008391005556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5fd",
            "leftCorner": {
              "x": 12.561,
              "y": 4.291,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.454,
              "y": 4.3,
              "z": 0.409
            },
            "gtin": "4008391005556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5fe",
            "leftCorner": {
              "x": 12.453,
              "y": 4.292,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.395,
              "y": 4.297,
              "z": 0.409
            },
            "gtin": "4008391041479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5ff",
            "leftCorner": {
              "x": 12.395,
              "y": 4.297,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.335,
              "y": 4.303,
              "z": 0.409
            },
            "gtin": "4008391041479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d600",
            "leftCorner": {
              "x": 12.335,
              "y": 4.301,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.194,
              "y": 4.313,
              "z": 0.409
            },
            "gtin": "4008391041721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d601",
            "leftCorner": {
              "x": 12.194,
              "y": 4.31,
              "z": 0.409
            },
            "rightCorner": {
              "x": 12.099,
              "y": 4.318,
              "z": 0.409
            },
            "gtin": "4008391040229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d602",
            "leftCorner": {
              "x": 12.1,
              "y": 4.324,
              "z": 0.409
            },
            "rightCorner": {
              "x": 11.972,
              "y": 4.335,
              "z": 0.409
            },
            "gtin": "4008391002067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d603",
            "leftCorner": {
              "x": 11.972,
              "y": 4.329,
              "z": 0.409
            },
            "rightCorner": {
              "x": 11.865,
              "y": 4.338,
              "z": 0.409
            },
            "gtin": "4008391050419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d5fa",
            "leftCorner": {
              "x": 11.865,
              "y": 4.339,
              "z": 0.409
            },
            "rightCorner": {
              "x": 11.749,
              "y": 4.349,
              "z": 0.409
            },
            "gtin": "4008391008205",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461db",
        "height": 0.85745,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d604",
            "leftCorner": {
              "x": 12.949,
              "y": 4.297,
              "z": 0.702
            },
            "rightCorner": {
              "x": 12.798,
              "y": 4.31,
              "z": 0.702
            },
            "gtin": "4021234160007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d607",
            "leftCorner": {
              "x": 12.795,
              "y": 4.278,
              "z": 0.702
            },
            "rightCorner": {
              "x": 12.663,
              "y": 4.289,
              "z": 0.702
            },
            "gtin": "4008713713336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d608",
            "leftCorner": {
              "x": 12.662,
              "y": 4.286,
              "z": 0.702
            },
            "rightCorner": {
              "x": 12.548,
              "y": 4.296,
              "z": 0.702
            },
            "gtin": "4021234102021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d609",
            "leftCorner": {
              "x": 12.548,
              "y": 4.293,
              "z": 0.702
            },
            "rightCorner": {
              "x": 12.445,
              "y": 4.301,
              "z": 0.702
            },
            "gtin": "4021234101246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d60a",
            "leftCorner": {
              "x": 12.445,
              "y": 4.298,
              "z": 0.702
            },
            "rightCorner": {
              "x": 12.387,
              "y": 4.303,
              "z": 0.702
            },
            "gtin": "4021234101239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d60b",
            "leftCorner": {
              "x": 12.387,
              "y": 4.303,
              "z": 0.702
            },
            "rightCorner": {
              "x": 12.329,
              "y": 4.308,
              "z": 0.702
            },
            "gtin": "4021234101239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d60c",
            "leftCorner": {
              "x": 12.329,
              "y": 4.305,
              "z": 0.702
            },
            "rightCorner": {
              "x": 12.177,
              "y": 4.318,
              "z": 0.702
            },
            "gtin": "4021234101543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d60d",
            "leftCorner": {
              "x": 12.177,
              "y": 4.322,
              "z": 0.702
            },
            "rightCorner": {
              "x": 12.082,
              "y": 4.33,
              "z": 0.702
            },
            "gtin": "4021234101338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d60e",
            "leftCorner": {
              "x": 12.083,
              "y": 4.335,
              "z": 0.702
            },
            "rightCorner": {
              "x": 11.977,
              "y": 4.344,
              "z": 0.702
            },
            "gtin": "4046097800129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d60f",
            "leftCorner": {
              "x": 11.976,
              "y": 4.337,
              "z": 0.702
            },
            "rightCorner": {
              "x": 11.911,
              "y": 4.343,
              "z": 0.702
            },
            "gtin": "4015637824659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d610",
            "leftCorner": {
              "x": 11.911,
              "y": 4.343,
              "z": 0.702
            },
            "rightCorner": {
              "x": 11.844,
              "y": 4.349,
              "z": 0.702
            },
            "gtin": "4015637824659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d605",
            "leftCorner": {
              "x": 11.844,
              "y": 4.352,
              "z": 0.702
            },
            "rightCorner": {
              "x": 11.797,
              "y": 4.356,
              "z": 0.702
            },
            "gtin": "4015637825649",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d606",
            "leftCorner": {
              "x": 11.797,
              "y": 4.356,
              "z": 0.702
            },
            "rightCorner": {
              "x": 11.749,
              "y": 4.36,
              "z": 0.702
            },
            "gtin": "4015637825649",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461de",
        "height": 1.1565,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d61f",
            "leftCorner": {
              "x": 12.949,
              "y": 4.298,
              "z": 0.946
            },
            "rightCorner": {
              "x": 12.856,
              "y": 4.306,
              "z": 0.946
            },
            "gtin": "4063367150340",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d620",
            "leftCorner": {
              "x": 12.856,
              "y": 4.306,
              "z": 0.946
            },
            "rightCorner": {
              "x": 12.765,
              "y": 4.314,
              "z": 0.946
            },
            "gtin": "4063367150340",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d622",
            "leftCorner": {
              "x": 12.761,
              "y": 4.27,
              "z": 0.946
            },
            "rightCorner": {
              "x": 12.644,
              "y": 4.28,
              "z": 0.946
            },
            "gtin": "4008713708820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d623",
            "leftCorner": {
              "x": 12.646,
              "y": 4.296,
              "z": 0.946
            },
            "rightCorner": {
              "x": 12.501,
              "y": 4.308,
              "z": 0.946
            },
            "gtin": "4008713713145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d624",
            "leftCorner": {
              "x": 12.5,
              "y": 4.303,
              "z": 0.946
            },
            "rightCorner": {
              "x": 12.444,
              "y": 4.307,
              "z": 0.946
            },
            "gtin": "4008713713374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d625",
            "leftCorner": {
              "x": 12.444,
              "y": 4.307,
              "z": 0.946
            },
            "rightCorner": {
              "x": 12.389,
              "y": 4.312,
              "z": 0.946
            },
            "gtin": "4008713713374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d626",
            "leftCorner": {
              "x": 12.39,
              "y": 4.327,
              "z": 0.946
            },
            "rightCorner": {
              "x": 12.243,
              "y": 4.339,
              "z": 0.946
            },
            "gtin": "4008713713343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d627",
            "leftCorner": {
              "x": 12.242,
              "y": 4.316,
              "z": 0.946
            },
            "rightCorner": {
              "x": 12.172,
              "y": 4.322,
              "z": 0.946
            },
            "gtin": "4008713713237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d628",
            "leftCorner": {
              "x": 12.172,
              "y": 4.322,
              "z": 0.946
            },
            "rightCorner": {
              "x": 12.101,
              "y": 4.328,
              "z": 0.946
            },
            "gtin": "4008713713237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d629",
            "leftCorner": {
              "x": 12.101,
              "y": 4.33,
              "z": 0.946
            },
            "rightCorner": {
              "x": 11.975,
              "y": 4.341,
              "z": 0.946
            },
            "gtin": "4008713713336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d62a",
            "leftCorner": {
              "x": 11.975,
              "y": 4.345,
              "z": 0.946
            },
            "rightCorner": {
              "x": 11.842,
              "y": 4.356,
              "z": 0.946
            },
            "gtin": "4008713713350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d621",
            "leftCorner": {
              "x": 11.842,
              "y": 4.353,
              "z": 0.946
            },
            "rightCorner": {
              "x": 11.749,
              "y": 4.361,
              "z": 0.946
            },
            "gtin": "4008713713367",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461dd",
        "height": 1.7102,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d582",
            "leftCorner": {
              "x": 12.918,
              "y": 4.267,
              "z": 1.399
            },
            "rightCorner": {
              "x": 12.806,
              "y": 4.276,
              "z": 1.399
            },
            "gtin": "4036554704442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d583",
            "leftCorner": {
              "x": 12.806,
              "y": 4.276,
              "z": 1.399
            },
            "rightCorner": {
              "x": 12.662,
              "y": 4.289,
              "z": 1.399
            },
            "gtin": "4036554704466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d584",
            "leftCorner": {
              "x": 12.662,
              "y": 4.294,
              "z": 1.399
            },
            "rightCorner": {
              "x": 12.482,
              "y": 4.31,
              "z": 1.399
            },
            "gtin": "4260462986595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d585",
            "leftCorner": {
              "x": 12.481,
              "y": 4.301,
              "z": 1.399
            },
            "rightCorner": {
              "x": 12.327,
              "y": 4.314,
              "z": 1.399
            },
            "gtin": "4260462986557",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d586",
            "leftCorner": {
              "x": 12.326,
              "y": 4.311,
              "z": 1.399
            },
            "rightCorner": {
              "x": 12.139,
              "y": 4.327,
              "z": 1.399
            },
            "gtin": "4260462986496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d587",
            "leftCorner": {
              "x": 12.139,
              "y": 4.325,
              "z": 1.399
            },
            "rightCorner": {
              "x": 12.007,
              "y": 4.337,
              "z": 1.399
            },
            "gtin": "4260462980029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d588",
            "leftCorner": {
              "x": 12.008,
              "y": 4.339,
              "z": 1.399
            },
            "rightCorner": {
              "x": 11.826,
              "y": 4.354,
              "z": 1.399
            },
            "gtin": "4260462986533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d561",
            "leftCorner": {
              "x": 11.826,
              "y": 4.353,
              "z": 1.399
            },
            "rightCorner": {
              "x": 11.749,
              "y": 4.359,
              "z": 1.399
            },
            "gtin": "4008713708837",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e0262",
    "rightNeighborShelfId": "e0264"
  },
  {
    "id": "e0264",
    "name": "e0264",
    "x": 11.753,
    "y": 4.402,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99908,
      "w": 0.04287
    },

    "layers": [],
    "leftNeighborShelfId": "e0263",
    "rightNeighborShelfId": "e0265"
  },
  {
    "id": "e0265",
    "name": "e0265",
    "x": 10.558,
    "y": 4.504,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99908,
      "w": 0.04287
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 54
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5461e2",
        "height": 0.14802,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d663",
            "leftCorner": {
              "x": 10.557,
              "y": 4.493,
              "z": 0.121
            },
            "rightCorner": {
              "x": 10.368,
              "y": 4.51,
              "z": 0.121
            },
            "gtin": "4063367363368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d664",
            "leftCorner": {
              "x": 10.368,
              "y": 4.51,
              "z": 0.121
            },
            "rightCorner": {
              "x": 10.18,
              "y": 4.526,
              "z": 0.121
            },
            "gtin": "4063367363368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d666",
            "leftCorner": {
              "x": 10.176,
              "y": 4.485,
              "z": 0.121
            },
            "rightCorner": {
              "x": 10.068,
              "y": 4.495,
              "z": 0.121
            },
            "gtin": "4008713713565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d667",
            "leftCorner": {
              "x": 10.068,
              "y": 4.495,
              "z": 0.121
            },
            "rightCorner": {
              "x": 9.96,
              "y": 4.504,
              "z": 0.121
            },
            "gtin": "4008713713565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d668",
            "leftCorner": {
              "x": 9.96,
              "y": 4.504,
              "z": 0.121
            },
            "rightCorner": {
              "x": 9.853,
              "y": 4.513,
              "z": 0.121
            },
            "gtin": "4008713713565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d669",
            "leftCorner": {
              "x": 9.854,
              "y": 4.524,
              "z": 0.121
            },
            "rightCorner": {
              "x": 9.71,
              "y": 4.536,
              "z": 0.121
            },
            "gtin": "4008713712926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d66a",
            "leftCorner": {
              "x": 9.71,
              "y": 4.536,
              "z": 0.121
            },
            "rightCorner": {
              "x": 9.567,
              "y": 4.548,
              "z": 0.121
            },
            "gtin": "4008713712926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d66b",
            "leftCorner": {
              "x": 9.564,
              "y": 4.521,
              "z": 0.121
            },
            "rightCorner": {
              "x": 9.376,
              "y": 4.537,
              "z": 0.121
            },
            "gtin": "4000540031874",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461e4",
        "height": 0.49758,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d68e",
            "leftCorner": {
              "x": 10.557,
              "y": 4.495,
              "z": 0.407
            },
            "rightCorner": {
              "x": 10.429,
              "y": 4.506,
              "z": 0.407
            },
            "gtin": "4260453440211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d68f",
            "leftCorner": {
              "x": 10.429,
              "y": 4.506,
              "z": 0.407
            },
            "rightCorner": {
              "x": 10.301,
              "y": 4.517,
              "z": 0.407
            },
            "gtin": "4260453440211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d692",
            "leftCorner": {
              "x": 10.297,
              "y": 4.474,
              "z": 0.407
            },
            "rightCorner": {
              "x": 10.167,
              "y": 4.485,
              "z": 0.407
            },
            "gtin": "4260453440228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d693",
            "leftCorner": {
              "x": 10.167,
              "y": 4.482,
              "z": 0.407
            },
            "rightCorner": {
              "x": 10.006,
              "y": 4.495,
              "z": 0.407
            },
            "gtin": "4260453440365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d694",
            "leftCorner": {
              "x": 10.006,
              "y": 4.495,
              "z": 0.407
            },
            "rightCorner": {
              "x": 9.845,
              "y": 4.509,
              "z": 0.407
            },
            "gtin": "4260453440365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d695",
            "leftCorner": {
              "x": 9.846,
              "y": 4.521,
              "z": 0.407
            },
            "rightCorner": {
              "x": 9.747,
              "y": 4.529,
              "z": 0.407
            },
            "gtin": "4008713713381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d696",
            "leftCorner": {
              "x": 9.747,
              "y": 4.529,
              "z": 0.407
            },
            "rightCorner": {
              "x": 9.649,
              "y": 4.538,
              "z": 0.407
            },
            "gtin": "4008713713381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d697",
            "leftCorner": {
              "x": 9.648,
              "y": 4.535,
              "z": 0.407
            },
            "rightCorner": {
              "x": 9.605,
              "y": 4.539,
              "z": 0.407
            },
            "gtin": "4063367362774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d698",
            "leftCorner": {
              "x": 9.605,
              "y": 4.539,
              "z": 0.407
            },
            "rightCorner": {
              "x": 9.562,
              "y": 4.542,
              "z": 0.407
            },
            "gtin": "4063367362774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d699",
            "leftCorner": {
              "x": 9.562,
              "y": 4.542,
              "z": 0.407
            },
            "rightCorner": {
              "x": 9.519,
              "y": 4.546,
              "z": 0.407
            },
            "gtin": "4063367362774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d69a",
            "leftCorner": {
              "x": 9.519,
              "y": 4.545,
              "z": 0.407
            },
            "rightCorner": {
              "x": 9.434,
              "y": 4.553,
              "z": 0.407
            },
            "gtin": "4063367029615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d69b",
            "leftCorner": {
              "x": 9.434,
              "y": 4.553,
              "z": 0.407
            },
            "rightCorner": {
              "x": 9.349,
              "y": 4.56,
              "z": 0.407
            },
            "gtin": "4063367029615",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461e3",
        "height": 0.80774,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d672",
            "leftCorner": {
              "x": 10.558,
              "y": 4.501,
              "z": 0.661
            },
            "rightCorner": {
              "x": 10.311,
              "y": 4.523,
              "z": 0.661
            },
            "gtin": "4008713713459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d674",
            "leftCorner": {
              "x": 10.307,
              "y": 4.477,
              "z": 0.661
            },
            "rightCorner": {
              "x": 10.216,
              "y": 4.484,
              "z": 0.661
            },
            "gtin": "4337185931505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d675",
            "leftCorner": {
              "x": 10.216,
              "y": 4.484,
              "z": 0.661
            },
            "rightCorner": {
              "x": 10.126,
              "y": 4.492,
              "z": 0.661
            },
            "gtin": "4337185931505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d676",
            "leftCorner": {
              "x": 10.126,
              "y": 4.492,
              "z": 0.661
            },
            "rightCorner": {
              "x": 10.035,
              "y": 4.5,
              "z": 0.661
            },
            "gtin": "4337185931505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d677",
            "leftCorner": {
              "x": 10.035,
              "y": 4.5,
              "z": 0.661
            },
            "rightCorner": {
              "x": 9.944,
              "y": 4.508,
              "z": 0.661
            },
            "gtin": "4337185931505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d678",
            "leftCorner": {
              "x": 9.945,
              "y": 4.52,
              "z": 0.661
            },
            "rightCorner": {
              "x": 9.796,
              "y": 4.533,
              "z": 0.661
            },
            "gtin": "4008713712919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d679",
            "leftCorner": {
              "x": 9.796,
              "y": 4.533,
              "z": 0.661
            },
            "rightCorner": {
              "x": 9.646,
              "y": 4.545,
              "z": 0.661
            },
            "gtin": "4008713712919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d67a",
            "leftCorner": {
              "x": 9.645,
              "y": 4.537,
              "z": 0.661
            },
            "rightCorner": {
              "x": 9.494,
              "y": 4.55,
              "z": 0.661
            },
            "gtin": "4008713712988",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d67b",
            "leftCorner": {
              "x": 9.494,
              "y": 4.55,
              "z": 0.661
            },
            "rightCorner": {
              "x": 9.343,
              "y": 4.563,
              "z": 0.661
            },
            "gtin": "4008713712988",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461e1",
        "height": 1.1094,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d650",
            "leftCorner": {
              "x": 10.557,
              "y": 4.494,
              "z": 0.908
            },
            "rightCorner": {
              "x": 10.293,
              "y": 4.517,
              "z": 0.908
            },
            "gtin": "8595564521389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d651",
            "leftCorner": {
              "x": 10.293,
              "y": 4.517,
              "z": 0.908
            },
            "rightCorner": {
              "x": 10.029,
              "y": 4.539,
              "z": 0.908
            },
            "gtin": "8595564521389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d654",
            "leftCorner": {
              "x": 10.025,
              "y": 4.496,
              "z": 0.908
            },
            "rightCorner": {
              "x": 9.833,
              "y": 4.513,
              "z": 0.908
            },
            "gtin": "4337185888069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d655",
            "leftCorner": {
              "x": 9.834,
              "y": 4.514,
              "z": 0.908
            },
            "rightCorner": {
              "x": 9.543,
              "y": 4.539,
              "z": 0.908
            },
            "gtin": "8595564522645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d656",
            "leftCorner": {
              "x": 9.544,
              "y": 4.545,
              "z": 0.908
            },
            "rightCorner": {
              "x": 9.431,
              "y": 4.555,
              "z": 0.908
            },
            "gtin": "4337185898839",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d657",
            "leftCorner": {
              "x": 9.431,
              "y": 4.555,
              "z": 0.908
            },
            "rightCorner": {
              "x": 9.318,
              "y": 4.564,
              "z": 0.908
            },
            "gtin": "4337185898839",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461df",
        "height": 1.4079,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d62b",
            "leftCorner": {
              "x": 10.558,
              "y": 4.501,
              "z": 1.152
            },
            "rightCorner": {
              "x": 10.352,
              "y": 4.519,
              "z": 1.152
            },
            "gtin": "4063367231292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d62d",
            "leftCorner": {
              "x": 10.349,
              "y": 4.482,
              "z": 1.152
            },
            "rightCorner": {
              "x": 10.253,
              "y": 4.49,
              "z": 1.152
            },
            "gtin": "4008713713466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d62e",
            "leftCorner": {
              "x": 10.254,
              "y": 4.503,
              "z": 1.152
            },
            "rightCorner": {
              "x": 10.014,
              "y": 4.523,
              "z": 1.152
            },
            "gtin": "9002033130281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d62f",
            "leftCorner": {
              "x": 10.013,
              "y": 4.506,
              "z": 1.152
            },
            "rightCorner": {
              "x": 9.935,
              "y": 4.513,
              "z": 1.152
            },
            "gtin": "9002033130298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d630",
            "leftCorner": {
              "x": 9.935,
              "y": 4.513,
              "z": 1.152
            },
            "rightCorner": {
              "x": 9.857,
              "y": 4.52,
              "z": 1.152
            },
            "gtin": "9002033130298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d631",
            "leftCorner": {
              "x": 9.857,
              "y": 4.524,
              "z": 1.152
            },
            "rightCorner": {
              "x": 9.659,
              "y": 4.541,
              "z": 1.152
            },
            "gtin": "9002033130274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d632",
            "leftCorner": {
              "x": 9.659,
              "y": 4.541,
              "z": 1.152
            },
            "rightCorner": {
              "x": 9.46,
              "y": 4.558,
              "z": 1.152
            },
            "gtin": "9002033130274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d62c",
            "leftCorner": {
              "x": 9.46,
              "y": 4.56,
              "z": 1.152
            },
            "rightCorner": {
              "x": 9.359,
              "y": 4.569,
              "z": 1.152
            },
            "gtin": "4000281315516",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461e0",
        "height": 1.7075,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d633",
            "leftCorner": {
              "x": 10.558,
              "y": 4.498,
              "z": 1.397
            },
            "rightCorner": {
              "x": 10.45,
              "y": 4.507,
              "z": 1.397
            },
            "gtin": "4008713713442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d634",
            "leftCorner": {
              "x": 10.45,
              "y": 4.507,
              "z": 1.397
            },
            "rightCorner": {
              "x": 10.343,
              "y": 4.517,
              "z": 1.397
            },
            "gtin": "4008713713442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d635",
            "leftCorner": {
              "x": 10.343,
              "y": 4.517,
              "z": 1.397
            },
            "rightCorner": {
              "x": 10.236,
              "y": 4.526,
              "z": 1.397
            },
            "gtin": "4008713713442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d639",
            "leftCorner": {
              "x": 10.232,
              "y": 4.479,
              "z": 1.397
            },
            "rightCorner": {
              "x": 10.103,
              "y": 4.491,
              "z": 1.397
            },
            "gtin": "4260582961694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d63a",
            "leftCorner": {
              "x": 10.102,
              "y": 4.488,
              "z": 1.397
            },
            "rightCorner": {
              "x": 9.942,
              "y": 4.502,
              "z": 1.397
            },
            "gtin": "4337185783616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d63b",
            "leftCorner": {
              "x": 9.944,
              "y": 4.524,
              "z": 1.397
            },
            "rightCorner": {
              "x": 9.83,
              "y": 4.533,
              "z": 1.397
            },
            "gtin": "4000540010473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d63c",
            "leftCorner": {
              "x": 9.829,
              "y": 4.521,
              "z": 1.397
            },
            "rightCorner": {
              "x": 9.761,
              "y": 4.527,
              "z": 1.397
            },
            "gtin": "4000540063035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d63d",
            "leftCorner": {
              "x": 9.761,
              "y": 4.527,
              "z": 1.397
            },
            "rightCorner": {
              "x": 9.693,
              "y": 4.532,
              "z": 1.397
            },
            "gtin": "4000540063035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d63e",
            "leftCorner": {
              "x": 9.693,
              "y": 4.532,
              "z": 1.397
            },
            "rightCorner": {
              "x": 9.624,
              "y": 4.538,
              "z": 1.397
            },
            "gtin": "4000540063035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d63f",
            "leftCorner": {
              "x": 9.625,
              "y": 4.546,
              "z": 1.397
            },
            "rightCorner": {
              "x": 9.49,
              "y": 4.557,
              "z": 1.397
            },
            "gtin": "4000540003048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d640",
            "leftCorner": {
              "x": 9.49,
              "y": 4.557,
              "z": 1.397
            },
            "rightCorner": {
              "x": 9.355,
              "y": 4.569,
              "z": 1.397
            },
            "gtin": "4000540003048",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e0264",
    "rightNeighborShelfId": "e0266"
  },
  {
    "id": "e0266",
    "name": "e0266",
    "x": 9.362,
    "y": 4.607,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99908,
      "w": 0.04287
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 50
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5461ed",
        "height": 0.15073,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d66c",
            "leftCorner": {
              "x": 9.379,
              "y": 4.567,
              "z": 0.123
            },
            "rightCorner": {
              "x": 9.212,
              "y": 4.581,
              "z": 0.123
            },
            "gtin": "4000540023473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d66d",
            "leftCorner": {
              "x": 9.212,
              "y": 4.581,
              "z": 0.123
            },
            "rightCorner": {
              "x": 9.046,
              "y": 4.595,
              "z": 0.123
            },
            "gtin": "4000540023473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d66e",
            "leftCorner": {
              "x": 9.044,
              "y": 4.57,
              "z": 0.123
            },
            "rightCorner": {
              "x": 8.859,
              "y": 4.586,
              "z": 0.123
            },
            "gtin": "4000540001334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d66f",
            "leftCorner": {
              "x": 8.859,
              "y": 4.581,
              "z": 0.123
            },
            "rightCorner": {
              "x": 8.676,
              "y": 4.597,
              "z": 0.123
            },
            "gtin": "4000540023572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d670",
            "leftCorner": {
              "x": 8.676,
              "y": 4.598,
              "z": 0.123
            },
            "rightCorner": {
              "x": 8.504,
              "y": 4.612,
              "z": 0.123
            },
            "gtin": "4000540013177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d671",
            "leftCorner": {
              "x": 8.504,
              "y": 4.614,
              "z": 0.123
            },
            "rightCorner": {
              "x": 8.314,
              "y": 4.63,
              "z": 0.123
            },
            "gtin": "4000540003215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d665",
            "leftCorner": {
              "x": 8.314,
              "y": 4.634,
              "z": 0.123
            },
            "rightCorner": {
              "x": 8.161,
              "y": 4.647,
              "z": 0.123
            },
            "gtin": "4000540033878",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461ec",
        "height": 0.50631,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d69c",
            "leftCorner": {
              "x": 9.347,
              "y": 4.545,
              "z": 0.414
            },
            "rightCorner": {
              "x": 9.171,
              "y": 4.561,
              "z": 0.414
            },
            "gtin": "4000540071887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d69d",
            "leftCorner": {
              "x": 9.171,
              "y": 4.561,
              "z": 0.414
            },
            "rightCorner": {
              "x": 8.994,
              "y": 4.576,
              "z": 0.414
            },
            "gtin": "4000540071887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d69e",
            "leftCorner": {
              "x": 8.994,
              "y": 4.566,
              "z": 0.414
            },
            "rightCorner": {
              "x": 8.764,
              "y": 4.586,
              "z": 0.414
            },
            "gtin": "4000540003260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d69f",
            "leftCorner": {
              "x": 8.764,
              "y": 4.586,
              "z": 0.414
            },
            "rightCorner": {
              "x": 8.534,
              "y": 4.605,
              "z": 0.414
            },
            "gtin": "4000540003260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6a0",
            "leftCorner": {
              "x": 8.534,
              "y": 4.6,
              "z": 0.414
            },
            "rightCorner": {
              "x": 8.262,
              "y": 4.623,
              "z": 0.414
            },
            "gtin": "4000540001457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6a1",
            "leftCorner": {
              "x": 8.262,
              "y": 4.625,
              "z": 0.414
            },
            "rightCorner": {
              "x": 8.194,
              "y": 4.631,
              "z": 0.414
            },
            "gtin": "4000540003314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6a2",
            "leftCorner": {
              "x": 8.194,
              "y": 4.631,
              "z": 0.414
            },
            "rightCorner": {
              "x": 8.126,
              "y": 4.637,
              "z": 0.414
            },
            "gtin": "4000540003314",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461eb",
        "height": 0.80641,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d67c",
            "leftCorner": {
              "x": 9.342,
              "y": 4.56,
              "z": 0.66
            },
            "rightCorner": {
              "x": 9.243,
              "y": 4.568,
              "z": 0.66
            },
            "gtin": "4000540053869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d67d",
            "leftCorner": {
              "x": 9.243,
              "y": 4.568,
              "z": 0.66
            },
            "rightCorner": {
              "x": 9.144,
              "y": 4.577,
              "z": 0.66
            },
            "gtin": "4000540053869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d67e",
            "leftCorner": {
              "x": 9.143,
              "y": 4.564,
              "z": 0.66
            },
            "rightCorner": {
              "x": 8.981,
              "y": 4.578,
              "z": 0.66
            },
            "gtin": "4000540003246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d67f",
            "leftCorner": {
              "x": 8.979,
              "y": 4.561,
              "z": 0.66
            },
            "rightCorner": {
              "x": 8.864,
              "y": 4.571,
              "z": 0.66
            },
            "gtin": "4000540001341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d680",
            "leftCorner": {
              "x": 8.865,
              "y": 4.586,
              "z": 0.66
            },
            "rightCorner": {
              "x": 8.685,
              "y": 4.601,
              "z": 0.66
            },
            "gtin": "4000540023169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d681",
            "leftCorner": {
              "x": 8.686,
              "y": 4.612,
              "z": 0.66
            },
            "rightCorner": {
              "x": 8.549,
              "y": 4.624,
              "z": 0.66
            },
            "gtin": "4000540043587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d682",
            "leftCorner": {
              "x": 8.549,
              "y": 4.624,
              "z": 0.66
            },
            "rightCorner": {
              "x": 8.411,
              "y": 4.636,
              "z": 0.66
            },
            "gtin": "4000540043587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d683",
            "leftCorner": {
              "x": 8.41,
              "y": 4.617,
              "z": 0.66
            },
            "rightCorner": {
              "x": 8.319,
              "y": 4.625,
              "z": 0.66
            },
            "gtin": "4000540003222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d684",
            "leftCorner": {
              "x": 8.319,
              "y": 4.625,
              "z": 0.66
            },
            "rightCorner": {
              "x": 8.229,
              "y": 4.633,
              "z": 0.66
            },
            "gtin": "4000540003222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d685",
            "leftCorner": {
              "x": 8.228,
              "y": 4.627,
              "z": 0.66
            },
            "rightCorner": {
              "x": 8.176,
              "y": 4.632,
              "z": 0.66
            },
            "gtin": "4000540003567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d686",
            "leftCorner": {
              "x": 8.176,
              "y": 4.632,
              "z": 0.66
            },
            "rightCorner": {
              "x": 8.124,
              "y": 4.636,
              "z": 0.66
            },
            "gtin": "4000540003567",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461ef",
        "height": 1.1044,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d658",
            "leftCorner": {
              "x": 9.318,
              "y": 4.567,
              "z": 0.904
            },
            "rightCorner": {
              "x": 9.163,
              "y": 4.581,
              "z": 0.904
            },
            "gtin": "4000540003468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d659",
            "leftCorner": {
              "x": 9.162,
              "y": 4.565,
              "z": 0.904
            },
            "rightCorner": {
              "x": 9.001,
              "y": 4.578,
              "z": 0.904
            },
            "gtin": "4000540011364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d65a",
            "leftCorner": {
              "x": 9.0,
              "y": 4.571,
              "z": 0.904
            },
            "rightCorner": {
              "x": 8.815,
              "y": 4.587,
              "z": 0.904
            },
            "gtin": "4000540023206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d65b",
            "leftCorner": {
              "x": 8.815,
              "y": 4.585,
              "z": 0.904
            },
            "rightCorner": {
              "x": 8.536,
              "y": 4.609,
              "z": 0.904
            },
            "gtin": "4000540013764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d65c",
            "leftCorner": {
              "x": 8.536,
              "y": 4.614,
              "z": 0.904
            },
            "rightCorner": {
              "x": 8.397,
              "y": 4.626,
              "z": 0.904
            },
            "gtin": "4000540001501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d65d",
            "leftCorner": {
              "x": 8.396,
              "y": 4.619,
              "z": 0.904
            },
            "rightCorner": {
              "x": 8.198,
              "y": 4.636,
              "z": 0.904
            },
            "gtin": "4000540011517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d65e",
            "leftCorner": {
              "x": 8.199,
              "y": 4.642,
              "z": 0.904
            },
            "rightCorner": {
              "x": 8.096,
              "y": 4.651,
              "z": 0.904
            },
            "gtin": "4000540003420",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461ee",
        "height": 1.418,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d71f",
            "leftCorner": {
              "x": 8.976,
              "y": 4.568,
              "z": 1.16
            },
            "rightCorner": {
              "x": 8.688,
              "y": 4.593,
              "z": 1.16
            },
            "gtin": "4000540001549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d719",
            "leftCorner": {
              "x": 9.36,
              "y": 4.581,
              "z": 1.16
            },
            "rightCorner": {
              "x": 9.275,
              "y": 4.588,
              "z": 1.16
            },
            "gtin": "4000540003956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d71a",
            "leftCorner": {
              "x": 9.275,
              "y": 4.588,
              "z": 1.16
            },
            "rightCorner": {
              "x": 9.189,
              "y": 4.596,
              "z": 1.16
            },
            "gtin": "4000540003956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d71e",
            "leftCorner": {
              "x": 9.186,
              "y": 4.564,
              "z": 1.16
            },
            "rightCorner": {
              "x": 8.978,
              "y": 4.581,
              "z": 1.16
            },
            "gtin": "4000540003147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d720",
            "leftCorner": {
              "x": 8.689,
              "y": 4.601,
              "z": 1.16
            },
            "rightCorner": {
              "x": 8.55,
              "y": 4.613,
              "z": 1.16
            },
            "gtin": "4000540003192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d721",
            "leftCorner": {
              "x": 8.549,
              "y": 4.604,
              "z": 1.16
            },
            "rightCorner": {
              "x": 8.383,
              "y": 4.618,
              "z": 1.16
            },
            "gtin": "4000540003185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d722",
            "leftCorner": {
              "x": 8.383,
              "y": 4.618,
              "z": 1.16
            },
            "rightCorner": {
              "x": 8.217,
              "y": 4.632,
              "z": 1.16
            },
            "gtin": "4000540003185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d723",
            "leftCorner": {
              "x": 8.218,
              "y": 4.634,
              "z": 1.16
            },
            "rightCorner": {
              "x": 8.158,
              "y": 4.639,
              "z": 1.16
            },
            "gtin": "4000540003130",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461ea",
        "height": 1.7067,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d641",
            "leftCorner": {
              "x": 9.353,
              "y": 4.548,
              "z": 1.396
            },
            "rightCorner": {
              "x": 9.244,
              "y": 4.557,
              "z": 1.396
            },
            "gtin": "4000540091069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d642",
            "leftCorner": {
              "x": 9.244,
              "y": 4.557,
              "z": 1.396
            },
            "rightCorner": {
              "x": 9.135,
              "y": 4.567,
              "z": 1.396
            },
            "gtin": "4000540091069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d643",
            "leftCorner": {
              "x": 9.135,
              "y": 4.567,
              "z": 1.396
            },
            "rightCorner": {
              "x": 9.026,
              "y": 4.576,
              "z": 1.396
            },
            "gtin": "4000540091069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d644",
            "leftCorner": {
              "x": 9.026,
              "y": 4.574,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.837,
              "y": 4.59,
              "z": 1.396
            },
            "gtin": "4000540051018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d645",
            "leftCorner": {
              "x": 8.837,
              "y": 4.584,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.719,
              "y": 4.594,
              "z": 1.396
            },
            "gtin": "4000540011050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d646",
            "leftCorner": {
              "x": 8.719,
              "y": 4.594,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.601,
              "y": 4.604,
              "z": 1.396
            },
            "gtin": "4000540011050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d647",
            "leftCorner": {
              "x": 8.601,
              "y": 4.6,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.403,
              "y": 4.616,
              "z": 1.396
            },
            "gtin": "4000540011081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d648",
            "leftCorner": {
              "x": 8.403,
              "y": 4.616,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.205,
              "y": 4.634,
              "z": 1.396
            },
            "gtin": "4000540011081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d649",
            "leftCorner": {
              "x": 8.206,
              "y": 4.636,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.154,
              "y": 4.641,
              "z": 1.396
            },
            "gtin": "4000540001204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d64a",
            "leftCorner": {
              "x": 8.154,
              "y": 4.641,
              "z": 1.396
            },
            "rightCorner": {
              "x": 8.102,
              "y": 4.645,
              "z": 1.396
            },
            "gtin": "4000540001204",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e0265",
    "rightNeighborShelfId": "e0267"
  },
  {
    "id": "e0267",
    "name": "e0267",
    "x": 8.166,
    "y": 4.71,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99908,
      "w": 0.04287
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 42
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5461f7",
        "height": 0.16079,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d766",
            "leftCorner": {
              "x": 8.165,
              "y": 4.702,
              "z": 0.132
            },
            "rightCorner": {
              "x": 7.966,
              "y": 4.719,
              "z": 0.132
            },
            "gtin": "4000540001563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d768",
            "leftCorner": {
              "x": 7.962,
              "y": 4.678,
              "z": 0.132
            },
            "rightCorner": {
              "x": 7.726,
              "y": 4.699,
              "z": 0.132
            },
            "gtin": "4000521013523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d769",
            "leftCorner": {
              "x": 7.726,
              "y": 4.699,
              "z": 0.132
            },
            "rightCorner": {
              "x": 7.49,
              "y": 4.719,
              "z": 0.132
            },
            "gtin": "4000521013523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d76a",
            "leftCorner": {
              "x": 7.49,
              "y": 4.719,
              "z": 0.132
            },
            "rightCorner": {
              "x": 7.314,
              "y": 4.734,
              "z": 0.132
            },
            "gtin": "4000521664305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d767",
            "leftCorner": {
              "x": 7.316,
              "y": 4.759,
              "z": 0.132
            },
            "rightCorner": {
              "x": 6.968,
              "y": 4.789,
              "z": 0.132
            },
            "gtin": "4000521664107",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461f6",
        "height": 0.50832,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d6a3",
            "leftCorner": {
              "x": 8.129,
              "y": 4.677,
              "z": 0.416
            },
            "rightCorner": {
              "x": 7.999,
              "y": 4.689,
              "z": 0.416
            },
            "gtin": "4000521004606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6a4",
            "leftCorner": {
              "x": 7.998,
              "y": 4.676,
              "z": 0.416
            },
            "rightCorner": {
              "x": 7.872,
              "y": 4.687,
              "z": 0.416
            },
            "gtin": "4000521021870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6a5",
            "leftCorner": {
              "x": 7.872,
              "y": 4.684,
              "z": 0.416
            },
            "rightCorner": {
              "x": 7.677,
              "y": 4.701,
              "z": 0.416
            },
            "gtin": "4000521661908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6a6",
            "leftCorner": {
              "x": 7.677,
              "y": 4.699,
              "z": 0.416
            },
            "rightCorner": {
              "x": 7.573,
              "y": 4.708,
              "z": 0.416
            },
            "gtin": "4000521008871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d6a7",
            "leftCorner": {
              "x": 7.573,
              "y": 4.708,
              "z": 0.416
            },
            "rightCorner": {
              "x": 7.47,
              "y": 4.717,
              "z": 0.416
            },
            "gtin": "4000521008871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d690",
            "leftCorner": {
              "x": 7.471,
              "y": 4.733,
              "z": 0.416
            },
            "rightCorner": {
              "x": 7.219,
              "y": 4.755,
              "z": 0.416
            },
            "gtin": "4000521040680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d691",
            "leftCorner": {
              "x": 7.219,
              "y": 4.755,
              "z": 0.416
            },
            "rightCorner": {
              "x": 6.967,
              "y": 4.776,
              "z": 0.416
            },
            "gtin": "4000521040680",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461f5",
        "height": 0.80682,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d687",
            "leftCorner": {
              "x": 8.128,
              "y": 4.681,
              "z": 0.66
            },
            "rightCorner": {
              "x": 8.006,
              "y": 4.692,
              "z": 0.66
            },
            "gtin": "4000521661700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d688",
            "leftCorner": {
              "x": 8.006,
              "y": 4.692,
              "z": 0.66
            },
            "rightCorner": {
              "x": 7.883,
              "y": 4.702,
              "z": 0.66
            },
            "gtin": "4000521661700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d689",
            "leftCorner": {
              "x": 7.884,
              "y": 4.708,
              "z": 0.66
            },
            "rightCorner": {
              "x": 7.723,
              "y": 4.721,
              "z": 0.66
            },
            "gtin": "4000521661304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d68a",
            "leftCorner": {
              "x": 7.722,
              "y": 4.716,
              "z": 0.66
            },
            "rightCorner": {
              "x": 7.613,
              "y": 4.726,
              "z": 0.66
            },
            "gtin": "4000521040567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d68b",
            "leftCorner": {
              "x": 7.613,
              "y": 4.719,
              "z": 0.66
            },
            "rightCorner": {
              "x": 7.507,
              "y": 4.729,
              "z": 0.66
            },
            "gtin": "4000521040727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d68c",
            "leftCorner": {
              "x": 7.507,
              "y": 4.733,
              "z": 0.66
            },
            "rightCorner": {
              "x": 7.265,
              "y": 4.754,
              "z": 0.66
            },
            "gtin": "4000521040864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d68d",
            "leftCorner": {
              "x": 7.265,
              "y": 4.751,
              "z": 0.66
            },
            "rightCorner": {
              "x": 7.036,
              "y": 4.771,
              "z": 0.66
            },
            "gtin": "4000521039080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d673",
            "leftCorner": {
              "x": 7.027,
              "y": 4.661,
              "z": 0.66
            },
            "rightCorner": {
              "x": 6.958,
              "y": 4.667,
              "z": 0.66
            },
            "gtin": "4000521039127",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461f9",
        "height": 1.1038,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d65f",
            "leftCorner": {
              "x": 8.098,
              "y": 4.683,
              "z": 0.903
            },
            "rightCorner": {
              "x": 7.957,
              "y": 4.695,
              "z": 0.903
            },
            "gtin": "4000521012861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d660",
            "leftCorner": {
              "x": 7.958,
              "y": 4.699,
              "z": 0.903
            },
            "rightCorner": {
              "x": 7.787,
              "y": 4.714,
              "z": 0.903
            },
            "gtin": "4000521021917",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c845ed67a01d9a1d661",
            "leftCorner": {
              "x": 7.786,
              "y": 4.709,
              "z": 0.903
            },
            "rightCorner": {
              "x": 7.591,
              "y": 4.726,
              "z": 0.903
            },
            "gtin": "4000521040581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d662",
            "leftCorner": {
              "x": 7.591,
              "y": 4.725,
              "z": 0.903
            },
            "rightCorner": {
              "x": 7.506,
              "y": 4.732,
              "z": 0.903
            },
            "gtin": "4000521041991",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c845ed67a01d9a1d652",
            "leftCorner": {
              "x": 7.507,
              "y": 4.742,
              "z": 0.903
            },
            "rightCorner": {
              "x": 7.238,
              "y": 4.765,
              "z": 0.903
            },
            "gtin": "4000521021894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d653",
            "leftCorner": {
              "x": 7.238,
              "y": 4.765,
              "z": 0.903
            },
            "rightCorner": {
              "x": 6.968,
              "y": 4.788,
              "z": 0.903
            },
            "gtin": "4000521021894",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461f8",
        "height": 1.419,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d724",
            "leftCorner": {
              "x": 8.16,
              "y": 4.676,
              "z": 1.161
            },
            "rightCorner": {
              "x": 8.027,
              "y": 4.687,
              "z": 1.161
            },
            "gtin": "4000521031312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d725",
            "leftCorner": {
              "x": 8.026,
              "y": 4.683,
              "z": 1.161
            },
            "rightCorner": {
              "x": 7.957,
              "y": 4.689,
              "z": 1.161
            },
            "gtin": "4000521031299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d726",
            "leftCorner": {
              "x": 7.957,
              "y": 4.689,
              "z": 1.161
            },
            "rightCorner": {
              "x": 7.889,
              "y": 4.695,
              "z": 1.161
            },
            "gtin": "4000521031299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d727",
            "leftCorner": {
              "x": 7.89,
              "y": 4.711,
              "z": 1.161
            },
            "rightCorner": {
              "x": 7.8,
              "y": 4.719,
              "z": 1.161
            },
            "gtin": "4000521040642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d728",
            "leftCorner": {
              "x": 7.8,
              "y": 4.719,
              "z": 1.161
            },
            "rightCorner": {
              "x": 7.71,
              "y": 4.726,
              "z": 1.161
            },
            "gtin": "4000521040642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d729",
            "leftCorner": {
              "x": 7.709,
              "y": 4.716,
              "z": 1.161
            },
            "rightCorner": {
              "x": 7.599,
              "y": 4.725,
              "z": 1.161
            },
            "gtin": "4000521040666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d72a",
            "leftCorner": {
              "x": 7.599,
              "y": 4.728,
              "z": 1.161
            },
            "rightCorner": {
              "x": 7.458,
              "y": 4.74,
              "z": 1.161
            },
            "gtin": "4000521004569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d71b",
            "leftCorner": {
              "x": 7.457,
              "y": 4.728,
              "z": 1.161
            },
            "rightCorner": {
              "x": 7.294,
              "y": 4.743,
              "z": 1.161
            },
            "gtin": "4000521031152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d71c",
            "leftCorner": {
              "x": 7.294,
              "y": 4.743,
              "z": 1.161
            },
            "rightCorner": {
              "x": 7.13,
              "y": 4.757,
              "z": 1.161
            },
            "gtin": "4000521031152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d71d",
            "leftCorner": {
              "x": 7.13,
              "y": 4.757,
              "z": 1.161
            },
            "rightCorner": {
              "x": 6.967,
              "y": 4.771,
              "z": 1.161
            },
            "gtin": "4000521031152",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5461fa",
        "height": 1.7135,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d64b",
            "leftCorner": {
              "x": 8.104,
              "y": 4.68,
              "z": 1.402
            },
            "rightCorner": {
              "x": 8.014,
              "y": 4.688,
              "z": 1.402
            },
            "gtin": "4000521662103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d64c",
            "leftCorner": {
              "x": 8.015,
              "y": 4.696,
              "z": 1.402
            },
            "rightCorner": {
              "x": 7.826,
              "y": 4.712,
              "z": 1.402
            },
            "gtin": "4000521041977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d64d",
            "leftCorner": {
              "x": 7.826,
              "y": 4.705,
              "z": 1.402
            },
            "rightCorner": {
              "x": 7.719,
              "y": 4.714,
              "z": 1.402
            },
            "gtin": "4000521004620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d64e",
            "leftCorner": {
              "x": 7.719,
              "y": 4.716,
              "z": 1.402
            },
            "rightCorner": {
              "x": 7.614,
              "y": 4.725,
              "z": 1.402
            },
            "gtin": "4000521017118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d64f",
            "leftCorner": {
              "x": 7.615,
              "y": 4.73,
              "z": 1.402
            },
            "rightCorner": {
              "x": 7.455,
              "y": 4.744,
              "z": 1.402
            },
            "gtin": "4000521040628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d636",
            "leftCorner": {
              "x": 7.454,
              "y": 4.742,
              "z": 1.402
            },
            "rightCorner": {
              "x": 7.292,
              "y": 4.756,
              "z": 1.402
            },
            "gtin": "4000521010423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d637",
            "leftCorner": {
              "x": 7.292,
              "y": 4.756,
              "z": 1.402
            },
            "rightCorner": {
              "x": 7.13,
              "y": 4.77,
              "z": 1.402
            },
            "gtin": "4000521010423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d638",
            "leftCorner": {
              "x": 7.13,
              "y": 4.77,
              "z": 1.402
            },
            "rightCorner": {
              "x": 6.968,
              "y": 4.784,
              "z": 1.402
            },
            "gtin": "4000521010423",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e0266"
  },
  {
    "id": "e0268",
    "name": "e0268",
    "x": 8.101,
    "y": 6.854,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.026168,
      "w": 0.99966
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 40
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a54622b",
        "height": 0.14798,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a546229",
        "height": 0.60525,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d90a",
            "leftCorner": {
              "x": 8.083,
              "y": 6.915,
              "z": 0.495
            },
            "rightCorner": {
              "x": 8.444,
              "y": 6.896,
              "z": 0.495
            },
            "gtin": "4300175167734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d904",
            "leftCorner": {
              "x": 8.102,
              "y": 6.874,
              "z": 0.495
            },
            "rightCorner": {
              "x": 8.691,
              "y": 6.843,
              "z": 0.495
            },
            "gtin": "4063367377228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d90b",
            "leftCorner": {
              "x": 8.444,
              "y": 6.896,
              "z": 0.495
            },
            "rightCorner": {
              "x": 8.804,
              "y": 6.878,
              "z": 0.495
            },
            "gtin": "4300175167734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d905",
            "leftCorner": {
              "x": 8.691,
              "y": 6.843,
              "z": 0.495
            },
            "rightCorner": {
              "x": 9.279,
              "y": 6.812,
              "z": 0.495
            },
            "gtin": "4063367377228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d90c",
            "leftCorner": {
              "x": 8.804,
              "y": 6.879,
              "z": 0.495
            },
            "rightCorner": {
              "x": 8.969,
              "y": 6.871,
              "z": 0.495
            },
            "gtin": "4063367377228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d90d",
            "leftCorner": {
              "x": 8.969,
              "y": 6.871,
              "z": 0.495
            },
            "rightCorner": {
              "x": 9.134,
              "y": 6.862,
              "z": 0.495
            },
            "gtin": "4063367377228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d90e",
            "leftCorner": {
              "x": 9.134,
              "y": 6.862,
              "z": 0.495
            },
            "rightCorner": {
              "x": 9.299,
              "y": 6.853,
              "z": 0.495
            },
            "gtin": "4063367377228",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546228",
        "height": 0.84997,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d916",
            "leftCorner": {
              "x": 8.102,
              "y": 6.867,
              "z": 0.695
            },
            "rightCorner": {
              "x": 8.396,
              "y": 6.851,
              "z": 0.695
            },
            "gtin": "4032600004337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d917",
            "leftCorner": {
              "x": 8.396,
              "y": 6.851,
              "z": 0.695
            },
            "rightCorner": {
              "x": 8.69,
              "y": 6.836,
              "z": 0.695
            },
            "gtin": "4032600004337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d918",
            "leftCorner": {
              "x": 8.69,
              "y": 6.836,
              "z": 0.695
            },
            "rightCorner": {
              "x": 8.984,
              "y": 6.82,
              "z": 0.695
            },
            "gtin": "4032600004337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d919",
            "leftCorner": {
              "x": 8.984,
              "y": 6.82,
              "z": 0.695
            },
            "rightCorner": {
              "x": 9.278,
              "y": 6.805,
              "z": 0.695
            },
            "gtin": "4032600004337",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546227",
        "height": 1.0991,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d91f",
            "leftCorner": {
              "x": 8.102,
              "y": 6.868,
              "z": 0.899
            },
            "rightCorner": {
              "x": 8.335,
              "y": 6.856,
              "z": 0.899
            },
            "gtin": "4032600134324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d920",
            "leftCorner": {
              "x": 8.335,
              "y": 6.856,
              "z": 0.899
            },
            "rightCorner": {
              "x": 8.568,
              "y": 6.843,
              "z": 0.899
            },
            "gtin": "4032600134324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d921",
            "leftCorner": {
              "x": 8.568,
              "y": 6.843,
              "z": 0.899
            },
            "rightCorner": {
              "x": 8.801,
              "y": 6.831,
              "z": 0.899
            },
            "gtin": "4032600134324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d922",
            "leftCorner": {
              "x": 8.801,
              "y": 6.831,
              "z": 0.899
            },
            "rightCorner": {
              "x": 9.034,
              "y": 6.819,
              "z": 0.899
            },
            "gtin": "4032600134324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d923",
            "leftCorner": {
              "x": 9.034,
              "y": 6.819,
              "z": 0.899
            },
            "rightCorner": {
              "x": 9.268,
              "y": 6.807,
              "z": 0.899
            },
            "gtin": "4032600134324",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a54622a",
        "height": 1.4104,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d8f2",
            "leftCorner": {
              "x": 8.102,
              "y": 6.866,
              "z": 1.154
            },
            "rightCorner": {
              "x": 8.189,
              "y": 6.861,
              "z": 1.154
            },
            "gtin": "4012448397129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8f3",
            "leftCorner": {
              "x": 8.189,
              "y": 6.861,
              "z": 1.154
            },
            "rightCorner": {
              "x": 8.276,
              "y": 6.857,
              "z": 1.154
            },
            "gtin": "4012448397129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8f6",
            "leftCorner": {
              "x": 8.278,
              "y": 6.893,
              "z": 1.154
            },
            "rightCorner": {
              "x": 8.386,
              "y": 6.888,
              "z": 1.154
            },
            "gtin": "4012448396900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8f7",
            "leftCorner": {
              "x": 8.386,
              "y": 6.892,
              "z": 1.154
            },
            "rightCorner": {
              "x": 8.523,
              "y": 6.885,
              "z": 1.154
            },
            "gtin": "4012448396924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8f8",
            "leftCorner": {
              "x": 8.523,
              "y": 6.885,
              "z": 1.154
            },
            "rightCorner": {
              "x": 8.659,
              "y": 6.878,
              "z": 1.154
            },
            "gtin": "4012448396924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8f9",
            "leftCorner": {
              "x": 8.659,
              "y": 6.878,
              "z": 1.154
            },
            "rightCorner": {
              "x": 8.795,
              "y": 6.871,
              "z": 1.154
            },
            "gtin": "4012448396924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8fa",
            "leftCorner": {
              "x": 8.795,
              "y": 6.865,
              "z": 1.154
            },
            "rightCorner": {
              "x": 8.94,
              "y": 6.857,
              "z": 1.154
            },
            "gtin": "4012448396948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8fb",
            "leftCorner": {
              "x": 8.94,
              "y": 6.857,
              "z": 1.154
            },
            "rightCorner": {
              "x": 9.085,
              "y": 6.85,
              "z": 1.154
            },
            "gtin": "4012448396948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8fc",
            "leftCorner": {
              "x": 9.085,
              "y": 6.853,
              "z": 1.154
            },
            "rightCorner": {
              "x": 9.174,
              "y": 6.848,
              "z": 1.154
            },
            "gtin": "4012448396986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8fd",
            "leftCorner": {
              "x": 9.174,
              "y": 6.848,
              "z": 1.154
            },
            "rightCorner": {
              "x": 9.263,
              "y": 6.844,
              "z": 1.154
            },
            "gtin": "4012448396986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8fe",
            "leftCorner": {
              "x": 9.263,
              "y": 6.844,
              "z": 1.154
            },
            "rightCorner": {
              "x": 9.352,
              "y": 6.839,
              "z": 1.154
            },
            "gtin": "4012448396986",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546226",
        "height": 1.7109,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d83f",
            "leftCorner": {
              "x": 9.228,
              "y": 6.853,
              "z": 1.4
            },
            "rightCorner": {
              "x": 9.331,
              "y": 6.847,
              "z": 1.4
            },
            "gtin": "4012448397044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d833",
            "leftCorner": {
              "x": 8.096,
              "y": 6.912,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.187,
              "y": 6.907,
              "z": 1.4
            },
            "gtin": "4000400121868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d834",
            "leftCorner": {
              "x": 8.187,
              "y": 6.907,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.279,
              "y": 6.903,
              "z": 1.4
            },
            "gtin": "4000400121868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d835",
            "leftCorner": {
              "x": 8.278,
              "y": 6.896,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.371,
              "y": 6.892,
              "z": 1.4
            },
            "gtin": "4000400162397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d836",
            "leftCorner": {
              "x": 8.371,
              "y": 6.892,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.463,
              "y": 6.887,
              "z": 1.4
            },
            "gtin": "4000400162397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d837",
            "leftCorner": {
              "x": 8.463,
              "y": 6.889,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.558,
              "y": 6.884,
              "z": 1.4
            },
            "gtin": "4032600123014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d838",
            "leftCorner": {
              "x": 8.558,
              "y": 6.884,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.654,
              "y": 6.879,
              "z": 1.4
            },
            "gtin": "4032600123014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d839",
            "leftCorner": {
              "x": 8.654,
              "y": 6.879,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.749,
              "y": 6.874,
              "z": 1.4
            },
            "gtin": "4032600123014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d83a",
            "leftCorner": {
              "x": 8.749,
              "y": 6.874,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.844,
              "y": 6.869,
              "z": 1.4
            },
            "gtin": "4032600123014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d83b",
            "leftCorner": {
              "x": 8.844,
              "y": 6.864,
              "z": 1.4
            },
            "rightCorner": {
              "x": 8.937,
              "y": 6.859,
              "z": 1.4
            },
            "gtin": "4032600123038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d83c",
            "leftCorner": {
              "x": 8.937,
              "y": 6.859,
              "z": 1.4
            },
            "rightCorner": {
              "x": 9.031,
              "y": 6.854,
              "z": 1.4
            },
            "gtin": "4032600123038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d83d",
            "leftCorner": {
              "x": 9.031,
              "y": 6.854,
              "z": 1.4
            },
            "rightCorner": {
              "x": 9.125,
              "y": 6.85,
              "z": 1.4
            },
            "gtin": "4032600123038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d83e",
            "leftCorner": {
              "x": 9.125,
              "y": 6.858,
              "z": 1.4
            },
            "rightCorner": {
              "x": 9.228,
              "y": 6.853,
              "z": 1.4
            },
            "gtin": "4012448397044",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "dde6e",
    "rightNeighborShelfId": "e0269"
  },
  {
    "id": "e0269",
    "name": "e0269",
    "x": 9.307,
    "y": 6.776,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.040786,
      "w": 0.99917
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 42
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546206",
        "height": 0.15261,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d8e6",
            "leftCorner": {
              "x": 9.654,
              "y": 6.802,
              "z": 0.125
            },
            "rightCorner": {
              "x": 10.156,
              "y": 6.761,
              "z": 0.125
            },
            "gtin": "4337185665479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8e7",
            "leftCorner": {
              "x": 10.156,
              "y": 6.761,
              "z": 0.125
            },
            "rightCorner": {
              "x": 10.657,
              "y": 6.72,
              "z": 0.125
            },
            "gtin": "4337185665479",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546203",
        "height": 0.60337,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d90f",
            "leftCorner": {
              "x": 9.308,
              "y": 6.831,
              "z": 0.494
            },
            "rightCorner": {
              "x": 9.451,
              "y": 6.819,
              "z": 0.494
            },
            "gtin": "4000400130693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d910",
            "leftCorner": {
              "x": 9.451,
              "y": 6.819,
              "z": 0.494
            },
            "rightCorner": {
              "x": 9.594,
              "y": 6.808,
              "z": 0.494
            },
            "gtin": "4000400130693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d911",
            "leftCorner": {
              "x": 9.594,
              "y": 6.81,
              "z": 0.494
            },
            "rightCorner": {
              "x": 9.74,
              "y": 6.798,
              "z": 0.494
            },
            "gtin": "8712566434084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d912",
            "leftCorner": {
              "x": 9.74,
              "y": 6.798,
              "z": 0.494
            },
            "rightCorner": {
              "x": 9.885,
              "y": 6.786,
              "z": 0.494
            },
            "gtin": "8712566434084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d913",
            "leftCorner": {
              "x": 9.885,
              "y": 6.79,
              "z": 0.494
            },
            "rightCorner": {
              "x": 9.996,
              "y": 6.781,
              "z": 0.494
            },
            "gtin": "4000400124968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d914",
            "leftCorner": {
              "x": 9.996,
              "y": 6.781,
              "z": 0.494
            },
            "rightCorner": {
              "x": 10.108,
              "y": 6.772,
              "z": 0.494
            },
            "gtin": "4000400124968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d915",
            "leftCorner": {
              "x": 10.108,
              "y": 6.772,
              "z": 0.494
            },
            "rightCorner": {
              "x": 10.218,
              "y": 6.763,
              "z": 0.494
            },
            "gtin": "4000400124968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d906",
            "leftCorner": {
              "x": 10.219,
              "y": 6.774,
              "z": 0.494
            },
            "rightCorner": {
              "x": 10.292,
              "y": 6.768,
              "z": 0.494
            },
            "gtin": "4032600122086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d907",
            "leftCorner": {
              "x": 10.292,
              "y": 6.768,
              "z": 0.494
            },
            "rightCorner": {
              "x": 10.364,
              "y": 6.762,
              "z": 0.494
            },
            "gtin": "4032600122086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d908",
            "leftCorner": {
              "x": 10.364,
              "y": 6.762,
              "z": 0.494
            },
            "rightCorner": {
              "x": 10.436,
              "y": 6.756,
              "z": 0.494
            },
            "gtin": "4032600122086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d909",
            "leftCorner": {
              "x": 10.436,
              "y": 6.756,
              "z": 0.494
            },
            "rightCorner": {
              "x": 10.509,
              "y": 6.75,
              "z": 0.494
            },
            "gtin": "4032600122086",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546204",
        "height": 0.85498,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d91d",
            "leftCorner": {
              "x": 9.321,
              "y": 6.808,
              "z": 0.7
            },
            "rightCorner": {
              "x": 9.691,
              "y": 6.778,
              "z": 0.7
            },
            "gtin": "4032600122055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d91e",
            "leftCorner": {
              "x": 9.691,
              "y": 6.778,
              "z": 0.7
            },
            "rightCorner": {
              "x": 10.061,
              "y": 6.748,
              "z": 0.7
            },
            "gtin": "4032600122055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d91a",
            "leftCorner": {
              "x": 10.062,
              "y": 6.765,
              "z": 0.7
            },
            "rightCorner": {
              "x": 10.211,
              "y": 6.753,
              "z": 0.7
            },
            "gtin": "4032600122185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d91b",
            "leftCorner": {
              "x": 10.211,
              "y": 6.753,
              "z": 0.7
            },
            "rightCorner": {
              "x": 10.359,
              "y": 6.741,
              "z": 0.7
            },
            "gtin": "4032600122185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d91c",
            "leftCorner": {
              "x": 10.359,
              "y": 6.741,
              "z": 0.7
            },
            "rightCorner": {
              "x": 10.508,
              "y": 6.729,
              "z": 0.7
            },
            "gtin": "4032600122185",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546205",
        "height": 1.1054,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d926",
            "leftCorner": {
              "x": 9.321,
              "y": 6.817,
              "z": 0.904
            },
            "rightCorner": {
              "x": 9.454,
              "y": 6.806,
              "z": 0.904
            },
            "gtin": "4099137108914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d927",
            "leftCorner": {
              "x": 9.454,
              "y": 6.805,
              "z": 0.904
            },
            "rightCorner": {
              "x": 9.863,
              "y": 6.772,
              "z": 0.904
            },
            "gtin": "4012448396887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d928",
            "leftCorner": {
              "x": 9.864,
              "y": 6.784,
              "z": 0.904
            },
            "rightCorner": {
              "x": 10.103,
              "y": 6.764,
              "z": 0.904
            },
            "gtin": "4012448396825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d924",
            "leftCorner": {
              "x": 10.103,
              "y": 6.77,
              "z": 0.904
            },
            "rightCorner": {
              "x": 10.306,
              "y": 6.753,
              "z": 0.904
            },
            "gtin": "4012448396849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d925",
            "leftCorner": {
              "x": 10.306,
              "y": 6.753,
              "z": 0.904
            },
            "rightCorner": {
              "x": 10.508,
              "y": 6.737,
              "z": 0.904
            },
            "gtin": "4012448396849",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546201",
        "height": 1.4128,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d8ff",
            "leftCorner": {
              "x": 9.36,
              "y": 6.815,
              "z": 1.156
            },
            "rightCorner": {
              "x": 9.46,
              "y": 6.807,
              "z": 1.156
            },
            "gtin": "8008698004586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d900",
            "leftCorner": {
              "x": 9.46,
              "y": 6.807,
              "z": 1.156
            },
            "rightCorner": {
              "x": 9.559,
              "y": 6.798,
              "z": 1.156
            },
            "gtin": "8008698004586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d901",
            "leftCorner": {
              "x": 9.559,
              "y": 6.798,
              "z": 1.156
            },
            "rightCorner": {
              "x": 9.659,
              "y": 6.79,
              "z": 1.156
            },
            "gtin": "8008698004586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d902",
            "leftCorner": {
              "x": 9.66,
              "y": 6.802,
              "z": 1.156
            },
            "rightCorner": {
              "x": 9.805,
              "y": 6.79,
              "z": 1.156
            },
            "gtin": "4337185380594",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d903",
            "leftCorner": {
              "x": 9.805,
              "y": 6.79,
              "z": 1.156
            },
            "rightCorner": {
              "x": 9.95,
              "y": 6.778,
              "z": 1.156
            },
            "gtin": "4337185380594",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8f4",
            "leftCorner": {
              "x": 9.95,
              "y": 6.778,
              "z": 1.156
            },
            "rightCorner": {
              "x": 10.229,
              "y": 6.755,
              "z": 1.156
            },
            "gtin": "4063367379499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d8f5",
            "leftCorner": {
              "x": 10.229,
              "y": 6.755,
              "z": 1.156
            },
            "rightCorner": {
              "x": 10.508,
              "y": 6.733,
              "z": 1.156
            },
            "gtin": "4063367379499",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546202",
        "height": 1.7131,
        "facings": [
          {
            "id": "68300c845ed67a01d9a1d840",
            "leftCorner": {
              "x": 9.339,
              "y": 6.814,
              "z": 1.402
            },
            "rightCorner": {
              "x": 9.469,
              "y": 6.803,
              "z": 1.402
            },
            "gtin": "4007951002721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d841",
            "leftCorner": {
              "x": 9.469,
              "y": 6.803,
              "z": 1.402
            },
            "rightCorner": {
              "x": 9.598,
              "y": 6.793,
              "z": 1.402
            },
            "gtin": "4007951002721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d842",
            "leftCorner": {
              "x": 9.598,
              "y": 6.793,
              "z": 1.402
            },
            "rightCorner": {
              "x": 9.728,
              "y": 6.782,
              "z": 1.402
            },
            "gtin": "4007951002721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d843",
            "leftCorner": {
              "x": 9.729,
              "y": 6.794,
              "z": 1.402
            },
            "rightCorner": {
              "x": 9.788,
              "y": 6.789,
              "z": 1.402
            },
            "gtin": "4007951002707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d844",
            "leftCorner": {
              "x": 9.788,
              "y": 6.789,
              "z": 1.402
            },
            "rightCorner": {
              "x": 9.848,
              "y": 6.785,
              "z": 1.402
            },
            "gtin": "4007951002707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d845",
            "leftCorner": {
              "x": 9.848,
              "y": 6.785,
              "z": 1.402
            },
            "rightCorner": {
              "x": 9.907,
              "y": 6.78,
              "z": 1.402
            },
            "gtin": "4007951002707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d846",
            "leftCorner": {
              "x": 9.907,
              "y": 6.781,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.134,
              "y": 6.762,
              "z": 1.402
            },
            "gtin": "4007951002660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d847",
            "leftCorner": {
              "x": 10.134,
              "y": 6.765,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.178,
              "y": 6.761,
              "z": 1.402
            },
            "gtin": "4007951006330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d848",
            "leftCorner": {
              "x": 10.178,
              "y": 6.761,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.221,
              "y": 6.758,
              "z": 1.402
            },
            "gtin": "4007951006330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d849",
            "leftCorner": {
              "x": 10.221,
              "y": 6.759,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.391,
              "y": 6.745,
              "z": 1.402
            },
            "gtin": "4007951003476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d84a",
            "leftCorner": {
              "x": 10.392,
              "y": 6.746,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.463,
              "y": 6.74,
              "z": 1.402
            },
            "gtin": "8018699025213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c845ed67a01d9a1d84b",
            "leftCorner": {
              "x": 10.463,
              "y": 6.74,
              "z": 1.402
            },
            "rightCorner": {
              "x": 10.535,
              "y": 6.734,
              "z": 1.402
            },
            "gtin": "8018699025213",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e0268",
    "rightNeighborShelfId": "b6f78"
  },
  {
    "id": "edeb5",
    "name": "edeb5",
    "x": 8.439,
    "y": 32.766,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.02595,
      "w": 0.99966
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 21
    },
    "layers": [
      {
        "id": "682ffdded15af3232a5468d1",
        "height": 1.0642,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21480",
            "leftCorner": {
              "x": 8.826,
              "y": 32.898,
              "z": 0.871
            },
            "rightCorner": {
              "x": 9.206,
              "y": 32.877,
              "z": 0.871
            },
            "gtin": "4001686322901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21482",
            "leftCorner": {
              "x": 9.208,
              "y": 32.919,
              "z": 0.871
            },
            "rightCorner": {
              "x": 9.346,
              "y": 32.911,
              "z": 0.871
            },
            "gtin": "4001686328941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21483",
            "leftCorner": {
              "x": 9.346,
              "y": 32.911,
              "z": 0.871
            },
            "rightCorner": {
              "x": 9.485,
              "y": 32.904,
              "z": 0.871
            },
            "gtin": "4001686328941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21481",
            "leftCorner": {
              "x": 9.48,
              "y": 32.806,
              "z": 0.871
            },
            "rightCorner": {
              "x": 9.693,
              "y": 32.796,
              "z": 0.871
            },
            "gtin": "4001686327609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2147f",
            "leftCorner": {
              "x": 8.447,
              "y": 32.917,
              "z": 0.871
            },
            "rightCorner": {
              "x": 8.826,
              "y": 32.898,
              "z": 0.871
            },
            "gtin": "4001686322901",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468d2",
        "height": 1.4093,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21484",
            "leftCorner": {
              "x": 8.447,
              "y": 32.91,
              "z": 1.153
            },
            "rightCorner": {
              "x": 8.822,
              "y": 32.891,
              "z": 1.153
            },
            "gtin": "4001686725504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21485",
            "leftCorner": {
              "x": 8.822,
              "y": 32.891,
              "z": 1.153
            },
            "rightCorner": {
              "x": 9.197,
              "y": 32.871,
              "z": 1.153
            },
            "gtin": "4001686725504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21487",
            "leftCorner": {
              "x": 9.199,
              "y": 32.911,
              "z": 1.153
            },
            "rightCorner": {
              "x": 9.479,
              "y": 32.897,
              "z": 1.153
            },
            "gtin": "4001686322963",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68300c8b5ed67a01d9a21486",
            "leftCorner": {
              "x": 9.475,
              "y": 32.808,
              "z": 1.153
            },
            "rightCorner": {
              "x": 9.693,
              "y": 32.797,
              "z": 1.153
            },
            "gtin": "4001686151105",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468d4",
        "height": 1.7669,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a2148e",
            "leftCorner": {
              "x": 8.446,
              "y": 32.897,
              "z": 1.446
            },
            "rightCorner": {
              "x": 9.253,
              "y": 32.855,
              "z": 1.446
            },
            "gtin": "4001686120248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21490",
            "leftCorner": {
              "x": 9.255,
              "y": 32.899,
              "z": 1.446
            },
            "rightCorner": {
              "x": 9.351,
              "y": 32.893,
              "z": 1.446
            },
            "gtin": "4001686327517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21491",
            "leftCorner": {
              "x": 9.351,
              "y": 32.893,
              "z": 1.446
            },
            "rightCorner": {
              "x": 9.447,
              "y": 32.888,
              "z": 1.446
            },
            "gtin": "4001686327517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2148f",
            "leftCorner": {
              "x": 9.444,
              "y": 32.829,
              "z": 1.446
            },
            "rightCorner": {
              "x": 9.693,
              "y": 32.816,
              "z": 1.446
            },
            "gtin": "4001686327456",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468d5",
        "height": 0.16068,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21492",
            "leftCorner": {
              "x": 8.449,
              "y": 32.954,
              "z": 0.131
            },
            "rightCorner": {
              "x": 9.186,
              "y": 32.915,
              "z": 0.131
            },
            "gtin": "4001686301524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21494",
            "leftCorner": {
              "x": 9.188,
              "y": 32.959,
              "z": 0.131
            },
            "rightCorner": {
              "x": 9.431,
              "y": 32.945,
              "z": 0.131
            },
            "gtin": "4001686386910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21493",
            "leftCorner": {
              "x": 9.427,
              "y": 32.861,
              "z": 0.131
            },
            "rightCorner": {
              "x": 9.695,
              "y": 32.847,
              "z": 0.131
            },
            "gtin": "4001686003015",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdded15af3232a5468d3",
        "height": 0.66014,
        "facings": [
          {
            "id": "68300c8b5ed67a01d9a21488",
            "leftCorner": {
              "x": 8.448,
              "y": 32.928,
              "z": 0.54
            },
            "rightCorner": {
              "x": 9.191,
              "y": 32.889,
              "z": 0.54
            },
            "gtin": "4001686322536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2148c",
            "leftCorner": {
              "x": 9.193,
              "y": 32.927,
              "z": 0.54
            },
            "rightCorner": {
              "x": 9.326,
              "y": 32.92,
              "z": 0.54
            },
            "gtin": "4001686329757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2148d",
            "leftCorner": {
              "x": 9.326,
              "y": 32.92,
              "z": 0.54
            },
            "rightCorner": {
              "x": 9.459,
              "y": 32.913,
              "z": 0.54
            },
            "gtin": "4001686329757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a21489",
            "leftCorner": {
              "x": 9.455,
              "y": 32.83,
              "z": 0.54
            },
            "rightCorner": {
              "x": 9.534,
              "y": 32.826,
              "z": 0.54
            },
            "gtin": "9002975378956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2148a",
            "leftCorner": {
              "x": 9.534,
              "y": 32.826,
              "z": 0.54
            },
            "rightCorner": {
              "x": 9.614,
              "y": 32.822,
              "z": 0.54
            },
            "gtin": "9002975378956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c8b5ed67a01d9a2148b",
            "leftCorner": {
              "x": 9.614,
              "y": 32.822,
              "z": 0.54
            },
            "rightCorner": {
              "x": 9.694,
              "y": 32.818,
              "z": 0.54
            },
            "gtin": "9002975378956",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "92ffd"
  },
  {
    "id": "edebf",
    "name": "edebf",
    "x": 2.5,
    "y": 13.873,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68756,
      "w": 0.72613
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 65
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a5463e5",
        "height": 0.1447,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e8a1",
            "leftCorner": {
              "x": 2.478,
              "y": 13.874,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.482,
              "y": 13.956,
              "z": 0.118
            },
            "gtin": "4337185703171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8a2",
            "leftCorner": {
              "x": 2.482,
              "y": 13.956,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.487,
              "y": 14.039,
              "z": 0.118
            },
            "gtin": "4337185703171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8a3",
            "leftCorner": {
              "x": 2.487,
              "y": 14.039,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.491,
              "y": 14.121,
              "z": 0.118
            },
            "gtin": "4337185703171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8a4",
            "leftCorner": {
              "x": 2.491,
              "y": 14.121,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.496,
              "y": 14.204,
              "z": 0.118
            },
            "gtin": "4337185703171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8a5",
            "leftCorner": {
              "x": 2.496,
              "y": 14.204,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.5,
              "y": 14.286,
              "z": 0.118
            },
            "gtin": "4337185703171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8a6",
            "leftCorner": {
              "x": 2.5,
              "y": 14.286,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.505,
              "y": 14.368,
              "z": 0.118
            },
            "gtin": "4337185703171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8a9",
            "leftCorner": {
              "x": 2.485,
              "y": 14.369,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.488,
              "y": 14.425,
              "z": 0.118
            },
            "gtin": "4337185597855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8aa",
            "leftCorner": {
              "x": 2.488,
              "y": 14.425,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.492,
              "y": 14.479,
              "z": 0.118
            },
            "gtin": "4337185597855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8ab",
            "leftCorner": {
              "x": 2.492,
              "y": 14.479,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.494,
              "y": 14.534,
              "z": 0.118
            },
            "gtin": "4337185597855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8ac",
            "leftCorner": {
              "x": 2.467,
              "y": 14.536,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.471,
              "y": 14.593,
              "z": 0.118
            },
            "gtin": "4337185597817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8ad",
            "leftCorner": {
              "x": 2.471,
              "y": 14.593,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.474,
              "y": 14.649,
              "z": 0.118
            },
            "gtin": "4337185597817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8ae",
            "leftCorner": {
              "x": 2.474,
              "y": 14.649,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.477,
              "y": 14.706,
              "z": 0.118
            },
            "gtin": "4337185597817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8af",
            "leftCorner": {
              "x": 2.495,
              "y": 14.705,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.497,
              "y": 14.752,
              "z": 0.118
            },
            "gtin": "4009300020998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8b0",
            "leftCorner": {
              "x": 2.497,
              "y": 14.752,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.5,
              "y": 14.8,
              "z": 0.118
            },
            "gtin": "4009300020998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8b1",
            "leftCorner": {
              "x": 2.5,
              "y": 14.8,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.502,
              "y": 14.846,
              "z": 0.118
            },
            "gtin": "4009300020998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8b2",
            "leftCorner": {
              "x": 2.502,
              "y": 14.846,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.505,
              "y": 14.894,
              "z": 0.118
            },
            "gtin": "4009300020998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8b3",
            "leftCorner": {
              "x": 2.495,
              "y": 14.894,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.498,
              "y": 14.951,
              "z": 0.118
            },
            "gtin": "4337185579257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8b4",
            "leftCorner": {
              "x": 2.498,
              "y": 14.951,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.501,
              "y": 15.007,
              "z": 0.118
            },
            "gtin": "4337185579257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8b5",
            "leftCorner": {
              "x": 2.501,
              "y": 15.007,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.504,
              "y": 15.064,
              "z": 0.118
            },
            "gtin": "4337185579257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e8b6",
            "leftCorner": {
              "x": 2.504,
              "y": 15.064,
              "z": 0.118
            },
            "rightCorner": {
              "x": 2.507,
              "y": 15.12,
              "z": 0.118
            },
            "gtin": "4337185579257",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463e2",
        "height": 1.0,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e7ec",
            "leftCorner": {
              "x": 2.492,
              "y": 13.873,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.516,
              "y": 14.302,
              "z": 0.818
            },
            "gtin": "4009452000091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7ef",
            "leftCorner": {
              "x": 2.48,
              "y": 14.304,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.487,
              "y": 14.426,
              "z": 0.818
            },
            "gtin": "4009452000916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7f0",
            "leftCorner": {
              "x": 2.487,
              "y": 14.426,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.493,
              "y": 14.547,
              "z": 0.818
            },
            "gtin": "4009452000916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7f1",
            "leftCorner": {
              "x": 2.493,
              "y": 14.547,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.5,
              "y": 14.669,
              "z": 0.818
            },
            "gtin": "4009452000916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7f2",
            "leftCorner": {
              "x": 2.498,
              "y": 14.669,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.502,
              "y": 14.74,
              "z": 0.818
            },
            "gtin": "4009452002033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7f3",
            "leftCorner": {
              "x": 2.502,
              "y": 14.74,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.506,
              "y": 14.81,
              "z": 0.818
            },
            "gtin": "4009452002033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7f4",
            "leftCorner": {
              "x": 2.502,
              "y": 14.81,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.507,
              "y": 14.897,
              "z": 0.818
            },
            "gtin": "4009452000886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7f5",
            "leftCorner": {
              "x": 2.507,
              "y": 14.897,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.512,
              "y": 14.985,
              "z": 0.818
            },
            "gtin": "4009452000886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7f6",
            "leftCorner": {
              "x": 2.513,
              "y": 14.985,
              "z": 0.818
            },
            "rightCorner": {
              "x": 2.52,
              "y": 15.105,
              "z": 0.818
            },
            "gtin": "4009452000084",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463e4",
        "height": 1.3524,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e863",
            "leftCorner": {
              "x": 2.5,
              "y": 13.873,
              "z": 1.107
            },
            "rightCorner": {
              "x": 2.507,
              "y": 13.994,
              "z": 1.107
            },
            "gtin": "4009452005607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e864",
            "leftCorner": {
              "x": 2.507,
              "y": 13.994,
              "z": 1.107
            },
            "rightCorner": {
              "x": 2.513,
              "y": 14.114,
              "z": 1.107
            },
            "gtin": "4009452005607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e865",
            "leftCorner": {
              "x": 2.513,
              "y": 14.114,
              "z": 1.107
            },
            "rightCorner": {
              "x": 2.52,
              "y": 14.234,
              "z": 1.107
            },
            "gtin": "4009452005607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e867",
            "leftCorner": {
              "x": 2.484,
              "y": 14.236,
              "z": 1.107
            },
            "rightCorner": {
              "x": 2.488,
              "y": 14.297,
              "z": 1.107
            },
            "gtin": "4009452005614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e868",
            "leftCorner": {
              "x": 2.488,
              "y": 14.297,
              "z": 1.107
            },
            "rightCorner": {
              "x": 2.491,
              "y": 14.359,
              "z": 1.107
            },
            "gtin": "4009452005614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e869",
            "leftCorner": {
              "x": 2.489,
              "y": 14.359,
              "z": 1.107
            },
            "rightCorner": {
              "x": 2.496,
              "y": 14.501,
              "z": 1.107
            },
            "gtin": "4009452003450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e86a",
            "leftCorner": {
              "x": 2.496,
              "y": 14.501,
              "z": 1.107
            },
            "rightCorner": {
              "x": 2.5,
              "y": 14.567,
              "z": 1.107
            },
            "gtin": "070177029630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e86b",
            "leftCorner": {
              "x": 2.491,
              "y": 14.568,
              "z": 1.107
            },
            "rightCorner": {
              "x": 2.496,
              "y": 14.651,
              "z": 1.107
            },
            "gtin": "070177029623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e86c",
            "leftCorner": {
              "x": 2.508,
              "y": 14.65,
              "z": 1.107
            },
            "rightCorner": {
              "x": 2.513,
              "y": 14.751,
              "z": 1.107
            },
            "gtin": "070177233938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e86d",
            "leftCorner": {
              "x": 2.502,
              "y": 14.751,
              "z": 1.107
            },
            "rightCorner": {
              "x": 2.512,
              "y": 14.941,
              "z": 1.107
            },
            "gtin": "070177077198",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e86e",
            "leftCorner": {
              "x": 2.512,
              "y": 14.941,
              "z": 1.107
            },
            "rightCorner": {
              "x": 2.523,
              "y": 15.132,
              "z": 1.107
            },
            "gtin": "070177077198",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463e1",
        "height": 1.7022,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e7a3",
            "leftCorner": {
              "x": 2.502,
              "y": 13.873,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.508,
              "y": 13.969,
              "z": 1.393
            },
            "gtin": "4016883450326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7a4",
            "leftCorner": {
              "x": 2.508,
              "y": 13.969,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.513,
              "y": 14.064,
              "z": 1.393
            },
            "gtin": "4016883450326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7a5",
            "leftCorner": {
              "x": 2.513,
              "y": 14.064,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.518,
              "y": 14.159,
              "z": 1.393
            },
            "gtin": "4016883450326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7a7",
            "leftCorner": {
              "x": 2.5,
              "y": 14.16,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.502,
              "y": 14.197,
              "z": 1.393
            },
            "gtin": "4016883464019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7a8",
            "leftCorner": {
              "x": 2.502,
              "y": 14.197,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.504,
              "y": 14.234,
              "z": 1.393
            },
            "gtin": "4016883464019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7a9",
            "leftCorner": {
              "x": 2.486,
              "y": 14.235,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.49,
              "y": 14.301,
              "z": 1.393
            },
            "gtin": "4016883481580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7aa",
            "leftCorner": {
              "x": 2.496,
              "y": 14.301,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.502,
              "y": 14.413,
              "z": 1.393
            },
            "gtin": "4009300001669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7ab",
            "leftCorner": {
              "x": 2.506,
              "y": 14.413,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.51,
              "y": 14.491,
              "z": 1.393
            },
            "gtin": "4002221049673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7ac",
            "leftCorner": {
              "x": 2.498,
              "y": 14.492,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.504,
              "y": 14.607,
              "z": 1.393
            },
            "gtin": "4009300002468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7ad",
            "leftCorner": {
              "x": 2.504,
              "y": 14.607,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.51,
              "y": 14.722,
              "z": 1.393
            },
            "gtin": "4009300002468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7ae",
            "leftCorner": {
              "x": 2.503,
              "y": 14.722,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.507,
              "y": 14.812,
              "z": 1.393
            },
            "gtin": "4002221011380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7af",
            "leftCorner": {
              "x": 2.519,
              "y": 14.811,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.523,
              "y": 14.884,
              "z": 1.393
            },
            "gtin": "4002221011403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7b0",
            "leftCorner": {
              "x": 2.51,
              "y": 14.885,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.516,
              "y": 14.985,
              "z": 1.393
            },
            "gtin": "4002221011342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7b1",
            "leftCorner": {
              "x": 2.516,
              "y": 14.985,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.521,
              "y": 15.085,
              "z": 1.393
            },
            "gtin": "4002221011342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e7b2",
            "leftCorner": {
              "x": 2.521,
              "y": 15.085,
              "z": 1.393
            },
            "rightCorner": {
              "x": 2.527,
              "y": 15.185,
              "z": 1.393
            },
            "gtin": "4002221011342",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a5463e3",
        "height": 0.60189,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e833",
            "leftCorner": {
              "x": 2.484,
              "y": 13.874,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.49,
              "y": 13.976,
              "z": 0.492
            },
            "gtin": "4009452000077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e834",
            "leftCorner": {
              "x": 2.49,
              "y": 13.976,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.495,
              "y": 14.077,
              "z": 0.492
            },
            "gtin": "4009452000077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e836",
            "leftCorner": {
              "x": 2.499,
              "y": 14.076,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.505,
              "y": 14.187,
              "z": 0.492
            },
            "gtin": "4009452000053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e837",
            "leftCorner": {
              "x": 2.505,
              "y": 14.187,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.511,
              "y": 14.297,
              "z": 0.492
            },
            "gtin": "4009452000053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e838",
            "leftCorner": {
              "x": 2.483,
              "y": 14.299,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.492,
              "y": 14.474,
              "z": 0.492
            },
            "gtin": "4009452000046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e839",
            "leftCorner": {
              "x": 2.474,
              "y": 14.475,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.48,
              "y": 14.58,
              "z": 0.492
            },
            "gtin": "4009452000039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e83a",
            "leftCorner": {
              "x": 2.488,
              "y": 14.58,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.499,
              "y": 14.778,
              "z": 0.492
            },
            "gtin": "4009452002101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e83b",
            "leftCorner": {
              "x": 2.486,
              "y": 14.778,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.492,
              "y": 14.895,
              "z": 0.492
            },
            "gtin": "4009452000015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e83c",
            "leftCorner": {
              "x": 2.489,
              "y": 14.895,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.494,
              "y": 14.988,
              "z": 0.492
            },
            "gtin": "4009452000008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e83d",
            "leftCorner": {
              "x": 2.508,
              "y": 14.987,
              "z": 0.492
            },
            "rightCorner": {
              "x": 2.517,
              "y": 15.154,
              "z": 0.492
            },
            "gtin": "4009452001111",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "41ab1"
  },
  {
    "id": "edec0",
    "name": "edec0",
    "x": 2.448,
    "y": 21.164,
    "width": 1.2,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.9996,
      "w": 0.028166
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 58,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546415",
        "height": 0.8092,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eaa1",
            "leftCorner": {
              "x": 2.358,
              "y": 21.191,
              "z": 0.662
            },
            "rightCorner": {
              "x": 2.268,
              "y": 21.196,
              "z": 0.662
            },
            "gtin": "4008455060811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaa2",
            "leftCorner": {
              "x": 2.268,
              "y": 21.196,
              "z": 0.662
            },
            "rightCorner": {
              "x": 2.177,
              "y": 21.201,
              "z": 0.662
            },
            "gtin": "4008455060811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaa3",
            "leftCorner": {
              "x": 2.177,
              "y": 21.201,
              "z": 0.662
            },
            "rightCorner": {
              "x": 2.086,
              "y": 21.205,
              "z": 0.662
            },
            "gtin": "4008455060811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaa0",
            "leftCorner": {
              "x": 2.449,
              "y": 21.185,
              "z": 0.662
            },
            "rightCorner": {
              "x": 2.358,
              "y": 21.191,
              "z": 0.662
            },
            "gtin": "4008455060811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaa5",
            "leftCorner": {
              "x": 2.084,
              "y": 21.172,
              "z": 0.662
            },
            "rightCorner": {
              "x": 1.932,
              "y": 21.182,
              "z": 0.662
            },
            "gtin": "4012400521159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaa6",
            "leftCorner": {
              "x": 1.931,
              "y": 21.168,
              "z": 0.662
            },
            "rightCorner": {
              "x": 1.798,
              "y": 21.175,
              "z": 0.662
            },
            "gtin": "4001499926099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaa7",
            "leftCorner": {
              "x": 1.798,
              "y": 21.175,
              "z": 0.662
            },
            "rightCorner": {
              "x": 1.665,
              "y": 21.182,
              "z": 0.662
            },
            "gtin": "4001499926099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaa8",
            "leftCorner": {
              "x": 1.665,
              "y": 21.182,
              "z": 0.662
            },
            "rightCorner": {
              "x": 1.532,
              "y": 21.19,
              "z": 0.662
            },
            "gtin": "4001499926099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaa4",
            "leftCorner": {
              "x": 1.533,
              "y": 21.201,
              "z": 0.662
            },
            "rightCorner": {
              "x": 1.249,
              "y": 21.218,
              "z": 0.662
            },
            "gtin": "4001499923746",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546414",
        "height": 1.715,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1db6b",
            "leftCorner": {
              "x": 2.012,
              "y": 21.176,
              "z": 1.403
            },
            "rightCorner": {
              "x": 1.898,
              "y": 21.182,
              "z": 1.403
            },
            "gtin": "4015000971904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db6c",
            "leftCorner": {
              "x": 1.898,
              "y": 21.182,
              "z": 1.403
            },
            "rightCorner": {
              "x": 1.784,
              "y": 21.188,
              "z": 1.403
            },
            "gtin": "4015000971904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db6d",
            "leftCorner": {
              "x": 1.783,
              "y": 21.174,
              "z": 1.403
            },
            "rightCorner": {
              "x": 1.624,
              "y": 21.183,
              "z": 1.403
            },
            "gtin": "8435495819615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db6e",
            "leftCorner": {
              "x": 1.624,
              "y": 21.183,
              "z": 1.403
            },
            "rightCorner": {
              "x": 1.465,
              "y": 21.192,
              "z": 1.403
            },
            "gtin": "8435495819615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db6f",
            "leftCorner": {
              "x": 1.465,
              "y": 21.193,
              "z": 1.403
            },
            "rightCorner": {
              "x": 1.361,
              "y": 21.199,
              "z": 1.403
            },
            "gtin": "4001499961458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db70",
            "leftCorner": {
              "x": 1.361,
              "y": 21.199,
              "z": 1.403
            },
            "rightCorner": {
              "x": 1.257,
              "y": 21.205,
              "z": 1.403
            },
            "gtin": "4001499961458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db66",
            "leftCorner": {
              "x": 2.449,
              "y": 21.179,
              "z": 1.403
            },
            "rightCorner": {
              "x": 2.34,
              "y": 21.185,
              "z": 1.403
            },
            "gtin": "4008455021515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db67",
            "leftCorner": {
              "x": 2.34,
              "y": 21.185,
              "z": 1.403
            },
            "rightCorner": {
              "x": 2.231,
              "y": 21.191,
              "z": 1.403
            },
            "gtin": "4008455021515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db68",
            "leftCorner": {
              "x": 2.231,
              "y": 21.191,
              "z": 1.403
            },
            "rightCorner": {
              "x": 2.122,
              "y": 21.198,
              "z": 1.403
            },
            "gtin": "4008455021515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1db69",
            "leftCorner": {
              "x": 2.122,
              "y": 21.198,
              "z": 1.403
            },
            "rightCorner": {
              "x": 2.013,
              "y": 21.204,
              "z": 1.403
            },
            "gtin": "4008455021515",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546419",
        "height": 0.16706,
        "facings": [
          {
            "id": "68300c855ed67a01d9a1dbc5",
            "leftCorner": {
              "x": 2.448,
              "y": 21.17,
              "z": 0.137
            },
            "rightCorner": {
              "x": 2.227,
              "y": 21.182,
              "z": 0.137
            },
            "gtin": "4251758406873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbc6",
            "leftCorner": {
              "x": 2.227,
              "y": 21.182,
              "z": 0.137
            },
            "rightCorner": {
              "x": 2.005,
              "y": 21.195,
              "z": 0.137
            },
            "gtin": "4251758406873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbc9",
            "leftCorner": {
              "x": 2.003,
              "y": 21.158,
              "z": 0.137
            },
            "rightCorner": {
              "x": 1.937,
              "y": 21.162,
              "z": 0.137
            },
            "gtin": "4251758406859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbca",
            "leftCorner": {
              "x": 1.937,
              "y": 21.162,
              "z": 0.137
            },
            "rightCorner": {
              "x": 1.871,
              "y": 21.166,
              "z": 0.137
            },
            "gtin": "4251758406859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbcb",
            "leftCorner": {
              "x": 1.872,
              "y": 21.171,
              "z": 0.137
            },
            "rightCorner": {
              "x": 1.763,
              "y": 21.177,
              "z": 0.137
            },
            "gtin": "4251758406798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbcc",
            "leftCorner": {
              "x": 1.763,
              "y": 21.177,
              "z": 0.137
            },
            "rightCorner": {
              "x": 1.655,
              "y": 21.183,
              "z": 0.137
            },
            "gtin": "4251758406798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbcd",
            "leftCorner": {
              "x": 1.655,
              "y": 21.183,
              "z": 0.137
            },
            "rightCorner": {
              "x": 1.547,
              "y": 21.189,
              "z": 0.137
            },
            "gtin": "4251758406798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbce",
            "leftCorner": {
              "x": 1.546,
              "y": 21.179,
              "z": 0.137
            },
            "rightCorner": {
              "x": 1.379,
              "y": 21.188,
              "z": 0.137
            },
            "gtin": "4251758406811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c855ed67a01d9a1dbcf",
            "leftCorner": {
              "x": 1.379,
              "y": 21.188,
              "z": 0.137
            },
            "rightCorner": {
              "x": 1.211,
              "y": 21.197,
              "z": 0.137
            },
            "gtin": "4251758406811",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546417",
        "height": 0.45895,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eab3",
            "leftCorner": {
              "x": 2.449,
              "y": 21.179,
              "z": 0.375
            },
            "rightCorner": {
              "x": 2.338,
              "y": 21.186,
              "z": 0.375
            },
            "gtin": "4251758406934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eab4",
            "leftCorner": {
              "x": 2.338,
              "y": 21.186,
              "z": 0.375
            },
            "rightCorner": {
              "x": 2.227,
              "y": 21.192,
              "z": 0.375
            },
            "gtin": "4251758406934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eab5",
            "leftCorner": {
              "x": 2.227,
              "y": 21.192,
              "z": 0.375
            },
            "rightCorner": {
              "x": 2.115,
              "y": 21.198,
              "z": 0.375
            },
            "gtin": "4251758406934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eab7",
            "leftCorner": {
              "x": 2.114,
              "y": 21.166,
              "z": 0.375
            },
            "rightCorner": {
              "x": 1.952,
              "y": 21.176,
              "z": 0.375
            },
            "gtin": "4251758407139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eab8",
            "leftCorner": {
              "x": 1.952,
              "y": 21.176,
              "z": 0.375
            },
            "rightCorner": {
              "x": 1.83,
              "y": 21.182,
              "z": 0.375
            },
            "gtin": "4251758407054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eab9",
            "leftCorner": {
              "x": 1.83,
              "y": 21.182,
              "z": 0.375
            },
            "rightCorner": {
              "x": 1.708,
              "y": 21.189,
              "z": 0.375
            },
            "gtin": "4251758407054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaba",
            "leftCorner": {
              "x": 1.708,
              "y": 21.18,
              "z": 0.375
            },
            "rightCorner": {
              "x": 1.496,
              "y": 21.192,
              "z": 0.375
            },
            "gtin": "4002448077114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eabb",
            "leftCorner": {
              "x": 1.497,
              "y": 21.204,
              "z": 0.375
            },
            "rightCorner": {
              "x": 1.396,
              "y": 21.21,
              "z": 0.375
            },
            "gtin": "8435495819332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eab6",
            "leftCorner": {
              "x": 1.395,
              "y": 21.194,
              "z": 0.375
            },
            "rightCorner": {
              "x": 1.248,
              "y": 21.201,
              "z": 0.375
            },
            "gtin": "8435495819301",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546416",
        "height": 1.1143,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eaa9",
            "leftCorner": {
              "x": 2.449,
              "y": 21.188,
              "z": 0.912
            },
            "rightCorner": {
              "x": 2.113,
              "y": 21.207,
              "z": 0.912
            },
            "gtin": "4008455061412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaae",
            "leftCorner": {
              "x": 2.113,
              "y": 21.202,
              "z": 0.912
            },
            "rightCorner": {
              "x": 2.01,
              "y": 21.208,
              "z": 0.912
            },
            "gtin": "4008455061511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaaf",
            "leftCorner": {
              "x": 2.009,
              "y": 21.189,
              "z": 0.912
            },
            "rightCorner": {
              "x": 1.948,
              "y": 21.193,
              "z": 0.912
            },
            "gtin": "4008455004174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eab0",
            "leftCorner": {
              "x": 1.948,
              "y": 21.193,
              "z": 0.912
            },
            "rightCorner": {
              "x": 1.887,
              "y": 21.196,
              "z": 0.912
            },
            "gtin": "4008455004174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eab1",
            "leftCorner": {
              "x": 1.886,
              "y": 21.185,
              "z": 0.912
            },
            "rightCorner": {
              "x": 1.798,
              "y": 21.191,
              "z": 0.912
            },
            "gtin": "4008455063614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eab2",
            "leftCorner": {
              "x": 1.798,
              "y": 21.191,
              "z": 0.912
            },
            "rightCorner": {
              "x": 1.71,
              "y": 21.196,
              "z": 0.912
            },
            "gtin": "4008455063614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaaa",
            "leftCorner": {
              "x": 1.709,
              "y": 21.171,
              "z": 0.912
            },
            "rightCorner": {
              "x": 1.594,
              "y": 21.177,
              "z": 0.912
            },
            "gtin": "4008455095912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaab",
            "leftCorner": {
              "x": 1.594,
              "y": 21.177,
              "z": 0.912
            },
            "rightCorner": {
              "x": 1.478,
              "y": 21.184,
              "z": 0.912
            },
            "gtin": "4008455095912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaac",
            "leftCorner": {
              "x": 1.478,
              "y": 21.184,
              "z": 0.912
            },
            "rightCorner": {
              "x": 1.363,
              "y": 21.19,
              "z": 0.912
            },
            "gtin": "4008455095912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eaad",
            "leftCorner": {
              "x": 1.363,
              "y": 21.19,
              "z": 0.912
            },
            "rightCorner": {
              "x": 1.248,
              "y": 21.196,
              "z": 0.912
            },
            "gtin": "4008455095912",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546418",
        "height": 1.4201,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1eabc",
            "leftCorner": {
              "x": 2.449,
              "y": 21.176,
              "z": 1.162
            },
            "rightCorner": {
              "x": 2.327,
              "y": 21.183,
              "z": 1.162
            },
            "gtin": "4008455018812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eabd",
            "leftCorner": {
              "x": 2.327,
              "y": 21.183,
              "z": 1.162
            },
            "rightCorner": {
              "x": 2.206,
              "y": 21.189,
              "z": 1.162
            },
            "gtin": "4008455018812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eabe",
            "leftCorner": {
              "x": 2.206,
              "y": 21.189,
              "z": 1.162
            },
            "rightCorner": {
              "x": 2.085,
              "y": 21.196,
              "z": 1.162
            },
            "gtin": "4008455018812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eac0",
            "leftCorner": {
              "x": 2.083,
              "y": 21.171,
              "z": 1.162
            },
            "rightCorner": {
              "x": 2.007,
              "y": 21.176,
              "z": 1.162
            },
            "gtin": "4022142115011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eac1",
            "leftCorner": {
              "x": 2.007,
              "y": 21.176,
              "z": 1.162
            },
            "rightCorner": {
              "x": 1.932,
              "y": 21.181,
              "z": 1.162
            },
            "gtin": "4022142115011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eac2",
            "leftCorner": {
              "x": 1.931,
              "y": 21.171,
              "z": 1.162
            },
            "rightCorner": {
              "x": 1.858,
              "y": 21.174,
              "z": 1.162
            },
            "gtin": "4008455086811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eac3",
            "leftCorner": {
              "x": 1.858,
              "y": 21.174,
              "z": 1.162
            },
            "rightCorner": {
              "x": 1.785,
              "y": 21.179,
              "z": 1.162
            },
            "gtin": "4008455086811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eac4",
            "leftCorner": {
              "x": 1.785,
              "y": 21.179,
              "z": 1.162
            },
            "rightCorner": {
              "x": 1.712,
              "y": 21.183,
              "z": 1.162
            },
            "gtin": "4008455086811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eac5",
            "leftCorner": {
              "x": 1.712,
              "y": 21.172,
              "z": 1.162
            },
            "rightCorner": {
              "x": 1.503,
              "y": 21.184,
              "z": 1.162
            },
            "gtin": "4001499923739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eac6",
            "leftCorner": {
              "x": 1.504,
              "y": 21.197,
              "z": 1.162
            },
            "rightCorner": {
              "x": 1.371,
              "y": 21.204,
              "z": 1.162
            },
            "gtin": "4052400035126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1eabf",
            "leftCorner": {
              "x": 1.37,
              "y": 21.176,
              "z": 1.162
            },
            "rightCorner": {
              "x": 1.247,
              "y": 21.183,
              "z": 1.162
            },
            "gtin": "4052400034150",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "41ab6"
  },
  {
    "id": "edece",
    "name": "edece",
    "x": -14.068,
    "y": 22.354,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69518,
      "w": 0.71884
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 3
    },
    "layers": [
      {
        "id": "682ffddcd15af3232a546455",
        "height": 1.4027,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a546457",
        "height": 0.13474,
        "facings": []
      },
      {
        "id": "682ffddcd15af3232a546456",
        "height": 0.58124,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1ee28",
            "leftCorner": {
              "x": -14.085,
              "y": 22.354,
              "z": 0.476
            },
            "rightCorner": {
              "x": -14.076,
              "y": 22.622,
              "z": 0.476
            },
            "gtin": "4262429770063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee29",
            "leftCorner": {
              "x": -14.076,
              "y": 22.622,
              "z": 0.476
            },
            "rightCorner": {
              "x": -14.067,
              "y": 22.889,
              "z": 0.476
            },
            "gtin": "4262429770063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1ee2a",
            "leftCorner": {
              "x": -14.093,
              "y": 22.889,
              "z": 0.476
            },
            "rightCorner": {
              "x": -14.091,
              "y": 22.985,
              "z": 0.476
            },
            "gtin": "4262429770162",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffddcd15af3232a546454",
        "height": 1.031,
        "facings": []
      }
    ],
    "rightNeighborShelfId": "41ac9"
  },
  {
    "id": "eded2",
    "name": "eded2",
    "x": -13.812,
    "y": 26.621,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68276,
      "w": 0.73065
    },

    "layers": [],
    "leftNeighborShelfId": "41acb",
    "rightNeighborShelfId": "41acc"
  },
  {
    "id": "eded6",
    "name": "eded6",
    "x": -13.197,
    "y": 36.579,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.68252,
      "w": 0.73087
    },

    "layers": [],
    "leftNeighborShelfId": "41ace",
    "rightNeighborShelfId": "41acf"
  },
  {
    "id": "ededa",
    "name": "ededa",
    "x": -12.994,
    "y": 41.531,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69589,
      "w": 0.71815
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 20
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546489",
        "height": 0.16815,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e973",
            "leftCorner": {
              "x": -13.009,
              "y": 41.532,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.991,
              "y": 42.086,
              "z": 0.138
            },
            "gtin": "3253920709011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e975",
            "leftCorner": {
              "x": -13.039,
              "y": 42.087,
              "z": 0.138
            },
            "rightCorner": {
              "x": -13.029,
              "y": 42.403,
              "z": 0.138
            },
            "gtin": "7610859246707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e976",
            "leftCorner": {
              "x": -13.032,
              "y": 42.404,
              "z": 0.138
            },
            "rightCorner": {
              "x": -13.027,
              "y": 42.539,
              "z": 0.138
            },
            "gtin": "7610859246677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e977",
            "leftCorner": {
              "x": -13.014,
              "y": 42.538,
              "z": 0.138
            },
            "rightCorner": {
              "x": -13.01,
              "y": 42.657,
              "z": 0.138
            },
            "gtin": "4004617370507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e978",
            "leftCorner": {
              "x": -12.995,
              "y": 42.657,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.991,
              "y": 42.793,
              "z": 0.138
            },
            "gtin": "4004617371009",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54648a",
        "height": 0.99774,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f1cf",
            "leftCorner": {
              "x": -13.011,
              "y": 41.532,
              "z": 0.816
            },
            "rightCorner": {
              "x": -13.008,
              "y": 41.644,
              "z": 0.816
            },
            "gtin": "4005437313194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1d0",
            "leftCorner": {
              "x": -13.008,
              "y": 41.644,
              "z": 0.816
            },
            "rightCorner": {
              "x": -13.004,
              "y": 41.757,
              "z": 0.816
            },
            "gtin": "4005437313194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1d1",
            "leftCorner": {
              "x": -13.004,
              "y": 41.757,
              "z": 0.816
            },
            "rightCorner": {
              "x": -13.0,
              "y": 41.869,
              "z": 0.816
            },
            "gtin": "4005437313194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1d3",
            "leftCorner": {
              "x": -13.044,
              "y": 41.87,
              "z": 0.816
            },
            "rightCorner": {
              "x": -13.035,
              "y": 42.152,
              "z": 0.816
            },
            "gtin": "7610859222060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1d4",
            "leftCorner": {
              "x": -13.028,
              "y": 42.152,
              "z": 0.816
            },
            "rightCorner": {
              "x": -13.024,
              "y": 42.302,
              "z": 0.816
            },
            "gtin": "4052396082852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1d5",
            "leftCorner": {
              "x": -13.022,
              "y": 42.302,
              "z": 0.816
            },
            "rightCorner": {
              "x": -13.016,
              "y": 42.509,
              "z": 0.816
            },
            "gtin": "4052396082876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1d6",
            "leftCorner": {
              "x": -13.01,
              "y": 42.509,
              "z": 0.816
            },
            "rightCorner": {
              "x": -13.005,
              "y": 42.656,
              "z": 0.816
            },
            "gtin": "7610859222053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1d2",
            "leftCorner": {
              "x": -12.986,
              "y": 42.655,
              "z": 0.816
            },
            "rightCorner": {
              "x": -12.982,
              "y": 42.782,
              "z": 0.816
            },
            "gtin": "4009017521894",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54648b",
        "height": 1.1992,
        "facings": [
          {
            "id": "68300c865ed67a01d9a1e96f",
            "leftCorner": {
              "x": -13.008,
              "y": 41.532,
              "z": 0.981
            },
            "rightCorner": {
              "x": -12.988,
              "y": 42.172,
              "z": 0.981
            },
            "gtin": "5900791003011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c865ed67a01d9a1e971",
            "leftCorner": {
              "x": -13.03,
              "y": 42.173,
              "z": 0.981
            },
            "rightCorner": {
              "x": -13.01,
              "y": 42.821,
              "z": 0.981
            },
            "gtin": "5900791000010",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546488",
        "height": 1.6104,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f1ca",
            "leftCorner": {
              "x": -13.003,
              "y": 41.531,
              "z": 1.318
            },
            "rightCorner": {
              "x": -12.999,
              "y": 41.66,
              "z": 1.318
            },
            "gtin": "4300175502931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1cb",
            "leftCorner": {
              "x": -12.999,
              "y": 41.66,
              "z": 1.318
            },
            "rightCorner": {
              "x": -12.995,
              "y": 41.787,
              "z": 1.318
            },
            "gtin": "4300175502931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1cd",
            "leftCorner": {
              "x": -13.044,
              "y": 41.788,
              "z": 1.318
            },
            "rightCorner": {
              "x": -13.036,
              "y": 42.024,
              "z": 1.318
            },
            "gtin": "4335896125930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1ce",
            "leftCorner": {
              "x": -13.026,
              "y": 42.024,
              "z": 1.318
            },
            "rightCorner": {
              "x": -13.014,
              "y": 42.409,
              "z": 1.318
            },
            "gtin": "5900791000010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1cc",
            "leftCorner": {
              "x": -13.012,
              "y": 42.409,
              "z": 1.318
            },
            "rightCorner": {
              "x": -13.001,
              "y": 42.782,
              "z": 1.318
            },
            "gtin": "4001515297950",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "41ad1",
    "rightNeighborShelfId": "d9f57"
  },
  {
    "id": "edee1",
    "name": "edee1",
    "x": -12.779,
    "y": 46.398,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69209,
      "w": 0.72181
    },

    "layers": [],
    "leftNeighborShelfId": "d9f59",
    "rightNeighborShelfId": "d9f66"
  },
  {
    "id": "edee5",
    "name": "edee5",
    "x": -12.578,
    "y": 51.501,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.69635,
      "w": 0.71771
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 68
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a54649c",
        "height": 0.16647,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f264",
            "leftCorner": {
              "x": -12.595,
              "y": 51.501,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.591,
              "y": 51.635,
              "z": 0.136
            },
            "gtin": "8005989247875",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f265",
            "leftCorner": {
              "x": -12.591,
              "y": 51.635,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.587,
              "y": 51.767,
              "z": 0.136
            },
            "gtin": "8005989247875",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f268",
            "leftCorner": {
              "x": -12.631,
              "y": 51.768,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.628,
              "y": 51.883,
              "z": 0.136
            },
            "gtin": "8005989248179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f269",
            "leftCorner": {
              "x": -12.628,
              "y": 51.883,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.624,
              "y": 51.998,
              "z": 0.136
            },
            "gtin": "8005989248179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f26a",
            "leftCorner": {
              "x": -12.617,
              "y": 51.998,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.601,
              "y": 52.56,
              "z": 0.136
            },
            "gtin": "8005989248186",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f26b",
            "leftCorner": {
              "x": -12.598,
              "y": 52.56,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.594,
              "y": 52.656,
              "z": 0.136
            },
            "gtin": "4018833952669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f26c",
            "leftCorner": {
              "x": -12.594,
              "y": 52.656,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.592,
              "y": 52.752,
              "z": 0.136
            },
            "gtin": "4018833952669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f26d",
            "leftCorner": {
              "x": -12.592,
              "y": 52.752,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.589,
              "y": 52.847,
              "z": 0.136
            },
            "gtin": "4018833952669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f26e",
            "leftCorner": {
              "x": -12.589,
              "y": 52.847,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.586,
              "y": 52.943,
              "z": 0.136
            },
            "gtin": "4018833952669",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546498",
        "height": 0.49071,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f209",
            "leftCorner": {
              "x": -12.598,
              "y": 51.501,
              "z": 0.401
            },
            "rightCorner": {
              "x": -12.596,
              "y": 51.57,
              "z": 0.401
            },
            "gtin": "7610859257130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f20a",
            "leftCorner": {
              "x": -12.596,
              "y": 51.57,
              "z": 0.401
            },
            "rightCorner": {
              "x": -12.593,
              "y": 51.639,
              "z": 0.401
            },
            "gtin": "7610859257130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f20d",
            "leftCorner": {
              "x": -12.637,
              "y": 51.641,
              "z": 0.401
            },
            "rightCorner": {
              "x": -12.634,
              "y": 51.724,
              "z": 0.401
            },
            "gtin": "7610859257192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f20e",
            "leftCorner": {
              "x": -12.634,
              "y": 51.724,
              "z": 0.401
            },
            "rightCorner": {
              "x": -12.632,
              "y": 51.807,
              "z": 0.401
            },
            "gtin": "7610859257192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f20f",
            "leftCorner": {
              "x": -12.628,
              "y": 51.807,
              "z": 0.401
            },
            "rightCorner": {
              "x": -12.623,
              "y": 51.977,
              "z": 0.401
            },
            "gtin": "7610859257093",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f210",
            "leftCorner": {
              "x": -12.623,
              "y": 51.977,
              "z": 0.401
            },
            "rightCorner": {
              "x": -12.617,
              "y": 52.147,
              "z": 0.401
            },
            "gtin": "7610859257093",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f211",
            "leftCorner": {
              "x": -12.613,
              "y": 52.147,
              "z": 0.401
            },
            "rightCorner": {
              "x": -12.611,
              "y": 52.217,
              "z": 0.401
            },
            "gtin": "7610859257116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f212",
            "leftCorner": {
              "x": -12.611,
              "y": 52.217,
              "z": 0.401
            },
            "rightCorner": {
              "x": -12.608,
              "y": 52.288,
              "z": 0.401
            },
            "gtin": "7610859257116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f213",
            "leftCorner": {
              "x": -12.617,
              "y": 52.288,
              "z": 0.401
            },
            "rightCorner": {
              "x": -12.615,
              "y": 52.373,
              "z": 0.401
            },
            "gtin": "7610859257086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f214",
            "leftCorner": {
              "x": -12.615,
              "y": 52.373,
              "z": 0.401
            },
            "rightCorner": {
              "x": -12.613,
              "y": 52.457,
              "z": 0.401
            },
            "gtin": "7610859257086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f215",
            "leftCorner": {
              "x": -12.598,
              "y": 52.456,
              "z": 0.401
            },
            "rightCorner": {
              "x": -12.595,
              "y": 52.53,
              "z": 0.401
            },
            "gtin": "8005989247851",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f216",
            "leftCorner": {
              "x": -12.595,
              "y": 52.53,
              "z": 0.401
            },
            "rightCorner": {
              "x": -12.593,
              "y": 52.603,
              "z": 0.401
            },
            "gtin": "8005989247851",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f217",
            "leftCorner": {
              "x": -12.598,
              "y": 52.604,
              "z": 0.401
            },
            "rightCorner": {
              "x": -12.597,
              "y": 52.637,
              "z": 0.401
            },
            "gtin": "7610859257109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f218",
            "leftCorner": {
              "x": -12.597,
              "y": 52.637,
              "z": 0.401
            },
            "rightCorner": {
              "x": -12.596,
              "y": 52.671,
              "z": 0.401
            },
            "gtin": "7610859257109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f219",
            "leftCorner": {
              "x": -12.596,
              "y": 52.671,
              "z": 0.401
            },
            "rightCorner": {
              "x": -12.594,
              "y": 52.706,
              "z": 0.401
            },
            "gtin": "7610859257109",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546499",
        "height": 0.79088,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f220",
            "leftCorner": {
              "x": -12.597,
              "y": 51.501,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.595,
              "y": 51.577,
              "z": 0.647
            },
            "gtin": "3426470020138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f221",
            "leftCorner": {
              "x": -12.595,
              "y": 51.577,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.593,
              "y": 51.653,
              "z": 0.647
            },
            "gtin": "3426470020138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f222",
            "leftCorner": {
              "x": -12.593,
              "y": 51.653,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.59,
              "y": 51.729,
              "z": 0.647
            },
            "gtin": "3426470020138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f223",
            "leftCorner": {
              "x": -12.59,
              "y": 51.729,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.589,
              "y": 51.805,
              "z": 0.647
            },
            "gtin": "3426470020138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f226",
            "leftCorner": {
              "x": -12.625,
              "y": 51.806,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.621,
              "y": 51.929,
              "z": 0.647
            },
            "gtin": "3426470020107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f227",
            "leftCorner": {
              "x": -12.621,
              "y": 51.929,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.617,
              "y": 52.052,
              "z": 0.647
            },
            "gtin": "3426470020107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f228",
            "leftCorner": {
              "x": -12.617,
              "y": 52.052,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.614,
              "y": 52.176,
              "z": 0.647
            },
            "gtin": "3426470020107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f229",
            "leftCorner": {
              "x": -12.614,
              "y": 52.176,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.61,
              "y": 52.299,
              "z": 0.647
            },
            "gtin": "3426470020107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f22a",
            "leftCorner": {
              "x": -12.61,
              "y": 52.299,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.605,
              "y": 52.422,
              "z": 0.647
            },
            "gtin": "3426470020107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f22b",
            "leftCorner": {
              "x": -12.602,
              "y": 52.421,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.601,
              "y": 52.476,
              "z": 0.647
            },
            "gtin": "4337185909771",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f22c",
            "leftCorner": {
              "x": -12.601,
              "y": 52.476,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.599,
              "y": 52.53,
              "z": 0.647
            },
            "gtin": "4337185909771",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f22d",
            "leftCorner": {
              "x": -12.599,
              "y": 52.53,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.598,
              "y": 52.585,
              "z": 0.647
            },
            "gtin": "4337185909771",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f22e",
            "leftCorner": {
              "x": -12.598,
              "y": 52.585,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.596,
              "y": 52.639,
              "z": 0.647
            },
            "gtin": "4337185909771",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f22f",
            "leftCorner": {
              "x": -12.596,
              "y": 52.639,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.595,
              "y": 52.693,
              "z": 0.647
            },
            "gtin": "4337185909771",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f230",
            "leftCorner": {
              "x": -12.595,
              "y": 52.693,
              "z": 0.647
            },
            "rightCorner": {
              "x": -12.593,
              "y": 52.747,
              "z": 0.647
            },
            "gtin": "4337185909771",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54649b",
        "height": 1.0472,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f258",
            "leftCorner": {
              "x": -12.59,
              "y": 51.501,
              "z": 0.857
            },
            "rightCorner": {
              "x": -12.587,
              "y": 51.574,
              "z": 0.857
            },
            "gtin": "7610859256959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f259",
            "leftCorner": {
              "x": -12.587,
              "y": 51.574,
              "z": 0.857
            },
            "rightCorner": {
              "x": -12.586,
              "y": 51.647,
              "z": 0.857
            },
            "gtin": "7610859256959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f25c",
            "leftCorner": {
              "x": -12.628,
              "y": 51.648,
              "z": 0.857
            },
            "rightCorner": {
              "x": -12.621,
              "y": 51.868,
              "z": 0.857
            },
            "gtin": "4337185909726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f25d",
            "leftCorner": {
              "x": -12.618,
              "y": 51.868,
              "z": 0.857
            },
            "rightCorner": {
              "x": -12.612,
              "y": 52.049,
              "z": 0.857
            },
            "gtin": "4018833952454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f25e",
            "leftCorner": {
              "x": -12.605,
              "y": 52.049,
              "z": 0.857
            },
            "rightCorner": {
              "x": -12.599,
              "y": 52.276,
              "z": 0.857
            },
            "gtin": "4018833023741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f25f",
            "leftCorner": {
              "x": -12.599,
              "y": 52.276,
              "z": 0.857
            },
            "rightCorner": {
              "x": -12.592,
              "y": 52.504,
              "z": 0.857
            },
            "gtin": "4018833023741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f260",
            "leftCorner": {
              "x": -12.592,
              "y": 52.504,
              "z": 0.857
            },
            "rightCorner": {
              "x": -12.585,
              "y": 52.731,
              "z": 0.857
            },
            "gtin": "4018833023741",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546497",
        "height": 1.3969,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f1fd",
            "leftCorner": {
              "x": -12.589,
              "y": 51.501,
              "z": 1.143
            },
            "rightCorner": {
              "x": -12.586,
              "y": 51.596,
              "z": 1.143
            },
            "gtin": "8807246005897",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1fe",
            "leftCorner": {
              "x": -12.586,
              "y": 51.596,
              "z": 1.143
            },
            "rightCorner": {
              "x": -12.584,
              "y": 51.69,
              "z": 1.143
            },
            "gtin": "8807246005897",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f1ff",
            "leftCorner": {
              "x": -12.584,
              "y": 51.69,
              "z": 1.143
            },
            "rightCorner": {
              "x": -12.581,
              "y": 51.784,
              "z": 1.143
            },
            "gtin": "8807246005897",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f202",
            "leftCorner": {
              "x": -12.62,
              "y": 51.785,
              "z": 1.143
            },
            "rightCorner": {
              "x": -12.617,
              "y": 51.881,
              "z": 1.143
            },
            "gtin": "8807246005828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f203",
            "leftCorner": {
              "x": -12.617,
              "y": 51.881,
              "z": 1.143
            },
            "rightCorner": {
              "x": -12.614,
              "y": 51.976,
              "z": 1.143
            },
            "gtin": "8807246005828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f204",
            "leftCorner": {
              "x": -12.62,
              "y": 51.976,
              "z": 1.143
            },
            "rightCorner": {
              "x": -12.617,
              "y": 52.055,
              "z": 1.143
            },
            "gtin": "8807246005071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f205",
            "leftCorner": {
              "x": -12.617,
              "y": 52.055,
              "z": 1.143
            },
            "rightCorner": {
              "x": -12.616,
              "y": 52.135,
              "z": 1.143
            },
            "gtin": "8807246005071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f206",
            "leftCorner": {
              "x": -12.602,
              "y": 52.135,
              "z": 1.143
            },
            "rightCorner": {
              "x": -12.598,
              "y": 52.254,
              "z": 1.143
            },
            "gtin": "7610859153951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f207",
            "leftCorner": {
              "x": -12.598,
              "y": 52.254,
              "z": 1.143
            },
            "rightCorner": {
              "x": -12.594,
              "y": 52.372,
              "z": 1.143
            },
            "gtin": "7610859153951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f208",
            "leftCorner": {
              "x": -12.595,
              "y": 52.372,
              "z": 1.143
            },
            "rightCorner": {
              "x": -12.589,
              "y": 52.605,
              "z": 1.143
            },
            "gtin": "7610859153944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f200",
            "leftCorner": {
              "x": -12.599,
              "y": 52.605,
              "z": 1.143
            },
            "rightCorner": {
              "x": -12.596,
              "y": 52.679,
              "z": 1.143
            },
            "gtin": "7610859153975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f201",
            "leftCorner": {
              "x": -12.596,
              "y": 52.679,
              "z": 1.143
            },
            "rightCorner": {
              "x": -12.593,
              "y": 52.752,
              "z": 1.143
            },
            "gtin": "7610859153975",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a54649a",
        "height": 1.7458,
        "facings": [
          {
            "id": "68300c875ed67a01d9a1f239",
            "leftCorner": {
              "x": -12.587,
              "y": 51.501,
              "z": 1.428
            },
            "rightCorner": {
              "x": -12.584,
              "y": 51.596,
              "z": 1.428
            },
            "gtin": "4337185909832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f23a",
            "leftCorner": {
              "x": -12.584,
              "y": 51.596,
              "z": 1.428
            },
            "rightCorner": {
              "x": -12.582,
              "y": 51.691,
              "z": 1.428
            },
            "gtin": "4337185909832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f23e",
            "leftCorner": {
              "x": -12.625,
              "y": 51.692,
              "z": 1.428
            },
            "rightCorner": {
              "x": -12.618,
              "y": 51.928,
              "z": 1.428
            },
            "gtin": "4052396045888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f23f",
            "leftCorner": {
              "x": -12.614,
              "y": 51.928,
              "z": 1.428
            },
            "rightCorner": {
              "x": -12.611,
              "y": 52.041,
              "z": 1.428
            },
            "gtin": "4052396045901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f240",
            "leftCorner": {
              "x": -12.611,
              "y": 52.041,
              "z": 1.428
            },
            "rightCorner": {
              "x": -12.607,
              "y": 52.156,
              "z": 1.428
            },
            "gtin": "4052396045901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f241",
            "leftCorner": {
              "x": -12.599,
              "y": 52.155,
              "z": 1.428
            },
            "rightCorner": {
              "x": -12.594,
              "y": 52.329,
              "z": 1.428
            },
            "gtin": "4009017951769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f242",
            "leftCorner": {
              "x": -12.6,
              "y": 52.329,
              "z": 1.428
            },
            "rightCorner": {
              "x": -12.599,
              "y": 52.395,
              "z": 1.428
            },
            "gtin": "4052396045864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f243",
            "leftCorner": {
              "x": -12.599,
              "y": 52.395,
              "z": 1.428
            },
            "rightCorner": {
              "x": -12.597,
              "y": 52.461,
              "z": 1.428
            },
            "gtin": "4052396045864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f244",
            "leftCorner": {
              "x": -12.598,
              "y": 52.461,
              "z": 1.428
            },
            "rightCorner": {
              "x": -12.594,
              "y": 52.606,
              "z": 1.428
            },
            "gtin": "4052396045857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c875ed67a01d9a1f245",
            "leftCorner": {
              "x": -12.594,
              "y": 52.606,
              "z": 1.428
            },
            "rightCorner": {
              "x": -12.589,
              "y": 52.75,
              "z": 1.428
            },
            "gtin": "4052396045857",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "d9f6a",
    "rightNeighborShelfId": "d9f62"
  },
  {
    "id": "edeea",
    "name": "edeea",
    "x": 7.992,
    "y": 34.648,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.7228,
      "w": 0.69106
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 42
    },
    "layers": [
      {
        "id": "682ffdddd15af3232a546567",
        "height": 0.15607,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fbd8",
            "leftCorner": {
              "x": 8.013,
              "y": 34.647,
              "z": 0.128
            },
            "rightCorner": {
              "x": 8.005,
              "y": 34.472,
              "z": 0.128
            },
            "gtin": "4014400930078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbd9",
            "leftCorner": {
              "x": 8.005,
              "y": 34.472,
              "z": 0.128
            },
            "rightCorner": {
              "x": 7.998,
              "y": 34.298,
              "z": 0.128
            },
            "gtin": "4014400930078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbdb",
            "leftCorner": {
              "x": 8.034,
              "y": 34.297,
              "z": 0.128
            },
            "rightCorner": {
              "x": 8.031,
              "y": 34.243,
              "z": 0.128
            },
            "gtin": "4260042076449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbdc",
            "leftCorner": {
              "x": 8.031,
              "y": 34.243,
              "z": 0.128
            },
            "rightCorner": {
              "x": 8.029,
              "y": 34.191,
              "z": 0.128
            },
            "gtin": "4260042076449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbdd",
            "leftCorner": {
              "x": 8.029,
              "y": 34.191,
              "z": 0.128
            },
            "rightCorner": {
              "x": 8.027,
              "y": 34.138,
              "z": 0.128
            },
            "gtin": "4260042076449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbde",
            "leftCorner": {
              "x": 8.028,
              "y": 34.138,
              "z": 0.128
            },
            "rightCorner": {
              "x": 8.023,
              "y": 34.035,
              "z": 0.128
            },
            "gtin": "3587361043176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbdf",
            "leftCorner": {
              "x": 8.023,
              "y": 34.035,
              "z": 0.128
            },
            "rightCorner": {
              "x": 8.019,
              "y": 33.933,
              "z": 0.128
            },
            "gtin": "3587361043176",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546566",
        "height": 0.50694,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fbcb",
            "leftCorner": {
              "x": 7.997,
              "y": 34.648,
              "z": 0.415
            },
            "rightCorner": {
              "x": 7.988,
              "y": 34.427,
              "z": 0.415
            },
            "gtin": "8410031976373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbcd",
            "leftCorner": {
              "x": 8.03,
              "y": 34.425,
              "z": 0.415
            },
            "rightCorner": {
              "x": 8.024,
              "y": 34.305,
              "z": 0.415
            },
            "gtin": "8410031990584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbce",
            "leftCorner": {
              "x": 8.02,
              "y": 34.305,
              "z": 0.415
            },
            "rightCorner": {
              "x": 8.016,
              "y": 34.216,
              "z": 0.415
            },
            "gtin": "8410031961782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbcf",
            "leftCorner": {
              "x": 8.016,
              "y": 34.216,
              "z": 0.415
            },
            "rightCorner": {
              "x": 8.012,
              "y": 34.128,
              "z": 0.415
            },
            "gtin": "8410031961782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbd0",
            "leftCorner": {
              "x": 8.008,
              "y": 34.128,
              "z": 0.415
            },
            "rightCorner": {
              "x": 8.002,
              "y": 33.986,
              "z": 0.415
            },
            "gtin": "8410525253850",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546564",
        "height": 0.8071,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fba6",
            "leftCorner": {
              "x": 7.994,
              "y": 34.648,
              "z": 0.66
            },
            "rightCorner": {
              "x": 7.987,
              "y": 34.499,
              "z": 0.66
            },
            "gtin": "8410031972337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fba9",
            "leftCorner": {
              "x": 8.027,
              "y": 34.497,
              "z": 0.66
            },
            "rightCorner": {
              "x": 8.024,
              "y": 34.43,
              "z": 0.66
            },
            "gtin": "8410031132519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbaa",
            "leftCorner": {
              "x": 8.024,
              "y": 34.43,
              "z": 0.66
            },
            "rightCorner": {
              "x": 8.021,
              "y": 34.363,
              "z": 0.66
            },
            "gtin": "8410031132519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbab",
            "leftCorner": {
              "x": 8.021,
              "y": 34.363,
              "z": 0.66
            },
            "rightCorner": {
              "x": 8.018,
              "y": 34.283,
              "z": 0.66
            },
            "gtin": "1230000131384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbac",
            "leftCorner": {
              "x": 8.018,
              "y": 34.283,
              "z": 0.66
            },
            "rightCorner": {
              "x": 8.014,
              "y": 34.204,
              "z": 0.66
            },
            "gtin": "1230000131384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbad",
            "leftCorner": {
              "x": 8.021,
              "y": 34.203,
              "z": 0.66
            },
            "rightCorner": {
              "x": 8.014,
              "y": 34.038,
              "z": 0.66
            },
            "gtin": "8435124855052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbae",
            "leftCorner": {
              "x": 8.014,
              "y": 34.038,
              "z": 0.66
            },
            "rightCorner": {
              "x": 8.006,
              "y": 33.871,
              "z": 0.66
            },
            "gtin": "8435124855052",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546561",
        "height": 1.0621,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fb79",
            "leftCorner": {
              "x": 7.998,
              "y": 34.648,
              "z": 0.869
            },
            "rightCorner": {
              "x": 7.994,
              "y": 34.562,
              "z": 0.869
            },
            "gtin": "8437001799763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb7a",
            "leftCorner": {
              "x": 7.994,
              "y": 34.562,
              "z": 0.869
            },
            "rightCorner": {
              "x": 7.99,
              "y": 34.476,
              "z": 0.869
            },
            "gtin": "8437001799763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb7c",
            "leftCorner": {
              "x": 8.026,
              "y": 34.474,
              "z": 0.869
            },
            "rightCorner": {
              "x": 8.02,
              "y": 34.35,
              "z": 0.869
            },
            "gtin": "4038448016327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb7d",
            "leftCorner": {
              "x": 8.02,
              "y": 34.35,
              "z": 0.869
            },
            "rightCorner": {
              "x": 8.015,
              "y": 34.228,
              "z": 0.869
            },
            "gtin": "4038448016327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb7e",
            "leftCorner": {
              "x": 8.021,
              "y": 34.227,
              "z": 0.869
            },
            "rightCorner": {
              "x": 8.016,
              "y": 34.107,
              "z": 0.869
            },
            "gtin": "90384844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb7f",
            "leftCorner": {
              "x": 8.016,
              "y": 34.107,
              "z": 0.869
            },
            "rightCorner": {
              "x": 8.01,
              "y": 33.986,
              "z": 0.869
            },
            "gtin": "90384844",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546565",
        "height": 1.3131,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fbb7",
            "leftCorner": {
              "x": 8.002,
              "y": 34.647,
              "z": 1.074
            },
            "rightCorner": {
              "x": 7.997,
              "y": 34.539,
              "z": 1.074
            },
            "gtin": "4014437132537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbb9",
            "leftCorner": {
              "x": 8.029,
              "y": 34.537,
              "z": 1.074
            },
            "rightCorner": {
              "x": 8.026,
              "y": 34.479,
              "z": 1.074
            },
            "gtin": "7622201503833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbba",
            "leftCorner": {
              "x": 8.026,
              "y": 34.479,
              "z": 1.074
            },
            "rightCorner": {
              "x": 8.024,
              "y": 34.422,
              "z": 1.074
            },
            "gtin": "7622201503833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbbb",
            "leftCorner": {
              "x": 8.024,
              "y": 34.422,
              "z": 1.074
            },
            "rightCorner": {
              "x": 8.021,
              "y": 34.364,
              "z": 1.074
            },
            "gtin": "7622201503833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbbc",
            "leftCorner": {
              "x": 8.024,
              "y": 34.363,
              "z": 1.074
            },
            "rightCorner": {
              "x": 8.014,
              "y": 34.162,
              "z": 1.074
            },
            "gtin": "8410525240454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbbd",
            "leftCorner": {
              "x": 8.012,
              "y": 34.162,
              "z": 1.074
            },
            "rightCorner": {
              "x": 8.008,
              "y": 34.071,
              "z": 1.074
            },
            "gtin": "8410525253850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fbbe",
            "leftCorner": {
              "x": 8.008,
              "y": 34.071,
              "z": 1.074
            },
            "rightCorner": {
              "x": 8.004,
              "y": 33.98,
              "z": 1.074
            },
            "gtin": "8410525253850",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546562",
        "height": 1.564,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fb8d",
            "leftCorner": {
              "x": 8.022,
              "y": 34.614,
              "z": 1.28
            },
            "rightCorner": {
              "x": 8.017,
              "y": 34.511,
              "z": 1.28
            },
            "gtin": "4260680630119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb8e",
            "leftCorner": {
              "x": 8.023,
              "y": 34.511,
              "z": 1.28
            },
            "rightCorner": {
              "x": 8.019,
              "y": 34.432,
              "z": 1.28
            },
            "gtin": "4270000400506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb8f",
            "leftCorner": {
              "x": 8.02,
              "y": 34.432,
              "z": 1.28
            },
            "rightCorner": {
              "x": 8.017,
              "y": 34.364,
              "z": 1.28
            },
            "gtin": "4270000400544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb90",
            "leftCorner": {
              "x": 8.023,
              "y": 34.364,
              "z": 1.28
            },
            "rightCorner": {
              "x": 8.017,
              "y": 34.232,
              "z": 1.28
            },
            "gtin": "4260042078306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb91",
            "leftCorner": {
              "x": 8.017,
              "y": 34.232,
              "z": 1.28
            },
            "rightCorner": {
              "x": 8.011,
              "y": 34.101,
              "z": 1.28
            },
            "gtin": "4260042078306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb92",
            "leftCorner": {
              "x": 7.997,
              "y": 34.101,
              "z": 1.28
            },
            "rightCorner": {
              "x": 7.994,
              "y": 34.027,
              "z": 1.28
            },
            "gtin": "5011053026621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fb93",
            "leftCorner": {
              "x": 7.994,
              "y": 34.027,
              "z": 1.28
            },
            "rightCorner": {
              "x": 7.991,
              "y": 33.953,
              "z": 1.28
            },
            "gtin": "5011053026621",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "682ffdddd15af3232a546563",
        "height": 1.7596,
        "facings": [
          {
            "id": "68300c885ed67a01d9a1fb9d",
            "leftCorner": {
              "x": 7.996,
              "y": 34.648,
              "z": 1.44
            },
            "rightCorner": {
              "x": 7.988,
              "y": 34.461,
              "z": 1.44
            },
            "gtin": "3501276213035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fba0",
            "leftCorner": {
              "x": 8.028,
              "y": 34.459,
              "z": 1.44
            },
            "rightCorner": {
              "x": 8.016,
              "y": 34.198,
              "z": 1.44
            },
            "gtin": "3501276211031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68300c885ed67a01d9a1fba1",
            "leftCorner": {
              "x": 8.012,
              "y": 34.198,
              "z": 1.44
            },
            "rightCorner": {
              "x": 8.002,
              "y": 33.968,
              "z": 1.44
            },
            "gtin": "3501276243032",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "rightNeighborShelfId": "468a5"
  }
]